(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[888],{

/***/ 2234:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(5556);
tslib_1.__exportStar(__webpack_require__(3359), exports);
tslib_1.__exportStar(__webpack_require__(9738), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 533:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.mapSections = void 0;
const jsx_runtime_1 = __webpack_require__(4246);
const react_error_boundary_1 = __webpack_require__(1906);
const uuid_1 = __webpack_require__(338);
/**
 * Will take in the page sections data and react section components
 * and render in the order they appear in the page sections data.
 * @param {*} pageSections
 * @param {*} sectionComponents
 */
const mapSections = (pageSections, sectionComponents, pageData) => {
    const componentMap = sectionComponents
        ? sectionComponents.reduce((compMap, Component) => {
            let schemaKey = '';
            if (Component?.Schema && typeof Component?.Schema === 'function') {
                schemaKey = Component.Schema(pageData)?.key;
            }
            else {
                schemaKey = Component.Schema.key;
            }
            if (!schemaKey) {
                return compMap;
            }
            compMap[schemaKey] = Component;
            return compMap;
        }, {})
        : {};
    return pageSections.reduce((acc, section) => {
        if (!section)
            return acc;
        const { _template: CompSchemaKey, ...cms } = section;
        const Comp = componentMap[CompSchemaKey];
        if (!Comp)
            return acc;
        if (cms?.sectionVisibility === 'hidden')
            return acc;
        return [
            ...acc,
            // sections wrapper with data-comp and data-comp-id for easy scrolling on section select
            (0, jsx_runtime_1.jsx)("section", { "data-comp": CompSchemaKey, "data-comp-id": cms?.id, children: (0, jsx_runtime_1.jsx)(react_error_boundary_1.ErrorBoundary, { "data-comp": "SectionErrorBoundary", FallbackComponent: () => ((0, jsx_runtime_1.jsx)(SectionErrorFallback, { name: CompSchemaKey })), children: (0, jsx_runtime_1.jsx)(Comp, { "comp-name": CompSchemaKey, cms: cms }) }) }, (0, uuid_1.v4)()),
        ];
    }, []);
};
exports.mapSections = mapSections;
function SectionErrorFallback({ name }) {
    return ((0, jsx_runtime_1.jsx)("section", { style: {
            padding: '16px',
        }, children: (0, jsx_runtime_1.jsxs)("div", { style: {
                border: 'thin solid #f87171',
                height: '350px',
                width: '100%',
                backgroundColor: '#fecaca',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: '8px',
            }, children: ["An error occured in your", (0, jsx_runtime_1.jsxs)("span", { style: { fontWeight: 'bold', fontFamily: 'monospace' }, children: ["\u00A0", name, "\u00A0"] }), "section"] }) }));
}
//# sourceMappingURL=mapSections.js.map

/***/ }),

/***/ 118:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.mapSectionsWithAddedProps = void 0;
const mapSectionsWithAddedProps = (props) => (section) => {
    try {
        if (!section)
            return null;
        if (!props)
            return section;
        if (typeof props !== 'object') {
            console.warn('mapSectionsWithAddedProps:error: props must be an object');
            return section;
        }
        return {
            ...section,
            props: {
                ...section.props,
                children: {
                    ...section.props.children,
                    props: {
                        ...section.props.children.props,
                        children: {
                            ...section.props.children.props.children,
                            props: {
                                ...section.props.children.props.children.props,
                                ...props,
                            },
                        },
                    },
                },
            },
        };
    }
    catch (error) {
        return section;
    }
};
exports.mapSectionsWithAddedProps = mapSectionsWithAddedProps;
//# sourceMappingURL=mapSectionsWithAddedProps.js.map

/***/ }),

/***/ 9738:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.renderSections = void 0;
const mapSections_1 = __webpack_require__(533);
const mapSectionsWithAddedProps_1 = __webpack_require__(118);
const renderSections = (pageData, sectionComponents) => {
    const pageDataSections = pageData?.page?.sections ||
        pageData?.article?.sections ||
        pageData?.blog?.sections;
    if (!pageDataSections) {
        return () => {
            return null;
        };
    }
    const allSections = (0, mapSections_1.mapSections)([...pageDataSections], sectionComponents, pageData);
    const pageDataTemplateSections = pageDataSections?.filter((section) => section.parentContentType === 'template');
    const pageDataPageSections = pageDataSections?.filter((section) => section.parentContentType !== 'template');
    const templateSections = (0, mapSections_1.mapSections)(pageDataTemplateSections, sectionComponents, pageData);
    const pageSections = (0, mapSections_1.mapSections)(pageDataPageSections, sectionComponents, pageData);
    return (options) => {
        try {
            if (!options)
                return allSections;
            if (typeof options !== 'object') {
                throw new Error(`parameter must be an object; received ${typeof options}`);
            }
            if (options.type && !['template', 'page', 'all'].includes(options.type)) {
                console.warn('renderSections:', '`type` must be "template", "page", or "all"');
            }
            if (options.props && typeof options.props !== 'object') {
                throw new Error(`\`props\` must be an object; received ${typeof options.props}`);
            }
            const { props, type } = options;
            switch (type) {
                case 'template':
                    if (props) {
                        return templateSections.map((0, mapSectionsWithAddedProps_1.mapSectionsWithAddedProps)(props));
                    }
                    return templateSections;
                case 'page':
                    if (props) {
                        return pageSections.map((0, mapSectionsWithAddedProps_1.mapSectionsWithAddedProps)(props));
                    }
                    return pageSections;
                default:
                    if (props) {
                        return allSections.map((0, mapSectionsWithAddedProps_1.mapSectionsWithAddedProps)(props));
                    }
                    return allSections;
            }
        }
        catch (error) {
            console.error('renderSections:error', error.message);
            return allSections;
        }
    };
};
exports.renderSections = renderSections;
//# sourceMappingURL=renderSections.js.map

/***/ }),

/***/ 3359:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomizerShell = void 0;
const tslib_1 = __webpack_require__(5556);
/* eslint-disable react-hooks/rules-of-hooks */
const react_1 = __webpack_require__(7378);
const penpal_1 = __webpack_require__(7221);
const router_1 = tslib_1.__importDefault(__webpack_require__(6677));
const useCustomizerShell = ({ environment = 'production', isPreview, isShareableToken, sectionComponents, staticProps, storefrontSettingsSchema, }) => {
    if (!isPreview || (isPreview && isShareableToken)) {
        return {
            pageData: staticProps.page || staticProps.blog || staticProps.article,
            storefrontSettings: staticProps?.settings?.settings,
        };
    }
    try {
        const [_pageData, _setPageData] = (0, react_1.useState)(null);
        const [_storefrontSettings, _setStorefrontSettings] = (0, react_1.useState)(null);
        const [parentConnection, setParentConnection] = (0, react_1.useState)(null);
        const [hasLoadedOnce, setHasLoadedOnce] = (0, react_1.useState)(false);
        const [isRouteChanging, setIsRouteChanging] = (0, react_1.useState)(false);
        // eslint-disable-next-line consistent-return
        const _refreshSections = (0, react_1.useCallback)(() => {
            if (!sectionComponents)
                return [];
            const sectionSchemas = sectionComponents
                .map((section) => {
                if (section.Schema && typeof section.Schema === 'function') {
                    const qualifiedSchema = section.Schema({ ...staticProps });
                    return qualifiedSchema;
                }
                return section.Schema;
            })
                .filter(Boolean);
            if (parentConnection) {
                try {
                    const sectionSchemasString = JSON.stringify(sectionSchemas);
                    parentConnection.setSectionsSchemas(sectionSchemasString);
                }
                catch (error) {
                    console.error(error);
                    // parentConnection.displayError('Something went wrong parsing sections');
                }
            }
        }, [staticProps, parentConnection, sectionComponents]);
        // eslint-disable-next-line consistent-return
        const _refreshStorefrontSettingsSchema = (0, react_1.useCallback)(() => {
            if (!storefrontSettingsSchema)
                return [];
            const storefrontSettingsSchemaString = JSON.stringify(storefrontSettingsSchema);
            if (parentConnection) {
                if (sectionComponents) {
                    parentConnection.setStorefrontSettingsSchema(storefrontSettingsSchemaString);
                }
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [staticProps, parentConnection, storefrontSettingsSchema]);
        const handleRouteChangeStart = (url) => {
            if (url !== router_1.default.asPath) {
                setIsRouteChanging(true);
                _setPageData(null); // Clear page data when route changes to new path
            }
        };
        const handleRouteChangeComplete = (0, react_1.useCallback)((url) => {
            if (url === router_1.default.asPath)
                setIsRouteChanging(false);
            if (parentConnection) {
                const currentRoute = {
                    environment,
                    currentPath: router_1.default.router.asPath,
                    template: staticProps?.template,
                    templateType: staticProps?.templateType,
                    handle: staticProps?.pageHandle,
                    title: staticProps?.pageTitle,
                    description: staticProps?.pageDescription,
                };
                parentConnection.setCurrentRoute(currentRoute);
            }
        }, [parentConnection, staticProps, environment]);
        (0, react_1.useEffect)(() => {
            router_1.default.events.on('routeChangeStart', handleRouteChangeStart);
            router_1.default.events.on('routeChangeComplete', handleRouteChangeComplete);
            router_1.default.events.on('routeChangeError', handleRouteChangeComplete);
            return () => {
                router_1.default.events.off('routeChangeStart', handleRouteChangeStart);
                router_1.default.events.off('routeChangeComplete', handleRouteChangeComplete);
                router_1.default.events.off('routeChangeError', handleRouteChangeComplete);
            };
        }, [handleRouteChangeStart, handleRouteChangeComplete]);
        (0, react_1.useEffect)(() => {
            if (parentConnection) {
                parentConnection.onRouteChange(isRouteChanging);
            }
        }, [isRouteChanging, parentConnection]);
        (0, react_1.useEffect)(() => {
            const connection = (0, penpal_1.connectToParent)({
                // Methods child is exposing to parent.
                // parentOrigin: 'http://localhost:3000', // TODO: make this the platform URL
                // parentOrigin: 'https://backpack-platform.herokuapp.com', // TODO: make this the platform URL
                methods: {
                    routeToPage: (path) => {
                        router_1.default.push(path);
                    },
                    scrollToSection: (sectionId) => {
                        const sectionEl = document.querySelector(`[data-comp-id="${sectionId}"]`);
                        if (sectionEl) {
                            sectionEl.scrollIntoView({
                                block: 'center',
                                behavior: 'smooth',
                            });
                        }
                    },
                    /**
                     * This is the live form data from the shell that will be used to render the page.
                     * @param {Object} content : The page content data from form to be rendered;
                     */
                    setPageData: (content) => {
                        _setPageData(content);
                    },
                    /**
                     * This is the live storefront settings from the shell that will be used to render the page.
                     * @param {*} settings : The storefront settings data from form to be rendered;
                     */
                    setStorefrontSettings: (settings) => {
                        _setStorefrontSettings(settings);
                    },
                },
            });
            async function setConnectionMethods() {
                try {
                    const newParentConnection = await connection.promise;
                    setParentConnection(newParentConnection);
                }
                catch (e) {
                    console.error('Error when trying to connect Frame to Customizer Shell.', e);
                }
            }
            setConnectionMethods();
        }, []);
        // Inform the Customizer shell which page we are on on initial load.
        (0, react_1.useEffect)(() => {
            if (parentConnection && !hasLoadedOnce) {
                const currentRoute = {
                    environment,
                    currentPath: router_1.default.router.asPath,
                    template: staticProps?.template,
                    templateType: staticProps?.templateType,
                    handle: staticProps?.pageHandle,
                    title: staticProps?.pageTitle,
                    description: staticProps?.pageDescription, // Needed?
                };
                parentConnection.setCurrentRoute(currentRoute);
                setHasLoadedOnce(true);
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [parentConnection, staticProps]);
        (0, react_1.useEffect)(() => {
            _refreshSections();
            _refreshStorefrontSettingsSchema();
        }, [
            staticProps,
            _refreshSections,
            _refreshStorefrontSettingsSchema,
            sectionComponents,
        ]);
        return {
            pageData: _pageData,
            error: null,
            storefrontSettings: _storefrontSettings,
        };
    }
    catch (error) {
        console.error(error);
        return {
            pageData: staticProps.page,
            error,
            storefrontSettings: staticProps.settings,
        };
    }
};
exports.useCustomizerShell = useCustomizerShell;
//# sourceMappingURL=useCustomizerShell.js.map

/***/ }),

/***/ 6759:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
exports.N$ = __webpack_unused_export__ = void 0;
var memoize_1 = __webpack_require__(9234);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return memoize_1.memoize; } });
var rafTimeoutInterval_1 = __webpack_require__(1756);
Object.defineProperty(exports, "N$", ({ enumerable: true, get: function () { return rafTimeoutInterval_1.rafTimeoutInterval; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 9234:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.memoize = void 0;
const memoize = (fn) => {
    const cache = {};
    return (...args) => {
        const n = args[0];
        if (n in cache) {
            return cache[n];
        }
        const result = fn(n);
        cache[n] = result;
        return result;
    };
};
exports.memoize = memoize;
//# sourceMappingURL=memoize.js.map

/***/ }),

/***/ 1756:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

// See the links below for more information:
// http://creativejs.com/resources/requestanimationframe/
// https://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
//
// Source:
// https://gist.github.com/joyrexus/7304146
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.rafTimeoutInterval = void 0;
const rafTimeoutInterval = () => {
    if (typeof window === 'undefined')
        return;
    var requestAnimFrame = (function () {
        return (window.requestAnimationFrame ||
            window.webkitRequestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            window.oRequestAnimationFrame ||
            window.msRequestAnimationFrame ||
            function (callback) {
                window.setTimeout(callback, 1000 / 60);
            });
    })();
    /**
     * Behaves the same as setInterval except uses requestAnimationFrame() where possible for better performance
     * @param {function} fn The callback function
     * @param {int} delay The delay in milliseconds
     */
    var requestInterval = function (fn, delay) {
        if (!window.requestAnimationFrame &&
            !window.webkitRequestAnimationFrame &&
            // Firefox 5 ships without cancel support
            !(window.mozRequestAnimationFrame && window.mozCancelRequestAnimationFrame) &&
            !window.oRequestAnimationFrame &&
            !window.msRequestAnimationFrame) {
            return window.setInterval(fn, delay);
        }
        var start = new Date().getTime();
        var handle = new Object();
        function loop() {
            var current = new Date().getTime();
            var delta = current - start;
            if (delta >= delay) {
                fn.call();
                start = new Date().getTime();
            }
            handle.value = requestAnimFrame(loop);
        }
        ;
        handle.value = requestAnimFrame(loop);
        return handle;
    };
    /**
    * Behaves the same as setTimeout except uses requestAnimationFrame() where possible for better performance
    * @param {function} fn The callback function
    * @param {int} delay The delay in milliseconds
    */
    var requestTimeout = function (fn, delay) {
        if (!window.requestAnimationFrame &&
            !window.webkitRequestAnimationFrame &&
            // Firefox 5 ships without cancelsupport
            !(window.mozRequestAnimationFrame && window.mozCancelRequestAnimationFrame) &&
            !window.oRequestAnimationFrame &&
            !window.msRequestAnimationFrame) {
            return window.setTimeout(fn, delay);
        }
        var start = new Date().getTime();
        var handle = new Object();
        function loop() {
            var current = new Date().getTime();
            var delta = current - start;
            delta >= delay
                ? fn.call()
                : handle.value = requestAnimFrame(loop);
        }
        ;
        handle.value = requestAnimFrame(loop);
        return handle;
    };
    /**
    * Behaves the same as clearInterval except uses cancelRequestAnimationFrame() where possible for better performance
    * @param {int|object} fn The callback function
    */
    var clearRequestInterval = function (handle) {
        window.cancelAnimationFrame
            ? window.cancelAnimationFrame(handle.value)
            : window.webkitCancelAnimationFrame
                ? window.webkitCancelAnimationFrame(handle.value)
                : window.webkitCancelRequestAnimationFrame
                    ? window.webkitCancelRequestAnimationFrame(handle.value)
                    : /* Support for legacy API */ window.mozCancelRequestAnimationFrame
                        ? window.mozCancelRequestAnimationFrame(handle.value)
                        : window.oCancelRequestAnimationFrame
                            ? window.oCancelRequestAnimationFrame(handle.value)
                            : window.msCancelRequestAnimationFrame
                                ? window.msCancelRequestAnimationFrame(handle.value)
                                : clearInterval(handle);
    };
    /**
     * Behaves the same as clearTimeout except uses cancelRequestAnimationFrame() where possible for better performance
     * @param {int|object} fn The callback function
     */
    var clearRequestTimeout = function (handle) {
        window.cancelAnimationFrame
            ? window.cancelAnimationFrame(handle.value)
            : window.webkitCancelAnimationFrame
                ? window.webkitCancelAnimationFrame(handle.value)
                : window.webkitCancelRequestAnimationFrame
                    ? window.webkitCancelRequestAnimationFrame(handle.value)
                    : /* Support for legacy API */ window.mozCancelRequestAnimationFrame
                        ? window.mozCancelRequestAnimationFrame(handle.value)
                        : window.oCancelRequestAnimationFrame
                            ? window.oCancelRequestAnimationFrame(handle.value)
                            : window.msCancelRequestAnimationFrame
                                ? window.msCancelRequestAnimationFrame(handle.value)
                                : clearTimeout(handle);
    };
    window.requestAnimFrame = requestAnimFrame;
    window.requestInterval = requestInterval;
    window.requestTimeout = requestTimeout;
    window.clearRequestInterval = clearRequestInterval;
    window.clearRequestTimeout = clearRequestTimeout;
};
exports.rafTimeoutInterval = rafTimeoutInterval;
//# sourceMappingURL=rafTimeoutInterval.js.map

/***/ }),

/***/ 9141:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(4284);

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StateProvider = void 0;
const tslib_1 = __webpack_require__(5556);
const jsx_runtime_1 = __webpack_require__(4246);
const recoil_1 = __webpack_require__(9853);
const recoil_toolkit_1 = __webpack_require__(434);
const store_1 = tslib_1.__importDefault(__webpack_require__(4385));
function StateProvider({ storefrontSettings, route, pageData, pageProps, children, }) {
    function initializeState({ set }) {
        set(store_1.default.storefrontSettings, storefrontSettings);
        set(store_1.default.route, route);
        if (!pageData)
            return;
        if (pageData?.resourceType === 'product_page') {
            set(store_1.default.product, pageProps.product);
        }
        if (pageData?.resourceType === 'collection_page') {
            set(store_1.default.collection, pageProps.collection);
        }
        if (pageData?.resourceType === 'page') {
            set(store_1.default.page, pageProps.page);
        }
        if (pageData?.resourceType === 'blog') {
            set(store_1.default.blog, pageProps.blog);
        }
        if (pageData?.resourceType === 'article') {
            set(store_1.default.article, pageProps.article);
        }
    }
    const isDevelopment = "production" === 'development';
    // eslint-disable-next-line eqeqeq
    const recoilDevToolsEnabled = process.env.RECOIL_DEV_TOOLS_ENABLED == 'true';
    if (isDevelopment && recoilDevToolsEnabled) {
        return (
        // eslint-disable-next-line react/jsx-filename-extension
        (0, jsx_runtime_1.jsxs)(recoil_1.RecoilRoot, { initializeState: initializeState, children: [(0, jsx_runtime_1.jsx)(recoil_toolkit_1.RecoilDevTools, { enableConsole: true }), children] }));
    }
    return (0, jsx_runtime_1.jsx)(recoil_1.RecoilRoot, { initializeState: initializeState, children: children });
}
exports.StateProvider = StateProvider;
//# sourceMappingURL=StateProvider.js.map

/***/ }),

/***/ 8043:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.analyticsStore = void 0;
const tslib_1 = __webpack_require__(5556);
/* eslint-disable max-lines */
const recoil_1 = __webpack_require__(9853);
const effects_1 = tslib_1.__importDefault(__webpack_require__(9025));
/**
  Analytics State
*/
const customerAndCartInit = (0, recoil_1.atom)({
    key: 'analytics/customerAndCartInit',
    default: false,
    effects: [
        // effects.logStateChange('customerAndCartInit'),
        effects_1.default.onChange({
            key: 'customerAndCartInit',
            topic: 'CUSTOMER_AND_CART_INIT',
            actions: ['publishGtmEvent', 'publishBusEvent'],
        }),
    ],
});
exports.analyticsStore = {
    // actual state - atoms
    customerAndCartInit,
};
//# sourceMappingURL=analytics.js.map

/***/ }),

/***/ 9807:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.analyticsStore = void 0;
var analytics_1 = __webpack_require__(8043);
Object.defineProperty(exports, "analyticsStore", ({ enumerable: true, get: function () { return analytics_1.analyticsStore; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 772:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useArticle = void 0;
var useArticle_1 = __webpack_require__(4170);
Object.defineProperty(exports, "useArticle", ({ enumerable: true, get: function () { return useArticle_1.useArticle; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 4170:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useArticle = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useArticle = () => (0, store_1.useRecoilValue)(store_1.default.article);
exports.useArticle = useArticle;
//# sourceMappingURL=useArticle.js.map

/***/ }),

/***/ 1634:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.articleStore = void 0;
const tslib_1 = __webpack_require__(5556);
/* eslint-disable max-lines */
const recoil_1 = __webpack_require__(9853);
const effects_1 = tslib_1.__importDefault(__webpack_require__(9025));
/**
  Article State
*/
const article = (0, recoil_1.atom)({
    key: 'article/article',
    default: null,
    effects: [
        // effects.logStateChange('article'),
        effects_1.default.onChange({
            key: 'article',
            topic: 'ARTICLE_UPDATE',
            actions: ['publishBusEvent'],
        }),
    ],
});
const articlesList = (0, recoil_1.atom)({
    key: 'article/articlesList',
    default: [],
});
// articles json fuse index
const articlesIndex = (0, recoil_1.atom)({
    key: 'article/articlesIndex',
    default: null, // { keys: [], records: [] }
});
exports.articleStore = {
    // actual state - atoms
    article,
    articlesIndex,
    articlesList,
};
//# sourceMappingURL=article.js.map

/***/ }),

/***/ 2159:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.articleStore = void 0;
var article_1 = __webpack_require__(1634);
Object.defineProperty(exports, "articleStore", ({ enumerable: true, get: function () { return article_1.articleStore; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 1457:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useBlog = void 0;
var useBlog_1 = __webpack_require__(2897);
Object.defineProperty(exports, "useBlog", ({ enumerable: true, get: function () { return useBlog_1.useBlog; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2897:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useBlog = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useBlog = () => (0, store_1.useRecoilValue)(store_1.default.blog);
exports.useBlog = useBlog;
//# sourceMappingURL=useBlog.js.map

/***/ }),

/***/ 6345:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.blogStore = void 0;
const tslib_1 = __webpack_require__(5556);
/* eslint-disable max-lines */
const recoil_1 = __webpack_require__(9853);
const effects_1 = tslib_1.__importDefault(__webpack_require__(9025));
/**
  Blog State
*/
const blog = (0, recoil_1.atom)({
    key: 'blog/blog',
    default: null,
    effects: [
        effects_1.default.onChange({
            key: 'blog',
            topic: 'BLOG_UPDATE',
            actions: ['publishBusEvent'],
        }),
    ],
});
const blogsList = (0, recoil_1.atom)({
    key: 'blog/blogsList',
    default: [],
});
// blogs json fuse index
const blogsIndex = (0, recoil_1.atom)({
    key: 'blog/blogsIndex',
    default: null, // { keys: [], recors: [] }
});
exports.blogStore = {
    // actual state - atoms
    blog,
    blogsIndex,
    blogsList,
};
//# sourceMappingURL=blog.js.map

/***/ }),

/***/ 3727:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.blogStore = void 0;
var blog_1 = __webpack_require__(6345);
Object.defineProperty(exports, "blogStore", ({ enumerable: true, get: function () { return blog_1.blogStore; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 106:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CartClient = void 0;
const tslib_1 = __webpack_require__(5556);
/* eslint-disable no-undef */
/* eslint-disable class-methods-use-this */
const graphql_request_1 = __webpack_require__(3671);
const humanize_graphql_response_1 = tslib_1.__importDefault(__webpack_require__(7207));
const queries_1 = __webpack_require__(4765);
const mutations_1 = __webpack_require__(9881);
/**
 * @see: https://shopify.dev/custom-storefronts/cart
 */
class CartClient {
    constructor({ apiToken, apiVersion, domain, debug }) {
        this.apiToken = apiToken;
        this.apiVersion = apiVersion;
        this.domain = domain;
        this.endpoint = '';
        this.options = {};
        this.debug = debug || false;
        this.client = this.initClient();
    }
    initClient() {
        this.endpoint = `https://${this.domain}/api/${this.apiVersion}/graphql.json`;
        // client
        this.options = {
            method: 'POST',
            mode: 'cors',
            headers: {
                'X-Shopify-Storefront-Access-Token': this.apiToken,
                'Content-Type': 'application/json; charset=utf-8',
            },
        };
        return new graphql_request_1.GraphQLClient(this.endpoint, this.options);
    }
    /**
     * Customer queries client
     * @param {gqlQuery} query
     * @param {object} variables
     * @returns
     */
    async query({ query, variables }) {
        if (this.debug) {
            console.log('CartClient:', query, variables);
        }
        return this.client.rawRequest(query, variables);
    }
    /**
     * Customer mutation client
     * @param {gqlMutation} mutation
     * @param {object} variables
     * @returns
     */
    async mutate({ mutation, variables }) {
        if (this.debug) {
            console.log('CartClient:', mutation, variables);
        }
        return this.client.rawRequest(mutation, variables);
    }
    /**
     * Create a new cart
     * @param {country} twoDigitCountryCode - US, MX..
     * @param {cartInput} cartInput - can pass any valid cart param here: e.g — buyerIdentity, attributes etc..
     * @returns a new full cart instance
     */
    async create({ country, cartInput } = { county: 'US', cartInput: {} }) {
        try {
            if (!cartInput) {
                throw new Error('cart create failed "cartInput" not provided');
            }
            const { data, errors, status } = await this.mutate({
                mutation: mutations_1.mutations.create,
                variables: { country, cartInput },
            });
            if (status !== 200) {
                throw new Error(`Network request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            const { cartCreate: { cart, userErrors }, } = data;
            if (userErrors?.length) {
                throw new Error(userErrors[0].message);
            }
            return { error: null, newCart: (0, humanize_graphql_response_1.default)(cart) };
        }
        catch (error) {
            return { error: error.message, newCart: null };
        }
    }
    /**
     * Retrieve an existing cart by id
     * @param {id} cart.id "Z2lkOi8vc2hvcGlmeS9DYXJ0LzRlMDFmMTQ5YTQ2MThlYzFmYzgwYjljMjk1ZGZjZTk4"
     * @returns full cart object
     */
    async get({ id, country } = { id: '', country: 'US' }) {
        try {
            if (!id) {
                throw new Error('cart get failed "id" not provided');
            }
            const query = queries_1.queries.get;
            const variables = { id, country };
            // get cart
            const { data, errors, status } = await this.query({ query, variables });
            if (status !== 200) {
                throw new Error(`Network request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            if (!data?.cart) {
                throw new Error('Cart object not returned in response');
            }
            return { error: null, existingCart: (0, humanize_graphql_response_1.default)(data.cart) };
        }
        catch (error) {
            return { error: error.message, existingCart: null };
        }
    }
    /**
     * Add a line item to the cart
     * @param {*} param0
     * @returns
     */
    async addItem({ cartId, country, merchandiseId, quantity, sellingPlanId, attributes } = {
        cartId: null,
        country: 'US',
        attributes: [],
        merchandiseId: null,
        quantity: 1,
        sellingPlanId: null,
    }) {
        try {
            if (!cartId) {
                throw new Error('addItem "cartId" not provided');
            }
            if (!merchandiseId) {
                throw new Error('addItem "merchandiseId" not provided');
            }
            // update cart with a single line item
            const { data, errors, status } = await this.mutate({
                mutation: mutations_1.mutations.addItems,
                variables: sellingPlanId
                    ? {
                        cartId,
                        country,
                        lines: [{ attributes, merchandiseId, quantity, sellingPlanId }],
                    }
                    : {
                        cartId,
                        country,
                        lines: [{ attributes, merchandiseId, quantity }],
                    },
            });
            if (status !== 200) {
                throw new Error(`Add item request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            if (!data?.cartLinesAdd?.updatedCart) {
                throw new Error('Add item cart object not returned in response');
            }
            const { updatedCart } = data.cartLinesAdd;
            return { error: null, updatedCart: (0, humanize_graphql_response_1.default)(updatedCart) };
        }
        catch (error) {
            return { error: error.message, updatedCart: null };
        }
    }
    /**
     * Add multiple line items to the cart
     * @param {*} param0
     * @returns
     */
    async addItems({ cartId, lines, country } = {
        cartId: null,
        country: 'US',
        lines: [],
    }) {
        try {
            if (!cartId) {
                throw new Error('addItems "cartId" not provided');
            }
            if (!lines) {
                throw new Error('addItems "lines" not provided');
            }
            const { data, errors, status } = await this.mutate({
                mutation: mutations_1.mutations.addItems,
                variables: { cartId, country, lines },
            });
            if (status !== 200) {
                throw new Error(`Add item request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            if (!data?.cartLinesAdd?.updatedCart) {
                throw new Error('Add item cart object not returned in response');
            }
            const { updatedCart } = data.cartLinesAdd;
            return { error: null, updatedCart: (0, humanize_graphql_response_1.default)(updatedCart) };
        }
        catch (error) {
            return { error: error.message, updatedCart: null };
        }
    }
    /**
     * Remove a line item by id
     * @param {*} param0
     * @returns
     */
    async removeItem({ cartId, country, lineId } = {
        cartId: null,
        country: 'US',
        lineId: null,
    }) {
        try {
            if (!cartId) {
                throw new Error('removeItem "cartId" not provided');
            }
            if (!lineId) {
                throw new Error('removeItem "lineId" not provided');
            }
            const { data, errors, status } = await this.mutate({
                mutation: mutations_1.mutations.removeItems,
                variables: {
                    cartId,
                    country,
                    lineIds: [lineId],
                },
            });
            if (status !== 200) {
                throw new Error(`Add item request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            if (!data?.cartLinesRemove?.updatedCart) {
                throw new Error('Remove item cart object not returned in response');
            }
            const { updatedCart } = data.cartLinesRemove;
            return { error: null, updatedCart: (0, humanize_graphql_response_1.default)(updatedCart) };
        }
        catch (error) {
            return { error: error.message, updatedCart: null };
        }
    }
    /**
     * Remove multiple items from the cart by lineIds
     * @param {*} param0
     * @returns
     */
    async removeItems({ cartId, country, lineIds } = {
        cartId: null,
        country: 'US',
        lineIds: [],
    }) {
        try {
            if (!cartId) {
                throw new Error('removeItems "cartId" not provided');
            }
            if (!lineIds) {
                throw new Error('removeItems "lineIds" not provided');
            }
            const { data, errors, status } = await this.mutate({
                mutation: mutations_1.mutations.removeItems,
                variables: {
                    cartId,
                    country,
                    lineIds,
                },
            });
            if (status !== 200) {
                throw new Error(`Add item request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            if (!data?.cartLinesRemove?.updatedCart) {
                throw new Error('Remove item cart object not returned in response');
            }
            const { updatedCart } = data.cartLinesRemove;
            return { error: null, updatedCart: (0, humanize_graphql_response_1.default)(updatedCart) };
        }
        catch (error) {
            return { error: error.message, updatedCart: null };
        }
    }
    /**
     * Update a line item property
     * @param {*} param0
     * @returns
     */
    async updateItem({ cartId, country, lineId, quantity, merchandiseId, attributes, sellingPlanId, } = {
        cartId: null,
        country: 'US',
        lineId: null,
        quantity: 0,
        merchandiseId: null,
        attributes: [],
        sellingPlanId: null,
    }) {
        try {
            if (!cartId) {
                throw new Error('updateItem "cartId" not provided');
            }
            if (!lineId) {
                throw new Error('updateItem "lineId" not provided');
            }
            const update = { id: lineId };
            if (quantity) {
                update.quantity = quantity;
            }
            if (merchandiseId) {
                update.merchandiseId = merchandiseId;
            }
            if (attributes) {
                update.attributes = attributes;
            }
            if (sellingPlanId) {
                update.sellingPlanId = sellingPlanId;
            }
            const { data, errors, status } = await this.mutate({
                mutation: mutations_1.mutations.updateItems,
                variables: {
                    cartId,
                    country,
                    lines: [update],
                },
            });
            if (status !== 200) {
                throw new Error(`Update item request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            if (!data?.cartLinesUpdate?.updatedCart) {
                throw new Error('Update item cart object not returned in response');
            }
            const { updatedCart } = data.cartLinesUpdate;
            return { error: null, updatedCart: (0, humanize_graphql_response_1.default)(updatedCart) };
        }
        catch (error) {
            return { error: error.message, updatedCart: null };
        }
    }
    /**
     * Update multiple line items at once
     * @param {*} param0
     * @returns
     */
    async updateItems({ cartId, country, lines } = {
        cartId: null,
        country: 'US',
        lines: [],
    }) {
        try {
            if (!cartId) {
                throw new Error('updateItems "cartId" not provided');
            }
            if (!lines?.length) {
                throw new Error('updateItems "lines" not provided');
            }
            const lineToUpdate = (line) => {
                const updatedLine = {
                    id: line.lineId,
                    quantity: line?.quantity,
                    merchandiseId: line?.variant?.id || '',
                    attributes: line?.attributes || [],
                };
                if (line?.sellingPlanId) {
                    updatedLine.sellingPlanId = line.sellingPlanId;
                }
                return updatedLine;
            };
            const { data, errors, status } = await this.mutate({
                mutation: mutations_1.mutations.updateItems,
                variables: {
                    cartId,
                    country,
                    lines: lines.map(lineToUpdate),
                },
            });
            if (status !== 200) {
                throw new Error(`Update items request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            if (!data?.cartLinesUpdate?.updatedCart) {
                throw new Error('Update items cart object not returned in response');
            }
            const { updatedCart } = data.cartLinesUpdate;
            return { error: null, updatedCart: (0, humanize_graphql_response_1.default)(updatedCart) };
        }
        catch (error) {
            return { error: error.message, updatedCart: null };
        }
    }
    /**
     * Update cart note
     * @param {*} param0
     * @returns
     */
    async updateNote({ cartId, country, note } = {
        cartId: null,
        country: 'US',
        note: '',
    }) {
        try {
            if (!cartId) {
                throw new Error('updateNode "cartId" not provided');
            }
            if (typeof note === 'undefined') {
                throw new Error('updateNode "note" not provided');
            }
            const { data, errors, status } = await this.mutate({
                mutation: mutations_1.mutations.updateNote,
                variables: { cartId, country, note },
            });
            if (status !== 200) {
                throw new Error(`Update note request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            if (!data?.cartNoteUpdate?.updatedCart) {
                throw new Error('Update note cart object not returned in response');
            }
            const { updatedCart } = data.cartNoteUpdate;
            return { error: null, updatedCart: (0, humanize_graphql_response_1.default)(updatedCart) };
        }
        catch (error) {
            return { error: error.message, updatedCart: null };
        }
    }
    /**
     * Update cart discount code
     * @param {*} param0
     * @returns
     */
    async updateDiscount({ cartId, country, discountCode } = {
        cartId: null,
        country: 'US',
        discountCode: '',
    }) {
        try {
            if (!cartId) {
                throw new Error('updateDiscount "cartId" not provided');
            }
            if (!discountCode) {
                throw new Error('updateDiscount "discountCode" not provided');
            }
            // only one is discountCode is allowed, god knows why they want this as an array.
            const { data, errors, status } = await this.mutate({
                mutation: mutations_1.mutations.updateDiscountCode,
                variables: { cartId, country, discountCodes: [discountCode] },
            });
            if (status !== 200) {
                throw new Error(`Update discount request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            if (!data?.cartDiscountCodesUpdate?.updatedCart) {
                throw new Error('Update discount cart object not returned in response');
            }
            const { updatedCart } = data.cartDiscountCodesUpdate;
            return { error: null, updatedCart: (0, humanize_graphql_response_1.default)(updatedCart) };
        }
        catch (error) {
            return { error: error.message, updatedCart: null };
        }
    }
    /**
     * Remove cart discount code
     * @param {*} param0
     * @returns
     */
    async removeDiscount({ cartId, country } = {
        cartId: null,
        country: 'US',
    }) {
        try {
            if (!cartId) {
                throw new Error('removeDiscount "cartId" not provided');
            }
            // remove discount code by passing an empty array
            const { data, errors, status } = await this.mutate({
                mutation: mutations_1.mutations.updateDiscountCode,
                variables: { cartId, country, discountCodes: [] },
            });
            if (status !== 200) {
                throw new Error(`remove discount request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            if (!data?.cartDiscountCodesUpdate?.updatedCart) {
                throw new Error('Update discount cart object not returned in response');
            }
            const { updatedCart } = data.cartDiscountCodesUpdate;
            return { error: null, updatedCart: (0, humanize_graphql_response_1.default)(updatedCart) };
        }
        catch (error) {
            return { error: error.message, updatedCart: null };
        }
    }
    /**
     * Update cart attributes
     * @param {[{ key, value }...]} attributes
     * @returns
     */
    async updateAttributes({ cartId, country, attributes } = {
        cartId: null,
        country: 'US',
        attributes: [],
    }) {
        try {
            if (!cartId) {
                throw new Error('updateAttributes "cartId" not provided');
            }
            if (!attributes) {
                throw new Error('updateAttributes "attributes" not provided');
            }
            // update cart-level attributes (not line attributes)
            const { data, errors, status } = await this.mutate({
                mutation: mutations_1.mutations.updateAttributes,
                variables: { cartId, country, attributes },
            });
            if (status !== 200) {
                throw new Error(`Update attributes request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            if (!data?.cartAttributesUpdate?.updatedCart) {
                throw new Error('Update attributes cart object not returned in response');
            }
            const { updatedCart } = data.cartAttributesUpdate;
            return { error: null, updatedCart: (0, humanize_graphql_response_1.default)(updatedCart) };
        }
        catch (error) {
            return { error: error.message, updatedCart: null };
        }
    }
    /**
     * Update cart attributes
     * @param {object} buyerIdentity
     * @param {country} twoDigitCountryCode - US, MX..
     * @returns
     */
    async updateBuyerIdentity({ cartId, country, buyerIdentity } = {
        cartId: null,
        buyerIdentity: null,
        country: 'US',
    }) {
        try {
            if (!cartId) {
                throw new Error('updateBuyerIdentity "cartId" not provided');
            }
            if (!buyerIdentity) {
                throw new Error('updateBuyerIdentity "buyerIdentity" not provided');
            }
            // update cart-level attributes (not line attributes)
            const { data, errors, status } = await this.mutate({
                mutation: mutations_1.mutations.updateBuyerIdentity,
                variables: { cartId, country, buyerIdentity },
            });
            if (status !== 200) {
                throw new Error(`Update buyerIdentity request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            if (!data?.cartBuyerIdentityUpdate?.updatedCart) {
                throw new Error('Update attributes cart object not returned in response');
            }
            const updatedCart = (0, humanize_graphql_response_1.default)(data.cartBuyerIdentityUpdate.updatedCart);
            return { error: null, updatedCart };
        }
        catch (error) {
            return { error: error.message, updatedCart: null };
        }
    }
}
exports.CartClient = CartClient;
//# sourceMappingURL=client.js.map

/***/ }),

/***/ 2728:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const graphql_request_1 = __webpack_require__(3671);
const customerFragment = (0, graphql_request_1.gql) `
  fragment Customer on Customer {
    acceptsMarketing
    createdAt
    defaultAddress {
      firstName
      lastName
      formatted
      formattedArea
      name
      address1
      address2
      latitude
      longitude
      id
      company
      country
      countryCodeV2
      province
      provinceCode
      phone
    }
    displayName
    email
    firstName
    id
    lastName
    phone
    tags
    updatedAt
    orders(first: 10) {
      edges {
        node {
          orderNumber
          id
        }
      }
    }
  }
`;
const buyerIdentity = (0, graphql_request_1.gql) `
  fragment BuyerIdentity on CartBuyerIdentity {
    email
    phone
    countryCode
    customer {
      ...Customer
    }
  }
  ${customerFragment}
`;
const attribute = (0, graphql_request_1.gql) `
  fragment Attribute on Attribute {
    key
    value
  }
`;
const discountCode = (0, graphql_request_1.gql) `
  fragment DiscountCode on CartDiscountCode {
    applicable
    code
  }
`;
const moneyV2 = (0, graphql_request_1.gql) `
  fragment MoneyV2 on MoneyV2 {
    amount
    currencyCode
  }
`;
const estimatedCost = (0, graphql_request_1.gql) `
  fragment EstimatedCost on CartEstimatedCost {
    subtotalAmount {
      ...MoneyV2
    }
    totalAmount {
      ...MoneyV2
    }
  }
`;
const lineEstimatedCost = (0, graphql_request_1.gql) `
  fragment LineEstimatedCost on CartLineEstimatedCost {
    subtotalAmount {
      ...MoneyV2
    }
    totalAmount {
      ...MoneyV2
    }
  }
`;
const discountAllocation = (0, graphql_request_1.gql) `
  fragment DiscountAllocation on CartDiscountAllocation {
    discountedAmount {
      ...MoneyV2
    }
    ... on CartCodeDiscountAllocation {
      __typename
      code
      discountedAmount {
        ...MoneyV2
      }
    }
    ... on CartCustomDiscountAllocation {
      __typename
      discountedAmount {
        ...MoneyV2
      }
      title
    }
    ... on CartAutomaticDiscountAllocation {
      __typename
      discountedAmount {
        ...MoneyV2
      }
      title
    }
  }
`;
const image = (0, graphql_request_1.gql) `
  fragment Image on Image {
    altText
    height
    src
    id
    width
  }
`;
const selectedOption = (0, graphql_request_1.gql) `
  fragment SelectedOption on SelectedOption {
    name
    value
  }
`;
const unitPriceMeasurement = (0, graphql_request_1.gql) `
  fragment UnitPriceMeasurement on UnitPriceMeasurement {
    measuredType
    quantityUnit
    quantityValue
    referenceUnit
    referenceValue
  }
`;
// barcode is erroring for some reason
const productVariant = (0, graphql_request_1.gql) `
  fragment ProductVariant on ProductVariant {
    availableForSale
    compareAtPriceV2 {
      ...MoneyV2
    }
    currentlyNotInStock
    id
    image {
      ...Image
    }
    priceV2 {
      ...MoneyV2
    }
    product {
      handle
      id
      title
      tags
      onlineStoreUrl
      collections(first: 100) {
        nodes {
          handle
        }
      }
      productType
    }
    quantityAvailable
    requiresShipping
    selectedOptions {
      ...SelectedOption
    }
    sku
    title
    unitPrice {
      ...MoneyV2
    }
    unitPriceMeasurement {
      ...UnitPriceMeasurement
    }
    weight
    weightUnit
  }
`;
const merchandise = (0, graphql_request_1.gql) `
  fragment Merchandise on Merchandise {
    ...ProductVariant
  }
`;
const priceAdjustment = (0, graphql_request_1.gql) `
  fragment PriceAdjustment on SellingPlanAllocationPriceAdjustment {
    compareAtPrice {
      ...MoneyV2
    }
    perDeliveryPrice {
      ...MoneyV2
    }
    price {
      ...MoneyV2
    }
    unitPrice {
      ...MoneyV2
    }
  }
`;
const sellingPlanOption = (0, graphql_request_1.gql) `
  fragment SellingPlanOption on SellingPlanOption {
    name
    value
  }
`;
const sellingPlan = (0, graphql_request_1.gql) `
  fragment SellingPlan on SellingPlan {
    description
    id
    name
    options {
      ...SellingPlanOption
    }
    recurringDeliveries
  }
`;
const fullCartFragment = (0, graphql_request_1.gql) `
  fragment FullCart on Cart {
    attributes {
      ...Attribute
    }
    buyerIdentity {
      ...BuyerIdentity
    }
    checkoutUrl
    createdAt
    discountAllocations {
      ...DiscountAllocation
    }
    discountCodes {
      ...DiscountCode
    }
    estimatedCost {
      ...EstimatedCost
    }
    id
    lines(first: 100) {
      edges {
        node {
          attributes {
            ...Attribute
          }
          discountAllocations {
            ...DiscountAllocation
          }
          estimatedCost {
            ...LineEstimatedCost
          }
          id
          variant: merchandise {
            ...Merchandise
          }
          quantity
          sellingPlanAllocation {
            sellingPlan {
              ...SellingPlan
            }
            priceAdjustments {
              ...PriceAdjustment
            }
          }
        }
      }
    }
    note
    updatedAt
    __typename
  }
  ${buyerIdentity}
  ${attribute}
  ${discountCode}
  ${moneyV2}
  ${estimatedCost}
  ${lineEstimatedCost}
  ${discountAllocation}
  ${image}
  ${selectedOption}
  ${unitPriceMeasurement}
  ${priceAdjustment}
  ${sellingPlan}
  ${sellingPlanOption}
  ${productVariant}
  ${merchandise}
`;
const useErrors = (0, graphql_request_1.gql) `
  fragment UserError on CartUserError {
    code
    field
    message
  }
`;
exports["default"] = {
    useErrors,
    fullCartFragment,
};
//# sourceMappingURL=fragments.js.map

/***/ }),

/***/ 4812:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CartClient = void 0;
var client_1 = __webpack_require__(106);
Object.defineProperty(exports, "CartClient", ({ enumerable: true, get: function () { return client_1.CartClient; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 9881:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.mutations = void 0;
const tslib_1 = __webpack_require__(5556);
/* eslint-disable prettier/prettier */
const graphql_request_1 = __webpack_require__(3671);
const fragments_1 = tslib_1.__importDefault(__webpack_require__(2728));
/*
  Mutations
*/
const addItems = (0, graphql_request_1.gql) `
  mutation addItems($country: CountryCode, $cartId: ID!, $lines: [CartLineInput!]!)
  @inContext(country: $country) {
    cartLinesAdd(cartId: $cartId, lines: $lines) {
      updatedCart: cart {
        ...FullCart
      }
      userErrors {
        ...UserError
      }
    }
  }
  ${fragments_1.default.fullCartFragment}
  ${fragments_1.default.useErrors}
`;
const create = (0, graphql_request_1.gql) `
  mutation create($country: CountryCode, $cartInput: CartInput)
  @inContext(country: $country) {
    cartCreate(input: $cartInput) {
      cart {
        ...FullCart
      }
      userErrors {
        ...UserError
      }
    }
  }
  ${fragments_1.default.fullCartFragment}
  ${fragments_1.default.useErrors}
`;
const removeItems = (0, graphql_request_1.gql) `
  mutation removeItems($country: CountryCode, $cartId: ID!, $lineIds: [ID!]!)
  @inContext(country: $country) {
    cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
      updatedCart: cart {
        ...FullCart
      }
      userErrors {
        ...UserError
      }
    }
  }
  ${fragments_1.default.fullCartFragment}
  ${fragments_1.default.useErrors}
`;
const updateAttributes = (0, graphql_request_1.gql) `
  mutation updateAttributes($country: CountryCode, $cartId: ID!, $attributes: [AttributeInput!]!)
  @inContext(country: $country) {
    cartAttributesUpdate(cartId: $cartId, attributes: $attributes) {
      updatedCart: cart {
        ...FullCart
      }
      userErrors {
        ...UserError
      }
    }
  }
  ${fragments_1.default.fullCartFragment}
  ${fragments_1.default.useErrors}
`;
const updateBuyerIdentity = (0, graphql_request_1.gql) `
  mutation updateBuyerIdentity($country: CountryCode, $cartId: ID!, $buyerIdentity: CartBuyerIdentityInput!)
  @inContext(country: $country) {
    cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: $buyerIdentity) {
      updatedCart: cart {
        ...FullCart
      }
      userErrors {
        ...UserError
      }
    }
  }
  ${fragments_1.default.fullCartFragment}
  ${fragments_1.default.useErrors}
`;
const updateDiscountCode = (0, graphql_request_1.gql) `
  mutation updateDiscountCode($country: CountryCode, $cartId: ID!, $discountCodes: [String!])
  @inContext(country: $country) {
    cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
      updatedCart: cart {
        ...FullCart
      }
      userErrors {
        ...UserError
      }
    }
  }
  ${fragments_1.default.fullCartFragment}
  ${fragments_1.default.useErrors}
`;
const updateItems = (0, graphql_request_1.gql) `
  mutation updateItems($country: CountryCode, $cartId: ID!, $lines: [CartLineUpdateInput!]!)
  @inContext(country: $country) {
    cartLinesUpdate(cartId: $cartId, lines: $lines) {
      updatedCart: cart {
        ...FullCart
      }
      userErrors {
        ...UserError
      }
    }
  }
  ${fragments_1.default.fullCartFragment}
  ${fragments_1.default.useErrors}
`;
const updateNote = (0, graphql_request_1.gql) `
  mutation updateNote($country: CountryCode, $cartId: ID!, $note: String)
  @inContext(country: $country) {
    cartNoteUpdate(cartId: $cartId, note: $note) {
      updatedCart: cart {
        ...FullCart
      }
      userErrors {
        ...UserError
      }
    }
  }
  ${fragments_1.default.fullCartFragment}
  ${fragments_1.default.useErrors}
`;
exports.mutations = {
    addItems,
    create,
    removeItems,
    updateAttributes,
    updateBuyerIdentity,
    updateDiscountCode,
    updateItems,
    updateNote,
};
//# sourceMappingURL=mutations.js.map

/***/ }),

/***/ 4765:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.queries = void 0;
const tslib_1 = __webpack_require__(5556);
/* eslint-disable prettier/prettier */
const graphql_request_1 = __webpack_require__(3671);
const fragments_1 = tslib_1.__importDefault(__webpack_require__(2728));
/*
  Queries
*/
const get = (0, graphql_request_1.gql) `
  query ($id: ID!, $country: CountryCode) @inContext(country: $country) {
    cart(id: $id) {
      ...FullCart
    }
  }
  ${fragments_1.default.fullCartFragment}
`;
exports.queries = {
    get,
};
//# sourceMappingURL=queries.js.map

/***/ }),

/***/ 8081:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(5556);
tslib_1.__exportStar(__webpack_require__(7892), exports);
tslib_1.__exportStar(__webpack_require__(6228), exports);
tslib_1.__exportStar(__webpack_require__(1887), exports);
tslib_1.__exportStar(__webpack_require__(4717), exports);
// getters / selectors
tslib_1.__exportStar(__webpack_require__(7542), exports);
tslib_1.__exportStar(__webpack_require__(9659), exports);
tslib_1.__exportStar(__webpack_require__(3953), exports);
tslib_1.__exportStar(__webpack_require__(3660), exports);
tslib_1.__exportStar(__webpack_require__(8587), exports);
tslib_1.__exportStar(__webpack_require__(295), exports);
tslib_1.__exportStar(__webpack_require__(2914), exports);
tslib_1.__exportStar(__webpack_require__(3061), exports);
tslib_1.__exportStar(__webpack_require__(3437), exports);
tslib_1.__exportStar(__webpack_require__(3015), exports); // no-op
tslib_1.__exportStar(__webpack_require__(6511), exports);
tslib_1.__exportStar(__webpack_require__(9745), exports);
tslib_1.__exportStar(__webpack_require__(8692), exports);
tslib_1.__exportStar(__webpack_require__(2249), exports);
tslib_1.__exportStar(__webpack_require__(1350), exports);
tslib_1.__exportStar(__webpack_require__(4471), exports);
tslib_1.__exportStar(__webpack_require__(5153), exports);
tslib_1.__exportStar(__webpack_require__(7411), exports);
tslib_1.__exportStar(__webpack_require__(339), exports);
tslib_1.__exportStar(__webpack_require__(9249), exports);
tslib_1.__exportStar(__webpack_require__(2177), exports); // no-op
tslib_1.__exportStar(__webpack_require__(9997), exports); // no-op
tslib_1.__exportStar(__webpack_require__(1899), exports);
tslib_1.__exportStar(__webpack_require__(4502), exports);
tslib_1.__exportStar(__webpack_require__(364), exports);
tslib_1.__exportStar(__webpack_require__(5201), exports);
tslib_1.__exportStar(__webpack_require__(6307), exports);
tslib_1.__exportStar(__webpack_require__(579), exports);
tslib_1.__exportStar(__webpack_require__(7759), exports);
tslib_1.__exportStar(__webpack_require__(684), exports);
tslib_1.__exportStar(__webpack_require__(3781), exports);
tslib_1.__exportStar(__webpack_require__(6442), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 7542:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCart = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const helpers_1 = __webpack_require__(5542);
const useCart = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const cart = (0, store_1.useRecoilValue)(store_1.default.cart);
    const cartItems = (0, store_1.useRecoilValue)(store_1.default.cartItems$());
    return isMounted && cart ? { ...cart, lines: cartItems } : null;
};
exports.useCart = useCart;
//# sourceMappingURL=useCart.js.map

/***/ }),

/***/ 1899:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartAddAttributes = void 0;
const tslib_1 = __webpack_require__(5556);
const react_1 = __webpack_require__(7378);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useCartStartFinishErrors_1 = __webpack_require__(4420);
const useCartUpdateAttributes_1 = __webpack_require__(364);
const useCartAddAttributes = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({
        ...options,
        id: 'cart/addAttributes',
    });
    // action
    const setCart = (0, store_1.useSetRecoilState)(store_1.default.cart);
    const existingAttributes = (0, store_1.useRecoilValue)(store_1.default.cartAttributes$);
    const { cartUpdateAttributes } = (0, useCartUpdateAttributes_1.useCartUpdateAttributes)();
    const cartAddAttributes = (0, react_1.useCallback)(async (data, callback) => {
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data: {
                    validationErrors = [
                        `parameter is required; must be an object with "attributes", e.g. "{ attributes: [{ key: 'abc', value: '123' }] }"`,
                    ];
                    break;
                }
                case typeof data !== 'object': {
                    validationErrors = [
                        `parameter must be an object with "attributes", e.g. "{ attributes: [{ key: 'abc', value: '123' }] }"`,
                    ];
                    break;
                }
                case !data?.attributes: {
                    validationErrors = [
                        `"attributes" is required in parameter object, e.g. "{ attributes: [{ key: 'abc', value: '123' }] }"`,
                    ];
                    break;
                }
                case !Array.isArray(data?.attributes): {
                    validationErrors = [
                        `"attributes" must be an array, e.g. "{ attributes: [{ key: 'abc', value: '123' }] }"`,
                    ];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                throw new Error(validationErrors[0]);
            }
            const updatedCart = await cartUpdateAttributes({
                attributes: [...existingAttributes, ...data.attributes],
            });
            if (!updatedCart || !updatedCart?.id) {
                throw new Error('Invalid cart add attributes response');
            }
            setFinished(true);
            setCart(updatedCart);
            if (callback)
                callback(updatedCart);
            return updatedCart;
        }
        catch (error) {
            console.error('cartAddAttributes:error', error.message);
            setErrors([error.message]);
            return null;
        }
    });
    return {
        cartAddAttributes,
        setStarted,
        setFinished,
        setErrors,
        ...status,
    };
};
exports.useCartAddAttributes = useCartAddAttributes;
//# sourceMappingURL=useCartAddAttributes.js.map

/***/ }),

/***/ 7411:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartAddDiscount = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useCartStartFinishErrors_1 = __webpack_require__(4420);
const useCartAddDiscount = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({ ...options, id: 'cart/addDiscount' });
    const setCart = (0, store_1.useSetRecoilState)(store_1.default.cart);
    const cartAddDiscount = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data:
                    validationErrors = [
                        `parameter is required; must be an object with "discountCode", e.g. "{ discountCode: 'abc123' }"`,
                    ];
                    break;
                case typeof data !== 'object':
                    validationErrors = [
                        `parameter must be an object with "discountCode", e.g. "{ discountCode: 'abc123' }"`,
                    ];
                    break;
                case !data?.discountCode: {
                    validationErrors = [
                        `"discountCode" is required in parameter object, e.g. "{ discountCode: 'abc123' }"`,
                    ];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                throw new Error(validationErrors[0]);
            }
            const { error, updatedCart } = await snapshot.getPromise(store_1.default.cartUpdateDiscount(data));
            if (error) {
                throw new Error(error);
            }
            if (!updatedCart || updatedCart?.__typename !== 'Cart') {
                throw new Error(`Invalid cart note update response for note ${data?.note}`);
            }
            setFinished(true);
            setCart(updatedCart);
            if (callback)
                callback(updatedCart);
            return updatedCart;
        }
        catch (error) {
            console.error('cartAddDiscount:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    return {
        cartAddDiscount,
        setStarted,
        setFinished,
        setErrors,
        ...status,
    };
};
exports.useCartAddDiscount = useCartAddDiscount;
//# sourceMappingURL=useCartAddDiscount.js.map

/***/ }),

/***/ 339:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartAddDiscountUrl = void 0;
const tslib_1 = __webpack_require__(5556);
/* eslint-disable no-unused-expressions */
const router_1 = __webpack_require__(6677);
const react_1 = __webpack_require__(7378);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useCartAddDiscount_1 = __webpack_require__(7411);
const DEBUG = false;
const defaultProps = {
    queryParams: ['discount_code', 'discountCode'],
    removeParams: true,
};
/**
  looks for ?discountCode=xyz and attempts to apply it to the cart
  if we want to use another param we can pass it to this hook via queryParams
  e.g — useCartAddDiscountUrl({ queryParams: ['promo'] }) -> would work on  https..?promo=PACK_TEST
*/
const useCartAddDiscountUrl = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const cartId = (0, store_1.useRecoilValue)(store_1.default.cartId$);
    const [appliedDiscount, setApplied] = (0, react_1.useState)();
    const router = (0, router_1.useRouter)();
    const { cartAddDiscount } = (0, useCartAddDiscount_1.useCartAddDiscount)();
    const applyDiscountCodeOnMount = async () => {
        // already has a discount applied
        if (appliedDiscount || !cartId) {
            return null;
        }
        try {
            // search url params for a discount param, continue after the first find.
            const discountCode = Object.keys(router.query).reduce((_code, param) => {
                const isDiscountParam = props.queryParams.includes(param);
                if (_code)
                    return _code;
                if (isDiscountParam) {
                    const code = router.query[param];
                    return code;
                }
                return _code;
            }, null);
            DEBUG && console.log('useCartAddDiscountUrl:discountCode', discountCode);
            // eslint-disable-next-line prettier/prettier
            DEBUG && console.log(`useCartAddDiscountUrl: detected discount code ${discountCode} in a param(s) ${props.queryParams.join(',')}`);
            if (!discountCode)
                return null;
            DEBUG && console.log('useCartAddDiscountUrl: applying discount...');
            const cartWithDiscount = await cartAddDiscount({
                discountCode,
                checkoutId: cartId,
            });
            // eslint-disable-next-line prettier/prettier
            DEBUG && console.log('useCartAddDiscountUrl: discount application response', cartWithDiscount);
            // check if invalid discountCode provided
            if (!cartWithDiscount?.discountApplications?.length) {
                setApplied(false);
                // eslint-disable-next-line prettier/prettier
                DEBUG && console.log('useCartAddDiscountUrl: discount code application failed');
                return null;
            }
            DEBUG && console.log('useCartAddDiscountUrl: discount code applied!');
            const [base, params] = router.asPath.split('?');
            // if we have url param(s)
            if (params?.length && props.removeParams) {
                const cleanParams = new URLSearchParams(params);
                // remove promo from url after its been applied
                props.queryParams.forEach((param) => {
                    cleanParams.delete(param);
                });
                // if we still have other params after removing the discount one we keep them
                if (cleanParams.toString().length) {
                    // eslint-disable-next-line prettier/prettier
                    router.replace(`${base}?${cleanParams}`, undefined, { shallow: true });
                }
                else {
                    router.replace(`${base}`, undefined, { shallow: true });
                }
            }
            const appliedCode = cartWithDiscount.discountApplications[0];
            setApplied(appliedCode);
            return appliedCode;
        }
        catch (error) {
            setApplied(false);
            return null;
        }
    };
    (0, react_1.useEffect)(() => {
        applyDiscountCodeOnMount();
    }, [Object.keys(router.query).join(','), cartId]);
    return appliedDiscount;
};
exports.useCartAddDiscountUrl = useCartAddDiscountUrl;
//# sourceMappingURL=useCartAddDiscountUrl.js.map

/***/ }),

/***/ 2177:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartAddGiftCard = void 0;
const react_1 = __webpack_require__(7378);
const useCartAddGiftCard = () => {
    (0, react_1.useEffect)(() => {
        console.warn('Cart giftcards are not yet supported on Cart API (v2)');
    }, []);
    return {
        cartAddGiftCard: null,
    };
};
exports.useCartAddGiftCard = useCartAddGiftCard;
//# sourceMappingURL=useCartAddGiftCard.js.map

/***/ }),

/***/ 6307:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartAddItem = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useCartStartFinishErrors_1 = __webpack_require__(4420);
const helpers_1 = __webpack_require__(5542);
const useCartAddItem = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({ ...options, id: 'cart/addItem' });
    // action
    const setCart = (0, store_1.useSetRecoilState)(store_1.default.cart);
    // fetch an existing cart using a checkoutId
    const cartAddItem = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        // current cart
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data:
                    validationErrors = [
                        `parameter is required; must be an object with "merchandiseId" and "quantity", e.g. "{ merchandiseId: 'abc123', quantity: 1 }"`,
                    ];
                    break;
                case typeof data !== 'object':
                    validationErrors = [
                        `parameter must be an object with "merchandiseId" and "quantity", e.g. "{ merchandiseId: 'abc123', quantity: 1 }"`,
                    ];
                    break;
                case !data?.merchandiseId:
                    validationErrors = [
                        `"merchandiseId" is required in parameter object, e.g. "{ merchandiseId: 'abc123', quantity: 1 }"`,
                    ];
                    break;
                case !data?.quantity:
                    validationErrors = [
                        `"quantity" is required in parameter object, e.g. "{ merchandiseId: 'abc123', quantity: 1 }"`,
                    ];
                    break;
                default:
                    break;
            }
            if (validationErrors?.length) {
                throw new Error(validationErrors[0]);
            }
            const _cart = snapshot.getLoadable(store_1.default.cart).contents;
            const { itemInCart, attributes, haveSameAttributes } = (0, helpers_1.getAddAction)({
                cart: _cart,
                data,
            });
            const addItemPromise = store_1.default.cartAddItem({
                ...data,
                attributes,
            });
            const updateItemPromise = store_1.default.cartUpdateItem({
                ...data,
                lineId: itemInCart?.id,
                quantity: data.quantity + (itemInCart?.quantity || 0),
                attributes,
            });
            const updateExisting = itemInCart && haveSameAttributes;
            // update existing cart item if already in cart
            const { error, updatedCart } = updateExisting
                ? await snapshot.getPromise(updateItemPromise) // update existing item
                : await snapshot.getPromise(addItemPromise); // add the item
            if (error) {
                throw new Error(error);
            }
            if (!updatedCart || updatedCart?.__typename !== 'Cart') {
                throw new Error(`Invalid cart add item response for merchandiseId ${data?.merchandiseId}`);
            }
            setFinished(true);
            setCart(updatedCart);
            if (callback)
                callback(updatedCart);
            return updatedCart;
        }
        catch (error) {
            console.error('cartAddItem:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    return {
        cartAddItem,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useCartAddItem = useCartAddItem;
//# sourceMappingURL=useCartAddItem.js.map

/***/ }),

/***/ 579:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartAddItems = void 0;
const tslib_1 = __webpack_require__(5556);
/* eslint-disable no-await-in-loop */
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useCartStartFinishErrors_1 = __webpack_require__(4420);
const helpers_1 = __webpack_require__(5542);
const useCartAddItems = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({ ...options, id: 'cart/addItems' });
    // action
    const setCart = (0, store_1.useSetRecoilState)(store_1.default.cart);
    const cartAddItems = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data:
                    validationErrors = [
                        `parameter is required; must be an array of objects with "merchandiseId" and "quantity", e.g. "[{ merchandiseId: 'abc123', quantity: 1 }]"`,
                    ];
                    break;
                case !Array.isArray(data):
                    validationErrors = [
                        `parameter must be an array of objects with "merchandiseId" and "quantity", e.g. "[{ merchandiseId: 'abc123', quantity: 1 }]"`,
                    ];
                    break;
                case !data?.length:
                    validationErrors = [
                        `parameter array must have at least one item to add, e.g. "[{ merchandiseId: 'abc123', quantity: 1 }]"`,
                    ];
                    break;
                // check all passed items to add have a variantId prop
                case data?.some((item) => !item?.merchandiseId):
                    validationErrors = [
                        `"merchandiseId" is required in every object in parameter array, e.g. "[{ merchandiseId: 'abc123', quantity: 1 }]"`,
                    ];
                    break;
                // check all passed items to add have a quantity prop
                case data?.some((item) => !item?.quantity):
                    validationErrors = [
                        `"quantity" is required in every object in parameter array, e.g. "[{ merchandiseId: 'abc123', quantity: 1 }]"`,
                    ];
                    break;
                default:
                    break;
            }
            if (validationErrors?.length) {
                throw new Error(validationErrors[0]);
            }
            const results = [];
            // add or update each line item
            for (let index = 0; index < data.length; index += 1) {
                const currentItem = data[index];
                const _cart = snapshot.getLoadable(store_1.default.cart).contents;
                const { itemInCart, attributes, haveSameAttributes } = (0, helpers_1.getAddAction)({
                    cart: _cart,
                    data: currentItem,
                });
                const addItemPromise = store_1.default.cartAddItem({
                    ...currentItem,
                    quantity: itemInCart && haveSameAttributes
                        ? itemInCart.quantity + currentItem.quantity
                        : currentItem.quantity,
                    attributes,
                });
                const updateItemPromise = store_1.default.cartUpdateItem({
                    lineId: itemInCart?.id,
                    quantity: currentItem.quantity + (itemInCart?.quantity || 0),
                    attributes,
                });
                // update existing cart item if already in cart
                const { error, updatedCart } = itemInCart && haveSameAttributes
                    ? await snapshot.getPromise(updateItemPromise) // update existing item
                    : await snapshot.getPromise(addItemPromise); // add the item
                if (error) {
                    throw new Error(error);
                }
                if (!updatedCart || updatedCart?.__typename !== 'Cart') {
                    throw new Error(`Failed to add item with id ${currentItem.merchandiseId}`);
                }
                else {
                    results.push(updatedCart);
                    snapshot.map(({ set }) => set(store_1.default.cart, updatedCart));
                }
            }
            const isValidCart = (cart) => cart && cart?.id;
            const success = results.filter(isValidCart).filter(Boolean).length === data?.length;
            if (!success) {
                throw new Error('Invalid add line items cart response');
            }
            const cart = results[results.length - 1];
            setFinished(true);
            setCart(cart);
            if (callback)
                callback(cart);
            return cart;
        }
        catch (error) {
            console.error('cartAddItems:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    return {
        cartAddItems,
        setStarted,
        setErrors,
        setFinished,
        ...status,
    };
};
exports.useCartAddItems = useCartAddItems;
//# sourceMappingURL=useCartAddItems.js.map

/***/ }),

/***/ 6511:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartAttributes = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const helpers_1 = __webpack_require__(5542);
const useCartAttributes = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const cartAttributes = (0, store_1.useRecoilValue)(store_1.default.cartAttributes$);
    return isMounted ? cartAttributes : [];
};
exports.useCartAttributes = useCartAttributes;
//# sourceMappingURL=useCartAttributes.js.map

/***/ }),

/***/ 6228:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartBuyer = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const helpers_1 = __webpack_require__(5542);
const useCartBuyer = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const cartBuyer = (0, store_1.useRecoilValue)(store_1.default.cartBuyer);
    return isMounted ? cartBuyer : null;
};
exports.useCartBuyer = useCartBuyer;
//# sourceMappingURL=useCartBuyer.js.map

/***/ }),

/***/ 5153:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartCheckout = void 0;
const tslib_1 = __webpack_require__(5556);
/* eslint-disable no-undef */
const react_1 = __webpack_require__(7378);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useCartStartFinishErrors_1 = __webpack_require__(4420);
const useCartCheckout = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({ ...options, id: 'cart/checkout' });
    const cartCheckoutUrl = (0, store_1.useRecoilValue)(store_1.default.cartCheckoutUrl$);
    const customer = (0, store_1.useRecoilValue)(store_1.default.customer);
    const setCartCheckout = (0, store_1.useSetRecoilState)(store_1.default.cartCheckout);
    // attempts to redirect the user to the checkout logged in (with Shopify+ multi-pass token)
    const cartCheckout = (0, react_1.useCallback)(async (data, callback) => {
        const redirect = typeof data?.redirect !== 'undefined' ? data?.redirect : true;
        let loggedOutCartCheckout;
        let checkoutUrl = cartCheckoutUrl; // e.g — storefront.myshopify.com
        // if we have cart domain we modify the checkout url host — e.g shop.storefront.com
        if (true) {
            checkoutUrl = new URL(cartCheckoutUrl);
            checkoutUrl.host = "shop.clearlyfiltered.com";
        }
        const maybeCheckoutViaMultiPass = async () => {
            // data for multi-pass token
            const multiPassCustomer = {
                email: customer.email,
                addresses: customer.defaultAddress ? [customer.defaultAddress] : [],
                firstName: customer.firstName,
                lastName: customer.lastName,
                acceptsMarketing: customer.acceptsMarketing,
                return_to: checkoutUrl,
                tag_string: customer.tags.join(', '),
                created_at: new Date().toISOString(),
            };
            if (!multiPassCustomer)
                throw new Error('Missing multiPassCustomer');
            // fetch an authenticated multipass token from our api
            const multiPassReq = await fetch('/api/multipass', {
                method: 'POST',
                body: JSON.stringify(multiPassCustomer),
            });
            const multiPass = await multiPassReq.json();
            if (multiPassReq?.status !== 200) {
                console.log(`Checking out without multipass (401):`, multiPass.error);
                setErrors([`multipass api failed: ${multiPass.error}`]);
                setFinished(true);
                setCartCheckout(loggedOutCartCheckout);
                if (callback)
                    callback(checkoutUrl);
                return checkoutUrl;
            }
            if (multiPass?.error) {
                setErrors(['There was an error creating a multipass token']);
                setFinished(true);
                setCartCheckout(loggedOutCartCheckout);
                if (callback)
                    callback(checkoutUrl);
                return checkoutUrl;
            }
            if (multiPass?.url) {
                // got multi-pass url, go to checkout with multi-pass
                setFinished(true);
                const checkout = {
                    url: multiPass.url,
                    multiPass: true,
                    redirect,
                };
                setCartCheckout(checkout);
                if (callback)
                    callback(multiPass.url);
                return multiPass.url;
            }
            // just in case
            setFinished(true);
            setCartCheckout(loggedOutCartCheckout);
            if (callback)
                callback(checkoutUrl);
            return checkoutUrl;
        };
        // Attempt to checkout via multipass or regular
        try {
            setStarted(true);
            if (!checkoutUrl) {
                setErrors(['Cart checkoutUrl not provided']);
                return null;
            }
            // default checkout object (if no multipass)
            loggedOutCartCheckout = {
                url: checkoutUrl,
                redirect,
                multiPass: false,
            };
            // only if we have a customer we can attempt to multi-pass checkout
            if (customer) {
                await maybeCheckoutViaMultiPass();
                return true;
            }
            setFinished(true);
            // setting cartCheckout will trigger a redirect (if true)
            setCartCheckout(loggedOutCartCheckout);
            if (callback)
                callback(loggedOutCartCheckout);
            return loggedOutCartCheckout;
        }
        catch (exception) {
            setErrors([exception.message]);
            const checkout = {
                url: checkoutUrl,
                redirect,
                multiPass: false,
            };
            setCartCheckout(checkout);
            return checkout;
        }
    }, [customer, cartCheckoutUrl]);
    return {
        cartCheckout,
        setStarted,
        setErrors,
        setFinished,
        ...status,
    };
};
exports.useCartCheckout = useCartCheckout;
//# sourceMappingURL=useCartCheckout.js.map

/***/ }),

/***/ 4471:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartClear = void 0;
const tslib_1 = __webpack_require__(5556);
const react_1 = __webpack_require__(7378);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useCartRemoveItems_1 = __webpack_require__(684);
const useCartClear = () => {
    const cart = (0, store_1.useRecoilValue)(store_1.default.cart);
    const { cartRemoveItems, ...removeItemsState } = (0, useCartRemoveItems_1.useCartRemoveItems)();
    const cartClear = (0, react_1.useCallback)(async (callback) => {
        if (!cart?.lines?.length) {
            removeItemsState.setErrors(['Cart is already empty']);
            if (callback)
                callback(null);
            return null;
        }
        const lineIds = cart?.lines.map(({ id }) => id);
        const _cart = await cartRemoveItems({ lineIds });
        if (callback)
            callback(_cart);
        return _cart;
    }, [cart?.lines?.length, removeItemsState]);
    return {
        cartClear,
        ...removeItemsState,
    };
};
exports.useCartClear = useCartClear;
//# sourceMappingURL=useCartClear.js.map

/***/ }),

/***/ 3953:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartCount = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const helpers_1 = __webpack_require__(5542);
const useCartCount = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const cartCount = (0, store_1.useRecoilValue)(store_1.default.cartCount$);
    return isMounted ? cartCount : null;
};
exports.useCartCount = useCartCount;
//# sourceMappingURL=useCartCount.js.map

/***/ }),

/***/ 1350:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartCreate = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useCartStartFinishErrors_1 = __webpack_require__(4420);
const useCartCreate = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({ ...options, id: 'cart/create' });
    // action
    const setCart = (0, store_1.useSetRecoilState)(store_1.default.cart);
    // create a new cart with optional email, shippingAddress and note
    const cartCreate = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            const { error, newCart } = await snapshot.getPromise(store_1.default.cartCreate({
                country: data?.country || 'US',
                cartInput: data?.cartInput || {},
            }));
            if (error) {
                throw new Error(error);
            }
            if (!newCart || !newCart?.id || newCart?.__typename !== 'Cart') {
                throw new Error(`Invalid cart create response ${newCart}`);
            }
            setFinished(true);
            setCart(newCart);
            if (callback)
                callback(newCart);
            return newCart;
        }
        catch (error) {
            console.error('cartCreate:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    return {
        cartCreate,
        setStarted,
        setErrors,
        setFinished,
        ...status,
    };
};
exports.useCartCreate = useCartCreate;
//# sourceMappingURL=useCartCreate.js.map

/***/ }),

/***/ 9745:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartDiscounts = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const helpers_1 = __webpack_require__(5542);
const useCartDiscounts = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const cartDiscounts = (0, store_1.useRecoilValue)(store_1.default.cartDiscounts$);
    return isMounted ? cartDiscounts : [];
};
exports.useCartDiscounts = useCartDiscounts;
//# sourceMappingURL=useCartDiscounts.js.map

/***/ }),

/***/ 8587:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartEmail = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const helpers_1 = __webpack_require__(5542);
const useCartEmail = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const cartEmail = (0, store_1.useRecoilValue)(store_1.default.cartEmail$);
    return isMounted ? cartEmail : null;
};
exports.useCartEmail = useCartEmail;
//# sourceMappingURL=useCartEmail.js.map

/***/ }),

/***/ 2914:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartEmpty = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const helpers_1 = __webpack_require__(5542);
const useCartEmpty = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const cartEmpty = (0, store_1.useRecoilValue)(store_1.default.cartEmpty$);
    return isMounted ? cartEmpty : null;
};
exports.useCartEmpty = useCartEmpty;
//# sourceMappingURL=useCartEmpty.js.map

/***/ }),

/***/ 2249:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartGet = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useCartStartFinishErrors_1 = __webpack_require__(4420);
const useCartGet = (options) => {
    const country = (0, store_1.useRecoilValue)(store_1.default.country);
    const countryCode = country?.isoCode || 'US';
    const currencyCode = country?.currency?.isoCode || 'USD';
    // action
    const setCart = (0, store_1.useSetRecoilState)(store_1.default.cart);
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({
        ...options,
        id: `cart/get/${countryCode}/${currencyCode}`,
    });
    // fetch an existing cart using a checkoutId
    const cartGet = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data:
                    validationErrors = [
                        `parameter is required; must be an object with "id", e.g. "{ id: 'abc123' }"`,
                    ];
                    break;
                case typeof data !== 'object':
                    validationErrors = [
                        `parameter must be an object with "id", e.g. "{ id: 'abc123' }"`,
                    ];
                    break;
                case !data?.id: {
                    validationErrors = [
                        `"id" is required in parameter object, e.g. "{ id: 'abc123' }"`,
                    ];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                throw new Error(validationErrors[0]);
            }
            const { error, existingCart } = await snapshot.getPromise(store_1.default.cartGet({ id: data?.id || null }));
            if (error) {
                throw new Error(error);
            }
            if (!existingCart || existingCart?.__typename !== 'Cart') {
                throw new Error(`Invalid cart fetch response for id: ${data?.id}`);
            }
            setFinished(true);
            setCart(existingCart);
            if (callback)
                callback(existingCart);
            return existingCart;
        }
        catch (error) {
            console.error('cartGet:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    return {
        cartGet,
        setStarted,
        setErrors,
        setFinished,
        ...status,
    };
};
exports.useCartGet = useCartGet;
//# sourceMappingURL=useCartGet.js.map

/***/ }),

/***/ 3015:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartGiftCards = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const helpers_1 = __webpack_require__(5542);
// Not yet supported on CART API
const useCartGiftCards = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const giftCards = (0, store_1.useRecoilValue)(store_1.default.cartGiftCards$);
    return isMounted ? giftCards : [];
};
exports.useCartGiftCards = useCartGiftCards;
//# sourceMappingURL=useCartGiftCards.js.map

/***/ }),

/***/ 9659:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartId = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const helpers_1 = __webpack_require__(5542);
const useCartId = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const cartId = (0, store_1.useRecoilValue)(store_1.default.cart)?.id;
    return isMounted ? cartId : null;
};
exports.useCartId = useCartId;
//# sourceMappingURL=useCartId.js.map

/***/ }),

/***/ 8692:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartInit = void 0;
const tslib_1 = __webpack_require__(5556);
/* eslint-disable no-unused-expressions */
const react_1 = __webpack_require__(7378);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useCartGet_1 = __webpack_require__(2249);
const useCartCreate_1 = __webpack_require__(1350);
const DEBUG = false;
const defaultProps = {
    fetchOnMount: false,
    options: {},
};
const useCartInit = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const initializing = (0, react_1.useRef)(false);
    const setCustomerAndCartInit = (0, store_1.useSetRecoilState)(store_1.default.customerAndCartInit);
    const customerInit = (0, store_1.useRecoilValue)(store_1.default.customerInit);
    const [cartInit, setCartInit] = (0, store_1.useRecoilState)(store_1.default.cartInit);
    const [cart, setCart] = (0, store_1.useRecoilState)(store_1.default.cart);
    const customer = (0, store_1.useRecoilValue)(store_1.default.customer);
    const { cartGet, ...carGetStatus } = (0, useCartGet_1.useCartGet)();
    const { cartCreate, ...carCreateStatus } = (0, useCartCreate_1.useCartCreate)();
    const getCartAction = (0, react_1.useCallback)((_cart) => {
        // only run when customer has been initialized
        const thenDaysAgo = new Date();
        thenDaysAgo.setDate(thenDaysAgo.getDate() - 10);
        const createdAt = _cart?.createdAt ? new Date(_cart.createdAt) : new Date();
        // validations
        const noPersistedCart = !_cart;
        const cartPurchased = _cart?.completedAt || false;
        const persistedCartInvalid = !_cart?.id || (_cart?.__typename && _cart.__typename !== 'Cart');
        const isTenDaysOld = createdAt < thenDaysAgo;
        // any true returns true
        const shouldCreate = [
            noPersistedCart,
            cartPurchased,
            persistedCartInvalid,
            isTenDaysOld,
        ].some(Boolean);
        if (shouldCreate) {
            let createReason = null;
            if (noPersistedCart) {
                createReason = "Don't have a persisted cart, creating new cart...";
            }
            else if (persistedCartInvalid) {
                createReason =
                    'Have persisted cart, buts its invalid. creating new cart...';
            }
            else if (cartPurchased) {
                createReason =
                    'Have persisted cart but its been purchased, creating new cart...';
            }
            else if (isTenDaysOld) {
                createReason =
                    'Have expired persisted cart (10+ days old), creating new cart...';
            }
            // just for troubleshooting
            DEBUG &&
                createReason &&
                console.log(`🛒 cart init: creating new cart due: ${createReason}`);
        }
        return shouldCreate;
    }, []);
    const createNewCart = (0, react_1.useCallback)(async ({ email, attempt = 0 }) => {
        const maxRetries = 2;
        let newCart = null;
        if (attempt >= maxRetries) {
            setCartInit(false);
            return null;
        }
        newCart = await cartCreate({
            cartInput: email ? { buyerIdentity: { email } } : {},
        });
        if (newCart?.id) {
            setCartInit(true);
            return newCart;
        }
        // if we fail to create we should retry one more time
        return createNewCart({
            email,
            attempt: attempt + 1,
        });
    }, []);
    const createOrGetCartOnCustomerInit = () => {
        if (!props.fetchOnMount)
            return;
        if (!customerInit)
            return;
        if (initializing.current)
            return;
        if (cartInit) {
            setCustomerAndCartInit(true); // set for analytics (customer event)
            return;
        }
        initializing.current = true;
        const validatePersistedCartAndReuseOrCreate = async () => {
            const existingCart = await cartGet({ id: cart.id });
            if (existingCart?.id) {
                setCart(existingCart);
                setCartInit(true);
                return;
            }
            if (!existingCart) {
                setCart(null);
                await createNewCart({ email: customer?.email, attempt: 1 });
            }
        };
        if (getCartAction(cart)) {
            createNewCart({ email: customer?.email, attempt: 1 });
        }
        else {
            validatePersistedCartAndReuseOrCreate();
        }
    };
    (0, react_1.useEffect)(() => {
        createOrGetCartOnCustomerInit();
    }, [customerInit, cartInit, cart, customer, props?.fetchOnMount]);
    // no bueno if we get here
    const cartInitErrorHandler = () => {
        // todo: currently if we error and then retry and succeed this would still show the initial error
        const anyErrors = carGetStatus?.errors?.length || carCreateStatus?.errors?.length;
        if (anyErrors) {
            console.groupCollapsed('🛒 cart init: failed 🚫');
            carGetStatus?.errors &&
                console.log('🛒 cart init: get errors:\t\t\t', carGetStatus?.errors);
            carCreateStatus?.errors &&
                console.log('🛒 cart init: create errors:\t\t\t', carCreateStatus?.errors);
            console.groupEnd();
        }
    };
    (0, react_1.useEffect)(() => {
        cartInitErrorHandler();
    }, [carGetStatus?.errors?.length, carCreateStatus?.errors?.length]);
    return cart;
};
exports.useCartInit = useCartInit;
//# sourceMappingURL=useCartInit.js.map

/***/ }),

/***/ 3061:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartItem = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const helpers_1 = __webpack_require__(5542);
const useCartItem = ({ id } = { id: null }) => {
    const isMounted = (0, helpers_1.useMounted)();
    const cartItem = (0, store_1.useRecoilValue)(store_1.default.cartItem$({ id }));
    return isMounted && id ? cartItem : null;
};
exports.useCartItem = useCartItem;
//# sourceMappingURL=useCartItem.js.map

/***/ }),

/***/ 3660:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartItems = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const helpers_1 = __webpack_require__(5542);
const useCartItems = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const cartItems = (0, store_1.useRecoilValue)(store_1.default.cartItems$());
    return isMounted ? cartItems : [];
};
exports.useCartItems = useCartItems;
//# sourceMappingURL=useCartItems.js.map

/***/ }),

/***/ 4502:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartRemoveAttributes = void 0;
const tslib_1 = __webpack_require__(5556);
const react_1 = __webpack_require__(7378);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useCartStartFinishErrors_1 = __webpack_require__(4420);
const useCartUpdateAttributes_1 = __webpack_require__(364);
const useCartRemoveAttributes = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({ ...options, id: 'cart/removeAttribute' });
    // action
    const existingCustomAttributes = (0, store_1.useRecoilValue)(store_1.default.cartAttributes$);
    const { cartUpdateAttributes } = (0, useCartUpdateAttributes_1.useCartUpdateAttributes)();
    const cartRemoveAttributes = (0, react_1.useCallback)(async (data, callback) => {
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data:
                    validationErrors = [
                        `parameter is required; must be an object with "attributeKeys", e.g. "{ attributeKeys: ['abc'] }"`,
                    ];
                    break;
                case typeof data !== 'object':
                    validationErrors = [
                        `parameter must be an object with "attributeKeys", e.g. "{ attributeKeys: ['abc'] }"`,
                    ];
                    break;
                case !Array.isArray(data?.attributeKeys):
                    validationErrors = [
                        `"attributeKeys" must be an array of strings, e.g. "{ attributeKeys: ['abc'] }"`,
                    ];
                    break;
                case !data?.attributeKeys?.length:
                    validationErrors = [
                        `"attributeKeys" must have at least one key, e.g. "{ attributeKeys: ['abc'] }"`,
                    ];
                    break;
                case data?.attributeKeys?.some((key) => typeof key !== 'string'):
                    validationErrors = [
                        `Every key in "attributeKeys" must be a string, e.g. "{ attributeKeys: ['abc'] }"`,
                    ];
                    break;
                default:
                    break;
            }
            if (validationErrors?.length) {
                throw new Error(validationErrors[0]);
            }
            // filter out attributes to remove
            const updatedAttributes = existingCustomAttributes.filter((attribute) => {
                try {
                    const markedForRemoval = data.attributeKeys.includes(attribute.key);
                    return !markedForRemoval;
                }
                catch (error) {
                    return true;
                }
            });
            const cartAttributes = await cartUpdateAttributes({
                attributes: updatedAttributes,
            });
            if (cartAttributes?.type?.name !== 'Attribute') {
                throw new Error('Invalid cart delete attributes response');
            }
            setFinished(true);
            // cartUpdateAttributes will updated the cart via setCart(cart)
            if (callback)
                callback(cartAttributes);
            return cartAttributes;
        }
        catch (error) {
            console.error('cartRemoveAttributes:error', error.message);
            setErrors([error.message]);
            return null;
        }
    });
    return {
        cartRemoveAttributes,
        setStarted,
        setErrors,
        setFinished,
        ...status,
    };
};
exports.useCartRemoveAttributes = useCartRemoveAttributes;
//# sourceMappingURL=useCartRemoveAttributes.js.map

/***/ }),

/***/ 9249:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartRemoveDiscount = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useCartStartFinishErrors_1 = __webpack_require__(4420);
const useCartRemoveDiscount = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({ ...options, id: 'cart/removeDiscount' });
    const setCart = (0, store_1.useSetRecoilState)(store_1.default.cart);
    const cartRemoveDiscount = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            const { error, updatedCart } = await snapshot.getPromise(store_1.default.cartRemoveDiscount());
            if (error) {
                throw new Error(error);
            }
            if (!updatedCart || !updatedCart?.id) {
                throw new Error('Invalid discount remove response');
            }
            setFinished(true);
            // not triggering an update of side effects for some reason
            setCart(updatedCart);
            if (callback)
                callback(updatedCart);
            return updatedCart;
        }
        catch (error) {
            console.error('cartRemoveDiscount:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    return {
        cartRemoveDiscount,
        setStarted,
        setErrors,
        setFinished,
        ...status,
    };
};
exports.useCartRemoveDiscount = useCartRemoveDiscount;
//# sourceMappingURL=useCartRemoveDiscount.js.map

/***/ }),

/***/ 9997:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartRemoveGiftCard = void 0;
const react_1 = __webpack_require__(7378);
const useCartRemoveGiftCard = () => {
    (0, react_1.useEffect)(() => {
        console.warn('Cart giftcards are not yet supported on Cart API (v2)');
    }, []);
    return {
        cartRemoveGiftCard: null,
    };
};
exports.useCartRemoveGiftCard = useCartRemoveGiftCard;
//# sourceMappingURL=useCartRemoveGiftCard.js.map

/***/ }),

/***/ 7759:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartRemoveItem = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useCartStartFinishErrors_1 = __webpack_require__(4420);
const useCartRemoveItem = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({ ...options, id: 'cart/removeItem' });
    // action
    const setCart = (0, store_1.useSetRecoilState)(store_1.default.cart);
    // fetch an existing cart using a checkoutId
    const cartRemoveItem = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data:
                    validationErrors = [
                        `parameter is required; must be an object with "lineId", e.g. "{ lineId: 'abc123' }"`,
                    ];
                    break;
                case typeof data !== 'object':
                    validationErrors = [
                        `parameter must be an object with "lineId", e.g. "{ lineId: 'abc123' }"`,
                    ];
                    break;
                case !data?.lineId:
                    validationErrors = [
                        `"lineId" is required in parameter object, e.g. "{ lineId: 'abc123' }"`,
                    ];
                    break;
                default:
                    break;
            }
            if (validationErrors?.length) {
                throw new Error(validationErrors[0]);
            }
            const { error, updatedCart } = await snapshot.getPromise(store_1.default.cartRemoveItem(data));
            if (error) {
                throw new Error(error);
            }
            if (!updatedCart || updatedCart?.__typename !== 'Cart') {
                throw new Error(`Invalid cart remove item response for lineId ${data?.lineId}`);
            }
            setFinished(true);
            setCart(updatedCart);
            if (callback)
                callback(updatedCart);
            return updatedCart;
        }
        catch (error) {
            console.error('cartRemoveItem:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    return {
        cartRemoveItem,
        setStarted,
        setErrors,
        setFinished,
        ...status,
    };
};
exports.useCartRemoveItem = useCartRemoveItem;
//# sourceMappingURL=useCartRemoveItem.js.map

/***/ }),

/***/ 684:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartRemoveItems = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useCartStartFinishErrors_1 = __webpack_require__(4420);
const useCartRemoveItems = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({ ...options, id: 'cart/removeItems' });
    // action
    const setCart = (0, store_1.useSetRecoilState)(store_1.default.cart);
    // fetch an existing cart using a checkoutId
    const cartRemoveItems = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data:
                    validationErrors = [
                        `parameter is required; must be an object with "lineIds", e.g. "{ lineIds: ['abc123'] }"`,
                    ];
                    break;
                case typeof data !== 'object':
                    validationErrors = [
                        `parameter must be an object with "lineIds", e.g. "{ lineIds: ['abc123'] }"`,
                    ];
                    break;
                case !data?.lineIds:
                    validationErrors = [
                        `"lineIds" is required in parameter object, e.g. "{ lineIds: ['abc123'] }"`,
                    ];
                    break;
                case !Array.isArray(data?.lineIds):
                    validationErrors = [
                        `"lineIds" must be an array of strings, e.g. "{ lineIds: ['abc123'] }"`,
                    ];
                    break;
                case !data?.lineIds?.length:
                    validationErrors = [
                        `"lineIds" must have at least one line id to remove, e.g. "{ lineIds: ['abc123'] }"`,
                    ];
                    break;
                case data?.lineIds?.some((lineId) => typeof lineId !== 'string'):
                    validationErrors = [
                        `Every line id in "lineIds" must be a string, e.g. "{ lineIds: ['abc123'] }"`,
                    ];
                    break;
                default:
                    break;
            }
            if (validationErrors?.length) {
                throw new Error(validationErrors[0]);
            }
            const { error, updatedCart } = await snapshot.getPromise(store_1.default.cartRemoveItems(data));
            if (error) {
                throw new Error(error);
            }
            if (!updatedCart || updatedCart?.__typename !== 'Cart') {
                throw new Error(`Invalid cart remove items response for lineIds ${data?.lineIds}`);
            }
            setFinished(true);
            setCart(updatedCart);
            if (callback)
                callback(updatedCart);
            return updatedCart;
        }
        catch (error) {
            console.error('cartRemoveItems:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    return {
        cartRemoveItems,
        setStarted,
        setErrors,
        setFinished,
        ...status,
    };
};
exports.useCartRemoveItems = useCartRemoveItems;
//# sourceMappingURL=useCartRemoveItems.js.map

/***/ }),

/***/ 4420:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartStartFinishErrors = void 0;
const tslib_1 = __webpack_require__(5556);
const react_1 = __webpack_require__(7378);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const DEBUG = false;
const useCartStartFinishErrors = (options) => {
    const setCartStarted = (0, store_1.useSetRecoilState)(store_1.default.cartStatusStarted('cart/all'));
    const setCartFinished = (0, store_1.useSetRecoilState)(store_1.default.cartStatusFinished('cart/all'));
    const setCartSuccess = (0, store_1.useSetRecoilState)(store_1.default.cartStatusSuccess('cart/all'));
    const setCartErrors = (0, store_1.useSetRecoilState)(store_1.default.cartStatusErrors('cart/all'));
    const isCartId = /^cart/.test(options?.id);
    const [started, setStarted] = (0, store_1.useRecoilState)(store_1.default.cartStatusStarted(options?.id || ''));
    const [finished, setFinished] = (0, store_1.useRecoilState)(store_1.default.cartStatusFinished(options?.id || ''));
    const [success, setSuccess] = (0, store_1.useRecoilState)(store_1.default.cartStatusSuccess(options?.id || ''));
    const [errors, setErrors] = (0, store_1.useRecoilState)(store_1.default.cartStatusErrors(options?.id || ''));
    const autoReset = (0, react_1.useRef)(options?.autoReset || 0);
    const resetTimer = (0, react_1.useRef)(options?.resetTimer || null);
    // update local hook status
    const reset = (0, react_1.useCallback)(() => {
        if (typeof setErrors === 'undefined')
            return;
        setErrors([]);
        setStarted(false);
        setFinished(false);
        setSuccess(false);
        resetTimer.current = null;
    }, []);
    const updateStateOnErrors = () => {
        let unMounting = false;
        if (errors?.length > 0) {
            if (unMounting)
                return;
            setFinished(true);
            setSuccess(false);
        }
        // eslint-disable-next-line consistent-return
        return () => {
            unMounting = true;
        };
    };
    const updateStateOnFinished = () => {
        let unMounting = false;
        if (finished) {
            if (DEBUG) {
                console.groupCollapsed('status:', options?.id);
                console.log('started', started);
                console.log('errors', errors);
                console.log('finished', finished);
                console.log('success', success);
                console.groupEnd();
            }
            if (unMounting)
                return;
            const withoutErrors = errors?.length === 0;
            setStarted(false);
            setSuccess(withoutErrors);
            if (autoReset?.current) {
                const to = setTimeout(() => {
                    if (unMounting)
                        return;
                    reset();
                    clearTimeout(to);
                }, autoReset.current);
            }
        }
        // eslint-disable-next-line consistent-return
        return () => {
            unMounting = true;
        };
    };
    (0, react_1.useEffect)(() => {
        updateStateOnErrors();
    }, [errors?.length]);
    (0, react_1.useEffect)(() => {
        updateStateOnFinished();
    }, [finished, options?.id]);
    // update global cart status
    (0, react_1.useEffect)(() => {
        if (isCartId) {
            setCartErrors(errors);
        }
    }, [errors?.length]);
    (0, react_1.useEffect)(() => {
        if (isCartId) {
            setCartStarted(started);
        }
    }, [started]);
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        setCartFinished(finished);
        const to = setTimeout(() => {
            if (unMounting)
                return;
            setCartFinished(false);
            clearTimeout(to);
        }, 1000);
        return () => {
            unMounting = true;
        };
    }, [finished]);
    (0, react_1.useEffect)(() => {
        if (isCartId) {
            setCartSuccess(success);
        }
    }, [success]);
    return {
        started,
        setStarted,
        finished,
        setFinished,
        success,
        setSuccess,
        errors,
        setErrors,
        reset,
        resetTimer,
    };
};
exports.useCartStartFinishErrors = useCartStartFinishErrors;
//# sourceMappingURL=useCartStartFinishErrors.js.map

/***/ }),

/***/ 1887:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartStatus = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
// global status of the cart, any cart action will trigger
// these states via useRecoilStartFinishErrors.js
const useCartStatus = () => {
    return {
        started: (0, store_1.useRecoilValue)(store_1.default.cartStatusStarted('cart/all')),
        finished: (0, store_1.useRecoilValue)(store_1.default.cartStatusFinished('cart/all')),
        success: (0, store_1.useRecoilValue)(store_1.default.cartStatusSuccess('cart/all')),
        errors: (0, store_1.useRecoilValue)(store_1.default.cartStatusErrors('cart/all')),
    };
};
exports.useCartStatus = useCartStatus;
//# sourceMappingURL=useCartStatus.js.map

/***/ }),

/***/ 295:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartTotalPrice = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const helpers_1 = __webpack_require__(5542);
const useCartTotalPrice = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const cartTotalPrice = (0, store_1.useRecoilValue)(store_1.default.cartTotal$);
    return isMounted ? cartTotalPrice : null;
};
exports.useCartTotalPrice = useCartTotalPrice;
//# sourceMappingURL=useCartTotalPrice.js.map

/***/ }),

/***/ 7892:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartTotals = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const helpers_1 = __webpack_require__(5542);
// not localized
const useCartTotals = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const _cart = (0, store_1.useRecoilValue)(store_1.default.cart);
    const cartTotal = (0, store_1.useRecoilValue)(store_1.default.cartTotal$);
    const cartSubtotal = (0, store_1.useRecoilValue)(store_1.default.cartSubtotal$);
    const cartTax = (0, store_1.useRecoilValue)(store_1.default.cartTax$);
    const cartDuty = (0, store_1.useRecoilValue)(store_1.default.cartDuty$);
    const cartDiscountTotal = (0, store_1.useRecoilValue)(store_1.default.cartDiscountTotal$);
    return _cart && isMounted
        ? {
            total: cartTotal,
            subtotal: cartSubtotal,
            duty: cartDuty,
            tax: cartTax,
            discount: cartDiscountTotal,
        }
        : {
            total: 0,
            subtotal: 0,
            duty: 0,
            tax: 0,
            discount: 0,
        };
};
exports.useCartTotals = useCartTotals;
//# sourceMappingURL=useCartTotals.js.map

/***/ }),

/***/ 364:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartUpdateAttributes = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useCartStartFinishErrors_1 = __webpack_require__(4420);
const useCartUpdateAttributes = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({ ...options, id: 'cart/updateAttributes' });
    const setCart = (0, store_1.useSetRecoilState)(store_1.default.cart);
    const cartUpdateAttributes = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data: {
                    validationErrors = [
                        `parameter is required; must be an object with "attributes", e.g. "{ attributes: [{ key: 'abc123', value: '123' }] }"`,
                    ];
                    break;
                }
                case typeof data !== 'object': {
                    validationErrors = [
                        `parameter must be an object with "attributes", e.g. "{ attributes: [{ key: 'abc123', value: '123' }] }"`,
                    ];
                    break;
                }
                case !data?.attributes: {
                    validationErrors = [
                        `"attributes" is required in parameter object, e.g. "{ attributes: [{ key: 'abc123', value: '123' }] }"`,
                    ];
                    break;
                }
                case !Array.isArray(data?.attributes): {
                    validationErrors = [
                        `"attributes" must be an array, e.g. "{ attributes: [{ key: 'abc123', value: '123' }] }"`,
                    ];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                throw new Error(validationErrors[0]);
            }
            const { error, updatedCart } = await snapshot.getPromise(store_1.default.cartUpdateAttributes(data));
            if (error) {
                throw new Error(error);
            }
            if (!updatedCart || updatedCart?.__typename !== 'Cart') {
                throw new Error(`Invalid cart attributes update response for ${data?.attributes}`);
            }
            setFinished(true);
            setCart(updatedCart);
            if (callback)
                callback(updatedCart);
            return updatedCart;
        }
        catch (error) {
            console.error('cartUpdateAttributes:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    return {
        cartUpdateAttributes,
        setStarted,
        setErrors,
        setFinished,
        ...status,
    };
};
exports.useCartUpdateAttributes = useCartUpdateAttributes;
//# sourceMappingURL=useCartUpdateAttributes.js.map

/***/ }),

/***/ 4717:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartUpdateBuyerIdentity = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useCartStartFinishErrors_1 = __webpack_require__(4420);
const useCartUpdateBuyerIdentity = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({ ...options, id: 'cart/updateBuyerIdentity' });
    const setCart = (0, store_1.useSetRecoilState)(store_1.default.cart);
    const cartUpdateBuyerIdentity = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data: {
                    validationErrors = [
                        'parameter is required; must be an object with "buyerIdentity", e.g. "{ buyerIdentity: { ... } }"',
                    ];
                    break;
                }
                case typeof data !== 'object': {
                    validationErrors = [
                        'parameter must be an object with "buyerIdentity", e.g. "{ buyerIdentity: { ... } }"',
                    ];
                    break;
                }
                case !data?.buyerIdentity: {
                    validationErrors = [
                        '"buyerIdentity" is required in parameter object, e.g. "{ buyerIdentity: { ... } }"',
                    ];
                    break;
                }
                case typeof data?.buyerIdentity !== 'object': {
                    validationErrors = [
                        '"buyerIdentity" must be an object, e.g. "{ buyerIdentity: { ... } }"',
                    ];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                throw new Error(validationErrors[0]);
            }
            const { error, updatedCart } = await snapshot.getPromise(store_1.default.cartUpdateBuyerIdentity(data));
            if (error) {
                throw new Error(error);
            }
            if (!updatedCart || updatedCart?.__typename !== 'Cart') {
                throw new Error(`Invalid cart buyerIdentity update response for ${data?.buyerIdentity}`);
            }
            setFinished(true);
            setCart(updatedCart);
            if (callback)
                callback(updatedCart);
            return updatedCart;
        }
        catch (error) {
            console.error('cartUpdateBuyerIdentity:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    return {
        cartUpdateBuyerIdentity,
        setStarted,
        setErrors,
        setFinished,
        ...status,
    };
};
exports.useCartUpdateBuyerIdentity = useCartUpdateBuyerIdentity;
//# sourceMappingURL=useCartUpdateBuyerIdentity.js.map

/***/ }),

/***/ 3781:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartUpdateItem = void 0;
const tslib_1 = __webpack_require__(5556);
const deepmerge_1 = tslib_1.__importDefault(__webpack_require__(406));
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useCartStartFinishErrors_1 = __webpack_require__(4420);
const useCartUpdateItem = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({ ...options, id: 'cart/updateItem' });
    // action
    const setCart = (0, store_1.useSetRecoilState)(store_1.default.cart);
    // fetch an existing cart using a checkoutId
    const cartUpdateItem = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data:
                    validationErrors = [
                        `parameter is required; must be an object with "lineId", e.g. "{ lineId: 'abc123', quantity: 1 (optional), attributes: [{ key: 'abc', value: '123' }] (optional), sellingPlanId: 'abc123' (optional) }"`,
                    ];
                    break;
                case typeof data !== 'object':
                    validationErrors = [
                        `parameter must be an object with "lineId", e.g. "{ lineId: 'abc123', quantity: 1 (optional), attributes: [{ key: 'abc', value: '123' }] (optional), sellingPlanId: 'abc123' (optional) }"`,
                    ];
                    break;
                case !data?.lineId:
                    validationErrors = [
                        `"lineId" is required in parameter object, e.g. "{ lineId: 'abc123', quantity: 1 (optional), attributes: [{ key: 'abc', value: '123' }] (optional), sellingPlanId: 'abc123' (optional) }"`,
                    ];
                    break;
                // quantity, attributes, merchandiseId, sellingPlanId are optional
                default:
                    break;
            }
            if (validationErrors?.length) {
                throw new Error(validationErrors[0]);
            }
            const _cart = snapshot.getLoadable(store_1.default.cart).contents;
            // find the item to update and merge in the updated props
            const updatedItemData = _cart.lines
                .filter((_line) => _line.id === data.lineId)
                .map((line) => (0, deepmerge_1.default)(line, data))[0];
            const { error, updatedCart } = await snapshot.getPromise(store_1.default.cartUpdateItem(updatedItemData));
            if (error) {
                throw new Error(error);
            }
            if (!updatedCart || updatedCart?.__typename !== 'Cart') {
                throw new Error(`Invalid cart update item response for merchandiseId ${data?.id}`);
            }
            setFinished(true);
            setCart(updatedCart);
            const updatedItem = updatedCart.lines.find((item) => item.id === data?.lineId) || null;
            if (callback)
                callback(updatedItem);
            return updatedItem;
        }
        catch (error) {
            console.error('cartUpdateItem:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    return {
        cartUpdateItem,
        setStarted,
        setErrors,
        setFinished,
        ...status,
    };
};
exports.useCartUpdateItem = useCartUpdateItem;
//# sourceMappingURL=useCartUpdateItem.js.map

/***/ }),

/***/ 6442:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartUpdateItems = void 0;
const tslib_1 = __webpack_require__(5556);
const deepmerge_1 = tslib_1.__importDefault(__webpack_require__(406));
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useCartStartFinishErrors_1 = __webpack_require__(4420);
const useCartUpdateItems = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({ ...options, id: 'cart/updateItems' });
    // action
    const setCart = (0, store_1.useSetRecoilState)(store_1.default.cart);
    // fetch an existing cart using a checkoutId
    const cartUpdateItems = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data:
                    validationErrors = [
                        `parameter is required; must be an array of objects with "lineId", e.g. "[{ lineId: 'abc123', quantity: 1 (optional), attributes: [{ key: 'abc', value: '123' }] (optional), sellingPlanId: 'abc123' (optional) }]"`,
                    ];
                    break;
                case !Array.isArray(data):
                    validationErrors = [
                        `parameter must be an array of objects with "lineId", e.g. "[{ lineId: 'abc123', quantity: 1 (optional), attributes: [{ key: 'abc', value: '123' }] (optional), sellingPlanId: 'abc123' (optional) }]"`,
                    ];
                    break;
                case !data?.length:
                    validationErrors = [
                        `parameter array must have at least one item to update, e.g. "[{ lineId: 'abc123', quantity: 1 (optional), attributes: [{ key: 'abc', value: '123' }] (optional), sellingPlanId: 'abc123' (optional) }]"`,
                    ];
                    break;
                case data?.some((item) => !item?.lineId):
                    validationErrors = [
                        `"lineId" is required in every object in parameter array, e.g. "[{ lineId: 'abc123', quantity: 1 (optional), attributes: [{ key: 'abc', value: '123' }] (optional), sellingPlanId: 'abc123' (optional) }]"`,
                    ];
                    break;
                // there's other check we could do like checking quantity is an integer,
                // attributes and array and sellingPlanId a string
                default:
                    break;
            }
            if (validationErrors?.length) {
                throw new Error(validationErrors[0]);
            }
            const _cart = snapshot.getLoadable(store_1.default.cart).contents;
            const lines = _cart.lines.map((_line) => {
                const updatingLine = data.find((_updatingLine) => _updatingLine.lineId === _line.id);
                if (!updatingLine) {
                    return _line;
                }
                return (0, deepmerge_1.default)(_line, updatingLine);
            });
            const { error, updatedCart } = await snapshot.getPromise(store_1.default.cartUpdateItems({ lines }));
            if (error) {
                throw new Error(error);
            }
            if (!updatedCart || updatedCart?.__typename !== 'Cart') {
                throw new Error(`Invalid cart lines update response`);
            }
            setFinished(true);
            setCart(updatedCart);
            const updatingItemIds = data.map((line) => line.lineId);
            const updatedItems = updatedCart.lines.filter((item) => updatingItemIds.includes(item.id)) || [null];
            if (callback)
                callback(updatedItems);
            return updatedItems;
        }
        catch (error) {
            console.error('cartUpdateItems:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    return {
        cartUpdateItems,
        setStarted,
        setErrors,
        setFinished,
        ...status,
    };
};
exports.useCartUpdateItems = useCartUpdateItems;
//# sourceMappingURL=useCartUpdateItems.js.map

/***/ }),

/***/ 5201:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartUpdateNote = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useCartStartFinishErrors_1 = __webpack_require__(4420);
const useCartUpdateNote = (options) => {
    const { setStarted, setFinished, setErrors, ...status } = (0, useCartStartFinishErrors_1.useCartStartFinishErrors)({ ...options, id: 'cart/updateNote' });
    const setCart = (0, store_1.useSetRecoilState)(store_1.default.cart);
    const cartUpdateNote = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data:
                    validationErrors = [
                        `parameter is required; must be an object with "note", e.g. "{ note: 'hello' }"`,
                    ];
                    break;
                case typeof data !== 'object':
                    validationErrors = [
                        `parameter must be an object with "note", e.g. "{ note: 'hello' }"`,
                    ];
                    break;
                case !data?.note: {
                    validationErrors = [
                        `"note" is required in parameter object, e.g. "{ note: 'hello' }"`,
                    ];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                throw new Error(validationErrors[0]);
            }
            const { error, updatedCart } = await snapshot.getPromise(store_1.default.cartUpdateNote(data));
            if (error) {
                throw new Error(error);
            }
            if (!updatedCart || updatedCart?.__typename !== 'Cart') {
                throw new Error(`Invalid cart note update response for note ${data?.note}`);
            }
            setFinished(true);
            setCart(updatedCart);
            if (callback)
                callback(updatedCart.note);
            return updatedCart.note;
        }
        catch (error) {
            console.error('cartUpdateNote:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    return {
        cartUpdateNote,
        setStarted,
        setErrors,
        setFinished,
        ...status,
    };
};
exports.useCartUpdateNote = useCartUpdateNote;
//# sourceMappingURL=useCartUpdateNote.js.map

/***/ }),

/***/ 3437:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCartUpdatedAt = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const helpers_1 = __webpack_require__(5542);
const useCartUpdatedAt = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const cartUpdatedAt = (0, store_1.useRecoilValue)(store_1.default.cart)?.updatedAt;
    return isMounted ? cartUpdatedAt : null;
};
exports.useCartUpdatedAt = useCartUpdatedAt;
//# sourceMappingURL=useCartUpdatedAt.js.map

/***/ }),

/***/ 4021:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.cartStore = void 0;
const tslib_1 = __webpack_require__(5556);
/* eslint-disable max-lines */
const recoil_1 = __webpack_require__(9853);
const atob_1 = tslib_1.__importDefault(__webpack_require__(8981));
const effects_1 = tslib_1.__importDefault(__webpack_require__(9025));
const store_1 = __webpack_require__(437);
const client_1 = __webpack_require__(4812);
const client_2 = __webpack_require__(5431);
const cartClient = new client_1.CartClient({
    apiToken: "3bc6486eea19d75d4dd39479084d4c7a",
    apiVersion: '2025-04',
    domain: "shop.clearlyfiltered.com" || 0,
});
const productClient = new client_2.ProductClient({
    apiToken: "3bc6486eea19d75d4dd39479084d4c7a",
    apiVersion: '2025-04',
    domain: "clearly-filtered.myshopify.com",
});
/**
  CART STATE
*/
const cartInit = (0, recoil_1.atom)({
    key: 'cart/cartInit',
    default: null,
    effects: [
        // effects.logStateChange('cartInit'),
        effects_1.default.onChange({
            key: 'cartInit',
            topic: 'CART_INIT',
            actions: ['publishGtmEvent', 'publishBusEvent'],
        }),
    ],
});
const cart = (0, recoil_1.atom)({
    key: 'cart/cart',
    default: null,
    effects: [
        // effects.logStateChange('cart'),
        effects_1.default.setSelfToPersistedKey('cart', `Cart|${effects_1.default.SHOPIFY_NAME}`, 'CART_EXISTING'),
        effects_1.default.onSetUpdatePersistedKey(`Cart|${effects_1.default.SHOPIFY_NAME}`),
        effects_1.default.onChange({
            key: 'cart',
            topic: 'CART_UPDATE',
            actions: ['publishGtmEvent', 'publishBusEvent'],
        }),
    ],
});
const cartLinePriceIn = (0, recoil_1.atomFamily)({
    key: 'cart/linePriceIn',
    default: null,
});
/* Status */
const cartStatusStarted = (0, recoil_1.atomFamily)({
    key: 'cart/statusStarted',
    default: false,
});
const cartStatusFinished = (0, recoil_1.atomFamily)({
    key: 'cart/statusFinished',
    default: false,
});
const cartStatusSuccess = (0, recoil_1.atomFamily)({
    key: 'cart/statusSuccess',
    default: false,
});
const cartStatusErrors = (0, recoil_1.atomFamily)({
    key: 'cart/statusErrors',
    default: [],
});
const cartCheckout = (0, recoil_1.atom)({
    key: 'cart/checkout',
    default: {
        url: null,
        redirect: true,
        multiPass: undefined,
    },
    effects: [
        effects_1.default.onChange({
            key: 'cartCheckout',
            topic: 'CHECKOUT',
            actions: ['publishGtmEvent', 'publishBusEvent'],
        }),
        effects_1.default.onSetRedirectToCheckout(), // last so we have a chance to fire events
    ],
});
/*
  ---------------
  Getters
  ---------------
*/
const cartId$ = (0, recoil_1.selector)({
    key: 'cart/cartId$',
    get: ({ get }) => {
        const _cart = get(cart);
        if (!_cart)
            return null;
        return _cart.id;
    },
});
const cartCount$ = (0, recoil_1.selector)({
    key: 'cart/cartCount$',
    get: ({ get }) => {
        const _cart = get(cart);
        if (!_cart)
            return 0;
        const { lines = [] } = _cart;
        const accLineTotals = (items, { quantity }) => items + quantity;
        const totalItems = lines?.reduce(accLineTotals, 0);
        return totalItems || 0;
    },
});
const cartLocale$ = (0, recoil_1.selector)({
    key: 'cart/locale$',
    get: ({ get }) => {
        const _cart = get(cart);
        if (!_cart?.locale)
            return null;
        return _cart.locale;
    },
});
const cartEmpty$ = (0, recoil_1.selector)({
    key: 'cart/cartEmpty$',
    get: ({ get }) => {
        const _cartCount = get(cartCount$);
        return _cartCount === 0;
    },
});
// not yet supported on CartAPI
const cartGiftCards$ = (0, recoil_1.selector)({
    key: 'cart/cartGiftCards$',
    get: () => {
        return [];
    },
});
const cartDiscounts$ = (0, recoil_1.selector)({
    key: 'cart/cartDiscounts$',
    get: ({ get }) => {
        const _cart = get(cart);
        return _cart?.discountCodes || [];
    },
});
const cartAttributes$ = (0, recoil_1.selector)({
    key: 'cartAttributes$',
    get: ({ get }) => {
        const _cart = get(cart);
        return _cart
            ? _cart.attributes.map(({ key, value }) => ({ key, value }))
            : [];
    },
});
const cartTotal$ = (0, recoil_1.selector)({
    key: 'cart/total$',
    get: ({ get }) => {
        const _cart = get(cart);
        if (!_cart?.estimatedCost?.totalAmount?.amount)
            return 0;
        return _cart.estimatedCost.totalAmount.amount;
    },
});
const cartSubtotal$ = (0, recoil_1.selector)({
    key: 'cart/subtotal$',
    get: ({ get }) => {
        const _cart = get(cart);
        if (!_cart?.estimatedCost?.subtotalAmount?.amount)
            return 0;
        return _cart.estimatedCost.subtotalAmount.amount;
    },
});
const cartTax$ = (0, recoil_1.selector)({
    key: 'cart/tax$',
    get: ({ get }) => {
        const _cart = get(cart);
        if (!_cart?.estimatedCost?.totalTaxAmount?.amount)
            return 0;
        return _cart.estimatedCost.totalTaxAmount.amount;
    },
});
const cartDuty$ = (0, recoil_1.selector)({
    key: 'cart/duty$',
    get: ({ get }) => {
        const _cart = get(cart);
        if (!_cart?.estimatedCost?.totalDutyAmount?.amount)
            return 0;
        return _cart.estimatedCost.totalDutyAmount.amount;
    },
});
const cartDiscountTotal$ = (0, recoil_1.selector)({
    key: 'cart/discountTotal$',
    get: ({ get }) => {
        const _cart = get(cart);
        if (!_cart?.estimatedCost?.totalDiscountAmount?.amount)
            return 0;
        return _cart.estimatedCost.totalDiscountAmount.amount;
    },
});
const cartCheckoutUrl$ = (0, recoil_1.selector)({
    key: 'cart/CheckoutUrl$',
    get: ({ get }) => {
        const _cart = get(cart);
        if (!_cart)
            return null;
        return _cart.checkoutUrl;
    },
});
const cartItems$ = (0, recoil_1.selectorFamily)({
    key: 'cart/cartItems$',
    get: () => ({ get }) => {
        const _cart = get(cart);
        if (!_cart?.lines?.length)
            return [];
        return [..._cart.lines].reverse();
    },
});
const cartItem$ = (0, recoil_1.selectorFamily)({
    key: 'cart/cartItem$',
    get: ({ id: desiredItemId }) => function getCallback({ get }) {
        const _cartItems = get(cartItems$);
        // this helps us build  /products/handle?variant=legacyId from cart items
        const convertItemVariantIdsToLegacy = ({ merchandise, ...item }) => ({
            ...item,
            merchandise: {
                ...merchandise,
                id: (0, atob_1.default)(merchandise.id).split('/').pop(),
            },
        });
        return _cartItems.length
            ? _cartItems
                .filter(({ id }) => id === desiredItemId)
                .map(convertItemVariantIdsToLegacy)[0]
            : null;
    },
});
const cartBuyer$ = (0, recoil_1.selector)({
    key: 'cart/cartBuyer$',
    get: ({ get }) => {
        const _cart = get(cart);
        return _cart.buyerIdentity;
    },
});
const cartEmail$ = (0, recoil_1.selector)({
    key: 'cart/cartEmail$',
    get: ({ get }) => {
        const _cart = get(cart);
        return _cart?.buyerIdentity?.email ? _cart.buyerIdentity.email : null;
    },
});
/**
 * New async fetchers and setters
 */
const cartCreate = (0, recoil_1.selectorFamily)({
    key: 'cart/create',
    get: ({ country, cartInput }) => async () => {
        return cartClient.create({ country, cartInput });
    },
});
const cartGet = (0, recoil_1.selectorFamily)({
    key: 'cart/get',
    get: ({ id }) => async ({ get }) => {
        const _country = get(store_1.shopStore.country);
        const country = _country;
        return cartClient.get({ id, country: country.isoCode });
    },
});
const cartAddItem = (0, recoil_1.selectorFamily)({
    key: 'cart/addItem',
    get: (data) => async ({ get }) => {
        const _cart = get(cart);
        const _cartId = _cart?.id || null;
        const country = get(store_1.shopStore.country);
        return cartClient.addItem({
            cartId: _cartId,
            country: country?.isoCode,
            ...data,
        });
    },
});
const cartAddItems = (0, recoil_1.selectorFamily)({
    key: 'cart/addItems',
    get: ({ lines = [] }) => async ({ get }) => {
        const _cart = get(cart);
        const _cartId = _cart?.id || null;
        const country = get(store_1.shopStore.country);
        return cartClient.addItem({
            cartId: _cartId,
            country: country?.isoCode,
            lines,
        });
    },
});
const cartRemoveItem = (0, recoil_1.selectorFamily)({
    key: 'cart/removeItem',
    get: ({ lineId }) => async ({ get }) => {
        const _cart = get(cart);
        const _cartId = _cart?.id || null;
        const country = get(store_1.shopStore.country);
        return cartClient.removeItem({
            cartId: _cartId,
            country: country?.isoCode,
            lineId,
        });
    },
});
const cartRemoveItems = (0, recoil_1.selectorFamily)({
    key: 'cart/removeItems',
    get: ({ lineIds = [] }) => async ({ get }) => {
        const _cart = get(cart);
        const _cartId = _cart?.id || null;
        const country = get(store_1.shopStore.country);
        return cartClient.removeItems({
            cartId: _cartId,
            country: country?.isoCode,
            lineIds,
        });
    },
});
const cartUpdateItem = (0, recoil_1.selectorFamily)({
    key: 'cart/updateItem',
    get: (data) => async ({ get }) => {
        const _cart = get(cart);
        const _cartId = _cart?.id || null;
        const country = get(store_1.shopStore.country);
        return cartClient.updateItem({
            cartId: _cartId,
            country: country?.isoCode,
            ...data,
        });
    },
});
const cartUpdateItems = (0, recoil_1.selectorFamily)({
    key: 'cart/updateItems',
    get: (data) => async ({ get }) => {
        const _cart = get(cart);
        const _cartId = _cart?.id || null;
        const country = get(store_1.shopStore.country);
        return cartClient.updateItems({
            cartId: _cartId,
            country: country?.isoCode,
            ...data,
        });
    },
});
const cartUpdateNote = (0, recoil_1.selectorFamily)({
    key: 'cart/updateNote',
    get: (data) => async ({ get }) => {
        const _cart = get(cart);
        const _cartId = _cart?.id || null;
        const country = get(store_1.shopStore.country);
        return cartClient.updateNote({
            cartId: _cartId,
            country: country?.isoCode,
            ...data,
        });
    },
});
const cartUpdateDiscount = (0, recoil_1.selectorFamily)({
    key: 'cart/updateDiscount',
    get: (data) => async ({ get }) => {
        const _cart = get(cart);
        const _cartId = _cart?.id || null;
        const country = get(store_1.shopStore.country);
        return cartClient.updateDiscount({
            cartId: _cartId,
            country: country?.isoCode,
            ...data,
        });
    },
});
const cartRemoveDiscount = (0, recoil_1.selectorFamily)({
    key: 'cart/removeDiscount',
    get: () => async ({ get }) => {
        const _cart = get(cart);
        const _cartId = _cart?.id || null;
        const country = get(store_1.shopStore.country);
        return cartClient.removeDiscount({
            cartId: _cartId,
            country: country?.isoCode,
            discountCodes: [],
        });
    },
});
const cartUpdateAttributes = (0, recoil_1.selectorFamily)({
    key: 'cart/updateAttributes',
    get: (data) => async ({ get }) => {
        const _cart = get(cart);
        const _cartId = _cart?.id || null;
        const country = get(store_1.shopStore.country);
        return cartClient.updateAttributes({
            cartId: _cartId,
            country: country?.isoCode,
            ...data,
        });
    },
});
const cartUpdateBuyerIdentity = (0, recoil_1.selectorFamily)({
    key: 'cart/updateBuyerIdentity',
    get: (data) => async ({ get }) => {
        const _cart = get(cart);
        const _cartId = _cart?.id || null;
        const country = get(store_1.shopStore.country);
        return cartClient.updateBuyerIdentity({
            cartId: _cartId,
            country: data?.country || country?.isoCode,
            ...data,
        });
    },
});
const fetchCartLinePriceIn = (0, recoil_1.selectorFamily)({
    key: 'cart/fetchCartLinePriceIn',
    get: (data) => async ({ get }) => {
        const passedCountryCode = data?.country?.isoCode || data?.country;
        const country = get(store_1.shopStore.country);
        const _country = passedCountryCode || country.isoCode || 'US';
        return productClient.getLocalizedProduct({
            ...data,
            country: _country,
        });
    },
});
exports.cartStore = {
    // actual state - atoms
    cart,
    cartInit,
    cartCheckout,
    cartLinePriceIn,
    // status
    cartStatusStarted,
    cartStatusFinished,
    cartStatusSuccess,
    cartStatusErrors,
    // computed utils
    cartLocale$,
    cartBuyer$,
    cartId$,
    cartEmpty$,
    cartCount$,
    cartCheckoutUrl$,
    cartGiftCards$,
    cartAttributes$,
    cartDiscounts$,
    cartItems$,
    cartEmail$,
    cartItem$,
    // computed totals
    cartTotal$,
    cartSubtotal$,
    cartTax$,
    cartDuty$,
    cartDiscountTotal$,
    // Async queries and mutations
    cartCreate,
    cartGet,
    cartAddItem,
    cartAddItems,
    cartRemoveItem,
    cartRemoveItems,
    cartRemoveDiscount,
    cartUpdateItem,
    cartUpdateItems,
    cartUpdateNote,
    cartUpdateDiscount,
    cartUpdateAttributes,
    cartUpdateBuyerIdentity,
    fetchCartLinePriceIn,
};
//# sourceMappingURL=cart.js.map

/***/ }),

/***/ 9005:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.cartStore = void 0;
var cart_1 = __webpack_require__(4021);
Object.defineProperty(exports, "cartStore", ({ enumerable: true, get: function () { return cart_1.cartStore; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 10:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(5556);
tslib_1.__exportStar(__webpack_require__(2311), exports);
tslib_1.__exportStar(__webpack_require__(673), exports);
tslib_1.__exportStar(__webpack_require__(3301), exports);
tslib_1.__exportStar(__webpack_require__(1198), exports);
tslib_1.__exportStar(__webpack_require__(5583), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2311:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCollection = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useCollection = () => (0, store_1.useRecoilValue)(store_1.default.collection);
exports.useCollection = useCollection;
//# sourceMappingURL=useCollection.js.map

/***/ }),

/***/ 673:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCollectionByHandle = void 0;
const tslib_1 = __webpack_require__(5556);
const react_1 = __webpack_require__(7378);
const router_1 = __webpack_require__(6677);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const helpers_1 = __webpack_require__(5542);
const store_2 = __webpack_require__(7152);
const useCollectionByHandle = ({ handle = null, fetchOnMount = true, options, }) => {
    const { started, setStarted, finished, setFinished, success, setSuccess, errors, setErrors, reset, resetTimer, } = (0, helpers_1.useStartFinishErrors)(options);
    const { isPreview } = (0, router_1.useRouter)();
    const setCollections = (0, store_1.useSetRecoilState)(store_1.default.collections);
    const [collection, setCollection] = (0, store_1.useRecoilState)(store_1.default.collectionByHandle$(handle));
    // fetch json collection on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        if (!handle) {
            setErrors(['A collection "handle" must be provided']);
        }
        const earlyExitIf = [
            !fetchOnMount,
            !handle,
            finished && collection?.id, // already have a collection
        ];
        if (earlyExitIf.some(Boolean))
            return undefined;
        if (!unMounting)
            setStarted(true);
        store_2.collectionActions
            .fetchCollectionByHandle({ handle, version: 'full' })
            .then((jsonCollection) => {
            // bad response
            if ((!jsonCollection || !jsonCollection?.id) && !unMounting) {
                setErrors(['Invalid collection response']);
            }
            // fetch collection products
            fetch(`/json/collections/products/${jsonCollection.handle}.json`)
                .then((response) => response.json())
                .then((result) => {
                const loadedProducts = isPreview
                    ? result
                    : result.filter((product) => product.status === 'ACTIVE');
                const fullJsonCollection = {
                    ...jsonCollection,
                    products: [...jsonCollection.products, ...loadedProducts],
                };
                if (!unMounting)
                    setCollection(fullJsonCollection);
                if (!unMounting)
                    setFinished(true);
                // all good update collections, which in turns updates
                // the collectionByHandle familiy selector
                if (!unMounting) {
                    setCollections((collections) => ({
                        ...collections,
                        [jsonCollection.handle]: fullJsonCollection,
                    }));
                }
            });
        })
            .catch((error) => {
            if (!unMounting)
                setErrors([error.message]);
        });
        return () => {
            unMounting = true;
        };
    }, [handle, fetchOnMount]);
    return {
        collection: collection || null,
        fetchCollectionByHandle: store_2.collectionActions.fetchCollectionByHandle,
        started,
        finished,
        success,
        setSuccess,
        errors,
        setErrors,
        resetTimer,
        reset,
    };
};
exports.useCollectionByHandle = useCollectionByHandle;
//# sourceMappingURL=useCollectionByHandle.js.map

/***/ }),

/***/ 3301:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCollectionHandles = void 0;
const tslib_1 = __webpack_require__(5556);
const react_1 = __webpack_require__(7378);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const helpers_1 = __webpack_require__(5542);
const store_2 = __webpack_require__(7152);
const useCollectionHandles = ({ fetchOnMount, options } = { fetchOnMount: true, options: null }) => {
    const { started, setStarted, finished, setFinished, success, setSuccess, errors, setErrors, reset, resetTimer, } = (0, helpers_1.useStartFinishErrors)(options);
    const [collectionHandles, setCollectionHandles] = (0, store_1.useRecoilState)(store_1.default.collectionHandles);
    // fetch json collection on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !fetchOnMount,
            finished && collectionHandles?.length, // already have a collection
        ];
        if (earlyExitIf.some(Boolean))
            return undefined;
        if (!unMounting)
            setStarted(true);
        store_2.collectionActions
            .fetchCollectionHandles()
            .then((jsonCollectionHandles) => {
            // bad response
            if ((!jsonCollectionHandles || !jsonCollectionHandles?.length) &&
                !unMounting) {
                setErrors(['Invalid collection handles response']);
            }
            if (!unMounting)
                setFinished(true);
            // all good update collections, which in turns updates
            // the collectionByHandle familiy selector
            if (!unMounting)
                setCollectionHandles(jsonCollectionHandles);
        })
            .catch((error) => {
            if (!unMounting)
                setErrors([error.message]);
        });
        return () => {
            unMounting = true;
        };
    }, [fetchOnMount, collectionHandles]);
    return {
        collectionHandles,
        fetchCollectionHandles: store_2.collectionActions.fetchCollectionHandles,
        started,
        finished,
        success,
        setSuccess,
        errors,
        setErrors,
        resetTimer,
        reset,
    };
};
exports.useCollectionHandles = useCollectionHandles;
//# sourceMappingURL=useCollectionHandles.js.map

/***/ }),

/***/ 5583:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCollectionsIndex = void 0;
const tslib_1 = __webpack_require__(5556);
const react_1 = __webpack_require__(7378);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const helpers_1 = __webpack_require__(5542);
const store_2 = __webpack_require__(7152);
const useCollectionsIndex = ({ fetchOnMount, options } = { fetchOnMount: true, options: null }) => {
    const { started, setStarted, finished, setFinished, success, setSuccess, errors, setErrors, reset, resetTimer, } = (0, helpers_1.useStartFinishErrors)(options);
    const [collectionsIndex, setCollectionIndex] = (0, store_1.useRecoilState)(store_1.default.collectionsIndex);
    // fetch json collections on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !fetchOnMount,
            finished && collectionsIndex?.keys, // already have a collections
        ];
        if (earlyExitIf.some(Boolean))
            return undefined;
        if (!unMounting)
            setStarted(true);
        store_2.collectionActions
            .fetchCollectionsIndex()
            .then((jsonCollectionIndex) => {
            // bad response
            if ((!jsonCollectionIndex || !jsonCollectionIndex?.keys) &&
                !unMounting) {
                setErrors(['Invalid collections index response']);
            }
            if (!unMounting)
                setFinished(true);
            // all good update collectionss, which in turns updates
            // the collectionsByHandle familiy selector
            if (!unMounting)
                setCollectionIndex(jsonCollectionIndex);
        })
            .catch((error) => {
            console.log('error', error);
            if (!unMounting)
                setErrors([error.message]);
        });
        return () => {
            unMounting = true;
        };
    }, [fetchOnMount, collectionsIndex]);
    return {
        collectionsIndex,
        fetchCollectionsIndex: store_2.collectionActions.fetchCollectionsIndex,
        started,
        finished,
        success,
        setSuccess,
        errors,
        setErrors,
        resetTimer,
        reset,
    };
};
exports.useCollectionsIndex = useCollectionsIndex;
//# sourceMappingURL=useCollectionsIndex.js.map

/***/ }),

/***/ 1198:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCollectionsList = void 0;
const tslib_1 = __webpack_require__(5556);
const react_1 = __webpack_require__(7378);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const helpers_1 = __webpack_require__(5542);
const store_2 = __webpack_require__(7152);
const useCollectionsList = ({ fetchOnMount, options } = { fetchOnMount: true, options: null }) => {
    const { started, setStarted, finished, setFinished, success, setSuccess, errors, setErrors, reset, resetTimer, } = (0, helpers_1.useStartFinishErrors)(options);
    const [collectionsList, setCollectionList] = (0, store_1.useRecoilState)(store_1.default.collectionsList);
    // fetch json collections on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !fetchOnMount,
            finished && collectionsList?.length, // already have a collections
        ];
        if (earlyExitIf.some(Boolean))
            return undefined;
        if (!unMounting)
            setStarted(true);
        store_2.collectionActions
            .fetchCollectionsList()
            .then((jsonCollectionList) => {
            // bad response
            if ((!jsonCollectionList || !jsonCollectionList?.length) &&
                !unMounting) {
                setErrors(['Invalid collections list response']);
            }
            if (!unMounting)
                setFinished(true);
            // all good update collectionss, which in turns updates
            // the collectionsByHandle familiy selector
            if (!unMounting)
                setCollectionList(jsonCollectionList);
        })
            .catch((error) => {
            if (!unMounting)
                setErrors([error.message]);
        });
        return () => {
            unMounting = true;
        };
    }, [fetchOnMount, collectionsList]);
    return {
        collectionsList,
        fetchCollectionsList: store_2.collectionActions.fetchCollectionsList,
        started,
        finished,
        success,
        setSuccess,
        errors,
        setErrors,
        resetTimer,
        reset,
    };
};
exports.useCollectionsList = useCollectionsList;
//# sourceMappingURL=useCollectionsList.js.map

/***/ }),

/***/ 9939:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fetchCollectionHandles = exports.fetchCollectionsIndex = exports.fetchCollectionsList = exports.fetchCollectionByHandle = void 0;
const fetchCollectionByHandle = async ({ handle }) => {
    if (!handle)
        throw new TypeError('Missing required product "handle"');
    try {
        const url = `/json/collections/${handle}.json`;
        // eslint-disable-next-line no-undef
        const response = await fetch(url);
        if (response?.ok) {
            return await response.json();
        }
        return null;
    }
    catch (error) {
        console.error(`Failed to fetch ${handle} collection due to`, error.message);
        throw error;
    }
};
exports.fetchCollectionByHandle = fetchCollectionByHandle;
// collection listings and index fetch factory
const _fetchCollections = (target) => async () => {
    if (!target)
        throw new TypeError('Missing required collection endpoint "target"');
    try {
        const productUrl = `/json/${target}.json`;
        // eslint-disable-next-line no-undef
        const response = await fetch(productUrl);
        if (response?.ok) {
            return await response.json();
        }
        return null;
    }
    catch (error) {
        console.error(`Failed to fetch ${target} due to`, error.message);
        throw error;
    }
};
// product listings and indexes
exports.fetchCollectionsList = _fetchCollections('collections-list');
exports.fetchCollectionsIndex = _fetchCollections('collections-index');
exports.fetchCollectionHandles = _fetchCollections('collections');
//# sourceMappingURL=actions.js.map

/***/ }),

/***/ 2255:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.collectionStore = void 0;
const tslib_1 = __webpack_require__(5556);
/* eslint-disable max-lines */
const recoil_1 = __webpack_require__(9853);
const effects_1 = tslib_1.__importDefault(__webpack_require__(9025));
/**
  Product State
*/
const collection = (0, recoil_1.atom)({
    key: 'collection/collection',
    default: null,
    effects: [
        effects_1.default.onChange({
            key: 'collection',
            topic: 'COLLECTION_UPDATE',
            actions: ['publishBusEvent'],
        }),
    ],
});
const collections = (0, recoil_1.atom)({
    key: 'collection/collections',
    default: {},
});
const collectionsList = (0, recoil_1.atom)({
    key: 'collection/collectionsList',
    default: [],
});
// collections json fuse index
const collectionsIndex = (0, recoil_1.atom)({
    key: 'collection/collectionsIndex',
    default: null,
});
const collectionHandles = (0, recoil_1.atom)({
    key: 'collection/collectionHandles',
    default: [],
});
const collectionByHandle$ = (0, recoil_1.selectorFamily)({
    key: 'collection/collectionByHandle$',
    get: (handle) => function ({ get }) {
        const _collections = get(collections);
        const _collection = _collections && handle ? _collections[handle] : null;
        return _collection || null;
    },
    set: (handle) => ({ get, set }, newCollection) => {
        const _collections = get(collections);
        if (newCollection && newCollection?.handle && !_collections[handle]) {
            // add collection to cached list
            const _updatedCollections = {
                ..._collections,
                [handle]: newCollection,
            };
            set(collections, _updatedCollections);
            // set collection as default
            set(collection, newCollection);
        }
    },
});
exports.collectionStore = {
    // actual state - atoms
    collection,
    collections,
    collectionHandles,
    collectionsIndex,
    collectionsList,
    collectionByHandle$,
};
//# sourceMappingURL=collection.js.map

/***/ }),

/***/ 7152:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.collectionActions = exports.collectionStore = void 0;
const tslib_1 = __webpack_require__(5556);
var collection_1 = __webpack_require__(2255);
Object.defineProperty(exports, "collectionStore", ({ enumerable: true, get: function () { return collection_1.collectionStore; } }));
exports.collectionActions = tslib_1.__importStar(__webpack_require__(9939));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 6910:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CustomerClient = void 0;
class CustomerClient {
    constructor({ debug }) {
        this.debug = debug || false;
    }
    // eslint-disable-next-line class-methods-use-this
    async customerApi({ endpoint = 'get', body }) {
        const method = 'POST';
        const url = `/api/customer/${endpoint}`;
        const headers = { 'Content-Type': 'application/json' };
        try {
            // eslint-disable-next-line no-undef
            const request = await fetch(url, {
                method,
                headers,
                body: JSON.stringify(body),
            });
            if (!request?.ok) {
                throw new Error(`${endpoint} request not ok`);
            }
            const data = await request.json();
            if (this.debug) {
                console.log(`CustomerClient: ${url}`, body);
            }
            const { ok, errors, response } = data;
            if (errors?.length) {
                throw new Error(errors[0]);
            }
            if (!ok) {
                throw new Error(`${endpoint} response not ok`);
            }
            return { error: null, data: response };
        }
        catch (error) {
            console.log(`CustomerClient: ${url}/error: ${error.message}`);
            return { error: error.message, data: null };
        }
    }
    // Customer
    async activate(body) {
        return this.customerApi({ endpoint: 'activate', body });
    }
    async get(body) {
        return this.customerApi({ endpoint: 'get', body });
    }
    async login(body) {
        return this.customerApi({ endpoint: 'login', body });
    }
    async create(body) {
        return this.customerApi({ endpoint: 'create', body });
    }
    async update(body) {
        return this.customerApi({ endpoint: 'update', body });
    }
    async orders(body) {
        return this.customerApi({ endpoint: 'orders', body });
    }
    async order(body) {
        return this.customerApi({ endpoint: 'order', body });
    }
    async metafield(body) {
        return this.customerApi({ endpoint: 'metafield', body });
    }
    // Address
    async addresses(body) {
        return this.customerApi({ endpoint: 'addresses', body });
    }
    async addressCreate(body) {
        return this.customerApi({ endpoint: 'address-create', body });
    }
    async addressUpdate(body) {
        return this.customerApi({ endpoint: 'address-update', body });
    }
    async addressDelete(body) {
        return this.customerApi({ endpoint: 'address-delete', body });
    }
    // Password
    async passwordRecover(body) {
        return this.customerApi({ endpoint: 'password-recover', body });
    }
    async passwordReset(body) {
        return this.customerApi({ endpoint: 'password-reset', body });
    }
}
exports.CustomerClient = CustomerClient;
//# sourceMappingURL=client.js.map

/***/ }),

/***/ 354:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CustomerClient = void 0;
var client_1 = __webpack_require__(6910);
Object.defineProperty(exports, "CustomerClient", ({ enumerable: true, get: function () { return client_1.CustomerClient; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 3296:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(5556);
tslib_1.__exportStar(__webpack_require__(8640), exports); // new on v2 (async);
tslib_1.__exportStar(__webpack_require__(3478), exports); // new on v2
tslib_1.__exportStar(__webpack_require__(2081), exports); // new on v2
// getters — selectors
tslib_1.__exportStar(__webpack_require__(8138), exports); // now async on v2
tslib_1.__exportStar(__webpack_require__(2995), exports); // now async on v2
tslib_1.__exportStar(__webpack_require__(6764), exports);
tslib_1.__exportStar(__webpack_require__(1491), exports);
tslib_1.__exportStar(__webpack_require__(7382), exports);
// musts
tslib_1.__exportStar(__webpack_require__(1674), exports);
tslib_1.__exportStar(__webpack_require__(124), exports);
// customer apis
tslib_1.__exportStar(__webpack_require__(7839), exports);
tslib_1.__exportStar(__webpack_require__(9638), exports);
tslib_1.__exportStar(__webpack_require__(1820), exports);
tslib_1.__exportStar(__webpack_require__(1151), exports);
tslib_1.__exportStar(__webpack_require__(2174), exports);
tslib_1.__exportStar(__webpack_require__(1041), exports);
// address apis
tslib_1.__exportStar(__webpack_require__(3063), exports);
tslib_1.__exportStar(__webpack_require__(9130), exports);
tslib_1.__exportStar(__webpack_require__(9230), exports);
// password apis
tslib_1.__exportStar(__webpack_require__(2148), exports);
tslib_1.__exportStar(__webpack_require__(3246), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 6764:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomer = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useCustomer = () => (0, store_1.useRecoilValue)(store_1.default.customer);
exports.useCustomer = useCustomer;
//# sourceMappingURL=useCustomer.js.map

/***/ }),

/***/ 7382:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerAccessToken = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useCustomerAccessToken = () => (0, store_1.useRecoilValue)(store_1.default.accessToken);
exports.useCustomerAccessToken = useCustomerAccessToken;
//# sourceMappingURL=useCustomerAccessToken.js.map

/***/ }),

/***/ 1820:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerActivate = void 0;
const tslib_1 = __webpack_require__(5556);
const useCustomerStartFinishErrors_1 = __webpack_require__(2957);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const defaultProps = {
    options: {},
};
const useCustomerActivate = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { started, setStarted, finished, setFinished, errors, setErrors, reset, resetTimer, } = (0, useCustomerStartFinishErrors_1.useCustomerStartFinishErrors)({
        ...props.options,
        id: 'customer/activate',
    });
    // state
    const _accessToken = (0, store_1.useRecoilValue)(store_1.default.accessToken);
    const _customer = (0, store_1.useRecoilValue)(store_1.default.customer);
    // login method - get token from email and password then get customer from token
    const activateAccount = (0, store_1.useRecoilCallback)(({ snapshot, set }) => async (data, callback) => {
        const release = snapshot.retain();
        setStarted(true);
        let validationErrors = null;
        switch (true) {
            case !data?.customerId:
                validationErrors = ['customerId not provided'];
                break;
            case !data?.activationToken:
                validationErrors = ['activationToken not provided'];
                break;
            case !data?.password:
                validationErrors = ['password not provided'];
                break;
            default:
                break;
        }
        if (validationErrors?.length) {
            setErrors(validationErrors);
            return null;
        }
        try {
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchCustomerActivate(data));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!response?.customer) {
                setErrors(['Invalid activate response missing customer']);
                return null;
            }
            if (!response?.accessToken) {
                setErrors(['Invalid activate response missing accessToken']);
                return null;
            }
            const { customer, accessToken } = response;
            setFinished(true);
            set(store_1.default.accessToken, accessToken);
            set(store_1.default.customer, customer);
            if (callback)
                callback(customer);
            return customer;
        }
        catch (error) {
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    // hook return
    return {
        activateAccount,
        accessToken: finished ? _accessToken : null,
        customer: finished ? _customer : null,
        started,
        finished,
        success: !errors?.length || false,
        errors,
        setErrors,
        resetTimer,
        reset,
    };
};
exports.useCustomerActivate = useCustomerActivate;
//# sourceMappingURL=useCustomerActivate.js.map

/***/ }),

/***/ 2995:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerAddresses = void 0;
const tslib_1 = __webpack_require__(5556);
const react_1 = __webpack_require__(7378);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useCustomerStartFinishErrors_1 = __webpack_require__(2957);
const defaultProps = {
    fetchOnMount: true,
    options: {},
};
const useCustomerAddresses = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const fetching = (0, react_1.useRef)(false);
    const { setStarted, setFinished, setErrors, finished, ...status } = (0, useCustomerStartFinishErrors_1.useCustomerStartFinishErrors)({
        ...props.options,
        id: 'customer/addresses',
    });
    const [addresses, setAddresses] = (0, store_1.useRecoilState)(store_1.default.customerAddresses);
    const getAddresses = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        setStarted(true);
        try {
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchAddresses());
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!response?.addresses) {
                setErrors([`Missing addresses data for ${data}`]);
                return null;
            }
            setFinished(true);
            setAddresses(response.addresses);
            if (callback)
                callback(response.addresses);
            return response.addresses;
        }
        catch (error) {
            console.error('getAddresses:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    }, []);
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !props.fetchOnMount,
            fetching.current,
            addresses?.length, // already have order
        ];
        if (earlyExitIf.some(Boolean)) {
            return undefined;
        }
        fetching.current = true;
        getAddresses()
            .then((_addresses) => {
            if (unMounting)
                return;
            setAddresses(_addresses);
            fetching.current = false;
        })
            .catch((error) => {
            console.error('failed to getAddresses due to', error.message);
        });
        return () => {
            unMounting = true;
            fetching.current = false;
        };
    }, [props.fetchOnMount]);
    return {
        addresses,
        getAddresses,
        setStarted,
        setFinished,
        setErrors,
        finished,
        ...status,
    };
};
exports.useCustomerAddresses = useCustomerAddresses;
//# sourceMappingURL=useCustomerAddresses.js.map

/***/ }),

/***/ 1674:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerAuth = void 0;
const tslib_1 = __webpack_require__(5556);
/* eslint-disable prettier/prettier */
const react_1 = __webpack_require__(7378);
const router_1 = __webpack_require__(6677);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useCustomer_1 = __webpack_require__(6764);
const defaultProps = {
    autoRedirect: true,
    defaultRoute: '/account/orders',
    id: '', // to help console.log specific useCustomerAuth instances
};
const useCustomerAuth = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { autoRedirect, defaultRoute, id } = props;
    const router = (0, router_1.useRouter)();
    const customer = (0, useCustomer_1.useCustomer)();
    const customerInit = (0, store_1.useRecoilValue)(store_1.default.customerInit);
    const [authenticated, setAuthenticated] = (0, store_1.useRecoilState)(store_1.default.authenticated);
    // path checkers
    const onLoginPath = /\/login/g.test(router?.asPath || '');
    const onRegisterPath = /\/register/g.test(router?.asPath || '');
    const onResetPath = /\/reset/g.test(router?.asPath || '');
    const onActivatePath = /\/activate/g.test(router?.asPath || '');
    const onLoginRegisterActivateOrResetPath = onLoginPath || onRegisterPath || onActivatePath || onResetPath;
    const onAnyAccountPath = /\/account/g.test(router?.asPath || '');
    const onAuthenticatedPath = onAnyAccountPath && !onLoginRegisterActivateOrResetPath;
    const queriedRedirectPath = router.query?.redirect;
    const onRedirectToPath = queriedRedirectPath
        ? router?.asPath === queriedRedirectPath
        : false;
    const isDefaultRoute = router?.asPath === defaultRoute;
    // Authenticate the user and maybe auto-redirect
    const authenticateUser = () => {
        // console.log(id, 'authenticateUser:customerInit', customerInit);
        if (!customerInit) {
            // Customer not ready, waiting for customerInit..
            return;
        }
        if (authenticated || authenticated === false) {
            // console.log(id, 'authenticateUser: non need to reauthenticate')
            return;
        }
        // Customer is ready..
        const loggedIn = customer?.id;
        if (loggedIn) {
            setAuthenticated(true);
            return;
        }
        setAuthenticated(false);
    };
    const routeGuest = () => {
        // Customer is ready..
        const loggedIn = customer?.id;
        if (loggedIn) {
            // console.log(id, 'routeGuest: already logged in early exit')
            return null;
        }
        if (authenticated !== false) {
            // console.log(id, 'routeGuest: authenticated or not yet authenticated early exit');
            return null; // can be 'undefined', 'false', true
        }
        // console.log('kick out if not logged in and the current path is protected')
        if (onAuthenticatedPath) {
            // console.log(id, 'routeGuest:Not logged in accessing a protected route. redirecting to login')
            router.push('/account/login');
        }
        else {
            // console.log(id, 'routeGuest:Not logged and accessing unprotected route. not redirecting (login, register, reset, activate)');
        }
        return null;
    };
    const routeCustomer = () => {
        if (!authenticated) {
            // console.log(id, 'routeCustomer: not authenticated early exit');
            return;
        }
        if (!onAnyAccountPath) {
            // console.log(id, `routeCustomer:Modal login scenario — NOT coming from /account/login, /account/register or /account/reset or any /account/x don't auto redirect`);
            return;
        }
        // if user sets withLogin.. HOC authOptions to autoRedirect: false
        if (!autoRedirect) {
            // console.log(id, 'routeCustomer:user needs to manually redirect away from these routes');
            return;
        }
        // user passed a redirect url via  ?redirect=/pages/xxx
        if (queriedRedirectPath && !onRedirectToPath) {
            // console.log(id, 'routeCustomer:Auto-redirecting to passed ?redirect');
            router.push(queriedRedirectPath);
            return;
        }
        /*
          This could be cleaned up into no if/else,
          I just want to keep it like this for clarity
          and future troubleshooting
        */
        if (onAuthenticatedPath) {
            // console.log(id, 'routeCustomer:Inside a protected account route. Not redirecting - eg. from /account/orders to /account/address')
        }
        else if (isDefaultRoute) {
            // console.log(id, 'routeCustomer:Already in default account route e.g /account/orders, No redirecting')
        }
        else {
            // console.log(id, `routeCustomer:Auto-redirecting to default ${defaultRoute || '/account/orders'}`)
            router.push(defaultRoute || '/account/orders');
        }
    };
    (0, react_1.useEffect)(() => {
        authenticateUser();
    }, [customerInit, authenticated, id]);
    // logged-out routing
    (0, react_1.useEffect)(() => {
        routeGuest();
    }, [authenticated, id, customer, onAuthenticatedPath]);
    // logged-in routing
    (0, react_1.useEffect)(() => {
        routeCustomer();
    }, [
        authenticated,
        id,
        customer,
        onAnyAccountPath,
        autoRedirect,
        queriedRedirectPath,
        onRedirectToPath,
        onAuthenticatedPath,
        isDefaultRoute,
        defaultRoute,
    ]);
    return { authenticated, customer, customerInit };
};
exports.useCustomerAuth = useCustomerAuth;
//# sourceMappingURL=useCustomerAuth.js.map

/***/ }),

/***/ 9638:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerCreate = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useCustomerStartFinishErrors_1 = __webpack_require__(2957);
const defaultProps = {
    options: {},
};
const useCustomerCreate = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { started, setStarted, finished, setFinished, errors, setErrors, reset, resetTimer, } = (0, useCustomerStartFinishErrors_1.useCustomerStartFinishErrors)({ ...props.options, id: 'customer/create' });
    // state
    const _accessToken = (0, store_1.useRecoilValue)(store_1.default.accessToken);
    const _customer = (0, store_1.useRecoilValue)(store_1.default.customer);
    // sign up method
    const customerCreate = (0, store_1.useRecoilCallback)(({ snapshot, set }) => async (data, callback) => {
        setStarted(true);
        let validationErrors = null;
        switch (true) {
            case !data:
                validationErrors = ['data not provided'];
                break;
            case !data.firstName:
                validationErrors = ['firstName not provided'];
                break;
            case !data.lastName:
                validationErrors = ['lastName not provided'];
                break;
            case !data.email:
                validationErrors = ['email not provided'];
                break;
            case !data.password:
                validationErrors = ['password not provided'];
                break;
            case typeof data.acceptsMarketing === 'undefined':
                validationErrors = ['acceptsMarketing not provided'];
                break;
            default:
                break;
        }
        if (validationErrors?.length) {
            setErrors(validationErrors);
            return null;
        }
        try {
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchCustomerCreate(data));
            if (error) {
                setErrors([error]);
                return null;
            }
            const { customer, accessToken } = response;
            if (!customer?.__typename === 'Customer') {
                setErrors(['Invalid customer response']);
                return null;
            }
            if (!accessToken?.__typename === 'CustomerAccessToken') {
                setErrors(['Invalid customer accessToken response']);
                return null;
            }
            setFinished(true);
            // used to distinguish new sign ups and fire GTM events
            set(store_1.default.customer, customer);
            set(store_1.default.newCustomer, customer);
            set(store_1.default.accessToken, accessToken);
            set(store_1.default.authenticated, true);
            if (callback)
                callback(customer);
            return customer;
        }
        catch (error) {
            setErrors([error.message]);
            return null;
        }
    });
    // hook return
    return {
        customerCreate,
        accessToken: finished ? _accessToken : null,
        customer: finished ? _customer : null,
        started,
        finished,
        success: !errors?.length || false,
        errors,
        setErrors,
        resetTimer,
        reset,
    };
};
exports.useCustomerCreate = useCustomerCreate;
//# sourceMappingURL=useCustomerCreate.js.map

/***/ }),

/***/ 3063:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerCreateAddress = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useCustomerStartFinishErrors_1 = __webpack_require__(2957);
const useCustomerGet_1 = __webpack_require__(7839);
const defaultProps = {
    options: {},
};
const useCustomerCreateAddress = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { started, setStarted, finished, setFinished, errors, setErrors, reset, resetTimer, } = (0, useCustomerStartFinishErrors_1.useCustomerStartFinishErrors)({
        ...props.options,
        id: 'customer/addressCreate',
    });
    const { customerGet } = (0, useCustomerGet_1.useCustomerGet)();
    const addresses = (0, store_1.useRecoilValue)(store_1.default.customerAddresses);
    // update a customer address, (optionally) set as default and get fresh customer
    const createAddress = (0, store_1.useRecoilCallback)(({ snapshot, set }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data?.address: {
                    validationErrors = ['address object to update not provided'];
                    break;
                }
                case typeof data?.isDefault === 'undefined': {
                    validationErrors = ['isDefault not provided'];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                setErrors(validationErrors);
                return null;
            }
            // accessToken is required and will be injected at addressCreate$
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchAddressCreate(data));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!response?.address) {
                setErrors(['Invalid address create response']);
                return null;
            }
            const { address: newAddress } = response;
            // update the cached address and add the new address
            const updatedAddresses = [...addresses, newAddress];
            set(store_1.default.customerAddresses, updatedAddresses);
            setFinished(true);
            if (callback)
                callback(newAddress);
            await customerGet({ forceUpdate: true });
            return newAddress; // new address
        }
        catch (error) {
            console.error(`createAddress:error ${error.message}`);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    // hook return
    return {
        createAddress,
        started,
        finished,
        success: !errors?.length || false,
        errors,
        setErrors,
        resetTimer,
        reset,
    };
};
exports.useCustomerCreateAddress = useCustomerCreateAddress;
//# sourceMappingURL=useCustomerCreateAddress.js.map

/***/ }),

/***/ 1491:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerDefaultAddress = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useCustomerDefaultAddress = () => {
    return (0, store_1.useRecoilValue)(store_1.default.customerDefaultAddress$);
};
exports.useCustomerDefaultAddress = useCustomerDefaultAddress;
//# sourceMappingURL=useCustomerDefaultAddress.js.map

/***/ }),

/***/ 9230:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerDeleteAddress = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useCustomerStartFinishErrors_1 = __webpack_require__(2957);
const useCustomerGet_1 = __webpack_require__(7839);
const useCustomerDeleteAddress = (options) => {
    const { started, setStarted, finished, setFinished, errors, setErrors, reset, resetTimer, } = (0, useCustomerStartFinishErrors_1.useCustomerStartFinishErrors)(options);
    const { customerGet } = (0, useCustomerGet_1.useCustomerGet)();
    // state
    const _accessToken = (0, store_1.useRecoilValue)(store_1.default.accessToken);
    const addresses = (0, store_1.useRecoilValue)(store_1.default.customerAddresses);
    // delete a customer address
    const deleteAddress = (0, store_1.useRecoilCallback)(({ snapshot, set }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data?.id: {
                    validationErrors = ['address id to delete not provided'];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                setErrors(validationErrors);
                return null;
            }
            // accessToken is required and will be injected at addressDelete$
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchAddressDelete(data));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!response?.deletedCustomerAddressId) {
                setErrors(['Invalid address delete response']);
                return null;
            }
            const { deletedCustomerAddressId } = response;
            // update the cached address by removing the currently deleted address
            const updatedAddresses = addresses.filter((_address) => {
                const wasDeleted = _address.id.split('?')[0] === data?.id.split('?')[0];
                if (wasDeleted)
                    return false;
                return true;
            });
            set(store_1.default.customerAddresses, updatedAddresses);
            setFinished(true);
            if (callback)
                callback(deletedCustomerAddressId);
            await customerGet({ forceUpdate: true });
            return deletedCustomerAddressId;
        }
        catch (error) {
            console.error(`deleteAddress:error ${error.message}`);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    // hook return
    return {
        deleteAddress,
        accessToken: finished ? _accessToken : null,
        started,
        finished,
        success: !errors?.length || false,
        errors,
        setErrors,
        resetTimer,
        reset,
    };
};
exports.useCustomerDeleteAddress = useCustomerDeleteAddress;
//# sourceMappingURL=useCustomerDeleteAddress.js.map

/***/ }),

/***/ 7839:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerGet = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useCustomerStartFinishErrors_1 = __webpack_require__(2957);
const defaultProps = {
    options: {},
};
const useCustomerGet = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const customer = (0, store_1.useRecoilValue)(store_1.default.customer);
    const accessToken = (0, store_1.useRecoilValue)(store_1.default.accessToken);
    const { setStarted, setFinished, setErrors, ...status } = (0, useCustomerStartFinishErrors_1.useCustomerStartFinishErrors)({
        id: `customer/${accessToken?.token ?? ''}/get`,
        ...props.options,
    });
    const customerGet = (0, store_1.useRecoilCallback)(({ snapshot, set }) => async (data, callback) => {
        setStarted(true);
        const release = snapshot.retain();
        try {
            // return cached customer
            if (customer?.id && !data?.forceUpdate) {
                setFinished(true);
                return customer;
            }
            // can pass accessToken or will use the on in store
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchCustomerGet(data));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!response?.customer) {
                setErrors(['customer get response missing customer data']);
                return null;
            }
            if (!response?.customer?.__typename === 'Customer') {
                setErrors(['customer get invalid customer response']);
                return null;
            }
            const { customer: _customer } = response;
            setFinished(true);
            set(store_1.default.customer, _customer);
            if (callback)
                callback(_customer);
            return _customer;
        }
        catch (error) {
            console.error(`customerGet:error ${error.message}`);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    }, [customer]);
    return {
        customerGet,
        customer,
        setStarted,
        setFinished,
        setErrors,
        ...status,
    };
};
exports.useCustomerGet = useCustomerGet;
//# sourceMappingURL=useCustomerGet.js.map

/***/ }),

/***/ 124:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerInit = void 0;
const tslib_1 = __webpack_require__(5556);
/* eslint-disable prettier/prettier */
/* eslint-disable no-unused-expressions */
const react_1 = __webpack_require__(7378);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useCustomerGet_1 = __webpack_require__(7839);
const useCustomerLogout_1 = __webpack_require__(2174);
// temp while we validate new customer works as expected;
const DEBUG = false;
const defaultProps = {
    fetchOnMount: false,
    options: {},
};
const useCustomerInit = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const initializing = (0, react_1.useRef)(false);
    const customer = (0, store_1.useRecoilValue)(store_1.default.customer);
    const accessToken = (0, store_1.useRecoilValue)(store_1.default.accessToken);
    const isValidAccessToken = (0, store_1.useRecoilValue)(store_1.default.isValidAccessToken$);
    const { customerLogout } = (0, useCustomerLogout_1.useCustomerLogout)();
    const { customerGet } = (0, useCustomerGet_1.useCustomerGet)();
    const init = (0, store_1.useRecoilCallback)(({ snapshot, set }) => async (data, callback) => {
        if (!props?.fetchOnMount)
            return null;
        if (initializing.current)
            return null;
        initializing.current = true;
        const release = snapshot.retain();
        try {
            switch (true) {
                case customer: {
                    DEBUG &&
                        console.log('👷‍♂️ customer init: Found existing customer (auto-login)'); // auto-login
                    break;
                }
                case !accessToken: {
                    DEBUG && console.log('👷‍♂️ customer init: No access token found.'); // no persisted token -> no auto-login attempt
                    set(store_1.default.customer, null);
                    break;
                }
                case isValidAccessToken: {
                    DEBUG &&
                        console.log('👷‍♂️ customer init: Have valid token fetching customer');
                    await customerGet({ accessToken }); // update customer data
                    break;
                }
                default: {
                    DEBUG &&
                        console.log('👷‍♂️ customer init: Invalid/expired token logging customer out');
                    await customerLogout(); // deletes stale accessToken
                    set(store_1.default.customerInit, false);
                    return null;
                }
            }
            set(store_1.default.customerInit, true);
            if (callback)
                callback(customer);
            return customer;
        }
        catch (error) {
            console.error('👷‍♂️ customer init: error', error.message);
            return null;
        }
        finally {
            release();
        }
    });
    // manage customer here, so that we don't cause un-necessary top level re-renders
    (0, react_1.useEffect)(() => {
        init();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customer, accessToken, isValidAccessToken, props?.fetchOnMount]);
    return customer;
};
exports.useCustomerInit = useCustomerInit;
//# sourceMappingURL=useCustomerInit.js.map

/***/ }),

/***/ 1151:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerLogin = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useCustomerStartFinishErrors_1 = __webpack_require__(2957);
const defaultProps = {
    options: {},
};
const useCustomerLogin = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { started, setStarted, finished, setFinished, errors, setErrors, reset, resetTimer, } = (0, useCustomerStartFinishErrors_1.useCustomerStartFinishErrors)({ ...props.options, id: 'customer/login' });
    // state
    const accessToken = (0, store_1.useRecoilValue)(store_1.default.accessToken);
    const customer = (0, store_1.useRecoilValue)(store_1.default.customer);
    // login method - get token from email and password then get customer from token
    const customerLogin = (0, store_1.useRecoilCallback)(({ snapshot, set }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data?.email:
                    validationErrors = ['email not provided'];
                    break;
                case !data?.password:
                    validationErrors = ['password not provided'];
                    break;
                default:
                    break;
            }
            if (validationErrors?.length) {
                setErrors(validationErrors);
                return null;
            }
            // get accessToken and customer via /api/customer-login
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchCustomerLogin(data));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!response?.accessToken) {
                setErrors(['Invalid login response access token']);
                return null;
            }
            if (!response?.customer) {
                setErrors(['Invalid login response missing customer']);
                return null;
            }
            const { accessToken: _accessToken, customer: _customer } = response;
            setFinished(true);
            set(store_1.default.accessToken, _accessToken);
            set(store_1.default.customer, _customer);
            set(store_1.default.authenticated, true);
            if (callback)
                callback(customer);
            return customer || null;
        }
        catch (error) {
            console.error(`customerLogin:error ${error.message}`);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    // hook return
    return {
        customerLogin,
        accessToken: finished ? accessToken : null,
        customer: finished ? customer : null,
        started,
        finished,
        success: !errors?.length || false,
        errors,
        setErrors,
        resetTimer,
        reset,
    };
};
exports.useCustomerLogin = useCustomerLogin;
//# sourceMappingURL=useCustomerLogin.js.map

/***/ }),

/***/ 2174:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerLogout = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useCustomerStartFinishErrors_1 = __webpack_require__(2957);
const defaultProps = {
    options: {},
};
// keeping same verbose structure for consistency despite the fact that we don't need async calls
const useCustomerLogout = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const accessToken = (0, store_1.useRecoilValue)(store_1.default.accessToken);
    const { started, setStarted, finished, setFinished, errors, setErrors, reset: resetStatus, resetTimer, } = (0, useCustomerStartFinishErrors_1.useCustomerStartFinishErrors)({
        ...props.options,
        id: `customer/${accessToken?.token ?? ''}/logout`,
    });
    // login method - get token from email and password then get customer from token
    const customerLogout = (0, store_1.useRecoilCallback)(({ snapshot, reset, set }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            setFinished(true);
            // will set both localStorage and state to null
            set(store_1.default.customer, null);
            reset(store_1.default.accessToken);
            reset(store_1.default.authenticated);
            // reset ancillary customer state
            reset(store_1.default.customerAddresses);
            reset(store_1.default.customerMetafield(undefined));
            reset(store_1.default.customerOrder(undefined));
            reset(store_1.default.customerOrders(1));
            reset(store_1.default.customerOrdersAction);
            reset(store_1.default.customerOrdersCursor(1));
            reset(store_1.default.customerOrdersPage);
            if (callback)
                callback(true);
            return true;
        }
        catch (error) {
            console.error(`customerLogout:error ${error.message}`);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    // hook return
    return {
        customerLogout,
        started,
        finished,
        success: !errors?.length || false,
        errors,
        setErrors,
        resetTimer,
        reset: resetStatus,
    };
};
exports.useCustomerLogout = useCustomerLogout;
//# sourceMappingURL=useCustomerLogout.js.map

/***/ }),

/***/ 2081:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerMetafield = void 0;
const tslib_1 = __webpack_require__(5556);
/* eslint-disable no-undef */
const react_1 = __webpack_require__(7378);
const helpers_1 = __webpack_require__(5542);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const defaultProps = {
    key: '',
    namespace: '',
    fetchOnMount: true,
    options: {},
};
const useCustomerMetafield = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    let { key, namespace } = props;
    if (!key)
        throw new Error('"key" prop not provided');
    if (!namespace)
        throw new Error('"namespace" prop not provided');
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, helpers_1.useRecoilStartFinishErrors)({
        id: `product/getProductMetafield/${namespace}/${key}`,
        ...props.options,
    });
    const [metafield, setMetafield] = (0, store_1.useRecoilState)(store_1.default.productMetafield({ key, namespace }));
    const getMetafield = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        try {
            setStarted(true);
            // eslint-disable-next-line no-use-before-define
            if (metafield) {
                setFinished(true);
                if (callback)
                    callback(metafield);
                return metafield;
            }
            if (data?.key) {
                key = data.key;
            }
            if (data?.namespace) {
                namespace = data.namespace;
            }
            let validationErrors = null;
            switch (true) {
                case !key: {
                    validationErrors = ['key not provided'];
                    break;
                }
                case !namespace: {
                    validationErrors = ['namespace not provided'];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                setErrors(validationErrors);
                return null;
            }
            // get the metafield via the product client
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchCustomerMetafield({ key, namespace }));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!response?.metafield) {
                setErrors([
                    `Invalid customer metafield response: ${JSON.stringify(response)}`,
                ]);
                return null;
            }
            setFinished(true);
            setMetafield(response.metafield);
            if (callback)
                callback(response.metafield);
            return response.metafield;
        }
        catch (error) {
            console.error(`getCustomerMetafield:error ${error.message}`);
            setErrors([error.message]);
            return null;
        }
    }, [key, namespace]);
    // fetch on change
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !key,
            !namespace,
            !props.fetchOnMount,
            finished && metafield, // already have metafield
        ];
        const shouldExit = !earlyExitIf.some(Boolean);
        if (shouldExit) {
            getMetafield({ key, namespace })
                .then((_metafield) => {
                if (unMounting || !_metafield)
                    return;
                setMetafield(_metafield);
            })
                .catch((error) => {
                console.error('failed to getMetafield due to', error.message);
            });
        }
        return () => {
            if (shouldExit) {
                unMounting = true;
            }
        };
    }, [key, namespace, props.fetchOnMount]);
    return {
        metafield,
        getMetafield,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useCustomerMetafield = useCustomerMetafield;
//# sourceMappingURL=useCustomerMetafield.js.map

/***/ }),

/***/ 8640:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerOrder = void 0;
const tslib_1 = __webpack_require__(5556);
const react_1 = __webpack_require__(7378);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useCustomerStartFinishErrors_1 = __webpack_require__(2957);
const defaultProps = {
    id: null,
    fetchOnMount: true,
    options: {},
};
const useCustomerOrder = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    if (!props?.id) {
        throw new Error('id not provided');
    }
    const fetching = (0, react_1.useRef)(false);
    const { setStarted, setFinished, setErrors, finished, ...status } = (0, useCustomerStartFinishErrors_1.useCustomerStartFinishErrors)({
        ...props.options,
        id: `customer/order/${props.id}`,
    });
    const [order, setOrder] = (0, store_1.useRecoilState)(store_1.default.customerOrder(props.id));
    const getOrder = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        setStarted(true);
        let validationErrors = null;
        switch (true) {
            case !data.id:
                validationErrors = ['id not provided'];
                break;
            default:
                break;
        }
        if (validationErrors?.length) {
            setErrors(validationErrors);
            return null;
        }
        try {
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchCustomerOrder(data));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!response?.order?.id) {
                setErrors([`Missing order data for ${JSON.stringify(data)}`]);
                return null;
            }
            setFinished(true);
            setOrder(response.order);
            if (callback)
                callback(response.order);
            return response.order;
        }
        catch (error) {
            console.error('getOrder:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    }, []);
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !props?.id,
            !props.fetchOnMount,
            fetching.current,
            order, // already have order
        ];
        if (earlyExitIf.some(Boolean)) {
            return undefined;
        }
        fetching.current = true;
        getOrder({ id: props?.id })
            .then((_order) => {
            if (unMounting)
                return;
            setOrder(_order);
            fetching.current = false;
        })
            .catch((error) => {
            console.error('failed to getOrder due to', error.message);
        });
        return () => {
            unMounting = true;
            fetching.current = false;
        };
    }, [props.fetchOnMount, props?.id]);
    return {
        order,
        setStarted,
        setFinished,
        setErrors,
        finished,
        ...status,
    };
};
exports.useCustomerOrder = useCustomerOrder;
//# sourceMappingURL=useCustomerOrder.js.map

/***/ }),

/***/ 8138:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerOrders = void 0;
const tslib_1 = __webpack_require__(5556);
const react_1 = __webpack_require__(7378);
const useCustomerStartFinishErrors_1 = __webpack_require__(2957);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const defaultProps = {
    page: 1,
    perPage: 10,
    fetchOnMount: true,
    options: {},
};
const useCustomerOrders = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const fetching = (0, react_1.useRef)(false);
    const customer = (0, store_1.useRecoilValue)(store_1.default.customer);
    const accessToken = (0, store_1.useRecoilValue)(store_1.default.accessToken);
    const [page, setPage] = (0, store_1.useRecoilState)(store_1.default.customerOrdersPage);
    const setAction = (0, store_1.useSetRecoilState)(store_1.default.customerOrdersAction);
    const [cursor, setCursor] = (0, store_1.useRecoilState)(store_1.default.customerOrdersCursor(page));
    const [orders, setOrders] = (0, store_1.useRecoilState)(store_1.default.customerOrders(page));
    const { setStarted, setFinished, setErrors, finished, ...status } = (0, useCustomerStartFinishErrors_1.useCustomerStartFinishErrors)({
        ...props.options,
        id: `customer/${accessToken?.token ?? ''}/orders/${props.page}`,
    });
    const getNext = (0, react_1.useCallback)(() => {
        if (cursor?.after) {
            setFinished(false);
            setPage((_page) => _page + 1);
            setAction('next');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cursor?.after]);
    const getPrevious = (0, react_1.useCallback)(() => {
        if (cursor?.before && page > 1) {
            setFinished(false);
            setPage((_page) => _page - 1);
            setAction('prev');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cursor?.before, page]);
    const getPageOrdersData = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        setStarted(true);
        let validationErrors = null;
        switch (true) {
            case !data?.page:
                validationErrors = ['page not provided'];
                break;
            case !data?.perPage:
                validationErrors = ['perPage not provided'];
                break;
            default:
                break;
        }
        if (validationErrors?.length) {
            setErrors(validationErrors);
            return null;
        }
        try {
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchCustomerOrders(data));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!Array.isArray(response.orders)) {
                setErrors([`Missing orders data for ${data}`]);
                return null;
            }
            setFinished(true);
            if (callback)
                callback(response);
            return response;
        }
        catch (error) {
            console.error('getPageOrdersData:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    }, []);
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !customer,
            !page,
            !props.perPage,
            !props.fetchOnMount,
            fetching.current,
            orders?.length, // already have metafield
        ];
        if (earlyExitIf.some(Boolean)) {
            return undefined;
        }
        fetching.current = true;
        getPageOrdersData({ page, perPage: props.perPage })
            .then((data) => {
            if (unMounting)
                return;
            setCursor({
                after: data.after || null,
                before: data.before || null,
            });
            setOrders(data.orders);
            fetching.current = false;
        })
            .catch((error) => {
            console.error('failed to getPageOrdersData due to', error.message);
        });
        return () => {
            unMounting = true;
            fetching.current = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customer, props.fetchOnMount, props.perPage, page]);
    return {
        orders,
        page,
        hasPrevious: !!cursor?.before,
        getPrevious,
        hasNext: !!cursor?.after,
        getNext,
        setStarted,
        setFinished,
        setErrors,
        finished,
        ...status,
    };
};
exports.useCustomerOrders = useCustomerOrders;
//# sourceMappingURL=useCustomerOrders.js.map

/***/ }),

/***/ 2148:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerRecoverPassword = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useCustomerStartFinishErrors_1 = __webpack_require__(2957);
const defaultProps = {
    options: {},
};
const useCustomerRecoverPassword = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { started, setStarted, finished, setFinished, errors, setErrors, reset, resetTimer, } = (0, useCustomerStartFinishErrors_1.useCustomerStartFinishErrors)({
        ...props.options,
        id: 'customer/passwordRecover',
    });
    // login method - get token from email and password then get customer from token
    const recoverPassword = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        setStarted(true);
        let validationErrors = null;
        switch (true) {
            case !data?.email:
                validationErrors = ['email not provided'];
                break;
            default:
                break;
        }
        if (validationErrors?.length) {
            setErrors(validationErrors);
            return null;
        }
        try {
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchPasswordRecover(data));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (typeof response?.emailSent === 'undefined') {
                setErrors(['Invalid recover email response']);
                return null;
            }
            const { emailSent } = response;
            setFinished(true);
            if (callback)
                callback(emailSent);
            return emailSent;
        }
        catch (error) {
            console.error('recoverPassword:error', error.message);
            setErrors([error.message]);
            return null;
        }
    });
    // hook return
    return {
        recoverPassword,
        emailSent: (finished && !errors?.length) || null,
        started,
        finished,
        success: !errors?.length || false,
        errors,
        setErrors,
        resetTimer,
        reset,
    };
};
exports.useCustomerRecoverPassword = useCustomerRecoverPassword;
//# sourceMappingURL=useCustomerRecoverPassword.js.map

/***/ }),

/***/ 3246:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerResetPassword = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useCustomerStartFinishErrors_1 = __webpack_require__(2957);
const defaultProps = {
    options: {},
};
const useCustomerResetPassword = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { started, setStarted, finished, setFinished, errors, setErrors, reset, resetTimer, } = (0, useCustomerStartFinishErrors_1.useCustomerStartFinishErrors)({
        ...props.options,
        id: 'customer/passwordReset',
    });
    // state
    const _accessToken = (0, store_1.useRecoilValue)(store_1.default.accessToken);
    const _customer = (0, store_1.useRecoilValue)(store_1.default.customer);
    // login method - get token from email and password then get customer from token
    const resetPassword = (0, store_1.useRecoilCallback)(({ snapshot, set }) => async (data, callback) => {
        setStarted(true);
        let validationErrors = null;
        switch (true) {
            case !data?.password:
                validationErrors = ['password not provided'];
                break;
            case !data?.url:
                validationErrors = ['url not provided'];
                break;
            default:
                break;
        }
        if (validationErrors?.length) {
            setErrors(validationErrors);
            return null;
        }
        try {
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchPasswordReset(data));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!response?.customer) {
                setErrors(['Invalid reset response missing customer']);
                return null;
            }
            if (!response?.accessToken) {
                setErrors(['Invalid reset response missing accessToken']);
                return null;
            }
            const { customer, accessToken } = response;
            setFinished(true);
            set(store_1.default.accessToken, accessToken);
            set(store_1.default.customer, customer);
            set(store_1.default.authenticated, true);
            if (callback)
                callback(customer);
            return customer;
        }
        catch (error) {
            console.error('resetPassword:error', error.message);
            setErrors([error.message]);
            return null;
        }
    });
    // hook return
    return {
        resetPassword,
        accessToken: finished ? _accessToken : null,
        customer: finished ? _customer : null,
        started,
        finished,
        success: !errors?.length || false,
        errors,
        setErrors,
        resetTimer,
        reset,
    };
};
exports.useCustomerResetPassword = useCustomerResetPassword;
//# sourceMappingURL=useCustomerResetPassword.js.map

/***/ }),

/***/ 2957:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerStartFinishErrors = void 0;
const tslib_1 = __webpack_require__(5556);
/* eslint-disable prettier/prettier */
const react_1 = __webpack_require__(7378);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const DEBUG = false;
const useCustomerStartFinishErrors = (options) => {
    const setCustomerStarted = (0, store_1.useSetRecoilState)(store_1.default.customerStatusStarted('customer/all'));
    const setCustomerFinished = (0, store_1.useSetRecoilState)(store_1.default.customerStatusFinished('customer/all'));
    const setCustomerSuccess = (0, store_1.useSetRecoilState)(store_1.default.customerStatusSuccess('customer/all'));
    const setCustomerErrors = (0, store_1.useSetRecoilState)(store_1.default.customerStatusErrors('customer/all'));
    const [started, setStarted] = (0, store_1.useRecoilState)(store_1.default.customerStatusStarted(options?.id || ''));
    const [finished, setFinished] = (0, store_1.useRecoilState)(store_1.default.customerStatusFinished(options?.id || ''));
    const [success, setSuccess] = (0, store_1.useRecoilState)(store_1.default.customerStatusSuccess(options?.id || ''));
    const [errors, setErrors] = (0, store_1.useRecoilState)(store_1.default.customerStatusErrors(options?.id || ''));
    const autoReset = (0, react_1.useRef)(options?.autoReset || 0);
    const resetTimer = (0, react_1.useRef)(options?.resetTimer || null);
    const isCustomerId = /^customer/.test(options?.id);
    // update local hook status
    const reset = (0, react_1.useCallback)(() => {
        if (typeof setErrors === 'undefined')
            return;
        setErrors([]);
        setStarted(false);
        setFinished(false);
        setSuccess(false);
        resetTimer.current = null;
    }, []);
    const updateStateOnErrors = () => {
        let unMounting = false;
        if (errors?.length > 0) {
            if (unMounting)
                return;
            setFinished(true);
            setSuccess(false);
        }
        // eslint-disable-next-line consistent-return
        return () => {
            unMounting = true;
        };
    };
    const updateStateOnFinished = () => {
        let unMounting = false;
        if (finished) {
            if (DEBUG) {
                console.groupCollapsed('status:', options?.id);
                console.log('started', started);
                console.log('errors', errors);
                console.log('finished', finished);
                console.log('success', success);
                console.groupEnd();
            }
            if (unMounting)
                return;
            const withoutErrors = errors?.length === 0;
            setStarted(false);
            setSuccess(withoutErrors);
            if (autoReset?.current) {
                const to = setTimeout(() => {
                    if (unMounting)
                        return;
                    reset();
                    clearTimeout(to);
                }, autoReset.current);
            }
        }
        // eslint-disable-next-line consistent-return
        return () => {
            unMounting = true;
        };
    };
    (0, react_1.useEffect)(() => {
        updateStateOnErrors();
    }, [errors?.length]);
    (0, react_1.useEffect)(() => {
        updateStateOnFinished();
    }, [finished, options?.id]);
    // update global cart status
    (0, react_1.useEffect)(() => {
        if (isCustomerId) {
            setCustomerErrors(errors);
        }
    }, [errors?.length]);
    (0, react_1.useEffect)(() => {
        if (isCustomerId) {
            setCustomerStarted(started);
        }
    }, [started]);
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        setCustomerFinished(finished);
        const to = setTimeout(() => {
            if (unMounting)
                return;
            setCustomerFinished(false);
            clearTimeout(to);
        }, 1000);
        return () => {
            unMounting = true;
        };
    }, [finished]);
    (0, react_1.useEffect)(() => {
        if (isCustomerId) {
            setCustomerSuccess(success);
        }
    }, [success]);
    return {
        started,
        setStarted,
        finished,
        setFinished,
        success,
        setSuccess,
        errors,
        setErrors,
        reset,
        resetTimer,
    };
};
exports.useCustomerStartFinishErrors = useCustomerStartFinishErrors;
//# sourceMappingURL=useCustomerStartFinishErrors.js.map

/***/ }),

/***/ 3478:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerStatus = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
// global status of the customer, any customer action will trigger
// these states via useRecoilStartFinishErrors.js
const useCustomerStatus = () => {
    return {
        started: (0, store_1.useRecoilValue)(store_1.default.customerStatusStarted('customer/all')),
        finished: (0, store_1.useRecoilValue)(store_1.default.customerStatusFinished('customer/all')),
        success: (0, store_1.useRecoilValue)(store_1.default.customerStatusSuccess('customer/all')),
        errors: (0, store_1.useRecoilValue)(store_1.default.customerStatusErrors('customer/all')),
    };
};
exports.useCustomerStatus = useCustomerStatus;
//# sourceMappingURL=useCustomerStatus.js.map

/***/ }),

/***/ 9130:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerUpdateAddress = void 0;
const tslib_1 = __webpack_require__(5556);
const react_1 = __webpack_require__(7378);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useCustomerStartFinishErrors_1 = __webpack_require__(2957);
const useCustomerGet_1 = __webpack_require__(7839);
const defaultProps = {
    options: {},
};
const useCustomerUpdateAddress = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { started, setStarted, finished, setFinished, success, errors, setErrors, reset, resetTimer, } = (0, useCustomerStartFinishErrors_1.useCustomerStartFinishErrors)({
        ...props.options,
        id: 'customer/updateAddress',
    });
    const { customerGet } = (0, useCustomerGet_1.useCustomerGet)();
    // state
    const [address, setAddress] = (0, react_1.useState)();
    const addresses = (0, store_1.useRecoilValue)(store_1.default.customerAddresses);
    // update a customer address, (optionally) set as default and get fresh customer
    const updateAddress = (0, store_1.useRecoilCallback)(({ snapshot, set }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            let validationErrors = null;
            switch (true) {
                case !data?.id: {
                    validationErrors = ['address to update id not provided'];
                    break;
                }
                case !data?.address: {
                    validationErrors = ['address object to update not provided'];
                    break;
                }
                case typeof data?.isDefault === 'undefined': {
                    validationErrors = ['address isDefault to update not provided'];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                setErrors(validationErrors);
                return null;
            }
            // accessToken is required and will be injected at addressUpdate$
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchAddressUpdate(data));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!response?.address) {
                setErrors(['Invalid address update response']);
                return null;
            }
            const { address: _updatedAddress } = response;
            setFinished(true);
            setAddress(_updatedAddress);
            // update the cached address which was just updated
            const updatedAddresses = addresses.map((_address) => {
                const wasUpdated = _address.id.split('?')[0] === _updatedAddress.id.split('?')[0];
                if (!wasUpdated)
                    return _address;
                return _updatedAddress;
            });
            set(store_1.default.customerAddresses, updatedAddresses);
            if (callback)
                callback(_updatedAddress);
            await customerGet({ forceUpdate: true });
            return _updatedAddress; // updated address
        }
        catch (error) {
            console.error('updateAddress:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    // hook return
    return {
        address,
        updateAddress,
        started,
        finished,
        success,
        errors,
        setErrors,
        resetTimer,
        reset,
    };
};
exports.useCustomerUpdateAddress = useCustomerUpdateAddress;
//# sourceMappingURL=useCustomerUpdateAddress.js.map

/***/ }),

/***/ 1041:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCustomerUpdateDetails = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useCustomerStartFinishErrors_1 = __webpack_require__(2957);
const defaultProps = {
    options: {},
};
const useCustomerUpdateDetails = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { started, setStarted, finished, setFinished, success, errors, setErrors, reset, resetTimer, } = (0, useCustomerStartFinishErrors_1.useCustomerStartFinishErrors)({ ...props.options, id: 'customer/update' });
    // state
    const _customer = (0, store_1.useRecoilValue)(store_1.default.customer);
    // login method - get token from email and password then get customer from token
    const customerUpdateDetails = (0, store_1.useRecoilCallback)(({ snapshot, set }) => async (data, callback) => {
        setStarted(true);
        let validationErrors = null;
        switch (true) {
            case !data:
                validationErrors = ['data not provided'];
                break;
            case !data.firstName:
                validationErrors = ['firstName not provided'];
                break;
            case !data.lastName:
                validationErrors = ['lastName not provided'];
                break;
            case !data.email:
                validationErrors = ['email not provided'];
                break;
            case typeof data.acceptsMarketing === 'undefined':
                validationErrors = ['acceptsMarketing not provided'];
                break;
            default:
                break;
        }
        if (validationErrors?.length) {
            setErrors(validationErrors);
            return null;
        }
        try {
            // accessToken is also required so will be injected at customerUpdate$
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchCustomerUpdate({ customer: data }));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!response?.customer ||
                !response?.customer?.id ||
                !response?.accessToken) {
                setErrors(['Invalid customer update response response']);
                return null;
            }
            const { customer, accessToken } = response;
            setFinished(true);
            set(store_1.default.accessToken, accessToken);
            set(store_1.default.customer, customer);
            if (callback)
                callback(customer);
            return customer;
        }
        catch (error) {
            console.error('customerUpdateDetails:error', error.message);
            setErrors([error.message]);
            return null;
        }
    });
    // hook return
    return {
        customerUpdateDetails,
        customer: finished ? _customer : null,
        started,
        finished,
        success,
        errors,
        setErrors,
        resetTimer,
        reset,
    };
};
exports.useCustomerUpdateDetails = useCustomerUpdateDetails;
//# sourceMappingURL=useCustomerUpdateDetails.js.map

/***/ }),

/***/ 6029:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.customerStore = void 0;
const tslib_1 = __webpack_require__(5556);
/* eslint-disable max-lines */
const recoil_1 = __webpack_require__(9853);
const effects_1 = tslib_1.__importDefault(__webpack_require__(9025));
const store_1 = __webpack_require__(437);
const client_1 = __webpack_require__(354);
const client = new client_1.CustomerClient({
    debug: false,
});
/**
  Customer State
*/
const customerInit = (0, recoil_1.atom)({
    key: 'customer/init',
    default: false,
    effects: [
        // effects.logStateChange('customerInit'),
        effects_1.default.onChange({
            key: 'customerInit',
            topic: 'CUSTOMER_INIT',
            actions: ['publishGtmEvent', 'publishBusEvent'],
        }),
    ],
});
const accessToken = (0, recoil_1.atom)({
    key: 'customer/accessToken',
    default: null,
    effects: [
        // effects.logStateChange('accessToken'),
        effects_1.default.setSelfToPersistedKey('accessToken', `CustomerToken|${effects_1.default.SHOPIFY_NAME}`),
        effects_1.default.onSetUpdatePersistedKey(`CustomerToken|${effects_1.default.SHOPIFY_NAME}`),
    ],
});
const customer = (0, recoil_1.atom)({
    key: 'customer/customer',
    default: undefined,
    effects: [
        // effects.logStateChange('customer'),
        effects_1.default.onChange({
            key: 'customer',
            topic: 'CUSTOMER_UPDATE',
            actions: ['publishGtmEvent', 'publishBusEvent'],
        }),
    ],
});
// async
const customerAddresses = (0, recoil_1.atom)({
    key: 'customer/addresses',
    default: null,
});
// Paginated lists of order summaries for order history listing
const customerOrders = (0, recoil_1.atomFamily)({
    key: 'customer/orders',
    default: null,
});
// full order items with line items etc..
const customerOrder = (0, recoil_1.atomFamily)({
    key: 'customer/order',
    default: null,
});
const customerMetafield = (0, recoil_1.atomFamily)({
    key: 'customer/metafield',
    default: null,
});
const customerOrdersPage = (0, recoil_1.atom)({
    key: 'customer/ordersPage',
    default: 1,
});
const customerOrdersCursor = (0, recoil_1.atomFamily)({
    key: 'customer/ordersCursor',
    default: { before: null, after: null },
});
const customerOrdersAction = (0, recoil_1.atom)({
    key: 'customer/ordersAction',
    default: 'next', // || prev
});
const authenticated = (0, recoil_1.atom)({
    key: 'customer/authenticated',
    default: undefined,
});
const newCustomer = (0, recoil_1.atom)({
    key: 'customer/new',
    default: false,
    effects: [
        effects_1.default.onChange({
            key: 'newCustomer',
            topic: 'CUSTOMER_REGISTERED',
            actions: ['publishGtmEvent', 'publishBusEvent'],
        }),
    ],
});
/*
  ---------------
  Status
  ---------------
*/
const customerStatusStarted = (0, recoil_1.atomFamily)({
    key: 'customer/statusStarted',
    default: false,
});
const customerStatusFinished = (0, recoil_1.atomFamily)({
    key: 'customer/statusFinished',
    default: false,
});
const customerStatusSuccess = (0, recoil_1.atomFamily)({
    key: 'customer/statusSuccess',
    default: false,
});
const customerStatusErrors = (0, recoil_1.atomFamily)({
    key: 'customer/statusErrors',
    default: [],
});
/*
  ---------------
  Getters
  ---------------
*/
const customerDefaultAddress$ = (0, recoil_1.selector)({
    key: 'customer/defaultAddress$',
    get: ({ get }) => {
        const _customer = get(customer);
        return _customer ? _customer.defaultAddress : null;
    },
});
const isValidAccessToken$ = (0, recoil_1.selector)({
    key: 'customer/isValidToken',
    get: ({ get }) => {
        const _accessToken = get(accessToken);
        const isValidToken = _accessToken?.expires
            ? Date.parse(_accessToken.expires) > Date.now()
            : false;
        return isValidToken;
    },
});
/*
  ---------------
  Async fetchers and setters
  ---------------
*/
/*
  Customer: ACTIVATE, LOGIN, GET, CREATE, UPDATE
*/
const fetchCustomerActivate = (0, recoil_1.selectorFamily)({
    key: 'customer/active',
    get: (activateDetails) => async ({ get }) => {
        const country = get(store_1.shopStore.country);
        return client.activate({
            ...activateDetails,
            country: country?.isoCode,
        });
    },
});
const fetchCustomerGet = (0, recoil_1.selectorFamily)({
    key: 'customer/get',
    get: ({ accessToken: passedToken, forceUpdate = false }) => async ({ get }) => {
        const _customer = get(customer);
        const _accessToken = get(accessToken);
        const country = get(store_1.shopStore.country);
        if (passedToken || forceUpdate) {
            return client.get({
                accessToken: passedToken || _accessToken,
                country: country?.isoCode,
            });
        }
        return Promise.resolve(_customer);
    },
});
const fetchCustomerLogin = (0, recoil_1.selectorFamily)({
    key: 'customer/login',
    get: (loginDetails) => async ({ get }) => {
        const country = get(store_1.shopStore.country);
        return client.login({
            ...loginDetails,
            country: country?.isoCode,
        });
    },
});
const fetchCustomerCreate = (0, recoil_1.selectorFamily)({
    key: 'customer/create',
    get: (newCustomerData) => async ({ get }) => {
        const country = get(store_1.shopStore.country);
        return client.create({
            ...newCustomerData,
            country: country?.isoCode,
        });
    },
});
const fetchCustomerUpdate = (0, recoil_1.selectorFamily)({
    key: 'customer/update',
    get: ({ accessToken: passedToken, customer: updatedCustomer }) => async ({ get }) => {
        const _accessToken = get(accessToken);
        const country = get(store_1.shopStore.country);
        return client.update({
            accessToken: passedToken || _accessToken,
            customer: updatedCustomer,
            country: country?.isoCode,
        });
    },
});
const fetchCustomerOrder = (0, recoil_1.selectorFamily)({
    key: 'customer/fetchCustomerOrder',
    get: ({ orderNumber = null, id = null }) => async ({ get }) => {
        const _accessToken = get(accessToken);
        const country = get(store_1.shopStore.country);
        const { error, data } = await client.order({
            orderNumber,
            id,
            accessToken: _accessToken,
            country: country?.isoCode,
        });
        if (error) {
            return {
                error,
                data: null,
            };
        }
        return {
            error: null,
            data,
        };
    },
});
const fetchCustomerMetafield = (0, recoil_1.selectorFamily)({
    key: 'customer/fetchCustomerMetafield',
    get: ({ namespace = null, key = null }) => async ({ get }) => {
        const _accessToken = get(accessToken);
        const country = get(store_1.shopStore.country);
        const { error, data } = await client.metafield({
            namespace,
            key,
            accessToken: _accessToken,
            country: country?.isoCode,
        });
        if (error) {
            return {
                error,
                data: null,
            };
        }
        return {
            error: null,
            data,
        };
    },
});
const fetchCustomerOrders = (0, recoil_1.selectorFamily)({
    key: 'customer/fetchCustomerOrders',
    get: ({ page = 1, perPage = 4 }) => async ({ get }) => {
        const _accessToken = get(accessToken);
        const country = get(store_1.shopStore.country);
        const _cursor = get(customerOrdersCursor(page));
        const _prevCursor = get(customerOrdersCursor(page > 2 ? page - 1 : 1));
        const _action = get(customerOrdersAction);
        const fetchPage = async ({ page: _page, perPage: _perPage }) => {
            const pageInfo = {
                accessToken: _accessToken.token,
                country: country?.isoCode,
            };
            const isFirst = _page === 1;
            const isNext = _action === 'next';
            const isPrev = _action === 'previous';
            switch (true) {
                case isFirst: {
                    pageInfo.first = _perPage;
                    break;
                }
                case isNext: {
                    if (_prevCursor.after) {
                        pageInfo.after = _prevCursor.after;
                    }
                    pageInfo.first = _perPage;
                    break;
                }
                case isPrev: {
                    pageInfo.last = _perPage;
                    pageInfo.before = _cursor.before;
                    break;
                }
                default:
                    pageInfo.first = _perPage;
                    break;
            }
            const { error, data } = await client.orders(pageInfo);
            if (error) {
                return {
                    error,
                    data: {
                        orders: null,
                        ...pageInfo,
                    },
                };
            }
            // good
            return {
                error: null,
                data,
            };
        };
        return fetchPage({ page, perPage });
    },
});
/*
  Address: CREATE, DELETE, UPDATE
*/
const fetchAddresses = (0, recoil_1.selectorFamily)({
    key: 'customer/addresses',
    get: () => async ({ get }) => {
        const _accessToken = get(accessToken);
        const country = get(store_1.shopStore.country);
        return client.addresses({
            accessToken: _accessToken,
            country: country?.isoCode,
        });
    },
});
const fetchAddressCreate = (0, recoil_1.selectorFamily)({
    key: 'customer/addressCreate',
    get: (newAddressData) => async ({ get }) => {
        const _accessToken = get(accessToken);
        const country = get(store_1.shopStore.country);
        return client.addressCreate({
            ...newAddressData,
            accessToken: _accessToken,
            country: country?.isoCode,
        });
    },
});
const fetchAddressDelete = (0, recoil_1.selectorFamily)({
    key: 'customer/addressDelete',
    get: ({ id, accessToken: passedToken }) => async ({ get }) => {
        const _accessToken = get(accessToken);
        const country = get(store_1.shopStore.country);
        return client.addressDelete({
            id,
            accessToken: passedToken || _accessToken,
            country: country?.isoCode,
        });
    },
});
const fetchAddressUpdate = (0, recoil_1.selectorFamily)({
    key: 'customer/addressUpdate',
    get: (addressUpdateData) => async ({ get }) => {
        const _accessToken = get(accessToken);
        const country = get(store_1.shopStore.country);
        return client.addressUpdate({
            ...addressUpdateData,
            accessToken: _accessToken,
            country: country?.isoCode,
        });
    },
});
/*
  Password: RESET, RECOVER
*/
const fetchPasswordReset = (0, recoil_1.selectorFamily)({
    key: 'customer/passwordReset',
    get: (resetData) => async ({ get }) => {
        const country = get(store_1.shopStore.country);
        return client.passwordReset({
            ...resetData,
            country: country?.isoCode,
        });
    },
});
const fetchPasswordRecover = (0, recoil_1.selectorFamily)({
    key: 'customer/passwordRecover',
    get: ({ email }) => async ({ get }) => {
        const country = get(store_1.shopStore.country);
        return client.passwordRecover({
            email,
            country: country?.isoCode,
        });
    },
});
exports.customerStore = {
    // status — new on v2
    customerStatusStarted,
    customerStatusFinished,
    customerStatusSuccess,
    customerStatusErrors,
    // Async fetchers and setters — new on v2
    fetchAddresses,
    fetchAddressCreate,
    fetchAddressDelete,
    fetchAddressUpdate,
    // actual state - atoms
    customerAddresses,
    customerInit,
    accessToken,
    customer,
    customerMetafield,
    customerOrder,
    customerOrders,
    customerOrdersPage,
    customerOrdersCursor,
    customerOrdersAction,
    authenticated,
    newCustomer,
    // getters
    isValidAccessToken$,
    customerDefaultAddress$,
    fetchCustomerActivate,
    fetchCustomerCreate,
    fetchCustomerGet,
    fetchCustomerLogin,
    fetchCustomerMetafield,
    fetchCustomerOrder,
    fetchCustomerOrders,
    fetchCustomerUpdate,
    fetchPasswordRecover,
    fetchPasswordReset,
};
//# sourceMappingURL=customer.js.map

/***/ }),

/***/ 747:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.customerStore = void 0;
var customer_1 = __webpack_require__(6029);
Object.defineProperty(exports, "customerStore", ({ enumerable: true, get: function () { return customer_1.customerStore; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 9025:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const logStateChange_1 = __webpack_require__(3645);
const onSetRedirectToCheckout_1 = __webpack_require__(9060);
const onSetUpdatePersistedKey_1 = __webpack_require__(5417);
const setSelfToPersistedKey_1 = __webpack_require__(5973);
const onChange_1 = __webpack_require__(4889);
const shared_1 = __webpack_require__(2065);
exports["default"] = {
    // shared utils
    SHOPIFY_NAME: shared_1.SHOPIFY_NAME,
    publishBusEvent: shared_1.publishBusEvent,
    publishGtmEvent: shared_1.publishGtmEvent,
    resolveTopicData: shared_1.resolveTopicData,
    routeToTemplate: shared_1.routeToTemplate,
    // effects
    logStateChange: logStateChange_1.logStateChange,
    onSetRedirectToCheckout: onSetRedirectToCheckout_1.onSetRedirectToCheckout,
    onSetUpdatePersistedKey: onSetUpdatePersistedKey_1.onSetUpdatePersistedKey,
    setSelfToPersistedKey: setSelfToPersistedKey_1.setSelfToPersistedKey,
    onChange: onChange_1.onChange,
};
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 3645:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.logStateChange = void 0;
const logStateChange = key => ({ onSet }) => {
    onSet((newValue, oldValue) => {
        console.groupCollapsed(`updated "${key}"`);
        console.log('is:\t\t', newValue);
        console.log('was:\t', oldValue);
        console.groupEnd();
        return newValue;
    });
};
exports.logStateChange = logStateChange;
//# sourceMappingURL=logStateChange.js.map

/***/ }),

/***/ 4889:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.onChange = void 0;
const shared_1 = __webpack_require__(2065);
const isBrowser = typeof window !== 'undefined';
// todo: we can use Router.page.data
const onChange = ({ topic: topicGroup, actions: passedActions }) => ({ onSet }) => {
    onSet((newValue, oldValue) => {
        if (!isBrowser)
            return newValue;
        if (!topicGroup)
            return newValue;
        if (!passedActions)
            return newValue;
        if (!newValue && !oldValue)
            return newValue;
        let actions = passedActions;
        if (!Array.isArray(passedActions)) {
            if (typeof passedActions === 'string') {
                actions = [passedActions];
            }
            else {
                console.warn('Invalid onChange actions provided. "actions" must be an array or a string', passedActions);
                return newValue;
            }
        }
        // converts a generic topic e.g CART_UPDATE to a more specific action if applicable
        try {
            const [topic, topicData] = (0, shared_1.resolveTopicData)(topicGroup, newValue, oldValue);
            if (!topic) {
                console.warn(`Could not determine topic for ${topicGroup}`);
                return newValue;
            }
            if (typeof topicData === 'undefined') {
                console.error(`No ${topic} topic data`);
                return newValue;
            }
            // perform each onChange action
            actions.forEach((action) => {
                switch (action) {
                    case 'publishGtmEvent': {
                        return (0, shared_1.publishGtmEvent)(topic, topicData);
                    }
                    case 'publishBusEvent': {
                        return (0, shared_1.publishBusEvent)(topic, topicData);
                    }
                    default:
                        console.warn(`Unsupported onChange action ${action}`);
                        return newValue;
                }
            });
            return newValue;
        }
        catch (error) {
            console.error(topicGroup, error.message);
            return newValue;
        }
    });
};
exports.onChange = onChange;
//# sourceMappingURL=onChange.js.map

/***/ }),

/***/ 9060:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.onSetRedirectToCheckout = void 0;
const onSetRedirectToCheckout = () => ({ onSet }) => {
    onSet((newValue, oldValue) => {
        if (!newValue?.redirect)
            return; // In case user wants to manually redirect
        // redirect to either multipass or regular checkout
        window.location.href = newValue.url;
        return newValue;
    });
};
exports.onSetRedirectToCheckout = onSetRedirectToCheckout;
//# sourceMappingURL=onSetRedirectToCheckout.js.map

/***/ }),

/***/ 5417:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.onSetUpdatePersistedKey = void 0;
/* eslint-disable max-lines */
const shared_1 = __webpack_require__(2065);
const onSetUpdatePersistedKey = (key) => ({ onSet }) => {
    onSet((newValue) => {
        let safeNewValue = newValue;
        switch (key) {
            case `CustomerToken|${shared_1.SHOPIFY_NAME}`: {
                // if somehow, we have an invalid token in state, we don't persist it.
                if (!newValue?.token || !newValue?.expires) {
                    safeNewValue = null;
                }
                break;
            }
            case `Cart|${shared_1.SHOPIFY_NAME}`: {
                // if somehow, we have an invalid cart in state, we skip the update to persist it.
                if (!newValue?.id) {
                    safeNewValue = null;
                }
                break;
            }
            default:
                break;
        }
        // eslint-disable-next-line no-undef
        window.localStorage.setItem(key, JSON.stringify(safeNewValue));
        return safeNewValue;
    });
};
exports.onSetUpdatePersistedKey = onSetUpdatePersistedKey;
//# sourceMappingURL=onSetUpdatePersistedKey.js.map

/***/ }),

/***/ 5973:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setSelfToPersistedKey = void 0;
const shared_1 = __webpack_require__(2065);
const isBrowser = typeof window !== 'undefined';
const setSelfToPersistedKey = (key, cachedKey, topic) => ({ setSelf }) => {
    setSelf(() => {
        if (!isBrowser)
            return null;
        try {
            let cachedJsonValue = JSON.parse(window.localStorage.getItem(cachedKey));
            const isValidAccessToken = !!cachedJsonValue?.expires &&
                Date.parse(cachedJsonValue.expires) > Date.now();
            switch (key) {
                case 'accessToken': {
                    if (cachedJsonValue && cachedJsonValue?.expires) {
                        if (!isValidAccessToken) {
                            console.log('Token is expired deleting..');
                            window.localStorage.setItem(cachedKey, null);
                            cachedJsonValue = null;
                        }
                    }
                    break;
                }
                case 'cart': {
                    if (cachedJsonValue && cachedJsonValue?.completedAt) {
                        if (!isValidAccessToken) {
                            console.log('Cart completed at deleting..');
                            window.localStorage.setItem(cachedKey, null);
                            cachedJsonValue = null;
                        }
                    }
                    break;
                }
                case 'country': {
                    if (cachedJsonValue && !cachedJsonValue?.isoCode) {
                        console.log('Invalid cached country object resetting..');
                        window.localStorage.setItem(cachedKey, null);
                        cachedJsonValue = null;
                    }
                    break;
                }
                default:
                    break;
            }
            // console.log('Setting initial', `"${key}"`, 'to', cachedJsonValue)
            if (topic && cachedJsonValue)
                (0, shared_1.publishBusEvent)(topic, cachedJsonValue);
            return cachedJsonValue;
        }
        catch (error) {
            console.error('setSelfToPersistedKey: Could not set initial persisted values for', key, error.message);
            return null;
        }
    });
};
exports.setSelfToPersistedKey = setSelfToPersistedKey;
//# sourceMappingURL=setSelfToPersistedKey.js.map

/***/ }),

/***/ 2065:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.resolveTopicData = exports.resolveCartTopics = exports.resolveCustomerTopics = exports.resolveViewRouteTopics = exports.routeToTemplate = exports.publishGtmEvent = exports.publishBusEvent = exports.SHOPIFY_NAME = void 0;
const tslib_1 = __webpack_require__(5556);
/* eslint-disable max-lines */
const router_1 = tslib_1.__importDefault(__webpack_require__(6677));
const pubsub_js_1 = tslib_1.__importDefault(__webpack_require__(7651));
const isBrowser = typeof window !== 'undefined';
exports.SHOPIFY_NAME = "clearly-filtered.myshopify.com"?.split('.')[0] || '';
// Publish to EventBus
// eslint-disable-next-line consistent-return
const publishBusEvent = (topic, data) => {
    if (typeof topic === 'undefined') {
        console.warn(`No topic was provided for Bus event`);
        return null;
    }
    if (typeof data === 'undefined') {
        console.warn(`No data was provided for ${topic} Bus event`);
        return null;
    }
    pubsub_js_1.default.publish(topic, data);
};
exports.publishBusEvent = publishBusEvent;
const publishGtmEvent = (topic, gtmData) => {
    if (!isBrowser)
        return null;
    if (typeof topic === 'undefined') {
        console.warn(`No topic was provided for GTM event`);
        return null;
    }
    if (typeof gtmData === 'undefined') {
        console.warn(`No data was provided for ${topic} GTM event`);
        return null;
    }
    // eslint-disable-next-line no-undef
    if (!window?.dataLayer) {
        // console.warn(`An initialized dataLayer is required before publishing GTM ${topic} events`);
        return false;
    }
    // add event to GTM
    // eslint-disable-next-line no-undef
    window.dataLayer.push({
        event: topic,
        data: gtmData,
    });
    return true;
};
exports.publishGtmEvent = publishGtmEvent;
const routeToTemplate = ({ route }) => [
    {
        path: '/',
        name: 'isHome',
    },
    {
        path: '/account',
        name: 'isAccount',
    },
    {
        path: '/cart',
        name: 'isCart',
    },
    {
        path: '/collections/',
        name: 'isCollection',
    },
    {
        path: '/pages/',
        name: 'isPage',
    },
    {
        path: '/products/',
        name: 'isProduct',
    },
    {
        path: '/blogs/',
        name: 'isBlog',
    },
    {
        path: '/articles/',
        name: 'isArticle',
    },
    {
        path: '/404',
        name: 'is404',
    },
].reduce((templates, template) => {
    const _templates = templates;
    // check for home
    if (template.path === '/') {
        _templates[template.name] = route === template.path;
    }
    else {
        // non home routes
        const isValidPath = route.includes(template.path);
        _templates[template.name] = !!isValidPath;
    }
    return _templates;
}, {
    // initial templates
    isAccount: false,
    isArticle: false,
    isBlog: false,
    isCart: false,
    isCollection: false,
    isHome: false,
    isPage: false,
    isProduct: false,
    is404: false,
});
exports.routeToTemplate = routeToTemplate;
const resolveViewRouteTopics = (route) => {
    try {
        const template = (0, exports.routeToTemplate)({ route });
        const { isAccount, isArticle, isBlog, isCart, isCollection, isHome, isPage, isProduct, is404, } = template;
        const routeProps = router_1.default?.router?.components?.[router_1.default.route]?.props?.pageProps || null;
        switch (true) {
            case isAccount:
                return ['VIEW_ACCOUNT', route];
            case isArticle:
                return ['VIEW_ARTICLE', routeProps?.article || route];
            case isBlog:
                return ['VIEW_BLOG', routeProps?.blog || route];
            case isCart:
                return ['VIEW_CART', route];
            case isCollection: {
                const collectionFirst100products = {
                    ...routeProps?.collection,
                    products: routeProps?.collection?.products?.slice(0, 100),
                };
                return ['VIEW_COLLECTION', collectionFirst100products || route];
            }
            case isHome:
                return ['VIEW_HOME', routeProps?.page || route];
            case isPage:
                return ['VIEW_PAGE', routeProps?.page || route];
            case isProduct:
                return ['VIEW_PRODUCT', routeProps?.product || route];
            case is404:
                return ['VIEW_404', routeProps?.page || route];
            default:
                return ['VIEW_OTHER', route];
        }
    }
    catch (error) {
        console.error('resolveViewRouteTopics failed due to', error.message);
        return ['ROUTE_UPDATE', null];
    }
};
exports.resolveViewRouteTopics = resolveViewRouteTopics;
const resolveVariantTopics = (topic, currentVariant) => {
    const variantIsAvailable = currentVariant &&
        (currentVariant?.inventoryPolicy === 'CONTINUE' ||
            currentVariant?.inventoryQuantity > 0);
    if (variantIsAvailable) {
        if (currentVariant.inventoryPolicy === 'CONTINUE') {
            return ['SELECTED_VARIANT_AVAILABLE_CONTINUE', currentVariant];
        }
        return ['SELECTED_VARIANT_AVAILABLE', currentVariant];
    }
    if (!variantIsAvailable) {
        return ['SELECTED_VARIANT_SOLDOUT', currentVariant];
    }
    return [topic, currentVariant];
};
// eslint-disable-next-line consistent-return
const resolveCustomerTopics = (customer, prevCustomer) => {
    if (prevCustomer && customer) {
        return ['CUSTOMER_LOGIN', customer];
    }
    if (!prevCustomer && customer) {
        return ['CUSTOMER_LOGIN', customer];
    }
    if (prevCustomer && !customer) {
        return ['CUSTOMER_LOGOUT', prevCustomer];
    }
    return [];
};
exports.resolveCustomerTopics = resolveCustomerTopics;
const getTotalItems = (items) => items?.length
    ? items.reduce((total, { quantity }) => total + quantity, 0)
    : 0;
const resolveCartTopics = (topic, cart, prevCart) => {
    try {
        const lineItems = cart?.lines?.length;
        const lineItemsPrev = prevCart?.lines?.length || 0;
        const totalItems = getTotalItems(cart?.lines);
        const totalItemsPrev = getTotalItems(prevCart?.lines) || 0;
        const discounts = cart?.discountApplications?.length;
        const discountsPrev = prevCart?.discountApplications?.length;
        const createdAt = cart?.createdAt ? new Date(cart.createdAt) : null;
        const updatedAt = cart?.updatedAt ? new Date(cart.updatedAt) : null;
        const completedAt = cart?.completedAt ? new Date(cart.completedAt) : null;
        if (lineItems > lineItemsPrev) {
            // diff between both lineItemLists
            const addedItem = cart.lines?.filter(({ id: id1 }) => !prevCart?.lines?.some(({ id: id2 }) => id2 === id1));
            return ['CART_ADD_ITEM', addedItem];
        }
        if (lineItems < lineItemsPrev) {
            const removedItem = prevCart?.lines?.length
                ? prevCart.lines.filter(({ id: id1 }) => !cart.lines?.some(({ id: id2 }) => id2 === id1))
                : null;
            if (totalItemsPrev > 1 && totalItems === 0) {
                return ['CART_CLEARED', prevCart];
            }
            return ['CART_REMOVE_ITEM', removedItem];
        }
        if (totalItems !== totalItemsPrev) {
            if (totalItems > totalItemsPrev) {
                const modifiedItem = cart.lines?.filter(({ id: id1, quantity: qty1 }) => !prevCart?.lines?.some(({ id: id2, quantity: qty2 }) => id2 === id1 && qty1 === qty2));
                return ['CART_INCREASE_ITEM_QUANTITY', modifiedItem];
            }
            const modifiedItem = prevCart.lines?.filter(({ id: id1, quantity: qty1 }) => !cart?.lines?.some(({ id: id2, quantity: qty2 }) => id2 === id1 && qty1 === qty2));
            return ['CART_REDUCE_ITEM_QUANTITY', modifiedItem];
        }
        // Discounts
        if (discountsPrev < discounts) {
            // eslint-disable-next-line no-undef
            if (window?.location?.href?.includes('discountCode=')) {
                return ['CART_ADD_DISCOUNT_URL', cart?.discountApplications?.[0]?.code];
            }
            return ['CART_ADD_DISCOUNT', cart?.discountApplications?.[0]?.code];
        }
        if (discountsPrev > discounts) {
            return [
                'CART_REMOVE_DISCOUNT',
                prevCart?.discountApplications?.[0]?.code,
            ];
        }
        // notes
        if (cart?.note !== prevCart?.note) {
            if (prevCart?.note === null && cart.note) {
                return ['CART_ADD_NOTE', cart?.note];
            }
            if (prevCart?.note !== cart.note) {
                return ['CART_UPDATED_NOTE', cart?.note];
            }
            if (cart?.note === null && prevCart.note) {
                return ['CART_REMOVED_NOTE', cart?.note];
            }
        }
        if (completedAt) {
            return ['CART_PURCHASED', cart];
        }
        if (updatedAt > createdAt && totalItems) {
            return ['CART_UPDATED', cart];
        }
        if (!prevCart && cart) {
            return ['CART_CREATE', cart];
        }
        return ['CART_READY', cart];
    }
    catch (error) {
        console.error('resolveCartTopics failed due to:', error.message);
        return [null, null];
    }
};
exports.resolveCartTopics = resolveCartTopics;
// eslint-disable-next-line consistent-return
const resolveTopicData = (topicGroup, newValue, oldValue) => {
    try {
        switch (true) {
            case ['ROUTE_UPDATE'].includes(topicGroup): {
                return (0, exports.resolveViewRouteTopics)(newValue, oldValue);
            }
            case ['CUSTOMER_INIT'].includes(topicGroup): {
                return ['CUSTOMER_INIT', newValue];
            }
            case ['CUSTOMER_UPDATE'].includes(topicGroup): {
                return (0, exports.resolveCustomerTopics)(newValue, oldValue);
            }
            case ['CART_UPDATE'].includes(topicGroup): {
                return (0, exports.resolveCartTopics)(topicGroup, newValue, oldValue);
            }
            case ['COUNTRY_UPDATE'].includes(topicGroup): {
                return ['COUNTRY_UPDATE', newValue];
            }
            case ['VARIANT_UPDATE'].includes(topicGroup): {
                return resolveVariantTopics(topicGroup, newValue, oldValue);
            }
            case ['CHECKOUT'].includes(topicGroup): {
                return ['CHECKOUT', newValue];
            }
            case ['CUSTOMER_REGISTERED'].includes(topicGroup): {
                return ['CUSTOMER_REGISTERED', newValue];
            }
            default: {
                return [topicGroup, newValue];
            }
        }
    }
    catch (error) {
        console.error('resolveTopicData failed due', error.message);
    }
};
exports.resolveTopicData = resolveTopicData;
//# sourceMappingURL=shared.js.map

/***/ }),

/***/ 2667:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Localize = void 0;
const tslib_1 = __webpack_require__(5556);
/* eslint-disable no-undef */
/* eslint-disable class-methods-use-this */
const isomorphic_fetch_1 = tslib_1.__importDefault(__webpack_require__(4447));
const defaultProps = { country: 'US', currency: 'USD' };
class Localize {
    constructor({ country, currency } = defaultProps) {
        this.country = country;
        this.currency = currency;
    }
    /**
     * fetch a country's locale (extended info) by currencyCode or countryCode
     */
    async fetchLocale({ countryCode, currencyCode }) {
        if (!currencyCode && !countryCode) {
            throw new Error('"currencyCode" or "countryCode" must be provided');
        }
        const isDev = "production" !== 'production';
        const server = isDev ? 'http://localhost:8080' : "https://clearlyfiltered.com";
        const endpoint = `${server}/api/shopify/locale`;
        const localeRequest = await (0, isomorphic_fetch_1.default)(endpoint, {
            method: 'POST',
            body: JSON.stringify({ countryCode, currencyCode }),
        });
        const { response } = await localeRequest.json();
        const { locale } = response;
        return locale;
    }
    localize({ amount, locale }) {
        const localeOptions = {
            style: 'currency',
            currency: locale.currency || this.currency,
        };
        const localizedAmount = new Intl.NumberFormat(locale.defaultLocale, localeOptions).format(amount);
        return localizedAmount.replace(/\.00$/, '');
    }
    /**
     * Add locale info to the cart, and localizes estimatedCosts and line prices for the current country
     * @param {*} param0
     * @returns
     */
    cartTotals({ cart, locale }) {
        const { discountAmount, totalSavingsAmount, totalDiscountAmount, totalCompareAtAmount, } = this.cartCombinedTotals({
            lines: cart.lines,
            locale,
        });
        const estimatedCost = this.estimatedCost({
            estimatedCost: cart.estimatedCost,
            locale,
            discountAmount,
            totalDiscountAmount,
            totalSavingsAmount,
            totalCompareAtAmount,
        });
        return { ...cart, locale, estimatedCost };
    }
    // estimate the total discount amount from, discount codes + subscriptions
    cartCombinedTotals({ lines, locale }) {
        let discountAmount = null; // custom
        let totalDiscountAmount = null; // custom
        let totalSavingsAmount = null; // custom
        let totalCompareAtAmount = null; // custom
        // get combined savings, discounts and compareAt (full price)
        // from all line items so we can display the full breakdown
        const combinedDefault = {
            combinedSavings: 0,
            combinedDiscount: 0,
            combinedDiscountTotal: 0,
            combineCompareAt: 0,
        };
        const itemTotals = (_total, line) => {
            const localizedLine = this.cartLine({ line, locale });
            // subscription discounts
            const savingsAmount = localizedLine?.estimatedCost?.savingsAmount;
            const lineDiscount = localizedLine?.estimatedCost?.discountAmount;
            const compareAtPriceAmount = localizedLine?.estimatedCost?.compareAtPriceAmount;
            const lineTotal = { ..._total };
            if (savingsAmount) {
                lineTotal.combinedSavings += savingsAmount.amountTotal;
            }
            if (lineDiscount) {
                lineTotal.combinedDiscount += lineDiscount.amountTotal;
            }
            if (compareAtPriceAmount) {
                lineTotal.combineCompareAt += compareAtPriceAmount.amountTotal;
            }
            // used as Discounted Total when theres discounts as subTotal does not include discount deductions
            lineTotal.combinedDiscountTotal +=
                localizedLine?.estimatedCost.totalAmount.amount;
            return lineTotal;
        };
        const { combinedSavings, combinedDiscountTotal, combinedDiscount, combineCompareAt, } = lines.reduce(itemTotals, combinedDefault);
        if (combinedSavings) {
            totalSavingsAmount = {
                amount: combinedSavings,
                currencyCode: locale.currency,
                locale: this.localize({ amount: combinedSavings, locale }),
            };
        }
        if (combinedDiscount) {
            discountAmount = {
                amount: combinedDiscount,
                currencyCode: locale.currency,
                locale: this.localize({ amount: combinedDiscount, locale }),
            };
        }
        if (combinedDiscountTotal) {
            totalDiscountAmount = {
                amount: combinedDiscountTotal,
                currencyCode: locale.currency,
                locale: this.localize({ amount: combinedDiscountTotal, locale }),
            };
        }
        if (combineCompareAt) {
            totalCompareAtAmount = {
                amount: combineCompareAt,
                currencyCode: locale.currency,
                locale: this.localize({ amount: combineCompareAt, locale }),
            };
        }
        return {
            discountAmount,
            totalDiscountAmount,
            totalSavingsAmount,
            totalCompareAtAmount,
        };
    }
    /**
     * Adds locale, compareAt and priceV2 locale pricing to a variant
     */
    cartLine({ line, locale }) {
        try {
            const variant = { ...line.variant, locale };
            let compareAtPriceAmount = null; // the full price before (sale)
            // localize cart line discountAllocations
            const { discountAllocations, discountAmount } = this.cartLineDiscountAllocations({
                discountAllocations: [...line.discountAllocations],
                quantity: line.quantity,
                locale,
            });
            // localize cartLine variant
            // localize priceV2
            const priceV2amount = parseFloat(variant.priceV2.amount);
            const priceV2amountTotal = priceV2amount * line.quantity;
            variant.priceV2 = {
                ...variant.priceV2,
                amount: priceV2amount,
                amountTotal: priceV2amountTotal,
                locale: this.localize({ amount: priceV2amount, locale }),
                localeTotal: this.localize({ amount: priceV2amountTotal, locale }),
            };
            compareAtPriceAmount = variant.priceV2;
            // // localize compareAtPriceV2
            if (variant?.compareAtPriceV2) {
                const compareAtPriceV2amount = parseFloat(variant.compareAtPriceV2.amount);
                const compareAtPriceV2amountTotal = compareAtPriceV2amount * line.quantity;
                variant.compareAtPriceV2 = {
                    ...variant.compareAtPriceV2,
                    amount: compareAtPriceV2amount,
                    amountTotal: compareAtPriceV2amountTotal,
                    locale: this.localize({ amount: compareAtPriceV2amount, locale }),
                    localeTotal: this.localize({
                        amount: compareAtPriceV2amountTotal,
                        locale,
                    }),
                };
                compareAtPriceAmount = variant.compareAtPriceV2;
            }
            // // localize compareAtPriceV2
            if (variant?.unitPrice) {
                const unitPriceAmount = parseFloat(variant.unitPrice.amount);
                const unitPriceAmountTotal = unitPriceAmount * line.quantity;
                variant.unitPrice = {
                    ...variant.unitPrice,
                    amount: unitPriceAmount,
                    amountTotal: unitPriceAmountTotal,
                    locale: this.localize({ amount: unitPriceAmount, locale }),
                    localeTotal: this.localize({
                        amount: unitPriceAmountTotal,
                        locale,
                    }),
                };
            }
            // // localize discountAtPrice
            if (variant?.discountAtPrice) {
                const discountAtPriceAmount = parseFloat(variant.discountAtPrice.amount);
                const discountAtPriceAmountTotal = discountAtPriceAmount * line.quantity;
                variant.discountAtPrice = {
                    ...variant.discountAtPrice,
                    amount: discountAtPriceAmount,
                    amountTotal: discountAtPriceAmountTotal,
                    locale: this.localize({
                        amount: discountAtPriceAmount,
                        locale,
                    }),
                    localeTotal: this.localize({
                        amount: discountAtPriceAmountTotal,
                        locale,
                    }),
                };
            }
            // maybe localize selling plan allocation for the line item
            let { sellingPlanAllocation } = line;
            if (sellingPlanAllocation) {
                sellingPlanAllocation = this.cartLineSellingPlanAllocation({
                    sellingPlanAllocation: { ...line.sellingPlanAllocation },
                    locale,
                    quantity: line.quantity,
                });
            }
            // if subscription, we use the sellingPlanAllocation savings else,
            // we use the variant compareAt and priceV2amount to estimate the savings
            let savingsAmount = null;
            const isSubscription = sellingPlanAllocation;
            if (isSubscription) {
                savingsAmount = sellingPlanAllocation.priceAdjustments[0].savingsAmount;
                // we overwrite this use the one from subscription
                compareAtPriceAmount =
                    sellingPlanAllocation.priceAdjustments[0].compareAtPrice;
            }
            else if (variant.compareAtPriceV2) {
                // one-time item
                const savingAmount = variant.compareAtPriceV2.amount - variant.priceV2.amount;
                const savingAmountTotal = variant.compareAtPriceV2.amountTotal - variant.priceV2.amountTotal;
                savingsAmount = savingAmount
                    ? {
                        amount: parseFloat(savingAmount.toFixed(2)),
                        amountTotal: parseFloat(savingAmountTotal.toFixed(2)),
                        currencyCode: locale.currency,
                        locale: this.localize({ amount: savingAmount, locale }),
                        localeTotal: this.localize({
                            amount: savingAmountTotal,
                            locale,
                        }),
                    }
                    : null;
            }
            // localize estimatedCost
            const estimatedCost = this.estimatedCost({
                estimatedCost: { ...line.estimatedCost },
                locale,
                discountAmount,
                savingsAmount,
                compareAtPriceAmount,
            });
            return {
                ...line,
                sellingPlanAllocation,
                estimatedCost,
                discountAllocations,
                variant,
                locale,
            };
        }
        catch (error) {
            console.error('cartLine:error', error);
            return line;
        }
    }
    /**
     * Adds locale, compareAt and priceV2 locale pricing to a variant
     */
    estimatedCost({ estimatedCost: cost, locale, discountAmount, // optional
    savingsAmount, // optional
    compareAtPriceAmount, // optional
    totalSavingsAmount, // optional
    totalDiscountAmount, // optional
    totalCompareAtAmount, // optional
     }) {
        const estimatedCost = { ...cost };
        // localize official fields
        if (cost?.subtotalAmount) {
            const subTotalAmount = parseFloat(cost.subtotalAmount.amount);
            estimatedCost.subtotalAmount = {
                ...estimatedCost.subtotalAmount,
                amount: subTotalAmount,
                locale: this.localize({ amount: subTotalAmount, locale }),
            };
        }
        if (cost?.totalAmount) {
            const totalAmount = parseFloat(cost.totalAmount.amount);
            estimatedCost.totalAmount = {
                ...estimatedCost.totalAmount,
                amount: totalAmount,
                locale: this.localize({ amount: totalAmount, locale }),
            };
        }
        if (cost?.totalDutyAmount) {
            const totalDutyAmount = parseFloat(cost.totalDutyAmount.amount);
            estimatedCost.totalDutyAmount = {
                ...estimatedCost.totalDutyAmount,
                amount: totalDutyAmount,
                locale: this.localize({ amount: totalDutyAmount, locale }),
            };
        }
        if (cost?.totalTaxAmount) {
            const totalTaxAmount = parseFloat(cost.totalTaxAmount.amount);
            estimatedCost.totalTaxAmount = {
                ...estimatedCost.totalTaxAmount,
                amount: totalTaxAmount,
                locale: this.localize({ amount: totalTaxAmount, locale }),
            };
        }
        // localize custom fields
        if (typeof discountAmount !== 'undefined') {
            estimatedCost.discountAmount = discountAmount;
        }
        if (typeof savingsAmount !== 'undefined') {
            estimatedCost.savingsAmount = savingsAmount;
        }
        if (typeof totalDiscountAmount !== 'undefined') {
            estimatedCost.totalDiscountAmount = totalDiscountAmount;
        }
        if (typeof totalSavingsAmount !== 'undefined') {
            estimatedCost.totalSavingsAmount = totalSavingsAmount;
        }
        if (typeof totalCompareAtAmount !== 'undefined') {
            estimatedCost.totalCompareAtAmount = totalCompareAtAmount;
        }
        if (compareAtPriceAmount) {
            estimatedCost.compareAtPriceAmount = compareAtPriceAmount;
        }
        return estimatedCost;
    }
    // Localize the line item's subscription pricing
    cartLineSellingPlanAllocation({ sellingPlanAllocation: _sellingPlanAllocation, locale, quantity, }) {
        const { priceAdjustments: _priceAdjustments, sellingPlan } = _sellingPlanAllocation;
        // localize each selling plan price adjustment for the given line item
        /**
          A list of price adjustments, with a maximum of two. When there are two
          the first price adjustment goes into effect at the time of purchase,
          while the second one starts after a certain number of orders
         */
        const priceAdjustments = _priceAdjustments?.map(({ compareAtPrice, perDeliveryPrice, price, unitPrice }) => {
            const localized = {};
            /**
              The price of the variant when it's purchased without a selling plan for the same number of deliveries.
              For example, if a customer purchases 6 deliveries of $10.00 granola separately, then the price is 6 x $10.00 = $60.00.
             */
            if (compareAtPrice) {
                localized.compareAtPrice = { ...compareAtPrice };
                const compareAtPriceAmount = parseFloat(compareAtPrice.amount);
                const compareAtPriceAmountTotal = compareAtPriceAmount * quantity;
                localized.compareAtPrice.amount = compareAtPriceAmount;
                localized.compareAtPrice.amountTotal = compareAtPriceAmountTotal;
                localized.compareAtPrice.locale = this.localize({
                    amount: compareAtPriceAmount,
                    locale,
                });
                localized.compareAtPrice.localeTotal = this.localize({
                    amount: compareAtPriceAmountTotal,
                    locale,
                });
            }
            /**
              The effective price for a single delivery. For example, for a prepaid subscription plan that
              includes 6 deliveries at the price of $48.00, the per delivery price is $8.00.
             */
            if (perDeliveryPrice) {
                localized.perDeliveryPrice = { ...perDeliveryPrice };
                const perDeliveryPriceAmount = parseFloat(perDeliveryPrice.amount);
                const perDeliveryPriceAmountTotal = perDeliveryPriceAmount * quantity;
                localized.perDeliveryPrice.amount = perDeliveryPriceAmount;
                localized.perDeliveryPrice.amountTotal = perDeliveryPriceAmountTotal;
                localized.perDeliveryPrice.locale = this.localize({
                    amount: perDeliveryPriceAmount,
                    locale,
                });
                localized.perDeliveryPrice.localeTotal = this.localize({
                    amount: perDeliveryPriceAmountTotal,
                    locale,
                });
            }
            /**
              The price of the variant when it's purchased with a selling plan For example, for a prepaid subscription plan
              that includes 6 deliveries of $10.00 granola, where the customer gets 20% off, the price is 6 x $10.00 x 0.80 = $48.00.
             */
            if (price) {
                localized.price = { ...price };
                const priceAmount = parseFloat(price.amount);
                const priceAmountTotal = priceAmount * quantity;
                localized.price.amount = priceAmount;
                localized.price.amountTotal = priceAmountTotal;
                localized.price.locale = this.localize({
                    amount: priceAmount,
                    locale,
                });
                localized.price.localeTotal = this.localize({
                    amount: priceAmountTotal,
                    locale,
                });
            }
            /**
              The resulting price per unit for the variant associated with the selling plan.
              If the variant isn't sold by quantity or measurement, then this field returns null.
             */
            if (unitPrice) {
                localized.unitPrice = { ...unitPrice };
                const unitPriceAmount = parseFloat(unitPrice.amount);
                const unitPriceAmountTotal = unitPriceAmount * quantity;
                localized.unitPrice.amount = unitPriceAmount;
                localized.unitPrice.amountTotal = unitPriceAmountTotal;
                localized.unitPrice.locale = this.localize({
                    amount: unitPriceAmount,
                    locale,
                });
                localized.unitPrice.localeTotal = this.localize({
                    amount: unitPriceAmountTotal,
                    locale,
                });
            }
            /**
              A custom property we add to calculate the discount amount applied by the subscription
             */
            const savingsAmount = localized.compareAtPrice.amount - localized.price.amount;
            const savingsAmountTotal = localized.compareAtPrice.amountTotal - localized.price.amountTotal;
            localized.savingsAmount = savingsAmount
                ? {
                    amount: parseFloat(savingsAmount.toFixed(2)),
                    amountTotal: parseFloat(savingsAmountTotal.toFixed(2)),
                    currencyCode: localized.compareAtPrice.currencyCode,
                    locale: this.localize({
                        amount: savingsAmount,
                        locale,
                    }),
                    localeTotal: this.localize({
                        amount: savingsAmountTotal,
                        locale,
                    }),
                }
                : null;
            return localized;
        });
        return { priceAdjustments, sellingPlan };
    }
    cartLineDiscountAllocations({ discountAllocations: _discountAllocations, quantity, locale, }) {
        let discountAmount = null; // the amount discounted
        const discountAllocations = [..._discountAllocations].map(({ discountedAmount: _discountAmount }) => {
            const amount = parseFloat(_discountAmount.amount);
            const amountTotal = amount * quantity;
            discountAmount = {
                ..._discountAmount,
                amount,
                amountTotal,
                locale: this.localize({ amount, locale }),
                localeTotal: this.localize({ amount: amountTotal, locale }),
            };
            return { discountAmount };
        });
        return { discountAllocations, discountAmount };
    }
    /**
     * Adds locale, locale min and max pricing to the product and compareAt and priceV2 locale pricing to its variants
     */
    product({ product: rawProduct, locale }) {
        const product = { ...rawProduct, locale };
        product.priceRange.maxVariantPrice.locale = this.localize({
            amount: product.priceRange.maxVariantPrice.amount,
            locale,
        });
        // localize minVariantPrice
        product.priceRange.minVariantPrice.locale = this.localize({
            amount: product.priceRange.minVariantPrice.amount,
            locale,
        });
        // localize variants
        product.variants = this.variants({
            variants: product.variants,
            locale,
        });
        return product;
    }
    /**
     * Localizes all product variants
     */
    variants({ variants = [], locale }) {
        return variants.map((variant) => {
            return this.variant({ variant, locale });
        });
    }
    /**
     * Adds locale, compareAt and priceV2 locale pricing to a variant
     */
    variant({ variant: rawVariant, locale }) {
        const variant = { ...rawVariant, locale };
        // localize the variant price
        let amount = parseFloat(variant.priceV2.amount);
        variant.priceV2 = {
            ...variant.priceV2,
            amount,
            locale: this.localize({ amount, locale }),
        };
        // localize the variant compareAtPriceV2
        if (variant?.compareAtPriceV2?.amount) {
            amount = parseFloat(variant.compareAtPriceV2.amount);
            variant.compareAtPriceV2 = {
                ...variant?.compareAtPriceV2,
                amount,
                locale: this.localize({ amount, locale }),
            };
        }
        // localize the variant sellingPlansAllocations
        if (variant?.sellingPlanAllocations?.length) {
            variant.sellingPlanAllocations = this.sellingPlanAllocations({
                sellingPlanAllocations: variant.sellingPlanAllocations,
                locale,
            });
        }
        return variant;
    }
    /**
     * Localize all selling plan allocations
     */
    sellingPlanAllocations({ sellingPlanAllocations: _sellingPlanAllocations = [], locale, }) {
        const sellingPlanAllocations = [..._sellingPlanAllocations];
        return sellingPlanAllocations.map((allocation) => {
            return this.sellingPlan({ allocation, locale });
        });
    }
    /**
     * Localize a single selling plan
     */
    sellingPlan({ allocation: _allocation, locale }) {
        const { priceAdjustments: _priceAdjustments, sellingPlan } = _allocation;
        // const adjustmentValue = sellingPlan?.priceAdjustments?.[0]?.adjustmentValue;
        // // A percentage amount that's deducted from the original variant price. For example, 10% off.
        // const percentageOff = adjustmentValue?.adjustmentPercentage || 0;
        // // A fixed price adjustment for a variant that's purchased with a selling plan.
        // const fixedPrice = adjustmentValue?.price?.amount || 0;
        // // A fixed amount that's deducted from the original variant price. For example, $10.00 off.
        // const amountOff = adjustmentValue?.adjustmentAmount?.amount || 0;
        const priceAdjustments = _priceAdjustments.map((adjustment) => {
            let { compareAtPrice, price, perDeliveryPrice, unitPrice } = adjustment;
            // localize selling plan compareAtPrice (Full price if no discount)
            if (compareAtPrice?.amount) {
                const amount = parseFloat(compareAtPrice.amount);
                compareAtPrice = {
                    ...compareAtPrice,
                    amount,
                    locale: this.localize({ amount, locale }),
                };
            }
            // localize selling plan price
            if (price?.amount) {
                const amount = parseFloat(price.amount);
                price = {
                    ...price,
                    amount,
                    locale: this.localize({ amount, locale }),
                };
            }
            // localize selling plan perDeliveryPrice
            if (perDeliveryPrice?.amount) {
                const amount = parseFloat(perDeliveryPrice.amount);
                perDeliveryPrice = {
                    ...perDeliveryPrice,
                    amount,
                    locale: this.localize({ amount, locale }),
                };
            }
            // localize selling plan unitPrice
            if (unitPrice?.amount) {
                const amount = parseFloat(unitPrice.amount);
                unitPrice = {
                    ...unitPrice,
                    amount,
                    locale: this.localize({ amount, locale }),
                };
            }
            return { compareAtPrice, price, perDeliveryPrice, unitPrice };
        });
        return { priceAdjustments, sellingPlan };
    }
    orderTotals({ order: rawOrder, locale }) {
        const order = { ...rawOrder, locale };
        // currents
        if (order?.currentTotalTax?.amount) {
            const amount = parseFloat(order.currentTotalTax.amount);
            order.currentTotalTax = {
                ...order?.currentTotalTax,
                amount,
                locale: this.localize({ amount, locale }),
            };
        }
        if (order?.currentTotalDuties?.amount) {
            const amount = parseFloat(order.currentTotalDuties.amount);
            order.currentTotalDuties = {
                ...order.currentTotalDuties,
                amount,
                locale: this.localize({ amount, locale }),
            };
        }
        if (order?.currentSubtotalPrice?.amount) {
            const amount = parseFloat(order.currentSubtotalPrice.amount);
            order.currentSubtotalPrice = {
                ...order.currentSubtotalPrice,
                amount,
                locale: this.localize({ amount, locale }),
            };
        }
        // totals
        if (order?.totalPriceV2?.amount) {
            const amount = parseFloat(order.totalPriceV2.amount);
            order.totalPriceV2 = {
                ...order.totalPriceV2,
                amount,
                locale: this.localize({ amount, locale }),
            };
        }
        if (order?.subtotalPriceV2?.amount) {
            const amount = parseFloat(order.subtotalPriceV2.amount);
            order.subtotalPriceV2 = {
                ...order.subtotalPriceV2,
                amount,
                locale: this.localize({ amount, locale }),
            };
        }
        if (order?.totalRefundedV2?.amount) {
            const amount = parseFloat(order.totalRefundedV2.amount);
            order.totalRefundedV2 = {
                ...order.totalRefundedV2,
                amount,
                locale: this.localize({ amount, locale }),
            };
        }
        if (order?.totalShippingPriceV2?.amount) {
            const amount = parseFloat(order.totalShippingPriceV2.amount);
            order.totalShippingPriceV2 = {
                ...order.totalShippingPriceV2,
                amount,
                locale: this.localize({ amount, locale }),
            };
        }
        if (order?.totalTaxV2?.amount) {
            const amount = parseFloat(order.totalTaxV2.amount);
            order.totalTaxV2 = {
                ...order.totalTaxV2,
                amount,
                locale: this.localize({ amount, locale }),
            };
        }
        return order;
    }
    orderLine({ line: rawLine, locale, currentLocale }) {
        const line = { ...rawLine, locale };
        // localize to order's original locale
        if (line?.originalTotalPrice?.amount) {
            const amount = parseFloat(line.originalTotalPrice.amount);
            line.originalTotalPrice = {
                ...line.originalTotalPrice,
                amount,
                locale: this.localize({
                    amount,
                    locale,
                }),
            };
        }
        // discounted line price
        let allocatedAmount = null;
        line.discountAllocations = line.discountAllocations.map(({ allocatedAmount: _allocatedAmount }) => {
            const amount = parseFloat(_allocatedAmount.amount);
            allocatedAmount = {
                ..._allocatedAmount,
                amount,
                locale: this.localize({
                    amount,
                    locale,
                }),
            };
            return { allocatedAmount };
        });
        line.discountAmount = allocatedAmount;
        // overwriting
        const discountedPriceAmount = allocatedAmount?.amount
            ? parseFloat(line.originalTotalPrice.amount) -
                parseFloat(line.discountAmount.amount)
            : line.originalTotalPrice.amount;
        line.discountedTotalPrice = {
            ...line.originalTotalPrice,
            amount: discountedPriceAmount,
            locale: this.localize({
                amount: discountedPriceAmount,
                locale,
            }),
        };
        // localize variants to current locale (not orders loale)
        line.variant = this.variant({
            variant: line.variant,
            locale: currentLocale,
        });
        return line;
    }
}
exports.Localize = Localize;
//# sourceMappingURL=Localize.js.map

/***/ }),

/***/ 1772:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.decodedId = void 0;
/**
 * Decodes a base64 encoded id to a string.
 *  Z2lkOi8vc2hvcGlmeS9Qcm9kdWN0VmFyaWFudC8zOTYzMDYzMzU5OTE2MA -> gid://shopify/ProductVariant/39630633599160
 * @param {*} id a base64 encodedId
 * @returns decoded if
 */
const decodedId = (id) => {
    try {
        if (!id)
            return null;
        return window.atob(id);
    }
    catch (error) {
        return id;
    }
};
exports.decodedId = decodedId;
//# sourceMappingURL=decodedId.js.map

/***/ }),

/***/ 2708:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getAddAction = void 0;
const tslib_1 = __webpack_require__(5556);
const lodash_isequal_1 = tslib_1.__importDefault(__webpack_require__(2004));
const getAddAction = ({ cart, data }) => {
    const sameVariantIdAndSellingPlan = ({ variant, sellingPlanAllocation }) => {
        // if the variant id is the same, and the selling plan is the same
        return (variant.id === data?.merchandiseId &&
            sellingPlanAllocation?.sellingPlan?.id === data?.sellingPlanId);
    };
    const mapAttributes = (attributesArray = []) => attributesArray.reduce((attrs, { key, value }) => {
        return { ...attrs, [key]: value };
    }, {});
    const itemInCart = cart.lines.find(sameVariantIdAndSellingPlan) || null;
    const itemInCartAttributes = itemInCart?.attributes
        ? mapAttributes(itemInCart.attributes)
        : {};
    const addingItemAttributes = data?.attributes
        ? mapAttributes(data.attributes)
        : {};
    const haveSameAttributes = itemInCart
        ? (0, lodash_isequal_1.default)(itemInCartAttributes, addingItemAttributes)
        : false;
    const attributes = data?.attributes?.length ? data.attributes : [];
    return { itemInCart, haveSameAttributes, attributes };
};
exports.getAddAction = getAddAction;
//# sourceMappingURL=getAddAction.js.map

/***/ }),

/***/ 5542:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Localize = exports.useRecoilStartFinishErrors = exports.useStartFinishErrors = exports.useMounted = exports.getAddAction = exports.decodedId = void 0;
var decodedId_1 = __webpack_require__(1772);
Object.defineProperty(exports, "decodedId", ({ enumerable: true, get: function () { return decodedId_1.decodedId; } }));
var getAddAction_1 = __webpack_require__(2708);
Object.defineProperty(exports, "getAddAction", ({ enumerable: true, get: function () { return getAddAction_1.getAddAction; } }));
var useMounted_1 = __webpack_require__(4180);
Object.defineProperty(exports, "useMounted", ({ enumerable: true, get: function () { return useMounted_1.useMounted; } }));
var useStartFinishErrors_1 = __webpack_require__(798);
Object.defineProperty(exports, "useStartFinishErrors", ({ enumerable: true, get: function () { return useStartFinishErrors_1.useStartFinishErrors; } }));
var useRecoilStartFinishErrors_1 = __webpack_require__(2574);
Object.defineProperty(exports, "useRecoilStartFinishErrors", ({ enumerable: true, get: function () { return useRecoilStartFinishErrors_1.useRecoilStartFinishErrors; } }));
var Localize_1 = __webpack_require__(2667);
Object.defineProperty(exports, "Localize", ({ enumerable: true, get: function () { return Localize_1.Localize; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 4180:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useMounted = void 0;
const react_1 = __webpack_require__(7378);
const useMounted = () => {
    const [isMounted, setIsMounted] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        let unmounting = false;
        if (!unmounting) {
            setIsMounted(true);
        }
        return () => {
            unmounting = true;
        };
    }, []);
    return isMounted;
};
exports.useMounted = useMounted;
//# sourceMappingURL=useMounted.js.map

/***/ }),

/***/ 2574:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useRecoilStartFinishErrors = void 0;
const tslib_1 = __webpack_require__(5556);
const react_1 = __webpack_require__(7378);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useRecoilStartFinishErrors = (options) => {
    const setCartStarted = (0, store_1.useSetRecoilState)(store_1.default.cartStatusStarted('cart/all'));
    const setCartFinished = (0, store_1.useSetRecoilState)(store_1.default.cartStatusFinished('cart/all'));
    const setCartSuccess = (0, store_1.useSetRecoilState)(store_1.default.cartStatusSuccess('cart/all'));
    const setCartErrors = (0, store_1.useSetRecoilState)(store_1.default.cartStatusErrors('cart/all'));
    const isCartId = /^cart/.test(options?.id);
    const [started, setStarted] = (0, store_1.useRecoilState)(store_1.default.cartStatusStarted(options?.id || ''));
    const [finished, setFinished] = (0, store_1.useRecoilState)(store_1.default.cartStatusFinished(options?.id || ''));
    const [success, setSuccess] = (0, store_1.useRecoilState)(store_1.default.cartStatusSuccess(options?.id || ''));
    const [errors, setErrors] = (0, store_1.useRecoilState)(store_1.default.cartStatusErrors(options?.id || ''));
    const autoReset = (0, react_1.useRef)(options?.autoReset || 0);
    const resetTimer = (0, react_1.useRef)(options?.resetTimer || null);
    // update local hook status
    const reset = (0, react_1.useCallback)(() => {
        if (typeof setErrors === 'undefined')
            return;
        setErrors([]);
        setStarted(false);
        setFinished(false);
        setSuccess(false);
        resetTimer.current = null;
    }, []);
    const updateStateOnErrors = () => {
        console.log(options.id, 'updateStateOnErrors....', errors);
        let unMounting = false;
        if (errors?.length > 0) {
            if (unMounting)
                return;
            setFinished(true);
            setSuccess(false);
        }
        // eslint-disable-next-line consistent-return
        return () => {
            unMounting = true;
        };
    };
    const updateStateOnFinished = () => {
        let unMounting = false;
        if (finished) {
            if (options?.id) {
                console.groupCollapsed('id', options?.id);
                console.log('started', started);
                console.log('errors', errors);
                console.log('finished', finished);
                console.log('success', success);
                console.groupEnd();
            }
            if (unMounting)
                return;
            const withoutErrors = errors?.length === 0;
            setStarted(false);
            setSuccess(withoutErrors);
            if (autoReset?.current) {
                const to = setTimeout(() => {
                    if (unMounting)
                        return;
                    reset();
                    clearTimeout(to);
                }, autoReset.current);
            }
        }
        // eslint-disable-next-line consistent-return
        return () => {
            unMounting = true;
        };
    };
    (0, react_1.useEffect)(() => {
        updateStateOnErrors();
    }, [errors?.length]);
    (0, react_1.useEffect)(() => {
        updateStateOnFinished();
    }, [finished, options?.id]);
    // update global cart status
    (0, react_1.useEffect)(() => {
        if (isCartId) {
            setCartErrors(errors);
        }
    }, [errors?.length]);
    (0, react_1.useEffect)(() => {
        if (isCartId) {
            setCartStarted(started);
        }
    }, [started]);
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        setCartFinished(finished);
        const to = setTimeout(() => {
            if (unMounting)
                return;
            setCartFinished(false);
            clearTimeout(to);
        }, 1000);
        return () => {
            unMounting = true;
        };
    }, [finished]);
    (0, react_1.useEffect)(() => {
        if (isCartId) {
            setCartSuccess(success);
        }
    }, [success]);
    return {
        started,
        setStarted,
        finished,
        setFinished,
        success,
        setSuccess,
        errors,
        setErrors,
        reset,
        resetTimer,
    };
};
exports.useRecoilStartFinishErrors = useRecoilStartFinishErrors;
//# sourceMappingURL=useRecoilStartFinishErrors.js.map

/***/ }),

/***/ 798:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useStartFinishErrors = void 0;
const tslib_1 = __webpack_require__(5556);
const react_1 = __webpack_require__(7378);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useStartFinishErrors = (options) => {
    const setCartStarted = (0, store_1.useSetRecoilState)(store_1.default.cartStatusStarted('global'));
    const setCartFinished = (0, store_1.useSetRecoilState)(store_1.default.cartStatusFinished('global'));
    const setCartSuccess = (0, store_1.useSetRecoilState)(store_1.default.cartStatusSuccess('global'));
    const setCartErrors = (0, store_1.useSetRecoilState)(store_1.default.cartStatusErrors('global'));
    const [started, setStarted] = (0, react_1.useState)(options?.started || false);
    const [success, setSuccess] = (0, react_1.useState)(options?.success || false);
    const [finished, setFinished] = (0, react_1.useState)(options?.finished || false);
    const [errors, setErrors] = (0, react_1.useState)(options?.errors || []);
    const autoReset = (0, react_1.useRef)(options?.autoReset || 0);
    const resetTimer = (0, react_1.useRef)(options?.resetTimer || null);
    // update local hook status
    const reset = (0, react_1.useCallback)(() => {
        if (typeof setErrors === 'undefined')
            return;
        setErrors([]);
        setStarted(false);
        setFinished(false);
        setSuccess(false);
        resetTimer.current = null;
    }, []);
    const updateStateOnErrors = () => {
        let unMounting = false;
        if (errors?.length > 0) {
            if (unMounting)
                return;
            setFinished(true);
            setSuccess(false);
        }
        // eslint-disable-next-line consistent-return
        return () => {
            unMounting = true;
        };
    };
    const updateStateOnFinished = () => {
        let unMounting = false;
        if (finished) {
            if (options?.id) {
                console.groupCollapsed('id', options?.id);
                console.log('started', started);
                console.log('errors', errors);
                console.log('finished', finished);
                console.log('success', success);
                console.groupEnd();
            }
            if (unMounting)
                return;
            setStarted(false);
            setSuccess(errors?.length === 0);
            if (autoReset?.current) {
                const to = setTimeout(() => {
                    if (unMounting)
                        return;
                    reset();
                    clearTimeout(to);
                }, autoReset.current);
            }
        }
        // eslint-disable-next-line consistent-return
        return () => {
            unMounting = true;
        };
    };
    (0, react_1.useEffect)(() => {
        updateStateOnErrors();
    }, [errors?.length]);
    (0, react_1.useEffect)(() => {
        updateStateOnFinished();
    }, [finished, options?.id]);
    // update global cart status
    (0, react_1.useEffect)(() => {
        setCartErrors(errors);
    }, [errors?.length]);
    (0, react_1.useEffect)(() => {
        if (options?.id) {
            console.log('setting started to', started);
            setCartStarted(started);
        }
    }, [started]);
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        if (options?.id) {
            console.log('setting finished to', finished);
            setCartFinished(finished);
            const to = setTimeout(() => {
                if (unMounting)
                    return;
                setCartFinished(false);
                clearTimeout(to);
            }, 1000);
        }
        return () => {
            unMounting = true;
        };
    }, [finished]);
    (0, react_1.useEffect)(() => {
        setCartSuccess(success);
    }, [success]);
    return {
        started,
        setStarted,
        finished,
        setFinished,
        success,
        setSuccess,
        errors,
        setErrors,
        reset,
        resetTimer,
    };
};
exports.useStartFinishErrors = useStartFinishErrors;
//# sourceMappingURL=useStartFinishErrors.js.map

/***/ }),

/***/ 7610:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(5556);
tslib_1.__exportStar(__webpack_require__(772), exports);
tslib_1.__exportStar(__webpack_require__(1457), exports);
tslib_1.__exportStar(__webpack_require__(8081), exports);
tslib_1.__exportStar(__webpack_require__(10), exports);
tslib_1.__exportStar(__webpack_require__(3296), exports);
tslib_1.__exportStar(__webpack_require__(9196), exports);
tslib_1.__exportStar(__webpack_require__(5314), exports);
tslib_1.__exportStar(__webpack_require__(8335), exports);
tslib_1.__exportStar(__webpack_require__(972), exports);
tslib_1.__exportStar(__webpack_require__(5852), exports);
tslib_1.__exportStar(__webpack_require__(2022), exports);
tslib_1.__exportStar(__webpack_require__(8844), exports);
tslib_1.__exportStar(__webpack_require__(5542), exports);
//# sourceMappingURL=hooks.js.map

/***/ }),

/***/ 2031:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.store = exports.StateProvider = void 0;
const tslib_1 = __webpack_require__(5556);
/* exports all storefront effects so they can be used in the project */
const effects_1 = tslib_1.__importDefault(__webpack_require__(9025));
/**
 * Pass down the storefront recoil hooks to the project
 * so that they can be in the same shared recoil instance
 */
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
var StateProvider_1 = __webpack_require__(9141);
Object.defineProperty(exports, "StateProvider", ({ enumerable: true, get: function () { return StateProvider_1.StateProvider; } }));
/* eslint-disable import/export */
tslib_1.__exportStar(__webpack_require__(7610), exports); // These hooks will be the default hooks found in @backpackjs/storefront
exports.store = {
    state: store_1.default,
    effects: effects_1.default,
    recoil: {
        useRecoilState: store_1.useRecoilState,
        useRecoilStateLoadable: store_1.useRecoilStateLoadable,
        useSetRecoilState: store_1.useSetRecoilState,
        useResetRecoilState: store_1.useResetRecoilState,
        useRecoilValue: store_1.useRecoilValue,
        useRecoilValueLoadable: store_1.useRecoilValueLoadable,
        useRecoilSnapshot: store_1.useRecoilSnapshot,
        useRecoilCallback: store_1.useRecoilCallback,
        atom: store_1.atom,
        atomFamily: store_1.atomFamily,
        selector: store_1.selector,
        selectorFamily: store_1.selectorFamily,
    },
};
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 9196:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLocalizedOrderTotals = exports.useLocalizedOrderLine = exports.useLocalizedCartTotals = exports.useLocalizedCartLine = exports.useLocalizedVariant = exports.useLocalizedProduct = void 0;
var useLocalizedProduct_1 = __webpack_require__(7831);
Object.defineProperty(exports, "useLocalizedProduct", ({ enumerable: true, get: function () { return useLocalizedProduct_1.useLocalizedProduct; } }));
var useLocalizedVariant_1 = __webpack_require__(865);
Object.defineProperty(exports, "useLocalizedVariant", ({ enumerable: true, get: function () { return useLocalizedVariant_1.useLocalizedVariant; } }));
var useLocalizedCartLine_1 = __webpack_require__(4642);
Object.defineProperty(exports, "useLocalizedCartLine", ({ enumerable: true, get: function () { return useLocalizedCartLine_1.useLocalizedCartLine; } }));
var useLocalizedCartTotals_1 = __webpack_require__(4260);
Object.defineProperty(exports, "useLocalizedCartTotals", ({ enumerable: true, get: function () { return useLocalizedCartTotals_1.useLocalizedCartTotals; } }));
var useLocalizedOrderLine_1 = __webpack_require__(8370);
Object.defineProperty(exports, "useLocalizedOrderLine", ({ enumerable: true, get: function () { return useLocalizedOrderLine_1.useLocalizedOrderLine; } }));
var useLocalizedOrderTotals_1 = __webpack_require__(4205);
Object.defineProperty(exports, "useLocalizedOrderTotals", ({ enumerable: true, get: function () { return useLocalizedOrderTotals_1.useLocalizedOrderTotals; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 5988:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLocaleStartFinishErrors = void 0;
const tslib_1 = __webpack_require__(5556);
/* eslint-disable prettier/prettier */
const react_1 = __webpack_require__(7378);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const DEBUG = false;
const useLocaleStartFinishErrors = (options) => {
    const setCartStarted = (0, store_1.useSetRecoilState)(store_1.default.localeStatusStarted('locale/all'));
    const setCartFinished = (0, store_1.useSetRecoilState)(store_1.default.localeStatusFinished('locale/all'));
    const setCartSuccess = (0, store_1.useSetRecoilState)(store_1.default.localeStatusSuccess('locale/all'));
    const setCartErrors = (0, store_1.useSetRecoilState)(store_1.default.localeStatusErrors('locale/all'));
    const isCartId = /^cart/.test(options?.id);
    const [started, setStarted] = (0, store_1.useRecoilState)(store_1.default.localeStatusStarted(options?.id || ''));
    const [finished, setFinished] = (0, store_1.useRecoilState)(store_1.default.localeStatusFinished(options?.id || ''));
    const [success, setSuccess] = (0, store_1.useRecoilState)(store_1.default.localeStatusSuccess(options?.id || ''));
    const [errors, setErrors] = (0, store_1.useRecoilState)(store_1.default.localeStatusErrors(options?.id || ''));
    const autoReset = (0, react_1.useRef)(options?.autoReset || 0);
    const resetTimer = (0, react_1.useRef)(options?.resetTimer || null);
    // update local hook status
    const reset = (0, react_1.useCallback)(() => {
        if (typeof setErrors === 'undefined')
            return;
        setErrors([]);
        setStarted(false);
        setFinished(false);
        setSuccess(false);
        resetTimer.current = null;
    }, []);
    const updateStateOnErrors = () => {
        let unMounting = false;
        if (errors?.length > 0) {
            if (unMounting)
                return;
            setFinished(true);
            setSuccess(false);
        }
        // eslint-disable-next-line consistent-return
        return () => {
            unMounting = true;
        };
    };
    const updateStateOnFinished = () => {
        let unMounting = false;
        if (finished) {
            if (DEBUG) {
                console.groupCollapsed('status:', options?.id);
                console.log('started', started);
                console.log('errors', errors);
                console.log('finished', finished);
                console.log('success', success);
                console.groupEnd();
            }
            if (unMounting)
                return;
            const withoutErrors = errors?.length === 0;
            setStarted(false);
            setSuccess(withoutErrors);
            if (autoReset?.current) {
                const to = setTimeout(() => {
                    if (unMounting)
                        return;
                    reset();
                    clearTimeout(to);
                }, autoReset.current);
            }
        }
        // eslint-disable-next-line consistent-return
        return () => {
            unMounting = true;
        };
    };
    (0, react_1.useEffect)(() => {
        updateStateOnErrors();
    }, [errors?.length]);
    (0, react_1.useEffect)(() => {
        updateStateOnFinished();
    }, [finished, options?.id]);
    // update global cart status
    (0, react_1.useEffect)(() => {
        if (isCartId) {
            setCartErrors(errors);
        }
    }, [errors?.length]);
    (0, react_1.useEffect)(() => {
        if (isCartId) {
            setCartStarted(started);
        }
    }, [started]);
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        setCartFinished(finished);
        const to = setTimeout(() => {
            if (unMounting)
                return;
            setCartFinished(false);
            clearTimeout(to);
        }, 1000);
        return () => {
            unMounting = true;
        };
    }, [finished]);
    (0, react_1.useEffect)(() => {
        if (isCartId) {
            setCartSuccess(success);
        }
    }, [success]);
    return {
        started,
        setStarted,
        finished,
        setFinished,
        success,
        setSuccess,
        errors,
        setErrors,
        reset,
        resetTimer,
    };
};
exports.useLocaleStartFinishErrors = useLocaleStartFinishErrors;
//# sourceMappingURL=useLocaleStartFinishErrors.js.map

/***/ }),

/***/ 4642:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLocalizedCartLine = void 0;
const tslib_1 = __webpack_require__(5556);
/* eslint-disable no-undef */
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const defaultProps = {
    line: null,
    options: {},
};
/**
 * Localized a cart line item
 * @param {*} passedProps
 * @returns
 */
const useLocalizedCartLine = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    if (!props.line) {
        console.warn('useLocalizedCartLine "line" prop no provided');
        return { localized: null };
    }
    return {
        localized: (0, store_1.useRecoilValue)(store_1.default.localizedCartLine(props.line)),
    };
};
exports.useLocalizedCartLine = useLocalizedCartLine;
//# sourceMappingURL=useLocalizedCartLine.js.map

/***/ }),

/***/ 4260:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLocalizedCartTotals = void 0;
const tslib_1 = __webpack_require__(5556);
/* eslint-disable no-undef */
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
/**
 * Localized a cart line totals
 * @param {*} passedProps
 * @returns
 */
const useLocalizedCartTotals = () => {
    return {
        localized: (0, store_1.useRecoilValue)(store_1.default.localizedCartTotals),
    };
};
exports.useLocalizedCartTotals = useLocalizedCartTotals;
//# sourceMappingURL=useLocalizedCartTotals.js.map

/***/ }),

/***/ 8370:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLocalizedOrderLine = void 0;
const tslib_1 = __webpack_require__(5556);
/* eslint-disable no-undef */
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const defaultProps = {
    line: null,
    currencyCode: '',
    options: {},
};
/**
 * Localized a order line item
 * @param {*} passedProps
 * @returns
 */
const useLocalizedOrderLine = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    if (!props.line) {
        console.warn('useLocalizedOrderLine "line" prop no provided');
        return { localized: null };
    }
    if (!props.currencyCode) {
        console.warn('useLocalizedOrderLine "currencyCode" prop no provided');
        return { localized: null };
    }
    return {
        localized: (0, store_1.useRecoilValue)(store_1.default.localizedOrderLine(props)),
    };
};
exports.useLocalizedOrderLine = useLocalizedOrderLine;
//# sourceMappingURL=useLocalizedOrderLine.js.map

/***/ }),

/***/ 4205:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLocalizedOrderTotals = void 0;
const tslib_1 = __webpack_require__(5556);
/* eslint-disable no-undef */
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const defaultProps = {
    order: null,
    options: {},
};
/**
 * Localized a cart line totals
 * @param {*} passedProps
 * @returns
 */
const useLocalizedOrderTotals = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    if (!props.order) {
        console.warn('useLocalizedOrderTotals "order" prop no provided');
        return { localized: null };
    }
    return {
        localized: (0, store_1.useRecoilValue)(store_1.default.localizedOrderTotals(props.order)),
    };
};
exports.useLocalizedOrderTotals = useLocalizedOrderTotals;
//# sourceMappingURL=useLocalizedOrderTotals.js.map

/***/ }),

/***/ 7831:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLocalizedProduct = void 0;
const tslib_1 = __webpack_require__(5556);
/* eslint-disable no-undef */
const deepmerge_1 = tslib_1.__importDefault(__webpack_require__(406));
const react_1 = __webpack_require__(7378);
const useLocaleStartFinishErrors_1 = __webpack_require__(5988);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const defaultProps = {
    handle: null,
    product: null,
    countryCode: null,
    currency: null,
    localizeVariants: false,
    fetchOnMount: true,
    options: {},
};
/**
 * Retrieve the localized prices for a product in a given country
 * @param {*} passedProps
 * @returns
 */
const useLocalizedProduct = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const isBusy = (0, react_1.useRef)(false);
    const recoilProduct = (0, store_1.useRecoilValue)(store_1.default.product);
    const product = props.product?.handle ? props.product : recoilProduct;
    let handle = props.handle || product?.handle;
    const recoilCountry = (0, store_1.useRecoilValue)(store_1.default.country);
    let country = props.countryCode || recoilCountry?.isoCode;
    let currency = props.currency || recoilCountry?.currency?.isoCode;
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useLocaleStartFinishErrors_1.useLocaleStartFinishErrors)({
        ...props.options,
        id: `locale/product/${handle}/${country?.isoCode || country}/${currency}`,
    });
    const [localized, setLocalized] = (0, store_1.useRecoilState)(store_1.default.localizedProduct({ handle, country, currency }));
    const localize = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            // if the user passes a handle via the fetcher prioritize it
            if (data?.handle) {
                handle = data.handle;
            }
            if (data?.country) {
                country = data.country;
            }
            if (data?.currency) {
                currency = data.currency;
            }
            let validationErrors = null;
            switch (true) {
                case !handle: {
                    validationErrors = ['handle not provided'];
                    break;
                }
                case !country: {
                    validationErrors = ['country not provided'];
                    break;
                }
                case !currency: {
                    validationErrors = ['currency not provided'];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                setErrors(validationErrors);
                return null;
            }
            const { error, product: _product } = await snapshot.getPromise(store_1.default.fetchLocaleProduct({ handle, country, currency }));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!_product) {
                setErrors([`Invalid product price in response ${_product}`]);
                return null;
            }
            if (!product?.variants) {
                setErrors([`Invalid source product provided ${product}`]);
                return null;
            }
            setFinished(true);
            // console.log('original product', product);
            // console.log('localized product', _product);
            // merge the original product with the localized version
            const mergedProduct = {
                ...product,
                locale: _product.locale,
                priceRange: _product.priceRange,
                requiresSellingPlan: _product.requiresSellingPlan,
                sellingPlanGroups: _product.requiresSellingPlan,
            };
            // localize all product variants including fromGrouping (optional)
            if (props.localizeVariants) {
                // merge the original variants (that have no locale) with the localized versions
                const localizedProductVariants = product.variants
                    .filter((variant) => !variant.fromGrouping)
                    .map((variant) => {
                    const localizedVariant = _product.variants.find((_variant) => _variant.id === variant.id);
                    return (0, deepmerge_1.default)(variant, localizedVariant);
                });
                // fetch locale for grouping variants as shopify knows nothing about the grouping
                const groupingVariants = product.variants.filter((variant) => variant.fromGrouping);
                const groupingVariantInPromise = groupingVariants.map((_variant) => snapshot.getPromise(store_1.default.fetchProductVariantPriceIn({
                    handle: _variant.product.handle,
                    selectedOptions: _variant.selectedOptions,
                })));
                const groupingLocalizedVariantsResponse = await Promise.all(groupingVariantInPromise);
                const groupingLocalizedVariants = groupingLocalizedVariantsResponse.map((response) => {
                    if (response.error) {
                        return null;
                    }
                    return response.variant;
                });
                // apply merged variants
                mergedProduct.variants = [
                    ...localizedProductVariants,
                    ...groupingLocalizedVariants,
                ];
            }
            setLocalized(mergedProduct);
            if (callback)
                callback(mergedProduct);
            return mergedProduct;
        }
        catch (error) {
            console.error('localize:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    // fetch on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !handle,
            !country,
            !currency,
            !props.fetchOnMount,
            isBusy.current,
            localized,
        ];
        if (earlyExitIf.some(Boolean)) {
            return undefined;
        }
        isBusy.current = true;
        localize({ handle, country, currency })
            .then((_product) => {
            if (unMounting)
                return null;
            setLocalized(_product);
            isBusy.current = false;
            return _product;
        })
            .catch((error) => {
            console.error('failed to localize due to', error.message);
        });
        return () => {
            unMounting = true;
        };
    }, [handle, country, currency, localized, props.fetchOnMount]);
    return {
        localized: localized || null,
        localize,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useLocalizedProduct = useLocalizedProduct;
//# sourceMappingURL=useLocalizedProduct.js.map

/***/ }),

/***/ 865:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLocalizedVariant = void 0;
const tslib_1 = __webpack_require__(5556);
/* eslint-disable no-undef */
const react_1 = __webpack_require__(7378);
const useLocaleStartFinishErrors_1 = __webpack_require__(5988);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const defaultProps = {
    variant: { product: { handle: null }, selectedOptions: null, id: '' },
    countryCode: null,
    currency: null,
    fetchOnMount: true,
    options: {},
};
/**
 * Retrieve the localized prices for a product in a given country
 * @param {*} passedProps
 * @returns
 */
const useLocalizedVariant = (passedProps) => {
    const fallbackCountry = (0, store_1.useRecoilValue)(store_1.default.country)?.isoCode;
    const fallbackCurrency = (0, store_1.useRecoilValue)(store_1.default.country)?.currency?.isoCode;
    const props = passedProps?.variant
        ? { ...defaultProps, ...passedProps }
        : defaultProps;
    let { handle } = props.variant.product;
    let { selectedOptions } = props.variant;
    let country = props.countryCode || fallbackCountry;
    let currency = props.currency || fallbackCurrency;
    const statusId = `locale/product/${handle}/variant/${props.variant.id
        .split('/')
        .pop()}/${country}/${currency}`;
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useLocaleStartFinishErrors_1.useLocaleStartFinishErrors)({ ...props.options, id: statusId });
    const [localized, setLocalized] = (0, store_1.useRecoilState)(store_1.default.localizedVariant({ handle, selectedOptions, country, currency }));
    const localize = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        const release = snapshot.retain();
        try {
            setStarted(true);
            // if the user passes a handle via the fetcher prioritize it
            if (data?.handle) {
                handle = data.handle;
            }
            if (data?.selectedOptions) {
                selectedOptions = data.selectedOptions;
            }
            if (data?.country) {
                country = data.country;
            }
            if (data?.currency) {
                currency = data.currency;
            }
            let validationErrors = null;
            switch (true) {
                case !handle: {
                    validationErrors = ['handle not provided'];
                    break;
                }
                case !selectedOptions: {
                    validationErrors = ['selectedOptions not provided'];
                    break;
                }
                case !country: {
                    validationErrors = ['country not provided'];
                    break;
                }
                case !currency: {
                    validationErrors = ['currency not provided'];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                setErrors(validationErrors);
                return null;
            }
            const { error, variant: _variant } = await snapshot.getPromise(store_1.default.fetchLocalizedVariant({
                handle,
                selectedOptions,
                country,
                currency,
            }));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!_variant) {
                setErrors([
                    `Invalid product variant price in response: ${_variant}`,
                ]);
                return null;
            }
            setFinished(true);
            setLocalized(_variant);
            if (callback)
                callback(_variant);
            return _variant;
        }
        catch (error) {
            console.error('localize:error', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !handle,
            !selectedOptions?.length,
            !country,
            !currency,
            !props.fetchOnMount,
            finished,
        ];
        if (earlyExitIf.some(Boolean)) {
            return;
        }
        localize({ handle, country, currency })
            .then((variant) => {
            if (unMounting)
                return;
            setLocalized(variant);
        })
            .catch((error) => {
            console.error('failed to localize due to', error.message);
        });
        // eslint-disable-next-line
        return () => {
            unMounting = true;
        };
    }, [
        country,
        currency,
        finished,
        handle,
        props.fetchOnMount,
        props.variant.id,
        selectedOptions,
    ]);
    return {
        localized: localized || null,
        localize,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useLocalizedVariant = useLocalizedVariant;
//# sourceMappingURL=useLocalizedVariant.js.map

/***/ }),

/***/ 9970:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.localeStore = void 0;
var locale_1 = __webpack_require__(4415);
Object.defineProperty(exports, "localeStore", ({ enumerable: true, get: function () { return locale_1.localeStore; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 4415:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.localeStore = void 0;
/* eslint-disable max-lines */
const recoil_1 = __webpack_require__(9853);
const client_1 = __webpack_require__(5431);
const store_1 = __webpack_require__(437);
const store_2 = __webpack_require__(9005);
const Localize_1 = __webpack_require__(2667);
const localize = new Localize_1.Localize();
const productClient = new client_1.ProductClient({
    apiToken: "3bc6486eea19d75d4dd39479084d4c7a",
    apiVersion: '2025-04',
    domain: "clearly-filtered.myshopify.com",
});
/**
  Locale State
*/
const localizedProduct = (0, recoil_1.atomFamily)({
    key: 'locale/product',
    default: null,
});
const localizedVariant = (0, recoil_1.atomFamily)({
    key: 'locale/variant',
    default: null,
});
const localizedCartLine = (0, recoil_1.selectorFamily)({
    key: 'locale/cartLine',
    get: (line) => ({ get }) => {
        const { locale } = get(store_1.shopStore.country);
        return localize.cartLine({ line, locale });
    },
});
const localizedCartTotals = (0, recoil_1.selector)({
    key: 'locale/cartTotals',
    get: ({ get }) => {
        const cart = get(store_2.cartStore.cart);
        const { locale } = get(store_1.shopStore.country);
        return localize.cartTotals({ cart, locale });
    },
});
const localizedOrderLine = (0, recoil_1.selectorFamily)({
    key: 'locale/orderLine',
    get: ({ line, currencyCode }) => ({ get }) => {
        const { locale: currentLocale } = get(store_1.shopStore.country);
        const countries = get(store_1.shopStore.countries);
        const orderCounty = countries.find((country) => {
            return country.currency?.isoCode === currencyCode;
        });
        const orderLocale = orderCounty?.locale || currentLocale;
        return localize.orderLine({
            line,
            currentLocale,
            locale: orderLocale,
        });
    },
});
const localizedOrderTotals = (0, recoil_1.selectorFamily)({
    key: 'locale/orderTotals',
    get: (order) => ({ get }) => {
        const countries = get(store_1.shopStore.countries);
        const orderCounty = countries.find((country) => {
            return country.currency?.isoCode === order.currencyCode;
        });
        const orderLocale = orderCounty?.locale;
        return localize.orderTotals({
            order,
            locale: orderLocale,
        });
    },
});
/* Status */
const localeStatusStarted = (0, recoil_1.atomFamily)({
    key: 'locale/statusStarted',
    default: false,
});
const localeStatusFinished = (0, recoil_1.atomFamily)({
    key: 'locale/statusFinished',
    default: false,
});
const localeStatusSuccess = (0, recoil_1.atomFamily)({
    key: 'locale/statusSuccess',
    default: false,
});
const localeStatusErrors = (0, recoil_1.atomFamily)({
    key: 'locale/statusErrors',
    default: [],
});
/* Async */
const fetchLocaleProduct = (0, recoil_1.selectorFamily)({
    key: 'locale/fetchProduct',
    get: (data) => async ({ get }) => {
        const passedCountryCode = data?.country?.isoCode || data?.country;
        const country = get(store_1.shopStore.country);
        const _country = passedCountryCode || country?.isoCode || 'US';
        try {
            // get product in country's currency
            const { error, product: _product } = await productClient.getLocalizedProduct({
                ...data,
                country: _country,
            });
            if (error) {
                throw new Error(error);
            }
            if (!_product || !_product?.id) {
                throw new Error('Invalid locale product response');
            }
            // add locale to localized product
            const _localizedProduct = localize.product({
                product: _product,
                locale: country.locale,
            });
            return { error: null, product: _localizedProduct };
        }
        catch (error) {
            return { error: error.message, product: null };
        }
    },
});
const fetchLocalizedVariant = (0, recoil_1.selectorFamily)({
    key: 'locale/fetchVariant',
    get: (data) => async ({ get }) => {
        const passedCountryCode = data?.country?.isoCode || data?.country;
        const country = get(store_1.shopStore.country);
        const _country = passedCountryCode || country?.isoCode || 'US';
        try {
            // get variant localized in the current country
            const { error, variant: rawVariant } = await productClient.getLocalizedVariant({
                ...data,
                country: _country,
                locale: country.locale,
            });
            if (error) {
                throw new Error(error);
            }
            if (!rawVariant || !rawVariant?.id) {
                throw new Error('Invalid locale variant response');
            }
            // add locale to localized variant
            const _localizedVariant = localize.variant({
                variant: rawVariant,
                locale: country.locale,
            });
            // convert sellingPlanAllocations to a map
            const spsByKey = (_sps, sp) => {
                return {
                    ..._sps,
                    [sp.sellingPlan.id]: sp,
                };
            };
            // added to make it easier to find the active selling plan
            const sellingPlans = _localizedVariant.sellingPlanAllocations.reduce(spsByKey, {});
            const variant = { ..._localizedVariant, sellingPlans };
            return { error: null, variant };
        }
        catch (error) {
            return { error: error.message, variant: null };
        }
    },
});
// Localized stored
exports.localeStore = {
    localizedProduct,
    localizedVariant,
    localizedCartLine,
    localizedCartTotals,
    localizedOrderLine,
    localizedOrderTotals,
    // status
    localeStatusStarted,
    localeStatusFinished,
    localeStatusSuccess,
    localeStatusErrors,
    // async
    fetchLocaleProduct,
    fetchLocalizedVariant,
};
//# sourceMappingURL=locale.js.map

/***/ }),

/***/ 5314:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(5556);
tslib_1.__exportStar(__webpack_require__(3031), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 3031:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.usePage = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const usePage = () => (0, store_1.useRecoilValue)(store_1.default.page);
exports.usePage = usePage;
//# sourceMappingURL=usePage.js.map

/***/ }),

/***/ 8886:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.pageStore = void 0;
var page_1 = __webpack_require__(523);
Object.defineProperty(exports, "pageStore", ({ enumerable: true, get: function () { return page_1.pageStore; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 523:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.pageStore = void 0;
const tslib_1 = __webpack_require__(5556);
/* eslint-disable max-lines */
const recoil_1 = __webpack_require__(9853);
const effects_1 = tslib_1.__importDefault(__webpack_require__(9025));
/**
  Page State
*/
const page = (0, recoil_1.atom)({
    key: 'page/page',
    default: null,
    effects: [
        // effects.logStateChange('page'),
        effects_1.default.onChange({
            key: 'page',
            topic: 'PAGE_UPDATE',
            actions: ['publishBusEvent'],
        }),
    ],
});
const pagesList = (0, recoil_1.atom)({
    key: 'page/pagesList',
    default: [],
});
// pages json fuse index
const pagesIndex = (0, recoil_1.atom)({
    key: 'page/pagesIndex',
    default: null,
});
exports.pageStore = {
    // actual state - atoms
    page,
    pagesIndex,
    pagesList,
};
//# sourceMappingURL=page.js.map

/***/ }),

/***/ 466:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ProductClient = void 0;
const tslib_1 = __webpack_require__(5556);
/* eslint-disable no-undef */
/* eslint-disable class-methods-use-this */
const graphql_request_1 = __webpack_require__(3671);
const humanize_graphql_response_1 = tslib_1.__importDefault(__webpack_require__(7207));
const queries_1 = __webpack_require__(8318);
/**
 * @see: https://shopify.dev/custom-storefronts/cart
 */
class ProductClient {
    constructor({ apiToken, apiVersion, domain }) {
        this.apiToken = apiToken;
        this.apiVersion = apiVersion;
        this.domain = domain;
        this.endpoint = `https://${this.domain}/api/${apiVersion}/graphql.json`;
        this.options = {
            method: 'POST',
            mode: 'cors',
            headers: {
                'X-Shopify-Storefront-Access-Token': this.apiToken,
                'Content-Type': 'application/json; charset=utf-8',
            },
        };
        this.client = new graphql_request_1.GraphQLClient(this.endpoint, this.options);
    }
    /**
     *
     * @param
     * @returns
     */
    async storefront({ query, variables }) {
        return this.client.rawRequest(query, variables);
    }
    /**
     * Fetch a /json/ hosted file
     * @param {jsonPath} path a valid /json/**.* path
     * @returns a json object
     */
    async json({ path }) {
        try {
            if (!path)
                throw new TypeError('Missing required json "path"');
            const jsonUrl = `/json/${path}`;
            // eslint-disable-next-line no-undef
            const response = await fetch(jsonUrl);
            if (!response?.ok) {
                return { error: 'json response not ok', data: null };
            }
            const data = await response.json();
            return { error: null, data };
        }
        catch (error) {
            const errorMsg = `requestJson: failed to fetch json ${path} due to ${error.message}`;
            console.error(errorMsg);
            return { error, data: null };
        }
    }
    /**
     * Get a product's live sellingPlans by handle
     * @param {string} handle - can pass any valid cart param here: e.g — buyerIdentity, attributes etc..
     * @returns a new full cart instance
     */
    async getByHandle({ handle } = { handle: null }) {
        try {
            if (!handle) {
                throw new Error('get product failed "handle" not provided');
            }
            const productPath = `products/${handle}.json`;
            const { error, data } = await this.json({
                path: productPath,
            });
            if (error) {
                throw new Error(error);
            }
            return { error: null, product: data };
        }
        catch (error) {
            console.error('getByHandle:error', error.message);
            return { error: error.message, product: null };
        }
    }
    /**
     * Fetch a list of all products with some basic meta (great for building collection filters)
     * @returns products-list.json
     */
    async getList() {
        try {
            const { error, data } = await this.json({
                path: 'products-list.json',
            });
            if (error) {
                throw new Error(error);
            }
            return { error: null, productsList: data };
        }
        catch (error) {
            console.error('getList:error', error.message);
            return { error: error.message, productsList: null };
        }
    }
    /**
     * Fetch a index of all products (used by fuse search index)
     * @returns products-index.json
     */
    async getIndex() {
        try {
            const { error, data } = await this.json({
                path: 'products-index.json',
            });
            if (error) {
                throw new Error(error);
            }
            return { error: null, productsIndex: data };
        }
        catch (error) {
            console.error('getIndex:error', error.message);
            return { error: error.message, productsIndex: null };
        }
    }
    /**
     * Fetch a set of uniq product properties
     * @returns products-uniq.json
     */
    async getUniq() {
        try {
            const { error, data } = await this.json({
                path: 'products-uniq.json',
            });
            if (error) {
                throw new Error(error);
            }
            return { error: null, productsUniq: data };
        }
        catch (error) {
            return { error: error.message, productsUniq: null };
        }
    }
    /**
     * Fetch a list of all product handles
     * @returns products.json
     */
    async getHandles() {
        try {
            const { error, data } = await this.json({
                path: 'products.json',
            });
            if (error) {
                throw new Error(error);
            }
            return { error: null, productHandles: data };
        }
        catch (error) {
            console.error('getHandles:error', error.message);
            return { error: error.message, productHandles: null };
        }
    }
    /**
     * Get a product's live sellingPlans by handle
     * @param {twoDigitCountryCode} country - US, MX..
     * @param {string} handle - can pass any valid cart param here: e.g — buyerIdentity, attributes etc..
     * @returns a new full cart instance
     */
    async getSellingPlans({ country, handle } = { country: 'US', handle: null }) {
        try {
            if (!handle) {
                throw new Error('get selling plans failed "handle" not provided');
            }
            const { data, errors, status } = await this.storefront({
                query: queries_1.queries.getProductSellingPlans,
                variables: { country, handle },
            });
            if (status !== 200) {
                throw new Error(`Network request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            const { product } = data;
            return { error: null, product: (0, humanize_graphql_response_1.default)(product) };
        }
        catch (error) {
            console.error('getProductSellingPlans:error', error.message);
            return { error: error.message, product: null };
        }
    }
    /**
     * Get a variant selling plans in a given countries context
     * @param {twoDigitCountryCode} country - US, MX..
     * @param {String} handle - the target product's handle
     * @param {String} selectedOptions - the target variant's selectedOptions
     * @returns a full variant with prices in a target country
     */
    async getVariantSellingPlans({ country, currency, handle, selectedOptions } = {
        country: 'US',
        currency: 'USD',
        handle: null,
        selectedOptions: [],
        locale,
    }) {
        try {
            if (!handle) {
                throw new Error('get variant selling plan failed "handle" not provided');
            }
            if (!selectedOptions) {
                throw new Error('get variant selling plan failed "selectedOptions" not provided');
            }
            // get variant price in country
            const { data, errors, status } = await this.storefront({
                query: queries_1.queries.getProductVariantSellingPlans,
                variables: { country, handle, selectedOptions },
            });
            if (status !== 200) {
                throw new Error(`Network request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            const { product } = (0, humanize_graphql_response_1.default)(data);
            let { variant } = product;
            // add locale pricing and info to the variant
            variant = this._localizeVariant({ variant, locale, currency });
            return { error: null, variant };
        }
        catch (error) {
            console.error('getVariantSellingPlans:error', error.message);
            return { error: error.message, variant: null };
        }
    }
    /**
     * Get a product's live inventory by handle
     * @param {twoDigitCountryCode} country - US, MX..
     * @param {String} handle - can pass any valid cart param here: e.g — buyerIdentity, attributes etc..
     * @param {Boolean} withQuantity - if true we return the quantities available too
     * @returns live inventory for a product
     */
    async getInventory({ country, handle, withQuantity } = {
        country: 'US',
        handle: null,
        withQuantity: true,
    }) {
        try {
            if (!handle) {
                throw new Error('get inventory failed "handle" not provided');
            }
            const { data, errors, status } = await this.storefront({
                query: withQuantity
                    ? queries_1.queries.getInventoryWithQuantity
                    : queries_1.queries.getInventory,
                variables: { country, handle },
            });
            if (status !== 200) {
                throw new Error(`Network request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            const { product } = data;
            return { error: null, product: (0, humanize_graphql_response_1.default)(product) };
        }
        catch (error) {
            console.error('getInventory:error', error.message);
            return { error: error.message, product: null };
        }
    }
    /**
     * Get a product and variants price in a given countries context
     * @param {twoDigitCountryCode} country - US, MX..
     * @param {String} handle - the target product's handle
     * @returns product and variants prices in that country
     */
    async getLocalizedProduct({ country, handle } = {
        country: 'US',
        handle: null,
    }) {
        try {
            if (!handle) {
                throw new Error('get localized product failed "handle" not provided');
            }
            const { data, errors, status } = await this.storefront({
                query: queries_1.queries.getLocalizedProduct,
                variables: { country, handle },
            });
            if (status !== 200) {
                throw new Error(`Network request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            const { product } = (0, humanize_graphql_response_1.default)(data);
            return { error: null, product };
        }
        catch (error) {
            console.error('getLocalizedProduct:error', error.message);
            return { error: error.message, product: null };
        }
    }
    /**
     * Get a variant price in a given countries context
     * @param {twoDigitCountryCode} country - US, MX..
     * @param {String} locale - country locale
     * @param {String} handle - the target product's handle
     * @param {String} selectedOptions - the target variant's selectedOptions
     * @returns a full variant with prices in a target country
     */
    async getLocalizedVariant({ country, handle, selectedOptions } = {
        country: 'US',
        locale: null,
        handle: null,
        selectedOptions: [],
    }) {
        try {
            if (!country) {
                throw new Error('get localized variant "country" not provided');
            }
            if (!handle) {
                throw new Error('get localized variant "handle" not provided');
            }
            if (!selectedOptions) {
                throw new Error('get localized variant "selectedOptions" not provided');
            }
            // get variant price in country
            const { data, errors, status } = await this.storefront({
                query: queries_1.queries.getLocalizedVariant,
                variables: { country, handle, selectedOptions },
            });
            if (status !== 200) {
                throw new Error(`Network request failed with status ${status}`);
            }
            if (!data.product) {
                throw new Error(`No localized variant found for product with handle \`${handle}\``);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            const { product } = (0, humanize_graphql_response_1.default)(data);
            const { variant } = product;
            return { error: null, variant };
        }
        catch (error) {
            console.error('getLocalizedVariant:error', error.message);
            return { error: error.message, variant: null };
        }
    }
    /**
     * Get a product's recommendations via shopify
     * @param {String} productId - product legacyResourceId
     * @param {Integer|String} limit - how many recommendations to get
     * @returns a new full cart instance
     */
    async getRecommendations({ productId, limit } = {
        productId: null,
        limit: 6,
    }) {
        try {
            if (!productId) {
                throw new Error('get recommendations failed "productId" not provided');
            }
            // eslint-disable-next-line no-undef
            const url = window.location.origin;
            const endpoint = `${url}/api/shopify/recommendations`;
            // eslint-disable-next-line no-undef
            const request = await fetch(endpoint, {
                method: 'POSt',
                body: JSON.stringify({ productId, limit }),
            });
            if (!request?.ok) {
                throw new Error('Recommendations request not ok');
            }
            const { errors, response } = await request.json();
            if (errors?.length) {
                throw new Error(errors[0]);
            }
            if (!response?.products) {
                throw new Error('Invalid recommendations response');
            }
            const { products } = response;
            const recommendations = products.map((product) => {
                return {
                    handle: product.handle,
                    legacyResourceId: productId,
                };
            });
            return { error: null, recommendations };
        }
        catch (error) {
            console.error('getRecommendations:error', error.message);
            return { error: error.message, recommendations: [] };
        }
    }
    /**
     * Get a product's metafield by handle
     * @param {twoDigitCountryCode} country - US, MX..
     * @param {String} handle - the product handle
     * @param {String} key - the metafield key
     * @param {String} namespace - the metafield namespace
     * @returns a metafield key and value
     */
    async getMetafield({ country, handle, key, namespace } = {
        country: 'US',
        handle: null,
        key: '',
        namespace: '',
    }) {
        try {
            if (!handle) {
                throw new Error('get metafield failed "handle" not provided');
            }
            if (!key) {
                throw new Error('get metafield failed "key" not provided');
            }
            if (!namespace) {
                throw new Error('get metafield failed "namespace" not provided');
            }
            const { data, errors, status } = await this.storefront({
                query: queries_1.queries.getMetafield,
                variables: { country, handle, key, namespace },
            });
            if (status !== 200) {
                throw new Error(`Network request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            const { product } = data;
            return { error: null, metafield: product?.metafield };
        }
        catch (error) {
            console.error('getMetafield:error', error.message);
            return { error: error.message, metafield: null };
        }
    }
    /**
     * Get a product variant metafield
     * @param {twoDigitCountryCode} country - US, MX..
     * @param {String} handle - the product handle
     * @param {[Object]} selectedOptions - the selectedOptions of the target variant
     * @param {String} key - the metafield key
     * @param {String} namespace - the metafield namespace
     * @returns a metafield key and value
     */
    async getVariantMetafield({ country, handle, key, namespace, selectedOptions } = {
        country: 'US',
        handle: null,
        key: '',
        namespace: '',
        selectedOptions: [], // eg.. [{ Size: '50 cm', ...}]
    }) {
        try {
            if (!handle) {
                throw new Error('get metafield failed "handle" not provided');
            }
            if (!key) {
                throw new Error('get metafield failed "key" not provided');
            }
            if (!namespace) {
                throw new Error('get metafield failed "namespace" not provided');
            }
            if (!selectedOptions) {
                throw new Error('get metafield failed "selectedOptions" not provided');
            }
            if (!Array.isArray(selectedOptions)) {
                throw new Error('get metafield failed "selectedOptions" must be an array');
            }
            const { data, errors, status } = await this.storefront({
                query: queries_1.queries.getVariantMetafield,
                variables: { country, handle, key, namespace, selectedOptions },
            });
            if (status !== 200) {
                throw new Error(`Network request failed with status ${status}`);
            }
            if (errors?.length) {
                throw new Error(errors);
            }
            const { product } = data;
            const { selectedVariant } = product;
            return { error: null, metafield: selectedVariant.metafield };
        }
        catch (error) {
            console.error('getVariantMetafield:error', error.message);
            return { error: error.message, metafield: null };
        }
    }
    /**
     * Search shopify admin api for products
     * @param {String} term - product term to search
     * @param {number} limit - optional limit 10 max
     * @returns a list of products
     */
    async searchProducts({ term, limit }) {
        try {
            // eslint-disable-next-line no-undef
            const request = await fetch('/api/shopify/search', {
                method: 'POST',
                body: JSON.stringify({
                    term,
                    limit: limit || 10,
                    types: ['product'],
                }),
            });
            if (!request?.ok) {
                throw new Error('Products search response not ok');
            }
            const { errors, response } = await request.json();
            if (errors?.length) {
                throw new Error(errors[0]);
            }
            return { error: null, results: response.results.products };
        }
        catch (error) {
            console.error('searchProducts:error', error.message);
            return { error: error.message, results: null };
        }
    }
}
exports.ProductClient = ProductClient;
//# sourceMappingURL=client.js.map

/***/ }),

/***/ 9195:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const graphql_request_1 = __webpack_require__(3671);
const Price = (0, graphql_request_1.gql) `
  fragment Price on MoneyV2 {
    amount
    currencyCode
  }
`;
const SellingPlan = (0, graphql_request_1.gql) `
  fragment SellingPlan on SellingPlan {
    id
    name
    description
    priceAdjustments {
      adjustmentValue {
        ... on SellingPlanFixedAmountPriceAdjustment {
          adjustmentAmount {
            amount
            currencyCode
          }
        }
        ... on SellingPlanFixedPriceAdjustment {
          price {
            amount
            currencyCode
          }
        }
        ... on SellingPlanPercentagePriceAdjustment {
          adjustmentPercentage
        }
      }
      orderCount
    }
    recurringDeliveries
    options {
      name
      value
    }
  }
`;
const SellingPlanAllocation = (0, graphql_request_1.gql) `
  fragment SellingPlanAllocation on SellingPlanAllocation {
    priceAdjustments {
      compareAtPrice {
        ...Price
      }
      price {
        ...Price
      }
      perDeliveryPrice {
        ...Price
      }
      unitPrice {
        ...Price
      }
    }
    sellingPlan {
      ...SellingPlan
    }
  }
`;
const SellingPlanGroup = (0, graphql_request_1.gql) `
  fragment SellingPlanGroup on SellingPlanGroup {
    appName
    name
    options {
      name
      values
    }
    sellingPlans(first: 10) {
      edges {
        node {
          ...SellingPlan
        }
      }
    }
  }
`;
const LiveInventoryVariant = (0, graphql_request_1.gql) `
  fragment LiveInventoryVariant on ProductVariant {
    id
    availableForSale
    currentlyNotInStock
    product {
      handle
    }
  }
`;
const LiveInventoryVariantWithQuantity = (0, graphql_request_1.gql) `
  fragment LiveInventoryVariantWithQuantity on ProductVariant {
    id
    quantityAvailable
    currentlyNotInStock
    availableForSale
    product {
      handle
    }
  }
`;
const CountryPriceVariant = (0, graphql_request_1.gql) `
  fragment CountryPriceVariant on ProductVariant {
    id
    product {
      handle
    }
    compareAtPriceV2 {
      ...Price
    }
    priceV2 {
      ...Price
    }
    sellingPlanAllocations(first: 10) {
      edges {
        node {
          ...SellingPlanAllocation
        }
      }
    }
  }
`;
const CountryPriceSelectedVariant = (0, graphql_request_1.gql) `
  fragment CountryPriceSelectedVariant on ProductVariant {
    compareAtPriceV2 {
      ...Price
    }
    id
    priceV2 {
      ...Price
    }
    product {
      handle
      id
    }
    selectedOptions {
      name
      value
    }
    sellingPlanAllocations(first: 10) {
      edges {
        node {
          ...SellingPlanAllocation
        }
      }
    }
    unitPrice {
      ...Price
    }
    unitPriceMeasurement {
      measuredType
      quantityUnit
      quantityValue
    }
  }
`;
const FullVariant = (0, graphql_request_1.gql) `
  fragment FullVariant on ProductVariant {
    availableForSale
    barcode
    id
    compareAtPriceV2 {
      ...Price
    }
    product {
      handle
      id
    }
    sku
    image {
      originalSrc
      altText
      width
      height
    }
    quantityAvailable
    requiresShipping
    weight
    weightUnit
    availableForSale
    sellingPlanAllocations(first: 10) {
      edges {
        node {
          ...SellingPlanAllocation
        }
      }
    }
    selectedOptions {
      name
      value
    }
    unitPrice {
      ...Price
    }
    unitPriceMeasurement {
      measuredType
      quantityUnit
      quantityValue
    }
    priceV2 {
      ...Price
    }
  }
`;
const MinMaxVariantPrice = (0, graphql_request_1.gql) `
  fragment MinMaxVariantPrice on ProductPriceRange {
    maxVariantPrice {
      ...Price
    }
    minVariantPrice {
      ...Price
    }
  }
`;
const Metafield = (0, graphql_request_1.gql) `
  fragment Metafield on Metafield {
    key
    id
    value
    namespace
  }
`;
exports["default"] = {
    LiveInventoryVariant,
    LiveInventoryVariantWithQuantity,
    CountryPriceVariant,
    CountryPriceSelectedVariant,
    Metafield,
    MinMaxVariantPrice,
    Price,
    SellingPlan,
    SellingPlanAllocation,
    SellingPlanGroup,
};
//# sourceMappingURL=fragments.js.map

/***/ }),

/***/ 5431:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ProductClient = void 0;
var client_1 = __webpack_require__(466);
Object.defineProperty(exports, "ProductClient", ({ enumerable: true, get: function () { return client_1.ProductClient; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 8318:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.queries = void 0;
const tslib_1 = __webpack_require__(5556);
/* eslint-disable prettier/prettier */
const graphql_request_1 = __webpack_require__(3671);
const fragments_1 = tslib_1.__importDefault(__webpack_require__(9195));
/*
  Queries
*/
const getProductSellingPlans = (0, graphql_request_1.gql) `
  query getProductSellingPlans($country: CountryCode, $handle: String!)
  @inContext(country: $country) {
    product: productByHandle(handle: $handle) {
      id
      handle
      requiresSellingPlan
      sellingPlanGroups(first: 1) {
        edges {
          node {
            ...SellingPlanGroup
          }
        }
      }
    }
  }
  ${fragments_1.default.SellingPlan}
  ${fragments_1.default.SellingPlanGroup}
`;
const getProductVariantSellingPlans = (0, graphql_request_1.gql) `
  query getProductVariantSellingPlans($country: CountryCode, $handle: String!, $selectedOptions: [SelectedOptionInput!]!)
  @inContext(country: $country) {
    product: productByHandle(handle: $handle) {
      id
      handle
      requiresSellingPlan
      sellingPlanGroups(first: 1) {
        edges {
          node {
            ...SellingPlanGroup
          }
        }
      }
      variant: variantBySelectedOptions(selectedOptions: $selectedOptions) {
        ...CountryPriceSelectedVariant
      }
    }
  }
  ${fragments_1.default.Price}
  ${fragments_1.default.SellingPlan}
  ${fragments_1.default.SellingPlanGroup}
  ${fragments_1.default.SellingPlanAllocation}
  ${fragments_1.default.CountryPriceSelectedVariant}
`;
// withQuantity === false
const getInventory = (0, graphql_request_1.gql) `
  query getInventory($country: CountryCode, $handle: String!)
  @inContext(country: $country) {
    product: productByHandle(handle: $handle) {
      id
      handle
      availableForSale
      variants(first: 250) {
        edges {
          node {
            ...LiveInventoryVariant
          }
        }
      }
    }
  }
  ${fragments_1.default.LiveInventoryVariant}
`;
// withQuantity === true (default)
const getInventoryWithQuantity = (0, graphql_request_1.gql) `
  query getInventoryWithQuantity($country: CountryCode, $handle: String!)
  @inContext(country: $country) {
    product: productByHandle(handle: $handle) {
      id
      handle
      availableForSale
      totalInventory
      variants(first: 250) {
        edges {
          node {
            ...LiveInventoryVariantWithQuantity
          }
        }
      }
    }
  }
  ${fragments_1.default.LiveInventoryVariantWithQuantity}
`;
/*
  Temp querying for sellingPlanAllocations as we don't sync them atm
  Shorthand for now as this will be merged with the SSG product
  at productIn hooh
*/
const getLocalizedProduct = (0, graphql_request_1.gql) `
  query getLocalizedProduct($country: CountryCode, $handle: String!)
  @inContext(country: $country) {
    product: productByHandle(handle: $handle) {
      id
      handle
      priceRange {
        ...MinMaxVariantPrice
      }
      compareAtPriceRange {
        ...MinMaxVariantPrice
      }
      requiresSellingPlan
      sellingPlanGroups(first: 1) {
        edges {
          node {
            ...SellingPlanGroup
          }
        }
      }
      variants(first: 250) {
        edges {
          node {
            ...CountryPriceVariant
          }
        }
      }
    }
  }
  ${fragments_1.default.Price}
  ${fragments_1.default.SellingPlan}
  ${fragments_1.default.SellingPlanGroup}
  ${fragments_1.default.MinMaxVariantPrice}
  ${fragments_1.default.SellingPlanAllocation}
  ${fragments_1.default.CountryPriceVariant}
`;
const getLocalizedVariant = (0, graphql_request_1.gql) `
  query getLocalizedVariant($country: CountryCode, $handle: String!, $selectedOptions: [SelectedOptionInput!]!)
  @inContext(country: $country) {
    product: productByHandle(handle: $handle) {
      id
      handle
      priceRange {
        ...MinMaxVariantPrice
      }
      compareAtPriceRange {
        ...MinMaxVariantPrice
      }
      variant: variantBySelectedOptions(selectedOptions: $selectedOptions) {
        ...CountryPriceSelectedVariant
      }
    }
  }
  ${fragments_1.default.Price}
  ${fragments_1.default.MinMaxVariantPrice}
  ${fragments_1.default.SellingPlan}
  ${fragments_1.default.SellingPlanAllocation}
  ${fragments_1.default.CountryPriceSelectedVariant}
`;
const getMetafield = (0, graphql_request_1.gql) `
  query getMetafield($country: CountryCode, $handle: String!, $key: String!, $namespace: String!)
  @inContext(country: $country) {
    product: productByHandle(handle: $handle) {
      handle
      id
      metafield(key: $key, namespace: $namespace) {
        ...Metafield
      }
    }
  }
  ${fragments_1.default.Metafield}
`;
const getVariantMetafield = (0, graphql_request_1.gql) `
  query getVariantMetafield($country: CountryCode, $handle: String!, $key: String!, $namespace: String!, $selectedOptions: [SelectedOptionInput!]!)
  @inContext(country: $country) {
    product: productByHandle(handle: $handle) {
      handle
      id
      selectedVariant: variantBySelectedOptions(selectedOptions: $selectedOptions) {
        id
        metafield(key: $key, namespace: $namespace) {
          ...Metafield
        }
      }
    }
  }
  ${fragments_1.default.Metafield}
`;
exports.queries = {
    getProductSellingPlans,
    getProductVariantSellingPlans,
    getInventory,
    getInventoryWithQuantity,
    getLocalizedProduct,
    getLocalizedVariant,
    getMetafield,
    getVariantMetafield,
};
//# sourceMappingURL=queries.js.map

/***/ }),

/***/ 8335:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(5556);
// new in V2
tslib_1.__exportStar(__webpack_require__(9901), exports);
tslib_1.__exportStar(__webpack_require__(476), exports);
tslib_1.__exportStar(__webpack_require__(5343), exports);
tslib_1.__exportStar(__webpack_require__(6722), exports);
tslib_1.__exportStar(__webpack_require__(9122), exports);
tslib_1.__exportStar(__webpack_require__(7080), exports);
tslib_1.__exportStar(__webpack_require__(9045), exports);
// Modified in v2
tslib_1.__exportStar(__webpack_require__(3269), exports); // renamed from useProductLiveInventory
// single products
tslib_1.__exportStar(__webpack_require__(9918), exports);
tslib_1.__exportStar(__webpack_require__(2631), exports);
tslib_1.__exportStar(__webpack_require__(2186), exports);
tslib_1.__exportStar(__webpack_require__(2237), exports);
tslib_1.__exportStar(__webpack_require__(6701), exports);
// listings and indexes
tslib_1.__exportStar(__webpack_require__(869), exports);
tslib_1.__exportStar(__webpack_require__(4433), exports);
tslib_1.__exportStar(__webpack_require__(7220), exports);
tslib_1.__exportStar(__webpack_require__(2701), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 9918:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProduct = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useProduct = (initial) => (0, store_1.useRecoilValue)(store_1.default.product) || initial;
exports.useProduct = useProduct;
//# sourceMappingURL=useProduct.js.map

/***/ }),

/***/ 2186:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductByHandle = void 0;
const tslib_1 = __webpack_require__(5556);
const react_1 = __webpack_require__(7378);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useProductStartFinishErrors_1 = __webpack_require__(2315);
const defaultProps = {
    handle: null,
    version: 'full',
    fetchOnMount: true,
    options: {},
};
const useProductByHandle = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useProductStartFinishErrors_1.useProductStartFinishErrors)({
        ...props.options,
        id: `product/${props?.handle}/getProductByHandle`,
    });
    let { handle, version } = props;
    const [product, setProduct] = (0, store_1.useRecoilState)(store_1.default.productByHandle({ handle, version }));
    const fetchProductByHandle = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        try {
            setStarted(true);
            if (product) {
                setFinished(true);
                if (callback)
                    callback(product);
                return product;
            }
            // if the user passes a handle via the fetcher prioritize it
            if (data?.handle) {
                handle = data.handle;
            }
            if (data?.version) {
                version = data.version;
            }
            let validationErrors = null;
            switch (true) {
                case !handle: {
                    validationErrors = ['handle not provided'];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                setErrors(validationErrors);
                return null;
            }
            const { error, product: _product } = await snapshot.getPromise(store_1.default.fetchProductByHandle({ handle, version }));
            if (error) {
                setErrors([error]);
            }
            if (!_product || !_product?.id) {
                setErrors([`invalid product response: ${_product}`]);
                return null;
            }
            setFinished(true);
            setProduct(_product);
            if (callback)
                callback(_product);
            return _product;
        }
        catch (error) {
            setErrors([error.message]);
            return null;
        }
    }, [handle, product, version]);
    // fetch json product on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !props.fetchOnMount,
            !handle,
            finished && product, // already have a product
        ];
        if (earlyExitIf.some(Boolean))
            return undefined;
        if (!unMounting) {
            setStarted(true);
        }
        fetchProductByHandle({ handle, version })
            .then((_product) => {
            if (!_product || unMounting)
                return;
            setProduct(_product);
        })
            .catch((error) => {
            console.error('failed to getProductByHandle due to', error.message);
        });
        return () => {
            unMounting = true;
        };
    }, [handle, props.fetchOnMount]);
    return {
        product,
        fetchProductByHandle,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useProductByHandle = useProductByHandle;
//# sourceMappingURL=useProductByHandle.js.map

/***/ }),

/***/ 2701:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductHandles = void 0;
const tslib_1 = __webpack_require__(5556);
const react_1 = __webpack_require__(7378);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useProductStartFinishErrors_1 = __webpack_require__(2315);
const defaultProps = { fetchOnMount: true, options: {} };
const useProductHandles = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useProductStartFinishErrors_1.useProductStartFinishErrors)({
        ...props.options,
        id: 'product/getProductHandles',
    });
    const [productHandles, setProductHandles] = (0, store_1.useRecoilState)(store_1.default.productHandles);
    const fetchProductHandles = (0, store_1.useRecoilCallback)(({ snapshot }) => async (_, callback) => {
        try {
            setStarted(true);
            // eslint-disable-next-line no-use-before-define
            if (productHandles) {
                setFinished(true);
                if (callback)
                    callback(productHandles);
                return productHandles;
            }
            const { error, productHandles: _productHandles } = await snapshot.getPromise(store_1.default.fetchProductHandles());
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!Array.isArray(_productHandles)) {
                setErrors([`invalid product response: ${_productHandles}`]);
                return null;
            }
            setFinished(true);
            setProductHandles(_productHandles);
            if (callback)
                callback(_productHandles);
            return _productHandles;
        }
        catch (error) {
            setErrors([error.message]);
            return null;
        }
    }, []);
    // fetch json product on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !props.fetchOnMount,
            finished && productHandles?.length, // already have a product
        ];
        if (earlyExitIf.some(Boolean))
            return undefined;
        fetchProductHandles()
            .then((jsonProductHandles) => {
            if (unMounting)
                return;
            // bad response
            if (!Array.isArray(jsonProductHandles)) {
                setErrors(['Invalid product handles response']);
                return;
            }
            setFinished(true);
            // all good update products, which in turns updates
            // the productByHandle family selector
            setProductHandles(jsonProductHandles);
        })
            .catch((error) => {
            if (!unMounting) {
                setErrors([error.message]);
            }
        });
        return () => {
            unMounting = true;
        };
    }, [props.fetchOnMount, productHandles]);
    return {
        productHandles,
        fetchProductHandles,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useProductHandles = useProductHandles;
//# sourceMappingURL=useProductHandles.js.map

/***/ }),

/***/ 3269:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductInventory = void 0;
const tslib_1 = __webpack_require__(5556);
const react_1 = __webpack_require__(7378);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const helpers_1 = __webpack_require__(5542);
const useProductStartFinishErrors_1 = __webpack_require__(2315);
const defaultProps = {
    handle: null,
    fetchOnMount: true,
    withQuantity: true,
    options: {},
};
const useProductInventory = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useProductStartFinishErrors_1.useProductStartFinishErrors)({
        ...props.options,
        id: `product/${props.handle}/getInventory`,
    });
    const recoilProduct = (0, store_1.useRecoilValue)(store_1.default.product);
    let handle = props.handle || recoilProduct?.handle;
    let { withQuantity } = props;
    const [inventory, setInventory] = (0, store_1.useRecoilState)(store_1.default.productInventory({ handle, withQuantity }));
    const getInventory = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        try {
            setStarted(true);
            if (inventory) {
                setFinished(true);
                if (callback)
                    callback(inventory);
                return inventory;
            }
            // if the user passes a handle via the fetcher prioritize it
            if (data?.handle) {
                handle = data.handle;
            }
            if (data?.withQuantity) {
                withQuantity = data.withQuantity;
            }
            let validationErrors = null;
            switch (true) {
                case !handle: {
                    validationErrors = ['handle not provided'];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                setErrors(validationErrors);
                return null;
            }
            const { error, product } = await snapshot.getPromise(store_1.default.fetchProductInventoryByHandle({ handle, withQuantity }));
            if (error) {
                setErrors([error]);
            }
            if (!product || !product?.id) {
                setErrors([`Invalid product live inventory response: ${product}`]);
                return null;
            }
            // convert variants array to keyed-object
            const _productInventory = {
                ...product,
                variants: product.variants.reduce((_variants, variant) => {
                    return { ..._variants, [(0, helpers_1.decodedId)(variant.id)]: variant };
                }, {}),
            };
            setFinished(true);
            setInventory(_productInventory);
            if (callback)
                callback(_productInventory);
            return _productInventory;
        }
        catch (error) {
            setErrors([error.message]);
            return null;
        }
    }, [handle, inventory, withQuantity]);
    // fetch json product on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [!props.fetchOnMount, !handle, finished && inventory];
        if (earlyExitIf.some(Boolean)) {
            return undefined;
        }
        getInventory({ handle, withQuantity })
            .then((liveInventory) => {
            if (!liveInventory || unMounting)
                return;
            setInventory(liveInventory);
        })
            .catch((error) => {
            console.error('failed to fetchInventoryOnMount due to', error.message);
        });
        return () => {
            unMounting = true;
        };
    }, [handle, props.fetchOnMount, inventory, withQuantity]);
    return {
        inventory,
        getInventory,
        finished,
        setStarted,
        setFinished,
        setErrors,
        ...status,
    };
};
exports.useProductInventory = useProductInventory;
//# sourceMappingURL=useProductInventory.js.map

/***/ }),

/***/ 2631:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductInventoryByHandle = void 0;
const useProductInventory_1 = __webpack_require__(3269);
const defaultProps = {
    handle: null,
    withQuantity: true,
    fetchOnMount: true,
    options: {},
};
const useProductInventoryByHandle = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    return (0, useProductInventory_1.useProductInventory)({
        handle: props.handle,
        withQuantity: typeof props.withQuantity === 'undefined' ? true : props.withQuantity,
        fetchOnMount: typeof props.fetchOnMount === 'undefined' ? true : props.fetchOnMount,
    });
};
exports.useProductInventoryByHandle = useProductInventoryByHandle;
//# sourceMappingURL=useProductInventoryByHandle.js.map

/***/ }),

/***/ 2237:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductItemByHandle = void 0;
const react_1 = __webpack_require__(7378);
const useProductByHandle_1 = __webpack_require__(2186);
const defaultProps = {
    handle: null,
    fetchOnMount: true,
    options: {},
};
// DEPRECATED - use useProductByHandle instead
const useProductItemByHandle = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { product: productItem, fetchProductByHandle, ...productByHandleStatus } = (0, useProductByHandle_1.useProductByHandle)(props);
    (0, react_1.useEffect)(() => {
        if (false) {}
    }, []);
    return {
        productItem,
        fetchProductItemByHandle: fetchProductByHandle,
        ...productByHandleStatus,
    };
};
exports.useProductItemByHandle = useProductItemByHandle;
//# sourceMappingURL=useProductItemByHandle.js.map

/***/ }),

/***/ 5343:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductMetafield = void 0;
const tslib_1 = __webpack_require__(5556);
/* eslint-disable no-undef */
const react_1 = __webpack_require__(7378);
const useProductStartFinishErrors_1 = __webpack_require__(2315);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const defaultProps = {
    handle: null,
    key: '',
    namespace: '',
    fetchOnMount: true,
    options: {},
};
const useProductMetafield = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useProductStartFinishErrors_1.useProductStartFinishErrors)({
        ...props.options,
        id: `product/${props?.handle}/getProductMetafield`,
    });
    const recoilProduct = (0, store_1.useRecoilValue)(store_1.default.product);
    let handle = props.handle || recoilProduct?.handle;
    let { key, namespace } = props;
    const [metafield, setMetafield] = (0, store_1.useRecoilState)(store_1.default.productMetafield({ handle, key, namespace }));
    const getMetafield = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        try {
            setStarted(true);
            // eslint-disable-next-line no-use-before-define
            if (metafield) {
                setFinished(true);
                if (callback)
                    callback(metafield);
                return metafield;
            }
            // if the user passes a handle via the fetcher prioritize it
            if (data?.handle) {
                handle = data.handle;
            }
            if (data?.key) {
                key = data.key;
            }
            if (data?.namespace) {
                namespace = data.namespace;
            }
            let validationErrors = null;
            switch (true) {
                case !handle: {
                    validationErrors = ['handle not provided'];
                    break;
                }
                case !key: {
                    validationErrors = ['key not provided'];
                    break;
                }
                case !namespace: {
                    validationErrors = ['namespace not provided'];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                setErrors(validationErrors);
                return null;
            }
            // get the metafield via the product client
            const { error, metafield: _metafield } = await snapshot.getPromise(store_1.default.fetchMetafield({ handle, key, namespace }));
            if (error) {
                setErrors([error]);
            }
            if (!_metafield) {
                setErrors([`Invalid product metafield response: ${_metafield}`]);
                return [];
            }
            setFinished(true);
            setMetafield(_metafield);
            if (callback)
                callback(_metafield);
            return _metafield;
        }
        catch (error) {
            setErrors([error.message]);
            return [];
        }
    }, [key, handle, namespace]);
    // fetch on change
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !handle,
            !key,
            !namespace,
            !props.fetchOnMount,
            finished && metafield, // already have metafield
        ];
        if (earlyExitIf.some(Boolean)) {
            return undefined;
        }
        getMetafield({ handle, key, namespace })
            .then((_metafield) => {
            if (unMounting || !_metafield)
                return;
            setMetafield(_metafield);
        })
            .catch((error) => {
            console.error('failed to getMetafield due to', error.message);
        });
        return () => {
            unMounting = true;
        };
    }, [handle, key, namespace, props.fetchOnMount]);
    return {
        metafield,
        getMetafield,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useProductMetafield = useProductMetafield;
//# sourceMappingURL=useProductMetafield.js.map

/***/ }),

/***/ 6701:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductRecommendations = void 0;
const tslib_1 = __webpack_require__(5556);
/* eslint-disable no-undef */
const react_1 = __webpack_require__(7378);
const useProductStartFinishErrors_1 = __webpack_require__(2315);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const defaultProps = {
    legacyResourceId: null,
    fetchOnMount: true,
    limit: 6,
    options: {},
};
const useProductRecommendations = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const recoilProduct = (0, store_1.useRecoilValue)(store_1.default.product);
    const product = props.product || recoilProduct;
    let { limit } = props;
    let legacyResourceId = props?.legacyResourceId || product?.legacyResourceId || null;
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useProductStartFinishErrors_1.useProductStartFinishErrors)({
        ...props.options,
        id: `product/${legacyResourceId}/getRecommendations`,
    });
    const [recommendations, setRecommendations] = (0, store_1.useRecoilState)(store_1.default.productRecommendations({
        productId: legacyResourceId,
        limit,
    }));
    const getRecommendations = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        try {
            setStarted(true);
            // if the user passes a handle via the fetcher prioritize it
            if (data?.legacyResourceId) {
                legacyResourceId = data.legacyResourceId;
            }
            if (data?.limit) {
                limit = data.limit;
            }
            let validationErrors = null;
            switch (true) {
                case !legacyResourceId: {
                    validationErrors = ['legacyResourceId not provided'];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                setErrors(validationErrors);
                return null;
            }
            const { error, recommendations: _recommendations } = await snapshot.getPromise(store_1.default.fetchProductRecommendations({
                productId: legacyResourceId,
                limit: limit || 6,
            }));
            if (error) {
                setErrors([error]);
            }
            if (!_recommendations) {
                setErrors([
                    `Invalid product recommendations response: ${_recommendations}`,
                ]);
                return [];
            }
            setFinished(true);
            setRecommendations(_recommendations);
            if (callback)
                callback(_recommendations);
            return _recommendations;
        }
        catch (error) {
            setErrors([error.message]);
            return [];
        }
    }, [legacyResourceId, limit]);
    // fetch recommendations on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [!props.fetchOnMount, !legacyResourceId, finished];
        if (earlyExitIf.some(Boolean)) {
            return undefined;
        }
        getRecommendations({ legacyResourceId, limit })
            // eslint-disable-next-line no-shadow
            .then((recommendations) => {
            if (!recommendations || unMounting)
                return;
            setRecommendations(recommendations);
        })
            .catch((error) => {
            console.error('failed to fetchRecommendationsOnMount due to', error.message);
        });
        return () => {
            unMounting = true;
        };
    }, [legacyResourceId, props.fetchOnMount, limit]);
    return {
        recommendations,
        getRecommendations,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useProductRecommendations = useProductRecommendations;
//# sourceMappingURL=useProductRecommendations.js.map

/***/ }),

/***/ 9122:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductRecommendationsByHandle = void 0;
const react_1 = __webpack_require__(7378);
const useProductRecommendations_1 = __webpack_require__(6701);
const useProductByHandle_1 = __webpack_require__(2186);
const useProductStartFinishErrors_1 = __webpack_require__(2315);
const defaultProps = {
    handle: null,
    fetchOnMount: true,
    limit: 6,
    options: {},
};
const useProductRecommendationsByHandle = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const [recommendations, setRecommendations] = (0, react_1.useState)([]);
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useProductStartFinishErrors_1.useProductStartFinishErrors)({
        ...props.options,
        id: `product/${props.handle}/getRecommendationsByHandle`,
    });
    // fetch the product by handle to find the legacyResourceId which
    // shopify recommendation API requires
    const { product, ...productStatus } = (0, useProductByHandle_1.useProductByHandle)({
        handle: props.handle,
    });
    const { getRecommendations } = (0, useProductRecommendations_1.useProductRecommendations)({
        fetchOnMount: false,
    });
    // fetch the recommendations once we have the product legacyResourceId
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        setStarted(true);
        const earlyExitIf = [!props.fetchOnMount, !product?.legacyResourceId];
        if (earlyExitIf.some(Boolean))
            return undefined;
        if (recommendations?.length) {
            setFinished(true);
            return undefined;
        }
        getRecommendations({
            legacyResourceId: product.legacyResourceId,
            limit: props.limit,
        })
            .then((_recommendations) => {
            if (!_recommendations || unMounting)
                return null;
            setFinished(true);
            setRecommendations(_recommendations);
            return _recommendations;
        })
            .catch((error) => {
            setErrors([error.message]);
            console.error('failed to fetchRecommendationsOnMount due to', error.message);
        });
        return () => {
            unMounting = true;
        };
    }, [productStatus?.finished, product?.handle, props.fetchOnMount]);
    return {
        recommendations,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useProductRecommendationsByHandle = useProductRecommendationsByHandle;
//# sourceMappingURL=useProductRecommendationsByHandle.js.map

/***/ }),

/***/ 7080:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductSearch = void 0;
const tslib_1 = __webpack_require__(5556);
/* eslint-disable no-undef */
const react_1 = __webpack_require__(7378);
const useProductStartFinishErrors_1 = __webpack_require__(2315);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const defaultProps = {
    term: null,
    fetchOnMount: true,
    limit: 6,
    options: {},
};
const useProductSearch = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useProductStartFinishErrors_1.useProductStartFinishErrors)({
        ...props.options,
        id: `product/search/${props.term}`,
    });
    let { term, limit } = props;
    const [results, setResults] = (0, store_1.useRecoilState)(store_1.default.productSearchResults(term));
    const getSearchResults = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        try {
            setStarted(true);
            // if the user passes a handle via the fetcher prioritize it
            if (data?.term) {
                term = data.term;
            }
            if (data?.limit) {
                limit = data.limit;
            }
            let validationErrors = null;
            switch (true) {
                case typeof term === 'undefined': {
                    validationErrors = ['term not provided'];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                setErrors(validationErrors);
                return null;
            }
            const { error, results: _results } = await snapshot.getPromise(store_1.default.fetchSearchResults({ term, limit }));
            if (error) {
                setErrors([error]);
            }
            if (!_results) {
                setErrors([`Invalid product search response: ${_results}`]);
                return [];
            }
            setFinished(true);
            setResults(_results);
            if (callback)
                callback(_results);
            return _results;
        }
        catch (error) {
            setErrors([error.message]);
            return [];
        }
    });
    // fetch results on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [!props.fetchOnMount, !term, finished];
        if (earlyExitIf.some(Boolean))
            return undefined;
        getSearchResults({ term, limit })
            // eslint-disable-next-line no-shadow
            .then((_results) => {
            if (unMounting)
                return;
            setResults(_results);
        })
            .catch((error) => {
            console.error('failed to getSearchResults due to', error.message);
        });
        return () => {
            unMounting = true;
        };
    }, [term, props.fetchOnMount, limit]);
    return {
        results,
        getSearchResults,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useProductSearch = useProductSearch;
//# sourceMappingURL=useProductSearch.js.map

/***/ }),

/***/ 9901:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductSellingPlans = void 0;
const tslib_1 = __webpack_require__(5556);
/* eslint-disable no-undef */
const react_1 = __webpack_require__(7378);
const useProductStartFinishErrors_1 = __webpack_require__(2315);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const defaultProps = {
    handle: null,
    fetchOnMount: true,
    options: {},
};
const useProductSellingPlans = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const recoilProduct = (0, store_1.useRecoilValue)(store_1.default.product);
    let handle = props.handle || recoilProduct?.handle;
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useProductStartFinishErrors_1.useProductStartFinishErrors)({
        ...props.options,
        id: `product/${handle}/getSellingPlans`,
    });
    const [sellingPlans, setSellingPlans] = (0, store_1.useRecoilState)(store_1.default.productSellingPlans({ handle }));
    const getSellingPlans = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        try {
            setStarted(true);
            // eslint-disable-next-line no-use-before-define
            if (sellingPlans) {
                setFinished(true);
                if (callback)
                    callback(sellingPlans);
                return sellingPlans;
            }
            // if the user passes a handle via the fetcher prioritize it
            if (data?.handle) {
                handle = data.handle;
            }
            let validationErrors = null;
            switch (true) {
                case !handle: {
                    validationErrors = ['handle not provided'];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                setErrors(validationErrors);
                return null;
            }
            const { error, product: _product } = await snapshot.getPromise(store_1.default.fetchProductSellingPlan({ handle }));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!_product || !_product?.sellingPlanGroups) {
                setErrors([`Invalid product selling plans response: ${_product}`]);
                return null;
            }
            setFinished(true);
            const { requiresSellingPlan, sellingPlanGroups } = _product;
            const response = { requiresSellingPlan, sellingPlanGroups };
            setSellingPlans(response);
            if (callback)
                callback(response);
            return response;
        }
        catch (error) {
            setErrors([error.message]);
            return null;
        }
    }, [handle]);
    // fetch on handle change
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !handle,
            !props.fetchOnMount,
            finished && sellingPlans, // already have recommendations
        ];
        if (earlyExitIf.some(Boolean))
            return undefined;
        getSellingPlans({ handle })
            .then((data) => {
            if (unMounting || !data)
                return;
            setSellingPlans(data);
        })
            .catch((error) => {
            console.error('failed to fetchProductSellingPlanByHandle due to', error.message);
        });
        return () => {
            unMounting = true;
        };
    }, [handle, props.fetchOnMount]);
    return {
        requiresSellingPlan: typeof sellingPlans?.requiresSellingPlan !== 'undefined'
            ? sellingPlans?.requiresSellingPlan
            : null,
        sellingPlanGroups: sellingPlans?.sellingPlanGroups || null,
        hasSellingPlans: sellingPlans?.sellingPlanGroups?.length > 0,
        getSellingPlans,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useProductSellingPlans = useProductSellingPlans;
//# sourceMappingURL=useProductSellingPlans.js.map

/***/ }),

/***/ 2315:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductStartFinishErrors = void 0;
const tslib_1 = __webpack_require__(5556);
const react_1 = __webpack_require__(7378);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const DEBUG = false;
const useProductStartFinishErrors = (options) => {
    const setCartStarted = (0, store_1.useSetRecoilState)(store_1.default.productStatusStarted('product/all'));
    const setCartFinished = (0, store_1.useSetRecoilState)(store_1.default.productStatusFinished('product/all'));
    const setCartSuccess = (0, store_1.useSetRecoilState)(store_1.default.productStatusSuccess('product/all'));
    const setCartErrors = (0, store_1.useSetRecoilState)(store_1.default.productStatusErrors('product/all'));
    const isCartId = /^cart/.test(options?.id);
    const [started, setStarted] = (0, store_1.useRecoilState)(store_1.default.productStatusStarted(options?.id || ''));
    const [finished, setFinished] = (0, store_1.useRecoilState)(store_1.default.productStatusFinished(options?.id || ''));
    const [success, setSuccess] = (0, store_1.useRecoilState)(store_1.default.productStatusSuccess(options?.id || ''));
    const [errors, setErrors] = (0, store_1.useRecoilState)(store_1.default.productStatusErrors(options?.id || ''));
    const autoReset = (0, react_1.useRef)(options?.autoReset || 0);
    const resetTimer = (0, react_1.useRef)(options?.resetTimer || null);
    // update local hook status
    const reset = (0, react_1.useCallback)(() => {
        if (typeof setErrors === 'undefined')
            return;
        setErrors([]);
        setStarted(false);
        setFinished(false);
        setSuccess(false);
        resetTimer.current = null;
    }, []);
    const updateStateOnErrors = () => {
        let unMounting = false;
        if (errors?.length > 0) {
            if (unMounting)
                return;
            setFinished(true);
            setSuccess(false);
        }
        // eslint-disable-next-line consistent-return
        return () => {
            unMounting = true;
        };
    };
    const updateStateOnFinished = () => {
        let unMounting = false;
        if (finished) {
            if (DEBUG) {
                console.groupCollapsed('status:', options?.id);
                console.log('started', started);
                console.log('errors', errors);
                console.log('finished', finished);
                console.log('success', success);
                console.groupEnd();
            }
            if (unMounting)
                return;
            const withoutErrors = errors?.length === 0;
            setStarted(false);
            setSuccess(withoutErrors);
            if (autoReset?.current) {
                const to = setTimeout(() => {
                    if (unMounting)
                        return;
                    reset();
                    clearTimeout(to);
                }, autoReset.current);
            }
        }
        // eslint-disable-next-line consistent-return
        return () => {
            unMounting = true;
        };
    };
    (0, react_1.useEffect)(() => {
        updateStateOnErrors();
    }, [errors?.length]);
    (0, react_1.useEffect)(() => {
        updateStateOnFinished();
    }, [finished, options?.id]);
    // update global cart status
    (0, react_1.useEffect)(() => {
        if (isCartId)
            setCartErrors(errors);
    }, [errors?.length]);
    (0, react_1.useEffect)(() => {
        if (isCartId)
            setCartStarted(started);
    }, [started]);
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        setCartFinished(finished);
        const to = setTimeout(() => {
            if (unMounting)
                return;
            setCartFinished(false);
            clearTimeout(to);
        }, 1000);
        return () => {
            unMounting = true;
        };
    }, [finished]);
    (0, react_1.useEffect)(() => {
        if (isCartId)
            setCartSuccess(success);
    }, [success]);
    return {
        started,
        setStarted,
        finished,
        setFinished,
        success,
        setSuccess,
        errors,
        setErrors,
        reset,
        resetTimer,
    };
};
exports.useProductStartFinishErrors = useProductStartFinishErrors;
//# sourceMappingURL=useProductStartFinishErrors.js.map

/***/ }),

/***/ 6722:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductVariantMetafield = void 0;
const tslib_1 = __webpack_require__(5556);
/* eslint-disable no-undef */
const react_1 = __webpack_require__(7378);
const useProductStartFinishErrors_1 = __webpack_require__(2315);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
// TODO: input should be selectedVariant, handle and selectedOptions should be decipher from it
// @see: useProductVariantPriceIn
const defaultProps = {
    handle: null,
    key: '',
    namespace: '',
    selectedOptions: null,
    fetchOnMount: true,
    options: {},
};
const useProductVariantMetafield = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const recoilProduct = (0, store_1.useRecoilValue)(store_1.default.product);
    let handle = props.handle || recoilProduct?.handle;
    let { key, namespace, selectedOptions } = props;
    const { finished, errors, setStarted, setFinished, setErrors, ...status } = (0, useProductStartFinishErrors_1.useProductStartFinishErrors)({
        ...props.options,
        id: `product/${handle}/${props?.key}/getProductVariantMetafield`,
    });
    const [metafield, setMetafield] = (0, store_1.useRecoilState)(store_1.default.productVariantMetafield({ handle, key, namespace, selectedOptions }));
    const getVariantMetafield = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        try {
            setStarted(true);
            // eslint-disable-next-line no-use-before-define
            if (metafield) {
                setFinished(true);
                if (callback)
                    callback(metafield);
                return metafield;
            }
            // if the user passes a handle via the fetcher prioritize it
            if (data?.handle) {
                handle = data.handle;
            }
            if (data?.key) {
                key = data.key;
            }
            if (data?.namespace) {
                namespace = data.namespace;
            }
            if (data?.selectedOptions) {
                selectedOptions = data.selectedOptions;
            }
            let validationErrors = null;
            switch (true) {
                case !handle: {
                    validationErrors = ['handle not provided'];
                    break;
                }
                case !key: {
                    validationErrors = ['key not provided'];
                    break;
                }
                case !namespace: {
                    validationErrors = ['namespace not provided'];
                    break;
                }
                case !selectedOptions: {
                    validationErrors = ['selectedOptions not provided'];
                    break;
                }
                case !Array.isArray(selectedOptions): {
                    // eslint-disable-next-line prettier/prettier
                    validationErrors = [
                        'get metafield failed "selectedOptions" must be an array',
                    ];
                    break;
                }
                case !selectedOptions[0]?.name || !selectedOptions[0]?.value: {
                    // eslint-disable-next-line prettier/prettier
                    validationErrors = [
                        'get metafield failed invalid "selectedOptions". Must be in the shape [{ name: "Size", value: "50 cm" }, ..]',
                    ];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                throw new Error(validationErrors[0]);
            }
            const { error, metafield: _metafield } = await snapshot.getPromise(store_1.default.fetchVariantMetafield({
                handle,
                key,
                namespace,
                selectedOptions,
            }));
            if (error) {
                throw new Error(error);
            }
            setFinished(true);
            setMetafield(_metafield);
            if (callback)
                callback(_metafield);
            return _metafield;
        }
        catch (error) {
            console.error('failed to getVariantMetafield due to', error.message);
            setErrors([error.message]);
            return null;
        }
    }, [key, handle, namespace, selectedOptions]);
    // fetch on change
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !handle,
            !key,
            !namespace,
            !selectedOptions,
            !props.fetchOnMount,
            finished && metafield,
            errors.length, // finished and errors
        ];
        if (earlyExitIf.some(Boolean)) {
            return undefined;
        }
        getVariantMetafield({ handle, key, namespace, selectedOptions })
            .then((_metafield) => {
            if (unMounting)
                return;
            setMetafield(_metafield);
        })
            .catch((error) => {
            console.error('failed to getVariantMetafield due to', error.message);
        });
        return () => {
            unMounting = true;
        };
    }, [handle, key, namespace, props.fetchOnMount, selectedOptions, finished]);
    return {
        metafield,
        getVariantMetafield,
        finished,
        errors,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useProductVariantMetafield = useProductVariantMetafield;
//# sourceMappingURL=useProductVariantMetafield.js.map

/***/ }),

/***/ 9045:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductVariantSellingPlan = void 0;
const tslib_1 = __webpack_require__(5556);
/* eslint-disable no-undef */
const react_1 = __webpack_require__(7378);
const useProductStartFinishErrors_1 = __webpack_require__(2315);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const defaultProps = {
    variant: { product: { handle: null }, selectedOptions: null, id: '' },
    countryCode: null,
    currency: null,
    fetchOnMount: true,
    options: {},
};
const useProductVariantSellingPlan = (passedProps) => {
    const countryFallback = (0, store_1.useRecoilValue)(store_1.default.country)?.isoCode;
    const currencyFallback = (0, store_1.useRecoilValue)(store_1.default.country)?.currency?.isoCode;
    const props = passedProps?.variant
        ? { ...defaultProps, ...passedProps }
        : defaultProps;
    let { handle } = props.variant.product;
    let { selectedOptions } = props.variant;
    let country = props.countryCode || countryFallback;
    let currency = props.currency || currencyFallback;
    const statusId = `product/${handle}/variant/${props.variant.id
        .split('/')
        .pop()}/${country}/${currency}/sellingPlan`;
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useProductStartFinishErrors_1.useProductStartFinishErrors)({ ...props.options, id: statusId });
    const [variantSub, setVariantSub] = (0, store_1.useRecoilState)(store_1.default.productVariantSellingPlan({
        handle,
        selectedOptions,
        country,
        currency,
    }));
    const getVariantSellingPlans = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        try {
            setStarted(true);
            // if the user passes a handle via the fetcher prioritize it
            if (data?.handle) {
                handle = data.handle;
            }
            if (data?.selectedOptions) {
                selectedOptions = data.selectedOptions;
            }
            if (data?.country) {
                country = data.country;
            }
            if (data?.currency) {
                currency = data.currency;
            }
            let validationErrors = null;
            switch (true) {
                case !handle: {
                    validationErrors = ['handle not provided'];
                    break;
                }
                case !selectedOptions: {
                    validationErrors = ['selectedOptions not provided'];
                    break;
                }
                case !country: {
                    validationErrors = ['country not provided'];
                    break;
                }
                case !currency: {
                    validationErrors = ['currency not provided'];
                    break;
                }
                default:
                    break;
            }
            if (validationErrors?.length) {
                setErrors(validationErrors);
                return null;
            }
            const { error, variant } = await snapshot.getPromise(store_1.default.fetchProductVariantSellingPlan({
                handle,
                selectedOptions,
                country,
                currency,
            }));
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!variant) {
                setErrors([
                    `Invalid product variant price in response: ${variant}`,
                ]);
                return null;
            }
            setFinished(true);
            setVariantSub(variant);
            if (callback)
                callback(variant);
            return variant;
        }
        catch (error) {
            setErrors([error.message]);
            return [];
        }
    });
    // fetch on handle change
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !handle,
            !selectedOptions?.length,
            !country,
            !currency,
            !props.fetchOnMount,
            finished && variantSub,
        ];
        if (earlyExitIf.some(Boolean)) {
            return undefined;
        }
        getVariantSellingPlans({ handle })
            .then((data) => {
            if (unMounting)
                return;
            setVariantSub(data);
        })
            .catch((error) => {
            console.error('failed to getVariantSellingPlans due to', error.message);
        });
        return () => {
            unMounting = true;
        };
    }, [
        handle,
        props.variant.id,
        selectedOptions,
        country,
        currency,
        variantSub,
    ]);
    return {
        variantSub: variantSub || null,
        getVariantSellingPlans,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useProductVariantSellingPlan = useProductVariantSellingPlan;
//# sourceMappingURL=useProductVariantSellingPlan.js.map

/***/ }),

/***/ 476:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductsFromHandles = void 0;
/* eslint-disable consistent-return */
const react_1 = __webpack_require__(7378);
const useProductStartFinishErrors_1 = __webpack_require__(2315);
const defaultProps = {
    handles: null,
    options: {},
};
const useProductsFromHandles = (passedProps = defaultProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useProductStartFinishErrors_1.useProductStartFinishErrors)({
        ...props.options,
        id: `product/${props?.handles?.join('/')}/getProductsFromHandles`,
    });
    const [products, setProducts] = (0, react_1.useState)(null);
    const [productsMap, setProductsMap] = (0, react_1.useState)(null);
    // fetch bundle products from handles
    (0, react_1.useEffect)(() => {
        if (!props.handles?.length) {
            return;
        }
        if (products?.length) {
            setFinished(true);
            return;
        }
        setStarted(true);
        let unMounting;
        const fetchProductFromHandle = (handle) => {
            // if we have already fetched return it, else fetch it
            const product = products?.[handle] || null;
            if (product)
                return product;
            const endpoint = `/json/products/${handle}.json`;
            // eslint-disable-next-line no-undef
            return fetch(endpoint)
                .then((response) => response.json())
                .catch((error) => {
                // console.error('Problem fetching', handle, error.message);
                setErrors([error.message]);
                return { handle };
            });
        };
        const setBundleProducts = (_products) => {
            if (!_products?.length) {
                // didn't fetch
                if (unMounting)
                    return;
                setFinished(true);
                return;
            }
            // have fetched products
            if (unMounting)
                return;
            // we return a products map keyed by handle — not an array
            const mergedProducts = (prevProducts) => {
                const newProducts = _products.reduce((byHandle, product) => {
                    return {
                        ...byHandle,
                        [product.handle]: product,
                    };
                }, {});
                return {
                    ...prevProducts,
                    ...newProducts,
                };
            };
            if (unMounting)
                return;
            setFinished(true);
            setProducts(_products);
            setProductsMap(mergedProducts);
        };
        const bundleProductsPromises = props.handles.map(fetchProductFromHandle);
        Promise.all(bundleProductsPromises).then(setBundleProducts);
        return () => {
            unMounting = true;
        };
    }, [props.handles?.join('|')]);
    return {
        products,
        productsMap,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useProductsFromHandles = useProductsFromHandles;
//# sourceMappingURL=useProductsFromHandles.js.map

/***/ }),

/***/ 869:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductsIndex = void 0;
const tslib_1 = __webpack_require__(5556);
const react_1 = __webpack_require__(7378);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useProductStartFinishErrors_1 = __webpack_require__(2315);
const defaultProps = {
    fetchOnMount: true,
    options: {},
};
const useProductsIndex = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useProductStartFinishErrors_1.useProductStartFinishErrors)({
        ...props.options,
        id: 'product/productsIndex',
    });
    const [productsIndex, setProductsIndex] = (0, store_1.useRecoilState)(store_1.default.productsIndex);
    const fetchProductHandles = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        try {
            setStarted(true);
            // eslint-disable-next-line no-use-before-define
            if (productsIndex) {
                setFinished(true);
                if (callback)
                    callback(productsIndex);
                return productsIndex;
            }
            const { error, productsIndex: _productsIndex } = await snapshot.getPromise(store_1.default.fetchProductsIndex());
            if (error) {
                setErrors([error]);
            }
            if (!_productsIndex) {
                setErrors([`invalid product response: ${_productsIndex}`]);
                return null;
            }
            setFinished(true);
            setProductsIndex(_productsIndex);
            if (callback)
                callback(_productsIndex);
            return _productsIndex;
        }
        catch (error) {
            setErrors([error.message]);
            return null;
        }
    }, []);
    // fetch json product on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !props.fetchOnMount,
            finished && productsIndex?.length, // already have a product
        ];
        if (earlyExitIf.some(Boolean))
            return undefined;
        if (!unMounting) {
            setStarted(true);
        }
        fetchProductHandles()
            .then((jsonProductsIndex) => {
            if (unMounting)
                return;
            // bad response
            if (!jsonProductsIndex) {
                setErrors(['Invalid products index response']);
                return;
            }
            setFinished(true);
            // all good update products, which in turns updates
            // the productByHandle family selector
            setProductsIndex(jsonProductsIndex);
        })
            .catch((error) => {
            if (!unMounting) {
                setErrors([error.message]);
            }
        });
        return () => {
            unMounting = true;
        };
    }, [props.fetchOnMount, productsIndex]);
    return {
        productsIndex,
        fetchProductHandles,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useProductsIndex = useProductsIndex;
//# sourceMappingURL=useProductsIndex.js.map

/***/ }),

/***/ 4433:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductsList = void 0;
const tslib_1 = __webpack_require__(5556);
const react_1 = __webpack_require__(7378);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useProductStartFinishErrors_1 = __webpack_require__(2315);
const defaultProps = {
    fetchOnMount: true,
    options: {},
};
const useProductsList = (passedPops) => {
    const props = { ...defaultProps, ...passedPops };
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useProductStartFinishErrors_1.useProductStartFinishErrors)({
        ...props.options,
        id: 'product/productsList',
    });
    const [productsList, setProductsList] = (0, store_1.useRecoilState)(store_1.default.productsList);
    const fetchProductsList = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        try {
            setStarted(true);
            // eslint-disable-next-line no-use-before-define
            if (productsList) {
                setFinished(true);
                if (callback)
                    callback(productsList);
                return productsList;
            }
            const { error, productsList: _productsList } = await snapshot.getPromise(store_1.default.fetchProductsList());
            if (error) {
                setErrors([error]);
            }
            if (!_productsList || !Array.isArray(_productsList)) {
                setErrors([`invalid product list response: ${_productsList}`]);
                return null;
            }
            setFinished(true);
            setProductsList(_productsList);
            if (callback)
                callback(_productsList);
            return _productsList;
        }
        catch (error) {
            setErrors([error.message]);
            return null;
        }
    }, []);
    // fetch json product on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !props.fetchOnMount,
            finished && productsList?.length, // already have a product
        ];
        if (earlyExitIf.some(Boolean))
            return undefined;
        fetchProductsList()
            .then((jsonProductsList) => {
            if (unMounting)
                return;
            // bad response
            if (!Array.isArray(jsonProductsList)) {
                setErrors(['Invalid products index response']);
                return;
            }
            setFinished(true);
            // all good update products, which in turns updates
            // the productByHandle family selector
            setProductsList(jsonProductsList);
        })
            .catch((error) => {
            if (!unMounting) {
                setErrors([error.message]);
            }
        });
        return () => {
            unMounting = true;
        };
    }, [props.fetchOnMount, productsList]);
    return {
        productsList,
        fetchProductsList,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useProductsList = useProductsList;
//# sourceMappingURL=useProductsList.js.map

/***/ }),

/***/ 7220:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useProductsUniq = void 0;
const tslib_1 = __webpack_require__(5556);
const react_1 = __webpack_require__(7378);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useProductStartFinishErrors_1 = __webpack_require__(2315);
const defaultProps = { fetchOnMount: true, options: {} };
const useProductsUniq = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const { finished, setStarted, setFinished, setErrors, ...status } = (0, useProductStartFinishErrors_1.useProductStartFinishErrors)({
        ...props.options,
        id: 'product/productsUniq',
    });
    const [productsUniq, setProductsUniq] = (0, store_1.useRecoilState)(store_1.default.productsUniq);
    const fetchProductsUniq = (0, store_1.useRecoilCallback)(({ snapshot }) => async (data, callback) => {
        try {
            setStarted(true);
            // eslint-disable-next-line no-use-before-define
            if (productsUniq) {
                setFinished(true);
                if (callback)
                    callback(productsUniq);
                return productsUniq;
            }
            const { error, productsUniq: _productsUniq } = await snapshot.getPromise(store_1.default.fetchProductsUniq());
            if (error) {
                setErrors([error]);
            }
            if (!_productsUniq) {
                setErrors([`invalid product uniq response: ${_productsUniq}`]);
                return null;
            }
            setFinished(true);
            setProductsUniq(_productsUniq);
            if (callback)
                callback(_productsUniq);
            return _productsUniq;
        }
        catch (error) {
            setErrors([error.message]);
            return null;
        }
    }, []);
    // fetch json product on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [
            !props.fetchOnMount,
            finished && productsUniq, // already have a product
        ];
        if (earlyExitIf.some(Boolean))
            return undefined;
        if (!unMounting) {
            setStarted(true);
        }
        fetchProductsUniq()
            .then((jsonProductsUniq) => {
            if (unMounting)
                return;
            // bad response
            if (!jsonProductsUniq) {
                setErrors(['Invalid products uniq response']);
                return;
            }
            setFinished(true);
            // all good update products, which in turns updates
            // the productByHandle family selector
            setProductsUniq(jsonProductsUniq);
        })
            .catch((error) => {
            if (!unMounting) {
                setErrors([error.message]);
            }
        });
        return () => {
            unMounting = true;
        };
    }, [props.fetchOnMount, productsUniq]);
    return {
        productsUniq,
        fetchProductsUniq,
        finished,
        setErrors,
        setFinished,
        setStarted,
        ...status,
    };
};
exports.useProductsUniq = useProductsUniq;
//# sourceMappingURL=useProductsUniq.js.map

/***/ }),

/***/ 1857:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.productStore = void 0;
var product_1 = __webpack_require__(7099);
Object.defineProperty(exports, "productStore", ({ enumerable: true, get: function () { return product_1.productStore; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 7099:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.productStore = void 0;
const tslib_1 = __webpack_require__(5556);
/* eslint-disable max-lines */
const recoil_1 = __webpack_require__(9853);
const effects_1 = tslib_1.__importDefault(__webpack_require__(9025));
const store_1 = __webpack_require__(437);
const client_1 = __webpack_require__(5431);
const client = new client_1.ProductClient({
    apiToken: "3bc6486eea19d75d4dd39479084d4c7a",
    apiVersion: '2025-04',
    domain: "clearly-filtered.myshopify.com",
});
/**
  Product State
*/
const product = (0, recoil_1.atom)({
    key: 'product/product',
    default: null,
    effects: [
        // effects.logStateChange('product'),
        effects_1.default.onChange({
            key: 'product',
            topic: 'PRODUCT_UPDATE',
            actions: ['publishBusEvent'],
        }),
    ],
});
const productByHandle = (0, recoil_1.atomFamily)({
    key: 'product/byHandle',
    default: null,
});
const productInventory = (0, recoil_1.atomFamily)({
    key: 'product/inventory',
    default: null,
});
const productSellingPlans = (0, recoil_1.atomFamily)({
    key: 'product/sellingPlans',
    default: null,
});
// market/country price
const productPriceIn = (0, recoil_1.atomFamily)({
    key: 'product/priceIn',
    default: null,
});
const productVariantPriceIn = (0, recoil_1.atomFamily)({
    key: 'product/variantPriceIn',
    default: null,
});
const productVariantSellingPlan = (0, recoil_1.atomFamily)({
    key: 'product/variantSellingPlan',
    default: null,
});
const productRecommendations = (0, recoil_1.atomFamily)({
    key: 'product/recommendations',
    default: [],
});
const productSearchResults = (0, recoil_1.atomFamily)({
    key: 'product/searchResults',
    default: [],
});
const productMetafield = (0, recoil_1.atomFamily)({
    key: 'product/metafield',
    default: null,
});
const productVariantMetafield = (0, recoil_1.atomFamily)({
    key: 'product/variantMetafield',
    default: null,
});
const productsList = (0, recoil_1.atom)({
    key: 'product/productsList',
    default: null,
});
const productsUniq = (0, recoil_1.atom)({
    key: 'product/productsUniq',
    default: null, // { types: [], vendors: [], options: [] }
});
// products json fuse index
const productsIndex = (0, recoil_1.atom)({
    key: 'product/productsIndex',
    default: null,
});
const productHandles = (0, recoil_1.atom)({
    key: 'product/productHandles',
    default: null, // []
});
/* Status */
const productStatusStarted = (0, recoil_1.atomFamily)({
    key: 'product/statusStarted',
    default: false,
});
const productStatusFinished = (0, recoil_1.atomFamily)({
    key: 'product/statusFinished',
    default: false,
});
const productStatusSuccess = (0, recoil_1.atomFamily)({
    key: 'product/statusSuccess',
    default: false,
});
const productStatusErrors = (0, recoil_1.atomFamily)({
    key: 'product/statusErrors',
    default: [],
});
/*
  Async fetchers
*/
const fetchProductByHandle = (0, recoil_1.selectorFamily)({
    key: 'product/fetchProductByHandle',
    get: ({ handle, version }) => async () => {
        return client.getByHandle({
            handle,
            version,
        });
    },
});
const fetchProductInventoryByHandle = (0, recoil_1.selectorFamily)({
    key: 'product/fetchProductInventoryByHandle',
    get: (data) => async ({ get }) => {
        const country = get(store_1.shopStore.country);
        const passedCountryCode = data?.country?.isoCode || data?.country;
        const _country = passedCountryCode || country?.isoCode || 'US';
        return client.getInventory({
            ...data,
            country: _country,
        });
    },
});
const fetchProductSellingPlan = (0, recoil_1.selectorFamily)({
    key: 'product/fetchProductSellingPlan',
    get: (data) => async ({ get }) => {
        const country = get(store_1.shopStore.country);
        const passedCountryCode = data?.country?.isoCode || data?.country;
        const _country = passedCountryCode || country?.isoCode || 'US';
        return client.getSellingPlans({
            ...data,
            country: _country,
        });
    },
});
const fetchProductVariantSellingPlan = (0, recoil_1.selectorFamily)({
    key: 'product/fetchProductVariantSellingPlan',
    get: (data) => async ({ get }) => {
        const country = get(store_1.shopStore.country);
        const passedCountryCode = data?.country?.isoCode || data?.country;
        const _country = passedCountryCode || country?.isoCode || 'US';
        return client.getVariantSellingPlans({
            ...data,
            country: _country,
            locale: country?.locale,
        });
    },
});
const fetchProductHandles = (0, recoil_1.selectorFamily)({
    key: 'product/fetchProductHandles',
    get: () => async () => {
        return client.getHandles();
    },
});
const fetchProductsList = (0, recoil_1.selectorFamily)({
    key: 'product/fetchProductsList',
    get: () => async () => {
        return client.getList();
    },
});
const fetchProductsUniq = (0, recoil_1.selectorFamily)({
    key: 'product/fetchProductsUniq',
    get: () => async () => {
        return client.getUniq();
    },
});
const fetchProductsIndex = (0, recoil_1.selectorFamily)({
    key: 'product/fetchProductsIndex',
    get: () => async () => {
        return client.getIndex();
    },
});
const fetchProductRecommendations = (0, recoil_1.selectorFamily)({
    key: 'product/fetchProductRecommendations',
    get: ({ productId, limit }) => async () => {
        return client.getRecommendations({
            productId,
            limit,
        });
    },
});
const fetchSearchResults = (0, recoil_1.selectorFamily)({
    key: 'product/fetchSearchResults',
    get: ({ term, limit }) => async () => {
        return client.searchProducts({
            term,
            limit,
        });
    },
});
const fetchMetafield = (0, recoil_1.selectorFamily)({
    key: 'product/fetchMetafield',
    get: ({ handle, key, namespace }) => async () => {
        return client.getMetafield({
            handle,
            key,
            namespace,
        });
    },
});
const fetchVariantMetafield = (0, recoil_1.selectorFamily)({
    key: 'product/fetchVariantMetafield',
    get: ({ handle, key, namespace, selectedOptions }) => async () => {
        return client.getVariantMetafield({
            handle,
            key,
            namespace,
            selectedOptions,
        });
    },
});
exports.productStore = {
    // actual state - atoms
    product,
    productPriceIn,
    productVariantPriceIn,
    productVariantSellingPlan,
    productSellingPlans,
    productInventory,
    productByHandle,
    productMetafield,
    productVariantMetafield,
    productRecommendations,
    productSearchResults,
    productsIndex,
    productsList,
    productsUniq,
    productHandles,
    // status
    productStatusStarted,
    productStatusFinished,
    productStatusSuccess,
    productStatusErrors,
    // async fetches
    fetchProductByHandle,
    fetchProductSellingPlan,
    fetchProductVariantSellingPlan,
    fetchProductInventoryByHandle,
    fetchProductHandles,
    fetchProductsList,
    fetchProductsUniq,
    fetchProductsIndex,
    fetchProductRecommendations,
    fetchSearchResults,
    fetchMetafield,
    fetchVariantMetafield,
};
//# sourceMappingURL=product.js.map

/***/ }),

/***/ 972:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(5556);
tslib_1.__exportStar(__webpack_require__(2962), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2962:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.withRouter = exports.useRouter = exports.Router = void 0;
const tslib_1 = __webpack_require__(5556);
const router_1 = tslib_1.__importStar(__webpack_require__(6677));
exports.Router = router_1.default;
exports.useRouter = router_1.useRouter;
exports.withRouter = router_1.withRouter;
//# sourceMappingURL=useRouter.js.map

/***/ }),

/***/ 5852:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(5556);
tslib_1.__exportStar(__webpack_require__(2842), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 2842:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useSettings = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useSettings = () => {
    return (0, store_1.useRecoilValue)(store_1.default.storefrontSettings);
};
exports.useSettings = useSettings;
//# sourceMappingURL=useSettings.js.map

/***/ }),

/***/ 8584:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.settingsStore = void 0;
var settings_1 = __webpack_require__(1782);
Object.defineProperty(exports, "settingsStore", ({ enumerable: true, get: function () { return settings_1.settingsStore; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 1782:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.settingsStore = void 0;
const recoil_1 = __webpack_require__(9853);
const storefrontSettings = (0, recoil_1.atom)({
    key: 'storefront/settings',
    default: null,
    effects: [],
});
exports.settingsStore = {
    // actual state - atoms
    storefrontSettings,
};
//# sourceMappingURL=settings.js.map

/***/ }),

/***/ 5587:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ShopClient = void 0;
const tslib_1 = __webpack_require__(5556);
const graphql_request_1 = __webpack_require__(3671);
const humanize_graphql_response_1 = tslib_1.__importDefault(__webpack_require__(7207));
const queries_1 = __webpack_require__(5982);
class ShopClient {
    constructor({ apiToken, apiVersion, domain, debug }) {
        this.apiToken = apiToken;
        this.apiVersion = apiVersion;
        this.domain = domain;
        this.endpoint = '';
        this.options = {};
        this.debug = debug || false;
        this.client = this.init();
    }
    init() {
        this.endpoint = `https://${this.domain}/api/${this.apiVersion}/graphql.json`;
        // client
        this.options = {
            method: 'POST',
            mode: 'cors',
            headers: {
                'X-Shopify-Storefront-Access-Token': this.apiToken,
                'Content-Type': 'application/json; charset=utf-8',
            },
        };
        return new graphql_request_1.GraphQLClient(this.endpoint, this.options);
    }
    /**
     * Customer queries client
     * @param {gqlQuery} query
     * @param {object} variables
     * @returns
     */
    async query({ query, variables }) {
        if (this.debug) {
            console.log('ShopClient:', query, variables);
        }
        return this.client.rawRequest(query, variables);
    }
    /**
     * Customer mutation client
     * @param {gqlMutation} mutation
     * @param {object} variables
     * @returns
     */
    async mutate({ mutation, variables }) {
        if (this.debug) {
            console.log('ShopClient:', mutation, variables);
        }
        return this.client.rawRequest(mutation, variables);
    }
    /**
     * Query the storefront shop object data
     * @param {String} country
     */
    async getShop() {
        try {
            const request = await this.query({
                query: queries_1.queries.shop,
                variables: {},
            });
            const shop = request?.data?.shop;
            return { error: null, data: (0, humanize_graphql_response_1.default)(shop) };
        }
        catch (error) {
            return { error: error.message, data: null };
        }
    }
    /**
     * Query all countries locales
     * @param {String} country
     */
    async getLocales(props) {
        try {
            const { countryCode } = props;
            const request = await this.query({
                query: queries_1.queries.localization,
                variables: { country: countryCode },
            });
            const localization = request?.data?.localization;
            const countryCodes = localization.availableCountries.map((_country) => _country?.isoCode);
            // eslint-disable-next-line no-undef
            const localesRequest = await fetch('/api/shopify/locales', {
                method: 'POST',
                body: JSON.stringify({ countryCodes }),
            });
            const { response } = await localesRequest.json();
            if (!response) {
                throw new Error('getLocales: shopify locales response not ok');
            }
            const { locales } = response;
            return { error: null, data: locales };
        }
        catch (error) {
            console.error('getLocales:error', error.message);
            return { error: error.message, data: null };
        }
    }
    /**
     * Query available countries and currencies
     * @param {String} country
     * @see https://shopify.dev/custom-storefronts/products/international-pricing#query-available-countries-and-currencies
     */
    async getCountries(props) {
        try {
            if (!props?.countryCode) {
                throw new Error('getCountries: missing primary countryCode');
            }
            if (!props?.currencyCode) {
                throw new Error('getCountries: missing primary currencyCode');
            }
            if (!props?.currencies) {
                throw new Error('getCountries: missing currencies');
            }
            const { countryCode } = props;
            const request = await this.query({
                query: queries_1.queries.localization,
                variables: { country: countryCode },
            });
            if (request.status !== 200) {
                throw new Error(`getCountries: response error ${request.status}`);
            }
            const data = (0, humanize_graphql_response_1.default)(request?.data);
            const localization = data?.localization; // { availableCountries: [...], country: {..} }
            // fetch local for each available country and add it to each item
            const { data: locales } = await this.getLocales({ countryCode });
            const countryWithLocale = (_country) => {
                const locale = locales[_country?.isoCode];
                // if we don't a full locale for this country filter it out. Kosovo and Netherland Antilles
                // currently missing from country-locale-map@^1.8.0. I've requested the developer to add them.
                // @see: https://github.com/atnmorrison/country-locale-map/issues/27
                if (!locale)
                    return null;
                return { ..._country, locale: locales[_country?.isoCode] };
            };
            // default country
            localization.country.locale = locales[localization.country?.isoCode];
            // all available countries in the store (not the same as enabled markets)
            localization.availableCountries = localization.availableCountries
                .map(countryWithLocale)
                .filter(Boolean);
            /*
              Each currency represents an enabled market,
              if only one is set then markets are disabled
            */
            if (props.currencies?.length === 1) {
                localization.activeCountries = [localization.country];
            }
            else {
                // multiple markets enabled, filter
                localization.activeCountries = localization.availableCountries.filter((country) => {
                    return props.currencies.includes(country.locale.currency);
                });
            }
            return {
                error: null,
                data: localization,
            };
        }
        catch (error) {
            return { error: error.message, data: null };
        }
    }
}
exports.ShopClient = ShopClient;
//# sourceMappingURL=client.js.map

/***/ }),

/***/ 465:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const graphql_request_1 = __webpack_require__(3671);
const Country = (0, graphql_request_1.gql) `
  fragment Country on Country {
    currency {
      isoCode
      name
      symbol
    }
    isoCode
    name
    unitSystem
  }
`;
const Policy = (0, graphql_request_1.gql) `
  fragment Policy on ShopPolicy {
    handle
    id
    title
    body
    __typename
  }
`;
exports["default"] = {
    Country,
    Policy,
};
//# sourceMappingURL=fragments.js.map

/***/ }),

/***/ 6574:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ShopClient = void 0;
var client_1 = __webpack_require__(5587);
Object.defineProperty(exports, "ShopClient", ({ enumerable: true, get: function () { return client_1.ShopClient; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 5982:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.queries = void 0;
const tslib_1 = __webpack_require__(5556);
/* eslint-disable prettier/prettier */
const graphql_request_1 = __webpack_require__(3671);
const fragments_1 = tslib_1.__importDefault(__webpack_require__(465));
/*
  Queries
*/
const shop = (0, graphql_request_1.gql) `
  query {
    shop {
      description
      moneyFormat
      name
      paymentSettings {
        acceptedCardBrands
        cardVaultUrl
        countryCode
        currencyCode
        enabledPresentmentCurrencies
        supportedDigitalWallets
        shopifyPaymentsAccountId
      }
      primaryDomain {
        host
        sslEnabled
        url
      }
      shipsToCountries
    }
  }
`;
const localization = (0, graphql_request_1.gql) `
  query ($country: CountryCode) @inContext(country: $country) {
    shop {
      paymentSettings {
        enabledCurrencies: enabledPresentmentCurrencies
      }
    }
    localization {
      availableCountries {
        ...Country
      }
      country {
        ...Country
      }
    }
  }
  ${fragments_1.default.Country}
`;
exports.queries = {
    localization,
    shop,
};
//# sourceMappingURL=queries.js.map

/***/ }),

/***/ 2022:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLocale = exports.useAvailableCountries = exports.useCountries = exports.useCountry = exports.useCurrencies = exports.useCurrency = exports.useShop = exports.useStorefrontInit = exports.useCountriesInit = exports.useShopInit = void 0;
var useShopInit_1 = __webpack_require__(3840);
Object.defineProperty(exports, "useShopInit", ({ enumerable: true, get: function () { return useShopInit_1.useShopInit; } }));
var useCountriesInit_1 = __webpack_require__(7344);
Object.defineProperty(exports, "useCountriesInit", ({ enumerable: true, get: function () { return useCountriesInit_1.useCountriesInit; } }));
// eslint-disable-next-line import/no-cycle
var useStorefrontInit_1 = __webpack_require__(8123); // new on v2
Object.defineProperty(exports, "useStorefrontInit", ({ enumerable: true, get: function () { return useStorefrontInit_1.useStorefrontInit; } }));
// getters
var useShop_1 = __webpack_require__(9056);
Object.defineProperty(exports, "useShop", ({ enumerable: true, get: function () { return useShop_1.useShop; } }));
var useCurrency_1 = __webpack_require__(8422);
Object.defineProperty(exports, "useCurrency", ({ enumerable: true, get: function () { return useCurrency_1.useCurrency; } }));
var useCurrencies_1 = __webpack_require__(371);
Object.defineProperty(exports, "useCurrencies", ({ enumerable: true, get: function () { return useCurrencies_1.useCurrencies; } }));
var useCountry_1 = __webpack_require__(5030);
Object.defineProperty(exports, "useCountry", ({ enumerable: true, get: function () { return useCountry_1.useCountry; } }));
var useCountries_1 = __webpack_require__(2411);
Object.defineProperty(exports, "useCountries", ({ enumerable: true, get: function () { return useCountries_1.useCountries; } }));
var useAvailableCountries_1 = __webpack_require__(7310);
Object.defineProperty(exports, "useAvailableCountries", ({ enumerable: true, get: function () { return useAvailableCountries_1.useAvailableCountries; } }));
var useLocale_1 = __webpack_require__(6376);
Object.defineProperty(exports, "useLocale", ({ enumerable: true, get: function () { return useLocale_1.useLocale; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 7310:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useAvailableCountries = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const helpers_1 = __webpack_require__(5542);
const useAvailableCountries = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const availableCountries = (0, store_1.useRecoilValue)(store_1.default.availableCountries);
    return isMounted ? availableCountries : null;
};
exports.useAvailableCountries = useAvailableCountries;
//# sourceMappingURL=useAvailableCountries.js.map

/***/ }),

/***/ 2411:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCountries = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const helpers_1 = __webpack_require__(5542);
const useCountries = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const countries = (0, store_1.useRecoilValue)(store_1.default.countries);
    return isMounted ? countries : null;
};
exports.useCountries = useCountries;
//# sourceMappingURL=useCountries.js.map

/***/ }),

/***/ 7344:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCountriesInit = void 0;
const tslib_1 = __webpack_require__(5556);
const react_1 = __webpack_require__(7378);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useShopStartFinishErrors_1 = __webpack_require__(1108);
const defaultProps = {
    fetchOnMount: false,
    options: {},
};
const useCountriesInit = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const [country, setCountry] = (0, store_1.useRecoilState)(store_1.default.country);
    const [countries, setCountries] = (0, store_1.useRecoilState)(store_1.default.countries);
    const [availableCountries, setAvailableCountries] = (0, store_1.useRecoilState)(store_1.default.availableCountries);
    const { setStarted, setFinished, setErrors, finished, ...status } = (0, useShopStartFinishErrors_1.useShopStartFinishErrors)({
        ...props.options,
        id: `shop/countries/init`,
    });
    const getCountries = (0, store_1.useRecoilCallback)(({ snapshot }) => async (_, callback) => {
        setStarted(true);
        const release = snapshot.retain();
        try {
            // can pass accessToken or will use the on in store
            const { error, data: response } = await snapshot.getPromise(store_1.default.fetchCountries());
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!response?.country) {
                setErrors(['countries init response missing country data']);
                return null;
            }
            if (!response?.country?.name) {
                setErrors(['countries init invalid response']);
                return null;
            }
            const { country: _country, availableCountries: _availableCountries, activeCountries: _countries, } = response;
            setFinished(true);
            setAvailableCountries(_availableCountries);
            // mark the primary market as default
            const primaryCountry = { ..._country, isPrimary: true };
            const countriesWithPrimary = _countries.map((__country) => {
                if (__country?.isoCode === primaryCountry?.isoCode) {
                    return primaryCountry;
                }
                return __country;
            });
            // if we don't have a persisted country we set the shop default as default
            if (!country) {
                setCountry(primaryCountry);
            }
            setCountries(countriesWithPrimary);
            const data = {
                country: primaryCountry,
                countries: countriesWithPrimary,
                availableCountries: _availableCountries,
            };
            if (callback)
                callback(data);
            return data;
        }
        catch (error) {
            console.error(`getCountries:error ${error.message}`);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    // fetch on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [!props.fetchOnMount, finished];
        if (earlyExitIf.some(Boolean)) {
            return undefined;
        }
        getCountries()
            // eslint-disable-next-line no-shadow
            .then((data) => {
            if (unMounting || !data)
                return null;
            if (!country) {
                setCountry(data.country);
            }
            setCountries(data.countries);
            return data;
        })
            .catch((error) => {
            console.error('failed to getCountries due to', error.message);
        });
        return () => {
            unMounting = true;
        };
    }, [props.fetchOnMount, country, finished]);
    return {
        country,
        countries,
        availableCountries,
        getCountries,
        finished,
        setStarted,
        setFinished,
        setErrors,
        ...status,
    };
};
exports.useCountriesInit = useCountriesInit;
//# sourceMappingURL=useCountriesInit.js.map

/***/ }),

/***/ 5030:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCountry = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const helpers_1 = __webpack_require__(5542);
const useShopStartFinishErrors_1 = __webpack_require__(1108);
const useCartUpdateBuyerIdentity_1 = __webpack_require__(4717);
const useCountry = (options) => {
    const isMounted = (0, helpers_1.useMounted)();
    const country = (0, store_1.useRecoilValue)(store_1.default.country);
    const { setStarted, setFinished, setErrors, ...status } = (0, useShopStartFinishErrors_1.useShopStartFinishErrors)({ ...options, id: 'shop/updatedCountry' });
    const { cartUpdateBuyerIdentity } = (0, useCartUpdateBuyerIdentity_1.useCartUpdateBuyerIdentity)();
    const updateCountry = (0, store_1.useRecoilCallback)(({ snapshot, set }) => async (data, callback) => {
        const release = snapshot.retain();
        let validationErrors = null;
        switch (true) {
            case !data || !data?.country: {
                validationErrors = ['country data not provided'];
                break;
            }
            case !data?.country?.isoCode: {
                validationErrors = ['country must include an isoCode'];
                break;
            }
            default:
                break;
        }
        if (validationErrors?.length) {
            setErrors(validationErrors);
            return null;
        }
        try {
            setStarted(true);
            // update the cart locale
            const updatedCart = await cartUpdateBuyerIdentity({
                country: data.country?.isoCode,
                buyerIdentity: {
                    countryCode: data.country?.isoCode,
                },
            });
            if (!updatedCart?.id) {
                setErrors(['Failed to update cart buyer identity countryCode']);
                return null;
            }
            // update the shop state
            set(store_1.default.country, data.country);
            setFinished(true);
            if (callback)
                callback(data.country);
            return data.country;
        }
        catch (error) {
            console.error('failed to update country to due to', error.message);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    return {
        country: isMounted ? country : null,
        updateCountry,
        setStarted,
        setErrors,
        setFinished,
        ...status,
    };
};
exports.useCountry = useCountry;
//# sourceMappingURL=useCountry.js.map

/***/ }),

/***/ 371:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCurrencies = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const helpers_1 = __webpack_require__(5542);
const useCurrencies = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const currencies = (0, store_1.useRecoilValue)(store_1.default.currencies$);
    return isMounted ? currencies : null;
};
exports.useCurrencies = useCurrencies;
//# sourceMappingURL=useCurrencies.js.map

/***/ }),

/***/ 8422:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useCurrency = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const helpers_1 = __webpack_require__(5542);
const useCurrency = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const country = (0, store_1.useRecoilValue)(store_1.default.country);
    return isMounted ? country?.locale?.currency || null : null;
};
exports.useCurrency = useCurrency;
//# sourceMappingURL=useCurrency.js.map

/***/ }),

/***/ 6376:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLocale = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const helpers_1 = __webpack_require__(5542);
const useLocale = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const country = (0, store_1.useRecoilValue)(store_1.default.country);
    return isMounted ? country?.locale || null : null;
};
exports.useLocale = useLocale;
//# sourceMappingURL=useLocale.js.map

/***/ }),

/***/ 9056:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useShop = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const helpers_1 = __webpack_require__(5542);
const useShop = () => {
    const isMounted = (0, helpers_1.useMounted)();
    const shop = (0, store_1.useRecoilValue)(store_1.default.shop);
    return isMounted ? shop : null;
};
exports.useShop = useShop;
//# sourceMappingURL=useShop.js.map

/***/ }),

/***/ 3840:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useShopInit = void 0;
const tslib_1 = __webpack_require__(5556);
const react_1 = __webpack_require__(7378);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useShopStartFinishErrors_1 = __webpack_require__(1108);
const defaultProps = {
    fetchOnMount: true,
    options: {},
};
const useShopInit = (passedProps) => {
    const props = { ...defaultProps, ...passedProps };
    const [shop, setShop] = (0, store_1.useRecoilState)(store_1.default.shop);
    const [, setShopInit] = (0, store_1.useRecoilState)(store_1.default.shopInit);
    const { setStarted, setFinished, setErrors, finished, ...status } = (0, useShopStartFinishErrors_1.useShopStartFinishErrors)({
        ...props.options,
        id: `shop/init`,
    });
    const getShop = (0, store_1.useRecoilCallback)(({ snapshot }) => async (_, callback) => {
        setStarted(true);
        const release = snapshot.retain();
        try {
            // can pass accessToken or will use the on in store
            const { error, data: _shop } = await snapshot.getPromise(store_1.default.fetchShop());
            if (error) {
                setErrors([error]);
                return null;
            }
            if (!_shop) {
                setErrors(['shop get response missing shop data']);
                return null;
            }
            setFinished(true);
            setShopInit(true);
            setShop(_shop);
            if (callback)
                callback(_shop);
            return _shop;
        }
        catch (error) {
            console.error(`getShop:error ${error.message}`);
            setErrors([error.message]);
            return null;
        }
        finally {
            release();
        }
    });
    // fetch on mount
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        const earlyExitIf = [!props.fetchOnMount, shop];
        if (earlyExitIf.some(Boolean)) {
            return undefined;
        }
        getShop()
            // eslint-disable-next-line no-shadow
            .then((shop) => {
            if (unMounting)
                return;
            setShop(shop);
        })
            .catch((error) => {
            console.error('failed to getShop due to', error.message);
        });
        return () => {
            unMounting = true;
        };
    }, [props.fetchOnMount, shop, finished]);
    return {
        shop,
        getShop,
        finished,
        setStarted,
        setFinished,
        setErrors,
        ...status,
    };
};
exports.useShopInit = useShopInit;
//# sourceMappingURL=useShopInit.js.map

/***/ }),

/***/ 1108:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useShopStartFinishErrors = void 0;
const tslib_1 = __webpack_require__(5556);
/* eslint-disable prettier/prettier */
const react_1 = __webpack_require__(7378);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const DEBUG = false;
const useShopStartFinishErrors = (options) => {
    const setShopStarted = (0, store_1.useSetRecoilState)(store_1.default.shopStatusStarted('shop/all'));
    const setShopFinished = (0, store_1.useSetRecoilState)(store_1.default.shopStatusFinished('shop/all'));
    const setShopSuccess = (0, store_1.useSetRecoilState)(store_1.default.shopStatusSuccess('shop/all'));
    const setShopErrors = (0, store_1.useSetRecoilState)(store_1.default.shopStatusErrors('shop/all'));
    const [started, setStarted] = (0, store_1.useRecoilState)(store_1.default.shopStatusStarted(options?.id || ''));
    const [finished, setFinished] = (0, store_1.useRecoilState)(store_1.default.shopStatusFinished(options?.id || ''));
    const [success, setSuccess] = (0, store_1.useRecoilState)(store_1.default.shopStatusSuccess(options?.id || ''));
    const [errors, setErrors] = (0, store_1.useRecoilState)(store_1.default.shopStatusErrors(options?.id || ''));
    const autoReset = (0, react_1.useRef)(options?.autoReset || 0);
    const resetTimer = (0, react_1.useRef)(options?.resetTimer || null);
    const isCustomerId = /^customer/.test(options?.id);
    // update local hook status
    const reset = (0, react_1.useCallback)(() => {
        if (typeof setErrors === 'undefined')
            return;
        setErrors([]);
        setStarted(false);
        setFinished(false);
        setSuccess(false);
        resetTimer.current = null;
    }, []);
    const updateStateOnErrors = () => {
        let unMounting = false;
        if (errors?.length > 0) {
            if (unMounting)
                return;
            setFinished(true);
            setSuccess(false);
        }
        // eslint-disable-next-line consistent-return
        return () => {
            unMounting = true;
        };
    };
    const updateStateOnFinished = () => {
        let unMounting = false;
        if (finished) {
            if (DEBUG) {
                console.groupCollapsed('status:', options?.id);
                console.log('started', started);
                console.log('errors', errors);
                console.log('finished', finished);
                console.log('success', success);
                console.groupEnd();
            }
            if (unMounting)
                return;
            const withoutErrors = errors?.length === 0;
            setStarted(false);
            setSuccess(withoutErrors);
            if (autoReset?.current) {
                const to = setTimeout(() => {
                    if (unMounting)
                        return;
                    reset();
                    clearTimeout(to);
                }, autoReset.current);
            }
        }
        // eslint-disable-next-line consistent-return
        return () => {
            unMounting = true;
        };
    };
    (0, react_1.useEffect)(() => {
        updateStateOnErrors();
    }, [errors?.length]);
    (0, react_1.useEffect)(() => {
        updateStateOnFinished();
    }, [finished, options?.id]);
    // update global cart status
    (0, react_1.useEffect)(() => {
        if (isCustomerId) {
            setShopErrors(errors);
        }
    }, [errors?.length]);
    (0, react_1.useEffect)(() => {
        if (isCustomerId) {
            setShopStarted(started);
        }
    }, [started]);
    (0, react_1.useEffect)(() => {
        let unMounting = false;
        setShopFinished(finished);
        const to = setTimeout(() => {
            if (unMounting)
                return;
            setShopFinished(false);
            clearTimeout(to);
        }, 1000);
        return () => {
            unMounting = true;
        };
    }, [finished]);
    (0, react_1.useEffect)(() => {
        if (isCustomerId) {
            setShopSuccess(success);
        }
    }, [success]);
    return {
        started,
        setStarted,
        finished,
        setFinished,
        success,
        setSuccess,
        errors,
        setErrors,
        reset,
        resetTimer,
    };
};
exports.useShopStartFinishErrors = useShopStartFinishErrors;
//# sourceMappingURL=useShopStartFinishErrors.js.map

/***/ }),

/***/ 8123:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useStorefrontInit = void 0;
const useShopInit_1 = __webpack_require__(3840);
const useCountriesInit_1 = __webpack_require__(7344);
const hooks_1 = __webpack_require__(8081);
const hooks_2 = __webpack_require__(3296);
const useStorefrontInit = () => {
    // 1. initialize the shop to determine primary currency code and country
    const { shop, ...shopStatus } = (0, useShopInit_1.useShopInit)();
    const primaryCountryCode = shop?.paymentSettings?.countryCode;
    // 2. initialize the countries to get all the available countries/markets info
    const { country, countries, ...countriesStatus } = (0, useCountriesInit_1.useCountriesInit)({
        fetchOnMount: primaryCountryCode,
    });
    const fullCountryCode = country?.isoCode;
    // 3. initialize customer and cart (the cart will be initialized once customerInit is true)
    const cart = (0, hooks_1.useCartInit)({ fetchOnMount: fullCountryCode });
    const customer = (0, hooks_2.useCustomerInit)({ fetchOnMount: fullCountryCode });
    return {
        customer,
        cart,
        shop,
        country,
        countries,
        finished: customer && cart && shop && country && countries,
        errors: [...countriesStatus.errors, ...shopStatus.errors],
    };
};
exports.useStorefrontInit = useStorefrontInit;
//# sourceMappingURL=useStorefrontInit.js.map

/***/ }),

/***/ 437:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.shopStore = void 0;
var shop_1 = __webpack_require__(4652);
Object.defineProperty(exports, "shopStore", ({ enumerable: true, get: function () { return shop_1.shopStore; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 4652:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.shopStore = void 0;
const tslib_1 = __webpack_require__(5556);
/* eslint-disable max-lines */
const recoil_1 = __webpack_require__(9853);
const effects_1 = tslib_1.__importDefault(__webpack_require__(9025));
const client_1 = __webpack_require__(6574);
const client = new client_1.ShopClient({
    apiToken: "3bc6486eea19d75d4dd39479084d4c7a",
    apiVersion: '2025-04',
    domain: "clearly-filtered.myshopify.com",
    debug: false,
});
// @see: https://shopify.dev/themes/internationalization/multiple-currencies-languages#javascript-submission-of-the-localization-form
const shop = (0, recoil_1.atom)({
    key: 'shop',
    default: null,
    effects: [
    // effects.logStateChange('shop')
    ],
});
const shopInit = (0, recoil_1.atom)({
    key: 'shop/init',
    default: false,
});
const country = (0, recoil_1.atom)({
    key: 'shop/country',
    default: null,
    // default: {
    //   currency: {
    //     isoCode: 'USD',
    //     name: 'United States Dollar',
    //     symbol: '$',
    //   },
    //   isoCode: 'US',
    //   name: 'United States',
    //   unitSystem: 'IMPERIAL_SYSTEM',
    // },
    effects: [
        // effects.logStateChange('country'),
        effects_1.default.setSelfToPersistedKey('country', `Country|${effects_1.default.SHOPIFY_NAME}`, 'COUNTRY_EXISTING'),
        effects_1.default.onSetUpdatePersistedKey(`Country|${effects_1.default.SHOPIFY_NAME}`),
        effects_1.default.onChange({
            key: 'country',
            topic: 'COUNTRY_UPDATE',
            actions: ['publishGtmEvent', 'publishBusEvent'],
        }),
    ],
});
/*
  ---------------
  Getters
  ---------------
*/
const primaryCurrencyCode$ = (0, recoil_1.selector)({
    key: 'shop/primaryCurrencyCode$',
    get: ({ get }) => {
        const _shop = get(shop);
        return _shop?.paymentSettings?.currencyCode || null;
    },
});
const primaryCountryCode$ = (0, recoil_1.selector)({
    key: 'shop/primaryCountryCode$',
    get: ({ get }) => {
        const _shop = get(shop);
        return _shop?.paymentSettings?.countryCode || null;
    },
});
/*
  When multiple markets are enabled on a store
  it will return an array of currencyCodes the user can checkout with
    e.g ['BR', 'CA', 'CN', 'DE', 'FR', 'GB', 'MX', 'RU', 'US']

  When no markets have been configured the array will include only the
  default market's currency code
    e.g ['USD] – user can only checkout in USD
*/
const currencies$ = (0, recoil_1.selector)({
    key: 'shop/currencies$',
    get: ({ get }) => {
        const _shop = get(shop);
        return _shop?.paymentSettings?.enabledPresentmentCurrencies || [];
    },
});
/*
  ---------------
  Status
  ---------------
*/
const countries = (0, recoil_1.atom)({
    key: 'shop/countries',
    default: [],
});
const availableCountries = (0, recoil_1.atom)({
    key: 'shop/availableCountries',
    default: [],
});
const shopStatusStarted = (0, recoil_1.atomFamily)({
    key: 'shop/statusStarted',
    default: false,
});
const shopStatusFinished = (0, recoil_1.atomFamily)({
    key: 'shop/statusFinished',
    default: false,
});
const shopStatusSuccess = (0, recoil_1.atomFamily)({
    key: 'shop/statusSuccess',
    default: false,
});
const shopStatusErrors = (0, recoil_1.atomFamily)({
    key: 'shop/statusErrors',
    default: [],
});
/*
  ---------------
  Async fetchers and setters
  ---------------
*/
/*
  Shop: countries...
*/
const fetchShop = (0, recoil_1.selectorFamily)({
    key: 'shop/fetchShop',
    get: () => async () => {
        return client.getShop();
    },
});
const fetchCountries = (0, recoil_1.selectorFamily)({
    key: 'shop/fetchCountries',
    get: () => async ({ get }) => {
        const primaryCurrencyCode = get(primaryCurrencyCode$);
        const primaryCountryCode = get(primaryCountryCode$);
        const currencies = get(currencies$);
        if (!primaryCountryCode)
            return null;
        return client.getCountries({
            countryCode: primaryCountryCode,
            currencyCode: primaryCurrencyCode,
            currencies, // presentmentCurrencies.
        });
    },
});
// new on v2
exports.shopStore = {
    shop,
    shopInit,
    country,
    countries,
    availableCountries,
    primaryCurrencyCode$,
    primaryCountryCode$,
    currencies$,
    shopStatusStarted,
    shopStatusFinished,
    shopStatusSuccess,
    shopStatusErrors,
    fetchShop,
    fetchCountries,
};
//# sourceMappingURL=shop.js.map

/***/ }),

/***/ 4385:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.selectorFamily = exports.selector = exports.atomFamily = exports.atom = exports.useGotoRecoilSnapshot = exports.useRecoilCallback = exports.useRecoilSnapshot = exports.useRecoilValueLoadable = exports.useRecoilValue = exports.useResetRecoilState = exports.useSetRecoilState = exports.useRecoilStateLoadable = exports.useRecoilState = void 0;
const store_1 = __webpack_require__(9807);
const store_2 = __webpack_require__(2159);
const store_3 = __webpack_require__(3727);
const store_4 = __webpack_require__(9005);
const store_5 = __webpack_require__(7152);
const store_6 = __webpack_require__(747);
const store_7 = __webpack_require__(9970);
const store_8 = __webpack_require__(8886);
const store_9 = __webpack_require__(1857);
const store_10 = __webpack_require__(437);
const store_11 = __webpack_require__(6839);
const store_12 = __webpack_require__(8584);
// just so that we don't need to imports in components
var recoil_1 = __webpack_require__(9853);
Object.defineProperty(exports, "useRecoilState", ({ enumerable: true, get: function () { return recoil_1.useRecoilState; } }));
Object.defineProperty(exports, "useRecoilStateLoadable", ({ enumerable: true, get: function () { return recoil_1.useRecoilStateLoadable; } }));
Object.defineProperty(exports, "useSetRecoilState", ({ enumerable: true, get: function () { return recoil_1.useSetRecoilState; } }));
Object.defineProperty(exports, "useResetRecoilState", ({ enumerable: true, get: function () { return recoil_1.useResetRecoilState; } }));
Object.defineProperty(exports, "useRecoilValue", ({ enumerable: true, get: function () { return recoil_1.useRecoilValue; } }));
Object.defineProperty(exports, "useRecoilValueLoadable", ({ enumerable: true, get: function () { return recoil_1.useRecoilValueLoadable; } }));
Object.defineProperty(exports, "useRecoilSnapshot", ({ enumerable: true, get: function () { return recoil_1.useRecoilSnapshot; } }));
Object.defineProperty(exports, "useRecoilCallback", ({ enumerable: true, get: function () { return recoil_1.useRecoilCallback; } }));
Object.defineProperty(exports, "useGotoRecoilSnapshot", ({ enumerable: true, get: function () { return recoil_1.useGotoRecoilSnapshot; } }));
Object.defineProperty(exports, "atom", ({ enumerable: true, get: function () { return recoil_1.atom; } }));
Object.defineProperty(exports, "atomFamily", ({ enumerable: true, get: function () { return recoil_1.atomFamily; } }));
Object.defineProperty(exports, "selector", ({ enumerable: true, get: function () { return recoil_1.selector; } }));
Object.defineProperty(exports, "selectorFamily", ({ enumerable: true, get: function () { return recoil_1.selectorFamily; } }));
// eslint-disable-next-line import/no-default-export
exports["default"] = {
    ...store_1.analyticsStore,
    ...store_2.articleStore,
    ...store_3.blogStore,
    ...store_4.cartStore,
    ...store_5.collectionStore,
    ...store_6.customerStore,
    ...store_7.localeStore,
    ...store_8.pageStore,
    ...store_9.productStore,
    ...store_10.shopStore,
    ...store_11.viewStore,
    ...store_12.settingsStore,
};
//# sourceMappingURL=store.js.map

/***/ }),

/***/ 8844:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useTemplate = void 0;
var useTemplate_1 = __webpack_require__(412);
Object.defineProperty(exports, "useTemplate", ({ enumerable: true, get: function () { return useTemplate_1.useTemplate; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 412:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useTemplate = void 0;
const tslib_1 = __webpack_require__(5556);
const store_1 = tslib_1.__importStar(__webpack_require__(4385));
const useTemplate = () => (0, store_1.useRecoilValue)(store_1.default.template);
exports.useTemplate = useTemplate;
//# sourceMappingURL=useTemplate.js.map

/***/ }),

/***/ 6839:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.viewStore = void 0;
var view_1 = __webpack_require__(4979);
Object.defineProperty(exports, "viewStore", ({ enumerable: true, get: function () { return view_1.viewStore; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 4979:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.viewStore = void 0;
const tslib_1 = __webpack_require__(5556);
/* eslint-disable max-lines */
const recoil_1 = __webpack_require__(9853);
const effects_1 = tslib_1.__importDefault(__webpack_require__(9025));
/**
  ROUTE_VIEW State
*/
const route = (0, recoil_1.atom)({
    key: 'view/route',
    default: '',
    effects: [
        effects_1.default.onChange({
            key: 'route',
            topic: 'ROUTE_UPDATE',
            actions: ['publishGtmEvent', 'publishBusEvent'],
        }),
    ],
});
const template = (0, recoil_1.selector)({
    key: 'view/template',
    default: null,
    get: ({ get }) => {
        const _route = get(route);
        const _template = _route
            ? effects_1.default.routeToTemplate({ route: _route })
            : null; // not ready
        return _template;
    },
});
// viewStore
exports.viewStore = {
    route,
    template,
};
//# sourceMappingURL=view.js.map

/***/ }),

/***/ 8981:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
/* provided dependency */ var Buffer = __webpack_require__(816)["lW"];
(function (w) {
  "use strict";

  function findBest(atobNative) {
    // normal window
    if ('function' === typeof atobNative) { return atobNative; }


    // browserify (web worker)
    if ('function' === typeof Buffer) {
      return function atobBrowserify(a) {
        //!! Deliberately using an API that's deprecated in node.js because
        //!! this file is for browsers and we expect them to cope with it.
        //!! Discussion: github.com/node-browser-compat/atob/pull/9
        return new Buffer(a, 'base64').toString('binary');
      };
    }

    // ios web worker with base64js
    if ('object' === typeof w.base64js) {
      // bufferToBinaryString
      // https://git.coolaj86.com/coolaj86/unibabel.js/blob/master/index.js#L50
      return function atobWebWorker_iOS(a) {
        var buf = w.base64js.b64ToByteArray(a);
        return Array.prototype.map.call(buf, function (ch) {
          return String.fromCharCode(ch);
        }).join('');
      };
    }

		return function () {
			// ios web worker without base64js
			throw new Error("You're probably in an old browser or an iOS webworker." +
				" It might help to include beatgammit's base64-js.");
    };
  }

  var atobBest = findBest(w.atob);
  w.atob = atobBest;

  if (( true) && module && module.exports) {
    module.exports = atobBest;
  }
}(window));


/***/ }),

/***/ 4782:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 816:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(4782)
var ieee754 = __webpack_require__(8898)
var customInspectSymbol =
  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
    : null

exports.lW = Buffer
__webpack_unused_export__ = SlowBuffer
exports.h2 = 50

var K_MAX_LENGTH = 0x7fffffff
__webpack_unused_export__ = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1)
    var proto = { foo: function () { return 42 } }
    Object.setPrototypeOf(proto, Uint8Array.prototype)
    Object.setPrototypeOf(arr, proto)
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length)
  Object.setPrototypeOf(buf, Buffer.prototype)
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value)
  }

  if (value == null) {
    throw new TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof SharedArrayBuffer !== 'undefined' &&
      (isInstance(value, SharedArrayBuffer) ||
      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  var valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  var b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(
      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
    )
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
Object.setPrototypeOf(Buffer, Uint8Array)

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  var length = byteLength(string, encoding) | 0
  var buf = createBuffer(length)

  var actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayView (arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    var copy = new Uint8Array(arrayView)
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
  }
  return fromArrayLike(arrayView)
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype)

  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        Buffer.from(buf).copy(buffer, pos)
      } else {
        Uint8Array.prototype.set.call(
          buffer,
          buf,
          pos
        )
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    } else {
      buf.copy(buffer, pos)
    }
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  var len = string.length
  var mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.h2
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  var strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF)
      ? 4
      : (firstByte > 0xDF)
          ? 3
          : (firstByte > 0xBF)
              ? 2
              : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]]
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (var i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype)

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUintLE =
Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUintBE =
Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUint8 =
Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUint16LE =
Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUint16BE =
Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUint32LE =
Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUint32BE =
Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUintLE =
Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUintBE =
Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUint8 =
Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUint16LE =
Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUint16BE =
Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUint32LE =
Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUint32BE =
Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  } else if (typeof val === 'boolean') {
    val = Number(val)
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    var len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = (function () {
  var alphabet = '0123456789abcdef'
  var table = new Array(256)
  for (var i = 0; i < 16; ++i) {
    var i16 = i * 16
    for (var j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j]
    }
  }
  return table
})()


/***/ }),

/***/ 9372:
/***/ (function(module, exports) {

var global = typeof self !== 'undefined' ? self : this;
var __self__ = (function () {
function F() {
this.fetch = false;
this.DOMException = global.DOMException
}
F.prototype = global;
return new F();
})();
(function(self) {

var irrelevant = (function (exports) {

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function() {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return {done: value === undefined, value: value}
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function() {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function(body) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this);
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      };

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      };
    }

    this.text = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    };

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      };
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    };

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input, options) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      this.signal = input.signal;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body);
  }

  Request.prototype.clone = function() {
    return new Request(this, {body: this._bodyInit})
  };

  function decode(body) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function(bytes) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''});
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  };

  exports.DOMException = self.DOMException;
  try {
    new exports.DOMException();
  } catch (err) {
    exports.DOMException = function(message, name) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    exports.DOMException.prototype = Object.create(Error.prototype);
    exports.DOMException.prototype.constructor = exports.DOMException;
  }

  function fetch(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new exports.DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        resolve(new Response(body, options));
      };

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function() {
        reject(new exports.DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function() {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    self.fetch = fetch;
    self.Headers = Headers;
    self.Request = Request;
    self.Response = Response;
  }

  exports.Headers = Headers;
  exports.Request = Request;
  exports.Response = Response;
  exports.fetch = fetch;

  Object.defineProperty(exports, '__esModule', { value: true });

  return exports;

})({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
exports["default"] = ctx.fetch // For TypeScript consumers without esModuleInterop.
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
exports.Headers = ctx.Headers
exports.Request = ctx.Request
exports.Response = ctx.Response
module.exports = exports


/***/ }),

/***/ 406:
/***/ (function(module) {

"use strict";


var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function getMergeFunction(key, options) {
	if (!options.customMerge) {
		return deepmerge
	}
	var customMerge = options.customMerge(key);
	return typeof customMerge === 'function' ? customMerge : deepmerge
}

function getEnumerableOwnPropertySymbols(target) {
	return Object.getOwnPropertySymbols
		? Object.getOwnPropertySymbols(target).filter(function(symbol) {
			return Object.propertyIsEnumerable.call(target, symbol)
		})
		: []
}

function getKeys(target) {
	return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
}

function propertyIsOnObject(object, property) {
	try {
		return property in object
	} catch(_) {
		return false
	}
}

// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target, key) {
	return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
		&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
			&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		getKeys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	getKeys(source).forEach(function(key) {
		if (propertyIsUnsafe(target, key)) {
			return
		}

		if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
			destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
		} else {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
	// implementations can use it. The caller may not replace it.
	options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

module.exports = deepmerge_1;


/***/ }),

/***/ 229:
/***/ (function(module) {

"use strict";


var hasOwn = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var defineProperty = Object.defineProperty;
var gOPD = Object.getOwnPropertyDescriptor;

var isArray = function isArray(arr) {
	if (typeof Array.isArray === 'function') {
		return Array.isArray(arr);
	}

	return toStr.call(arr) === '[object Array]';
};

var isPlainObject = function isPlainObject(obj) {
	if (!obj || toStr.call(obj) !== '[object Object]') {
		return false;
	}

	var hasOwnConstructor = hasOwn.call(obj, 'constructor');
	var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
	// Not own constructor property must be Object
	if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
		return false;
	}

	// Own properties are enumerated firstly, so to speed up,
	// if last one is own, then all properties are own.
	var key;
	for (key in obj) { /**/ }

	return typeof key === 'undefined' || hasOwn.call(obj, key);
};

// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var setProperty = function setProperty(target, options) {
	if (defineProperty && options.name === '__proto__') {
		defineProperty(target, options.name, {
			enumerable: true,
			configurable: true,
			value: options.newValue,
			writable: true
		});
	} else {
		target[options.name] = options.newValue;
	}
};

// Return undefined instead of __proto__ if '__proto__' is not an own property
var getProperty = function getProperty(obj, name) {
	if (name === '__proto__') {
		if (!hasOwn.call(obj, name)) {
			return void 0;
		} else if (gOPD) {
			// In early versions of node, obj['__proto__'] is buggy when obj has
			// __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
			return gOPD(obj, name).value;
		}
	}

	return obj[name];
};

module.exports = function extend() {
	var options, name, src, copy, copyIsArray, clone;
	var target = arguments[0];
	var i = 1;
	var length = arguments.length;
	var deep = false;

	// Handle a deep copy situation
	if (typeof target === 'boolean') {
		deep = target;
		target = arguments[1] || {};
		// skip the boolean and the target
		i = 2;
	}
	if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
		target = {};
	}

	for (; i < length; ++i) {
		options = arguments[i];
		// Only deal with non-null/undefined values
		if (options != null) {
			// Extend the base object
			for (name in options) {
				src = getProperty(target, name);
				copy = getProperty(options, name);

				// Prevent never-ending loop
				if (target !== copy) {
					// Recurse if we're merging plain objects or arrays
					if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
						if (copyIsArray) {
							copyIsArray = false;
							clone = src && isArray(src) ? src : [];
						} else {
							clone = src && isPlainObject(src) ? src : {};
						}

						// Never move original objects, clone them
						setProperty(target, { name: name, newValue: extend(deep, clone, copy) });

					// Don't bring in undefined values
					} else if (typeof copy !== 'undefined') {
						setProperty(target, { name: name, newValue: copy });
					}
				}
			}
		}
	}

	// Return the modified object
	return target;
};


/***/ }),

/***/ 6471:
/***/ (function(module) {

"use strict";


// do not edit .js files directly - edit src/index.jst



module.exports = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }



    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};


/***/ }),

/***/ 8107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Fuse; }
/* harmony export */ });
/**
 * Fuse.js v6.6.2 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2022 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */

function isArray(value) {
  return !Array.isArray
    ? getTag(value) === '[object Array]'
    : Array.isArray(value)
}

// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
const INFINITY = 1 / 0;
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value
  }
  let result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result
}

function toString(value) {
  return value == null ? '' : baseToString(value)
}

function isString(value) {
  return typeof value === 'string'
}

function isNumber(value) {
  return typeof value === 'number'
}

// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function isBoolean(value) {
  return (
    value === true ||
    value === false ||
    (isObjectLike(value) && getTag(value) == '[object Boolean]')
  )
}

function isObject(value) {
  return typeof value === 'object'
}

// Checks if `value` is object-like.
function isObjectLike(value) {
  return isObject(value) && value !== null
}

function isDefined(value) {
  return value !== undefined && value !== null
}

function isBlank(value) {
  return !value.trim().length
}

// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function getTag(value) {
  return value == null
    ? value === undefined
      ? '[object Undefined]'
      : '[object Null]'
    : Object.prototype.toString.call(value)
}

const EXTENDED_SEARCH_UNAVAILABLE = 'Extended search is not available';

const INCORRECT_INDEX_TYPE = "Incorrect 'index' type";

const LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key) =>
  `Invalid value for key ${key}`;

const PATTERN_LENGTH_TOO_LARGE = (max) =>
  `Pattern length exceeds max of ${max}.`;

const MISSING_KEY_PROPERTY = (name) => `Missing ${name} property in key`;

const INVALID_KEY_WEIGHT_VALUE = (key) =>
  `Property 'weight' in key '${key}' must be a positive integer`;

const hasOwn = Object.prototype.hasOwnProperty;

class KeyStore {
  constructor(keys) {
    this._keys = [];
    this._keyMap = {};

    let totalWeight = 0;

    keys.forEach((key) => {
      let obj = createKey(key);

      totalWeight += obj.weight;

      this._keys.push(obj);
      this._keyMap[obj.id] = obj;

      totalWeight += obj.weight;
    });

    // Normalize weights so that their sum is equal to 1
    this._keys.forEach((key) => {
      key.weight /= totalWeight;
    });
  }
  get(keyId) {
    return this._keyMap[keyId]
  }
  keys() {
    return this._keys
  }
  toJSON() {
    return JSON.stringify(this._keys)
  }
}

function createKey(key) {
  let path = null;
  let id = null;
  let src = null;
  let weight = 1;
  let getFn = null;

  if (isString(key) || isArray(key)) {
    src = key;
    path = createKeyPath(key);
    id = createKeyId(key);
  } else {
    if (!hasOwn.call(key, 'name')) {
      throw new Error(MISSING_KEY_PROPERTY('name'))
    }

    const name = key.name;
    src = name;

    if (hasOwn.call(key, 'weight')) {
      weight = key.weight;

      if (weight <= 0) {
        throw new Error(INVALID_KEY_WEIGHT_VALUE(name))
      }
    }

    path = createKeyPath(name);
    id = createKeyId(name);
    getFn = key.getFn;
  }

  return { path, id, weight, src, getFn }
}

function createKeyPath(key) {
  return isArray(key) ? key : key.split('.')
}

function createKeyId(key) {
  return isArray(key) ? key.join('.') : key
}

function get(obj, path) {
  let list = [];
  let arr = false;

  const deepGet = (obj, path, index) => {
    if (!isDefined(obj)) {
      return
    }
    if (!path[index]) {
      // If there's no path left, we've arrived at the object we care about.
      list.push(obj);
    } else {
      let key = path[index];

      const value = obj[key];

      if (!isDefined(value)) {
        return
      }

      // If we're at the last value in the path, and if it's a string/number/bool,
      // add it to the list
      if (
        index === path.length - 1 &&
        (isString(value) || isNumber(value) || isBoolean(value))
      ) {
        list.push(toString(value));
      } else if (isArray(value)) {
        arr = true;
        // Search each item in the array.
        for (let i = 0, len = value.length; i < len; i += 1) {
          deepGet(value[i], path, index + 1);
        }
      } else if (path.length) {
        // An object. Recurse further.
        deepGet(value, path, index + 1);
      }
    }
  };

  // Backwards compatibility (since path used to be a string)
  deepGet(obj, isString(path) ? path.split('.') : path, 0);

  return arr ? list : list[0]
}

const MatchOptions = {
  // Whether the matches should be included in the result set. When `true`, each record in the result
  // set will include the indices of the matched characters.
  // These can consequently be used for highlighting purposes.
  includeMatches: false,
  // When `true`, the matching function will continue to the end of a search pattern even if
  // a perfect match has already been located in the string.
  findAllMatches: false,
  // Minimum number of characters that must be matched before a result is considered a match
  minMatchCharLength: 1
};

const BasicOptions = {
  // When `true`, the algorithm continues searching to the end of the input even if a perfect
  // match is found before the end of the same input.
  isCaseSensitive: false,
  // When true, the matching function will continue to the end of a search pattern even if
  includeScore: false,
  // List of properties that will be searched. This also supports nested properties.
  keys: [],
  // Whether to sort the result list, by score
  shouldSort: true,
  // Default sort function: sort by ascending score, ascending index
  sortFn: (a, b) =>
    a.score === b.score ? (a.idx < b.idx ? -1 : 1) : a.score < b.score ? -1 : 1
};

const FuzzyOptions = {
  // Approximately where in the text is the pattern expected to be found?
  location: 0,
  // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
  // (of both letters and location), a threshold of '1.0' would match anything.
  threshold: 0.6,
  // Determines how close the match must be to the fuzzy location (specified above).
  // An exact letter match which is 'distance' characters away from the fuzzy location
  // would score as a complete mismatch. A distance of '0' requires the match be at
  // the exact location specified, a threshold of '1000' would require a perfect match
  // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
  distance: 100
};

const AdvancedOptions = {
  // When `true`, it enables the use of unix-like search commands
  useExtendedSearch: false,
  // The get function to use when fetching an object's properties.
  // The default will search nested paths *ie foo.bar.baz*
  getFn: get,
  // When `true`, search will ignore `location` and `distance`, so it won't matter
  // where in the string the pattern appears.
  // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
  ignoreLocation: false,
  // When `true`, the calculation for the relevance score (used for sorting) will
  // ignore the field-length norm.
  // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
  ignoreFieldNorm: false,
  // The weight to determine how much field length norm effects scoring.
  fieldNormWeight: 1
};

var Config = {
  ...BasicOptions,
  ...MatchOptions,
  ...FuzzyOptions,
  ...AdvancedOptions
};

const SPACE = /[^ ]+/g;

// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function norm(weight = 1, mantissa = 3) {
  const cache = new Map();
  const m = Math.pow(10, mantissa);

  return {
    get(value) {
      const numTokens = value.match(SPACE).length;

      if (cache.has(numTokens)) {
        return cache.get(numTokens)
      }

      // Default function is 1/sqrt(x), weight makes that variable
      const norm = 1 / Math.pow(numTokens, 0.5 * weight);

      // In place of `toFixed(mantissa)`, for faster computation
      const n = parseFloat(Math.round(norm * m) / m);

      cache.set(numTokens, n);

      return n
    },
    clear() {
      cache.clear();
    }
  }
}

class FuseIndex {
  constructor({
    getFn = Config.getFn,
    fieldNormWeight = Config.fieldNormWeight
  } = {}) {
    this.norm = norm(fieldNormWeight, 3);
    this.getFn = getFn;
    this.isCreated = false;

    this.setIndexRecords();
  }
  setSources(docs = []) {
    this.docs = docs;
  }
  setIndexRecords(records = []) {
    this.records = records;
  }
  setKeys(keys = []) {
    this.keys = keys;
    this._keysMap = {};
    keys.forEach((key, idx) => {
      this._keysMap[key.id] = idx;
    });
  }
  create() {
    if (this.isCreated || !this.docs.length) {
      return
    }

    this.isCreated = true;

    // List is Array<String>
    if (isString(this.docs[0])) {
      this.docs.forEach((doc, docIndex) => {
        this._addString(doc, docIndex);
      });
    } else {
      // List is Array<Object>
      this.docs.forEach((doc, docIndex) => {
        this._addObject(doc, docIndex);
      });
    }

    this.norm.clear();
  }
  // Adds a doc to the end of the index
  add(doc) {
    const idx = this.size();

    if (isString(doc)) {
      this._addString(doc, idx);
    } else {
      this._addObject(doc, idx);
    }
  }
  // Removes the doc at the specified index of the index
  removeAt(idx) {
    this.records.splice(idx, 1);

    // Change ref index of every subsquent doc
    for (let i = idx, len = this.size(); i < len; i += 1) {
      this.records[i].i -= 1;
    }
  }
  getValueForItemAtKeyId(item, keyId) {
    return item[this._keysMap[keyId]]
  }
  size() {
    return this.records.length
  }
  _addString(doc, docIndex) {
    if (!isDefined(doc) || isBlank(doc)) {
      return
    }

    let record = {
      v: doc,
      i: docIndex,
      n: this.norm.get(doc)
    };

    this.records.push(record);
  }
  _addObject(doc, docIndex) {
    let record = { i: docIndex, $: {} };

    // Iterate over every key (i.e, path), and fetch the value at that key
    this.keys.forEach((key, keyIndex) => {
      let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);

      if (!isDefined(value)) {
        return
      }

      if (isArray(value)) {
        let subRecords = [];
        const stack = [{ nestedArrIndex: -1, value }];

        while (stack.length) {
          const { nestedArrIndex, value } = stack.pop();

          if (!isDefined(value)) {
            continue
          }

          if (isString(value) && !isBlank(value)) {
            let subRecord = {
              v: value,
              i: nestedArrIndex,
              n: this.norm.get(value)
            };

            subRecords.push(subRecord);
          } else if (isArray(value)) {
            value.forEach((item, k) => {
              stack.push({
                nestedArrIndex: k,
                value: item
              });
            });
          } else ;
        }
        record.$[keyIndex] = subRecords;
      } else if (isString(value) && !isBlank(value)) {
        let subRecord = {
          v: value,
          n: this.norm.get(value)
        };

        record.$[keyIndex] = subRecord;
      }
    });

    this.records.push(record);
  }
  toJSON() {
    return {
      keys: this.keys,
      records: this.records
    }
  }
}

function createIndex(
  keys,
  docs,
  { getFn = Config.getFn, fieldNormWeight = Config.fieldNormWeight } = {}
) {
  const myIndex = new FuseIndex({ getFn, fieldNormWeight });
  myIndex.setKeys(keys.map(createKey));
  myIndex.setSources(docs);
  myIndex.create();
  return myIndex
}

function parseIndex(
  data,
  { getFn = Config.getFn, fieldNormWeight = Config.fieldNormWeight } = {}
) {
  const { keys, records } = data;
  const myIndex = new FuseIndex({ getFn, fieldNormWeight });
  myIndex.setKeys(keys);
  myIndex.setIndexRecords(records);
  return myIndex
}

function computeScore$1(
  pattern,
  {
    errors = 0,
    currentLocation = 0,
    expectedLocation = 0,
    distance = Config.distance,
    ignoreLocation = Config.ignoreLocation
  } = {}
) {
  const accuracy = errors / pattern.length;

  if (ignoreLocation) {
    return accuracy
  }

  const proximity = Math.abs(expectedLocation - currentLocation);

  if (!distance) {
    // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy
  }

  return accuracy + proximity / distance
}

function convertMaskToIndices(
  matchmask = [],
  minMatchCharLength = Config.minMatchCharLength
) {
  let indices = [];
  let start = -1;
  let end = -1;
  let i = 0;

  for (let len = matchmask.length; i < len; i += 1) {
    let match = matchmask[i];
    if (match && start === -1) {
      start = i;
    } else if (!match && start !== -1) {
      end = i - 1;
      if (end - start + 1 >= minMatchCharLength) {
        indices.push([start, end]);
      }
      start = -1;
    }
  }

  // (i-1 - start) + 1 => i - start
  if (matchmask[i - 1] && i - start >= minMatchCharLength) {
    indices.push([start, i - 1]);
  }

  return indices
}

// Machine word size
const MAX_BITS = 32;

function search(
  text,
  pattern,
  patternAlphabet,
  {
    location = Config.location,
    distance = Config.distance,
    threshold = Config.threshold,
    findAllMatches = Config.findAllMatches,
    minMatchCharLength = Config.minMatchCharLength,
    includeMatches = Config.includeMatches,
    ignoreLocation = Config.ignoreLocation
  } = {}
) {
  if (pattern.length > MAX_BITS) {
    throw new Error(PATTERN_LENGTH_TOO_LARGE(MAX_BITS))
  }

  const patternLen = pattern.length;
  // Set starting location at beginning text and initialize the alphabet.
  const textLen = text.length;
  // Handle the case when location > text.length
  const expectedLocation = Math.max(0, Math.min(location, textLen));
  // Highest score beyond which we give up.
  let currentThreshold = threshold;
  // Is there a nearby exact match? (speedup)
  let bestLocation = expectedLocation;

  // Performance: only computer matches when the minMatchCharLength > 1
  // OR if `includeMatches` is true.
  const computeMatches = minMatchCharLength > 1 || includeMatches;
  // A mask of the matches, used for building the indices
  const matchMask = computeMatches ? Array(textLen) : [];

  let index;

  // Get all exact matches, here for speed up
  while ((index = text.indexOf(pattern, bestLocation)) > -1) {
    let score = computeScore$1(pattern, {
      currentLocation: index,
      expectedLocation,
      distance,
      ignoreLocation
    });

    currentThreshold = Math.min(score, currentThreshold);
    bestLocation = index + patternLen;

    if (computeMatches) {
      let i = 0;
      while (i < patternLen) {
        matchMask[index + i] = 1;
        i += 1;
      }
    }
  }

  // Reset the best location
  bestLocation = -1;

  let lastBitArr = [];
  let finalScore = 1;
  let binMax = patternLen + textLen;

  const mask = 1 << (patternLen - 1);

  for (let i = 0; i < patternLen; i += 1) {
    // Scan for the best match; each iteration allows for one more error.
    // Run a binary search to determine how far from the match location we can stray
    // at this error level.
    let binMin = 0;
    let binMid = binMax;

    while (binMin < binMid) {
      const score = computeScore$1(pattern, {
        errors: i,
        currentLocation: expectedLocation + binMid,
        expectedLocation,
        distance,
        ignoreLocation
      });

      if (score <= currentThreshold) {
        binMin = binMid;
      } else {
        binMax = binMid;
      }

      binMid = Math.floor((binMax - binMin) / 2 + binMin);
    }

    // Use the result from this iteration as the maximum for the next.
    binMax = binMid;

    let start = Math.max(1, expectedLocation - binMid + 1);
    let finish = findAllMatches
      ? textLen
      : Math.min(expectedLocation + binMid, textLen) + patternLen;

    // Initialize the bit array
    let bitArr = Array(finish + 2);

    bitArr[finish + 1] = (1 << i) - 1;

    for (let j = finish; j >= start; j -= 1) {
      let currentLocation = j - 1;
      let charMatch = patternAlphabet[text.charAt(currentLocation)];

      if (computeMatches) {
        // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
        matchMask[currentLocation] = +!!charMatch;
      }

      // First pass: exact match
      bitArr[j] = ((bitArr[j + 1] << 1) | 1) & charMatch;

      // Subsequent passes: fuzzy match
      if (i) {
        bitArr[j] |=
          ((lastBitArr[j + 1] | lastBitArr[j]) << 1) | 1 | lastBitArr[j + 1];
      }

      if (bitArr[j] & mask) {
        finalScore = computeScore$1(pattern, {
          errors: i,
          currentLocation,
          expectedLocation,
          distance,
          ignoreLocation
        });

        // This match will almost certainly be better than any existing match.
        // But check anyway.
        if (finalScore <= currentThreshold) {
          // Indeed it is
          currentThreshold = finalScore;
          bestLocation = currentLocation;

          // Already passed `loc`, downhill from here on in.
          if (bestLocation <= expectedLocation) {
            break
          }

          // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
          start = Math.max(1, 2 * expectedLocation - bestLocation);
        }
      }
    }

    // No hope for a (better) match at greater error levels.
    const score = computeScore$1(pattern, {
      errors: i + 1,
      currentLocation: expectedLocation,
      expectedLocation,
      distance,
      ignoreLocation
    });

    if (score > currentThreshold) {
      break
    }

    lastBitArr = bitArr;
  }

  const result = {
    isMatch: bestLocation >= 0,
    // Count exact matches (those with a score of 0) to be "almost" exact
    score: Math.max(0.001, finalScore)
  };

  if (computeMatches) {
    const indices = convertMaskToIndices(matchMask, minMatchCharLength);
    if (!indices.length) {
      result.isMatch = false;
    } else if (includeMatches) {
      result.indices = indices;
    }
  }

  return result
}

function createPatternAlphabet(pattern) {
  let mask = {};

  for (let i = 0, len = pattern.length; i < len; i += 1) {
    const char = pattern.charAt(i);
    mask[char] = (mask[char] || 0) | (1 << (len - i - 1));
  }

  return mask
}

class BitapSearch {
  constructor(
    pattern,
    {
      location = Config.location,
      threshold = Config.threshold,
      distance = Config.distance,
      includeMatches = Config.includeMatches,
      findAllMatches = Config.findAllMatches,
      minMatchCharLength = Config.minMatchCharLength,
      isCaseSensitive = Config.isCaseSensitive,
      ignoreLocation = Config.ignoreLocation
    } = {}
  ) {
    this.options = {
      location,
      threshold,
      distance,
      includeMatches,
      findAllMatches,
      minMatchCharLength,
      isCaseSensitive,
      ignoreLocation
    };

    this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();

    this.chunks = [];

    if (!this.pattern.length) {
      return
    }

    const addChunk = (pattern, startIndex) => {
      this.chunks.push({
        pattern,
        alphabet: createPatternAlphabet(pattern),
        startIndex
      });
    };

    const len = this.pattern.length;

    if (len > MAX_BITS) {
      let i = 0;
      const remainder = len % MAX_BITS;
      const end = len - remainder;

      while (i < end) {
        addChunk(this.pattern.substr(i, MAX_BITS), i);
        i += MAX_BITS;
      }

      if (remainder) {
        const startIndex = len - MAX_BITS;
        addChunk(this.pattern.substr(startIndex), startIndex);
      }
    } else {
      addChunk(this.pattern, 0);
    }
  }

  searchIn(text) {
    const { isCaseSensitive, includeMatches } = this.options;

    if (!isCaseSensitive) {
      text = text.toLowerCase();
    }

    // Exact match
    if (this.pattern === text) {
      let result = {
        isMatch: true,
        score: 0
      };

      if (includeMatches) {
        result.indices = [[0, text.length - 1]];
      }

      return result
    }

    // Otherwise, use Bitap algorithm
    const {
      location,
      distance,
      threshold,
      findAllMatches,
      minMatchCharLength,
      ignoreLocation
    } = this.options;

    let allIndices = [];
    let totalScore = 0;
    let hasMatches = false;

    this.chunks.forEach(({ pattern, alphabet, startIndex }) => {
      const { isMatch, score, indices } = search(text, pattern, alphabet, {
        location: location + startIndex,
        distance,
        threshold,
        findAllMatches,
        minMatchCharLength,
        includeMatches,
        ignoreLocation
      });

      if (isMatch) {
        hasMatches = true;
      }

      totalScore += score;

      if (isMatch && indices) {
        allIndices = [...allIndices, ...indices];
      }
    });

    let result = {
      isMatch: hasMatches,
      score: hasMatches ? totalScore / this.chunks.length : 1
    };

    if (hasMatches && includeMatches) {
      result.indices = allIndices;
    }

    return result
  }
}

class BaseMatch {
  constructor(pattern) {
    this.pattern = pattern;
  }
  static isMultiMatch(pattern) {
    return getMatch(pattern, this.multiRegex)
  }
  static isSingleMatch(pattern) {
    return getMatch(pattern, this.singleRegex)
  }
  search(/*text*/) {}
}

function getMatch(pattern, exp) {
  const matches = pattern.match(exp);
  return matches ? matches[1] : null
}

// Token: 'file

class ExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'exact'
  }
  static get multiRegex() {
    return /^="(.*)"$/
  }
  static get singleRegex() {
    return /^=(.*)$/
  }
  search(text) {
    const isMatch = text === this.pattern;

    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, this.pattern.length - 1]
    }
  }
}

// Token: !fire

class InverseExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'inverse-exact'
  }
  static get multiRegex() {
    return /^!"(.*)"$/
  }
  static get singleRegex() {
    return /^!(.*)$/
  }
  search(text) {
    const index = text.indexOf(this.pattern);
    const isMatch = index === -1;

    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, text.length - 1]
    }
  }
}

// Token: ^file

class PrefixExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'prefix-exact'
  }
  static get multiRegex() {
    return /^\^"(.*)"$/
  }
  static get singleRegex() {
    return /^\^(.*)$/
  }
  search(text) {
    const isMatch = text.startsWith(this.pattern);

    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, this.pattern.length - 1]
    }
  }
}

// Token: !^fire

class InversePrefixExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'inverse-prefix-exact'
  }
  static get multiRegex() {
    return /^!\^"(.*)"$/
  }
  static get singleRegex() {
    return /^!\^(.*)$/
  }
  search(text) {
    const isMatch = !text.startsWith(this.pattern);

    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, text.length - 1]
    }
  }
}

// Token: .file$

class SuffixExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'suffix-exact'
  }
  static get multiRegex() {
    return /^"(.*)"\$$/
  }
  static get singleRegex() {
    return /^(.*)\$$/
  }
  search(text) {
    const isMatch = text.endsWith(this.pattern);

    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [text.length - this.pattern.length, text.length - 1]
    }
  }
}

// Token: !.file$

class InverseSuffixExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'inverse-suffix-exact'
  }
  static get multiRegex() {
    return /^!"(.*)"\$$/
  }
  static get singleRegex() {
    return /^!(.*)\$$/
  }
  search(text) {
    const isMatch = !text.endsWith(this.pattern);
    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, text.length - 1]
    }
  }
}

class FuzzyMatch extends BaseMatch {
  constructor(
    pattern,
    {
      location = Config.location,
      threshold = Config.threshold,
      distance = Config.distance,
      includeMatches = Config.includeMatches,
      findAllMatches = Config.findAllMatches,
      minMatchCharLength = Config.minMatchCharLength,
      isCaseSensitive = Config.isCaseSensitive,
      ignoreLocation = Config.ignoreLocation
    } = {}
  ) {
    super(pattern);
    this._bitapSearch = new BitapSearch(pattern, {
      location,
      threshold,
      distance,
      includeMatches,
      findAllMatches,
      minMatchCharLength,
      isCaseSensitive,
      ignoreLocation
    });
  }
  static get type() {
    return 'fuzzy'
  }
  static get multiRegex() {
    return /^"(.*)"$/
  }
  static get singleRegex() {
    return /^(.*)$/
  }
  search(text) {
    return this._bitapSearch.searchIn(text)
  }
}

// Token: 'file

class IncludeMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'include'
  }
  static get multiRegex() {
    return /^'"(.*)"$/
  }
  static get singleRegex() {
    return /^'(.*)$/
  }
  search(text) {
    let location = 0;
    let index;

    const indices = [];
    const patternLen = this.pattern.length;

    // Get all exact matches
    while ((index = text.indexOf(this.pattern, location)) > -1) {
      location = index + patternLen;
      indices.push([index, location - 1]);
    }

    const isMatch = !!indices.length;

    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices
    }
  }
}

// ❗Order is important. DO NOT CHANGE.
const searchers = [
  ExactMatch,
  IncludeMatch,
  PrefixExactMatch,
  InversePrefixExactMatch,
  InverseSuffixExactMatch,
  SuffixExactMatch,
  InverseExactMatch,
  FuzzyMatch
];

const searchersLen = searchers.length;

// Regex to split by spaces, but keep anything in quotes together
const SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
const OR_TOKEN = '|';

// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function parseQuery(pattern, options = {}) {
  return pattern.split(OR_TOKEN).map((item) => {
    let query = item
      .trim()
      .split(SPACE_RE)
      .filter((item) => item && !!item.trim());

    let results = [];
    for (let i = 0, len = query.length; i < len; i += 1) {
      const queryItem = query[i];

      // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
      let found = false;
      let idx = -1;
      while (!found && ++idx < searchersLen) {
        const searcher = searchers[idx];
        let token = searcher.isMultiMatch(queryItem);
        if (token) {
          results.push(new searcher(token, options));
          found = true;
        }
      }

      if (found) {
        continue
      }

      // 2. Handle single query matches (i.e, once that are *not* quoted)
      idx = -1;
      while (++idx < searchersLen) {
        const searcher = searchers[idx];
        let token = searcher.isSingleMatch(queryItem);
        if (token) {
          results.push(new searcher(token, options));
          break
        }
      }
    }

    return results
  })
}

// These extended matchers can return an array of matches, as opposed
// to a singl match
const MultiMatchSet = new Set([FuzzyMatch.type, IncludeMatch.type]);

/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */
class ExtendedSearch {
  constructor(
    pattern,
    {
      isCaseSensitive = Config.isCaseSensitive,
      includeMatches = Config.includeMatches,
      minMatchCharLength = Config.minMatchCharLength,
      ignoreLocation = Config.ignoreLocation,
      findAllMatches = Config.findAllMatches,
      location = Config.location,
      threshold = Config.threshold,
      distance = Config.distance
    } = {}
  ) {
    this.query = null;
    this.options = {
      isCaseSensitive,
      includeMatches,
      minMatchCharLength,
      findAllMatches,
      ignoreLocation,
      location,
      threshold,
      distance
    };

    this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
    this.query = parseQuery(this.pattern, this.options);
  }

  static condition(_, options) {
    return options.useExtendedSearch
  }

  searchIn(text) {
    const query = this.query;

    if (!query) {
      return {
        isMatch: false,
        score: 1
      }
    }

    const { includeMatches, isCaseSensitive } = this.options;

    text = isCaseSensitive ? text : text.toLowerCase();

    let numMatches = 0;
    let allIndices = [];
    let totalScore = 0;

    // ORs
    for (let i = 0, qLen = query.length; i < qLen; i += 1) {
      const searchers = query[i];

      // Reset indices
      allIndices.length = 0;
      numMatches = 0;

      // ANDs
      for (let j = 0, pLen = searchers.length; j < pLen; j += 1) {
        const searcher = searchers[j];
        const { isMatch, indices, score } = searcher.search(text);

        if (isMatch) {
          numMatches += 1;
          totalScore += score;
          if (includeMatches) {
            const type = searcher.constructor.type;
            if (MultiMatchSet.has(type)) {
              allIndices = [...allIndices, ...indices];
            } else {
              allIndices.push(indices);
            }
          }
        } else {
          totalScore = 0;
          numMatches = 0;
          allIndices.length = 0;
          break
        }
      }

      // OR condition, so if TRUE, return
      if (numMatches) {
        let result = {
          isMatch: true,
          score: totalScore / numMatches
        };

        if (includeMatches) {
          result.indices = allIndices;
        }

        return result
      }
    }

    // Nothing was matched
    return {
      isMatch: false,
      score: 1
    }
  }
}

const registeredSearchers = [];

function register(...args) {
  registeredSearchers.push(...args);
}

function createSearcher(pattern, options) {
  for (let i = 0, len = registeredSearchers.length; i < len; i += 1) {
    let searcherClass = registeredSearchers[i];
    if (searcherClass.condition(pattern, options)) {
      return new searcherClass(pattern, options)
    }
  }

  return new BitapSearch(pattern, options)
}

const LogicalOperator = {
  AND: '$and',
  OR: '$or'
};

const KeyType = {
  PATH: '$path',
  PATTERN: '$val'
};

const isExpression = (query) =>
  !!(query[LogicalOperator.AND] || query[LogicalOperator.OR]);

const isPath = (query) => !!query[KeyType.PATH];

const isLeaf = (query) =>
  !isArray(query) && isObject(query) && !isExpression(query);

const convertToExplicit = (query) => ({
  [LogicalOperator.AND]: Object.keys(query).map((key) => ({
    [key]: query[key]
  }))
});

// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function parse(query, options, { auto = true } = {}) {
  const next = (query) => {
    let keys = Object.keys(query);

    const isQueryPath = isPath(query);

    if (!isQueryPath && keys.length > 1 && !isExpression(query)) {
      return next(convertToExplicit(query))
    }

    if (isLeaf(query)) {
      const key = isQueryPath ? query[KeyType.PATH] : keys[0];

      const pattern = isQueryPath ? query[KeyType.PATTERN] : query[key];

      if (!isString(pattern)) {
        throw new Error(LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key))
      }

      const obj = {
        keyId: createKeyId(key),
        pattern
      };

      if (auto) {
        obj.searcher = createSearcher(pattern, options);
      }

      return obj
    }

    let node = {
      children: [],
      operator: keys[0]
    };

    keys.forEach((key) => {
      const value = query[key];

      if (isArray(value)) {
        value.forEach((item) => {
          node.children.push(next(item));
        });
      }
    });

    return node
  };

  if (!isExpression(query)) {
    query = convertToExplicit(query);
  }

  return next(query)
}

// Practical scoring function
function computeScore(
  results,
  { ignoreFieldNorm = Config.ignoreFieldNorm }
) {
  results.forEach((result) => {
    let totalScore = 1;

    result.matches.forEach(({ key, norm, score }) => {
      const weight = key ? key.weight : null;

      totalScore *= Math.pow(
        score === 0 && weight ? Number.EPSILON : score,
        (weight || 1) * (ignoreFieldNorm ? 1 : norm)
      );
    });

    result.score = totalScore;
  });
}

function transformMatches(result, data) {
  const matches = result.matches;
  data.matches = [];

  if (!isDefined(matches)) {
    return
  }

  matches.forEach((match) => {
    if (!isDefined(match.indices) || !match.indices.length) {
      return
    }

    const { indices, value } = match;

    let obj = {
      indices,
      value
    };

    if (match.key) {
      obj.key = match.key.src;
    }

    if (match.idx > -1) {
      obj.refIndex = match.idx;
    }

    data.matches.push(obj);
  });
}

function transformScore(result, data) {
  data.score = result.score;
}

function format(
  results,
  docs,
  {
    includeMatches = Config.includeMatches,
    includeScore = Config.includeScore
  } = {}
) {
  const transformers = [];

  if (includeMatches) transformers.push(transformMatches);
  if (includeScore) transformers.push(transformScore);

  return results.map((result) => {
    const { idx } = result;

    const data = {
      item: docs[idx],
      refIndex: idx
    };

    if (transformers.length) {
      transformers.forEach((transformer) => {
        transformer(result, data);
      });
    }

    return data
  })
}

class Fuse {
  constructor(docs, options = {}, index) {
    this.options = { ...Config, ...options };

    if (
      this.options.useExtendedSearch &&
      !true
    ) {}

    this._keyStore = new KeyStore(this.options.keys);

    this.setCollection(docs, index);
  }

  setCollection(docs, index) {
    this._docs = docs;

    if (index && !(index instanceof FuseIndex)) {
      throw new Error(INCORRECT_INDEX_TYPE)
    }

    this._myIndex =
      index ||
      createIndex(this.options.keys, this._docs, {
        getFn: this.options.getFn,
        fieldNormWeight: this.options.fieldNormWeight
      });
  }

  add(doc) {
    if (!isDefined(doc)) {
      return
    }

    this._docs.push(doc);
    this._myIndex.add(doc);
  }

  remove(predicate = (/* doc, idx */) => false) {
    const results = [];

    for (let i = 0, len = this._docs.length; i < len; i += 1) {
      const doc = this._docs[i];
      if (predicate(doc, i)) {
        this.removeAt(i);
        i -= 1;
        len -= 1;

        results.push(doc);
      }
    }

    return results
  }

  removeAt(idx) {
    this._docs.splice(idx, 1);
    this._myIndex.removeAt(idx);
  }

  getIndex() {
    return this._myIndex
  }

  search(query, { limit = -1 } = {}) {
    const {
      includeMatches,
      includeScore,
      shouldSort,
      sortFn,
      ignoreFieldNorm
    } = this.options;

    let results = isString(query)
      ? isString(this._docs[0])
        ? this._searchStringList(query)
        : this._searchObjectList(query)
      : this._searchLogical(query);

    computeScore(results, { ignoreFieldNorm });

    if (shouldSort) {
      results.sort(sortFn);
    }

    if (isNumber(limit) && limit > -1) {
      results = results.slice(0, limit);
    }

    return format(results, this._docs, {
      includeMatches,
      includeScore
    })
  }

  _searchStringList(query) {
    const searcher = createSearcher(query, this.options);
    const { records } = this._myIndex;
    const results = [];

    // Iterate over every string in the index
    records.forEach(({ v: text, i: idx, n: norm }) => {
      if (!isDefined(text)) {
        return
      }

      const { isMatch, score, indices } = searcher.searchIn(text);

      if (isMatch) {
        results.push({
          item: text,
          idx,
          matches: [{ score, value: text, norm, indices }]
        });
      }
    });

    return results
  }

  _searchLogical(query) {

    const expression = parse(query, this.options);

    const evaluate = (node, item, idx) => {
      if (!node.children) {
        const { keyId, searcher } = node;

        const matches = this._findMatches({
          key: this._keyStore.get(keyId),
          value: this._myIndex.getValueForItemAtKeyId(item, keyId),
          searcher
        });

        if (matches && matches.length) {
          return [
            {
              idx,
              item,
              matches
            }
          ]
        }

        return []
      }

      const res = [];
      for (let i = 0, len = node.children.length; i < len; i += 1) {
        const child = node.children[i];
        const result = evaluate(child, item, idx);
        if (result.length) {
          res.push(...result);
        } else if (node.operator === LogicalOperator.AND) {
          return []
        }
      }
      return res
    };

    const records = this._myIndex.records;
    const resultMap = {};
    const results = [];

    records.forEach(({ $: item, i: idx }) => {
      if (isDefined(item)) {
        let expResults = evaluate(expression, item, idx);

        if (expResults.length) {
          // Dedupe when adding
          if (!resultMap[idx]) {
            resultMap[idx] = { idx, item, matches: [] };
            results.push(resultMap[idx]);
          }
          expResults.forEach(({ matches }) => {
            resultMap[idx].matches.push(...matches);
          });
        }
      }
    });

    return results
  }

  _searchObjectList(query) {
    const searcher = createSearcher(query, this.options);
    const { keys, records } = this._myIndex;
    const results = [];

    // List is Array<Object>
    records.forEach(({ $: item, i: idx }) => {
      if (!isDefined(item)) {
        return
      }

      let matches = [];

      // Iterate over every key (i.e, path), and fetch the value at that key
      keys.forEach((key, keyIndex) => {
        matches.push(
          ...this._findMatches({
            key,
            value: item[keyIndex],
            searcher
          })
        );
      });

      if (matches.length) {
        results.push({
          idx,
          item,
          matches
        });
      }
    });

    return results
  }
  _findMatches({ key, value, searcher }) {
    if (!isDefined(value)) {
      return []
    }

    let matches = [];

    if (isArray(value)) {
      value.forEach(({ v: text, i: idx, n: norm }) => {
        if (!isDefined(text)) {
          return
        }

        const { isMatch, score, indices } = searcher.searchIn(text);

        if (isMatch) {
          matches.push({
            score,
            key,
            value: text,
            idx,
            norm,
            indices
          });
        }
      });
    } else {
      const { v: text, n: norm } = value;

      const { isMatch, score, indices } = searcher.searchIn(text);

      if (isMatch) {
        matches.push({ score, key, value: text, norm, indices });
      }
    }

    return matches
  }
}

Fuse.version = '6.6.2';
Fuse.createIndex = createIndex;
Fuse.parseIndex = parseIndex;
Fuse.config = Config;

{
  Fuse.parseQuery = parse;
}

{
  register(ExtendedSearch);
}




/***/ }),

/***/ 7842:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/he v1.2.0 by @mathias | MIT license */
;(function(root) {

	// Detect free variables `exports`.
	var freeExports =  true && exports;

	// Detect free variable `module`.
	var freeModule =  true && module &&
		module.exports == freeExports && module;

	// Detect free variable `global`, from Node.js or Browserified code,
	// and use it as `root`.
	var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g;
	if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
		root = freeGlobal;
	}

	/*--------------------------------------------------------------------------*/

	// All astral symbols.
	var regexAstralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
	// All ASCII symbols (not just printable ASCII) except those listed in the
	// first column of the overrides table.
	// https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides
	var regexAsciiWhitelist = /[\x01-\x7F]/g;
	// All BMP symbols that are not ASCII newlines, printable ASCII symbols, or
	// code points listed in the first column of the overrides table on
	// https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides.
	var regexBmpWhitelist = /[\x01-\t\x0B\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g;

	var regexEncodeNonAscii = /<\u20D2|=\u20E5|>\u20D2|\u205F\u200A|\u219D\u0338|\u2202\u0338|\u2220\u20D2|\u2229\uFE00|\u222A\uFE00|\u223C\u20D2|\u223D\u0331|\u223E\u0333|\u2242\u0338|\u224B\u0338|\u224D\u20D2|\u224E\u0338|\u224F\u0338|\u2250\u0338|\u2261\u20E5|\u2264\u20D2|\u2265\u20D2|\u2266\u0338|\u2267\u0338|\u2268\uFE00|\u2269\uFE00|\u226A\u0338|\u226A\u20D2|\u226B\u0338|\u226B\u20D2|\u227F\u0338|\u2282\u20D2|\u2283\u20D2|\u228A\uFE00|\u228B\uFE00|\u228F\u0338|\u2290\u0338|\u2293\uFE00|\u2294\uFE00|\u22B4\u20D2|\u22B5\u20D2|\u22D8\u0338|\u22D9\u0338|\u22DA\uFE00|\u22DB\uFE00|\u22F5\u0338|\u22F9\u0338|\u2933\u0338|\u29CF\u0338|\u29D0\u0338|\u2A6D\u0338|\u2A70\u0338|\u2A7D\u0338|\u2A7E\u0338|\u2AA1\u0338|\u2AA2\u0338|\u2AAC\uFE00|\u2AAD\uFE00|\u2AAF\u0338|\u2AB0\u0338|\u2AC5\u0338|\u2AC6\u0338|\u2ACB\uFE00|\u2ACC\uFE00|\u2AFD\u20E5|[\xA0-\u0113\u0116-\u0122\u0124-\u012B\u012E-\u014D\u0150-\u017E\u0192\u01B5\u01F5\u0237\u02C6\u02C7\u02D8-\u02DD\u0311\u0391-\u03A1\u03A3-\u03A9\u03B1-\u03C9\u03D1\u03D2\u03D5\u03D6\u03DC\u03DD\u03F0\u03F1\u03F5\u03F6\u0401-\u040C\u040E-\u044F\u0451-\u045C\u045E\u045F\u2002-\u2005\u2007-\u2010\u2013-\u2016\u2018-\u201A\u201C-\u201E\u2020-\u2022\u2025\u2026\u2030-\u2035\u2039\u203A\u203E\u2041\u2043\u2044\u204F\u2057\u205F-\u2063\u20AC\u20DB\u20DC\u2102\u2105\u210A-\u2113\u2115-\u211E\u2122\u2124\u2127-\u2129\u212C\u212D\u212F-\u2131\u2133-\u2138\u2145-\u2148\u2153-\u215E\u2190-\u219B\u219D-\u21A7\u21A9-\u21AE\u21B0-\u21B3\u21B5-\u21B7\u21BA-\u21DB\u21DD\u21E4\u21E5\u21F5\u21FD-\u2205\u2207-\u2209\u220B\u220C\u220F-\u2214\u2216-\u2218\u221A\u221D-\u2238\u223A-\u2257\u2259\u225A\u225C\u225F-\u2262\u2264-\u228B\u228D-\u229B\u229D-\u22A5\u22A7-\u22B0\u22B2-\u22BB\u22BD-\u22DB\u22DE-\u22E3\u22E6-\u22F7\u22F9-\u22FE\u2305\u2306\u2308-\u2310\u2312\u2313\u2315\u2316\u231C-\u231F\u2322\u2323\u232D\u232E\u2336\u233D\u233F\u237C\u23B0\u23B1\u23B4-\u23B6\u23DC-\u23DF\u23E2\u23E7\u2423\u24C8\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2550-\u256C\u2580\u2584\u2588\u2591-\u2593\u25A1\u25AA\u25AB\u25AD\u25AE\u25B1\u25B3-\u25B5\u25B8\u25B9\u25BD-\u25BF\u25C2\u25C3\u25CA\u25CB\u25EC\u25EF\u25F8-\u25FC\u2605\u2606\u260E\u2640\u2642\u2660\u2663\u2665\u2666\u266A\u266D-\u266F\u2713\u2717\u2720\u2736\u2758\u2772\u2773\u27C8\u27C9\u27E6-\u27ED\u27F5-\u27FA\u27FC\u27FF\u2902-\u2905\u290C-\u2913\u2916\u2919-\u2920\u2923-\u292A\u2933\u2935-\u2939\u293C\u293D\u2945\u2948-\u294B\u294E-\u2976\u2978\u2979\u297B-\u297F\u2985\u2986\u298B-\u2996\u299A\u299C\u299D\u29A4-\u29B7\u29B9\u29BB\u29BC\u29BE-\u29C5\u29C9\u29CD-\u29D0\u29DC-\u29DE\u29E3-\u29E5\u29EB\u29F4\u29F6\u2A00-\u2A02\u2A04\u2A06\u2A0C\u2A0D\u2A10-\u2A17\u2A22-\u2A27\u2A29\u2A2A\u2A2D-\u2A31\u2A33-\u2A3C\u2A3F\u2A40\u2A42-\u2A4D\u2A50\u2A53-\u2A58\u2A5A-\u2A5D\u2A5F\u2A66\u2A6A\u2A6D-\u2A75\u2A77-\u2A9A\u2A9D-\u2AA2\u2AA4-\u2AB0\u2AB3-\u2AC8\u2ACB\u2ACC\u2ACF-\u2ADB\u2AE4\u2AE6-\u2AE9\u2AEB-\u2AF3\u2AFD\uFB00-\uFB04]|\uD835[\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDD6B]/g;
	var encodeMap = {'\xAD':'shy','\u200C':'zwnj','\u200D':'zwj','\u200E':'lrm','\u2063':'ic','\u2062':'it','\u2061':'af','\u200F':'rlm','\u200B':'ZeroWidthSpace','\u2060':'NoBreak','\u0311':'DownBreve','\u20DB':'tdot','\u20DC':'DotDot','\t':'Tab','\n':'NewLine','\u2008':'puncsp','\u205F':'MediumSpace','\u2009':'thinsp','\u200A':'hairsp','\u2004':'emsp13','\u2002':'ensp','\u2005':'emsp14','\u2003':'emsp','\u2007':'numsp','\xA0':'nbsp','\u205F\u200A':'ThickSpace','\u203E':'oline','_':'lowbar','\u2010':'dash','\u2013':'ndash','\u2014':'mdash','\u2015':'horbar',',':'comma',';':'semi','\u204F':'bsemi',':':'colon','\u2A74':'Colone','!':'excl','\xA1':'iexcl','?':'quest','\xBF':'iquest','.':'period','\u2025':'nldr','\u2026':'mldr','\xB7':'middot','\'':'apos','\u2018':'lsquo','\u2019':'rsquo','\u201A':'sbquo','\u2039':'lsaquo','\u203A':'rsaquo','"':'quot','\u201C':'ldquo','\u201D':'rdquo','\u201E':'bdquo','\xAB':'laquo','\xBB':'raquo','(':'lpar',')':'rpar','[':'lsqb',']':'rsqb','{':'lcub','}':'rcub','\u2308':'lceil','\u2309':'rceil','\u230A':'lfloor','\u230B':'rfloor','\u2985':'lopar','\u2986':'ropar','\u298B':'lbrke','\u298C':'rbrke','\u298D':'lbrkslu','\u298E':'rbrksld','\u298F':'lbrksld','\u2990':'rbrkslu','\u2991':'langd','\u2992':'rangd','\u2993':'lparlt','\u2994':'rpargt','\u2995':'gtlPar','\u2996':'ltrPar','\u27E6':'lobrk','\u27E7':'robrk','\u27E8':'lang','\u27E9':'rang','\u27EA':'Lang','\u27EB':'Rang','\u27EC':'loang','\u27ED':'roang','\u2772':'lbbrk','\u2773':'rbbrk','\u2016':'Vert','\xA7':'sect','\xB6':'para','@':'commat','*':'ast','/':'sol','undefined':null,'&':'amp','#':'num','%':'percnt','\u2030':'permil','\u2031':'pertenk','\u2020':'dagger','\u2021':'Dagger','\u2022':'bull','\u2043':'hybull','\u2032':'prime','\u2033':'Prime','\u2034':'tprime','\u2057':'qprime','\u2035':'bprime','\u2041':'caret','`':'grave','\xB4':'acute','\u02DC':'tilde','^':'Hat','\xAF':'macr','\u02D8':'breve','\u02D9':'dot','\xA8':'die','\u02DA':'ring','\u02DD':'dblac','\xB8':'cedil','\u02DB':'ogon','\u02C6':'circ','\u02C7':'caron','\xB0':'deg','\xA9':'copy','\xAE':'reg','\u2117':'copysr','\u2118':'wp','\u211E':'rx','\u2127':'mho','\u2129':'iiota','\u2190':'larr','\u219A':'nlarr','\u2192':'rarr','\u219B':'nrarr','\u2191':'uarr','\u2193':'darr','\u2194':'harr','\u21AE':'nharr','\u2195':'varr','\u2196':'nwarr','\u2197':'nearr','\u2198':'searr','\u2199':'swarr','\u219D':'rarrw','\u219D\u0338':'nrarrw','\u219E':'Larr','\u219F':'Uarr','\u21A0':'Rarr','\u21A1':'Darr','\u21A2':'larrtl','\u21A3':'rarrtl','\u21A4':'mapstoleft','\u21A5':'mapstoup','\u21A6':'map','\u21A7':'mapstodown','\u21A9':'larrhk','\u21AA':'rarrhk','\u21AB':'larrlp','\u21AC':'rarrlp','\u21AD':'harrw','\u21B0':'lsh','\u21B1':'rsh','\u21B2':'ldsh','\u21B3':'rdsh','\u21B5':'crarr','\u21B6':'cularr','\u21B7':'curarr','\u21BA':'olarr','\u21BB':'orarr','\u21BC':'lharu','\u21BD':'lhard','\u21BE':'uharr','\u21BF':'uharl','\u21C0':'rharu','\u21C1':'rhard','\u21C2':'dharr','\u21C3':'dharl','\u21C4':'rlarr','\u21C5':'udarr','\u21C6':'lrarr','\u21C7':'llarr','\u21C8':'uuarr','\u21C9':'rrarr','\u21CA':'ddarr','\u21CB':'lrhar','\u21CC':'rlhar','\u21D0':'lArr','\u21CD':'nlArr','\u21D1':'uArr','\u21D2':'rArr','\u21CF':'nrArr','\u21D3':'dArr','\u21D4':'iff','\u21CE':'nhArr','\u21D5':'vArr','\u21D6':'nwArr','\u21D7':'neArr','\u21D8':'seArr','\u21D9':'swArr','\u21DA':'lAarr','\u21DB':'rAarr','\u21DD':'zigrarr','\u21E4':'larrb','\u21E5':'rarrb','\u21F5':'duarr','\u21FD':'loarr','\u21FE':'roarr','\u21FF':'hoarr','\u2200':'forall','\u2201':'comp','\u2202':'part','\u2202\u0338':'npart','\u2203':'exist','\u2204':'nexist','\u2205':'empty','\u2207':'Del','\u2208':'in','\u2209':'notin','\u220B':'ni','\u220C':'notni','\u03F6':'bepsi','\u220F':'prod','\u2210':'coprod','\u2211':'sum','+':'plus','\xB1':'pm','\xF7':'div','\xD7':'times','<':'lt','\u226E':'nlt','<\u20D2':'nvlt','=':'equals','\u2260':'ne','=\u20E5':'bne','\u2A75':'Equal','>':'gt','\u226F':'ngt','>\u20D2':'nvgt','\xAC':'not','|':'vert','\xA6':'brvbar','\u2212':'minus','\u2213':'mp','\u2214':'plusdo','\u2044':'frasl','\u2216':'setmn','\u2217':'lowast','\u2218':'compfn','\u221A':'Sqrt','\u221D':'prop','\u221E':'infin','\u221F':'angrt','\u2220':'ang','\u2220\u20D2':'nang','\u2221':'angmsd','\u2222':'angsph','\u2223':'mid','\u2224':'nmid','\u2225':'par','\u2226':'npar','\u2227':'and','\u2228':'or','\u2229':'cap','\u2229\uFE00':'caps','\u222A':'cup','\u222A\uFE00':'cups','\u222B':'int','\u222C':'Int','\u222D':'tint','\u2A0C':'qint','\u222E':'oint','\u222F':'Conint','\u2230':'Cconint','\u2231':'cwint','\u2232':'cwconint','\u2233':'awconint','\u2234':'there4','\u2235':'becaus','\u2236':'ratio','\u2237':'Colon','\u2238':'minusd','\u223A':'mDDot','\u223B':'homtht','\u223C':'sim','\u2241':'nsim','\u223C\u20D2':'nvsim','\u223D':'bsim','\u223D\u0331':'race','\u223E':'ac','\u223E\u0333':'acE','\u223F':'acd','\u2240':'wr','\u2242':'esim','\u2242\u0338':'nesim','\u2243':'sime','\u2244':'nsime','\u2245':'cong','\u2247':'ncong','\u2246':'simne','\u2248':'ap','\u2249':'nap','\u224A':'ape','\u224B':'apid','\u224B\u0338':'napid','\u224C':'bcong','\u224D':'CupCap','\u226D':'NotCupCap','\u224D\u20D2':'nvap','\u224E':'bump','\u224E\u0338':'nbump','\u224F':'bumpe','\u224F\u0338':'nbumpe','\u2250':'doteq','\u2250\u0338':'nedot','\u2251':'eDot','\u2252':'efDot','\u2253':'erDot','\u2254':'colone','\u2255':'ecolon','\u2256':'ecir','\u2257':'cire','\u2259':'wedgeq','\u225A':'veeeq','\u225C':'trie','\u225F':'equest','\u2261':'equiv','\u2262':'nequiv','\u2261\u20E5':'bnequiv','\u2264':'le','\u2270':'nle','\u2264\u20D2':'nvle','\u2265':'ge','\u2271':'nge','\u2265\u20D2':'nvge','\u2266':'lE','\u2266\u0338':'nlE','\u2267':'gE','\u2267\u0338':'ngE','\u2268\uFE00':'lvnE','\u2268':'lnE','\u2269':'gnE','\u2269\uFE00':'gvnE','\u226A':'ll','\u226A\u0338':'nLtv','\u226A\u20D2':'nLt','\u226B':'gg','\u226B\u0338':'nGtv','\u226B\u20D2':'nGt','\u226C':'twixt','\u2272':'lsim','\u2274':'nlsim','\u2273':'gsim','\u2275':'ngsim','\u2276':'lg','\u2278':'ntlg','\u2277':'gl','\u2279':'ntgl','\u227A':'pr','\u2280':'npr','\u227B':'sc','\u2281':'nsc','\u227C':'prcue','\u22E0':'nprcue','\u227D':'sccue','\u22E1':'nsccue','\u227E':'prsim','\u227F':'scsim','\u227F\u0338':'NotSucceedsTilde','\u2282':'sub','\u2284':'nsub','\u2282\u20D2':'vnsub','\u2283':'sup','\u2285':'nsup','\u2283\u20D2':'vnsup','\u2286':'sube','\u2288':'nsube','\u2287':'supe','\u2289':'nsupe','\u228A\uFE00':'vsubne','\u228A':'subne','\u228B\uFE00':'vsupne','\u228B':'supne','\u228D':'cupdot','\u228E':'uplus','\u228F':'sqsub','\u228F\u0338':'NotSquareSubset','\u2290':'sqsup','\u2290\u0338':'NotSquareSuperset','\u2291':'sqsube','\u22E2':'nsqsube','\u2292':'sqsupe','\u22E3':'nsqsupe','\u2293':'sqcap','\u2293\uFE00':'sqcaps','\u2294':'sqcup','\u2294\uFE00':'sqcups','\u2295':'oplus','\u2296':'ominus','\u2297':'otimes','\u2298':'osol','\u2299':'odot','\u229A':'ocir','\u229B':'oast','\u229D':'odash','\u229E':'plusb','\u229F':'minusb','\u22A0':'timesb','\u22A1':'sdotb','\u22A2':'vdash','\u22AC':'nvdash','\u22A3':'dashv','\u22A4':'top','\u22A5':'bot','\u22A7':'models','\u22A8':'vDash','\u22AD':'nvDash','\u22A9':'Vdash','\u22AE':'nVdash','\u22AA':'Vvdash','\u22AB':'VDash','\u22AF':'nVDash','\u22B0':'prurel','\u22B2':'vltri','\u22EA':'nltri','\u22B3':'vrtri','\u22EB':'nrtri','\u22B4':'ltrie','\u22EC':'nltrie','\u22B4\u20D2':'nvltrie','\u22B5':'rtrie','\u22ED':'nrtrie','\u22B5\u20D2':'nvrtrie','\u22B6':'origof','\u22B7':'imof','\u22B8':'mumap','\u22B9':'hercon','\u22BA':'intcal','\u22BB':'veebar','\u22BD':'barvee','\u22BE':'angrtvb','\u22BF':'lrtri','\u22C0':'Wedge','\u22C1':'Vee','\u22C2':'xcap','\u22C3':'xcup','\u22C4':'diam','\u22C5':'sdot','\u22C6':'Star','\u22C7':'divonx','\u22C8':'bowtie','\u22C9':'ltimes','\u22CA':'rtimes','\u22CB':'lthree','\u22CC':'rthree','\u22CD':'bsime','\u22CE':'cuvee','\u22CF':'cuwed','\u22D0':'Sub','\u22D1':'Sup','\u22D2':'Cap','\u22D3':'Cup','\u22D4':'fork','\u22D5':'epar','\u22D6':'ltdot','\u22D7':'gtdot','\u22D8':'Ll','\u22D8\u0338':'nLl','\u22D9':'Gg','\u22D9\u0338':'nGg','\u22DA\uFE00':'lesg','\u22DA':'leg','\u22DB':'gel','\u22DB\uFE00':'gesl','\u22DE':'cuepr','\u22DF':'cuesc','\u22E6':'lnsim','\u22E7':'gnsim','\u22E8':'prnsim','\u22E9':'scnsim','\u22EE':'vellip','\u22EF':'ctdot','\u22F0':'utdot','\u22F1':'dtdot','\u22F2':'disin','\u22F3':'isinsv','\u22F4':'isins','\u22F5':'isindot','\u22F5\u0338':'notindot','\u22F6':'notinvc','\u22F7':'notinvb','\u22F9':'isinE','\u22F9\u0338':'notinE','\u22FA':'nisd','\u22FB':'xnis','\u22FC':'nis','\u22FD':'notnivc','\u22FE':'notnivb','\u2305':'barwed','\u2306':'Barwed','\u230C':'drcrop','\u230D':'dlcrop','\u230E':'urcrop','\u230F':'ulcrop','\u2310':'bnot','\u2312':'profline','\u2313':'profsurf','\u2315':'telrec','\u2316':'target','\u231C':'ulcorn','\u231D':'urcorn','\u231E':'dlcorn','\u231F':'drcorn','\u2322':'frown','\u2323':'smile','\u232D':'cylcty','\u232E':'profalar','\u2336':'topbot','\u233D':'ovbar','\u233F':'solbar','\u237C':'angzarr','\u23B0':'lmoust','\u23B1':'rmoust','\u23B4':'tbrk','\u23B5':'bbrk','\u23B6':'bbrktbrk','\u23DC':'OverParenthesis','\u23DD':'UnderParenthesis','\u23DE':'OverBrace','\u23DF':'UnderBrace','\u23E2':'trpezium','\u23E7':'elinters','\u2423':'blank','\u2500':'boxh','\u2502':'boxv','\u250C':'boxdr','\u2510':'boxdl','\u2514':'boxur','\u2518':'boxul','\u251C':'boxvr','\u2524':'boxvl','\u252C':'boxhd','\u2534':'boxhu','\u253C':'boxvh','\u2550':'boxH','\u2551':'boxV','\u2552':'boxdR','\u2553':'boxDr','\u2554':'boxDR','\u2555':'boxdL','\u2556':'boxDl','\u2557':'boxDL','\u2558':'boxuR','\u2559':'boxUr','\u255A':'boxUR','\u255B':'boxuL','\u255C':'boxUl','\u255D':'boxUL','\u255E':'boxvR','\u255F':'boxVr','\u2560':'boxVR','\u2561':'boxvL','\u2562':'boxVl','\u2563':'boxVL','\u2564':'boxHd','\u2565':'boxhD','\u2566':'boxHD','\u2567':'boxHu','\u2568':'boxhU','\u2569':'boxHU','\u256A':'boxvH','\u256B':'boxVh','\u256C':'boxVH','\u2580':'uhblk','\u2584':'lhblk','\u2588':'block','\u2591':'blk14','\u2592':'blk12','\u2593':'blk34','\u25A1':'squ','\u25AA':'squf','\u25AB':'EmptyVerySmallSquare','\u25AD':'rect','\u25AE':'marker','\u25B1':'fltns','\u25B3':'xutri','\u25B4':'utrif','\u25B5':'utri','\u25B8':'rtrif','\u25B9':'rtri','\u25BD':'xdtri','\u25BE':'dtrif','\u25BF':'dtri','\u25C2':'ltrif','\u25C3':'ltri','\u25CA':'loz','\u25CB':'cir','\u25EC':'tridot','\u25EF':'xcirc','\u25F8':'ultri','\u25F9':'urtri','\u25FA':'lltri','\u25FB':'EmptySmallSquare','\u25FC':'FilledSmallSquare','\u2605':'starf','\u2606':'star','\u260E':'phone','\u2640':'female','\u2642':'male','\u2660':'spades','\u2663':'clubs','\u2665':'hearts','\u2666':'diams','\u266A':'sung','\u2713':'check','\u2717':'cross','\u2720':'malt','\u2736':'sext','\u2758':'VerticalSeparator','\u27C8':'bsolhsub','\u27C9':'suphsol','\u27F5':'xlarr','\u27F6':'xrarr','\u27F7':'xharr','\u27F8':'xlArr','\u27F9':'xrArr','\u27FA':'xhArr','\u27FC':'xmap','\u27FF':'dzigrarr','\u2902':'nvlArr','\u2903':'nvrArr','\u2904':'nvHarr','\u2905':'Map','\u290C':'lbarr','\u290D':'rbarr','\u290E':'lBarr','\u290F':'rBarr','\u2910':'RBarr','\u2911':'DDotrahd','\u2912':'UpArrowBar','\u2913':'DownArrowBar','\u2916':'Rarrtl','\u2919':'latail','\u291A':'ratail','\u291B':'lAtail','\u291C':'rAtail','\u291D':'larrfs','\u291E':'rarrfs','\u291F':'larrbfs','\u2920':'rarrbfs','\u2923':'nwarhk','\u2924':'nearhk','\u2925':'searhk','\u2926':'swarhk','\u2927':'nwnear','\u2928':'toea','\u2929':'tosa','\u292A':'swnwar','\u2933':'rarrc','\u2933\u0338':'nrarrc','\u2935':'cudarrr','\u2936':'ldca','\u2937':'rdca','\u2938':'cudarrl','\u2939':'larrpl','\u293C':'curarrm','\u293D':'cularrp','\u2945':'rarrpl','\u2948':'harrcir','\u2949':'Uarrocir','\u294A':'lurdshar','\u294B':'ldrushar','\u294E':'LeftRightVector','\u294F':'RightUpDownVector','\u2950':'DownLeftRightVector','\u2951':'LeftUpDownVector','\u2952':'LeftVectorBar','\u2953':'RightVectorBar','\u2954':'RightUpVectorBar','\u2955':'RightDownVectorBar','\u2956':'DownLeftVectorBar','\u2957':'DownRightVectorBar','\u2958':'LeftUpVectorBar','\u2959':'LeftDownVectorBar','\u295A':'LeftTeeVector','\u295B':'RightTeeVector','\u295C':'RightUpTeeVector','\u295D':'RightDownTeeVector','\u295E':'DownLeftTeeVector','\u295F':'DownRightTeeVector','\u2960':'LeftUpTeeVector','\u2961':'LeftDownTeeVector','\u2962':'lHar','\u2963':'uHar','\u2964':'rHar','\u2965':'dHar','\u2966':'luruhar','\u2967':'ldrdhar','\u2968':'ruluhar','\u2969':'rdldhar','\u296A':'lharul','\u296B':'llhard','\u296C':'rharul','\u296D':'lrhard','\u296E':'udhar','\u296F':'duhar','\u2970':'RoundImplies','\u2971':'erarr','\u2972':'simrarr','\u2973':'larrsim','\u2974':'rarrsim','\u2975':'rarrap','\u2976':'ltlarr','\u2978':'gtrarr','\u2979':'subrarr','\u297B':'suplarr','\u297C':'lfisht','\u297D':'rfisht','\u297E':'ufisht','\u297F':'dfisht','\u299A':'vzigzag','\u299C':'vangrt','\u299D':'angrtvbd','\u29A4':'ange','\u29A5':'range','\u29A6':'dwangle','\u29A7':'uwangle','\u29A8':'angmsdaa','\u29A9':'angmsdab','\u29AA':'angmsdac','\u29AB':'angmsdad','\u29AC':'angmsdae','\u29AD':'angmsdaf','\u29AE':'angmsdag','\u29AF':'angmsdah','\u29B0':'bemptyv','\u29B1':'demptyv','\u29B2':'cemptyv','\u29B3':'raemptyv','\u29B4':'laemptyv','\u29B5':'ohbar','\u29B6':'omid','\u29B7':'opar','\u29B9':'operp','\u29BB':'olcross','\u29BC':'odsold','\u29BE':'olcir','\u29BF':'ofcir','\u29C0':'olt','\u29C1':'ogt','\u29C2':'cirscir','\u29C3':'cirE','\u29C4':'solb','\u29C5':'bsolb','\u29C9':'boxbox','\u29CD':'trisb','\u29CE':'rtriltri','\u29CF':'LeftTriangleBar','\u29CF\u0338':'NotLeftTriangleBar','\u29D0':'RightTriangleBar','\u29D0\u0338':'NotRightTriangleBar','\u29DC':'iinfin','\u29DD':'infintie','\u29DE':'nvinfin','\u29E3':'eparsl','\u29E4':'smeparsl','\u29E5':'eqvparsl','\u29EB':'lozf','\u29F4':'RuleDelayed','\u29F6':'dsol','\u2A00':'xodot','\u2A01':'xoplus','\u2A02':'xotime','\u2A04':'xuplus','\u2A06':'xsqcup','\u2A0D':'fpartint','\u2A10':'cirfnint','\u2A11':'awint','\u2A12':'rppolint','\u2A13':'scpolint','\u2A14':'npolint','\u2A15':'pointint','\u2A16':'quatint','\u2A17':'intlarhk','\u2A22':'pluscir','\u2A23':'plusacir','\u2A24':'simplus','\u2A25':'plusdu','\u2A26':'plussim','\u2A27':'plustwo','\u2A29':'mcomma','\u2A2A':'minusdu','\u2A2D':'loplus','\u2A2E':'roplus','\u2A2F':'Cross','\u2A30':'timesd','\u2A31':'timesbar','\u2A33':'smashp','\u2A34':'lotimes','\u2A35':'rotimes','\u2A36':'otimesas','\u2A37':'Otimes','\u2A38':'odiv','\u2A39':'triplus','\u2A3A':'triminus','\u2A3B':'tritime','\u2A3C':'iprod','\u2A3F':'amalg','\u2A40':'capdot','\u2A42':'ncup','\u2A43':'ncap','\u2A44':'capand','\u2A45':'cupor','\u2A46':'cupcap','\u2A47':'capcup','\u2A48':'cupbrcap','\u2A49':'capbrcup','\u2A4A':'cupcup','\u2A4B':'capcap','\u2A4C':'ccups','\u2A4D':'ccaps','\u2A50':'ccupssm','\u2A53':'And','\u2A54':'Or','\u2A55':'andand','\u2A56':'oror','\u2A57':'orslope','\u2A58':'andslope','\u2A5A':'andv','\u2A5B':'orv','\u2A5C':'andd','\u2A5D':'ord','\u2A5F':'wedbar','\u2A66':'sdote','\u2A6A':'simdot','\u2A6D':'congdot','\u2A6D\u0338':'ncongdot','\u2A6E':'easter','\u2A6F':'apacir','\u2A70':'apE','\u2A70\u0338':'napE','\u2A71':'eplus','\u2A72':'pluse','\u2A73':'Esim','\u2A77':'eDDot','\u2A78':'equivDD','\u2A79':'ltcir','\u2A7A':'gtcir','\u2A7B':'ltquest','\u2A7C':'gtquest','\u2A7D':'les','\u2A7D\u0338':'nles','\u2A7E':'ges','\u2A7E\u0338':'nges','\u2A7F':'lesdot','\u2A80':'gesdot','\u2A81':'lesdoto','\u2A82':'gesdoto','\u2A83':'lesdotor','\u2A84':'gesdotol','\u2A85':'lap','\u2A86':'gap','\u2A87':'lne','\u2A88':'gne','\u2A89':'lnap','\u2A8A':'gnap','\u2A8B':'lEg','\u2A8C':'gEl','\u2A8D':'lsime','\u2A8E':'gsime','\u2A8F':'lsimg','\u2A90':'gsiml','\u2A91':'lgE','\u2A92':'glE','\u2A93':'lesges','\u2A94':'gesles','\u2A95':'els','\u2A96':'egs','\u2A97':'elsdot','\u2A98':'egsdot','\u2A99':'el','\u2A9A':'eg','\u2A9D':'siml','\u2A9E':'simg','\u2A9F':'simlE','\u2AA0':'simgE','\u2AA1':'LessLess','\u2AA1\u0338':'NotNestedLessLess','\u2AA2':'GreaterGreater','\u2AA2\u0338':'NotNestedGreaterGreater','\u2AA4':'glj','\u2AA5':'gla','\u2AA6':'ltcc','\u2AA7':'gtcc','\u2AA8':'lescc','\u2AA9':'gescc','\u2AAA':'smt','\u2AAB':'lat','\u2AAC':'smte','\u2AAC\uFE00':'smtes','\u2AAD':'late','\u2AAD\uFE00':'lates','\u2AAE':'bumpE','\u2AAF':'pre','\u2AAF\u0338':'npre','\u2AB0':'sce','\u2AB0\u0338':'nsce','\u2AB3':'prE','\u2AB4':'scE','\u2AB5':'prnE','\u2AB6':'scnE','\u2AB7':'prap','\u2AB8':'scap','\u2AB9':'prnap','\u2ABA':'scnap','\u2ABB':'Pr','\u2ABC':'Sc','\u2ABD':'subdot','\u2ABE':'supdot','\u2ABF':'subplus','\u2AC0':'supplus','\u2AC1':'submult','\u2AC2':'supmult','\u2AC3':'subedot','\u2AC4':'supedot','\u2AC5':'subE','\u2AC5\u0338':'nsubE','\u2AC6':'supE','\u2AC6\u0338':'nsupE','\u2AC7':'subsim','\u2AC8':'supsim','\u2ACB\uFE00':'vsubnE','\u2ACB':'subnE','\u2ACC\uFE00':'vsupnE','\u2ACC':'supnE','\u2ACF':'csub','\u2AD0':'csup','\u2AD1':'csube','\u2AD2':'csupe','\u2AD3':'subsup','\u2AD4':'supsub','\u2AD5':'subsub','\u2AD6':'supsup','\u2AD7':'suphsub','\u2AD8':'supdsub','\u2AD9':'forkv','\u2ADA':'topfork','\u2ADB':'mlcp','\u2AE4':'Dashv','\u2AE6':'Vdashl','\u2AE7':'Barv','\u2AE8':'vBar','\u2AE9':'vBarv','\u2AEB':'Vbar','\u2AEC':'Not','\u2AED':'bNot','\u2AEE':'rnmid','\u2AEF':'cirmid','\u2AF0':'midcir','\u2AF1':'topcir','\u2AF2':'nhpar','\u2AF3':'parsim','\u2AFD':'parsl','\u2AFD\u20E5':'nparsl','\u266D':'flat','\u266E':'natur','\u266F':'sharp','\xA4':'curren','\xA2':'cent','$':'dollar','\xA3':'pound','\xA5':'yen','\u20AC':'euro','\xB9':'sup1','\xBD':'half','\u2153':'frac13','\xBC':'frac14','\u2155':'frac15','\u2159':'frac16','\u215B':'frac18','\xB2':'sup2','\u2154':'frac23','\u2156':'frac25','\xB3':'sup3','\xBE':'frac34','\u2157':'frac35','\u215C':'frac38','\u2158':'frac45','\u215A':'frac56','\u215D':'frac58','\u215E':'frac78','\uD835\uDCB6':'ascr','\uD835\uDD52':'aopf','\uD835\uDD1E':'afr','\uD835\uDD38':'Aopf','\uD835\uDD04':'Afr','\uD835\uDC9C':'Ascr','\xAA':'ordf','\xE1':'aacute','\xC1':'Aacute','\xE0':'agrave','\xC0':'Agrave','\u0103':'abreve','\u0102':'Abreve','\xE2':'acirc','\xC2':'Acirc','\xE5':'aring','\xC5':'angst','\xE4':'auml','\xC4':'Auml','\xE3':'atilde','\xC3':'Atilde','\u0105':'aogon','\u0104':'Aogon','\u0101':'amacr','\u0100':'Amacr','\xE6':'aelig','\xC6':'AElig','\uD835\uDCB7':'bscr','\uD835\uDD53':'bopf','\uD835\uDD1F':'bfr','\uD835\uDD39':'Bopf','\u212C':'Bscr','\uD835\uDD05':'Bfr','\uD835\uDD20':'cfr','\uD835\uDCB8':'cscr','\uD835\uDD54':'copf','\u212D':'Cfr','\uD835\uDC9E':'Cscr','\u2102':'Copf','\u0107':'cacute','\u0106':'Cacute','\u0109':'ccirc','\u0108':'Ccirc','\u010D':'ccaron','\u010C':'Ccaron','\u010B':'cdot','\u010A':'Cdot','\xE7':'ccedil','\xC7':'Ccedil','\u2105':'incare','\uD835\uDD21':'dfr','\u2146':'dd','\uD835\uDD55':'dopf','\uD835\uDCB9':'dscr','\uD835\uDC9F':'Dscr','\uD835\uDD07':'Dfr','\u2145':'DD','\uD835\uDD3B':'Dopf','\u010F':'dcaron','\u010E':'Dcaron','\u0111':'dstrok','\u0110':'Dstrok','\xF0':'eth','\xD0':'ETH','\u2147':'ee','\u212F':'escr','\uD835\uDD22':'efr','\uD835\uDD56':'eopf','\u2130':'Escr','\uD835\uDD08':'Efr','\uD835\uDD3C':'Eopf','\xE9':'eacute','\xC9':'Eacute','\xE8':'egrave','\xC8':'Egrave','\xEA':'ecirc','\xCA':'Ecirc','\u011B':'ecaron','\u011A':'Ecaron','\xEB':'euml','\xCB':'Euml','\u0117':'edot','\u0116':'Edot','\u0119':'eogon','\u0118':'Eogon','\u0113':'emacr','\u0112':'Emacr','\uD835\uDD23':'ffr','\uD835\uDD57':'fopf','\uD835\uDCBB':'fscr','\uD835\uDD09':'Ffr','\uD835\uDD3D':'Fopf','\u2131':'Fscr','\uFB00':'fflig','\uFB03':'ffilig','\uFB04':'ffllig','\uFB01':'filig','fj':'fjlig','\uFB02':'fllig','\u0192':'fnof','\u210A':'gscr','\uD835\uDD58':'gopf','\uD835\uDD24':'gfr','\uD835\uDCA2':'Gscr','\uD835\uDD3E':'Gopf','\uD835\uDD0A':'Gfr','\u01F5':'gacute','\u011F':'gbreve','\u011E':'Gbreve','\u011D':'gcirc','\u011C':'Gcirc','\u0121':'gdot','\u0120':'Gdot','\u0122':'Gcedil','\uD835\uDD25':'hfr','\u210E':'planckh','\uD835\uDCBD':'hscr','\uD835\uDD59':'hopf','\u210B':'Hscr','\u210C':'Hfr','\u210D':'Hopf','\u0125':'hcirc','\u0124':'Hcirc','\u210F':'hbar','\u0127':'hstrok','\u0126':'Hstrok','\uD835\uDD5A':'iopf','\uD835\uDD26':'ifr','\uD835\uDCBE':'iscr','\u2148':'ii','\uD835\uDD40':'Iopf','\u2110':'Iscr','\u2111':'Im','\xED':'iacute','\xCD':'Iacute','\xEC':'igrave','\xCC':'Igrave','\xEE':'icirc','\xCE':'Icirc','\xEF':'iuml','\xCF':'Iuml','\u0129':'itilde','\u0128':'Itilde','\u0130':'Idot','\u012F':'iogon','\u012E':'Iogon','\u012B':'imacr','\u012A':'Imacr','\u0133':'ijlig','\u0132':'IJlig','\u0131':'imath','\uD835\uDCBF':'jscr','\uD835\uDD5B':'jopf','\uD835\uDD27':'jfr','\uD835\uDCA5':'Jscr','\uD835\uDD0D':'Jfr','\uD835\uDD41':'Jopf','\u0135':'jcirc','\u0134':'Jcirc','\u0237':'jmath','\uD835\uDD5C':'kopf','\uD835\uDCC0':'kscr','\uD835\uDD28':'kfr','\uD835\uDCA6':'Kscr','\uD835\uDD42':'Kopf','\uD835\uDD0E':'Kfr','\u0137':'kcedil','\u0136':'Kcedil','\uD835\uDD29':'lfr','\uD835\uDCC1':'lscr','\u2113':'ell','\uD835\uDD5D':'lopf','\u2112':'Lscr','\uD835\uDD0F':'Lfr','\uD835\uDD43':'Lopf','\u013A':'lacute','\u0139':'Lacute','\u013E':'lcaron','\u013D':'Lcaron','\u013C':'lcedil','\u013B':'Lcedil','\u0142':'lstrok','\u0141':'Lstrok','\u0140':'lmidot','\u013F':'Lmidot','\uD835\uDD2A':'mfr','\uD835\uDD5E':'mopf','\uD835\uDCC2':'mscr','\uD835\uDD10':'Mfr','\uD835\uDD44':'Mopf','\u2133':'Mscr','\uD835\uDD2B':'nfr','\uD835\uDD5F':'nopf','\uD835\uDCC3':'nscr','\u2115':'Nopf','\uD835\uDCA9':'Nscr','\uD835\uDD11':'Nfr','\u0144':'nacute','\u0143':'Nacute','\u0148':'ncaron','\u0147':'Ncaron','\xF1':'ntilde','\xD1':'Ntilde','\u0146':'ncedil','\u0145':'Ncedil','\u2116':'numero','\u014B':'eng','\u014A':'ENG','\uD835\uDD60':'oopf','\uD835\uDD2C':'ofr','\u2134':'oscr','\uD835\uDCAA':'Oscr','\uD835\uDD12':'Ofr','\uD835\uDD46':'Oopf','\xBA':'ordm','\xF3':'oacute','\xD3':'Oacute','\xF2':'ograve','\xD2':'Ograve','\xF4':'ocirc','\xD4':'Ocirc','\xF6':'ouml','\xD6':'Ouml','\u0151':'odblac','\u0150':'Odblac','\xF5':'otilde','\xD5':'Otilde','\xF8':'oslash','\xD8':'Oslash','\u014D':'omacr','\u014C':'Omacr','\u0153':'oelig','\u0152':'OElig','\uD835\uDD2D':'pfr','\uD835\uDCC5':'pscr','\uD835\uDD61':'popf','\u2119':'Popf','\uD835\uDD13':'Pfr','\uD835\uDCAB':'Pscr','\uD835\uDD62':'qopf','\uD835\uDD2E':'qfr','\uD835\uDCC6':'qscr','\uD835\uDCAC':'Qscr','\uD835\uDD14':'Qfr','\u211A':'Qopf','\u0138':'kgreen','\uD835\uDD2F':'rfr','\uD835\uDD63':'ropf','\uD835\uDCC7':'rscr','\u211B':'Rscr','\u211C':'Re','\u211D':'Ropf','\u0155':'racute','\u0154':'Racute','\u0159':'rcaron','\u0158':'Rcaron','\u0157':'rcedil','\u0156':'Rcedil','\uD835\uDD64':'sopf','\uD835\uDCC8':'sscr','\uD835\uDD30':'sfr','\uD835\uDD4A':'Sopf','\uD835\uDD16':'Sfr','\uD835\uDCAE':'Sscr','\u24C8':'oS','\u015B':'sacute','\u015A':'Sacute','\u015D':'scirc','\u015C':'Scirc','\u0161':'scaron','\u0160':'Scaron','\u015F':'scedil','\u015E':'Scedil','\xDF':'szlig','\uD835\uDD31':'tfr','\uD835\uDCC9':'tscr','\uD835\uDD65':'topf','\uD835\uDCAF':'Tscr','\uD835\uDD17':'Tfr','\uD835\uDD4B':'Topf','\u0165':'tcaron','\u0164':'Tcaron','\u0163':'tcedil','\u0162':'Tcedil','\u2122':'trade','\u0167':'tstrok','\u0166':'Tstrok','\uD835\uDCCA':'uscr','\uD835\uDD66':'uopf','\uD835\uDD32':'ufr','\uD835\uDD4C':'Uopf','\uD835\uDD18':'Ufr','\uD835\uDCB0':'Uscr','\xFA':'uacute','\xDA':'Uacute','\xF9':'ugrave','\xD9':'Ugrave','\u016D':'ubreve','\u016C':'Ubreve','\xFB':'ucirc','\xDB':'Ucirc','\u016F':'uring','\u016E':'Uring','\xFC':'uuml','\xDC':'Uuml','\u0171':'udblac','\u0170':'Udblac','\u0169':'utilde','\u0168':'Utilde','\u0173':'uogon','\u0172':'Uogon','\u016B':'umacr','\u016A':'Umacr','\uD835\uDD33':'vfr','\uD835\uDD67':'vopf','\uD835\uDCCB':'vscr','\uD835\uDD19':'Vfr','\uD835\uDD4D':'Vopf','\uD835\uDCB1':'Vscr','\uD835\uDD68':'wopf','\uD835\uDCCC':'wscr','\uD835\uDD34':'wfr','\uD835\uDCB2':'Wscr','\uD835\uDD4E':'Wopf','\uD835\uDD1A':'Wfr','\u0175':'wcirc','\u0174':'Wcirc','\uD835\uDD35':'xfr','\uD835\uDCCD':'xscr','\uD835\uDD69':'xopf','\uD835\uDD4F':'Xopf','\uD835\uDD1B':'Xfr','\uD835\uDCB3':'Xscr','\uD835\uDD36':'yfr','\uD835\uDCCE':'yscr','\uD835\uDD6A':'yopf','\uD835\uDCB4':'Yscr','\uD835\uDD1C':'Yfr','\uD835\uDD50':'Yopf','\xFD':'yacute','\xDD':'Yacute','\u0177':'ycirc','\u0176':'Ycirc','\xFF':'yuml','\u0178':'Yuml','\uD835\uDCCF':'zscr','\uD835\uDD37':'zfr','\uD835\uDD6B':'zopf','\u2128':'Zfr','\u2124':'Zopf','\uD835\uDCB5':'Zscr','\u017A':'zacute','\u0179':'Zacute','\u017E':'zcaron','\u017D':'Zcaron','\u017C':'zdot','\u017B':'Zdot','\u01B5':'imped','\xFE':'thorn','\xDE':'THORN','\u0149':'napos','\u03B1':'alpha','\u0391':'Alpha','\u03B2':'beta','\u0392':'Beta','\u03B3':'gamma','\u0393':'Gamma','\u03B4':'delta','\u0394':'Delta','\u03B5':'epsi','\u03F5':'epsiv','\u0395':'Epsilon','\u03DD':'gammad','\u03DC':'Gammad','\u03B6':'zeta','\u0396':'Zeta','\u03B7':'eta','\u0397':'Eta','\u03B8':'theta','\u03D1':'thetav','\u0398':'Theta','\u03B9':'iota','\u0399':'Iota','\u03BA':'kappa','\u03F0':'kappav','\u039A':'Kappa','\u03BB':'lambda','\u039B':'Lambda','\u03BC':'mu','\xB5':'micro','\u039C':'Mu','\u03BD':'nu','\u039D':'Nu','\u03BE':'xi','\u039E':'Xi','\u03BF':'omicron','\u039F':'Omicron','\u03C0':'pi','\u03D6':'piv','\u03A0':'Pi','\u03C1':'rho','\u03F1':'rhov','\u03A1':'Rho','\u03C3':'sigma','\u03A3':'Sigma','\u03C2':'sigmaf','\u03C4':'tau','\u03A4':'Tau','\u03C5':'upsi','\u03A5':'Upsilon','\u03D2':'Upsi','\u03C6':'phi','\u03D5':'phiv','\u03A6':'Phi','\u03C7':'chi','\u03A7':'Chi','\u03C8':'psi','\u03A8':'Psi','\u03C9':'omega','\u03A9':'ohm','\u0430':'acy','\u0410':'Acy','\u0431':'bcy','\u0411':'Bcy','\u0432':'vcy','\u0412':'Vcy','\u0433':'gcy','\u0413':'Gcy','\u0453':'gjcy','\u0403':'GJcy','\u0434':'dcy','\u0414':'Dcy','\u0452':'djcy','\u0402':'DJcy','\u0435':'iecy','\u0415':'IEcy','\u0451':'iocy','\u0401':'IOcy','\u0454':'jukcy','\u0404':'Jukcy','\u0436':'zhcy','\u0416':'ZHcy','\u0437':'zcy','\u0417':'Zcy','\u0455':'dscy','\u0405':'DScy','\u0438':'icy','\u0418':'Icy','\u0456':'iukcy','\u0406':'Iukcy','\u0457':'yicy','\u0407':'YIcy','\u0439':'jcy','\u0419':'Jcy','\u0458':'jsercy','\u0408':'Jsercy','\u043A':'kcy','\u041A':'Kcy','\u045C':'kjcy','\u040C':'KJcy','\u043B':'lcy','\u041B':'Lcy','\u0459':'ljcy','\u0409':'LJcy','\u043C':'mcy','\u041C':'Mcy','\u043D':'ncy','\u041D':'Ncy','\u045A':'njcy','\u040A':'NJcy','\u043E':'ocy','\u041E':'Ocy','\u043F':'pcy','\u041F':'Pcy','\u0440':'rcy','\u0420':'Rcy','\u0441':'scy','\u0421':'Scy','\u0442':'tcy','\u0422':'Tcy','\u045B':'tshcy','\u040B':'TSHcy','\u0443':'ucy','\u0423':'Ucy','\u045E':'ubrcy','\u040E':'Ubrcy','\u0444':'fcy','\u0424':'Fcy','\u0445':'khcy','\u0425':'KHcy','\u0446':'tscy','\u0426':'TScy','\u0447':'chcy','\u0427':'CHcy','\u045F':'dzcy','\u040F':'DZcy','\u0448':'shcy','\u0428':'SHcy','\u0449':'shchcy','\u0429':'SHCHcy','\u044A':'hardcy','\u042A':'HARDcy','\u044B':'ycy','\u042B':'Ycy','\u044C':'softcy','\u042C':'SOFTcy','\u044D':'ecy','\u042D':'Ecy','\u044E':'yucy','\u042E':'YUcy','\u044F':'yacy','\u042F':'YAcy','\u2135':'aleph','\u2136':'beth','\u2137':'gimel','\u2138':'daleth'};

	var regexEscape = /["&'<>`]/g;
	var escapeMap = {
		'"': '&quot;',
		'&': '&amp;',
		'\'': '&#x27;',
		'<': '&lt;',
		// See https://mathiasbynens.be/notes/ambiguous-ampersands: in HTML, the
		// following is not strictly necessary unless it’s part of a tag or an
		// unquoted attribute value. We’re only escaping it to support those
		// situations, and for XML support.
		'>': '&gt;',
		// In Internet Explorer ≤ 8, the backtick character can be used
		// to break out of (un)quoted attribute values or HTML comments.
		// See http://html5sec.org/#102, http://html5sec.org/#108, and
		// http://html5sec.org/#133.
		'`': '&#x60;'
	};

	var regexInvalidEntity = /&#(?:[xX][^a-fA-F0-9]|[^0-9xX])/;
	var regexInvalidRawCodePoint = /[\0-\x08\x0B\x0E-\x1F\x7F-\x9F\uFDD0-\uFDEF\uFFFE\uFFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDFFE\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
	var regexDecode = /&(CounterClockwiseContourIntegral|DoubleLongLeftRightArrow|ClockwiseContourIntegral|NotNestedGreaterGreater|NotSquareSupersetEqual|DiacriticalDoubleAcute|NotRightTriangleEqual|NotSucceedsSlantEqual|NotPrecedesSlantEqual|CloseCurlyDoubleQuote|NegativeVeryThinSpace|DoubleContourIntegral|FilledVerySmallSquare|CapitalDifferentialD|OpenCurlyDoubleQuote|EmptyVerySmallSquare|NestedGreaterGreater|DoubleLongRightArrow|NotLeftTriangleEqual|NotGreaterSlantEqual|ReverseUpEquilibrium|DoubleLeftRightArrow|NotSquareSubsetEqual|NotDoubleVerticalBar|RightArrowLeftArrow|NotGreaterFullEqual|NotRightTriangleBar|SquareSupersetEqual|DownLeftRightVector|DoubleLongLeftArrow|leftrightsquigarrow|LeftArrowRightArrow|NegativeMediumSpace|blacktriangleright|RightDownVectorBar|PrecedesSlantEqual|RightDoubleBracket|SucceedsSlantEqual|NotLeftTriangleBar|RightTriangleEqual|SquareIntersection|RightDownTeeVector|ReverseEquilibrium|NegativeThickSpace|longleftrightarrow|Longleftrightarrow|LongLeftRightArrow|DownRightTeeVector|DownRightVectorBar|GreaterSlantEqual|SquareSubsetEqual|LeftDownVectorBar|LeftDoubleBracket|VerticalSeparator|rightleftharpoons|NotGreaterGreater|NotSquareSuperset|blacktriangleleft|blacktriangledown|NegativeThinSpace|LeftDownTeeVector|NotLessSlantEqual|leftrightharpoons|DoubleUpDownArrow|DoubleVerticalBar|LeftTriangleEqual|FilledSmallSquare|twoheadrightarrow|NotNestedLessLess|DownLeftTeeVector|DownLeftVectorBar|RightAngleBracket|NotTildeFullEqual|NotReverseElement|RightUpDownVector|DiacriticalTilde|NotSucceedsTilde|circlearrowright|NotPrecedesEqual|rightharpoondown|DoubleRightArrow|NotSucceedsEqual|NonBreakingSpace|NotRightTriangle|LessEqualGreater|RightUpTeeVector|LeftAngleBracket|GreaterFullEqual|DownArrowUpArrow|RightUpVectorBar|twoheadleftarrow|GreaterEqualLess|downharpoonright|RightTriangleBar|ntrianglerighteq|NotSupersetEqual|LeftUpDownVector|DiacriticalAcute|rightrightarrows|vartriangleright|UpArrowDownArrow|DiacriticalGrave|UnderParenthesis|EmptySmallSquare|LeftUpVectorBar|leftrightarrows|DownRightVector|downharpoonleft|trianglerighteq|ShortRightArrow|OverParenthesis|DoubleLeftArrow|DoubleDownArrow|NotSquareSubset|bigtriangledown|ntrianglelefteq|UpperRightArrow|curvearrowright|vartriangleleft|NotLeftTriangle|nleftrightarrow|LowerRightArrow|NotHumpDownHump|NotGreaterTilde|rightthreetimes|LeftUpTeeVector|NotGreaterEqual|straightepsilon|LeftTriangleBar|rightsquigarrow|ContourIntegral|rightleftarrows|CloseCurlyQuote|RightDownVector|LeftRightVector|nLeftrightarrow|leftharpoondown|circlearrowleft|SquareSuperset|OpenCurlyQuote|hookrightarrow|HorizontalLine|DiacriticalDot|NotLessGreater|ntriangleright|DoubleRightTee|InvisibleComma|InvisibleTimes|LowerLeftArrow|DownLeftVector|NotSubsetEqual|curvearrowleft|trianglelefteq|NotVerticalBar|TildeFullEqual|downdownarrows|NotGreaterLess|RightTeeVector|ZeroWidthSpace|looparrowright|LongRightArrow|doublebarwedge|ShortLeftArrow|ShortDownArrow|RightVectorBar|GreaterGreater|ReverseElement|rightharpoonup|LessSlantEqual|leftthreetimes|upharpoonright|rightarrowtail|LeftDownVector|Longrightarrow|NestedLessLess|UpperLeftArrow|nshortparallel|leftleftarrows|leftrightarrow|Leftrightarrow|LeftRightArrow|longrightarrow|upharpoonleft|RightArrowBar|ApplyFunction|LeftTeeVector|leftarrowtail|NotEqualTilde|varsubsetneqq|varsupsetneqq|RightTeeArrow|SucceedsEqual|SucceedsTilde|LeftVectorBar|SupersetEqual|hookleftarrow|DifferentialD|VerticalTilde|VeryThinSpace|blacktriangle|bigtriangleup|LessFullEqual|divideontimes|leftharpoonup|UpEquilibrium|ntriangleleft|RightTriangle|measuredangle|shortparallel|longleftarrow|Longleftarrow|LongLeftArrow|DoubleLeftTee|Poincareplane|PrecedesEqual|triangleright|DoubleUpArrow|RightUpVector|fallingdotseq|looparrowleft|PrecedesTilde|NotTildeEqual|NotTildeTilde|smallsetminus|Proportional|triangleleft|triangledown|UnderBracket|NotHumpEqual|exponentiale|ExponentialE|NotLessTilde|HilbertSpace|RightCeiling|blacklozenge|varsupsetneq|HumpDownHump|GreaterEqual|VerticalLine|LeftTeeArrow|NotLessEqual|DownTeeArrow|LeftTriangle|varsubsetneq|Intersection|NotCongruent|DownArrowBar|LeftUpVector|LeftArrowBar|risingdotseq|GreaterTilde|RoundImplies|SquareSubset|ShortUpArrow|NotSuperset|quaternions|precnapprox|backepsilon|preccurlyeq|OverBracket|blacksquare|MediumSpace|VerticalBar|circledcirc|circleddash|CircleMinus|CircleTimes|LessGreater|curlyeqprec|curlyeqsucc|diamondsuit|UpDownArrow|Updownarrow|RuleDelayed|Rrightarrow|updownarrow|RightVector|nRightarrow|nrightarrow|eqslantless|LeftCeiling|Equilibrium|SmallCircle|expectation|NotSucceeds|thickapprox|GreaterLess|SquareUnion|NotPrecedes|NotLessLess|straightphi|succnapprox|succcurlyeq|SubsetEqual|sqsupseteq|Proportion|Laplacetrf|ImaginaryI|supsetneqq|NotGreater|gtreqqless|NotElement|ThickSpace|TildeEqual|TildeTilde|Fouriertrf|rmoustache|EqualTilde|eqslantgtr|UnderBrace|LeftVector|UpArrowBar|nLeftarrow|nsubseteqq|subsetneqq|nsupseteqq|nleftarrow|succapprox|lessapprox|UpTeeArrow|upuparrows|curlywedge|lesseqqgtr|varepsilon|varnothing|RightFloor|complement|CirclePlus|sqsubseteq|Lleftarrow|circledast|RightArrow|Rightarrow|rightarrow|lmoustache|Bernoullis|precapprox|mapstoleft|mapstodown|longmapsto|dotsquare|downarrow|DoubleDot|nsubseteq|supsetneq|leftarrow|nsupseteq|subsetneq|ThinSpace|ngeqslant|subseteqq|HumpEqual|NotSubset|triangleq|NotCupCap|lesseqgtr|heartsuit|TripleDot|Leftarrow|Coproduct|Congruent|varpropto|complexes|gvertneqq|LeftArrow|LessTilde|supseteqq|MinusPlus|CircleDot|nleqslant|NotExists|gtreqless|nparallel|UnionPlus|LeftFloor|checkmark|CenterDot|centerdot|Mellintrf|gtrapprox|bigotimes|OverBrace|spadesuit|therefore|pitchfork|rationals|PlusMinus|Backslash|Therefore|DownBreve|backsimeq|backprime|DownArrow|nshortmid|Downarrow|lvertneqq|eqvparsl|imagline|imagpart|infintie|integers|Integral|intercal|LessLess|Uarrocir|intlarhk|sqsupset|angmsdaf|sqsubset|llcorner|vartheta|cupbrcap|lnapprox|Superset|SuchThat|succnsim|succneqq|angmsdag|biguplus|curlyvee|trpezium|Succeeds|NotTilde|bigwedge|angmsdah|angrtvbd|triminus|cwconint|fpartint|lrcorner|smeparsl|subseteq|urcorner|lurdshar|laemptyv|DDotrahd|approxeq|ldrushar|awconint|mapstoup|backcong|shortmid|triangle|geqslant|gesdotol|timesbar|circledR|circledS|setminus|multimap|naturals|scpolint|ncongdot|RightTee|boxminus|gnapprox|boxtimes|andslope|thicksim|angmsdaa|varsigma|cirfnint|rtriltri|angmsdab|rppolint|angmsdac|barwedge|drbkarow|clubsuit|thetasym|bsolhsub|capbrcup|dzigrarr|doteqdot|DotEqual|dotminus|UnderBar|NotEqual|realpart|otimesas|ulcorner|hksearow|hkswarow|parallel|PartialD|elinters|emptyset|plusacir|bbrktbrk|angmsdad|pointint|bigoplus|angmsdae|Precedes|bigsqcup|varkappa|notindot|supseteq|precneqq|precnsim|profalar|profline|profsurf|leqslant|lesdotor|raemptyv|subplus|notnivb|notnivc|subrarr|zigrarr|vzigzag|submult|subedot|Element|between|cirscir|larrbfs|larrsim|lotimes|lbrksld|lbrkslu|lozenge|ldrdhar|dbkarow|bigcirc|epsilon|simrarr|simplus|ltquest|Epsilon|luruhar|gtquest|maltese|npolint|eqcolon|npreceq|bigodot|ddagger|gtrless|bnequiv|harrcir|ddotseq|equivDD|backsim|demptyv|nsqsube|nsqsupe|Upsilon|nsubset|upsilon|minusdu|nsucceq|swarrow|nsupset|coloneq|searrow|boxplus|napprox|natural|asympeq|alefsym|congdot|nearrow|bigstar|diamond|supplus|tritime|LeftTee|nvinfin|triplus|NewLine|nvltrie|nvrtrie|nwarrow|nexists|Diamond|ruluhar|Implies|supmult|angzarr|suplarr|suphsub|questeq|because|digamma|Because|olcross|bemptyv|omicron|Omicron|rotimes|NoBreak|intprod|angrtvb|orderof|uwangle|suphsol|lesdoto|orslope|DownTee|realine|cudarrl|rdldhar|OverBar|supedot|lessdot|supdsub|topfork|succsim|rbrkslu|rbrksld|pertenk|cudarrr|isindot|planckh|lessgtr|pluscir|gesdoto|plussim|plustwo|lesssim|cularrp|rarrsim|Cayleys|notinva|notinvb|notinvc|UpArrow|Uparrow|uparrow|NotLess|dwangle|precsim|Product|curarrm|Cconint|dotplus|rarrbfs|ccupssm|Cedilla|cemptyv|notniva|quatint|frac35|frac38|frac45|frac56|frac58|frac78|tridot|xoplus|gacute|gammad|Gammad|lfisht|lfloor|bigcup|sqsupe|gbreve|Gbreve|lharul|sqsube|sqcups|Gcedil|apacir|llhard|lmidot|Lmidot|lmoust|andand|sqcaps|approx|Abreve|spades|circeq|tprime|divide|topcir|Assign|topbot|gesdot|divonx|xuplus|timesd|gesles|atilde|solbar|SOFTcy|loplus|timesb|lowast|lowbar|dlcorn|dlcrop|softcy|dollar|lparlt|thksim|lrhard|Atilde|lsaquo|smashp|bigvee|thinsp|wreath|bkarow|lsquor|lstrok|Lstrok|lthree|ltimes|ltlarr|DotDot|simdot|ltrPar|weierp|xsqcup|angmsd|sigmav|sigmaf|zeetrf|Zcaron|zcaron|mapsto|vsupne|thetav|cirmid|marker|mcomma|Zacute|vsubnE|there4|gtlPar|vsubne|bottom|gtrarr|SHCHcy|shchcy|midast|midcir|middot|minusb|minusd|gtrdot|bowtie|sfrown|mnplus|models|colone|seswar|Colone|mstpos|searhk|gtrsim|nacute|Nacute|boxbox|telrec|hairsp|Tcedil|nbumpe|scnsim|ncaron|Ncaron|ncedil|Ncedil|hamilt|Scedil|nearhk|hardcy|HARDcy|tcedil|Tcaron|commat|nequiv|nesear|tcaron|target|hearts|nexist|varrho|scedil|Scaron|scaron|hellip|Sacute|sacute|hercon|swnwar|compfn|rtimes|rthree|rsquor|rsaquo|zacute|wedgeq|homtht|barvee|barwed|Barwed|rpargt|horbar|conint|swarhk|roplus|nltrie|hslash|hstrok|Hstrok|rmoust|Conint|bprime|hybull|hyphen|iacute|Iacute|supsup|supsub|supsim|varphi|coprod|brvbar|agrave|Supset|supset|igrave|Igrave|notinE|Agrave|iiiint|iinfin|copysr|wedbar|Verbar|vangrt|becaus|incare|verbar|inodot|bullet|drcorn|intcal|drcrop|cularr|vellip|Utilde|bumpeq|cupcap|dstrok|Dstrok|CupCap|cupcup|cupdot|eacute|Eacute|supdot|iquest|easter|ecaron|Ecaron|ecolon|isinsv|utilde|itilde|Itilde|curarr|succeq|Bumpeq|cacute|ulcrop|nparsl|Cacute|nprcue|egrave|Egrave|nrarrc|nrarrw|subsup|subsub|nrtrie|jsercy|nsccue|Jsercy|kappav|kcedil|Kcedil|subsim|ulcorn|nsimeq|egsdot|veebar|kgreen|capand|elsdot|Subset|subset|curren|aacute|lacute|Lacute|emptyv|ntilde|Ntilde|lagran|lambda|Lambda|capcap|Ugrave|langle|subdot|emsp13|numero|emsp14|nvdash|nvDash|nVdash|nVDash|ugrave|ufisht|nvHarr|larrfs|nvlArr|larrhk|larrlp|larrpl|nvrArr|Udblac|nwarhk|larrtl|nwnear|oacute|Oacute|latail|lAtail|sstarf|lbrace|odblac|Odblac|lbrack|udblac|odsold|eparsl|lcaron|Lcaron|ograve|Ograve|lcedil|Lcedil|Aacute|ssmile|ssetmn|squarf|ldquor|capcup|ominus|cylcty|rharul|eqcirc|dagger|rfloor|rfisht|Dagger|daleth|equals|origof|capdot|equest|dcaron|Dcaron|rdquor|oslash|Oslash|otilde|Otilde|otimes|Otimes|urcrop|Ubreve|ubreve|Yacute|Uacute|uacute|Rcedil|rcedil|urcorn|parsim|Rcaron|Vdashl|rcaron|Tstrok|percnt|period|permil|Exists|yacute|rbrack|rbrace|phmmat|ccaron|Ccaron|planck|ccedil|plankv|tstrok|female|plusdo|plusdu|ffilig|plusmn|ffllig|Ccedil|rAtail|dfisht|bernou|ratail|Rarrtl|rarrtl|angsph|rarrpl|rarrlp|rarrhk|xwedge|xotime|forall|ForAll|Vvdash|vsupnE|preceq|bigcap|frac12|frac13|frac14|primes|rarrfs|prnsim|frac15|Square|frac16|square|lesdot|frac18|frac23|propto|prurel|rarrap|rangle|puncsp|frac25|Racute|qprime|racute|lesges|frac34|abreve|AElig|eqsim|utdot|setmn|urtri|Equal|Uring|seArr|uring|searr|dashv|Dashv|mumap|nabla|iogon|Iogon|sdote|sdotb|scsim|napid|napos|equiv|natur|Acirc|dblac|erarr|nbump|iprod|erDot|ucirc|awint|esdot|angrt|ncong|isinE|scnap|Scirc|scirc|ndash|isins|Ubrcy|nearr|neArr|isinv|nedot|ubrcy|acute|Ycirc|iukcy|Iukcy|xutri|nesim|caret|jcirc|Jcirc|caron|twixt|ddarr|sccue|exist|jmath|sbquo|ngeqq|angst|ccaps|lceil|ngsim|UpTee|delta|Delta|rtrif|nharr|nhArr|nhpar|rtrie|jukcy|Jukcy|kappa|rsquo|Kappa|nlarr|nlArr|TSHcy|rrarr|aogon|Aogon|fflig|xrarr|tshcy|ccirc|nleqq|filig|upsih|nless|dharl|nlsim|fjlig|ropar|nltri|dharr|robrk|roarr|fllig|fltns|roang|rnmid|subnE|subne|lAarr|trisb|Ccirc|acirc|ccups|blank|VDash|forkv|Vdash|langd|cedil|blk12|blk14|laquo|strns|diams|notin|vDash|larrb|blk34|block|disin|uplus|vdash|vBarv|aelig|starf|Wedge|check|xrArr|lates|lbarr|lBarr|notni|lbbrk|bcong|frasl|lbrke|frown|vrtri|vprop|vnsup|gamma|Gamma|wedge|xodot|bdquo|srarr|doteq|ldquo|boxdl|boxdL|gcirc|Gcirc|boxDl|boxDL|boxdr|boxdR|boxDr|TRADE|trade|rlhar|boxDR|vnsub|npart|vltri|rlarr|boxhd|boxhD|nprec|gescc|nrarr|nrArr|boxHd|boxHD|boxhu|boxhU|nrtri|boxHu|clubs|boxHU|times|colon|Colon|gimel|xlArr|Tilde|nsime|tilde|nsmid|nspar|THORN|thorn|xlarr|nsube|nsubE|thkap|xhArr|comma|nsucc|boxul|boxuL|nsupe|nsupE|gneqq|gnsim|boxUl|boxUL|grave|boxur|boxuR|boxUr|boxUR|lescc|angle|bepsi|boxvh|varpi|boxvH|numsp|Theta|gsime|gsiml|theta|boxVh|boxVH|boxvl|gtcir|gtdot|boxvL|boxVl|boxVL|crarr|cross|Cross|nvsim|boxvr|nwarr|nwArr|sqsup|dtdot|Uogon|lhard|lharu|dtrif|ocirc|Ocirc|lhblk|duarr|odash|sqsub|Hacek|sqcup|llarr|duhar|oelig|OElig|ofcir|boxvR|uogon|lltri|boxVr|csube|uuarr|ohbar|csupe|ctdot|olarr|olcir|harrw|oline|sqcap|omacr|Omacr|omega|Omega|boxVR|aleph|lneqq|lnsim|loang|loarr|rharu|lobrk|hcirc|operp|oplus|rhard|Hcirc|orarr|Union|order|ecirc|Ecirc|cuepr|szlig|cuesc|breve|reals|eDDot|Breve|hoarr|lopar|utrif|rdquo|Umacr|umacr|efDot|swArr|ultri|alpha|rceil|ovbar|swarr|Wcirc|wcirc|smtes|smile|bsemi|lrarr|aring|parsl|lrhar|bsime|uhblk|lrtri|cupor|Aring|uharr|uharl|slarr|rbrke|bsolb|lsime|rbbrk|RBarr|lsimg|phone|rBarr|rbarr|icirc|lsquo|Icirc|emacr|Emacr|ratio|simne|plusb|simlE|simgE|simeq|pluse|ltcir|ltdot|empty|xharr|xdtri|iexcl|Alpha|ltrie|rarrw|pound|ltrif|xcirc|bumpe|prcue|bumpE|asymp|amacr|cuvee|Sigma|sigma|iiint|udhar|iiota|ijlig|IJlig|supnE|imacr|Imacr|prime|Prime|image|prnap|eogon|Eogon|rarrc|mdash|mDDot|cuwed|imath|supne|imped|Amacr|udarr|prsim|micro|rarrb|cwint|raquo|infin|eplus|range|rangd|Ucirc|radic|minus|amalg|veeeq|rAarr|epsiv|ycirc|quest|sharp|quot|zwnj|Qscr|race|qscr|Qopf|qopf|qint|rang|Rang|Zscr|zscr|Zopf|zopf|rarr|rArr|Rarr|Pscr|pscr|prop|prod|prnE|prec|ZHcy|zhcy|prap|Zeta|zeta|Popf|popf|Zdot|plus|zdot|Yuml|yuml|phiv|YUcy|yucy|Yscr|yscr|perp|Yopf|yopf|part|para|YIcy|Ouml|rcub|yicy|YAcy|rdca|ouml|osol|Oscr|rdsh|yacy|real|oscr|xvee|andd|rect|andv|Xscr|oror|ordm|ordf|xscr|ange|aopf|Aopf|rHar|Xopf|opar|Oopf|xopf|xnis|rhov|oopf|omid|xmap|oint|apid|apos|ogon|ascr|Ascr|odot|odiv|xcup|xcap|ocir|oast|nvlt|nvle|nvgt|nvge|nvap|Wscr|wscr|auml|ntlg|ntgl|nsup|nsub|nsim|Nscr|nscr|nsce|Wopf|ring|npre|wopf|npar|Auml|Barv|bbrk|Nopf|nopf|nmid|nLtv|beta|ropf|Ropf|Beta|beth|nles|rpar|nleq|bnot|bNot|nldr|NJcy|rscr|Rscr|Vscr|vscr|rsqb|njcy|bopf|nisd|Bopf|rtri|Vopf|nGtv|ngtr|vopf|boxh|boxH|boxv|nges|ngeq|boxV|bscr|scap|Bscr|bsim|Vert|vert|bsol|bull|bump|caps|cdot|ncup|scnE|ncap|nbsp|napE|Cdot|cent|sdot|Vbar|nang|vBar|chcy|Mscr|mscr|sect|semi|CHcy|Mopf|mopf|sext|circ|cire|mldr|mlcp|cirE|comp|shcy|SHcy|vArr|varr|cong|copf|Copf|copy|COPY|malt|male|macr|lvnE|cscr|ltri|sime|ltcc|simg|Cscr|siml|csub|Uuml|lsqb|lsim|uuml|csup|Lscr|lscr|utri|smid|lpar|cups|smte|lozf|darr|Lopf|Uscr|solb|lopf|sopf|Sopf|lneq|uscr|spar|dArr|lnap|Darr|dash|Sqrt|LJcy|ljcy|lHar|dHar|Upsi|upsi|diam|lesg|djcy|DJcy|leqq|dopf|Dopf|dscr|Dscr|dscy|ldsh|ldca|squf|DScy|sscr|Sscr|dsol|lcub|late|star|Star|Uopf|Larr|lArr|larr|uopf|dtri|dzcy|sube|subE|Lang|lang|Kscr|kscr|Kopf|kopf|KJcy|kjcy|KHcy|khcy|DZcy|ecir|edot|eDot|Jscr|jscr|succ|Jopf|jopf|Edot|uHar|emsp|ensp|Iuml|iuml|eopf|isin|Iscr|iscr|Eopf|epar|sung|epsi|escr|sup1|sup2|sup3|Iota|iota|supe|supE|Iopf|iopf|IOcy|iocy|Escr|esim|Esim|imof|Uarr|QUOT|uArr|uarr|euml|IEcy|iecy|Idot|Euml|euro|excl|Hscr|hscr|Hopf|hopf|TScy|tscy|Tscr|hbar|tscr|flat|tbrk|fnof|hArr|harr|half|fopf|Fopf|tdot|gvnE|fork|trie|gtcc|fscr|Fscr|gdot|gsim|Gscr|gscr|Gopf|gopf|gneq|Gdot|tosa|gnap|Topf|topf|geqq|toea|GJcy|gjcy|tint|gesl|mid|Sfr|ggg|top|ges|gla|glE|glj|geq|gne|gEl|gel|gnE|Gcy|gcy|gap|Tfr|tfr|Tcy|tcy|Hat|Tau|Ffr|tau|Tab|hfr|Hfr|ffr|Fcy|fcy|icy|Icy|iff|ETH|eth|ifr|Ifr|Eta|eta|int|Int|Sup|sup|ucy|Ucy|Sum|sum|jcy|ENG|ufr|Ufr|eng|Jcy|jfr|els|ell|egs|Efr|efr|Jfr|uml|kcy|Kcy|Ecy|ecy|kfr|Kfr|lap|Sub|sub|lat|lcy|Lcy|leg|Dot|dot|lEg|leq|les|squ|div|die|lfr|Lfr|lgE|Dfr|dfr|Del|deg|Dcy|dcy|lne|lnE|sol|loz|smt|Cup|lrm|cup|lsh|Lsh|sim|shy|map|Map|mcy|Mcy|mfr|Mfr|mho|gfr|Gfr|sfr|cir|Chi|chi|nap|Cfr|vcy|Vcy|cfr|Scy|scy|ncy|Ncy|vee|Vee|Cap|cap|nfr|scE|sce|Nfr|nge|ngE|nGg|vfr|Vfr|ngt|bot|nGt|nis|niv|Rsh|rsh|nle|nlE|bne|Bfr|bfr|nLl|nlt|nLt|Bcy|bcy|not|Not|rlm|wfr|Wfr|npr|nsc|num|ocy|ast|Ocy|ofr|xfr|Xfr|Ofr|ogt|ohm|apE|olt|Rho|ape|rho|Rfr|rfr|ord|REG|ang|reg|orv|And|and|AMP|Rcy|amp|Afr|ycy|Ycy|yen|yfr|Yfr|rcy|par|pcy|Pcy|pfr|Pfr|phi|Phi|afr|Acy|acy|zcy|Zcy|piv|acE|acd|zfr|Zfr|pre|prE|psi|Psi|qfr|Qfr|zwj|Or|ge|Gg|gt|gg|el|oS|lt|Lt|LT|Re|lg|gl|eg|ne|Im|it|le|DD|wp|wr|nu|Nu|dd|lE|Sc|sc|pi|Pi|ee|af|ll|Ll|rx|gE|xi|pm|Xi|ic|pr|Pr|in|ni|mp|mu|ac|Mu|or|ap|Gt|GT|ii);|&(Aacute|Agrave|Atilde|Ccedil|Eacute|Egrave|Iacute|Igrave|Ntilde|Oacute|Ograve|Oslash|Otilde|Uacute|Ugrave|Yacute|aacute|agrave|atilde|brvbar|ccedil|curren|divide|eacute|egrave|frac12|frac14|frac34|iacute|igrave|iquest|middot|ntilde|oacute|ograve|oslash|otilde|plusmn|uacute|ugrave|yacute|AElig|Acirc|Aring|Ecirc|Icirc|Ocirc|THORN|Ucirc|acirc|acute|aelig|aring|cedil|ecirc|icirc|iexcl|laquo|micro|ocirc|pound|raquo|szlig|thorn|times|ucirc|Auml|COPY|Euml|Iuml|Ouml|QUOT|Uuml|auml|cent|copy|euml|iuml|macr|nbsp|ordf|ordm|ouml|para|quot|sect|sup1|sup2|sup3|uuml|yuml|AMP|ETH|REG|amp|deg|eth|not|reg|shy|uml|yen|GT|LT|gt|lt)(?!;)([=a-zA-Z0-9]?)|&#([0-9]+)(;?)|&#[xX]([a-fA-F0-9]+)(;?)|&([0-9a-zA-Z]+)/g;
	var decodeMap = {'aacute':'\xE1','Aacute':'\xC1','abreve':'\u0103','Abreve':'\u0102','ac':'\u223E','acd':'\u223F','acE':'\u223E\u0333','acirc':'\xE2','Acirc':'\xC2','acute':'\xB4','acy':'\u0430','Acy':'\u0410','aelig':'\xE6','AElig':'\xC6','af':'\u2061','afr':'\uD835\uDD1E','Afr':'\uD835\uDD04','agrave':'\xE0','Agrave':'\xC0','alefsym':'\u2135','aleph':'\u2135','alpha':'\u03B1','Alpha':'\u0391','amacr':'\u0101','Amacr':'\u0100','amalg':'\u2A3F','amp':'&','AMP':'&','and':'\u2227','And':'\u2A53','andand':'\u2A55','andd':'\u2A5C','andslope':'\u2A58','andv':'\u2A5A','ang':'\u2220','ange':'\u29A4','angle':'\u2220','angmsd':'\u2221','angmsdaa':'\u29A8','angmsdab':'\u29A9','angmsdac':'\u29AA','angmsdad':'\u29AB','angmsdae':'\u29AC','angmsdaf':'\u29AD','angmsdag':'\u29AE','angmsdah':'\u29AF','angrt':'\u221F','angrtvb':'\u22BE','angrtvbd':'\u299D','angsph':'\u2222','angst':'\xC5','angzarr':'\u237C','aogon':'\u0105','Aogon':'\u0104','aopf':'\uD835\uDD52','Aopf':'\uD835\uDD38','ap':'\u2248','apacir':'\u2A6F','ape':'\u224A','apE':'\u2A70','apid':'\u224B','apos':'\'','ApplyFunction':'\u2061','approx':'\u2248','approxeq':'\u224A','aring':'\xE5','Aring':'\xC5','ascr':'\uD835\uDCB6','Ascr':'\uD835\uDC9C','Assign':'\u2254','ast':'*','asymp':'\u2248','asympeq':'\u224D','atilde':'\xE3','Atilde':'\xC3','auml':'\xE4','Auml':'\xC4','awconint':'\u2233','awint':'\u2A11','backcong':'\u224C','backepsilon':'\u03F6','backprime':'\u2035','backsim':'\u223D','backsimeq':'\u22CD','Backslash':'\u2216','Barv':'\u2AE7','barvee':'\u22BD','barwed':'\u2305','Barwed':'\u2306','barwedge':'\u2305','bbrk':'\u23B5','bbrktbrk':'\u23B6','bcong':'\u224C','bcy':'\u0431','Bcy':'\u0411','bdquo':'\u201E','becaus':'\u2235','because':'\u2235','Because':'\u2235','bemptyv':'\u29B0','bepsi':'\u03F6','bernou':'\u212C','Bernoullis':'\u212C','beta':'\u03B2','Beta':'\u0392','beth':'\u2136','between':'\u226C','bfr':'\uD835\uDD1F','Bfr':'\uD835\uDD05','bigcap':'\u22C2','bigcirc':'\u25EF','bigcup':'\u22C3','bigodot':'\u2A00','bigoplus':'\u2A01','bigotimes':'\u2A02','bigsqcup':'\u2A06','bigstar':'\u2605','bigtriangledown':'\u25BD','bigtriangleup':'\u25B3','biguplus':'\u2A04','bigvee':'\u22C1','bigwedge':'\u22C0','bkarow':'\u290D','blacklozenge':'\u29EB','blacksquare':'\u25AA','blacktriangle':'\u25B4','blacktriangledown':'\u25BE','blacktriangleleft':'\u25C2','blacktriangleright':'\u25B8','blank':'\u2423','blk12':'\u2592','blk14':'\u2591','blk34':'\u2593','block':'\u2588','bne':'=\u20E5','bnequiv':'\u2261\u20E5','bnot':'\u2310','bNot':'\u2AED','bopf':'\uD835\uDD53','Bopf':'\uD835\uDD39','bot':'\u22A5','bottom':'\u22A5','bowtie':'\u22C8','boxbox':'\u29C9','boxdl':'\u2510','boxdL':'\u2555','boxDl':'\u2556','boxDL':'\u2557','boxdr':'\u250C','boxdR':'\u2552','boxDr':'\u2553','boxDR':'\u2554','boxh':'\u2500','boxH':'\u2550','boxhd':'\u252C','boxhD':'\u2565','boxHd':'\u2564','boxHD':'\u2566','boxhu':'\u2534','boxhU':'\u2568','boxHu':'\u2567','boxHU':'\u2569','boxminus':'\u229F','boxplus':'\u229E','boxtimes':'\u22A0','boxul':'\u2518','boxuL':'\u255B','boxUl':'\u255C','boxUL':'\u255D','boxur':'\u2514','boxuR':'\u2558','boxUr':'\u2559','boxUR':'\u255A','boxv':'\u2502','boxV':'\u2551','boxvh':'\u253C','boxvH':'\u256A','boxVh':'\u256B','boxVH':'\u256C','boxvl':'\u2524','boxvL':'\u2561','boxVl':'\u2562','boxVL':'\u2563','boxvr':'\u251C','boxvR':'\u255E','boxVr':'\u255F','boxVR':'\u2560','bprime':'\u2035','breve':'\u02D8','Breve':'\u02D8','brvbar':'\xA6','bscr':'\uD835\uDCB7','Bscr':'\u212C','bsemi':'\u204F','bsim':'\u223D','bsime':'\u22CD','bsol':'\\','bsolb':'\u29C5','bsolhsub':'\u27C8','bull':'\u2022','bullet':'\u2022','bump':'\u224E','bumpe':'\u224F','bumpE':'\u2AAE','bumpeq':'\u224F','Bumpeq':'\u224E','cacute':'\u0107','Cacute':'\u0106','cap':'\u2229','Cap':'\u22D2','capand':'\u2A44','capbrcup':'\u2A49','capcap':'\u2A4B','capcup':'\u2A47','capdot':'\u2A40','CapitalDifferentialD':'\u2145','caps':'\u2229\uFE00','caret':'\u2041','caron':'\u02C7','Cayleys':'\u212D','ccaps':'\u2A4D','ccaron':'\u010D','Ccaron':'\u010C','ccedil':'\xE7','Ccedil':'\xC7','ccirc':'\u0109','Ccirc':'\u0108','Cconint':'\u2230','ccups':'\u2A4C','ccupssm':'\u2A50','cdot':'\u010B','Cdot':'\u010A','cedil':'\xB8','Cedilla':'\xB8','cemptyv':'\u29B2','cent':'\xA2','centerdot':'\xB7','CenterDot':'\xB7','cfr':'\uD835\uDD20','Cfr':'\u212D','chcy':'\u0447','CHcy':'\u0427','check':'\u2713','checkmark':'\u2713','chi':'\u03C7','Chi':'\u03A7','cir':'\u25CB','circ':'\u02C6','circeq':'\u2257','circlearrowleft':'\u21BA','circlearrowright':'\u21BB','circledast':'\u229B','circledcirc':'\u229A','circleddash':'\u229D','CircleDot':'\u2299','circledR':'\xAE','circledS':'\u24C8','CircleMinus':'\u2296','CirclePlus':'\u2295','CircleTimes':'\u2297','cire':'\u2257','cirE':'\u29C3','cirfnint':'\u2A10','cirmid':'\u2AEF','cirscir':'\u29C2','ClockwiseContourIntegral':'\u2232','CloseCurlyDoubleQuote':'\u201D','CloseCurlyQuote':'\u2019','clubs':'\u2663','clubsuit':'\u2663','colon':':','Colon':'\u2237','colone':'\u2254','Colone':'\u2A74','coloneq':'\u2254','comma':',','commat':'@','comp':'\u2201','compfn':'\u2218','complement':'\u2201','complexes':'\u2102','cong':'\u2245','congdot':'\u2A6D','Congruent':'\u2261','conint':'\u222E','Conint':'\u222F','ContourIntegral':'\u222E','copf':'\uD835\uDD54','Copf':'\u2102','coprod':'\u2210','Coproduct':'\u2210','copy':'\xA9','COPY':'\xA9','copysr':'\u2117','CounterClockwiseContourIntegral':'\u2233','crarr':'\u21B5','cross':'\u2717','Cross':'\u2A2F','cscr':'\uD835\uDCB8','Cscr':'\uD835\uDC9E','csub':'\u2ACF','csube':'\u2AD1','csup':'\u2AD0','csupe':'\u2AD2','ctdot':'\u22EF','cudarrl':'\u2938','cudarrr':'\u2935','cuepr':'\u22DE','cuesc':'\u22DF','cularr':'\u21B6','cularrp':'\u293D','cup':'\u222A','Cup':'\u22D3','cupbrcap':'\u2A48','cupcap':'\u2A46','CupCap':'\u224D','cupcup':'\u2A4A','cupdot':'\u228D','cupor':'\u2A45','cups':'\u222A\uFE00','curarr':'\u21B7','curarrm':'\u293C','curlyeqprec':'\u22DE','curlyeqsucc':'\u22DF','curlyvee':'\u22CE','curlywedge':'\u22CF','curren':'\xA4','curvearrowleft':'\u21B6','curvearrowright':'\u21B7','cuvee':'\u22CE','cuwed':'\u22CF','cwconint':'\u2232','cwint':'\u2231','cylcty':'\u232D','dagger':'\u2020','Dagger':'\u2021','daleth':'\u2138','darr':'\u2193','dArr':'\u21D3','Darr':'\u21A1','dash':'\u2010','dashv':'\u22A3','Dashv':'\u2AE4','dbkarow':'\u290F','dblac':'\u02DD','dcaron':'\u010F','Dcaron':'\u010E','dcy':'\u0434','Dcy':'\u0414','dd':'\u2146','DD':'\u2145','ddagger':'\u2021','ddarr':'\u21CA','DDotrahd':'\u2911','ddotseq':'\u2A77','deg':'\xB0','Del':'\u2207','delta':'\u03B4','Delta':'\u0394','demptyv':'\u29B1','dfisht':'\u297F','dfr':'\uD835\uDD21','Dfr':'\uD835\uDD07','dHar':'\u2965','dharl':'\u21C3','dharr':'\u21C2','DiacriticalAcute':'\xB4','DiacriticalDot':'\u02D9','DiacriticalDoubleAcute':'\u02DD','DiacriticalGrave':'`','DiacriticalTilde':'\u02DC','diam':'\u22C4','diamond':'\u22C4','Diamond':'\u22C4','diamondsuit':'\u2666','diams':'\u2666','die':'\xA8','DifferentialD':'\u2146','digamma':'\u03DD','disin':'\u22F2','div':'\xF7','divide':'\xF7','divideontimes':'\u22C7','divonx':'\u22C7','djcy':'\u0452','DJcy':'\u0402','dlcorn':'\u231E','dlcrop':'\u230D','dollar':'$','dopf':'\uD835\uDD55','Dopf':'\uD835\uDD3B','dot':'\u02D9','Dot':'\xA8','DotDot':'\u20DC','doteq':'\u2250','doteqdot':'\u2251','DotEqual':'\u2250','dotminus':'\u2238','dotplus':'\u2214','dotsquare':'\u22A1','doublebarwedge':'\u2306','DoubleContourIntegral':'\u222F','DoubleDot':'\xA8','DoubleDownArrow':'\u21D3','DoubleLeftArrow':'\u21D0','DoubleLeftRightArrow':'\u21D4','DoubleLeftTee':'\u2AE4','DoubleLongLeftArrow':'\u27F8','DoubleLongLeftRightArrow':'\u27FA','DoubleLongRightArrow':'\u27F9','DoubleRightArrow':'\u21D2','DoubleRightTee':'\u22A8','DoubleUpArrow':'\u21D1','DoubleUpDownArrow':'\u21D5','DoubleVerticalBar':'\u2225','downarrow':'\u2193','Downarrow':'\u21D3','DownArrow':'\u2193','DownArrowBar':'\u2913','DownArrowUpArrow':'\u21F5','DownBreve':'\u0311','downdownarrows':'\u21CA','downharpoonleft':'\u21C3','downharpoonright':'\u21C2','DownLeftRightVector':'\u2950','DownLeftTeeVector':'\u295E','DownLeftVector':'\u21BD','DownLeftVectorBar':'\u2956','DownRightTeeVector':'\u295F','DownRightVector':'\u21C1','DownRightVectorBar':'\u2957','DownTee':'\u22A4','DownTeeArrow':'\u21A7','drbkarow':'\u2910','drcorn':'\u231F','drcrop':'\u230C','dscr':'\uD835\uDCB9','Dscr':'\uD835\uDC9F','dscy':'\u0455','DScy':'\u0405','dsol':'\u29F6','dstrok':'\u0111','Dstrok':'\u0110','dtdot':'\u22F1','dtri':'\u25BF','dtrif':'\u25BE','duarr':'\u21F5','duhar':'\u296F','dwangle':'\u29A6','dzcy':'\u045F','DZcy':'\u040F','dzigrarr':'\u27FF','eacute':'\xE9','Eacute':'\xC9','easter':'\u2A6E','ecaron':'\u011B','Ecaron':'\u011A','ecir':'\u2256','ecirc':'\xEA','Ecirc':'\xCA','ecolon':'\u2255','ecy':'\u044D','Ecy':'\u042D','eDDot':'\u2A77','edot':'\u0117','eDot':'\u2251','Edot':'\u0116','ee':'\u2147','efDot':'\u2252','efr':'\uD835\uDD22','Efr':'\uD835\uDD08','eg':'\u2A9A','egrave':'\xE8','Egrave':'\xC8','egs':'\u2A96','egsdot':'\u2A98','el':'\u2A99','Element':'\u2208','elinters':'\u23E7','ell':'\u2113','els':'\u2A95','elsdot':'\u2A97','emacr':'\u0113','Emacr':'\u0112','empty':'\u2205','emptyset':'\u2205','EmptySmallSquare':'\u25FB','emptyv':'\u2205','EmptyVerySmallSquare':'\u25AB','emsp':'\u2003','emsp13':'\u2004','emsp14':'\u2005','eng':'\u014B','ENG':'\u014A','ensp':'\u2002','eogon':'\u0119','Eogon':'\u0118','eopf':'\uD835\uDD56','Eopf':'\uD835\uDD3C','epar':'\u22D5','eparsl':'\u29E3','eplus':'\u2A71','epsi':'\u03B5','epsilon':'\u03B5','Epsilon':'\u0395','epsiv':'\u03F5','eqcirc':'\u2256','eqcolon':'\u2255','eqsim':'\u2242','eqslantgtr':'\u2A96','eqslantless':'\u2A95','Equal':'\u2A75','equals':'=','EqualTilde':'\u2242','equest':'\u225F','Equilibrium':'\u21CC','equiv':'\u2261','equivDD':'\u2A78','eqvparsl':'\u29E5','erarr':'\u2971','erDot':'\u2253','escr':'\u212F','Escr':'\u2130','esdot':'\u2250','esim':'\u2242','Esim':'\u2A73','eta':'\u03B7','Eta':'\u0397','eth':'\xF0','ETH':'\xD0','euml':'\xEB','Euml':'\xCB','euro':'\u20AC','excl':'!','exist':'\u2203','Exists':'\u2203','expectation':'\u2130','exponentiale':'\u2147','ExponentialE':'\u2147','fallingdotseq':'\u2252','fcy':'\u0444','Fcy':'\u0424','female':'\u2640','ffilig':'\uFB03','fflig':'\uFB00','ffllig':'\uFB04','ffr':'\uD835\uDD23','Ffr':'\uD835\uDD09','filig':'\uFB01','FilledSmallSquare':'\u25FC','FilledVerySmallSquare':'\u25AA','fjlig':'fj','flat':'\u266D','fllig':'\uFB02','fltns':'\u25B1','fnof':'\u0192','fopf':'\uD835\uDD57','Fopf':'\uD835\uDD3D','forall':'\u2200','ForAll':'\u2200','fork':'\u22D4','forkv':'\u2AD9','Fouriertrf':'\u2131','fpartint':'\u2A0D','frac12':'\xBD','frac13':'\u2153','frac14':'\xBC','frac15':'\u2155','frac16':'\u2159','frac18':'\u215B','frac23':'\u2154','frac25':'\u2156','frac34':'\xBE','frac35':'\u2157','frac38':'\u215C','frac45':'\u2158','frac56':'\u215A','frac58':'\u215D','frac78':'\u215E','frasl':'\u2044','frown':'\u2322','fscr':'\uD835\uDCBB','Fscr':'\u2131','gacute':'\u01F5','gamma':'\u03B3','Gamma':'\u0393','gammad':'\u03DD','Gammad':'\u03DC','gap':'\u2A86','gbreve':'\u011F','Gbreve':'\u011E','Gcedil':'\u0122','gcirc':'\u011D','Gcirc':'\u011C','gcy':'\u0433','Gcy':'\u0413','gdot':'\u0121','Gdot':'\u0120','ge':'\u2265','gE':'\u2267','gel':'\u22DB','gEl':'\u2A8C','geq':'\u2265','geqq':'\u2267','geqslant':'\u2A7E','ges':'\u2A7E','gescc':'\u2AA9','gesdot':'\u2A80','gesdoto':'\u2A82','gesdotol':'\u2A84','gesl':'\u22DB\uFE00','gesles':'\u2A94','gfr':'\uD835\uDD24','Gfr':'\uD835\uDD0A','gg':'\u226B','Gg':'\u22D9','ggg':'\u22D9','gimel':'\u2137','gjcy':'\u0453','GJcy':'\u0403','gl':'\u2277','gla':'\u2AA5','glE':'\u2A92','glj':'\u2AA4','gnap':'\u2A8A','gnapprox':'\u2A8A','gne':'\u2A88','gnE':'\u2269','gneq':'\u2A88','gneqq':'\u2269','gnsim':'\u22E7','gopf':'\uD835\uDD58','Gopf':'\uD835\uDD3E','grave':'`','GreaterEqual':'\u2265','GreaterEqualLess':'\u22DB','GreaterFullEqual':'\u2267','GreaterGreater':'\u2AA2','GreaterLess':'\u2277','GreaterSlantEqual':'\u2A7E','GreaterTilde':'\u2273','gscr':'\u210A','Gscr':'\uD835\uDCA2','gsim':'\u2273','gsime':'\u2A8E','gsiml':'\u2A90','gt':'>','Gt':'\u226B','GT':'>','gtcc':'\u2AA7','gtcir':'\u2A7A','gtdot':'\u22D7','gtlPar':'\u2995','gtquest':'\u2A7C','gtrapprox':'\u2A86','gtrarr':'\u2978','gtrdot':'\u22D7','gtreqless':'\u22DB','gtreqqless':'\u2A8C','gtrless':'\u2277','gtrsim':'\u2273','gvertneqq':'\u2269\uFE00','gvnE':'\u2269\uFE00','Hacek':'\u02C7','hairsp':'\u200A','half':'\xBD','hamilt':'\u210B','hardcy':'\u044A','HARDcy':'\u042A','harr':'\u2194','hArr':'\u21D4','harrcir':'\u2948','harrw':'\u21AD','Hat':'^','hbar':'\u210F','hcirc':'\u0125','Hcirc':'\u0124','hearts':'\u2665','heartsuit':'\u2665','hellip':'\u2026','hercon':'\u22B9','hfr':'\uD835\uDD25','Hfr':'\u210C','HilbertSpace':'\u210B','hksearow':'\u2925','hkswarow':'\u2926','hoarr':'\u21FF','homtht':'\u223B','hookleftarrow':'\u21A9','hookrightarrow':'\u21AA','hopf':'\uD835\uDD59','Hopf':'\u210D','horbar':'\u2015','HorizontalLine':'\u2500','hscr':'\uD835\uDCBD','Hscr':'\u210B','hslash':'\u210F','hstrok':'\u0127','Hstrok':'\u0126','HumpDownHump':'\u224E','HumpEqual':'\u224F','hybull':'\u2043','hyphen':'\u2010','iacute':'\xED','Iacute':'\xCD','ic':'\u2063','icirc':'\xEE','Icirc':'\xCE','icy':'\u0438','Icy':'\u0418','Idot':'\u0130','iecy':'\u0435','IEcy':'\u0415','iexcl':'\xA1','iff':'\u21D4','ifr':'\uD835\uDD26','Ifr':'\u2111','igrave':'\xEC','Igrave':'\xCC','ii':'\u2148','iiiint':'\u2A0C','iiint':'\u222D','iinfin':'\u29DC','iiota':'\u2129','ijlig':'\u0133','IJlig':'\u0132','Im':'\u2111','imacr':'\u012B','Imacr':'\u012A','image':'\u2111','ImaginaryI':'\u2148','imagline':'\u2110','imagpart':'\u2111','imath':'\u0131','imof':'\u22B7','imped':'\u01B5','Implies':'\u21D2','in':'\u2208','incare':'\u2105','infin':'\u221E','infintie':'\u29DD','inodot':'\u0131','int':'\u222B','Int':'\u222C','intcal':'\u22BA','integers':'\u2124','Integral':'\u222B','intercal':'\u22BA','Intersection':'\u22C2','intlarhk':'\u2A17','intprod':'\u2A3C','InvisibleComma':'\u2063','InvisibleTimes':'\u2062','iocy':'\u0451','IOcy':'\u0401','iogon':'\u012F','Iogon':'\u012E','iopf':'\uD835\uDD5A','Iopf':'\uD835\uDD40','iota':'\u03B9','Iota':'\u0399','iprod':'\u2A3C','iquest':'\xBF','iscr':'\uD835\uDCBE','Iscr':'\u2110','isin':'\u2208','isindot':'\u22F5','isinE':'\u22F9','isins':'\u22F4','isinsv':'\u22F3','isinv':'\u2208','it':'\u2062','itilde':'\u0129','Itilde':'\u0128','iukcy':'\u0456','Iukcy':'\u0406','iuml':'\xEF','Iuml':'\xCF','jcirc':'\u0135','Jcirc':'\u0134','jcy':'\u0439','Jcy':'\u0419','jfr':'\uD835\uDD27','Jfr':'\uD835\uDD0D','jmath':'\u0237','jopf':'\uD835\uDD5B','Jopf':'\uD835\uDD41','jscr':'\uD835\uDCBF','Jscr':'\uD835\uDCA5','jsercy':'\u0458','Jsercy':'\u0408','jukcy':'\u0454','Jukcy':'\u0404','kappa':'\u03BA','Kappa':'\u039A','kappav':'\u03F0','kcedil':'\u0137','Kcedil':'\u0136','kcy':'\u043A','Kcy':'\u041A','kfr':'\uD835\uDD28','Kfr':'\uD835\uDD0E','kgreen':'\u0138','khcy':'\u0445','KHcy':'\u0425','kjcy':'\u045C','KJcy':'\u040C','kopf':'\uD835\uDD5C','Kopf':'\uD835\uDD42','kscr':'\uD835\uDCC0','Kscr':'\uD835\uDCA6','lAarr':'\u21DA','lacute':'\u013A','Lacute':'\u0139','laemptyv':'\u29B4','lagran':'\u2112','lambda':'\u03BB','Lambda':'\u039B','lang':'\u27E8','Lang':'\u27EA','langd':'\u2991','langle':'\u27E8','lap':'\u2A85','Laplacetrf':'\u2112','laquo':'\xAB','larr':'\u2190','lArr':'\u21D0','Larr':'\u219E','larrb':'\u21E4','larrbfs':'\u291F','larrfs':'\u291D','larrhk':'\u21A9','larrlp':'\u21AB','larrpl':'\u2939','larrsim':'\u2973','larrtl':'\u21A2','lat':'\u2AAB','latail':'\u2919','lAtail':'\u291B','late':'\u2AAD','lates':'\u2AAD\uFE00','lbarr':'\u290C','lBarr':'\u290E','lbbrk':'\u2772','lbrace':'{','lbrack':'[','lbrke':'\u298B','lbrksld':'\u298F','lbrkslu':'\u298D','lcaron':'\u013E','Lcaron':'\u013D','lcedil':'\u013C','Lcedil':'\u013B','lceil':'\u2308','lcub':'{','lcy':'\u043B','Lcy':'\u041B','ldca':'\u2936','ldquo':'\u201C','ldquor':'\u201E','ldrdhar':'\u2967','ldrushar':'\u294B','ldsh':'\u21B2','le':'\u2264','lE':'\u2266','LeftAngleBracket':'\u27E8','leftarrow':'\u2190','Leftarrow':'\u21D0','LeftArrow':'\u2190','LeftArrowBar':'\u21E4','LeftArrowRightArrow':'\u21C6','leftarrowtail':'\u21A2','LeftCeiling':'\u2308','LeftDoubleBracket':'\u27E6','LeftDownTeeVector':'\u2961','LeftDownVector':'\u21C3','LeftDownVectorBar':'\u2959','LeftFloor':'\u230A','leftharpoondown':'\u21BD','leftharpoonup':'\u21BC','leftleftarrows':'\u21C7','leftrightarrow':'\u2194','Leftrightarrow':'\u21D4','LeftRightArrow':'\u2194','leftrightarrows':'\u21C6','leftrightharpoons':'\u21CB','leftrightsquigarrow':'\u21AD','LeftRightVector':'\u294E','LeftTee':'\u22A3','LeftTeeArrow':'\u21A4','LeftTeeVector':'\u295A','leftthreetimes':'\u22CB','LeftTriangle':'\u22B2','LeftTriangleBar':'\u29CF','LeftTriangleEqual':'\u22B4','LeftUpDownVector':'\u2951','LeftUpTeeVector':'\u2960','LeftUpVector':'\u21BF','LeftUpVectorBar':'\u2958','LeftVector':'\u21BC','LeftVectorBar':'\u2952','leg':'\u22DA','lEg':'\u2A8B','leq':'\u2264','leqq':'\u2266','leqslant':'\u2A7D','les':'\u2A7D','lescc':'\u2AA8','lesdot':'\u2A7F','lesdoto':'\u2A81','lesdotor':'\u2A83','lesg':'\u22DA\uFE00','lesges':'\u2A93','lessapprox':'\u2A85','lessdot':'\u22D6','lesseqgtr':'\u22DA','lesseqqgtr':'\u2A8B','LessEqualGreater':'\u22DA','LessFullEqual':'\u2266','LessGreater':'\u2276','lessgtr':'\u2276','LessLess':'\u2AA1','lesssim':'\u2272','LessSlantEqual':'\u2A7D','LessTilde':'\u2272','lfisht':'\u297C','lfloor':'\u230A','lfr':'\uD835\uDD29','Lfr':'\uD835\uDD0F','lg':'\u2276','lgE':'\u2A91','lHar':'\u2962','lhard':'\u21BD','lharu':'\u21BC','lharul':'\u296A','lhblk':'\u2584','ljcy':'\u0459','LJcy':'\u0409','ll':'\u226A','Ll':'\u22D8','llarr':'\u21C7','llcorner':'\u231E','Lleftarrow':'\u21DA','llhard':'\u296B','lltri':'\u25FA','lmidot':'\u0140','Lmidot':'\u013F','lmoust':'\u23B0','lmoustache':'\u23B0','lnap':'\u2A89','lnapprox':'\u2A89','lne':'\u2A87','lnE':'\u2268','lneq':'\u2A87','lneqq':'\u2268','lnsim':'\u22E6','loang':'\u27EC','loarr':'\u21FD','lobrk':'\u27E6','longleftarrow':'\u27F5','Longleftarrow':'\u27F8','LongLeftArrow':'\u27F5','longleftrightarrow':'\u27F7','Longleftrightarrow':'\u27FA','LongLeftRightArrow':'\u27F7','longmapsto':'\u27FC','longrightarrow':'\u27F6','Longrightarrow':'\u27F9','LongRightArrow':'\u27F6','looparrowleft':'\u21AB','looparrowright':'\u21AC','lopar':'\u2985','lopf':'\uD835\uDD5D','Lopf':'\uD835\uDD43','loplus':'\u2A2D','lotimes':'\u2A34','lowast':'\u2217','lowbar':'_','LowerLeftArrow':'\u2199','LowerRightArrow':'\u2198','loz':'\u25CA','lozenge':'\u25CA','lozf':'\u29EB','lpar':'(','lparlt':'\u2993','lrarr':'\u21C6','lrcorner':'\u231F','lrhar':'\u21CB','lrhard':'\u296D','lrm':'\u200E','lrtri':'\u22BF','lsaquo':'\u2039','lscr':'\uD835\uDCC1','Lscr':'\u2112','lsh':'\u21B0','Lsh':'\u21B0','lsim':'\u2272','lsime':'\u2A8D','lsimg':'\u2A8F','lsqb':'[','lsquo':'\u2018','lsquor':'\u201A','lstrok':'\u0142','Lstrok':'\u0141','lt':'<','Lt':'\u226A','LT':'<','ltcc':'\u2AA6','ltcir':'\u2A79','ltdot':'\u22D6','lthree':'\u22CB','ltimes':'\u22C9','ltlarr':'\u2976','ltquest':'\u2A7B','ltri':'\u25C3','ltrie':'\u22B4','ltrif':'\u25C2','ltrPar':'\u2996','lurdshar':'\u294A','luruhar':'\u2966','lvertneqq':'\u2268\uFE00','lvnE':'\u2268\uFE00','macr':'\xAF','male':'\u2642','malt':'\u2720','maltese':'\u2720','map':'\u21A6','Map':'\u2905','mapsto':'\u21A6','mapstodown':'\u21A7','mapstoleft':'\u21A4','mapstoup':'\u21A5','marker':'\u25AE','mcomma':'\u2A29','mcy':'\u043C','Mcy':'\u041C','mdash':'\u2014','mDDot':'\u223A','measuredangle':'\u2221','MediumSpace':'\u205F','Mellintrf':'\u2133','mfr':'\uD835\uDD2A','Mfr':'\uD835\uDD10','mho':'\u2127','micro':'\xB5','mid':'\u2223','midast':'*','midcir':'\u2AF0','middot':'\xB7','minus':'\u2212','minusb':'\u229F','minusd':'\u2238','minusdu':'\u2A2A','MinusPlus':'\u2213','mlcp':'\u2ADB','mldr':'\u2026','mnplus':'\u2213','models':'\u22A7','mopf':'\uD835\uDD5E','Mopf':'\uD835\uDD44','mp':'\u2213','mscr':'\uD835\uDCC2','Mscr':'\u2133','mstpos':'\u223E','mu':'\u03BC','Mu':'\u039C','multimap':'\u22B8','mumap':'\u22B8','nabla':'\u2207','nacute':'\u0144','Nacute':'\u0143','nang':'\u2220\u20D2','nap':'\u2249','napE':'\u2A70\u0338','napid':'\u224B\u0338','napos':'\u0149','napprox':'\u2249','natur':'\u266E','natural':'\u266E','naturals':'\u2115','nbsp':'\xA0','nbump':'\u224E\u0338','nbumpe':'\u224F\u0338','ncap':'\u2A43','ncaron':'\u0148','Ncaron':'\u0147','ncedil':'\u0146','Ncedil':'\u0145','ncong':'\u2247','ncongdot':'\u2A6D\u0338','ncup':'\u2A42','ncy':'\u043D','Ncy':'\u041D','ndash':'\u2013','ne':'\u2260','nearhk':'\u2924','nearr':'\u2197','neArr':'\u21D7','nearrow':'\u2197','nedot':'\u2250\u0338','NegativeMediumSpace':'\u200B','NegativeThickSpace':'\u200B','NegativeThinSpace':'\u200B','NegativeVeryThinSpace':'\u200B','nequiv':'\u2262','nesear':'\u2928','nesim':'\u2242\u0338','NestedGreaterGreater':'\u226B','NestedLessLess':'\u226A','NewLine':'\n','nexist':'\u2204','nexists':'\u2204','nfr':'\uD835\uDD2B','Nfr':'\uD835\uDD11','nge':'\u2271','ngE':'\u2267\u0338','ngeq':'\u2271','ngeqq':'\u2267\u0338','ngeqslant':'\u2A7E\u0338','nges':'\u2A7E\u0338','nGg':'\u22D9\u0338','ngsim':'\u2275','ngt':'\u226F','nGt':'\u226B\u20D2','ngtr':'\u226F','nGtv':'\u226B\u0338','nharr':'\u21AE','nhArr':'\u21CE','nhpar':'\u2AF2','ni':'\u220B','nis':'\u22FC','nisd':'\u22FA','niv':'\u220B','njcy':'\u045A','NJcy':'\u040A','nlarr':'\u219A','nlArr':'\u21CD','nldr':'\u2025','nle':'\u2270','nlE':'\u2266\u0338','nleftarrow':'\u219A','nLeftarrow':'\u21CD','nleftrightarrow':'\u21AE','nLeftrightarrow':'\u21CE','nleq':'\u2270','nleqq':'\u2266\u0338','nleqslant':'\u2A7D\u0338','nles':'\u2A7D\u0338','nless':'\u226E','nLl':'\u22D8\u0338','nlsim':'\u2274','nlt':'\u226E','nLt':'\u226A\u20D2','nltri':'\u22EA','nltrie':'\u22EC','nLtv':'\u226A\u0338','nmid':'\u2224','NoBreak':'\u2060','NonBreakingSpace':'\xA0','nopf':'\uD835\uDD5F','Nopf':'\u2115','not':'\xAC','Not':'\u2AEC','NotCongruent':'\u2262','NotCupCap':'\u226D','NotDoubleVerticalBar':'\u2226','NotElement':'\u2209','NotEqual':'\u2260','NotEqualTilde':'\u2242\u0338','NotExists':'\u2204','NotGreater':'\u226F','NotGreaterEqual':'\u2271','NotGreaterFullEqual':'\u2267\u0338','NotGreaterGreater':'\u226B\u0338','NotGreaterLess':'\u2279','NotGreaterSlantEqual':'\u2A7E\u0338','NotGreaterTilde':'\u2275','NotHumpDownHump':'\u224E\u0338','NotHumpEqual':'\u224F\u0338','notin':'\u2209','notindot':'\u22F5\u0338','notinE':'\u22F9\u0338','notinva':'\u2209','notinvb':'\u22F7','notinvc':'\u22F6','NotLeftTriangle':'\u22EA','NotLeftTriangleBar':'\u29CF\u0338','NotLeftTriangleEqual':'\u22EC','NotLess':'\u226E','NotLessEqual':'\u2270','NotLessGreater':'\u2278','NotLessLess':'\u226A\u0338','NotLessSlantEqual':'\u2A7D\u0338','NotLessTilde':'\u2274','NotNestedGreaterGreater':'\u2AA2\u0338','NotNestedLessLess':'\u2AA1\u0338','notni':'\u220C','notniva':'\u220C','notnivb':'\u22FE','notnivc':'\u22FD','NotPrecedes':'\u2280','NotPrecedesEqual':'\u2AAF\u0338','NotPrecedesSlantEqual':'\u22E0','NotReverseElement':'\u220C','NotRightTriangle':'\u22EB','NotRightTriangleBar':'\u29D0\u0338','NotRightTriangleEqual':'\u22ED','NotSquareSubset':'\u228F\u0338','NotSquareSubsetEqual':'\u22E2','NotSquareSuperset':'\u2290\u0338','NotSquareSupersetEqual':'\u22E3','NotSubset':'\u2282\u20D2','NotSubsetEqual':'\u2288','NotSucceeds':'\u2281','NotSucceedsEqual':'\u2AB0\u0338','NotSucceedsSlantEqual':'\u22E1','NotSucceedsTilde':'\u227F\u0338','NotSuperset':'\u2283\u20D2','NotSupersetEqual':'\u2289','NotTilde':'\u2241','NotTildeEqual':'\u2244','NotTildeFullEqual':'\u2247','NotTildeTilde':'\u2249','NotVerticalBar':'\u2224','npar':'\u2226','nparallel':'\u2226','nparsl':'\u2AFD\u20E5','npart':'\u2202\u0338','npolint':'\u2A14','npr':'\u2280','nprcue':'\u22E0','npre':'\u2AAF\u0338','nprec':'\u2280','npreceq':'\u2AAF\u0338','nrarr':'\u219B','nrArr':'\u21CF','nrarrc':'\u2933\u0338','nrarrw':'\u219D\u0338','nrightarrow':'\u219B','nRightarrow':'\u21CF','nrtri':'\u22EB','nrtrie':'\u22ED','nsc':'\u2281','nsccue':'\u22E1','nsce':'\u2AB0\u0338','nscr':'\uD835\uDCC3','Nscr':'\uD835\uDCA9','nshortmid':'\u2224','nshortparallel':'\u2226','nsim':'\u2241','nsime':'\u2244','nsimeq':'\u2244','nsmid':'\u2224','nspar':'\u2226','nsqsube':'\u22E2','nsqsupe':'\u22E3','nsub':'\u2284','nsube':'\u2288','nsubE':'\u2AC5\u0338','nsubset':'\u2282\u20D2','nsubseteq':'\u2288','nsubseteqq':'\u2AC5\u0338','nsucc':'\u2281','nsucceq':'\u2AB0\u0338','nsup':'\u2285','nsupe':'\u2289','nsupE':'\u2AC6\u0338','nsupset':'\u2283\u20D2','nsupseteq':'\u2289','nsupseteqq':'\u2AC6\u0338','ntgl':'\u2279','ntilde':'\xF1','Ntilde':'\xD1','ntlg':'\u2278','ntriangleleft':'\u22EA','ntrianglelefteq':'\u22EC','ntriangleright':'\u22EB','ntrianglerighteq':'\u22ED','nu':'\u03BD','Nu':'\u039D','num':'#','numero':'\u2116','numsp':'\u2007','nvap':'\u224D\u20D2','nvdash':'\u22AC','nvDash':'\u22AD','nVdash':'\u22AE','nVDash':'\u22AF','nvge':'\u2265\u20D2','nvgt':'>\u20D2','nvHarr':'\u2904','nvinfin':'\u29DE','nvlArr':'\u2902','nvle':'\u2264\u20D2','nvlt':'<\u20D2','nvltrie':'\u22B4\u20D2','nvrArr':'\u2903','nvrtrie':'\u22B5\u20D2','nvsim':'\u223C\u20D2','nwarhk':'\u2923','nwarr':'\u2196','nwArr':'\u21D6','nwarrow':'\u2196','nwnear':'\u2927','oacute':'\xF3','Oacute':'\xD3','oast':'\u229B','ocir':'\u229A','ocirc':'\xF4','Ocirc':'\xD4','ocy':'\u043E','Ocy':'\u041E','odash':'\u229D','odblac':'\u0151','Odblac':'\u0150','odiv':'\u2A38','odot':'\u2299','odsold':'\u29BC','oelig':'\u0153','OElig':'\u0152','ofcir':'\u29BF','ofr':'\uD835\uDD2C','Ofr':'\uD835\uDD12','ogon':'\u02DB','ograve':'\xF2','Ograve':'\xD2','ogt':'\u29C1','ohbar':'\u29B5','ohm':'\u03A9','oint':'\u222E','olarr':'\u21BA','olcir':'\u29BE','olcross':'\u29BB','oline':'\u203E','olt':'\u29C0','omacr':'\u014D','Omacr':'\u014C','omega':'\u03C9','Omega':'\u03A9','omicron':'\u03BF','Omicron':'\u039F','omid':'\u29B6','ominus':'\u2296','oopf':'\uD835\uDD60','Oopf':'\uD835\uDD46','opar':'\u29B7','OpenCurlyDoubleQuote':'\u201C','OpenCurlyQuote':'\u2018','operp':'\u29B9','oplus':'\u2295','or':'\u2228','Or':'\u2A54','orarr':'\u21BB','ord':'\u2A5D','order':'\u2134','orderof':'\u2134','ordf':'\xAA','ordm':'\xBA','origof':'\u22B6','oror':'\u2A56','orslope':'\u2A57','orv':'\u2A5B','oS':'\u24C8','oscr':'\u2134','Oscr':'\uD835\uDCAA','oslash':'\xF8','Oslash':'\xD8','osol':'\u2298','otilde':'\xF5','Otilde':'\xD5','otimes':'\u2297','Otimes':'\u2A37','otimesas':'\u2A36','ouml':'\xF6','Ouml':'\xD6','ovbar':'\u233D','OverBar':'\u203E','OverBrace':'\u23DE','OverBracket':'\u23B4','OverParenthesis':'\u23DC','par':'\u2225','para':'\xB6','parallel':'\u2225','parsim':'\u2AF3','parsl':'\u2AFD','part':'\u2202','PartialD':'\u2202','pcy':'\u043F','Pcy':'\u041F','percnt':'%','period':'.','permil':'\u2030','perp':'\u22A5','pertenk':'\u2031','pfr':'\uD835\uDD2D','Pfr':'\uD835\uDD13','phi':'\u03C6','Phi':'\u03A6','phiv':'\u03D5','phmmat':'\u2133','phone':'\u260E','pi':'\u03C0','Pi':'\u03A0','pitchfork':'\u22D4','piv':'\u03D6','planck':'\u210F','planckh':'\u210E','plankv':'\u210F','plus':'+','plusacir':'\u2A23','plusb':'\u229E','pluscir':'\u2A22','plusdo':'\u2214','plusdu':'\u2A25','pluse':'\u2A72','PlusMinus':'\xB1','plusmn':'\xB1','plussim':'\u2A26','plustwo':'\u2A27','pm':'\xB1','Poincareplane':'\u210C','pointint':'\u2A15','popf':'\uD835\uDD61','Popf':'\u2119','pound':'\xA3','pr':'\u227A','Pr':'\u2ABB','prap':'\u2AB7','prcue':'\u227C','pre':'\u2AAF','prE':'\u2AB3','prec':'\u227A','precapprox':'\u2AB7','preccurlyeq':'\u227C','Precedes':'\u227A','PrecedesEqual':'\u2AAF','PrecedesSlantEqual':'\u227C','PrecedesTilde':'\u227E','preceq':'\u2AAF','precnapprox':'\u2AB9','precneqq':'\u2AB5','precnsim':'\u22E8','precsim':'\u227E','prime':'\u2032','Prime':'\u2033','primes':'\u2119','prnap':'\u2AB9','prnE':'\u2AB5','prnsim':'\u22E8','prod':'\u220F','Product':'\u220F','profalar':'\u232E','profline':'\u2312','profsurf':'\u2313','prop':'\u221D','Proportion':'\u2237','Proportional':'\u221D','propto':'\u221D','prsim':'\u227E','prurel':'\u22B0','pscr':'\uD835\uDCC5','Pscr':'\uD835\uDCAB','psi':'\u03C8','Psi':'\u03A8','puncsp':'\u2008','qfr':'\uD835\uDD2E','Qfr':'\uD835\uDD14','qint':'\u2A0C','qopf':'\uD835\uDD62','Qopf':'\u211A','qprime':'\u2057','qscr':'\uD835\uDCC6','Qscr':'\uD835\uDCAC','quaternions':'\u210D','quatint':'\u2A16','quest':'?','questeq':'\u225F','quot':'"','QUOT':'"','rAarr':'\u21DB','race':'\u223D\u0331','racute':'\u0155','Racute':'\u0154','radic':'\u221A','raemptyv':'\u29B3','rang':'\u27E9','Rang':'\u27EB','rangd':'\u2992','range':'\u29A5','rangle':'\u27E9','raquo':'\xBB','rarr':'\u2192','rArr':'\u21D2','Rarr':'\u21A0','rarrap':'\u2975','rarrb':'\u21E5','rarrbfs':'\u2920','rarrc':'\u2933','rarrfs':'\u291E','rarrhk':'\u21AA','rarrlp':'\u21AC','rarrpl':'\u2945','rarrsim':'\u2974','rarrtl':'\u21A3','Rarrtl':'\u2916','rarrw':'\u219D','ratail':'\u291A','rAtail':'\u291C','ratio':'\u2236','rationals':'\u211A','rbarr':'\u290D','rBarr':'\u290F','RBarr':'\u2910','rbbrk':'\u2773','rbrace':'}','rbrack':']','rbrke':'\u298C','rbrksld':'\u298E','rbrkslu':'\u2990','rcaron':'\u0159','Rcaron':'\u0158','rcedil':'\u0157','Rcedil':'\u0156','rceil':'\u2309','rcub':'}','rcy':'\u0440','Rcy':'\u0420','rdca':'\u2937','rdldhar':'\u2969','rdquo':'\u201D','rdquor':'\u201D','rdsh':'\u21B3','Re':'\u211C','real':'\u211C','realine':'\u211B','realpart':'\u211C','reals':'\u211D','rect':'\u25AD','reg':'\xAE','REG':'\xAE','ReverseElement':'\u220B','ReverseEquilibrium':'\u21CB','ReverseUpEquilibrium':'\u296F','rfisht':'\u297D','rfloor':'\u230B','rfr':'\uD835\uDD2F','Rfr':'\u211C','rHar':'\u2964','rhard':'\u21C1','rharu':'\u21C0','rharul':'\u296C','rho':'\u03C1','Rho':'\u03A1','rhov':'\u03F1','RightAngleBracket':'\u27E9','rightarrow':'\u2192','Rightarrow':'\u21D2','RightArrow':'\u2192','RightArrowBar':'\u21E5','RightArrowLeftArrow':'\u21C4','rightarrowtail':'\u21A3','RightCeiling':'\u2309','RightDoubleBracket':'\u27E7','RightDownTeeVector':'\u295D','RightDownVector':'\u21C2','RightDownVectorBar':'\u2955','RightFloor':'\u230B','rightharpoondown':'\u21C1','rightharpoonup':'\u21C0','rightleftarrows':'\u21C4','rightleftharpoons':'\u21CC','rightrightarrows':'\u21C9','rightsquigarrow':'\u219D','RightTee':'\u22A2','RightTeeArrow':'\u21A6','RightTeeVector':'\u295B','rightthreetimes':'\u22CC','RightTriangle':'\u22B3','RightTriangleBar':'\u29D0','RightTriangleEqual':'\u22B5','RightUpDownVector':'\u294F','RightUpTeeVector':'\u295C','RightUpVector':'\u21BE','RightUpVectorBar':'\u2954','RightVector':'\u21C0','RightVectorBar':'\u2953','ring':'\u02DA','risingdotseq':'\u2253','rlarr':'\u21C4','rlhar':'\u21CC','rlm':'\u200F','rmoust':'\u23B1','rmoustache':'\u23B1','rnmid':'\u2AEE','roang':'\u27ED','roarr':'\u21FE','robrk':'\u27E7','ropar':'\u2986','ropf':'\uD835\uDD63','Ropf':'\u211D','roplus':'\u2A2E','rotimes':'\u2A35','RoundImplies':'\u2970','rpar':')','rpargt':'\u2994','rppolint':'\u2A12','rrarr':'\u21C9','Rrightarrow':'\u21DB','rsaquo':'\u203A','rscr':'\uD835\uDCC7','Rscr':'\u211B','rsh':'\u21B1','Rsh':'\u21B1','rsqb':']','rsquo':'\u2019','rsquor':'\u2019','rthree':'\u22CC','rtimes':'\u22CA','rtri':'\u25B9','rtrie':'\u22B5','rtrif':'\u25B8','rtriltri':'\u29CE','RuleDelayed':'\u29F4','ruluhar':'\u2968','rx':'\u211E','sacute':'\u015B','Sacute':'\u015A','sbquo':'\u201A','sc':'\u227B','Sc':'\u2ABC','scap':'\u2AB8','scaron':'\u0161','Scaron':'\u0160','sccue':'\u227D','sce':'\u2AB0','scE':'\u2AB4','scedil':'\u015F','Scedil':'\u015E','scirc':'\u015D','Scirc':'\u015C','scnap':'\u2ABA','scnE':'\u2AB6','scnsim':'\u22E9','scpolint':'\u2A13','scsim':'\u227F','scy':'\u0441','Scy':'\u0421','sdot':'\u22C5','sdotb':'\u22A1','sdote':'\u2A66','searhk':'\u2925','searr':'\u2198','seArr':'\u21D8','searrow':'\u2198','sect':'\xA7','semi':';','seswar':'\u2929','setminus':'\u2216','setmn':'\u2216','sext':'\u2736','sfr':'\uD835\uDD30','Sfr':'\uD835\uDD16','sfrown':'\u2322','sharp':'\u266F','shchcy':'\u0449','SHCHcy':'\u0429','shcy':'\u0448','SHcy':'\u0428','ShortDownArrow':'\u2193','ShortLeftArrow':'\u2190','shortmid':'\u2223','shortparallel':'\u2225','ShortRightArrow':'\u2192','ShortUpArrow':'\u2191','shy':'\xAD','sigma':'\u03C3','Sigma':'\u03A3','sigmaf':'\u03C2','sigmav':'\u03C2','sim':'\u223C','simdot':'\u2A6A','sime':'\u2243','simeq':'\u2243','simg':'\u2A9E','simgE':'\u2AA0','siml':'\u2A9D','simlE':'\u2A9F','simne':'\u2246','simplus':'\u2A24','simrarr':'\u2972','slarr':'\u2190','SmallCircle':'\u2218','smallsetminus':'\u2216','smashp':'\u2A33','smeparsl':'\u29E4','smid':'\u2223','smile':'\u2323','smt':'\u2AAA','smte':'\u2AAC','smtes':'\u2AAC\uFE00','softcy':'\u044C','SOFTcy':'\u042C','sol':'/','solb':'\u29C4','solbar':'\u233F','sopf':'\uD835\uDD64','Sopf':'\uD835\uDD4A','spades':'\u2660','spadesuit':'\u2660','spar':'\u2225','sqcap':'\u2293','sqcaps':'\u2293\uFE00','sqcup':'\u2294','sqcups':'\u2294\uFE00','Sqrt':'\u221A','sqsub':'\u228F','sqsube':'\u2291','sqsubset':'\u228F','sqsubseteq':'\u2291','sqsup':'\u2290','sqsupe':'\u2292','sqsupset':'\u2290','sqsupseteq':'\u2292','squ':'\u25A1','square':'\u25A1','Square':'\u25A1','SquareIntersection':'\u2293','SquareSubset':'\u228F','SquareSubsetEqual':'\u2291','SquareSuperset':'\u2290','SquareSupersetEqual':'\u2292','SquareUnion':'\u2294','squarf':'\u25AA','squf':'\u25AA','srarr':'\u2192','sscr':'\uD835\uDCC8','Sscr':'\uD835\uDCAE','ssetmn':'\u2216','ssmile':'\u2323','sstarf':'\u22C6','star':'\u2606','Star':'\u22C6','starf':'\u2605','straightepsilon':'\u03F5','straightphi':'\u03D5','strns':'\xAF','sub':'\u2282','Sub':'\u22D0','subdot':'\u2ABD','sube':'\u2286','subE':'\u2AC5','subedot':'\u2AC3','submult':'\u2AC1','subne':'\u228A','subnE':'\u2ACB','subplus':'\u2ABF','subrarr':'\u2979','subset':'\u2282','Subset':'\u22D0','subseteq':'\u2286','subseteqq':'\u2AC5','SubsetEqual':'\u2286','subsetneq':'\u228A','subsetneqq':'\u2ACB','subsim':'\u2AC7','subsub':'\u2AD5','subsup':'\u2AD3','succ':'\u227B','succapprox':'\u2AB8','succcurlyeq':'\u227D','Succeeds':'\u227B','SucceedsEqual':'\u2AB0','SucceedsSlantEqual':'\u227D','SucceedsTilde':'\u227F','succeq':'\u2AB0','succnapprox':'\u2ABA','succneqq':'\u2AB6','succnsim':'\u22E9','succsim':'\u227F','SuchThat':'\u220B','sum':'\u2211','Sum':'\u2211','sung':'\u266A','sup':'\u2283','Sup':'\u22D1','sup1':'\xB9','sup2':'\xB2','sup3':'\xB3','supdot':'\u2ABE','supdsub':'\u2AD8','supe':'\u2287','supE':'\u2AC6','supedot':'\u2AC4','Superset':'\u2283','SupersetEqual':'\u2287','suphsol':'\u27C9','suphsub':'\u2AD7','suplarr':'\u297B','supmult':'\u2AC2','supne':'\u228B','supnE':'\u2ACC','supplus':'\u2AC0','supset':'\u2283','Supset':'\u22D1','supseteq':'\u2287','supseteqq':'\u2AC6','supsetneq':'\u228B','supsetneqq':'\u2ACC','supsim':'\u2AC8','supsub':'\u2AD4','supsup':'\u2AD6','swarhk':'\u2926','swarr':'\u2199','swArr':'\u21D9','swarrow':'\u2199','swnwar':'\u292A','szlig':'\xDF','Tab':'\t','target':'\u2316','tau':'\u03C4','Tau':'\u03A4','tbrk':'\u23B4','tcaron':'\u0165','Tcaron':'\u0164','tcedil':'\u0163','Tcedil':'\u0162','tcy':'\u0442','Tcy':'\u0422','tdot':'\u20DB','telrec':'\u2315','tfr':'\uD835\uDD31','Tfr':'\uD835\uDD17','there4':'\u2234','therefore':'\u2234','Therefore':'\u2234','theta':'\u03B8','Theta':'\u0398','thetasym':'\u03D1','thetav':'\u03D1','thickapprox':'\u2248','thicksim':'\u223C','ThickSpace':'\u205F\u200A','thinsp':'\u2009','ThinSpace':'\u2009','thkap':'\u2248','thksim':'\u223C','thorn':'\xFE','THORN':'\xDE','tilde':'\u02DC','Tilde':'\u223C','TildeEqual':'\u2243','TildeFullEqual':'\u2245','TildeTilde':'\u2248','times':'\xD7','timesb':'\u22A0','timesbar':'\u2A31','timesd':'\u2A30','tint':'\u222D','toea':'\u2928','top':'\u22A4','topbot':'\u2336','topcir':'\u2AF1','topf':'\uD835\uDD65','Topf':'\uD835\uDD4B','topfork':'\u2ADA','tosa':'\u2929','tprime':'\u2034','trade':'\u2122','TRADE':'\u2122','triangle':'\u25B5','triangledown':'\u25BF','triangleleft':'\u25C3','trianglelefteq':'\u22B4','triangleq':'\u225C','triangleright':'\u25B9','trianglerighteq':'\u22B5','tridot':'\u25EC','trie':'\u225C','triminus':'\u2A3A','TripleDot':'\u20DB','triplus':'\u2A39','trisb':'\u29CD','tritime':'\u2A3B','trpezium':'\u23E2','tscr':'\uD835\uDCC9','Tscr':'\uD835\uDCAF','tscy':'\u0446','TScy':'\u0426','tshcy':'\u045B','TSHcy':'\u040B','tstrok':'\u0167','Tstrok':'\u0166','twixt':'\u226C','twoheadleftarrow':'\u219E','twoheadrightarrow':'\u21A0','uacute':'\xFA','Uacute':'\xDA','uarr':'\u2191','uArr':'\u21D1','Uarr':'\u219F','Uarrocir':'\u2949','ubrcy':'\u045E','Ubrcy':'\u040E','ubreve':'\u016D','Ubreve':'\u016C','ucirc':'\xFB','Ucirc':'\xDB','ucy':'\u0443','Ucy':'\u0423','udarr':'\u21C5','udblac':'\u0171','Udblac':'\u0170','udhar':'\u296E','ufisht':'\u297E','ufr':'\uD835\uDD32','Ufr':'\uD835\uDD18','ugrave':'\xF9','Ugrave':'\xD9','uHar':'\u2963','uharl':'\u21BF','uharr':'\u21BE','uhblk':'\u2580','ulcorn':'\u231C','ulcorner':'\u231C','ulcrop':'\u230F','ultri':'\u25F8','umacr':'\u016B','Umacr':'\u016A','uml':'\xA8','UnderBar':'_','UnderBrace':'\u23DF','UnderBracket':'\u23B5','UnderParenthesis':'\u23DD','Union':'\u22C3','UnionPlus':'\u228E','uogon':'\u0173','Uogon':'\u0172','uopf':'\uD835\uDD66','Uopf':'\uD835\uDD4C','uparrow':'\u2191','Uparrow':'\u21D1','UpArrow':'\u2191','UpArrowBar':'\u2912','UpArrowDownArrow':'\u21C5','updownarrow':'\u2195','Updownarrow':'\u21D5','UpDownArrow':'\u2195','UpEquilibrium':'\u296E','upharpoonleft':'\u21BF','upharpoonright':'\u21BE','uplus':'\u228E','UpperLeftArrow':'\u2196','UpperRightArrow':'\u2197','upsi':'\u03C5','Upsi':'\u03D2','upsih':'\u03D2','upsilon':'\u03C5','Upsilon':'\u03A5','UpTee':'\u22A5','UpTeeArrow':'\u21A5','upuparrows':'\u21C8','urcorn':'\u231D','urcorner':'\u231D','urcrop':'\u230E','uring':'\u016F','Uring':'\u016E','urtri':'\u25F9','uscr':'\uD835\uDCCA','Uscr':'\uD835\uDCB0','utdot':'\u22F0','utilde':'\u0169','Utilde':'\u0168','utri':'\u25B5','utrif':'\u25B4','uuarr':'\u21C8','uuml':'\xFC','Uuml':'\xDC','uwangle':'\u29A7','vangrt':'\u299C','varepsilon':'\u03F5','varkappa':'\u03F0','varnothing':'\u2205','varphi':'\u03D5','varpi':'\u03D6','varpropto':'\u221D','varr':'\u2195','vArr':'\u21D5','varrho':'\u03F1','varsigma':'\u03C2','varsubsetneq':'\u228A\uFE00','varsubsetneqq':'\u2ACB\uFE00','varsupsetneq':'\u228B\uFE00','varsupsetneqq':'\u2ACC\uFE00','vartheta':'\u03D1','vartriangleleft':'\u22B2','vartriangleright':'\u22B3','vBar':'\u2AE8','Vbar':'\u2AEB','vBarv':'\u2AE9','vcy':'\u0432','Vcy':'\u0412','vdash':'\u22A2','vDash':'\u22A8','Vdash':'\u22A9','VDash':'\u22AB','Vdashl':'\u2AE6','vee':'\u2228','Vee':'\u22C1','veebar':'\u22BB','veeeq':'\u225A','vellip':'\u22EE','verbar':'|','Verbar':'\u2016','vert':'|','Vert':'\u2016','VerticalBar':'\u2223','VerticalLine':'|','VerticalSeparator':'\u2758','VerticalTilde':'\u2240','VeryThinSpace':'\u200A','vfr':'\uD835\uDD33','Vfr':'\uD835\uDD19','vltri':'\u22B2','vnsub':'\u2282\u20D2','vnsup':'\u2283\u20D2','vopf':'\uD835\uDD67','Vopf':'\uD835\uDD4D','vprop':'\u221D','vrtri':'\u22B3','vscr':'\uD835\uDCCB','Vscr':'\uD835\uDCB1','vsubne':'\u228A\uFE00','vsubnE':'\u2ACB\uFE00','vsupne':'\u228B\uFE00','vsupnE':'\u2ACC\uFE00','Vvdash':'\u22AA','vzigzag':'\u299A','wcirc':'\u0175','Wcirc':'\u0174','wedbar':'\u2A5F','wedge':'\u2227','Wedge':'\u22C0','wedgeq':'\u2259','weierp':'\u2118','wfr':'\uD835\uDD34','Wfr':'\uD835\uDD1A','wopf':'\uD835\uDD68','Wopf':'\uD835\uDD4E','wp':'\u2118','wr':'\u2240','wreath':'\u2240','wscr':'\uD835\uDCCC','Wscr':'\uD835\uDCB2','xcap':'\u22C2','xcirc':'\u25EF','xcup':'\u22C3','xdtri':'\u25BD','xfr':'\uD835\uDD35','Xfr':'\uD835\uDD1B','xharr':'\u27F7','xhArr':'\u27FA','xi':'\u03BE','Xi':'\u039E','xlarr':'\u27F5','xlArr':'\u27F8','xmap':'\u27FC','xnis':'\u22FB','xodot':'\u2A00','xopf':'\uD835\uDD69','Xopf':'\uD835\uDD4F','xoplus':'\u2A01','xotime':'\u2A02','xrarr':'\u27F6','xrArr':'\u27F9','xscr':'\uD835\uDCCD','Xscr':'\uD835\uDCB3','xsqcup':'\u2A06','xuplus':'\u2A04','xutri':'\u25B3','xvee':'\u22C1','xwedge':'\u22C0','yacute':'\xFD','Yacute':'\xDD','yacy':'\u044F','YAcy':'\u042F','ycirc':'\u0177','Ycirc':'\u0176','ycy':'\u044B','Ycy':'\u042B','yen':'\xA5','yfr':'\uD835\uDD36','Yfr':'\uD835\uDD1C','yicy':'\u0457','YIcy':'\u0407','yopf':'\uD835\uDD6A','Yopf':'\uD835\uDD50','yscr':'\uD835\uDCCE','Yscr':'\uD835\uDCB4','yucy':'\u044E','YUcy':'\u042E','yuml':'\xFF','Yuml':'\u0178','zacute':'\u017A','Zacute':'\u0179','zcaron':'\u017E','Zcaron':'\u017D','zcy':'\u0437','Zcy':'\u0417','zdot':'\u017C','Zdot':'\u017B','zeetrf':'\u2128','ZeroWidthSpace':'\u200B','zeta':'\u03B6','Zeta':'\u0396','zfr':'\uD835\uDD37','Zfr':'\u2128','zhcy':'\u0436','ZHcy':'\u0416','zigrarr':'\u21DD','zopf':'\uD835\uDD6B','Zopf':'\u2124','zscr':'\uD835\uDCCF','Zscr':'\uD835\uDCB5','zwj':'\u200D','zwnj':'\u200C'};
	var decodeMapLegacy = {'aacute':'\xE1','Aacute':'\xC1','acirc':'\xE2','Acirc':'\xC2','acute':'\xB4','aelig':'\xE6','AElig':'\xC6','agrave':'\xE0','Agrave':'\xC0','amp':'&','AMP':'&','aring':'\xE5','Aring':'\xC5','atilde':'\xE3','Atilde':'\xC3','auml':'\xE4','Auml':'\xC4','brvbar':'\xA6','ccedil':'\xE7','Ccedil':'\xC7','cedil':'\xB8','cent':'\xA2','copy':'\xA9','COPY':'\xA9','curren':'\xA4','deg':'\xB0','divide':'\xF7','eacute':'\xE9','Eacute':'\xC9','ecirc':'\xEA','Ecirc':'\xCA','egrave':'\xE8','Egrave':'\xC8','eth':'\xF0','ETH':'\xD0','euml':'\xEB','Euml':'\xCB','frac12':'\xBD','frac14':'\xBC','frac34':'\xBE','gt':'>','GT':'>','iacute':'\xED','Iacute':'\xCD','icirc':'\xEE','Icirc':'\xCE','iexcl':'\xA1','igrave':'\xEC','Igrave':'\xCC','iquest':'\xBF','iuml':'\xEF','Iuml':'\xCF','laquo':'\xAB','lt':'<','LT':'<','macr':'\xAF','micro':'\xB5','middot':'\xB7','nbsp':'\xA0','not':'\xAC','ntilde':'\xF1','Ntilde':'\xD1','oacute':'\xF3','Oacute':'\xD3','ocirc':'\xF4','Ocirc':'\xD4','ograve':'\xF2','Ograve':'\xD2','ordf':'\xAA','ordm':'\xBA','oslash':'\xF8','Oslash':'\xD8','otilde':'\xF5','Otilde':'\xD5','ouml':'\xF6','Ouml':'\xD6','para':'\xB6','plusmn':'\xB1','pound':'\xA3','quot':'"','QUOT':'"','raquo':'\xBB','reg':'\xAE','REG':'\xAE','sect':'\xA7','shy':'\xAD','sup1':'\xB9','sup2':'\xB2','sup3':'\xB3','szlig':'\xDF','thorn':'\xFE','THORN':'\xDE','times':'\xD7','uacute':'\xFA','Uacute':'\xDA','ucirc':'\xFB','Ucirc':'\xDB','ugrave':'\xF9','Ugrave':'\xD9','uml':'\xA8','uuml':'\xFC','Uuml':'\xDC','yacute':'\xFD','Yacute':'\xDD','yen':'\xA5','yuml':'\xFF'};
	var decodeMapNumeric = {'0':'\uFFFD','128':'\u20AC','130':'\u201A','131':'\u0192','132':'\u201E','133':'\u2026','134':'\u2020','135':'\u2021','136':'\u02C6','137':'\u2030','138':'\u0160','139':'\u2039','140':'\u0152','142':'\u017D','145':'\u2018','146':'\u2019','147':'\u201C','148':'\u201D','149':'\u2022','150':'\u2013','151':'\u2014','152':'\u02DC','153':'\u2122','154':'\u0161','155':'\u203A','156':'\u0153','158':'\u017E','159':'\u0178'};
	var invalidReferenceCodePoints = [1,2,3,4,5,6,7,8,11,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,127,128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,158,159,64976,64977,64978,64979,64980,64981,64982,64983,64984,64985,64986,64987,64988,64989,64990,64991,64992,64993,64994,64995,64996,64997,64998,64999,65000,65001,65002,65003,65004,65005,65006,65007,65534,65535,131070,131071,196606,196607,262142,262143,327678,327679,393214,393215,458750,458751,524286,524287,589822,589823,655358,655359,720894,720895,786430,786431,851966,851967,917502,917503,983038,983039,1048574,1048575,1114110,1114111];

	/*--------------------------------------------------------------------------*/

	var stringFromCharCode = String.fromCharCode;

	var object = {};
	var hasOwnProperty = object.hasOwnProperty;
	var has = function(object, propertyName) {
		return hasOwnProperty.call(object, propertyName);
	};

	var contains = function(array, value) {
		var index = -1;
		var length = array.length;
		while (++index < length) {
			if (array[index] == value) {
				return true;
			}
		}
		return false;
	};

	var merge = function(options, defaults) {
		if (!options) {
			return defaults;
		}
		var result = {};
		var key;
		for (key in defaults) {
			// A `hasOwnProperty` check is not needed here, since only recognized
			// option names are used anyway. Any others are ignored.
			result[key] = has(options, key) ? options[key] : defaults[key];
		}
		return result;
	};

	// Modified version of `ucs2encode`; see https://mths.be/punycode.
	var codePointToSymbol = function(codePoint, strict) {
		var output = '';
		if ((codePoint >= 0xD800 && codePoint <= 0xDFFF) || codePoint > 0x10FFFF) {
			// See issue #4:
			// “Otherwise, if the number is in the range 0xD800 to 0xDFFF or is
			// greater than 0x10FFFF, then this is a parse error. Return a U+FFFD
			// REPLACEMENT CHARACTER.”
			if (strict) {
				parseError('character reference outside the permissible Unicode range');
			}
			return '\uFFFD';
		}
		if (has(decodeMapNumeric, codePoint)) {
			if (strict) {
				parseError('disallowed character reference');
			}
			return decodeMapNumeric[codePoint];
		}
		if (strict && contains(invalidReferenceCodePoints, codePoint)) {
			parseError('disallowed character reference');
		}
		if (codePoint > 0xFFFF) {
			codePoint -= 0x10000;
			output += stringFromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
			codePoint = 0xDC00 | codePoint & 0x3FF;
		}
		output += stringFromCharCode(codePoint);
		return output;
	};

	var hexEscape = function(codePoint) {
		return '&#x' + codePoint.toString(16).toUpperCase() + ';';
	};

	var decEscape = function(codePoint) {
		return '&#' + codePoint + ';';
	};

	var parseError = function(message) {
		throw Error('Parse error: ' + message);
	};

	/*--------------------------------------------------------------------------*/

	var encode = function(string, options) {
		options = merge(options, encode.options);
		var strict = options.strict;
		if (strict && regexInvalidRawCodePoint.test(string)) {
			parseError('forbidden code point');
		}
		var encodeEverything = options.encodeEverything;
		var useNamedReferences = options.useNamedReferences;
		var allowUnsafeSymbols = options.allowUnsafeSymbols;
		var escapeCodePoint = options.decimal ? decEscape : hexEscape;

		var escapeBmpSymbol = function(symbol) {
			return escapeCodePoint(symbol.charCodeAt(0));
		};

		if (encodeEverything) {
			// Encode ASCII symbols.
			string = string.replace(regexAsciiWhitelist, function(symbol) {
				// Use named references if requested & possible.
				if (useNamedReferences && has(encodeMap, symbol)) {
					return '&' + encodeMap[symbol] + ';';
				}
				return escapeBmpSymbol(symbol);
			});
			// Shorten a few escapes that represent two symbols, of which at least one
			// is within the ASCII range.
			if (useNamedReferences) {
				string = string
					.replace(/&gt;\u20D2/g, '&nvgt;')
					.replace(/&lt;\u20D2/g, '&nvlt;')
					.replace(/&#x66;&#x6A;/g, '&fjlig;');
			}
			// Encode non-ASCII symbols.
			if (useNamedReferences) {
				// Encode non-ASCII symbols that can be replaced with a named reference.
				string = string.replace(regexEncodeNonAscii, function(string) {
					// Note: there is no need to check `has(encodeMap, string)` here.
					return '&' + encodeMap[string] + ';';
				});
			}
			// Note: any remaining non-ASCII symbols are handled outside of the `if`.
		} else if (useNamedReferences) {
			// Apply named character references.
			// Encode `<>"'&` using named character references.
			if (!allowUnsafeSymbols) {
				string = string.replace(regexEscape, function(string) {
					return '&' + encodeMap[string] + ';'; // no need to check `has()` here
				});
			}
			// Shorten escapes that represent two symbols, of which at least one is
			// `<>"'&`.
			string = string
				.replace(/&gt;\u20D2/g, '&nvgt;')
				.replace(/&lt;\u20D2/g, '&nvlt;');
			// Encode non-ASCII symbols that can be replaced with a named reference.
			string = string.replace(regexEncodeNonAscii, function(string) {
				// Note: there is no need to check `has(encodeMap, string)` here.
				return '&' + encodeMap[string] + ';';
			});
		} else if (!allowUnsafeSymbols) {
			// Encode `<>"'&` using hexadecimal escapes, now that they’re not handled
			// using named character references.
			string = string.replace(regexEscape, escapeBmpSymbol);
		}
		return string
			// Encode astral symbols.
			.replace(regexAstralSymbols, function($0) {
				// https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
				var high = $0.charCodeAt(0);
				var low = $0.charCodeAt(1);
				var codePoint = (high - 0xD800) * 0x400 + low - 0xDC00 + 0x10000;
				return escapeCodePoint(codePoint);
			})
			// Encode any remaining BMP symbols that are not printable ASCII symbols
			// using a hexadecimal escape.
			.replace(regexBmpWhitelist, escapeBmpSymbol);
	};
	// Expose default options (so they can be overridden globally).
	encode.options = {
		'allowUnsafeSymbols': false,
		'encodeEverything': false,
		'strict': false,
		'useNamedReferences': false,
		'decimal' : false
	};

	var decode = function(html, options) {
		options = merge(options, decode.options);
		var strict = options.strict;
		if (strict && regexInvalidEntity.test(html)) {
			parseError('malformed character reference');
		}
		return html.replace(regexDecode, function($0, $1, $2, $3, $4, $5, $6, $7, $8) {
			var codePoint;
			var semicolon;
			var decDigits;
			var hexDigits;
			var reference;
			var next;

			if ($1) {
				reference = $1;
				// Note: there is no need to check `has(decodeMap, reference)`.
				return decodeMap[reference];
			}

			if ($2) {
				// Decode named character references without trailing `;`, e.g. `&amp`.
				// This is only a parse error if it gets converted to `&`, or if it is
				// followed by `=` in an attribute context.
				reference = $2;
				next = $3;
				if (next && options.isAttributeValue) {
					if (strict && next == '=') {
						parseError('`&` did not start a character reference');
					}
					return $0;
				} else {
					if (strict) {
						parseError(
							'named character reference was not terminated by a semicolon'
						);
					}
					// Note: there is no need to check `has(decodeMapLegacy, reference)`.
					return decodeMapLegacy[reference] + (next || '');
				}
			}

			if ($4) {
				// Decode decimal escapes, e.g. `&#119558;`.
				decDigits = $4;
				semicolon = $5;
				if (strict && !semicolon) {
					parseError('character reference was not terminated by a semicolon');
				}
				codePoint = parseInt(decDigits, 10);
				return codePointToSymbol(codePoint, strict);
			}

			if ($6) {
				// Decode hexadecimal escapes, e.g. `&#x1D306;`.
				hexDigits = $6;
				semicolon = $7;
				if (strict && !semicolon) {
					parseError('character reference was not terminated by a semicolon');
				}
				codePoint = parseInt(hexDigits, 16);
				return codePointToSymbol(codePoint, strict);
			}

			// If we’re still here, `if ($7)` is implied; it’s an ambiguous
			// ampersand for sure. https://mths.be/notes/ambiguous-ampersands
			if (strict) {
				parseError(
					'named character reference was not terminated by a semicolon'
				);
			}
			return $0;
		});
	};
	// Expose default options (so they can be overridden globally).
	decode.options = {
		'isAttributeValue': false,
		'strict': false
	};

	var escape = function(string) {
		return string.replace(regexEscape, function($0) {
			// Note: there is no need to check `has(escapeMap, $0)` here.
			return escapeMap[$0];
		});
	};

	/*--------------------------------------------------------------------------*/

	var he = {
		'version': '1.2.0',
		'encode': encode,
		'decode': decode,
		'escape': escape,
		'unescape': decode
	};

	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
			return he;
		}).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}	else { var key; }

}(this));


/***/ }),

/***/ 7207:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const isObject = __webpack_require__(3710)

function humanizeGraphQLResponse (input) {
  if (!input) return null
  const output = {}

  Object.keys(input).forEach(key => {
    if (input[key] && input[key].edges) {
      output[key] = input[key].edges.map(edge => humanizeGraphQLResponse(edge.node))
    } else if (isObject(input[key])) {
      output[key] = humanizeGraphQLResponse(input[key])
    } else {
      output[key] = input[key]
    }
  })

  return output
}

module.exports = humanizeGraphQLResponse


/***/ }),

/***/ 3710:
/***/ (function(module) {

module.exports = function isObject (obj) {
  return obj !== null && typeof obj === 'object' && !Array.isArray(obj)
}


/***/ }),

/***/ 8898:
/***/ (function(__unused_webpack_module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 3812:
/***/ (function(module) {

// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;

var NEWLINE_REGEX = /\n/g;
var WHITESPACE_REGEX = /^\s*/;

// declaration
var PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var COLON_REGEX = /^:\s*/;
var VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var SEMICOLON_REGEX = /^[;\s]*/;

// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var TRIM_REGEX = /^\s+|\s+$/g;

// strings
var NEWLINE = '\n';
var FORWARD_SLASH = '/';
var ASTERISK = '*';
var EMPTY_STRING = '';

// types
var TYPE_COMMENT = 'comment';
var TYPE_DECLARATION = 'declaration';

/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */
module.exports = function(style, options) {
  if (typeof style !== 'string') {
    throw new TypeError('First argument must be a string');
  }

  if (!style) return [];

  options = options || {};

  /**
   * Positional.
   */
  var lineno = 1;
  var column = 1;

  /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */
  function updatePosition(str) {
    var lines = str.match(NEWLINE_REGEX);
    if (lines) lineno += lines.length;
    var i = str.lastIndexOf(NEWLINE);
    column = ~i ? str.length - i : column + str.length;
  }

  /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */
  function position() {
    var start = { line: lineno, column: column };
    return function(node) {
      node.position = new Position(start);
      whitespace();
      return node;
    };
  }

  /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */
  function Position(start) {
    this.start = start;
    this.end = { line: lineno, column: column };
    this.source = options.source;
  }

  /**
   * Non-enumerable source string.
   */
  Position.prototype.content = style;

  var errorsList = [];

  /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */
  function error(msg) {
    var err = new Error(
      options.source + ':' + lineno + ':' + column + ': ' + msg
    );
    err.reason = msg;
    err.filename = options.source;
    err.line = lineno;
    err.column = column;
    err.source = style;

    if (options.silent) {
      errorsList.push(err);
    } else {
      throw err;
    }
  }

  /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */
  function match(re) {
    var m = re.exec(style);
    if (!m) return;
    var str = m[0];
    updatePosition(str);
    style = style.slice(str.length);
    return m;
  }

  /**
   * Parse whitespace.
   */
  function whitespace() {
    match(WHITESPACE_REGEX);
  }

  /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */
  function comments(rules) {
    var c;
    rules = rules || [];
    while ((c = comment())) {
      if (c !== false) {
        rules.push(c);
      }
    }
    return rules;
  }

  /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */
  function comment() {
    var pos = position();
    if (FORWARD_SLASH != style.charAt(0) || ASTERISK != style.charAt(1)) return;

    var i = 2;
    while (
      EMPTY_STRING != style.charAt(i) &&
      (ASTERISK != style.charAt(i) || FORWARD_SLASH != style.charAt(i + 1))
    ) {
      ++i;
    }
    i += 2;

    if (EMPTY_STRING === style.charAt(i - 1)) {
      return error('End of comment missing');
    }

    var str = style.slice(2, i - 2);
    column += 2;
    updatePosition(str);
    style = style.slice(i);
    column += 2;

    return pos({
      type: TYPE_COMMENT,
      comment: str
    });
  }

  /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */
  function declaration() {
    var pos = position();

    // prop
    var prop = match(PROPERTY_REGEX);
    if (!prop) return;
    comment();

    // :
    if (!match(COLON_REGEX)) return error("property missing ':'");

    // val
    var val = match(VALUE_REGEX);

    var ret = pos({
      type: TYPE_DECLARATION,
      property: trim(prop[0].replace(COMMENT_REGEX, EMPTY_STRING)),
      value: val
        ? trim(val[0].replace(COMMENT_REGEX, EMPTY_STRING))
        : EMPTY_STRING
    });

    // ;
    match(SEMICOLON_REGEX);

    return ret;
  }

  /**
   * Parse declarations.
   *
   * @return {Object[]}
   */
  function declarations() {
    var decls = [];

    comments(decls);

    // declarations
    var decl;
    while ((decl = declaration())) {
      if (decl !== false) {
        decls.push(decl);
        comments(decls);
      }
    }

    return decls;
  }

  whitespace();
  return declarations();
};

/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */
function trim(str) {
  return str ? str.replace(TRIM_REGEX, EMPTY_STRING) : EMPTY_STRING;
}


/***/ }),

/***/ 3299:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Q=Object.create;var T=Object.defineProperty;var X=Object.getOwnPropertyDescriptor;var tt=Object.getOwnPropertyNames;var et=Object.getPrototypeOf,it=Object.prototype.hasOwnProperty;var nt=(h,c)=>()=>(c||h((c={exports:{}}).exports,c),c.exports),ot=(h,c)=>{for(var v in c)T(h,v,{get:c[v],enumerable:!0})},K=(h,c,v,m)=>{if(c&&typeof c=="object"||typeof c=="function")for(let _ of tt(c))!it.call(h,_)&&_!==v&&T(h,_,{get:()=>c[_],enumerable:!(m=X(c,_))||m.enumerable});return h};var B=(h,c,v)=>(v=h!=null?Q(et(h)):{},K(c||!h||!h.__esModule?T(v,"default",{value:h,enumerable:!0}):v,h)),rt=h=>K(T({},"__esModule",{value:!0}),h);var z=nt((ut,F)=>{(function(h){typeof F=="object"&&F.exports?F.exports=h():window.intlTelInput=h()})(function(h){"use strict";return function(){for(var c=[["Afghanistan","af","93"],["Albania","al","355"],["Algeria","dz","213"],["American Samoa","as","1",5,["684"]],["Andorra","ad","376"],["Angola","ao","244"],["Anguilla","ai","1",6,["264"]],["Antigua & Barbuda","ag","1",7,["268"]],["Argentina","ar","54"],["Armenia","am","374"],["Aruba","aw","297"],["Ascension Island","ac","247"],["Australia","au","61",0],["Austria","at","43"],["Azerbaijan","az","994"],["Bahamas","bs","1",8,["242"]],["Bahrain","bh","973"],["Bangladesh","bd","880"],["Barbados","bb","1",9,["246"]],["Belarus","by","375"],["Belgium","be","32"],["Belize","bz","501"],["Benin","bj","229"],["Bermuda","bm","1",10,["441"]],["Bhutan","bt","975"],["Bolivia","bo","591"],["Bosnia & Herzegovina","ba","387"],["Botswana","bw","267"],["Brazil","br","55"],["British Indian Ocean Territory","io","246"],["British Virgin Islands","vg","1",11,["284"]],["Brunei","bn","673"],["Bulgaria","bg","359"],["Burkina Faso","bf","226"],["Burundi","bi","257"],["Cambodia","kh","855"],["Cameroon","cm","237"],["Canada","ca","1",1,["204","226","236","249","250","263","289","306","343","354","365","367","368","382","387","403","416","418","428","431","437","438","450","584","468","474","506","514","519","548","579","581","584","587","604","613","639","647","672","683","705","709","742","753","778","780","782","807","819","825","867","873","902","905"]],["Cape Verde","cv","238"],["Caribbean Netherlands","bq","599",1,["3","4","7"]],["Cayman Islands","ky","1",12,["345"]],["Central African Republic","cf","236"],["Chad","td","235"],["Chile","cl","56"],["China","cn","86"],["Christmas Island","cx","61",2,["89164"]],["Cocos (Keeling) Islands","cc","61",1,["89162"]],["Colombia","co","57"],["Comoros","km","269"],["Congo - Brazzaville","cg","242"],["Congo - Kinshasa","cd","243"],["Cook Islands","ck","682"],["Costa Rica","cr","506"],["C\xF4te d\u2019Ivoire","ci","225"],["Croatia","hr","385"],["Cuba","cu","53"],["Cura\xE7ao","cw","599",0],["Cyprus","cy","357"],["Czech Republic","cz","420"],["Denmark","dk","45"],["Djibouti","dj","253"],["Dominica","dm","1",13,["767"]],["Dominican Republic","do","1",2,["809","829","849"]],["Ecuador","ec","593"],["Egypt","eg","20"],["El Salvador","sv","503"],["Equatorial Guinea","gq","240"],["Eritrea","er","291"],["Estonia","ee","372"],["Eswatini","sz","268"],["Ethiopia","et","251"],["Falkland Islands","fk","500"],["Faroe Islands","fo","298"],["Fiji","fj","679"],["Finland","fi","358",0],["France","fr","33"],["French Guiana","gf","594"],["French Polynesia","pf","689"],["Gabon","ga","241"],["Gambia","gm","220"],["Georgia","ge","995"],["Germany","de","49"],["Ghana","gh","233"],["Gibraltar","gi","350"],["Greece","gr","30"],["Greenland","gl","299"],["Grenada","gd","1",14,["473"]],["Guadeloupe","gp","590",0],["Guam","gu","1",15,["671"]],["Guatemala","gt","502"],["Guernsey","gg","44",1,["1481","7781","7839","7911"]],["Guinea","gn","224"],["Guinea-Bissau","gw","245"],["Guyana","gy","592"],["Haiti","ht","509"],["Honduras","hn","504"],["Hong Kong","hk","852"],["Hungary","hu","36"],["Iceland","is","354"],["India","in","91"],["Indonesia","id","62"],["Iran","ir","98"],["Iraq","iq","964"],["Ireland","ie","353"],["Isle of Man","im","44",2,["1624","74576","7524","7924","7624"]],["Israel","il","972"],["Italy","it","39",0],["Jamaica","jm","1",4,["876","658"]],["Japan","jp","81"],["Jersey","je","44",3,["1534","7509","7700","7797","7829","7937"]],["Jordan","jo","962"],["Kazakhstan","kz","7",1,["33","7"]],["Kenya","ke","254"],["Kiribati","ki","686"],["Kosovo","xk","383"],["Kuwait","kw","965"],["Kyrgyzstan","kg","996"],["Laos","la","856"],["Latvia","lv","371"],["Lebanon","lb","961"],["Lesotho","ls","266"],["Liberia","lr","231"],["Libya","ly","218"],["Liechtenstein","li","423"],["Lithuania","lt","370"],["Luxembourg","lu","352"],["Macau","mo","853"],["Madagascar","mg","261"],["Malawi","mw","265"],["Malaysia","my","60"],["Maldives","mv","960"],["Mali","ml","223"],["Malta","mt","356"],["Marshall Islands","mh","692"],["Martinique","mq","596"],["Mauritania","mr","222"],["Mauritius","mu","230"],["Mayotte","yt","262",1,["269","639"]],["Mexico","mx","52"],["Micronesia","fm","691"],["Moldova","md","373"],["Monaco","mc","377"],["Mongolia","mn","976"],["Montenegro","me","382"],["Montserrat","ms","1",16,["664"]],["Morocco","ma","212",0],["Mozambique","mz","258"],["Myanmar (Burma)","mm","95"],["Namibia","na","264"],["Nauru","nr","674"],["Nepal","np","977"],["Netherlands","nl","31"],["New Caledonia","nc","687"],["New Zealand","nz","64"],["Nicaragua","ni","505"],["Niger","ne","227"],["Nigeria","ng","234"],["Niue","nu","683"],["Norfolk Island","nf","672"],["North Korea","kp","850"],["North Macedonia","mk","389"],["Northern Mariana Islands","mp","1",17,["670"]],["Norway","no","47",0],["Oman","om","968"],["Pakistan","pk","92"],["Palau","pw","680"],["Palestine","ps","970"],["Panama","pa","507"],["Papua New Guinea","pg","675"],["Paraguay","py","595"],["Peru","pe","51"],["Philippines","ph","63"],["Poland","pl","48"],["Portugal","pt","351"],["Puerto Rico","pr","1",3,["787","939"]],["Qatar","qa","974"],["R\xE9union","re","262",0],["Romania","ro","40"],["Russia","ru","7",0],["Rwanda","rw","250"],["Samoa","ws","685"],["San Marino","sm","378"],["S\xE3o Tom\xE9 & Pr\xEDncipe","st","239"],["Saudi Arabia","sa","966"],["Senegal","sn","221"],["Serbia","rs","381"],["Seychelles","sc","248"],["Sierra Leone","sl","232"],["Singapore","sg","65"],["Sint Maarten","sx","1",21,["721"]],["Slovakia","sk","421"],["Slovenia","si","386"],["Solomon Islands","sb","677"],["Somalia","so","252"],["South Africa","za","27"],["South Korea","kr","82"],["South Sudan","ss","211"],["Spain","es","34"],["Sri Lanka","lk","94"],["St Barth\xE9lemy","bl","590",1],["St Helena","sh","290"],["St Kitts & Nevis","kn","1",18,["869"]],["St Lucia","lc","1",19,["758"]],["St Martin","mf","590",2],["St Pierre & Miquelon","pm","508"],["St Vincent & Grenadines","vc","1",20,["784"]],["Sudan","sd","249"],["Suriname","sr","597"],["Svalbard & Jan Mayen","sj","47",1,["79"]],["Sweden","se","46"],["Switzerland","ch","41"],["Syria","sy","963"],["Taiwan","tw","886"],["Tajikistan","tj","992"],["Tanzania","tz","255"],["Thailand","th","66"],["Timor-Leste","tl","670"],["Togo","tg","228"],["Tokelau","tk","690"],["Tonga","to","676"],["Trinidad & Tobago","tt","1",22,["868"]],["Tunisia","tn","216"],["Turkey","tr","90"],["Turkmenistan","tm","993"],["Turks & Caicos Islands","tc","1",23,["649"]],["Tuvalu","tv","688"],["Uganda","ug","256"],["Ukraine","ua","380"],["United Arab Emirates","ae","971"],["United Kingdom","gb","44",0],["United States","us","1",0],["Uruguay","uy","598"],["US Virgin Islands","vi","1",24,["340"]],["Uzbekistan","uz","998"],["Vanuatu","vu","678"],["Vatican City","va","39",1,["06698"]],["Venezuela","ve","58"],["Vietnam","vn","84"],["Wallis & Futuna","wf","681"],["Western Sahara","eh","212",1,["5288","5289"]],["Yemen","ye","967"],["Zambia","zm","260"],["Zimbabwe","zw","263"],["\xC5land Islands","ax","358",1,["18"]]],v=0;v<c.length;v++){var m=c[v];c[v]={name:m[0],iso2:m[1],dialCode:m[2],priority:m[3]||0,areaCodes:m[4]||null,nodeById:{}}}function _(s){for(var n=1;n<arguments.length;n++){var t=arguments[n]!=null?Object(arguments[n]):{},e=Object.keys(t);typeof Object.getOwnPropertySymbols=="function"&&e.push.apply(e,Object.getOwnPropertySymbols(t).filter(function(i){return Object.getOwnPropertyDescriptor(t,i).enumerable})),e.forEach(function(i){P(s,i,t[i])})}return s}function P(s,n,t){return n=D(n),n in s?Object.defineProperty(s,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):s[n]=t,s}function x(s,n){return C(s)||I(s,n)||U(s,n)||O()}function O(){throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`)}function U(s,n){if(s){if(typeof s=="string")return k(s,n);var t=Object.prototype.toString.call(s).slice(8,-1);if(t==="Object"&&s.constructor&&(t=s.constructor.name),t==="Map"||t==="Set")return Array.from(s);if(t==="Arguments"||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))return k(s,n)}}function k(s,n){(n==null||n>s.length)&&(n=s.length);for(var t=0,e=new Array(n);t<n;t++)e[t]=s[t];return e}function I(s,n){var t=s==null?null:typeof Symbol<"u"&&s[Symbol.iterator]||s["@@iterator"];if(t!=null){var e,i,o,r,a=[],l=!0,u=!1;try{if(o=(t=t.call(s)).next,n===0){if(Object(t)!==t)return;l=!1}else for(;!(l=(e=o.call(t)).done)&&(a.push(e.value),a.length!==n);l=!0);}catch(p){u=!0,i=p}finally{try{if(!l&&t.return!=null&&(r=t.return(),Object(r)!==r))return}finally{if(u)throw i}}return a}}function C(s){if(Array.isArray(s))return s}function L(s,n){if(!(s instanceof n))throw new TypeError("Cannot call a class as a function")}function b(s,n){for(var t=0;t<n.length;t++){var e=n[t];e.enumerable=e.enumerable||!1,e.configurable=!0,"value"in e&&(e.writable=!0),Object.defineProperty(s,D(e.key),e)}}function M(s,n,t){return n&&b(s.prototype,n),t&&b(s,t),Object.defineProperty(s,"prototype",{writable:!1}),s}function D(s){var n=H(s,"string");return typeof n=="symbol"?n:String(n)}function H(s,n){if(typeof s!="object"||s===null)return s;var t=s[Symbol.toPrimitive];if(t!==h){var e=t.call(s,n||"default");if(typeof e!="object")return e;throw new TypeError("@@toPrimitive must return a primitive value.")}return(n==="string"?String:Number)(s)}var S={getInstance:function(n){var t=n.getAttribute("data-intl-tel-input-id");return window.intlTelInputGlobals.instances[t]},instances:{},documentReady:function(){return document.readyState==="complete"}};typeof window=="object"&&(window.intlTelInputGlobals=S);var W=0,G={allowDropdown:!0,autoInsertDialCode:!1,autoPlaceholder:"polite",countrySearch:!0,containerClass:"",customPlaceholder:null,dropdownContainer:null,excludeCountries:[],fixDropdownWidth:!0,formatAsYouType:!0,formatOnDisplay:!0,geoIpLookup:null,hiddenInput:null,i18n:{},initialCountry:"",nationalMode:!0,onlyCountries:[],placeholderNumberType:"MOBILE",preferredCountries:[],showFlags:!0,showSelectedDialCode:!1,useFullscreenPopup:typeof navigator<"u"&&typeof window<"u"?/Android.+Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)||window.innerWidth<=500:!1,utilsScript:""},q=["800","822","833","844","855","866","877","880","881","882","883","884","885","886","887","888","889"],E=function(n){var t=window.intlTelInputGlobals.instances;Object.values(t).forEach(function(e){return e[n]()})},Y=function(){function s(n){var t=arguments.length>1&&arguments[1]!==h?arguments[1]:{};L(this,s),this.id=W++,this.telInput=n,this.activeItem=null,this.highlightedItem=null,this.options=Object.assign({},G,t),this.hadInitialPlaceholder=!!n.getAttribute("placeholder")}return M(s,[{key:"_init",value:function(){var t=this;this.options.useFullscreenPopup&&(this.options.fixDropdownWidth=!1),this.options.countrySearch&&!this.options.useFullscreenPopup&&(this.options.fixDropdownWidth=!0),this.options.nationalMode&&(this.options.autoInsertDialCode=!1),this.options.showSelectedDialCode&&(this.options.autoInsertDialCode=!1);var e=this.options.allowDropdown&&!this.options.showSelectedDialCode;if(!this.options.showFlags&&e&&(this.options.showFlags=!0),this.options.useFullscreenPopup&&!this.options.dropdownContainer&&(this.options.dropdownContainer=document.body),this.isRTL=!!this.telInput.closest("[dir=rtl]"),typeof Promise<"u"){var i=new Promise(function(r,a){t.resolveAutoCountryPromise=r,t.rejectAutoCountryPromise=a}),o=new Promise(function(r,a){t.resolveUtilsScriptPromise=r,t.rejectUtilsScriptPromise=a});this.promise=Promise.all([i,o])}else this.resolveAutoCountryPromise=this.rejectAutoCountryPromise=function(){},this.resolveUtilsScriptPromise=this.rejectUtilsScriptPromise=function(){};this.selectedCountryData={},this._processCountryData(),this._generateMarkup(),this._setInitialState(),this._initListeners(),this._initRequests()}},{key:"_processCountryData",value:function(){this._processAllCountries(),this._processCountryCodes(),this._processPreferredCountries(),this._translateCountryNames(),(this.options.onlyCountries.length||this.options.i18n)&&this.countries.sort(this._countryNameSort)}},{key:"_addCountryCode",value:function(t,e,i){e.length>this.countryCodeMaxLen&&(this.countryCodeMaxLen=e.length),this.countryCodes.hasOwnProperty(e)||(this.countryCodes[e]=[]);for(var o=0;o<this.countryCodes[e].length;o++)if(this.countryCodes[e][o]===t)return;var r=i!==h?i:this.countryCodes[e].length;this.countryCodes[e][r]=t}},{key:"_processAllCountries",value:function(){if(this.options.onlyCountries.length){var t=this.options.onlyCountries.map(function(i){return i.toLowerCase()});this.countries=c.filter(function(i){return t.indexOf(i.iso2)>-1})}else if(this.options.excludeCountries.length){var e=this.options.excludeCountries.map(function(i){return i.toLowerCase()});this.countries=c.filter(function(i){return e.indexOf(i.iso2)===-1})}else this.countries=c}},{key:"_translateCountryNames",value:function(){for(var t=0;t<this.countries.length;t++){var e=this.countries[t].iso2.toLowerCase();this.options.i18n.hasOwnProperty(e)&&(this.countries[t].name=this.options.i18n[e])}}},{key:"_countryNameSort",value:function(t,e){return t.name<e.name?-1:t.name>e.name?1:0}},{key:"_processCountryCodes",value:function(){this.countryCodeMaxLen=0,this.dialCodes={},this.countryCodes={};for(var t=0;t<this.countries.length;t++){var e=this.countries[t];this.dialCodes[e.dialCode]||(this.dialCodes[e.dialCode]=!0),this._addCountryCode(e.iso2,e.dialCode,e.priority)}for(var i=0;i<this.countries.length;i++){var o=this.countries[i];if(o.areaCodes)for(var r=this.countryCodes[o.dialCode][0],a=0;a<o.areaCodes.length;a++){for(var l=o.areaCodes[a],u=1;u<l.length;u++){var p=o.dialCode+l.substr(0,u);this._addCountryCode(r,p),this._addCountryCode(o.iso2,p)}this._addCountryCode(o.iso2,o.dialCode+l)}}}},{key:"_processPreferredCountries",value:function(){this.preferredCountries=[];for(var t=0;t<this.options.preferredCountries.length;t++){var e=this.options.preferredCountries[t].toLowerCase(),i=this._getCountryData(e,!1,!0);i&&this.preferredCountries.push(i)}}},{key:"_createEl",value:function(t,e,i){var o=document.createElement(t);return e&&Object.entries(e).forEach(function(r){var a=x(r,2),l=a[0],u=a[1];return o.setAttribute(l,u)}),i&&i.appendChild(o),o}},{key:"_generateMarkup",value:function(){this.telInput.classList.add("iti__tel-input"),!this.telInput.hasAttribute("autocomplete")&&!(this.telInput.form&&this.telInput.form.hasAttribute("autocomplete"))&&this.telInput.setAttribute("autocomplete","off");var t=this.options,e=t.allowDropdown,i=t.showSelectedDialCode,o=t.showFlags,r=t.containerClass,a=t.hiddenInput,l=t.dropdownContainer,u=t.fixDropdownWidth,p=t.useFullscreenPopup,g=t.countrySearch,f="iti";e&&(f+=" iti--allow-dropdown"),i&&(f+=" iti--show-selected-dial-code"),o&&(f+=" iti--show-flags"),r&&(f+=" ".concat(r)),p||(f+=" iti--inline-dropdown");var y=this._createEl("div",{class:f});this.telInput.parentNode.insertBefore(y,this.telInput);var A=e||o||i;if(A&&(this.flagsContainer=this._createEl("div",{class:"iti__flag-container"},y)),y.appendChild(this.telInput),A&&(this.selectedFlag=this._createEl("div",_({class:"iti__selected-flag"},e&&{role:"combobox","aria-haspopup":"listbox","aria-controls":"iti-".concat(this.id,"__country-listbox"),"aria-expanded":"false","aria-label":this.options.i18n.selectedCountryAriaLabel||"Selected country"}),this.flagsContainer)),o&&(this.selectedFlagInner=this._createEl("div",{class:"iti__flag"},this.selectedFlag)),this.selectedFlag&&this.telInput.disabled&&this.selectedFlag.setAttribute("aria-disabled","true"),i&&(this.selectedDialCode=this._createEl("div",{class:"iti__selected-dial-code"},this.selectedFlag)),e){this.telInput.disabled||this.selectedFlag.setAttribute("tabindex","0"),this.dropdownArrow=this._createEl("div",{class:"iti__arrow"},this.selectedFlag);var J=u?"":"iti--flexible-dropdown-width";if(this.dropdownContent=this._createEl("div",{class:"iti__dropdown-content iti__hide ".concat(J)}),g&&(this.searchInput=this._createEl("input",{type:"text",class:"iti__search-input",placeholder:this.options.i18n.searchPlaceholder||"Search"},this.dropdownContent)),this.countryList=this._createEl("ul",{class:"iti__country-list",id:"iti-".concat(this.id,"__country-listbox"),role:"listbox","aria-label":this.options.i18n.countryListAriaLabel||"List of countries"},this.dropdownContent),this.preferredCountries.length&&!g&&(this._appendListItems(this.preferredCountries,"iti__preferred",!0),this._createEl("li",{class:"iti__divider","aria-hidden":"true"},this.countryList)),this._appendListItems(this.countries,"iti__standard"),l){var N="iti iti--container";p?N+=" iti--fullscreen-popup":N+=" iti--inline-dropdown",g&&(N+=" iti--country-search"),this.dropdown=this._createEl("div",{class:N}),this.dropdown.appendChild(this.dropdownContent)}else this.flagsContainer.appendChild(this.dropdownContent)}if(a){var Z=this.telInput.getAttribute("name"),$=a(Z);this.hiddenInput=this._createEl("input",{type:"hidden",name:$}),y.appendChild(this.hiddenInput)}}},{key:"_appendListItems",value:function(t,e,i){for(var o=0;o<t.length;o++){var r=t[o],a=i?"-preferred":"",l=this._createEl("li",{id:"iti-".concat(this.id,"__item-").concat(r.iso2).concat(a),class:"iti__country ".concat(e),tabindex:"-1",role:"option","data-dial-code":r.dialCode,"data-country-code":r.iso2,"aria-selected":"false"},this.countryList);r.nodeById[this.id]=l;var u="";this.options.showFlags&&(u+="<div class='iti__flag-box'><div class='iti__flag iti__".concat(r.iso2,"'></div></div>")),u+="<span class='iti__country-name'>".concat(r.name,"</span>"),u+="<span class='iti__dial-code'>+".concat(r.dialCode,"</span>"),l.insertAdjacentHTML("beforeend",u)}}},{key:"_setInitialState",value:function(){var t=this.telInput.getAttribute("value"),e=this.telInput.value,i=t&&t.charAt(0)==="+"&&(!e||e.charAt(0)!=="+"),o=i?t:e,r=this._getDialCode(o),a=this._isRegionlessNanp(o),l=this.options,u=l.initialCountry,p=l.autoInsertDialCode;if(r&&!a)this._updateFlagFromNumber(o);else if(u!=="auto"){var g=u&&this._getCountryData(u,!1,!0);g?this._setFlag(u.toLowerCase()):r&&a?this._setFlag("us"):(this.defaultCountry=this.preferredCountries.length?this.preferredCountries[0].iso2:this.countries[0].iso2,o||this._setFlag(this.defaultCountry)),!o&&p&&(this.telInput.value="+".concat(this.selectedCountryData.dialCode))}o&&this._updateValFromNumber(o)}},{key:"_initListeners",value:function(){this._initKeyListeners(),this.options.autoInsertDialCode&&this._initBlurListeners(),this.options.allowDropdown&&this._initDropdownListeners(),this.hiddenInput&&this._initHiddenInputListener()}},{key:"_initHiddenInputListener",value:function(){var t=this;this._handleHiddenInputSubmit=function(){t.hiddenInput.value=t.getNumber()},this.telInput.form&&this.telInput.form.addEventListener("submit",this._handleHiddenInputSubmit)}},{key:"_initDropdownListeners",value:function(){var t=this;this._handleLabelClick=function(i){t.dropdownContent.classList.contains("iti__hide")?t.telInput.focus():i.preventDefault()};var e=this.telInput.closest("label");e&&e.addEventListener("click",this._handleLabelClick),this._handleClickSelectedFlag=function(){t.dropdownContent.classList.contains("iti__hide")&&!t.telInput.disabled&&!t.telInput.readOnly&&t._showDropdown()},this.selectedFlag.addEventListener("click",this._handleClickSelectedFlag),this._handleFlagsContainerKeydown=function(i){var o=t.dropdownContent.classList.contains("iti__hide");o&&["ArrowUp","ArrowDown"," ","Enter"].includes(i.key)&&(i.preventDefault(),i.stopPropagation(),t._showDropdown()),i.key==="Tab"&&t._closeDropdown()},this.flagsContainer.addEventListener("keydown",this._handleFlagsContainerKeydown)}},{key:"_initRequests",value:function(){var t=this;this.options.utilsScript&&!window.intlTelInputUtils?window.intlTelInputGlobals.documentReady()?window.intlTelInputGlobals.loadUtils(this.options.utilsScript):window.addEventListener("load",function(){window.intlTelInputGlobals.loadUtils(t.options.utilsScript)}):this.resolveUtilsScriptPromise(),this.options.initialCountry==="auto"?this._loadAutoCountry():this.resolveAutoCountryPromise()}},{key:"_loadAutoCountry",value:function(){window.intlTelInputGlobals.autoCountry?this.handleAutoCountry():window.intlTelInputGlobals.startedLoadingAutoCountry||(window.intlTelInputGlobals.startedLoadingAutoCountry=!0,typeof this.options.geoIpLookup=="function"&&this.options.geoIpLookup(function(t){window.intlTelInputGlobals.autoCountry=t.toLowerCase(),setTimeout(function(){return E("handleAutoCountry")})},function(){return E("rejectAutoCountryPromise")}))}},{key:"_initKeyListeners",value:function(){var t=this,e=!1;this._handleKeyEvent=function(i){if(t._updateFlagFromNumber(t.telInput.value)&&t._triggerCountryChange(),i&&i.data&&/[^+0-9]/.test(i.data)?e=!0:/[^+0-9]/.test(t.telInput.value)||(e=!1),t.options.formatAsYouType&&!e){var o=t.telInput.selectionStart,r=t.telInput.value.substring(0,o),a=r.replace(/[^+0-9]/g,"").length,l=i&&i.inputType==="deleteContentForward",u=t._formatNumberAsYouType(),p=t._translateCursorPosition(a,u,o,l);t.telInput.value=u,t.telInput.setSelectionRange(p,p)}},this.telInput.addEventListener("input",this._handleKeyEvent),this._handleClipboardEvent=function(){setTimeout(t._handleKeyEvent)},this.telInput.addEventListener("cut",this._handleClipboardEvent),this.telInput.addEventListener("paste",this._handleClipboardEvent)}},{key:"_translateCursorPosition",value:function(t,e,i,o){if(i===0&&!o)return 0;for(var r=0,a=0;a<e.length;a++){if(/[+0-9]/.test(e[a])&&r++,r===t&&!o)return a+1;if(o&&r===t+1)return a}return e.length}},{key:"_cap",value:function(t){var e=this.telInput.getAttribute("maxlength");return e&&t.length>e?t.substr(0,e):t}},{key:"_initBlurListeners",value:function(){var t=this;this._handleSubmitOrBlurEvent=function(){t._removeEmptyDialCode()},this.telInput.form&&this.telInput.form.addEventListener("submit",this._handleSubmitOrBlurEvent),this.telInput.addEventListener("blur",this._handleSubmitOrBlurEvent)}},{key:"_removeEmptyDialCode",value:function(){if(this.telInput.value.charAt(0)==="+"){var t=this._getNumeric(this.telInput.value);(!t||this.selectedCountryData.dialCode===t)&&(this.telInput.value="")}}},{key:"_getNumeric",value:function(t){return t.replace(/\D/g,"")}},{key:"_trigger",value:function(t){var e=new Event(t,{bubbles:!0,cancelable:!0});this.telInput.dispatchEvent(e)}},{key:"_showDropdown",value:function(){if(this.options.fixDropdownWidth&&(this.dropdownContent.style.width="".concat(this.telInput.offsetWidth,"px")),this.dropdownContent.classList.remove("iti__hide"),this.selectedFlag.setAttribute("aria-expanded","true"),this._setDropdownPosition(),this.options.countrySearch){var t=this.countryList.firstElementChild;t&&this._highlightListItem(t,!1),this.searchInput.focus()}else this.activeItem&&(this._highlightListItem(this.activeItem,!1),this._scrollTo(this.activeItem,!0));this._bindDropdownListeners(),this.dropdownArrow.classList.add("iti__arrow--up"),this._trigger("open:countrydropdown")}},{key:"_toggleClass",value:function(t,e,i){i&&!t.classList.contains(e)?t.classList.add(e):!i&&t.classList.contains(e)&&t.classList.remove(e)}},{key:"_setDropdownPosition",value:function(){var t=this;if(this.options.dropdownContainer&&this.options.dropdownContainer.appendChild(this.dropdown),!this.options.useFullscreenPopup){var e=this.telInput.getBoundingClientRect(),i=document.documentElement.scrollTop,o=e.top+i,r=this.dropdownContent.offsetHeight,a=o+this.telInput.offsetHeight+r<i+window.innerHeight,l=o-r>i,u=!this.options.countrySearch&&!a&&l;if(this._toggleClass(this.dropdownContent,"iti__dropdown-content--dropup",u),this.options.dropdownContainer){var p=u?0:this.telInput.offsetHeight;this.dropdown.style.top="".concat(o+p,"px"),this.dropdown.style.left="".concat(e.left+document.body.scrollLeft,"px"),this._handleWindowScroll=function(){return t._closeDropdown()},window.addEventListener("scroll",this._handleWindowScroll)}}}},{key:"_bindDropdownListeners",value:function(){var t=this;this._handleMouseoverCountryList=function(l){var u=l.target.closest(".iti__country");u&&t._highlightListItem(u,!1)},this.countryList.addEventListener("mouseover",this._handleMouseoverCountryList),this._handleClickCountryList=function(l){var u=l.target.closest(".iti__country");u&&t._selectListItem(u)},this.countryList.addEventListener("click",this._handleClickCountryList);var e=!0;this._handleClickOffToClose=function(){e||t._closeDropdown(),e=!1},document.documentElement.addEventListener("click",this._handleClickOffToClose);var i="",o=null;if(this._handleKeydownOnDropdown=function(l){["ArrowUp","ArrowDown","Enter","Escape"].includes(l.key)&&(l.preventDefault(),l.stopPropagation(),l.key==="ArrowUp"||l.key==="ArrowDown"?t._handleUpDownKey(l.key):l.key==="Enter"?t._handleEnterKey():l.key==="Escape"&&t._closeDropdown()),!t.options.countrySearch&&/^[a-zA-ZÀ-ÿа-яА-Я ]$/.test(l.key)&&(l.stopPropagation(),o&&clearTimeout(o),i+=l.key.toLowerCase(),t._searchForCountry(i),o=setTimeout(function(){i=""},1e3))},document.addEventListener("keydown",this._handleKeydownOnDropdown),this.options.countrySearch){var r=function(){var u=t.searchInput.value.trim();u?t._filterCountries(u):t._filterCountries("",!0)},a=null;this._handleSearchChange=function(){a&&clearTimeout(a),a=setTimeout(function(){r(),a=null},100)},this.searchInput.addEventListener("input",this._handleSearchChange),this.searchInput.addEventListener("click",function(l){return l.stopPropagation()})}}},{key:"_normaliseString",value:function(){var t=arguments.length>0&&arguments[0]!==h?arguments[0]:"";return t.normalize("NFD").replace(/[\u0300-\u036f]/g,"").toLowerCase()}},{key:"_filterCountries",value:function(t){var e=arguments.length>1&&arguments[1]!==h?arguments[1]:!1,i=!0;this.countryList.innerHTML="";for(var o=this._normaliseString(t),r=0;r<this.countries.length;r++){var a=this.countries[r],l=this._normaliseString(a.name),u="+".concat(a.dialCode);(e||l.includes(o)||u.includes(o)||a.iso2.includes(o))&&(this.countryList.appendChild(a.nodeById[this.id]),i&&(this._highlightListItem(a.nodeById[this.id],!1),i=!1))}}},{key:"_handleUpDownKey",value:function(t){var e=t==="ArrowUp"?this.highlightedItem.previousElementSibling:this.highlightedItem.nextElementSibling;if(e?e.classList.contains("iti__divider")&&(e=t==="ArrowUp"?e.previousElementSibling:e.nextElementSibling):this.countryList.childElementCount>1&&(e=t==="ArrowUp"?this.countryList.lastElementChild:this.countryList.firstElementChild),e){var i=!this.options.countrySearch;this._highlightListItem(e,i),this.options.countrySearch&&this._scrollTo(e,!1)}}},{key:"_handleEnterKey",value:function(){this.highlightedItem&&this._selectListItem(this.highlightedItem)}},{key:"_searchForCountry",value:function(t){for(var e=0;e<this.countries.length;e++)if(this._startsWith(this.countries[e].name,t)){var i=this.countries[e].nodeById[this.id];this._highlightListItem(i,!1),this._scrollTo(i,!0);break}}},{key:"_startsWith",value:function(t,e){return t.substr(0,e.length).toLowerCase()===e}},{key:"_updateValFromNumber",value:function(t){var e=t;if(this.options.formatOnDisplay&&window.intlTelInputUtils&&this.selectedCountryData){var i=this.options.nationalMode||e.charAt(0)!=="+"&&!this.options.showSelectedDialCode,o=intlTelInputUtils.numberFormat,r=o.NATIONAL,a=o.INTERNATIONAL,l=i?r:a;e=intlTelInputUtils.formatNumber(e,this.selectedCountryData.iso2,l)}e=this._beforeSetNumber(e),this.telInput.value=e}},{key:"_updateFlagFromNumber",value:function(t){var e=t.indexOf("+"),i=e?t.substring(e):t,o=this.selectedCountryData.dialCode,r=o==="1";i&&r&&i.charAt(0)!=="+"&&(i.charAt(0)!=="1"&&(i="1".concat(i)),i="+".concat(i)),this.options.showSelectedDialCode&&o&&i.charAt(0)!=="+"&&(i="+".concat(o).concat(i));var a=this._getDialCode(i,!0),l=this._getNumeric(i),u=null;if(a){var p=this.countryCodes[this._getNumeric(a)],g=p.indexOf(this.selectedCountryData.iso2)!==-1&&l.length<=a.length-1,f=o==="1"&&this._isRegionlessNanp(l);if(!f&&!g){for(var y=0;y<p.length;y++)if(p[y]){u=p[y];break}}}else i.charAt(0)==="+"&&l.length?u="":(!i||i==="+")&&(u=this.defaultCountry);return u!==null?this._setFlag(u):!1}},{key:"_isRegionlessNanp",value:function(t){var e=this._getNumeric(t);if(e.charAt(0)==="1"){var i=e.substr(1,3);return q.indexOf(i)!==-1}return!1}},{key:"_highlightListItem",value:function(t,e){var i=this.highlightedItem;i&&i.classList.remove("iti__highlight"),this.highlightedItem=t,this.highlightedItem.classList.add("iti__highlight"),this.selectedFlag.setAttribute("aria-activedescendant",t.getAttribute("id")),e&&this.highlightedItem.focus()}},{key:"_getCountryData",value:function(t,e,i){for(var o=e?c:this.countries,r=0;r<o.length;r++)if(o[r].iso2===t)return o[r];if(i)return null;throw new Error("No country data for '".concat(t,"'"))}},{key:"_setFlag",value:function(t){var e=this.options,i=e.allowDropdown,o=e.showSelectedDialCode,r=e.showFlags,a=e.countrySearch,l=this.selectedCountryData.iso2?this.selectedCountryData:{};if(this.selectedCountryData=t?this._getCountryData(t,!1,!1):{},this.selectedCountryData.iso2&&(this.defaultCountry=this.selectedCountryData.iso2),r&&this.selectedFlagInner.setAttribute("class","iti__flag iti__".concat(t)),this._setSelectedCountryFlagTitleAttribute(t,o),o){var u=this.selectedCountryData.dialCode?"+".concat(this.selectedCountryData.dialCode):"";this.selectedDialCode.innerHTML=u;var p=this.selectedFlag.offsetWidth||this._getHiddenSelectedFlagWidth();this.isRTL?this.telInput.style.paddingRight="".concat(p+6,"px"):this.telInput.style.paddingLeft="".concat(p+6,"px")}if(this._updatePlaceholder(),i&&!a){var g=this.activeItem;if(g&&(g.classList.remove("iti__active"),g.setAttribute("aria-selected","false")),t){var f=this.countryList.querySelector("#iti-".concat(this.id,"__item-").concat(t,"-preferred"))||this.countryList.querySelector("#iti-".concat(this.id,"__item-").concat(t));f.setAttribute("aria-selected","true"),f.classList.add("iti__active"),this.activeItem=f}}return l.iso2!==t}},{key:"_setSelectedCountryFlagTitleAttribute",value:function(t,e){if(this.selectedFlag){var i;t&&!e?i="".concat(this.selectedCountryData.name,": +").concat(this.selectedCountryData.dialCode):t?i=this.selectedCountryData.name:i="Unknown",this.selectedFlag.setAttribute("title",i)}}},{key:"_getHiddenSelectedFlagWidth",value:function(){var t=this.telInput.parentNode.cloneNode();t.style.visibility="hidden",document.body.appendChild(t);var e=this.flagsContainer.cloneNode();t.appendChild(e);var i=this.selectedFlag.cloneNode(!0);e.appendChild(i);var o=i.offsetWidth;return t.parentNode.removeChild(t),o}},{key:"_updatePlaceholder",value:function(){var t=this.options.autoPlaceholder==="aggressive"||!this.hadInitialPlaceholder&&this.options.autoPlaceholder==="polite";if(window.intlTelInputUtils&&t){var e=intlTelInputUtils.numberType[this.options.placeholderNumberType],i=this.selectedCountryData.iso2?intlTelInputUtils.getExampleNumber(this.selectedCountryData.iso2,this.options.nationalMode,e):"";i=this._beforeSetNumber(i),typeof this.options.customPlaceholder=="function"&&(i=this.options.customPlaceholder(i,this.selectedCountryData)),this.telInput.setAttribute("placeholder",i)}}},{key:"_selectListItem",value:function(t){var e=this._setFlag(t.getAttribute("data-country-code"));this._closeDropdown(),this._updateDialCode(t.getAttribute("data-dial-code")),this.telInput.focus(),e&&this._triggerCountryChange()}},{key:"_closeDropdown",value:function(){this.dropdownContent.classList.add("iti__hide"),this.selectedFlag.setAttribute("aria-expanded","false"),this.selectedFlag.removeAttribute("aria-activedescendant"),this.dropdownArrow.classList.remove("iti__arrow--up"),document.removeEventListener("keydown",this._handleKeydownOnDropdown),this.options.countrySearch&&this.searchInput.removeEventListener("input",this._handleSearchChange),document.documentElement.removeEventListener("click",this._handleClickOffToClose),this.countryList.removeEventListener("mouseover",this._handleMouseoverCountryList),this.countryList.removeEventListener("click",this._handleClickCountryList),this.options.dropdownContainer&&(this.options.useFullscreenPopup||window.removeEventListener("scroll",this._handleWindowScroll),this.dropdown.parentNode&&this.dropdown.parentNode.removeChild(this.dropdown)),this._trigger("close:countrydropdown")}},{key:"_scrollTo",value:function(t,e){var i=this.countryList,o=document.documentElement.scrollTop,r=i.offsetHeight,a=i.getBoundingClientRect().top+o,l=a+r,u=t.offsetHeight,p=t.getBoundingClientRect().top+o,g=p+u,f=p-a+i.scrollTop,y=r/2-u/2;if(p<a)e&&(f-=y),i.scrollTop=f;else if(g>l){e&&(f+=y);var A=r-u;i.scrollTop=f-A}}},{key:"_updateDialCode",value:function(t){var e=this.telInput.value,i="+".concat(t),o;if(e.charAt(0)==="+"){var r=this._getDialCode(e);r?o=e.replace(r,i):o=i,this.telInput.value=o}else this.options.autoInsertDialCode&&(e?o=i+e:o=i,this.telInput.value=o)}},{key:"_getDialCode",value:function(t,e){var i="";if(t.charAt(0)==="+")for(var o="",r=0;r<t.length;r++){var a=t.charAt(r);if(!isNaN(parseInt(a,10))){if(o+=a,e)this.countryCodes[o]&&(i=t.substr(0,r+1));else if(this.dialCodes[o]){i=t.substr(0,r+1);break}if(o.length===this.countryCodeMaxLen)break}}return i}},{key:"_getFullNumber",value:function(){var t=this.telInput.value.trim(),e=this.selectedCountryData.dialCode,i,o=this._getNumeric(t);return this.options.showSelectedDialCode&&!this.options.nationalMode&&t.charAt(0)!=="+"&&e&&o?i="+".concat(e):i="",i+t}},{key:"_beforeSetNumber",value:function(t){var e=t;if(this.options.showSelectedDialCode){var i=this._getDialCode(e);if(i){i="+".concat(this.selectedCountryData.dialCode);var o=e[i.length]===" "||e[i.length]==="-"?i.length+1:i.length;e=e.substr(o)}}return this._cap(e)}},{key:"_triggerCountryChange",value:function(){this._trigger("countrychange")}},{key:"_formatNumberAsYouType",value:function(){var t=this._getFullNumber(),e=window.intlTelInputUtils?intlTelInputUtils.formatNumberAsYouType(t,this.selectedCountryData.iso2):t,i=this.selectedCountryData.dialCode;if(this.options.showSelectedDialCode&&!this.options.nationalMode&&this.telInput.value.charAt(0)!=="+"&&e.includes("+".concat(i))){var o=e.split("+".concat(i))[1]||"";return o.trim()}return e}},{key:"handleAutoCountry",value:function(){this.options.initialCountry==="auto"&&(this.defaultCountry=window.intlTelInputGlobals.autoCountry,this.telInput.value||this.setCountry(this.defaultCountry),this.resolveAutoCountryPromise())}},{key:"handleUtils",value:function(){window.intlTelInputUtils&&(this.telInput.value&&this._updateValFromNumber(this.telInput.value),this._updatePlaceholder()),this.resolveUtilsScriptPromise()}},{key:"destroy",value:function(){var t=this.telInput.form;if(this.options.allowDropdown){this._closeDropdown(),this.selectedFlag.removeEventListener("click",this._handleClickSelectedFlag),this.flagsContainer.removeEventListener("keydown",this._handleFlagsContainerKeydown);var e=this.telInput.closest("label");e&&e.removeEventListener("click",this._handleLabelClick)}this.hiddenInput&&t&&t.removeEventListener("submit",this._handleHiddenInputSubmit),this.options.autoInsertDialCode&&(t&&t.removeEventListener("submit",this._handleSubmitOrBlurEvent),this.telInput.removeEventListener("blur",this._handleSubmitOrBlurEvent)),this.telInput.removeEventListener("input",this._handleKeyEvent),this.telInput.removeEventListener("cut",this._handleClipboardEvent),this.telInput.removeEventListener("paste",this._handleClipboardEvent),this.telInput.removeAttribute("data-intl-tel-input-id");var i=this.telInput.parentNode;i.parentNode.insertBefore(this.telInput,i),i.parentNode.removeChild(i),delete window.intlTelInputGlobals.instances[this.id]}},{key:"getExtension",value:function(){return window.intlTelInputUtils?intlTelInputUtils.getExtension(this._getFullNumber(),this.selectedCountryData.iso2):""}},{key:"getNumber",value:function(t){if(window.intlTelInputUtils){var e=this.selectedCountryData.iso2;return intlTelInputUtils.formatNumber(this._getFullNumber(),e,t)}return""}},{key:"getNumberType",value:function(){return window.intlTelInputUtils?intlTelInputUtils.getNumberType(this._getFullNumber(),this.selectedCountryData.iso2):-99}},{key:"getSelectedCountryData",value:function(){return this.selectedCountryData}},{key:"getValidationError",value:function(){if(window.intlTelInputUtils){var t=this.selectedCountryData.iso2;return intlTelInputUtils.getValidationError(this._getFullNumber(),t)}return-99}},{key:"isValidNumber",value:function(){var t=this._getFullNumber();return window.intlTelInputUtils?intlTelInputUtils.isPossibleNumber(t,this.selectedCountryData.iso2):null}},{key:"isValidNumberPrecise",value:function(){var t=this._getFullNumber();return window.intlTelInputUtils?intlTelInputUtils.isValidNumber(t,this.selectedCountryData.iso2):null}},{key:"setCountry",value:function(t){var e=t.toLowerCase();this.selectedCountryData.iso2!==e&&(this._setFlag(e),this._updateDialCode(this.selectedCountryData.dialCode),this._triggerCountryChange())}},{key:"setNumber",value:function(t){var e=this._updateFlagFromNumber(t);this._updateValFromNumber(t),e&&this._triggerCountryChange()}},{key:"setPlaceholderNumberType",value:function(t){this.options.placeholderNumberType=t,this._updatePlaceholder()}}]),s}();S.getCountryData=function(){return c};var R=function(n,t,e){var i=document.createElement("script");i.onload=function(){E("handleUtils"),t&&t()},i.onerror=function(){E("rejectUtilsScriptPromise"),e&&e()},i.className="iti-load-utils",i.async=!0,i.src=n,document.body.appendChild(i)};return S.loadUtils=function(s){if(!window.intlTelInputUtils&&!window.intlTelInputGlobals.startedLoadingUtilsScript){if(window.intlTelInputGlobals.startedLoadingUtilsScript=!0,typeof Promise<"u")return new Promise(function(n,t){return R(s,n,t)});R(s)}return null},S.defaults=G,S.version="19.2.16",function(s,n){var t=new Y(s,n);return t._init(),s.setAttribute("data-intl-tel-input-id",t.id),window.intlTelInputGlobals.instances[t.id]=t,t}}()})});var at={};ot(at,{default:()=>st});module.exports=rt(at);var w=B(__webpack_require__(7378)),d=B(__webpack_require__(3615)),V=B(z()),j=({initialValue:h,onChangeNumber:c,onChangeCountry:v,onChangeValidity:m,onChangeErrorCode:_,initOptions:P,className:x,disabled:O,onFocus:U,onBlur:k})=>{let I=(0,w.useRef)(null),C=(0,w.useRef)(null),L=()=>{let b=C.current.getNumber(),M=C.current.getSelectedCountryData().iso2;if(c(b),v(M),C.current.isValidNumber())m(!0),_(null);else{let D=C.current.getValidationError();m(!1),_(D)}};return(0,w.useEffect)(()=>{let b=I.current;return C.current=(0,V.default)(I.current,P),b.addEventListener("countrychange",L),()=>{b.removeEventListener("countrychange",L),C.current.destroy()}},[]),w.default.createElement("input",{type:"tel",ref:I,onInput:L,defaultValue:h,className:x,disabled:O,onFocus:U,onBlur:k})};j.propTypes={initialValue:d.default.string,onChangeNumber:d.default.func,onChangeCountry:d.default.func,onChangeValidity:d.default.func,onChangeErrorCode:d.default.func,initOptions:d.default.shape({allowDropdown:d.default.bool,autoInsertDialCode:d.default.bool,autoPlaceholder:d.default.string,containerClass:d.default.string,countrySearch:d.default.bool,customPlaceholder:d.default.func,dropdownContainer:d.default.node,excludeCountries:d.default.arrayOf(d.default.string),fixDropdownWidth:d.default.bool,formatAsYouType:d.default.bool,formatOnDisplay:d.default.bool,geoIpLookup:d.default.func,hiddenInput:d.default.func,i18n:d.default.objectOf(d.default.string),initialCountry:d.default.string,nationalMode:d.default.bool,onlyCountries:d.default.arrayOf(d.default.string),placeholderNumberType:d.default.string,preferredCountries:d.default.arrayOf(d.default.string),showFlags:d.default.bool,showSelectedDialCode:d.default.bool,useFullscreenPopup:d.default.bool,utilsScript:d.default.string}),className:d.default.string,disabled:d.default.bool,onFocus:d.default.func,onBlur:d.default.func};j.defaultProps={initialValue:"",onChangeNumber:()=>{},onChangeCountry:()=>{},onChangeValidity:()=>{},onChangeErrorCode:()=>{},initOptions:{},className:"",disabled:!1,onFocus:()=>{},onBlur:()=>{}};var st=j;
//# sourceMappingURL=IntlTelInput.cjs.js.map


/***/ }),

/***/ 8809:
/***/ (function(module) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}


/***/ }),

/***/ 4447:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.
__webpack_require__(2572);
module.exports = self.fetch.bind(self);


/***/ }),

/***/ 6601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InvalidTokenError */
function e(e){this.message=e}e.prototype=new Error,e.prototype.name="InvalidCharacterError";var r="undefined"!=typeof window&&window.atob&&window.atob.bind(window)||function(r){var t=String(r).replace(/=+$/,"");if(t.length%4==1)throw new e("'atob' failed: The string to be decoded is not correctly encoded.");for(var n,o,a=0,i=0,c="";o=t.charAt(i++);~o&&(n=a%4?64*n+o:o,a++%4)?c+=String.fromCharCode(255&n>>(-2*a&6)):0)o="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);return c};function t(e){var t=e.replace(/-/g,"+").replace(/_/g,"/");switch(t.length%4){case 0:break;case 2:t+="==";break;case 3:t+="=";break;default:throw"Illegal base64url string!"}try{return function(e){return decodeURIComponent(r(e).replace(/(.)/g,(function(e,r){var t=r.charCodeAt(0).toString(16).toUpperCase();return t.length<2&&(t="0"+t),"%"+t})))}(t)}catch(e){return r(t)}}function n(e){this.message=e}function o(e,r){if("string"!=typeof e)throw new n("Invalid token specified");var o=!0===(r=r||{}).header?0:1;try{return JSON.parse(t(e.split(".")[o]))}catch(e){throw new n("Invalid token specified: "+e.message)}}n.prototype=new Error,n.prototype.name="InvalidTokenError";/* harmony default export */ __webpack_exports__["Z"] = (o);
//# sourceMappingURL=jwt-decode.esm.js.map


/***/ }),

/***/ 3261:
/***/ (function(module) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN = 0 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */
function chunk(array, size, guard) {
  if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
    size = 1;
  } else {
    size = nativeMax(toInteger(size), 0);
  }
  var length = array ? array.length : 0;
  if (!length || size < 1) {
    return [];
  }
  var index = 0,
      resIndex = 0,
      result = Array(nativeCeil(length / size));

  while (index < length) {
    result[resIndex++] = baseSlice(array, index, (index += size));
  }
  return result;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = chunk;


/***/ }),

/***/ 3198:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;


/***/ }),

/***/ 2004:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = isEqual;


/***/ }),

/***/ 9139:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
    rsComboSymbolsRange = '\\u20d0-\\u20f0',
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsLowerMisc = '(?:' + rsLower + '|' + rsMisc + ')',
    rsUpperMisc = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptLowerContr = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptUpperContr = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptLowerContr + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsUpperMisc + '+' + rsOptUpperContr + '(?=' + [rsBreak, rsUpper + rsLowerMisc, '$'].join('|') + ')',
  rsUpper + '?' + rsLowerMisc + '+' + rsOptLowerContr,
  rsUpper + '+' + rsOptUpperContr,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 'ss'
};

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */
var kebabCase = createCompounder(function(result, word, index) {
  return result + (index ? '-' : '') + word.toLowerCase();
});

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = kebabCase;


/***/ }),

/***/ 4441:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
    rsComboSymbolsRange = '\\u20d0-\\u20f0',
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsLowerMisc = '(?:' + rsLower + '|' + rsMisc + ')',
    rsUpperMisc = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptLowerContr = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptUpperContr = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptLowerContr + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsUpperMisc + '+' + rsOptUpperContr + '(?=' + [rsBreak, rsUpper + rsLowerMisc, '$'].join('|') + ')',
  rsUpper + '?' + rsLowerMisc + '+' + rsOptLowerContr,
  rsUpper + '+' + rsOptUpperContr,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 'ss'
};

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */
var snakeCase = createCompounder(function(result, word, index) {
  return result + (index ? '_' : '') + word.toLowerCase();
});

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = snakeCase;


/***/ }),

/***/ 8784:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports =  true && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else {}
}.call(this));


/***/ }),

/***/ 8425:
/***/ (function(module) {

(function(f){if(true){module.exports=f()}else { var g; }})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=undefined;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=undefined;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
module.exports = function(forceSimilar) {
	if (typeof Map !== 'function' || forceSimilar) {
		var Similar = _dereq_('./similar');
		return new Similar();
	}
	else {
		return new Map();
	}
}

},{"./similar":2}],2:[function(_dereq_,module,exports){
function Similar() {
	this.list = [];
	this.lastItem = undefined;
	this.size = 0;

	return this;
}

Similar.prototype.get = function(key) {
	var index;

	if (this.lastItem && this.isEqual(this.lastItem.key, key)) {
		return this.lastItem.val;
	}

	index = this.indexOf(key);
	if (index >= 0) {
		this.lastItem = this.list[index];
		return this.list[index].val;
	}

	return undefined;
};

Similar.prototype.set = function(key, val) {
	var index;

	if (this.lastItem && this.isEqual(this.lastItem.key, key)) {
		this.lastItem.val = val;
		return this;
	}

	index = this.indexOf(key);
	if (index >= 0) {
		this.lastItem = this.list[index];
		this.list[index].val = val;
		return this;
	}

	this.lastItem = { key: key, val: val };
	this.list.push(this.lastItem);
	this.size++;

	return this;
};

Similar.prototype.delete = function(key) {
	var index;

	if (this.lastItem && this.isEqual(this.lastItem.key, key)) {
		this.lastItem = undefined;
	}

	index = this.indexOf(key);
	if (index >= 0) {
		this.size--;
		return this.list.splice(index, 1)[0];
	}

	return undefined;
};


// important that has() doesn't use get() in case an existing key has a falsy value, in which case has() would return false
Similar.prototype.has = function(key) {
	var index;

	if (this.lastItem && this.isEqual(this.lastItem.key, key)) {
		return true;
	}

	index = this.indexOf(key);
	if (index >= 0) {
		this.lastItem = this.list[index];
		return true;
	}

	return false;
};

Similar.prototype.forEach = function(callback, thisArg) {
	var i;
	for (i = 0; i < this.size; i++) {
		callback.call(thisArg || this, this.list[i].val, this.list[i].key, this);
	}
};

Similar.prototype.indexOf = function(key) {
	var i;
	for (i = 0; i < this.size; i++) {
		if (this.isEqual(this.list[i].key, key)) {
			return i;
		}
	}
	return -1;
};

// check if the numbers are equal, or whether they are both precisely NaN (isNaN returns true for all non-numbers)
Similar.prototype.isEqual = function(val1, val2) {
	return val1 === val2 || (val1 !== val1 && val2 !== val2);
};

module.exports = Similar;
},{}],3:[function(_dereq_,module,exports){
var MapOrSimilar = _dereq_('map-or-similar');

module.exports = function (limit) {
	var cache = new MapOrSimilar(undefined === 'true'),
		lru = [];

	return function (fn) {
		var memoizerific = function () {
			var currentCache = cache,
				newMap,
				fnResult,
				argsLengthMinusOne = arguments.length - 1,
				lruPath = Array(argsLengthMinusOne + 1),
				isMemoized = true,
				i;

			if ((memoizerific.numArgs || memoizerific.numArgs === 0) && memoizerific.numArgs !== argsLengthMinusOne + 1) {
				throw new Error('Memoizerific functions should always be called with the same number of arguments');
			}

			// loop through each argument to traverse the map tree
			for (i = 0; i < argsLengthMinusOne; i++) {
				lruPath[i] = {
					cacheItem: currentCache,
					arg: arguments[i]
				};

				// climb through the hierarchical map tree until the second-last argument has been found, or an argument is missing.
				// if all arguments up to the second-last have been found, this will potentially be a cache hit (determined later)
				if (currentCache.has(arguments[i])) {
					currentCache = currentCache.get(arguments[i]);
					continue;
				}

				isMemoized = false;

				// make maps until last value
				newMap = new MapOrSimilar(undefined === 'true');
				currentCache.set(arguments[i], newMap);
				currentCache = newMap;
			}

			// we are at the last arg, check if it is really memoized
			if (isMemoized) {
				if (currentCache.has(arguments[argsLengthMinusOne])) {
					fnResult = currentCache.get(arguments[argsLengthMinusOne]);
				}
				else {
					isMemoized = false;
				}
			}

			if (!isMemoized) {
				fnResult = fn.apply(null, arguments);
				currentCache.set(arguments[argsLengthMinusOne], fnResult);
			}

			if (limit > 0) {
				lruPath[argsLengthMinusOne] = {
					cacheItem: currentCache,
					arg: arguments[argsLengthMinusOne]
				};

				if (isMemoized) {
					moveToMostRecentLru(lru, lruPath);
				}
				else {
					lru.push(lruPath);
				}

				if (lru.length > limit) {
					removeCachedResult(lru.shift());
				}
			}

			memoizerific.wasMemoized = isMemoized;
			memoizerific.numArgs = argsLengthMinusOne + 1;

			return fnResult;
		};

		memoizerific.limit = limit;
		memoizerific.wasMemoized = false;
		memoizerific.cache = cache;
		memoizerific.lru = lru;

		return memoizerific;
	};
};

// move current args to most recent position
function moveToMostRecentLru(lru, lruPath) {
	var lruLen = lru.length,
		lruPathLen = lruPath.length,
		isMatch,
		i, ii;

	for (i = 0; i < lruLen; i++) {
		isMatch = true;
		for (ii = 0; ii < lruPathLen; ii++) {
			if (!isEqual(lru[i][ii].arg, lruPath[ii].arg)) {
				isMatch = false;
				break;
			}
		}
		if (isMatch) {
			break;
		}
	}

	lru.push(lru.splice(i, 1)[0]);
}

// remove least recently used cache item and all dead branches
function removeCachedResult(removedLru) {
	var removedLruLen = removedLru.length,
		currentLru = removedLru[removedLruLen - 1],
		tmp,
		i;

	currentLru.cacheItem.delete(currentLru.arg);

	// walk down the tree removing dead branches (size 0) along the way
	for (i = removedLruLen - 2; i >= 0; i--) {
		currentLru = removedLru[i];
		tmp = currentLru.cacheItem.get(currentLru.arg);

		if (!tmp || !tmp.size) {
			currentLru.cacheItem.delete(currentLru.arg);
		} else {
			break;
		}
	}
}

// check if the numbers are equal, or whether they are both precisely NaN (isNaN returns true for all non-numbers)
function isEqual(val1, val2) {
	return val1 === val2 || (val1 !== val1 && val2 !== val2);
}
},{"map-or-similar":1}]},{},[3])(3)
});

/***/ }),

/***/ 2572:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

/* globals self */ exports.Headers = self.Headers;
exports.Request = self.Request;
exports.Response = self.Response;
exports.fetch = self.fetch;

//# sourceMappingURL=whatwg-fetch.js.map

/***/ }),

/***/ 4284:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ref, ref1;
module.exports = ((ref = __webpack_require__.g.process) == null ? void 0 : ref.env) && typeof ((ref1 = __webpack_require__.g.process) == null ? void 0 : ref1.env) === "object" ? __webpack_require__.g.process : __webpack_require__(6118);

//# sourceMappingURL=process.js.map

/***/ }),

/***/ 6461:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(6130);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "iT": function() { return /* reexport */ AccountsAuthLoader; },
  "bg": function() { return /* reexport */ PageErrorBoundary; },
  "yG": function() { return /* reexport */ PageHead; },
  "iA": function() { return /* reexport */ Partytown_Partytown; },
  "UZ": function() { return /* reexport */ PreviewModeToast; },
  "$j": function() { return /* reexport */ Spinner_Spinner; }
});

// UNUSED EXPORTS: RoutingSpinner

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ./src/_components/Spinner.module.css
var Spinner_module = __webpack_require__(4386);
var Spinner_module_default = /*#__PURE__*/__webpack_require__.n(Spinner_module);
;// CONCATENATED MODULE: ./src/_components/Spinner.jsx



function Spinner_Spinner(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: (Spinner_module_default()).spinner,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.25 3C11.25 2.58579 11.5858 2.25 12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12C2.25 10.4448 2.61468 8.97258 3.26388 7.66623C3.44822 7.29529 3.89836 7.14403 4.26929 7.32836C4.64023 7.5127 4.79149 7.96284 4.60716 8.33377C4.05873 9.43734 3.75 10.6815 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C16.5563 20.25 20.25 16.5563 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75C11.5858 3.75 11.25 3.41421 11.25 3Z",
            fill: props.color || "#1F2937"
        })
    });
}

;// CONCATENATED MODULE: ./src/_components/AccountsAuthLoader.jsx



function AccountsAuthLoader(param) {
    var _minHeight = param.minHeight, minHeight = _minHeight === void 0 ? 650 : _minHeight, _width = param.width, width = _width === void 0 ? "100%" : _width;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            margin: 0,
            width: width || "100%",
            minWidth: 0,
            minHeight: minHeight || 650
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                boxSizing: "border-box",
                margin: 0,
                minWidth: 0
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner_Spinner, {})
        })
    });
}

// EXTERNAL MODULE: ../node_modules/react-error-boundary/dist/react-error-boundary.esm.js
var react_error_boundary_esm = __webpack_require__(1906);
// EXTERNAL MODULE: ./src/_components/PageErrorBoundary.module.css
var PageErrorBoundary_module = __webpack_require__(1218);
var PageErrorBoundary_module_default = /*#__PURE__*/__webpack_require__.n(PageErrorBoundary_module);
;// CONCATENATED MODULE: ./src/_components/PageErrorBoundary.jsx




function PageError() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        role: "alert",
        style: {
            margin: 0,
            width: "100%",
            height: "100%",
            minWidth: 0,
            padding: "16px",
            boxSizing: "border-box"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (PageErrorBoundary_module_default()).skeletonBox,
                style: {
                    width: "100%",
                    height: "320px",
                    marginBottom: "24px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (PageErrorBoundary_module_default()).skeletonBox,
                style: {
                    width: "100%",
                    height: "24px",
                    marginBottom: "8px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (PageErrorBoundary_module_default()).skeletonBox,
                style: {
                    width: "80%",
                    height: "24px",
                    marginBottom: "8px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (PageErrorBoundary_module_default()).skeletonBox,
                style: {
                    width: "60%",
                    height: "24px",
                    marginBottom: "8px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (PageErrorBoundary_module_default()).skeletonBox,
                style: {
                    width: "60%",
                    height: "24px",
                    marginBottom: "8px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (PageErrorBoundary_module_default()).skeletonBox,
                style: {
                    width: "100%",
                    height: "24px",
                    marginBottom: "24px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    display: "flex",
                    gap: "16px",
                    marginBottom: "24px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (PageErrorBoundary_module_default()).skeletonBox,
                        style: {
                            width: "100%",
                            height: "100%",
                            aspectRatio: "1 / 1"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (PageErrorBoundary_module_default()).skeletonBox,
                        style: {
                            width: "100%",
                            height: "100%",
                            aspectRatio: "1 / 1"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (PageErrorBoundary_module_default()).skeletonBox,
                style: {
                    width: "100%",
                    height: "24px",
                    marginBottom: "24px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (PageErrorBoundary_module_default()).skeletonBox,
                style: {
                    width: "100%",
                    height: "320px",
                    marginBottom: "24px"
                }
            })
        ]
    });
}
function PageErrorBoundary(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_error_boundary_esm.ErrorBoundary, {
        "data-comp": "PageErrorBoundary",
        FallbackComponent: PageError,
        children: children
    });
}

// EXTERNAL MODULE: ../node_modules/next/head.js
var head = __webpack_require__(8038);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/_components/PageHead.jsx
/* provided dependency */ var process = __webpack_require__(4284);



var backpackHeadUserConfig = {};
function PageHead(param) {
    var _page = param.page, page = _page === void 0 ? {} : _page, children = param.children;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var resourceType = (page || {}).resourceType;
    var ref12 = (page === null || page === void 0 ? void 0 : page.seo) || {}, noIndex = ref12.noIndex, noFollow = ref12.noFollow;
    var index = noIndex ? "noindex" : "index";
    var follow = noFollow ? "nofollow" : "follow";
    var pageUrl = "";
    if (resourceType === "home_page") {
        pageUrl = "https://clearlyfiltered.com";
    } else if (resourceType === "page") {
        pageUrl = "".concat("https://clearlyfiltered.com", "/pages/").concat(page.handle);
    } else if (resourceType === "product_page") {
        pageUrl = "".concat("https://clearlyfiltered.com", "/products/").concat(page.handle);
    } else if (resourceType === "collection_page") {
        pageUrl = "".concat("https://clearlyfiltered.com", "/collections/").concat(page.handle);
    } else if (resourceType === "article") {
        pageUrl = "".concat("https://clearlyfiltered.com", "/articles/").concat(page.handle);
    } else if (resourceType === "blog") {
        pageUrl = "".concat("https://clearlyfiltered.com", "/blogs/").concat(page.handle);
    } else {
        pageUrl = "https://clearlyfiltered.com";
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: page === null || page === void 0 ? void 0 : (ref = page.seo) === null || ref === void 0 ? void 0 : ref.title
                    }, "page-title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: page === null || page === void 0 ? void 0 : (ref1 = page.seo) === null || ref1 === void 0 ? void 0 : ref1.description
                    }, "page-description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: page === null || page === void 0 ? void 0 : (ref2 = page.seo) === null || ref2 === void 0 ? void 0 : ref2.keywords
                    }, "page-keywords"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: pageUrl
                    }, "page-canonical-url"),
                    (page === null || page === void 0 ? void 0 : page.favicon) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "shortcut icon",
                        href: page.favicon
                    }) : null,
                    (page === null || page === void 0 ? void 0 : (ref3 = page.seo) === null || ref3 === void 0 ? void 0 : ref3.image) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:image",
                                content: page.seo.image
                            }, "page:fb:image"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:image:alt",
                                content: (page === null || page === void 0 ? void 0 : (ref4 = page.seo) === null || ref4 === void 0 ? void 0 : ref4.title) || (backpackHeadUserConfig === null || backpackHeadUserConfig === void 0 ? void 0 : backpackHeadUserConfig.title)
                            }, "page:fb:image:alt"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:image",
                                content: page.seo.image
                            }, "page:twitter:image")
                        ]
                    }) : null,
                    process.env.FACEBOOK_APP_ID ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "fb:app_id",
                        content: process.env.FACEBOOK_APP_ID
                    }, "page:fb:app_id") : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: pageUrl
                    }, "page:fb:url"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }, "page:fb:type"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: (page === null || page === void 0 ? void 0 : (ref5 = page.seo) === null || ref5 === void 0 ? void 0 : ref5.title) || (backpackHeadUserConfig === null || backpackHeadUserConfig === void 0 ? void 0 : backpackHeadUserConfig.title)
                    }, "page:fb:title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: (page === null || page === void 0 ? void 0 : (ref6 = page.seo) === null || ref6 === void 0 ? void 0 : ref6.description) || (backpackHeadUserConfig === null || backpackHeadUserConfig === void 0 ? void 0 : backpackHeadUserConfig.description)
                    }, "page:fb:description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:locale",
                        content: backpackHeadUserConfig === null || backpackHeadUserConfig === void 0 ? void 0 : backpackHeadUserConfig.locale
                    }, "page:fb:locale"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:author",
                        content: backpackHeadUserConfig === null || backpackHeadUserConfig === void 0 ? void 0 : backpackHeadUserConfig.description
                    }, "page:fb:author"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary"
                    }, "page:twitter:card"),
                    (backpackHeadUserConfig === null || backpackHeadUserConfig === void 0 ? void 0 : (ref7 = backpackHeadUserConfig.social) === null || ref7 === void 0 ? void 0 : ref7.twitter) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:site",
                        content: backpackHeadUserConfig.social.twitter
                    }, "page:twitter:site") : null,
                    (backpackHeadUserConfig === null || backpackHeadUserConfig === void 0 ? void 0 : (ref8 = backpackHeadUserConfig.social) === null || ref8 === void 0 ? void 0 : ref8.twitter) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:creator",
                        content: backpackHeadUserConfig.social.twitter
                    }, "page:twitter:creator") : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:url",
                        content: pageUrl
                    }, "page:twitter:url"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: (page === null || page === void 0 ? void 0 : (ref9 = page.seo) === null || ref9 === void 0 ? void 0 : ref9.title) || (backpackHeadUserConfig === null || backpackHeadUserConfig === void 0 ? void 0 : backpackHeadUserConfig.title)
                    }, "page:twitter:title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: (page === null || page === void 0 ? void 0 : (ref10 = page.seo) === null || ref10 === void 0 ? void 0 : ref10.description) || (backpackHeadUserConfig === null || backpackHeadUserConfig === void 0 ? void 0 : backpackHeadUserConfig.description)
                    }, "page:twitter:description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image:alt",
                        content: (page === null || page === void 0 ? void 0 : (ref11 = page.seo) === null || ref11 === void 0 ? void 0 : ref11.title) || (backpackHeadUserConfig === null || backpackHeadUserConfig === void 0 ? void 0 : backpackHeadUserConfig.title)
                    }, "page:twitter:image:alt"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "".concat(index, ",").concat(follow)
                    }, "default-all-search-engines-crawling"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "googlebot",
                        content: "".concat(index, ",").concat(follow)
                    }, "default-google-engine-crawling")
                ]
            }),
            children
        ]
    });
}

;// CONCATENATED MODULE: ./src/_components/RoutingSpinner.jsx


function RoutingSpinner() {
    return /*#__PURE__*/ _jsx("div", {
        style: {
            width: "100%",
            height: "100%",
            position: "fixed",
            zIndex: "2147483647",
            pointerEvents: "none"
        },
        children: /*#__PURE__*/ _jsx("div", {
            style: {
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#374151cc"
            },
            children: /*#__PURE__*/ _jsx(Spinner, {
                color: "white"
            })
        })
    });
}

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(169);
;// CONCATENATED MODULE: ../node_modules/@builder.io/partytown/integration/index.mjs
const PartytownSnippet = "/* Partytown 0.8.0 - MIT builder.io */\n!function(t,e,n,i,r,o,a,d,s,c,l,p){function u(){p||(p=1,\"/\"==(a=(o.lib||\"/~partytown/\")+(o.debug?\"debug/\":\"\"))[0]&&(s=e.querySelectorAll('script[type=\"text/partytown\"]'),i!=t?i.dispatchEvent(new CustomEvent(\"pt1\",{detail:t})):(d=setTimeout(f,1e4),e.addEventListener(\"pt0\",w),r?h(1):n.serviceWorker?n.serviceWorker.register(a+(o.swPath||\"partytown-sw.js\"),{scope:a}).then((function(t){t.active?h():t.installing&&t.installing.addEventListener(\"statechange\",(function(t){\"activated\"==t.target.state&&h()}))}),console.error):f())))}function h(t){c=e.createElement(t?\"script\":\"iframe\"),t||(c.setAttribute(\"style\",\"display:block;width:0;height:0;border:0;visibility:hidden\"),c.setAttribute(\"aria-hidden\",!0)),c.src=a+\"partytown-\"+(t?\"atomics.js?v=0.8.0\":\"sandbox-sw.html?\"+Date.now()),e.querySelector(o.sandboxParent||\"body\").appendChild(c)}function f(n,r){for(w(),i==t&&(o.forward||[]).map((function(e){delete t[e.split(\".\")[0]]})),n=0;n<s.length;n++)(r=e.createElement(\"script\")).innerHTML=s[n].innerHTML,e.head.appendChild(r);c&&c.parentNode.removeChild(c)}function w(){clearTimeout(d)}o=t.partytown||{},i==t&&(o.forward||[]).map((function(e){l=t,e.split(\".\").map((function(e,n,i){l=l[i[n]]=n+1<i.length?\"push\"==i[n+1]?[]:l[i[n]]||{}:function(){(t._ptf=t._ptf||[]).push(i,arguments)}}))})),\"complete\"==e.readyState?u():(t.addEventListener(\"DOMContentLoaded\",u),t.addEventListener(\"load\",u))}(window,document,navigator,top,window.crossOriginIsolated);";

const createSnippet = (config, snippetCode) => {
    const { forward = [], ...filteredConfig } = config || {};
    const configStr = JSON.stringify(filteredConfig, (k, v) => {
        if (typeof v === 'function') {
            v = String(v);
            if (v.startsWith(k + '(')) {
                v = 'function ' + v;
            }
        }
        return v;
    });
    return [
        `!(function(w,p,f,c){`,
        Object.keys(filteredConfig).length > 0
            ? `c=w[p]=Object.assign(w[p]||{},${configStr});`
            : `c=w[p]=w[p]||{};`,
        `c[f]=(c[f]||[])`,
        forward.length > 0 ? `.concat(${JSON.stringify(forward)})` : ``,
        `})(window,'partytown','forward');`,
        snippetCode,
    ].join('');
};

/**
 * The `type` attribute for Partytown scripts, which does two things:
 *
 * 1. Prevents the `<script>` from executing on the main thread.
 * 2. Is used as a selector so the Partytown library can find all scripts to execute in a web worker.
 *
 * @public
 */
const SCRIPT_TYPE = (/* unused pure expression or super */ null && (`text/partytown`));

/**
 * Function that returns the Partytown snippet as a string, which can be
 * used as the innerHTML of the inlined Partytown script in the head.
 *
 * @public
 */
const partytownSnippet = (config) => createSnippet(config, PartytownSnippet);



;// CONCATENATED MODULE: ../node_modules/@builder.io/partytown/react/index.mjs



/**
 * The React `<Partytown/>` component should be placed within the `<head>`
 * of the document. This component should work for SSR/SSG only HTML
 * (static HTML without javascript), clientside javascript only
 * (entire React app is build with clientside javascript),
 * and both SSR/SSG HTML that's then hydrated by the client.
 *
 * @public
 */
const Partytown = (props = {}) => {
    // purposely not using useState() or useEffect() so this component
    // can also work as a React Server Component
    // this check is only be done on the client, and skipped over on the server
    if (typeof document !== 'undefined' && !document._partytown) {
        if (!document.querySelector('script[data-partytown]')) {
            // the append script to document code should only run on the client
            // and only if the SSR'd script doesn't already exist within the document.
            // If the SSR'd script isn't found in the document, then this
            // must be a clientside only render. Append the partytown script
            // to the <head>.
            const scriptElm = document.createElement('script');
            scriptElm.dataset.partytown = '';
            scriptElm.innerHTML = partytownSnippet(props);
            document.head.appendChild(scriptElm);
        }
        // should only append this script once per document, and is not dynamic
        document._partytown = true;
    }
    // `dangerouslySetInnerHTML` only works for scripts rendered as HTML from SSR.
    // The added code will set the [type="data-pt-script"] attribute to the SSR rendered
    // <script>. If this code renders as SSR HTML, then on the client it'll execute
    // and add the attribute which will tell the Client JS of the component to NOT
    // add the same script to the <head>.
    const innerHTML = partytownSnippet(props) + 'document.currentScript.dataset.partytown="";';
    return react.createElement("script", { suppressHydrationWarning: true, dangerouslySetInnerHTML: { __html: innerHTML } });
};



;// CONCATENATED MODULE: ./src/_components/Partytown.jsx
/* provided dependency */ var Partytown_process = __webpack_require__(4284);
/* eslint-disable react/destructuring-assignment */ 





var isNetlify = "true" === "true";
var context = Partytown_process.env.CONTEXT;
var isDev =  false || context === "dev";
var isPreview = [
    "deploy-preview",
    "branch-deploy"
].includes(context);
var isProduction =  true || 0;
var getProxyUrl = function(url) {
    try {
        if (url.startsWith("http")) return url;
        if (isDev) {
            return "http://localhost:".concat(Partytown_process.env.PORT, "/proxy/").concat(url);
        }
        if (isPreview) {
            return "".concat(Partytown_process.env.DEPLOY_PRIME_URL, "/proxy/").concat(url);
        // could also be `${process.env.DEPLOY_URL}/proxy/${url}` (unique deploy url)
        }
        if (isProduction && isNetlify) {
            return "".concat(Partytown_process.env.URL, "/proxy/").concat(url);
        }
        return "".concat(window.location.origin, "/proxy/").concat(url);
    } catch (error) {
        return "".concat("https://clearlyfiltered.com", "/proxy/").concat(url);
    }
};
var resolveUrl = function(url, location, type) {
    var host = url.host, pathname = url.pathname, search = url.search;
    return type === "script" && !pathname.startsWith("/proxy") ? new URL("".concat(location.origin, "/proxy/").concat(host).concat(pathname).concat(search)) : url;
};
function Partytown_Partytown(props) {
    var ref;
    if (props.enabled !== true) return null;
    var options = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        resolveUrl: props.resolveUrl || resolveUrl,
        loadScriptsOnMainThread: props === null || props === void 0 ? void 0 : (ref = props.loadScriptsOnMainThread) === null || ref === void 0 ? void 0 : ref.flatMap(getProxyUrl)
    });
    if (isDev && props.debug === "verbose") {
        console.log("partytown options", options);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Partytown, (0,_object_spread/* default */.Z)({}, options))
    });
}

// EXTERNAL MODULE: ./src/_components/PreviewModeToast.module.css
var PreviewModeToast_module = __webpack_require__(5309);
var PreviewModeToast_module_default = /*#__PURE__*/__webpack_require__.n(PreviewModeToast_module);
;// CONCATENATED MODULE: ./src/_components/PreviewModeToast.jsx




function Eye(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.75 12c0-.338.136-.905.493-1.591a7.858 7.858 0 0 1 1.64-2.108C6.374 6.926 8.694 5.75 12 5.75c3.308 0 5.627 1.176 7.116 2.551a7.86 7.86 0 0 1 1.64 2.108c.358.686.494 1.253.494 1.591 0 .338-.136.905-.493 1.591a7.86 7.86 0 0 1-1.64 2.108c-1.49 1.375-3.81 2.551-7.117 2.551-3.308 0-5.627-1.176-7.116-2.551a7.858 7.858 0 0 1-1.64-2.108c-.358-.686-.494-1.253-.494-1.591ZM12 4.25c-3.692 0-6.373 1.324-8.134 2.949a9.356 9.356 0 0 0-1.953 2.517c-.424.814-.663 1.622-.663 2.284 0 .662.24 1.47.663 2.284a9.356 9.356 0 0 0 1.953 2.517C5.627 18.426 8.308 19.75 12 19.75s6.373-1.324 8.134-2.949a9.356 9.356 0 0 0 1.953-2.517c.424-.814.663-1.622.663-2.284 0-.662-.24-1.47-.663-2.284a9.355 9.355 0 0 0-1.953-2.517C18.373 5.574 15.692 4.25 12 4.25ZM9.75 12a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0ZM12 8.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5Z",
            fill: "currentColor"
        })
    }));
}
function PreviewModeToast() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (PreviewModeToast_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Eye, {
                style: {
                    width: 16,
                    height: 16,
                    minWidth: 16
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (PreviewModeToast_module_default()).message,
                children: "You are currently previewing your storefront with draft content"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "/api/exitEdit",
                title: "Leave preview mode",
                style: {
                    fontSize: 12,
                    textAlign: "right"
                },
                children: "Exit preview mode"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/_components/index.js









/***/ }),

/***/ 2448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ useGlobalProductPageContext; },
/* harmony export */   "n": function() { return /* binding */ GlobalProductPageContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);

var GlobalProductPageContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)();
var useGlobalProductPageContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(GlobalProductPageContext);
};


/***/ }),

/***/ 8249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "n": function() { return /* reexport */ GlobalContextProvider; },
  "b": function() { return /* reexport */ useGlobalContext; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(169);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
;// CONCATENATED MODULE: ./src/contexts/globalContext.jsx




var Context = /*#__PURE__*/ (0,react.createContext)();
var globalState = {
    cartOpen: false,
    modal: {
        children: null,
        props: {}
    },
    drawer: {
        children: null,
        props: {}
    },
    overlayOpen: false,
    searchOpen: false,
    accountOpen: false,
    testVariant: "original"
};
var reducer = function(state, action) {
    switch(action.type){
        case "OPEN_CART":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                cartOpen: true,
                modal: {
                    children: null,
                    props: {}
                },
                drawer: {
                    children: null,
                    props: {}
                },
                overlayOpen: true,
                searchOpen: false
            });
        case "CLOSE_CART":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                cartOpen: false,
                overlayOpen: false
            });
        case "OPEN_MODAL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                cartOpen: false,
                modal: {
                    children: action.payload.children,
                    props: action.payload.props
                },
                overlayOpen: true,
                searchOpen: false
            });
        case "CLOSE_MODAL":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                modal: {
                    children: null,
                    props: {}
                },
                overlayOpen: false
            });
        case "OPEN_ACCOUNT":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                cartOpen: false,
                modal: {
                    children: null,
                    props: {}
                },
                drawer: {
                    children: null,
                    props: {}
                },
                overlayOpen: true,
                accountOpen: true
            });
        case "CLOSE_ACCOUNT":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                overlayOpen: false,
                accountOpen: false
            });
        case "OPEN_DRAWER":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                cartOpen: false,
                drawer: {
                    children: action.payload.children,
                    props: action.payload.props
                },
                overlayOpen: true,
                searchOpen: false,
                accountOpen: false
            });
        case "CLOSE_DRAWER":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                drawer: {
                    children: null,
                    props: {}
                },
                overlayOpen: false
            });
        case "CLOSE_OVERLAY":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                cartOpen: false,
                modal: {
                    children: null,
                    props: {}
                },
                drawer: {
                    children: null,
                    props: {}
                },
                overlayOpen: false,
                searchOpen: false,
                accountOpen: false
            });
        case "OPEN_SEARCH":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                cartOpen: false,
                modal: {
                    children: null,
                    props: {}
                },
                drawer: {
                    children: null,
                    props: {}
                },
                overlayOpen: true,
                searchOpen: true,
                accountOpen: false
            });
        case "CLOSE_SEARCH":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                overlayOpen: false,
                searchOpen: false,
                accountOpen: false
            });
        case "SET_TEST_VARIANT":
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                testVariant: action.payload.name
            });
        default:
            throw new Error("Invalid Context action of type: ".concat(action.type));
    }
};
var globalActions = function(dispatch) {
    return {
        openCart: function() {
            dispatch({
                type: "OPEN_CART"
            });
        },
        closeCart: function() {
            dispatch({
                type: "CLOSE_CART"
            });
        },
        openAccount: function() {
            dispatch({
                type: "OPEN_ACCOUNT"
            });
        },
        closeAccount: function() {
            dispatch({
                type: "CLOSE_ACCOUNT"
            });
        },
        openModal: function(children, props) {
            dispatch({
                type: "OPEN_MODAL",
                payload: {
                    children: children,
                    props: props
                }
            });
        },
        closeModal: function() {
            dispatch({
                type: "CLOSE_MODAL"
            });
        },
        openDrawer: function(children, props) {
            dispatch({
                type: "OPEN_DRAWER",
                payload: {
                    children: children,
                    props: props
                }
            });
        },
        closeDrawer: function() {
            dispatch({
                type: "CLOSE_DRAWER"
            });
        },
        closeOverlay: function() {
            dispatch({
                type: "CLOSE_OVERLAY"
            });
        },
        openSearch: function() {
            dispatch({
                type: "OPEN_SEARCH"
            });
        },
        closeSearch: function() {
            dispatch({
                type: "CLOSE_SEARCH"
            });
        },
        setTestVariant: function(name) {
            dispatch({
                type: "SET_TEST_VARIANT",
                payload: {
                    name: name
                }
            });
        }
    };
};
function GlobalContextProvider(param) {
    var children = param.children;
    var ref = (0,react.useReducer)(reducer, (0,_object_spread/* default */.Z)({}, globalState)), state = ref[0], dispatch = ref[1];
    var value = (0,react.useMemo)(function() {
        return {
            state: state,
            actions: globalActions(dispatch)
        };
    }, [
        state
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Context.Provider, {
        value: value,
        children: children
    });
}
var useGlobalContext = function() {
    return (0,react.useContext)(Context);
};

;// CONCATENATED MODULE: ./src/contexts/index.js



/***/ }),

/***/ 4068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "yn": function() { return /* reexport */ useBodyScrollLock; },
  "iF": function() { return /* reexport */ useCartCount; },
  "_P": function() { return /* reexport */ useCartItems; },
  "Bb": function() { return /* reexport */ useColorSwatches; },
  "FE": function() { return /* reexport */ useCountries; },
  "KZ": function() { return /* reexport */ useDataLayerActions; },
  "RF": function() { return /* reexport */ useScrollPosition; },
  "rH": function() { return /* reexport */ useSearchArticleResults; },
  "ch": function() { return /* reexport */ useSearchAutocomplete; },
  "Mx": function() { return /* reexport */ useSearchCollectionResults; },
  "v9": function() { return /* reexport */ useSearchPageResults; },
  "DV": function() { return /* reexport */ useSearchProductResults; },
  "ri": function() { return /* reexport */ useSetViewportHeightCssVar; },
  "bu": function() { return /* reexport */ useShopifyAnalytics; },
  "FG": function() { return /* reexport */ useSubscriptionWidget; },
  "_B": function() { return /* reexport */ useThemeColors; },
  "be": function() { return /* reexport */ useVariantPrices; }
});

// UNUSED EXPORTS: useLocalizedProducts, useLocalizedSelectedVariant, useMultipass

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
;// CONCATENATED MODULE: ./src/hooks/useBodyScrollLock.js

function useBodyScrollLock() {
    var scrollY = (0,react.useRef)(0);
    var lockBodyScroll = (0,react.useCallback)(function() {
        try {
            scrollY.current = window.scrollY;
            document.body.style.top = "-".concat(scrollY.current, "px");
            document.body.style.position = "fixed";
        } catch (error) {
            console.error(error);
        }
    }, []);
    var unlockBodyScroll = (0,react.useCallback)(function() {
        try {
            document.body.style.removeProperty("top");
            document.body.style.removeProperty("position");
            window.scrollTo({
                top: scrollY.current,
                left: 0,
                behavior: "instant"
            });
            scrollY.current = 0;
        } catch (error) {
            console.error(error);
        }
    }, []);
    return {
        lockBodyScroll: lockBodyScroll,
        unlockBodyScroll: unlockBodyScroll
    };
}

// EXTERNAL MODULE: ../node_modules/@backpackjs/storefront/dist/index.js
var dist = __webpack_require__(2031);
;// CONCATENATED MODULE: ./src/hooks/useCartCount.js


var useCartCount = function() {
    var cartItems = (0,dist.useCartItems)();
    var cartCount = (0,dist.useCartCount)();
    return (0,react.useMemo)(function() {
        var routeProducts = cartItems === null || cartItems === void 0 ? void 0 : cartItems.filter(function(item) {
            return item.variant.product.handle === "routeins";
        });
        var routeQty = (routeProducts === null || routeProducts === void 0 ? void 0 : routeProducts.length) ? routeProducts.reduce(function(acc, item) {
            return acc + item.quantity;
        }, 0) : 0;
        return cartCount - routeQty;
    }, [
        cartCount,
        cartItems
    ]);
};

;// CONCATENATED MODULE: ./src/hooks/useCartItems.js


var useCartItems = function() {
    var cartItems = (0,dist.useCartItems)();
    return (0,react.useMemo)(function() {
        return cartItems === null || cartItems === void 0 ? void 0 : cartItems.filter(function(item) {
            return item.variant.product.handle !== "routeins";
        });
    }, [
        cartItems
    ]);
};

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(7599);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(169);
;// CONCATENATED MODULE: ./src/hooks/useColorSwatches.js





function useColorSwatches() {
    var ref;
    var settings = (0,dist.useSettings)();
    var swatches = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.product) === null || ref === void 0 ? void 0 : ref.colors).swatches;
    var swatchesMap = (0,react.useMemo)(function() {
        if (!(swatches === null || swatches === void 0 ? void 0 : swatches.length)) return {};
        return swatches.reduce(function(acc, param) {
            var name = param.name, color = param.color, image = param.image;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, name === null || name === void 0 ? void 0 : name.toLowerCase().trim(), (image === null || image === void 0 ? void 0 : image.src) || color));
        }, {});
    }, [
        swatches
    ]);
    return {
        swatchesMap: swatchesMap
    };
}

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(3842);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3444);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(5556);
;// CONCATENATED MODULE: ./src/hooks/useCountries.js




var getCountries = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var _firstCountries, firstCountries, data, initialDataList, firstCountriesMap, initialNameList, finalDataList, finalNameList, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _firstCountries = param.firstCountries, firstCountries = _firstCountries === void 0 ? [] : _firstCountries;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        __webpack_require__.e(/* import() */ 582).then(__webpack_require__.t.bind(__webpack_require__, 3036, 19))
                    ];
                case 2:
                    data = _state.sent();
                    initialDataList = data.default;
                    firstCountriesMap = firstCountries.reduce(function(acc, value) {
                        acc[value] = {};
                        return acc;
                    }, {});
                    initialNameList = initialDataList.map(function(item) {
                        if (firstCountriesMap[item.countryName]) {
                            firstCountriesMap[item.countryName] = item;
                        }
                        return item.countryName;
                    });
                    finalDataList = (0,_to_consumable_array/* default */.Z)(Object.values(firstCountriesMap)).concat((0,_to_consumable_array/* default */.Z)(initialDataList));
                    finalNameList = (0,_to_consumable_array/* default */.Z)(Object.keys(firstCountriesMap)).concat((0,_to_consumable_array/* default */.Z)(initialNameList));
                    return [
                        2,
                        {
                            finalDataList: finalDataList,
                            finalNameList: finalNameList
                        }
                    ];
                case 3:
                    error = _state.sent();
                    throw new Error(error);
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function getCountries(_) {
        return _ref.apply(this, arguments);
    };
}();
var useCountries = function(props) {
    var ref = (0,react.useState)({
        countryNames: [],
        countryNamesData: []
    }), countriesData = ref[0], setCountriesData = ref[1];
    var firstCountries = Array.isArray(props === null || props === void 0 ? void 0 : props.firstCountries) ? props === null || props === void 0 ? void 0 : props.firstCountries : [];
    var awaitCountries = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getCountries({
                                firstCountries: firstCountries
                            })
                        ];
                    case 1:
                        data = _state.sent();
                        setCountriesData({
                            countryNames: data.finalNameList,
                            countryNamesData: data.finalDataList
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function awaitCountries() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (countriesData.countryNames.length && countriesData.countryNamesData.length) return;
        awaitCountries();
    }, []);
    return countriesData;
};

// EXTERNAL MODULE: ./src/utils/index.js + 4 modules
var utils = __webpack_require__(714);
;// CONCATENATED MODULE: ./src/hooks/localization/useLocalizedSelectedVariant.js






var useLocalizedSelectedVariant = function() {
    var localize = (0,dist.useLocalizedVariant)().localize;
    var getLocalizedVariant = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var countryCode, variant, ref, ref1, ref2, ref3, ref4, ref5, ref6, localizedVariant, localCurrencyCode, localizedAmount, localizedCompareAtAmount, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        countryCode = param.countryCode, variant = param.variant;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        if (!variant) return [
                            2,
                            null
                        ];
                        if (!countryCode) return [
                            2,
                            variant
                        ];
                        return [
                            4,
                            localize({
                                handle: variant.product.handle,
                                selectedOptions: variant.selectedOptions,
                                country: countryCode
                            })
                        ];
                    case 2:
                        localizedVariant = _state.sent();
                        if (!localizedVariant) return [
                            2,
                            variant
                        ];
                        localCurrencyCode = (ref = localizedVariant.priceV2) === null || ref === void 0 ? void 0 : ref.currencyCode;
                        localizedAmount = (ref1 = localizedVariant.priceV2) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.amount) === null || ref2 === void 0 ? void 0 : ref2.toFixed(2);
                        localizedCompareAtAmount = (ref3 = localizedVariant.compareAtPriceV2) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.amount) === null || ref4 === void 0 ? void 0 : ref4.toFixed(2);
                        return [
                            2,
                            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, variant), {
                                currencyCode: localCurrencyCode,
                                priceV2: {
                                    amount: localizedAmount || ((ref5 = variant.priceV2) === null || ref5 === void 0 ? void 0 : ref5.amount),
                                    currencyCode: localCurrencyCode
                                },
                                compareAtPriceV2: {
                                    amount: localizedCompareAtAmount || ((ref6 = variant.compareAtPriceV2) === null || ref6 === void 0 ? void 0 : ref6.amount),
                                    currencyCode: localCurrencyCode
                                },
                                price: localizedAmount || variant.price,
                                compareAtPrice: localizedCompareAtAmount || variant.compareAtPrice
                            })
                        ];
                    case 3:
                        error = _state.sent();
                        console.error("getLocalizedVariant:error", error.message);
                        return [
                            2,
                            variant
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    return {
        getLocalizedVariant: getLocalizedVariant
    };
};

;// CONCATENATED MODULE: ./src/hooks/localization/useLocalizedProducts.js






var useLocalizedProducts = function() {
    var getLocalizedVariant = useLocalizedSelectedVariant().getLocalizedVariant;
    var getLocalizedProductsWithFirstVariant = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var countryCode, products, localizedPromises, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        countryCode = param.countryCode, products = param.products;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        if (!(products === null || products === void 0 ? void 0 : products.length)) return [
                            2,
                            []
                        ];
                        if (!countryCode) return [
                            2,
                            products
                        ];
                        localizedPromises = products.map(function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(function(product) {
                                var ref, ref1, ref2, localizedVariant, amount, currencyCode;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!(product === null || product === void 0 ? void 0 : (ref = product.variants) === null || ref === void 0 ? void 0 : ref[0])) return [
                                                2,
                                                null
                                            ];
                                            return [
                                                4,
                                                getLocalizedVariant({
                                                    variant: product.variants[0],
                                                    countryCode: countryCode
                                                })
                                            ];
                                        case 1:
                                            localizedVariant = _state.sent();
                                            amount = (ref1 = localizedVariant.priceV2) === null || ref1 === void 0 ? void 0 : ref1.amount;
                                            currencyCode = (ref2 = localizedVariant.priceV2) === null || ref2 === void 0 ? void 0 : ref2.currencyCode;
                                            return [
                                                2,
                                                (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
                                                    priceRange: {
                                                        max: amount,
                                                        maxVariantPrice: {
                                                            amount: amount,
                                                            currencyCode: currencyCode
                                                        },
                                                        min: amount,
                                                        minVariantPrice: {
                                                            amount: amount,
                                                            currencyCode: currencyCode
                                                        }
                                                    },
                                                    variants: [
                                                        localizedVariant
                                                    ]
                                                })
                                            ];
                                    }
                                });
                            });
                            return function(product) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        return [
                            4,
                            Promise.all(localizedPromises)
                        ];
                    case 2:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 3:
                        error = _state.sent();
                        console.error("getLocalizedProductsWithFirstVariant:error", error.message);
                        return [
                            2,
                            products
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    return {
        getLocalizedProductsWithFirstVariant: getLocalizedProductsWithFirstVariant
    };
};

;// CONCATENATED MODULE: ./src/hooks/localization/index.js



;// CONCATENATED MODULE: ./src/hooks/datalayer/useDataLayerActions.js








var isDevelopment = "production" === "development";
var useDataLayerActions = function() {
    var getLocalizedVariant = useLocalizedSelectedVariant().getLocalizedVariant;
    var getLocalizedProductsWithFirstVariant = useLocalizedProducts().getLocalizedProductsWithFirstVariant;
    var country = (0,dist.useCountry)().country;
    var countryCode = country === null || country === void 0 ? void 0 : country.isoCode;
    var sendClickProductItemEvent = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var isSearchResult, listIndex, localized, product, searchTerm, selectedVariant, localizedVariant;
            return (0,tslib_es6.__generator)(this, function(_state) {
                isSearchResult = param.isSearchResult, listIndex = param.listIndex, localized = param.localized, product = param.product, searchTerm = param.searchTerm, selectedVariant = param.selectedVariant;
                try {
                    if (!selectedVariant || typeof listIndex !== "number") return [
                        2
                    ];
                    localizedVariant = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selectedVariant), {
                        priceV2: (localized === null || localized === void 0 ? void 0 : localized.priceV2) || (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.priceV2),
                        compareAtPriceV2: (localized === null || localized === void 0 ? void 0 : localized.compareAtPriceV2) || (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.compareAtPriceV2),
                        image: selectedVariant.image || (product === null || product === void 0 ? void 0 : product.featuredImage) || "",
                        index: listIndex,
                        product: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.product), {
                            collections: product === null || product === void 0 ? void 0 : product.collections,
                            vendor: product === null || product === void 0 ? void 0 : product.vendor
                        }),
                        list: window.location.pathname.startsWith("/collections") ? window.location.pathname : "",
                        searchTerm: searchTerm
                    });
                    PubSub.publish(isSearchResult ? "CLICK_SEARCH_ITEM" : "CLICK_COLLECTION_ITEM", localizedVariant);
                } catch (error) {
                    if (!isDevelopment) return [
                        2
                    ];
                    console.error("DataLayer:sendClickProductItemEvent error", error.message);
                }
                return [
                    2
                ];
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var sendClickProductBundleItemEvent = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var listIndex, localizedProducts;
            return (0,tslib_es6.__generator)(this, function(_state) {
                listIndex = param.listIndex, localizedProducts = param.localizedProducts;
                try {
                    if (!(localizedProducts === null || localizedProducts === void 0 ? void 0 : localizedProducts.length) || typeof listIndex !== "number") return [
                        2
                    ];
                    PubSub.publish("CLICK_BUNDLE_ITEM", localizedProducts.map(function(product) {
                        var ref;
                        return (ref = product.variants) === null || ref === void 0 ? void 0 : ref[0];
                    }).filter(Boolean));
                } catch (error) {
                    if (!isDevelopment) return [
                        2
                    ];
                    console.error("DataLayer:sendClickProductBundleItemEvent error", error.message);
                }
                return [
                    2
                ];
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var sendViewCollectionEvent = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var collectionId, passedCountryCode, products, fullProducts, localizedProducts, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        collectionId = param.collectionId, passedCountryCode = param.countryCode, products = param.products;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        if (!(products === null || products === void 0 ? void 0 : products.length) || !collectionId) return [
                            2
                        ];
                        if (!passedCountryCode && !countryCode) return [
                            2
                        ];
                        return [
                            4,
                            (0,utils/* fetchProductsFromHandles */.H4)(products.slice(0, 7).map(function(param) {
                                var handle = param.handle;
                                return handle;
                            }))
                        ];
                    case 2:
                        fullProducts = _state.sent();
                        return [
                            4,
                            getLocalizedProductsWithFirstVariant({
                                products: fullProducts,
                                countryCode: passedCountryCode || countryCode
                            })
                        ];
                    case 3:
                        localizedProducts = _state.sent();
                        PubSub.publish("VIEW_COLLECTION_PAGE", {
                            products: localizedProducts === null || localizedProducts === void 0 ? void 0 : localizedProducts.filter(Boolean),
                            id: collectionId.split("/").pop()
                        });
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        if (!isDevelopment) return [
                            2
                        ];
                        console.error("DataLayer:sendViewCollectionEvent error", error.message);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        countryCode
    ]);
    var sendViewProductEvent = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var passedCountryCode, product, _selectedVariant, selectedVariant, ref, localizedVariant, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        passedCountryCode = param.countryCode, product = param.product, _selectedVariant = param.selectedVariant;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        if (!product) return [
                            2
                        ];
                        if (!passedCountryCode && !countryCode) return [
                            2
                        ];
                        selectedVariant = _selectedVariant;
                        // if no selected variant is passed, use the first variant
                        if (!selectedVariant) {
                            ;
                            selectedVariant = (ref = product.variants) === null || ref === void 0 ? void 0 : ref[0];
                        }
                        if (!selectedVariant) return [
                            2
                        ];
                        return [
                            4,
                            getLocalizedVariant({
                                variant: selectedVariant,
                                countryCode: passedCountryCode || countryCode
                            })
                        ];
                    case 2:
                        localizedVariant = _state.sent();
                        localizedVariant = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, localizedVariant), {
                            image: localizedVariant.image || product.featuredImage,
                            product: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, localizedVariant.product), {
                                vendor: product.vendor
                            })
                        });
                        PubSub.publish("VIEW_PRODUCT_PAGE", {
                            product: product,
                            variant: localizedVariant
                        });
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        if (!isDevelopment) return [
                            2
                        ];
                        console.error("DataLayer:sendViewProductEvent error", error.message);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        countryCode
    ]);
    var sendViewProductBundleEvent = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var passedCountryCode, products, fullProducts, localizedVariants, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        passedCountryCode = param.countryCode, products = param.products;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        if (!(products === null || products === void 0 ? void 0 : products.length)) return [
                            2
                        ];
                        if (!passedCountryCode && !countryCode) return [
                            2
                        ];
                        return [
                            4,
                            (0,utils/* fetchProductsFromHandles */.H4)(products.slice(0, 7).map(function(param) {
                                var handle = param.handle;
                                return handle;
                            }))
                        ];
                    case 2:
                        fullProducts = _state.sent();
                        return [
                            4,
                            Promise.all(fullProducts.map(function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(function(product) {
                                    var ref, selectedVariant, localizedVariant;
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                selectedVariant = (ref = product.variants) === null || ref === void 0 ? void 0 : ref[0];
                                                if (!selectedVariant) return [
                                                    2,
                                                    undefined
                                                ];
                                                return [
                                                    4,
                                                    getLocalizedVariant({
                                                        variant: selectedVariant,
                                                        countryCode: passedCountryCode || countryCode
                                                    })
                                                ];
                                            case 1:
                                                localizedVariant = _state.sent();
                                                localizedVariant = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, localizedVariant), {
                                                    image: localizedVariant.image || product.featuredImage,
                                                    product: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, localizedVariant.product), {
                                                        collections: product.collections,
                                                        vendor: product.vendor
                                                    })
                                                });
                                                return [
                                                    2,
                                                    localizedVariant
                                                ];
                                        }
                                    });
                                });
                                return function(product) {
                                    return _ref.apply(this, arguments);
                                };
                            }()))
                        ];
                    case 3:
                        localizedVariants = _state.sent();
                        PubSub.publish("VIEW_PRODUCT_BUNDLE_PAGE", localizedVariants === null || localizedVariants === void 0 ? void 0 : localizedVariants.filter(Boolean));
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        if (!isDevelopment) return [
                            2
                        ];
                        console.error("DataLayer:sendViewProductBundleEvent error", error.message);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        countryCode
    ]);
    var sendViewSearchResultsEvent = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var passedCountryCode, isSearchPage, products, searchTerm, fullProducts, localizedProducts, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        passedCountryCode = param.countryCode, isSearchPage = param.isSearchPage, products = param.products, searchTerm = param.searchTerm;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        if (!(products === null || products === void 0 ? void 0 : products.length)) return [
                            2
                        ];
                        if (!passedCountryCode && !countryCode) return [
                            2
                        ];
                        return [
                            4,
                            (0,utils/* fetchProductsFromHandles */.H4)(products.slice(0, 14).map(function(param) {
                                var item = param.item;
                                return item === null || item === void 0 ? void 0 : item.handle;
                            }))
                        ];
                    case 2:
                        fullProducts = _state.sent();
                        return [
                            4,
                            getLocalizedProductsWithFirstVariant({
                                products: fullProducts,
                                countryCode: passedCountryCode || countryCode
                            })
                        ];
                    case 3:
                        localizedProducts = _state.sent();
                        PubSub.publish(isSearchPage ? "VIEW_SEARCH_PAGE_RESULTS" : "VIEW_SEARCH_RESULTS", localizedProducts === null || localizedProducts === void 0 ? void 0 : localizedProducts.filter(Boolean).map(function(product) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
                                searchTerm: searchTerm
                            });
                        }).slice(0, 7));
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        if (!isDevelopment) return [
                            2
                        ];
                        console.error("DataLayer:sendViewSearchResultsEvent error", error.message);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        countryCode
    ]);
    var sendSubscribeEvent = (0,react.useCallback)(function(param) {
        var email = param.email, phone = param.phone, formId = param.form_id;
        if (email) {
            PubSub.publish("SUBSCRIBE_EMAIL", {
                email: email,
                form_id: formId
            });
        }
        if (phone) {
            PubSub.publish("SUBSCRIBE_PHONE", phone);
        }
    }, []);
    var sendLogInEvent = (0,react.useCallback)(function() {
        PubSub.publish("CUSTOMER_LOGGED_IN");
    }, []);
    var sendRegisterEvent = (0,react.useCallback)(function() {
        PubSub.publish("CUSTOMER_REGISTERED");
    }, []);
    return {
        sendClickProductItemEvent: sendClickProductItemEvent,
        sendClickProductBundleItemEvent: sendClickProductBundleItemEvent,
        sendViewCollectionEvent: sendViewCollectionEvent,
        sendViewProductEvent: sendViewProductEvent,
        sendViewProductBundleEvent: sendViewProductBundleEvent,
        sendViewSearchResultsEvent: sendViewSearchResultsEvent,
        sendSubscribeEvent: sendSubscribeEvent,
        sendLogInEvent: sendLogInEvent,
        sendRegisterEvent: sendRegisterEvent
    };
};

;// CONCATENATED MODULE: ./src/hooks/datalayer/index.js


// EXTERNAL MODULE: ../node_modules/fuse.js/dist/fuse.esm.js
var fuse_esm = __webpack_require__(8107);
;// CONCATENATED MODULE: ./src/hooks/search/useSearchAutocomplete.js







function useSearchAutocomplete(param) {
    var term = param.term, _mounted = param.mounted, mounted = _mounted === void 0 ? true : _mounted;
    var ref;
    var settings = (0,dist.useSettings)();
    var ref1 = (0,react.useState)(null), autocompleteFuse = ref1[0], setAutocompleteFuse = ref1[1];
    var ref2 = (0,react.useState)([]), autocompleteResults = ref2[0], setAutocompleteResults = ref2[1];
    var enabled = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.search) === null || ref === void 0 ? void 0 : ref.autocomplete).enabled;
    var propertyKeys = [
        "title"
    ];
    var setAutocompleteFuseOnMount = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var productsRes, productsList, termsTable, sortedList, formattedList, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    if (autocompleteFuse) return [
                        2
                    ];
                    return [
                        4,
                        fetch("/json/products-list.json")
                    ];
                case 1:
                    productsRes = _state.sent();
                    return [
                        4,
                        productsRes.json()
                    ];
                case 2:
                    productsList = _state.sent();
                    termsTable = productsList.reduce(function(table, product) {
                        propertyKeys.forEach(function(key) {
                            var property = product[key];
                            if (!property) return;
                            property.split(" ").forEach(function(item, index, arr) {
                                var ref;
                                var word = item.toLowerCase();
                                if (!/[a-z0-9]/.test(word)) return;
                                if (table[word]) {
                                    table[word] += 1;
                                } else {
                                    table[word] = 1;
                                }
                                var nextWord = (ref = arr[index + 1]) === null || ref === void 0 ? void 0 : ref.toLowerCase();
                                if (nextWord && /[a-z0-9]/.test(nextWord)) {
                                    var twoWords = "".concat(word, " ").concat(nextWord);
                                    if (table[twoWords]) {
                                        table[twoWords] += 1;
                                    } else {
                                        table[twoWords] = 1;
                                    }
                                }
                            });
                        });
                        return table;
                    }, {});
                    sortedList = (0,_to_consumable_array/* default */.Z)(Object.keys(termsTable)).sort(function(a, b) {
                        return termsTable[a] - termsTable[b];
                    });
                    formattedList = sortedList.map(function(suggestion) {
                        return {
                            suggestion: suggestion
                        };
                    });
                    setAutocompleteFuse(new fuse_esm/* default */.Z(formattedList.filter(function(i) {
                        return i.status === "ACTIVE";
                    }), {
                        keys: [
                            "suggestion"
                        ],
                        ignoreLocation: true,
                        minMatchCharLength: 3,
                        threshold: 0.3
                    }));
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    console.error(error.message);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        autocompleteFuse,
        propertyKeys
    ]);
    (0,react.useEffect)(function() {
        if (!enabled || !mounted) return;
        setAutocompleteFuseOnMount();
    }, [
        enabled,
        mounted,
        propertyKeys
    ]);
    (0,react.useEffect)(function() {
        if (!enabled || !autocompleteFuse) return;
        if (!term) {
            setAutocompleteResults([]);
            return;
        }
        var results = autocompleteFuse.search(term);
        setAutocompleteResults(results);
    }, [
        autocompleteFuse,
        enabled,
        term
    ]);
    return {
        autocompleteResults: autocompleteResults
    };
}

;// CONCATENATED MODULE: ./src/hooks/search/useSearchCollectionResults.js






function useSearchCollectionResults(param) {
    var term = param.term, _mounted = param.mounted, mounted = _mounted === void 0 ? true : _mounted;
    var ref;
    var settings = (0,dist.useSettings)();
    var ref1 = (0,react.useState)(null), collectionsFuse = ref1[0], setCollectionsFuse = ref1[1];
    var ref2 = (0,react.useState)(null), collectionResults = ref2[0], setCollectionResults = ref2[1];
    var collectionsEnabled = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.search) === null || ref === void 0 ? void 0 : ref.results).collectionsEnabled;
    var setCollectionsFuseOnMount = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var response, list, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    if (collectionsFuse) return [
                        2
                    ];
                    return [
                        4,
                        fetch("/json/collections-list.json")
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    list = _state.sent();
                    setCollectionsFuse(new fuse_esm/* default */.Z(list, {
                        keys: [
                            "title"
                        ],
                        ignoreLocation: true,
                        minMatchCharLength: 3,
                        threshold: 0.3
                    }));
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    console.error(error.message);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        collectionsFuse
    ]);
    var searchCollectionsOnTermChange = (0,react.useCallback)(function() {
        if (!collectionsFuse) return;
        if (!term) {
            setCollectionResults([]);
            return;
        }
        var results = collectionsFuse.search(term);
        setCollectionResults(results);
    }, [
        collectionsFuse,
        term
    ]);
    (0,react.useEffect)(function() {
        if (!mounted || !collectionsEnabled) return;
        setCollectionsFuseOnMount();
    }, [
        collectionsEnabled,
        mounted
    ]);
    (0,react.useEffect)(function() {
        searchCollectionsOnTermChange();
    }, [
        term,
        collectionsFuse
    ]);
    return {
        collectionResults: collectionResults
    };
}

;// CONCATENATED MODULE: ./src/hooks/search/useSearchProductResults.js






function useSearchProductResults(param) {
    var term = param.term, _mounted = param.mounted, mounted = _mounted === void 0 ? true : _mounted;
    var ref;
    var settings = (0,dist.useSettings)();
    var ref1 = (0,react.useState)(null), productsFuse = ref1[0], setProductsFuse = ref1[1];
    var ref2 = (0,react.useState)(null), productResults = ref2[0], setProductResults = ref2[1];
    var productsEnabled = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.search) === null || ref === void 0 ? void 0 : ref.results).productsEnabled;
    var setProductsFuseOnMount = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var response, list, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    if (productsFuse) return [
                        2
                    ];
                    return [
                        4,
                        fetch("/json/products-list.json")
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    list = _state.sent();
                    setProductsFuse(new fuse_esm/* default */.Z(list.filter(function(i) {
                        return i.status === "ACTIVE";
                    }), {
                        keys: [
                            {
                                name: "title",
                                weight: 2
                            },
                            "productType"
                        ],
                        ignoreLocation: true,
                        minMatchCharLength: 3,
                        threshold: 0.3
                    }));
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    console.error(error.message);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        productsFuse
    ]);
    var searchProductsOnTermChange = (0,react.useCallback)(function() {
        if (!productsFuse) return;
        if (!term) {
            setProductResults([]);
            return;
        }
        var results = productsFuse.search(term);
        setProductResults(results);
    }, [
        productsFuse,
        term
    ]);
    (0,react.useEffect)(function() {
        if (!mounted || !productsEnabled) return;
        setProductsFuseOnMount();
    }, [
        mounted,
        productsEnabled
    ]);
    (0,react.useEffect)(function() {
        searchProductsOnTermChange();
    }, [
        term,
        productsFuse
    ]);
    return {
        productResults: productResults
    };
}

;// CONCATENATED MODULE: ./src/hooks/search/useSearchPageResults.js






function useSearchPageResults(param) {
    var term = param.term, _mounted = param.mounted, mounted = _mounted === void 0 ? true : _mounted;
    var ref;
    var settings = (0,dist.useSettings)();
    var ref1 = (0,react.useState)(null), pagesFuse = ref1[0], setPagesFuse = ref1[1];
    var ref2 = (0,react.useState)(null), pageResults = ref2[0], setPageResults = ref2[1];
    var pagesEnabled = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.search) === null || ref === void 0 ? void 0 : ref.results).pagesEnabled;
    var setPagesFuseOnMount = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var response, list, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    if (pagesFuse) return [
                        2
                    ];
                    return [
                        4,
                        fetch("/json/pages-list.json")
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    list = _state.sent();
                    setPagesFuse(new fuse_esm/* default */.Z(list, {
                        keys: [
                            "title"
                        ],
                        ignoreLocation: true,
                        minMatchCharLength: 3,
                        threshold: 0.3
                    }));
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    console.error(error.message);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        pagesFuse
    ]);
    var searchPagesOnTermChange = (0,react.useCallback)(function() {
        if (!pagesFuse) return;
        if (!term) {
            setPageResults([]);
            return;
        }
        var results = pagesFuse.search(term);
        setPageResults(results);
    }, [
        pagesFuse,
        term
    ]);
    (0,react.useEffect)(function() {
        // if (!mounted || !pagesEnabled) return;
        setPagesFuseOnMount();
    }, [
        mounted,
        pagesEnabled
    ]);
    (0,react.useEffect)(function() {
        searchPagesOnTermChange();
    }, [
        term,
        pagesFuse
    ]);
    return {
        pageResults: pageResults
    };
}

;// CONCATENATED MODULE: ./src/hooks/search/useSearchArticleResults.js






function useSearchArticleResults(param) {
    var term = param.term, _mounted = param.mounted, mounted = _mounted === void 0 ? true : _mounted;
    var ref;
    var settings = (0,dist.useSettings)();
    var ref1 = (0,react.useState)(null), articlesFuse = ref1[0], setArticlesFuse = ref1[1];
    var ref2 = (0,react.useState)(null), articleResults = ref2[0], setArticleResults = ref2[1];
    var articlesEnabled = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.search) === null || ref === void 0 ? void 0 : ref.results).articlesEnabled;
    var setArticlesFuseOnMount = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var response, list, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    if (articlesFuse) return [
                        2
                    ];
                    return [
                        4,
                        fetch("/json/articles-list.json")
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    list = _state.sent();
                    setArticlesFuse(new fuse_esm/* default */.Z(list, {
                        keys: [
                            "title"
                        ],
                        ignoreLocation: true,
                        minMatchCharLength: 3,
                        threshold: 0.3
                    }));
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    console.error(error.message);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        articlesFuse
    ]);
    var searchArticlesOnTermChange = (0,react.useCallback)(function() {
        if (!articlesFuse) return;
        if (!term) {
            setArticleResults([]);
            return;
        }
        var results = articlesFuse.search(term);
        setArticleResults(results);
    }, [
        articlesFuse,
        term
    ]);
    (0,react.useEffect)(function() {
        // if (!mounted || !pagesEnabled) return;
        setArticlesFuseOnMount();
    }, [
        mounted,
        articlesEnabled
    ]);
    (0,react.useEffect)(function() {
        searchArticlesOnTermChange();
    }, [
        term,
        articlesFuse
    ]);
    return {
        articleResults: articleResults
    };
}

;// CONCATENATED MODULE: ./src/hooks/search/index.js






;// CONCATENATED MODULE: ./src/hooks/document/useSetViewportHeightCssVar.js

function useSetViewportHeightCssVar() {
    (0,react.useEffect)(function() {
        var setViewportHeight = function() {
            var viewportHeight = "".concat(window.innerHeight, "px");
            document.documentElement.style.setProperty("--viewport-height", viewportHeight);
        };
        window.addEventListener("resize", setViewportHeight);
        setViewportHeight();
        return function() {
            window.removeEventListener("resize", setViewportHeight);
        };
    }, []);
}

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(5341);
// EXTERNAL MODULE: ../node_modules/lodash.kebabcase/index.js
var lodash_kebabcase = __webpack_require__(9139);
var lodash_kebabcase_default = /*#__PURE__*/__webpack_require__.n(lodash_kebabcase);
;// CONCATENATED MODULE: ./src/hooks/document/useThemeColors.js





function useThemeColors() {
    var settings = (0,dist.useSettings)();
    var ref = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : settings.theme), buttons = ref.buttons, colors = ref.colors;
    (0,react.useEffect)(function() {
        if (!buttons) return;
        Object.entries(buttons).forEach(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), buttonType = _param[0], buttonColors = _param[1];
            Object.entries(buttonColors).forEach(function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                document.documentElement.style.setProperty("--".concat(lodash_kebabcase_default()(buttonType), "-btn-").concat(lodash_kebabcase_default()(key)), value || "transparent");
            });
        });
    }, [
        buttons
    ]);
    (0,react.useEffect)(function() {
        if (!colors) return;
        Object.entries(colors).forEach(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
            document.documentElement.style.setProperty("--".concat(lodash_kebabcase_default()(key)), value || null);
        });
    }, [
        colors
    ]);
}

;// CONCATENATED MODULE: ./src/hooks/document/useScrollPosition.js

var useScrollPosition = function() {
    var limit = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 50;
    var ref = (0,react.useState)(false), scrolledPast = ref[0], setScrolledPast = ref[1];
    (0,react.useEffect)(function() {
        var updatePosition = function() {
            if (window.pageYOffset >= limit && !scrolledPast) {
                setScrolledPast(true);
            } else if (window.pageYOffset < limit && scrolledPast) {
                setScrolledPast(false);
            }
        };
        window.addEventListener("scroll", updatePosition);
        updatePosition();
        return function() {
            return window.removeEventListener("scroll", updatePosition);
        };
    }, [
        scrolledPast
    ]);
    return scrolledPast;
};

;// CONCATENATED MODULE: ./src/hooks/document/index.js




;// CONCATENATED MODULE: ../node_modules/@shopify/hydrogen-react/dist/browser-prod/analytics-constants.mjs
const AnalyticsEventName = {
  PAGE_VIEW: "PAGE_VIEW",
  ADD_TO_CART: "ADD_TO_CART",
  PAGE_VIEW_2: "PAGE_VIEW_2",
  COLLECTION_VIEW: "COLLECTION_VIEW",
  PRODUCT_VIEW: "PRODUCT_VIEW",
  SEARCH_VIEW: "SEARCH_VIEW"
};
const AnalyticsPageType = {
  article: "article",
  blog: "blog",
  captcha: "captcha",
  cart: "cart",
  collection: "collection",
  customersAccount: "customers/account",
  customersActivateAccount: "customers/activate_account",
  customersAddresses: "customers/addresses",
  customersLogin: "customers/login",
  customersOrder: "customers/order",
  customersRegister: "customers/register",
  customersResetPassword: "customers/reset_password",
  giftCard: "gift_card",
  home: "index",
  listCollections: "list-collections",
  forbidden: "403",
  notFound: "404",
  page: "page",
  password: "password",
  product: "product",
  policy: "policy",
  search: "search"
};
const ShopifySalesChannel = {
  hydrogen: "hydrogen",
  headless: "headless"
};
const ShopifyAppId = {
  hydrogen: "6167201",
  headless: "12875497473"
};

//# sourceMappingURL=analytics-constants.mjs.map

;// CONCATENATED MODULE: ../node_modules/@shopify/hydrogen-react/dist/browser-prod/analytics-utils.mjs
function schemaWrapper(schemaId, payload) {
  return {
    schema_id: schemaId,
    payload,
    metadata: {
      event_created_at_ms: Date.now()
    }
  };
}
function parseGid(gid) {
  const defaultReturn = {
    id: "",
    resource: null,
    resourceId: null,
    search: "",
    searchParams: new URLSearchParams(),
    hash: ""
  };
  if (typeof gid !== "string") {
    return defaultReturn;
  }
  try {
    const { search, searchParams, pathname, hash } = new URL(gid);
    const pathnameParts = pathname.split("/");
    const lastPathnamePart = pathnameParts[pathnameParts.length - 1];
    const resourcePart = pathnameParts[pathnameParts.length - 2];
    if (!lastPathnamePart || !resourcePart) {
      return defaultReturn;
    }
    const id = `${lastPathnamePart}${search}${hash}` || "";
    const resourceId = lastPathnamePart || null;
    const resource = resourcePart ?? null;
    return { id, resource, resourceId, search, searchParams, hash };
  } catch {
    return defaultReturn;
  }
}
function addDataIf(keyValuePairs, formattedData) {
  if (typeof keyValuePairs !== "object") {
    return {};
  }
  Object.entries(keyValuePairs).forEach(([key, value]) => {
    if (value) {
      formattedData[key] = value;
    }
  });
  return formattedData;
}
function errorIfServer(fnName) {
  if (typeof document === "undefined") {
    console.error(
      `${fnName} should only be used within the useEffect callback or event handlers`
    );
    return true;
  }
  return false;
}

//# sourceMappingURL=analytics-utils.mjs.map

;// CONCATENATED MODULE: ../node_modules/@shopify/hydrogen-react/dist/browser-prod/tracking-utils.mjs
const SHOPIFY_VISIT_TOKEN_HEADER = "X-Shopify-VisitToken";
const SHOPIFY_UNIQUE_TOKEN_HEADER = "X-Shopify-UniqueToken";
const cachedTrackingValues = { current: null };
function tracking_utils_getTrackingValues(cookieString) {
  var _a, _b, _c;
  let trackingValues;
  if (typeof window !== "undefined" && typeof window.performance !== "undefined") {
    try {
      const resourceRE = /^https?:\/\/([^/]+)(\/api\/(?:unstable|2\d{3}-\d{2})\/graphql\.json(?=$|\?))?/;
      const entries = performance.getEntriesByType(
        "resource"
      );
      let matchedValues;
      for (let i = entries.length - 1; i >= 0; i--) {
        const entry = entries[i];
        if (entry.initiatorType !== "fetch")
          continue;
        const currentHost = window.location.host;
        const match = entry.name.match(resourceRE);
        if (!match)
          continue;
        const [, matchedHost, sfapiPath] = match;
        const isMatch = (
          // Same origin (exact host match)
          matchedHost === currentHost || // Subdomain with SFAPI path
          sfapiPath && (matchedHost == null ? void 0 : matchedHost.endsWith(`.${currentHost}`))
        );
        if (isMatch) {
          const values = extractFromPerformanceEntry(entry);
          if (values) {
            matchedValues = values;
            break;
          }
        }
      }
      if (matchedValues) {
        trackingValues = matchedValues;
      }
      if (trackingValues) {
        cachedTrackingValues.current = trackingValues;
      } else if (cachedTrackingValues.current) {
        trackingValues = cachedTrackingValues.current;
      }
      if (!trackingValues) {
        const navigationEntries = performance.getEntriesByType(
          "navigation"
        )[0];
        trackingValues = extractFromPerformanceEntry(navigationEntries, false);
      }
    } catch {
    }
  }
  if (!trackingValues) {
    const cookie = typeof cookieString === "string" ? cookieString : typeof document !== "undefined" ? document.cookie : "";
    trackingValues = {
      uniqueToken: ((_a = cookie.match(/\b_shopify_y=([^;]+)/)) == null ? void 0 : _a[1]) || "",
      visitToken: ((_b = cookie.match(/\b_shopify_s=([^;]+)/)) == null ? void 0 : _b[1]) || "",
      consent: ((_c = cookie.match(/\b_tracking_consent=([^;]+)/)) == null ? void 0 : _c[1]) || ""
    };
  }
  return trackingValues;
}
function extractFromPerformanceEntry(entry, isConsentRequired = true) {
  let uniqueToken = "";
  let visitToken = "";
  let consent = "";
  const serverTiming = entry.serverTiming;
  if (serverTiming && serverTiming.length >= 3) {
    for (let i = serverTiming.length - 1; i >= 0; i--) {
      const { name, description } = serverTiming[i];
      if (!name || !description)
        continue;
      if (name === "_y") {
        uniqueToken = description;
      } else if (name === "_s") {
        visitToken = description;
      } else if (name === "_cmp") {
        consent = description;
      }
      if (uniqueToken && visitToken && consent)
        break;
    }
  }
  return uniqueToken && visitToken && (isConsentRequired ? consent : true) ? { uniqueToken, visitToken, consent } : void 0;
}

//# sourceMappingURL=tracking-utils.mjs.map

;// CONCATENATED MODULE: ../node_modules/@shopify/hydrogen-react/dist/browser-prod/cookies-utils.mjs


const tokenHash = "xxxx-4xxx-xxxx-xxxxxxxxxxxx";
function buildUUID() {
  let hash = "";
  try {
    const crypto = window.crypto;
    const randomValuesArray = new Uint16Array(31);
    crypto.getRandomValues(randomValuesArray);
    let i = 0;
    hash = tokenHash.replace(/[x]/g, (c) => {
      const r = randomValuesArray[i] % 16;
      const v = c === "x" ? r : r & 3 | 8;
      i++;
      return v.toString(16);
    }).toUpperCase();
  } catch (err) {
    hash = tokenHash.replace(/[x]/g, (c) => {
      const r = Math.random() * 16 | 0;
      const v = c === "x" ? r : r & 3 | 8;
      return v.toString(16);
    }).toUpperCase();
  }
  return `${hexTime()}-${hash}`;
}
function hexTime() {
  let dateNumber = 0;
  let perfNumber = 0;
  dateNumber = (/* @__PURE__ */ new Date()).getTime() >>> 0;
  try {
    perfNumber = performance.now() >>> 0;
  } catch (err) {
    perfNumber = 0;
  }
  const output = Math.abs(dateNumber + perfNumber).toString(16).toLowerCase();
  return output.padStart(8, "0");
}
function getShopifyCookies(cookies) {
  const trackingValues = getTrackingValues(cookies);
  return {
    [SHOPIFY_Y]: trackingValues.uniqueToken,
    [SHOPIFY_S]: trackingValues.visitToken
  };
}

//# sourceMappingURL=cookies-utils.mjs.map

;// CONCATENATED MODULE: ../node_modules/@shopify/hydrogen-react/dist/browser-prod/analytics-schema-trekkie-storefront-page-view.mjs



const SCHEMA_ID = "trekkie_storefront_page_view/1.4";
const OXYGEN_DOMAIN = "myshopify.dev";
function pageView(payload) {
  const pageViewPayload = payload;
  const { id, resource } = parseGid(pageViewPayload.resourceId);
  const resourceType = resource ? resource.toLowerCase() : void 0;
  return [
    schemaWrapper(
      SCHEMA_ID,
      addDataIf(
        {
          pageType: pageViewPayload.pageType,
          customerId: parseInt(parseGid(pageViewPayload.customerId).id || "0"),
          resourceType,
          resourceId: parseInt(id)
        },
        formatPayload(pageViewPayload)
      )
    )
  ];
}
function formatPayload(payload) {
  return {
    appClientId: payload.shopifySalesChannel ? ShopifyAppId[payload.shopifySalesChannel] : ShopifyAppId.headless,
    isMerchantRequest: isMerchantRequest(payload.url),
    hydrogenSubchannelId: payload.storefrontId || payload.hydrogenSubchannelId || "0",
    isPersistentCookie: payload.hasUserConsent,
    uniqToken: payload.uniqueToken,
    visitToken: payload.visitToken,
    microSessionId: buildUUID(),
    microSessionCount: 1,
    url: payload.url,
    path: payload.path,
    search: payload.search,
    referrer: payload.referrer,
    title: payload.title,
    shopId: parseInt(parseGid(payload.shopId).id),
    currency: payload.currency,
    contentLanguage: payload.acceptedLanguage || "en"
  };
}
function isMerchantRequest(url) {
  if (typeof url !== "string") {
    return false;
  }
  const hostname = new URL(url).hostname;
  if (hostname.indexOf(OXYGEN_DOMAIN) !== -1 || hostname === "localhost") {
    return true;
  }
  return false;
}

//# sourceMappingURL=analytics-schema-trekkie-storefront-page-view.mjs.map

;// CONCATENATED MODULE: ../node_modules/@shopify/hydrogen-react/dist/browser-prod/packages/hydrogen-react/package.json.mjs
const version = "2024.7.7";

//# sourceMappingURL=package.json.mjs.map

;// CONCATENATED MODULE: ../node_modules/@shopify/hydrogen-react/dist/browser-prod/analytics-schema-custom-storefront-customer-tracking.mjs




const analytics_schema_custom_storefront_customer_tracking_SCHEMA_ID = "custom_storefront_customer_tracking/1.2";
const PAGE_RENDERED_EVENT_NAME = "page_rendered";
const COLLECTION_PAGE_RENDERED_EVENT_NAME = "collection_page_rendered";
const PRODUCT_PAGE_RENDERED_EVENT_NAME = "product_page_rendered";
const PRODUCT_ADDED_TO_CART_EVENT_NAME = "product_added_to_cart";
const SEARCH_SUBMITTED_EVENT_NAME = "search_submitted";
function prepareAdditionalPayload(payload) {
  return {
    canonical_url: payload.canonicalUrl || payload.url,
    customer_id: parseInt(parseGid(payload.customerId).id || "0")
  };
}
function analytics_schema_custom_storefront_customer_tracking_pageView(payload) {
  const pageViewPayload = payload;
  const additionalPayload = prepareAdditionalPayload(pageViewPayload);
  const pageType = pageViewPayload.pageType;
  const pageViewEvents = [];
  pageViewEvents.push(
    schemaWrapper(
      analytics_schema_custom_storefront_customer_tracking_SCHEMA_ID,
      addDataIf(
        {
          event_name: PAGE_RENDERED_EVENT_NAME,
          ...additionalPayload
        },
        analytics_schema_custom_storefront_customer_tracking_formatPayload(pageViewPayload)
      )
    )
  );
  switch (pageType) {
    case AnalyticsPageType.collection:
      pageViewEvents.push(
        schemaWrapper(
          analytics_schema_custom_storefront_customer_tracking_SCHEMA_ID,
          addDataIf(
            {
              event_name: COLLECTION_PAGE_RENDERED_EVENT_NAME,
              ...additionalPayload,
              collection_name: pageViewPayload.collectionHandle,
              collection_id: parseInt(
                parseGid(pageViewPayload.collectionId).id
              )
            },
            analytics_schema_custom_storefront_customer_tracking_formatPayload(pageViewPayload)
          )
        )
      );
      break;
    case AnalyticsPageType.product:
      pageViewEvents.push(
        schemaWrapper(
          analytics_schema_custom_storefront_customer_tracking_SCHEMA_ID,
          addDataIf(
            {
              event_name: PRODUCT_PAGE_RENDERED_EVENT_NAME,
              ...additionalPayload,
              products: formatProductPayload(pageViewPayload.products),
              total_value: pageViewPayload.totalValue
            },
            analytics_schema_custom_storefront_customer_tracking_formatPayload(pageViewPayload)
          )
        )
      );
      break;
    case AnalyticsPageType.search:
      pageViewEvents.push(
        schemaWrapper(
          analytics_schema_custom_storefront_customer_tracking_SCHEMA_ID,
          addDataIf(
            {
              event_name: SEARCH_SUBMITTED_EVENT_NAME,
              ...additionalPayload,
              search_string: pageViewPayload.searchString
            },
            analytics_schema_custom_storefront_customer_tracking_formatPayload(pageViewPayload)
          )
        )
      );
      break;
  }
  return pageViewEvents;
}
function pageView2(payload) {
  const pageViewPayload = payload;
  const additionalPayload = prepareAdditionalPayload(pageViewPayload);
  return [
    schemaWrapper(
      analytics_schema_custom_storefront_customer_tracking_SCHEMA_ID,
      addDataIf(
        {
          event_name: PAGE_RENDERED_EVENT_NAME,
          ...additionalPayload
        },
        analytics_schema_custom_storefront_customer_tracking_formatPayload(pageViewPayload)
      )
    )
  ];
}
function collectionView(payload) {
  const pageViewPayload = payload;
  const additionalPayload = prepareAdditionalPayload(pageViewPayload);
  return [
    schemaWrapper(
      analytics_schema_custom_storefront_customer_tracking_SCHEMA_ID,
      addDataIf(
        {
          event_name: COLLECTION_PAGE_RENDERED_EVENT_NAME,
          ...additionalPayload,
          collection_name: pageViewPayload.collectionHandle,
          collection_id: parseInt(parseGid(pageViewPayload.collectionId).id)
        },
        analytics_schema_custom_storefront_customer_tracking_formatPayload(pageViewPayload)
      )
    )
  ];
}
function productView(payload) {
  const pageViewPayload = payload;
  const additionalPayload = prepareAdditionalPayload(pageViewPayload);
  return [
    schemaWrapper(
      analytics_schema_custom_storefront_customer_tracking_SCHEMA_ID,
      addDataIf(
        {
          event_name: PRODUCT_PAGE_RENDERED_EVENT_NAME,
          ...additionalPayload,
          products: formatProductPayload(pageViewPayload.products),
          total_value: pageViewPayload.totalValue
        },
        analytics_schema_custom_storefront_customer_tracking_formatPayload(pageViewPayload)
      )
    )
  ];
}
function searchView(payload) {
  const pageViewPayload = payload;
  const additionalPayload = prepareAdditionalPayload(pageViewPayload);
  return [
    schemaWrapper(
      analytics_schema_custom_storefront_customer_tracking_SCHEMA_ID,
      addDataIf(
        {
          event_name: SEARCH_SUBMITTED_EVENT_NAME,
          ...additionalPayload,
          search_string: pageViewPayload.searchString
        },
        analytics_schema_custom_storefront_customer_tracking_formatPayload(pageViewPayload)
      )
    )
  ];
}
function addToCart(payload) {
  const addToCartPayload = payload;
  const cartToken = parseGid(addToCartPayload.cartId);
  const cart_token = (cartToken == null ? void 0 : cartToken.id) ? `${cartToken.id}` : null;
  return [
    schemaWrapper(
      analytics_schema_custom_storefront_customer_tracking_SCHEMA_ID,
      addDataIf(
        {
          event_name: PRODUCT_ADDED_TO_CART_EVENT_NAME,
          customerId: addToCartPayload.customerId,
          cart_token,
          total_value: addToCartPayload.totalValue,
          products: formatProductPayload(addToCartPayload.products),
          customer_id: parseInt(
            parseGid(addToCartPayload.customerId).id || "0"
          )
        },
        analytics_schema_custom_storefront_customer_tracking_formatPayload(addToCartPayload)
      )
    )
  ];
}
function analytics_schema_custom_storefront_customer_tracking_formatPayload(payload) {
  return {
    source: payload.shopifySalesChannel || ShopifySalesChannel.headless,
    asset_version_id: payload.assetVersionId || version,
    hydrogenSubchannelId: payload.storefrontId || payload.hydrogenSubchannelId || "0",
    is_persistent_cookie: payload.hasUserConsent,
    deprecated_visit_token: payload.visitToken,
    unique_token: payload.uniqueToken,
    event_time: Date.now(),
    event_id: buildUUID(),
    event_source_url: payload.url,
    referrer: payload.referrer,
    user_agent: payload.userAgent,
    navigation_type: payload.navigationType,
    navigation_api: payload.navigationApi,
    shop_id: parseInt(parseGid(payload.shopId).id),
    currency: payload.currency,
    ccpa_enforced: payload.ccpaEnforced || false,
    gdpr_enforced: payload.gdprEnforced || false,
    gdpr_enforced_as_string: payload.gdprEnforced ? "true" : "false",
    analytics_allowed: payload.analyticsAllowed || false,
    marketing_allowed: payload.marketingAllowed || false,
    sale_of_data_allowed: payload.saleOfDataAllowed || false
  };
}
function formatProductPayload(products) {
  return products ? products.map((p) => {
    const product = addDataIf(
      {
        variant_gid: p.variantGid,
        category: p.category,
        sku: p.sku,
        product_id: parseInt(parseGid(p.productGid).id),
        variant_id: parseInt(parseGid(p.variantGid).id)
      },
      {
        product_gid: p.productGid,
        name: p.name,
        variant: p.variantName || "",
        brand: p.brand,
        price: parseFloat(p.price),
        quantity: Number(p.quantity || 0)
      }
    );
    return JSON.stringify(product);
  }) : [];
}

//# sourceMappingURL=analytics-schema-custom-storefront-customer-tracking.mjs.map

;// CONCATENATED MODULE: ../node_modules/@shopify/hydrogen-react/dist/browser-prod/analytics.mjs





function sendShopifyAnalytics(event, shopDomain) {
  const { eventName, payload } = event;
  if (!payload.hasUserConsent)
    return Promise.resolve();
  let events = [];
  const pageViewPayload = payload;
  if (eventName === AnalyticsEventName.PAGE_VIEW) {
    events = events.concat(
      pageView(pageViewPayload),
      analytics_schema_custom_storefront_customer_tracking_pageView(pageViewPayload)
    );
  } else if (eventName === AnalyticsEventName.ADD_TO_CART) {
    events = events.concat(
      addToCart(payload)
    );
  } else if (eventName === AnalyticsEventName.PAGE_VIEW_2) {
    events = events.concat(
      pageView(pageViewPayload),
      pageView2(pageViewPayload)
    );
  } else if (eventName === AnalyticsEventName.COLLECTION_VIEW) {
    events = events.concat(collectionView(pageViewPayload));
  } else if (eventName === AnalyticsEventName.PRODUCT_VIEW) {
    events = events.concat(productView(pageViewPayload));
  } else if (eventName === AnalyticsEventName.SEARCH_VIEW) {
    events = events.concat(searchView(pageViewPayload));
  }
  if (events.length) {
    return sendToShopify(events, shopDomain);
  } else {
    return Promise.resolve();
  }
}
function isLighthouseUserAgent() {
  if (typeof window === "undefined" || !window.navigator)
    return false;
  return /Chrome-Lighthouse/.test(window.navigator.userAgent);
}
const ERROR_MESSAGE = "sendShopifyAnalytics request is unsuccessful";
function sendToShopify(events, shopDomain) {
  if (isLighthouseUserAgent()) {
    return Promise.resolve();
  }
  const eventsToBeSent = {
    events,
    metadata: {
      event_sent_at_ms: Date.now()
    }
  };
  try {
    return fetch(
      shopDomain ? `https://${shopDomain}/.well-known/shopify/monorail/unstable/produce_batch` : "https://monorail-edge.shopifysvc.com/unstable/produce_batch",
      {
        method: "post",
        headers: {
          "content-type": "text/plain"
        },
        body: JSON.stringify(eventsToBeSent)
      }
    ).then((response) => {
      if (!response.ok) {
        throw new Error("Response failed");
      }
      return response.text();
    }).then((data) => {
      if (data) {
        const jsonResponse = JSON.parse(data);
        jsonResponse.result.forEach((eventResponse) => {
          if (eventResponse.status !== 200) {
            console.error(ERROR_MESSAGE, "\n\n", eventResponse.message);
          }
        });
      }
    }).catch((err) => {
      console.error(ERROR_MESSAGE, err);
      if (false)
        {}
    });
  } catch (error) {
    return Promise.resolve();
  }
}
function getClientBrowserParameters() {
  if (errorIfServer("getClientBrowserParameters")) {
    return {
      uniqueToken: "",
      visitToken: "",
      url: "",
      path: "",
      search: "",
      referrer: "",
      title: "",
      userAgent: "",
      navigationType: "",
      navigationApi: ""
    };
  }
  const [navigationType, navigationApi] = getNavigationType();
  const trackingValues = tracking_utils_getTrackingValues();
  return {
    uniqueToken: trackingValues.uniqueToken,
    visitToken: trackingValues.visitToken,
    url: location.href,
    path: location.pathname,
    search: location.search,
    referrer: document.referrer,
    title: document.title,
    userAgent: navigator.userAgent,
    navigationType,
    navigationApi
  };
}
function getNavigationTypeExperimental() {
  try {
    const navigationEntries = (performance == null ? void 0 : performance.getEntriesByType) && (performance == null ? void 0 : performance.getEntriesByType("navigation"));
    if (navigationEntries && navigationEntries[0]) {
      const rawType = window.performance.getEntriesByType(
        "navigation"
      )[0]["type"];
      const navType = rawType && rawType.toString();
      return navType;
    }
  } catch (err) {
  }
  return void 0;
}
function getNavigationTypeLegacy() {
  var _a, _b;
  try {
    if (PerformanceNavigation && ((_a = performance == null ? void 0 : performance.navigation) == null ? void 0 : _a.type) !== null && ((_b = performance == null ? void 0 : performance.navigation) == null ? void 0 : _b.type) !== void 0) {
      const rawType = performance.navigation.type;
      switch (rawType) {
        case PerformanceNavigation.TYPE_NAVIGATE:
          return "navigate";
          break;
        case PerformanceNavigation.TYPE_RELOAD:
          return "reload";
          break;
        case PerformanceNavigation.TYPE_BACK_FORWARD:
          return "back_forward";
          break;
        default:
          return `unknown: ${rawType}`;
      }
    }
  } catch (err) {
  }
  return void 0;
}
function getNavigationType() {
  try {
    let navApi = "PerformanceNavigationTiming";
    let navType = getNavigationTypeExperimental();
    if (!navType) {
      navType = getNavigationTypeLegacy();
      navApi = "performance.navigation";
    }
    if (navType) {
      return [navType, navApi];
    } else {
      return ["unknown", "unknown"];
    }
  } catch (err) {
  }
  return ["error", "error"];
}

//# sourceMappingURL=analytics.mjs.map

// EXTERNAL MODULE: ../node_modules/fast-deep-equal/index.js
var fast_deep_equal = __webpack_require__(6471);
var fast_deep_equal_default = /*#__PURE__*/__webpack_require__.n(fast_deep_equal);
;// CONCATENATED MODULE: ./src/hooks/shopify-analytics/useShopifyAnalyticsAddToCart.js









function useShopifyAnalyticsAddToCart(param) {
    var basePayload = param.basePayload, sendShopifyAnalyticsEvent = param.sendShopifyAnalyticsEvent;
    var cart = (0,dist.useCart)();
    var cartCount = useCartCount();
    var cartItems = useCartItems();
    var ref = (0,react.useState)(null), previousCartCount = ref[0], setPreviousCartCount = ref[1];
    var ref1 = (0,react.useState)(null), previousCartItems = ref1[0], setPreviousCartItems = ref1[1];
    var ref2 = (0,react.useState)(null), previousCartItemsMap = ref2[0], setPreviousCartItemsMap = ref2[1];
    (0,react.useEffect)(function() {
        if (!cart) return;
        var cartItemsMap = cartItems.reduce(function(acc, line) {
            if (!line.variant) return acc;
            var variantId = line.variant.id;
            if (!acc[variantId]) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, variantId, [
                    line
                ]));
            }
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, variantId, (0,_to_consumable_array/* default */.Z)(acc[variantId]).concat([
                line
            ])));
        }, {});
        if (!previousCartItems || cartCount <= previousCartCount) {
            setPreviousCartItems(cartItems);
            setPreviousCartCount(cartCount);
            setPreviousCartItemsMap(cartItemsMap);
            return;
        }
        var isAddedItems = [];
        var isIncreasedItems = [];
        cartItems.forEach(function(line, index) {
            var ref, ref1;
            var variantId = (ref = line.variant) === null || ref === void 0 ? void 0 : ref.id;
            if (!variantId) return;
            var previousLine = (ref1 = previousCartItemsMap[variantId]) === null || ref1 === void 0 ? void 0 : ref1.find(function(prevLine) {
                return fast_deep_equal_default()(prevLine.attributes, line.attributes);
            });
            if (!previousLine) {
                var ref2, ref3;
                isAddedItems.push((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, line), {
                    index: index,
                    quantityAdded: line.quantity,
                    totalPrice: (ref2 = line.estimatedCost) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.totalAmount) === null || ref3 === void 0 ? void 0 : ref3.amount
                }));
                return;
            }
            if (line.quantity > previousLine.quantity) {
                var ref4, ref5;
                var quantityAdded = line.quantity - previousLine.quantity;
                var totalAmount = ((ref4 = line.estimatedCost) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.totalAmount) === null || ref5 === void 0 ? void 0 : ref5.amount) || "0";
                isIncreasedItems.push((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, line), {
                    index: index,
                    quantityAdded: quantityAdded,
                    totalPrice: (parseFloat(totalAmount) / line.quantity * quantityAdded).toFixed(2)
                }));
            }
        });
        var updatedCartItems = (0,_to_consumable_array/* default */.Z)(isAddedItems).concat((0,_to_consumable_array/* default */.Z)(isIncreasedItems));
        // Keep the baseline current even while tracking is denied or unavailable.
        // Granting consent must not report additions made before consent.
        setPreviousCartItems(cartItems);
        setPreviousCartCount(cartCount);
        setPreviousCartItemsMap(cartItemsMap);
        if (!basePayload || !updatedCartItems.length) return;
        var totalValue = updatedCartItems.reduce(function(acc, line) {
            return acc + parseFloat(line.totalPrice || "0");
        }, 0);
        var products = updatedCartItems.map(function(line) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                productGid: line.variant.product.id,
                name: line.variant.product.title,
                price: line.totalPrice,
                variantGid: line.variant.id,
                variantName: line.variant.title,
                category: line.variant.product.productType,
                brand: "Clearly Filtered" || 0
            }, line.variant.sku ? {
                sku: line.variant.sku
            } : null), {
                quantity: line.quantityAdded
            });
        });
        sendShopifyAnalyticsEvent(// payload
        (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, basePayload), {
            cartId: cart.id,
            totalValue: totalValue,
            products: products
        }), // event name
        "ADD_TO_CART");
    }, [
        basePayload,
        cart === null || cart === void 0 ? void 0 : cart.updatedAt
    ]);
}

// EXTERNAL MODULE: ../node_modules/next/router.js
var router = __webpack_require__(6677);
;// CONCATENATED MODULE: ./src/hooks/shopify-analytics/useShopifyAnalyticsPageView.js




var PAGE_TYPES = {
    "/": "home",
    "/account": "customersAccount",
    "/account/activate": "customersActivateAccount",
    "/account/address-book": "customersAddresses",
    "/account/login": "customersLogin",
    "/account/orders/": "customersOrders",
    "/account/register": "customersRegister",
    "/account/reset-password": "customersResetPassword",
    "/articles": "article",
    "/blogs": "blog",
    "/cart": "cart",
    "/collections": "collection",
    "/not-found": "notFound",
    "/pages": "page",
    "/pages/404": "notFound",
    "/pages/privacy-policy": "policy",
    "/pages/search": "search",
    "/products": "product"
};
function useShopifyAnalyticsPageView(param) {
    var basePayload = param.basePayload, collection = param.collection, product = param.product, sendShopifyAnalyticsEvent = param.sendShopifyAnalyticsEvent;
    var pathnameRef = (0,react.useRef)(null);
    var ref = (0,router.useRouter)(), asPath = ref.asPath, query = ref.query;
    var pathname = asPath.split("?")[0];
    var searchString = pathname === "/pages/search" && query.term;
    (0,react.useEffect)(function() {
        if (!basePayload || pathnameRef.current === pathname && !searchString) return undefined;
        sendShopifyAnalyticsEvent(// payload
        (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, basePayload), {
            canonicalUrl: "".concat("https://clearlyfiltered.com").concat(window.location.pathname === "/" ? "" : window.location.pathname),
            pageType: pathname.startsWith("/account/orders/") ? PAGE_TYPES["/account/orders/"] : PAGE_TYPES[pathname] || PAGE_TYPES[pathname.split("/").slice(0, -1).join("/")] || ""
        }), searchString ? {
            searchString: searchString
        } : null, collection ? {
            collectionHandle: collection.handle,
            resourceId: collection.id
        } : null, product ? {
            totalValue: parseFloat(product.priceRange.min),
            resourceId: product.id,
            products: [
                {
                    productGid: product.id,
                    name: product.title,
                    brand: product.vendor,
                    price: product.priceRange.min,
                    category: product.productType
                }, 
            ]
        } : null), // event name
        "PAGE_VIEW");
        pathnameRef.current = pathname;
        return function() {
            pathnameRef.current = pathname;
        };
    }, [
        basePayload,
        pathname,
        searchString
    ]);
}

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(1373);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_array.mjs
var _to_array = __webpack_require__(9967);
;// CONCATENATED MODULE: ./src/hooks/shopify-analytics/shopifyTracking.js




var LEGACY_SHOPIFY_COOKIES = [
    "_shopify_y",
    "_shopify_s"
];
var SHOPIFY_CONSENT_READY_EVENT = "shopify:consent-ready";
function getLegacyShopifyTokens(cookieString) {
    var values = {};
    cookieString.split(";").forEach(function(part) {
        var ref = (0,_to_array/* default */.Z)(part.trim().split("=")), name = ref[0], value = ref.slice(1);
        // Match the previous SDK's duplicate-name behavior during migration.
        if (LEGACY_SHOPIFY_COOKIES.includes(name)) values[name] = value.join("=");
    });
    return {
        uniqueToken: values._shopify_y,
        visitToken: values._shopify_s
    };
}
function hasShopifyTrackingValues(values) {
    return [
        values === null || values === void 0 ? void 0 : values.uniqueToken,
        values === null || values === void 0 ? void 0 : values.visitToken
    ].every(function(value) {
        return typeof value === "string" && value.length > 0 && !value.startsWith("00000000-");
    });
}
function readShopifyConsent() {
    var ref;
    if (false) {}
    var privacy = (ref = window.Shopify) === null || ref === void 0 ? void 0 : ref.customerPrivacy;
    if (!(privacy === null || privacy === void 0 ? void 0 : privacy.analyticsProcessingAllowed) || !(privacy === null || privacy === void 0 ? void 0 : privacy.currentVisitorConsent) || !(privacy === null || privacy === void 0 ? void 0 : privacy.marketingAllowed) || !(privacy === null || privacy === void 0 ? void 0 : privacy.saleOfDataAllowed)) return null;
    try {
        var consent = privacy.currentVisitorConsent();
        var preference = function(value) {
            if (value === "yes") return true;
            if (value === "no") return false;
            return null;
        };
        return {
            analyticsAllowed: privacy.analyticsProcessingAllowed(),
            marketingAllowed: privacy.marketingAllowed(),
            saleOfDataAllowed: privacy.saleOfDataAllowed(),
            visitorConsent: {
                analytics: preference(consent.analytics),
                marketing: preference(consent.marketing),
                preferences: preference(consent.preferences),
                saleOfData: preference(consent.sale_of_data)
            }
        };
    } catch (e) {
        return null;
    }
}
function initializeShopifyConsent(value, requestedConsent) {
    var ref;
    var privacy = (ref = window.Shopify) === null || ref === void 0 ? void 0 : ref.customerPrivacy;
    if (typeof value !== "string" || !value || !privacy || privacy.cachedConsent || JSON.stringify(readShopifyConsent()) !== JSON.stringify(requestedConsent)) return;
    // Shopify's encrypted cookies are not readable by the privacy API after a
    // reload. Initialize its cache from Shopify's response, as Hydrogen does,
    // without overwriting a visitor choice made while this request was pending.
    privacy.cachedConsent = value;
    document.dispatchEvent(new Event(SHOPIFY_CONSENT_READY_EVENT));
}
function getLegacyTokens() {
    var original = getLegacyShopifyTokens(document.cookie);
    // The old hook wrote host-only cookies, while checkout writes the same names
    // for the parent domain. Cookie reads cannot reliably identify their scope.
    // If both exist, remove only the obsolete host-only copy before forwarding
    // cookies to Shopify, so checkout's shared identity is unambiguous.
    LEGACY_SHOPIFY_COOKIES.forEach(function(name) {
        var duplicates = document.cookie.split(";").filter(function(part) {
            return part.trim().startsWith("".concat(name, "="));
        });
        if (duplicates.length > 1) document.cookie = "".concat(name, "=; Max-Age=0; Path=/; SameSite=Lax");
    });
    var current = getLegacyShopifyTokens(document.cookie);
    return {
        uniqueToken: current.uniqueToken || original.uniqueToken,
        visitToken: current.visitToken || original.visitToken
    };
}
var trackingRequest;
var trackingConsent;
function postShopifyTracking(body, signal) {
    // Storefront scripts can wrap fetch and leave this handshake pending. Keep
    // the identity/consent request on the browser's working XHR transport.
    if (typeof XMLHttpRequest === "undefined") {
        return fetch("/api/shopify-tracking", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: body,
            signal: signal
        });
    }
    return new Promise(function(resolve, reject) {
        var xhr = new XMLHttpRequest();
        var finished = false;
        var abort;
        var finish = function(callback, value) {
            if (finished) return;
            finished = true;
            signal.removeEventListener("abort", abort);
            callback(value);
        };
        abort = function() {
            xhr.abort();
            finish(reject, signal.reason || new Error("Shopify tracking aborted"));
        };
        xhr.open("POST", "/api/shopify-tracking");
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.onload = function() {
            if (!xhr.status) {
                finish(reject, new TypeError("Shopify tracking network error"));
                return;
            }
            finish(resolve, {
                ok: xhr.status >= 200 && xhr.status < 300,
                status: xhr.status,
                json: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        return [
                            2,
                            JSON.parse(xhr.responseText)
                        ];
                    });
                })
            });
        };
        xhr.onerror = function() {
            return finish(reject, new TypeError("Shopify tracking network error"));
        };
        xhr.onabort = function() {
            return finish(reject, signal.reason || new Error("Shopify tracking aborted"));
        };
        signal.addEventListener("abort", abort, {
            once: true
        });
        try {
            if (signal.aborted) abort();
            else xhr.send(body);
        } catch (error) {
            finish(reject, error);
        }
    });
}
function requestShopifyTracking(syncConsent) {
    return _requestShopifyTracking.apply(this, arguments);
}
function _requestShopifyTracking() {
    _requestShopifyTracking = (0,_async_to_generator/* default */.Z)(function(syncConsent) {
        var ref, consent, legacyTokens, _tmp, current, controller, timeout, cookieDomain, values, response, error, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    consent = readShopifyConsent();
                    if (!consent || !consent.analyticsAllowed && !syncConsent) return [
                        2,
                        null
                    ];
                    if (!consent.analyticsAllowed) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        getLegacyTokens()
                    ];
                case 1:
                    _tmp = _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    _tmp = undefined;
                    _state.label = 3;
                case 3:
                    legacyTokens = _tmp;
                    current = readShopifyConsent();
                    if (!current || JSON.stringify(current) !== JSON.stringify(consent)) return [
                        2,
                        null
                    ];
                    controller = new AbortController();
                    timeout = setTimeout(function() {
                        return controller.abort();
                    }, 10000);
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        ,
                        7,
                        8
                    ]);
                    return [
                        4,
                        postShopifyTracking(JSON.stringify({
                            visitorConsent: consent.visitorConsent,
                            legacyTokens: legacyTokens,
                            globalPrivacyControl: navigator.globalPrivacyControl === true
                        }), controller.signal)
                    ];
                case 5:
                    response = _state.sent();
                    if (!response.ok) {
                        error = new Error("Shopify tracking initialization failed");
                        error.retryable = response.status === 429 || response.status >= 500;
                        throw error;
                    }
                    return [
                        4,
                        response.json()
                    ];
                case 6:
                    _tmp1 = _state.sent(), values = (0,_object_without_properties/* default */.Z)(_tmp1, [
                        "cookieDomain"
                    ]), cookieDomain = _tmp1.cookieDomain, _tmp1;
                    return [
                        3,
                        8
                    ];
                case 7:
                    clearTimeout(timeout);
                    return [
                        7
                    ];
                case 8:
                    initializeShopifyConsent(values.consent, consent);
                    // Only remove the app's obsolete host-only copies after the server has set
                    // canonical shared cookies successfully. Do not delete on localhost/preview.
                    if (cookieDomain) {
                        LEGACY_SHOPIFY_COOKIES.forEach(function(name) {
                            document.cookie = "".concat(name, "=; Max-Age=0; Path=/; SameSite=Lax");
                        });
                    }
                    if (!((ref = readShopifyConsent()) === null || ref === void 0 ? void 0 : ref.analyticsAllowed) || !hasShopifyTrackingValues(values)) return [
                        2,
                        null
                    ];
                    return [
                        2,
                        values
                    ];
            }
        });
    });
    return _requestShopifyTracking.apply(this, arguments);
}
function refreshShopifyTracking() {
    return _refreshShopifyTracking.apply(this, arguments);
}
function _refreshShopifyTracking() {
    _refreshShopifyTracking = (0,_async_to_generator/* default */.Z)(function() {
        var ref, _syncConsent, syncConsent, consent, consentKey, e, ref1, request, values;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, _syncConsent = ref.syncConsent, syncConsent = _syncConsent === void 0 ? false : _syncConsent;
                    consent = readShopifyConsent();
                    if (!consent || !consent.analyticsAllowed && !syncConsent) return [
                        2,
                        null
                    ];
                    consentKey = JSON.stringify(consent);
                    if (!(trackingRequest && trackingConsent !== consentKey)) return [
                        3,
                        5
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        trackingRequest
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2,
                        refreshShopifyTracking({
                            syncConsent: syncConsent
                        })
                    ];
                case 5:
                    // Share an in-flight initialization: simultaneous page/cart events must not
                    // create two identities before either response has set the server cookies.
                    if (!trackingRequest) {
                        ;
                        trackingConsent = consentKey;
                        request = function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                                var attempt, error;
                                var _arguments = arguments;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            attempt = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : 0;
                                            _state.label = 1;
                                        case 1:
                                            _state.trys.push([
                                                1,
                                                3,
                                                ,
                                                5
                                            ]);
                                            return [
                                                4,
                                                requestShopifyTracking(syncConsent)
                                            ];
                                        case 2:
                                            return [
                                                2,
                                                _state.sent()
                                            ];
                                        case 3:
                                            error = _state.sent();
                                            if (error.retryable === false || attempt === 2) throw error;
                                            // Retry temporary failures only; each attempt rereads current consent.
                                            return [
                                                4,
                                                new Promise(function(resolve) {
                                                    setTimeout(resolve, (attempt + 1) * 1000);
                                                })
                                            ];
                                        case 4:
                                            _state.sent();
                                            return [
                                                2,
                                                request(attempt + 1)
                                            ];
                                        case 5:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function request() {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        trackingRequest = (((ref1 = navigator.locks) === null || ref1 === void 0 ? void 0 : ref1.request) ? navigator.locks.request("shopify-tracking", function() {
                            return request();
                        }) : request()).finally(function() {
                            trackingRequest = null;
                            trackingConsent = null;
                        });
                    }
                    return [
                        4,
                        trackingRequest
                    ];
                case 6:
                    values = _state.sent();
                    // A marketing/preferences change during the request also invalidates _cmp.
                    // Wait for current Shopify values before sending the event's consent data.
                    if (JSON.stringify(readShopifyConsent()) !== consentKey) return [
                        2,
                        refreshShopifyTracking({
                            syncConsent: syncConsent
                        })
                    ];
                    return [
                        2,
                        values
                    ];
            }
        });
    });
    return _refreshShopifyTracking.apply(this, arguments);
}

;// CONCATENATED MODULE: ./src/hooks/shopify-analytics/useShopifyConsent.js



function useShopifyConsent() {
    var ref = (0,react.useState)(null), consent = ref[0], setConsent = ref[1];
    (0,react.useEffect)(function() {
        var interval;
        var syncConsent = function() {
            var next = readShopifyConsent();
            setConsent(function(previous) {
                return fast_deep_equal_default()(previous, next) ? previous : next;
            });
            if (next) window.clearInterval(interval);
        };
        // The existing privacy script loads asynchronously. Pending is distinct
        // from denied: never delete valid cookies while waiting for initialization.
        interval = window.setInterval(syncConsent, 250);
        var timeout = window.setTimeout(function() {
            return window.clearInterval(interval);
        }, 15000);
        document.addEventListener("visitorConsentCollected", syncConsent);
        document.addEventListener(SHOPIFY_CONSENT_READY_EVENT, syncConsent);
        document.addEventListener("load", syncConsent, true);
        window.addEventListener("pageshow", syncConsent);
        window.addEventListener("focus", syncConsent);
        syncConsent();
        return function() {
            window.clearInterval(interval);
            window.clearTimeout(timeout);
            document.removeEventListener("visitorConsentCollected", syncConsent);
            document.removeEventListener(SHOPIFY_CONSENT_READY_EVENT, syncConsent);
            document.removeEventListener("load", syncConsent, true);
            window.removeEventListener("pageshow", syncConsent);
            window.removeEventListener("focus", syncConsent);
        };
    }, []);
    return consent;
}

;// CONCATENATED MODULE: ./src/hooks/shopify-analytics/useShopifyAnalytics.js











// Envs to set:
// * NEXT_PUBLIC_SHOPIFY_SHOP_ID // see readme on where to obtain
// * NEXT_PUBLIC_SITE_TITLE // provides brand name
var DEBUG = true;
var sendShopifyAnalyticsEvent = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(analyticsPageData, eventName, callback, isEnabled) {
        var browserParameters, tracking, consent, payload, event, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    if (!AnalyticsEventName[eventName] || !isEnabled()) return [
                        2
                    ];
                    browserParameters = getClientBrowserParameters();
                    return [
                        4,
                        refreshShopifyTracking()
                    ];
                case 1:
                    tracking = _state.sent();
                    consent = readShopifyConsent();
                    if (!tracking || !(consent === null || consent === void 0 ? void 0 : consent.analyticsAllowed) || !isEnabled()) return [
                        2
                    ];
                    payload = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, browserParameters, analyticsPageData, tracking), {
                        hasUserConsent: consent.analyticsAllowed,
                        analyticsAllowed: consent.analyticsAllowed,
                        marketingAllowed: consent.marketingAllowed,
                        saleOfDataAllowed: consent.saleOfDataAllowed
                    });
                    event = {
                        eventName: AnalyticsEventName[eventName],
                        payload: payload
                    };
                    return [
                        4,
                        sendShopifyAnalytics(event)
                    ];
                case 2:
                    _state.sent();
                    if (typeof callback === "function") callback(event);
                    if (DEBUG) console.log("sendShopifyAnalytics:event", event);
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    console.error("sendShopifyAnalyticsEvent:error", error.message);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function sendShopifyAnalyticsEvent(analyticsPageData, eventName, callback, isEnabled) {
        return _ref.apply(this, arguments);
    };
}();
function useShopifyAnalytics(param) {
    var collection = param.collection, product = param.product;
    var currency = (0,dist.useCurrency)();
    var customer = (0,dist.useCustomer)();
    var settings = (0,dist.useSettings)();
    var enabled = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : settings.analytics).enabled;
    var consent = useShopifyConsent();
    var hasUserConsent = consent === null || consent === void 0 ? void 0 : consent.analyticsAllowed;
    (0,react.useEffect)(function() {
        if (!enabled || !consent) return undefined;
        var active = true;
        var failed = false;
        // Synchronize every privacy change without creating an analytics event.
        // Initial page/cart requests share this same in-flight synchronization.
        var synchronize = function() {
            failed = false;
            refreshShopifyTracking({
                syncConsent: true
            }).catch(function() {
                if (!active) return;
                failed = true;
                console.error("Shopify consent cookie synchronization failed");
            });
        };
        var retryFailed = function() {
            if (failed) synchronize();
        };
        window.addEventListener("focus", retryFailed);
        window.addEventListener("pageshow", retryFailed);
        synchronize();
        return function() {
            active = false;
            window.removeEventListener("focus", retryFailed);
            window.removeEventListener("pageshow", retryFailed);
        };
    }, [
        enabled,
        consent
    ]);
    var enabledRef = (0,react.useRef)(enabled);
    enabledRef.current = enabled;
    var sendEvent = (0,react.useCallback)(function(payload, eventName, callback) {
        return sendShopifyAnalyticsEvent(payload, eventName, callback, function() {
            return enabledRef.current;
        });
    }, []);
    var customerPending = typeof customer === "undefined";
    var basePayload = (0,react.useMemo)(function() {
        if (!currency || customerPending || !enabled || !hasUserConsent || !"10110318") return null;
        return (0,_object_spread/* default */.Z)({
            hasUserConsent: hasUserConsent,
            shopId: "gid://shopify/Shop/".concat("10110318"),
            currency: currency,
            acceptedLanguage: "en",
            shopifySalesChannel: "headless"
        }, customer ? {
            customerId: customer.id
        } : null);
    }, [
        currency,
        customer,
        enabled,
        hasUserConsent
    ]);
    useShopifyAnalyticsPageView({
        basePayload: basePayload,
        collection: collection,
        product: product,
        sendShopifyAnalyticsEvent: sendEvent
    });
    useShopifyAnalyticsAddToCart({
        basePayload: basePayload,
        sendShopifyAnalyticsEvent: sendEvent
    });
}

;// CONCATENATED MODULE: ./src/hooks/shopify-analytics/index.js


;// CONCATENATED MODULE: ./src/hooks/useSubscriptionWidget.js



function useSubscriptionWidget(product) {
    var settings = (0,dist.useSettings)();
    var ref = (0,react.useState)(null), productSubscriptionWidget = ref[0], setProductSubscriptionWidget = ref[1];
    (0,react.useEffect)(function() {
        var ref;
        if (!product || !settings) {
            return;
        }
        var ref1;
        // Get all products with subscriptions set in settings
        var subscriptionProducts = (ref1 = settings === null || settings === void 0 ? void 0 : (ref = settings.subscriptions) === null || ref === void 0 ? void 0 : ref.subscriptionProducts) !== null && ref1 !== void 0 ? ref1 : [];
        // clone list of subscription products
        var subscriptionWidgetDetails = (0,_to_consumable_array/* default */.Z)(subscriptionProducts);
        // find the subscription product that matches the current product
        var widget = (subscriptionWidgetDetails === null || subscriptionWidgetDetails === void 0 ? void 0 : subscriptionWidgetDetails.length) && (subscriptionWidgetDetails === null || subscriptionWidgetDetails === void 0 ? void 0 : subscriptionWidgetDetails.find(function(productSubscription) {
            var ref;
            var currentProductHandle = product === null || product === void 0 ? void 0 : product.handle;
            var subscriptionProductHandle = productSubscription === null || productSubscription === void 0 ? void 0 : (ref = productSubscription.product) === null || ref === void 0 ? void 0 : ref.handle;
            return currentProductHandle === subscriptionProductHandle;
        }));
        setProductSubscriptionWidget(widget);
    }, [
        settings,
        product
    ]);
    return {
        productSubscriptionWidget: productSubscriptionWidget
    };
}

;// CONCATENATED MODULE: ./src/hooks/useVariantPrices.js


function useVariantPrices(param) {
    var variant = param.variant, purchaseType = param.purchaseType, isPdp = param.isPdp;
    var ref = (0,_object_spread/* default */.Z)({}, variant), id = ref.id, priceV2 = ref.priceV2, compareAtPriceV2 = ref.compareAtPriceV2, sellingPlanAllocations = ref.sellingPlanAllocations;
    return (0,react.useMemo)(function() {
        var ref;
        var amount = 0;
        var compareAtAmount = 0;
        /**
     * return if no price on variant
     */ if (!(priceV2 === null || priceV2 === void 0 ? void 0 : priceV2.amount)) {
            return {
                price: null,
                compareAtPrice: null
            };
        }
        /**
     * get subscription amount
     */ var subscriptionAmount = null;
        var subscriptionCompareAmount = null;
        if ((sellingPlanAllocations === null || sellingPlanAllocations === void 0 ? void 0 : sellingPlanAllocations.length) && ((ref = sellingPlanAllocations[0].priceAdjustments) === null || ref === void 0 ? void 0 : ref.length)) {
            var ref1, ref2;
            var adjustment = sellingPlanAllocations[0].priceAdjustments[0];
            subscriptionAmount = parseFloat((adjustment === null || adjustment === void 0 ? void 0 : (ref1 = adjustment.price) === null || ref1 === void 0 ? void 0 : ref1.amount) || 0);
            subscriptionCompareAmount = parseFloat((adjustment === null || adjustment === void 0 ? void 0 : (ref2 = adjustment.compareAtPrice) === null || ref2 === void 0 ? void 0 : ref2.amount) || 0);
        }
        /**
     * set amount and compareAtAmount
     */ if (isPdp && purchaseType === "subscription" && subscriptionAmount) {
            amount = subscriptionAmount;
            compareAtAmount = subscriptionCompareAmount;
        } else if (!isPdp && subscriptionAmount) {
            amount = subscriptionAmount;
        } else {
            amount = parseFloat(priceV2.amount);
            compareAtAmount = parseFloat((compareAtPriceV2 === null || compareAtPriceV2 === void 0 ? void 0 : compareAtPriceV2.amount) || "0");
        }
        return {
            price: "$".concat(amount.toFixed(2).replace(".00", "")),
            compareAtPrice: compareAtAmount > amount ? "$".concat(compareAtAmount.toFixed(2).replace(".00", "")) : null
        };
    }, [
        id,
        purchaseType
    ]);
}

;// CONCATENATED MODULE: ./src/hooks/index.js















/***/ }),

/***/ 2868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ useAuth; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(3842);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(5556);
;// CONCATENATED MODULE: ./src/gql/index.js
var productMediaMetaobject = "query getMetaobjectById($id: ID!) {\n  metaobject(id: $id) {\n    id\n    fields {\n      key\n      value\n      references (first: 9) {\n        edges {\n          node {\n            ... on MediaImage {\n              image {\n                altText\n                height\n                id\n                url\n                width\n              }\n              mediaContentType\n            }\n            ... on Video {\n              mediaContentType\n              previewImage {\n                altText\n                height\n                id\n                url\n                width\n              }\n              sources {\n                format\n                height\n                mimeType\n                url\n                width\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}";
var gql_getCustomerAccessTokenWithMultipass = "mutation customerAccessTokenCreateWithMultipass($multipassToken: String!) {\n  customerAccessTokenCreateWithMultipass(multipassToken: $multipassToken) {\n    customerAccessToken {\n      accessToken\n      expiresAt\n    }\n    customerUserErrors {\n      code\n      field\n      message\n    }\n  }\n}";
var gql_getCustomerByAccessToken = 'query getCustomerByAccessToken ($accessToken: String!) {\n  customer(customerAccessToken: "$accessToken") {\n    id\n    firstName\n    lastName\n    acceptsMarketing\n    email\n    tags\n  }\n}';

// EXTERNAL MODULE: ./src/utils/queryStorefrontApi.js
var queryStorefrontApi = __webpack_require__(5244);
;// CONCATENATED MODULE: ./src/hooks/useAuth.js




function useAuth() {
    var getCustomerAccessTokenWithMultipass = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(multipassToken) {
            var query, variables, res, data, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        query = gql_getCustomerAccessTokenWithMultipass;
                        variables = {
                            multipassToken: multipassToken
                        };
                        return [
                            4,
                            (0,queryStorefrontApi/* queryStorefrontApi */.h)(query, variables)
                        ];
                    case 1:
                        res = _state.sent();
                        data = res === null || res === void 0 ? void 0 : res.body;
                        if (!(data === null || data === void 0 ? void 0 : data.customerAccessTokenCreateWithMultipass)) {
                            throw new Error("No data returned from Shopify");
                        }
                        return [
                            2,
                            {
                                status: res.status,
                                body: data.customerAccessTokenCreateWithMultipass
                            }
                        ];
                    case 2:
                        error = _state.sent();
                        console.error("Error:", error);
                        return [
                            2,
                            {
                                status: 500,
                                error: "Error receiving data"
                            }
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function getCustomerAccessTokenWithMultipass(multipassToken) {
            return _ref.apply(this, arguments);
        };
    }();
    var getCustomerByAccessToken = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(accessToken) {
            var query, variables, res, data, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        query = gql_getCustomerByAccessToken;
                        variables = {
                            accessToken: accessToken
                        };
                        return [
                            4,
                            (0,queryStorefrontApi/* queryStorefrontApi */.h)(query, variables)
                        ];
                    case 1:
                        res = _state.sent();
                        data = res === null || res === void 0 ? void 0 : res.body;
                        if (!(data === null || data === void 0 ? void 0 : data.customer)) {
                            throw new Error("No data returned from Shopify");
                        }
                        return [
                            2,
                            {
                                status: res.status,
                                body: data.customer
                            }
                        ];
                    case 2:
                        error = _state.sent();
                        console.error("Error:", error);
                        return [
                            2,
                            {
                                status: 500,
                                error: "Error receiving data"
                            }
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function getCustomerByAccessToken(accessToken) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        getCustomerAccessTokenWithMultipass: getCustomerAccessTokenWithMultipass,
        getCustomerByAccessToken: getCustomerByAccessToken
    };
}


/***/ }),

/***/ 8311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ useIpFetcher; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);

var useIpFetcher = function(ipinfoKey) {
    var lsKey = "user_location";
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if ( false || typeof localStorage == "undefined" || !ipinfoKey) {
            return;
        }
        // Check if the IP info stored within the last day
        var stored = localStorage.getItem(lsKey);
        if (stored) {
            var ref = JSON.parse(stored), timestamp = ref.timestamp, country_code = ref.country_code;
            var ONE_HOUR = 60 * 60 * 1000;
            if (Date.now() - timestamp < ONE_HOUR && country_code) {
                return;
            }
        }
        // Fetch in the background, non-blocking
        fetch("https://api.ipinfo.io/lite/me?token=".concat(ipinfoKey)).then(function(res) {
            return res.json();
        }).then(function(data) {
            localStorage.setItem(lsKey, JSON.stringify({
                country_code: data.country_code,
                country: data.country,
                timestamp: Date.now()
            }));
        }).catch(function(err) {
            return console.error("IP fetch failed:", err);
        });
    }, []);
    var getUserLocationInfo = function() {
        return JSON.parse(localStorage.getItem(lsKey) || "{}");
    };
    return {
        getUserLocationInfo: getUserLocationInfo
    };
};


/***/ }),

/***/ 5601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ useMultipass; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(169);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5556);




function useMultipass() {
    var generateUrl = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(param) {
            var customer, returnTo, apiEndpoint, currentTime, customerData, response, data;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        customer = param.customer, returnTo = param.returnTo;
                        apiEndpoint = "/api/multipass-login";
                        currentTime = new Date();
                        customerData = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, customer), {
                            created_at: currentTime,
                            return_to: returnTo
                        });
                        return [
                            4,
                            fetch(apiEndpoint, {
                                method: "POST",
                                body: JSON.stringify({
                                    data: customerData
                                })
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            4,
                            response.json()
                        ];
                    case 2:
                        data = _state.sent();
                        if (!data) {
                            throw new Error("No data returned from fetchReviewAggregate");
                        }
                        return [
                            2,
                            data
                        ];
                }
            });
        });
        return function generateUrl(_) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        generateUrl: generateUrl
    };
}


/***/ }),

/***/ 6130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(169);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../node_modules/@backpackjs/core-nextjs/dist/utils/index.js
var utils = __webpack_require__(6759);
// EXTERNAL MODULE: ../node_modules/@backpackjs/storefront/dist/index.js
var dist = __webpack_require__(2031);
// EXTERNAL MODULE: ../node_modules/telejson/dist/index.mjs
var telejson_dist = __webpack_require__(3347);
// EXTERNAL MODULE: ../node_modules/@backpackjs/core-nextjs/dist/customizerUtils/index.js
var customizerUtils = __webpack_require__(2234);
// EXTERNAL MODULE: ./src/_components/index.js + 9 modules
var _components = __webpack_require__(3183);
// EXTERNAL MODULE: ./src/sections/ArticleBlockQuote/ArticleBlockQuote.jsx + 1 modules
var ArticleBlockQuote = __webpack_require__(3913);
;// CONCATENATED MODULE: ./src/sections/ArticleBlockQuote/index.js


// EXTERNAL MODULE: ./src/snippets/Typography/index.js + 3 modules
var Typography = __webpack_require__(7373);
// EXTERNAL MODULE: ./src/snippets/index.js + 131 modules
var snippets = __webpack_require__(1790);
;// CONCATENATED MODULE: ./src/sections/ArticleContaminantAccordions/Accordion.jsx



function Accordion(param) {
    var accordion = param.accordion;
    var body = accordion.body, defaultOpen = accordion.defaultOpen, header = accordion.header;
    var ref = (0,react.useState)(defaultOpen), isOpen = ref[0], setIsOpen = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                "aria-label": "".concat(isOpen ? "Close" : "Open", " accordion for ").concat(header),
                className: "flex min-h-[4rem] w-full items-center justify-between gap-x-4 border-t border-[#DDE2E7] py-6 px-6 pb-4 text-left lg:py-8 lg:px-10 lg:pb-6",
                onClick: function() {
                    return setIsOpen(!isOpen);
                },
                type: "button",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Subheading */.pm, {
                        variant: "medium",
                        className: "!font-[400] lg:!text-[18px]",
                        children: header
                    }),
                    isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                        className: "w-4 text-current",
                        src: "/svgs/minus.svg#minus",
                        title: "Up",
                        viewBox: "0 0 24 24"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                        className: "w-4 text-current",
                        src: "/svgs/plus.svg#plus",
                        title: "Down",
                        viewBox: "0 0 24 24"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "px-6 pb-4 pr-2 lg:px-10 [&_p]:lg:!text-[16px] [&_p]:lg:!leading-[22px] ".concat(isOpen ? "block" : "hidden"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Markdown */.UG, {
                    children: body
                })
            })
        ]
    });
}
Accordion.displayName = "Accordion";

;// CONCATENATED MODULE: ./src/sections/ArticleContaminantAccordions/ArticleContaminantAccordions.schema.js
function Schema() {
    return {
        category: "Article",
        label: "Article Contaminant Accordions",
        key: "articleContaminantAccordions",
        // previewSrc:
        //   'https://cdn.shopify.com/s/files/1/0671/5074/1778/files/accordions-preview.jpg?v=1675730300',
        fields: [
            {
                name: "title",
                component: "text",
                label: "Title",
                description: "Leave Blank to hide from Table of Contents"
            },
            {
                name: "anchorId",
                component: "text",
                label: "Table Of Contents Title",
                description: "Leave Blank to hide from Table of Contents"
            },
            {
                label: "Heading",
                name: "heading",
                component: "text",
                defaultValue: "Accordions Heading"
            },
            {
                label: "Desktop Image",
                name: "desktopImage",
                component: "image"
            },
            {
                label: "Mobile Image",
                name: "mobileImage",
                component: "image"
            },
            {
                label: "Accordions",
                name: "accordions",
                component: "group-list",
                itemProps: {
                    label: "{{item.header}}"
                },
                fields: [
                    {
                        label: "Header",
                        name: "header",
                        component: "text"
                    },
                    {
                        label: "Body",
                        name: "body",
                        component: "markdown"
                    },
                    {
                        label: "Default Open",
                        name: "defaultOpen",
                        component: "toggle",
                        description: "Sets accordion to be open by default",
                        toggleLabels: {
                            true: "On",
                            false: "Off"
                        }
                    }, 
                ],
                defaultValue: [
                    {
                        header: "Excepteur sint occaecat cupidatat non proident?",
                        body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
                        defaultOpen: true
                    },
                    {
                        header: "Excepteur sint occaecat cupidatat non proident?",
                        body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
                        defaultOpen: false
                    },
                    {
                        header: "Excepteur sint occaecat cupidatat non proident?",
                        body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
                        defaultOpen: false
                    },
                    {
                        header: "Excepteur sint occaecat cupidatat non proident?",
                        body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
                        defaultOpen: false
                    }, 
                ],
                defaultItem: {
                    header: "Excepteur sint occaecat cupidatat non proident?",
                    body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
                    defaultOpen: false
                }
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/ArticleContaminantAccordions/ArticleContaminantAccordions.jsx





function ArticleContaminantAccordions(param) {
    var cms = param.cms;
    var accordions = cms.accordions, heading = cms.heading, title = cms.title, desktopImage = cms.desktopImage, mobileImage = cms.mobileImage;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mb-8 lg:mb-16",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mx-auto max-w-[1100px]",
                children: [
                    heading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Headline */.s0, {
                        variant: "h4",
                        element: "h4",
                        className: "flex justify-between border border-b-0 border-[#DDE2E7] px-6 pb-4 pt-4 lg:px-10 lg:pb-6 lg:pt-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "!text-primary",
                                children: heading
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                width: "42px",
                                height: "42px",
                                alt: "icon",
                                className: "hidden lg:block",
                                src: "https://cdn.shopify.com/s/files/1/1011/0318/files/Vector_7.png?v=1688148078"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                width: "31px",
                                height: "31px",
                                alt: "icon",
                                className: "lg:hidden",
                                src: "https://cdn.shopify.com/s/files/1/1011/0318/files/Vector_7.png?v=1688148078"
                            })
                        ]
                    }),
                    desktopImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative w-full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                            width: "765px",
                            height: "275px",
                            className: "border border-[#DDE2E7]",
                            alt: heading,
                            src: desktopImage === null || desktopImage === void 0 ? void 0 : desktopImage.src,
                            quality: "90"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "grid grid-cols-1 gap-4 border border-t-0 border-[#DDE2E7] text-primary",
                        children: accordions === null || accordions === void 0 ? void 0 : accordions.map(function(accordion, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion, {
                                    accordion: accordion
                                })
                            }, index);
                        })
                    })
                ]
            })
        })
    });
}
ArticleContaminantAccordions.displayName = "ArticleContaminantAccordions";
ArticleContaminantAccordions.Schema = Schema;

;// CONCATENATED MODULE: ./src/sections/ArticleContaminantAccordions/index.js


// EXTERNAL MODULE: ./src/utils/handleize.js
var handleize = __webpack_require__(5979);
;// CONCATENATED MODULE: ./src/utils/useMediaQuery.js

function useMediaQuery(query) {
    var handleChange = function handleChange() {
        setMatches(getMatches(query));
    };
    var getMatches = function(newQuery) {
        // Prevents SSR issues
        if (true) {
            return window.matchMedia(newQuery).matches;
        }
        return false;
    };
    var ref = (0,react.useState)(getMatches(query)), matches = ref[0], setMatches = ref[1];
    (0,react.useEffect)(function() {
        var matchMedia = window.matchMedia(query);
        // Triggered at the first client-side load and if query changes
        handleChange();
        // Listen matchMedia
        if (matchMedia.addListener) {
            matchMedia.addListener(handleChange);
        } else {
            matchMedia.addEventListener("change", handleChange);
        }
        return function() {
            if (matchMedia.removeListener) {
                matchMedia.removeListener(handleChange);
            } else {
                matchMedia.removeEventListener("change", handleChange);
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        query
    ]);
    return matches;
}
/* harmony default export */ var utils_useMediaQuery = (useMediaQuery);

;// CONCATENATED MODULE: ./src/sections/ArticleContaminantFacts/ArticleContaminantFacts.schema.js
var ArticleContaminantFacts_schema_Schema = function() {
    return {
        category: "Article",
        label: "Article Contaminant Facts",
        key: "articleContaminantFacts",
        //   previewSrc:
        //     'https://cdn.shopify.com/s/files/1/1011/0318/files/Screen_20Shot_202023-05-24_20at_202.55.23_20PM.png?v=1684965343',
        fields: [
            {
                name: "title",
                component: "text",
                label: "Title",
                description: "Leave Blank to hide from Table of Contents"
            },
            {
                name: "anchorId",
                component: "text",
                label: "Table Of Contents Title",
                description: "Leave Blank to hide from Table of Contents"
            },
            {
                name: "header",
                component: "text",
                label: "Header",
                defaultValue: "Contamination Facts"
            },
            {
                label: "Facts",
                name: "facts",
                validate: {
                    maxItems: 3
                },
                component: "group-list",
                itemProps: {
                    label: "{{item.header}}"
                },
                fields: [
                    {
                        label: "Header",
                        name: "header",
                        component: "text"
                    },
                    {
                        label: "Copy",
                        name: "copy",
                        component: "text"
                    }, 
                ],
                defaultValue: [
                    {
                        header: "50",
                        copy: "SATES AFFECTED"
                    },
                    {
                        header: "252M",
                        copy: "PEOPLE EFFECTED"
                    },
                    {
                        header: "7/10",
                        copy: "TOXICITY RATING"
                    }, 
                ],
                defaultItem: {
                    header: "50",
                    copy: "SATES AFFECTED"
                }
            },
            {
                component: "group",
                name: "guideline",
                label: "Guideline",
                fields: [
                    {
                        name: "guidelineheader",
                        component: "text",
                        label: "Guideline Header",
                        defaultValue: "Health Guideline vs Legal Limit"
                    },
                    {
                        name: "guidelineLeftSideHeading",
                        component: "text",
                        label: "Guideline Left Side Heading",
                        defaultValue: "Health Guideline"
                    },
                    {
                        name: "guidelineLeftSideCopy",
                        component: "text",
                        label: "Guideline Left Side Copy",
                        defaultValue: "none"
                    },
                    {
                        name: "guidelineLeftSideMarker",
                        component: "number",
                        label: "Guideline Left Side Marker (%)",
                        description: "Enter a number between 0 and 100",
                        defaultValue: "0"
                    },
                    {
                        name: "guidelineLeftSideMarkerMobile",
                        component: "number",
                        label: "Guideline Left Side Marker on Mobile (%)",
                        description: "Enter a number between 0 and 100",
                        defaultValue: "0"
                    },
                    {
                        name: "guidelineRightSideHeading",
                        component: "text",
                        label: "Guideline Right Side Heading",
                        defaultValue: "Legal Limit"
                    },
                    {
                        name: "guidelineRightSideCopy",
                        component: "text",
                        label: "Guideline Right Side Copy",
                        defaultValue: "4ppm"
                    },
                    {
                        name: "guidelineRightSideMarker",
                        component: "number",
                        label: "Guideline Right Side Marker (%)",
                        description: "Enter a number between 0 and 100",
                        defaultValue: "19"
                    },
                    {
                        name: "guidelineRightSideMarkerMobile",
                        component: "number",
                        label: "Guideline Right Side Marker on Mobile (%)",
                        description: "Enter a number between 0 and 100",
                        defaultValue: "35"
                    }, 
                ]
            },
            {
                label: "Desktop Image",
                name: "desktopImage",
                component: "image"
            },
            {
                label: "Mobile Image",
                name: "mobileImage",
                component: "image"
            }, 
        ]
    };
};

;// CONCATENATED MODULE: ./src/sections/ArticleContaminantFacts/ArticleContaminantFacts.jsx






function ArticleContaminantFacts(param) {
    var cms = param.cms;
    var title = cms.title, anchorId = cms.anchorId, header = cms.header, facts = cms.facts, guideline = cms.guideline, oldGuidelineHeader = cms.guidelineheader, desktopImage = cms.desktopImage, mobileImage = cms.mobileImage;
    var guidelineheader = (guideline === null || guideline === void 0 ? void 0 : guideline.guidelineheader) || oldGuidelineHeader;
    var guidelineLeftSideHeading = guideline === null || guideline === void 0 ? void 0 : guideline.guidelineLeftSideHeading;
    var guidelineLeftSideCopy = guideline === null || guideline === void 0 ? void 0 : guideline.guidelineLeftSideCopy;
    var guidelineLeftSideMarker = guideline === null || guideline === void 0 ? void 0 : guideline.guidelineLeftSideMarker;
    var guidelineLeftSideMarkerMobile = guideline === null || guideline === void 0 ? void 0 : guideline.guidelineLeftSideMarkerMobile;
    var guidelineRightSideHeading = guideline === null || guideline === void 0 ? void 0 : guideline.guidelineRightSideHeading;
    var guidelineRightSideCopy = guideline === null || guideline === void 0 ? void 0 : guideline.guidelineRightSideCopy;
    var guidelineRightSideMarker = guideline === null || guideline === void 0 ? void 0 : guideline.guidelineRightSideMarker;
    var guidelineRightSideMarkerMobile = guideline === null || guideline === void 0 ? void 0 : guideline.guidelineRightSideMarkerMobile;
    var isMobile = utils_useMediaQuery("(max-width: 767px)");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative mb-8 font-light lg:mb-16",
        children: [
            anchorId && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: (0,handleize/* default */.Z)(anchorId),
                className: "absolute top-16"
            }),
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                variant: "h4",
                element: "h4",
                className: "border-t border-[#DDE2E7] pb-4 pt-12 lg:pb-16",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-[1px] w-full bg-[#DDE2E7]"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                variant: "h6",
                element: "h6",
                className: "pb-4 pt-8 text-primary max-md:!text-[16px] lg:pb-6",
                children: header
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-8 grid items-center justify-around gap-6 gap-y-10 pb-12 lg:grid-cols-3 lg:pb-24",
                children: facts.map(function(param, index) {
                    var headerText = param.header, copy = param.copy;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "rounded-lg bg-gradient-to-r from-[#F1DCC1] via-[#8DCEF9] to-[#2179C2] p-[1px] text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "rounded-lg bg-[#F2F7FB] px-6 py-4 text-primary",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                                    variant: "h3",
                                    element: "h3",
                                    className: "pb-4 max-lg:!text-[52px] lg:pb-4",
                                    children: headerText
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "h-[1px] w-full bg-gradient-to-r from-[#F1DCC1] via-[#8DCEF9] to-[#2179C2]"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "pt-4 font-mono",
                                    children: copy
                                })
                            ]
                        })
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-[1px] w-full bg-[#DDE2E7] text-primary"
            }),
            guidelineheader ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                variant: "h6",
                element: "h6",
                className: "pb-4 pt-8 max-md:!text-[16px] lg:pb-12",
                children: guidelineheader
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pb-4 pt-8 lg:pb-12"
            }),
            (guidelineLeftSideHeading || guidelineLeftSideCopy || guidelineRightSideHeading || guidelineRightSideCopy) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative overflow-hidden border border-[#DDE2E7] pb-7",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute bottom-0 left-0 right-0 h-7",
                        style: {
                            background: "linear-gradient(90deg, #F3DCC1 0%, #8DCFF9 50%, #207AC2 100%)"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute bottom-0 right-0 h-7 w-[1px] border-r border-dashed border-[#777]",
                        style: {
                            right: "".concat(isMobile ? guidelineRightSideMarkerMobile : guidelineRightSideMarker, "%")
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute bottom-0 right-0 h-7 w-[1px] border-r border-dashed border-[#777]",
                        style: {
                            left: "".concat(isMobile ? guidelineLeftSideMarkerMobile : guidelineLeftSideMarker, "%")
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                        className: "w-full [&_td]:px-3 [&_td]:pb-2 [&_th]:px-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            className: "text-left",
                                            style: {
                                                width: "".concat(100 - (isMobile ? guidelineRightSideMarkerMobile : guidelineRightSideMarker), "%")
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "tracking-wide font-mono text-xs font-normal uppercase md:text-sm",
                                                children: guidelineLeftSideHeading
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            className: "text-left",
                                            style: {
                                                width: "".concat(isMobile ? guidelineRightSideMarkerMobile : guidelineRightSideMarker, "%")
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "tracking-wide font-mono text-xs font-normal uppercase md:text-sm",
                                                children: guidelineRightSideHeading
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            className: "text-left",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-sm md:text-lg",
                                                children: guidelineLeftSideCopy
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            className: "text-left",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-sm md:text-lg",
                                                children: guidelineRightSideCopy
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            desktopImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative hidden w-full lg:block",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                    width: "765px",
                    height: "275px",
                    className: "border border-[#DDE2E7]",
                    alt: guidelineheader,
                    src: desktopImage === null || desktopImage === void 0 ? void 0 : desktopImage.src,
                    quality: "90"
                })
            }),
            mobileImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative w-full pb-8 lg:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                    width: "765px",
                    height: "275px",
                    className: "border border-[#DDE2E7]",
                    alt: guidelineheader,
                    src: mobileImage === null || mobileImage === void 0 ? void 0 : mobileImage.src,
                    quality: "90"
                })
            })
        ]
    });
}
ArticleContaminantFacts.displayName = "ArticleContaminantFacts";
ArticleContaminantFacts.Schema = ArticleContaminantFacts_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/ArticleContaminantFacts/index.js


;// CONCATENATED MODULE: ./src/sections/ArticleContaminantTable/ArticleContaminantTable.schema.js
var ArticleContaminantTable_schema_Schema = function() {
    return {
        category: "Article",
        label: "Article Contaminant Table",
        key: "articleContaminantTable",
        //   previewSrc:
        //     'https://cdn.shopify.com/s/files/1/1011/0318/files/Screen_20Shot_202023-05-24_20at_202.55.23_20PM.png?v=1684965343',
        fields: [
            {
                name: "title",
                component: "text",
                label: "Title",
                description: "Leave Blank to hide from Table of Contents"
            },
            {
                name: "anchorId",
                component: "text",
                label: "Table Of Contents Title",
                description: "Leave Blank to hide from Table of Contents"
            },
            {
                label: "Table Group Header",
                name: "tableGroupHeader",
                validate: {
                    maxItems: 2
                },
                component: "group-list",
                itemProps: {
                    label: "{{item.header}}"
                },
                fields: [
                    {
                        label: "Header",
                        name: "header",
                        component: "text"
                    }, 
                ],
                defaultValue: [
                    {
                        header: "Clearly Filtered Products with Affinity Filtration Technology"
                    },
                    {
                        header: "Flouride in tap water Removal"
                    }, 
                ],
                defaultItem: {
                    header: "Clearly Filtered Products with Affinity Filtration Technology"
                }
            },
            {
                label: "Table Group Rows",
                name: "tableGroupRows",
                component: "group-list",
                itemProps: {
                    label: "{{item.leftColumn}}"
                },
                fields: [
                    {
                        label: "Left Column",
                        name: "leftColumn",
                        component: "text"
                    },
                    {
                        label: "Right Column",
                        name: "rightColumn",
                        component: "text"
                    }, 
                ],
                defaultValue: [
                    {
                        leftColumn: "Water Pitcher Filter",
                        rightColumn: "98.3%"
                    },
                    {
                        leftColumn: "Under the Sink Filter",
                        rightColumn: "98.3%"
                    },
                    {
                        leftColumn: "Refrigerator Filter",
                        rightColumn: "98.3%"
                    }, 
                ],
                defaultItem: {
                    leftColumn: "Water Pitcher Filter",
                    rightColumn: "98.3%"
                }
            }, 
        ]
    };
};

;// CONCATENATED MODULE: ./src/sections/ArticleContaminantTable/ArticleContaminantTable.jsx




function ArticleContaminantTable(param) {
    var cms = param.cms;
    var title = cms.title, anchorId = cms.anchorId, tableGroupHeader = cms.tableGroupHeader, tableGroupRows = cms.tableGroupRows;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative mb-8 font-light lg:mb-16",
        children: [
            anchorId && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: (0,handleize/* default */.Z)(anchorId),
                className: "absolute top-16"
            }),
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                variant: "h4",
                element: "h4",
                className: "border-t border-[#DDE2E7] pb-4 pt-12 lg:pb-16",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid grid-cols-2 items-center justify-around gap-6 gap-y-10",
                style: {
                    background: "linear-gradient(270deg, #5B71A1 0%, #536896 10.94%, #4D618E 19.27%, #354974 33.84%, #354C7A 50.38%, #3C5280 65.88%, #3A4C79 77.84%, #232F54 100%)"
                },
                children: tableGroupHeader.map(function(param, index) {
                    var header = param.header;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "font-white px-4 pt-4 pb-4 font-light text-white lg:pr-8",
                            children: header
                        })
                    }, index);
                })
            }),
            tableGroupRows.map(function(param, index) {
                var leftColumn = param.leftColumn, rightColumn = param.rightColumn;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid grid-cols-2 items-center justify-around gap-6 gap-y-10 border border-[#DDE2E7]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "border-r border-[#DDE2E7] px-4 pt-6 pb-6 font-light lg:pr-8",
                                children: leftColumn
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "px-4 pt-6 pb-6 font-light lg:pr-8",
                                children: rightColumn
                            })
                        })
                    ]
                }, index);
            })
        ]
    });
}
ArticleContaminantTable.displayName = "ArticleContaminantTable";
ArticleContaminantTable.Schema = ArticleContaminantTable_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/ArticleContaminantTable/index.js


;// CONCATENATED MODULE: ./src/sections/ArticleContent/ArticleContent.schema.js
var ArticleContent_schema_Schema = function() {
    return {
        category: "Article",
        label: "Article Content",
        key: "articleContent",
        //   previewSrc:
        //     'https://cdn.shopify.com/s/files/1/1011/0318/files/Screen_20Shot_202023-05-24_20at_202.55.23_20PM.png?v=1684965343',
        fields: [
            {
                name: "title",
                component: "text",
                label: "Title"
            },
            {
                name: "anchorId",
                component: "text",
                label: "Table Of Contents Title",
                description: "Leave Blank to hide from Table of Contents"
            },
            {
                label: "Content",
                name: "content",
                component: "markdown",
                defaultValue: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
            }, 
        ]
    };
};

;// CONCATENATED MODULE: ./src/sections/ArticleContent/ArticleContent.jsx
/* eslint-disable react/no-unstable-nested-components */ 




function ArticleContent(param) {
    var cms = param.cms;
    var title = cms.title, anchorId = cms.anchorId, content = cms.content;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "article-content relative mb-8 font-light lg:mb-16",
        children: [
            anchorId && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: (0,handleize/* default */.Z)(anchorId),
                className: "absolute top-16"
            }),
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                variant: "h3",
                element: "h2",
                className: "border-t border-[#DDE2E7] pb-4 pt-12 text-primary lg:pb-8",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Markdown */.UG, {
                className: "text-primary",
                components: {
                    h1: function h1(data) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                            variant: "h1",
                            element: "h1",
                            children: data.children
                        });
                    },
                    h2: function h2(data) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                            variant: "h3",
                            element: "h2",
                            children: data.children
                        });
                    },
                    h3: function h3(data) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                            variant: "h4",
                            element: "h3",
                            children: data.children
                        });
                    },
                    h4: function h4(data) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                            variant: "h5",
                            element: "h4",
                            children: data.children
                        });
                    },
                    h5: function h5(data) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                            variant: "h6",
                            element: "h5",
                            children: data.children
                        });
                    }
                },
                children: content
            })
        ]
    });
}
ArticleContent.displayName = "/ArticleContent";
ArticleContent.Schema = ArticleContent_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/ArticleContent/index.js


;// CONCATENATED MODULE: ./src/sections/ArticleFiftyFifty/ArticleFiftyFifty.schema.js
function ArticleFiftyFifty_schema_Schema() {
    return {
        category: "Article",
        label: "Article Fifty Fifty Image",
        key: "articleFiftyFifty",
        // previewSrc:
        //   'https://cdn.shopify.com/s/files/1/1011/0318/files/Screen_20Shot_202023-05-23_20at_2010.45.53_20AM.png?v=1684864558',
        fields: [
            {
                name: "title",
                component: "text",
                label: "Title"
            },
            {
                name: "anchorId",
                component: "text",
                label: "Table Of Contents Title",
                description: "Leave Blank to hide from Table of Contents"
            },
            {
                label: "Image",
                name: "image",
                component: "image"
            },
            {
                label: "Image Caption",
                name: "caption",
                component: "text"
            },
            {
                label: "Image Attribution",
                name: "attribution",
                component: "text"
            },
            {
                label: "Image Attribution Link",
                name: "attributionLink",
                component: "link"
            },
            {
                label: "Eyebrow",
                name: "eyebrow",
                component: "text",
                defaultValue: "GET PEACE OF MIND"
            },
            {
                label: "Heading",
                name: "heading",
                component: "text",
                defaultValue: "Shop the most powerful filtration systems on the planet."
            },
            {
                label: "Copy",
                name: "copy",
                component: "text",
                defaultValue: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
            },
            {
                label: "Link",
                name: "link",
                component: "link"
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/ArticleFiftyFifty/ArticleFiftyFifty.jsx




function ArticleFiftyFifty(param) {
    var cms = param.cms;
    var title = cms.title, anchorId = cms.anchorId, heading = cms.heading, eyebrow = cms.eyebrow, copy = cms.copy, link = cms.link, image = cms.image, caption = cms.caption, attribution = cms.attribution, attributionLink = cms.attributionLink;
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative mb-8 border-b border-t border-[#DDE2E7] lg:mb-16",
        children: [
            anchorId && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: (0,handleize/* default */.Z)(anchorId),
                className: "absolute top-16"
            }),
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                variant: "h4",
                element: "h4",
                className: "border-t border-[#DDE2E7] pb-4 pt-12 lg:pb-16",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "items-center overflow-hidden py-12 lg:flex lg:py-12",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "lg:w-1/2",
                        children: image && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mb-6 lg:mb-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                                    href: (ref = link === null || link === void 0 ? void 0 : link.url) !== null && ref !== void 0 ? ref : "",
                                    className: "lg:block",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                        className: "",
                                        sizes: "48px",
                                        width: "370px",
                                        height: "370px",
                                        src: image.src
                                    })
                                }),
                                (caption || attribution) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Attribution */.xn, {
                                    caption: caption,
                                    attribution: attribution,
                                    attributionLink: attributionLink
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(snippets/* Link */.rU, {
                        href: (ref1 = link === null || link === void 0 ? void 0 : link.url) !== null && ref1 !== void 0 ? ref1 : "",
                        className: "lg:w-1/2 lg:pl-8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Eyebrow */.j4, {
                                className: "mb-4",
                                children: eyebrow
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                                variant: "h5",
                                element: "h5",
                                children: heading
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Body */.uT, {
                                variant: "medium",
                                className: "mx-auto mb-6 mt-6 lg:mb-12",
                                children: copy
                            }),
                            link && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "cta-group flex gap-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Button */.zx, {
                                    variant: "filled",
                                    theme: "primary",
                                    children: link.text
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
ArticleFiftyFifty.displayName = "ArticleFiftyFifty";
ArticleFiftyFifty.Schema = ArticleFiftyFifty_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/ArticleFiftyFifty/index.js


;// CONCATENATED MODULE: ./src/sections/ArticleHero/ArticleHero.schema.js
var ArticleHero_schema_Schema = function() {
    return {
        category: "Article",
        label: "Article Hero",
        key: "articleHero",
        // previewSrc:
        //   'https://cdn.shopify.com/s/files/1/1011/0318/files/collection-hero.png',
        fields: [
            {
                name: "category",
                component: "text",
                label: "Category",
                defaultValue: "News"
            },
            {
                name: "articleTime",
                component: "text",
                label: "Article Time",
                defaultValue: "5"
            },
            {
                name: "title",
                component: "text",
                label: "Title"
            },
            {
                name: "mediaImage",
                component: "image",
                label: "Accompanying Image"
            },
            {
                name: "mediaVideo",
                component: "text",
                label: "Accompanying Video",
                description: "Accompanying Video will always be used in place of Accompanying Image."
            },
            {
                label: "Background Color",
                name: "backgroundColor",
                component: "select",
                options: [
                    {
                        label: "Blue",
                        value: "blue"
                    },
                    {
                        label: "Red",
                        value: "red"
                    }, 
                ],
                defaultValue: "blue"
            },
            {
                name: "mediaPlacement",
                component: "select",
                label: "Media Placement",
                options: [
                    {
                        label: "Left",
                        value: "left"
                    },
                    {
                        label: "Right",
                        value: "right"
                    }, 
                ],
                defaultValue: "left"
            },
            {
                label: "Center Content",
                name: "centerContent",
                component: "toggle",
                toggleLabels: {
                    true: "On",
                    false: "Off"
                },
                defaultValue: false
            }, 
        ]
    };
};

// EXTERNAL MODULE: ./src/snippets/Svg/index.js
var Svg = __webpack_require__(7342);
;// CONCATENATED MODULE: ../node_modules/react-share/es/utils/objectToGetParams.js
function objectToGetParams(object) {
    var params = Object.entries(object)
        .filter(function (_a) {
        var value = _a[1];
        return value !== undefined && value !== null;
    })
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(String(value)));
    });
    return params.length > 0 ? "?".concat(params.join('&')) : '';
}

// EXTERNAL MODULE: ../node_modules/classnames/index.js
var classnames = __webpack_require__(5);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ../node_modules/react-share/es/ShareButton.js
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


var isPromise = function (obj) {
    return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
};
var getBoxPositionOnWindowCenter = function (width, height) { return ({
    left: window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - width / 2,
    top: window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - height / 2,
}); };
var getBoxPositionOnScreenCenter = function (width, height) { return ({
    top: (window.screen.height - height) / 2,
    left: (window.screen.width - width) / 2,
}); };
function windowOpen(url, _a, onClose) {
    var height = _a.height, width = _a.width, configRest = __rest(_a, ["height", "width"]);
    var config = __assign({ height: height, width: width, location: 'no', toolbar: 'no', status: 'no', directories: 'no', menubar: 'no', scrollbars: 'yes', resizable: 'no', centerscreen: 'yes', chrome: 'yes' }, configRest);
    var shareDialog = window.open(url, '', Object.keys(config)
        .map(function (key) { return "".concat(key, "=").concat(config[key]); })
        .join(', '));
    if (onClose) {
        var interval_1 = window.setInterval(function () {
            try {
                if (shareDialog === null || shareDialog.closed) {
                    window.clearInterval(interval_1);
                    onClose(shareDialog);
                }
            }
            catch (e) {
                /* eslint-disable no-console */
                console.error(e);
                /* eslint-enable no-console */
            }
        }, 1000);
    }
    return shareDialog;
}
var ShareButton = /** @class */ (function (_super) {
    __extends(ShareButton, _super);
    function ShareButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.openShareDialog = function (link) {
            var _a = _this.props, onShareWindowClose = _a.onShareWindowClose, _b = _a.windowHeight, windowHeight = _b === void 0 ? 400 : _b, _c = _a.windowPosition, windowPosition = _c === void 0 ? 'windowCenter' : _c, _d = _a.windowWidth, windowWidth = _d === void 0 ? 550 : _d;
            var windowConfig = __assign({ height: windowHeight, width: windowWidth }, (windowPosition === 'windowCenter'
                ? getBoxPositionOnWindowCenter(windowWidth, windowHeight)
                : getBoxPositionOnScreenCenter(windowWidth, windowHeight)));
            windowOpen(link, windowConfig, onShareWindowClose);
        };
        _this.handleClick = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var _a, beforeOnClick, disabled, networkLink, onClick, url, openShareDialogOnClick, opts, link, returnVal;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, beforeOnClick = _a.beforeOnClick, disabled = _a.disabled, networkLink = _a.networkLink, onClick = _a.onClick, url = _a.url, openShareDialogOnClick = _a.openShareDialogOnClick, opts = _a.opts;
                        link = networkLink(url, opts);
                        if (disabled) {
                            return [2 /*return*/];
                        }
                        event.preventDefault();
                        if (!beforeOnClick) return [3 /*break*/, 2];
                        returnVal = beforeOnClick();
                        if (!isPromise(returnVal)) return [3 /*break*/, 2];
                        return [4 /*yield*/, returnVal];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        if (openShareDialogOnClick) {
                            this.openShareDialog(link);
                        }
                        if (onClick) {
                            onClick(event, link);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    ShareButton.prototype.render = function () {
        var _a = this.props, beforeOnClick = _a.beforeOnClick, children = _a.children, className = _a.className, disabled = _a.disabled, disabledStyle = _a.disabledStyle, forwardedRef = _a.forwardedRef, networkLink = _a.networkLink, networkName = _a.networkName, onShareWindowClose = _a.onShareWindowClose, openShareDialogOnClick = _a.openShareDialogOnClick, opts = _a.opts, resetButtonStyle = _a.resetButtonStyle, style = _a.style, url = _a.url, windowHeight = _a.windowHeight, windowPosition = _a.windowPosition, windowWidth = _a.windowWidth, rest = __rest(_a, ["beforeOnClick", "children", "className", "disabled", "disabledStyle", "forwardedRef", "networkLink", "networkName", "onShareWindowClose", "openShareDialogOnClick", "opts", "resetButtonStyle", "style", "url", "windowHeight", "windowPosition", "windowWidth"]);
        var newClassName = classnames_default()('react-share__ShareButton', {
            'react-share__ShareButton--disabled': !!disabled,
            disabled: !!disabled,
        }, className);
        var newStyle = resetButtonStyle
            ? __assign(__assign({ backgroundColor: 'transparent', border: 'none', padding: 0, font: 'inherit', color: 'inherit', cursor: 'pointer' }, style), (disabled && disabledStyle)) : __assign(__assign({}, style), (disabled && disabledStyle));
        return (react.createElement("button", __assign({}, rest, { "aria-label": rest['aria-label'] || networkName, className: newClassName, onClick: this.handleClick, ref: forwardedRef, style: newStyle }), children));
    };
    ShareButton.defaultProps = {
        disabledStyle: { opacity: 0.6 },
        openShareDialogOnClick: true,
        resetButtonStyle: true,
    };
    return ShareButton;
}(react.Component));
/* harmony default export */ var es_ShareButton = (ShareButton);

;// CONCATENATED MODULE: ../node_modules/react-share/es/hocs/createShareButton.js
var createShareButton_assign = (undefined && undefined.__assign) || function () {
    createShareButton_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return createShareButton_assign.apply(this, arguments);
};


function createShareButton(networkName, link, optsMap, defaultProps) {
    function CreatedButton(props, ref) {
        var opts = optsMap(props);
        var passedProps = createShareButton_assign({}, props);
        // remove keys from passed props that are passed as opts
        var optsKeys = Object.keys(opts);
        optsKeys.forEach(function (key) {
            delete passedProps[key];
        });
        return (react.createElement(es_ShareButton, createShareButton_assign({}, defaultProps, passedProps, { forwardedRef: ref, networkName: networkName, networkLink: link, opts: optsMap(props) })));
    }
    CreatedButton.displayName = "ShareButton-".concat(networkName);
    return (0,react.forwardRef)(CreatedButton);
}
/* harmony default export */ var hocs_createShareButton = (createShareButton);

;// CONCATENATED MODULE: ../node_modules/react-share/es/EmailShareButton.js


function emailLink(url, _a) {
    var subject = _a.subject, body = _a.body, separator = _a.separator;
    return 'mailto:' + objectToGetParams({ subject: subject, body: body ? body + separator + url : url });
}
var EmailShareButton = hocs_createShareButton('email', emailLink, function (props) { return ({
    subject: props.subject,
    body: props.body,
    separator: props.separator || ' ',
}); }, {
    openShareDialogOnClick: false,
    onClick: function (_, link) {
        window.location.href = link;
    },
});
/* harmony default export */ var es_EmailShareButton = (EmailShareButton);

;// CONCATENATED MODULE: ../node_modules/react-share/es/utils/assert.js
var assert_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var AssertionError = /** @class */ (function (_super) {
    assert_extends(AssertionError, _super);
    function AssertionError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = 'AssertionError';
        return _this;
    }
    return AssertionError;
}(Error));
function assert(value, message) {
    if (!value) {
        throw new AssertionError(message);
    }
}

;// CONCATENATED MODULE: ../node_modules/react-share/es/LinkedinShareButton.js



function linkedinLink(url, _a) {
    var title = _a.title, summary = _a.summary, source = _a.source;
    assert(url, 'linkedin.url');
    return ('https://linkedin.com/shareArticle' +
        objectToGetParams({ url: url, mini: 'true', title: title, summary: summary, source: source }));
}
var LinkedinShareButton = hocs_createShareButton('linkedin', linkedinLink, function (_a) {
    var title = _a.title, summary = _a.summary, source = _a.source;
    return ({ title: title, summary: summary, source: source });
}, {
    windowWidth: 750,
    windowHeight: 600,
});
/* harmony default export */ var es_LinkedinShareButton = (LinkedinShareButton);

;// CONCATENATED MODULE: ../node_modules/react-share/es/FacebookShareButton.js



function facebookLink(url, _a) {
    var quote = _a.quote, hashtag = _a.hashtag;
    assert(url, 'facebook.url');
    return ('https://www.facebook.com/sharer/sharer.php' +
        objectToGetParams({
            u: url,
            quote: quote,
            hashtag: hashtag,
        }));
}
var FacebookShareButton = hocs_createShareButton('facebook', facebookLink, function (props) { return ({
    quote: props.quote,
    hashtag: props.hashtag,
}); }, {
    windowWidth: 550,
    windowHeight: 400,
});
/* harmony default export */ var es_FacebookShareButton = (FacebookShareButton);

;// CONCATENATED MODULE: ../node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */

const floating_ui_utils_sides = (/* unused pure expression or super */ null && (['top', 'right', 'bottom', 'left']));
const alignments = (/* unused pure expression or super */ null && (['start', 'end']));
const floating_ui_utils_placements = /*#__PURE__*/(/* unused pure expression or super */ null && (floating_ui_utils_sides.reduce((acc, side) => acc.concat(side, side + "-" + alignments[0], side + "-" + alignments[1]), [])));
const floating_ui_utils_min = Math.min;
const floating_ui_utils_max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = v => ({
  x: v,
  y: v
});
const oppositeSideMap = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
const oppositeAlignmentMap = {
  start: 'end',
  end: 'start'
};
function clamp(start, value, end) {
  return floating_ui_utils_max(start, floating_ui_utils_min(value, end));
}
function floating_ui_utils_evaluate(value, param) {
  return typeof value === 'function' ? value(param) : value;
}
function floating_ui_utils_getSide(placement) {
  return placement.split('-')[0];
}
function floating_ui_utils_getAlignment(placement) {
  return placement.split('-')[1];
}
function floating_ui_utils_getOppositeAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
function getAxisLength(axis) {
  return axis === 'y' ? 'height' : 'width';
}
function floating_ui_utils_getSideAxis(placement) {
  return ['top', 'bottom'].includes(floating_ui_utils_getSide(placement)) ? 'y' : 'x';
}
function getAlignmentAxis(placement) {
  return floating_ui_utils_getOppositeAxis(floating_ui_utils_getSideAxis(placement));
}
function floating_ui_utils_getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = floating_ui_utils_getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [floating_ui_utils_getOppositeAlignmentPlacement(placement), oppositePlacement, floating_ui_utils_getOppositeAlignmentPlacement(oppositePlacement)];
}
function floating_ui_utils_getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, alignment => oppositeAlignmentMap[alignment]);
}
function getSideList(side, isStart, rtl) {
  const lr = ['left', 'right'];
  const rl = ['right', 'left'];
  const tb = ['top', 'bottom'];
  const bt = ['bottom', 'top'];
  switch (side) {
    case 'top':
    case 'bottom':
      if (rtl) return isStart ? rl : lr;
      return isStart ? lr : rl;
    case 'left':
    case 'right':
      return isStart ? tb : bt;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = floating_ui_utils_getAlignment(placement);
  let list = getSideList(floating_ui_utils_getSide(placement), direction === 'start', rtl);
  if (alignment) {
    list = list.map(side => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(floating_ui_utils_getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, side => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function floating_ui_utils_getPaddingObject(padding) {
  return typeof padding !== 'number' ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function floating_ui_utils_rectToClientRect(rect) {
  return {
    ...rect,
    top: rect.y,
    left: rect.x,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  };
}



;// CONCATENATED MODULE: ../node_modules/@floating-ui/core/dist/floating-ui.core.mjs



function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const sideAxis = floating_ui_utils_getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = floating_ui_utils_getSide(placement);
  const isVertical = sideAxis === 'y';
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case 'top':
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case 'bottom':
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case 'right':
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case 'left':
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (floating_ui_utils_getAlignment(placement)) {
    case 'start':
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case 'end':
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */
const computePosition = async (reference, floating, config) => {
  const {
    placement = 'bottom',
    strategy = 'absolute',
    middleware = [],
    platform
  } = config;
  const validMiddleware = middleware.filter(Boolean);
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
  let rects = await platform.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x,
    y
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i = 0; i < validMiddleware.length; i++) {
    const {
      name,
      fn
    } = validMiddleware[i];
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn({
      x,
      y,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform,
      elements: {
        reference,
        floating
      }
    });
    x = nextX != null ? nextX : x;
    y = nextY != null ? nextY : y;
    middlewareData = {
      ...middlewareData,
      [name]: {
        ...middlewareData[name],
        ...data
      }
    };
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === 'object') {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x,
          y
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i = -1;
    }
  }
  return {
    x,
    y,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};

/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */
async function detectOverflow(state, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x,
    y,
    platform,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = 'clippingAncestors',
    rootBoundary = 'viewport',
    elementContext = 'floating',
    altBoundary = false,
    padding = 0
  } = floating_ui_utils_evaluate(options, state);
  const paddingObject = floating_ui_utils_getPaddingObject(padding);
  const altContext = elementContext === 'floating' ? 'reference' : 'floating';
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = floating_ui_utils_rectToClientRect(await platform.getClippingRect({
    element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || (await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating))),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === 'floating' ? {
    ...rects.floating,
    x,
    y
  } : rects.reference;
  const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
  const offsetScale = (await (platform.isElement == null ? void 0 : platform.isElement(offsetParent))) ? (await (platform.getScale == null ? void 0 : platform.getScale(offsetParent))) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = floating_ui_utils_rectToClientRect(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements,
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow = options => ({
  name: 'arrow',
  options,
  async fn(state) {
    const {
      x,
      y,
      placement,
      rects,
      platform,
      elements,
      middlewareData
    } = state;
    // Since `element` is required, we don't Partial<> the type.
    const {
      element,
      padding = 0
    } = floating_ui_utils_evaluate(options, state) || {};
    if (element == null) {
      return {};
    }
    const paddingObject = floating_ui_utils_getPaddingObject(padding);
    const coords = {
      x,
      y
    };
    const axis = getAlignmentAxis(placement);
    const length = getAxisLength(axis);
    const arrowDimensions = await platform.getDimensions(element);
    const isYAxis = axis === 'y';
    const minProp = isYAxis ? 'top' : 'left';
    const maxProp = isYAxis ? 'bottom' : 'right';
    const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
    const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
    let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;

    // DOM platform can return `window` as the `offsetParent`.
    if (!clientSize || !(await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent)))) {
      clientSize = elements.floating[clientProp] || rects.floating[length];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;

    // If the padding is large enough that it causes the arrow to no longer be
    // centered, modify the padding so that it is centered.
    const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
    const minPadding = floating_ui_utils_min(paddingObject[minProp], largestPossiblePadding);
    const maxPadding = floating_ui_utils_min(paddingObject[maxProp], largestPossiblePadding);

    // Make sure the arrow doesn't overflow the floating element if the center
    // point is outside the floating element's bounds.
    const min$1 = minPadding;
    const max = clientSize - arrowDimensions[length] - maxPadding;
    const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
    const offset = clamp(min$1, center, max);

    // If the reference is small enough that the arrow's padding causes it to
    // to point to nothing for an aligned placement, adjust the offset of the
    // floating element itself. To ensure `shift()` continues to take action,
    // a single reset is performed when this is true.
    const shouldAddOffset = !middlewareData.arrow && floating_ui_utils_getAlignment(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
    const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
    return {
      [axis]: coords[axis] + alignmentOffset,
      data: {
        [axis]: offset,
        centerOffset: center - offset - alignmentOffset,
        ...(shouldAddOffset && {
          alignmentOffset
        })
      },
      reset: shouldAddOffset
    };
  }
});

function getPlacementList(alignment, autoAlignment, allowedPlacements) {
  const allowedPlacementsSortedByAlignment = alignment ? [...allowedPlacements.filter(placement => getAlignment(placement) === alignment), ...allowedPlacements.filter(placement => getAlignment(placement) !== alignment)] : allowedPlacements.filter(placement => getSide(placement) === placement);
  return allowedPlacementsSortedByAlignment.filter(placement => {
    if (alignment) {
      return getAlignment(placement) === alignment || (autoAlignment ? getOppositeAlignmentPlacement(placement) !== placement : false);
    }
    return true;
  });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */
const autoPlacement = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'autoPlacement',
    options,
    async fn(state) {
      var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
      const {
        rects,
        middlewareData,
        placement,
        platform,
        elements
      } = state;
      const {
        crossAxis = false,
        alignment,
        allowedPlacements = placements,
        autoAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);
      const placements$1 = alignment !== undefined || allowedPlacements === placements ? getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
      const currentPlacement = placements$1[currentIndex];
      if (currentPlacement == null) {
        return {};
      }
      const alignmentSides = getAlignmentSides(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));

      // Make `computeCoords` start from the right place.
      if (placement !== currentPlacement) {
        return {
          reset: {
            placement: placements$1[0]
          }
        };
      }
      const currentOverflows = [overflow[getSide(currentPlacement)], overflow[alignmentSides[0]], overflow[alignmentSides[1]]];
      const allOverflows = [...(((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || []), {
        placement: currentPlacement,
        overflows: currentOverflows
      }];
      const nextPlacement = placements$1[currentIndex + 1];

      // There are more placements to check.
      if (nextPlacement) {
        return {
          data: {
            index: currentIndex + 1,
            overflows: allOverflows
          },
          reset: {
            placement: nextPlacement
          }
        };
      }
      const placementsSortedByMostSpace = allOverflows.map(d => {
        const alignment = getAlignment(d.placement);
        return [d.placement, alignment && crossAxis ?
        // Check along the mainAxis and main crossAxis side.
        d.overflows.slice(0, 2).reduce((acc, v) => acc + v, 0) :
        // Check only the mainAxis.
        d.overflows[0], d.overflows];
      }).sort((a, b) => a[1] - b[1]);
      const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter(d => d[2].slice(0,
      // Aligned placements should not check their opposite crossAxis
      // side.
      getAlignment(d[0]) ? 2 : 3).every(v => v <= 0));
      const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
      if (resetPlacement !== placement) {
        return {
          data: {
            index: currentIndex + 1,
            overflows: allOverflows
          },
          reset: {
            placement: resetPlacement
          }
        };
      }
      return {};
    }
  };
};

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const flip = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'flip',
    options,
    async fn(state) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform,
        elements
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = 'bestFit',
        fallbackAxisSideDirection = 'none',
        flipAlignment = true,
        ...detectOverflowOptions
      } = floating_ui_utils_evaluate(options, state);

      // If a reset by the arrow was caused due to an alignment offset being
      // added, we should skip any logic now since `flip()` has already done its
      // work.
      // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
      if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      const side = floating_ui_utils_getSide(placement);
      const isBasePlacement = floating_ui_utils_getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== 'none') {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides = floating_ui_utils_getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides[0]], overflow[sides[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];

      // One or more sides is overflowing.
      if (!overflows.every(side => side <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements[nextIndex];
        if (nextPlacement) {
          // Try next placement and re-run the lifecycle.
          return {
            data: {
              index: nextIndex,
              overflows: overflowsData
            },
            reset: {
              placement: nextPlacement
            }
          };
        }

        // First, find the candidates that fit on the mainAxis side of overflow,
        // then find the placement that fits the best on the main crossAxis side.
        let resetPlacement = (_overflowsData$filter = overflowsData.filter(d => d.overflows[0] <= 0).sort((a, b) => a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;

        // Otherwise fallback.
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case 'bestFit':
              {
                var _overflowsData$map$so;
                const placement = (_overflowsData$map$so = overflowsData.map(d => [d.placement, d.overflows.filter(overflow => overflow > 0).reduce((acc, overflow) => acc + overflow, 0)]).sort((a, b) => a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                if (placement) {
                  resetPlacement = placement;
                }
                break;
              }
            case 'initialPlacement':
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};

function getSideOffsets(overflow, rect) {
  return {
    top: overflow.top - rect.height,
    right: overflow.right - rect.width,
    bottom: overflow.bottom - rect.height,
    left: overflow.left - rect.width
  };
}
function isAnySideFullyClipped(overflow) {
  return sides.some(side => overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */
const hide = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'hide',
    options,
    async fn(state) {
      const {
        rects
      } = state;
      const {
        strategy = 'referenceHidden',
        ...detectOverflowOptions
      } = evaluate(options, state);
      switch (strategy) {
        case 'referenceHidden':
          {
            const overflow = await detectOverflow(state, {
              ...detectOverflowOptions,
              elementContext: 'reference'
            });
            const offsets = getSideOffsets(overflow, rects.reference);
            return {
              data: {
                referenceHiddenOffsets: offsets,
                referenceHidden: isAnySideFullyClipped(offsets)
              }
            };
          }
        case 'escaped':
          {
            const overflow = await detectOverflow(state, {
              ...detectOverflowOptions,
              altBoundary: true
            });
            const offsets = getSideOffsets(overflow, rects.floating);
            return {
              data: {
                escapedOffsets: offsets,
                escaped: isAnySideFullyClipped(offsets)
              }
            };
          }
        default:
          {
            return {};
          }
      }
    }
  };
};

function getBoundingRect(rects) {
  const minX = min(...rects.map(rect => rect.left));
  const minY = min(...rects.map(rect => rect.top));
  const maxX = max(...rects.map(rect => rect.right));
  const maxY = max(...rects.map(rect => rect.bottom));
  return {
    x: minX,
    y: minY,
    width: maxX - minX,
    height: maxY - minY
  };
}
function getRectsByLine(rects) {
  const sortedRects = rects.slice().sort((a, b) => a.y - b.y);
  const groups = [];
  let prevRect = null;
  for (let i = 0; i < sortedRects.length; i++) {
    const rect = sortedRects[i];
    if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) {
      groups.push([rect]);
    } else {
      groups[groups.length - 1].push(rect);
    }
    prevRect = rect;
  }
  return groups.map(rect => rectToClientRect(getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */
const inline = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'inline',
    options,
    async fn(state) {
      const {
        placement,
        elements,
        rects,
        platform,
        strategy
      } = state;
      // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
      // ClientRect's bounds, despite the event listener being triggered. A
      // padding of 2 seems to handle this issue.
      const {
        padding = 2,
        x,
        y
      } = evaluate(options, state);
      const nativeClientRects = Array.from((await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference))) || []);
      const clientRects = getRectsByLine(nativeClientRects);
      const fallback = rectToClientRect(getBoundingRect(nativeClientRects));
      const paddingObject = getPaddingObject(padding);
      function getBoundingClientRect() {
        // There are two rects and they are disjoined.
        if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) {
          // Find the first rect in which the point is fully inside.
          return clientRects.find(rect => x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
        }

        // There are 2 or more connected rects.
        if (clientRects.length >= 2) {
          if (getSideAxis(placement) === 'y') {
            const firstRect = clientRects[0];
            const lastRect = clientRects[clientRects.length - 1];
            const isTop = getSide(placement) === 'top';
            const top = firstRect.top;
            const bottom = lastRect.bottom;
            const left = isTop ? firstRect.left : lastRect.left;
            const right = isTop ? firstRect.right : lastRect.right;
            const width = right - left;
            const height = bottom - top;
            return {
              top,
              bottom,
              left,
              right,
              width,
              height,
              x: left,
              y: top
            };
          }
          const isLeftSide = getSide(placement) === 'left';
          const maxRight = max(...clientRects.map(rect => rect.right));
          const minLeft = min(...clientRects.map(rect => rect.left));
          const measureRects = clientRects.filter(rect => isLeftSide ? rect.left === minLeft : rect.right === maxRight);
          const top = measureRects[0].top;
          const bottom = measureRects[measureRects.length - 1].bottom;
          const left = minLeft;
          const right = maxRight;
          const width = right - left;
          const height = bottom - top;
          return {
            top,
            bottom,
            left,
            right,
            width,
            height,
            x: left,
            y: top
          };
        }
        return fallback;
      }
      const resetRects = await platform.getElementRects({
        reference: {
          getBoundingClientRect
        },
        floating: elements.floating,
        strategy
      });
      if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) {
        return {
          reset: {
            rects: resetRects
          }
        };
      }
      return {};
    }
  };
};

// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.

async function convertValueToCoords(state, options) {
  const {
    placement,
    platform,
    elements
  } = state;
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
  const side = floating_ui_utils_getSide(placement);
  const alignment = floating_ui_utils_getAlignment(placement);
  const isVertical = floating_ui_utils_getSideAxis(placement) === 'y';
  const mainAxisMulti = ['left', 'top'].includes(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = floating_ui_utils_evaluate(options, state);
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === 'number' ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...rawValue
  };
  if (alignment && typeof alignmentAxis === 'number') {
    crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}

/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */
const offset = function (options) {
  if (options === void 0) {
    options = 0;
  }
  return {
    name: 'offset',
    options,
    async fn(state) {
      var _middlewareData$offse, _middlewareData$arrow;
      const {
        x,
        y,
        placement,
        middlewareData
      } = state;
      const diffCoords = await convertValueToCoords(state, options);

      // If the placement is the same and the arrow caused an alignment offset
      // then we don't need to change the positioning coordinates.
      if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      return {
        x: x + diffCoords.x,
        y: y + diffCoords.y,
        data: {
          ...diffCoords,
          placement
        }
      };
    }
  };
};

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const shift = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'shift',
    options,
    async fn(state) {
      const {
        x,
        y,
        placement
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: _ref => {
            let {
              x,
              y
            } = _ref;
            return {
              x,
              y
            };
          }
        },
        ...detectOverflowOptions
      } = floating_ui_utils_evaluate(options, state);
      const coords = {
        x,
        y
      };
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const crossAxis = floating_ui_utils_getSideAxis(floating_ui_utils_getSide(placement));
      const mainAxis = floating_ui_utils_getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === 'y' ? 'top' : 'left';
        const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
        const min = mainAxisCoord + overflow[minSide];
        const max = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = clamp(min, mainAxisCoord, max);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === 'y' ? 'top' : 'left';
        const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
        const min = crossAxisCoord + overflow[minSide];
        const max = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = clamp(min, crossAxisCoord, max);
      }
      const limitedCoords = limiter.fn({
        ...state,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x,
          y: limitedCoords.y - y
        }
      };
    }
  };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */
const limitShift = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    options,
    fn(state) {
      const {
        x,
        y,
        placement,
        rects,
        middlewareData
      } = state;
      const {
        offset = 0,
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true
      } = evaluate(options, state);
      const coords = {
        x,
        y
      };
      const crossAxis = getSideAxis(placement);
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      const rawOffset = evaluate(offset, state);
      const computedOffset = typeof rawOffset === 'number' ? {
        mainAxis: rawOffset,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...rawOffset
      };
      if (checkMainAxis) {
        const len = mainAxis === 'y' ? 'height' : 'width';
        const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
        const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
        if (mainAxisCoord < limitMin) {
          mainAxisCoord = limitMin;
        } else if (mainAxisCoord > limitMax) {
          mainAxisCoord = limitMax;
        }
      }
      if (checkCrossAxis) {
        var _middlewareData$offse, _middlewareData$offse2;
        const len = mainAxis === 'y' ? 'width' : 'height';
        const isOriginSide = ['top', 'left'].includes(getSide(placement));
        const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
        const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
        if (crossAxisCoord < limitMin) {
          crossAxisCoord = limitMin;
        } else if (crossAxisCoord > limitMax) {
          crossAxisCoord = limitMax;
        }
      }
      return {
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      };
    }
  };
};

/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */
const size = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'size',
    options,
    async fn(state) {
      const {
        placement,
        rects,
        platform,
        elements
      } = state;
      const {
        apply = () => {},
        ...detectOverflowOptions
      } = evaluate(options, state);
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const side = getSide(placement);
      const alignment = getAlignment(placement);
      const isYAxis = getSideAxis(placement) === 'y';
      const {
        width,
        height
      } = rects.floating;
      let heightSide;
      let widthSide;
      if (side === 'top' || side === 'bottom') {
        heightSide = side;
        widthSide = alignment === ((await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating))) ? 'start' : 'end') ? 'left' : 'right';
      } else {
        widthSide = side;
        heightSide = alignment === 'end' ? 'top' : 'bottom';
      }
      const overflowAvailableHeight = height - overflow[heightSide];
      const overflowAvailableWidth = width - overflow[widthSide];
      const noShift = !state.middlewareData.shift;
      let availableHeight = overflowAvailableHeight;
      let availableWidth = overflowAvailableWidth;
      if (isYAxis) {
        const maximumClippingWidth = width - overflow.left - overflow.right;
        availableWidth = alignment || noShift ? min(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
      } else {
        const maximumClippingHeight = height - overflow.top - overflow.bottom;
        availableHeight = alignment || noShift ? min(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
      }
      if (noShift && !alignment) {
        const xMin = max(overflow.left, 0);
        const xMax = max(overflow.right, 0);
        const yMin = max(overflow.top, 0);
        const yMax = max(overflow.bottom, 0);
        if (isYAxis) {
          availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : max(overflow.left, overflow.right));
        } else {
          availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : max(overflow.top, overflow.bottom));
        }
      }
      await apply({
        ...state,
        availableWidth,
        availableHeight
      });
      const nextDimensions = await platform.getDimensions(elements.floating);
      if (width !== nextDimensions.width || height !== nextDimensions.height) {
        return {
          reset: {
            rects: true
          }
        };
      }
      return {};
    }
  };
};



;// CONCATENATED MODULE: ../node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || '').toLowerCase();
  }
  // Mocked nodes in testing environments may not be instances of Node. By
  // returning `#document` an infinite loop won't occur.
  // https://github.com/floating-ui/floating-ui/issues/2317
  return '#document';
}
function getWindow(node) {
  var _node$ownerDocument;
  return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  // Browsers without `ShadowRoot` support.
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = floating_ui_utils_dom_getComputedStyle(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !['inline', 'contents'].includes(display);
}
function isTableElement(element) {
  return ['table', 'td', 'th'].includes(getNodeName(element));
}
function isContainingBlock(element) {
  const webkit = isWebKit();
  const css = floating_ui_utils_dom_getComputedStyle(element);

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || ['transform', 'perspective', 'filter'].some(value => (css.willChange || '').includes(value)) || ['paint', 'layout', 'strict', 'content'].some(value => (css.contain || '').includes(value));
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else {
      currentNode = getParentNode(currentNode);
    }
  }
  return null;
}
function isWebKit() {
  if (typeof CSS === 'undefined' || !CSS.supports) return false;
  return CSS.supports('-webkit-backdrop-filter', 'none');
}
function isLastTraversableNode(node) {
  return ['html', 'body', '#document'].includes(getNodeName(node));
}
function floating_ui_utils_dom_getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.pageXOffset,
    scrollTop: element.pageYOffset
  };
}
function getParentNode(node) {
  if (getNodeName(node) === 'html') {
    return node;
  }
  const result =
  // Step into the shadow DOM of the parent of a slotted node.
  node.assignedSlot ||
  // DOM Element detected.
  node.parentNode ||
  // ShadowRoot detected.
  isShadowRoot(node) && node.host ||
  // Fallback.
  getDocumentElement(node);
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? getOverflowAncestors(win.frameElement) : []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}



;// CONCATENATED MODULE: ../node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs






function getCssDimensions(element) {
  const css = floating_ui_utils_dom_getComputedStyle(element);
  // In testing environments, the `width` and `height` properties are empty
  // strings for SVG elements, returning NaN. Fallback to `0` in this case.
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}

function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}

function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $
  } = getCssDimensions(domElement);
  let x = ($ ? round(rect.width) : rect.width) / width;
  let y = ($ ? round(rect.height) : rect.height) / height;

  // 0, NaN, or Infinity should always fallback to 1.

  if (!x || !Number.isFinite(x)) {
    x = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return {
    x,
    y
  };
}

const noOffsets = /*#__PURE__*/createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow(element)) {
    return false;
  }
  return isFixed;
}

function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x = (clientRect.left + visualOffsets.x) / scale.x;
  let y = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow(domElement);
    const offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
    let currentIFrame = win.frameElement;
    while (currentIFrame && offsetParent && offsetWin !== win) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = floating_ui_utils_dom_getComputedStyle(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x += left;
      y += top;
      currentIFrame = getWindow(currentIFrame).frameElement;
    }
  }
  return floating_ui_utils_rectToClientRect({
    width,
    height,
    x,
    y
  });
}

const topLayerSelectors = [':popover-open', ':modal'];
function topLayer(floating) {
  let isTopLayer = false;
  let x = 0;
  let y = 0;
  function setIsTopLayer(selector) {
    try {
      isTopLayer = isTopLayer || floating.matches(selector);
    } catch (e) {}
  }
  topLayerSelectors.forEach(selector => {
    setIsTopLayer(selector);
  });
  if (isTopLayer) {
    const containingBlock = getContainingBlock(floating);
    if (containingBlock) {
      const rect = containingBlock.getBoundingClientRect();
      x = rect.x;
      y = rect.y;
    }
  }
  return [isTopLayer, x, y];
}

function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    elements,
    rect,
    offsetParent,
    strategy
  } = _ref;
  const documentElement = getDocumentElement(offsetParent);
  const [isTopLayer] = elements ? topLayer(elements.floating) : [false];
  if (offsetParent === documentElement || isTopLayer) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== 'fixed') {
    if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
  };
}

function getClientRects(element) {
  return Array.from(element.getClientRects());
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  return getBoundingClientRect(getDocumentElement(element)).left + getNodeScroll(element).scrollLeft;
}

// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function getDocumentRect(element) {
  const html = getDocumentElement(element);
  const scroll = getNodeScroll(element);
  const body = element.ownerDocument.body;
  const width = floating_ui_utils_max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = floating_ui_utils_max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y = -scroll.scrollTop;
  if (floating_ui_utils_dom_getComputedStyle(body).direction === 'rtl') {
    x += floating_ui_utils_max(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}

function getViewportRect(element, strategy) {
  const win = getWindow(element);
  const html = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x = 0;
  let y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x,
    y
  };
}

// Returns the inner client rect, subtracting scrollbars if present.
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === 'fixed');
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = isHTMLElement(element) ? getScale(element) : createCoords(1);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x = left * scale.x;
  const y = top * scale.y;
  return {
    width,
    height,
    x,
    y
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === 'viewport') {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === 'document') {
    rect = getDocumentRect(getDocumentElement(element));
  } else if (isElement(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      ...clippingAncestor,
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y
    };
  }
  return floating_ui_utils_rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = getParentNode(element);
  if (parentNode === stopNode || !isElement(parentNode) || isLastTraversableNode(parentNode)) {
    return false;
  }
  return floating_ui_utils_dom_getComputedStyle(parentNode).position === 'fixed' || hasFixedPositionAncestor(parentNode, stopNode);
}

// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element, [], false).filter(el => isElement(el) && getNodeName(el) !== 'body');
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = floating_ui_utils_dom_getComputedStyle(element).position === 'fixed';
  let currentNode = elementIsFixed ? getParentNode(element) : element;

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = floating_ui_utils_dom_getComputedStyle(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === 'fixed') {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && ['absolute', 'fixed'].includes(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
    if (shouldDropCurrentNode) {
      // Drop non-containing blocks.
      result = result.filter(ancestor => ancestor !== currentNode);
    } else {
      // Record last containing block for next iteration.
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache.set(element, result);
  return result;
}

// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function getClippingRect(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === 'clippingAncestors' ? getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = floating_ui_utils_max(rect.top, accRect.top);
    accRect.right = floating_ui_utils_min(rect.right, accRect.right);
    accRect.bottom = floating_ui_utils_min(rect.bottom, accRect.bottom);
    accRect.left = floating_ui_utils_max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}

function getDimensions(element) {
  const {
    width,
    height
  } = getCssDimensions(element);
  return {
    width,
    height
  };
}

function getRectRelativeToOffsetParent(element, offsetParent, strategy, floating) {
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const isFixed = strategy === 'fixed';
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  let x = rect.left + scroll.scrollLeft - offsets.x;
  let y = rect.top + scroll.scrollTop - offsets.y;
  const [isTopLayer, topLayerX, topLayerY] = topLayer(floating);
  if (isTopLayer) {
    x += topLayerX;
    y += topLayerY;
    if (isOffsetParentAnElement) {
      x += offsetParent.clientLeft;
      y += offsetParent.clientTop;
    }
  }
  return {
    x,
    y,
    width: rect.width,
    height: rect.height
  };
}

function getTrueOffsetParent(element, polyfill) {
  if (!isHTMLElement(element) || floating_ui_utils_dom_getComputedStyle(element).position === 'fixed') {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  return element.offsetParent;
}

// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent(element, polyfill) {
  const window = getWindow(element);
  if (!isHTMLElement(element)) {
    return window;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && isTableElement(offsetParent) && floating_ui_utils_dom_getComputedStyle(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && floating_ui_utils_dom_getComputedStyle(offsetParent).position === 'static' && !isContainingBlock(offsetParent))) {
    return window;
  }
  return offsetParent || getContainingBlock(element) || window;
}

const getElementRects = async function (data) {
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  return {
    reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy, data.floating),
    floating: {
      x: 0,
      y: 0,
      ...(await getDimensionsFn(data.floating))
    }
  };
};

function isRTL(element) {
  return floating_ui_utils_dom_getComputedStyle(element).direction === 'rtl';
}

const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement: getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement: isElement,
  isRTL
};

// https://samthor.au/2021/observing-dom/
function observeMove(element, onMove) {
  let io = null;
  let timeoutId;
  const root = getDocumentElement(element);
  function cleanup() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io) == null || _io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const {
      left,
      top,
      width,
      height
    } = element.getBoundingClientRect();
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor(top);
    const insetRight = floor(root.clientWidth - (left + width));
    const insetBottom = floor(root.clientHeight - (top + height));
    const insetLeft = floor(left);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options = {
      rootMargin,
      threshold: floating_ui_utils_max(0, floating_ui_utils_min(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 100);
        } else {
          refresh(false, ratio);
        }
      }
      isFirstUpdate = false;
    }

    // Older browsers don't support a `document` as the root and will throw an
    // error.
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options,
        // Handle <iframe>s
        root: root.ownerDocument
      });
    } catch (e) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup;
}

/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */
function autoUpdate(reference, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === 'function',
    layoutShift = typeof IntersectionObserver === 'function',
    animationFrame = false
  } = options;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...(referenceEl ? getOverflowAncestors(referenceEl) : []), ...getOverflowAncestors(floating)] : [];
  ancestors.forEach(ancestor => {
    ancestorScroll && ancestor.addEventListener('scroll', update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener('resize', update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver(_ref => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        // Prevent update loops when using the `size` middleware.
        // https://github.com/floating-ui/floating-ui/issues/1740
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    resizeObserver.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _resizeObserver2;
    ancestors.forEach(ancestor => {
      ancestorScroll && ancestor.removeEventListener('scroll', update);
      ancestorResize && ancestor.removeEventListener('resize', update);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}

/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */
const floating_ui_dom_autoPlacement = (/* unused pure expression or super */ null && (autoPlacement$1));

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const floating_ui_dom_shift = shift;

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const floating_ui_dom_flip = flip;

/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */
const floating_ui_dom_size = (/* unused pure expression or super */ null && (size$1));

/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */
const floating_ui_dom_hide = (/* unused pure expression or super */ null && (hide$1));

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */
const floating_ui_dom_arrow = arrow;

/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */
const floating_ui_dom_inline = (/* unused pure expression or super */ null && (inline$1));

/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */
const floating_ui_dom_limitShift = (/* unused pure expression or super */ null && (limitShift$1));

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */
const floating_ui_dom_computePosition = (reference, floating, options) => {
  // This caches the expensive `getClippingElementAncestors` function so that
  // multiple lifecycle resets re-use the same result. It only lives for a
  // single call. If other functions become expensive, we can add them as well.
  const cache = new Map();
  const mergedOptions = {
    platform,
    ...options
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition(reference, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};



;// CONCATENATED MODULE: ../node_modules/react-tooltip/dist/react-tooltip.min.mjs
/* provided dependency */ var process = __webpack_require__(4284);
/*
* React Tooltip
* {@link https://github.com/ReactTooltip/react-tooltip}
* @copyright ReactTooltip Team
* @license MIT
*/
const h="react-tooltip-core-styles",w="react-tooltip-base-styles",b={core:!1,base:!1};function S({css:e,id:t=w,type:o="base",ref:l}){var r,n;if(!e||"undefined"==typeof document||b[o])return;if("core"===o&&"undefined"!=typeof process&&(null===(r=null===process||void 0===process?void 0:process.env)||void 0===r?void 0:r.REACT_TOOLTIP_DISABLE_CORE_STYLES))return;if("base"!==o&&"undefined"!=typeof process&&(null===(n=null===process||void 0===process?void 0:process.env)||void 0===n?void 0:n.REACT_TOOLTIP_DISABLE_BASE_STYLES))return;"core"===o&&(t=h),l||(l={});const{insertAt:c}=l;if(document.getElementById(t))return void console.warn(`[react-tooltip] Element with id '${t}' already exists. Call \`removeStyle()\` first`);const i=document.head||document.getElementsByTagName("head")[0],s=document.createElement("style");s.id=t,s.type="text/css","top"===c&&i.firstChild?i.insertBefore(s,i.firstChild):i.appendChild(s),s.styleSheet?s.styleSheet.cssText=e:s.appendChild(document.createTextNode(e)),b[o]=!0}function E({type:e="base",id:t=w}={}){if(!b[e])return;"core"===e&&(t=h);const o=document.getElementById(t);"style"===(null==o?void 0:o.tagName)?null==o||o.remove():console.warn(`[react-tooltip] Failed to remove 'style' element with id '${t}'. Call \`injectStyle()\` first`),b[e]=!1}const g=(e,t,o)=>{let l=null;const r=function(...r){const n=()=>{l=null,o||e.apply(this,r)};o&&!l&&(e.apply(this,r),l=setTimeout(n,t)),o||(l&&clearTimeout(l),l=setTimeout(n,t))};return r.cancel=()=>{l&&(clearTimeout(l),l=null)},r},_="DEFAULT_TOOLTIP_ID",A={anchorRefs:new Set,activeAnchor:{current:null},attach:()=>{},detach:()=>{},setActiveAnchor:()=>{}},O=(0,react.createContext)({getTooltipData:()=>A}),T=({children:t})=>{const[n,c]=o({[_]:new Set}),[i,s]=o({[_]:{current:null}}),a=(e,...t)=>{c((o=>{var l;const r=null!==(l=o[e])&&void 0!==l?l:new Set;return t.forEach((e=>r.add(e))),{...o,[e]:new Set(r)}}))},u=(e,...t)=>{c((o=>{const l=o[e];return l?(t.forEach((e=>l.delete(e))),{...o}):o}))},d=l(((e=_)=>{var t,o;return{anchorRefs:null!==(t=n[e])&&void 0!==t?t:new Set,activeAnchor:null!==(o=i[e])&&void 0!==o?o:{current:null},attach:(...t)=>a(e,...t),detach:(...t)=>u(e,...t),setActiveAnchor:t=>((e,t)=>{s((o=>{var l;return(null===(l=o[e])||void 0===l?void 0:l.current)===t.current?o:{...o,[e]:t}}))})(e,t)}}),[n,i,a,u]),p=r((()=>({getTooltipData:d})),[d]);return e.createElement(O.Provider,{value:p},t)};function k(e=_){return (0,react.useContext)(O).getTooltipData(e)}const L=({tooltipId:t,children:o,className:l,place:r,content:n,html:s,variant:a,offset:u,wrapper:d,events:p,positionStrategy:v,delayShow:m,delayHide:f})=>{const{attach:h,detach:w}=k(t),b=c(null);return i((()=>(h(b),()=>{w(b)})),[]),e.createElement("span",{ref:b,className:y("react-tooltip-wrapper",l),"data-tooltip-place":r,"data-tooltip-content":n,"data-tooltip-html":s,"data-tooltip-variant":a,"data-tooltip-offset":u,"data-tooltip-wrapper":d,"data-tooltip-events":p,"data-tooltip-position-strategy":v,"data-tooltip-delay-show":m,"data-tooltip-delay-hide":f},o)},C="undefined"!=typeof window?react.useLayoutEffect:react.useEffect,R=e=>{if(!(e instanceof HTMLElement||e instanceof SVGElement))return!1;const t=getComputedStyle(e);return["overflow","overflow-x","overflow-y"].some((e=>{const o=t.getPropertyValue(e);return"auto"===o||"scroll"===o}))},x=e=>{if(!e)return null;let t=e.parentElement;for(;t;){if(R(t))return t;t=t.parentElement}return document.scrollingElement||document.documentElement},N=async({elementReference:e=null,tooltipReference:t=null,tooltipArrowReference:o=null,place:l="top",offset:r=10,strategy:n="absolute",middlewares:c=[offset(Number(r)),floating_ui_dom_flip({fallbackAxisSideDirection:"start"}),floating_ui_dom_shift({padding:5})],border:i})=>{if(!e)return{tooltipStyles:{},tooltipArrowStyles:{},place:l};if(null===t)return{tooltipStyles:{},tooltipArrowStyles:{},place:l};const s=c;return o?(s.push(floating_ui_dom_arrow({element:o,padding:5})),floating_ui_dom_computePosition(e,t,{placement:l,strategy:n,middleware:s}).then((({x:e,y:t,placement:o,middlewareData:l})=>{var r,n;const c={left:`${e}px`,top:`${t}px`,border:i},{x:s,y:a}=null!==(r=l.arrow)&&void 0!==r?r:{x:0,y:0},u=null!==(n={top:"bottom",right:"left",bottom:"top",left:"right"}[o.split("-")[0]])&&void 0!==n?n:"bottom",d=i&&{borderBottom:i,borderRight:i};let p=0;if(i){const e=`${i}`.match(/(\d+)px/);p=(null==e?void 0:e[1])?Number(e[1]):1}return{tooltipStyles:c,tooltipArrowStyles:{left:null!=s?`${s}px`:"",top:null!=a?`${a}px`:"",right:"",bottom:"",...d,[u]:`-${4+p}px`},place:o}}))):floating_ui_dom_computePosition(e,t,{placement:"bottom",strategy:n,middleware:s}).then((({x:e,y:t,placement:o})=>({tooltipStyles:{left:`${e}px`,top:`${t}px`},tooltipArrowStyles:{},place:o})))};var $={tooltip:"core-styles-module_tooltip__3vRRp",fixed:"core-styles-module_fixed__pcSol",arrow:"core-styles-module_arrow__cvMwQ",noArrow:"core-styles-module_noArrow__xock6",clickable:"core-styles-module_clickable__ZuTTB",show:"core-styles-module_show__Nt9eE",closing:"core-styles-module_closing__sGnxF"},I={tooltip:"styles-module_tooltip__mnnfp",arrow:"styles-module_arrow__K0L3T",dark:"styles-module_dark__xNqje",light:"styles-module_light__Z6W-X",success:"styles-module_success__A2AKt",warning:"styles-module_warning__SCK0X",error:"styles-module_error__JvumD",info:"styles-module_info__BWdHW"};const j=({forwardRef:t,id:r,className:n,classNameArrow:s,variant:u="dark",anchorId:d,anchorSelect:p,place:v="top",offset:m=10,events:h=["hover"],openOnClick:w=!1,positionStrategy:b="absolute",middlewares:S,wrapper:E,delayShow:_=0,delayHide:A=0,float:O=!1,hidden:T=!1,noArrow:L=!1,clickable:R=!1,closeOnEsc:j=!1,closeOnScroll:B=!1,closeOnResize:z=!1,openEvents:D,closeEvents:q,globalCloseEvents:H,imperativeModeOnly:M,style:W,position:P,afterShow:V,afterHide:F,content:K,contentWrapperRef:U,isOpen:X,defaultIsOpen:Y=!1,setIsOpen:G,activeAnchor:Z,setActiveAnchor:J,border:Q,opacity:ee,arrowColor:te,role:oe="tooltip"})=>{var le;const re=(0,react.useRef)(null),ne=(0,react.useRef)(null),ce=(0,react.useRef)(null),ie=(0,react.useRef)(null),se=(0,react.useRef)(null),[ae,ue]=(0,react.useState)(v),[de,pe]=(0,react.useState)({}),[ve,me]=(0,react.useState)({}),[fe,ye]=(0,react.useState)(!1),[he,we]=(0,react.useState)(!1),[be,Se]=(0,react.useState)(null),Ee=(0,react.useRef)(!1),ge=(0,react.useRef)(null),{anchorRefs:_e,setActiveAnchor:Ae}=k(r),Oe=(0,react.useRef)(!1),[Te,ke]=(0,react.useState)([]),Le=(0,react.useRef)(!1),Ce=w||h.includes("click"),Re=Ce||(null==D?void 0:D.click)||(null==D?void 0:D.dblclick)||(null==D?void 0:D.mousedown),xe=D?{...D}:{mouseenter:!0,focus:!0,click:!1,dblclick:!1,mousedown:!1};!D&&Ce&&Object.assign(xe,{mouseenter:!1,focus:!1,click:!0});const Ne=q?{...q}:{mouseleave:!0,blur:!0,click:!1,dblclick:!1,mouseup:!1};!q&&Ce&&Object.assign(Ne,{mouseleave:!1,blur:!1});const $e=H?{...H}:{escape:j||!1,scroll:B||!1,resize:z||!1,clickOutsideAnchor:Re||!1};M&&(Object.assign(xe,{mouseenter:!1,focus:!1,click:!1,dblclick:!1,mousedown:!1}),Object.assign(Ne,{mouseleave:!1,blur:!1,click:!1,dblclick:!1,mouseup:!1}),Object.assign($e,{escape:!1,scroll:!1,resize:!1,clickOutsideAnchor:!1})),C((()=>(Le.current=!0,()=>{Le.current=!1})),[]);const Ie=e=>{Le.current&&(e&&we(!0),setTimeout((()=>{Le.current&&(null==G||G(e),void 0===X&&ye(e))}),10))};(0,react.useEffect)((()=>{if(void 0===X)return()=>null;X&&we(!0);const e=setTimeout((()=>{ye(X)}),10);return()=>{clearTimeout(e)}}),[X]),(0,react.useEffect)((()=>{if(fe!==Ee.current)if(se.current&&clearTimeout(se.current),Ee.current=fe,fe)null==V||V();else{const e=(e=>{const t=e.match(/^([\d.]+)(m?s?)$/);if(!t)return 0;const[,o,l]=t;return"s"!==l&&"ms"!==l?0:Number(o)*("ms"===l?1:1e3)})(getComputedStyle(document.body).getPropertyValue("--rt-transition-show-delay"));se.current=setTimeout((()=>{we(!1),Se(null),null==F||F()}),e+25)}}),[fe]);const je=(e=_)=>{ce.current&&clearTimeout(ce.current),ce.current=setTimeout((()=>{Ie(!0)}),e)},Be=(e=A)=>{ie.current&&clearTimeout(ie.current),ie.current=setTimeout((()=>{Oe.current||Ie(!1)}),e)},ze=e=>{var t;if(!e)return;const o=null!==(t=e.currentTarget)&&void 0!==t?t:e.target;if(!(null==o?void 0:o.isConnected))return J(null),void Ae({current:null});_?je():Ie(!0),J(o),Ae({current:o}),ie.current&&clearTimeout(ie.current)},De=()=>{R?Be(A||100):A?Be():Ie(!1),ce.current&&clearTimeout(ce.current)},qe=({x:e,y:t})=>{var o;const l={getBoundingClientRect:()=>({x:e,y:t,width:0,height:0,top:t,left:e,right:e,bottom:t})};N({place:null!==(o=null==be?void 0:be.place)&&void 0!==o?o:v,offset:m,elementReference:l,tooltipReference:re.current,tooltipArrowReference:ne.current,strategy:b,middlewares:S,border:Q}).then((e=>{Object.keys(e.tooltipStyles).length&&pe(e.tooltipStyles),Object.keys(e.tooltipArrowStyles).length&&me(e.tooltipArrowStyles),ue(e.place)}))},He=e=>{if(!e)return;const t=e,o={x:t.clientX,y:t.clientY};qe(o),ge.current=o},Me=e=>{var t;if(!fe)return;const o=e.target;if(null===(t=re.current)||void 0===t?void 0:t.contains(o))return;[document.querySelector(`[id='${d}']`),...Te].some((e=>null==e?void 0:e.contains(o)))||(Ie(!1),ce.current&&clearTimeout(ce.current))},We=g(ze,50,!0),Pe=g(De,50,!0),Ve=e=>{Pe.cancel(),We(e)},Fe=()=>{We.cancel(),Pe()},Ke=(0,react.useCallback)((()=>{var e,t;const o=null!==(e=null==be?void 0:be.position)&&void 0!==e?e:P;o?qe(o):O?ge.current&&qe(ge.current):(null==Z?void 0:Z.isConnected)&&N({place:null!==(t=null==be?void 0:be.place)&&void 0!==t?t:v,offset:m,elementReference:Z,tooltipReference:re.current,tooltipArrowReference:ne.current,strategy:b,middlewares:S,border:Q}).then((e=>{Le.current&&(Object.keys(e.tooltipStyles).length&&pe(e.tooltipStyles),Object.keys(e.tooltipArrowStyles).length&&me(e.tooltipArrowStyles),ue(e.place))}))}),[fe,Z,K,W,v,null==be?void 0:be.place,m,b,P,null==be?void 0:be.position,O]);(0,react.useEffect)((()=>{var e,t;const o=new Set(_e);Te.forEach((e=>{o.add({current:e})}));const l=document.querySelector(`[id='${d}']`);l&&o.add({current:l});const r=()=>{Ie(!1)},n=x(Z),c=x(re.current);$e.scroll&&(window.addEventListener("scroll",r),null==n||n.addEventListener("scroll",r),null==c||c.addEventListener("scroll",r));let i=null;$e.resize?window.addEventListener("resize",r):Z&&re.current&&(i=autoUpdate(Z,re.current,Ke,{ancestorResize:!0,elementResize:!0,layoutShift:!0}));const s=e=>{"Escape"===e.key&&Ie(!1)};$e.escape&&window.addEventListener("keydown",s),$e.clickOutsideAnchor&&window.addEventListener("click",Me);const a=[],u=e=>{fe&&(null==e?void 0:e.target)===Z||ze(e)},p=e=>{fe&&(null==e?void 0:e.target)===Z&&De()},v=["mouseenter","mouseleave","focus","blur"],m=["click","dblclick","mousedown","mouseup"];Object.entries(xe).forEach((([e,t])=>{t&&(v.includes(e)?a.push({event:e,listener:Ve}):m.includes(e)&&a.push({event:e,listener:u}))})),Object.entries(Ne).forEach((([e,t])=>{t&&(v.includes(e)?a.push({event:e,listener:Fe}):m.includes(e)&&a.push({event:e,listener:p}))})),O&&a.push({event:"pointermove",listener:He});const y=()=>{Oe.current=!0},h=()=>{Oe.current=!1,De()};return R&&!Re&&(null===(e=re.current)||void 0===e||e.addEventListener("mouseenter",y),null===(t=re.current)||void 0===t||t.addEventListener("mouseleave",h)),a.forEach((({event:e,listener:t})=>{o.forEach((o=>{var l;null===(l=o.current)||void 0===l||l.addEventListener(e,t)}))})),()=>{var e,t;$e.scroll&&(window.removeEventListener("scroll",r),null==n||n.removeEventListener("scroll",r),null==c||c.removeEventListener("scroll",r)),$e.resize?window.removeEventListener("resize",r):null==i||i(),$e.clickOutsideAnchor&&window.removeEventListener("click",Me),$e.escape&&window.removeEventListener("keydown",s),R&&!Re&&(null===(e=re.current)||void 0===e||e.removeEventListener("mouseenter",y),null===(t=re.current)||void 0===t||t.removeEventListener("mouseleave",h)),a.forEach((({event:e,listener:t})=>{o.forEach((o=>{var l;null===(l=o.current)||void 0===l||l.removeEventListener(e,t)}))}))}}),[Z,Ke,he,_e,Te,D,q,H,Ce]),(0,react.useEffect)((()=>{var e,t;let o=null!==(t=null!==(e=null==be?void 0:be.anchorSelect)&&void 0!==e?e:p)&&void 0!==t?t:"";!o&&r&&(o=`[data-tooltip-id='${r}']`);const l=new MutationObserver((e=>{const t=[],l=[];e.forEach((e=>{if("attributes"===e.type&&"data-tooltip-id"===e.attributeName){e.target.getAttribute("data-tooltip-id")===r?t.push(e.target):e.oldValue===r&&l.push(e.target)}if("childList"===e.type){if(Z){const t=[...e.removedNodes].filter((e=>1===e.nodeType));if(o)try{l.push(...t.filter((e=>e.matches(o)))),l.push(...t.flatMap((e=>[...e.querySelectorAll(o)])))}catch(e){}t.some((e=>{var t;return!!(null===(t=null==e?void 0:e.contains)||void 0===t?void 0:t.call(e,Z))&&(we(!1),Ie(!1),J(null),ce.current&&clearTimeout(ce.current),ie.current&&clearTimeout(ie.current),!0)}))}if(o)try{const l=[...e.addedNodes].filter((e=>1===e.nodeType));t.push(...l.filter((e=>e.matches(o)))),t.push(...l.flatMap((e=>[...e.querySelectorAll(o)])))}catch(e){}}})),(t.length||l.length)&&ke((e=>[...e.filter((e=>!l.includes(e))),...t]))}));return l.observe(document.body,{childList:!0,subtree:!0,attributes:!0,attributeFilter:["data-tooltip-id"],attributeOldValue:!0}),()=>{l.disconnect()}}),[r,p,null==be?void 0:be.anchorSelect,Z]),(0,react.useEffect)((()=>{Ke()}),[Ke]),(0,react.useEffect)((()=>{if(!(null==U?void 0:U.current))return()=>null;const e=new ResizeObserver((()=>{setTimeout((()=>Ke()))}));return e.observe(U.current),()=>{e.disconnect()}}),[K,null==U?void 0:U.current]),(0,react.useEffect)((()=>{var e;const t=document.querySelector(`[id='${d}']`),o=[...Te,t];Z&&o.includes(Z)||J(null!==(e=Te[0])&&void 0!==e?e:t)}),[d,Te,Z]),(0,react.useEffect)((()=>(Y&&Ie(!0),()=>{ce.current&&clearTimeout(ce.current),ie.current&&clearTimeout(ie.current)})),[]),(0,react.useEffect)((()=>{var e;let t=null!==(e=null==be?void 0:be.anchorSelect)&&void 0!==e?e:p;if(!t&&r&&(t=`[data-tooltip-id='${r}']`),t)try{const e=Array.from(document.querySelectorAll(t));ke(e)}catch(e){ke([])}}),[r,p,null==be?void 0:be.anchorSelect]);const Ue=null!==(le=null==be?void 0:be.content)&&void 0!==le?le:K,Xe=fe&&Object.keys(de).length>0;return (0,react.useImperativeHandle)(t,(()=>({open:e=>{if(null==e?void 0:e.anchorSelect)try{document.querySelector(e.anchorSelect)}catch(t){return void console.warn(`[react-tooltip] "${e.anchorSelect}" is not a valid CSS selector`)}Se(null!=e?e:null),(null==e?void 0:e.delay)?je(e.delay):Ie(!0)},close:e=>{(null==e?void 0:e.delay)?Be(e.delay):Ie(!1)},activeAnchor:Z,place:ae,isOpen:Boolean(he&&!T&&Ue&&Xe)}))),he&&!T&&Ue?react.createElement(E,{id:r,role:oe,className:classnames("react-tooltip",$.tooltip,I.tooltip,I[u],n,`react-tooltip__place-${ae}`,$[Xe?"show":"closing"],Xe?"react-tooltip__show":"react-tooltip__closing","fixed"===b&&$.fixed,R&&$.clickable),onTransitionEnd:e=>{se.current&&clearTimeout(se.current),fe||"opacity"!==e.propertyName||(we(!1),Se(null),null==F||F())},style:{...W,...de,opacity:void 0!==ee&&Xe?ee:void 0},ref:re},Ue,react.createElement(E,{className:classnames("react-tooltip-arrow",$.arrow,I.arrow,s,L&&$.noArrow),style:{...ve,background:te?`linear-gradient(to right bottom, transparent 50%, ${te} 50%)`:void 0},ref:ne})):null},B=({content:t})=>react.createElement("span",{dangerouslySetInnerHTML:{__html:t}}),z=(e,t)=>!("CSS"in window&&"supports"in window.CSS)||window.CSS.supports(e,t),D=react.forwardRef((({id:t,anchorId:l,anchorSelect:r,content:n,html:s,render:a,className:u,classNameArrow:d,variant:p="dark",place:v="top",offset:m=10,wrapper:f="div",children:h=null,events:w=["hover"],openOnClick:b=!1,positionStrategy:S="absolute",middlewares:E,delayShow:g=0,delayHide:_=0,float:A=!1,hidden:O=!1,noArrow:T=!1,clickable:L=!1,closeOnEsc:C=!1,closeOnScroll:R=!1,closeOnResize:x=!1,openEvents:N,closeEvents:$,globalCloseEvents:I,imperativeModeOnly:D=!1,style:q,position:H,isOpen:M,defaultIsOpen:W=!1,disableStyleInjection:P=!1,border:V,opacity:F,arrowColor:K,setIsOpen:U,afterShow:X,afterHide:Y,role:G="tooltip"},Z)=>{const[J,Q]=(0,react.useState)(n),[ee,te]=(0,react.useState)(s),[oe,le]=(0,react.useState)(v),[re,ne]=(0,react.useState)(p),[ce,ie]=(0,react.useState)(m),[se,ae]=(0,react.useState)(g),[ue,de]=(0,react.useState)(_),[pe,ve]=(0,react.useState)(A),[me,fe]=(0,react.useState)(O),[ye,he]=(0,react.useState)(f),[we,be]=(0,react.useState)(w),[Se,Ee]=(0,react.useState)(S),[ge,_e]=(0,react.useState)(null),[Ae,Oe]=(0,react.useState)(null),Te=(0,react.useRef)(P),{anchorRefs:ke,activeAnchor:Le}=k(t),Ce=e=>null==e?void 0:e.getAttributeNames().reduce(((t,o)=>{var l;if(o.startsWith("data-tooltip-")){t[o.replace(/^data-tooltip-/,"")]=null!==(l=null==e?void 0:e.getAttribute(o))&&void 0!==l?l:null}return t}),{}),Re=e=>{const t={place:e=>{var t;le(null!==(t=e)&&void 0!==t?t:v)},content:e=>{Q(null!=e?e:n)},html:e=>{te(null!=e?e:s)},variant:e=>{var t;ne(null!==(t=e)&&void 0!==t?t:p)},offset:e=>{ie(null===e?m:Number(e))},wrapper:e=>{var t;he(null!==(t=e)&&void 0!==t?t:f)},events:e=>{const t=null==e?void 0:e.split(" ");be(null!=t?t:w)},"position-strategy":e=>{var t;Ee(null!==(t=e)&&void 0!==t?t:S)},"delay-show":e=>{ae(null===e?g:Number(e))},"delay-hide":e=>{de(null===e?_:Number(e))},float:e=>{ve(null===e?A:"true"===e)},hidden:e=>{fe(null===e?O:"true"===e)},"class-name":e=>{_e(e)}};Object.values(t).forEach((e=>e(null))),Object.entries(e).forEach((([e,o])=>{var l;null===(l=t[e])||void 0===l||l.call(t,o)}))};(0,react.useEffect)((()=>{Q(n)}),[n]),(0,react.useEffect)((()=>{te(s)}),[s]),(0,react.useEffect)((()=>{le(v)}),[v]),(0,react.useEffect)((()=>{ne(p)}),[p]),(0,react.useEffect)((()=>{ie(m)}),[m]),(0,react.useEffect)((()=>{ae(g)}),[g]),(0,react.useEffect)((()=>{de(_)}),[_]),(0,react.useEffect)((()=>{ve(A)}),[A]),(0,react.useEffect)((()=>{fe(O)}),[O]),(0,react.useEffect)((()=>{Ee(S)}),[S]),(0,react.useEffect)((()=>{Te.current!==P&&console.warn("[react-tooltip] Do not change `disableStyleInjection` dynamically.")}),[P]),(0,react.useEffect)((()=>{"undefined"!=typeof window&&window.dispatchEvent(new CustomEvent("react-tooltip-inject-styles",{detail:{disableCore:"core"===P,disableBase:P}}))}),[]),(0,react.useEffect)((()=>{var e;const o=new Set(ke);let n=r;if(!n&&t&&(n=`[data-tooltip-id='${t}']`),n)try{document.querySelectorAll(n).forEach((e=>{o.add({current:e})}))}catch(e){console.warn(`[react-tooltip] "${n}" is not a valid CSS selector`)}const c=document.querySelector(`[id='${l}']`);if(c&&o.add({current:c}),!o.size)return()=>null;const i=null!==(e=null!=Ae?Ae:c)&&void 0!==e?e:Le.current,s=new MutationObserver((e=>{e.forEach((e=>{var t;if(!i||"attributes"!==e.type||!(null===(t=e.attributeName)||void 0===t?void 0:t.startsWith("data-tooltip-")))return;const o=Ce(i);Re(o)}))})),a={attributes:!0,childList:!1,subtree:!1};if(i){const e=Ce(i);Re(e),s.observe(i,a)}return()=>{s.disconnect()}}),[ke,Le,Ae,l,r]),(0,react.useEffect)((()=>{(null==q?void 0:q.border)&&console.warn("[react-tooltip] Do not set `style.border`. Use `border` prop instead."),V&&!z("border",`${V}`)&&console.warn(`[react-tooltip] "${V}" is not a valid \`border\`.`),(null==q?void 0:q.opacity)&&console.warn("[react-tooltip] Do not set `style.opacity`. Use `opacity` prop instead."),F&&!z("opacity",`${F}`)&&console.warn(`[react-tooltip] "${F}" is not a valid \`opacity\`.`)}),[]);let xe=h;const Ne=(0,react.useRef)(null);if(a){const t=a({content:null!=J?J:null,activeAnchor:Ae});xe=t?react.createElement("div",{ref:Ne,className:"react-tooltip-content-wrapper"},t):null}else J&&(xe=J);ee&&(xe=react.createElement(B,{content:ee}));const $e={forwardRef:Z,id:t,anchorId:l,anchorSelect:r,className:classnames(u,ge),classNameArrow:d,content:xe,contentWrapperRef:Ne,place:oe,variant:re,offset:ce,wrapper:ye,events:we,openOnClick:b,positionStrategy:Se,middlewares:E,delayShow:se,delayHide:ue,float:pe,hidden:me,noArrow:T,clickable:L,closeOnEsc:C,closeOnScroll:R,closeOnResize:x,openEvents:N,closeEvents:$,globalCloseEvents:I,imperativeModeOnly:D,style:q,position:H,isOpen:M,defaultIsOpen:W,border:V,opacity:F,arrowColor:K,setIsOpen:U,afterShow:X,afterHide:Y,activeAnchor:Ae,setActiveAnchor:e=>Oe(e),role:G};return react.createElement(j,{...$e})}));"undefined"!=typeof window&&window.addEventListener("react-tooltip-inject-styles",(e=>{e.detail.disableCore||S({css:`:root{--rt-color-white:#fff;--rt-color-dark:#222;--rt-color-success:#8dc572;--rt-color-error:#be6464;--rt-color-warning:#f0ad4e;--rt-color-info:#337ab7;--rt-opacity:0.9;--rt-transition-show-delay:0.15s;--rt-transition-closing-delay:0.15s}.core-styles-module_tooltip__3vRRp{position:absolute;top:0;left:0;pointer-events:none;opacity:0;will-change:opacity}.core-styles-module_fixed__pcSol{position:fixed}.core-styles-module_arrow__cvMwQ{position:absolute;background:inherit}.core-styles-module_noArrow__xock6{display:none}.core-styles-module_clickable__ZuTTB{pointer-events:auto}.core-styles-module_show__Nt9eE{opacity:var(--rt-opacity);transition:opacity var(--rt-transition-show-delay)ease-out}.core-styles-module_closing__sGnxF{opacity:0;transition:opacity var(--rt-transition-closing-delay)ease-in}`,type:"core"}),e.detail.disableBase||S({css:`
.styles-module_tooltip__mnnfp{padding:8px 16px;border-radius:3px;font-size:90%;width:max-content}.styles-module_arrow__K0L3T{width:8px;height:8px}[class*='react-tooltip__place-top']>.styles-module_arrow__K0L3T{transform:rotate(45deg)}[class*='react-tooltip__place-right']>.styles-module_arrow__K0L3T{transform:rotate(135deg)}[class*='react-tooltip__place-bottom']>.styles-module_arrow__K0L3T{transform:rotate(225deg)}[class*='react-tooltip__place-left']>.styles-module_arrow__K0L3T{transform:rotate(315deg)}.styles-module_dark__xNqje{background:var(--rt-color-dark);color:var(--rt-color-white)}.styles-module_light__Z6W-X{background-color:var(--rt-color-white);color:var(--rt-color-dark)}.styles-module_success__A2AKt{background-color:var(--rt-color-success);color:var(--rt-color-white)}.styles-module_warning__SCK0X{background-color:var(--rt-color-warning);color:var(--rt-color-white)}.styles-module_error__JvumD{background-color:var(--rt-color-error);color:var(--rt-color-white)}.styles-module_info__BWdHW{background-color:var(--rt-color-info);color:var(--rt-color-white)}`,type:"base"})}));

;// CONCATENATED MODULE: ./src/sections/ArticleHero/ArticleHeroShare.jsx




function ArticleHeroShare(props) {
    var link = props.link, centerContent = props.centerContent, title = props.title;
    var shareUrl = (0,react.useMemo)(function() {
        if (true) {
            return window.location.href;
        }
        return "";
    }, []);
    var ref = (0,react.useState)("Copy URL"), copyUrlTooltip = ref[0], setCopyUrlTooltip = ref[1];
    var copyUrl = function() {
        navigator.clipboard.writeText(shareUrl);
        setCopyUrlTooltip("Copied!");
        setTimeout(function() {
            setCopyUrlTooltip("Copy URL");
        }, 2000);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bottom-12 flex w-full items-center lg:bottom-28 ".concat(centerContent ? "justify-center" : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "pr-4 text-sm font-light",
                children: "Share This Article:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_EmailShareButton, {
                url: shareUrl,
                subject: "Clearly Filtered - ".concat(title),
                className: "mr-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    width: "18",
                    height: "15",
                    viewBox: "0 0 18 15",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M17.64 0H0.36C0.264522 0 0.172955 0.0415883 0.105442 0.115616C0.0379285 0.189643 0 0.290046 0 0.394737V13.8158C0 14.1299 0.113785 14.4311 0.316325 14.6532C0.518864 14.8752 0.793566 15 1.08 15H16.92C17.2064 15 17.4811 14.8752 17.6837 14.6532C17.8862 14.4311 18 14.1299 18 13.8158V0.394737C18 0.290046 17.9621 0.189643 17.8946 0.115616C17.827 0.0415883 17.7355 0 17.64 0ZM16.7148 0.789474L9 8.54309L1.2852 0.789474H16.7148ZM16.92 14.2105H1.08C0.984522 14.2105 0.892955 14.1689 0.825442 14.0949C0.757929 14.0209 0.72 13.9205 0.72 13.8158V1.29178L8.757 9.375C8.82337 9.44157 8.91005 9.47849 9 9.47849C9.08995 9.47849 9.17664 9.44157 9.243 9.375L17.28 1.29178V13.8158C17.28 13.9205 17.2421 14.0209 17.1746 14.0949C17.107 14.1689 17.0155 14.2105 16.92 14.2105Z",
                        fill: "#202635"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_LinkedinShareButton, {
                url: shareUrl,
                className: "mr-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    width: "17",
                    height: "18",
                    viewBox: "0 0 17 18",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M15.98 0H1.02C0.749479 0 0.490038 0.113785 0.298751 0.316325C0.107464 0.518864 0 0.793566 0 1.08V16.92C0 17.2064 0.107464 17.4811 0.298751 17.6837C0.490038 17.8862 0.749479 18 1.02 18H15.98C16.2505 18 16.51 17.8862 16.7012 17.6837C16.8925 17.4811 17 17.2064 17 16.92V1.08C17 0.793566 16.8925 0.518864 16.7012 0.316325C16.51 0.113785 16.2505 0 15.98 0ZM16.32 16.92C16.32 17.0155 16.2842 17.107 16.2204 17.1746C16.1567 17.2421 16.0702 17.28 15.98 17.28H1.02C0.929826 17.28 0.843346 17.2421 0.779584 17.1746C0.715821 17.107 0.68 17.0155 0.68 16.92V1.08C0.68 0.984522 0.715821 0.892955 0.779584 0.825442C0.843346 0.757929 0.929826 0.72 1.02 0.72H15.98C16.0702 0.72 16.1567 0.757929 16.2204 0.825442C16.2842 0.892955 16.32 0.984522 16.32 1.08V16.92ZM5.44 7.56V13.32C5.44 13.4155 5.40418 13.507 5.34042 13.5746C5.27665 13.6421 5.19017 13.68 5.1 13.68C5.00983 13.68 4.92335 13.6421 4.85958 13.5746C4.79582 13.507 4.76 13.4155 4.76 13.32V7.56C4.76 7.46452 4.79582 7.37295 4.85958 7.30544C4.92335 7.23793 5.00983 7.2 5.1 7.2C5.19017 7.2 5.27665 7.23793 5.34042 7.30544C5.40418 7.37295 5.44 7.46452 5.44 7.56ZM12.92 10.08V13.32C12.92 13.4155 12.8842 13.507 12.8204 13.5746C12.7567 13.6421 12.6702 13.68 12.58 13.68C12.4898 13.68 12.4033 13.6421 12.3396 13.5746C12.2758 13.507 12.24 13.4155 12.24 13.32V10.08C12.24 9.50713 12.0251 8.95773 11.6425 8.55265C11.2599 8.14757 10.741 7.92 10.2 7.92C9.65896 7.92 9.14008 8.14757 8.7575 8.55265C8.37493 8.95773 8.16 9.50713 8.16 10.08V13.32C8.16 13.4155 8.12418 13.507 8.06042 13.5746C7.99665 13.6421 7.91017 13.68 7.82 13.68C7.72983 13.68 7.64335 13.6421 7.57958 13.5746C7.51582 13.507 7.48 13.4155 7.48 13.32V7.56C7.48 7.46452 7.51582 7.37295 7.57958 7.30544C7.64335 7.23793 7.72983 7.2 7.82 7.2C7.91017 7.2 7.99665 7.23793 8.06042 7.30544C8.12418 7.37295 8.16 7.46452 8.16 7.56V8.1783C8.52526 7.73977 9.00795 7.42934 9.54387 7.28829C10.0798 7.14724 10.6436 7.18225 11.1602 7.38867C11.6769 7.59509 12.122 7.96314 12.4363 8.44388C12.7507 8.92462 12.9194 9.49529 12.92 10.08ZM5.78 5.04C5.78 5.1824 5.74012 5.32161 5.6654 5.44001C5.59068 5.55841 5.48448 5.6507 5.36023 5.70519C5.23597 5.75969 5.09925 5.77395 4.96734 5.74617C4.83543 5.71838 4.71427 5.64981 4.61917 5.54912C4.52407 5.44842 4.4593 5.32013 4.43307 5.18047C4.40683 5.0408 4.42029 4.89603 4.47176 4.76447C4.52323 4.63291 4.61039 4.52046 4.72221 4.44134C4.83404 4.36223 4.96551 4.32 5.1 4.32C5.28035 4.32 5.45331 4.39586 5.58083 4.53088C5.70836 4.66591 5.78 4.84904 5.78 5.04Z",
                        fill: "#202635"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_FacebookShareButton, {
                url: shareUrl,
                className: "facebook mr-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    width: "18",
                    height: "18",
                    viewBox: "0 0 18 18",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M9 0C7.21997 0 5.47991 0.527841 3.99987 1.51677C2.51983 2.50571 1.36628 3.91131 0.685088 5.55585C0.00389942 7.20038 -0.17433 9.00998 0.172937 10.7558C0.520203 12.5016 1.37737 14.1053 2.63604 15.364C3.89471 16.6226 5.49836 17.4798 7.24419 17.8271C8.99002 18.1743 10.7996 17.9961 12.4442 17.3149C14.0887 16.6337 15.4943 15.4802 16.4832 14.0001C17.4722 12.5201 18 10.78 18 9C17.9974 6.61385 17.0483 4.32619 15.3611 2.63893C13.6738 0.951673 11.3861 0.00262044 9 0ZM9.36 17.2719V10.8H11.88C11.9755 10.8 12.067 10.7621 12.1346 10.6946C12.2021 10.627 12.24 10.5355 12.24 10.44C12.24 10.3445 12.2021 10.253 12.1346 10.1854C12.067 10.1179 11.9755 10.08 11.88 10.08H9.36V7.56C9.36 7.08261 9.54964 6.62477 9.88721 6.28721C10.2248 5.94964 10.6826 5.76 11.16 5.76H12.6C12.6955 5.76 12.787 5.72207 12.8546 5.65456C12.9221 5.58704 12.96 5.49548 12.96 5.4C12.96 5.30452 12.9221 5.21295 12.8546 5.14544C12.787 5.07793 12.6955 5.04 12.6 5.04H11.16C10.4917 5.04 9.85068 5.3055 9.37809 5.77809C8.9055 6.25068 8.64 6.89165 8.64 7.56V10.08H6.12C6.02452 10.08 5.93296 10.1179 5.86544 10.1854C5.79793 10.253 5.76 10.3445 5.76 10.44C5.76 10.5355 5.79793 10.627 5.86544 10.6946C5.93296 10.7621 6.02452 10.8 6.12 10.8H8.64V17.2719C6.47724 17.1778 4.43735 16.2404 2.95733 14.6605C1.47731 13.0806 0.674889 10.984 0.721961 8.81968C0.769034 6.65539 1.66186 4.59559 3.20916 3.08157C4.75647 1.56755 6.83519 0.71973 9 0.71973C11.1648 0.71973 13.2435 1.56755 14.7908 3.08157C16.3381 4.59559 17.231 6.65539 17.278 8.81968C17.3251 10.984 16.5227 13.0806 15.0427 14.6605C13.5627 16.2404 11.5228 17.1778 9.36 17.2719Z",
                        fill: "#202635"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                onClick: function() {
                    return copyUrl();
                },
                target: "_blank",
                className: "copy cursor-pointer",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(D, {
                        delayHide: 500,
                        content: "Copy URL",
                        id: "copy-url"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        width: "15",
                        height: "17",
                        viewBox: "0 0 15 17",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        "data-tooltip-id": "copy-url",
                        "data-tooltip-content": copyUrlTooltip,
                        "data-tooltip-place": "top",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M8.04764 14.1519C8.07796 14.1862 8.102 14.2269 8.11841 14.2718C8.13482 14.3166 8.14326 14.3647 8.14326 14.4133C8.14326 14.4618 8.13482 14.5099 8.11841 14.5547C8.102 14.5996 8.07796 14.6403 8.04764 14.6747L7.23746 15.5928C6.44238 16.4938 5.36402 17 4.2396 17C3.11519 17 2.03683 16.4938 1.24175 15.5928C0.446671 14.6918 8.37753e-09 13.4697 0 12.1955C-8.37753e-09 10.9213 0.446671 9.69923 1.24175 8.79822L3.20772 6.5703C3.97207 5.70392 4.99968 5.20128 6.08029 5.16522C7.1609 5.12916 8.21283 5.56241 9.02084 6.37633C9.05296 6.4086 9.07914 6.44772 9.09792 6.49145C9.11669 6.53519 9.12767 6.58268 9.13025 6.63123C9.13282 6.67978 9.12693 6.72842 9.11291 6.77439C9.0989 6.82036 9.07703 6.86274 9.04856 6.89913C9.02009 6.93552 8.98557 6.9652 8.94697 6.98647C8.90838 7.00775 8.86647 7.0202 8.82363 7.02311C8.78079 7.02603 8.73787 7.01935 8.6973 7.00347C8.65674 6.98759 8.61934 6.9628 8.58722 6.93054C7.90377 6.24211 7.01409 5.87554 6.10007 5.90575C5.18605 5.93597 4.31674 6.3607 3.66987 7.09311L1.70308 9.32102C1.03036 10.0834 0.652424 11.1174 0.652424 12.1955C0.652424 13.2736 1.03036 14.3076 1.70308 15.07C2.37581 15.8324 3.28822 16.2606 4.2396 16.2606C5.19098 16.2606 6.1034 15.8324 6.77612 15.07L7.58631 14.1519C7.61659 14.1175 7.65255 14.0903 7.69213 14.0717C7.73171 14.0531 7.77413 14.0435 7.81698 14.0435C7.85982 14.0435 7.90225 14.0531 7.94183 14.0717C7.98141 14.0903 8.01736 14.1175 8.04764 14.1519ZM13.7597 1.40509C12.964 0.505325 11.8859 0 10.7618 0C9.6378 0 8.55966 0.505325 7.764 1.40509L6.95381 2.32323C6.92341 2.35786 6.89933 2.39894 6.88294 2.44412C6.86655 2.48929 6.85817 2.53769 6.85829 2.58654C6.8584 2.63538 6.867 2.68373 6.8836 2.72881C6.9002 2.77388 6.92447 2.81482 6.95503 2.84927C6.98559 2.88371 7.02184 2.91101 7.06171 2.92958C7.10157 2.94815 7.14428 2.95765 7.18738 2.95752C7.23048 2.95739 7.27314 2.94764 7.31292 2.92883C7.3527 2.91002 7.38882 2.88251 7.41922 2.84788L8.22941 1.92974C8.90213 1.16738 9.81455 0.739092 10.7659 0.739092C11.7173 0.739092 12.6297 1.16738 13.3024 1.92974C13.9752 2.69211 14.3531 3.72609 14.3531 4.80423C14.3531 5.88237 13.9752 6.91636 13.3024 7.67872L11.3316 9.90663C10.6848 10.6392 9.81556 11.0641 8.90154 11.0945C7.98752 11.1248 7.09778 10.7584 6.41423 10.0701C6.38212 10.0379 6.34471 10.0131 6.30415 9.99719C6.26359 9.98131 6.22066 9.97463 6.17782 9.97755C6.09131 9.98344 6.0104 10.028 5.9529 10.1015C5.89539 10.175 5.86601 10.2714 5.87121 10.3694C5.8764 10.4675 5.91576 10.5592 5.98061 10.6243C6.78862 11.4382 7.84055 11.8715 8.92116 11.8354C10.0018 11.7994 11.0294 11.2967 11.7937 10.4304L13.7597 8.20244C14.5539 7.30073 15 6.07874 15 4.80469C15 3.53065 14.5539 2.30866 13.7597 1.40694V1.40509Z",
                            fill: "#202635"
                        })
                    })
                ]
            })
        ]
    });
}
ArticleHeroShare.displayName = "ArticleArticleHeroShare";

;// CONCATENATED MODULE: ./src/sections/ArticleHero/ArticleHero.jsx







function ArticleHero(param) {
    var cms = param.cms;
    var articleTime = cms.articleTime, title = cms.title, mediaImage = cms.mediaImage, mediaVideo = cms.mediaVideo, mediaPlacement = cms.mediaPlacement, backgroundColor = cms.backgroundColor, centerContent = cms.centerContent;
    var hasMedia = mediaImage || mediaVideo;
    var articleSettings = (0,dist.useArticle)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative text-primary",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute inset-0 bg-[#D9D9D9] bg-gradient-to-r from-[#2179C2] via-[#8DCEF9] to-[#F1DCC1] ".concat(backgroundColor === "blue" ? "opacity-[15%]" : "opacity-[0%]", " ").concat(hasMedia ? "from-[#00000080] to-[#00000000]" : "bg-[#D9D9D9] from-[#2179C2] via-[#8DCEF9] to-[#F1DCC1] text-center opacity-20")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute left-0 top-0 z-[-1] h-full w-full bg-cover bg-center",
                style: {
                    backgroundImage: "".concat(backgroundColor === "red" ? "url(https://cdn.shopify.com/s/files/1/1011/0318/files/pexels-photo-7512939.png?v=1686175785)" : null)
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat(hasMedia ? "md:flex" : "", " ").concat(mediaPlacement && mediaPlacement === "left" ? "flex-row-reverse" : "", " relative overflow-hidden"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(snippets/* Link */.rU, {
                        className: "absolute left-12 top-8 hidden cursor-pointer lg:flex",
                        href: "/blogs/all",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                                className: "w-5 text-text",
                                src: "/svgs/arrow-left.svg#arrow-left",
                                title: "Arrow Left",
                                viewBox: "0 0 24 24"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "pl-6 font-light",
                                children: "Back to blog"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "md:px-contained flex flex-col items-center px-[18px] py-4 text-left lg:py-28 ".concat(hasMedia ? "md:flex-[0_0_50%]" : "md:text-center", " ").concat(centerContent ? "!text-center" : ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mx-auto flex w-full max-w-[975px] grow flex-col justify-center md:text-text ".concat(hasMedia ? "text-white" : "text-text"),
                                children: [
                                    (articleSettings === null || articleSettings === void 0 ? void 0 : articleSettings.category) && articleTime && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "font-momo !lg:text-[14px] mb-5 text-sm uppercase tracking-[0.04em] text-[#202635]",
                                        children: [
                                            articleSettings.category,
                                            " •",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "text-shadowGray",
                                                children: [
                                                    articleTime,
                                                    " MIN READ"
                                                ]
                                            })
                                        ]
                                    }),
                                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                                        className: "mb-6 capitalize text-[#202635]",
                                        variant: "h2",
                                        element: "h2",
                                        children: title
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleHeroShare, {
                                link: "/articles/".concat(articleSettings === null || articleSettings === void 0 ? void 0 : articleSettings.handle),
                                centerContent: centerContent,
                                title: title
                            })
                        ]
                    }),
                    hasMedia ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative inset-0 z-0 md:flex-[0_0_50%] lg:px-12 lg:py-28",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative aspect-[762/576] min-h-full max-w-full",
                            children: [
                                (mediaImage === null || mediaImage === void 0 ? void 0 : mediaImage.src) && !mediaVideo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                    fill: true,
                                    alt: title,
                                    sizes: "(min-width: 1024px) 40vw, 100vw",
                                    src: mediaImage === null || mediaImage === void 0 ? void 0 : mediaImage.src
                                }) : null,
                                mediaVideo ? /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                    src: mediaVideo,
                                    autoPlay: true,
                                    muted: true,
                                    loop: true,
                                    playsInline: true,
                                    className: "h-full w-full object-cover"
                                }) : null
                            ]
                        })
                    }) : null
                ]
            })
        ]
    });
}
ArticleHero.displayName = "ArticleHero";
ArticleHero.Schema = ArticleHero_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/ArticleHero/index.js


;// CONCATENATED MODULE: ./src/sections/ArticleImage/ArticleImage.schema.js
function ArticleImage_schema_Schema() {
    return {
        category: "Article",
        label: "Article Image",
        key: "articleImage",
        // previewSrc:
        //   'https://cdn.shopify.com/s/files/1/1011/0318/files/Screenshot_2024-09-04_at_9.51.32_AM.png?v=1725468763',
        fields: [
            {
                label: "Image",
                name: "image",
                component: "image"
            },
            {
                label: "Image Link",
                name: "imageLink",
                component: "link"
            },
            {
                label: "Caption",
                name: "caption",
                component: "text"
            },
            {
                label: "Attribution",
                name: "attribution",
                component: "text"
            },
            {
                label: "Attribution Link",
                name: "attributionLink",
                component: "link"
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/ArticleImage/ArticleImage.jsx



function ArticleImage(param) {
    var cms = param.cms;
    var image = cms.image, imageLink = cms.imageLink, caption = cms.caption, attribution = cms.attribution, attributionLink = cms.attributionLink;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mb-8 lg:mb-16",
        children: [
            image && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                href: (ref = imageLink === null || imageLink === void 0 ? void 0 : imageLink.url) !== null && ref !== void 0 ? ref : "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                    src: image.src,
                    width: image.width,
                    height: image.height
                })
            }),
            (caption || attribution) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Attribution */.xn, {
                caption: caption,
                attribution: attribution,
                attributionLink: attributionLink
            })
        ]
    });
}
ArticleImage.displayName = "ArticleImage";
ArticleImage.Schema = ArticleImage_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/ArticleImage/index.js


;// CONCATENATED MODULE: ./src/sections/ArticleReferences/ArticleReferences.schema.js
var ArticleReferences_schema_Schema = function() {
    return {
        category: "Article",
        label: "Article References",
        key: "articleReferences",
        //   previewSrc:
        //     'https://cdn.shopify.com/s/files/1/1011/0318/files/Screen_20Shot_202023-05-24_20at_202.55.23_20PM.png?v=1684965343',
        fields: [
            {
                name: "title",
                component: "text",
                label: "Title",
                description: "Leave Blank to hide from Table of Contents"
            },
            {
                name: "anchorId",
                component: "text",
                label: "Table Of Contents Title",
                description: "Leave Blank to hide from Table of Contents"
            },
            {
                label: "References",
                name: "refrerences",
                component: "group-list",
                itemProps: {
                    label: "{{item.link.text}}"
                },
                fields: [
                    {
                        label: "External reference",
                        name: "link",
                        component: "link"
                    },
                    {
                        label: "Text only reference",
                        name: "text",
                        component: "text",
                        description: "Will replace external reference if filled"
                    }, 
                ],
                defaultItem: {
                    link: {
                        text: "US EPA. National Primary Drinking Water Regulations. Accessed September 2, 2019",
                        url: "https://www.epa.gov/ground-water-and-drinking-water/national-primary-drinking-water-regulations"
                    }
                }
            }, 
        ]
    };
};

;// CONCATENATED MODULE: ./src/sections/ArticleReferences/ArticleReferences.jsx





function ArticleReferences(param) {
    var cms = param.cms;
    var title = cms.title, anchorId = cms.anchorId, refrerences = cms.refrerences;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative mb-8 lg:mb-16",
        children: [
            anchorId && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: (0,handleize/* default */.Z)(anchorId),
                className: "absolute top-16"
            }),
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                variant: "h4",
                element: "h4",
                className: "border-t border-[#DDE2E7] pb-4 pt-12 lg:pb-16",
                children: title
            }),
            refrerences === null || refrerences === void 0 ? void 0 : refrerences.map(function(param, index) {
                var link = param.link, text = param.text;
                return text ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "overflow-auto pb-4 font-light",
                    children: [
                        index + 1,
                        ". ",
                        text
                    ]
                }, index) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "overflow-auto pb-4 font-light",
                    children: [
                        index + 1,
                        ". ",
                        link.text,
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                            href: link === null || link === void 0 ? void 0 : link.url,
                            children: link === null || link === void 0 ? void 0 : link.url
                        })
                    ]
                }, index);
            })
        ]
    });
}
ArticleReferences.displayName = "ArticleReferences";
ArticleReferences.Schema = ArticleReferences_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/ArticleReferences/index.js


;// CONCATENATED MODULE: ../node_modules/@vimeo/player/dist/player.es.js
/*! @vimeo/player v2.21.0 | (c) 2024 Vimeo | MIT License | https://github.com/vimeo/player.js */
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

/**
 * @module lib/functions
 */

/**
 * Check to see this is a node environment.
 * @type {Boolean}
 */
/* global global */
var player_es_isNode = typeof __webpack_require__.g !== 'undefined' && {}.toString.call(__webpack_require__.g) === '[object global]';

/**
 * Get the name of the method for a given getter or setter.
 *
 * @param {string} prop The name of the property.
 * @param {string} type Either “get” or “set”.
 * @return {string}
 */
function getMethodName(prop, type) {
  if (prop.indexOf(type.toLowerCase()) === 0) {
    return prop;
  }
  return "".concat(type.toLowerCase()).concat(prop.substr(0, 1).toUpperCase()).concat(prop.substr(1));
}

/**
 * Check to see if the object is a DOM Element.
 *
 * @param {*} element The object to check.
 * @return {boolean}
 */
function isDomElement(element) {
  return Boolean(element && element.nodeType === 1 && 'nodeName' in element && element.ownerDocument && element.ownerDocument.defaultView);
}

/**
 * Check to see whether the value is a number.
 *
 * @see http://dl.dropboxusercontent.com/u/35146/js/tests/isNumber.html
 * @param {*} value The value to check.
 * @param {boolean} integer Check if the value is an integer.
 * @return {boolean}
 */
function isInteger(value) {
  // eslint-disable-next-line eqeqeq
  return !isNaN(parseFloat(value)) && isFinite(value) && Math.floor(value) == value;
}

/**
 * Check to see if the URL is a Vimeo url.
 *
 * @param {string} url The url string.
 * @return {boolean}
 */
function isVimeoUrl(url) {
  return /^(https?:)?\/\/((player|www)\.)?vimeo\.com(?=$|\/)/.test(url);
}

/**
 * Check to see if the URL is for a Vimeo embed.
 *
 * @param {string} url The url string.
 * @return {boolean}
 */
function isVimeoEmbed(url) {
  var expr = /^https:\/\/player\.vimeo\.com\/video\/\d+/;
  return expr.test(url);
}

/**
 * Get the Vimeo URL from an element.
 * The element must have either a data-vimeo-id or data-vimeo-url attribute.
 *
 * @param {object} oEmbedParameters The oEmbed parameters.
 * @return {string}
 */
function getVimeoUrl() {
  var oEmbedParameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var id = oEmbedParameters.id;
  var url = oEmbedParameters.url;
  var idOrUrl = id || url;
  if (!idOrUrl) {
    throw new Error('An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.');
  }
  if (isInteger(idOrUrl)) {
    return "https://vimeo.com/".concat(idOrUrl);
  }
  if (isVimeoUrl(idOrUrl)) {
    return idOrUrl.replace('http:', 'https:');
  }
  if (id) {
    throw new TypeError("\u201C".concat(id, "\u201D is not a valid video id."));
  }
  throw new TypeError("\u201C".concat(idOrUrl, "\u201D is not a vimeo.com url."));
}

/* eslint-disable max-params */
/**
 * A utility method for attaching and detaching event handlers
 *
 * @param {EventTarget} target
 * @param {string | string[]} eventName
 * @param {function} callback
 * @param {'addEventListener' | 'on'} onName
 * @param {'removeEventListener' | 'off'} offName
 * @return {{cancel: (function(): void)}}
 */
var subscribe = function subscribe(target, eventName, callback) {
  var onName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'addEventListener';
  var offName = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'removeEventListener';
  var eventNames = typeof eventName === 'string' ? [eventName] : eventName;
  eventNames.forEach(function (evName) {
    target[onName](evName, callback);
  });
  return {
    cancel: function cancel() {
      return eventNames.forEach(function (evName) {
        return target[offName](evName, callback);
      });
    }
  };
};

var arrayIndexOfSupport = typeof Array.prototype.indexOf !== 'undefined';
var postMessageSupport = typeof window !== 'undefined' && typeof window.postMessage !== 'undefined';
if (!player_es_isNode && (!arrayIndexOfSupport || !postMessageSupport)) {
  throw new Error('Sorry, the Vimeo Player API is not available in this browser.');
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/*!
 * weakmap-polyfill v2.0.4 - ECMAScript6 WeakMap polyfill
 * https://github.com/polygonplanet/weakmap-polyfill
 * Copyright (c) 2015-2021 polygonplanet <polygon.planet.aqua@gmail.com>
 * @license MIT
 */

(function (self) {

  if (self.WeakMap) {
    return;
  }
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var hasDefine = Object.defineProperty && function () {
    try {
      // Avoid IE8's broken Object.defineProperty
      return Object.defineProperty({}, 'x', {
        value: 1
      }).x === 1;
    } catch (e) {}
  }();
  var defineProperty = function (object, name, value) {
    if (hasDefine) {
      Object.defineProperty(object, name, {
        configurable: true,
        writable: true,
        value: value
      });
    } else {
      object[name] = value;
    }
  };
  self.WeakMap = function () {
    // ECMA-262 23.3 WeakMap Objects
    function WeakMap() {
      if (this === void 0) {
        throw new TypeError("Constructor WeakMap requires 'new'");
      }
      defineProperty(this, '_id', genId('_WeakMap'));

      // ECMA-262 23.3.1.1 WeakMap([iterable])
      if (arguments.length > 0) {
        // Currently, WeakMap `iterable` argument is not supported
        throw new TypeError('WeakMap iterable is not supported');
      }
    }

    // ECMA-262 23.3.3.2 WeakMap.prototype.delete(key)
    defineProperty(WeakMap.prototype, 'delete', function (key) {
      checkInstance(this, 'delete');
      if (!isObject(key)) {
        return false;
      }
      var entry = key[this._id];
      if (entry && entry[0] === key) {
        delete key[this._id];
        return true;
      }
      return false;
    });

    // ECMA-262 23.3.3.3 WeakMap.prototype.get(key)
    defineProperty(WeakMap.prototype, 'get', function (key) {
      checkInstance(this, 'get');
      if (!isObject(key)) {
        return void 0;
      }
      var entry = key[this._id];
      if (entry && entry[0] === key) {
        return entry[1];
      }
      return void 0;
    });

    // ECMA-262 23.3.3.4 WeakMap.prototype.has(key)
    defineProperty(WeakMap.prototype, 'has', function (key) {
      checkInstance(this, 'has');
      if (!isObject(key)) {
        return false;
      }
      var entry = key[this._id];
      if (entry && entry[0] === key) {
        return true;
      }
      return false;
    });

    // ECMA-262 23.3.3.5 WeakMap.prototype.set(key, value)
    defineProperty(WeakMap.prototype, 'set', function (key, value) {
      checkInstance(this, 'set');
      if (!isObject(key)) {
        throw new TypeError('Invalid value used as weak map key');
      }
      var entry = key[this._id];
      if (entry && entry[0] === key) {
        entry[1] = value;
        return this;
      }
      defineProperty(key, this._id, [key, value]);
      return this;
    });
    function checkInstance(x, methodName) {
      if (!isObject(x) || !hasOwnProperty.call(x, '_id')) {
        throw new TypeError(methodName + ' method called on incompatible receiver ' + typeof x);
      }
    }
    function genId(prefix) {
      return prefix + '_' + rand() + '.' + rand();
    }
    function rand() {
      return Math.random().toString().substring(2);
    }
    defineProperty(WeakMap, '_polyfill', true);
    return WeakMap;
  }();
  function isObject(x) {
    return Object(x) === x;
  }
})(typeof globalThis !== 'undefined' ? globalThis : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : commonjsGlobal);

var npo_src = createCommonjsModule(function (module) {
/*! Native Promise Only
    v0.8.1 (c) Kyle Simpson
    MIT License: http://getify.mit-license.org
*/

(function UMD(name, context, definition) {
  // special form of UMD for polyfilling across evironments
  context[name] = context[name] || definition();
  if ( module.exports) {
    module.exports = context[name];
  }
})("Promise", typeof commonjsGlobal != "undefined" ? commonjsGlobal : commonjsGlobal, function DEF() {

  var builtInProp,
    cycle,
    scheduling_queue,
    ToString = Object.prototype.toString,
    timer = typeof setImmediate != "undefined" ? function timer(fn) {
      return setImmediate(fn);
    } : setTimeout;

  // dammit, IE8.
  try {
    Object.defineProperty({}, "x", {});
    builtInProp = function builtInProp(obj, name, val, config) {
      return Object.defineProperty(obj, name, {
        value: val,
        writable: true,
        configurable: config !== false
      });
    };
  } catch (err) {
    builtInProp = function builtInProp(obj, name, val) {
      obj[name] = val;
      return obj;
    };
  }

  // Note: using a queue instead of array for efficiency
  scheduling_queue = function Queue() {
    var first, last, item;
    function Item(fn, self) {
      this.fn = fn;
      this.self = self;
      this.next = void 0;
    }
    return {
      add: function add(fn, self) {
        item = new Item(fn, self);
        if (last) {
          last.next = item;
        } else {
          first = item;
        }
        last = item;
        item = void 0;
      },
      drain: function drain() {
        var f = first;
        first = last = cycle = void 0;
        while (f) {
          f.fn.call(f.self);
          f = f.next;
        }
      }
    };
  }();
  function schedule(fn, self) {
    scheduling_queue.add(fn, self);
    if (!cycle) {
      cycle = timer(scheduling_queue.drain);
    }
  }

  // promise duck typing
  function isThenable(o) {
    var _then,
      o_type = typeof o;
    if (o != null && (o_type == "object" || o_type == "function")) {
      _then = o.then;
    }
    return typeof _then == "function" ? _then : false;
  }
  function notify() {
    for (var i = 0; i < this.chain.length; i++) {
      notifyIsolated(this, this.state === 1 ? this.chain[i].success : this.chain[i].failure, this.chain[i]);
    }
    this.chain.length = 0;
  }

  // NOTE: This is a separate function to isolate
  // the `try..catch` so that other code can be
  // optimized better
  function notifyIsolated(self, cb, chain) {
    var ret, _then;
    try {
      if (cb === false) {
        chain.reject(self.msg);
      } else {
        if (cb === true) {
          ret = self.msg;
        } else {
          ret = cb.call(void 0, self.msg);
        }
        if (ret === chain.promise) {
          chain.reject(TypeError("Promise-chain cycle"));
        } else if (_then = isThenable(ret)) {
          _then.call(ret, chain.resolve, chain.reject);
        } else {
          chain.resolve(ret);
        }
      }
    } catch (err) {
      chain.reject(err);
    }
  }
  function resolve(msg) {
    var _then,
      self = this;

    // already triggered?
    if (self.triggered) {
      return;
    }
    self.triggered = true;

    // unwrap
    if (self.def) {
      self = self.def;
    }
    try {
      if (_then = isThenable(msg)) {
        schedule(function () {
          var def_wrapper = new MakeDefWrapper(self);
          try {
            _then.call(msg, function $resolve$() {
              resolve.apply(def_wrapper, arguments);
            }, function $reject$() {
              reject.apply(def_wrapper, arguments);
            });
          } catch (err) {
            reject.call(def_wrapper, err);
          }
        });
      } else {
        self.msg = msg;
        self.state = 1;
        if (self.chain.length > 0) {
          schedule(notify, self);
        }
      }
    } catch (err) {
      reject.call(new MakeDefWrapper(self), err);
    }
  }
  function reject(msg) {
    var self = this;

    // already triggered?
    if (self.triggered) {
      return;
    }
    self.triggered = true;

    // unwrap
    if (self.def) {
      self = self.def;
    }
    self.msg = msg;
    self.state = 2;
    if (self.chain.length > 0) {
      schedule(notify, self);
    }
  }
  function iteratePromises(Constructor, arr, resolver, rejecter) {
    for (var idx = 0; idx < arr.length; idx++) {
      (function IIFE(idx) {
        Constructor.resolve(arr[idx]).then(function $resolver$(msg) {
          resolver(idx, msg);
        }, rejecter);
      })(idx);
    }
  }
  function MakeDefWrapper(self) {
    this.def = self;
    this.triggered = false;
  }
  function MakeDef(self) {
    this.promise = self;
    this.state = 0;
    this.triggered = false;
    this.chain = [];
    this.msg = void 0;
  }
  function Promise(executor) {
    if (typeof executor != "function") {
      throw TypeError("Not a function");
    }
    if (this.__NPO__ !== 0) {
      throw TypeError("Not a promise");
    }

    // instance shadowing the inherited "brand"
    // to signal an already "initialized" promise
    this.__NPO__ = 1;
    var def = new MakeDef(this);
    this["then"] = function then(success, failure) {
      var o = {
        success: typeof success == "function" ? success : true,
        failure: typeof failure == "function" ? failure : false
      };
      // Note: `then(..)` itself can be borrowed to be used against
      // a different promise constructor for making the chained promise,
      // by substituting a different `this` binding.
      o.promise = new this.constructor(function extractChain(resolve, reject) {
        if (typeof resolve != "function" || typeof reject != "function") {
          throw TypeError("Not a function");
        }
        o.resolve = resolve;
        o.reject = reject;
      });
      def.chain.push(o);
      if (def.state !== 0) {
        schedule(notify, def);
      }
      return o.promise;
    };
    this["catch"] = function $catch$(failure) {
      return this.then(void 0, failure);
    };
    try {
      executor.call(void 0, function publicResolve(msg) {
        resolve.call(def, msg);
      }, function publicReject(msg) {
        reject.call(def, msg);
      });
    } catch (err) {
      reject.call(def, err);
    }
  }
  var PromisePrototype = builtInProp({}, "constructor", Promise, /*configurable=*/false);

  // Note: Android 4 cannot use `Object.defineProperty(..)` here
  Promise.prototype = PromisePrototype;

  // built-in "brand" to signal an "uninitialized" promise
  builtInProp(PromisePrototype, "__NPO__", 0, /*configurable=*/false);
  builtInProp(Promise, "resolve", function Promise$resolve(msg) {
    var Constructor = this;

    // spec mandated checks
    // note: best "isPromise" check that's practical for now
    if (msg && typeof msg == "object" && msg.__NPO__ === 1) {
      return msg;
    }
    return new Constructor(function executor(resolve, reject) {
      if (typeof resolve != "function" || typeof reject != "function") {
        throw TypeError("Not a function");
      }
      resolve(msg);
    });
  });
  builtInProp(Promise, "reject", function Promise$reject(msg) {
    return new this(function executor(resolve, reject) {
      if (typeof resolve != "function" || typeof reject != "function") {
        throw TypeError("Not a function");
      }
      reject(msg);
    });
  });
  builtInProp(Promise, "all", function Promise$all(arr) {
    var Constructor = this;

    // spec mandated checks
    if (ToString.call(arr) != "[object Array]") {
      return Constructor.reject(TypeError("Not an array"));
    }
    if (arr.length === 0) {
      return Constructor.resolve([]);
    }
    return new Constructor(function executor(resolve, reject) {
      if (typeof resolve != "function" || typeof reject != "function") {
        throw TypeError("Not a function");
      }
      var len = arr.length,
        msgs = Array(len),
        count = 0;
      iteratePromises(Constructor, arr, function resolver(idx, msg) {
        msgs[idx] = msg;
        if (++count === len) {
          resolve(msgs);
        }
      }, reject);
    });
  });
  builtInProp(Promise, "race", function Promise$race(arr) {
    var Constructor = this;

    // spec mandated checks
    if (ToString.call(arr) != "[object Array]") {
      return Constructor.reject(TypeError("Not an array"));
    }
    return new Constructor(function executor(resolve, reject) {
      if (typeof resolve != "function" || typeof reject != "function") {
        throw TypeError("Not a function");
      }
      iteratePromises(Constructor, arr, function resolver(idx, msg) {
        resolve(msg);
      }, reject);
    });
  });
  return Promise;
});
});

/**
 * @module lib/callbacks
 */

var callbackMap = new WeakMap();

/**
 * Store a callback for a method or event for a player.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name.
 * @param {(function(this:Player, *): void|{resolve: function, reject: function})} callback
 *        The callback to call or an object with resolve and reject functions for a promise.
 * @return {void}
 */
function storeCallback(player, name, callback) {
  var playerCallbacks = callbackMap.get(player.element) || {};
  if (!(name in playerCallbacks)) {
    playerCallbacks[name] = [];
  }
  playerCallbacks[name].push(callback);
  callbackMap.set(player.element, playerCallbacks);
}

/**
 * Get the callbacks for a player and event or method.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name
 * @return {function[]}
 */
function getCallbacks(player, name) {
  var playerCallbacks = callbackMap.get(player.element) || {};
  return playerCallbacks[name] || [];
}

/**
 * Remove a stored callback for a method or event for a player.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name
 * @param {function} [callback] The specific callback to remove.
 * @return {boolean} Was this the last callback?
 */
function removeCallback(player, name, callback) {
  var playerCallbacks = callbackMap.get(player.element) || {};
  if (!playerCallbacks[name]) {
    return true;
  }

  // If no callback is passed, remove all callbacks for the event
  if (!callback) {
    playerCallbacks[name] = [];
    callbackMap.set(player.element, playerCallbacks);
    return true;
  }
  var index = playerCallbacks[name].indexOf(callback);
  if (index !== -1) {
    playerCallbacks[name].splice(index, 1);
  }
  callbackMap.set(player.element, playerCallbacks);
  return playerCallbacks[name] && playerCallbacks[name].length === 0;
}

/**
 * Return the first stored callback for a player and event or method.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name.
 * @return {function} The callback, or false if there were none
 */
function shiftCallbacks(player, name) {
  var playerCallbacks = getCallbacks(player, name);
  if (playerCallbacks.length < 1) {
    return false;
  }
  var callback = playerCallbacks.shift();
  removeCallback(player, name, callback);
  return callback;
}

/**
 * Move callbacks associated with an element to another element.
 *
 * @param {HTMLElement} oldElement The old element.
 * @param {HTMLElement} newElement The new element.
 * @return {void}
 */
function swapCallbacks(oldElement, newElement) {
  var playerCallbacks = callbackMap.get(oldElement);
  callbackMap.set(newElement, playerCallbacks);
  callbackMap.delete(oldElement);
}

/**
 * @module lib/postmessage
 */

/**
 * Parse a message received from postMessage.
 *
 * @param {*} data The data received from postMessage.
 * @return {object}
 */
function parseMessageData(data) {
  if (typeof data === 'string') {
    try {
      data = JSON.parse(data);
    } catch (error) {
      // If the message cannot be parsed, throw the error as a warning
      console.warn(error);
      return {};
    }
  }
  return data;
}

/**
 * Post a message to the specified target.
 *
 * @param {Player} player The player object to use.
 * @param {string} method The API method to call.
 * @param {object} params The parameters to send to the player.
 * @return {void}
 */
function postMessage(player, method, params) {
  if (!player.element.contentWindow || !player.element.contentWindow.postMessage) {
    return;
  }
  var message = {
    method: method
  };
  if (params !== undefined) {
    message.value = params;
  }

  // IE 8 and 9 do not support passing messages, so stringify them
  var ieVersion = parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, '$1'));
  if (ieVersion >= 8 && ieVersion < 10) {
    message = JSON.stringify(message);
  }
  player.element.contentWindow.postMessage(message, player.origin);
}

/**
 * Parse the data received from a message event.
 *
 * @param {Player} player The player that received the message.
 * @param {(Object|string)} data The message data. Strings will be parsed into JSON.
 * @return {void}
 */
function processData(player, data) {
  data = parseMessageData(data);
  var callbacks = [];
  var param;
  if (data.event) {
    if (data.event === 'error') {
      var promises = getCallbacks(player, data.data.method);
      promises.forEach(function (promise) {
        var error = new Error(data.data.message);
        error.name = data.data.name;
        promise.reject(error);
        removeCallback(player, data.data.method, promise);
      });
    }
    callbacks = getCallbacks(player, "event:".concat(data.event));
    param = data.data;
  } else if (data.method) {
    var callback = shiftCallbacks(player, data.method);
    if (callback) {
      callbacks.push(callback);
      param = data.value;
    }
  }
  callbacks.forEach(function (callback) {
    try {
      if (typeof callback === 'function') {
        callback.call(player, param);
        return;
      }
      callback.resolve(param);
    } catch (e) {
      // empty
    }
  });
}

/**
 * @module lib/embed
 */
var oEmbedParameters = ['airplay', 'audio_tracks', 'autopause', 'autoplay', 'background', 'byline', 'cc', 'chapters', 'chromecast', 'color', 'colors', 'controls', 'dnt', 'fullscreen', 'height', 'id', 'interactive_params', 'keyboard', 'loop', 'maxheight', 'maxwidth', 'muted', 'play_button_position', 'playsinline', 'portrait', 'progress_bar', 'quality_selector', 'responsive', 'speed', 'texttrack', 'title', 'transcript', 'transparent', 'url', 'vimeo_logo', 'volume', 'width'];

/**
 * Get the 'data-vimeo'-prefixed attributes from an element as an object.
 *
 * @param {HTMLElement} element The element.
 * @param {Object} [defaults={}] The default values to use.
 * @return {Object<string, string>}
 */
function getOEmbedParameters(element) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return oEmbedParameters.reduce(function (params, param) {
    var value = element.getAttribute("data-vimeo-".concat(param));
    if (value || value === '') {
      params[param] = value === '' ? 1 : value;
    }
    return params;
  }, defaults);
}

/**
 * Create an embed from oEmbed data inside an element.
 *
 * @param {object} data The oEmbed data.
 * @param {HTMLElement} element The element to put the iframe in.
 * @return {HTMLIFrameElement} The iframe embed.
 */
function createEmbed(_ref, element) {
  var html = _ref.html;
  if (!element) {
    throw new TypeError('An element must be provided');
  }
  if (element.getAttribute('data-vimeo-initialized') !== null) {
    return element.querySelector('iframe');
  }
  var div = document.createElement('div');
  div.innerHTML = html;
  element.appendChild(div.firstChild);
  element.setAttribute('data-vimeo-initialized', 'true');
  return element.querySelector('iframe');
}

/**
 * Make an oEmbed call for the specified URL.
 *
 * @param {string} videoUrl The vimeo.com url for the video.
 * @param {Object} [params] Parameters to pass to oEmbed.
 * @param {HTMLElement} element The element.
 * @return {Promise}
 */
function getOEmbedData(videoUrl) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var element = arguments.length > 2 ? arguments[2] : undefined;
  return new Promise(function (resolve, reject) {
    if (!isVimeoUrl(videoUrl)) {
      throw new TypeError("\u201C".concat(videoUrl, "\u201D is not a vimeo.com url."));
    }
    var url = "https://vimeo.com/api/oembed.json?url=".concat(encodeURIComponent(videoUrl));
    for (var param in params) {
      if (params.hasOwnProperty(param)) {
        url += "&".concat(param, "=").concat(encodeURIComponent(params[param]));
      }
    }
    var xhr = 'XDomainRequest' in window ? new XDomainRequest() : new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.onload = function () {
      if (xhr.status === 404) {
        reject(new Error("\u201C".concat(videoUrl, "\u201D was not found.")));
        return;
      }
      if (xhr.status === 403) {
        reject(new Error("\u201C".concat(videoUrl, "\u201D is not embeddable.")));
        return;
      }
      try {
        var json = JSON.parse(xhr.responseText);
        // Check api response for 403 on oembed
        if (json.domain_status_code === 403) {
          // We still want to create the embed to give users visual feedback
          createEmbed(json, element);
          reject(new Error("\u201C".concat(videoUrl, "\u201D is not embeddable.")));
          return;
        }
        resolve(json);
      } catch (error) {
        reject(error);
      }
    };
    xhr.onerror = function () {
      var status = xhr.status ? " (".concat(xhr.status, ")") : '';
      reject(new Error("There was an error fetching the embed code from Vimeo".concat(status, ".")));
    };
    xhr.send();
  });
}

/**
 * Initialize all embeds within a specific element
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */
function initializeEmbeds() {
  var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  var elements = [].slice.call(parent.querySelectorAll('[data-vimeo-id], [data-vimeo-url]'));
  var handleError = function handleError(error) {
    if ('console' in window && console.error) {
      console.error("There was an error creating an embed: ".concat(error));
    }
  };
  elements.forEach(function (element) {
    try {
      // Skip any that have data-vimeo-defer
      if (element.getAttribute('data-vimeo-defer') !== null) {
        return;
      }
      var params = getOEmbedParameters(element);
      var url = getVimeoUrl(params);
      getOEmbedData(url, params, element).then(function (data) {
        return createEmbed(data, element);
      }).catch(handleError);
    } catch (error) {
      handleError(error);
    }
  });
}

/**
 * Resize embeds when messaged by the player.
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */
function resizeEmbeds() {
  var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  // Prevent execution if users include the player.js script multiple times.
  if (window.VimeoPlayerResizeEmbeds_) {
    return;
  }
  window.VimeoPlayerResizeEmbeds_ = true;
  var onMessage = function onMessage(event) {
    if (!isVimeoUrl(event.origin)) {
      return;
    }

    // 'spacechange' is fired only on embeds with cards
    if (!event.data || event.data.event !== 'spacechange') {
      return;
    }
    var iframes = parent.querySelectorAll('iframe');
    for (var i = 0; i < iframes.length; i++) {
      if (iframes[i].contentWindow !== event.source) {
        continue;
      }

      // Change padding-bottom of the enclosing div to accommodate
      // card carousel without distorting aspect ratio
      var space = iframes[i].parentElement;
      space.style.paddingBottom = "".concat(event.data.data[0].bottom, "px");
      break;
    }
  };
  window.addEventListener('message', onMessage);
}

/**
 * Add chapters to existing metadata for Google SEO
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */
function initAppendVideoMetadata() {
  var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  //  Prevent execution if users include the player.js script multiple times.
  if (window.VimeoSeoMetadataAppended) {
    return;
  }
  window.VimeoSeoMetadataAppended = true;
  var onMessage = function onMessage(event) {
    if (!isVimeoUrl(event.origin)) {
      return;
    }
    var data = parseMessageData(event.data);
    if (!data || data.event !== 'ready') {
      return;
    }
    var iframes = parent.querySelectorAll('iframe');
    for (var i = 0; i < iframes.length; i++) {
      var iframe = iframes[i];

      // Initiate appendVideoMetadata if iframe is a Vimeo embed
      var isValidMessageSource = iframe.contentWindow === event.source;
      if (isVimeoEmbed(iframe.src) && isValidMessageSource) {
        var player = new Player(iframe);
        player.callMethod('appendVideoMetadata', window.location.href);
      }
    }
  };
  window.addEventListener('message', onMessage);
}

/**
 * Seek to time indicated by vimeo_t query parameter if present in URL
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */
function checkUrlTimeParam() {
  var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  //  Prevent execution if users include the player.js script multiple times.
  if (window.VimeoCheckedUrlTimeParam) {
    return;
  }
  window.VimeoCheckedUrlTimeParam = true;
  var handleError = function handleError(error) {
    if ('console' in window && console.error) {
      console.error("There was an error getting video Id: ".concat(error));
    }
  };
  var onMessage = function onMessage(event) {
    if (!isVimeoUrl(event.origin)) {
      return;
    }
    var data = parseMessageData(event.data);
    if (!data || data.event !== 'ready') {
      return;
    }
    var iframes = parent.querySelectorAll('iframe');
    var _loop = function _loop() {
      var iframe = iframes[i];
      var isValidMessageSource = iframe.contentWindow === event.source;
      if (isVimeoEmbed(iframe.src) && isValidMessageSource) {
        var player = new Player(iframe);
        player.getVideoId().then(function (videoId) {
          var matches = new RegExp("[?&]vimeo_t_".concat(videoId, "=([^&#]*)")).exec(window.location.href);
          if (matches && matches[1]) {
            var sec = decodeURI(matches[1]);
            player.setCurrentTime(sec);
          }
          return;
        }).catch(handleError);
      }
    };
    for (var i = 0; i < iframes.length; i++) {
      _loop();
    }
  };
  window.addEventListener('message', onMessage);
}

/* MIT License

Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
Terms */

function initializeScreenfull() {
  var fn = function () {
    var val;
    var fnMap = [['requestFullscreen', 'exitFullscreen', 'fullscreenElement', 'fullscreenEnabled', 'fullscreenchange', 'fullscreenerror'],
    // New WebKit
    ['webkitRequestFullscreen', 'webkitExitFullscreen', 'webkitFullscreenElement', 'webkitFullscreenEnabled', 'webkitfullscreenchange', 'webkitfullscreenerror'],
    // Old WebKit
    ['webkitRequestFullScreen', 'webkitCancelFullScreen', 'webkitCurrentFullScreenElement', 'webkitCancelFullScreen', 'webkitfullscreenchange', 'webkitfullscreenerror'], ['mozRequestFullScreen', 'mozCancelFullScreen', 'mozFullScreenElement', 'mozFullScreenEnabled', 'mozfullscreenchange', 'mozfullscreenerror'], ['msRequestFullscreen', 'msExitFullscreen', 'msFullscreenElement', 'msFullscreenEnabled', 'MSFullscreenChange', 'MSFullscreenError']];
    var i = 0;
    var l = fnMap.length;
    var ret = {};
    for (; i < l; i++) {
      val = fnMap[i];
      if (val && val[1] in document) {
        for (i = 0; i < val.length; i++) {
          ret[fnMap[0][i]] = val[i];
        }
        return ret;
      }
    }
    return false;
  }();
  var eventNameMap = {
    fullscreenchange: fn.fullscreenchange,
    fullscreenerror: fn.fullscreenerror
  };
  var screenfull = {
    request: function request(element) {
      return new Promise(function (resolve, reject) {
        var onFullScreenEntered = function onFullScreenEntered() {
          screenfull.off('fullscreenchange', onFullScreenEntered);
          resolve();
        };
        screenfull.on('fullscreenchange', onFullScreenEntered);
        element = element || document.documentElement;
        var returnPromise = element[fn.requestFullscreen]();
        if (returnPromise instanceof Promise) {
          returnPromise.then(onFullScreenEntered).catch(reject);
        }
      });
    },
    exit: function exit() {
      return new Promise(function (resolve, reject) {
        if (!screenfull.isFullscreen) {
          resolve();
          return;
        }
        var onFullScreenExit = function onFullScreenExit() {
          screenfull.off('fullscreenchange', onFullScreenExit);
          resolve();
        };
        screenfull.on('fullscreenchange', onFullScreenExit);
        var returnPromise = document[fn.exitFullscreen]();
        if (returnPromise instanceof Promise) {
          returnPromise.then(onFullScreenExit).catch(reject);
        }
      });
    },
    on: function on(event, callback) {
      var eventName = eventNameMap[event];
      if (eventName) {
        document.addEventListener(eventName, callback);
      }
    },
    off: function off(event, callback) {
      var eventName = eventNameMap[event];
      if (eventName) {
        document.removeEventListener(eventName, callback);
      }
    }
  };
  Object.defineProperties(screenfull, {
    isFullscreen: {
      get: function get() {
        return Boolean(document[fn.fullscreenElement]);
      }
    },
    element: {
      enumerable: true,
      get: function get() {
        return document[fn.fullscreenElement];
      }
    },
    isEnabled: {
      enumerable: true,
      get: function get() {
        // Coerce to boolean in case of old WebKit
        return Boolean(document[fn.fullscreenEnabled]);
      }
    }
  });
  return screenfull;
}

/** @typedef {import('./timing-src-connector.types').PlayerControls} PlayerControls */
/** @typedef {import('./timing-object.types').TimingObject} TimingObject */
/** @typedef {import('./timing-src-connector.types').TimingSrcConnectorOptions} TimingSrcConnectorOptions */
/** @typedef {(msg: string) => any} Logger */
/** @typedef {import('timing-object.types').TConnectionState} TConnectionState */

/**
 * @type {TimingSrcConnectorOptions}
 *
 * For details on these properties and their effects, see the typescript definition referenced above.
 */
var defaultOptions = {
  role: 'viewer',
  autoPlayMuted: true,
  allowedDrift: 0.3,
  maxAllowedDrift: 1,
  minCheckInterval: 0.1,
  maxRateAdjustment: 0.2,
  maxTimeToCatchUp: 1
};

/**
 * There's a proposed W3C spec for the Timing Object which would introduce a new set of APIs that would simplify time-synchronization tasks for browser applications.
 *
 * Proposed spec: https://webtiming.github.io/timingobject/
 * V3 Spec: https://timingsrc.readthedocs.io/en/latest/
 * Demuxed talk: https://www.youtube.com/watch?v=cZSjDaGDmX8
 *
 * This class makes it easy to connect Vimeo.Player to a provided TimingObject via Vimeo.Player.setTimingSrc(myTimingObject, options) and the synchronization will be handled automatically.
 *
 * There are 5 general responsibilities in TimingSrcConnector:
 *
 * 1. `updatePlayer()` which sets the player's currentTime, playbackRate and pause/play state based on current state of the TimingObject.
 * 2. `updateTimingObject()` which sets the TimingObject's position and velocity from the player's state.
 * 3. `playerUpdater` which listens for change events on the TimingObject and will respond by calling updatePlayer.
 * 4. `timingObjectUpdater` which listens to the player events of seeked, play and pause and will respond by calling `updateTimingObject()`.
 * 5. `maintainPlaybackPosition` this is code that constantly monitors the player to make sure it's always in sync with the TimingObject. This is needed because videos will generally not play with precise time accuracy and there will be some drift which becomes more noticeable over longer periods (as noted in the timing-object spec). More details on this method below.
 */
var TimingSrcConnector = /*#__PURE__*/function (_EventTarget) {
  _inherits(TimingSrcConnector, _EventTarget);
  var _super = _createSuper(TimingSrcConnector);
  /**
   * @param {PlayerControls} player
   * @param {TimingObject} timingObject
   * @param {TimingSrcConnectorOptions} options
   * @param {Logger} logger
   */
  function TimingSrcConnector(_player, timingObject) {
    var _this;
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var logger = arguments.length > 3 ? arguments[3] : undefined;
    _classCallCheck(this, TimingSrcConnector);
    _this = _super.call(this);
    _defineProperty(_assertThisInitialized(_this), "logger", void 0);
    _defineProperty(_assertThisInitialized(_this), "speedAdjustment", 0);
    /**
     * @param {PlayerControls} player
     * @param {number} newAdjustment
     * @return {Promise<void>}
     */
    _defineProperty(_assertThisInitialized(_this), "adjustSpeed", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(player, newAdjustment) {
        var newPlaybackRate;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(_this.speedAdjustment === newAdjustment)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.next = 4;
              return player.getPlaybackRate();
            case 4:
              _context.t0 = _context.sent;
              _context.t1 = _this.speedAdjustment;
              _context.t2 = _context.t0 - _context.t1;
              _context.t3 = newAdjustment;
              newPlaybackRate = _context.t2 + _context.t3;
              _this.log("New playbackRate:  ".concat(newPlaybackRate));
              _context.next = 12;
              return player.setPlaybackRate(newPlaybackRate);
            case 12:
              _this.speedAdjustment = newAdjustment;
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
    _this.logger = logger;
    _this.init(timingObject, _player, _objectSpread2(_objectSpread2({}, defaultOptions), options));
    return _this;
  }
  _createClass(TimingSrcConnector, [{
    key: "disconnect",
    value: function disconnect() {
      this.dispatchEvent(new Event('disconnect'));
    }

    /**
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @param {TimingSrcConnectorOptions} options
     * @return {Promise<void>}
     */
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(timingObject, player, options) {
        var _this2 = this;
        var playerUpdater, positionSync, timingObjectUpdater;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.waitForTOReadyState(timingObject, 'open');
            case 2:
              if (!(options.role === 'viewer')) {
                _context2.next = 10;
                break;
              }
              _context2.next = 5;
              return this.updatePlayer(timingObject, player, options);
            case 5:
              playerUpdater = subscribe(timingObject, 'change', function () {
                return _this2.updatePlayer(timingObject, player, options);
              });
              positionSync = this.maintainPlaybackPosition(timingObject, player, options);
              this.addEventListener('disconnect', function () {
                positionSync.cancel();
                playerUpdater.cancel();
              });
              _context2.next = 14;
              break;
            case 10:
              _context2.next = 12;
              return this.updateTimingObject(timingObject, player);
            case 12:
              timingObjectUpdater = subscribe(player, ['seeked', 'play', 'pause', 'ratechange'], function () {
                return _this2.updateTimingObject(timingObject, player);
              }, 'on', 'off');
              this.addEventListener('disconnect', function () {
                return timingObjectUpdater.cancel();
              });
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function init(_x3, _x4, _x5) {
        return _init.apply(this, arguments);
      }
      return init;
    }()
    /**
     * Sets the TimingObject's state to reflect that of the player
     *
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @return {Promise<void>}
     */
  }, {
    key: "updateTimingObject",
    value: function () {
      var _updateTimingObject = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(timingObject, player) {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.t0 = timingObject;
              _context3.next = 3;
              return player.getCurrentTime();
            case 3:
              _context3.t1 = _context3.sent;
              _context3.next = 6;
              return player.getPaused();
            case 6:
              if (!_context3.sent) {
                _context3.next = 10;
                break;
              }
              _context3.t2 = 0;
              _context3.next = 13;
              break;
            case 10:
              _context3.next = 12;
              return player.getPlaybackRate();
            case 12:
              _context3.t2 = _context3.sent;
            case 13:
              _context3.t3 = _context3.t2;
              _context3.t4 = {
                position: _context3.t1,
                velocity: _context3.t3
              };
              _context3.t0.update.call(_context3.t0, _context3.t4);
            case 16:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function updateTimingObject(_x6, _x7) {
        return _updateTimingObject.apply(this, arguments);
      }
      return updateTimingObject;
    }()
    /**
     * Sets the player's timing state to reflect that of the TimingObject
     *
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @param {TimingSrcConnectorOptions} options
     * @return {Promise<void>}
     */
  }, {
    key: "updatePlayer",
    value: function () {
      var _updatePlayer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(timingObject, player, options) {
        var _timingObject$query, position, velocity;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _timingObject$query = timingObject.query(), position = _timingObject$query.position, velocity = _timingObject$query.velocity;
              if (typeof position === 'number') {
                player.setCurrentTime(position);
              }
              if (!(typeof velocity === 'number')) {
                _context5.next = 25;
                break;
              }
              if (!(velocity === 0)) {
                _context5.next = 11;
                break;
              }
              _context5.next = 6;
              return player.getPaused();
            case 6:
              _context5.t0 = _context5.sent;
              if (!(_context5.t0 === false)) {
                _context5.next = 9;
                break;
              }
              player.pause();
            case 9:
              _context5.next = 25;
              break;
            case 11:
              if (!(velocity > 0)) {
                _context5.next = 25;
                break;
              }
              _context5.next = 14;
              return player.getPaused();
            case 14:
              _context5.t1 = _context5.sent;
              if (!(_context5.t1 === true)) {
                _context5.next = 19;
                break;
              }
              _context5.next = 18;
              return player.play().catch( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(err) {
                  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        if (!(err.name === 'NotAllowedError' && options.autoPlayMuted)) {
                          _context4.next = 5;
                          break;
                        }
                        _context4.next = 3;
                        return player.setMuted(true);
                      case 3:
                        _context4.next = 5;
                        return player.play().catch(function (err2) {
                          return console.error('Couldn\'t play the video from TimingSrcConnector. Error:', err2);
                        });
                      case 5:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }));
                return function (_x11) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 18:
              this.updatePlayer(timingObject, player, options);
            case 19:
              _context5.next = 21;
              return player.getPlaybackRate();
            case 21:
              _context5.t2 = _context5.sent;
              _context5.t3 = velocity;
              if (!(_context5.t2 !== _context5.t3)) {
                _context5.next = 25;
                break;
              }
              player.setPlaybackRate(velocity);
            case 25:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function updatePlayer(_x8, _x9, _x10) {
        return _updatePlayer.apply(this, arguments);
      }
      return updatePlayer;
    }()
    /**
     * Since video players do not play with 100% time precision, we need to closely monitor
     * our player to be sure it remains in sync with the TimingObject.
     *
     * If out of sync, we use the current conditions and the options provided to determine
     * whether to re-sync via setting currentTime or adjusting the playbackRate
     *
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @param {TimingSrcConnectorOptions} options
     * @return {{cancel: (function(): void)}}
     */
  }, {
    key: "maintainPlaybackPosition",
    value: function maintainPlaybackPosition(timingObject, player, options) {
      var _this3 = this;
      var allowedDrift = options.allowedDrift,
        maxAllowedDrift = options.maxAllowedDrift,
        minCheckInterval = options.minCheckInterval,
        maxRateAdjustment = options.maxRateAdjustment,
        maxTimeToCatchUp = options.maxTimeToCatchUp;
      var syncInterval = Math.min(maxTimeToCatchUp, Math.max(minCheckInterval, maxAllowedDrift)) * 1000;
      var check = /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
          var diff, diffAbs, min, max, adjustment;
          return _regeneratorRuntime().wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                _context6.t0 = timingObject.query().velocity === 0;
                if (_context6.t0) {
                  _context6.next = 6;
                  break;
                }
                _context6.next = 4;
                return player.getPaused();
              case 4:
                _context6.t1 = _context6.sent;
                _context6.t0 = _context6.t1 === true;
              case 6:
                if (!_context6.t0) {
                  _context6.next = 8;
                  break;
                }
                return _context6.abrupt("return");
              case 8:
                _context6.t2 = timingObject.query().position;
                _context6.next = 11;
                return player.getCurrentTime();
              case 11:
                _context6.t3 = _context6.sent;
                diff = _context6.t2 - _context6.t3;
                diffAbs = Math.abs(diff);
                _this3.log("Drift: ".concat(diff));
                if (!(diffAbs > maxAllowedDrift)) {
                  _context6.next = 22;
                  break;
                }
                _context6.next = 18;
                return _this3.adjustSpeed(player, 0);
              case 18:
                player.setCurrentTime(timingObject.query().position);
                _this3.log('Resync by currentTime');
                _context6.next = 29;
                break;
              case 22:
                if (!(diffAbs > allowedDrift)) {
                  _context6.next = 29;
                  break;
                }
                min = diffAbs / maxTimeToCatchUp;
                max = maxRateAdjustment;
                adjustment = min < max ? (max - min) / 2 : max;
                _context6.next = 28;
                return _this3.adjustSpeed(player, adjustment * Math.sign(diff));
              case 28:
                _this3.log('Resync by playbackRate');
              case 29:
              case "end":
                return _context6.stop();
            }
          }, _callee6);
        }));
        return function check() {
          return _ref3.apply(this, arguments);
        };
      }();
      var interval = setInterval(function () {
        return check();
      }, syncInterval);
      return {
        cancel: function cancel() {
          return clearInterval(interval);
        }
      };
    }

    /**
     * @param {string} msg
     */
  }, {
    key: "log",
    value: function log(msg) {
      var _this$logger;
      (_this$logger = this.logger) === null || _this$logger === void 0 ? void 0 : _this$logger.call(this, "TimingSrcConnector: ".concat(msg));
    }
  }, {
    key: "waitForTOReadyState",
    value:
    /**
     * @param {TimingObject} timingObject
     * @param {TConnectionState} state
     * @return {Promise<void>}
     */
    function waitForTOReadyState(timingObject, state) {
      return new Promise(function (resolve) {
        var check = function check() {
          if (timingObject.readyState === state) {
            resolve();
          } else {
            timingObject.addEventListener('readystatechange', check, {
              once: true
            });
          }
        };
        check();
      });
    }
  }]);
  return TimingSrcConnector;
}( /*#__PURE__*/_wrapNativeSuper(EventTarget));

var playerMap = new WeakMap();
var readyMap = new WeakMap();
var screenfull = {};
var Player = /*#__PURE__*/function () {
  /**
   * Create a Player.
   *
   * @param {(HTMLIFrameElement|HTMLElement|string|jQuery)} element A reference to the Vimeo
   *        player iframe, and id, or a jQuery object.
   * @param {object} [options] oEmbed parameters to use when creating an embed in the element.
   * @return {Player}
   */
  function Player(element) {
    var _this = this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, Player);
    /* global jQuery */
    if (window.jQuery && element instanceof jQuery) {
      if (element.length > 1 && window.console && console.warn) {
        console.warn('A jQuery object with multiple elements was passed, using the first element.');
      }
      element = element[0];
    }

    // Find an element by ID
    if (typeof document !== 'undefined' && typeof element === 'string') {
      element = document.getElementById(element);
    }

    // Not an element!
    if (!isDomElement(element)) {
      throw new TypeError('You must pass either a valid element or a valid id.');
    }

    // Already initialized an embed in this div, so grab the iframe
    if (element.nodeName !== 'IFRAME') {
      var iframe = element.querySelector('iframe');
      if (iframe) {
        element = iframe;
      }
    }

    // iframe url is not a Vimeo url
    if (element.nodeName === 'IFRAME' && !isVimeoUrl(element.getAttribute('src') || '')) {
      throw new Error('The player element passed isn’t a Vimeo embed.');
    }

    // If there is already a player object in the map, return that
    if (playerMap.has(element)) {
      return playerMap.get(element);
    }
    this._window = element.ownerDocument.defaultView;
    this.element = element;
    this.origin = '*';
    var readyPromise = new npo_src(function (resolve, reject) {
      _this._onMessage = function (event) {
        if (!isVimeoUrl(event.origin) || _this.element.contentWindow !== event.source) {
          return;
        }
        if (_this.origin === '*') {
          _this.origin = event.origin;
        }
        var data = parseMessageData(event.data);
        var isError = data && data.event === 'error';
        var isReadyError = isError && data.data && data.data.method === 'ready';
        if (isReadyError) {
          var error = new Error(data.data.message);
          error.name = data.data.name;
          reject(error);
          return;
        }
        var isReadyEvent = data && data.event === 'ready';
        var isPingResponse = data && data.method === 'ping';
        if (isReadyEvent || isPingResponse) {
          _this.element.setAttribute('data-ready', 'true');
          resolve();
          return;
        }
        processData(_this, data);
      };
      _this._window.addEventListener('message', _this._onMessage);
      if (_this.element.nodeName !== 'IFRAME') {
        var params = getOEmbedParameters(element, options);
        var url = getVimeoUrl(params);
        getOEmbedData(url, params, element).then(function (data) {
          var iframe = createEmbed(data, element);
          // Overwrite element with the new iframe,
          // but store reference to the original element
          _this.element = iframe;
          _this._originalElement = element;
          swapCallbacks(element, iframe);
          playerMap.set(_this.element, _this);
          return data;
        }).catch(reject);
      }
    });

    // Store a copy of this Player in the map
    readyMap.set(this, readyPromise);
    playerMap.set(this.element, this);

    // Send a ping to the iframe so the ready promise will be resolved if
    // the player is already ready.
    if (this.element.nodeName === 'IFRAME') {
      postMessage(this, 'ping');
    }
    if (screenfull.isEnabled) {
      var exitFullscreen = function exitFullscreen() {
        return screenfull.exit();
      };
      this.fullscreenchangeHandler = function () {
        if (screenfull.isFullscreen) {
          storeCallback(_this, 'event:exitFullscreen', exitFullscreen);
        } else {
          removeCallback(_this, 'event:exitFullscreen', exitFullscreen);
        }
        // eslint-disable-next-line
        _this.ready().then(function () {
          postMessage(_this, 'fullscreenchange', screenfull.isFullscreen);
        });
      };
      screenfull.on('fullscreenchange', this.fullscreenchangeHandler);
    }
    return this;
  }

  /**
   * Get a promise for a method.
   *
   * @param {string} name The API method to call.
   * @param {Object} [args={}] Arguments to send via postMessage.
   * @return {Promise}
   */
  _createClass(Player, [{
    key: "callMethod",
    value: function callMethod(name) {
      var _this2 = this;
      var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return new npo_src(function (resolve, reject) {
        // We are storing the resolve/reject handlers to call later, so we
        // can’t return here.
        // eslint-disable-next-line promise/always-return
        return _this2.ready().then(function () {
          storeCallback(_this2, name, {
            resolve: resolve,
            reject: reject
          });
          postMessage(_this2, name, args);
        }).catch(reject);
      });
    }

    /**
     * Get a promise for the value of a player property.
     *
     * @param {string} name The property name
     * @return {Promise}
     */
  }, {
    key: "get",
    value: function get(name) {
      var _this3 = this;
      return new npo_src(function (resolve, reject) {
        name = getMethodName(name, 'get');

        // We are storing the resolve/reject handlers to call later, so we
        // can’t return here.
        // eslint-disable-next-line promise/always-return
        return _this3.ready().then(function () {
          storeCallback(_this3, name, {
            resolve: resolve,
            reject: reject
          });
          postMessage(_this3, name);
        }).catch(reject);
      });
    }

    /**
     * Get a promise for setting the value of a player property.
     *
     * @param {string} name The API method to call.
     * @param {mixed} value The value to set.
     * @return {Promise}
     */
  }, {
    key: "set",
    value: function set(name, value) {
      var _this4 = this;
      return new npo_src(function (resolve, reject) {
        name = getMethodName(name, 'set');
        if (value === undefined || value === null) {
          throw new TypeError('There must be a value to set.');
        }

        // We are storing the resolve/reject handlers to call later, so we
        // can’t return here.
        // eslint-disable-next-line promise/always-return
        return _this4.ready().then(function () {
          storeCallback(_this4, name, {
            resolve: resolve,
            reject: reject
          });
          postMessage(_this4, name, value);
        }).catch(reject);
      });
    }

    /**
     * Add an event listener for the specified event. Will call the
     * callback with a single parameter, `data`, that contains the data for
     * that event.
     *
     * @param {string} eventName The name of the event.
     * @param {function(*)} callback The function to call when the event fires.
     * @return {void}
     */
  }, {
    key: "on",
    value: function on(eventName, callback) {
      if (!eventName) {
        throw new TypeError('You must pass an event name.');
      }
      if (!callback) {
        throw new TypeError('You must pass a callback function.');
      }
      if (typeof callback !== 'function') {
        throw new TypeError('The callback must be a function.');
      }
      var callbacks = getCallbacks(this, "event:".concat(eventName));
      if (callbacks.length === 0) {
        this.callMethod('addEventListener', eventName).catch(function () {
          // Ignore the error. There will be an error event fired that
          // will trigger the error callback if they are listening.
        });
      }
      storeCallback(this, "event:".concat(eventName), callback);
    }

    /**
     * Remove an event listener for the specified event. Will remove all
     * listeners for that event if a `callback` isn’t passed, or only that
     * specific callback if it is passed.
     *
     * @param {string} eventName The name of the event.
     * @param {function} [callback] The specific callback to remove.
     * @return {void}
     */
  }, {
    key: "off",
    value: function off(eventName, callback) {
      if (!eventName) {
        throw new TypeError('You must pass an event name.');
      }
      if (callback && typeof callback !== 'function') {
        throw new TypeError('The callback must be a function.');
      }
      var lastCallback = removeCallback(this, "event:".concat(eventName), callback);

      // If there are no callbacks left, remove the listener
      if (lastCallback) {
        this.callMethod('removeEventListener', eventName).catch(function (e) {
          // Ignore the error. There will be an error event fired that
          // will trigger the error callback if they are listening.
        });
      }
    }

    /**
     * A promise to load a new video.
     *
     * @promise LoadVideoPromise
     * @fulfill {number} The video with this id or url successfully loaded.
     * @reject {TypeError} The id was not a number.
     */
    /**
     * Load a new video into this embed. The promise will be resolved if
     * the video is successfully loaded, or it will be rejected if it could
     * not be loaded.
     *
     * @param {number|string|object} options The id of the video, the url of the video, or an object with embed options.
     * @return {LoadVideoPromise}
     */
  }, {
    key: "loadVideo",
    value: function loadVideo(options) {
      return this.callMethod('loadVideo', options);
    }

    /**
     * A promise to perform an action when the Player is ready.
     *
     * @todo document errors
     * @promise LoadVideoPromise
     * @fulfill {void}
     */
    /**
     * Trigger a function when the player iframe has initialized. You do not
     * need to wait for `ready` to trigger to begin adding event listeners
     * or calling other methods.
     *
     * @return {ReadyPromise}
     */
  }, {
    key: "ready",
    value: function ready() {
      var readyPromise = readyMap.get(this) || new npo_src(function (resolve, reject) {
        reject(new Error('Unknown player. Probably unloaded.'));
      });
      return npo_src.resolve(readyPromise);
    }

    /**
     * A promise to add a cue point to the player.
     *
     * @promise AddCuePointPromise
     * @fulfill {string} The id of the cue point to use for removeCuePoint.
     * @reject {RangeError} the time was less than 0 or greater than the
     *         video’s duration.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */
    /**
     * Add a cue point to the player.
     *
     * @param {number} time The time for the cue point.
     * @param {object} [data] Arbitrary data to be returned with the cue point.
     * @return {AddCuePointPromise}
     */
  }, {
    key: "addCuePoint",
    value: function addCuePoint(time) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.callMethod('addCuePoint', {
        time: time,
        data: data
      });
    }

    /**
     * A promise to remove a cue point from the player.
     *
     * @promise AddCuePointPromise
     * @fulfill {string} The id of the cue point that was removed.
     * @reject {InvalidCuePoint} The cue point with the specified id was not
     *         found.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */
    /**
     * Remove a cue point from the video.
     *
     * @param {string} id The id of the cue point to remove.
     * @return {RemoveCuePointPromise}
     */
  }, {
    key: "removeCuePoint",
    value: function removeCuePoint(id) {
      return this.callMethod('removeCuePoint', id);
    }

    /**
     * A representation of a text track on a video.
     *
     * @typedef {Object} VimeoTextTrack
     * @property {string} language The ISO language code.
     * @property {string} kind The kind of track it is (captions or subtitles).
     * @property {string} label The human‐readable label for the track.
     */
    /**
     * A promise to enable a text track.
     *
     * @promise EnableTextTrackPromise
     * @fulfill {VimeoTextTrack} The text track that was enabled.
     * @reject {InvalidTrackLanguageError} No track was available with the
     *         specified language.
     * @reject {InvalidTrackError} No track was available with the specified
     *         language and kind.
     */
    /**
     * Enable the text track with the specified language, and optionally the
     * specified kind (captions or subtitles).
     *
     * When set via the API, the track language will not change the viewer’s
     * stored preference.
     *
     * @param {string} language The two‐letter language code.
     * @param {string} [kind] The kind of track to enable (captions or subtitles).
     * @return {EnableTextTrackPromise}
     */
  }, {
    key: "enableTextTrack",
    value: function enableTextTrack(language, kind) {
      if (!language) {
        throw new TypeError('You must pass a language.');
      }
      return this.callMethod('enableTextTrack', {
        language: language,
        kind: kind
      });
    }

    /**
     * A promise to disable the active text track.
     *
     * @promise DisableTextTrackPromise
     * @fulfill {void} The track was disabled.
     */
    /**
     * Disable the currently-active text track.
     *
     * @return {DisableTextTrackPromise}
     */
  }, {
    key: "disableTextTrack",
    value: function disableTextTrack() {
      return this.callMethod('disableTextTrack');
    }

    /**
     * A promise to pause the video.
     *
     * @promise PausePromise
     * @fulfill {void} The video was paused.
     */
    /**
     * Pause the video if it’s playing.
     *
     * @return {PausePromise}
     */
  }, {
    key: "pause",
    value: function pause() {
      return this.callMethod('pause');
    }

    /**
     * A promise to play the video.
     *
     * @promise PlayPromise
     * @fulfill {void} The video was played.
     */
    /**
     * Play the video if it’s paused. **Note:** on iOS and some other
     * mobile devices, you cannot programmatically trigger play. Once the
     * viewer has tapped on the play button in the player, however, you
     * will be able to use this function.
     *
     * @return {PlayPromise}
     */
  }, {
    key: "play",
    value: function play() {
      return this.callMethod('play');
    }

    /**
     * Request that the player enters fullscreen.
     * @return {Promise}
     */
  }, {
    key: "requestFullscreen",
    value: function requestFullscreen() {
      if (screenfull.isEnabled) {
        return screenfull.request(this.element);
      }
      return this.callMethod('requestFullscreen');
    }

    /**
     * Request that the player exits fullscreen.
     * @return {Promise}
     */
  }, {
    key: "exitFullscreen",
    value: function exitFullscreen() {
      if (screenfull.isEnabled) {
        return screenfull.exit();
      }
      return this.callMethod('exitFullscreen');
    }

    /**
     * Returns true if the player is currently fullscreen.
     * @return {Promise}
     */
  }, {
    key: "getFullscreen",
    value: function getFullscreen() {
      if (screenfull.isEnabled) {
        return npo_src.resolve(screenfull.isFullscreen);
      }
      return this.get('fullscreen');
    }

    /**
     * Request that the player enters picture-in-picture.
     * @return {Promise}
     */
  }, {
    key: "requestPictureInPicture",
    value: function requestPictureInPicture() {
      return this.callMethod('requestPictureInPicture');
    }

    /**
     * Request that the player exits picture-in-picture.
     * @return {Promise}
     */
  }, {
    key: "exitPictureInPicture",
    value: function exitPictureInPicture() {
      return this.callMethod('exitPictureInPicture');
    }

    /**
     * Returns true if the player is currently picture-in-picture.
     * @return {Promise}
     */
  }, {
    key: "getPictureInPicture",
    value: function getPictureInPicture() {
      return this.get('pictureInPicture');
    }

    /**
     * A promise to prompt the viewer to initiate remote playback.
     *
     * @promise RemotePlaybackPromptPromise
     * @fulfill {void}
     * @reject {NotFoundError} No remote playback device is available.
     */
    /**
     * Request to prompt the user to initiate remote playback.
     *
     * @return {RemotePlaybackPromptPromise}
     */
  }, {
    key: "remotePlaybackPrompt",
    value: function remotePlaybackPrompt() {
      return this.callMethod('remotePlaybackPrompt');
    }

    /**
     * A promise to unload the video.
     *
     * @promise UnloadPromise
     * @fulfill {void} The video was unloaded.
     */
    /**
     * Return the player to its initial state.
     *
     * @return {UnloadPromise}
     */
  }, {
    key: "unload",
    value: function unload() {
      return this.callMethod('unload');
    }

    /**
     * Cleanup the player and remove it from the DOM
     *
     * It won't be usable and a new one should be constructed
     *  in order to do any operations.
     *
     * @return {Promise}
     */
  }, {
    key: "destroy",
    value: function destroy() {
      var _this5 = this;
      return new npo_src(function (resolve) {
        readyMap.delete(_this5);
        playerMap.delete(_this5.element);
        if (_this5._originalElement) {
          playerMap.delete(_this5._originalElement);
          _this5._originalElement.removeAttribute('data-vimeo-initialized');
        }
        if (_this5.element && _this5.element.nodeName === 'IFRAME' && _this5.element.parentNode) {
          // If we've added an additional wrapper div, remove that from the DOM.
          // If not, just remove the iframe element.
          if (_this5.element.parentNode.parentNode && _this5._originalElement && _this5._originalElement !== _this5.element.parentNode) {
            _this5.element.parentNode.parentNode.removeChild(_this5.element.parentNode);
          } else {
            _this5.element.parentNode.removeChild(_this5.element);
          }
        }

        // If the clip is private there is a case where the element stays the
        // div element. Destroy should reset the div and remove the iframe child.
        if (_this5.element && _this5.element.nodeName === 'DIV' && _this5.element.parentNode) {
          _this5.element.removeAttribute('data-vimeo-initialized');
          var iframe = _this5.element.querySelector('iframe');
          if (iframe && iframe.parentNode) {
            // If we've added an additional wrapper div, remove that from the DOM.
            // If not, just remove the iframe element.
            if (iframe.parentNode.parentNode && _this5._originalElement && _this5._originalElement !== iframe.parentNode) {
              iframe.parentNode.parentNode.removeChild(iframe.parentNode);
            } else {
              iframe.parentNode.removeChild(iframe);
            }
          }
        }
        _this5._window.removeEventListener('message', _this5._onMessage);
        if (screenfull.isEnabled) {
          screenfull.off('fullscreenchange', _this5.fullscreenchangeHandler);
        }
        resolve();
      });
    }

    /**
     * A promise to get the autopause behavior of the video.
     *
     * @promise GetAutopausePromise
     * @fulfill {boolean} Whether autopause is turned on or off.
     * @reject {UnsupportedError} Autopause is not supported with the current
     *         player or browser.
     */
    /**
     * Get the autopause behavior for this player.
     *
     * @return {GetAutopausePromise}
     */
  }, {
    key: "getAutopause",
    value: function getAutopause() {
      return this.get('autopause');
    }

    /**
     * A promise to set the autopause behavior of the video.
     *
     * @promise SetAutopausePromise
     * @fulfill {boolean} Whether autopause is turned on or off.
     * @reject {UnsupportedError} Autopause is not supported with the current
     *         player or browser.
     */
    /**
     * Enable or disable the autopause behavior of this player.
     *
     * By default, when another video is played in the same browser, this
     * player will automatically pause. Unless you have a specific reason
     * for doing so, we recommend that you leave autopause set to the
     * default (`true`).
     *
     * @param {boolean} autopause
     * @return {SetAutopausePromise}
     */
  }, {
    key: "setAutopause",
    value: function setAutopause(autopause) {
      return this.set('autopause', autopause);
    }

    /**
     * A promise to get the buffered property of the video.
     *
     * @promise GetBufferedPromise
     * @fulfill {Array} Buffered Timeranges converted to an Array.
     */
    /**
     * Get the buffered property of the video.
     *
     * @return {GetBufferedPromise}
     */
  }, {
    key: "getBuffered",
    value: function getBuffered() {
      return this.get('buffered');
    }

    /**
     * @typedef {Object} CameraProperties
     * @prop {number} props.yaw - Number between 0 and 360.
     * @prop {number} props.pitch - Number between -90 and 90.
     * @prop {number} props.roll - Number between -180 and 180.
     * @prop {number} props.fov - The field of view in degrees.
     */
    /**
     * A promise to get the camera properties of the player.
     *
     * @promise GetCameraPromise
     * @fulfill {CameraProperties} The camera properties.
     */
    /**
     * For 360° videos get the camera properties for this player.
     *
     * @return {GetCameraPromise}
     */
  }, {
    key: "getCameraProps",
    value: function getCameraProps() {
      return this.get('cameraProps');
    }

    /**
     * A promise to set the camera properties of the player.
     *
     * @promise SetCameraPromise
     * @fulfill {Object} The camera was successfully set.
     * @reject {RangeError} The range was out of bounds.
     */
    /**
     * For 360° videos set the camera properties for this player.
     *
     * @param {CameraProperties} camera The camera properties
     * @return {SetCameraPromise}
     */
  }, {
    key: "setCameraProps",
    value: function setCameraProps(camera) {
      return this.set('cameraProps', camera);
    }

    /**
     * A representation of a chapter.
     *
     * @typedef {Object} VimeoChapter
     * @property {number} startTime The start time of the chapter.
     * @property {object} title The title of the chapter.
     * @property {number} index The place in the order of Chapters. Starts at 1.
     */
    /**
     * A promise to get chapters for the video.
     *
     * @promise GetChaptersPromise
     * @fulfill {VimeoChapter[]} The chapters for the video.
     */
    /**
     * Get an array of all the chapters for the video.
     *
     * @return {GetChaptersPromise}
     */
  }, {
    key: "getChapters",
    value: function getChapters() {
      return this.get('chapters');
    }

    /**
     * A promise to get the currently active chapter.
     *
     * @promise GetCurrentChaptersPromise
     * @fulfill {VimeoChapter|undefined} The current chapter for the video.
     */
    /**
     * Get the currently active chapter for the video.
     *
     * @return {GetCurrentChaptersPromise}
     */
  }, {
    key: "getCurrentChapter",
    value: function getCurrentChapter() {
      return this.get('currentChapter');
    }

    /**
     * A promise to get the accent color of the player.
     *
     * @promise GetColorPromise
     * @fulfill {string} The hex color of the player.
     */
    /**
     * Get the accent color for this player. Note this is deprecated in place of `getColorTwo`.
     *
     * @return {GetColorPromise}
     */
  }, {
    key: "getColor",
    value: function getColor() {
      return this.get('color');
    }

    /**
     * A promise to get all colors for the player in an array.
     *
     * @promise GetColorsPromise
     * @fulfill {string[]} The hex colors of the player.
     */
    /**
     * Get all the colors for this player in an array: [colorOne, colorTwo, colorThree, colorFour]
     *
     * @return {GetColorPromise}
     */
  }, {
    key: "getColors",
    value: function getColors() {
      return npo_src.all([this.get('colorOne'), this.get('colorTwo'), this.get('colorThree'), this.get('colorFour')]);
    }

    /**
     * A promise to set the accent color of the player.
     *
     * @promise SetColorPromise
     * @fulfill {string} The color was successfully set.
     * @reject {TypeError} The string was not a valid hex or rgb color.
     * @reject {ContrastError} The color was set, but the contrast is
     *         outside of the acceptable range.
     * @reject {EmbedSettingsError} The owner of the player has chosen to
     *         use a specific color.
     */
    /**
     * Set the accent color of this player to a hex or rgb string. Setting the
     * color may fail if the owner of the video has set their embed
     * preferences to force a specific color.
     * Note this is deprecated in place of `setColorTwo`.
     *
     * @param {string} color The hex or rgb color string to set.
     * @return {SetColorPromise}
     */
  }, {
    key: "setColor",
    value: function setColor(color) {
      return this.set('color', color);
    }

    /**
     * A promise to set all colors for the player.
     *
     * @promise SetColorsPromise
     * @fulfill {string[]} The colors were successfully set.
     * @reject {TypeError} The string was not a valid hex or rgb color.
     * @reject {ContrastError} The color was set, but the contrast is
     *         outside of the acceptable range.
     * @reject {EmbedSettingsError} The owner of the player has chosen to
     *         use a specific color.
     */
    /**
     * Set the colors of this player to a hex or rgb string. Setting the
     * color may fail if the owner of the video has set their embed
     * preferences to force a specific color.
     * The colors should be passed in as an array: [colorOne, colorTwo, colorThree, colorFour].
     * If a color should not be set, the index in the array can be left as null.
     *
     * @param {string[]} colors Array of the hex or rgb color strings to set.
     * @return {SetColorsPromise}
     */
  }, {
    key: "setColors",
    value: function setColors(colors) {
      if (!Array.isArray(colors)) {
        return new npo_src(function (resolve, reject) {
          return reject(new TypeError('Argument must be an array.'));
        });
      }
      var nullPromise = new npo_src(function (resolve) {
        return resolve(null);
      });
      var colorPromises = [colors[0] ? this.set('colorOne', colors[0]) : nullPromise, colors[1] ? this.set('colorTwo', colors[1]) : nullPromise, colors[2] ? this.set('colorThree', colors[2]) : nullPromise, colors[3] ? this.set('colorFour', colors[3]) : nullPromise];
      return npo_src.all(colorPromises);
    }

    /**
     * A representation of a cue point.
     *
     * @typedef {Object} VimeoCuePoint
     * @property {number} time The time of the cue point.
     * @property {object} data The data passed when adding the cue point.
     * @property {string} id The unique id for use with removeCuePoint.
     */
    /**
     * A promise to get the cue points of a video.
     *
     * @promise GetCuePointsPromise
     * @fulfill {VimeoCuePoint[]} The cue points added to the video.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */
    /**
     * Get an array of the cue points added to the video.
     *
     * @return {GetCuePointsPromise}
     */
  }, {
    key: "getCuePoints",
    value: function getCuePoints() {
      return this.get('cuePoints');
    }

    /**
     * A promise to get the current time of the video.
     *
     * @promise GetCurrentTimePromise
     * @fulfill {number} The current time in seconds.
     */
    /**
     * Get the current playback position in seconds.
     *
     * @return {GetCurrentTimePromise}
     */
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.get('currentTime');
    }

    /**
     * A promise to set the current time of the video.
     *
     * @promise SetCurrentTimePromise
     * @fulfill {number} The actual current time that was set.
     * @reject {RangeError} the time was less than 0 or greater than the
     *         video’s duration.
     */
    /**
     * Set the current playback position in seconds. If the player was
     * paused, it will remain paused. Likewise, if the player was playing,
     * it will resume playing once the video has buffered.
     *
     * You can provide an accurate time and the player will attempt to seek
     * to as close to that time as possible. The exact time will be the
     * fulfilled value of the promise.
     *
     * @param {number} currentTime
     * @return {SetCurrentTimePromise}
     */
  }, {
    key: "setCurrentTime",
    value: function setCurrentTime(currentTime) {
      return this.set('currentTime', currentTime);
    }

    /**
     * A promise to get the duration of the video.
     *
     * @promise GetDurationPromise
     * @fulfill {number} The duration in seconds.
     */
    /**
     * Get the duration of the video in seconds. It will be rounded to the
     * nearest second before playback begins, and to the nearest thousandth
     * of a second after playback begins.
     *
     * @return {GetDurationPromise}
     */
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.get('duration');
    }

    /**
     * A promise to get the ended state of the video.
     *
     * @promise GetEndedPromise
     * @fulfill {boolean} Whether or not the video has ended.
     */
    /**
     * Get the ended state of the video. The video has ended if
     * `currentTime === duration`.
     *
     * @return {GetEndedPromise}
     */
  }, {
    key: "getEnded",
    value: function getEnded() {
      return this.get('ended');
    }

    /**
     * A promise to get the loop state of the player.
     *
     * @promise GetLoopPromise
     * @fulfill {boolean} Whether or not the player is set to loop.
     */
    /**
     * Get the loop state of the player.
     *
     * @return {GetLoopPromise}
     */
  }, {
    key: "getLoop",
    value: function getLoop() {
      return this.get('loop');
    }

    /**
     * A promise to set the loop state of the player.
     *
     * @promise SetLoopPromise
     * @fulfill {boolean} The loop state that was set.
     */
    /**
     * Set the loop state of the player. When set to `true`, the player
     * will start over immediately once playback ends.
     *
     * @param {boolean} loop
     * @return {SetLoopPromise}
     */
  }, {
    key: "setLoop",
    value: function setLoop(loop) {
      return this.set('loop', loop);
    }

    /**
     * A promise to set the muted state of the player.
     *
     * @promise SetMutedPromise
     * @fulfill {boolean} The muted state that was set.
     */
    /**
     * Set the muted state of the player. When set to `true`, the player
     * volume will be muted.
     *
     * @param {boolean} muted
     * @return {SetMutedPromise}
     */
  }, {
    key: "setMuted",
    value: function setMuted(muted) {
      return this.set('muted', muted);
    }

    /**
     * A promise to get the muted state of the player.
     *
     * @promise GetMutedPromise
     * @fulfill {boolean} Whether or not the player is muted.
     */
    /**
     * Get the muted state of the player.
     *
     * @return {GetMutedPromise}
     */
  }, {
    key: "getMuted",
    value: function getMuted() {
      return this.get('muted');
    }

    /**
     * A promise to get the paused state of the player.
     *
     * @promise GetLoopPromise
     * @fulfill {boolean} Whether or not the video is paused.
     */
    /**
     * Get the paused state of the player.
     *
     * @return {GetLoopPromise}
     */
  }, {
    key: "getPaused",
    value: function getPaused() {
      return this.get('paused');
    }

    /**
     * A promise to get the playback rate of the player.
     *
     * @promise GetPlaybackRatePromise
     * @fulfill {number} The playback rate of the player on a scale from 0 to 2.
     */
    /**
     * Get the playback rate of the player on a scale from `0` to `2`.
     *
     * @return {GetPlaybackRatePromise}
     */
  }, {
    key: "getPlaybackRate",
    value: function getPlaybackRate() {
      return this.get('playbackRate');
    }

    /**
     * A promise to set the playbackrate of the player.
     *
     * @promise SetPlaybackRatePromise
     * @fulfill {number} The playback rate was set.
     * @reject {RangeError} The playback rate was less than 0 or greater than 2.
     */
    /**
     * Set the playback rate of the player on a scale from `0` to `2`. When set
     * via the API, the playback rate will not be synchronized to other
     * players or stored as the viewer's preference.
     *
     * @param {number} playbackRate
     * @return {SetPlaybackRatePromise}
     */
  }, {
    key: "setPlaybackRate",
    value: function setPlaybackRate(playbackRate) {
      return this.set('playbackRate', playbackRate);
    }

    /**
     * A promise to get the played property of the video.
     *
     * @promise GetPlayedPromise
     * @fulfill {Array} Played Timeranges converted to an Array.
     */
    /**
     * Get the played property of the video.
     *
     * @return {GetPlayedPromise}
     */
  }, {
    key: "getPlayed",
    value: function getPlayed() {
      return this.get('played');
    }

    /**
     * A promise to get the qualities available of the current video.
     *
     * @promise GetQualitiesPromise
     * @fulfill {Array} The qualities of the video.
     */
    /**
     * Get the qualities of the current video.
     *
     * @return {GetQualitiesPromise}
     */
  }, {
    key: "getQualities",
    value: function getQualities() {
      return this.get('qualities');
    }

    /**
     * A promise to get the current set quality of the video.
     *
     * @promise GetQualityPromise
     * @fulfill {string} The current set quality.
     */
    /**
     * Get the current set quality of the video.
     *
     * @return {GetQualityPromise}
     */
  }, {
    key: "getQuality",
    value: function getQuality() {
      return this.get('quality');
    }

    /**
     * A promise to set the video quality.
     *
     * @promise SetQualityPromise
     * @fulfill {number} The quality was set.
     * @reject {RangeError} The quality is not available.
     */
    /**
     * Set a video quality.
     *
     * @param {string} quality
     * @return {SetQualityPromise}
     */
  }, {
    key: "setQuality",
    value: function setQuality(quality) {
      return this.set('quality', quality);
    }

    /**
     * A promise to get the remote playback availability.
     *
     * @promise RemotePlaybackAvailabilityPromise
     * @fulfill {boolean} Whether remote playback is available.
     */
    /**
     * Get the availability of remote playback.
     *
     * @return {RemotePlaybackAvailabilityPromise}
     */
  }, {
    key: "getRemotePlaybackAvailability",
    value: function getRemotePlaybackAvailability() {
      return this.get('remotePlaybackAvailability');
    }

    /**
     * A promise to get the current remote playback state.
     *
     * @promise RemotePlaybackStatePromise
     * @fulfill {string} The state of the remote playback: connecting, connected, or disconnected.
     */
    /**
     * Get the current remote playback state.
     *
     * @return {RemotePlaybackStatePromise}
     */
  }, {
    key: "getRemotePlaybackState",
    value: function getRemotePlaybackState() {
      return this.get('remotePlaybackState');
    }

    /**
     * A promise to get the seekable property of the video.
     *
     * @promise GetSeekablePromise
     * @fulfill {Array} Seekable Timeranges converted to an Array.
     */
    /**
     * Get the seekable property of the video.
     *
     * @return {GetSeekablePromise}
     */
  }, {
    key: "getSeekable",
    value: function getSeekable() {
      return this.get('seekable');
    }

    /**
     * A promise to get the seeking property of the player.
     *
     * @promise GetSeekingPromise
     * @fulfill {boolean} Whether or not the player is currently seeking.
     */
    /**
     * Get if the player is currently seeking.
     *
     * @return {GetSeekingPromise}
     */
  }, {
    key: "getSeeking",
    value: function getSeeking() {
      return this.get('seeking');
    }

    /**
     * A promise to get the text tracks of a video.
     *
     * @promise GetTextTracksPromise
     * @fulfill {VimeoTextTrack[]} The text tracks associated with the video.
     */
    /**
     * Get an array of the text tracks that exist for the video.
     *
     * @return {GetTextTracksPromise}
     */
  }, {
    key: "getTextTracks",
    value: function getTextTracks() {
      return this.get('textTracks');
    }

    /**
     * A promise to get the embed code for the video.
     *
     * @promise GetVideoEmbedCodePromise
     * @fulfill {string} The `<iframe>` embed code for the video.
     */
    /**
     * Get the `<iframe>` embed code for the video.
     *
     * @return {GetVideoEmbedCodePromise}
     */
  }, {
    key: "getVideoEmbedCode",
    value: function getVideoEmbedCode() {
      return this.get('videoEmbedCode');
    }

    /**
     * A promise to get the id of the video.
     *
     * @promise GetVideoIdPromise
     * @fulfill {number} The id of the video.
     */
    /**
     * Get the id of the video.
     *
     * @return {GetVideoIdPromise}
     */
  }, {
    key: "getVideoId",
    value: function getVideoId() {
      return this.get('videoId');
    }

    /**
     * A promise to get the title of the video.
     *
     * @promise GetVideoTitlePromise
     * @fulfill {number} The title of the video.
     */
    /**
     * Get the title of the video.
     *
     * @return {GetVideoTitlePromise}
     */
  }, {
    key: "getVideoTitle",
    value: function getVideoTitle() {
      return this.get('videoTitle');
    }

    /**
     * A promise to get the native width of the video.
     *
     * @promise GetVideoWidthPromise
     * @fulfill {number} The native width of the video.
     */
    /**
     * Get the native width of the currently‐playing video. The width of
     * the highest‐resolution available will be used before playback begins.
     *
     * @return {GetVideoWidthPromise}
     */
  }, {
    key: "getVideoWidth",
    value: function getVideoWidth() {
      return this.get('videoWidth');
    }

    /**
     * A promise to get the native height of the video.
     *
     * @promise GetVideoHeightPromise
     * @fulfill {number} The native height of the video.
     */
    /**
     * Get the native height of the currently‐playing video. The height of
     * the highest‐resolution available will be used before playback begins.
     *
     * @return {GetVideoHeightPromise}
     */
  }, {
    key: "getVideoHeight",
    value: function getVideoHeight() {
      return this.get('videoHeight');
    }

    /**
     * A promise to get the vimeo.com url for the video.
     *
     * @promise GetVideoUrlPromise
     * @fulfill {number} The vimeo.com url for the video.
     * @reject {PrivacyError} The url isn’t available because of the video’s privacy setting.
     */
    /**
     * Get the vimeo.com url for the video.
     *
     * @return {GetVideoUrlPromise}
     */
  }, {
    key: "getVideoUrl",
    value: function getVideoUrl() {
      return this.get('videoUrl');
    }

    /**
     * A promise to get the volume level of the player.
     *
     * @promise GetVolumePromise
     * @fulfill {number} The volume level of the player on a scale from 0 to 1.
     */
    /**
     * Get the current volume level of the player on a scale from `0` to `1`.
     *
     * Most mobile devices do not support an independent volume from the
     * system volume. In those cases, this method will always return `1`.
     *
     * @return {GetVolumePromise}
     */
  }, {
    key: "getVolume",
    value: function getVolume() {
      return this.get('volume');
    }

    /**
     * A promise to set the volume level of the player.
     *
     * @promise SetVolumePromise
     * @fulfill {number} The volume was set.
     * @reject {RangeError} The volume was less than 0 or greater than 1.
     */
    /**
     * Set the volume of the player on a scale from `0` to `1`. When set
     * via the API, the volume level will not be synchronized to other
     * players or stored as the viewer’s preference.
     *
     * Most mobile devices do not support setting the volume. An error will
     * *not* be triggered in that situation.
     *
     * @param {number} volume
     * @return {SetVolumePromise}
     */
  }, {
    key: "setVolume",
    value: function setVolume(volume) {
      return this.set('volume', volume);
    }

    /** @typedef {import('./lib/timing-object.types').TimingObject} TimingObject */
    /** @typedef {import('./lib/timing-src-connector.types').TimingSrcConnectorOptions} TimingSrcConnectorOptions */
    /** @typedef {import('./lib/timing-src-connector').TimingSrcConnector} TimingSrcConnector */

    /**
     * Connects a TimingObject to the video player (https://webtiming.github.io/timingobject/)
     *
     * @param {TimingObject} timingObject
     * @param {TimingSrcConnectorOptions} options
     *
     * @return {Promise<TimingSrcConnector>}
     */
  }, {
    key: "setTimingSrc",
    value: function () {
      var _setTimingSrc = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(timingObject, options) {
        var _this6 = this;
        var connector;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (timingObject) {
                _context.next = 2;
                break;
              }
              throw new TypeError('A Timing Object must be provided.');
            case 2:
              _context.next = 4;
              return this.ready();
            case 4:
              connector = new TimingSrcConnector(this, timingObject, options);
              postMessage(this, 'notifyTimingObjectConnect');
              connector.addEventListener('disconnect', function () {
                return postMessage(_this6, 'notifyTimingObjectDisconnect');
              });
              return _context.abrupt("return", connector);
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function setTimingSrc(_x, _x2) {
        return _setTimingSrc.apply(this, arguments);
      }
      return setTimingSrc;
    }()
  }]);
  return Player;
}(); // Setup embed only if this is not a node environment
if (!player_es_isNode) {
  screenfull = initializeScreenfull();
  initializeEmbeds();
  resizeEmbeds();
  initAppendVideoMetadata();
  checkUrlTimeParam();
}

/* harmony default export */ var player_es = (Player);

;// CONCATENATED MODULE: ../node_modules/@u-wave/react-vimeo/dist/react-vimeo.es.js




function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  react_vimeo_es_setPrototypeOf(subClass, superClass);
}
function react_vimeo_es_setPrototypeOf(o, p) {
  react_vimeo_es_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return react_vimeo_es_setPrototypeOf(o, p);
}
function react_vimeo_es_assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

var eventNames = {
  play: 'onPlay',
  playing: 'onPlaying',
  pause: 'onPause',
  ended: 'onEnd',
  timeupdate: 'onTimeUpdate',
  progress: 'onProgress',
  seeked: 'onSeeked',
  texttrackchange: 'onTextTrackChange',
  cuechange: 'onCueChange',
  cuepoint: 'onCuePoint',
  volumechange: 'onVolumeChange',
  playbackratechange: 'onPlaybackRateChange',
  error: 'onError',
  loaded: 'onLoaded'
};

var Vimeo = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Vimeo, _React$Component);
  function Vimeo(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.refContainer = _this.refContainer.bind(react_vimeo_es_assertThisInitialized(_this));
    return _this;
  }
  var _proto = Vimeo.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.createPlayer();
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this2 = this;
    // eslint-disable-next-line react/destructuring-assignment
    var changes = Object.keys(this.props).filter(function (name) {
      return _this2.props[name] !== prevProps[name];
    });
    this.updateProps(changes);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.player.destroy();
  }

  /**
   * @private
   */;
  _proto.getInitialOptions = function getInitialOptions() {
    var _ref;
    var video = this.props.video;
    var videoType = /^https?:/i.test(video) ? 'url' : 'id';
    /* eslint-disable react/destructuring-assignment */
    return _ref = {}, _ref[videoType] = video, _ref.width = this.props.width, _ref.height = this.props.height, _ref.autopause = this.props.autopause, _ref.autoplay = this.props.autoplay, _ref.byline = this.props.showByline, _ref.color = this.props.color, _ref.controls = this.props.controls, _ref.loop = this.props.loop, _ref.portrait = this.props.showPortrait, _ref.title = this.props.showTitle, _ref.muted = this.props.muted, _ref.background = this.props.background, _ref.responsive = this.props.responsive, _ref.dnt = this.props.dnt, _ref.speed = this.props.speed, _ref.keyboard = this.props.keyboard, _ref.pip = this.props.pip, _ref.playsinline = this.props.playsInline, _ref.quality = this.props.quality, _ref.texttrack = this.props.textTrack, _ref.transparent = this.props.transparent, _ref;
    /* eslint-enable react/destructuring-assignment */
  }

  /**
   * @private
   */;
  _proto.updateProps = function updateProps(propNames) {
    var _this3 = this;
    var player = this.player;
    propNames.forEach(function (name) {
      // eslint-disable-next-line react/destructuring-assignment
      var value = _this3.props[name];
      switch (name) {
        case 'autopause':
          player.setAutopause(value);
          break;
        case 'color':
          player.setColor(value);
          break;
        case 'loop':
          player.setLoop(value);
          break;
        case 'volume':
          player.setVolume(value);
          break;
        case 'paused':
          player.getPaused().then(function (paused) {
            if (value && !paused) {
              return player.pause();
            }
            if (!value && paused) {
              return player.play();
            }
            return null;
          });
          break;
        case 'width':
        case 'height':
          player.element[name] = value;
          break;
        case 'video':
          if (value) {
            var start = _this3.props.start;
            var loaded = player.loadVideo(value);
            // Set the start time only when loading a new video.
            // It seems like this has to be done after the video has loaded, else it just starts at
            // the beginning!
            if (typeof start === 'number') {
              loaded.then(function () {
                player.setCurrentTime(start);
              });
            }
          } else {
            player.unload();
          }
          break;
        case 'playbackRate':
          player.setPlaybackRate(value);
          break;
        case 'quality':
          player.setQuality(value);
          break;
        // Nothing
      }
    });
  }

  /**
   * @private
   */;
  _proto.createPlayer = function createPlayer() {
    var _this4 = this;
    var _this$props = this.props,
      start = _this$props.start,
      volume = _this$props.volume,
      playbackRate = _this$props.playbackRate;
    this.player = new player_es(this.container, this.getInitialOptions());
    Object.keys(eventNames).forEach(function (dmName) {
      var reactName = eventNames[dmName];
      _this4.player.on(dmName, function (event) {
        // eslint-disable-next-line react/destructuring-assignment
        var handler = _this4.props[reactName];
        if (handler) {
          handler(event);
        }
      });
    });
    var _this$props2 = this.props,
      onError = _this$props2.onError,
      onReady = _this$props2.onReady;
    this.player.ready().then(function () {
      if (onReady) {
        onReady(_this4.player);
      }
    }, function (err) {
      if (onError) {
        onError(err);
      } else {
        throw err;
      }
    });
    if (typeof start === 'number') {
      this.player.setCurrentTime(start);
    }
    if (typeof volume === 'number') {
      this.updateProps(['volume']);
    }
    if (typeof playbackRate === 'number') {
      this.updateProps(['playbackRate']);
    }
  }

  /**
   * @private
   */;
  _proto.refContainer = function refContainer(container) {
    this.container = container;
  };
  _proto.render = function render() {
    var _this$props3 = this.props,
      id = _this$props3.id,
      className = _this$props3.className,
      style = _this$props3.style;
    return /*#__PURE__*/react.createElement("div", {
      id: id,
      className: className,
      style: style,
      ref: this.refContainer
    });
  };
  return Vimeo;
}(react.Component);
if (false) {}

Vimeo.defaultProps = {
  autopause: true,
  autoplay: false,
  showByline: true,
  controls: true,
  loop: false,
  showPortrait: true,
  showTitle: true,
  muted: false,
  background: false,
  responsive: false,
  dnt: false,
  speed: false,
  keyboard: true,
  pip: false,
  playsInline: true,
  transparent: true
};



;// CONCATENATED MODULE: ./src/sections/ArticleVideo/ArticleVideo.schema.js
var ArticleVideo_schema_Schema = function() {
    return {
        category: "Article",
        label: "Article Video",
        key: "articleVideo",
        //   previewSrc:
        //     'https://cdn.shopify.com/s/files/1/1011/0318/files/Screen_20Shot_202023-05-24_20at_202.55.23_20PM.png?v=1684965343',
        fields: [
            {
                name: "title",
                component: "text",
                label: "Title"
            },
            {
                name: "anchorId",
                component: "text",
                label: "TOC Anchor Title",
                description: "Leave Blank to hide from Table of Contents"
            },
            {
                name: "video",
                component: "text",
                label: "Video ID"
            },
            {
                label: "Image",
                name: "image",
                component: "image"
            }, 
        ]
    };
};

;// CONCATENATED MODULE: ./src/sections/ArticleVideo/ArticleVideo.jsx







function ArticleVideo(param) {
    var cms = param.cms;
    var video = cms.video, title = cms.title, anchorId = cms.anchorId, image = cms.image;
    var ref = (0,react.useState)(false), isPlaying = ref[0], setIsPlaying = ref[1];
    return video && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative mb-8 lg:mb-16",
        children: [
            anchorId && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: (0,handleize/* default */.Z)(anchorId),
                className: "absolute top-16"
            }),
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                variant: "h4",
                element: "h4",
                className: "border-t border-[#DDE2E7] pb-4 pt-12 lg:pb-16",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative aspect-video cursor-pointer md:h-[430px] lg:mx-0",
                onClick: function() {
                    return setIsPlaying(true);
                },
                children: isPlaying && video ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Vimeo, {
                    video: video,
                    width: "100%",
                    height: "100%",
                    autoplay: true,
                    muted: true,
                    responsive: true,
                    className: "vimeo-player inset-0 h-full [&>div]:h-full [&>div]:!p-0"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                            className: "absolute mx-auto w-full",
                            fill: true,
                            src: image === null || image === void 0 ? void 0 : image.src
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* PlayButton */.JM, {})
                        })
                    ]
                })
            })
        ]
    });
}
ArticleVideo.displayName = "ArticleVideo";
ArticleVideo.Schema = ArticleVideo_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/ArticleVideo/index.js


// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3444);
;// CONCATENATED MODULE: ./src/sections/BlogArticleList/BlogArticleList.schema.js
var BlogArticleList_schema_Schema = function() {
    return {
        label: "Blog Article List",
        key: "blogArticleList",
        category: "Blog",
        //   previewSrc:
        //     'https://cdn.shopify.com/s/files/1/1011/0318/files/blog_list.png?v=1684851075',
        fields: [
            {
                label: "Desktop Columns",
                name: "desktopColumns",
                component: "select",
                options: [
                    {
                        label: "4",
                        value: "4"
                    },
                    {
                        label: "3",
                        value: "4"
                    }, 
                ],
                defaultValue: "3"
            },
            // add sort by date or title
            {
                label: "Sort By",
                name: "sortBy",
                component: "select",
                options: [
                    {
                        label: "Date",
                        value: "date"
                    },
                    {
                        label: "Title",
                        value: "title"
                    }, 
                ],
                defaultValue: "date"
            }, 
        ]
    };
};

;// CONCATENATED MODULE: ./src/sections/BlogArticleList/BlogArticleList.jsx







function BlogArticleList(param) {
    var cms = param.cms;
    var blogSettings = (0,dist.useBlog)();
    var ref = (0,react.useState)([]), articles = ref[0], setArticles = ref[1];
    var desktopColumns = cms.desktopColumns, _sortBy = cms.sortBy, sortBy = _sortBy === void 0 ? "date" : _sortBy;
    (0,react.useEffect)(function() {
        if (blogSettings === null || blogSettings === void 0 ? void 0 : blogSettings.articles) {
            var sortedArticles;
            if (sortBy === "date") {
                // Sort by createdAt date
                sortedArticles = (0,_to_consumable_array/* default */.Z)(blogSettings.articles).sort(function(a, b) {
                    var dateA = new Date(a.createdAt);
                    var dateB = new Date(b.createdAt);
                    return dateB - dateA;
                });
            } else {
                // Sort alphabetically by title
                sortedArticles = (0,_to_consumable_array/* default */.Z)(blogSettings.articles).sort(function(a, b) {
                    return a.title.localeCompare(b.title);
                });
            }
            setArticles(sortedArticles);
        }
    }, [
        blogSettings === null || blogSettings === void 0 ? void 0 : blogSettings.articles,
        sortBy
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "my-20",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "px-contained mx-auto max-w-[var(--content-max-width)]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid gap-6 gap-y-6 lg:gap-y-10 lg:grid-cols-".concat(desktopColumns),
                children: articles === null || articles === void 0 ? void 0 : articles.map(function(article, index) {
                    var ref, ref1;
                    var articleTime = article.tags.filter(function(tag) {
                        return tag.includes("articleTime::");
                    });
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                        href: "/articles/".concat(article.handle),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "group",
                            children: [
                                ((ref = article.seo) === null || ref === void 0 ? void 0 : ref.image) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative h-[265px] w-full lg:h-[275px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                        src: article.seo.image,
                                        alt: article.title,
                                        loading: "lazy",
                                        sizes: "400px",
                                        quality: 100,
                                        fill: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mb-2 mt-4 uppercase",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* AltText */.Fh, {
                                        className: "!lg:text-[14px] uppercase tracking-[0.04em]",
                                        children: [
                                            article.category,
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-shadowGray",
                                                children: articleTime && articleTime.length ? "• ".concat(articleTime[0].split("::")[1], " MIN READ") : null
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                                    variant: "h5",
                                    className: "tracking-[-.01em] lg:text-[22px]",
                                    children: article.title
                                })
                            ]
                        }, (ref1 = article.link) === null || ref1 === void 0 ? void 0 : ref1.url)
                    }, "blog-card-".concat(index));
                })
            })
        })
    });
}
BlogArticleList.displayName = "BlogArticleList";
BlogArticleList.Schema = BlogArticleList_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/BlogArticleList/index.js


;// CONCATENATED MODULE: ./src/sections/BlogFeaturedBanner/BlogFeaturedBanner.schema.js
var BlogFeaturedBanner_schema_Schema = function() {
    return {
        category: "Blog",
        label: "Blog Featured Banner",
        key: "blogFeaturedBanner",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/Screen_20Shot_202023-05-24_20at_202.55.23_20PM.png?v=1684965343",
        fields: [
            {
                name: "title",
                component: "text",
                label: "Title",
                defaultValue: 'PFAS "Forever Chemicals" Contamination Worse than Previously Thought'
            },
            {
                name: "category",
                component: "text",
                label: "Category",
                defaultValue: "News"
            },
            {
                name: "articleTime",
                component: "text",
                label: "Article Time",
                defaultValue: "5"
            },
            {
                label: "Call to action",
                name: "cta",
                component: "link"
            },
            {
                name: "image",
                component: "image",
                label: "Accompanying Image"
            }, 
        ]
    };
};

;// CONCATENATED MODULE: ./src/sections/BlogFeaturedBanner/BlogFeaturedBanner.jsx




function BlogFeaturedBanner(param) {
    var cms = param.cms;
    var title = cms.title, category = cms.category, articleTime = cms.articleTime, image = cms.image, cta = cms.cta;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative h-[600px] w-full lg:h-[905px]",
            children: [
                (image === null || image === void 0 ? void 0 : image.src) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                    fill: true,
                    alt: title,
                    sizes: "(min-width: 1024px) 40vw, 100vw",
                    src: image === null || image === void 0 ? void 0 : image.src
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "absolute left-1/2 bottom-0 mx-auto min-h-[100px] w-11/12 -translate-x-1/2 bg-white px-8 py-6 text-center lg:w-[1025px] lg:px-28 lg:py-14",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "font-momo mb-6 text-sm uppercase",
                            children: [
                                category,
                                " •",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "text-shadowGray",
                                    children: [
                                        articleTime,
                                        " MIN READ"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                            variant: "h3",
                            element: "h3",
                            className: "mb-8",
                            children: title
                        }),
                        cta && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Button */.zx, {
                                theme: "secondary",
                                variant: "outlined",
                                href: cta.url,
                                children: cta.text
                            })
                        })
                    ]
                })
            ]
        })
    });
}
BlogFeaturedBanner.displayName = "Blog Featured Banner";
BlogFeaturedBanner.Schema = BlogFeaturedBanner_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/BlogFeaturedBanner/index.js


;// CONCATENATED MODULE: ./src/sections/BlogFeaturedPost/BlogFeaturedPost.schema.js
var BlogFeaturedPost_schema_Schema = function() {
    return {
        label: "Blog Featured Post",
        category: "Blog",
        key: "blogFeaturedPost",
        fields: [
            {
                label: "Image",
                name: "image",
                component: "image"
            },
            {
                name: "heading",
                component: "text",
                label: "Heading",
                defaultValue: 'PFAS "Forever Chemicals" Contamination Worse than Previously Thought'
            },
            {
                name: "copy",
                component: "text",
                label: "Copy",
                defaultValue: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae "
            },
            {
                name: "category",
                component: "text",
                label: "Category",
                defaultValue: "US VS THEM"
            },
            {
                name: "articleTime",
                component: "text",
                label: "Article Read Time",
                defaultValue: "5"
            },
            {
                label: "Call to action",
                name: "cta",
                component: "link"
            }, 
        ]
    };
};

// EXTERNAL MODULE: ./src/snippets/Button/Button.jsx
var Button = __webpack_require__(6946);
;// CONCATENATED MODULE: ./src/sections/BlogFeaturedPost/BlogFeaturedPost.jsx





function BlogFeaturedPost(param) {
    var cms = param.cms;
    var heading = cms.heading, category = cms.category, articleTime = cms.articleTime, copy = cms.copy, cta = cms.cta, image = cms.image;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-accent3O relative",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "px-contained items-center overflow-hidden py-12 lg:flex lg:py-24",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "lg:w-7/12",
                    children: image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-6 lg:mb-0 lg:block lg:h-[620px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                            className: "max-h-[270px] w-full object-cover lg:max-h-[620px]",
                            sizes: "48px",
                            width: "890px",
                            height: "620px",
                            src: image.src
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "lg:w-5/12 lg:pl-20",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* AltText */.Fh, {
                            className: "mb-4 uppercase",
                            children: [
                                category,
                                " •",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "font-shadowGray",
                                    children: [
                                        articleTime,
                                        " Min Read"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                            variant: "h3",
                            element: "h3",
                            children: heading
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Body */.uT, {
                            variant: "medium",
                            className: "mx-auto mb-6 mt-6 lg:mb-12",
                            children: copy
                        }),
                        cta && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                theme: "primary",
                                variant: "outlined",
                                href: cta.url,
                                children: cta.text
                            })
                        })
                    ]
                })
            ]
        })
    });
}
BlogFeaturedPost.displayName = "Blog Featured Post";
BlogFeaturedPost.Schema = BlogFeaturedPost_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/BlogFeaturedPost/index.js


// EXTERNAL MODULE: ./src/snippets/Typography/Headline.jsx
var Headline = __webpack_require__(6856);
;// CONCATENATED MODULE: ./src/sections/BlogHero/BlogHero.schema.js
var BlogHero_schema_Schema = function() {
    return {
        label: "Blog Hero",
        key: "blogHero",
        fields: [
            {
                label: "Heading",
                name: "heading",
                component: "text",
                defaultValue: "Water Blog Home"
            },
            {
                label: "Copy",
                name: "copy",
                component: "text",
                defaultValue: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo."
            },
            {
                label: "Background Video URL",
                name: "backgroundVideoUrl",
                description: "Video will always be muted and autoplay with loop",
                component: "text"
            },
            {
                label: "Background Video URL (Mobile)",
                name: "backgroundVideoUrlMobile",
                component: "text"
            },
            {
                label: "Background Image",
                name: "backgroundImage",
                component: "image"
            },
            {
                label: "Background Image (Mobile)",
                name: "backgroundImageMobile",
                component: "image"
            }, 
        ]
    };
};

// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(6677);
// EXTERNAL MODULE: ../node_modules/next/link.js
var next_link = __webpack_require__(9894);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/sections/BlogHero/BlogHeroSearchLink.jsx



function BlogHeroSearchLink(param) {
    var item = param.item;
    var text = item.text, url = item.url;
    var ref = (0,react.useState)(false), isActive = ref[0], setIsActive = ref[1];
    (0,react.useEffect)(function() {
        var findActiveUrl = function() {
            var newUrl = "".concat(url);
            if (newUrl === window.location.pathname) {
                setIsActive(true);
            }
        };
        findActiveUrl();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative w-auto rounded-full py-2 px-4 transition duration-300 lg:py-3 lg:px-6 ".concat(isActive ? "group bg-[#fff] text-primary" : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: url,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "group:text-primary duration block w-max  cursor-pointer text-base font-[400] tracking-[-.01em] transition hover:text-[#fff] group-hover:text-primary lg:text-[20px] ".concat(isActive ? "text-primary" : "text-[#BCBEC2]"),
                children: text
            })
        })
    });
}
BlogHeroSearchLink.displayName = "BlogHeroSearchLink";

;// CONCATENATED MODULE: ./src/sections/BlogHero/BlogHeroSearch.jsx





function BlogHeroSearch(param) {
    var categories = param.categories;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), searchBarOpen = ref[0], setSearchBarOpen = ref[1];
    var searchRef = (0,react.useRef)();
    var handleKeyDown = function(event) {
        if (event.key === "Enter" && event.target.value.length) {
            var search = {
                searchType: "blog-articles",
                value: event.target.value
            };
            router.push({
                pathname: "/pages/search?term=".concat(event.target.value, "&searchType=blog-articles"),
                query: search
            }, "/pages/search?term=".concat(event.target.value, "&searchType=blog-articles"));
        }
    };
    var handleSearch = function() {
        var search = {
            searchType: "blog-articles",
            value: searchRef.current.value
        };
        router.push({
            pathname: "/pages/search?term=".concat(searchRef.current.value, "&searchType=blog-articles"),
            query: search
        }, "/pages/search?term=".concat(searchRef.current.value, "&searchType=blog-articles"));
    };
    return categories && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative col-span-12 flex w-full flex-col-reverse px-4 py-3 lg:col-span-12 lg:flex lg:rounded-full lg:border lg:border-transparent lg:bg-[#4D515D] lg:py-4 lg:pr-48",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex-no-wrap no-scrollbar flex flex-row overflow-auto",
                children: categories.map(function(cta, index) {
                    if ("link" in cta) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogHeroSearchLink, {
                            item: cta.link
                        }, index);
                    }
                    return null;
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "absolute right-8 top-1/2 hidden -translate-y-1/2 cursor-pointer lg:flex",
                onClick: function() {
                    return setSearchBarOpen(!searchBarOpen);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "mr-4 font-[400] lg:text-[20px]",
                        children: "Search"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                        className: "w-5 cursor-pointer text-text",
                        src: "/svgs/search-white.svg#search-white",
                        title: "Seach",
                        viewBox: "0 0 15 15"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-8 flex -translate-y-1/2 justify-between gap-3 overflow-hidden rounded-full bg-[#4D515D] pl-3 pr-4 lg:absolute lg:top-1/2 lg:mb-0 lg:w-full lg:max-w-[calc(100%-2rem)] lg:border lg:border-[#4D515D] lg:border-border lg:border-transparent ".concat(searchBarOpen ? "lg:flex" : "lg:hidden"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        ref: searchRef,
                        "aria-label": "Search here",
                        className: "min-w-0 flex-1 bg-transparent px-2 py-3 text-base tracking-[-0.01em] text-white outline-none placeholder:text-[#fff] lg:text-[20px]",
                        placeholder: "Search here",
                        onKeyDown: function(event) {
                            return handleKeyDown(event);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                        className: "hidden w-5 cursor-pointer text-text lg:block",
                        src: "/svgs/close-white.svg#close-white",
                        title: "Close",
                        viewBox: "0 0 24 24",
                        onClick: function() {
                            return setSearchBarOpen(!searchBarOpen);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                        className: "mr-2 w-5 cursor-pointer text-text lg:hidden",
                        src: "/svgs/search-white.svg#search-white",
                        title: "Seach",
                        viewBox: "0 0 15 15",
                        onClick: handleSearch
                    })
                ]
            })
        ]
    });
}
BlogHeroSearch.displayName = "BlogHeroSearch";

;// CONCATENATED MODULE: ./src/snippets/BackgroundVideo/BackgroundVideo.jsx




function BackgroundVideo(param) {
    var videoUrl = param.videoUrl, mobileVideoUrl = param.mobileVideoUrl;
    var isVimeo = videoUrl === null || videoUrl === void 0 ? void 0 : videoUrl.includes("vimeo");
    var isMobileVimeo = mobileVideoUrl === null || mobileVideoUrl === void 0 ? void 0 : mobileVideoUrl.includes("vimeo");
    var isTabletOrDesktop = utils_useMediaQuery("(min-width: 768px)");
    var ref = (0,react.useState)(false), isRendered = ref[0], setIsRendered = ref[1];
    var ref1 = (0,react.useState)(null), height = ref1[0], setHeight = ref1[1];
    (0,react.useEffect)(function() {
        setIsRendered(true);
    }, []);
    (0,react.useEffect)(function() {
        if (isRendered) {
            setHeight(window.innerHeight);
        }
    }, [
        isRendered
    ]);
    if (!isRendered) return null;
    if (!videoUrl) return null;
    if (isTabletOrDesktop) {
        if (isVimeo) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "vimeo-wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Vimeo, {
                video: videoUrl,
                loop: true,
                muted: true,
                background: true
            })
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
            autoPlay: true,
            className: "h-full w-full object-cover",
            src: videoUrl,
            loop: true,
            playsInline: true,
            muted: true,
            controls: false
        });
    }
    if (isMobileVimeo && height) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "vimeo-wrapper",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Vimeo, {
            video: mobileVideoUrl,
            loop: true,
            background: true
        })
    });
    if (isMobileVimeo && !height) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
        src: mobileVideoUrl,
        autoPlay: true,
        loop: true,
        muted: true,
        playsInline: true,
        controls: false,
        className: "h-full w-full object-cover"
    });
}

;// CONCATENATED MODULE: ./src/snippets/BackgroundVideo/index.js


;// CONCATENATED MODULE: ./src/sections/HeroBanner/HeroBackground.jsx



function HeroBackground(param) {
    var video = param.video, mobileVideo = param.mobileVideo, image = param.image, mobileImage = param.mobileImage;
    var _alt, _alt1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            video && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "release-iframe absolute left-0 top-0 z-[-1] h-full w-full overflow-hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundVideo, {
                    videoUrl: video,
                    mobileVideoUrl: mobileVideo || video
                })
            }),
            !video && image && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                src: image.src,
                alt: (_alt = image.alt) !== null && _alt !== void 0 ? _alt : "Hero Banner Image",
                width: 2000,
                height: 1200,
                className: "hidden h-full w-full object-cover md:block"
            }),
            !mobileVideo && mobileImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                src: mobileImage.src,
                alt: (_alt1 = mobileImage.alt) !== null && _alt1 !== void 0 ? _alt1 : "Hero Banner Image",
                width: 2000,
                height: 1200,
                className: "h-full w-full object-cover md:hidden"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/sections/BlogHero/BlogHero.jsx









function BlogHero(param) {
    var cms = param.cms;
    var settings = (0,dist.useSettings)();
    var categories = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : settings.blog).categories;
    var copy = cms.copy, heading = cms.heading, backgroundVideoUrl = cms.backgroundVideoUrl, backgroundVideoUrlMobile = cms.backgroundVideoUrlMobile, backgroundImageMobile = cms.backgroundImageMobile, backgroundImage = cms.backgroundImage;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "relative h-[600px] bg-primary text-white md:h-[750px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-content absolute inset-0 z-[1] h-full w-full bg-orange-300/10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBackground, {
                    image: backgroundImage,
                    mobileImage: backgroundImageMobile,
                    video: backgroundVideoUrl,
                    mobileVideo: backgroundVideoUrlMobile
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-contained lg:text-eye relative z-[2] flex h-full w-full max-w-[--var(content-max-width)] flex-col justify-between gap-y-4 pt-12 pb-8 md:pt-28 md:pb-12",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex h-full flex-col justify-center pt-14 lg:pt-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Headline/* default */.Z, {
                                variant: "h1",
                                element: "h2",
                                className: "mx-auto mb-8 max-w-[785px] text-center",
                                children: heading
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Body */.uT, {
                                className: "mx-auto max-w-[900px] text-center",
                                children: copy
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogHeroSearch, {
                        categories: categories
                    })
                ]
            })
        ]
    });
}
BlogHero.displayName = "Blog Hero";
BlogHero.Schema = BlogHero_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/BlogHero/index.js


;// CONCATENATED MODULE: ./src/sections/BlogList/BlogList.schema.js

var article = {
    label: "Article",
    name: "article",
    component: "group",
    fields: [
        {
            label: "Title",
            name: "title",
            component: "text"
        },
        {
            label: "Category",
            name: "category",
            component: "text"
        },
        {
            label: "Image",
            name: "image",
            component: "image"
        },
        {
            name: "articleTime",
            component: "text",
            label: "Article Read Time",
            defaultValue: "5"
        },
        {
            label: "Link",
            name: "link",
            component: "link"
        }, 
    ]
};
function BlogList_schema_Schema() {
    return {
        label: "Blog list",
        key: "blogList",
        category: "Content",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/blog_list.png?v=1684851075",
        fields: [
            {
                label: "Title",
                name: "title",
                component: "text"
            },
            {
                label: "View all link",
                name: "viewAllLink",
                component: "link"
            },
            {
                label: "Articles",
                name: "articles",
                component: "group-list",
                itemProps: function(param) {
                    var key = param.id, title = param.title;
                    return {
                        key: key,
                        label: title
                    };
                },
                defaultItem: function() {
                    return {
                        title: "New article"
                    };
                },
                validate: {
                    maxItems: 3
                },
                fields: (0,_to_consumable_array/* default */.Z)(article.fields)
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/BlogList/BlogList.jsx




function BlogList(param) {
    var cms = param.cms;
    var title = cms.title, viewAllLink = cms.viewAllLink, articles = cms.articles;
    var _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "my-20 print:hidden",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "px-contained mx-auto max-w-[var(--content-max-width)]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mb-10 flex justify-between",
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                            variant: "h3",
                            children: title
                        }),
                        (viewAllLink === null || viewAllLink === void 0 ? void 0 : viewAllLink.text) && (viewAllLink === null || viewAllLink === void 0 ? void 0 : viewAllLink.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "hidden lg:block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Button */.zx, {
                                href: viewAllLink.url,
                                variant: "outlined",
                                theme: "secondary",
                                children: viewAllLink.text
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid gap-6 gap-y-10 lg:grid-cols-3",
                    children: [
                        articles === null || articles === void 0 ? void 0 : articles.map(function(article, index) {
                            var ref, ref1, ref2;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                                href: (ref = article.link) === null || ref === void 0 ? void 0 : ref.url,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "group",
                                    children: [
                                        ((ref1 = article.image) === null || ref1 === void 0 ? void 0 : ref1.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "relative aspect-[353/255] w-full md:aspect-square [&>span]:!h-full [&>span]:!w-full",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                                src: article.image.src,
                                                alt: (_alt = article.image.alt) !== null && _alt !== void 0 ? _alt : article.title,
                                                loading: "lazy",
                                                quality: 100,
                                                sizes: "400px",
                                                fill: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "my-4 h-[1px] bg-[#20263533] transition-all group-hover:bg-gradient-to-r group-hover:from-[#F1DCC1] group-hover:to-[#2179C2]"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mb-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* AltText */.Fh, {
                                                className: "uppercase",
                                                children: [
                                                    article.category,
                                                    (article === null || article === void 0 ? void 0 : article.articleTime) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "text-shadowGray",
                                                        children: [
                                                            "• ",
                                                            article.articleTime,
                                                            " Min Read"
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                                            variant: "h5",
                                            children: article.title
                                        })
                                    ]
                                }, (ref2 = article.link) === null || ref2 === void 0 ? void 0 : ref2.url)
                            }, "blog-card-".concat(index));
                        }),
                        (viewAllLink === null || viewAllLink === void 0 ? void 0 : viewAllLink.text) && (viewAllLink === null || viewAllLink === void 0 ? void 0 : viewAllLink.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-center lg:hidden",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Button */.zx, {
                                href: viewAllLink.url,
                                variant: "filled",
                                theme: "primary",
                                children: viewAllLink.text
                            })
                        })
                    ]
                })
            ]
        })
    });
}
BlogList.displayName = "BlogList";
BlogList.Schema = BlogList_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/BlogList/index.js


;// CONCATENATED MODULE: ./src/sections/BlogPopularPosts/BlogPopularPosts.schema.js
var BlogPopularPosts_schema_Schema = function() {
    return {
        label: "Blog Popular Posts",
        category: "Blog",
        key: "blogPopularPosts",
        fields: [
            {
                name: "header",
                component: "text",
                label: "Header",
                defaultValue: "Popular Posts"
            },
            {
                label: "Featured Post",
                name: "featuredPost",
                description: "",
                component: "group",
                fields: [
                    {
                        label: "Image",
                        name: "image",
                        component: "image"
                    },
                    {
                        name: "heading",
                        component: "text",
                        label: "Heading",
                        defaultValue: "Effects of drinking water infrastructure on public health"
                    },
                    {
                        name: "category",
                        component: "text",
                        label: "Category",
                        defaultValue: "HEALTH & SAFETY"
                    },
                    {
                        name: "articleTime",
                        component: "text",
                        label: "Article Read Time",
                        defaultValue: "5"
                    },
                    {
                        label: "Call to action",
                        name: "cta",
                        component: "link"
                    }, 
                ]
            },
            {
                label: "Popular Posts",
                name: "popularPosts",
                component: "group-list",
                validate: {
                    maxItems: 3
                },
                itemProps: {
                    label: "{{item.title}}"
                },
                fields: [
                    {
                        label: "Image",
                        name: "image",
                        component: "image"
                    },
                    {
                        name: "title",
                        component: "text",
                        label: "Title",
                        defaultValue: "Hydration Tips for Athletes"
                    },
                    {
                        name: "category",
                        component: "text",
                        label: "Category",
                        defaultValue: "WATER 101"
                    },
                    {
                        name: "articleTime",
                        component: "text",
                        label: "Article Read Time",
                        defaultValue: "5"
                    },
                    {
                        label: "Call to action",
                        name: "cta",
                        component: "link"
                    }, 
                ],
                defaultValue: [
                    {
                        title: "Hydration Tips for Athletes",
                        category: "Water 101",
                        articleTime: "5"
                    },
                    {
                        title: "Drinking Water Standards and Maximum Contaminant Levels",
                        category: "US VS THEM",
                        articleTime: "5"
                    },
                    {
                        title: 'PFAS "Forever Chemicals" Contamination Worse than Previously Thought',
                        category: "NEWS",
                        articleTime: "5"
                    }, 
                ]
            }, 
        ]
    };
};

;// CONCATENATED MODULE: ./src/sections/BlogPopularPosts/BlogPopularPosts.jsx




function PopularPost(props) {
    var image = props.image, title = props.title, cta = props.cta, category = props.category, articleTime = props.articleTime;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
        href: cta === null || cta === void 0 ? void 0 : cta.url,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "group mb-8 cursor-pointer",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "my-4 h-[1px] bg-[#fff] transition-all group-hover:bg-gradient-to-r group-hover:from-[#F1DCC1] group-hover:to-[#2179C2]"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-8 flex items-center justify-between lg:items-start",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mb-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* AltText */.Fh, {
                                        className: "uppercase",
                                        children: [
                                            category,
                                            " •",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "text-shadowGray",
                                                children: [
                                                    articleTime,
                                                    " Min Read"
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                                    variant: "h5",
                                    className: "max-lg:text-[16px]",
                                    children: title
                                })
                            ]
                        }),
                        (image === null || image === void 0 ? void 0 : image.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative flex h-[85px] w-full max-w-[110px] justify-end lg:h-[210px] lg:max-w-[260px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                src: image.src,
                                alt: image.alt || title,
                                width: "260px",
                                height: "210px",
                                className: "object-cover"
                            })
                        })
                    ]
                })
            ]
        }, cta === null || cta === void 0 ? void 0 : cta.url)
    });
}
function BlogPopularPosts(param) {
    var cms = param.cms;
    var ref, ref1;
    var header = cms.header, featuredPost = cms.featuredPost, popularPosts = cms.popularPosts;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pt-12 pb-8 lg:pb-28 lg:pt-20",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "px-contained mx-auto flex max-w-[var(--content-max-width)] pb-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                    variant: "h3",
                    className: "",
                    children: header
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "lg:px-contained mx-auto max-w-[var(--content-max-width)] lg:grid lg:grid-cols-2 lg:gap-16",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(snippets/* Link */.rU, {
                        href: (ref = featuredPost.cta) === null || ref === void 0 ? void 0 : ref.url,
                        className: "relative flex cursor-pointer",
                        children: [
                            ((ref1 = featuredPost.image) === null || ref1 === void 0 ? void 0 : ref1.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute flex h-[420px] w-full justify-end lg:h-full",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                    src: featuredPost.image.src,
                                    alt: featuredPost.image.alt || featuredPost.header,
                                    fill: true,
                                    className: "h-[420px] object-cover lg:h-full "
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex h-[420px] items-end lg:h-auto",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "px-contained group relative z-10 mb-8 py-8",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-8 flex justify-between",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "w-full",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mb-2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* AltText */.Fh, {
                                                        className: "uppercase tracking-[0.04em] text-white",
                                                        children: [
                                                            featuredPost.category,
                                                            " •",
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "",
                                                                children: [
                                                                    featuredPost.articleTime,
                                                                    " Min Read"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                                                    variant: "h3",
                                                    className: "text-white",
                                                    children: featuredPost.heading
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "px-contained lg:px-0",
                        children: popularPosts === null || popularPosts === void 0 ? void 0 : popularPosts.map(function(param, index) {
                            var image = param.image, title = param.title, articleTime = param.articleTime, cta = param.cta, category = param.category;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PopularPost, {
                                image: image,
                                title: title,
                                category: category,
                                articleTime: articleTime,
                                cta: cta
                            }, index);
                        })
                    })
                ]
            })
        ]
    });
}
BlogPopularPosts.displayName = "Blog Popular Posts";
BlogPopularPosts.Schema = BlogPopularPosts_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/BlogPopularPosts/index.js


;// CONCATENATED MODULE: ./src/sections/CareerBlock/CareerBlock.schema.js
var mediaContent = {
    label: "Media Settings",
    name: "media",
    component: "group",
    fields: [
        {
            label: "Image 1",
            name: "image1",
            component: "image"
        },
        {
            label: "Image 2",
            name: "image2",
            component: "image"
        },
        {
            label: "Image 3",
            name: "image3",
            component: "image"
        },
        {
            label: "Image 4",
            name: "image4",
            component: "image"
        }, 
    ]
};
function CareerBlock_schema_Schema() {
    return {
        category: "Text",
        label: "Career Block",
        key: "careerBlock",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/Screen_20Shot_202023-05-23_20at_2010.47.08_20AM.png?v=1684864571",
        fields: [
            {
                label: "Eyebrow",
                name: "eyebrow",
                component: "text",
                defaultValue: "CAREERS"
            },
            {
                label: "Heading",
                name: "heading",
                component: "text",
                defaultValue: "Lorem Ipsum Dolor Sit Amet"
            },
            {
                label: "Copy",
                name: "copy",
                component: "text",
                defaultValue: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore."
            },
            {
                label: "Call To Action",
                name: "cta",
                component: "link"
            },
            mediaContent, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/CareerBlock/CareerBlock.jsx





function CareerBlock(param) {
    var cms = param.cms;
    var heading = cms.heading, eyebrow = cms.eyebrow, copy = cms.copy, cta = cms.cta, media = cms.media;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative bg-accent3Opacity20",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute inset-0 bg-[#D9D9D9] bg-gradient-to-t from-[#2179C2] via-[#8DCEF9] to-[#F1DCC1] text-center opacity-20"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-contained relative overflow-hidden py-72 text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "p-8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Eyebrow */.j4, {
                                className: "mb-4",
                                children: eyebrow
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                                variant: "h3",
                                element: "h3",
                                children: heading
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Body */.uT, {
                                variant: "medium",
                                className: "mx-auto mb-6 mt-6 max-w-2xl lg:mb-12",
                                children: copy
                            }),
                            cta && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-0 lg:mt-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    href: cta === null || cta === void 0 ? void 0 : cta.url,
                                    theme: "primary",
                                    variant: "filled",
                                    children: cta === null || cta === void 0 ? void 0 : cta.text
                                })
                            })
                        ]
                    }),
                    (media === null || media === void 0 ? void 0 : media.image1) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute top-10 lg:hidden",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                    className: "",
                                    sizes: "48px",
                                    width: "170px",
                                    height: "96px",
                                    src: media.image1.src
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute top-20 hidden lg:block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                    className: "",
                                    sizes: "48px",
                                    width: "369px",
                                    height: "208px",
                                    src: media.image1.src
                                })
                            })
                        ]
                    }),
                    (media === null || media === void 0 ? void 0 : media.image2) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute right-4 top-40 lg:hidden",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                    className: "",
                                    sizes: "48px",
                                    width: "170px",
                                    height: "96px",
                                    src: media.image2.src
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute right-44 top-20 hidden lg:block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                    className: "",
                                    sizes: "48px",
                                    width: "369px",
                                    height: "208px",
                                    src: media.image2.src
                                })
                            })
                        ]
                    }),
                    (media === null || media === void 0 ? void 0 : media.image3) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute bottom-40 left-4 lg:hidden",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                    className: "",
                                    sizes: "48px",
                                    width: "170px",
                                    height: "96px",
                                    src: media.image3.src
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute bottom-20 left-44 hidden lg:block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                    className: "",
                                    sizes: "48px",
                                    width: "369px",
                                    height: "208px",
                                    src: media.image3.src
                                })
                            })
                        ]
                    }),
                    (media === null || media === void 0 ? void 0 : media.image4) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute bottom-8 right-4 lg:hidden",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                    className: "",
                                    sizes: "48px",
                                    width: "170px",
                                    height: "96px",
                                    src: media.image4.src
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute bottom-20 right-16 hidden lg:block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                    className: "",
                                    sizes: "48px",
                                    width: "369px",
                                    height: "208px",
                                    src: media.image4.src
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
CareerBlock.displayName = "Career Block";
CareerBlock.Schema = CareerBlock_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/CareerBlock/index.js


;// CONCATENATED MODULE: ./src/sections/CareerIcons/CareerIcons.schema.js
function CareerIcons_schema_Schema() {
    return {
        category: "Text",
        label: "Career Icons",
        key: "careerIcons",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/Screen_20Shot_202023-05-23_20at_2011.49.39_20AM.png?v=1684867874",
        fields: [
            {
                label: "Career Icon",
                name: "careerIconItems",
                component: "group-list",
                itemProps: {
                    label: "{{item.header}}"
                },
                fields: [
                    {
                        label: "Image",
                        name: "image",
                        component: "image"
                    },
                    {
                        label: "Header",
                        name: "header",
                        component: "text"
                    },
                    {
                        label: "Copy",
                        name: "copy",
                        component: "text"
                    }, 
                ],
                defaultValue: [
                    {
                        header: "A TEAM YOU WANT TO BE ON",
                        copy: "We’re fun, friendly, and flexible—and that’s not changing anytime soon. It’s part of our culture. "
                    }, 
                ],
                defaultItem: {
                    header: "A TEAM YOU WANT TO BE ON",
                    copy: "We’re fun, friendly, and flexible—and that’s not changing anytime soon. It’s part of our culture. "
                }
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/CareerIcons/CareerIcon.jsx


function CareerIcon(param) {
    var item = param.item;
    var image = item.image, header = item.header, copy = item.copy;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative mb-8 w-full px-4 text-center text-primary md:w-1/3 lg:mb-14 lg:w-1/4",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                image && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                    className: "mx-auto mb-4",
                    sizes: "48px",
                    width: "48px",
                    height: "48px",
                    src: image.src
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "letter mb-2 text-[18px] font-normal leading-6 tracking-[.04em] lg:text-lg",
                    children: header
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mb-2 text-sm text-[#4D515D]",
                    children: copy
                })
            ]
        })
    });
}
CareerIcon.displayName = "Career Listing";

;// CONCATENATED MODULE: ./src/sections/CareerIcons/CareerIcons.jsx



function CareerIcons(param) {
    var cms = param.cms;
    var careerIconItems = cms.careerIconItems;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-accent3Opacity20",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "px-contained mx-auto max-w-[var(--content-max-width)] overflow-hidden pb-6 pt-16",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                    className: "mb-14 text-center text-[24px] font-light tracking-[-.02em] text-primary sm:text-4xl",
                    children: "Why work with us?"
                }),
                careerIconItems && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-wrap",
                    children: careerIconItems.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CareerIcon, {
                            item: item
                        }, index);
                    })
                })
            ]
        })
    });
}
CareerIcons.displayName = "Career Icons";
CareerIcons.Schema = CareerIcons_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/CareerListings/CareerListings.schema.js
function CareerListings_schema_Schema() {
    return {
        category: "Text",
        label: "Career Listings",
        key: "careerListings",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/Screen_20Shot_202023-05-23_20at_2011.49.49_20AM.png?v=1684867877",
        fields: [
            {
                label: "Career Listing",
                name: "careerListingItems",
                component: "group-list",
                itemProps: {
                    label: "{{item.header}}"
                },
                fields: [
                    {
                        label: "Header",
                        name: "header",
                        component: "text"
                    },
                    {
                        label: "Department",
                        name: "department",
                        component: "text"
                    },
                    {
                        label: "Body",
                        name: "body",
                        component: "markdown"
                    },
                    {
                        label: "Job Time",
                        name: "jobTime",
                        component: "text"
                    },
                    {
                        label: "Job Location",
                        name: "jobLocation",
                        component: "text"
                    }, 
                ],
                defaultValue: [
                    {
                        header: "Marketing - Social Media Manager",
                        department: "DEPARTMENT",
                        jobTime: "Full-Time",
                        jobLocation: "Rancho Santa Margarita"
                    }, 
                ],
                defaultItem: {
                    header: "Marketing - Social Media Manager",
                    department: "DEPARTMENT",
                    jobTime: "Full-Time",
                    jobLocation: "Rancho Santa Margarita"
                }
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/CareerListings/CareerListing.jsx


function CareerListing(param) {
    var item = param.item;
    var header = item.header, department = item.department, body = item.body, jobTime = item.jobTime, jobLocation = item.jobLocation;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mb-12 pb-4 relative transition duration-300 border-b border-zinc-100",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mb-2 letter text-sm font-normal leading-6 tracking-[.04em] lg:text-lg",
                children: department
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                className: "mb-4 text-3xl font-light tracking-[-.01em]",
                children: header
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Markdown */.UG, {
                children: body
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-2 font-normal",
                children: jobTime
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "font-normal",
                children: jobLocation
            })
        ]
    });
}
CareerListing.displayName = "Career Listing";

;// CONCATENATED MODULE: ./src/sections/CareerListings/CareerListings.jsx



function CareerListings(param) {
    var cms = param.cms;
    var careerListingItems = cms.careerListingItems;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-clearBlue",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "px-contained pt-16 pb-4 overflow-hidden max-w-3xl mx-auto",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                    className: "mb-8 text-4xl font-light tracking-[-.01em]",
                    children: "Open Listings"
                }),
                careerListingItems && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "",
                    children: careerListingItems.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CareerListing, {
                            item: item
                        }, index);
                    })
                })
            ]
        })
    });
}
CareerListings.displayName = "Career Listings";
CareerListings.Schema = CareerListings_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/CareerListings/index.js


// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(3842);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(5556);
;// CONCATENATED MODULE: ./src/sections/JazzHRListings/JazzHRListings.schema.js
function JazzHRListings_schema_Schema() {
    return {
        category: "Text",
        label: "JazzHRListings",
        key: "jazzHrListings",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/Screen_20Shot_202023-05-23_20at_2011.49.49_20AM.png?v=1684867877",
        fields: []
    };
}

;// CONCATENATED MODULE: ./src/sections/JazzHRListings/JobListing.jsx

function JobListing(param) {
    var job = param.job;
    var title = job.title, department = job.department, boardCode = job.board_code, type = job.type, city = job.city, state = job.state;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative mb-12 border-b border-zinc-100 pb-4 transition duration-300",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "letter mb-2 text-sm font-normal leading-6 tracking-[.04em] lg:text-lg",
                children: department
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                className: "mb-4 text-3xl font-light tracking-[-.01em]",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "font-normal",
                children: state ? "".concat(city, ", ").concat(state) : city
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-2 font-normal",
                children: type
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "https://clearlyfiltered.applytojob.com/apply/".concat(boardCode),
                    target: "_blank",
                    rel: "noreferrer",
                    children: "View Details"
                })
            })
        ]
    });
}
JobListing.displayName = "Job Listing";

;// CONCATENATED MODULE: ./src/sections/JazzHRListings/JazzHRListings.jsx






function JazzHRListings() {
    var ref = (0,react.useState)([]), jobs = ref[0], setJobs = ref[1];
    var getJobs = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var jazzResponse, body;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch("/api/jazz-hr-jobs")
                        ];
                    case 1:
                        jazzResponse = _state.sent();
                        if (!(jazzResponse.status === 200)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            jazzResponse.json()
                        ];
                    case 2:
                        body = _state.sent();
                        setJobs(Array.isArray(body) ? body : [
                            body
                        ]);
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function getJobs() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        getJobs();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-clearBlue",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "px-contained mx-auto max-w-3xl overflow-hidden pb-4 pt-16",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: "mb-8 text-4xl font-light tracking-[-.01em]",
                        children: "Open Listings"
                    })
                }),
                jobs.map(function(job) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(JobListing, {
                        job: job
                    });
                })
            ]
        })
    });
}
JazzHRListings.displayName = "JazzHR Listings";
JazzHRListings.Schema = JazzHRListings_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/JazzHRListings/index.js


;// CONCATENATED MODULE: ./src/sections/CollectionHero/CollectionHero.schema.js
var CollectionHero_schema_Schema = function() {
    return {
        category: "Collection",
        label: "Collection Hero",
        key: "collection-hero",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/collection-hero.png",
        fields: [
            {
                name: "superTitle",
                component: "text",
                label: "Super Title"
            },
            {
                name: "title",
                component: "text",
                label: "Title"
            },
            {
                name: "content",
                component: "textarea",
                label: "Content"
            },
            {
                name: "leftCTA",
                component: "link",
                label: "Left CTA Button"
            },
            {
                name: "rightCTA",
                component: "link",
                label: "Right CTA Button"
            },
            {
                name: "mediaImage",
                component: "image",
                label: "Accompanying Image"
            },
            {
                name: "mediaVideo",
                component: "text",
                label: "Accompanying Video",
                description: "Accompanying Video will always be used in place of Accompanying Image."
            },
            {
                name: "mediaPlacement",
                component: "select",
                label: "Media Placement",
                options: [
                    {
                        label: "Left",
                        value: "left"
                    },
                    {
                        label: "Right",
                        value: "right"
                    }, 
                ],
                defaultValue: "left"
            },
            {
                name: "mediaPosition",
                component: "select",
                label: "Media Position",
                options: [
                    {
                        label: "Center",
                        value: "center"
                    },
                    {
                        label: "Top Left",
                        value: "top-left"
                    },
                    {
                        label: "Top Right",
                        value: "top-right"
                    },
                    {
                        label: "Bottom Left",
                        value: "bottom-left"
                    },
                    {
                        label: "Bottom Right",
                        value: "bottom-right"
                    }, 
                ],
                defaultValue: "center"
            }, 
        ]
    };
};

;// CONCATENATED MODULE: ./src/sections/CollectionHero/CollectionHero.jsx





function CollectionHero(param) {
    var cms = param.cms;
    var superTitle = cms.superTitle, title = cms.title, content = cms.content, mediaImage = cms.mediaImage, mediaVideo = cms.mediaVideo, mediaPlacement = cms.mediaPlacement, mediaPosition = cms.mediaPosition, leftCTA = cms.leftCTA, rightCTA = cms.rightCTA;
    var collection = (0,dist.useCollection)();
    var collectionTitle = collection === null || collection === void 0 ? void 0 : collection.title;
    var collectionDescription = collection === null || collection === void 0 ? void 0 : collection.description;
    var hasMedia = mediaImage || mediaVideo;
    var positionClassMap = {
        center: "object-center",
        "top-left": "object-left-top",
        "top-right": "object-right-top",
        "bottom-left": "object-left-bottom",
        "bottom-right": "object-right-bottom"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat(hasMedia ? "md:flex" : "", " ").concat(mediaPlacement && mediaPlacement === "left" ? "flex-row-reverse" : "", " relative overflow-hidden"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative z-10 flex items-center p-[18px] md:px-[89px] md:pb-[110px] md:pt-[72px] ".concat(hasMedia ? "min-h-[276px] pb-6 pt-[127px] md:flex-[0_0_50%]" : "min-h-[180px] text-left md:text-center"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute inset-0 bg-gradient-to-t md:bg-[#D9D9D9]  md:from-[#2179C2] md:via-[#8DCEF9] md:to-[#F1DCC1] md:opacity-20 ".concat(hasMedia ? "from-[#00000080] to-[#00000000]" : "bg-[#D9D9D9] from-[#2179C2] via-[#8DCEF9] to-[#F1DCC1] text-center opacity-20")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative mx-auto w-full max-w-[975px] md:text-text ".concat(hasMedia ? "text-white" : "text-text"),
                        children: [
                            superTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Subheading */.pm, {
                                className: "mb-2 uppercase",
                                children: superTitle
                            }),
                            (title || collectionTitle) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                                className: "mb-6 capitalize",
                                variant: "h3",
                                element: "h1",
                                children: title || collectionTitle
                            }),
                            (content || collectionDescription) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Body */.uT, {
                                variant: "medium",
                                className: "mx-auto max-w-[765px]",
                                children: content || collectionDescription
                            }),
                            (leftCTA || rightCTA) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mt-8 flex gap-6 ".concat(hasMedia ? "justify-start" : "justify-center"),
                                children: [
                                    leftCTA && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Button */.zx, {
                                        href: leftCTA === null || leftCTA === void 0 ? void 0 : leftCTA.url,
                                        variant: "filled",
                                        theme: "primary",
                                        children: leftCTA === null || leftCTA === void 0 ? void 0 : leftCTA.text
                                    }),
                                    rightCTA && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Button */.zx, {
                                        href: rightCTA === null || rightCTA === void 0 ? void 0 : rightCTA.url,
                                        variant: "filled",
                                        theme: "primary",
                                        children: rightCTA === null || rightCTA === void 0 ? void 0 : rightCTA.text
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            hasMedia ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute inset-0 z-0 md:relative md:flex-[0_0_50%]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative aspect-[864/400] min-h-full max-w-full",
                    children: [
                        (mediaImage === null || mediaImage === void 0 ? void 0 : mediaImage.src) && !mediaVideo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                            fill: true,
                            alt: title || collectionTitle,
                            sizes: "(min-width: 1024px) 40vw, 100vw",
                            src: mediaImage === null || mediaImage === void 0 ? void 0 : mediaImage.src,
                            className: mediaPosition ? positionClassMap[mediaPosition] : "object-center"
                        }) : null,
                        mediaVideo ? /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                            src: mediaVideo,
                            autoPlay: true,
                            muted: true,
                            loop: true,
                            playsInline: true,
                            className: "h-full w-full object-cover"
                        }) : null
                    ]
                })
            }) : null
        ]
    });
}
CollectionHero.displayName = "CollectionHero";
CollectionHero.Schema = CollectionHero_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/CollectionHero/index.js


;// CONCATENATED MODULE: ./src/sections/CollectionNav/CollectionNav.schema.js
var CollectionNav_schema_Schema = function() {
    return {
        category: "Collection",
        label: "Collection Nav",
        key: "collection-nav",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/collection-nav.png",
        fields: [
            {
                label: "Menu Links",
                name: "links",
                component: "group-list",
                itemProps: {
                    label: "{{item.link.text}}"
                },
                fields: [
                    {
                        label: "Link",
                        name: "link",
                        component: "link"
                    },
                    {
                        label: "Mobile Image",
                        name: "mobileImage",
                        component: "image"
                    },
                    {
                        label: "Mobile Text",
                        name: "mobileText",
                        component: "text"
                    }, 
                ]
            }, 
        ]
    };
};

;// CONCATENATED MODULE: ./src/sections/CollectionNav/CollectionNav.jsx




function CollectionNav(param) {
    var cms = param.cms;
    var links = cms.links;
    var asPath = (0,next_router.useRouter)().asPath;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: (links === null || links === void 0 ? void 0 : links.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            className: "flex gap-3 overflow-auto border-b border-b-[#E9E9EB] bg-[#f2f7fb] p-[20px] lg:justify-center lg:gap-8 lg:bg-white",
            children: links.map(function(item, index) {
                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "flex flex-[0_0_125px] lg:flex-initial",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                        className: "flex h-full w-full flex-col justify-end overflow-hidden rounded-[10px] border p-[10px] text-text duration-200 lg:rounded-none lg:border-0 lg:bg-transparent lg:px-0 lg:py-0 lg:hover:border-primary lg:hover:bg-white lg:hover:text-[#3383C5] ".concat((item === null || item === void 0 ? void 0 : (ref = item.link) === null || ref === void 0 ? void 0 : ref.url) === asPath ? "border-primary bg-white lg:text-[#3383C5]" : "border-[#DDE2E7] bg-[#E6F0F8]"),
                        "aria-label": (ref1 = item.link) === null || ref1 === void 0 ? void 0 : ref1.text,
                        href: item === null || item === void 0 ? void 0 : (ref2 = item.link) === null || ref2 === void 0 ? void 0 : ref2.url,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "desktop-text hidden lg:block",
                                    children: item === null || item === void 0 ? void 0 : (ref3 = item.link) === null || ref3 === void 0 ? void 0 : ref3.text
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mobile-nav-item flex flex-col items-center lg:hidden",
                                    children: [
                                        (item === null || item === void 0 ? void 0 : (ref4 = item.mobileImage) === null || ref4 === void 0 ? void 0 : ref4.src) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mobile-image relative aspect-[1/1] w-full max-w-[70px]",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                                fill: true,
                                                alt: item === null || item === void 0 ? void 0 : (ref5 = item.link) === null || ref5 === void 0 ? void 0 : ref5.text,
                                                className: "object-contain mix-blend-multiply",
                                                sizes: "(min-width: 1440px) 900px, (min-width: 768px) 50vw, 100vw",
                                                src: item === null || item === void 0 ? void 0 : (ref6 = item.mobileImage) === null || ref6 === void 0 ? void 0 : ref6.src,
                                                quality: "90"
                                            })
                                        }) : null,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mobile-text mt-4 text-center text-xs uppercase",
                                            children: (item === null || item === void 0 ? void 0 : item.mobileText) ? item.mobileText : item === null || item === void 0 ? void 0 : (ref7 = item.link) === null || ref7 === void 0 ? void 0 : ref7.text
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }, index);
            })
        }) : null
    });
}
CollectionNav.displayName = "CollectionNav";
CollectionNav.Schema = CollectionNav_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/CollectionNav/index.js


;// CONCATENATED MODULE: ./src/sections/CollectionsList/CollectionsList.schema.js
var collection = {
    label: "Collection",
    name: "collection",
    fields: [
        {
            label: "Name",
            name: "name",
            component: "text"
        },
        {
            label: "Image",
            name: "image",
            component: "image"
        },
        {
            label: "Link",
            name: "link",
            component: "link"
        }, 
    ]
};
function CollectionsList_schema_Schema() {
    return {
        label: "Collections List",
        key: "collections-list",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/collections_list.png?v=1686314380",
        category: "Collection",
        fields: [
            {
                label: "Dark mode",
                name: "darkMode",
                component: "toggle",
                description: "Use dark mode for this",
                defaultValue: false
            },
            {
                label: "Collections",
                name: "collections",
                component: "group-list",
                itemProps: function(param) {
                    var key = param.id, name = param.name;
                    return {
                        label: name,
                        key: key
                    };
                },
                fields: collection.fields
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/CollectionsList/CollectionsList.jsx




function CollectionsList(param) {
    var cms = param.cms;
    var collections = cms.collections, darkMode = cms.darkMode;
    var _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: darkMode ? "dark" : "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: "custom-scroll mx-contained flex justify-center border-b border-[#0000001A] bg-background pb-8 pt-8 lg:pt-16",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "px-contained flex max-w-[var(--content-max-width)] gap-2 overflow-x-scroll pb-8 lg:items-center lg:gap-x-0",
                children: collections.map(function(collection, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                                href: collection.link.url,
                                className: "lg:group shrink-0 cursor-pointer rounded-[10px] border border-[#DDE2E7] bg-[#E6F0F8] p-3 lg:border-none lg:bg-transparent lg:p-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col items-center justify-center text-center lg:gap-y-5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                            src: collection.image.src,
                                            alt: (_alt = collection.image.alt) !== null && _alt !== void 0 ? _alt : collection.link.text,
                                            width: 200,
                                            height: 200,
                                            className: "h-20 w-20 object-contain mix-blend-multiply lg:mx-16 lg:h-24 lg:w-24 lg:transition-transform lg:duration-300 lg:ease-in-out lg:group-hover:scale-110"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-xs font-extralight uppercase text-[#24293B] lg:text-lg lg:normal-case lg:transition-colors lg:duration-300 lg:ease-in-out lg:group-hover:text-secondary",
                                            children: collection.link.text
                                        })
                                    ]
                                })
                            }),
                            index < collections.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hidden h-32 w-[1px] shrink-0 bg-[#0000001A] lg:block"
                            })
                        ]
                    }, index);
                })
            })
        })
    });
}
CollectionsList.displayName = "CollectionsList";
CollectionsList.Schema = CollectionsList_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/CollectionsList/index.js


// EXTERNAL MODULE: ../node_modules/swiper/modules/index.mjs + 28 modules
var modules = __webpack_require__(3365);
// EXTERNAL MODULE: ../node_modules/swiper/swiper-react.mjs + 3 modules
var swiper_react = __webpack_require__(5509);
// EXTERNAL MODULE: ./src/snippets/Button/index.js + 2 modules
var snippets_Button = __webpack_require__(7388);
;// CONCATENATED MODULE: ./src/sections/CommonContaminants/CommonContaminants.schema.js
var CommonContaminants_schema_Schema = function() {
    return {
        label: "Common Contaminants",
        category: "Blog",
        key: "commonContaminants",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/Screen_20Shot_202023-05-25_20at_209.57.41_20AM.png?v=1685033902",
        fields: [
            {
                label: "Icon",
                name: "icon",
                component: "image"
            },
            {
                label: "Heading",
                name: "heading",
                component: "text",
                defaultValue: "Common Contaminants"
            },
            {
                label: "Copy",
                name: "copy",
                component: "text",
                defaultValue: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae "
            },
            {
                label: "Call to action",
                name: "cta",
                component: "link"
            },
            {
                label: "Contaminants",
                name: "contaminants",
                validate: {
                    maxItems: 16
                },
                component: "group-list",
                itemProps: {
                    label: "{{item.title}}"
                },
                fields: [
                    {
                        label: "Image",
                        name: "image",
                        component: "image"
                    },
                    {
                        name: "title",
                        component: "text",
                        label: "Title"
                    },
                    {
                        name: "category",
                        component: "text",
                        label: "Category"
                    },
                    {
                        name: "articleTime",
                        component: "text",
                        label: "Article Read Time"
                    },
                    {
                        label: "Call to action",
                        name: "cta",
                        component: "link"
                    }, 
                ],
                defaultValue: [
                    {
                        title: "Arsenic",
                        category: "Contaminants",
                        articleTime: "5",
                        image: {
                            src: "https://cdn.shopify.com/s/files/1/1011/0318/files/Mask_20group_20_2847_29.png?v=1685031478&width=960&quality=75"
                        }
                    },
                    {
                        title: "Flouride",
                        category: "Contaminants",
                        articleTime: "5",
                        image: {
                            src: "https://cdn.shopify.com/s/files/1/1011/0318/files/Mask_20group_20_2847_29.png?v=1685031478&width=960&quality=75"
                        }
                    },
                    {
                        title: "HAA5 (Haloacetic Acids)",
                        category: "Contaminants",
                        articleTime: "5",
                        image: {
                            src: "https://cdn.shopify.com/s/files/1/1011/0318/files/Mask_20group_20_2847_29.png?v=1685031478&width=960&quality=75"
                        }
                    },
                    {
                        title: "PFAS / PFOA",
                        category: "Contaminants",
                        articleTime: "5",
                        image: {
                            src: "https://cdn.shopify.com/s/files/1/1011/0318/files/Mask_20group_20_2847_29.png?v=1685031478&width=960&quality=75"
                        }
                    },
                    {
                        title: "Radiation",
                        category: "Contaminants",
                        articleTime: "5",
                        image: {
                            src: "https://cdn.shopify.com/s/files/1/1011/0318/files/Mask_20group_20_2847_29.png?v=1685031478&width=960&quality=75"
                        }
                    },
                    {
                        title: "Lead",
                        category: "Contaminants",
                        articleTime: "5",
                        image: {
                            src: "https://cdn.shopify.com/s/files/1/1011/0318/files/Mask_20group_20_2847_29.png?v=1685031478&width=960&quality=75"
                        }
                    },
                    {
                        title: "Chromium 6",
                        category: "Contaminants",
                        articleTime: "5",
                        image: {
                            src: "https://cdn.shopify.com/s/files/1/1011/0318/files/Mask_20group_20_2847_29.png?v=1685031478&width=960&quality=75"
                        }
                    },
                    {
                        title: "Human Hormones",
                        category: "Contaminants",
                        articleTime: "5",
                        image: {
                            src: "https://cdn.shopify.com/s/files/1/1011/0318/files/Mask_20group_20_2847_29.png?v=1685031478&width=960&quality=75"
                        }
                    },
                    {
                        title: "Pesticides",
                        category: "Contaminants",
                        articleTime: "5",
                        image: {
                            src: "https://cdn.shopify.com/s/files/1/1011/0318/files/Mask_20group_20_2847_29.png?v=1685031478&width=960&quality=75"
                        }
                    },
                    {
                        title: "Total Trihalomethanes (TTHMs)",
                        category: "Contaminants",
                        articleTime: "5",
                        image: {
                            src: "https://cdn.shopify.com/s/files/1/1011/0318/files/Mask_20group_20_2847_29.png?v=1685031478&width=960&quality=75"
                        }
                    }, 
                ]
            },
            {
                label: "Slider Settings",
                name: "slider",
                component: "group",
                description: "Slider style, slides per view",
                fields: [
                    {
                        label: "Slider Style",
                        name: "sliderStyle",
                        component: "select",
                        description: "Loop and centered settings only apply if the number of products is at least twice the number of slides per view",
                        options: [
                            {
                                label: "Contained",
                                value: "contained"
                            },
                            {
                                label: "Contained w/ Loop",
                                value: "containedWithLoop"
                            },
                            {
                                label: "Full Bleed, Centered w/ Loop",
                                value: "fullBleed"
                            },
                            {
                                label: "Full Bleed, Centered w/ Loop & Gradient",
                                value: "fullBleedWithGradient"
                            }, 
                        ]
                    },
                    {
                        label: "Slides Per View (desktop)",
                        name: "slidesPerViewDesktop",
                        component: "number"
                    },
                    {
                        label: "Slides Per View (tablet)",
                        name: "slidesPerViewTablet",
                        component: "number"
                    },
                    {
                        label: "Slides Per View (mobile)",
                        name: "slidesPerViewMobile",
                        component: "number"
                    }, 
                ],
                defaultValue: {
                    sliderStyle: "contained",
                    slidesPerViewDesktop: 4,
                    slidesPerViewTablet: 3.4,
                    slidesPerViewMobile: 1.4
                }
            }, 
        ]
    };
};

;// CONCATENATED MODULE: ./src/sections/CommonContaminants/CommonContaminants.jsx








function ContaminantSlide(props) {
    var image = props.image, title = props.title, cta = props.cta, category = props.category, articleTime = props.articleTime;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
        href: cta === null || cta === void 0 ? void 0 : cta.url,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "group",
            children: [
                (image === null || image === void 0 ? void 0 : image.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative aspect-video w-full lg:h-[275px]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                        src: image.src,
                        alt: image.alt || title,
                        width: "385px",
                        height: "275px",
                        className: "absolute h-full w-full object-cover"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mb-2 pt-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* AltText */.Fh, {
                        className: "uppercase tracking-[0.04em] text-white",
                        children: [
                            category,
                            " •",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "text-shadowGray",
                                children: [
                                    articleTime,
                                    " Min Read"
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                    variant: "h5",
                    className: "text-white",
                    children: title
                })
            ]
        })
    });
}
function CommonContaminants(param) {
    var cms = param.cms;
    var heading = cms.heading, copy = cms.copy, icon = cms.icon, cta = cms.cta, contaminants = cms.contaminants;
    var ref = (0,react.useState)(null), swiper = ref[0], setSwiper = ref[1];
    var ref1 = (0,react.useState)(1), activeSlideIndex = ref1[0], setActiveSlideIndex = ref1[1];
    swiper === null || swiper === void 0 ? void 0 : swiper.on("slideChange", function() {
        setActiveSlideIndex(swiper.realIndex + 1);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "overflow-hidden bg-[#202635] pb-12 pt-12 lg:pt-20",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "px-contained mx-auto max-w-[var(--content-max-width)]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative z-10 mb-10 text-center lg:pl-20",
                    children: [
                        (icon === null || icon === void 0 ? void 0 : icon.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative mx-auto h-[61px] w-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                src: icon.src,
                                alt: "icon",
                                width: "61px",
                                height: "61px",
                                className: "mx-auto mb-4 object-cover"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                            variant: "h3",
                            className: "mt-4 text-white",
                            children: heading
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Body */.uT, {
                            variant: "medium",
                            className: "mx-auto mb-6 mt-6 max-w-2xl text-white lg:mb-12",
                            children: copy
                        }),
                        cta && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets_Button/* Button */.zx, {
                                theme: "primary",
                                variant: "filled",
                                href: cta.url,
                                children: cta.text
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "hidden justify-end lg:flex",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "prev",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets_Button/* ArrowButton */.b4, {
                                        arrowDirection: "left"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "next pl-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets_Button/* ArrowButton */.b4, {
                                        arrowDirection: "right"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                            onSwiper: setSwiper,
                            className: "!static mx-auto mt-8 w-full max-w-[90%] overflow-visible lg:mt-4 lg:max-w-[100%]",
                            loop: true,
                            navigation: {
                                prevEl: ".prev",
                                nextEl: ".next",
                                clickable: true
                            },
                            pagination: {
                                el: ".swiper-pagination",
                                type: "bullets",
                                renderBullet: function renderBullet(_, className) {
                                    return '<span class="!bg-white '.concat(className, ' w-full rounded-none !m-0"></span>');
                                }
                            },
                            modules: [
                                modules/* Pagination */.tl,
                                modules/* Navigation */.W_
                            ],
                            slidesPerView: 1,
                            spaceBetween: 20,
                            breakpoints: {
                                1024: {
                                    loop: true,
                                    slidesPerView: 4,
                                    spaceBetween: 20
                                }
                            },
                            children: contaminants === null || contaminants === void 0 ? void 0 : contaminants.map(function(param, index) {
                                var image = param.image, title = param.title, articleTime = param.articleTime, contaminantCta = param.cta, category = param.category;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContaminantSlide, {
                                        image: image,
                                        title: title,
                                        category: category,
                                        articleTime: articleTime,
                                        cta: contaminantCta
                                    }, index)
                                }, index);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "swiper-pagination swiper-progress !static mx-auto mt-8 flex w-full flex-nowrap lg:mt-16 lg:max-w-[calc(100%-100px)]"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative mx-auto hidden w-full pb-2 lg:block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "absolute right-0 top-[-13px] text-sm font-normal text-white",
                                children: [
                                    activeSlideIndex,
                                    " / ",
                                    swiper === null || swiper === void 0 ? void 0 : swiper.slides.length
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-12 flex justify-center lg:hidden",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "prev",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets_Button/* ArrowButton */.b4, {
                                arrowDirection: "left"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "next pl-8",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets_Button/* ArrowButton */.b4, {
                                arrowDirection: "right"
                            })
                        })
                    ]
                })
            ]
        })
    });
}
CommonContaminants.displayName = "Common Contaminants";
CommonContaminants.Schema = CommonContaminants_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/CommonContaminants/index.js


;// CONCATENATED MODULE: ./src/sections/CommunityImpact/CommunityImpact.schema.js
var CommunityImpact_schema_Schema = function() {
    return {
        // category: 'Article',
        label: "Community Impact",
        key: "communityImpact",
        fields: [
            {
                name: "title",
                component: "text",
                label: "Title",
                description: "Leave Blank to hide from Table of Contents"
            },
            {
                label: "Body",
                name: "body",
                component: "markdown"
            }, 
        ]
    };
};

// EXTERNAL MODULE: ./src/snippets/Beam/index.js + 5 modules
var Beam = __webpack_require__(5582);
;// CONCATENATED MODULE: ./src/sections/CommunityImpact/CommunityImpact.jsx
/* eslint-disable react/no-unstable-nested-components */ 



function CommunityImpact(param) {
    var cms = param.cms;
    var title = cms.title, body = cms.body;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "beam-sync-visibility px-contained mx-auto max-w-[960px] overflow-hidden py-12 lg:py-24",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "header mb-12 text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                        variant: "h2",
                        element: "h1",
                        className: "mb-10 lg:mb-14",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Markdown */.UG, {
                        components: {
                            h1: function h1(data) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                                    element: "h1",
                                    variant: "h2",
                                    children: data.children
                                });
                            },
                            h2: function h2(data) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                                    element: "h2",
                                    variant: "h3",
                                    children: data.children
                                });
                            },
                            h3: function h3(data) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                                    element: "h3",
                                    variant: "h4",
                                    children: data.children
                                });
                            },
                            h4: function h4(data) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                                    element: "h4",
                                    variant: "h5",
                                    children: data.children
                                });
                            },
                            h5: function h5(data) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                                    element: "h5",
                                    variant: "h6",
                                    children: data.children
                                });
                            }
                        },
                        children: body
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Beam/* BeamCommunityImpact */.TY, {})
        ]
    });
}
CommunityImpact.displayName = "CommunityImpact";
CommunityImpact.Schema = CommunityImpact_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/CommunityImpact/index.js


;// CONCATENATED MODULE: ./src/sections/ContactFormBuilder/ContactFormContent.jsx




function ContactFormContent(param) {
    var content = param.content, _open = param.open, open = _open === void 0 ? false : _open;
    var ref = (0,react.useState)(open), isOpen = ref[0], setIsOpen = ref[1];
    return content && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mb-6 flex border-b border-zinc-200 pb-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pr-4 lg:pt-2",
                children: content.image && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                    className: "mx-auto lg:mb-4",
                    sizes: "32px",
                    width: "32px",
                    height: "32px",
                    src: content.image.src,
                    alt: "icon"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full",
                children: [
                    content.title && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "button",
                        className: "mb-2 flex w-full cursor-pointer items-center justify-between text-2xl font-light tracking-[-.02em] lg:cursor-default",
                        onClick: function() {
                            return setIsOpen(!isOpen);
                        },
                        onKeyDown: function() {
                            return setIsOpen(!isOpen);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: content.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "lg:hidden",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                                        className: "".concat(!isOpen ? "block" : "hidden", " w-5 text-text"),
                                        src: "/svgs/chevron-down.svg#chevron-down",
                                        title: "Close",
                                        viewBox: "0 0 24 24"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                                        className: "".concat(isOpen ? "block" : "hidden", " w-5 text-text"),
                                        src: "/svgs/chevron-up.svg#chevron-up",
                                        title: "Close",
                                        viewBox: "0 0 24 24"
                                    })
                                ]
                            })
                        ]
                    }),
                    content.body && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat(isOpen ? "block" : "hidden", " lg:block"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Markdown */.UG, {
                            className: "[&_p]:!font-extralight",
                            children: content.body
                        })
                    })
                ]
            })
        ]
    });
}
ContactFormContent.displayName = "Contact Form Content";

;// CONCATENATED MODULE: ./src/sections/ContactFormBuilder/GorgiasForm.jsx


function GorgiasForm(param) {
    var formUid = param.formUid;
    var elemRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (!elemRef.current) {
            return;
        }
        var script = document.createElement("script");
        script.src = "https://contact.gorgias.help/api/contact-forms/loader.js?v=3";
        script.defer = true;
        script.setAttribute("data-gorgias-loader-contact-form", "");
        script.setAttribute("data-gorgias-contact-form-uid", formUid);
        elemRef.current.appendChild(script);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: elemRef
    });
}

// EXTERNAL MODULE: ../node_modules/lodash.snakecase/index.js
var lodash_snakecase = __webpack_require__(4441);
var lodash_snakecase_default = /*#__PURE__*/__webpack_require__.n(lodash_snakecase);
;// CONCATENATED MODULE: ./src/sections/ContactFormBuilder/ContactFormBuilder.schema.js


var inputField = function(type) {
    return {
        label: type,
        key: lodash_snakecase_default()(type),
        defaultItem: {
            name: lodash_snakecase_default()(type),
            label: "".concat(type)
        },
        itemProps: function(item) {
            return {
                label: "".concat(type).concat(item.label ? ": ".concat(item.label) : "")
            };
        },
        fields: [
            {
                label: "Name",
                name: "name",
                component: "text",
                validate: {
                    required: true
                },
                description: 'Unique, lowercase, and no spaces\ne.g. "email", "first_name", "accepts_marketing"'
            },
            {
                label: "Label",
                name: "label",
                component: "text"
            },
            {
                label: "Placeholder",
                name: "placeholder",
                component: "text"
            },
            {
                label: "Info Message",
                name: "infoMessage",
                component: "text"
            },
            {
                label: "Required",
                name: "required",
                component: "toggle",
                toggleLabels: {
                    true: "On",
                    false: "Off"
                }
            },
            {
                label: "Half Width",
                name: "halfWidth",
                component: "toggle",
                toggleLabels: {
                    true: "On",
                    false: "Off"
                }
            }, 
        ]
    };
};
var multiChoiceField = function(type) {
    return {
        label: type,
        key: lodash_snakecase_default()(type),
        defaultItem: {
            name: lodash_snakecase_default()(type),
            label: "".concat(type)
        },
        itemProps: function(item) {
            return {
                label: "".concat(type).concat(item.label ? ": ".concat(item.label) : "")
            };
        },
        fields: [
            {
                label: "Name",
                name: "name",
                component: "text",
                validate: {
                    required: true
                },
                description: 'Unique, lowercase, and no spaces\ne.g. "email", "first_name", "accepts_marketing"'
            },
            {
                label: "Label",
                name: "label",
                component: "text"
            }, 
        ].concat((0,_to_consumable_array/* default */.Z)(type === "Select" ? [
            {
                label: "Placeholder",
                name: "placeholder",
                component: "text"
            }, 
        ] : []), [
            {
                label: "Info Message",
                name: "infoMessage",
                component: "text"
            },
            {
                label: "Options",
                name: "options",
                component: "list",
                field: {
                    component: "text"
                }
            }, 
        ], (0,_to_consumable_array/* default */.Z)(type === "Radio" || type === "Multiple Checkbox" ? [
            {
                label: "Direction",
                name: "direction",
                component: "radio-group",
                direction: "horizontal",
                variant: "radio",
                options: [
                    {
                        label: "Horizontal",
                        value: "horizontal"
                    },
                    {
                        label: "Vertical",
                        value: "vertical"
                    }, 
                ],
                defaultValue: "horizontal"
            }, 
        ] : []), (0,_to_consumable_array/* default */.Z)(type !== "Multiple Checkbox" ? [
            {
                label: "Required",
                name: "required",
                component: "toggle",
                toggleLabels: {
                    true: "On",
                    false: "Off"
                }
            }, 
        ] : []), [
            {
                label: "Half Width",
                name: "halfWidth",
                component: "toggle",
                toggleLabels: {
                    true: "On",
                    false: "Off"
                }
            }, 
        ], (0,_to_consumable_array/* default */.Z)(type === "Multiple Checkbox" ? [
            {
                label: "Hide Label",
                name: "hideLabel",
                component: "toggle",
                toggleLabels: {
                    true: "On",
                    false: "Off"
                }
            }, 
        ] : []))
    };
};
var countryField = {
    label: "Country",
    key: "country",
    defaultItem: {
        name: "country",
        label: "Country"
    },
    itemProps: function(item) {
        return {
            label: "Country".concat(item.label ? ": ".concat(item.label) : "")
        };
    },
    fields: [
        {
            label: "Name",
            name: "name",
            component: "text",
            validate: {
                required: true
            },
            description: 'Unique, lowercase, and no spaces\ne.g. "email", "first_name", "accepts_marketing"'
        },
        {
            label: "Label",
            name: "label",
            component: "text"
        },
        {
            label: "Placeholder",
            name: "placeholder",
            component: "text"
        },
        {
            label: "Info Message",
            name: "infoMessage",
            component: "text"
        },
        {
            label: "Required",
            name: "required",
            component: "toggle",
            toggleLabels: {
                true: "On",
                false: "Off"
            }
        },
        {
            label: "Half Width",
            name: "halfWidth",
            component: "toggle",
            toggleLabels: {
                true: "On",
                false: "Off"
            }
        }, 
    ]
};
var labelField = {
    label: "Label",
    key: "label",
    defaultItem: {
        label: "Label Text"
    },
    itemProps: function(item) {
        return {
            label: "Label".concat(item.label ? ": ".concat(item.label) : "")
        };
    },
    fields: [
        {
            label: "Label",
            name: "label",
            component: "text"
        }, 
    ]
};
var checkboxField = {
    label: "Checkbox",
    key: "checkbox",
    defaultItem: {
        name: "checkbox",
        label: "Checkbox"
    },
    itemProps: function(item) {
        return {
            label: "Checkbox".concat(item.label ? ": ".concat(item.label) : "")
        };
    },
    fields: [
        {
            label: "Name",
            name: "name",
            component: "text",
            validate: {
                required: true
            },
            description: 'Unique, lowercase, and no spaces\ne.g. "email", "first_name", "accepts_marketing"'
        },
        {
            label: "Label",
            name: "label",
            component: "text"
        },
        {
            label: "Link",
            name: "link",
            component: "link"
        },
        {
            label: "Required",
            name: "required",
            component: "toggle",
            toggleLabels: {
                true: "On",
                false: "Off"
            }
        },
        {
            label: "Half Width",
            name: "halfWidth",
            component: "toggle",
            toggleLabels: {
                true: "On",
                false: "Off"
            }
        }, 
    ]
};
var fileField = {
    label: "File",
    key: "file",
    defaultItem: {
        name: "file",
        label: "File Upload"
    },
    itemProps: function(item) {
        return {
            label: "File".concat(item.label ? ": ".concat(item.label) : "")
        };
    },
    fields: [
        {
            label: "Name",
            name: "name",
            component: "text",
            validate: {
                required: true
            },
            description: 'Unique, lowercase, and no spaces\ne.g. "email", "first_name", "accepts_marketing"'
        },
        {
            label: "Label",
            name: "label",
            component: "text"
        },
        {
            label: "Info Message",
            name: "infoMessage",
            component: "text"
        },
        {
            label: "Required",
            name: "required",
            component: "toggle",
            toggleLabels: {
                true: "On",
                false: "Off"
            }
        },
        {
            label: "Half Width",
            name: "halfWidth",
            component: "toggle",
            toggleLabels: {
                true: "On",
                false: "Off"
            }
        }, 
    ]
};
var ContactFormBuilder_schema_Schema = function() {
    return {
        category: "Text",
        label: "Contact Form Builder",
        key: "contact-form-builder",
        fields: [
            {
                label: "Heading",
                name: "heading",
                component: "text",
                defaultValue: "Questions? Comments? Feedback?"
            },
            {
                label: "Sub Heading",
                name: "subHeading",
                component: "text",
                defaultValue: "Email us using the form below."
            },
            {
                label: "Form Type",
                name: "formType",
                component: "radio-group",
                options: [
                    {
                        label: "Gorgias",
                        value: "gorgias"
                    },
                    {
                        label: "Custom",
                        value: "custom"
                    }, 
                ],
                defaultValue: "gorgias"
            },
            {
                label: "Gorgias Form UID",
                name: "gorgiasFormUid",
                component: "text",
                description: 'Only used if form type is "Gorgias"',
                defaultValue: "kjxn3ybv"
            },
            {
                label: "Fields",
                name: "fields",
                component: "blocks",
                templates: {
                    checkbox: checkboxField,
                    country: countryField,
                    date: inputField("Date"),
                    email: inputField("Email"),
                    file: fileField,
                    label: labelField,
                    multipleCheckbox: multiChoiceField("Multiple Checkbox"),
                    number: inputField("Number"),
                    phone: inputField("Phone"),
                    radio: multiChoiceField("Radio"),
                    select: multiChoiceField("Select"),
                    text: inputField("Text"),
                    textArea: inputField("Text Area"),
                    time: inputField("Time"),
                    url: inputField("Url")
                }
            },
            {
                label: "Submit Button Text",
                name: "submitText",
                component: "text",
                defaultValue: "Submit"
            },
            {
                label: "reCAPTCHA v2 Enabled",
                name: "recaptchaEnabled",
                component: "toggle",
                description: "reCAPTCHA v2 site key must first be set as environment variable",
                toggleLabels: {
                    true: "On",
                    false: "Off"
                },
                defaultValue: false
            },
            {
                label: "Live Chat",
                name: "liveChat",
                component: "group",
                description: "Live Chat Section",
                fields: [
                    {
                        label: "Image",
                        name: "image",
                        component: "image"
                    },
                    {
                        label: "Title",
                        name: "title",
                        component: "text"
                    },
                    {
                        label: "Body",
                        name: "body",
                        component: "markdown"
                    }, 
                ],
                defaultValue: {
                    title: "Live Chat"
                }
            },
            {
                label: "Call Us",
                name: "callUs",
                component: "group",
                description: "Call Us Section",
                fields: [
                    {
                        label: "Image",
                        name: "image",
                        component: "image"
                    },
                    {
                        label: "Title",
                        name: "title",
                        component: "text"
                    },
                    {
                        label: "Body",
                        name: "body",
                        component: "markdown"
                    }, 
                ],
                defaultValue: {
                    title: "Call Us"
                }
            },
            {
                label: "SMS Text",
                name: "smsText",
                component: "group",
                description: "SMS Text Section",
                fields: [
                    {
                        label: "Image",
                        name: "image",
                        component: "image"
                    },
                    {
                        label: "Title",
                        name: "title",
                        component: "text"
                    },
                    {
                        label: "Body",
                        name: "body",
                        component: "markdown"
                    }, 
                ]
            },
            {
                label: "Common Questions",
                name: "commonQuestions",
                component: "group",
                description: "Common Questions Section",
                fields: [
                    {
                        label: "Image",
                        name: "image",
                        component: "image"
                    },
                    {
                        label: "Title",
                        name: "title",
                        component: "text"
                    },
                    {
                        label: "Body",
                        name: "body",
                        component: "markdown"
                    }, 
                ]
            }, 
        ]
    };
};

// EXTERNAL MODULE: ../node_modules/next/head.js
var head = __webpack_require__(8038);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/hooks/index.js + 36 modules
var hooks = __webpack_require__(4068);
;// CONCATENATED MODULE: ./src/sections/ContactFormBuilder/CountryField.jsx




var firstCountries = [
    "United States",
    "Canada",
    "United Kingdom",
    "France",
    "Australia",
    "New Zealand",
    "--", 
];
function CountryField(param) {
    var selectClass = param.selectClass, name = param.name, placeholder = param.placeholder, required = param.required;
    var countryNames = (0,hooks/* useCountries */.FE)().countryNames;
    var countryOptions = (0,react.useMemo)(function() {
        if (!(countryNames === null || countryNames === void 0 ? void 0 : countryNames.length)) return null;
        return [
            ""
        ].concat((0,_to_consumable_array/* default */.Z)(firstCountries), (0,_to_consumable_array/* default */.Z)(countryNames));
    }, [
        countryNames === null || countryNames === void 0 ? void 0 : countryNames.length,
        firstCountries
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
        className: "".concat(selectClass),
        id: name,
        name: name,
        required: required,
        children: countryOptions === null || countryOptions === void 0 ? void 0 : countryOptions.map(function(country, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                disabled: index === 0 || country === "--",
                selected: index === 0,
                value: country,
                children: country || placeholder
            }, "".concat(country, ".").concat(index));
        })
    });
}
CountryField.displayName = "CountryField";

;// CONCATENATED MODULE: ./src/sections/ContactFormBuilder/FormField.jsx




function FormField(param) {
    var field = param.field;
    var type = field._template, column = field.column, direction = field.direction, halfWidth = field.halfWidth, hideLabel = field.hideLabel, infoMessage = field.infoMessage, label = field.label, link = field.link, options = field.options, placeholder = field.placeholder, required = field.required;
    var name = lodash_snakecase_default()(field.name);
    var isTextarea = type === "textArea";
    var isRadio = type === "radio";
    var isSelect = type === "select";
    var isCountry = type === "country";
    // Non inputs
    var isLabel = type === "label";
    var hasLabel = !isLabel;
    // Uses <checkbox>
    var isCheckbox = type === "checkbox";
    var isMultiCheckbox = type === "multipleCheckbox";
    var isCheckboxType = isCheckbox || isMultiCheckbox;
    // Uses <input type="file">
    var isFile = type === "file";
    var isFileType = isFile;
    // Uses <input>
    var isText = type === "text";
    var isEmail = type === "email";
    var isPhone = type === "phone";
    var isDate = type === "date";
    var isNumber = type === "number";
    var isUrl = type === "url";
    var isTime = type === "time";
    var isAddress = type === "address";
    var isInput = isText || isEmail || isPhone || isDate || isNumber || isUrl || isTime || isAddress;
    var isNotFullWidth = isCheckbox || isRadio || isFileType || isCheckboxType;
    var inputClass = "w-full rounded-md border border-border p-3 text-base !min-w-0";
    var labelClass = "opacity-50 text-xs block m-0";
    var selectClass = "appearance-none bg-[url('/svgs/chevron-down.svg')] bg-[length:1rem_1rem] bg-[calc(100%-0.75rem)] bg-no-repeat ".concat(inputClass);
    var halfWidthSpan = column === 1 ? "col-span-2 xs:col-[1]" : "col-span-2 xs:col-[2]";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col ".concat(halfWidth ? halfWidthSpan : "col-[1_/_span_2]", " ").concat(isNotFullWidth ? "items-start" : "items-stretch"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                className: "flex gap-x-1 gap-y-1.5 ".concat(isCheckbox || isRadio || isFileType ? "justify-self-start" : "justify-self-stretch", " ").concat(isCheckbox || isLabel ? "py-1" : "", " ").concat(isCheckbox ? "flex-row" : "flex-col-reverse", " ").concat(isNotFullWidth ? "w-auto" : "w-full"),
                htmlFor: name,
                children: [
                    isLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "".concat(labelClass),
                        children: label
                    }),
                    isFileType && /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        className: "py-2",
                        id: name,
                        name: name,
                        required: required,
                        type: "file"
                    }),
                    isInput && /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        className: "".concat(inputClass),
                        id: name,
                        name: name,
                        placeholder: placeholder,
                        required: required,
                        type: isPhone ? "tel" : type
                    }),
                    isTextarea && /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                        className: "resize-none ".concat(inputClass),
                        id: name,
                        name: name,
                        placeholder: placeholder,
                        required: required,
                        type: "textarea"
                    }),
                    isCheckbox && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                id: name,
                                name: name,
                                required: required,
                                type: "checkbox",
                                value: "yes"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                type: "hidden",
                                name: name,
                                value: "no"
                            })
                        ]
                    }),
                    isMultiCheckbox && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-wrap justify-start gap-x-4 gap-y-2 self-start ".concat(direction === "vertical" ? "flex-col" : "flex-row"),
                        children: options === null || options === void 0 ? void 0 : options.map(function(value) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                className: "flex gap-1",
                                htmlFor: "".concat(name, ".").concat(value),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        id: "".concat(name, ".").concat(value),
                                        name: value,
                                        type: "checkbox",
                                        value: "yes"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        type: "hidden",
                                        name: value,
                                        value: "no"
                                    }),
                                    value
                                ]
                            }, "".concat(name, ".").concat(value));
                        })
                    }),
                    isRadio && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-wrap justify-start gap-x-4 gap-y-2 self-start ".concat(direction === "vertical" ? "flex-col" : "flex-row"),
                        children: options === null || options === void 0 ? void 0 : options.map(function(value) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                className: "flex gap-1",
                                htmlFor: "".concat(name, ".").concat(value),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        id: "".concat(name, ".").concat(value),
                                        name: name,
                                        type: "radio",
                                        value: value
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: value
                                    })
                                ]
                            }, "".concat(name, ".").concat(value));
                        })
                    }),
                    isSelect && /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                        className: "".concat(selectClass),
                        id: name,
                        name: name,
                        required: required,
                        children: [
                            ""
                        ].concat((0,_to_consumable_array/* default */.Z)(options || [])).map(function(value, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                disabled: index === 0,
                                selected: index === 0,
                                value: value,
                                children: value || placeholder
                            }, "".concat(name, ".").concat(index, "}"));
                        })
                    }),
                    isCountry && /*#__PURE__*/ (0,jsx_runtime.jsx)(CountryField, {
                        name: name,
                        placeholder: placeholder,
                        required: required,
                        selectClass: selectClass
                    }),
                    hasLabel && !hideLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML: {
                            __html: "".concat(label).concat((link === null || link === void 0 ? void 0 : link.text) ? '&nbsp;<a href="'.concat(link.url, '" onclick="event.preventDefault" target="_blank" style"position:inline;">').concat(link.text, "</a>") : "").concat(required ? " *" : "")
                        },
                        className: "[&_a]:underline ".concat(labelClass)
                    })
                ]
            }),
            infoMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-2 text-xs text-mediumDarkGray xs:text-sm",
                children: infoMessage
            })
        ]
    }, name);
}
FormField.displayName = "FormField";

;// CONCATENATED MODULE: ./src/sections/ContactFormBuilder/useForm.js



var useForm = function(param) {
    var fields = param.fields;
    var parsedFields = (0,react.useMemo)(function() {
        if (!(fields === null || fields === void 0 ? void 0 : fields.length)) return [];
        // Determine the intended column number for the form field
        var columnCounter = 0;
        return fields.map(function(field) {
            var isHalfWidth = !!field.halfWidth;
            var column = 1;
            if (columnCounter % 2 !== 0 && !isHalfWidth) {
                columnCounter = 0;
                column = 1;
            } else if (columnCounter % 2 === 0 && !isHalfWidth) {
                columnCounter += 2;
                column = 2;
            } else if (columnCounter % 2 !== 0 && isHalfWidth) {
                columnCounter += 1;
                column = 2;
            } else if (columnCounter % 2 === 0 && isHalfWidth) {
                columnCounter += 1;
                column = 1;
            }
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field), {
                column: column
            });
        });
    }, [
        fields
    ]);
    return {
        parsedFields: parsedFields
    };
};

;// CONCATENATED MODULE: ./src/sections/ContactFormBuilder/ContactForm.jsx








var isBrowser = "object" !== "undefined";
function ContactForm(cms) {
    var ref;
    var formRef = (0,react.useRef)(null);
    var captchaRef = (0,react.useRef)(null);
    var fields = cms.fields, submitText = cms.submitText, recaptchaEnabled = cms.recaptchaEnabled;
    var parsedFields = useForm({
        fields: fields
    }).parsedFields;
    var ref1 = (0,react.useState)([]), errors = ref1[0], setErrors = ref1[1];
    var ref2 = (0,react.useState)(null), successMessage = ref2[0], setSuccessMessage = ref2[1];
    var ref3 = (0,react.useState)(false), captchaLoaded = ref3[0], setCaptchaLoaded = ref3[1];
    var renderCaptcha = isBrowser && (window === null || window === void 0 ? void 0 : (ref = window.grecaptcha) === null || ref === void 0 ? void 0 : ref.render);
    var captchaReady = typeof renderCaptcha === "function";
    var isRecaptchaEnabled = recaptchaEnabled && !!"6LdyIc4qAAAAAA-GF7BltItPMkKDMfgLOygZ6VcF";
    var submitGorgiasForm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(payload) {
            var apiEndpoint, response, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        apiEndpoint = "/api/gorgias";
                        return [
                            4,
                            fetch(apiEndpoint, {
                                method: "POST",
                                body: JSON.stringify(payload)
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            4,
                            response.json()
                        ];
                    case 2:
                        data = _state.sent();
                        if (!data) {
                            throw new Error("No data returned from fetchReviewAggregate");
                        }
                        return [
                            2,
                            data
                        ];
                }
            });
        });
        return function submitGorgiasForm(payload) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var ref, formIsValid, ref1, captchaResponse, _tmp, payload, res, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        setErrors([]);
                        setSuccessMessage(null);
                        formIsValid = (ref = formRef.current) === null || ref === void 0 ? void 0 : ref.checkValidity();
                        // if (!isRecaptchaEnabled || !captchaLoaded || !formIsValid) return;
                        if (isRecaptchaEnabled && !captchaLoaded || !formIsValid) return [
                            2
                        ];
                        if (!isRecaptchaEnabled) return [
                            3,
                            4
                        ];
                        _tmp = isBrowser;
                        if (!_tmp) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            window === null || window === void 0 ? void 0 : (ref1 = window.grecaptcha) === null || ref1 === void 0 ? void 0 : ref1.getResponse()
                        ];
                    case 2:
                        _tmp = _state.sent();
                        _state.label = 3;
                    case 3:
                        captchaResponse = _tmp;
                        if (!captchaResponse) {
                            setErrors([
                                "Please verify you are not a robot"
                            ]);
                            return [
                                2
                            ];
                        }
                        _state.label = 4;
                    case 4:
                        payload = Object.fromEntries(new FormData(formRef.current));
                        return [
                            4,
                            submitGorgiasForm(payload)
                        ];
                    case 5:
                        res = _state.sent();
                        if (res.error) {
                            setErrors([
                                res.error
                            ]);
                        } else {
                            formRef.current.reset();
                            setSuccessMessage("Message sent successfully!");
                        }
                        return [
                            3,
                            7
                        ];
                    case 6:
                        error = _state.sent();
                        console.error(error);
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function(e) {
            return _ref.apply(this, arguments);
        };
    }(), [
        isRecaptchaEnabled,
        captchaLoaded
    ]);
    // Render captcha if recaptcha is enabled and captcha is ready
    // Must add NEXT_PUBLIC_RECAPTCHA_SITE_KEY to env variables
    // See: https://developers.google.com/recaptcha/intro
    (0,react.useEffect)(function() {
        try {
            if (!captchaReady || !isRecaptchaEnabled) return;
            renderCaptcha("form-captcha-widget", {
                sitekey: "6LdyIc4qAAAAAA-GF7BltItPMkKDMfgLOygZ6VcF"
            });
        } catch (error) {
            console.error(error);
        }
    }, [
        captchaReady,
        isRecaptchaEnabled
    ]);
    // Observe when captcha is loaded to permit form submission
    (0,react.useEffect)(function() {
        if (!captchaRef.current || !isRecaptchaEnabled) return undefined;
        var observer = new MutationObserver(function() {
            setCaptchaLoaded(true);
            observer.disconnect();
        });
        observer.observe(captchaRef.current, {
            attributes: true,
            characterData: true,
            childList: true,
            subtree: true
        });
        return function() {
            observer.disconnect();
        };
    }, [
        isRecaptchaEnabled
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    src: "https://www.google.com/recaptcha/api.js"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: "grid grid-cols-2 gap-8 [&_input]:font-extralight [&_textarea]:font-extralight",
                encType: "multipart/form-data",
                method: "POST",
                ref: formRef,
                onSubmit: handleSubmit,
                children: [
                    parsedFields === null || parsedFields === void 0 ? void 0 : parsedFields.map(function(field) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormField, {
                                field: field
                            })
                        }, field.name);
                    }),
                    (fields === null || fields === void 0 ? void 0 : fields.some(function(field) {
                        return field.required;
                    })) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-span-2 m-0 block text-xs opacity-50",
                        children: "* Required field"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-span-2 flex flex-col gap-4",
                        children: [
                            isRecaptchaEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                ref: captchaRef,
                                className: "my-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    id: "form-captcha-widget"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Button */.zx, {
                                theme: "secondary",
                                variant: "outlined",
                                type: "submit",
                                className: "mt-6 flex w-full max-w-[210px] items-center justify-center bg-[#fff]",
                                children: submitText || "Submit"
                            }),
                            (errors === null || errors === void 0 ? void 0 : errors.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-col gap-1",
                                children: errors.map(function(error) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-red-500",
                                        children: error
                                    }, error);
                                })
                            }),
                            successMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "rounded border border-solid border-green-700 bg-green-50 p-3 text-center text-green-700",
                                children: successMessage
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/sections/ContactFormBuilder/ContactFormBuilder.jsx





function ContactFormBuilder(param) {
    var cms = param.cms;
    var heading = cms.heading, subHeading = cms.subHeading, fields = cms.fields, liveChat = cms.liveChat, callUs = cms.callUs, smsText = cms.smsText, commonQuestions = cms.commonQuestions, submitText = cms.submitText, formType = cms.formType, gorgiasFormUid = cms.gorgiasFormUid, recaptchaEnabled = cms.recaptchaEnabled;
    var formUid = gorgiasFormUid !== null && gorgiasFormUid !== void 0 ? gorgiasFormUid : "kjxn3ybv";
    var formEnabled = true;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-clearBlue",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "px-contained py-contained flex flex-col-reverse lg:flex-row",
            children: [
                formEnabled && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "lg:w-1/2 lg:pr-8",
                    children: [
                        heading && /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                            className: "mb-2 text-3xl font-light tracking-[-.01em]",
                            children: heading
                        }),
                        subHeading && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mb-4 text-lg text-[#3383C5] md:mb-6\n                ".concat(formType === "custom" && "lg:mb-12"),
                            children: subHeading
                        }),
                        formType === "custom" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactForm, {
                            fields: fields,
                            submitText: submitText,
                            recaptchaEnabled: recaptchaEnabled
                        }),
                        formType === "gorgias" && formUid && /*#__PURE__*/ (0,jsx_runtime.jsx)(GorgiasForm, {
                            formUid: formUid
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "lg:w-1/2 lg:pl-8 ".concat(!formEnabled ? "mx-auto" : ""),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactFormContent, {
                            content: liveChat
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactFormContent, {
                            content: callUs
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactFormContent, {
                            content: smsText
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactFormContent, {
                            content: commonQuestions
                        })
                    ]
                })
            ]
        })
    });
}
ContactFormBuilder.displayName = "ContactFormBuilder";
ContactFormBuilder.Schema = ContactFormBuilder_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/ContactFormBuilder/index.js


;// CONCATENATED MODULE: ./src/sections/CumulativeImpact/CumulativeImpact.schema.js
var CumulativeImpact_schema_Schema = function() {
    return {
        // category: 'Article',
        label: "Cumulative Impact",
        key: "cumulativeImpact",
        fields: [
            {
                name: "title",
                component: "text",
                label: "Title",
                description: "Leave Blank to hide from Table of Contents"
            },
            {
                label: "Body",
                name: "body",
                component: "markdown"
            }, 
        ]
    };
};

;// CONCATENATED MODULE: ./src/sections/CumulativeImpact/CumulativeImpact.jsx
/* eslint-disable react/no-unstable-nested-components */ 



function CumulativeImpact(param) {
    var cms = param.cms;
    var title = cms.title, body = cms.body;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "px-contained mx-auto max-w-[960px] overflow-hidden py-12 lg:py-24",
        children: [
            (title || body) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "header mb-12 text-center",
                children: [
                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                        variant: "h2",
                        element: "h1",
                        className: "mb-10 lg:mb-14",
                        children: title
                    }),
                    body && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Markdown */.UG, {
                        components: {
                            h1: function h1(data) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                                    element: "h1",
                                    variant: "h2",
                                    children: data.children
                                });
                            },
                            h2: function h2(data) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                                    element: "h2",
                                    variant: "h3",
                                    children: data.children
                                });
                            },
                            h3: function h3(data) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                                    element: "h3",
                                    variant: "h4",
                                    children: data.children
                                });
                            },
                            h4: function h4(data) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                                    element: "h4",
                                    variant: "h5",
                                    children: data.children
                                });
                            },
                            h5: function h5(data) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                                    element: "h5",
                                    variant: "h6",
                                    children: data.children
                                });
                            }
                        },
                        children: body
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Beam/* BeamCumulativeImpact */.NF, {})
        ]
    });
}
CumulativeImpact.displayName = "CumulativeImpact";
CumulativeImpact.Schema = CumulativeImpact_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/CumulativeImpact/index.js


;// CONCATENATED MODULE: ./src/sections/DynamicArticleHero/DynamicArticleHero.schema.js
var DynamicArticleHero_schema_Schema = function() {
    return {
        category: "Article",
        label: "Dynamic Article Hero",
        key: "dynamicArticleHero",
        fields: [
            {
                name: "mediaVideo",
                component: "text",
                label: "Accompanying Video",
                description: "Accompanying Video will always be used in place of Accompanying Image."
            },
            {
                label: "Background Color",
                name: "backgroundColor",
                component: "select",
                options: [
                    {
                        label: "Blue",
                        value: "blue"
                    },
                    {
                        label: "Red",
                        value: "red"
                    }, 
                ],
                defaultValue: "blue"
            },
            {
                name: "mediaPlacement",
                component: "select",
                label: "Media Placement",
                options: [
                    {
                        label: "Left",
                        value: "left"
                    },
                    {
                        label: "Right",
                        value: "right"
                    }, 
                ],
                defaultValue: "left"
            },
            {
                label: "Center Content",
                name: "centerContent",
                component: "toggle",
                toggleLabels: {
                    true: "On",
                    false: "Off"
                },
                defaultValue: false
            }, 
        ]
    };
};

;// CONCATENATED MODULE: ./src/sections/DynamicArticleHero/DynamicArticleHeroShare.jsx




function DynamicArticleHeroShare(props) {
    var link = props.link, centerContent = props.centerContent, title = props.title;
    var shareUrl = (0,react.useMemo)(function() {
        if (true) {
            return window.location.href;
        }
        return "";
    }, []);
    var ref = (0,react.useState)("Copy URL"), copyUrlTooltip = ref[0], setCopyUrlTooltip = ref[1];
    var copyUrl = function() {
        navigator.clipboard.writeText(shareUrl);
        setCopyUrlTooltip("Copied!");
        setTimeout(function() {
            setCopyUrlTooltip("Copy URL");
        }, 2000);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bottom-12 flex w-full items-center lg:bottom-28 ".concat(centerContent ? "justify-center" : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "pr-4 text-sm font-light",
                children: "Share This Article:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_EmailShareButton, {
                url: shareUrl,
                subject: "Clearly Filtered - ".concat(title),
                className: "mr-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    width: "18",
                    height: "15",
                    viewBox: "0 0 18 15",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M17.64 0H0.36C0.264522 0 0.172955 0.0415883 0.105442 0.115616C0.0379285 0.189643 0 0.290046 0 0.394737V13.8158C0 14.1299 0.113785 14.4311 0.316325 14.6532C0.518864 14.8752 0.793566 15 1.08 15H16.92C17.2064 15 17.4811 14.8752 17.6837 14.6532C17.8862 14.4311 18 14.1299 18 13.8158V0.394737C18 0.290046 17.9621 0.189643 17.8946 0.115616C17.827 0.0415883 17.7355 0 17.64 0ZM16.7148 0.789474L9 8.54309L1.2852 0.789474H16.7148ZM16.92 14.2105H1.08C0.984522 14.2105 0.892955 14.1689 0.825442 14.0949C0.757929 14.0209 0.72 13.9205 0.72 13.8158V1.29178L8.757 9.375C8.82337 9.44157 8.91005 9.47849 9 9.47849C9.08995 9.47849 9.17664 9.44157 9.243 9.375L17.28 1.29178V13.8158C17.28 13.9205 17.2421 14.0209 17.1746 14.0949C17.107 14.1689 17.0155 14.2105 16.92 14.2105Z",
                        fill: "#202635"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_LinkedinShareButton, {
                url: shareUrl,
                className: "mr-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    width: "17",
                    height: "18",
                    viewBox: "0 0 17 18",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M15.98 0H1.02C0.749479 0 0.490038 0.113785 0.298751 0.316325C0.107464 0.518864 0 0.793566 0 1.08V16.92C0 17.2064 0.107464 17.4811 0.298751 17.6837C0.490038 17.8862 0.749479 18 1.02 18H15.98C16.2505 18 16.51 17.8862 16.7012 17.6837C16.8925 17.4811 17 17.2064 17 16.92V1.08C17 0.793566 16.8925 0.518864 16.7012 0.316325C16.51 0.113785 16.2505 0 15.98 0ZM16.32 16.92C16.32 17.0155 16.2842 17.107 16.2204 17.1746C16.1567 17.2421 16.0702 17.28 15.98 17.28H1.02C0.929826 17.28 0.843346 17.2421 0.779584 17.1746C0.715821 17.107 0.68 17.0155 0.68 16.92V1.08C0.68 0.984522 0.715821 0.892955 0.779584 0.825442C0.843346 0.757929 0.929826 0.72 1.02 0.72H15.98C16.0702 0.72 16.1567 0.757929 16.2204 0.825442C16.2842 0.892955 16.32 0.984522 16.32 1.08V16.92ZM5.44 7.56V13.32C5.44 13.4155 5.40418 13.507 5.34042 13.5746C5.27665 13.6421 5.19017 13.68 5.1 13.68C5.00983 13.68 4.92335 13.6421 4.85958 13.5746C4.79582 13.507 4.76 13.4155 4.76 13.32V7.56C4.76 7.46452 4.79582 7.37295 4.85958 7.30544C4.92335 7.23793 5.00983 7.2 5.1 7.2C5.19017 7.2 5.27665 7.23793 5.34042 7.30544C5.40418 7.37295 5.44 7.46452 5.44 7.56ZM12.92 10.08V13.32C12.92 13.4155 12.8842 13.507 12.8204 13.5746C12.7567 13.6421 12.6702 13.68 12.58 13.68C12.4898 13.68 12.4033 13.6421 12.3396 13.5746C12.2758 13.507 12.24 13.4155 12.24 13.32V10.08C12.24 9.50713 12.0251 8.95773 11.6425 8.55265C11.2599 8.14757 10.741 7.92 10.2 7.92C9.65896 7.92 9.14008 8.14757 8.7575 8.55265C8.37493 8.95773 8.16 9.50713 8.16 10.08V13.32C8.16 13.4155 8.12418 13.507 8.06042 13.5746C7.99665 13.6421 7.91017 13.68 7.82 13.68C7.72983 13.68 7.64335 13.6421 7.57958 13.5746C7.51582 13.507 7.48 13.4155 7.48 13.32V7.56C7.48 7.46452 7.51582 7.37295 7.57958 7.30544C7.64335 7.23793 7.72983 7.2 7.82 7.2C7.91017 7.2 7.99665 7.23793 8.06042 7.30544C8.12418 7.37295 8.16 7.46452 8.16 7.56V8.1783C8.52526 7.73977 9.00795 7.42934 9.54387 7.28829C10.0798 7.14724 10.6436 7.18225 11.1602 7.38867C11.6769 7.59509 12.122 7.96314 12.4363 8.44388C12.7507 8.92462 12.9194 9.49529 12.92 10.08ZM5.78 5.04C5.78 5.1824 5.74012 5.32161 5.6654 5.44001C5.59068 5.55841 5.48448 5.6507 5.36023 5.70519C5.23597 5.75969 5.09925 5.77395 4.96734 5.74617C4.83543 5.71838 4.71427 5.64981 4.61917 5.54912C4.52407 5.44842 4.4593 5.32013 4.43307 5.18047C4.40683 5.0408 4.42029 4.89603 4.47176 4.76447C4.52323 4.63291 4.61039 4.52046 4.72221 4.44134C4.83404 4.36223 4.96551 4.32 5.1 4.32C5.28035 4.32 5.45331 4.39586 5.58083 4.53088C5.70836 4.66591 5.78 4.84904 5.78 5.04Z",
                        fill: "#202635"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_FacebookShareButton, {
                url: shareUrl,
                className: "facebook mr-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    width: "18",
                    height: "18",
                    viewBox: "0 0 18 18",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M9 0C7.21997 0 5.47991 0.527841 3.99987 1.51677C2.51983 2.50571 1.36628 3.91131 0.685088 5.55585C0.00389942 7.20038 -0.17433 9.00998 0.172937 10.7558C0.520203 12.5016 1.37737 14.1053 2.63604 15.364C3.89471 16.6226 5.49836 17.4798 7.24419 17.8271C8.99002 18.1743 10.7996 17.9961 12.4442 17.3149C14.0887 16.6337 15.4943 15.4802 16.4832 14.0001C17.4722 12.5201 18 10.78 18 9C17.9974 6.61385 17.0483 4.32619 15.3611 2.63893C13.6738 0.951673 11.3861 0.00262044 9 0ZM9.36 17.2719V10.8H11.88C11.9755 10.8 12.067 10.7621 12.1346 10.6946C12.2021 10.627 12.24 10.5355 12.24 10.44C12.24 10.3445 12.2021 10.253 12.1346 10.1854C12.067 10.1179 11.9755 10.08 11.88 10.08H9.36V7.56C9.36 7.08261 9.54964 6.62477 9.88721 6.28721C10.2248 5.94964 10.6826 5.76 11.16 5.76H12.6C12.6955 5.76 12.787 5.72207 12.8546 5.65456C12.9221 5.58704 12.96 5.49548 12.96 5.4C12.96 5.30452 12.9221 5.21295 12.8546 5.14544C12.787 5.07793 12.6955 5.04 12.6 5.04H11.16C10.4917 5.04 9.85068 5.3055 9.37809 5.77809C8.9055 6.25068 8.64 6.89165 8.64 7.56V10.08H6.12C6.02452 10.08 5.93296 10.1179 5.86544 10.1854C5.79793 10.253 5.76 10.3445 5.76 10.44C5.76 10.5355 5.79793 10.627 5.86544 10.6946C5.93296 10.7621 6.02452 10.8 6.12 10.8H8.64V17.2719C6.47724 17.1778 4.43735 16.2404 2.95733 14.6605C1.47731 13.0806 0.674889 10.984 0.721961 8.81968C0.769034 6.65539 1.66186 4.59559 3.20916 3.08157C4.75647 1.56755 6.83519 0.71973 9 0.71973C11.1648 0.71973 13.2435 1.56755 14.7908 3.08157C16.3381 4.59559 17.231 6.65539 17.278 8.81968C17.3251 10.984 16.5227 13.0806 15.0427 14.6605C13.5627 16.2404 11.5228 17.1778 9.36 17.2719Z",
                        fill: "#202635"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                onClick: function() {
                    return copyUrl();
                },
                target: "_blank",
                className: "copy cursor-pointer",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(D, {
                        delayHide: 500,
                        content: "Copy URL",
                        id: "copy-url"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        width: "15",
                        height: "17",
                        viewBox: "0 0 15 17",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        "data-tooltip-id": "copy-url",
                        "data-tooltip-content": copyUrlTooltip,
                        "data-tooltip-place": "top",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M8.04764 14.1519C8.07796 14.1862 8.102 14.2269 8.11841 14.2718C8.13482 14.3166 8.14326 14.3647 8.14326 14.4133C8.14326 14.4618 8.13482 14.5099 8.11841 14.5547C8.102 14.5996 8.07796 14.6403 8.04764 14.6747L7.23746 15.5928C6.44238 16.4938 5.36402 17 4.2396 17C3.11519 17 2.03683 16.4938 1.24175 15.5928C0.446671 14.6918 8.37753e-09 13.4697 0 12.1955C-8.37753e-09 10.9213 0.446671 9.69923 1.24175 8.79822L3.20772 6.5703C3.97207 5.70392 4.99968 5.20128 6.08029 5.16522C7.1609 5.12916 8.21283 5.56241 9.02084 6.37633C9.05296 6.4086 9.07914 6.44772 9.09792 6.49145C9.11669 6.53519 9.12767 6.58268 9.13025 6.63123C9.13282 6.67978 9.12693 6.72842 9.11291 6.77439C9.0989 6.82036 9.07703 6.86274 9.04856 6.89913C9.02009 6.93552 8.98557 6.9652 8.94697 6.98647C8.90838 7.00775 8.86647 7.0202 8.82363 7.02311C8.78079 7.02603 8.73787 7.01935 8.6973 7.00347C8.65674 6.98759 8.61934 6.9628 8.58722 6.93054C7.90377 6.24211 7.01409 5.87554 6.10007 5.90575C5.18605 5.93597 4.31674 6.3607 3.66987 7.09311L1.70308 9.32102C1.03036 10.0834 0.652424 11.1174 0.652424 12.1955C0.652424 13.2736 1.03036 14.3076 1.70308 15.07C2.37581 15.8324 3.28822 16.2606 4.2396 16.2606C5.19098 16.2606 6.1034 15.8324 6.77612 15.07L7.58631 14.1519C7.61659 14.1175 7.65255 14.0903 7.69213 14.0717C7.73171 14.0531 7.77413 14.0435 7.81698 14.0435C7.85982 14.0435 7.90225 14.0531 7.94183 14.0717C7.98141 14.0903 8.01736 14.1175 8.04764 14.1519ZM13.7597 1.40509C12.964 0.505325 11.8859 0 10.7618 0C9.6378 0 8.55966 0.505325 7.764 1.40509L6.95381 2.32323C6.92341 2.35786 6.89933 2.39894 6.88294 2.44412C6.86655 2.48929 6.85817 2.53769 6.85829 2.58654C6.8584 2.63538 6.867 2.68373 6.8836 2.72881C6.9002 2.77388 6.92447 2.81482 6.95503 2.84927C6.98559 2.88371 7.02184 2.91101 7.06171 2.92958C7.10157 2.94815 7.14428 2.95765 7.18738 2.95752C7.23048 2.95739 7.27314 2.94764 7.31292 2.92883C7.3527 2.91002 7.38882 2.88251 7.41922 2.84788L8.22941 1.92974C8.90213 1.16738 9.81455 0.739092 10.7659 0.739092C11.7173 0.739092 12.6297 1.16738 13.3024 1.92974C13.9752 2.69211 14.3531 3.72609 14.3531 4.80423C14.3531 5.88237 13.9752 6.91636 13.3024 7.67872L11.3316 9.90663C10.6848 10.6392 9.81556 11.0641 8.90154 11.0945C7.98752 11.1248 7.09778 10.7584 6.41423 10.0701C6.38212 10.0379 6.34471 10.0131 6.30415 9.99719C6.26359 9.98131 6.22066 9.97463 6.17782 9.97755C6.09131 9.98344 6.0104 10.028 5.9529 10.1015C5.89539 10.175 5.86601 10.2714 5.87121 10.3694C5.8764 10.4675 5.91576 10.5592 5.98061 10.6243C6.78862 11.4382 7.84055 11.8715 8.92116 11.8354C10.0018 11.7994 11.0294 11.2967 11.7937 10.4304L13.7597 8.20244C14.5539 7.30073 15 6.07874 15 4.80469C15 3.53065 14.5539 2.30866 13.7597 1.40694V1.40509Z",
                            fill: "#202635"
                        })
                    })
                ]
            })
        ]
    });
}
DynamicArticleHeroShare.displayName = "ArticleDynamicArticleHeroShare";

;// CONCATENATED MODULE: ./src/sections/DynamicArticleHero/DynamicArticleHero.jsx







function DynamicArticleHero(param) {
    var cms = param.cms;
    var ref, ref1, ref2, ref3;
    var mediaVideo = cms.mediaVideo, mediaPlacement = cms.mediaPlacement, backgroundColor = cms.backgroundColor, centerContent = cms.centerContent;
    var article = (0,dist.useArticle)();
    var mediaImage = (article === null || article === void 0 ? void 0 : (ref = article.seo) === null || ref === void 0 ? void 0 : ref.image) ? {
        src: article.seo.image
    } : null;
    var hasMedia = mediaImage || mediaVideo;
    var articleTime = ((ref2 = article === null || article === void 0 ? void 0 : (ref1 = article.tags) === null || ref1 === void 0 ? void 0 : ref1.find(function(tag) {
        return tag.includes("minutes:");
    })) === null || ref2 === void 0 ? void 0 : ref2.replace(/\D/g, "")) || "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative text-primary",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute inset-0 bg-[#D9D9D9] bg-gradient-to-r from-[#2179C2] via-[#8DCEF9] to-[#F1DCC1] ".concat(backgroundColor === "blue" ? "opacity-[15%]" : "opacity-[0%]", " ").concat(hasMedia ? "from-[#00000080] to-[#00000000]" : "bg-[#D9D9D9] from-[#2179C2] via-[#8DCEF9] to-[#F1DCC1] text-center opacity-20")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute left-0 top-0 z-[-1] h-full w-full bg-cover bg-center",
                style: {
                    backgroundImage: "".concat(backgroundColor === "red" ? "url(https://cdn.shopify.com/s/files/1/1011/0318/files/pexels-photo-7512939.png?v=1686175785)" : null)
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat(hasMedia ? "md:flex" : "", " ").concat(mediaPlacement && mediaPlacement === "left" ? "flex-row-reverse" : "", " relative overflow-hidden"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(snippets/* Link */.rU, {
                        className: "absolute left-12 top-8 hidden cursor-pointer lg:flex",
                        href: "/blogs/all",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                                className: "w-5 text-text",
                                src: "/svgs/arrow-left.svg#arrow-left",
                                title: "Arrow Left",
                                viewBox: "0 0 24 24"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "pl-6 font-light",
                                children: "Back to blog"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "md:px-contained flex flex-col items-center px-[18px] py-4 text-left lg:py-28 ".concat(hasMedia ? "md:flex-[0_0_50%]" : "md:text-center", " ").concat(centerContent ? "!text-center" : ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mx-auto flex w-full max-w-[975px] grow flex-col justify-center md:text-text ".concat(hasMedia ? "text-white" : "text-text"),
                                children: [
                                    (article === null || article === void 0 ? void 0 : (ref3 = article.blog) === null || ref3 === void 0 ? void 0 : ref3.title) && articleTime && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "font-momo !lg:text-[14px] mb-5 text-sm uppercase tracking-[0.04em] text-[#202635]",
                                        children: [
                                            article.blog.title,
                                            " •",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "text-shadowGray",
                                                children: [
                                                    articleTime,
                                                    " MIN READ"
                                                ]
                                            })
                                        ]
                                    }),
                                    (article === null || article === void 0 ? void 0 : article.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                                        className: "mb-6 capitalize text-[#202635]",
                                        variant: "h2",
                                        element: "h2",
                                        children: article.title
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicArticleHeroShare, {
                                link: "/articles/".concat(article === null || article === void 0 ? void 0 : article.handle),
                                centerContent: centerContent,
                                title: article === null || article === void 0 ? void 0 : article.title
                            })
                        ]
                    }),
                    hasMedia ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative inset-0 z-0 md:flex-[0_0_50%] lg:px-12 lg:py-28",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative aspect-[762/576] min-h-full max-w-full",
                            children: [
                                (mediaImage === null || mediaImage === void 0 ? void 0 : mediaImage.src) && !mediaVideo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                    fill: true,
                                    alt: article === null || article === void 0 ? void 0 : article.title,
                                    sizes: "(min-width: 1024px) 40vw, 100vw",
                                    src: mediaImage === null || mediaImage === void 0 ? void 0 : mediaImage.src
                                }) : null,
                                mediaVideo ? /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                    src: mediaVideo,
                                    autoPlay: true,
                                    muted: true,
                                    loop: true,
                                    playsInline: true,
                                    className: "h-full w-full object-cover"
                                }) : null
                            ]
                        })
                    }) : null
                ]
            })
        ]
    });
}
DynamicArticleHero.displayName = "DynamicArticleHero";
DynamicArticleHero.Schema = DynamicArticleHero_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/DynamicArticleHero/index.js


;// CONCATENATED MODULE: ./src/sections/DynamicBlogList/DynamicBlogList.schema.js
function DynamicBlogList_schema_Schema() {
    return {
        label: "Dynamic Blog list",
        key: "dynamicBlogList",
        category: "Content",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/blog_list.png?v=1684851075",
        fields: [
            {
                label: "Title",
                name: "title",
                component: "text"
            },
            {
                label: "View all link",
                name: "viewAllLink",
                component: "link"
            },
            {
                label: "Article Handles",
                name: "articleHandles",
                component: "list",
                field: {
                    component: "text"
                },
                validate: {
                    maxItems: 3
                }
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/DynamicBlogList/DynamicBlogList.jsx




// import articleList from '../../../public/json/articles-list.json'; // eslint-disable-line

function DynamicBlogList(param) {
    var cms = param.cms;
    var title = cms.title, viewAllLink = cms.viewAllLink, _articleHandles = cms.articleHandles, articleHandles = _articleHandles === void 0 ? [] : _articleHandles;
    var ref = (0,react.useState)([]), articleList = ref[0], setArticleList = ref[1];
    (0,react.useEffect)(function() {
        fetch("/json/articles-list.json").then(function(r) {
            return r.ok ? r.json() : [];
        }).then(function(data) {
            return setArticleList(Array.isArray(data) ? data : []);
        }).catch(function() {
            return setArticleList([]);
        });
    }, []);
    var articles = articleHandles.reduce(function(reducer, articleHandle) {
        var article = articleList.find(function(param) {
            var handle = param.handle;
            return handle === articleHandle;
        });
        if (article) {
            var ref;
            var articleTime = ((ref = article.tags.find(function(tag) {
                return tag.includes("minutes:");
            })) === null || ref === void 0 ? void 0 : ref.replace(/\D/g, "")) || "";
            reducer.push({
                title: article.title,
                blog: article.blog,
                articleTime: articleTime,
                image: {
                    src: article.seo.image,
                    alt: article.title
                },
                link: {
                    url: "/articles/".concat(article.handle)
                }
            });
        }
        return reducer;
    }, []);
    var _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "my-20 print:hidden",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "px-contained mx-auto max-w-[var(--content-max-width)]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mb-10 flex justify-between",
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                            variant: "h3",
                            children: title
                        }),
                        (viewAllLink === null || viewAllLink === void 0 ? void 0 : viewAllLink.text) && (viewAllLink === null || viewAllLink === void 0 ? void 0 : viewAllLink.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "hidden lg:block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Button */.zx, {
                                href: viewAllLink.url,
                                variant: "outlined",
                                theme: "secondary",
                                children: viewAllLink.text
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid gap-6 gap-y-10 lg:grid-cols-3",
                    children: [
                        articles === null || articles === void 0 ? void 0 : articles.map(function(article, index) {
                            var ref, ref1, ref2, ref3;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                                href: (ref = article.link) === null || ref === void 0 ? void 0 : ref.url,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "group",
                                    children: [
                                        ((ref1 = article.image) === null || ref1 === void 0 ? void 0 : ref1.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "relative aspect-[353/255] w-full md:aspect-square [&>span]:!h-full [&>span]:!w-full",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                                src: article.image.src,
                                                alt: (_alt = article.image.alt) !== null && _alt !== void 0 ? _alt : article.title,
                                                loading: "lazy",
                                                quality: 100,
                                                sizes: "400px",
                                                fill: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "my-4 h-[1px] bg-[#20263533] transition-all group-hover:bg-gradient-to-r group-hover:from-[#F1DCC1] group-hover:to-[#2179C2]"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mb-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* AltText */.Fh, {
                                                className: "uppercase",
                                                children: [
                                                    article === null || article === void 0 ? void 0 : (ref2 = article.blog) === null || ref2 === void 0 ? void 0 : ref2.title,
                                                    (article === null || article === void 0 ? void 0 : article.articleTime) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "text-shadowGray",
                                                        children: [
                                                            "• ",
                                                            article.articleTime,
                                                            " Min Read"
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                                            variant: "h5",
                                            children: article.title
                                        })
                                    ]
                                }, (ref3 = article.link) === null || ref3 === void 0 ? void 0 : ref3.url)
                            }, "blog-card-".concat(index));
                        }),
                        (viewAllLink === null || viewAllLink === void 0 ? void 0 : viewAllLink.text) && (viewAllLink === null || viewAllLink === void 0 ? void 0 : viewAllLink.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-center lg:hidden",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Button */.zx, {
                                href: viewAllLink.url,
                                variant: "filled",
                                theme: "primary",
                                children: viewAllLink.text
                            })
                        })
                    ]
                })
            ]
        })
    });
}
DynamicBlogList.displayName = "DynamicBlogList";
DynamicBlogList.Schema = DynamicBlogList_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/DynamicBlogList/index.js


// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_array.mjs
var _to_array = __webpack_require__(9967);
;// CONCATENATED MODULE: ./src/sections/DynamicPopularPosts/DynamicPopularPosts.schema.js
function DynamicPopularPosts_schema_Schema() {
    return {
        label: "Dynamic Popular Posts",
        category: "Blog",
        key: "dynamicPopularPosts",
        fields: [
            {
                name: "header",
                component: "text",
                label: "Header",
                defaultValue: "Popular Posts"
            },
            {
                label: "Article Handles",
                name: "articleHandles",
                description: "First handle will be the featured article",
                component: "list",
                field: {
                    component: "text"
                },
                validate: {
                    maxItems: 4
                }
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/DynamicPopularPosts/DynamicPopularPosts.jsx





// import articleList from '../../../public/json/articles-list.json'; // eslint-disable-line

function DynamicPopularPosts_PopularPost(props) {
    var image = props.image, title = props.title, cta = props.cta, blog = props.blog, articleTime = props.articleTime;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
        href: cta === null || cta === void 0 ? void 0 : cta.url,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "group mb-8 cursor-pointer",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "my-4 h-[1px] bg-[#fff] transition-all group-hover:bg-gradient-to-r group-hover:from-[#F1DCC1] group-hover:to-[#2179C2]"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-8 flex items-center justify-between lg:items-start",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mb-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* AltText */.Fh, {
                                        className: "uppercase",
                                        children: [
                                            blog === null || blog === void 0 ? void 0 : blog.title,
                                            articleTime ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "mr-2 text-shadowGray",
                                                children: [
                                                    "• ",
                                                    articleTime,
                                                    " Min Read"
                                                ]
                                            }) : ""
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                                    variant: "h5",
                                    className: "max-lg:text-[16px]",
                                    children: title
                                })
                            ]
                        }),
                        (image === null || image === void 0 ? void 0 : image.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative flex h-[85px] w-full max-w-[110px] justify-end lg:h-[210px] lg:max-w-[260px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                src: image.src,
                                alt: image.alt || title,
                                width: "260px",
                                height: "210px",
                                className: "object-cover"
                            })
                        })
                    ]
                })
            ]
        }, cta === null || cta === void 0 ? void 0 : cta.url)
    });
}
function DynamicPopularPosts(param) {
    var cms = param.cms;
    var ref, ref1, ref2;
    var header = cms.header, _articleHandles = cms.articleHandles, articleHandles = _articleHandles === void 0 ? [] : _articleHandles;
    var ref3 = (0,react.useState)([]), articleList = ref3[0], setArticleList = ref3[1];
    (0,react.useEffect)(function() {
        fetch("/json/articles-list.json").then(function(r) {
            return r.ok ? r.json() : [];
        }).then(function(data) {
            return setArticleList(Array.isArray(data) ? data : []);
        }).catch(function() {
            return setArticleList([]);
        });
    }, []);
    var ref4 = (0,_to_array/* default */.Z)(articleHandles.reduce(function(reducer, articleHandle) {
        var article = articleList.find(function(param) {
            var handle = param.handle;
            return handle === articleHandle;
        });
        if (article) {
            var ref;
            var articleTime = ((ref = article.tags.find(function(tag) {
                return tag.includes("minutes:");
            })) === null || ref === void 0 ? void 0 : ref.replace(/\D/g, "")) || "";
            reducer.push({
                title: article.title,
                blog: article.blog,
                articleTime: articleTime,
                image: {
                    src: article.seo.image,
                    alt: article.title
                },
                cta: {
                    url: "/articles/".concat(article.handle)
                }
            });
        }
        return reducer;
    }, [])), featuredArticle = ref4[0], articles = ref4.slice(1);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pb-8 pt-12 lg:pb-28 lg:pt-20",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "px-contained mx-auto flex max-w-[var(--content-max-width)] pb-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                    variant: "h3",
                    className: "",
                    children: header
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "lg:px-contained mx-auto max-w-[var(--content-max-width)] lg:grid lg:grid-cols-2 lg:gap-16",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(snippets/* Link */.rU, {
                        href: (ref = featuredArticle.cta) === null || ref === void 0 ? void 0 : ref.url,
                        className: "relative flex cursor-pointer",
                        children: [
                            ((ref1 = featuredArticle.image) === null || ref1 === void 0 ? void 0 : ref1.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute flex h-[420px] w-full justify-end lg:h-full",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                    src: featuredArticle.image.src,
                                    alt: featuredArticle.image.alt || featuredArticle.title,
                                    fill: true,
                                    className: "h-[420px] object-cover lg:h-full "
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex h-[420px] items-end lg:h-auto",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "px-contained group relative z-10 mb-8 py-8",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-8 flex justify-between",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "w-full",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mb-2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* AltText */.Fh, {
                                                        className: "uppercase tracking-[0.04em] text-white",
                                                        children: [
                                                            featuredArticle === null || featuredArticle === void 0 ? void 0 : (ref2 = featuredArticle.blog) === null || ref2 === void 0 ? void 0 : ref2.title,
                                                            featuredArticle.articleTime ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "ml-2",
                                                                children: [
                                                                    "• ",
                                                                    featuredArticle.articleTime,
                                                                    " Min Read"
                                                                ]
                                                            }) : ""
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                                                    variant: "h3",
                                                    className: "text-white",
                                                    children: featuredArticle.title
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "px-contained lg:px-0",
                        children: articles === null || articles === void 0 ? void 0 : articles.map(function(param, index) {
                            var image = param.image, title = param.title, articleTime = param.articleTime, cta = param.cta, blog = param.blog;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicPopularPosts_PopularPost, {
                                image: image,
                                title: title,
                                blog: blog,
                                articleTime: articleTime,
                                cta: cta
                            }, index);
                        })
                    })
                ]
            })
        ]
    });
}
DynamicPopularPosts.displayName = "DynamicPopularPosts";
DynamicPopularPosts.Schema = DynamicPopularPosts_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/DynamicPopularPosts/index.js


;// CONCATENATED MODULE: ./src/sections/Environment/Environment.schema.js
var statsContent = {
    label: "Stats Settings",
    name: "stats",
    component: "group",
    fields: [
        {
            label: "Stats",
            name: "statItems",
            component: "group-list",
            itemProps: {
                label: "{{item.title}}"
            },
            fields: [
                {
                    label: "Ttile",
                    name: "title",
                    component: "text"
                },
                {
                    label: "Number",
                    name: "number",
                    component: "text"
                }, 
            ]
        }, 
    ]
};
var Environment_schema_Schema = function() {
    return {
        label: "Environment",
        category: "Content",
        key: "environment",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/Screen_20Shot_202023-05-23_20at_2010.45.29_20AM.png?v=1684864554",
        fields: [
            {
                label: "Heading",
                name: "heading",
                component: "text",
                defaultValue: "Our Environmental Impact"
            },
            {
                label: "Color Heading",
                name: "colorHeading",
                component: "text",
                defaultValue: "Every Sip Counts"
            },
            {
                label: "Eyebrow",
                name: "eyebrow",
                component: "text",
                defaultValue: "About the Problem"
            },
            {
                label: "Copy",
                name: "copy",
                component: "text",
                defaultValue: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
            },
            {
                label: "Image",
                name: "image",
                component: "image"
            },
            statsContent, 
        ]
    };
};

;// CONCATENATED MODULE: ./src/sections/Environment/Environment.jsx





function Stat(props) {
    var content = props.content;
    var ref = (0,react.useState)(parseFloat(Number(content.number.replace(/,/g, "")))), count = ref[0], setCount = ref[1];
    (0,react.useEffect)(function() {
        var numberWithCommas = function numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        };
        var increment = function increment() {
            var newNumber = Number(count++);
            setCount(numberWithCommas(newNumber));
        };
        var interval = setInterval(increment, 2000);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mb-4 w-full rounded-lg border border-[#DDE2E7] p-6 lg:mb-0 lg:px-8 lg:py-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "font-normal text-[#3279B8]",
                children: content.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-2 font-light tracking-[-.02em] max-lg:text-[32px] lg:text-2xl 2xl:text-5xl",
                children: count
            })
        ]
    });
}
function Environment(param) {
    var cms = param.cms;
    var heading = cms.heading, colorHeading = cms.colorHeading, eyebrow = cms.eyebrow, copy = cms.copy, image = cms.image, stats = cms.stats;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative bg-[#e6f0f81a]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-contained overflow-hidden pt-0 lg:flex lg:pt-20",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "pt-20 lg:w-1/2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Headline */.s0, {
                                variant: "h3",
                                element: "h3",
                                className: "relative z-10 mb-6 mt-6 max-w-3xl lg:mb-12",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: heading
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-[#3383C5]",
                                        children: colorHeading
                                    })
                                ]
                            }),
                            image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "pt-12 lg:hidden",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                    className: "",
                                    sizes: "48px",
                                    width: "357px",
                                    height: "357px",
                                    src: image.src
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("blockquote", {
                                className: "px-4 pb-10 pt-16 lg:max-w-xl lg:px-16 lg:py-24 lg:pb-0 lg:pt-8",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mb-4 font-normal tracking-[-.01em] text-[#000]",
                                        children: eyebrow
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-base text-[#000] lg:text-xl",
                                        children: copy
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "lg:w-1/2",
                        children: image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "hidden lg:block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                className: "",
                                sizes: "48px",
                                width: "660px",
                                height: "660px",
                                src: image.src
                            })
                        })
                    })
                ]
            }),
            (stats === null || stats === void 0 ? void 0 : stats.statItems.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "px-contained grid-cols-4 items-stretch gap-x-8 overflow-hidden pb-16 pt-8 lg:grid",
                children: stats.statItems.map(function(stat, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stat, {
                        content: stat
                    }, index);
                })
            })
        ]
    });
}
Environment.displayName = "Environment";
Environment.Schema = Environment_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/Environment/index.js


// EXTERNAL MODULE: ../node_modules/fast-deep-equal/index.js
var fast_deep_equal = __webpack_require__(6471);
var fast_deep_equal_default = /*#__PURE__*/__webpack_require__.n(fast_deep_equal);
;// CONCATENATED MODULE: ./src/sections/FeaturedProduct/FeaturedProduct.schema.js
var FeaturedProduct_schema_Schema = function() {
    return {
        category: "Product",
        label: "Featured Product",
        key: "featuredProduct",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/featuredproductlayout.png?v=1721666072",
        fields: [
            {
                label: "Section ID",
                name: "sectionId",
                component: "text",
                description: "Add an ID to your section for linking purposes. Please make sure to not use the same ID twice."
            },
            {
                label: "Custom Save Percentage Text",
                name: "customSavePercentageText",
                component: "text",
                description: "Use {{ amount }} to insert the savings percentage value into your text. You can include any additional text around this value to customize your message."
            },
            {
                name: "featuredProduct",
                component: "productSearch",
                label: "Select Product"
            },
            {
                label: "Linked Product Groups",
                component: "group-list",
                name: "linkedProductGroups",
                itemProps: {
                    label: "{{item.groupName}}"
                },
                fields: [
                    {
                        label: "Group Name",
                        name: "groupName",
                        component: "text",
                        defaultValue: "Options"
                    },
                    {
                        label: "Linked Products",
                        component: "group-list",
                        name: "linkedProducts",
                        itemProps: {
                            label: "{{item.linkedProductTitle}}"
                        },
                        fields: [
                            {
                                label: "Product Title",
                                name: "linkedProductTitle",
                                component: "text"
                            },
                            {
                                label: "Product",
                                name: "linkedProduct",
                                component: "productSearch"
                            }, 
                        ]
                    }, 
                ]
            },
            {
                name: "productBannerText",
                component: "text",
                label: "Product Banner Text"
            },
            {
                name: "bottomBannerHeading",
                component: "text",
                label: "Bottom Banner Heading"
            },
            {
                name: "bottomBannerText",
                component: "markdown",
                label: "Bottom Banner Text"
            },
            {
                label: "Product Display Type",
                name: "productDisplayType",
                component: "select",
                options: [
                    {
                        label: "Featured",
                        value: "featured"
                    },
                    {
                        label: "One-time Only",
                        value: "onetimeOnly"
                    }, 
                ],
                defaultValue: "featured"
            },
            {
                label: "Product Description",
                name: "productDescription",
                component: "markdown"
            },
            {
                label: "Product Features",
                name: "productFeatures",
                component: "group-list",
                validate: {
                    maxItems: 6
                },
                fields: [
                    {
                        label: "Product Feature Icon",
                        name: "productFeatureIcon",
                        component: "image"
                    },
                    {
                        label: "Feature Description",
                        name: "featureDescription",
                        component: "text"
                    }, 
                ]
            },
            {
                component: "group",
                name: "discount",
                label: "Discount",
                fields: [
                    {
                        name: "enableDiscount",
                        component: "toggle",
                        label: "Enable Discount",
                        defaultValue: false
                    },
                    {
                        name: "discountCode",
                        component: "text",
                        label: "Discount Code",
                        description: "Discount code to be applied to cart on Add To Cart"
                    },
                    {
                        name: "discountType",
                        component: "select",
                        label: "Discount Type",
                        options: [
                            {
                                label: "Percentage",
                                value: "percentage"
                            },
                            {
                                label: "Fixed Amount",
                                value: "fixed"
                            }, 
                        ]
                    },
                    {
                        name: "discountAmount",
                        component: "number",
                        label: "Amount off",
                        description: "Discount amount to be applied to cart on Add To Cart"
                    }, 
                ]
            }, 
        ]
    };
};

// EXTERNAL MODULE: ./src/contexts/globalProductPageContext.js
var globalProductPageContext = __webpack_require__(2448);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(7599);
;// CONCATENATED MODULE: ./src/sections/FeaturedProduct/ProductOptions/ProductColorOptionValue.jsx





function ColorOptionValue(param) {
    var isSelected = param.isSelected, swatch = param.swatch, value = param.value;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "swatch-selector relative flex h-8 w-8 items-center justify-center overflow-hidden rounded-[50%] transition md:hover:border-text ".concat(isSelected ? "border border-text" : ""),
        style: {
            backgroundColor: swatch === null || swatch === void 0 ? void 0 : swatch.color
        },
        children: [
            (swatch === null || swatch === void 0 ? void 0 : (ref = swatch.image) === null || ref === void 0 ? void 0 : ref.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                alt: value,
                className: "absolute left-1/2 top-1/2 h-full w-full -translate-x-1/2 -translate-y-1/2 object-cover",
                height: "32",
                src: swatch.image.src,
                width: "32"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute left-1/2 top-1/2 h-full w-full -translate-x-1/2 -translate-y-1/2 rounded-[50%] border-clearBlue transition-[border-width] duration-100 ".concat(isSelected ? "border-[3px]" : "border-[0px]")
            })
        ]
    });
}
function ProductColorOptionValue(param) {
    var inventory = param.inventory, isSelected = param.isSelected, newSelectedOptions = param.newSelectedOptions, product = param.product, setSelectedOptions = param.setSelectedOptions, value = param.value;
    var ref, ref1, ref2, ref3, ref4;
    var settings = (0,dist.useSettings)();
    var swatches = settings === null || settings === void 0 ? void 0 : (ref = settings.product) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.swatches;
    var isFromGrouping = (ref2 = product.grouping) === null || ref2 === void 0 ? void 0 : ref2.isTransformed;
    var variantFromOptionValue = (0,react.useMemo)(function() {
        var ref;
        return (ref = product.variants) === null || ref === void 0 ? void 0 : ref.find(function(param) {
            var selectedOptionsMap = param.selectedOptionsMap;
            return fast_deep_equal_default()(newSelectedOptions, selectedOptionsMap);
        });
    }, [
        newSelectedOptions,
        product.variants
    ]);
    var optionValueIsAvailable = (inventory === null || inventory === void 0 ? void 0 : (ref3 = inventory.variants) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[variantFromOptionValue === null || variantFromOptionValue === void 0 ? void 0 : variantFromOptionValue.id]) === null || ref4 === void 0 ? void 0 : ref4.availableForSale) || false;
    var swatch = (0,react.useMemo)(function() {
        if (!swatches) return null;
        return swatches.find(function(param) {
            var name = param.name;
            return (name === null || name === void 0 ? void 0 : name.trim().toLowerCase()) === value.toLowerCase();
        }) || null;
    }, [
        swatches,
        value
    ]);
    var url = (0,react.useMemo)(function() {
        if (!isFromGrouping) return null;
        var selectedVariantFromOptions = product.grouping.variants.find(function(param) {
            var selectedOptionsMap = param.selectedOptionsMap;
            return fast_deep_equal_default()(newSelectedOptions, selectedOptionsMap);
        });
        if (!selectedVariantFromOptions) return null;
        var params = "";
        if (true) {
            var search = window.location.search;
            params = new URLSearchParams(search);
            params.set("variant", selectedVariantFromOptions.legacyResourceId);
        }
        return "/products/".concat(selectedVariantFromOptions.product.handle, "?").concat(params);
    }, [
        isFromGrouping,
        newSelectedOptions
    ]);
    return isFromGrouping ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: "product-option-item",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
            "aria-label": value,
            href: url,
            onClick: function(e) {
                if (isSelected) e.preventDefault();
            },
            scroll: false,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorOptionValue, {
                isSelected: isSelected,
                swatch: swatch,
                value: value
            })
        })
    }) : variantFromOptionValue && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: "product-option-item",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            "aria-label": value,
            onClick: function() {
                if (isSelected) return;
                setSelectedOptions(newSelectedOptions);
            },
            className: "relative\n            ".concat(isSelected && !optionValueIsAvailable ? "[&>div]:!border-error" : "", "\n            ").concat(!optionValueIsAvailable ? 'after:absolute after:left-0 after:right-0 after:top-1/2 after:h-[2px] after:-translate-y-[1px] after:-rotate-45 after:scale-90 after:bg-clearBlue after:content-[""]' : "", "\n          "),
            type: "button",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorOptionValue, {
                isSelected: isSelected,
                swatch: swatch,
                value: value
            })
        })
    });
}
ProductColorOptionValue.displayName = "ProductColorOptionValue";
ColorOptionValue.displayName = "ColorOptionValue";

;// CONCATENATED MODULE: ./src/sections/FeaturedProduct/ProductOptions/ProductOptionValue.jsx



function ProductOptionValue(param) {
    var inventory = param.inventory, isSelected = param.isSelected, newSelectedOptions = param.newSelectedOptions, product = param.product, setSelectedOptions = param.setSelectedOptions, value = param.value;
    var ref, ref1;
    var variantFromOptionValue = (0,react.useMemo)(function() {
        var ref;
        return (ref = product.variants) === null || ref === void 0 ? void 0 : ref.find(function(param) {
            var selectedOptionsMap = param.selectedOptionsMap;
            return fast_deep_equal_default()(newSelectedOptions, selectedOptionsMap);
        });
    }, [
        newSelectedOptions,
        product.variants
    ]);
    var optionValueIsAvailable = (inventory === null || inventory === void 0 ? void 0 : (ref = inventory.variants) === null || ref === void 0 ? void 0 : (ref1 = ref[variantFromOptionValue === null || variantFromOptionValue === void 0 ? void 0 : variantFromOptionValue.id]) === null || ref1 === void 0 ? void 0 : ref1.availableForSale) || false;
    var disabled = !variantFromOptionValue;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: "product-option-item",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
            "aria-label": value,
            className: "relative inline-block min-w-[3.5rem] overflow-hidden border px-[20px] py-[10px] text-text transition hover:border-text hover:bg-white md:hover:border-text\n        ".concat(optionValueIsAvailable ? "border-[#797D86] bg-[#E6F0F8]" : "opacity-50", "\n        ").concat(isSelected ? "cursor-pointer border-black bg-white shadow-[inset_0_0_0_1px_#000000]" : ""),
            disabled: disabled,
            onClick: function() {
                if (isSelected) return;
                setSelectedOptions(newSelectedOptions);
            },
            type: "button",
            children: [
                !optionValueIsAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute inset-0 top-[50%] h-[1px] w-[calc(100%+20px)] -rotate-[18deg] border-t border-t-text bg-red-200 opacity-30"
                }),
                value
            ]
        })
    });
}
ProductOptionValue.displayName = "ProductOptionValue";

;// CONCATENATED MODULE: ./src/sections/FeaturedProduct/ProductOptions/ProductOptions.jsx









function ProductOptions(param) {
    var product = param.product, selectedOptions = param.selectedOptions, selectedVariant = param.selectedVariant, setSelectedOptions = param.setSelectedOptions;
    var ref, ref1, ref2, ref3;
    var variantGroups = product === null || product === void 0 ? void 0 : product.variantGroups;
    var inventory = (0,dist.useProductInventoryByHandle)({
        handle: selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.product) === null || ref === void 0 ? void 0 : ref.handle,
        withInventory: false
    }).inventory;
    var variantFromOptionValue = (0,react.useMemo)(function() {
        var ref;
        return product === null || product === void 0 ? void 0 : (ref = product.variants) === null || ref === void 0 ? void 0 : ref.find(function(param) {
            var selectedOptionsMap = param.selectedOptionsMap;
            return fast_deep_equal_default()(selectedOptions, selectedOptionsMap);
        });
    }, [
        selectedOptions,
        product === null || product === void 0 ? void 0 : product.variants
    ]);
    var optionValueIsAvailable = (inventory === null || inventory === void 0 ? void 0 : (ref1 = inventory.variants) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[variantFromOptionValue === null || variantFromOptionValue === void 0 ? void 0 : variantFromOptionValue.id]) === null || ref2 === void 0 ? void 0 : ref2.availableForSale) || false;
    // const disabled = !variantFromOptionValue;
    var ref4 = (0,react.useState)(false), displayOos = ref4[0], setDisplayOos = ref4[1];
    (0,react.useEffect)(function() {
        if (!inventory) return;
        setDisplayOos(!optionValueIsAvailable);
    }, [
        inventory,
        optionValueIsAvailable
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            inventory && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-options flex flex-col text-primary",
                children: (ref3 = product.options) === null || ref3 === void 0 ? void 0 : ref3.map(function(param) {
                    var id = param.id, name = param.name, values = param.values;
                    var ref;
                    var productOrGroupingValues = ((ref = product.grouping) === null || ref === void 0 ? void 0 : ref.isTransformed) ? product.grouping.optionsMap[name] : values;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "product-option-group",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                className: "mb-6 mt-6 border-t border-t-[#DDE2E7] p-0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "product-selected-option mb-2 flex items-center justify-between gap-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mb-4 flex items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "product-selected-option__name text-base font-normal uppercase leading-6",
                                            children: name === "Size" ? "Select a Size" : "".concat(name, ":")
                                        }),
                                        name !== "Size" && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "product-selected-option__value text-base font-normal uppercase",
                                            children: selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions[name]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "product-option-list flex flex-wrap gap-2",
                                children: productOrGroupingValues === null || productOrGroupingValues === void 0 ? void 0 : productOrGroupingValues.map(function(value) {
                                    var isSelected = (selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions[name]) === value;
                                    var newSelectedOptions = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selectedOptions), (0,_define_property/* default */.Z)({}, name, value));
                                    var variantIsInGroup = variantGroups.length > 0 && variantGroups.some(function(group) {
                                        return group.variants.some(function(variant) {
                                            var colorOption = variant.selectedOptions.find(function(option) {
                                                return option.name === "Color";
                                            });
                                            return colorOption.value === value;
                                        });
                                    });
                                    if (variantIsInGroup) return null;
                                    return name === "Color" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductColorOptionValue, {
                                        inventory: inventory,
                                        isSelected: isSelected,
                                        newSelectedOptions: newSelectedOptions,
                                        product: product,
                                        setSelectedOptions: setSelectedOptions,
                                        value: value
                                    }, value) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductOptionValue, {
                                        inventory: inventory,
                                        isSelected: isSelected,
                                        newSelectedOptions: newSelectedOptions,
                                        product: product,
                                        setSelectedOptions: setSelectedOptions,
                                        value: value
                                    }, value);
                                })
                            }),
                            variantGroups.length > 0 && name === "Color" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "product-option-variant-group flex flex-col gap-2",
                                children: variantGroups.map(function(group) {
                                    var metaobject = group.metaobject;
                                    var title = metaobject.title, calloutText = metaobject.callout_text;
                                    var groupValues = group.variants.map(function(variant) {
                                        var colorOption = variant.selectedOptions.find(function(option) {
                                            return option.name === "Color";
                                        });
                                        return colorOption.value;
                                    });
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mt-6",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mb-2 flex items-center justify-between gap-2",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "mb-4 flex items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                            className: "text-base font-normal uppercase leading-6",
                                                            children: title
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-base italic text-[--shadow-gray]",
                                                            children: calloutText
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                className: "flex flex-wrap gap-2",
                                                children: groupValues === null || groupValues === void 0 ? void 0 : groupValues.map(function(value) {
                                                    var isSelected = (selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions[name]) === value;
                                                    var newSelectedOptions = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selectedOptions), (0,_define_property/* default */.Z)({}, name, value));
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductColorOptionValue, {
                                                        inventory: inventory,
                                                        isSelected: isSelected,
                                                        newSelectedOptions: newSelectedOptions,
                                                        product: product,
                                                        setSelectedOptions: setSelectedOptions,
                                                        value: value
                                                    }, value);
                                                })
                                            })
                                        ]
                                    }, group.group);
                                })
                            })
                        ]
                    }, id);
                })
            }),
            displayOos && inventory && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-options--oos relative mt-4 border border-error p-[10px] text-center text-error before:absolute before:inset-0 before:bg-error before:opacity-[0.15]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative",
                    children: "This item is currently out of stock"
                })
            })
        ]
    });
}
ProductOptions.displayName = "ProductOptions";

;// CONCATENATED MODULE: ./src/sections/FeaturedProduct/ProductOptions/index.js


// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(3615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/sections/FeaturedProduct/ProductGroupItem.jsx





function ProductGroupItem(param) {
    var product = param.product;
    var ref = (0,globalProductPageContext/* useGlobalProductPageContext */.j)(), selectedProduct = ref.selectedProduct, setSelectedProduct = ref.setSelectedProduct;
    var ref1 = (0,react.useState)(true), isAvailable = ref1[0], setIsAvailable = ref1[1];
    var ref2 = (0,react.useState)(false), isActive = ref2[0], setIsActive = ref2[1];
    var linkedProduct = product === null || product === void 0 ? void 0 : product.linkedProduct;
    var ref3 = (0,dist.useProductByHandle)({
        handle: linkedProduct === null || linkedProduct === void 0 ? void 0 : linkedProduct.handle
    }), packProduct = ref3.product;
    (0,react.useEffect)(function() {
        if (!packProduct) return;
        var ref;
        var availableInventory = (ref = packProduct === null || packProduct === void 0 ? void 0 : packProduct.totalInventory) !== null && ref !== void 0 ? ref : 0;
        setIsAvailable(availableInventory > 0 || !(packProduct === null || packProduct === void 0 ? void 0 : packProduct.tracksInventory));
        setIsActive((linkedProduct === null || linkedProduct === void 0 ? void 0 : linkedProduct.handle) === (selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.handle));
    }, [
        selectedProduct,
        packProduct
    ]);
    var productTitle = product === null || product === void 0 ? void 0 : product.linkedProductTitle;
    var classes = "relative inline-block min-w-[3.5rem] overflow-hidden border px-[20px] py-[10px] text-text transition hover:border-text hover:bg-white md:hover:border-text";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            isActive && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "".concat(classes, " cursor-pointer border-black bg-white shadow-[inset_0_0_0_1px_#000000]"),
                children: productTitle
            }),
            !isActive && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: "".concat(isAvailable ? "border-[#797D86] bg-[#E6F0F8]" : "pointer-events-none opacity-50", "\n          ").concat(classes),
                type: "button",
                "aria-label": productTitle,
                onClick: function() {
                    return setSelectedProduct(packProduct);
                },
                children: [
                    !isAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute inset-0 top-[50%] h-[1px] w-[calc(100%+20px)] -rotate-[18deg] border-t border-t-text bg-red-200 opacity-30"
                    }),
                    productTitle
                ]
            })
        ]
    });
}
ProductGroupItem.displayName = "ProductGroupItem";
ProductGroupItem.propTypes = {
    product: prop_types_default().shape({
        linkedProductTitle: (prop_types_default()).string,
        linkedProduct: (prop_types_default()).object
    })
};

// EXTERNAL MODULE: ./src/snippets/RechargeSubscriptionWidget/RechargeSubscriptionWidget.jsx + 5 modules
var RechargeSubscriptionWidget = __webpack_require__(6426);
;// CONCATENATED MODULE: ./src/sections/FeaturedProduct/ProductDetails.jsx








function ProductDetails(param) {
    var product = param.product, linkedProductGroups = param.linkedProductGroups, selectedOptions = param.selectedOptions, selectedVariant = param.selectedVariant, productType = param.productType, setSelectedOptions = param.setSelectedOptions, productDescription = param.productDescription, productFeatures = param.productFeatures, bottomBannerText = param.bottomBannerText, bottomBannerHeading = param.bottomBannerHeading;
    var ref;
    var ref1 = (0,globalProductPageContext/* useGlobalProductPageContext */.j)(), discount = ref1.discount, purchaseType = ref1.purchaseType, selectedSellingPlan = ref1.selectedSellingPlan, productSubscriptionWidget = ref1.productSubscriptionWidget, setRecommendedFilterFrequency = ref1.setRecommendedFilterFrequency;
    var ref2 = (0,hooks/* useVariantPrices */.be)({
        variant: selectedVariant,
        purchaseType: purchaseType,
        isPdp: true
    }), price = ref2.price, compareAtPrice = ref2.compareAtPrice;
    var hideOptions = (product === null || product === void 0 ? void 0 : (ref = product.variants) === null || ref === void 0 ? void 0 : ref.length) === 1 && product.variants[0].title === "Default Title";
    var defaultRecommendedFrequency = productSubscriptionWidget === null || productSubscriptionWidget === void 0 ? void 0 : productSubscriptionWidget.defaultRecommendedFrequency;
    (0,react.useEffect)(function() {
        if (defaultRecommendedFrequency) {
            setRecommendedFilterFrequency(defaultRecommendedFrequency);
        }
    }, [
        defaultRecommendedFrequency
    ]);
    var ref3 = (0,react.useState)(price), displayPrice = ref3[0], setDisplayPrice = ref3[1];
    var ref4 = (0,react.useState)(compareAtPrice), comparePrice = ref4[0], setDisplayComparePrice = ref4[1];
    (0,react.useEffect)(function() {
        if (!price) {
            return;
        }
        setDisplayPrice(price);
        setDisplayComparePrice(compareAtPrice);
        if (discount === null || discount === void 0 ? void 0 : discount.enableDiscount) {
            if (!compareAtPrice) {
                setDisplayComparePrice(price);
            }
            var discountPrice = parseFloat(price.replace("$", ""));
            if (discount.discountType === "fixed") {
                discountPrice -= discount.discountAmount;
            } else {
                discountPrice -= discountPrice * (discount.discountAmount / 100);
            }
            discountPrice = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD"
            }).format(discountPrice).replace(".00", "");
            setDisplayPrice(discountPrice);
        } else if (compareAtPrice) {
            var compareAtPriceNew = compareAtPrice.replace("$", "");
            var priceNew = price.replace("$", "");
            var percentageSaved = (compareAtPriceNew - priceNew) / compareAtPriceNew * 100;
        }
    }, [
        price,
        compareAtPrice,
        discount,
        product
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "product-details flex flex-col md:pl-4 lg:pl-10 xl:pl-16",
        children: [
            !hideOptions && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductOptions, {
                product: product,
                selectedOptions: selectedOptions,
                selectedVariant: selectedVariant,
                setSelectedOptions: setSelectedOptions
            }),
            productType === "onetimeOnly" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                        className: "mb-6 mt-6 border-t border-t-[#DDE2E7] p-0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "product-details__product-description__wrap",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "product-details__product-description mb-5 [&_p]:!text-base",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Markdown */.UG, {
                                    className: "text-[#202635]",
                                    children: productDescription
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "product-details__features inline-flex flex-col gap-3",
                                children: productFeatures.map(function(feature, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "product-details__features-wrap inline-flex items-center text-[#202635] max-sm:text-xs",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                                className: "product-details__image mr-3",
                                                sizes: "48px",
                                                width: "24px",
                                                height: "24px",
                                                src: feature.productFeatureIcon.src,
                                                alt: feature.productFeatureIcon.alt
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: feature.featureDescription
                                            })
                                        ]
                                    }, index);
                                })
                            })
                        ]
                    })
                ]
            }),
            linkedProductGroups && linkedProductGroups.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "linked-product-groups",
                children: linkedProductGroups.map(function(group, groupIndex) {
                    var ref, ref1, ref2;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mb-6 ".concat((group === null || group === void 0 ? void 0 : group.linkedProducts) && (group === null || group === void 0 ? void 0 : (ref = group.linkedProducts) === null || ref === void 0 ? void 0 : ref.length) ? "mt-6 border-t border-t-[#DDE2E7]" : "", " border-b border-b-[#DDE2E7]  pb-6 pt-6"),
                        children: [
                            (group === null || group === void 0 ? void 0 : group.groupName) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "text-base font-normal uppercase leading-6",
                                children: group === null || group === void 0 ? void 0 : group.groupName
                            }),
                            (group === null || group === void 0 ? void 0 : group.linkedProducts) && (group === null || group === void 0 ? void 0 : (ref1 = group.linkedProducts) === null || ref1 === void 0 ? void 0 : ref1.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "pt-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "flex flex-wrap gap-2",
                                    children: group === null || group === void 0 ? void 0 : (ref2 = group.linkedProducts) === null || ref2 === void 0 ? void 0 : ref2.map(function(linkedProduct, linkedProductIndex) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductGroupItem, {
                                            product: linkedProduct
                                        }, "linked-product-".concat(linkedProductIndex));
                                    })
                                })
                            })
                        ]
                    }, "linked-product-group-".concat(groupIndex));
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                className: "mb-6 mt-6 border-t border-t-[#DDE2E7] p-0"
            }),
            productSubscriptionWidget && productType !== "onetimeOnly" && /*#__PURE__*/ (0,jsx_runtime.jsx)(RechargeSubscriptionWidget/* RechargeSubscriptionWidget */.N, {
                product: product,
                widgetContent: productSubscriptionWidget,
                widgetType: productType,
                originalDiscountPrice: price
            }),
            productType === "onetimeOnly" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                htmlFor: "purchase_type_one-time",
                className: "flex cursor-pointer items-center justify-between bg-[#E6F0F8] p-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                id: "purchase_type_one-time",
                                type: "radio",
                                name: "one_time_purchase",
                                className: " hidden",
                                value: "one-time"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mr-4 h-[20px] w-[20px] rounded-full border-[6px] border-textLink"
                            }),
                            "One-time purchase"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: comparePrice ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "price",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "mr-2 line-through opacity-50",
                                    children: comparePrice
                                }),
                                displayPrice
                            ]
                        }) : "".concat(displayPrice)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* AddToCart */.o4, {
                selectedVariant: selectedVariant,
                product: product,
                purchaseType: purchaseType,
                productType: productType,
                selectedSellingPlan: selectedSellingPlan,
                minPrice: displayPrice,
                discountCode: (discount === null || discount === void 0 ? void 0 : discount.enableDiscount) ? discount.discountCode : null
            }),
            (bottomBannerText || bottomBannerHeading) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-10 bg-[#F2F7FB] p-5 text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mb-2 text-lg",
                        children: bottomBannerHeading
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-sm",
                        children: bottomBannerText
                    })
                ]
            })
        ]
    });
}
ProductDetails.displayName = "ProductDetails";

// EXTERNAL MODULE: ./src/snippets/Okendo/OkendoStarRating.jsx
var OkendoStarRating = __webpack_require__(391);
;// CONCATENATED MODULE: ./src/sections/FeaturedProduct/ProductHeader.jsx








function ProductHeader(param) {
    var product = param.product, selectedVariant = param.selectedVariant, purchaseType = param.purchaseType, productType = param.productType, productBannerText = param.productBannerText, customSavePercentageText = param.customSavePercentageText;
    var ref;
    var discount = (0,globalProductPageContext/* useGlobalProductPageContext */.j)().discount;
    var ref1 = (0,hooks/* useVariantPrices */.be)({
        variant: selectedVariant,
        purchaseType: purchaseType,
        isPdp: true
    }), price = ref1.price, compareAtPrice = ref1.compareAtPrice;
    var ref2 = (0,react.useState)(price), displayPrice = ref2[0], setDisplayPrice = ref2[1];
    var ref3 = (0,react.useState)(compareAtPrice), displayComparePrice = ref3[0], setDisplayComparePrice = ref3[1];
    var ref4 = (0,react.useState)(compareAtPrice), savingsPercentage = ref4[0], setSavingsPercentage = ref4[1];
    (0,react.useEffect)(function() {
        if (!price) {
            return;
        }
        setDisplayPrice(price);
        setDisplayComparePrice(compareAtPrice);
        if (discount === null || discount === void 0 ? void 0 : discount.enableDiscount) {
            if (!compareAtPrice) {
                setDisplayComparePrice(price);
            }
            var discountPrice = parseFloat(price.replace("$", ""));
            if (discount.discountType === "fixed") {
                discountPrice -= discount.discountAmount;
            } else {
                discountPrice -= discountPrice * (discount.discountAmount / 100);
            }
            discountPrice = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD"
            }).format(discountPrice).replace(".00", "");
            setDisplayPrice(discountPrice);
            setSavingsPercentage("".concat(discount.discountAmount, "%"));
        } else if (compareAtPrice) {
            var compareAtPriceNew = compareAtPrice.replace("$", "");
            var priceNew = price.replace("$", "");
            var percentageSaved = (compareAtPriceNew - priceNew) / compareAtPriceNew * 100;
            setSavingsPercentage("".concat(percentageSaved, "%"));
        }
    }, [
        price,
        compareAtPrice,
        discount,
        product
    ]);
    var settings = (0,dist.useSettings)();
    var enabledStarRating = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.product) === null || ref === void 0 ? void 0 : ref.reviews).enabledStarRating;
    var ref5 = (0,react.useState)(false), hasReviews = ref5[0], setHasReviews = ref5[1];
    (0,react.useEffect)(function() {
        var metaFields = product === null || product === void 0 ? void 0 : product.metafields;
        metaFields === null || metaFields === void 0 ? void 0 : metaFields.forEach(function(metaField) {
            if (metaField.key === "ProductReviewsWidgetSnippet") {
                setHasReviews(true);
            }
        });
    }, [
        product
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "product-header text-primary md:pl-4 lg:pl-10 xl:pl-16",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-header__eyebrow mb-4 flex items-center gap-x-2 md:flex-row",
                children: enabledStarRating && hasReviews && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "product-header__ratings",
                    "aria-label": "Scroll to product reviews",
                    type: "button",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OkendoStarRating/* OkendoStarRating */.m, {
                        className: "[&_span]:text-[14px] [&_span]:font-light [&_span]:md:text-[20px]",
                        productId: product === null || product === void 0 ? void 0 : product.legacyResourceId
                    })
                })
            }),
            (product === null || product === void 0 ? void 0 : product.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                element: "h1",
                variant: "h3",
                className: "product-header__title mb-6",
                children: product.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "product-header__price-container mt-2 flex min-h-[1.5rem] gap-2 text-[20px] ".concat(productType === "featured" || productType === "onetimeOnly" ? "justify-between" : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "product-header__pricing flex gap-2",
                        children: [
                            displayComparePrice && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "product-header__compare-price text-mediumGray line-through",
                                children: displayComparePrice
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "product-header__price",
                                children: displayPrice
                            })
                        ]
                    }),
                    productType && displayComparePrice && price && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-sm uppercase text-[#0064B7] text-right font-mono",
                        children: customSavePercentageText ? customSavePercentageText.replace(/(\{\{\s?amount\s?\}\})/gi, savingsPercentage) : "Save ".concat(savingsPercentage).concat(productType === "featured" ? " w/ subscription!" : "!")
                    })
                ]
            }),
            [
                "featured",
                "onetimeOnly"
            ].includes(productType) && productBannerText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-header__banner mt-6 bg-[linear-gradient(270.3deg,_rgba(33,_121,_194,_0.25)_0%,_rgba(141,_206,_249,_0.25)_51.04%,_rgba(241,_220,_193,_0.25)_100%)] p-2 text-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: productBannerText
                })
            })
        ]
    });
}
ProductHeader.displayName = "ProductHeader";

;// CONCATENATED MODULE: ./src/sections/FeaturedProduct/ProductMedia/ProductImage.jsx


function ProductImage(param) {
    var media = param.media, priority = param.priority;
    var image = media.image, product = media.product;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative aspect-square bg-[#E6F0F8] lg:aspect-[893/595]",
        children: (image === null || image === void 0 ? void 0 : image.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
            alt: product.title,
            fill: true,
            priority: priority,
            className: "!object-contain mix-blend-multiply",
            sizes: "(min-width: 1440px) 900px, (min-width: 768px) 50vw, 100vw",
            src: image.src,
            // IMPORTANT: for naturally large, high resolution images from Shopify,
            // reduce quality back to the default 75 for better page performance
            quality: 90
        })
    });
}
ProductImage.displayName = "ProductImage";

// EXTERNAL MODULE: ./src/contexts/index.js + 1 modules
var contexts = __webpack_require__(8249);
;// CONCATENATED MODULE: ./src/sections/FeaturedProduct/ProductMedia/ProductMediaThumbnails.jsx




function ProductMediaThumbnails(param) {
    var activeIndex = param.activeIndex, selectedMedia = param.selectedMedia, swiper = param.swiper;
    var ref = (0,contexts/* useGlobalContext */.b)(), openModal = ref.actions.openModal;
    var handleModal = function() {
        var imageSrc = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, videoSources = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        // example modal
        openModal(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "p-6",
                children: [
                    imageSrc && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "modal-image-wrapper relative flex aspect-video h-[40rem] w-full max-w-[1200px] items-center justify-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                            alt: "Image Preview",
                            fill: true,
                            sizes: "(min-width: 1440px) 900px, (min-width: 768px) 50vw, 100vw",
                            className: "!object-contain mix-blend-multiply",
                            src: imageSrc
                        })
                    }),
                    videoSources && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "modal-video-wrapper",
                        children: videoSources.map(function(source) {
                            if ((source === null || source === void 0 ? void 0 : source.format) === "mp4") {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                    autoPlay: true,
                                    playsInline: true,
                                    className: "h-full w-full object-cover",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                        src: source === null || source === void 0 ? void 0 : source.url,
                                        type: "video/mp4"
                                    })
                                });
                            }
                            return null;
                        })
                    })
                ]
            })
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: "grid grid-cols-2 gap-8",
        children: selectedMedia === null || selectedMedia === void 0 ? void 0 : selectedMedia.map(function(param, index) {
            var id = param.id, mediaContentType = param.mediaContentType, preview = param.preview, product = param.product, sources = param.sources;
            var ref, ref1;
            var previewSrc = preview === null || preview === void 0 ? void 0 : (ref = preview.image) === null || ref === void 0 ? void 0 : ref.previewSrc;
            var videoClasses = mediaContentType === "VIDEO" ? "col-span-2" : "";
            var firstClasses = index === 0 ? "md:hidden" : "";
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "".concat(videoClasses, " ").concat(firstClasses),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    "aria-label": "Slide to product image ".concat(index + 1),
                    className: "relative flex h-full w-full items-center justify-center overflow-hidden bg-[#E6F0F8] transition\n                ".concat(mediaContentType === "VIDEO" ? "aspect-[893/595]" : "aspect-square", "\n                "),
                    onClick: function() {
                        if (mediaContentType !== "VIDEO" && previewSrc) {
                            var ref;
                            handleModal(preview === null || preview === void 0 ? void 0 : (ref = preview.image) === null || ref === void 0 ? void 0 : ref.src);
                        } else handleModal(null, sources);
                        swiper.slideTo(index);
                    },
                    type: "button",
                    children: [
                        previewSrc && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                            alt: product.title,
                            fill: true,
                            className: " ".concat(mediaContentType === "VIDEO" ? "" : "!object-contain !mix-blend-multiply"),
                            sizes: "(min-width: 1440px) 500px, (min-width: 768px) 50vw, 100vw",
                            priority: index < 2,
                            src: preview === null || preview === void 0 ? void 0 : (ref1 = preview.image) === null || ref1 === void 0 ? void 0 : ref1.src
                        }),
                        mediaContentType === "VIDEO" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute bottom-[30px] right-[30px] flex h-[47px] w-[47px] items-center justify-center rounded-full bg-gradient-to-t from-[#8DCEF9] to-[#C1EFFA]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex h-full w-full scale-95 items-center justify-center rounded-full bg-white",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                                    className: "w-[14px] text-textLink",
                                    src: "/svgs/play.svg#play",
                                    title: "Play",
                                    viewBox: "0 0 24 24"
                                })
                            })
                        })
                    ]
                })
            }, id);
        })
    });
}
ProductMediaThumbnails.displayName = "ProductMediaThumbnails";

// EXTERNAL MODULE: ../node_modules/react-intersection-observer/index.mjs
var react_intersection_observer = __webpack_require__(205);
;// CONCATENATED MODULE: ./src/sections/FeaturedProduct/ProductMedia/ProductVideo.jsx



function ProductVideo(param) {
    var media = param.media;
    var ref;
    var videoRef = (0,react.useRef)(null);
    var ref1 = (0,react_intersection_observer/* useInView */.YD)({
        threshold: 0
    }), ref2 = ref1.ref, inView = ref1.inView;
    var sources = media.sources, preview = media.preview;
    var videoSources = sources === null || sources === void 0 ? void 0 : sources.filter(function(param) {
        var mimeType = param.mimeType;
        return mimeType === "video/mp4";
    });
    (0,react.useEffect)(function() {
        if (inView) {
            videoRef.current.play();
        } else {
            videoRef.current.pause();
        }
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: ref2,
        className: "flex aspect-square items-center justify-center bg-[#E6F0F8] lg:aspect-[893/595]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
            ref: videoRef,
            muted: true,
            playsInline: true,
            loop: true,
            controls: false,
            poster: preview === null || preview === void 0 ? void 0 : (ref = preview.image) === null || ref === void 0 ? void 0 : ref.src,
            className: "w-full",
            children: inView && (videoSources === null || videoSources === void 0 ? void 0 : videoSources.length) ? videoSources.map(function(source) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    src: source.url,
                    type: source.mimeType
                }, source.url);
            }) : null
        })
    });
}
ProductVideo.displayName = "ProductVideo";

;// CONCATENATED MODULE: ./src/sections/FeaturedProduct/ProductMedia/ProductMedia.jsx








function ProductMedia(param) {
    var selectedMedia = param.selectedMedia, selectedVariant = param.selectedVariant;
    var ref, ref1;
    var ref2 = (0,react.useState)(null), swiper = ref2[0], setSwiper = ref2[1];
    var ref3 = (0,react.useState)(null), activeIndex = ref3[0], setActiveIndex = ref3[1];
    // Reset the active index when the selected color changes
    (0,react.useEffect)(function() {
        if (!swiper) return;
        setActiveIndex(0);
        swiper === null || swiper === void 0 ? void 0 : swiper.slideTo(0);
    }, [
        selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.selectedOptionsMap) === null || ref === void 0 ? void 0 : ref.Color,
        swiper
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grid grid-cols-1 justify-between gap-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "order-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative bg-[#E6F0F8]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                            onSwiper: setSwiper,
                            modules: [
                                modules/* A11y */.s5,
                                modules/* Pagination */.tl
                            ],
                            onSlideChange: function(_swiper) {
                                setActiveIndex(_swiper.realIndex);
                            },
                            slidesPerView: 1,
                            grabCursor: true,
                            lazy: {
                                loadPrevNext: true
                            },
                            pagination: {
                                el: ".swiper-pagination",
                                clickable: true
                            },
                            className: "max-md:!pb-5 md:pb-0 [&_.swiper-wrapper]:flex [&_.swiper-wrapper]:items-center",
                            children: [
                                selectedMedia === null || selectedMedia === void 0 ? void 0 : selectedMedia.map(function(media, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "p-12",
                                            children: media.mediaContentType === "VIDEO" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductVideo, {
                                                media: media
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImage, {
                                                media: media,
                                                priority: index === 0
                                            })
                                        })
                                    }, media.id);
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "active-bullet-black swiper-pagination bottom-[25px] flex w-full justify-center gap-2.5 pb-4 pt-4 mix-blend-multiply md:hidden"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "pointer-events-none absolute left-0 top-0 z-[1] p-2.5 xs:p-4 md:p-3 xl:p-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Badges */.a9, {
                                tags: selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref1 = selectedVariant.product) === null || ref1 === void 0 ? void 0 : ref1.tags
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative order-1 hidden w-full overflow-x-auto scrollbar-hide md:block ",
                children: (selectedMedia === null || selectedMedia === void 0 ? void 0 : selectedMedia.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductMediaThumbnails, {
                    activeIndex: activeIndex,
                    selectedMedia: selectedMedia,
                    setActiveIndex: setActiveIndex,
                    swiper: swiper
                })
            })
        ]
    });
}
ProductMedia.displayName = "ProductMedia";

;// CONCATENATED MODULE: ./src/sections/FeaturedProduct/ProductMedia/index.js


;// CONCATENATED MODULE: ./src/sections/FeaturedProduct/FeaturedProduct.jsx











function FeaturedProduct(param) {
    var cms = param.cms;
    var ref = (0,_object_spread/* default */.Z)({}, cms), discount = ref.discount, featuredProduct = ref.featuredProduct, linkedProductGroups = ref.linkedProductGroups, productBannerText = ref.productBannerText, bottomBannerText = ref.bottomBannerText, bottomBannerHeading = ref.bottomBannerHeading, productDisplayType = ref.productDisplayType, productDescription = ref.productDescription, productFeatures = ref.productFeatures, sectionId = ref.sectionId, customSavePercentageText = ref.customSavePercentageText;
    var handle = featuredProduct === null || featuredProduct === void 0 ? void 0 : featuredProduct.handle;
    var product = (0,dist.useProductByHandle)({
        handle: handle
    }).product;
    var ref1 = (0,react.useState)(null), recommendedFilterFrequency = ref1[0], setRecommendedFilterFrequency = ref1[1];
    var ref2 = (0,react.useState)(null), selectedSellingPlan = ref2[0], setSelectedSellingPlan = ref2[1];
    var ref3 = (0,react.useState)(null), purchaseType = ref3[0], setPurchaseType = ref3[1];
    var ref4 = (0,react.useState)(product), selectedProduct = ref4[0], setSelectedProduct = ref4[1];
    var productSubscriptionWidget = (0,hooks/* useSubscriptionWidget */.FG)(selectedProduct).productSubscriptionWidget;
    var ref5 = (0,react.useState)(null), selectedVariant = ref5[0], setSelectedVariant = ref5[1];
    var ref6 = (0,react.useState)(null), selectedOptions = ref6[0], setSelectedOptions = ref6[1];
    var ref7 = (0,react.useState)(null), productByline = ref7[0], setProductByline = ref7[1];
    var ref8 = (0,react.useState)(product === null || product === void 0 ? void 0 : product.media), productMedia = ref8[0], setProductMedia = ref8[1];
    (0,react.useEffect)(function() {
        if (product) {
            setSelectedProduct(product);
        }
    }, [
        product
    ]);
    (0,react.useEffect)(function() {
        if (selectedProduct) {
            var ref;
            setSelectedOptions((ref = selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.variants[0]) === null || ref === void 0 ? void 0 : ref.selectedOptionsMap);
            if (productDisplayType === "onetimeOnly") {
                setPurchaseType("one-time");
            } else {
                setPurchaseType((selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.sellingPlanGroupCount) > 0 ? "subscription" : "one-time");
            }
        }
    }, [
        selectedProduct
    ]);
    (0,react.useEffect)(function() {
        if (!(product === null || product === void 0 ? void 0 : product.variants)) return;
        // set selected variant from selected options unless has one variant
        var selectedVariantFromOptions = product.variants.find(function(param) {
            var selectedOptionsMap = param.selectedOptionsMap;
            return fast_deep_equal_default()(selectedOptions, selectedOptionsMap);
        });
        setSelectedVariant(selectedVariantFromOptions || null);
    }, [
        selectedOptions
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (!selectedVariant) return;
        // set selected media from selected options
        var options = Object.keys(product.optionsMap || {});
        var optionNames = options.map(function(option) {
            return product.optionsMap[option];
        }).flat().map(function(option) {
            return option.toLowerCase();
        });
        setProductMedia((ref = product.media) === null || ref === void 0 ? void 0 : ref.map(function(media) {
            if (!optionNames.includes(media.alt.toLowerCase())) return media;
            if (media.alt.toLowerCase() === (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.title.toLowerCase())) return media;
            return null;
        }).filter(function(media) {
            return media;
        }));
    }, [
        selectedVariant
    ]);
    var stickyTopClass = "md:top-[calc(var(--header-height)+2.5rem)] xl:top-[calc(var(--header-height)+3rem)]";
    var globalProductData = (0,react.useMemo)(function() {
        return {
            discount: discount,
            selectedProduct: selectedProduct,
            selectedSellingPlan: selectedSellingPlan,
            setSelectedSellingPlan: setSelectedSellingPlan,
            setSelectedProduct: setSelectedProduct,
            purchaseType: purchaseType,
            setPurchaseType: setPurchaseType,
            recommendedFilterFrequency: recommendedFilterFrequency,
            setRecommendedFilterFrequency: setRecommendedFilterFrequency,
            selectedVariant: selectedVariant,
            productSubscriptionWidget: productSubscriptionWidget,
            productByline: productByline,
            setProductByline: setProductByline
        };
    }, [
        discount,
        selectedProduct,
        selectedSellingPlan,
        purchaseType,
        recommendedFilterFrequency,
        selectedVariant,
        productSubscriptionWidget,
        productByline, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(globalProductPageContext/* GlobalProductPageContext.Provider */.n.Provider, {
        value: globalProductData,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            id: sectionId,
            className: "featured-product px-contained bg-white py-[32px] md:py-[62px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product__top-section md:px-contained mt-4 max-w-[var(--content-max-width)] md:mx-auto md:pb-12",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mx-auto flex flex-col md:flex-row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "product__media-section order-0 mb-6 md:mb-0 md:flex-[0_0_50%] xl:flex-[0_0_55%]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "md:sticky ".concat(stickyTopClass),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductMedia, {
                                    selectedMedia: productMedia,
                                    selectedVariant: selectedVariant,
                                    product: selectedProduct
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "product__details-section relative z-10 order-1 px-4 md:flex-[0_0_50%] xl:flex-[0_0_45%]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col md:sticky ".concat(stickyTopClass),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductHeader, {
                                        selectedSellingPlan: selectedSellingPlan,
                                        purchaseType: purchaseType,
                                        product: selectedProduct,
                                        selectedVariant: selectedVariant,
                                        productType: productDisplayType,
                                        productBannerText: productBannerText,
                                        customSavePercentageText: customSavePercentageText
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetails, {
                                        product: selectedProduct,
                                        linkedProductGroups: linkedProductGroups,
                                        selectedOptions: selectedOptions,
                                        selectedVariant: selectedVariant,
                                        productType: productDisplayType,
                                        setSelectedOptions: setSelectedOptions,
                                        productDescription: productDescription,
                                        productFeatures: productFeatures,
                                        discount: discount,
                                        bottomBannerText: bottomBannerText,
                                        bottomBannerHeading: bottomBannerHeading
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
}
FeaturedProduct.Schema = FeaturedProduct_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/FeaturedProduct/index.js


;// CONCATENATED MODULE: ./src/sections/FeaturedProducts/FeaturedProducts.schema.js
var FeaturedProducts_schema_Schema = function() {
    return {
        category: "Product",
        label: "Featured Products",
        key: "featuredProducts",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/featured-products.png?v=1685571408",
        fields: [
            {
                name: "sectionTitle",
                component: "text",
                label: "Section Title",
                defaultValue: "Featured Products"
            },
            {
                name: "sectionLink",
                component: "link",
                label: "Section Link"
            },
            {
                name: "featuredProducts",
                component: "group-list",
                label: "Featured Products",
                itemProps: {
                    label: "{{item.featuredProduct.title}}"
                },
                validate: {
                    maxItems: 4
                },
                fields: [
                    {
                        label: "Featured Product",
                        component: "productSearch",
                        name: "featuredProduct"
                    }, 
                ]
            }, 
        ]
    };
};

;// CONCATENATED MODULE: ./src/sections/FeaturedProducts/FeaturedProducts.jsx




function FeaturedProducts(param) {
    var cms = param.cms;
    var ref = (0,_object_spread/* default */.Z)({}, cms), sectionTitle = ref.sectionTitle, sectionLink = ref.sectionLink, featuredProducts = ref.featuredProducts;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "featured-products px-contained py-[32px] md:py-[62px]",
        children: [
            /* Section Header */ (sectionTitle || (sectionLink === null || sectionLink === void 0 ? void 0 : sectionLink.url)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "featured-products__header flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                        element: "h3",
                        variant: "h3",
                        className: "title",
                        children: sectionTitle
                    }),
                    (sectionLink === null || sectionLink === void 0 ? void 0 : sectionLink.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                        "aria-label": sectionLink === null || sectionLink === void 0 ? void 0 : sectionLink.text,
                        href: sectionLink === null || sectionLink === void 0 ? void 0 : sectionLink.url,
                        newTab: sectionLink === null || sectionLink === void 0 ? void 0 : sectionLink.newTab,
                        tabIndex: "-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Button */.zx, {
                            theme: "dark",
                            variant: "outlined",
                            children: sectionLink === null || sectionLink === void 0 ? void 0 : sectionLink.text
                        })
                    })
                ]
            }),
            /* Featured Products */ (featuredProducts === null || featuredProducts === void 0 ? void 0 : featuredProducts.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "featured-products__grid mt-[53px] grid grid-cols-2 gap-[18px] lg:grid-cols-4",
                children: featuredProducts.map(function(featuredProduct, index) {
                    var ref;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* ProductItem */.Cd, {
                            enabledColorSelector: true,
                            enabledQuickShop: false,
                            enabledStarRating: true,
                            handle: featuredProduct === null || featuredProduct === void 0 ? void 0 : (ref = featuredProduct.featuredProduct) === null || ref === void 0 ? void 0 : ref.handle,
                            index: index
                        })
                    }, "product-grid-item-".concat(index));
                })
            })
        ]
    });
}
FeaturedProducts.displayName = "FeaturedProducts";
FeaturedProducts.Schema = FeaturedProducts_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/FeaturedProducts/index.js


;// CONCATENATED MODULE: ./src/sections/FiftyFiftyImage/FiftyFiftyImage.schema.js
function FiftyFiftyImage_schema_Schema() {
    return {
        category: "Image",
        label: "Fifty Fifty Image",
        key: "fiftyFiftyImage",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/Screen_20Shot_202023-05-23_20at_2010.45.53_20AM.png?v=1684864558",
        fields: [
            {
                label: "Image Flipped",
                name: "imageFlipped",
                component: "toggle",
                toggleLabels: {
                    true: "On",
                    false: "Off"
                },
                defaultValue: false
            },
            {
                label: "Dark Mode",
                name: "darkMode",
                description: "Set The Background dark and text white",
                component: "toggle",
                defaultValue: false
            },
            {
                label: "Image",
                name: "image",
                component: "image"
            },
            {
                label: "Video URL",
                name: "videoUrl",
                component: "text",
                description: "Replaces the image with a video if set"
            },
            {
                label: "Image Eyebrow",
                name: "imageEyebrow",
                component: "text",
                defaultValue: "EFFECTIVELY REMOVES"
            },
            {
                label: "Image Heading",
                name: "imageHeading",
                component: "text",
                defaultValue: "99% of 220 contaminants"
            },
            {
                label: "Eyebrow",
                name: "eyebrow",
                component: "text",
                defaultValue: "Our Technology"
            },
            {
                label: "Heading",
                name: "heading",
                component: "text",
                defaultValue: "The most powerful filtration media on the planet."
            },
            {
                label: "Copy",
                name: "copy",
                component: "text",
                defaultValue: "Traditionally, water pitchers have not been serious filtration devices. The Clearly Filtered\xae Water Pitcher with Affinity\xae Filtration Technology changes everything, removing up to 99.9% of 365+ harmful and dangerous tap water contaminants. That’s more than the 3 leading brand name pitchers combined."
            },
            {
                label: "CTA Copy",
                name: "ctaCopy",
                component: "text",
                defaultValue: "Our Technology"
            },
            {
                label: "CTA Url",
                name: "ctaUrl",
                component: "text",
                defaultValue: "#"
            },
            {
                label: "CTA Theme",
                name: "ctaTheme",
                component: "select",
                defaultValue: "primary",
                options: [
                    {
                        label: "Primary",
                        value: "primary"
                    },
                    {
                        label: "Secondary",
                        value: "secondary"
                    },
                    {
                        label: "Light",
                        value: "light"
                    },
                    {
                        label: "Dark",
                        value: "dark"
                    }, 
                ]
            },
            {
                label: "CTA Variant",
                name: "ctaVariant",
                component: "select",
                defaultValue: "outlined",
                options: [
                    {
                        label: "Outlined",
                        value: "outlined"
                    },
                    {
                        label: "Filled",
                        value: "filled"
                    }, 
                ]
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/FiftyFiftyImage/FiftyFiftyImage.jsx






function FiftyFiftyImage(param) {
    var cms = param.cms;
    var imageFlipped = cms.imageFlipped, darkMode = cms.darkMode, heading = cms.heading, eyebrow = cms.eyebrow, copy = cms.copy, ctaCopy = cms.ctaCopy, ctaUrl = cms.ctaUrl, image = cms.image, videoUrl = cms.videoUrl, imageEyebrow = cms.imageEyebrow, imageHeading = cms.imageHeading, ctaVariant = cms.ctaVariant, ctaTheme = cms.ctaTheme;
    var textColor = "text-[#202635]";
    var bgColor = "bg-white";
    var buttonTheme = "primary";
    if (darkMode) {
        textColor = "text-[#fff]";
        bgColor = "bg-[#202635]";
        buttonTheme = "light";
    }
    var isMobile = utils_useMediaQuery("(max-width: 767px)");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative ".concat(bgColor),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "px-contained items-center overflow-hidden py-12 lg:flex lg:py-24 ".concat(imageFlipped ? "flex-row-reverse" : null),
            children: [
                (image || videoUrl) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative flex aspect-square items-center justify-center lg:w-1/2",
                    children: [
                        videoUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                            className: "absolute inset-0 h-full w-full object-cover object-center",
                            autoPlay: true,
                            loop: true,
                            muted: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                src: videoUrl,
                                type: "video/mp4"
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                            className: "absolute inset-0 h-full w-full object-cover object-center",
                            sizes: "48px",
                            width: "820px",
                            height: "725px",
                            src: image.src
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative w-full p-4 text-center",
                            children: [
                                imageEyebrow && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Eyebrow */.j4, {
                                    className: "mb-4 text-[12px] uppercase text-white md:text-[16px]",
                                    children: imageEyebrow
                                }),
                                imageHeading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mx-auto max-w-[180px] rounded-[100px] border border-white p-2 text-[22px] font-light leading-none text-white md:max-w-[310px] md:text-[42px]",
                                    children: imageHeading
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "lg:w-1/2  ".concat(imageFlipped ? "lg:pr-24" : "max-sm:pt-4 lg:pl-24"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Eyebrow */.j4, {
                            className: "mb-4 ".concat(textColor),
                            children: eyebrow
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                            variant: isMobile ? "h4" : "h3",
                            className: "".concat(textColor),
                            element: "h3",
                            children: heading
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Body */.uT, {
                            variant: "medium",
                            className: "mx-auto mb-6 mt-6 lg:mb-12 ".concat(textColor),
                            children: copy
                        }),
                        ctaCopy && ctaUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-0 lg:mt-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                href: ctaUrl,
                                theme: ctaTheme || buttonTheme,
                                variant: ctaVariant || "outlined",
                                children: ctaCopy
                            })
                        })
                    ]
                })
            ]
        })
    });
}
FiftyFiftyImage.displayName = "Fifty Fifty Image";
FiftyFiftyImage.Schema = FiftyFiftyImage_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/FiftyFiftyImage/index.js


;// CONCATENATED MODULE: ./src/utils/schemas/button-link.js
var buttonLink = [
    {
        label: "Link",
        name: "link",
        component: "link"
    },
    {
        label: "Button Theme",
        name: "theme",
        component: "select",
        options: [
            {
                label: "Primary",
                value: "primary"
            },
            {
                label: "Secondary",
                value: "secondary"
            },
            {
                label: "Light",
                value: "light"
            }, 
        ]
    },
    {
        label: "Button Variant",
        name: "variant",
        component: "select",
        options: [
            {
                label: "Filled",
                value: "filled"
            },
            {
                label: "Outlined",
                value: "outlined"
            }, 
        ]
    }, 
];
/* harmony default export */ var button_link = (buttonLink);

;// CONCATENATED MODULE: ./src/sections/FiltrationTechnology/FiltrationTechnology.schema.js

var videoPreviewSettings = {
    label: "Video Preview Settings",
    name: "videoPreviewSettings",
    component: "group",
    description: "video preview image, cta",
    fields: [
        {
            component: "image",
            name: "image",
            label: "Video Image Thumbnail"
        },
        {
            component: "text",
            name: "ctaText",
            label: "Call to Action Text",
            defaultValue: "See it in action"
        }, 
    ]
};
var modalSettings = {
    label: "Modal Settings",
    name: "modalSettings",
    component: "group",
    description: "modal title, video url, cta, etc.",
    fields: [
        {
            label: "Eyebrow Text",
            name: "eyebrowText",
            component: "text"
        },
        {
            label: "Heading",
            name: "heading",
            component: "text"
        },
        {
            label: "Video URL",
            name: "videoUrl",
            component: "text"
        },
        {
            label: "Video Background",
            name: "videoBackground",
            component: "image",
            description: "Used as a placeholder when the video isn't playing"
        },
        {
            component: "markdown",
            name: "content",
            label: "Content",
            description: "Content to display under video",
            defaultValue: "# In its simplest form, Affinity Filtration Technology leverages 2 cutting-edge components:"
        },
        {
            label: "Call to Action Buttons",
            name: "ctas",
            component: "group-list",
            description: "Max of two buttons",
            itemProps: {
                label: "{{item.link.text}}"
            },
            defaultItem: {
                link: {
                    text: "How Our Technology Works",
                    url: ""
                },
                theme: "primary",
                variant: "filled"
            },
            validate: {
                maxItems: 2
            },
            fields: button_link
        }, 
    ]
};
var callouts = {
    component: "group-list",
    name: "callouts",
    label: "Callouts",
    description: "Callout items under section",
    fields: [
        {
            component: "image",
            name: "image",
            label: "SVG Image Icon"
        },
        {
            component: "text",
            name: "heading",
            label: "Heading"
        },
        {
            component: "textarea",
            name: "content",
            label: "Content"
        }, 
    ],
    defaultValue: [
        {
            image: {
                src: "https://cdn.shopify.com/s/files/1/1011/0318/files/Vector-1.svg?v=1684456136"
            },
            heading: "Contaminant Magnet",
            content: "Our filter targets more contaminants than the 3 leading brand name water pitchers combined."
        },
        {
            image: {
                src: "https://cdn.shopify.com/s/files/1/1011/0318/files/Vector-1.svg?v=1684456136"
            },
            heading: "Targets 365+ Contaminants",
            content: "Our filter targets more contaminants than the 3 leading brand name water pitchers combined."
        },
        {
            image: {
                src: "https://cdn.shopify.com/s/files/1/1011/0318/files/Vector-1.svg?v=1684456136"
            },
            heading: "Contaminant Magnet",
            content: "Our filter targets more contaminants than the 3 leading brand name water pitchers combined."
        }, 
    ]
};
function FiltrationTechnology_schema_Schema() {
    return {
        label: "Filtration Technology",
        key: "filtration-technology",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/filtration_technology.png?v=1686314381",
        category: "Content",
        fields: [
            {
                component: "image",
                name: "backgroundImage",
                label: "Background Image"
            },
            {
                label: "Background Video URL",
                name: "backgroundVideoUrl",
                component: "text"
            },
            {
                label: "Eyebrow Text",
                name: "eyebrowText",
                component: "text",
                defaultValue: "Affinity Filtration Technology"
            },
            {
                label: "Heading",
                name: "heading",
                component: "text",
                defaultValue: "Advanced filters that set a new standard"
            },
            {
                label: "Subheading",
                name: "subheading",
                component: "textarea",
                defaultValue: "Our breakthrough filtration technology targets up to 73x more dangerous chemicals, contaminants, & toxins than typical carbon filters."
            },
            {
                label: "Call to Action Buttons",
                name: "ctas",
                component: "group-list",
                description: "Max of two buttons",
                itemProps: {
                    label: "{{item.link.text}}"
                },
                defaultItem: {
                    link: {
                        text: "Our Technology",
                        url: ""
                    },
                    theme: "primary",
                    variant: "filled"
                },
                validate: {
                    maxItems: 2
                },
                fields: button_link
            },
            {
                component: "image",
                name: "image",
                label: "Image",
                description: "Image to display in middle of this section"
            },
            videoPreviewSettings,
            modalSettings,
            callouts, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/FiltrationTechnology/FiltrationTechnologyVideo.jsx
/* eslint-disable jsx-a11y/media-has-caption */ 

function FiltrationTechnologyVideo(param) {
    var videoUrl = param.videoUrl, muted = param.muted, loop = param.loop, playsInline = param.playsInline, className = param.className, controls = param.controls, poster = param.poster;
    if (videoUrl === null || videoUrl === void 0 ? void 0 : videoUrl.includes("vimeo")) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Vimeo, {
        responsive: true,
        height: "auto",
        video: videoUrl,
        loop: loop,
        muted: muted,
        className: className,
        controls: controls,
        background: true
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
        poster: poster,
        src: videoUrl,
        loop: loop,
        muted: muted,
        playsInline: playsInline,
        className: className,
        controls: controls
    });
}

;// CONCATENATED MODULE: ./src/sections/FiltrationTechnology/FiltrationTechnologyDrawer.jsx






function FiltrationTechnologyDrawer(param) {
    var content = param.content, className = param.className;
    var ref, ref1;
    var isMobile = utils_useMediaQuery("(max-width: 767px)");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat(className),
        children: [
            (content === null || content === void 0 ? void 0 : content.eyebrowText) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Eyebrow */.j4, {
                className: "mb-3",
                children: content.eyebrowText
            }),
            (content === null || content === void 0 ? void 0 : content.heading) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                variant: isMobile ? "h4" : "h3",
                className: "mb-4",
                children: content === null || content === void 0 ? void 0 : content.heading
            }),
            (content === null || content === void 0 ? void 0 : content.videoUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative mb-10 aspect-video",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FiltrationTechnologyVideo, {
                    poster: content === null || content === void 0 ? void 0 : (ref = content.videoBackground) === null || ref === void 0 ? void 0 : ref.src,
                    videoUrl: content === null || content === void 0 ? void 0 : content.videoUrl,
                    controls: true,
                    playsInline: true,
                    className: "absolute inset-0 block h-full w-full object-cover ".concat(className)
                })
            }),
            (content === null || content === void 0 ? void 0 : content.content) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-sm",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Markdown */.UG, {
                    children: content === null || content === void 0 ? void 0 : content.content
                })
            }),
            (content === null || content === void 0 ? void 0 : content.ctas) && (content === null || content === void 0 ? void 0 : (ref1 = content.ctas) === null || ref1 === void 0 ? void 0 : ref1.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-6",
                children: content.ctas.map(function(cta, index) {
                    if ("link" in cta) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            href: cta.link.url,
                            variant: cta.variant,
                            theme: cta.theme,
                            children: cta.link.text
                        }, index);
                    }
                    return null;
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/sections/FiltrationTechnology/FiltrationTechnologyVideoPreview.jsx


function FiltrationTechnologyVideoPreview(param) {
    var content = param.content;
    var _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative cursor-pointer overflow-hidden rounded-2xl",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute inset-0 h-full w-full bg-gradient-to-b from-[#00000000] to-[#000000CC]"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                src: content.image.src,
                alt: (_alt = content.image.alt) !== null && _alt !== void 0 ? _alt : "Filtration Technology Video Preview",
                width: 350,
                height: 200
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "absolute bottom-5 left-0 flex w-full justify-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "mr-3",
                        children: content.ctaText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                        className: "h-[26px] w-[26px] text-text",
                        src: "/svgs/play-2.svg#play-2",
                        title: "Close",
                        viewBox: "0 0 26 26"
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/sections/FiltrationTechnology/FiltrationTechnology.jsx











function FiltrationTechnology(param) {
    var cms = param.cms;
    var backgroundImage = cms.backgroundImage, eyebrowText = cms.eyebrowText, heading = cms.heading, subheading = cms.subheading, ctas = cms.ctas, image = cms.image, videoPreviewSettings = cms.videoPreviewSettings, modalSettings = cms.modalSettings, callouts = cms.callouts, backgroundVideoUrl = cms.backgroundVideoUrl;
    var ref = (0,contexts/* useGlobalContext */.b)(), openDrawer = ref.actions.openDrawer;
    var openVideoModal = (0,react.useCallback)(function() {
        openDrawer(/*#__PURE__*/ (0,jsx_runtime.jsx)(FiltrationTechnologyDrawer, {
            content: modalSettings
        }));
    }, []);
    var _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-gradient relative bg-gradient-to-t from-[#050b1b] to-[#2e436c]",
        children: [
            backgroundVideoUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute inset-0 z-[1]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                    src: backgroundVideoUrl,
                    autoPlay: true,
                    loop: true,
                    muted: true,
                    playsInline: true,
                    className: "h-full w-full object-cover"
                })
            }),
            !backgroundVideoUrl && backgroundImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-content absolute inset-0 z-[1] h-full w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                    src: backgroundImage.src,
                    alt: backgroundImage.alt,
                    width: 1440,
                    height: 870,
                    className: "hidden h-full w-full object-cover md:block"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative z-[2] py-20 pt-[8px] text-white",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "px-contained relative mx-auto flex max-w-[--var(content-max-width)] flex-col gap-10 pt-20",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col items-center text-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Eyebrow */.j4, {
                                        className: "mb-3",
                                        children: eyebrowText
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                                        variant: "h3",
                                        className: "mb-4 max-lg:text-[30px]",
                                        children: heading
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "max-w-3xl",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Body */.uT, {
                                            variant: "medium",
                                            className: "max-lg:text-[16px]",
                                            children: subheading
                                        })
                                    })
                                ]
                            }),
                            ctas && ctas.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex justify-center gap-5",
                                children: ctas.map(function(cta, index) {
                                    if ("link" in cta) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            href: cta.link.url,
                                            variant: cta.variant,
                                            theme: cta.theme,
                                            children: cta.link.text
                                        }, index);
                                    }
                                    return null;
                                })
                            }),
                            image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mx-auto flex max-w-[386px] justify-center px-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "".concat(image.src, "&width=400&quality=60"),
                                    alt: (_alt = image.alt) !== null && _alt !== void 0 ? _alt : "Filtration Technology Image",
                                    width: 400,
                                    height: 400,
                                    loading: "lazy"
                                })
                            }),
                            videoPreviewSettings && videoPreviewSettings.image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "px-4 md:absolute md:bottom-4",
                                onClick: openVideoModal,
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FiltrationTechnologyVideoPreview, {
                                    content: videoPreviewSettings
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                        className: "my-9 opacity-20"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "px-contained relative mx-auto max-w-[var(--content-max-width)] text-center md:text-left",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                modules: [
                                    modules/* Pagination */.tl
                                ],
                                slidesPerView: 1,
                                pagination: {
                                    clickable: true,
                                    el: "#slider-nav",
                                    type: "bullets",
                                    renderBullet: function renderBullet(_, className) {
                                        return '<span class="'.concat(className, '" style="background-color: #FFFFFF"></span>');
                                    }
                                },
                                breakpoints: {
                                    768: {
                                        slidesPerView: 2
                                    },
                                    1024: {
                                        slidesPerView: 3
                                    }
                                },
                                children: callouts.map(function(callout, index) {
                                    var _alt;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                        className: "[&:first-child>.callout]:border-l-0 ",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "callout border-l-[#FFFFFF33] px-[25px] md:px-[50px] lg:border-l",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "callout__image mx-auto mb-6 inline-block lg:mx-0",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                                        src: callout.image.src,
                                                        alt: (_alt = callout.image.alt) !== null && _alt !== void 0 ? _alt : "Filtration Technology Icon",
                                                        width: 56,
                                                        height: 56,
                                                        className: "h-14 w-14 object-contain"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "callout__text text-lg",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "mb-2 text-[1.19rem]",
                                                            children: callout.heading
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Body */.uT, {
                                                            variant: "small",
                                                            children: callout.content
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }, index);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: "slider-nav",
                                className: "absolute left-0 -mb-10 flex w-full justify-center"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
FiltrationTechnology.displayName = "FiltrationTechnology";
FiltrationTechnology.Schema = FiltrationTechnology_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/FiltrationTechnology/index.js


;// CONCATENATED MODULE: ./src/sections/FullBleedHero/FullBleedHero.schema.js
function FullBleedHero_schema_Schema() {
    return {
        label: "Full Bleed Hero",
        key: "fullBleedHero",
        category: "Product",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/full-bleed-hero.png",
        fields: [
            {
                name: "headline",
                component: "text",
                label: "Hero Headline"
            },
            {
                label: "Background Image",
                name: "backgroundImage",
                component: "image"
            },
            {
                label: "Background Video URL",
                name: "backgroundVideoUrl",
                description: "Video will always be muted and autoplay with loop and override the background image if present.",
                component: "text"
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/FullBleedHero/FullBleedHero.jsx



function FullBleedHero(param) {
    var cms = param.cms;
    var headline = cms.headline, backgroundImage = cms.backgroundImage, backgroundVideoUrl = cms.backgroundVideoUrl;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative flex aspect-[388/505] items-center justify-center p-12 px-4 text-center sm:aspect-[1728/769]",
        children: [
            backgroundVideoUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                playsInline: true,
                src: backgroundVideoUrl,
                autoPlay: true,
                loop: true,
                muted: true,
                className: "z-1 absolute left-0 top-0 h-full w-full object-cover"
            }),
            !backgroundVideoUrl && backgroundImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                src: backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.src,
                alt: "Full Bleed Background",
                fill: true,
                sizes: "100vw",
                className: "object-cover"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute inset-0 bg-black opacity-50"
            }),
            headline && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                element: "h1",
                variant: "h2",
                className: "relative font-light text-white max-sm:text-[30px]",
                children: headline
            })
        ]
    });
}
FullBleedHero.displayName = "FullBleedHero";
FullBleedHero.Schema = FullBleedHero_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/FullBleedHero/index.js


;// CONCATENATED MODULE: ./src/settings/common.js
var COLORS = [
    {
        label: "Background",
        value: "var(--background)"
    },
    {
        label: "Text",
        value: "var(--text)"
    },
    {
        label: "Border",
        value: "var(--border)"
    },
    {
        label: "Primary",
        value: "var(--primary)"
    },
    {
        label: "Secondary",
        value: "var(--secondary)"
    },
    {
        label: "Accent 1",
        value: "var(--accent-1)"
    },
    {
        label: "Accent 2",
        value: "var(--accent-2)"
    },
    {
        label: "Accent 3",
        value: "var(--accent-3)"
    },
    {
        label: "Success",
        value: "var(--success)"
    },
    {
        label: "Error",
        value: "var(--error)"
    },
    {
        label: "Black",
        value: "var(--black)"
    },
    {
        label: "Off Black",
        value: "var(--off-black)"
    },
    {
        label: "Dark Gray",
        value: "var(--dark-gray)"
    },
    {
        label: "Medium Dark Gray",
        value: "var(--medium-dark-gray)"
    },
    {
        label: "Medium Gray",
        value: "var(--medium-gray)"
    },
    {
        label: "Gray",
        value: "var(--gray)"
    },
    {
        label: "Light Gray",
        value: "var(--light-gray)"
    },
    {
        label: "Off White",
        value: "var(--off-white)"
    },
    {
        label: "White",
        value: "var(--white)"
    },
    {
        label: "Transparent",
        value: "transparent"
    }, 
];
var FLEX_POSITIONS = {
    mobile: [
        {
            value: "justify-start items-start",
            label: "Left Top"
        },
        {
            value: "justify-start items-center",
            label: "Left Center"
        },
        {
            value: "justify-start items-end",
            label: "Left Bottom"
        },
        {
            value: "justify-center items-start",
            label: "Center Top"
        },
        {
            value: "justify-center items-center",
            label: "Center Center"
        },
        {
            value: "justify-center items-end",
            label: "Center Bottom"
        },
        {
            value: "justify-end items-start",
            label: "Right Top"
        },
        {
            value: "justify-end items-center",
            label: "Right Center"
        },
        {
            value: "justify-end items-end",
            label: "Right Bottom"
        }, 
    ],
    desktop: [
        {
            value: "md:justify-start md:items-start",
            label: "Left Top"
        },
        {
            value: "md:justify-start md:items-center",
            label: "Left Center"
        },
        {
            value: "md:justify-start md:items-end",
            label: "Left Bottom"
        },
        {
            value: "md:justify-center md:items-start",
            label: "Center Top"
        },
        {
            value: "md:justify-center md:items-center",
            label: "Center Center"
        },
        {
            value: "md:justify-center md:items-end",
            label: "Center Bottom"
        },
        {
            value: "md:justify-end md:items-start",
            label: "Right Top"
        },
        {
            value: "md:justify-end md:items-center",
            label: "Right Center"
        },
        {
            value: "md:justify-end md:items-end",
            label: "Right Bottom"
        }, 
    ]
};
var OBJECT_POSITIONS = {
    mobile: [
        {
            value: "object-left-top",
            label: "Left Top"
        },
        {
            value: "object-left",
            label: "Left Center"
        },
        {
            value: "object-left-bottom",
            label: "Left Bottom"
        },
        {
            value: "object-top",
            label: "Center Top"
        },
        {
            value: "object-center",
            label: "Center Center"
        },
        {
            value: "object-bottom",
            label: "Center Bottom"
        },
        {
            value: "object-right-top",
            label: "Right Top"
        },
        {
            value: "object-right",
            label: "Right Center"
        },
        {
            value: "object-right-bottom",
            label: "Right Bottom"
        }, 
    ],
    desktop: [
        {
            value: "md:object-left-top",
            label: "Left Top"
        },
        {
            value: "md:object-left",
            label: "Left Center"
        },
        {
            value: "md:object-left-bottom",
            label: "Left Bottom"
        },
        {
            value: "md:object-top",
            label: "Center Top"
        },
        {
            value: "md:object-center",
            label: "Center Center"
        },
        {
            value: "md:object-bottom",
            label: "Center Bottom"
        },
        {
            value: "md:object-right-top",
            label: "Right Top"
        },
        {
            value: "md:object-right",
            label: "Right Center"
        },
        {
            value: "md:object-right-bottom",
            label: "Right Bottom"
        }, 
    ]
};
var TEXT_ALIGN = {
    mobile: [
        {
            label: "Left",
            value: "text-left"
        },
        {
            label: "Center",
            value: "text-center"
        },
        {
            label: "Right",
            value: "text-right"
        }, 
    ],
    desktop: [
        {
            label: "Left",
            value: "md:text-left"
        },
        {
            label: "Center",
            value: "md:text-center"
        },
        {
            label: "Right",
            value: "md:text-right"
        }, 
    ]
};


;// CONCATENATED MODULE: ./src/sections/HeroBanner/Hero.schema.js

var Hero_schema_Schema = function() {
    return {
        label: "Hero Banner",
        key: "hero-banner",
        category: "Hero",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/hero_banner.png?v=1686314605",
        fields: [
            {
                label: "Eyebrow Text",
                name: "eyebrowText",
                component: "text"
            },
            {
                label: "Heading",
                name: "heading",
                component: "text"
            },
            {
                label: "Heading Variant",
                name: "headingVariant",
                component: "select",
                required: true,
                defaultValue: {
                    value: "h1",
                    label: "H1"
                },
                options: [
                    {
                        label: "H1",
                        value: "h1"
                    },
                    {
                        label: "H2",
                        value: "h2"
                    },
                    {
                        label: "H3",
                        value: "h3"
                    }, 
                ]
            },
            {
                label: "Extra Top Padding",
                name: "extraTopPadding",
                description: "For use when navigation overlays banner",
                component: "toggle",
                defaultValue: false
            },
            {
                label: "Fixed banner height (mobile)",
                name: "mobileFixedBannerHeight",
                defaultValue: 474,
                component: "number"
            },
            {
                label: "Fixed heading font size (mobile)",
                name: "mobileFixedBannerFontSize",
                component: "number"
            },
            {
                label: "Subheading (Desktop & Tablet)",
                name: "subheading",
                component: "text"
            },
            {
                label: "Subheading (Mobile)",
                name: "mobileSubheading",
                component: "text"
            },
            {
                label: "Enable Button Spacing",
                name: "enableButtonSpacing",
                component: "toggle",
                description: "Add extra spacing between the subtext and the button."
            },
            {
                label: "Call to Action Buttons",
                name: "ctas",
                component: "group-list",
                description: "Max of two buttons",
                itemProps: {
                    label: "{{item.link.text}}"
                },
                validate: {
                    maxItems: 2
                },
                fields: [
                    {
                        label: "Link",
                        name: "link",
                        component: "link"
                    },
                    {
                        label: "Link ID",
                        name: "linkId",
                        component: "text",
                        description: "Add the section ID you would like the button to scroll down to."
                    },
                    {
                        label: "Button Theme",
                        name: "theme",
                        component: "select",
                        options: [
                            {
                                label: "Primary",
                                value: "primary"
                            },
                            {
                                label: "Secondary",
                                value: "secondary"
                            },
                            {
                                label: "Light",
                                value: "light"
                            }, 
                        ]
                    },
                    {
                        label: "Button Variant",
                        name: "variant",
                        component: "select",
                        options: [
                            {
                                label: "Filled",
                                value: "filled"
                            },
                            {
                                label: "Outlined",
                                value: "outlined"
                            }, 
                        ]
                    }, 
                ],
                defaultItem: {
                    link: {
                        text: "Shop All",
                        url: ""
                    }
                }
            },
            {
                label: "Background Video URL",
                name: "backgroundVideoUrl",
                description: "Video will always be muted and autoplay with loop",
                component: "text",
                required: true
            },
            {
                label: "Background Video URL (Mobile)",
                name: "backgroundVideoUrlMobile",
                component: "text"
            },
            {
                label: "Background Image",
                name: "backgroundImage",
                component: "image"
            },
            {
                label: "Background Image (Mobile)",
                name: "backgroundImageMobile",
                component: "image"
            },
            {
                label: "Enable Full Width Button (Mobile)",
                name: "enableFullWidthButton",
                description: "Toggle full width button on mobile.",
                component: "toggle",
                defaultValue: false
            },
            {
                label: "Vertical Content Alignment (desktop only)",
                name: "verticalAlignment",
                component: "select",
                options: [
                    {
                        label: "Top",
                        value: "lg:justify-start"
                    },
                    {
                        label: "Center",
                        value: "lg:justify-center"
                    },
                    {
                        label: "Bottom",
                        value: "lg:justify-end"
                    }, 
                ],
                defaultValue: "justify-end"
            },
            {
                label: "Horizontal Content Alignment",
                name: "horizontalAlignment",
                component: "select",
                options: [
                    {
                        label: "Left",
                        value: "items-start"
                    },
                    {
                        label: "Center",
                        value: "text-center items-center"
                    },
                    {
                        label: "Right",
                        value: "text-right items-end"
                    }, 
                ],
                defaultValue: "items-center"
            },
            {
                label: "Text Color",
                name: "color",
                component: "select",
                options: COLORS,
                defaultValue: "var(--white)"
            },
            {
                label: "Scroll Indicator",
                name: "scrollIndicator",
                description: "Show the scroll indicator",
                component: "toggle",
                defaultValue: false
            },
            {
                component: "group",
                name: "countdown",
                label: "Countdown Timer",
                fields: [
                    {
                        label: "Enable Timer",
                        name: "enable",
                        description: "Display a countdown timer on the banner",
                        component: "toggle",
                        defaultValue: false
                    },
                    {
                        component: "text",
                        name: "datetime",
                        label: "Date & Time",
                        description: "Must match format: MM/DD/YYYY HH:mm:ss",
                        defaultValue: "07/12/2026 12:00:00"
                    }, 
                ]
            },
            {
                component: "group",
                name: "signup",
                label: "Signup Form",
                fields: [
                    {
                        label: "Enable Signup Form",
                        name: "enable",
                        description: "Display a signup form on the banner",
                        component: "toggle",
                        defaultValue: false
                    },
                    {
                        component: "text",
                        name: "placeholder",
                        label: "Placeholder"
                    },
                    {
                        component: "text",
                        name: "buttonText",
                        label: "Button Text"
                    },
                    {
                        component: "text",
                        name: "successMessage",
                        label: "Success Message"
                    },
                    {
                        component: "text",
                        name: "listId",
                        label: "Klaviyo List ID"
                    },
                    {
                        label: "Success CTA Link",
                        name: "successCtaLink",
                        component: "link",
                        description: "(optional) replaces the form submit button on successful submission"
                    }, 
                ],
                defaultValue: {
                    placeholder: "Email address",
                    buttonText: "Get my Code",
                    successMessage: "Thanks for subscribing! Your submission was received successfully."
                }
            }, 
        ]
    };
};

;// CONCATENATED MODULE: ./src/sections/HeroBanner/CountdownTimer.jsx


function Separator() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: "mt-[0.88rem] inline-block align-top text-lg lg:mt-5",
        children: ":"
    });
}
function IntervalBlock(param) {
    var time = param.time, label = param.label;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mx-4 inline-block",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-2 flex h-12 w-12 items-center justify-center rounded-[0.63rem] bg-[rgba(255,255,255,0.3)] text-[1.38rem] lg:h-[4.5rem] lg:w-[4.5rem] lg:text-[1.75rem]",
                children: time
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "block text-sm uppercase",
                children: label
            })
        ]
    });
}
function CountdownTimer(param) {
    var enable = param.enable, datetime = param.datetime;
    // check if is valid datetime - MM/dd/yyyy 12:00:00
    var isValidDatetime = function(string) {
        var datetimeRegex = /^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}$/;
        return datetimeRegex.test(string);
    };
    var shouldShow = !!enable && isValidDatetime(datetime);
    // get days hours minutes seconds
    var getTimeRemaining = function(endtime) {
        var total = Date.parse(endtime) - Date.parse(new Date());
        if (total <= 0) {
            return {
                total: 0,
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0
            };
        }
        var seconds = Math.floor(total / 1000 % 60);
        var minutes = Math.floor(total / 1000 / 60 % 60);
        var hours = Math.floor(total / (1000 * 60 * 60) % 24);
        var days = Math.floor(total / (1000 * 60 * 60 * 24));
        return {
            total: total,
            days: days,
            hours: hours,
            minutes: minutes,
            seconds: seconds
        };
    };
    var ref = (0,react.useState)({
        total: 0,
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    }), timeRemaining = ref[0], setTimeRemaining = ref[1];
    (0,react.useEffect)(function() {
        var interval = setInterval(function() {
            setTimeRemaining(getTimeRemaining(datetime));
        }, 1000);
        return function() {
            clearInterval(interval);
        };
    }, [
        timeRemaining
    ]);
    return !!shouldShow && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "countdown-timer mb-9 lg:mb-[4.5rem]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IntervalBlock, {
                time: timeRemaining.days,
                label: "days"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Separator, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IntervalBlock, {
                time: timeRemaining.hours,
                label: "hrs"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Separator, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IntervalBlock, {
                time: timeRemaining.minutes,
                label: "min"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Separator, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IntervalBlock, {
                time: timeRemaining.seconds,
                label: "sec"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/sections/HeroBanner/SignupForm.jsx





function SignupForm(param) {
    var enable = param.enable, placeholder = param.placeholder, buttonText = param.buttonText, successMessage = param.successMessage, listId = param.listId, successCtaLink = param.successCtaLink;
    var ref = (0,react.useState)(""), formEmail = ref[0], setFormEmail = ref[1];
    var ref1 = (0,react.useState)(false), isSuccessful = ref1[0], setIsSuccessful = ref1[1];
    var ref2 = (0,react.useState)(false), isErrored = ref2[0], setIsErrored = ref2[1];
    var handleNewsletterSignup = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
            var payload, klaviyoResponse;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        payload = {
                            emailAddress: formEmail
                        };
                        if (listId) {
                            payload.listId = listId;
                        }
                        return [
                            4,
                            fetch("/api/klaviyo-subscribe", {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify(payload)
                            })
                        ];
                    case 1:
                        klaviyoResponse = _state.sent();
                        if (klaviyoResponse.status === 200) {
                            setIsSuccessful(true);
                            setIsErrored(false);
                        } else {
                            setIsErrored(true);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleNewsletterSignup(event) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref3 = (0,react.useState)(""), formFieldClasses = ref3[0], setFormFieldClasses = ref3[1];
    (0,react.useEffect)(function() {
        if (isSuccessful) {
            setFormFieldClasses("border-2 border-solid border-[#5ABE8A]");
        } else if (isErrored) {
            setFormFieldClasses("border-2 border-solid border-error");
        } else {
            setFormFieldClasses("");
        }
    }, [
        isSuccessful,
        isErrored
    ]);
    return !!enable && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mt-9 w-[620px] max-w-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            className: "klaviyo-form w-full px-8",
            onSubmit: handleNewsletterSignup,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative flex justify-between ".concat(!isSuccessful && !isErrored ? "mb-6 lg:mb-9" : ""),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            type: "email",
                            className: "w-full rounded-[0.63rem] bg-[rgba(255,255,255,0.3)] p-3 text-lg font-light placeholder-[var(--primary)] outline-none lg:p-5 lg:text-xl ".concat(formFieldClasses),
                            disabled: isSuccessful,
                            value: formEmail,
                            placeholder: placeholder || "Email address",
                            onChange: function(event) {
                                setFormEmail(event.target.value);
                            }
                        }),
                        isSuccessful && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                            className: "absolute right-3 top-1/2 h-5 w-5 -translate-y-1/2 transform object-contain text-[#5ABE8A] lg:h-8 lg:w-8",
                            src: "/svgs/checkmark-with-circle.svg#checkmark-with-circle",
                            title: "Check",
                            viewBox: "0 0 32 33"
                        })
                    ]
                }),
                isSuccessful && successMessage && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "py-9",
                            children: successMessage
                        }),
                        successCtaLink && /*#__PURE__*/ (0,jsx_runtime.jsxs)(snippets/* Button */.zx, {
                            theme: "light",
                            variant: "filled",
                            className: "w-full",
                            wrapperClassName: "w-full",
                            href: successCtaLink.url,
                            children: [
                                successCtaLink.text,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                                    className: "ml-6 inline-block w-4 lg:ml-10",
                                    src: "/svgs/arrow-right.svg#arrow-right",
                                    title: "Arrow Right",
                                    viewBox: "0 0 24 24"
                                })
                            ]
                        })
                    ]
                }),
                isErrored && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "py-9 text-error",
                    children: "An error occurred. Please try again."
                }),
                !isSuccessful && buttonText && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Button */.zx, {
                    ariaLabel: "submit",
                    type: "submit",
                    theme: "primary",
                    variant: "filled",
                    className: "w-full",
                    children: buttonText
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/utils/scrollUtility.js
/**
  * This utility smoothly scrolls to a target element specified by its selector.
*/ function handleScroll(event, selector) {
    var targetElement = document.querySelector(selector);
    if (targetElement) {
        event.preventDefault();
        targetElement.scrollIntoView({
            behavior: "smooth"
        });
    }
}

;// CONCATENATED MODULE: ./src/sections/HeroBanner/HeroBanner.jsx












function HeroBanner(param) {
    var cms = param.cms;
    var backgroundImageMobile = cms.backgroundImageMobile, backgroundImage = cms.backgroundImage, horizontalAlignment = cms.horizontalAlignment, verticalAlignment = cms.verticalAlignment, enableFullWidthButton = cms.enableFullWidthButton, backgroundVideoUrl = cms.backgroundVideoUrl, backgroundVideoUrlMobile = cms.backgroundVideoUrlMobile, countdown = cms.countdown, color = cms.color, ctas = cms.ctas, extraTopPadding = cms.extraTopPadding, eyebrowText = cms.eyebrowText, heading = cms.heading, headingVariant = cms.headingVariant, mobileFixedBannerFontSize = cms.mobileFixedBannerFontSize, mobileFixedBannerHeight = cms.mobileFixedBannerHeight, mobileSubheading = cms.mobileSubheading, scrollIndicator = cms.scrollIndicator, signup = cms.signup, subheading = cms.subheading, enableButtonSpacing = cms.enableButtonSpacing;
    var isMobile = utils_useMediaQuery("(max-width: 767px)");
    var textColor = color !== null && color !== void 0 ? color : "white";
    var ref = (0,react.useState)({}), sectionStyles = ref[0], setSectionStyles = ref[1];
    (0,react.useEffect)(function() {
        if (isMobile) {
            setSectionStyles({
                color: textColor,
                minHeight: mobileFixedBannerHeight ? "".concat(mobileFixedBannerHeight, "px") : "auto"
            });
        } else {
            setSectionStyles({
                color: textColor
            });
        }
    }, [
        isMobile
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "relative flex h-auto min-h-[480px] flex-col justify-end bg-primary md:min-h-screen ".concat(verticalAlignment, " ").concat(extraTopPadding ? "pt-[96px] md:pt-[120px]" : ""),
        style: sectionStyles,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-content absolute inset-0 z-[1] h-full w-full bg-orange-300/10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBackground, {
                    image: backgroundImage,
                    mobileImage: backgroundImageMobile,
                    video: backgroundVideoUrl,
                    mobileVideo: backgroundVideoUrlMobile
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-contained lg:text-eye relative z-[2] flex h-full w-full max-w-[--var(content-max-width)] flex-col justify-end ".concat(horizontalAlignment, " ").concat(enableButtonSpacing ? "md:gap-y-12" : "gap-y-4", "  py-12 md:py-28"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CountdownTimer, (0,_object_spread/* default */.Z)({}, countdown)),
                    eyebrowText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Eyebrow */.j4, {
                        className: "max-sm:!text-[14px]",
                        children: eyebrowText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "heading-text m",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "grid grid-cols-12",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-span-12 max-w-3xl items-center lg:col-span-12",
                                children: [
                                    heading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Headline/* default */.Z, {
                                        variant: headingVariant || "h1",
                                        element: "h2",
                                        className: "mb-4 max-w-[785px]",
                                        style: isMobile && mobileFixedBannerFontSize ? {
                                            fontSize: mobileFixedBannerFontSize
                                        } : {},
                                        children: heading
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "hidden lg:block",
                                        children: subheading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Body */.uT, {
                                            variant: "large",
                                            children: subheading
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "lg:hidden",
                                        children: mobileSubheading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Body */.uT, {
                                            variant: "medium",
                                            children: mobileSubheading
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    ctas && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "cta-group flex flex-wrap gap-3 ".concat(enableFullWidthButton ? "max-sm:w-full" : ""),
                        children: ctas.map(function(cta, index) {
                            if ("link" in cta) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    href: cta.linkId ? "#".concat(cta.linkId) : cta.link.url,
                                    variant: cta.variant,
                                    theme: cta.theme,
                                    wrapperClassName: "shrink-0 ".concat(enableFullWidthButton ? "max-sm:w-full" : "", " ").concat(ctas.length > 1 ? "max-sm:max-w-1/2" : ""),
                                    className: "".concat(enableFullWidthButton ? "max-sm:w-full" : "", " max-sm:text-[14px]"),
                                    onClick: function(event) {
                                        return cta.linkId && handleScroll(event, "#".concat(cta.linkId));
                                    },
                                    children: cta.link.text
                                }, index);
                            }
                            return null;
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SignupForm, (0,_object_spread/* default */.Z)({}, signup)),
                    scrollIndicator && !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute bottom-[88px] left-1/2 h-[24px] w-[1px] -translate-x-1/2 bg-[#fff] lg:bottom-[108px]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute bottom-[30px] left-1/2 h-[72px] w-[1px] -translate-x-1/2 bg-[#fff] opacity-50 lg:bottom-[60px]"
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
}
HeroBanner.Schema = Hero_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/HeroBannerWithNewsTicker/HeroBannerWithNewsTicker.schema.js
function HeroBannerWithNewsTicker_schema_Schema() {
    return {
        label: "Hero Banner With News Ticker",
        key: "heroBannerWithNewsTicker",
        category: "Hero",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/hero_banner_news_ticker.png?v=1684793147",
        fields: [
            {
                label: "Light Mode",
                name: "lightMode",
                component: "toggle",
                description: "Enable Light Text & Buttons.",
                defaultValue: false
            },
            {
                label: "Background Image",
                name: "backgroundImage",
                component: "image"
            },
            {
                label: "Background Image (mobile)",
                name: "backgroundMobileImage",
                component: "image"
            },
            {
                label: "Heading",
                name: "heading",
                component: "text"
            },
            {
                label: "Call to action",
                name: "cta",
                component: "link"
            },
            {
                label: "Newsticker",
                name: "newsticker",
                component: "group-list",
                fields: [
                    {
                        label: "Icon",
                        name: "icon",
                        component: "image"
                    },
                    {
                        label: "Text",
                        name: "text",
                        component: "text"
                    }, 
                ]
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/HeroBannerWithNewsTicker/HeroBannerWithNewsTicker.jsx





function HeroBannerWithNewsTicker(param) {
    var cms = param.cms;
    var backgroundImage = cms.backgroundImage, backgroundMobileImage = cms.backgroundMobileImage, newsticker = cms.newsticker, heading = cms.heading, cta = cms.cta, lightMode = cms.lightMode;
    var isMobile = utils_useMediaQuery("(max-width: 767px)");
    var mobileImageBackup = (backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.src) ? "".concat(backgroundImage.src, "&width=800&quality=75") : null;
    var mobileImage = (backgroundMobileImage === null || backgroundMobileImage === void 0 ? void 0 : backgroundMobileImage.src) ? "".concat(backgroundMobileImage.src, "&width=800&quality=75") : mobileImageBackup;
    var desktopImage = (backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.src) ? "".concat(backgroundImage.src, "&width=2000") : null;
    var ref = (0,react.useState)("h1"), headlineVariant = ref[0], setHeadlineVariant = ref[1];
    var ref1 = (0,react.useState)(mobileImage), bGImage = ref1[0], setBGImage = ref1[1];
    (0,react.useEffect)(function() {
        if (isMobile) {
            setHeadlineVariant("h1");
            setBGImage(mobileImage);
        } else {
            setHeadlineVariant("h2");
            setBGImage(desktopImage);
        }
    }, [
        isMobile
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "h-[540px] bg-cover bg-left-top lg:h-[574px] lg:bg-center print:hidden",
                style: {
                    backgroundImage: "url(".concat(bGImage, ")")
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "px-contained flex h-full flex-col gap-10 py-12 lg:max-w-[700px] lg:justify-center",
                    children: [
                        heading && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                            variant: headlineVariant,
                            className: "".concat(lightMode ? "text-white" : "text-text"),
                            children: heading
                        }),
                        cta && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Button */.zx, {
                                theme: "".concat(lightMode ? "light" : "secondary"),
                                variant: "filled",
                                href: cta.url,
                                children: cta.text
                            })
                        })
                    ]
                })
            }),
            (newsticker === null || newsticker === void 0 ? void 0 : newsticker.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "relative flex h-24 items-center overflow-x-hidden bg-[#343B49] print:hidden",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute inset-0 z-10 bg-gradient-to-r from-[#F1DCC1] to-[#2179C2] mix-blend-multiply"
                            }),
                            Array(3).fill().map(function(_, i) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                    className: "animate-news-ticker-1",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex gap-10 px-5 text-white",
                                        children: newsticker === null || newsticker === void 0 ? void 0 : newsticker.map(function(item, index) {
                                            var ref, ref1;
                                            if (!(item === null || item === void 0 ? void 0 : item.text)) return null;
                                            var ref2;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex items-center gap-x-2",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                                        src: item === null || item === void 0 ? void 0 : (ref = item.icon) === null || ref === void 0 ? void 0 : ref.src,
                                                        alt: (ref2 = item === null || item === void 0 ? void 0 : (ref1 = item.icon) === null || ref1 === void 0 ? void 0 : ref1.alt) !== null && ref2 !== void 0 ? ref2 : "News Ticker Icon",
                                                        className: "h-5 w-5 object-contain",
                                                        width: 20,
                                                        height: 20
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Body */.uT, {
                                                        children: item === null || item === void 0 ? void 0 : item.text
                                                    })
                                                ]
                                            }, "ticker-item-".concat(index));
                                        })
                                    })
                                }, i);
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-1 bg-gradient-to-r from-[#F1DCC1] to-[#2179C2]"
                    })
                ]
            })
        ]
    });
}
HeroBannerWithNewsTicker.displayName = "HeroBannerWithNewsTicker";
HeroBannerWithNewsTicker.Schema = HeroBannerWithNewsTicker_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/HeroBannerWithNewsTicker/index.js


;// CONCATENATED MODULE: ./src/sections/HowItWorks/HowItWorks.schema.js
function HowItWorks_schema_Schema() {
    return {
        category: "Text",
        label: "How It Works",
        key: "howItWorks",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/Screen_20Shot_202023-05-23_20at_2010.47.30_20AM.png?v=1684864578",
        fields: [
            {
                label: "Header",
                name: "header",
                component: "text",
                defaultValue: "How it works"
            },
            {
                label: "Copy",
                name: "copy",
                component: "text",
                defaultValue: "Subscribe now to ensure you always have a replacement filter ready and you never run out of clean water."
            },
            {
                label: "CTA Copy",
                name: "ctaCopy",
                component: "text"
            },
            {
                label: "CTA Url",
                name: "ctaUrl",
                component: "text"
            },
            {
                label: "How It Works Items",
                name: "howItWorksItems",
                component: "group-list",
                itemProps: {
                    label: "{{item.header}}"
                },
                fields: [
                    {
                        label: "Header",
                        name: "header",
                        component: "text"
                    },
                    {
                        label: "Copy",
                        name: "copy",
                        component: "text"
                    },
                    {
                        label: "Image",
                        name: "image",
                        component: "image"
                    }, 
                ],
                defaultValue: [
                    {
                        header: "Subscribe",
                        copy: 'Subscribe & within minutes, you"ll receive an email to activate your account & set up your subscription.'
                    },
                    {
                        header: "Schedule",
                        copy: 'Once you"ve activated your account, log in to update your information, pause, or adjust frequency, & cancel any time.'
                    },
                    {
                        header: "Save",
                        copy: "Save 10% on every order & get free shipping in the USA. No long-term commitment, surprises, or hidden fees."
                    }, 
                ],
                defaultItem: {
                    header: "Subscribe",
                    copy: 'Subscribe & within minutes, you"ll receive an email to activate your account & set up your subscription.',
                    ctaCopy: "Shop & Subscribe",
                    ctaUrl: "#"
                }
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/HowItWorks/HowItWorks.jsx




function HowItWorksItem(props) {
    var image = props.image, header = props.header, copy = props.copy, index = props.index, activeIndex = props.activeIndex, setActiveItem = props.setActiveItem, setActiveIndex = props.setActiveIndex, howItWorksItems = props.howItWorksItems;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mx-auto mb-4 cursor-pointer items-center justify-center lg:flex",
        onClick: function() {
            setActiveIndex(index);
            setActiveItem(howItWorksItems[index]);
        },
        children: [
            image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "lg:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                    className: "mx-auto mb-6",
                    sizes: "48px",
                    width: "355px",
                    height: "355px",
                    src: image.src
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full rounded-lg bg-[#D9D9D9] bg-gradient-to-l from-[#88b3e0] via-[#8DCEF9] to-[#F1DCC1] p-[1px] lg:h-36 ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "back flex h-full w-full justify-center rounded-lg lg:py-0",
                    style: {
                        backgroundColor: activeIndex === index ? "rgba(255,255,255,0.8)" : "transparent",
                        background: activeIndex === index ? "#e1f0fc" : "var(--clearBlue)"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-[0_0_100px] items-center justify-center px-4 text-center text-3xl font-light tracking-[-0.01em] lg:px-6 lg:text-4xl",
                            children: [
                                "0",
                                index + 1
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-[1px] bg-[#D9D9D9] bg-gradient-to-t from-[#88b3e0] via-[#8DCEF9] to-[#F1DCC1]"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col justify-center py-8 pl-4 pr-3 text-left lg:pl-4 lg:pr-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mb-2 text-lg font-light lg:text-xl",
                                    children: header
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-xs font-light lg:text-base",
                                    children: copy
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
function HowItWorks(param) {
    var cms = param.cms;
    var header = cms.header, copy = cms.copy, ctaCopy = cms.ctaCopy, ctaUrl = cms.ctaUrl, howItWorksItems = cms.howItWorksItems;
    var ref = (0,react.useState)(0), activeIndex = ref[0], setActiveIndex = ref[1];
    var ref1 = (0,react.useState)(howItWorksItems.length > 0 ? howItWorksItems[0] : null), activeItem = ref1[0], setActiveItem = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "px-contained lg:py-contained relative mx-auto flex pb-16 pt-2 lg:pb-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative hidden w-1/2 lg:block lg:pr-12",
                children: (activeItem === null || activeItem === void 0 ? void 0 : activeItem.image) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                    className: "mx-auto mb-4",
                    sizes: "48px",
                    width: "815px",
                    height: "815px",
                    src: activeItem.image.src
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mx-auto text-center lg:w-1/2 lg:max-w-lg lg:text-left",
                children: [
                    header && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "mx-auto mb-6 text-3xl font-light lg:text-5xl",
                        children: header
                    }),
                    copy && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mb-6 text-sm lg:text-xl",
                        children: copy
                    }),
                    ctaCopy && ctaUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-4 lg:hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Button */.zx, {
                            href: ctaUrl,
                            theme: "primary",
                            variant: "filled",
                            children: ctaCopy
                        })
                    }),
                    (howItWorksItems === null || howItWorksItems === void 0 ? void 0 : howItWorksItems.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mx-auto flex max-w-none flex-col items-center gap-4 md:gap-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-4 flex flex-wrap justify-center lg:flex",
                            children: howItWorksItems.map(function(param, index) {
                                var image = param.image, header = param.header, copy = param.copy;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(HowItWorksItem, {
                                    image: image,
                                    header: header,
                                    copy: copy,
                                    index: index,
                                    activeIndex: activeIndex,
                                    setActiveItem: setActiveItem,
                                    setActiveIndex: setActiveIndex,
                                    howItWorksItems: howItWorksItems
                                }, index);
                            })
                        })
                    }),
                    ctaCopy && ctaUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-6 hidden lg:block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Button */.zx, {
                            href: ctaUrl,
                            theme: "primary",
                            variant: "filled",
                            children: ctaCopy
                        })
                    })
                ]
            })
        ]
    });
}
HowItWorks.displayName = "HowItWorks";
HowItWorks.Schema = HowItWorks_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/HowItWorks/index.js


// EXTERNAL MODULE: ../node_modules/lodash/lodash.js
var lodash = __webpack_require__(8784);
// EXTERNAL MODULE: ./src/snippets/Carousel/Carousel.jsx
var Carousel = __webpack_require__(7105);
// EXTERNAL MODULE: ./src/snippets/Typography/Subheading.jsx
var Subheading = __webpack_require__(9221);
;// CONCATENATED MODULE: ./src/sections/ImageActionsCarousel/ImageActionsCarousel.schema.js
var actionItemFields = [
    {
        label: "Image",
        name: "image",
        component: "image"
    },
    {
        label: "Title",
        name: "title",
        component: "text"
    },
    {
        component: "link",
        name: "link",
        label: "Link",
        defaultValue: {
            text: "Buy now",
            url: "/pages/about-us"
        }
    }, 
];
function ImageActionsCarousel_schema_Schema() {
    return {
        label: "Image Actions Carousel",
        key: "imageActionsCarousel",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/image_actions_carousel.png?v=1684843135",
        category: "Slider",
        fields: [
            {
                label: "Dark mode",
                name: "darkMode",
                component: "toggle",
                description: "Use dark mode for this",
                defaultValue: false
            },
            {
                component: "link",
                name: "mobileCta",
                label: "Mobile CTA"
            },
            {
                label: "Title",
                name: "title",
                component: "text"
            },
            {
                label: "Action Items",
                name: "actionItems",
                component: "group-list",
                itemProps: {
                    label: "{{item.title}}"
                },
                validate: {
                    maxItems: 6
                },
                fields: actionItemFields
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/ImageActionsCarousel/ImageActionsCarousel.jsx
/* eslint-disable no-use-before-define */ 








function ImageActionsCarousel(param) {
    var cms = param.cms;
    var title = cms.title, actionItems = cms.actionItems, darkMode = cms.darkMode, mobileCta = cms.mobileCta;
    var isMobile = utils_useMediaQuery("(max-width: 767px)");
    var remappedActionItemsDesktop = (0,react.useMemo)(function() {
        return (0,lodash.chunk)(actionItems, 3);
    }, [
        actionItems
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat(darkMode ? "dark" : "", " overflow-hidden text-primary"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: "py-10 dark:bg-[#202635] dark:text-[#ffffff] [&_.carousel-slider]:overflow-visible [&_.slider-wrapper]:overflow-visible",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "px-contained mx-auto max-w-[var(--content-max-width)]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative z-10 mb-10",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Headline/* default */.Z, {
                                variant: "h3",
                                children: title
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "hidden lg:block [&_.control-dots]:!bottom-[-20px] [&_.control-dots]:!ml-0 [&_.control-dots]:!w-full [&_.control-dots]:!max-w-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* default */.Z, {
                                className: "!px-0",
                                topArrows: true,
                                itemsPerPageMultiplier: 3,
                                overwriteTotalItems: actionItems === null || actionItems === void 0 ? void 0 : actionItems.length,
                                children: remappedActionItemsDesktop === null || remappedActionItemsDesktop === void 0 ? void 0 : remappedActionItemsDesktop.map(function(actionsChunk, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "grid grid-cols-3",
                                        children: actionsChunk.map(function(item, _index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageAction, {
                                                item: item
                                            }, _index);
                                        })
                                    }, index);
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "image-actions-carousel-mobile flex overflow-x-auto overflow-y-hidden pb-10 lg:hidden",
                            children: actionItems === null || actionItems === void 0 ? void 0 : actionItems.map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-full min-w-[300px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageAction, {
                                        item: item
                                    })
                                }, index);
                            })
                        })
                    ]
                }),
                isMobile && (mobileCta === null || mobileCta === void 0 ? void 0 : mobileCta.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "px-contained mx-auto mt-10 max-w-[var(--content-max-width)]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Button */.zx, {
                            href: mobileCta === null || mobileCta === void 0 ? void 0 : mobileCta.url,
                            theme: "light",
                            variant: "outlined",
                            children: mobileCta === null || mobileCta === void 0 ? void 0 : mobileCta.text
                        })
                    })
                })
            ]
        })
    });
}
function ImageAction(param) {
    var item = param.item;
    var ref, ref1;
    var _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
        href: (ref = item.link) === null || ref === void 0 ? void 0 : ref.url,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-gray-300 mb-2 mr-4 aspect-square flex-shrink-0",
                children: ((ref1 = item.image) === null || ref1 === void 0 ? void 0 : ref1.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                    className: "h-full w-full object-cover",
                    src: item.image.src,
                    alt: (_alt = item.image.alt) !== null && _alt !== void 0 ? _alt : item.title,
                    width: 500,
                    height: 500
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Subheading/* default */.Z, {
                variant: "large",
                children: item.title
            })
        ]
    });
}
ImageActionsCarousel.Schema = ImageActionsCarousel_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/ImageActionsCarousel/index.js


;// CONCATENATED MODULE: ./src/sections/ImageBehindText/ImageBehindText.schema.js
function ImageBehindText_schema_Schema() {
    return {
        category: "Image",
        label: "Image Behind Text",
        key: "imageBehindText",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/Screen_20Shot_202023-05-23_20at_2010.46.51_20AM.png?v=1684864565",
        fields: [
            {
                label: "Eyebrow",
                name: "eyebrow",
                component: "text",
                defaultValue: "Our Story"
            },
            {
                label: "Copy",
                name: "copy",
                component: "text",
                defaultValue: 'Clearly Filtered started in 2011 with the belief that water shouldn"t contain harmful chemicals, toxic heavy metals, or any other form of contamination. This philosophy has led to the development of one of the most advanced filtration technologies in the world.'
            },
            {
                label: "Image",
                name: "image",
                component: "image"
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/ImageBehindText/ImageBehindText.jsx




function ImageBehindText(param) {
    var cms = param.cms;
    var eyebrow = cms.eyebrow, copy = cms.copy, image = cms.image;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-[#202635] relative",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "lg:px-contained lg:py-72 overflow-hidden max-w-7xl mx-auto relative",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "py-24 lg: py-0 px-4 lg:px-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Eyebrow */.j4, {
                            className: "mb-4 text-white uppercase relative z-10 ",
                            children: eyebrow
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                            variant: "h3",
                            element: "h3",
                            className: "max-w-3xl mb-6 lg:mb-12 mt-6 text-white relative z-10",
                            children: copy
                        })
                    ]
                }),
                image && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "lg:absolute lg:top-1/2 lg:-translate-y-1/2 lg:right-0 z-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                            className: "",
                            sizes: "48px",
                            width: "762px",
                            height: "756px",
                            src: image.src
                        })
                    })
                })
            ]
        })
    });
}
ImageBehindText.displayName = "Image Behind Text";
ImageBehindText.Schema = ImageBehindText_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/ImageBehindText/index.js


;// CONCATENATED MODULE: ./src/sections/ImageSlider/ImageSlider.schema.js
var slideContent = {
    label: "Slider Settings",
    name: "slider",
    description: "",
    component: "group",
    fields: [
        {
            label: "Slides",
            name: "slideItems",
            component: "group-list",
            itemProps: {
                label: "{{item.title}}"
            },
            fields: [
                {
                    label: "Image",
                    name: "image",
                    component: "image"
                },
                {
                    label: "Title",
                    name: "title",
                    component: "text"
                },
                {
                    label: "Copy",
                    name: "copy",
                    component: "text"
                }, 
            ],
            defaultValue: [
                {
                    title: "BELIEF ONE",
                    copy: "Clean water. Clear conscience."
                }, 
            ],
            defaultItem: {
                title: "BELIEF ONE",
                copy: "Clean water. Clear conscience."
            }
        }, 
    ]
};
var ImageSlider_schema_Schema = function() {
    return {
        label: "Image Slider",
        category: "Slider",
        key: "imageSlider",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/Screen_20Shot_202023-05-23_20at_2010.46.01_20AM.png?v=1684864562",
        fields: [
            {
                label: "Eyebrow",
                name: "eyebrow",
                component: "text",
                defaultValue: "OUR MISSION"
            },
            {
                label: "Heading",
                name: "heading",
                component: "text",
                defaultValue: "Empower a Healthier You"
            },
            {
                label: "Copy",
                name: "copy",
                component: "text",
                defaultValue: 'We are on a mission to provide people with the tools to take control of their water and live healthier lives. It"s a lot easier to remove contaminants from the water you drink than to remove disease once it has entered the body.'
            },
            slideContent, 
        ]
    };
};

;// CONCATENATED MODULE: ./src/sections/ImageSlider/ImageSlider.jsx







function ImageSlide(props) {
    var image = props.image, title = props.title, copy = props.copy;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative mx-auto max-w-[1260px] rounded-lg lg:px-12 lg:py-12",
        children: [
            image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative h-0 overflow-hidden pb-[70%] xs:pb-[56.25%]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                    className: "absolute inset-0 mx-auto h-full w-full object-cover",
                    sizes: "48px",
                    width: "1286px",
                    height: "723px",
                    src: image.src,
                    priority: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "absolute top-40 flex w-full flex-col items-center justify-center lg:top-1/2 lg:-translate-y-1/2 lg:pr-12",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "absolute -top-28 rounded-full border border-white px-4 py-1 text-2xs font-normal text-white before:absolute before:left-1/2 before:top-[26px] before:h-[85px] before:w-[1px] before:-translate-x-1/2 before:bg-white after:content-[''] lg:-top-28 lg:px-8 lg:py-2 lg:text-sm lg:before:top-[36px] lg:before:h-[76px]",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "border border-white px-3 py-2 text-[20px] leading-tight text-white lg:px-6 lg:py-4 lg:text-[42px]",
                        children: copy
                    })
                ]
            })
        ]
    });
}
function ImageSlider(param) {
    var cms = param.cms;
    var heading = cms.heading, eyebrow = cms.eyebrow, copy = cms.copy, slider = cms.slider;
    var ref = (0,react.useState)(null), swiper = ref[0], setSwiper = ref[1];
    var ref1 = (0,react.useState)(1), activeSlideIndex = ref1[0], setActiveSlideIndex = ref1[1];
    var uniqID = Math.floor(Math.random() * Date.now());
    swiper === null || swiper === void 0 ? void 0 : swiper.on("slideChange", function() {
        setActiveSlideIndex(swiper.realIndex + 1);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative bg-[#b3d1e94d]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "px-contained overflow-hidden pb-16 pt-12 text-center lg:pb-24 lg:pt-24",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Eyebrow */.j4, {
                    className: "mb-4",
                    children: eyebrow
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                    variant: "h3",
                    element: "h3",
                    children: heading
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Body */.uT, {
                    variant: "large",
                    className: "mx-auto mt-4 max-w-[685px]",
                    children: copy
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                    onSwiper: setSwiper,
                    className: "!static mx-auto mt-8 w-full max-w-[1260px] overflow-visible lg:mt-16",
                    grabCursor: true,
                    loop: true,
                    centeredSlides: true,
                    pagination: {
                        el: ".swiper-pagination-image-".concat(uniqID),
                        type: "bullets",
                        clickable: true,
                        bulletActiveClass: "!bg-[#202635] z-[20] opacity-100",
                        renderBullet: function renderBullet(index, className) {
                            return '<span\n                class="absolute bg-[#CCD8E3] h-[1px] '.concat(className, ' opacity-100"\n                style="width: ').concat((index + 1) * (100 / ((slider === null || slider === void 0 ? void 0 : slider.slideItems.length) || 1)), '%"\n              ></span>');
                        }
                    },
                    modules: [
                        modules/* Pagination */.tl
                    ],
                    slidesPerView: 1,
                    spaceBetween: 16,
                    breakpoints: {
                        1024: {
                            loop: true,
                            slidesPerView: 1,
                            spaceBetween: 0
                        }
                    },
                    children: slider === null || slider === void 0 ? void 0 : slider.slideItems.map(function(param, index) {
                        var image = param.image, title = param.title, slideCopy = param.copy;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSlide, {
                                image: image,
                                title: title,
                                copy: slideCopy
                            })
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "swiper-pagination-image-".concat(uniqID, " swiper-progress relative mx-auto mt-8 flex w-full max-w-[calc(940px-64px)] flex-nowrap justify-start lg:mt-16")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative mx-auto hidden max-w-[940px] lg:block",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "absolute right-[-25px] top-[-13px] text-sm font-normal",
                        children: [
                            activeSlideIndex,
                            " / ",
                            swiper === null || swiper === void 0 ? void 0 : swiper.slides.length
                        ]
                    })
                })
            ]
        })
    });
}
ImageSlider.displayName = "Image Slider";
ImageSlider.Schema = ImageSlider_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/ImageSlider/index.js


// EXTERNAL MODULE: ../node_modules/fuse.js/dist/fuse.esm.js
var fuse_esm = __webpack_require__(8107);
;// CONCATENATED MODULE: ./src/hooks/labResults/useMergedContaminants.js




function useMergedContaminants(contaminants) {
    var settings = (0,dist.useSettings)();
    var contaminantSettings = (0,_object_spread/* default */.Z)({}, settings).contaminantSettings;
    var ref = (0,_object_spread/* default */.Z)({}, contaminantSettings), globalContaminants = ref.contaminants, contaminantCategories = ref.contaminantCategories;
    var cleanName = function(name) {
        return name.replace(".", "-").replace("[", "-").replace("]", "-");
    };
    return (0,react.useMemo)(function() {
        var ref, ref1, ref2;
        var finalContaminants = {};
        (ref2 = (ref1 = (ref = globalContaminants === null || globalContaminants === void 0 ? void 0 : globalContaminants.filter(function(globalContaminant) {
            var ref;
            // replace any characters that are not allowed in a variable name
            return contaminants === null || contaminants === void 0 ? void 0 : (ref = contaminants[cleanName(globalContaminant.name)]) === null || ref === void 0 ? void 0 : ref.enabled;
        })) === null || ref === void 0 ? void 0 : ref.map(function(globalContaminant) {
            var mergedContaminant = (0,_object_spread/* default */.Z)({}, globalContaminant, contaminants === null || contaminants === void 0 ? void 0 : contaminants[cleanName(globalContaminant.name)]);
            // Make sure after merging, no properties are empty Locally, if they are use the Global values
            Object.keys(mergedContaminant).forEach(function(key) {
                if (mergedContaminant[key] === "") mergedContaminant[key] = globalContaminant[key];
            });
            return mergedContaminant;
        })) === null || ref1 === void 0 ? void 0 : ref1.sort(function(a, b) {
            var ref;
            return a === null || a === void 0 ? void 0 : (ref = a.name) === null || ref === void 0 ? void 0 : ref.localeCompare(b === null || b === void 0 ? void 0 : b.name);
        })) === null || ref2 === void 0 ? void 0 : ref2.forEach(function(contaminant) {
            var ref, ref1;
            var currentContaminantCategory = contaminant.category;
            // Normalize our contaminant aliases
            contaminant.aliases = contaminant === null || contaminant === void 0 ? void 0 : (ref = contaminant.aliases) === null || ref === void 0 ? void 0 : ref.map(function(alias) {
                return alias.alias;
            });
            // Check to see if the current contaminant category matches one from our Global List of Categories
            contaminantCategories.forEach(function(category) {
                if (category.categoryName === currentContaminantCategory) {
                    // If this Category hasn't been defined yet in our final contaminants list, let's set it
                    if (!finalContaminants[category.categoryName]) {
                        finalContaminants[category.categoryName] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, category), {
                            contaminants: []
                        });
                    }
                    // Add our contaminant to the category's "contaminants" list property.
                    finalContaminants[category.categoryName].contaminants.push(contaminant);
                }
            });
            if (!(finalContaminants === null || finalContaminants === void 0 ? void 0 : finalContaminants[currentContaminantCategory]) || !((ref1 = Object === null || Object === void 0 ? void 0 : Object.keys(finalContaminants === null || finalContaminants === void 0 ? void 0 : finalContaminants[currentContaminantCategory])) === null || ref1 === void 0 ? void 0 : ref1.length) > 0) {
                // If this Category hasn't been defined yet in our final contaminants list, let's set it
                if (!finalContaminants.Uncategorized) {
                    finalContaminants.Uncategorized = {
                        contaminants: []
                    };
                }
                // Add our contaminant to the category's "contaminants" list property.
                finalContaminants.Uncategorized.contaminants.push(contaminant);
            }
        });
        return Object.keys(finalContaminants).sort().reduce(function(obj, key) {
            obj[key] = finalContaminants[key];
            return obj;
        }, {});
    }, [
        contaminants,
        contaminantSettings
    ]);
}

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(5341);
;// CONCATENATED MODULE: ./src/utils/flattenContaminant.js

function isEndPointObject(obj) {
    return Object.values(obj).every(function(value) {
        return typeof value !== "object" || Array.isArray(value);
    });
}
function flattenContaminant(obj) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", flattened = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // eslint-disable-next-line no-restricted-syntax
        for(var _iterator = Object.entries(obj)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _value = (0,_sliced_to_array/* default */.Z)(_step.value, 2), key = _value[0], value = _value[1];
            var newKey = prefix ? "".concat(prefix, "-").concat(key) : key;
            if (typeof value === "object" && !Array.isArray(value)) {
                if (isEndPointObject(value)) {
                    flattened[newKey] = value;
                } else {
                    flattenContaminant(value, newKey, flattened);
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return flattened;
}
/* harmony default export */ var utils_flattenContaminant = (flattenContaminant);

;// CONCATENATED MODULE: ./src/sections/LabResults/LabResults.schema.js

var LabResults_schema_Schema = function(param) {
    var settings = param.settings;
    var ref, ref1;
    var contaminantSettings = settings === null || settings === void 0 ? void 0 : (ref = settings.settings) === null || ref === void 0 ? void 0 : ref.contaminantSettings;
    var contaminants = contaminantSettings === null || contaminantSettings === void 0 ? void 0 : contaminantSettings.contaminants;
    var contaminantList = (ref1 = (0,_to_consumable_array/* default */.Z)(contaminants)) === null || ref1 === void 0 ? void 0 : ref1.sort(function(a, b) {
        var ref, ref1;
        return (a === null || a === void 0 ? void 0 : (ref = a.category) === null || ref === void 0 ? void 0 : ref.localeCompare(b === null || b === void 0 ? void 0 : b.category)) || (a === null || a === void 0 ? void 0 : (ref1 = a.name) === null || ref1 === void 0 ? void 0 : ref1.localeCompare(b === null || b === void 0 ? void 0 : b.name));
    }).map(function(contaminant) {
        var _challengeWater, _filteredWater, _percentRemoved;
        return {
            component: "group",
            name: contaminant.name,
            label: contaminant.name,
            description: contaminant.category,
            fields: [
                {
                    component: "toggle",
                    name: "enabled",
                    label: "Enabled?"
                },
                {
                    component: "text",
                    name: "challengeWater",
                    label: "Challenge Water",
                    description: "Global: ".concat((_challengeWater = contaminant.challengeWater) !== null && _challengeWater !== void 0 ? _challengeWater : "N/A"),
                    defaultValue: contaminant.challengeWater
                },
                {
                    component: "text",
                    name: "filteredWater",
                    label: "Filtered Water",
                    description: "Global: ".concat((_filteredWater = contaminant.filteredWater) !== null && _filteredWater !== void 0 ? _filteredWater : "N/A"),
                    defaultValue: contaminant.filteredWater
                },
                {
                    component: "text",
                    name: "percentRemoved",
                    label: "Percent Removed",
                    description: "Global: ".concat((_percentRemoved = contaminant.percentRemoved) !== null && _percentRemoved !== void 0 ? _percentRemoved : "N/A"),
                    defaultValue: contaminant.percentRemoved
                }, 
            ]
        };
    });
    return {
        label: "Lab Results",
        key: "lab-results",
        category: "Lab Results",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/lab-results.png?v=1685124975",
        fields: [
            {
                component: "group",
                name: "contaminants",
                label: "Contaminants",
                fields: contaminantList
            },
            {
                component: "group",
                name: "search",
                label: "Search",
                fields: [
                    {
                        component: "text",
                        name: "searchPlaceholderText",
                        label: "Search Placeholder Text",
                        defaultValue: "Search Test Results..."
                    },
                    {
                        component: "text",
                        name: "noResultsHeading",
                        label: "No Results Heading",
                        defaultValue: "Uh-oh. We couldnt fine anything for {search term}"
                    },
                    {
                        component: "markdown",
                        name: "noResultsContent",
                        label: "No Results Content",
                        defaultValue: "Please double check to make sure that your search is spelled correctly. If you are still not seeing a particular contaminant, please contact our support team and let us know which contaminant you're looking to remove. We value this feedback and use this when testing. Thank you!"
                    },
                    {
                        component: "group-list",
                        name: "topSearchTerms",
                        label: "Top Search Terms",
                        itemProps: {
                            label: "{{item.searchTerm}}"
                        },
                        fields: [
                            {
                                component: "text",
                                name: "searchTerm",
                                label: "Search Term"
                            }, 
                        ]
                    }, 
                ]
            }, 
        ]
    };
};

;// CONCATENATED MODULE: ./src/sections/LabResults/LabResults.jsx








function LabResults(param) {
    var cms = param.cms;
    var ref;
    var contaminants = cms.contaminants, search = cms.search;
    var mergedContaminants = useMergedContaminants(utils_flattenContaminant(contaminants));
    var ref1 = (0,react.useState)([]), openAccordions = ref1[0], setOpenAccordions = ref1[1];
    // These handle which category / contaminants are current being searched upon
    var ref2 = (0,react.useState)(""), searchedCategory = ref2[0], setSearchedCategory = ref2[1];
    var ref3 = (0,react.useState)(""), searchedContaminant = ref3[0], setSearchedContaminant = ref3[1];
    var ref4 = (0,react.useState)(""), foundContaminant = ref4[0], setFoundContaminant = ref4[1];
    var ref5 = (0,react.useState)([]), autoCompleteResults = ref5[0], setAutoCompleteResults = ref5[1];
    var ref6 = (0,react.useState)(false), categoryDropdownOpen = ref6[0], setCategoryDropdownOpen = ref6[1];
    // Hide autocomplete search results on outside click & Blur
    var searchInput = (0,react.useRef)();
    (0,react.useEffect)(function() {
        var handleClick = function(event) {
            if (searchInput.current && !searchInput.current.contains(event.target)) {
                setAutoCompleteResults([]);
            }
        };
        document.addEventListener("click", handleClick, true);
        return function() {
            document.removeEventListener("click", handleClick, true);
        };
    }, [
        searchInput
    ]);
    var scrollToSearchedCategory = function(cat) {
        var ref;
        var category = cat !== null && cat !== void 0 ? cat : searchedCategory;
        var categoryIndex = (ref = Object.keys(mergedContaminants)) === null || ref === void 0 ? void 0 : ref.indexOf(category);
        if (categoryIndex >= 0) {
            setOpenAccordions([]);
            setTimeout(function() {
                var ref;
                (ref = document.getElementById("category-".concat(categoryIndex))) === null || ref === void 0 ? void 0 : ref.scrollIntoView();
                setSearchedCategory(category);
                setOpenAccordions([
                    category
                ]);
            }, 0);
        }
    };
    var setAutoCompleteWithFuse = function(contaminant) {
        var ref, ref1;
        setAutoCompleteResults([]);
        setSearchedContaminant(contaminant);
        setFoundContaminant("");
        // Normalize our contaminants for use in Fuse Search
        var normalizedContaminants = [];
        Object.keys(mergedContaminants).forEach(function(category) {
            normalizedContaminants = (0,_to_consumable_array/* default */.Z)(normalizedContaminants).concat((0,_to_consumable_array/* default */.Z)(mergedContaminants[category].contaminants));
        });
        // adding categories to the suggestions list, in case the user searches for a category
        // instead of the direct contaminant name
        normalizedContaminants = (0,_to_consumable_array/* default */.Z)(normalizedContaminants).concat((0,_to_consumable_array/* default */.Z)(Object.keys(mergedContaminants).map(function(category) {
            return {
                name: category,
                category: category,
                aliases: [
                    category
                ]
            };
        })));
        var aliases = normalizedContaminants.filter(function(c) {
            var ref;
            return ((ref = c.aliases) === null || ref === void 0 ? void 0 : ref.length) > 1;
        });
        var flatAliases = aliases.map(function(aliasContaminant) {
            return (0,_to_consumable_array/* default */.Z)(aliasContaminant.aliases.map(function(alias) {
                return {
                    name: alias,
                    isAlias: true,
                    originalContaminant: aliasContaminant,
                    category: aliasContaminant.category,
                    aliases: [
                        alias
                    ]
                };
            }));
        }).flat();
        // adding suggestions to the suggestions list, in case the user searches for a suggestion
        // instead of the direct contaminant name
        normalizedContaminants = (0,_to_consumable_array/* default */.Z)(normalizedContaminants).concat((0,_to_consumable_array/* default */.Z)(flatAliases));
        // Conduct a Fuse Search
        var fuse = new fuse_esm/* default */.Z(normalizedContaminants, {
            shouldSort: true,
            threshold: 0.3,
            minMatchCharLength: 1,
            keys: [
                "name",
                "aliases"
            ]
        });
        var result = fuse.search(contaminant).slice(0, 8);
        setAutoCompleteResults(result);
        // If an exact match is found, let's just use that
        if (((ref = result[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.item) === null || ref1 === void 0 ? void 0 : ref1.name.toLowerCase()) === contaminant.toLowerCase()) {
            // Reconnect aliases
            var resultContaminant = result[0].item.isAlias ? result[0].item.originalContaminant : result[0].item;
            setFoundContaminant(resultContaminant.name);
            setAutoCompleteResults([]);
            scrollToSearchedCategory(resultContaminant.category);
        }
    };
    // Handle toggling a category accordion
    var toggleAccordionItem = function(categoryKey) {
        var currentOpenAccordions = (0,_to_consumable_array/* default */.Z)(openAccordions);
        if (currentOpenAccordions.includes(categoryKey)) currentOpenAccordions.splice(currentOpenAccordions.indexOf(categoryKey), 1);
        else currentOpenAccordions.push(categoryKey);
        setOpenAccordions(currentOpenAccordions);
    };
    // Set the initial Category to be toggled Open
    (0,react.useEffect)(function() {
        var ref;
        setOpenAccordions([
            (ref = mergedContaminants[Object.keys(mergedContaminants)[0]]) === null || ref === void 0 ? void 0 : ref.categoryName, 
        ]);
    }, []);
    var sortSearchedContaminants = function(a, b) {
        if ((a === null || a === void 0 ? void 0 : a.name) === foundContaminant) return -1;
        if ((b === null || b === void 0 ? void 0 : b.name) === foundContaminant) return 1;
        return 0;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "lab-results px-contained py-[32px] md:py-[62px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "lab-results__search-bar",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "search-bar__inputs flex items-center justify-between border-b border-b-[#DDE2E7] pb-[14px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "search-input relative flex-grow rounded-full border border-border bg-white p-[5px] md:border-none md:bg-transparent md:p-0",
                                ref: searchInput,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                                                className: "w-5 text-text",
                                                src: "/svgs/search.svg#search",
                                                title: "Search",
                                                viewBox: "0 0 24 24"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                autoComplete: "off",
                                                id: "lab-results-search-input",
                                                className: "font-shadowGray w-full bg-transparent px-2 py-1 text-sm text-shadowGray outline-0 md:px-4 md:text-base",
                                                placeholder: (search === null || search === void 0 ? void 0 : search.searchPlaceholderText) || "Search...",
                                                type: "text",
                                                onKeyDown: function(event) {
                                                    if (event.key === "Enter") {
                                                        setAutoCompleteResults([]);
                                                    }
                                                },
                                                onChange: function(event) {
                                                    setAutoCompleteWithFuse(event.target.value);
                                                },
                                                value: searchedContaminant
                                            })
                                        ]
                                    }),
                                    (autoCompleteResults === null || autoCompleteResults === void 0 ? void 0 : autoCompleteResults.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        id: "lab-results-search-autocomplete",
                                        className: "absolute z-10 rounded-[21px] border border-[#E9E9EB] bg-white px-[32px] py-[16px]",
                                        children: autoCompleteResults.map(function(result, autoCompleteIndex) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                type: "button",
                                                className: "mb-[10px] block w-full text-left last:mb-0 ",
                                                onClick: function() {
                                                    setAutoCompleteResults([]);
                                                    setFoundContaminant(result.item.name);
                                                    setSearchedContaminant(result.item.name);
                                                    scrollToSearchedCategory(result.item.category);
                                                },
                                                children: result.item.name
                                            }, "auto-complete-".concat(autoCompleteIndex));
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "category-input ml-6 flex-[0_0_135px] md:flex-[0_0_213px] ".concat(categoryDropdownOpen ? "" : "flex justify-end"),
                                children: Object.keys(mergedContaminants).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "relative",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Button */.zx, {
                                            theme: "dark",
                                            variant: "outlined",
                                            className: "relative z-20 w-full justify-start !px-[20px] !py-[10px] !text-left ".concat(categoryDropdownOpen ? "bg-white" : "bg-background"),
                                            onClick: function() {
                                                setCategoryDropdownOpen(!categoryDropdownOpen);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(snippets/* Body */.uT, {
                                                variant: "small",
                                                element: "span",
                                                className: "flex justify-between",
                                                children: [
                                                    searchedCategory || "Categories",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                                                        className: "ml-6 w-4 text-text ".concat(categoryDropdownOpen ? "rotate-[270deg] scale-x-50 scale-y-75" : "rotate-90 scale-x-50 scale-y-75"),
                                                        src: "/svgs/play.svg#play",
                                                        title: "Chevron",
                                                        viewBox: "0 0 24 24"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            className: "absolute z-10 w-full -translate-y-6 flex-col items-start gap-2 rounded-b-[21px] border border-[#E9E9EB] bg-white p-4 pt-6 ".concat(categoryDropdownOpen ? "visible" : "hidden"),
                                            children: (ref = Object.keys(mergedContaminants)) === null || ref === void 0 ? void 0 : ref.map(function(contaminantCategory, categoryIndex) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        type: "button",
                                                        className: "w-full py-1 text-left",
                                                        value: contaminantCategory,
                                                        onClick: function() {
                                                            setCategoryDropdownOpen(false);
                                                            setSearchedContaminant("");
                                                            setFoundContaminant("");
                                                            setAutoCompleteResults([]);
                                                            scrollToSearchedCategory(contaminantCategory);
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Body */.uT, {
                                                            variant: "small",
                                                            element: "span",
                                                            children: contaminantCategory
                                                        })
                                                    })
                                                }, "category-select-".concat(categoryIndex));
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "search-bar__top-searches mt-[30px] flex flex-wrap items-center gap-[20px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "top-searches__label",
                                children: "Top Searches"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "top-searches__pills overflow-hidden",
                                children: (search === null || search === void 0 ? void 0 : search.topSearchTerms) && Object.keys(search === null || search === void 0 ? void 0 : search.topSearchTerms).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "no-scrollbar flex gap-[20px] overflow-auto lg:flex-wrap",
                                    children: search.topSearchTerms.map(function(searchTermObject, searchTermIndex) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Button */.zx, {
                                                onClick: function() {
                                                    setAutoCompleteResults([]);
                                                    setSearchedContaminant(searchTermObject.searchTerm);
                                                    setFoundContaminant(searchTermObject.searchTerm);
                                                    Object.keys(mergedContaminants).forEach(function(contaminantCategory, categoryIndex) {
                                                        mergedContaminants === null || mergedContaminants === void 0 ? void 0 : mergedContaminants[contaminantCategory].contaminants.forEach(function(contaminantObject) {
                                                            if (searchTermObject.searchTerm === contaminantObject.name) {
                                                                scrollToSearchedCategory(contaminantCategory);
                                                            }
                                                        });
                                                    });
                                                },
                                                variant: "outlined",
                                                theme: "dark",
                                                className: "w-max !px-[20px] !py-[10px] !font-[#202635]",
                                                children: searchTermObject.searchTerm
                                            })
                                        }, "search-term-".concat(searchTermIndex));
                                    })
                                })
                            })
                        ]
                    }),
                    /* No Results Found */ searchedContaminant !== "" && foundContaminant === "" && autoCompleteResults.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        id: "no-results",
                        className: "serach-bar__no-results mt-[40px]",
                        children: [
                            (search === null || search === void 0 ? void 0 : search.noResultsHeading) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                                variant: "h4",
                                element: "h4",
                                className: "no-results__heading",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: search.noResultsHeading.replace("{search term}", '<span class="text-[#3383C5]">'.concat(searchedContaminant, "</span>"))
                                    }
                                })
                            }),
                            (search === null || search === void 0 ? void 0 : search.noResultsContent) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Body */.uT, {
                                variant: "medium",
                                className: "no-results__content mt-4",
                                children: search.noResultsContent
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "lab-results__main-results overflow-auto pt-[54px]",
                children: Object.keys(mergedContaminants).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    children: /* Loop over Categories first */ Object.keys(mergedContaminants).map(function(contaminantCategory, categoryIndex) {
                        var ref, /* Loop over contaminants */ ref1, ref2, ref3, ref4, ref5, ref6;
                        var category = mergedContaminants[contaminantCategory];
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            id: "category-".concat(categoryIndex),
                            className: "contaminant-category mb-[17px] rounded-[10px] bg-white p-[15px] md:mb-[30px] md:p-[30px] ".concat(openAccordions.includes(contaminantCategory) ? "" : "[&_.contaminant-category-details_.category-description]:hidden [&_.contaminants-section]:hidden", " ").concat(contaminantCategory === searchedCategory ? "border border-primary" : ""),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "contaminant-category-details",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(snippets/* Headline */.s0, {
                                            element: "h3",
                                            variant: "h5",
                                            className: "category-name flex cursor-pointer items-center justify-between",
                                            onClick: function() {
                                                return toggleAccordionItem(contaminantCategory);
                                            },
                                            children: [
                                                contaminantCategory,
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "h-[35px] w-[35px] rounded-full bg-gradient-to-t from-[#5881D9] to-[#C2F0FA] md:h-[50px] md:w-[50px]",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex h-full w-full scale-95 items-center justify-center rounded-full bg-white",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                                                            className: "w-[10px] text-text md:w-[15px] ".concat(openAccordions.includes(contaminantCategory) ? "rotate-180" : ""),
                                                            src: "/svgs/chevron-down.svg#chevron-down",
                                                            title: "Chevron Down",
                                                            viewBox: "0 0 24 24"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        (mergedContaminants === null || mergedContaminants === void 0 ? void 0 : (ref = mergedContaminants[contaminantCategory]) === null || ref === void 0 ? void 0 : ref.categoryDescription) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Body */.uT, {
                                            variant: "small",
                                            className: "category-description w-full max-w-[calc(100%-75px)] pt-[24px] md:max-w-[833px]",
                                            children: mergedContaminants[contaminantCategory].categoryDescription
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "contaminants-section overflow-x-auto pt-[32px] scrollbar-hide",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "hidden flex-col md:flex md:min-w-[1100px]",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                    className: "contaminants-heading order-1 flex justify-end text-[12px] font-light text-white md:text-[18px]",
                                                    style: {
                                                        background: "linear-gradient(270deg, #5B71A1 0%, #536896 10.94%, #4D618E 19.27%, #354974 33.84%, #354C7A 50.38%, #3C5280 65.88%, #3A4C79 77.84%, #232F54 100%)"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            className: "flex flex-[0_0_65%] items-center p-[10px] md:flex-auto lg:p-[22px]",
                                                            children: "Contaminant"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                            className: "flex flex-[0_0_35%] flex-col items-center justify-center p-[10px] text-center md:flex-[0_0_200px] lg:p-[22px] ",
                                                            children: [
                                                                "Challenge Water",
                                                                category.challengeWaterUnits && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    className: "text-xs md:text-sm",
                                                                    children: [
                                                                        "\xa0",
                                                                        category.challengeWaterUnits
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                            className: "flex flex-[0_0_35%] flex-col items-center justify-center p-[10px] text-center md:flex-[0_0_200px] lg:p-[22px] ",
                                                            children: [
                                                                "Filtered Water",
                                                                category.filteredWaterUnits && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    className: "text-xs md:text-sm",
                                                                    children: [
                                                                        "\xa0",
                                                                        category.filteredWaterUnits
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            className: "flex flex-[0_0_35%] flex-col items-center justify-center p-[10px] text-center md:flex-[0_0_200px] lg:p-[22px]",
                                                            children: "% Removal"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            className: "flex flex-[0_0_35%] flex-col items-center justify-center p-[10px] text-center md:flex-[0_0_200px] lg:p-[22px]",
                                                            children: "Health Concern"
                                                        })
                                                    ]
                                                }),
                                                ((ref1 = mergedContaminants[contaminantCategory]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.contaminants) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 && ((ref3 = mergedContaminants[contaminantCategory]) === null || ref3 === void 0 ? void 0 : ref3.contaminants.map(function(contaminant, contaminantIndex) {
                                                    var ref, ref1, ref2, ref3, ref4;
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                        className: "contaminant flex justify-end border border-[#2026351A] ".concat((contaminant === null || contaminant === void 0 ? void 0 : contaminant.name) === foundContaminant ? "order-2 bg-[#cce0f1]" : "order-3"),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Body */.uT, {
                                                                variant: "medium",
                                                                element: "li",
                                                                className: "flex flex-[0_0_65%] items-center border-r border-[#2026351A] p-[10px] text-[12px] md:flex-auto md:text-[18px] lg:p-[22px]",
                                                                children: (ref = contaminant === null || contaminant === void 0 ? void 0 : contaminant.name) !== null && ref !== void 0 ? ref : " "
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Body */.uT, {
                                                                variant: "medium",
                                                                element: "li",
                                                                className: "flex flex-[0_0_35%] items-center justify-center border-r border-[#2026351A] p-[10px] text-center text-[12px] md:flex-[0_0_200px] md:text-[18px] lg:p-[22px]",
                                                                children: (ref1 = contaminant === null || contaminant === void 0 ? void 0 : contaminant.challengeWater) !== null && ref1 !== void 0 ? ref1 : " "
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Body */.uT, {
                                                                variant: "medium",
                                                                element: "li",
                                                                className: "flex flex-[0_0_35%] items-center justify-center border-r border-[#2026351A] p-[10px] text-center text-[12px] md:flex-[0_0_200px] md:text-[18px] lg:p-[22px]",
                                                                children: (ref2 = contaminant === null || contaminant === void 0 ? void 0 : contaminant.filteredWater) !== null && ref2 !== void 0 ? ref2 : " "
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                className: "flex flex-[0_0_35%] items-center justify-center border-r border-[#2026351A] p-[10px] text-center font-light md:flex-[0_0_200px] md:text-[28px] lg:p-[22px]",
                                                                children: (ref3 = contaminant === null || contaminant === void 0 ? void 0 : contaminant.percentRemoved) !== null && ref3 !== void 0 ? ref3 : " "
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Body */.uT, {
                                                                variant: "medium",
                                                                element: "li",
                                                                className: "flex flex-[0_0_35%] items-center justify-center p-[10px] text-center text-[12px] md:flex-[0_0_200px] md:text-[18px] lg:p-[22px]",
                                                                children: (ref4 = contaminant === null || contaminant === void 0 ? void 0 : contaminant.healthConcern) !== null && ref4 !== void 0 ? ref4 : " "
                                                            })
                                                        ]
                                                    }, "contaminant-".concat(contaminantIndex));
                                                }))
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex gap-0 md:hidden [&_td]:whitespace-nowrap [&_td]:border [&_td]:border-[#2026351A] [&_td]:p-[10px] [&_th]:whitespace-nowrap [&_th]:text-[12px] [&_th]:font-light [&_th]:text-white",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex overflow-auto",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                                            style: {
                                                                background: "linear-gradient(270deg, #5B71A1 0%, #536896 10.94%, #4D618E 19.27%, #354974 33.84%, #354C7A 50.38%, #3C5280 65.88%, #3A4C79 77.84%, #232F54 100%)"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                        className: "sticky left-0 max-w-[60vw] p-[10px]",
                                                                        style: {
                                                                            background: "linear-gradient(45deg, rgb(53 73 116), #3a4f7c)"
                                                                        },
                                                                        children: "Contaminants"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                        className: "p-[10px]",
                                                                        children: "% Removal"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("th", {
                                                                        className: "p-[10px]",
                                                                        children: [
                                                                            "Challenge Water",
                                                                            category.challengeWaterUnits && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                className: "text-xs md:text-sm",
                                                                                children: [
                                                                                    "\xa0",
                                                                                    category.challengeWaterUnits
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("th", {
                                                                        className: "p-[10px]",
                                                                        children: [
                                                                            "Filtered Water",
                                                                            category.filteredWaterUnits && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                className: "text-xs md:text-sm",
                                                                                children: [
                                                                                    "\xa0",
                                                                                    category.filteredWaterUnits
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                        className: "p-[10px]",
                                                                        children: "Health Concern"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                                            children: ((ref4 = mergedContaminants[contaminantCategory]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.contaminants) === null || ref5 === void 0 ? void 0 : ref5.length) > 0 && ((ref6 = mergedContaminants[contaminantCategory]) === null || ref6 === void 0 ? void 0 : ref6.contaminants.sort(sortSearchedContaminants).map(function(contaminant, contaminantIndex) {
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                                    className: "p-[10px] md:items-center lg:p-[22px] lg:text-center ".concat((contaminant === null || contaminant === void 0 ? void 0 : contaminant.name) === foundContaminant ? "bg-[#cce0f1]" : ""),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                            className: "sticky left-0 max-w-[60vw] overflow-hidden text-ellipsis ".concat((contaminant === null || contaminant === void 0 ? void 0 : contaminant.name) === foundContaminant ? "bg-[#cce0f1]" : "bg-white"),
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Body */.uT, {
                                                                                variant: "small",
                                                                                children: contaminant.name
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                            className: "text-center",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Body */.uT, {
                                                                                variant: "medium",
                                                                                children: contaminant.percentRemoved
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                            className: "text-center",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Body */.uT, {
                                                                                variant: "small",
                                                                                children: contaminant.challengeWater
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                            className: "text-center",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Body */.uT, {
                                                                                variant: "small",
                                                                                children: contaminant.filteredWater
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                            className: "text-center",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Body */.uT, {
                                                                                variant: "small",
                                                                                children: contaminant.healthConcern
                                                                            })
                                                                        })
                                                                    ]
                                                                }, "mobile-contaminant-".concat(contaminantIndex));
                                                            }))
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }, "contaminant-category-".concat(categoryIndex));
                    })
                })
            })
        ]
    });
}
LabResults.displayName = "LabResults";
LabResults.Schema = LabResults_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/LabResults/index.js


;// CONCATENATED MODULE: ./src/sections/LabResultsNavigation/LabResultsNavigation.schema.js
var LabResultsNavigation_schema_Schema = function() {
    return {
        label: "Lab Results Navigation",
        key: "labResultsNavigation",
        category: "Lab Results",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/lab-results-nav.png?v=1685037549",
        fields: [
            {
                name: "heading",
                component: "text",
                label: "Heading"
            },
            {
                label: "Menu Links",
                name: "links",
                component: "group-list",
                itemProps: {
                    label: "{{item.link.text}}"
                },
                fields: [
                    {
                        label: "Link",
                        name: "link",
                        component: "link"
                    },
                    {
                        label: "Image",
                        name: "image",
                        component: "image"
                    }, 
                ]
            }, 
        ]
    };
};

;// CONCATENATED MODULE: ./src/sections/LabResultsNavigation/LabResultsNavigation.jsx





function LabResultsNavigation(param) {
    var cms = param.cms;
    var asPath = (0,next_router.useRouter)().asPath;
    var links = cms.links, heading = cms.heading;
    var ref = (0,react.useState)(false), renderClientSideComponent = ref[0], setRenderClientSideComponent = ref[1];
    (0,react.useEffect)(function() {
        setRenderClientSideComponent(true);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "lab-results-navigation py-[50px]",
        children: [
            heading && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Subheading */.pm, {
                className: "px-contained mb-2 text-[13px] uppercase lg:text-center lg:text-lg",
                children: heading
            }),
            (links === null || links === void 0 ? void 0 : links.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "flex gap-3 overflow-auto bg-[#f2f7fb] p-4 lg:justify-center",
                children: links.map(function(item, index) {
                    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "flex h-[163px] flex-[0_0_160px] md:order-none\n                ".concat((item === null || item === void 0 ? void 0 : (ref = item.link) === null || ref === void 0 ? void 0 : ref.url) === asPath && renderClientSideComponent ? "order-0" : "order-1"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                            className: "flex h-full w-full flex-col justify-center overflow-hidden rounded-[10px] border p-[10px] text-text duration-200 ".concat((item === null || item === void 0 ? void 0 : (ref1 = item.link) === null || ref1 === void 0 ? void 0 : ref1.url) === asPath && renderClientSideComponent ? "border-primary bg-white" : "border-[#DDE2E7] bg-[#E6F0F8]"),
                            "aria-label": (ref2 = item.link) === null || ref2 === void 0 ? void 0 : ref2.text,
                            href: item === null || item === void 0 ? void 0 : (ref3 = item.link) === null || ref3 === void 0 ? void 0 : ref3.url,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mobile-nav-item flex flex-col items-center",
                                    children: [
                                        (item === null || item === void 0 ? void 0 : (ref4 = item.image) === null || ref4 === void 0 ? void 0 : ref4.src) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mobile-image relative aspect-[1/1] w-full max-w-[85px]",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                                fill: true,
                                                alt: item === null || item === void 0 ? void 0 : (ref5 = item.link) === null || ref5 === void 0 ? void 0 : ref5.text,
                                                className: "object-contain mix-blend-multiply",
                                                sizes: "(min-width: 1440px) 900px, (min-width: 768px) 50vw, 100vw",
                                                src: item === null || item === void 0 ? void 0 : (ref6 = item.image) === null || ref6 === void 0 ? void 0 : ref6.src,
                                                quality: "90"
                                            })
                                        }) : null,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mobile-text mt-4 text-center text-xs uppercase",
                                            children: (item === null || item === void 0 ? void 0 : item.mobileText) ? item.mobileText : item === null || item === void 0 ? void 0 : (ref7 = item.link) === null || ref7 === void 0 ? void 0 : ref7.text
                                        })
                                    ]
                                })
                            })
                        })
                    }, index);
                })
            }) : null
        ]
    });
}
LabResultsNavigation.displayName = "LabResultsNavigation";
LabResultsNavigation.Schema = LabResultsNavigation_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/LabResultsNavigation/index.js


;// CONCATENATED MODULE: ./src/sections/LabResultsOverview/LabResultsOverview.schema.js
var LabResultsOverview_schema_Schema = function() {
    return {
        category: "Lab Results",
        label: "Lab Results Overview",
        key: "labResultsOverview",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/lab-results-overview.png?v=1685040204",
        fields: [
            {
                label: "Section Title",
                name: "sectionTitle",
                component: "text",
                defaultValue: "Performance Data"
            },
            {
                label: "Featured Image",
                name: "featuredImage",
                component: "image"
            },
            {
                label: "Value Props",
                name: "valueProps",
                component: "group-list",
                itemProps: {
                    label: "Prop: {{item.propTitle}}"
                },
                validate: {
                    maxItems: 6
                },
                fields: [
                    {
                        label: "Prop Title",
                        name: "propTitle",
                        component: "text"
                    },
                    {
                        label: "Prop Value",
                        name: "propValue",
                        component: "text"
                    }, 
                ]
            },
            {
                label: "Asset Link",
                name: "assetLink",
                component: "link"
            },
            {
                label: "Section Disclosure",
                name: "sectionDisclosure",
                component: "textarea",
                defaultValue: "Tests performed in accordance with NSF Standards 42, 53 & 401 for water quality and the reduction of chemicals and contaminants. The water was spiked with the substances indicated below and then passed through the filter. The results are stated in the report below. All contaminants were reduced to a concentration equal to or less than the permissible limits set forth by NSF."
            }, 
        ]
    };
};

;// CONCATENATED MODULE: ./src/sections/LabResultsOverview/LabResultsOverview.jsx



function LabResultsOverview(param) {
    var cms = param.cms;
    var assetLink = cms.assetLink, valueProps = cms.valueProps, sectionTitle = cms.sectionTitle, sectionDisclosure = cms.sectionDisclosure, featuredImage = cms.featuredImage;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "lab-results-overview border-t border-[#DDE2E7] py-[62px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "px-contained mx-auto max-w-[1155px]",
            children: [
                /* Section Title */ sectionTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                    element: "h2",
                    variant: "h3",
                    className: "lab-results__title mb-7 text-center",
                    children: sectionTitle
                }),
                /* Value Props */ (valueProps === null || valueProps === void 0 ? void 0 : valueProps.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "lab-results__value-props-wrapper rounded-[17px] bg-[#D9D9D9] bg-gradient-to-l from-[#2179C2] via-[#8DCEF9] to-[#F1DCC1] p-[1px]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "rounded-[16px] bg-[var(--clearBlue)] p-[20px] md:flex",
                        children: [
                            featuredImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mx-auto flex w-full max-w-[200px] flex-[0_0_200px] items-center p-4 pl-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative aspect-[200/208] w-full",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                        fill: true,
                                        alt: sectionTitle || "Performance Data",
                                        className: "object-contain mix-blend-multiply",
                                        sizes: "(min-width: 1440px) 300px, (min-width: 768px) 50vw, 100vw",
                                        src: featuredImage === null || featuredImage === void 0 ? void 0 : featuredImage.src,
                                        quality: "90"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "lab-results__value-props flex-auto border-l-[#2026351A] md:grid md:grid-cols-3 md:border-l md:pl-[20px]",
                                children: valueProps.map(function(valueProp, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        className: "lab-results__value-prop border-b border-l-[#2026351A] border-b-[#2026351A] p-4 last:border-b-0 md:min-h-[125px] md:border-l md:[&:nth-child(3n+1)]:border-l-0 md:[&:nth-last-child(-n+3)]:border-b-0 ",
                                        children: [
                                            (valueProp === null || valueProp === void 0 ? void 0 : valueProp.propTitle) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Eyebrow */.j4, {
                                                className: "uppercase text-textLink",
                                                children: valueProp.propTitle
                                            }),
                                            (valueProp === null || valueProp === void 0 ? void 0 : valueProp.propValue) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Body */.uT, {
                                                variant: "small",
                                                children: valueProp.propValue
                                            })
                                        ]
                                    }, "value-prop-".concat(index));
                                })
                            })
                        ]
                    })
                }),
                /* Disclosure & Asset Link */ (sectionDisclosure || (assetLink === null || assetLink === void 0 ? void 0 : assetLink.url)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "lab-results__disclosure mt-[22px] items-center justify-between gap-[22px] md:flex",
                    children: [
                        sectionDisclosure && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Body */.uT, {
                            variant: "xs",
                            className: "flex-auto max-md:mb-[26px]",
                            children: sectionDisclosure
                        }),
                        (assetLink === null || assetLink === void 0 ? void 0 : assetLink.url) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(snippets/* Link */.rU, {
                            className: "flex flex-[1_0_280px] items-center justify-center rounded-[68px] border border-primary py-[16px] px-[35px] text-[17px] max-md:max-w-[212px] max-md:text-xs",
                            "aria-label": assetLink === null || assetLink === void 0 ? void 0 : assetLink.text,
                            href: assetLink === null || assetLink === void 0 ? void 0 : assetLink.url,
                            newTab: assetLink === null || assetLink === void 0 ? void 0 : assetLink.newTab,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                                    className: "mr-[22px] h-[25px] w-[25px] text-textLink",
                                    src: "/svgs/noprecache/icons/download.svg#download",
                                    title: "Download",
                                    viewBox: "0 0 25 25"
                                }),
                                assetLink === null || assetLink === void 0 ? void 0 : assetLink.text
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
LabResultsOverview.displayName = "LabResultsOverview";
LabResultsOverview.Schema = LabResultsOverview_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/LabResultsOverview/index.js


;// CONCATENATED MODULE: ./src/sections/Legal/Legal.schema.js
function Legal_schema_Schema() {
    return {
        category: "Text",
        label: "Legal",
        key: "legal",
        fields: [
            {
                label: "Body",
                name: "body",
                component: "markdown"
            },
            {
                label: "Legal Menu Item",
                name: "legalMenuItems",
                component: "group-list",
                itemProps: {
                    label: "{{item.header}}"
                },
                fields: [
                    {
                        label: "Header",
                        name: "header",
                        component: "text"
                    },
                    {
                        label: "Url",
                        name: "url",
                        component: "text"
                    }, 
                ],
                defaultValue: [
                    {
                        header: "Privacy",
                        url: "privacy"
                    }, 
                ],
                defaultItem: {
                    header: "Privacy",
                    url: "privacy"
                }
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/Legal/LegalMenu.jsx





function LegalMenu(param) {
    var menuItems = param.menuItems;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), activeItem = ref[0], setActiveItem = ref[1];
    var ref1 = (0,react.useState)(false), activeMenu = ref1[0], setActiveMenu = ref1[1];
    (0,react.useEffect)(function() {
        var findActiveItem = function() {
            var active = menuItems.filter(function(item) {
                return "/pages/".concat(item.url) === router.asPath;
            });
            setActiveItem(active[0]);
        };
        findActiveItem();
    }, []);
    return menuItems && menuItems.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "lg:hidden",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex cursor-pointer items-center justify-between border-b border-zinc-200 bg-white p-4",
                onClick: function() {
                    return setActiveMenu(!activeMenu);
                },
                children: [
                    (activeItem === null || activeItem === void 0 ? void 0 : activeItem.header) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                        className: "text-xl font-light tracking-[-.01em]",
                        children: activeItem.header
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                                className: "".concat(!activeMenu ? "block" : "hidden", " w-5 text-text"),
                                src: "/svgs/chevron-down.svg#chevron-down",
                                title: "Close",
                                viewBox: "0 0 24 24"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                                className: "".concat(activeMenu ? "block" : "hidden", " w-5 text-text"),
                                src: "/svgs/chevron-up.svg#chevron-up",
                                title: "Close",
                                viewBox: "0 0 24 24"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat(activeMenu ? "block" : "hidden"),
                children: menuItems.filter(function(item) {
                    return "/pages/".concat(item.url) !== router.asPath;
                }).map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: item.url,
                        className: "",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex cursor-pointer items-center justify-between border-b border-zinc-200 bg-white p-4 text-xl font-light tracking-[-.01em]",
                            children: item.header
                        })
                    }, index);
                })
            })
        ]
    });
}
LegalMenu.displayName = "Legal Menu";

;// CONCATENATED MODULE: ./src/sections/Legal/LegalMenuItem.jsx



function LegalMenuItem(param) {
    var item = param.item;
    var header = item.header, url = item.url;
    var fullUrl = "/pages/".concat(url);
    var ref = (0,react.useState)(false), isActive = ref[0], setIsActive = ref[1];
    (0,react.useEffect)(function() {
        var findActiveUrl = function() {
            if (fullUrl === window.location.pathname) {
                setIsActive(true);
            }
        };
        findActiveUrl();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: "relative mb-4 transition duration-300 ".concat(isActive ? "active" : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: fullUrl,
            children: header
        })
    });
}
LegalMenuItem.displayName = "Legal Menu Item";

;// CONCATENATED MODULE: ./src/sections/Legal/Legal.jsx





function Legal(param) {
    var cms = param.cms;
    var body = cms.body, legalMenuItems = cms.legalMenuItems;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "legal lg:px-contained overflow-hidden bg-clearBlue lg:flex lg:pt-16",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "legal-menu relative lg:w-1/3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LegalMenu, {
                        menuItems: legalMenuItems
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mb-4 hidden text-lg uppercase lg:block",
                        children: "Legal"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "hidden max-w-xs lg:block",
                        children: legalMenuItems === null || legalMenuItems === void 0 ? void 0 : legalMenuItems.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LegalMenuItem, {
                                item: item
                            }, index);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "legal__markdown my-4 max-w-xl px-4 md:my-2 lg:w-2/3 lg:px-0 xl:my-12",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Markdown */.UG, {
                    children: body
                })
            })
        ]
    });
}
Legal.displayName = "Legal";
Legal.Schema = Legal_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/Legal/index.js


;// CONCATENATED MODULE: ./src/sections/Newsletter/Newsletter.schema.js
var Newsletter_schema_Schema = function() {
    return {
        label: "Newsletter",
        category: "Newsletter",
        key: "newsletter",
        fields: [
            {
                label: "Background Image",
                name: "image",
                component: "image"
            },
            {
                name: "heading",
                component: "text",
                label: "Heading",
                defaultValue: "Sign up for our monthly newsletter"
            },
            {
                name: "copy",
                component: "text",
                label: "Copy",
                defaultValue: "Sign up to receive the latest news, lab tests, contaminants and much much much more."
            },
            {
                name: "disclaimer",
                component: "text",
                label: "Disclaimer",
                defaultValue: "By signing up you agree to our User Agreement Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et."
            }, 
        ]
    };
};

;// CONCATENATED MODULE: ./src/sections/Newsletter/Newsletter.jsx








function Newsletter(param) {
    var cms = param.cms;
    var sendSubscribeEvent = (0,hooks/* useDataLayerActions */.KZ)().sendSubscribeEvent;
    var image = cms.image, heading = cms.heading, copy = cms.copy, disclaimer = cms.disclaimer;
    var ref = (0,react.useState)(""), formEmail = ref[0], setFormEmail = ref[1];
    var ref1 = (0,react.useState)(false), isSuccessful = ref1[0], setIsSuccessful = ref1[1];
    var handleNewsletterSignup = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
            var klaviyoResponse;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        return [
                            4,
                            fetch("/api/klaviyo-subscribe", {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify({
                                    emailAddress: formEmail
                                })
                            })
                        ];
                    case 1:
                        klaviyoResponse = _state.sent();
                        if (klaviyoResponse.status === 200) {
                            setIsSuccessful(true);
                            setFormEmail("");
                            sendSubscribeEvent({
                                email: formEmail,
                                form_id: "newsletter_signup"
                            });
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleNewsletterSignup(event) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "newseletter relative flex min-h-[475px] items-center justify-center lg:min-h-[620px]",
        children: [
            (image === null || image === void 0 ? void 0 : image.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute mx-auto h-[475px] w-full lg:h-[620px] ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                    src: image.src,
                    alt: "icon",
                    fill: true,
                    className: "mx-auto mb-4 object-cover"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-contained relative mx-auto max-w-[1200px] overflow-hidden py-12",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute left-4 top-0 h-full w-full max-w-[calc(100%-2em)] bg-gradient-to-r from-[#2179C2] via-[#8DCEF9] to-[#F1DCC1] opacity-30 lg:left-0 lg:max-w-full"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute left-4 top-0 h-full w-full max-w-[calc(100%-2em)] bg-[#fff] opacity-70 lg:left-0 lg:max-w-full"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "lx:px-16 relative z-10 flex flex-wrap items-center justify-between px-6 py-0 lg:flex-nowrap lg:py-20",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                id: "email-signup-left",
                                className: "mb-4 flex-[0_0_100%] text-xl font-[300] lg:mb-0 lg:flex-[0_0_45%] lg:text-[28px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                                        variant: "h4",
                                        className: "max-w-[360px]",
                                        children: heading
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Body */.uT, {
                                        variant: "medium",
                                        className: "mt-6 max-w-[370px]",
                                        children: copy
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                id: "email-signup-right",
                                className: "flex flex-[0_0_100%] flex-col justify-between lg:flex-[0_0_55%] [&_svg]:text-black",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex justify-between border-b border-b-[#202635]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                                            className: "klaviyo-form-PAPDgq w-full",
                                            onSubmit: handleNewsletterSignup,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                        type: "email",
                                                        value: formEmail,
                                                        placeholder: "Enter your email",
                                                        onChange: function(event) {
                                                            setFormEmail(event.target.value);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                        type: "submit",
                                                        children: [
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                                                                className: "w-[24px] text-white",
                                                                src: "/svgs/arrow-right.svg#arrow-right",
                                                                title: "Submit",
                                                                viewBox: "0 0 24 24"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    isSuccessful && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "py-6",
                                        children: "Thanks for subscribing! Your submission was received successfully."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Body */.uT, {
                                        variant: "xs",
                                        className: "mt-6",
                                        children: disclaimer
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
Newsletter.displayName = "Newsletter";
Newsletter.Schema = Newsletter_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/Newsletter/index.js


;// CONCATENATED MODULE: ./src/sections/NewsletterExtended/NewsletterExtended.schema.js
var NewsletterExtended_schema_Schema = function() {
    return {
        label: "Newsletter (Extended)",
        category: "Newsletter",
        key: "newsletterExtended",
        fields: [
            {
                label: "Background Image",
                name: "image",
                component: "image"
            },
            {
                component: "select",
                name: "formType",
                label: "Form Type",
                options: [
                    {
                        label: "Email",
                        value: "email"
                    },
                    {
                        label: "Phone",
                        value: "phone"
                    }, 
                ],
                defaultValue: "email"
            },
            {
                component: "group",
                name: "emailForm",
                label: "Email Form",
                description: "Settings for the email signup form",
                fields: [
                    {
                        component: "text",
                        name: "subheading",
                        label: "Subheading"
                    },
                    {
                        component: "text",
                        name: "heading",
                        label: "Heading"
                    },
                    {
                        component: "text",
                        name: "placeholder",
                        label: "Placeholder"
                    },
                    {
                        component: "text",
                        name: "buttonText",
                        label: "Button Text"
                    },
                    {
                        component: "text",
                        name: "successMessage",
                        label: "Success Message"
                    },
                    {
                        component: "text",
                        name: "listId",
                        label: "Klaviyo List ID"
                    }, 
                ],
                defaultValue: {
                    subheading: "Upgrade now with",
                    heading: "10% off your first order of a new filtration system",
                    placeholder: "Email address",
                    buttonText: "Get my Code",
                    successMessage: "Thanks for subscribing! Your submission was received successfully."
                }
            },
            {
                component: "group",
                name: "phoneForm",
                label: "Phone Form",
                description: "Settings for the phone number signup form",
                fields: [
                    {
                        component: "text",
                        name: "subheading",
                        label: "Subheading"
                    },
                    {
                        component: "text",
                        name: "heading",
                        label: "Heading"
                    },
                    {
                        component: "text",
                        name: "buttonText",
                        label: "Button Text"
                    },
                    {
                        component: "html",
                        name: "disclaimer",
                        label: "Disclaimer"
                    },
                    {
                        component: "text",
                        name: "checkMessage",
                        label: "Check Message"
                    },
                    {
                        component: "text",
                        name: "replyMessage",
                        label: "Reply Message"
                    },
                    {
                        component: "link",
                        name: "successButton",
                        label: "Success Button"
                    },
                    {
                        component: "text",
                        name: "listId",
                        label: "Klaviyo List ID"
                    }, 
                ],
                defaultValue: {
                    subheading: "Sign up for texts & get",
                    heading: "10% off your first order of a new filtration system",
                    placeholder: "201 - 555 - 1234",
                    buttonText: "Get my Code",
                    disclaimer: '<p>*By providing your phone number, you agree to receive recurring automated marketing text messages (e.g. cart reminders) from this shop and third parties acting on its behalf. Consent is not a condition to obtain goods or services. Msg & data rates may apply. Msg frequency varies. Reply HELP for help and STOP to cancel. You also agree to the <a href="/pages/terms-conditions">Terms of Service</a> and <a href="/pages/privacy-policy">Privacy Policy</a>.</p>',
                    checkMessage: "Check your \uD83D\uDCF2 and",
                    replyMessage: "Reply “Y” to finish signing up & get your code",
                    successButton: {
                        text: "Got it, Thanks!",
                        url: "/"
                    }
                }
            }, 
        ]
    };
};

;// CONCATENATED MODULE: ./src/sections/NewsletterExtended/EmailForm.jsx







function EmailForm(param) {
    var settings = param.settings;
    var heading = settings.heading, subheading = settings.subheading, placeholder = settings.placeholder, buttonText = settings.buttonText, successMessage = settings.successMessage, _listId = settings.listId, listId = _listId === void 0 ? "" : _listId;
    var sendSubscribeEvent = (0,hooks/* useDataLayerActions */.KZ)().sendSubscribeEvent;
    var ref = (0,react.useState)(""), formEmail = ref[0], setFormEmail = ref[1];
    var ref1 = (0,react.useState)(false), isSuccessful = ref1[0], setIsSuccessful = ref1[1];
    var handleNewsletterSignup = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
            var payload, klaviyoResponse;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        payload = {
                            emailAddress: formEmail
                        };
                        if (listId) {
                            payload.listId = listId;
                        }
                        return [
                            4,
                            fetch("/api/klaviyo-subscribe", {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify(payload)
                            })
                        ];
                    case 1:
                        klaviyoResponse = _state.sent();
                        if (klaviyoResponse.status === 200) {
                            setIsSuccessful(true);
                            setFormEmail("");
                            sendSubscribeEvent({
                                email: formEmail,
                                form_id: "newsletter_extended_email_signup"
                            });
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleNewsletterSignup(event) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "text-center",
        children: [
            subheading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Subheading */.pm, {
                variant: "large",
                className: "mb-4 px-4 uppercase",
                children: subheading
            }),
            heading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                variant: "h2",
                className: "mb-8 max-w-[700px] px-4",
                children: heading
            }),
            !isSuccessful && /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: "klaviyo-form w-full px-8",
                onSubmit: handleNewsletterSignup,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mb-8 flex justify-between border-b border-[#4d515d33] pb-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "email",
                                className: "w-full bg-transparent text-lg font-light outline-none lg:text-xl",
                                value: formEmail,
                                placeholder: placeholder || "Email address",
                                onChange: function(event) {
                                    setFormEmail(event.target.value);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                type: "submit",
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                                        className: "w-[24px] text-black",
                                        src: "/svgs/arrow-right.svg#arrow-right",
                                        title: "Submit",
                                        viewBox: "0 0 24 24"
                                    })
                                ]
                            })
                        ]
                    }),
                    buttonText && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Button */.zx, {
                        ariaLabel: "submit",
                        type: "submit",
                        theme: "primary",
                        variant: "filled",
                        className: "w-full",
                        children: buttonText
                    })
                ]
            }),
            isSuccessful && successMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "py-6",
                children: successMessage
            })
        ]
    });
}

// EXTERNAL MODULE: ../node_modules/intl-tel-input/react/build/IntlTelInput.cjs.js
var IntlTelInput_cjs = __webpack_require__(3299);
var IntlTelInput_cjs_default = /*#__PURE__*/__webpack_require__.n(IntlTelInput_cjs);
// EXTERNAL MODULE: ../node_modules/intl-tel-input/build/css/intlTelInput.css
var intlTelInput = __webpack_require__(2080);
;// CONCATENATED MODULE: ./src/sections/NewsletterExtended/PhoneForm.jsx









function PhoneForm(param) {
    var settings = param.settings;
    var heading = settings.heading, subheading = settings.subheading, buttonText = settings.buttonText, disclaimer = settings.disclaimer, checkMessage = settings.checkMessage, replyMessage = settings.replyMessage, successButton = settings.successButton, listId = settings.listId;
    var sendSubscribeEvent = (0,hooks/* useDataLayerActions */.KZ)().sendSubscribeEvent;
    var ref = (0,react.useState)(null), formNumber = ref[0], setFormNumber = ref[1];
    var ref1 = (0,react.useState)(false), isSuccessful = ref1[0], setIsSuccessful = ref1[1];
    var handleNewsletterSignup = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
            var phoneNumber, payload, klaviyoResponse;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        phoneNumber = "".concat(formNumber).replace(/\D/g, "");
                        payload = {
                            phoneNumber: "+".concat(phoneNumber)
                        };
                        if (listId) {
                            payload.listId = listId;
                        }
                        return [
                            4,
                            fetch("/api/klaviyo-subscribe", {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify(payload)
                            })
                        ];
                    case 1:
                        klaviyoResponse = _state.sent();
                        if (klaviyoResponse.status === 200) {
                            setIsSuccessful(true);
                            setFormNumber("");
                            sendSubscribeEvent({
                                phone: phoneNumber
                            });
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleNewsletterSignup(event) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "newsletter-extended-phone-form text-center",
        children: !isSuccessful ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                subheading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Subheading */.pm, {
                    variant: "large",
                    className: "mb-4 px-4 uppercase",
                    children: subheading
                }),
                heading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                    variant: "h2",
                    className: "mb-8 max-w-[700px] px-4",
                    children: heading
                }),
                !isSuccessful && /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    className: "klaviyo-form w-full px-8",
                    onSubmit: handleNewsletterSignup,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mb-8 flex justify-between border-b border-[#4d515d33] pb-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((IntlTelInput_cjs_default()), {
                                    onChangeNumber: setFormNumber,
                                    className: "w-full bg-transparent text-lg font-light outline-none lg:text-xl",
                                    initOptions: {
                                        initialCountry: "us",
                                        utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@19.2.16/build/js/utils.js",
                                        containerClass: "w-full font-light",
                                        showSelectedDialCode: true
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    type: "submit",
                                    children: [
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                                            className: "w-[24px] text-black",
                                            src: "/svgs/arrow-right.svg#arrow-right",
                                            title: "Submit",
                                            viewBox: "0 0 24 24"
                                        })
                                    ]
                                })
                            ]
                        }),
                        disclaimer && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mx-auto mb-8 max-w-[600px] text-left text-xs lg:text-sm",
                            dangerouslySetInnerHTML: {
                                __html: disclaimer
                            }
                        }),
                        buttonText && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Button */.zx, {
                            ariaLabel: "submit",
                            type: "submit",
                            theme: "primary",
                            variant: "filled",
                            className: "w-full",
                            children: buttonText
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "px-8",
            children: [
                subheading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Subheading */.pm, {
                    variant: "large",
                    className: "mb-4 uppercase",
                    children: checkMessage
                }),
                heading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                    variant: "h2",
                    className: "mb-16 max-w-[700px]",
                    children: replyMessage
                }),
                successButton.url && successButton.text && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Button */.zx, {
                    href: successButton.url,
                    theme: "primary",
                    variant: "filled",
                    className: "w-full",
                    wrapperClassName: "w-full",
                    children: successButton.text
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/sections/NewsletterExtended/NewsletterExtended.jsx





function NewsletterExtended(param) {
    var cms = param.cms;
    var image = cms.image, formType = cms.formType, emailForm = cms.emailForm, phoneForm = cms.phoneForm;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "newsletter-extended relative flex min-h-[475px] items-center justify-center lg:min-h-[800px]",
        children: [
            (image === null || image === void 0 ? void 0 : image.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute mx-auto h-full w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                    src: image.src,
                    alt: "icon",
                    fill: true,
                    className: "mx-auto object-cover"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-contained relative mx-auto max-w-[1200px] overflow-hidden py-16 my-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute left-4 top-0 h-full w-full max-w-[calc(100%-2em)] bg-[#ECF7FF] lg:left-0 lg:max-w-full"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative z-10",
                        children: formType === "email" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailForm, {
                            settings: emailForm
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneForm, {
                            settings: phoneForm
                        })
                    })
                ]
            })
        ]
    });
}
NewsletterExtended.displayName = "NewsletterExtended";
NewsletterExtended.Schema = NewsletterExtended_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/NewsletterExtended/index.js


;// CONCATENATED MODULE: ./src/sections/OkendoReviews/OkendoReviews.schema.js
function OkendoReviews_schema_Schema() {
    return {
        key: "okendo-reviews",
        label: "Okendo Reviews",
        fields: [
            {
                name: "product",
                label: "Product",
                component: "productSearch"
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/OkendoReviews/OkendoReviewsWidget.jsx


function OkendoReviewsWidget(param) {
    var productId = param.productId;
    var widgetContainer = (0,react.useRef)(null);
    var widgetContainer2 = (0,react.useRef)(null);
    var ref = (0,react.useState)("..."), reviewsCount = ref[0], setReviewsCount = ref[1];
    var tabs = (0,react.useMemo)(function() {
        return [
            "Reviews",
            "Questions"
        ];
    }, []);
    var ref1 = (0,react.useState)("Reviews"), tab = ref1[0], setTab = ref1[1];
    var initialiseWidget = function() {
        window.okeWidgetApi.initWidget(widgetContainer.current);
        window.okeWidgetApi.initWidget(widgetContainer2.current);
    };
    (0,react.useEffect)(function() {
        var ref;
        if ((ref = window.okeWidgetApi) === null || ref === void 0 ? void 0 : ref.initWidget) {
            initialiseWidget();
        } else {
            document.addEventListener("oke-script-loaded", initialiseWidget);
        }
        var interval = setInterval(function() {
            var ref, ref1;
            if (reviewsCount === "...") setReviewsCount(((ref = document.querySelector(".oke-w-reviews-count")) === null || ref === void 0 ? void 0 : (ref1 = ref.textContent) === null || ref1 === void 0 ? void 0 : ref1.replace(/[^\d]/gi, "")) || "...");
        }, 1000);
        return function() {
            document.removeEventListener("oke-script-loaded", initialiseWidget);
            clearInterval(interval);
        };
    }, [
        productId,
        tab
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mx-auto max-w-[1200px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex gap-2",
                    children: tabs.map(function(_tab) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            role: "button",
                            tabIndex: 0,
                            onKeyDown: function(e) {
                                return e.key === "Enter" && setTab(_tab);
                            },
                            onClick: function() {
                                return setTab(_tab);
                            },
                            className: [
                                "border-b-2 py-3 text-[#202635]",
                                tab === _tab ? "border-[#DDE2E7]" : "border-transparent", 
                            ].join(" "),
                            children: [
                                _tab,
                                _tab === "Reviews" && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "ml-2 inline-block bg-[#3383C5] px-2 py-0.5 text-white",
                                    children: reviewsCount
                                })
                            ]
                        }, _tab);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: tab === "Reviews" ? "block" : "hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: widgetContainer2,
                    "data-oke-widget": true,
                    "data-oke-reviews-product-id": "shopify-".concat(productId)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: tab === "Questions" ? "block" : "hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    "data-oke-questions-widget": true,
                    ref: widgetContainer,
                    "data-oke-reviews-product-id": "shopify-".concat(productId)
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/sections/OkendoReviews/OkendoReviews.jsx






/**
 *
 * @param {object} props - props object
 * @param {object} props.cms - cms object
 * @param {object} props.cms.product - product object
 * @param {string} props.cms.product.handle - product handle
 * @param {string} props.cms.product.title - product title
 *
 * @returns {JSX.Element} - OkendoReviews component
 * @example
 * <OkendoReviews
 *  cms={{
 *   product: {
 *    handle: 'product-handle',
 *    title: 'Product Title',
 *   },
 *  }}
 * />
 */ function OkendoReviews(param) {
    var cms = param.cms;
    var ref;
    var ref1 = (0,react.useState)(false), shouldRender = ref1[0], setShouldRender = ref1[1];
    var product = (0,dist.useProductByHandle)({
        handle: cms === null || cms === void 0 ? void 0 : (ref = cms.product) === null || ref === void 0 ? void 0 : ref.handle
    }).product;
    var memoizedId = (0,react.useMemo)(function() {
        var separatedInstances = String(product === null || product === void 0 ? void 0 : product.id).split("/");
        return separatedInstances[separatedInstances.length - 1];
    }, [
        product
    ]);
    (0,react.useEffect)(function() {
        setShouldRender(true);
    }, []);
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "overflow-hidden bg-[#E6F0F8] px-4 py-20",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OkendoReviewsWidget, {
            productId: memoizedId
        })
    });
}
OkendoReviews.propTypes = {
    cms: prop_types_default().shape({
        product: prop_types_default().shape({
            handle: (prop_types_default()).string.isRequired,
            title: (prop_types_default()).string.isRequired
        }).isRequired
    })
};
OkendoReviews.defaultProps = {
    cms: {
        product: {
            handle: "",
            title: ""
        }
    }
};
OkendoReviews.displayName = "OkendoReviews";
OkendoReviews.Schema = OkendoReviews_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/PackAccordions/Accordion.jsx




function Accordion_Accordion(param) {
    var accordion = param.accordion, index = param.index, activeIndex = param.activeIndex, handleClick = param.handleClick;
    var body = accordion.body, header = accordion.header;
    var isOpen = activeIndex === index;
    var isMobile = utils_useMediaQuery("(max-width: 767px)");
    var ref = (0,react.useState)("small"), variant = ref[0], setVariant = ref[1];
    (0,react.useEffect)(function() {
        if (isMobile) {
            setVariant("small");
        } else {
            setVariant("medium");
        }
    }, [
        isMobile
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                "aria-label": "".concat(isOpen ? "Close" : "Open", " accordion for ").concat(header),
                className: "flex min-h-[4rem] w-full items-center justify-between gap-x-4 border-t border-[#0000001A] py-3 pb-0 text-left",
                onClick: function() {
                    return handleClick(index);
                },
                type: "button",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Subheading */.pm, {
                        variant: variant,
                        children: header
                    }),
                    isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                        className: "w-4 text-current",
                        src: "/svgs/chevron-up.svg#chevron-up",
                        title: "Up",
                        viewBox: "0 0 24 24"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                        className: "w-4 text-current",
                        src: "/svgs/chevron-down.svg#chevron-down",
                        title: "Down",
                        viewBox: "0 0 24 24"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pb-2 pr-2 max-sm:pt-4 ".concat(isOpen ? "block" : "hidden"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Markdown */.UG, {
                    className: "[&_p]:!text-[14px] [&_p]:font-[200] [&_p]:lg:!text-[18px]",
                    children: body
                })
            })
        ]
    });
}
Accordion_Accordion.displayName = "Accordion";

;// CONCATENATED MODULE: ./src/sections/PackAccordions/Accordions.schema.js

function Accordions_schema_Schema() {
    return {
        category: "Text",
        label: "Accordions",
        key: "accordions",
        previewSrc: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/accordions-preview.jpg?v=1675730300",
        fields: [
            {
                label: "Heading",
                name: "heading",
                component: "text",
                defaultValue: "Accordions Heading"
            },
            {
                label: "Accordions",
                name: "accordions",
                component: "group-list",
                itemProps: {
                    label: "{{item.header}}"
                },
                fields: [
                    {
                        label: "Header",
                        name: "header",
                        component: "text"
                    },
                    {
                        label: "Body",
                        name: "body",
                        component: "markdown"
                    },
                    {
                        label: "Default Open",
                        name: "defaultOpen",
                        component: "toggle",
                        description: "Sets accordion to be open by default",
                        toggleLabels: {
                            true: "On",
                            false: "Off"
                        }
                    }, 
                ],
                defaultValue: [
                    {
                        header: "Excepteur sint occaecat cupidatat non proident?",
                        body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
                        defaultOpen: false
                    }, 
                ],
                defaultItem: {
                    header: "Excepteur sint occaecat cupidatat non proident?",
                    body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
                    defaultOpen: false
                }
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/PackAccordions/Accordions.jsx





function Accordions(param) {
    var cms = param.cms;
    var accordions = cms.accordions, heading = cms.heading;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var ref1 = (0,react.useState)(0), activeIndex = ref1[0], setActiveIndex = ref1[1];
    var handleClick = function(index) {
        setActiveIndex(activeIndex === index ? null : index);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-[#E6F0F8]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "px-contained py-7 md:py-12 xl:py-20",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mx-auto max-w-[1100px]",
                children: [
                    heading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                        variant: "h4",
                        element: "h4",
                        className: "pb-12",
                        children: heading
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "grid grid-cols-1 gap-4",
                        children: accordions === null || accordions === void 0 ? void 0 : accordions.map(function(accordion, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion_Accordion, {
                                    index: index,
                                    activeIndex: activeIndex,
                                    accordion: accordion,
                                    handleClick: handleClick,
                                    isOpen: isOpen,
                                    setIsOpen: setIsOpen
                                })
                            }, index);
                        })
                    })
                ]
            })
        })
    });
}
Accordions.displayName = "Accordions";
Accordions.Schema = Accordions_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/PackAccordions/index.js


;// CONCATENATED MODULE: ./src/sections/PackBlogCategories/BlogCategories.schema.js
function BlogCategories_schema_Schema(param) {
    var blog = param.blog;
    if (!blog) return null;
    return {
        category: "Blog",
        label: "Blog Categories",
        key: "blog-categories",
        previewSrc: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/blog-categories-preview.jpg?v=1675732821",
        fields: [
            {
                label: "Categories",
                name: "categories",
                component: "list",
                description: '"All" category is added to the front automatically',
                field: {
                    component: "text"
                }
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/PackBlogCategories/BlogCategories.jsx








function BlogCategories(param) {
    var cms = param.cms;
    var ref;
    var blog = (0,dist.useBlog)();
    var router = (0,next_router.useRouter)();
    var categoryParam = (ref = router.query.category) === null || ref === void 0 ? void 0 : ref.toLowerCase().trim();
    var categories = cms.categories;
    var url = "/blogs/".concat(blog === null || blog === void 0 ? void 0 : blog.handle);
    var handleCategoryClick = (0,react.useCallback)(function(category) {
        if (category === categoryParam) return;
        if (!categoryParam && category === "all") return;
        if (category === "all") {
            router.replace({
                pathname: url,
                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                    category: ""
                })
            }, undefined, {
                shallow: true
            });
        } else {
            router.replace({
                pathname: url,
                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                    category: category
                })
            }, undefined, {
                shallow: true
            });
        }
    }, [
        categoryParam,
        router.query,
        url
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "px-contained scrollbar-hide flex overflow-x-auto pt-4 xs:justify-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            className: "flex justify-center gap-2 xs:flex-wrap",
            children: [
                "All"
            ].concat((0,_to_consumable_array/* default */.Z)(categories || [])).map(function(item, index) {
                var category = item.toLowerCase().trim();
                var isActive = false;
                if (categoryParam) {
                    isActive = categoryParam === category;
                } else {
                    isActive = category === "all";
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "btn-text flex h-8 items-center justify-center rounded-full px-4 transition ".concat(isActive ? "bg-black text-white" : "bg-lightGray text-text"),
                        onClick: function() {
                            return handleCategoryClick(category);
                        },
                        type: "button",
                        children: category
                    })
                }, index);
            })
        })
    });
}
BlogCategories.displayName = "BlogCategories";
BlogCategories.Schema = BlogCategories_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/PackBlogCategories/index.js


;// CONCATENATED MODULE: ./src/sections/PackBlogGrid/BlogGridItem.jsx



function BlogGridItem(param) {
    var article = param.article;
    var ref;
    var date = (0,react.useMemo)(function() {
        var options = {
            year: "numeric",
            month: "long",
            day: "numeric"
        };
        return new Date(article.publishedAt || article.createdAt).toLocaleDateString("en-US", options);
    }, [
        article.createdAt,
        article.publishedAt
    ]);
    var url = "/articles/".concat(article.handle);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                "aria-label": article.title,
                href: url,
                tabIndex: "-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative mb-4 aspect-[3/2] bg-offWhite",
                    children: ((ref = article.seo) === null || ref === void 0 ? void 0 : ref.image) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                        alt: article.title,
                        fill: true,
                        sizes: "(min-width: 1440px) 1200px, (min-width: 768px) 50vw, 100vw",
                        src: article.seo.image
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col items-start gap-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "text-sm text-mediumGray",
                        children: [
                            article.author ? "".concat(article.author, " | ") : "",
                            date
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                        "aria-label": article.title,
                        href: url,
                        tabIndex: "-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "text-title-h4",
                            children: article.title
                        })
                    }),
                    article.excerpt && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "overflow-hidden text-sm",
                        style: {
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical"
                        },
                        children: article.excerpt
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                        "aria-label": "Read article ".concat(article.title),
                        className: "text-label text-main-underline",
                        href: url,
                        children: "Read More"
                    })
                ]
            })
        ]
    });
}
BlogGridItem.displayName = "BlogGridItem";

;// CONCATENATED MODULE: ./src/sections/PackBlogGrid/BlogGrid.schema.js
function BlogGrid_schema_Schema(param) {
    var blog = param.blog;
    if (!blog) return null;
    return {
        category: "Blog",
        label: "Blog Grid",
        key: "blog-grid",
        previewSrc: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/blog-preview.jpg?v=1675732824",
        fields: []
    };
}

;// CONCATENATED MODULE: ./src/sections/PackBlogGrid/BlogGrid.jsx






function BlogGrid() {
    var blog = (0,dist.useBlog)();
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(blog === null || blog === void 0 ? void 0 : blog.articles), filteredArticles = ref[0], setFilteredArticles = ref[1];
    var categoryParam = router.query.category;
    (0,react.useEffect)(function() {
        if (categoryParam) {
            var ref;
            var filtered = blog === null || blog === void 0 ? void 0 : (ref = blog.articles) === null || ref === void 0 ? void 0 : ref.filter(function(param) {
                var category = param.category;
                return (category === null || category === void 0 ? void 0 : category.toLowerCase().trim()) === (categoryParam === null || categoryParam === void 0 ? void 0 : categoryParam.toLowerCase().trim());
            });
            setFilteredArticles(filtered);
        } else {
            setFilteredArticles(blog === null || blog === void 0 ? void 0 : blog.articles);
        }
    }, [
        blog === null || blog === void 0 ? void 0 : blog.articles,
        categoryParam
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "px-contained py-8 md:py-10 lg:py-12",
        children: (filteredArticles === null || filteredArticles === void 0 ? void 0 : filteredArticles.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            className: "mx-auto grid max-w-[var(--content-max-width)] grid-cols-1 gap-x-5 gap-y-8 xs:grid-cols-2 md:grid-cols-3",
            children: filteredArticles.map(function(article) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogGridItem, {
                        article: article
                    })
                }, article.id);
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex min-h-[12.5rem] items-center justify-center text-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "No posts found under this category."
            })
        })
    });
}
BlogGrid.displayName = "BlogGrid";
BlogGrid.Schema = BlogGrid_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/PackBlogGrid/index.js


;// CONCATENATED MODULE: ./src/sections/PackCollection/Collection.schema.js
function Collection_schema_Schema(param) {
    var collection = param.collection;
    if (!collection) return null;
    return {
        category: "Collection",
        label: "Collection",
        key: "collection",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/collections.png?v=1684883680",
        fields: [
            {
                component: "toggle",
                name: "seprateByType",
                label: "Separate Products By Type",
                toggleLabels: {
                    true: "Enable",
                    false: "Disable"
                },
                defaultValue: true
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/PackCollection/Collection.jsx

// adding collection via section allows control of order of grid on the page
function Collection() {
    return null;
}
Collection.displayName = "Collection";
Collection.Schema = Collection_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/PackCollection/index.js


;// CONCATENATED MODULE: ./src/sections/PackHalfHero/HalfHero.schema.js

var media = {
    label: "Media Settings",
    name: "media",
    description: "Image settings, video settings, order, aspect ratio",
    component: "group",
    fields: [
        {
            label: "Image Settings",
            name: "image",
            description: "Image, image position",
            component: "group",
            fields: [
                {
                    label: "Image Alt",
                    name: "alt",
                    component: "text",
                    description: "Brief description of image"
                },
                {
                    label: "Image (tablet/desktop)",
                    name: "imageDesktop",
                    component: "image"
                },
                {
                    label: "Image Position (tablet/desktop)",
                    name: "positionDesktop",
                    component: "select",
                    options: OBJECT_POSITIONS.desktop
                },
                {
                    label: "Image (mobile)",
                    name: "imageMobile",
                    component: "image"
                },
                {
                    label: "Image Position (mobile)",
                    name: "positionMobile",
                    component: "select",
                    options: OBJECT_POSITIONS.mobile
                }, 
            ]
        },
        {
            label: "Video Settings",
            name: "video",
            description: "Video link, poster image, autoplay, sound",
            component: "group",
            fields: [
                {
                    label: "Video URL (tablet/desktop)",
                    name: "srcDesktop",
                    component: "text",
                    description: "Overrides tablet/desktop image option"
                },
                {
                    label: "Poster Image (tablet/desktop)",
                    name: "posterDesktop",
                    component: "image"
                },
                {
                    label: "Video URL (mobile)",
                    name: "srcMobile",
                    component: "text",
                    description: "Overrides mobile image option"
                },
                {
                    label: "Poster Image (mobile)",
                    name: "posterMobile",
                    component: "image"
                },
                {
                    label: "Autoplay When In View",
                    name: "autoplay",
                    component: "toggle",
                    description: "Disabling controls video through play button instead. Also applies muted and loop attributes",
                    toggleLabels: {
                        true: "On",
                        false: "Off"
                    }
                },
                {
                    label: "Sound",
                    name: "sound",
                    component: "toggle",
                    description: "Only applicable if autoplay is off. Also applies controls attribute",
                    toggleLabels: {
                        true: "On",
                        false: "Off"
                    }
                }, 
            ]
        },
        {
            label: "Media Order (tablet/desktop)",
            name: "mediaOrderDesktop",
            component: "radio-group",
            direction: "horizontal",
            variant: "radio",
            options: [
                {
                    label: "Left",
                    value: "1"
                },
                {
                    label: "Right",
                    value: "2"
                }, 
            ]
        },
        {
            label: "Media Aspect Ratio (tablet)",
            name: "aspectTablet",
            component: "select",
            options: [
                {
                    label: "3:2",
                    value: "md:before:pb-[67%]"
                },
                {
                    label: "4:3",
                    value: "md:before:pb-[75%]"
                },
                {
                    label: "5:4",
                    value: "md:before:pb-[80%]"
                },
                {
                    label: "8:7",
                    value: "md:before:pb-[87.5%]"
                },
                {
                    label: "1:1",
                    value: "md:before:pb-[100%]"
                },
                {
                    label: "7:8",
                    value: "md:before:pb-[114%]"
                },
                {
                    label: "4:5",
                    value: "md:before:pb-[125%]"
                },
                {
                    label: "3:4",
                    value: "md:before:pb-[133%]"
                },
                {
                    label: "2:3",
                    value: "md:before:pb-[150%]"
                }, 
            ]
        },
        {
            label: "Media Aspect Ratio (desktop)",
            name: "aspectDesktop",
            component: "select",
            options: [
                {
                    label: "3:2",
                    value: "lg:before:pb-[67%]"
                },
                {
                    label: "4:3",
                    value: "lg:before:pb-[75%]"
                },
                {
                    label: "5:4",
                    value: "lg:before:pb-[80%]"
                },
                {
                    label: "8:7",
                    value: "lg:before:pb-[87.5%]"
                },
                {
                    label: "1:1",
                    value: "lg:before:pb-[100%]"
                },
                {
                    label: "7:8",
                    value: "lg:before:pb-[114%]"
                },
                {
                    label: "4:5",
                    value: "lg:before:pb-[125%]"
                },
                {
                    label: "3:4",
                    value: "lg:before:pb-[133%]"
                },
                {
                    label: "2:3",
                    value: "lg:before:pb-[150%]"
                }, 
            ]
        },
        {
            label: "Fill Empty Space (tablet/desktop)",
            name: "fill",
            component: "toggle",
            description: "Fill any vertical empty space with media. Applicable only to tablet and desktop",
            toggleLabels: {
                true: "On",
                false: "Off"
            }
        },
        {
            label: "Media Order (mobile)",
            name: "mediaOrderMobile",
            component: "radio-group",
            direction: "horizontal",
            variant: "radio",
            options: [
                {
                    label: "Top",
                    value: "1"
                },
                {
                    label: "Bottom",
                    value: "2"
                }, 
            ]
        },
        {
            label: "Media Aspect Ratio (mobile)",
            name: "aspectMobile",
            component: "select",
            options: [
                {
                    label: "3:2",
                    value: "max-md:before:pb-[67%]"
                },
                {
                    label: "4:3",
                    value: "max-md:before:pb-[75%]"
                },
                {
                    label: "5:4",
                    value: "max-md:before:pb-[80%]"
                },
                {
                    label: "8:7",
                    value: "max-md:before:pb-[87.5%]"
                },
                {
                    label: "1:1",
                    value: "max-md:before:pb-[100%]"
                },
                {
                    label: "7:8",
                    value: "max-md:before:pb-[114%]"
                },
                {
                    label: "4:5",
                    value: "max-md:before:pb-[125%]"
                },
                {
                    label: "3:4",
                    value: "max-md:before:pb-[133%]"
                },
                {
                    label: "2:3",
                    value: "max-md:before:pb-[150%]"
                }, 
            ]
        }, 
    ],
    defaultValue: {
        image: {
            alt: "Man with backpack crossing the street",
            imageDesktop: {
                src: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/mad-rabbit-tattoo-tn1yJqxNj-8-unsplash.jpg?v=1672787927"
            },
            positionDesktop: "md:object-center",
            imageMobile: {
                src: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/mad-rabbit-tattoo-tn1yJqxNj-8-unsplash.jpg?v=1672787927"
            },
            positionMobile: "object-center"
        },
        video: {
            autoplay: true,
            sound: false
        },
        mediaOrderDesktop: "1",
        aspectTablet: "md:before:pb-[100%]",
        aspectDesktop: "lg:before:pb-[100%]",
        fill: true,
        mediaOrderMobile: "1",
        aspectMobile: "max-md:before:pb-[100%]"
    }
};
var content = {
    label: "Content Settings",
    name: "content",
    description: "Heading, superheading, subtext, buttons, text color, alignment, content width",
    component: "group",
    fields: [
        {
            label: "Heading",
            name: "heading",
            component: "textarea"
        },
        {
            label: "Superheading",
            name: "superheading",
            component: "text"
        },
        {
            label: "Subtext",
            name: "subtext",
            component: "markdown"
        },
        {
            label: "Buttons",
            name: "buttons",
            component: "group-list",
            description: "Max of two buttons",
            itemProps: {
                label: "{{item.link.text}}"
            },
            validate: {
                maxItems: 2
            },
            fields: [
                {
                    label: "Link",
                    name: "link",
                    component: "link"
                },
                {
                    label: "Button Style",
                    name: "style",
                    component: "select",
                    options: [
                        {
                            label: "Primary",
                            value: "primary"
                        },
                        {
                            label: "Secondary",
                            value: "secondary"
                        },
                        {
                            label: "Light",
                            value: "light"
                        },
                        {
                            label: "Dark",
                            value: "dark"
                        }, 
                    ]
                }, 
            ],
            defaultItem: {
                link: {
                    text: "Shop Now",
                    url: ""
                },
                style: "btn-primary"
            }
        },
        {
            label: "Text Color",
            name: "color",
            component: "select",
            options: COLORS
        },
        {
            label: "Content Alignment (tablet/desktop)",
            name: "alignmentDesktop",
            component: "radio-group",
            direction: "horizontal",
            variant: "radio",
            options: [
                {
                    label: "Left",
                    value: "md:text-left md:items-start"
                },
                {
                    label: "Center",
                    value: "md:text-center md:items-center"
                },
                {
                    label: "Right",
                    value: "md:text-right md:items-end"
                }, 
            ]
        },
        {
            label: "Max Content Width (tablet/desktop)",
            name: "maxWidthDesktop",
            component: "select",
            options: [
                {
                    label: "Narrow",
                    value: "md:max-w-[22rem] lg:max-w-[28rem]"
                },
                {
                    label: "Medium",
                    value: "md:max-w-[30rem] lg:max-w-[38rem]"
                },
                {
                    label: "Wide",
                    value: "md:max-w-[38rem] lg:max-w-[48rem]"
                },
                {
                    label: "Full",
                    value: "md:max-w-full"
                }, 
            ]
        },
        {
            label: "Content Alignment (mobile)",
            name: "alignmentMobile",
            component: "radio-group",
            direction: "horizontal",
            variant: "radio",
            options: [
                {
                    label: "Left",
                    value: "text-left items-start"
                },
                {
                    label: "Center",
                    value: "text-center items-center"
                },
                {
                    label: "Right",
                    value: "text-right items-end"
                }, 
            ]
        },
        {
            label: "Content Alignment Over Image (mobile)",
            name: "alignmentMobileOverImage",
            component: "toggle",
            toggleLabels: {
                true: "Above",
                false: "Below"
            }
        }, 
    ],
    defaultValue: {
        heading: "Half Hero Heading",
        superheading: "",
        subtext: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        buttons: [
            {
                link: {
                    text: "Shop Now",
                    url: ""
                },
                style: "btn-primary"
            }, 
        ],
        color: "var(--text)",
        alignmentDesktop: "md:text-left md:items-start",
        maxWidthDesktop: "md:max-w-[30rem] lg:max-w-[38rem]",
        alignmentMobile: "text-left items-start",
        alignmentMobileOverImage: false
    }
};
var HalfHero_schema_Schema = function() {
    return {
        category: "Hero",
        label: "Half Hero",
        key: "half-hero",
        previewSrc: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/half-hero-preview_396b489b-da92-490a-b59d-87b2c9467c67.jpg?v=1675795226",
        fields: [
            media,
            content,
            {
                label: "Section Settings",
                name: "section",
                component: "group",
                description: "Background color, above the fold, full width, full bleed, vertical padding",
                fields: [
                    {
                        label: "Background Color",
                        name: "bgColor",
                        component: "select",
                        options: COLORS
                    },
                    {
                        label: "Above The Fold",
                        name: "aboveTheFold",
                        component: "toggle",
                        description: "Sets the heading as H1 and image load as priority",
                        toggleLabels: {
                            true: "On",
                            false: "Off"
                        }
                    },
                    {
                        label: "Full Width",
                        name: "fullWidth",
                        component: "toggle",
                        description: "Removes max width of this section",
                        toggleLabels: {
                            true: "On",
                            false: "Off"
                        }
                    },
                    {
                        label: "Full Bleed",
                        name: "fullBleed",
                        component: "toggle",
                        description: "Removes horizontal padding of this section",
                        toggleLabels: {
                            true: "On",
                            false: "Off"
                        }
                    },
                    {
                        label: "Vertical Padding",
                        name: "verticalPadding",
                        component: "toggle",
                        description: "Adds vertical padding to this section",
                        toggleLabels: {
                            true: "On",
                            false: "Off"
                        }
                    }, 
                ],
                defaultValue: {
                    bgColor: "var(--background)",
                    aboveTheFold: false,
                    fullWidth: true,
                    fullBleed: true,
                    verticalPadding: false
                }
            }, 
        ]
    };
};

;// CONCATENATED MODULE: ./src/sections/PackHalfHero/HalfHeroContent.jsx







function HalfHeroContent(param) {
    var aboveTheFold = param.aboveTheFold, content = param.content;
    var ref = (0,_object_spread/* default */.Z)({}, content), alignmentDesktop = ref.alignmentDesktop, alignmentMobile = ref.alignmentMobile, alignmentMobileOverImage = ref.alignmentMobileOverImage, buttons = ref.buttons, color = ref.color, heading = ref.heading, maxWidthDesktop = ref.maxWidthDesktop, subtext = ref.subtext, superheading = ref.superheading;
    var ref1 = (0,contexts/* useGlobalContext */.b)(), openAccount = ref1.actions.openAccount;
    var alignmentClasses = "".concat(alignmentMobile, " ").concat(alignmentDesktop);
    var headingWithBreaks = (0,react.useMemo)(function() {
        var splitHeading = heading === null || heading === void 0 ? void 0 : heading.split("\n");
        if ((splitHeading === null || splitHeading === void 0 ? void 0 : splitHeading.length) === 1) return heading;
        return splitHeading === null || splitHeading === void 0 ? void 0 : splitHeading.reduce(function(acc, line, index, arr) {
            acc.push(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: line
            }, index));
            if (index < arr.length - 1) acc.push(/*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}, "br".concat(index)));
            return acc;
        }, []);
    }, [
        heading
    ]);
    var onClick = function() {
        openAccount();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "px-contained py-contained w-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mx-auto flex flex-col gap-4 ".concat(alignmentClasses, " ").concat(maxWidthDesktop, " ").concat(alignmentMobileOverImage ? "text-[#fff] lg:text-[#121D29]" : color),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        superheading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Eyebrow */.j4, {
                            className: "mb-4 uppercase",
                            children: superheading
                        }),
                        aboveTheFold ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                            variant: "h2",
                            element: "h2",
                            children: headingWithBreaks
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                            variant: "h2",
                            element: "h2",
                            children: headingWithBreaks
                        })
                    ]
                }),
                subtext && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "[&_a]:underline [&_h1]:text-base [&_h2]:text-base [&_h3]:text-base [&_h4]:text-base [&_h5]:text-base [&_h6]:text-base [&_p]:text-base",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Markdown */.UG, {
                        children: subtext
                    })
                }),
                (buttons === null || buttons === void 0 ? void 0 : buttons.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "flow-row mt-4 flex flex-wrap justify-center gap-4",
                    children: buttons.slice(0, 2).map(function(param, index) {
                        var link = param.link, style = param.style;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                href: link === null || link === void 0 ? void 0 : link.url,
                                theme: style,
                                variant: "".concat(index === 0 ? "filled" : "outlined"),
                                onClick: (link === null || link === void 0 ? void 0 : link.text) === "Login" ? function() {
                                    return onClick();
                                } : null,
                                children: link === null || link === void 0 ? void 0 : link.text
                            })
                        }, index);
                    })
                })
            ]
        })
    });
}
HalfHeroContent.displayName = "HalfHeroContent";

;// CONCATENATED MODULE: ./src/sections/PackHalfHero/HalfHeroVideo.jsx
/* eslint-disable jsx-a11y/media-has-caption */ 



function HalfHeroVideo(param) {
    var autoplay = param.autoplay, posterSrc = param.posterSrc, sound = param.sound, videoAlt = param.videoAlt, videoSrc = param.videoSrc;
    var videoRef = (0,react.useRef)(null);
    var ref = (0,react_intersection_observer/* useInView */.YD)({
        rootMargin: "0px",
        triggerOnce: true
    }), ref1 = ref.ref, inView = ref.inView;
    var ref2 = (0,react.useState)(null), isPlaying = ref2[0], setIsPlaying = ref2[1];
    (0,react.useEffect)(function() {
        if (autoplay || isPlaying === null || sound) return;
        if (isPlaying) {
            videoRef.current.play();
        } else {
            videoRef.current.pause();
        }
    }, [
        autoplay,
        isPlaying,
        sound
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: ref1,
        className: "absolute inset-0 h-full w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                autoPlay: autoplay,
                className: "h-full w-full object-cover",
                controls: !autoplay && sound,
                loop: autoplay || !sound,
                muted: autoplay || !sound,
                playsInline: true,
                poster: posterSrc,
                ref: videoRef,
                children: inView && videoSrc && /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    src: videoSrc,
                    type: "video/mp4"
                })
            }),
            !autoplay && !sound && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                "aria-label": "Play video for ".concat(videoAlt),
                className: "group absolute inset-0 h-full w-full transition md:hover:bg-transparent ".concat(!isPlaying ? "bg-[rgba(0,0,0,0.2)]" : ""),
                onClick: function() {
                    return setIsPlaying(!isPlaying);
                },
                type: "button",
                children: !isPlaying && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                    className: "absolute top-1/2 left-1/2 w-12 -translate-x-1/2 -translate-y-1/2 text-white opacity-90 transition group-hover:opacity-100 xs:w-16 lg:w-20",
                    src: "/svgs/play.svg#play",
                    title: "Play",
                    viewBox: "0 0 24 24"
                })
            })
        ]
    });
}
HalfHeroVideo.displayName = "HalfHeroVideo";

;// CONCATENATED MODULE: ./src/sections/PackHalfHero/HalfHeroMedia.jsx




function HalfHeroMedia(param) {
    var aboveTheFold = param.aboveTheFold, media = param.media, videoAlt = param.videoAlt;
    var ref, ref1, ref2, ref3;
    var ref4 = (0,_object_spread/* default */.Z)({}, media), image = ref4.image, video = ref4.video;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "absolute inset-0 h-full w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative h-full w-full overflow-hidden md:hidden",
                children: [
                    (video === null || video === void 0 ? void 0 : video.srcMobile) && /*#__PURE__*/ (0,jsx_runtime.jsx)(HalfHeroVideo, {
                        autoplay: video.autoplay,
                        posterSrc: (ref = video.posterMobile) === null || ref === void 0 ? void 0 : ref.src,
                        sound: video.sound,
                        videoAlt: videoAlt,
                        videoSrc: video.srcMobile
                    }),
                    (image === null || image === void 0 ? void 0 : (ref1 = image.imageMobile) === null || ref1 === void 0 ? void 0 : ref1.src) && !(video === null || video === void 0 ? void 0 : video.srcMobile) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                        alt: image.alt,
                        className: "".concat(image.positionMobile),
                        fill: true,
                        sizes: "100vw",
                        priority: aboveTheFold,
                        src: image.imageMobile.src
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative hidden h-full w-full overflow-hidden md:block",
                children: [
                    (video === null || video === void 0 ? void 0 : video.srcDesktop) && /*#__PURE__*/ (0,jsx_runtime.jsx)(HalfHeroVideo, {
                        autoplay: video.autoplay,
                        posterSrc: (ref2 = video.posterDesktop) === null || ref2 === void 0 ? void 0 : ref2.src,
                        sound: video.sound,
                        videoAlt: videoAlt,
                        videoSrc: video.srcDesktop
                    }),
                    (image === null || image === void 0 ? void 0 : (ref3 = image.imageDesktop) === null || ref3 === void 0 ? void 0 : ref3.src) && !(video === null || video === void 0 ? void 0 : video.srcDesktop) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                        alt: image.alt,
                        className: "".concat(image.positionDesktop),
                        fill: true,
                        priority: aboveTheFold,
                        sizes: "50vw",
                        src: image.imageDesktop.src
                    })
                ]
            })
        ]
    });
}
HalfHeroMedia.displayName = "HalfHeroMedia";

;// CONCATENATED MODULE: ./src/sections/PackHalfHero/HalfHero.jsx





function HalfHero(param) {
    var cms = param.cms;
    var section = cms.section, content = cms.content, media = cms.media;
    var ref = (0,_object_spread/* default */.Z)({}, media), aspectDesktop = ref.aspectDesktop, aspectMobile = ref.aspectMobile, aspectTablet = ref.aspectTablet, fill = ref.fill, mediaOrderDesktop = ref.mediaOrderDesktop, mediaOrderMobile = ref.mediaOrderMobile;
    var maxWidthContainerClass = (section === null || section === void 0 ? void 0 : section.fullWidth) ? "max-w-none" : "max-w-[var(--content-max-width)]";
    var fillClass = fill ? "h-full" : "md:before:float-left ".concat(aspectTablet, " ").concat(aspectDesktop);
    var mediaOrderClasses = "".concat(mediaOrderMobile === "2" ? "order-2" : "order-1", " ").concat(mediaOrderDesktop === "2" ? "md:order-2" : "md:order-1");
    var contentOrderClasses = "".concat(mediaOrderMobile === "2" ? "order-1" : "order-2", " ").concat(mediaOrderDesktop === "2" ? "md:order-1" : "md:order-2");
    var mediaBgColorClass = (section === null || section === void 0 ? void 0 : section.bgColor) === "var(--background)" || (section === null || section === void 0 ? void 0 : section.bgColor) === "var(--white)" ? "bg-offWhite" : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((section === null || section === void 0 ? void 0 : section.fullBleed) ? "" : "px-contained", " relative overflow-hidden bg-[#f2f7fb] ").concat((section === null || section === void 0 ? void 0 : section.verticalPadding) ? "py-contained" : ""),
        style: {
            backgroundColor: section === null || section === void 0 ? void 0 : section.bgColor
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute h-full w-full",
                style: {
                    background: "linear-gradient(180deg, #2179C2 0%, #8DCEF9 51.04%, #F1DCC1 100%)",
                    opacity: 0.15,
                    transform: "matrix(1, 0, 0, -1, 0, 0)"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative mx-auto grid grid-cols-1 items-center md:grid-cols-2 ".concat(maxWidthContainerClass),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative w-full max-md:before:float-left ".concat(aspectMobile, " ").concat(fillClass, " ").concat(mediaOrderClasses, " ").concat(mediaBgColorClass, " ").concat(content.alignmentMobileOverImage ? "!absolute z-[1] lg:!relative" : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HalfHeroMedia, {
                            aboveTheFold: section === null || section === void 0 ? void 0 : section.aboveTheFold,
                            media: media,
                            videoAlt: content === null || content === void 0 ? void 0 : content.heading
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative z-[2] flex w-full items-center md:before:float-left ".concat(aspectTablet, " ").concat(aspectDesktop, " ").concat(contentOrderClasses),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HalfHeroContent, {
                            aboveTheFold: section === null || section === void 0 ? void 0 : section.aboveTheFold,
                            content: content
                        })
                    })
                ]
            })
        ]
    });
}
HalfHero.displayName = "HalfHero";
HalfHero.Schema = HalfHero_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/PackHalfHero/index.js


;// CONCATENATED MODULE: ./src/sections/PackHero/HeroContent.jsx






function HeroContent(param) {
    var aboveTheFold = param.aboveTheFold, isFirstSlide = param.isFirstSlide, slide = param.slide;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var button = slide.button, content = slide.content, text = slide.text;
    var ref8 = (0,_object_spread/* default */.Z)({}, text), color = ref8.color, heading = ref8.heading, subheading = ref8.subheading, superheading = ref8.superheading;
    var ref9 = (0,_object_spread/* default */.Z)({}, content), alignmentMobile = ref9.alignmentMobile, alignmentDesktop = ref9.alignmentDesktop, darkOverlay = ref9.darkOverlay, maxWidthMobile = ref9.maxWidthMobile, maxWidthDesktop = ref9.maxWidthDesktop, positionMobile = ref9.positionMobile, positionDesktop = ref9.positionDesktop;
    var alignmentClasses = "".concat(alignmentMobile, " ").concat(alignmentDesktop);
    var positionClasses = "".concat(positionMobile, " ").concat(positionDesktop);
    var maxWidthContentClasses = "".concat(maxWidthMobile, " ").concat(maxWidthDesktop);
    var darkOverlayClass = darkOverlay ? "bg-[rgba(0,0,0,0.2)]" : "";
    var headingWithBreaks = (0,react.useMemo)(function() {
        var splitHeading = heading === null || heading === void 0 ? void 0 : heading.split("\n");
        if ((splitHeading === null || splitHeading === void 0 ? void 0 : splitHeading.length) === 1) return heading;
        return splitHeading === null || splitHeading === void 0 ? void 0 : splitHeading.reduce(function(acc, line, index, arr) {
            acc.push(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: line
            }, index));
            if (index < arr.length - 1) acc.push(/*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}, "br".concat(index)));
            return acc;
        }, []);
    }, [
        heading
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pointer-events-none absolute inset-0 flex h-full w-full p-4 md:p-8 xl:p-12 ".concat(positionClasses, " ").concat(darkOverlayClass),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pointer-events-auto flex flex-col ".concat(alignmentClasses, " ").concat(maxWidthContentClasses),
                style: {
                    color: color
                },
                children: [
                    superheading && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-superheading max-lg:mb-1",
                        children: superheading
                    }),
                    aboveTheFold && isFirstSlide ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                        variant: "h2",
                        element: "h2",
                        className: "pb-4",
                        children: headingWithBreaks
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                        variant: "h2",
                        element: "h2",
                        className: "pb-4",
                        children: headingWithBreaks
                    }),
                    subheading && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mt-4",
                        children: subheading
                    }),
                    (button === null || button === void 0 ? void 0 : (ref = button.buttons) === null || ref === void 0 ? void 0 : ref.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "mt-6 flex flex-col justify-center gap-4 xs:flex-row",
                        children: button === null || button === void 0 ? void 0 : (ref1 = button.buttons) === null || ref1 === void 0 ? void 0 : ref1.slice(0, 2).map(function(param, index) {
                            var link = param.link, style = param.style;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    href: link === null || link === void 0 ? void 0 : link.text,
                                    theme: style ? style : "primary",
                                    variant: "filled",
                                    children: link === null || link === void 0 ? void 0 : link.text
                                })
                            }, index);
                        })
                    })
                ]
            }),
            (button === null || button === void 0 ? void 0 : button.clickableSlide) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                "aria-label": (ref2 = button.buttons) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.link) === null || ref4 === void 0 ? void 0 : ref4.text,
                className: "pointer-events-auto absolute inset-0 z-[1] h-full w-full",
                href: (ref5 = button.buttons) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[0]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.link) === null || ref7 === void 0 ? void 0 : ref7.url
            })
        ]
    });
}
HeroContent.displayName = "HeroContent";

;// CONCATENATED MODULE: ./src/sections/PackHero/HeroVideo.jsx


function HeroVideo(param) {
    var isVisible = param.isVisible, posterSrc = param.posterSrc, videoSrc = param.videoSrc;
    var videoRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (isVisible) {
            videoRef.current.play();
        } else {
            videoRef.current.pause();
        }
    }, [
        isVisible
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
        className: "absolute inset-0 h-full w-full object-cover",
        controls: false,
        loop: true,
        muted: true,
        playsInline: true,
        poster: posterSrc,
        ref: videoRef,
        children: isVisible && videoSrc && /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
            src: videoSrc,
            type: "video/mp4"
        })
    });
}
HeroVideo.displayName = "HeroVideo";

;// CONCATENATED MODULE: ./src/sections/PackHero/HeroSlide.jsx




function HeroSlide(param) {
    var aboveTheFold = param.aboveTheFold, isFirstSlide = param.isFirstSlide, isVisible = param.isVisible, slide = param.slide;
    var ref, ref1, ref2, ref3;
    var image = slide.image, video = slide.video;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative h-full w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative h-full w-full overflow-hidden md:hidden",
                children: [
                    (video === null || video === void 0 ? void 0 : video.srcMobile) && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroVideo, {
                        isVisible: isVisible,
                        posterSrc: (ref = video.posterMobile) === null || ref === void 0 ? void 0 : ref.src,
                        videoSrc: video.srcMobile
                    }),
                    (image === null || image === void 0 ? void 0 : (ref1 = image.imageMobile) === null || ref1 === void 0 ? void 0 : ref1.src) && !(video === null || video === void 0 ? void 0 : video.srcMobile) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                        alt: image.alt,
                        className: "".concat(image.positionMobile),
                        fill: true,
                        priority: aboveTheFold && isFirstSlide,
                        sizes: "100vw",
                        src: image.imageMobile.src
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative hidden h-full w-full overflow-hidden md:block",
                children: [
                    (video === null || video === void 0 ? void 0 : video.srcDesktop) && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroVideo, {
                        isVisible: isVisible,
                        posterSrc: (ref2 = video.posterDesktop) === null || ref2 === void 0 ? void 0 : ref2.src,
                        videoSrc: video.srcDesktop
                    }),
                    (image === null || image === void 0 ? void 0 : (ref3 = image.imageDesktop) === null || ref3 === void 0 ? void 0 : ref3.src) && !(video === null || video === void 0 ? void 0 : video.srcDesktop) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                        alt: image.alt,
                        className: "".concat(image.positionDesktop),
                        fill: true,
                        priority: aboveTheFold && isFirstSlide,
                        sizes: "100vw",
                        src: image.imageDesktop.src
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroContent, {
                aboveTheFold: aboveTheFold,
                isFirstSlide: isFirstSlide,
                slide: slide
            })
        ]
    });
}
HeroSlide.displayName = "HeroSlide";

;// CONCATENATED MODULE: ./src/sections/PackHero/HeroSlider.jsx





function HeroSlider(param) {
    var aboveTheFold = param.aboveTheFold, slider = param.slider, slides = param.slides;
    var ref = (0,react.useState)(0), visibleIndex = ref[0], setVisibleIndex = ref[1];
    var activeBulletColor = slider.activeBulletColor, autoplay = slider.autoplay, delay = slider.delay, effect = slider.effect, pagination = slider.pagination;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
        a11y: {
            enabled: true
        },
        autoplay: autoplay ? {
            delay: delay || 5000,
            disableOnInteraction: false
        } : false,
        className: "h-full w-full",
        effect: effect,
        fadeEffect: {
            crossFade: true
        },
        grabCursor: true,
        onSlideChange: function(swiper) {
            return setVisibleIndex(swiper.realIndex);
        },
        modules: [
            modules/* A11y */.s5,
            modules/* Autoplay */.pt,
            modules/* EffectFade */.xW,
            modules/* Pagination */.tl
        ],
        pagination: {
            el: ".swiper-pagination",
            type: "bullets",
            clickable: true,
            renderBullet: function renderBullet(_, className) {
                return '<span class="'.concat(className, '" style="background-color: ').concat(activeBulletColor, '"></span>');
            }
        },
        slidesPerView: 1,
        children: [
            slides.map(function(slide, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroSlide, {
                        aboveTheFold: aboveTheFold,
                        isFirstSlide: index === 0,
                        isVisible: index === visibleIndex,
                        slide: slide
                    })
                }, index);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "swiper-pagination ".concat(pagination ? "" : "!hidden")
            })
        ]
    });
}
HeroSlider.displayName = "HeroSlider";

;// CONCATENATED MODULE: ./src/sections/PackHero/Hero.schema.js

var Hero_schema_image = {
    label: "Image Settings",
    name: "image",
    description: "Image, image position",
    component: "group",
    fields: [
        {
            label: "Image Alt",
            name: "alt",
            component: "text",
            description: "Brief description of image"
        },
        {
            label: "Image (tablet/desktop)",
            name: "imageDesktop",
            component: "image"
        },
        {
            label: "Image Position (tablet/desktop)",
            name: "positionDesktop",
            component: "select",
            options: OBJECT_POSITIONS.desktop
        },
        {
            label: "Image (mobile)",
            name: "imageMobile",
            component: "image"
        },
        {
            label: "Image Position (mobile)",
            name: "positionMobile",
            component: "select",
            options: OBJECT_POSITIONS.mobile
        }, 
    ]
};
var video = {
    label: "Video Settings",
    name: "video",
    description: "Video link, poster image",
    component: "group",
    fields: [
        {
            label: "Video URL (tablet/desktop)",
            name: "srcDesktop",
            component: "text",
            description: "Overrides tablet/desktop image option"
        },
        {
            label: "Poster Image (tablet/desktop)",
            name: "posterDesktop",
            component: "image",
            description: "First frame of video while video loads"
        },
        {
            label: "Video URL (mobile)",
            name: "srcMobile",
            component: "text",
            description: "Overrides mobile image option"
        },
        {
            label: "Poster Image (mobile)",
            name: "posterMobile",
            component: "image",
            description: "First frame of video while video loads"
        }, 
    ]
};
var Hero_schema_text = {
    label: "Text Settings",
    name: "text",
    description: "Heading, superheading, subheading, color",
    component: "group",
    fields: [
        {
            label: "Heading",
            name: "heading",
            component: "textarea"
        },
        {
            label: "Superheading",
            name: "superheading",
            component: "text"
        },
        {
            label: "Subheading",
            name: "subheading",
            component: "text"
        },
        {
            label: "Text Color",
            name: "color",
            component: "select",
            options: COLORS
        }, 
    ]
};
var buttons = {
    label: "Button Settings",
    name: "button",
    description: "Clickable slide, button links, button styles",
    component: "group",
    fields: [
        {
            label: "Entire Slide Clickable",
            name: "clickableSlide",
            component: "toggle",
            description: "Makes entire slide clickable using the first link below",
            toggleLabels: {
                true: "On",
                false: "Off"
            }
        },
        {
            label: "Buttons",
            name: "buttons",
            component: "group-list",
            description: "Max of two buttons",
            itemProps: {
                label: "{{item.link.text}}"
            },
            validate: {
                maxItems: 2
            },
            fields: [
                {
                    label: "Link",
                    name: "link",
                    component: "link"
                },
                {
                    label: "Button Style",
                    name: "style",
                    component: "select",
                    options: [
                        {
                            label: "Primary",
                            value: "primary"
                        },
                        {
                            label: "Secondary",
                            value: "secondary"
                        },
                        {
                            label: "Light",
                            value: "light"
                        },
                        {
                            label: "Inverse Dark",
                            value: "btn-inverse-dark"
                        }, 
                    ]
                }, 
            ],
            defaultItem: {
                link: {
                    text: "Shop All",
                    url: ""
                },
                style: "btn-primary"
            }
        }, 
    ]
};
var Hero_schema_content = {
    label: "Content Settings",
    name: "content",
    description: "Dark overlay, content position, content alignment",
    component: "group",
    fields: [
        {
            label: "Dark Overlay",
            name: "darkOverlay",
            component: "toggle",
            description: "Adds 20% opacity black overlay over media",
            toggleLabels: {
                true: "On",
                false: "Off"
            }
        },
        {
            label: "Content Position (tablet/desktop)",
            name: "positionDesktop",
            component: "select",
            options: FLEX_POSITIONS.desktop
        },
        {
            label: "Content Alignment (tablet/desktop)",
            name: "alignmentDesktop",
            component: "radio-group",
            direction: "horizontal",
            variant: "radio",
            options: [
                {
                    label: "Left",
                    value: "md:text-left md:items-start"
                },
                {
                    label: "Center",
                    value: "md:text-center md:items-center"
                },
                {
                    label: "Right",
                    value: "md:text-right md:items-end"
                }, 
            ]
        },
        {
            label: "Max Content Width (tablet/desktop)",
            name: "maxWidthDesktop",
            component: "select",
            options: [
                {
                    label: "Narrow",
                    value: "md:max-w-[22rem] lg:max-w-[28rem]"
                },
                {
                    label: "Medium",
                    value: "md:max-w-[30rem] lg:max-w-[38rem]"
                },
                {
                    label: "Wide",
                    value: "md:max-w-[38rem] lg:max-w-[48rem]"
                },
                {
                    label: "Full",
                    value: "md:max-w-full"
                }, 
            ]
        },
        {
            label: "Content Position (mobile)",
            name: "positionMobile",
            component: "select",
            options: FLEX_POSITIONS.mobile
        },
        {
            label: "Content Alignment (mobile)",
            name: "alignmentMobile",
            component: "radio-group",
            direction: "horizontal",
            variant: "radio",
            options: [
                {
                    label: "Left",
                    value: "text-left items-start"
                },
                {
                    label: "Center",
                    value: "text-center items-center"
                },
                {
                    label: "Right",
                    value: "text-right items-end"
                }, 
            ]
        },
        {
            label: "Max Content Width (mobile)",
            name: "maxWidthMobile",
            component: "select",
            options: [
                {
                    label: "Narrow",
                    value: "max-w-[16.5rem]"
                },
                {
                    label: "Medium",
                    value: "max-w-[22.5rem]"
                },
                {
                    label: "Wide",
                    value: "max-w-[28.5rem]"
                },
                {
                    label: "Full",
                    value: "max-w-full"
                }, 
            ]
        }, 
    ]
};
var defaultSlide = {
    image: {
        alt: "Three men outside wearing outerwear",
        imageDesktop: {
            src: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/tanya-pro-J2Cr4cBnN-0-unsplash_20_281_29.jpg?v=1672724643"
        },
        positionDesktop: "md:object-center",
        imageMobile: {
            src: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/tanya-pro-J2Cr4cBnN-0-unsplash_20_281_29.jpg?v=1672724643"
        },
        positionMobile: "object-center"
    },
    text: {
        heading: "All new products\nthis season",
        superheading: "",
        subheading: "New styles and new fits",
        color: "var(--white)"
    },
    button: {
        clickableSlide: false,
        buttons: [
            {
                link: {
                    text: "Shop Now",
                    url: ""
                },
                style: "btn-primary"
            }, 
        ]
    },
    content: {
        darkOverlay: false,
        alignmentDesktop: "md:text-left md:items-start",
        positionDesktop: "md:justify-start items-center",
        maxWidthDesktop: "md:max-w-[30rem] lg:max-w-[38rem]",
        alignmentMobile: "text-left items-start",
        positionMobile: "justify-start items-center",
        maxWidthMobile: "max-w-[22.5rem]"
    }
};
var PackHero_Hero_schema_Schema = function() {
    return {
        category: "Hero",
        label: "Hero",
        key: "hero",
        previewSrc: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/hero-preview_2cd7154c-7ec6-4846-84ca-85aaef836165.jpg?v=1675795229",
        fields: [
            {
                name: "slides",
                label: "Slides",
                component: "group-list",
                itemProps: {
                    label: "{{item.text.heading}}"
                },
                fields: [
                    Hero_schema_image,
                    video,
                    Hero_schema_text,
                    buttons,
                    Hero_schema_content
                ],
                defaultValue: [
                    defaultSlide
                ],
                defaultItem: defaultSlide
            },
            {
                label: "Slider Settings",
                name: "slider",
                description: "Autoplay, delay, transition effect, bullet color",
                component: "group",
                fields: [
                    {
                        label: "Enable Autoplay",
                        name: "autoplay",
                        component: "toggle",
                        toggleLabels: {
                            true: "On",
                            false: "Off"
                        }
                    },
                    {
                        label: "Enable Pagination Bullets",
                        name: "pagination",
                        component: "toggle",
                        toggleLabels: {
                            true: "On",
                            false: "Off"
                        }
                    },
                    {
                        label: "Delay Between Transitions (ms)",
                        name: "delay",
                        component: "number"
                    },
                    {
                        label: "Effect Between Transitions",
                        name: "effect",
                        component: "radio-group",
                        direction: "horizontal",
                        variant: "radio",
                        options: [
                            {
                                label: "Slide",
                                value: "slide"
                            },
                            {
                                label: "Fade",
                                value: "fade"
                            }, 
                        ]
                    },
                    {
                        label: "Active Bullet Color",
                        name: "activeBulletColor",
                        component: "select",
                        options: COLORS
                    }, 
                ],
                defaultValue: {
                    autoplay: true,
                    pagination: true,
                    delay: 8000,
                    effect: "fade",
                    activeBulletColor: "var(--white)"
                }
            },
            {
                label: "Section Settings",
                name: "section",
                component: "group",
                description: "Above the fold, full width, full bleed, height",
                fields: [
                    {
                        label: "Above The Fold",
                        name: "aboveTheFold",
                        component: "toggle",
                        description: "Sets the first slide's heading as H1 and preloads the image",
                        toggleLabels: {
                            true: "On",
                            false: "Off"
                        }
                    },
                    {
                        label: "Full Width",
                        name: "fullWidth",
                        component: "toggle",
                        description: "Removes max width of this section",
                        toggleLabels: {
                            true: "On",
                            false: "Off"
                        }
                    },
                    {
                        label: "Full Bleed",
                        name: "fullBleed",
                        component: "toggle",
                        description: "Removes padding of this section",
                        toggleLabels: {
                            true: "On",
                            false: "Off"
                        }
                    },
                    {
                        label: "Height (desktop)",
                        name: "heightDesktop",
                        component: "select",
                        description: "Sets desktop height of this section",
                        options: [
                            {
                                label: "200px",
                                value: "lg:h-[12.5rem]"
                            },
                            {
                                label: "300px",
                                value: "lg:h-[18.75rem]"
                            },
                            {
                                label: "400px",
                                value: "lg:h-[25rem]"
                            },
                            {
                                label: "500px",
                                value: "lg:h-[31.25rem]"
                            },
                            {
                                label: "600px",
                                value: "lg:h-[37.5rem]"
                            },
                            {
                                label: "700px",
                                value: "lg:h-[43.75rem]"
                            },
                            {
                                label: "800px",
                                value: "lg:h-[50rem]"
                            }, 
                        ]
                    },
                    {
                        label: "Height (tablet)",
                        name: "heightTablet",
                        component: "select",
                        description: "Sets tablet height of this section",
                        options: [
                            {
                                label: "200px",
                                value: "md:h-[12.5rem]"
                            },
                            {
                                label: "300px",
                                value: "md:h-[18.75rem]"
                            },
                            {
                                label: "400px",
                                value: "md:h-[25rem]"
                            },
                            {
                                label: "500px",
                                value: "md:h-[31.25rem]"
                            },
                            {
                                label: "600px",
                                value: "md:h-[37.5rem]"
                            },
                            {
                                label: "700px",
                                value: "md:h-[43.75rem]"
                            },
                            {
                                label: "800px",
                                value: "md:h-[50rem]"
                            }, 
                        ]
                    },
                    {
                        label: "Height (mobile)",
                        name: "heightMobile",
                        component: "select",
                        description: "Sets mobile height of this section",
                        options: [
                            {
                                label: "200px",
                                value: "h-[12.5rem]"
                            },
                            {
                                label: "300px",
                                value: "h-[18.75rem]"
                            },
                            {
                                label: "400px",
                                value: "h-[25rem]"
                            },
                            {
                                label: "500px",
                                value: "h-[31.25rem]"
                            },
                            {
                                label: "600px",
                                value: "h-[37.5rem]"
                            },
                            {
                                label: "700px",
                                value: "h-[43.75rem]"
                            },
                            {
                                label: "800px",
                                value: "h-[50rem]"
                            }, 
                        ]
                    }, 
                ],
                defaultValue: {
                    aboveTheFold: true,
                    fullWidth: true,
                    fullBleed: true,
                    heightDesktop: "lg:h-[43.75rem]",
                    heightTablet: "md:h-[37.5rem]",
                    heightMobile: "h-[25rem]"
                }
            }, 
        ]
    };
};

;// CONCATENATED MODULE: ./src/sections/PackHero/Hero.jsx




function Hero(param) {
    var cms = param.cms;
    var section = cms.section, slider = cms.slider, slides = cms.slides;
    var maxWidthContainerClass = (section === null || section === void 0 ? void 0 : section.fullWidth) ? "max-w-none" : "max-w-[var(--content-max-width)]";
    var isFullBleed = section === null || section === void 0 ? void 0 : section.fullBleed;
    var heightContainerClasses = "".concat(section === null || section === void 0 ? void 0 : section.heightMobile, " ").concat(section === null || section === void 0 ? void 0 : section.heightTablet, " ").concat(section === null || section === void 0 ? void 0 : section.heightDesktop);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat(isFullBleed ? "" : "px-contained"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative mx-auto flex flex-col bg-offWhite ".concat(heightContainerClasses, " ").concat(maxWidthContainerClass),
            children: [
                (slides === null || slides === void 0 ? void 0 : slides.length) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroSlider, {
                    aboveTheFold: section === null || section === void 0 ? void 0 : section.aboveTheFold,
                    slider: slider,
                    slides: slides
                }),
                (slides === null || slides === void 0 ? void 0 : slides.length) === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroSlide, {
                    aboveTheFold: section === null || section === void 0 ? void 0 : section.aboveTheFold,
                    isFirstSlide: true,
                    isVisible: true,
                    slide: slides[0]
                })
            ]
        })
    });
}
Hero.displayName = "Hero";
Hero.Schema = PackHero_Hero_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/PackHero/index.js


;// CONCATENATED MODULE: ./src/sections/PackIconRow/IconRow.schema.js

function IconRow_schema_Schema() {
    return {
        category: "Text",
        label: "Icon Row",
        key: "icon-row",
        previewSrc: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/icon-row-preview.jpg?v=1675730317",
        fields: [
            {
                label: "Heading",
                name: "heading",
                component: "text",
                defaultValue: "Icon Row Heading"
            },
            {
                label: "Subtext",
                name: "subtext",
                component: "markdown",
                defaultValue: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
            },
            {
                label: "Icons",
                name: "icons",
                component: "group-list",
                itemProps: {
                    label: "{{item.icon}}"
                },
                fields: [
                    {
                        label: "Icon",
                        name: "icon",
                        component: "select",
                        options: [
                            {
                                label: "Shipping",
                                value: "shipping"
                            },
                            {
                                label: "Customer Service",
                                value: "customer-service"
                            },
                            {
                                label: "Warranty",
                                value: "warranty"
                            },
                            {
                                label: "Innovation",
                                value: "innovation"
                            }, 
                        ]
                    },
                    {
                        label: "Label",
                        name: "label",
                        component: "text"
                    }, 
                ],
                defaultValue: [
                    {
                        icon: "shipping",
                        label: "Free Shipping"
                    },
                    {
                        icon: "customer-service",
                        label: "Top Customer Service"
                    },
                    {
                        icon: "warranty",
                        label: "Lifetime Warranty"
                    },
                    {
                        icon: "innovation",
                        label: "Innovative Designs"
                    }, 
                ],
                defaultItem: {
                    icon: "shipping",
                    label: "New Icon"
                }
            },
            {
                label: "Section Settings",
                name: "section",
                component: "group",
                description: "Background color, text color, icon color, full width",
                fields: [
                    {
                        label: "Background Color",
                        name: "bgColor",
                        component: "select",
                        options: COLORS
                    },
                    {
                        label: "Text Color",
                        name: "textColor",
                        component: "select",
                        options: COLORS
                    },
                    {
                        label: "Icon Color",
                        name: "iconColor",
                        component: "select",
                        options: COLORS
                    },
                    {
                        label: "Full Width",
                        name: "fullWidth",
                        component: "toggle",
                        description: "Removes max width of this section",
                        toggleLabels: {
                            true: "On",
                            false: "Off"
                        }
                    }, 
                ],
                defaultValue: {
                    bgColor: "var(--off-white)",
                    textColor: "var(--text)",
                    iconColor: "var(--primary)",
                    fullWidth: false
                }
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/PackIconRow/IconRow.jsx



function IconRow(param) {
    var cms = param.cms;
    var heading = cms.heading, icons = cms.icons, section = cms.section, subtext = cms.subtext;
    var maxWidthClass = (section === null || section === void 0 ? void 0 : section.fullWidth) ? "max-w-none" : "max-w-[var(--content-max-width)]";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "px-contained py-contained",
        style: {
            backgroundColor: section === null || section === void 0 ? void 0 : section.bgColor,
            color: section === null || section === void 0 ? void 0 : section.textColor
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mx-auto flex flex-col items-center gap-4 text-center md:gap-6 ".concat(maxWidthClass),
            children: [
                heading && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-title-h2 mx-auto max-w-[46rem]",
                    children: heading
                }),
                subtext && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-auto max-w-[46rem] [&_p]:text-base [&_h2]:text-base [&_h1]:text-base [&_h3]:text-base [&_h4]:text-base [&_h5]:text-base [&_h6]:text-base [&_a]:underline",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Markdown */.UG, {
                        children: subtext
                    })
                }),
                (icons === null || icons === void 0 ? void 0 : icons.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "mt-4 flex flex-wrap justify-center",
                    children: icons.map(function(param, index) {
                        var icon = param.icon, label = param.label;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            className: "flex max-w-[16rem] grow basis-1/2 flex-col items-center p-4 text-center md:basis-1/6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                                    className: "w-12",
                                    src: "/svgs/noprecache/icons/".concat(icon, ".svg#").concat(icon),
                                    style: {
                                        color: section === null || section === void 0 ? void 0 : section.iconColor
                                    },
                                    title: label || icon,
                                    viewBox: "0 0 24 24"
                                }),
                                label && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mt-3 font-bold",
                                    children: label
                                })
                            ]
                        }, index);
                    })
                })
            ]
        })
    });
}
IconRow.displayName = "IconRow";
IconRow.Schema = IconRow_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/PackIconRow/index.js


;// CONCATENATED MODULE: ./src/sections/PackImage/Image.schema.js

function Image_schema_Schema() {
    return {
        category: "Image",
        label: "Image",
        key: "image",
        previewSrc: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/image-preview.jpg?v=1675730321",
        fields: [
            {
                label: "Image Settings",
                name: "image",
                component: "group",
                description: "Image, aspect ratio, image position",
                fields: [
                    {
                        label: "Image Alt",
                        name: "alt",
                        component: "text",
                        description: "Brief description of image"
                    },
                    {
                        label: "Image (tablet/desktop)",
                        name: "imageDesktop",
                        component: "image"
                    },
                    {
                        label: "Image Aspect Ratio (tablet/desktop)",
                        name: "aspectDesktop",
                        component: "select",
                        options: [
                            {
                                label: "3:1",
                                value: "md:aspect-[3/1]"
                            },
                            {
                                label: "5:2",
                                value: "md:aspect-[5/2]"
                            },
                            {
                                label: "2:1",
                                value: "md:aspect-[2/1]"
                            },
                            {
                                label: "16:9",
                                value: "md:aspect-[16/9]"
                            },
                            {
                                label: "3:2",
                                value: "md:aspect-[3/2]"
                            },
                            {
                                label: "4:3",
                                value: "md:aspect-[4/3]"
                            },
                            {
                                label: "5:4",
                                value: "md:aspect-[5/4]"
                            },
                            {
                                label: "1:1",
                                value: "md:aspect-[1/1]"
                            },
                            {
                                label: "4:5",
                                value: "md:aspect-[4/5]"
                            },
                            {
                                label: "3:4",
                                value: "md:aspect-[3/4]"
                            },
                            {
                                label: "2:3",
                                value: "md:aspect-[2/3]"
                            },
                            {
                                label: "9:16",
                                value: "md:aspect-[9/16]"
                            }, 
                        ]
                    },
                    {
                        label: "Image Position (tablet/desktop)",
                        name: "positionDesktop",
                        component: "select",
                        options: OBJECT_POSITIONS.desktop
                    },
                    {
                        label: "Image (mobile)",
                        name: "imageMobile",
                        component: "image"
                    },
                    {
                        label: "Image Aspect Ratio (mobile)",
                        name: "aspectMobile",
                        component: "select",
                        options: [
                            {
                                label: "3:1",
                                value: "aspect-[3/1]"
                            },
                            {
                                label: "5:2",
                                value: "aspect-[5/2]"
                            },
                            {
                                label: "2:1",
                                value: "aspect-[2/1]"
                            },
                            {
                                label: "16:9",
                                value: "aspect-[16/9]"
                            },
                            {
                                label: "3:2",
                                value: "aspect-[3/2]"
                            },
                            {
                                label: "4:3",
                                value: "aspect-[4/3]"
                            },
                            {
                                label: "5:4",
                                value: "aspect-[5/4]"
                            },
                            {
                                label: "1:1",
                                value: "aspect-[1/1]"
                            },
                            {
                                label: "4:5",
                                value: "aspect-[4/5]"
                            },
                            {
                                label: "3:4",
                                value: "aspect-[3/4]"
                            },
                            {
                                label: "2:3",
                                value: "aspect-[2/3]"
                            },
                            {
                                label: "9:16",
                                value: "aspect-[9/16]"
                            }, 
                        ]
                    },
                    {
                        label: "Image Position (mobile)",
                        name: "positionMobile",
                        component: "select",
                        options: OBJECT_POSITIONS.mobile
                    }, 
                ],
                defaultValue: {
                    alt: "Rack of green t-shirts",
                    imageDesktop: {
                        src: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/keagan-henman-xPJYL0l5Ii8-unsplash_20_281_29.jpg?v=1672349016"
                    },
                    aspectDesktop: "md:aspect-[16/9]",
                    positionDesktop: "md:object-center",
                    imageMobile: {
                        src: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/keagan-henman-xPJYL0l5Ii8-unsplash_20_281_29.jpg?v=1672349016"
                    },
                    aspectMobile: "aspect-[16/9]",
                    positionMobile: "object-center"
                }
            },
            {
                label: "Content Settings",
                name: "content",
                component: "group",
                description: "Link, caption",
                fields: [
                    {
                        label: "Link",
                        name: "link",
                        component: "link",
                        description: "Optional link to make image clickable"
                    },
                    {
                        label: "Caption",
                        name: "caption",
                        component: "markdown",
                        description: "Optional caption below image"
                    }, 
                ]
            },
            {
                label: "Section Settings",
                name: "section",
                component: "group",
                description: "Max width, horizontal padding",
                fields: [
                    {
                        label: "Max Width",
                        name: "maxWidth",
                        component: "select",
                        options: [
                            {
                                label: "Narrow",
                                value: "max-w-[30rem]"
                            },
                            {
                                label: "Medium Narrow",
                                value: "max-w-[45rem]"
                            },
                            {
                                label: "Medium",
                                value: "max-w-[60rem]"
                            },
                            {
                                label: "Medium Wide",
                                value: "max-w-[75rem]"
                            },
                            {
                                label: "Wide",
                                value: "max-w-[90rem]"
                            },
                            {
                                label: "Full",
                                value: "max-w-full"
                            }, 
                        ]
                    },
                    {
                        label: "Enable Horizontal Padding",
                        name: "enablePadding",
                        component: "toggle",
                        toggleLabels: {
                            true: "On",
                            false: "Off"
                        }
                    }, 
                ],
                defaultValue: {
                    maxWidth: "max-w-[90rem]",
                    enablePadding: true
                }
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/PackImage/Image.jsx





function Image(param) {
    var cms = param.cms;
    var content = cms.content, image = cms.image, section = cms.section;
    var ref = (0,_object_spread/* default */.Z)({}, image), alt = ref.alt, aspectDesktop = ref.aspectDesktop, aspectMobile = ref.aspectMobile, imageDesktop = ref.imageDesktop, imageMobile = ref.imageMobile, positionDesktop = ref.positionDesktop, positionMobile = ref.positionMobile;
    var ref1 = (0,_object_spread/* default */.Z)({}, content), caption = ref1.caption, link = ref1.link;
    var ref2 = (0,_object_spread/* default */.Z)({}, section), maxWidth = ref2.maxWidth, enablePadding = ref2.enablePadding;
    var sizes = (0,react.useMemo)(function() {
        var ref;
        return ((ref = /[0-9]+(?:px)|[0-9]+(?:rem)/.exec(maxWidth)) === null || ref === void 0 ? void 0 : ref[0]) || "100vw";
    }, [
        maxWidth
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "py-4 md:py-6 lg:py-8 ".concat(enablePadding ? "px-contained" : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(snippets/* Link */.rU, {
                "aria-label": link === null || link === void 0 ? void 0 : link.text,
                className: "mx-auto ".concat(maxWidth),
                href: link === null || link === void 0 ? void 0 : link.url,
                newTab: link === null || link === void 0 ? void 0 : link.newTab,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative bg-offWhite md:hidden ".concat(aspectMobile),
                        children: (imageMobile === null || imageMobile === void 0 ? void 0 : imageMobile.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                            alt: alt,
                            className: "".concat(positionMobile),
                            fill: true,
                            sizes: sizes,
                            src: imageMobile.src
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative hidden bg-offWhite md:block ".concat(aspectDesktop),
                        children: (imageDesktop === null || imageDesktop === void 0 ? void 0 : imageDesktop.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                            alt: alt,
                            className: "".concat(positionDesktop),
                            fill: true,
                            sizes: sizes,
                            src: imageDesktop.src
                        })
                    })
                ]
            }),
            caption && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-3 ".concat(enablePadding ? "" : "px-contained"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-auto [&_p]:text-base [&_h2]:text-base [&_h1]:text-base [&_h3]:text-base [&_h4]:text-base [&_h5]:text-base [&_h6]:text-base [&_a]:underline ".concat(maxWidth),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Markdown */.UG, {
                        children: caption
                    })
                })
            })
        ]
    });
}
Image.displayName = "Image";
Image.Schema = Image_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/PackImage/index.js


;// CONCATENATED MODULE: ./src/sections/PackImageTiles/ImageTile.jsx


function ImageTile(param) {
    var aspectRatio = param.aspectRatio, content = param.content, item = param.item;
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(snippets/* Link */.rU, {
        "aria-label": item.link.text,
        className: "w-full",
        href: (content === null || content === void 0 ? void 0 : content.clickableImage) ? item.link.url : "",
        newTab: item.link.newTab,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative bg-offWhite ".concat(aspectRatio),
                children: ((ref = item.image) === null || ref === void 0 ? void 0 : ref.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                    alt: item.alt,
                    className: "".concat(item.position),
                    fill: true,
                    sizes: "(min-width: 1024px) 30vw, (min-width: 768px) 50vw, 100vw",
                    src: item.image.src
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pointer-events-none absolute inset-0 flex h-full w-full p-6 text-center md:p-8 ".concat((content === null || content === void 0 ? void 0 : content.darkOverlay) ? "bg-[rgba(0,0,0,0.2)]" : "", " ").concat(content === null || content === void 0 ? void 0 : content.contentPosition),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "pointer-events-auto flex flex-col gap-3 lg:gap-4",
                    children: [
                        item.heading && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "text-xl text-white sm:text-2xl",
                            children: item.heading
                        }),
                        !(content === null || content === void 0 ? void 0 : content.hideButton) && ((ref1 = item.link) === null || ref1 === void 0 ? void 0 : ref1.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                                "aria-label": item.link.text,
                                className: "".concat(content === null || content === void 0 ? void 0 : content.buttonStyle),
                                href: !(content === null || content === void 0 ? void 0 : content.clickableImage) ? item.link.url : "",
                                newTab: item.link.newTab,
                                children: item.link.text
                            })
                        })
                    ]
                })
            })
        ]
    });
}
ImageTile.displayName = "ImageTile";

;// CONCATENATED MODULE: ./src/sections/PackImageTiles/ImageTiles.schema.js

function ImageTiles_schema_Schema() {
    return {
        category: "Image",
        label: "Image Tiles",
        key: "image-tiles",
        previewSrc: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/image-tiles-preview.jpg?v=1675730325",
        fields: [
            {
                label: "Heading",
                name: "heading",
                component: "text"
            },
            {
                label: "Tiles",
                name: "tiles",
                description: "Min of 2 tiles, max of 3 tiles",
                component: "group-list",
                itemProps: {
                    label: "{{item.heading}}"
                },
                validate: {
                    maxItems: 3
                },
                fields: [
                    {
                        label: "Image Alt",
                        name: "alt",
                        component: "text",
                        description: "Brief description of image"
                    },
                    {
                        label: "Image",
                        name: "image",
                        component: "image"
                    },
                    {
                        label: "Image Position",
                        name: "position",
                        component: "select",
                        options: OBJECT_POSITIONS.mobile
                    },
                    {
                        label: "Heading",
                        name: "heading",
                        component: "text"
                    },
                    {
                        label: "Link",
                        name: "link",
                        component: "link"
                    }, 
                ],
                defaultItem: {
                    alt: "Man in white and light tan outfit",
                    image: {
                        src: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/man-in-white-and-light-tan-outfit.jpg?v=1672348139"
                    },
                    position: "object-center",
                    heading: "Headline",
                    link: {
                        text: "Shop Now",
                        url: ""
                    }
                },
                defaultValue: [
                    {
                        alt: "Man in white and light tan outfit",
                        image: {
                            src: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/man-in-white-and-light-tan-outfit.jpg?v=1672348139"
                        },
                        position: "object-center",
                        heading: "Headline",
                        link: {
                            text: "Shop Now",
                            url: ""
                        }
                    },
                    {
                        alt: "Man in brown coat sitting down",
                        image: {
                            src: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/austin-wade-d2s8NQ6WD24-unsplash.jpg?v=1672348122"
                        },
                        position: "object-center",
                        heading: "Headline",
                        link: {
                            text: "Shop Now",
                            url: ""
                        }
                    },
                    {
                        alt: "Man in gray sweater and tan coat",
                        image: {
                            src: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/man-poses-in-light-colored-overcoat.jpg?v=1672348143"
                        },
                        position: "object-center",
                        heading: "Headline",
                        link: {
                            text: "Shop Now",
                            url: ""
                        }
                    }, 
                ]
            },
            {
                label: "Content Settings",
                name: "content",
                component: "group",
                description: "Dark overlay, content position, button style, clickable image, hide button",
                fields: [
                    {
                        label: "Dark Overlay",
                        name: "darkOverlay",
                        component: "toggle",
                        description: "Adds 20% opacity black overlay over media",
                        toggleLabels: {
                            true: "On",
                            false: "Off"
                        }
                    },
                    {
                        label: "Content Position",
                        name: "contentPosition",
                        component: "select",
                        options: FLEX_POSITIONS.mobile
                    },
                    {
                        label: "Button Style",
                        name: "buttonStyle",
                        component: "select",
                        options: [
                            {
                                label: "Primary",
                                value: "btn-primary"
                            },
                            {
                                label: "Secondary",
                                value: "btn-secondary"
                            },
                            {
                                label: "Inverse Light",
                                value: "btn-inverse-light"
                            },
                            {
                                label: "Inverse Dark",
                                value: "btn-inverse-dark"
                            }, 
                        ]
                    },
                    {
                        label: "Clickable Image",
                        name: "clickableImage",
                        component: "toggle",
                        description: "Makes entire image a clickable link",
                        toggleLabels: {
                            true: "On",
                            false: "Off"
                        }
                    },
                    {
                        label: "Hide Button",
                        name: "hideButton",
                        component: "toggle",
                        toggleLabels: {
                            true: "On",
                            false: "Off"
                        }
                    }, 
                ],
                defaultValue: {
                    darkOverlay: false,
                    contentPosition: "justify-center items-end",
                    buttonStyle: "btn-inverse-light",
                    clickableImage: true,
                    hideButton: false
                }
            },
            {
                label: "Section Settings",
                name: "section",
                component: "group",
                description: "Image aspect ratio, full width",
                fields: [
                    {
                        label: "Image Aspect Ratio",
                        name: "aspectRatio",
                        component: "select",
                        options: [
                            {
                                label: "3:2",
                                value: "aspect-[3/2]"
                            },
                            {
                                label: "4:3",
                                value: "aspect-[4/3]"
                            },
                            {
                                label: "5:4",
                                value: "aspect-[5/4]"
                            },
                            {
                                label: "8:7",
                                value: "aspect-[8/7]"
                            },
                            {
                                label: "1:1",
                                value: "aspect-[1/1]"
                            },
                            {
                                label: "7:8",
                                value: "aspect-[7/8]"
                            },
                            {
                                label: "4:5",
                                value: "aspect-[4/5]"
                            },
                            {
                                label: "3:4",
                                value: "aspect-[3/4]"
                            },
                            {
                                label: "2:3",
                                value: "aspect-[2/3]"
                            }, 
                        ]
                    },
                    {
                        label: "Full Width",
                        name: "fullWidth",
                        component: "toggle",
                        description: "Removes max width of this section",
                        toggleLabels: {
                            true: "On",
                            false: "Off"
                        }
                    }, 
                ],
                defaultValue: {
                    aspectRatio: "aspect-[3/4]",
                    fullWidth: false
                }
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/PackImageTiles/ImageTiles.jsx






function ImageTiles(param) {
    var cms = param.cms;
    var content = cms.content, heading = cms.heading, section = cms.section, tiles = cms.tiles;
    var ref = (0,react.useState)(null), swiper = ref[0], setSwiper = ref[1];
    var maxWidthClass = (section === null || section === void 0 ? void 0 : section.fullWidth) ? "max-w-none" : "max-w-[var(--content-max-width)]";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "lg-px-contained py-4 md:py-6",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mx-auto ".concat(maxWidthClass),
            children: [
                heading && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-title-h2 mb-6 px-4 text-center md:mb-10",
                    children: heading
                }),
                (tiles === null || tiles === void 0 ? void 0 : tiles.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative lg:hidden ".concat(!swiper ? "min-h-[25rem]" : ""),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                    grabCursor: true,
                                    onSwiper: setSwiper,
                                    slidesOffsetAfter: 16,
                                    slidesOffsetBefore: 16,
                                    slidesPerView: 1.4,
                                    spaceBetween: 16,
                                    breakpoints: {
                                        768: {
                                            slidesPerView: tiles.length < 3 ? 1.4 : 2.4,
                                            slidesOffsetBefore: 32,
                                            slidesOffsetAfter: 32,
                                            spaceBetween: 20
                                        }
                                    },
                                    children: swiper && tiles.slice(0, 3).map(function(item, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageTile, {
                                                aspectRatio: section === null || section === void 0 ? void 0 : section.aspectRatio,
                                                content: content,
                                                item: item
                                            })
                                        }, index);
                                    })
                                }),
                                !swiper && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Spinner */.$j, {
                                    width: "32",
                                    className: "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "hidden gap-x-5 lg:grid ".concat(tiles.length < 3 ? "grid-cols-2" : "grid-cols-3"),
                            children: tiles.slice(0, 3).map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageTile, {
                                        aspectRatio: section === null || section === void 0 ? void 0 : section.aspectRatio,
                                        content: content,
                                        item: item
                                    })
                                }, index);
                            })
                        })
                    ]
                })
            ]
        })
    });
}
ImageTiles.displayName = "ImageTiles";
ImageTiles.Schema = ImageTiles_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/PackImageTiles/index.js


;// CONCATENATED MODULE: ./src/sections/PackMarkdown/Markdown.schema.js
function Markdown_schema_Schema() {
    return {
        category: "Text",
        label: "Markdown",
        key: "markdown",
        previewSrc: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/markdown-preview.jpg?v=1675730328",
        fields: [
            {
                label: "Content",
                name: "content",
                component: "markdown",
                defaultValue: "**Lorem ipsum dolor sit amet**, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea _commodo consequat_."
            },
            {
                label: "Center All Text",
                name: "centerAllText",
                component: "toggle",
                toggleLabels: {
                    true: "On",
                    false: "Off"
                },
                defaultValue: false
            },
            {
                label: "Section Settings",
                name: "section",
                component: "group",
                description: "Max content width",
                fields: [
                    {
                        label: "Max Content Width",
                        name: "maxWidth",
                        component: "select",
                        options: [
                            {
                                label: "Narrow",
                                value: "max-w-[30rem]"
                            },
                            {
                                label: "Medium Narrow",
                                value: "max-w-[45rem]"
                            },
                            {
                                label: "Medium",
                                value: "max-w-[60rem]"
                            },
                            {
                                label: "Medium Wide",
                                value: "max-w-[75rem]"
                            },
                            {
                                label: "Wide",
                                value: "max-w-[90rem]"
                            },
                            {
                                label: "Full",
                                value: "max-w-full"
                            }, 
                        ]
                    }, 
                ],
                defaultValue: {
                    maxWidth: "max-w-[60rem]"
                }
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/PackMarkdown/Markdown.jsx



function Markdown(param) {
    var cms = param.cms;
    var centerAllText = cms.centerAllText, content = cms.content, section = cms.section;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "px-contained py-contained",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "mx-auto ".concat(section === null || section === void 0 ? void 0 : section.maxWidth),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Markdown */.UG, {
                centerAllText: centerAllText,
                children: content
            })
        })
    });
}
Markdown.displayName = "Markdown";
Markdown.Schema = Markdown_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/PackMarkdown/index.js


;// CONCATENATED MODULE: ./src/sections/PackPressSlider/PressSliderThumb.jsx


function PressSliderThumb(param) {
    var alt = param.alt, image = param.image, isActive = param.isActive, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative mx-auto flex w-full max-w-[8rem] justify-center pb-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "relative aspect-[3/2] w-full overflow-hidden",
                onClick: onClick,
                type: "button",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute left-0 top-1/2 flex aspect-square w-full -translate-y-1/2 items-center justify-center overflow-hidden",
                    children: (image === null || image === void 0 ? void 0 : image.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                        alt: alt,
                        className: "object-contain transition ".concat(isActive ? "opacity-100" : "opacity-30"),
                        width: "128",
                        height: "128",
                        src: image.src
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute bottom-0 left-0 h-px w-full origin-center bg-current transition ".concat(isActive ? "scale-100" : "scale-0")
            })
        ]
    });
}
PressSliderThumb.displayName = "PressSliderThumb";

;// CONCATENATED MODULE: ./src/sections/PackPressSlider/PressSlider.schema.js

function PressSlider_schema_Schema() {
    return {
        category: "Slider",
        label: "Press Slider",
        key: "press-slider",
        previewSrc: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/press-slider-preview.jpg?v=1675730332",
        fields: [
            {
                label: "Slides",
                name: "slides",
                component: "group-list",
                description: "Max of 6 slides",
                validate: {
                    maxItems: 6
                },
                itemProps: {
                    label: "{{item.quote}}"
                },
                fields: [
                    {
                        label: "Alt",
                        name: "alt",
                        component: "text",
                        description: "Brief description of image"
                    },
                    {
                        label: "Logo",
                        name: "image",
                        component: "image",
                        description: "Image should be: in png or svg format; cropped to fit within a 3:2 viewbox; and no larger than 10kb"
                    },
                    {
                        label: "Quote",
                        name: "quote",
                        component: "textarea"
                    }, 
                ],
                defaultItem: {
                    image: {
                        src: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/forbes_logo_small.png?v=1673633896"
                    },
                    quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt."
                },
                defaultValue: [
                    {
                        image: {
                            src: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/forbes_logo_small.png?v=1673633896"
                        },
                        quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt."
                    },
                    {
                        image: {
                            src: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/vanity_fair_logo_small.png?v=1673633925"
                        },
                        quote: "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris."
                    },
                    {
                        image: {
                            src: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/forbes_logo_small.png?v=1673633896"
                        },
                        quote: "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore."
                    },
                    {
                        image: {
                            src: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/vanity_fair_logo_small.png?v=1673633925"
                        },
                        quote: "Excepteur sint occaecat cupidatat non proident, sunt in culpa."
                    },
                    {
                        image: {
                            src: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/forbes_logo_small.png?v=1673633896"
                        },
                        quote: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem."
                    },
                    {
                        image: {
                            src: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/vanity_fair_logo_small.png?v=1673633925"
                        },
                        quote: "Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit."
                    }, 
                ]
            },
            {
                label: "Section Settings",
                name: "section",
                component: "group",
                description: "Full width, background color, text color",
                fields: [
                    {
                        label: "Full Width",
                        name: "fullWidth",
                        component: "toggle",
                        description: "Removes max width of this section",
                        toggleLabels: {
                            true: "On",
                            false: "Off"
                        }
                    },
                    {
                        label: "Background Color",
                        name: "bgColor",
                        component: "select",
                        options: COLORS
                    },
                    {
                        label: "Text Color",
                        name: "textColor",
                        component: "select",
                        options: COLORS
                    }, 
                ],
                defaultValue: {
                    fullWidth: false,
                    bgColor: "var(--background)",
                    textColor: "var(--text)"
                }
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/PackPressSlider/PressSlider.jsx







function PressSlider(param) {
    var cms = param.cms;
    var section = cms.section, slides = cms.slides;
    var ref = (0,_object_spread/* default */.Z)({}, section), bgColor = ref.bgColor, fullWidth = ref.fullWidth, textColor = ref.textColor;
    var ref1 = (0,react.useState)(null), mainSwiper = ref1[0], setMainSwiper = ref1[1];
    var ref2 = (0,react.useState)(null), thumbsSwiper = ref2[0], setThumbsSwiper = ref2[1];
    var ref3 = (0,react.useState)(0), activeIndex = ref3[0], setActiveIndex = ref3[1];
    var maxWidthContainerClass = fullWidth ? "max-w-none" : "max-w-[var(--content-max-width)]";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "md-px-contained py-contained",
        style: {
            backgroundColor: bgColor,
            color: textColor
        },
        children: (slides === null || slides === void 0 ? void 0 : slides.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mx-auto pt-4 ".concat(maxWidthContainerClass),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                    autoplay: {
                        delay: 8000,
                        disableOnInteraction: false
                    },
                    centeredSlides: true,
                    grabCursor: true,
                    modules: [
                        modules/* Autoplay */.pt,
                        modules/* Thumbs */.o3
                    ],
                    onActiveIndexChange: function(swiper) {
                        if (!thumbsSwiper) return;
                        setActiveIndex(swiper.activeIndex);
                        thumbsSwiper.slideTo(swiper.activeIndex);
                    },
                    onSwiper: setMainSwiper,
                    slidesPerView: 1,
                    thumbs: {
                        swiper: thumbsSwiper
                    },
                    children: slides.map(function(param, index) {
                        var quote = param.quote;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            className: "w-full py-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                className: "mx-auto max-w-[50rem] px-4 text-center text-3xl font-bold md:text-4xl",
                                children: [
                                    '"',
                                    quote,
                                    '"'
                                ]
                            })
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "mx-auto mt-8 hidden gap-8 md:grid",
                    style: {
                        gridTemplateColumns: "repeat(".concat(slides.length, ", 1fr)"),
                        width: "calc(1/6*100%*".concat(slides.length, ")")
                    },
                    children: slides.map(function(param, index) {
                        var alt = param.alt, image = param.image;
                        var isActive = index === activeIndex;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "flex justify-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PressSliderThumb, {
                                alt: alt,
                                image: image,
                                isActive: isActive,
                                onClick: function() {
                                    if (!mainSwiper) return;
                                    mainSwiper.slideTo(index);
                                }
                            })
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-4 md:hidden",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                        centeredSlides: true,
                        className: "max-md:cursor-grab",
                        modules: [
                            modules/* Thumbs */.o3
                        ],
                        onSwiper: setThumbsSwiper,
                        slidesPerView: 2.25,
                        onActiveIndexChange: function(swiper) {
                            if (!mainSwiper) return;
                            mainSwiper.slideTo(swiper.activeIndex);
                        },
                        children: slides.map(function(param, index) {
                            var alt = param.alt, image = param.image;
                            var isActive = index === activeIndex;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                className: "flex justify-center px-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PressSliderThumb, {
                                    alt: alt,
                                    image: image,
                                    isActive: isActive,
                                    onClick: function() {
                                        if (!mainSwiper) return;
                                        mainSwiper.slideTo(index);
                                    }
                                })
                            }, index);
                        })
                    })
                })
            ]
        })
    });
}
PressSlider.displayName = "PressSlider";
PressSlider.Schema = PressSlider_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/PackPressSlider/index.js


;// CONCATENATED MODULE: ./src/sections/PackProductsSlider/ProductsSlider.schema.js
function ProductsSlider_schema_Schema() {
    return {
        category: "Slider",
        label: "Products Slider",
        key: "products-slider",
        previewSrc: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/products-slider-preview.jpg?v=1675730335",
        fields: [
            {
                label: "Heading",
                name: "heading",
                component: "text",
                defaultValue: "Products Slider Heading"
            },
            {
                label: "Products",
                name: "products",
                component: "group-list",
                itemProps: {
                    label: "{{item.product.handle}}"
                },
                fields: [
                    {
                        name: "product",
                        component: "productSearch",
                        label: "Product"
                    }, 
                ],
                defaultValue: [
                    {
                        handle: ""
                    },
                    {
                        handle: ""
                    },
                    {
                        handle: ""
                    },
                    {
                        handle: ""
                    }, 
                ]
            },
            {
                label: "Footer Button",
                name: "button",
                component: "link"
            },
            {
                label: "Product Item Settings",
                name: "productItem",
                component: "group",
                description: "Star rating, color variant selector, quick shop",
                fields: [
                    {
                        label: "Enable Star Rating",
                        name: "enabledStarRating",
                        component: "toggle",
                        toggleLabels: {
                            true: "On",
                            false: "Off"
                        }
                    },
                    {
                        label: "Enable Color Variant Selector",
                        name: "enabledColorSelector",
                        component: "toggle",
                        toggleLabels: {
                            true: "On",
                            false: "Off"
                        }
                    },
                    {
                        label: "Enable Quick Shop",
                        name: "enabledQuickShop",
                        component: "toggle",
                        description: 'Quick shop is hidden on mobile and will only show if the product item has only one variant or multiple variants through a single option, e.g. "Size',
                        toggleLabels: {
                            true: "On",
                            false: "Off"
                        }
                    }, 
                ],
                defaultValue: {
                    enabledStarRating: false,
                    enabledColorSelector: false,
                    enabledColorNameOnHover: false,
                    enabledQuickShop: false
                }
            },
            {
                label: "Slider Settings",
                name: "slider",
                component: "group",
                description: "Slider style, slides per view",
                fields: [
                    {
                        label: "Slider Style",
                        name: "sliderStyle",
                        component: "select",
                        description: "Loop and centered settings only apply if the number of products is at least twice the number of slides per view",
                        options: [
                            {
                                label: "Contained",
                                value: "contained"
                            },
                            {
                                label: "Contained w/ Loop",
                                value: "containedWithLoop"
                            },
                            {
                                label: "Full Bleed, Centered w/ Loop",
                                value: "fullBleed"
                            },
                            {
                                label: "Full Bleed, Centered w/ Loop & Gradient",
                                value: "fullBleedWithGradient"
                            }, 
                        ]
                    },
                    {
                        label: "Slides Per View (desktop)",
                        name: "slidesPerViewDesktop",
                        component: "number"
                    },
                    {
                        label: "Slides Per View (tablet)",
                        name: "slidesPerViewTablet",
                        component: "number"
                    },
                    {
                        label: "Slides Per View (mobile)",
                        name: "slidesPerViewMobile",
                        component: "number"
                    }, 
                ],
                defaultValue: {
                    sliderStyle: "contained",
                    slidesPerViewDesktop: 4,
                    slidesPerViewTablet: 3.4,
                    slidesPerViewMobile: 1.4
                }
            },
            {
                label: "Section Settings",
                name: "section",
                component: "group",
                description: "Button style, full width",
                fields: [
                    {
                        label: "Button Style",
                        name: "buttonStyle",
                        component: "select",
                        options: [
                            {
                                label: "Primary",
                                value: "btn-primary"
                            },
                            {
                                label: "Secondary",
                                value: "btn-secondary"
                            },
                            {
                                label: "Inverse Light",
                                value: "btn-inverse-light"
                            },
                            {
                                label: "Inverse Dark",
                                value: "btn-inverse-dark"
                            }, 
                        ]
                    },
                    {
                        label: "Full Width",
                        name: "fullWidth",
                        component: "toggle",
                        description: "Removes max width from contained styles",
                        toggleLabels: {
                            true: "On",
                            false: "Off"
                        }
                    }, 
                ],
                defaultValue: {
                    buttonStyle: "btn-primary",
                    fullWidth: false
                }
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/PackProductsSlider/ProductsSlider.jsx








function ProductsSlider(param) {
    var cms = param.cms;
    var button = cms.button, heading = cms.heading, productItem = cms.productItem, products = cms.products, section = cms.section, slider = cms.slider, textColor = cms.textColor;
    var swatchesMap = (0,hooks/* useColorSwatches */.Bb)().swatchesMap;
    var ref = (0,react.useState)(null), swiper = ref[0], setSwiper = ref[1];
    var sliderStyle = (0,_object_spread/* default */.Z)({}, slider).sliderStyle;
    var slidesPerViewDesktop = (slider === null || slider === void 0 ? void 0 : slider.slidesPerViewDesktop) || 4;
    var slidesPerViewTablet = (slider === null || slider === void 0 ? void 0 : slider.slidesPerViewTablet) || 3.4;
    var slidesPerViewMobile = (slider === null || slider === void 0 ? void 0 : slider.slidesPerViewMobile) || 1.4;
    var isFullBleedAndCentered = sliderStyle === "fullBleed" || sliderStyle === "fullBleedWithGradient";
    var isLoop = isFullBleedAndCentered || sliderStyle === "containedWithLoop";
    var maxWidthClass = (section === null || section === void 0 ? void 0 : section.fullWidth) || isFullBleedAndCentered ? "max-w-none" : "max-w-[var(--content-max-width)]";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "py-contained ".concat(!isFullBleedAndCentered ? "lg-px-contained" : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "m-auto flex flex-col items-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-title-h2 px-4 text-center",
                    style: {
                        color: textColor
                    },
                    children: heading
                }),
                products && /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                    centeredSlides: isFullBleedAndCentered && products.length >= slidesPerViewMobile * 2,
                    className: "relative mt-10 w-full ".concat(maxWidthClass, " ").concat(sliderStyle === "fullBleedWithGradient" ? "before:swiper-offset-gradient-270-left after:swiper-offset-gradient-270-right" : ""),
                    grabCursor: true,
                    loop: isLoop && products.length >= slidesPerViewMobile * 2,
                    modules: [
                        modules/* Navigation */.W_
                    ],
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                        disabledClass: "cursor-not-allowed opacity-20"
                    },
                    onSwiper: setSwiper,
                    slidesOffsetAfter: isFullBleedAndCentered ? 0 : 16,
                    slidesOffsetBefore: isFullBleedAndCentered ? 0 : 16,
                    slidesPerView: slidesPerViewMobile,
                    spaceBetween: 16,
                    breakpoints: {
                        768: {
                            centeredSlides: isFullBleedAndCentered && products.length >= slidesPerViewTablet * 2,
                            loop: isLoop && products.length >= slidesPerViewTablet * 2,
                            slidesPerView: slidesPerViewTablet,
                            spaceBetween: 20,
                            slidesOffsetBefore: isFullBleedAndCentered ? 0 : 32,
                            slidesOffsetAfter: isFullBleedAndCentered ? 0 : 32
                        },
                        1024: {
                            centeredSlides: isFullBleedAndCentered && products.length >= slidesPerViewDesktop * 2,
                            loop: isLoop && products.length >= slidesPerViewDesktop * 2,
                            slidesPerView: slidesPerViewDesktop,
                            spaceBetween: 20,
                            slidesOffsetBefore: 0,
                            slidesOffsetAfter: 0
                        }
                    },
                    children: [
                        swiper && products.map(function(param, index) {
                            var product = param.product;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* ProductItem */.Cd, {
                                    enabledColorNameOnHover: productItem === null || productItem === void 0 ? void 0 : productItem.enabledColorNameOnHover,
                                    enabledColorSelector: productItem === null || productItem === void 0 ? void 0 : productItem.enabledColorSelector,
                                    enabledQuickShop: productItem === null || productItem === void 0 ? void 0 : productItem.enabledQuickShop,
                                    enabledStarRating: productItem === null || productItem === void 0 ? void 0 : productItem.enabledStarRating,
                                    handle: product === null || product === void 0 ? void 0 : product.handle,
                                    index: index,
                                    swatchesMap: swatchesMap
                                })
                            }, index);
                        }),
                        products.length > slidesPerViewDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "z-1 absolute top-[calc(50%-28px)] left-0 right-0 md:px-8 xl:px-14",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative mx-auto ".concat(maxWidthClass, " ").concat(isFullBleedAndCentered ? "min-[90rem]:max-w-full" : ""),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "swiper-button-prev top-[calc(50%-1.6875rem)] left-0 !hidden !h-[3.5rem] !w-[3.5rem] rounded-full border border-border bg-white after:hidden lg:!flex ".concat(!isFullBleedAndCentered ? "xl:-left-[1.6875rem]" : ""),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                                            className: "w-[1.25rem] text-black",
                                            src: "/svgs/arrow-left.svg#arrow-left",
                                            title: "Arrow Left",
                                            viewBox: "0 0 24 24"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "swiper-button-next top-[calc(50%-1.6875rem)] right-0 !hidden !h-[3.5rem] !w-[3.5rem] rounded-full border border-border bg-white after:hidden lg:!flex ".concat(!isFullBleedAndCentered ? "xl:-right-[1.6875rem]" : ""),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                                            className: "w-[1.25rem] text-black",
                                            src: "/svgs/arrow-right.svg#arrow-right",
                                            title: "Arrow Right",
                                            viewBox: "0 0 24 24"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                !swiper && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative min-h-[20rem]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Spinner */.$j, {
                        width: "32",
                        className: "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                    })
                }),
                (button === null || button === void 0 ? void 0 : button.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-10",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                        "aria-label": button.text,
                        className: "".concat((section === null || section === void 0 ? void 0 : section.buttonStyle) || "btn-primary"),
                        href: button.url,
                        newTab: button.newTab,
                        children: button.text
                    })
                })
            ]
        })
    });
}
ProductsSlider.displayName = "ProductsSlider";
ProductsSlider.Schema = ProductsSlider_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/PackProductsSlider/index.js


;// CONCATENATED MODULE: ./src/sections/PackSocialImagesGrid/SocialImagesGrid.schema.js
function SocialImagesGrid_schema_Schema() {
    return {
        category: "Image",
        label: "Social Images Grid",
        key: "social-images-grid",
        previewSrc: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/social-feed-preview.jpg?v=1675730338",
        fields: [
            {
                label: "Images",
                name: "images",
                description: "Grid requires four images",
                component: "group-list",
                itemProps: {
                    label: "{{item.alt}}"
                },
                validate: {
                    maxItems: 4
                },
                fields: [
                    {
                        label: "Image Alt",
                        name: "alt",
                        component: "text",
                        description: "Brief description of image"
                    },
                    {
                        label: "Image",
                        name: "image",
                        component: "image"
                    },
                    {
                        label: "Platform",
                        name: "platform",
                        component: "select",
                        options: [
                            {
                                label: "Facebook",
                                value: "facebook"
                            },
                            {
                                label: "Instagram",
                                value: "instagram"
                            },
                            {
                                label: "Pinterest",
                                value: "pinterest"
                            },
                            {
                                label: "TikTok",
                                value: "tiktok"
                            },
                            {
                                label: "Vimeo",
                                value: "vimeo"
                            },
                            {
                                label: "YouTube",
                                value: "youtube"
                            }, 
                        ]
                    },
                    {
                        label: "Social Post URL",
                        name: "url",
                        component: "text"
                    }, 
                ],
                defaultItem: {
                    alt: "Man in white short sleeve shirt",
                    image: {
                        src: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/kenzie-kraft-9QW52RyBLao-unsplash.jpg?v=1672348135"
                    },
                    platform: "instagram",
                    url: "https://www.instagram.com"
                },
                defaultValue: [
                    {
                        alt: "Man in white short sleeve shirt",
                        image: {
                            src: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/kenzie-kraft-9QW52RyBLao-unsplash.jpg?v=1672348135"
                        },
                        platform: "instagram",
                        url: "https://www.instagram.com"
                    },
                    {
                        alt: "Menswear everyday carry",
                        image: {
                            src: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/nordwood-themes-Nv4QHkTVEaI-unsplash-2.jpg?v=1672787938"
                        },
                        platform: "instagram",
                        url: "https://www.instagram.com"
                    },
                    {
                        alt: "Man in white t-shirt leaning against wall",
                        image: {
                            src: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/mad-rabbit-tattoo-X0Ob-bhTdz8-unsplash.jpg?v=1672787932"
                        },
                        platform: "instagram",
                        url: "https://www.instagram.com"
                    },
                    {
                        alt: "Rack of neutral tone shirts",
                        image: {
                            src: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/fernando-lavin-fi5YSQfxbVk-unsplash.jpg?v=1672787923"
                        },
                        platform: "instagram",
                        url: "https://www.instagram.com"
                    }, 
                ]
            },
            {
                label: "Section Settings",
                name: "section",
                component: "group",
                description: "Full width, full bleed",
                fields: [
                    {
                        label: "Full Width",
                        name: "fullWidth",
                        component: "toggle",
                        description: "Removes max width of this section",
                        toggleLabels: {
                            true: "On",
                            false: "Off"
                        }
                    },
                    {
                        label: "Full Bleed",
                        name: "fullBleed",
                        component: "toggle",
                        description: "Removes padding of this section",
                        toggleLabels: {
                            true: "On",
                            false: "Off"
                        }
                    }, 
                ],
                defaultValue: {
                    fullWidth: false,
                    fullBleed: true
                }
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/PackSocialImagesGrid/SocialImagesGrid.jsx



function SocialImagesGrid(param) {
    var cms = param.cms;
    var images = cms.images, section = cms.section;
    var maxWidthClass = (section === null || section === void 0 ? void 0 : section.fullWidth) ? "max-w-none" : "max-w-[var(--content-max-width)]";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "py-px ".concat((section === null || section === void 0 ? void 0 : section.fullBleed) ? "" : "px-contained"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            className: "mx-auto grid grid-cols-2 gap-px sm:grid-cols-4 ".concat(maxWidthClass),
            children: images === null || images === void 0 ? void 0 : images.slice(0, 4).map(function(item, index) {
                var ref;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                        "aria-label": "Open new tab to view ".concat(item.platform, " post"),
                        href: item.url,
                        newTab: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative aspect-square bg-offWhite",
                            children: [
                                ((ref = item.image) === null || ref === void 0 ? void 0 : ref.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                    alt: item.alt,
                                    fill: true,
                                    sizes: "(min-width: 768px) 25vw, 50vw",
                                    src: item.image.src
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                                    className: "absolute top-2 right-2 w-4 text-white lg:top-3 lg:right-3 lg:w-5",
                                    src: "/svgs/noprecache/social/".concat(item.platform, ".svg#").concat(item.platform),
                                    title: item.platform,
                                    viewBox: "0 0 24 24"
                                })
                            ]
                        })
                    })
                }, index);
            })
        })
    });
}
SocialImagesGrid.displayName = "SocialImagesGrid";
SocialImagesGrid.Schema = SocialImagesGrid_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/PackSocialImagesGrid/index.js


;// CONCATENATED MODULE: ./src/sections/PackTabbedThreeTiles/TabbedThreeTiles.schema.js

var defaultTab = {
    tabName: "Tab Name",
    tiles: [
        {
            alt: "Man in white and light tan outfit",
            image: {
                src: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/man-in-white-and-light-tan-outfit.jpg?v=1672348139"
            },
            position: "object-center",
            heading: "Headline",
            description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry."
        },
        {
            alt: "Man in brown coat sitting down",
            image: {
                src: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/austin-wade-d2s8NQ6WD24-unsplash.jpg?v=1672348122"
            },
            position: "object-center",
            heading: "Headline",
            description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry."
        },
        {
            alt: "Man in gray sweater and tan coat",
            image: {
                src: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/man-poses-in-light-colored-overcoat.jpg?v=1672348143"
            },
            position: "object-center",
            heading: "Headline",
            description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry."
        }, 
    ]
};
function TabbedThreeTiles_schema_Schema() {
    return {
        category: "Image",
        label: "Tabbed Three Tiles",
        key: "tabbed-three-tiles",
        previewSrc: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/tabbed-three-tiles-preview.jpg?v=1675730342",
        fields: [
            {
                label: "Heading",
                name: "heading",
                component: "text",
                defaultValue: "Tabbed Three Tile Heading"
            },
            {
                label: "Tabs",
                name: "tabs",
                component: "group-list",
                itemProps: {
                    label: "{{item.tabName}}"
                },
                fields: [
                    {
                        label: "Tab Name",
                        name: "tabName",
                        component: "text"
                    },
                    {
                        label: "Tiles",
                        name: "tiles",
                        description: "Max of 3 tiles",
                        component: "group-list",
                        itemProps: {
                            label: "{{item.heading}}"
                        },
                        validate: {
                            maxItems: 3
                        },
                        fields: [
                            {
                                label: "Image Alt",
                                name: "alt",
                                component: "text",
                                description: "Brief description of image"
                            },
                            {
                                label: "Image",
                                name: "image",
                                component: "image"
                            },
                            {
                                label: "Image Position",
                                name: "position",
                                component: "select",
                                options: OBJECT_POSITIONS.mobile
                            },
                            {
                                label: "Heading",
                                name: "heading",
                                component: "text"
                            },
                            {
                                label: "Description",
                                name: "description",
                                component: "textarea"
                            },
                            {
                                label: "Link",
                                name: "link",
                                component: "link"
                            }, 
                        ],
                        defaultItem: {
                            alt: "Man in white and light tan outfit",
                            image: {
                                src: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/man-in-white-and-light-tan-outfit.jpg?v=1672348139"
                            },
                            position: "object-center",
                            heading: "Headline",
                            description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
                            link: {
                                text: "",
                                url: ""
                            }
                        }
                    }, 
                ],
                defaultValue: [
                    defaultTab
                ],
                defaultItem: defaultTab
            },
            {
                label: "Footer Button",
                name: "button",
                component: "link"
            },
            {
                label: "Section Settings",
                name: "section",
                component: "group",
                description: "Image aspect ratio, background color, text color, full width",
                fields: [
                    {
                        label: "Image Aspect Ratio",
                        name: "aspectRatio",
                        component: "select",
                        options: [
                            {
                                label: "3:2",
                                value: "aspect-[3/2]"
                            },
                            {
                                label: "4:3",
                                value: "aspect-[4/3]"
                            },
                            {
                                label: "5:4",
                                value: "aspect-[5/4]"
                            },
                            {
                                label: "8:7",
                                value: "aspect-[8/7]"
                            },
                            {
                                label: "1:1",
                                value: "aspect-[1/1]"
                            },
                            {
                                label: "7:8",
                                value: "aspect-[7/8]"
                            },
                            {
                                label: "4:5",
                                value: "aspect-[4/5]"
                            },
                            {
                                label: "3:4",
                                value: "aspect-[3/4]"
                            },
                            {
                                label: "2:3",
                                value: "aspect-[2/3]"
                            }, 
                        ]
                    },
                    {
                        label: "Background Color",
                        name: "bgColor",
                        component: "select",
                        options: COLORS
                    },
                    {
                        label: "Text Color",
                        name: "textColor",
                        component: "select",
                        options: COLORS
                    },
                    {
                        label: "Button Style",
                        name: "buttonStyle",
                        component: "select",
                        options: [
                            {
                                label: "Primary",
                                value: "btn-primary"
                            },
                            {
                                label: "Secondary",
                                value: "btn-secondary"
                            },
                            {
                                label: "Inverse Light",
                                value: "btn-inverse-light"
                            },
                            {
                                label: "Inverse Dark",
                                value: "btn-inverse-dark"
                            }, 
                        ]
                    },
                    {
                        label: "Full Width",
                        name: "fullWidth",
                        component: "toggle",
                        description: "Removes max width of this section",
                        toggleLabels: {
                            true: "On",
                            false: "Off"
                        }
                    }, 
                ],
                defaultValue: {
                    aspectRatio: "aspect-[3/4]",
                    bgColor: "var(--background)",
                    textColor: "var(--text)",
                    buttonStyle: "btn-primary",
                    fullWidth: false
                }
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/PackTabbedThreeTiles/TabbedThreeTilesTabs.jsx

function TabbedThreeTilesTabs(param) {
    var activeTabIndex = param.activeTabIndex, maxWidthClass = param.maxWidthClass, setActiveTabIndex = param.setActiveTabIndex, tabs = param.tabs, textColor = param.textColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mx-auto px-4 ".concat(maxWidthClass, " scrollbar-hide mb-6 overflow-x-auto border-b border-border md:mb-10"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            className: "flex justify-center gap-4 xs:gap-8",
            children: tabs === null || tabs === void 0 ? void 0 : tabs.map(function(tab, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        "aria-label": tab.tabName,
                        className: "before:z-1 text-nav relative flex h-full flex-col whitespace-nowrap pb-3 before:absolute before:bottom-0 before:w-full before:origin-center before:border-b-2 before:border-current before:transition max-xs:pb-2 max-xs:text-xs ".concat(activeTabIndex === index ? "before:scale-100" : "before:scale-0"),
                        onClick: function() {
                            return setActiveTabIndex(index);
                        },
                        style: {
                            color: textColor
                        },
                        type: "button",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: tab.tabName
                        })
                    })
                }, index);
            })
        })
    });
}
TabbedThreeTilesTabs.displayName = "TabbedThreeTilesTabs";

;// CONCATENATED MODULE: ./src/sections/PackTabbedThreeTiles/TabbedThreeTiles.jsx






function TabbedThreeTiles(param) {
    var cms = param.cms;
    var ref = (0,react.useState)(0), activeTabIndex = ref[0], setActiveTabIndex = ref[1];
    var button = cms.button, heading = cms.heading, section = cms.section, tabs = cms.tabs;
    var ref1 = (0,_object_spread/* default */.Z)({}, section), aspectRatio = ref1.aspectRatio, bgColor = ref1.bgColor, fullWidth = ref1.fullWidth, textColor = ref1.textColor;
    var maxWidthClass = fullWidth ? "max-w-none" : "max-w-[var(--content-max-width)]";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "lg-px-contained py-contained",
        style: {
            backgroundColor: bgColor
        },
        children: [
            heading && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "text-title-h2 mb-6 px-4 text-center md:mb-10",
                style: {
                    color: textColor
                },
                children: heading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mx-auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabbedThreeTilesTabs, {
                        activeTabIndex: activeTabIndex,
                        maxWidthClass: maxWidthClass,
                        setActiveTabIndex: setActiveTabIndex,
                        tabs: tabs,
                        textColor: textColor
                    }),
                    (tabs === null || tabs === void 0 ? void 0 : tabs.length) > 0 && tabs.map(function(param, index) {
                        var tiles = param.tiles;
                        if (index !== activeTabIndex) return null;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* ThreeTilesRow */.sE, {
                                aspectRatio: aspectRatio,
                                maxWidthClass: maxWidthClass,
                                textColor: textColor,
                                tiles: tiles
                            })
                        }, index);
                    })
                ]
            }),
            (button === null || button === void 0 ? void 0 : button.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-10 flex flex-col items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                    "aria-label": button.text,
                    className: "".concat((section === null || section === void 0 ? void 0 : section.buttonStyle) || "btn-primary"),
                    href: button.url,
                    newTab: button.newTab,
                    children: button.text
                })
            })
        ]
    });
}
TabbedThreeTiles.displayName = "TabbedThreeTiles";
TabbedThreeTiles.Schema = TabbedThreeTiles_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/PackTabbedThreeTiles/index.js


;// CONCATENATED MODULE: ./src/sections/PackTestimonialSlider/TestimonialSlider.schema.js

function TestimonialSlider_schema_Schema() {
    return {
        category: "Slider",
        label: "Testimonial Slider",
        key: "testimonial-slider",
        previewSrc: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/testimonial-slider-preview.jpg?v=1675730345",
        fields: [
            {
                label: "Heading",
                name: "heading",
                component: "text",
                defaultValue: "Testimonial Slider Heading"
            },
            {
                label: "Testimonial Slides",
                name: "testimonialSlides",
                component: "group-list",
                itemProps: {
                    label: "{{item.title}}"
                },
                fields: [
                    {
                        label: "Title",
                        name: "title",
                        component: "text"
                    },
                    {
                        label: "Body",
                        name: "body",
                        component: "textarea"
                    },
                    {
                        label: "Author",
                        name: "author",
                        component: "text"
                    },
                    {
                        label: "Rating",
                        name: "rating",
                        component: "select",
                        options: [
                            {
                                label: "1",
                                value: "1"
                            },
                            {
                                label: "1.5",
                                value: "1.5"
                            },
                            {
                                label: "2",
                                value: "2"
                            },
                            {
                                label: "2.5",
                                value: "2.5"
                            },
                            {
                                label: "3",
                                value: "3"
                            },
                            {
                                label: "3.5",
                                value: "3.5"
                            },
                            {
                                label: "4",
                                value: "4"
                            },
                            {
                                label: "4.5",
                                value: "4.5"
                            },
                            {
                                label: "5",
                                value: "5"
                            }, 
                        ],
                        defaultValue: "5"
                    }, 
                ],
                defaultItem: {
                    title: "Fermentum fusce",
                    body: "Praesent commodo cursus magna, vel scelerisque nisl consectetur et.",
                    author: "– John Doe",
                    rating: "5"
                },
                defaultValue: [
                    {
                        title: "Fermentum fusce",
                        body: "Praesent commodo cursus magna, vel scelerisque nisl consectetur et.",
                        author: "– John Doe",
                        rating: "5"
                    },
                    {
                        title: "Lorem ipsum dolor",
                        body: "Praesent commodo cursus magna, vel scelerisque nisl consectetur et.",
                        author: "– John Doe",
                        rating: "5"
                    },
                    {
                        title: "Sed ut perspiciatis",
                        body: "Praesent commodo cursus magna, vel scelerisque nisl consectetur et.",
                        author: "– John Doe",
                        rating: "5"
                    }, 
                ]
            },
            {
                label: "Link",
                name: "link",
                component: "link"
            },
            {
                label: "Section Settings",
                name: "section",
                component: "group",
                description: "Full width, background color, text color, bullet color, star color",
                fields: [
                    {
                        label: "Full Width",
                        name: "fullWidth",
                        component: "toggle",
                        description: "Removes max width of this section",
                        toggleLabels: {
                            true: "On",
                            false: "Off"
                        },
                        defaultValue: false
                    },
                    {
                        label: "Background Color",
                        name: "bgColor",
                        component: "select",
                        options: COLORS
                    },
                    {
                        label: "Text Color",
                        name: "textColor",
                        component: "select",
                        options: COLORS
                    },
                    {
                        label: "Slider Pagination Bullet Color",
                        name: "sliderPaginationBulletColor",
                        component: "select",
                        options: COLORS
                    },
                    {
                        label: "Review Star Color",
                        name: "reviewStarColor",
                        component: "select",
                        options: COLORS
                    }, 
                ],
                defaultValue: {
                    fullWidth: false,
                    bgColor: "var(--black)",
                    textColor: "var(--white)",
                    sliderPaginationBulletColor: "var(--white)",
                    reviewStarColor: "var(--accent1)"
                }
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/PackTestimonialSlider/TestimonialSlider.jsx






function TestimonialSlider(param) {
    var cms = param.cms;
    var ref = (0,_object_spread/* default */.Z)({}, cms), heading = ref.heading, link = ref.link, section = ref.section, blocks = ref.testimonialSlides;
    var ref1 = (0,_object_spread/* default */.Z)({}, section), bgColor = ref1.bgColor, fullWidth = ref1.fullWidth, reviewStarColor = ref1.reviewStarColor, textColor = ref1.textColor;
    var maxWidthClass = fullWidth ? "max-w-none" : "max-w-[var(--content-max-width)]";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "md-px-contained py-12 lg:py-16",
        style: {
            backgroundColor: bgColor
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat(maxWidthClass, " relative mx-auto flex flex-col items-center lg:px-14"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-title-h2 px-4 text-center",
                    style: {
                        color: textColor
                    },
                    children: heading
                }),
                (blocks === null || blocks === void 0 ? void 0 : blocks.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                    className: "!static mt-10 w-full",
                    grabCursor: true,
                    loop: blocks.length > 1,
                    pagination: {
                        el: ".swiper-pagination",
                        type: "bullets",
                        clickable: true,
                        renderBullet: function renderBullet(_, className) {
                            return '<span class="!bg-offWhite '.concat(className, '"></span>');
                        }
                    },
                    modules: [
                        modules/* Pagination */.tl,
                        modules/* Navigation */.W_
                    ],
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                        disabledClass: "cursor-not-allowed opacity-20"
                    },
                    slidesPerView: 1,
                    spaceBetween: 16,
                    breakpoints: {
                        1024: {
                            loop: blocks.length >= 6,
                            slidesPerView: 3,
                            spaceBetween: 0
                        }
                    },
                    children: [
                        blocks.map(function(item, index) {
                            var rating = (item === null || item === void 0 ? void 0 : item.rating) ? parseFloat(item.rating) : 5;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mx-auto flex max-w-[18.75rem] flex-col items-center text-center lg:max-w-[15.625rem]",
                                    style: {
                                        color: textColor
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* ReviewStars */.Hm, {
                                            rating: rating,
                                            color: reviewStarColor
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "my-4 text-2xl",
                                            children: item.title
                                        }),
                                        item.body && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: item.body
                                        }),
                                        item.author && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "mt-4 text-base font-normal",
                                            children: item.author
                                        })
                                    ]
                                })
                            }, index);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "swiper-pagination !static mt-6 md:!hidden"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "swiper-button-prev left-0 !hidden !h-[3.5rem] !w-[3.5rem] rounded-full bg-white after:hidden ".concat(blocks.length > 1 ? "md:!flex" : "md:!hidden", " ").concat(blocks.length > 3 ? "lg:!flex" : "lg:!hidden"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                                className: "w-[1.25rem] text-black",
                                src: "/svgs/arrow-left.svg#arrow-left",
                                title: "Arrow Left",
                                viewBox: "0 0 24 24"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "swiper-button-next right-0 !hidden !h-[3.5rem] !w-[3.5rem] rounded-full bg-white after:hidden ".concat(blocks.length > 1 ? "md:!flex" : "md:!hidden", " ").concat(blocks.length > 3 ? "lg:!flex" : "lg:!hidden"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                                className: "w-[1.25rem] text-black",
                                src: "/svgs/arrow-right.svg#arrow-right",
                                title: "Arrow Right",
                                viewBox: "0 0 24 24"
                            })
                        })
                    ]
                }),
                (link === null || link === void 0 ? void 0 : link.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-10",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                        "aria-label": link.text,
                        className: "btn-primary",
                        href: link.url,
                        newTab: link.newTab,
                        children: link.text
                    })
                })
            ]
        })
    });
}
TestimonialSlider.displayName = "TestimonialSlider";
TestimonialSlider.Schema = TestimonialSlider_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/PackTestimonialSlider/index.js


;// CONCATENATED MODULE: ./src/sections/PackTextBlock/TextBlock.schema.js

function TextBlock_schema_Schema() {
    return {
        category: "Text",
        label: "Text Block",
        key: "text-block",
        previewSrc: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/text-block-preview.jpg?v=1675730349",
        fields: [
            {
                label: "Heading",
                name: "heading",
                component: "text",
                defaultValue: "Text Block Heading"
            },
            {
                label: "Subtext",
                name: "subtext",
                component: "markdown",
                defaultValue: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
            },
            {
                label: "Buttons",
                name: "buttons",
                component: "group-list",
                description: "Max of two buttons",
                itemProps: {
                    label: "{{item.link.text}}"
                },
                validate: {
                    maxItems: 2
                },
                fields: [
                    {
                        label: "Link",
                        name: "link",
                        component: "link"
                    },
                    {
                        label: "Button Style",
                        name: "style",
                        component: "select",
                        options: [
                            {
                                label: "Primary",
                                value: "btn-primary"
                            },
                            {
                                label: "Secondary",
                                value: "btn-secondary"
                            },
                            {
                                label: "Inverse Light",
                                value: "btn-inverse-light"
                            },
                            {
                                label: "Inverse Dark",
                                value: "btn-inverse-dark"
                            }, 
                        ]
                    }, 
                ],
                defaultItem: {
                    link: {
                        text: "Shop Now",
                        url: ""
                    },
                    style: "btn-primary"
                },
                defaultValue: [
                    {
                        link: {
                            text: "Shop Now",
                            url: ""
                        },
                        style: "btn-primary"
                    }, 
                ]
            },
            {
                label: "Section Settings",
                name: "section",
                component: "group",
                description: "Above the fold, background color, text color, icon color, full width",
                fields: [
                    {
                        label: "Above The Fold",
                        name: "aboveTheFold",
                        component: "toggle",
                        description: "Sets the heading as H1",
                        toggleLabels: {
                            true: "On",
                            false: "Off"
                        }
                    },
                    {
                        label: "Background Color",
                        name: "bgColor",
                        component: "select",
                        options: COLORS
                    },
                    {
                        label: "Text Color",
                        name: "textColor",
                        component: "select",
                        options: COLORS
                    },
                    {
                        label: "Full Width",
                        name: "fullWidth",
                        component: "toggle",
                        description: "Removes max width of this section",
                        toggleLabels: {
                            true: "On",
                            false: "Off"
                        }
                    }, 
                ],
                defaultValue: {
                    aboveTheFold: false,
                    bgColor: "var(--background)",
                    textColor: "var(--text)",
                    fullWidth: false
                }
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/PackTextBlock/TextBlock.jsx



function TextBlock(param) {
    var cms = param.cms;
    var buttons = cms.buttons, heading = cms.heading, section = cms.section, subtext = cms.subtext;
    var maxWidthClass = (section === null || section === void 0 ? void 0 : section.fullWidth) ? "max-w-none" : "max-w-[var(--content-max-width)]";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "px-contained py-contained",
        style: {
            backgroundColor: section === null || section === void 0 ? void 0 : section.bgColor,
            color: section === null || section === void 0 ? void 0 : section.textColor
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mx-auto flex flex-col items-center gap-4 md:gap-6 ".concat(maxWidthClass, " text-center"),
            children: [
                heading && ((section === null || section === void 0 ? void 0 : section.aboveTheFold) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: "text-title-h2 mx-auto max-w-[46rem]",
                    children: heading
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-title-h2 mx-auto max-w-[46rem]",
                    children: heading
                })),
                subtext && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-auto max-w-[46rem] [&_p]:text-base [&_h2]:text-base [&_h1]:text-base [&_h3]:text-base [&_h4]:text-base [&_h5]:text-base [&_h6]:text-base [&_a]:underline",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Markdown */.UG, {
                        children: subtext
                    })
                }),
                (buttons === null || buttons === void 0 ? void 0 : buttons.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "mt-4 flex flex-col justify-center gap-4 xs:flex-row",
                    children: buttons.slice(0, 2).map(function(param, index) {
                        var link = param.link, style = param.style;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                                "aria-label": link === null || link === void 0 ? void 0 : link.text,
                                className: style,
                                href: link === null || link === void 0 ? void 0 : link.url,
                                newTab: link === null || link === void 0 ? void 0 : link.newTab,
                                children: link === null || link === void 0 ? void 0 : link.text
                            })
                        }, index);
                    })
                })
            ]
        })
    });
}
TextBlock.displayName = "TextBlock";
TextBlock.Schema = TextBlock_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/PackTextBlock/index.js


;// CONCATENATED MODULE: ./src/sections/PackThreeTiles/ThreeTiles.schema.js

function ThreeTiles_schema_Schema() {
    return {
        category: "Image",
        label: "Three Tiles",
        key: "three-tiles",
        previewSrc: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/three-tiles-preview.jpg?v=1675730352",
        fields: [
            {
                label: "Heading",
                name: "heading",
                component: "text",
                defaultValue: "Three Tiles Heading"
            },
            {
                label: "Tiles",
                name: "tiles",
                description: "Max of 3 tiles",
                component: "group-list",
                itemProps: {
                    label: "{{item.heading}}"
                },
                validate: {
                    maxItems: 3
                },
                fields: [
                    {
                        label: "Image Alt",
                        name: "alt",
                        component: "text",
                        description: "Brief description of image"
                    },
                    {
                        label: "Image",
                        name: "image",
                        component: "image"
                    },
                    {
                        label: "Image Position",
                        name: "position",
                        component: "select",
                        options: OBJECT_POSITIONS.mobile
                    },
                    {
                        label: "Heading",
                        name: "heading",
                        component: "text"
                    },
                    {
                        label: "Description",
                        name: "description",
                        component: "textarea"
                    },
                    {
                        label: "Link",
                        name: "link",
                        component: "link"
                    }, 
                ],
                defaultItem: {
                    alt: "Man in white and light tan outfit",
                    image: {
                        src: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/man-in-white-and-light-tan-outfit.jpg?v=1672348139"
                    },
                    position: "object-center",
                    heading: "Headline",
                    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
                    link: {
                        text: "",
                        url: ""
                    }
                },
                defaultValue: [
                    {
                        alt: "Man in white and light tan outfit",
                        image: {
                            src: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/man-in-white-and-light-tan-outfit.jpg?v=1672348139"
                        },
                        position: "object-center",
                        heading: "Headline",
                        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit."
                    },
                    {
                        alt: "Man in brown coat sitting down",
                        image: {
                            src: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/austin-wade-d2s8NQ6WD24-unsplash.jpg?v=1672348122"
                        },
                        position: "object-center",
                        heading: "Headline",
                        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit."
                    },
                    {
                        alt: "Man in gray sweater and tan coat",
                        image: {
                            src: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/man-poses-in-light-colored-overcoat.jpg?v=1672348143"
                        },
                        position: "object-center",
                        heading: "Headline",
                        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit."
                    }, 
                ]
            },
            {
                label: "Footer Button",
                name: "button",
                component: "link"
            },
            {
                label: "Section Settings",
                name: "section",
                component: "group",
                description: "Image aspect ratio, background color, text color, full width",
                fields: [
                    {
                        label: "Image Aspect Ratio",
                        name: "aspectRatio",
                        component: "select",
                        options: [
                            {
                                label: "3:2",
                                value: "aspect-[3/2]"
                            },
                            {
                                label: "4:3",
                                value: "aspect-[4/3]"
                            },
                            {
                                label: "5:4",
                                value: "aspect-[5/4]"
                            },
                            {
                                label: "8:7",
                                value: "aspect-[8/7]"
                            },
                            {
                                label: "1:1",
                                value: "aspect-[1/1]"
                            },
                            {
                                label: "7:8",
                                value: "aspect-[7/8]"
                            },
                            {
                                label: "4:5",
                                value: "aspect-[4/5]"
                            },
                            {
                                label: "3:4",
                                value: "aspect-[3/4]"
                            },
                            {
                                label: "2:3",
                                value: "aspect-[2/3]"
                            }, 
                        ]
                    },
                    {
                        label: "Background Color",
                        name: "bgColor",
                        component: "select",
                        options: COLORS
                    },
                    {
                        label: "Text Color",
                        name: "textColor",
                        component: "select",
                        options: COLORS
                    },
                    {
                        label: "Button Style",
                        name: "buttonStyle",
                        component: "select",
                        options: [
                            {
                                label: "Primary",
                                value: "btn-primary"
                            },
                            {
                                label: "Secondary",
                                value: "btn-secondary"
                            },
                            {
                                label: "Inverse Light",
                                value: "btn-inverse-light"
                            },
                            {
                                label: "Inverse Dark",
                                value: "btn-inverse-dark"
                            }, 
                        ]
                    },
                    {
                        label: "Full Width",
                        name: "fullWidth",
                        component: "toggle",
                        description: "Removes max width of this section",
                        toggleLabels: {
                            true: "On",
                            false: "Off"
                        }
                    }, 
                ],
                defaultValue: {
                    aspectRatio: "aspect-[3/4]",
                    bgColor: "var(--background)",
                    textColor: "var(--text)",
                    buttonStyle: "btn-primary",
                    fullWidth: false
                }
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/PackThreeTiles/ThreeTiles.jsx




function ThreeTiles(param) {
    var cms = param.cms;
    var button = cms.button, heading = cms.heading, section = cms.section, tiles = cms.tiles;
    var ref = (0,_object_spread/* default */.Z)({}, section), aspectRatio = ref.aspectRatio, bgColor = ref.bgColor, fullWidth = ref.fullWidth, textColor = ref.textColor;
    var maxWidthClass = fullWidth ? "max-w-none" : "max-w-[var(--content-max-width)]";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "lg-px-contained py-contained",
        style: {
            backgroundColor: bgColor
        },
        children: [
            heading && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "text-title-h2 mb-6 px-4 text-center md:mb-10",
                style: {
                    color: textColor
                },
                children: heading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* ThreeTilesRow */.sE, {
                aspectRatio: aspectRatio,
                maxWidthClass: maxWidthClass,
                textColor: textColor,
                tiles: tiles
            }),
            (button === null || button === void 0 ? void 0 : button.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-10 flex flex-col items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                    "aria-label": button.text,
                    className: "".concat((section === null || section === void 0 ? void 0 : section.buttonStyle) || "btn-primary"),
                    href: button.url,
                    newTab: button.newTab,
                    children: button.text
                })
            })
        ]
    });
}
ThreeTiles.displayName = "ThreeTiles";
ThreeTiles.Schema = ThreeTiles_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/PackThreeTiles/index.js


;// CONCATENATED MODULE: ./src/sections/PackTwoTiles/TwoTiles.schema.js
function TwoTiles_schema_Schema() {
    return {
        category: "Image",
        label: "Two Tiles",
        key: "two-tiles",
        previewSrc: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/two-tiles-preview.jpg?v=1675730356",
        fields: [
            {
                label: "Tiles",
                name: "tiles",
                description: "Max of 2 tiles",
                component: "group-list",
                itemProps: {
                    label: "{{item.heading}}"
                },
                validate: {
                    maxItems: 2
                },
                fields: [
                    {
                        label: "Image Alt",
                        name: "alt",
                        component: "text",
                        description: "Brief description of image"
                    },
                    {
                        label: "Image",
                        name: "image",
                        component: "image"
                    },
                    {
                        label: "Heading",
                        name: "heading",
                        component: "text"
                    },
                    {
                        label: "Link",
                        name: "link",
                        component: "link"
                    }, 
                ],
                defaultItem: {
                    alt: "Rack of green t-shirts",
                    image: {
                        src: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/keagan-henman-xPJYL0l5Ii8-unsplash_20_281_29.jpg?v=1672349016"
                    },
                    position: "object-center",
                    heading: "Headline",
                    description: "Nulla vitae elit libero, a pharetra augue.",
                    link: {
                        text: "",
                        url: ""
                    }
                },
                defaultValue: [
                    {
                        alt: "Rack of green t-shirts",
                        image: {
                            src: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/keagan-henman-xPJYL0l5Ii8-unsplash_20_281_29.jpg?v=1672349016"
                        },
                        position: "object-center",
                        heading: "Headline",
                        description: "Nulla vitae elit libero, a pharetra augue."
                    },
                    {
                        alt: "Dark orange jacket on a hanger",
                        image: {
                            src: "https://cdn.shopify.com/s/files/1/0671/5074/1778/files/tobias-tullius-Fg15LdqpWrs-unsplash.jpg?v=1672348152"
                        },
                        position: "object-center",
                        heading: "Headline",
                        description: "Nulla vitae elit libero, a pharetra augue."
                    }, 
                ]
            },
            {
                label: "Section Settings",
                name: "section",
                component: "group",
                description: "Full width",
                fields: [
                    {
                        label: "Full Width",
                        name: "fullWidth",
                        component: "toggle",
                        description: "Removes max width of this section",
                        toggleLabels: {
                            true: "On",
                            false: "Off"
                        }
                    }, 
                ],
                defaultValue: {
                    fullWidth: false
                }
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/PackTwoTiles/TwoTiles.jsx






function TwoTiles(param) {
    var cms = param.cms;
    var section = cms.section, tiles = cms.tiles;
    var maxWidthClass = (section === null || section === void 0 ? void 0 : section.fullWidth) ? "max-w-none" : "max-w-[var(--content-max-width)]";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "px-contained py-20",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat(maxWidthClass, " mx-auto grid gap-x-6 gap-y-12 md:grid-cols-2 lg:gap-x-16"),
            children: tiles === null || tiles === void 0 ? void 0 : tiles.slice(0, 2).map(function(item, index) {
                var ref, ref1, ref2, ref3, ref4, ref5, ref6;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative mb-4 bg-offWhite h-[220px] lg:h-[380px] w-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                                "aria-label": item.heading,
                                href: (ref = item.link) === null || ref === void 0 ? void 0 : ref.url,
                                newTab: (ref1 = item.link) === null || ref1 === void 0 ? void 0 : ref1.newTab,
                                tabIndex: "-1",
                                children: (item === null || item === void 0 ? void 0 : (ref2 = item.image) === null || ref2 === void 0 ? void 0 : ref2.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                    alt: item.alt,
                                    className: "".concat(item.position),
                                    fill: true,
                                    sizes: "(min-width: 1024px) 40vw, 100vw",
                                    src: item.image.src
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-start",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                                    "aria-label": item.heading,
                                    href: (ref3 = item.link) === null || ref3 === void 0 ? void 0 : ref3.url,
                                    newTab: (ref4 = item.link) === null || ref4 === void 0 ? void 0 : ref4.newTab,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "group flex",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                                            variant: "h4",
                                            element: "h4",
                                            className: "pb-4",
                                            children: item.heading
                                        })
                                    })
                                }),
                                (item === null || item === void 0 ? void 0 : item.link) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    href: item === null || item === void 0 ? void 0 : (ref5 = item.link) === null || ref5 === void 0 ? void 0 : ref5.url,
                                    theme: "primary",
                                    variant: "filled",
                                    children: item === null || item === void 0 ? void 0 : (ref6 = item.link) === null || ref6 === void 0 ? void 0 : ref6.text
                                })
                            ]
                        })
                    ]
                }, index);
            })
        })
    });
}
TwoTiles.displayName = "TwoTiles";
TwoTiles.Schema = TwoTiles_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/PackTwoTiles/index.js


// EXTERNAL MODULE: ../node_modules/next/script.js
var script = __webpack_require__(3218);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./src/sections/PandectesWithdrawal/PandectesWithdrawal.schema.js
function PandectesWithdrawal_schema_Schema() {
    return {
        category: "Legal",
        label: "Pandectes Withdrawal",
        key: "pandectes-withdrawal",
        fields: [
            {
                label: "Locale",
                name: "localeCode",
                component: "text",
                description: 'Two-letter locale code (e.g. "en"). Required.',
                defaultValue: "en"
            },
            {
                label: "Language",
                name: "lang",
                component: "text",
                description: 'Language code (e.g. "en"). Required.',
                defaultValue: "en"
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/PandectesWithdrawal/PandectesWithdrawal.jsx




function PandectesWithdrawal(param) {
    var cms = param.cms;
    var _localeCode = cms.localeCode, localeCode = _localeCode === void 0 ? "en" : _localeCode, _lang = cms.lang, lang = _lang === void 0 ? "en" : _lang;
    // The withdrawal module reads config defined by the settings script, so it
    // must only load once the settings script has executed.
    var ref = (0,react.useState)(false), settingsLoaded = ref[0], setSettingsLoaded = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "px-contained py-contained",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "pandectes-withdrawal-settings",
                src: "https://st.pandect.es/clearly-filtered/pandectes-withdrawal-settings.js",
                strategy: "afterInteractive",
                onLoad: function() {
                    return setSettingsLoaded(true);
                }
            }),
            settingsLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "pandectes-withdrawal-script",
                type: "module",
                src: "https://s.pandect.es/scripts/latest/pandectes-withdrawal.js",
                strategy: "afterInteractive"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("pandectes-withdrawal", {
                "data-locale": localeCode,
                lang: lang
            })
        ]
    });
}
PandectesWithdrawal.displayName = "PandectesWithdrawal";
PandectesWithdrawal.Schema = PandectesWithdrawal_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/PandectesWithdrawal/index.js


;// CONCATENATED MODULE: ./src/sections/PageBanner/PageBanner.schema.js
var PageBanner_schema_Schema = function() {
    return {
        label: "Page Banner",
        category: "Banner",
        key: "page-banner",
        fields: [
            {
                label: "Heading",
                name: "heading",
                component: "text",
                defaultValue: "Heading"
            },
            {
                label: "Copy",
                name: "copy",
                component: "text",
                defaultValue: "Donec ultrices elit a ligula aliquet facilisis. Pellentesque ultrices aliquet lacinia. Aenean suscipit tortor venenatis ullamcorper pharetra. Cras ac pharetra purus biam."
            },
            {
                label: "Background Gradient Start Color",
                name: "bgGradientStart",
                component: "color",
                defaultValue: "#2179C2",
                description: "Select the starting color of the background gradient. (#2179C2) A 20% opacity will be applied to the color selected."
            },
            {
                label: "Background Gradient End Color",
                name: "bgGradientEnd",
                component: "color",
                defaultValue: "#F1DCC1",
                description: "Select the ending color of the background gradient. (#F1DCC1) A 20% opacity will be applied to the color selected."
            }, 
        ],
        defaultItem: {
            header: "Get in Touch",
            copy: "Monday - Friday 9AM to 4PM Pacific Time."
        }
    };
};

;// CONCATENATED MODULE: ./src/sections/PageBanner/PageBanner.jsx


function PageBanner(param) {
    var cms = param.cms;
    var heading = cms.heading, copy = cms.copy, bgGradientStart = cms.bgGradientStart, bgGradientEnd = cms.bgGradientEnd;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative bg-accent3Opacity20",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    backgroundImage: "linear-gradient(to right, ".concat(bgGradientStart, ", ").concat(bgGradientEnd, ")")
                },
                className: "page-banner__background absolute h-full w-full bg-[#D9D9D9] bg-gradient-to-r opacity-20"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-contained overflow-hidden pb-24 pt-24",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: "mb-4 text-center text-4xl font-light tracking-[-.02em] max-md:text-[30px]",
                        children: heading
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mx-auto max-w-3xl text-center",
                        children: copy
                    })
                ]
            })
        ]
    });
}
PageBanner.displayName = "Page Banner";
PageBanner.Schema = PageBanner_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/PageBanner/index.js


;// CONCATENATED MODULE: ./src/sections/PartnerSlider/PartnerSlider.schema.js
var PartnerSlider_schema_slideContent = {
    label: "Slider Settings",
    name: "slider",
    description: "",
    component: "group",
    fields: [
        {
            label: "Slides",
            name: "slideItems",
            component: "group-list",
            itemProps: {
                label: "{{item.title}}"
            },
            validate: {
                maxItems: 5
            },
            fields: [
                {
                    label: "Image",
                    name: "image",
                    component: "image"
                },
                {
                    label: "Title",
                    name: "title",
                    component: "text"
                },
                {
                    label: "Copy",
                    name: "copy",
                    component: "text"
                }, 
            ],
            defaultValue: [
                {
                    title: "Company Name",
                    copy: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore."
                }, 
            ],
            defaultItem: {
                title: "Company Name",
                copy: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore."
            }
        }, 
    ]
};
var PartnerSlider_schema_Schema = function() {
    return {
        label: "Partner Slider",
        category: "Slider",
        key: "partnerSlider",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/Screen_20Shot_202023-05-23_20at_2010.47.01_20AM.png?v=1684864568",
        fields: [
            {
                label: "Eyebrow",
                name: "eyebrow",
                component: "text",
                defaultValue: "OUR PARTNERS"
            },
            {
                label: "Heading",
                name: "heading",
                component: "text",
                defaultValue: "Making an Impact"
            },
            PartnerSlider_schema_slideContent, 
        ]
    };
};

;// CONCATENATED MODULE: ./src/sections/PartnerSlider/PartnerSlider.jsx







function PartnerSlide(props) {
    var image = props.image, title = props.title, copy = props.copy;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative mx-auto max-w-[720px] rounded-lg py-12",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-0 h-full w-full rounded-lg bg-gradient-to-r from-[#C1EFFA] to-[#8DCEF9] opacity-30"
            }),
            image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                    className: "mx-auto",
                    sizes: "48px",
                    width: "108px",
                    height: "108px",
                    src: image.src
                })
            }),
            !image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-6 h-[108px] w-[108px]"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                variant: "h5",
                element: "h5",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Body */.uT, {
                variant: "large",
                className: "mx-auto mt-4 max-w-[500px]",
                children: copy
            })
        ]
    });
}
function PartnerSlider(param) {
    var cms = param.cms;
    var heading = cms.heading, eyebrow = cms.eyebrow, slider = cms.slider;
    var ref = (0,react.useState)(null), swiper = ref[0], setSwiper = ref[1];
    var ref1 = (0,react.useState)(1), activeSlideIndex = ref1[0], setActiveSlideIndex = ref1[1];
    swiper === null || swiper === void 0 ? void 0 : swiper.on("slideChange", function() {
        setActiveSlideIndex(this.realIndex + 1);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative bg-[#F2F7FB]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "px-contained overflow-hidden pb-16 pt-12 text-center lg:pb-24 lg:pt-24",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Eyebrow */.j4, {
                    className: "mb-4",
                    children: eyebrow
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                    variant: "h3",
                    element: "h3",
                    children: heading
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                    onSwiper: setSwiper,
                    className: "!static mx-auto mt-8 w-full max-w-[760px] overflow-visible lg:mt-16",
                    centeredSlides: true,
                    grabCursor: true,
                    loop: true,
                    pagination: {
                        el: ".swiper-pagination",
                        type: "bullets",
                        clickable: true,
                        renderBullet: function renderBullet(_, className) {
                            return '<span class="!bg-primary '.concat(className, ' rounded-full w-2 max-lg:!h-2 lg:w-full lg:rounded-none max-lg:!mx-2 lg:mx-0"></span>');
                        }
                    },
                    modules: [
                        modules/* Pagination */.tl
                    ],
                    slidesPerView: 1,
                    spaceBetween: 16,
                    breakpoints: {
                        1024: {
                            loop: true,
                            slidesPerView: 1,
                            spaceBetween: 0
                        }
                    },
                    children: slider === null || slider === void 0 ? void 0 : slider.slideItems.map(function(param, index) {
                        var image = param.image, title = param.title, copy = param.copy;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerSlide, {
                                image: image,
                                title: title,
                                copy: copy
                            }, index)
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "swiper-pagination swiper-progress !static mx-auto mt-8 w-[900px] max-w-[900px] flex-nowrap lg:mt-16 lg:flex"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative mx-auto hidden max-w-[940px] lg:block",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "absolute right-[-25px] top-[-13px] text-sm font-normal",
                        children: [
                            activeSlideIndex,
                            " / ",
                            swiper === null || swiper === void 0 ? void 0 : swiper.slides.length
                        ]
                    })
                })
            ]
        })
    });
}
PartnerSlider.displayName = "Partner Slider";
PartnerSlider.Schema = PartnerSlider_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/PartnerSlider/index.js


;// CONCATENATED MODULE: ./src/sections/ProductAdditionalDetails/ProductAdditionalDetails.schema.js
function ProductAdditionalDetails_schema_Schema() {
    return {
        key: "product-additional-details",
        label: "Product Additional Details",
        category: "Product",
        fields: [
            {
                component: "group-list",
                name: "productCallouts",
                label: "Product Callouts",
                itemProps: {
                    label: "Callout: {{item.title}}"
                },
                fields: [
                    {
                        component: "text",
                        name: "title",
                        label: "Title"
                    },
                    {
                        component: "text",
                        name: "content",
                        label: "Content"
                    },
                    {
                        component: "image",
                        name: "icon",
                        label: "Icon"
                    }, 
                ],
                defaultValue: [
                    {
                        title: "Extended Filter Life",
                        content: "Lasts 2.5x longer than standard store-bought filters"
                    },
                    {
                        title: "Affinity\xae Filtration",
                        content: "Targets up to 73x more contaminants than mainstream water filters"
                    },
                    {
                        title: "Medical-Grade Materials",
                        content: "100% free of BPS/BPA, phthalates, and EA activity"
                    }, 
                ],
                validate: {
                    maxItems: 3
                }
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/ProductAdditionalDetails/ProductAdditionalDetails.jsx

function ProductAdditionalDetails() {
    // Return nothing, this component only used to store data
    return null;
}
ProductAdditionalDetails.displayName = "ProductAdditionalDetails";
ProductAdditionalDetails.Schema = ProductAdditionalDetails_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/ProductAdditionalDetails/index.js


// EXTERNAL MODULE: ../node_modules/lodash.chunk/index.js
var lodash_chunk = __webpack_require__(3261);
var lodash_chunk_default = /*#__PURE__*/__webpack_require__.n(lodash_chunk);
;// CONCATENATED MODULE: ./src/sections/ProductCarousel/ProductCarousel.schema.js
function ProductCarousel_schema_Schema() {
    return {
        label: "Product Carousel",
        key: "productCarousel",
        category: "Product",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/product_carousel.png?v=1686314380",
        fields: [
            {
                label: "Heading",
                name: "heading",
                component: "text",
                defaultValue: "Products Slider Heading"
            },
            {
                label: "Products",
                name: "products",
                validate: {
                    required: true,
                    maxItems: 12
                },
                component: "group-list",
                itemProps: {
                    label: "{{item.product.handle}}"
                },
                fields: [
                    {
                        name: "product",
                        component: "productSearch",
                        label: "Product"
                    }, 
                ],
                defaultValue: [
                    {
                        handle: ""
                    },
                    {
                        handle: ""
                    },
                    {
                        handle: ""
                    },
                    {
                        handle: ""
                    }, 
                ]
            },
            {
                label: "CTA",
                name: "cta",
                component: "link"
            },
            {
                label: "Product Item Settings",
                name: "productItem",
                component: "group",
                description: "Star rating, color variant selector, quick shop",
                fields: [
                    {
                        label: "Enable Star Rating",
                        name: "enabledStarRating",
                        component: "toggle",
                        toggleLabels: {
                            true: "On",
                            false: "Off"
                        }
                    },
                    {
                        label: "Enable Color Variant Selector",
                        name: "enabledColorSelector",
                        component: "toggle",
                        toggleLabels: {
                            true: "On",
                            false: "Off"
                        }
                    }, 
                ],
                defaultValue: {
                    enabledStarRating: false,
                    enabledColorSelector: false,
                    enabledColorNameOnHover: false,
                    enabledQuickShop: false
                }
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/ProductCarousel/ProductCarousel.jsx









function ProductCarousel(param) {
    var cms = param.cms;
    var heading = cms.heading, productItem = cms.productItem, products = cms.products, cta = cms.cta;
    var remappedProductsDesktop = (0,react.useMemo)(function() {
        return lodash_chunk_default()(products, 4);
    }, [
        products
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "pt-10",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "px-contained mx-auto",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative z-10 mb-10 flex items-center justify-between lg:pl-20",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                            variant: "h3",
                            children: heading
                        }),
                        cta && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "justify-center lg:mt-14 lg:hidden",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                                className: "underline",
                                href: cta.url,
                                children: cta.text
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "hidden lg:block",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* default */.Z, {
                        topArrows: true,
                        infiniteLoop: true,
                        itemsPerPageMultiplier: 4,
                        overwriteTotalItems: products.length,
                        children: remappedProductsDesktop === null || remappedProductsDesktop === void 0 ? void 0 : remappedProductsDesktop.map(function(productChunk, index) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                className: "grid grid-cols-4",
                                children: productChunk === null || productChunk === void 0 ? void 0 : productChunk.map(function(param, _index) {
                                    var product = param.product;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                        className: "group relative flex-1 shrink-0 border border-r-0 border-[#E9E9EB] p-6 text-left transition-all last:border-r",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "pointer-events-none absolute left-0 top-0 z-10 h-full w-full bg-gradient-to-l from-[#F1DCC126] to-[#2179C226] opacity-0 bg-blend-multiply transition-opacity group-hover:opacity-100"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "relative z-0 [&_.product-item-media]:bg-background",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* ProductItem */.Cd, {
                                                    disableBackground: true,
                                                    disableHoverEffect: true,
                                                    enabledColorNameOnHover: productItem === null || productItem === void 0 ? void 0 : productItem.enabledColorNameOnHover,
                                                    enabledColorSelector: productItem === null || productItem === void 0 ? void 0 : productItem.enabledColorSelector,
                                                    enabledQuickShop: productItem === null || productItem === void 0 ? void 0 : productItem.enabledQuickShop,
                                                    enabledStarRating: productItem === null || productItem === void 0 ? void 0 : productItem.enabledStarRating,
                                                    handle: product === null || product === void 0 ? void 0 : product.handle,
                                                    index: index
                                                })
                                            })
                                        ]
                                    }, _index);
                                })
                            }, index);
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pb-10 lg:hidden",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSliderMobile, {
                        productItem: productItem,
                        products: products
                    })
                }),
                (cta === null || cta === void 0 ? void 0 : cta.url) && (cta === null || cta === void 0 ? void 0 : cta.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "hidden justify-center lg:mt-14 lg:flex",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Button */.zx, {
                        theme: "primary",
                        variant: "filled",
                        href: cta.url,
                        children: cta.text
                    })
                })
            ]
        })
    });
}
function ProductSliderMobile(param) {
    var productItem = param.productItem, products = param.products;
    var swatchesMap = (0,hooks/* useColorSwatches */.Bb)().swatchesMap;
    var ref = (0,react.useState)(null), swiper = ref[0], setSwiper = ref[1];
    var slidesPerViewDesktop = 4;
    var slidesPerViewTablet = 3.4;
    var slidesPerViewMobile = 2.1;
    var isFullBleedAndCentered = false;
    var isLoop = false;
    var maxWidthClass = "max-w-[var(--content-max-width)]";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            products && /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                centeredSlides: isFullBleedAndCentered && products.length >= slidesPerViewMobile * 2,
                className: "relative mt-10 w-full ".concat(maxWidthClass),
                grabCursor: true,
                loop: isLoop && products.length >= slidesPerViewMobile * 2,
                modules: [
                    modules/* Navigation */.W_
                ],
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                    disabledClass: "cursor-not-allowed opacity-20"
                },
                onSwiper: setSwiper,
                slidesOffsetAfter: isFullBleedAndCentered ? 0 : 16,
                slidesOffsetBefore: isFullBleedAndCentered ? 0 : 16,
                slidesPerView: slidesPerViewMobile,
                spaceBetween: 16,
                breakpoints: {
                    768: {
                        centeredSlides: isFullBleedAndCentered && products.length >= slidesPerViewTablet * 2,
                        loop: isLoop && products.length >= slidesPerViewTablet * 2,
                        slidesPerView: slidesPerViewTablet,
                        spaceBetween: 20,
                        slidesOffsetBefore: isFullBleedAndCentered ? 0 : 32,
                        slidesOffsetAfter: isFullBleedAndCentered ? 0 : 32
                    },
                    1024: {
                        centeredSlides: isFullBleedAndCentered && products.length >= slidesPerViewDesktop * 2,
                        loop: isLoop && products.length >= slidesPerViewDesktop * 2,
                        slidesPerView: slidesPerViewDesktop,
                        spaceBetween: 20,
                        slidesOffsetBefore: 0,
                        slidesOffsetAfter: 0
                    }
                },
                children: [
                    swiper && products.map(function(param, index) {
                        var product = param.product;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* ProductItem */.Cd, {
                                disableBackground: true,
                                disableHoverEffect: true,
                                enabledColorNameOnHover: productItem === null || productItem === void 0 ? void 0 : productItem.enabledColorNameOnHover,
                                enabledColorSelector: productItem === null || productItem === void 0 ? void 0 : productItem.enabledColorSelector,
                                enabledQuickShop: productItem === null || productItem === void 0 ? void 0 : productItem.enabledQuickShop,
                                enabledStarRating: productItem === null || productItem === void 0 ? void 0 : productItem.enabledStarRating,
                                handle: product === null || product === void 0 ? void 0 : product.handle,
                                index: index,
                                swatchesMap: swatchesMap
                            })
                        }, index);
                    }),
                    products.length > slidesPerViewDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "z-1 relative left-0 right-0 top-[calc(50%-28px)] max-lg:h-[50px] md:px-8 lg:absolute xl:px-14",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative mx-auto justify-center gap-[40px] max-lg:mt-[100px] max-lg:flex max-sm:mt-[75px] ".concat(maxWidthClass, " ").concat(isFullBleedAndCentered ? "min-[90rem]:max-w-full" : ""),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "swiper-button-prev relative left-0 top-0 !h-[3.5rem] !w-[3.5rem] rounded-full border border-border bg-white bg-gradient-to-r from-[#C1EFFA] to-[#8DCEF9] p-[1px] after:hidden lg:absolute lg:top-[calc(50%-1.6875rem)] lg:!flex ".concat(!isFullBleedAndCentered ? "xl:-left-[1.6875rem]" : ""),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "inner-content flex h-full w-full items-center justify-center rounded-full bg-white",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                                            className: "w-[14px] text-black",
                                            src: "/svgs/arrow-left.svg#arrow-left",
                                            title: "Arrow Left",
                                            viewBox: "0 0 24 24"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "swiper-button-next relative right-0 top-0 !h-[3.5rem] !w-[3.5rem] rounded-full border border-border bg-white bg-gradient-to-r from-[#C1EFFA] to-[#8DCEF9] p-[1px] after:hidden lg:absolute lg:top-[calc(50%-1.6875rem)] lg:!flex ".concat(!isFullBleedAndCentered ? "xl:-right-[1.6875rem]" : ""),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "inner-content flex h-full w-full items-center justify-center rounded-full bg-white",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                                            className: "w-[14px] text-black",
                                            src: "/svgs/arrow-right.svg#arrow-right",
                                            title: "Arrow Right",
                                            viewBox: "0 0 24 24"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            !swiper && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative min-h-[20rem]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Spinner */.$j, {
                    width: "32",
                    className: "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
                })
            })
        ]
    });
}
ProductCarousel.displayName = "ProductCarousel";
ProductCarousel.Schema = ProductCarousel_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/ProductCarousel/index.js


;// CONCATENATED MODULE: ./src/utils/schemas/eyebrow.js
var eyebrow = {
    label: "Eyebrow",
    name: "eyebrow",
    component: "text",
    defaultValue: "FILTER REPLACEMENT MADE SIMPLE"
};
/* harmony default export */ var schemas_eyebrow = (eyebrow);

;// CONCATENATED MODULE: ./src/utils/schemas/headline.js
var headline = {
    label: "Headline",
    name: "headline",
    component: "text",
    defaultValue: "Experience Best-in-Class Filtration"
};
/* harmony default export */ var schemas_headline = (headline);

;// CONCATENATED MODULE: ./src/sections/ProductComparisonTable/ProductComparisonTable.schema.js




function ProductComparisonTable_schema_Schema() {
    return {
        key: "product-comparison-table",
        label: "Product Comparison Table",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/Screenshot_2.png?v=1686860394",
        category: "Product",
        fields: [
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, schemas_eyebrow), {
                defaultValue: "US VS THEM"
            }),
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, schemas_headline), {
                defaultValue: "Setting a new standard in portable filtration"
            }),
            {
                label: "Disclaimer text",
                name: "disclaimerText",
                component: "text"
            },
            {
                label: "CTA",
                name: "cta",
                component: "link"
            },
            {
                label: "Header items",
                name: "headerItems",
                itemProps: {
                    label: "{{item.columnHeading}}"
                },
                component: "group-list",
                fields: [
                    {
                        label: "Column heading",
                        name: "columnHeading",
                        component: "text"
                    },
                    {
                        label: "Image",
                        name: "image",
                        component: "image"
                    }, 
                ]
            },
            {
                label: "Rows",
                name: "rows",
                component: "group-list",
                itemProps: {
                    label: "{{item.rowHeading}}"
                },
                fields: [
                    {
                        label: "Row heading",
                        name: "rowHeading",
                        component: "text"
                    },
                    {
                        label: "Row columns",
                        name: "rowColumns",
                        component: "group-list",
                        itemProps: {
                            label: "{{item.text}}"
                        },
                        fields: [
                            {
                                label: "Background",
                                name: "background",
                                component: "select",
                                options: [
                                    {
                                        label: "Transparent",
                                        value: "transparent"
                                    },
                                    {
                                        label: "Gradient",
                                        value: "gradient"
                                    }, 
                                ]
                            },
                            {
                                label: "Text",
                                name: "text",
                                component: "text"
                            },
                            {
                                label: "Image",
                                name: "image",
                                component: "image"
                            }, 
                        ]
                    }, 
                ]
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/ProductComparisonTable/ProductComparisonTable.jsx





/**
 * @typedef Link
 * @type {object}
 * @property {string} url - The image source.
 * @property {string} text - The image alt text.
 *
 *
 * @typedef Image
 * @type {object}
 * @property {string} src - The image source.
 * @property {string} alt - The image alt text.
 *
 * @typedef HeaderItem
 * @type {object}
 * @property {string} columnHeading - The column heading text.
 * @property {Image} image - The image object.
 *
 * @typedef RowColumn
 * @type {object}
 * @property {string} background - The background color.
 * @property {string} text - The text.
 * @property {Image} image - The image object.
 */ /**
 * @typedef RowItem
 * @type {object}
 * @property {string} rowHeading - The row heading text.
 * @property {RowColumn[]} rowColumns - The row columns array.
 */ /**
 * Step carousel/slider made for product detail page.
 * @param {object} props - The props that were defined by the caller of this component.
 * @param {object} props.cms - The content that will came from PACK.
 * @param {string} props.cms.eyebrow - The eyebrow text.
 * @param {string} props.cms.headline - The headline text.
 * @param {string} props.cms.disclaimerText - The disclaimer text.
 * @param {Link} props.cms.cta - The cta object.
 * @param {HeaderItem[]} props.cms.headerItems - The header items array.
 * @param {RowItem[]} props.cms.rows - The row items array.
 *
 * @component
 */ function ProductComparisonTable(param) {
    var cms = param.cms;
    var eyebrow = cms.eyebrow, headerItems = cms.headerItems, rows = cms.rows, headline = cms.headline, cta = cms.cta, disclaimerText = cms.disclaimerText;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "my-20",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "px-contained mx-auto max-w-[var(--content-max-width)]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mx-auto mb-8 max-w-3xl text-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Eyebrow */.j4, {
                                children: eyebrow
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                            variant: "h4",
                            children: headline
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "-mx-4 overflow-auto md:mx-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "grid min-w-[600px] grid-cols-4",
                            children: headerItems === null || headerItems === void 0 ? void 0 : headerItems.map(function(headerItem, index) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                    className: [
                                        "col-span-1",
                                        index === 0 ? "col-start-2" : "", 
                                    ].join(" "),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex h-full flex-col items-center justify-center p-4",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mb-4",
                                                children: (headerItem === null || headerItem === void 0 ? void 0 : headerItem.image) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                                    src: headerItem.image.src,
                                                    alt: headerItem.image.alt,
                                                    width: 98,
                                                    height: 98,
                                                    className: "mix-blend-multiply",
                                                    style: {
                                                        height: "98px",
                                                        width: "98px",
                                                        objectFit: "contain"
                                                    }
                                                }) : null
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-sm font-bold text-[#202635]",
                                                    children: headerItem.columnHeading
                                                })
                                            })
                                        ]
                                    })
                                }, "header-item-".concat(index));
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: " min-w-[600px] border border-[#DDE2E7] ",
                            children: rows === null || rows === void 0 ? void 0 : rows.map(function(rowItem, index) {
                                var ref;
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                    className: "group grid auto-rows-max grid-cols-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: [
                                                "col-span-1"
                                            ].join(" "),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "h-full border-b border-[#DDE2E7] px-3 py-8 group-last:border-none lg:px-16",
                                                children: rowItem === null || rowItem === void 0 ? void 0 : rowItem.rowHeading
                                            })
                                        }),
                                        rowItem === null || rowItem === void 0 ? void 0 : (ref = rowItem.rowColumns) === null || ref === void 0 ? void 0 : ref.map(function(rowColumn, _index) {
                                            var ref, ref1;
                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                className: [
                                                    "flex justify-center border-b border-[#DDE2E7] py-8 px-3 text-center group-last:border-none lg:px-10",
                                                    (rowColumn === null || rowColumn === void 0 ? void 0 : rowColumn.background) === "gradient" ? "border-opacity-30 text-white" : "", 
                                                ].join(" "),
                                                style: {
                                                    background: (rowColumn === null || rowColumn === void 0 ? void 0 : rowColumn.background) === "gradient" ? "linear-gradient(270deg, #5B71A1 0%, #536896 10.94%, #4D618E 19.27%, #354974 33.84%, #354C7A 50.38%, #3C5280 65.88%, #3A4C79 77.84%, #232F54 100%)" : undefined
                                                },
                                                children: [
                                                    rowColumn === null || rowColumn === void 0 ? void 0 : rowColumn.text,
                                                    (rowColumn === null || rowColumn === void 0 ? void 0 : rowColumn.image) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                                        src: rowColumn === null || rowColumn === void 0 ? void 0 : (ref = rowColumn.image) === null || ref === void 0 ? void 0 : ref.src,
                                                        alt: rowColumn === null || rowColumn === void 0 ? void 0 : (ref1 = rowColumn.image) === null || ref1 === void 0 ? void 0 : ref1.alt,
                                                        width: 25,
                                                        height: 25,
                                                        className: "pointer-events-none select-none"
                                                    })
                                                ]
                                            }, "row-item-".concat(_index));
                                        })
                                    ]
                                }, "row-".concat(index));
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "my-6 text-center text-xs",
                    children: disclaimerText
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex justify-center",
                    children: cta && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Button */.zx, {
                            theme: "primary",
                            variant: "filled",
                            href: cta.url,
                            children: cta.text
                        })
                    })
                })
            ]
        })
    });
}
ProductComparisonTable.propTypes = {
    cms: prop_types_default().shape({
        eyebrow: (prop_types_default()).string,
        headline: (prop_types_default()).string,
        disclaimerText: (prop_types_default()).string,
        cta: prop_types_default().shape({
            url: (prop_types_default()).string,
            text: (prop_types_default()).string
        }),
        headerItems: prop_types_default().arrayOf(prop_types_default().shape({
            columnHeading: (prop_types_default()).string,
            image: prop_types_default().shape({
                src: (prop_types_default()).string,
                alt: (prop_types_default()).string
            })
        })),
        rows: prop_types_default().arrayOf(prop_types_default().shape({
            rowHeading: (prop_types_default()).string,
            rowColumns: prop_types_default().arrayOf(prop_types_default().shape({
                background: (prop_types_default()).string,
                text: (prop_types_default()).string,
                image: prop_types_default().oneOfType([
                    prop_types_default().shape({
                        src: (prop_types_default()).string,
                        alt: (prop_types_default()).string
                    }),
                    (prop_types_default()).string, 
                ])
            }))
        }))
    })
};
ProductComparisonTable.defaultProps = {
    cms: {
        eyebrow: "",
        headline: "",
        disclaimerText: "",
        cta: {
            url: "",
            text: ""
        },
        headerItems: [],
        rows: []
    }
};
ProductComparisonTable.displayName = "ProductComparisonTable";
ProductComparisonTable.Schema = ProductComparisonTable_schema_Schema;
/* harmony default export */ var ProductComparisonTable_ProductComparisonTable = (ProductComparisonTable);

;// CONCATENATED MODULE: ./src/sections/ProductComparisonTable/index.js


;// CONCATENATED MODULE: ./src/snippets/ProductGroupItem/ProductGroupItem.jsx





function ProductGroupItem_ProductGroupItem(param) {
    var product = param.product;
    var ref = (0,react.useState)(true), isAvailable = ref[0], setIsAvailable = ref[1];
    var ref1 = (0,react.useState)(false), isActive = ref1[0], setIsActive = ref1[1];
    // get current product
    var currentProduct = (0,dist.useProduct)();
    var linkedProduct = product === null || product === void 0 ? void 0 : product.linkedProduct;
    var ref2 = (0,dist.useProductByHandle)({
        handle: linkedProduct === null || linkedProduct === void 0 ? void 0 : linkedProduct.handle
    }), packProduct = ref2.product;
    (0,react.useEffect)(function() {
        if (!packProduct) return;
        var ref;
        var availableInventory = (ref = packProduct === null || packProduct === void 0 ? void 0 : packProduct.totalInventory) !== null && ref !== void 0 ? ref : 0;
        setIsAvailable(availableInventory > 0 || !(packProduct === null || packProduct === void 0 ? void 0 : packProduct.tracksInventory));
        setIsActive((linkedProduct === null || linkedProduct === void 0 ? void 0 : linkedProduct.handle) === (currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.handle));
    }, [
        currentProduct,
        packProduct
    ]);
    var productURL = "/products/".concat(linkedProduct === null || linkedProduct === void 0 ? void 0 : linkedProduct.handle);
    var productTitle = product === null || product === void 0 ? void 0 : product.linkedProductTitle;
    var classes = "relative inline-block min-w-[3.5rem] overflow-hidden border px-[20px] py-[10px] text-[0.7rem] md:text-base text-text transition hover:border-text hover:bg-white md:hover:border-text";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "whitespace-nowrap",
        children: [
            isActive && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "".concat(classes, " cursor-pointer border-black bg-white shadow-[inset_0_0_0_1px_#000000]"),
                children: productTitle
            }),
            !isActive && /*#__PURE__*/ (0,jsx_runtime.jsxs)(snippets/* Link */.rU, {
                className: "".concat(isAvailable ? "border-[#797D86] bg-[#E6F0F8]" : "pointer-events-none opacity-50", "\n          ").concat(classes),
                "aria-label": productTitle,
                href: productURL,
                children: [
                    !isAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute inset-0 top-[50%] h-[1px] w-[calc(100%+20px)] -rotate-[18deg] border-t border-t-text bg-red-200 opacity-30"
                    }),
                    productTitle
                ]
            })
        ]
    });
}
ProductGroupItem_ProductGroupItem.displayName = "ProductGroupItem";
ProductGroupItem_ProductGroupItem.propTypes = {
    product: prop_types_default().shape({
        linkedProductTitle: (prop_types_default()).string,
        linkedProduct: (prop_types_default()).object
    })
};

;// CONCATENATED MODULE: ./src/snippets/ProductGroupItem/index.js


// EXTERNAL MODULE: ./src/snippets/Image/index.js + 2 modules
var snippets_Image = __webpack_require__(8601);
// EXTERNAL MODULE: ./src/snippets/AddToCart/index.js + 3 modules
var AddToCart = __webpack_require__(9729);
;// CONCATENATED MODULE: ./src/snippets/Rebuy/RebuyUpsell.jsx




function RebuyUpsell(param) {
    var recommendedProduct = param.recommendedProduct;
    var /* Image */ ref, ref1, ref2, ref3, ref4, ref5, /* Add to Cart Button */ ref6, ref7, ref8, ref9;
    var fullProduct = (0,dist.useProductByHandle)({
        handle: recommendedProduct === null || recommendedProduct === void 0 ? void 0 : recommendedProduct.handle
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: "mb-4 border border-[#DDE2E7] p-[14px] lg:px-[22px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-row items-center justify-between",
            children: [
                (recommendedProduct === null || recommendedProduct === void 0 ? void 0 : (ref = recommendedProduct.image) === null || ref === void 0 ? void 0 : ref.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative aspect-square w-[70px] shrink-0 bg-background lg:w-[100px]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets_Image/* Image */.E, {
                        alt: recommendedProduct === null || recommendedProduct === void 0 ? void 0 : recommendedProduct.title,
                        className: "absolute h-full w-full object-contain !mix-blend-multiply",
                        width: "150px",
                        height: "150px",
                        src: recommendedProduct === null || recommendedProduct === void 0 ? void 0 : (ref1 = recommendedProduct.image) === null || ref1 === void 0 ? void 0 : ref1.src
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex-1 px-2",
                    children: [
                        (recommendedProduct === null || recommendedProduct === void 0 ? void 0 : recommendedProduct.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-[13px] font-light lg:text-base",
                            children: recommendedProduct === null || recommendedProduct === void 0 ? void 0 : recommendedProduct.title
                        }),
                        (recommendedProduct === null || recommendedProduct === void 0 ? void 0 : (ref2 = recommendedProduct.variants) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.price) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-1 text-[10px] lg:mt-2 lg:text-sm",
                            children: [
                                "$",
                                recommendedProduct === null || recommendedProduct === void 0 ? void 0 : (ref4 = recommendedProduct.variants) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[0]) === null || ref5 === void 0 ? void 0 : ref5.price
                            ]
                        })
                    ]
                }),
                (recommendedProduct === null || recommendedProduct === void 0 ? void 0 : (ref6 = recommendedProduct.variants) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[0]) === null || ref7 === void 0 ? void 0 : ref7.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "max-sm:mt-4 [&_button]:mt-0 [&_button]:!py-2 [&_button_p]:text-[11px] [&_p]:!mb-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCart/* AddToCart */.o, {
                        addToCartText: "Add",
                        selectedVariant: fullProduct === null || fullProduct === void 0 ? void 0 : (ref8 = fullProduct.product) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.variants) === null || ref9 === void 0 ? void 0 : ref9[0]
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/snippets/CrossSellProduct/CrossSellProduct.jsx




function CrossSellProduct(param) {
    var crossSellProduct = param.product;
    var ref, ref1, ref2;
    // const product = crossSellProduct?.product;
    var handle = crossSellProduct === null || crossSellProduct === void 0 ? void 0 : (ref = crossSellProduct.product) === null || ref === void 0 ? void 0 : ref.handle;
    var product = (0,dist.useProductByHandle)({
        handle: handle
    }).product;
    var price = (0,hooks/* useVariantPrices */.be)({
        variant: product === null || product === void 0 ? void 0 : (ref1 = product.variants) === null || ref1 === void 0 ? void 0 : ref1[0]
    }).price;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(snippets/* Link */.rU, {
            "aria-label": product === null || product === void 0 ? void 0 : product.title,
            href: "/products/".concat(product === null || product === void 0 ? void 0 : product.handle, "/"),
            children: [
                (product === null || product === void 0 ? void 0 : (ref2 = product.featuredImage) === null || ref2 === void 0 ? void 0 : ref2.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative aspect-square bg-[#E6F0F8]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                        className: "!object-contain mix-blend-multiply",
                        alt: product === null || product === void 0 ? void 0 : product.title,
                        fill: true,
                        sizes: "(min-width: 768px) 33vw, 50vw",
                        src: product.featuredImage.src
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-4 text-sm font-light",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            className: "font-light",
                            children: product === null || product === void 0 ? void 0 : product.title
                        }),
                        "From ",
                        price
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/snippets/CrossSellProduct/index.js


;// CONCATENATED MODULE: ./src/sections/ProductDetailAccordions/ProductDetailAccordion.jsx





function ProductDetailAccordion(param) {
    var accordion = param.accordion, headerBgColor = param.headerBgColor, headerTextColor = param.headerTextColor, recommendedProducts = param.recommendedProducts;
    var ref;
    var body = accordion.body, defaultOpen = accordion.defaultOpen, header = accordion.header, isUpsell = accordion.isUpsell, crossSellProducts = accordion.crossSellProducts;
    var ref1 = (0,react.useState)(defaultOpen), isOpen = ref1[0], setIsOpen = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pdp-accordion-inner",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                "aria-label": "".concat(isOpen ? "Close" : "Open", " accordion for ").concat(header),
                className: "pdp-accordion-inner__button flex h-14 w-full items-center justify-between gap-x-4 border-t border-t-[#2026351A] py-8",
                onClick: function() {
                    return setIsOpen(!isOpen);
                },
                style: {
                    backgroundColor: headerBgColor,
                    color: headerTextColor
                },
                type: "button",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Body */.uT, {
                        className: "font-base font-normal uppercase max-sm:text-xs max-sm:font-light",
                        element: "div",
                        children: header
                    }),
                    isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                        className: "w-4 text-current",
                        src: "/svgs/chevron-up.svg#chevron-up",
                        title: "Up",
                        viewBox: "0 0 24 24"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                        className: "w-4 text-current",
                        src: "/svgs/chevron-down.svg#chevron-down",
                        title: "Down",
                        viewBox: "0 0 24 24"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pdp-accordion-inner__body py-4 pb-8 [&_h1]:mb-3 [&_h1]:text-sm [&_h2]:mb-3 [&_h2]:text-sm [&_h3]:mb-3 [&_h3]:text-sm [&_h4]:mb-3 [&_h4]:text-sm [&_h5]:mb-3 [&_h5]:text-sm [&_h6]:mb-3 [&_h6]:text-sm [&_ol]:!pl-4 [&_ol]:text-sm [&_p]:mb-3 [&_p]:text-sm [&_ul]:!pl-4 [&_ul]:text-sm ".concat(isOpen ? "block" : "hidden", " [&_p]:!text-base [&_p]:max-sm:!text-sm [&_ul.recommended-products]:!pl-0"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Markdown */.UG, {
                        children: body
                    }),
                    isUpsell && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "recommended-products mt-2",
                        children: recommendedProducts === null || recommendedProducts === void 0 ? void 0 : (ref = recommendedProducts.data) === null || ref === void 0 ? void 0 : ref.map(function(item, itemIndex) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(RebuyUpsell, {
                                recommendedProduct: item
                            }, "recommended-product-".concat(itemIndex));
                        })
                    }),
                    crossSellProducts && Object.keys(crossSellProducts).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grid max-w-[366px] grid-cols-2 gap-[26px]",
                        children: crossSellProducts.map(function(crossSellProduct, crossSellProductIndex) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CrossSellProduct, {
                                product: crossSellProduct
                            }, "cross-sell-product-".concat(crossSellProductIndex));
                        })
                    })
                ]
            })
        ]
    });
}
ProductDetailAccordion.displayName = "ProductDetailAccordion";

;// CONCATENATED MODULE: ./src/sections/ProductDetailAccordions/ProductDetailAccordions.schema.js

function ProductDetailAccordions_schema_Schema(param) {
    var product = param.product, settings = param.settings;
    if (!product) return null;
    return {
        category: "Product",
        label: "Product Detail Accordions",
        key: "product-detail-accordions",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/product-detail-accordions.png?v=1686164567",
        fields: [
            {
                label: "View Test Results",
                name: "viewTestResults",
                component: "link"
            },
            {
                label: "Product Byline",
                name: "productByLine",
                component: "text"
            },
            {
                label: "Disclaimer",
                name: "disclaimer",
                component: "text"
            },
            {
                label: "Disclaimer Alert Color",
                name: "disclaimerColor",
                component: "color",
                defaultValue: "#F1DCC1"
            },
            {
                label: "Disclaimer URL (optional)",
                name: "disclaimerUrl",
                component: "text"
            },
            {
                label: "Disclaimer Open in New Tab (optional)",
                name: "disclaimerOpenNewTab",
                component: "toggle"
            },
            {
                label: "Out of stock message",
                name: "outOfStockMessage",
                component: "group",
                defaultValue: {
                    disclaimer: "Out of Stock - Restock available soon",
                    disclaimerColor: "#ED7C5C",
                    disclaimerUrl: "",
                    disclaimerOpenNewTab: false
                },
                fields: [
                    {
                        label: "Out of Stock Disclaimer",
                        name: "disclaimer",
                        defaultValue: "Out of Stock - Restock available soon",
                        component: "text"
                    },
                    {
                        label: "Out of Stock Disclaimer Alert Color",
                        name: "disclaimerColor",
                        component: "color",
                        defaultValue: "#ED7C5C"
                    },
                    {
                        label: "Out of Stock Disclaimer URL (optional)",
                        name: "disclaimerUrl",
                        component: "text"
                    },
                    {
                        label: "Out of Stock Disclaimer Open in New Tab (optional)",
                        name: "disclaimerOpenNewTab",
                        component: "toggle"
                    }, 
                ]
            },
            {
                label: "Linked Product Groups",
                component: "group-list",
                name: "linkedProductGroups",
                itemProps: {
                    label: "{{item.groupName}}"
                },
                fields: [
                    {
                        label: "Group Name",
                        name: "groupName",
                        component: "text",
                        defaultValue: "Size"
                    },
                    {
                        label: "Linked Products",
                        component: "group-list",
                        name: "linkedProducts",
                        itemProps: {
                            label: "{{item.linkedProductTitle}}"
                        },
                        fields: [
                            {
                                label: "Product Title",
                                name: "linkedProductTitle",
                                component: "text",
                                defaultValue: "32oz Bottle"
                            },
                            {
                                label: "Product",
                                name: "linkedProduct",
                                component: "productSearch"
                            }, 
                        ]
                    }, 
                ]
            },
            {
                label: "Frequency Calculator",
                name: "frequencyCalculator",
                component: "group",
                description: "Configuration for the filter replacement frequency calculator can be set up here.",
                fields: [
                    {
                        label: "Enable Frequency Calculator?",
                        name: "enableFrequencyCalculator",
                        component: "toggle",
                        defaultValue: false
                    },
                    {
                        component: "markdown",
                        name: "disclaimerOverride",
                        label: "Disclaimer",
                        description: "Fill out to override the global calculator disclaimer"
                    },
                    {
                        component: "text",
                        name: "labelOverride",
                        label: "Slider label",
                        description: "Fill out to override the global label that displays below the slider"
                    }, 
                ]
            },
            {
                label: "Accordions",
                name: "accordions",
                component: "group-list",
                itemProps: {
                    label: "{{item.header}}"
                },
                fields: [
                    {
                        label: "Header",
                        name: "header",
                        component: "text"
                    },
                    {
                        label: "Body",
                        name: "body",
                        component: "markdown"
                    },
                    {
                        label: "Display Upsells",
                        name: "isUpsell",
                        component: "toggle",
                        description: "Display Re-Buy product upsells."
                    },
                    {
                        label: "Cross Sell Products",
                        name: "crossSellProducts",
                        description: "Feature additional products to purchase with this one.",
                        validate: {
                            maxItems: 2
                        },
                        component: "group-list",
                        itemProps: {
                            label: "{{item.product.title}}"
                        },
                        fields: [
                            {
                                name: "product",
                                component: "productSearch",
                                label: "Product"
                            }, 
                        ]
                    },
                    {
                        label: "Default Open",
                        name: "defaultOpen",
                        component: "toggle",
                        description: "Sets accordion to be open by default",
                        toggleLabels: {
                            true: "On",
                            false: "Off"
                        }
                    }, 
                ],
                defaultValue: [
                    {
                        header: "Sizing",
                        body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
                        defaultOpen: false
                    },
                    {
                        header: "Care",
                        body: "* Lorem ipsum dolor sit amet\n* Consectetur adipiscing elit\n* Sed do eiusmod tempor",
                        defaultOpen: false
                    }, 
                ],
                defaultItem: {
                    header: "Details",
                    body: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
                    defaultOpen: false
                }
            },
            {
                label: "Accordion Header Background Color",
                name: "headerBgColor",
                component: "select",
                options: COLORS,
                defaultValue: "var(--off-white)"
            },
            {
                label: "Accordion Header Text Color",
                name: "headerTextColor",
                component: "select",
                options: COLORS,
                defaultValue: "var(--text)"
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/ProductDetailAccordions/ProductDetailAccordions.jsx












function ProductDetailAccordions(param) {
    var cms = param.cms;
    var accordions = cms.accordions, headerBgColor = cms.headerBgColor, headerTextColor = cms.headerTextColor, linkedProductGroups = cms.linkedProductGroups, disclaimer = cms.disclaimer, disclaimerColor = cms.disclaimerColor, viewTestResults = cms.viewTestResults, productByLine = cms.productByLine, disclaimerUrl = cms.disclaimerUrl, disclaimerOpenNewTab = cms.disclaimerOpenNewTab, outOfStockMessage = cms.outOfStockMessage, frequencyCalculatorSettings = cms.frequencyCalculator;
    var product = (0,dist.useProduct)();
    var ref = (0,globalProductPageContext/* useGlobalProductPageContext */.j)(), selectedSellingPlan = ref.selectedSellingPlan, purchaseType = ref.purchaseType, setRecommendedFilterFrequency = ref.setRecommendedFilterFrequency, recommendedProducts = ref.recommendedProducts, selectedVariant = ref.selectedVariant, setRecommendedProducts = ref.setRecommendedProducts, scrollReference = ref.scrollReference, productSubscriptionWidget = ref.productSubscriptionWidget, setProductTestResults = ref.setProductTestResults, setProductByline = ref.setProductByline;
    (0,react.useEffect)(function() {
        if (productByLine && setProductByline) {
            setProductByline(productByLine);
        }
    }, [
        productByLine,
        setProductByline
    ]);
    // set the default recommended frequency if it exists
    var defaultRecommendedFrequency = productSubscriptionWidget === null || productSubscriptionWidget === void 0 ? void 0 : productSubscriptionWidget.defaultRecommendedFrequency;
    (0,react.useEffect)(function() {
        if (defaultRecommendedFrequency) {
            setRecommendedFilterFrequency(defaultRecommendedFrequency);
        }
    }, [
        defaultRecommendedFrequency
    ]);
    var fetchRebuyRecommendations = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var response, data, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        fetch("/api/rebuy", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                productID: product === null || product === void 0 ? void 0 : product.legacyResourceId
                            })
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    data = _state.sent();
                    setRecommendedProducts(data);
                    if (!data) {
                        throw new Error("No data returned from Out of Stock Notifications API");
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    console.error("Out of Stock Notifications Error: ".concat(error.message));
                    throw error;
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        product
    ]);
    (0,react.useEffect)(function() {
        fetchRebuyRecommendations();
    }, [
        product
    ]);
    (0,react.useEffect)(function() {
        if (viewTestResults && setProductTestResults) {
            setProductTestResults(viewTestResults);
        }
    }, [
        viewTestResults
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            linkedProductGroups && (linkedProductGroups === null || linkedProductGroups === void 0 ? void 0 : linkedProductGroups.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "linked-product-groups",
                children: linkedProductGroups.map(function(group, groupIndex) {
                    var ref, ref1;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mb-[0.4rem] border-b border-b-[#DDE2E7] pb-3 md:mb-6 md:pb-6 ",
                        children: [
                            (group === null || group === void 0 ? void 0 : group.groupName) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "mt-0 text-[11px] font-normal uppercase leading-6 md:text-base",
                                children: group === null || group === void 0 ? void 0 : group.groupName
                            }),
                            (group === null || group === void 0 ? void 0 : group.linkedProducts) && (group === null || group === void 0 ? void 0 : (ref = group.linkedProducts) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "overflow-x-auto md:overflow-x-visible md:pt-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "flex gap-2 md:flex-wrap",
                                    children: group === null || group === void 0 ? void 0 : (ref1 = group.linkedProducts) === null || ref1 === void 0 ? void 0 : ref1.map(function(linkedProduct, linkedProductIndex) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductGroupItem_ProductGroupItem, {
                                            product: linkedProduct
                                        }, "linked-product-".concat(linkedProductIndex));
                                    })
                                })
                            })
                        ]
                    }, "linked-product-group-".concat(groupIndex));
                })
            }),
            productSubscriptionWidget && /*#__PURE__*/ (0,jsx_runtime.jsx)(RechargeSubscriptionWidget/* RechargeSubscriptionWidget */.N, {
                frequencyCalculatorSettings: frequencyCalculatorSettings,
                linkedProductGroups: linkedProductGroups,
                product: product,
                widgetContent: productSubscriptionWidget
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* AddToCart */.o4, {
                oosDisclaimer: outOfStockMessage === null || outOfStockMessage === void 0 ? void 0 : outOfStockMessage.disclaimer,
                oosDisclaimerColor: outOfStockMessage === null || outOfStockMessage === void 0 ? void 0 : outOfStockMessage.disclaimerColor,
                oosDisclaimerUrl: outOfStockMessage === null || outOfStockMessage === void 0 ? void 0 : outOfStockMessage.disclaimerUrl,
                oosDisclaimerOpenNewTab: outOfStockMessage === null || outOfStockMessage === void 0 ? void 0 : outOfStockMessage.disclaimerOpenNewTab,
                disclaimer: disclaimer,
                disclaimerColor: disclaimerColor,
                disclaimerUrl: disclaimerUrl,
                disclaimerOpenNewTab: disclaimerOpenNewTab,
                isPdp: true,
                showPrice: true,
                purchaseType: purchaseType,
                selectedSellingPlan: selectedSellingPlan,
                selectedVariant: selectedVariant,
                product: product
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: scrollReference
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Beam/* BeamProductDetailsPage */.mr, {}),
            /* Accordions */ (accordions === null || accordions === void 0 ? void 0 : accordions.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "pdp-accordion mt-[40px] grid grid-cols-1 p-0",
                children: accordions.map(function(accordion, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "pdp-accordion-item",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetailAccordion, {
                            recommendedProducts: recommendedProducts,
                            accordion: accordion,
                            headerBgColor: headerBgColor,
                            headerTextColor: headerTextColor
                        })
                    }, index);
                })
            }) : null
        ]
    });
}
ProductDetailAccordions.displayName = "ProductDetailAccordions";
ProductDetailAccordions.Schema = ProductDetailAccordions_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/ProductDetailAccordions/index.js


;// CONCATENATED MODULE: ./src/sections/ProductFilterReplacement/ProductFilterReplacement.schema.js
function ProductFilterReplacement_schema_Schema() {
    return {
        category: "Text",
        label: "Product Filter Replacement",
        key: "productFilterReplacement",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/Screen_20Shot_202023-05-23_20at_2010.47.39_20AM.png?v=1684864582",
        fields: [
            {
                label: "Eyebrow",
                name: "eyebrow",
                component: "text",
                defaultValue: "FILTER REPLACEMENT MADE SIMPLE"
            },
            {
                label: "Header",
                name: "header",
                component: "text",
                defaultValue: "How Often Should I Replace My Filter?"
            },
            {
                label: "Copy",
                name: "copy",
                component: "text",
                defaultValue: 'How often varies based on your filtration system of choice and how much water you use. We recommend no more than 6 months or 180 gallons between filter changes. Select your filtration system, and we"ll help you find the right filter change frequency for your needs.'
            },
            {
                label: "Product Filter Replacement Items",
                name: "productFilterReplacementItems",
                component: "group-list",
                itemProps: {
                    label: "{{item.header}}"
                },
                fields: [
                    {
                        label: "Header",
                        name: "header",
                        component: "text"
                    },
                    {
                        label: "Replacement Options",
                        name: "replacementOptions",
                        description: "How often should filters be replaced based on the number of people in a household.",
                        component: "group-list",
                        itemProps: {
                            label: "{{item.numberOfPeople}} person(s) - {{item.replacementFrequency}}"
                        },
                        fields: [
                            {
                                label: "Number of People",
                                component: "text",
                                name: "numberOfPeople",
                                defaultValue: 1
                            },
                            {
                                label: "Replacement Frequency",
                                component: "text",
                                name: "replacementFrequency",
                                defaultValue: "6 Months"
                            }, 
                        ]
                    },
                    {
                        label: "Product Title",
                        name: "productTitle",
                        component: "text"
                    },
                    {
                        label: "Product SubTitle",
                        name: "productSubTitle",
                        component: "text"
                    },
                    {
                        label: "Product Price",
                        name: "productPrice",
                        component: "text"
                    },
                    {
                        label: "Product Image",
                        name: "productImage",
                        component: "image"
                    },
                    {
                        label: "CTA Copy",
                        name: "ctaCopy",
                        component: "text"
                    },
                    {
                        label: "CTA Url",
                        name: "ctaUrl",
                        component: "text"
                    },
                    {
                        label: "Link Copy",
                        name: "linkCopy",
                        component: "text"
                    },
                    {
                        label: "Link Url",
                        name: "linkUrl",
                        component: "text"
                    }, 
                ],
                defaultValue: [
                    {
                        header: "Picher",
                        replacement1person: "Replace every 6 months",
                        replacement2person: "Replace every 4 months",
                        replacement3person: "Replace every 3 months",
                        replacement4person: "Replace every 2 months",
                        productTitle: "Water Pitcher with Affinity Filtration Technology",
                        productSubTitle: "Get clean and safe water on-the-go with our double-walled bottle",
                        productPrice: "$XX.XX",
                        ctaCopy: "Shop Now",
                        ctaUrl: "#",
                        linkCopy: "Replacement Filters",
                        linkUrl: "#"
                    },
                    {
                        header: "Water Bottle",
                        replacement1person: "Replace every 6 months",
                        replacement2person: "Replace every 4 months",
                        replacement3person: "Replace every 3 months",
                        replacement4person: "Replace every 2 months",
                        productTitle: "Water Pitcher with Affinity Filtration Technology",
                        productSubTitle: "Get clean and safe water on-the-go with our double-walled bottle",
                        productPrice: "$XX.XX",
                        ctaCopy: "Shop Now",
                        ctaUrl: "#",
                        linkCopy: "Replacement Filters",
                        linkUrl: "#"
                    },
                    {
                        header: "Fridge",
                        replacement1person: "Replace every 6 months",
                        replacement2person: "Replace every 4 months",
                        replacement3person: "Replace every 3 months",
                        replacement4person: "Replace every 2 months",
                        productTitle: "Water Pitcher with Affinity Filtration Technology",
                        productSubTitle: "Get clean and safe water on-the-go with our double-walled bottle",
                        productPrice: "$XX.XX",
                        ctaCopy: "Shop Now",
                        ctaUrl: "#",
                        linkCopy: "Replacement Filters",
                        linkUrl: "#"
                    },
                    {
                        header: "Under Sink",
                        replacement1person: "Replace every 6 months",
                        replacement2person: "Replace every 4 months",
                        replacement3person: "Replace every 3 months",
                        replacement4person: "Replace every 2 months",
                        productTitle: "Water Pitcher with Affinity Filtration Technology",
                        productSubTitle: "Get clean and safe water on-the-go with our double-walled bottle",
                        productPrice: "$XX.XX",
                        ctaCopy: "Shop Now",
                        ctaUrl: "#",
                        linkCopy: "Replacement Filters",
                        linkUrl: "#"
                    }, 
                ]
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/ProductFilterReplacement/ProductFilterReplacement.jsx




function ProductFilterReplacement(param) {
    var cms = param.cms;
    var ref, ref1;
    var eyebrow = cms.eyebrow, header = cms.header, copy = cms.copy, productFilterReplacementItems = cms.productFilterReplacementItems;
    var ref2 = (0,react.useState)(0), activeIndex = ref2[0], setActiveIndex = ref2[1];
    var ref3 = (0,react.useState)(productFilterReplacementItems.length > 0 ? productFilterReplacementItems[0] : null), activeItem = ref3[0], setActiveItem = ref3[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative mx-auto bg-[#dfecf6] py-11 lg:py-24",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-contained mx-auto mb-12 max-w-[1440px] border-b border-[#ccd8e3] text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Eyebrow */.j4, {
                        className: "mb-4",
                        children: eyebrow
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                        variant: "h3",
                        className: "mb-4",
                        children: header
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Body */.uT, {
                        className: "mx-auto max-w-4xl pb-12",
                        children: copy
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-contained",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Eyebrow */.j4, {
                        className: "mb-4 lg:text-center",
                        children: "CHOOSE YOUR FILTER:"
                    }),
                    productFilterReplacementItems.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "overflow-auto scrollbar-hide",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mx-auto flex flex-row flex-nowrap items-center lg:justify-center",
                            children: productFilterReplacementItems.slice(0, 4).map(function(param, index) {
                                var text = param.header;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: "mx-2 cursor-pointer whitespace-nowrap rounded-full px-[2.125rem] py-[0.706rem] pb-[0.75rem] text-center font-sans text-[17px] shadow-[inset_0px_0px_0px_1px_#202635] hover:bg-[#202635] focus:bg-[#3383C5] lg:w-auto\n                    ".concat(activeIndex === index ? "border border-transparent bg-[#202635] text-white" : "border border-text bg-[transparent] text-text hover:text-white"),
                                    onClick: function() {
                                        setActiveIndex(index);
                                        setActiveItem(productFilterReplacementItems[index]);
                                    },
                                    onKeyDown: function() {
                                        setActiveIndex(index);
                                        setActiveItem(productFilterReplacementItems[index]);
                                    },
                                    children: text
                                }, index);
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-contained mx-auto mb-12 mt-12 max-w-7xl lg:flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative overflow-hidden lg:block lg:w-1/2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                className: "absolute mx-auto w-full",
                                fill: true,
                                src: "https://cdn.shopify.com/s/files/1/1011/0318/files/Mask_20group_20_2835_29.png?v=1684277231"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative px-4 py-16 lg:px-12 lg:py-28",
                                children: (activeItem === null || activeItem === void 0 ? void 0 : activeItem.replacementOptions) && (activeItem === null || activeItem === void 0 ? void 0 : (ref = activeItem.replacementOptions) === null || ref === void 0 ? void 0 : ref.length) && (activeItem === null || activeItem === void 0 ? void 0 : (ref1 = activeItem.replacementOptions) === null || ref1 === void 0 ? void 0 : ref1.map(function(replacementOption, replacementOptionIndex) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mb-8 flex w-full items-center justify-between border-b border-[rgba(255,255,255,0.1)] pb-8 lg:mb-24 lg:border-0 lg:pb-0",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-col text-center lg:pr-6",
                                                children: [
                                                    /* 1 Person */ (replacementOption === null || replacementOption === void 0 ? void 0 : replacementOption.numberOfPeople) && (replacementOption === null || replacementOption === void 0 ? void 0 : replacementOption.numberOfPeople) === "1" && /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                        width: "32",
                                                        height: "32",
                                                        viewBox: "0 0 32 32",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M28.8652 27.4995C28.7774 27.6515 28.6512 27.7778 28.4991 27.8656C28.347 27.9533 28.1746 27.9995 27.999 27.9995H3.99897C3.82353 27.9993 3.65121 27.953 3.49933 27.8651C3.34746 27.7773 3.22137 27.651 3.13372 27.4991C3.04607 27.3471 2.99995 27.1747 3 26.9992C3.00005 26.8238 3.04625 26.6514 3.13397 26.4995C5.03772 23.2082 7.97147 20.8482 11.3952 19.7295C9.70168 18.7213 8.38591 17.1851 7.64996 15.3567C6.91401 13.5284 6.79858 11.509 7.3214 9.60869C7.84422 7.70838 8.97638 6.03224 10.544 4.83765C12.1116 3.64306 14.0281 2.99609 15.999 2.99609C17.9699 2.99609 19.8863 3.64306 21.4539 4.83765C23.0216 6.03224 24.1537 7.70838 24.6765 9.60869C25.1994 11.509 25.0839 13.5284 24.348 15.3567C23.612 17.1851 22.2963 18.7213 20.6027 19.7295C24.0265 20.8482 26.9602 23.2082 28.864 26.4995C28.9519 26.6514 28.9984 26.8238 28.9986 26.9993C28.9988 27.1749 28.9528 27.3474 28.8652 27.4995Z",
                                                            fill: "white"
                                                        })
                                                    }),
                                                    /* 2 People */ (replacementOption === null || replacementOption === void 0 ? void 0 : replacementOption.numberOfPeople) && (replacementOption === null || replacementOption === void 0 ? void 0 : replacementOption.numberOfPeople) === "2" && /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                        width: "32",
                                                        height: "32",
                                                        viewBox: "0 0 32 32",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M20.5611 24.4529C20.6595 24.6038 20.7153 24.7784 20.7227 24.9584C20.73 25.1384 20.6886 25.317 20.6028 25.4754C20.517 25.6338 20.39 25.7661 20.2353 25.8582C20.0805 25.9504 19.9038 25.9991 19.7236 25.9991H1.28113C1.101 25.9991 0.924218 25.9504 0.769465 25.8582C0.614713 25.7661 0.487735 25.6338 0.401946 25.4754C0.316157 25.317 0.274743 25.1384 0.28208 24.9584C0.289417 24.7784 0.345232 24.6038 0.443628 24.4529C1.85126 22.2862 3.92174 20.6327 6.34613 19.7391C5.00588 18.8469 3.98834 17.547 3.444 16.0317C2.89966 14.5164 2.85741 12.8662 3.32349 11.325C3.78958 9.78386 4.73926 8.4336 6.03209 7.47392C7.32493 6.51424 8.89228 5.99609 10.5024 5.99609C12.1125 5.99609 13.6798 6.51424 14.9727 7.47392C16.2655 8.4336 17.2152 9.78386 17.6813 11.325C18.1474 12.8662 18.1051 14.5164 17.5608 16.0317C17.0164 17.547 15.9989 18.8469 14.6586 19.7391C17.083 20.6327 19.1535 22.2862 20.5611 24.4529ZM31.5499 24.4341C30.1419 22.2765 28.076 20.6302 25.6586 19.7391C27.2409 18.6733 28.3575 17.0446 28.7812 15.1846C29.2049 13.3245 28.9039 11.3729 27.9394 9.72692C26.9749 8.08098 25.4194 6.86443 23.5896 6.32492C21.7597 5.78541 19.7931 5.96348 18.0899 6.82289C18.0248 6.85651 17.9678 6.90405 17.9231 6.96212C17.8784 7.0202 17.847 7.0874 17.8311 7.15895C17.8153 7.23051 17.8153 7.30468 17.8313 7.37622C17.8473 7.44775 17.8788 7.51489 17.9236 7.57289C19.1901 9.15265 19.9174 11.0964 19.9991 13.1195C20.0807 15.1426 19.5124 17.1387 18.3774 18.8154C18.304 18.925 18.2769 19.0591 18.302 19.1885C18.327 19.318 18.4022 19.4323 18.5111 19.5066C19.991 20.5395 21.2579 21.8479 22.2424 23.3604C22.6394 23.9685 22.8016 24.7003 22.6986 25.4191C22.687 25.4906 22.6911 25.5638 22.7106 25.6336C22.7301 25.7034 22.7645 25.7681 22.8115 25.8232C22.8584 25.8784 22.9168 25.9227 22.9826 25.9531C23.0483 25.9834 23.1199 25.9992 23.1924 25.9991H30.7299C30.9501 25.9992 31.1641 25.9266 31.3389 25.7926C31.5136 25.6585 31.6392 25.4706 31.6961 25.2579C31.7309 25.118 31.7358 24.9724 31.7106 24.8305C31.6854 24.6885 31.6307 24.5535 31.5499 24.4341Z",
                                                            fill: "white"
                                                        })
                                                    }),
                                                    /* 3-4 People */ (replacementOption === null || replacementOption === void 0 ? void 0 : replacementOption.numberOfPeople) && (replacementOption === null || replacementOption === void 0 ? void 0 : replacementOption.numberOfPeople) === "3-4" && /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                        width: "32",
                                                        height: "32",
                                                        viewBox: "0 0 32 32",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M8.01306 18.4752C8.01645 18.5429 8.00603 18.6106 7.98242 18.6742C7.95882 18.7378 7.92253 18.7959 7.87576 18.845C7.82898 18.8941 7.77271 18.9332 7.71036 18.9599C7.64801 18.9866 7.58088 19.0003 7.51306 19.0002H1.99806C1.77235 19.0005 1.55317 18.9245 1.37615 18.7845C1.19913 18.6445 1.07469 18.4487 1.02306 18.2289C0.990912 18.0786 0.992394 17.9229 1.0274 17.7732C1.06241 17.6234 1.13007 17.4832 1.22556 17.3627C2.10782 16.1927 3.27842 15.2714 4.62306 14.6889C4.03272 14.1507 3.57994 13.4788 3.30266 12.7296C3.02537 11.9804 2.93164 11.1756 3.02933 10.3828C3.12701 9.58987 3.41326 8.83193 3.86411 8.17242C4.31495 7.51291 4.91727 6.97103 5.6206 6.59217C6.32393 6.2133 7.1078 6.00849 7.90657 5.99487C8.70534 5.98125 9.49574 6.15923 10.2116 6.51389C10.9274 6.86856 11.5478 7.38959 12.0209 8.03335C12.494 8.6771 12.8059 9.42484 12.9306 10.2139C12.9467 10.3201 12.9276 10.4285 12.8764 10.5228C12.8252 10.6172 12.7446 10.6922 12.6468 10.7364C11.2598 11.3777 10.0851 12.4022 9.26144 13.6893C8.43774 14.9763 7.99937 16.4721 7.99806 18.0002C7.99806 18.1602 7.99806 18.3177 8.01306 18.4752ZM30.7631 17.3614C29.8828 16.1928 28.7149 15.272 27.3731 14.6889C27.9634 14.1507 28.4162 13.4788 28.6935 12.7296C28.9708 11.9804 29.0645 11.1756 28.9668 10.3828C28.8691 9.58987 28.5829 8.83193 28.132 8.17242C27.6812 7.51291 27.0789 6.97103 26.3755 6.59217C25.6722 6.2133 24.8883 6.00849 24.0896 5.99487C23.2908 5.98125 22.5004 6.15923 21.7845 6.51389C21.0687 6.86856 20.4483 7.38959 19.9752 8.03335C19.5021 8.6771 19.1902 9.42484 19.0656 10.2139C19.0495 10.3201 19.0685 10.4285 19.1197 10.5228C19.1709 10.6172 19.2515 10.6922 19.3493 10.7364C20.7363 11.3777 21.911 12.4022 22.7347 13.6893C23.5584 14.9763 23.9967 16.4721 23.9981 18.0002C23.9981 18.1602 23.9981 18.3177 23.9831 18.4752C23.9797 18.5429 23.9901 18.6106 24.0137 18.6742C24.0373 18.7378 24.0736 18.7959 24.1204 18.845C24.1671 18.8941 24.2234 18.9332 24.2858 18.9599C24.3481 18.9866 24.4152 19.0003 24.4831 19.0002H29.9981C30.2238 19.0005 30.4429 18.9245 30.62 18.7845C30.797 18.6445 30.9214 18.4487 30.9731 18.2289C31.0054 18.0783 31.0039 17.9223 30.9687 17.7723C30.9334 17.6223 30.8653 17.482 30.7693 17.3614H30.7631ZM19.6381 22.7589C20.6337 21.9964 21.3655 20.941 21.7304 19.7411C22.0953 18.5413 22.075 17.2572 21.6724 16.0694C21.2698 14.8817 20.5052 13.8499 19.4859 13.1191C18.4667 12.3884 17.2441 11.9954 15.9899 11.9954C14.7358 11.9954 13.5132 12.3884 12.4939 13.1191C11.4747 13.8499 10.71 14.8817 10.3075 16.0694C9.90488 17.2572 9.88462 18.5413 10.2495 19.7411C10.6144 20.941 11.3461 21.9964 12.3418 22.7589C10.575 23.5245 9.09964 24.8355 8.13181 26.5002C8.04403 26.6522 7.99783 26.8247 7.99784 27.0002C7.99785 27.1758 8.04407 27.3483 8.13187 27.5003C8.21966 27.6523 8.34593 27.7785 8.49798 27.8663C8.65003 27.9541 8.8225 28.0002 8.99806 28.0002H22.9981C23.1736 28.0002 23.3461 27.9541 23.4981 27.8663C23.6502 27.7785 23.7765 27.6523 23.8643 27.5003C23.952 27.3483 23.9983 27.1758 23.9983 27.0002C23.9983 26.8247 23.9521 26.6522 23.8643 26.5002C22.8944 24.8345 21.4163 23.5233 19.6468 22.7589H19.6381Z",
                                                            fill: "white"
                                                        })
                                                    }),
                                                    /* 5+ People */ (replacementOption === null || replacementOption === void 0 ? void 0 : replacementOption.numberOfPeople) && (replacementOption === null || replacementOption === void 0 ? void 0 : replacementOption.numberOfPeople) !== "1" && (replacementOption === null || replacementOption === void 0 ? void 0 : replacementOption.numberOfPeople) !== "2" && (replacementOption === null || replacementOption === void 0 ? void 0 : replacementOption.numberOfPeople) !== "3-4" && /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        width: "32",
                                                        height: "32",
                                                        viewBox: "0 0 32 32",
                                                        fill: "none",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                            d: "M28.8 27.3992C28.9118 27.5477 28.9799 27.7245 28.9968 27.9097C29.0137 28.0948 28.9786 28.281 28.8955 28.4474C28.8124 28.6137 28.6846 28.7535 28.5264 28.8512C28.3682 28.9489 28.1859 29.0006 28 29.0004H4C3.81429 29.0004 3.63225 28.9487 3.47427 28.8511C3.31629 28.7534 3.18863 28.6137 3.10557 28.4476C3.02252 28.2815 2.98736 28.0956 3.00404 27.9106C3.02072 27.7257 3.08857 27.549 3.2 27.4004C4.08548 26.2133 5.26628 25.2785 6.625 24.6892C5.88022 24.0094 5.35837 23.1204 5.12794 22.1387C4.8975 21.1571 4.96926 20.1287 5.33379 19.1885C5.69832 18.2484 6.33858 17.4404 7.17054 16.8707C8.0025 16.301 8.98728 15.9961 9.99563 15.9961C11.004 15.9961 11.9887 16.301 12.8207 16.8707C13.6527 17.4404 14.2929 18.2484 14.6575 19.1885C15.022 20.1287 15.0937 21.1571 14.8633 22.1387C14.6329 23.1204 14.111 24.0094 13.3663 24.6892C14.3465 25.1129 15.2373 25.7191 15.9913 26.4754C16.7452 25.7191 17.636 25.1129 18.6162 24.6892C17.8715 24.0094 17.3496 23.1204 17.1192 22.1387C16.8888 21.1571 16.9605 20.1287 17.325 19.1885C17.6896 18.2484 18.3298 17.4404 19.1618 16.8707C19.9938 16.301 20.9785 15.9961 21.9869 15.9961C22.9952 15.9961 23.98 16.301 24.812 16.8707C25.6439 17.4404 26.2842 18.2484 26.6487 19.1885C27.0132 20.1287 27.085 21.1571 26.8546 22.1387C26.6241 23.1204 26.1023 24.0094 25.3575 24.6892C26.7225 25.2754 27.9097 26.2099 28.8 27.3992ZM3.4 15.8004C3.50506 15.8792 3.62461 15.9366 3.75182 15.9691C3.87903 16.0017 4.01142 16.009 4.14142 15.9904C4.27142 15.9718 4.39649 15.9278 4.50949 15.8609C4.62249 15.794 4.72121 15.7055 4.8 15.6004C5.40546 14.7932 6.19055 14.1379 7.09311 13.6867C7.99567 13.2354 8.99091 13.0004 10 13.0004C11.0091 13.0004 12.0043 13.2354 12.9069 13.6867C13.8094 14.1379 14.5945 14.7932 15.2 15.6004C15.2931 15.7246 15.4139 15.8254 15.5528 15.8949C15.6916 15.9643 15.8448 16.0004 16 16.0004C16.1552 16.0004 16.3084 15.9643 16.4472 15.8949C16.5861 15.8254 16.7069 15.7246 16.8 15.6004C17.4055 14.7932 18.1906 14.1379 19.0931 13.6867C19.9957 13.2354 20.9909 13.0004 22 13.0004C23.0091 13.0004 24.0043 13.2354 24.9069 13.6867C25.8095 14.1379 26.5945 14.7932 27.2 15.6004C27.2789 15.7055 27.3777 15.794 27.4907 15.8609C27.6038 15.9277 27.729 15.9717 27.859 15.9902C27.9891 16.0087 28.1215 16.0014 28.2488 15.9688C28.376 15.9361 28.4956 15.8787 28.6006 15.7998C28.7057 15.7209 28.7942 15.6221 28.8611 15.5091C28.9279 15.396 28.9719 15.2708 28.9904 15.1408C29.0089 15.0107 29.0016 14.8783 28.969 14.751C28.9363 14.6238 28.8789 14.5042 28.8 14.3992C27.9145 13.2123 26.7337 12.278 25.375 11.6892C26.1198 11.0094 26.6416 10.1204 26.8721 9.13873C27.1025 8.15707 27.0307 7.12867 26.6662 6.18853C26.3017 5.24839 25.6614 4.44043 24.8295 3.8707C23.9975 3.30097 23.0127 2.99609 22.0044 2.99609C20.996 2.99609 20.0113 3.30097 19.1793 3.8707C18.3473 4.44043 17.7071 5.24839 17.3425 6.18853C16.978 7.12867 16.9063 8.15707 17.1367 9.13873C17.3671 10.1204 17.889 11.0094 18.6338 11.6892C17.6535 12.1129 16.7627 12.7191 16.0088 13.4754C15.2548 12.7191 14.364 12.1129 13.3837 11.6892C14.1285 11.0094 14.6504 10.1204 14.8808 9.13873C15.1112 8.15707 15.0395 7.12867 14.675 6.18853C14.3104 5.24839 13.6702 4.44043 12.8382 3.8707C12.0062 3.30097 11.0215 2.99609 10.0131 2.99609C9.00479 2.99609 8.02 3.30097 7.18804 3.8707C6.35608 4.44043 5.71582 5.24839 5.35129 6.18853C4.98676 7.12867 4.915 8.15707 5.14544 9.13873C5.37587 10.1204 5.89772 11.0094 6.6425 11.6892C5.2774 12.2759 4.09032 13.2109 3.2 14.4004C3.12121 14.5055 3.06388 14.625 3.03129 14.7522C2.9987 14.8795 2.99148 15.0118 3.01005 15.1419C3.02862 15.2719 3.07262 15.3969 3.13953 15.5099C3.20643 15.6229 3.29494 15.7216 3.4 15.8004Z",
                                                            fill: "white"
                                                        })
                                                    }),
                                                    (replacementOption === null || replacementOption === void 0 ? void 0 : replacementOption.numberOfPeople) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "mt-1 text-xs font-light text-white lg:text-base",
                                                        children: [
                                                            replacementOption === null || replacementOption === void 0 ? void 0 : replacementOption.numberOfPeople,
                                                            " ",
                                                            (replacementOption === null || replacementOption === void 0 ? void 0 : replacementOption.numberOfPeople) && (replacementOption === null || replacementOption === void 0 ? void 0 : replacementOption.numberOfPeople) === "1" ? "Person" : "People"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            (replacementOption === null || replacementOption === void 0 ? void 0 : replacementOption.replacementFrequency) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(snippets/* Headline */.s0, {
                                                variant: "h5",
                                                className: "text-center text-base font-light text-white lg:w-9/12 lg:text-2xl",
                                                children: [
                                                    "Replace every",
                                                    " ",
                                                    replacementOption === null || replacementOption === void 0 ? void 0 : replacementOption.replacementFrequency
                                                ]
                                            })
                                        ]
                                    }, "replacement-option-".concat(replacementOptionIndex));
                                }))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative flex-col items-center overflow-hidden bg-[#E6F0F8] py-14 lg:flex lg:w-1/2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col-reverse gap-4 md:flex-col",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            activeItem.productTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                                                variant: "h4",
                                                className: "mx-auto mb-6 w-9/12 text-center font-light",
                                                children: activeItem.productTitle
                                            }),
                                            activeItem.productSubTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Body */.uT, {
                                                className: "mx-auto mb-4 w-11/12 text-center",
                                                children: activeItem.productSubTitle
                                            }),
                                            activeItem.productPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Body */.uT, {
                                                className: "text-center",
                                                children: activeItem.productPrice
                                            })
                                        ]
                                    }),
                                    activeItem.productImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                        className: "mx-auto mix-blend-multiply",
                                        sizes: "48px",
                                        width: "300px",
                                        height: "300px",
                                        src: activeItem.productImage.src
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mt-6 flex flex-col items-center justify-center lg:flex-row",
                                children: [
                                    activeItem.ctaCopy && activeItem.ctaUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mb-4 lg:mb-0 lg:pr-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Button */.zx, {
                                            href: activeItem.ctaUrl,
                                            theme: "primary",
                                            variant: "filled",
                                            children: activeItem.ctaCopy
                                        })
                                    }),
                                    activeItem.linkCopy && activeItem.linkUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                                        "aria-label": activeItem.linkCopy,
                                        className: "underline underline-offset-4",
                                        href: activeItem.linkUrl,
                                        children: activeItem.linkCopy
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
ProductFilterReplacement.displayName = "ProductFilterReplacements";
ProductFilterReplacement.Schema = ProductFilterReplacement_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/ProductFilterReplacement/index.js


;// CONCATENATED MODULE: ./src/sections/ProductOverview/ProductOverview.schema.js
function ProductOverview_schema_Schema() {
    return {
        label: "Product Overview & Features",
        key: "productOverviewFeatures",
        category: "Product",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/product-overview-features.png",
        fields: [
            {
                name: "eyebrow",
                component: "text",
                label: "Eyebrow Text"
            },
            {
                name: "heading",
                component: "text",
                label: "Heading"
            },
            {
                label: "Featured Image",
                name: "image",
                component: "image"
            },
            {
                label: "Image Alignment",
                name: "imageAlignment",
                component: "select",
                options: [
                    {
                        label: "Left",
                        value: "left"
                    },
                    {
                        label: "Right",
                        value: "right"
                    }, 
                ],
                defaultValue: "left"
            },
            {
                name: "promoHeading",
                component: "text",
                label: "Promo Heading"
            },
            {
                name: "promoItems",
                component: "group-list",
                label: "Promo Items",
                itemProps: {
                    label: "{{item.promoItem}}"
                },
                fields: [
                    {
                        name: "promoItem",
                        component: "text",
                        label: "Promo Item"
                    }, 
                ]
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/ProductOverview/ProductOverview.jsx



function ProductOverview(param) {
    var cms = param.cms;
    var eyebrow = cms.eyebrow, heading = cms.heading, image = cms.image, imageAlignment = cms.imageAlignment, promoHeading = cms.promoHeading, promoItems = cms.promoItems;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "px-contained mx-auto max-w-[var(--content-max-width)] pb-[30px] pt-[60px] md:pt-[90px] md:pb-[45px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "overview-header mx-auto max-w-[1024px] pb-[60px] text-center md:pb-[90px]",
                children: [
                    eyebrow && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Eyebrow */.j4, {
                        className: "mb-4 uppercase",
                        children: eyebrow
                    }),
                    heading && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                        variant: "h4",
                        element: "h2",
                        children: heading
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "overview-content grid grid-cols-1 lg:grid-cols-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "content-column order-1 flex items-center bg-[#E6F0F8] p-[36px] md:px-[50px] md:py-[100px] lg:aspect-square ".concat(imageAlignment === "left" ? "lg:order-1" : "lg:order-0"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                promoHeading && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                                    variant: "h4",
                                    element: "h2",
                                    children: promoHeading
                                }),
                                (promoItems === null || promoItems === void 0 ? void 0 : promoItems.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "mt-[40px] grid grid-cols-1 gap-[28px]",
                                    children: promoItems.map(function(item, itemIndex) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            className: "flex items-start gap-[20px] text-lg font-[350] leading-[1]",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                                                    className: "flex-[0_0_16px] text-secondary",
                                                    src: "/svgs/circle-check.svg#circle-check",
                                                    title: item === null || item === void 0 ? void 0 : item.promoItem,
                                                    viewBox: "0 0 18 18"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Body */.uT, {
                                                    variant: "medium",
                                                    children: item === null || item === void 0 ? void 0 : item.promoItem
                                                })
                                            ]
                                        }, "promo-item-".concat(itemIndex));
                                    })
                                })
                            ]
                        })
                    }),
                    image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "image-column order-0 relative max-lg:aspect-square ".concat(imageAlignment === "left" ? "lg:order-0" : "lg:order-1"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                            src: image === null || image === void 0 ? void 0 : image.src,
                            alt: heading,
                            fill: true,
                            sizes: "(min-width: 991px) 60vw, 100vw",
                            className: "object-cover"
                        })
                    })
                ]
            })
        ]
    });
}
ProductOverview.displayName = "ProductOverview";
ProductOverview.Schema = ProductOverview_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/ProductOverview/index.js


// EXTERNAL MODULE: ./src/snippets/ProductItem/ColorVariantSelector/index.js + 3 modules
var ColorVariantSelector = __webpack_require__(5900);
// EXTERNAL MODULE: ./src/snippets/ProductItem/ProductItemMedia/ProductItemMedia.jsx + 2 modules
var ProductItemMedia = __webpack_require__(8766);
;// CONCATENATED MODULE: ./src/utils/schemas/body.js
var body = {
    label: "Body",
    name: "body",
    component: "text",
    defaultValue: "Get clean and safe water on-the-go with our double-walled bottle"
};
/* harmony default export */ var schemas_body = (body);

;// CONCATENATED MODULE: ./src/sections/ProductPromoBannerCarousel/ProductPromoBannerCarousel.schema.js



var banner = [
    {
        label: "Video URL",
        name: "videoUrl",
        description: "If a video is provided, it will be used instead of the image",
        defaultValue: "https://cdn.shopify.com/videos/c/o/v/865f2843e03344b1abdd4193e9e5c34d.mp4",
        component: "text"
    },
    {
        label: "Image",
        name: "image",
        description: "If a video is provided, it will be used instead of the image",
        component: "image"
    },
    {
        label: "Offer",
        name: "offer",
        component: "group",
        fields: [
            schemas_headline,
            schemas_body,
            {
                label: "Product",
                component: "productSearch",
                name: "productName"
            },
            {
                label: "Price",
                name: "price",
                component: "text"
            },
            {
                label: "Image",
                name: "image",
                component: "image"
            },
            {
                label: "Multiply image?",
                description: "Add mix-blend-mode: multiply to image",
                name: "multiplyImage",
                component: "toggle",
                toggleLabels: {
                    true: "On",
                    false: "Off"
                }
            },
            {
                label: "Calls to Action",
                name: "ctas",
                component: "group-list",
                description: "Max of two buttons",
                itemProps: {
                    label: "{{item.link.text}}"
                },
                defaultItem: {
                    link: {
                        text: "Shop All",
                        url: ""
                    },
                    theme: "primary",
                    variant: "filled"
                },
                validate: {
                    maxItems: 2
                },
                fields: [
                    {
                        label: "Link",
                        name: "link",
                        component: "link"
                    },
                    {
                        label: "Regular Link",
                        name: "isRegularLink",
                        component: "toggle",
                        defaultValue: false,
                        description: "Display the link as a regular underlined link. Ignores the button Theme and Variant settings below when enabled."
                    },
                    {
                        label: "Button Theme",
                        name: "theme",
                        component: "select",
                        options: [
                            {
                                label: "Primary",
                                value: "primary"
                            },
                            {
                                label: "Secondary",
                                value: "secondary"
                            },
                            {
                                label: "Light",
                                value: "light"
                            }, 
                        ]
                    },
                    {
                        label: "Button Variant",
                        name: "variant",
                        component: "select",
                        options: [
                            {
                                label: "Filled",
                                value: "filled"
                            },
                            {
                                label: "Outlined",
                                value: "outlined"
                            }, 
                        ]
                    }, 
                ]
            }, 
        ]
    }, 
];
var banners = {
    label: "Banners",
    name: "banners",
    component: "group-list",
    fields: banner
};
function ProductPromoBannerCarousel_schema_Schema() {
    return {
        label: "Product Promo Banner Carousel",
        key: "productPromoBannerCarousel",
        category: "Product",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/product_promo_banner.png?v=1686314381",
        fields: [
            schemas_eyebrow,
            schemas_headline,
            banners
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/ProductPromoBannerCarousel/ProductPromoBannerCarousel.jsx











function Banner(param) {
    var videoUrl = param.videoUrl, image = param.image, offer = param.offer;
    var ref, ref1, ref2;
    var swatchesMap = (0,hooks/* useColorSwatches */.Bb)().swatchesMap;
    var product = (0,dist.useProductByHandle)({
        handle: offer === null || offer === void 0 ? void 0 : (ref = offer.productName) === null || ref === void 0 ? void 0 : ref.handle
    }).product;
    var ref3 = (0,react.useState)(null), variantFromColor = ref3[0], setVariantFromColor = ref3[1];
    var variant = variantFromColor || (product === null || product === void 0 ? void 0 : (ref1 = product.variants) === null || ref1 === void 0 ? void 0 : ref1[0]);
    var productUrl = variant ? "/products/".concat((ref2 = variant.product) === null || ref2 === void 0 ? void 0 : ref2.handle, "?variant=").concat(variant.legacyResourceId) : "";
    var _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col lg:h-[45.125rem] lg:flex-row",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex-1",
                children: [
                    videoUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                        src: videoUrl,
                        autoPlay: true,
                        loop: true,
                        muted: true,
                        className: "h-full w-full object-cover"
                    }),
                    !videoUrl && image && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                        width: 650,
                        height: 750,
                        className: "h-full w-full object-cover",
                        alt: (_alt = image.alt) !== null && _alt !== void 0 ? _alt : "".concat(offer === null || offer === void 0 ? void 0 : offer.headline, " Image"),
                        src: image.src
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex h-full w-full flex-1 items-center justify-center bg-[#E6F0F8] px-5 py-10 lg:px-0 lg:py-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "max-w-[520px]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "order-2 grid gap-4 text-center lg:order-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                                        variant: "h4",
                                        children: offer === null || offer === void 0 ? void 0 : offer.headline
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Body */.uT, {
                                        variant: "medium",
                                        children: offer === null || offer === void 0 ? void 0 : offer.body
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Body */.uT, {
                                        variant: "medium",
                                        children: offer === null || offer === void 0 ? void 0 : offer.price
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "pointer-events-none relative order-1 h-48 select-none lg:order-2 lg:h-60",
                                style: {
                                    mixBlendMode: (offer === null || offer === void 0 ? void 0 : offer.multiplyImage) ? "multiply" : "normal"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative flex h-full items-center justify-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductItemMedia/* ProductItemMedia */.V, {
                                        disableHoverEffect: true,
                                        disableBackground: true,
                                        product: product,
                                        variant: variant
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "order-2 mt-[-20px] flex justify-center lg:order-3 lg:mt-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorVariantSelector/* ColorVariantSelector */.A, {
                                    className: "mb-2 mt-[22px]",
                                    enabledColorNameOnHover: false,
                                    product: product,
                                    setVariantFromColor: setVariantFromColor,
                                    swatchesMap: swatchesMap,
                                    variantFromColor: variantFromColor
                                })
                            }),
                            (offer === null || offer === void 0 ? void 0 : offer.ctas) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "cta-group order-3 flex items-center justify-center gap-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Button */.zx, {
                                        href: productUrl,
                                        theme: "primary",
                                        variant: "filled",
                                        children: "Shop now"
                                    }),
                                    offer === null || offer === void 0 ? void 0 : offer.ctas.filter(function(cta) {
                                        return "link" in cta;
                                    }).map(function(cta, index) {
                                        if (cta === null || cta === void 0 ? void 0 : cta.isRegularLink) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                                                className: "text-primary underline underline-offset-2 max-md:text-[14px]",
                                                href: cta.link.url,
                                                children: cta.link.text
                                            }, index);
                                        }
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Button */.zx, {
                                            href: cta.link.url,
                                            variant: cta.variant,
                                            theme: cta.theme,
                                            children: cta.link.text
                                        }, index);
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}
function ProductPromoBannerCarousel(param) {
    var cms = param.cms;
    var eyebrow = cms.eyebrow, headline = cms.headline, banners = cms.banners;
    var isDesktop = utils_useMediaQuery("(min-width: 1024px)");
    var ref = (0,react.useState)(false), renderClientSideComponent = ref[0], setRenderClientSideComponent = ref[1];
    (0,react.useEffect)(function() {
        setRenderClientSideComponent(true);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "my-8 lg:my-20",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "px-contained mx-auto max-w-[var(--content-max-width)]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mb-20 flex flex-col gap-10 text-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Eyebrow */.j4, {
                            children: eyebrow
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                            variant: "h2",
                            className: "md:!text-[42px]",
                            children: headline
                        })
                    ]
                }),
                renderClientSideComponent ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* default */.Z, {
                        children: banners.map(function(banner, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner, (0,_object_spread/* default */.Z)({}, banner), index);
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grid gap-10",
                        children: banners.map(function(banner, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner, (0,_object_spread/* default */.Z)({}, banner), index);
                        })
                    })
                }) : null
            ]
        })
    });
}
ProductPromoBannerCarousel.Schema = ProductPromoBannerCarousel_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/ProductPromoBannerCarousel/index.js


// EXTERNAL MODULE: ./src/snippets/Typography/Eyebrow.jsx
var Eyebrow = __webpack_require__(8544);
;// CONCATENATED MODULE: ./src/sections/ProductSteps/ProductSteps.schema.js




var slides = {
    label: "Slides",
    name: "slides",
    component: "group-list",
    fields: [
        {
            label: "Step text",
            name: "stepText",
            component: "text",
            description: "e.g. Step 01, Step 02, Step 03",
            defaultValue: "Step ##",
            required: true
        },
        {
            label: "Image",
            name: "image",
            component: "image",
            defaultValue: "https://cdn.shopify.com/s/files/1/1011/0318/files/larq-bottle-insulated_promo-card_anim_v_201.png",
            required: true
        },
        {
            label: "Video URL",
            name: "videoUrl",
            description: "Replaces Image if set. Video will always be muted and autoplay with loop",
            component: "text"
        },
        {
            label: "Heading",
            name: "heading",
            component: "text",
            defaultValue: "Step One: Woven Mesh Screen",
            required: true
        },
        {
            label: "Content",
            name: "content",
            component: "markdown",
            defaultValue: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis.",
            required: true
        }, 
    ]
};
function ProductSteps_schema_Schema() {
    return {
        key: "product-steps",
        label: "Product Steps",
        category: "Product",
        fields: [
            {
                label: "Dark mode",
                name: "darkMode",
                component: "toggle",
                description: "Use dark mode for this slide",
                defaultValue: false
            },
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, schemas_eyebrow), {
                defaultValue: "HOW IT WORKS",
                required: true
            }),
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, schemas_headline), {
                defaultValue: "Dual-stage filtration technology removes harmful contaminants in 3 easy steps",
                required: true
            }),
            slides, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/ProductSteps/ProductStepsContent.jsx




/**
 * @typedef Image
 * @type {object}
 * @property {string} src - The image source.
 * @property {string} alt - The image alt text.
 */ /**
 * @typedef Step
 * @type {object}
 * @property {string} stepText - The step text.
 * @property {Image} image - The image.
 * @property {string} heading - The heading.
 * @property {string} content - The content.
 */ /**
 * Step carousel/slider made for product detail page.
 * @param {object} props - The props that were defined by the caller of this component.
 * @param {Array.<Step>} props.steps - The content that will came from PACK.
 * @param {number} props.currentStep - The current slide.
 * @param {function} props.setCurrentSlide - The current slide setter.
 *
 * @component
 * @example
 * const images = cms.images;
 * return (
 *  <ProductStepsContent
 *    images={images}
 *    onChange={console.log}
 *  />
 * )
 */ function ProductStepsContent(param) {
    var steps = param.steps, currentStep = param.currentStep, setCurrentSlide = param.setCurrentSlide;
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative mx-auto mb-8 flex max-w-[680px] items-center justify-between gap-x-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute inset-0 flex items-center opacity-10",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "h-[1px] w-full bg-black dark:bg-white dark:opacity-30"
                        })
                    }),
                    steps.map(function(step, index) {
                        var ref;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("span", {
                            role: "button",
                            onClick: function() {
                                return currentStep !== index && setCurrentSlide(index);
                            },
                            tabIndex: 0,
                            onKeyPress: function(e) {
                                return e.key === "Enter" && currentStep !== index && setCurrentSlide(index);
                            },
                            className: [
                                "relative inline-block cursor-pointer select-none rounded-full border px-4 py-1 pb-1.5 text-center lg:min-w-[120px] lg:pb-2",
                                index === currentStep ? "border-[#121D29] bg-[#121D29] text-[#FFFFFF] dark:bg-[#FFFFFF] dark:text-[#202635]" : "border-[#121d2970] bg-background text-[#121D2970] dark:border-[#ffffff3d] dark:bg-[#202635] dark:text-[#ffffff3d]", 
                            ].join(" "),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Eyebrow */.j4, {
                                children: (ref = step.stepText) === null || ref === void 0 ? void 0 : ref.toUpperCase()
                            })
                        }, index);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mx-auto max-w-[680px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-left",
                    children: [
                        (steps === null || steps === void 0 ? void 0 : (ref = steps[currentStep]) === null || ref === void 0 ? void 0 : ref.heading) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                            variant: "h5",
                            children: steps[currentStep].heading
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Body */.uT, {
                                element: "div",
                                variant: "medium",
                                children: (steps === null || steps === void 0 ? void 0 : (ref1 = steps[currentStep]) === null || ref1 === void 0 ? void 0 : ref1.content) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Markdown */.UG, {
                                    children: steps[currentStep].content
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
}
ProductStepsContent.propTypes = {
    /**
   * Images array
   */ steps: prop_types_default().arrayOf(prop_types_default().shape({
        stepText: (prop_types_default()).string.isRequired,
        heading: (prop_types_default()).string.isRequired,
        content: (prop_types_default()).string.isRequired,
        image: prop_types_default().oneOfType([
            prop_types_default().shape({
                src: (prop_types_default()).string,
                alt: (prop_types_default()).string
            }),
            (prop_types_default()).string, 
        ])
    })),
    currentStep: (prop_types_default()).number
};
ProductStepsContent.defaultProps = {
    steps: [],
    currentStep: 0
};
/* harmony default export */ var ProductSteps_ProductStepsContent = (ProductStepsContent);

;// CONCATENATED MODULE: ./src/sections/ProductSteps/ProductStepsImageCarousel.jsx





/**
 * @typedef Image
 * @type {object}
 * @property {string} src - The image source.
 * @property {string} alt - The image alt text.
 */ /**
 * @typedef OnChange
 * @type {function}
 * @param {number} index - The index of the current slide.
 */ /**
 * Step carousel/slider made for product detail page.
 * @param {object} props - The props that were defined by the caller of this component.
 * @param {Array.<Image>} props.images - The content that will came from PACK.
 * @param {OnChange} props.onChange - The onChange function.
 * @param {number} props.currentSlide - The current slide.
 *
 * @component
 * @example
 * const images = cms.images;
 * return (
 *  <ProductStepsImageCarousel
 *    images={images}
 *    onChange={console.log}
 *  />
 * )
 */ function ProductStepsImageCarousel(param) {
    var images = param.images, onChange = param.onChange, currentSlide = param.currentSlide;
    var ref;
    var slideArray = (ref = images.map(function(slide) {
        return {
            type: slide.type,
            url: typeof slide.item === "string" ? slide.item : slide.item.src
        };
    })) !== null && ref !== void 0 ? ref : [];
    var isMobile = utils_useMediaQuery("(max-width: 767px)");
    var ref1 = (0,react.useState)(false), showArrows = ref1[0], setShowArrows = ref1[1];
    (0,react.useEffect)(function() {
        setShowArrows(!isMobile);
    }, [
        isMobile
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "-mx-4 md:mx-0",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Carousel */.lr, {
            showArrows: showArrows,
            emulateTouch: true,
            showIndicators: false,
            onChange: onChange,
            selectedItem: currentSlide,
            children: slideArray.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative mx-auto h-[240px] w-full bg-[#EDF3F9] dark:bg-[#202635] md:h-[480px] md:max-w-[var(--content-max-width)] lg:h-[630px]",
                    children: item.url && (item.type === "image" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                        src: item.url,
                        alt: "Product step image",
                        fill: true,
                        style: {
                            objectFit: "contain"
                        }
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                        autoPlay: true,
                        muted: true,
                        loop: true,
                        playsInline: true,
                        className: "h-full w-full object-contain",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                            src: item.url,
                            type: "video/mp4"
                        })
                    }))
                }, index);
            })
        })
    });
}
ProductStepsImageCarousel.propTypes = {
    /**
   * Images array
   */ images: prop_types_default().arrayOf(prop_types_default().shape({
        type: (prop_types_default()).string,
        item: prop_types_default().oneOfType([
            (prop_types_default()).string,
            prop_types_default().shape({
                src: (prop_types_default()).string,
                alt: (prop_types_default()).string
            }), 
        ])
    }))
};
ProductStepsImageCarousel.defaultProps = {
    images: []
};
/* harmony default export */ var ProductSteps_ProductStepsImageCarousel = (ProductStepsImageCarousel);

;// CONCATENATED MODULE: ./src/sections/ProductSteps/ProductSteps.jsx








/**
 * @typedef Image
 * @type {object}
 * @property {string} src - The image source.
 * @property {string} alt - The image alt text.
 */ /**
 * Step carousel/slider made for product detail page.
 * @param {object} props - The props that were defined by the caller of this component.
 * @param {object} props.cms - The content that will came from PACK.
 * @param {boolean} props.cms.darkMode - Dark mode toggle.
 * @param {string} props.cms.eyebrow - The eyebrow text.
 * @param {string} props.cms.headline - The headline text.
 * @param {Array.<{ stepText: String, image: Image, heading: String content: String }>} props.cms.slides - The slides array.
 * @param {object} props.cms.slides - The slides array.
 *
 * @component
 */ function ProductSteps(param) {
    var cms = param.cms;
    var eyebrow = cms.eyebrow, headline = cms.headline, slides = cms.slides, darkMode = cms.darkMode;
    var ref;
    var images = (0,react.useMemo)(function() {
        return (ref = slides === null || slides === void 0 ? void 0 : slides.map(function(slide) {
            if (slide.videoUrl) {
                return {
                    type: "video",
                    item: slide.videoUrl
                };
            }
            return {
                type: "image",
                item: slide.image
            };
        })) !== null && ref !== void 0 ? ref : [];
    }, [
        slides
    ]);
    var ref1 = (0,react.useState)(0), currentSlide = ref1[0], setCurrentSlide = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: darkMode ? "dark" : "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: "py-10 text-center dark:bg-[#202635] dark:text-[#ffffff] lg:py-40",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-contained mx-auto max-w-[var(--content-max-width)]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                        className: "mb-10 border-white opacity-20"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mx-auto mb-8 max-w-3xl",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Eyebrow/* default */.Z, {
                                children: eyebrow
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                                variant: "h4",
                                children: headline
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSteps_ProductStepsImageCarousel, {
                        images: images,
                        onChange: setCurrentSlide,
                        currentSlide: currentSlide
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSteps_ProductStepsContent, {
                        steps: slides,
                        currentStep: currentSlide,
                        setCurrentSlide: setCurrentSlide
                    })
                ]
            })
        })
    });
}
ProductSteps.propTypes = {
    /**
   * CMS content that came from PACK
   */ cms: prop_types_default().shape({
        eyebrow: (prop_types_default()).string.isRequired,
        headline: (prop_types_default()).string.isRequired,
        darkMode: (prop_types_default()).bool,
        slides: prop_types_default().arrayOf(prop_types_default().shape({
            stepText: (prop_types_default()).string.isRequired,
            image: prop_types_default().oneOfType([
                prop_types_default().shape({
                    src: (prop_types_default()).string,
                    alt: (prop_types_default()).string
                }),
                (prop_types_default()).string, 
            ]),
            heading: (prop_types_default()).string.isRequired,
            content: (prop_types_default()).string.isRequired
        }))
    })
};
ProductSteps.defaultProps = {
    cms: {
        eyebrow: "",
        headline: "",
        darkMode: false,
        slides: []
    }
};
ProductSteps.displayName = "ProductSteps";
ProductSteps.Schema = ProductSteps_schema_Schema;
/* harmony default export */ var ProductSteps_ProductSteps = (ProductSteps);

;// CONCATENATED MODULE: ./src/sections/ProductSupport/ProductSupport.schema.js
var videoContent = {
    label: "Video Settings",
    name: "videoResources",
    description: "Video Conent",
    component: "group-list",
    fields: [
        {
            label: "Video Title",
            name: "videotitle",
            component: "text",
            defaultValue: "Video Title"
        },
        {
            label: "Video Copy",
            name: "videocopy",
            component: "text",
            defaultValue: "Video Copy"
        },
        {
            label: "Video Image",
            name: "videoimage",
            component: "image",
            defaultValue: "https://cdn.shopify.com/s/files/1/1011/0318/files/Stainless_Steel_Fridge_Filter_700x_201.jpg?v=1686873500"
        },
        {
            label: "Video Vimeo ID",
            name: "videoid",
            component: "text",
            defaultValue: "286409603"
        }, 
    ],
    defaultValue: [
        {
            videotitle: "Video Title",
            videocopy: "Video Copy",
            videoimage: "https://cdn.shopify.com/s/files/1/1011/0318/files/Stainless_Steel_Fridge_Filter_700x_201.jpg?v=1686873500",
            videolink: "286409603"
        }, 
    ]
};
var resourceSettings = {
    label: "Resource Settings",
    name: "resourceSettings",
    description: "Resource Settings",
    component: "group",
    fields: [
        {
            label: "Resources",
            name: "resources",
            component: "group-list",
            fields: [
                {
                    label: "Resource Title",
                    name: "resourceTitle",
                    component: "text",
                    defaultValue: "Resource Title"
                },
                {
                    label: "Resource Link",
                    name: "resourceLink",
                    component: "text",
                    defaultValue: "https://cdn.shopify.com/s/files/1/1011/0318/files/Printed_Testing_Data_Pitcher__02152023.pdf?v=1679588915"
                },
                {
                    label: "Resource Size",
                    name: "resourceSize",
                    component: "text",
                    defaultValue: "1.2 MB"
                }, 
            ]
        }, 
    ]
};
var faqSettings = {
    label: "FAQ Settings",
    name: "faqSettings",
    description: "FAQ Settings",
    component: "group",
    fields: [
        {
            label: "Faq Title",
            name: "faqTitle",
            component: "text",
            defaultValue: "Help & FAQs"
        },
        {
            label: "Faq Copy",
            name: "faqCopy",
            component: "markdown",
            defaultValue: "Still have questions? We have a great Frequently Asked Questions (FAQs) section we update regularly that may be of help. Also feel free to contact us."
        },
        {
            label: "Call to action",
            name: "faqCta",
            component: "link"
        }, 
    ]
};
function ProductSupport_schema_Schema() {
    return {
        category: "Text",
        label: "Product Support",
        key: "productSupport",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/Screen_20Shot_202023-05-23_20at_2010.47.52_20AM.png?v=1684864586",
        fields: [
            {
                label: "Eyebrow",
                name: "eyebrow",
                component: "text",
                defaultValue: "Select the product you need help with:"
            },
            {
                label: "Resources Header",
                name: "header",
                component: "text",
                defaultValue: "User Manuals & Downloads"
            },
            {
                label: "Empty Video Text",
                name: "emptyVideoText",
                component: "text",
                defaultValue: "Videos Coming Soon",
                description: "Will Display if no videos have a link"
            },
            {
                label: "Product Support Items",
                name: "productSupportItems",
                component: "group-list",
                itemProps: {
                    label: "{{item.header}}"
                },
                fields: [
                    {
                        label: "Header",
                        name: "header",
                        component: "text"
                    },
                    {
                        label: "Product image",
                        name: "productImage",
                        component: "image"
                    },
                    faqSettings,
                    videoContent,
                    resourceSettings, 
                ]
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/ProductSupport/ProductResourceDownload.jsx

function ProductResourceDownload(props) {
    var resourceTitle = props.resourceTitle, resourceLink = props.resourceLink, resourceSize = props.resourceSize;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mb-6 flex w-full items-center justify-between border-b border-[#2026351a] pb-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "w-9/12 text-lg lg:w-full",
                children: resourceTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                "aria-label": resourceTitle,
                href: resourceLink,
                target: "_blank",
                rel: "noopener noreferrer",
                className: "flex flex-col items-center justify-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        width: "37",
                        height: "37",
                        viewBox: "0 0 37 37",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M37 23.3261V34.587C37 35.2269 36.7458 35.8407 36.2932 36.2932C35.8407 36.7458 35.2269 37 34.587 37H2.41304C1.77306 37 1.1593 36.7458 0.706764 36.2932C0.25423 35.8407 0 35.2269 0 34.587V23.3261C0 23.1128 0.0847437 22.9082 0.235588 22.7573C0.386433 22.6065 0.591021 22.5217 0.804348 22.5217C1.01767 22.5217 1.22226 22.6065 1.37311 22.7573C1.52395 22.9082 1.6087 23.1128 1.6087 23.3261V34.587C1.6087 34.8003 1.69344 35.0049 1.84428 35.1557C1.99513 35.3066 2.19972 35.3913 2.41304 35.3913H34.587C34.8003 35.3913 35.0049 35.3066 35.1557 35.1557C35.3066 35.0049 35.3913 34.8003 35.3913 34.587V23.3261C35.3913 23.1128 35.476 22.9082 35.6269 22.7573C35.7777 22.6065 35.9823 22.5217 36.1957 22.5217C36.409 22.5217 36.6136 22.6065 36.7644 22.7573C36.9153 22.9082 37 23.1128 37 23.3261ZM17.9309 23.8952C18.0056 23.9699 18.0943 24.0293 18.192 24.0698C18.2896 24.1102 18.3943 24.1311 18.5 24.1311C18.6057 24.1311 18.7104 24.1102 18.808 24.0698C18.9057 24.0293 18.9944 23.9699 19.0691 23.8952L27.1126 15.8517C27.1873 15.777 27.2466 15.6882 27.287 15.5906C27.3275 15.4929 27.3483 15.3883 27.3483 15.2826C27.3483 15.1769 27.3275 15.0723 27.287 14.9746C27.2466 14.877 27.1873 14.7883 27.1126 14.7135C27.0378 14.6388 26.9491 14.5795 26.8515 14.5391C26.7538 14.4986 26.6492 14.4778 26.5435 14.4778C26.4378 14.4778 26.3331 14.4986 26.2355 14.5391C26.1379 14.5795 26.0491 14.6388 25.9744 14.7135L19.3043 21.3836V0.804348C19.3043 0.591021 19.2196 0.386433 19.0688 0.235588C18.9179 0.0847437 18.7133 0 18.5 0C18.2867 0 18.0821 0.0847437 17.9312 0.235588C17.7804 0.386433 17.6957 0.591021 17.6957 0.804348V21.3836L11.0256 14.7135C10.8747 14.5626 10.67 14.4778 10.4565 14.4778C10.2431 14.4778 10.0384 14.5626 9.88745 14.7135C9.73652 14.8645 9.65173 15.0692 9.65173 15.2826C9.65173 15.4961 9.73652 15.7008 9.88745 15.8517L17.9309 23.8952Z",
                            fill: "#3383C5"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mt-2 whitespace-nowrap text-sm font-light",
                        children: resourceSize
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/sections/ProductSupport/ProductSupportVideoBanner.jsx




function ProductSupportVideoBanner(props) {
    var ref;
    var videoContent = props.videoContent;
    var ref1 = (0,react.useState)(false), isPlaying = ref1[0], setIsPlaying = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mx-4 mb-6 lg:mx-0",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "relative h-0 overflow-hidden pb-[56.25%]",
            children: isPlaying && videoContent.videoid ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Vimeo, {
                video: videoContent.videoid,
                width: "100%",
                height: "100%",
                autoplay: true,
                muted: true,
                responsive: true,
                className: "vimeo-player absolute inset-0"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                type: "button",
                className: "absolute inset-0 cursor-pointer",
                onClick: function() {
                    return setIsPlaying(true);
                },
                children: [
                    ((ref = videoContent.videoimage) === null || ref === void 0 ? void 0 : ref.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                        className: "absolute inset-0 object-cover",
                        fill: true,
                        src: videoContent.videoimage.src
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "absolute top-0 left-0 w-full p-4 text-center lg:px-12 lg:pt-12",
                        children: [
                            videoContent.videotitle && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "font-white text-base tracking-[-0.01em] text-white lg:text-2xl",
                                children: [
                                    videoContent.videotitle,
                                    " "
                                ]
                            }),
                            videoContent.videocopy && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "font-white text-xs font-light text-white lg:text-base",
                                children: [
                                    videoContent.videocopy,
                                    " "
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* PlayButton */.JM, {})
                    })
                ]
            })
        })
    });
}

;// CONCATENATED MODULE: ./src/sections/ProductSupport/ProductSupport.jsx






function ProductSupport(param) {
    var cms = param.cms;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var header = cms.header, eyebrow = cms.eyebrow, productSupportItems = cms.productSupportItems, emptyVideoText = cms.emptyVideoText;
    var ref8 = (0,react.useState)(0), activeIndex = ref8[0], setActiveIndex = ref8[1];
    var ref9 = (0,react.useState)(productSupportItems.length > 0 ? productSupportItems[0] : null), activeItem = ref9[0], setActiveItem = ref9[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "lg:px-contained lg:py-contained relative mx-auto max-w-screen-2xl pb-0 pt-12 lg:pb-4 lg:pt-4",
                children: [
                    eyebrow && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Eyebrow */.j4, {
                        className: "mb-6 text-center uppercase",
                        children: eyebrow
                    }),
                    productSupportItems.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "px-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "overflow-auto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-row flex-nowrap gap-4 max-lg:pb-[36px] lg:mx-auto lg:items-center lg:justify-center lg:pl-0",
                                children: productSupportItems.slice(0, 5).map(function(param, index) {
                                    var buttonHeader = param.header, productImage = param.productImage;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        type: "button",
                                        className: "min-w-[128px] cursor-pointer rounded-lg px-2 py-[0.706rem] pb-[0.75rem] text-center  hover:bg-[#fff] focus:bg-[#fff] lg:w-auto lg:max-w-[160px] ".concat(activeIndex === index ? "border bg-[#fff]" : "border border-[#DDE2E7] bg-[#E6F0F8] text-text"),
                                        onClick: function() {
                                            setActiveIndex(index);
                                            setActiveItem(productSupportItems[index]);
                                        },
                                        onKeyDown: function() {
                                            setActiveIndex(index);
                                            setActiveItem(productSupportItems[index]);
                                        },
                                        children: [
                                            productImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                                className: "mx-auto mb-4",
                                                sizes: "48px",
                                                width: "77px",
                                                height: "77px",
                                                src: productImage.src
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-xs font-light uppercase tracking-[0.04em]",
                                                children: buttonHeader
                                            })
                                        ]
                                    }, index);
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                className: "border-[#D9DDE8] max-lg:mt-[28px]"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "lg:px-contained relative mx-auto mt-12 max-w-screen-2xl lg:mb-12 lg:flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative overflow-hidden lg:block lg:w-3/5 lg:pr-6",
                        children: activeItem.videoResources ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: (ref = activeItem.videoResources) === null || ref === void 0 ? void 0 : ref.map(function(videoContent) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSupportVideoBanner, {
                                    videoContent: videoContent,
                                    emptyVideoText: emptyVideoText
                                });
                            })
                        }) : emptyVideoText && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                            variant: "h5",
                            element: "h5",
                            children: emptyVideoText
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative lg:w-2/5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: " top-[60px] mt-10 flex-col items-center overflow-hidden bg-[#E6F0F8] px-4 py-14 lg:sticky lg:mt-0 lg:px-10",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                                    variant: "h5",
                                    className: "mx-auto mb-7 w-full border-b border-[#2026351a] pb-12 font-light",
                                    children: header
                                }),
                                (ref1 = activeItem.resourceSettings) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.resources) === null || ref2 === void 0 ? void 0 : ref2.map(function(item) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductResourceDownload, {
                                        resourceTitle: item.resourceTitle,
                                        resourceLink: item.resourceLink,
                                        resourceSize: item.resourceSize
                                    });
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                                    variant: "h5",
                                    className: "mb-7 w-full text-left font-light",
                                    children: (ref3 = activeItem.faqSettings) === null || ref3 === void 0 ? void 0 : ref3.faqTitle
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Markdown */.UG, {
                                    className: "[&_p]:!text-[16px]",
                                    children: (ref4 = activeItem.faqSettings) === null || ref4 === void 0 ? void 0 : ref4.faqCopy
                                }),
                                ((ref5 = activeItem.faqSettings) === null || ref5 === void 0 ? void 0 : ref5.faqCta) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-8 flex w-full items-start",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Button */.zx, {
                                        href: (ref6 = activeItem.faqSettings) === null || ref6 === void 0 ? void 0 : ref6.faqCta.url,
                                        theme: "primary",
                                        variant: "outlined",
                                        children: (ref7 = activeItem.faqSettings) === null || ref7 === void 0 ? void 0 : ref7.faqCta.text
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
ProductSupport.displayName = "ProductSupport";
ProductSupport.Schema = ProductSupport_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/ProductSupport/index.js


;// CONCATENATED MODULE: ./src/sections/ProductThreeColumnDrawers/ProductThreeColumnDrawers.schema.js

var drawerSettings = {
    label: "Drawer Settings",
    name: "drawerSettings",
    component: "group",
    description: "Drawer title, video url, cta, etc.",
    fields: [
        {
            label: "Eyebrow Text",
            name: "eyebrowText",
            component: "text"
        },
        {
            label: "Heading",
            name: "heading",
            component: "text"
        },
        {
            label: "Video URL",
            name: "videoUrl",
            component: "text"
        },
        {
            component: "markdown",
            name: "content",
            label: "Content",
            description: "Content to display under video"
        },
        {
            label: "Call to Action Buttons",
            name: "ctas",
            component: "group-list",
            description: "Max of two buttons",
            itemProps: {
                label: "{{item.link.text}}"
            },
            validate: {
                maxItems: 2
            },
            fields: button_link
        }, 
    ]
};
function ProductThreeColumnDrawers_schema_Schema() {
    return {
        label: "Product 3 Column Drawer",
        key: "ProductThreeColumnDrawers",
        category: "Product",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/product-three-column-drawers.png",
        fields: [
            {
                label: "Eyebrow Text",
                name: "eyebrowText",
                component: "text"
            },
            {
                label: "Heading",
                name: "heading",
                component: "text"
            },
            {
                label: "Columns",
                name: "columns",
                component: "group-list",
                itemProps: {
                    label: "{{item.heading}}"
                },
                validate: {
                    maxItems: 3
                },
                fields: [
                    {
                        name: "image",
                        label: "Image",
                        component: "image"
                    },
                    {
                        name: "heading",
                        label: "Heading",
                        component: "text"
                    },
                    {
                        name: "subHeading",
                        label: "Subheading",
                        component: "text"
                    },
                    {
                        name: "cta",
                        label: "CTA",
                        component: "text"
                    },
                    drawerSettings, 
                ]
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/ProductThreeColumnDrawers/ProductThreeColumnDrawers.jsx






function ProductThreeColumnDrawers(param) {
    var cms = param.cms;
    var heading = cms.heading, eyebrowText = cms.eyebrowText, columns = cms.columns;
    var ref = (0,contexts/* useGlobalContext */.b)(), openDrawer = ref.actions.openDrawer;
    var triggerDrawerOpen = (0,react.useCallback)(function(drawerSettings) {
        openDrawer(/*#__PURE__*/ (0,jsx_runtime.jsx)(FiltrationTechnologyDrawer, {
            content: drawerSettings,
            className: "[&_em]:not-italic [&_em]:text-secondary"
        }));
    }, [
        columns
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "px-contained mx-auto max-w-[var(--content-max-width)] py-[30px] md:py-[45px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid gap-3 lg:mb-24 mb-14 text-center text-[#202635]",
                children: [
                    eyebrowText && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Eyebrow */.j4, {
                        children: eyebrowText
                    }),
                    heading && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                        variant: "h2",
                        children: heading
                    })
                ]
            }),
            (columns === null || columns === void 0 ? void 0 : columns.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "three-column-columns-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "three-column-columns grid grid-cols-1 gap-[22px] md:grid-cols-3",
                    children: columns === null || columns === void 0 ? void 0 : columns.map(function(column, columnIndex) {
                        var image = column.image, heading = column.heading, subHeading = column.subHeading, cta = column.cta, drawerSettings = column.drawerSettings;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "three-column-column text-center max-md:mb-6",
                            children: [
                                (image === null || image === void 0 ? void 0 : image.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative aspect-square",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                        src: image === null || image === void 0 ? void 0 : image.src,
                                        alt: heading,
                                        fill: true,
                                        sizes: "(min-width: 1024px) 40vw, 100vw",
                                        className: "object-cover"
                                    })
                                }),
                                heading && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Subheading */.pm, {
                                    className: "mt-[25px] font-medium",
                                    variant: "medium",
                                    children: heading
                                }),
                                subHeading && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Body */.uT, {
                                    variant: "small",
                                    className: "mt-[10px]",
                                    children: subHeading
                                }),
                                cta && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    onClick: function() {
                                        triggerDrawerOpen(drawerSettings);
                                    },
                                    type: "button",
                                    className: "mt-[20px] text-textLink underline underline-offset-4",
                                    children: cta
                                })
                            ]
                        }, "column-".concat(columnIndex));
                    })
                })
            })
        ]
    });
}
ProductThreeColumnDrawers.displayName = "ProductThreeColumnDrawers";
ProductThreeColumnDrawers.Schema = ProductThreeColumnDrawers_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/ProductThreeColumnDrawers/index.js


;// CONCATENATED MODULE: ./src/sections/ProductUniqueTechnology/ProductUniqueTechnology.schema.js
function ProductUniqueTechnology_schema_Schema() {
    return {
        label: "Technology 50/50 Split",
        key: "uniqueTechnology",
        category: "Product",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/unique-technology.png",
        fields: [
            {
                label: "Dark Mode",
                name: "darkMode",
                description: "Set The Background dark and text white",
                component: "toggle",
                defaultValue: false
            },
            {
                name: "image",
                label: "Image",
                component: "image"
            },
            {
                label: "Image (mobile)",
                name: "mobileImage",
                component: "image"
            },
            {
                label: "Image Alignment",
                name: "imageAlignment",
                component: "select",
                options: [
                    {
                        label: "Left",
                        value: "left"
                    },
                    {
                        label: "Right",
                        value: "right"
                    }, 
                ],
                defaultValue: "left"
            },
            {
                name: "eyebrow",
                label: "Eyebrow Text",
                component: "text"
            },
            {
                name: "heading",
                label: "Heading",
                component: "text"
            },
            {
                name: "content",
                label: "Content",
                component: "markdown"
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/ProductUniqueTechnology/ProductUniqueTechnology.jsx




function ProductUniqueTechnology(param) {
    var cms = param.cms;
    var eyebrow = cms.eyebrow, heading = cms.heading, image = cms.image, imageAlignment = cms.imageAlignment, content = cms.content, darkMode = cms.darkMode, mobileImage = cms.mobileImage;
    var isMobile = utils_useMediaQuery("(max-width: 767px)");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: darkMode ? "dark" : "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "dark:bg-[#202635] dark:text-white",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: [
                    "px-contained mx-auto max-w-[var(--content-max-width)] pb-[30px] md:pb-[45px] md:pt-[90px]", 
                ].join(" "),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "unique-technology grid grid-cols-1 lg:grid-cols-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "content-column flex items-center border-t border-t-[#FFFFFF33] p-4 pt-[60px] sm:p-[36px] md:px-[50px] md:py-[100px] lg:order-1 lg:aspect-square lg:border-t-0 ".concat(imageAlignment === "left" ? "lg:order-1" : "lg:order-0"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    eyebrow && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Eyebrow */.j4, {
                                        className: "mb-4 uppercase",
                                        children: eyebrow
                                    }),
                                    heading && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                                        variant: "h3",
                                        element: "h2",
                                        className: "mb-[40px] max-md:text-[22px]",
                                        children: heading
                                    }),
                                    (image || mobileImage) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "image-column order-0 relative block py-6 max-lg:aspect-square lg:hidden ".concat(imageAlignment === "left" ? "lg:order-0" : "lg:order-1"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                            src: isMobile && mobileImage ? mobileImage.src : image === null || image === void 0 ? void 0 : image.src,
                                            alt: heading,
                                            fill: true,
                                            sizes: "(min-width: 991px) 60vw, 100vw",
                                            className: "!object-contain"
                                        })
                                    }),
                                    content && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-[14px] sm:text-[18px] [&_p:not(:first-child)_strong]:border-t [&_p:not(:first-child)_strong]:border-t-[#FFFFFF33] [&_p:not(:first-child)_strong]:pt-6 [&_strong]:mt-6 [&_strong]:block [&_strong]:text-[16px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Markdown */.UG, {
                                            children: content
                                        })
                                    })
                                ]
                            })
                        }),
                        (image || mobileImage) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "image-column order-0 relative hidden max-lg:aspect-square lg:block ".concat(imageAlignment === "left" ? "lg:order-0" : "lg:order-1"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                src: isMobile && mobileImage ? mobileImage.src : image === null || image === void 0 ? void 0 : image.src,
                                alt: heading,
                                fill: true,
                                sizes: "(min-width: 991px) 60vw, 100vw",
                                className: "!object-contain"
                            })
                        })
                    ]
                })
            })
        })
    });
}
ProductUniqueTechnology.displayName = "ProductUniqueTechnology";
ProductUniqueTechnology.Schema = ProductUniqueTechnology_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/ProductUniqueTechnology/index.js


;// CONCATENATED MODULE: ./src/sections/PromoBanner/PromoBanner.schema.js
function PromoBanner_schema_Schema() {
    return {
        label: "Promo Banner",
        key: "promo-banner",
        category: "Banner",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/promo_banner.png?v=1684355227",
        fields: [
            {
                label: "Eyebrow Text",
                name: "eyebrowText",
                component: "text"
            },
            {
                label: "Heading",
                name: "heading",
                component: "text"
            },
            {
                label: "Image",
                name: "image",
                component: "image"
            },
            {
                label: "Promo Eyebrow Text",
                name: "promoEyebrowText",
                component: "text"
            },
            {
                label: "Promo Heading",
                name: "promoHeading",
                component: "text"
            },
            {
                label: "Promo Description",
                name: "promoDescription",
                component: "text"
            },
            {
                label: "Call to Action Buttons",
                name: "ctas",
                component: "group-list",
                description: "Max of two buttons",
                itemProps: {
                    label: "{{item.link.text}}"
                },
                defaultItem: {
                    link: {
                        text: "Shop All",
                        url: ""
                    },
                    theme: "primary",
                    variant: "filled"
                },
                validate: {
                    maxItems: 2
                },
                fields: [
                    {
                        label: "Link",
                        name: "link",
                        component: "link"
                    },
                    {
                        label: "Regular Link",
                        name: "isRegularLink",
                        component: "toggle",
                        defaultValue: false,
                        description: "Display the link as a regular underlined link. Ignores the button Theme and Variant settings below when enabled."
                    },
                    {
                        label: "Button Theme",
                        name: "theme",
                        component: "select",
                        options: [
                            {
                                label: "Primary",
                                value: "primary"
                            },
                            {
                                label: "Secondary",
                                value: "secondary"
                            },
                            {
                                label: "Light",
                                value: "light"
                            }, 
                        ]
                    },
                    {
                        label: "Button Variant",
                        name: "variant",
                        component: "select",
                        options: [
                            {
                                label: "Filled",
                                value: "filled"
                            },
                            {
                                label: "Outlined",
                                value: "outlined"
                            }, 
                        ]
                    }, 
                ]
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/PromoBanner/PromoBanner.jsx





function PromoBanner(param) {
    var cms = param.cms;
    var eyebrowText = cms.eyebrowText, heading = cms.heading, image = cms.image, promoEyebrowText = cms.promoEyebrowText, promoHeading = cms.promoHeading, promoDescription = cms.promoDescription, ctas = cms.ctas;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "px-contained mx-auto my-20 flex max-w-[var(--content-max-width)] flex-col gap-10",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-4 lg:text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Eyebrow */.j4, {
                        children: eyebrowText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                        variant: "h3",
                        children: heading
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col lg:flex-row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-1 shrink-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                            src: image.src,
                            alt: image.alt,
                            className: "w-full object-cover",
                            width: image.width,
                            height: image.height
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-1 shrink-0 items-center justify-center bg-gradient-to-r from-[#C1EFFA] to-[#8DCEF9] px-6 py-11",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col gap-4 lg:max-w-[452px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Eyebrow */.j4, {
                                    children: promoEyebrowText
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                                    variant: "h3",
                                    children: promoHeading
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Body */.uT, {
                                    variant: "medium",
                                    children: promoDescription
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex items-center gap-5",
                                    children: ctas.map(function(cta, index) {
                                        if ("link" in cta) {
                                            if (cta === null || cta === void 0 ? void 0 : cta.isRegularLink) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                                                    className: "underline underline-offset-2",
                                                    href: cta.link.url,
                                                    children: cta.link.text
                                                });
                                            }
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                href: cta.link.url,
                                                variant: cta.variant,
                                                theme: cta.theme,
                                                children: cta.link.text
                                            }, index);
                                        }
                                        return null;
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
PromoBanner.Schema = PromoBanner_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/PromoBanner/index.js


// EXTERNAL MODULE: ../node_modules/react-responsive-carousel/lib/styles/carousel.min.css
var carousel_min = __webpack_require__(5560);
;// CONCATENATED MODULE: ./src/sections/Quiz/Quiz.schema.js
function Quiz_schema_Schema() {
    return {
        label: "Quiz",
        key: "quiz",
        category: "Content",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/quizz.png?v=1684786495",
        fields: [
            {
                label: "Eyebrow Text",
                name: "eyebrowText",
                component: "text"
            },
            {
                label: "Heading",
                name: "heading",
                component: "text"
            },
            {
                label: "Body Text",
                name: "body",
                component: "markdown"
            },
            {
                label: "Action Button",
                name: "actionButton",
                component: "link"
            },
            {
                label: "Background Video URL",
                name: "backgroundVideoUrl",
                component: "text",
                defaultValue: "https://cdn.shopify.com/videos/c/o/v/6a6773d78b664a3aae88a75d18f73247.mp4"
            },
            {
                label: "Background Image",
                name: "backgroundImage",
                component: "image"
            },
            {
                label: "Cities",
                name: "cities",
                component: "group-list",
                fields: [
                    {
                        label: "Contaminants Box Title",
                        name: "contaminantsBoxTitle",
                        component: "text"
                    },
                    {
                        label: "Contaminants Box Content",
                        name: "contaminantsBoxContent",
                        component: "markdown"
                    },
                    {
                        label: "City",
                        name: "city",
                        component: "text"
                    },
                    {
                        label: "Total contaminants found",
                        name: "totalContaminantsFound",
                        component: "number"
                    },
                    {
                        label: "Percentage of contaminants",
                        description: "Pick a number between 0 and 100",
                        name: "percentageOfContaminants",
                        component: "number",
                        defaultValue: 0
                    }, 
                ]
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ../node_modules/react-circular-progressbar/dist/index.esm.js


/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function index_esm_extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var index_esm_assign = function() {
    index_esm_assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return index_esm_assign.apply(this, arguments);
};

function index_esm_rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

var VIEWBOX_WIDTH = 100;
var VIEWBOX_HEIGHT = 100;
var VIEWBOX_HEIGHT_HALF = 50;
var VIEWBOX_CENTER_X = 50;
var VIEWBOX_CENTER_Y = 50;

function Path(_a) {
    var className = _a.className, counterClockwise = _a.counterClockwise, dashRatio = _a.dashRatio, pathRadius = _a.pathRadius, strokeWidth = _a.strokeWidth, style = _a.style;
    return ((0,react.createElement)("path", { className: className, style: Object.assign({}, style, getDashStyle({ pathRadius: pathRadius, dashRatio: dashRatio, counterClockwise: counterClockwise })), d: getPathDescription({
            pathRadius: pathRadius,
            counterClockwise: counterClockwise,
        }), strokeWidth: strokeWidth, fillOpacity: 0 }));
}
function getPathDescription(_a) {
    var pathRadius = _a.pathRadius, counterClockwise = _a.counterClockwise;
    var radius = pathRadius;
    var rotation = counterClockwise ? 1 : 0;
    return "\n      M " + VIEWBOX_CENTER_X + "," + VIEWBOX_CENTER_Y + "\n      m 0,-" + radius + "\n      a " + radius + "," + radius + " " + rotation + " 1 1 0," + 2 * radius + "\n      a " + radius + "," + radius + " " + rotation + " 1 1 0,-" + 2 * radius + "\n    ";
}
function getDashStyle(_a) {
    var counterClockwise = _a.counterClockwise, dashRatio = _a.dashRatio, pathRadius = _a.pathRadius;
    var diameter = Math.PI * 2 * pathRadius;
    var gapLength = (1 - dashRatio) * diameter;
    return {
        strokeDasharray: diameter + "px " + diameter + "px",
        strokeDashoffset: (counterClockwise ? -gapLength : gapLength) + "px",
    };
}

var CircularProgressbar = (function (_super) {
    index_esm_extends(CircularProgressbar, _super);
    function CircularProgressbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CircularProgressbar.prototype.getBackgroundPadding = function () {
        if (!this.props.background) {
            return 0;
        }
        return this.props.backgroundPadding;
    };
    CircularProgressbar.prototype.getPathRadius = function () {
        return VIEWBOX_HEIGHT_HALF - this.props.strokeWidth / 2 - this.getBackgroundPadding();
    };
    CircularProgressbar.prototype.getPathRatio = function () {
        var _a = this.props, value = _a.value, minValue = _a.minValue, maxValue = _a.maxValue;
        var boundedValue = Math.min(Math.max(value, minValue), maxValue);
        return (boundedValue - minValue) / (maxValue - minValue);
    };
    CircularProgressbar.prototype.render = function () {
        var _a = this.props, circleRatio = _a.circleRatio, className = _a.className, classes = _a.classes, counterClockwise = _a.counterClockwise, styles = _a.styles, strokeWidth = _a.strokeWidth, text = _a.text;
        var pathRadius = this.getPathRadius();
        var pathRatio = this.getPathRatio();
        return ((0,react.createElement)("svg", { className: classes.root + " " + className, style: styles.root, viewBox: "0 0 " + VIEWBOX_WIDTH + " " + VIEWBOX_HEIGHT, "data-test-id": "CircularProgressbar" },
            this.props.background ? ((0,react.createElement)("circle", { className: classes.background, style: styles.background, cx: VIEWBOX_CENTER_X, cy: VIEWBOX_CENTER_Y, r: VIEWBOX_HEIGHT_HALF })) : null,
            (0,react.createElement)(Path, { className: classes.trail, counterClockwise: counterClockwise, dashRatio: circleRatio, pathRadius: pathRadius, strokeWidth: strokeWidth, style: styles.trail }),
            (0,react.createElement)(Path, { className: classes.path, counterClockwise: counterClockwise, dashRatio: pathRatio * circleRatio, pathRadius: pathRadius, strokeWidth: strokeWidth, style: styles.path }),
            text ? ((0,react.createElement)("text", { className: classes.text, style: styles.text, x: VIEWBOX_CENTER_X, y: VIEWBOX_CENTER_Y }, text)) : null));
    };
    CircularProgressbar.defaultProps = {
        background: false,
        backgroundPadding: 0,
        circleRatio: 1,
        classes: {
            root: 'CircularProgressbar',
            trail: 'CircularProgressbar-trail',
            path: 'CircularProgressbar-path',
            text: 'CircularProgressbar-text',
            background: 'CircularProgressbar-background',
        },
        counterClockwise: false,
        className: '',
        maxValue: 100,
        minValue: 0,
        strokeWidth: 8,
        styles: {
            root: {},
            trail: {},
            path: {},
            text: {},
            background: {},
        },
        text: '',
    };
    return CircularProgressbar;
}(react.Component));

function CircularProgressbarWithChildren(props) {
    var children = props.children, circularProgressbarProps = index_esm_rest(props, ["children"]);
    return (createElement("div", { "data-test-id": "CircularProgressbarWithChildren" },
        createElement("div", { style: { position: 'relative', width: '100%', height: '100%' } },
            createElement(CircularProgressbar, index_esm_assign({}, circularProgressbarProps)),
            props.children ? (createElement("div", { "data-test-id": "CircularProgressbarWithChildren__children", style: {
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    marginTop: '-100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                } }, props.children)) : null)));
}

function buildStyles(_a) {
    var rotation = _a.rotation, strokeLinecap = _a.strokeLinecap, textColor = _a.textColor, textSize = _a.textSize, pathColor = _a.pathColor, pathTransition = _a.pathTransition, pathTransitionDuration = _a.pathTransitionDuration, trailColor = _a.trailColor, backgroundColor = _a.backgroundColor;
    var rotationTransform = rotation == null ? undefined : "rotate(" + rotation + "turn)";
    var rotationTransformOrigin = rotation == null ? undefined : 'center center';
    return {
        root: {},
        path: removeUndefinedValues({
            stroke: pathColor,
            strokeLinecap: strokeLinecap,
            transform: rotationTransform,
            transformOrigin: rotationTransformOrigin,
            transition: pathTransition,
            transitionDuration: pathTransitionDuration == null ? undefined : pathTransitionDuration + "s",
        }),
        trail: removeUndefinedValues({
            stroke: trailColor,
            strokeLinecap: strokeLinecap,
            transform: rotationTransform,
            transformOrigin: rotationTransformOrigin,
        }),
        text: removeUndefinedValues({
            fill: textColor,
            fontSize: textSize,
        }),
        background: removeUndefinedValues({
            fill: backgroundColor,
        }),
    };
}
function removeUndefinedValues(obj) {
    Object.keys(obj).forEach(function (key) {
        if (obj[key] == null) {
            delete obj[key];
        }
    });
    return obj;
}


//# sourceMappingURL=index.esm.js.map

;// CONCATENATED MODULE: ./src/sections/Quiz/QuizContaminantsFound.jsx



function QuizContaminantsFound(param) {
    var percentage = param.percentage, cityName = param.cityName, contaminantsFound = param.contaminantsFound;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative z-10 text-white",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative mb-5 flex h-full w-full justify-center lg:mb-12",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-0 w-[200px] lg:w-[444px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgressbar, {
                            value: percentage,
                            circleRatio: 0.5,
                            strokeWidth: 2,
                            styles: buildStyles({
                                rotation: 3 / 4,
                                strokeLinecap: null,
                                pathTransitionDuration: 0.5,
                                textSize: "1.5rem",
                                trailColor: "#ECF7FF33",
                                pathColor: "#2179C2"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "flex h-[102px] items-end text-[4.75rem] leading-none lg:h-[220px] lg:text-[8.75rem]",
                        children: contaminantsFound
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pb-10 lg:pb-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Eyebrow */.j4, {
                        children: "TOTAL CONTAMINANTS FOUND IN:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-2xl font-medium lg:text-3xl",
                        children: cityName
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/sections/Quiz/QuizContaminantsWeRemoveBox.jsx


function QuizContaminantsWeRemoveBox(param) {
    var contaminantsBoxTitle = param.contaminantsBoxTitle, contaminantsBoxContent = param.contaminantsBoxContent;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mb-10 flex max-w-[520px] rounded-2xl border border-[#2179C2]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid gap-3 px-6 py-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Body */.uT, {
                        variant: "small",
                        children: contaminantsBoxTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Body */.uT, {
                        element: "div",
                        variant: "xs",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Markdown */.UG, {
                            className: "[&_p]:lg:text-sm [&_p]:lg:font-extralight [&_p]:lg:leading-5",
                            children: contaminantsBoxContent
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hidden h-full w-[1px] bg-[#2179C2] lg:block"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hidden shrink-0 items-center justify-center px-[34px] lg:flex ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "https://cdn.shopify.com/s/files/1/1011/0318/files/What_sInYourWaterIcon_2.png?v=1705690049",
                    alt: "",
                    className: "aspect-square w-20 shrink-0 object-contain"
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/sections/Quiz/Quiz.jsx
/* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ 






function Quiz(param) {
    var cms = param.cms;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var eyebrowText = cms.eyebrowText, heading = cms.heading, body = cms.body, actionButton = cms.actionButton, backgroundVideoUrl = cms.backgroundVideoUrl, backgroundImage = cms.backgroundImage, contaminantsBoxTitle = cms.contaminantsBoxTitle, contaminantsBoxContent = cms.contaminantsBoxContent, cities = cms.cities;
    var ref7 = (0,react.useState)(0), selectedSlide = ref7[0], setSelectedSlide = ref7[1];
    var slides = (cities === null || cities === void 0 ? void 0 : cities.length) || 0;
    (0,react.useEffect)(function() {
        var interval = setInterval(function() {
            setSelectedSlide(function(prev) {
                return (prev + 1) % slides;
            });
        }, 5000);
        return function() {
            return clearInterval(interval);
        };
    }, [
        selectedSlide
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "mx-auto max-w-[var(--max-content-width)]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid lg:grid-cols-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row-start-2 flex justify-end bg-[#E6F0F8] lg:row-start-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "px-contained my-10 text-left lg:my-[9rem] lg:w-[calc(var(--content-max-width)/2)] lg:px-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "grid gap-3 px-4 md:px-8 xl:px-12",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* AltText */.Fh, {
                                        children: eyebrowText
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                                        variant: "h3",
                                        children: heading
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "lg:max-w-[520px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Markdown */.UG, {
                                            children: body
                                        })
                                    }),
                                    ((cities === null || cities === void 0 ? void 0 : (ref = cities[selectedSlide]) === null || ref === void 0 ? void 0 : ref.contaminantsBoxContent) || (cities === null || cities === void 0 ? void 0 : (ref1 = cities[selectedSlide]) === null || ref1 === void 0 ? void 0 : ref1.contaminantsBoxTitle)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(QuizContaminantsWeRemoveBox, {
                                        contaminantsBoxContent: cities === null || cities === void 0 ? void 0 : (ref2 = cities[selectedSlide]) === null || ref2 === void 0 ? void 0 : ref2.contaminantsBoxContent,
                                        contaminantsBoxTitle: cities === null || cities === void 0 ? void 0 : (ref3 = cities[selectedSlide]) === null || ref3 === void 0 ? void 0 : ref3.contaminantsBoxTitle
                                    }),
                                    actionButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Button */.zx, {
                                            theme: "primary",
                                            variant: "filled",
                                            href: actionButton.url,
                                            children: actionButton.text
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row-start-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "h-full select-none text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative flex h-full w-full items-center justify-center",
                                children: [
                                    backgroundVideoUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                        src: backgroundVideoUrl,
                                        autoPlay: true,
                                        loop: true,
                                        playsInline: true,
                                        muted: true,
                                        className: "z-1 absolute left-0 top-0 h-full w-full object-cover"
                                    }),
                                    !backgroundVideoUrl && backgroundImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: backgroundImage.src,
                                        alt: backgroundImage.alt,
                                        className: "z-1 absolute left-0 top-0 h-full w-full object-cover"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex aspect-square w-full items-center justify-center lg:aspect-auto lg:w-[444px]",
                                        children: [
                                            (cities === null || cities === void 0 ? void 0 : cities.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(QuizContaminantsFound, {
                                                cityName: (ref4 = cities[selectedSlide]) === null || ref4 === void 0 ? void 0 : ref4.city,
                                                contaminantsFound: (ref5 = cities[selectedSlide]) === null || ref5 === void 0 ? void 0 : ref5.totalContaminantsFound,
                                                percentage: (ref6 = cities[selectedSlide]) === null || ref6 === void 0 ? void 0 : ref6.percentageOfContaminants
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "absolute bottom-10 z-20 flex w-full justify-center gap-x-4",
                                                children: Array(slides).fill().map(function(_, i) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: [
                                                            i === selectedSlide ? "bg-[#ffffff]" : "bg-[#ffffff33]",
                                                            "h-3 w-3 cursor-pointer rounded-full", 
                                                        ].join(" "),
                                                        onClick: function() {
                                                            return setSelectedSlide(i);
                                                        }
                                                    }, i);
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
}
Quiz.displayName = "Quiz";
Quiz.Schema = Quiz_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/Quiz/index.js


;// CONCATENATED MODULE: ./src/sections/RatingBanner/RatingBanner.schema.js
function RatingBanner_schema_Schema() {
    return {
        label: "Rating Banner",
        key: "rating-banner",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/rating_banner.png?v=1686314380",
        category: "Banner",
        fields: [
            {
                label: "Title",
                name: "title",
                component: "text",
                defaultValue: "Rated 4.9 stars across 10,000+ Reviews"
            },
            {
                component: "toggle",
                name: "toggleStars",
                label: "Show stars",
                description: "Show/hide stars",
                toggleLabels: {
                    true: "Enable",
                    false: "Disable"
                },
                defaultValue: true
            },
            {
                component: "number",
                name: "starCount",
                label: "Star Count",
                defaultValue: 5,
                description: "Decimal numbers supported - rounds to nearest hundredth",
                validate: {
                    required: true
                }
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/RatingBanner/RatingBanner.jsx
/* eslint-disable no-use-before-define */ 


function RatingBanner(param) {
    var cms = param.cms;
    var title = cms.title, toggleStars = cms.toggleStars, _starCount = cms.starCount, starCount = _starCount === void 0 ? "5" : _starCount;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "h-[3.375rem] bg-gradient-to-r from-[#C1EFFA99] to-[#8DCEF999] text-[#000000]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex h-full flex-wrap items-center justify-center gap-x-[0.625rem] text-center text-xs font-extralight md:text-sm",
            children: [
                title,
                toggleStars && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* ReviewStars */.Hm, {
                    color: "rgb(33, 121, 194)",
                    rating: parseFloat(starCount),
                    size: "small"
                })
            ]
        })
    });
}
RatingBanner.displayName = "RatingStars";
RatingBanner.Schema = RatingBanner_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/RatingBanner/index.js


;// CONCATENATED MODULE: ./src/sections/RelatedProducts/RelatedProducts.schema.js
var RelatedProducts_schema_Schema = function() {
    return {
        category: "Product",
        label: "Related Products",
        key: "related-products",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/featured-products.png?v=1685571408",
        fields: [
            {
                name: "sectionTitle",
                component: "text",
                label: "Section Title",
                defaultValue: "Related Products"
            },
            {
                name: "sectionLink",
                component: "link",
                label: "Section Link"
            },
            {
                name: "relatedProducts",
                component: "group-list",
                label: "Related Products",
                itemProps: {
                    label: "{{item.featuredProduct.title}}"
                },
                validate: {
                    maxItems: 4
                },
                fields: [
                    {
                        label: "Related Product",
                        component: "productSearch",
                        name: "featuredProduct"
                    }, 
                ]
            }, 
        ]
    };
};

;// CONCATENATED MODULE: ./src/sections/RelatedProducts/RelatedProducts.jsx









function RelatedProducts(param) {
    var cms = param.cms;
    var ref = (0,_object_spread/* default */.Z)({}, cms), sectionTitle = ref.sectionTitle, sectionLink = ref.sectionLink, relatedProducts = ref.relatedProducts;
    var navigationPrevRef = (0,react.useRef)(null);
    var navigationNextRef = (0,react.useRef)(null);
    var isMediumScreen = utils_useMediaQuery("(min-width: 640px)");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "featured-products px-contained py-[32px] md:py-[62px]",
        children: [
            /* Section Header */ (sectionTitle || (sectionLink === null || sectionLink === void 0 ? void 0 : sectionLink.url)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "featured-products__header mb-6 flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                        element: "h3",
                        variant: "h3",
                        className: "title",
                        children: sectionTitle
                    }),
                    (sectionLink === null || sectionLink === void 0 ? void 0 : sectionLink.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                        "aria-label": sectionLink === null || sectionLink === void 0 ? void 0 : sectionLink.text,
                        href: sectionLink === null || sectionLink === void 0 ? void 0 : sectionLink.url,
                        newTab: sectionLink === null || sectionLink === void 0 ? void 0 : sectionLink.newTab,
                        tabIndex: "-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Button */.zx, {
                            theme: "dark",
                            variant: "outlined",
                            children: sectionLink === null || sectionLink === void 0 ? void 0 : sectionLink.text
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                slidesPerView: isMediumScreen ? 4 : 2,
                spaceBetween: 18,
                modules: [
                    modules/* Navigation */.W_
                ],
                slideNextClass: "bottom_swiper-slide-next",
                slidePrevClass: "bottom_swiper-slide-prev",
                navigation: {
                    enabled: true,
                    prevEl: navigationPrevRef.current,
                    nextEl: navigationNextRef.current
                },
                onResize: function(swiper) {
                    swiper.params.navigation.enabled = swiper.enable;
                    swiper.params.navigation.prevEl = navigationPrevRef.current;
                    swiper.params.navigation.nextEl = navigationNextRef.current;
                },
                onBeforeInit: function(swiper) {
                    swiper.params.navigation.enabled = true;
                    swiper.params.navigation.prevEl = navigationPrevRef.current;
                    swiper.params.navigation.nextEl = navigationNextRef.current;
                },
                children: [
                    relatedProducts === null || relatedProducts === void 0 ? void 0 : relatedProducts.map(function(featuredProduct, index) {
                        var ref;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* ProductItem */.Cd, {
                                disableHoverEffect: true,
                                enabledQuickShop: false,
                                enabledStarRating: true,
                                disa: true,
                                handle: featuredProduct === null || featuredProduct === void 0 ? void 0 : (ref = featuredProduct.featuredProduct) === null || ref === void 0 ? void 0 : ref.handle,
                                index: index
                            })
                        }, "product-grid-item-".concat(index));
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-8 flex justify-center gap-8 md:hidden",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets_Button/* ArrowButton */.b4, {
                                arrowDirection: "left",
                                ref: navigationPrevRef
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets_Button/* ArrowButton */.b4, {
                                arrowDirection: "right",
                                ref: navigationNextRef
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
RelatedProducts.displayName = "RelatedProducts";
RelatedProducts.Schema = RelatedProducts_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/RelatedProducts/index.js


;// CONCATENATED MODULE: ./src/sections/ReviewsSlider/ReviewsSlider.schema.js
function ReviewsSlider_schema_Schema() {
    return {
        label: "Reviews Slider",
        key: "reviews-slider",
        category: "Slider",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/reviews.png?v=1684933544",
        fields: [
            {
                label: "Eyebrow",
                name: "eyebrow",
                component: "text",
                defaultValue: "COMPLETE CONFIDENCE IN YOUR WATER"
            },
            {
                label: "Title",
                name: "title",
                component: "text",
                defaultValue: "Trusted by more than 10,000+ customers."
            },
            {
                label: "Call to action",
                name: "cta",
                component: "link",
                defaultValue: {
                    href: "/reviews",
                    label: "Read All Reviews"
                }
            },
            {
                label: "Remove Background Linear Gradient",
                name: "remove_linear_gradient",
                component: "toggle"
            },
            {
                label: "Reviews",
                name: "reviews",
                component: "group-list",
                validate: {
                    maxItems: 6
                },
                fields: [
                    {
                        label: "Name",
                        name: "name",
                        component: "text"
                    },
                    {
                        label: "Review",
                        name: "review",
                        component: "textarea"
                    },
                    {
                        label: "Image",
                        name: "image",
                        component: "image"
                    },
                    {
                        label: "Rating",
                        name: "rating",
                        component: "number",
                        defaultValue: 5
                    }, 
                ]
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/ReviewsSlider/ReviewsSlider.jsx
/* eslint-disable camelcase */ 








function ReviewsSlider(param) {
    var cms = param.cms;
    var eyebrow = cms.eyebrow, title = cms.title, cta = cms.cta, remove_linear_gradient = cms.remove_linear_gradient, reviews = cms.reviews;
    var navigationPrevRef = (0,react.useRef)(null);
    var navigationNextRef = (0,react.useRef)(null);
    var isMobile = utils_useMediaQuery("(max-width: 1023px)");
    var ref = (0,react.useState)(false), renderClientSideComponent = ref[0], setRenderClientSideComponent = ref[1];
    (0,react.useEffect)(function() {
        setRenderClientSideComponent(true);
    }, []);
    var _alt;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "".concat(remove_linear_gradient ? "bg-[#2179C21a]" : "bg-gradient-to-t from-[#2179C21a] to-[#F1DCC11a]", " pb-20 pt-28"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mx-auto max-w-[var(--content-max-width)] text-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid gap-3 lg:mb-14",
                    children: [
                        eyebrow && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Eyebrow */.j4, {
                            children: eyebrow
                        }),
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                            variant: "h3",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-center lg:hidden",
                            children: (cta === null || cta === void 0 ? void 0 : cta.url) && (cta === null || cta === void 0 ? void 0 : cta.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets_Button/* Button */.zx, {
                                variant: "filled",
                                theme: "primary",
                                href: cta.url,
                                children: cta.text
                            })
                        })
                    ]
                }),
                renderClientSideComponent && /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                    modules: [
                        modules/* Navigation */.W_
                    ],
                    navigation: {
                        prevEl: navigationPrevRef.current,
                        nextEl: navigationNextRef.current
                    },
                    onBeforeInit: function(_swiper) {
                        _swiper.params.navigation.prevEl = navigationPrevRef.current;
                        _swiper.params.navigation.nextEl = navigationNextRef.current;
                    },
                    slidesPerView: isMobile ? 1.3 : 3,
                    centeredSlides: true,
                    loop: true,
                    spaceBetween: 1,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute left-[calc(32%)] top-0 z-10 hidden h-[80%] items-center lg:flex",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets_Button/* ArrowButton */.b4, {
                                arrowDirection: "left",
                                ref: navigationPrevRef
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute right-[calc(32%)] top-0 z-10 hidden h-[80%] items-center lg:flex",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets_Button/* ArrowButton */.b4, {
                                arrowDirection: "right",
                                ref: navigationNextRef
                            })
                        }),
                        (0,_to_consumable_array/* default */.Z)(reviews).concat((0,_to_consumable_array/* default */.Z)(reviews)).map(function(review, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                className: "pt-24",
                                children: function(param) {
                                    var isActive = param.isActive;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mb-20 flex flex-col items-center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "relative aspect-square w-[90%] transition-all lg:w-[calc(100%-10rem)]",
                                                    style: {
                                                        transform: isActive ? "scale(1.1)" : "scale(1)"
                                                    },
                                                    children: [
                                                        review.image && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                                            src: review.image.src,
                                                            alt: (_alt = review.image.alt) !== null && _alt !== void 0 ? _alt : "Review image by ".concat(review.name),
                                                            loading: "lazy",
                                                            sizes: "400px",
                                                            fill: true
                                                        }),
                                                        !isActive && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "absolute -bottom-6 left-0 hidden w-full text-left md:block",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* AltText */.Fh, {
                                                                className: "!text-sm text-[#797D8699]",
                                                                children: review.name
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            isActive && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "px-contained",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "mb-3 mt-7 flex justify-center",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* ReviewStars */.Hm, {
                                                            rating: review.rating,
                                                            color: "#2179C2"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Body */.uT, {
                                                        element: "div",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("blockquote", {
                                                            className: "min-h-[120px] text-center",
                                                            children: review.review
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "mt-4",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* AltText */.Fh, {
                                                            className: "!text-sm text-[#797D8699]",
                                                            children: review.name
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    });
                                }
                            }, index);
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-10 hidden justify-center lg:flex",
                    children: (cta === null || cta === void 0 ? void 0 : cta.url) && (cta === null || cta === void 0 ? void 0 : cta.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets_Button/* Button */.zx, {
                        variant: "filled",
                        theme: "primary",
                        href: cta.url,
                        children: cta.text
                    })
                })
            ]
        })
    });
}
ReviewsSlider.displayName = "ReviewsSlider";
ReviewsSlider.Schema = ReviewsSlider_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/SearchResults/SearchHeader.jsx


function SearchHeader(param) {
    var rawTerm = param.rawTerm, onChange = param.onChange, totalCount = param.totalCount;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "px-contained py-contained",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat(totalCount > 0 ? "border-b border-zinc-200 pb-8" : "mb-6 border-b border-zinc-200 pb-6", "  "),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mb-6 flex gap-2 text-sm",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
                            "aria-label": "Home",
                            className: "text-[#20263580]",
                            href: "/",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Home"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "/"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-primary",
                            children: "Search"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "text-[26px] font-light tracking-[-.01em] text-primary md:mb-8 md:text-[42px]",
                    children: "Search Results"
                }),
                rawTerm && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "color-primaryLight font-primaryLight mb-4 text-primaryLight",
                    children: [
                        "Showing ",
                        totalCount || 0,
                        " results for “[",
                        rawTerm,
                        "]”"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative flex justify-between gap-3 rounded-full border border-border bg-white pl-3 pr-4 lg:max-w-3xl",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                            className: "w-5 text-text",
                            src: "/svgs/search.svg#search",
                            title: "Search",
                            viewBox: "0 0 24 24"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            "aria-label": "Search here",
                            className: "min-w-0 flex-1 py-3 text-base outline-none",
                            placeholder: "Search here",
                            onChange: onChange,
                            value: rawTerm || ""
                        })
                    ]
                })
            ]
        })
    });
}
SearchHeader.displayName = "SearchHeader";

;// CONCATENATED MODULE: ./src/sections/SearchResults/SearchList.jsx
// import Link from 'next/link';





var collectionItem = function(item) {
    var ref;
    var collectionImage = item === null || item === void 0 ? void 0 : (ref = item.image) === null || ref === void 0 ? void 0 : ref.src;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Link */.rU, {
        className: "",
        "aria-label": item.title,
        href: "/collections/".concat(item.handle),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                collectionImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mb-6 lg:mb-0 lg:block",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                        className: "",
                        sizes: "48px",
                        width: "425px",
                        height: "425px",
                        src: collectionImage
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mt-4 text-xl font-light tracking-[-.02em]",
                    children: item.title
                })
            ]
        })
    });
};
var listItem = function(item, resultCTA, resultUrl) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mb-6 w-8/12 border-b border-zinc-200 pb-6",
        children: [
            (item === null || item === void 0 ? void 0 : item.category) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-2 text-2xs font-normal uppercase tracking-[.04em] lg:text-sm",
                children: item.category
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-4 text-2xl font-light tracking-[.02em] lg:text-4xl",
                children: item.title
            }),
            (item === null || item === void 0 ? void 0 : item.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mb-2 text-xs lg:text-base",
                children: item.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(snippets/* Link */.rU, {
                "aria-label": resultCTA,
                className: "color-link mt-4 flex items-center text-sm font-normal text-textLink no-underline lg:text-lg",
                href: "/".concat(resultUrl, "/").concat(item.handle),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "pr-4",
                        children: resultCTA
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                            className: "inherit w-5",
                            src: "/svgs/arrow-right.svg#arrow-right",
                            title: "Close",
                            viewBox: "0 0 24 24"
                        })
                    })
                ]
            })
        ]
    });
};
function SearchList(param) {
    var results = param.results, resultName = param.resultName, resultCTA = param.resultCTA, resultUrl = param.resultUrl, emptyCollectionProducts = param.emptyCollectionProducts, products = param.products;
    var ref = (0,react.useState)([]), collectionResults = ref[0], setCollectionResults = ref[1];
    var fetchCollectionResults = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var collectionRes, collectionItems;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!results.length) {
                            return [
                                2,
                                setCollectionResults([])
                            ];
                        }
                        collectionRes = results.map(function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(function(result) {
                                var response, data;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                fetch("/json/collections/".concat(result.item.handle, ".json"))
                                            ];
                                        case 1:
                                            response = _state.sent();
                                            return [
                                                4,
                                                response.json()
                                            ];
                                        case 2:
                                            data = _state.sent();
                                            return [
                                                2,
                                                {
                                                    item: data
                                                }
                                            ];
                                    }
                                });
                            });
                            return function(result) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        return [
                            4,
                            Promise.all(collectionRes)
                        ];
                    case 1:
                        collectionItems = _state.sent();
                        setCollectionResults(collectionItems);
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchCollectionResults() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (resultName == "Collection" && results.length) {
            fetchCollectionResults();
        }
        return function() {
            setCollectionResults([]);
        };
    }, [
        results,
        resultName
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "",
        children: (results === null || results === void 0 ? void 0 : results.length) > 0 && function() {
            if (resultName === "Products" && results.length && products) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Collection */.FE, {
                    emptyCollectionProducts: emptyCollectionProducts,
                    handle: "search",
                    products: products,
                    showHeading: false
                });
            }
            if (resultName === "Collection" && results.length) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid-cols-3 gap-x-5 lg:grid",
                    children: collectionResults.map(function(param, index) {
                        var item = param.item;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                            children: collectionItem(item)
                        }, index);
                    })
                });
            }
            return results.map(function(param, index) {
                var item = param.item;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: listItem(item, resultCTA, resultUrl)
                }, index);
            });
        }()
    });
}
SearchList.displayName = "SearchList";

;// CONCATENATED MODULE: ./src/sections/SearchResults/SearchFilterMenu.jsx




function SearchFilterMenu(param) {
    var productResults = param.productResults, collectionResults = param.collectionResults, articleResults = param.articleResults, pageResults = param.pageResults, searchType = param.searchType, setSearchType = param.setSearchType;
    var ref = (0,react.useState)(null), activeItem = ref[0], setActiveItem = ref[1];
    var ref1 = (0,react.useState)(false), activeMenu = ref1[0], setActiveMenu = ref1[1];
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        var findActiveItem = function() {
            var ref, ref1, ref2, ref3, ref4;
            if (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.searchType) {
                var ref5;
                setSearchType(router === null || router === void 0 ? void 0 : (ref5 = router.query) === null || ref5 === void 0 ? void 0 : ref5.searchType);
            }
            if (searchType === "products" || (router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.searchType) === "products") {
                setActiveItem("Product Results");
            }
            if (searchType === "collections" || (router === null || router === void 0 ? void 0 : (ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.searchType) === "collections") {
                setActiveItem("Collection Results");
            }
            if (searchType === "blog-articles" || (router === null || router === void 0 ? void 0 : (ref3 = router.query) === null || ref3 === void 0 ? void 0 : ref3.searchType) === "blog-articles") {
                setActiveItem("Blog Articles Results");
            }
            if (searchType === "pages" || (router === null || router === void 0 ? void 0 : (ref4 = router.query) === null || ref4 === void 0 ? void 0 : ref4.searchType) === "pages") {
                setActiveItem("Page Results");
            }
        };
        findActiveItem();
    }, []);
    var updateMenu = function(type, searchTypeName, active) {
        setSearchType(type);
        setActiveMenu(!active);
        setActiveItem(searchTypeName);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-[50%] lg:w-2/12",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "hidden flex-col lg:flex ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "button",
                        className: "mb-2 cursor-pointer text-left font-normal uppercase tracking-[.02em] ".concat(searchType === "products" ? "text-secondary" : "", " ").concat((productResults === null || productResults === void 0 ? void 0 : productResults.length) === 0 ? "pointer-events-none cursor-not-allowed" : ""),
                        onClick: function() {
                            return setSearchType("products");
                        },
                        children: [
                            "PRODUCTS (",
                            productResults === null || productResults === void 0 ? void 0 : productResults.length,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "button",
                        className: "mb-2 cursor-pointer text-left font-normal uppercase tracking-[.02em] ".concat(searchType === "collections" ? "text-secondary" : "", " ").concat((collectionResults === null || collectionResults === void 0 ? void 0 : collectionResults.length) === 0 ? "pointer-events-none cursor-not-allowed" : ""),
                        onClick: function() {
                            return setSearchType("collections");
                        },
                        children: [
                            "COLLECTIONS (",
                            collectionResults === null || collectionResults === void 0 ? void 0 : collectionResults.length,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "button",
                        className: "mb-2 cursor-pointer text-left font-normal uppercase tracking-[.02em] ".concat(searchType === "blog-articles" ? "text-secondary" : "", " ").concat((articleResults === null || articleResults === void 0 ? void 0 : articleResults.length) === 0 ? "pointer-events-none cursor-not-allowed" : ""),
                        onClick: function() {
                            return setSearchType("blog-articles");
                        },
                        children: [
                            "BLOG ARTICLES (",
                            articleResults === null || articleResults === void 0 ? void 0 : articleResults.length,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "button",
                        className: "mb-2 cursor-pointer text-left font-normal uppercase tracking-[.02em] ".concat(searchType === "pages" ? "text-secondary" : "", " ").concat((pageResults === null || pageResults === void 0 ? void 0 : pageResults.length) === 0 ? "pointer-events-none cursor-not-allowed" : ""),
                        onClick: function() {
                            return setSearchType("pages");
                        },
                        children: [
                            "PAGES (",
                            pageResults === null || pageResults === void 0 ? void 0 : pageResults.length,
                            ")"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "overflow-hidden rounded-3xl border border-border bg-white lg:hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "button",
                        className: "flex h-[48px] w-full cursor-pointer items-center justify-between rounded-full px-4 py-3",
                        onClick: function() {
                            return setActiveMenu(!activeMenu);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-sm font-light tracking-[-.01em]",
                                children: activeItem
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                                        className: "".concat(!activeMenu ? "block" : "hidden", " w-5 text-text"),
                                        src: "/svgs/chevron-down.svg#chevron-down",
                                        title: "Close",
                                        viewBox: "0 0 24 24"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                                        className: "".concat(activeMenu ? "block" : "hidden", " w-5 text-text"),
                                        src: "/svgs/chevron-up.svg#chevron-up",
                                        title: "Close",
                                        viewBox: "0 0 24 24"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat(activeMenu ? "block" : "hidden"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                type: "button",
                                onClick: function() {
                                    return updateMenu("products", "Product Results", true);
                                },
                                className: "flex w-full cursor-pointer items-center justify-between border-t border-zinc-200 bg-white p-4 text-sm font-light tracking-[-.01em]",
                                children: [
                                    "Product Results (",
                                    productResults === null || productResults === void 0 ? void 0 : productResults.length,
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                type: "button",
                                onClick: function() {
                                    return updateMenu("collections", "Collection Result", true);
                                },
                                className: "flex w-full cursor-pointer items-center justify-between border-t border-zinc-200 bg-white p-4 text-sm font-light tracking-[-.01em]",
                                children: [
                                    "Collection Results (",
                                    collectionResults === null || collectionResults === void 0 ? void 0 : collectionResults.length,
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                type: "button",
                                onClick: function() {
                                    return updateMenu("blog-articles", "Blog Articles Results", true);
                                },
                                className: "flex w-full cursor-pointer items-center justify-between border-t border-zinc-200 bg-white p-4 text-sm font-light tracking-[-.01em]",
                                children: [
                                    "Blog Articles Results (",
                                    articleResults === null || articleResults === void 0 ? void 0 : articleResults.length,
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                type: "button",
                                onClick: function() {
                                    return updateMenu("pages", "Page Results", true);
                                },
                                className: "flex w-full cursor-pointer items-center justify-between border-t border-zinc-200 bg-white p-4 text-sm font-light tracking-[-.01em]",
                                children: [
                                    "Page Results (",
                                    pageResults === null || pageResults === void 0 ? void 0 : pageResults.length,
                                    ")"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/sections/SearchResults/SearchEmptyResults.jsx



function SearchEmptyResults(param) {
    var collectionProducts = param.collectionProducts, term = param.term;
    var products = (0,dist.useProductsFromHandles)({
        handles: collectionProducts === null || collectionProducts === void 0 ? void 0 : collectionProducts.map(function(item) {
            return item.handle;
        })
    }).products;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "px-contained mb-12",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                className: "mb-8 text-[26px] font-light tracking-[-.01em] text-primary md:text-4xl",
                children: [
                    "Uh-oh. We couldn’t find anything for ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "“",
                    term,
                    "”"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "mb-6 text-[14px] text-primary md:text-lg ",
                children: [
                    "Try a different search term or take a peek at some of these ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "popular products & collections we think you might like!"
                ]
            }),
            products && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Collection */.FE, {
                handle: "search",
                products: products,
                showHeading: false
            })
        ]
    });
}
SearchEmptyResults.displayName = "SearchEmptyResults";

;// CONCATENATED MODULE: ./src/sections/SearchResults/SearchResults.schema.js
function SearchResults_schema_Schema(param) {
    var page = param.page;
    if ((page === null || page === void 0 ? void 0 : page.handle) !== "search") return null;
    return {
        category: "Search",
        label: "Search Results",
        key: "search-results",
        //   previewSrc:
        //     'https://cdn.shopify.com/s/files/1/0671/5074/1778/files/search-results-preview.jpg?v=1675732833',
        fields: []
    };
}

// EXTERNAL MODULE: ./src/utils/index.js + 4 modules
var src_utils = __webpack_require__(714);
;// CONCATENATED MODULE: ./src/sections/SearchResults/SearchResults.jsx













function SearchResults() {
    var query = (0,next_router.useRouter)().query;
    var sendViewSearchResultsEvent = (0,hooks/* useDataLayerActions */.KZ)().sendViewSearchResultsEvent;
    var ref = (0,react.useState)(query.term), rawTerm = ref[0], setRawTerm = ref[1];
    var ref1 = (0,react.useState)(rawTerm), term = ref1[0], setTerm = ref1[1];
    var ref2 = (0,react.useState)(0), totalCount = ref2[0], setTotalCount = ref2[1];
    var ref3 = (0,react.useState)(null), emptyCollectionProducts = ref3[0], setEmptyCollectionProducts = ref3[1];
    var ref4 = (0,react.useState)("products"), searchType = ref4[0], setSearchType = ref4[1];
    var ref5 = (0,react.useState)(null), products = ref5[0], setProducts = ref5[1];
    var productResults = (0,hooks/* useSearchProductResults */.DV)({
        term: term,
        mounted: true
    }).productResults;
    var collectionResults = (0,hooks/* useSearchCollectionResults */.Mx)({
        term: term
    }).collectionResults;
    var pageResults = (0,hooks/* useSearchPageResults */.v9)({
        term: term
    }).pageResults;
    var articleResults = (0,hooks/* useSearchArticleResults */.rH)({
        term: term
    }).articleResults;
    (0,react.useEffect)(function() {
        // debounce raw term
        var handler = window.requestTimeout(function() {
            setTerm(rawTerm);
            setTotalCount((productResults === null || productResults === void 0 ? void 0 : productResults.length) + (collectionResults === null || collectionResults === void 0 ? void 0 : collectionResults.length) + (articleResults === null || articleResults === void 0 ? void 0 : articleResults.length) + (pageResults === null || pageResults === void 0 ? void 0 : pageResults.length));
        }, 300);
        return function() {
            window.clearRequestTimeout(handler);
        };
    }, [
        rawTerm,
        productResults,
        collectionResults,
        articleResults,
        pageResults
    ]);
    (0,react.useEffect)(function() {
        sendViewSearchResultsEvent({
            products: productResults,
            isSearchPage: true,
            searchTerm: term
        });
    }, [
        productResults,
        sendViewSearchResultsEvent
    ]);
    (0,react.useEffect)(function() {
        var fetchData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var data, json;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fetch("/json/collections/frontpage.json")
                            ];
                        case 1:
                            data = _state.sent();
                            return [
                                4,
                                data.json()
                            ];
                        case 2:
                            json = _state.sent();
                            setEmptyCollectionProducts(json.products);
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData().catch(console.error);
    }, []);
    (0,react.useEffect)(function() {
        if ((term === null || term === void 0 ? void 0 : term.length) < 3) {
            setTotalCount(0);
        }
    }, [
        term
    ]);
    (0,react.useEffect)(function() {
        if (!productResults) {
            setProducts(null);
            return;
        }
        var getFullProducts = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var handles, fullProducts;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            handles = productResults.map(function(param) {
                                var item = param.item;
                                return item === null || item === void 0 ? void 0 : item.handle;
                            });
                            return [
                                4,
                                (0,src_utils/* fetchProductsFromHandles */.H4)(handles)
                            ];
                        case 1:
                            fullProducts = _state.sent();
                            setProducts(fullProducts);
                            return [
                                2
                            ];
                    }
                });
            });
            return function getFullProducts() {
                return _ref.apply(this, arguments);
            };
        }();
        getFullProducts();
    }, [
        productResults
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-clearBlue",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchHeader, {
                rawTerm: rawTerm || null,
                onChange: function(e) {
                    setRawTerm(e.target.value);
                },
                totalCount: totalCount
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "",
                children: (productResults === null || productResults === void 0 ? void 0 : productResults.length) > 0 || (collectionResults === null || collectionResults === void 0 ? void 0 : collectionResults.length) > 0 || (articleResults === null || articleResults === void 0 ? void 0 : articleResults.length) > 0 || (pageResults === null || pageResults === void 0 ? void 0 : pageResults.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "px-contained mb-8 lg:flex",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchFilterMenu, {
                            setSearchType: setSearchType,
                            searchType: searchType,
                            productResults: productResults,
                            collectionResults: collectionResults,
                            pageResults: pageResults,
                            articleResults: articleResults
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full",
                            children: [
                                searchType === "products" && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchList, {
                                    emptyCollectionProducts: emptyCollectionProducts,
                                    results: productResults,
                                    resultName: "Products",
                                    rawTerm: rawTerm,
                                    products: products
                                }),
                                searchType === "collections" && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchList, {
                                    results: collectionResults,
                                    resultUrl: "collections",
                                    resultName: "Collection",
                                    resultCTA: "View Collection"
                                }),
                                searchType === "blog-articles" && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchList, {
                                    results: articleResults,
                                    resultUrl: "articles",
                                    resultName: "Blog Articles",
                                    resultCTA: "Read Article"
                                }),
                                searchType === "pages" && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchList, {
                                    results: pageResults,
                                    resultUrl: "pages",
                                    resultName: "Pages",
                                    resultCTA: "View Page"
                                })
                            ]
                        })
                    ]
                }) : emptyCollectionProducts && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchEmptyResults, {
                    collectionProducts: emptyCollectionProducts,
                    term: term
                })
            })
        ]
    });
}
SearchResults.displayName = "SearchResults";
SearchResults.Schema = SearchResults_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/SearchResults/index.js


// EXTERNAL MODULE: ../node_modules/scrolly-video/dist/ScrollyVideo.cjs.jsx
var ScrollyVideo_cjs = __webpack_require__(1914);
var ScrollyVideo_cjs_default = /*#__PURE__*/__webpack_require__.n(ScrollyVideo_cjs);
;// CONCATENATED MODULE: ./src/sections/ScrollyVideoSection/ScrollyVideoSection.schema.js
function ScrollyVideoSection_schema_Schema() {
    return {
        label: "Scrolly Video Section",
        key: "scrolly-video-section",
        fields: [
            {
                label: "Eyebrow Text",
                name: "eyebrowText",
                component: "text"
            },
            {
                label: "Title",
                name: "title",
                component: "text"
            },
            {
                label: "Video Link",
                name: "videoLink",
                component: "text"
            },
            {
                label: "Video Cards",
                name: "videoCards",
                component: "group-list",
                validate: {
                    maxItems: 4
                },
                fields: [
                    {
                        label: "Title",
                        name: "title",
                        component: "text"
                    },
                    {
                        label: "Icon",
                        name: "icon",
                        component: "image"
                    },
                    {
                        label: "Card Spacing (vh)",
                        name: "cardSpacing",
                        component: "number",
                        defaultValue: "50"
                    },
                    {
                        label: "Subtitle",
                        name: "subtitle",
                        component: "markdown"
                    },
                    {
                        label: "Review Intro",
                        name: "reviewIntro",
                        component: "text"
                    },
                    {
                        label: "Rating",
                        name: "rating",
                        component: "number",
                        defaultValue: 5
                    },
                    {
                        label: "Review Name",
                        name: "reviewName",
                        component: "text"
                    },
                    {
                        label: "Review",
                        name: "review",
                        component: "textarea"
                    },
                    {
                        label: "Date",
                        name: "date",
                        component: "text"
                    }, 
                ]
            },
            {
                label: "Video Cards (Mobile)",
                name: "videoCardsMobile",
                component: "group-list",
                validate: {
                    maxItems: 4
                },
                fields: [
                    {
                        label: "CardVideo Link",
                        name: "cardVideoLink",
                        component: "text"
                    },
                    {
                        label: "Title",
                        name: "title",
                        component: "text"
                    },
                    {
                        label: "Icon",
                        name: "icon",
                        component: "image"
                    },
                    {
                        label: "Subtitle",
                        name: "subtitle",
                        component: "markdown"
                    },
                    {
                        label: "Review Intro",
                        name: "reviewIntro",
                        component: "text"
                    },
                    {
                        label: "Rating",
                        name: "rating",
                        component: "number",
                        defaultValue: 5
                    },
                    {
                        label: "Review Name",
                        name: "reviewName",
                        component: "text"
                    },
                    {
                        label: "Review",
                        name: "review",
                        component: "textarea"
                    },
                    {
                        label: "Date",
                        name: "date",
                        component: "text"
                    }, 
                ]
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/ScrollyVideoSection/ScrollyVideoMobileCard.jsx




function ScrollyVideoMobileCard(param) {
    var card = param.card, index = param.index;
    var ref = (0,react_intersection_observer/* useInView */.YD)({
        threshold: 0.5,
        triggerOnce: true
    }), ref1 = ref.ref, inView = ref.inView;
    var videoRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (!videoRef.current) return;
        if (inView) {
            videoRef.current.play();
        } else {
            videoRef.current.pause();
        }
    }, [
        ref1,
        inView
    ]);
    var isFirstItem = index === 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "sticky top-0 flex h-screen flex-col items-center justify-center bg-white pb-20 pt-[var(--header-height)]",
        ref: ref1,
        children: [
            !isFirstItem && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-0 h-[5vh] w-full bg-gradient-to-t from-[#ffffff] to-[#e6f0f8]"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                className: "mx-auto w-full max-w-[400px]",
                ref: videoRef,
                src: card.cardVideoLink,
                muted: true,
                loop: true,
                playsInline: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "scroll-video__mob__bottom mx-5 mt-4 text-center",
                children: [
                    card.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                        className: "mx-auto mb-2 pt-0 max-sm:w-[24px]",
                        sizes: "48px",
                        width: "24px",
                        height: "24px",
                        src: card.icon.src,
                        alt: card.icon.alt
                    }),
                    card.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "mb-2 text-[18px] font-normal",
                        children: card.title
                    }),
                    card.subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Markdown */.UG, {
                        className: "scrolly-video__mob__subtitle",
                        children: card.subtitle
                    })
                ]
            })
        ]
    }, index);
}

;// CONCATENATED MODULE: ./src/sections/ScrollyVideoSection/ScrollyVideoSection.jsx


// eslint-disable-next-line import/extensions






var getCardWrapperClasses = function(index) {
    var justifyEndClass = index % 2 === 1 ? "justify-end" : "justify-start text-right";
    return "scrolly-video__card-wrap flex items-start z-[1] relative md:mx-[2rem] lg:mx-[0rem] h-[100vh] ".concat(justifyEndClass);
};
function ScrollyVideoSection(param) {
    var cms = param.cms;
    var videoLink = cms.videoLink, videoCards = cms.videoCards, eyebrowText = cms.eyebrowText, title = cms.title, videoCardsMobile = cms.videoCardsMobile;
    var cardsWithReviews = videoCardsMobile.filter(function(card) {
        return card.review;
    });
    var isMobile = utils_useMediaQuery("(max-width: 767px)");
    var ref = (0,react.useState)(false), shouldShow = ref[0], setShouldShow = ref[1];
    (0,react.useEffect)(function() {
        if (isMobile) {
            setShouldShow(false);
        } else {
            setShouldShow(true);
        }
    }, [
        isMobile
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "scrolly-video relative bg-white",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "scrolly-video__heading mx-auto mb-0 w-full bg-transparent px-2 pt-16 text-center text-[#202635] md:absolute md:left-1/2 md:top-[7rem] md:z-[1] md:-translate-x-1/2 md:-translate-y-1/2 md:pb-10",
                children: [
                    eyebrowText && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-md mb-4 max-sm:text-[0.813rem]",
                        children: eyebrowText
                    }),
                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-[3.5rem] font-light leading-snug max-sm:text-[2rem]",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "scrolly-video__desk px-contained hidden h-[700vh] md:block",
                children: [
                    shouldShow ? /*#__PURE__*/ (0,jsx_runtime.jsx)((ScrollyVideo_cjs_default()), {
                        src: videoLink
                    }) : "",
                    videoCards.map(function(card, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: getCardWrapperClasses(index),
                            style: {
                                marginBottom: "".concat(card.cardSpacing, "vh")
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "scrolly-video__card-info sticky top-[30vh] rounded-lg bg-gradient-to-t from-[#ffffff] to-[#e6f0f8] p-[18px] text-[#202635] shadow-xl sm:max-w-[275px] lg:max-w-[375px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mb-2 inline-flex items-center text-lg font-normal ".concat(index % 2 === 1 ? "flex-row-reverse" : "flex-row"),
                                        children: [
                                            card.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                className: "text-xl font-normal",
                                                children: card.title
                                            }),
                                            card.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                                className: "mx-auto pt-0 max-sm:w-[18px] ".concat(index % 2 === 1 ? "mr-2" : "ml-2"),
                                                sizes: "48px",
                                                width: "24px",
                                                height: "24px",
                                                src: card.icon.src,
                                                alt: card.icon.alt
                                            })
                                        ]
                                    }),
                                    card.subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Markdown */.UG, {
                                        className: "scrolly-video__desk__subtitle",
                                        children: card.subtitle
                                    }),
                                    card.reviewIntro && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "text-md mb-4 font-normal text-[#0064B7]",
                                        children: [
                                            card.reviewIntro,
                                            ":"
                                        ]
                                    }),
                                    card.review && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "scrolly-video__card rounded-lg border-[0.0625rem] border-[#202635] p-[1rem] text-left",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* ReviewStars */.Hm, {
                                                rating: card.rating,
                                                color: "#2179C2"
                                            }),
                                            card.reviewName && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-md mb-2 mt-2 font-normal",
                                                children: card.reviewName
                                            }),
                                            card.review && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "mb-4 text-sm font-light",
                                                children: card.review
                                            }),
                                            card.date && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-xs",
                                                children: card.date
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, index);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "scrolly-video__mob",
                children: [
                    cardsWithReviews.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                        slidesPerView: 1.3,
                        centeredSlides: true,
                        loop: true,
                        spaceBetween: 7,
                        children: videoCardsMobile.map(function(card, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: card.review && /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                    className: "hidden pt-24 max-md:block",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mb-4 text-center",
                                        children: [
                                            card.reviewIntro && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "text-md mb-4 font-normal text-[#0064B7]",
                                                children: [
                                                    card.reviewIntro,
                                                    ":"
                                                ]
                                            }),
                                            card.review && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "scrolly-video__card flex h-[17rem] flex-col items-start justify-center rounded-lg bg-[#E6F0F8] p-[25px] text-left shadow-lg",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* ReviewStars */.Hm, {
                                                        rating: card.rating,
                                                        color: "#2179C2"
                                                    }),
                                                    card.reviewName && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "mb-2 mt-2 text-lg font-normal",
                                                        children: card.reviewName
                                                    }),
                                                    card.review && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-md mb-4 font-light",
                                                        children: card.review
                                                    }),
                                                    card.date && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-sm",
                                                        children: card.date
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }, index)
                            });
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hidden scrollbar-hide max-md:block",
                        children: videoCardsMobile.map(function(card, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollyVideoMobileCard, {
                                card: card,
                                index: index
                            }, "scrolly-mobile-card-".concat(index));
                        })
                    })
                ]
            })
        ]
    });
}
ScrollyVideoSection.Schema = ScrollyVideoSection_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/ScrollyVideoSection/index.js


;// CONCATENATED MODULE: ./src/sections/SimpleHeroBanner/SimpleHeroBanner.schema.js
function SimpleHeroBanner_schema_Schema() {
    return {
        category: "Hero",
        label: "Simple Hero Banner",
        key: "simpleHeroBanner",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/simple-hero-banner.png?v=1721400498",
        fields: [
            {
                label: "Condense Hero Height",
                name: "condensedHero",
                description: "This is a toggle to condense the height of the hero banner.",
                component: "toggle",
                defaultValue: false
            },
            {
                label: "Heading",
                name: "heading",
                component: "text",
                defaultValue: "Lorem Ipsum Dolor Sit Amet"
            },
            {
                label: "Call To Action",
                name: "cta",
                component: "link"
            },
            {
                label: "Link",
                name: "link",
                component: "link"
            },
            {
                label: "Link ID",
                name: "linkId",
                component: "text",
                description: "Add the section ID you would like the button to scroll down/up to."
            },
            {
                label: "Button Theme",
                name: "theme",
                component: "select",
                options: [
                    {
                        label: "Primary",
                        value: "primary"
                    },
                    {
                        label: "Secondary",
                        value: "secondary"
                    },
                    {
                        label: "Light",
                        value: "light"
                    }, 
                ]
            },
            {
                label: "Button Variant",
                name: "variant",
                component: "select",
                options: [
                    {
                        label: "Filled",
                        value: "filled"
                    },
                    {
                        label: "Outlined",
                        value: "outlined"
                    }, 
                ],
                defaultValue: "filled"
            },
            {
                label: "Background Image",
                name: "backgroundImage",
                component: "image"
            },
            {
                label: "Background Image (Mobile)",
                name: "backgroundImageMobile",
                component: "image"
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/SimpleHeroBanner/SimpleHeroBanner.jsx






function SimpleHeroBanner(param) {
    var cms = param.cms;
    var heading = cms.heading, cta = cms.cta, theme = cms.theme, variant = cms.variant, linkId = cms.linkId, condensedHero = cms.condensedHero, backgroundImage = cms.backgroundImage, backgroundImageMobile = cms.backgroundImageMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative bg-accent3Opacity20",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "px-contained relative overflow-hidden ".concat(condensedHero ? "py-10" : "py-72", " max-sm:py-48 text-center"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "bg-content absolute inset-0 z-[1] h-full w-full bg-orange-300/10",
                    children: [
                        backgroundImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                            src: backgroundImage.src,
                            alt: backgroundImage.alt,
                            width: 2000,
                            height: 1200,
                            className: "hidden h-full w-full object-cover md:block"
                        }),
                        backgroundImageMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                            src: backgroundImageMobile.src,
                            alt: backgroundImageMobile.alt,
                            width: 2000,
                            height: 1200,
                            className: "h-full w-full object-cover md:hidden"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute inset-0 bg-black opacity-50 z-[1]"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "p-8 relative z-[1]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                            variant: "h2",
                            element: "h2",
                            className: "relative font-light text-white max-sm:text-[30px] max-sm:max-w-72 max-sm:mx-auto",
                            children: heading
                        }),
                        cta && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-0 lg:mt-6 max-sm:w-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                href: linkId ? "#".concat(linkId) : cta.url,
                                theme: theme,
                                variant: variant,
                                className: "mt-6 max-sm:w-full",
                                wrapperClassName: "max-sm:w-full",
                                onClick: function(event) {
                                    return linkId && handleScroll(event, "#".concat(linkId));
                                },
                                children: cta === null || cta === void 0 ? void 0 : cta.text
                            })
                        })
                    ]
                })
            ]
        })
    });
}
SimpleHeroBanner.displayName = "Simple Hero Banner";
SimpleHeroBanner.Schema = SimpleHeroBanner_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/SimpleHeroBanner/index.js


;// CONCATENATED MODULE: ./src/sections/ImageWithTextLanding/ImageWithTextLanding.schema.js
function ImageWithTextLanding_schema_Schema() {
    return {
        label: "Image With Text Landing",
        key: "imageWithTextLanding",
        category: "Text",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/imagewithtextlayout.png?v=1721663759",
        fields: [
            {
                label: "Dark Mode",
                name: "darkMode",
                description: "Set The Background dark and text white",
                component: "toggle",
                defaultValue: false
            },
            {
                label: "Extra Top Padding",
                name: "topPadding",
                description: "Add extra top padding to section.",
                component: "toggle",
                defaultValue: false
            },
            {
                label: "Extra Bottom Padding",
                name: "bottomPadding",
                description: "Add extra bottom padding to section",
                component: "toggle",
                defaultValue: false
            },
            {
                label: "Align Text With Image",
                name: "alignTextWithImage",
                description: "Align text next to the image toggle",
                component: "toggle",
                defaultValue: false
            },
            {
                name: "image",
                label: "Image",
                component: "image"
            },
            {
                label: "Image (mobile)",
                name: "mobileImage",
                component: "image"
            },
            {
                label: "Image Alignment",
                name: "imageAlignment",
                component: "select",
                options: [
                    {
                        label: "Left",
                        value: "left"
                    },
                    {
                        label: "Right",
                        value: "right"
                    }, 
                ],
                defaultValue: "left"
            },
            {
                label: "Eyebrow Icon Image",
                name: "eyebrowIconImage",
                component: "image"
            },
            {
                name: "eyebrow",
                label: "Eyebrow Text",
                component: "text"
            },
            {
                name: "heading",
                label: "Heading",
                component: "text"
            },
            {
                name: "content",
                label: "Content",
                component: "markdown"
            },
            {
                name: "buttonLink",
                label: "Button Link",
                component: "link"
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/ImageWithTextLanding/ImageWithTextLanding.jsx



function ImageWithTextLanding(param) {
    var cms = param.cms;
    var eyebrow = cms.eyebrow, heading = cms.heading, image = cms.image, imageAlignment = cms.imageAlignment, eyebrowIconImage = cms.eyebrowIconImage, alignTextWithImage = cms.alignTextWithImage, topPadding = cms.topPadding, bottomPadding = cms.bottomPadding, content = cms.content, buttonLink = cms.buttonLink, darkMode = cms.darkMode, mobileImage = cms.mobileImage;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: darkMode ? "dark" : "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "dark:bg-[#202635] dark:text-white ".concat(topPadding ? "pt-[25px]" : "md:pt-[0px]", " ").concat(bottomPadding ? "pb-[55px]" : "md:pb-[0px]"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: [
                    "px-contained } mx-auto max-w-[var(--content-max-width)] pb-[0px] max-md:pt-[25px] md:pb-[25px] md:pt-[50px]", 
                ].join(" "),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "unique-technology grid grid-cols-1 lg:grid-cols-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "content-column ".concat(alignTextWithImage && imageAlignment === "right" ? "lg:justify-end lg:text-right" : "", " :order-1 order-1 flex items-center border-t border-t-[#FFFFFF33] p-4 py-[60px] max-lg:px-[0px] max-lg:pb-[25px] max-lg:pt-[10px] lg:border-t-0 lg:px-[50px] ").concat(imageAlignment === "left" ? "order-1" : "order-0"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "inline-flex items-center ".concat(imageAlignment === "right" ? "lg:flex-row-reverse" : "flex-row"),
                                        children: [
                                            eyebrowIconImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                                className: "mx-auto max-sm:w-[18px]",
                                                sizes: "48px",
                                                width: "24px",
                                                height: "24px",
                                                src: eyebrowIconImage.src
                                            }),
                                            eyebrow && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Eyebrow */.j4, {
                                                children: eyebrow
                                            })
                                        ]
                                    }),
                                    heading && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                                        variant: "h3",
                                        element: "h2",
                                        className: "mb-[10px] max-md:text-[22px]",
                                        children: heading
                                    }),
                                    content && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-[14px] sm:text-[18px] [&_p:not(:first-child)_strong]:border-t [&_p:not(:first-child)_strong]:border-t-[#FFFFFF33] [&_p:not(:first-child)_strong]:pt-6 [&_strong]:mt-6 [&_strong]:block [&_strong]:text-[16px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Markdown */.UG, {
                                            children: content
                                        })
                                    }),
                                    buttonLink && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Button */.zx, {
                                            href: buttonLink === null || buttonLink === void 0 ? void 0 : buttonLink.url,
                                            theme: "primary",
                                            variant: "filled",
                                            children: buttonLink === null || buttonLink === void 0 ? void 0 : buttonLink.text
                                        })
                                    })
                                ]
                            })
                        }),
                        (image || mobileImage) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "image-column  order-0 relative block h-[276px] w-full py-6 lg:h-[600px] ".concat(imageAlignment === "left" ? "lg:order-0" : "lg:order-1"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                    src: mobileImage ? mobileImage.src : image === null || image === void 0 ? void 0 : image.src,
                                    alt: heading,
                                    fill: true,
                                    className: "block lg:hidden"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                    src: image === null || image === void 0 ? void 0 : image.src,
                                    alt: heading,
                                    fill: true,
                                    className: "hidden lg:block"
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}
ImageWithTextLanding.displayName = "Image With Text Landing";
ImageWithTextLanding.Schema = ImageWithTextLanding_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/ImageWithTextLanding/index.js


;// CONCATENATED MODULE: ./src/sections/ValueProps/ValueProps.schema.js

function ValueProps_schema_Schema() {
    return {
        category: "Text",
        label: "Value Props",
        key: "value-props",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/Screen_20Shot_202023-05-23_20at_2010.47.21_20AM.png?v=1684864574",
        fields: [
            {
                label: "Section Title",
                name: "sectionTitle",
                component: "text"
            },
            {
                label: "Value Prop",
                name: "valueProp",
                component: "group-list",
                itemProps: {
                    label: "{{item.header}}"
                },
                fields: [
                    {
                        label: "Image",
                        name: "image",
                        component: "image"
                    },
                    {
                        label: "Header",
                        name: "header",
                        component: "text"
                    },
                    {
                        label: "Copy",
                        name: "copy",
                        component: "text"
                    }, 
                ],
                defaultValue: [
                    {
                        header: "Save 10% on Every Replacement Filter",
                        copy: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque."
                    },
                    {
                        header: "Get Free Shipping (in the USA)",
                        copy: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque."
                    },
                    {
                        header: "Customize Your Schedule",
                        copy: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque."
                    },
                    {
                        header: "Cancel Anytime",
                        copy: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque."
                    }, 
                ],
                defaultItem: {
                    header: "Save 10% on Every Replacement Filter",
                    copy: "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque."
                }
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/ValueProps/ValueProps.jsx





var valuePropItem = function(image, header, copy, index) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative mb-4 px-6 text-center lg:mb-8 lg:w-1/4",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "",
            children: [
                image && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                    className: "mx-auto mb-6",
                    sizes: "48px",
                    width: "44px",
                    height: "44px",
                    src: image.src
                }),
                header && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "letter mb-4 text-lg font-light leading-6 tracking-[-.01em] lg:text-xl",
                    children: header
                }),
                copy && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-base",
                    children: copy
                })
            ]
        })
    }, "value-prop-item-".concat(index));
};
function ValueProps(param) {
    var cms = param.cms;
    var valueProp = cms.valueProp, sectionTitle = cms.sectionTitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "px-contained lg:py-contained mx-auto mb-10 bg-[#B3D1E94D] pb-14 pt-4 lg:mb-16 lg:border-b lg:border-zinc-200 lg:bg-clearBlue",
        children: [
            sectionTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "text-center text-[3rem] font-light max-sm:text-[1.625rem] md:mb-6",
                children: sectionTitle
            }),
            (valueProp === null || valueProp === void 0 ? void 0 : valueProp.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mx-auto flex max-w-none flex-col items-center gap-4 text-center md:gap-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-4 hidden flex-wrap justify-center lg:flex",
                        children: valueProp.map(function(param, index) {
                            var image = param.image, header = param.header, copy = param.copy;
                            return valuePropItem(image, header, copy, index);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                        className: "!static mt-10 w-full lg:hidden",
                        grabCursor: true,
                        loop: valueProp.length > 1,
                        pagination: {
                            el: ".swiper-pagination__value-props",
                            type: "bullets",
                            clickable: true,
                            renderBullet: function renderBullet(_, className) {
                                return '<span class="!bg-primary '.concat(className, '"></span>');
                            }
                        },
                        modules: [
                            modules/* Pagination */.tl
                        ],
                        slidesPerView: 1,
                        spaceBetween: 16,
                        breakpoints: {
                            1024: {
                                loop: valueProp.length >= 6,
                                slidesPerView: 3,
                                spaceBetween: 0
                            }
                        },
                        children: valueProp.map(function(param, index) {
                            var image = param.image, header = param.header, copy = param.copy;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                children: valuePropItem(image, header, copy)
                            }, "value-prop-".concat(index));
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "swiper-pagination swiper-pagination__value-props !static lg:!hidden"
                    })
                ]
            })
        ]
    });
}
ValueProps.displayName = "ValueProps";
ValueProps.Schema = ValueProps_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/ValueProps/index.js


;// CONCATENATED MODULE: ./src/sections/VideoBanner/VideoBanner.schema.js




function VideoBanner_schema_Schema() {
    return {
        label: "Video Section",
        key: "video-section",
        fields: [
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, schemas_eyebrow), {
                defaultValue: "THE CLEARLY FILTERED DIFFERENCE"
            }),
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, schemas_headline), {
                defaultValue: "Advanced Filters that Set a New Standard"
            }),
            {
                label: "Content",
                name: "content",
                component: "markdown"
            },
            {
                label: "Vimeo URL",
                name: "videoUrl",
                component: "text"
            },
            {
                label: "Image",
                name: "image",
                component: "image"
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/VideoBanner/VideoBanner.jsx





function VideoBanner(param) {
    var cms = param.cms;
    var eyebrow = cms.eyebrow, headline = cms.headline, content = cms.content, videoUrl = cms.videoUrl, image = cms.image;
    var ref = (0,react.useState)(false), isPlaying = ref[0], setIsPlaying = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "bg-[#202635] py-20 text-[#FFFFFF]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "px-contained mx-auto max-w-[var(--content-max-width)] space-y-10",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mx-auto max-w-[55.75rem] space-y-6 text-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Eyebrow */.j4, {
                            children: eyebrow
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                            variant: "h3",
                            children: headline
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Body */.uT, {
                            variant: "medium",
                            element: "div",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Markdown */.UG, {
                                children: content
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "video group relative mx-auto aspect-video lg:w-2/3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative h-full cursor-pointer lg:mx-0",
                        onClick: function() {
                            return setIsPlaying(true);
                        },
                        tabIndex: 0,
                        onKeyPress: function(e) {
                            return e.key === "Enter" && setIsPlaying(true);
                        },
                        role: "button",
                        children: isPlaying && videoUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Vimeo, {
                            video: videoUrl,
                            width: "100%",
                            height: "100%",
                            autoplay: true,
                            muted: true,
                            responsive: true,
                            className: "vimeo-player absolute inset-0"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                (image === null || image === void 0 ? void 0 : image.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                    className: "absolute mx-auto w-full",
                                    fill: true,
                                    src: image === null || image === void 0 ? void 0 : image.src
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* PlayButton */.JM, {})
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}
VideoBanner.Schema = VideoBanner_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/VideoBanner/index.js


;// CONCATENATED MODULE: ./src/sections/VideoSlider/VideoSlider.schema.js
var VideoSlider_schema_Schema = function() {
    return {
        label: "Video Slider",
        category: "Slider",
        key: "videoSlider",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/What_is_Testing_d2572378-3760-4039-96e2-5be32928fad4.jpg?v=1752878794",
        fields: [
            {
                label: "Heading",
                name: "heading",
                component: "text",
                defaultValue: "What others are saying"
            },
            {
                label: "Video Slides",
                name: "videoSlides",
                component: "group-list",
                description: "We recommend adding at a minimum 10 slides to ensure proper looping.",
                itemProps: {
                    label: "{{item.title}}"
                },
                fields: [
                    {
                        label: "Title",
                        name: "title",
                        component: "text"
                    },
                    {
                        label: "Video URL",
                        name: "videoUrl",
                        component: "text"
                    },
                    {
                        label: "Poster Image",
                        name: "videoPoster",
                        component: "image",
                        description: "First frame of video while video loads"
                    },
                    {
                        name: "product",
                        label: "Product",
                        component: "productSearch"
                    },
                    {
                        label: "Override Product Image",
                        name: "productImage",
                        component: "image",
                        description: "Use this image instead of the products default first image"
                    },
                    {
                        label: "Override Product Image Alt Text",
                        name: "productImageAlt",
                        component: "text"
                    }, 
                ]
            }, 
        ]
    };
};
/* harmony default export */ var VideoSlider_schema = (VideoSlider_schema_Schema);

;// CONCATENATED MODULE: ./src/sections/VideoSlider/VideoSlide.jsx




function VideoSlide(param) {
    var videoSlide = param.videoSlide, activeVideoSlide = param.activeVideoSlide, setActiveVideoSlide = param.setActiveVideoSlide, globalMuteState = param.globalMuteState, setGlobalMuteState = param.setGlobalMuteState, slideIndex = param.slideIndex;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    var videoUrl = videoSlide.videoUrl, videoPoster = videoSlide.videoPoster, product = videoSlide.product, productImage = videoSlide.productImage, productImageAlt = videoSlide.productImageAlt;
    var imageSrc = (productImage === null || productImage === void 0 ? void 0 : productImage.src) || (product === null || product === void 0 ? void 0 : (ref = product.data) === null || ref === void 0 ? void 0 : (ref1 = ref.images) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.originalSrc);
    var ref13, ref14;
    var imageAlt = (ref14 = (ref13 = productImageAlt !== null && productImageAlt !== void 0 ? productImageAlt : productImage === null || productImage === void 0 ? void 0 : productImage.alt) !== null && ref13 !== void 0 ? ref13 : product === null || product === void 0 ? void 0 : (ref3 = product.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.images) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[0]) === null || ref5 === void 0 ? void 0 : ref5.altText) !== null && ref14 !== void 0 ? ref14 : product === null || product === void 0 ? void 0 : (ref6 = product.data) === null || ref6 === void 0 ? void 0 : ref6.title;
    var videoRef = (0,react.useRef)(null);
    var videoSlideId = slideIndex;
    var ref15 = (0,react.useState)(false), isHovered = ref15[0], setIsHovered = ref15[1];
    var ref16 = (0,react.useState)(true), isMuted = ref16[0], setIsMuted = ref16[1];
    var ref17 = (0,react.useState)(false), isPlaying = ref17[0], setIsPlaying = ref17[1];
    var ref18 = (0,dist.useProductByHandle)({
        handle: product === null || product === void 0 ? void 0 : (ref7 = product.data) === null || ref7 === void 0 ? void 0 : ref7.handle
    }), fullProduct = ref18.product;
    var priceMin = parseFloat((fullProduct === null || fullProduct === void 0 ? void 0 : (ref8 = fullProduct.priceRange) === null || ref8 === void 0 ? void 0 : ref8.min) || 0);
    var priceMax = parseFloat((fullProduct === null || fullProduct === void 0 ? void 0 : (ref9 = fullProduct.priceRange) === null || ref9 === void 0 ? void 0 : ref9.max) || 0);
    /* --- EVENT HANDLERS --- */ var playVideo = function() {
        setIsPlaying(true);
        videoRef.current.play();
        if (globalMuteState === false) {
            setIsMuted(false);
        }
    };
    var pauseVideo = function() {
        if (videoRef.current) {
            setIsPlaying(false);
            videoRef.current.pause();
            // Additionally mute the video when pausing to prevent audio leakage
            setIsMuted(true);
            videoRef.current.muted = true;
        }
    };
    var handleClick = function() {
        if (isMuted && isPlaying) {
            setIsMuted(false);
            setGlobalMuteState(false);
        } else if (!isMuted && isPlaying) {
            pauseVideo();
        } else {
            playVideo();
        }
    };
    var handleFocus = function() {
        setActiveVideoSlide(videoSlideId);
    };
    var handlePauseButtonClick = function() {
        if (isPlaying) {
            pauseVideo();
        } else {
            playVideo();
        }
    };
    var handleMuteButtonClick = function() {
        setIsMuted(!isMuted);
        setGlobalMuteState(!isMuted);
    };
    /* --- EFFECTS --- */ (0,react.useEffect)(function() {
        if (activeVideoSlide !== videoSlideId) {
            pauseVideo();
            setIsHovered(false);
        } else {
            playVideo();
            setIsHovered(true);
        }
    }, [
        activeVideoSlide,
        videoSlide
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative aspect-[3/4] w-full",
                onFocus: handleFocus,
                onMouseEnter: handleFocus,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                        ref: videoRef,
                        src: videoUrl,
                        poster: videoPoster === null || videoPoster === void 0 ? void 0 : videoPoster.src,
                        loop: true,
                        playsInline: true,
                        muted: isMuted,
                        className: "h-full w-full object-cover",
                        onClick: handleClick
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute right-1 top-1 text-white",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: "flex h-[34px] w-[34px] items-center justify-center rounded-full p-1",
                            onClick: handleMuteButtonClick,
                            "aria-label": isMuted ? "Un-mute video" : "Mute video",
                            children: isMuted ? /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                                src: "/svgs/video-sound-off.svg#video-sound-off",
                                viewBox: "0 0 24 24"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                                src: "/svgs/video-sound-on.svg#video-sound-on",
                                viewBox: "0 0 24 24"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute bottom-1 right-1 text-white",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: "".concat(isHovered ? "opacity-50" : "opacity-0", " ").concat(isPlaying ? "opacity-50" : "!opacity-100", " flex h-[34px] w-[34px] items-center justify-center rounded-full p-1 transition-opacity duration-200"),
                            onClick: handlePauseButtonClick,
                            "aria-label": isPlaying ? "Pause video" : "Play video",
                            children: isPlaying ? /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                                src: "/svgs/video-pause.svg#video-pause",
                                viewBox: "0 0 36 36"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                                src: "/svgs/video-play.svg#video-play",
                                viewBox: "0 0 36 36"
                            })
                        })
                    })
                ]
            }),
            product && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative mt-6 border-t border-[#DDE2E7] pt-6 text-xs",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "overflow flex flex-row text-primary",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-[96px] shrink-0",
                            children: imageSrc && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative aspect-square w-full border border-[#DDE2E7] bg-white",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                                    src: imageSrc,
                                    alt: imageAlt,
                                    loading: "lazy",
                                    quality: 100,
                                    sizes: "400px",
                                    fill: true
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-[calc(100%-96px)] pl-4",
                            children: [
                                (product === null || product === void 0 ? void 0 : (ref10 = product.data) === null || ref10 === void 0 ? void 0 : ref10.title) && (product === null || product === void 0 ? void 0 : (ref11 = product.data) === null || ref11 === void 0 ? void 0 : ref11.handle) && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "after:absolute after:inset-0 after:block after:h-full after:w-full after:content-['']",
                                    href: "/products/".concat(product === null || product === void 0 ? void 0 : (ref12 = product.data) === null || ref12 === void 0 ? void 0 : ref12.handle),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "overflow-hidden text-ellipsis whitespace-nowrap text-lg font-light leading-normal",
                                        children: product.data.title
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-2 text-[16px]",
                                    children: priceMin === priceMax ? "$".concat(priceMin.toFixed(2)) : "$".concat(priceMin.toFixed(2), " - $").concat(priceMax.toFixed(2))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-3 flex aspect-square w-[32px] items-center justify-center rounded-full border bg-secondary text-white",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                                        className: "w-5 text-current",
                                        src: "/svgs/plus.svg#plus",
                                        title: "Down",
                                        viewBox: "0 0 24 24"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/sections/VideoSlider/VideoSlider.jsx







function VideoSlider(param) {
    var cms = param.cms;
    var heading = cms.heading, videoSlides = cms.videoSlides;
    var carouselId = (0,react.useId)();
    var ref = (0,react.useState)(null), activeVideoSlide = ref[0], setActiveVideoSlide = ref[1];
    var ref1 = (0,react.useState)(true), globalMuteState = ref1[0], setGlobalMuteState = ref1[1];
    var sliderRef = (0,react.useRef)(null);
    var prefersReducedMotion = function() {
        // bail if user prefers reduced motion
        var checkReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
        return (checkReducedMotion === null || checkReducedMotion === void 0 ? void 0 : checkReducedMotion.matches) === true;
    };
    // handle IntersectionObserver for mobile
    (0,react.useEffect)(function() {
        var handleIntersection = function handleIntersection(entries, observer) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    // setActiveVideoSlide(videoSlideId);
                    setActiveVideoSlide(0);
                    // only observe once
                    observer.unobserve(entry.target);
                }
            });
        };
        if (false) {}
        if (window.innerWidth >= 575) return;
        if (prefersReducedMotion()) return;
        if (!videoSlides.length) return;
        var observer = new IntersectionObserver(handleIntersection, {
            root: null,
            rootMargin: "0px",
            threshold: 0.8
        });
        observer.observe(sliderRef.current);
    }, []);
    var handleSlideChange = function(swiper) {
        var _realIndex;
        var newIndex = (_realIndex = swiper.realIndex) !== null && _realIndex !== void 0 ? _realIndex : null;
        setActiveVideoSlide(newIndex);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "bg-clearBlue py-20",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "space-y-10",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-auto max-w-[55.75rem] space-y-6 text-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                        variant: "h3",
                        children: heading
                    })
                }),
                videoSlides && videoSlides.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "px-contained relative",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                        ref: sliderRef,
                        loop: true,
                        grabCursor: true,
                        slidesPerView: 1,
                        spaceBetween: 16,
                        navigation: {
                            nextEl: '[data-swiper-nav-id="carousel-'.concat(carouselId, '-next"]'),
                            prevEl: '[data-swiper-nav-id="carousel-'.concat(carouselId, '-prev"]'),
                            disabledClass: "cursor-not-allowed opacity-20"
                        },
                        pagination: {
                            type: "progressbar",
                            el: '[data-swiper-nav-id="carousel-'.concat(carouselId, '-pagination"]')
                        },
                        modules: [
                            modules/* Navigation */.W_,
                            modules/* Pagination */.tl
                        ],
                        breakpoints: {
                            // Tablet - Portrait
                            575: {
                                slidesPerView: 3.25
                            },
                            // Tablet - Landscape
                            768: {
                                slidesPerView: 3.5
                            },
                            // Desktop
                            1200: {
                                slidesPerView: 5
                            }
                        },
                        onSlideChange: handleSlideChange,
                        className: "pb-8",
                        children: [
                            videoSlides === null || videoSlides === void 0 ? void 0 : videoSlides.map(function(slide, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoSlide, {
                                        activeVideoSlide: activeVideoSlide,
                                        setActiveVideoSlide: setActiveVideoSlide,
                                        globalMuteState: globalMuteState,
                                        setGlobalMuteState: setGlobalMuteState,
                                        videoSlide: slide,
                                        slideIndex: index
                                    })
                                }, index);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                type: "button",
                                title: "Previous Slide",
                                className: "absolute left-2 top-1/4 z-10 flex !h-[28px] !w-[28px] translate-y-full items-center justify-center rounded-full bg-white after:hidden",
                                "data-swiper-nav-id": "carousel-".concat(carouselId, "-prev"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "sr-only",
                                        children: "Previous Slide"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                                        className: "w-[0.8rem] text-black",
                                        src: "/svgs/arrow-left.svg#arrow-left",
                                        title: "Arrow Left",
                                        viewBox: "0 0 24 24"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                type: "button",
                                title: "Next Slide",
                                className: "absolute left-auto right-2 top-1/4 z-10 flex !h-[28px] !w-[28px] translate-y-full items-center justify-center rounded-full bg-white after:hidden",
                                "data-swiper-nav-id": "carousel-".concat(carouselId, "-next"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "sr-only",
                                        children: "Next Slide"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                                        className: "w-[0.8rem] text-black",
                                        src: "/svgs/arrow-right.svg#arrow-right",
                                        title: "Arrow Right",
                                        viewBox: "0 0 24 24"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "swiper-pagination !top-auto bottom-0 left-0 right-0 z-10 h-1 bg-white",
                                style: {
                                    "--swiper-pagination-color": "var(--secondary)"
                                },
                                "data-swiper-nav-id": "carousel-".concat(carouselId, "-pagination")
                            })
                        ]
                    })
                })
            ]
        })
    });
}
VideoSlider.Schema = VideoSlider_schema;

;// CONCATENATED MODULE: ./src/sections/VideoSlider/index.js


// EXTERNAL MODULE: ../node_modules/he/he.js
var he = __webpack_require__(7842);
;// CONCATENATED MODULE: ./src/contexts/ewgContext.js

var EWGContext = /*#__PURE__*/ (0,react.createContext)(null);
var useEWGContext = function() {
    return (0,react.useContext)(EWGContext);
};

;// CONCATENATED MODULE: ./src/sections/WIWYTopContaminants/WIYWTopContaminants.schema.js
function WIYWTopContaminants_schema_Schema(param) {
    var pageHandle = param.pageHandle;
    if (pageHandle !== "whats-in-your-water") return null;
    return {
        label: "WIYW Top Contaminants",
        key: "WIYWTopContaminants",
        category: "WIYW",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/top-contaminants.png",
        fields: []
    };
}

;// CONCATENATED MODULE: ./src/sections/WIWYTopContaminants/WIYWTopContaminants.jsx




// import { Pagination } from 'swiper/modules';




function WIYWTopContaminants() {
    var ref = useEWGContext(), EWGResultsTop3Contaminants = ref.EWGResultsTop3Contaminants, activeEWGSystem = ref.activeEWGSystem, EWGResults = ref.EWGResults;
    var print = function() {
        window.print();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-contained relative mx-auto max-w-[var(--content-max-width)] py-[30px] text-center print:hidden md:py-[60px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "top-contaminants-header",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Eyebrow */.j4, {
                                className: "uppercase",
                                children: "Top Contaminants"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(snippets/* Headline */.s0, {
                                variant: "h3",
                                element: "h2",
                                children: [
                                    "Most Harmful Contaminants in",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-[500]",
                                        children: (0,he.decode)((activeEWGSystem === null || activeEWGSystem === void 0 ? void 0 : activeEWGSystem.SystemName) || "N/A")
                                    })
                                ]
                            })
                        ]
                    }),
                    EWGResultsTop3Contaminants && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "top-contaminants-body py-[60px]",
                                children: [
                                    (EWGResultsTop3Contaminants === null || EWGResultsTop3Contaminants === void 0 ? void 0 : EWGResultsTop3Contaminants.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                        className: "w-full",
                                        modules: [
                                            modules/* Pagination */.tl
                                        ],
                                        pagination: {
                                            el: ".top-contaminants-pagination-container",
                                            type: "bullets",
                                            clickable: true,
                                            bulletActiveClass: "!bg-[#202635]",
                                            lockClass: "hidden",
                                            renderBullet: function renderBullet(_, className) {
                                                return '<span class="block !mx-2 bg-[#8a8d97] w-2 h-2 rounded-full '.concat(className, ' opacity-100"></span>');
                                            }
                                        },
                                        spaceBetween: 20,
                                        slidesPerView: 1,
                                        breakpoints: {
                                            640: {
                                                slidesPerView: 2
                                            },
                                            1024: {
                                                slidesPerView: 3
                                            }
                                        },
                                        children: EWGResultsTop3Contaminants.map(function(contaminant, contaminantIndex) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                                className: "h-auto w-full self-stretch py-2",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* ContaminantResultCard */.Ov, {
                                                    contaminant: contaminant
                                                })
                                            }, contaminantIndex);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "top-contaminants-pagination-container mx-auto mt-8 flex justify-center lg:mt-16"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "top-contaminants-footer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Button */.zx, {
                                    onClick: print,
                                    variant: "filled",
                                    theme: "primary",
                                    children: "View the PDF"
                                })
                            })
                        ]
                    }),
                    !EWGResultsTop3Contaminants && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "top-contaminants-body pt-10",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mx-auto max-w-[520px] border border-solid border-error bg-[#f1e5e3] py-1 text-center text-error",
                            children: "No contaminants found"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "hidden py-10 print:block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "top-contaminants-header",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "wiyw-dashboard-header text-center font-sans text-xl font-light",
                            children: [
                                "Most Harmful Contaminants in",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "font-[500]",
                                    children: (0,he.decode)((activeEWGSystem === null || activeEWGSystem === void 0 ? void 0 : activeEWGSystem.SystemName) || "N/A")
                                })
                            ]
                        })
                    }),
                    EWGResultsTop3Contaminants && (EWGResultsTop3Contaminants === null || EWGResultsTop3Contaminants === void 0 ? void 0 : EWGResultsTop3Contaminants.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "top-contaminants-body flex pt-10",
                        children: EWGResultsTop3Contaminants.map(function(contaminant, contaminantIndex) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-1/3 px-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* ContaminantResultCard */.Ov, {
                                    contaminant: contaminant,
                                    className: "mb-3"
                                })
                            }, "print-contaminant-result-card-".concat(contaminantIndex));
                        })
                    }),
                    !EWGResultsTop3Contaminants && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "top-contaminants-body pt-10",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "mx-auto max-w-[520px] border border-solid border-error bg-[#f1e5e3] py-1 text-center text-error",
                            children: "No contaminants found"
                        })
                    })
                ]
            })
        ]
    });
}
WIYWTopContaminants.displayName = "WIYWTopContaminants";
WIYWTopContaminants.Schema = WIYWTopContaminants_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/WIWYTopContaminants/index.js


;// CONCATENATED MODULE: ../node_modules/react-indiana-drag-scroll/dist/index.es.js

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */var n=function(t,e){return(n=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])})(t,e)};var index_es_o,index_es_r,index_es_i=(function(t){
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
!function(){var e={}.hasOwnProperty;function n(){for(var t=[],o=0;o<arguments.length;o++){var r=arguments[o];if(r){var i=typeof r;if("string"===i||"number"===i)t.push(r);else if(Array.isArray(r)&&r.length){var s=n.apply(null,r);s&&t.push(s)}else if("object"===i)for(var l in r)e.call(r,l)&&r[l]&&t.push(l)}}return t.join(" ")}t.exports?(n.default=n,t.exports=n):window.classNames=n}()}(index_es_r={path:index_es_o,exports:{},require:function(t,e){return function(){throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs")}(null==e&&index_es_r.path)}},index_es_r.exports),index_es_r.exports);function s(t,e,n){var o,r,i,s,l;function a(){var c=Date.now()-s;c<e&&c>=0?o=setTimeout(a,e-c):(o=null,n||(l=t.apply(i,r),i=r=null))}null==e&&(e=100);var c=function(){i=this,r=arguments,s=Date.now();var c=n&&!o;return o||(o=setTimeout(a,e)),c&&(l=t.apply(i,r),i=r=null),l};return c.clear=function(){o&&(clearTimeout(o),o=null)},c.flush=function(){o&&(l=t.apply(i,r),i=r=null,clearTimeout(o),o=null)},c}s.debounce=s;var index_es_l=s;!function(t,e){void 0===e&&(e={});var n=e.insertAt;if(t&&"undefined"!=typeof document){var o=document.head||document.getElementsByTagName("head")[0],r=document.createElement("style");r.type="text/css","top"===n&&o.firstChild?o.insertBefore(r,o.firstChild):o.appendChild(r),r.styleSheet?r.styleSheet.cssText=t:r.appendChild(document.createTextNode(t))}}(".indiana-scroll-container {\n  overflow: auto; }\n  .indiana-scroll-container--dragging {\n    scroll-behavior: auto !important; }\n    .indiana-scroll-container--dragging > * {\n      pointer-events: none;\n      cursor: -webkit-grab;\n      cursor: grab; }\n  .indiana-scroll-container--hide-scrollbars {\n    overflow: hidden;\n    overflow: -moz-scrollbars-none;\n    -ms-overflow-style: none;\n    scrollbar-width: none; }\n    .indiana-scroll-container--hide-scrollbars::-webkit-scrollbar {\n      display: none !important;\n      height: 0 !important;\n      width: 0 !important;\n      background: transparent !important;\n      -webkit-appearance: none !important; }\n  .indiana-scroll-container--native-scroll {\n    overflow: auto; }\n\n.indiana-dragging {\n  cursor: -webkit-grab;\n  cursor: grab; }\n");var a,index_es_c=(a="indiana-scroll-container",function(t,e){if(!t)return a;var n;"string"==typeof t?n=t:e=t;var o=a;return n&&(o+="__"+n),o+(e?Object.keys(e).reduce((function(t,n){var r=e[n];return r&&(t+=" "+("boolean"==typeof r?o+"--"+n:o+"--"+n+"_"+r)),t}),""):"")}),p=function(e){function o(n){var o=e.call(this,n)||this;return o.onEndScroll=function(){o.scrolling=!1,!o.pressed&&o.started&&o.processEnd()},o.onScroll=function(t){var e=o.container.current;e.scrollLeft===o.scrollLeft&&e.scrollTop===o.scrollTop||(o.scrolling=!0,o.processScroll(t),o.onEndScroll())},o.onTouchStart=function(t){var e=o.props.nativeMobileScroll;if(o.isDraggable(t.target))if(o.internal=!0,e&&o.scrolling)o.pressed=!0;else{var n=t.touches[0];o.processClick(t,n.clientX,n.clientY),!e&&o.props.stopPropagation&&t.stopPropagation()}},o.onTouchEnd=function(t){var e=o.props.nativeMobileScroll;o.pressed&&(!o.started||o.scrolling&&e?o.pressed=!1:o.processEnd(),o.forceUpdate())},o.onTouchMove=function(t){var e=o.props.nativeMobileScroll;if(o.pressed&&(!e||!o.isMobile)){var n=t.touches[0];n&&o.processMove(t,n.clientX,n.clientY),t.preventDefault(),o.props.stopPropagation&&t.stopPropagation()}},o.onMouseDown=function(t){o.isDraggable(t.target)&&o.isScrollable()&&(o.internal=!0,-1!==o.props.buttons.indexOf(t.button)&&(o.processClick(t,t.clientX,t.clientY),t.preventDefault(),o.props.stopPropagation&&t.stopPropagation()))},o.onMouseMove=function(t){o.pressed&&(o.processMove(t,t.clientX,t.clientY),t.preventDefault(),o.props.stopPropagation&&t.stopPropagation())},o.onMouseUp=function(t){o.pressed&&(o.started?o.processEnd():(o.internal=!1,o.pressed=!1,o.forceUpdate(),o.props.onClick&&o.props.onClick(t)),t.preventDefault(),o.props.stopPropagation&&t.stopPropagation())},o.container=react.createRef(),o.onEndScroll=index_es_l(o.onEndScroll,300),o.scrolling=!1,o.started=!1,o.pressed=!1,o.internal=!1,o.getRef=o.getRef.bind(o),o}return function(t,e){function o(){this.constructor=t}n(t,e),t.prototype=null===e?Object.create(e):(o.prototype=e.prototype,new o)}(o,e),o.prototype.componentDidMount=function(){var t=this.props.nativeMobileScroll,e=this.container.current;window.addEventListener("mouseup",this.onMouseUp),window.addEventListener("mousemove",this.onMouseMove),window.addEventListener("touchmove",this.onTouchMove,{passive:!1}),window.addEventListener("touchend",this.onTouchEnd),e.addEventListener("touchstart",this.onTouchStart,{passive:!1}),e.addEventListener("mousedown",this.onMouseDown,{passive:!1}),t&&(this.isMobile=this.isMobileDevice(),this.isMobile&&this.forceUpdate())},o.prototype.componentWillUnmount=function(){window.removeEventListener("mouseup",this.onMouseUp),window.removeEventListener("mousemove",this.onMouseMove),window.removeEventListener("touchmove",this.onTouchMove),window.removeEventListener("touchend",this.onTouchEnd)},o.prototype.getElement=function(){return this.container.current},o.prototype.isMobileDevice=function(){return void 0!==window.orientation||-1!==navigator.userAgent.indexOf("IEMobile")},o.prototype.isDraggable=function(t){var e=this.props.ignoreElements;if(e){var n=t.closest(e);return null===n||n.contains(this.getElement())}return!0},o.prototype.isScrollable=function(){var t=this.container.current;return t&&(t.scrollWidth>t.clientWidth||t.scrollHeight>t.clientHeight)},o.prototype.processClick=function(t,e,n){var o=this.container.current;this.scrollLeft=o.scrollLeft,this.scrollTop=o.scrollTop,this.clientX=e,this.clientY=n,this.pressed=!0},o.prototype.processStart=function(t){void 0===t&&(t=!0);var e=this.props.onStartScroll;this.started=!0,t&&document.body.classList.add("indiana-dragging"),e&&e({external:!this.internal}),this.forceUpdate()},o.prototype.processScroll=function(t){if(this.started){var e=this.props.onScroll;e&&e({external:!this.internal})}else this.processStart(!1)},o.prototype.processMove=function(t,e,n){var o=this.props,r=o.horizontal,i=o.vertical,s=o.activationDistance,l=o.onScroll,a=this.container.current;this.started?(r&&(a.scrollLeft-=e-this.clientX),i&&(a.scrollTop-=n-this.clientY),l&&l({external:!this.internal}),this.clientX=e,this.clientY=n,this.scrollLeft=a.scrollLeft,this.scrollTop=a.scrollTop):(r&&Math.abs(e-this.clientX)>s||i&&Math.abs(n-this.clientY)>s)&&(this.clientX=e,this.clientY=n,this.processStart())},o.prototype.processEnd=function(){var t=this.props.onEndScroll;this.container.current&&t&&t({external:!this.internal}),this.pressed=!1,this.started=!1,this.scrolling=!1,this.internal=!1,document.body.classList.remove("indiana-dragging"),this.forceUpdate()},o.prototype.getRef=function(t){[this.container,this.props.innerRef].forEach((function(e){e&&("function"==typeof e?e(t):e.current=t)}))},o.prototype.render=function(){var e=this.props,n=e.children,o=e.draggingClassName,r=e.className,s=e.style,l=e.hideScrollbars,a=e.component;return react.createElement(a,{className:index_es_i(r,this.pressed&&o,index_es_c({dragging:this.pressed,"hide-scrollbars":l,"native-scroll":this.isMobile})),style:s,ref:this.getRef,onScroll:this.onScroll},n)},o.defaultProps={nativeMobileScroll:!0,hideScrollbars:!0,activationDistance:10,vertical:!0,horizontal:!0,stopPropagation:!1,style:{},component:"div",buttons:[0]},o}(react.PureComponent);/* harmony default export */ var index_es = (p);
//# sourceMappingURL=index.es.js.map

;// CONCATENATED MODULE: ./src/sections/WIYWDashboard/WIYWDashboard.schema.js
function WIYWDashboard_schema_Schema(param) {
    var pageHandle = param.pageHandle;
    if (pageHandle !== "whats-in-your-water") return null;
    return {
        label: "WIYW Dashboard",
        key: "WIYWDashboard",
        category: "WIYW",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/wiyw-dashboard.png",
        fields: [
            {
                label: "Background Image",
                name: "backgroundImage",
                component: "image"
            },
            {
                label: "Background Video URL",
                name: "backgroundVideoUrl",
                description: "Video will always be muted and autoplay with loop and override the background image if present.",
                component: "text"
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/WIYWDashboard/WIYWDashboard.jsx











function WIYWDashboard(param) {
    var cms = param.cms;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
    var ref15 = (0,_object_spread/* default */.Z)({}, cms), backgroundImage = ref15.backgroundImage, backgroundVideoUrl = ref15.backgroundVideoUrl;
    var ref16 = useEWGContext(), EWGResults = ref16.EWGResults, EWGSystems = ref16.EWGSystems, activeEWGSystem = ref16.activeEWGSystem, setActiveEWGSystem = ref16.setActiveEWGSystem, EWGResultsExceedingGuidelines = ref16.EWGResultsExceedingGuidelines, EWGResultsRemovedContaminants = ref16.EWGResultsRemovedContaminants;
    var EWGResultsPercentRemovedContaminants = null;
    if ((EWGResultsExceedingGuidelines === null || EWGResultsExceedingGuidelines === void 0 ? void 0 : EWGResultsExceedingGuidelines.length) && (EWGResultsExceedingGuidelines === null || EWGResultsExceedingGuidelines === void 0 ? void 0 : EWGResultsExceedingGuidelines.length) > 0 && (EWGResults === null || EWGResults === void 0 ? void 0 : (ref = EWGResults.ContaminantList) === null || ref === void 0 ? void 0 : ref.length)) {
        /*
    EWGResultsPercentRemovedContaminants =
      (EWGResultsExceedingGuidelines.length /
        EWGResults.ContaminantList.length) *
      100;
    */ // set 40 as the base for amount of contaminants in the water
        EWGResultsPercentRemovedContaminants = EWGResultsExceedingGuidelines.length / 40 * 100;
    }
    if (EWGResultsPercentRemovedContaminants > 100) {
        EWGResultsPercentRemovedContaminants = 100;
    }
    var ref17 = (0,react.useState)("Copy URL"), copyUrlTooltip = ref17[0], setCopyUrlTooltip = ref17[1];
    var shareUrl = (0,react.useMemo)(function() {
        if (true) {
            return window.location.href;
        }
        return "";
    }, []);
    var copyUrl = function() {
        navigator.clipboard.writeText(shareUrl);
        setCopyUrlTooltip("Copied!");
        setTimeout(function() {
            setCopyUrlTooltip("Copy URL");
        }, 2000);
    };
    var print = function() {
        window.print();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative bg-primary print:hidden",
                children: [
                    (backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.src) && !backgroundVideoUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Image */.Ee, {
                        fill: true,
                        alt: "Background Image",
                        sizes: "100vw",
                        src: backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.src
                    }) : null,
                    backgroundVideoUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                        src: backgroundVideoUrl,
                        autoPlay: true,
                        muted: true,
                        loop: true,
                        playsInline: true,
                        className: "absolute h-full w-full object-cover"
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "px-contained relative mx-auto max-w-[1200px] pb-[30px] pt-[120px] text-white md:pb-[45px] md:pt-[180px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "wiyw-dashboard-header text-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "uppercase",
                                        children: "Your Results"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(snippets/* Headline */.s0, {
                                        variant: "h3",
                                        element: "h1",
                                        children: [
                                            "Contaminants Detected in",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "font-[500]",
                                                children: (0,he.decode)((activeEWGSystem === null || activeEWGSystem === void 0 ? void 0 : activeEWGSystem.SystemName) || "N/A")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mt-[22px] flex items-center justify-center gap-[23px] text-[16px] font-light",
                                        children: [
                                            "Share:",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                className: "flex gap-[23px]",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_FacebookShareButton, {
                                                            url: shareUrl,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                                                                className: "w-[18px]",
                                                                src: "/svgs/noprecache/social/facebook-thin.svg#facebook-thin",
                                                                title: "Share on Facebook",
                                                                viewBox: "0 0 18 18"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            className: "cursor-pointer",
                                                            type: "button",
                                                            onClick: print,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                                                                className: "w-[19px]",
                                                                src: "/svgs/noprecache/social/print.svg#print",
                                                                title: "Print this Page",
                                                                viewBox: "0 0 19 16"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(D, {
                                                                delayHide: 500,
                                                                content: "Copy URL",
                                                                id: "copy-url"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                className: "cursor-pointer",
                                                                type: "button",
                                                                onClick: copyUrl,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                                                                    className: "w-[15px]",
                                                                    src: "/svgs/noprecache/social/link.svg#link",
                                                                    title: "Share this Page",
                                                                    viewBox: "0 0 15 17",
                                                                    "data-tooltip-id": "copy-url",
                                                                    "data-tooltip-content": copyUrlTooltip,
                                                                    "data-tooltip-place": "top"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "wiyw-dashboard-main my-[40px] flex flex-wrap items-center justify-between border-b border-t border-[#FFFFFF1A] py-[40px] text-center md:flex-nowrap",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "dashboard-left flex flex-[0_0_100%] flex-col p-[20px] md:flex-[0_0_50%] md:border-r md:border-r-[#FFFFFF1A]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "relative aspect-[16/9] h-full w-full overflow-hidden xs:aspect-[16/8] sm:aspect-[16/6] md:aspect-video lg:aspect-[16/7]",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "relative mx-auto flex max-w-[368px] items-center justify-center [&_.CircularProgressbar-path]:!mix-blend-overlay [&_svg]:h-full [&_svg]:w-full",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgressbar, {
                                                            value: EWGResultsPercentRemovedContaminants,
                                                            circleRatio: 0.5,
                                                            strokeWidth: 4,
                                                            styles: buildStyles({
                                                                rotation: 3 / 4,
                                                                strokeLinecap: "round",
                                                                pathTransitionDuration: 0.5,
                                                                textSize: "1.5rem",
                                                                trailColor: "#8DCEF933",
                                                                pathColor: "#CCE0F1"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "absolute -translate-y-[200%] text-[110px] font-light sm:text-[120px]",
                                                            children: (EWGResultsExceedingGuidelines === null || EWGResultsExceedingGuidelines === void 0 ? void 0 : EWGResultsExceedingGuidelines.length) ? EWGResultsExceedingGuidelines.length : "N/A"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                                                        element: "h5",
                                                        variant: "h5",
                                                        className: "!text-[22px]",
                                                        children: "Contaminants"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Eyebrow */.j4, {
                                                        className: "uppercase",
                                                        children: "Exceed EWG Health Guidelines"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "mx-auto my-[20px] w-[15px] border-t-[3px] border-t-[#FFFFFF1A]"
                                                    }),
                                                    EWGResults && (EWGResults === null || EWGResults === void 0 ? void 0 : (ref1 = EWGResults.ContaminantList) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(snippets/* Body */.uT, {
                                                        variant: "medium",
                                                        className: "mb-2",
                                                        children: [
                                                            EWGResults === null || EWGResults === void 0 ? void 0 : (ref2 = EWGResults.ContaminantList) === null || ref2 === void 0 ? void 0 : ref2.length,
                                                            " Total Contaminants in Your Water"
                                                        ]
                                                    }),
                                                    EWGResultsRemovedContaminants && (EWGResultsRemovedContaminants === null || EWGResultsRemovedContaminants === void 0 ? void 0 : EWGResultsRemovedContaminants.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(snippets/* Body */.uT, {
                                                        variant: "medium",
                                                        children: [
                                                            EWGResultsRemovedContaminants === null || EWGResultsRemovedContaminants === void 0 ? void 0 : EWGResultsRemovedContaminants.length,
                                                            " Removed by Clearly Filtered"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "dashboard-right flex-[0_0_100%] border-t border-t-[#FFFFFF1A] pt-[40px] text-left md:flex-[0_0_50%] md:border-t-0 md:pt-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "grid grid-cols-2 md:pl-[30px]",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "dashboard-water-provider border-b border-r border-b-[#FFFFFF1A] border-r-[#FFFFFF1A] p-[14px] sm:p-[20px]",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Eyebrow */.j4, {
                                                            className: "uppercase",
                                                            children: "Water Provider"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "mt-2 font-light",
                                                            children: (activeEWGSystem === null || activeEWGSystem === void 0 ? void 0 : activeEWGSystem.SystemName) ? (0,he.decode)(activeEWGSystem === null || activeEWGSystem === void 0 ? void 0 : activeEWGSystem.SystemName) : "N/A"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "dashboard-population-affected border-b border-b-[#FFFFFF1A] p-[14px] sm:p-[20px]",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Eyebrow */.j4, {
                                                            className: "uppercase",
                                                            children: "Population Affected"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "mt-2 font-light",
                                                            children: (activeEWGSystem === null || activeEWGSystem === void 0 ? void 0 : activeEWGSystem.Population) ? activeEWGSystem === null || activeEWGSystem === void 0 ? void 0 : (ref3 = activeEWGSystem.Population) === null || ref3 === void 0 ? void 0 : ref3.toLocaleString("en-US") : "N/A"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "dashboard-data-available border-r border-r-[#FFFFFF1A] p-[14px] sm:p-[20px]",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Eyebrow */.j4, {
                                                            className: "uppercase",
                                                            children: "Data Available"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "mt-2 font-light",
                                                            children: (EWGResults === null || EWGResults === void 0 ? void 0 : (ref4 = EWGResults.ContaminantList) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[0]) === null || ref5 === void 0 ? void 0 : ref5.ContaminantTimeFrame) ? EWGResults === null || EWGResults === void 0 ? void 0 : (ref6 = EWGResults.ContaminantList) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[0]) === null || ref7 === void 0 ? void 0 : ref7.ContaminantTimeFrame : "N/A"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "dashboard-water-source p-[14px] sm:p-[20px]",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Eyebrow */.j4, {
                                                            className: "uppercase",
                                                            children: "Water Source"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "mt-2 font-light",
                                                            children: (activeEWGSystem === null || activeEWGSystem === void 0 ? void 0 : activeEWGSystem.PrimSource_fulltext) ? activeEWGSystem === null || activeEWGSystem === void 0 ? void 0 : activeEWGSystem.PrimSource_fulltext : "N/A"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "wiyw-dashboard-footer text-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mb-[26px] font-mono text-sm uppercase",
                                        children: "View water providers in your area"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "no-scrollbar overflow-x-auto",
                                        children: EWGSystems && EWGSystems.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                className: "flex gap-[20px] sm:flex-wrap sm:justify-center",
                                                children: EWGSystems.map(function(EWGSystem, EWGSystemIndex) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            type: "button",
                                                            onClick: function() {
                                                                setActiveEWGSystem(EWGSystem);
                                                            },
                                                            className: "".concat((activeEWGSystem === null || activeEWGSystem === void 0 ? void 0 : activeEWGSystem.PWS) === (EWGSystem === null || EWGSystem === void 0 ? void 0 : EWGSystem.PWS) ? "border-[#ffffff] bg-[#FFFFFF]  text-primary" : "text-white hover:bg-[#FFFFFF1A]", " whitespace-nowrap rounded-full border px-3 py-2 text-xs lg:px-4 lg:py-2 lg:text-sm"),
                                                            children: (0,he.decode)((EWGSystem === null || EWGSystem === void 0 ? void 0 : EWGSystem.SystemName) || "N/A")
                                                        })
                                                    }, "ewg-system-".concat(EWGSystemIndex));
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-[40px] flex items-center justify-center text-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(snippets/* Link */.rU, {
                                            className: "flex cursor-pointer",
                                            href: "/pages/whats-in-your-water-quiz?retake=true",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                                                    className: "w-[13px]",
                                                    src: "/svgs/restart.svg#restart",
                                                    title: "Retake Quiz",
                                                    viewBox: "0 0 13 12"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "ml-4 underline underline-offset-2",
                                                    children: "Retake Quiz"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hidden print:block",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "px-contained relative mx-auto max-w-[1200px] !pt-10 pb-10 text-black",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "wiyw-dashboard-header text-center font-sans text-xl font-light",
                            children: [
                                "Contaminants Detected in",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "font-[500]",
                                    children: (0,he.decode)((activeEWGSystem === null || activeEWGSystem === void 0 ? void 0 : activeEWGSystem.SystemName) || "N/A")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "wiyw-dashboard-main my-0 flex flex-wrap items-center justify-between border-b border-t border-[#FFFFFF1A] py-[40px] text-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "dashboard-left flex w-2/5 flex-col pr-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex items-center justify-center text-4xl font-light",
                                            children: (EWGResultsExceedingGuidelines === null || EWGResultsExceedingGuidelines === void 0 ? void 0 : EWGResultsExceedingGuidelines.length) ? EWGResultsExceedingGuidelines.length : "N/A"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Eyebrow */.j4, {
                                                    className: "mb-2",
                                                    children: "Contaminants Exceed EWG Health Guidelines"
                                                }),
                                                EWGResults && (EWGResults === null || EWGResults === void 0 ? void 0 : (ref8 = EWGResults.ContaminantList) === null || ref8 === void 0 ? void 0 : ref8.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(snippets/* Body */.uT, {
                                                    variant: "medium",
                                                    className: "mb-2",
                                                    children: [
                                                        EWGResults === null || EWGResults === void 0 ? void 0 : (ref9 = EWGResults.ContaminantList) === null || ref9 === void 0 ? void 0 : ref9.length,
                                                        " Total Contaminants in Your Water"
                                                    ]
                                                }),
                                                EWGResultsRemovedContaminants && (EWGResultsRemovedContaminants === null || EWGResultsRemovedContaminants === void 0 ? void 0 : EWGResultsRemovedContaminants.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(snippets/* Body */.uT, {
                                                    variant: "medium",
                                                    children: [
                                                        EWGResultsRemovedContaminants === null || EWGResultsRemovedContaminants === void 0 ? void 0 : EWGResultsRemovedContaminants.length,
                                                        " Removed by Clearly Filtered"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "dashboard-right w-3/5 border-l py-6 pl-6 text-left",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "grid grid-cols-2 gap-6",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "dashboard-water-provider border-b border-r border-b-[#FFFFFF1A] border-r-[#FFFFFF1A]",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Eyebrow */.j4, {
                                                        className: "uppercase",
                                                        children: "Water Provider"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "mt-1 text-sm font-light",
                                                        children: (activeEWGSystem === null || activeEWGSystem === void 0 ? void 0 : activeEWGSystem.SystemName) ? (0,he.decode)(activeEWGSystem === null || activeEWGSystem === void 0 ? void 0 : activeEWGSystem.SystemName) : "N/A"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "dashboard-population-affected border-b border-b-[#FFFFFF1A]",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Eyebrow */.j4, {
                                                        className: "uppercase",
                                                        children: "Population Affected"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "mt-1 text-sm font-light",
                                                        children: (activeEWGSystem === null || activeEWGSystem === void 0 ? void 0 : activeEWGSystem.Population) ? activeEWGSystem === null || activeEWGSystem === void 0 ? void 0 : (ref10 = activeEWGSystem.Population) === null || ref10 === void 0 ? void 0 : ref10.toLocaleString("en-US") : "N/A"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "dashboard-data-available border-r border-r-[#FFFFFF1A]",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Eyebrow */.j4, {
                                                        className: "uppercase",
                                                        children: "Data Available"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "mt-1 text-sm font-light",
                                                        children: (EWGResults === null || EWGResults === void 0 ? void 0 : (ref11 = EWGResults.ContaminantList) === null || ref11 === void 0 ? void 0 : (ref12 = ref11[0]) === null || ref12 === void 0 ? void 0 : ref12.ContaminantTimeFrame) ? EWGResults === null || EWGResults === void 0 ? void 0 : (ref13 = EWGResults.ContaminantList) === null || ref13 === void 0 ? void 0 : (ref14 = ref13[0]) === null || ref14 === void 0 ? void 0 : ref14.ContaminantTimeFrame : "N/A"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "dashboard-water-source",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Eyebrow */.j4, {
                                                        className: "uppercase",
                                                        children: "Water Source"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "mt-1 text-sm font-light",
                                                        children: (activeEWGSystem === null || activeEWGSystem === void 0 ? void 0 : activeEWGSystem.PrimSource_fulltext) ? activeEWGSystem === null || activeEWGSystem === void 0 ? void 0 : activeEWGSystem.PrimSource_fulltext : "N/A"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
WIYWDashboard.displayName = "WIYWDashboard";
WIYWDashboard.Schema = WIYWDashboard_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/WIYWDashboard/index.js


;// CONCATENATED MODULE: ./src/sections/WIYWFullResults/WIYWFullResults.schema.js
function WIYWFullResults_schema_Schema(param) {
    var pageHandle = param.pageHandle;
    if (pageHandle !== "whats-in-your-water") return null;
    return {
        label: "WIYW Full Results",
        key: "WIYWFullResults",
        category: "WIYW",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/wiyw-full-results.png",
        fields: [
            {
                label: "Eyebrow Text",
                name: "eyebrowText",
                component: "text"
            },
            {
                label: "Section Disclosure",
                name: "sectionDisclosure",
                component: "textarea"
            }, 
        ]
    };
}

;// CONCATENATED MODULE: ./src/sections/WIYWFullResults/WIYWFullResults.jsx
/* eslint-disable no-nested-ternary */ 







function WIYWFullResults(param) {
    var cms = param.cms;
    var eyebrowText = cms.eyebrowText, sectionDisclosure = cms.sectionDisclosure;
    var ref = useEWGContext(), EWGResultsExceedingGuidelines = ref.EWGResultsExceedingGuidelines, EWGResultsWithinGuidelines = ref.EWGResultsWithinGuidelines, activeEWGSystem = ref.activeEWGSystem;
    var ref1 = (0,react.useState)(false), isViewAll = ref1[0], setIsViewAll = ref1[1]; // [TODO] - Remove this state and use the state from the EWGContext instead
    var isMobile = utils_useMediaQuery("(max-width: 767px)");
    var ref2 = (0,react.useState)("exceeds"), visibleResults = ref2[0], setVisibleResults = ref2[1];
    var slicedContaminants = (0,react.useMemo)(function() {
        return (0,_to_consumable_array/* default */.Z)(EWGResultsExceedingGuidelines || []).concat((0,_to_consumable_array/* default */.Z)(EWGResultsWithinGuidelines || [])).slice(0, 4);
    });
    var allContaminantsJsx = (0,react.useMemo)(function() {
        return (EWGResultsExceedingGuidelines || EWGResultsWithinGuidelines) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "wiyw-exceeds-guidelines py-[60px] ".concat(visibleResults === "exceeds" ? "block" : "hidden"),
                    children: (EWGResultsExceedingGuidelines === null || EWGResultsExceedingGuidelines === void 0 ? void 0 : EWGResultsExceedingGuidelines.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grid grid-cols-1 gap-[20px] sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4",
                        children: EWGResultsExceedingGuidelines.map(function(contaminantExceedingGuidelines, contaminantExceedingGuidelinesIndex) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* ContaminantResultCard */.Ov, {
                                contaminant: contaminantExceedingGuidelines
                            }, "exceeds-guidelines-card-".concat(contaminantExceedingGuidelinesIndex));
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "wiyw-within-guidelines py-[60px] ".concat(visibleResults === "within" ? "block" : "hidden"),
                    children: (EWGResultsWithinGuidelines === null || EWGResultsWithinGuidelines === void 0 ? void 0 : EWGResultsWithinGuidelines.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grid grid-cols-1 gap-[20px] sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4",
                        children: EWGResultsWithinGuidelines.map(function(contaminantWithinGuidelines, contaminantWithinGuidelinesIndex) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* ContaminantResultCard */.Ov, {
                                alternate: true,
                                contaminant: contaminantWithinGuidelines
                            }, "within-guidelines-card-".concat(contaminantWithinGuidelinesIndex));
                        })
                    })
                })
            ]
        });
    }, [
        EWGResultsExceedingGuidelines,
        EWGResultsWithinGuidelines,
        visibleResults
    ]);
    var slicedContaminantsJsx = (0,react.useMemo)(function() {
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
            className: "wiyw-exceeds-guidelines relative py-[60px] ".concat(visibleResults === "exceeds" ? "block" : "hidden"),
            children: [
                (slicedContaminants === null || slicedContaminants === void 0 ? void 0 : slicedContaminants.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid grid-cols-1 gap-[20px] sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4",
                    children: slicedContaminants.map(function(contaminantExceedingGuidelines, contaminantExceedingGuidelinesIndex) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* ContaminantResultCard */.Ov, {
                            contaminant: contaminantExceedingGuidelines
                        }, "exceeds-guidelines-card-".concat(contaminantExceedingGuidelinesIndex));
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute bottom-[60px] left-0 h-[calc(25%+16px)] w-full bg-gradient-to-t from-[#F2F7FB] to-transparent"
                })
            ]
        });
    }, [
        slicedContaminants,
        visibleResults
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-contained relative mx-auto max-w-[1728px] py-[30px] text-center print:hidden md:py-[60px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "wiyw-full-results-header",
                        children: [
                            eyebrowText && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Eyebrow */.j4, {
                                className: "uppercase",
                                children: eyebrowText
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(snippets/* Headline */.s0, {
                                variant: "h3",
                                element: "h2",
                                children: [
                                    "All Contaminants Detected in",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-[500]",
                                        children: (0,he.decode)((activeEWGSystem === null || activeEWGSystem === void 0 ? void 0 : activeEWGSystem.SystemName) || "N/A")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "result-toggle mt-[30px] flex justify-center gap-[20px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "exceeds-toggle",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Button */.zx, {
                                            variant: visibleResults === "exceeds" ? "filled" : "outlined",
                                            theme: "dark",
                                            className: "!border-text !text-text hover:!bg-text hover:!text-white focus:!bg-text active:!bg-text ".concat(visibleResults === "exceeds" ? "!text-white" : null),
                                            onClick: function() {
                                                setVisibleResults("exceeds");
                                            },
                                            children: "Exceeds Guidelines"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "within-toggle",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Button */.zx, {
                                            variant: visibleResults === "within" ? "filled" : "outlined",
                                            theme: "dark",
                                            className: "!border-text !text-text hover:!bg-text hover:!text-white focus:!bg-text active:!bg-text ".concat(visibleResults === "within" ? "!text-white" : null),
                                            onClick: function() {
                                                setVisibleResults("within");
                                            },
                                            children: "Others Detected"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "result-legend mt-[30px] flex justify-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center justify-center gap-[13px] rounded-[10px] border border-[#DDE2E7] px-[20px] py-[10px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "relative flex h-[26px] w-[26px] items-center justify-center rounded-full border-[2px] border-secondary",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                                                className: "w-[14px] text-secondary",
                                                src: "/svgs/checkmark.svg#checkmark",
                                                title: "Checkmark",
                                                viewBox: "0 0 24 24"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "font-mono uppercase tracking-[0.004em]",
                                            children: "Removed By Clearly Filtered"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "wiyw-full-results-body",
                        children: [
                            isMobile ? isViewAll ? allContaminantsJsx : slicedContaminantsJsx : allContaminantsJsx,
                            !isViewAll && isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Button */.zx, {
                                theme: "primary",
                                variant: "filled",
                                className: "mb-4",
                                onClick: function() {
                                    return setIsViewAll(true);
                                },
                                children: "View All Contaminants"
                            }),
                            !EWGResultsExceedingGuidelines && !EWGResultsWithinGuidelines && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "py-10",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mx-auto max-w-[520px] border border-solid border-error bg-[#f1e5e3] py-1 text-center text-error",
                                    children: "No contaminants found"
                                })
                            })
                        ]
                    }),
                    sectionDisclosure && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "wiyw-full-results-footer mx-auto max-w-[1024px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Body */.uT, {
                            variant: "xs",
                            className: "text-[#797D86]",
                            children: sectionDisclosure
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "hidden py-10 print:block",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "wiyw-full-results-header mb-5 break-inside-avoid",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "wiyw-dashboard-header text-center font-sans text-xl font-light",
                                children: [
                                    "All Contaminants Detected in",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-[500]",
                                        children: (0,he.decode)((activeEWGSystem === null || activeEWGSystem === void 0 ? void 0 : activeEWGSystem.SystemName) || "N/A")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "result-legend mt-[30px] flex justify-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center justify-center gap-[13px] rounded-[10px] border border-[#DDE2E7] px-4 py-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "relative flex h-[26px] w-[26px] items-center justify-center rounded-full border-[2px] border-secondary",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Svg */.ny, {
                                                className: "w-[14px] text-secondary",
                                                src: "/svgs/checkmark.svg#checkmark",
                                                title: "Checkmark",
                                                viewBox: "0 0 24 24"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "font-mono text-sm uppercase tracking-[0.004em]",
                                            children: "Removed By Clearly Filtered"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "wiyw-full-results-body",
                        children: [
                            (EWGResultsExceedingGuidelines === null || EWGResultsExceedingGuidelines === void 0 ? void 0 : EWGResultsExceedingGuidelines.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: EWGResultsExceedingGuidelines.map(function(contaminantExceedingGuidelines, contaminantExceedingGuidelinesIndex) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-full px-2 py-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* ContaminantResultCardPrint */.gO, {
                                            contaminant: contaminantExceedingGuidelines
                                        })
                                    }, "exceeds-guidelines-card-".concat(contaminantExceedingGuidelinesIndex));
                                })
                            }),
                            (EWGResultsWithinGuidelines === null || EWGResultsWithinGuidelines === void 0 ? void 0 : EWGResultsWithinGuidelines.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: EWGResultsWithinGuidelines.map(function(contaminantWithinGuidelines, contaminantWithinGuidelinesIndex) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-full px-2 py-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* ContaminantResultCardPrint */.gO, {
                                            contaminant: contaminantWithinGuidelines
                                        })
                                    }, "within-guidelines-card-".concat(contaminantWithinGuidelinesIndex));
                                })
                            }),
                            !EWGResultsExceedingGuidelines && !EWGResultsWithinGuidelines && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "py-10",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mx-auto max-w-[520px] border border-solid border-error bg-[#f1e5e3] py-1 text-center text-error",
                                    children: "No contaminants found"
                                })
                            })
                        ]
                    }),
                    sectionDisclosure && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "wiyw-full-results-footer mx-auto max-w-[1024px] pt-10",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Body */.uT, {
                            variant: "xs",
                            className: "text-[#797D86]",
                            children: sectionDisclosure
                        })
                    })
                ]
            })
        ]
    });
}
WIYWFullResults.displayName = "WIYWFullResults";
WIYWFullResults.Schema = WIYWFullResults_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/WIYWFullResults/index.js


;// CONCATENATED MODULE: ../node_modules/use-local-storage-state/es/src/useLocalStorageState.js

// in memory fallback used then `localStorage` throws an error
const inMemoryData = new Map();
function useLocalStorageState(key, options) {
    // istanbul ignore next
    if (react.useSyncExternalStore === undefined) {
        throw new TypeError(`You are using React 17 or below. Install with "npm install use-local-storage-state@17".`);
    }
    const [defaultValue] = (0,react.useState)(options === null || options === void 0 ? void 0 : options.defaultValue);
    // SSR support
    // - on the server, return a constant value
    // - this makes the implementation simpler and smaller because the `localStorage` object is
    //   `undefined` on the server
    if (typeof window === 'undefined') {
        return [
            defaultValue,
            () => { },
            {
                isPersistent: true,
                removeItem: () => { },
            },
        ];
    }
    const serializer = options === null || options === void 0 ? void 0 : options.serializer;
    // disabling ESLint because the above if statement can be executed only on the server. the value
    // of `window` can't change between calls.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useBrowserLocalStorageState(key, defaultValue, options === null || options === void 0 ? void 0 : options.storageSync, serializer === null || serializer === void 0 ? void 0 : serializer.parse, serializer === null || serializer === void 0 ? void 0 : serializer.stringify);
}
function useBrowserLocalStorageState(key, defaultValue, storageSync = true, parse = parseJSON, stringify = JSON.stringify) {
    // store default value in localStorage:
    // - initial issue: https://github.com/astoilkov/use-local-storage-state/issues/26
    //   issues that were caused by incorrect initial and secondary implementations:
    //   - https://github.com/astoilkov/use-local-storage-state/issues/30
    //   - https://github.com/astoilkov/use-local-storage-state/issues/33
    if (!inMemoryData.has(key) &&
        defaultValue !== undefined &&
        goodTry(() => localStorage.getItem(key)) === null) {
        // reasons for `localStorage` to throw an error:
        // - maximum quota is exceeded
        // - under Mobile Safari (since iOS 5) when the user enters private mode
        //   `localStorage.setItem()` will throw
        // - trying to access localStorage object when cookies are disabled in Safari throws
        //   "SecurityError: The operation is insecure."
        goodTry(() => localStorage.setItem(key, stringify(defaultValue)));
    }
    // we keep the `parsed` value in a ref because `useSyncExternalStore` requires a cached version
    const storageValue = (0,react.useRef)({
        item: null,
        parsed: defaultValue,
    });
    const value = (0,react.useSyncExternalStore)((0,react.useCallback)((onStoreChange) => {
        const onChange = (localKey) => {
            if (key === localKey) {
                onStoreChange();
            }
        };
        callbacks.add(onChange);
        return () => {
            callbacks.delete(onChange);
        };
    }, [key]), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    () => {
        var _a;
        const item = (_a = goodTry(() => localStorage.getItem(key))) !== null && _a !== void 0 ? _a : null;
        if (inMemoryData.has(key)) {
            storageValue.current = {
                item,
                parsed: inMemoryData.get(key),
            };
        }
        else if (item !== storageValue.current.item) {
            let parsed;
            try {
                parsed = item === null ? defaultValue : parse(item);
            }
            catch (_b) {
                parsed = defaultValue;
            }
            storageValue.current = {
                item,
                parsed,
            };
        }
        return storageValue.current.parsed;
    }, 
    // istanbul ignore next
    () => defaultValue);
    const setState = (0,react.useCallback)((newValue) => {
        const value = newValue instanceof Function ? newValue(storageValue.current.parsed) : newValue;
        // reasons for `localStorage` to throw an error:
        // - maximum quota is exceeded
        // - under Mobile Safari (since iOS 5) when the user enters private mode
        //   `localStorage.setItem()` will throw
        // - trying to access `localStorage` object when cookies are disabled in Safari throws
        //   "SecurityError: The operation is insecure."
        try {
            localStorage.setItem(key, stringify(value));
            inMemoryData.delete(key);
        }
        catch (_a) {
            inMemoryData.set(key, value);
        }
        triggerCallbacks(key);
    }, [key, stringify]);
    // - syncs change across tabs, windows, iframes
    // - the `storage` event is called only in all tabs, windows, iframe's except the one that
    //   triggered the change
    (0,react.useEffect)(() => {
        if (!storageSync) {
            return undefined;
        }
        const onStorage = (e) => {
            if (e.storageArea === goodTry(() => localStorage) && e.key === key) {
                triggerCallbacks(key);
            }
        };
        window.addEventListener('storage', onStorage);
        return () => window.removeEventListener('storage', onStorage);
    }, [key, storageSync]);
    return (0,react.useMemo)(() => [
        value,
        setState,
        {
            isPersistent: value === defaultValue || !inMemoryData.has(key),
            removeItem() {
                goodTry(() => localStorage.removeItem(key));
                inMemoryData.delete(key);
                triggerCallbacks(key);
            },
        },
    ], [key, setState, value, defaultValue]);
}
// notifies all instances using the same `key` to update
const callbacks = new Set();
function triggerCallbacks(key) {
    for (const callback of [...callbacks]) {
        callback(key);
    }
}
// a wrapper for `JSON.parse()` that supports "undefined" value. otherwise,
// `JSON.parse(JSON.stringify(undefined))` returns the string "undefined" not the value `undefined`
function parseJSON(value) {
    return value === 'undefined' ? undefined : JSON.parse(value);
}
function goodTry(tryFn) {
    try {
        return tryFn();
    }
    catch (_a) {
        return undefined;
    }
}

;// CONCATENATED MODULE: ../node_modules/use-local-storage-state/es/index.js

/* harmony default export */ var es = (useLocalStorageState);

;// CONCATENATED MODULE: ./src/sections/WIYWQuiz/WIYWQuiz.schema.js
function WIYWQuiz_schema_Schema() {
    return {
        label: "Whats In Your Water Quiz",
        key: "wiyw-quiz",
        fields: [
            {
                label: "Landing Page",
                name: "landingPage",
                component: "group",
                fields: [
                    {
                        label: "Image",
                        name: "image",
                        component: "image"
                    },
                    {
                        label: "Eyebrow",
                        name: "eyebrow",
                        component: "text"
                    },
                    {
                        label: "Heading",
                        name: "heading",
                        component: "text"
                    },
                    {
                        label: "Bullets",
                        name: "bullets",
                        component: "group-list",
                        fields: [
                            {
                                label: "Bullet",
                                name: "bullet",
                                component: "text"
                            }, 
                        ]
                    },
                    {
                        label: "Disclaimer Text",
                        name: "disclaimerText",
                        component: "textarea"
                    }, 
                ]
            },
            {
                label: "Quiz",
                name: "quiz",
                component: "group",
                fields: [
                    {
                        label: "Questions Pages",
                        name: "questionsPages",
                        component: "group-list",
                        fields: [
                            {
                                label: "Heading",
                                name: "heading",
                                component: "text"
                            },
                            {
                                label: "Subheading",
                                name: "subheading",
                                component: "text"
                            },
                            {
                                label: "Choices",
                                name: "choices",
                                component: "select",
                                options: [
                                    {
                                        label: "Single Choice",
                                        value: "single"
                                    },
                                    {
                                        label: "Multiple Choice",
                                        value: "multiple"
                                    }, 
                                ],
                                defaultValue: "multiple"
                            },
                            {
                                label: "Columns",
                                name: "columns",
                                component: "select",
                                options: [
                                    {
                                        label: "1",
                                        value: "1"
                                    },
                                    {
                                        label: "2",
                                        value: "2"
                                    },
                                    {
                                        label: "3",
                                        value: "3"
                                    }, 
                                ]
                            },
                            {
                                label: "Options",
                                name: "options",
                                component: "group-list",
                                fields: [
                                    {
                                        label: "Option Text",
                                        name: "optionText",
                                        component: "text"
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ]
            },
            {
                label: "Email Entry Page",
                name: "emailEntryPage",
                component: "group",
                fields: [
                    {
                        label: "Eyebrow",
                        name: "eyebrow",
                        component: "text"
                    },
                    {
                        label: "Heading",
                        name: "heading",
                        component: "text"
                    },
                    {
                        label: "Input Placeholder",
                        name: "inputPlaceholder",
                        component: "text"
                    },
                    {
                        label: "CTA Text",
                        name: "ctaText",
                        component: "text"
                    },
                    {
                        label: "Skip Text",
                        name: "skipText",
                        component: "text"
                    },
                    {
                        label: "Disclaimer Text",
                        name: "disclaimerText",
                        component: "text",
                        defaultValue: "By providing your email, you agree to receive promotional emails and updates from Clearly Filtered."
                    }, 
                ]
            }, 
        ]
    };
} // generate a jsdoc for a react fucntional component that will receive the above data as props inside of an object called cms

// EXTERNAL MODULE: ../node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(3198);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
;// CONCATENATED MODULE: ./src/sections/WIYWQuiz/components/email-input.jsx
/* eslint-disable @typescript-eslint/no-empty-function */ 



function EmailInput(param) {
    var _value = param.value, value = _value === void 0 ? "" : _value, _loading = param.loading, loading = _loading === void 0 ? false : _loading, _onChange = param.onChange, onChange = _onChange === void 0 ? function() {} : _onChange, _onSubmit = param.onSubmit, onSubmit = _onSubmit === void 0 ? function() {} : _onSubmit, _ctaText = param.ctaText, ctaText = _ctaText === void 0 ? "" : _ctaText, _inputPlaceholder = param.inputPlaceholder, inputPlaceholder = _inputPlaceholder === void 0 ? "E-mail address" : _inputPlaceholder;
    // local clone of value to debounce changes
    var ref = (0,react.useState)(value), localValue = ref[0], setLocalValue = ref[1];
    var debouncedSave = (0,react.useCallback)(lodash_debounce_default()(function(nextValue) {
        return setLocalValue(nextValue);
    }, 500), []);
    (0,react.useEffect)(function() {
        debouncedSave(value);
    }, [
        value
    ]);
    var emailValidation = (0,react.useMemo)(function() {
        // if value is empty, user didn't touch the input yet
        if ((localValue === null || localValue === void 0 ? void 0 : localValue.length) === 0) return {
            valid: true
        };
        // test if value is a valid e-mail
        if (/\S+@\S+\.\S+/.test(localValue)) return {
            valid: true
        };
        // if value is not a valid e-mail, return error message
        return {
            valid: false,
            message: "*Please enter a valid e-mail"
        };
    }, [
        localValue
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: [
                            "w-full border border-[#DDE2E7] bg-stone-50 px-9 py-4 transition-all focus-within:ring hover:ring",
                            (emailValidation === null || emailValidation === void 0 ? void 0 : emailValidation.valid) ? "" : "ring ring-red-400", 
                        ].join(" "),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            value: value,
                            onChange: onChange,
                            placeholder: inputPlaceholder,
                            className: [
                                "text-gray-800 w-full bg-stone-50 text-[18px] font-light leading-relaxed outline-none", 
                            ].join(" ")
                        })
                    }),
                    !(emailValidation === null || emailValidation === void 0 ? void 0 : emailValidation.valid) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mt-2 text-base text-red-400",
                        children: (emailValidation === null || emailValidation === void 0 ? void 0 : emailValidation.message) || "Please enter a valid e-mail"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "my-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    variant: "filled",
                    theme: "primary",
                    disabled: localValue.length === 0 || !(emailValidation === null || emailValidation === void 0 ? void 0 : emailValidation.valid),
                    onClick: onSubmit,
                    loading: loading,
                    children: ctaText || "Continue"
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/sections/WIYWQuiz/pages/email.jsx




// generate jsdoc for props
/**
 * @typedef {Object} EmailCaptureProps
 * @property {string} email
 * @property {boolean} loading
 * @property {() => void} setEmail
 * @property {() => void} onSubmit
 * @property {() => void} onSkip
 * @property {Object} emailPage
 * @property {string} emailPage.eyebrow
 * @property {string} emailPage.heading
 * @property {string} emailPage.inputPlaceholder
 * @property {string} emailPage.ctaText
 * @property {string} emailPage.skipText
 * @property {string} emailPage.disclaimerText
 * @param {EmailCaptureProps} props
 * @returns {JSX.Element}
 */ function EmailCapture(param) {
    var emailPage = param.emailPage, loading = param.loading, onSubmit = param.onSubmit, email = param.email, setEmail = param.setEmail, onSkip = param.onSkip;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "px-contained flex min-h-screen flex-col items-center justify-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "max-w-[630px] text-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Eyebrow */.j4, {
                    children: emailPage.eyebrow
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                    variant: "h3",
                    children: emailPage.heading
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-20",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailInput, {
                        loading: loading,
                        value: email,
                        inputPlaceholder: emailPage.inputPlaceholder,
                        onChange: function(e) {
                            return setEmail(e.target.value);
                        },
                        onSubmit: function() {
                            return onSubmit(email);
                        },
                        ctaText: emailPage.ctaText
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mb-10 flex flex-col items-center",
                    children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "font-semibold hover:underline",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Spinner */.$j, {
                            width: "32"
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        tabIndex: 0,
                        onClick: onSkip,
                        onKeyDown: function(e) {
                            if (e.key === "Enter") onSkip();
                        },
                        role: "button",
                        className: "font-semibold hover:underline",
                        children: emailPage.skipText
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-xs font-light",
                    children: emailPage.disclaimerText
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./src/snippets/Svg/Svg.jsx
var Svg_Svg = __webpack_require__(989);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(1373);
;// CONCATENATED MODULE: ./src/sections/WIYWQuiz/components/zip-input.jsx







/**
 * @typedef {Object} ZipInputProps
 * @property {string} value
 * @property {(e: React.ChangeEvent<HTMLInputElement>) => void} onChange
 * @property {string} [placeholder]
 * @property {string} [className]
 * @property {string} [style]
 * @property {string} [id]
 * @property {string} [name]
 * @property {string} [type]
 * @property {boolean} [required]
 * @property {boolean} [disabled]
 * @property {() => void} onSubmit
 * @param {ZipInputProps} props
 * @returns {JSX.Element}
 */ function ZipInput(_param) {
    var _value = _param.value, value = _value === void 0 ? "" : _value, onChange = _param.onChange, onSubmit = _param.onSubmit, props = (0,_object_without_properties/* default */.Z)(_param, [
        "value",
        "onChange",
        "onSubmit"
    ]);
    // local clone of value to debounce changes
    var ref = (0,react.useState)(value), localValue = ref[0], setLocalValue = ref[1];
    var debouncedSave = (0,react.useCallback)(lodash_debounce_default()(function(nextValue) {
        return setLocalValue(nextValue);
    }, 250), []);
    (0,react.useEffect)(function() {
        debouncedSave(value);
    }, [
        value
    ]);
    var zipValidation = (0,react.useMemo)(function() {
        // if value is empty, user didn't touch the input yet
        if ((localValue === null || localValue === void 0 ? void 0 : localValue.length) === 0) return {
            valid: true
        };
        // test if value is a valid zip code
        if (/^\d{5}(?:[-\s]\d{4})?$/gm.test(localValue)) return {
            valid: true
        };
        // if value is not a valid zip code, return error message
        return {
            valid: false,
            message: "*Please enter a valid zip code"
        };
    }, [
        localValue
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: [
                    "mb-4 w-full rounded-[65px] border-red-400 bg-stone-50 px-9 py-4 transition-all focus-within:ring hover:ring",
                    (zipValidation === null || zipValidation === void 0 ? void 0 : zipValidation.valid) ? "" : "ring ring-red-400", 
                ].join(" "),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        value: value,
                        onChange: onChange,
                        placeholder: "Zip Code",
                        onKeyDown: function(e) {
                            return e.key === "Enter" && zipValidation.valid && onSubmit();
                        }
                    }, props), {
                        className: [
                            "text-gray-800 w-full bg-stone-50 text-[18px] font-light leading-relaxed outline-none", 
                        ].join(" ")
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: onSubmit,
                        type: "button",
                        disabled: !(zipValidation === null || zipValidation === void 0 ? void 0 : zipValidation.valid) || !value.length,
                        className: "absolute right-9 top-0 flex h-full items-center justify-center outline-none transition-all focus:scale-125 disabled:opacity-50",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                            className: "w-5 text-text",
                            src: "/svgs/search.svg#search",
                            title: "Search",
                            viewBox: "0 0 24 24"
                        })
                    })
                ]
            }),
            !(zipValidation === null || zipValidation === void 0 ? void 0 : zipValidation.valid) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "absolute -bottom-6 mt-2 text-base text-red-400",
                children: (zipValidation === null || zipValidation === void 0 ? void 0 : zipValidation.message) || "Please enter a valid zip code"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/sections/WIYWQuiz/pages/landing.jsx





/**
 * @typedef {Object} LandingPageProps
 * @property {Object} landingPage
 * @property {Object} landingPage.image
 * @property {string} landingPage.image.src
 * @property {string} landingPage.image.alt
 * @property {string} landingPage.eyebrow
 * @property {string} landingPage.heading
 * @property {string[]} landingPage.bullets
 * @property {string} landingPage.disclaimerText
 * @property {string} zip
 * @property {(zip: string) => void} setZip
 * @property {() => void} onSubmit
 * @param {LandingPageProps} props
 * @returns {JSX.Element}
 */ function LandingPage(param) {
    var landingPage = param.landingPage, zip = param.zip, setZip = param.setZip, onSubmit = param.onSubmit;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grid grid-cols-1 md:grid-cols-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative row-start-2 min-h-[100vw] overflow-hidden md:row-start-1 lg:min-h-screen",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets_Image/* Image */.E, {
                    alt: landingPage.image.alt,
                    fill: true,
                    className: "object-cover",
                    src: landingPage.image.src
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center justify-center p-6 md:p-10 lg:p-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "max-w-[630px] space-y-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "text-center md:text-left",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Eyebrow */.j4, {
                                    children: landingPage.eyebrow
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                                    variant: "h3",
                                    children: landingPage.heading
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ZipInput, {
                            value: zip,
                            onChange: function(e) {
                                return setZip(e.target.value);
                            },
                            onSubmit: onSubmit
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                            className: "my-20 border-[#DDE2E7]"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "space-y-6",
                            children: landingPage.bullets.map(function(param, index) {
                                var bullet = param.bullet;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    className: "flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg_Svg/* Svg */.n, {
                                            className: "mr-2 inline-block h-[17px] w-[17px] shrink-0 text-[#3383C5]",
                                            title: "Arrow",
                                            src: "/svgs/circle-check.svg#circle-check",
                                            viewBox: "0 0 17 17"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Body */.uT, {
                                            variant: "small",
                                            children: bullet
                                        })
                                    ]
                                }, index);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Body */.uT, {
                            variant: "xs",
                            children: landingPage.disclaimerText
                        })
                    ]
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/sections/WIYWQuiz/pages/step.jsx
/* eslint-disable no-use-before-define */ /* eslint-disable @typescript-eslint/no-empty-function */ 







// generate jsdoc for props based on WIYWQuiz.jsx that is sended to this component
/**
 * @typedef {Object} QuizQuestionOption
 * @property {string} optionText
 *
 * @typedef {Object} StepProps
 * @property {QuizQuestionOption[]} options
 * @property {string} subheading
 * @property {() => void} onSelect
 * @property {() => void} onBack
 * @property {() => void} onSubmit
 * @property {number} step
 * @property {number} steps
 * @property {string} heading
 * @property {'single' | 'multiple'} choices
 * @property {string} columns
 *
 * @param {StepProps} props
 * @returns {JSX.Element}
 * @example
 */ function Step(param) {
    var _options = param.options, options = _options === void 0 ? [] : _options, _subheading = param.subheading, subheading = _subheading === void 0 ? "" : _subheading, _onSelect = param.onSelect, onSelect = _onSelect === void 0 ? function() {} : _onSelect, _onBack = param.onBack, onBack = _onBack === void 0 ? function() {} : _onBack, _onSubmit = param.onSubmit, onSubmit = _onSubmit === void 0 ? function() {} : _onSubmit, _step = param.step, step = _step === void 0 ? 1 : _step, _choices = param.choices, choices = _choices === void 0 ? "multiple" : _choices, _steps = param.steps, steps = _steps === void 0 ? 1 : _steps, _heading = param.heading, heading = _heading === void 0 ? "" : _heading, _columns = param.columns, columns = _columns === void 0 ? "2" : _columns;
    /**
   * DO NOT change the local storage key! This will be used further to process the data
   */ var ref = (0,_sliced_to_array/* default */.Z)(es("WIYWQuiz-".concat(heading), {
        defaultValue: []
    }), 2), selected = ref[0], setSelected = ref[1];
    var select = (0,react.useCallback)(function(el) {
        return choices === "single" ? setSelected([
            el
        ]) : setSelected((0,_to_consumable_array/* default */.Z)(selected).concat([
            el
        ]));
    }, [
        selected,
        setSelected,
        choices
    ]);
    var unselect = (0,react.useCallback)(function(el) {
        return setSelected(selected.filter(function(item) {
            return item !== el;
        }));
    }, [
        selected,
        setSelected
    ]);
    (0,react.useEffect)(function() {
        onSelect(selected);
    }, [
        selected
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "px-contained py-5 text-[#202635]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                role: "button",
                className: "flex gap-x-3",
                onClick: onBack,
                onKeyDown: function(e) {
                    if (e.key === "Enter") onBack();
                },
                tabIndex: 0,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                        className: "w-[1.25rem] text-black",
                        src: "/svgs/arrow-left.svg#arrow-left",
                        title: "Arrow Left",
                        viewBox: "0 0 24 24"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-sm font-light",
                        children: "Back"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "heading mt-11 space-y-3 text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Eyebrow */.j4, {
                        children: [
                            "QUESTION ",
                            step,
                            " of ",
                            steps
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                        variant: "h3",
                        children: heading
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Subheading */.pm, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "font-mono text-xs font-light uppercase",
                            children: subheading
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: [
                    "body mx-auto mt-10 grid max-w-[640px] gap-5",
                    // eslint-disable-next-line no-nested-ternary
                    columns === "3" ? "md:grid-cols-3" : columns === "1" ? "md:grid-cols-1" : "md:grid-cols-2", 
                ].join(" "),
                children: options.map(function(param, index) {
                    var optionText = param.optionText;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        role: "checkbox",
                        "aria-checked": selected.includes(optionText),
                        tabIndex: 0,
                        onKeyDown: function(e) {
                            if (e.key === "Enter") {
                                if (selected.includes(optionText)) {
                                    unselect(optionText);
                                } else {
                                    select(optionText);
                                }
                            }
                        },
                        className: [
                            "flex h-14 cursor-pointer items-center gap-x-2 rounded-md border border-[#DDE2E7] px-4 py-3",
                            selected.includes(optionText) ? "bg-[#FFFFFF]" : "bg-[#E6F0F8]", 
                        ].join(" "),
                        onClick: function() {
                            if (selected.includes(optionText)) {
                                unselect(optionText);
                            } else {
                                select(optionText);
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBox, {
                                checked: selected.includes(optionText)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-sm font-light md:text-base",
                                children: optionText
                            })
                        ]
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "my-10 flex justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    variant: "filled",
                    theme: "primary",
                    disabled: selected.length === 0,
                    onClick: onSubmit,
                    children: "Continue"
                })
            })
        ]
    });
}
function CheckBox(param) {
    var _checked = param.checked, checked = _checked === void 0 ? false : _checked, _className = param.className, className = _className === void 0 ? "" : _className, _onClick = param.onClick, onClick = _onClick === void 0 ? function() {} : _onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        role: "checkbox",
        "aria-checked": checked,
        tabIndex: 0,
        onKeyDown: function(e) {
            if (e.key === "Enter") onClick();
        },
        onClick: onClick,
        className: [
            "flex h-5 w-5 items-center justify-center border border-primary ".concat(className),
            checked ? "bg-primary" : "", 
        ].join(" "),
        children: checked && /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
            className: "w-3 text-white",
            src: "/svgs/checkmark.svg#checkmark",
            viewBox: "0 0 24 24"
        })
    });
}

;// CONCATENATED MODULE: ./src/sections/WIYWQuiz/WIYWQuiz.jsx
















/**
 * @typedef {Object} WIYWQuizProps
 * @property {Object} cms
 * @property {Object} cms.landingPage
 * @property {Object} cms.landingPage.image
 * @property {string} cms.landingPage.image.src
 * @property {string} cms.landingPage.image.alt
 * @property {string} cms.landingPage.eyebrow
 * @property {string} cms.landingPage.heading
 * @property {string[]} cms.landingPage.bullets
 * @property {string} cms.landingPage.disclaimerText
 * @property {Object} cms.quiz
 * @property {Object[]} cms.quiz.questionsPages
 * @property {string} cms.quiz.questionsPages[].heading
 * @property {string} cms.quiz.questionsPages[].subheading
 * @property {string} cms.quiz.questionsPages[].columns
 * @property {'single'|'multiple'} cms.quiz.questionsPages[].choices
 * @property {string[]} cms.quiz.questionsPages[].options
 * @property {Object} cms.emailEntryPage
 * @property {string} cms.emailEntryPage.eyebrow
 * @property {string} cms.emailEntryPage.heading
 * @property {string} cms.emailEntryPage.inputPlaceholder
 * @property {string} cms.emailEntryPage.ctaText
 * @param {WIYWQuizProps} props
 * @returns {JSX.Element}
 */ function WIYWQuiz(param) {
    var cms = param.cms;
    var cart = (0,dist.useCart)();
    var ref = (0,next_router.useRouter)(), push = ref.push, query = ref.query;
    var initialStep = 0;
    var ref1 = (0,react.useState)(initialStep), step = ref1[0], setStep = ref1[1];
    var ref2 = (0,react.useState)(""), zip = ref2[0], setZip = ref2[1];
    var ref3 = (0,react.useState)(false), loading = ref3[0], setLoading = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)(es("quizEmail", {
        defaultValue: ""
    }), 2), email = ref4[0], setEmail = ref4[1];
    var cartAddAttributes = (0,dist.useCartAddAttributes)().cartAddAttributes;
    var setZipCode = useEWGContext().setZipCode;
    // get titles of all questions
    var questionTitles = cms.quiz.questionsPages.map(function(page) {
        return page.heading;
    });
    // On Step change, send dataLayer event containing the previous question and answer
    (0,react.useEffect)(function() {
        if (step > 1 && step < cms.quiz.questionsPages.length + 2) {
            var previousQuestion = cms.quiz.questionsPages[step - 2].heading;
            var previousQuestionAnswers = JSON.parse(localStorage.getItem("WIYWQuiz-".concat(previousQuestion)));
            var previousQuestionAnswersObject = {};
            previousQuestionAnswers.forEach(function(answer, answerIndex) {
                previousQuestionAnswersObject["".concat(answerIndex)] = answer.trim();
            });
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: "dl_quiz_question_answered",
                quiz_zipcode: zip,
                quiz_question: previousQuestion,
                quiz_answers: previousQuestionAnswersObject,
                quiz_step: step - 1
            });
        }
    }, [
        step
    ]);
    var startQuiz = function() {
        if (!zip) return;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "dl_quiz_started",
            quiz_zipcode: zip
        });
    };
    var finishQuiz = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var type, checkoutData;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        type = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "skip";
                        checkoutData = questionTitles.map(function(title) {
                            var ref;
                            var answers = localStorage.getItem("WIYWQuiz-".concat(title));
                            return {
                                key: title,
                                value: (ref = JSON.parse(answers)) === null || ref === void 0 ? void 0 : ref.join(", ")
                            };
                        });
                        return [
                            4,
                            cartAddAttributes({
                                attributes: checkoutData
                            })
                        ];
                    case 1:
                        _state.sent();
                        if (!zip) return [
                            2
                        ];
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            event: "dl_quiz_submit",
                            quiz_zipcode: zip,
                            submit_type: type
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function finishQuiz() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleQuizSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(userEmail) {
            var klaviyoData, payload;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            ,
                            2,
                            3
                        ]);
                        setLoading(true);
                        klaviyoData = questionTitles.map(function(title) {
                            var ref;
                            var answers = localStorage.getItem("WIYWQuiz-".concat(title));
                            return (0,_define_property/* default */.Z)({}, title, (ref = JSON.parse(answers)) === null || ref === void 0 ? void 0 : ref.join(", "));
                        }).reduce(function(acc, curr) {
                            return (0,_object_spread/* default */.Z)({}, acc, curr);
                        }, {
                            zip_code: zip
                        });
                        payload = {
                            source: "WIYW Quiz Flow",
                            listId: "QTUx59",
                            emailAddress: userEmail,
                            properties: klaviyoData
                        };
                        return [
                            4,
                            fetch("/api/klaviyo-subscribe", {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify(payload)
                            })
                        ];
                    case 1:
                        _state.sent();
                        finishQuiz("email");
                        // redirect to results page
                        push("/pages/whats-in-your-water?zip=".concat(zip));
                        return [
                            3,
                            3
                        ];
                    case 2:
                        setLoading(false);
                        return [
                            7
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleQuizSubmit(userEmail) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSkipQuiz = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        return [
                            4,
                            finishQuiz("skip")
                        ];
                    case 1:
                        _state.sent();
                        setLoading(true);
                        push("/pages/whats-in-your-water?zip=".concat(zip));
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSkipQuiz() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (zip && (zip === null || zip === void 0 ? void 0 : zip.length) === 5) {
            // If the current saved Zip code is different from the one entered, reset the quiz answers.
            var currentZipCode = localStorage.getItem("WIYWQuiz-zipCode");
            if (currentZipCode !== zip) {
                questionTitles.forEach(function(title) {
                    localStorage.removeItem("WIYWQuiz-".concat(title));
                });
                localStorage.removeItem("quizEmail");
            }
            localStorage.setItem("WIYWQuiz-zipCode", zip);
            setZipCode(zip);
        }
    }, [
        zip
    ]);
    (0,react.useEffect)(function() {
        if (query.retake) {
            localStorage.removeItem("quizEmail");
            questionTitles.forEach(function(title) {
                localStorage.removeItem("WIYWQuiz-".concat(title));
            });
        }
    }, [
        query
    ]);
    if (step === 0) return /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingPage, {
        landingPage: cms.landingPage,
        zip: zip,
        setZip: setZip,
        onSubmit: function() {
            startQuiz();
            setStep(function(s) {
                return s + 1;
            });
        }
    });
    if (step > cms.quiz.questionsPages.length) return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailCapture, {
        loading: loading,
        emailPage: cms.emailEntryPage,
        email: email,
        setEmail: setEmail,
        onSubmit: handleQuizSubmit,
        onSkip: handleSkipQuiz
    });
    if (step > 0) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Step, {
        onBack: function() {
            return setStep(step - 1);
        },
        onSubmit: function() {
            return setStep(step + 1);
        },
        setStep: setStep,
        step: step,
        choices: cms.quiz.questionsPages[step - 1].choices,
        steps: cms.quiz.questionsPages.length,
        heading: cms.quiz.questionsPages[step - 1].heading,
        subheading: cms.quiz.questionsPages[step - 1].subheading,
        options: cms.quiz.questionsPages[step - 1].options,
        columns: cms.quiz.questionsPages[step - 1].columns
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: "not found"
    });
}
WIYWQuiz.propTypes = {
    cms: prop_types_default().shape({
        landingPage: prop_types_default().shape({
            image: prop_types_default().shape({
                src: (prop_types_default()).string,
                alt: (prop_types_default()).string
            }),
            eyebrow: (prop_types_default()).string,
            heading: (prop_types_default()).string,
            bullets: prop_types_default().arrayOf(prop_types_default().shape({
                bullet: (prop_types_default()).string
            })),
            disclaimerText: (prop_types_default()).string
        }),
        quiz: prop_types_default().shape({
            questionsPages: prop_types_default().arrayOf(prop_types_default().shape({
                heading: (prop_types_default()).string,
                subheading: (prop_types_default()).string,
                columns: (prop_types_default()).string,
                options: prop_types_default().arrayOf(prop_types_default().shape({
                    optionText: (prop_types_default()).string
                }))
            }))
        }),
        emailEntryPage: prop_types_default().shape({
            eyebrow: (prop_types_default()).string,
            heading: (prop_types_default()).string,
            inputPlaceholder: (prop_types_default()).string,
            ctaText: (prop_types_default()).string
        })
    })
};
WIYWQuiz.displayName = "WIYWQuiz";
WIYWQuiz.Schema = WIYWQuiz_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/WIYWRecomendedProducts/WIYWRecommendedProducts.schema.js
var product = [
    {
        name: "product",
        label: "Product",
        component: "productSearch"
    },
    {
        name: "headline",
        label: "Headline",
        component: "text"
    },
    {
        name: "body",
        label: "Body",
        component: "textarea"
    }, 
];
var WIYWRecommendedProducts_schema_Schema = function() {
    return {
        category: "WIYW",
        label: "Recommended Products",
        key: "recommendedProducts",
        previewSrc: "https://cdn.shopify.com/s/files/1/1011/0318/files/Screenshot_202023-07-10_20at_2013.33.28.png?v=1689006849",
        fields: [
            {
                name: "eyebrowText",
                component: "text",
                label: "Eyebrow Text",
                defaultValue: "GET PEACE OF MIND"
            },
            {
                name: "sectionLink",
                component: "link",
                label: "Section Link"
            },
            {
                label: "ON THE GO",
                component: "group",
                name: "onTheGoProduct",
                fields: product
            },
            {
                label: "MOST POPULAR",
                component: "group",
                name: "mostPopularProduct",
                fields: product
            },
            {
                label: "LARGE FAMILY",
                component: "group",
                fields: product,
                name: "largeFamilyProduct"
            }, 
        ]
    };
};

;// CONCATENATED MODULE: ./src/sections/WIYWRecomendedProducts/WIYWRecommendedProducts.jsx










/**
 * @typedef ProductSearch - The product object.
 * @property {String} handle - The product handle.
 * @property {String} title - The product title.
 *
 * @typedef Product - The product object.
 * @property {String} headline - The product handle.
 * @property {String} body - The product title.
 * @property {ProductSearch} product - The product price.
 *
 * Document the recommended products component based on WIYWRecommendedProducts.schema.js
 *
 * @param {Object} props - The props object.
 * @param {Object} props.cms - The CMS object containing the data to loop through and display.
 * @param {String} props.cms.eyebrowText - The eyebrow text.
 * @param {Object} props.cms.sectionLink - The section link.
 * @param {String} props.cms.sectionLink.text - The section link text.
 * @param {String} props.cms.sectionLink.url - The section link URL.
 * @param {Boolean} props.cms.sectionLink.newTab - The section link new tab.
 * @param {Product} props.cms.onTheGoProduct
 * @param {Product} props.cms.mostPopularProduct
 * @param {Product} props.cms.largeFamilyProduct
 * @returns {JSX.Element} - The recommended products component.
 */ function RecommendedProducts(param) {
    var cms = param.cms;
    var ref, ref1, ref2;
    var eyebrowText = cms.eyebrowText, sectionLink = cms.sectionLink, largeFamilyProduct = cms.largeFamilyProduct, mostPopularProduct = cms.mostPopularProduct, onTheGoProduct = cms.onTheGoProduct;
    var activeEWGSystem = useEWGContext().activeEWGSystem;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "featured-products bg-[#D9E8F4] print:hidden",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "px-contained mx-auto max-w-[var(--content-max-width)] py-[32px] md:py-[62px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mb-4 text-center",
                    children: eyebrowText && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Eyebrow */.j4, {
                        className: "uppercase",
                        children: eyebrowText
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mb-10 text-center",
                    children: (activeEWGSystem === null || activeEWGSystem === void 0 ? void 0 : activeEWGSystem.SystemName) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(snippets/* Headline */.s0, {
                        variant: "h3",
                        element: "h2",
                        children: [
                            "Recommended Products for",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-[500]",
                                children: (0,he.decode)(activeEWGSystem === null || activeEWGSystem === void 0 ? void 0 : activeEWGSystem.SystemName)
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid gap-6 md:grid-cols-1 lg:grid-cols-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "bg-[#E6F0F8] p-8",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductItem, {
                                eyebrowText: "MOST POPULAR",
                                productHandle: mostPopularProduct === null || mostPopularProduct === void 0 ? void 0 : (ref = mostPopularProduct.product) === null || ref === void 0 ? void 0 : ref.handle,
                                body: mostPopularProduct === null || mostPopularProduct === void 0 ? void 0 : mostPopularProduct.body,
                                headline: mostPopularProduct === null || mostPopularProduct === void 0 ? void 0 : mostPopularProduct.headline
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "bg-[#E6F0F8] p-8",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductItem, {
                                eyebrowText: "ON THE GO",
                                productHandle: onTheGoProduct === null || onTheGoProduct === void 0 ? void 0 : (ref1 = onTheGoProduct.product) === null || ref1 === void 0 ? void 0 : ref1.handle,
                                body: onTheGoProduct === null || onTheGoProduct === void 0 ? void 0 : onTheGoProduct.body,
                                headline: onTheGoProduct === null || onTheGoProduct === void 0 ? void 0 : onTheGoProduct.headline
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "bg-[#E6F0F8] p-8",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductItem, {
                                eyebrowText: "LARGE FAMILY",
                                productHandle: largeFamilyProduct === null || largeFamilyProduct === void 0 ? void 0 : (ref2 = largeFamilyProduct.product) === null || ref2 === void 0 ? void 0 : ref2.handle,
                                body: largeFamilyProduct === null || largeFamilyProduct === void 0 ? void 0 : largeFamilyProduct.body,
                                headline: largeFamilyProduct === null || largeFamilyProduct === void 0 ? void 0 : largeFamilyProduct.headline
                            })
                        })
                    ]
                }),
                (sectionLink === null || sectionLink === void 0 ? void 0 : sectionLink.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "cta-group order-3 mt-10 flex items-center justify-center gap-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Button */.zx, {
                        href: sectionLink.url,
                        theme: "primary",
                        variant: "filled",
                        children: sectionLink.text
                    })
                })
            ]
        })
    });
}
function ProductItem(param) {
    var productHandle = param.productHandle, headline = param.headline, body = param.body, multiplyImage = param.multiplyImage, eyebrowText = param.eyebrowText;
    var ref, ref1;
    var swatchesMap = (0,hooks/* useColorSwatches */.Bb)().swatchesMap;
    var product = (0,dist.useProductByHandle)({
        handle: productHandle
    }).product;
    var ref2 = (0,react.useState)(null), variantFromColor = ref2[0], setVariantFromColor = ref2[1];
    var variant = variantFromColor || (product === null || product === void 0 ? void 0 : (ref = product.variants) === null || ref === void 0 ? void 0 : ref[0]);
    var productUrl = variant ? "/products/".concat((ref1 = variant.product) === null || ref1 === void 0 ? void 0 : ref1.handle, "?variant=").concat(variant.legacyResourceId) : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex flex-col lg:flex-row",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex h-full w-full flex-1 items-center justify-center bg-[#E6F0F8] px-5 py-10 lg:px-0 lg:py-0",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "max-w-[520px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(snippets/* Link */.rU, {
                    href: productUrl,
                    className: "flex flex-col gap-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-10 text-center text-[#0064B7]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Eyebrow */.j4, {
                                children: eyebrowText
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "order-2 grid gap-4 text-center lg:order-1",
                            children: [
                                headline && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Headline */.s0, {
                                    variant: "h5",
                                    children: headline
                                }),
                                body && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Body */.uT, {
                                    variant: "small",
                                    children: body
                                }),
                                (product === null || product === void 0 ? void 0 : product.price) && /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Body */.uT, {
                                    variant: "small",
                                    children: product === null || product === void 0 ? void 0 : product.price
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "pointer-events-none relative order-1 h-48 select-none lg:order-2 lg:h-60",
                            style: {
                                mixBlendMode: multiplyImage ? "multiply" : "normal"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative flex h-full items-center justify-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductItemMedia/* ProductItemMedia */.V, {
                                    disableHoverEffect: true,
                                    disableBackground: true,
                                    product: product,
                                    variant: variant
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "order-2 mt-[-20px] flex justify-center lg:order-3 lg:mt-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorVariantSelector/* ColorVariantSelector */.A, {
                                className: "mb-2 mt-[22px]",
                                enabledColorNameOnHover: false,
                                product: product,
                                setVariantFromColor: setVariantFromColor,
                                swatchesMap: swatchesMap,
                                variantFromColor: variantFromColor
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cta-group order-3 flex items-center justify-center gap-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Button */.zx, {
                                theme: "primary",
                                variant: "filled",
                                children: "Shop now"
                            })
                        })
                    ]
                })
            })
        })
    });
}
RecommendedProducts.displayName = "RecommendedProducts";
RecommendedProducts.Schema = WIYWRecommendedProducts_schema_Schema;

;// CONCATENATED MODULE: ./src/sections/index.js


































































































/* harmony default export */ var sections = ([
    Accordions,
    ArticleBlockQuote/* ArticleBlockQuote */.A,
    ArticleContaminantAccordions,
    ArticleContaminantFacts,
    ArticleContaminantTable,
    ArticleContent,
    ArticleFiftyFifty,
    ArticleHero,
    ArticleImage,
    ArticleReferences,
    ArticleVideo,
    BlogCategories,
    BlogArticleList,
    BlogFeaturedBanner,
    BlogFeaturedPost,
    BlogGrid,
    BlogHero,
    BlogList,
    BlogPopularPosts,
    CareerBlock,
    CareerIcons,
    CareerListings,
    JazzHRListings,
    Collection,
    CollectionHero,
    CollectionNav,
    CollectionsList,
    CommonContaminants,
    CommunityImpact,
    ContactFormBuilder,
    CumulativeImpact,
    DynamicArticleHero,
    DynamicBlogList,
    DynamicPopularPosts,
    Environment,
    FeaturedProduct,
    FeaturedProducts,
    FiltrationTechnology,
    FiftyFiftyImage,
    FullBleedHero,
    HalfHero,
    Hero,
    HeroBanner,
    HeroBannerWithNewsTicker,
    HowItWorks,
    IconRow,
    Image,
    ImageActionsCarousel,
    ImageBehindText,
    ImageSlider,
    ImageTiles,
    ImageWithTextLanding,
    LabResults,
    LabResultsNavigation,
    LabResultsOverview,
    Legal,
    Markdown,
    Newsletter,
    NewsletterExtended,
    OkendoReviews,
    PageBanner,
    PandectesWithdrawal,
    PartnerSlider,
    ProductAdditionalDetails,
    PressSlider,
    ProductCarousel,
    ProductComparisonTable_ProductComparisonTable,
    ProductDetailAccordions,
    ProductFilterReplacement,
    ProductOverview,
    ProductPromoBannerCarousel,
    ProductSupport,
    ProductsSlider,
    ProductSteps_ProductSteps,
    ProductThreeColumnDrawers,
    ProductUniqueTechnology,
    PromoBanner,
    Quiz,
    RatingBanner,
    RecommendedProducts,
    RelatedProducts,
    ReviewsSlider,
    ScrollyVideoSection,
    SearchResults,
    SimpleHeroBanner,
    SocialImagesGrid,
    TabbedThreeTiles,
    TestimonialSlider,
    TextBlock,
    ThreeTiles,
    TwoTiles,
    ValueProps,
    WIYWQuiz,
    VideoBanner,
    VideoSlider,
    WIYWDashboard,
    WIYWFullResults,
    WIYWTopContaminants, 
]);

;// CONCATENATED MODULE: ./src/settings/account/activate.js
/* harmony default export */ var activate = ({
    label: "Activate Account",
    name: "activate",
    component: "group",
    fields: [
        {
            label: "Heading",
            name: "heading",
            component: "text"
        },
        {
            label: "Subtext",
            name: "subtext",
            component: "text"
        }, 
    ],
    defaultValue: {
        heading: "Activate Account",
        subtext: "Create your password to activate your account."
    }
});

;// CONCATENATED MODULE: ./src/settings/account/forgot.js
/* harmony default export */ var forgot = ({
    label: "Forgot Password",
    name: "forgot",
    component: "group",
    fields: [
        {
            label: "Heading",
            name: "heading",
            component: "text"
        },
        {
            label: "Subtext",
            name: "subtext",
            component: "text"
        },
        {
            label: "Post Submission Text",
            name: "postSubmissionText",
            component: "text"
        }, 
    ],
    defaultValue: {
        heading: "Forgot Password",
        subtext: "We will send you an email to reset your password.",
        postSubmissionText: "If account exists, an email will be sent shortly"
    }
});

;// CONCATENATED MODULE: ./src/settings/account/login.js
/* harmony default export */ var login = ({
    label: "Login",
    name: "login",
    component: "group",
    fields: [
        {
            label: "Login Page Heading",
            name: "heading",
            component: "text"
        },
        {
            label: "Flyout Heading",
            name: "flyoutHeading",
            component: "textarea"
        },
        {
            label: "Flyout Subeading",
            name: "subheading",
            component: "text"
        },
        {
            label: "Forgot Password Text",
            name: "forgotText",
            component: "text"
        },
        {
            label: "Create Account Text",
            name: "createText",
            component: "text"
        },
        {
            label: "Create Account Link Text",
            name: "createLinkText",
            component: "text"
        },
        {
            label: "Unidentified Customer Error Text",
            name: "unidentifiedCustomerText",
            component: "text"
        }, 
    ],
    defaultValue: {
        heading: "Sign In",
        subheading: "Track orders and manage your subscription in your account.",
        forgotText: "Forgot Password",
        createText: "Don't have an account?",
        createLinkText: "Create Account",
        unidentifiedCustomerText: "The email and password do not match"
    }
});

;// CONCATENATED MODULE: ./src/settings/account/menu.js
// menu
/* harmony default export */ var menu = ({
    label: "Account Menu",
    name: "menu",
    component: "group",
    fields: [
        {
            label: "Menu items",
            name: "menuItems",
            component: "group-list",
            itemProps: {
                label: "{{item.link.text}}"
            },
            fields: [
                {
                    label: "Link",
                    name: "link",
                    component: "link"
                }, 
            ],
            defaultItem: {
                link: {
                    text: "New Menu Item",
                    url: ""
                }
            },
            defaultValue: [
                {
                    link: {
                        text: "Order History",
                        url: "/account/orders"
                    }
                },
                {
                    link: {
                        text: "Address Book",
                        url: "/account/address-book"
                    }
                },
                {
                    link: {
                        text: "Edit Profile",
                        url: "/account/profile"
                    }
                }, 
            ]
        },
        {
            label: "Flyout Navigation Items",
            name: "flyoutMenuItems",
            component: "group-list",
            itemProps: {
                label: "{{item.link.text}}"
            },
            fields: [
                {
                    label: "Link",
                    name: "link",
                    component: "link"
                }, 
            ],
            defaultItem: {
                link: {
                    text: "New Menu Item",
                    url: ""
                }
            },
            defaultValue: [
                {
                    link: {
                        text: "Order History",
                        url: "/account/orders"
                    }
                },
                {
                    link: {
                        text: "Address Book",
                        url: "/account/address-book"
                    }
                },
                {
                    link: {
                        text: "Edit Profile",
                        url: "/account/profile"
                    }
                }, 
            ]
        },
        {
            label: "Help Heading",
            name: "helpHeading",
            component: "text",
            defaultValue: "Need Help?"
        },
        {
            label: "Help Email",
            name: "helpEmail",
            component: "text",
            defaultValue: "info@clearlyfiltered.com"
        },
        {
            label: "Help Phone",
            name: "helpPhone",
            component: "text",
            defaultValue: "1-888-867-5309"
        },
        {
            label: "Call Hours",
            name: "callHours",
            component: "text",
            defaultValue: "M-F 9am-9pm PST"
        },
        {
            label: "Chat Hours",
            name: "chatHours",
            component: "text",
            defaultValue: "M-F 9am-9pm PST"
        }, 
    ]
});

;// CONCATENATED MODULE: ./src/settings/account/register.js
/* harmony default export */ var register = ({
    label: "Register",
    name: "register",
    component: "group",
    fields: [
        {
            label: "Register Page Heading",
            name: "heading",
            component: "text"
        },
        {
            label: "Flyout Heading",
            name: "flyoutHeading",
            component: "textarea"
        },
        {
            label: "Flyout Subeading",
            name: "subheading",
            component: "text"
        },
        {
            label: "Login Text",
            name: "loginText",
            component: "text"
        },
        {
            label: "Login Link Text",
            name: "loginLinkText",
            component: "text"
        }, 
    ],
    defaultValue: {
        heading: "Create Account",
        subheading: "Track orders and manage your subscription in your account.",
        loginText: "Already have an account?",
        loginLinkText: "Sign In"
    }
});

;// CONCATENATED MODULE: ./src/settings/account/reset.js
/* harmony default export */ var account_reset = ({
    label: "Password Reset",
    name: "reset",
    component: "group",
    fields: [
        {
            label: "Heading",
            name: "heading",
            component: "text"
        },
        {
            label: "Subtext",
            name: "subtext",
            component: "text"
        }, 
    ],
    defaultValue: {
        heading: "Reset Password",
        subtext: "Please enter your new password."
    }
});

;// CONCATENATED MODULE: ./src/settings/account/index.js






/* harmony default export */ var account = ({
    label: "Account",
    name: "account",
    component: "group",
    description: "Menu, login, register, password reset",
    fields: [
        menu,
        login,
        register,
        forgot,
        account_reset,
        activate
    ]
});

;// CONCATENATED MODULE: ./src/settings/analytics.js
/* harmony default export */ var analytics = ({
    label: "Analytics",
    name: "analytics",
    component: "group",
    description: "Enable Shopify analytics",
    fields: [
        {
            label: "Enabled",
            name: "enabled",
            component: "toggle",
            description: 'Ensure "NEXT_PUBLIC_SHOPIFY_SHOP_ID" is set as an env var',
            toggleLabels: {
                true: "On",
                false: "Off"
            },
            defaultValue: true
        }, 
    ]
});

;// CONCATENATED MODULE: ./src/settings/beam.js
/* harmony default export */ var beam = ({
    label: "Beam",
    name: "beam",
    component: "group",
    description: "Global Beam settings",
    fields: [
        {
            label: "API Key",
            name: "beamApiKey",
            component: "text"
        },
        {
            label: "Store ID",
            name: "beamStoreId",
            component: "text"
        },
        {
            label: "Chain ID",
            name: "beamChainId",
            component: "text"
        },
        {
            label: "Store Top Domain",
            name: "beamStoreTopDomain",
            component: "text"
        },
        {
            label: "Session ID Cookie",
            name: "beamSessionIdCookie",
            component: "text"
        }, 
    ]
});

;// CONCATENATED MODULE: ./src/settings/blog.js
/* harmony default export */ var blog = ({
    label: "Blog",
    name: "blog",
    component: "group",
    description: "Global blog settings",
    fields: [
        {
            label: "Blog Categories",
            name: "categories",
            description: "Categories to display in the blog hero navigation.",
            component: "group-list",
            itemProps: {
                label: "{{item.link.text}}"
            },
            fields: [
                {
                    label: "Link",
                    name: "link",
                    component: "link"
                }, 
            ],
            defaultItem: {
                link: {
                    text: "New Category",
                    url: ""
                }
            },
            defaultValue: [
                {
                    link: {
                        text: "All",
                        url: "/blogs/all"
                    }
                },
                {
                    link: {
                        text: "Contaminants",
                        url: "/blogs/contaminants"
                    }
                },
                {
                    link: {
                        text: "Health & Safety",
                        url: "/blogs/health-safety"
                    }
                },
                {
                    link: {
                        text: "News",
                        url: "/blogs/news"
                    }
                },
                {
                    link: {
                        text: "Us vs Them",
                        url: "/blogs/us-vs-them"
                    }
                },
                {
                    link: {
                        text: "Water 101",
                        url: "/blogs/water-101"
                    }
                }, 
            ]
        }, 
    ]
});

;// CONCATENATED MODULE: ./src/settings/cart.js

/* harmony default export */ var cart = ({
    label: "Cart",
    name: "cart",
    component: "group",
    description: "Cart upsell, announcement text, free shipping meter, empty cart, totals",
    fields: [
        {
            label: "Heading",
            name: "heading",
            component: "text",
            defaultValue: "My Cart"
        },
        {
            label: "Shipping Bar",
            name: "shippingBar",
            component: "group",
            description: "Shipping bar text",
            fields: [
                {
                    label: "Display to US Only",
                    name: "usOnly",
                    component: "toggle",
                    toggleLabels: {
                        true: "On",
                        false: "Off"
                    },
                    defaultValue: true
                },
                {
                    label: "ipinfo.io API token",
                    name: "ipinfoKey",
                    component: "text",
                    description: "API Token from ipinfo.io account, used for US only display",
                    defaultValue: "045cf8fbfab3b5"
                },
                {
                    label: "All Subscriptions Text",
                    name: "subscriptionOnly",
                    component: "text",
                    description: "Text to display when only subscription items in cart",
                    defaultValue: "FREE SHIPPING (US ONLY)"
                },
                {
                    label: "All One-times Text",
                    name: "onetimeOnly",
                    component: "text",
                    description: "Text to display when only one-time items in cart",
                    defaultValue: "Switch to subscription for 10% savings and free shipping (US)"
                },
                {
                    label: "Mixed Cart Text",
                    name: "mixedCart",
                    component: "text",
                    description: "Text to display when both subscription and one-time items in cart",
                    defaultValue: "Switch to subscription for 10% savings and free shipping (US)"
                }, 
            ]
        },
        {
            label: "Announcement Bar",
            name: "announcement",
            component: "group",
            description: "Announcement bar / disclaimer text",
            fields: [
                {
                    label: "Enabled",
                    name: "enabled",
                    component: "toggle",
                    toggleLabels: {
                        true: "On",
                        false: "Off"
                    }
                },
                {
                    label: "Announcement Text",
                    name: "text",
                    component: "text",
                    description: "Announcement / disclaimer text"
                }, 
            ],
            defaultValue: {
                enabled: false,
                minCartSpend: 100,
                progressMessage: "You're only {{amount}} away from free shipping!",
                qualifiedMessage: "You've qualified for free shipping!",
                progressBarColor: "var(--primary)"
            }
        },
        {
            label: "Empty Cart",
            name: "emptyCart",
            component: "group",
            description: "Message, links",
            fields: [
                {
                    label: "Empty Cart Message",
                    name: "message",
                    component: "text",
                    defaultValue: "Your cart is empty"
                },
                {
                    label: "Links",
                    name: "links",
                    component: "group-list",
                    itemProps: {
                        label: "{{item.link.text}}"
                    },
                    fields: [
                        {
                            label: "Link",
                            name: "link",
                            component: "link"
                        }, 
                    ],
                    defaultItem: {
                        link: {
                            url: "/collections/all",
                            text: "Shop All"
                        }
                    },
                    defaultValue: [
                        {
                            link: {
                                url: "/collections/all",
                                text: "Shop All"
                            }
                        }, 
                    ]
                }, 
            ]
        },
        {
            label: "Free Shipping Meter",
            name: "freeShipping",
            component: "group",
            description: "Enable, minimum cart spend, messages",
            fields: [
                {
                    label: "Enabled",
                    name: "enabled",
                    component: "toggle",
                    toggleLabels: {
                        true: "On",
                        false: "Off"
                    }
                },
                {
                    label: "Minimum Cart Spend",
                    name: "minCartSpend",
                    component: "number",
                    description: "Minimum cart spend to qualify for free shipping"
                },
                {
                    label: "Progress Message",
                    name: "progressMessage",
                    component: "text",
                    description: "Message when cart has not yet reached minimum spend. Use {{amount}} to display the remaining amount"
                },
                {
                    label: "Qualified Message",
                    name: "qualifiedMessage",
                    component: "text",
                    description: "Message when cart has qualified"
                },
                {
                    label: "Progress Bar Color",
                    name: "progressBarColor",
                    component: "select",
                    options: COLORS
                }, 
            ],
            defaultValue: {
                enabled: false,
                minCartSpend: 100,
                progressMessage: "You're only {{amount}} away from free shipping!",
                qualifiedMessage: "You've qualified for free shipping!",
                progressBarColor: "var(--primary)"
            }
        },
        {
            label: "Totals",
            name: "totals",
            component: "group",
            description: "Subtotal text, subtext, checkout text",
            fields: [
                {
                    label: "Subtotal Text",
                    name: "subtotalText",
                    component: "text"
                },
                {
                    label: "Subtext",
                    name: "subtext",
                    component: "text"
                },
                {
                    label: "Checkout Text",
                    name: "checkoutText",
                    component: "text"
                }, 
            ],
            defaultValue: {
                subtotalText: "Subtotal",
                subtext: "",
                checkoutText: "Checkout"
            }
        },
        {
            label: "Upsell",
            name: "upsell",
            component: "group",
            description: "Enable, message, product",
            fields: [
                {
                    label: "Enabled",
                    name: "enabled",
                    component: "toggle",
                    toggleLabels: {
                        true: "On",
                        false: "Off"
                    }
                },
                {
                    label: "Message",
                    name: "message",
                    component: "text"
                },
                {
                    label: "Product",
                    name: "product",
                    component: "productSearch"
                }, 
            ],
            defaultValue: {
                enabled: false,
                message: "Don't miss out on this item!"
            }
        },
        {
            label: "Line Items",
            name: "lineItems",
            component: "group",
            fields: [
                {
                    label: "Title Overrides",
                    name: "titleOverrides",
                    component: "group-list",
                    itemProps: {
                        label: "{{item.title}} {{item.subtitle}}"
                    },
                    fields: [
                        {
                            label: "Product",
                            name: "product",
                            component: "productSearch"
                        },
                        {
                            label: "Title Override",
                            name: "title",
                            component: "text"
                        },
                        {
                            label: "Subtitle Override",
                            name: "subtitle",
                            component: "text"
                        }, 
                    ]
                }, 
            ]
        }, 
    ]
});

;// CONCATENATED MODULE: ./src/settings/collection.js

/* harmony default export */ var settings_collection = ({
    label: "Collection",
    name: "collection",
    component: "group",
    description: "Filters, sort, pagination, product item, promotion",
    fields: [
        {
            label: "Filters",
            name: "filters",
            component: "group",
            description: "Enable, custom filters, show option count",
            fields: [
                {
                    label: "Enable",
                    name: "enabled",
                    component: "toggle",
                    toggleLabels: {
                        true: "On",
                        false: "Off"
                    },
                    defaultValue: true
                },
                {
                    label: "Show Option Count",
                    name: "showCount",
                    component: "toggle",
                    toggleLabels: {
                        true: "On",
                        false: "Off"
                    },
                    defaultValue: true
                },
                {
                    label: "Sticky To Top",
                    name: "sticky",
                    component: "toggle",
                    description: "Sticky to top of left column on tablet/desktop",
                    toggleLabels: {
                        true: "On",
                        false: "Off"
                    },
                    defaultValue: true
                },
                {
                    label: "Filters",
                    name: "filters",
                    component: "group-list",
                    description: "A filter's options are automatically determined by the products in the collection.\n\nNote: a filter will be hidden if there are no options, or only has one option, which has a count equal to the total number of products in the collection.",
                    itemProps: {
                        label: "{{item.label}}"
                    },
                    fields: [
                        {
                            label: "Shopify Property",
                            name: "source",
                            component: "radio-group",
                            direction: "horizontal",
                            variant: "radio",
                            description: 'Note: Shopify tags must separate name and value with "::", e.g. "colorfilter::Red"',
                            options: [
                                {
                                    label: "Tag",
                                    value: "tag"
                                },
                                {
                                    label: "Option",
                                    value: "option"
                                },
                                {
                                    label: "Product Type",
                                    value: "productType"
                                }, 
                            ]
                        },
                        {
                            label: "Name",
                            name: "name",
                            component: "text",
                            description: 'Letter casing must be same as name in Shopify.\nTags e.g. "colorfilter", "material"\nOptions e.g. "Color", "Size"\nNot applicable for Product Type'
                        },
                        {
                            label: "Label",
                            name: "label",
                            component: "text"
                        },
                        {
                            label: "Uses Color Swatches",
                            name: "isColor",
                            component: "toggle",
                            description: "Matches option value with color value set in:\nStorefront Settings > Product > Colors",
                            toggleLabels: {
                                true: "On",
                                false: "Off"
                            }
                        },
                        {
                            label: "Default Open",
                            name: "defaultOpen",
                            component: "toggle",
                            description: "Applicable only to filter dropdowns on tablet and desktop",
                            toggleLabels: {
                                true: "On",
                                false: "Off"
                            }
                        },
                        {
                            label: "Order Options By",
                            name: "orderValuesBy",
                            component: "radio-group",
                            direction: "horizontal",
                            variant: "radio",
                            options: [
                                {
                                    label: "Alphabet",
                                    value: "alphabet"
                                },
                                {
                                    label: "Number",
                                    value: "number"
                                },
                                {
                                    label: "Custom",
                                    value: "custom"
                                }, 
                            ]
                        },
                        {
                            label: "Custom Order",
                            name: "customOrder",
                            component: "list",
                            field: {
                                component: "text"
                            }
                        }, 
                    ],
                    defaultItem: {
                        source: "tag",
                        name: "tag",
                        label: "Tag",
                        isColor: false,
                        defaultOpen: false,
                        orderValuesBy: "alphabet"
                    },
                    defaultValue: [
                        {
                            source: "productType",
                            name: "",
                            label: "Product Type",
                            isColor: false,
                            defaultOpen: false,
                            orderValuesBy: "alphabet"
                        },
                        {
                            source: "option",
                            name: "Color",
                            label: "Color",
                            isColor: true,
                            defaultOpen: false,
                            orderValuesBy: "alphabet"
                        },
                        {
                            source: "option",
                            name: "Size",
                            label: "Size",
                            isColor: false,
                            defaultOpen: false,
                            orderValuesBy: "custom",
                            customOrder: [
                                "One Size",
                                "OS",
                                "O/S",
                                "XXS",
                                "XX-Small",
                                "XS",
                                "X-Small",
                                "S",
                                "Small",
                                "M",
                                "Medium",
                                "L",
                                "Large",
                                "XL",
                                "X-Large",
                                "XXL",
                                "XX-Large",
                                "XXXL",
                                "XXX-Large", 
                            ]
                        }, 
                    ]
                }, 
            ]
        },
        {
            label: "Pagination",
            name: "pagination",
            component: "group",
            description: "Enable, products per load, load type, load text",
            fields: [
                {
                    label: "Enable",
                    name: "enabled",
                    component: "toggle",
                    description: "Loads products in segments",
                    toggleLabels: {
                        true: "On",
                        false: "Off"
                    }
                },
                {
                    label: "Products Per Load",
                    name: "resultsPerPage",
                    component: "number",
                    description: "Count includes any promo tiles that may be positioned within each load"
                },
                {
                    label: "Load Type",
                    name: "loadType",
                    component: "radio-group",
                    direction: "horizontal",
                    variant: "radio",
                    options: [
                        {
                            label: "Button",
                            value: "button"
                        },
                        {
                            label: "Infinite Scroll",
                            value: "infinite"
                        }, 
                    ]
                },
                {
                    label: "Load Text",
                    name: "loadText",
                    component: "text"
                },
                {
                    label: "Load Button Style",
                    name: "buttonStyle",
                    component: "select",
                    options: [
                        {
                            label: "Primary",
                            value: "btn-primary"
                        },
                        {
                            label: "Secondary",
                            value: "btn-secondary"
                        },
                        {
                            label: "Inverse Light",
                            value: "btn-inverse-light"
                        },
                        {
                            label: "Inverse Dark",
                            value: "btn-inverse-dark"
                        }, 
                    ]
                }, 
            ],
            defaultValue: {
                enabled: true,
                resultsPerPage: 24,
                loadType: "button",
                loadText: "Load More",
                buttonStyle: "btn-inverse-dark"
            }
        },
        {
            label: "Product Item",
            name: "productItem",
            component: "group",
            description: "Star rating, color variant selector, quick shop",
            fields: [
                {
                    label: "Enable Star Rating",
                    name: "enabledStarRating",
                    component: "toggle",
                    toggleLabels: {
                        true: "On",
                        false: "Off"
                    }
                },
                {
                    label: "Enable Color Variant Selector",
                    name: "enabledColorSelector",
                    component: "toggle",
                    toggleLabels: {
                        true: "On",
                        false: "Off"
                    }
                },
                {
                    label: "Enable Color Name On Hover",
                    name: "enabledColorNameOnHover",
                    component: "toggle",
                    toggleLabels: {
                        true: "On",
                        false: "Off"
                    }
                },
                {
                    label: "Enable Quick Shop",
                    name: "enabledQuickShop",
                    component: "toggle",
                    description: 'Note: Quick shop is hidden on mobile and will only show if the product item has only one variant or multiple variants through a single option, e.g. "Size"',
                    toggleLabels: {
                        true: "On",
                        false: "Off"
                    }
                },
                {
                    label: "Quick Shop Text (Multi-variant)",
                    name: "quickShopMultiText",
                    description: "Use {{option}} to display the variant option name",
                    component: "text"
                },
                {
                    label: "Quick Shop Text (Single-variant)",
                    name: "quickShopSingleText",
                    component: "text"
                }, 
            ],
            defaultValue: {
                enabledStarRating: true,
                enabledColorSelector: true,
                enabledColorNameOnHover: false,
                enabledQuickShop: true,
                quickShopMultiText: "+ Quick Add {{option}}",
                quickShopSingleText: "+ Quick Add"
            }
        },
        {
            label: "Promotion",
            name: "promotion",
            component: "group",
            description: "Promo tile campaigns",
            fields: [
                {
                    label: "Promo Tile Campaigns",
                    name: "campaigns",
                    component: "group-list",
                    itemProps: {
                        label: "{{item.name}}"
                    },
                    fields: [
                        {
                            label: "Name",
                            name: "name",
                            component: "text"
                        },
                        {
                            label: "Promo Tiles",
                            name: "promoTiles",
                            component: "group-list",
                            itemProps: {
                                label: "{{item.position}}: {{item.text.heading}}"
                            },
                            fields: [
                                {
                                    label: "Grid Position",
                                    name: "position",
                                    component: "number",
                                    description: "Where should this promo appear in the grid?"
                                },
                                {
                                    label: "Grid Span",
                                    name: "span",
                                    component: "number",
                                    description: "How many columns should this promo span?",
                                    defaultValue: 1
                                },
                                {
                                    label: "Link",
                                    name: "link",
                                    component: "link",
                                    description: "Makes the entire tile a clickable link"
                                },
                                {
                                    label: "Background Settings",
                                    name: "background",
                                    component: "group",
                                    description: "Background color, image, video, dark overlay",
                                    fields: [
                                        {
                                            label: "Background Color",
                                            name: "bgColor",
                                            component: "select",
                                            options: COLORS
                                        },
                                        {
                                            label: "Image Alt",
                                            name: "alt",
                                            component: "text",
                                            description: "Brief description of image"
                                        },
                                        {
                                            label: "Image",
                                            name: "image",
                                            component: "image",
                                            description: "Overrides background color"
                                        },
                                        {
                                            label: "Video URL",
                                            name: "videoSrc",
                                            component: "text",
                                            description: "Overrides image. Autoplays once in view"
                                        },
                                        {
                                            label: "Video Poster Image",
                                            name: "videoPoster",
                                            component: "image",
                                            description: "First frame of video while video loads"
                                        },
                                        {
                                            label: "Overlay Opacity",
                                            name: "overlayOpacity",
                                            component: "number",
                                            description: "Enter a number between 0 and 100",
                                            defaultValue: 50
                                        }, 
                                    ]
                                },
                                {
                                    label: "Text Settings",
                                    name: "text",
                                    component: "group",
                                    description: "Heading, subtext, text color",
                                    fields: [
                                        {
                                            label: "Icon",
                                            name: "icon",
                                            component: "image"
                                        },
                                        {
                                            label: "Supertext",
                                            name: "supertext",
                                            component: "text"
                                        },
                                        {
                                            label: "Supertext Style",
                                            name: "supertextStyle",
                                            component: "select",
                                            options: [
                                                {
                                                    label: "Standard",
                                                    value: "standard"
                                                },
                                                {
                                                    label: "Bubble",
                                                    value: "bubble"
                                                }, 
                                            ]
                                        },
                                        {
                                            label: "Heading",
                                            name: "heading",
                                            component: "text"
                                        },
                                        {
                                            label: "Heading Size",
                                            name: "headingSize",
                                            component: "select",
                                            defaultValue: "standard",
                                            options: [
                                                {
                                                    label: "Standard",
                                                    value: "standard"
                                                },
                                                {
                                                    label: "Large",
                                                    value: "large"
                                                }, 
                                            ]
                                        },
                                        {
                                            label: "Subtext",
                                            name: "subtext",
                                            component: "textarea"
                                        },
                                        {
                                            label: "Enable Bottom Accent",
                                            name: "bottomAccentEnabled",
                                            component: "toggle"
                                        },
                                        {
                                            label: "Bottom Button",
                                            name: "bottomButton",
                                            component: "text"
                                        },
                                        {
                                            label: "Bottom Button Theme",
                                            name: "bottomButtonTheme",
                                            component: "select",
                                            defaultValue: "primary",
                                            options: [
                                                {
                                                    label: "Light",
                                                    value: "light"
                                                },
                                                {
                                                    label: "Primary",
                                                    value: "primary"
                                                },
                                                {
                                                    label: "Secondary",
                                                    value: "secondary"
                                                }, 
                                            ]
                                        },
                                        {
                                            label: "Bottom Button Variant",
                                            name: "bottomButtonVariant",
                                            component: "select",
                                            defaultValue: "filled",
                                            options: [
                                                {
                                                    label: "Outlined",
                                                    value: "outlined"
                                                },
                                                {
                                                    label: "Filled",
                                                    value: "filled"
                                                }, 
                                            ]
                                        },
                                        {
                                            label: "Text Color",
                                            name: "textColor",
                                            component: "select",
                                            options: COLORS
                                        }, 
                                    ]
                                }, 
                            ],
                            defaultItem: {
                                position: 5,
                                aspectRatio: "aspect-[3/4]",
                                background: {
                                    bgColor: "var(--off-white)",
                                    darkOverlay: false
                                },
                                text: {
                                    heading: "Promo Tile Heading",
                                    subtext: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
                                    textColor: "var(--text)"
                                }
                            }
                        },
                        {
                            label: "Collection Handles",
                            name: "collections",
                            component: "list",
                            description: 'Add all collection handles that will run this campaign, e.g. "all", "best-sellers".\n\nTo apply to search results page, add "search"',
                            field: {
                                component: "text"
                            }
                        }, 
                    ],
                    defaultItem: {
                        enabled: true,
                        name: "Campaign",
                        promoTiles: [
                            {
                                position: 5,
                                aspectRatio: "aspect-[3/4]",
                                background: {
                                    bgColor: "var(--off-white)",
                                    darkOverlay: false
                                },
                                text: {
                                    heading: "Promo Tile Heading",
                                    subtext: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
                                    textColor: "var(--text)"
                                }
                            }, 
                        ],
                        collections: [
                            "all"
                        ]
                    }
                }, 
            ]
        },
        {
            label: "Product Type Grids",
            name: "productTypeGrids",
            component: "group-list",
            description: "Define how many grid columns per each Product Type (Default: 3)",
            itemProps: {
                label: "{{item.productType}} - {{item.productTypeGridCount}}"
            },
            fields: [
                {
                    label: "Product Type",
                    component: "text",
                    name: "productType"
                },
                {
                    label: "Grid Count",
                    component: "number",
                    name: "productTypeGridCount",
                    defaultValue: 3
                }, 
            ]
        }, 
    ]
});

;// CONCATENATED MODULE: ./src/settings/contaminants.js
/* harmony default export */ var contaminants = ({
    label: "Contaminants",
    name: "contaminantSettings",
    component: "group",
    description: "List of contaminants referenced throughout the site.",
    fields: [
        {
            label: "Contaminant Categories",
            name: "contaminantCategories",
            component: "group-list",
            itemProps: {
                label: "{{item.categoryName}}"
            },
            fields: [
                {
                    label: "Category Name",
                    name: "categoryName",
                    component: "text"
                },
                {
                    label: "Category Description",
                    name: "categoryDescription",
                    component: "textarea"
                },
                {
                    label: "Challenge Water Units",
                    name: "challengeWaterUnits",
                    component: "text",
                    defaultValue: "(mg/L)"
                },
                {
                    label: "Filtered Water Units",
                    name: "filteredWaterUnits",
                    component: "text",
                    defaultValue: "(mg/L)"
                }, 
            ]
        },
        {
            label: "Contaminants",
            name: "contaminants",
            component: "group-list",
            itemProps: {
                label: "{{item.name}}"
            },
            fields: [
                {
                    label: "Contaminant Name",
                    name: "name",
                    component: "text"
                },
                {
                    label: "Top Ranking Contaminant?",
                    name: "isTop",
                    component: "toggle",
                    defaultValue: false,
                    description: 'Should this contaminant be categorized as a "Top" contaminant. This is largely used on the What\'s in your Water page.'
                },
                {
                    label: "Top Ranking Rate",
                    name: "topRankingRate",
                    component: "number",
                    defaultValue: 50,
                    description: "If this is a top contaminant, what's it's rank? Used to determine the order of priority"
                },
                {
                    label: "Contaminant Category",
                    name: "category",
                    component: "text",
                    description: "This value should match the Contaminant Category name EXACTLY."
                },
                {
                    label: "Aliases",
                    name: "aliases",
                    description: "What other names does this contaminant go by?",
                    component: "group-list",
                    itemProps: {
                        label: "{{item.alias}}"
                    },
                    fields: [
                        {
                            component: "text",
                            name: "alias",
                            label: "Alias Name"
                        }, 
                    ]
                },
                {
                    component: "text",
                    name: "challengeWater",
                    label: "Challenge Water"
                },
                {
                    component: "text",
                    name: "filteredWater",
                    label: "Filtered Water"
                },
                {
                    component: "text",
                    name: "percentRemoved",
                    label: "Percent Removed"
                },
                {
                    component: "text",
                    name: "healthConcern",
                    label: "Health Concern"
                }, 
            ]
        }, 
    ]
});

;// CONCATENATED MODULE: ./src/settings/filter-replacement-calculator.js
/* harmony default export */ var filter_replacement_calculator = ({
    label: "Filter Replacement Calculator",
    name: "filterReplacementCalculator",
    component: "group",
    description: "Settings for the filter replacement calculator modal.",
    fields: [
        {
            label: "CTA to open calculator",
            name: "ctaToOpenCalculator",
            component: "text",
            defaultValue: "Help Me Decide"
        },
        {
            label: "Calculator Title",
            name: "title",
            component: "text",
            defaultValue: "How often should I change my water filter?"
        },
        {
            label: "Slider label",
            name: "label",
            component: "text",
            defaultValue: "Use the slider to select the number of people in your household"
        },
        {
            label: "CTA within calculator",
            name: "ctaWithinCalculator",
            component: "text",
            defaultValue: "Add To Cart"
        },
        {
            component: "group-list",
            name: "recommendations",
            label: "Products",
            description: "Recommended purchase frequency by people in household",
            itemProps: {
                label: "{{item.product.handle}}"
            },
            fields: [
                {
                    component: "productSearch",
                    name: "product",
                    label: "Product"
                },
                {
                    component: "group-list",
                    name: "recommendation",
                    label: "Recommendation",
                    itemProps: {
                        label: "{{item.people}} people -> {{item.frequency}} months"
                    },
                    fields: [
                        {
                            component: "number",
                            name: "people",
                            label: "People"
                        },
                        {
                            component: "number",
                            name: "frequency",
                            label: "Recommended Purchase Frequency (In Months)"
                        }, 
                    ]
                }, 
            ]
        },
        {
            component: "markdown",
            name: "disclaimer",
            label: "Disclaimer"
        }, 
    ]
});

;// CONCATENATED MODULE: ./src/settings/footer.js

/* harmony default export */ var footer = ({
    label: "Footer",
    name: "footer",
    component: "group",
    description: "Menu, social, legal, email marketing",
    fields: [
        {
            label: "Background Color",
            name: "bgColor",
            component: "select",
            options: COLORS,
            defaultValue: "var(--black)"
        },
        {
            label: "Text Color",
            name: "textColor",
            component: "select",
            options: COLORS,
            defaultValue: "var(--white)"
        },
        {
            label: "Email Marketing",
            name: "marketing",
            component: "group",
            description: "Enable, heading, text",
            fields: [
                {
                    label: "Heading",
                    name: "heading",
                    component: "text"
                },
                {
                    label: "Subtext",
                    name: "subtext",
                    component: "textarea"
                }, 
            ],
            defaultValue: {
                enabled: true,
                heading: "Stay In Touch",
                subtext: "Get the latest news and updates sent straight to your inbox.",
                placeholder: "Enter your email...",
                buttonText: "Sign Up"
            }
        },
        {
            label: "Legal",
            name: "legal",
            component: "group",
            description: "Legal links, copyright notice",
            fields: [
                {
                    label: "Legal Links",
                    name: "links",
                    component: "group-list",
                    itemProps: {
                        label: "{{item.link.text}}"
                    },
                    fields: [
                        {
                            label: "Link",
                            name: "link",
                            component: "link"
                        }, 
                    ],
                    defaultValue: [
                        {
                            link: {
                                text: "Privacy Policy",
                                url: "/pages/privacy-policy"
                            }
                        },
                        {
                            link: {
                                text: "Terms & Conditions",
                                url: "/pages/terms-conditions"
                            }
                        }, 
                    ]
                },
                {
                    label: "Site Copyright Notice",
                    name: "copyrightNotice",
                    component: "text",
                    defaultValue: "All Rights Reserved"
                }, 
            ]
        },
        {
            label: "Menu",
            name: "menu",
            component: "group",
            description: "Menu items",
            fields: [
                {
                    label: "Menu Items",
                    name: "menuItems",
                    component: "group-list",
                    itemProps: {
                        label: "{{item.title}}"
                    },
                    fields: [
                        {
                            label: "Menu Item Title",
                            name: "title",
                            component: "text"
                        },
                        {
                            label: "Menu Item Links",
                            name: "links",
                            component: "group-list",
                            itemProps: {
                                label: "{{item.link.text}}"
                            },
                            fields: [
                                {
                                    label: "Link",
                                    name: "link",
                                    component: "link"
                                }, 
                            ]
                        }, 
                    ]
                }, 
            ]
        },
        {
            label: "Social",
            name: "social",
            component: "group",
            description: "Social links, heading",
            fields: [
                {
                    label: "Social Links",
                    name: "links",
                    component: "group-list",
                    itemProps: {
                        label: "{{item.platform}}"
                    },
                    fields: [
                        {
                            label: "Platform",
                            name: "platform",
                            component: "select",
                            options: [
                                {
                                    label: "Facebook",
                                    value: "facebook"
                                },
                                {
                                    label: "Instagram",
                                    value: "instagram"
                                },
                                {
                                    label: "LinkedIn",
                                    value: "linkedin"
                                },
                                {
                                    label: "Pinterest",
                                    value: "pinterest"
                                },
                                {
                                    label: "TikTok",
                                    value: "tiktok"
                                },
                                {
                                    label: "Twitter",
                                    value: "twitter"
                                },
                                {
                                    label: "Vimeo",
                                    value: "vimeo"
                                },
                                {
                                    label: "YouTube",
                                    value: "youtube"
                                }, 
                            ]
                        },
                        {
                            label: "Url",
                            name: "url",
                            component: "text"
                        }, 
                    ],
                    defaultItem: {
                        platform: "facebook",
                        url: ""
                    }
                }, 
            ]
        },
        {
            label: "Quiz Widget Settings",
            name: "quizWidgetSettings",
            component: "group",
            description: "Settings for contaminants quiz widget.",
            fields: [
                {
                    label: "Widget Title",
                    name: "title",
                    component: "text"
                },
                {
                    label: "Widget Link",
                    name: "link",
                    component: "link"
                },
                {
                    label: "Widget Background Color",
                    name: "bgColor",
                    component: "select",
                    options: COLORS,
                    defaultValue: "var(--black)"
                },
                {
                    label: "Widget Background Image",
                    name: "bgImage",
                    component: "image"
                }, 
            ]
        }, 
    ]
});

;// CONCATENATED MODULE: ./src/settings/general.js
/* harmony default export */ var general = ({
    label: "General",
    name: "general",
    component: "group",
    description: "General site settings",
    fields: [
        {
            label: "Logo",
            name: "logo",
            component: "image"
        },
        {
            label: "Favicon",
            name: "favicon",
            component: "image"
        }, 
    ]
});

;// CONCATENATED MODULE: ./src/settings/header.js

/* harmony default export */ var header = ({
    label: "Header",
    name: "header",
    component: "group",
    description: "Menu, promobar",
    fields: [
        {
            label: "Promobar",
            name: "promobar",
            component: "group",
            description: "Enable, messages, colors, slider settings",
            fields: [
                {
                    label: "Enabled",
                    name: "enabled",
                    component: "toggle",
                    toggleLabels: {
                        true: "On",
                        false: "Off"
                    },
                    defaultValue: true
                },
                {
                    label: "Autohide",
                    name: "autohide",
                    component: "toggle",
                    description: "Hides promobar after scrolling away from top of the page",
                    toggleLabels: {
                        true: "On",
                        false: "Off"
                    },
                    defaultValue: true
                },
                {
                    label: "Autoplay Delay",
                    name: "delay",
                    component: "number",
                    description: "Delay between transitions (in ms)",
                    defaultValue: 5000
                },
                {
                    label: "Speed",
                    name: "speed",
                    component: "number",
                    description: "Duration of transition between slides (in ms)",
                    defaultValue: 500
                },
                {
                    label: "Messages",
                    name: "messages",
                    component: "group-list",
                    itemProps: {
                        label: "{{item.message}}"
                    },
                    fields: [
                        {
                            label: "Message",
                            name: "message",
                            component: "text"
                        },
                        {
                            label: "Link (optional)",
                            name: "link",
                            component: "link",
                            description: "Link wrapping entire message"
                        }, 
                    ],
                    defaultItem: {
                        message: "Free shipping on orders over $100. Shop Now"
                    }
                }, 
            ]
        },
        {
            label: "Menu",
            name: "menu",
            component: "group",
            description: "Menu items, products slider, links",
            fields: [
                {
                    label: "Menu Items",
                    name: "menuItems",
                    component: "group-list",
                    itemProps: {
                        label: "{{item.menuItem.text}}"
                    },
                    fields: [
                        {
                            label: "Menu Item",
                            name: "menuItem",
                            component: "link"
                        },
                        {
                            label: "Submenu Links",
                            name: "links",
                            component: "group-list",
                            itemProps: {
                                label: "{{item.link.text}}"
                            },
                            description: "The standard desktop menu. This menu will always be used for mobile. Use Icon Menu Links below for an alternative desktop style.",
                            fields: [
                                {
                                    label: "Link",
                                    name: "link",
                                    component: "link"
                                },
                                {
                                    label: "Submenu Item Icon",
                                    name: "image",
                                    component: "image"
                                },
                                {
                                    label: "Subnav Cards",
                                    name: "subnavCards",
                                    component: "group-list",
                                    itemProps: {
                                        label: "{{item.title}}"
                                    },
                                    validate: {
                                        maxItems: 3
                                    },
                                    fields: [
                                        {
                                            label: "Enable Gradient Background",
                                            name: "enableGradient",
                                            component: "toggle",
                                            defaultValue: false
                                        },
                                        {
                                            label: "Image",
                                            name: "image",
                                            component: "image"
                                        },
                                        {
                                            label: "Title",
                                            name: "title",
                                            component: "text"
                                        },
                                        {
                                            label: "Link",
                                            name: "link",
                                            component: "link"
                                        }, 
                                    ]
                                }, 
                            ]
                        },
                        {
                            label: "Icon Menu Links",
                            name: "iconMenuLinks",
                            component: "group-list",
                            description: "An alternate icon-style menu that will take precedence over Submenu Links on desktop if available.",
                            itemProps: {
                                label: "{{item.link.text}}"
                            },
                            fields: [
                                {
                                    label: "Icon",
                                    name: "icon",
                                    component: "image",
                                    description: "Icons should be black and have transparent backgrounds to work properly here."
                                },
                                {
                                    label: "Link",
                                    name: "link",
                                    component: "link"
                                }, 
                            ]
                        },
                        {
                            label: "Insert Logo Before",
                            name: "logoBefore",
                            component: "toggle",
                            toggleLabels: {
                                true: "On",
                                false: "Off"
                            }
                        }, 
                    ],
                    defaultItem: {
                        menuItem: {
                            text: "Shop",
                            url: "/collections/all"
                        }
                    }
                },
                {
                    label: "Addtional Links",
                    name: "links",
                    description: "Visible only in menu sidebar",
                    component: "group-list",
                    itemProps: {
                        label: "{{item.link.text}}"
                    },
                    fields: [
                        {
                            label: "Icon",
                            name: "icon",
                            component: "image"
                        },
                        {
                            label: "Link",
                            name: "link",
                            component: "link"
                        }, 
                    ]
                }, 
            ]
        },
        {
            label: "Appearance",
            name: "appearance",
            description: "Update how the header appears per page.",
            component: "group-list",
            itemProps: {
                label: "Page: {{item.affectedPage.text}}"
            },
            fields: [
                {
                    label: "Affected Page",
                    name: "affectedPage",
                    description: "Which page should these styles apply to?",
                    component: "link"
                },
                {
                    label: "Transparent Mode",
                    name: "transparentMode",
                    description: "Should the header sit atop content, and have a transparent background? (Disappears on scroll)",
                    component: "toggle",
                    defaultValue: false
                },
                {
                    label: "Transparent Mode Text Color",
                    name: "transparentModeTextColor",
                    description: "What color should the text be if 'Transparent Mode' is enabled above?",
                    component: "select",
                    defaultValue: "dark",
                    options: [
                        {
                            label: "Light",
                            value: "light"
                        },
                        {
                            label: "Dark",
                            value: "dark"
                        }, 
                    ]
                }, 
            ]
        }, 
    ]
});

;// CONCATENATED MODULE: ./src/settings/pandectes.js

/* harmony default export */ var pandectes = ({
    label: "Pandectes (GPC)",
    name: "pandectes",
    component: "group",
    description: "Settings pertaining to the GPC, specifically around Pandectes integration",
    fields: [
        {
            label: "Enable Banner",
            name: "gpcBannerEnabled",
            component: "toggle",
            defaultValue: false
        },
        {
            label: "Display for gpc",
            name: "gpcBannerGpcEnabled",
            component: "toggle",
            defaultValue: false
        },
        {
            label: "Display for dnt",
            name: "gpcBannerDntEnabled",
            component: "toggle",
            defaultValue: false
        },
        {
            label: "Banner Text",
            name: "gpcBannerText",
            component: "text",
            defaultValue: "We respect your Global Privacy Control (GPC) signal and automatically opt you out of non-essential cookies and data sharing."
        },
        {
            label: "Banner Background Color",
            name: "gpcBannerColor",
            component: "select",
            options: COLORS,
            defaultValue: "#CCE0F1"
        }, 
    ]
});

;// CONCATENATED MODULE: ./src/settings/product.js

/* harmony default export */ var settings_product = ({
    label: "Product",
    name: "product",
    component: "group",
    description: "Add to cart, back in stock, badges, color swatches, reviews",
    fields: [
        {
            label: "Add To Cart",
            name: "addToCart",
            component: "group",
            description: "Add to cart, sold out, presale text, subtext",
            fields: [
                {
                    label: "Add To Cart Text",
                    name: "addToCartText",
                    component: "text"
                },
                {
                    label: "Sold Out Text",
                    name: "soldOutText",
                    component: "text"
                },
                {
                    label: "Preorder Text",
                    name: "preorderText",
                    component: "text"
                },
                {
                    label: "Subtext",
                    name: "subtext",
                    component: "text",
                    description: "Text below the Add To Cart button"
                }, 
            ],
            defaultValue: {
                addToCartText: "Add To Cart",
                soldOutText: "Sold Out",
                preorderText: "Preorder",
                subtext: ""
            }
        },
        {
            label: "Back In Stock",
            name: "backInStock",
            component: "group",
            description: "Enable notifications, notify me text, modal texts",
            fields: [
                {
                    label: "Enable Notifications",
                    name: "enabled",
                    component: "toggle",
                    toggleLabels: {
                        true: "On",
                        false: "Off"
                    }
                },
                {
                    label: "Notify Me Text",
                    name: "notifyMeText",
                    component: "text"
                },
                {
                    label: "Modal Heading",
                    name: "heading",
                    component: "text"
                },
                {
                    label: "Modal Subtext",
                    name: "subtext",
                    component: "text"
                },
                {
                    label: "Modal Submit Text",
                    name: "submitText",
                    component: "text"
                }, 
            ],
            defaultValue: {
                enabled: false,
                notifyMeText: "Notify Me When Available",
                heading: "Notify Me When Available",
                subtext: "Enter your email below and we'll notify you when this product is back in stock.",
                submitText: "Submit"
            }
        },
        {
            label: "Badges",
            name: "badges",
            component: "group",
            description: "Badge colors",
            fields: [
                {
                    label: "Badge Colors",
                    name: "badgeColors",
                    component: "group-list",
                    description: 'Note: product badges are set up via Shopify tags using the format "badge::Some Value"',
                    itemProps: {
                        label: "{{item.tag}}"
                    },
                    fields: [
                        {
                            label: "Tag Value",
                            name: "tag",
                            component: "text",
                            description: 'Letter casing must be same as tag value in Shopify, e.g. "New", "Sale"'
                        },
                        {
                            label: "Background Color",
                            name: "bgColor",
                            component: "select",
                            options: COLORS
                        },
                        {
                            label: "Text Color",
                            name: "textColor",
                            component: "select",
                            options: COLORS
                        }, 
                    ],
                    defaultItem: {
                        bgColor: "var(--black)",
                        textColor: "var(--white)"
                    },
                    defaultValue: [
                        {
                            tag: "Best Seller",
                            bgColor: "var(--black)",
                            textColor: "var(--white)"
                        },
                        {
                            tag: "New",
                            bgColor: "var(--secondary)",
                            textColor: "var(--white)"
                        },
                        {
                            tag: "Sale",
                            bgColor: "var(--primary)",
                            textColor: "var(--white)"
                        }, 
                    ]
                }, 
            ]
        },
        {
            label: "Colors",
            name: "colors",
            component: "group",
            description: "Color swatches",
            fields: [
                {
                    label: "Color Swatches",
                    name: "swatches",
                    component: "group-list",
                    itemProps: {
                        label: "{{item.name}}"
                    },
                    defaultItem: function() {
                        return {
                            name: "New Color"
                        };
                    },
                    fields: [
                        {
                            label: "Color Name",
                            name: "name",
                            component: "text"
                        },
                        {
                            label: "Color",
                            name: "color",
                            component: "color"
                        },
                        {
                            name: "image",
                            label: "Image",
                            component: "image",
                            description: "If provided, image will overlay the color.\nEnsure image is no more than 2KB in size"
                        }, 
                    ],
                    defaultValue: [
                        {
                            name: "Black",
                            color: "#000000"
                        },
                        {
                            name: "White",
                            color: "#FFFFFF"
                        }, 
                    ]
                }, 
            ]
        },
        {
            label: "Reviews",
            name: "reviews",
            component: "group",
            description: "Star rating",
            fields: [
                {
                    label: "Enable Star Rating",
                    name: "enabledStarRating",
                    component: "toggle",
                    toggleLabels: {
                        true: "On",
                        false: "Off"
                    }
                }, 
            ],
            defaultValue: {
                enabledStarRating: true
            }
        }, 
    ]
});

;// CONCATENATED MODULE: ./src/settings/search.js
/* harmony default export */ var search = ({
    label: "Search",
    name: "search",
    component: "group",
    description: "Search results, autocomplete, suggestions",
    fields: [
        {
            label: "Search Results",
            name: "results",
            component: "group",
            fields: [
                {
                    label: "Product Search Enabled",
                    name: "productsEnabled",
                    component: "toggle",
                    toggleLabels: {
                        true: "On",
                        false: "Off"
                    }
                },
                {
                    label: "Collection Search Enabled",
                    name: "collectionsEnabled",
                    component: "toggle",
                    toggleLabels: {
                        true: "On",
                        false: "Off"
                    }
                },
                {
                    label: "Page Search Enabled",
                    name: "pagessEnabled",
                    component: "toggle",
                    toggleLabels: {
                        true: "On",
                        false: "Off"
                    }
                },
                {
                    label: "No Results Text",
                    name: "noResultsText",
                    component: "text"
                }, 
            ],
            defaultValue: {
                productsEnabled: true,
                collectionsEnabled: true,
                noResultsText: "No results found."
            }
        },
        {
            label: "Search Autocomplete",
            name: "autocomplete",
            component: "group",
            description: "Autogenerated list of suggested search terms matching current input",
            fields: [
                {
                    label: "Enabled",
                    name: "enabled",
                    component: "toggle",
                    toggleLabels: {
                        true: "On",
                        false: "Off"
                    }
                },
                {
                    label: "Heading",
                    name: "heading",
                    component: "text"
                },
                {
                    label: "Limit",
                    name: "limit",
                    component: "number"
                }, 
            ],
            defaultValue: {
                enabled: true,
                heading: "Suggested Searches....",
                limit: 5
            }
        },
        {
            label: "Search Suggestions",
            name: "suggestions",
            component: "group",
            description: "Preset list of suggested search terms visible only when there are no results or search input",
            fields: [
                {
                    label: "Enabled",
                    name: "enabled",
                    component: "toggle",
                    toggleLabels: {
                        true: "On",
                        false: "Off"
                    }
                },
                {
                    label: "Heading",
                    name: "heading",
                    component: "text"
                },
                {
                    label: "Terms",
                    name: "terms",
                    component: "list",
                    field: {
                        component: "text"
                    }
                }, 
            ],
            defaultValue: {
                enabled: true,
                heading: "Suggested Searches....",
                terms: [
                    "Pitchers",
                    "Water Bottles",
                    "Fridge Filters"
                ]
            }
        }, 
    ]
});

;// CONCATENATED MODULE: ./src/settings/subscriptions.js
/* harmony default export */ var subscriptions = ({
    label: "Recharge Subscriptions",
    name: "subscriptions",
    component: "group",
    description: "Settings pertaining to the Recharge subscription widget.",
    fields: [
        {
            label: "Subscription Products",
            name: "subscriptionProducts",
            component: "group-list",
            itemProps: {
                label: "{{item.product.title}}"
            },
            fields: [
                {
                    label: "Product",
                    name: "product",
                    component: "productSearch"
                },
                {
                    label: "Subscribe & Save Subtext",
                    name: "subscribeSaveSubText",
                    component: "text",
                    defaultValue: "Free US Shipping. Delay or cancel anytime."
                },
                {
                    label: "Default Recommended Frequency",
                    name: "defaultRecommendedFrequency",
                    component: "number",
                    description: "Must match one of the frequency options available in the Recharge app."
                },
                {
                    label: "Override Selection Text",
                    name: "overrideSelectionText",
                    component: "text",
                    description: 'Replaces the "Delivery every" string in the select box text.'
                },
                {
                    label: "Override Recurring Price",
                    name: "overrideRecurringPrice",
                    component: "number",
                    description: 'For product swap subscriptions where the next price doesn\'t match the "Ships Now" price.'
                },
                {
                    label: "Recurring Price Title Override",
                    name: "overrideRecurringPriceTitle",
                    component: "text",
                    description: 'Replaces the "Recurring Price" text.'
                },
                {
                    label: "Ships Now",
                    component: "group",
                    name: "shipsNow",
                    description: "Which items ship now?",
                    fields: [
                        {
                            label: "Show Ships Now?",
                            name: "show",
                            component: "toggle",
                            toggleLabels: {
                                true: "On",
                                false: "Off"
                            }
                        },
                        {
                            label: "Image",
                            name: "image",
                            component: "image",
                            description: "Leave blank to default to the product's image"
                        },
                        {
                            label: "Items",
                            name: "items",
                            component: "markdown",
                            description: "Use {qty} as a variable to replace it with the quantity used in the cart."
                        }, 
                    ]
                },
                {
                    label: "Ships Recurringly ",
                    component: "group",
                    name: "shipsRecurringly",
                    description: "Which items ship on a recurring basis?",
                    fields: [
                        {
                            label: "Show Ships Recurringly?",
                            name: "show",
                            component: "toggle",
                            toggleLabels: {
                                true: "On",
                                false: "Off"
                            }
                        },
                        {
                            label: "Image",
                            name: "image",
                            component: "image"
                        },
                        {
                            label: "Items",
                            name: "items",
                            component: "markdown",
                            description: "Use {qty} as a variable to replace it with the qty used in the cart."
                        }, 
                    ]
                }, 
            ]
        }, 
    ]
});

;// CONCATENATED MODULE: ./src/settings/theme.js
var BUTTON_COLOR_FIELDS = [
    {
        label: "Background Color",
        name: "bgColor",
        component: "color"
    },
    {
        label: "Border Color",
        name: "borderColor",
        component: "color"
    },
    {
        label: "Text Color",
        name: "textColor",
        component: "color"
    },
    {
        label: "Hover Background Color",
        name: "hoverBgColor",
        component: "color"
    },
    {
        label: "Hover Border Color",
        name: "hoverBorderColor",
        component: "color"
    },
    {
        label: "Hover Text Color",
        name: "hoverTextColor",
        component: "color"
    }, 
];
/* harmony default export */ var theme = ({
    label: "Theme",
    name: "theme",
    component: "group",
    description: "Theme colors, button colors",
    fields: [
        {
            label: "Buttons",
            name: "buttons",
            component: "group",
            fields: [
                {
                    label: "Primary",
                    name: "primary",
                    component: "group",
                    fields: BUTTON_COLOR_FIELDS,
                    defaultValue: {
                        bgColor: "#202635",
                        borderColor: "#202635",
                        textColor: "#FFFFFF",
                        hoverBgColor: "#0064B7",
                        hoverBorderColor: "#0064B7",
                        hoverTextColor: "#FFFFFF"
                    }
                },
                {
                    label: "Secondary",
                    name: "secondary",
                    component: "group",
                    fields: BUTTON_COLOR_FIELDS,
                    defaultValue: {
                        bgColor: "#0064B7",
                        borderColor: "#0064B7",
                        textColor: "#FFFFFF",
                        hoverBgColor: "#202635",
                        hoverBorderColor: "#202635",
                        hoverTextColor: "#FFFFFF"
                    }
                },
                {
                    label: "Inverse Light",
                    name: "inverseLight",
                    component: "group",
                    fields: BUTTON_COLOR_FIELDS,
                    defaultValue: {
                        bgColor: "transparent",
                        borderColor: "#FFFFFF",
                        textColor: "#FFFFFF",
                        hoverBgColor: "#FFFFFF",
                        hoverBorderColor: "#FFFFFF",
                        hoverTextColor: "#111111"
                    }
                },
                {
                    label: "Inverse Dark",
                    name: "inverseDark",
                    component: "group",
                    fields: BUTTON_COLOR_FIELDS,
                    defaultValue: {
                        bgColor: "transparent",
                        borderColor: "#111111",
                        textColor: "#111111",
                        hoverBgColor: "#111111",
                        hoverBorderColor: "#111111",
                        hoverTextColor: "#FFFFFF"
                    }
                }, 
            ]
        },
        {
            label: "Colors",
            name: "colors",
            component: "group",
            fields: [
                {
                    label: "Background",
                    name: "background",
                    component: "color"
                },
                {
                    label: "Text",
                    name: "text",
                    component: "color"
                },
                {
                    label: "Border",
                    name: "border",
                    component: "color"
                },
                {
                    label: "Primary",
                    name: "primary",
                    component: "color"
                },
                {
                    label: "Secondary",
                    name: "secondary",
                    component: "color"
                },
                {
                    label: "Accent 1",
                    name: "accent1",
                    component: "color"
                },
                {
                    label: "Accent 2",
                    name: "accent2",
                    component: "color"
                },
                {
                    label: "Accent 3",
                    name: "accent3",
                    component: "color"
                },
                {
                    label: "Success",
                    name: "success",
                    component: "color"
                },
                {
                    label: "Error",
                    name: "error",
                    component: "color"
                },
                {
                    label: "Black",
                    name: "black",
                    component: "color"
                },
                {
                    label: "Off Black",
                    name: "offBlack",
                    component: "color"
                },
                {
                    label: "Dark Gray",
                    name: "darkGray",
                    component: "color"
                },
                {
                    label: "Medium Dark Gray",
                    name: "mediumDarkGray",
                    component: "color"
                },
                {
                    label: "Medium Gray",
                    name: "mediumGray",
                    component: "color"
                },
                {
                    label: "Gray",
                    name: "gray",
                    component: "color"
                },
                {
                    label: "Light Gray",
                    name: "lightGray",
                    component: "color"
                },
                {
                    label: "Off White",
                    name: "offWhite",
                    component: "color"
                },
                {
                    label: "White",
                    name: "white",
                    component: "color"
                }, 
            ],
            defaultValue: {
                background: "#ECF7FF",
                text: "#202635",
                border: "#ECF7FF",
                primary: "#202635",
                secondary: "#0064b7",
                accent1: "#F1DCC1",
                accent2: "#8DCEF9",
                accent3: "#C1EFFA",
                success: "#5ABE8A",
                error: "#ED7C5C",
                black: "#111111",
                offBlack: "#202635",
                darkGray: "#484848",
                mediumDarkGray: "#707070",
                mediumGray: "#989898",
                gray: "#C0C0C0",
                lightGray: "#E8E8E8",
                offWhite: "#ECF7FF",
                white: "#FFFFFF"
            }
        }, 
    ]
});

;// CONCATENATED MODULE: ./src/settings/index.js
















/* harmony default export */ var settings = ([
    account,
    analytics,
    beam,
    blog,
    cart,
    settings_collection,
    contaminants,
    filter_replacement_calculator,
    footer,
    general,
    header,
    pandectes,
    settings_product,
    search,
    subscriptions,
    theme, 
]);

;// CONCATENATED MODULE: ./src/hooks/EWG/useEWGResults.js








function useEWGResults(page) {
    var ref;
    var settings = (0,dist.useSettings)();
    var EWGapiKey = "5a4227b3-e33c-a232-3681-44ebb7b5f221";
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react.useState)(null), EWGResults = ref2[0], setEWGResults = ref2[1];
    var ref3 = (0,react.useState)(null), EWGSystems = ref3[0], setEWGSystems = ref3[1];
    var ref4 = (0,react.useState)(null), activeEWGSystem = ref4[0], setActiveEWGSystem = ref4[1];
    var ref5 = (0,react.useState)(null), zipCode = ref5[0], setZipCode = ref5[1];
    var contaminantSettings = (0,_object_spread/* default */.Z)({}, settings).contaminantSettings;
    var router = (0,next_router.useRouter)();
    var setEWGSystemsFromZip = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var localStorageData, systemsListEndpoint, systemsListResponse, systemsListResponseJSON, ref;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(((page === null || page === void 0 ? void 0 : page.handle) === "whats-in-your-water" || (page === null || page === void 0 ? void 0 : page.handle) === "whats-in-your-water-quiz") && (zipCode === null || zipCode === void 0 ? void 0 : zipCode.length) === 5)) return [
                        3,
                        4
                    ];
                    localStorageData = localStorage.getItem("EWG-".concat(zipCode)) ? JSON.parse(localStorage.getItem("EWG-".concat(zipCode))) : null;
                    if (!(localStorageData && (localStorageData === null || localStorageData === void 0 ? void 0 : localStorageData.zipCode) && (localStorageData === null || localStorageData === void 0 ? void 0 : localStorageData.activeEWGSystem) && (localStorageData === null || localStorageData === void 0 ? void 0 : localStorageData.EWGSystems))) return [
                        3,
                        1
                    ];
                    console.log("Setting EWG Systems from LocalStorage");
                    setEWGSystems(localStorageData === null || localStorageData === void 0 ? void 0 : localStorageData.EWGSystems);
                    setActiveEWGSystem(localStorageData === null || localStorageData === void 0 ? void 0 : localStorageData.activeEWGSystem);
                    return [
                        3,
                        4
                    ];
                case 1:
                    console.log("Fetching EWG Systems from API");
                    systemsListEndpoint = "https://waterapi.ewg.org/zip_systems.php?zip=".concat(zipCode, "&key=").concat(EWGapiKey);
                    return [
                        4,
                        fetch(systemsListEndpoint)
                    ];
                case 2:
                    systemsListResponse = _state.sent();
                    return [
                        4,
                        systemsListResponse.json()
                    ];
                case 3:
                    systemsListResponseJSON = _state.sent();
                    if (systemsListResponseJSON === null || systemsListResponseJSON === void 0 ? void 0 : systemsListResponseJSON.SystemList) {
                        ;
                        setEWGSystems(systemsListResponseJSON === null || systemsListResponseJSON === void 0 ? void 0 : systemsListResponseJSON.SystemList);
                        setActiveEWGSystem(systemsListResponseJSON === null || systemsListResponseJSON === void 0 ? void 0 : (ref = systemsListResponseJSON.SystemList) === null || ref === void 0 ? void 0 : ref[0]);
                    }
                    _state.label = 4;
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        zipCode
    ]);
    // Set the EWG Result Set from the current active System.
    var setEWGResultsFromActiveSystem = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref, localStorageData, ref1, ref2, systemsDataEndpoint, systemsDataResponse, systemsDataResponseJSON, localStorageResultsData, localStorageDataToSave;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(((page === null || page === void 0 ? void 0 : page.handle) === "whats-in-your-water" || (page === null || page === void 0 ? void 0 : page.handle) === "whats-in-your-water-quiz") && (activeEWGSystem === null || activeEWGSystem === void 0 ? void 0 : activeEWGSystem.PWS))) return [
                        3,
                        4
                    ];
                    localStorageData = localStorage.getItem("EWG-".concat(zipCode)) ? JSON.parse(localStorage.getItem("EWG-".concat(zipCode))) : null;
                    if (!(localStorageData && (localStorageData === null || localStorageData === void 0 ? void 0 : (ref = localStorageData.EWGResults) === null || ref === void 0 ? void 0 : ref[activeEWGSystem === null || activeEWGSystem === void 0 ? void 0 : activeEWGSystem.PWS]))) return [
                        3,
                        1
                    ];
                    console.log("Setting EWG Data from LocalStorage");
                    setLoading(true);
                    setEWGResults(localStorageData === null || localStorageData === void 0 ? void 0 : (ref1 = localStorageData.EWGResults) === null || ref1 === void 0 ? void 0 : ref1[activeEWGSystem === null || activeEWGSystem === void 0 ? void 0 : activeEWGSystem.PWS]);
                    setLoading(false);
                    return [
                        3,
                        4
                    ];
                case 1:
                    console.log("Fetching EWG Data from API");
                    setLoading(true);
                    systemsDataEndpoint = "https://waterapi.ewg.org/systeminformation.php?pws=".concat(activeEWGSystem === null || activeEWGSystem === void 0 ? void 0 : activeEWGSystem.PWS, "&key=").concat(EWGapiKey);
                    return [
                        4,
                        fetch(systemsDataEndpoint)
                    ];
                case 2:
                    systemsDataResponse = _state.sent();
                    return [
                        4,
                        systemsDataResponse.json()
                    ];
                case 3:
                    systemsDataResponseJSON = _state.sent();
                    setLoading(false);
                    if ((systemsDataResponseJSON === null || systemsDataResponseJSON === void 0 ? void 0 : (ref2 = systemsDataResponseJSON.ContaminantList) === null || ref2 === void 0 ? void 0 : ref2.length) > 0) {
                        // Loop through the data we get back from EWG and append any Clearly Filtered Data that we have.
                        systemsDataResponseJSON.ContaminantList = systemsDataResponseJSON.ContaminantList.map(function(EWGContaminant) {
                            var ref, ref1;
                            var foundClearlyFilteredData = false;
                            var EWGContaminantName = EWGContaminant === null || EWGContaminant === void 0 ? void 0 : (ref = EWGContaminant.ContaminantName) === null || ref === void 0 ? void 0 : ref.toLowerCase();
                            contaminantSettings === null || contaminantSettings === void 0 ? void 0 : (ref1 = contaminantSettings.contaminants) === null || ref1 === void 0 ? void 0 : ref1.forEach(function(contaminant) {
                                var ref;
                                var contaminantName = contaminant === null || contaminant === void 0 ? void 0 : (ref = contaminant.name) === null || ref === void 0 ? void 0 : ref.toLowerCase();
                                if (EWGContaminantName === contaminantName) {
                                    foundClearlyFilteredData = contaminant;
                                }
                            });
                            if (foundClearlyFilteredData) {
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, EWGContaminant), {
                                    ClearlyFilteredData: foundClearlyFilteredData
                                });
                            }
                            return EWGContaminant;
                        });
                    }
                    localStorageResultsData = localStorage.getItem("EWG-".concat(zipCode)) ? JSON.parse(localStorage.getItem("EWG-".concat(zipCode))) : null;
                    localStorageDataToSave = {
                        zipCode: zipCode,
                        EWGSystems: EWGSystems,
                        activeEWGSystem: activeEWGSystem,
                        EWGResults: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, localStorageResultsData === null || localStorageResultsData === void 0 ? void 0 : localStorageResultsData.EWGResults), (0,_define_property/* default */.Z)({}, activeEWGSystem === null || activeEWGSystem === void 0 ? void 0 : activeEWGSystem.PWS, systemsDataResponseJSON))
                    };
                    localStorage.setItem("EWG-".concat(zipCode), JSON.stringify(localStorageDataToSave));
                    setEWGResults(systemsDataResponseJSON);
                    _state.label = 4;
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        activeEWGSystem
    ]);
    // On router query change, let's check for a zip code and set it if we're on the What's in your water page.
    (0,react.useEffect)(function() {
        var ref, ref1;
        if (((page === null || page === void 0 ? void 0 : page.handle) === "whats-in-your-water" || (page === null || page === void 0 ? void 0 : page.handle) === "whats-in-your-water-quiz") && (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.zip) && (router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.zip.length) === 5) {
            setZipCode(router.query.zip);
        }
    }, [
        router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.zip
    ]);
    // On zipCode change, let's set the EWG Systems based on our zipCode
    (0,react.useEffect)(function() {
        if (((page === null || page === void 0 ? void 0 : page.handle) === "whats-in-your-water" || (page === null || page === void 0 ? void 0 : page.handle) === "whats-in-your-water-quiz") && (zipCode === null || zipCode === void 0 ? void 0 : zipCode.length) === 5) {
            setEWGSystemsFromZip();
        }
    }, [
        zipCode
    ]);
    // When our EWG System changes, let's fetch our new data
    (0,react.useEffect)(function() {
        if (((page === null || page === void 0 ? void 0 : page.handle) === "whats-in-your-water" || (page === null || page === void 0 ? void 0 : page.handle) === "whats-in-your-water-quiz") && activeEWGSystem) {
            setEWGResultsFromActiveSystem();
        }
    }, [
        activeEWGSystem
    ]);
    // Which Contaminants Exceed the EWG Recommended Guidelines?
    var EWGResultsExceedingGuidelines = (0,react.useMemo)(function() {
        var ref;
        if ((EWGResults === null || EWGResults === void 0 ? void 0 : EWGResults.ContaminantList) && (EWGResults === null || EWGResults === void 0 ? void 0 : (ref = EWGResults.ContaminantList) === null || ref === void 0 ? void 0 : ref.length) > 0) {
            var ref1;
            return EWGResults === null || EWGResults === void 0 ? void 0 : (ref1 = EWGResults.ContaminantList) === null || ref1 === void 0 ? void 0 : ref1.filter(function(contaminant) {
                return (contaminant === null || contaminant === void 0 ? void 0 : contaminant.SystemAverage) > (contaminant === null || contaminant === void 0 ? void 0 : contaminant.ContaminantHGValue) && contaminant.ContaminantHGValue > 0;
            });
        }
        return null;
    }, [
        EWGResults === null || EWGResults === void 0 ? void 0 : EWGResults.ContaminantList
    ]);
    // Which Contaminants are Within the EWG Recommended Guidelines?
    var EWGResultsWithinGuidelines = (0,react.useMemo)(function() {
        var ref;
        if ((EWGResults === null || EWGResults === void 0 ? void 0 : EWGResults.ContaminantList) && (EWGResults === null || EWGResults === void 0 ? void 0 : (ref = EWGResults.ContaminantList) === null || ref === void 0 ? void 0 : ref.length) > 0) {
            var ref1;
            return EWGResults === null || EWGResults === void 0 ? void 0 : (ref1 = EWGResults.ContaminantList) === null || ref1 === void 0 ? void 0 : ref1.filter(function(contaminant) {
                return !((contaminant === null || contaminant === void 0 ? void 0 : contaminant.SystemAverage) > (contaminant === null || contaminant === void 0 ? void 0 : contaminant.ContaminantHGValue) && contaminant.ContaminantHGValue > 0);
            });
        }
        return null;
    }, [
        EWGResults === null || EWGResults === void 0 ? void 0 : EWGResults.ContaminantList
    ]);
    // Contaminants that have been removed by Clearly Filtered as specified in the contaminants Global Site Settings.
    var EWGResultsRemovedContaminants = (0,react.useMemo)(function() {
        var ref;
        if ((EWGResults === null || EWGResults === void 0 ? void 0 : EWGResults.ContaminantList) && (EWGResults === null || EWGResults === void 0 ? void 0 : (ref = EWGResults.ContaminantList) === null || ref === void 0 ? void 0 : ref.length) > 0) {
            var ref1;
            return EWGResults === null || EWGResults === void 0 ? void 0 : (ref1 = EWGResults.ContaminantList) === null || ref1 === void 0 ? void 0 : ref1.filter(function(contaminant) {
                var ref;
                return !!(contaminant === null || contaminant === void 0 ? void 0 : (ref = contaminant.ClearlyFilteredData) === null || ref === void 0 ? void 0 : ref.percentRemoved);
            });
        }
        return null;
    }, [
        EWGResults === null || EWGResults === void 0 ? void 0 : EWGResults.ContaminantList
    ]);
    // Determines the top 3 contaminants by topRankingRate.
    var EWGResultsTop3Contaminants = (0,react.useMemo)(function() {
        var ref;
        if ((EWGResults === null || EWGResults === void 0 ? void 0 : EWGResults.ContaminantList) && (EWGResults === null || EWGResults === void 0 ? void 0 : (ref = EWGResults.ContaminantList) === null || ref === void 0 ? void 0 : ref.length) > 0) {
            return EWGResults === null || EWGResults === void 0 ? void 0 : EWGResults.ContaminantList.sort(function(a, b) {
                var ref, ref1;
                var aTopRankingRate = (a === null || a === void 0 ? void 0 : (ref = a.ClearlyFilteredData) === null || ref === void 0 ? void 0 : ref.topRankingRate) ? a.ClearlyFilteredData.topRankingRate : 999999999;
                var bTopRankingRate = (b === null || b === void 0 ? void 0 : (ref1 = b.ClearlyFilteredData) === null || ref1 === void 0 ? void 0 : ref1.topRankingRate) ? b.ClearlyFilteredData.topRankingRate : 999999999;
                if (aTopRankingRate < bTopRankingRate) {
                    return -1;
                }
                if (aTopRankingRate > bTopRankingRate) {
                    return 1;
                }
                return 0;
            }).slice(0, 3);
        }
        return null;
    }, [
        EWGResults === null || EWGResults === void 0 ? void 0 : EWGResults.ContaminantList
    ]);
    return (0,react.useMemo)(function() {
        return {
            loading: loading,
            zipCode: zipCode,
            setZipCode: setZipCode,
            EWGSystems: EWGSystems,
            activeEWGSystem: activeEWGSystem,
            setActiveEWGSystem: setActiveEWGSystem,
            contaminantSettings: contaminantSettings,
            EWGResults: EWGResults,
            EWGResultsExceedingGuidelines: EWGResultsExceedingGuidelines,
            EWGResultsWithinGuidelines: EWGResultsWithinGuidelines,
            EWGResultsRemovedContaminants: EWGResultsRemovedContaminants,
            EWGResultsTop3Contaminants: EWGResultsTop3Contaminants
        };
    }, [
        zipCode,
        setZipCode,
        EWGSystems,
        loading,
        activeEWGSystem,
        setActiveEWGSystem,
        contaminantSettings,
        EWGResults,
        EWGResultsExceedingGuidelines,
        EWGResultsWithinGuidelines,
        EWGResultsRemovedContaminants,
        EWGResultsTop3Contaminants, 
    ]);
}

// EXTERNAL MODULE: ./src/hooks/useIpFetcher.js
var useIpFetcher = __webpack_require__(8311);
;// CONCATENATED MODULE: ./src/layouts/Storefront.jsx












function StorefrontLayout(_param) {
    var ContentForLayout = _param.ContentForLayout, props = (0,_object_without_properties/* default */.Z)(_param, [
        "ContentForLayout"
    ]);
    var ref, ref1, ref2, ref3, ref4;
    var settings = (0,dist.useSettings)();
    var asPath = (0,next_router.useRouter)().asPath;
    var scrolledPast = (0,hooks/* useScrollPosition */.RF)(100);
    var ref5 = (0,react.useState)(false), transparentMode = ref5[0], setTransparentMode = ref5[1];
    var ref6 = (0,react.useState)("dark"), transparentModeTextColor = ref6[0], setTransparentModeTextColor = ref6[1];
    var ref7 = (0,react.useState)(false), initialTransparentMode = ref7[0], setInitialTransparentMode = ref7[1];
    var page = props.page;
    var EWGProviderValue = useEWGResults(page);
    var promobar = settings === null || settings === void 0 ? void 0 : (ref = settings.header) === null || ref === void 0 ? void 0 : ref.promobar;
    var promobarDisabled = !!promobar && (!promobar.enabled || !((ref1 = promobar.messages) === null || ref1 === void 0 ? void 0 : ref1.length));
    var ref8 = (0,react.useState)(false), promobarHidden = ref8[0], setPromobarHidden = ref8[1];
    (0,react.useEffect)(function() {
        var ref;
        var found = false;
        settings === null || settings === void 0 ? void 0 : (ref = settings.header) === null || ref === void 0 ? void 0 : ref.appearance.forEach(function(page) {
            var ref;
            if (asPath.split("?").shift() === (page === null || page === void 0 ? void 0 : (ref = page.affectedPage) === null || ref === void 0 ? void 0 : ref.url)) {
                setTransparentMode(page.transparentMode);
                setInitialTransparentMode(page.transparentMode);
                setTransparentModeTextColor(page.transparentModeTextColor);
                found = true;
            } else if (found === false) {
                setTransparentMode(false);
                setInitialTransparentMode(false);
                setTransparentModeTextColor("dark");
            }
        });
    }, [
        asPath,
        settings
    ]);
    (0,react.useEffect)(function() {
        if (initialTransparentMode) {
            if (scrolledPast) {
                setTransparentMode(false);
            } else {
                setTransparentMode(true);
            }
        }
    }, [
        scrolledPast
    ]);
    /* Load globally used scripts */ (0,react.useEffect)(function() {
        // Load Okendo
        if (!document.getElementById("okendo-script")) {
            var metaTag = document.createElement("meta");
            metaTag.name = "oke:subscriber_id";
            metaTag.content = "1ad203d1-4b76-42c0-b9db-d76307bcf033";
            document.head.appendChild(metaTag);
            var scriptTag = document.createElement("script");
            scriptTag.id = "okendo-script";
            scriptTag.src = "https://cdn-static.okendo.io/reviews-widget-plus/js/okendo-reviews.js";
            document.head.appendChild(scriptTag);
        }
        // Gorgias Convert Bundle Loader
        if (!document.getElementById("convert-bundle-loader")) {
            var scriptTag1 = document.createElement("script");
            scriptTag1.id = "convert-bundle-loader";
            scriptTag1.src = "https://bundle.dyn-rev.app/loader.js?g_cvt_id=1d937050-2158-458a-9480-d20341ca9294";
            document.head.appendChild(scriptTag1);
        }
    }, []);
    // initialize customer, cart, shop and markets
    (0,dist.useStorefrontInit)();
    // auto applies cart discount found on the landing url
    (0,dist.useCartAddDiscountUrl)();
    // set css var for viewport height
    (0,hooks/* useSetViewportHeightCssVar */.ri)();
    // set css vars for theme colors
    (0,hooks/* useThemeColors */._B)();
    // send page view and add to cart events to Shopify analytics
    (0,hooks/* useShopifyAnalytics */.bu)({
        collection: props.collection,
        product: props.product
    });
    // fetch user IP, save in localstorage
    (0,useIpFetcher/* useIpFetcher */.X)(settings === null || settings === void 0 ? void 0 : (ref2 = settings.cart) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.shippingBar) === null || ref3 === void 0 ? void 0 : ref3.ipinfoKey);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EWGContext.Provider, {
        value: EWGProviderValue,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(contexts/* GlobalContextProvider */.n, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* StorefrontHead */.wI, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* TestVariant */.pV, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* VisuallyIo */.mm, (0,_object_spread/* default */.Z)({}, props)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* DataLayer */.WJ, (0,_object_spread/* default */.Z)({}, props)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Scripts */.KC, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* SchemaMarkup */.Hb, (0,_object_spread/* default */.Z)({}, props)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Header */.h4, {
                    page: page,
                    scrolledPast: scrolledPast,
                    setPromoBarHidden: setPromobarHidden,
                    promobarHidden: promobarHidden,
                    transparentModeTextColor: transparentModeTextColor,
                    transparentMode: transparentMode,
                    promobarDisabled: promobarDisabled
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                    className: "".concat(promobarDisabled ? "pt-[60px] md:pt-[var(--header-height)]" : "pt-[calc(60px+var(--promobar-height))] md:pt-[calc(var(--header-height)+var(--promobar-height))] print:!pt-0", " ").concat(initialTransparentMode ? "!pt-0" : "", " ").concat((page === null || page === void 0 ? void 0 : (ref4 = page.template) === null || ref4 === void 0 ? void 0 : ref4.type) === "product" && scrolledPast ? "" : ""),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentForLayout, (0,_object_spread/* default */.Z)({}, props))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Footer */.$_, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Overlay */.aV, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Cart */.AP, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Search */.ol, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Account */.mR, {
                    promobarHidden: promobarHidden
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Modal */.u_, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Drawer */.dy, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Upsellit */.qV, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Pandectes */.KW, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(snippets/* Superfiliate */.J, {})
            ]
        })
    });
}
/* harmony default export */ var Storefront = (StorefrontLayout);

// EXTERNAL MODULE: ./src/styles/storefront.css
var storefront = __webpack_require__(1307);
;// CONCATENATED MODULE: ./src/pages/_app.jsx
/* eslint-disable react/destructuring-assignment */ /* eslint-disable import/no-unresolved */ 






// This is new customizer bridge






(0,utils/* rafTimeoutInterval */.N$)();
function StorefrontApp(param) {
    var Component = param.Component, pageData = param.pageData, pageProps = param.pageProps, router = param.router, storefrontSettings = param.storefrontSettings;
    var setRoute = dist.store.recoil.useSetRecoilState(dist.store.state.route);
    var setStorefrontSettings = dist.store.recoil.useSetRecoilState(dist.store.state.storefrontSettings);
    var config = (0,telejson_dist/* parse */.Qc)((pageProps === null || pageProps === void 0 ? void 0 : pageProps.config) || "{}");
    // update ROUTE_VIEW state
    // this is responsible for sending all the VIEW_X events
    (0,react.useEffect)(function() {
        setRoute(router.asPath);
    }, [
        router.asPath,
        setRoute
    ]);
    // update the storefront settings in recoil store
    (0,react.useEffect)(function() {
        setStorefrontSettings(storefrontSettings);
    }, [
        storefrontSettings,
        setStorefrontSettings
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(_components/* Partytown */.iA, (0,_object_spread/* default */.Z)({}, config === null || config === void 0 ? void 0 : config.partytown)),
            pageProps.isPreview && pageProps.isShareableToken && /*#__PURE__*/ (0,jsx_runtime.jsx)(_components/* PreviewModeToast */.UZ, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Storefront, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                ContentForLayout: Component
            }, pageProps), {
                config: config,
                renderSections: (0,customizerUtils.renderSections)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pageProps), {
                    page: pageData
                }), sections)
            }))
        ]
    });
}
var useOverlayScript = function(param) {
    var isPreview = param.isPreview, overlay = param.overlay;
    (0,react.useEffect)(function() {
        if (isPreview && ((overlay === null || overlay === void 0 ? void 0 : overlay.src) || (overlay === null || overlay === void 0 ? void 0 : overlay.version)) && !window.isOverlayScriptInjected) {
            var script = document.createElement("script");
            script.src = (overlay === null || overlay === void 0 ? void 0 : overlay.src) || "https://d3dizc9fcooe02.cloudfront.net/overlay@".concat(overlay === null || overlay === void 0 ? void 0 : overlay.version, "/dist/overlay.js");
            script.async = true;
            document.head.appendChild(script);
            window.isOverlayScriptInjected = true;
        }
    }, [
        isPreview,
        overlay
    ]);
};
function App(props) {
    var ref;
    var Component = props.Component, pageProps = props.pageProps, router = props.router;
    var ref1 = (0,customizerUtils.useCustomizerShell)({
        environment: pageProps.environment,
        isPreview: pageProps.isPreview,
        isShareableToken: pageProps.isShareableToken,
        sectionComponents: sections,
        staticProps: pageProps,
        storefrontSettingsSchema: settings
    }), pageData = ref1.pageData, storefrontSettings = ref1.storefrontSettings;
    useOverlayScript({
        isPreview: pageProps.isPreview,
        overlay: (ref = pageProps.customizerMeta) === null || ref === void 0 ? void 0 : ref.overlay
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(_components/* PageErrorBoundary */.bg, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.StateProvider, {
            pageData: pageData,
            pageProps: pageProps,
            route: router.asPath,
            storefrontSettings: storefrontSettings,
            children: /*#__PURE__*/ react.cloneElement(/*#__PURE__*/ (0,jsx_runtime.jsx)(StorefrontApp, {}), {
                Component: Component,
                pageData: pageData,
                pageProps: pageProps,
                router: router,
                storefrontSettings: storefrontSettings
            }, null)
        })
    });
}
/* harmony default export */ var _app = (App);


/***/ }),

/***/ 3913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ ArticleBlockQuote; },
  "V": function() { return /* binding */ Blockquote; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
;// CONCATENATED MODULE: ./src/sections/ArticleBlockQuote/ArticleBlockQuote.schema.js
var Schema = function() {
    return {
        category: "Article",
        label: "Article Block Quote",
        key: "articleBlockQuote",
        //   previewSrc:
        //     'https://cdn.shopify.com/s/files/1/1011/0318/files/Screen_20Shot_202023-05-24_20at_202.55.23_20PM.png?v=1684965343',
        fields: [
            {
                name: "title",
                component: "text",
                label: "Title",
                description: "Leave Blank to hide from Table of Contents"
            },
            {
                name: "quote",
                component: "text",
                label: "Quote",
                defaultValue: "Many dissolved solids naturally increase water’s conductivity. Therefore, TDS meters measure conductivity—not contaminants—to estimate TDS levels."
            }, 
        ]
    };
};

;// CONCATENATED MODULE: ./src/sections/ArticleBlockQuote/ArticleBlockQuote.jsx


function Blockquote(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative mb-8 font-light text-[#3383C5] lg:mb-16 lg:text-[42px] lg:leading-[56px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-[1px] w-full bg-gradient-to-r from-[#2179C2] via-[#8DCEF9] to-[#F1DCC1]"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("blockquote", {
                className: "py-16 font-light text-[#3383C5] lg:text-[42px] lg:leading-[56px]",
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-[1px] w-full bg-gradient-to-r from-[#F1DCC1] via-[#8DCEF9] to-[#2179C2]"
            })
        ]
    });
}
function ArticleBlockQuote(param) {
    var cms = param.cms;
    var quote = cms.quote;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Blockquote, {
        children: quote
    });
}
ArticleBlockQuote.displayName = "ArticleBlockQuote";
ArticleBlockQuote.Schema = Schema;


/***/ }),

/***/ 3263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PasswordlessLogin; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(5034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(169);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5556);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7378);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8039);
/* harmony import */ var jwt_decode__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6601);
/* harmony import */ var _backpackjs_storefront__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2031);
/* harmony import */ var _backpackjs_storefront__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _hooks_useAuth__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2868);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(714);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3183);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7388);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7373);
// https://clearly-filtered-dev.us.auth0.com/authorize?response_type=code&client_id=rguBLkw4a1pJe2Mwqf5VZQy8SmYUtoAN
// https://clearly-filtered-dev.us.auth0.com/v2/logout?response_type=code&client_id=rguBLkw4a1pJe2Mwqf5VZQy8SmYUtoAN








// eslint-disable-next-line camelcase




// eslint-disable-next-line import/no-unresolved



function PasswordlessLogin() {
    var ref, ref1;
    var query = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().query;
    var customer = (0,_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_4__.useCustomer)();
    var getCustomerAccessTokenWithMultipass = (0,_hooks_useAuth__WEBPACK_IMPORTED_MODULE_5__/* .useAuth */ .a)().getCustomerAccessTokenWithMultipass;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), loading = ref2[0], setLoading = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("email"), step = ref3[0], setStep = ref3[1];
    var ref4 = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_10__/* .useForm */ .cI)(), register = ref4.register, handleSubmit = ref4.handleSubmit, watch = ref4.watch, setError = ref4.setError, errors = ref4.formState.errors;
    var checkMultipass = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function(token) {
            var ref, ref1, res, accessToken, safeNewValue, shopifyName, key;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getCustomerAccessTokenWithMultipass(token)
                        ];
                    case 1:
                        res = _state.sent();
                        accessToken = res === null || res === void 0 ? void 0 : (ref = res.body) === null || ref === void 0 ? void 0 : ref.customerAccessToken;
                        if (!accessToken) {
                            console.log("no access token found");
                            setError("email", {
                                type: "custom",
                                message: "no access token found"
                            });
                            setLoading(false);
                            return [
                                2
                            ];
                        }
                        safeNewValue = {
                            token: accessToken.accessToken,
                            expires: accessToken.expiresAt
                        };
                        shopifyName = ((ref1 = "clearly-filtered.myshopify.com") === null || ref1 === void 0 ? void 0 : ref1.split(".")[0]) || "";
                        key = "CustomerToken|".concat(shopifyName);
                        window.localStorage.setItem(key, JSON.stringify(safeNewValue));
                        // reload page if setting customer doesn't work
                        window.location = "/account?login=success";
                        return [
                            2
                        ];
                }
            });
        });
        return function checkMultipass(token) {
            return _ref.apply(this, arguments);
        };
    }();
    var submitEmail = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function(data) {
            var email, endpoint, options, response, resData;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        email = data.email;
                        (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .trackTripleWhaleContact */ .p1)({
                            email: email
                        });
                        endpoint = "/api/auth0-submit-email";
                        options = {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                email: email
                            })
                        };
                        return [
                            4,
                            fetch(endpoint, options)
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            4,
                            response.json()
                        ];
                    case 2:
                        resData = _state.sent();
                        if (resData.error_description) {
                            setError("email", {
                                type: "custom",
                                message: resData.error_description
                            });
                            return [
                                2
                            ];
                        }
                        if (resData.error) {
                            setError("email", {
                                type: "custom",
                                message: resData.error
                            });
                            return [
                                2
                            ];
                        }
                        setStep("otp");
                        return [
                            2
                        ];
                }
            });
        });
        return function submitEmail(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var submitOtp = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function(data) {
            var email, otp, endpoint, options, response, authResult, decoded;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        email = data.email, otp = data.otp;
                        endpoint = "/api/auth0-submit-otp";
                        options = {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                email: email,
                                code: otp
                            })
                        };
                        return [
                            4,
                            fetch(endpoint, options)
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            4,
                            response.json()
                        ];
                    case 2:
                        authResult = _state.sent();
                        if (authResult.error_description) {
                            setError("otp", {
                                type: "custom",
                                message: authResult.error_description
                            });
                            return [
                                2
                            ];
                        }
                        if (authResult.error) {
                            setError("otp", {
                                type: "custom",
                                message: authResult.error
                            });
                            return [
                                2
                            ];
                        }
                        if (authResult.id_token) {
                            setLoading(true);
                            decoded = (0,jwt_decode__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(authResult.id_token);
                            checkMultipass(decoded.multipass_token);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function submitOtp(data) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!(query === null || query === void 0 ? void 0 : query.session_token)) {
            return;
        }
        setLoading(true);
        checkMultipass(query.session_token);
    }, [
        query
    ]);
    // useEffect(() => {
    //   if (customer) {
    //     window.location = '/account?login=success';
    //   }
    // }, [customer]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            !loading && step === "email" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                    onSubmit: handleSubmit(submitEmail),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "mb-4 flex items-center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                                    className: "grow border-[var(--text)]"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_9__/* .Body */ .uT, {
                                    variant: "medium",
                                    className: "px-4 text-center",
                                    children: "Login with a one time code"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                                    className: "grow border-[var(--text)]"
                                })
                            ]
                        }),
                        errors.email && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            role: "alert",
                            className: "mb-2 text-red-500",
                            children: (ref = errors.email) === null || ref === void 0 ? void 0 : ref.message
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, register("email")), {
                            id: "email",
                            type: "email",
                            placeholder: "your@email.com",
                            className: "null w-full border border-[#DDE2E7] px-3 py-5 text-sm font-light !outline-0"
                        })),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_8__/* .Button */ .zx, {
                            theme: "primary",
                            variant: "filled",
                            type: "submit",
                            className: "mx-auto mt-6 flex w-full max-w-[250px] items-center justify-center",
                            children: "Send me a login code"
                        })
                    ]
                })
            }),
            !loading && step === "otp" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                    onSubmit: handleSubmit(submitOtp),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: "hidden",
                            children: [
                                "An email with the code has been sent to ",
                                watch("email")
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "mb-4 flex items-center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                                    className: "grow border-[var(--text)]"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_9__/* .Body */ .uT, {
                                    variant: "medium",
                                    className: "px-4 text-center",
                                    children: "Login with a one time code"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                                    className: "grow border-[var(--text)]"
                                })
                            ]
                        }),
                        errors.otp && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            role: "alert",
                            className: "mb-2 text-red-500",
                            children: (ref1 = errors.otp) === null || ref1 === void 0 ? void 0 : ref1.message
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, register("otp")), {
                            type: "text",
                            placeholder: "000000",
                            className: "null w-full border border-[#DDE2E7] px-3 py-5 text-sm font-light !outline-0"
                        })),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_8__/* .Button */ .zx, {
                            theme: "primary",
                            variant: "filled",
                            type: "submit",
                            className: "mx-auto mt-6 flex w-full max-w-[250px] items-center justify-center",
                            children: "Verify code"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mt-4 block text-center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                type: "button",
                                onClick: function() {
                                    return setStep("email");
                                },
                                children: "didn't receive a code?"
                            })
                        })
                    ]
                })
            }),
            loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_7__/* .AccountsAuthLoader */ .iT, {})
        ]
    });
}


/***/ }),

/***/ 9729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* reexport */ AddToCart; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(3842);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(1373);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(5556);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(3615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../node_modules/@backpackjs/storefront/dist/index.js
var dist = __webpack_require__(2031);
// EXTERNAL MODULE: ./src/hooks/index.js + 36 modules
var hooks = __webpack_require__(4068);
// EXTERNAL MODULE: ./src/snippets/Button/index.js + 2 modules
var Button = __webpack_require__(7388);
// EXTERNAL MODULE: ./src/snippets/Link/index.js + 1 modules
var Link = __webpack_require__(7227);
// EXTERNAL MODULE: ./src/snippets/Spinner/index.js + 1 modules
var Spinner = __webpack_require__(7804);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ./src/contexts/index.js + 1 modules
var contexts = __webpack_require__(8249);
// EXTERNAL MODULE: ./src/snippets/Typography/index.js + 3 modules
var Typography = __webpack_require__(7373);
;// CONCATENATED MODULE: ./src/snippets/AddToCart/BackInStockModal.jsx










function BackInStockModal(param) {
    var selectedVariant = param.selectedVariant, product = param.product;
    var ref;
    var sendSubscribeEvent = (0,hooks/* useDataLayerActions */.KZ)().sendSubscribeEvent;
    var customer = (0,dist.useCustomer)();
    var settings = (0,dist.useSettings)();
    var ref1 = (0,contexts/* useGlobalContext */.b)(), closeModal = ref1.actions.closeModal;
    var ref2 = (0,react.useState)((customer === null || customer === void 0 ? void 0 : customer.email) || ""), email = ref2[0], setEmail = ref2[1];
    var ref3 = (0,react.useState)(), submissionMessage = ref3[0], setSubmissionMessage = ref3[1];
    var ref4 = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.product) === null || ref === void 0 ? void 0 : ref.backInStock), heading = ref4.heading, subtext = ref4.subtext, submitText = ref4.submitText;
    var handleSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var ref, response, data, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            fetch("/api/out-of-stock", {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify({
                                    email: email,
                                    variant: selectedVariant.legacyResourceId
                                })
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        return [
                            4,
                            response.json()
                        ];
                    case 3:
                        data = _state.sent();
                        if (!data) {
                            throw new Error("No data returned from Out of Stock Notifications API");
                        }
                        if ((ref = data.errors) === null || ref === void 0 ? void 0 : ref.length) {
                            throw new Error(data.errors[0].detail);
                        }
                        setSubmissionMessage("You're in! We'll let you know when it's back");
                        sendSubscribeEvent({
                            email: email,
                            form_id: "product_back_in_stock_signup"
                        });
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        console.error("Out of Stock Notifications Error: ".concat(error.message));
                        throw error;
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(e) {
            return _ref.apply(this, arguments);
        };
    }(), [
        email,
        selectedVariant
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "text-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-screen max-w-[700px] px-12 py-[50px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mx-auto max-w-[550px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Eyebrow */.j4, {
                        className: "mb-4 uppercase",
                        children: heading
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                            variant: "h4",
                            element: "h2",
                            className: "mb-4",
                            children: selectedVariant.product.title
                        })
                    }),
                    subtext && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mt-6",
                        children: subtext
                    }),
                    selectedVariant.title !== "Default Title" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Body */.uT, {
                        variant: "large",
                        className: "mt-4 !font-bold",
                        children: selectedVariant.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        className: "mx-auto mt-[50px] flex w-full max-w-[386px] flex-col items-center",
                        onSubmit: handleSubmit,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                className: "w-full border border-[#DDE2E7] bg-white p-[18px] md:max-w-[30rem]",
                                name: "email",
                                onChange: function(e) {
                                    return setEmail(e.target.value);
                                },
                                placeholder: "Enter your email...",
                                required: true,
                                type: "email",
                                value: email
                            }),
                            submissionMessage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "relative mt-[40px] w-full border border-success p-[10px] text-center text-success before:absolute before:inset-0 before:bg-success before:opacity-[0.15]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: submissionMessage
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                                "aria-label": "Notify Me",
                                className: "mt-[40px] max-md:w-full",
                                type: "submit",
                                variant: "filled",
                                theme: "primary",
                                children: submitText
                            })
                        ]
                    })
                ]
            })
        })
    });
}
BackInStockModal.displayName = "BackInStockModal";

;// CONCATENATED MODULE: ./src/snippets/AddToCart/useAddToCart.js






function useAddToCart() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        addToCartTextOverride: "",
        selectedVariant: null
    }, addToCartTextOverride = ref.addToCartText, selectedVariant = ref.selectedVariant, selectedSellingPlan = ref.selectedSellingPlan, purchaseType = ref.purchaseType, showPrice = ref.showPrice, price = ref.price;
    var ref1, ref2, ref3, ref4, ref5, ref6;
    var ref7 = (0,contexts/* useGlobalContext */.b)(), _actions = ref7.actions, openCart = _actions.openCart, openModal = _actions.openModal, closeDrawer = _actions.closeDrawer;
    var cartAddItem = (0,dist.useCartAddItem)().cartAddItem;
    var _ref = (0,dist.useProductInventoryByHandle)({
        handle: selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref1 = selectedVariant.product) === null || ref1 === void 0 ? void 0 : ref1.handle,
        withInventory: false
    }), inventory = _ref.inventory, inventoryStatus = (0,_object_without_properties/* default */.Z)(_ref, [
        "inventory"
    ]);
    var settings = (0,dist.useSettings)();
    var ref8 = (0,react.useState)(false), isAdding = ref8[0], setIsAdding = ref8[1];
    var isLoading = !(inventoryStatus === null || inventoryStatus === void 0 ? void 0 : inventoryStatus.success);
    var variantInventory = inventory === null || inventory === void 0 ? void 0 : (ref2 = inventory.variants) === null || ref2 === void 0 ? void 0 : ref2[selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id];
    var variantIsSoldOut = !isLoading && !(variantInventory === null || variantInventory === void 0 ? void 0 : variantInventory.availableForSale);
    var variantIsPreorder = !variantIsSoldOut && (variantInventory === null || variantInventory === void 0 ? void 0 : variantInventory.currentlyNotInStock);
    var enabledNotifyMe = settings === null || settings === void 0 ? void 0 : (ref3 = settings.product) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.backInStock) === null || ref4 === void 0 ? void 0 : ref4.enabled;
    var buttonText = "";
    if (variantIsPreorder) {
        var ref9, ref10;
        buttonText = (settings === null || settings === void 0 ? void 0 : (ref9 = settings.product) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.addToCart) === null || ref10 === void 0 ? void 0 : ref10.preorderText) || "Preorder";
    } else if (variantIsSoldOut) {
        var ref11, ref12, ref13, ref14;
        buttonText = enabledNotifyMe ? (settings === null || settings === void 0 ? void 0 : (ref11 = settings.product) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.backInStock) === null || ref12 === void 0 ? void 0 : ref12.notifyMeText) || "Notify Me" : (settings === null || settings === void 0 ? void 0 : (ref13 = settings.product) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.addToCart) === null || ref14 === void 0 ? void 0 : ref14.soldOutText) || "Sold Out";
    } else {
        var ref15, ref16;
        buttonText = addToCartTextOverride || (settings === null || settings === void 0 ? void 0 : (ref15 = settings.product) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.addToCart) === null || ref16 === void 0 ? void 0 : ref16.addToCartText) || "Add To Cart";
        if (showPrice && price) {
            buttonText += " — ".concat(price);
        }
    }
    var handleAddToCart = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref, cartItem;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id)) return [
                        2
                    ];
                    setIsAdding(true);
                    cartItem = {
                        merchandiseId: selectedVariant.id,
                        quantity: 1
                    };
                    if (purchaseType && purchaseType === "subscription" && (selectedSellingPlan === null || selectedSellingPlan === void 0 ? void 0 : (ref = selectedSellingPlan.sellingPlan) === null || ref === void 0 ? void 0 : ref.id)) {
                        cartItem.sellingPlanId = selectedSellingPlan.sellingPlan.id;
                    }
                    return [
                        4,
                        cartAddItem(cartItem)
                    ];
                case 1:
                    _state.sent();
                    setIsAdding(false);
                    openCart();
                    return [
                        2
                    ];
            }
        });
    }), [
        isAdding,
        isLoading,
        selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id,
        purchaseType,
        selectedSellingPlan, 
    ]);
    var handleNotifyMe = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(component) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (!(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id) || isLoading) return [
                    2
                ];
                closeDrawer();
                openModal(component);
                return [
                    2
                ];
            });
        });
        return function(component) {
            return _ref.apply(this, arguments);
        };
    }(), [
        isLoading,
        selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id
    ]);
    return {
        state: {
            buttonText: buttonText,
            isAdding: isAdding,
            isLoading: isLoading,
            isNotifyMe: variantIsSoldOut && enabledNotifyMe,
            isSoldOut: variantIsSoldOut,
            subtext: settings === null || settings === void 0 ? void 0 : (ref5 = settings.product) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.addToCart) === null || ref6 === void 0 ? void 0 : ref6.subtext
        },
        actions: {
            handleAddToCart: handleAddToCart,
            handleNotifyMe: handleNotifyMe
        }
    };
}

;// CONCATENATED MODULE: ./src/snippets/AddToCart/AddToCart.jsx













function AddToCart(param) {
    var addToCartText = param.addToCartText, className = param.className, discountCode = param.discountCode, isPdp = param.isPdp, selectedVariant = param.selectedVariant, selectedSellingPlan = param.selectedSellingPlan, purchaseType = param.purchaseType, productType = param.productType, product = param.product, showPrice = param.showPrice, minPrice = param.minPrice, oosDisclaimer = param.oosDisclaimer, oosDisclaimerColor = param.oosDisclaimerColor, oosDisclaimerUrl = param.oosDisclaimerUrl, oosDisclaimerOpenNewTab = param.oosDisclaimerOpenNewTab, disclaimer = param.disclaimer, disclaimerColor = param.disclaimerColor, disclaimerUrl = param.disclaimerUrl, disclaimerOpenNewTab = param.disclaimerOpenNewTab;
    var ref, ref1, ref2;
    var _ref = (0,dist.useCartAddDiscount)(), cartAddDiscount = _ref.cartAddDiscount, addDiscountStatus = (0,_object_without_properties/* default */.Z)(_ref, [
        "cartAddDiscount"
    ]);
    var price = (0,hooks/* useVariantPrices */.be)({
        variant: selectedVariant,
        purchaseType: purchaseType,
        isPdp: isPdp
    }).price;
    var ref3 = useAddToCart({
        addToCartText: addToCartText,
        selectedVariant: selectedVariant,
        selectedSellingPlan: selectedSellingPlan,
        purchaseType: purchaseType,
        showPrice: showPrice,
        price: price
    }), _state = ref3.state, buttonText = _state.buttonText, isAdding = _state.isAdding, isLoading = _state.isLoading, isNotifyMe = _state.isNotifyMe, isSoldOut = _state.isSoldOut, subtext = _state.subtext, _actions = ref3.actions, handleAddToCart = _actions.handleAddToCart, handleNotifyMe = _actions.handleNotifyMe;
    var addToCart = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!discountCode) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            cartAddDiscount({
                                discountCode: discountCode
                            })
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            handleAddToCart()
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function addToCart() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref4 = (0,react.useState)(""), cursorClass = ref4[0], setCursorClass = ref4[1];
    (0,react.useEffect)(function() {
        if (isAdding) {
            setCursorClass("cursor-default");
        } else if (isLoading) {
            setCursorClass("cursor-wait");
        } else if (isSoldOut && !isNotifyMe || selectedVariant === null) {
            setCursorClass("cursor-not-allowed");
        } else {
            setCursorClass("");
        }
    }, [
        isAdding,
        isLoading,
        isSoldOut,
        isNotifyMe,
        selectedVariant
    ]);
    var ref5 = (0,react.useState)(""), displayText = ref5[0], setDisplayText = ref5[1];
    (0,react.useEffect)(function() {
        if (!buttonText || selectedVariant === null) {
            setDisplayText("Unavailable");
            return;
        }
        if ([
            "oneTimeOnly",
            "featured"
        ].includes(productType) && minPrice && !isSoldOut) {
            setDisplayText("".concat(buttonText, " — ").concat(minPrice));
            return;
        }
        setDisplayText(buttonText);
    }, [
        selectedVariant,
        minPrice,
        buttonText
    ]);
    var TRUEMED_SRC = "https://static.truemed.com/widgets/product-page-widget.min.js";
    (0,react.useEffect)(function() {
        var ref, ref1, ref2;
        var isAccessory = (product === null || product === void 0 ? void 0 : (ref = product.collections) === null || ref === void 0 ? void 0 : ref.some(function(c) {
            return (c === null || c === void 0 ? void 0 : c.handle) === "accessories";
        })) || (selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref1 = selectedVariant.product) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.productType) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) === "accessories";
        if (!isPdp || isAccessory) return;
        if (typeof document === "undefined") return;
        // check if already loaded
        if (document.querySelector('script[src="'.concat(TRUEMED_SRC, '"]'))) return;
        if (window.truemedScriptLoaded) return;
        var script = document.createElement("script");
        script.src = TRUEMED_SRC;
        script.async = true;
        script.onload = function() {
            window.truemedScriptLoaded = true;
        };
        document.head.appendChild(script);
    }, [
        isPdp,
        product,
        selectedVariant
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "add-to-cart",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                theme: "".concat(isNotifyMe || isSoldOut ? "secondary" : "primary"),
                variant: "filled",
                "aria-label": buttonText,
                className: "add-to-cart-button relative mt-[40px] w-full max-md:h-[54px]  max-md:p-[10px_34px_13px] max-md:!text-[16px] ".concat(cursorClass, " ").concat(className),
                disabled: isSoldOut && !isNotifyMe,
                onClick: function() {
                    if (isNotifyMe && selectedVariant !== null) {
                        handleNotifyMe(/*#__PURE__*/ (0,jsx_runtime.jsx)(BackInStockModal, {
                            selectedVariant: selectedVariant,
                            product: product
                        }));
                    } else {
                        addToCart();
                    }
                },
                type: "button",
                children: isAdding ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "transition ".concat(isLoading ? "opacity-30" : "", " max-md:h-[20px] max-md:!font-[400]"),
                    children: displayText
                })
            }),
            isPdp && subtext && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "add-to-cart__subtext mt-1 text-center text-xs",
                children: subtext
            }),
            isPdp && isSoldOut && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "add-to-cart__disclaimer mt-[20px] flex items-center justify-center text-center text-[14px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mr-[10px] h-[10px] w-[10px] rounded-full",
                        style: {
                            backgroundColor: "".concat(oosDisclaimerColor !== null && oosDisclaimerColor !== void 0 ? oosDisclaimerColor : "#F1DCC1")
                        }
                    }),
                    oosDisclaimerUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                        className: "underline",
                        href: oosDisclaimerUrl,
                        target: oosDisclaimerOpenNewTab ? "_blank" : "_self",
                        children: oosDisclaimer
                    }) : oosDisclaimer
                ]
            }),
            isPdp && !isSoldOut && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "add-to-cart__disclaimer mt-[20px] flex items-center justify-center text-center text-[14px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mr-[10px] h-[10px] w-[10px] rounded-full",
                        style: {
                            backgroundColor: "".concat(disclaimerColor !== null && disclaimerColor !== void 0 ? disclaimerColor : "#F1DCC1")
                        }
                    }),
                    disclaimerUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                        className: "underline",
                        href: disclaimerUrl,
                        target: disclaimerOpenNewTab ? "_blank" : "_self",
                        children: disclaimer
                    }) : disclaimer
                ]
            }),
            !((product === null || product === void 0 ? void 0 : (ref = product.collections) === null || ref === void 0 ? void 0 : ref.some(function(collection) {
                return collection.handle === "accessories";
            })) || (selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref1 = selectedVariant.product) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.productType) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) === "accessories") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "truemed-instructions",
                className: "mt-1 !flex h-3 !justify-center pb-4",
                "data-public-id": "tm_qual_r35a2uey6w"
            })
        ]
    });
}
AddToCart.displayName = "AddToCart";
AddToCart.propTypes = {
    addToCartText: (prop_types_default()).string,
    className: (prop_types_default()).string,
    isPdp: (prop_types_default()).bool,
    selectedVariant: (prop_types_default()).object
};

;// CONCATENATED MODULE: ./src/snippets/AddToCart/index.js



/***/ }),

/***/ 2545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* reexport */ Badges; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(7599);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3444);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../node_modules/@backpackjs/storefront/dist/index.js
var dist = __webpack_require__(2031);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(3615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/snippets/Badges/Badges.jsx








function Badges(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _tags = param.tags, tags = _tags === void 0 ? [] : _tags;
    var ref;
    var settings = (0,dist.useSettings)();
    var badgeColors = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.product) === null || ref === void 0 ? void 0 : ref.badges).badgeColors;
    var badgeColorsMap = (0,react.useMemo)(function() {
        if (!badgeColors) return {};
        return badgeColors.reduce(function(acc, badge) {
            var ref;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, (ref = badge.tag) === null || ref === void 0 ? void 0 : ref.trim(), badge));
        }, {});
    }, [
        badgeColors
    ]);
    var badges = (0,react.useMemo)(function() {
        return tags.reduce(function(acc, tag) {
            if (tag.startsWith("badge::")) {
                var ref;
                var value = (ref = tag.split("badge::")[1]) === null || ref === void 0 ? void 0 : ref.trim();
                if (!value) return acc;
                return (0,_to_consumable_array/* default */.Z)(acc).concat([
                    value
                ]);
            }
            return acc;
        }, []);
    }, [
        tags
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "text-label flex flex-wrap gap-2.5 font-mono xs:gap-3 [&_div]:rounded-[42px] [&_div]:px-4 [&_div]:py-2 ".concat(className),
        children: badges === null || badges === void 0 ? void 0 : badges.map(function(badge, index) {
            var ref, ref1;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    backgroundColor: ((ref = badgeColorsMap[badge]) === null || ref === void 0 ? void 0 : ref.bgColor) || "var(--secondary)",
                    color: ((ref1 = badgeColorsMap[badge]) === null || ref1 === void 0 ? void 0 : ref1.textColor) || "var(--white)"
                },
                children: badge
            }, index);
        })
    });
}
Badges.displayName = "Badges";
Badges.propTypes = {
    className: (prop_types_default()).string,
    tags: prop_types_default().arrayOf((prop_types_default()).string)
};

;// CONCATENATED MODULE: ./src/snippets/Badges/index.js



/***/ }),

/***/ 5582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "TY": function() { return /* reexport */ BeamCommunityImpactWrapper; },
  "NF": function() { return /* reexport */ BeamCumulativeImpactWrapper; },
  "mr": function() { return /* reexport */ BeamProductDetailsPageWrapper; },
  "hR": function() { return /* reexport */ BeamSelectNonprofitWrapper; }
});

// UNUSED EXPORTS: Beam

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/next/script.js
var script = __webpack_require__(3218);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./src/snippets/Beam/Beam.jsx


function Beam() {
    return /*#__PURE__*/ _jsx(Script, {
        id: "beam-session",
        type: "module",
        dangerouslySetInnerHTML: {
            __html: "\n        import { createSession } from 'https://production-beam-widgets.beamimpact.com/web-sdk/v1.53.1/dist/integrations/session.esm.js';\n        import {\n            events,\n            setCookieValue,\n        } from 'https://production-beam-widgets.beamimpact.com/web-sdk/v1.53.1/dist/integrations/utils.esm.js';\n\n        const storeDomain = window.location.host.includes('localhost:') ? 'localhost' : window.location.host;\n        const beamApiKey = 'dDTsAdyADu1n.e27fbf81-504b-46e4-9e1c-e9c51400d112';\n        const cookieName = 'beam_session';\n\n        createSession({\n            domain: storeDomain,\n            apiKey: beamApiKey,\n            cookieName,\n        });\n\n        // On cart change, update the cart Id in the beam session cookie\n        window.addEventListener(events.BeamCartChangeEvent.eventName, async (event) => {\n            const cartId = event?.detail?.cartId;\n            if (cartId) {\n                setCookieValue({\n                name: cookieName,\n                value: cartId,\n                path: '/',\n                domain: storeDomain,\n                });\n            }\n        })\n        "
        }
    });
}

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(3842);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(5341);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(5556);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../node_modules/@backpackjs/storefront/dist/index.js
var dist = __webpack_require__(2031);
;// CONCATENATED MODULE: ./src/snippets/Beam/BeamSelectNonprofit.jsx
"use client";







function BeamSelectNonprofitWrapper() {
    var cart = (0,dist.useCart)();
    var cartAddAttributes = (0,dist.useCartAddAttributes)().cartAddAttributes;
    var settings = (0,dist.useSettings)();
    var beamSettings = settings === null || settings === void 0 ? void 0 : settings.beam;
    // Optional: state for handling nonprofit selection in app
    var ref = (0,react.useState)({
        id: null,
        name: null
    }), selectedNonprofit = ref[0], setSelectedNonprofit = ref[1];
    var element = (0,react.useRef)(null);
    var handleNonprofitSelect = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
            var _detail, selectedNonprofitId, nonprofitName, selectionId, attributes;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(cart === null || cart === void 0 ? void 0 : cart.id)) return [
                            2
                        ];
                        _detail = event.detail, selectedNonprofitId = _detail.selectedNonprofitId, nonprofitName = _detail.nonprofitName, selectionId = _detail.selectionId;
                        // Nonprofit details can be displayed in a message, saved on server, etc.
                        setSelectedNonprofit({
                            name: nonprofitName,
                            id: selectedNonprofitId
                        });
                        attributes = {
                            beam_cart_id: cart.id,
                            beam_chain_id: beamSettings.beamChainId,
                            beam_store_id: parseInt(beamSettings.beamStoreId, 10),
                            beam_nonprofit_id: selectedNonprofitId,
                            beam_selection_id: selectionId
                        };
                        // Update your cart with Beam metadata
                        return [
                            4,
                            cartAddAttributes({
                                attributes: Object.entries(attributes).map(function(param) {
                                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                                    return {
                                        key: key,
                                        value: value.toString()
                                    };
                                })
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleNonprofitSelect(event) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var currentElement = element.current;
        var handler = function(e) {
            return handleNonprofitSelect(e);
        };
        if (currentElement && (cart === null || cart === void 0 ? void 0 : cart.id) && (beamSettings === null || beamSettings === void 0 ? void 0 : beamSettings.beamStoreId) && (beamSettings === null || beamSettings === void 0 ? void 0 : beamSettings.beamChainId)) {
            currentElement.addEventListener("beamnonprofitselect", handler);
            currentElement.addEventListener("beamnonprofitselect", handler);
        }
        return function() {
            if (currentElement) {
                currentElement.removeEventListener("beamnonprofitselect", handler);
                currentElement.removeEventListener("beamnonprofitselect", handler);
            }
        };
    }, [
        element,
        cart === null || cart === void 0 ? void 0 : cart.id,
        beamSettings === null || beamSettings === void 0 ? void 0 : beamSettings.beamChainId,
        beamSettings === null || beamSettings === void 0 ? void 0 : beamSettings.beamStoreId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                strategy: "afterInteractive",
                type: "module",
                crossOrigin: "anonymous",
                src: "https://sdk.beamimpact.com/web-sdk/v1.53.1/dist/components/select-nonprofit.esm.js"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("beam-select-nonprofit", {
                ref: element,
                apiKey: beamSettings === null || beamSettings === void 0 ? void 0 : beamSettings.beamApiKey,
                chainId: beamSettings === null || beamSettings === void 0 ? void 0 : beamSettings.beamChainId,
                storeId: parseInt((beamSettings === null || beamSettings === void 0 ? void 0 : beamSettings.beamStoreId) || 0, 10),
                class: "font-sans"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/snippets/Beam/BeamCommunityImpact.jsx



function BeamCommunityImpactWrapper() {
    var settings = (0,dist.useSettings)();
    var beamSettings = settings === null || settings === void 0 ? void 0 : settings.beam;
    if (!beamSettings) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                strategy: "afterInteractive",
                type: "module",
                crossOrigin: "anonymous",
                src: "https://sdk.beamimpact.com/web-sdk/v1.53.1/dist/components/community-impact.esm.js"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("beam-community-impact", {
                apiKey: beamSettings.beamApiKey,
                chainId: beamSettings.beamChainId,
                storeId: beamSettings.beamStoreId,
                baseUrl: "https://api.beamimpact.com",
                lang: "en",
                cardStyle: "image",
                class: "font-sans"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/snippets/Beam/BeamCumulativeImpact.jsx



function BeamCumulativeImpactWrapper() {
    var settings = (0,dist.useSettings)();
    var beamSettings = settings === null || settings === void 0 ? void 0 : settings.beam;
    if (!beamSettings) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                strategy: "afterInteractive",
                type: "module",
                crossOrigin: "anonymous",
                src: "https://sdk.beamimpact.com/web-sdk/v1.53.1/dist/components/cumulative-impact.esm.js"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("beam-cumulative-impact", {
                apiKey: beamSettings.beamApiKey,
                chainId: beamSettings.beamChainId,
                storeId: beamSettings.beamStoreId,
                baseUrl: "https://api.beamimpact.com",
                lang: "en"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/snippets/Beam/BeamProductDetailsPage.jsx



function BeamProductDetailsPageWrapper() {
    var settings = (0,dist.useSettings)();
    var beamSettings = settings === null || settings === void 0 ? void 0 : settings.beam;
    if (!beamSettings) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                strategy: "afterInteractive",
                type: "module",
                crossOrigin: "anonymous",
                src: "https://sdk.beamimpact.com/web-sdk/v1.53.1/dist/components/product-details-page.esm.js"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "my-[40px] border border-[#83888E] bg-[#E9F0F7]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("beam-product-details-page", {
                    apiKey: beamSettings.beamApiKey,
                    storeId: beamSettings.beamStoreId,
                    baseUrl: "https://api.beamimpact.com"
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/snippets/Beam/index.js







/***/ }),

/***/ 6946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7378);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7227);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4360);
/* eslint-disable no-shadow */ 




function Button(props) {
    var children = props.children, theme = props.theme, variant = props.variant, onClick = props.onClick, type = props.type, href = props.href, className = props.className, disabled = props.disabled, loading = props.loading, wrapperClassName = props.wrapperClassName, ariaLabel = props.ariaLabel;
    var buttonTheme = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var classStr = "";
        if (theme === "primary" && variant === "filled") {
            classStr += "\n        bg-textLink\n        text-white\n        hover:bg-primary focus:bg-primary\n      ";
        }
        if (theme === "primary" && variant === "outlined") {
            classStr += "\n        bg-transparent\n        text-textLink\n        border border-textLink\n        hover:border-primary focus:border-primary\n        hover:bg-primary focus:bg-primary\n        hover:text-white focus:text-white\n      ";
        }
        if (theme === "secondary" && variant === "filled") {
            classStr += "\n        bg-primary\n        text-white\n        hover:bg-textLink focus:bg-textLink\n      ";
        }
        if (theme === "secondary" && variant === "outlined") {
            classStr += "\n        bg-transparent\n        text-primary\n        border border-primary\n        hover:bg-primary focus:bg-primary\n        hover:text-white focus:text-white\n      ";
        }
        if (theme === "light" && variant === "filled") {
            classStr += "\n        bg-white\n        text-primary\n        hover:bg-textLink focus:bg-textLink\n        hover:text-white focus:text-white";
        }
        if (theme === "light" && variant === "outlined") {
            classStr += "\n        bg-transparent\n        text-white\n        border border-white\n        hover:bg-white focus:bg-white\n        hover:text-primary focus:text-primary\n      ";
        }
        if (theme === "dark" && variant === "filled") {
            classStr += "\n        bg-text\n        text-white\n        hover:bg-textLink focus:bg-textLink\n        hover:text-white focus:text-white";
        }
        if (theme === "dark" && variant === "outlined") {
            classStr += "\n        bg-transparent\n        text-text\n        border border-text\n        hover:bg-white focus:bg-white\n        hover:text-text focus:text-text\n      ";
        }
        return classStr;
    }, [
        theme,
        variant
    ]);
    var Wrapper = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return href ? function LinkWrapper(param) {
            var children = param.children;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .r, {
                href: href,
                className: "inline-block ".concat(wrapperClassName),
                children: children
            });
        } : function ButtonWrapper(param) {
            var children = param.children;
            return children;
        };
    }, [
        href
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
            "aria-label": ariaLabel || null,
            disabled: disabled || loading,
            onClick: onClick,
            className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_3__/* .twMerge */ .m6)([
                "rounded-full px-[24px] py-[12px] text-center font-sans text-xs font-light disabled:opacity-50 lg:px-[2.125rem] lg:pb-[1.175rem] lg:pt-[0.906rem] lg:text-base lg:font-normal",
                buttonTheme,
                className, 
            ].join(" ")),
            // eslint-disable-next-line react/button-has-type
            type: type,
            children: children
        })
    });
}
Button.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node.isRequired),
    href: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    variant: prop_types__WEBPACK_IMPORTED_MODULE_4___default().oneOf([
        "filled",
        "outlined"
    ]).isRequired,
    theme: prop_types__WEBPACK_IMPORTED_MODULE_4___default().oneOf([
        "primary",
        "secondary",
        "light",
        "dark"
    ]).isRequired,
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func),
    type: prop_types__WEBPACK_IMPORTED_MODULE_4___default().oneOf([
        "button",
        "submit",
        "reset"
    ])
};


/***/ }),

/***/ 7388:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b4": function() { return /* reexport */ Button_ArrowButton; },
  "zx": function() { return /* reexport */ Button/* default */.Z; }
});

// UNUSED EXPORTS: ProductCta

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(1373);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(3615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ./src/snippets/Link/index.js + 1 modules
var Link = __webpack_require__(7227);
;// CONCATENATED MODULE: ./src/snippets/Button/ArrowButton.jsx
/* eslint-disable no-shadow */ 






var ArrowButton = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var onClick = _param.onClick, type = _param.type, href = _param.href, arrowDirection = _param.arrowDirection, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onClick",
        "type",
        "href",
        "arrowDirection"
    ]);
    var Wrapper = (0,react.useMemo)(function() {
        return href ? function LinkWrapper(param) {
            var children = param.children;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                href: href,
                children: children
            });
        } : function ButtonWrapper(param) {
            var children = param.children;
            return children;
        };
    }, [
        href
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            ref: ref,
            onClick: onClick
        }, props), {
            className: "flex h-[3.125rem] w-[3.125rem] items-center justify-center rounded-full bg-gradient-to-r from-[#C1EFFA] to-[#8DCEF9] p-[2px] text-center font-sans text-base text-[#202635] transition-colors hover:text-[#3383C5] disabled:cursor-not-allowed disabled:opacity-50",
            // eslint-disable-next-line react/button-has-type
            type: type,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "inner-content flex h-full w-full items-center justify-center rounded-full bg-white",
                children: arrowDirection === "right" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    width: "12",
                    height: "10",
                    viewBox: "0 0 12 10",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M11.8534 5.35373L7.35351 9.85348C7.25969 9.9473 7.13245 10 6.99977 10C6.86709 10 6.73985 9.9473 6.64603 9.85348C6.55222 9.75966 6.49951 9.63242 6.49951 9.49975C6.49951 9.36707 6.55222 9.23983 6.64603 9.14602L10.2928 5.49997H0.499984C0.36738 5.49997 0.240207 5.4473 0.146442 5.35353C0.0526768 5.25977 0 5.1326 0 5C0 4.8674 0.0526768 4.74023 0.146442 4.64647C0.240207 4.5527 0.36738 4.50003 0.499984 4.50003H10.2928L6.64603 0.85398C6.55222 0.760165 6.49951 0.632925 6.49951 0.50025C6.49951 0.367576 6.55222 0.240335 6.64603 0.14652C6.73985 0.0527047 6.86709 0 6.99977 0C7.13245 0 7.25969 0.0527047 7.35351 0.14652L11.8534 4.64627C11.8998 4.6927 11.9367 4.74784 11.9619 4.80854C11.9871 4.86924 12 4.9343 12 5C12 5.0657 11.9871 5.13076 11.9619 5.19146C11.9367 5.25215 11.8998 5.3073 11.8534 5.35373Z",
                        fill: "currentColor"
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    width: "12",
                    height: "10",
                    viewBox: "0 0 12 10",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M0.146638 5.35373L4.64649 9.85348C4.74031 9.9473 4.86755 10 5.00023 10C5.13291 10 5.26015 9.9473 5.35397 9.85348C5.44778 9.75966 5.50049 9.63242 5.50049 9.49975C5.50049 9.36707 5.44778 9.23983 5.35397 9.14602L1.70721 5.49997H11.5C11.6326 5.49997 11.7598 5.4473 11.8536 5.35353C11.9473 5.25977 12 5.1326 12 5C12 4.8674 11.9473 4.74023 11.8536 4.64647C11.7598 4.5527 11.6326 4.50003 11.5 4.50003H1.70721L5.35397 0.85398C5.44778 0.760165 5.50049 0.632925 5.50049 0.50025C5.50049 0.367576 5.44778 0.240335 5.35397 0.14652C5.26015 0.0527047 5.13291 0 5.00023 0C4.86755 0 4.74031 0.0527047 4.64649 0.14652L0.146638 4.64627C0.100151 4.6927 0.0632725 4.74784 0.0381107 4.80854C0.0129499 4.86924 0 4.9343 0 5C0 5.0657 0.0129499 5.13076 0.0381107 5.19146C0.0632725 5.25215 0.100151 5.3073 0.146638 5.35373Z",
                        fill: "currentColor"
                    })
                })
            })
        }))
    });
});
ArrowButton.propTypes = {
    arrowDirection: prop_types_default().oneOf([
        "left",
        "right"
    ]),
    href: (prop_types_default()).string,
    onClick: (prop_types_default()).func,
    type: prop_types_default().oneOf([
        "button",
        "submit",
        "reset"
    ])
};
/* harmony default export */ var Button_ArrowButton = (ArrowButton);

// EXTERNAL MODULE: ./src/snippets/Button/Button.jsx
var Button = __webpack_require__(6946);
;// CONCATENATED MODULE: ./src/snippets/Button/ProductCta.jsx
/* eslint-disable no-shadow */ 



function ProductCta(props) {
    var children = props.children, onClick = props.onClick, type = props.type, href = props.href;
    var Wrapper = (0,react.useMemo)(function() {
        return href ? function LinkWrapper(param) {
            var children = param.children;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                href: href,
                children: children
            });
        } : function ButtonWrapper(param) {
            var children = param.children;
            return children;
        };
    }, [
        href
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            onClick: onClick,
            className: "flex min-w-[200px] items-center justify-center rounded-full bg-gradient-to-r from-[#C1EFFA] to-[#8DCEF9] p-[3px] text-center font-sans text-base text-[#202635]",
            // eslint-disable-next-line react/button-has-type
            type: type,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "inner-content h-full w-full rounded-full bg-white px-[34px] pt-[14px] pb-[12px]",
                children: children
            })
        })
    });
}
ProductCta.propTypes = {
    children: (prop_types_default()).node.isRequired,
    href: (prop_types_default()).string,
    onClick: (prop_types_default()).func,
    type: prop_types_default().oneOf([
        "button",
        "submit",
        "reset"
    ])
};

;// CONCATENATED MODULE: ./src/snippets/Button/index.js





/***/ }),

/***/ 7105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Carousel; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7378);
/* harmony import */ var react_responsive_carousel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4837);
/* harmony import */ var react_responsive_carousel_lib_styles_carousel_min_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5560);
/* harmony import */ var react_responsive_carousel_lib_styles_carousel_min_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_responsive_carousel_lib_styles_carousel_min_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7388);





function Carousel(param) {
    var children = param.children, onChange = param.onChange, _centerMode = param.centerMode, centerMode = _centerMode === void 0 ? false : _centerMode, _centerSlidePercentage = param.centerSlidePercentage, centerSlidePercentage = _centerSlidePercentage === void 0 ? 30 : _centerSlidePercentage, _showIndicators = param.showIndicators, showIndicators = _showIndicators === void 0 ? true : _showIndicators, renderArrowNext = param.renderArrowNext, renderArrowPrev = param.renderArrowPrev, _topArrows = param.topArrows, topArrows = _topArrows === void 0 ? false : _topArrows, _infiniteLoop = param.infiniteLoop, infiniteLoop = _infiniteLoop === void 0 ? false : _infiniteLoop, _itemsPerPageMultiplier = param.itemsPerPageMultiplier, itemsPerPageMultiplier = _itemsPerPageMultiplier === void 0 ? 1 : _itemsPerPageMultiplier, _overwriteTotalItems = param.overwriteTotalItems, overwriteTotalItems = _overwriteTotalItems === void 0 ? false : _overwriteTotalItems, _showArrows = param.showArrows, showArrows = _showArrows === void 0 ? true : _showArrows, _emulateTouch = param.emulateTouch, emulateTouch = _emulateTouch === void 0 ? false : _emulateTouch, _selectedItem = param.selectedItem, selectedItem = _selectedItem === void 0 ? undefined : _selectedItem, _className = param.className, className = _className === void 0 ? "" : _className;
    var length = (children || {
        length: 0
    }).length;
    var getPage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(index) {
        if (!itemsPerPageMultiplier || !overwriteTotalItems) return index + 1;
        return (index + 1) * itemsPerPageMultiplier > overwriteTotalItems ? overwriteTotalItems : (index + 1) * itemsPerPageMultiplier;
    }, [
        itemsPerPageMultiplier,
        overwriteTotalItems
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                children: "\n          .carousel .control-dots {\n            width: calc(100% - 10rem);\n            margin-left: 5rem;\n          }\n\n          .carousel-slider {\n            position: relative;\n            padding-bottom: 40px;\n          }\n        "
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_responsive_carousel__WEBPACK_IMPORTED_MODULE_2__/* .Carousel */ .lr, {
                onChange: onChange,
                className: topArrows ? "-mt-20" : "pt-0",
                showStatus: false,
                showThumbs: false,
                showArrows: showArrows,
                emulateTouch: emulateTouch,
                centerMode: centerMode,
                infiniteLoop: centerMode || infiniteLoop,
                showIndicators: showIndicators,
                selectedItem: selectedItem,
                centerSlidePercentage: centerMode ? centerSlidePercentage : undefined,
                renderItem: function(item) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: [
                            centerMode ? "px-0" : "px-20",
                            topArrows ? "pt-20" : "pt-0",
                            !showArrows && "!px-0",
                            className, 
                        ].join(" "),
                        children: item
                    });
                },
                renderArrowNext: renderArrowNext || function(onClickHandler, hasNext) {
                    return hasNext && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: topArrows ? "absolute right-0 top-0 z-10 flex h-full items-start" : "absolute right-0 top-0 z-10 flex h-full items-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_4__/* .ArrowButton */ .b4, {
                            onClick: onClickHandler,
                            arrowDirection: "right"
                        })
                    });
                },
                renderArrowPrev: renderArrowPrev || function(onClickHandler, hasPrev) {
                    return hasPrev && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: topArrows ? "absolute right-20 top-0 z-10 flex h-full items-start" : "absolute left-0 top-0 z-10 flex h-full items-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_4__/* .ArrowButton */ .b4, {
                            onClick: onClickHandler,
                            arrowDirection: "left"
                        })
                    });
                },
                renderIndicator: function(onClickHandler, isSelected, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: [
                                    "absolute bottom-2 left-0 h-[1px] flex-1 transition-all duration-300",
                                    isSelected ? "z-[1] bg-[#202635] dark:bg-[#ffffff] dark:bg-opacity-50" : "z-[0] bg-[#C7D5E1] dark:bg-opacity-10", 
                                ],
                                style: {
                                    width: "calc(".concat("".concat(100 / length * (index + 1), "%"), " - 50px)"),
                                    zIndex: isSelected ? 1 : 0
                                }
                            }),
                            isSelected && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "absolute bottom-0 right-0 w-[50px] font-mono text-xs",
                                children: [
                                    getPage(index),
                                    "/",
                                    overwriteTotalItems || length * itemsPerPageMultiplier
                                ]
                            })
                        ]
                    });
                },
                children: children
            })
        ]
    });
}


/***/ }),

/***/ 8601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* reexport */ Image; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(1373);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(3615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3444);
// EXTERNAL MODULE: ../node_modules/next/head.js
var head = __webpack_require__(8038);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/snippets/Image/ImageElement.jsx






var IMAGE_SIZES = [
    16,
    32,
    48,
    64,
    96,
    128,
    256,
    384
];
var DEVICE_SIZES = [
    640,
    768,
    960,
    1280,
    1536,
    2048,
    2560,
    3072,
    3840
];
var ALL_SIZES = (0,_to_consumable_array/* default */.Z)(IMAGE_SIZES).concat((0,_to_consumable_array/* default */.Z)(DEVICE_SIZES)).sort(function(a, b) {
    return a - b;
});
var DEFAULT_QUALITY = 75; // 1 - 100
function getWidths(param) {
    var config = param.config, sizes = param.sizes, width = param.width;
    var ref = (0,_object_spread/* default */.Z)({}, config), _deviceSizes = ref.deviceSizes, deviceSizes = _deviceSizes === void 0 ? [] : _deviceSizes, _allSizes = ref.allSizes, allSizes = _allSizes === void 0 ? [] : _allSizes;
    if (sizes) {
        // Find all the "vw" percent sizes used in the sizes prop
        var percentSizes = (sizes.match(/(1?\d?\d)vw/g) || []).map(function(size) {
            return parseInt(size, 10);
        });
        if (percentSizes.length) {
            var _Math;
            var smallestRatio = (_Math = Math).min.apply(_Math, (0,_to_consumable_array/* default */.Z)(percentSizes)) * 0.01;
            return {
                widths: allSizes.filter(function(s) {
                    return s >= deviceSizes[0] * smallestRatio;
                }),
                kind: "w"
            };
        }
        return {
            widths: allSizes,
            kind: "w"
        };
    }
    // For "fill" images with no "sizes" prop, return all device sizes
    if (typeof width !== "number") {
        return {
            widths: deviceSizes,
            kind: "w"
        };
    }
    // For images with set widths, find first size at least twice the width
    var widths = (0,_to_consumable_array/* default */.Z)(new Set([
        width,
        width * 2
    ].map(function(w) {
        return allSizes.find(function(p) {
            return p >= w;
        }) || allSizes[allSizes.length - 1];
    })));
    return {
        widths: widths,
        kind: "x"
    };
}
function generateImgAttrs(param) {
    var config = param.config, loader = param.loader, quality = param.quality, sizes = param.sizes, src = param.src, width = param.width;
    var ref = getWidths({
        config: config,
        sizes: sizes,
        width: width
    }), widths = ref.widths, kind = ref.kind;
    var last = widths.length - 1;
    return {
        sizes: !sizes && kind === "w" ? "100vw" : sizes,
        srcSet: widths.map(function(w, i) {
            return "".concat(loader({
                src: src,
                quality: quality,
                width: w
            }), " ").concat(kind === "w" ? w : i + 1).concat(kind);
        }).join(", "),
        src: loader({
            quality: quality,
            src: src,
            width: widths[last]
        })
    };
}
function getInt(value) {
    if (typeof value === "number" || typeof value === "undefined") {
        return value;
    }
    if (typeof value === "string") {
        return parseInt(value, 10);
    }
    return NaN;
}
// Shopify CDN specific url param mutations
// For other CDNs, create another custom loader
function shopifyCdnLoader(param) {
    var src = param.src, quality = param.quality, width = param.width;
    if (!src) return "";
    var params = new URLSearchParams(src.split("?")[1] || "");
    params.set("width", width);
    params.set("quality", quality < 1 || quality > 100 ? DEFAULT_QUALITY : quality);
    return "".concat(src.split("?")[0], "?").concat(params);
}
var ImageElement = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var alt = _param.alt, className = _param.className, fill = _param.fill, height = _param.height, loading = _param.loading, priority = _param.priority, _quality = _param.quality, quality = _quality === void 0 ? DEFAULT_QUALITY : _quality, sizes = _param.sizes, src = _param.src, width = _param.width, props = (0,_object_without_properties/* default */.Z)(_param, [
        "alt",
        "className",
        "fill",
        "height",
        "loading",
        "priority",
        "quality",
        "sizes",
        "src",
        "width"
    ]);
    var config = {
        allSizes: ALL_SIZES,
        deviceSizes: DEVICE_SIZES
    };
    var qualityInt = getInt(quality);
    var widthInt = getInt(width);
    var heightInt = getInt(height);
    var imgAttributes = generateImgAttrs({
        config: config,
        loader: shopifyCdnLoader,
        quality: qualityInt,
        sizes: sizes,
        src: src,
        width: widthInt
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            priority && /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", (0,_object_spread/* default */.Z)({
                    rel: "preload",
                    as: "image",
                    href: imgAttributes.src
                }, fill ? {
                    imageSrcSet: imgAttributes.srcSet,
                    imageSizes: imgAttributes.sizes
                } : null))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread/* default */.Z)({
                alt: alt,
                className: "".concat(fill ? "absolute inset-0 m-auto box-border block h-0 max-h-full min-h-full w-0 min-w-full max-w-full border-none object-cover p-0" : "", " ").concat(className),
                decoding: "async",
                loading: priority ? "eager" : loading,
                ref: ref,
                src: imgAttributes.src
            }, fill ? {
                sizes: imgAttributes.sizes,
                srcSet: imgAttributes.srcSet
            } : {
                height: "".concat(heightInt),
                width: "".concat(widthInt)
            }, props))
        ]
    });
});
ImageElement.displayName = "ImageElement";

;// CONCATENATED MODULE: ./src/snippets/Image/Image.jsx







// Intended for use with images hosted by a CDN only
// For local images (e.g. `import Image from './image.jpg'`) and remote images (e.g. `/image.jpg`), use the <img> html tag directly
var DOMAIN = "cdn.shopify.com";
var Image = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var alt = _param.alt, className = _param.className, fill = _param.fill, height = _param.height, loading = _param.loading, priority = _param.priority, quality = _param.quality, sizes = _param.sizes, src = _param.src, width = _param.width, props = (0,_object_without_properties/* default */.Z)(_param, [
        "alt",
        "className",
        "fill",
        "height",
        "loading",
        "priority",
        "quality",
        "sizes",
        "src",
        "width"
    ]);
    if (false) { var url, _$ref; }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageElement, (0,_object_spread/* default */.Z)({
        alt: alt,
        className: className,
        fill: fill,
        height: height,
        loading: loading,
        priority: priority,
        quality: quality,
        ref: ref,
        sizes: sizes,
        src: src,
        width: width
    }, props));
});
Image.displayName = "Image";
Image.defaultProps = {
    alt: "",
    className: "",
    fill: false,
    height: undefined,
    loading: "lazy",
    priority: false,
    quality: undefined,
    sizes: "",
    src: "",
    width: undefined
};
Image.propTypes = {
    alt: (prop_types_default()).string,
    className: (prop_types_default()).string,
    fill: (prop_types_default()).bool,
    height: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).number
    ]),
    loading: prop_types_default().oneOf([
        "auto",
        "eager",
        "lazy"
    ]),
    priority: (prop_types_default()).bool,
    quality: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).number
    ]),
    sizes: (prop_types_default()).string,
    src: (prop_types_default()).string,
    width: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).number
    ])
};

;// CONCATENATED MODULE: ./src/snippets/Image/index.js



/***/ }),

/***/ 7227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": function() { return /* reexport */ Link; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(1373);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/next/link.js
var next_link = __webpack_require__(9894);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(3615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
;// CONCATENATED MODULE: ./src/snippets/Link/Link.jsx







// nextjs link docs: https://nextjs.org/docs/api-reference/next/link
var Link = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var as = _param.as, children = _param.children, className = _param.className, _href = _param.href, href = _href === void 0 ? "" : _href, _locale = _param.locale, locale = _locale === void 0 ? false : _locale, _newTab = _param.newTab, newTab = _newTab === void 0 ? false : _newTab, _prefetch = _param.prefetch, prefetch = _prefetch === void 0 ? true : _prefetch, _replace = _param.replace, replace = _replace === void 0 ? false : _replace, _scroll = _param.scroll, scroll = _scroll === void 0 ? true : _scroll, _shallow = _param.shallow, shallow = _shallow === void 0 ? false : _shallow, style = _param.style, _primary = _param.primary, primary = _primary === void 0 ? false : _primary, _secondary = _param.secondary, secondary = _secondary === void 0 ? false : _secondary, props = (0,_object_without_properties/* default */.Z)(_param, [
        "as",
        "children",
        "className",
        "href",
        "locale",
        "newTab",
        "prefetch",
        "replace",
        "scroll",
        "shallow",
        "style",
        "primary",
        "secondary"
    ]);
    return href ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        as: as,
        href: href,
        locale: locale,
        passHref: true,
        replace: replace,
        scroll: scroll,
        shallow: shallow
    }, !prefetch ? {
        prefetch: false
    } : null), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            className: [
                primary ? "text-sm text-[#3383C5] underline" : "",
                secondary ? "text-sm text-[#202635] underline" : "",
                className, 
            ].join(" "),
            ref: ref,
            style: style
        }, newTab ? {
            target: "_blank"
        } : null, props), {
            children: children
        }))
    })) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        ref: ref,
        style: style,
        children: children
    });
});
Link.displayName = "Link";
Link.propTypes = {
    as: (prop_types_default()).string,
    children: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).node
    ]),
    className: (prop_types_default()).string,
    href: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).object
    ]),
    locale: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).bool
    ]),
    newTab: (prop_types_default()).bool,
    prefetch: (prop_types_default()).bool,
    replace: (prop_types_default()).bool,
    scroll: (prop_types_default()).bool,
    shallow: (prop_types_default()).bool,
    style: (prop_types_default()).object,
    primary: (prop_types_default()).bool,
    secondary: (prop_types_default()).bool
};

;// CONCATENATED MODULE: ./src/snippets/Link/index.js



/***/ }),

/***/ 2725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* reexport */ Markdown; }
});

// NAMESPACE OBJECT: ../node_modules/micromark/lib/constructs.js
var constructs_namespaceObject = {};
__webpack_require__.r(constructs_namespaceObject);
__webpack_require__.d(constructs_namespaceObject, {
  "attentionMarkers": function() { return attentionMarkers; },
  "contentInitial": function() { return contentInitial; },
  "disable": function() { return disable; },
  "document": function() { return constructs_document; },
  "flow": function() { return constructs_flow; },
  "flowInitial": function() { return flowInitial; },
  "insideSpan": function() { return insideSpan; },
  "string": function() { return constructs_string; },
  "text": function() { return constructs_text; }
});

// NAMESPACE OBJECT: ../node_modules/property-information/lib/util/types.js
var types_namespaceObject = {};
__webpack_require__.r(types_namespaceObject);
__webpack_require__.d(types_namespaceObject, {
  "boolean": function() { return types_boolean; },
  "booleanish": function() { return booleanish; },
  "commaOrSpaceSeparated": function() { return commaOrSpaceSeparated; },
  "commaSeparated": function() { return commaSeparated; },
  "number": function() { return number; },
  "overloadedBoolean": function() { return overloadedBoolean; },
  "spaceSeparated": function() { return spaceSeparated; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../node_modules/is-buffer/index.js
var is_buffer = __webpack_require__(8809);
;// CONCATENATED MODULE: ../node_modules/unist-util-stringify-position/lib/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */

/**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */

/**
 * Serialize the positional info of a point, position (start and end points),
 * or node.
 *
 * @param {Node | NodeLike | Position | PositionLike | Point | PointLike | null | undefined} [value]
 *   Node, position, or point.
 * @returns {string}
 *   Pretty printed positional info of a node (`string`).
 *
 *   In the format of a range `ls:cs-le:ce` (when given `node` or `position`)
 *   or a point `l:c` (when given `point`), where `l` stands for line, `c` for
 *   column, `s` for `start`, and `e` for end.
 *   An empty string (`''`) is returned if the given value is neither `node`,
 *   `position`, nor `point`.
 */
function stringifyPosition(value) {
  // Nothing.
  if (!value || typeof value !== 'object') {
    return ''
  }

  // Node.
  if ('position' in value || 'type' in value) {
    return position(value.position)
  }

  // Position.
  if ('start' in value || 'end' in value) {
    return position(value)
  }

  // Point.
  if ('line' in value || 'column' in value) {
    return point(value)
  }

  // ?
  return ''
}

/**
 * @param {Point | PointLike | null | undefined} point
 * @returns {string}
 */
function point(point) {
  return index(point && point.line) + ':' + index(point && point.column)
}

/**
 * @param {Position | PositionLike | null | undefined} pos
 * @returns {string}
 */
function position(pos) {
  return point(pos && pos.start) + '-' + point(pos && pos.end)
}

/**
 * @param {number | null | undefined} value
 * @returns {number}
 */
function index(value) {
  return value && typeof value === 'number' ? value : 1
}

;// CONCATENATED MODULE: ../node_modules/vfile-message/lib/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 * @typedef {object & {type: string, position?: Position | undefined}} NodeLike
 */



/**
 * Message.
 */
class VFileMessage extends Error {
  /**
   * Create a message for `reason` at `place` from `origin`.
   *
   * When an error is passed in as `reason`, the `stack` is copied.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   *
   *   > 👉 **Note**: you should use markdown.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // To do: next major: expose `undefined` everywhere instead of `null`.
  constructor(reason, place, origin) {
    /** @type {[string | null, string | null]} */
    const parts = [null, null]
    /** @type {Position} */
    let position = {
      // @ts-expect-error: we always follows the structure of `position`.
      start: {line: null, column: null},
      // @ts-expect-error: "
      end: {line: null, column: null}
    }

    super()

    if (typeof place === 'string') {
      origin = place
      place = undefined
    }

    if (typeof origin === 'string') {
      const index = origin.indexOf(':')

      if (index === -1) {
        parts[1] = origin
      } else {
        parts[0] = origin.slice(0, index)
        parts[1] = origin.slice(index + 1)
      }
    }

    if (place) {
      // Node.
      if ('type' in place || 'position' in place) {
        if (place.position) {
          // To do: next major: deep clone.
          // @ts-expect-error: looks like a position.
          position = place.position
        }
      }
      // Position.
      else if ('start' in place || 'end' in place) {
        // @ts-expect-error: looks like a position.
        // To do: next major: deep clone.
        position = place
      }
      // Point.
      else if ('line' in place || 'column' in place) {
        // To do: next major: deep clone.
        position.start = place
      }
    }

    // Fields from `Error`.
    /**
     * Serialized positional info of error.
     *
     * On normal errors, this would be something like `ParseError`, buit in
     * `VFile` messages we use this space to show where an error happened.
     */
    this.name = stringifyPosition(place) || '1:1'

    /**
     * Reason for message.
     *
     * @type {string}
     */
    this.message = typeof reason === 'object' ? reason.message : reason

    /**
     * Stack of message.
     *
     * This is used by normal errors to show where something happened in
     * programming code, irrelevant for `VFile` messages,
     *
     * @type {string}
     */
    this.stack = ''

    if (typeof reason === 'object' && reason.stack) {
      this.stack = reason.stack
    }

    /**
     * Reason for message.
     *
     * > 👉 **Note**: you should use markdown.
     *
     * @type {string}
     */
    this.reason = this.message

    /* eslint-disable no-unused-expressions */
    /**
     * State of problem.
     *
     * * `true` — marks associated file as no longer processable (error)
     * * `false` — necessitates a (potential) change (warning)
     * * `null | undefined` — for things that might not need changing (info)
     *
     * @type {boolean | null | undefined}
     */
    this.fatal

    /**
     * Starting line of error.
     *
     * @type {number | null}
     */
    this.line = position.start.line

    /**
     * Starting column of error.
     *
     * @type {number | null}
     */
    this.column = position.start.column

    /**
     * Full unist position.
     *
     * @type {Position | null}
     */
    this.position = position

    /**
     * Namespace of message (example: `'my-package'`).
     *
     * @type {string | null}
     */
    this.source = parts[0]

    /**
     * Category of message (example: `'my-rule'`).
     *
     * @type {string | null}
     */
    this.ruleId = parts[1]

    /**
     * Path of a file (used throughout the `VFile` ecosystem).
     *
     * @type {string | null}
     */
    this.file

    // The following fields are “well known”.
    // Not standard.
    // Feel free to add other non-standard fields to your messages.

    /**
     * Specify the source value that’s being reported, which is deemed
     * incorrect.
     *
     * @type {string | null}
     */
    this.actual

    /**
     * Suggest acceptable values that can be used instead of `actual`.
     *
     * @type {Array<string> | null}
     */
    this.expected

    /**
     * Link to docs for the message.
     *
     * > 👉 **Note**: this must be an absolute URL that can be passed as `x`
     * > to `new URL(x)`.
     *
     * @type {string | null}
     */
    this.url

    /**
     * Long form description of the message (you should use markdown).
     *
     * @type {string | null}
     */
    this.note
    /* eslint-enable no-unused-expressions */
  }
}

VFileMessage.prototype.file = ''
VFileMessage.prototype.name = ''
VFileMessage.prototype.reason = ''
VFileMessage.prototype.message = ''
VFileMessage.prototype.stack = ''
VFileMessage.prototype.fatal = null
VFileMessage.prototype.column = null
VFileMessage.prototype.line = null
VFileMessage.prototype.source = null
VFileMessage.prototype.ruleId = null
VFileMessage.prototype.position = null

;// CONCATENATED MODULE: ../node_modules/vfile/lib/minpath.browser.js
// A derivative work based on:
// <https://github.com/browserify/path-browserify>.
// Which is licensed:
//
// MIT License
//
// Copyright (c) 2013 James Halliday
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
// A derivative work based on:
//
// Parts of that are extracted from Node’s internal `path` module:
// <https://github.com/nodejs/node/blob/master/lib/path.js>.
// Which is licensed:
//
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

const path = {basename, dirname, extname, join, sep: '/'}

/* eslint-disable max-depth, complexity */

/**
 * Get the basename from a path.
 *
 * @param {string} path
 *   File path.
 * @param {string | undefined} [ext]
 *   Extension to strip.
 * @returns {string}
 *   Stem or basename.
 */
function basename(path, ext) {
  if (ext !== undefined && typeof ext !== 'string') {
    throw new TypeError('"ext" argument must be a string')
  }

  assertPath(path)
  let start = 0
  let end = -1
  let index = path.length
  /** @type {boolean | undefined} */
  let seenNonSlash

  if (ext === undefined || ext.length === 0 || ext.length > path.length) {
    while (index--) {
      if (path.charCodeAt(index) === 47 /* `/` */) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now.
        if (seenNonSlash) {
          start = index + 1
          break
        }
      } else if (end < 0) {
        // We saw the first non-path separator, mark this as the end of our
        // path component.
        seenNonSlash = true
        end = index + 1
      }
    }

    return end < 0 ? '' : path.slice(start, end)
  }

  if (ext === path) {
    return ''
  }

  let firstNonSlashEnd = -1
  let extIndex = ext.length - 1

  while (index--) {
    if (path.charCodeAt(index) === 47 /* `/` */) {
      // If we reached a path separator that was not part of a set of path
      // separators at the end of the string, stop now.
      if (seenNonSlash) {
        start = index + 1
        break
      }
    } else {
      if (firstNonSlashEnd < 0) {
        // We saw the first non-path separator, remember this index in case
        // we need it if the extension ends up not matching.
        seenNonSlash = true
        firstNonSlashEnd = index + 1
      }

      if (extIndex > -1) {
        // Try to match the explicit extension.
        if (path.charCodeAt(index) === ext.charCodeAt(extIndex--)) {
          if (extIndex < 0) {
            // We matched the extension, so mark this as the end of our path
            // component
            end = index
          }
        } else {
          // Extension does not match, so our result is the entire path
          // component
          extIndex = -1
          end = firstNonSlashEnd
        }
      }
    }
  }

  if (start === end) {
    end = firstNonSlashEnd
  } else if (end < 0) {
    end = path.length
  }

  return path.slice(start, end)
}

/**
 * Get the dirname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */
function dirname(path) {
  assertPath(path)

  if (path.length === 0) {
    return '.'
  }

  let end = -1
  let index = path.length
  /** @type {boolean | undefined} */
  let unmatchedSlash

  // Prefix `--` is important to not run on `0`.
  while (--index) {
    if (path.charCodeAt(index) === 47 /* `/` */) {
      if (unmatchedSlash) {
        end = index
        break
      }
    } else if (!unmatchedSlash) {
      // We saw the first non-path separator
      unmatchedSlash = true
    }
  }

  return end < 0
    ? path.charCodeAt(0) === 47 /* `/` */
      ? '/'
      : '.'
    : end === 1 && path.charCodeAt(0) === 47 /* `/` */
    ? '//'
    : path.slice(0, end)
}

/**
 * Get an extname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   Extname.
 */
function extname(path) {
  assertPath(path)

  let index = path.length

  let end = -1
  let startPart = 0
  let startDot = -1
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find.
  let preDotState = 0
  /** @type {boolean | undefined} */
  let unmatchedSlash

  while (index--) {
    const code = path.charCodeAt(index)

    if (code === 47 /* `/` */) {
      // If we reached a path separator that was not part of a set of path
      // separators at the end of the string, stop now.
      if (unmatchedSlash) {
        startPart = index + 1
        break
      }

      continue
    }

    if (end < 0) {
      // We saw the first non-path separator, mark this as the end of our
      // extension.
      unmatchedSlash = true
      end = index + 1
    }

    if (code === 46 /* `.` */) {
      // If this is our first dot, mark it as the start of our extension.
      if (startDot < 0) {
        startDot = index
      } else if (preDotState !== 1) {
        preDotState = 1
      }
    } else if (startDot > -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension.
      preDotState = -1
    }
  }

  if (
    startDot < 0 ||
    end < 0 ||
    // We saw a non-dot character immediately before the dot.
    preDotState === 0 ||
    // The (right-most) trimmed path component is exactly `..`.
    (preDotState === 1 && startDot === end - 1 && startDot === startPart + 1)
  ) {
    return ''
  }

  return path.slice(startDot, end)
}

/**
 * Join segments from a path.
 *
 * @param {Array<string>} segments
 *   Path segments.
 * @returns {string}
 *   File path.
 */
function join(...segments) {
  let index = -1
  /** @type {string | undefined} */
  let joined

  while (++index < segments.length) {
    assertPath(segments[index])

    if (segments[index]) {
      joined =
        joined === undefined ? segments[index] : joined + '/' + segments[index]
    }
  }

  return joined === undefined ? '.' : normalize(joined)
}

/**
 * Normalize a basic file path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */
// Note: `normalize` is not exposed as `path.normalize`, so some code is
// manually removed from it.
function normalize(path) {
  assertPath(path)

  const absolute = path.charCodeAt(0) === 47 /* `/` */

  // Normalize the path according to POSIX rules.
  let value = normalizeString(path, !absolute)

  if (value.length === 0 && !absolute) {
    value = '.'
  }

  if (value.length > 0 && path.charCodeAt(path.length - 1) === 47 /* / */) {
    value += '/'
  }

  return absolute ? '/' + value : value
}

/**
 * Resolve `.` and `..` elements in a path with directory names.
 *
 * @param {string} path
 *   File path.
 * @param {boolean} allowAboveRoot
 *   Whether `..` can move above root.
 * @returns {string}
 *   File path.
 */
function normalizeString(path, allowAboveRoot) {
  let result = ''
  let lastSegmentLength = 0
  let lastSlash = -1
  let dots = 0
  let index = -1
  /** @type {number | undefined} */
  let code
  /** @type {number} */
  let lastSlashIndex

  while (++index <= path.length) {
    if (index < path.length) {
      code = path.charCodeAt(index)
    } else if (code === 47 /* `/` */) {
      break
    } else {
      code = 47 /* `/` */
    }

    if (code === 47 /* `/` */) {
      if (lastSlash === index - 1 || dots === 1) {
        // Empty.
      } else if (lastSlash !== index - 1 && dots === 2) {
        if (
          result.length < 2 ||
          lastSegmentLength !== 2 ||
          result.charCodeAt(result.length - 1) !== 46 /* `.` */ ||
          result.charCodeAt(result.length - 2) !== 46 /* `.` */
        ) {
          if (result.length > 2) {
            lastSlashIndex = result.lastIndexOf('/')

            if (lastSlashIndex !== result.length - 1) {
              if (lastSlashIndex < 0) {
                result = ''
                lastSegmentLength = 0
              } else {
                result = result.slice(0, lastSlashIndex)
                lastSegmentLength = result.length - 1 - result.lastIndexOf('/')
              }

              lastSlash = index
              dots = 0
              continue
            }
          } else if (result.length > 0) {
            result = ''
            lastSegmentLength = 0
            lastSlash = index
            dots = 0
            continue
          }
        }

        if (allowAboveRoot) {
          result = result.length > 0 ? result + '/..' : '..'
          lastSegmentLength = 2
        }
      } else {
        if (result.length > 0) {
          result += '/' + path.slice(lastSlash + 1, index)
        } else {
          result = path.slice(lastSlash + 1, index)
        }

        lastSegmentLength = index - lastSlash - 1
      }

      lastSlash = index
      dots = 0
    } else if (code === 46 /* `.` */ && dots > -1) {
      dots++
    } else {
      dots = -1
    }
  }

  return result
}

/**
 * Make sure `path` is a string.
 *
 * @param {string} path
 *   File path.
 * @returns {asserts path is string}
 *   Nothing.
 */
function assertPath(path) {
  if (typeof path !== 'string') {
    throw new TypeError(
      'Path must be a string. Received ' + JSON.stringify(path)
    )
  }
}

/* eslint-enable max-depth, complexity */

;// CONCATENATED MODULE: ../node_modules/vfile/lib/minproc.browser.js
// Somewhat based on:
// <https://github.com/defunctzombie/node-process/blob/master/browser.js>.
// But I don’t think one tiny line of code can be copyrighted. 😅
const proc = {cwd}

function cwd() {
  return '/'
}

;// CONCATENATED MODULE: ../node_modules/vfile/lib/minurl.shared.js
/**
 * @typedef URL
 * @property {string} hash
 * @property {string} host
 * @property {string} hostname
 * @property {string} href
 * @property {string} origin
 * @property {string} password
 * @property {string} pathname
 * @property {string} port
 * @property {string} protocol
 * @property {string} search
 * @property {any} searchParams
 * @property {string} username
 * @property {() => string} toString
 * @property {() => string} toJSON
 */

/**
 * Check if `fileUrlOrPath` looks like a URL.
 *
 * @param {unknown} fileUrlOrPath
 *   File path or URL.
 * @returns {fileUrlOrPath is URL}
 *   Whether it’s a URL.
 */
// From: <https://github.com/nodejs/node/blob/fcf8ba4/lib/internal/url.js#L1501>
function isUrl(fileUrlOrPath) {
  return (
    fileUrlOrPath !== null &&
    typeof fileUrlOrPath === 'object' &&
    // @ts-expect-error: indexable.
    fileUrlOrPath.href &&
    // @ts-expect-error: indexable.
    fileUrlOrPath.origin
  )
}

;// CONCATENATED MODULE: ../node_modules/vfile/lib/minurl.browser.js
/// <reference lib="dom" />



// See: <https://github.com/nodejs/node/blob/fcf8ba4/lib/internal/url.js>

/**
 * @param {string | URL} path
 *   File URL.
 * @returns {string}
 *   File URL.
 */
function urlToPath(path) {
  if (typeof path === 'string') {
    path = new URL(path)
  } else if (!isUrl(path)) {
    /** @type {NodeJS.ErrnoException} */
    const error = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' +
        path +
        '`'
    )
    error.code = 'ERR_INVALID_ARG_TYPE'
    throw error
  }

  if (path.protocol !== 'file:') {
    /** @type {NodeJS.ErrnoException} */
    const error = new TypeError('The URL must be of scheme file')
    error.code = 'ERR_INVALID_URL_SCHEME'
    throw error
  }

  return getPathFromURLPosix(path)
}

/**
 * Get a path from a POSIX URL.
 *
 * @param {URL} url
 *   URL.
 * @returns {string}
 *   File path.
 */
function getPathFromURLPosix(url) {
  if (url.hostname !== '') {
    /** @type {NodeJS.ErrnoException} */
    const error = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    )
    error.code = 'ERR_INVALID_FILE_URL_HOST'
    throw error
  }

  const pathname = url.pathname
  let index = -1

  while (++index < pathname.length) {
    if (
      pathname.charCodeAt(index) === 37 /* `%` */ &&
      pathname.charCodeAt(index + 1) === 50 /* `2` */
    ) {
      const third = pathname.charCodeAt(index + 2)
      if (third === 70 /* `F` */ || third === 102 /* `f` */) {
        /** @type {NodeJS.ErrnoException} */
        const error = new TypeError(
          'File URL path must not include encoded / characters'
        )
        error.code = 'ERR_INVALID_FILE_URL_PATH'
        throw error
      }
    }
  }

  return decodeURIComponent(pathname)
}



;// CONCATENATED MODULE: ../node_modules/vfile/lib/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 * @typedef {import('./minurl.shared.js').URL} URL
 * @typedef {import('../index.js').Data} Data
 * @typedef {import('../index.js').Value} Value
 */

/**
 * @typedef {Record<string, unknown> & {type: string, position?: Position | undefined}} NodeLike
 *
 * @typedef {'ascii' | 'utf8' | 'utf-8' | 'utf16le' | 'ucs2' | 'ucs-2' | 'base64' | 'base64url' | 'latin1' | 'binary' | 'hex'} BufferEncoding
 *   Encodings supported by the buffer class.
 *
 *   This is a copy of the types from Node, copied to prevent Node globals from
 *   being needed.
 *   Copied from: <https://github.com/DefinitelyTyped/DefinitelyTyped/blob/90a4ec8/types/node/buffer.d.ts#L170>
 *
 * @typedef {Options | URL | Value | VFile} Compatible
 *   Things that can be passed to the constructor.
 *
 * @typedef VFileCoreOptions
 *   Set multiple values.
 * @property {Value | null | undefined} [value]
 *   Set `value`.
 * @property {string | null | undefined} [cwd]
 *   Set `cwd`.
 * @property {Array<string> | null | undefined} [history]
 *   Set `history`.
 * @property {URL | string | null | undefined} [path]
 *   Set `path`.
 * @property {string | null | undefined} [basename]
 *   Set `basename`.
 * @property {string | null | undefined} [stem]
 *   Set `stem`.
 * @property {string | null | undefined} [extname]
 *   Set `extname`.
 * @property {string | null | undefined} [dirname]
 *   Set `dirname`.
 * @property {Data | null | undefined} [data]
 *   Set `data`.
 *
 * @typedef Map
 *   Raw source map.
 *
 *   See:
 *   <https://github.com/mozilla/source-map/blob/58819f0/source-map.d.ts#L15-L23>.
 * @property {number} version
 *   Which version of the source map spec this map is following.
 * @property {Array<string>} sources
 *   An array of URLs to the original source files.
 * @property {Array<string>} names
 *   An array of identifiers which can be referenced by individual mappings.
 * @property {string | undefined} [sourceRoot]
 *   The URL root from which all sources are relative.
 * @property {Array<string> | undefined} [sourcesContent]
 *   An array of contents of the original source files.
 * @property {string} mappings
 *   A string of base64 VLQs which contain the actual mappings.
 * @property {string} file
 *   The generated file this source map is associated with.
 *
 * @typedef {{[key: string]: unknown} & VFileCoreOptions} Options
 *   Configuration.
 *
 *   A bunch of keys that will be shallow copied over to the new file.
 *
 * @typedef {Record<string, unknown>} ReporterSettings
 *   Configuration for reporters.
 */

/**
 * @template {ReporterSettings} Settings
 *   Options type.
 * @callback Reporter
 *   Type for a reporter.
 * @param {Array<VFile>} files
 *   Files to report.
 * @param {Settings} options
 *   Configuration.
 * @returns {string}
 *   Report.
 */







/**
 * Order of setting (least specific to most), we need this because otherwise
 * `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
 * stem can be set.
 *
 * @type {Array<'basename' | 'dirname' | 'extname' | 'history' | 'path' | 'stem'>}
 */
const order = ['history', 'path', 'basename', 'stem', 'extname', 'dirname']

class VFile {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Buffer` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(value) {
    /** @type {Options | VFile} */
    let options

    if (!value) {
      options = {}
    } else if (typeof value === 'string' || buffer(value)) {
      options = {value}
    } else if (isUrl(value)) {
      options = {path: value}
    } else {
      options = value
    }

    /**
     * Place to store custom information (default: `{}`).
     *
     * It’s OK to store custom data directly on the file but moving it to
     * `data` is recommended.
     *
     * @type {Data}
     */
    this.data = {}

    /**
     * List of messages associated with the file.
     *
     * @type {Array<VFileMessage>}
     */
    this.messages = []

    /**
     * List of filepaths the file moved between.
     *
     * The first is the original path and the last is the current path.
     *
     * @type {Array<string>}
     */
    this.history = []

    /**
     * Base of `path` (default: `process.cwd()` or `'/'` in browsers).
     *
     * @type {string}
     */
    this.cwd = proc.cwd()

    /* eslint-disable no-unused-expressions */
    /**
     * Raw value.
     *
     * @type {Value}
     */
    this.value

    // The below are non-standard, they are “well-known”.
    // As in, used in several tools.

    /**
     * Whether a file was saved to disk.
     *
     * This is used by vfile reporters.
     *
     * @type {boolean}
     */
    this.stored

    /**
     * Custom, non-string, compiled, representation.
     *
     * This is used by unified to store non-string results.
     * One example is when turning markdown into React nodes.
     *
     * @type {unknown}
     */
    this.result

    /**
     * Source map.
     *
     * This type is equivalent to the `RawSourceMap` type from the `source-map`
     * module.
     *
     * @type {Map | null | undefined}
     */
    this.map
    /* eslint-enable no-unused-expressions */

    // Set path related properties in the correct order.
    let index = -1

    while (++index < order.length) {
      const prop = order[index]

      // Note: we specifically use `in` instead of `hasOwnProperty` to accept
      // `vfile`s too.
      if (
        prop in options &&
        options[prop] !== undefined &&
        options[prop] !== null
      ) {
        // @ts-expect-error: TS doesn’t understand basic reality.
        this[prop] = prop === 'history' ? [...options[prop]] : options[prop]
      }
    }

    /** @type {string} */
    let prop

    // Set non-path related properties.
    for (prop in options) {
      // @ts-expect-error: fine to set other things.
      if (!order.includes(prop)) {
        // @ts-expect-error: fine to set other things.
        this[prop] = options[prop]
      }
    }
  }

  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   */
  get path() {
    return this.history[this.history.length - 1]
  }

  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {string | URL} path
   */
  set path(path) {
    if (isUrl(path)) {
      path = urlToPath(path)
    }

    assertNonEmpty(path, 'path')

    if (this.path !== path) {
      this.history.push(path)
    }
  }

  /**
   * Get the parent path (example: `'~'`).
   */
  get dirname() {
    return typeof this.path === 'string' ? path.dirname(this.path) : undefined
  }

  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   */
  set dirname(dirname) {
    lib_assertPath(this.basename, 'dirname')
    this.path = path.join(dirname || '', this.basename)
  }

  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   */
  get basename() {
    return typeof this.path === 'string' ? path.basename(this.path) : undefined
  }

  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */
  set basename(basename) {
    assertNonEmpty(basename, 'basename')
    assertPart(basename, 'basename')
    this.path = path.join(this.dirname || '', basename)
  }

  /**
   * Get the extname (including dot) (example: `'.js'`).
   */
  get extname() {
    return typeof this.path === 'string' ? path.extname(this.path) : undefined
  }

  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   */
  set extname(extname) {
    assertPart(extname, 'extname')
    lib_assertPath(this.dirname, 'extname')

    if (extname) {
      if (extname.charCodeAt(0) !== 46 /* `.` */) {
        throw new Error('`extname` must start with `.`')
      }

      if (extname.includes('.', 1)) {
        throw new Error('`extname` cannot contain multiple dots')
      }
    }

    this.path = path.join(this.dirname, this.stem + (extname || ''))
  }

  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   */
  get stem() {
    return typeof this.path === 'string'
      ? path.basename(this.path, this.extname)
      : undefined
  }

  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */
  set stem(stem) {
    assertNonEmpty(stem, 'stem')
    assertPart(stem, 'stem')
    this.path = path.join(this.dirname || '', stem + (this.extname || ''))
  }

  /**
   * Serialize the file.
   *
   * @param {BufferEncoding | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Buffer`
   *   (default: `'utf8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(encoding) {
    return (this.value || '').toString(encoding || undefined)
  }

  /**
   * Create a warning message associated with the file.
   *
   * Its `fatal` is set to `false` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(reason, place, origin) {
    const message = new VFileMessage(reason, place, origin)

    if (this.path) {
      message.name = this.path + ':' + message.name
      message.file = this.path
    }

    message.fatal = false

    this.messages.push(message)

    return message
  }

  /**
   * Create an info message associated with the file.
   *
   * Its `fatal` is set to `null` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(reason, place, origin) {
    const message = this.message(reason, place, origin)

    message.fatal = null

    return message
  }

  /**
   * Create a fatal error associated with the file.
   *
   * Its `fatal` is set to `true` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * > 👉 **Note**: a fatal error means that a file is no longer processable.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Message.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(reason, place, origin) {
    const message = this.message(reason, place, origin)

    message.fatal = true

    throw message
  }
}

/**
 * Assert that `part` is not a path (as in, does not contain `path.sep`).
 *
 * @param {string | null | undefined} part
 *   File path part.
 * @param {string} name
 *   Part name.
 * @returns {void}
 *   Nothing.
 */
function assertPart(part, name) {
  if (part && part.includes(path.sep)) {
    throw new Error(
      '`' + name + '` cannot be a path: did not expect `' + path.sep + '`'
    )
  }
}

/**
 * Assert that `part` is not empty.
 *
 * @param {string | undefined} part
 *   Thing.
 * @param {string} name
 *   Part name.
 * @returns {asserts part is string}
 *   Nothing.
 */
function assertNonEmpty(part, name) {
  if (!part) {
    throw new Error('`' + name + '` cannot be empty')
  }
}

/**
 * Assert `path` exists.
 *
 * @param {string | undefined} path
 *   Path.
 * @param {string} name
 *   Dependency name.
 * @returns {asserts path is string}
 *   Nothing.
 */
function lib_assertPath(path, name) {
  if (!path) {
    throw new Error('Setting `' + name + '` requires `path` to be set too')
  }
}

/**
 * Assert `value` is a buffer.
 *
 * @param {unknown} value
 *   thing.
 * @returns {value is Buffer}
 *   Whether `value` is a Node.js buffer.
 */
function buffer(value) {
  return is_buffer(value)
}

;// CONCATENATED MODULE: ../node_modules/bail/index.js
/**
 * Throw a given error.
 *
 * @param {Error|null|undefined} [error]
 *   Maybe error.
 * @returns {asserts error is null|undefined}
 */
function bail(error) {
  if (error) {
    throw error
  }
}

// EXTERNAL MODULE: ../node_modules/extend/index.js
var extend = __webpack_require__(229);
;// CONCATENATED MODULE: ../node_modules/is-plain-obj/index.js
function isPlainObject(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}

	const prototype = Object.getPrototypeOf(value);
	return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}

;// CONCATENATED MODULE: ../node_modules/trough/lib/index.js
// To do: remove `void`s
// To do: remove `null` from output of our APIs, allow it as user APIs.

/**
 * @typedef {(error?: Error | null | undefined, ...output: Array<any>) => void} Callback
 *   Callback.
 *
 * @typedef {(...input: Array<any>) => any} Middleware
 *   Ware.
 *
 * @typedef Pipeline
 *   Pipeline.
 * @property {Run} run
 *   Run the pipeline.
 * @property {Use} use
 *   Add middleware.
 *
 * @typedef {(...input: Array<any>) => void} Run
 *   Call all middleware.
 *
 *   Calls `done` on completion with either an error or the output of the
 *   last middleware.
 *
 *   > 👉 **Note**: as the length of input defines whether async functions get a
 *   > `next` function,
 *   > it’s recommended to keep `input` at one value normally.

 *
 * @typedef {(fn: Middleware) => Pipeline} Use
 *   Add middleware.
 */

/**
 * Create new middleware.
 *
 * @returns {Pipeline}
 *   Pipeline.
 */
function trough() {
  /** @type {Array<Middleware>} */
  const fns = []
  /** @type {Pipeline} */
  const pipeline = {run, use}

  return pipeline

  /** @type {Run} */
  function run(...values) {
    let middlewareIndex = -1
    /** @type {Callback} */
    const callback = values.pop()

    if (typeof callback !== 'function') {
      throw new TypeError('Expected function as last argument, not ' + callback)
    }

    next(null, ...values)

    /**
     * Run the next `fn`, or we’re done.
     *
     * @param {Error | null | undefined} error
     * @param {Array<any>} output
     */
    function next(error, ...output) {
      const fn = fns[++middlewareIndex]
      let index = -1

      if (error) {
        callback(error)
        return
      }

      // Copy non-nullish input into values.
      while (++index < values.length) {
        if (output[index] === null || output[index] === undefined) {
          output[index] = values[index]
        }
      }

      // Save the newly created `output` for the next call.
      values = output

      // Next or done.
      if (fn) {
        wrap(fn, next)(...output)
      } else {
        callback(null, ...output)
      }
    }
  }

  /** @type {Use} */
  function use(middelware) {
    if (typeof middelware !== 'function') {
      throw new TypeError(
        'Expected `middelware` to be a function, not ' + middelware
      )
    }

    fns.push(middelware)
    return pipeline
  }
}

/**
 * Wrap `middleware` into a uniform interface.
 *
 * You can pass all input to the resulting function.
 * `callback` is then called with the output of `middleware`.
 *
 * If `middleware` accepts more arguments than the later given in input,
 * an extra `done` function is passed to it after that input,
 * which must be called by `middleware`.
 *
 * The first value in `input` is the main input value.
 * All other input values are the rest input values.
 * The values given to `callback` are the input values,
 * merged with every non-nullish output value.
 *
 * * if `middleware` throws an error,
 *   returns a promise that is rejected,
 *   or calls the given `done` function with an error,
 *   `callback` is called with that error
 * * if `middleware` returns a value or returns a promise that is resolved,
 *   that value is the main output value
 * * if `middleware` calls `done`,
 *   all non-nullish values except for the first one (the error) overwrite the
 *   output values
 *
 * @param {Middleware} middleware
 *   Function to wrap.
 * @param {Callback} callback
 *   Callback called with the output of `middleware`.
 * @returns {Run}
 *   Wrapped middleware.
 */
function wrap(middleware, callback) {
  /** @type {boolean} */
  let called

  return wrapped

  /**
   * Call `middleware`.
   * @this {any}
   * @param {Array<any>} parameters
   * @returns {void}
   */
  function wrapped(...parameters) {
    const fnExpectsCallback = middleware.length > parameters.length
    /** @type {any} */
    let result

    if (fnExpectsCallback) {
      parameters.push(done)
    }

    try {
      result = middleware.apply(this, parameters)
    } catch (error) {
      const exception = /** @type {Error} */ (error)

      // Well, this is quite the pickle.
      // `middleware` received a callback and called it synchronously, but that
      // threw an error.
      // The only thing left to do is to throw the thing instead.
      if (fnExpectsCallback && called) {
        throw exception
      }

      return done(exception)
    }

    if (!fnExpectsCallback) {
      if (result && result.then && typeof result.then === 'function') {
        result.then(then, done)
      } else if (result instanceof Error) {
        done(result)
      } else {
        then(result)
      }
    }
  }

  /**
   * Call `callback`, only once.
   *
   * @type {Callback}
   */
  function done(error, ...output) {
    if (!called) {
      called = true
      callback(error, ...output)
    }
  }

  /**
   * Call `done` with one value.
   *
   * @param {any} [value]
   */
  function then(value) {
    done(null, value)
  }
}

;// CONCATENATED MODULE: ../node_modules/unified/lib/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('vfile').VFileCompatible} VFileCompatible
 * @typedef {import('vfile').VFileValue} VFileValue
 * @typedef {import('..').Processor} Processor
 * @typedef {import('..').Plugin} Plugin
 * @typedef {import('..').Preset} Preset
 * @typedef {import('..').Pluggable} Pluggable
 * @typedef {import('..').PluggableList} PluggableList
 * @typedef {import('..').Transformer} Transformer
 * @typedef {import('..').Parser} Parser
 * @typedef {import('..').Compiler} Compiler
 * @typedef {import('..').RunCallback} RunCallback
 * @typedef {import('..').ProcessCallback} ProcessCallback
 *
 * @typedef Context
 * @property {Node} tree
 * @property {VFile} file
 */








// Expose a frozen processor.
const unified = base().freeze()

const own = {}.hasOwnProperty

// Function to create the first processor.
/**
 * @returns {Processor}
 */
function base() {
  const transformers = trough()
  /** @type {Processor['attachers']} */
  const attachers = []
  /** @type {Record<string, unknown>} */
  let namespace = {}
  /** @type {boolean|undefined} */
  let frozen
  let freezeIndex = -1

  // Data management.
  // @ts-expect-error: overloads are handled.
  processor.data = data
  processor.Parser = undefined
  processor.Compiler = undefined

  // Lock.
  processor.freeze = freeze

  // Plugins.
  processor.attachers = attachers
  // @ts-expect-error: overloads are handled.
  processor.use = use

  // API.
  processor.parse = parse
  processor.stringify = stringify
  // @ts-expect-error: overloads are handled.
  processor.run = run
  processor.runSync = runSync
  // @ts-expect-error: overloads are handled.
  processor.process = process
  processor.processSync = processSync

  // Expose.
  return processor

  // Create a new processor based on the processor in the current scope.
  /** @type {Processor} */
  function processor() {
    const destination = base()
    let index = -1

    while (++index < attachers.length) {
      destination.use(...attachers[index])
    }

    destination.data(extend(true, {}, namespace))

    return destination
  }

  /**
   * @param {string|Record<string, unknown>} [key]
   * @param {unknown} [value]
   * @returns {unknown}
   */
  function data(key, value) {
    if (typeof key === 'string') {
      // Set `key`.
      if (arguments.length === 2) {
        assertUnfrozen('data', frozen)
        namespace[key] = value
        return processor
      }

      // Get `key`.
      return (own.call(namespace, key) && namespace[key]) || null
    }

    // Set space.
    if (key) {
      assertUnfrozen('data', frozen)
      namespace = key
      return processor
    }

    // Get space.
    return namespace
  }

  /** @type {Processor['freeze']} */
  function freeze() {
    if (frozen) {
      return processor
    }

    while (++freezeIndex < attachers.length) {
      const [attacher, ...options] = attachers[freezeIndex]

      if (options[0] === false) {
        continue
      }

      if (options[0] === true) {
        options[0] = undefined
      }

      /** @type {Transformer|void} */
      const transformer = attacher.call(processor, ...options)

      if (typeof transformer === 'function') {
        transformers.use(transformer)
      }
    }

    frozen = true
    freezeIndex = Number.POSITIVE_INFINITY

    return processor
  }

  /**
   * @param {Pluggable|null|undefined} [value]
   * @param {...unknown} options
   * @returns {Processor}
   */
  function use(value, ...options) {
    /** @type {Record<string, unknown>|undefined} */
    let settings

    assertUnfrozen('use', frozen)

    if (value === null || value === undefined) {
      // Empty.
    } else if (typeof value === 'function') {
      addPlugin(value, ...options)
    } else if (typeof value === 'object') {
      if (Array.isArray(value)) {
        addList(value)
      } else {
        addPreset(value)
      }
    } else {
      throw new TypeError('Expected usable value, not `' + value + '`')
    }

    if (settings) {
      namespace.settings = Object.assign(namespace.settings || {}, settings)
    }

    return processor

    /**
     * @param {import('..').Pluggable<unknown[]>} value
     * @returns {void}
     */
    function add(value) {
      if (typeof value === 'function') {
        addPlugin(value)
      } else if (typeof value === 'object') {
        if (Array.isArray(value)) {
          const [plugin, ...options] = value
          addPlugin(plugin, ...options)
        } else {
          addPreset(value)
        }
      } else {
        throw new TypeError('Expected usable value, not `' + value + '`')
      }
    }

    /**
     * @param {Preset} result
     * @returns {void}
     */
    function addPreset(result) {
      addList(result.plugins)

      if (result.settings) {
        settings = Object.assign(settings || {}, result.settings)
      }
    }

    /**
     * @param {PluggableList|null|undefined} [plugins]
     * @returns {void}
     */
    function addList(plugins) {
      let index = -1

      if (plugins === null || plugins === undefined) {
        // Empty.
      } else if (Array.isArray(plugins)) {
        while (++index < plugins.length) {
          const thing = plugins[index]
          add(thing)
        }
      } else {
        throw new TypeError('Expected a list of plugins, not `' + plugins + '`')
      }
    }

    /**
     * @param {Plugin} plugin
     * @param {...unknown} [value]
     * @returns {void}
     */
    function addPlugin(plugin, value) {
      let index = -1
      /** @type {Processor['attachers'][number]|undefined} */
      let entry

      while (++index < attachers.length) {
        if (attachers[index][0] === plugin) {
          entry = attachers[index]
          break
        }
      }

      if (entry) {
        if (isPlainObject(entry[1]) && isPlainObject(value)) {
          value = extend(true, entry[1], value)
        }

        entry[1] = value
      } else {
        // @ts-expect-error: fine.
        attachers.push([...arguments])
      }
    }
  }

  /** @type {Processor['parse']} */
  function parse(doc) {
    processor.freeze()
    const file = vfile(doc)
    const Parser = processor.Parser
    assertParser('parse', Parser)

    if (newable(Parser, 'parse')) {
      // @ts-expect-error: `newable` checks this.
      return new Parser(String(file), file).parse()
    }

    // @ts-expect-error: `newable` checks this.
    return Parser(String(file), file) // eslint-disable-line new-cap
  }

  /** @type {Processor['stringify']} */
  function stringify(node, doc) {
    processor.freeze()
    const file = vfile(doc)
    const Compiler = processor.Compiler
    assertCompiler('stringify', Compiler)
    assertNode(node)

    if (newable(Compiler, 'compile')) {
      // @ts-expect-error: `newable` checks this.
      return new Compiler(node, file).compile()
    }

    // @ts-expect-error: `newable` checks this.
    return Compiler(node, file) // eslint-disable-line new-cap
  }

  /**
   * @param {Node} node
   * @param {VFileCompatible|RunCallback} [doc]
   * @param {RunCallback} [callback]
   * @returns {Promise<Node>|void}
   */
  function run(node, doc, callback) {
    assertNode(node)
    processor.freeze()

    if (!callback && typeof doc === 'function') {
      callback = doc
      doc = undefined
    }

    if (!callback) {
      return new Promise(executor)
    }

    executor(null, callback)

    /**
     * @param {null|((node: Node) => void)} resolve
     * @param {(error: Error) => void} reject
     * @returns {void}
     */
    function executor(resolve, reject) {
      // @ts-expect-error: `doc` can’t be a callback anymore, we checked.
      transformers.run(node, vfile(doc), done)

      /**
       * @param {Error|null} error
       * @param {Node} tree
       * @param {VFile} file
       * @returns {void}
       */
      function done(error, tree, file) {
        tree = tree || node
        if (error) {
          reject(error)
        } else if (resolve) {
          resolve(tree)
        } else {
          // @ts-expect-error: `callback` is defined if `resolve` is not.
          callback(null, tree, file)
        }
      }
    }
  }

  /** @type {Processor['runSync']} */
  function runSync(node, file) {
    /** @type {Node|undefined} */
    let result
    /** @type {boolean|undefined} */
    let complete

    processor.run(node, file, done)

    assertDone('runSync', 'run', complete)

    // @ts-expect-error: we either bailed on an error or have a tree.
    return result

    /**
     * @param {Error|null} [error]
     * @param {Node} [tree]
     * @returns {void}
     */
    function done(error, tree) {
      bail(error)
      result = tree
      complete = true
    }
  }

  /**
   * @param {VFileCompatible} doc
   * @param {ProcessCallback} [callback]
   * @returns {Promise<VFile>|undefined}
   */
  function process(doc, callback) {
    processor.freeze()
    assertParser('process', processor.Parser)
    assertCompiler('process', processor.Compiler)

    if (!callback) {
      return new Promise(executor)
    }

    executor(null, callback)

    /**
     * @param {null|((file: VFile) => void)} resolve
     * @param {(error?: Error|null|undefined) => void} reject
     * @returns {void}
     */
    function executor(resolve, reject) {
      const file = vfile(doc)

      processor.run(processor.parse(file), file, (error, tree, file) => {
        if (error || !tree || !file) {
          done(error)
        } else {
          /** @type {unknown} */
          const result = processor.stringify(tree, file)

          if (result === undefined || result === null) {
            // Empty.
          } else if (looksLikeAVFileValue(result)) {
            file.value = result
          } else {
            file.result = result
          }

          done(error, file)
        }
      })

      /**
       * @param {Error|null|undefined} [error]
       * @param {VFile|undefined} [file]
       * @returns {void}
       */
      function done(error, file) {
        if (error || !file) {
          reject(error)
        } else if (resolve) {
          resolve(file)
        } else {
          // @ts-expect-error: `callback` is defined if `resolve` is not.
          callback(null, file)
        }
      }
    }
  }

  /** @type {Processor['processSync']} */
  function processSync(doc) {
    /** @type {boolean|undefined} */
    let complete

    processor.freeze()
    assertParser('processSync', processor.Parser)
    assertCompiler('processSync', processor.Compiler)

    const file = vfile(doc)

    processor.process(file, done)

    assertDone('processSync', 'process', complete)

    return file

    /**
     * @param {Error|null|undefined} [error]
     * @returns {void}
     */
    function done(error) {
      complete = true
      bail(error)
    }
  }
}

/**
 * Check if `value` is a constructor.
 *
 * @param {unknown} value
 * @param {string} name
 * @returns {boolean}
 */
function newable(value, name) {
  return (
    typeof value === 'function' &&
    // Prototypes do exist.
    // type-coverage:ignore-next-line
    value.prototype &&
    // A function with keys in its prototype is probably a constructor.
    // Classes’ prototype methods are not enumerable, so we check if some value
    // exists in the prototype.
    // type-coverage:ignore-next-line
    (keys(value.prototype) || name in value.prototype)
  )
}

/**
 * Check if `value` is an object with keys.
 *
 * @param {Record<string, unknown>} value
 * @returns {boolean}
 */
function keys(value) {
  /** @type {string} */
  let key

  for (key in value) {
    if (own.call(value, key)) {
      return true
    }
  }

  return false
}

/**
 * Assert a parser is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Parser}
 */
function assertParser(name, value) {
  if (typeof value !== 'function') {
    throw new TypeError('Cannot `' + name + '` without `Parser`')
  }
}

/**
 * Assert a compiler is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Compiler}
 */
function assertCompiler(name, value) {
  if (typeof value !== 'function') {
    throw new TypeError('Cannot `' + name + '` without `Compiler`')
  }
}

/**
 * Assert the processor is not frozen.
 *
 * @param {string} name
 * @param {unknown} frozen
 * @returns {asserts frozen is false}
 */
function assertUnfrozen(name, frozen) {
  if (frozen) {
    throw new Error(
      'Cannot call `' +
        name +
        '` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`.'
    )
  }
}

/**
 * Assert `node` is a unist node.
 *
 * @param {unknown} node
 * @returns {asserts node is Node}
 */
function assertNode(node) {
  // `isPlainObj` unfortunately uses `any` instead of `unknown`.
  // type-coverage:ignore-next-line
  if (!isPlainObject(node) || typeof node.type !== 'string') {
    throw new TypeError('Expected node, got `' + node + '`')
    // Fine.
  }
}

/**
 * Assert that `complete` is `true`.
 *
 * @param {string} name
 * @param {string} asyncName
 * @param {unknown} complete
 * @returns {asserts complete is true}
 */
function assertDone(name, asyncName, complete) {
  if (!complete) {
    throw new Error(
      '`' + name + '` finished async. Use `' + asyncName + '` instead'
    )
  }
}

/**
 * @param {VFileCompatible} [value]
 * @returns {VFile}
 */
function vfile(value) {
  return looksLikeAVFile(value) ? value : new VFile(value)
}

/**
 * @param {VFileCompatible} [value]
 * @returns {value is VFile}
 */
function looksLikeAVFile(value) {
  return Boolean(
    value &&
      typeof value === 'object' &&
      'message' in value &&
      'messages' in value
  )
}

/**
 * @param {unknown} [value]
 * @returns {value is VFileValue}
 */
function looksLikeAVFileValue(value) {
  return typeof value === 'string' || is_buffer(value)
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-string/lib/index.js
/**
 * @typedef {import('mdast').Root|import('mdast').Content} Node
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [includeImageAlt=true]
 *   Whether to use `alt` for `image`s.
 * @property {boolean | null | undefined} [includeHtml=true]
 *   Whether to use `value` of HTML.
 */

/** @type {Options} */
const emptyOptions = {}

/**
 * Get the text content of a node or list of nodes.
 *
 * Prefers the node’s plain-text fields, otherwise serializes its children,
 * and if the given value is an array, serialize the nodes in it.
 *
 * @param {unknown} value
 *   Thing to serialize, typically `Node`.
 * @param {Options | null | undefined} [options]
 *   Configuration (optional).
 * @returns {string}
 *   Serialized `value`.
 */
function lib_toString(value, options) {
  const settings = options || emptyOptions
  const includeImageAlt =
    typeof settings.includeImageAlt === 'boolean'
      ? settings.includeImageAlt
      : true
  const includeHtml =
    typeof settings.includeHtml === 'boolean' ? settings.includeHtml : true

  return one(value, includeImageAlt, includeHtml)
}

/**
 * One node or several nodes.
 *
 * @param {unknown} value
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized node.
 */
function one(value, includeImageAlt, includeHtml) {
  if (node(value)) {
    if ('value' in value) {
      return value.type === 'html' && !includeHtml ? '' : value.value
    }

    if (includeImageAlt && 'alt' in value && value.alt) {
      return value.alt
    }

    if ('children' in value) {
      return lib_all(value.children, includeImageAlt, includeHtml)
    }
  }

  if (Array.isArray(value)) {
    return lib_all(value, includeImageAlt, includeHtml)
  }

  return ''
}

/**
 * Serialize a list of nodes.
 *
 * @param {Array<unknown>} values
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized nodes.
 */
function lib_all(values, includeImageAlt, includeHtml) {
  /** @type {Array<string>} */
  const result = []
  let index = -1

  while (++index < values.length) {
    result[index] = one(values[index], includeImageAlt, includeHtml)
  }

  return result.join('')
}

/**
 * Check if `value` looks like a node.
 *
 * @param {unknown} value
 *   Thing.
 * @returns {value is Node}
 *   Whether `value` is a node.
 */
function node(value) {
  return Boolean(value && typeof value === 'object')
}

;// CONCATENATED MODULE: ../node_modules/micromark-util-chunked/index.js
/**
 * Like `Array#splice`, but smarter for giant arrays.
 *
 * `Array#splice` takes all items to be inserted as individual argument which
 * causes a stack overflow in V8 when trying to insert 100k items for instance.
 *
 * Otherwise, this does not return the removed items, and takes `items` as an
 * array instead of rest parameters.
 *
 * @template {unknown} T
 *   Item type.
 * @param {Array<T>} list
 *   List to operate on.
 * @param {number} start
 *   Index to remove/insert at (can be negative).
 * @param {number} remove
 *   Number of items to remove.
 * @param {Array<T>} items
 *   Items to inject into `list`.
 * @returns {void}
 *   Nothing.
 */
function splice(list, start, remove, items) {
  const end = list.length
  let chunkStart = 0
  /** @type {Array<unknown>} */
  let parameters

  // Make start between zero and `end` (included).
  if (start < 0) {
    start = -start > end ? 0 : end + start
  } else {
    start = start > end ? end : start
  }
  remove = remove > 0 ? remove : 0

  // No need to chunk the items if there’s only a couple (10k) items.
  if (items.length < 10000) {
    parameters = Array.from(items)
    parameters.unshift(start, remove)
    // @ts-expect-error Hush, it’s fine.
    list.splice(...parameters)
  } else {
    // Delete `remove` items starting from `start`
    if (remove) list.splice(start, remove)

    // Insert the items in chunks to not cause stack overflows.
    while (chunkStart < items.length) {
      parameters = items.slice(chunkStart, chunkStart + 10000)
      parameters.unshift(start, 0)
      // @ts-expect-error Hush, it’s fine.
      list.splice(...parameters)
      chunkStart += 10000
      start += 10000
    }
  }
}

/**
 * Append `items` (an array) at the end of `list` (another array).
 * When `list` was empty, returns `items` instead.
 *
 * This prevents a potentially expensive operation when `list` is empty,
 * and adds items in batches to prevent V8 from hanging.
 *
 * @template {unknown} T
 *   Item type.
 * @param {Array<T>} list
 *   List to operate on.
 * @param {Array<T>} items
 *   Items to add to `list`.
 * @returns {Array<T>}
 *   Either `list` or `items`.
 */
function push(list, items) {
  if (list.length > 0) {
    splice(list, list.length, 0, items)
    return list
  }
  return items
}

;// CONCATENATED MODULE: ../node_modules/micromark-util-combine-extensions/index.js
/**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Handles} Handles
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').NormalizedExtension} NormalizedExtension
 */



const micromark_util_combine_extensions_hasOwnProperty = {}.hasOwnProperty

/**
 * Combine multiple syntax extensions into one.
 *
 * @param {Array<Extension>} extensions
 *   List of syntax extensions.
 * @returns {NormalizedExtension}
 *   A single combined extension.
 */
function combineExtensions(extensions) {
  /** @type {NormalizedExtension} */
  const all = {}
  let index = -1

  while (++index < extensions.length) {
    syntaxExtension(all, extensions[index])
  }

  return all
}

/**
 * Merge `extension` into `all`.
 *
 * @param {NormalizedExtension} all
 *   Extension to merge into.
 * @param {Extension} extension
 *   Extension to merge.
 * @returns {void}
 */
function syntaxExtension(all, extension) {
  /** @type {keyof Extension} */
  let hook

  for (hook in extension) {
    const maybe = micromark_util_combine_extensions_hasOwnProperty.call(all, hook) ? all[hook] : undefined
    /** @type {Record<string, unknown>} */
    const left = maybe || (all[hook] = {})
    /** @type {Record<string, unknown> | undefined} */
    const right = extension[hook]
    /** @type {string} */
    let code

    if (right) {
      for (code in right) {
        if (!micromark_util_combine_extensions_hasOwnProperty.call(left, code)) left[code] = []
        const value = right[code]
        constructs(
          // @ts-expect-error Looks like a list.
          left[code],
          Array.isArray(value) ? value : value ? [value] : []
        )
      }
    }
  }
}

/**
 * Merge `list` into `existing` (both lists of constructs).
 * Mutates `existing`.
 *
 * @param {Array<unknown>} existing
 * @param {Array<unknown>} list
 * @returns {void}
 */
function constructs(existing, list) {
  let index = -1
  /** @type {Array<unknown>} */
  const before = []

  while (++index < list.length) {
    // @ts-expect-error Looks like an object.
    ;(list[index].add === 'after' ? existing : before).push(list[index])
  }

  splice(existing, 0, 0, before)
}

/**
 * Combine multiple HTML extensions into one.
 *
 * @param {Array<HtmlExtension>} htmlExtensions
 *   List of HTML extensions.
 * @returns {HtmlExtension}
 *   A single combined HTML extension.
 */
function micromark_util_combine_extensions_combineHtmlExtensions(htmlExtensions) {
  /** @type {HtmlExtension} */
  const handlers = {}
  let index = -1

  while (++index < htmlExtensions.length) {
    htmlExtension(handlers, htmlExtensions[index])
  }

  return handlers
}

/**
 * Merge `extension` into `all`.
 *
 * @param {HtmlExtension} all
 *   Extension to merge into.
 * @param {HtmlExtension} extension
 *   Extension to merge.
 * @returns {void}
 */
function htmlExtension(all, extension) {
  /** @type {keyof HtmlExtension} */
  let hook

  for (hook in extension) {
    const maybe = micromark_util_combine_extensions_hasOwnProperty.call(all, hook) ? all[hook] : undefined
    const left = maybe || (all[hook] = {})
    const right = extension[hook]
    /** @type {keyof Handles} */
    let type

    if (right) {
      for (type in right) {
        // @ts-expect-error assume document vs regular handler are managed correctly.
        left[type] = right[type]
      }
    }
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-util-character/lib/unicode-punctuation-regex.js
// This module is generated by `script/`.
//
// CommonMark handles attention (emphasis, strong) markers based on what comes
// before or after them.
// One such difference is if those characters are Unicode punctuation.
// This script is generated from the Unicode data.

/**
 * Regular expression that matches a unicode punctuation character.
 */
const unicodePunctuationRegex =
  /[!-\/:-@\[-`\{-~\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/

;// CONCATENATED MODULE: ../node_modules/micromark-util-character/index.js
/**
 * @typedef {import('micromark-util-types').Code} Code
 */



/**
 * Check whether the character code represents an ASCII alpha (`a` through `z`,
 * case insensitive).
 *
 * An **ASCII alpha** is an ASCII upper alpha or ASCII lower alpha.
 *
 * An **ASCII upper alpha** is a character in the inclusive range U+0041 (`A`)
 * to U+005A (`Z`).
 *
 * An **ASCII lower alpha** is a character in the inclusive range U+0061 (`a`)
 * to U+007A (`z`).
 *
 * @param code
 *   Code.
 * @returns
 *   Whether it matches.
 */
const asciiAlpha = regexCheck(/[A-Za-z]/)

/**
 * Check whether the character code represents an ASCII alphanumeric (`a`
 * through `z`, case insensitive, or `0` through `9`).
 *
 * An **ASCII alphanumeric** is an ASCII digit (see `asciiDigit`) or ASCII alpha
 * (see `asciiAlpha`).
 *
 * @param code
 *   Code.
 * @returns
 *   Whether it matches.
 */
const asciiAlphanumeric = regexCheck(/[\dA-Za-z]/)

/**
 * Check whether the character code represents an ASCII atext.
 *
 * atext is an ASCII alphanumeric (see `asciiAlphanumeric`), or a character in
 * the inclusive ranges U+0023 NUMBER SIGN (`#`) to U+0027 APOSTROPHE (`'`),
 * U+002A ASTERISK (`*`), U+002B PLUS SIGN (`+`), U+002D DASH (`-`), U+002F
 * SLASH (`/`), U+003D EQUALS TO (`=`), U+003F QUESTION MARK (`?`), U+005E
 * CARET (`^`) to U+0060 GRAVE ACCENT (`` ` ``), or U+007B LEFT CURLY BRACE
 * (`{`) to U+007E TILDE (`~`).
 *
 * See:
 * **\[RFC5322]**:
 * [Internet Message Format](https://tools.ietf.org/html/rfc5322).
 * P. Resnick.
 * IETF.
 *
 * @param code
 *   Code.
 * @returns
 *   Whether it matches.
 */
const asciiAtext = regexCheck(/[#-'*+\--9=?A-Z^-~]/)

/**
 * Check whether a character code is an ASCII control character.
 *
 * An **ASCII control** is a character in the inclusive range U+0000 NULL (NUL)
 * to U+001F (US), or U+007F (DEL).
 *
 * @param {Code} code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */
function asciiControl(code) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code !== null && (code < 32 || code === 127)
  )
}

/**
 * Check whether the character code represents an ASCII digit (`0` through `9`).
 *
 * An **ASCII digit** is a character in the inclusive range U+0030 (`0`) to
 * U+0039 (`9`).
 *
 * @param code
 *   Code.
 * @returns
 *   Whether it matches.
 */
const asciiDigit = regexCheck(/\d/)

/**
 * Check whether the character code represents an ASCII hex digit (`a` through
 * `f`, case insensitive, or `0` through `9`).
 *
 * An **ASCII hex digit** is an ASCII digit (see `asciiDigit`), ASCII upper hex
 * digit, or an ASCII lower hex digit.
 *
 * An **ASCII upper hex digit** is a character in the inclusive range U+0041
 * (`A`) to U+0046 (`F`).
 *
 * An **ASCII lower hex digit** is a character in the inclusive range U+0061
 * (`a`) to U+0066 (`f`).
 *
 * @param code
 *   Code.
 * @returns
 *   Whether it matches.
 */
const asciiHexDigit = regexCheck(/[\dA-Fa-f]/)

/**
 * Check whether the character code represents ASCII punctuation.
 *
 * An **ASCII punctuation** is a character in the inclusive ranges U+0021
 * EXCLAMATION MARK (`!`) to U+002F SLASH (`/`), U+003A COLON (`:`) to U+0040 AT
 * SIGN (`@`), U+005B LEFT SQUARE BRACKET (`[`) to U+0060 GRAVE ACCENT
 * (`` ` ``), or U+007B LEFT CURLY BRACE (`{`) to U+007E TILDE (`~`).
 *
 * @param code
 *   Code.
 * @returns
 *   Whether it matches.
 */
const asciiPunctuation = regexCheck(/[!-/:-@[-`{-~]/)

/**
 * Check whether a character code is a markdown line ending.
 *
 * A **markdown line ending** is the virtual characters M-0003 CARRIAGE RETURN
 * LINE FEED (CRLF), M-0004 LINE FEED (LF) and M-0005 CARRIAGE RETURN (CR).
 *
 * In micromark, the actual character U+000A LINE FEED (LF) and U+000D CARRIAGE
 * RETURN (CR) are replaced by these virtual characters depending on whether
 * they occurred together.
 *
 * @param {Code} code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */
function markdownLineEnding(code) {
  return code !== null && code < -2
}

/**
 * Check whether a character code is a markdown line ending (see
 * `markdownLineEnding`) or markdown space (see `markdownSpace`).
 *
 * @param {Code} code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */
function markdownLineEndingOrSpace(code) {
  return code !== null && (code < 0 || code === 32)
}

/**
 * Check whether a character code is a markdown space.
 *
 * A **markdown space** is the concrete character U+0020 SPACE (SP) and the
 * virtual characters M-0001 VIRTUAL SPACE (VS) and M-0002 HORIZONTAL TAB (HT).
 *
 * In micromark, the actual character U+0009 CHARACTER TABULATION (HT) is
 * replaced by one M-0002 HORIZONTAL TAB (HT) and between 0 and 3 M-0001 VIRTUAL
 * SPACE (VS) characters, depending on the column at which the tab occurred.
 *
 * @param {Code} code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */
function markdownSpace(code) {
  return code === -2 || code === -1 || code === 32
}

// Size note: removing ASCII from the regex and using `asciiPunctuation` here
// In fact adds to the bundle size.
/**
 * Check whether the character code represents Unicode punctuation.
 *
 * A **Unicode punctuation** is a character in the Unicode `Pc` (Punctuation,
 * Connector), `Pd` (Punctuation, Dash), `Pe` (Punctuation, Close), `Pf`
 * (Punctuation, Final quote), `Pi` (Punctuation, Initial quote), `Po`
 * (Punctuation, Other), or `Ps` (Punctuation, Open) categories, or an ASCII
 * punctuation (see `asciiPunctuation`).
 *
 * See:
 * **\[UNICODE]**:
 * [The Unicode Standard](https://www.unicode.org/versions/).
 * Unicode Consortium.
 *
 * @param code
 *   Code.
 * @returns
 *   Whether it matches.
 */
const unicodePunctuation = regexCheck(unicodePunctuationRegex)

/**
 * Check whether the character code represents Unicode whitespace.
 *
 * Note that this does handle micromark specific markdown whitespace characters.
 * See `markdownLineEndingOrSpace` to check that.
 *
 * A **Unicode whitespace** is a character in the Unicode `Zs` (Separator,
 * Space) category, or U+0009 CHARACTER TABULATION (HT), U+000A LINE FEED (LF),
 * U+000C (FF), or U+000D CARRIAGE RETURN (CR) (**\[UNICODE]**).
 *
 * See:
 * **\[UNICODE]**:
 * [The Unicode Standard](https://www.unicode.org/versions/).
 * Unicode Consortium.
 *
 * @param code
 *   Code.
 * @returns
 *   Whether it matches.
 */
const unicodeWhitespace = regexCheck(/\s/)

/**
 * Create a code check from a regex.
 *
 * @param {RegExp} regex
 * @returns {(code: Code) => boolean}
 */
function regexCheck(regex) {
  return check

  /**
   * Check whether a code matches the bound regex.
   *
   * @param {Code} code
   *   Character code.
   * @returns {boolean}
   *   Whether the character code matches the bound regex.
   */
  function check(code) {
    return code !== null && regex.test(String.fromCharCode(code))
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-factory-space/index.js
/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */



// To do: implement `spaceOrTab`, `spaceOrTabMinMax`, `spaceOrTabWithOptions`.

/**
 * Parse spaces and tabs.
 *
 * There is no `nok` parameter:
 *
 * *   spaces in markdown are often optional, in which case this factory can be
 *     used and `ok` will be switched to whether spaces were found or not
 * *   one line ending or space can be detected with `markdownSpace(code)` right
 *     before using `factorySpace`
 *
 * ###### Examples
 *
 * Where `␉` represents a tab (plus how much it expands) and `␠` represents a
 * single space.
 *
 * ```markdown
 * ␉
 * ␠␠␠␠
 * ␉␠
 * ```
 *
 * @param {Effects} effects
 *   Context.
 * @param {State} ok
 *   State switched to when successful.
 * @param {TokenType} type
 *   Type (`' \t'`).
 * @param {number | undefined} [max=Infinity]
 *   Max (exclusive).
 * @returns
 *   Start state.
 */
function factorySpace(effects, ok, type, max) {
  const limit = max ? max - 1 : Number.POSITIVE_INFINITY
  let size = 0
  return start

  /** @type {State} */
  function start(code) {
    if (markdownSpace(code)) {
      effects.enter(type)
      return prefix(code)
    }
    return ok(code)
  }

  /** @type {State} */
  function prefix(code) {
    if (markdownSpace(code) && size++ < limit) {
      effects.consume(code)
      return prefix
    }
    effects.exit(type)
    return ok(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark/lib/initialize/content.js
/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */



/** @type {InitialConstruct} */
const content = {
  tokenize: initializeContent
}

/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */
function initializeContent(effects) {
  const contentStart = effects.attempt(
    this.parser.constructs.contentInitial,
    afterContentStartConstruct,
    paragraphInitial
  )
  /** @type {Token} */
  let previous
  return contentStart

  /** @type {State} */
  function afterContentStartConstruct(code) {
    if (code === null) {
      effects.consume(code)
      return
    }
    effects.enter('lineEnding')
    effects.consume(code)
    effects.exit('lineEnding')
    return factorySpace(effects, contentStart, 'linePrefix')
  }

  /** @type {State} */
  function paragraphInitial(code) {
    effects.enter('paragraph')
    return lineStart(code)
  }

  /** @type {State} */
  function lineStart(code) {
    const token = effects.enter('chunkText', {
      contentType: 'text',
      previous
    })
    if (previous) {
      previous.next = token
    }
    previous = token
    return data(code)
  }

  /** @type {State} */
  function data(code) {
    if (code === null) {
      effects.exit('chunkText')
      effects.exit('paragraph')
      effects.consume(code)
      return
    }
    if (markdownLineEnding(code)) {
      effects.consume(code)
      effects.exit('chunkText')
      return lineStart
    }

    // Data.
    effects.consume(code)
    return data
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark/lib/initialize/document.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ContainerState} ContainerState
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */

/**
 * @typedef {[Construct, ContainerState]} StackItem
 */




/** @type {InitialConstruct} */
const document_document = {
  tokenize: initializeDocument
}

/** @type {Construct} */
const containerConstruct = {
  tokenize: tokenizeContainer
}

/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */
function initializeDocument(effects) {
  const self = this
  /** @type {Array<StackItem>} */
  const stack = []
  let continued = 0
  /** @type {TokenizeContext | undefined} */
  let childFlow
  /** @type {Token | undefined} */
  let childToken
  /** @type {number} */
  let lineStartOffset
  return start

  /** @type {State} */
  function start(code) {
    // First we iterate through the open blocks, starting with the root
    // document, and descending through last children down to the last open
    // block.
    // Each block imposes a condition that the line must satisfy if the block is
    // to remain open.
    // For example, a block quote requires a `>` character.
    // A paragraph requires a non-blank line.
    // In this phase we may match all or just some of the open blocks.
    // But we cannot close unmatched blocks yet, because we may have a lazy
    // continuation line.
    if (continued < stack.length) {
      const item = stack[continued]
      self.containerState = item[1]
      return effects.attempt(
        item[0].continuation,
        documentContinue,
        checkNewContainers
      )(code)
    }

    // Done.
    return checkNewContainers(code)
  }

  /** @type {State} */
  function documentContinue(code) {
    continued++

    // Note: this field is called `_closeFlow` but it also closes containers.
    // Perhaps a good idea to rename it but it’s already used in the wild by
    // extensions.
    if (self.containerState._closeFlow) {
      self.containerState._closeFlow = undefined
      if (childFlow) {
        closeFlow()
      }

      // Note: this algorithm for moving events around is similar to the
      // algorithm when dealing with lazy lines in `writeToChild`.
      const indexBeforeExits = self.events.length
      let indexBeforeFlow = indexBeforeExits
      /** @type {Point | undefined} */
      let point

      // Find the flow chunk.
      while (indexBeforeFlow--) {
        if (
          self.events[indexBeforeFlow][0] === 'exit' &&
          self.events[indexBeforeFlow][1].type === 'chunkFlow'
        ) {
          point = self.events[indexBeforeFlow][1].end
          break
        }
      }
      exitContainers(continued)

      // Fix positions.
      let index = indexBeforeExits
      while (index < self.events.length) {
        self.events[index][1].end = Object.assign({}, point)
        index++
      }

      // Inject the exits earlier (they’re still also at the end).
      splice(
        self.events,
        indexBeforeFlow + 1,
        0,
        self.events.slice(indexBeforeExits)
      )

      // Discard the duplicate exits.
      self.events.length = index
      return checkNewContainers(code)
    }
    return start(code)
  }

  /** @type {State} */
  function checkNewContainers(code) {
    // Next, after consuming the continuation markers for existing blocks, we
    // look for new block starts (e.g. `>` for a block quote).
    // If we encounter a new block start, we close any blocks unmatched in
    // step 1 before creating the new block as a child of the last matched
    // block.
    if (continued === stack.length) {
      // No need to `check` whether there’s a container, of `exitContainers`
      // would be moot.
      // We can instead immediately `attempt` to parse one.
      if (!childFlow) {
        return documentContinued(code)
      }

      // If we have concrete content, such as block HTML or fenced code,
      // we can’t have containers “pierce” into them, so we can immediately
      // start.
      if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) {
        return flowStart(code)
      }

      // If we do have flow, it could still be a blank line,
      // but we’d be interrupting it w/ a new container if there’s a current
      // construct.
      // To do: next major: remove `_gfmTableDynamicInterruptHack` (no longer
      // needed in micromark-extension-gfm-table@1.0.6).
      self.interrupt = Boolean(
        childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack
      )
    }

    // Check if there is a new container.
    self.containerState = {}
    return effects.check(
      containerConstruct,
      thereIsANewContainer,
      thereIsNoNewContainer
    )(code)
  }

  /** @type {State} */
  function thereIsANewContainer(code) {
    if (childFlow) closeFlow()
    exitContainers(continued)
    return documentContinued(code)
  }

  /** @type {State} */
  function thereIsNoNewContainer(code) {
    self.parser.lazy[self.now().line] = continued !== stack.length
    lineStartOffset = self.now().offset
    return flowStart(code)
  }

  /** @type {State} */
  function documentContinued(code) {
    // Try new containers.
    self.containerState = {}
    return effects.attempt(
      containerConstruct,
      containerContinue,
      flowStart
    )(code)
  }

  /** @type {State} */
  function containerContinue(code) {
    continued++
    stack.push([self.currentConstruct, self.containerState])
    // Try another.
    return documentContinued(code)
  }

  /** @type {State} */
  function flowStart(code) {
    if (code === null) {
      if (childFlow) closeFlow()
      exitContainers(0)
      effects.consume(code)
      return
    }
    childFlow = childFlow || self.parser.flow(self.now())
    effects.enter('chunkFlow', {
      contentType: 'flow',
      previous: childToken,
      _tokenizer: childFlow
    })
    return flowContinue(code)
  }

  /** @type {State} */
  function flowContinue(code) {
    if (code === null) {
      writeToChild(effects.exit('chunkFlow'), true)
      exitContainers(0)
      effects.consume(code)
      return
    }
    if (markdownLineEnding(code)) {
      effects.consume(code)
      writeToChild(effects.exit('chunkFlow'))
      // Get ready for the next line.
      continued = 0
      self.interrupt = undefined
      return start
    }
    effects.consume(code)
    return flowContinue
  }

  /**
   * @param {Token} token
   * @param {boolean | undefined} [eof]
   * @returns {void}
   */
  function writeToChild(token, eof) {
    const stream = self.sliceStream(token)
    if (eof) stream.push(null)
    token.previous = childToken
    if (childToken) childToken.next = token
    childToken = token
    childFlow.defineSkip(token.start)
    childFlow.write(stream)

    // Alright, so we just added a lazy line:
    //
    // ```markdown
    // > a
    // b.
    //
    // Or:
    //
    // > ~~~c
    // d
    //
    // Or:
    //
    // > | e |
    // f
    // ```
    //
    // The construct in the second example (fenced code) does not accept lazy
    // lines, so it marked itself as done at the end of its first line, and
    // then the content construct parses `d`.
    // Most constructs in markdown match on the first line: if the first line
    // forms a construct, a non-lazy line can’t “unmake” it.
    //
    // The construct in the third example is potentially a GFM table, and
    // those are *weird*.
    // It *could* be a table, from the first line, if the following line
    // matches a condition.
    // In this case, that second line is lazy, which “unmakes” the first line
    // and turns the whole into one content block.
    //
    // We’ve now parsed the non-lazy and the lazy line, and can figure out
    // whether the lazy line started a new flow block.
    // If it did, we exit the current containers between the two flow blocks.
    if (self.parser.lazy[token.start.line]) {
      let index = childFlow.events.length
      while (index--) {
        if (
          // The token starts before the line ending…
          childFlow.events[index][1].start.offset < lineStartOffset &&
          // …and either is not ended yet…
          (!childFlow.events[index][1].end ||
            // …or ends after it.
            childFlow.events[index][1].end.offset > lineStartOffset)
        ) {
          // Exit: there’s still something open, which means it’s a lazy line
          // part of something.
          return
        }
      }

      // Note: this algorithm for moving events around is similar to the
      // algorithm when closing flow in `documentContinue`.
      const indexBeforeExits = self.events.length
      let indexBeforeFlow = indexBeforeExits
      /** @type {boolean | undefined} */
      let seen
      /** @type {Point | undefined} */
      let point

      // Find the previous chunk (the one before the lazy line).
      while (indexBeforeFlow--) {
        if (
          self.events[indexBeforeFlow][0] === 'exit' &&
          self.events[indexBeforeFlow][1].type === 'chunkFlow'
        ) {
          if (seen) {
            point = self.events[indexBeforeFlow][1].end
            break
          }
          seen = true
        }
      }
      exitContainers(continued)

      // Fix positions.
      index = indexBeforeExits
      while (index < self.events.length) {
        self.events[index][1].end = Object.assign({}, point)
        index++
      }

      // Inject the exits earlier (they’re still also at the end).
      splice(
        self.events,
        indexBeforeFlow + 1,
        0,
        self.events.slice(indexBeforeExits)
      )

      // Discard the duplicate exits.
      self.events.length = index
    }
  }

  /**
   * @param {number} size
   * @returns {void}
   */
  function exitContainers(size) {
    let index = stack.length

    // Exit open containers.
    while (index-- > size) {
      const entry = stack[index]
      self.containerState = entry[1]
      entry[0].exit.call(self, effects)
    }
    stack.length = size
  }
  function closeFlow() {
    childFlow.write([null])
    childToken = undefined
    childFlow = undefined
    self.containerState._closeFlow = undefined
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeContainer(effects, ok, nok) {
  // Always populated by defaults.

  return factorySpace(
    effects,
    effects.attempt(this.parser.constructs.document, ok, nok),
    'linePrefix',
    this.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4
  )
}

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/blank-line.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */



/** @type {Construct} */
const blankLine = {
  tokenize: tokenizeBlankLine,
  partial: true
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeBlankLine(effects, ok, nok) {
  return start

  /**
   * Start of blank line.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *     ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    return markdownSpace(code)
      ? factorySpace(effects, after, 'linePrefix')(code)
      : after(code)
  }

  /**
   * At eof/eol, after optional whitespace.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *       ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */
  function after(code) {
    return code === null || markdownLineEnding(code) ? ok(code) : nok(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-util-subtokenize/index.js
/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Token} Token
 */


/**
 * Tokenize subcontent.
 *
 * @param {Array<Event>} events
 *   List of events.
 * @returns {boolean}
 *   Whether subtokens were found.
 */
function subtokenize(events) {
  /** @type {Record<string, number>} */
  const jumps = {}
  let index = -1
  /** @type {Event} */
  let event
  /** @type {number | undefined} */
  let lineIndex
  /** @type {number} */
  let otherIndex
  /** @type {Event} */
  let otherEvent
  /** @type {Array<Event>} */
  let parameters
  /** @type {Array<Event>} */
  let subevents
  /** @type {boolean | undefined} */
  let more
  while (++index < events.length) {
    while (index in jumps) {
      index = jumps[index]
    }
    event = events[index]

    // Add a hook for the GFM tasklist extension, which needs to know if text
    // is in the first content of a list item.
    if (
      index &&
      event[1].type === 'chunkFlow' &&
      events[index - 1][1].type === 'listItemPrefix'
    ) {
      subevents = event[1]._tokenizer.events
      otherIndex = 0
      if (
        otherIndex < subevents.length &&
        subevents[otherIndex][1].type === 'lineEndingBlank'
      ) {
        otherIndex += 2
      }
      if (
        otherIndex < subevents.length &&
        subevents[otherIndex][1].type === 'content'
      ) {
        while (++otherIndex < subevents.length) {
          if (subevents[otherIndex][1].type === 'content') {
            break
          }
          if (subevents[otherIndex][1].type === 'chunkText') {
            subevents[otherIndex][1]._isInFirstContentOfListItem = true
            otherIndex++
          }
        }
      }
    }

    // Enter.
    if (event[0] === 'enter') {
      if (event[1].contentType) {
        Object.assign(jumps, subcontent(events, index))
        index = jumps[index]
        more = true
      }
    }
    // Exit.
    else if (event[1]._container) {
      otherIndex = index
      lineIndex = undefined
      while (otherIndex--) {
        otherEvent = events[otherIndex]
        if (
          otherEvent[1].type === 'lineEnding' ||
          otherEvent[1].type === 'lineEndingBlank'
        ) {
          if (otherEvent[0] === 'enter') {
            if (lineIndex) {
              events[lineIndex][1].type = 'lineEndingBlank'
            }
            otherEvent[1].type = 'lineEnding'
            lineIndex = otherIndex
          }
        } else {
          break
        }
      }
      if (lineIndex) {
        // Fix position.
        event[1].end = Object.assign({}, events[lineIndex][1].start)

        // Switch container exit w/ line endings.
        parameters = events.slice(lineIndex, index)
        parameters.unshift(event)
        splice(events, lineIndex, index - lineIndex + 1, parameters)
      }
    }
  }
  return !more
}

/**
 * Tokenize embedded tokens.
 *
 * @param {Array<Event>} events
 * @param {number} eventIndex
 * @returns {Record<string, number>}
 */
function subcontent(events, eventIndex) {
  const token = events[eventIndex][1]
  const context = events[eventIndex][2]
  let startPosition = eventIndex - 1
  /** @type {Array<number>} */
  const startPositions = []
  const tokenizer =
    token._tokenizer || context.parser[token.contentType](token.start)
  const childEvents = tokenizer.events
  /** @type {Array<[number, number]>} */
  const jumps = []
  /** @type {Record<string, number>} */
  const gaps = {}
  /** @type {Array<Chunk>} */
  let stream
  /** @type {Token | undefined} */
  let previous
  let index = -1
  /** @type {Token | undefined} */
  let current = token
  let adjust = 0
  let start = 0
  const breaks = [start]

  // Loop forward through the linked tokens to pass them in order to the
  // subtokenizer.
  while (current) {
    // Find the position of the event for this token.
    while (events[++startPosition][1] !== current) {
      // Empty.
    }
    startPositions.push(startPosition)
    if (!current._tokenizer) {
      stream = context.sliceStream(current)
      if (!current.next) {
        stream.push(null)
      }
      if (previous) {
        tokenizer.defineSkip(current.start)
      }
      if (current._isInFirstContentOfListItem) {
        tokenizer._gfmTasklistFirstContentOfListItem = true
      }
      tokenizer.write(stream)
      if (current._isInFirstContentOfListItem) {
        tokenizer._gfmTasklistFirstContentOfListItem = undefined
      }
    }

    // Unravel the next token.
    previous = current
    current = current.next
  }

  // Now, loop back through all events (and linked tokens), to figure out which
  // parts belong where.
  current = token
  while (++index < childEvents.length) {
    if (
      // Find a void token that includes a break.
      childEvents[index][0] === 'exit' &&
      childEvents[index - 1][0] === 'enter' &&
      childEvents[index][1].type === childEvents[index - 1][1].type &&
      childEvents[index][1].start.line !== childEvents[index][1].end.line
    ) {
      start = index + 1
      breaks.push(start)
      // Help GC.
      current._tokenizer = undefined
      current.previous = undefined
      current = current.next
    }
  }

  // Help GC.
  tokenizer.events = []

  // If there’s one more token (which is the cases for lines that end in an
  // EOF), that’s perfect: the last point we found starts it.
  // If there isn’t then make sure any remaining content is added to it.
  if (current) {
    // Help GC.
    current._tokenizer = undefined
    current.previous = undefined
  } else {
    breaks.pop()
  }

  // Now splice the events from the subtokenizer into the current events,
  // moving back to front so that splice indices aren’t affected.
  index = breaks.length
  while (index--) {
    const slice = childEvents.slice(breaks[index], breaks[index + 1])
    const start = startPositions.pop()
    jumps.unshift([start, start + slice.length - 1])
    splice(events, start, 2, slice)
  }
  index = -1
  while (++index < jumps.length) {
    gaps[adjust + jumps[index][0]] = adjust + jumps[index][1]
    adjust += jumps[index][1] - jumps[index][0] - 1
  }
  return gaps
}

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/content.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */




/**
 * No name because it must not be turned off.
 * @type {Construct}
 */
const content_content = {
  tokenize: tokenizeContent,
  resolve: resolveContent
}

/** @type {Construct} */
const continuationConstruct = {
  tokenize: tokenizeContinuation,
  partial: true
}

/**
 * Content is transparent: it’s parsed right now. That way, definitions are also
 * parsed right now: before text in paragraphs (specifically, media) are parsed.
 *
 * @type {Resolver}
 */
function resolveContent(events) {
  subtokenize(events)
  return events
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeContent(effects, ok) {
  /** @type {Token | undefined} */
  let previous
  return chunkStart

  /**
   * Before a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^
   * ```
   *
   * @type {State}
   */
  function chunkStart(code) {
    effects.enter('content')
    previous = effects.enter('chunkContent', {
      contentType: 'content'
    })
    return chunkInside(code)
  }

  /**
   * In a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^^^
   * ```
   *
   * @type {State}
   */
  function chunkInside(code) {
    if (code === null) {
      return contentEnd(code)
    }

    // To do: in `markdown-rs`, each line is parsed on its own, and everything
    // is stitched together resolving.
    if (markdownLineEnding(code)) {
      return effects.check(
        continuationConstruct,
        contentContinue,
        contentEnd
      )(code)
    }

    // Data.
    effects.consume(code)
    return chunkInside
  }

  /**
   *
   *
   * @type {State}
   */
  function contentEnd(code) {
    effects.exit('chunkContent')
    effects.exit('content')
    return ok(code)
  }

  /**
   *
   *
   * @type {State}
   */
  function contentContinue(code) {
    effects.consume(code)
    effects.exit('chunkContent')
    previous.next = effects.enter('chunkContent', {
      contentType: 'content',
      previous
    })
    previous = previous.next
    return chunkInside
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeContinuation(effects, ok, nok) {
  const self = this
  return startLookahead

  /**
   *
   *
   * @type {State}
   */
  function startLookahead(code) {
    effects.exit('chunkContent')
    effects.enter('lineEnding')
    effects.consume(code)
    effects.exit('lineEnding')
    return factorySpace(effects, prefixed, 'linePrefix')
  }

  /**
   *
   *
   * @type {State}
   */
  function prefixed(code) {
    if (code === null || markdownLineEnding(code)) {
      return nok(code)
    }

    // Always populated by defaults.

    const tail = self.events[self.events.length - 1]
    if (
      !self.parser.constructs.disable.null.includes('codeIndented') &&
      tail &&
      tail[1].type === 'linePrefix' &&
      tail[2].sliceSerialize(tail[1], true).length >= 4
    ) {
      return ok(code)
    }
    return effects.interrupt(self.parser.constructs.flow, nok, ok)(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark/lib/initialize/flow.js
/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */




/** @type {InitialConstruct} */
const flow = {
  tokenize: initializeFlow
}

/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */
function initializeFlow(effects) {
  const self = this
  const initial = effects.attempt(
    // Try to parse a blank line.
    blankLine,
    atBlankEnding,
    // Try to parse initial flow (essentially, only code).
    effects.attempt(
      this.parser.constructs.flowInitial,
      afterConstruct,
      factorySpace(
        effects,
        effects.attempt(
          this.parser.constructs.flow,
          afterConstruct,
          effects.attempt(content_content, afterConstruct)
        ),
        'linePrefix'
      )
    )
  )
  return initial

  /** @type {State} */
  function atBlankEnding(code) {
    if (code === null) {
      effects.consume(code)
      return
    }
    effects.enter('lineEndingBlank')
    effects.consume(code)
    effects.exit('lineEndingBlank')
    self.currentConstruct = undefined
    return initial
  }

  /** @type {State} */
  function afterConstruct(code) {
    if (code === null) {
      effects.consume(code)
      return
    }
    effects.enter('lineEnding')
    effects.consume(code)
    effects.exit('lineEnding')
    self.currentConstruct = undefined
    return initial
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark/lib/initialize/text.js
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */

const resolver = {
  resolveAll: createResolver()
}
const string = initializeFactory('string')
const text_text = initializeFactory('text')

/**
 * @param {'string' | 'text'} field
 * @returns {InitialConstruct}
 */
function initializeFactory(field) {
  return {
    tokenize: initializeText,
    resolveAll: createResolver(
      field === 'text' ? resolveAllLineSuffixes : undefined
    )
  }

  /**
   * @this {TokenizeContext}
   * @type {Initializer}
   */
  function initializeText(effects) {
    const self = this
    const constructs = this.parser.constructs[field]
    const text = effects.attempt(constructs, start, notText)
    return start

    /** @type {State} */
    function start(code) {
      return atBreak(code) ? text(code) : notText(code)
    }

    /** @type {State} */
    function notText(code) {
      if (code === null) {
        effects.consume(code)
        return
      }
      effects.enter('data')
      effects.consume(code)
      return data
    }

    /** @type {State} */
    function data(code) {
      if (atBreak(code)) {
        effects.exit('data')
        return text(code)
      }

      // Data.
      effects.consume(code)
      return data
    }

    /**
     * @param {Code} code
     * @returns {boolean}
     */
    function atBreak(code) {
      if (code === null) {
        return true
      }
      const list = constructs[code]
      let index = -1
      if (list) {
        // Always populated by defaults.

        while (++index < list.length) {
          const item = list[index]
          if (!item.previous || item.previous.call(self, self.previous)) {
            return true
          }
        }
      }
      return false
    }
  }
}

/**
 * @param {Resolver | undefined} [extraResolver]
 * @returns {Resolver}
 */
function createResolver(extraResolver) {
  return resolveAllText

  /** @type {Resolver} */
  function resolveAllText(events, context) {
    let index = -1
    /** @type {number | undefined} */
    let enter

    // A rather boring computation (to merge adjacent `data` events) which
    // improves mm performance by 29%.
    while (++index <= events.length) {
      if (enter === undefined) {
        if (events[index] && events[index][1].type === 'data') {
          enter = index
          index++
        }
      } else if (!events[index] || events[index][1].type !== 'data') {
        // Don’t do anything if there is one data token.
        if (index !== enter + 2) {
          events[enter][1].end = events[index - 1][1].end
          events.splice(enter + 2, index - enter - 2)
          index = enter + 2
        }
        enter = undefined
      }
    }
    return extraResolver ? extraResolver(events, context) : events
  }
}

/**
 * A rather ugly set of instructions which again looks at chunks in the input
 * stream.
 * The reason to do this here is that it is *much* faster to parse in reverse.
 * And that we can’t hook into `null` to split the line suffix before an EOF.
 * To do: figure out if we can make this into a clean utility, or even in core.
 * As it will be useful for GFMs literal autolink extension (and maybe even
 * tables?)
 *
 * @type {Resolver}
 */
function resolveAllLineSuffixes(events, context) {
  let eventIndex = 0 // Skip first.

  while (++eventIndex <= events.length) {
    if (
      (eventIndex === events.length ||
        events[eventIndex][1].type === 'lineEnding') &&
      events[eventIndex - 1][1].type === 'data'
    ) {
      const data = events[eventIndex - 1][1]
      const chunks = context.sliceStream(data)
      let index = chunks.length
      let bufferIndex = -1
      let size = 0
      /** @type {boolean | undefined} */
      let tabs
      while (index--) {
        const chunk = chunks[index]
        if (typeof chunk === 'string') {
          bufferIndex = chunk.length
          while (chunk.charCodeAt(bufferIndex - 1) === 32) {
            size++
            bufferIndex--
          }
          if (bufferIndex) break
          bufferIndex = -1
        }
        // Number
        else if (chunk === -2) {
          tabs = true
          size++
        } else if (chunk === -1) {
          // Empty
        } else {
          // Replacement character, exit.
          index++
          break
        }
      }
      if (size) {
        const token = {
          type:
            eventIndex === events.length || tabs || size < 2
              ? 'lineSuffix'
              : 'hardBreakTrailing',
          start: {
            line: data.end.line,
            column: data.end.column - size,
            offset: data.end.offset - size,
            _index: data.start._index + index,
            _bufferIndex: index
              ? bufferIndex
              : data.start._bufferIndex + bufferIndex
          },
          end: Object.assign({}, data.end)
        }
        data.end = Object.assign({}, token.start)
        if (data.start.offset === data.end.offset) {
          Object.assign(data, token)
        } else {
          events.splice(
            eventIndex,
            0,
            ['enter', token, context],
            ['exit', token, context]
          )
          eventIndex += 2
        }
      }
      eventIndex++
    }
  }
  return events
}

;// CONCATENATED MODULE: ../node_modules/micromark-util-resolve-all/index.js
/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */

/**
 * Call all `resolveAll`s.
 *
 * @param {Array<{resolveAll?: Resolver | undefined}>} constructs
 *   List of constructs, optionally with `resolveAll`s.
 * @param {Array<Event>} events
 *   List of events.
 * @param {TokenizeContext} context
 *   Context used by `tokenize`.
 * @returns {Array<Event>}
 *   Changed events.
 */
function resolveAll(constructs, events, context) {
  /** @type {Array<Resolver>} */
  const called = []
  let index = -1

  while (++index < constructs.length) {
    const resolve = constructs[index].resolveAll

    if (resolve && !called.includes(resolve)) {
      events = resolve(events, context)
      called.push(resolve)
    }
  }

  return events
}

;// CONCATENATED MODULE: ../node_modules/micromark/lib/create-tokenizer.js
/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ConstructRecord} ConstructRecord
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenType} TokenType
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */

/**
 * @callback Restore
 * @returns {void}
 *
 * @typedef Info
 * @property {Restore} restore
 * @property {number} from
 *
 * @callback ReturnHandle
 *   Handle a successful run.
 * @param {Construct} construct
 * @param {Info} info
 * @returns {void}
 */




/**
 * Create a tokenizer.
 * Tokenizers deal with one type of data (e.g., containers, flow, text).
 * The parser is the object dealing with it all.
 * `initialize` works like other constructs, except that only its `tokenize`
 * function is used, in which case it doesn’t receive an `ok` or `nok`.
 * `from` can be given to set the point before the first character, although
 * when further lines are indented, they must be set with `defineSkip`.
 *
 * @param {ParseContext} parser
 * @param {InitialConstruct} initialize
 * @param {Omit<Point, '_bufferIndex' | '_index'> | undefined} [from]
 * @returns {TokenizeContext}
 */
function createTokenizer(parser, initialize, from) {
  /** @type {Point} */
  let point = Object.assign(
    from
      ? Object.assign({}, from)
      : {
          line: 1,
          column: 1,
          offset: 0
        },
    {
      _index: 0,
      _bufferIndex: -1
    }
  )
  /** @type {Record<string, number>} */
  const columnStart = {}
  /** @type {Array<Construct>} */
  const resolveAllConstructs = []
  /** @type {Array<Chunk>} */
  let chunks = []
  /** @type {Array<Token>} */
  let stack = []
  /** @type {boolean | undefined} */
  let consumed = true

  /**
   * Tools used for tokenizing.
   *
   * @type {Effects}
   */
  const effects = {
    consume,
    enter,
    exit,
    attempt: constructFactory(onsuccessfulconstruct),
    check: constructFactory(onsuccessfulcheck),
    interrupt: constructFactory(onsuccessfulcheck, {
      interrupt: true
    })
  }

  /**
   * State and tools for resolving and serializing.
   *
   * @type {TokenizeContext}
   */
  const context = {
    previous: null,
    code: null,
    containerState: {},
    events: [],
    parser,
    sliceStream,
    sliceSerialize,
    now,
    defineSkip,
    write
  }

  /**
   * The state function.
   *
   * @type {State | void}
   */
  let state = initialize.tokenize.call(context, effects)

  /**
   * Track which character we expect to be consumed, to catch bugs.
   *
   * @type {Code}
   */
  let expectedCode
  if (initialize.resolveAll) {
    resolveAllConstructs.push(initialize)
  }
  return context

  /** @type {TokenizeContext['write']} */
  function write(slice) {
    chunks = push(chunks, slice)
    main()

    // Exit if we’re not done, resolve might change stuff.
    if (chunks[chunks.length - 1] !== null) {
      return []
    }
    addResult(initialize, 0)

    // Otherwise, resolve, and exit.
    context.events = resolveAll(resolveAllConstructs, context.events, context)
    return context.events
  }

  //
  // Tools.
  //

  /** @type {TokenizeContext['sliceSerialize']} */
  function sliceSerialize(token, expandTabs) {
    return serializeChunks(sliceStream(token), expandTabs)
  }

  /** @type {TokenizeContext['sliceStream']} */
  function sliceStream(token) {
    return sliceChunks(chunks, token)
  }

  /** @type {TokenizeContext['now']} */
  function now() {
    // This is a hot path, so we clone manually instead of `Object.assign({}, point)`
    const {line, column, offset, _index, _bufferIndex} = point
    return {
      line,
      column,
      offset,
      _index,
      _bufferIndex
    }
  }

  /** @type {TokenizeContext['defineSkip']} */
  function defineSkip(value) {
    columnStart[value.line] = value.column
    accountForPotentialSkip()
  }

  //
  // State management.
  //

  /**
   * Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
   * `consume`).
   * Here is where we walk through the chunks, which either include strings of
   * several characters, or numerical character codes.
   * The reason to do this in a loop instead of a call is so the stack can
   * drain.
   *
   * @returns {void}
   */
  function main() {
    /** @type {number} */
    let chunkIndex
    while (point._index < chunks.length) {
      const chunk = chunks[point._index]

      // If we’re in a buffer chunk, loop through it.
      if (typeof chunk === 'string') {
        chunkIndex = point._index
        if (point._bufferIndex < 0) {
          point._bufferIndex = 0
        }
        while (
          point._index === chunkIndex &&
          point._bufferIndex < chunk.length
        ) {
          go(chunk.charCodeAt(point._bufferIndex))
        }
      } else {
        go(chunk)
      }
    }
  }

  /**
   * Deal with one code.
   *
   * @param {Code} code
   * @returns {void}
   */
  function go(code) {
    consumed = undefined
    expectedCode = code
    state = state(code)
  }

  /** @type {Effects['consume']} */
  function consume(code) {
    if (markdownLineEnding(code)) {
      point.line++
      point.column = 1
      point.offset += code === -3 ? 2 : 1
      accountForPotentialSkip()
    } else if (code !== -1) {
      point.column++
      point.offset++
    }

    // Not in a string chunk.
    if (point._bufferIndex < 0) {
      point._index++
    } else {
      point._bufferIndex++

      // At end of string chunk.
      // @ts-expect-error Points w/ non-negative `_bufferIndex` reference
      // strings.
      if (point._bufferIndex === chunks[point._index].length) {
        point._bufferIndex = -1
        point._index++
      }
    }

    // Expose the previous character.
    context.previous = code

    // Mark as consumed.
    consumed = true
  }

  /** @type {Effects['enter']} */
  function enter(type, fields) {
    /** @type {Token} */
    // @ts-expect-error Patch instead of assign required fields to help GC.
    const token = fields || {}
    token.type = type
    token.start = now()
    context.events.push(['enter', token, context])
    stack.push(token)
    return token
  }

  /** @type {Effects['exit']} */
  function exit(type) {
    const token = stack.pop()
    token.end = now()
    context.events.push(['exit', token, context])
    return token
  }

  /**
   * Use results.
   *
   * @type {ReturnHandle}
   */
  function onsuccessfulconstruct(construct, info) {
    addResult(construct, info.from)
  }

  /**
   * Discard results.
   *
   * @type {ReturnHandle}
   */
  function onsuccessfulcheck(_, info) {
    info.restore()
  }

  /**
   * Factory to attempt/check/interrupt.
   *
   * @param {ReturnHandle} onreturn
   * @param {{interrupt?: boolean | undefined} | undefined} [fields]
   */
  function constructFactory(onreturn, fields) {
    return hook

    /**
     * Handle either an object mapping codes to constructs, a list of
     * constructs, or a single construct.
     *
     * @param {Array<Construct> | Construct | ConstructRecord} constructs
     * @param {State} returnState
     * @param {State | undefined} [bogusState]
     * @returns {State}
     */
    function hook(constructs, returnState, bogusState) {
      /** @type {Array<Construct>} */
      let listOfConstructs
      /** @type {number} */
      let constructIndex
      /** @type {Construct} */
      let currentConstruct
      /** @type {Info} */
      let info
      return Array.isArray(constructs) /* c8 ignore next 1 */
        ? handleListOfConstructs(constructs)
        : 'tokenize' in constructs
        ? // @ts-expect-error Looks like a construct.
          handleListOfConstructs([constructs])
        : handleMapOfConstructs(constructs)

      /**
       * Handle a list of construct.
       *
       * @param {ConstructRecord} map
       * @returns {State}
       */
      function handleMapOfConstructs(map) {
        return start

        /** @type {State} */
        function start(code) {
          const def = code !== null && map[code]
          const all = code !== null && map.null
          const list = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...(Array.isArray(def) ? def : def ? [def] : []),
            ...(Array.isArray(all) ? all : all ? [all] : [])
          ]
          return handleListOfConstructs(list)(code)
        }
      }

      /**
       * Handle a list of construct.
       *
       * @param {Array<Construct>} list
       * @returns {State}
       */
      function handleListOfConstructs(list) {
        listOfConstructs = list
        constructIndex = 0
        if (list.length === 0) {
          return bogusState
        }
        return handleConstruct(list[constructIndex])
      }

      /**
       * Handle a single construct.
       *
       * @param {Construct} construct
       * @returns {State}
       */
      function handleConstruct(construct) {
        return start

        /** @type {State} */
        function start(code) {
          // To do: not needed to store if there is no bogus state, probably?
          // Currently doesn’t work because `inspect` in document does a check
          // w/o a bogus, which doesn’t make sense. But it does seem to help perf
          // by not storing.
          info = store()
          currentConstruct = construct
          if (!construct.partial) {
            context.currentConstruct = construct
          }

          // Always populated by defaults.

          if (
            construct.name &&
            context.parser.constructs.disable.null.includes(construct.name)
          ) {
            return nok(code)
          }
          return construct.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            fields ? Object.assign(Object.create(context), fields) : context,
            effects,
            ok,
            nok
          )(code)
        }
      }

      /** @type {State} */
      function ok(code) {
        consumed = true
        onreturn(currentConstruct, info)
        return returnState
      }

      /** @type {State} */
      function nok(code) {
        consumed = true
        info.restore()
        if (++constructIndex < listOfConstructs.length) {
          return handleConstruct(listOfConstructs[constructIndex])
        }
        return bogusState
      }
    }
  }

  /**
   * @param {Construct} construct
   * @param {number} from
   * @returns {void}
   */
  function addResult(construct, from) {
    if (construct.resolveAll && !resolveAllConstructs.includes(construct)) {
      resolveAllConstructs.push(construct)
    }
    if (construct.resolve) {
      splice(
        context.events,
        from,
        context.events.length - from,
        construct.resolve(context.events.slice(from), context)
      )
    }
    if (construct.resolveTo) {
      context.events = construct.resolveTo(context.events, context)
    }
  }

  /**
   * Store state.
   *
   * @returns {Info}
   */
  function store() {
    const startPoint = now()
    const startPrevious = context.previous
    const startCurrentConstruct = context.currentConstruct
    const startEventsIndex = context.events.length
    const startStack = Array.from(stack)
    return {
      restore,
      from: startEventsIndex
    }

    /**
     * Restore state.
     *
     * @returns {void}
     */
    function restore() {
      point = startPoint
      context.previous = startPrevious
      context.currentConstruct = startCurrentConstruct
      context.events.length = startEventsIndex
      stack = startStack
      accountForPotentialSkip()
    }
  }

  /**
   * Move the current point a bit forward in the line when it’s on a column
   * skip.
   *
   * @returns {void}
   */
  function accountForPotentialSkip() {
    if (point.line in columnStart && point.column < 2) {
      point.column = columnStart[point.line]
      point.offset += columnStart[point.line] - 1
    }
  }
}

/**
 * Get the chunks from a slice of chunks in the range of a token.
 *
 * @param {Array<Chunk>} chunks
 * @param {Pick<Token, 'end' | 'start'>} token
 * @returns {Array<Chunk>}
 */
function sliceChunks(chunks, token) {
  const startIndex = token.start._index
  const startBufferIndex = token.start._bufferIndex
  const endIndex = token.end._index
  const endBufferIndex = token.end._bufferIndex
  /** @type {Array<Chunk>} */
  let view
  if (startIndex === endIndex) {
    // @ts-expect-error `_bufferIndex` is used on string chunks.
    view = [chunks[startIndex].slice(startBufferIndex, endBufferIndex)]
  } else {
    view = chunks.slice(startIndex, endIndex)
    if (startBufferIndex > -1) {
      const head = view[0]
      if (typeof head === 'string') {
        view[0] = head.slice(startBufferIndex)
      } else {
        view.shift()
      }
    }
    if (endBufferIndex > 0) {
      // @ts-expect-error `_bufferIndex` is used on string chunks.
      view.push(chunks[endIndex].slice(0, endBufferIndex))
    }
  }
  return view
}

/**
 * Get the string value of a slice of chunks.
 *
 * @param {Array<Chunk>} chunks
 * @param {boolean | undefined} [expandTabs=false]
 * @returns {string}
 */
function serializeChunks(chunks, expandTabs) {
  let index = -1
  /** @type {Array<string>} */
  const result = []
  /** @type {boolean | undefined} */
  let atTab
  while (++index < chunks.length) {
    const chunk = chunks[index]
    /** @type {string} */
    let value
    if (typeof chunk === 'string') {
      value = chunk
    } else
      switch (chunk) {
        case -5: {
          value = '\r'
          break
        }
        case -4: {
          value = '\n'
          break
        }
        case -3: {
          value = '\r' + '\n'
          break
        }
        case -2: {
          value = expandTabs ? ' ' : '\t'
          break
        }
        case -1: {
          if (!expandTabs && atTab) continue
          value = ' '
          break
        }
        default: {
          // Currently only replacement character.
          value = String.fromCharCode(chunk)
        }
      }
    atTab = chunk === -2
    result.push(value)
  }
  return result.join('')
}

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/thematic-break.js
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */



/** @type {Construct} */
const thematicBreak = {
  name: 'thematicBreak',
  tokenize: tokenizeThematicBreak
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeThematicBreak(effects, ok, nok) {
  let size = 0
  /** @type {NonNullable<Code>} */
  let marker
  return start

  /**
   * Start of thematic break.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter('thematicBreak')
    // To do: parse indent like `markdown-rs`.
    return before(code)
  }

  /**
   * After optional whitespace, at marker.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */
  function before(code) {
    marker = code
    return atBreak(code)
  }

  /**
   * After something, before something else.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */
  function atBreak(code) {
    if (code === marker) {
      effects.enter('thematicBreakSequence')
      return sequence(code)
    }
    if (size >= 3 && (code === null || markdownLineEnding(code))) {
      effects.exit('thematicBreak')
      return ok(code)
    }
    return nok(code)
  }

  /**
   * In sequence.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */
  function sequence(code) {
    if (code === marker) {
      effects.consume(code)
      size++
      return sequence
    }
    effects.exit('thematicBreakSequence')
    return markdownSpace(code)
      ? factorySpace(effects, atBreak, 'whitespace')(code)
      : atBreak(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/list.js
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ContainerState} ContainerState
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */






/** @type {Construct} */
const list = {
  name: 'list',
  tokenize: tokenizeListStart,
  continuation: {
    tokenize: tokenizeListContinuation
  },
  exit: tokenizeListEnd
}

/** @type {Construct} */
const listItemPrefixWhitespaceConstruct = {
  tokenize: tokenizeListItemPrefixWhitespace,
  partial: true
}

/** @type {Construct} */
const indentConstruct = {
  tokenize: tokenizeIndent,
  partial: true
}

// To do: `markdown-rs` parses list items on their own and later stitches them
// together.

/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */
function tokenizeListStart(effects, ok, nok) {
  const self = this
  const tail = self.events[self.events.length - 1]
  let initialSize =
    tail && tail[1].type === 'linePrefix'
      ? tail[2].sliceSerialize(tail[1], true).length
      : 0
  let size = 0
  return start

  /** @type {State} */
  function start(code) {
    const kind =
      self.containerState.type ||
      (code === 42 || code === 43 || code === 45
        ? 'listUnordered'
        : 'listOrdered')
    if (
      kind === 'listUnordered'
        ? !self.containerState.marker || code === self.containerState.marker
        : asciiDigit(code)
    ) {
      if (!self.containerState.type) {
        self.containerState.type = kind
        effects.enter(kind, {
          _container: true
        })
      }
      if (kind === 'listUnordered') {
        effects.enter('listItemPrefix')
        return code === 42 || code === 45
          ? effects.check(thematicBreak, nok, atMarker)(code)
          : atMarker(code)
      }
      if (!self.interrupt || code === 49) {
        effects.enter('listItemPrefix')
        effects.enter('listItemValue')
        return inside(code)
      }
    }
    return nok(code)
  }

  /** @type {State} */
  function inside(code) {
    if (asciiDigit(code) && ++size < 10) {
      effects.consume(code)
      return inside
    }
    if (
      (!self.interrupt || size < 2) &&
      (self.containerState.marker
        ? code === self.containerState.marker
        : code === 41 || code === 46)
    ) {
      effects.exit('listItemValue')
      return atMarker(code)
    }
    return nok(code)
  }

  /**
   * @type {State}
   **/
  function atMarker(code) {
    effects.enter('listItemMarker')
    effects.consume(code)
    effects.exit('listItemMarker')
    self.containerState.marker = self.containerState.marker || code
    return effects.check(
      blankLine,
      // Can’t be empty when interrupting.
      self.interrupt ? nok : onBlank,
      effects.attempt(
        listItemPrefixWhitespaceConstruct,
        endOfPrefix,
        otherPrefix
      )
    )
  }

  /** @type {State} */
  function onBlank(code) {
    self.containerState.initialBlankLine = true
    initialSize++
    return endOfPrefix(code)
  }

  /** @type {State} */
  function otherPrefix(code) {
    if (markdownSpace(code)) {
      effects.enter('listItemPrefixWhitespace')
      effects.consume(code)
      effects.exit('listItemPrefixWhitespace')
      return endOfPrefix
    }
    return nok(code)
  }

  /** @type {State} */
  function endOfPrefix(code) {
    self.containerState.size =
      initialSize +
      self.sliceSerialize(effects.exit('listItemPrefix'), true).length
    return ok(code)
  }
}

/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */
function tokenizeListContinuation(effects, ok, nok) {
  const self = this
  self.containerState._closeFlow = undefined
  return effects.check(blankLine, onBlank, notBlank)

  /** @type {State} */
  function onBlank(code) {
    self.containerState.furtherBlankLines =
      self.containerState.furtherBlankLines ||
      self.containerState.initialBlankLine

    // We have a blank line.
    // Still, try to consume at most the items size.
    return factorySpace(
      effects,
      ok,
      'listItemIndent',
      self.containerState.size + 1
    )(code)
  }

  /** @type {State} */
  function notBlank(code) {
    if (self.containerState.furtherBlankLines || !markdownSpace(code)) {
      self.containerState.furtherBlankLines = undefined
      self.containerState.initialBlankLine = undefined
      return notInCurrentItem(code)
    }
    self.containerState.furtherBlankLines = undefined
    self.containerState.initialBlankLine = undefined
    return effects.attempt(indentConstruct, ok, notInCurrentItem)(code)
  }

  /** @type {State} */
  function notInCurrentItem(code) {
    // While we do continue, we signal that the flow should be closed.
    self.containerState._closeFlow = true
    // As we’re closing flow, we’re no longer interrupting.
    self.interrupt = undefined
    // Always populated by defaults.

    return factorySpace(
      effects,
      effects.attempt(list, ok, nok),
      'linePrefix',
      self.parser.constructs.disable.null.includes('codeIndented')
        ? undefined
        : 4
    )(code)
  }
}

/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */
function tokenizeIndent(effects, ok, nok) {
  const self = this
  return factorySpace(
    effects,
    afterPrefix,
    'listItemIndent',
    self.containerState.size + 1
  )

  /** @type {State} */
  function afterPrefix(code) {
    const tail = self.events[self.events.length - 1]
    return tail &&
      tail[1].type === 'listItemIndent' &&
      tail[2].sliceSerialize(tail[1], true).length === self.containerState.size
      ? ok(code)
      : nok(code)
  }
}

/**
 * @type {Exiter}
 * @this {TokenizeContext}
 */
function tokenizeListEnd(effects) {
  effects.exit(this.containerState.type)
}

/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */
function tokenizeListItemPrefixWhitespace(effects, ok, nok) {
  const self = this

  // Always populated by defaults.

  return factorySpace(
    effects,
    afterPrefix,
    'listItemPrefixWhitespace',
    self.parser.constructs.disable.null.includes('codeIndented')
      ? undefined
      : 4 + 1
  )

  /** @type {State} */
  function afterPrefix(code) {
    const tail = self.events[self.events.length - 1]
    return !markdownSpace(code) &&
      tail &&
      tail[1].type === 'listItemPrefixWhitespace'
      ? ok(code)
      : nok(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/block-quote.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */



/** @type {Construct} */
const blockQuote = {
  name: 'blockQuote',
  tokenize: tokenizeBlockQuoteStart,
  continuation: {
    tokenize: tokenizeBlockQuoteContinuation
  },
  exit
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeBlockQuoteStart(effects, ok, nok) {
  const self = this
  return start

  /**
   * Start of block quote.
   *
   * ```markdown
   * > | > a
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    if (code === 62) {
      const state = self.containerState
      if (!state.open) {
        effects.enter('blockQuote', {
          _container: true
        })
        state.open = true
      }
      effects.enter('blockQuotePrefix')
      effects.enter('blockQuoteMarker')
      effects.consume(code)
      effects.exit('blockQuoteMarker')
      return after
    }
    return nok(code)
  }

  /**
   * After `>`, before optional whitespace.
   *
   * ```markdown
   * > | > a
   *      ^
   * ```
   *
   * @type {State}
   */
  function after(code) {
    if (markdownSpace(code)) {
      effects.enter('blockQuotePrefixWhitespace')
      effects.consume(code)
      effects.exit('blockQuotePrefixWhitespace')
      effects.exit('blockQuotePrefix')
      return ok
    }
    effects.exit('blockQuotePrefix')
    return ok(code)
  }
}

/**
 * Start of block quote continuation.
 *
 * ```markdown
 *   | > a
 * > | > b
 *     ^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeBlockQuoteContinuation(effects, ok, nok) {
  const self = this
  return contStart

  /**
   * Start of block quote continuation.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */
  function contStart(code) {
    if (markdownSpace(code)) {
      // Always populated by defaults.

      return factorySpace(
        effects,
        contBefore,
        'linePrefix',
        self.parser.constructs.disable.null.includes('codeIndented')
          ? undefined
          : 4
      )(code)
    }
    return contBefore(code)
  }

  /**
   * At `>`, after optional whitespace.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */
  function contBefore(code) {
    return effects.attempt(blockQuote, ok, nok)(code)
  }
}

/** @type {Exiter} */
function exit(effects) {
  effects.exit('blockQuote')
}

;// CONCATENATED MODULE: ../node_modules/micromark-factory-destination/index.js
/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */


/**
 * Parse destinations.
 *
 * ###### Examples
 *
 * ```markdown
 * <a>
 * <a\>b>
 * <a b>
 * <a)>
 * a
 * a\)b
 * a(b)c
 * a(b)
 * ```
 *
 * @param {Effects} effects
 *   Context.
 * @param {State} ok
 *   State switched to when successful.
 * @param {State} nok
 *   State switched to when unsuccessful.
 * @param {TokenType} type
 *   Type for whole (`<a>` or `b`).
 * @param {TokenType} literalType
 *   Type when enclosed (`<a>`).
 * @param {TokenType} literalMarkerType
 *   Type for enclosing (`<` and `>`).
 * @param {TokenType} rawType
 *   Type when not enclosed (`b`).
 * @param {TokenType} stringType
 *   Type for the value (`a` or `b`).
 * @param {number | undefined} [max=Infinity]
 *   Depth of nested parens (inclusive).
 * @returns {State}
 *   Start state.
 */ // eslint-disable-next-line max-params
function factoryDestination(
  effects,
  ok,
  nok,
  type,
  literalType,
  literalMarkerType,
  rawType,
  stringType,
  max
) {
  const limit = max || Number.POSITIVE_INFINITY
  let balance = 0
  return start

  /**
   * Start of destination.
   *
   * ```markdown
   * > | <aa>
   *     ^
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    if (code === 60) {
      effects.enter(type)
      effects.enter(literalType)
      effects.enter(literalMarkerType)
      effects.consume(code)
      effects.exit(literalMarkerType)
      return enclosedBefore
    }

    // ASCII control, space, closing paren.
    if (code === null || code === 32 || code === 41 || asciiControl(code)) {
      return nok(code)
    }
    effects.enter(type)
    effects.enter(rawType)
    effects.enter(stringType)
    effects.enter('chunkString', {
      contentType: 'string'
    })
    return raw(code)
  }

  /**
   * After `<`, at an enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */
  function enclosedBefore(code) {
    if (code === 62) {
      effects.enter(literalMarkerType)
      effects.consume(code)
      effects.exit(literalMarkerType)
      effects.exit(literalType)
      effects.exit(type)
      return ok
    }
    effects.enter(stringType)
    effects.enter('chunkString', {
      contentType: 'string'
    })
    return enclosed(code)
  }

  /**
   * In enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */
  function enclosed(code) {
    if (code === 62) {
      effects.exit('chunkString')
      effects.exit(stringType)
      return enclosedBefore(code)
    }
    if (code === null || code === 60 || markdownLineEnding(code)) {
      return nok(code)
    }
    effects.consume(code)
    return code === 92 ? enclosedEscape : enclosed
  }

  /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | <a\*a>
   *        ^
   * ```
   *
   * @type {State}
   */
  function enclosedEscape(code) {
    if (code === 60 || code === 62 || code === 92) {
      effects.consume(code)
      return enclosed
    }
    return enclosed(code)
  }

  /**
   * In raw destination.
   *
   * ```markdown
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */
  function raw(code) {
    if (
      !balance &&
      (code === null || code === 41 || markdownLineEndingOrSpace(code))
    ) {
      effects.exit('chunkString')
      effects.exit(stringType)
      effects.exit(rawType)
      effects.exit(type)
      return ok(code)
    }
    if (balance < limit && code === 40) {
      effects.consume(code)
      balance++
      return raw
    }
    if (code === 41) {
      effects.consume(code)
      balance--
      return raw
    }

    // ASCII control (but *not* `\0`) and space and `(`.
    // Note: in `markdown-rs`, `\0` exists in codes, in `micromark-js` it
    // doesn’t.
    if (code === null || code === 32 || code === 40 || asciiControl(code)) {
      return nok(code)
    }
    effects.consume(code)
    return code === 92 ? rawEscape : raw
  }

  /**
   * After `\`, at special character.
   *
   * ```markdown
   * > | a\*a
   *       ^
   * ```
   *
   * @type {State}
   */
  function rawEscape(code) {
    if (code === 40 || code === 41 || code === 92) {
      effects.consume(code)
      return raw
    }
    return raw(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-factory-label/index.js
/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */


/**
 * Parse labels.
 *
 * > 👉 **Note**: labels in markdown are capped at 999 characters in the string.
 *
 * ###### Examples
 *
 * ```markdown
 * [a]
 * [a
 * b]
 * [a\]b]
 * ```
 *
 * @this {TokenizeContext}
 *   Tokenize context.
 * @param {Effects} effects
 *   Context.
 * @param {State} ok
 *   State switched to when successful.
 * @param {State} nok
 *   State switched to when unsuccessful.
 * @param {TokenType} type
 *   Type of the whole label (`[a]`).
 * @param {TokenType} markerType
 *   Type for the markers (`[` and `]`).
 * @param {TokenType} stringType
 *   Type for the identifier (`a`).
 * @returns {State}
 *   Start state.
 */ // eslint-disable-next-line max-params
function factoryLabel(effects, ok, nok, type, markerType, stringType) {
  const self = this
  let size = 0
  /** @type {boolean} */
  let seen
  return start

  /**
   * Start of label.
   *
   * ```markdown
   * > | [a]
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter(type)
    effects.enter(markerType)
    effects.consume(code)
    effects.exit(markerType)
    effects.enter(stringType)
    return atBreak
  }

  /**
   * In label, at something, before something else.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */
  function atBreak(code) {
    if (
      size > 999 ||
      code === null ||
      code === 91 ||
      (code === 93 && !seen) ||
      // To do: remove in the future once we’ve switched from
      // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
      // which doesn’t need this.
      // Hidden footnotes hook.
      /* c8 ignore next 3 */
      (code === 94 &&
        !size &&
        '_hiddenFootnoteSupport' in self.parser.constructs)
    ) {
      return nok(code)
    }
    if (code === 93) {
      effects.exit(stringType)
      effects.enter(markerType)
      effects.consume(code)
      effects.exit(markerType)
      effects.exit(type)
      return ok
    }

    // To do: indent? Link chunks and EOLs together?
    if (markdownLineEnding(code)) {
      effects.enter('lineEnding')
      effects.consume(code)
      effects.exit('lineEnding')
      return atBreak
    }
    effects.enter('chunkString', {
      contentType: 'string'
    })
    return labelInside(code)
  }

  /**
   * In label, in text.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */
  function labelInside(code) {
    if (
      code === null ||
      code === 91 ||
      code === 93 ||
      markdownLineEnding(code) ||
      size++ > 999
    ) {
      effects.exit('chunkString')
      return atBreak(code)
    }
    effects.consume(code)
    if (!seen) seen = !markdownSpace(code)
    return code === 92 ? labelEscape : labelInside
  }

  /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | [a\*a]
   *        ^
   * ```
   *
   * @type {State}
   */
  function labelEscape(code) {
    if (code === 91 || code === 92 || code === 93) {
      effects.consume(code)
      size++
      return labelInside
    }
    return labelInside(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-factory-title/index.js
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */



/**
 * Parse titles.
 *
 * ###### Examples
 *
 * ```markdown
 * "a"
 * 'b'
 * (c)
 * "a
 * b"
 * 'a
 *     b'
 * (a\)b)
 * ```
 *
 * @param {Effects} effects
 *   Context.
 * @param {State} ok
 *   State switched to when successful.
 * @param {State} nok
 *   State switched to when unsuccessful.
 * @param {TokenType} type
 *   Type of the whole title (`"a"`, `'b'`, `(c)`).
 * @param {TokenType} markerType
 *   Type for the markers (`"`, `'`, `(`, and `)`).
 * @param {TokenType} stringType
 *   Type for the value (`a`).
 * @returns {State}
 *   Start state.
 */ // eslint-disable-next-line max-params
function factoryTitle(effects, ok, nok, type, markerType, stringType) {
  /** @type {NonNullable<Code>} */
  let marker
  return start

  /**
   * Start of title.
   *
   * ```markdown
   * > | "a"
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    if (code === 34 || code === 39 || code === 40) {
      effects.enter(type)
      effects.enter(markerType)
      effects.consume(code)
      effects.exit(markerType)
      marker = code === 40 ? 41 : code
      return begin
    }
    return nok(code)
  }

  /**
   * After opening marker.
   *
   * This is also used at the closing marker.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */
  function begin(code) {
    if (code === marker) {
      effects.enter(markerType)
      effects.consume(code)
      effects.exit(markerType)
      effects.exit(type)
      return ok
    }
    effects.enter(stringType)
    return atBreak(code)
  }

  /**
   * At something, before something else.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */
  function atBreak(code) {
    if (code === marker) {
      effects.exit(stringType)
      return begin(marker)
    }
    if (code === null) {
      return nok(code)
    }

    // Note: blank lines can’t exist in content.
    if (markdownLineEnding(code)) {
      // To do: use `space_or_tab_eol_with_options`, connect.
      effects.enter('lineEnding')
      effects.consume(code)
      effects.exit('lineEnding')
      return factorySpace(effects, atBreak, 'linePrefix')
    }
    effects.enter('chunkString', {
      contentType: 'string'
    })
    return inside(code)
  }

  /**
   *
   *
   * @type {State}
   */
  function inside(code) {
    if (code === marker || code === null || markdownLineEnding(code)) {
      effects.exit('chunkString')
      return atBreak(code)
    }
    effects.consume(code)
    return code === 92 ? escape : inside
  }

  /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | "a\*b"
   *      ^
   * ```
   *
   * @type {State}
   */
  function escape(code) {
    if (code === marker || code === 92) {
      effects.consume(code)
      return inside
    }
    return inside(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-factory-whitespace/index.js
/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 */



/**
 * Parse spaces and tabs.
 *
 * There is no `nok` parameter:
 *
 * *   line endings or spaces in markdown are often optional, in which case this
 *     factory can be used and `ok` will be switched to whether spaces were found
 *     or not
 * *   one line ending or space can be detected with
 *     `markdownLineEndingOrSpace(code)` right before using `factoryWhitespace`
 *
 * @param {Effects} effects
 *   Context.
 * @param {State} ok
 *   State switched to when successful.
 * @returns
 *   Start state.
 */
function factoryWhitespace(effects, ok) {
  /** @type {boolean} */
  let seen
  return start

  /** @type {State} */
  function start(code) {
    if (markdownLineEnding(code)) {
      effects.enter('lineEnding')
      effects.consume(code)
      effects.exit('lineEnding')
      seen = true
      return start
    }
    if (markdownSpace(code)) {
      return factorySpace(
        effects,
        start,
        seen ? 'linePrefix' : 'lineSuffix'
      )(code)
    }
    return ok(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-util-normalize-identifier/index.js
/**
 * Normalize an identifier (as found in references, definitions).
 *
 * Collapses markdown whitespace, trim, and then lower- and uppercase.
 *
 * Some characters are considered “uppercase”, such as U+03F4 (`ϴ`), but if their
 * lowercase counterpart (U+03B8 (`θ`)) is uppercased will result in a different
 * uppercase character (U+0398 (`Θ`)).
 * So, to get a canonical form, we perform both lower- and uppercase.
 *
 * Using uppercase last makes sure keys will never interact with default
 * prototypal values (such as `constructor`): nothing in the prototype of
 * `Object` is uppercase.
 *
 * @param {string} value
 *   Identifier to normalize.
 * @returns {string}
 *   Normalized identifier.
 */
function normalizeIdentifier(value) {
  return (
    value
      // Collapse markdown whitespace.
      .replace(/[\t\n\r ]+/g, ' ')
      // Trim.
      .replace(/^ | $/g, '')
      // Some characters are considered “uppercase”, but if their lowercase
      // counterpart is uppercased will result in a different uppercase
      // character.
      // Hence, to get that form, we perform both lower- and uppercase.
      // Upper case makes sure keys will not interact with default prototypal
      // methods: no method is uppercase.
      .toLowerCase()
      .toUpperCase()
  )
}

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/definition.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */








/** @type {Construct} */
const definition = {
  name: 'definition',
  tokenize: tokenizeDefinition
}

/** @type {Construct} */
const titleBefore = {
  tokenize: tokenizeTitleBefore,
  partial: true
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeDefinition(effects, ok, nok) {
  const self = this
  /** @type {string} */
  let identifier
  return start

  /**
   * At start of a definition.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    // Do not interrupt paragraphs (but do follow definitions).
    // To do: do `interrupt` the way `markdown-rs` does.
    // To do: parse whitespace the way `markdown-rs` does.
    effects.enter('definition')
    return before(code)
  }

  /**
   * After optional whitespace, at `[`.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */
  function before(code) {
    // To do: parse whitespace the way `markdown-rs` does.

    return factoryLabel.call(
      self,
      effects,
      labelAfter,
      // Note: we don’t need to reset the way `markdown-rs` does.
      nok,
      'definitionLabel',
      'definitionLabelMarker',
      'definitionLabelString'
    )(code)
  }

  /**
   * After label.
   *
   * ```markdown
   * > | [a]: b "c"
   *        ^
   * ```
   *
   * @type {State}
   */
  function labelAfter(code) {
    identifier = normalizeIdentifier(
      self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1)
    )
    if (code === 58) {
      effects.enter('definitionMarker')
      effects.consume(code)
      effects.exit('definitionMarker')
      return markerAfter
    }
    return nok(code)
  }

  /**
   * After marker.
   *
   * ```markdown
   * > | [a]: b "c"
   *         ^
   * ```
   *
   * @type {State}
   */
  function markerAfter(code) {
    // Note: whitespace is optional.
    return markdownLineEndingOrSpace(code)
      ? factoryWhitespace(effects, destinationBefore)(code)
      : destinationBefore(code)
  }

  /**
   * Before destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *          ^
   * ```
   *
   * @type {State}
   */
  function destinationBefore(code) {
    return factoryDestination(
      effects,
      destinationAfter,
      // Note: we don’t need to reset the way `markdown-rs` does.
      nok,
      'definitionDestination',
      'definitionDestinationLiteral',
      'definitionDestinationLiteralMarker',
      'definitionDestinationRaw',
      'definitionDestinationString'
    )(code)
  }

  /**
   * After destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */
  function destinationAfter(code) {
    return effects.attempt(titleBefore, after, after)(code)
  }

  /**
   * After definition.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */
  function after(code) {
    return markdownSpace(code)
      ? factorySpace(effects, afterWhitespace, 'whitespace')(code)
      : afterWhitespace(code)
  }

  /**
   * After definition, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */
  function afterWhitespace(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit('definition')

      // Note: we don’t care about uniqueness.
      // It’s likely that that doesn’t happen very frequently.
      // It is more likely that it wastes precious time.
      self.parser.defined.push(identifier)

      // To do: `markdown-rs` interrupt.
      // // You’d be interrupting.
      // tokenizer.interrupt = true
      return ok(code)
    }
    return nok(code)
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeTitleBefore(effects, ok, nok) {
  return titleBefore

  /**
   * After destination, at whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */
  function titleBefore(code) {
    return markdownLineEndingOrSpace(code)
      ? factoryWhitespace(effects, beforeMarker)(code)
      : nok(code)
  }

  /**
   * At title.
   *
   * ```markdown
   *   | [a]: b
   * > | "c"
   *     ^
   * ```
   *
   * @type {State}
   */
  function beforeMarker(code) {
    return factoryTitle(
      effects,
      titleAfter,
      nok,
      'definitionTitle',
      'definitionTitleMarker',
      'definitionTitleString'
    )(code)
  }

  /**
   * After title.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */
  function titleAfter(code) {
    return markdownSpace(code)
      ? factorySpace(effects, titleAfterOptionalWhitespace, 'whitespace')(code)
      : titleAfterOptionalWhitespace(code)
  }

  /**
   * After title, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */
  function titleAfterOptionalWhitespace(code) {
    return code === null || markdownLineEnding(code) ? ok(code) : nok(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/code-indented.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */



/** @type {Construct} */
const codeIndented = {
  name: 'codeIndented',
  tokenize: tokenizeCodeIndented
}

/** @type {Construct} */
const furtherStart = {
  tokenize: tokenizeFurtherStart,
  partial: true
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeCodeIndented(effects, ok, nok) {
  const self = this
  return start

  /**
   * Start of code (indented).
   *
   * > **Parsing note**: it is not needed to check if this first line is a
   * > filled line (that it has a non-whitespace character), because blank lines
   * > are parsed already, so we never run into that.
   *
   * ```markdown
   * > |     aaa
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    // To do: manually check if interrupting like `markdown-rs`.

    effects.enter('codeIndented')
    // To do: use an improved `space_or_tab` function like `markdown-rs`,
    // so that we can drop the next state.
    return factorySpace(effects, afterPrefix, 'linePrefix', 4 + 1)(code)
  }

  /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */
  function afterPrefix(code) {
    const tail = self.events[self.events.length - 1]
    return tail &&
      tail[1].type === 'linePrefix' &&
      tail[2].sliceSerialize(tail[1], true).length >= 4
      ? atBreak(code)
      : nok(code)
  }

  /**
   * At a break.
   *
   * ```markdown
   * > |     aaa
   *         ^  ^
   * ```
   *
   * @type {State}
   */
  function atBreak(code) {
    if (code === null) {
      return after(code)
    }
    if (markdownLineEnding(code)) {
      return effects.attempt(furtherStart, atBreak, after)(code)
    }
    effects.enter('codeFlowValue')
    return inside(code)
  }

  /**
   * In code content.
   *
   * ```markdown
   * > |     aaa
   *         ^^^^
   * ```
   *
   * @type {State}
   */
  function inside(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit('codeFlowValue')
      return atBreak(code)
    }
    effects.consume(code)
    return inside
  }

  /** @type {State} */
  function after(code) {
    effects.exit('codeIndented')
    // To do: allow interrupting like `markdown-rs`.
    // Feel free to interrupt.
    // tokenizer.interrupt = false
    return ok(code)
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeFurtherStart(effects, ok, nok) {
  const self = this
  return furtherStart

  /**
   * At eol, trying to parse another indent.
   *
   * ```markdown
   * > |     aaa
   *            ^
   *   |     bbb
   * ```
   *
   * @type {State}
   */
  function furtherStart(code) {
    // To do: improve `lazy` / `pierce` handling.
    // If this is a lazy line, it can’t be code.
    if (self.parser.lazy[self.now().line]) {
      return nok(code)
    }
    if (markdownLineEnding(code)) {
      effects.enter('lineEnding')
      effects.consume(code)
      effects.exit('lineEnding')
      return furtherStart
    }

    // To do: the code here in `micromark-js` is a bit different from
    // `markdown-rs` because there it can attempt spaces.
    // We can’t yet.
    //
    // To do: use an improved `space_or_tab` function like `markdown-rs`,
    // so that we can drop the next state.
    return factorySpace(effects, afterPrefix, 'linePrefix', 4 + 1)(code)
  }

  /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */
  function afterPrefix(code) {
    const tail = self.events[self.events.length - 1]
    return tail &&
      tail[1].type === 'linePrefix' &&
      tail[2].sliceSerialize(tail[1], true).length >= 4
      ? ok(code)
      : markdownLineEnding(code)
      ? furtherStart(code)
      : nok(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/heading-atx.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */




/** @type {Construct} */
const headingAtx = {
  name: 'headingAtx',
  tokenize: tokenizeHeadingAtx,
  resolve: resolveHeadingAtx
}

/** @type {Resolver} */
function resolveHeadingAtx(events, context) {
  let contentEnd = events.length - 2
  let contentStart = 3
  /** @type {Token} */
  let content
  /** @type {Token} */
  let text

  // Prefix whitespace, part of the opening.
  if (events[contentStart][1].type === 'whitespace') {
    contentStart += 2
  }

  // Suffix whitespace, part of the closing.
  if (
    contentEnd - 2 > contentStart &&
    events[contentEnd][1].type === 'whitespace'
  ) {
    contentEnd -= 2
  }
  if (
    events[contentEnd][1].type === 'atxHeadingSequence' &&
    (contentStart === contentEnd - 1 ||
      (contentEnd - 4 > contentStart &&
        events[contentEnd - 2][1].type === 'whitespace'))
  ) {
    contentEnd -= contentStart + 1 === contentEnd ? 2 : 4
  }
  if (contentEnd > contentStart) {
    content = {
      type: 'atxHeadingText',
      start: events[contentStart][1].start,
      end: events[contentEnd][1].end
    }
    text = {
      type: 'chunkText',
      start: events[contentStart][1].start,
      end: events[contentEnd][1].end,
      contentType: 'text'
    }
    splice(events, contentStart, contentEnd - contentStart + 1, [
      ['enter', content, context],
      ['enter', text, context],
      ['exit', text, context],
      ['exit', content, context]
    ])
  }
  return events
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeHeadingAtx(effects, ok, nok) {
  let size = 0
  return start

  /**
   * Start of a heading (atx).
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    // To do: parse indent like `markdown-rs`.
    effects.enter('atxHeading')
    return before(code)
  }

  /**
   * After optional whitespace, at `#`.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */
  function before(code) {
    effects.enter('atxHeadingSequence')
    return sequenceOpen(code)
  }

  /**
   * In opening sequence.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */
  function sequenceOpen(code) {
    if (code === 35 && size++ < 6) {
      effects.consume(code)
      return sequenceOpen
    }

    // Always at least one `#`.
    if (code === null || markdownLineEndingOrSpace(code)) {
      effects.exit('atxHeadingSequence')
      return atBreak(code)
    }
    return nok(code)
  }

  /**
   * After something, before something else.
   *
   * ```markdown
   * > | ## aa
   *       ^
   * ```
   *
   * @type {State}
   */
  function atBreak(code) {
    if (code === 35) {
      effects.enter('atxHeadingSequence')
      return sequenceFurther(code)
    }
    if (code === null || markdownLineEnding(code)) {
      effects.exit('atxHeading')
      // To do: interrupt like `markdown-rs`.
      // // Feel free to interrupt.
      // tokenizer.interrupt = false
      return ok(code)
    }
    if (markdownSpace(code)) {
      return factorySpace(effects, atBreak, 'whitespace')(code)
    }

    // To do: generate `data` tokens, add the `text` token later.
    // Needs edit map, see: `markdown.rs`.
    effects.enter('atxHeadingText')
    return data(code)
  }

  /**
   * In further sequence (after whitespace).
   *
   * Could be normal “visible” hashes in the heading or a final sequence.
   *
   * ```markdown
   * > | ## aa ##
   *           ^
   * ```
   *
   * @type {State}
   */
  function sequenceFurther(code) {
    if (code === 35) {
      effects.consume(code)
      return sequenceFurther
    }
    effects.exit('atxHeadingSequence')
    return atBreak(code)
  }

  /**
   * In text.
   *
   * ```markdown
   * > | ## aa
   *        ^
   * ```
   *
   * @type {State}
   */
  function data(code) {
    if (code === null || code === 35 || markdownLineEndingOrSpace(code)) {
      effects.exit('atxHeadingText')
      return atBreak(code)
    }
    effects.consume(code)
    return data
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/setext-underline.js
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */



/** @type {Construct} */
const setextUnderline = {
  name: 'setextUnderline',
  tokenize: tokenizeSetextUnderline,
  resolveTo: resolveToSetextUnderline
}

/** @type {Resolver} */
function resolveToSetextUnderline(events, context) {
  // To do: resolve like `markdown-rs`.
  let index = events.length
  /** @type {number | undefined} */
  let content
  /** @type {number | undefined} */
  let text
  /** @type {number | undefined} */
  let definition

  // Find the opening of the content.
  // It’ll always exist: we don’t tokenize if it isn’t there.
  while (index--) {
    if (events[index][0] === 'enter') {
      if (events[index][1].type === 'content') {
        content = index
        break
      }
      if (events[index][1].type === 'paragraph') {
        text = index
      }
    }
    // Exit
    else {
      if (events[index][1].type === 'content') {
        // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1)
      }
      if (!definition && events[index][1].type === 'definition') {
        definition = index
      }
    }
  }
  const heading = {
    type: 'setextHeading',
    start: Object.assign({}, events[text][1].start),
    end: Object.assign({}, events[events.length - 1][1].end)
  }

  // Change the paragraph to setext heading text.
  events[text][1].type = 'setextHeadingText'

  // If we have definitions in the content, we’ll keep on having content,
  // but we need move it.
  if (definition) {
    events.splice(text, 0, ['enter', heading, context])
    events.splice(definition + 1, 0, ['exit', events[content][1], context])
    events[content][1].end = Object.assign({}, events[definition][1].end)
  } else {
    events[content][1] = heading
  }

  // Add the heading exit at the end.
  events.push(['exit', heading, context])
  return events
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeSetextUnderline(effects, ok, nok) {
  const self = this
  /** @type {NonNullable<Code>} */
  let marker
  return start

  /**
   * At start of heading (setext) underline.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    let index = self.events.length
    /** @type {boolean | undefined} */
    let paragraph
    // Find an opening.
    while (index--) {
      // Skip enter/exit of line ending, line prefix, and content.
      // We can now either have a definition or a paragraph.
      if (
        self.events[index][1].type !== 'lineEnding' &&
        self.events[index][1].type !== 'linePrefix' &&
        self.events[index][1].type !== 'content'
      ) {
        paragraph = self.events[index][1].type === 'paragraph'
        break
      }
    }

    // To do: handle lazy/pierce like `markdown-rs`.
    // To do: parse indent like `markdown-rs`.
    if (!self.parser.lazy[self.now().line] && (self.interrupt || paragraph)) {
      effects.enter('setextHeadingLine')
      marker = code
      return before(code)
    }
    return nok(code)
  }

  /**
   * After optional whitespace, at `-` or `=`.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */
  function before(code) {
    effects.enter('setextHeadingLineSequence')
    return inside(code)
  }

  /**
   * In sequence.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */
  function inside(code) {
    if (code === marker) {
      effects.consume(code)
      return inside
    }
    effects.exit('setextHeadingLineSequence')
    return markdownSpace(code)
      ? factorySpace(effects, after, 'lineSuffix')(code)
      : after(code)
  }

  /**
   * After sequence, after optional whitespace.
   *
   * ```markdown
   *   | aa
   * > | ==
   *       ^
   * ```
   *
   * @type {State}
   */
  function after(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit('setextHeadingLine')
      return ok(code)
    }
    return nok(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-util-html-tag-name/index.js
/**
 * List of lowercase HTML “block” tag names.
 *
 * The list, when parsing HTML (flow), results in more relaxed rules (condition
 * 6).
 * Because they are known blocks, the HTML-like syntax doesn’t have to be
 * strictly parsed.
 * For tag names not in this list, a more strict algorithm (condition 7) is used
 * to detect whether the HTML-like syntax is seen as HTML (flow) or not.
 *
 * This is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 *
 * > 👉 **Note**: `search` was added in `CommonMark@0.31`.
 */
const htmlBlockNames = [
  'address',
  'article',
  'aside',
  'base',
  'basefont',
  'blockquote',
  'body',
  'caption',
  'center',
  'col',
  'colgroup',
  'dd',
  'details',
  'dialog',
  'dir',
  'div',
  'dl',
  'dt',
  'fieldset',
  'figcaption',
  'figure',
  'footer',
  'form',
  'frame',
  'frameset',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'head',
  'header',
  'hr',
  'html',
  'iframe',
  'legend',
  'li',
  'link',
  'main',
  'menu',
  'menuitem',
  'nav',
  'noframes',
  'ol',
  'optgroup',
  'option',
  'p',
  'param',
  'search',
  'section',
  'summary',
  'table',
  'tbody',
  'td',
  'tfoot',
  'th',
  'thead',
  'title',
  'tr',
  'track',
  'ul'
]

/**
 * List of lowercase HTML “raw” tag names.
 *
 * The list, when parsing HTML (flow), results in HTML that can include lines
 * without exiting, until a closing tag also in this list is found (condition
 * 1).
 *
 * This module is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 *
 * > 👉 **Note**: `textarea` was added in `CommonMark@0.30`.
 */
const htmlRawNames = ['pre', 'script', 'style', 'textarea']

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/html-flow.js
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */





/** @type {Construct} */
const htmlFlow = {
  name: 'htmlFlow',
  tokenize: tokenizeHtmlFlow,
  resolveTo: resolveToHtmlFlow,
  concrete: true
}

/** @type {Construct} */
const blankLineBefore = {
  tokenize: tokenizeBlankLineBefore,
  partial: true
}
const nonLazyContinuationStart = {
  tokenize: tokenizeNonLazyContinuationStart,
  partial: true
}

/** @type {Resolver} */
function resolveToHtmlFlow(events) {
  let index = events.length
  while (index--) {
    if (events[index][0] === 'enter' && events[index][1].type === 'htmlFlow') {
      break
    }
  }
  if (index > 1 && events[index - 2][1].type === 'linePrefix') {
    // Add the prefix start to the HTML token.
    events[index][1].start = events[index - 2][1].start
    // Add the prefix start to the HTML line token.
    events[index + 1][1].start = events[index - 2][1].start
    // Remove the line prefix.
    events.splice(index - 2, 2)
  }
  return events
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeHtmlFlow(effects, ok, nok) {
  const self = this
  /** @type {number} */
  let marker
  /** @type {boolean} */
  let closingTag
  /** @type {string} */
  let buffer
  /** @type {number} */
  let index
  /** @type {Code} */
  let markerB
  return start

  /**
   * Start of HTML (flow).
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    // To do: parse indent like `markdown-rs`.
    return before(code)
  }

  /**
   * At `<`, after optional whitespace.
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */
  function before(code) {
    effects.enter('htmlFlow')
    effects.enter('htmlFlowData')
    effects.consume(code)
    return open
  }

  /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | <x />
   *      ^
   * > | <!doctype>
   *      ^
   * > | <!--xxx-->
   *      ^
   * ```
   *
   * @type {State}
   */
  function open(code) {
    if (code === 33) {
      effects.consume(code)
      return declarationOpen
    }
    if (code === 47) {
      effects.consume(code)
      closingTag = true
      return tagCloseStart
    }
    if (code === 63) {
      effects.consume(code)
      marker = 3
      // To do:
      // tokenizer.concrete = true
      // To do: use `markdown-rs` style interrupt.
      // While we’re in an instruction instead of a declaration, we’re on a `?`
      // right now, so we do need to search for `>`, similar to declarations.
      return self.interrupt ? ok : continuationDeclarationInside
    }

    // ASCII alphabetical.
    if (asciiAlpha(code)) {
      effects.consume(code)
      // @ts-expect-error: not null.
      buffer = String.fromCharCode(code)
      return tagName
    }
    return nok(code)
  }

  /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | <!doctype>
   *       ^
   * > | <!--xxx-->
   *       ^
   * > | <![CDATA[>&<]]>
   *       ^
   * ```
   *
   * @type {State}
   */
  function declarationOpen(code) {
    if (code === 45) {
      effects.consume(code)
      marker = 2
      return commentOpenInside
    }
    if (code === 91) {
      effects.consume(code)
      marker = 5
      index = 0
      return cdataOpenInside
    }

    // ASCII alphabetical.
    if (asciiAlpha(code)) {
      effects.consume(code)
      marker = 4
      // // Do not form containers.
      // tokenizer.concrete = true
      return self.interrupt ? ok : continuationDeclarationInside
    }
    return nok(code)
  }

  /**
   * After `<!-`, inside a comment, at another `-`.
   *
   * ```markdown
   * > | <!--xxx-->
   *        ^
   * ```
   *
   * @type {State}
   */
  function commentOpenInside(code) {
    if (code === 45) {
      effects.consume(code)
      // // Do not form containers.
      // tokenizer.concrete = true
      return self.interrupt ? ok : continuationDeclarationInside
    }
    return nok(code)
  }

  /**
   * After `<![`, inside CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *        ^^^^^^
   * ```
   *
   * @type {State}
   */
  function cdataOpenInside(code) {
    const value = 'CDATA['
    if (code === value.charCodeAt(index++)) {
      effects.consume(code)
      if (index === value.length) {
        // // Do not form containers.
        // tokenizer.concrete = true
        return self.interrupt ? ok : continuation
      }
      return cdataOpenInside
    }
    return nok(code)
  }

  /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | </x>
   *       ^
   * ```
   *
   * @type {State}
   */
  function tagCloseStart(code) {
    if (asciiAlpha(code)) {
      effects.consume(code)
      // @ts-expect-error: not null.
      buffer = String.fromCharCode(code)
      return tagName
    }
    return nok(code)
  }

  /**
   * In tag name.
   *
   * ```markdown
   * > | <ab>
   *      ^^
   * > | </ab>
   *       ^^
   * ```
   *
   * @type {State}
   */
  function tagName(code) {
    if (
      code === null ||
      code === 47 ||
      code === 62 ||
      markdownLineEndingOrSpace(code)
    ) {
      const slash = code === 47
      const name = buffer.toLowerCase()
      if (!slash && !closingTag && htmlRawNames.includes(name)) {
        marker = 1
        // // Do not form containers.
        // tokenizer.concrete = true
        return self.interrupt ? ok(code) : continuation(code)
      }
      if (htmlBlockNames.includes(buffer.toLowerCase())) {
        marker = 6
        if (slash) {
          effects.consume(code)
          return basicSelfClosing
        }

        // // Do not form containers.
        // tokenizer.concrete = true
        return self.interrupt ? ok(code) : continuation(code)
      }
      marker = 7
      // Do not support complete HTML when interrupting.
      return self.interrupt && !self.parser.lazy[self.now().line]
        ? nok(code)
        : closingTag
        ? completeClosingTagAfter(code)
        : completeAttributeNameBefore(code)
    }

    // ASCII alphanumerical and `-`.
    if (code === 45 || asciiAlphanumeric(code)) {
      effects.consume(code)
      buffer += String.fromCharCode(code)
      return tagName
    }
    return nok(code)
  }

  /**
   * After closing slash of a basic tag name.
   *
   * ```markdown
   * > | <div/>
   *          ^
   * ```
   *
   * @type {State}
   */
  function basicSelfClosing(code) {
    if (code === 62) {
      effects.consume(code)
      // // Do not form containers.
      // tokenizer.concrete = true
      return self.interrupt ? ok : continuation
    }
    return nok(code)
  }

  /**
   * After closing slash of a complete tag name.
   *
   * ```markdown
   * > | <x/>
   *        ^
   * ```
   *
   * @type {State}
   */
  function completeClosingTagAfter(code) {
    if (markdownSpace(code)) {
      effects.consume(code)
      return completeClosingTagAfter
    }
    return completeEnd(code)
  }

  /**
   * At an attribute name.
   *
   * At first, this state is used after a complete tag name, after whitespace,
   * where it expects optional attributes or the end of the tag.
   * It is also reused after attributes, when expecting more optional
   * attributes.
   *
   * ```markdown
   * > | <a />
   *        ^
   * > | <a :b>
   *        ^
   * > | <a _b>
   *        ^
   * > | <a b>
   *        ^
   * > | <a >
   *        ^
   * ```
   *
   * @type {State}
   */
  function completeAttributeNameBefore(code) {
    if (code === 47) {
      effects.consume(code)
      return completeEnd
    }

    // ASCII alphanumerical and `:` and `_`.
    if (code === 58 || code === 95 || asciiAlpha(code)) {
      effects.consume(code)
      return completeAttributeName
    }
    if (markdownSpace(code)) {
      effects.consume(code)
      return completeAttributeNameBefore
    }
    return completeEnd(code)
  }

  /**
   * In attribute name.
   *
   * ```markdown
   * > | <a :b>
   *         ^
   * > | <a _b>
   *         ^
   * > | <a b>
   *         ^
   * ```
   *
   * @type {State}
   */
  function completeAttributeName(code) {
    // ASCII alphanumerical and `-`, `.`, `:`, and `_`.
    if (
      code === 45 ||
      code === 46 ||
      code === 58 ||
      code === 95 ||
      asciiAlphanumeric(code)
    ) {
      effects.consume(code)
      return completeAttributeName
    }
    return completeAttributeNameAfter(code)
  }

  /**
   * After attribute name, at an optional initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | <a b>
   *         ^
   * > | <a b=c>
   *         ^
   * ```
   *
   * @type {State}
   */
  function completeAttributeNameAfter(code) {
    if (code === 61) {
      effects.consume(code)
      return completeAttributeValueBefore
    }
    if (markdownSpace(code)) {
      effects.consume(code)
      return completeAttributeNameAfter
    }
    return completeAttributeNameBefore(code)
  }

  /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * > | <a b="c">
   *          ^
   * ```
   *
   * @type {State}
   */
  function completeAttributeValueBefore(code) {
    if (
      code === null ||
      code === 60 ||
      code === 61 ||
      code === 62 ||
      code === 96
    ) {
      return nok(code)
    }
    if (code === 34 || code === 39) {
      effects.consume(code)
      markerB = code
      return completeAttributeValueQuoted
    }
    if (markdownSpace(code)) {
      effects.consume(code)
      return completeAttributeValueBefore
    }
    return completeAttributeValueUnquoted(code)
  }

  /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | <a b="c">
   *           ^
   * > | <a b='c'>
   *           ^
   * ```
   *
   * @type {State}
   */
  function completeAttributeValueQuoted(code) {
    if (code === markerB) {
      effects.consume(code)
      markerB = null
      return completeAttributeValueQuotedAfter
    }
    if (code === null || markdownLineEnding(code)) {
      return nok(code)
    }
    effects.consume(code)
    return completeAttributeValueQuoted
  }

  /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * ```
   *
   * @type {State}
   */
  function completeAttributeValueUnquoted(code) {
    if (
      code === null ||
      code === 34 ||
      code === 39 ||
      code === 47 ||
      code === 60 ||
      code === 61 ||
      code === 62 ||
      code === 96 ||
      markdownLineEndingOrSpace(code)
    ) {
      return completeAttributeNameAfter(code)
    }
    effects.consume(code)
    return completeAttributeValueUnquoted
  }

  /**
   * After double or single quoted attribute value, before whitespace or the
   * end of the tag.
   *
   * ```markdown
   * > | <a b="c">
   *            ^
   * ```
   *
   * @type {State}
   */
  function completeAttributeValueQuotedAfter(code) {
    if (code === 47 || code === 62 || markdownSpace(code)) {
      return completeAttributeNameBefore(code)
    }
    return nok(code)
  }

  /**
   * In certain circumstances of a complete tag where only an `>` is allowed.
   *
   * ```markdown
   * > | <a b="c">
   *             ^
   * ```
   *
   * @type {State}
   */
  function completeEnd(code) {
    if (code === 62) {
      effects.consume(code)
      return completeAfter
    }
    return nok(code)
  }

  /**
   * After `>` in a complete tag.
   *
   * ```markdown
   * > | <x>
   *        ^
   * ```
   *
   * @type {State}
   */
  function completeAfter(code) {
    if (code === null || markdownLineEnding(code)) {
      // // Do not form containers.
      // tokenizer.concrete = true
      return continuation(code)
    }
    if (markdownSpace(code)) {
      effects.consume(code)
      return completeAfter
    }
    return nok(code)
  }

  /**
   * In continuation of any HTML kind.
   *
   * ```markdown
   * > | <!--xxx-->
   *          ^
   * ```
   *
   * @type {State}
   */
  function continuation(code) {
    if (code === 45 && marker === 2) {
      effects.consume(code)
      return continuationCommentInside
    }
    if (code === 60 && marker === 1) {
      effects.consume(code)
      return continuationRawTagOpen
    }
    if (code === 62 && marker === 4) {
      effects.consume(code)
      return continuationClose
    }
    if (code === 63 && marker === 3) {
      effects.consume(code)
      return continuationDeclarationInside
    }
    if (code === 93 && marker === 5) {
      effects.consume(code)
      return continuationCdataInside
    }
    if (markdownLineEnding(code) && (marker === 6 || marker === 7)) {
      effects.exit('htmlFlowData')
      return effects.check(
        blankLineBefore,
        continuationAfter,
        continuationStart
      )(code)
    }
    if (code === null || markdownLineEnding(code)) {
      effects.exit('htmlFlowData')
      return continuationStart(code)
    }
    effects.consume(code)
    return continuation
  }

  /**
   * In continuation, at eol.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */
  function continuationStart(code) {
    return effects.check(
      nonLazyContinuationStart,
      continuationStartNonLazy,
      continuationAfter
    )(code)
  }

  /**
   * In continuation, at eol, before non-lazy content.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */
  function continuationStartNonLazy(code) {
    effects.enter('lineEnding')
    effects.consume(code)
    effects.exit('lineEnding')
    return continuationBefore
  }

  /**
   * In continuation, before non-lazy content.
   *
   * ```markdown
   *   | <x>
   * > | asd
   *     ^
   * ```
   *
   * @type {State}
   */
  function continuationBefore(code) {
    if (code === null || markdownLineEnding(code)) {
      return continuationStart(code)
    }
    effects.enter('htmlFlowData')
    return continuation(code)
  }

  /**
   * In comment continuation, after one `-`, expecting another.
   *
   * ```markdown
   * > | <!--xxx-->
   *             ^
   * ```
   *
   * @type {State}
   */
  function continuationCommentInside(code) {
    if (code === 45) {
      effects.consume(code)
      return continuationDeclarationInside
    }
    return continuation(code)
  }

  /**
   * In raw continuation, after `<`, at `/`.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                            ^
   * ```
   *
   * @type {State}
   */
  function continuationRawTagOpen(code) {
    if (code === 47) {
      effects.consume(code)
      buffer = ''
      return continuationRawEndTag
    }
    return continuation(code)
  }

  /**
   * In raw continuation, after `</`, in a raw tag name.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                             ^^^^^^
   * ```
   *
   * @type {State}
   */
  function continuationRawEndTag(code) {
    if (code === 62) {
      const name = buffer.toLowerCase()
      if (htmlRawNames.includes(name)) {
        effects.consume(code)
        return continuationClose
      }
      return continuation(code)
    }
    if (asciiAlpha(code) && buffer.length < 8) {
      effects.consume(code)
      // @ts-expect-error: not null.
      buffer += String.fromCharCode(code)
      return continuationRawEndTag
    }
    return continuation(code)
  }

  /**
   * In cdata continuation, after `]`, expecting `]>`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *                  ^
   * ```
   *
   * @type {State}
   */
  function continuationCdataInside(code) {
    if (code === 93) {
      effects.consume(code)
      return continuationDeclarationInside
    }
    return continuation(code)
  }

  /**
   * In declaration or instruction continuation, at `>`.
   *
   * ```markdown
   * > | <!-->
   *         ^
   * > | <?>
   *       ^
   * > | <!q>
   *        ^
   * > | <!--ab-->
   *             ^
   * > | <![CDATA[>&<]]>
   *                   ^
   * ```
   *
   * @type {State}
   */
  function continuationDeclarationInside(code) {
    if (code === 62) {
      effects.consume(code)
      return continuationClose
    }

    // More dashes.
    if (code === 45 && marker === 2) {
      effects.consume(code)
      return continuationDeclarationInside
    }
    return continuation(code)
  }

  /**
   * In closed continuation: everything we get until the eol/eof is part of it.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */
  function continuationClose(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit('htmlFlowData')
      return continuationAfter(code)
    }
    effects.consume(code)
    return continuationClose
  }

  /**
   * Done.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */
  function continuationAfter(code) {
    effects.exit('htmlFlow')
    // // Feel free to interrupt.
    // tokenizer.interrupt = false
    // // No longer concrete.
    // tokenizer.concrete = false
    return ok(code)
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeNonLazyContinuationStart(effects, ok, nok) {
  const self = this
  return start

  /**
   * At eol, before continuation.
   *
   * ```markdown
   * > | * ```js
   *            ^
   *   | b
   * ```
   *
   * @type {State}
   */
  function start(code) {
    if (markdownLineEnding(code)) {
      effects.enter('lineEnding')
      effects.consume(code)
      effects.exit('lineEnding')
      return after
    }
    return nok(code)
  }

  /**
   * A continuation.
   *
   * ```markdown
   *   | * ```js
   * > | b
   *     ^
   * ```
   *
   * @type {State}
   */
  function after(code) {
    return self.parser.lazy[self.now().line] ? nok(code) : ok(code)
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeBlankLineBefore(effects, ok, nok) {
  return start

  /**
   * Before eol, expecting blank line.
   *
   * ```markdown
   * > | <div>
   *          ^
   *   |
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter('lineEnding')
    effects.consume(code)
    effects.exit('lineEnding')
    return effects.attempt(blankLine, ok, nok)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/code-fenced.js
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */



/** @type {Construct} */
const nonLazyContinuation = {
  tokenize: tokenizeNonLazyContinuation,
  partial: true
}

/** @type {Construct} */
const codeFenced = {
  name: 'codeFenced',
  tokenize: tokenizeCodeFenced,
  concrete: true
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeCodeFenced(effects, ok, nok) {
  const self = this
  /** @type {Construct} */
  const closeStart = {
    tokenize: tokenizeCloseStart,
    partial: true
  }
  let initialPrefix = 0
  let sizeOpen = 0
  /** @type {NonNullable<Code>} */
  let marker
  return start

  /**
   * Start of code.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function start(code) {
    // To do: parse whitespace like `markdown-rs`.
    return beforeSequenceOpen(code)
  }

  /**
   * In opening fence, after prefix, at sequence.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function beforeSequenceOpen(code) {
    const tail = self.events[self.events.length - 1]
    initialPrefix =
      tail && tail[1].type === 'linePrefix'
        ? tail[2].sliceSerialize(tail[1], true).length
        : 0
    marker = code
    effects.enter('codeFenced')
    effects.enter('codeFencedFence')
    effects.enter('codeFencedFenceSequence')
    return sequenceOpen(code)
  }

  /**
   * In opening fence sequence.
   *
   * ```markdown
   * > | ~~~js
   *      ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function sequenceOpen(code) {
    if (code === marker) {
      sizeOpen++
      effects.consume(code)
      return sequenceOpen
    }
    if (sizeOpen < 3) {
      return nok(code)
    }
    effects.exit('codeFencedFenceSequence')
    return markdownSpace(code)
      ? factorySpace(effects, infoBefore, 'whitespace')(code)
      : infoBefore(code)
  }

  /**
   * In opening fence, after the sequence (and optional whitespace), before info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function infoBefore(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit('codeFencedFence')
      return self.interrupt
        ? ok(code)
        : effects.check(nonLazyContinuation, atNonLazyBreak, after)(code)
    }
    effects.enter('codeFencedFenceInfo')
    effects.enter('chunkString', {
      contentType: 'string'
    })
    return info(code)
  }

  /**
   * In info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function info(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit('chunkString')
      effects.exit('codeFencedFenceInfo')
      return infoBefore(code)
    }
    if (markdownSpace(code)) {
      effects.exit('chunkString')
      effects.exit('codeFencedFenceInfo')
      return factorySpace(effects, metaBefore, 'whitespace')(code)
    }
    if (code === 96 && code === marker) {
      return nok(code)
    }
    effects.consume(code)
    return info
  }

  /**
   * In opening fence, after info and whitespace, before meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function metaBefore(code) {
    if (code === null || markdownLineEnding(code)) {
      return infoBefore(code)
    }
    effects.enter('codeFencedFenceMeta')
    effects.enter('chunkString', {
      contentType: 'string'
    })
    return meta(code)
  }

  /**
   * In meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function meta(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit('chunkString')
      effects.exit('codeFencedFenceMeta')
      return infoBefore(code)
    }
    if (code === 96 && code === marker) {
      return nok(code)
    }
    effects.consume(code)
    return meta
  }

  /**
   * At eol/eof in code, before a non-lazy closing fence or content.
   *
   * ```markdown
   * > | ~~~js
   *          ^
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function atNonLazyBreak(code) {
    return effects.attempt(closeStart, after, contentBefore)(code)
  }

  /**
   * Before code content, not a closing fence, at eol.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function contentBefore(code) {
    effects.enter('lineEnding')
    effects.consume(code)
    effects.exit('lineEnding')
    return contentStart
  }

  /**
   * Before code content, not a closing fence.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function contentStart(code) {
    return initialPrefix > 0 && markdownSpace(code)
      ? factorySpace(
          effects,
          beforeContentChunk,
          'linePrefix',
          initialPrefix + 1
        )(code)
      : beforeContentChunk(code)
  }

  /**
   * Before code content, after optional prefix.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function beforeContentChunk(code) {
    if (code === null || markdownLineEnding(code)) {
      return effects.check(nonLazyContinuation, atNonLazyBreak, after)(code)
    }
    effects.enter('codeFlowValue')
    return contentChunk(code)
  }

  /**
   * In code content.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^^^^^^^^
   *   | ~~~
   * ```
   *
   * @type {State}
   */
  function contentChunk(code) {
    if (code === null || markdownLineEnding(code)) {
      effects.exit('codeFlowValue')
      return beforeContentChunk(code)
    }
    effects.consume(code)
    return contentChunk
  }

  /**
   * After code.
   *
   * ```markdown
   *   | ~~~js
   *   | alert(1)
   * > | ~~~
   *        ^
   * ```
   *
   * @type {State}
   */
  function after(code) {
    effects.exit('codeFenced')
    return ok(code)
  }

  /**
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */
  function tokenizeCloseStart(effects, ok, nok) {
    let size = 0
    return startBefore

    /**
     *
     *
     * @type {State}
     */
    function startBefore(code) {
      effects.enter('lineEnding')
      effects.consume(code)
      effects.exit('lineEnding')
      return start
    }

    /**
     * Before closing fence, at optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */
    function start(code) {
      // Always populated by defaults.

      // To do: `enter` here or in next state?
      effects.enter('codeFencedFence')
      return markdownSpace(code)
        ? factorySpace(
            effects,
            beforeSequenceClose,
            'linePrefix',
            self.parser.constructs.disable.null.includes('codeIndented')
              ? undefined
              : 4
          )(code)
        : beforeSequenceClose(code)
    }

    /**
     * In closing fence, after optional whitespace, at sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */
    function beforeSequenceClose(code) {
      if (code === marker) {
        effects.enter('codeFencedFenceSequence')
        return sequenceClose(code)
      }
      return nok(code)
    }

    /**
     * In closing fence sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */
    function sequenceClose(code) {
      if (code === marker) {
        size++
        effects.consume(code)
        return sequenceClose
      }
      if (size >= sizeOpen) {
        effects.exit('codeFencedFenceSequence')
        return markdownSpace(code)
          ? factorySpace(effects, sequenceCloseAfter, 'whitespace')(code)
          : sequenceCloseAfter(code)
      }
      return nok(code)
    }

    /**
     * After closing fence sequence, after optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *        ^
     * ```
     *
     * @type {State}
     */
    function sequenceCloseAfter(code) {
      if (code === null || markdownLineEnding(code)) {
        effects.exit('codeFencedFence')
        return ok(code)
      }
      return nok(code)
    }
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeNonLazyContinuation(effects, ok, nok) {
  const self = this
  return start

  /**
   *
   *
   * @type {State}
   */
  function start(code) {
    if (code === null) {
      return nok(code)
    }
    effects.enter('lineEnding')
    effects.consume(code)
    effects.exit('lineEnding')
    return lineStart
  }

  /**
   *
   *
   * @type {State}
   */
  function lineStart(code) {
    return self.parser.lazy[self.now().line] ? nok(code) : ok(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/decode-named-character-reference/index.dom.js
/// <reference lib="dom" />

/* eslint-env browser */

const index_dom_element = document.createElement('i')

/**
 * @param {string} value
 * @returns {string|false}
 */
function decodeNamedCharacterReference(value) {
  const characterReference = '&' + value + ';'
  index_dom_element.innerHTML = characterReference
  const char = index_dom_element.textContent

  // Some named character references do not require the closing semicolon
  // (`&not`, for instance), which leads to situations where parsing the assumed
  // named reference of `&notit;` will result in the string `¬it;`.
  // When we encounter a trailing semicolon after parsing, and the character
  // reference to decode was not a semicolon (`&semi;`), we can assume that the
  // matching was not complete.
  // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
  // yield `null`.
  if (char.charCodeAt(char.length - 1) === 59 /* `;` */ && value !== 'semi') {
    return false
  }

  // If the decoded string is equal to the input, the character reference was
  // not valid.
  // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
  // yield `null`.
  return char === characterReference ? false : char
}

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/character-reference.js
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */



/** @type {Construct} */
const characterReference = {
  name: 'characterReference',
  tokenize: tokenizeCharacterReference
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeCharacterReference(effects, ok, nok) {
  const self = this
  let size = 0
  /** @type {number} */
  let max
  /** @type {(code: Code) => boolean} */
  let test
  return start

  /**
   * Start of character reference.
   *
   * ```markdown
   * > | a&amp;b
   *      ^
   * > | a&#123;b
   *      ^
   * > | a&#x9;b
   *      ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter('characterReference')
    effects.enter('characterReferenceMarker')
    effects.consume(code)
    effects.exit('characterReferenceMarker')
    return open
  }

  /**
   * After `&`, at `#` for numeric references or alphanumeric for named
   * references.
   *
   * ```markdown
   * > | a&amp;b
   *       ^
   * > | a&#123;b
   *       ^
   * > | a&#x9;b
   *       ^
   * ```
   *
   * @type {State}
   */
  function open(code) {
    if (code === 35) {
      effects.enter('characterReferenceMarkerNumeric')
      effects.consume(code)
      effects.exit('characterReferenceMarkerNumeric')
      return numeric
    }
    effects.enter('characterReferenceValue')
    max = 31
    test = asciiAlphanumeric
    return value(code)
  }

  /**
   * After `#`, at `x` for hexadecimals or digit for decimals.
   *
   * ```markdown
   * > | a&#123;b
   *        ^
   * > | a&#x9;b
   *        ^
   * ```
   *
   * @type {State}
   */
  function numeric(code) {
    if (code === 88 || code === 120) {
      effects.enter('characterReferenceMarkerHexadecimal')
      effects.consume(code)
      effects.exit('characterReferenceMarkerHexadecimal')
      effects.enter('characterReferenceValue')
      max = 6
      test = asciiHexDigit
      return value
    }
    effects.enter('characterReferenceValue')
    max = 7
    test = asciiDigit
    return value(code)
  }

  /**
   * After markers (`&#x`, `&#`, or `&`), in value, before `;`.
   *
   * The character reference kind defines what and how many characters are
   * allowed.
   *
   * ```markdown
   * > | a&amp;b
   *       ^^^
   * > | a&#123;b
   *        ^^^
   * > | a&#x9;b
   *         ^
   * ```
   *
   * @type {State}
   */
  function value(code) {
    if (code === 59 && size) {
      const token = effects.exit('characterReferenceValue')
      if (
        test === asciiAlphanumeric &&
        !decodeNamedCharacterReference(self.sliceSerialize(token))
      ) {
        return nok(code)
      }

      // To do: `markdown-rs` uses a different name:
      // `CharacterReferenceMarkerSemi`.
      effects.enter('characterReferenceMarker')
      effects.consume(code)
      effects.exit('characterReferenceMarker')
      effects.exit('characterReference')
      return ok
    }
    if (test(code) && size++ < max) {
      effects.consume(code)
      return value
    }
    return nok(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/character-escape.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */


/** @type {Construct} */
const characterEscape = {
  name: 'characterEscape',
  tokenize: tokenizeCharacterEscape
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeCharacterEscape(effects, ok, nok) {
  return start

  /**
   * Start of character escape.
   *
   * ```markdown
   * > | a\*b
   *      ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter('characterEscape')
    effects.enter('escapeMarker')
    effects.consume(code)
    effects.exit('escapeMarker')
    return inside
  }

  /**
   * After `\`, at punctuation.
   *
   * ```markdown
   * > | a\*b
   *       ^
   * ```
   *
   * @type {State}
   */
  function inside(code) {
    // ASCII punctuation.
    if (asciiPunctuation(code)) {
      effects.enter('characterEscapeValue')
      effects.consume(code)
      effects.exit('characterEscapeValue')
      effects.exit('characterEscape')
      return ok
    }
    return nok(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/line-ending.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */



/** @type {Construct} */
const lineEnding = {
  name: 'lineEnding',
  tokenize: tokenizeLineEnding
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeLineEnding(effects, ok) {
  return start

  /** @type {State} */
  function start(code) {
    effects.enter('lineEnding')
    effects.consume(code)
    effects.exit('lineEnding')
    return factorySpace(effects, ok, 'linePrefix')
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/label-end.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */









/** @type {Construct} */
const labelEnd = {
  name: 'labelEnd',
  tokenize: tokenizeLabelEnd,
  resolveTo: resolveToLabelEnd,
  resolveAll: resolveAllLabelEnd
}

/** @type {Construct} */
const resourceConstruct = {
  tokenize: tokenizeResource
}
/** @type {Construct} */
const referenceFullConstruct = {
  tokenize: tokenizeReferenceFull
}
/** @type {Construct} */
const referenceCollapsedConstruct = {
  tokenize: tokenizeReferenceCollapsed
}

/** @type {Resolver} */
function resolveAllLabelEnd(events) {
  let index = -1
  while (++index < events.length) {
    const token = events[index][1]
    if (
      token.type === 'labelImage' ||
      token.type === 'labelLink' ||
      token.type === 'labelEnd'
    ) {
      // Remove the marker.
      events.splice(index + 1, token.type === 'labelImage' ? 4 : 2)
      token.type = 'data'
      index++
    }
  }
  return events
}

/** @type {Resolver} */
function resolveToLabelEnd(events, context) {
  let index = events.length
  let offset = 0
  /** @type {Token} */
  let token
  /** @type {number | undefined} */
  let open
  /** @type {number | undefined} */
  let close
  /** @type {Array<Event>} */
  let media

  // Find an opening.
  while (index--) {
    token = events[index][1]
    if (open) {
      // If we see another link, or inactive link label, we’ve been here before.
      if (
        token.type === 'link' ||
        (token.type === 'labelLink' && token._inactive)
      ) {
        break
      }

      // Mark other link openings as inactive, as we can’t have links in
      // links.
      if (events[index][0] === 'enter' && token.type === 'labelLink') {
        token._inactive = true
      }
    } else if (close) {
      if (
        events[index][0] === 'enter' &&
        (token.type === 'labelImage' || token.type === 'labelLink') &&
        !token._balanced
      ) {
        open = index
        if (token.type !== 'labelLink') {
          offset = 2
          break
        }
      }
    } else if (token.type === 'labelEnd') {
      close = index
    }
  }
  const group = {
    type: events[open][1].type === 'labelLink' ? 'link' : 'image',
    start: Object.assign({}, events[open][1].start),
    end: Object.assign({}, events[events.length - 1][1].end)
  }
  const label = {
    type: 'label',
    start: Object.assign({}, events[open][1].start),
    end: Object.assign({}, events[close][1].end)
  }
  const text = {
    type: 'labelText',
    start: Object.assign({}, events[open + offset + 2][1].end),
    end: Object.assign({}, events[close - 2][1].start)
  }
  media = [
    ['enter', group, context],
    ['enter', label, context]
  ]

  // Opening marker.
  media = push(media, events.slice(open + 1, open + offset + 3))

  // Text open.
  media = push(media, [['enter', text, context]])

  // Always populated by defaults.

  // Between.
  media = push(
    media,
    resolveAll(
      context.parser.constructs.insideSpan.null,
      events.slice(open + offset + 4, close - 3),
      context
    )
  )

  // Text close, marker close, label close.
  media = push(media, [
    ['exit', text, context],
    events[close - 2],
    events[close - 1],
    ['exit', label, context]
  ])

  // Reference, resource, or so.
  media = push(media, events.slice(close + 1))

  // Media close.
  media = push(media, [['exit', group, context]])
  splice(events, open, events.length, media)
  return events
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeLabelEnd(effects, ok, nok) {
  const self = this
  let index = self.events.length
  /** @type {Token} */
  let labelStart
  /** @type {boolean} */
  let defined

  // Find an opening.
  while (index--) {
    if (
      (self.events[index][1].type === 'labelImage' ||
        self.events[index][1].type === 'labelLink') &&
      !self.events[index][1]._balanced
    ) {
      labelStart = self.events[index][1]
      break
    }
  }
  return start

  /**
   * Start of label end.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   * ```
   *
   * @type {State}
   */
  function start(code) {
    // If there is not an okay opening.
    if (!labelStart) {
      return nok(code)
    }

    // If the corresponding label (link) start is marked as inactive,
    // it means we’d be wrapping a link, like this:
    //
    // ```markdown
    // > | a [b [c](d) e](f) g.
    //                  ^
    // ```
    //
    // We can’t have that, so it’s just balanced brackets.
    if (labelStart._inactive) {
      return labelEndNok(code)
    }
    defined = self.parser.defined.includes(
      normalizeIdentifier(
        self.sliceSerialize({
          start: labelStart.end,
          end: self.now()
        })
      )
    )
    effects.enter('labelEnd')
    effects.enter('labelMarker')
    effects.consume(code)
    effects.exit('labelMarker')
    effects.exit('labelEnd')
    return after
  }

  /**
   * After `]`.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   *       ^
   * ```
   *
   * @type {State}
   */
  function after(code) {
    // Note: `markdown-rs` also parses GFM footnotes here, which for us is in
    // an extension.

    // Resource (`[asd](fgh)`)?
    if (code === 40) {
      return effects.attempt(
        resourceConstruct,
        labelEndOk,
        defined ? labelEndOk : labelEndNok
      )(code)
    }

    // Full (`[asd][fgh]`) or collapsed (`[asd][]`) reference?
    if (code === 91) {
      return effects.attempt(
        referenceFullConstruct,
        labelEndOk,
        defined ? referenceNotFull : labelEndNok
      )(code)
    }

    // Shortcut (`[asd]`) reference?
    return defined ? labelEndOk(code) : labelEndNok(code)
  }

  /**
   * After `]`, at `[`, but not at a full reference.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] b
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */
  function referenceNotFull(code) {
    return effects.attempt(
      referenceCollapsedConstruct,
      labelEndOk,
      labelEndNok
    )(code)
  }

  /**
   * Done, we found something.
   *
   * ```markdown
   * > | [a](b) c
   *           ^
   * > | [a][b] c
   *           ^
   * > | [a][] b
   *          ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */
  function labelEndOk(code) {
    // Note: `markdown-rs` does a bunch of stuff here.
    return ok(code)
  }

  /**
   * Done, it’s nothing.
   *
   * There was an okay opening, but we didn’t match anything.
   *
   * ```markdown
   * > | [a](b c
   *        ^
   * > | [a][b c
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */
  function labelEndNok(code) {
    labelStart._balanced = true
    return nok(code)
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeResource(effects, ok, nok) {
  return resourceStart

  /**
   * At a resource.
   *
   * ```markdown
   * > | [a](b) c
   *        ^
   * ```
   *
   * @type {State}
   */
  function resourceStart(code) {
    effects.enter('resource')
    effects.enter('resourceMarker')
    effects.consume(code)
    effects.exit('resourceMarker')
    return resourceBefore
  }

  /**
   * In resource, after `(`, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */
  function resourceBefore(code) {
    return markdownLineEndingOrSpace(code)
      ? factoryWhitespace(effects, resourceOpen)(code)
      : resourceOpen(code)
  }

  /**
   * In resource, after optional whitespace, at `)` or a destination.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */
  function resourceOpen(code) {
    if (code === 41) {
      return resourceEnd(code)
    }
    return factoryDestination(
      effects,
      resourceDestinationAfter,
      resourceDestinationMissing,
      'resourceDestination',
      'resourceDestinationLiteral',
      'resourceDestinationLiteralMarker',
      'resourceDestinationRaw',
      'resourceDestinationString',
      32
    )(code)
  }

  /**
   * In resource, after destination, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *          ^
   * ```
   *
   * @type {State}
   */
  function resourceDestinationAfter(code) {
    return markdownLineEndingOrSpace(code)
      ? factoryWhitespace(effects, resourceBetween)(code)
      : resourceEnd(code)
  }

  /**
   * At invalid destination.
   *
   * ```markdown
   * > | [a](<<) b
   *         ^
   * ```
   *
   * @type {State}
   */
  function resourceDestinationMissing(code) {
    return nok(code)
  }

  /**
   * In resource, after destination and whitespace, at `(` or title.
   *
   * ```markdown
   * > | [a](b ) c
   *           ^
   * ```
   *
   * @type {State}
   */
  function resourceBetween(code) {
    if (code === 34 || code === 39 || code === 40) {
      return factoryTitle(
        effects,
        resourceTitleAfter,
        nok,
        'resourceTitle',
        'resourceTitleMarker',
        'resourceTitleString'
      )(code)
    }
    return resourceEnd(code)
  }

  /**
   * In resource, after title, at optional whitespace.
   *
   * ```markdown
   * > | [a](b "c") d
   *              ^
   * ```
   *
   * @type {State}
   */
  function resourceTitleAfter(code) {
    return markdownLineEndingOrSpace(code)
      ? factoryWhitespace(effects, resourceEnd)(code)
      : resourceEnd(code)
  }

  /**
   * In resource, at `)`.
   *
   * ```markdown
   * > | [a](b) d
   *          ^
   * ```
   *
   * @type {State}
   */
  function resourceEnd(code) {
    if (code === 41) {
      effects.enter('resourceMarker')
      effects.consume(code)
      effects.exit('resourceMarker')
      effects.exit('resource')
      return ok
    }
    return nok(code)
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeReferenceFull(effects, ok, nok) {
  const self = this
  return referenceFull

  /**
   * In a reference (full), at the `[`.
   *
   * ```markdown
   * > | [a][b] d
   *        ^
   * ```
   *
   * @type {State}
   */
  function referenceFull(code) {
    return factoryLabel.call(
      self,
      effects,
      referenceFullAfter,
      referenceFullMissing,
      'reference',
      'referenceMarker',
      'referenceString'
    )(code)
  }

  /**
   * In a reference (full), after `]`.
   *
   * ```markdown
   * > | [a][b] d
   *          ^
   * ```
   *
   * @type {State}
   */
  function referenceFullAfter(code) {
    return self.parser.defined.includes(
      normalizeIdentifier(
        self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1)
      )
    )
      ? ok(code)
      : nok(code)
  }

  /**
   * In reference (full) that was missing.
   *
   * ```markdown
   * > | [a][b d
   *        ^
   * ```
   *
   * @type {State}
   */
  function referenceFullMissing(code) {
    return nok(code)
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeReferenceCollapsed(effects, ok, nok) {
  return referenceCollapsedStart

  /**
   * In reference (collapsed), at `[`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *        ^
   * ```
   *
   * @type {State}
   */
  function referenceCollapsedStart(code) {
    // We only attempt a collapsed label if there’s a `[`.

    effects.enter('reference')
    effects.enter('referenceMarker')
    effects.consume(code)
    effects.exit('referenceMarker')
    return referenceCollapsedOpen
  }

  /**
   * In reference (collapsed), at `]`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *         ^
   * ```
   *
   *  @type {State}
   */
  function referenceCollapsedOpen(code) {
    if (code === 93) {
      effects.enter('referenceMarker')
      effects.consume(code)
      effects.exit('referenceMarker')
      effects.exit('reference')
      return ok
    }
    return nok(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/label-start-image.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */



/** @type {Construct} */
const labelStartImage = {
  name: 'labelStartImage',
  tokenize: tokenizeLabelStartImage,
  resolveAll: labelEnd.resolveAll
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeLabelStartImage(effects, ok, nok) {
  const self = this
  return start

  /**
   * Start of label (image) start.
   *
   * ```markdown
   * > | a ![b] c
   *       ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter('labelImage')
    effects.enter('labelImageMarker')
    effects.consume(code)
    effects.exit('labelImageMarker')
    return open
  }

  /**
   * After `!`, at `[`.
   *
   * ```markdown
   * > | a ![b] c
   *        ^
   * ```
   *
   * @type {State}
   */
  function open(code) {
    if (code === 91) {
      effects.enter('labelMarker')
      effects.consume(code)
      effects.exit('labelMarker')
      effects.exit('labelImage')
      return after
    }
    return nok(code)
  }

  /**
   * After `![`.
   *
   * ```markdown
   * > | a ![b] c
   *         ^
   * ```
   *
   * This is needed in because, when GFM footnotes are enabled, images never
   * form when started with a `^`.
   * Instead, links form:
   *
   * ```markdown
   * ![^a](b)
   *
   * ![^a][b]
   *
   * [b]: c
   * ```
   *
   * ```html
   * <p>!<a href=\"b\">^a</a></p>
   * <p>!<a href=\"c\">^a</a></p>
   * ```
   *
   * @type {State}
   */
  function after(code) {
    // To do: use a new field to do this, this is still needed for
    // `micromark-extension-gfm-footnote`, but the `label-start-link`
    // behavior isn’t.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs
      ? nok(code)
      : ok(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-util-classify-character/index.js
/**
 * @typedef {import('micromark-util-types').Code} Code
 */


/**
 * Classify whether a code represents whitespace, punctuation, or something
 * else.
 *
 * Used for attention (emphasis, strong), whose sequences can open or close
 * based on the class of surrounding characters.
 *
 * > 👉 **Note**: eof (`null`) is seen as whitespace.
 *
 * @param {Code} code
 *   Code.
 * @returns {typeof constants.characterGroupWhitespace | typeof constants.characterGroupPunctuation | undefined}
 *   Group.
 */
function classifyCharacter(code) {
  if (
    code === null ||
    markdownLineEndingOrSpace(code) ||
    unicodeWhitespace(code)
  ) {
    return 1
  }
  if (unicodePunctuation(code)) {
    return 2
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/attention.js
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */




/** @type {Construct} */
const attention = {
  name: 'attention',
  tokenize: tokenizeAttention,
  resolveAll: resolveAllAttention
}

/**
 * Take all events and resolve attention to emphasis or strong.
 *
 * @type {Resolver}
 */
function resolveAllAttention(events, context) {
  let index = -1
  /** @type {number} */
  let open
  /** @type {Token} */
  let group
  /** @type {Token} */
  let text
  /** @type {Token} */
  let openingSequence
  /** @type {Token} */
  let closingSequence
  /** @type {number} */
  let use
  /** @type {Array<Event>} */
  let nextEvents
  /** @type {number} */
  let offset

  // Walk through all events.
  //
  // Note: performance of this is fine on an mb of normal markdown, but it’s
  // a bottleneck for malicious stuff.
  while (++index < events.length) {
    // Find a token that can close.
    if (
      events[index][0] === 'enter' &&
      events[index][1].type === 'attentionSequence' &&
      events[index][1]._close
    ) {
      open = index

      // Now walk back to find an opener.
      while (open--) {
        // Find a token that can open the closer.
        if (
          events[open][0] === 'exit' &&
          events[open][1].type === 'attentionSequence' &&
          events[open][1]._open &&
          // If the markers are the same:
          context.sliceSerialize(events[open][1]).charCodeAt(0) ===
            context.sliceSerialize(events[index][1]).charCodeAt(0)
        ) {
          // If the opening can close or the closing can open,
          // and the close size *is not* a multiple of three,
          // but the sum of the opening and closing size *is* multiple of three,
          // then don’t match.
          if (
            (events[open][1]._close || events[index][1]._open) &&
            (events[index][1].end.offset - events[index][1].start.offset) % 3 &&
            !(
              (events[open][1].end.offset -
                events[open][1].start.offset +
                events[index][1].end.offset -
                events[index][1].start.offset) %
              3
            )
          ) {
            continue
          }

          // Number of markers to use from the sequence.
          use =
            events[open][1].end.offset - events[open][1].start.offset > 1 &&
            events[index][1].end.offset - events[index][1].start.offset > 1
              ? 2
              : 1
          const start = Object.assign({}, events[open][1].end)
          const end = Object.assign({}, events[index][1].start)
          movePoint(start, -use)
          movePoint(end, use)
          openingSequence = {
            type: use > 1 ? 'strongSequence' : 'emphasisSequence',
            start,
            end: Object.assign({}, events[open][1].end)
          }
          closingSequence = {
            type: use > 1 ? 'strongSequence' : 'emphasisSequence',
            start: Object.assign({}, events[index][1].start),
            end
          }
          text = {
            type: use > 1 ? 'strongText' : 'emphasisText',
            start: Object.assign({}, events[open][1].end),
            end: Object.assign({}, events[index][1].start)
          }
          group = {
            type: use > 1 ? 'strong' : 'emphasis',
            start: Object.assign({}, openingSequence.start),
            end: Object.assign({}, closingSequence.end)
          }
          events[open][1].end = Object.assign({}, openingSequence.start)
          events[index][1].start = Object.assign({}, closingSequence.end)
          nextEvents = []

          // If there are more markers in the opening, add them before.
          if (events[open][1].end.offset - events[open][1].start.offset) {
            nextEvents = push(nextEvents, [
              ['enter', events[open][1], context],
              ['exit', events[open][1], context]
            ])
          }

          // Opening.
          nextEvents = push(nextEvents, [
            ['enter', group, context],
            ['enter', openingSequence, context],
            ['exit', openingSequence, context],
            ['enter', text, context]
          ])

          // Always populated by defaults.

          // Between.
          nextEvents = push(
            nextEvents,
            resolveAll(
              context.parser.constructs.insideSpan.null,
              events.slice(open + 1, index),
              context
            )
          )

          // Closing.
          nextEvents = push(nextEvents, [
            ['exit', text, context],
            ['enter', closingSequence, context],
            ['exit', closingSequence, context],
            ['exit', group, context]
          ])

          // If there are more markers in the closing, add them after.
          if (events[index][1].end.offset - events[index][1].start.offset) {
            offset = 2
            nextEvents = push(nextEvents, [
              ['enter', events[index][1], context],
              ['exit', events[index][1], context]
            ])
          } else {
            offset = 0
          }
          splice(events, open - 1, index - open + 3, nextEvents)
          index = open + nextEvents.length - offset - 2
          break
        }
      }
    }
  }

  // Remove remaining sequences.
  index = -1
  while (++index < events.length) {
    if (events[index][1].type === 'attentionSequence') {
      events[index][1].type = 'data'
    }
  }
  return events
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeAttention(effects, ok) {
  const attentionMarkers = this.parser.constructs.attentionMarkers.null
  const previous = this.previous
  const before = classifyCharacter(previous)

  /** @type {NonNullable<Code>} */
  let marker
  return start

  /**
   * Before a sequence.
   *
   * ```markdown
   * > | **
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    marker = code
    effects.enter('attentionSequence')
    return inside(code)
  }

  /**
   * In a sequence.
   *
   * ```markdown
   * > | **
   *     ^^
   * ```
   *
   * @type {State}
   */
  function inside(code) {
    if (code === marker) {
      effects.consume(code)
      return inside
    }
    const token = effects.exit('attentionSequence')

    // To do: next major: move this to resolver, just like `markdown-rs`.
    const after = classifyCharacter(code)

    // Always populated by defaults.

    const open =
      !after || (after === 2 && before) || attentionMarkers.includes(code)
    const close =
      !before || (before === 2 && after) || attentionMarkers.includes(previous)
    token._open = Boolean(marker === 42 ? open : open && (before || !close))
    token._close = Boolean(marker === 42 ? close : close && (after || !open))
    return ok(code)
  }
}

/**
 * Move a point a bit.
 *
 * Note: `move` only works inside lines! It’s not possible to move past other
 * chunks (replacement characters, tabs, or line endings).
 *
 * @param {Point} point
 * @param {number} offset
 * @returns {void}
 */
function movePoint(point, offset) {
  point.column += offset
  point.offset += offset
  point._bufferIndex += offset
}

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/autolink.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */


/** @type {Construct} */
const autolink = {
  name: 'autolink',
  tokenize: tokenizeAutolink
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeAutolink(effects, ok, nok) {
  let size = 0
  return start

  /**
   * Start of an autolink.
   *
   * ```markdown
   * > | a<https://example.com>b
   *      ^
   * > | a<user@example.com>b
   *      ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter('autolink')
    effects.enter('autolinkMarker')
    effects.consume(code)
    effects.exit('autolinkMarker')
    effects.enter('autolinkProtocol')
    return open
  }

  /**
   * After `<`, at protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *       ^
   * > | a<user@example.com>b
   *       ^
   * ```
   *
   * @type {State}
   */
  function open(code) {
    if (asciiAlpha(code)) {
      effects.consume(code)
      return schemeOrEmailAtext
    }
    return emailAtext(code)
  }

  /**
   * At second byte of protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */
  function schemeOrEmailAtext(code) {
    // ASCII alphanumeric and `+`, `-`, and `.`.
    if (code === 43 || code === 45 || code === 46 || asciiAlphanumeric(code)) {
      // Count the previous alphabetical from `open` too.
      size = 1
      return schemeInsideOrEmailAtext(code)
    }
    return emailAtext(code)
  }

  /**
   * In ambiguous protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */
  function schemeInsideOrEmailAtext(code) {
    if (code === 58) {
      effects.consume(code)
      size = 0
      return urlInside
    }

    // ASCII alphanumeric and `+`, `-`, and `.`.
    if (
      (code === 43 || code === 45 || code === 46 || asciiAlphanumeric(code)) &&
      size++ < 32
    ) {
      effects.consume(code)
      return schemeInsideOrEmailAtext
    }
    size = 0
    return emailAtext(code)
  }

  /**
   * After protocol, in URL.
   *
   * ```markdown
   * > | a<https://example.com>b
   *             ^
   * ```
   *
   * @type {State}
   */
  function urlInside(code) {
    if (code === 62) {
      effects.exit('autolinkProtocol')
      effects.enter('autolinkMarker')
      effects.consume(code)
      effects.exit('autolinkMarker')
      effects.exit('autolink')
      return ok
    }

    // ASCII control, space, or `<`.
    if (code === null || code === 32 || code === 60 || asciiControl(code)) {
      return nok(code)
    }
    effects.consume(code)
    return urlInside
  }

  /**
   * In email atext.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *              ^
   * ```
   *
   * @type {State}
   */
  function emailAtext(code) {
    if (code === 64) {
      effects.consume(code)
      return emailAtSignOrDot
    }
    if (asciiAtext(code)) {
      effects.consume(code)
      return emailAtext
    }
    return nok(code)
  }

  /**
   * In label, after at-sign or dot.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                 ^       ^
   * ```
   *
   * @type {State}
   */
  function emailAtSignOrDot(code) {
    return asciiAlphanumeric(code) ? emailLabel(code) : nok(code)
  }

  /**
   * In label, where `.` and `>` are allowed.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                   ^
   * ```
   *
   * @type {State}
   */
  function emailLabel(code) {
    if (code === 46) {
      effects.consume(code)
      size = 0
      return emailAtSignOrDot
    }
    if (code === 62) {
      // Exit, then change the token type.
      effects.exit('autolinkProtocol').type = 'autolinkEmail'
      effects.enter('autolinkMarker')
      effects.consume(code)
      effects.exit('autolinkMarker')
      effects.exit('autolink')
      return ok
    }
    return emailValue(code)
  }

  /**
   * In label, where `.` and `>` are *not* allowed.
   *
   * Though, this is also used in `emailLabel` to parse other values.
   *
   * ```markdown
   * > | a<user.name@ex-ample.com>b
   *                    ^
   * ```
   *
   * @type {State}
   */
  function emailValue(code) {
    // ASCII alphanumeric or `-`.
    if ((code === 45 || asciiAlphanumeric(code)) && size++ < 63) {
      const next = code === 45 ? emailValue : emailLabel
      effects.consume(code)
      return next
    }
    return nok(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/html-text.js
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */



/** @type {Construct} */
const htmlText = {
  name: 'htmlText',
  tokenize: tokenizeHtmlText
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeHtmlText(effects, ok, nok) {
  const self = this
  /** @type {NonNullable<Code> | undefined} */
  let marker
  /** @type {number} */
  let index
  /** @type {State} */
  let returnState
  return start

  /**
   * Start of HTML (text).
   *
   * ```markdown
   * > | a <b> c
   *       ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter('htmlText')
    effects.enter('htmlTextData')
    effects.consume(code)
    return open
  }

  /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | a <b> c
   *        ^
   * > | a <!doctype> c
   *        ^
   * > | a <!--b--> c
   *        ^
   * ```
   *
   * @type {State}
   */
  function open(code) {
    if (code === 33) {
      effects.consume(code)
      return declarationOpen
    }
    if (code === 47) {
      effects.consume(code)
      return tagCloseStart
    }
    if (code === 63) {
      effects.consume(code)
      return instruction
    }

    // ASCII alphabetical.
    if (asciiAlpha(code)) {
      effects.consume(code)
      return tagOpen
    }
    return nok(code)
  }

  /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | a <!doctype> c
   *         ^
   * > | a <!--b--> c
   *         ^
   * > | a <![CDATA[>&<]]> c
   *         ^
   * ```
   *
   * @type {State}
   */
  function declarationOpen(code) {
    if (code === 45) {
      effects.consume(code)
      return commentOpenInside
    }
    if (code === 91) {
      effects.consume(code)
      index = 0
      return cdataOpenInside
    }
    if (asciiAlpha(code)) {
      effects.consume(code)
      return declaration
    }
    return nok(code)
  }

  /**
   * In a comment, after `<!-`, at another `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *          ^
   * ```
   *
   * @type {State}
   */
  function commentOpenInside(code) {
    if (code === 45) {
      effects.consume(code)
      return commentEnd
    }
    return nok(code)
  }

  /**
   * In comment.
   *
   * ```markdown
   * > | a <!--b--> c
   *           ^
   * ```
   *
   * @type {State}
   */
  function comment(code) {
    if (code === null) {
      return nok(code)
    }
    if (code === 45) {
      effects.consume(code)
      return commentClose
    }
    if (markdownLineEnding(code)) {
      returnState = comment
      return lineEndingBefore(code)
    }
    effects.consume(code)
    return comment
  }

  /**
   * In comment, after `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *             ^
   * ```
   *
   * @type {State}
   */
  function commentClose(code) {
    if (code === 45) {
      effects.consume(code)
      return commentEnd
    }
    return comment(code)
  }

  /**
   * In comment, after `--`.
   *
   * ```markdown
   * > | a <!--b--> c
   *              ^
   * ```
   *
   * @type {State}
   */
  function commentEnd(code) {
    return code === 62
      ? end(code)
      : code === 45
      ? commentClose(code)
      : comment(code)
  }

  /**
   * After `<![`, in CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *          ^^^^^^
   * ```
   *
   * @type {State}
   */
  function cdataOpenInside(code) {
    const value = 'CDATA['
    if (code === value.charCodeAt(index++)) {
      effects.consume(code)
      return index === value.length ? cdata : cdataOpenInside
    }
    return nok(code)
  }

  /**
   * In CDATA.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                ^^^
   * ```
   *
   * @type {State}
   */
  function cdata(code) {
    if (code === null) {
      return nok(code)
    }
    if (code === 93) {
      effects.consume(code)
      return cdataClose
    }
    if (markdownLineEnding(code)) {
      returnState = cdata
      return lineEndingBefore(code)
    }
    effects.consume(code)
    return cdata
  }

  /**
   * In CDATA, after `]`, at another `]`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                    ^
   * ```
   *
   * @type {State}
   */
  function cdataClose(code) {
    if (code === 93) {
      effects.consume(code)
      return cdataEnd
    }
    return cdata(code)
  }

  /**
   * In CDATA, after `]]`, at `>`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                     ^
   * ```
   *
   * @type {State}
   */
  function cdataEnd(code) {
    if (code === 62) {
      return end(code)
    }
    if (code === 93) {
      effects.consume(code)
      return cdataEnd
    }
    return cdata(code)
  }

  /**
   * In declaration.
   *
   * ```markdown
   * > | a <!b> c
   *          ^
   * ```
   *
   * @type {State}
   */
  function declaration(code) {
    if (code === null || code === 62) {
      return end(code)
    }
    if (markdownLineEnding(code)) {
      returnState = declaration
      return lineEndingBefore(code)
    }
    effects.consume(code)
    return declaration
  }

  /**
   * In instruction.
   *
   * ```markdown
   * > | a <?b?> c
   *         ^
   * ```
   *
   * @type {State}
   */
  function instruction(code) {
    if (code === null) {
      return nok(code)
    }
    if (code === 63) {
      effects.consume(code)
      return instructionClose
    }
    if (markdownLineEnding(code)) {
      returnState = instruction
      return lineEndingBefore(code)
    }
    effects.consume(code)
    return instruction
  }

  /**
   * In instruction, after `?`, at `>`.
   *
   * ```markdown
   * > | a <?b?> c
   *           ^
   * ```
   *
   * @type {State}
   */
  function instructionClose(code) {
    return code === 62 ? end(code) : instruction(code)
  }

  /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | a </b> c
   *         ^
   * ```
   *
   * @type {State}
   */
  function tagCloseStart(code) {
    // ASCII alphabetical.
    if (asciiAlpha(code)) {
      effects.consume(code)
      return tagClose
    }
    return nok(code)
  }

  /**
   * After `</x`, in a tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */
  function tagClose(code) {
    // ASCII alphanumerical and `-`.
    if (code === 45 || asciiAlphanumeric(code)) {
      effects.consume(code)
      return tagClose
    }
    return tagCloseBetween(code)
  }

  /**
   * In closing tag, after tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */
  function tagCloseBetween(code) {
    if (markdownLineEnding(code)) {
      returnState = tagCloseBetween
      return lineEndingBefore(code)
    }
    if (markdownSpace(code)) {
      effects.consume(code)
      return tagCloseBetween
    }
    return end(code)
  }

  /**
   * After `<x`, in opening tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */
  function tagOpen(code) {
    // ASCII alphanumerical and `-`.
    if (code === 45 || asciiAlphanumeric(code)) {
      effects.consume(code)
      return tagOpen
    }
    if (code === 47 || code === 62 || markdownLineEndingOrSpace(code)) {
      return tagOpenBetween(code)
    }
    return nok(code)
  }

  /**
   * In opening tag, after tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */
  function tagOpenBetween(code) {
    if (code === 47) {
      effects.consume(code)
      return end
    }

    // ASCII alphabetical and `:` and `_`.
    if (code === 58 || code === 95 || asciiAlpha(code)) {
      effects.consume(code)
      return tagOpenAttributeName
    }
    if (markdownLineEnding(code)) {
      returnState = tagOpenBetween
      return lineEndingBefore(code)
    }
    if (markdownSpace(code)) {
      effects.consume(code)
      return tagOpenBetween
    }
    return end(code)
  }

  /**
   * In attribute name.
   *
   * ```markdown
   * > | a <b c> d
   *          ^
   * ```
   *
   * @type {State}
   */
  function tagOpenAttributeName(code) {
    // ASCII alphabetical and `-`, `.`, `:`, and `_`.
    if (
      code === 45 ||
      code === 46 ||
      code === 58 ||
      code === 95 ||
      asciiAlphanumeric(code)
    ) {
      effects.consume(code)
      return tagOpenAttributeName
    }
    return tagOpenAttributeNameAfter(code)
  }

  /**
   * After attribute name, before initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | a <b c> d
   *           ^
   * ```
   *
   * @type {State}
   */
  function tagOpenAttributeNameAfter(code) {
    if (code === 61) {
      effects.consume(code)
      return tagOpenAttributeValueBefore
    }
    if (markdownLineEnding(code)) {
      returnState = tagOpenAttributeNameAfter
      return lineEndingBefore(code)
    }
    if (markdownSpace(code)) {
      effects.consume(code)
      return tagOpenAttributeNameAfter
    }
    return tagOpenBetween(code)
  }

  /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */
  function tagOpenAttributeValueBefore(code) {
    if (
      code === null ||
      code === 60 ||
      code === 61 ||
      code === 62 ||
      code === 96
    ) {
      return nok(code)
    }
    if (code === 34 || code === 39) {
      effects.consume(code)
      marker = code
      return tagOpenAttributeValueQuoted
    }
    if (markdownLineEnding(code)) {
      returnState = tagOpenAttributeValueBefore
      return lineEndingBefore(code)
    }
    if (markdownSpace(code)) {
      effects.consume(code)
      return tagOpenAttributeValueBefore
    }
    effects.consume(code)
    return tagOpenAttributeValueUnquoted
  }

  /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | a <b c="d"> e
   *             ^
   * ```
   *
   * @type {State}
   */
  function tagOpenAttributeValueQuoted(code) {
    if (code === marker) {
      effects.consume(code)
      marker = undefined
      return tagOpenAttributeValueQuotedAfter
    }
    if (code === null) {
      return nok(code)
    }
    if (markdownLineEnding(code)) {
      returnState = tagOpenAttributeValueQuoted
      return lineEndingBefore(code)
    }
    effects.consume(code)
    return tagOpenAttributeValueQuoted
  }

  /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */
  function tagOpenAttributeValueUnquoted(code) {
    if (
      code === null ||
      code === 34 ||
      code === 39 ||
      code === 60 ||
      code === 61 ||
      code === 96
    ) {
      return nok(code)
    }
    if (code === 47 || code === 62 || markdownLineEndingOrSpace(code)) {
      return tagOpenBetween(code)
    }
    effects.consume(code)
    return tagOpenAttributeValueUnquoted
  }

  /**
   * After double or single quoted attribute value, before whitespace or the end
   * of the tag.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */
  function tagOpenAttributeValueQuotedAfter(code) {
    if (code === 47 || code === 62 || markdownLineEndingOrSpace(code)) {
      return tagOpenBetween(code)
    }
    return nok(code)
  }

  /**
   * In certain circumstances of a tag where only an `>` is allowed.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */
  function end(code) {
    if (code === 62) {
      effects.consume(code)
      effects.exit('htmlTextData')
      effects.exit('htmlText')
      return ok
    }
    return nok(code)
  }

  /**
   * At eol.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   * > | a <!--a
   *            ^
   *   | b-->
   * ```
   *
   * @type {State}
   */
  function lineEndingBefore(code) {
    effects.exit('htmlTextData')
    effects.enter('lineEnding')
    effects.consume(code)
    effects.exit('lineEnding')
    return lineEndingAfter
  }

  /**
   * After eol, at optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */
  function lineEndingAfter(code) {
    // Always populated by defaults.

    return markdownSpace(code)
      ? factorySpace(
          effects,
          lineEndingAfterPrefix,
          'linePrefix',
          self.parser.constructs.disable.null.includes('codeIndented')
            ? undefined
            : 4
        )(code)
      : lineEndingAfterPrefix(code)
  }

  /**
   * After eol, after optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */
  function lineEndingAfterPrefix(code) {
    effects.enter('htmlTextData')
    return returnState(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/label-start-link.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */



/** @type {Construct} */
const labelStartLink = {
  name: 'labelStartLink',
  tokenize: tokenizeLabelStartLink,
  resolveAll: labelEnd.resolveAll
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeLabelStartLink(effects, ok, nok) {
  const self = this
  return start

  /**
   * Start of label (link) start.
   *
   * ```markdown
   * > | a [b] c
   *       ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter('labelLink')
    effects.enter('labelMarker')
    effects.consume(code)
    effects.exit('labelMarker')
    effects.exit('labelLink')
    return after
  }

  /** @type {State} */
  function after(code) {
    // To do: this isn’t needed in `micromark-extension-gfm-footnote`,
    // remove.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs
      ? nok(code)
      : ok(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/hard-break-escape.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */


/** @type {Construct} */
const hardBreakEscape = {
  name: 'hardBreakEscape',
  tokenize: tokenizeHardBreakEscape
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeHardBreakEscape(effects, ok, nok) {
  return start

  /**
   * Start of a hard break (escape).
   *
   * ```markdown
   * > | a\
   *      ^
   *   | b
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter('hardBreakEscape')
    effects.consume(code)
    return after
  }

  /**
   * After `\`, at eol.
   *
   * ```markdown
   * > | a\
   *       ^
   *   | b
   * ```
   *
   *  @type {State}
   */
  function after(code) {
    if (markdownLineEnding(code)) {
      effects.exit('hardBreakEscape')
      return ok(code)
    }
    return nok(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-core-commonmark/lib/code-text.js
/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Previous} Previous
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */


/** @type {Construct} */
const codeText = {
  name: 'codeText',
  tokenize: tokenizeCodeText,
  resolve: resolveCodeText,
  previous
}

// To do: next major: don’t resolve, like `markdown-rs`.
/** @type {Resolver} */
function resolveCodeText(events) {
  let tailExitIndex = events.length - 4
  let headEnterIndex = 3
  /** @type {number} */
  let index
  /** @type {number | undefined} */
  let enter

  // If we start and end with an EOL or a space.
  if (
    (events[headEnterIndex][1].type === 'lineEnding' ||
      events[headEnterIndex][1].type === 'space') &&
    (events[tailExitIndex][1].type === 'lineEnding' ||
      events[tailExitIndex][1].type === 'space')
  ) {
    index = headEnterIndex

    // And we have data.
    while (++index < tailExitIndex) {
      if (events[index][1].type === 'codeTextData') {
        // Then we have padding.
        events[headEnterIndex][1].type = 'codeTextPadding'
        events[tailExitIndex][1].type = 'codeTextPadding'
        headEnterIndex += 2
        tailExitIndex -= 2
        break
      }
    }
  }

  // Merge adjacent spaces and data.
  index = headEnterIndex - 1
  tailExitIndex++
  while (++index <= tailExitIndex) {
    if (enter === undefined) {
      if (index !== tailExitIndex && events[index][1].type !== 'lineEnding') {
        enter = index
      }
    } else if (
      index === tailExitIndex ||
      events[index][1].type === 'lineEnding'
    ) {
      events[enter][1].type = 'codeTextData'
      if (index !== enter + 2) {
        events[enter][1].end = events[index - 1][1].end
        events.splice(enter + 2, index - enter - 2)
        tailExitIndex -= index - enter - 2
        index = enter + 2
      }
      enter = undefined
    }
  }
  return events
}

/**
 * @this {TokenizeContext}
 * @type {Previous}
 */
function previous(code) {
  // If there is a previous code, there will always be a tail.
  return (
    code !== 96 ||
    this.events[this.events.length - 1][1].type === 'characterEscape'
  )
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeCodeText(effects, ok, nok) {
  const self = this
  let sizeOpen = 0
  /** @type {number} */
  let size
  /** @type {Token} */
  let token
  return start

  /**
   * Start of code (text).
   *
   * ```markdown
   * > | `a`
   *     ^
   * > | \`a`
   *      ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter('codeText')
    effects.enter('codeTextSequence')
    return sequenceOpen(code)
  }

  /**
   * In opening sequence.
   *
   * ```markdown
   * > | `a`
   *     ^
   * ```
   *
   * @type {State}
   */
  function sequenceOpen(code) {
    if (code === 96) {
      effects.consume(code)
      sizeOpen++
      return sequenceOpen
    }
    effects.exit('codeTextSequence')
    return between(code)
  }

  /**
   * Between something and something else.
   *
   * ```markdown
   * > | `a`
   *      ^^
   * ```
   *
   * @type {State}
   */
  function between(code) {
    // EOF.
    if (code === null) {
      return nok(code)
    }

    // To do: next major: don’t do spaces in resolve, but when compiling,
    // like `markdown-rs`.
    // Tabs don’t work, and virtual spaces don’t make sense.
    if (code === 32) {
      effects.enter('space')
      effects.consume(code)
      effects.exit('space')
      return between
    }

    // Closing fence? Could also be data.
    if (code === 96) {
      token = effects.enter('codeTextSequence')
      size = 0
      return sequenceClose(code)
    }
    if (markdownLineEnding(code)) {
      effects.enter('lineEnding')
      effects.consume(code)
      effects.exit('lineEnding')
      return between
    }

    // Data.
    effects.enter('codeTextData')
    return data(code)
  }

  /**
   * In data.
   *
   * ```markdown
   * > | `a`
   *      ^
   * ```
   *
   * @type {State}
   */
  function data(code) {
    if (
      code === null ||
      code === 32 ||
      code === 96 ||
      markdownLineEnding(code)
    ) {
      effects.exit('codeTextData')
      return between(code)
    }
    effects.consume(code)
    return data
  }

  /**
   * In closing sequence.
   *
   * ```markdown
   * > | `a`
   *       ^
   * ```
   *
   * @type {State}
   */
  function sequenceClose(code) {
    // More.
    if (code === 96) {
      effects.consume(code)
      size++
      return sequenceClose
    }

    // Done!
    if (size === sizeOpen) {
      effects.exit('codeTextSequence')
      effects.exit('codeText')
      return ok(code)
    }

    // More or less accents: mark as data.
    token.type = 'codeTextData'
    return data(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark/lib/constructs.js
/**
 * @typedef {import('micromark-util-types').Extension} Extension
 */




/** @satisfies {Extension['document']} */
const constructs_document = {
  [42]: list,
  [43]: list,
  [45]: list,
  [48]: list,
  [49]: list,
  [50]: list,
  [51]: list,
  [52]: list,
  [53]: list,
  [54]: list,
  [55]: list,
  [56]: list,
  [57]: list,
  [62]: blockQuote
}

/** @satisfies {Extension['contentInitial']} */
const contentInitial = {
  [91]: definition
}

/** @satisfies {Extension['flowInitial']} */
const flowInitial = {
  [-2]: codeIndented,
  [-1]: codeIndented,
  [32]: codeIndented
}

/** @satisfies {Extension['flow']} */
const constructs_flow = {
  [35]: headingAtx,
  [42]: thematicBreak,
  [45]: [setextUnderline, thematicBreak],
  [60]: htmlFlow,
  [61]: setextUnderline,
  [95]: thematicBreak,
  [96]: codeFenced,
  [126]: codeFenced
}

/** @satisfies {Extension['string']} */
const constructs_string = {
  [38]: characterReference,
  [92]: characterEscape
}

/** @satisfies {Extension['text']} */
const constructs_text = {
  [-5]: lineEnding,
  [-4]: lineEnding,
  [-3]: lineEnding,
  [33]: labelStartImage,
  [38]: characterReference,
  [42]: attention,
  [60]: [autolink, htmlText],
  [91]: labelStartLink,
  [92]: [hardBreakEscape, characterEscape],
  [93]: labelEnd,
  [95]: attention,
  [96]: codeText
}

/** @satisfies {Extension['insideSpan']} */
const insideSpan = {
  null: [attention, resolver]
}

/** @satisfies {Extension['attentionMarkers']} */
const attentionMarkers = {
  null: [42, 95]
}

/** @satisfies {Extension['disable']} */
const disable = {
  null: []
}

;// CONCATENATED MODULE: ../node_modules/micromark/lib/parse.js
/**
 * @typedef {import('micromark-util-types').Create} Create
 * @typedef {import('micromark-util-types').FullNormalizedExtension} FullNormalizedExtension
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 */









/**
 * @param {ParseOptions | null | undefined} [options]
 * @returns {ParseContext}
 */
function parse(options) {
  const settings = options || {}
  const constructs =
    /** @type {FullNormalizedExtension} */
    combineExtensions([constructs_namespaceObject, ...(settings.extensions || [])])

  /** @type {ParseContext} */
  const parser = {
    defined: [],
    lazy: {},
    constructs,
    content: create(content),
    document: create(document_document),
    flow: create(flow),
    string: create(string),
    text: create(text_text)
  }
  return parser

  /**
   * @param {InitialConstruct} initial
   */
  function create(initial) {
    return creator
    /** @type {Create} */
    function creator(from) {
      return createTokenizer(parser, initial, from)
    }
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark/lib/preprocess.js
/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Value} Value
 */

/**
 * @callback Preprocessor
 * @param {Value} value
 * @param {Encoding | null | undefined} [encoding]
 * @param {boolean | null | undefined} [end=false]
 * @returns {Array<Chunk>}
 */

const search = /[\0\t\n\r]/g

/**
 * @returns {Preprocessor}
 */
function preprocess() {
  let column = 1
  let buffer = ''
  /** @type {boolean | undefined} */
  let start = true
  /** @type {boolean | undefined} */
  let atCarriageReturn
  return preprocessor

  /** @type {Preprocessor} */
  function preprocessor(value, encoding, end) {
    /** @type {Array<Chunk>} */
    const chunks = []
    /** @type {RegExpMatchArray | null} */
    let match
    /** @type {number} */
    let next
    /** @type {number} */
    let startPosition
    /** @type {number} */
    let endPosition
    /** @type {Code} */
    let code

    // @ts-expect-error `Buffer` does allow an encoding.
    value = buffer + value.toString(encoding)
    startPosition = 0
    buffer = ''
    if (start) {
      // To do: `markdown-rs` actually parses BOMs (byte order mark).
      if (value.charCodeAt(0) === 65279) {
        startPosition++
      }
      start = undefined
    }
    while (startPosition < value.length) {
      search.lastIndex = startPosition
      match = search.exec(value)
      endPosition =
        match && match.index !== undefined ? match.index : value.length
      code = value.charCodeAt(endPosition)
      if (!match) {
        buffer = value.slice(startPosition)
        break
      }
      if (code === 10 && startPosition === endPosition && atCarriageReturn) {
        chunks.push(-3)
        atCarriageReturn = undefined
      } else {
        if (atCarriageReturn) {
          chunks.push(-5)
          atCarriageReturn = undefined
        }
        if (startPosition < endPosition) {
          chunks.push(value.slice(startPosition, endPosition))
          column += endPosition - startPosition
        }
        switch (code) {
          case 0: {
            chunks.push(65533)
            column++
            break
          }
          case 9: {
            next = Math.ceil(column / 4) * 4
            chunks.push(-2)
            while (column++ < next) chunks.push(-1)
            break
          }
          case 10: {
            chunks.push(-4)
            column = 1
            break
          }
          default: {
            atCarriageReturn = true
            column = 1
          }
        }
      }
      startPosition = endPosition + 1
    }
    if (end) {
      if (atCarriageReturn) chunks.push(-5)
      if (buffer) chunks.push(buffer)
      chunks.push(null)
    }
    return chunks
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark/lib/postprocess.js
/**
 * @typedef {import('micromark-util-types').Event} Event
 */



/**
 * @param {Array<Event>} events
 * @returns {Array<Event>}
 */
function postprocess(events) {
  while (!subtokenize(events)) {
    // Empty
  }
  return events
}

;// CONCATENATED MODULE: ../node_modules/micromark-util-decode-numeric-character-reference/index.js
/**
 * Turn the number (in string form as either hexa- or plain decimal) coming from
 * a numeric character reference into a character.
 *
 * Sort of like `String.fromCharCode(Number.parseInt(value, base))`, but makes
 * non-characters and control characters safe.
 *
 * @param {string} value
 *   Value to decode.
 * @param {number} base
 *   Numeric base.
 * @returns {string}
 *   Character.
 */
function decodeNumericCharacterReference(value, base) {
  const code = Number.parseInt(value, base)
  if (
    // C0 except for HT, LF, FF, CR, space.
    code < 9 ||
    code === 11 ||
    (code > 13 && code < 32) ||
    // Control character (DEL) of C0, and C1 controls.
    (code > 126 && code < 160) ||
    // Lone high surrogates and low surrogates.
    (code > 55295 && code < 57344) ||
    // Noncharacters.
    (code > 64975 && code < 65008) /* eslint-disable no-bitwise */ ||
    (code & 65535) === 65535 ||
    (code & 65535) === 65534 /* eslint-enable no-bitwise */ ||
    // Out of range
    code > 1114111
  ) {
    return '\uFFFD'
  }
  return String.fromCharCode(code)
}

;// CONCATENATED MODULE: ../node_modules/micromark-util-decode-string/index.js


const characterEscapeOrReference =
  /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi

/**
 * Decode markdown strings (which occur in places such as fenced code info
 * strings, destinations, labels, and titles).
 *
 * The “string” content type allows character escapes and -references.
 * This decodes those.
 *
 * @param {string} value
 *   Value to decode.
 * @returns {string}
 *   Decoded value.
 */
function decodeString(value) {
  return value.replace(characterEscapeOrReference, decode)
}

/**
 * @param {string} $0
 * @param {string} $1
 * @param {string} $2
 * @returns {string}
 */
function decode($0, $1, $2) {
  if ($1) {
    // Escape.
    return $1
  }

  // Reference.
  const head = $2.charCodeAt(0)
  if (head === 35) {
    const head = $2.charCodeAt(1)
    const hex = head === 120 || head === 88
    return decodeNumericCharacterReference($2.slice(hex ? 2 : 1), hex ? 16 : 10)
  }
  return decodeNamedCharacterReference($2) || $0
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-from-markdown/lib/index.js
/**
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Value} Value
 *
 * @typedef {import('unist').Parent} UnistParent
 * @typedef {import('unist').Point} Point
 *
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 * @typedef {import('mdast').StaticPhrasingContent} StaticPhrasingContent
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Break} Break
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('mdast').Code} Code
 * @typedef {import('mdast').Definition} Definition
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('mdast').HTML} HTML
 * @typedef {import('mdast').Image} Image
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('mdast').List} List
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('mdast').Text} Text
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('mdast').ReferenceType} ReferenceType
 * @typedef {import('../index.js').CompileData} CompileData
 */

/**
 * @typedef {Root | Content} Node
 * @typedef {Extract<Node, UnistParent>} Parent
 *
 * @typedef {Omit<UnistParent, 'type' | 'children'> & {type: 'fragment', children: Array<PhrasingContent>}} Fragment
 */

/**
 * @callback Transform
 *   Extra transform, to change the AST afterwards.
 * @param {Root} tree
 *   Tree to transform.
 * @returns {Root | undefined | null | void}
 *   New tree or nothing (in which case the current tree is used).
 *
 * @callback Handle
 *   Handle a token.
 * @param {CompileContext} this
 *   Context.
 * @param {Token} token
 *   Current token.
 * @returns {void}
 *   Nothing.
 *
 * @typedef {Record<string, Handle>} Handles
 *   Token types mapping to handles
 *
 * @callback OnEnterError
 *   Handle the case where the `right` token is open, but it is closed (by the
 *   `left` token) or because we reached the end of the document.
 * @param {Omit<CompileContext, 'sliceSerialize'>} this
 *   Context.
 * @param {Token | undefined} left
 *   Left token.
 * @param {Token} right
 *   Right token.
 * @returns {void}
 *   Nothing.
 *
 * @callback OnExitError
 *   Handle the case where the `right` token is open but it is closed by
 *   exiting the `left` token.
 * @param {Omit<CompileContext, 'sliceSerialize'>} this
 *   Context.
 * @param {Token} left
 *   Left token.
 * @param {Token} right
 *   Right token.
 * @returns {void}
 *   Nothing.
 *
 * @typedef {[Token, OnEnterError | undefined]} TokenTuple
 *   Open token on the stack, with an optional error handler for when
 *   that token isn’t closed properly.
 */

/**
 * @typedef Config
 *   Configuration.
 *
 *   We have our defaults, but extensions will add more.
 * @property {Array<string>} canContainEols
 *   Token types where line endings are used.
 * @property {Handles} enter
 *   Opening handles.
 * @property {Handles} exit
 *   Closing handles.
 * @property {Array<Transform>} transforms
 *   Tree transforms.
 *
 * @typedef {Partial<Config>} Extension
 *   Change how markdown tokens from micromark are turned into mdast.
 *
 * @typedef CompileContext
 *   mdast compiler context.
 * @property {Array<Node | Fragment>} stack
 *   Stack of nodes.
 * @property {Array<TokenTuple>} tokenStack
 *   Stack of tokens.
 * @property {<Key extends keyof CompileData>(key: Key) => CompileData[Key]} getData
 *   Get data from the key/value store.
 * @property {<Key extends keyof CompileData>(key: Key, value?: CompileData[Key]) => void} setData
 *   Set data into the key/value store.
 * @property {(this: CompileContext) => void} buffer
 *   Capture some of the output data.
 * @property {(this: CompileContext) => string} resume
 *   Stop capturing and access the output data.
 * @property {<Kind extends Node>(this: CompileContext, node: Kind, token: Token, onError?: OnEnterError) => Kind} enter
 *   Enter a token.
 * @property {(this: CompileContext, token: Token, onError?: OnExitError) => Node} exit
 *   Exit a token.
 * @property {TokenizeContext['sliceSerialize']} sliceSerialize
 *   Get the string value of a token.
 * @property {Config} config
 *   Configuration.
 *
 * @typedef FromMarkdownOptions
 *   Configuration for how to build mdast.
 * @property {Array<Extension | Array<Extension>> | null | undefined} [mdastExtensions]
 *   Extensions for this utility to change how tokens are turned into a tree.
 *
 * @typedef {ParseOptions & FromMarkdownOptions} Options
 *   Configuration.
 */

// To do: micromark: create a registry of tokens?
// To do: next major: don’t return given `Node` from `enter`.
// To do: next major: remove setter/getter.










const lib_own = {}.hasOwnProperty

/**
 * @param value
 *   Markdown to parse.
 * @param encoding
 *   Character encoding for when `value` is `Buffer`.
 * @param options
 *   Configuration.
 * @returns
 *   mdast tree.
 */
const fromMarkdown =
  /**
   * @type {(
   *   ((value: Value, encoding: Encoding, options?: Options | null | undefined) => Root) &
   *   ((value: Value, options?: Options | null | undefined) => Root)
   * )}
   */

  /**
   * @param {Value} value
   * @param {Encoding | Options | null | undefined} [encoding]
   * @param {Options | null | undefined} [options]
   * @returns {Root}
   */
  function (value, encoding, options) {
    if (typeof encoding !== 'string') {
      options = encoding
      encoding = undefined
    }
    return compiler(options)(
      postprocess(
        parse(options).document().write(preprocess()(value, encoding, true))
      )
    )
  }

/**
 * Note this compiler only understand complete buffering, not streaming.
 *
 * @param {Options | null | undefined} [options]
 */
function compiler(options) {
  /** @type {Config} */
  const config = {
    transforms: [],
    canContainEols: ['emphasis', 'fragment', 'heading', 'paragraph', 'strong'],
    enter: {
      autolink: opener(link),
      autolinkProtocol: onenterdata,
      autolinkEmail: onenterdata,
      atxHeading: opener(heading),
      blockQuote: opener(blockQuote),
      characterEscape: onenterdata,
      characterReference: onenterdata,
      codeFenced: opener(codeFlow),
      codeFencedFenceInfo: buffer,
      codeFencedFenceMeta: buffer,
      codeIndented: opener(codeFlow, buffer),
      codeText: opener(codeText, buffer),
      codeTextData: onenterdata,
      data: onenterdata,
      codeFlowValue: onenterdata,
      definition: opener(definition),
      definitionDestinationString: buffer,
      definitionLabelString: buffer,
      definitionTitleString: buffer,
      emphasis: opener(emphasis),
      hardBreakEscape: opener(hardBreak),
      hardBreakTrailing: opener(hardBreak),
      htmlFlow: opener(html, buffer),
      htmlFlowData: onenterdata,
      htmlText: opener(html, buffer),
      htmlTextData: onenterdata,
      image: opener(image),
      label: buffer,
      link: opener(link),
      listItem: opener(listItem),
      listItemValue: onenterlistitemvalue,
      listOrdered: opener(list, onenterlistordered),
      listUnordered: opener(list),
      paragraph: opener(paragraph),
      reference: onenterreference,
      referenceString: buffer,
      resourceDestinationString: buffer,
      resourceTitleString: buffer,
      setextHeading: opener(heading),
      strong: opener(strong),
      thematicBreak: opener(thematicBreak)
    },
    exit: {
      atxHeading: closer(),
      atxHeadingSequence: onexitatxheadingsequence,
      autolink: closer(),
      autolinkEmail: onexitautolinkemail,
      autolinkProtocol: onexitautolinkprotocol,
      blockQuote: closer(),
      characterEscapeValue: onexitdata,
      characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
      characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
      characterReferenceValue: onexitcharacterreferencevalue,
      codeFenced: closer(onexitcodefenced),
      codeFencedFence: onexitcodefencedfence,
      codeFencedFenceInfo: onexitcodefencedfenceinfo,
      codeFencedFenceMeta: onexitcodefencedfencemeta,
      codeFlowValue: onexitdata,
      codeIndented: closer(onexitcodeindented),
      codeText: closer(onexitcodetext),
      codeTextData: onexitdata,
      data: onexitdata,
      definition: closer(),
      definitionDestinationString: onexitdefinitiondestinationstring,
      definitionLabelString: onexitdefinitionlabelstring,
      definitionTitleString: onexitdefinitiontitlestring,
      emphasis: closer(),
      hardBreakEscape: closer(onexithardbreak),
      hardBreakTrailing: closer(onexithardbreak),
      htmlFlow: closer(onexithtmlflow),
      htmlFlowData: onexitdata,
      htmlText: closer(onexithtmltext),
      htmlTextData: onexitdata,
      image: closer(onexitimage),
      label: onexitlabel,
      labelText: onexitlabeltext,
      lineEnding: onexitlineending,
      link: closer(onexitlink),
      listItem: closer(),
      listOrdered: closer(),
      listUnordered: closer(),
      paragraph: closer(),
      referenceString: onexitreferencestring,
      resourceDestinationString: onexitresourcedestinationstring,
      resourceTitleString: onexitresourcetitlestring,
      resource: onexitresource,
      setextHeading: closer(onexitsetextheading),
      setextHeadingLineSequence: onexitsetextheadinglinesequence,
      setextHeadingText: onexitsetextheadingtext,
      strong: closer(),
      thematicBreak: closer()
    }
  }
  configure(config, (options || {}).mdastExtensions || [])

  /** @type {CompileData} */
  const data = {}
  return compile

  /**
   * Turn micromark events into an mdast tree.
   *
   * @param {Array<Event>} events
   *   Events.
   * @returns {Root}
   *   mdast tree.
   */
  function compile(events) {
    /** @type {Root} */
    let tree = {
      type: 'root',
      children: []
    }
    /** @type {Omit<CompileContext, 'sliceSerialize'>} */
    const context = {
      stack: [tree],
      tokenStack: [],
      config,
      enter,
      exit,
      buffer,
      resume,
      setData,
      getData
    }
    /** @type {Array<number>} */
    const listStack = []
    let index = -1
    while (++index < events.length) {
      // We preprocess lists to add `listItem` tokens, and to infer whether
      // items the list itself are spread out.
      if (
        events[index][1].type === 'listOrdered' ||
        events[index][1].type === 'listUnordered'
      ) {
        if (events[index][0] === 'enter') {
          listStack.push(index)
        } else {
          const tail = listStack.pop()
          index = prepareList(events, tail, index)
        }
      }
    }
    index = -1
    while (++index < events.length) {
      const handler = config[events[index][0]]
      if (lib_own.call(handler, events[index][1].type)) {
        handler[events[index][1].type].call(
          Object.assign(
            {
              sliceSerialize: events[index][2].sliceSerialize
            },
            context
          ),
          events[index][1]
        )
      }
    }

    // Handle tokens still being open.
    if (context.tokenStack.length > 0) {
      const tail = context.tokenStack[context.tokenStack.length - 1]
      const handler = tail[1] || defaultOnError
      handler.call(context, undefined, tail[0])
    }

    // Figure out `root` position.
    tree.position = {
      start: lib_point(
        events.length > 0
          ? events[0][1].start
          : {
              line: 1,
              column: 1,
              offset: 0
            }
      ),
      end: lib_point(
        events.length > 0
          ? events[events.length - 2][1].end
          : {
              line: 1,
              column: 1,
              offset: 0
            }
      )
    }

    // Call transforms.
    index = -1
    while (++index < config.transforms.length) {
      tree = config.transforms[index](tree) || tree
    }
    return tree
  }

  /**
   * @param {Array<Event>} events
   * @param {number} start
   * @param {number} length
   * @returns {number}
   */
  function prepareList(events, start, length) {
    let index = start - 1
    let containerBalance = -1
    let listSpread = false
    /** @type {Token | undefined} */
    let listItem
    /** @type {number | undefined} */
    let lineIndex
    /** @type {number | undefined} */
    let firstBlankLineIndex
    /** @type {boolean | undefined} */
    let atMarker
    while (++index <= length) {
      const event = events[index]
      if (
        event[1].type === 'listUnordered' ||
        event[1].type === 'listOrdered' ||
        event[1].type === 'blockQuote'
      ) {
        if (event[0] === 'enter') {
          containerBalance++
        } else {
          containerBalance--
        }
        atMarker = undefined
      } else if (event[1].type === 'lineEndingBlank') {
        if (event[0] === 'enter') {
          if (
            listItem &&
            !atMarker &&
            !containerBalance &&
            !firstBlankLineIndex
          ) {
            firstBlankLineIndex = index
          }
          atMarker = undefined
        }
      } else if (
        event[1].type === 'linePrefix' ||
        event[1].type === 'listItemValue' ||
        event[1].type === 'listItemMarker' ||
        event[1].type === 'listItemPrefix' ||
        event[1].type === 'listItemPrefixWhitespace'
      ) {
        // Empty.
      } else {
        atMarker = undefined
      }
      if (
        (!containerBalance &&
          event[0] === 'enter' &&
          event[1].type === 'listItemPrefix') ||
        (containerBalance === -1 &&
          event[0] === 'exit' &&
          (event[1].type === 'listUnordered' ||
            event[1].type === 'listOrdered'))
      ) {
        if (listItem) {
          let tailIndex = index
          lineIndex = undefined
          while (tailIndex--) {
            const tailEvent = events[tailIndex]
            if (
              tailEvent[1].type === 'lineEnding' ||
              tailEvent[1].type === 'lineEndingBlank'
            ) {
              if (tailEvent[0] === 'exit') continue
              if (lineIndex) {
                events[lineIndex][1].type = 'lineEndingBlank'
                listSpread = true
              }
              tailEvent[1].type = 'lineEnding'
              lineIndex = tailIndex
            } else if (
              tailEvent[1].type === 'linePrefix' ||
              tailEvent[1].type === 'blockQuotePrefix' ||
              tailEvent[1].type === 'blockQuotePrefixWhitespace' ||
              tailEvent[1].type === 'blockQuoteMarker' ||
              tailEvent[1].type === 'listItemIndent'
            ) {
              // Empty
            } else {
              break
            }
          }
          if (
            firstBlankLineIndex &&
            (!lineIndex || firstBlankLineIndex < lineIndex)
          ) {
            listItem._spread = true
          }

          // Fix position.
          listItem.end = Object.assign(
            {},
            lineIndex ? events[lineIndex][1].start : event[1].end
          )
          events.splice(lineIndex || index, 0, ['exit', listItem, event[2]])
          index++
          length++
        }

        // Create a new list item.
        if (event[1].type === 'listItemPrefix') {
          listItem = {
            type: 'listItem',
            _spread: false,
            start: Object.assign({}, event[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: undefined
          }
          // @ts-expect-error: `listItem` is most definitely defined, TS...
          events.splice(index, 0, ['enter', listItem, event[2]])
          index++
          length++
          firstBlankLineIndex = undefined
          atMarker = true
        }
      }
    }
    events[start][1]._spread = listSpread
    return length
  }

  /**
   * Set data.
   *
   * @template {keyof CompileData} Key
   *   Field type.
   * @param {Key} key
   *   Key of field.
   * @param {CompileData[Key]} [value]
   *   New value.
   * @returns {void}
   *   Nothing.
   */
  function setData(key, value) {
    data[key] = value
  }

  /**
   * Get data.
   *
   * @template {keyof CompileData} Key
   *   Field type.
   * @param {Key} key
   *   Key of field.
   * @returns {CompileData[Key]}
   *   Value.
   */
  function getData(key) {
    return data[key]
  }

  /**
   * Create an opener handle.
   *
   * @param {(token: Token) => Node} create
   *   Create a node.
   * @param {Handle} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */
  function opener(create, and) {
    return open

    /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {void}
     */
    function open(token) {
      enter.call(this, create(token), token)
      if (and) and.call(this, token)
    }
  }

  /**
   * @this {CompileContext}
   * @returns {void}
   */
  function buffer() {
    this.stack.push({
      type: 'fragment',
      children: []
    })
  }

  /**
   * @template {Node} Kind
   *   Node type.
   * @this {CompileContext}
   *   Context.
   * @param {Kind} node
   *   Node to enter.
   * @param {Token} token
   *   Corresponding token.
   * @param {OnEnterError | undefined} [errorHandler]
   *   Handle the case where this token is open, but it is closed by something else.
   * @returns {Kind}
   *   The given node.
   */
  function enter(node, token, errorHandler) {
    const parent = this.stack[this.stack.length - 1]
    // @ts-expect-error: Assume `Node` can exist as a child of `parent`.
    parent.children.push(node)
    this.stack.push(node)
    this.tokenStack.push([token, errorHandler])
    // @ts-expect-error: `end` will be patched later.
    node.position = {
      start: lib_point(token.start)
    }
    return node
  }

  /**
   * Create a closer handle.
   *
   * @param {Handle} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */
  function closer(and) {
    return close

    /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {void}
     */
    function close(token) {
      if (and) and.call(this, token)
      exit.call(this, token)
    }
  }

  /**
   * @this {CompileContext}
   *   Context.
   * @param {Token} token
   *   Corresponding token.
   * @param {OnExitError | undefined} [onExitError]
   *   Handle the case where another token is open.
   * @returns {Node}
   *   The closed node.
   */
  function exit(token, onExitError) {
    const node = this.stack.pop()
    const open = this.tokenStack.pop()
    if (!open) {
      throw new Error(
        'Cannot close `' +
          token.type +
          '` (' +
          stringifyPosition({
            start: token.start,
            end: token.end
          }) +
          '): it’s not open'
      )
    } else if (open[0].type !== token.type) {
      if (onExitError) {
        onExitError.call(this, token, open[0])
      } else {
        const handler = open[1] || defaultOnError
        handler.call(this, token, open[0])
      }
    }
    node.position.end = lib_point(token.end)
    return node
  }

  /**
   * @this {CompileContext}
   * @returns {string}
   */
  function resume() {
    return lib_toString(this.stack.pop())
  }

  //
  // Handlers.
  //

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onenterlistordered() {
    setData('expectingFirstListItemValue', true)
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onenterlistitemvalue(token) {
    if (getData('expectingFirstListItemValue')) {
      const ancestor = this.stack[this.stack.length - 2]
      ancestor.start = Number.parseInt(this.sliceSerialize(token), 10)
      setData('expectingFirstListItemValue')
    }
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitcodefencedfenceinfo() {
    const data = this.resume()
    const node = this.stack[this.stack.length - 1]
    node.lang = data
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitcodefencedfencemeta() {
    const data = this.resume()
    const node = this.stack[this.stack.length - 1]
    node.meta = data
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitcodefencedfence() {
    // Exit if this is the closing fence.
    if (getData('flowCodeInside')) return
    this.buffer()
    setData('flowCodeInside', true)
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitcodefenced() {
    const data = this.resume()
    const node = this.stack[this.stack.length - 1]
    node.value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, '')
    setData('flowCodeInside')
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitcodeindented() {
    const data = this.resume()
    const node = this.stack[this.stack.length - 1]
    node.value = data.replace(/(\r?\n|\r)$/g, '')
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitdefinitionlabelstring(token) {
    const label = this.resume()
    const node = this.stack[this.stack.length - 1]
    node.label = label
    node.identifier = normalizeIdentifier(
      this.sliceSerialize(token)
    ).toLowerCase()
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitdefinitiontitlestring() {
    const data = this.resume()
    const node = this.stack[this.stack.length - 1]
    node.title = data
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitdefinitiondestinationstring() {
    const data = this.resume()
    const node = this.stack[this.stack.length - 1]
    node.url = data
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitatxheadingsequence(token) {
    const node = this.stack[this.stack.length - 1]
    if (!node.depth) {
      const depth = this.sliceSerialize(token).length
      node.depth = depth
    }
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitsetextheadingtext() {
    setData('setextHeadingSlurpLineEnding', true)
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitsetextheadinglinesequence(token) {
    const node = this.stack[this.stack.length - 1]
    node.depth = this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitsetextheading() {
    setData('setextHeadingSlurpLineEnding')
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onenterdata(token) {
    const node = this.stack[this.stack.length - 1]
    let tail = node.children[node.children.length - 1]
    if (!tail || tail.type !== 'text') {
      // Add a new text node.
      tail = text()
      // @ts-expect-error: we’ll add `end` later.
      tail.position = {
        start: lib_point(token.start)
      }
      // @ts-expect-error: Assume `parent` accepts `text`.
      node.children.push(tail)
    }
    this.stack.push(tail)
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitdata(token) {
    const tail = this.stack.pop()
    tail.value += this.sliceSerialize(token)
    tail.position.end = lib_point(token.end)
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitlineending(token) {
    const context = this.stack[this.stack.length - 1]
    // If we’re at a hard break, include the line ending in there.
    if (getData('atHardBreak')) {
      const tail = context.children[context.children.length - 1]
      tail.position.end = lib_point(token.end)
      setData('atHardBreak')
      return
    }
    if (
      !getData('setextHeadingSlurpLineEnding') &&
      config.canContainEols.includes(context.type)
    ) {
      onenterdata.call(this, token)
      onexitdata.call(this, token)
    }
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexithardbreak() {
    setData('atHardBreak', true)
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexithtmlflow() {
    const data = this.resume()
    const node = this.stack[this.stack.length - 1]
    node.value = data
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexithtmltext() {
    const data = this.resume()
    const node = this.stack[this.stack.length - 1]
    node.value = data
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitcodetext() {
    const data = this.resume()
    const node = this.stack[this.stack.length - 1]
    node.value = data
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitlink() {
    const node = this.stack[this.stack.length - 1]
    // Note: there are also `identifier` and `label` fields on this link node!
    // These are used / cleaned here.
    // To do: clean.
    if (getData('inReference')) {
      /** @type {ReferenceType} */
      const referenceType = getData('referenceType') || 'shortcut'
      node.type += 'Reference'
      // @ts-expect-error: mutate.
      node.referenceType = referenceType
      // @ts-expect-error: mutate.
      delete node.url
      delete node.title
    } else {
      // @ts-expect-error: mutate.
      delete node.identifier
      // @ts-expect-error: mutate.
      delete node.label
    }
    setData('referenceType')
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitimage() {
    const node = this.stack[this.stack.length - 1]
    // Note: there are also `identifier` and `label` fields on this link node!
    // These are used / cleaned here.
    // To do: clean.
    if (getData('inReference')) {
      /** @type {ReferenceType} */
      const referenceType = getData('referenceType') || 'shortcut'
      node.type += 'Reference'
      // @ts-expect-error: mutate.
      node.referenceType = referenceType
      // @ts-expect-error: mutate.
      delete node.url
      delete node.title
    } else {
      // @ts-expect-error: mutate.
      delete node.identifier
      // @ts-expect-error: mutate.
      delete node.label
    }
    setData('referenceType')
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitlabeltext(token) {
    const string = this.sliceSerialize(token)
    const ancestor = this.stack[this.stack.length - 2]
    // @ts-expect-error: stash this on the node, as it might become a reference
    // later.
    ancestor.label = decodeString(string)
    // @ts-expect-error: same as above.
    ancestor.identifier = normalizeIdentifier(string).toLowerCase()
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitlabel() {
    const fragment = this.stack[this.stack.length - 1]
    const value = this.resume()
    const node = this.stack[this.stack.length - 1]
    // Assume a reference.
    setData('inReference', true)
    if (node.type === 'link') {
      /** @type {Array<StaticPhrasingContent>} */
      // @ts-expect-error: Assume static phrasing content.
      const children = fragment.children
      node.children = children
    } else {
      node.alt = value
    }
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitresourcedestinationstring() {
    const data = this.resume()
    const node = this.stack[this.stack.length - 1]
    node.url = data
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitresourcetitlestring() {
    const data = this.resume()
    const node = this.stack[this.stack.length - 1]
    node.title = data
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitresource() {
    setData('inReference')
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onenterreference() {
    setData('referenceType', 'collapsed')
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitreferencestring(token) {
    const label = this.resume()
    const node = this.stack[this.stack.length - 1]
    // @ts-expect-error: stash this on the node, as it might become a reference
    // later.
    node.label = label
    // @ts-expect-error: same as above.
    node.identifier = normalizeIdentifier(
      this.sliceSerialize(token)
    ).toLowerCase()
    setData('referenceType', 'full')
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */

  function onexitcharacterreferencemarker(token) {
    setData('characterReferenceType', token.type)
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitcharacterreferencevalue(token) {
    const data = this.sliceSerialize(token)
    const type = getData('characterReferenceType')
    /** @type {string} */
    let value
    if (type) {
      value = decodeNumericCharacterReference(
        data,
        type === 'characterReferenceMarkerNumeric' ? 10 : 16
      )
      setData('characterReferenceType')
    } else {
      const result = decodeNamedCharacterReference(data)
      value = result
    }
    const tail = this.stack.pop()
    tail.value += value
    tail.position.end = lib_point(token.end)
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitautolinkprotocol(token) {
    onexitdata.call(this, token)
    const node = this.stack[this.stack.length - 1]
    node.url = this.sliceSerialize(token)
  }

  /**
   * @this {CompileContext}
   * @type {Handle}
   */
  function onexitautolinkemail(token) {
    onexitdata.call(this, token)
    const node = this.stack[this.stack.length - 1]
    node.url = 'mailto:' + this.sliceSerialize(token)
  }

  //
  // Creaters.
  //

  /** @returns {Blockquote} */
  function blockQuote() {
    return {
      type: 'blockquote',
      children: []
    }
  }

  /** @returns {Code} */
  function codeFlow() {
    return {
      type: 'code',
      lang: null,
      meta: null,
      value: ''
    }
  }

  /** @returns {InlineCode} */
  function codeText() {
    return {
      type: 'inlineCode',
      value: ''
    }
  }

  /** @returns {Definition} */
  function definition() {
    return {
      type: 'definition',
      identifier: '',
      label: null,
      title: null,
      url: ''
    }
  }

  /** @returns {Emphasis} */
  function emphasis() {
    return {
      type: 'emphasis',
      children: []
    }
  }

  /** @returns {Heading} */
  function heading() {
    // @ts-expect-error `depth` will be set later.
    return {
      type: 'heading',
      depth: undefined,
      children: []
    }
  }

  /** @returns {Break} */
  function hardBreak() {
    return {
      type: 'break'
    }
  }

  /** @returns {HTML} */
  function html() {
    return {
      type: 'html',
      value: ''
    }
  }

  /** @returns {Image} */
  function image() {
    return {
      type: 'image',
      title: null,
      url: '',
      alt: null
    }
  }

  /** @returns {Link} */
  function link() {
    return {
      type: 'link',
      title: null,
      url: '',
      children: []
    }
  }

  /**
   * @param {Token} token
   * @returns {List}
   */
  function list(token) {
    return {
      type: 'list',
      ordered: token.type === 'listOrdered',
      start: null,
      spread: token._spread,
      children: []
    }
  }

  /**
   * @param {Token} token
   * @returns {ListItem}
   */
  function listItem(token) {
    return {
      type: 'listItem',
      spread: token._spread,
      checked: null,
      children: []
    }
  }

  /** @returns {Paragraph} */
  function paragraph() {
    return {
      type: 'paragraph',
      children: []
    }
  }

  /** @returns {Strong} */
  function strong() {
    return {
      type: 'strong',
      children: []
    }
  }

  /** @returns {Text} */
  function text() {
    return {
      type: 'text',
      value: ''
    }
  }

  /** @returns {ThematicBreak} */
  function thematicBreak() {
    return {
      type: 'thematicBreak'
    }
  }
}

/**
 * Copy a point-like value.
 *
 * @param {Point} d
 *   Point-like value.
 * @returns {Point}
 *   unist point.
 */
function lib_point(d) {
  return {
    line: d.line,
    column: d.column,
    offset: d.offset
  }
}

/**
 * @param {Config} combined
 * @param {Array<Extension | Array<Extension>>} extensions
 * @returns {void}
 */
function configure(combined, extensions) {
  let index = -1
  while (++index < extensions.length) {
    const value = extensions[index]
    if (Array.isArray(value)) {
      configure(combined, value)
    } else {
      extension(combined, value)
    }
  }
}

/**
 * @param {Config} combined
 * @param {Extension} extension
 * @returns {void}
 */
function extension(combined, extension) {
  /** @type {keyof Extension} */
  let key
  for (key in extension) {
    if (lib_own.call(extension, key)) {
      if (key === 'canContainEols') {
        const right = extension[key]
        if (right) {
          combined[key].push(...right)
        }
      } else if (key === 'transforms') {
        const right = extension[key]
        if (right) {
          combined[key].push(...right)
        }
      } else if (key === 'enter' || key === 'exit') {
        const right = extension[key]
        if (right) {
          Object.assign(combined[key], right)
        }
      }
    }
  }
}

/** @type {OnEnterError} */
function defaultOnError(left, right) {
  if (left) {
    throw new Error(
      'Cannot close `' +
        left.type +
        '` (' +
        stringifyPosition({
          start: left.start,
          end: left.end
        }) +
        '): a different token (`' +
        right.type +
        '`, ' +
        stringifyPosition({
          start: right.start,
          end: right.end
        }) +
        ') is open'
    )
  } else {
    throw new Error(
      'Cannot close document, a token (`' +
        right.type +
        '`, ' +
        stringifyPosition({
          start: right.start,
          end: right.end
        }) +
        ') is still open'
    )
  }
}

;// CONCATENATED MODULE: ../node_modules/remark-parse/lib/index.js
/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-from-markdown').Options} Options
 */



/**
 * @this {import('unified').Processor}
 * @type {import('unified').Plugin<[Options?] | void[], string, Root>}
 */
function remarkParse(options) {
  /** @type {import('unified').ParserFunction<Root>} */
  const parser = (doc) => {
    // Assume options.
    const settings = /** @type {Options} */ (this.data('settings'))

    return fromMarkdown(
      doc,
      Object.assign({}, settings, options, {
        // Note: these options are not in the readme.
        // The goal is for them to be set by plugins on `data` instead of being
        // passed by users.
        extensions: this.data('micromarkExtensions') || [],
        mdastExtensions: this.data('fromMarkdownExtensions') || []
      })
    )
  }

  Object.assign(this, {Parser: parser})
}

;// CONCATENATED MODULE: ../node_modules/micromark-util-sanitize-uri/index.js


/**
 * Make a value safe for injection as a URL.
 *
 * This encodes unsafe characters with percent-encoding and skips already
 * encoded sequences (see `normalizeUri`).
 * Further unsafe characters are encoded as character references (see
 * `micromark-util-encode`).
 *
 * A regex of allowed protocols can be given, in which case the URL is
 * sanitized.
 * For example, `/^(https?|ircs?|mailto|xmpp)$/i` can be used for `a[href]`, or
 * `/^https?$/i` for `img[src]` (this is what `github.com` allows).
 * If the URL includes an unknown protocol (one not matched by `protocol`, such
 * as a dangerous example, `javascript:`), the value is ignored.
 *
 * @param {string | undefined} url
 *   URI to sanitize.
 * @param {RegExp | null | undefined} [protocol]
 *   Allowed protocols.
 * @returns {string}
 *   Sanitized URI.
 */
function sanitizeUri(url, protocol) {
  const value = encode(normalizeUri(url || ''))
  if (!protocol) {
    return value
  }
  const colon = value.indexOf(':')
  const questionMark = value.indexOf('?')
  const numberSign = value.indexOf('#')
  const slash = value.indexOf('/')
  if (
    // If there is no protocol, it’s relative.
    colon < 0 ||
    // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    (slash > -1 && colon > slash) ||
    (questionMark > -1 && colon > questionMark) ||
    (numberSign > -1 && colon > numberSign) ||
    // It is a protocol, it should be allowed.
    protocol.test(value.slice(0, colon))
  ) {
    return value
  }
  return ''
}

/**
 * Normalize a URL.
 *
 * Encode unsafe characters with percent-encoding, skipping already encoded
 * sequences.
 *
 * @param {string} value
 *   URI to normalize.
 * @returns {string}
 *   Normalized URI.
 */
function normalizeUri(value) {
  /** @type {Array<string>} */
  const result = []
  let index = -1
  let start = 0
  let skip = 0
  while (++index < value.length) {
    const code = value.charCodeAt(index)
    /** @type {string} */
    let replace = ''

    // A correct percent encoded value.
    if (
      code === 37 &&
      asciiAlphanumeric(value.charCodeAt(index + 1)) &&
      asciiAlphanumeric(value.charCodeAt(index + 2))
    ) {
      skip = 2
    }
    // ASCII.
    else if (code < 128) {
      if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code))) {
        replace = String.fromCharCode(code)
      }
    }
    // Astral.
    else if (code > 55295 && code < 57344) {
      const next = value.charCodeAt(index + 1)

      // A correct surrogate pair.
      if (code < 56320 && next > 56319 && next < 57344) {
        replace = String.fromCharCode(code, next)
        skip = 1
      }
      // Lone surrogate.
      else {
        replace = '\uFFFD'
      }
    }
    // Unicode.
    else {
      replace = String.fromCharCode(code)
    }
    if (replace) {
      result.push(value.slice(start, index), encodeURIComponent(replace))
      start = index + skip + 1
      replace = ''
    }
    if (skip) {
      index += skip
      skip = 0
    }
  }
  return result.join('') + value.slice(start)
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/footer.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('./state.js').State} State
 */



/**
 * Generate a hast footer for called footnote definitions.
 *
 * @param {State} state
 *   Info passed around.
 * @returns {Element | undefined}
 *   `section` element or `undefined`.
 */
function footer(state) {
  /** @type {Array<ElementContent>} */
  const listItems = []
  let index = -1

  while (++index < state.footnoteOrder.length) {
    const def = state.footnoteById[state.footnoteOrder[index]]

    if (!def) {
      continue
    }

    const content = state.all(def)
    const id = String(def.identifier).toUpperCase()
    const safeId = normalizeUri(id.toLowerCase())
    let referenceIndex = 0
    /** @type {Array<ElementContent>} */
    const backReferences = []

    while (++referenceIndex <= state.footnoteCounts[id]) {
      /** @type {Element} */
      const backReference = {
        type: 'element',
        tagName: 'a',
        properties: {
          href:
            '#' +
            state.clobberPrefix +
            'fnref-' +
            safeId +
            (referenceIndex > 1 ? '-' + referenceIndex : ''),
          dataFootnoteBackref: true,
          className: ['data-footnote-backref'],
          ariaLabel: state.footnoteBackLabel
        },
        children: [{type: 'text', value: '↩'}]
      }

      if (referenceIndex > 1) {
        backReference.children.push({
          type: 'element',
          tagName: 'sup',
          children: [{type: 'text', value: String(referenceIndex)}]
        })
      }

      if (backReferences.length > 0) {
        backReferences.push({type: 'text', value: ' '})
      }

      backReferences.push(backReference)
    }

    const tail = content[content.length - 1]

    if (tail && tail.type === 'element' && tail.tagName === 'p') {
      const tailTail = tail.children[tail.children.length - 1]
      if (tailTail && tailTail.type === 'text') {
        tailTail.value += ' '
      } else {
        tail.children.push({type: 'text', value: ' '})
      }

      tail.children.push(...backReferences)
    } else {
      content.push(...backReferences)
    }

    /** @type {Element} */
    const listItem = {
      type: 'element',
      tagName: 'li',
      properties: {id: state.clobberPrefix + 'fn-' + safeId},
      children: state.wrap(content, true)
    }

    state.patch(def, listItem)

    listItems.push(listItem)
  }

  if (listItems.length === 0) {
    return
  }

  return {
    type: 'element',
    tagName: 'section',
    properties: {dataFootnotes: true, className: ['footnotes']},
    children: [
      {
        type: 'element',
        tagName: state.footnoteLabelTagName,
        properties: {
          // To do: use structured clone.
          ...JSON.parse(JSON.stringify(state.footnoteLabelProperties)),
          id: 'footnote-label'
        },
        children: [{type: 'text', value: state.footnoteLabel}]
      },
      {type: 'text', value: '\n'},
      {
        type: 'element',
        tagName: 'ol',
        properties: {},
        children: state.wrap(listItems, true)
      },
      {type: 'text', value: '\n'}
    ]
  }
}

;// CONCATENATED MODULE: ../node_modules/unist-util-is/lib/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 */

/**
 * @typedef {Record<string, unknown>} Props
 * @typedef {null | undefined | string | Props | TestFunctionAnything | Array<string | Props | TestFunctionAnything>} Test
 *   Check for an arbitrary node, unaware of TypeScript inferral.
 *
 * @callback TestFunctionAnything
 *   Check if a node passes a test, unaware of TypeScript inferral.
 * @param {unknown} this
 *   The given context.
 * @param {Node} node
 *   A node.
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean | void}
 *   Whether this node passes the test.
 */

/**
 * @template {Node} Kind
 *   Node type.
 * @typedef {Kind['type'] | Partial<Kind> | TestFunctionPredicate<Kind> | Array<Kind['type'] | Partial<Kind> | TestFunctionPredicate<Kind>>} PredicateTest
 *   Check for a node that can be inferred by TypeScript.
 */

/**
 * Check if a node passes a certain test.
 *
 * @template {Node} Kind
 *   Node type.
 * @callback TestFunctionPredicate
 *   Complex test function for a node that can be inferred by TypeScript.
 * @param {Node} node
 *   A node.
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {node is Kind}
 *   Whether this node passes the test.
 */

/**
 * @callback AssertAnything
 *   Check that an arbitrary value is a node, unaware of TypeScript inferral.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean}
 *   Whether this is a node and passes a test.
 */

/**
 * Check if a node is a node and passes a certain node test.
 *
 * @template {Node} Kind
 *   Node type.
 * @callback AssertPredicate
 *   Check that an arbitrary value is a specific node, aware of TypeScript.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {node is Kind}
 *   Whether this is a node and passes a test.
 */

/**
 * Check if `node` is a `Node` and whether it passes the given test.
 *
 * @param node
 *   Thing to check, typically `Node`.
 * @param test
 *   A check for a specific node.
 * @param index
 *   The node’s position in its parent.
 * @param parent
 *   The node’s parent.
 * @returns
 *   Whether `node` is a node and passes a test.
 */
const is =
  /**
   * @type {(
   *   (() => false) &
   *   (<Kind extends Node = Node>(node: unknown, test: PredicateTest<Kind>, index: number, parent: Parent, context?: unknown) => node is Kind) &
   *   (<Kind extends Node = Node>(node: unknown, test: PredicateTest<Kind>, index?: null | undefined, parent?: null | undefined, context?: unknown) => node is Kind) &
   *   ((node: unknown, test: Test, index: number, parent: Parent, context?: unknown) => boolean) &
   *   ((node: unknown, test?: Test, index?: null | undefined, parent?: null | undefined, context?: unknown) => boolean)
   * )}
   */
  (
    /**
     * @param {unknown} [node]
     * @param {Test} [test]
     * @param {number | null | undefined} [index]
     * @param {Parent | null | undefined} [parent]
     * @param {unknown} [context]
     * @returns {boolean}
     */
    // eslint-disable-next-line max-params
    function is(node, test, index, parent, context) {
      const check = convert(test)

      if (
        index !== undefined &&
        index !== null &&
        (typeof index !== 'number' ||
          index < 0 ||
          index === Number.POSITIVE_INFINITY)
      ) {
        throw new Error('Expected positive finite index')
      }

      if (
        parent !== undefined &&
        parent !== null &&
        (!is(parent) || !parent.children)
      ) {
        throw new Error('Expected parent node')
      }

      if (
        (parent === undefined || parent === null) !==
        (index === undefined || index === null)
      ) {
        throw new Error('Expected both parent and index')
      }

      // @ts-expect-error Looks like a node.
      return node && node.type && typeof node.type === 'string'
        ? Boolean(check.call(context, node, index, parent))
        : false
    }
  )

/**
 * Generate an assertion from a test.
 *
 * Useful if you’re going to test many nodes, for example when creating a
 * utility where something else passes a compatible test.
 *
 * The created function is a bit faster because it expects valid input only:
 * a `node`, `index`, and `parent`.
 *
 * @param test
 *   *   when nullish, checks if `node` is a `Node`.
 *   *   when `string`, works like passing `(node) => node.type === test`.
 *   *   when `function` checks if function passed the node is true.
 *   *   when `object`, checks that all keys in test are in node, and that they have (strictly) equal values.
 *   *   when `array`, checks if any one of the subtests pass.
 * @returns
 *   An assertion.
 */
const convert =
  /**
   * @type {(
   *   (<Kind extends Node>(test: PredicateTest<Kind>) => AssertPredicate<Kind>) &
   *   ((test?: Test) => AssertAnything)
   * )}
   */
  (
    /**
     * @param {Test} [test]
     * @returns {AssertAnything}
     */
    function (test) {
      if (test === undefined || test === null) {
        return ok
      }

      if (typeof test === 'string') {
        return typeFactory(test)
      }

      if (typeof test === 'object') {
        return Array.isArray(test) ? anyFactory(test) : propsFactory(test)
      }

      if (typeof test === 'function') {
        return castFactory(test)
      }

      throw new Error('Expected function, string, or object as test')
    }
  )

/**
 * @param {Array<string | Props | TestFunctionAnything>} tests
 * @returns {AssertAnything}
 */
function anyFactory(tests) {
  /** @type {Array<AssertAnything>} */
  const checks = []
  let index = -1

  while (++index < tests.length) {
    checks[index] = convert(tests[index])
  }

  return castFactory(any)

  /**
   * @this {unknown}
   * @param {Array<unknown>} parameters
   * @returns {boolean}
   */
  function any(...parameters) {
    let index = -1

    while (++index < checks.length) {
      if (checks[index].call(this, ...parameters)) return true
    }

    return false
  }
}

/**
 * Turn an object into a test for a node with a certain fields.
 *
 * @param {Props} check
 * @returns {AssertAnything}
 */
function propsFactory(check) {
  return castFactory(all)

  /**
   * @param {Node} node
   * @returns {boolean}
   */
  function all(node) {
    /** @type {string} */
    let key

    for (key in check) {
      // @ts-expect-error: hush, it sure works as an index.
      if (node[key] !== check[key]) return false
    }

    return true
  }
}

/**
 * Turn a string into a test for a node with a certain type.
 *
 * @param {string} check
 * @returns {AssertAnything}
 */
function typeFactory(check) {
  return castFactory(type)

  /**
   * @param {Node} node
   */
  function type(node) {
    return node && node.type === check
  }
}

/**
 * Turn a custom test into a test for a node that passes that test.
 *
 * @param {TestFunctionAnything} check
 * @returns {AssertAnything}
 */
function castFactory(check) {
  return assertion

  /**
   * @this {unknown}
   * @param {unknown} node
   * @param {Array<unknown>} parameters
   * @returns {boolean}
   */
  function assertion(node, ...parameters) {
    return Boolean(
      node &&
        typeof node === 'object' &&
        'type' in node &&
        // @ts-expect-error: fine.
        Boolean(check.call(this, node, ...parameters))
    )
  }
}

function ok() {
  return true
}

;// CONCATENATED MODULE: ../node_modules/unist-util-visit-parents/lib/color.browser.js
/**
 * @param {string} d
 * @returns {string}
 */
function color(d) {
  return d
}

;// CONCATENATED MODULE: ../node_modules/unist-util-visit-parents/lib/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 */

/**
 * @typedef {boolean | 'skip'} Action
 *   Union of the action types.
 *
 * @typedef {number} Index
 *   Move to the sibling at `index` next (after node itself is completely
 *   traversed).
 *
 *   Useful if mutating the tree, such as removing the node the visitor is
 *   currently on, or any of its previous siblings.
 *   Results less than 0 or greater than or equal to `children.length` stop
 *   traversing the parent.
 *
 * @typedef {[(Action | null | undefined | void)?, (Index | null | undefined)?]} ActionTuple
 *   List with one or two values, the first an action, the second an index.
 *
 * @typedef {Action | ActionTuple | Index | null | undefined | void} VisitorResult
 *   Any value that can be returned from a visitor.
 */

/**
 * @template {Node} [Visited=Node]
 *   Visited node type.
 * @template {Parent} [Ancestor=Parent]
 *   Ancestor type.
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform the parent of node (the last of `ancestors`).
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of an ancestor still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Array<Ancestor>} ancestors
 *   Ancestors of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 */

/**
 * @template {Node} [Tree=Node]
 *   Tree type.
 * @template {Test} [Check=string]
 *   Test type.
 * @typedef {Visitor<import('./complex-types.js').Matches<import('./complex-types.js').InclusiveDescendant<Tree>, Check>, Extract<import('./complex-types.js').InclusiveDescendant<Tree>, Parent>>} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parents`.
 */




/**
 * Continue traversing as normal.
 */
const CONTINUE = true

/**
 * Stop traversing immediately.
 */
const EXIT = false

/**
 * Do not traverse this node’s children.
 */
const SKIP = 'skip'

/**
 * Visit nodes, with ancestral information.
 *
 * This algorithm performs *depth-first* *tree traversal* in *preorder*
 * (**NLR**) or if `reverse` is given, in *reverse preorder* (**NRL**).
 *
 * You can choose for which nodes `visitor` is called by passing a `test`.
 * For complex tests, you should test yourself in `visitor`, as it will be
 * faster and will have improved type information.
 *
 * Walking the tree is an intensive task.
 * Make use of the return values of the visitor when possible.
 * Instead of walking a tree multiple times, walk it once, use `unist-util-is`
 * to check if a node matches, and then perform different operations.
 *
 * You can change the tree.
 * See `Visitor` for more info.
 *
 * @param tree
 *   Tree to traverse.
 * @param test
 *   `unist-util-is`-compatible test
 * @param visitor
 *   Handle each node.
 * @param reverse
 *   Traverse in reverse preorder (NRL) instead of the default preorder (NLR).
 * @returns
 *   Nothing.
 */
const visitParents =
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */
  (
    /**
     * @param {Node} tree
     * @param {Test} test
     * @param {Visitor<Node>} visitor
     * @param {boolean | null | undefined} [reverse]
     * @returns {void}
     */
    function (tree, test, visitor, reverse) {
      if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor
        // @ts-expect-error no visitor given, so `visitor` is test.
        visitor = test
        test = null
      }

      const is = convert(test)
      const step = reverse ? -1 : 1

      factory(tree, undefined, [])()

      /**
       * @param {Node} node
       * @param {number | undefined} index
       * @param {Array<Parent>} parents
       */
      function factory(node, index, parents) {
        /** @type {Record<string, unknown>} */
        // @ts-expect-error: hush
        const value = node && typeof node === 'object' ? node : {}

        if (typeof value.type === 'string') {
          const name =
            // `hast`
            typeof value.tagName === 'string'
              ? value.tagName
              : // `xast`
              typeof value.name === 'string'
              ? value.name
              : undefined

          Object.defineProperty(visit, 'name', {
            value:
              'node (' + color(node.type + (name ? '<' + name + '>' : '')) + ')'
          })
        }

        return visit

        function visit() {
          /** @type {ActionTuple} */
          let result = []
          /** @type {ActionTuple} */
          let subresult
          /** @type {number} */
          let offset
          /** @type {Array<Parent>} */
          let grandparents

          if (!test || is(node, index, parents[parents.length - 1] || null)) {
            result = toResult(visitor(node, parents))

            if (result[0] === EXIT) {
              return result
            }
          }

          // @ts-expect-error looks like a parent.
          if (node.children && result[0] !== SKIP) {
            // @ts-expect-error looks like a parent.
            offset = (reverse ? node.children.length : -1) + step
            // @ts-expect-error looks like a parent.
            grandparents = parents.concat(node)

            // @ts-expect-error looks like a parent.
            while (offset > -1 && offset < node.children.length) {
              // @ts-expect-error looks like a parent.
              subresult = factory(node.children[offset], offset, grandparents)()

              if (subresult[0] === EXIT) {
                return subresult
              }

              offset =
                typeof subresult[1] === 'number' ? subresult[1] : offset + step
            }
          }

          return result
        }
      }
    }
  )

/**
 * Turn a return value into a clean result.
 *
 * @param {VisitorResult} value
 *   Valid return values from visitors.
 * @returns {ActionTuple}
 *   Clean result.
 */
function toResult(value) {
  if (Array.isArray(value)) {
    return value
  }

  if (typeof value === 'number') {
    return [CONTINUE, value]
  }

  return [value]
}

;// CONCATENATED MODULE: ../node_modules/unist-util-visit/lib/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */

/**
 * Check if `Child` can be a child of `Ancestor`.
 *
 * Returns the ancestor when `Child` can be a child of `Ancestor`, or returns
 * `never`.
 *
 * @template {Node} Ancestor
 *   Node type.
 * @template {Node} Child
 *   Node type.
 * @typedef {(
 *   Ancestor extends Parent
 *     ? Child extends Ancestor['children'][number]
 *       ? Ancestor
 *       : never
 *     : never
 * )} ParentsOf
 */

/**
 * @template {Node} [Visited=Node]
 *   Visited node type.
 * @template {Parent} [Ancestor=Parent]
 *   Ancestor type.
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform `parent`.
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of `parent` still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Visited extends Node ? number | null : never} index
 *   Index of `node` in `parent`.
 * @param {Ancestor extends Node ? Ancestor | null : never} parent
 *   Parent of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 */

/**
 * Build a typed `Visitor` function from a node and all possible parents.
 *
 * It will infer which values are passed as `node` and which as `parent`.
 *
 * @template {Node} Visited
 *   Node type.
 * @template {Parent} Ancestor
 *   Parent type.
 * @typedef {Visitor<Visited, ParentsOf<Ancestor, Visited>>} BuildVisitorFromMatch
 */

/**
 * Build a typed `Visitor` function from a list of descendants and a test.
 *
 * It will infer which values are passed as `node` and which as `parent`.
 *
 * @template {Node} Descendant
 *   Node type.
 * @template {Test} Check
 *   Test type.
 * @typedef {(
 *   BuildVisitorFromMatch<
 *     import('unist-util-visit-parents/complex-types.js').Matches<Descendant, Check>,
 *     Extract<Descendant, Parent>
 *   >
 * )} BuildVisitorFromDescendants
 */

/**
 * Build a typed `Visitor` function from a tree and a test.
 *
 * It will infer which values are passed as `node` and which as `parent`.
 *
 * @template {Node} [Tree=Node]
 *   Node type.
 * @template {Test} [Check=string]
 *   Test type.
 * @typedef {(
 *   BuildVisitorFromDescendants<
 *     import('unist-util-visit-parents/complex-types.js').InclusiveDescendant<Tree>,
 *     Check
 *   >
 * )} BuildVisitor
 */



/**
 * Visit nodes.
 *
 * This algorithm performs *depth-first* *tree traversal* in *preorder*
 * (**NLR**) or if `reverse` is given, in *reverse preorder* (**NRL**).
 *
 * You can choose for which nodes `visitor` is called by passing a `test`.
 * For complex tests, you should test yourself in `visitor`, as it will be
 * faster and will have improved type information.
 *
 * Walking the tree is an intensive task.
 * Make use of the return values of the visitor when possible.
 * Instead of walking a tree multiple times, walk it once, use `unist-util-is`
 * to check if a node matches, and then perform different operations.
 *
 * You can change the tree.
 * See `Visitor` for more info.
 *
 * @param tree
 *   Tree to traverse.
 * @param test
 *   `unist-util-is`-compatible test
 * @param visitor
 *   Handle each node.
 * @param reverse
 *   Traverse in reverse preorder (NRL) instead of the default preorder (NLR).
 * @returns
 *   Nothing.
 */
const visit =
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */
  (
    /**
     * @param {Node} tree
     * @param {Test} test
     * @param {Visitor} visitor
     * @param {boolean | null | undefined} [reverse]
     * @returns {void}
     */
    function (tree, test, visitor, reverse) {
      if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor
        visitor = test
        test = null
      }

      visitParents(tree, test, overload, reverse)

      /**
       * @param {Node} node
       * @param {Array<Parent>} parents
       */
      function overload(node, parents) {
        const parent = parents[parents.length - 1]
        return visitor(
          node,
          parent ? parent.children.indexOf(node) : null,
          parent
        )
      }
    }
  )



;// CONCATENATED MODULE: ../node_modules/unist-util-position/lib/index.js
/**
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 */

/**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */

/**
 * Get the starting point of `node`.
 *
 * @param node
 *   Node.
 * @returns
 *   Point.
 */
const pointStart = unist_util_position_lib_point('start')

/**
 * Get the ending point of `node`.
 *
 * @param node
 *   Node.
 * @returns
 *   Point.
 */
const pointEnd = unist_util_position_lib_point('end')

/**
 * Get the positional info of `node`.
 *
 * @param {NodeLike | Node | null | undefined} [node]
 *   Node.
 * @returns {Position}
 *   Position.
 */
function lib_position(node) {
  return {start: pointStart(node), end: pointEnd(node)}
}

/**
 * Get the positional info of `node`.
 *
 * @param {'start' | 'end'} type
 *   Side.
 * @returns
 *   Getter.
 */
function unist_util_position_lib_point(type) {
  return point

  /**
   * Get the point info of `node` at a bound side.
   *
   * @param {NodeLike | Node | null | undefined} [node]
   * @returns {Point}
   */
  function point(node) {
    const point = (node && node.position && node.position[type]) || {}

    // To do: next major: don’t return points when invalid.
    return {
      // @ts-expect-error: in practice, null is allowed.
      line: point.line || null,
      // @ts-expect-error: in practice, null is allowed.
      column: point.column || null,
      // @ts-expect-error: in practice, null is allowed.
      offset: point.offset > -1 ? point.offset : null
    }
  }
}

;// CONCATENATED MODULE: ../node_modules/unist-util-generated/lib/index.js
/**
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef NodeLike
 * @property {PositionLike | null | undefined} [position]
 */

/**
 * Check if `node` is generated.
 *
 * @param {NodeLike | null | undefined} [node]
 *   Node to check.
 * @returns {boolean}
 *   Whether `node` is generated (does not have positional info).
 */
function generated(node) {
  return (
    !node ||
    !node.position ||
    !node.position.start ||
    !node.position.start.line ||
    !node.position.start.column ||
    !node.position.end ||
    !node.position.end.line ||
    !node.position.end.column
  )
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-definitions/lib/index.js
/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Definition} Definition
 */

/**
 * @typedef {Root | Content} Node
 *
 * @callback GetDefinition
 *   Get a definition by identifier.
 * @param {string | null | undefined} [identifier]
 *   Identifier of definition.
 * @returns {Definition | null}
 *   Definition corresponding to `identifier` or `null`.
 */



const mdast_util_definitions_lib_own = {}.hasOwnProperty

/**
 * Find definitions in `tree`.
 *
 * Uses CommonMark precedence, which means that earlier definitions are
 * preferred over duplicate later definitions.
 *
 * @param {Node} tree
 *   Tree to check.
 * @returns {GetDefinition}
 *   Getter.
 */
function definitions(tree) {
  /** @type {Record<string, Definition>} */
  const cache = Object.create(null)

  if (!tree || !tree.type) {
    throw new Error('mdast-util-definitions expected node')
  }

  visit(tree, 'definition', (definition) => {
    const id = clean(definition.identifier)
    if (id && !mdast_util_definitions_lib_own.call(cache, id)) {
      cache[id] = definition
    }
  })

  return definition

  /** @type {GetDefinition} */
  function definition(identifier) {
    const id = clean(identifier)
    // To do: next major: return `undefined` when not found.
    return id && mdast_util_definitions_lib_own.call(cache, id) ? cache[id] : null
  }
}

/**
 * @param {string | null | undefined} [value]
 * @returns {string}
 */
function clean(value) {
  return String(value || '').toUpperCase()
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/blockquote.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `blockquote` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Blockquote} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function blockquote(state, node) {
  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'blockquote',
    properties: {},
    children: state.wrap(state.all(node), true)
  }
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/break.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').Break} Break
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `break` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Break} node
 *   mdast node.
 * @returns {Array<Element | Text>}
 *   hast element content.
 */
function hardBreak(state, node) {
  /** @type {Element} */
  const result = {type: 'element', tagName: 'br', properties: {}, children: []}
  state.patch(node, result)
  return [state.applyData(node, result), {type: 'text', value: '\n'}]
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/code.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Code} Code
 * @typedef {import('../state.js').State} State

 */

/**
 * Turn an mdast `code` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Code} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function code(state, node) {
  const value = node.value ? node.value + '\n' : ''
  // To do: next major, use `node.lang` w/o regex, the splitting’s been going
  // on for years in remark now.
  const lang = node.lang ? node.lang.match(/^[^ \t]+(?=[ \t]|$)/) : null
  /** @type {Properties} */
  const properties = {}

  if (lang) {
    properties.className = ['language-' + lang]
  }

  // Create `<code>`.
  /** @type {Element} */
  let result = {
    type: 'element',
    tagName: 'code',
    properties,
    children: [{type: 'text', value}]
  }

  if (node.meta) {
    result.data = {meta: node.meta}
  }

  state.patch(node, result)
  result = state.applyData(node, result)

  // Create `<pre>`.
  result = {type: 'element', tagName: 'pre', properties: {}, children: [result]}
  state.patch(node, result)
  return result
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/delete.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Delete} Delete
 * @typedef {import('../state.js').State} State

 */

/**
 * Turn an mdast `delete` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Delete} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function strikethrough(state, node) {
  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'del',
    properties: {},
    children: state.all(node)
  }
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/emphasis.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `emphasis` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Emphasis} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function emphasis(state, node) {
  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'em',
    properties: {},
    children: state.all(node)
  }
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/footnote-reference.js
/**
 * @typedef {import('mdast').FootnoteReference} FootnoteReference
 * @typedef {import('hast').Element} Element
 * @typedef {import('../state.js').State} State
 */



/**
 * Turn an mdast `footnoteReference` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {FootnoteReference} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function footnoteReference(state, node) {
  const id = String(node.identifier).toUpperCase()
  const safeId = normalizeUri(id.toLowerCase())
  const index = state.footnoteOrder.indexOf(id)
  /** @type {number} */
  let counter

  if (index === -1) {
    state.footnoteOrder.push(id)
    state.footnoteCounts[id] = 1
    counter = state.footnoteOrder.length
  } else {
    state.footnoteCounts[id]++
    counter = index + 1
  }

  const reuseCounter = state.footnoteCounts[id]

  /** @type {Element} */
  const link = {
    type: 'element',
    tagName: 'a',
    properties: {
      href: '#' + state.clobberPrefix + 'fn-' + safeId,
      id:
        state.clobberPrefix +
        'fnref-' +
        safeId +
        (reuseCounter > 1 ? '-' + reuseCounter : ''),
      dataFootnoteRef: true,
      ariaDescribedBy: ['footnote-label']
    },
    children: [{type: 'text', value: String(counter)}]
  }
  state.patch(node, link)

  /** @type {Element} */
  const sup = {
    type: 'element',
    tagName: 'sup',
    properties: {},
    children: [link]
  }
  state.patch(node, sup)
  return state.applyData(node, sup)
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/footnote.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Footnote} Footnote
 * @typedef {import('../state.js').State} State
 */



// To do: when both:
// * <https://github.com/micromark/micromark-extension-footnote>
// * <https://github.com/syntax-tree/mdast-util-footnote>
// …are archived, remove this (also from mdast).
// These inline notes are not used in GFM.

/**
 * Turn an mdast `footnote` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Footnote} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function footnote(state, node) {
  const footnoteById = state.footnoteById
  let no = 1

  while (no in footnoteById) no++

  const identifier = String(no)

  footnoteById[identifier] = {
    type: 'footnoteDefinition',
    identifier,
    children: [{type: 'paragraph', children: node.children}],
    position: node.position
  }

  return footnoteReference(state, {
    type: 'footnoteReference',
    identifier,
    position: node.position
  })
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/heading.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `heading` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Heading} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function heading(state, node) {
  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'h' + node.depth,
    properties: {},
    children: state.all(node)
  }
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/html.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').HTML} Html
 * @typedef {import('../state.js').State} State
 * @typedef {import('../../index.js').Raw} Raw
 */

/**
 * Turn an mdast `html` node into hast (`raw` node in dangerous mode, otherwise
 * nothing).
 *
 * @param {State} state
 *   Info passed around.
 * @param {Html} node
 *   mdast node.
 * @returns {Raw | Element | null}
 *   hast node.
 */
function html(state, node) {
  if (state.dangerous) {
    /** @type {Raw} */
    const result = {type: 'raw', value: node.value}
    state.patch(node, result)
    return state.applyData(node, result)
  }

  // To do: next major: return `undefined`.
  return null
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/revert.js
/**
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Reference} Reference
 * @typedef {import('mdast').Root} Root
 *
 * @typedef {import('./state.js').State} State
 */

/**
 * @typedef {Root | Content} Nodes
 * @typedef {Extract<Nodes, Reference>} References
 */

// To do: next major: always return array.

/**
 * Return the content of a reference without definition as plain text.
 *
 * @param {State} state
 *   Info passed around.
 * @param {References} node
 *   Reference node (image, link).
 * @returns {ElementContent | Array<ElementContent>}
 *   hast content.
 */
function revert(state, node) {
  const subtype = node.referenceType
  let suffix = ']'

  if (subtype === 'collapsed') {
    suffix += '[]'
  } else if (subtype === 'full') {
    suffix += '[' + (node.label || node.identifier) + ']'
  }

  if (node.type === 'imageReference') {
    return {type: 'text', value: '![' + node.alt + suffix}
  }

  const contents = state.all(node)
  const head = contents[0]

  if (head && head.type === 'text') {
    head.value = '[' + head.value
  } else {
    contents.unshift({type: 'text', value: '['})
  }

  const tail = contents[contents.length - 1]

  if (tail && tail.type === 'text') {
    tail.value += suffix
  } else {
    contents.push({type: 'text', value: suffix})
  }

  return contents
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/image-reference.js
/**
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('../state.js').State} State
 */




/**
 * Turn an mdast `imageReference` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ImageReference} node
 *   mdast node.
 * @returns {ElementContent | Array<ElementContent>}
 *   hast node.
 */
function imageReference(state, node) {
  const def = state.definition(node.identifier)

  if (!def) {
    return revert(state, node)
  }

  /** @type {Properties} */
  const properties = {src: normalizeUri(def.url || ''), alt: node.alt}

  if (def.title !== null && def.title !== undefined) {
    properties.title = def.title
  }

  /** @type {Element} */
  const result = {type: 'element', tagName: 'img', properties, children: []}
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/image.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Image} Image
 * @typedef {import('../state.js').State} State
 */



/**
 * Turn an mdast `image` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Image} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function image_image(state, node) {
  /** @type {Properties} */
  const properties = {src: normalizeUri(node.url)}

  if (node.alt !== null && node.alt !== undefined) {
    properties.alt = node.alt
  }

  if (node.title !== null && node.title !== undefined) {
    properties.title = node.title
  }

  /** @type {Element} */
  const result = {type: 'element', tagName: 'img', properties, children: []}
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/inline-code.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `inlineCode` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {InlineCode} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function inlineCode(state, node) {
  /** @type {Text} */
  const text = {type: 'text', value: node.value.replace(/\r?\n|\r/g, ' ')}
  state.patch(node, text)

  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'code',
    properties: {},
    children: [text]
  }
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/link-reference.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('../state.js').State} State
 */




/**
 * Turn an mdast `linkReference` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {LinkReference} node
 *   mdast node.
 * @returns {ElementContent | Array<ElementContent>}
 *   hast node.
 */
function linkReference(state, node) {
  const def = state.definition(node.identifier)

  if (!def) {
    return revert(state, node)
  }

  /** @type {Properties} */
  const properties = {href: normalizeUri(def.url || '')}

  if (def.title !== null && def.title !== undefined) {
    properties.title = def.title
  }

  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'a',
    properties,
    children: state.all(node)
  }
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/link.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Link} Link
 * @typedef {import('../state.js').State} State
 */



/**
 * Turn an mdast `link` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Link} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function link_link(state, node) {
  /** @type {Properties} */
  const properties = {href: normalizeUri(node.url)}

  if (node.title !== null && node.title !== undefined) {
    properties.title = node.title
  }

  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'a',
    properties,
    children: state.all(node)
  }
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/list-item.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('../state.js').State} State
 */

/**
 * @typedef {Root | Content} Nodes
 * @typedef {Extract<Nodes, Parent>} Parents
 */

/**
 * Turn an mdast `listItem` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ListItem} node
 *   mdast node.
 * @param {Parents | null | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */
function listItem(state, node, parent) {
  const results = state.all(node)
  const loose = parent ? listLoose(parent) : listItemLoose(node)
  /** @type {Properties} */
  const properties = {}
  /** @type {Array<ElementContent>} */
  const children = []

  if (typeof node.checked === 'boolean') {
    const head = results[0]
    /** @type {Element} */
    let paragraph

    if (head && head.type === 'element' && head.tagName === 'p') {
      paragraph = head
    } else {
      paragraph = {type: 'element', tagName: 'p', properties: {}, children: []}
      results.unshift(paragraph)
    }

    if (paragraph.children.length > 0) {
      paragraph.children.unshift({type: 'text', value: ' '})
    }

    paragraph.children.unshift({
      type: 'element',
      tagName: 'input',
      properties: {type: 'checkbox', checked: node.checked, disabled: true},
      children: []
    })

    // According to github-markdown-css, this class hides bullet.
    // See: <https://github.com/sindresorhus/github-markdown-css>.
    properties.className = ['task-list-item']
  }

  let index = -1

  while (++index < results.length) {
    const child = results[index]

    // Add eols before nodes, except if this is a loose, first paragraph.
    if (
      loose ||
      index !== 0 ||
      child.type !== 'element' ||
      child.tagName !== 'p'
    ) {
      children.push({type: 'text', value: '\n'})
    }

    if (child.type === 'element' && child.tagName === 'p' && !loose) {
      children.push(...child.children)
    } else {
      children.push(child)
    }
  }

  const tail = results[results.length - 1]

  // Add a final eol.
  if (tail && (loose || tail.type !== 'element' || tail.tagName !== 'p')) {
    children.push({type: 'text', value: '\n'})
  }

  /** @type {Element} */
  const result = {type: 'element', tagName: 'li', properties, children}
  state.patch(node, result)
  return state.applyData(node, result)
}

/**
 * @param {Parents} node
 * @return {Boolean}
 */
function listLoose(node) {
  let loose = false
  if (node.type === 'list') {
    loose = node.spread || false
    const children = node.children
    let index = -1

    while (!loose && ++index < children.length) {
      loose = listItemLoose(children[index])
    }
  }

  return loose
}

/**
 * @param {ListItem} node
 * @return {Boolean}
 */
function listItemLoose(node) {
  const spread = node.spread

  return spread === undefined || spread === null
    ? node.children.length > 1
    : spread
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/list.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').List} List
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `list` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {List} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function list_list(state, node) {
  /** @type {Properties} */
  const properties = {}
  const results = state.all(node)
  let index = -1

  if (typeof node.start === 'number' && node.start !== 1) {
    properties.start = node.start
  }

  // Like GitHub, add a class for custom styling.
  while (++index < results.length) {
    const child = results[index]

    if (
      child.type === 'element' &&
      child.tagName === 'li' &&
      child.properties &&
      Array.isArray(child.properties.className) &&
      child.properties.className.includes('task-list-item')
    ) {
      properties.className = ['contains-task-list']
      break
    }
  }

  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: node.ordered ? 'ol' : 'ul',
    properties,
    children: state.wrap(results, true)
  }
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/paragraph.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `paragraph` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Paragraph} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function paragraph(state, node) {
  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'p',
    properties: {},
    children: state.all(node)
  }
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/root.js
/**
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `root` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastRoot} node
 *   mdast node.
 * @returns {HastRoot | HastElement}
 *   hast node.
 */
function root(state, node) {
  /** @type {HastRoot} */
  const result = {type: 'root', children: state.wrap(state.all(node))}
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/strong.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `strong` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Strong} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function strong(state, node) {
  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'strong',
    properties: {},
    children: state.all(node)
  }
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/table.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Table} Table
 * @typedef {import('../state.js').State} State
 */



/**
 * Turn an mdast `table` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Table} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function table(state, node) {
  const rows = state.all(node)
  const firstRow = rows.shift()
  /** @type {Array<Element>} */
  const tableContent = []

  if (firstRow) {
    /** @type {Element} */
    const head = {
      type: 'element',
      tagName: 'thead',
      properties: {},
      children: state.wrap([firstRow], true)
    }
    state.patch(node.children[0], head)
    tableContent.push(head)
  }

  if (rows.length > 0) {
    /** @type {Element} */
    const body = {
      type: 'element',
      tagName: 'tbody',
      properties: {},
      children: state.wrap(rows, true)
    }

    const start = pointStart(node.children[1])
    const end = pointEnd(node.children[node.children.length - 1])
    if (start.line && end.line) body.position = {start, end}
    tableContent.push(body)
  }

  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'table',
    properties: {},
    children: state.wrap(tableContent, true)
  }
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/table-row.js
/**
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').TableRow} TableRow
 * @typedef {import('../state.js').State} State
 */

/**
 * @typedef {Root | Content} Nodes
 * @typedef {Extract<Nodes, Parent>} Parents
 */

/**
 * Turn an mdast `tableRow` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableRow} node
 *   mdast node.
 * @param {Parents | null | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */
function tableRow(state, node, parent) {
  const siblings = parent ? parent.children : undefined
  // Generate a body row when without parent.
  const rowIndex = siblings ? siblings.indexOf(node) : 1
  const tagName = rowIndex === 0 ? 'th' : 'td'
  const align = parent && parent.type === 'table' ? parent.align : undefined
  const length = align ? align.length : node.children.length
  let cellIndex = -1
  /** @type {Array<ElementContent>} */
  const cells = []

  while (++cellIndex < length) {
    // Note: can also be undefined.
    const cell = node.children[cellIndex]
    /** @type {Properties} */
    const properties = {}
    const alignValue = align ? align[cellIndex] : undefined

    if (alignValue) {
      properties.align = alignValue
    }

    /** @type {Element} */
    let result = {type: 'element', tagName, properties, children: []}

    if (cell) {
      result.children = state.all(cell)
      state.patch(cell, result)
      result = state.applyData(node, result)
    }

    cells.push(result)
  }

  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'tr',
    properties: {},
    children: state.wrap(cells, true)
  }
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/table-cell.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `tableCell` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableCell} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function tableCell(state, node) {
  // Note: this function is normally not called: see `table-row` for how rows
  // and their cells are compiled.
  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'td', // Assume body cell.
    properties: {},
    children: state.all(node)
  }
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ../node_modules/trim-lines/index.js
const tab = 9 /* `\t` */
const space = 32 /* ` ` */

/**
 * Remove initial and final spaces and tabs at the line breaks in `value`.
 * Does not trim initial and final spaces and tabs of the value itself.
 *
 * @param {string} value
 *   Value to trim.
 * @returns {string}
 *   Trimmed value.
 */
function trimLines(value) {
  const source = String(value)
  const search = /\r?\n|\r/g
  let match = search.exec(source)
  let last = 0
  /** @type {Array<string>} */
  const lines = []

  while (match) {
    lines.push(
      trimLine(source.slice(last, match.index), last > 0, true),
      match[0]
    )

    last = match.index + match[0].length
    match = search.exec(source)
  }

  lines.push(trimLine(source.slice(last), last > 0, false))

  return lines.join('')
}

/**
 * @param {string} value
 *   Line to trim.
 * @param {boolean} start
 *   Whether to trim the start of the line.
 * @param {boolean} end
 *   Whether to trim the end of the line.
 * @returns {string}
 *   Trimmed line.
 */
function trimLine(value, start, end) {
  let startIndex = 0
  let endIndex = value.length

  if (start) {
    let code = value.codePointAt(startIndex)

    while (code === tab || code === space) {
      startIndex++
      code = value.codePointAt(startIndex)
    }
  }

  if (end) {
    let code = value.codePointAt(endIndex - 1)

    while (code === tab || code === space) {
      endIndex--
      code = value.codePointAt(endIndex - 1)
    }
  }

  return endIndex > startIndex ? value.slice(startIndex, endIndex) : ''
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/text.js
/**
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').Text} HastText
 * @typedef {import('mdast').Text} MdastText
 * @typedef {import('../state.js').State} State
 */



/**
 * Turn an mdast `text` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastText} node
 *   mdast node.
 * @returns {HastText | HastElement}
 *   hast node.
 */
function handlers_text_text(state, node) {
  /** @type {HastText} */
  const result = {type: 'text', value: trimLines(String(node.value))}
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/thematic-break.js
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('../state.js').State} State
 */

/**
 * Turn an mdast `thematicBreak` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ThematicBreak} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */
function thematic_break_thematicBreak(state, node) {
  /** @type {Element} */
  const result = {
    type: 'element',
    tagName: 'hr',
    properties: {},
    children: []
  }
  state.patch(node, result)
  return state.applyData(node, result)
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/handlers/index.js

























/**
 * Default handlers for nodes.
 */
const handlers = {
  blockquote: blockquote,
  break: hardBreak,
  code: code,
  delete: strikethrough,
  emphasis: emphasis,
  footnoteReference: footnoteReference,
  footnote: footnote,
  heading: heading,
  html: html,
  imageReference: imageReference,
  image: image_image,
  inlineCode: inlineCode,
  linkReference: linkReference,
  link: link_link,
  listItem: listItem,
  list: list_list,
  paragraph: paragraph,
  root: root,
  strong: strong,
  table: table,
  tableCell: tableCell,
  tableRow: tableRow,
  text: handlers_text_text,
  thematicBreak: thematic_break_thematicBreak,
  toml: ignore,
  yaml: ignore,
  definition: ignore,
  footnoteDefinition: ignore
}

// Return nothing for nodes that are ignored.
function ignore() {
  // To do: next major: return `undefined`.
  return null
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/state.js
/**
 * @typedef {import('hast').Content} HastContent
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').ElementContent} HastElementContent
 * @typedef {import('hast').Properties} HastProperties
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('hast').Text} HastText
 *
 * @typedef {import('mdast').Content} MdastContent
 * @typedef {import('mdast').Definition} MdastDefinition
 * @typedef {import('mdast').FootnoteDefinition} MdastFootnoteDefinition
 * @typedef {import('mdast').Parent} MdastParent
 * @typedef {import('mdast').Root} MdastRoot
 */

/**
 * @typedef {HastRoot | HastContent} HastNodes
 * @typedef {MdastRoot | MdastContent} MdastNodes
 * @typedef {Extract<MdastNodes, MdastParent>} MdastParents
 *
 * @typedef EmbeddedHastFields
 *   hast fields.
 * @property {string | null | undefined} [hName]
 *   Generate a specific element with this tag name instead.
 * @property {HastProperties | null | undefined} [hProperties]
 *   Generate an element with these properties instead.
 * @property {Array<HastElementContent> | null | undefined} [hChildren]
 *   Generate an element with this content instead.
 *
 * @typedef {Record<string, unknown> & EmbeddedHastFields} MdastData
 *   mdast data with embedded hast fields.
 *
 * @typedef {MdastNodes & {data?: MdastData | null | undefined}} MdastNodeWithData
 *   mdast node with embedded hast data.
 *
 * @typedef PointLike
 *   Point-like value.
 * @property {number | null | undefined} [line]
 *   Line.
 * @property {number | null | undefined} [column]
 *   Column.
 * @property {number | null | undefined} [offset]
 *   Offset.
 *
 * @typedef PositionLike
 *   Position-like value.
 * @property {PointLike | null | undefined} [start]
 *   Point-like value.
 * @property {PointLike | null | undefined} [end]
 *   Point-like value.
 *
 * @callback Handler
 *   Handle a node.
 * @param {State} state
 *   Info passed around.
 * @param {any} node
 *   mdast node to handle.
 * @param {MdastParents | null | undefined} parent
 *   Parent of `node`.
 * @returns {HastElementContent | Array<HastElementContent> | null | undefined}
 *   hast node.
 *
 * @callback HFunctionProps
 *   Signature of `state` for when props are passed.
 * @param {MdastNodes | PositionLike | null | undefined} node
 *   mdast node or unist position.
 * @param {string} tagName
 *   HTML tag name.
 * @param {HastProperties} props
 *   Properties.
 * @param {Array<HastElementContent> | null | undefined} [children]
 *   hast content.
 * @returns {HastElement}
 *   Compiled element.
 *
 * @callback HFunctionNoProps
 *   Signature of `state` for when no props are passed.
 * @param {MdastNodes | PositionLike | null | undefined} node
 *   mdast node or unist position.
 * @param {string} tagName
 *   HTML tag name.
 * @param {Array<HastElementContent> | null | undefined} [children]
 *   hast content.
 * @returns {HastElement}
 *   Compiled element.
 *
 * @typedef HFields
 *   Info on `state`.
 * @property {boolean} dangerous
 *   Whether HTML is allowed.
 * @property {string} clobberPrefix
 *   Prefix to use to prevent DOM clobbering.
 * @property {string} footnoteLabel
 *   Label to use to introduce the footnote section.
 * @property {string} footnoteLabelTagName
 *   HTML used for the footnote label.
 * @property {HastProperties} footnoteLabelProperties
 *   Properties on the HTML tag used for the footnote label.
 * @property {string} footnoteBackLabel
 *   Label to use from backreferences back to their footnote call.
 * @property {(identifier: string) => MdastDefinition | null} definition
 *   Definition cache.
 * @property {Record<string, MdastFootnoteDefinition>} footnoteById
 *   Footnote definitions by their identifier.
 * @property {Array<string>} footnoteOrder
 *   Identifiers of order when footnote calls first appear in tree order.
 * @property {Record<string, number>} footnoteCounts
 *   Counts for how often the same footnote was called.
 * @property {Handlers} handlers
 *   Applied handlers.
 * @property {Handler} unknownHandler
 *   Handler for any none not in `passThrough` or otherwise handled.
 * @property {(from: MdastNodes, node: HastNodes) => void} patch
 *   Copy a node’s positional info.
 * @property {<Type extends HastNodes>(from: MdastNodes, to: Type) => Type | HastElement} applyData
 *   Honor the `data` of `from`, and generate an element instead of `node`.
 * @property {(node: MdastNodes, parent: MdastParents | null | undefined) => HastElementContent | Array<HastElementContent> | null | undefined} one
 *   Transform an mdast node to hast.
 * @property {(node: MdastNodes) => Array<HastElementContent>} all
 *   Transform the children of an mdast parent to hast.
 * @property {<Type extends HastContent>(nodes: Array<Type>, loose?: boolean | null | undefined) => Array<Type | HastText>} wrap
 *   Wrap `nodes` with line endings between each node, adds initial/final line endings when `loose`.
 * @property {(left: MdastNodeWithData | PositionLike | null | undefined, right: HastElementContent) => HastElementContent} augment
 *   Like `state` but lower-level and usable on non-elements.
 *   Deprecated: use `patch` and `applyData`.
 * @property {Array<string>} passThrough
 *   List of node types to pass through untouched (except for their children).
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [allowDangerousHtml=false]
 *   Whether to persist raw HTML in markdown in the hast tree.
 * @property {string | null | undefined} [clobberPrefix='user-content-']
 *   Prefix to use before the `id` attribute on footnotes to prevent it from
 *   *clobbering*.
 * @property {string | null | undefined} [footnoteBackLabel='Back to content']
 *   Label to use from backreferences back to their footnote call (affects
 *   screen readers).
 * @property {string | null | undefined} [footnoteLabel='Footnotes']
 *   Label to use for the footnotes section (affects screen readers).
 * @property {HastProperties | null | undefined} [footnoteLabelProperties={className: ['sr-only']}]
 *   Properties to use on the footnote label (note that `id: 'footnote-label'`
 *   is always added as footnote calls use it with `aria-describedby` to
 *   provide an accessible label).
 * @property {string | null | undefined} [footnoteLabelTagName='h2']
 *   Tag name to use for the footnote label.
 * @property {Handlers | null | undefined} [handlers]
 *   Extra handlers for nodes.
 * @property {Array<string> | null | undefined} [passThrough]
 *   List of custom mdast node types to pass through (keep) in hast (note that
 *   the node itself is passed, but eventual children are transformed).
 * @property {Handler | null | undefined} [unknownHandler]
 *   Handler for all unknown nodes.
 *
 * @typedef {Record<string, Handler>} Handlers
 *   Handle nodes.
 *
 * @typedef {HFunctionProps & HFunctionNoProps & HFields} State
 *   Info passed around.
 */







const state_own = {}.hasOwnProperty

/**
 * Create `state` from an mdast tree.
 *
 * @param {MdastNodes} tree
 *   mdast node to transform.
 * @param {Options | null | undefined} [options]
 *   Configuration.
 * @returns {State}
 *   `state` function.
 */
function createState(tree, options) {
  const settings = options || {}
  const dangerous = settings.allowDangerousHtml || false
  /** @type {Record<string, MdastFootnoteDefinition>} */
  const footnoteById = {}

  // To do: next major: add `options` to state, remove:
  // `dangerous`, `clobberPrefix`, `footnoteLabel`, `footnoteLabelTagName`,
  // `footnoteLabelProperties`, `footnoteBackLabel`, `passThrough`,
  // `unknownHandler`.

  // To do: next major: move to `state.options.allowDangerousHtml`.
  state.dangerous = dangerous
  // To do: next major: move to `state.options`.
  state.clobberPrefix =
    settings.clobberPrefix === undefined || settings.clobberPrefix === null
      ? 'user-content-'
      : settings.clobberPrefix
  // To do: next major: move to `state.options`.
  state.footnoteLabel = settings.footnoteLabel || 'Footnotes'
  // To do: next major: move to `state.options`.
  state.footnoteLabelTagName = settings.footnoteLabelTagName || 'h2'
  // To do: next major: move to `state.options`.
  state.footnoteLabelProperties = settings.footnoteLabelProperties || {
    className: ['sr-only']
  }
  // To do: next major: move to `state.options`.
  state.footnoteBackLabel = settings.footnoteBackLabel || 'Back to content'
  // To do: next major: move to `state.options`.
  state.unknownHandler = settings.unknownHandler
  // To do: next major: move to `state.options`.
  state.passThrough = settings.passThrough

  state.handlers = {...handlers, ...settings.handlers}

  // To do: next major: replace utility with `definitionById` object, so we
  // only walk once (as we need footnotes too).
  state.definition = definitions(tree)
  state.footnoteById = footnoteById
  /** @type {Array<string>} */
  state.footnoteOrder = []
  /** @type {Record<string, number>} */
  state.footnoteCounts = {}

  state.patch = patch
  state.applyData = applyData
  state.one = oneBound
  state.all = allBound
  state.wrap = state_wrap
  // To do: next major: remove `augment`.
  state.augment = augment

  visit(tree, 'footnoteDefinition', (definition) => {
    const id = String(definition.identifier).toUpperCase()

    // Mimick CM behavior of link definitions.
    // See: <https://github.com/syntax-tree/mdast-util-definitions/blob/8290999/index.js#L26>.
    if (!state_own.call(footnoteById, id)) {
      footnoteById[id] = definition
    }
  })

  // @ts-expect-error Hush, it’s fine!
  return state

  /**
   * Finalise the created `right`, a hast node, from `left`, an mdast node.
   *
   * @param {MdastNodeWithData | PositionLike | null | undefined} left
   * @param {HastElementContent} right
   * @returns {HastElementContent}
   */
  /* c8 ignore start */
  // To do: next major: remove.
  function augment(left, right) {
    // Handle `data.hName`, `data.hProperties, `data.hChildren`.
    if (left && 'data' in left && left.data) {
      /** @type {MdastData} */
      const data = left.data

      if (data.hName) {
        if (right.type !== 'element') {
          right = {
            type: 'element',
            tagName: '',
            properties: {},
            children: []
          }
        }

        right.tagName = data.hName
      }

      if (right.type === 'element' && data.hProperties) {
        right.properties = {...right.properties, ...data.hProperties}
      }

      if ('children' in right && right.children && data.hChildren) {
        right.children = data.hChildren
      }
    }

    if (left) {
      const ctx = 'type' in left ? left : {position: left}

      if (!generated(ctx)) {
        // @ts-expect-error: fine.
        right.position = {start: pointStart(ctx), end: pointEnd(ctx)}
      }
    }

    return right
  }
  /* c8 ignore stop */

  /**
   * Create an element for `node`.
   *
   * @type {HFunctionProps}
   */
  /* c8 ignore start */
  // To do: next major: remove.
  function state(node, tagName, props, children) {
    if (Array.isArray(props)) {
      children = props
      props = {}
    }

    // @ts-expect-error augmenting an element yields an element.
    return augment(node, {
      type: 'element',
      tagName,
      properties: props || {},
      children: children || []
    })
  }
  /* c8 ignore stop */

  /**
   * Transform an mdast node into a hast node.
   *
   * @param {MdastNodes} node
   *   mdast node.
   * @param {MdastParents | null | undefined} [parent]
   *   Parent of `node`.
   * @returns {HastElementContent | Array<HastElementContent> | null | undefined}
   *   Resulting hast node.
   */
  function oneBound(node, parent) {
    // @ts-expect-error: that’s a state :)
    return state_one(state, node, parent)
  }

  /**
   * Transform the children of an mdast node into hast nodes.
   *
   * @param {MdastNodes} parent
   *   mdast node to compile
   * @returns {Array<HastElementContent>}
   *   Resulting hast nodes.
   */
  function allBound(parent) {
    // @ts-expect-error: that’s a state :)
    return state_all(state, parent)
  }
}

/**
 * Copy a node’s positional info.
 *
 * @param {MdastNodes} from
 *   mdast node to copy from.
 * @param {HastNodes} to
 *   hast node to copy into.
 * @returns {void}
 *   Nothing.
 */
function patch(from, to) {
  if (from.position) to.position = lib_position(from)
}

/**
 * Honor the `data` of `from` and maybe generate an element instead of `to`.
 *
 * @template {HastNodes} Type
 *   Node type.
 * @param {MdastNodes} from
 *   mdast node to use data from.
 * @param {Type} to
 *   hast node to change.
 * @returns {Type | HastElement}
 *   Nothing.
 */
function applyData(from, to) {
  /** @type {Type | HastElement} */
  let result = to

  // Handle `data.hName`, `data.hProperties, `data.hChildren`.
  if (from && from.data) {
    const hName = from.data.hName
    const hChildren = from.data.hChildren
    const hProperties = from.data.hProperties

    if (typeof hName === 'string') {
      // Transforming the node resulted in an element with a different name
      // than wanted:
      if (result.type === 'element') {
        result.tagName = hName
      }
      // Transforming the node resulted in a non-element, which happens for
      // raw, text, and root nodes (unless custom handlers are passed).
      // The intent is likely to keep the content around (otherwise: pass
      // `hChildren`).
      else {
        result = {
          type: 'element',
          tagName: hName,
          properties: {},
          children: []
        }

        // To do: next major: take the children from the `root`, or inject the
        // raw/text/comment or so into the element?
        // if ('children' in node) {
        //   // @ts-expect-error: assume `children` are allowed in elements.
        //   result.children = node.children
        // } else {
        //   // @ts-expect-error: assume `node` is allowed in elements.
        //   result.children.push(node)
        // }
      }
    }

    if (result.type === 'element' && hProperties) {
      result.properties = {...result.properties, ...hProperties}
    }

    if (
      'children' in result &&
      result.children &&
      hChildren !== null &&
      hChildren !== undefined
    ) {
      // @ts-expect-error: assume valid children are defined.
      result.children = hChildren
    }
  }

  return result
}

/**
 * Transform an mdast node into a hast node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastNodes} node
 *   mdast node.
 * @param {MdastParents | null | undefined} [parent]
 *   Parent of `node`.
 * @returns {HastElementContent | Array<HastElementContent> | null | undefined}
 *   Resulting hast node.
 */
// To do: next major: do not expose, keep bound.
function state_one(state, node, parent) {
  const type = node && node.type

  // Fail on non-nodes.
  if (!type) {
    throw new Error('Expected node, got `' + node + '`')
  }

  if (state_own.call(state.handlers, type)) {
    return state.handlers[type](state, node, parent)
  }

  if (state.passThrough && state.passThrough.includes(type)) {
    // To do: next major: deep clone.
    // @ts-expect-error: types of passed through nodes are expected to be added manually.
    return 'children' in node ? {...node, children: state_all(state, node)} : node
  }

  if (state.unknownHandler) {
    return state.unknownHandler(state, node, parent)
  }

  return defaultUnknownHandler(state, node)
}

/**
 * Transform the children of an mdast node into hast nodes.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastNodes} parent
 *   mdast node to compile
 * @returns {Array<HastElementContent>}
 *   Resulting hast nodes.
 */
// To do: next major: do not expose, keep bound.
function state_all(state, parent) {
  /** @type {Array<HastElementContent>} */
  const values = []

  if ('children' in parent) {
    const nodes = parent.children
    let index = -1
    while (++index < nodes.length) {
      const result = state_one(state, nodes[index], parent)

      // To do: see if we van clean this? Can we merge texts?
      if (result) {
        if (index && nodes[index - 1].type === 'break') {
          if (!Array.isArray(result) && result.type === 'text') {
            result.value = result.value.replace(/^\s+/, '')
          }

          if (!Array.isArray(result) && result.type === 'element') {
            const head = result.children[0]

            if (head && head.type === 'text') {
              head.value = head.value.replace(/^\s+/, '')
            }
          }
        }

        if (Array.isArray(result)) {
          values.push(...result)
        } else {
          values.push(result)
        }
      }
    }
  }

  return values
}

/**
 * Transform an unknown node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastNodes} node
 *   Unknown mdast node.
 * @returns {HastText | HastElement}
 *   Resulting hast node.
 */
function defaultUnknownHandler(state, node) {
  const data = node.data || {}
  /** @type {HastText | HastElement} */
  const result =
    'value' in node &&
    !(state_own.call(data, 'hProperties') || state_own.call(data, 'hChildren'))
      ? {type: 'text', value: node.value}
      : {
          type: 'element',
          tagName: 'div',
          properties: {},
          children: state_all(state, node)
        }

  state.patch(node, result)
  return state.applyData(node, result)
}

/**
 * Wrap `nodes` with line endings between each node.
 *
 * @template {HastContent} Type
 *   Node type.
 * @param {Array<Type>} nodes
 *   List of nodes to wrap.
 * @param {boolean | null | undefined} [loose=false]
 *   Whether to add line endings at start and end.
 * @returns {Array<Type | HastText>}
 *   Wrapped nodes.
 */
function state_wrap(nodes, loose) {
  /** @type {Array<Type | HastText>} */
  const result = []
  let index = -1

  if (loose) {
    result.push({type: 'text', value: '\n'})
  }

  while (++index < nodes.length) {
    if (index) result.push({type: 'text', value: '\n'})
    result.push(nodes[index])
  }

  if (loose && nodes.length > 0) {
    result.push({type: 'text', value: '\n'})
  }

  return result
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-hast/lib/index.js
/**
 * @typedef {import('hast').Content} HastContent
 * @typedef {import('hast').Root} HastRoot
 *
 * @typedef {import('mdast').Content} MdastContent
 * @typedef {import('mdast').Root} MdastRoot
 *
 * @typedef {import('./state.js').Options} Options
 */

/**
 * @typedef {HastRoot | HastContent} HastNodes
 * @typedef {MdastRoot | MdastContent} MdastNodes
 */




/**
 * Transform mdast to hast.
 *
 * ##### Notes
 *
 * ###### HTML
 *
 * Raw HTML is available in mdast as `html` nodes and can be embedded in hast
 * as semistandard `raw` nodes.
 * Most utilities ignore `raw` nodes but two notable ones don’t:
 *
 * *   `hast-util-to-html` also has an option `allowDangerousHtml` which will
 *     output the raw HTML.
 *     This is typically discouraged as noted by the option name but is useful
 *     if you completely trust authors
 * *   `hast-util-raw` can handle the raw embedded HTML strings by parsing them
 *     into standard hast nodes (`element`, `text`, etc).
 *     This is a heavy task as it needs a full HTML parser, but it is the only
 *     way to support untrusted content
 *
 * ###### Footnotes
 *
 * Many options supported here relate to footnotes.
 * Footnotes are not specified by CommonMark, which we follow by default.
 * They are supported by GitHub, so footnotes can be enabled in markdown with
 * `mdast-util-gfm`.
 *
 * The options `footnoteBackLabel` and `footnoteLabel` define natural language
 * that explains footnotes, which is hidden for sighted users but shown to
 * assistive technology.
 * When your page is not in English, you must define translated values.
 *
 * Back references use ARIA attributes, but the section label itself uses a
 * heading that is hidden with an `sr-only` class.
 * To show it to sighted users, define different attributes in
 * `footnoteLabelProperties`.
 *
 * ###### Clobbering
 *
 * Footnotes introduces a problem, as it links footnote calls to footnote
 * definitions on the page through `id` attributes generated from user content,
 * which results in DOM clobbering.
 *
 * DOM clobbering is this:
 *
 * ```html
 * <p id=x></p>
 * <script>alert(x) // `x` now refers to the DOM `p#x` element</script>
 * ```
 *
 * Elements by their ID are made available by browsers on the `window` object,
 * which is a security risk.
 * Using a prefix solves this problem.
 *
 * More information on how to handle clobbering and the prefix is explained in
 * Example: headings (DOM clobbering) in `rehype-sanitize`.
 *
 * ###### Unknown nodes
 *
 * Unknown nodes are nodes with a type that isn’t in `handlers` or `passThrough`.
 * The default behavior for unknown nodes is:
 *
 * *   when the node has a `value` (and doesn’t have `data.hName`,
 *     `data.hProperties`, or `data.hChildren`, see later), create a hast `text`
 *     node
 * *   otherwise, create a `<div>` element (which could be changed with
 *     `data.hName`), with its children mapped from mdast to hast as well
 *
 * This behavior can be changed by passing an `unknownHandler`.
 *
 * @param {MdastNodes} tree
 *   mdast tree.
 * @param {Options | null | undefined} [options]
 *   Configuration.
 * @returns {HastNodes | null | undefined}
 *   hast tree.
 */
// To do: next major: always return a single `root`.
function toHast(tree, options) {
  const state = createState(tree, options)
  const node = state.one(tree, null)
  const foot = footer(state)

  if (foot) {
    // @ts-expect-error If there’s a footer, there were definitions, meaning block
    // content.
    // So assume `node` is a parent node.
    node.children.push({type: 'text', value: '\n'}, foot)
  }

  // To do: next major: always return root?
  return Array.isArray(node) ? {type: 'root', children: node} : node
}

;// CONCATENATED MODULE: ../node_modules/remark-rehype/lib/index.js
/**
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('mdast-util-to-hast').Options} Options
 * @typedef {import('unified').Processor<any, any, any, any>} Processor
 *
 * @typedef {import('mdast-util-to-hast')} DoNotTouchAsThisImportIncludesRawInTree
 */



// Note: the `<MdastRoot, HastRoot>` overload doesn’t seem to work :'(

/**
 * Plugin that turns markdown into HTML to support rehype.
 *
 * *   If a destination processor is given, that processor runs with a new HTML
 *     (hast) tree (bridge-mode).
 *     As the given processor runs with a hast tree, and rehype plugins support
 *     hast, that means rehype plugins can be used with the given processor.
 *     The hast tree is discarded in the end.
 *     It’s highly unlikely that you want to do this.
 * *   The common case is to not pass a destination processor, in which case the
 *     current processor continues running with a new HTML (hast) tree
 *     (mutate-mode).
 *     As the current processor continues with a hast tree, and rehype plugins
 *     support hast, that means rehype plugins can be used after
 *     `remark-rehype`.
 *     It’s likely that this is what you want to do.
 *
 * @param destination
 *   Optional unified processor.
 * @param options
 *   Options passed to `mdast-util-to-hast`.
 */
const remarkRehype =
  /** @type {(import('unified').Plugin<[Processor, Options?]|[null|undefined, Options?]|[Options]|[], MdastRoot>)} */
  (
    function (destination, options) {
      return destination && 'run' in destination
        ? bridge(destination, options)
        : mutate(destination || options)
    }
  )

/* harmony default export */ var lib = (remarkRehype);

/**
 * Bridge-mode.
 * Runs the destination with the new hast tree.
 *
 * @type {import('unified').Plugin<[Processor, Options?], MdastRoot>}
 */
function bridge(destination, options) {
  return (node, file, next) => {
    destination.run(toHast(node, options), file, (error) => {
      next(error)
    })
  }
}

/**
 * Mutate-mode.
 * Further plugins run on the hast tree.
 *
 * @type {import('unified').Plugin<[Options?]|void[], MdastRoot, HastRoot>}
 */
function mutate(options) {
  // @ts-expect-error: assume a corresponding node is returned by `toHast`.
  return (node) => toHast(node, options)
}

// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(3615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ../node_modules/property-information/lib/util/schema.js
/**
 * @typedef {import('./info.js').Info} Info
 * @typedef {Record<string, Info>} Properties
 * @typedef {Record<string, string>} Normal
 */

class Schema {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(property, normal, space) {
    this.property = property
    this.normal = normal
    if (space) {
      this.space = space
    }
  }
}

/** @type {Properties} */
Schema.prototype.property = {}
/** @type {Normal} */
Schema.prototype.normal = {}
/** @type {string|null} */
Schema.prototype.space = null

;// CONCATENATED MODULE: ../node_modules/property-information/lib/util/merge.js
/**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 */



/**
 * @param {Schema[]} definitions
 * @param {string} [space]
 * @returns {Schema}
 */
function merge(definitions, space) {
  /** @type {Properties} */
  const property = {}
  /** @type {Normal} */
  const normal = {}
  let index = -1

  while (++index < definitions.length) {
    Object.assign(property, definitions[index].property)
    Object.assign(normal, definitions[index].normal)
  }

  return new Schema(property, normal, space)
}

;// CONCATENATED MODULE: ../node_modules/property-information/lib/normalize.js
/**
 * @param {string} value
 * @returns {string}
 */
function normalize_normalize(value) {
  return value.toLowerCase()
}

;// CONCATENATED MODULE: ../node_modules/property-information/lib/util/info.js
class Info {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(property, attribute) {
    /** @type {string} */
    this.property = property
    /** @type {string} */
    this.attribute = attribute
  }
}

/** @type {string|null} */
Info.prototype.space = null
Info.prototype.boolean = false
Info.prototype.booleanish = false
Info.prototype.overloadedBoolean = false
Info.prototype.number = false
Info.prototype.commaSeparated = false
Info.prototype.spaceSeparated = false
Info.prototype.commaOrSpaceSeparated = false
Info.prototype.mustUseProperty = false
Info.prototype.defined = false

;// CONCATENATED MODULE: ../node_modules/property-information/lib/util/types.js
let powers = 0

const types_boolean = increment()
const booleanish = increment()
const overloadedBoolean = increment()
const number = increment()
const spaceSeparated = increment()
const commaSeparated = increment()
const commaOrSpaceSeparated = increment()

function increment() {
  return 2 ** ++powers
}

;// CONCATENATED MODULE: ../node_modules/property-information/lib/util/defined-info.js



/** @type {Array<keyof types>} */
// @ts-expect-error: hush.
const checks = Object.keys(types_namespaceObject)

class DefinedInfo extends Info {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(property, attribute, mask, space) {
    let index = -1

    super(property, attribute)

    mark(this, 'space', space)

    if (typeof mask === 'number') {
      while (++index < checks.length) {
        const check = checks[index]
        mark(this, checks[index], (mask & types_namespaceObject[check]) === types_namespaceObject[check])
      }
    }
  }
}

DefinedInfo.prototype.defined = true

/**
 * @param {DefinedInfo} values
 * @param {string} key
 * @param {unknown} value
 */
function mark(values, key, value) {
  if (value) {
    // @ts-expect-error: assume `value` matches the expected value of `key`.
    values[key] = value
  }
}

;// CONCATENATED MODULE: ../node_modules/property-information/lib/util/create.js
/**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 *
 * @typedef {Record<string, string>} Attributes
 *
 * @typedef {Object} Definition
 * @property {Record<string, number|null>} properties
 * @property {(attributes: Attributes, property: string) => string} transform
 * @property {string} [space]
 * @property {Attributes} [attributes]
 * @property {Array<string>} [mustUseProperty]
 */





const create_own = {}.hasOwnProperty

/**
 * @param {Definition} definition
 * @returns {Schema}
 */
function create(definition) {
  /** @type {Properties} */
  const property = {}
  /** @type {Normal} */
  const normal = {}
  /** @type {string} */
  let prop

  for (prop in definition.properties) {
    if (create_own.call(definition.properties, prop)) {
      const value = definition.properties[prop]
      const info = new DefinedInfo(
        prop,
        definition.transform(definition.attributes || {}, prop),
        value,
        definition.space
      )

      if (
        definition.mustUseProperty &&
        definition.mustUseProperty.includes(prop)
      ) {
        info.mustUseProperty = true
      }

      property[prop] = info

      normal[normalize_normalize(prop)] = prop
      normal[normalize_normalize(info.attribute)] = prop
    }
  }

  return new Schema(property, normal, definition.space)
}

;// CONCATENATED MODULE: ../node_modules/property-information/lib/xlink.js


const xlink = create({
  space: 'xlink',
  transform(_, prop) {
    return 'xlink:' + prop.slice(5).toLowerCase()
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
})

;// CONCATENATED MODULE: ../node_modules/property-information/lib/xml.js


const xml = create({
  space: 'xml',
  transform(_, prop) {
    return 'xml:' + prop.slice(3).toLowerCase()
  },
  properties: {xmlLang: null, xmlBase: null, xmlSpace: null}
})

;// CONCATENATED MODULE: ../node_modules/property-information/lib/util/case-sensitive-transform.js
/**
 * @param {Record<string, string>} attributes
 * @param {string} attribute
 * @returns {string}
 */
function caseSensitiveTransform(attributes, attribute) {
  return attribute in attributes ? attributes[attribute] : attribute
}

;// CONCATENATED MODULE: ../node_modules/property-information/lib/util/case-insensitive-transform.js


/**
 * @param {Record<string, string>} attributes
 * @param {string} property
 * @returns {string}
 */
function caseInsensitiveTransform(attributes, property) {
  return caseSensitiveTransform(attributes, property.toLowerCase())
}

;// CONCATENATED MODULE: ../node_modules/property-information/lib/xmlns.js



const xmlns = create({
  space: 'xmlns',
  attributes: {xmlnsxlink: 'xmlns:xlink'},
  transform: caseInsensitiveTransform,
  properties: {xmlns: null, xmlnsXLink: null}
})

;// CONCATENATED MODULE: ../node_modules/property-information/lib/aria.js



const aria = create({
  transform(_, prop) {
    return prop === 'role' ? prop : 'aria-' + prop.slice(4).toLowerCase()
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: booleanish,
    ariaAutoComplete: null,
    ariaBusy: booleanish,
    ariaChecked: booleanish,
    ariaColCount: number,
    ariaColIndex: number,
    ariaColSpan: number,
    ariaControls: spaceSeparated,
    ariaCurrent: null,
    ariaDescribedBy: spaceSeparated,
    ariaDetails: null,
    ariaDisabled: booleanish,
    ariaDropEffect: spaceSeparated,
    ariaErrorMessage: null,
    ariaExpanded: booleanish,
    ariaFlowTo: spaceSeparated,
    ariaGrabbed: booleanish,
    ariaHasPopup: null,
    ariaHidden: booleanish,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: spaceSeparated,
    ariaLevel: number,
    ariaLive: null,
    ariaModal: booleanish,
    ariaMultiLine: booleanish,
    ariaMultiSelectable: booleanish,
    ariaOrientation: null,
    ariaOwns: spaceSeparated,
    ariaPlaceholder: null,
    ariaPosInSet: number,
    ariaPressed: booleanish,
    ariaReadOnly: booleanish,
    ariaRelevant: null,
    ariaRequired: booleanish,
    ariaRoleDescription: spaceSeparated,
    ariaRowCount: number,
    ariaRowIndex: number,
    ariaRowSpan: number,
    ariaSelected: booleanish,
    ariaSetSize: number,
    ariaSort: null,
    ariaValueMax: number,
    ariaValueMin: number,
    ariaValueNow: number,
    ariaValueText: null,
    role: null
  }
})

;// CONCATENATED MODULE: ../node_modules/property-information/lib/html.js




const html_html = create({
  space: 'html',
  attributes: {
    acceptcharset: 'accept-charset',
    classname: 'class',
    htmlfor: 'for',
    httpequiv: 'http-equiv'
  },
  transform: caseInsensitiveTransform,
  mustUseProperty: ['checked', 'multiple', 'muted', 'selected'],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: commaSeparated,
    acceptCharset: spaceSeparated,
    accessKey: spaceSeparated,
    action: null,
    allow: null,
    allowFullScreen: types_boolean,
    allowPaymentRequest: types_boolean,
    allowUserMedia: types_boolean,
    alt: null,
    as: null,
    async: types_boolean,
    autoCapitalize: null,
    autoComplete: spaceSeparated,
    autoFocus: types_boolean,
    autoPlay: types_boolean,
    blocking: spaceSeparated,
    capture: null,
    charSet: null,
    checked: types_boolean,
    cite: null,
    className: spaceSeparated,
    cols: number,
    colSpan: null,
    content: null,
    contentEditable: booleanish,
    controls: types_boolean,
    controlsList: spaceSeparated,
    coords: number | commaSeparated,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: types_boolean,
    defer: types_boolean,
    dir: null,
    dirName: null,
    disabled: types_boolean,
    download: overloadedBoolean,
    draggable: booleanish,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: types_boolean,
    formTarget: null,
    headers: spaceSeparated,
    height: number,
    hidden: types_boolean,
    high: number,
    href: null,
    hrefLang: null,
    htmlFor: spaceSeparated,
    httpEquiv: spaceSeparated,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: types_boolean,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: types_boolean,
    itemId: null,
    itemProp: spaceSeparated,
    itemRef: spaceSeparated,
    itemScope: types_boolean,
    itemType: spaceSeparated,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: types_boolean,
    low: number,
    manifest: null,
    max: null,
    maxLength: number,
    media: null,
    method: null,
    min: null,
    minLength: number,
    multiple: types_boolean,
    muted: types_boolean,
    name: null,
    nonce: null,
    noModule: types_boolean,
    noValidate: types_boolean,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: types_boolean,
    optimum: number,
    pattern: null,
    ping: spaceSeparated,
    placeholder: null,
    playsInline: types_boolean,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: types_boolean,
    referrerPolicy: null,
    rel: spaceSeparated,
    required: types_boolean,
    reversed: types_boolean,
    rows: number,
    rowSpan: number,
    sandbox: spaceSeparated,
    scope: null,
    scoped: types_boolean,
    seamless: types_boolean,
    selected: types_boolean,
    shadowRootDelegatesFocus: types_boolean,
    shadowRootMode: null,
    shape: null,
    size: number,
    sizes: null,
    slot: null,
    span: number,
    spellCheck: booleanish,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: number,
    step: null,
    style: null,
    tabIndex: number,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: types_boolean,
    useMap: null,
    value: booleanish,
    width: number,
    wrap: null,

    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null, // Several. Use CSS `text-align` instead,
    aLink: null, // `<body>`. Use CSS `a:active {color}` instead
    archive: spaceSeparated, // `<object>`. List of URIs to archives
    axis: null, // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null, // `<body>`. Use CSS `background-image` instead
    bgColor: null, // `<body>` and table elements. Use CSS `background-color` instead
    border: number, // `<table>`. Use CSS `border-width` instead,
    borderColor: null, // `<table>`. Use CSS `border-color` instead,
    bottomMargin: number, // `<body>`
    cellPadding: null, // `<table>`
    cellSpacing: null, // `<table>`
    char: null, // Several table elements. When `align=char`, sets the character to align on
    charOff: null, // Several table elements. When `char`, offsets the alignment
    classId: null, // `<object>`
    clear: null, // `<br>`. Use CSS `clear` instead
    code: null, // `<object>`
    codeBase: null, // `<object>`
    codeType: null, // `<object>`
    color: null, // `<font>` and `<hr>`. Use CSS instead
    compact: types_boolean, // Lists. Use CSS to reduce space between items instead
    declare: types_boolean, // `<object>`
    event: null, // `<script>`
    face: null, // `<font>`. Use CSS instead
    frame: null, // `<table>`
    frameBorder: null, // `<iframe>`. Use CSS `border` instead
    hSpace: number, // `<img>` and `<object>`
    leftMargin: number, // `<body>`
    link: null, // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null, // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null, // `<img>`. Use a `<picture>`
    marginHeight: number, // `<body>`
    marginWidth: number, // `<body>`
    noResize: types_boolean, // `<frame>`
    noHref: types_boolean, // `<area>`. Use no href instead of an explicit `nohref`
    noShade: types_boolean, // `<hr>`. Use background-color and height instead of borders
    noWrap: types_boolean, // `<td>` and `<th>`
    object: null, // `<applet>`
    profile: null, // `<head>`
    prompt: null, // `<isindex>`
    rev: null, // `<link>`
    rightMargin: number, // `<body>`
    rules: null, // `<table>`
    scheme: null, // `<meta>`
    scrolling: booleanish, // `<frame>`. Use overflow in the child context
    standby: null, // `<object>`
    summary: null, // `<table>`
    text: null, // `<body>`. Use CSS `color` instead
    topMargin: number, // `<body>`
    valueType: null, // `<param>`
    version: null, // `<html>`. Use a doctype.
    vAlign: null, // Several. Use CSS `vertical-align` instead
    vLink: null, // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: number, // `<img>` and `<object>`

    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: types_boolean,
    disableRemotePlayback: types_boolean,
    prefix: null,
    property: null,
    results: number,
    security: null,
    unselectable: null
  }
})

;// CONCATENATED MODULE: ../node_modules/property-information/lib/svg.js




const svg = create({
  space: 'svg',
  attributes: {
    accentHeight: 'accent-height',
    alignmentBaseline: 'alignment-baseline',
    arabicForm: 'arabic-form',
    baselineShift: 'baseline-shift',
    capHeight: 'cap-height',
    className: 'class',
    clipPath: 'clip-path',
    clipRule: 'clip-rule',
    colorInterpolation: 'color-interpolation',
    colorInterpolationFilters: 'color-interpolation-filters',
    colorProfile: 'color-profile',
    colorRendering: 'color-rendering',
    crossOrigin: 'crossorigin',
    dataType: 'datatype',
    dominantBaseline: 'dominant-baseline',
    enableBackground: 'enable-background',
    fillOpacity: 'fill-opacity',
    fillRule: 'fill-rule',
    floodColor: 'flood-color',
    floodOpacity: 'flood-opacity',
    fontFamily: 'font-family',
    fontSize: 'font-size',
    fontSizeAdjust: 'font-size-adjust',
    fontStretch: 'font-stretch',
    fontStyle: 'font-style',
    fontVariant: 'font-variant',
    fontWeight: 'font-weight',
    glyphName: 'glyph-name',
    glyphOrientationHorizontal: 'glyph-orientation-horizontal',
    glyphOrientationVertical: 'glyph-orientation-vertical',
    hrefLang: 'hreflang',
    horizAdvX: 'horiz-adv-x',
    horizOriginX: 'horiz-origin-x',
    horizOriginY: 'horiz-origin-y',
    imageRendering: 'image-rendering',
    letterSpacing: 'letter-spacing',
    lightingColor: 'lighting-color',
    markerEnd: 'marker-end',
    markerMid: 'marker-mid',
    markerStart: 'marker-start',
    navDown: 'nav-down',
    navDownLeft: 'nav-down-left',
    navDownRight: 'nav-down-right',
    navLeft: 'nav-left',
    navNext: 'nav-next',
    navPrev: 'nav-prev',
    navRight: 'nav-right',
    navUp: 'nav-up',
    navUpLeft: 'nav-up-left',
    navUpRight: 'nav-up-right',
    onAbort: 'onabort',
    onActivate: 'onactivate',
    onAfterPrint: 'onafterprint',
    onBeforePrint: 'onbeforeprint',
    onBegin: 'onbegin',
    onCancel: 'oncancel',
    onCanPlay: 'oncanplay',
    onCanPlayThrough: 'oncanplaythrough',
    onChange: 'onchange',
    onClick: 'onclick',
    onClose: 'onclose',
    onCopy: 'oncopy',
    onCueChange: 'oncuechange',
    onCut: 'oncut',
    onDblClick: 'ondblclick',
    onDrag: 'ondrag',
    onDragEnd: 'ondragend',
    onDragEnter: 'ondragenter',
    onDragExit: 'ondragexit',
    onDragLeave: 'ondragleave',
    onDragOver: 'ondragover',
    onDragStart: 'ondragstart',
    onDrop: 'ondrop',
    onDurationChange: 'ondurationchange',
    onEmptied: 'onemptied',
    onEnd: 'onend',
    onEnded: 'onended',
    onError: 'onerror',
    onFocus: 'onfocus',
    onFocusIn: 'onfocusin',
    onFocusOut: 'onfocusout',
    onHashChange: 'onhashchange',
    onInput: 'oninput',
    onInvalid: 'oninvalid',
    onKeyDown: 'onkeydown',
    onKeyPress: 'onkeypress',
    onKeyUp: 'onkeyup',
    onLoad: 'onload',
    onLoadedData: 'onloadeddata',
    onLoadedMetadata: 'onloadedmetadata',
    onLoadStart: 'onloadstart',
    onMessage: 'onmessage',
    onMouseDown: 'onmousedown',
    onMouseEnter: 'onmouseenter',
    onMouseLeave: 'onmouseleave',
    onMouseMove: 'onmousemove',
    onMouseOut: 'onmouseout',
    onMouseOver: 'onmouseover',
    onMouseUp: 'onmouseup',
    onMouseWheel: 'onmousewheel',
    onOffline: 'onoffline',
    onOnline: 'ononline',
    onPageHide: 'onpagehide',
    onPageShow: 'onpageshow',
    onPaste: 'onpaste',
    onPause: 'onpause',
    onPlay: 'onplay',
    onPlaying: 'onplaying',
    onPopState: 'onpopstate',
    onProgress: 'onprogress',
    onRateChange: 'onratechange',
    onRepeat: 'onrepeat',
    onReset: 'onreset',
    onResize: 'onresize',
    onScroll: 'onscroll',
    onSeeked: 'onseeked',
    onSeeking: 'onseeking',
    onSelect: 'onselect',
    onShow: 'onshow',
    onStalled: 'onstalled',
    onStorage: 'onstorage',
    onSubmit: 'onsubmit',
    onSuspend: 'onsuspend',
    onTimeUpdate: 'ontimeupdate',
    onToggle: 'ontoggle',
    onUnload: 'onunload',
    onVolumeChange: 'onvolumechange',
    onWaiting: 'onwaiting',
    onZoom: 'onzoom',
    overlinePosition: 'overline-position',
    overlineThickness: 'overline-thickness',
    paintOrder: 'paint-order',
    panose1: 'panose-1',
    pointerEvents: 'pointer-events',
    referrerPolicy: 'referrerpolicy',
    renderingIntent: 'rendering-intent',
    shapeRendering: 'shape-rendering',
    stopColor: 'stop-color',
    stopOpacity: 'stop-opacity',
    strikethroughPosition: 'strikethrough-position',
    strikethroughThickness: 'strikethrough-thickness',
    strokeDashArray: 'stroke-dasharray',
    strokeDashOffset: 'stroke-dashoffset',
    strokeLineCap: 'stroke-linecap',
    strokeLineJoin: 'stroke-linejoin',
    strokeMiterLimit: 'stroke-miterlimit',
    strokeOpacity: 'stroke-opacity',
    strokeWidth: 'stroke-width',
    tabIndex: 'tabindex',
    textAnchor: 'text-anchor',
    textDecoration: 'text-decoration',
    textRendering: 'text-rendering',
    transformOrigin: 'transform-origin',
    typeOf: 'typeof',
    underlinePosition: 'underline-position',
    underlineThickness: 'underline-thickness',
    unicodeBidi: 'unicode-bidi',
    unicodeRange: 'unicode-range',
    unitsPerEm: 'units-per-em',
    vAlphabetic: 'v-alphabetic',
    vHanging: 'v-hanging',
    vIdeographic: 'v-ideographic',
    vMathematical: 'v-mathematical',
    vectorEffect: 'vector-effect',
    vertAdvY: 'vert-adv-y',
    vertOriginX: 'vert-origin-x',
    vertOriginY: 'vert-origin-y',
    wordSpacing: 'word-spacing',
    writingMode: 'writing-mode',
    xHeight: 'x-height',
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: 'playbackorder',
    timelineBegin: 'timelinebegin'
  },
  transform: caseSensitiveTransform,
  properties: {
    about: commaOrSpaceSeparated,
    accentHeight: number,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: number,
    amplitude: number,
    arabicForm: null,
    ascent: number,
    attributeName: null,
    attributeType: null,
    azimuth: number,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: number,
    by: null,
    calcMode: null,
    capHeight: number,
    className: spaceSeparated,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: number,
    diffuseConstant: number,
    direction: null,
    display: null,
    dur: null,
    divisor: number,
    dominantBaseline: null,
    download: types_boolean,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: number,
    enableBackground: null,
    end: null,
    event: null,
    exponent: number,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: number,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: commaSeparated,
    g2: commaSeparated,
    glyphName: commaSeparated,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: number,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: number,
    horizOriginX: number,
    horizOriginY: number,
    id: null,
    ideographic: number,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: number,
    k: number,
    k1: number,
    k2: number,
    k3: number,
    k4: number,
    kernelMatrix: commaOrSpaceSeparated,
    kernelUnitLength: null,
    keyPoints: null, // SEMI_COLON_SEPARATED
    keySplines: null, // SEMI_COLON_SEPARATED
    keyTimes: null, // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: number,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: number,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: number,
    overlineThickness: number,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: number,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: spaceSeparated,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: number,
    pointsAtY: number,
    pointsAtZ: number,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: commaOrSpaceSeparated,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: commaOrSpaceSeparated,
    rev: commaOrSpaceSeparated,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: commaOrSpaceSeparated,
    requiredFeatures: commaOrSpaceSeparated,
    requiredFonts: commaOrSpaceSeparated,
    requiredFormats: commaOrSpaceSeparated,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: number,
    specularExponent: number,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: number,
    strikethroughThickness: number,
    string: null,
    stroke: null,
    strokeDashArray: commaOrSpaceSeparated,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: number,
    strokeOpacity: number,
    strokeWidth: null,
    style: null,
    surfaceScale: number,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: commaOrSpaceSeparated,
    tabIndex: number,
    tableValues: null,
    target: null,
    targetX: number,
    targetY: number,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: commaOrSpaceSeparated,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: number,
    underlineThickness: number,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: number,
    values: null,
    vAlphabetic: number,
    vMathematical: number,
    vectorEffect: null,
    vHanging: number,
    vIdeographic: number,
    version: null,
    vertAdvY: number,
    vertOriginX: number,
    vertOriginY: number,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: number,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
})

;// CONCATENATED MODULE: ../node_modules/property-information/index.js
/**
 * @typedef {import('./lib/util/info.js').Info} Info
 * @typedef {import('./lib/util/schema.js').Schema} Schema
 */












const property_information_html = merge([xml, xlink, xmlns, aria, html_html], 'html')
const property_information_svg = merge([xml, xlink, xmlns, aria, svg], 'svg')

;// CONCATENATED MODULE: ../node_modules/react-markdown/lib/rehype-filter.js


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').Element} Element
 *
 * @callback AllowElement
 * @param {Element} element
 * @param {number} index
 * @param {Element|Root} parent
 * @returns {boolean|undefined}
 *
 * @typedef Options
 * @property {Array<string>} [allowedElements]
 * @property {Array<string>} [disallowedElements=[]]
 * @property {AllowElement} [allowElement]
 * @property {boolean} [unwrapDisallowed=false]
 */

/**
 * @type {import('unified').Plugin<[Options], Root>}
 */
function rehypeFilter(options) {
  if (options.allowedElements && options.disallowedElements) {
    throw new TypeError(
      'Only one of `allowedElements` and `disallowedElements` should be defined'
    )
  }

  if (
    options.allowedElements ||
    options.disallowedElements ||
    options.allowElement
  ) {
    return (tree) => {
      visit(tree, 'element', (node, index, parent_) => {
        const parent = /** @type {Element|Root} */ (parent_)
        /** @type {boolean|undefined} */
        let remove

        if (options.allowedElements) {
          remove = !options.allowedElements.includes(node.tagName)
        } else if (options.disallowedElements) {
          remove = options.disallowedElements.includes(node.tagName)
        }

        if (!remove && options.allowElement && typeof index === 'number') {
          remove = !options.allowElement(node, index, parent)
        }

        if (remove && typeof index === 'number') {
          if (options.unwrapDisallowed && node.children) {
            parent.children.splice(index, 1, ...node.children)
          } else {
            parent.children.splice(index, 1)
          }

          return index
        }

        return undefined
      })
    }
  }
}

// EXTERNAL MODULE: ../node_modules/react-is/index.js
var react_is = __webpack_require__(9185);
;// CONCATENATED MODULE: ../node_modules/hast-util-whitespace/index.js
/**
 * Check if the given value is *inter-element whitespace*.
 *
 * @param {unknown} thing
 *   Thing to check (typically `Node` or `string`).
 * @returns {boolean}
 *   Whether the `value` is inter-element whitespace (`boolean`): consisting of
 *   zero or more of space, tab (`\t`), line feed (`\n`), carriage return
 *   (`\r`), or form feed (`\f`).
 *   If a node is passed it must be a `Text` node, whose `value` field is
 *   checked.
 */
function whitespace(thing) {
  /** @type {string} */
  const value =
    // @ts-expect-error looks like a node.
    thing && typeof thing === 'object' && thing.type === 'text'
      ? // @ts-expect-error looks like a text.
        thing.value || ''
      : thing

  // HTML whitespace expression.
  // See <https://infra.spec.whatwg.org/#ascii-whitespace>.
  return typeof value === 'string' && value.replace(/[ \t\n\f\r]/g, '') === ''
}

;// CONCATENATED MODULE: ../node_modules/property-information/lib/find.js
/**
 * @typedef {import('./util/schema.js').Schema} Schema
 */





const valid = /^data[-\w.:]+$/i
const dash = /-[a-z]/g
const cap = /[A-Z]/g

/**
 * @param {Schema} schema
 * @param {string} value
 * @returns {Info}
 */
function find(schema, value) {
  const normal = normalize_normalize(value)
  let prop = value
  let Type = Info

  if (normal in schema.normal) {
    return schema.property[schema.normal[normal]]
  }

  if (normal.length > 4 && normal.slice(0, 4) === 'data' && valid.test(value)) {
    // Attribute or property.
    if (value.charAt(4) === '-') {
      // Turn it into a property.
      const rest = value.slice(5).replace(dash, camelcase)
      prop = 'data' + rest.charAt(0).toUpperCase() + rest.slice(1)
    } else {
      // Turn it into an attribute.
      const rest = value.slice(4)

      if (!dash.test(rest)) {
        let dashes = rest.replace(cap, kebab)

        if (dashes.charAt(0) !== '-') {
          dashes = '-' + dashes
        }

        value = 'data' + dashes
      }
    }

    Type = DefinedInfo
  }

  return new Type(prop, value)
}

/**
 * @param {string} $0
 * @returns {string}
 */
function kebab($0) {
  return '-' + $0.toLowerCase()
}

/**
 * @param {string} $0
 * @returns {string}
 */
function camelcase($0) {
  return $0.charAt(1).toUpperCase()
}

;// CONCATENATED MODULE: ../node_modules/property-information/lib/hast-to-react.js
/**
 * `hast` is close to `React`, but differs in a couple of cases.
 *
 * To get a React property from a hast property, check if it is in
 * `hastToReact`, if it is, then use the corresponding value,
 * otherwise, use the hast property.
 *
 * @type {Record<string, string>}
 */
const hastToReact = {
  classId: 'classID',
  dataType: 'datatype',
  itemId: 'itemID',
  strokeDashArray: 'strokeDasharray',
  strokeDashOffset: 'strokeDashoffset',
  strokeLineCap: 'strokeLinecap',
  strokeLineJoin: 'strokeLinejoin',
  strokeMiterLimit: 'strokeMiterlimit',
  typeOf: 'typeof',
  xLinkActuate: 'xlinkActuate',
  xLinkArcRole: 'xlinkArcrole',
  xLinkHref: 'xlinkHref',
  xLinkRole: 'xlinkRole',
  xLinkShow: 'xlinkShow',
  xLinkTitle: 'xlinkTitle',
  xLinkType: 'xlinkType',
  xmlnsXLink: 'xmlnsXlink'
}

;// CONCATENATED MODULE: ../node_modules/space-separated-tokens/index.js
/**
 * Parse space-separated tokens to an array of strings.
 *
 * @param {string} value
 *   Space-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */
function space_separated_tokens_parse(value) {
  const input = String(value || '').trim()
  return input ? input.split(/[ \t\n\r\f]+/g) : []
}

/**
 * Serialize an array of strings as space separated-tokens.
 *
 * @param {Array<string|number>} values
 *   List of tokens.
 * @returns {string}
 *   Space-separated tokens.
 */
function stringify(values) {
  return values.join(' ').trim()
}

;// CONCATENATED MODULE: ../node_modules/comma-separated-tokens/index.js
/**
 * @typedef Options
 *   Configuration for `stringify`.
 * @property {boolean} [padLeft=true]
 *   Whether to pad a space before a token.
 * @property {boolean} [padRight=false]
 *   Whether to pad a space after a token.
 */

/**
 * @typedef {Options} StringifyOptions
 *   Please use `StringifyOptions` instead.
 */

/**
 * Parse comma-separated tokens to an array.
 *
 * @param {string} value
 *   Comma-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */
function comma_separated_tokens_parse(value) {
  /** @type {Array<string>} */
  const tokens = []
  const input = String(value || '')
  let index = input.indexOf(',')
  let start = 0
  /** @type {boolean} */
  let end = false

  while (!end) {
    if (index === -1) {
      index = input.length
      end = true
    }

    const token = input.slice(start, index).trim()

    if (token || !end) {
      tokens.push(token)
    }

    start = index + 1
    index = input.indexOf(',', start)
  }

  return tokens
}

/**
 * Serialize an array of strings or numbers to comma-separated tokens.
 *
 * @param {Array<string|number>} values
 *   List of tokens.
 * @param {Options} [options]
 *   Configuration for `stringify` (optional).
 * @returns {string}
 *   Comma-separated tokens.
 */
function comma_separated_tokens_stringify(values, options) {
  const settings = options || {}

  // Ensure the last empty entry is seen.
  const input = values[values.length - 1] === '' ? [...values, ''] : values

  return input
    .join(
      (settings.padRight ? ' ' : '') +
        ',' +
        (settings.padLeft === false ? '' : ' ')
    )
    .trim()
}

// EXTERNAL MODULE: ../node_modules/style-to-object/index.js
var style_to_object = __webpack_require__(5862);
;// CONCATENATED MODULE: ../node_modules/style-to-object/index.mjs


/* harmony default export */ var node_modules_style_to_object = (style_to_object);

;// CONCATENATED MODULE: ../node_modules/react-markdown/lib/uri-transformer.js
const protocols = ['http', 'https', 'mailto', 'tel']

/**
 * @param {string} uri
 * @returns {string}
 */
function uriTransformer(uri) {
  const url = (uri || '').trim()
  const first = url.charAt(0)

  if (first === '#' || first === '/') {
    return url
  }

  const colon = url.indexOf(':')
  if (colon === -1) {
    return url
  }

  let index = -1

  while (++index < protocols.length) {
    const protocol = protocols[index]

    if (
      colon === protocol.length &&
      url.slice(0, protocol.length).toLowerCase() === protocol
    ) {
      return url
    }
  }

  index = url.indexOf('?')
  if (index !== -1 && colon > index) {
    return url
  }

  index = url.indexOf('#')
  if (index !== -1 && colon > index) {
    return url
  }

  // eslint-disable-next-line no-script-url
  return 'javascript:void(0)'
}

;// CONCATENATED MODULE: ../node_modules/react-markdown/lib/ast-to-react.js
/**
 * @template T
 * @typedef {import('react').ComponentType<T>} ComponentType<T>
 */

/**
 * @template {import('react').ElementType} T
 * @typedef {import('react').ComponentPropsWithoutRef<T>} ComponentPropsWithoutRef<T>
 */

/**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('unist').Position} Position
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').Text} Text
 * @typedef {import('hast').Comment} Comment
 * @typedef {import('hast').DocType} Doctype
 * @typedef {import('property-information').Info} Info
 * @typedef {import('property-information').Schema} Schema
 * @typedef {import('./complex-types.js').ReactMarkdownProps} ReactMarkdownProps
 *
 * @typedef Raw
 * @property {'raw'} type
 * @property {string} value
 *
 * @typedef Context
 * @property {Options} options
 * @property {Schema} schema
 * @property {number} listDepth
 *
 * @callback TransformLink
 * @param {string} href
 * @param {Array<ElementContent>} children
 * @param {string?} title
 * @returns {string}
 *
 * @callback TransformImage
 * @param {string} src
 * @param {string} alt
 * @param {string?} title
 * @returns {string}
 *
 * @typedef {import('react').HTMLAttributeAnchorTarget} TransformLinkTargetType
 *
 * @callback TransformLinkTarget
 * @param {string} href
 * @param {Array<ElementContent>} children
 * @param {string?} title
 * @returns {TransformLinkTargetType|undefined}
 *
 * @typedef {keyof JSX.IntrinsicElements} ReactMarkdownNames
 *
 * To do: is `data-sourcepos` typeable?
 *
 * @typedef {ComponentPropsWithoutRef<'code'> & ReactMarkdownProps & {inline?: boolean}} CodeProps
 * @typedef {ComponentPropsWithoutRef<'h1'> & ReactMarkdownProps & {level: number}} HeadingProps
 * @typedef {ComponentPropsWithoutRef<'li'> & ReactMarkdownProps & {checked: boolean|null, index: number, ordered: boolean}} LiProps
 * @typedef {ComponentPropsWithoutRef<'ol'> & ReactMarkdownProps & {depth: number, ordered: true}} OrderedListProps
 * @typedef {ComponentPropsWithoutRef<'td'> & ReactMarkdownProps & {style?: Record<string, unknown>, isHeader: false}} TableDataCellProps
 * @typedef {ComponentPropsWithoutRef<'th'> & ReactMarkdownProps & {style?: Record<string, unknown>, isHeader: true}} TableHeaderCellProps
 * @typedef {ComponentPropsWithoutRef<'tr'> & ReactMarkdownProps & {isHeader: boolean}} TableRowProps
 * @typedef {ComponentPropsWithoutRef<'ul'> & ReactMarkdownProps & {depth: number, ordered: false}} UnorderedListProps
 *
 * @typedef {ComponentType<CodeProps>} CodeComponent
 * @typedef {ComponentType<HeadingProps>} HeadingComponent
 * @typedef {ComponentType<LiProps>} LiComponent
 * @typedef {ComponentType<OrderedListProps>} OrderedListComponent
 * @typedef {ComponentType<TableDataCellProps>} TableDataCellComponent
 * @typedef {ComponentType<TableHeaderCellProps>} TableHeaderCellComponent
 * @typedef {ComponentType<TableRowProps>} TableRowComponent
 * @typedef {ComponentType<UnorderedListProps>} UnorderedListComponent
 *
 * @typedef SpecialComponents
 * @property {CodeComponent|ReactMarkdownNames} code
 * @property {HeadingComponent|ReactMarkdownNames} h1
 * @property {HeadingComponent|ReactMarkdownNames} h2
 * @property {HeadingComponent|ReactMarkdownNames} h3
 * @property {HeadingComponent|ReactMarkdownNames} h4
 * @property {HeadingComponent|ReactMarkdownNames} h5
 * @property {HeadingComponent|ReactMarkdownNames} h6
 * @property {LiComponent|ReactMarkdownNames} li
 * @property {OrderedListComponent|ReactMarkdownNames} ol
 * @property {TableDataCellComponent|ReactMarkdownNames} td
 * @property {TableHeaderCellComponent|ReactMarkdownNames} th
 * @property {TableRowComponent|ReactMarkdownNames} tr
 * @property {UnorderedListComponent|ReactMarkdownNames} ul
 *
 * @typedef {Partial<Omit<import('./complex-types.js').NormalComponents, keyof SpecialComponents> & SpecialComponents>} Components
 *
 * @typedef Options
 * @property {boolean} [sourcePos=false]
 * @property {boolean} [rawSourcePos=false]
 * @property {boolean} [skipHtml=false]
 * @property {boolean} [includeElementIndex=false]
 * @property {null|false|TransformLink} [transformLinkUri]
 * @property {TransformImage} [transformImageUri]
 * @property {TransformLinkTargetType|TransformLinkTarget} [linkTarget]
 * @property {Components} [components]
 */










const ast_to_react_own = {}.hasOwnProperty

// The table-related elements that must not contain whitespace text according
// to React.
const tableElements = new Set(['table', 'thead', 'tbody', 'tfoot', 'tr'])

/**
 * @param {Context} context
 * @param {Element|Root} node
 */
function childrenToReact(context, node) {
  /** @type {Array<ReactNode>} */
  const children = []
  let childIndex = -1
  /** @type {Comment|Doctype|Element|Raw|Text} */
  let child

  while (++childIndex < node.children.length) {
    child = node.children[childIndex]

    if (child.type === 'element') {
      children.push(toReact(context, child, childIndex, node))
    } else if (child.type === 'text') {
      // Currently, a warning is triggered by react for *any* white space in
      // tables.
      // So we drop it.
      // See: <https://github.com/facebook/react/pull/7081>.
      // See: <https://github.com/facebook/react/pull/7515>.
      // See: <https://github.com/remarkjs/remark-react/issues/64>.
      // See: <https://github.com/remarkjs/react-markdown/issues/576>.
      if (
        node.type !== 'element' ||
        !tableElements.has(node.tagName) ||
        !whitespace(child)
      ) {
        children.push(child.value)
      }
    } else if (child.type === 'raw' && !context.options.skipHtml) {
      // Default behavior is to show (encoded) HTML.
      children.push(child.value)
    }
  }

  return children
}

/**
 * @param {Context} context
 * @param {Element} node
 * @param {number} index
 * @param {Element|Root} parent
 */
function toReact(context, node, index, parent) {
  const options = context.options
  const transform =
    options.transformLinkUri === undefined
      ? uriTransformer
      : options.transformLinkUri
  const parentSchema = context.schema
  /** @type {ReactMarkdownNames} */
  // @ts-expect-error assume a known HTML/SVG element.
  const name = node.tagName
  /** @type {Record<string, unknown>} */
  const properties = {}
  let schema = parentSchema
  /** @type {string} */
  let property

  if (parentSchema.space === 'html' && name === 'svg') {
    schema = property_information_svg
    context.schema = schema
  }

  if (node.properties) {
    for (property in node.properties) {
      if (ast_to_react_own.call(node.properties, property)) {
        addProperty(properties, property, node.properties[property], context)
      }
    }
  }

  if (name === 'ol' || name === 'ul') {
    context.listDepth++
  }

  const children = childrenToReact(context, node)

  if (name === 'ol' || name === 'ul') {
    context.listDepth--
  }

  // Restore parent schema.
  context.schema = parentSchema

  // Nodes created by plugins do not have positional info, in which case we use
  // an object that matches the position interface.
  const position = node.position || {
    start: {line: null, column: null, offset: null},
    end: {line: null, column: null, offset: null}
  }
  const component =
    options.components && ast_to_react_own.call(options.components, name)
      ? options.components[name]
      : name
  const basic = typeof component === 'string' || component === react.Fragment

  if (!react_is.isValidElementType(component)) {
    throw new TypeError(
      `Component for name \`${name}\` not defined or is not renderable`
    )
  }

  properties.key = index

  if (name === 'a' && options.linkTarget) {
    properties.target =
      typeof options.linkTarget === 'function'
        ? options.linkTarget(
            String(properties.href || ''),
            node.children,
            typeof properties.title === 'string' ? properties.title : null
          )
        : options.linkTarget
  }

  if (name === 'a' && transform) {
    properties.href = transform(
      String(properties.href || ''),
      node.children,
      typeof properties.title === 'string' ? properties.title : null
    )
  }

  if (
    !basic &&
    name === 'code' &&
    parent.type === 'element' &&
    parent.tagName !== 'pre'
  ) {
    properties.inline = true
  }

  if (
    !basic &&
    (name === 'h1' ||
      name === 'h2' ||
      name === 'h3' ||
      name === 'h4' ||
      name === 'h5' ||
      name === 'h6')
  ) {
    properties.level = Number.parseInt(name.charAt(1), 10)
  }

  if (name === 'img' && options.transformImageUri) {
    properties.src = options.transformImageUri(
      String(properties.src || ''),
      String(properties.alt || ''),
      typeof properties.title === 'string' ? properties.title : null
    )
  }

  if (!basic && name === 'li' && parent.type === 'element') {
    const input = getInputElement(node)
    properties.checked =
      input && input.properties ? Boolean(input.properties.checked) : null
    properties.index = getElementsBeforeCount(parent, node)
    properties.ordered = parent.tagName === 'ol'
  }

  if (!basic && (name === 'ol' || name === 'ul')) {
    properties.ordered = name === 'ol'
    properties.depth = context.listDepth
  }

  if (name === 'td' || name === 'th') {
    if (properties.align) {
      if (!properties.style) properties.style = {}
      // @ts-expect-error assume `style` is an object
      properties.style.textAlign = properties.align
      delete properties.align
    }

    if (!basic) {
      properties.isHeader = name === 'th'
    }
  }

  if (!basic && name === 'tr' && parent.type === 'element') {
    properties.isHeader = Boolean(parent.tagName === 'thead')
  }

  // If `sourcePos` is given, pass source information (line/column info from markdown source).
  if (options.sourcePos) {
    properties['data-sourcepos'] = flattenPosition(position)
  }

  if (!basic && options.rawSourcePos) {
    properties.sourcePosition = node.position
  }

  // If `includeElementIndex` is given, pass node index info to components.
  if (!basic && options.includeElementIndex) {
    properties.index = getElementsBeforeCount(parent, node)
    properties.siblingCount = getElementsBeforeCount(parent)
  }

  if (!basic) {
    properties.node = node
  }

  // Ensure no React warnings are emitted for void elements w/ children.
  return children.length > 0
    ? react.createElement(component, properties, children)
    : react.createElement(component, properties)
}

/**
 * @param {Element|Root} node
 * @returns {Element?}
 */
function getInputElement(node) {
  let index = -1

  while (++index < node.children.length) {
    const child = node.children[index]

    if (child.type === 'element' && child.tagName === 'input') {
      return child
    }
  }

  return null
}

/**
 * @param {Element|Root} parent
 * @param {Element} [node]
 * @returns {number}
 */
function getElementsBeforeCount(parent, node) {
  let index = -1
  let count = 0

  while (++index < parent.children.length) {
    if (parent.children[index] === node) break
    if (parent.children[index].type === 'element') count++
  }

  return count
}

/**
 * @param {Record<string, unknown>} props
 * @param {string} prop
 * @param {unknown} value
 * @param {Context} ctx
 */
function addProperty(props, prop, value, ctx) {
  const info = find(ctx.schema, prop)
  let result = value

  // Ignore nullish and `NaN` values.
  // eslint-disable-next-line no-self-compare
  if (result === null || result === undefined || result !== result) {
    return
  }

  // Accept `array`.
  // Most props are space-separated.
  if (Array.isArray(result)) {
    result = info.commaSeparated ? comma_separated_tokens_stringify(result) : stringify(result)
  }

  if (info.property === 'style' && typeof result === 'string') {
    result = parseStyle(result)
  }

  if (info.space && info.property) {
    props[
      ast_to_react_own.call(hastToReact, info.property)
        ? hastToReact[info.property]
        : info.property
    ] = result
  } else if (info.attribute) {
    props[info.attribute] = result
  }
}

/**
 * @param {string} value
 * @returns {Record<string, string>}
 */
function parseStyle(value) {
  /** @type {Record<string, string>} */
  const result = {}

  try {
    node_modules_style_to_object(value, iterator)
  } catch {
    // Silent.
  }

  return result

  /**
   * @param {string} name
   * @param {string} v
   */
  function iterator(name, v) {
    const k = name.slice(0, 4) === '-ms-' ? `ms-${name.slice(4)}` : name
    result[k.replace(/-([a-z])/g, styleReplacer)] = v
  }
}

/**
 * @param {unknown} _
 * @param {string} $1
 */
function styleReplacer(_, $1) {
  return $1.toUpperCase()
}

/**
 * @param {Position|{start: {line: null, column: null, offset: null}, end: {line: null, column: null, offset: null}}} pos
 * @returns {string}
 */
function flattenPosition(pos) {
  return [
    pos.start.line,
    ':',
    pos.start.column,
    '-',
    pos.end.line,
    ':',
    pos.end.column
  ]
    .map(String)
    .join('')
}

;// CONCATENATED MODULE: ../node_modules/react-markdown/lib/react-markdown.js
/**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('react').ReactElement<{}>} ReactElement
 * @typedef {import('unified').PluggableList} PluggableList
 * @typedef {import('hast').Root} Root
 * @typedef {import('./rehype-filter.js').Options} FilterOptions
 * @typedef {import('./ast-to-react.js').Options} TransformOptions
 *
 * @typedef CoreOptions
 * @property {string} children
 *
 * @typedef PluginOptions
 * @property {PluggableList} [remarkPlugins=[]]
 * @property {PluggableList} [rehypePlugins=[]]
 * @property {import('remark-rehype').Options | undefined} [remarkRehypeOptions={}]
 *
 * @typedef LayoutOptions
 * @property {string} [className]
 *
 * @typedef {CoreOptions & PluginOptions & LayoutOptions & FilterOptions & TransformOptions} ReactMarkdownOptions
 *
 * @typedef Deprecation
 * @property {string} id
 * @property {string} [to]
 */











const react_markdown_own = {}.hasOwnProperty
const changelog =
  'https://github.com/remarkjs/react-markdown/blob/main/changelog.md'

/** @type {Record<string, Deprecation>} */
const deprecated = {
  plugins: {to: 'remarkPlugins', id: 'change-plugins-to-remarkplugins'},
  renderers: {to: 'components', id: 'change-renderers-to-components'},
  astPlugins: {id: 'remove-buggy-html-in-markdown-parser'},
  allowDangerousHtml: {id: 'remove-buggy-html-in-markdown-parser'},
  escapeHtml: {id: 'remove-buggy-html-in-markdown-parser'},
  source: {to: 'children', id: 'change-source-to-children'},
  allowNode: {
    to: 'allowElement',
    id: 'replace-allownode-allowedtypes-and-disallowedtypes'
  },
  allowedTypes: {
    to: 'allowedElements',
    id: 'replace-allownode-allowedtypes-and-disallowedtypes'
  },
  disallowedTypes: {
    to: 'disallowedElements',
    id: 'replace-allownode-allowedtypes-and-disallowedtypes'
  },
  includeNodeIndex: {
    to: 'includeElementIndex',
    id: 'change-includenodeindex-to-includeelementindex'
  }
}

/**
 * React component to render markdown.
 *
 * @param {ReactMarkdownOptions} options
 * @returns {ReactElement}
 */
function ReactMarkdown(options) {
  for (const key in deprecated) {
    if (react_markdown_own.call(deprecated, key) && react_markdown_own.call(options, key)) {
      const deprecation = deprecated[key]
      console.warn(
        `[react-markdown] Warning: please ${
          deprecation.to ? `use \`${deprecation.to}\` instead of` : 'remove'
        } \`${key}\` (see <${changelog}#${deprecation.id}> for more info)`
      )
      delete deprecated[key]
    }
  }

  const processor = unified()
    .use(remarkParse)
    .use(options.remarkPlugins || [])
    .use(lib, {
      ...options.remarkRehypeOptions,
      allowDangerousHtml: true
    })
    .use(options.rehypePlugins || [])
    .use(rehypeFilter, options)

  const file = new VFile()

  if (typeof options.children === 'string') {
    file.value = options.children
  } else if (options.children !== undefined && options.children !== null) {
    console.warn(
      `[react-markdown] Warning: please pass a string as \`children\` (not: \`${options.children}\`)`
    )
  }

  const hastNode = processor.runSync(processor.parse(file), file)

  if (hastNode.type !== 'root') {
    throw new TypeError('Expected a `root` node')
  }

  /** @type {ReactElement} */
  let result = react.createElement(
    react.Fragment,
    {},
    childrenToReact({options, schema: property_information_html, listDepth: 0}, hastNode)
  )

  if (options.className) {
    result = react.createElement('div', {className: options.className}, result)
  }

  return result
}

ReactMarkdown.propTypes = {
  // Core options:
  children: prop_types.string,
  // Layout options:
  className: prop_types.string,
  // Filter options:
  allowElement: prop_types.func,
  allowedElements: prop_types.arrayOf(prop_types.string),
  disallowedElements: prop_types.arrayOf(prop_types.string),
  unwrapDisallowed: prop_types.bool,
  // Plugin options:
  remarkPlugins: prop_types.arrayOf(
    prop_types.oneOfType([
      prop_types.object,
      prop_types.func,
      prop_types.arrayOf(
        prop_types.oneOfType([
          prop_types.bool,
          prop_types.string,
          prop_types.object,
          prop_types.func,
          prop_types.arrayOf(
            // prettier-ignore
            // type-coverage:ignore-next-line
            prop_types.any
          )
        ])
      )
    ])
  ),
  rehypePlugins: prop_types.arrayOf(
    prop_types.oneOfType([
      prop_types.object,
      prop_types.func,
      prop_types.arrayOf(
        prop_types.oneOfType([
          prop_types.bool,
          prop_types.string,
          prop_types.object,
          prop_types.func,
          prop_types.arrayOf(
            // prettier-ignore
            // type-coverage:ignore-next-line
            prop_types.any
          )
        ])
      )
    ])
  ),
  // Transform options:
  sourcePos: prop_types.bool,
  rawSourcePos: prop_types.bool,
  skipHtml: prop_types.bool,
  includeElementIndex: prop_types.bool,
  transformLinkUri: prop_types.oneOfType([prop_types.func, prop_types.bool]),
  linkTarget: prop_types.oneOfType([prop_types.func, prop_types.string]),
  transformImageUri: prop_types.func,
  components: prop_types.object
}

;// CONCATENATED MODULE: ../node_modules/micromark-extension-gfm-autolink-literal/lib/syntax.js
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').ConstructRecord} ConstructRecord
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Previous} Previous
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */


const wwwPrefix = {
  tokenize: tokenizeWwwPrefix,
  partial: true
}
const domain = {
  tokenize: tokenizeDomain,
  partial: true
}
const syntax_path = {
  tokenize: tokenizePath,
  partial: true
}
const trail = {
  tokenize: tokenizeTrail,
  partial: true
}
const emailDomainDotTrail = {
  tokenize: tokenizeEmailDomainDotTrail,
  partial: true
}
const wwwAutolink = {
  tokenize: tokenizeWwwAutolink,
  previous: previousWww
}
const protocolAutolink = {
  tokenize: tokenizeProtocolAutolink,
  previous: previousProtocol
}
const emailAutolink = {
  tokenize: tokenizeEmailAutolink,
  previous: previousEmail
}

/** @type {ConstructRecord} */
const syntax_text = {}

// To do: next major: expose functions that yields extension.

/**
 * Extension for `micromark` that can be passed in `extensions` to enable GFM
 * autolink literal syntax.
 *
 * @type {Extension}
 */
const gfmAutolinkLiteral = {
  text: syntax_text
}

/** @type {Code} */
let syntax_code = 48

// Add alphanumerics.
while (syntax_code < 123) {
  syntax_text[syntax_code] = emailAutolink
  syntax_code++
  if (syntax_code === 58) syntax_code = 65
  else if (syntax_code === 91) syntax_code = 97
}
syntax_text[43] = emailAutolink
syntax_text[45] = emailAutolink
syntax_text[46] = emailAutolink
syntax_text[95] = emailAutolink
syntax_text[72] = [emailAutolink, protocolAutolink]
syntax_text[104] = [emailAutolink, protocolAutolink]
syntax_text[87] = [emailAutolink, wwwAutolink]
syntax_text[119] = [emailAutolink, wwwAutolink]

// To do: perform email autolink literals on events, afterwards.
// That’s where `markdown-rs` and `cmark-gfm` perform it.
// It should look for `@`, then for atext backwards, and then for a label
// forwards.
// To do: `mailto:`, `xmpp:` protocol as prefix.

/**
 * Email autolink literal.
 *
 * ```markdown
 * > | a contact@example.org b
 *       ^^^^^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeEmailAutolink(effects, ok, nok) {
  const self = this
  /** @type {boolean | undefined} */
  let dot
  /** @type {boolean} */
  let data
  return start

  /**
   * Start of email autolink literal.
   *
   * ```markdown
   * > | a contact@example.org b
   *       ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    if (
      !gfmAtext(code) ||
      !previousEmail.call(self, self.previous) ||
      previousUnbalanced(self.events)
    ) {
      return nok(code)
    }
    effects.enter('literalAutolink')
    effects.enter('literalAutolinkEmail')
    return atext(code)
  }

  /**
   * In email atext.
   *
   * ```markdown
   * > | a contact@example.org b
   *       ^
   * ```
   *
   * @type {State}
   */
  function atext(code) {
    if (gfmAtext(code)) {
      effects.consume(code)
      return atext
    }
    if (code === 64) {
      effects.consume(code)
      return emailDomain
    }
    return nok(code)
  }

  /**
   * In email domain.
   *
   * The reference code is a bit overly complex as it handles the `@`, of which
   * there may be just one.
   * Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L318>
   *
   * ```markdown
   * > | a contact@example.org b
   *               ^
   * ```
   *
   * @type {State}
   */
  function emailDomain(code) {
    // Dot followed by alphanumerical (not `-` or `_`).
    if (code === 46) {
      return effects.check(
        emailDomainDotTrail,
        emailDomainAfter,
        emailDomainDot
      )(code)
    }

    // Alphanumerical, `-`, and `_`.
    if (code === 45 || code === 95 || asciiAlphanumeric(code)) {
      data = true
      effects.consume(code)
      return emailDomain
    }

    // To do: `/` if xmpp.

    // Note: normally we’d truncate trailing punctuation from the link.
    // However, email autolink literals cannot contain any of those markers,
    // except for `.`, but that can only occur if it isn’t trailing.
    // So we can ignore truncating!
    return emailDomainAfter(code)
  }

  /**
   * In email domain, on dot that is not a trail.
   *
   * ```markdown
   * > | a contact@example.org b
   *                      ^
   * ```
   *
   * @type {State}
   */
  function emailDomainDot(code) {
    effects.consume(code)
    dot = true
    return emailDomain
  }

  /**
   * After email domain.
   *
   * ```markdown
   * > | a contact@example.org b
   *                          ^
   * ```
   *
   * @type {State}
   */
  function emailDomainAfter(code) {
    // Domain must not be empty, must include a dot, and must end in alphabetical.
    // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L332>.
    if (data && dot && asciiAlpha(self.previous)) {
      effects.exit('literalAutolinkEmail')
      effects.exit('literalAutolink')
      return ok(code)
    }
    return nok(code)
  }
}

/**
 * `www` autolink literal.
 *
 * ```markdown
 * > | a www.example.org b
 *       ^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeWwwAutolink(effects, ok, nok) {
  const self = this
  return wwwStart

  /**
   * Start of www autolink literal.
   *
   * ```markdown
   * > | www.example.com/a?b#c
   *     ^
   * ```
   *
   * @type {State}
   */
  function wwwStart(code) {
    if (
      (code !== 87 && code !== 119) ||
      !previousWww.call(self, self.previous) ||
      previousUnbalanced(self.events)
    ) {
      return nok(code)
    }
    effects.enter('literalAutolink')
    effects.enter('literalAutolinkWww')
    // Note: we *check*, so we can discard the `www.` we parsed.
    // If it worked, we consider it as a part of the domain.
    return effects.check(
      wwwPrefix,
      effects.attempt(domain, effects.attempt(syntax_path, wwwAfter), nok),
      nok
    )(code)
  }

  /**
   * After a www autolink literal.
   *
   * ```markdown
   * > | www.example.com/a?b#c
   *                          ^
   * ```
   *
   * @type {State}
   */
  function wwwAfter(code) {
    effects.exit('literalAutolinkWww')
    effects.exit('literalAutolink')
    return ok(code)
  }
}

/**
 * Protocol autolink literal.
 *
 * ```markdown
 * > | a https://example.org b
 *       ^^^^^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeProtocolAutolink(effects, ok, nok) {
  const self = this
  let buffer = ''
  let seen = false
  return protocolStart

  /**
   * Start of protocol autolink literal.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *     ^
   * ```
   *
   * @type {State}
   */
  function protocolStart(code) {
    if (
      (code === 72 || code === 104) &&
      previousProtocol.call(self, self.previous) &&
      !previousUnbalanced(self.events)
    ) {
      effects.enter('literalAutolink')
      effects.enter('literalAutolinkHttp')
      buffer += String.fromCodePoint(code)
      effects.consume(code)
      return protocolPrefixInside
    }
    return nok(code)
  }

  /**
   * In protocol.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *     ^^^^^
   * ```
   *
   * @type {State}
   */
  function protocolPrefixInside(code) {
    // `5` is size of `https`
    if (asciiAlpha(code) && buffer.length < 5) {
      // @ts-expect-error: definitely number.
      buffer += String.fromCodePoint(code)
      effects.consume(code)
      return protocolPrefixInside
    }
    if (code === 58) {
      const protocol = buffer.toLowerCase()
      if (protocol === 'http' || protocol === 'https') {
        effects.consume(code)
        return protocolSlashesInside
      }
    }
    return nok(code)
  }

  /**
   * In slashes.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *           ^^
   * ```
   *
   * @type {State}
   */
  function protocolSlashesInside(code) {
    if (code === 47) {
      effects.consume(code)
      if (seen) {
        return afterProtocol
      }
      seen = true
      return protocolSlashesInside
    }
    return nok(code)
  }

  /**
   * After protocol, before domain.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *             ^
   * ```
   *
   * @type {State}
   */
  function afterProtocol(code) {
    // To do: this is different from `markdown-rs`:
    // https://github.com/wooorm/markdown-rs/blob/b3a921c761309ae00a51fe348d8a43adbc54b518/src/construct/gfm_autolink_literal.rs#L172-L182
    return code === null ||
      asciiControl(code) ||
      markdownLineEndingOrSpace(code) ||
      unicodeWhitespace(code) ||
      unicodePunctuation(code)
      ? nok(code)
      : effects.attempt(domain, effects.attempt(syntax_path, protocolAfter), nok)(code)
  }

  /**
   * After a protocol autolink literal.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *                              ^
   * ```
   *
   * @type {State}
   */
  function protocolAfter(code) {
    effects.exit('literalAutolinkHttp')
    effects.exit('literalAutolink')
    return ok(code)
  }
}

/**
 * `www` prefix.
 *
 * ```markdown
 * > | a www.example.org b
 *       ^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeWwwPrefix(effects, ok, nok) {
  let size = 0
  return wwwPrefixInside

  /**
   * In www prefix.
   *
   * ```markdown
   * > | www.example.com
   *     ^^^^
   * ```
   *
   * @type {State}
   */
  function wwwPrefixInside(code) {
    if ((code === 87 || code === 119) && size < 3) {
      size++
      effects.consume(code)
      return wwwPrefixInside
    }
    if (code === 46 && size === 3) {
      effects.consume(code)
      return wwwPrefixAfter
    }
    return nok(code)
  }

  /**
   * After www prefix.
   *
   * ```markdown
   * > | www.example.com
   *         ^
   * ```
   *
   * @type {State}
   */
  function wwwPrefixAfter(code) {
    // If there is *anything*, we can link.
    return code === null ? nok(code) : ok(code)
  }
}

/**
 * Domain.
 *
 * ```markdown
 * > | a https://example.org b
 *               ^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeDomain(effects, ok, nok) {
  /** @type {boolean | undefined} */
  let underscoreInLastSegment
  /** @type {boolean | undefined} */
  let underscoreInLastLastSegment
  /** @type {boolean | undefined} */
  let seen
  return domainInside

  /**
   * In domain.
   *
   * ```markdown
   * > | https://example.com/a
   *             ^^^^^^^^^^^
   * ```
   *
   * @type {State}
   */
  function domainInside(code) {
    // Check whether this marker, which is a trailing punctuation
    // marker, optionally followed by more trailing markers, and then
    // followed by an end.
    if (code === 46 || code === 95) {
      return effects.check(trail, domainAfter, domainAtPunctuation)(code)
    }

    // GH documents that only alphanumerics (other than `-`, `.`, and `_`) can
    // occur, which sounds like ASCII only, but they also support `www.點看.com`,
    // so that’s Unicode.
    // Instead of some new production for Unicode alphanumerics, markdown
    // already has that for Unicode punctuation and whitespace, so use those.
    // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L12>.
    if (
      code === null ||
      markdownLineEndingOrSpace(code) ||
      unicodeWhitespace(code) ||
      (code !== 45 && unicodePunctuation(code))
    ) {
      return domainAfter(code)
    }
    seen = true
    effects.consume(code)
    return domainInside
  }

  /**
   * In domain, at potential trailing punctuation, that was not trailing.
   *
   * ```markdown
   * > | https://example.com
   *                    ^
   * ```
   *
   * @type {State}
   */
  function domainAtPunctuation(code) {
    // There is an underscore in the last segment of the domain
    if (code === 95) {
      underscoreInLastSegment = true
    }
    // Otherwise, it’s a `.`: save the last segment underscore in the
    // penultimate segment slot.
    else {
      underscoreInLastLastSegment = underscoreInLastSegment
      underscoreInLastSegment = undefined
    }
    effects.consume(code)
    return domainInside
  }

  /**
   * After domain.
   *
   * ```markdown
   * > | https://example.com/a
   *                        ^
   * ```
   *
   * @type {State} */
  function domainAfter(code) {
    // Note: that’s GH says a dot is needed, but it’s not true:
    // <https://github.com/github/cmark-gfm/issues/279>
    if (underscoreInLastLastSegment || underscoreInLastSegment || !seen) {
      return nok(code)
    }
    return ok(code)
  }
}

/**
 * Path.
 *
 * ```markdown
 * > | a https://example.org/stuff b
 *                          ^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizePath(effects, ok) {
  let sizeOpen = 0
  let sizeClose = 0
  return pathInside

  /**
   * In path.
   *
   * ```markdown
   * > | https://example.com/a
   *                        ^^
   * ```
   *
   * @type {State}
   */
  function pathInside(code) {
    if (code === 40) {
      sizeOpen++
      effects.consume(code)
      return pathInside
    }

    // To do: `markdown-rs` also needs this.
    // If this is a paren, and there are less closings than openings,
    // we don’t check for a trail.
    if (code === 41 && sizeClose < sizeOpen) {
      return pathAtPunctuation(code)
    }

    // Check whether this trailing punctuation marker is optionally
    // followed by more trailing markers, and then followed
    // by an end.
    if (
      code === 33 ||
      code === 34 ||
      code === 38 ||
      code === 39 ||
      code === 41 ||
      code === 42 ||
      code === 44 ||
      code === 46 ||
      code === 58 ||
      code === 59 ||
      code === 60 ||
      code === 63 ||
      code === 93 ||
      code === 95 ||
      code === 126
    ) {
      return effects.check(trail, ok, pathAtPunctuation)(code)
    }
    if (
      code === null ||
      markdownLineEndingOrSpace(code) ||
      unicodeWhitespace(code)
    ) {
      return ok(code)
    }
    effects.consume(code)
    return pathInside
  }

  /**
   * In path, at potential trailing punctuation, that was not trailing.
   *
   * ```markdown
   * > | https://example.com/a"b
   *                          ^
   * ```
   *
   * @type {State}
   */
  function pathAtPunctuation(code) {
    // Count closing parens.
    if (code === 41) {
      sizeClose++
    }
    effects.consume(code)
    return pathInside
  }
}

/**
 * Trail.
 *
 * This calls `ok` if this *is* the trail, followed by an end, which means
 * the entire trail is not part of the link.
 * It calls `nok` if this *is* part of the link.
 *
 * ```markdown
 * > | https://example.com").
 *                        ^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeTrail(effects, ok, nok) {
  return trail

  /**
   * In trail of domain or path.
   *
   * ```markdown
   * > | https://example.com").
   *                        ^
   * ```
   *
   * @type {State}
   */
  function trail(code) {
    // Regular trailing punctuation.
    if (
      code === 33 ||
      code === 34 ||
      code === 39 ||
      code === 41 ||
      code === 42 ||
      code === 44 ||
      code === 46 ||
      code === 58 ||
      code === 59 ||
      code === 63 ||
      code === 95 ||
      code === 126
    ) {
      effects.consume(code)
      return trail
    }

    // `&` followed by one or more alphabeticals and then a `;`, is
    // as a whole considered as trailing punctuation.
    // In all other cases, it is considered as continuation of the URL.
    if (code === 38) {
      effects.consume(code)
      return trailCharRefStart
    }

    // Needed because we allow literals after `[`, as we fix:
    // <https://github.com/github/cmark-gfm/issues/278>.
    // Check that it is not followed by `(` or `[`.
    if (code === 93) {
      effects.consume(code)
      return trailBracketAfter
    }
    if (
      // `<` is an end.
      code === 60 ||
      // So is whitespace.
      code === null ||
      markdownLineEndingOrSpace(code) ||
      unicodeWhitespace(code)
    ) {
      return ok(code)
    }
    return nok(code)
  }

  /**
   * In trail, after `]`.
   *
   * > 👉 **Note**: this deviates from `cmark-gfm` to fix a bug.
   * > See end of <https://github.com/github/cmark-gfm/issues/278> for more.
   *
   * ```markdown
   * > | https://example.com](
   *                         ^
   * ```
   *
   * @type {State}
   */
  function trailBracketAfter(code) {
    // Whitespace or something that could start a resource or reference is the end.
    // Switch back to trail otherwise.
    if (
      code === null ||
      code === 40 ||
      code === 91 ||
      markdownLineEndingOrSpace(code) ||
      unicodeWhitespace(code)
    ) {
      return ok(code)
    }
    return trail(code)
  }

  /**
   * In character-reference like trail, after `&`.
   *
   * ```markdown
   * > | https://example.com&amp;).
   *                         ^
   * ```
   *
   * @type {State}
   */
  function trailCharRefStart(code) {
    // When non-alpha, it’s not a trail.
    return asciiAlpha(code) ? trailCharRefInside(code) : nok(code)
  }

  /**
   * In character-reference like trail.
   *
   * ```markdown
   * > | https://example.com&amp;).
   *                         ^
   * ```
   *
   * @type {State}
   */
  function trailCharRefInside(code) {
    // Switch back to trail if this is well-formed.
    if (code === 59) {
      effects.consume(code)
      return trail
    }
    if (asciiAlpha(code)) {
      effects.consume(code)
      return trailCharRefInside
    }

    // It’s not a trail.
    return nok(code)
  }
}

/**
 * Dot in email domain trail.
 *
 * This calls `ok` if this *is* the trail, followed by an end, which means
 * the trail is not part of the link.
 * It calls `nok` if this *is* part of the link.
 *
 * ```markdown
 * > | contact@example.org.
 *                        ^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeEmailDomainDotTrail(effects, ok, nok) {
  return start

  /**
   * Dot.
   *
   * ```markdown
   * > | contact@example.org.
   *                    ^   ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    // Must be dot.
    effects.consume(code)
    return after
  }

  /**
   * After dot.
   *
   * ```markdown
   * > | contact@example.org.
   *                     ^   ^
   * ```
   *
   * @type {State}
   */
  function after(code) {
    // Not a trail if alphanumeric.
    return asciiAlphanumeric(code) ? nok(code) : ok(code)
  }
}

/**
 * See:
 * <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L156>.
 *
 * @type {Previous}
 */
function previousWww(code) {
  return (
    code === null ||
    code === 40 ||
    code === 42 ||
    code === 95 ||
    code === 91 ||
    code === 93 ||
    code === 126 ||
    markdownLineEndingOrSpace(code)
  )
}

/**
 * See:
 * <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L214>.
 *
 * @type {Previous}
 */
function previousProtocol(code) {
  return !asciiAlpha(code)
}

/**
 * @this {TokenizeContext}
 * @type {Previous}
 */
function previousEmail(code) {
  // Do not allow a slash “inside” atext.
  // The reference code is a bit weird, but that’s what it results in.
  // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L307>.
  // Other than slash, every preceding character is allowed.
  return !(code === 47 || gfmAtext(code))
}

/**
 * @param {Code} code
 * @returns {boolean}
 */
function gfmAtext(code) {
  return (
    code === 43 ||
    code === 45 ||
    code === 46 ||
    code === 95 ||
    asciiAlphanumeric(code)
  )
}

/**
 * @param {Array<Event>} events
 * @returns {boolean}
 */
function previousUnbalanced(events) {
  let index = events.length
  let result = false
  while (index--) {
    const token = events[index][1]
    if (
      (token.type === 'labelLink' || token.type === 'labelImage') &&
      !token._balanced
    ) {
      result = true
      break
    }

    // If we’ve seen this token, and it was marked as not having any unbalanced
    // bracket before it, we can exit.
    if (token._gfmAutolinkLiteralWalkedInto) {
      result = false
      break
    }
  }
  if (events.length > 0 && !result) {
    // Mark the last token as “walked into” w/o finding
    // anything.
    events[events.length - 1][1]._gfmAutolinkLiteralWalkedInto = true
  }
  return result
}

;// CONCATENATED MODULE: ../node_modules/micromark-extension-gfm-footnote/lib/syntax.js
/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */





const indent = {
  tokenize: syntax_tokenizeIndent,
  partial: true
}

// To do: micromark should support a `_hiddenGfmFootnoteSupport`, which only
// affects label start (image).
// That will let us drop `tokenizePotentialGfmFootnote*`.
// It currently has a `_hiddenFootnoteSupport`, which affects that and more.
// That can be removed when `micromark-extension-footnote` is archived.

/**
 * Create an extension for `micromark` to enable GFM footnote syntax.
 *
 * @returns {Extension}
 *   Extension for `micromark` that can be passed in `extensions` to
 *   enable GFM footnote syntax.
 */
function gfmFootnote() {
  /** @type {Extension} */
  return {
    document: {
      [91]: {
        tokenize: tokenizeDefinitionStart,
        continuation: {
          tokenize: tokenizeDefinitionContinuation
        },
        exit: gfmFootnoteDefinitionEnd
      }
    },
    text: {
      [91]: {
        tokenize: tokenizeGfmFootnoteCall
      },
      [93]: {
        add: 'after',
        tokenize: tokenizePotentialGfmFootnoteCall,
        resolveTo: resolveToPotentialGfmFootnoteCall
      }
    }
  }
}

// To do: remove after micromark update.
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizePotentialGfmFootnoteCall(effects, ok, nok) {
  const self = this
  let index = self.events.length
  /** @type {Array<string>} */
  // @ts-expect-error It’s fine!
  const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = [])
  /** @type {Token} */
  let labelStart

  // Find an opening.
  while (index--) {
    const token = self.events[index][1]
    if (token.type === 'labelImage') {
      labelStart = token
      break
    }

    // Exit if we’ve walked far enough.
    if (
      token.type === 'gfmFootnoteCall' ||
      token.type === 'labelLink' ||
      token.type === 'label' ||
      token.type === 'image' ||
      token.type === 'link'
    ) {
      break
    }
  }
  return start

  /**
   * @type {State}
   */
  function start(code) {
    if (!labelStart || !labelStart._balanced) {
      return nok(code)
    }
    const id = normalizeIdentifier(
      self.sliceSerialize({
        start: labelStart.end,
        end: self.now()
      })
    )
    if (id.codePointAt(0) !== 94 || !defined.includes(id.slice(1))) {
      return nok(code)
    }
    effects.enter('gfmFootnoteCallLabelMarker')
    effects.consume(code)
    effects.exit('gfmFootnoteCallLabelMarker')
    return ok(code)
  }
}

// To do: remove after micromark update.
/** @type {Resolver} */
function resolveToPotentialGfmFootnoteCall(events, context) {
  let index = events.length
  /** @type {Token | undefined} */
  let labelStart

  // Find an opening.
  while (index--) {
    if (
      events[index][1].type === 'labelImage' &&
      events[index][0] === 'enter'
    ) {
      labelStart = events[index][1]
      break
    }
  }
  // Change the `labelImageMarker` to a `data`.
  events[index + 1][1].type = 'data'
  events[index + 3][1].type = 'gfmFootnoteCallLabelMarker'

  // The whole (without `!`):
  /** @type {Token} */
  const call = {
    type: 'gfmFootnoteCall',
    start: Object.assign({}, events[index + 3][1].start),
    end: Object.assign({}, events[events.length - 1][1].end)
  }
  // The `^` marker
  /** @type {Token} */
  const marker = {
    type: 'gfmFootnoteCallMarker',
    start: Object.assign({}, events[index + 3][1].end),
    end: Object.assign({}, events[index + 3][1].end)
  }
  // Increment the end 1 character.
  marker.end.column++
  marker.end.offset++
  marker.end._bufferIndex++
  /** @type {Token} */
  const string = {
    type: 'gfmFootnoteCallString',
    start: Object.assign({}, marker.end),
    end: Object.assign({}, events[events.length - 1][1].start)
  }
  /** @type {Token} */
  const chunk = {
    type: 'chunkString',
    contentType: 'string',
    start: Object.assign({}, string.start),
    end: Object.assign({}, string.end)
  }

  /** @type {Array<Event>} */
  const replacement = [
    // Take the `labelImageMarker` (now `data`, the `!`)
    events[index + 1],
    events[index + 2],
    ['enter', call, context],
    // The `[`
    events[index + 3],
    events[index + 4],
    // The `^`.
    ['enter', marker, context],
    ['exit', marker, context],
    // Everything in between.
    ['enter', string, context],
    ['enter', chunk, context],
    ['exit', chunk, context],
    ['exit', string, context],
    // The ending (`]`, properly parsed and labelled).
    events[events.length - 2],
    events[events.length - 1],
    ['exit', call, context]
  ]
  events.splice(index, events.length - index + 1, ...replacement)
  return events
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeGfmFootnoteCall(effects, ok, nok) {
  const self = this
  /** @type {Array<string>} */
  // @ts-expect-error It’s fine!
  const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = [])
  let size = 0
  /** @type {boolean} */
  let data

  // Note: the implementation of `markdown-rs` is different, because it houses
  // core *and* extensions in one project.
  // Therefore, it can include footnote logic inside `label-end`.
  // We can’t do that, but luckily, we can parse footnotes in a simpler way than
  // needed for labels.
  return start

  /**
   * Start of footnote label.
   *
   * ```markdown
   * > | a [^b] c
   *       ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter('gfmFootnoteCall')
    effects.enter('gfmFootnoteCallLabelMarker')
    effects.consume(code)
    effects.exit('gfmFootnoteCallLabelMarker')
    return callStart
  }

  /**
   * After `[`, at `^`.
   *
   * ```markdown
   * > | a [^b] c
   *        ^
   * ```
   *
   * @type {State}
   */
  function callStart(code) {
    if (code !== 94) return nok(code)
    effects.enter('gfmFootnoteCallMarker')
    effects.consume(code)
    effects.exit('gfmFootnoteCallMarker')
    effects.enter('gfmFootnoteCallString')
    effects.enter('chunkString').contentType = 'string'
    return callData
  }

  /**
   * In label.
   *
   * ```markdown
   * > | a [^b] c
   *         ^
   * ```
   *
   * @type {State}
   */
  function callData(code) {
    if (
      // Too long.
      size > 999 ||
      // Closing brace with nothing.
      (code === 93 && !data) ||
      // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      code === null ||
      code === 91 ||
      markdownLineEndingOrSpace(code)
    ) {
      return nok(code)
    }
    if (code === 93) {
      effects.exit('chunkString')
      const token = effects.exit('gfmFootnoteCallString')
      if (!defined.includes(normalizeIdentifier(self.sliceSerialize(token)))) {
        return nok(code)
      }
      effects.enter('gfmFootnoteCallLabelMarker')
      effects.consume(code)
      effects.exit('gfmFootnoteCallLabelMarker')
      effects.exit('gfmFootnoteCall')
      return ok
    }
    if (!markdownLineEndingOrSpace(code)) {
      data = true
    }
    size++
    effects.consume(code)
    return code === 92 ? callEscape : callData
  }

  /**
   * On character after escape.
   *
   * ```markdown
   * > | a [^b\c] d
   *           ^
   * ```
   *
   * @type {State}
   */
  function callEscape(code) {
    if (code === 91 || code === 92 || code === 93) {
      effects.consume(code)
      size++
      return callData
    }
    return callData(code)
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeDefinitionStart(effects, ok, nok) {
  const self = this
  /** @type {Array<string>} */
  // @ts-expect-error It’s fine!
  const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = [])
  /** @type {string} */
  let identifier
  let size = 0
  /** @type {boolean | undefined} */
  let data
  return start

  /**
   * Start of GFM footnote definition.
   *
   * ```markdown
   * > | [^a]: b
   *     ^
   * ```
   *
   * @type {State}
   */
  function start(code) {
    effects.enter('gfmFootnoteDefinition')._container = true
    effects.enter('gfmFootnoteDefinitionLabel')
    effects.enter('gfmFootnoteDefinitionLabelMarker')
    effects.consume(code)
    effects.exit('gfmFootnoteDefinitionLabelMarker')
    return labelAtMarker
  }

  /**
   * In label, at caret.
   *
   * ```markdown
   * > | [^a]: b
   *      ^
   * ```
   *
   * @type {State}
   */
  function labelAtMarker(code) {
    if (code === 94) {
      effects.enter('gfmFootnoteDefinitionMarker')
      effects.consume(code)
      effects.exit('gfmFootnoteDefinitionMarker')
      effects.enter('gfmFootnoteDefinitionLabelString')
      effects.enter('chunkString').contentType = 'string'
      return labelInside
    }
    return nok(code)
  }

  /**
   * In label.
   *
   * > 👉 **Note**: `cmark-gfm` prevents whitespace from occurring in footnote
   * > definition labels.
   *
   * ```markdown
   * > | [^a]: b
   *       ^
   * ```
   *
   * @type {State}
   */
  function labelInside(code) {
    if (
      // Too long.
      size > 999 ||
      // Closing brace with nothing.
      (code === 93 && !data) ||
      // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      code === null ||
      code === 91 ||
      markdownLineEndingOrSpace(code)
    ) {
      return nok(code)
    }
    if (code === 93) {
      effects.exit('chunkString')
      const token = effects.exit('gfmFootnoteDefinitionLabelString')
      identifier = normalizeIdentifier(self.sliceSerialize(token))
      effects.enter('gfmFootnoteDefinitionLabelMarker')
      effects.consume(code)
      effects.exit('gfmFootnoteDefinitionLabelMarker')
      effects.exit('gfmFootnoteDefinitionLabel')
      return labelAfter
    }
    if (!markdownLineEndingOrSpace(code)) {
      data = true
    }
    size++
    effects.consume(code)
    return code === 92 ? labelEscape : labelInside
  }

  /**
   * After `\`, at a special character.
   *
   * > 👉 **Note**: `cmark-gfm` currently does not support escaped brackets:
   * > <https://github.com/github/cmark-gfm/issues/240>
   *
   * ```markdown
   * > | [^a\*b]: c
   *         ^
   * ```
   *
   * @type {State}
   */
  function labelEscape(code) {
    if (code === 91 || code === 92 || code === 93) {
      effects.consume(code)
      size++
      return labelInside
    }
    return labelInside(code)
  }

  /**
   * After definition label.
   *
   * ```markdown
   * > | [^a]: b
   *         ^
   * ```
   *
   * @type {State}
   */
  function labelAfter(code) {
    if (code === 58) {
      effects.enter('definitionMarker')
      effects.consume(code)
      effects.exit('definitionMarker')
      if (!defined.includes(identifier)) {
        defined.push(identifier)
      }

      // Any whitespace after the marker is eaten, forming indented code
      // is not possible.
      // No space is also fine, just like a block quote marker.
      return factorySpace(
        effects,
        whitespaceAfter,
        'gfmFootnoteDefinitionWhitespace'
      )
    }
    return nok(code)
  }

  /**
   * After definition prefix.
   *
   * ```markdown
   * > | [^a]: b
   *           ^
   * ```
   *
   * @type {State}
   */
  function whitespaceAfter(code) {
    // `markdown-rs` has a wrapping token for the prefix that is closed here.
    return ok(code)
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeDefinitionContinuation(effects, ok, nok) {
  /// Start of footnote definition continuation.
  ///
  /// ```markdown
  ///   | [^a]: b
  /// > |     c
  ///     ^
  /// ```
  //
  // Either a blank line, which is okay, or an indented thing.
  return effects.check(blankLine, ok, effects.attempt(indent, ok, nok))
}

/** @type {Exiter} */
function gfmFootnoteDefinitionEnd(effects) {
  effects.exit('gfmFootnoteDefinition')
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function syntax_tokenizeIndent(effects, ok, nok) {
  const self = this
  return factorySpace(
    effects,
    afterPrefix,
    'gfmFootnoteDefinitionIndent',
    4 + 1
  )

  /**
   * @type {State}
   */
  function afterPrefix(code) {
    const tail = self.events[self.events.length - 1]
    return tail &&
      tail[1].type === 'gfmFootnoteDefinitionIndent' &&
      tail[2].sliceSerialize(tail[1], true).length === 4
      ? ok(code)
      : nok(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-extension-gfm-strikethrough/lib/syntax.js
/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean} [singleTilde=true]
 *   Whether to support strikethrough with a single tilde.
 *
 *   Single tildes work on github.com, but are technically prohibited by the
 *   GFM spec.
 */




/**
 * Create an extension for `micromark` to enable GFM strikethrough syntax.
 *
 * @param {Options | null | undefined} [options]
 *   Configuration.
 * @returns {Extension}
 *   Extension for `micromark` that can be passed in `extensions`, to
 *   enable GFM strikethrough syntax.
 */
function gfmStrikethrough(options) {
  const options_ = options || {}
  let single = options_.singleTilde
  const tokenizer = {
    tokenize: tokenizeStrikethrough,
    resolveAll: resolveAllStrikethrough
  }
  if (single === null || single === undefined) {
    single = true
  }
  return {
    text: {
      [126]: tokenizer
    },
    insideSpan: {
      null: [tokenizer]
    },
    attentionMarkers: {
      null: [126]
    }
  }

  /**
   * Take events and resolve strikethrough.
   *
   * @type {Resolver}
   */
  function resolveAllStrikethrough(events, context) {
    let index = -1

    // Walk through all events.
    while (++index < events.length) {
      // Find a token that can close.
      if (
        events[index][0] === 'enter' &&
        events[index][1].type === 'strikethroughSequenceTemporary' &&
        events[index][1]._close
      ) {
        let open = index

        // Now walk back to find an opener.
        while (open--) {
          // Find a token that can open the closer.
          if (
            events[open][0] === 'exit' &&
            events[open][1].type === 'strikethroughSequenceTemporary' &&
            events[open][1]._open &&
            // If the sizes are the same:
            events[index][1].end.offset - events[index][1].start.offset ===
              events[open][1].end.offset - events[open][1].start.offset
          ) {
            events[index][1].type = 'strikethroughSequence'
            events[open][1].type = 'strikethroughSequence'

            /** @type {Token} */
            const strikethrough = {
              type: 'strikethrough',
              start: Object.assign({}, events[open][1].start),
              end: Object.assign({}, events[index][1].end)
            }

            /** @type {Token} */
            const text = {
              type: 'strikethroughText',
              start: Object.assign({}, events[open][1].end),
              end: Object.assign({}, events[index][1].start)
            }

            // Opening.
            /** @type {Array<Event>} */
            const nextEvents = [
              ['enter', strikethrough, context],
              ['enter', events[open][1], context],
              ['exit', events[open][1], context],
              ['enter', text, context]
            ]
            const insideSpan = context.parser.constructs.insideSpan.null
            if (insideSpan) {
              // Between.
              splice(
                nextEvents,
                nextEvents.length,
                0,
                resolveAll(insideSpan, events.slice(open + 1, index), context)
              )
            }

            // Closing.
            splice(nextEvents, nextEvents.length, 0, [
              ['exit', text, context],
              ['enter', events[index][1], context],
              ['exit', events[index][1], context],
              ['exit', strikethrough, context]
            ])
            splice(events, open - 1, index - open + 3, nextEvents)
            index = open + nextEvents.length - 2
            break
          }
        }
      }
    }
    index = -1
    while (++index < events.length) {
      if (events[index][1].type === 'strikethroughSequenceTemporary') {
        events[index][1].type = 'data'
      }
    }
    return events
  }

  /**
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */
  function tokenizeStrikethrough(effects, ok, nok) {
    const previous = this.previous
    const events = this.events
    let size = 0
    return start

    /** @type {State} */
    function start(code) {
      if (
        previous === 126 &&
        events[events.length - 1][1].type !== 'characterEscape'
      ) {
        return nok(code)
      }
      effects.enter('strikethroughSequenceTemporary')
      return more(code)
    }

    /** @type {State} */
    function more(code) {
      const before = classifyCharacter(previous)
      if (code === 126) {
        // If this is the third marker, exit.
        if (size > 1) return nok(code)
        effects.consume(code)
        size++
        return more
      }
      if (size < 2 && !single) return nok(code)
      const token = effects.exit('strikethroughSequenceTemporary')
      const after = classifyCharacter(code)
      token._open = !after || (after === 2 && Boolean(before))
      token._close = !before || (before === 2 && Boolean(after))
      return ok(code)
    }
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-extension-gfm-table/lib/edit-map.js
/**
 * @typedef {import('micromark-util-types').Event} Event
 */

// Port of `edit_map.rs` from `markdown-rs`.
// This should move to `markdown-js` later.

// Deal with several changes in events, batching them together.
//
// Preferably, changes should be kept to a minimum.
// Sometimes, it’s needed to change the list of events, because parsing can be
// messy, and it helps to expose a cleaner interface of events to the compiler
// and other users.
// It can also help to merge many adjacent similar events.
// And, in other cases, it’s needed to parse subcontent: pass some events
// through another tokenizer and inject the result.

/**
 * @typedef {[number, number, Array<Event>]} Change
 * @typedef {[number, number, number]} Jump
 */

/**
 * Tracks a bunch of edits.
 */
class EditMap {
  /**
   * Create a new edit map.
   */
  constructor() {
    /**
     * Record of changes.
     *
     * @type {Array<Change>}
     */
    this.map = []
  }

  /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {void}
   */
  add(index, remove, add) {
    addImpl(this, index, remove, add)
  }

  // To do: not used here.
  // /**
  //  * Create an edit: but insert `add` before existing additions.
  //  *
  //  * @param {number} index
  //  * @param {number} remove
  //  * @param {Array<Event>} add
  //  * @returns {void}
  //  */
  // addBefore(index, remove, add) {
  //   addImpl(this, index, remove, add, true)
  // }

  /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {void}
   */
  consume(events) {
    this.map.sort((a, b) => a[0] - b[0])

    /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */
    if (this.map.length === 0) {
      return
    }

    // To do: if links are added in events, like they are in `markdown-rs`,
    // this is needed.
    // // Calculate jumps: where items in the current list move to.
    // /** @type {Array<Jump>} */
    // const jumps = []
    // let index = 0
    // let addAcc = 0
    // let removeAcc = 0
    // while (index < this.map.length) {
    //   const [at, remove, add] = this.map[index]
    //   removeAcc += remove
    //   addAcc += add.length
    //   jumps.push([at, removeAcc, addAcc])
    //   index += 1
    // }
    //
    // . shiftLinks(events, jumps)

    let index = this.map.length
    /** @type {Array<Array<Event>>} */
    const vecs = []
    while (index > 0) {
      index -= 1
      vecs.push(events.slice(this.map[index][0] + this.map[index][1]))
      // eslint-disable-next-line unicorn/no-array-push-push
      vecs.push(this.map[index][2])

      // Truncate rest.
      events.length = this.map[index][0]
    }
    vecs.push([...events])
    events.length = 0
    let slice = vecs.pop()
    while (slice) {
      events.push(...slice)
      slice = vecs.pop()
    }

    // Truncate everything.
    this.map.length = 0
  }
}

/**
 * Create an edit.
 *
 * @param {EditMap} editMap
 * @param {number} at
 * @param {number} remove
 * @param {Array<Event>} add
 * @returns {void}
 */
function addImpl(editMap, at, remove, add) {
  let index = 0

  /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */
  if (remove === 0 && add.length === 0) {
    return
  }
  while (index < editMap.map.length) {
    if (editMap.map[index][0] === at) {
      editMap.map[index][1] += remove

      // To do: before not used.
      // if (before) {
      //   add.push(...editMap.map[index][2])
      //   editMap.map[index][2] = add
      // } else {
      editMap.map[index][2].push(...add)
      // }

      return
    }
    index += 1
  }
  editMap.map.push([at, remove, add])
}

// /**
//  * Shift `previous` and `next` links according to `jumps`.
//  *
//  * This fixes links in case there are events removed or added between them.
//  *
//  * @param {Array<Event>} events
//  * @param {Array<Jump>} jumps
//  */
// function shiftLinks(events, jumps) {
//   let jumpIndex = 0
//   let index = 0
//   let add = 0
//   let rm = 0

//   while (index < events.length) {
//     const rmCurr = rm

//     while (jumpIndex < jumps.length && jumps[jumpIndex][0] <= index) {
//       add = jumps[jumpIndex][2]
//       rm = jumps[jumpIndex][1]
//       jumpIndex += 1
//     }

//     // Ignore items that will be removed.
//     if (rm > rmCurr) {
//       index += rm - rmCurr
//     } else {
//       console.log('to do: links?', add, rmCurr)
//       // ?
//       // if let Some(link) = &events[index].link {
//       //     if let Some(next) = link.next {
//       //         events[next].link.as_mut().unwrap().previous = Some(index + add - rm);
//       //         while jumpIndex < jumps.len() && jumps[jumpIndex].0 <= next {
//       //             add = jumps[jumpIndex].2;
//       //             rm = jumps[jumpIndex].1;
//       //             jumpIndex += 1;
//       //         }
//       //         events[index].link.as_mut().unwrap().next = Some(next + add - rm);
//       //         index = next;
//       //         continue;
//       //     }
//       // }
//       index += 1
//     }
//   }
// }

;// CONCATENATED MODULE: ../node_modules/micromark-extension-gfm-table/lib/infer.js
/**
 * @typedef {import('micromark-util-types').Event} Event
 */

/**
 * @typedef {'left' | 'center' | 'right' | 'none'} Align
 */

/**
 * Figure out the alignment of a GFM table.
 *
 * @param {Array<Event>} events
 * @param {number} index
 * @returns {Array<Align>}
 */
function gfmTableAlign(events, index) {
  let inDelimiterRow = false
  /** @type {Array<Align>} */
  const align = []
  while (index < events.length) {
    const event = events[index]
    if (inDelimiterRow) {
      if (event[0] === 'enter') {
        // Start of alignment value: set a new column.
        // To do: `markdown-rs` uses `tableDelimiterCellValue`.
        if (event[1].type === 'tableContent') {
          align.push(
            events[index + 1][1].type === 'tableDelimiterMarker'
              ? 'left'
              : 'none'
          )
        }
      }
      // Exits:
      // End of alignment value: change the column.
      // To do: `markdown-rs` uses `tableDelimiterCellValue`.
      else if (event[1].type === 'tableContent') {
        if (events[index - 1][1].type === 'tableDelimiterMarker') {
          const alignIndex = align.length - 1
          align[alignIndex] = align[alignIndex] === 'left' ? 'center' : 'right'
        }
      }
      // Done!
      else if (event[1].type === 'tableDelimiterRow') {
        break
      }
    } else if (event[0] === 'enter' && event[1].type === 'tableDelimiterRow') {
      inDelimiterRow = true
    }
    index += 1
  }
  return align
}

;// CONCATENATED MODULE: ../node_modules/micromark-extension-gfm-table/lib/syntax.js
/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */

/**
 * @typedef {[number, number, number, number]} Range
 *   Cell info.
 *
 * @typedef {0 | 1 | 2 | 3} RowKind
 *   Where we are: `1` for head row, `2` for delimiter row, `3` for body row.
 */






// To do: next major: expose functions.

/**
 * Extension for `micromark` that can be passed in `extensions` to enable GFM
 * table syntax.
 *
 * @type {Extension}
 */
const gfmTable = {
  flow: {
    null: {
      tokenize: tokenizeTable,
      resolveAll: resolveTable
    }
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeTable(effects, ok, nok) {
  const self = this
  let size = 0
  let sizeB = 0
  /** @type {boolean | undefined} */
  let seen
  return start

  /**
   * Start of a GFM table.
   *
   * If there is a valid table row or table head before, then we try to parse
   * another row.
   * Otherwise, we try to parse a head.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   * > | | b |
   *     ^
   * ```
   * @type {State}
   */
  function start(code) {
    let index = self.events.length - 1
    while (index > -1) {
      const type = self.events[index][1].type
      if (
        type === 'lineEnding' ||
        // Note: markdown-rs uses `whitespace` instead of `linePrefix`
        type === 'linePrefix'
      )
        index--
      else break
    }
    const tail = index > -1 ? self.events[index][1].type : null
    const next =
      tail === 'tableHead' || tail === 'tableRow' ? bodyRowStart : headRowBefore

    // Don’t allow lazy body rows.
    if (next === bodyRowStart && self.parser.lazy[self.now().line]) {
      return nok(code)
    }
    return next(code)
  }

  /**
   * Before table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */
  function headRowBefore(code) {
    effects.enter('tableHead')
    effects.enter('tableRow')
    return headRowStart(code)
  }

  /**
   * Before table head row, after whitespace.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */
  function headRowStart(code) {
    if (code === 124) {
      return headRowBreak(code)
    }

    // To do: micromark-js should let us parse our own whitespace in extensions,
    // like `markdown-rs`:
    //
    // ```js
    // // 4+ spaces.
    // if (markdownSpace(code)) {
    //   return nok(code)
    // }
    // ```

    seen = true
    // Count the first character, that isn’t a pipe, double.
    sizeB += 1
    return headRowBreak(code)
  }

  /**
   * At break in table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *       ^
   *         ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */
  function headRowBreak(code) {
    if (code === null) {
      // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
      return nok(code)
    }
    if (markdownLineEnding(code)) {
      // If anything other than one pipe (ignoring whitespace) was used, it’s fine.
      if (sizeB > 1) {
        sizeB = 0
        // To do: check if this works.
        // Feel free to interrupt:
        self.interrupt = true
        effects.exit('tableRow')
        effects.enter('lineEnding')
        effects.consume(code)
        effects.exit('lineEnding')
        return headDelimiterStart
      }

      // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
      return nok(code)
    }
    if (markdownSpace(code)) {
      // To do: check if this is fine.
      // effects.attempt(State::Next(StateName::GfmTableHeadRowBreak), State::Nok)
      // State::Retry(space_or_tab(tokenizer))
      return factorySpace(effects, headRowBreak, 'whitespace')(code)
    }
    sizeB += 1
    if (seen) {
      seen = false
      // Header cell count.
      size += 1
    }
    if (code === 124) {
      effects.enter('tableCellDivider')
      effects.consume(code)
      effects.exit('tableCellDivider')
      // Whether a delimiter was seen.
      seen = true
      return headRowBreak
    }

    // Anything else is cell data.
    effects.enter('data')
    return headRowData(code)
  }

  /**
   * In table head row data.
   *
   * ```markdown
   * > | | a |
   *       ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */
  function headRowData(code) {
    if (code === null || code === 124 || markdownLineEndingOrSpace(code)) {
      effects.exit('data')
      return headRowBreak(code)
    }
    effects.consume(code)
    return code === 92 ? headRowEscape : headRowData
  }

  /**
   * In table head row escape.
   *
   * ```markdown
   * > | | a\-b |
   *         ^
   *   | | ---- |
   *   | | c    |
   * ```
   *
   * @type {State}
   */
  function headRowEscape(code) {
    if (code === 92 || code === 124) {
      effects.consume(code)
      return headRowData
    }
    return headRowData(code)
  }

  /**
   * Before delimiter row.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */
  function headDelimiterStart(code) {
    // Reset `interrupt`.
    self.interrupt = false

    // Note: in `markdown-rs`, we need to handle piercing here too.
    if (self.parser.lazy[self.now().line]) {
      return nok(code)
    }
    effects.enter('tableDelimiterRow')
    // Track if we’ve seen a `:` or `|`.
    seen = false
    if (markdownSpace(code)) {
      return factorySpace(
        effects,
        headDelimiterBefore,
        'linePrefix',
        self.parser.constructs.disable.null.includes('codeIndented')
          ? undefined
          : 4
      )(code)
    }
    return headDelimiterBefore(code)
  }

  /**
   * Before delimiter row, after optional whitespace.
   *
   * Reused when a `|` is found later, to parse another cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */
  function headDelimiterBefore(code) {
    if (code === 45 || code === 58) {
      return headDelimiterValueBefore(code)
    }
    if (code === 124) {
      seen = true
      // If we start with a pipe, we open a cell marker.
      effects.enter('tableCellDivider')
      effects.consume(code)
      effects.exit('tableCellDivider')
      return headDelimiterCellBefore
    }

    // More whitespace / empty row not allowed at start.
    return headDelimiterNok(code)
  }

  /**
   * After `|`, before delimiter cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *      ^
   * ```
   *
   * @type {State}
   */
  function headDelimiterCellBefore(code) {
    if (markdownSpace(code)) {
      return factorySpace(effects, headDelimiterValueBefore, 'whitespace')(code)
    }
    return headDelimiterValueBefore(code)
  }

  /**
   * Before delimiter cell value.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */
  function headDelimiterValueBefore(code) {
    // Align: left.
    if (code === 58) {
      sizeB += 1
      seen = true
      effects.enter('tableDelimiterMarker')
      effects.consume(code)
      effects.exit('tableDelimiterMarker')
      return headDelimiterLeftAlignmentAfter
    }

    // Align: none.
    if (code === 45) {
      sizeB += 1
      // To do: seems weird that this *isn’t* left aligned, but that state is used?
      return headDelimiterLeftAlignmentAfter(code)
    }
    if (code === null || markdownLineEnding(code)) {
      return headDelimiterCellAfter(code)
    }
    return headDelimiterNok(code)
  }

  /**
   * After delimiter cell left alignment marker.
   *
   * ```markdown
   *   | | a  |
   * > | | :- |
   *        ^
   * ```
   *
   * @type {State}
   */
  function headDelimiterLeftAlignmentAfter(code) {
    if (code === 45) {
      effects.enter('tableDelimiterFiller')
      return headDelimiterFiller(code)
    }

    // Anything else is not ok after the left-align colon.
    return headDelimiterNok(code)
  }

  /**
   * In delimiter cell filler.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */
  function headDelimiterFiller(code) {
    if (code === 45) {
      effects.consume(code)
      return headDelimiterFiller
    }

    // Align is `center` if it was `left`, `right` otherwise.
    if (code === 58) {
      seen = true
      effects.exit('tableDelimiterFiller')
      effects.enter('tableDelimiterMarker')
      effects.consume(code)
      effects.exit('tableDelimiterMarker')
      return headDelimiterRightAlignmentAfter
    }
    effects.exit('tableDelimiterFiller')
    return headDelimiterRightAlignmentAfter(code)
  }

  /**
   * After delimiter cell right alignment marker.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *         ^
   * ```
   *
   * @type {State}
   */
  function headDelimiterRightAlignmentAfter(code) {
    if (markdownSpace(code)) {
      return factorySpace(effects, headDelimiterCellAfter, 'whitespace')(code)
    }
    return headDelimiterCellAfter(code)
  }

  /**
   * After delimiter cell.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *          ^
   * ```
   *
   * @type {State}
   */
  function headDelimiterCellAfter(code) {
    if (code === 124) {
      return headDelimiterBefore(code)
    }
    if (code === null || markdownLineEnding(code)) {
      // Exit when:
      // * there was no `:` or `|` at all (it’s a thematic break or setext
      //   underline instead)
      // * the header cell count is not the delimiter cell count
      if (!seen || size !== sizeB) {
        return headDelimiterNok(code)
      }

      // Note: in markdown-rs`, a reset is needed here.
      effects.exit('tableDelimiterRow')
      effects.exit('tableHead')
      // To do: in `markdown-rs`, resolvers need to be registered manually.
      // effects.register_resolver(ResolveName::GfmTable)
      return ok(code)
    }
    return headDelimiterNok(code)
  }

  /**
   * In delimiter row, at a disallowed byte.
   *
   * ```markdown
   *   | | a |
   * > | | x |
   *       ^
   * ```
   *
   * @type {State}
   */
  function headDelimiterNok(code) {
    // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
    return nok(code)
  }

  /**
   * Before table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   * ```
   *
   * @type {State}
   */
  function bodyRowStart(code) {
    // Note: in `markdown-rs` we need to manually take care of a prefix,
    // but in `micromark-js` that is done for us, so if we’re here, we’re
    // never at whitespace.
    effects.enter('tableRow')
    return bodyRowBreak(code)
  }

  /**
   * At break in table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   *       ^
   *         ^
   * ```
   *
   * @type {State}
   */
  function bodyRowBreak(code) {
    if (code === 124) {
      effects.enter('tableCellDivider')
      effects.consume(code)
      effects.exit('tableCellDivider')
      return bodyRowBreak
    }
    if (code === null || markdownLineEnding(code)) {
      effects.exit('tableRow')
      return ok(code)
    }
    if (markdownSpace(code)) {
      return factorySpace(effects, bodyRowBreak, 'whitespace')(code)
    }

    // Anything else is cell content.
    effects.enter('data')
    return bodyRowData(code)
  }

  /**
   * In table body row data.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *       ^
   * ```
   *
   * @type {State}
   */
  function bodyRowData(code) {
    if (code === null || code === 124 || markdownLineEndingOrSpace(code)) {
      effects.exit('data')
      return bodyRowBreak(code)
    }
    effects.consume(code)
    return code === 92 ? bodyRowEscape : bodyRowData
  }

  /**
   * In table body row escape.
   *
   * ```markdown
   *   | | a    |
   *   | | ---- |
   * > | | b\-c |
   *         ^
   * ```
   *
   * @type {State}
   */
  function bodyRowEscape(code) {
    if (code === 92 || code === 124) {
      effects.consume(code)
      return bodyRowData
    }
    return bodyRowData(code)
  }
}

/** @type {Resolver} */
// eslint-disable-next-line complexity
function resolveTable(events, context) {
  let index = -1
  let inFirstCellAwaitingPipe = true
  /** @type {RowKind} */
  let rowKind = 0
  /** @type {Range} */
  let lastCell = [0, 0, 0, 0]
  /** @type {Range} */
  let cell = [0, 0, 0, 0]
  let afterHeadAwaitingFirstBodyRow = false
  let lastTableEnd = 0
  /** @type {Token | undefined} */
  let currentTable
  /** @type {Token | undefined} */
  let currentBody
  /** @type {Token | undefined} */
  let currentCell
  const map = new EditMap()
  while (++index < events.length) {
    const event = events[index]
    const token = event[1]
    if (event[0] === 'enter') {
      // Start of head.
      if (token.type === 'tableHead') {
        afterHeadAwaitingFirstBodyRow = false

        // Inject previous (body end and) table end.
        if (lastTableEnd !== 0) {
          flushTableEnd(map, context, lastTableEnd, currentTable, currentBody)
          currentBody = undefined
          lastTableEnd = 0
        }

        // Inject table start.
        currentTable = {
          type: 'table',
          start: Object.assign({}, token.start),
          // Note: correct end is set later.
          end: Object.assign({}, token.end)
        }
        map.add(index, 0, [['enter', currentTable, context]])
      } else if (
        token.type === 'tableRow' ||
        token.type === 'tableDelimiterRow'
      ) {
        inFirstCellAwaitingPipe = true
        currentCell = undefined
        lastCell = [0, 0, 0, 0]
        cell = [0, index + 1, 0, 0]

        // Inject table body start.
        if (afterHeadAwaitingFirstBodyRow) {
          afterHeadAwaitingFirstBodyRow = false
          currentBody = {
            type: 'tableBody',
            start: Object.assign({}, token.start),
            // Note: correct end is set later.
            end: Object.assign({}, token.end)
          }
          map.add(index, 0, [['enter', currentBody, context]])
        }
        rowKind = token.type === 'tableDelimiterRow' ? 2 : currentBody ? 3 : 1
      }
      // Cell data.
      else if (
        rowKind &&
        (token.type === 'data' ||
          token.type === 'tableDelimiterMarker' ||
          token.type === 'tableDelimiterFiller')
      ) {
        inFirstCellAwaitingPipe = false

        // First value in cell.
        if (cell[2] === 0) {
          if (lastCell[1] !== 0) {
            cell[0] = cell[1]
            currentCell = flushCell(
              map,
              context,
              lastCell,
              rowKind,
              undefined,
              currentCell
            )
            lastCell = [0, 0, 0, 0]
          }
          cell[2] = index
        }
      } else if (token.type === 'tableCellDivider') {
        if (inFirstCellAwaitingPipe) {
          inFirstCellAwaitingPipe = false
        } else {
          if (lastCell[1] !== 0) {
            cell[0] = cell[1]
            currentCell = flushCell(
              map,
              context,
              lastCell,
              rowKind,
              undefined,
              currentCell
            )
          }
          lastCell = cell
          cell = [lastCell[1], index, 0, 0]
        }
      }
    }
    // Exit events.
    else if (token.type === 'tableHead') {
      afterHeadAwaitingFirstBodyRow = true
      lastTableEnd = index
    } else if (
      token.type === 'tableRow' ||
      token.type === 'tableDelimiterRow'
    ) {
      lastTableEnd = index
      if (lastCell[1] !== 0) {
        cell[0] = cell[1]
        currentCell = flushCell(
          map,
          context,
          lastCell,
          rowKind,
          index,
          currentCell
        )
      } else if (cell[1] !== 0) {
        currentCell = flushCell(map, context, cell, rowKind, index, currentCell)
      }
      rowKind = 0
    } else if (
      rowKind &&
      (token.type === 'data' ||
        token.type === 'tableDelimiterMarker' ||
        token.type === 'tableDelimiterFiller')
    ) {
      cell[3] = index
    }
  }
  if (lastTableEnd !== 0) {
    flushTableEnd(map, context, lastTableEnd, currentTable, currentBody)
  }
  map.consume(context.events)

  // To do: move this into `html`, when events are exposed there.
  // That’s what `markdown-rs` does.
  // That needs updates to `mdast-util-gfm-table`.
  index = -1
  while (++index < context.events.length) {
    const event = context.events[index]
    if (event[0] === 'enter' && event[1].type === 'table') {
      event[1]._align = gfmTableAlign(context.events, index)
    }
  }
  return events
}

/// Generate a cell.
/**
 *
 * @param {EditMap} map
 * @param {TokenizeContext} context
 * @param {Range} range
 * @param {RowKind} rowKind
 * @param {number | undefined} rowEnd
 * @param {Token | undefined} previousCell
 * @returns {Token | undefined}
 */
// eslint-disable-next-line max-params
function flushCell(map, context, range, rowKind, rowEnd, previousCell) {
  // `markdown-rs` uses:
  // rowKind === 2 ? 'tableDelimiterCell' : 'tableCell'
  const groupName =
    rowKind === 1
      ? 'tableHeader'
      : rowKind === 2
      ? 'tableDelimiter'
      : 'tableData'
  // `markdown-rs` uses:
  // rowKind === 2 ? 'tableDelimiterCellValue' : 'tableCellText'
  const valueName = 'tableContent'

  // Insert an exit for the previous cell, if there is one.
  //
  // ```markdown
  // > | | aa | bb | cc |
  //          ^-- exit
  //           ^^^^-- this cell
  // ```
  if (range[0] !== 0) {
    previousCell.end = Object.assign({}, getPoint(context.events, range[0]))
    map.add(range[0], 0, [['exit', previousCell, context]])
  }

  // Insert enter of this cell.
  //
  // ```markdown
  // > | | aa | bb | cc |
  //           ^-- enter
  //           ^^^^-- this cell
  // ```
  const now = getPoint(context.events, range[1])
  previousCell = {
    type: groupName,
    start: Object.assign({}, now),
    // Note: correct end is set later.
    end: Object.assign({}, now)
  }
  map.add(range[1], 0, [['enter', previousCell, context]])

  // Insert text start at first data start and end at last data end, and
  // remove events between.
  //
  // ```markdown
  // > | | aa | bb | cc |
  //            ^-- enter
  //             ^-- exit
  //           ^^^^-- this cell
  // ```
  if (range[2] !== 0) {
    const relatedStart = getPoint(context.events, range[2])
    const relatedEnd = getPoint(context.events, range[3])
    /** @type {Token} */
    const valueToken = {
      type: valueName,
      start: Object.assign({}, relatedStart),
      end: Object.assign({}, relatedEnd)
    }
    map.add(range[2], 0, [['enter', valueToken, context]])
    if (rowKind !== 2) {
      // Fix positional info on remaining events
      const start = context.events[range[2]]
      const end = context.events[range[3]]
      start[1].end = Object.assign({}, end[1].end)
      start[1].type = 'chunkText'
      start[1].contentType = 'text'

      // Remove if needed.
      if (range[3] > range[2] + 1) {
        const a = range[2] + 1
        const b = range[3] - range[2] - 1
        map.add(a, b, [])
      }
    }
    map.add(range[3] + 1, 0, [['exit', valueToken, context]])
  }

  // Insert an exit for the last cell, if at the row end.
  //
  // ```markdown
  // > | | aa | bb | cc |
  //                    ^-- exit
  //               ^^^^^^-- this cell (the last one contains two “between” parts)
  // ```
  if (rowEnd !== undefined) {
    previousCell.end = Object.assign({}, getPoint(context.events, rowEnd))
    map.add(rowEnd, 0, [['exit', previousCell, context]])
    previousCell = undefined
  }
  return previousCell
}

/**
 * Generate table end (and table body end).
 *
 * @param {EditMap} map
 * @param {TokenizeContext} context
 * @param {number} index
 * @param {Token} table
 * @param {Token | undefined} tableBody
 */
// eslint-disable-next-line max-params
function flushTableEnd(map, context, index, table, tableBody) {
  /** @type {Array<Event>} */
  const exits = []
  const related = getPoint(context.events, index)
  if (tableBody) {
    tableBody.end = Object.assign({}, related)
    exits.push(['exit', tableBody, context])
  }
  table.end = Object.assign({}, related)
  exits.push(['exit', table, context])
  map.add(index + 1, 0, exits)
}

/**
 * @param {Array<Event>} events
 * @param {number} index
 * @returns {readonly Point}
 */
function getPoint(events, index) {
  const event = events[index]
  const side = event[0] === 'enter' ? 'start' : 'end'
  return event[1][side]
}

;// CONCATENATED MODULE: ../node_modules/micromark-extension-gfm-task-list-item/lib/syntax.js
/**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */



const tasklistCheck = {
  tokenize: tokenizeTasklistCheck
}

// To do: next major: expose function to make extension.

/**
 * Extension for `micromark` that can be passed in `extensions`, to
 * enable GFM task list items syntax.
 *
 * @type {Extension}
 */
const gfmTaskListItem = {
  text: {
    [91]: tasklistCheck
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function tokenizeTasklistCheck(effects, ok, nok) {
  const self = this
  return open

  /**
   * At start of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *       ^
   * ```
   *
   * @type {State}
   */
  function open(code) {
    if (
      // Exit if there’s stuff before.
      self.previous !== null ||
      // Exit if not in the first content that is the first child of a list
      // item.
      !self._gfmTasklistFirstContentOfListItem
    ) {
      return nok(code)
    }
    effects.enter('taskListCheck')
    effects.enter('taskListCheckMarker')
    effects.consume(code)
    effects.exit('taskListCheckMarker')
    return inside
  }

  /**
   * In task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *        ^
   * ```
   *
   * @type {State}
   */
  function inside(code) {
    // Currently we match how GH works in files.
    // To match how GH works in comments, use `markdownSpace` (`[\t ]`) instead
    // of `markdownLineEndingOrSpace` (`[\t\n\r ]`).
    if (markdownLineEndingOrSpace(code)) {
      effects.enter('taskListCheckValueUnchecked')
      effects.consume(code)
      effects.exit('taskListCheckValueUnchecked')
      return close
    }
    if (code === 88 || code === 120) {
      effects.enter('taskListCheckValueChecked')
      effects.consume(code)
      effects.exit('taskListCheckValueChecked')
      return close
    }
    return nok(code)
  }

  /**
   * At close of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *         ^
   * ```
   *
   * @type {State}
   */
  function close(code) {
    if (code === 93) {
      effects.enter('taskListCheckMarker')
      effects.consume(code)
      effects.exit('taskListCheckMarker')
      effects.exit('taskListCheck')
      return after
    }
    return nok(code)
  }

  /**
   * @type {State}
   */
  function after(code) {
    // EOL in paragraph means there must be something else after it.
    if (markdownLineEnding(code)) {
      return ok(code)
    }

    // Space or tab?
    // Check what comes after.
    if (markdownSpace(code)) {
      return effects.check(
        {
          tokenize: spaceThenNonSpace
        },
        ok,
        nok
      )(code)
    }

    // EOF, or non-whitespace, both wrong.
    return nok(code)
  }
}

/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */
function spaceThenNonSpace(effects, ok, nok) {
  return factorySpace(effects, after, 'whitespace')

  /**
   * After whitespace, after task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *           ^
   * ```
   *
   * @type {State}
   */
  function after(code) {
    // EOF means there was nothing, so bad.
    // EOL means there’s content after it, so good.
    // Impossible to have more spaces.
    // Anything else is good.
    return code === null ? nok(code) : ok(code)
  }
}

;// CONCATENATED MODULE: ../node_modules/micromark-extension-gfm/index.js
/**
 * @typedef {import('micromark-extension-gfm-footnote').HtmlOptions} HtmlOptions
 * @typedef {import('micromark-extension-gfm-strikethrough').Options} Options
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */









/**
 * Create an extension for `micromark` to enable GFM syntax.
 *
 * @param {Options | null | undefined} [options]
 *   Configuration (optional).
 *
 *   Passed to `micromark-extens-gfm-strikethrough`.
 * @returns {Extension}
 *   Extension for `micromark` that can be passed in `extensions` to enable GFM
 *   syntax.
 */
function gfm(options) {
  return combineExtensions([
    gfmAutolinkLiteral,
    gfmFootnote(),
    gfmStrikethrough(options),
    gfmTable,
    gfmTaskListItem
  ])
}

/**
 * Create an extension for `micromark` to support GFM when serializing to HTML.
 *
 * @param {HtmlOptions | null | undefined} [options]
 *   Configuration.
 *
 *   Passed to `micromark-extens-gfm-footnote`.
 * @returns {HtmlExtension}
 *   Extension for `micromark` that can be passed in `htmlExtensions` to
 *   support GFM when serializing to HTML.
 */
function gfmHtml(options) {
  return combineHtmlExtensions([
    gfmAutolinkLiteralHtml,
    gfmFootnoteHtml(options),
    gfmStrikethroughHtml,
    gfmTableHtml,
    gfmTagfilterHtml,
    gfmTaskListItemHtml
  ])
}

;// CONCATENATED MODULE: ../node_modules/ccount/index.js
/**
 * Count how often a character (or substring) is used in a string.
 *
 * @param {string} value
 *   Value to search in.
 * @param {string} character
 *   Character (or substring) to look for.
 * @return {number}
 *   Number of times `character` occurred in `value`.
 */
function ccount(value, character) {
  const source = String(value)

  if (typeof character !== 'string') {
    throw new TypeError('Expected character')
  }

  let count = 0
  let index = source.indexOf(character)

  while (index !== -1) {
    count++
    index = source.indexOf(character, index + character.length)
  }

  return count
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-find-and-replace/node_modules/escape-string-regexp/index.js
function escapeStringRegexp(string) {
	if (typeof string !== 'string') {
		throw new TypeError('Expected a string');
	}

	// Escape characters with special meaning either inside or outside character sets.
	// Use a simple backslash escape when it’s always valid, and a `\xnn` escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
	return string
		.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&')
		.replace(/-/g, '\\x2d');
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-find-and-replace/lib/index.js
/**
 * @typedef {import('mdast').Parent} MdastParent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 * @typedef {import('mdast').Text} Text
 * @typedef {import('unist-util-visit-parents').Test} Test
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */

/**
 * @typedef {Content | Root} Node
 * @typedef {Extract<Node, MdastParent>} Parent
 * @typedef {Exclude<Parent, Root>} ContentParent
 *
 * @typedef RegExpMatchObject
 *   Info on the match.
 * @property {number} index
 *   The index of the search at which the result was found.
 * @property {string} input
 *   A copy of the search string in the text node.
 * @property {[Root, ...Array<ContentParent>, Text]} stack
 *   All ancestors of the text node, where the last node is the text itself.
 *
 * @callback ReplaceFunction
 *   Callback called when a search matches.
 * @param {...any} parameters
 *   The parameters are the result of corresponding search expression:
 *
 *   * `value` (`string`) — whole match
 *   * `...capture` (`Array<string>`) — matches from regex capture groups
 *   * `match` (`RegExpMatchObject`) — info on the match
 * @returns {Array<PhrasingContent> | PhrasingContent | string | false | undefined | null}
 *   Thing to replace with.
 *
 *   * when `null`, `undefined`, `''`, remove the match
 *   * …or when `false`, do not replace at all
 *   * …or when `string`, replace with a text node of that value
 *   * …or when `Node` or `Array<Node>`, replace with those nodes
 *
 * @typedef {string | RegExp} Find
 *   Pattern to find.
 *
 *   Strings are escaped and then turned into global expressions.
 *
 * @typedef {Array<FindAndReplaceTuple>} FindAndReplaceList
 *   Several find and replaces, in array form.
 * @typedef {Record<string, Replace>} FindAndReplaceSchema
 *   Several find and replaces, in object form.
 * @typedef {[Find, Replace]} FindAndReplaceTuple
 *   Find and replace in tuple form.
 * @typedef {string | ReplaceFunction} Replace
 *   Thing to replace with.
 * @typedef {[RegExp, ReplaceFunction]} Pair
 *   Normalized find and replace.
 * @typedef {Array<Pair>} Pairs
 *   All find and replaced.
 *
 * @typedef Options
 *   Configuration.
 * @property {Test | null | undefined} [ignore]
 *   Test for which nodes to ignore.
 */





const mdast_util_find_and_replace_lib_own = {}.hasOwnProperty

/**
 * Find patterns in a tree and replace them.
 *
 * The algorithm searches the tree in *preorder* for complete values in `Text`
 * nodes.
 * Partial matches are not supported.
 *
 * @param tree
 *   Tree to change.
 * @param find
 *   Patterns to find.
 * @param replace
 *   Things to replace with (when `find` is `Find`) or configuration.
 * @param options
 *   Configuration (when `find` is not `Find`).
 * @returns
 *   Given, modified, tree.
 */
// To do: next major: remove `find` & `replace` combo, remove schema.
const findAndReplace =
  /**
   * @type {(
   *   (<Tree extends Node>(tree: Tree, find: Find, replace?: Replace | null | undefined, options?: Options | null | undefined) => Tree) &
   *   (<Tree extends Node>(tree: Tree, schema: FindAndReplaceSchema | FindAndReplaceList, options?: Options | null | undefined) => Tree)
   * )}
   **/
  (
    /**
     * @template {Node} Tree
     * @param {Tree} tree
     * @param {Find | FindAndReplaceSchema | FindAndReplaceList} find
     * @param {Replace | Options | null | undefined} [replace]
     * @param {Options | null | undefined} [options]
     * @returns {Tree}
     */
    function (tree, find, replace, options) {
      /** @type {Options | null | undefined} */
      let settings
      /** @type {FindAndReplaceSchema|FindAndReplaceList} */
      let schema

      if (typeof find === 'string' || find instanceof RegExp) {
        // @ts-expect-error don’t expect options twice.
        schema = [[find, replace]]
        settings = options
      } else {
        schema = find
        // @ts-expect-error don’t expect replace twice.
        settings = replace
      }

      if (!settings) {
        settings = {}
      }

      const ignored = convert(settings.ignore || [])
      const pairs = toPairs(schema)
      let pairIndex = -1

      while (++pairIndex < pairs.length) {
        visitParents(tree, 'text', visitor)
      }

      // To do next major: don’t return the given tree.
      return tree

      /** @type {import('unist-util-visit-parents/complex-types.js').BuildVisitor<Root, 'text'>} */
      function visitor(node, parents) {
        let index = -1
        /** @type {Parent | undefined} */
        let grandparent

        while (++index < parents.length) {
          const parent = parents[index]

          if (
            ignored(
              parent,
              // @ts-expect-error: TS doesn’t understand but it’s perfect.
              grandparent ? grandparent.children.indexOf(parent) : undefined,
              grandparent
            )
          ) {
            return
          }

          grandparent = parent
        }

        if (grandparent) {
          return handler(node, parents)
        }
      }

      /**
       * Handle a text node which is not in an ignored parent.
       *
       * @param {Text} node
       *   Text node.
       * @param {Array<Parent>} parents
       *   Parents.
       * @returns {VisitorResult}
       *   Result.
       */
      function handler(node, parents) {
        const parent = parents[parents.length - 1]
        const find = pairs[pairIndex][0]
        const replace = pairs[pairIndex][1]
        let start = 0
        // @ts-expect-error: TS is wrong, some of these children can be text.
        const index = parent.children.indexOf(node)
        let change = false
        /** @type {Array<PhrasingContent>} */
        let nodes = []

        find.lastIndex = 0

        let match = find.exec(node.value)

        while (match) {
          const position = match.index
          /** @type {RegExpMatchObject} */
          const matchObject = {
            index: match.index,
            input: match.input,
            // @ts-expect-error: stack is fine.
            stack: [...parents, node]
          }
          let value = replace(...match, matchObject)

          if (typeof value === 'string') {
            value = value.length > 0 ? {type: 'text', value} : undefined
          }

          // It wasn’t a match after all.
          if (value !== false) {
            if (start !== position) {
              nodes.push({
                type: 'text',
                value: node.value.slice(start, position)
              })
            }

            if (Array.isArray(value)) {
              nodes.push(...value)
            } else if (value) {
              nodes.push(value)
            }

            start = position + match[0].length
            change = true
          }

          if (!find.global) {
            break
          }

          match = find.exec(node.value)
        }

        if (change) {
          if (start < node.value.length) {
            nodes.push({type: 'text', value: node.value.slice(start)})
          }

          parent.children.splice(index, 1, ...nodes)
        } else {
          nodes = [node]
        }

        return index + nodes.length
      }
    }
  )

/**
 * Turn a schema into pairs.
 *
 * @param {FindAndReplaceSchema | FindAndReplaceList} schema
 *   Schema.
 * @returns {Pairs}
 *   Clean pairs.
 */
function toPairs(schema) {
  /** @type {Pairs} */
  const result = []

  if (typeof schema !== 'object') {
    throw new TypeError('Expected array or object as schema')
  }

  if (Array.isArray(schema)) {
    let index = -1

    while (++index < schema.length) {
      result.push([
        toExpression(schema[index][0]),
        toFunction(schema[index][1])
      ])
    }
  } else {
    /** @type {string} */
    let key

    for (key in schema) {
      if (mdast_util_find_and_replace_lib_own.call(schema, key)) {
        result.push([toExpression(key), toFunction(schema[key])])
      }
    }
  }

  return result
}

/**
 * Turn a find into an expression.
 *
 * @param {Find} find
 *   Find.
 * @returns {RegExp}
 *   Expression.
 */
function toExpression(find) {
  return typeof find === 'string' ? new RegExp(escapeStringRegexp(find), 'g') : find
}

/**
 * Turn a replace into a function.
 *
 * @param {Replace} replace
 *   Replace.
 * @returns {ReplaceFunction}
 *   Function.
 */
function toFunction(replace) {
  return typeof replace === 'function' ? replace : () => replace
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-gfm-autolink-literal/lib/index.js
/**
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-from-markdown').Transform} FromMarkdownTransform
 *
 * @typedef {import('mdast-util-to-markdown').ConstructName} ConstructName
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 *
 * @typedef {import('mdast-util-find-and-replace').ReplaceFunction} ReplaceFunction
 * @typedef {import('mdast-util-find-and-replace').RegExpMatchObject} RegExpMatchObject
 */





/** @type {ConstructName} */
const inConstruct = 'phrasing'
/** @type {Array<ConstructName>} */
const notInConstruct = ['autolink', 'link', 'image', 'label']

// To do: next major: expose functions instead of extensions.

/**
 * Extension for `mdast-util-from-markdown` to enable GFM autolink literals.
 *
 * @type {FromMarkdownExtension}
 */
const gfmAutolinkLiteralFromMarkdown = {
  transforms: [transformGfmAutolinkLiterals],
  enter: {
    literalAutolink: enterLiteralAutolink,
    literalAutolinkEmail: enterLiteralAutolinkValue,
    literalAutolinkHttp: enterLiteralAutolinkValue,
    literalAutolinkWww: enterLiteralAutolinkValue
  },
  exit: {
    literalAutolink: exitLiteralAutolink,
    literalAutolinkEmail: exitLiteralAutolinkEmail,
    literalAutolinkHttp: exitLiteralAutolinkHttp,
    literalAutolinkWww: exitLiteralAutolinkWww
  }
}

/**
 * Extension for `mdast-util-to-markdown` to enable GFM autolink literals.
 *
 * @type {ToMarkdownExtension}
 */
const gfmAutolinkLiteralToMarkdown = {
  unsafe: [
    {
      character: '@',
      before: '[+\\-.\\w]',
      after: '[\\-.\\w]',
      inConstruct,
      notInConstruct
    },
    {
      character: '.',
      before: '[Ww]',
      after: '[\\-.\\w]',
      inConstruct,
      notInConstruct
    },
    {character: ':', before: '[ps]', after: '\\/', inConstruct, notInConstruct}
  ]
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function enterLiteralAutolink(token) {
  this.enter({type: 'link', title: null, url: '', children: []}, token)
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function enterLiteralAutolinkValue(token) {
  this.config.enter.autolinkProtocol.call(this, token)
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitLiteralAutolinkHttp(token) {
  this.config.exit.autolinkProtocol.call(this, token)
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitLiteralAutolinkWww(token) {
  this.config.exit.data.call(this, token)
  const node = /** @type {Link} */ (this.stack[this.stack.length - 1])
  node.url = 'http://' + this.sliceSerialize(token)
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitLiteralAutolinkEmail(token) {
  this.config.exit.autolinkEmail.call(this, token)
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitLiteralAutolink(token) {
  this.exit(token)
}

/** @type {FromMarkdownTransform} */
function transformGfmAutolinkLiterals(tree) {
  findAndReplace(
    tree,
    [
      [/(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi, findUrl],
      [/([-.\w+]+)@([-\w]+(?:\.[-\w]+)+)/g, findEmail]
    ],
    {ignore: ['link', 'linkReference']}
  )
}

/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} protocol
 * @param {string} domain
 * @param {string} path
 * @param {RegExpMatchObject} match
 * @returns {Link | Array<PhrasingContent> | false}
 */
// eslint-disable-next-line max-params
function findUrl(_, protocol, domain, path, match) {
  let prefix = ''

  // Not an expected previous character.
  if (!lib_previous(match)) {
    return false
  }

  // Treat `www` as part of the domain.
  if (/^w/i.test(protocol)) {
    domain = protocol + domain
    protocol = ''
    prefix = 'http://'
  }

  if (!isCorrectDomain(domain)) {
    return false
  }

  const parts = splitUrl(domain + path)

  if (!parts[0]) return false

  /** @type {Link} */
  const result = {
    type: 'link',
    title: null,
    url: prefix + protocol + parts[0],
    children: [{type: 'text', value: protocol + parts[0]}]
  }

  if (parts[1]) {
    return [result, {type: 'text', value: parts[1]}]
  }

  return result
}

/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} atext
 * @param {string} label
 * @param {RegExpMatchObject} match
 * @returns {Link | false}
 */
function findEmail(_, atext, label, match) {
  if (
    // Not an expected previous character.
    !lib_previous(match, true) ||
    // Label ends in not allowed character.
    /[-\d_]$/.test(label)
  ) {
    return false
  }

  return {
    type: 'link',
    title: null,
    url: 'mailto:' + atext + '@' + label,
    children: [{type: 'text', value: atext + '@' + label}]
  }
}

/**
 * @param {string} domain
 * @returns {boolean}
 */
function isCorrectDomain(domain) {
  const parts = domain.split('.')

  if (
    parts.length < 2 ||
    (parts[parts.length - 1] &&
      (/_/.test(parts[parts.length - 1]) ||
        !/[a-zA-Z\d]/.test(parts[parts.length - 1]))) ||
    (parts[parts.length - 2] &&
      (/_/.test(parts[parts.length - 2]) ||
        !/[a-zA-Z\d]/.test(parts[parts.length - 2])))
  ) {
    return false
  }

  return true
}

/**
 * @param {string} url
 * @returns {[string, string | undefined]}
 */
function splitUrl(url) {
  const trailExec = /[!"&'),.:;<>?\]}]+$/.exec(url)

  if (!trailExec) {
    return [url, undefined]
  }

  url = url.slice(0, trailExec.index)

  let trail = trailExec[0]
  let closingParenIndex = trail.indexOf(')')
  const openingParens = ccount(url, '(')
  let closingParens = ccount(url, ')')

  while (closingParenIndex !== -1 && openingParens > closingParens) {
    url += trail.slice(0, closingParenIndex + 1)
    trail = trail.slice(closingParenIndex + 1)
    closingParenIndex = trail.indexOf(')')
    closingParens++
  }

  return [url, trail]
}

/**
 * @param {RegExpMatchObject} match
 * @param {boolean | null | undefined} [email=false]
 * @returns {boolean}
 */
function lib_previous(match, email) {
  const code = match.input.charCodeAt(match.index - 1)

  return (
    (match.index === 0 ||
      unicodeWhitespace(code) ||
      unicodePunctuation(code)) &&
    (!email || code !== 47)
  )
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-markdown/lib/util/association.js
/**
 * @typedef {import('../types.js').AssociationId} AssociationId
 */



/**
 * Get an identifier from an association to match it to others.
 *
 * Associations are nodes that match to something else through an ID:
 * <https://github.com/syntax-tree/mdast#association>.
 *
 * The `label` of an association is the string value: character escapes and
 * references work, and casing is intact.
 * The `identifier` is used to match one association to another:
 * controversially, character escapes and references don’t work in this
 * matching: `&copy;` does not match `©`, and `\+` does not match `+`.
 *
 * But casing is ignored (and whitespace) is trimmed and collapsed: ` A\nb`
 * matches `a b`.
 * So, we do prefer the label when figuring out how we’re going to serialize:
 * it has whitespace, casing, and we can ignore most useless character
 * escapes and all character references.
 *
 * @type {AssociationId}
 */
function association(node) {
  if (node.label || !node.identifier) {
    return node.label || ''
  }

  return decodeString(node.identifier)
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-markdown/lib/util/container-flow.js
/**
 * @typedef {import('../types.js').FlowContent} FlowContent
 * @typedef {import('../types.js').Node} Node
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').TrackFields} TrackFields
 */

/**
 * @param {Parent & {children: Array<FlowContent>}} parent
 *   Parent of flow nodes.
 * @param {State} state
 *   Info passed around about the current state.
 * @param {TrackFields} info
 *   Info on where we are in the document we are generating.
 * @returns {string}
 *   Serialized children, joined by (blank) lines.
 */
function containerFlow(parent, state, info) {
  const indexStack = state.indexStack
  const children = parent.children || []
  const tracker = state.createTracker(info)
  /** @type {Array<string>} */
  const results = []
  let index = -1

  indexStack.push(-1)

  while (++index < children.length) {
    const child = children[index]

    indexStack[indexStack.length - 1] = index

    results.push(
      tracker.move(
        state.handle(child, parent, state, {
          before: '\n',
          after: '\n',
          ...tracker.current()
        })
      )
    )

    if (child.type !== 'list') {
      state.bulletLastUsed = undefined
    }

    if (index < children.length - 1) {
      results.push(
        tracker.move(between(child, children[index + 1], parent, state))
      )
    }
  }

  indexStack.pop()

  return results.join('')
}

/**
 * @param {Node} left
 * @param {Node} right
 * @param {Parent} parent
 * @param {State} state
 * @returns {string}
 */
function between(left, right, parent, state) {
  let index = state.join.length

  while (index--) {
    const result = state.join[index](left, right, parent, state)

    if (result === true || result === 1) {
      break
    }

    if (typeof result === 'number') {
      return '\n'.repeat(1 + result)
    }

    if (result === false) {
      return '\n\n<!---->\n\n'
    }
  }

  return '\n\n'
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-markdown/lib/util/indent-lines.js
/**
 * @typedef {import('../types.js').IndentLines} IndentLines
 */

const eol = /\r?\n|\r/g

/**
 * @type {IndentLines}
 */
function indentLines(value, map) {
  /** @type {Array<string>} */
  const result = []
  let start = 0
  let line = 0
  /** @type {RegExpExecArray | null} */
  let match

  while ((match = eol.exec(value))) {
    one(value.slice(start, match.index))
    result.push(match[0])
    start = match.index + match[0].length
    line++
  }

  one(value.slice(start))

  return result.join('')

  /**
   * @param {string} value
   */
  function one(value) {
    result.push(map(value, line, !value))
  }
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-markdown/lib/util/pattern-compile.js
/**
 * @typedef {import('../types.js').Unsafe} Unsafe
 */

/**
 * @param {Unsafe} pattern
 * @returns {RegExp}
 */
function patternCompile(pattern) {
  if (!pattern._compiled) {
    const before =
      (pattern.atBreak ? '[\\r\\n][\\t ]*' : '') +
      (pattern.before ? '(?:' + pattern.before + ')' : '')

    pattern._compiled = new RegExp(
      (before ? '(' + before + ')' : '') +
        (/[|\\{}()[\]^$+*?.-]/.test(pattern.character) ? '\\' : '') +
        pattern.character +
        (pattern.after ? '(?:' + pattern.after + ')' : ''),
      'g'
    )
  }

  return pattern._compiled
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-markdown/lib/util/pattern-in-scope.js
/**
 * @typedef {import('../types.js').Unsafe} Unsafe
 * @typedef {import('../types.js').ConstructName} ConstructName
 */

/**
 * @param {Array<ConstructName>} stack
 * @param {Unsafe} pattern
 * @returns {boolean}
 */
function patternInScope(stack, pattern) {
  return (
    listInScope(stack, pattern.inConstruct, true) &&
    !listInScope(stack, pattern.notInConstruct, false)
  )
}

/**
 * @param {Array<ConstructName>} stack
 * @param {Unsafe['inConstruct']} list
 * @param {boolean} none
 * @returns {boolean}
 */
function listInScope(stack, list, none) {
  if (typeof list === 'string') {
    list = [list]
  }

  if (!list || list.length === 0) {
    return none
  }

  let index = -1

  while (++index < list.length) {
    if (stack.includes(list[index])) {
      return true
    }
  }

  return false
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-markdown/lib/util/safe.js
/**
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').SafeConfig} SafeConfig
 */




/**
 * Make a string safe for embedding in markdown constructs.
 *
 * In markdown, almost all punctuation characters can, in certain cases,
 * result in something.
 * Whether they do is highly subjective to where they happen and in what
 * they happen.
 *
 * To solve this, `mdast-util-to-markdown` tracks:
 *
 * * Characters before and after something;
 * * What “constructs” we are in.
 *
 * This information is then used by this function to escape or encode
 * special characters.
 *
 * @param {State} state
 *   Info passed around about the current state.
 * @param {string | null | undefined} input
 *   Raw value to make safe.
 * @param {SafeConfig} config
 *   Configuration.
 * @returns {string}
 *   Serialized markdown safe for embedding.
 */
function safe(state, input, config) {
  const value = (config.before || '') + (input || '') + (config.after || '')
  /** @type {Array<number>} */
  const positions = []
  /** @type {Array<string>} */
  const result = []
  /** @type {Record<number, {before: boolean, after: boolean}>} */
  const infos = {}
  let index = -1

  while (++index < state.unsafe.length) {
    const pattern = state.unsafe[index]

    if (!patternInScope(state.stack, pattern)) {
      continue
    }

    const expression = patternCompile(pattern)
    /** @type {RegExpExecArray | null} */
    let match

    while ((match = expression.exec(value))) {
      const before = 'before' in pattern || Boolean(pattern.atBreak)
      const after = 'after' in pattern
      const position = match.index + (before ? match[1].length : 0)

      if (positions.includes(position)) {
        if (infos[position].before && !before) {
          infos[position].before = false
        }

        if (infos[position].after && !after) {
          infos[position].after = false
        }
      } else {
        positions.push(position)
        infos[position] = {before, after}
      }
    }
  }

  positions.sort(numerical)

  let start = config.before ? config.before.length : 0
  const end = value.length - (config.after ? config.after.length : 0)
  index = -1

  while (++index < positions.length) {
    const position = positions[index]

    // Character before or after matched:
    if (position < start || position >= end) {
      continue
    }

    // If this character is supposed to be escaped because it has a condition on
    // the next character, and the next character is definitly being escaped,
    // then skip this escape.
    if (
      (position + 1 < end &&
        positions[index + 1] === position + 1 &&
        infos[position].after &&
        !infos[position + 1].before &&
        !infos[position + 1].after) ||
      (positions[index - 1] === position - 1 &&
        infos[position].before &&
        !infos[position - 1].before &&
        !infos[position - 1].after)
    ) {
      continue
    }

    if (start !== position) {
      // If we have to use a character reference, an ampersand would be more
      // correct, but as backslashes only care about punctuation, either will
      // do the trick
      result.push(escapeBackslashes(value.slice(start, position), '\\'))
    }

    start = position

    if (
      /[!-/:-@[-`{-~]/.test(value.charAt(position)) &&
      (!config.encode || !config.encode.includes(value.charAt(position)))
    ) {
      // Character escape.
      result.push('\\')
    } else {
      // Character reference.
      result.push(
        '&#x' + value.charCodeAt(position).toString(16).toUpperCase() + ';'
      )
      start++
    }
  }

  result.push(escapeBackslashes(value.slice(start, end), config.after))

  return result.join('')
}

/**
 * @param {number} a
 * @param {number} b
 * @returns {number}
 */
function numerical(a, b) {
  return a - b
}

/**
 * @param {string} value
 * @param {string} after
 * @returns {string}
 */
function escapeBackslashes(value, after) {
  const expression = /\\(?=[!-/:-@[-`{-~])/g
  /** @type {Array<number>} */
  const positions = []
  /** @type {Array<string>} */
  const results = []
  const whole = value + after
  let index = -1
  let start = 0
  /** @type {RegExpExecArray | null} */
  let match

  while ((match = expression.exec(whole))) {
    positions.push(match.index)
  }

  while (++index < positions.length) {
    if (start !== positions[index]) {
      results.push(value.slice(start, positions[index]))
    }

    results.push('\\')
    start = positions[index]
  }

  results.push(value.slice(start))

  return results.join('')
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-markdown/lib/util/track.js
/**
 * @typedef {import('../types.js').CreateTracker} CreateTracker
 * @typedef {import('../types.js').TrackCurrent} TrackCurrent
 * @typedef {import('../types.js').TrackMove} TrackMove
 * @typedef {import('../types.js').TrackShift} TrackShift
 */

/**
 * Track positional info in the output.
 *
 * @type {CreateTracker}
 */
function track(config) {
  // Defaults are used to prevent crashes when older utilities somehow activate
  // this code.
  /* c8 ignore next 5 */
  const options = config || {}
  const now = options.now || {}
  let lineShift = options.lineShift || 0
  let line = now.line || 1
  let column = now.column || 1

  return {move, current, shift}

  /**
   * Get the current tracked info.
   *
   * @type {TrackCurrent}
   */
  function current() {
    return {now: {line, column}, lineShift}
  }

  /**
   * Define an increased line shift (the typical indent for lines).
   *
   * @type {TrackShift}
   */
  function shift(value) {
    lineShift += value
  }

  /**
   * Move past some generated markdown.
   *
   * @type {TrackMove}
   */
  function move(input) {
    // eslint-disable-next-line unicorn/prefer-default-parameters
    const value = input || ''
    const chunks = value.split(/\r?\n|\r/g)
    const tail = chunks[chunks.length - 1]
    line += chunks.length - 1
    column =
      chunks.length === 1 ? column + tail.length : 1 + tail.length + lineShift
    return value
  }
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-gfm-footnote/lib/index.js
/**
 * @typedef {import('mdast').FootnoteReference} FootnoteReference
 * @typedef {import('mdast').FootnoteDefinition} FootnoteDefinition
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Map} Map
 */








lib_footnoteReference.peek = footnoteReferencePeek

// To do: next major: rename `context` -> `state`, `safeOptions` to `info`, use
// utilities on `state`.

/**
 * Create an extension for `mdast-util-from-markdown` to enable GFM footnotes
 * in markdown.
 *
 * @returns {FromMarkdownExtension}
 *   Extension for `mdast-util-from-markdown`.
 */
function gfmFootnoteFromMarkdown() {
  return {
    enter: {
      gfmFootnoteDefinition: enterFootnoteDefinition,
      gfmFootnoteDefinitionLabelString: enterFootnoteDefinitionLabelString,
      gfmFootnoteCall: enterFootnoteCall,
      gfmFootnoteCallString: enterFootnoteCallString
    },
    exit: {
      gfmFootnoteDefinition: exitFootnoteDefinition,
      gfmFootnoteDefinitionLabelString: exitFootnoteDefinitionLabelString,
      gfmFootnoteCall: exitFootnoteCall,
      gfmFootnoteCallString: exitFootnoteCallString
    }
  }
}

/**
 * Create an extension for `mdast-util-to-markdown` to enable GFM footnotes
 * in markdown.
 *
 * @returns {ToMarkdownExtension}
 *   Extension for `mdast-util-to-markdown`.
 */
function gfmFootnoteToMarkdown() {
  return {
    // This is on by default already.
    unsafe: [{character: '[', inConstruct: ['phrasing', 'label', 'reference']}],
    handlers: {footnoteDefinition, footnoteReference: lib_footnoteReference}
  }
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function enterFootnoteDefinition(token) {
  this.enter(
    {type: 'footnoteDefinition', identifier: '', label: '', children: []},
    token
  )
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function enterFootnoteDefinitionLabelString() {
  this.buffer()
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitFootnoteDefinitionLabelString(token) {
  const label = this.resume()
  const node = /** @type {FootnoteDefinition} */ (
    this.stack[this.stack.length - 1]
  )
  node.label = label
  node.identifier = normalizeIdentifier(
    this.sliceSerialize(token)
  ).toLowerCase()
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitFootnoteDefinition(token) {
  this.exit(token)
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function enterFootnoteCall(token) {
  this.enter({type: 'footnoteReference', identifier: '', label: ''}, token)
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function enterFootnoteCallString() {
  this.buffer()
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitFootnoteCallString(token) {
  const label = this.resume()
  const node = /** @type {FootnoteDefinition} */ (
    this.stack[this.stack.length - 1]
  )
  node.label = label
  node.identifier = normalizeIdentifier(
    this.sliceSerialize(token)
  ).toLowerCase()
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitFootnoteCall(token) {
  this.exit(token)
}

/**
 * @type {ToMarkdownHandle}
 * @param {FootnoteReference} node
 */
function lib_footnoteReference(node, _, context, safeOptions) {
  const tracker = track(safeOptions)
  let value = tracker.move('[^')
  const exit = context.enter('footnoteReference')
  const subexit = context.enter('reference')
  value += tracker.move(
    safe(context, association(node), {
      ...tracker.current(),
      before: value,
      after: ']'
    })
  )
  subexit()
  exit()
  value += tracker.move(']')
  return value
}

/** @type {ToMarkdownHandle} */
function footnoteReferencePeek() {
  return '['
}

/**
 * @type {ToMarkdownHandle}
 * @param {FootnoteDefinition} node
 */
function footnoteDefinition(node, _, context, safeOptions) {
  const tracker = track(safeOptions)
  let value = tracker.move('[^')
  const exit = context.enter('footnoteDefinition')
  const subexit = context.enter('label')
  value += tracker.move(
    safe(context, association(node), {
      ...tracker.current(),
      before: value,
      after: ']'
    })
  )
  subexit()
  value += tracker.move(
    ']:' + (node.children && node.children.length > 0 ? ' ' : '')
  )
  tracker.shift(4)
  value += tracker.move(
    indentLines(containerFlow(node, context, tracker.current()), map)
  )
  exit()

  return value
}

/** @type {Map} */
function map(line, index, blank) {
  if (index === 0) {
    return line
  }

  return (blank ? '' : '    ') + line
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-markdown/lib/util/container-phrasing.js
/**
 * @typedef {import('../types.js').Handle} Handle
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').PhrasingContent} PhrasingContent
 * @typedef {import('../types.js').State} State
 */

/**
 * Serialize the children of a parent that contains phrasing children.
 *
 * These children will be joined flush together.
 *
 * @param {Parent & {children: Array<PhrasingContent>}} parent
 *   Parent of flow nodes.
 * @param {State} state
 *   Info passed around about the current state.
 * @param {Info} info
 *   Info on where we are in the document we are generating.
 * @returns {string}
 *   Serialized children, joined together.
 */
function containerPhrasing(parent, state, info) {
  const indexStack = state.indexStack
  const children = parent.children || []
  /** @type {Array<string>} */
  const results = []
  let index = -1
  let before = info.before

  indexStack.push(-1)
  let tracker = state.createTracker(info)

  while (++index < children.length) {
    const child = children[index]
    /** @type {string} */
    let after

    indexStack[indexStack.length - 1] = index

    if (index + 1 < children.length) {
      /** @type {Handle} */
      // @ts-expect-error: hush, it’s actually a `zwitch`.
      let handle = state.handle.handlers[children[index + 1].type]
      /** @type {Handle} */
      // @ts-expect-error: hush, it’s actually a `zwitch`.
      if (handle && handle.peek) handle = handle.peek
      after = handle
        ? handle(children[index + 1], parent, state, {
            before: '',
            after: '',
            ...tracker.current()
          }).charAt(0)
        : ''
    } else {
      after = info.after
    }

    // In some cases, html (text) can be found in phrasing right after an eol.
    // When we’d serialize that, in most cases that would be seen as html
    // (flow).
    // As we can’t escape or so to prevent it from happening, we take a somewhat
    // reasonable approach: replace that eol with a space.
    // See: <https://github.com/syntax-tree/mdast-util-to-markdown/issues/15>
    if (
      results.length > 0 &&
      (before === '\r' || before === '\n') &&
      child.type === 'html'
    ) {
      results[results.length - 1] = results[results.length - 1].replace(
        /(\r?\n|\r)$/,
        ' '
      )
      before = ' '

      // To do: does this work to reset tracker?
      tracker = state.createTracker(info)
      tracker.move(results.join(''))
    }

    results.push(
      tracker.move(
        state.handle(child, parent, state, {
          ...tracker.current(),
          before,
          after
        })
      )
    )

    before = results[results.length - 1].slice(-1)
  }

  indexStack.pop()

  return results.join('')
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-gfm-strikethrough/lib/index.js
/**
 * @typedef {import('mdast').Delete} Delete
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').ConstructName} ConstructName
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 */




// To do: next major: expose functions.
// To do: next major: use `state`, state utilities.

/**
 * List of constructs that occur in phrasing (paragraphs, headings), but cannot
 * contain strikethrough.
 * So they sort of cancel each other out.
 * Note: could use a better name.
 *
 * Note: keep in sync with: <https://github.com/syntax-tree/mdast-util-to-markdown/blob/8ce8dbf/lib/unsafe.js#L14>
 *
 * @type {Array<ConstructName>}
 */
const constructsWithoutStrikethrough = [
  'autolink',
  'destinationLiteral',
  'destinationRaw',
  'reference',
  'titleQuote',
  'titleApostrophe'
]

handleDelete.peek = peekDelete

/**
 * Extension for `mdast-util-from-markdown` to enable GFM strikethrough.
 *
 * @type {FromMarkdownExtension}
 */
const gfmStrikethroughFromMarkdown = {
  canContainEols: ['delete'],
  enter: {strikethrough: enterStrikethrough},
  exit: {strikethrough: exitStrikethrough}
}

/**
 * Extension for `mdast-util-to-markdown` to enable GFM strikethrough.
 *
 * @type {ToMarkdownExtension}
 */
const gfmStrikethroughToMarkdown = {
  unsafe: [
    {
      character: '~',
      inConstruct: 'phrasing',
      notInConstruct: constructsWithoutStrikethrough
    }
  ],
  handlers: {delete: handleDelete}
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function enterStrikethrough(token) {
  this.enter({type: 'delete', children: []}, token)
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitStrikethrough(token) {
  this.exit(token)
}

/**
 * @type {ToMarkdownHandle}
 * @param {Delete} node
 */
function handleDelete(node, _, context, safeOptions) {
  const tracker = track(safeOptions)
  const exit = context.enter('strikethrough')
  let value = tracker.move('~~')
  value += containerPhrasing(node, context, {
    ...tracker.current(),
    before: value,
    after: '~'
  })
  value += tracker.move('~~')
  exit()
  return value
}

/** @type {ToMarkdownHandle} */
function peekDelete() {
  return '~'
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-markdown/lib/handle/inline-code.js
/**
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 */



inline_code_inlineCode.peek = inlineCodePeek

/**
 * @param {InlineCode} node
 * @param {Parent | undefined} _
 * @param {State} state
 * @returns {string}
 */
function inline_code_inlineCode(node, _, state) {
  let value = node.value || ''
  let sequence = '`'
  let index = -1

  // If there is a single grave accent on its own in the code, use a fence of
  // two.
  // If there are two in a row, use one.
  while (new RegExp('(^|[^`])' + sequence + '([^`]|$)').test(value)) {
    sequence += '`'
  }

  // If this is not just spaces or eols (tabs don’t count), and either the
  // first or last character are a space, eol, or tick, then pad with spaces.
  if (
    /[^ \r\n]/.test(value) &&
    ((/^[ \r\n]/.test(value) && /[ \r\n]$/.test(value)) || /^`|`$/.test(value))
  ) {
    value = ' ' + value + ' '
  }

  // We have a potential problem: certain characters after eols could result in
  // blocks being seen.
  // For example, if someone injected the string `'\n# b'`, then that would
  // result in an ATX heading.
  // We can’t escape characters in `inlineCode`, but because eols are
  // transformed to spaces when going from markdown to HTML anyway, we can swap
  // them out.
  while (++index < state.unsafe.length) {
    const pattern = state.unsafe[index]
    const expression = patternCompile(pattern)
    /** @type {RegExpExecArray | null} */
    let match

    // Only look for `atBreak`s.
    // Btw: note that `atBreak` patterns will always start the regex at LF or
    // CR.
    if (!pattern.atBreak) continue

    while ((match = expression.exec(value))) {
      let position = match.index

      // Support CRLF (patterns only look for one of the characters).
      if (
        value.charCodeAt(position) === 10 /* `\n` */ &&
        value.charCodeAt(position - 1) === 13 /* `\r` */
      ) {
        position--
      }

      value = value.slice(0, position) + ' ' + value.slice(match.index + 1)
    }
  }

  return sequence + value + sequence
}

/**
 * @returns {string}
 */
function inlineCodePeek() {
  return '`'
}

;// CONCATENATED MODULE: ../node_modules/markdown-table/index.js
/**
 * @typedef Options
 *   Configuration (optional).
 * @property {string|null|ReadonlyArray<string|null|undefined>} [align]
 *   One style for all columns, or styles for their respective columns.
 *   Each style is either `'l'` (left), `'r'` (right), or `'c'` (center).
 *   Other values are treated as `''`, which doesn’t place the colon in the
 *   alignment row but does align left.
 *   *Only the lowercased first character is used, so `Right` is fine.*
 * @property {boolean} [padding=true]
 *   Whether to add a space of padding between delimiters and cells.
 *
 *   When `true`, there is padding:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there is no padding:
 *
 *   ```markdown
 *   |Alpha|B    |
 *   |-----|-----|
 *   |C    |Delta|
 *   ```
 * @property {boolean} [delimiterStart=true]
 *   Whether to begin each row with the delimiter.
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are starting delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no starting delimiters:
 *
 *   ```markdown
 *   Alpha | B     |
 *   ----- | ----- |
 *   C     | Delta |
 *   ```
 * @property {boolean} [delimiterEnd=true]
 *   Whether to end each row with the delimiter.
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B
 *   | ----- | -----
 *   | C     | Delta
 *   ```
 * @property {boolean} [alignDelimiters=true]
 *   Whether to align the delimiters.
 *   By default, they are aligned:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   Pass `false` to make them staggered:
 *
 *   ```markdown
 *   | Alpha | B |
 *   | - | - |
 *   | C | Delta |
 *   ```
 * @property {(value: string) => number} [stringLength]
 *   Function to detect the length of table cell content.
 *   This is used when aligning the delimiters (`|`) between table cells.
 *   Full-width characters and emoji mess up delimiter alignment when viewing
 *   the markdown source.
 *   To fix this, you can pass this function, which receives the cell content
 *   and returns its “visible” size.
 *   Note that what is and isn’t visible depends on where the text is displayed.
 *
 *   Without such a function, the following:
 *
 *   ```js
 *   markdownTable([
 *     ['Alpha', 'Bravo'],
 *     ['中文', 'Charlie'],
 *     ['👩‍❤️‍👩', 'Delta']
 *   ])
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo |
 *   | - | - |
 *   | 中文 | Charlie |
 *   | 👩‍❤️‍👩 | Delta |
 *   ```
 *
 *   With [`string-width`](https://github.com/sindresorhus/string-width):
 *
 *   ```js
 *   import stringWidth from 'string-width'
 *
 *   markdownTable(
 *     [
 *       ['Alpha', 'Bravo'],
 *       ['中文', 'Charlie'],
 *       ['👩‍❤️‍👩', 'Delta']
 *     ],
 *     {stringLength: stringWidth}
 *   )
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo   |
 *   | ----- | ------- |
 *   | 中文  | Charlie |
 *   | 👩‍❤️‍👩    | Delta   |
 *   ```
 */

/**
 * @typedef {Options} MarkdownTableOptions
 * @todo
 *   Remove next major.
 */

/**
 * Generate a markdown ([GFM](https://docs.github.com/en/github/writing-on-github/working-with-advanced-formatting/organizing-information-with-tables)) table..
 *
 * @param {ReadonlyArray<ReadonlyArray<string|null|undefined>>} table
 *   Table data (matrix of strings).
 * @param {Options} [options]
 *   Configuration (optional).
 * @returns {string}
 */
function markdownTable(table, options = {}) {
  const align = (options.align || []).concat()
  const stringLength = options.stringLength || defaultStringLength
  /** @type {Array<number>} Character codes as symbols for alignment per column. */
  const alignments = []
  /** @type {Array<Array<string>>} Cells per row. */
  const cellMatrix = []
  /** @type {Array<Array<number>>} Sizes of each cell per row. */
  const sizeMatrix = []
  /** @type {Array<number>} */
  const longestCellByColumn = []
  let mostCellsPerRow = 0
  let rowIndex = -1

  // This is a superfluous loop if we don’t align delimiters, but otherwise we’d
  // do superfluous work when aligning, so optimize for aligning.
  while (++rowIndex < table.length) {
    /** @type {Array<string>} */
    const row = []
    /** @type {Array<number>} */
    const sizes = []
    let columnIndex = -1

    if (table[rowIndex].length > mostCellsPerRow) {
      mostCellsPerRow = table[rowIndex].length
    }

    while (++columnIndex < table[rowIndex].length) {
      const cell = serialize(table[rowIndex][columnIndex])

      if (options.alignDelimiters !== false) {
        const size = stringLength(cell)
        sizes[columnIndex] = size

        if (
          longestCellByColumn[columnIndex] === undefined ||
          size > longestCellByColumn[columnIndex]
        ) {
          longestCellByColumn[columnIndex] = size
        }
      }

      row.push(cell)
    }

    cellMatrix[rowIndex] = row
    sizeMatrix[rowIndex] = sizes
  }

  // Figure out which alignments to use.
  let columnIndex = -1

  if (typeof align === 'object' && 'length' in align) {
    while (++columnIndex < mostCellsPerRow) {
      alignments[columnIndex] = toAlignment(align[columnIndex])
    }
  } else {
    const code = toAlignment(align)

    while (++columnIndex < mostCellsPerRow) {
      alignments[columnIndex] = code
    }
  }

  // Inject the alignment row.
  columnIndex = -1
  /** @type {Array<string>} */
  const row = []
  /** @type {Array<number>} */
  const sizes = []

  while (++columnIndex < mostCellsPerRow) {
    const code = alignments[columnIndex]
    let before = ''
    let after = ''

    if (code === 99 /* `c` */) {
      before = ':'
      after = ':'
    } else if (code === 108 /* `l` */) {
      before = ':'
    } else if (code === 114 /* `r` */) {
      after = ':'
    }

    // There *must* be at least one hyphen-minus in each alignment cell.
    let size =
      options.alignDelimiters === false
        ? 1
        : Math.max(
            1,
            longestCellByColumn[columnIndex] - before.length - after.length
          )

    const cell = before + '-'.repeat(size) + after

    if (options.alignDelimiters !== false) {
      size = before.length + size + after.length

      if (size > longestCellByColumn[columnIndex]) {
        longestCellByColumn[columnIndex] = size
      }

      sizes[columnIndex] = size
    }

    row[columnIndex] = cell
  }

  // Inject the alignment row.
  cellMatrix.splice(1, 0, row)
  sizeMatrix.splice(1, 0, sizes)

  rowIndex = -1
  /** @type {Array<string>} */
  const lines = []

  while (++rowIndex < cellMatrix.length) {
    const row = cellMatrix[rowIndex]
    const sizes = sizeMatrix[rowIndex]
    columnIndex = -1
    /** @type {Array<string>} */
    const line = []

    while (++columnIndex < mostCellsPerRow) {
      const cell = row[columnIndex] || ''
      let before = ''
      let after = ''

      if (options.alignDelimiters !== false) {
        const size =
          longestCellByColumn[columnIndex] - (sizes[columnIndex] || 0)
        const code = alignments[columnIndex]

        if (code === 114 /* `r` */) {
          before = ' '.repeat(size)
        } else if (code === 99 /* `c` */) {
          if (size % 2) {
            before = ' '.repeat(size / 2 + 0.5)
            after = ' '.repeat(size / 2 - 0.5)
          } else {
            before = ' '.repeat(size / 2)
            after = before
          }
        } else {
          after = ' '.repeat(size)
        }
      }

      if (options.delimiterStart !== false && !columnIndex) {
        line.push('|')
      }

      if (
        options.padding !== false &&
        // Don’t add the opening space if we’re not aligning and the cell is
        // empty: there will be a closing space.
        !(options.alignDelimiters === false && cell === '') &&
        (options.delimiterStart !== false || columnIndex)
      ) {
        line.push(' ')
      }

      if (options.alignDelimiters !== false) {
        line.push(before)
      }

      line.push(cell)

      if (options.alignDelimiters !== false) {
        line.push(after)
      }

      if (options.padding !== false) {
        line.push(' ')
      }

      if (
        options.delimiterEnd !== false ||
        columnIndex !== mostCellsPerRow - 1
      ) {
        line.push('|')
      }
    }

    lines.push(
      options.delimiterEnd === false
        ? line.join('').replace(/ +$/, '')
        : line.join('')
    )
  }

  return lines.join('\n')
}

/**
 * @param {string|null|undefined} [value]
 * @returns {string}
 */
function serialize(value) {
  return value === null || value === undefined ? '' : String(value)
}

/**
 * @param {string} value
 * @returns {number}
 */
function defaultStringLength(value) {
  return value.length
}

/**
 * @param {string|null|undefined} value
 * @returns {number}
 */
function toAlignment(value) {
  const code = typeof value === 'string' ? value.codePointAt(0) : 0

  return code === 67 /* `C` */ || code === 99 /* `c` */
    ? 99 /* `c` */
    : code === 76 /* `L` */ || code === 108 /* `l` */
    ? 108 /* `l` */
    : code === 82 /* `R` */ || code === 114 /* `r` */
    ? 114 /* `r` */
    : 0
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-gfm-table/lib/index.js
/**
 * @typedef {import('mdast').Table} Table
 * @typedef {import('mdast').TableRow} TableRow
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('mdast').InlineCode} InlineCode
 *
 * @typedef {import('markdown-table').MarkdownTableOptions} MarkdownTableOptions
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Context} ToMarkdownContext
 * @typedef {import('mdast-util-to-markdown').SafeOptions} SafeOptions
 */

/**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [tableCellPadding=true]
 *   Whether to add a space of padding between delimiters and cells.
 * @property {boolean | null | undefined} [tablePipeAlign=true]
 *   Whether to align the delimiters.
 * @property {MarkdownTableOptions['stringLength'] | null | undefined} [stringLength]
 *   Function to detect the length of table cell content, used when aligning
 *   the delimiters between cells
 */





// To do: next major: use `state` and `state` utilities from `mdast-util-to-markdown`.
// To do: next major: use `defaultHandlers.inlineCode`.
// To do: next major: expose functions.

/**
 * Extension for `mdast-util-from-markdown` to enable GFM tables.
 *
 * @type {FromMarkdownExtension}
 */
const gfmTableFromMarkdown = {
  enter: {
    table: enterTable,
    tableData: enterCell,
    tableHeader: enterCell,
    tableRow: enterRow
  },
  exit: {
    codeText: exitCodeText,
    table: exitTable,
    tableData: lib_exit,
    tableHeader: lib_exit,
    tableRow: lib_exit
  }
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function enterTable(token) {
  /** @type {Array<'left' | 'right' | 'center' | 'none'>} */
  // @ts-expect-error: `align` is custom.
  const align = token._align
  this.enter(
    {
      type: 'table',
      align: align.map((d) => (d === 'none' ? null : d)),
      children: []
    },
    token
  )
  this.setData('inTable', true)
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitTable(token) {
  this.exit(token)
  this.setData('inTable')
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function enterRow(token) {
  this.enter({type: 'tableRow', children: []}, token)
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function lib_exit(token) {
  this.exit(token)
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function enterCell(token) {
  this.enter({type: 'tableCell', children: []}, token)
}

// Overwrite the default code text data handler to unescape escaped pipes when
// they are in tables.
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitCodeText(token) {
  let value = this.resume()

  if (this.getData('inTable')) {
    value = value.replace(/\\([\\|])/g, replace)
  }

  const node = /** @type {InlineCode} */ (this.stack[this.stack.length - 1])
  node.value = value
  this.exit(token)
}

/**
 * @param {string} $0
 * @param {string} $1
 * @returns {string}
 */
function replace($0, $1) {
  // Pipes work, backslashes don’t (but can’t escape pipes).
  return $1 === '|' ? $1 : $0
}

/**
 * Create an extension for `mdast-util-to-markdown` to enable GFM tables in
 * markdown.
 *
 * @param {Options | null | undefined} [options]
 *   Configuration.
 * @returns {ToMarkdownExtension}
 *   Extension for `mdast-util-to-markdown` to enable GFM tables.
 */
function gfmTableToMarkdown(options) {
  const settings = options || {}
  const padding = settings.tableCellPadding
  const alignDelimiters = settings.tablePipeAlign
  const stringLength = settings.stringLength
  const around = padding ? ' ' : '|'

  return {
    unsafe: [
      {character: '\r', inConstruct: 'tableCell'},
      {character: '\n', inConstruct: 'tableCell'},
      // A pipe, when followed by a tab or space (padding), or a dash or colon
      // (unpadded delimiter row), could result in a table.
      {atBreak: true, character: '|', after: '[\t :-]'},
      // A pipe in a cell must be encoded.
      {character: '|', inConstruct: 'tableCell'},
      // A colon must be followed by a dash, in which case it could start a
      // delimiter row.
      {atBreak: true, character: ':', after: '-'},
      // A delimiter row can also start with a dash, when followed by more
      // dashes, a colon, or a pipe.
      // This is a stricter version than the built in check for lists, thematic
      // breaks, and setex heading underlines though:
      // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
      {atBreak: true, character: '-', after: '[:|-]'}
    ],
    handlers: {
      table: handleTable,
      tableRow: handleTableRow,
      tableCell: handleTableCell,
      inlineCode: inlineCodeWithTable
    }
  }

  /**
   * @type {ToMarkdownHandle}
   * @param {Table} node
   */
  function handleTable(node, _, context, safeOptions) {
    return serializeData(
      handleTableAsData(node, context, safeOptions),
      node.align
    )
  }

  /**
   * This function isn’t really used normally, because we handle rows at the
   * table level.
   * But, if someone passes in a table row, this ensures we make somewhat sense.
   *
   * @type {ToMarkdownHandle}
   * @param {TableRow} node
   */
  function handleTableRow(node, _, context, safeOptions) {
    const row = handleTableRowAsData(node, context, safeOptions)
    const value = serializeData([row])
    // `markdown-table` will always add an align row
    return value.slice(0, value.indexOf('\n'))
  }

  /**
   * @type {ToMarkdownHandle}
   * @param {TableCell} node
   */
  function handleTableCell(node, _, context, safeOptions) {
    const exit = context.enter('tableCell')
    const subexit = context.enter('phrasing')
    const value = containerPhrasing(node, context, {
      ...safeOptions,
      before: around,
      after: around
    })
    subexit()
    exit()
    return value
  }

  /**
   * @param {Array<Array<string>>} matrix
   * @param {Array<string | null | undefined> | null | undefined} [align]
   */
  function serializeData(matrix, align) {
    return markdownTable(matrix, {
      align,
      // @ts-expect-error: `markdown-table` types should support `null`.
      alignDelimiters,
      // @ts-expect-error: `markdown-table` types should support `null`.
      padding,
      // @ts-expect-error: `markdown-table` types should support `null`.
      stringLength
    })
  }

  /**
   * @param {Table} node
   * @param {ToMarkdownContext} context
   * @param {SafeOptions} safeOptions
   */
  function handleTableAsData(node, context, safeOptions) {
    const children = node.children
    let index = -1
    /** @type {Array<Array<string>>} */
    const result = []
    const subexit = context.enter('table')

    while (++index < children.length) {
      result[index] = handleTableRowAsData(
        children[index],
        context,
        safeOptions
      )
    }

    subexit()

    return result
  }

  /**
   * @param {TableRow} node
   * @param {ToMarkdownContext} context
   * @param {SafeOptions} safeOptions
   */
  function handleTableRowAsData(node, context, safeOptions) {
    const children = node.children
    let index = -1
    /** @type {Array<string>} */
    const result = []
    const subexit = context.enter('tableRow')

    while (++index < children.length) {
      // Note: the positional info as used here is incorrect.
      // Making it correct would be impossible due to aligning cells?
      // And it would need copy/pasting `markdown-table` into this project.
      result[index] = handleTableCell(
        children[index],
        node,
        context,
        safeOptions
      )
    }

    subexit()

    return result
  }

  /**
   * @type {ToMarkdownHandle}
   * @param {InlineCode} node
   */
  function inlineCodeWithTable(node, parent, context) {
    let value = inline_code_inlineCode(node, parent, context)

    if (context.stack.includes('tableCell')) {
      value = value.replace(/\|/g, '\\$&')
    }

    return value
  }
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-markdown/lib/util/check-bullet.js
/**
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Options} Options
 */

/**
 * @param {State} state
 * @returns {Exclude<Options['bullet'], null | undefined>}
 */
function checkBullet(state) {
  const marker = state.options.bullet || '*'

  if (marker !== '*' && marker !== '+' && marker !== '-') {
    throw new Error(
      'Cannot serialize items with `' +
        marker +
        '` for `options.bullet`, expected `*`, `+`, or `-`'
    )
  }

  return marker
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-markdown/lib/util/check-list-item-indent.js
/**
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Options} Options
 */

/**
 * @param {State} state
 * @returns {Exclude<Options['listItemIndent'], null | undefined>}
 */
function checkListItemIndent(state) {
  const style = state.options.listItemIndent || 'tab'

  // To do: remove in a major.
  // @ts-expect-error: deprecated.
  if (style === 1 || style === '1') {
    return 'one'
  }

  if (style !== 'tab' && style !== 'one' && style !== 'mixed') {
    throw new Error(
      'Cannot serialize items with `' +
        style +
        '` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`'
    )
  }

  return style
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-to-markdown/lib/handle/list-item.js
/**
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('../types.js').Map} Map
 * @typedef {import('../types.js').Parent} Parent
 * @typedef {import('../types.js').State} State
 * @typedef {import('../types.js').Info} Info
 */




/**
 * @param {ListItem} node
 * @param {Parent | undefined} parent
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */
function list_item_listItem(node, parent, state, info) {
  const listItemIndent = checkListItemIndent(state)
  let bullet = state.bulletCurrent || checkBullet(state)

  // Add the marker value for ordered lists.
  if (parent && parent.type === 'list' && parent.ordered) {
    bullet =
      (typeof parent.start === 'number' && parent.start > -1
        ? parent.start
        : 1) +
      (state.options.incrementListMarker === false
        ? 0
        : parent.children.indexOf(node)) +
      bullet
  }

  let size = bullet.length + 1

  if (
    listItemIndent === 'tab' ||
    (listItemIndent === 'mixed' &&
      ((parent && parent.type === 'list' && parent.spread) || node.spread))
  ) {
    size = Math.ceil(size / 4) * 4
  }

  const tracker = state.createTracker(info)
  tracker.move(bullet + ' '.repeat(size - bullet.length))
  tracker.shift(size)
  const exit = state.enter('listItem')
  const value = state.indentLines(
    state.containerFlow(node, tracker.current()),
    map
  )
  exit()

  return value

  /** @type {Map} */
  function map(line, index, blank) {
    if (index) {
      return (blank ? '' : ' '.repeat(size)) + line
    }

    return (blank ? bullet : bullet + ' '.repeat(size - bullet.length)) + line
  }
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-gfm-task-list-item/lib/index.js
/**
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 */

/**
 * @typedef {Extract<Root | Content, Parent>} Parents
 */




// To do: next major: rename `context` -> `state`, `safeOptions` -> `info`, use
// `track` from `state`.
// To do: next major: replace exports with functions.
// To do: next major: use `defaulthandlers.listItem`.

/**
 * Extension for `mdast-util-from-markdown` to enable GFM task list items.
 *
 * @type {FromMarkdownExtension}
 */
const gfmTaskListItemFromMarkdown = {
  exit: {
    taskListCheckValueChecked: exitCheck,
    taskListCheckValueUnchecked: exitCheck,
    paragraph: exitParagraphWithTaskListItem
  }
}

/**
 * Extension for `mdast-util-to-markdown` to enable GFM task list items.
 *
 * @type {ToMarkdownExtension}
 */
const gfmTaskListItemToMarkdown = {
  unsafe: [{atBreak: true, character: '-', after: '[:|-]'}],
  handlers: {listItem: listItemWithTaskListItem}
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitCheck(token) {
  const node = /** @type {ListItem} */ (this.stack[this.stack.length - 2])
  // We’re always in a paragraph, in a list item.
  node.checked = token.type === 'taskListCheckValueChecked'
}

/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */
function exitParagraphWithTaskListItem(token) {
  const parent = /** @type {Parents} */ (this.stack[this.stack.length - 2])

  if (
    parent &&
    parent.type === 'listItem' &&
    typeof parent.checked === 'boolean'
  ) {
    const node = /** @type {Paragraph} */ (this.stack[this.stack.length - 1])
    const head = node.children[0]

    if (head && head.type === 'text') {
      const siblings = parent.children
      let index = -1
      /** @type {Paragraph | undefined} */
      let firstParaghraph

      while (++index < siblings.length) {
        const sibling = siblings[index]
        if (sibling.type === 'paragraph') {
          firstParaghraph = sibling
          break
        }
      }

      if (firstParaghraph === node) {
        // Must start with a space or a tab.
        head.value = head.value.slice(1)

        if (head.value.length === 0) {
          node.children.shift()
        } else if (
          node.position &&
          head.position &&
          typeof head.position.start.offset === 'number'
        ) {
          head.position.start.column++
          head.position.start.offset++
          node.position.start = Object.assign({}, head.position.start)
        }
      }
    }
  }

  this.exit(token)
}

/**
 * @type {ToMarkdownHandle}
 * @param {ListItem} node
 */
function listItemWithTaskListItem(node, parent, context, safeOptions) {
  const head = node.children[0]
  const checkable =
    typeof node.checked === 'boolean' && head && head.type === 'paragraph'
  const checkbox = '[' + (node.checked ? 'x' : ' ') + '] '
  const tracker = track(safeOptions)

  if (checkable) {
    tracker.move(checkbox)
  }

  let value = list_item_listItem(node, parent, context, {
    ...safeOptions,
    ...tracker.current()
  })

  if (checkable) {
    value = value.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, check)
  }

  return value

  /**
   * @param {string} $0
   * @returns {string}
   */
  function check($0) {
    return $0 + checkbox
  }
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-gfm/lib/index.js
/**
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 */

/**
 * @typedef {import('mdast-util-gfm-table').Options} Options
 *   Configuration.
 */







/**
 * Create an extension for `mdast-util-from-markdown` to enable GFM (autolink
 * literals, footnotes, strikethrough, tables, tasklists).
 *
 * @returns {Array<FromMarkdownExtension>}
 *   Extension for `mdast-util-from-markdown` to enable GFM (autolink literals,
 *   footnotes, strikethrough, tables, tasklists).
 */
function gfmFromMarkdown() {
  return [
    gfmAutolinkLiteralFromMarkdown,
    gfmFootnoteFromMarkdown(),
    gfmStrikethroughFromMarkdown,
    gfmTableFromMarkdown,
    gfmTaskListItemFromMarkdown
  ]
}

/**
 * Create an extension for `mdast-util-to-markdown` to enable GFM (autolink
 * literals, footnotes, strikethrough, tables, tasklists).
 *
 * @param {Options | null | undefined} [options]
 *   Configuration.
 * @returns {ToMarkdownExtension}
 *   Extension for `mdast-util-to-markdown` to enable GFM (autolink literals,
 *   footnotes, strikethrough, tables, tasklists).
 */
function gfmToMarkdown(options) {
  return {
    extensions: [
      gfmAutolinkLiteralToMarkdown,
      gfmFootnoteToMarkdown(),
      gfmStrikethroughToMarkdown,
      gfmTableToMarkdown(options),
      gfmTaskListItemToMarkdown
    ]
  }
}

;// CONCATENATED MODULE: ../node_modules/remark-gfm/index.js
/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('micromark-extension-gfm').Options & import('mdast-util-gfm').Options} Options
 */




/**
 * Plugin to support GFM (autolink literals, footnotes, strikethrough, tables, tasklists).
 *
 * @type {import('unified').Plugin<[Options?]|void[], Root>}
 */
function remarkGfm(options = {}) {
  const data = this.data()

  add('micromarkExtensions', gfm(options))
  add('fromMarkdownExtensions', gfmFromMarkdown())
  add('toMarkdownExtensions', gfmToMarkdown(options))

  /**
   * @param {string} field
   * @param {unknown} value
   */
  function add(field, value) {
    const list = /** @type {unknown[]} */ (
      // Other extensions
      /* c8 ignore next 2 */
      data[field] ? data[field] : (data[field] = [])
    )

    list.push(value)
  }
}

;// CONCATENATED MODULE: ../node_modules/mdast-util-newline-to-break/lib/index.js
/**
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-find-and-replace').ReplaceFunction} ReplaceFunction
 */

/**
 * @typedef {Content | Root} Node
 */



/**
 * Turn normal line endings into hard breaks.
 *
 * @param {Node} tree
 *   Tree to change.
 * @returns {void}
 *   Nothing.
 */
function newlineToBreak(tree) {
  findAndReplace(tree, /\r?\n|\r/g, lib_replace)
}

/**
 * Replace line endings.
 *
 * @type {ReplaceFunction}
 */
function lib_replace() {
  return {type: 'break'}
}

;// CONCATENATED MODULE: ../node_modules/remark-breaks/index.js
/**
 * @typedef {import('mdast').Root} Root
 */



/**
 * Plugin to support hard breaks without needing spaces or escapes (turns enters
 * into `<br>`s).
 *
 * @type {import('unified').Plugin<void[], Root>}
 */
function remarkBreaks() {
  return newlineToBreak
}

// EXTERNAL MODULE: ./src/sections/ArticleBlockQuote/ArticleBlockQuote.jsx + 1 modules
var ArticleBlockQuote = __webpack_require__(3913);
// EXTERNAL MODULE: ../node_modules/tailwind-merge/dist/bundle-mjs.mjs
var bundle_mjs = __webpack_require__(4360);
;// CONCATENATED MODULE: ./src/snippets/Markdown/Markdown.jsx
/* eslint-disable react/no-unstable-nested-components */ 








var Markdown = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var centerAllText = param.centerAllText, children = param.children, _components = param.components, components = _components === void 0 ? {} : _components, className = param.className;
    var remappedComponents = (0,_object_spread/* default */.Z)({
        a: function a(data) {
            var content = data.children[0];
            var link = data.href;
            if (!link.includes("clearlyfiltered.com")) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: link,
                    target: "_blank",
                    rel: "noreferrer",
                    children: content
                });
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: data.href,
                children: content
            });
        },
        blockquote: function blockquote(data) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleBlockQuote/* Blockquote */.V, {
                children: data.children
            });
        }
    }, components);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: ref,
        className: (0,bundle_mjs/* twMerge */.m6)("markdown [&>:first-child]:mt-0 [&>:last-child]:mb-0 [&_a]:underline [&_blockquote_p]:lg:text-[42px] [&_blockquote_p]:lg:leading-[56px] [&_h1]:mb-6 [&_h1]:text-center [&_h2]:mb-5 [&_h2]:mt-8 [&_h3]:mb-6 [&_h3]:mt-6 [&_h4]:mb-4 [&_h4]:mt-4 [&_h5]:mb-4 [&_h5]:mt-3 [&_h5]:font-[400] [&_h5]:tracking-[0.01em] [&_h5]:lg:text-[20px] [&_h6]:mb-4 [&_h6]:mt-4 [&_li>p]:mb-0 [&_li]:mb-2 [&_ol>li]:list-decimal [&_ol]:mb-4 [&_ol]:pl-8 [&_p]:mb-4 [&_p]:lg:text-[20px] [&_p]:lg:leading-[28px] [&_ul>li]:list-disc [&_ul]:mb-4 [&_ul]:pl-8 ".concat(className, " ").concat(centerAllText ? "[&>h2]:text-center [&>h3]:text-center [&>h4]:text-center [&>h5]:text-center [&>h6]:text-center [&>p]:text-center" : "")),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactMarkdown, {
            remarkPlugins: [
                remarkGfm,
                remarkBreaks
            ],
            components: remappedComponents,
            children: children
        })
    });
});
Markdown.displayName = "Markdown";
Markdown.propTypes = {
    centerAllText: (prop_types_default()).bool,
    children: (prop_types_default()).string,
    components: (prop_types_default()).object
};

;// CONCATENATED MODULE: ./src/snippets/Markdown/index.js



/***/ }),

/***/ 391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ OkendoStarRating; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7378);


function OkendoStarRating(param) {
    var productId = param.productId, className = param.className;
    var widgetContainer = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var initialiseWidget = function() {
        return window.okeWidgetApi.initWidget(widgetContainer.current);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref;
        if ((ref = window.okeWidgetApi) === null || ref === void 0 ? void 0 : ref.initWidget) {
            initialiseWidget();
            // manually set product id if the script is already loaded
            window.okeWidgetApi.setProduct(widgetContainer.current, "shopify-".concat(productId));
        } else {
            document.addEventListener("oke-script-loaded", initialiseWidget);
        }
        return function() {
            document.removeEventListener("oke-script-loaded", initialiseWidget);
        };
    }, [
        productId
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: className,
        ref: widgetContainer,
        "data-oke-star-rating": true,
        "data-oke-reviews-product-id": "shopify-".concat(productId)
    });
}


/***/ }),

/***/ 5900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* reexport */ ColorVariantSelector; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(7599);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3444);
// EXTERNAL MODULE: ./src/snippets/Image/index.js + 2 modules
var Image = __webpack_require__(8601);
;// CONCATENATED MODULE: ./src/snippets/ProductItem/ColorVariantSelector/ColorVariantOption.jsx


function ColorVariantOption(param) {
    var color = param.color, enabledColorNameOnHover = param.enabledColorNameOnHover, onClick = param.onClick, onMouseEnter = param.onMouseEnter, swatchesMap = param.swatchesMap, variantFromColor = param.variantFromColor;
    var isActive = color === (variantFromColor === null || variantFromColor === void 0 ? void 0 : variantFromColor.selectedOptionsMap.Color);
    var swatch = swatchesMap === null || swatchesMap === void 0 ? void 0 : swatchesMap[color === null || color === void 0 ? void 0 : color.toLowerCase().trim()];
    var hasImage = swatch === null || swatch === void 0 ? void 0 : swatch.startsWith("http");
    var backgroundColor = isActive && swatch === "#FFFFFF" ? "var(--off-white)" : swatch || "var(--off-white)";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "group/color relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                "aria-label": "Select ".concat(color, " color variant"),
                className: "relative flex h-6 w-6 items-center justify-center overflow-hidden rounded-[50%] ".concat(color === "WHITE" ? "border border-[#00000040]" : null, " transition  ").concat(isActive ? "border-text" : "scale-[85%]"),
                onClick: onClick,
                onMouseEnter: onMouseEnter,
                style: {
                    backgroundColor: backgroundColor
                },
                type: "button",
                children: [
                    hasImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                        alt: color,
                        className: "absolute left-1/2 top-1/2 h-full w-full -translate-x-1/2 -translate-y-1/2 object-cover",
                        height: "24",
                        src: swatch,
                        width: "24"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-1/2 left-1/2 h-full w-full -translate-x-1/2 -translate-y-1/2 rounded-[50%] border-[#FFFFFF80] transition-[border-width] duration-100 ".concat(isActive ? "border-[5px]" : "border-[0px]")
                    })
                ]
            }),
            enabledColorNameOnHover && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "pointer-events-none absolute left-[25%] bottom-[calc(100%+2px)] hidden whitespace-nowrap rounded bg-offWhite px-1 text-2xs leading-[14px] text-mediumDarkGray opacity-0 transition duration-75 md:block group-hover/color:md:opacity-100",
                children: color
            })
        ]
    });
}
ColorVariantOption.displayName = "ColorVariantOption";

;// CONCATENATED MODULE: ./src/snippets/ProductItem/ColorVariantSelector/ColorVariantOptions.jsx







function ColorVariantOptions(param) {
    var enabledColorNameOnHover = param.enabledColorNameOnHover, product = param.product, setVariantFromColor = param.setVariantFromColor, swatchesMap = param.swatchesMap, variantFromColor = param.variantFromColor;
    var ref, ref1;
    var ref2 = (0,react.useState)(14), maxCount = ref2[0], setMaxCount = ref2[1];
    var swatchListRef = (0,react.useRef)(null);
    var originalColor = (ref = product.optionsMap.Color) === null || ref === void 0 ? void 0 : ref[0];
    var colorOptions = ((ref1 = product.grouping) === null || ref1 === void 0 ? void 0 : ref1.isTransformed) ? [
        originalColor, 
    ].concat((0,_to_consumable_array/* default */.Z)(product.grouping.optionsMap.Color.filter(function(color) {
        return color !== originalColor;
    }))) : product.optionsMap.Color;
    var slicedColorOptions = colorOptions.slice(0, maxCount);
    var variantMapByColor = (0,react.useMemo)(function() {
        var ref;
        var variants = ((ref = product.grouping) === null || ref === void 0 ? void 0 : ref.isTransformed) ? product.grouping.variants : product.variants;
        return variants.reduce(function(acc, variant) {
            var ref;
            var variantColor = (ref = variant.selectedOptionsMap) === null || ref === void 0 ? void 0 : ref.Color;
            if (acc[variantColor]) return acc;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, variantColor, variant));
        }, {});
    }, [
        product.id
    ]);
    (0,react.useEffect)(function() {
        var updateMaxCount = function updateMaxCount() {
            if (!swatchListRef.current) return;
            // Snag the first swatch if we have it to calculate sizes
            var firstSwatch = swatchListRef.current.querySelector("li");
            if (!firstSwatch) return;
            // Calculate how many swatches fit per row based on the first swatch width and container width
            var swatchGap = 10;
            var swatchWidth = firstSwatch.offsetWidth + swatchGap;
            var containerWidth = swatchListRef.current.offsetWidth - swatchWidth + swatchGap;
            var count = Math.floor(containerWidth / swatchWidth);
            var remaining = colorOptions.length - count;
            // Remove existing "+N" element if present
            var existingRemaining = swatchListRef.current.querySelector("li.remaining");
            if (existingRemaining) {
                swatchListRef.current.removeChild(existingRemaining);
            }
            // If there are remaining swatches, show "+N"
            if (remaining > 0) {
                var listElement = document.createElement("li");
                listElement.className = "remaining order-1 mr-auto text-[14px]";
                listElement.innerHTML = "+ ".concat(remaining);
                swatchListRef.current.appendChild(listElement);
            }
            setMaxCount(count);
        };
        updateMaxCount();
        window.addEventListener("resize", updateMaxCount);
        return function() {
            return window.removeEventListener("resize", updateMaxCount);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        ref: swatchListRef,
        className: "flex w-full flex-wrap gap-[10px]",
        children: slicedColorOptions.map(function(color, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorVariantOption, {
                    color: color,
                    enabledColorNameOnHover: enabledColorNameOnHover,
                    onClick: function() {
                        return setVariantFromColor(variantMapByColor[color]);
                    },
                    onMouseEnter: function() {
                        return setVariantFromColor(variantMapByColor[color]);
                    },
                    swatchesMap: swatchesMap,
                    variantFromColor: variantFromColor
                })
            }, index);
        })
    });
}
ColorVariantOptions.displayName = "ColorVariantOptions";

;// CONCATENATED MODULE: ./src/snippets/ProductItem/ColorVariantSelector/ColorVariantSelector.jsx



function ColorVariantSelector(param) {
    var enabledColorNameOnHover = param.enabledColorNameOnHover, product = param.product, setVariantFromColor = param.setVariantFromColor, swatchesMap = param.swatchesMap, variantFromColor = param.variantFromColor, className = param.className;
    var ref, ref1, ref2, ref3, ref4;
    var hasMultipleColorsFromProduct = !(product === null || product === void 0 ? void 0 : (ref = product.grouping) === null || ref === void 0 ? void 0 : ref.isTransformed) && (product === null || product === void 0 ? void 0 : (ref1 = product.optionsMap) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Color) === null || ref2 === void 0 ? void 0 : ref2.length) > 1;
    var hasMultipleColorsFromGrouping = (product === null || product === void 0 ? void 0 : (ref3 = product.grouping) === null || ref3 === void 0 ? void 0 : ref3.isTransformed) && ((ref4 = product.grouping.optionsMap.Color) === null || ref4 === void 0 ? void 0 : ref4.length) > 1;
    var hasMultipleColors = hasMultipleColorsFromProduct || hasMultipleColorsFromGrouping;
    // sets initial variant from initial color
    (0,react.useEffect)(function() {
        var ref;
        if (!product || !hasMultipleColors) return;
        setVariantFromColor(((ref = product.variants) === null || ref === void 0 ? void 0 : ref[0]) || null);
    }, [
        product === null || product === void 0 ? void 0 : product.id,
        hasMultipleColors
    ]);
    return hasMultipleColors && variantFromColor ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mt-3.5 w-full ".concat(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorVariantOptions, {
            enabledColorNameOnHover: enabledColorNameOnHover,
            product: product,
            setVariantFromColor: setVariantFromColor,
            swatchesMap: swatchesMap,
            variantFromColor: variantFromColor
        })
    }) : null;
}
ColorVariantSelector.displayName = "ColorVariantSelector";

;// CONCATENATED MODULE: ./src/snippets/ProductItem/ColorVariantSelector/index.js



/***/ }),

/***/ 8766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* binding */ ProductItemMedia; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ./src/snippets/Badges/index.js + 1 modules
var Badges = __webpack_require__(2545);
// EXTERNAL MODULE: ./src/snippets/Button/index.js + 2 modules
var Button = __webpack_require__(7388);
// EXTERNAL MODULE: ./src/snippets/Image/index.js + 2 modules
var Image = __webpack_require__(8601);
// EXTERNAL MODULE: ./src/snippets/Spinner/index.js + 1 modules
var Spinner = __webpack_require__(7804);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
;// CONCATENATED MODULE: ./src/snippets/ProductItem/ProductItemMedia/ProductItemVideo.jsx


var ProductItemVideo = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var _autoPlay = param.autoPlay, autoPlay = _autoPlay === void 0 ? false : _autoPlay, media = param.media;
    var _$ref;
    var sources = media.sources, preview = media.preview;
    var videoSources = sources === null || sources === void 0 ? void 0 : sources.filter(function(param) {
        var mimeType = param.mimeType;
        return mimeType === "video/mp4";
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
        ref: ref,
        autoPlay: autoPlay,
        muted: true,
        playsInline: true,
        loop: true,
        controls: false,
        poster: preview === null || preview === void 0 ? void 0 : (_$ref = preview.image) === null || _$ref === void 0 ? void 0 : _$ref.src,
        className: "absolute inset-0 h-full w-full",
        children: (videoSources === null || videoSources === void 0 ? void 0 : videoSources.length) ? videoSources.map(function(source) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                src: source.url,
                type: source.mimeType
            }, source.url);
        }) : null
    });
});
ProductItemVideo.displayName = "ProductItemVideo";

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(7599);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3444);
;// CONCATENATED MODULE: ./src/snippets/ProductItem/ProductItemMedia/useProductItemMedia.js





function useProductItemMedia(param) {
    var product = param.product, variant = param.variant;
    var mediaMapByHandle = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3;
        if (!(product === null || product === void 0 ? void 0 : (ref = product.grouping) === null || ref === void 0 ? void 0 : ref.isTransformed) || !((product === null || product === void 0 ? void 0 : (ref1 = product.grouping) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.optionsMap) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.Color) === null || ref3 === void 0 ? void 0 : ref3.length) > 1)) return null;
        return product.grouping.media.reduce(function(acc, item) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, item.product.handle, (0,_to_consumable_array/* default */.Z)(acc[item.product.handle] || []).concat([
                item
            ])));
        }, {});
    }, [
        product === null || product === void 0 ? void 0 : product.id
    ]);
    return (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        if (!product || !variant) {
            return {
                aspectRatio: "var(--product-image-aspect-ratio)",
                primary: {
                    media: null,
                    isVideo: false
                },
                hover: {
                    media: null,
                    isVideo: false
                }
            };
        }
        var hasGroupColorVariants = (product === null || product === void 0 ? void 0 : (ref = product.grouping) === null || ref === void 0 ? void 0 : ref.isTransformed) && ((ref1 = product.grouping.optionsMap.Color) === null || ref1 === void 0 ? void 0 : ref1.length) > 1;
        var hasNonGroupColorVariants = !(product === null || product === void 0 ? void 0 : (ref2 = product.grouping) === null || ref2 === void 0 ? void 0 : ref2.isTransformed) && ((ref3 = product === null || product === void 0 ? void 0 : product.optionsMap.Color) === null || ref3 === void 0 ? void 0 : ref3.length) > 1;
        var medias = hasGroupColorVariants ? mediaMapByHandle[variant.product.handle] : product.media;
        var firstMediaIndex = 0;
        var secondMediaIndex = 1;
        // if multiple color variants from same product, use first media w/ color as alt
        if (hasNonGroupColorVariants) {
            var ref6, ref7, ref8, ref9;
            var colorOptions = (ref6 = product.optionsMap.Color) === null || ref6 === void 0 ? void 0 : ref6.map(function(color) {
                return color.toLowerCase();
            });
            var selectedColor = (ref7 = variant.selectedOptionsMap.Color) === null || ref7 === void 0 ? void 0 : ref7.toLowerCase();
            firstMediaIndex = medias.findIndex(function(item) {
                var ref;
                var alt = (ref = item.alt) === null || ref === void 0 ? void 0 : ref.trim().toLowerCase();
                return alt === selectedColor || !(colorOptions === null || colorOptions === void 0 ? void 0 : colorOptions.includes(alt));
            }) || 0;
            var secondMediaAlt = (ref8 = medias[firstMediaIndex + 1]) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.alt) === null || ref9 === void 0 ? void 0 : ref9.trim().toLowerCase();
            secondMediaIndex = secondMediaAlt === selectedColor || !(colorOptions === null || colorOptions === void 0 ? void 0 : colorOptions.includes(secondMediaAlt)) ? firstMediaIndex + 1 : -1;
        }
        var primaryMedia = medias === null || medias === void 0 ? void 0 : medias[firstMediaIndex];
        var primaryMediaImage = primaryMedia === null || primaryMedia === void 0 ? void 0 : (ref4 = primaryMedia.preview) === null || ref4 === void 0 ? void 0 : ref4.image;
        var secondMedia = medias === null || medias === void 0 ? void 0 : medias[secondMediaIndex];
        var hoverMedia = secondMediaIndex >= 1 && (secondMedia === null || secondMedia === void 0 ? void 0 : (ref5 = secondMedia.product) === null || ref5 === void 0 ? void 0 : ref5.handle) === variant.product.handle ? secondMedia : null;
        return {
            aspectRatio: primaryMediaImage ? primaryMediaImage.width / primaryMediaImage.height : "var(--product-image-aspect-ratio)",
            primary: {
                media: primaryMedia,
                isVideo: (primaryMedia === null || primaryMedia === void 0 ? void 0 : primaryMedia.mediaContentType) === "VIDEO"
            },
            hover: {
                media: hoverMedia,
                isVideo: (hoverMedia === null || hoverMedia === void 0 ? void 0 : hoverMedia.mediaContentType) === "VIDEO"
            }
        };
    }, [
        mediaMapByHandle,
        product === null || product === void 0 ? void 0 : product.id,
        variant === null || variant === void 0 ? void 0 : variant.id
    ]);
}

;// CONCATENATED MODULE: ./src/snippets/ProductItem/ProductItemMedia/ProductItemMedia.jsx







function ProductItemMedia(param) {
    var product = param.product, variant = param.variant, variantFromColor = param.variantFromColor, _disableHoverEffect = param.disableHoverEffect, disableHoverEffect = _disableHoverEffect === void 0 ? false : _disableHoverEffect, _disableBackground = param.disableBackground, disableBackground = _disableBackground === void 0 ? false : _disableBackground;
    var ref, ref1, ref2;
    var primary = useProductItemMedia({
        product: product,
        variant: variant
    }).primary;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat(disableHoverEffect ? "" : "group/media", " ").concat(disableBackground ? "" : "bg-[#e6f0f7]", " product-item-media relative flex aspect-square h-full w-full items-end justify-center"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute inset-0 bg-gradient-to-r from-[#2179C233] via-[#8DCEF933] to-[#F1DCC133] opacity-0 transition-opacity duration-200 group-hover/media:lg:opacity-100"
            }),
            primary.media && (primary.isVideo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductItemVideo, {
                autoPlay: true,
                media: primary.media
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                className: "".concat(disableBackground ? "" : "mix-blend-multiply", " !object-contain !mix-blend-multiply"),
                alt: variant === null || variant === void 0 ? void 0 : (ref = variant.product) === null || ref === void 0 ? void 0 : ref.title,
                fill: true,
                sizes: "(min-width: 768px) 33vw, 50vw",
                src: (variantFromColor === null || variantFromColor === void 0 ? void 0 : (ref1 = variantFromColor.image) === null || ref1 === void 0 ? void 0 : ref1.src) || primary.media.image.src
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "learn-more-hover relative hidden p-[38px] opacity-0 transition-opacity duration-200 group-hover/media:opacity-100 md:block",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                    variant: "filled",
                    theme: "primary",
                    className: "relative overflow-hidden bg-gradient-to-r from-[#C1EFFA] to-[#8DCEF9] px-[64px] !text-[17px] text-[#121D29] !shadow-none before:absolute before:left-[50%] before:top-[50%] before:h-[calc(100%-4px)] before:w-[calc(100%-4px)] before:-translate-x-[50%] before:-translate-y-[50%] before:rounded-full before:bg-white",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative text-primary",
                        children: "Learn More"
                    })
                })
            }),
            !primary.media && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-gray",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pointer-events-none absolute left-0 top-0 z-[1] p-2.5 xs:p-3 xl:p-4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badges/* Badges */.a, {
                    className: "max-xl:text-label-sm gap-2 xs:gap-2 [&_div]:max-xl:px-1.5 [&_div]:max-xl:py-0.5",
                    tags: variant === null || variant === void 0 ? void 0 : (ref2 = variant.product) === null || ref2 === void 0 ? void 0 : ref2.tags
                })
            })
        ]
    });
}
ProductItemMedia.displayName = "ProductItemMedia";


/***/ }),

/***/ 6426:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* binding */ RechargeSubscriptionWidget_RechargeSubscriptionWidget; }
});

// NAMESPACE OBJECT: ./src/snippets/RechargeSubscriptionWidget/RechargeSubscriptionWidgetDetails.jsx
var RechargeSubscriptionWidgetDetails_namespaceObject = {};
__webpack_require__.r(RechargeSubscriptionWidgetDetails_namespaceObject);

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var src_to_consumable_array = __webpack_require__(3444);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ./src/contexts/globalProductPageContext.js
var globalProductPageContext = __webpack_require__(2448);
// EXTERNAL MODULE: ./src/snippets/Typography/index.js + 3 modules
var Typography = __webpack_require__(7373);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(3615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/contexts/index.js + 1 modules
var contexts = __webpack_require__(8249);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(169);
// EXTERNAL MODULE: ../node_modules/@backpackjs/storefront/dist/index.js
var dist = __webpack_require__(2031);
// EXTERNAL MODULE: ./src/snippets/AddToCart/index.js + 3 modules
var AddToCart = __webpack_require__(9729);
// EXTERNAL MODULE: ./src/snippets/Image/index.js + 2 modules
var Image = __webpack_require__(8601);
// EXTERNAL MODULE: ./src/snippets/Markdown/index.js + 161 modules
var Markdown = __webpack_require__(2725);
// EXTERNAL MODULE: ./src/snippets/Svg/index.js
var Svg = __webpack_require__(7342);
;// CONCATENATED MODULE: ./src/hooks/useProductsByHandles.js

function useProductsByHandles(param) {
    var _handles = param.handles, handles = _handles === void 0 ? [] : _handles, fetchOnMount = param.fetchOnMount;
    if (!(handles === null || handles === void 0 ? void 0 : handles.length)) {
        return;
    }
    var hooks = handles.map(function(handle) {
        return (0,dist.useProductByHandle)({
            handle: handle,
            fetchOnMount: fetchOnMount
        });
    });
    return {
        products: hooks.map(function(hook) {
            return hook.product;
        }),
        hooks: hooks
    };
}

;// CONCATENATED MODULE: ./src/snippets/FrequencyCalculator/FrequencyCalculator.jsx











function FrequencyCalculator(param) {
    var linkedProductHandles = param.linkedProductHandles, pdpProduct = param.product, sectionSettings = param.sectionSettings, pdpSellingPlan = param.selectedSellingPlan, pdpSelectedVariant = param.selectedVariant, setPdpSelectedSellingPlanByID = param.setSelectedSellingPlanByID, subscriptionProducts = param.subscriptionProducts;
    var settings = (0,dist.useSettings)();
    var globalCalculatorSettings = settings === null || settings === void 0 ? void 0 : settings.filterReplacementCalculator;
    var recommendations = globalCalculatorSettings.recommendations.reduce(function(output, item) {
        var handle = item.product.data.handle;
        output[handle] = item.recommendation;
        return output;
    }, {});
    var title = globalCalculatorSettings.title, label = globalCalculatorSettings.label, ctaWithinCalculator = globalCalculatorSettings.ctaWithinCalculator, disclaimer = globalCalculatorSettings.disclaimer;
    var ref = (0,react.useState)(1), people = ref[0], setPeople = ref[1];
    var linkedProducts = useProductsByHandles({
        handles: linkedProductHandles
    });
    // This is needed to update the progress portion of the range on webkit ranges
    // Used to update the property vars based on input
    (0,react.useEffect)(function() {
        var range = document.getElementById("people-range");
        if (!range) return undefined;
        var set = function() {
            var min = +range.min || 0;
            var max = +range.max || 100;
            var value = +range.value;
            var percent = (value - min) * 100 / (max - min);
            range.style.setProperty("--min", String(min));
            range.style.setProperty("--max", String(max));
            range.style.setProperty("--value", String(value));
            range.style.setProperty("--percent", "".concat(percent, "%"));
        };
        set();
        range.addEventListener("input", set);
        range.addEventListener("change", set);
        return function() {
            range.removeEventListener("input", set);
            range.removeEventListener("change", set);
        };
    }, []);
    var normalizePlan = function(plan) {
        return (plan === null || plan === void 0 ? void 0 : plan.sellingPlan) ? plan : plan ? {
            sellingPlan: plan
        } : null;
    };
    var ref1 = (0,react.useState)(normalizePlan(pdpSellingPlan)), selectedPlan = ref1[0], setSelectedPlan = ref1[1];
    var ref2 = (0,react.useState)(pdpSelectedVariant), selectedVariant = ref2[0], setSelectedVariant = ref2[1];
    var userPickedRef = (0,react.useRef)(false);
    var products = (0,react.useMemo)(function() {
        var ref;
        return (linkedProducts === null || linkedProducts === void 0 ? void 0 : (ref = linkedProducts.products) === null || ref === void 0 ? void 0 : ref.length) ? linkedProducts.products : [
            pdpProduct
        ];
    }, [
        linkedProducts === null || linkedProducts === void 0 ? void 0 : linkedProducts.products,
        pdpProduct
    ]);
    var subscriptions = (0,react.useMemo)(function() {
        return subscriptionProducts.filter(function(subscription) {
            return products.map(function(product) {
                return product.handle;
            }).includes(subscription.product.handle);
        });
    }, [
        subscriptionProducts,
        products
    ]);
    var getSubscriptionByHandle = function(handle) {
        return subscriptions.find(function(subscription) {
            return subscription.product.handle === handle;
        });
    };
    // Recommendation based on the product, and number of people from state
    var recommendedPlans = (0,react.useMemo)(function() {
        var getRecommendedFrequency = function(product) {
            var ref, ref1;
            return (ref1 = (ref = recommendations[product.handle]) === null || ref === void 0 ? void 0 : ref.find(function(rec) {
                return rec.people === people;
            })) === null || ref1 === void 0 ? void 0 : ref1.frequency;
        };
        return products.flatMap(function(product) {
            return (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, product), {
                recommendedPlan: product.sellingPlanGroups.find(function(plan) {
                    var freq = parseInt(plan.options.find(function(option) {
                        return option.name === "Order Frequency and Unit";
                    })// example value: "12-month"
                    .values[0].split("-month"));
                    return freq === getRecommendedFrequency(product);
                })
            });
        });
    }, [
        products,
        people,
        recommendations
    ]);
    // Updates product selection when slider or selected product changes for a2c
    (0,react.useEffect)(function() {
        var ref, ref1;
        userPickedRef.current = false;
        var currentHandle = (selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.product) === null || ref === void 0 ? void 0 : ref.handle) || pdpProduct.handle;
        var target = recommendedPlans.find(function(product) {
            var ref, ref1;
            return product.handle === currentHandle && ((ref = product.recommendedPlan) === null || ref === void 0 ? void 0 : (ref1 = ref.sellingPlans) === null || ref1 === void 0 ? void 0 : ref1[0]);
        });
        if (!target) return;
        var nextPlan = {
            sellingPlan: target.recommendedPlan.sellingPlans[0]
        };
        if (nextPlan.sellingPlan.id !== (selectedPlan === null || selectedPlan === void 0 ? void 0 : (ref1 = selectedPlan.sellingPlan) === null || ref1 === void 0 ? void 0 : ref1.id)) {
            setSelectedPlan(nextPlan);
        }
    }, [
        people
    ]);
    var onChange = function(product, sellingPlan) {
        userPickedRef.current = true;
        setSelectedPlan(sellingPlan);
        // Not switching to a linked product
        if (product.id === pdpProduct.id) {
            setSelectedVariant(pdpSelectedVariant);
            setPdpSelectedSellingPlanByID(sellingPlan.sellingPlan.id);
            return;
        }
        // Linked product only has one variant
        if (product.variants.length === 1) {
            setSelectedVariant(product.variants[0]);
            return;
        }
        // Linked product has multiple variants
        // Try to match based on the PDP variant
        var pdpVariantOptions = pdpSelectedVariant.selectedOptionsMap;
        var nextVariant = product.variants.find(function(variant) {
            return variant.selectedOptionsMap === pdpVariantOptions;
        });
        setSelectedVariant(nextVariant || product.variants[0]);
    };
    var getMarkerClassname = function(number) {
        var className = "range-input__marker absolute -bottom-10";
        if (number === people) {
            return "".concat(className, " text-lg range-input__marker--active");
        }
        return "".concat(className, " text-sm opacity-[0.4]");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "frequency-calculator-modal flex h-full grow flex-col gap-4",
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                variant: "h4",
                element: "h4",
                className: "mb-4 flex items-center justify-center border-b border-[#DDE2E7] pb-6 text-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "frequency-calculator-modal-title w-",
                    children: title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid gap-4 bg-white p-4 text-center md:p-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-[1.125rem] leading-6 md:leading-[1.125rem] lg:text-xl",
                        "aria-live": "polite",
                        "aria-atomic": "true",
                        children: [
                            people,
                            " ",
                            people === 1 ? "Person" : "People",
                            " = ",
                            people,
                            "+ fills per day (Estimated)"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative mb-8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                className: "w-full",
                                id: "people-range",
                                max: "4",
                                min: "1",
                                onChange: function(e) {
                                    return setPeople(parseInt(e.target.value));
                                },
                                type: "range",
                                value: people
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "".concat(getMarkerClassname(1), " left-[3%] md:left-[1.5%]"),
                                children: "1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "".concat(getMarkerClassname(2), " left-[34%] -translate-x-1/2"),
                                children: "2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "".concat(getMarkerClassname(3), " left-[66%] -translate-x-1/2"),
                                children: "3"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "".concat(getMarkerClassname(4), " end-0 left-[95%] -translate-x-1/2 md:left-[98%]"),
                                children: "4"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        className: "text-[0.65rem] text-xs font-light md:text-sm",
                        htmlFor: "people-range",
                        children: sectionSettings.labelOverride || label
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "grow",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                        variant: "h5",
                        element: "h5",
                        className: "mb-4 mt-4 text-base md:mb-8 md:mt-8",
                        children: "Your recommended filter plan"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "leading-8",
                        children: recommendedPlans.map(function(product) {
                            var ref;
                            if (!(product === null || product === void 0 ? void 0 : product.recommendedPlan)) return;
                            var shipsRecurringly = (getSubscriptionByHandle(product.handle) || {}).shipsRecurringly;
                            if (!shipsRecurringly) return;
                            var image = shipsRecurringly.image, items = shipsRecurringly.items;
                            // There's always one sellingPlan per plan
                            var sellingPlan = product.recommendedPlan.sellingPlans[0];
                            var id = sellingPlan.id, planName = sellingPlan.name;
                            var isSelected = id === (selectedPlan === null || selectedPlan === void 0 ? void 0 : (ref = selectedPlan.sellingPlan) === null || ref === void 0 ? void 0 : ref.id);
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row items-center justify-between gap-4 border-t border-[#DDE2E7] py-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row items-center gap-4 text-xs font-light leading-[1.25rem] md:text-base",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                                alt: "",
                                                className: "max-w-[50px]",
                                                src: image.src,
                                                width: "50",
                                                height: "50"
                                            }, product.handle),
                                            items === null || items === void 0 ? void 0 : items.replace(/^\*/, "") // remove bullet point
                                            .replace(/\s*\([^)]*%\s*Off\)/gi, "").replaceAll("{qty}x", ""),
                                            " ",
                                            "- ",
                                            planName
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                checked: isSelected,
                                                className: "sr-only",
                                                id: "radio-".concat(id),
                                                name: "selected-plan",
                                                onChange: function() {
                                                    return onChange(product, {
                                                        sellingPlan: sellingPlan
                                                    });
                                                },
                                                type: "radio",
                                                value: id
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                "aria-label": "Select ".concat(planName),
                                                className: "cursor-pointer text-sm text-primary underline",
                                                htmlFor: "radio-".concat(id),
                                                children: isSelected ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "flex flex-row gap-2 text-success underline",
                                                    children: [
                                                        "Selected!",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                                                            className: "w-[24px]",
                                                            src: "/svgs/circle-check.svg#circle-check",
                                                            title: "Check",
                                                            viewBox: "0 0 20 20"
                                                        })
                                                    ]
                                                }) : "Select"
                                            })
                                        ]
                                    })
                                ]
                            }, id);
                        })
                    }),
                    ctaWithinCalculator && /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCart/* AddToCart */.o, {
                        addToCartText: ctaWithinCalculator,
                        className: "mt-[1.2rem] grow md:mt-[2.5rem]",
                        selectedVariant: selectedVariant,
                        purchaseType: "subscription",
                        selectedSellingPlan: selectedPlan
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                    className: "pt-[4rem] text-xs font-light md:pt-[0.5rem] [&_p]:mb-2 [&_p]:lg:text-xs [&_p]:lg:leading-[1.4]",
                    children: sectionSettings.disclaimerOverride || disclaimer
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/snippets/FrequencyCalculator/FrequencyCalculatorCTA.jsx






function FrequencyCalculatorCTA_FrequencyCalculatorCTA(param) {
    var linkedProductGroups = param.linkedProductGroups, product = param.product, sectionSettings = param.sectionSettings, selectedSellingPlan = param.selectedSellingPlan, selectedVariant = param.selectedVariant, setSelectedSellingPlanByID = param.setSelectedSellingPlanByID;
    var ref = (0,contexts/* useGlobalContext */.b)(), openDrawer = ref.actions.openDrawer;
    var ref1 = (0,react.useState)([]), linkedProductHandles = ref1[0], setLinkedProductHandles = ref1[1];
    (0,react.useEffect)(function() {
        if (!linkedProductGroups) {
            return;
        }
        var linkedHandles = linkedProductGroups.flatMap(function(group) {
            return group.linkedProducts.map(function(item) {
                return item.linkedProduct.handle;
            });
        });
        setLinkedProductHandles(linkedHandles);
    }, [
        linkedProductGroups
    ]);
    var settings = (0,dist.useSettings)();
    var ctaToOpenCalculator = (settings === null || settings === void 0 ? void 0 : settings.filterReplacementCalculator).ctaToOpenCalculator;
    var handleFrequencyCalculatorModal = function() {
        var ref;
        openDrawer(/*#__PURE__*/ (0,jsx_runtime.jsx)(FrequencyCalculator, {
            linkedProductHandles: linkedProductHandles,
            product: product,
            sectionSettings: sectionSettings,
            selectedSellingPlan: selectedSellingPlan,
            selectedVariant: selectedVariant,
            setSelectedSellingPlanByID: setSelectedSellingPlanByID,
            subscriptionProducts: settings === null || settings === void 0 ? void 0 : (ref = settings.subscriptions) === null || ref === void 0 ? void 0 : ref.subscriptionProducts
        }), {
            className: "frequency-calculator-modal-drawer"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "pdp-frequency-calculator-simplified mb-1 text-center md:mb-4",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            type: "button",
            onClick: function() {
                handleFrequencyCalculatorModal();
            },
            className: "cursor-pointer text-[13px] text-textLink underline md:text-base",
            children: ctaToOpenCalculator
        })
    });
}
FrequencyCalculatorCTA_FrequencyCalculatorCTA.propTypes = {
    frequencyCalculatorSettings: prop_types_default().shape({
        content: (prop_types_default()).string,
        cta: (prop_types_default()).string,
        enableFrequencyCalculator: (prop_types_default()).bool,
        product: (prop_types_default()).object,
        recommendationImage: (prop_types_default()).object,
        recommendationName: (prop_types_default()).string,
        responseMap: (prop_types_default()).array,
        selectedSellingPlan: (prop_types_default()).object,
        selectedVariant: (prop_types_default()).object,
        title: (prop_types_default()).string,
        setSelectedSellingPlanByID: (prop_types_default()).func,
        linkedProductGroups: (prop_types_default()).object
    })
};

;// CONCATENATED MODULE: ./src/snippets/FrequencyCalculator/index.js


;// CONCATENATED MODULE: ./src/snippets/RechargeSubscriptionWidget/RechargeSubscriptionWidgetDetails.jsx








function RechargeSubscriptionWidget(param) {
    var widgetContent = param.widgetContent, widgetType = param.widgetType, originalDiscountPrice = param.originalDiscountPrice, product = param.product, frequencyCalculatorSettings = param.frequencyCalculatorSettings, linkedProductGroups = param.linkedProductGroups;
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = useGlobalProductPageContext(), discount = ref5.discount, selectedVariant = ref5.selectedVariant, purchaseType = ref5.purchaseType, setPurchaseType = ref5.setPurchaseType, setSelectedSellingPlan = ref5.setSelectedSellingPlan, selectedSellingPlan = ref5.selectedSellingPlan, recommendedFilterFrequency = ref5.recommendedFilterFrequency;
    // Select the desired allocation plan by default, OR set it to the recommendedFilterFrequency
    var setSellingPlan = function(variant, frequency) {
        var ref, ref1;
        if (!frequency || !variant) {
            return;
        }
        var recommendedSellingPlan = (ref1 = (ref = variant.sellingPlanAllocations) === null || ref === void 0 ? void 0 : ref.filter(function(sellingPlan) {
            var ref;
            return ((ref = sellingPlan.sellingPlan.options[1]) === null || ref === void 0 ? void 0 : ref.value.split("-")[0]) === frequency.toString();
        })) === null || ref1 === void 0 ? void 0 : ref1[0];
        if (recommendedSellingPlan === null || recommendedSellingPlan === void 0 ? void 0 : recommendedSellingPlan.sellingPlan) {
            setSelectedSellingPlan(recommendedSellingPlan);
        } else {
            setSelectedSellingPlan(variant.sellingPlanAllocations[0]);
        }
    };
    var ref6 = useState(false), hasSetInitialFreq = ref6[0], sethasSetInitialFreq = ref6[1];
    // Run this effect when the selectedVariant changes
    useEffect(function() {
        if (!recommendedFilterFrequency || hasSetInitialFreq) return;
        setSellingPlan(selectedVariant, recommendedFilterFrequency);
        sethasSetInitialFreq(true);
    }, [
        selectedVariant
    ]);
    // Run this effect when the recommendedFilterFrequency changes
    useEffect(function() {
        if (!selectedVariant) return;
        setSellingPlan(selectedVariant, recommendedFilterFrequency);
        sethasSetInitialFreq(true);
    }, [
        recommendedFilterFrequency
    ]);
    var ref7 = useState(null), variantPrice = ref7[0], setvariantPrice = ref7[1];
    useEffect(function() {
        var ref, ref1;
        if (!(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.priceV2)) return;
        var price = parseFloat(selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.priceV2) === null || ref === void 0 ? void 0 : ref.amount);
        if (discount === null || discount === void 0 ? void 0 : discount.enableDiscount) {
            if (discount.discountType === "fixed") {
                price -= discount.discountAmount;
            } else {
                price -= price * (discount.discountAmount / 100);
            }
        }
        setvariantPrice(new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref1 = selectedVariant.priceV2) === null || ref1 === void 0 ? void 0 : ref1.currencyCode
        }).format(price));
    }, [
        selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.priceV2
    ]);
    var ref8 = useState(null), regularPrice = ref8[0], setRegularPrice = ref8[1];
    var ref9 = useState(null), comparePrice = ref9[0], setComparePrice = ref9[1];
    useEffect(function() {
        var ref, ref1;
        if (!(selectedSellingPlan === null || selectedSellingPlan === void 0 ? void 0 : selectedSellingPlan.priceAdjustments.length)) return;
        var priceAdjustment = selectedSellingPlan.priceAdjustments[0];
        if (priceAdjustment === null || priceAdjustment === void 0 ? void 0 : (ref = priceAdjustment.compareAtPrice) === null || ref === void 0 ? void 0 : ref.amount) {
            var ref2, ref3;
            setComparePrice(new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: priceAdjustment === null || priceAdjustment === void 0 ? void 0 : (ref2 = priceAdjustment.compareAtPrice) === null || ref2 === void 0 ? void 0 : ref2.currencyCode
            }).format(priceAdjustment === null || priceAdjustment === void 0 ? void 0 : (ref3 = priceAdjustment.compareAtPrice) === null || ref3 === void 0 ? void 0 : ref3.amount));
        }
        if (priceAdjustment === null || priceAdjustment === void 0 ? void 0 : (ref1 = priceAdjustment.price) === null || ref1 === void 0 ? void 0 : ref1.amount) {
            var ref4, ref5;
            var price = parseFloat(priceAdjustment === null || priceAdjustment === void 0 ? void 0 : (ref4 = priceAdjustment.price) === null || ref4 === void 0 ? void 0 : ref4.amount);
            if (discount === null || discount === void 0 ? void 0 : discount.enableDiscount) {
                if (discount.discountType === "fixed") {
                    price -= discount.discountAmount;
                } else {
                    price -= price * (discount.discountAmount / 100);
                }
            }
            setRegularPrice(new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: priceAdjustment === null || priceAdjustment === void 0 ? void 0 : (ref5 = priceAdjustment.price) === null || ref5 === void 0 ? void 0 : ref5.currencyCode
            }).format(price));
        }
    }, [
        selectedSellingPlan === null || selectedSellingPlan === void 0 ? void 0 : selectedSellingPlan.priceAdjustments
    ]);
    var ref10 = _object_spread({}, widgetContent), subscribeSaveSubText = ref10.subscribeSaveSubText, shipsNow = ref10.shipsNow, shipsRecurringly = ref10.shipsRecurringly, overrideRecurringPrice = ref10.overrideRecurringPrice, overrideRecurringPriceTitle = ref10.overrideRecurringPriceTitle, overrideSelectionText = ref10.overrideSelectionText;
    var setSelectedSellingPlanByID = function(sellingPlanID) {
        setSelectedSellingPlan(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.sellingPlanAllocations.filter(function(sellingPlan) {
            return sellingPlanID === (sellingPlan === null || sellingPlan === void 0 ? void 0 : sellingPlan.sellingPlan.id);
        })[0]);
    };
    var ref11 = useState(null), recurringPrice = ref11[0], setRecurringPrice = ref11[1];
    useEffect(function() {
        if (overrideRecurringPrice) {
            setRecurringPrice(new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD"
            }).format(overrideRecurringPrice));
        }
    }, [
        overrideRecurringPrice
    ]);
    var sellingPlanNameOverride = function(sellingPlanName) {
        if (!overrideSelectionText) return sellingPlanName;
        if (sellingPlanName.includes("Delivery every")) {
            return sellingPlanName.replace("Delivery every", overrideSelectionText);
        }
        return sellingPlanName;
    };
    var compareSellingPlans = function(a, b) {
        var frequencyA = a.sellingPlan.options[1].value.split("-")[0];
        var frequencyB = b.sellingPlan.options[1].value.split("-")[0];
        return frequencyA - frequencyB;
    };
    return /*#__PURE__*/ _jsx("div", {
        className: "recharge-subscription-widget mb-4",
        children: (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.sellingPlanAllocations) && (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.sellingPlanAllocations.length) > 0 && /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "recharge-subscription-widget__header-container flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ _jsx("h3", {
                            className: "recharge-subscription-widget__header mb-0 text-[11px] font-normal uppercase leading-6 md:mb-4 md:text-base",
                            children: "Choose Your Plan"
                        }),
                        (frequencyCalculatorSettings === null || frequencyCalculatorSettings === void 0 ? void 0 : frequencyCalculatorSettings.enableFrequencyCalculator) && /*#__PURE__*/ _jsx(FrequencyCalculatorCTA, {
                            linkedProductGroups: linkedProductGroups,
                            product: product,
                            sectionSettings: frequencyCalculatorSettings,
                            selectedSellingPlan: selectedSellingPlan,
                            selectedVariant: selectedVariant,
                            setSelectedSellingPlanByID: setSelectedSellingPlanByID
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("ul", {
                    className: "recharge-subscription-widget__options recharge-container grid grid-cols-1 gap-[20px]",
                    children: [
                        /*#__PURE__*/ _jsx("li", {
                            className: "recharge-subscription-widget__option border ".concat(purchaseType === "one-time" ? "border-2 border-primary bg-white" : "border-[#DDE2E7] bg-[#E6F0F8]"),
                            children: /*#__PURE__*/ _jsxs("label", {
                                htmlFor: "purchase_type_one-time__".concat(product.id),
                                className: "recharge-block recharge-block__one-time flex cursor-pointer items-center justify-between p-4",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex items-center",
                                        children: [
                                            /*#__PURE__*/ _jsx("input", {
                                                id: "purchase_type_one-time__".concat(product.id),
                                                type: "radio",
                                                name: "purchase_type",
                                                value: "one-time",
                                                className: "recharge-block__radio-input hidden",
                                                checked: purchaseType === "one-time",
                                                onChange: function() {
                                                    setPurchaseType("one-time");
                                                }
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "mr-4 h-[20px] w-[20px] rounded-full ".concat(purchaseType === "one-time" ? "border-[6px] border-textLink" : "border-[1px]")
                                            }),
                                            "One-time purchase"
                                        ]
                                    }),
                                    variantPrice && /*#__PURE__*/ _jsx("div", {
                                        children: variantPrice
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsxs("li", {
                            className: "recharge-subscription-widget__option border ".concat(purchaseType === "subscription" ? "border-2 border-primary bg-white" : "border-[#DDE2E7] bg-[#E6F0F8]"),
                            children: [
                                /*#__PURE__*/ _jsxs("label", {
                                    htmlFor: "purchase_type_subscription__".concat(product.id),
                                    className: "recharge-block recharge-block__autodeliver flex cursor-pointer items-center justify-between p-4",
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "mr-4 flex items-center",
                                            children: [
                                                /*#__PURE__*/ _jsx("input", {
                                                    id: "purchase_type_subscription__".concat(product.id),
                                                    type: "radio",
                                                    name: "purchase_type",
                                                    value: "subscription",
                                                    className: "recharge-block__radio-input hidden",
                                                    checked: purchaseType === "subscription",
                                                    onChange: function() {
                                                        setPurchaseType("subscription");
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "mr-4 h-[20px] w-[20px] shrink-0 rounded-full ".concat(purchaseType === "subscription" ? "border-[6px] border-textLink" : "border-[1px]")
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    children: [
                                                        "Autoship & Save",
                                                        " ",
                                                        selectedSellingPlan === null || selectedSellingPlan === void 0 ? void 0 : (ref = selectedSellingPlan.sellingPlan) === null || ref === void 0 ? void 0 : (ref1 = ref.priceAdjustments) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.adjustmentValue) === null || ref3 === void 0 ? void 0 : ref3.adjustmentPercentage,
                                                        "%",
                                                        subscribeSaveSubText && /*#__PURE__*/ _jsx("div", {
                                                            className: "block text-[#4D515D]",
                                                            children: /*#__PURE__*/ _jsx(Body, {
                                                                variant: "xs",
                                                                children: subscribeSaveSubText
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            children: /*#__PURE__*/ _jsx("div", {
                                                className: "flex",
                                                children: /*#__PURE__*/ _jsxs("div", {
                                                    className: "flex",
                                                    children: [
                                                        comparePrice && /*#__PURE__*/ _jsx("div", {
                                                            className: "text-shadowGray line-through",
                                                            children: comparePrice
                                                        }),
                                                        regularPrice && /*#__PURE__*/ _jsx("div", {
                                                            className: "ml-4",
                                                            children: regularPrice
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /* Subscription Frequency Options */ purchaseType === "subscription" && !!selectedVariant.sellingPlanAllocations.length && /*#__PURE__*/ _jsxs("div", {
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "relative p-4 before:pointer-events-none before:absolute before:right-8 before:top-5 before:scale-x-75 before:scale-y-[0.40] before:content-['▲'] after:pointer-events-none after:absolute after:bottom-5 after:right-8 after:scale-x-75 after:scale-y-[0.4] after:content-['▼'] lg:pl-12",
                                            children: /*#__PURE__*/ _jsx("select", {
                                                id: "pdp-subscription-widget",
                                                value: selectedSellingPlan === null || selectedSellingPlan === void 0 ? void 0 : (ref4 = selectedSellingPlan.sellingPlan) === null || ref4 === void 0 ? void 0 : ref4.id,
                                                onChange: function(event) {
                                                    setSelectedSellingPlanByID(event.target.value);
                                                },
                                                className: "w-full cursor-pointer appearance-none rounded-[10px] border border-primary bg-[var(--clearBlue)] px-4 py-2",
                                                children: _to_consumable_array(selectedVariant.sellingPlanAllocations).sort(compareSellingPlans).map(function(sellingPlan, sellingPlanIndex) {
                                                    var ref, ref1;
                                                    return /*#__PURE__*/ _jsx("option", {
                                                        value: sellingPlan === null || sellingPlan === void 0 ? void 0 : (ref = sellingPlan.sellingPlan) === null || ref === void 0 ? void 0 : ref.id,
                                                        children: sellingPlanNameOverride(sellingPlan === null || sellingPlan === void 0 ? void 0 : (ref1 = sellingPlan.sellingPlan) === null || ref1 === void 0 ? void 0 : ref1.name)
                                                    }, "selling-plan-".concat(sellingPlanIndex));
                                                })
                                            })
                                        }),
                                        !!widgetType && ((shipsNow === null || shipsNow === void 0 ? void 0 : shipsNow.show) || (shipsRecurringly === null || shipsRecurringly === void 0 ? void 0 : shipsRecurringly.show)) && /*#__PURE__*/ _jsx(RechargeSubscriptionWidgetDetails, {
                                            selectedVariant: selectedVariant,
                                            selectedSellingPlan: selectedSellingPlan,
                                            shipsNow: shipsNow,
                                            shipsRecurringly: shipsRecurringly,
                                            widgetType: widgetType,
                                            originalDiscountPrice: originalDiscountPrice,
                                            comparePrice: comparePrice
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                purchaseType === "subscription" && recurringPrice && recurringPrice !== regularPrice && /*#__PURE__*/ _jsxs("div", {
                    className: "mt-7",
                    children: [
                        /*#__PURE__*/ _jsx("hr", {
                            className: "border-[#DDE2E7]"
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "mt-4 text-[var(--primary)]",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "mb-2 flex justify-between text-base font-medium md:text-lg",
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            children: "Today’s Total"
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            children: regularPrice
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex justify-between text-sm font-light md:text-base",
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            children: overrideRecurringPriceTitle !== null && overrideRecurringPriceTitle !== void 0 ? overrideRecurringPriceTitle : "Recurring Price"
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            children: recurringPrice
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/snippets/RechargeSubscriptionWidget/RechargeSubscriptionWidget.jsx








function RechargeSubscriptionWidget_RechargeSubscriptionWidget(param) {
    var widgetContent = param.widgetContent, widgetType = param.widgetType, originalDiscountPrice = param.originalDiscountPrice, product = param.product, frequencyCalculatorSettings = param.frequencyCalculatorSettings, linkedProductGroups = param.linkedProductGroups;
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,globalProductPageContext/* useGlobalProductPageContext */.j)(), discount = ref5.discount, selectedVariant = ref5.selectedVariant, purchaseType = ref5.purchaseType, setPurchaseType = ref5.setPurchaseType, setSelectedSellingPlan = ref5.setSelectedSellingPlan, selectedSellingPlan = ref5.selectedSellingPlan, recommendedFilterFrequency = ref5.recommendedFilterFrequency;
    // Select the desired allocation plan by default, OR set it to the recommendedFilterFrequency
    var setSellingPlan = function(variant, frequency) {
        var ref, ref1;
        if (!frequency || !variant) {
            return;
        }
        var recommendedSellingPlan = (ref1 = (ref = variant.sellingPlanAllocations) === null || ref === void 0 ? void 0 : ref.filter(function(sellingPlan) {
            var ref;
            return ((ref = sellingPlan.sellingPlan.options[1]) === null || ref === void 0 ? void 0 : ref.value.split("-")[0]) === frequency.toString();
        })) === null || ref1 === void 0 ? void 0 : ref1[0];
        if (recommendedSellingPlan === null || recommendedSellingPlan === void 0 ? void 0 : recommendedSellingPlan.sellingPlan) {
            setSelectedSellingPlan(recommendedSellingPlan);
        } else {
            setSelectedSellingPlan(variant.sellingPlanAllocations[0]);
        }
    };
    var ref6 = (0,react.useState)(false), hasSetInitialFreq = ref6[0], sethasSetInitialFreq = ref6[1];
    // Run this effect when the selectedVariant changes
    (0,react.useEffect)(function() {
        if (!recommendedFilterFrequency || hasSetInitialFreq) return;
        setSellingPlan(selectedVariant, recommendedFilterFrequency);
        sethasSetInitialFreq(true);
    }, [
        selectedVariant
    ]);
    // Run this effect when the recommendedFilterFrequency changes
    (0,react.useEffect)(function() {
        if (!selectedVariant) return;
        setSellingPlan(selectedVariant, recommendedFilterFrequency);
        sethasSetInitialFreq(true);
    }, [
        recommendedFilterFrequency
    ]);
    var ref7 = (0,react.useState)(null), variantPrice = ref7[0], setvariantPrice = ref7[1];
    (0,react.useEffect)(function() {
        var ref, ref1;
        if (!(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.priceV2)) return;
        var price = parseFloat(selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.priceV2) === null || ref === void 0 ? void 0 : ref.amount);
        if (discount === null || discount === void 0 ? void 0 : discount.enableDiscount) {
            if (discount.discountType === "fixed") {
                price -= discount.discountAmount;
            } else {
                price -= price * (discount.discountAmount / 100);
            }
        }
        setvariantPrice(new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref1 = selectedVariant.priceV2) === null || ref1 === void 0 ? void 0 : ref1.currencyCode
        }).format(price));
    }, [
        selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.priceV2
    ]);
    var ref8 = (0,react.useState)(null), regularPrice = ref8[0], setRegularPrice = ref8[1];
    var ref9 = (0,react.useState)(null), comparePrice = ref9[0], setComparePrice = ref9[1];
    (0,react.useEffect)(function() {
        var ref, ref1;
        if (!(selectedSellingPlan === null || selectedSellingPlan === void 0 ? void 0 : selectedSellingPlan.priceAdjustments.length)) return;
        var priceAdjustment = selectedSellingPlan.priceAdjustments[0];
        if (priceAdjustment === null || priceAdjustment === void 0 ? void 0 : (ref = priceAdjustment.compareAtPrice) === null || ref === void 0 ? void 0 : ref.amount) {
            var ref2, ref3;
            setComparePrice(new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: priceAdjustment === null || priceAdjustment === void 0 ? void 0 : (ref2 = priceAdjustment.compareAtPrice) === null || ref2 === void 0 ? void 0 : ref2.currencyCode
            }).format(priceAdjustment === null || priceAdjustment === void 0 ? void 0 : (ref3 = priceAdjustment.compareAtPrice) === null || ref3 === void 0 ? void 0 : ref3.amount));
        }
        if (priceAdjustment === null || priceAdjustment === void 0 ? void 0 : (ref1 = priceAdjustment.price) === null || ref1 === void 0 ? void 0 : ref1.amount) {
            var ref4, ref5;
            var price = parseFloat(priceAdjustment === null || priceAdjustment === void 0 ? void 0 : (ref4 = priceAdjustment.price) === null || ref4 === void 0 ? void 0 : ref4.amount);
            if (discount === null || discount === void 0 ? void 0 : discount.enableDiscount) {
                if (discount.discountType === "fixed") {
                    price -= discount.discountAmount;
                } else {
                    price -= price * (discount.discountAmount / 100);
                }
            }
            setRegularPrice(new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: priceAdjustment === null || priceAdjustment === void 0 ? void 0 : (ref5 = priceAdjustment.price) === null || ref5 === void 0 ? void 0 : ref5.currencyCode
            }).format(price));
        }
    }, [
        selectedSellingPlan === null || selectedSellingPlan === void 0 ? void 0 : selectedSellingPlan.priceAdjustments
    ]);
    var ref10 = (0,src_object_spread/* default */.Z)({}, widgetContent), subscribeSaveSubText = ref10.subscribeSaveSubText, shipsNow = ref10.shipsNow, shipsRecurringly = ref10.shipsRecurringly, overrideRecurringPrice = ref10.overrideRecurringPrice, overrideRecurringPriceTitle = ref10.overrideRecurringPriceTitle, overrideSelectionText = ref10.overrideSelectionText;
    var setSelectedSellingPlanByID = function(sellingPlanID) {
        setSelectedSellingPlan(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.sellingPlanAllocations.filter(function(sellingPlan) {
            return sellingPlanID === (sellingPlan === null || sellingPlan === void 0 ? void 0 : sellingPlan.sellingPlan.id);
        })[0]);
    };
    var ref11 = (0,react.useState)(null), recurringPrice = ref11[0], setRecurringPrice = ref11[1];
    (0,react.useEffect)(function() {
        if (overrideRecurringPrice) {
            setRecurringPrice(new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD"
            }).format(overrideRecurringPrice));
        }
    }, [
        overrideRecurringPrice
    ]);
    var sellingPlanNameOverride = function(sellingPlanName) {
        if (!overrideSelectionText) return sellingPlanName;
        if (sellingPlanName.includes("Delivery every")) {
            return sellingPlanName.replace("Delivery every", overrideSelectionText);
        }
        return sellingPlanName;
    };
    var compareSellingPlans = function(a, b) {
        var frequencyA = a.sellingPlan.options[1].value.split("-")[0];
        var frequencyB = b.sellingPlan.options[1].value.split("-")[0];
        return frequencyA - frequencyB;
    };
    var handlePlanSelectClick = function() {
        document.documentElement.style.setProperty("scroll-padding", "auto");
        setTimeout(function() {
            document.documentElement.style.removeProperty("scroll-padding");
        }, 100);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "recharge-subscription-widget mb-4",
        children: (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.sellingPlanAllocations) && (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.sellingPlanAllocations.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "recharge-subscription-widget__header-container flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "recharge-subscription-widget__header mb-0 text-[11px] font-normal uppercase leading-6 md:mb-4 md:text-base",
                            children: "Choose Your Plan"
                        }),
                        (frequencyCalculatorSettings === null || frequencyCalculatorSettings === void 0 ? void 0 : frequencyCalculatorSettings.enableFrequencyCalculator) && /*#__PURE__*/ (0,jsx_runtime.jsx)(FrequencyCalculatorCTA_FrequencyCalculatorCTA, {
                            linkedProductGroups: linkedProductGroups,
                            product: product,
                            sectionSettings: frequencyCalculatorSettings,
                            selectedSellingPlan: selectedSellingPlan,
                            selectedVariant: selectedVariant,
                            setSelectedSellingPlanByID: setSelectedSellingPlanByID
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    className: "recharge-subscription-widget__options recharge-container grid grid-cols-1 gap-[20px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "recharge-subscription-widget__option border ".concat(purchaseType === "one-time" ? "border-2 border-primary bg-white" : "border-[#DDE2E7] bg-[#E6F0F8]"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                htmlFor: "purchase_type_one-time__".concat(product.id),
                                className: "recharge-block recharge-block__one-time flex cursor-pointer items-center justify-between p-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                id: "purchase_type_one-time__".concat(product.id),
                                                type: "radio",
                                                name: "purchase_type",
                                                value: "one-time",
                                                className: "recharge-block__radio-input hidden",
                                                checked: purchaseType === "one-time",
                                                onChange: function() {
                                                    setPurchaseType("one-time");
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mr-4 h-[20px] w-[20px] rounded-full ".concat(purchaseType === "one-time" ? "border-[6px] border-textLink" : "border-[1px]")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-sm md:text-base",
                                                children: "One-time purchase"
                                            })
                                        ]
                                    }),
                                    variantPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-sm md:text-base",
                                        children: variantPrice
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            className: "recharge-subscription-widget__option border ".concat(purchaseType === "subscription" ? "border-2 border-primary bg-white" : "border-[#DDE2E7] bg-[#E6F0F8]"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                    htmlFor: "purchase_type_subscription__".concat(product.id),
                                    className: "recharge-block recharge-block__autodeliver flex cursor-pointer items-center justify-between p-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "mr-4 flex items-center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    id: "purchase_type_subscription__".concat(product.id),
                                                    type: "radio",
                                                    name: "purchase_type",
                                                    value: "subscription",
                                                    className: "recharge-block__radio-input hidden",
                                                    checked: purchaseType === "subscription",
                                                    onChange: function() {
                                                        setPurchaseType("subscription");
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mr-4 h-[20px] w-[20px] shrink-0 rounded-full ".concat(purchaseType === "subscription" ? "border-[6px] border-textLink" : "border-[1px]")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: "text-sm md:text-base",
                                                            children: [
                                                                "Autoship & Save",
                                                                " ",
                                                                selectedSellingPlan === null || selectedSellingPlan === void 0 ? void 0 : (ref = selectedSellingPlan.sellingPlan) === null || ref === void 0 ? void 0 : (ref1 = ref.priceAdjustments) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.adjustmentValue) === null || ref3 === void 0 ? void 0 : ref3.adjustmentPercentage,
                                                                "%"
                                                            ]
                                                        }),
                                                        subscribeSaveSubText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "block text-[#4D515D]",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Body */.uT, {
                                                                variant: "xs",
                                                                children: subscribeSaveSubText
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex text-sm md:text-base",
                                                children: [
                                                    comparePrice && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-shadowGray line-through",
                                                        children: comparePrice
                                                    }),
                                                    regularPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "ml-4",
                                                        children: regularPrice
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /* Subscription Frequency Options */ purchaseType === "subscription" && !!selectedVariant.sellingPlanAllocations.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "relative p-4 pt-0 before:pointer-events-none before:absolute before:right-8 before:top-1 before:scale-x-75 before:scale-y-[0.40] before:content-['▲'] after:pointer-events-none after:absolute after:bottom-5 after:right-8 after:scale-x-75 after:scale-y-[0.4] after:content-['▼'] lg:pl-12",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                                                id: "pdp-subscription-widget",
                                                onMouseDown: handlePlanSelectClick,
                                                value: selectedSellingPlan === null || selectedSellingPlan === void 0 ? void 0 : (ref4 = selectedSellingPlan.sellingPlan) === null || ref4 === void 0 ? void 0 : ref4.id,
                                                onChange: function(event) {
                                                    setSelectedSellingPlanByID(event.target.value);
                                                },
                                                className: "w-full cursor-pointer appearance-none rounded-[10px] border border-primary bg-[var(--clearBlue)] px-4 py-2",
                                                children: (0,src_to_consumable_array/* default */.Z)(selectedVariant.sellingPlanAllocations).sort(compareSellingPlans).map(function(sellingPlan, sellingPlanIndex) {
                                                    var ref, ref1;
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        value: sellingPlan === null || sellingPlan === void 0 ? void 0 : (ref = sellingPlan.sellingPlan) === null || ref === void 0 ? void 0 : ref.id,
                                                        children: sellingPlanNameOverride(sellingPlan === null || sellingPlan === void 0 ? void 0 : (ref1 = sellingPlan.sellingPlan) === null || ref1 === void 0 ? void 0 : ref1.name)
                                                    }, "selling-plan-".concat(sellingPlanIndex));
                                                })
                                            })
                                        }),
                                        !!widgetType && widgetType !== "featured" && ((shipsNow === null || shipsNow === void 0 ? void 0 : shipsNow.show) || (shipsRecurringly === null || shipsRecurringly === void 0 ? void 0 : shipsRecurringly.show)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(RechargeSubscriptionWidgetDetails_namespaceObject.RechargeSubscriptionWidgetDetails, {
                                            selectedVariant: selectedVariant,
                                            selectedSellingPlan: selectedSellingPlan,
                                            shipsNow: shipsNow,
                                            shipsRecurringly: shipsRecurringly,
                                            widgetType: widgetType,
                                            originalDiscountPrice: originalDiscountPrice,
                                            comparePrice: comparePrice
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                purchaseType === "subscription" && recurringPrice && recurringPrice !== regularPrice && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-7",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                            className: "border-[#DDE2E7]"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-4 text-[var(--primary)]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mb-2 flex justify-between text-base font-medium md:text-lg",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "Today’s Total"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: regularPrice
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex justify-between text-sm font-light md:text-base",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: overrideRecurringPriceTitle !== null && overrideRecurringPriceTitle !== void 0 ? overrideRecurringPriceTitle : "Recurring Price"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: recurringPrice
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 7804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* reexport */ Spinner; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(3615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/snippets/Spinner/Spinner.jsx


function Spinner(param) {
    var className = param.className, _width = param.width, width = _width === void 0 ? 20 : _width, _stroke = param.stroke, stroke = _stroke === void 0 ? "currentColor" : _stroke;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        className: className,
        fill: "none",
        height: "".concat(width),
        role: "img",
        stroke: stroke,
        strokeWidth: "4",
        viewBox: "0 0 32 32",
        width: "".concat(width),
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Loading"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "16",
                cy: "16",
                fill: "none",
                opacity: "0.125",
                r: "12",
                strokeWidth: "4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "16",
                cy: "16",
                fill: "none",
                r: "12",
                strokeDasharray: "20 110",
                strokeWidth: "4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("animateTransform", {
                    attributeName: "transform",
                    attributeType: "XML",
                    dur: "750ms",
                    from: "0 16 16",
                    repeatCount: "indefinite",
                    to: "360 16 16",
                    type: "rotate"
                })
            })
        ]
    });
}
Spinner.displayName = "Spinner";
Spinner.propTypes = {
    className: (prop_types_default()).string,
    width: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).number
    ]),
    stroke: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./src/snippets/Spinner/index.js



/***/ }),

/***/ 989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ Svg; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(169);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1373);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7378);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);






var Svg = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var src = _param.src, title = _param.title, viewBox = _param.viewBox, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "src",
        "title",
        "viewBox"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        ref: ref,
        viewBox: viewBox,
        className: "h-full w-full"
    }, props), {
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("use", {
                href: src,
                className: "pointer-events-none"
            })
        ]
    }));
});
Svg.displayName = "Svg";
Svg.propTypes = {
    src: function src(props, propName, componentName) {
        if (!props[propName]) {
            return new Error("The prop `".concat(propName, "` is marked as required in `").concat(componentName, "`, but its value is `").concat(props[propName], "`."));
        }
        if (!/.+#[a-zA-Z][a-zA-Z0-9-_:.]+$/.test(props[propName])) {
            return new Error("Invalid prop `".concat(propName, "` supplied to' `").concat(componentName, "`. Must end with `#` followed by the `id` attributed to the svg, e.g. `icon-name.svg#icon-name`."));
        }
        return undefined;
    },
    title: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    viewBox: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string.isRequired)
};


/***/ }),

/***/ 7342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* reexport safe */ _Svg__WEBPACK_IMPORTED_MODULE_0__.n; }
/* harmony export */ });
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(989);



/***/ }),

/***/ 8544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Eyebrow; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);


function Eyebrow(props) {
    var _Element = props.Element, Element = _Element === void 0 ? "p" : _Element, className = props.className, children = props.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Element, {
        className: "font-sans text-[0.813rem] font-[200] leading-[1.113rem] tracking-[4%] lg:text-[1.125rem] lg:leading-[1.54rem] ".concat(className),
        children: children
    });
}
Eyebrow.propTypes = {
    Element: prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOf([
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "p"
    ]),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().node.isRequired)
};


/***/ }),

/***/ 6856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Headline; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7378);



function Headline(props) {
    var variant = props.variant, element = props.element, className = props.className, children = props.children, onClick = props.onClick, style = props.style;
    var Element = element || variant;
    var variants = {
        h1: "text-[2.625rem] leading-[2.625rem] lg:text-[4rem] lg:leading-[4.8rem]",
        h2: "text-[1.875rem] leading-[2.1rem] lg:text-[3.5rem] lg:leading-[4.55rem]",
        h3: "text-[1.625rem] leading-[2.113rem] lg:text-[2.625rem] lg:leading-[3.413rem]",
        h4: "text-[1.375rem] leading-[1.788rem] lg:text-[2.25rem] lg:leading-[2.925rem]",
        h5: "text-[1.25rem] leading-[1.5rem] lg:text-[1.75rem] lg:leading-[2.275rem]",
        h6: "text-[1.125rem] leading-[1.5rem] lg:text-[1.25rem] lg:leading-[1.75rem]"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Element, {
        onClick: onClick,
        className: "font-sans font-light tracking-[-0.02em] ".concat(variants[variant], " ").concat(className),
        style: style,
        children: children
    });
}
Headline.propTypes = {
    className: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
    variant: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf([
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6"
    ]),
    element: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf([
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6"
    ]),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().node.isRequired)
};


/***/ }),

/***/ 9221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Subheading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7378);



function Subheading(props) {
    var variant = props.variant, element = props.element, children = props.children, className = props.className;
    var Element = element || "p";
    var variants = {
        large: "tracking-[-1%] text-[1.25rem] leading-[1.625rem] lg:text-[1.375rem] lg:leading-[1.788rem]",
        medium: "tracking-[-1%] text-[1.125rem] leading-[1.463rem] lg:text-[1.25rem] lg:leading-[1.625rem]",
        small: "text-[1rem] leading-[1.4rem] lg:text-[1.125rem] lg:leading-[1.575rem]"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Element, {
        className: "font-sans font-light ".concat(variants[variant], " ").concat(className),
        children: children
    });
}
Subheading.propTypes = {
    variant: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf([
        "large",
        "medium",
        "small"
    ]),
    element: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf([
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "p"
    ]),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().node.isRequired)
};


/***/ }),

/***/ 7373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Fh": function() { return /* reexport */ AltText; },
  "uT": function() { return /* reexport */ Body; },
  "j4": function() { return /* reexport */ Eyebrow/* default */.Z; },
  "s0": function() { return /* reexport */ Headline/* default */.Z; },
  "pm": function() { return /* reexport */ Subheading/* default */.Z; }
});

// UNUSED EXPORTS: Hero

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(3615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/snippets/Typography/AltText.jsx


function AltText(props) {
    var _Element = props.Element, Element = _Element === void 0 ? "p" : _Element, children = props.children, className = props.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Element, {
        className: "font-mono text-[0.625rem] font-normal leading-[0.888rem] tracking-[0.04em] lg:text-[1rem] lg:leading-[1.243rem] ".concat(className),
        children: children
    });
}
AltText.propTypes = {
    className: (prop_types_default()).string,
    Element: prop_types_default().oneOf([
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "p"
    ]),
    children: (prop_types_default()).node.isRequired
};

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
;// CONCATENATED MODULE: ./src/snippets/Typography/Body.jsx



function Body(props) {
    var variant = props.variant, element = props.element, className = props.className, children = props.children;
    var Element = element || "p";
    var variants = {
        large: "text-[1rem] leading-[1.4rem] lg:text-[1.25rem] lg:leading-[1.75rem]",
        medium: "text-[0.875rem] leading-[1.225rem] lg:text-[1.125rem] lg:leading-[1.406rem]",
        small: "text-[0.75rem] leading-[1.05rem] lg:text-[1rem] lg:leading-[1.4rem]",
        xs: "text-[0.625rem] leading-[0.938rem] lg:text-[0.875rem] lg:leading-[1.313rem]"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Element, {
        className: "font-sans font-light ".concat(variants[variant], " ").concat(className),
        children: children
    });
}
Body.propTypes = {
    variant: prop_types_default().oneOf([
        "large",
        "medium",
        "small",
        "xs"
    ]),
    element: prop_types_default().oneOf([
        "p",
        "span",
        "div",
        "li"
    ]),
    children: (prop_types_default()).node.isRequired
};

// EXTERNAL MODULE: ./src/snippets/Typography/Eyebrow.jsx
var Eyebrow = __webpack_require__(8544);
// EXTERNAL MODULE: ./src/snippets/Typography/Headline.jsx
var Headline = __webpack_require__(6856);
;// CONCATENATED MODULE: ./src/snippets/Typography/Hero.jsx



function Hero(props) {
    var variant = props.variant, element = props.element, children = props.children;
    var Element = element || variant;
    var variants = {
        h1: "text-[2.625rem] leading-[2.625rem] lg:text-[5.625rem] lg:leading-[5.625rem]"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Element, {
        className: "font-sans font-light tracking-[-2%] ".concat(variants[variant]),
        children: children
    });
}
Hero.propTypes = {
    variant: prop_types_default().oneOf([
        "h1"
    ]).isRequired,
    element: prop_types_default().oneOf([
        "h1",
        "h2",
        "h3",
        "h4",
        "h5"
    ]),
    children: (prop_types_default()).node.isRequired
};

// EXTERNAL MODULE: ./src/snippets/Typography/Subheading.jsx
var Subheading = __webpack_require__(9221);
;// CONCATENATED MODULE: ./src/snippets/Typography/index.js








/***/ }),

/***/ 1790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "mR": function() { return /* reexport */ Account; },
  "o4": function() { return /* reexport */ AddToCart/* AddToCart */.o; },
  "Fh": function() { return /* reexport */ Typography/* AltText */.Fh; },
  "Yf": function() { return /* reexport */ ArticleTableOfContents; },
  "xn": function() { return /* reexport */ Attribution; },
  "a9": function() { return /* reexport */ Badges/* Badges */.a; },
  "uT": function() { return /* reexport */ Typography/* Body */.uT; },
  "zx": function() { return /* reexport */ Button/* Button */.zx; },
  "lr": function() { return /* reexport */ Carousel/* default */.Z; },
  "AP": function() { return /* reexport */ Cart; },
  "V": function() { return /* reexport */ CartPage; },
  "FE": function() { return /* reexport */ Collection; },
  "Ov": function() { return /* reexport */ ContaminantResultCard; },
  "gO": function() { return /* reexport */ ContaminantResultCardPrint; },
  "WJ": function() { return /* reexport */ DataLayer; },
  "dy": function() { return /* reexport */ Drawer; },
  "j4": function() { return /* reexport */ Typography/* Eyebrow */.j4; },
  "$_": function() { return /* reexport */ Footer; },
  "h4": function() { return /* reexport */ Header; },
  "s0": function() { return /* reexport */ Typography/* Headline */.s0; },
  "Ee": function() { return /* reexport */ Image/* Image */.E; },
  "rU": function() { return /* reexport */ Link/* Link */.r; },
  "UG": function() { return /* reexport */ Markdown/* Markdown */.U; },
  "u_": function() { return /* reexport */ Modal; },
  "aV": function() { return /* reexport */ Overlay; },
  "KW": function() { return /* reexport */ Pandectes; },
  "JM": function() { return /* reexport */ PlayButton; },
  "Cd": function() { return /* reexport */ ProductItem; },
  "Hm": function() { return /* reexport */ ReviewStars; },
  "Hb": function() { return /* reexport */ SchemaMarkup; },
  "KC": function() { return /* reexport */ Scripts; },
  "ol": function() { return /* reexport */ Search; },
  "Ph": function() { return /* reexport */ Select; },
  "$j": function() { return /* reexport */ Spinner/* Spinner */.$; },
  "wI": function() { return /* reexport */ StorefrontHead; },
  "pm": function() { return /* reexport */ Typography/* Subheading */.pm; },
  "J": function() { return /* reexport */ Superfiliate; },
  "ny": function() { return /* reexport */ Svg/* Svg */.n; },
  "pV": function() { return /* reexport */ TestVariant; },
  "sE": function() { return /* reexport */ ThreeTilesRow; },
  "qV": function() { return /* reexport */ Upsellit; },
  "mm": function() { return /* reexport */ VisuallyIo; }
});

// UNUSED EXPORTS: Beam, Hero, ProductCta, ProductStars

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../node_modules/@backpackjs/storefront/dist/index.js
var dist = __webpack_require__(2031);
// EXTERNAL MODULE: ./src/contexts/index.js + 1 modules
var contexts = __webpack_require__(8249);
// EXTERNAL MODULE: ./src/snippets/Svg/index.js
var Svg = __webpack_require__(7342);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(3842);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(5556);
// EXTERNAL MODULE: ./src/hooks/useMultipass.js
var useMultipass = __webpack_require__(5601);
// EXTERNAL MODULE: ./src/snippets/Button/index.js + 2 modules
var Button = __webpack_require__(7388);
// EXTERNAL MODULE: ./src/snippets/Link/index.js + 1 modules
var Link = __webpack_require__(7227);
// EXTERNAL MODULE: ./src/snippets/Typography/index.js + 3 modules
var Typography = __webpack_require__(7373);
;// CONCATENATED MODULE: ./src/snippets/Account/AccountMenu.jsx












function AccountMenu(param) {
    var setActiveForm = param.setActiveForm;
    var ref, ref1;
    var settings = (0,dist.useSettings)();
    var customer = (0,dist.useCustomer)();
    var customerLogout = (0,dist.useCustomerLogout)().customerLogout;
    var ref2 = (0,contexts/* useGlobalContext */.b)(), closeAccount = ref2.actions.closeAccount;
    var multipass = (0,useMultipass/* useMultipass */.q)();
    var isSubscriber = customer === null || customer === void 0 ? void 0 : (ref = customer.tags) === null || ref === void 0 ? void 0 : ref.filter(function(str) {
        return typeof str === "string" && str.indexOf("Active Subscriber") === 0 || typeof str === "string" && str.indexOf("Inactive Subscriber") === 0 || typeof str === "string" && str.indexOf("Recharge Subscriber") === 0;
    });
    var flyoutMenuItems = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref1 = settings.account) === null || ref1 === void 0 ? void 0 : ref1.menu).flyoutMenuItems;
    var menuItems = flyoutMenuItems === null || flyoutMenuItems === void 0 ? void 0 : flyoutMenuItems.filter(function(item) {
        var ref;
        if ((isSubscriber === null || isSubscriber === void 0 ? void 0 : isSubscriber.length) === 0 && (item === null || item === void 0 ? void 0 : (ref = item.link) === null || ref === void 0 ? void 0 : ref.url) === "https://www.clearlyfiltered.com/tools/recurring/portal/") {
            return;
        }
        return item;
    }).map(function(item) {
        var link = item.link;
        return link;
    });
    (0,react.useEffect)(function() {
        if (!customer) {
            setActiveForm("login");
        }
    }, [
        customer
    ]);
    var handleLogout = function() {
        customerLogout();
        closeAccount();
    };
    var handleMenuItemClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e, url) {
            var res;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!url.includes("/tools/recurring/")) return [
                            3,
                            2
                        ];
                        e.preventDefault();
                        return [
                            4,
                            multipass.generateUrl({
                                customer: {
                                    email: customer === null || customer === void 0 ? void 0 : customer.email
                                },
                                returnTo: "https://shop.clearlyfiltered.com/tools/recurring/login"
                            })
                        ];
                    case 1:
                        res = _state.sent();
                        if (res === null || res === void 0 ? void 0 : res.url) {
                            window.location.href = res.url;
                        }
                        _state.label = 2;
                    case 2:
                        closeAccount();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleMenuItemClick(e, url) {
            return _ref.apply(this, arguments);
        };
    }();
    return customer && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col overflow-y-auto rounded px-4 py-3 md:px-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Headline */.s0, {
                variant: "h5",
                className: "lg:max-w-[350px]",
                children: [
                    "Welcome Back",
                    customer.firstName && ", ".concat(customer.firstName)
                ]
            }),
            menuItems && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "mt-8",
                children: menuItems.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* Link */.r, {
                            className: "mt-4 flex items-center justify-between border-b border-[#DDE2E7] pb-4 text-sm font-normal no-underline",
                            href: item.url,
                            newTab: item.newTab,
                            onClick: function(e) {
                                return handleMenuItemClick(e, item.url);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-lg",
                                    children: item.text
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                                    className: "w-5 text-text",
                                    src: "/svgs/arrow-right.svg#arrow-right",
                                    title: "Close",
                                    viewBox: "0 0 24 24"
                                })
                            ]
                        })
                    }, item.url);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                theme: "primary",
                variant: "filled",
                href: "/account/address-book",
                className: "mx-auto mt-12 flex w-full max-w-[210px] items-center justify-center",
                onClick: function() {
                    return closeAccount();
                },
                children: "Go to My Account"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                "aria-label": "Cancel",
                className: "mt-6 text-center text-sm font-light tracking-[-.01em]",
                onClick: function() {
                    return handleLogout();
                },
                type: "button",
                children: [
                    "Not ",
                    customer.firstName,
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-underline",
                        children: "Log Out"
                    })
                ]
            })
        ]
    });
}
AccountMenu.displayName = "AccountMenu";

// EXTERNAL MODULE: ../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(8039);
// EXTERNAL MODULE: ./src/snippets/Spinner/index.js + 1 modules
var Spinner = __webpack_require__(7804);
// EXTERNAL MODULE: ./src/hooks/index.js + 36 modules
var hooks = __webpack_require__(4068);
// EXTERNAL MODULE: ./src/utils/index.js + 4 modules
var utils = __webpack_require__(714);
;// CONCATENATED MODULE: ./src/snippets/Account/CreateAccount.jsx













function CreateAccount(param) {
    var setActiveForm = param.setActiveForm;
    var ref;
    var sendRegisterEvent = (0,hooks/* useDataLayerActions */.KZ)().sendRegisterEvent;
    var ref1 = (0,dist.useCustomerCreate)(), customerCreate = ref1.customerCreate, customerErrors = ref1.errors, finished = ref1.finished, reset = ref1.reset, resetTimer = ref1.resetTimer, setErrors = ref1.setErrors, started = ref1.started, success = ref1.success;
    var settings = (0,dist.useSettings)();
    var ref2 = (0,index_esm/* useForm */.cI)(), register = ref2.register, handleSubmit = ref2.handleSubmit, errors = ref2.formState.errors;
    var ref3 = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.account) === null || ref === void 0 ? void 0 : ref.register), flyoutHeading = ref3.flyoutHeading, subheading = ref3.subheading, loginText = ref3.loginText, loginLinkText = ref3.loginLinkText;
    var regex = /_([^_]+)_/g;
    var heading = flyoutHeading === null || flyoutHeading === void 0 ? void 0 : flyoutHeading.replace(regex, '<span class="text-[#202635] opacity-50">$1</span>');
    var buttonText = (0,react.useMemo)(function() {
        if (finished) {
            resetTimer.current = setTimeout(function() {
                if (reset) reset();
                clearTimeout(resetTimer.current);
            }, 3000);
            return success ? "Account Created" : "Failed";
        }
        return started ? "Creating Account" : "Create Account";
    }, [
        finished,
        started,
        success
    ]);
    var handleCustomerCreate = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var name, lastName, email, password, passwordConfirm;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (started) return [
                            2
                        ];
                        name = data.name, lastName = data.lastName, email = data.email, password = data.password, passwordConfirm = data.passwordConfirm;
                        (0,utils/* trackTripleWhaleContact */.p1)({
                            email: email
                        });
                        if (password !== passwordConfirm) {
                            setErrors([
                                "Passwords do not match. Please try again."
                            ]);
                            if (finished) {
                                resetTimer.current = setTimeout(function() {
                                    if (reset) reset();
                                    clearTimeout(resetTimer.current);
                                }, 3000);
                            }
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            customerCreate({
                                firstName: name,
                                lastName: lastName,
                                email: email,
                                password: password,
                                acceptsMarketing: false
                            })
                        ];
                    case 1:
                        _state.sent();
                        sendRegisterEvent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(), [
        finished,
        reset,
        started
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col overflow-y-auto rounded p-40 px-4 pt-3 md:px-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                variant: "h5",
                className: "lg:max-w-[350px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    dangerouslySetInnerHTML: {
                        __html: heading
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-2 text-left text-sm font-light",
                children: subheading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: "mx-auto mt-6 flex w-full flex-col gap-4",
                onSubmit: handleSubmit(handleCustomerCreate),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        className: "relative flex w-full flex-col-reverse gap-x-1 gap-y-1.5 justify-self-stretch",
                        htmlFor: "firstName",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                className: "w-full !min-w-0 border border-[#DDE2E7] px-3 py-[19px] text-sm font-light !outline-0 ".concat(errors.lastName ? "!border-[#ED7C5C] !text-[#ED7C5C]" : null),
                                name: "firstName",
                                placeholder: "first name",
                                type: "text"
                            }, register("name", {
                                required: true,
                                maxLength: 80
                            }))),
                            errors.name && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "absolute right-4 top-1/2 -translate-y-1/2 transform",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                                    className: "w-5 text-text",
                                    src: "/svgs/error.svg#error",
                                    title: "Error icon",
                                    viewBox: "0 0 16 16"
                                })
                            })
                        ]
                    }),
                    errors.name && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[14px] text-[#ED7C5C]",
                        children: "*Please enter a first name"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        className: "relative flex w-full flex-col-reverse gap-x-1 gap-y-1.5 justify-self-stretch",
                        htmlFor: "lastName",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                className: "w-full !min-w-0 border border-[#DDE2E7] px-3 py-[19px] text-sm font-light !outline-0 ".concat(errors.lastName ? "!border-[#ED7C5C] !text-[#ED7C5C]" : null),
                                name: "lastName",
                                placeholder: "last name",
                                type: "text"
                            }, register("lastName", {
                                required: true,
                                maxLength: 100
                            }))),
                            errors.lastName && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "absolute right-4 top-1/2 -translate-y-1/2 transform",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                                    className: "w-5 text-text",
                                    src: "/svgs/error.svg#error",
                                    title: "Error icon",
                                    viewBox: "0 0 16 16"
                                })
                            })
                        ]
                    }),
                    errors.lastName && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[14px] text-[#ED7C5C]",
                        children: "*Please enter a last name"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        className: "relative flex w-full flex-col-reverse gap-x-1 gap-y-1.5 justify-self-stretch",
                        htmlFor: "email",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                className: "w-full !min-w-0 border border-[#DDE2E7] px-3 py-[19px] text-sm font-light !outline-0 ".concat(errors.email ? "!border-[#ED7C5C] !text-[#ED7C5C]" : null),
                                name: "email",
                                placeholder: "email",
                                type: "text"
                            }, register("email", {
                                required: true,
                                pattern: /^\S+@\S+$/i
                            }))),
                            errors.email && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "absolute right-4 top-1/2 -translate-y-1/2 transform",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                                    className: "w-5 text-text",
                                    src: "/svgs/error.svg#error",
                                    title: "Error icon",
                                    viewBox: "0 0 16 16"
                                })
                            })
                        ]
                    }),
                    errors.email && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[14px] text-[#ED7C5C]",
                        children: "*Please enter a valid email address"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        className: "relative flex w-full flex-col-reverse gap-x-1 gap-y-1.5 justify-self-stretch",
                        htmlFor: "password",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                className: "w-full !min-w-0 border border-[#DDE2E7] px-3 py-[19px] text-sm font-light !outline-0 ".concat(errors.password ? "!border-[#ED7C5C] !text-[#ED7C5C]" : null),
                                name: "password",
                                placeholder: "password",
                                type: "password"
                            }, register("password", {
                                required: true
                            }))),
                            errors.password && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "absolute right-4 top-1/2 -translate-y-1/2 transform",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                                    className: "w-5 text-text",
                                    src: "/svgs/error.svg#error",
                                    title: "Error icon",
                                    viewBox: "0 0 16 16"
                                })
                            })
                        ]
                    }),
                    errors.password && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[14px] text-[#ED7C5C]",
                        children: "*Please enter a password"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        className: "relative flex w-full flex-col-reverse gap-x-1 gap-y-1.5 justify-self-stretch",
                        htmlFor: "passwordConfirm",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                className: "w-full !min-w-0 border border-[#DDE2E7] px-3 py-[19px] text-sm font-light !outline-0 ".concat(errors.passwordConfirm ? "!border-[#ED7C5C] !text-[#ED7C5C]" : null),
                                name: "passwordConfirm",
                                placeholder: "password confirm",
                                type: "password"
                            }, register("passwordConfirm", {
                                required: true
                            }))),
                            errors.passwordConfirm && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "absolute right-4 top-1/2 -translate-y-1/2 transform",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                                    className: "w-5 text-text",
                                    src: "/svgs/error.svg#error",
                                    title: "Error icon",
                                    viewBox: "0 0 16 16"
                                })
                            })
                        ]
                    }),
                    errors.passwordConfirm && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[14px] text-[#ED7C5C]",
                        children: "*Please confirm your password"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                        theme: "primary",
                        variant: "filled",
                        type: "submit",
                        className: "mx-auto mt-12 flex w-full max-w-[210px] items-center justify-center",
                        children: started ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {}) : "Create Account"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                "aria-label": "Log In",
                className: "mt-6 text-center text-sm font-light tracking-[-.01em]",
                onClick: function() {
                    return setActiveForm("login");
                },
                type: "button",
                children: [
                    loginText,
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-underline",
                        children: loginLinkText
                    })
                ]
            }),
            (customerErrors === null || customerErrors === void 0 ? void 0 : customerErrors.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "mt-4 flex flex-col items-center gap-1",
                children: customerErrors.map(function(error, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "text-center text-[14px] text-[#ED7C5C]",
                        children: error
                    }, index);
                })
            })
        ]
    });
}
CreateAccount.displayName = "CreateAccount";

;// CONCATENATED MODULE: ./src/snippets/Account/ForgotPassword.jsx











function ForgotPassword(param) {
    var setActiveForm = param.setActiveForm;
    var ref;
    var ref1 = (0,dist.useCustomerRecoverPassword)(), finished = ref1.finished, recoverPassword = ref1.recoverPassword, reset = ref1.reset, resetTimer = ref1.resetTimer, started = ref1.started, success = ref1.success;
    var settings = (0,dist.useSettings)();
    var ref2 = (0,react.useState)(""), message = ref2[0], setMessage = ref2[1];
    var ref3 = (0,index_esm/* useForm */.cI)(), register = ref3.register, handleSubmit = ref3.handleSubmit, errors = ref3.formState.errors;
    var ref4 = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.account) === null || ref === void 0 ? void 0 : ref.forgot), heading = ref4.heading, postSubmissionText = ref4.postSubmissionText, subtext = ref4.subtext;
    var buttonText = (0,react.useMemo)(function() {
        if (finished) {
            resetTimer.current = setTimeout(function() {
                if (reset) reset();
                clearTimeout(resetTimer.current);
            }, 3000);
            return success ? "Submitted" : "Submitted";
        }
        return started ? "Submitting" : "Submit";
    }, [
        finished,
        started,
        success
    ]);
    var handleRecoverPassword = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var email;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        email = data.email;
                        return [
                            4,
                            recoverPassword({
                                email: email
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    (0,react.useEffect)(function() {
        if (finished) {
            setMessage(postSubmissionText);
        }
    }, [
        finished
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col overflow-y-auto rounded px-4 py-3 md:px-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                variant: "h5",
                className: "lg:max-w-[350px]",
                children: heading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-6 text-left text-sm font-light",
                children: subtext
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: "mx-auto mt-6 flex w-full flex-col gap-4",
                onSubmit: handleSubmit(handleRecoverPassword),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        className: "relative flex w-full flex-col-reverse gap-x-1 gap-y-1.5 justify-self-stretch",
                        htmlFor: "email",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                className: "w-full !min-w-0 border border-[#DDE2E7] px-3 py-[19px] text-sm font-light !outline-0 ".concat(errors.email ? "!border-[#ED7C5C]" : null, " ").concat(message ? "!border-[#5ABE8A] !text-[#5ABE8A]" : null),
                                name: "email",
                                placeholder: "email",
                                type: "text"
                            }, register("email", {
                                required: true,
                                pattern: /^\S+@\S+$/i
                            }))),
                            message && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "absolute right-4 top-1/2 -translate-y-1/2 transform",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                                    className: "w-5 text-text",
                                    src: "/svgs/green-checkmark.svg#checkmark",
                                    title: "Success icon",
                                    viewBox: "0 0 18 18"
                                })
                            })
                        ]
                    }),
                    errors.email && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[14px] text-[#ED7C5C]",
                        children: "*Please enter a valid email address"
                    }),
                    message && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[14px] text-[#5ABE8A]",
                        children: "Success! Please check your email"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                        theme: "primary",
                        variant: "filled",
                        type: "submit",
                        className: "mx-auto mt-12 flex w-full max-w-[210px] items-center justify-center",
                        children: started ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {}) : "Submit"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: "mt-6 text-center text-sm font-light tracking-[-.01em]",
                onClick: function() {
                    return setActiveForm("login");
                },
                type: "button",
                children: [
                    "Already a member?",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-underline font-base",
                        children: "Log In"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: "mt-6 text-center text-sm font-light tracking-[-.01em]",
                onClick: function() {
                    return setActiveForm("create");
                },
                type: "button",
                children: [
                    "Don‘t have an account?",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-underline font-base",
                        children: "Sign Up"
                    })
                ]
            })
        ]
    });
}
ForgotPassword.displayName = "ForgotPasswordForm";

// EXTERNAL MODULE: ./src/snippets/Account/passwordless-login.jsx
var passwordless_login = __webpack_require__(3263);
;// CONCATENATED MODULE: ./src/snippets/Account/Login.jsx













function Login(param) {
    var setActiveForm = param.setActiveForm;
    var ref;
    var sendLogInEvent = (0,hooks/* useDataLayerActions */.KZ)().sendLogInEvent;
    var settings = (0,dist.useSettings)();
    var ref1 = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.account) === null || ref === void 0 ? void 0 : ref.login), flyoutHeading = ref1.flyoutHeading, subheading = ref1.subheading, forgotText = ref1.forgotText, createText = ref1.createText, createLinkText = ref1.createLinkText, unidentifiedCustomerText = ref1.unidentifiedCustomerText;
    var regex = /_([^_]+)_/g;
    var heading = flyoutHeading === null || flyoutHeading === void 0 ? void 0 : flyoutHeading.replace(regex, '<span class="text-[#202635] opacity-50">$1</span>');
    var ref2 = (0,dist.useCustomerLogin)(), customerLogin = ref2.customerLogin, started = ref2.started, finished = ref2.finished, loginErrors = ref2.errors, success = ref2.success, reset = ref2.reset, resetTimer = ref2.resetTimer;
    var ref3 = (0,index_esm/* useForm */.cI)(), register = ref3.register, handleSubmit = ref3.handleSubmit, errors = ref3.formState.errors;
    var buttonText = (0,react.useMemo)(function() {
        if (finished) {
            resetTimer.current = setTimeout(function() {
                if (reset) reset();
                clearTimeout(resetTimer.current);
            }, 3000);
            return success ? "Logged In" : "Failed";
        }
        return started ? "Logging In" : "Log In";
    }, [
        started,
        success,
        finished
    ]);
    var handleLogin = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var email, password;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (started) return [
                            2
                        ];
                        email = data.email, password = data.password;
                        return [
                            4,
                            customerLogin({
                                email: email,
                                password: password
                            })
                        ];
                    case 1:
                        _state.sent();
                        sendLogInEvent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(), [
        started
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col overflow-y-auto rounded px-4 pb-40 pt-3 md:px-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                variant: "h5",
                className: "lg:max-w-[350px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    dangerouslySetInnerHTML: {
                        __html: heading
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-2 text-left text-sm font-light",
                children: subheading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "my-12",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(passwordless_login/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-4 flex items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                        className: "grow border-[var(--text)]"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Body */.uT, {
                        variant: "medium",
                        className: "px-4 text-center",
                        children: "or use your password"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                        className: "grow border-[var(--text)]"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: "mx-auto flex w-full flex-col gap-4",
                onSubmit: handleSubmit(handleLogin),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        className: "relative flex w-full flex-col-reverse gap-x-1 gap-y-1.5 justify-self-stretch",
                        htmlFor: "email",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                className: "text-md w-full !min-w-0 border border-[#DDE2E7] px-3 py-[19px] font-light !outline-0 ".concat(errors.email ? "!border-[#ED7C5C] !text-[#ED7C5C]" : null),
                                name: "email",
                                placeholder: "email",
                                type: "text"
                            }, register("email", {
                                required: true,
                                pattern: /^\S+@\S+$/i
                            }))),
                            errors.email && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "absolute right-4 top-1/2 -translate-y-1/2 transform",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                                    className: "w-5 text-text",
                                    src: "/svgs/error.svg#error",
                                    title: "Error icon",
                                    viewBox: "0 0 16 16"
                                })
                            })
                        ]
                    }),
                    errors.email && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[14px] text-[#ED7C5C]",
                        children: "*Please enter a valid email address"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        className: "relative flex w-full flex-col-reverse gap-x-1 gap-y-1.5 justify-self-stretch",
                        htmlFor: "password",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                className: "text-md w-full !min-w-0 border border-[#DDE2E7] px-3 py-[19px] font-light !outline-0 ".concat(errors.password ? "!border-[#ED7C5C] !text-[#ED7C5C]" : null),
                                name: "password",
                                placeholder: "••••••••",
                                type: "password"
                            }, register("password", {
                                required: true
                            }))),
                            errors.password && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "absolute right-4 top-1/2 -translate-y-1/2 transform",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                                    className: "w-5 text-text",
                                    src: "/svgs/error.svg#error",
                                    title: "Error icon",
                                    viewBox: "0 0 16 16"
                                })
                            })
                        ]
                    }),
                    errors.password && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[14px] text-[#ED7C5C]",
                        children: "*Please enter a password"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                        theme: "primary",
                        variant: "filled",
                        type: "submit",
                        className: "mx-auto mt-12 flex w-full max-w-[210px] items-center justify-center",
                        children: started ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {}) : buttonText
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                "aria-label": "Forgot Password?",
                className: "mt-6 text-center text-sm font-light tracking-[-.01em] underline",
                onClick: function() {
                    return setActiveForm("password");
                },
                type: "button",
                children: forgotText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                "aria-label": "Sign Up",
                className: "mt-6 text-center text-sm font-light tracking-[-.01em]",
                onClick: function() {
                    return setActiveForm("create");
                },
                type: "button",
                children: [
                    createText,
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-underline font-base",
                        children: createLinkText
                    })
                ]
            }),
            (loginErrors === null || loginErrors === void 0 ? void 0 : loginErrors.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "mt-4 flex flex-col items-center gap-1",
                children: loginErrors.map(function(error, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "text-center text-[14px] text-[#ED7C5C]",
                        children: error === "Unidentified customer" ? unidentifiedCustomerText : error
                    }, index);
                })
            })
        ]
    });
}
Login.displayName = "LoginForm";

;// CONCATENATED MODULE: ./src/snippets/Account/Account.jsx









function Account(param) {
    var promobarHidden = param.promobarHidden;
    var ref = (0,contexts/* useGlobalContext */.b)(), accountOpen = ref.state.accountOpen, closeAccount = ref.actions.closeAccount;
    var customer = (0,dist.useCustomer)();
    var ref1 = (0,react.useState)("login"), activeForm = ref1[0], setActiveForm = ref1[1];
    (0,react.useEffect)(function() {
        if (customer) {
            setActiveForm("currentUser");
        }
    }, [
        customer
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("aside", {
        className: "fixed left-full top-0 z-[70] flex h-full w-full flex-col overflow-hidden bg-background bg-clearBlue pt-8 transition md:max-w-[500px] ".concat(accountOpen ? "".concat(promobarHidden ? "mt-[58px] md:mt-[var(--header-height)]" : "mt-[calc(58px+var(--promobar-height))] md:mt-[calc(var(--header-height)+var(--promobar-height))]", " pointer-events-auto -translate-x-full") : "pointer-events-none translate-x-0"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex-end relative flex h-14 flex-row-reverse items-center justify-between px-4 lg:px-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        "aria-label": "Close Account",
                        className: "",
                        onClick: closeAccount,
                        type: "button",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                            className: "w-5 text-text",
                            src: "/svgs/close.svg#close",
                            title: "Close",
                            viewBox: "0 0 24 24"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-base uppercase tracking-[.02em] text-primaryLight",
                        children: "Account"
                    })
                ]
            }),
            activeForm === "login" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Login, {
                setActiveForm: setActiveForm
            }),
            activeForm === "create" && /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateAccount, {
                setActiveForm: setActiveForm
            }),
            activeForm === "password" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ForgotPassword, {
                setActiveForm: setActiveForm
            }),
            activeForm === "currentUser" && /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountMenu, {
                setActiveForm: setActiveForm
            })
        ]
    });
}
Account.displayName = "Account";

;// CONCATENATED MODULE: ./src/snippets/Account/index.js


// EXTERNAL MODULE: ./src/snippets/AddToCart/index.js + 3 modules
var AddToCart = __webpack_require__(9729);
;// CONCATENATED MODULE: ./src/snippets/ArticleTableOfContents/ArticleTableOfContents.jsx


function ArticleTableOfContents(props) {
    var titles = props.titles, scrollToView = props.scrollToView, isInViewport = props.isInViewport;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var toggleDropdown = function() {
        setIsOpen(!isOpen);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "sticky top-16 z-10 text-left md:top-[83px] lg:hidden",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    type: "button",
                    onClick: toggleDropdown,
                    className: "z-[10] flex w-full items-center justify-between bg-[#fff] px-4 py-4 text-[13px] font-[400] uppercase focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2",
                    id: "dropdown-menu",
                    "aria-haspopup": "true",
                    "aria-expanded": isOpen ? "true" : "false",
                    children: [
                        "Table of Contents",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            className: "-mr-1 ml-2 h-5 w-5 ".concat(isOpen ? "rotate-180" : ""),
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 20 20",
                            fill: "currentColor",
                            "aria-hidden": "true",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                fillRule: "evenodd",
                                d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
                                clipRule: "evenodd"
                            })
                        })
                    ]
                })
            }),
            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute left-0 w-full origin-top-right divide-y bg-white shadow-lg",
                role: "menu",
                "aria-orientation": "vertical",
                "aria-labelledby": "dropdown-menu",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "py-1",
                    role: "none",
                    children: titles.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            type: "button",
                            id: "test-".concat(item.handle),
                            className: "group w-full cursor-pointer border-[#DDE2E7] px-4 pb-4 text-left text-[16px] font-[400] text-shadowGray last:border-b-0 hover:text-[#202635] lg:border-b ".concat(isInViewport("#".concat(item.handle)) ? "!text-[#202635]" : null),
                            onClick: function() {
                                return scrollToView(item.handle);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "group:first:opacity-0 h-[1px] w-full bg-gradient-to-r from-[#F1DCC1] via-[#8DCEF9] to-[#2179C2] opacity-20 hover:opacity-100 ".concat(isInViewport("#".concat(item.handle)) ? "!opacity-100" : null)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "block pt-4",
                                    children: item.title
                                })
                            ]
                        }, index);
                    })
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/snippets/ArticleTableOfContents/index.js


;// CONCATENATED MODULE: ./src/snippets/Attribution/Attribution.jsx


function Attribution(param) {
    var caption = param.caption, attribution = param.attribution, attributionLink = param.attributionLink;
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "attribution mt-2",
        children: [
            caption && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-mediumGray",
                children: caption
            }),
            attribution && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                href: (ref = attributionLink === null || attributionLink === void 0 ? void 0 : attributionLink.url) !== null && ref !== void 0 ? ref : "",
                newTab: (ref1 = attributionLink === null || attributionLink === void 0 ? void 0 : attributionLink.newTab) !== null && ref1 !== void 0 ? ref1 : false,
                className: "text-sm text-mediumGray",
                children: attribution
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/snippets/Attribution/index.js


// EXTERNAL MODULE: ./src/snippets/Badges/index.js + 1 modules
var Badges = __webpack_require__(2545);
// EXTERNAL MODULE: ./src/snippets/Beam/index.js + 5 modules
var Beam = __webpack_require__(5582);
// EXTERNAL MODULE: ./src/snippets/Carousel/Carousel.jsx
var Carousel = __webpack_require__(7105);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(6677);
// EXTERNAL MODULE: ../node_modules/lodash/lodash.js
var lodash = __webpack_require__(8784);
// EXTERNAL MODULE: ./src/snippets/Button/Button.jsx
var Button_Button = __webpack_require__(6946);
;// CONCATENATED MODULE: ./src/snippets/Cart/CartEmpty.jsx





function CartEmpty(param) {
    var closeCart = param.closeCart;
    var ref;
    var settings = (0,dist.useSettings)();
    var ref1 = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.cart) === null || ref === void 0 ? void 0 : ref.emptyCart), links = ref1.links, message = ref1.message;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
        className: "absolute left-1/2 top-10 flex w-full -translate-x-1/2 flex-col items-center gap-5 px-5",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "text-center text-[28px] font-light tracking-[-0.01em]",
                children: "You have no items in your cart"
            }),
            links === null || links === void 0 ? void 0 : links.map(function(param, index) {
                var link = param.link;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                        "aria-label": link === null || link === void 0 ? void 0 : link.text,
                        className: "btn-primary",
                        href: link === null || link === void 0 ? void 0 : link.url,
                        newTab: link === null || link === void 0 ? void 0 : link.newTab,
                        onClick: closeCart,
                        children: link === null || link === void 0 ? void 0 : link.text
                    })
                }, index);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                href: "/collections/shop-all",
                variant: "filled",
                theme: "primary",
                children: "Shop All Products"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-8 h-[1px] w-full bg-[#DDE2E7]"
            })
        ]
    });
}
CartEmpty.displayName = "CartEmpty";

;// CONCATENATED MODULE: ./src/snippets/Cart/CartHeader.jsx



function CartHeader(param) {
    var closeCart = param.closeCart, announcement = param.announcement, isCartPage = param.isCartPage;
    var cartCount = (0,hooks/* useCartCount */.iF)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative flex items-center justify-between px-[18px] pb-3 pt-[18px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                        className: "cart-header-heading text-base text-primary font-normal",
                        children: [
                            "Your Cart",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "".concat(isCartPage ? "" : "lg:hidden"),
                                children: [
                                    "(",
                                    cartCount || 0,
                                    ")"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        "aria-label": "Close cart",
                        className: "w-6 h-6 p-[6px] ".concat(isCartPage ? "hidden" : ""),
                        onClick: closeCart,
                        type: "button",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                            className: "text-text",
                            src: "/svgs/close.svg#close",
                            title: "Close Cart",
                            viewBox: "0 0 24 24"
                        })
                    })
                ]
            }),
            (announcement === null || announcement === void 0 ? void 0 : announcement.enabled) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "bg-[#CCE0F1] px-3 py-[.6rem] text-center text-xs font-light text-black",
                    children: announcement === null || announcement === void 0 ? void 0 : announcement.text
                })
            })
        ]
    });
}
CartHeader.displayName = "CartHeader";

// EXTERNAL MODULE: ./src/snippets/Image/index.js + 2 modules
var Image = __webpack_require__(8601);
// EXTERNAL MODULE: ./src/snippets/Markdown/index.js + 161 modules
var Markdown = __webpack_require__(2725);
;// CONCATENATED MODULE: ./src/utils/formatCurrency.js
function formatCurrency(value) {
    var currency = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "USD", locale = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "en-US";
    return new Intl.NumberFormat(locale, {
        style: "currency",
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(value);
}

;// CONCATENATED MODULE: ./src/snippets/Cart/RechargeSubscriptionWidgetDetails.jsx






function RechargeSubscriptionWidgetDetails(param) {
    var selectedVariant = param.selectedVariant, selectedSellingPlan = param.selectedSellingPlan, shipsNow = param.shipsNow, shipsRecurringly = param.shipsRecurringly, className = param.className, widgetType = param.widgetType, item = param.item, _expandable = param.expandable, expandable = _expandable === void 0 ? false : _expandable;
    var ref, ref1, ref2, ref3;
    var product = (0,dist.useProduct)();
    var ref4 = (0,react.useState)(null), shipNowImage = ref4[0], setShipNowImage = ref4[1];
    var ref5 = (0,react.useState)(false), show = ref5[0], setShow = ref5[1];
    (0,react.useEffect)(function() {
        var ref, ref1, ref2;
        if (selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.image) === null || ref === void 0 ? void 0 : ref.src) {
            var ref3;
            setShipNowImage(selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref3 = selectedVariant.image) === null || ref3 === void 0 ? void 0 : ref3.src);
        } else if (shipsNow === null || shipsNow === void 0 ? void 0 : (ref1 = shipsNow.image) === null || ref1 === void 0 ? void 0 : ref1.src) {
            var ref4;
            setShipNowImage(shipsNow === null || shipsNow === void 0 ? void 0 : (ref4 = shipsNow.image) === null || ref4 === void 0 ? void 0 : ref4.src);
        } else if (product === null || product === void 0 ? void 0 : (ref2 = product.featuredImage) === null || ref2 === void 0 ? void 0 : ref2.src) {
            var ref5;
            setShipNowImage(product === null || product === void 0 ? void 0 : (ref5 = product.featuredImage) === null || ref5 === void 0 ? void 0 : ref5.src);
        }
    }, [
        product,
        selectedVariant,
        shipsNow
    ]);
    var frequencyDisplay = selectedSellingPlan === null || selectedSellingPlan === void 0 ? void 0 : (ref = selectedSellingPlan.sellingPlan) === null || ref === void 0 ? void 0 : (ref1 = ref.name) === null || ref1 === void 0 ? void 0 : ref1.replace("Delivery every ", "");
    return expandable && !show && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        type: "button",
        className: "text-[11px] font-normal underline",
        onClick: function() {
            setShow(!show);
        },
        children: "View Delivery Details"
    }) || /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "border border-t-0 border-[#DDE2E7] p-3 text-primary ".concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: "text-[11px] text-secondary underline",
                onClick: function() {
                    setShow(!show);
                },
                children: "Hide Delivery Details"
            }),
            (shipsNow === null || shipsNow === void 0 ? void 0 : shipsNow.show) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "ships-now ".concat(expandable ? "mt-2" : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "mb-2 flex border-b border-[#20263533] pb-1 text-xs font-normal leading-6",
                        children: "Ships Today"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center text-[12px] [&_li]:mb-0",
                        children: [
                            shipNowImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative aspect-square h-[56px] w-[56px] md:h-[68px] md:w-[68px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                        alt: "Ships Now",
                                        className: "absolute h-full w-full object-contain !mix-blend-multiply",
                                        width: "60px",
                                        height: "60px",
                                        src: shipNowImage
                                    })
                                })
                            }),
                            (shipsNow === null || shipsNow === void 0 ? void 0 : shipsNow.items) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-[12px] font-normal [&_li]:!mb-0 [&_p]:!text-[12px]",
                                children: [
                                    (item === null || item === void 0 ? void 0 : item.quantity) && (shipsNow === null || shipsNow === void 0 ? void 0 : shipsNow.items) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                                        children: shipsNow === null || shipsNow === void 0 ? void 0 : shipsNow.items.replaceAll("{qty}", item === null || item === void 0 ? void 0 : item.quantity)
                                    }),
                                    !(item === null || item === void 0 ? void 0 : item.quantity) && (shipsNow === null || shipsNow === void 0 ? void 0 : shipsNow.items) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                                        children: shipsNow === null || shipsNow === void 0 ? void 0 : shipsNow.items.replaceAll("{qty}", 1)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            shipsRecurringly.show && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "ships-recurringly mt-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mb-2 flex justify-between border-b border-[#20263533] pb-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "mr-4 flex text-xs font-normal leading-6",
                                children: " Ships every ".concat(frequencyDisplay)
                            }),
                            widgetType === "featured" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-shadowGray line-through",
                                        children: formatCurrency(shipsRecurringly === null || shipsRecurringly === void 0 ? void 0 : shipsRecurringly.price)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "ml-4",
                                        children: formatCurrency(shipsRecurringly === null || shipsRecurringly === void 0 ? void 0 : shipsRecurringly.overridePrice)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center text-[12px] font-normal [&_li]:!mb-0",
                        children: [
                            (shipsRecurringly === null || shipsRecurringly === void 0 ? void 0 : (ref2 = shipsRecurringly.image) === null || ref2 === void 0 ? void 0 : ref2.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative aspect-square h-[56px] w-[56px] md:h-[68px] md:w-[68px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                        alt: "Autoships",
                                        className: "absolute h-full w-full object-contain !mix-blend-multiply",
                                        width: "60px",
                                        height: "60px",
                                        src: shipsRecurringly === null || shipsRecurringly === void 0 ? void 0 : (ref3 = shipsRecurringly.image) === null || ref3 === void 0 ? void 0 : ref3.src
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-[12px] font-normal [&_li]:!mb-0 [&_p]:!text-[12px]",
                                children: [
                                    (item === null || item === void 0 ? void 0 : item.quantity) && (shipsRecurringly === null || shipsRecurringly === void 0 ? void 0 : shipsRecurringly.items) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                                        children: shipsRecurringly === null || shipsRecurringly === void 0 ? void 0 : shipsRecurringly.items.replaceAll("{qty}", item === null || item === void 0 ? void 0 : item.quantity)
                                    }),
                                    !(item === null || item === void 0 ? void 0 : item.quantity) && (shipsRecurringly === null || shipsRecurringly === void 0 ? void 0 : shipsRecurringly.items) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                                        children: shipsRecurringly === null || shipsRecurringly === void 0 ? void 0 : shipsRecurringly.items.replaceAll("{qty}", 1)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3444);
;// CONCATENATED MODULE: ./src/snippets/Cart/CartItemSubscriptionDropdown.jsx




function CartItemSubscriptionDropdown(props) {
    var ref, ref1;
    var selectedOption = props.selectedOption, setSelectedOption = props.setSelectedOption, options = props.options, updateSubscription = props.updateSubscription;
    var handleSelectChange = function(event) {
        var newSelectedOption = options.find(function(option) {
            return option.sellingPlan.id === event.target.value;
        });
        setSelectedOption(newSelectedOption);
        updateSubscription(newSelectedOption);
    };
    var compareSellingPlans = function(a, b) {
        var frequencyA = a.sellingPlan.options[1].value.split("-")[0];
        var frequencyB = b.sellingPlan.options[1].value.split("-")[0];
        return frequencyA - frequencyB;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative border border-[#E9E9EB] p-0 text-primary",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                id: "subscription-select-".concat(selectedOption === null || selectedOption === void 0 ? void 0 : (ref = selectedOption.sellingPlan) === null || ref === void 0 ? void 0 : ref.id.split("/").pop()),
                className: "h-9 w-full appearance-none pl-2 pr-4 text-[12px] font-medium bg-transparent",
                onChange: function(event) {
                    return handleSelectChange(event);
                },
                value: selectedOption === null || selectedOption === void 0 ? void 0 : (ref1 = selectedOption.sellingPlan) === null || ref1 === void 0 ? void 0 : ref1.id,
                children: (0,_to_consumable_array/* default */.Z)(options).sort(compareSellingPlans).map(function(option) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: option.sellingPlan.id,
                        children: option.sellingPlan.name
                    }, option.sellingPlan.id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                src: "/svgs/select-chevrons.svg#select-chevrons",
                title: "Select",
                viewBox: "0 0 6 12",
                className: "pointer-events-none absolute right-2 top-1/2 h-3 w-3 -translate-y-1/2 fill-current text-primary"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/snippets/Cart/QuantitySelector.jsx



function QuantitySelector(param) {
    var handleDecrement = param.handleDecrement, handleIncrement = param.handleIncrement, isUpdatingItem = param.isUpdatingItem, item = param.item;
    var variant = item.variant, quantity = item.quantity;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex w-[84px] items-center justify-between border border-[#E9E9EB]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                "aria-label": "Reduce quantity of ".concat(variant.product.title, " by 1 to ").concat(quantity - 1),
                className: "relative h-7 w-8 transition disabled:opacity-50 md:hover:border-gray",
                disabled: isUpdatingItem,
                onClick: handleDecrement,
                type: "button",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                    className: "absolute left-1/2 top-1/2 w-3 -translate-x-1/2 -translate-y-1/2 text-primary",
                    src: "/svgs/minus.svg#minus",
                    title: "Minus",
                    viewBox: "0 0 24 24"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative flex flex-1 items-center justify-center text-xs",
                children: isUpdatingItem ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {
                    stroke: "var(--gray)"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "w-full text-center font-normal outline-none",
                    children: quantity
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                "aria-label": "Increase quantity of ".concat(variant.product.title, " by 1 to ").concat(quantity + 1),
                className: "relative h-7 w-8 transition disabled:opacity-50 md:hover:border-gray",
                disabled: isUpdatingItem,
                onClick: handleIncrement,
                type: "button",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                    className: "absolute left-1/2 top-1/2 w-3 -translate-x-1/2 -translate-y-1/2 text-primary",
                    src: "/svgs/plus.svg#plus",
                    title: "Plus",
                    viewBox: "0 0 24 24"
                })
            })
        ]
    });
}
QuantitySelector.displayName = "QuantitySelector";

;// CONCATENATED MODULE: ./src/snippets/Cart/useCartItem.js




var useCartItem = function(param) {
    var id = param.id, quantity = param.quantity;
    var cartRemoveItem = (0,dist.useCartRemoveItem)().cartRemoveItem;
    var cartUpdateItem = (0,dist.useCartUpdateItem)().cartUpdateItem;
    var ref = (0,react.useState)(false), isUpdatingItem = ref[0], setIsUpdatingItem = ref[1];
    var ref1 = (0,react.useState)(false), isRemovingItem = ref1[0], setIsRemovingItem = ref1[1];
    var handleDecrement = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var newQuantity;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(quantity > 1)) return [
                        3,
                        2
                    ];
                    setIsUpdatingItem(true);
                    newQuantity = quantity - 1;
                    return [
                        4,
                        cartUpdateItem({
                            lineId: id,
                            quantity: newQuantity
                        })
                    ];
                case 1:
                    _state.sent();
                    setIsUpdatingItem(false);
                    return [
                        3,
                        4
                    ];
                case 2:
                    setIsRemovingItem(true);
                    return [
                        4,
                        cartRemoveItem({
                            lineId: id
                        })
                    ];
                case 3:
                    _state.sent();
                    setIsRemovingItem(false);
                    _state.label = 4;
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        id,
        quantity
    ]);
    var handleIncrement = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var newQuantity;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setIsUpdatingItem(true);
                    newQuantity = quantity + 1;
                    return [
                        4,
                        cartUpdateItem({
                            lineId: id,
                            quantity: newQuantity
                        })
                    ];
                case 1:
                    _state.sent();
                    setIsUpdatingItem(false);
                    return [
                        2
                    ];
            }
        });
    }), [
        id,
        quantity
    ]);
    var handleRemove = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setIsRemovingItem(true);
                    return [
                        4,
                        cartRemoveItem({
                            lineId: id
                        })
                    ];
                case 1:
                    _state.sent();
                    setIsRemovingItem(false);
                    return [
                        2
                    ];
            }
        });
    }), [
        id
    ]);
    return {
        isUpdatingItem: isUpdatingItem,
        isRemovingItem: isRemovingItem,
        handleDecrement: handleDecrement,
        handleIncrement: handleIncrement,
        handleRemove: handleRemove
    };
};

;// CONCATENATED MODULE: ./src/snippets/Cart/useCartItemPrices.js

function useCartItemPrices(param) {
    var item = param.item;
    var discountAllocations = item.discountAllocations, estimatedCost = item.estimatedCost, id = item.id, quantity = item.quantity, variant = item.variant;
    return (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var totalAmount = parseFloat((estimatedCost === null || estimatedCost === void 0 ? void 0 : (ref = estimatedCost.totalAmount) === null || ref === void 0 ? void 0 : ref.amount) || "0");
        // compare at price from variant
        var variantAmount = parseFloat((variant === null || variant === void 0 ? void 0 : (ref1 = variant.priceV2) === null || ref1 === void 0 ? void 0 : ref1.amount) || "0");
        var variantCompareAtAmount = parseFloat((variant === null || variant === void 0 ? void 0 : (ref2 = variant.compareAtPriceV2) === null || ref2 === void 0 ? void 0 : ref2.amount) || "0");
        var compareAtPriceFromVariant = variantCompareAtAmount > variantAmount ? variantCompareAtAmount : 0;
        // compare at price from discount
        var subtotalAmount = parseFloat((estimatedCost === null || estimatedCost === void 0 ? void 0 : (ref3 = estimatedCost.subtotalAmount) === null || ref3 === void 0 ? void 0 : ref3.amount) || "0");
        var totalDiscount = parseFloat((discountAllocations === null || discountAllocations === void 0 ? void 0 : (ref4 = discountAllocations[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.discountedAmount) === null || ref5 === void 0 ? void 0 : ref5.amount) || "0");
        var compareAtPriceFromDiscount = totalDiscount ? subtotalAmount / quantity : 0;
        // prices
        var price = totalAmount / quantity;
        var compareAtPrice = compareAtPriceFromVariant || compareAtPriceFromDiscount;
        return {
            price: "$".concat(price.toFixed(2).replace(".00", "")),
            compareAtPrice: compareAtPrice ? "$".concat(compareAtPrice.toFixed(2).replace(".00", "")) : null
        };
    }, [
        id,
        quantity
    ]);
}

;// CONCATENATED MODULE: ./src/snippets/Cart/CartItem.jsx
















function CartItem(param) {
    var closeCart = param.closeCart, item = param.item, setIsUpdating = param.setIsUpdating;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var attributes = item.attributes, id = item.id, variant = item.variant, quantity = item.quantity;
    var settings = (0,dist.useSettings)();
    var titleOverrides = settings === null || settings === void 0 ? void 0 : (ref = settings.cart) === null || ref === void 0 ? void 0 : (ref1 = ref.lineItems) === null || ref1 === void 0 ? void 0 : ref1.titleOverrides;
    var titleOverride = titleOverrides === null || titleOverrides === void 0 ? void 0 : titleOverrides.find(function(override) {
        var ref;
        return ((ref = override.product) === null || ref === void 0 ? void 0 : ref.id) === variant.product.id;
    });
    var ref8 = (0,contexts/* useGlobalContext */.b)(), testVariant = ref8.state.testVariant;
    var ref9 = (0,react.useState)(false), selectedSubscription = ref9[0], setSelectedSubscription = ref9[1];
    var ref10 = useCartItem({
        id: id,
        quantity: quantity,
        attributes: attributes
    }), isUpdatingItem = ref10.isUpdatingItem, isRemovingItem = ref10.isRemovingItem, handleDecrement = ref10.handleDecrement, handleIncrement = ref10.handleIncrement, handleRemove = ref10.handleRemove;
    var ref11 = useCartItemPrices({
        item: item
    }), price = ref11.price, compareAtPrice = ref11.compareAtPrice;
    var cartAddItem = (0,dist.useCartAddItem)().cartAddItem;
    var cartUpdateItem = (0,dist.useCartUpdateItem)().cartUpdateItem;
    var cartRemoveItem = (0,dist.useCartRemoveItem)().cartRemoveItem;
    var ref12 = (0,react.useState)(false), tooltipVisible = ref12[0], setTooltipVisible = ref12[1];
    (0,react.useEffect)(function() {
        if (item === null || item === void 0 ? void 0 : item.sellingPlanAllocation) {
            setSelectedSubscription(item.sellingPlanAllocation);
        }
    }, [
        item
    ]);
    var fullProduct = (0,dist.useProductByHandle)({
        handle: item.variant.product.handle
    });
    var variantSellingPlans = (0,react.useMemo)(function() {
        var ref;
        return fullProduct === null || fullProduct === void 0 ? void 0 : (ref = fullProduct.product) === null || ref === void 0 ? void 0 : ref.variants.filter(function(productVariant) {
            var ref;
            return (productVariant === null || productVariant === void 0 ? void 0 : productVariant.id) === (item === null || item === void 0 ? void 0 : (ref = item.variant) === null || ref === void 0 ? void 0 : ref.id);
        })[0];
    }, [
        fullProduct
    ]);
    var sellingPlan = {};
    var updateSubscription = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(option) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsUpdating(true);
                        sellingPlan = {
                            lineId: item.id,
                            quantity: item.quantity,
                            sellingPlanId: option === null || option === void 0 ? void 0 : option.sellingPlan.id
                        };
                        setSelectedSubscription(option);
                        return [
                            4,
                            cartUpdateItem(sellingPlan).then(function() {
                                return setIsUpdating(false);
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function updateSubscription(option) {
            return _ref.apply(this, arguments);
        };
    }();
    var addSubscription = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsUpdating(true);
                        sellingPlan = {
                            attributes: attributes,
                            merchandiseId: item.variant.id,
                            quantity: item.quantity,
                            sellingPlanId: (ref = variantSellingPlans === null || variantSellingPlans === void 0 ? void 0 : variantSellingPlans.sellingPlanAllocations[0]) === null || ref === void 0 ? void 0 : ref.sellingPlan.id
                        };
                        setSelectedSubscription(variantSellingPlans === null || variantSellingPlans === void 0 ? void 0 : variantSellingPlans.sellingPlanAllocations[0]);
                        return [
                            4,
                            cartRemoveItem({
                                lineId: item.id
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            cartAddItem(sellingPlan).then(function() {
                                return setIsUpdating(false);
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function addSubscription() {
            return _ref.apply(this, arguments);
        };
    }();
    var url = "/products/".concat(variant.product.handle);
    var productSubscriptionWidget = (0,hooks/* useSubscriptionWidget */.FG)(item === null || item === void 0 ? void 0 : (ref2 = item.variant) === null || ref2 === void 0 ? void 0 : ref2.product).productSubscriptionWidget;
    var shipsNow = productSubscriptionWidget === null || productSubscriptionWidget === void 0 ? void 0 : productSubscriptionWidget.shipsNow;
    var shipsRecurringly = productSubscriptionWidget === null || productSubscriptionWidget === void 0 ? void 0 : productSubscriptionWidget.shipsRecurringly;
    var displaySubscriptionDropdown = ((shipsNow === null || shipsNow === void 0 ? void 0 : shipsNow.show) || (shipsRecurringly === null || shipsRecurringly === void 0 ? void 0 : shipsRecurringly.show)) && (item === null || item === void 0 ? void 0 : item.variant) && (item === null || item === void 0 ? void 0 : item.sellingPlanAllocation);
    var getItemId = function() {
        if (!item) return null;
        var parts = item.id.split("/");
        var lastPart = parts[parts.length - 1];
        return lastPart.split("?")[0];
    };
    var itemId = getItemId();
    var imageComponent = /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
        alt: variant.product.title,
        className: "w-[70px] shrink-0 bg-offWhite md:w-[112px]",
        height: Math.floor(90 / (variant.image.width / variant.image.height)),
        src: variant.image.src,
        width: "112"
    });
    var titleComponent = /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
        className: "text-sm font-normal leading-4",
        children: (titleOverride === null || titleOverride === void 0 ? void 0 : titleOverride.title) ? titleOverride.title : variant.product.title
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative flex flex-wrap items-center gap-1 border-[#DDE2E7] p-4 ".concat(displaySubscriptionDropdown ? "pb-[10px]" : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex w-full justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mr-3 aspect-square w-[112px] shrink-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                    "aria-label": "View ".concat(variant.product.title),
                                    href: url,
                                    onClick: closeCart,
                                    tabIndex: "-1",
                                    children: imageComponent
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex min-h-[6.25em] grow flex-col justify-evenly text-[#202635]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "relative",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                            "aria-label": "View ".concat(variant.product.title),
                                            href: url,
                                            onClick: closeCart,
                                            children: titleComponent
                                        }),
                                        (titleOverride === null || titleOverride === void 0 ? void 0 : titleOverride.subtitle) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-xs font-normal text-[#4D515D]",
                                            children: titleOverride === null || titleOverride === void 0 ? void 0 : titleOverride.subtitle
                                        }),
                                        variant.title !== "Default Title" && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-base font-light tracking-[-.01em] opacity-60",
                                            children: variant.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col items-start ".concat((variantSellingPlans === null || variantSellingPlans === void 0 ? void 0 : variantSellingPlans.sellingPlanAllocations.length) > 0 && (item === null || item === void 0 ? void 0 : (ref3 = item.sellingPlanAllocation) === null || ref3 === void 0 ? void 0 : ref3.sellingPlan) === 0 ? "flex-col" : "flex-1"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "my-3 flex items-baseline justify-end",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-sm font-normal",
                                                            children: price
                                                        }),
                                                        compareAtPrice ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "ml-2 text-[11px] font-normal text-[#4D515D] line-through",
                                                            children: compareAtPrice
                                                        }) : (variantSellingPlans === null || variantSellingPlans === void 0 ? void 0 : variantSellingPlans.sellingPlanAllocations.length) > 0 && (item === null || item === void 0 ? void 0 : (ref4 = item.sellingPlanAllocation) === null || ref4 === void 0 ? void 0 : ref4.sellingPlan) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            className: "ml-2 text-[11px] font-normal line-through opacity-60",
                                                            children: [
                                                                "$",
                                                                Number((ref6 = item === null || item === void 0 ? void 0 : (ref5 = item.sellingPlanAllocation) === null || ref5 === void 0 ? void 0 : ref5.priceAdjustments[0].compareAtPrice) === null || ref6 === void 0 ? void 0 : ref6.amount).toFixed(2)
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantitySelector, {
                                                    handleDecrement: handleDecrement,
                                                    handleIncrement: handleIncrement,
                                                    isUpdatingItem: isUpdatingItem,
                                                    item: item
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex shrink-0 items-end text-primary",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    "aria-label": "Remove ".concat(variant.product.title, " from cart"),
                                    className: "h-4 w-4 p-[2px] text-[#ED7C5C]",
                                    onClick: handleRemove,
                                    type: "button",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                                        src: "/svgs/trash.svg#trash",
                                        title: "Remove Item",
                                        viewBox: "0 0 10 12"
                                    })
                                })
                            })
                        ]
                    }),
                    isRemovingItem && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute left-0 top-0 flex h-full w-full items-center justify-center bg-[rgba(255,255,255,0.6)] text-mediumGray",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {})
                    }),
                    (variantSellingPlans === null || variantSellingPlans === void 0 ? void 0 : variantSellingPlans.sellingPlanAllocations.length) > 0 && !(item === null || item === void 0 ? void 0 : item.sellingPlanAllocation) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative mt-2 flex w-full rounded-sm border border-secondary bg-gradient-to-r from-[#fcf8f3] via-[#e7f4fd] to-[#d3e4f3] px-4 py-[0.4rem]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                htmlFor: "subscribe-checkbox-".concat(itemId),
                                className: "subscribe-unlock__content flex w-full cursor-pointer items-center text-[13px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        id: "subscribe-checkbox-".concat(itemId),
                                        type: "checkbox",
                                        className: "custom-checkbox peer hidden",
                                        onClick: function() {
                                            return addSubscription();
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "custom-checkbox-checkmark relative mr-2 flex h-4 w-4 items-center justify-center rounded-[1px] border border-solid border-secondary transition-[background] duration-[0.3s] peer-[:checked]:bg-secondary"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "font-medium text-secondary",
                                        children: "Upgrade to subscription & unlock 10% off"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                type: "button",
                                className: "subscribe-unlock__icon relative flex w-full flex-1 cursor-pointer items-center justify-end ".concat(tooltipVisible ? "active" : ""),
                                "aria-label": "Toggle Tooltip",
                                "aria-expanded": tooltipVisible,
                                "aria-controls": "toggle-tooltip",
                                onClick: function() {
                                    return setTooltipVisible(function(prev) {
                                        return !prev;
                                    });
                                },
                                onMouseEnter: function() {
                                    return setTooltipVisible(true);
                                },
                                onMouseLeave: function() {
                                    return setTooltipVisible(false);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                                        className: "w-[14px] ".concat(tooltipVisible ? "text-accent2" : "text-secondary"),
                                        src: "/svgs/tooltip.svg#tooltip",
                                        title: "Tooltip",
                                        viewBox: "0 0 12 12"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        id: "toggle-tooltip",
                                        className: "subscribe-unlock__tooltip absolute -top-[7.1rem] right-[-1.2rem] block w-60 rounded-sm bg-clearBlue p-4 shadow-[0_0.4rem_1rem_rgba(0,0,0,0.2)] ".concat(tooltipVisible ? "" : "hidden"),
                                        role: "tooltip",
                                        hidden: !tooltipVisible,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "subscribe-unlock__tooltip__inner relative before:absolute before:bottom-[-2.3rem] before:right-[-1.5rem] before:z-[1] before:block before:h-8 before:w-8 before:-translate-x-2/4 before:-translate-y-2/4 before:rotate-45 before:bg-clearBlue before:content-['']",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                className: "relative z-[1] list-disc pl-2 text-left font-light",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: "text-xs leading-6 text-[#343b49]",
                                                        children: "10% off first purchase and refills"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: "text-xs leading-6 text-[#343b49]",
                                                        children: "Free shipping on all refills (U.S. only)"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: "text-xs leading-6 text-[#343b49]",
                                                        children: "Pause, Skip, or Cancel any time."
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            displaySubscriptionDropdown && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-4 pb-4",
                children: [
                    (variantSellingPlans === null || variantSellingPlans === void 0 ? void 0 : variantSellingPlans.sellingPlanAllocations.length) > 0 && (item === null || item === void 0 ? void 0 : (ref7 = item.sellingPlanAllocation) === null || ref7 === void 0 ? void 0 : ref7.sellingPlan) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CartItemSubscriptionDropdown, {
                        selectedOption: selectedSubscription,
                        options: variantSellingPlans === null || variantSellingPlans === void 0 ? void 0 : variantSellingPlans.sellingPlanAllocations,
                        setSelectedOption: setSelectedSubscription,
                        updateSubscription: updateSubscription
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RechargeSubscriptionWidgetDetails, {
                        item: item,
                        selectedVariant: item === null || item === void 0 ? void 0 : item.variant,
                        selectedSellingPlan: item === null || item === void 0 ? void 0 : item.sellingPlanAllocation,
                        shipsNow: productSubscriptionWidget === null || productSubscriptionWidget === void 0 ? void 0 : productSubscriptionWidget.shipsNow,
                        shipsRecurringly: productSubscriptionWidget === null || productSubscriptionWidget === void 0 ? void 0 : productSubscriptionWidget.shipsRecurringly,
                        expandable: true
                    })
                ]
            })
        ]
    });
}
CartItem.displayName = "CartItem";

;// CONCATENATED MODULE: ./src/snippets/Cart/CartTotals.jsx







function CartTotals() {
    var ref, ref1;
    var ref2 = (0,react.useState)(false), checkoutDisabled = ref2[0], setCheckoutdisabled = ref2[1];
    var ref3 = (0,react.useState)(0), discountAmount = ref3[0], setDiscountAmount = ref3[1];
    var cart = (0,dist.useCart)();
    var cartItems = (0,dist.useCartItems)();
    var cartCount = (0,hooks/* useCartCount */.iF)();
    var cartTotals = (0,dist.useCartTotals)();
    var cartCheckout = (0,dist.useCartCheckout)().cartCheckout;
    var settings = (0,dist.useSettings)();
    var ref4 = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.cart) === null || ref === void 0 ? void 0 : ref.totals), subtext = ref4.subtext, subtotalText = ref4.subtotalText;
    (0,react.useEffect)(function() {
        if (cartCount === 0) {
            setCheckoutdisabled(true);
        } else {
            setCheckoutdisabled(false);
        }
        if (cart === null || cart === void 0 ? void 0 : cart.discountCodes.length) {
            setDiscountAmount(cartTotals.subtotal - cartTotals.total);
        } else {
            setDiscountAmount(0);
        }
    }, [
        cart
    ]);
    var ref5 = (0,react.useState)(0), total = ref5[0], setTotal = ref5[1];
    var ref6 = (0,react.useState)(0), subtotal = ref6[0], setSubtotal = ref6[1];
    (0,react.useEffect)(function() {
        setSubtotal((cartTotals === null || cartTotals === void 0 ? void 0 : cartTotals.subtotal) || 0);
        setTotal((cartTotals === null || cartTotals === void 0 ? void 0 : cartTotals.total) || 0);
        // check for route products in cart
        var routeProducts = cartItems === null || cartItems === void 0 ? void 0 : cartItems.filter(function(item) {
            return item.variant.product.handle === "routeins";
        });
        // if route products are in cart, decrease total and subtotal by the price of the route products
        if (routeProducts === null || routeProducts === void 0 ? void 0 : routeProducts.length) {
            routeProducts.forEach(function(routeProduct) {
                setSubtotal(function(prevSubtotal) {
                    return prevSubtotal - parseFloat(routeProduct.quantity * routeProduct.variant.priceV2.amount);
                });
                setTotal(function(prevTotal) {
                    return prevTotal - parseFloat(routeProduct.quantity * routeProduct.variant.priceV2.amount);
                });
            });
        }
    }, [
        cartItems,
        cartTotals
    ]);
    var discountCode = ((ref1 = cart === null || cart === void 0 ? void 0 : cart.discountCodes[0]) === null || ref1 === void 0 ? void 0 : ref1.applicable) ? cart.discountCodes[0].code : null;
    var cartRemoveDiscount = (0,dist.useCartRemoveDiscount)().cartRemoveDiscount;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex-col gap-4 border-t border-t-[#DDE2E7] bg-[#ecf7ff]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "px-[18px] py-[18px]",
            children: [
                (cart === null || cart === void 0 ? void 0 : cart.discountCodes.length) && discountAmount !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mb-4 flex justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Discount"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                "$",
                                parseFloat(discountAmount || "0").toFixed(2)
                            ]
                        })
                    ]
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mb-4 flex justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-sm font-normal tracking-[.04em]",
                            children: subtotalText || "Subtotal"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "text-sm font-normal",
                            children: [
                                discountCode && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    type: "button",
                                    onClick: cartRemoveDiscount,
                                    className: "mr-4 text-[11px] text-[#4D515D]",
                                    "aria-label": "Remove discount code",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                                            className: "mr-[6px] inline-block w-[14px]",
                                            src: "/svgs/circle-remove.svg#circle-remove",
                                            title: "Remove",
                                            viewBox: "0 0 14 14",
                                            "aria-hidden": "true"
                                        }),
                                        discountCode
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "line-through opacity-60 ".concat(discountAmount === 0 ? "hidden" : null),
                                    children: [
                                        " ",
                                        "$",
                                        parseFloat(subtotal).toFixed(2)
                                    ]
                                }),
                                " ",
                                "$",
                                parseFloat(total).toFixed(2)
                            ]
                        })
                    ]
                }),
                subtext && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mt-1 text-xs",
                    children: subtext
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    onClick: cartCheckout,
                    variant: "filled",
                    theme: "primary",
                    className: "h-12 w-full pb-[13px] pt-[10px] text-lg font-normal",
                    disabled: checkoutDisabled,
                    children: "Checkout"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mt-2 text-center text-2xs font-normal text-[#4D515D]",
                    children: "Shipping and taxes are calculated at checkout"
                })
            ]
        })
    });
}
CartTotals.displayName = "CartTotals";

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(1373);
;// CONCATENATED MODULE: ./src/snippets/Cart/CartUpsell.jsx








function CartUpsell(param) {
    var closeCart = param.closeCart;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var cartAddItem = (0,dist.useCartAddItem)().cartAddItem;
    var cart = (0,dist.useCart)();
    var settings = (0,dist.useSettings)();
    var ref10 = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.cart) === null || ref === void 0 ? void 0 : ref.upsell), message = ref10.message, product = ref10.product;
    var productItem = (0,dist.useProductItemByHandle)({
        handle: product === null || product === void 0 ? void 0 : product.handle
    }).productItem;
    var _ref = (0,dist.useProductInventoryByHandle)({
        handle: product === null || product === void 0 ? void 0 : product.handle
    }), inventory = _ref.inventory, inventoryStatus = (0,_object_without_properties/* default */.Z)(_ref, [
        "inventory"
    ]);
    var selectedVariant = productItem === null || productItem === void 0 ? void 0 : (ref1 = productItem.variants) === null || ref1 === void 0 ? void 0 : ref1[0];
    var variantInventory = inventory === null || inventory === void 0 ? void 0 : (ref2 = inventory.variants) === null || ref2 === void 0 ? void 0 : ref2[selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id];
    var variantIsSoldOut = (inventoryStatus === null || inventoryStatus === void 0 ? void 0 : inventoryStatus.success) && !(variantInventory === null || variantInventory === void 0 ? void 0 : variantInventory.availableForSale);
    var variantIsPreorder = !variantIsSoldOut && (variantInventory === null || variantInventory === void 0 ? void 0 : variantInventory.currentlyNotInStock);
    var soldOutText = (settings === null || settings === void 0 ? void 0 : (ref3 = settings.product) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.addToCart) === null || ref4 === void 0 ? void 0 : ref4.soldOutText) || "Sold Out";
    var preorderText = (settings === null || settings === void 0 ? void 0 : (ref5 = settings.product) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.addToCart) === null || ref6 === void 0 ? void 0 : ref6.preorderText) || "Preorder";
    var addToCartText = (settings === null || settings === void 0 ? void 0 : (ref7 = settings.product) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.addToCart) === null || ref8 === void 0 ? void 0 : ref8.addToCartText) || "Add To Cart";
    var soldOutOrPreorderText = variantIsPreorder ? preorderText : soldOutText;
    var buttonText = variantIsSoldOut || variantIsPreorder ? soldOutOrPreorderText : addToCartText;
    var ref11 = (0,hooks/* useVariantPrices */.be)({
        variant: selectedVariant
    }), price = ref11.price, compareAtPrice = ref11.compareAtPrice;
    var showUpsell = (cart === null || cart === void 0 ? void 0 : (ref9 = cart.lines) === null || ref9 === void 0 ? void 0 : ref9.length) > 0 && !!(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id);
    var image = product === null || product === void 0 ? void 0 : product.featuredImage;
    var productIsInCart = (0,react.useMemo)(function() {
        if (!showUpsell) return null;
        return !!cart.lines.find(function(item) {
            return item.variant.product.handle === product.handle;
        });
    }, [
        cart === null || cart === void 0 ? void 0 : cart.updatedAt,
        product === null || product === void 0 ? void 0 : product.handle,
        showUpsell
    ]);
    return showUpsell && !productIsInCart ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-2 border-t border-t-border p-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "text-center text-xs font-normal",
                children: message
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center justify-center gap-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                        "aria-label": product === null || product === void 0 ? void 0 : product.title,
                        href: product === null || product === void 0 ? void 0 : product.path,
                        onClick: closeCart,
                        tabIndex: "-1",
                        className: "w-10 bg-offWhite",
                        children: (image === null || image === void 0 ? void 0 : image.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                            alt: product === null || product === void 0 ? void 0 : product.title,
                            height: Math.floor(40 / (image.width / image.height)),
                            src: image.src,
                            width: "40"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex max-w-[25rem] flex-1 flex-col gap-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                "aria-label": product === null || product === void 0 ? void 0 : product.title,
                                href: product === null || product === void 0 ? void 0 : product.path,
                                onClick: closeCart,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    className: "text-xs font-bold",
                                    children: product === null || product === void 0 ? void 0 : product.title
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center justify-between gap-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        "aria-label": buttonText,
                                        className: "text-label-sm text-main-underline",
                                        disabled: variantIsSoldOut,
                                        onClick: function() {
                                            cartAddItem({
                                                merchandiseId: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id,
                                                quantity: 1
                                            });
                                        },
                                        type: "button",
                                        children: buttonText
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-1 flex-wrap justify-end gap-x-1",
                                        children: [
                                            compareAtPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-xs text-mediumGray line-through",
                                                children: compareAtPrice
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-xs",
                                                children: price
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    }) : null;
}
CartUpsell.displayName = "CartUpsell";

;// CONCATENATED MODULE: ./src/snippets/Cart/CartDiscount.jsx







function CartDiscount() {
    var ref = (0,react.useState)(""), discountCode = ref[0], setDiscountCode = ref[1];
    var ref1 = (0,react.useState)(false), applied = ref1[0], setApplied = ref1[1];
    var ref2 = (0,react.useState)(false), isOpen = ref2[0], setIsOpen = ref2[1];
    var ref3 = (0,react.useState)(false), error = ref3[0], setError = ref3[1];
    var _ref = (0,dist.useCartAddDiscount)(), cartAddDiscount = _ref.cartAddDiscount, addDiscountStatus = (0,_object_without_properties/* default */.Z)(_ref, [
        "cartAddDiscount"
    ]);
    var _ref1 = (0,dist.useCartRemoveDiscount)(), cartRemoveDiscount = _ref1.cartRemoveDiscount, removeDiscountStatus = (0,_object_without_properties/* default */.Z)(_ref1, [
        "cartRemoveDiscount"
    ]);
    var handleRemoveDiscount = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            cartRemoveDiscount()
                        ];
                    case 1:
                        _state.sent();
                        setApplied(false);
                        setDiscountCode("");
                        return [
                            2
                        ];
                }
            });
        });
        return function handleRemoveDiscount() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleApplyDiscount = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, ref2, cartAddDiscountRS;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setError(false);
                        return [
                            4,
                            cartAddDiscount({
                                discountCode: discountCode
                            })
                        ];
                    case 1:
                        cartAddDiscountRS = _state.sent();
                        if ((cartAddDiscountRS === null || cartAddDiscountRS === void 0 ? void 0 : (ref = cartAddDiscountRS.discountCodes) === null || ref === void 0 ? void 0 : ref.length) && ((ref1 = cartAddDiscountRS === null || cartAddDiscountRS === void 0 ? void 0 : cartAddDiscountRS.discountCodes[0]) === null || ref1 === void 0 ? void 0 : ref1.code) === discountCode && ((ref2 = cartAddDiscountRS === null || cartAddDiscountRS === void 0 ? void 0 : cartAddDiscountRS.discountCodes[0]) === null || ref2 === void 0 ? void 0 : ref2.applicable) === true) {
                            setApplied(true);
                        } else {
                            setError(true);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleApplyDiscount() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        if (!applied) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            handleRemoveDiscount()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            handleApplyDiscount()
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var cart = (0,dist.useCart)();
    (0,react.useEffect)(function() {
        if ((cart === null || cart === void 0 ? void 0 : cart.discountCodes.length) && (cart === null || cart === void 0 ? void 0 : cart.discountCodes[0].applicable) === true) {
            setApplied(true);
            setDiscountCode(cart === null || cart === void 0 ? void 0 : cart.discountCodes[0].code);
            if (discountCode === (cart === null || cart === void 0 ? void 0 : cart.discountCodes[0].code)) {
                setDiscountCode(cart === null || cart === void 0 ? void 0 : cart.discountCodes[0].code);
            }
        }
    }, [
        cart,
        discountCode
    ]);
    (0,react.useEffect)(function() {
        if (!cart) {
            return;
        }
        if (!cart.discountCodes.length) {
            setApplied(false);
            setDiscountCode("");
        }
    }, [
        cart === null || cart === void 0 ? void 0 : cart.discountCodes
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "discount-code-wrapper bg-[#ecf7ff] px-[18px] py-3",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                "aria-label": "".concat(isOpen ? "Close" : "Open", " accordion for discount code}"),
                className: "flex w-full items-center justify-between gap-x-4 text-left",
                onClick: function() {
                    return setIsOpen(!isOpen);
                },
                type: "button",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-xs font-normal tracking-[-0.01em]",
                        children: "Discount Code"
                    }),
                    isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                        className: "w-4 text-current",
                        src: "/svgs/minus.svg#minus",
                        title: "Minus",
                        viewBox: "0 0 24 24"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                        className: "w-4 text-current",
                        src: "/svgs/plus.svg#plus",
                        title: "Plus",
                        viewBox: "0 0 24 24"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pb-2 pt-4 ".concat(isOpen ? "block" : "hidden"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        className: "input-group relative",
                        onSubmit: handleSubmit,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                "aria-label": "Discount Code",
                                id: "discount-code-input",
                                "aria-invalid": error ? "true" : "false",
                                "aria-describedby": error ? "discount-code-error" : undefined,
                                className: "h-[40px] w-full min-w-0 flex-1 border border-[#E9E9EB] px-4 py-2 text-xs font-light outline-none placeholder:text-[#343B49] ".concat(applied ? "text-mediumGray" : ""),
                                placeholder: "Discount Code",
                                onChange: function(param) {
                                    var target = param.target;
                                    return setDiscountCode(target.value);
                                },
                                value: discountCode,
                                readOnly: applied
                            }),
                            applied ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "absolute right-[3px] top-0 flex h-[40px] items-center px-[18px] text-xs uppercase text-[var(--success)]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Applied"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                                        className: "ml-2 w-[14px] text-[var(--success)]",
                                        src: "/svgs/checkmark-with-circle-filled.svg#checkmark-with-circle-filled",
                                        title: "Discount Code Applied",
                                        viewBox: "0 0 14 14"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "submit",
                                disabled: !discountCode.length || (addDiscountStatus === null || addDiscountStatus === void 0 ? void 0 : addDiscountStatus.loading),
                                className: "absolute right-[3px] top-0 flex h-full cursor-pointer items-center px-[18px] text-xs uppercase ".concat(applied ? "text-[var(--success)]" : "text-[var(--secondary)]"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Apply"
                                })
                            })
                        ]
                    }),
                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "discount-code-error",
                        className: "pt-3 text-xs text-error",
                        "aria-live": "polite",
                        role: "alert",
                        children: "Invalid or expired discount code"
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/snippets/Cart/FreeShippingMeter.jsx





function FreeShippingMeter() {
    var ref;
    var cartCount = (0,hooks/* useCartCount */.iF)();
    var cartTotals = (0,dist.useCartTotals)();
    var settings = (0,dist.useSettings)();
    var ref1 = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.cart) === null || ref === void 0 ? void 0 : ref.freeShipping), enabled = ref1.enabled, minCartSpend = ref1.minCartSpend, progressBarColor = ref1.progressBarColor, progressMessage = ref1.progressMessage, qualifiedMessage = ref1.qualifiedMessage;
    var showMeter = enabled && cartCount > 0 && minCartSpend > 0;
    var progress = (0,react.useMemo)(function() {
        if (!showMeter) return null;
        var total = parseFloat(cartTotals.total);
        var fraction = total / minCartSpend;
        var remainder = minCartSpend - total;
        if (fraction >= 1) {
            return {
                percent: 100,
                message: qualifiedMessage
            };
        }
        return {
            percent: fraction * 100,
            message: progressMessage === null || progressMessage === void 0 ? void 0 : progressMessage.replace("{{amount}}", "$".concat(remainder.toFixed(2).replace(".00", "")))
        };
    }, [
        cartTotals.total,
        minCartSpend,
        progressMessage,
        qualifiedMessage,
        showMeter, 
    ]);
    return showMeter ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "border-b border-b-border p-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mb-2 text-center text-xs",
                children: progress.message
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-1.5 w-full overflow-hidden rounded bg-lightGray",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "h-full w-full origin-left transition",
                    style: {
                        transform: "scaleX(".concat(progress.percent, "%)"),
                        backgroundColor: progressBarColor
                    }
                })
            })
        ]
    }) : null;
}
FreeShippingMeter.displayName = "FreeShippingMeter";

// EXTERNAL MODULE: ./src/hooks/useIpFetcher.js
var useIpFetcher = __webpack_require__(8311);
;// CONCATENATED MODULE: ./src/snippets/Cart/Cart.jsx
















function Cart() {
    var ref, ref1, ref2;
    var cartItems = (0,hooks/* useCartItems */._P)();
    var settings = (0,dist.useSettings)();
    var asPath = (0,next_router.useRouter)().asPath;
    var ref3 = (0,contexts/* useGlobalContext */.b)(), cartOpen = ref3.state.cartOpen, closeCart = ref3.actions.closeCart;
    var ref4 = (0,react.useState)(false), isUpdating = ref4[0], setIsUpdating = ref4[1];
    var isCartPage = function() {
        return asPath === "/cart";
    };
    var cartSettings = settings === null || settings === void 0 ? void 0 : settings.cart;
    var enabledUpsell = cartSettings === null || cartSettings === void 0 ? void 0 : (ref = cartSettings.upsell) === null || ref === void 0 ? void 0 : ref.enabled;
    var shippingBarSettings = cartSettings === null || cartSettings === void 0 ? void 0 : cartSettings.shippingBar;
    var beamSettings = settings === null || settings === void 0 ? void 0 : settings.beam;
    var hasSubscriptionItems = cartItems === null || cartItems === void 0 ? void 0 : cartItems.some(function(item) {
        return item.sellingPlanAllocation;
    });
    var hasOnetimeItems = cartItems === null || cartItems === void 0 ? void 0 : cartItems.some(function(item) {
        return !item.sellingPlanAllocation;
    });
    // set shipping bar text and state variables
    var isOnlySubscriptionItems = hasSubscriptionItems && !hasOnetimeItems;
    var defaultText = "Switch to subscription for 10% savings and free shipping (US)";
    var shippingBarText = (shippingBarSettings === null || shippingBarSettings === void 0 ? void 0 : shippingBarSettings.onetimeOnly) || defaultText;
    if (hasSubscriptionItems && hasOnetimeItems) {
        shippingBarText = (shippingBarSettings === null || shippingBarSettings === void 0 ? void 0 : shippingBarSettings.mixedCart) || defaultText;
    } else if (hasSubscriptionItems) {
        shippingBarText = (shippingBarSettings === null || shippingBarSettings === void 0 ? void 0 : shippingBarSettings.subscriptionOnly) || "FREE SHIPPING (US ONLY)";
    }
    // check if the shipping statuse bar should display based on user location
    var getUserLocationInfo = (0,useIpFetcher/* useIpFetcher */.X)().getUserLocationInfo;
    var ref5 = (0,react.useState)(true), shouldShowShippingBar = ref5[0], setShouldShowShippingBar = ref5[1];
    (0,react.useEffect)(function() {
        if ((shippingBarSettings === null || shippingBarSettings === void 0 ? void 0 : shippingBarSettings.usOnly) === true) {
            var userLocationInfo = getUserLocationInfo();
            if ((userLocationInfo === null || userLocationInfo === void 0 ? void 0 : userLocationInfo.country_code) && userLocationInfo.country_code !== "US") {
                setShouldShowShippingBar(false);
            }
        }
    }, [
        cartOpen
    ]);
    var cartWrapper = (0,react.useRef)(null);
    var ref6 = (0,react.useState)(false), isOverflowing = ref6[0], setIsOverflowing = ref6[1];
    (0,react.useEffect)(function() {
        var element = cartWrapper.current;
        if (!element || !cartOpen) return undefined;
        var checkIsOverflowing = function() {
            if (!element) return;
            var newIsOverflowing = element.scrollHeight > element.clientHeight;
            setIsOverflowing(function(prev) {
                return prev !== newIsOverflowing ? newIsOverflowing : prev;
            });
        };
        var throttledCheckIsOverflowing = (0,lodash.throttle)(checkIsOverflowing, 100);
        var resizeObserver = new ResizeObserver(function() {
            throttledCheckIsOverflowing();
        });
        var mutationObserver = new MutationObserver(function() {
            throttledCheckIsOverflowing();
        });
        mutationObserver.observe(element, {
            childList: true,
            subtree: true
        });
        resizeObserver.observe(element);
        // Initial check
        checkIsOverflowing();
        // Cleanup observers
        return function() {
            resizeObserver.disconnect();
            mutationObserver.disconnect();
            if (throttledCheckIsOverflowing.cancel) {
                throttledCheckIsOverflowing.cancel();
            }
        };
    }, [
        cartOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("aside", {
        className: "group fixed left-full top-0 z-[70] flex h-full w-full flex-col justify-between overflow-hidden bg-[#fff] text-[var(--primary)] transition md:max-w-[460px] ".concat(cartOpen ? "pointer-events-auto -translate-x-full" : "pointer-events-none translate-x-0", "\n      ").concat(isCartPage() ? "hidden" : null, "\n      ").concat(isOverflowing ? "is-overflowing" : ""),
        children: cartOpen && !isCartPage() && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CartHeader, {
                    closeCart: closeCart,
                    heading: settings === null || settings === void 0 ? void 0 : (ref1 = settings.cart) === null || ref1 === void 0 ? void 0 : ref1.heading,
                    announcement: settings === null || settings === void 0 ? void 0 : (ref2 = settings.cart) === null || ref2 === void 0 ? void 0 : ref2.announcement
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FreeShippingMeter, {}),
                !!(cartItems === null || cartItems === void 0 ? void 0 : cartItems.length) && !!shouldShowShippingBar && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "px-[18px]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "border-b-2 pb-2 text-center text-xs ".concat(isOnlySubscriptionItems ? "border-[var(--success)]" : "relative border-[#E9E9EB] before:absolute before:-bottom-[2px] before:block before:h-[2px] before:w-1/2 before:bg-warning"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex justify-start",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "mr-2 flex items-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "block h-2 w-2 rounded-lg ".concat(isOnlySubscriptionItems ? "bg-[var(--success)]" : "bg-[var(--warning)]")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "font-normal text-[#343B49]",
                                    children: shippingBarText
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    id: "cart-wrapper",
                    ref: cartWrapper,
                    className: "cart__wrapper relative flex-1 overflow-y-auto scrollbar-hide",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            children: (cartItems === null || cartItems === void 0 ? void 0 : cartItems.length) ? cartItems.map(function(item) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartItem, {
                                        item: item,
                                        closeCart: closeCart,
                                        setIsUpdating: setIsUpdating
                                    })
                                }, item.id);
                            }) : !isUpdating && /*#__PURE__*/ (0,jsx_runtime.jsx)(CartEmpty, {
                                closeCart: closeCart
                            })
                        }),
                        !!beamSettings && !!(cartItems === null || cartItems === void 0 ? void 0 : cartItems.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "p-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "border border-[#E9E9EB] bg-[#F2F7FB] p-[18px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Beam/* BeamSelectNonprofit */.hR, {})
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative group-[.is-overflowing]:shadow-[0px_0px_20px_0px_rgba(0,0,0,0.25)]",
                    children: [
                        enabledUpsell && /*#__PURE__*/ (0,jsx_runtime.jsx)(CartUpsell, {
                            closeCart: closeCart
                        }),
                        !!(cartItems === null || cartItems === void 0 ? void 0 : cartItems.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CartDiscount, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CartTotals, {})
                    ]
                })
            ]
        })
    });
}
Cart.displayName = "Cart";

;// CONCATENATED MODULE: ./src/snippets/Cart/CartPage.jsx












function CartPage() {
    var ref;
    var settings = (0,dist.useSettings)();
    var cartItems = (0,hooks/* useCartItems */._P)();
    var asPath = (0,next_router.useRouter)().asPath;
    var beamSettings = settings === null || settings === void 0 ? void 0 : settings.beam;
    var isCartPage = function() {
        return asPath === "/cart";
    };
    var ref1 = (0,contexts/* useGlobalContext */.b)(), closeCart = ref1.actions.closeCart;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "md-px-contained py-contained bg-[#fff] [&_.cart-header-heading]:normal-case md:[&_.cart-header-heading]:text-[36px] md:[&_.cart-header-heading]:font-light",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mx-auto lg:max-w-[710px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CartHeader, {
                    closeCart: closeCart,
                    heading: settings === null || settings === void 0 ? void 0 : (ref = settings.cart) === null || ref === void 0 ? void 0 : ref.heading,
                    isCartPage: isCartPage()
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FreeShippingMeter, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "relative flex-1 overflow-y-auto scrollbar-hide",
                    children: (cartItems === null || cartItems === void 0 ? void 0 : cartItems.length) ? cartItems.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartItem, {
                                item: item,
                                closeCart: closeCart
                            })
                        }, item.id);
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CartEmpty, {
                        closeCart: closeCart
                    })
                }),
                !!beamSettings && !!(cartItems === null || cartItems === void 0 ? void 0 : cartItems.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "px-4 py-6",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Beam/* BeamSelectNonprofit */.hR, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "[&_.discount-code-wrapper]:bg-transparent",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartDiscount, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CartTotals, {})
            ]
        })
    });
}
CartPage.displayName = "CartPage";

;// CONCATENATED MODULE: ./src/snippets/Cart/index.js



;// CONCATENATED MODULE: ./src/snippets/ContaminantResultCard/ContaminantResultCard.jsx





function ContaminantResultCard(param) {
    var contaminant = param.contaminant, alternate = param.alternate;
    var ref = (0,_object_spread/* default */.Z)({}, contaminant), ContaminantName = ref.ContaminantName, // ContaminantHealthRisks,
    SystemAverage = ref.SystemAverage, ContaminantHGValue = ref.ContaminantHGValue, ClearlyFilteredData = ref.ClearlyFilteredData;
    var ref1 = (0,_object_spread/* default */.Z)({}, ClearlyFilteredData), category = ref1.category, healthConcern = ref1.healthConcern, percentRemoved = ref1.percentRemoved;
    var multiplier = Math.abs(parseFloat(SystemAverage / ContaminantHGValue).toFixed(2));
    var displayUnits = contaminant === null || contaminant === void 0 ? void 0 : contaminant.ContaminantDisplayUnits;
    // This assumes that the ewg measurement is always in ppm
    var convertMeasurement = function(measurement) {
        if (displayUnits === "ppm") {
            return measurement;
        }
        if (displayUnits === "ppb") {
            return measurement * 1000;
        }
        if (displayUnits === "ppt") {
            return measurement * 1000000;
        }
        return measurement;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "contaminant-card flex h-full bg-gradient-to-l from-[#2179C2] via-[#8DCEF9] to-[#F1DCC1] p-[2px] print:border print:bg-none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative flex w-full flex-col justify-between bg-white p-[30px]",
            children: [
                percentRemoved && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute right-[12px] top-[12px] flex h-[26px] w-[26px] items-center justify-center rounded-full border-[2px] border-secondary",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                        className: "w-[14px] text-secondary",
                        src: "/svgs/checkmark.svg#checkmark",
                        title: "Checkmark",
                        viewBox: "0 0 24 24"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        category && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Eyebrow */.j4, {
                            className: "card-eyebrow font-mono !text-sm uppercase tracking-[0.04em]",
                            children: category
                        }),
                        ContaminantName && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                            variant: "h5",
                            element: "h4",
                            className: "card-headline py-[6px] !text-[22px] font-normal",
                            children: ContaminantName
                        }),
                        healthConcern && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "card-health-concerns",
                            children: [
                                "Health Risk: ",
                                healthConcern
                            ]
                        })
                    ]
                }),
                alternate && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-4 py-[20px] text-left text-sm lg:pb-[60px] lg:pt-[30px]",
                    children: [
                        (contaminant === null || contaminant === void 0 ? void 0 : contaminant.SystemAverage) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mb-[10px] flex justify-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "uppercase",
                                    children: "This Utility"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        parseFloat(convertMeasurement(contaminant.SystemAverage)).toFixed(2),
                                        " ",
                                        displayUnits
                                    ]
                                })
                            ]
                        }),
                        (contaminant === null || contaminant === void 0 ? void 0 : contaminant.ContaminantHGValue) && (contaminant === null || contaminant === void 0 ? void 0 : contaminant.ContaminantHGValue) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mb-[10px] flex justify-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "uppercase",
                                    children: "EWG Health Guideline"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        parseFloat(convertMeasurement(contaminant.ContaminantHGValue)).toFixed(2),
                                        " ",
                                        displayUnits
                                    ]
                                })
                            ]
                        }),
                        (contaminant === null || contaminant === void 0 ? void 0 : contaminant.ContaminantHGValue) && (contaminant === null || contaminant === void 0 ? void 0 : contaminant.ContaminantHGValue) <= 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-[10px] flex justify-between text-[#797D86]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "uppercase",
                                children: "No EWG Guidelines"
                            })
                        }),
                        (contaminant === null || contaminant === void 0 ? void 0 : contaminant.ContaminantMCLValue) && parseFloat(contaminant.ContaminantMCLValue) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mb-[10px] flex justify-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "uppercase",
                                    children: "Legal Limit"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        Math.round(convertMeasurement(contaminant.ContaminantMCLValue)).toFixed(2),
                                        " ",
                                        displayUnits
                                    ]
                                })
                            ]
                        }),
                        (contaminant === null || contaminant === void 0 ? void 0 : contaminant.ContaminantMCLValue) && (contaminant === null || contaminant === void 0 ? void 0 : contaminant.ContaminantMCLValue) <= 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-[10px] flex justify-between text-[#797D86]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "uppercase",
                                children: "No Legal Limit"
                            })
                        })
                    ]
                }),
                !alternate && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "py-[20px] lg:pb-[60px] lg:pt-[30px]",
                    children: [
                        " ",
                        alternate,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                            variant: "h2",
                            element: "h5",
                            className: "text-primary",
                            children: ContaminantHGValue !== -1 ? "".concat(multiplier, "x") : "N/A"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                ContaminantHGValue === -1 && "No",
                                " EWG Health Guidelines"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "card-percent-removed text-secondary",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-[24px] h-[1px] bg-gradient-to-l from-[#2179C2] via-[#8DCEF9] to-[#F1DCC1] lg:my-[24px]"
                        }),
                        percentRemoved ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Eyebrow */.j4, {
                            className: "!text-[15px] uppercase",
                            children: "Clearly Filtered removes up to"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Eyebrow */.j4, {
                            className: "!text-[15px] uppercase text-shadowGray",
                            children: "Have not tested for"
                        }),
                        percentRemoved ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                            variant: "h2",
                            element: "h5",
                            className: "text-secondary",
                            children: percentRemoved
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                            variant: "h2",
                            element: "h5",
                            children: "\xa0"
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/snippets/ContaminantResultCard/index.js


;// CONCATENATED MODULE: ./src/snippets/ContaminantResultCardPrint/ContaminantResultCardPrint.jsx




function ContaminantResultCardPrint(param) {
    var contaminant = param.contaminant;
    var ref = (0,_object_spread/* default */.Z)({}, contaminant), ContaminantName = ref.ContaminantName, // ContaminantHealthRisks,
    SystemAverage = ref.SystemAverage, ContaminantHGValue = ref.ContaminantHGValue, ClearlyFilteredData = ref.ClearlyFilteredData;
    var ref1 = (0,_object_spread/* default */.Z)({}, ClearlyFilteredData), category = ref1.category, healthConcern = ref1.healthConcern, percentRemoved = ref1.percentRemoved;
    var multiplier = Math.abs(parseFloat(SystemAverage / ContaminantHGValue).toFixed(2));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative w-full break-inside-avoid overflow-y-visible border p-4",
        children: [
            percentRemoved && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-[12px] right-[12px] flex h-[26px] w-[26px] items-center justify-center rounded-full border-[2px] border-secondary",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                    className: "w-[14px] text-secondary",
                    src: "/svgs/checkmark.svg#checkmark",
                    title: "Checkmark",
                    viewBox: "0 0 24 24"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "float-left w-1/2",
                children: [
                    category && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-xs",
                        children: category
                    }),
                    ContaminantName && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "py-1",
                        children: ContaminantName
                    }),
                    healthConcern && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "text-sm",
                        children: [
                            "Health Risk: ",
                            healthConcern
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "float-left w-1/2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "mb-1 text-sm",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-semibold",
                                children: ContaminantHGValue !== -1 ? "".concat(multiplier, "x") : "N/A"
                            }),
                            " ",
                            ContaminantHGValue === -1 && "No",
                            " EWG Health Guidelines"
                        ]
                    }),
                    percentRemoved ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "text-sm",
                        children: [
                            "Clearly Filtered removes up to",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-base text-secondary",
                                children: percentRemoved
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-sm text-[#797D86]",
                        children: "Have not tested for"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "clear-both table overflow-auto"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/snippets/ContaminantResultCardPrint/index.js


// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(3615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(5341);
;// CONCATENATED MODULE: ./src/snippets/Collection/CollectionFilters/CollectionFilterOption.jsx





function CollectionFilterOption(param) {
    var activeFilters = param.activeFilters, addFilter = param.addFilter, count = param.count, isColor = param.isColor, name = param.name, removeFilter = param.removeFilter, showCount = param.showCount, swatchesMap = param.swatchesMap, value = param.value;
    var isActive = (0,react.useMemo)(function() {
        return Object.entries(activeFilters).some(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], values = _param[1];
            return key === name && values.some(function(v) {
                return v === value;
            });
        });
    }, [
        activeFilters,
        value
    ]);
    var swatch = null;
    var hasImage = false;
    if (isColor) {
        swatch = swatchesMap[value.toLowerCase().trim()];
        hasImage = swatch === null || swatch === void 0 ? void 0 : swatch.startsWith("http");
    }
    var colorBackground = isActive && swatch === "#FFFFFF" ? "var(--off-white)" : swatch || "var(--off-white)";
    var nonColorBackground = isActive ? "var(--black)" : "var(--off-white)";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        "aria-label": "Add ".concat(value, " to filters"),
        className: "flex gap-4 text-left text-base max-md:h-12 max-md:w-full max-md:items-center max-md:px-4 md:gap-2 ".concat(isActive ? "text-text max-md:font-bold" : "text-primary"),
        onClick: function() {
            if (isActive) {
                removeFilter({
                    key: name,
                    value: value
                });
            } else {
                addFilter({
                    key: name,
                    value: value
                });
            }
        },
        type: "button",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative flex h-6 w-6 items-center justify-center overflow-hidden border transition md:mt-[0.125rem] md:h-5 md:w-5 md:hover:border-text ".concat(isActive ? "border-text" : ""),
                style: {
                    backgroundColor: isColor ? colorBackground : nonColorBackground
                },
                children: [
                    hasImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                        alt: value,
                        className: "absolute left-1/2 top-1/2 h-full w-full -translate-x-1/2 -translate-y-1/2 object-cover",
                        height: "24",
                        width: "24",
                        src: swatch
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute left-1/2 top-1/2 flex h-full w-full -translate-x-1/2 -translate-y-1/2 items-center justify-center transition-[border-width] duration-100 ".concat(isActive ? "border-[2.5px] bg-primary md:border-[2px]" : "border-[0px] bg-white "),
                        children: isActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                            className: "absolute h-full w-full object-contain text-white",
                            src: "/svgs/checkmark.svg#checkmark",
                            title: "Check",
                            viewBox: "0 0 24 24"
                        }) : null
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "flex-1",
                children: value
            })
        ]
    });
}
CollectionFilterOption.displayName = "CollectionFilterOption";

;// CONCATENATED MODULE: ./src/snippets/Collection/CollectionFilters/CollectionDropdownFilter.jsx




function CollectionDropdownFilter(param) {
    var activeFilters = param.activeFilters, addFilter = param.addFilter, _defaultOpen = param.defaultOpen, defaultOpen = _defaultOpen === void 0 ? false : _defaultOpen, filter = param.filter, removeFilter = param.removeFilter, showCount = param.showCount, swatchesMap = param.swatchesMap;
    var ref, ref1;
    var ref2 = (0,react.useState)(defaultOpen), isOpen = ref2[0], setIsOpen = ref2[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative mt-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                "aria-label": filter.label,
                className: "relative z-10 mb-4 flex h-14 w-full items-center justify-between gap-4 border-b border-[#E9E9EB] bg-white px-[20px] py-[10px] text-left font-light max-md:px-4 ".concat(isOpen ? "md:rounded-[68px] md:border md:border-primary" : "md:rounded-[68px] md:border"),
                onClick: function() {
                    return setIsOpen(!isOpen);
                },
                type: "button",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                        className: "mr-[12px] text-base font-light max-md:text-sm max-md:font-[400] max-md:uppercase",
                        children: [
                            "By ",
                            filter.label,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "ml-2 inline-block w-[40px]",
                                children: ((ref = activeFilters[filter.name]) === null || ref === void 0 ? void 0 : ref.length) ? "(".concat((ref1 = activeFilters[filter.name]) === null || ref1 === void 0 ? void 0 : ref1.length, ")") : ""
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                        className: "w-4 text-text ".concat(isOpen ? "rotate-[270deg] scale-x-50 scale-y-75" : "rotate-90 scale-x-50 scale-y-75"),
                        src: "/svgs/play.svg#play",
                        title: "Chevron",
                        viewBox: "0 0 24 24"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "w-full flex-col border-[#E9E9EB] bg-white md:absolute md:-translate-y-12 md:items-start md:gap-2 md:rounded-b-[21px] md:border md:p-4 md:pt-12 ".concat(isOpen ? "flex" : "hidden"),
                children: filter.values.map(function(param, index) {
                    var count = param.count, value = param.value;
                    return value && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionFilterOption, {
                            activeFilters: activeFilters,
                            addFilter: addFilter,
                            count: count,
                            isColor: filter.isColor,
                            name: filter.name,
                            removeFilter: removeFilter,
                            showCount: showCount,
                            swatchesMap: swatchesMap,
                            value: value
                        })
                    }, index);
                })
            })
        ]
    });
}
CollectionDropdownFilter.displayName = "CollectionDropdownFilter";

;// CONCATENATED MODULE: ./src/snippets/Collection/CollectionFilters/CollectionFiltersSummary.jsx





function CollectionFiltersSummary(param) {
    var activeFilters = param.activeFilters, clearFilters = param.clearFilters, filtersMap = param.filtersMap, removeFilter = param.removeFilter;
    var activeFiltersList = (0,react.useMemo)(function() {
        var filterEntries = Object.entries(activeFilters);
        if (!filterEntries.length) return [];
        return filterEntries.reduce(function(acc, param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), filterKey = _param[0], filterValues = _param[1];
            return (0,_to_consumable_array/* default */.Z)(acc).concat((0,_to_consumable_array/* default */.Z)(filterValues.map(function(value) {
                return {
                    key: filterKey,
                    value: value
                };
            })));
        }, []);
    }, [
        activeFilters
    ]);
    return activeFiltersList.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "p-4",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
            className: "flex flex-wrap gap-2",
            children: [
                activeFiltersList.map(function(param, index) {
                    var key = param.key, value = param.value;
                    var ref;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "max-w-full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            className: "group flex max-w-full items-center rounded-full border bg-[var(----clearBlue)] py-2 pl-2.5 pr-3 text-xs transition md:hover:bg-primary md:hover:text-white",
                            onClick: function() {
                                return removeFilter({
                                    key: key,
                                    value: value
                                });
                            },
                            type: "button",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex-1 truncate font-light",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                (ref = filtersMap[key]) === null || ref === void 0 ? void 0 : ref.label,
                                                ":"
                                            ]
                                        }),
                                        " ",
                                        value
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                                    className: "ml-1 w-2.5 text-text group-hover:text-white",
                                    src: "/svgs/close.svg#close",
                                    title: "Close",
                                    viewBox: "0 0 24 24"
                                })
                            ]
                        })
                    }, index);
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "flex items-center",
                    children: clearFilters && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "ml-4 border-l pl-2 font-light",
                        onClick: clearFilters,
                        type: "button",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-[var(--textLink)]",
                            children: "Clear All"
                        })
                    })
                })
            ]
        })
    }) : null;
}
CollectionFiltersSummary.displayName = "CollectionFiltersSummary";

;// CONCATENATED MODULE: ./src/snippets/Collection/CollectionMenuSidebar.jsx





function CollectionMenuSidebar(param) {
    var children = param.children, isOpen = param.isOpen, setIsOpen = param.setIsOpen, title = param.title, totalFilters = param.totalFilters, clearFilters = param.clearFilters;
    var ref = (0,hooks/* useBodyScrollLock */.yn)(), lockBodyScroll = ref.lockBodyScroll, unlockBodyScroll = ref.unlockBodyScroll;
    (0,react.useEffect)(function() {
        if (isOpen) {
            lockBodyScroll();
        } else {
            unlockBodyScroll();
        }
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat(isOpen ? "translate-x-0" : "translate-x-full", " position fixed inset-0 z-[100] flex h-full w-full flex-col bg-white pt-[calc(60px+var(--promobar-height))] transition md:!hidden md:pt-[calc(var(--header-height)+var(--promobar-height))]"),
        children: isOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative flex h-14 items-center justify-between gap-4 border-b border-border px-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                            className: "text-center text-lg text-[20px] font-light",
                            children: [
                                title,
                                " ",
                                totalFilters ? "(".concat(totalFilters, ")") : null
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "",
                                onClick: function() {
                                    return setIsOpen(false);
                                },
                                type: "button",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                                    className: "w-[1.25rem] text-black",
                                    src: "/svgs/close.svg#close",
                                    title: "Close",
                                    viewBox: "0 0 24 24"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative flex-1 overflow-y-auto p-4 scrollbar-hide",
                    children: children
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex w-full gap-[20px] p-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                            variant: "outlined",
                            theme: "primary",
                            className: "flex-1 !border-primary text-[14px] !text-primary hover:!text-white focus:!text-white active:!text-white",
                            onClick: clearFilters,
                            children: "Clear All"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                            className: "flex-1 text-[14px]",
                            variant: "filled",
                            theme: "primary",
                            onClick: function() {
                                return setIsOpen(false);
                            },
                            children: "Apply Filters"
                        })
                    ]
                })
            ]
        })
    });
}
CollectionMenuSidebar.displayName = "CollectionMenuSidebar";

;// CONCATENATED MODULE: ./src/snippets/Collection/CollectionFilters/CollectionMobileFilters.jsx






function CollectionMobileFilters(param) {
    var activeFilters = param.activeFilters, addFilter = param.addFilter, clearFilters = param.clearFilters, collectionCount = param.collectionCount, filters = param.filters, filtersMap = param.filtersMap, removeFilter = param.removeFilter, showCount = param.showCount, swatchesMap = param.swatchesMap;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var totalFilters = (0,react.useMemo)(function() {
        return Object.values(activeFilters || {}).reduce(function(acc, filterValues) {
            return acc + filterValues.length;
        }, 0);
    }, [
        activeFilters
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                "aria-label": "Open filters sidebar",
                className: "mx-auto mt-8 flex w-full max-w-[230px] items-center justify-center rounded-[68px] border border-[#BCBEC2] px-[64px] py-[10px] text-sm font-light",
                onClick: function() {
                    return setIsOpen(!isOpen);
                },
                type: "button",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                        className: "mr-4 w-[26px] text-black",
                        src: "/svgs/filter.svg#filter",
                        title: "Filter",
                        viewBox: "0 0 26 26"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-1 items-center gap-2 overflow-hidden xs:gap-3",
                        children: [
                            "Filter ",
                            totalFilters > 0 ? "(".concat(totalFilters, ")") : null
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CollectionMenuSidebar, {
                totalFilters: totalFilters,
                clearFilters: clearFilters,
                isOpen: isOpen,
                setIsOpen: setIsOpen,
                title: "Filters",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "sticky top-0 z-[1] border-b border-border bg-background p-4 pt-5 max-md:hidden",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mb-4 flex justify-between gap-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                        className: "text-nav",
                                        children: [
                                            "Filters Summary",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-xs",
                                                children: totalFilters ? "(".concat(totalFilters, ")") : ""
                                            })
                                        ]
                                    }),
                                    totalFilters > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "text-label text-main-underline",
                                        onClick: clearFilters,
                                        type: "button",
                                        children: "Clear All"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "max-h-[4.5rem] min-h-[2rem] overflow-y-auto scrollbar-hide",
                                children: totalFilters ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionFiltersSummary, {
                                    activeFilters: activeFilters,
                                    filtersMap: filtersMap,
                                    removeFilter: removeFilter
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "leading-[2rem] text-mediumGray",
                                    children: "No filters selected yet"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        children: filters.map(function(filter, index) {
                            if (!filter.values.length || filter.values.length === 1) return null;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionDropdownFilter, {
                                    activeFilters: activeFilters,
                                    addFilter: addFilter,
                                    defaultOpen: true,
                                    filter: filter,
                                    removeFilter: removeFilter,
                                    showCount: showCount,
                                    swatchesMap: swatchesMap
                                })
                            }, index);
                        })
                    })
                ]
            })
        ]
    });
}
CollectionMobileFilters.displayName = "CollectionMobileFilters";

;// CONCATENATED MODULE: ./src/snippets/Collection/CollectionFilters/CollectionFilters.jsx





function CollectionFilters(param) {
    var collectionCount = param.collectionCount, collectionFiltersData = param.collectionFiltersData, swatchesMap = param.swatchesMap;
    var ref, ref1;
    var settings = (0,dist.useSettings)();
    var showCount = settings === null || settings === void 0 ? void 0 : (ref = settings.collection) === null || ref === void 0 ? void 0 : (ref1 = ref.filters) === null || ref1 === void 0 ? void 0 : ref1.showCount;
    var _state = collectionFiltersData.state, activeFilters = _state.activeFilters, filters = _state.filters, filtersMap = _state.filtersMap, _actions = collectionFiltersData.actions, addFilter = _actions.addFilter, removeFilter = _actions.removeFilter, clearFilters = _actions.clearFilters;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-5",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative z-30 md:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionMobileFilters, {
                    activeFilters: activeFilters,
                    addFilter: addFilter,
                    clearFilters: clearFilters,
                    collectionCount: collectionCount,
                    filters: filters,
                    filtersMap: filtersMap,
                    removeFilter: removeFilter,
                    showCount: showCount,
                    swatchesMap: swatchesMap
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mx-4 flex items-center justify-between border-b border-b-[#E9E9EB] pb-4 md:pb-8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-shadowGray",
                                children: [
                                    collectionCount,
                                    " Items"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "flex justify-end gap-[20px] max-md:hidden",
                                children: filters.map(function(filter, index) {
                                    if (!filter.values.length || filter.values.length === 1) return null;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionDropdownFilter, {
                                            activeFilters: activeFilters,
                                            addFilter: addFilter,
                                            defaultOpen: filter.defaultOpen,
                                            filter: filter,
                                            removeFilter: removeFilter,
                                            showCount: showCount,
                                            swatchesMap: swatchesMap
                                        })
                                    }, index);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionFiltersSummary, {
                            activeFilters: activeFilters,
                            clearFilters: clearFilters,
                            filtersMap: filtersMap,
                            removeFilter: removeFilter
                        })
                    })
                ]
            })
        ]
    });
}
CollectionFilters.displayName = "CollectionFilters";

;// CONCATENATED MODULE: ./src/snippets/Collection/CollectionFilters/index.js


// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(7599);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(169);
// EXTERNAL MODULE: ../node_modules/react-intersection-observer/index.mjs
var react_intersection_observer = __webpack_require__(205);
;// CONCATENATED MODULE: ./src/snippets/Collection/CollectionPromoTile.jsx







function CollectionPromoTile(param) {
    var tile = param.tile;
    var ref;
    var ref1 = (0,react_intersection_observer/* useInView */.YD)({
        rootMargin: "0px",
        triggerOnce: true
    }), ref2 = ref1.ref, inView = ref1.inView;
    var background = tile.background, link = tile.link, text = tile.text;
    var ref3 = (0,_object_spread/* default */.Z)({}, background), bgColor = ref3.bgColor, overlayOpacity = ref3.overlayOpacity, image = ref3.image, videoPoster = ref3.videoPoster, videoSrc = ref3.videoSrc;
    var ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
        "aria-label": (text === null || text === void 0 ? void 0 : text.heading) || (link === null || link === void 0 ? void 0 : link.text),
        className: "h-full",
        href: link === null || link === void 0 ? void 0 : link.url,
        newTab: link === null || link === void 0 ? void 0 : link.newTab,
        ref: ref2,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative h-full overflow-hidden",
            style: {
                backgroundColor: image ? "var(--off-white)" : bgColor
            },
            children: [
                videoSrc && /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                    autoPlay: true,
                    className: "absolute inset-0 h-full w-full object-cover",
                    controls: false,
                    loop: true,
                    muted: true,
                    playsInline: true,
                    poster: videoPoster === null || videoPoster === void 0 ? void 0 : videoPoster.src,
                    children: inView && /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                        src: videoSrc,
                        type: "video/mp4"
                    })
                }),
                (image === null || image === void 0 ? void 0 : image.src) && !videoSrc && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                    alt: (ref4 = text === null || text === void 0 ? void 0 : text.heading) !== null && ref4 !== void 0 ? ref4 : "Promo Tile",
                    fill: true,
                    sizes: "(max-width: 768px) 33vw, 66vw",
                    src: image.src
                }),
                (videoSrc || (image === null || image === void 0 ? void 0 : image.src)) && overlayOpacity !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        opacity: overlayOpacity / 100
                    },
                    className: "pointer-events-none absolute inset-0 h-full w-full bg-black"
                }),
                ((text === null || text === void 0 ? void 0 : text.heading) || (text === null || text === void 0 ? void 0 : text.subtext) || (text === null || text === void 0 ? void 0 : text.supertext)) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative flex h-full items-center justify-center px-4 text-center",
                    style: {
                        color: text === null || text === void 0 ? void 0 : text.textColor
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full max-w-[672px] px-2 py-6 sm:p-8",
                        children: [
                            (text === null || text === void 0 ? void 0 : text.icon) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                className: "mx-auto mb-8",
                                sizes: "44px",
                                width: "44px",
                                height: "44px",
                                src: text === null || text === void 0 ? void 0 : (ref = text.icon) === null || ref === void 0 ? void 0 : ref.src
                            }),
                            (text === null || text === void 0 ? void 0 : text.supertext) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: " mb-5 inline-block uppercase max-sm:!text-[10px] ".concat((text === null || text === void 0 ? void 0 : text.supertextStyle) === "bubble" ? "rounded-[50px] border border-white px-[1rem] py-[0.5rem] text-[18px] lg:mt-[200px]" : "text-sm"),
                                children: text === null || text === void 0 ? void 0 : text.supertext
                            }),
                            (text === null || text === void 0 ? void 0 : text.heading) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Headline */.s0, {
                                className: (text === null || text === void 0 ? void 0 : text.headingSize) === "large" ? "max-sm:!text-[18px]" : "max-sm:!text-[11px]",
                                variant: (text === null || text === void 0 ? void 0 : text.headingSize) === "large" ? "h2" : "h5",
                                element: "h3",
                                children: text.heading
                            }) : null,
                            (text === null || text === void 0 ? void 0 : text.subtext) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-4 leading-normal max-sm:text-[7px] lg:text-base",
                                children: text === null || text === void 0 ? void 0 : text.subtext
                            }),
                            (text === null || text === void 0 ? void 0 : text.bottomAccentEnabled) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex h-[80px] items-center justify-center opacity-50 after:block after:h-[32px] after:border-l after:border-l-white after:content-[''] sm:h-[150px] sm:after:h-[80px]"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-[80px] sm:h-[150px]"
                            }),
                            (text === null || text === void 0 ? void 0 : text.bottomButton) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                                theme: text === null || text === void 0 ? void 0 : text.bottomButtonTheme,
                                variant: text === null || text === void 0 ? void 0 : text.bottomButtonVariant,
                                className: "text-[11px] sm:text-sm",
                                children: text === null || text === void 0 ? void 0 : text.bottomButton
                            })
                        ]
                    })
                })
            ]
        })
    });
}
CollectionPromoTile.displayName = "CollectionPromoTile";

// EXTERNAL MODULE: ./src/snippets/Okendo/OkendoStarRating.jsx
var OkendoStarRating = __webpack_require__(391);
// EXTERNAL MODULE: ./src/snippets/ProductItem/ColorVariantSelector/index.js + 3 modules
var ColorVariantSelector = __webpack_require__(5900);
// EXTERNAL MODULE: ./src/snippets/ProductItem/ProductItemMedia/ProductItemMedia.jsx + 2 modules
var ProductItemMedia = __webpack_require__(8766);
;// CONCATENATED MODULE: ./src/snippets/ProductItem/ProductItemPrice.jsx


function ProductItemPrice(param) {
    var variant = param.variant, className = param.className;
    var ref = (0,hooks/* useVariantPrices */.be)({
        variant: variant
    }), price = ref.price, compareAtPrice = ref.compareAtPrice;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mt-1 flex flex-wrap gap-x-1 ".concat(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "text-[10px] font-light md:text-base",
            children: [
                "From",
                compareAtPrice && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "text-mediumGray line-through",
                    children: [
                        " ",
                        compareAtPrice
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        " ",
                        price
                    ]
                })
            ]
        })
    });
}
ProductItemPrice.displayName = "ProductItemPrice";

;// CONCATENATED MODULE: ./src/snippets/ProductItem/QuickShop/QuickShopOption.jsx







function QuickShopOption(param) {
    var inventory = param.inventory, inventoryStatus = param.inventoryStatus, optionName = param.optionName, value = param.value, variant = param.variant, variants = param.variants;
    var ref;
    var ref1 = (0,contexts/* useGlobalContext */.b)(), openCart = ref1.actions.openCart;
    var cartAddItem = (0,dist.useCartAddItem)().cartAddItem;
    var ref2 = (0,react.useState)(false), isAdding = ref2[0], setIsAdding = ref2[1];
    var variantToAdd = (0,react.useMemo)(function() {
        return variants.find(function(_variant) {
            var ref, ref1;
            var color = _variant.selectedOptionsMap.Color;
            return ((ref = _variant.product) === null || ref === void 0 ? void 0 : ref.handle) === (variant === null || variant === void 0 ? void 0 : (ref1 = variant.product) === null || ref1 === void 0 ? void 0 : ref1.handle) && _variant.selectedOptionsMap[optionName] === value && (!color || color === (variant === null || variant === void 0 ? void 0 : variant.selectedOptionsMap.Color));
        });
    }, [
        variant === null || variant === void 0 ? void 0 : variant.id,
        value
    ]);
    var variantInventory = inventory === null || inventory === void 0 ? void 0 : (ref = inventory.variants) === null || ref === void 0 ? void 0 : ref[variantToAdd === null || variantToAdd === void 0 ? void 0 : variantToAdd.id];
    var variantIsSoldOut = (inventoryStatus === null || inventoryStatus === void 0 ? void 0 : inventoryStatus.success) && !(variantInventory === null || variantInventory === void 0 ? void 0 : variantInventory.availableForSale);
    // const variantIsPreorder =
    //   !variantIsSoldOut && variantInventory?.currentlyNotInStock;
    var handleAddToCart = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(variantToAdd === null || variantToAdd === void 0 ? void 0 : variantToAdd.id) || !(inventoryStatus === null || inventoryStatus === void 0 ? void 0 : inventoryStatus.success) || isAdding) return [
                        2
                    ];
                    setIsAdding(true);
                    return [
                        4,
                        cartAddItem({
                            merchandiseId: variantToAdd.id,
                            quantity: 1
                        })
                    ];
                case 1:
                    _state.sent();
                    setIsAdding(false);
                    openCart();
                    return [
                        2
                    ];
            }
        });
    }), [
        variantToAdd === null || variantToAdd === void 0 ? void 0 : variantToAdd.id,
        inventoryStatus === null || inventoryStatus === void 0 ? void 0 : inventoryStatus.success,
        isAdding
    ]);
    var disabled = !variantToAdd || variantIsSoldOut;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        "aria-label": value,
        className: "group/option flex h-full w-full items-center justify-center whitespace-nowrap text-center text-sm transition ".concat(disabled ? "cursor-not-allowed text-gray" : "cursor-pointer hover:bg-black hover:text-white"),
        disabled: disabled,
        onClick: handleAddToCart,
        type: "button",
        children: isAdding ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "text-mediumGray group-hover/option:text-white",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {})
        }) : value
    });
}
QuickShopOption.displayName = "QuickShopOption";

;// CONCATENATED MODULE: ./src/snippets/ProductItem/QuickShop/QuickShopOptions.jsx





function QuickShopOptions(param) {
    var quickShopMultiText = param.quickShopMultiText, product = param.product, variant = param.variant;
    var ref, ref1;
    var variantHandle = variant === null || variant === void 0 ? void 0 : (ref = variant.product) === null || ref === void 0 ? void 0 : ref.handle;
    var _ref = (0,dist.useProductInventoryByHandle)({
        handle: variantHandle,
        withInventory: false
    }), inventory = _ref.inventory, inventoryStatus = (0,_object_without_properties/* default */.Z)(_ref, [
        "inventory"
    ]);
    var option = (0,react.useMemo)(function() {
        var ref;
        if (!product) return {
            name: "",
            values: [],
            text: ""
        };
        var options = (product === null || product === void 0 ? void 0 : (ref = product.grouping) === null || ref === void 0 ? void 0 : ref.isTransformed) ? product.grouping.options : product.options;
        var _option = options.find(function(param) {
            var name = param.name;
            return name !== "Color";
        });
        return {
            name: _option === null || _option === void 0 ? void 0 : _option.name,
            values: (_option === null || _option === void 0 ? void 0 : _option.values) || [],
            text: quickShopMultiText === null || quickShopMultiText === void 0 ? void 0 : quickShopMultiText.replace("{{option}}", _option === null || _option === void 0 ? void 0 : _option.name)
        };
    }, [
        quickShopMultiText,
        product === null || product === void 0 ? void 0 : product.id
    ]);
    var variants = (product === null || product === void 0 ? void 0 : (ref1 = product.grouping) === null || ref1 === void 0 ? void 0 : ref1.isTransformed) ? product.grouping.variants : product === null || product === void 0 ? void 0 : product.variants;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "group/quickshop relative flex h-[3.125rem] w-full items-center justify-center overflow-hidden rounded border border-black",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "btn-text truncate px-3",
                children: option.text
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "invisible absolute inset-0 grid h-full w-full bg-background group-hover/quickshop:visible group-focus/quickshop:visible",
                style: {
                    gridTemplateColumns: "repeat(".concat(option.values.length, ", 1fr)")
                },
                children: option.values.map(function(value) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "overflow-hidden border-r border-black last:border-none",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuickShopOption, {
                            optionName: "Size",
                            inventory: inventory,
                            inventoryStatus: inventoryStatus,
                            variant: variant,
                            value: value,
                            variants: variants
                        })
                    }, value);
                })
            })
        ]
    });
}
QuickShopOptions.displayName = "QuickShopOptions";

;// CONCATENATED MODULE: ./src/snippets/ProductItem/QuickShop/QuickShop.jsx






function QuickShop(param) {
    var enabledColorSelector = param.enabledColorSelector, product = param.product, variant = param.variant;
    var ref, ref1, ref2, ref3;
    var settings = (0,dist.useSettings)();
    var ref4 = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.collection) === null || ref === void 0 ? void 0 : ref.productItem), quickShopMultiText = ref4.quickShopMultiText, quickShopSingleText = ref4.quickShopSingleText;
    var qualifiesForQuickShop = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3;
        if (!product) return false;
        var initialOptions = ((ref = product.grouping) === null || ref === void 0 ? void 0 : ref.isTransformed) ? product.grouping.options : product.options;
        var options = enabledColorSelector ? initialOptions.filter(function(option) {
            return option.name !== "Color";
        }) : initialOptions;
        var hasOnlySingleValueOptions = options.every(function(option) {
            return option.values.length === 1;
        }) || false;
        var hasOnlyOneOptionWithMultipleValues = options.reduce(function(acc, option) {
            return acc + (option.values.length > 1 ? 1 : 0);
        }, 0) === 1 || false;
        var hasColorOptionWithMultipleValues = enabledColorSelector ? false : ((ref1 = product.grouping) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.optionsMap) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.Color) === null || ref3 === void 0 ? void 0 : ref3.length) > 1 || false;
        return (hasOnlySingleValueOptions || hasOnlyOneOptionWithMultipleValues) && !hasColorOptionWithMultipleValues;
    }, [
        enabledColorSelector,
        product === null || product === void 0 ? void 0 : product.id,
        variant === null || variant === void 0 ? void 0 : variant.id
    ]);
    var hasOneVariant = !(product === null || product === void 0 ? void 0 : (ref1 = product.grouping) === null || ref1 === void 0 ? void 0 : ref1.isTransformed) && (product === null || product === void 0 ? void 0 : (ref2 = product.variants) === null || ref2 === void 0 ? void 0 : ref2.length) === 1;
    return qualifiesForQuickShop ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mt-5 hidden opacity-0 transition group-hover:opacity-100 md:block lg:mt-6",
        children: [
            hasOneVariant && /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCart/* AddToCart */.o, {
                addToCartText: quickShopSingleText,
                className: "btn-inverse-dark",
                selectedVariant: product === null || product === void 0 ? void 0 : (ref3 = product.variants) === null || ref3 === void 0 ? void 0 : ref3[0]
            }),
            !hasOneVariant && variant && /*#__PURE__*/ (0,jsx_runtime.jsx)(QuickShopOptions, {
                quickShopMultiText: quickShopMultiText,
                product: product,
                variant: variant
            })
        ]
    }) : null;
}
QuickShop.displayName = "QuickShop";

;// CONCATENATED MODULE: ./src/snippets/ProductItem/QuickShop/index.js


;// CONCATENATED MODULE: ./src/snippets/ProductItem/ProductItem.jsx












function ProductItem(param) {
    var enabledColorNameOnHover = param.enabledColorNameOnHover, enabledColorSelector = param.enabledColorSelector, enabledQuickShop = param.enabledQuickShop, enabledStarRating = param.enabledStarRating, handle = param.handle, index = param.index, isSearchPage = param.isSearchPage, onClick = param.onClick, swatchesMap = param.swatchesMap, _disableHoverEffect = param.disableHoverEffect, disableHoverEffect = _disableHoverEffect === void 0 ? false : _disableHoverEffect, _disableBackground = param.disableBackground, disableBackground = _disableBackground === void 0 ? false : _disableBackground, searchTerm = param.searchTerm;
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,react_intersection_observer/* useInView */.YD)({
        rootMargin: "400px",
        triggerOnce: true
    }), ref6 = ref5.ref, inView = ref5.inView;
    var product = (0,dist.useProductByHandle)({
        handle: handle,
        fetchOnMount: inView
    }).product;
    var sendClickProductItemEvent = (0,hooks/* useDataLayerActions */.KZ)().sendClickProductItemEvent;
    var ref7 = (0,react.useState)(null), variantFromColor = ref7[0], setVariantFromColor = ref7[1];
    var variantParamId = (variantFromColor === null || variantFromColor === void 0 ? void 0 : variantFromColor.legacyResourceId) || (product === null || product === void 0 ? void 0 : product.legacyResourceId);
    var variantParam = "";
    if (variantParamId) {
        variantParam = "?variant=".concat(variantParamId);
    }
    var variant = variantFromColor || (product === null || product === void 0 ? void 0 : (ref = product.variants) === null || ref === void 0 ? void 0 : ref[0]);
    var productUrl = variant ? "/products/".concat((ref1 = variant.product) === null || ref1 === void 0 ? void 0 : ref1.handle).concat(variantParam) : "";
    var color = variant === null || variant === void 0 ? void 0 : (ref2 = variant.selectedOptionsMap) === null || ref2 === void 0 ? void 0 : ref2.Color;
    var title = variant === null || variant === void 0 ? void 0 : (ref3 = variant.product) === null || ref3 === void 0 ? void 0 : ref3.title;
    var localized = (0,dist.useLocalizedVariant)({
        variant: variant
    }).localized;
    var handleClick = (0,react.useCallback)(function() {
        sendClickProductItemEvent({
            isSearchResult: isSearchPage,
            listIndex: index,
            localized: localized,
            product: product,
            searchTerm: searchTerm,
            selectedVariant: variant
        });
        if (typeof onClick === "function") onClick();
    }, [
        index,
        localized,
        product === null || product === void 0 ? void 0 : product.id,
        searchTerm,
        variant === null || variant === void 0 ? void 0 : variant.id
    ]);
    var metaFields = product === null || product === void 0 ? void 0 : product.metafields;
    var reviews = false;
    var calloutText = null;
    var calloutTextColor = "Black";
    var calloutTextColorMap = {
        Black: "#242627",
        Secondary: "#0064B7",
        "Medium Grey": "#989898",
        Error: "#8B0000",
        Success: "#5ABE8A"
    };
    metaFields === null || metaFields === void 0 ? void 0 : metaFields.forEach(function(metaField) {
        if (metaField.key === "plp_callout_text") {
            // the metaobject the metafield points at, resolved at build time by
            // transforms/product-metaobject-references
            calloutText = metaField === null || metaField === void 0 ? void 0 : metaField.reference;
        }
        if (metaField.key === "plp_callout_text_color") {
            calloutTextColor = metaField.value;
        }
        if (metaField.key === "ProductReviewsWidgetSnippet") {
            reviews = true;
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "group flex h-full flex-col justify-between",
        ref: ref6,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col items-start",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                        "aria-label": title,
                        className: "mb-3 w-full",
                        href: productUrl,
                        onClick: handleClick,
                        tabIndex: "-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductItemMedia/* ProductItemMedia */.V, {
                            disableBackground: disableBackground,
                            disableHoverEffect: disableHoverEffect,
                            product: product,
                            variant: variant,
                            variantFromColor: variantFromColor
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "min-h-[30px]",
                        children: enabledStarRating && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-[10px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                "aria-label": "Reviews for ".concat(title),
                                href: productUrl,
                                onClick: handleClick,
                                tabIndex: "-1",
                                children: reviews && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "okendo-widget-container text-primary [&_.oke-sr-count]:font-light max-md:[&_.oke-sr-count]:text-[10px] [&_svg]:h-[13px] ",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OkendoStarRating/* OkendoStarRating */.m, {
                                        productId: product === null || product === void 0 ? void 0 : product.legacyResourceId
                                    })
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                        "aria-label": title,
                        href: productUrl,
                        onClick: handleClick,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "text-sm font-light text-[#24293B] md:text-xl",
                            children: title
                        })
                    }),
                    (product === null || product === void 0 ? void 0 : (ref4 = product.tags) === null || ref4 === void 0 ? void 0 : ref4.includes("Affinity Technology")) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-2 mt-1 text-sm font-[300] text-[#797D86] md:text-[20px]",
                        children: "with Affinity Filtration Technology"
                    }),
                    enabledColorSelector && /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorVariantSelector/* ColorVariantSelector */.A, {
                        className: "mb-2 mt-[22px]",
                        enabledColorNameOnHover: enabledColorNameOnHover,
                        product: product,
                        setVariantFromColor: setVariantFromColor,
                        swatchesMap: swatchesMap,
                        variantFromColor: variantFromColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductItemPrice, {
                        variant: variant,
                        className: "mt-[15px]"
                    })
                ]
            }),
            enabledQuickShop && /*#__PURE__*/ (0,jsx_runtime.jsx)(QuickShop, {
                enabledColorSelector: enabledColorSelector,
                product: product,
                variant: variant
            }),
            (calloutText === null || calloutText === void 0 ? void 0 : calloutText.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    color: calloutTextColorMap[calloutTextColor]
                },
                className: "mt-[20px] flex items-center text-left text-[14px]",
                children: calloutText === null || calloutText === void 0 ? void 0 : calloutText.text
            })
        ]
    });
}
ProductItem.displayName = "ProductItem";
ProductItem.propTypes = {
    enabledColorNameOnHover: (prop_types_default()).bool,
    enabledColorSelector: (prop_types_default()).bool,
    enabledQuickShop: (prop_types_default()).bool,
    enabledStarRating: (prop_types_default()).bool,
    handle: (prop_types_default()).string,
    index: (prop_types_default()).number,
    isSearchPage: (prop_types_default()).bool,
    onClick: (prop_types_default()).func,
    swatchesMap: (prop_types_default()).object
};

;// CONCATENATED MODULE: ./src/snippets/ProductItem/index.js


;// CONCATENATED MODULE: ./src/snippets/Collection/CollectionGrid.jsx









function CollectionGrid(param) {
    var activeFilters = param.activeFilters, collectionProductsData = param.collectionProductsData, isSearchPage = param.isSearchPage, promoTiles = param.promoTiles, swatchesMap = param.swatchesMap, showHeading = param.showHeading;
    var settings = (0,dist.useSettings)();
    var ref = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : settings.collection), productItem = ref.productItem, productTypeGrids = ref.productTypeGrids;
    var hasActiveFilters = Object.keys(activeFilters).length > 0;
    var ref1 = (0,react.useState)([]), finalFilteredProducts = ref1[0], setFinalFilteredProducts = ref1[1];
    // Generate a map of Product Type -> Grid Columns
    var productTypeGridMap = {};
    productTypeGrids === null || productTypeGrids === void 0 ? void 0 : productTypeGrids.forEach(function(gridItem) {
        productTypeGridMap[gridItem.productType] = gridItem.productTypeGridCount;
    });
    var _state = collectionProductsData.state, filteredProducts = _state.filteredProducts, productsLimit = _state.productsLimit;
    // Group Product Cards into their respective Product Type Bins, include Promotion Cards
    // Fires Whenever "filteredProducts" changes - Usually on Filter Changing
    (0,react.useEffect)(function() {
        if (!filteredProducts.length) setFinalFilteredProducts([]);
        else {
            setFinalFilteredProducts([]);
            filteredProducts.slice(0, productsLimit).forEach(function(product, index) {
                var maxGridSize = 3;
                var gridSpan = 1;
                var promoTile = promoTiles === null || promoTiles === void 0 ? void 0 : promoTiles.find(function(param) {
                    var position = param.position;
                    return position === index + 1;
                });
                if (promoTile) {
                    var _productType;
                    maxGridSize = (_productType = productTypeGridMap[product.productType]) !== null && _productType !== void 0 ? _productType : maxGridSize;
                    gridSpan = promoTile.span > maxGridSize ? maxGridSize : promoTile.span;
                }
                var tileFragment = /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        promoTile && JSON.stringify(activeFilters) === "{}" && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            "data-mobile-span": "".concat(gridSpan >= 2 ? 2 : 1),
                            className: "promo-tile max-lg:[&.promo-tile[data-mobile-span!='2']]:!col-span-1 min-h-[256px] max-lg:[&.promo-tile[data-mobile-span='2']]:!col-span-2",
                            style: {
                                gridColumn: "span ".concat(gridSpan, " / span ").concat(gridSpan)
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionPromoTile, {
                                tile: promoTile
                            })
                        }, "promo-tile-".concat(product.id)),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            "data-prod-tags": JSON.stringify(product.tags),
                            "data-prod": product.handle,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductItem, {
                                enabledColorNameOnHover: productItem === null || productItem === void 0 ? void 0 : productItem.enabledColorNameOnHover,
                                enabledColorSelector: productItem === null || productItem === void 0 ? void 0 : productItem.enabledColorSelector,
                                enabledQuickShop: productItem === null || productItem === void 0 ? void 0 : productItem.enabledQuickShop,
                                enabledStarRating: productItem === null || productItem === void 0 ? void 0 : productItem.enabledStarRating,
                                handle: product.handle,
                                index: index,
                                isSearchPage: isSearchPage,
                                swatchesMap: swatchesMap
                            })
                        }, "collection-tile-".concat(product.id))
                    ]
                }, product.id);
                // Update the state of Final Filtered Products
                setFinalFilteredProducts(function(previousState) {
                    if (previousState[product.productType]) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, previousState), (0,_define_property/* default */.Z)({}, product.productType, (0,_to_consumable_array/* default */.Z)(previousState[product === null || product === void 0 ? void 0 : product.productType]).concat([
                            tileFragment, 
                        ])));
                    }
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, previousState), (0,_define_property/* default */.Z)({}, product.productType, [
                        tileFragment
                    ]));
                });
            });
        }
    }, [
        filteredProducts
    ]);
    // Return the Template for Collection Grid - Looping over 'finalFilteredProducts'
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /* With Product Type Headings */ Object.keys(finalFilteredProducts).length > 0 && (showHeading !== null && showHeading !== void 0 ? showHeading : true) && Object.keys(finalFilteredProducts).map(function(productType, productTypeIndex) {
                var _productType, _productType1, _productType2;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    style: {
                        gridTemplateColumns: "repeat(".concat((_productType = productTypeGridMap[productType]) !== null && _productType !== void 0 ? _productType : 3, ", 1fr)")
                    },
                    className: "mx-auto grid gap-x-4 gap-y-8 overflow-hidden px-4 max-lg:!grid-cols-2 xs:gap-x-5 md:px-0 [&:first-child_li:first-child]:mt-0 [&:first-child_li:first-child]:border-0",
                    children: [
                        Object.keys(finalFilteredProducts).length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            style: {
                                gridColumn: "span ".concat((_productType1 = productTypeGridMap[productType]) !== null && _productType1 !== void 0 ? _productType1 : 3, " / span ").concat((_productType2 = productTypeGridMap[productType]) !== null && _productType2 !== void 0 ? _productType2 : 3)
                            },
                            className: "col-span-3 mt-[20px] border-t border-[#E9E9EB] py-4 text-[20px] font-light max-lg:!col-span-2 md:mt-[72px] md:py-[36px] md:text-[36px]",
                            children: productType
                        }),
                        finalFilteredProducts[productType].map(function(collectionCard) {
                            return collectionCard;
                        })
                    ]
                }, "product-type-heading-".concat(productTypeIndex));
            }),
            /* Without Product Type Headings */ Object.keys(finalFilteredProducts).length > 0 && !showHeading && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "mx-auto grid grid-cols-3 gap-x-4 gap-y-8 overflow-hidden px-4 max-lg:!grid-cols-1 xs:gap-x-5 md:px-0 [&:first-child>li:first-child]:mt-0 [&:first-child>li:first-child]:border-0 [&>li:first-child]:!border-0 [&>li]:border-t [&>li]:border-t-[#DDE2E7] [&>li]:pt-8 lg:[&>li]:border-t-0",
                children: Object.keys(finalFilteredProducts).map(function(productType, productTypeIndex) {
                    return finalFilteredProducts[productType].map(function(collectionCard) {
                        return collectionCard;
                    });
                })
            }),
            !(filteredProducts === null || filteredProducts === void 0 ? void 0 : filteredProducts.length) && hasActiveFilters && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex min-h-[12rem] items-center justify-center text-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "No products found matching these filters."
                })
            })
        ]
    });
}
CollectionGrid.displayName = "CollectionGrid";

;// CONCATENATED MODULE: ./src/snippets/Select/Select.jsx




function Select(param) {
    var _onSelect = param.onSelect, onSelect = _onSelect === void 0 ? function() {} : _onSelect, _options = param.options, options = _options === void 0 ? [] : _options, prefix = param.prefix, placeholder = param.placeholder, placeholderClass = param.placeholderClass, className = param.className, selectedOption = param.selectedOption;
    var ref = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(false), isOpen = ref1[0], setIsOpen = ref1[1];
    (0,react.useEffect)(function() {
        var outsideClickHandler = function(e) {
            if (!ref.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        if (isOpen) {
            document.addEventListener("click", outsideClickHandler);
        } else {
            document.removeEventListener("click", outsideClickHandler);
        }
        return function() {
            document.removeEventListener("click", outsideClickHandler);
        };
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: ref,
        className: "relative w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                "aria-label": "Open account menu",
                className: "flex h-12 w-full items-center justify-between gap-4 rounded-full border border-border px-2 py-3 text-base ".concat(className, " bg-white"),
                onClick: function() {
                    if (options.length) setIsOpen(!isOpen);
                },
                type: "button",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "min-w-[80px] text-left text-sm ".concat(selectedOption ? "text-primary" : placeholderClass || "text-mediumGray"),
                        children: [
                            prefix !== null && prefix !== void 0 ? prefix : null,
                            " ",
                            selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                        className: "w-[20px] text-text ".concat(isOpen ? "rotate-180" : ""),
                        src: "/svgs/chevron-down.svg#chevron-down",
                        title: "Chevron",
                        viewBox: "0 0 24 24"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "select-options absolute left-0 top-[calc(100%+0.5rem)] z-10 w-full rounded-[0.5rem] border border-gray bg-background text-base transition duration-100 ".concat(isOpen ? "pointer-events-auto translate-y-0 opacity-100" : "pointer-events-none -translate-y-1 opacity-0"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "flex max-h-[18rem] flex-col gap-0 overflow-y-auto py-2",
                    children: options.map(function(option, index) {
                        var isActive = option.value === (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value);
                        if (index === 0 && !(selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value)) onSelect(option);
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: "flex",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                "aria-hidden": isOpen ? "true" : "false",
                                className: "w-full px-5 py-1.5 text-left transition md:hover:bg-offWhite ".concat(isActive ? "bg-lightGray" : "bg-transparent"),
                                onClick: function() {
                                    onSelect(option);
                                    setIsOpen(false);
                                },
                                tabIndex: isOpen ? "0" : "-1",
                                type: "button",
                                children: option.label
                            })
                        }, index);
                    })
                })
            })
        ]
    });
}
Select.displayname = "Select";
Select.propTypes = {
    onSelect: (prop_types_default()).func,
    options: prop_types_default().arrayOf((prop_types_default()).object),
    placeholder: (prop_types_default()).string,
    placeholderClass: (prop_types_default()).string,
    selectedOption: (prop_types_default()).object
};

;// CONCATENATED MODULE: ./src/snippets/Select/index.js


;// CONCATENATED MODULE: ./src/snippets/Collection/utils.js


var productTypeKey = "product_type";
var sortKeys = [
    "default",
    "highToLow",
    "lowToHigh",
    "aToZ",
    "zToA"
];
var getFilteredProducts = function(param) {
    var _activeFilters = param.activeFilters, activeFilters = _activeFilters === void 0 ? {} : _activeFilters, _products = param.products, products = _products === void 0 ? [] : _products;
    var ref;
    var filteredProducts = products.reduce(function(acc, product) {
        if (!product.optionsMap) return acc;
        var minReqLength = Object.keys(activeFilters).filter(function(key) {
            return key !== productTypeKey;
        }).length;
        // filter by product option
        var optionMatches = [];
        var optionFilters = Object.keys(activeFilters).reduce(function(optionsAcc, key) {
            if (key.startsWith("option.")) {
                return (0,_to_consumable_array/* default */.Z)(optionsAcc).concat([
                    key.replace("option.", "")
                ]);
            }
            return optionsAcc;
        }, []);
        if (optionFilters.length) {
            optionFilters.forEach(function(filter) {
                if (product.optionsMap[filter]) {
                    var hasMatch = product.optionsMap[filter].some(function(value) {
                        return activeFilters["option.".concat(filter)].includes(value);
                    });
                    if (hasMatch) {
                        optionMatches.push(filter);
                    }
                }
            });
        }
        // filter by product tag
        var tagMatches = [];
        var tagFilters = Object.keys(activeFilters).reduce(function(tagsAcc, key) {
            if (key.startsWith("tag.")) {
                return (0,_to_consumable_array/* default */.Z)(tagsAcc).concat([
                    key.replace("tag.", "")
                ]);
            }
            return tagsAcc;
        }, []);
        if (tagFilters.length) {
            tagFilters.forEach(function(filter) {
                if (product.tags) {
                    var hasMatch = product.tags.some(function(tag) {
                        var ref = (0,_sliced_to_array/* default */.Z)(tag.split("::"), 2), _key = ref[0], _value = ref[1];
                        var key = _key.trim();
                        var value = _value === null || _value === void 0 ? void 0 : _value.trim();
                        if (value && filter === key) {
                            return activeFilters["tag.".concat(filter)].includes(value);
                        }
                        return false;
                    });
                    if (hasMatch) {
                        tagMatches.push(filter);
                    }
                }
            });
        }
        var matches = (0,_to_consumable_array/* default */.Z)(optionMatches).concat((0,_to_consumable_array/* default */.Z)(tagMatches));
        if (matches.length >= minReqLength) {
            return (0,_to_consumable_array/* default */.Z)(acc).concat([
                product
            ]);
        }
        return acc;
    }, []);
    // filter by product type
    if (((ref = activeFilters[productTypeKey]) === null || ref === void 0 ? void 0 : ref.length) > 0) {
        filteredProducts = filteredProducts.filter(function(param) {
            var productType = param.productType;
            return activeFilters[productTypeKey].includes(productType);
        });
    }
    return filteredProducts;
};
var getSortedProducts = function(param) {
    var _products = param.products, products = _products === void 0 ? [] : _products, _sortBy = param.sortBy, sortBy = _sortBy === void 0 ? "" : _sortBy;
    switch(sortBy){
        case "default":
            return products;
        case "lowToHigh":
            return products.sort(function(a, b) {
                var ref, ref1, ref2, ref3;
                var aPrice = parseInt((ref = a.priceRange) === null || ref === void 0 ? void 0 : (ref1 = ref.maxVariantPrice) === null || ref1 === void 0 ? void 0 : ref1.amount, 10);
                var bPrice = parseInt((ref2 = b.priceRange) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.maxVariantPrice) === null || ref3 === void 0 ? void 0 : ref3.amount, 10);
                if (aPrice > bPrice) return -1;
                if (aPrice < bPrice) return 1;
                return 0;
            });
        case "highToLow":
            return products.sort(function(a, b) {
                var ref, ref1, ref2, ref3;
                var aPrice = parseInt((ref = a.priceRange) === null || ref === void 0 ? void 0 : (ref1 = ref.maxVariantPrice) === null || ref1 === void 0 ? void 0 : ref1.amount, 10);
                var bPrice = parseInt((ref2 = b.priceRange) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.maxVariantPrice) === null || ref3 === void 0 ? void 0 : ref3.amount, 10);
                if (aPrice > bPrice) return 1;
                if (aPrice < bPrice) return -1;
                return 0;
            });
        case "zToA":
            return products.sort(function(a, b) {
                return a.title.localeCompare(b.title);
            });
        case "aToZ":
            return products.sort(function(a, b) {
                return b.title.localeCompare(a.title);
            });
        default:
            return products;
    }
};
var updateFilterUrlParams = function(param) {
    var _entriesToAdd = param.entriesToAdd, entriesToAdd = _entriesToAdd === void 0 ? [] : _entriesToAdd, _keysToRemove = param.keysToRemove, keysToRemove = _keysToRemove === void 0 ? [] : _keysToRemove;
    var _location = window.location, origin = _location.origin, search = _location.search, pathname = _location.pathname;
    var params = new URLSearchParams(search);
    entriesToAdd.forEach(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
        params.set(key, value.join(","));
    });
    keysToRemove.forEach(function(key) {
        params.delete(key);
    });
    var updatedUrl = "".concat(origin).concat(pathname, "?").concat(params);
    localStorage.setItem("collectionFiltersURL", updatedUrl);
    window.history.replaceState(window.history.state, "", updatedUrl);
};
var sortAlphabetically = function(param) {
    var _values = param.values, values = _values === void 0 ? [] : _values;
    return values === null || values === void 0 ? void 0 : values.slice().sort(function(a, b) {
        if (a.value < b.value) return -1;
        if (a.value > b.value) return 1;
        return 0;
    });
};
var sortNumerically = function(param) {
    var _values = param.values, values = _values === void 0 ? [] : _values;
    return values === null || values === void 0 ? void 0 : values.slice().sort(function(a, b) {
        var aNum = parseFloat(a.value);
        var bNum = parseFloat(b.value);
        if (aNum < bNum) return -1;
        if (aNum > bNum) return 1;
        return 0;
    });
};
var sortCustom = function(param) {
    var _values = param.values, values = _values === void 0 ? [] : _values, _sortOrder = param.sortOrder, sortOrder = _sortOrder === void 0 ? [] : _sortOrder;
    if (!(sortOrder === null || sortOrder === void 0 ? void 0 : sortOrder.length)) return values;
    return values === null || values === void 0 ? void 0 : values.slice().sort(function(a, b) {
        var _sortOrder = sortOrder.map(function(v) {
            return v.trim();
        });
        var aIndex = _sortOrder.indexOf(a.value);
        var bIndex = _sortOrder.indexOf(b.value);
        if (aIndex < bIndex) return -1;
        if (aIndex > bIndex) return 1;
        return 0;
    });
};

;// CONCATENATED MODULE: ./src/snippets/Collection/CollectionSort.jsx








function CollectionSort(param) {
    var selectedSort = param.selectedSort, selectSort = param.selectSort;
    var ref;
    var settings = (0,dist.useSettings)();
    var sortOptions = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.collection) === null || ref === void 0 ? void 0 : ref.sort);
    var ref1 = (0,react.useState)(false), isOpen = ref1[0], setIsOpen = ref1[1];
    var options = (0,react.useMemo)(function() {
        return sortKeys.map(function(key) {
            return {
                value: key,
                label: sortOptions["".concat(key, "Label")]
            };
        });
    }, [
        sortOptions,
        sortKeys
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute right-0 top-[-50px] ml-auto max-w-[50%] lg:top-[-130px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Select, {
                    prefix: "Sort By: ",
                    onSelect: function(option) {
                        return selectSort(option);
                    },
                    options: options,
                    placeholder: "Sort By:",
                    selectedOption: selectedSort,
                    placeholderClass: "text-[14px]",
                    className: "!rounded-none border-0"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                "aria-label": "Open sort sidebar",
                className: "hidden h-14 w-full items-center justify-between overflow-hidden rounded-3xl border border-border bg-white pl-4 pr-2.5 text-left md:px-0",
                onClick: function() {
                    return setIsOpen(!isOpen);
                },
                type: "button",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-1 items-center gap-2 overflow-hidden xs:gap-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "text-[14px]",
                                children: "Sort By:"
                            }),
                            (selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.value) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "truncate text-xs text-mediumGray xs:text-sm",
                                children: selectedSort.label
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                        className: "w-5 text-text",
                        src: "/svgs/chevron-right.svg#chevron-right",
                        title: "Arrow Right",
                        viewBox: "0 0 24 24"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionMenuSidebar, {
                title: "Sort",
                isOpen: isOpen,
                setIsOpen: setIsOpen,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "overflow-y-auto",
                    children: options.map(function(option, index) {
                        var isActive = option.value === (selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.value);
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                "aria-label": option.label,
                                className: "flex h-12 w-full items-center gap-4 border-b border-border px-4 text-left text-text ".concat(isActive ? "font-bold text-text" : "text-mediumGray"),
                                onClick: function() {
                                    selectSort(option);
                                    setIsOpen(false);
                                },
                                type: "button",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "relative flex h-6 w-6 items-center justify-center overflow-hidden rounded-[50%] border border-border transition md:hover:border-text ".concat(isActive ? "border-text" : ""),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 overflow-hidden rounded-[50%] transition-[height,width] ".concat(isActive ? "h-[calc(100%-5px)] w-[calc(100%-5px)] bg-black" : "h-full w-full bg-offWhite")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "flex-1",
                                        children: option.label
                                    })
                                ]
                            })
                        }, index);
                    })
                })
            })
        ]
    });
}
CollectionSort.displayName = "CollectionSort";

;// CONCATENATED MODULE: ./src/snippets/Collection/useCollectionFilters.js









function useCollectionFilters() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        enabledFilters: true,
        id: "",
        products: []
    }, enabledFilters = ref.enabledFilters, id = ref.id, products = ref.products;
    var ref1;
    var ref2 = (0,next_router.useRouter)(), isReady = ref2.isReady, query = ref2.query;
    var settings = (0,dist.useSettings)();
    var filtersSettings = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref1 = settings.collection) === null || ref1 === void 0 ? void 0 : ref1.filters);
    var ref3 = (0,react.useState)({}), activeFilters = ref3[0], setActiveFilters = ref3[1];
    var ref4 = (0,react.useState)([]), filters = ref4[0], setFilters = ref4[1];
    var ref5 = (0,react.useState)({}), filtersMap = ref5[0], setFiltersMap = ref5[1];
    var addFilter = (0,react.useCallback)(function(param) {
        var key = param.key, value = param.value;
        var updatedActiveFilters = (0,_object_spread/* default */.Z)({}, activeFilters);
        updatedActiveFilters[key] = updatedActiveFilters[key] ? (0,_to_consumable_array/* default */.Z)(updatedActiveFilters[key]).concat([
            value
        ]) : [
            value
        ];
        setActiveFilters(updatedActiveFilters);
        updateFilterUrlParams({
            entriesToAdd: Object.entries(updatedActiveFilters)
        });
    }, [
        activeFilters
    ]);
    var removeFilter = (0,react.useCallback)(function(param) {
        var key = param.key, value = param.value;
        var ref, ref1;
        var updatedActiveFilters = (0,_object_spread/* default */.Z)({}, activeFilters);
        updatedActiveFilters[key] = updatedActiveFilters[key].filter(function(item) {
            return item !== value;
        });
        if (((ref = updatedActiveFilters[key]) === null || ref === void 0 ? void 0 : ref.length) === 0) delete updatedActiveFilters[key];
        setActiveFilters(updatedActiveFilters);
        if (((ref1 = activeFilters[key]) === null || ref1 === void 0 ? void 0 : ref1.length) === 1) {
            updateFilterUrlParams({
                keysToRemove: [
                    key
                ]
            });
        } else {
            updateFilterUrlParams({
                entriesToAdd: Object.entries(updatedActiveFilters)
            });
        }
    }, [
        activeFilters
    ]);
    var clearFilters = (0,react.useCallback)(function() {
        setActiveFilters({});
        updateFilterUrlParams({
            keysToRemove: Object.keys(activeFilters)
        });
    }, [
        activeFilters
    ]);
    // sets up filters and options on collection load
    (0,react.useEffect)(function() {
        if (!enabledFilters) return;
        var cmsFilters = filtersSettings.filters || [];
        var tagFilters = [];
        var optionFilters = [];
        // set up initial filters map
        var _filtersMap = cmsFilters.reduce(function(acc, param) {
            var customOrder = param.customOrder, defaultOpen = param.defaultOpen, isColor = param.isColor, label = param.label, name = param.name, orderValuesBy = param.orderValuesBy, source = param.source;
            if (source !== "productType" && !name) return acc;
            var _name = name === null || name === void 0 ? void 0 : name.trim();
            if (source === "tag") {
                tagFilters.push(_name);
            } else if (source === "option") {
                optionFilters.push(_name);
            }
            var filter = {
                name: source === "productType" ? productTypeKey : "".concat(source, ".").concat(_name),
                label: label,
                isColor: isColor || false,
                defaultOpen: defaultOpen,
                orderValuesBy: orderValuesBy,
                customOrder: customOrder,
                source: source,
                values: [],
                valuesMap: {}
            };
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, filter.name, filter));
        }, {});
        products.forEach(function(param) {
            var optionsMap = param.optionsMap, productType = param.productType, tags = param.tags;
            // product type options
            if (_filtersMap[productTypeKey]) {
                var ref;
                _filtersMap[productTypeKey].valuesMap = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, _filtersMap[productTypeKey].valuesMap), (0,_define_property/* default */.Z)({}, productType, {
                    value: productType,
                    count: (((ref = _filtersMap[productTypeKey].valuesMap[productType]) === null || ref === void 0 ? void 0 : ref.count) || 0) + 1
                }));
            }
            // tag filter options
            if (tagFilters === null || tagFilters === void 0 ? void 0 : tagFilters.length) {
                tags.forEach(function(tag) {
                    var ref = (0,_sliced_to_array/* default */.Z)(tag.split("::"), 2), _key = ref[0], _value = ref[1];
                    var key = _key.trim();
                    var value = _value === null || _value === void 0 ? void 0 : _value.trim();
                    if (value && tagFilters.includes(key)) {
                        var ref1;
                        _filtersMap["tag.".concat(key)].valuesMap = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, _filtersMap["tag.".concat(key)].valuesMap), (0,_define_property/* default */.Z)({}, value, {
                            value: value,
                            count: (((ref1 = _filtersMap["tag.".concat(key)].valuesMap[value]) === null || ref1 === void 0 ? void 0 : ref1.count) || 0) + 1
                        }));
                    }
                });
            }
            // option filter options
            Object.entries(optionsMap || {}).forEach(function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), _key = _param[0], values = _param[1];
                var key = _key.trim();
                if (optionFilters.includes(key)) {
                    _filtersMap["option.".concat(key)].valuesMap = (0,_object_spread/* default */.Z)({}, _filtersMap["option.".concat(key)].valuesMap, values.reduce(function(acc, value) {
                        var ref;
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, value, {
                            value: value,
                            count: (((ref = _filtersMap["option.".concat(key)].valuesMap[value]) === null || ref === void 0 ? void 0 : ref.count) || 0) + 1
                        }));
                    }, {}));
                }
            });
        });
        // sort options
        Object.values(_filtersMap).forEach(function(filter) {
            var values = Object.values(filter.valuesMap);
            if (filter.orderValuesBy === "alphabet") {
                _filtersMap[filter.name].values = sortAlphabetically({
                    values: values
                });
            } else if (filter.orderValuesBy === "number") {
                _filtersMap[filter.name].values = sortNumerically({
                    values: values
                });
            } else if (filter.orderValuesBy === "custom") {
                _filtersMap[filter.name].values = sortCustom({
                    values: values,
                    sortOrder: filter.customOrder
                });
            } else {
                _filtersMap[filter.name].values = values;
            }
            delete _filtersMap[filter.name].orderValuesBy;
            delete _filtersMap[filter.name].customOrder;
        });
        setFilters(Object.values(_filtersMap));
        setFiltersMap(_filtersMap);
    }, [
        enabledFilters,
        filtersSettings.filters,
        id,
        products
    ]);
    // sets filters on page load
    (0,react.useEffect)(function() {
        if (!isReady || !(filters === null || filters === void 0 ? void 0 : filters.length)) return;
        var _location = window.location, origin = _location.origin, search = _location.search, pathname = _location.pathname;
        var collectionFiltersURL = localStorage.getItem("collectionFiltersURL");
        var queryObject = {};
        if (collectionFiltersURL) {
            window.history.replaceState(window.history.state, "", "".concat(origin).concat(pathname, "?").concat(collectionFiltersURL.split("?")[1]));
            var searchParams = new URLSearchParams(collectionFiltersURL.split("?")[1]);
            queryObject = Object.fromEntries(searchParams.entries());
        } else queryObject = query;
        var filtersFromParams = Object.entries(queryObject || {}).reduce(function(acc, param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
            var ref, ref1;
            if (!((ref = filtersMap[key]) === null || ref === void 0 ? void 0 : (ref1 = ref.values) === null || ref1 === void 0 ? void 0 : ref1.some(function(v) {
                return value.split(",").includes(v.value);
            }))) return acc;
            acc[key] = value.split(",");
            return acc;
        }, {});
        setActiveFilters(filtersFromParams);
    }, [
        isReady,
        filters === null || filters === void 0 ? void 0 : filters.length
    ]);
    return {
        state: {
            activeFilters: activeFilters,
            filters: filters,
            filtersMap: filtersMap
        },
        actions: {
            addFilter: addFilter,
            removeFilter: removeFilter,
            clearFilters: clearFilters
        }
    };
}

;// CONCATENATED MODULE: ./src/snippets/Collection/useCollectionProducts.js




function useCollectionProducts() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        activeFilters: {},
        id: "",
        pagination: {},
        products: [],
        promoTiles: []
    }, activeFilters = ref.activeFilters, id = ref.id, pagination = ref.pagination, products = ref.products, promoTiles = ref.promoTiles;
    var asPathRef = (0,react.useRef)(null);
    var asPath = (0,next_router.useRouter)().asPath;
    var ref1 = (0,react_intersection_observer/* useInView */.YD)({
        rootMargin: "600px",
        triggerOnce: false
    }), loadMoreRef = ref1.ref, inView = ref1.inView;
    var ref2 = (0,react.useState)(products), filteredProducts = ref2[0], setFilteredProducts = ref2[1];
    var ref3 = (0,react.useState)(filteredProducts === null || filteredProducts === void 0 ? void 0 : filteredProducts.length), productsLimit = ref3[0], setProductsLimit = ref3[1];
    var ref4 = (0,react.useState)(null), selectedSort = ref4[0], setSelectedSort = ref4[1];
    var enabledPagination = (pagination === null || pagination === void 0 ? void 0 : pagination.enabled) || true;
    var resultsPerPage = (pagination === null || pagination === void 0 ? void 0 : pagination.resultsPerPage) || 24;
    var isInfiniteScroll = (pagination === null || pagination === void 0 ? void 0 : pagination.enabled) && (pagination === null || pagination === void 0 ? void 0 : pagination.loadType) === "infinite";
    var selectSort = (0,react.useCallback)(function(sort) {
        setSelectedSort(sort || null);
    }, []);
    var loadMoreProducts = (0,react.useCallback)(function() {
        if (productsLimit >= (filteredProducts === null || filteredProducts === void 0 ? void 0 : filteredProducts.length)) return;
        var numOfPromoTilesInLoad = promoTiles === null || promoTiles === void 0 ? void 0 : promoTiles.reduce(function(acc, param) {
            var position = param.position;
            var index = position - 1;
            if (index >= productsLimit && index < productsLimit + resultsPerPage) {
                return acc + 1;
            }
            return acc;
        }, 0);
        setProductsLimit(productsLimit + resultsPerPage - (numOfPromoTilesInLoad || 0));
    }, [
        filteredProducts === null || filteredProducts === void 0 ? void 0 : filteredProducts.length,
        productsLimit,
        promoTiles,
        resultsPerPage
    ]);
    // sets products limit on collection cms changes
    (0,react.useEffect)(function() {
        if (!enabledPagination || !resultsPerPage) {
            setProductsLimit(filteredProducts === null || filteredProducts === void 0 ? void 0 : filteredProducts.length);
            return undefined;
        }
        if (!promoTiles) {
            setProductsLimit(resultsPerPage);
            return undefined;
        }
        var numOfPromoTilesInLoad = promoTiles.reduce(function(acc, param) {
            var position = param.position;
            var index = position - 1;
            if (asPath !== asPathRef.current && index < resultsPerPage) {
                return acc + 1;
            }
            if (index >= productsLimit && index < productsLimit + resultsPerPage) {
                return acc + 1;
            }
            return acc;
        }, 0);
        setProductsLimit(resultsPerPage - (numOfPromoTilesInLoad || 0));
        asPathRef.current = asPath;
        return function() {
            asPathRef.current = null;
        };
    }, [
        asPath,
        enabledPagination,
        resultsPerPage,
        promoTiles
    ]);
    // filters and sorts products
    (0,react.useEffect)(function() {
        var _filteredProducts = getFilteredProducts({
            products: products,
            activeFilters: activeFilters
        });
        var sortedProducts = getSortedProducts({
            products: _filteredProducts,
            sortBy: selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.value
        });
        setFilteredProducts(sortedProducts);
    }, [
        activeFilters,
        enabledPagination,
        id,
        resultsPerPage,
        selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.value,
        products
    ]);
    // auto loads more products if infinite scroll is enabled
    (0,react.useEffect)(function() {
        if (!inView || !isInfiniteScroll) return;
        loadMoreProducts();
    }, [
        inView,
        isInfiniteScroll
    ]);
    return {
        state: {
            filteredProducts: filteredProducts,
            isInfiniteScroll: isInfiniteScroll,
            productsLimit: productsLimit,
            selectedSort: selectedSort
        },
        actions: {
            loadMoreProducts: loadMoreProducts,
            selectSort: selectSort
        },
        refs: {
            loadMoreRef: loadMoreRef
        }
    };
}

;// CONCATENATED MODULE: ./src/snippets/Collection/Collection.jsx












function Collection(param) {
    var handle = param.handle, products = param.products, showHeading = param.showHeading, emptyCollectionProducts = param.emptyCollectionProducts;
    var ref, ref1;
    var swatchesMap = (0,hooks/* useColorSwatches */.Bb)().swatchesMap;
    var settings = (0,dist.useSettings)();
    var ref2 = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : settings.collection), filtersSettings = ref2.filters, pagination = ref2.pagination, promotion = ref2.promotion;
    var isSearchPage = handle === "search";
    var enabledFilters = isSearchPage ? false : filtersSettings === null || filtersSettings === void 0 ? void 0 : filtersSettings.enabled;
    var id = isSearchPage ? products : handle;
    var promoTiles = (0,react.useMemo)(function() {
        var ref;
        if (!(promotion === null || promotion === void 0 ? void 0 : (ref = promotion.campaigns) === null || ref === void 0 ? void 0 : ref.length)) return null;
        var campaign = promotion.campaigns.find(function(param) {
            var collections = param.collections;
            return collections === null || collections === void 0 ? void 0 : collections.some(function(colHandle) {
                return colHandle.trim() === handle;
            });
        });
        return (campaign === null || campaign === void 0 ? void 0 : campaign.promoTiles) || null;
    }, [
        handle,
        promotion === null || promotion === void 0 ? void 0 : promotion.campaigns
    ]);
    var collectionFiltersData = useCollectionFilters({
        enabledFilters: enabledFilters,
        id: id,
        products: products
    });
    var collectionProductsData = useCollectionProducts({
        activeFilters: collectionFiltersData.state.activeFilters,
        id: id,
        pagination: pagination,
        products: products,
        promoTiles: promoTiles
    });
    // Sort the Products By Product Type
    var unSortedProducts = (0,_to_consumable_array/* default */.Z)(collectionProductsData.state.filteredProducts);
    var sortedProducts = unSortedProducts.sort(function(a, b) {
        if (a.productType < b.productType) return 1;
        if (a.productType > b.productType) return -1;
        return 0;
    });
    // Remove Products that do not contain FiltrationSystem:: tags for filtering, or are subscriptions
    sortedProducts = sortedProducts.filter(function(product) {
        var ref, ref1;
        return (product === null || product === void 0 ? void 0 : (ref = product.tags) === null || ref === void 0 ? void 0 : ref.length) && !(product === null || product === void 0 ? void 0 : (ref1 = product.tags) === null || ref1 === void 0 ? void 0 : ref1.includes("Subscription")) && (product === null || product === void 0 ? void 0 : product.publishedAt) !== null;
    });
    // Set our collection's filteredProducts state to our freshly sorted group of products
    collectionProductsData.state.filteredProducts = sortedProducts;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mx-auto grid",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "z-10",
                children: enabledFilters && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: " pb-4 md:pb-8",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionFilters, {
                        collectionFiltersData: collectionFiltersData,
                        collectionCount: (collectionProductsData === null || collectionProductsData === void 0 ? void 0 : (ref = collectionProductsData.state) === null || ref === void 0 ? void 0 : (ref1 = ref.filteredProducts) === null || ref1 === void 0 ? void 0 : ref1.length) || (products === null || products === void 0 ? void 0 : products.length),
                        swatchesMap: swatchesMap
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    isSearchPage && emptyCollectionProducts ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionSort, {
                        selectedSort: collectionProductsData.state.selectedSort,
                        selectSort: collectionProductsData.actions.selectSort
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionGrid, {
                        showHeading: showHeading,
                        activeFilters: collectionFiltersData.state.activeFilters,
                        collectionProductsData: collectionProductsData,
                        enabledFilters: enabledFilters,
                        isSearchPage: isSearchPage,
                        promoTiles: promoTiles,
                        swatchesMap: swatchesMap
                    })
                ]
            })
        ]
    });
}
Collection.displayName = "Collection";
Collection.propTypes = {
    handle: (prop_types_default()).string,
    products: prop_types_default().arrayOf((prop_types_default()).object)
};

;// CONCATENATED MODULE: ./src/snippets/Collection/index.js


// EXTERNAL MODULE: ../node_modules/next/script.js
var script = __webpack_require__(3218);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./src/snippets/DataLayer/hooks/useDataLayerAccount.js




function useDataLayerAccount(param) {
    var baseEcommerce = param.baseEcommerce, DEBUG = param.DEBUG, generateUserProperties = param.generateUserProperties, userDataEvent = param.userDataEvent, userDataEventTriggered = param.userDataEventTriggered;
    var customer = (0,dist.useCustomer)();
    var accessToken = dist.store.recoil.useRecoilValue(dist.store.state.accessToken);
    var ref = (0,react.useState)(false), loggedIn = ref[0], setLoggedIn = ref[1];
    var ref1 = (0,react.useState)(false), registered = ref1[0], setRegistered = ref1[1];
    var klaviyoUserLogin = function() {
        var _learnq = window._learnq || [];
        _learnq.push([
            "identify",
            {
                $email: customer.email,
                $first_name: customer.firstName,
                $last_name: customer.lastName
            }, 
        ]);
    };
    var loggedInEvent = (0,react.useCallback)(function(param) {
        var ecommerce = param.ecommerce, userProperties = param.userProperties;
        var event = {
            event: "dl_login",
            user_properties: userProperties,
            ecommerce: ecommerce
        };
        var _ElevarDataLayer;
        window.ElevarDataLayer = (_ElevarDataLayer = window.ElevarDataLayer) !== null && _ElevarDataLayer !== void 0 ? _ElevarDataLayer : [];
        window.ElevarDataLayer.push(event);
        if (DEBUG) console.log("DataLayer:elevar:".concat(event.event), event);
    }, []);
    var registeredEvent = (0,react.useCallback)(function(param) {
        var ecommerce = param.ecommerce, userProperties = param.userProperties;
        var event = {
            event: "dl_sign_up",
            user_properties: userProperties,
            ecommerce: ecommerce
        };
        var _ElevarDataLayer;
        window.ElevarDataLayer = (_ElevarDataLayer = window.ElevarDataLayer) !== null && _ElevarDataLayer !== void 0 ? _ElevarDataLayer : [];
        window.ElevarDataLayer.push(event);
        if (DEBUG) console.log("DataLayer:elevar:".concat(event.event), event);
    }, []);
    (0,react.useEffect)(function() {
        var customerLoggedIn = PubSub.subscribe("CUSTOMER_LOGGED_IN", /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                setLoggedIn(true);
                return [
                    2
                ];
            });
        }));
        var customerRegistered = PubSub.subscribe("CUSTOMER_REGISTERED", /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                setRegistered(true);
                return [
                    2
                ];
            });
        }));
        return function() {
            if (customerLoggedIn) {
                PubSub.unsubscribe(customerLoggedIn);
            }
            if (customerRegistered) {
                PubSub.unsubscribe(customerRegistered);
            }
        };
    }, []);
    // Generate new base data after customer login and customer profile is ready
    // Trigger 'dl_user_data' and 'dl_login' events
    (0,react.useEffect)(function() {
        if (!baseEcommerce || !customer || !(accessToken === null || accessToken === void 0 ? void 0 : accessToken.token) || !loggedIn || !userDataEventTriggered) {
            return;
        }
        (0,_async_to_generator/* default */.Z)(function() {
            var userProperties;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            generateUserProperties({
                                customer: customer,
                                accessToken: accessToken.token
                            })
                        ];
                    case 1:
                        userProperties = _state.sent();
                        userDataEvent({
                            userProperties: userProperties,
                            ecommerce: baseEcommerce
                        });
                        loggedInEvent({
                            userProperties: userProperties,
                            ecommerce: baseEcommerce
                        });
                        klaviyoUserLogin();
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        !!customer,
        accessToken === null || accessToken === void 0 ? void 0 : accessToken.token,
        !!baseEcommerce,
        loggedIn,
        userDataEventTriggered, 
    ]);
    // Generate new base data after customer register and customer profile is ready
    // Trigger 'dl_user_data' and 'dl_sign_up' events
    (0,react.useEffect)(function() {
        if (!baseEcommerce || !customer || !(accessToken === null || accessToken === void 0 ? void 0 : accessToken.token) || !registered || !userDataEventTriggered) {
            return;
        }
        (0,_async_to_generator/* default */.Z)(function() {
            var userProperties;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            generateUserProperties({
                                customer: customer,
                                accessToken: accessToken.token
                            })
                        ];
                    case 1:
                        userProperties = _state.sent();
                        userDataEvent({
                            userProperties: userProperties,
                            ecommerce: baseEcommerce
                        });
                        registeredEvent({
                            userProperties: userProperties,
                            ecommerce: baseEcommerce
                        });
                        setRegistered(false);
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        !!customer,
        accessToken === null || accessToken === void 0 ? void 0 : accessToken.token,
        !!baseEcommerce,
        registered,
        userDataEventTriggered, 
    ]);
}

// EXTERNAL MODULE: ../node_modules/fast-deep-equal/index.js
var fast_deep_equal = __webpack_require__(6471);
var fast_deep_equal_default = /*#__PURE__*/__webpack_require__.n(fast_deep_equal);
;// CONCATENATED MODULE: ./src/snippets/DataLayer/hooks/utils.js




var brand = "Clearly Filtered" || 0;
var getIdFromString = function(string) {
    return string.substring(string.lastIndexOf("/") + 1);
};
var returnKeyValueIfNotEmpty = function(key, value) {
    return value ? (0,_define_property/* default */.Z)({}, key, value) : {};
};
var mapProductItemProduct = function() {
    var list = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return function(product) {
        var index = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        try {
            var ref, ref1, ref2, ref3;
            if (!product) return null;
            var firstVariant = (ref = product.variants) === null || ref === void 0 ? void 0 : ref[0];
            return {
                id: (firstVariant === null || firstVariant === void 0 ? void 0 : firstVariant.sku) || "",
                name: product.title || "",
                brand: product.vendor || brand,
                category: product.productType || "",
                variant: ((firstVariant === null || firstVariant === void 0 ? void 0 : firstVariant.title) === "Default Title" ? product.title : (firstVariant === null || firstVariant === void 0 ? void 0 : firstVariant.title) || product.title) || "",
                price: "".concat((firstVariant === null || firstVariant === void 0 ? void 0 : (ref1 = firstVariant.priceV2) === null || ref1 === void 0 ? void 0 : ref1.amount) || ""),
                list: list,
                product_id: product.legacyResourceId || "",
                variant_id: (firstVariant === null || firstVariant === void 0 ? void 0 : firstVariant.legacyResourceId) || "",
                compare_at_price: "".concat((firstVariant === null || firstVariant === void 0 ? void 0 : (ref2 = firstVariant.compareAtPriceV2) === null || ref2 === void 0 ? void 0 : ref2.amount) || "n/a"),
                image: ((ref3 = product.featuredImage) === null || ref3 === void 0 ? void 0 : ref3.src) || "",
                position: index + 1
            };
        } catch (error) {
            console.error("DataLayer:mapProductItemProduct error", error.message);
            console.error("DataLayer:mapProductItemProduct product", product);
            return null;
        }
    };
};
var mapProductItemVariant = function() {
    var list = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return function(variant) {
        var index = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        try {
            var ref, ref1, ref2;
            if (!variant) return null;
            var _index;
            return {
                id: variant.sku || "",
                name: variant.product.title || "",
                brand: variant.product.vendor || brand,
                category: variant.product.productType || "",
                variant: (variant.title === "Default Title" ? variant.product.title : variant.title || variant.product.title) || "",
                price: "".concat(((ref = variant.priceV2) === null || ref === void 0 ? void 0 : ref.amount) || ""),
                list: list,
                product_id: variant.product.legacyResourceId || "",
                variant_id: variant.legacyResourceId || "",
                compare_at_price: "".concat(((ref1 = variant.compareAtPriceV2) === null || ref1 === void 0 ? void 0 : ref1.amount) || "n/a"),
                image: ((ref2 = variant.image) === null || ref2 === void 0 ? void 0 : ref2.src) || "",
                position: ((_index = variant.index) !== null && _index !== void 0 ? _index : index) + 1,
                url: "/products/".concat(variant.product.handle)
            };
        } catch (error) {
            console.error("DataLayer:mapProductItemVariant error", error.message);
            console.error("DataLayer:mapProductItemVariant variant", variant);
            return null;
        }
    };
};
var mapProductPageVariant = function() {
    var list = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return function(variant) {
        try {
            var ref, ref1, ref2, ref3;
            if (!variant) return null;
            return {
                id: variant.sku || "",
                name: variant.product.title || "",
                brand: variant.product.vendor || brand,
                category: variant.product.productType || "",
                variant: (variant.title === "Default Title" ? variant.product.title : variant.title || variant.product.title) || "",
                price: "".concat(((ref = variant.priceV2) === null || ref === void 0 ? void 0 : ref.amount) || ""),
                list: list,
                product_id: ((ref1 = variant.product.id) === null || ref1 === void 0 ? void 0 : ref1.split("/").pop()) || "",
                variant_id: variant.legacyResourceId || "",
                compare_at_price: "".concat(((ref2 = variant.compareAtPriceV2) === null || ref2 === void 0 ? void 0 : ref2.amount) || "n/a"),
                image: ((ref3 = variant.image) === null || ref3 === void 0 ? void 0 : ref3.src) || "",
                url: "/products/".concat(variant.product.handle, "?variant=").concat(variant.legacyResourceId)
            };
        } catch (error) {
            console.error("DataLayer:mapProductPageVariant error", error.message);
            console.error("DataLayer:mapProductPageVariant variant", variant);
            return null;
        }
    };
};
var decodedId = function(id) {
    try {
        if (!id) return undefined;
        return window.atob(id);
    } catch (error) {
        return id;
    }
};
var mapLineItem = function() {
    var list = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return function(item) {
        var index = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        try {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
            var ref10 = (0,_object_spread/* default */.Z)({}, item), quantity = ref10.quantity, variant = ref10.variant;
            if (!variant) return null;
            return {
                id: variant.sku || "",
                name: ((ref = variant.product) === null || ref === void 0 ? void 0 : ref.title) || "",
                brand: brand,
                category: ((ref1 = variant.product) === null || ref1 === void 0 ? void 0 : ref1.productType) || "",
                variant: (variant.title === "Default Title" ? (ref2 = variant.product) === null || ref2 === void 0 ? void 0 : ref2.title : variant.title || ((ref3 = variant.product) === null || ref3 === void 0 ? void 0 : ref3.title)) || "",
                price: "".concat(((ref4 = variant.priceV2) === null || ref4 === void 0 ? void 0 : ref4.amount) || ""),
                quantity: "".concat(quantity || ""),
                list: list,
                product_id: ((ref6 = decodedId((ref5 = variant.product) === null || ref5 === void 0 ? void 0 : ref5.id)) === null || ref6 === void 0 ? void 0 : ref6.split("/").pop()) || "",
                variant_id: ((ref7 = decodedId(variant.id)) === null || ref7 === void 0 ? void 0 : ref7.split("/").pop()) || "",
                compare_at_price: "".concat(((ref8 = variant.compareAtPriceV2) === null || ref8 === void 0 ? void 0 : ref8.amount) || "n/a"),
                image: ((ref9 = variant.image) === null || ref9 === void 0 ? void 0 : ref9.src) || "",
                position: (item.index || index) + 1,
                url: "/products/".concat(variant.product.handle, "?variant=").concat(variant.id.split("/").pop())
            };
        } catch (error) {
            console.error("DataLayer:mapLineItem error", error.message);
            console.error("DataLayer:mapLineItem item", item);
            return null;
        }
    };
};
var fetchCustomerOrders = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var accessToken, url, request, data, ok, response, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    accessToken = param.accessToken;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    if (!accessToken) return [
                        2,
                        null
                    ];
                    url = "/api/customer/orders";
                    return [
                        4,
                        fetch(url, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                first: 100,
                                country: "US",
                                accessToken: accessToken
                            })
                        })
                    ];
                case 2:
                    request = _state.sent();
                    if (!(request === null || request === void 0 ? void 0 : request.ok)) {
                        return [
                            2,
                            null
                        ];
                    }
                    return [
                        4,
                        request.json()
                    ];
                case 3:
                    data = _state.sent();
                    ok = data.ok, response = data.response;
                    if (!ok) {
                        return [
                            2,
                            null
                        ];
                    }
                    return [
                        2,
                        response === null || response === void 0 ? void 0 : response.orders
                    ];
                case 4:
                    error = _state.sent();
                    console.error("DataLayer:fetchCustomerOrders error", error.message);
                    return [
                        2,
                        null
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchCustomerOrders(_) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/hooks/useBeamCartUpdate.js



var beamCart;
function useBeamCartUpdate() {
    var cart = (0,dist.useCart)();
    var cartCount = (0,dist.useCartCount)();
    var settings = (0,dist.useSettings)();
    var beamSettings = settings === null || settings === void 0 ? void 0 : settings.beam;
    var cartChangeTrigger = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, ref2, ref3, _tmp, updateCart, BeamConfig, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = beamCart;
                        if (_tmp) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            import(/* webpackIgnore: true */ "https://sdk.beamimpact.com/web-sdk/v1.53.1/dist/integrations/cart.esm.js")
                        ];
                    case 1:
                        _tmp = _state.sent();
                        _state.label = 2;
                    case 2:
                        beamCart = _tmp;
                        updateCart = beamCart.updateCart;
                        BeamConfig = {
                            apiKey: beamSettings.beamApiKey,
                            storeId: parseInt(beamSettings.beamStoreId, 10),
                            baseUrl: "https://api.beamimpact.com",
                            domain: "clearlyfiltered.com"
                        };
                        data = {
                            cartId: cart.id,
                            currencyCode: cart === null || cart === void 0 ? void 0 : (ref = cart.estimatedCost) === null || ref === void 0 ? void 0 : (ref1 = ref.subtotalAmount) === null || ref1 === void 0 ? void 0 : ref1.currencyCode,
                            itemCount: cartCount,
                            subtotal: parseFloat((cart === null || cart === void 0 ? void 0 : (ref2 = cart.estimatedCost) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.subtotalAmount) === null || ref3 === void 0 ? void 0 : ref3.amount) || 0)
                        };
                        return [
                            4,
                            updateCart(BeamConfig, data)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function cartChangeTrigger() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        cartChangeTrigger: cartChangeTrigger
    };
}

;// CONCATENATED MODULE: ./src/snippets/DataLayer/hooks/useDataLayerCart.js












function useDataLayerCart(param) {
    var baseEcommerce = param.baseEcommerce, DEBUG = param.DEBUG, userDataEvent = param.userDataEvent, userDataEventTriggered = param.userDataEventTriggered, userProperties = param.userProperties;
    var asPathRef = (0,react.useRef)(null);
    var cart = (0,dist.useCart)();
    var cartCount = (0,dist.useCartCount)();
    var cartItems = (0,dist.useCartItems)();
    var router = (0,next_router.useRouter)();
    var asPath = router.asPath.split("?")[0];
    var ref = (0,contexts/* useGlobalContext */.b)(), cartOpen = ref.state.cartOpen;
    var cartChangeTrigger = useBeamCartUpdate().cartChangeTrigger;
    var ref1 = (0,react.useState)(null), previousCartCount = ref1[0], setPreviousCartCount = ref1[1];
    var ref2 = (0,react.useState)(null), previousCartItems = ref2[0], setPreviousCartItems = ref2[1];
    var ref3 = (0,react.useState)(null), previousCartItemsMap = ref3[0], setPreviousCartItemsMap = ref3[1];
    var klaviyoAddToCart = (0,react.useCallback)(function(param) {
        var _cart = param.cart;
        var _learnq = window._learnq || [];
        _learnq.push([
            "track",
            "Added to Cart",
            {
                total_price: _cart.estimatedCost.totalAmount.amount,
                $value: _cart.estimatedCost.totalAmount.amount,
                original_total_price: _cart.estimatedCost.subtotalAmount.amount,
                items: _cart.lines
            }, 
        ]);
    }, []);
    var addToCartEvent = (0,react.useCallback)(function(param) {
        var _cart = param.cart, ecommerce = param.ecommerce, lineItems = param.lineItems, _userProperties = param.userProperties;
        var ref, ref1, ref2, ref3;
        if (!(lineItems === null || lineItems === void 0 ? void 0 : lineItems.length)) return;
        var previousPath = sessionStorage.getItem("PREVIOUS_PATH");
        var list = window.location.pathname.startsWith("/collections") && window.location.pathname || (previousPath === null || previousPath === void 0 ? void 0 : previousPath.startsWith("/collections")) && previousPath || "";
        var event = {
            event: "dl_add_to_cart",
            user_properties: _userProperties,
            ecommerce: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ecommerce), {
                cart_id: (ref = _cart.id) === null || ref === void 0 ? void 0 : ref.split("/").pop(),
                cart_total: (ref1 = _cart.estimatedCost) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.totalAmount) === null || ref2 === void 0 ? void 0 : ref2.amount,
                cart_count: ((ref3 = _cart.lines) === null || ref3 === void 0 ? void 0 : ref3.reduce(function(acc, line) {
                    return acc + line.quantity;
                }, 0)) || 0,
                add: {
                    actionField: {
                        list: list
                    },
                    products: lineItems.slice(0, 7).map(mapLineItem(list))
                }
            })
        };
        var _ElevarDataLayer;
        window.ElevarDataLayer = (_ElevarDataLayer = window.ElevarDataLayer) !== null && _ElevarDataLayer !== void 0 ? _ElevarDataLayer : [];
        window.ElevarDataLayer.push(event);
        var token = getIdFromString((_cart === null || _cart === void 0 ? void 0 : _cart.id) || "");
        lineItems.forEach(function(line) {
            var ref, ref1, ref2, ref3, ref4, ref5;
            (0,utils/* trackTripleWhaleAddToCart */.YU)({
                item: (line === null || line === void 0 ? void 0 : (ref = line.variant) === null || ref === void 0 ? void 0 : (ref1 = ref.product) === null || ref1 === void 0 ? void 0 : ref1.legacyResourceId) || (line === null || line === void 0 ? void 0 : (ref2 = line.variant) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.product) === null || ref3 === void 0 ? void 0 : ref3.id),
                quantity: line === null || line === void 0 ? void 0 : line.quantity,
                variant: (line === null || line === void 0 ? void 0 : (ref4 = line.variant) === null || ref4 === void 0 ? void 0 : ref4.legacyResourceId) || (line === null || line === void 0 ? void 0 : (ref5 = line.variant) === null || ref5 === void 0 ? void 0 : ref5.id),
                token: token
            });
        });
        if (DEBUG) console.log("DataLayer:elevar:".concat(event.event), event);
    }, []);
    var removeFromCartEvent = (0,react.useCallback)(function(param) {
        var _cart = param.cart, ecommerce = param.ecommerce, lineItems = param.lineItems, _userProperties = param.userProperties;
        var ref, ref1, ref2, ref3;
        if (!(lineItems === null || lineItems === void 0 ? void 0 : lineItems.length)) return;
        var previousPath = sessionStorage.getItem("PREVIOUS_PATH");
        var list = window.location.pathname.startsWith("/collections") && window.location.pathname || (previousPath === null || previousPath === void 0 ? void 0 : previousPath.startsWith("/collections")) && previousPath || "";
        var event = {
            event: "dl_remove_from_cart",
            user_properties: _userProperties,
            ecommerce: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ecommerce), {
                cart_id: (ref = _cart.id) === null || ref === void 0 ? void 0 : ref.split("/").pop(),
                cart_total: (ref1 = _cart.estimatedCost) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.totalAmount) === null || ref2 === void 0 ? void 0 : ref2.amount,
                cart_count: ((ref3 = _cart.lines) === null || ref3 === void 0 ? void 0 : ref3.reduce(function(acc, line) {
                    return acc + line.quantity;
                }, 0)) || 0,
                remove: {
                    actionField: {
                        list: list
                    },
                    products: lineItems.map(mapLineItem(list))
                }
            })
        };
        var _ElevarDataLayer;
        window.ElevarDataLayer = (_ElevarDataLayer = window.ElevarDataLayer) !== null && _ElevarDataLayer !== void 0 ? _ElevarDataLayer : [];
        window.ElevarDataLayer.push(event);
        if (DEBUG) console.log("DataLayer:elevar:".concat(event.event), event);
    }, []);
    var viewCartEvent = (0,react.useCallback)(function(param) {
        var _cart = param.cart, ecommerce = param.ecommerce, _userProperties = param.userProperties;
        var ref, ref1, ref2, ref3, ref4;
        if (!_cart) return;
        var previousPath = sessionStorage.getItem("PREVIOUS_PATH");
        var list = window.location.pathname.startsWith("/collections") && window.location.pathname || (previousPath === null || previousPath === void 0 ? void 0 : previousPath.startsWith("/collections")) && previousPath || "";
        var event = {
            event: "dl_view_cart",
            user_properties: _userProperties,
            cart_total: (ref = _cart.estimatedCost) === null || ref === void 0 ? void 0 : (ref1 = ref.totalAmount) === null || ref1 === void 0 ? void 0 : ref1.amount,
            ecommerce: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ecommerce), {
                actionField: {
                    list: "Shopping Cart"
                },
                cart_id: (ref2 = _cart.id) === null || ref2 === void 0 ? void 0 : ref2.split("/").pop(),
                cart_count: ((ref3 = _cart.lines) === null || ref3 === void 0 ? void 0 : ref3.reduce(function(acc, line) {
                    return acc + line.quantity;
                }, 0)) || 0,
                impressions: ((ref4 = _cart.lines) === null || ref4 === void 0 ? void 0 : ref4.map(mapLineItem(list))) || []
            })
        };
        var _ElevarDataLayer;
        window.ElevarDataLayer = (_ElevarDataLayer = window.ElevarDataLayer) !== null && _ElevarDataLayer !== void 0 ? _ElevarDataLayer : [];
        window.ElevarDataLayer.push(event);
        if (DEBUG) console.log("DataLayer:elevar:".concat(event.event), event);
    }, []);
    // Trigger 'dl_view_cart' event on cart page
    (0,react.useEffect)(function() {
        if (!asPath.startsWith("/cart") || !cart || !baseEcommerce || !userProperties || asPath === asPathRef.current) return undefined;
        userDataEvent({
            ecommerce: baseEcommerce,
            userProperties: userProperties
        });
        viewCartEvent({
            cart: cart,
            ecommerce: baseEcommerce,
            userProperties: userProperties
        });
        asPathRef.current = asPath;
        return function() {
            asPathRef.current = null;
        };
    }, [
        asPath,
        !!cart,
        !!baseEcommerce,
        !!userProperties
    ]);
    // Trigger 'dl_view_cart' event when cart is opened
    (0,react.useEffect)(function() {
        if (!baseEcommerce || !cartOpen || !userDataEventTriggered || !userProperties) return;
        userDataEvent({
            ecommerce: baseEcommerce,
            userProperties: userProperties
        });
        viewCartEvent({
            cart: cart,
            ecommerce: baseEcommerce,
            userProperties: userProperties
        });
    }, [
        !!baseEcommerce,
        cartOpen,
        userDataEventTriggered
    ]);
    // Determine if a cart item was added, removed, or updated for events
    (0,react.useEffect)(function() {
        if (!cart || !baseEcommerce || !userDataEventTriggered) return;
        var cartItemsMap = cartItems.reduce(function(acc, line) {
            if (!line.variant) return acc;
            var variantId = line.variant.id;
            if (!acc[variantId]) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, variantId, [
                    line
                ]));
            }
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, variantId, (0,_to_consumable_array/* default */.Z)(acc[variantId]).concat([
                line
            ])));
        }, {});
        if (!previousCartItems || previousCartCount === cartCount) {
            setPreviousCartItems(cartItems);
            setPreviousCartCount(cartCount);
            setPreviousCartItemsMap(cartItemsMap);
            return;
        }
        var isAddedItems = [];
        var isIncreasedItems = [];
        var isRemovedItems = [];
        var isDecreasedItems = [];
        if (cartCount > previousCartCount) {
            cartItems.forEach(function(line, index) {
                var ref, ref1;
                var variantId = (ref = line.variant) === null || ref === void 0 ? void 0 : ref.id;
                if (!variantId) return;
                var previousLine = (ref1 = previousCartItemsMap[variantId]) === null || ref1 === void 0 ? void 0 : ref1.find(function(prevLine) {
                    var ref, ref1, ref2, ref3;
                    var hasSameSellingPlanSelection = !prevLine.sellingPlanAllocation && !line.sellingPlanAllocation || ((ref = prevLine.sellingPlanAllocation) === null || ref === void 0 ? void 0 : (ref1 = ref.sellingPlan) === null || ref1 === void 0 ? void 0 : ref1.id) === ((ref2 = line.sellingPlanAllocation) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.sellingPlan) === null || ref3 === void 0 ? void 0 : ref3.id);
                    return hasSameSellingPlanSelection && fast_deep_equal_default()(prevLine.attributes, line.attributes);
                });
                if (!previousLine) {
                    isAddedItems.push((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, line), {
                        index: index
                    }));
                    return;
                }
                if (line.quantity > previousLine.quantity) {
                    isIncreasedItems.push((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, line), {
                        quantity: line.quantity - previousLine.quantity,
                        index: index
                    }));
                }
            });
        } else if (cartCount < previousCartCount) {
            previousCartItems.forEach(function(prevLine, index) {
                var ref, ref1;
                var variantId = (ref = prevLine.variant) === null || ref === void 0 ? void 0 : ref.id;
                if (!variantId) return;
                var currentLine = (ref1 = cartItemsMap[variantId]) === null || ref1 === void 0 ? void 0 : ref1.find(function(line) {
                    var ref, ref1, ref2, ref3;
                    var hasSameSellingPlanSelection = !prevLine.sellingPlanAllocation && !line.sellingPlanAllocation || ((ref = prevLine.sellingPlanAllocation) === null || ref === void 0 ? void 0 : (ref1 = ref.sellingPlan) === null || ref1 === void 0 ? void 0 : ref1.id) === ((ref2 = line.sellingPlanAllocation) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.sellingPlan) === null || ref3 === void 0 ? void 0 : ref3.id);
                    return hasSameSellingPlanSelection && fast_deep_equal_default()(prevLine.attributes, line.attributes);
                });
                if (!currentLine) {
                    isRemovedItems.push((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevLine), {
                        index: index
                    }));
                    return;
                }
                if (currentLine.quantity < prevLine.quantity) {
                    isDecreasedItems.push((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevLine), {
                        quantity: prevLine.quantity - currentLine.quantity,
                        index: index
                    }));
                }
            });
        }
        if (isAddedItems.length || isIncreasedItems.length) {
            (0,_to_consumable_array/* default */.Z)(isAddedItems).concat((0,_to_consumable_array/* default */.Z)(isIncreasedItems)).forEach(function(line) {
                addToCartEvent({
                    cart: cart,
                    ecommerce: baseEcommerce,
                    lineItems: [
                        line
                    ],
                    userProperties: userProperties
                });
                klaviyoAddToCart({
                    cart: cart
                });
            });
        }
        if (isRemovedItems.length || isDecreasedItems.length) {
            removeFromCartEvent({
                cart: cart,
                ecommerce: baseEcommerce,
                lineItems: (0,_to_consumable_array/* default */.Z)(isRemovedItems).concat((0,_to_consumable_array/* default */.Z)(isDecreasedItems)),
                userProperties: userProperties
            });
        }
        if (isAddedItems.length || isIncreasedItems.length || isRemovedItems.length || isDecreasedItems.length) {
            cartChangeTrigger();
        }
        setPreviousCartItems(cartItems);
        setPreviousCartCount(cartCount);
        setPreviousCartItemsMap(cartItemsMap);
    }, [
        cart === null || cart === void 0 ? void 0 : cart.updatedAt,
        !!baseEcommerce,
        userDataEventTriggered
    ]);
}

;// CONCATENATED MODULE: ./src/snippets/DataLayer/hooks/useDataLayerCollection.js






function useDataLayerCollection(param) {
    var baseEcommerce = param.baseEcommerce, DEBUG = param.DEBUG, isPageAsCollection = param.isPageAsCollection, userDataEvent = param.userDataEvent, userDataEventTriggered = param.userDataEventTriggered, userProperties = param.userProperties;
    var collectionHandleRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(null), collectionProducts = ref[0], setCollectionProducts = ref[1];
    var ref1 = (0,react.useState)(null), collectionId = ref1[0], setCollectionId = ref1[1];
    var ref2 = (0,react.useState)(null), clickedCollectionItem = ref2[0], setClickedCollectionItem = ref2[1];
    var ref3 = (0,react.useState)(null), clickedBundleItemVariants = ref3[0], setClickedBundleItemVariants = ref3[1];
    var viewCollectionEvent = (0,react.useCallback)(function(param) {
        var ecommerce = param.ecommerce, products = param.products, _userProperties = param.userProperties;
        if (!(products === null || products === void 0 ? void 0 : products.length)) return;
        var list = window.location.pathname.startsWith("/collections") ? window.location.pathname : "";
        var event = {
            event: "dl_view_item_list",
            user_properties: _userProperties,
            ecommerce: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ecommerce), {
                impressions: products.slice(0, 7).map(mapProductItemProduct(list))
            })
        };
        var _ElevarDataLayer;
        window.ElevarDataLayer = (_ElevarDataLayer = window.ElevarDataLayer) !== null && _ElevarDataLayer !== void 0 ? _ElevarDataLayer : [];
        window.ElevarDataLayer.push(event);
        if (DEBUG) console.log("DataLayer:elevar:".concat(event.event), event);
    }, []);
    var clickCollectionItemEvent = (0,react.useCallback)(function(param) {
        var ecommerce = param.ecommerce, variant = param.variant;
        if (!variant) return;
        var list = variant.list || "";
        var event = {
            event: "dl_select_item",
            user_properties: userProperties,
            ecommerce: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ecommerce), {
                click: {
                    actionField: {
                        list: window.location.pathname.startsWith("/collection") ? window.location.pathname : "",
                        action: "click"
                    },
                    products: [
                        variant
                    ].map(mapProductItemVariant(list))
                }
            })
        };
        var _ElevarDataLayer;
        window.ElevarDataLayer = (_ElevarDataLayer = window.ElevarDataLayer) !== null && _ElevarDataLayer !== void 0 ? _ElevarDataLayer : [];
        window.ElevarDataLayer.push(event);
        if (DEBUG) console.log("DataLayer:elevar:".concat(event.event), event);
    }, [
        isPageAsCollection,
        userProperties
    ]);
    var clickBundleItemEvent = (0,react.useCallback)(function(param) {
        var ecommerce = param.ecommerce, variants = param.variants;
        if (!(variants === null || variants === void 0 ? void 0 : variants.length)) return;
        var list = variants[0].list || "";
        var event = {
            event: "dl_select_item",
            user_properties: userProperties,
            ecommerce: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ecommerce), {
                click: {
                    actionField: {
                        list: window.location.pathname.startsWith("/collection") || isPageAsCollection ? window.location.pathname : "",
                        action: "click"
                    },
                    products: variants.map(mapProductItemVariant(list))
                }
            })
        };
        var _ElevarDataLayer;
        window.ElevarDataLayer = (_ElevarDataLayer = window.ElevarDataLayer) !== null && _ElevarDataLayer !== void 0 ? _ElevarDataLayer : [];
        window.ElevarDataLayer.push(event);
        if (DEBUG) console.log("DataLayer:elevar:".concat(event.event), event);
    }, [
        isPageAsCollection,
        userProperties
    ]);
    // Subscribe to PubSub topic for 'dl_view_item_list' and 'dl_select_item' events
    (0,react.useEffect)(function() {
        var viewCollection = PubSub.subscribe("VIEW_COLLECTION_PAGE", function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(event, param) {
                var products, id;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    products = param.products, id = param.id;
                    setCollectionProducts(products);
                    setCollectionId(id);
                    return [
                        2
                    ];
                });
            });
            return function(event, _) {
                return _ref.apply(this, arguments);
            };
        }());
        var clickCollectionItem = PubSub.subscribe("CLICK_COLLECTION_ITEM", function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(event, variant) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    setClickedCollectionItem(variant);
                    return [
                        2
                    ];
                });
            });
            return function(event, variant) {
                return _ref.apply(this, arguments);
            };
        }());
        var clickBundleItem = PubSub.subscribe("CLICK_BUNDLE_ITEM", function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(event, variants) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    setClickedBundleItemVariants(variants);
                    return [
                        2
                    ];
                });
            });
            return function(event, variants) {
                return _ref.apply(this, arguments);
            };
        }());
        return function() {
            if (viewCollection) {
                PubSub.unsubscribe(viewCollection);
            }
            if (clickCollectionItem) {
                PubSub.unsubscribe(clickCollectionItem);
            }
            if (clickBundleItem) {
                PubSub.unsubscribe(clickBundleItem);
            }
        };
    }, []);
    // Trigger 'dl_user_data' and view 'dl_view_item_list'
    // events on collection page and after base data is ready
    (0,react.useEffect)(function() {
        var pageHandle = window.location.pathname.startsWith("/pages") ? "/pages/".concat(window.location.pathname.split("/").pop()) : window.location.pathname.split("/").pop();
        if (!(collectionProducts === null || collectionProducts === void 0 ? void 0 : collectionProducts.length) || !baseEcommerce || !userProperties || collectionHandleRef.current === pageHandle) return;
        userDataEvent({
            ecommerce: baseEcommerce,
            userProperties: userProperties
        });
        viewCollectionEvent({
            ecommerce: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, baseEcommerce), {
                collection_id: collectionId
            }),
            products: collectionProducts,
            userProperties: userProperties
        });
        collectionHandleRef.current = pageHandle;
    }, [
        collectionId,
        collectionProducts,
        !!baseEcommerce,
        !!userProperties
    ]);
    // Trigger 'dl_select_item' event on clicked collection
    // item and after user event
    (0,react.useEffect)(function() {
        if (!clickedCollectionItem || !baseEcommerce || !userDataEventTriggered) return;
        clickCollectionItemEvent({
            ecommerce: baseEcommerce,
            variant: clickedCollectionItem
        });
    }, [
        clickedCollectionItem,
        !!baseEcommerce,
        userDataEventTriggered
    ]);
    // Trigger 'dl_select_item' event on clicked collection
    // item and after user event
    (0,react.useEffect)(function() {
        if (!(clickedBundleItemVariants === null || clickedBundleItemVariants === void 0 ? void 0 : clickedBundleItemVariants.length) || !baseEcommerce || !userDataEventTriggered) return;
        clickBundleItemEvent({
            ecommerce: baseEcommerce,
            variants: clickedBundleItemVariants
        });
    }, [
        clickedBundleItemVariants,
        !!baseEcommerce,
        userDataEventTriggered
    ]);
}

;// CONCATENATED MODULE: ./src/snippets/DataLayer/hooks/useDataLayerCustomer.js






var IGNORED_PATHS = [
    "account",
    "cart",
    "collections",
    "products"
];
function useDataLayerCustomer(param) {
    var baseEcommerce = param.baseEcommerce, DEBUG = param.DEBUG, isPageAsProduct = param.isPageAsProduct, isPageAsCollection = param.isPageAsCollection, userProperties = param.userProperties;
    var asPathRef = (0,react.useRef)(null);
    var cart = (0,dist.useCart)();
    var router = (0,next_router.useRouter)();
    var asPath = router.asPath.split("?")[0];
    var ref = (0,react.useState)(false), delayForContextIsFinished = ref[0], setDelayForContextIsFinished = ref[1];
    var ref1 = (0,react.useState)(false), userDataEventTriggered = ref1[0], setUserDataEventTriggered = ref1[1];
    var userDataEvent = (0,react.useCallback)(function(param) {
        var ecommerce = param.ecommerce, _userProperties = param.userProperties;
        var ref, ref1, ref2;
        var previousPath = sessionStorage.getItem("PREVIOUS_PATH");
        var list = window.location.pathname.startsWith("/collections") && window.location.pathname || (previousPath === null || previousPath === void 0 ? void 0 : previousPath.startsWith("/collections")) && previousPath || "";
        var event = {
            event: "dl_user_data",
            user_properties: _userProperties,
            cart_total: (cart === null || cart === void 0 ? void 0 : (ref = cart.estimatedCost) === null || ref === void 0 ? void 0 : (ref1 = ref.totalAmount) === null || ref1 === void 0 ? void 0 : ref1.amount) || "0.0",
            ecommerce: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ecommerce), {
                cart_contents: {
                    products: (cart === null || cart === void 0 ? void 0 : (ref2 = cart.lines) === null || ref2 === void 0 ? void 0 : ref2.map(mapLineItem(list))) || []
                }
            })
        };
        var _ElevarDataLayer;
        window.ElevarDataLayer = (_ElevarDataLayer = window.ElevarDataLayer) !== null && _ElevarDataLayer !== void 0 ? _ElevarDataLayer : [];
        window.ElevarDataLayer.push(event);
        if (DEBUG) console.log("DataLayer:elevar:".concat(event.event), event);
        setUserDataEventTriggered(true);
        setDelayForContextIsFinished(false);
    }, [
        cart === null || cart === void 0 ? void 0 : cart.updatedAt
    ]);
    // Force delay on user data event
    (0,react.useEffect)(function() {
        setTimeout(function() {
            return setDelayForContextIsFinished(true);
        }, 1000);
    }, [
        asPath
    ]);
    // Trigger 'dl_user_data' event on path change after base data is ready,
    // excluding account and paths that trigger event directly before their respective events
    (0,react.useEffect)(function() {
        if (!delayForContextIsFinished || !baseEcommerce || !userProperties || IGNORED_PATHS.includes(asPath.split("/")[1]) || asPath.startsWith("/pages/search") || isPageAsProduct || isPageAsCollection || asPath === asPathRef.current) return undefined;
        userDataEvent({
            ecommerce: baseEcommerce,
            userProperties: userProperties
        });
        asPathRef.current = asPath;
        return function() {
            asPathRef.current = null;
        };
    }, [
        asPath,
        !!baseEcommerce,
        delayForContextIsFinished,
        isPageAsProduct,
        isPageAsCollection,
        !!userProperties, 
    ]);
    // Trigger 'dl_user_data' event on account pages after base data is ready,
    // excluding after login/register events
    (0,react.useEffect)(function() {
        if (!delayForContextIsFinished || !baseEcommerce || !userProperties || !asPath.startsWith("/account") || asPath === asPathRef.current) return undefined;
        userDataEvent({
            ecommerce: baseEcommerce,
            userProperties: userProperties
        });
        asPathRef.current = asPath;
        return function() {
            asPathRef.current = null;
        };
    }, [
        asPath,
        !!baseEcommerce,
        delayForContextIsFinished,
        !!userProperties
    ]);
    return {
        userDataEvent: userDataEvent,
        userDataEventTriggered: userDataEventTriggered
    };
}

;// CONCATENATED MODULE: ./src/snippets/DataLayer/hooks/useDataLayerInit.js








function useDataLayerInit(param) {
    var DEBUG = param.DEBUG;
    var asPathRef = (0,react.useRef)(null);
    var isLatestRef = (0,react.useRef)(false);
    var customer = (0,dist.useCustomer)();
    var router = (0,next_router.useRouter)();
    var asPath = router.asPath.split("?")[0];
    var accessToken = (0,dist.useCustomerAccessToken)();
    var ref = (0,react.useState)(false), customerReady = ref[0], setCustomerReady = ref[1];
    var ref1 = (0,react.useState)(null), userProperties = ref1[0], setUserProperties = ref1[1];
    var generateUserProperties = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var _customer, _accessToken, _userProperties, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, orders;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _customer = param.customer, _accessToken = param.accessToken;
                        _userProperties = {};
                        if (!_customer) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            fetchCustomerOrders({
                                accessToken: _accessToken
                            })
                        ];
                    case 1:
                        orders = _state.sent();
                        _userProperties = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            visitor_type: "logged_in",
                            user_consent: ""
                        }, returnKeyValueIfNotEmpty("customer_address_1", (ref = _customer.defaultAddress) === null || ref === void 0 ? void 0 : ref.address1), returnKeyValueIfNotEmpty("customer_address_2", (ref1 = _customer.defaultAddress) === null || ref1 === void 0 ? void 0 : ref1.address2), returnKeyValueIfNotEmpty("customer_city", (ref2 = _customer.defaultAddress) === null || ref2 === void 0 ? void 0 : ref2.city), returnKeyValueIfNotEmpty("customer_country", (ref3 = _customer.defaultAddress) === null || ref3 === void 0 ? void 0 : ref3.country), returnKeyValueIfNotEmpty("customer_country_code", (ref4 = _customer.defaultAddress) === null || ref4 === void 0 ? void 0 : ref4.countryCode), returnKeyValueIfNotEmpty("customer_phone", (ref5 = _customer.defaultAddress) === null || ref5 === void 0 ? void 0 : ref5.phone), returnKeyValueIfNotEmpty("customer_province_code", (ref6 = _customer.defaultAddress) === null || ref6 === void 0 ? void 0 : ref6.provinceCode), returnKeyValueIfNotEmpty("customer_province", (ref7 = _customer.defaultAddress) === null || ref7 === void 0 ? void 0 : ref7.province), returnKeyValueIfNotEmpty("customer_zip", (ref8 = _customer.defaultAddress) === null || ref8 === void 0 ? void 0 : ref8.zip)), {
                            customer_email: _customer.email,
                            customer_first_name: _customer.firstName,
                            customer_id: ((ref9 = _customer.id) === null || ref9 === void 0 ? void 0 : ref9.split("/").pop()) || "",
                            customer_last_name: _customer.lastName,
                            customer_order_count: "".concat((orders === null || orders === void 0 ? void 0 : orders.length) || 0),
                            customer_tags: ((ref10 = _customer.tags) === null || ref10 === void 0 ? void 0 : ref10.join(", ")) || "",
                            customer_total_spent: orders === null || orders === void 0 ? void 0 : orders.reduce(function(acc, order) {
                                var ref;
                                return acc + parseFloat(((ref = order.totalPriceV2) === null || ref === void 0 ? void 0 : ref.amount) || 0);
                            }, 0).toFixed(2)
                        });
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _userProperties = {
                            visitor_type: "guest",
                            user_consent: ""
                        };
                        _state.label = 3;
                    case 3:
                        setUserProperties(_userProperties);
                        return [
                            2,
                            _userProperties
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    (0,react.useEffect)(function() {
        var setUserId = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var data, dataJson;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fetch("/api/get-set-userid")
                            ];
                        case 1:
                            data = _state.sent();
                            return [
                                4,
                                data.json()
                            ];
                        case 2:
                            dataJson = _state.sent();
                            return [
                                2,
                                dataJson.id
                            ];
                    }
                });
            });
            return function setUserId() {
                return _ref.apply(this, arguments);
            };
        }();
        window.ElevarUserIdFn = /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var userId;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            setUserId()
                        ];
                    case 1:
                        userId = _state.sent();
                        return [
                            2,
                            userId
                        ];
                }
            });
        });
    }, []);
    // accommodates customer logic for both older and newer versions of @backpackjs/storefront
    (0,react.useEffect)(function() {
        if (customerReady) return;
        if (typeof customer === "undefined") {
            isLatestRef.current = true;
            return;
        }
        if (customer) {
            setCustomerReady(true);
        } else if (isLatestRef.current && customer === null) {
            // if customer was undefined then becomes null, the customer is logged out
            setCustomerReady(true);
        } else {
            // if customer starts off as null, then set a timeout to wait
            setTimeout(function() {
                setCustomerReady(true);
            }, 2000);
        }
    }, [
        customer
    ]);
    // Set previous paths and current path in session storage
    (0,react.useEffect)(function() {
        var currentPath = sessionStorage.getItem("CURRENT_PATH");
        if (asPath === currentPath) {
            sessionStorage.setItem("PREVIOUS_PATH_INLC_REFRESH", asPath);
            return;
        }
        sessionStorage.setItem("PREVIOUS_PATH", currentPath);
        sessionStorage.setItem("PREVIOUS_PATH_INLC_REFRESH", currentPath);
        sessionStorage.setItem("CURRENT_PATH", asPath);
    }, [
        asPath
    ]);
    // generate user properties on customer ready and path change
    (0,react.useEffect)(function() {
        if (!customerReady || // wait until customer status is ready
        customer && !(accessToken === null || accessToken === void 0 ? void 0 : accessToken.token) || // wait until accessToken is ready, if logged in customer
        asPath === asPathRef.current // prevent multiple triggers on same path
        ) return undefined;
        generateUserProperties({
            customer: customer,
            accessToken: accessToken === null || accessToken === void 0 ? void 0 : accessToken.token
        });
        asPathRef.current = asPath;
        return function() {
            asPathRef.current = null;
        };
    }, [
        accessToken === null || accessToken === void 0 ? void 0 : accessToken.token,
        asPath,
        customerReady
    ]);
    (0,react.useEffect)(function() {
        var ref;
        var handleRouteChange = function() {
            if (!(window === null || window === void 0 ? void 0 : window.ElevarInvalidateContext)) return;
            window.ElevarInvalidateContext();
            if (DEBUG) console.log("DataLayer:elevar:context");
        };
        router === null || router === void 0 ? void 0 : (ref = router.events) === null || ref === void 0 ? void 0 : ref.on("routeChangeComplete", handleRouteChange);
        return function() {
            var ref;
            router === null || router === void 0 ? void 0 : (ref = router.events) === null || ref === void 0 ? void 0 : ref.off("routeChangeComplete", handleRouteChange);
        };
    }, [
        router
    ]);
    return {
        generateUserProperties: generateUserProperties,
        userProperties: userProperties
    };
}

;// CONCATENATED MODULE: ./src/snippets/DataLayer/hooks/useDataLayerProduct.js






function useDataLayerProduct(param) {
    var baseEcommerce = param.baseEcommerce, DEBUG = param.DEBUG, userDataEvent = param.userDataEvent, userProperties = param.userProperties;
    var ref;
    var productHandleRef = (0,react.useRef)(null);
    var productBundleRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(null), viewedProductVariant = ref1[0], setViewedProductVariant = ref1[1];
    var ref2 = (0,react.useState)(null), viewedProduct = ref2[0], setViewedProduct = ref2[1];
    var ref3 = (0,react.useState)(null), viewedProductBundleVariants = ref3[0], setViewedProductBundleVariants = ref3[1];
    var klaviyoViewProduct = (0,react.useCallback)(function(param) {
        var _product = param.product;
        var _learnq = window._learnq || [];
        _learnq.push([
            "track",
            "Viewed Product",
            {
                Name: _product.title,
                ProductID: getIdFromString(_product.id),
                Categories: _product.collections === undefined ? null : _product.collections.map(function(a) {
                    return a.handle;
                }),
                ImageUrl: _product.featuredImage.src,
                Url: window.location.href,
                Brand: _product.vendor,
                Price: _product.variants[0].priceV2.amount,
                CompareAtPrice: _product.variants[0].compareAtPriceV2.amount
            }, 
        ]);
        _learnq.push([
            "trackViewedItem",
            {
                Title: _product.title,
                ItemId: getIdFromString(_product.id),
                Categories: _product.collections === undefined ? null : _product.collections.map(function(a) {
                    return a.handle;
                }),
                ImageUrl: _product.featuredImage.src,
                Url: window.location.href,
                Metadata: {
                    Brand: _product.vendor,
                    Price: _product.variants[0].priceV2.amount,
                    CompareAtPrice: _product.variants[0].compareAtPriceV2.amount
                }
            }, 
        ]);
    }, []);
    var viewProductEvent = (0,react.useCallback)(function(param) {
        var ecommerce = param.ecommerce, variant = param.variant, _userProperties = param.userProperties;
        if (!variant) return;
        var previousPath = sessionStorage.getItem("PREVIOUS_PATH");
        var list = (previousPath === null || previousPath === void 0 ? void 0 : previousPath.startsWith("/collections")) ? previousPath : "";
        var event = {
            event: "dl_view_item",
            user_properties: _userProperties,
            ecommerce: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ecommerce), {
                detail: {
                    actionField: {
                        list: list,
                        action: "detail"
                    },
                    products: [
                        variant
                    ].map(mapProductPageVariant(list))
                }
            })
        };
        var _ElevarDataLayer;
        window.ElevarDataLayer = (_ElevarDataLayer = window.ElevarDataLayer) !== null && _ElevarDataLayer !== void 0 ? _ElevarDataLayer : [];
        window.ElevarDataLayer.push(event);
        if (DEBUG) console.log("DataLayer:elevar:".concat(event.event), event);
    }, []);
    var viewProductBundleEvent = (0,react.useCallback)(function(param) {
        var ecommerce = param.ecommerce, variants = param.variants, _userProperties = param.userProperties;
        if (!(variants === null || variants === void 0 ? void 0 : variants.length)) return;
        var previousPath = sessionStorage.getItem("PREVIOUS_PATH");
        var list = (previousPath === null || previousPath === void 0 ? void 0 : previousPath.startsWith("/collections")) || (previousPath === null || previousPath === void 0 ? void 0 : previousPath.startsWith("/pages")) && (previousPath === null || previousPath === void 0 ? void 0 : previousPath.includes("kits")) ? previousPath : "";
        var event = {
            event: "dl_view_item",
            user_properties: _userProperties,
            ecommerce: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ecommerce), {
                detail: {
                    actionField: {
                        list: list,
                        action: "detail"
                    },
                    products: variants.map(mapProductPageVariant(list))
                }
            })
        };
        var _ElevarDataLayer;
        window.ElevarDataLayer = (_ElevarDataLayer = window.ElevarDataLayer) !== null && _ElevarDataLayer !== void 0 ? _ElevarDataLayer : [];
        window.ElevarDataLayer.push(event);
        if (DEBUG) console.log("DataLayer:elevar:".concat(event.event), event);
    }, []);
    // Subscribe to PubSub topic for 'dl_view_item' event
    (0,react.useEffect)(function() {
        var viewProductVariant = PubSub.subscribe("VIEW_PRODUCT_PAGE", function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(event, param) {
                var product, variant;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    product = param.product, variant = param.variant;
                    setViewedProductVariant(variant);
                    setViewedProduct(product);
                    return [
                        2
                    ];
                });
            });
            return function(event, _) {
                return _ref.apply(this, arguments);
            };
        }());
        var viewProductBundle = PubSub.subscribe("VIEW_PRODUCT_BUNDLE_PAGE", function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(event, variants) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    setViewedProductBundleVariants(variants);
                    return [
                        2
                    ];
                });
            });
            return function(event, variants) {
                return _ref.apply(this, arguments);
            };
        }());
        return function() {
            if (viewProductVariant) {
                PubSub.unsubscribe(viewProductVariant);
            }
            if (viewProductBundle) {
                PubSub.unsubscribe(viewProductBundle);
            }
        };
    }, []);
    (0,react.useEffect)(function() {
        if (!viewedProduct) return;
        klaviyoViewProduct({
            product: viewedProduct
        });
    }, [
        viewedProduct === null || viewedProduct === void 0 ? void 0 : viewedProduct.id
    ]);
    // Trigger 'dl_user_data' and 'dl_view_item' events on product change after base data is ready
    (0,react.useEffect)(function() {
        var pageHandle = window.location.pathname.split("/").pop();
        if (!baseEcommerce || !userProperties || !viewedProductVariant || productHandleRef.current === pageHandle) return;
        userDataEvent({
            ecommerce: baseEcommerce,
            userProperties: userProperties
        });
        viewProductEvent({
            ecommerce: baseEcommerce,
            variant: viewedProductVariant,
            userProperties: userProperties
        });
        productHandleRef.current = pageHandle;
    }, [
        !!baseEcommerce,
        viewedProductVariant === null || viewedProductVariant === void 0 ? void 0 : (ref = viewedProductVariant.product) === null || ref === void 0 ? void 0 : ref.id,
        !!userProperties
    ]);
    // Trigger 'dl_user_data' and 'dl_view_item' events on viewedProductVariant change after base data is ready
    (0,react.useEffect)(function() {
        var productBundlePathname = window.location.pathname;
        if (!baseEcommerce || !userProperties || !(viewedProductBundleVariants === null || viewedProductBundleVariants === void 0 ? void 0 : viewedProductBundleVariants.length) || productBundleRef.current === productBundlePathname) return;
        userDataEvent({
            ecommerce: baseEcommerce,
            userProperties: userProperties
        });
        viewProductBundleEvent({
            ecommerce: baseEcommerce,
            variants: viewedProductBundleVariants,
            userProperties: userProperties
        });
        productBundleRef.current = productBundlePathname;
    }, [
        !!baseEcommerce,
        viewedProductBundleVariants,
        !!userProperties
    ]);
}

;// CONCATENATED MODULE: ./src/snippets/DataLayer/hooks/useDataLayerSearch.js







function useDataLayerSearch(param) {
    var baseEcommerce = param.baseEcommerce, DEBUG = param.DEBUG, userDataEvent = param.userDataEvent, userDataEventTriggered = param.userDataEventTriggered, userProperties = param.userProperties;
    var asPathRef = (0,react.useRef)(null);
    var router = (0,next_router.useRouter)();
    var asPath = router.asPath.split("?")[0];
    var ref = (0,react.useState)(null), searchPageResults = ref[0], setSearchPageResults = ref[1];
    var ref1 = (0,react.useState)(null), searchResults = ref1[0], setSearchResults = ref1[1];
    var ref2 = (0,react.useState)(null), clickedSearchResultsItem = ref2[0], setClickedSearchResultsItem = ref2[1];
    var viewSearchResultsEvent = (0,react.useCallback)(function(param) {
        var ecommerce = param.ecommerce, results = param.results, _userProperties = param.userProperties;
        if (!(results === null || results === void 0 ? void 0 : results.length)) return;
        var event = {
            event: "dl_view_search_results",
            user_properties: _userProperties,
            ecommerce: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ecommerce), {
                actionField: {
                    list: "search results",
                    search_term: results[0].searchTerm
                },
                impressions: results.slice(0, 7).map(mapProductItemProduct())
            })
        };
        var _ElevarDataLayer;
        window.ElevarDataLayer = (_ElevarDataLayer = window.ElevarDataLayer) !== null && _ElevarDataLayer !== void 0 ? _ElevarDataLayer : [];
        window.ElevarDataLayer.push(event);
        if (DEBUG) console.log("DataLayer:elevar:".concat(event.event), event);
    }, []);
    var clickSearchResultsItemEvent = (0,react.useCallback)(function(param) {
        var ecommerce = param.ecommerce, _userProperties = param.userProperties, variant = param.variant;
        if (!variant) return;
        var event = {
            event: "dl_select_item",
            user_properties: _userProperties,
            ecommerce: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ecommerce), {
                click: {
                    actionField: {
                        list: "search_results",
                        action: "click",
                        search_term: variant.searchTerm
                    },
                    products: [
                        variant
                    ].map(mapProductItemVariant())
                }
            })
        };
        var _ElevarDataLayer;
        window.ElevarDataLayer = (_ElevarDataLayer = window.ElevarDataLayer) !== null && _ElevarDataLayer !== void 0 ? _ElevarDataLayer : [];
        window.ElevarDataLayer.push(event);
        if (DEBUG) console.log("DataLayer:elevar:".concat(event.event), event);
    }, []);
    // Subscribe to PubSub topics for 'view_search_results' and 'select_item' events
    (0,react.useEffect)(function() {
        var viewSearchPageResults = PubSub.subscribe("VIEW_SEARCH_PAGE_RESULTS", function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(event, results) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    setSearchPageResults(results);
                    return [
                        2
                    ];
                });
            });
            return function(event, results) {
                return _ref.apply(this, arguments);
            };
        }());
        var viewSearchResults = PubSub.subscribe("VIEW_SEARCH_RESULTS", function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(event, results) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    setSearchResults(results);
                    return [
                        2
                    ];
                });
            });
            return function(event, results) {
                return _ref.apply(this, arguments);
            };
        }());
        var clickSearchItem = PubSub.subscribe("CLICK_SEARCH_ITEM", function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(event, variant) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    setClickedSearchResultsItem(variant);
                    return [
                        2
                    ];
                });
            });
            return function(event, variant) {
                return _ref.apply(this, arguments);
            };
        }());
        return function() {
            if (viewSearchPageResults) {
                PubSub.unsubscribe(viewSearchPageResults);
            }
            if (viewSearchResults) {
                PubSub.unsubscribe(viewSearchResults);
            }
            if (clickSearchItem) {
                PubSub.unsubscribe(clickSearchItem);
            }
        };
    }, []);
    // Trigger 'dl_user_data' and 'dl_view_search_results' events after
    // new sidebar search results and base data is ready
    (0,react.useEffect)(function() {
        if (!asPath.startsWith("/pages/search") || !baseEcommerce || !(searchPageResults === null || searchPageResults === void 0 ? void 0 : searchPageResults.length) || !userProperties || asPath === asPathRef.current) return undefined;
        userDataEvent({
            ecommerce: baseEcommerce,
            userProperties: userProperties
        });
        viewSearchResultsEvent({
            ecommerce: baseEcommerce,
            results: searchPageResults,
            userProperties: userProperties
        });
        asPathRef.current = asPath;
        return function() {
            asPathRef.current = null;
        };
    }, [
        asPath,
        !!baseEcommerce,
        searchPageResults === null || searchPageResults === void 0 ? void 0 : searchPageResults.map(function(p) {
            return p === null || p === void 0 ? void 0 : p.handle;
        }).join(""),
        !!userProperties, 
    ]);
    // Trigger 'dl_user_data' and 'dl_view_search_results' events after
    // new search page results and base data is ready
    (0,react.useEffect)(function() {
        if (!baseEcommerce || !searchResults || !userDataEventTriggered || !userProperties) return;
        userDataEvent({
            ecommerce: baseEcommerce,
            userProperties: userProperties
        });
        viewSearchResultsEvent({
            ecommerce: baseEcommerce,
            results: searchResults,
            userProperties: userProperties
        });
    }, [
        !!baseEcommerce,
        searchResults,
        userDataEventTriggered
    ]);
    // Trigger 'dl_select_item' after clicked search item and user event
    (0,react.useEffect)(function() {
        if (!clickedSearchResultsItem || !baseEcommerce || !userDataEventTriggered) return;
        clickSearchResultsItemEvent({
            ecommerce: baseEcommerce,
            userProperties: userProperties,
            variant: clickedSearchResultsItem
        });
    }, [
        clickedSearchResultsItem,
        !!baseEcommerce,
        userDataEventTriggered
    ]);
}

;// CONCATENATED MODULE: ./src/snippets/DataLayer/hooks/useDataLayerSubscribe.js



function useDataLayerSubscribe(param) {
    var baseEcommerce = param.baseEcommerce, DEBUG = param.DEBUG, userDataEventTriggered = param.userDataEventTriggered;
    var ref = (0,react.useState)(""), subscribedEmail = ref[0], setSubscribedEmail = ref[1];
    var ref1 = (0,react.useState)(""), subscribedEmailFormId = ref1[0], setSubscribedEmailFormId = ref1[1];
    var ref2 = (0,react.useState)(""), subscribedPhone = ref2[0], setSubscribedPhone = ref2[1];
    var subscribeEmailEvent = (0,react.useCallback)(function(param) {
        var ecommerce = param.ecommerce, email = param.email, formId = param.form_id;
        if (!email) return;
        var event = {
            event: "dl_subscribe",
            lead_type: "email",
            form_id: formId,
            user_properties: {
                customer_email: email
            },
            ecommerce: ecommerce
        };
        var _ElevarDataLayer;
        window.ElevarDataLayer = (_ElevarDataLayer = window.ElevarDataLayer) !== null && _ElevarDataLayer !== void 0 ? _ElevarDataLayer : [];
        window.ElevarDataLayer.push(event);
        if (DEBUG) console.log("DataLayer:elevar:".concat(event.event), event);
    }, []);
    var subscribePhoneEvent = (0,react.useCallback)(function(param) {
        var ecommerce = param.ecommerce, phone = param.phone;
        if (!phone) return;
        var event = {
            event: "dl_subscribe",
            lead_type: "phone",
            user_properties: {
                customer_phone: phone
            },
            ecommerce: ecommerce
        };
        var _ElevarDataLayer;
        window.ElevarDataLayer = (_ElevarDataLayer = window.ElevarDataLayer) !== null && _ElevarDataLayer !== void 0 ? _ElevarDataLayer : [];
        window.ElevarDataLayer.push(event);
        if (DEBUG) console.log("DataLayer:elevar:".concat(event.event), event);
    }, []);
    // Subscribe to PubSub topic for 'dl_subscribe' event
    (0,react.useEffect)(function() {
        var subscribedWithEmail = PubSub.subscribe("SUBSCRIBE_EMAIL", function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(event, payload) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    if (typeof payload === "string") {
                        setSubscribedEmail(payload);
                        setSubscribedEmailFormId("");
                        return [
                            2
                        ];
                    }
                    setSubscribedEmail((payload === null || payload === void 0 ? void 0 : payload.email) || "");
                    setSubscribedEmailFormId((payload === null || payload === void 0 ? void 0 : payload.form_id) || "");
                    return [
                        2
                    ];
                });
            });
            return function(event, payload) {
                return _ref.apply(this, arguments);
            };
        }());
        var subscribedWithPhone = PubSub.subscribe("SUBSCRIBE_PHONE", function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(event, phone) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    setSubscribedPhone(phone);
                    return [
                        2
                    ];
                });
            });
            return function(event, phone) {
                return _ref.apply(this, arguments);
            };
        }());
        return function() {
            if (subscribedWithEmail) {
                PubSub.unsubscribe(subscribedWithEmail);
            }
            if (subscribedWithPhone) {
                PubSub.unsubscribe(subscribedWithPhone);
            }
        };
    }, []);
    // Trigger 'dl_subscribe' event after email submission
    (0,react.useEffect)(function() {
        if (!baseEcommerce || !subscribedEmail || !userDataEventTriggered) return;
        subscribeEmailEvent({
            ecommerce: baseEcommerce,
            email: subscribedEmail,
            form_id: subscribedEmailFormId
        });
    }, [
        !!baseEcommerce,
        subscribedEmail,
        subscribedEmailFormId,
        userDataEventTriggered, 
    ]);
    // Trigger 'dl_subscribe' event after phone submission
    (0,react.useEffect)(function() {
        if (!baseEcommerce || !subscribedPhone || !userDataEventTriggered) return;
        subscribePhoneEvent({
            ecommerce: baseEcommerce,
            phone: subscribedPhone
        });
    }, [
        !!baseEcommerce,
        subscribedPhone,
        userDataEventTriggered
    ]);
}

;// CONCATENATED MODULE: ./src/snippets/DataLayer/hooks/index.js









;// CONCATENATED MODULE: ./src/snippets/DataLayer/useDataLayer.js



// Envs to set:
// * NEXT_PUBLIC_SITE_TITLE // provides backup brand name
// DEBUG via Elevar's Data Layer Listener, add to the console:
// * Turn on: window.ElevarDebugMode(true)
// * Turn off: window.ElevarDebugMode(false)
var DEBUG = false; // logs outside of Elevar. will log even if failed elevar event
function useDataLayer(param) {
    var pageProp = param.page, template = param.template;
    var currencyCode = (0,dist.useCurrency)();
    var page = template === "page" ? pageProp : undefined;
    var baseEcommerce = (0,react.useMemo)(function() {
        if (!currencyCode) return null;
        return {
            currencyCode: currencyCode
        };
    }, [
        currencyCode
    ]);
    var isPageAsProduct = (0,react.useMemo)(function() {
        var ref;
        if (!page) return false;
        var productTypeSections = [
            ""
        ]; // section template names
        return (ref = page.sections) === null || ref === void 0 ? void 0 : ref.some(function(param) {
            var _template = param._template;
            return productTypeSections.includes(_template);
        });
    }, [
        page === null || page === void 0 ? void 0 : page.id
    ]);
    var isPageAsCollection = (0,react.useMemo)(function() {
        var ref;
        if (!page) return false;
        var colTypeSections = [
            ""
        ]; // section template names
        return (ref = page.sections) === null || ref === void 0 ? void 0 : ref.some(function(param) {
            var _template = param._template;
            return colTypeSections.includes(_template);
        });
    }, [
        page === null || page === void 0 ? void 0 : page.id
    ]);
    var ref = useDataLayerInit({
        DEBUG: DEBUG
    }), generateUserProperties = ref.generateUserProperties, userProperties = ref.userProperties;
    var ref1 = useDataLayerCustomer({
        baseEcommerce: baseEcommerce,
        DEBUG: DEBUG,
        isPageAsProduct: isPageAsProduct,
        isPageAsCollection: isPageAsCollection,
        userProperties: userProperties
    }), userDataEvent = ref1.userDataEvent, userDataEventTriggered = ref1.userDataEventTriggered;
    useDataLayerAccount({
        baseEcommerce: baseEcommerce,
        DEBUG: DEBUG,
        generateUserProperties: generateUserProperties,
        userDataEvent: userDataEvent,
        userDataEventTriggered: userDataEventTriggered
    });
    useDataLayerCart({
        baseEcommerce: baseEcommerce,
        DEBUG: DEBUG,
        userDataEvent: userDataEvent,
        userDataEventTriggered: userDataEventTriggered,
        userProperties: userProperties
    });
    useDataLayerProduct({
        baseEcommerce: baseEcommerce,
        DEBUG: DEBUG,
        userDataEvent: userDataEvent,
        userProperties: userProperties
    });
    useDataLayerCollection({
        baseEcommerce: baseEcommerce,
        DEBUG: DEBUG,
        isPageAsCollection: isPageAsCollection,
        userDataEvent: userDataEvent,
        userDataEventTriggered: userDataEventTriggered,
        userProperties: userProperties
    });
    useDataLayerSearch({
        baseEcommerce: baseEcommerce,
        DEBUG: DEBUG,
        userDataEvent: userDataEvent,
        userDataEventTriggered: userDataEventTriggered,
        userProperties: userProperties
    });
    useDataLayerSubscribe({
        baseEcommerce: baseEcommerce,
        DEBUG: DEBUG,
        userDataEventTriggered: userDataEventTriggered
    });
}

;// CONCATENATED MODULE: ./src/snippets/DataLayer/DataLayer.jsx



// Envs to set:
// * NEXT_PUBLIC_SITE_TITLE // provides backup brand name
function DataLayer(param) {
    var pageTitle = param.pageTitle, template = param.template;
    useDataLayer({
        pageTitle: pageTitle,
        template: template
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
        id: "elevar-script",
        type: "module",
        dangerouslySetInnerHTML: {
            __html: '\n      try {\n        const response = await fetch("https://shopify-gtm-suite.getelevar.com/configs/c30da8adf1b4d36a351ff6ae1d7ccc7768e583e4/config.json");\n        const config = await response.json();\n        const scriptUrl = config.script_src_custom_pages;\n\n        if (scriptUrl) {\n          const { handler } = await import(scriptUrl);\n          await handler(config);\n        }\n      } catch (error) {\n        console.error("Elevar Error:", error);\n      }\n      '
        }
    });
}
DataLayer.displayName = "DataLayer";

;// CONCATENATED MODULE: ./src/snippets/DataLayer/index.js


;// CONCATENATED MODULE: ./src/snippets/Drawer/Drawer.jsx







function Drawer() {
    var ref = (0,contexts/* useGlobalContext */.b)(), drawer = ref.state.drawer, closeDrawer = ref.actions.closeDrawer;
    var ref1 = (0,react.useState)(true), animateIn = ref1[0], setAnimateIn = ref1[1];
    (0,react.useEffect)(function() {
        setAnimateIn(true);
    }, [
        drawer
    ]);
    var _ref = (0,_object_spread/* default */.Z)({}, drawer.props), className = _ref.className, props = (0,_object_without_properties/* default */.Z)(_ref, [
        "className"
    ]);
    return drawer.children ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "\n        fixed bottom-0 right-0 top-0 z-50 w-[calc(100%-2rem)] max-w-[48rem] overflow-hidden bg-background ".concat(className, "\n        ").concat(animateIn ? "animate-slideIn" : "", "\n      "),
        onAnimationEnd: function() {
            return setAnimateIn(false);
        }
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex h-full flex-col overflow-y-auto px-4 py-[46px] scrollbar-hide lg:px-[46px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute right-0 top-0 md:right-5 md:top-5 z-10",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        "aria-label": "Close drawer",
                        className: "right-[18px] top-[96px] z-10 flex h-[46px] w-[46px] items-center justify-center bg-transparent lg:right-[120px] lg:top-[127px]",
                        onClick: closeDrawer,
                        type: "button",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                            className: "w-6 text-text",
                            src: "/svgs/close.svg#close",
                            title: "Close",
                            viewBox: "0 0 24 24"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex-grow",
                    children: drawer.children
                })
            ]
        })
    })) : null;
}
Drawer.displayName = "Drawer";

;// CONCATENATED MODULE: ./src/snippets/Drawer/index.js


;// CONCATENATED MODULE: ./src/snippets/Footer/EmailSignup.jsx








function EmailSignup(param) {
    var includeFooterContent = param.includeFooterContent;
    var ref;
    var settings = (0,dist.useSettings)();
    var sendSubscribeEvent = (0,hooks/* useDataLayerActions */.KZ)().sendSubscribeEvent;
    var ref1 = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.footer) === null || ref === void 0 ? void 0 : ref.marketing), heading = ref1.heading, subtext = ref1.subtext;
    var ref2 = (0,react.useState)(""), formEmail = ref2[0], setFormEmail = ref2[1];
    var ref3 = (0,react.useState)(false), isSuccessful = ref3[0], setIsSuccessful = ref3[1];
    var handleNewsletterSignup = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
            var klaviyoResponse;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        return [
                            4,
                            fetch("/api/klaviyo-subscribe", {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify({
                                    emailAddress: formEmail
                                })
                            })
                        ];
                    case 1:
                        klaviyoResponse = _state.sent();
                        if (klaviyoResponse.status === 200) {
                            setIsSuccessful(true);
                            setFormEmail("");
                            sendSubscribeEvent({
                                email: formEmail,
                                form_id: "footer_email_signup"
                            });
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleNewsletterSignup(event) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-wrap items-center justify-between lg:flex-nowrap",
        children: [
            includeFooterContent && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "email-signup-left",
                className: "mb-4 flex-[0_0_100%] text-xl font-[300] lg:mb-0 lg:flex-[0_0_55%] lg:text-[28px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "text-xl font-[300] lg:text-[28px]",
                        children: heading
                    }),
                    subtext && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[#A6A8AE]",
                        children: subtext
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "email-signup-right",
                className: "".concat(includeFooterContent ? "lg:flex-[0_0_45%]" : "", " flex-[0_0_100%]"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-between border-b border-b-[#DDE2E71A]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                            className: "klaviyo-form-PAPDgq w-full",
                            onSubmit: handleNewsletterSignup,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "email",
                                        value: formEmail,
                                        placeholder: "Email address",
                                        onChange: function(event) {
                                            setFormEmail(event.target.value);
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        type: "submit",
                                        children: [
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                                                className: "w-[24px] text-white",
                                                src: "/svgs/arrow-right.svg#arrow-right",
                                                title: "Submit",
                                                viewBox: "0 0 24 24"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    isSuccessful && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "py-6",
                        children: "Thanks for subscribing! Your submission was received successfully."
                    })
                ]
            })
        ]
    });
}
EmailSignup.displayName = "EmailSignup";

;// CONCATENATED MODULE: ./src/snippets/Footer/FooterLegal.jsx




function FooterLegal() {
    var ref;
    var settings = (0,dist.useSettings)();
    var ref1 = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.footer) === null || ref === void 0 ? void 0 : ref.legal), links = ref1.links, copyrightNotice = ref1.copyrightNotice;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col gap-x-4 gap-y-1 text-2xs xs:flex-row md:p-0 lg:text-sm",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "Copyright \xa9 ",
                    new Date().getFullYear(),
                    " ",
                    copyrightNotice
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "flex flex-wrap gap-x-2 gap-y-1",
                children: links === null || links === void 0 ? void 0 : links.map(function(param, index) {
                    var link = param.link;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "pr-2 ".concat(index === 0 ? "hidden" : "block", " md:block"),
                                children: "|"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                "aria-label": link === null || link === void 0 ? void 0 : link.text,
                                href: link === null || link === void 0 ? void 0 : link.url,
                                newTab: link === null || link === void 0 ? void 0 : link.newTab,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "hover-text-underline text-current",
                                    children: link === null || link === void 0 ? void 0 : link.text
                                })
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
}
FooterLegal.displayName = "FooterLegal";

;// CONCATENATED MODULE: ./src/snippets/Footer/MobileMenuItem.jsx




function MobileMenuItem(param) {
    var item = param.item;
    var ref;
    var ref1 = (0,react.useState)(false), isOpen = ref1[0], setIsOpen = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "border-b border-b-[#DDE2E71A]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                "aria-label": isOpen ? "Close ".concat(item.title, " menu") : "Open ".concat(item.title, " menu"),
                className: "flex h-14 w-full items-center justify-between py-4",
                onClick: function() {
                    return setIsOpen(!isOpen);
                },
                type: "button",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "text-base font-normal",
                        children: item.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                        className: "w-4 text-white ".concat(isOpen ? "rotate-180" : ""),
                        src: "/svgs/chevron-down.svg#chevron-down",
                        title: "Chevron",
                        viewBox: "0 0 24 24"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "flex-col items-start gap-2 pb-9 ".concat(isOpen ? "flex" : "hidden"),
                children: (ref = item.links) === null || ref === void 0 ? void 0 : ref.map(function(param, linkIndex) {
                    var link = param.link;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                            "aria-label": link === null || link === void 0 ? void 0 : link.text,
                            className: "hover-text-underline mb-2 block text-sm font-light text-[#A6A8AE]",
                            href: link === null || link === void 0 ? void 0 : link.url,
                            newTab: link === null || link === void 0 ? void 0 : link.newTab,
                            children: link === null || link === void 0 ? void 0 : link.text
                        })
                    }, linkIndex);
                })
            })
        ]
    });
}
MobileMenuItem.displayName = "MobileMenuItem";

;// CONCATENATED MODULE: ./src/snippets/Footer/FooterMenu.jsx





function FooterMenu() {
    var ref;
    var settings = (0,dist.useSettings)();
    var menuItems = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.footer) === null || ref === void 0 ? void 0 : ref.menu).menuItems;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "grid grid-cols-1 text-current md:hidden md:grid-cols-3 lg:grid-cols-4",
                children: menuItems === null || menuItems === void 0 ? void 0 : menuItems.map(function(item, menuIndex) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileMenuItem, {
                            item: item
                        })
                    }, menuIndex);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "hidden grid-cols-1 gap-x-6 gap-y-8 text-current md:grid md:grid-cols-4",
                children: menuItems === null || menuItems === void 0 ? void 0 : menuItems.map(function(param, menuIndex) {
                    var title = param.title, links = param.links;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "mb-4 text-lg",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "flex flex-col items-start gap-4",
                                children: links === null || links === void 0 ? void 0 : links.map(function(param, linkIndex) {
                                    var link = param.link;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "text-sm",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                            "aria-label": link === null || link === void 0 ? void 0 : link.text,
                                            className: "hover-text-underline text-[#A6A8AE]",
                                            href: link === null || link === void 0 ? void 0 : link.url,
                                            newTab: link === null || link === void 0 ? void 0 : link.newTab,
                                            children: link === null || link === void 0 ? void 0 : link.text
                                        })
                                    }, linkIndex);
                                })
                            })
                        ]
                    }, menuIndex);
                })
            })
        ]
    });
}
FooterMenu.displayName = "FooterMenu";

;// CONCATENATED MODULE: ./src/snippets/Footer/FooterSocial.jsx





function FooterSocial() {
    var ref;
    var settings = (0,dist.useSettings)();
    var links = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.footer) === null || ref === void 0 ? void 0 : ref.social).links;
    return (links === null || links === void 0 ? void 0 : links.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "text-current",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            className: "flex flex-wrap gap-3.5",
            children: links.map(function(param, index) {
                var platform = param.platform, url = param.url;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                        "aria-label": platform,
                        href: url,
                        newTab: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                            className: "w-6 text-current transition md:hover:opacity-80",
                            src: "/svgs/noprecache/social/".concat(platform, ".svg#").concat(platform),
                            title: platform,
                            viewBox: "0 0 24 24"
                        })
                    })
                }, index);
            })
        })
    }) : null;
}
FooterSocial.displayName = "FooterSocial";

;// CONCATENATED MODULE: ./src/snippets/Footer/FooterQuizWidget.jsx





function FooterQuizWidget() {
    var ref;
    var settings = (0,dist.useSettings)();
    var ref1 = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.footer) === null || ref === void 0 ? void 0 : ref.quizWidgetSettings), link = ref1.link, title = ref1.title, bgColor = ref1.bgColor, bgImage = ref1.bgImage;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "footer-quiz-widget",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                backgroundColor: bgColor
            },
            className: "aspect-[340/220] w-full p-[1.5rem]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative flex h-full min-h-[220px] w-full items-center justify-center text-center",
                children: [
                    (bgImage === null || bgImage === void 0 ? void 0 : bgImage.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                        className: "opacity-50 mix-blend-multiply",
                        alt: "Contaminants Quiz Background",
                        fill: true,
                        sizes: "(min-width: 1024px) 40vw, 100vw",
                        src: bgImage.src
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative",
                        children: [
                            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-3 text-[22px] font-[350]",
                                children: title
                            }),
                            link && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                "aria-label": link === null || link === void 0 ? void 0 : link.text,
                                className: "w-full font-[350] underline",
                                href: link === null || link === void 0 ? void 0 : link.url,
                                newTab: link === null || link === void 0 ? void 0 : link.newTab,
                                children: link.text
                            })
                        ]
                    })
                ]
            })
        })
    });
}
FooterQuizWidget.displayName = "FooterQuizWidget";

;// CONCATENATED MODULE: ./src/snippets/Footer/Footer.jsx








function Footer() {
    var settings = (0,dist.useSettings)();
    var ref = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : settings.footer), bgColor = ref.bgColor, textColor = ref.textColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        id: "footer",
        className: "px-contained print:hidden",
        style: {
            backgroundColor: bgColor,
            color: textColor
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "footer-top",
                className: "pb-[40px] pt-[50px] lg:py-[120px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailSignup, {
                    includeFooterContent: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "footer-bottom",
                className: "flex flex-wrap justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "footer-menu",
                        className: "flex-[0_0_100%] lg:flex-[0_0_75%]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterMenu, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "footer-quiz",
                        className: "hidden lg:block lg:flex-[0_0_25%]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterQuizWidget, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "footer-legal",
                className: "font flex flex-wrap justify-between py-[27px] font-light md:mt-[66px] md:border-t md:border-t-[#DDE2E71A]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "lg:order-0 order-1 flex flex-[0_0_100%] lg:flex-[0_0_75%] lg:justify-start",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLegal, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "order-0 mb-6 flex flex-[0_0_100%] lg:order-1 lg:mb-0 lg:flex-[0_0_25%] lg:justify-end",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterSocial, {})
                    })
                ]
            })
        ]
    });
}
Footer.displayName = "Footer";

;// CONCATENATED MODULE: ./src/snippets/Footer/index.js


;// CONCATENATED MODULE: ./src/snippets/Header/Menu.jsx









function Menu(param) {
    var handleOpenSidebar = param.handleOpenSidebar, handleMenuDrawerClose = param.handleMenuDrawerClose, handleMenuHoverIn = param.handleMenuHoverIn, handleMenuHoverOut = param.handleMenuHoverOut, menuDrawerContent = param.menuDrawerContent, transparentMode = param.transparentMode, transparentModeTextColor = param.transparentModeTextColor;
    var ref;
    var ref1 = (0,contexts/* useGlobalContext */.b)(), _actions = ref1.actions, openCart = _actions.openCart, openSearch = _actions.openSearch, openAccount = _actions.openAccount;
    var settings = (0,dist.useSettings)();
    var menuItems = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.header) === null || ref === void 0 ? void 0 : ref.menu).menuItems;
    var logo = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : settings.general).logo;
    var cartCount = (0,hooks/* useCartCount */.iF)();
    var imageColor = {};
    if (transparentMode) {
        if (transparentModeTextColor === "light") {
            imageColor = {
                filter: "brightness(0) invert(1)"
            };
        } else if (transparentModeTextColor === "dark") {
            imageColor = {
                filter: "brightness(0) invert(0)"
            };
        }
    }
    // Only allow the first item to display the Logo before if enabled.
    var usedLogo = false;
    var normalizedMenuItems = menuItems === null || menuItems === void 0 ? void 0 : menuItems.map(function(item) {
        var normalizedItem = (0,_object_spread/* default */.Z)({}, item);
        if ((normalizedItem === null || normalizedItem === void 0 ? void 0 : normalizedItem.logoBefore) && !usedLogo) {
            usedLogo = true;
        } else {
            normalizedItem.logoBefore = false;
        }
        return normalizedItem;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "px-contained relative z-[1] flex h-[60px] items-center justify-between transition md:h-[var(--header-height)]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "order-1 flex flex-[1_1_100%] items-center lg:order-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        className: "order-1 h-full w-full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "flex w-full",
                            children: normalizedMenuItems === null || normalizedMenuItems === void 0 ? void 0 : normalizedMenuItems.map(function(item, index) {
                                var ref, ref1, ref2, ref3, ref4;
                                var isHovered = ((ref = item.menuItem) === null || ref === void 0 ? void 0 : ref.text) === (menuDrawerContent === null || menuDrawerContent === void 0 ? void 0 : (ref1 = menuDrawerContent.menuItem) === null || ref1 === void 0 ? void 0 : ref1.text);
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                    children: [
                                        (item === null || item === void 0 ? void 0 : item.logoBefore) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "flex flex-[1_1_100%] justify-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                                "aria-label": "Go to homepage",
                                                className: "w-[140px] py-1 md:w-[200px]",
                                                href: "/",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                                    style: imageColor,
                                                    priority: true,
                                                    height: "82",
                                                    width: "400",
                                                    className: "h-auto w-full",
                                                    alt: "Clearly Filtered",
                                                    sizes: "(min-width: 1440px) 900px, (min-width: 768px) 50vw, 100vw",
                                                    src: (logo === null || logo === void 0 ? void 0 : logo.src) || "https://cdn.shopify.com/s/files/1/1011/0318/files/Primary_Logo_Horizontal_c3aceaee-7ecc-4fb8-90a6-98df0ee6f7c8.png?v=1690837284",
                                                    quality: "90"
                                                })
                                            })
                                        }) : null,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "hidden lg:flex lg:flex-[1_0_auto]",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                                "aria-label": (ref2 = item.menuItem) === null || ref2 === void 0 ? void 0 : ref2.text,
                                                className: "group relative flex items-center px-4 text-[17px] ".concat(isHovered ? "text-[#66A2D4]" : ""),
                                                href: (ref3 = item.menuItem) === null || ref3 === void 0 ? void 0 : ref3.url,
                                                onClick: handleMenuDrawerClose,
                                                onMouseEnter: function() {
                                                    return handleMenuHoverIn(index);
                                                },
                                                onMouseLeave: handleMenuHoverOut,
                                                children: (ref4 = item.menuItem) === null || ref4 === void 0 ? void 0 : ref4.text
                                            })
                                        })
                                    ]
                                }, index);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "order-0 flex flex-[0_0_50px] items-center gap-4 md:flex-[0_0_150px] lg:flex-auto",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                "aria-label": "Open menu",
                                className: "w-5 lg:hidden",
                                onClick: handleOpenSidebar,
                                type: "button",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                                    className: "w-full",
                                    src: "/svgs/menu.svg#menu",
                                    title: "Menu",
                                    viewBox: "0 0 24 24"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                "aria-label": "Open search",
                                className: "block w-5 md:hidden",
                                onClick: openSearch,
                                type: "button",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                                    className: "w-full",
                                    src: "/svgs/search.svg#search",
                                    title: "Search",
                                    viewBox: "0 0 24 24"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "order-3 flex flex-[0_0_50px] items-center justify-end gap-4 md:flex-[0_0_150px] md:gap-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        "aria-label": "Open search",
                        className: "hidden w-5 md:block",
                        onClick: openSearch,
                        type: "button",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                            className: "w-full",
                            src: "/svgs/search.svg#search",
                            title: "Search",
                            viewBox: "0 0 24 24"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        "aria-label": "Open Account",
                        className: "w-[17px]",
                        onClick: openAccount,
                        type: "button",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                            className: "w-full",
                            src: "/svgs/account.svg#account",
                            title: "Account",
                            viewBox: "0 0 17 17"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative flex items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            "aria-label": "Open cart",
                            className: "relative w-[21px]",
                            onClick: openCart,
                            type: "button",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                                    src: "/svgs/cart.svg#cart",
                                    title: "Cart",
                                    viewBox: "0 0 21 19"
                                }),
                                cartCount > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "absolute right-[-2px] top-[-4px] h-[16px] w-[16px] rounded-full bg-secondary text-xs text-white",
                                    children: cartCount < 99 ? cartCount : ""
                                }) : ""
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
Menu.displayName = "Menu";

;// CONCATENATED MODULE: ./src/snippets/Header/MenuDrawerSubnavCard.jsx
/* eslint-disable jsx-a11y/no-static-element-interactions */ 



function MenuDrawerSubnavCard(param) {
    var cardDetails = param.cardDetails, onClick = param.onClick;
    var ref = (0,_object_spread/* default */.Z)({}, cardDetails), link = ref.link, image = ref.image, title = ref.title, enableGradient = ref.enableGradient;
    return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events
    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        onClick: onClick,
        className: "subnav-card-wrapper w-full max-w-[50%] [&_.hover-line]:hover:bg-[#D9D9D9] [&_.hover-line]:hover:bg-gradient-to-l [&_.hover-line]:hover:from-[#2179C2] [&_.hover-line]:hover:via-[#8DCEF9] [&_.hover-line]:hover:to-[#FECD86] [&_img]:duration-200 [&_img]:hover:scale-110",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "subnav-card ",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* Link */.r, {
                "aria-label": link === null || link === void 0 ? void 0 : link.text,
                href: link === null || link === void 0 ? void 0 : link.url,
                children: [
                    (image === null || image === void 0 ? void 0 : image.src) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative flex items-center justify-center overflow-hidden ".concat(enableGradient ? "p-[20px]" : ""),
                                children: [
                                    enableGradient && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "bg-hover absolute inset-0 bg-[#D9D9D9] bg-gradient-to-r from-[#2179C2] via-[#8DCEF9] to-[#F1DCC1] opacity-20"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "relative aspect-[525/348] w-full max-w-[650px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                            width: 650,
                                            height: 430,
                                            className: "absolute inset-0 m-auto box-border block h-0 max-h-full min-h-full w-0 min-w-full max-w-full border-none object-contain p-0 mix-blend-multiply",
                                            alt: (link === null || link === void 0 ? void 0 : link.text) || title,
                                            src: image === null || image === void 0 ? void 0 : image.src
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hover-line mb-[18px] mt-8 h-[1px] w-full bg-[#E9E9EB]"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: "font-sans text-xl font-[300] text-[#0D141C]",
                        children: title
                    }),
                    (link === null || link === void 0 ? void 0 : link.text) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-[10px] text-[#0D141C] underline",
                        children: link.text
                    }) : null
                ]
            })
        })
    }));
}
MenuDrawerSubnavCard.displayName = "MenuDrawerSubnavCard";

;// CONCATENATED MODULE: ./src/snippets/Header/MenuDrawerSubnavCards.jsx





function MenuDrawerSubnavCards(param) {
    var menuDrawerContent = param.menuDrawerContent, hoveredLink = param.hoveredLink, onClick = param.onClick;
    var ref = (0,react.useState)([]), subnavCards = ref[0], setSubnavCards = ref[1];
    (0,react.useEffect)(function() {
        setSubnavCards([]);
        menuDrawerContent === null || menuDrawerContent === void 0 ? void 0 : menuDrawerContent.links.forEach(function(subnavItem, hoveredLinkIndex) {
            var cards = (0,_object_spread/* default */.Z)({}, subnavItem === null || subnavItem === void 0 ? void 0 : subnavItem.subnavCards);
            Object.keys(cards).forEach(function(key) {
                var subnavCard = (0,_object_spread/* default */.Z)({}, cards[key]);
                subnavCard.hoveredLinkIndex = hoveredLinkIndex;
                setSubnavCards(function(previous) {
                    return (0,_to_consumable_array/* default */.Z)(previous).concat([
                        subnavCard
                    ]);
                });
            });
        });
    }, [
        menuDrawerContent
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "subnav-cards",
        className: "flex gap-[40px]",
        children: subnavCards.map(function(card, index) {
            return hoveredLink === card.hoveredLinkIndex ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuDrawerSubnavCard, {
                onClick: onClick,
                cardDetails: card
            }, "subnav-card-".concat(index)) : null;
        })
    });
}
MenuDrawerSubnavCards.displayName = "MenuDrawerSubnavCards";

;// CONCATENATED MODULE: ./src/snippets/Header/MenuDrawer.jsx






function MenuDrawer(param) {
    var handleMenuDrawerClose = param.handleMenuDrawerClose, handleMenuDrawerStayOpen = param.handleMenuDrawerStayOpen, handleMenuHoverOut = param.handleMenuHoverOut, menuDrawerContent = param.menuDrawerContent;
    var ref = (0,_object_spread/* default */.Z)({}, menuDrawerContent), imageLinks = ref.imageLinks, links = ref.links, iconMenuLinks = ref.iconMenuLinks;
    var hasContent = (imageLinks === null || imageLinks === void 0 ? void 0 : imageLinks.length) > 0 || (links === null || links === void 0 ? void 0 : links.length) > 0 || (iconMenuLinks === null || iconMenuLinks === void 0 ? void 0 : iconMenuLinks.length) > 0;
    var ref1 = (0,react.useState)(0), hoveredLink = ref1[0], setHoveredLink = ref1[1];
    (0,react.useEffect)(function() {
        setHoveredLink(0);
    }, [
        menuDrawerContent
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "absolute left-0 top-[100%] hidden w-full origin-top border-border bg-white text-primary transition duration-200 lg:block ".concat(hasContent ? "scale-y-100 border-b" : "scale-y-0"),
        onMouseEnter: handleMenuDrawerStayOpen,
        onMouseLeave: handleMenuHoverOut,
        children: [
            /* Icon Menu Links */ hasContent && (iconMenuLinks === null || iconMenuLinks === void 0 ? void 0 : iconMenuLinks.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center justify-center border-t border-t-border py-[40px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "flex gap-[75px]",
                    children: iconMenuLinks.map(function(iconMenuItem, iconMenuItemIndex) {
                        var ref, ref1, ref2, ref3, ref4, ref5, ref6;
                        return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            onClick: handleMenuDrawerClose,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* Link */.r, {
                                "aria-label": iconMenuItem === null || iconMenuItem === void 0 ? void 0 : (ref = iconMenuItem.link) === null || ref === void 0 ? void 0 : ref.text,
                                className: "flex w-full flex-col items-center gap-[15px] hover:!text-[#66A2D4] [&:not(:hover)_img]:!filter-none",
                                href: iconMenuItem === null || iconMenuItem === void 0 ? void 0 : (ref1 = iconMenuItem.link) === null || ref1 === void 0 ? void 0 : ref1.url,
                                newTab: iconMenuItem === null || iconMenuItem === void 0 ? void 0 : (ref2 = iconMenuItem.link) === null || ref2 === void 0 ? void 0 : ref2.newTab,
                                children: [
                                    (iconMenuItem === null || iconMenuItem === void 0 ? void 0 : (ref3 = iconMenuItem.icon) === null || ref3 === void 0 ? void 0 : ref3.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "relative aspect-square w-[35px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                            style: {
                                                filter: "invert(54%) sepia(71%) saturate(312%) hue-rotate(165deg) brightness(100%) contrast(83%)"
                                            },
                                            alt: iconMenuItem === null || iconMenuItem === void 0 ? void 0 : (ref4 = iconMenuItem.link) === null || ref4 === void 0 ? void 0 : ref4.text,
                                            fill: true,
                                            sizes: "100vw",
                                            className: "!object-contain",
                                            src: iconMenuItem === null || iconMenuItem === void 0 ? void 0 : (ref5 = iconMenuItem.icon) === null || ref5 === void 0 ? void 0 : ref5.src
                                        })
                                    }),
                                    iconMenuItem === null || iconMenuItem === void 0 ? void 0 : (ref6 = iconMenuItem.link) === null || ref6 === void 0 ? void 0 : ref6.text
                                ]
                            })
                        }, "icon-menu-item-".concat(iconMenuItemIndex)));
                    })
                })
            }),
            /* Standard Submenu Links */ hasContent && (links === null || links === void 0 ? void 0 : links.length) > 0 && ((iconMenuLinks === null || iconMenuLinks === void 0 ? void 0 : iconMenuLinks.length) === 0 || !(iconMenuLinks === null || iconMenuLinks === void 0 ? void 0 : iconMenuLinks.length)) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-contained mx-[auto] flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-[0_1_455px] border-r border-r-[#0000001A] py-14",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "flex flex-col gap-2",
                            children: links === null || links === void 0 ? void 0 : links.map(function(param, index) {
                                var link = param.link;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "[&:not(:first-child)>a]:mt-4",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                        "aria-hidden": !hasContent,
                                        "aria-label": link === null || link === void 0 ? void 0 : link.text,
                                        className: " ".concat(index === hoveredLink ? " text-[#3383c5] underline" : "text-primary", " inline-block font-sans text-[22px] font-[300]"),
                                        href: link === null || link === void 0 ? void 0 : link.url,
                                        newTab: link === null || link === void 0 ? void 0 : link.newTab,
                                        onClick: handleMenuDrawerClose,
                                        onMouseOver: function() {
                                            setHoveredLink(index);
                                        },
                                        tabIndex: hasContent ? "0" : "-1",
                                        children: link === null || link === void 0 ? void 0 : link.text
                                    })
                                }, index);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-[1_1_100%] p-14 pr-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuDrawerSubnavCards, {
                            onClick: handleMenuDrawerClose,
                            hoveredLink: hoveredLink,
                            menuDrawerContent: menuDrawerContent
                        })
                    })
                ]
            })
        ]
    });
}
MenuDrawer.displayName = "MenuDrawer";

;// CONCATENATED MODULE: ./src/snippets/Header/MenuSidebar.jsx









function MenuSidebar(param) {
    var handleCloseSidebar = param.handleCloseSidebar, menuSidebarOpen = param.menuSidebarOpen, promobarDisabled = param.promobarDisabled, promobarHidden = param.promobarHidden;
    var ref;
    var settings = (0,dist.useSettings)();
    var ref1 = (0,contexts/* useGlobalContext */.b)(), openCart = ref1.actions.openCart;
    var customer = (0,dist.useCustomer)();
    var ref2 = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.header) === null || ref === void 0 ? void 0 : ref.menu), additionalLinks = ref2.links, menuItems = ref2.menuItems;
    var logo = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : settings.general).logo;
    var ref3 = (0,react.useState)([]), openSubMenus = ref3[0], setOpenSubMenus = ref3[1];
    var toggleOpenSubNavMenu = function(index) {
        if (openSubMenus.includes(index)) {
            setOpenSubMenus(openSubMenus.filter(function(e) {
                return e !== index;
            }));
        } else {
            setOpenSubMenus((0,_to_consumable_array/* default */.Z)(openSubMenus).concat([
                index
            ]));
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "fixed left-0 top-0 z-[60] h-full w-full lg:hidden ".concat(menuSidebarOpen ? "pointer-events-auto" : "pointer-events-none", " ").concat(promobarDisabled || promobarHidden ? "" : "mt-[var(--promobar-height)]"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                role: "button",
                "aria-hidden": "true",
                "aria-label": "Close menu sidebar",
                tabIndex: "-1",
                className: "absolute left-0 top-0 hidden h-full w-full bg-[rgba(0,0,0,0.3)] transition duration-200 md:block ".concat(menuSidebarOpen ? "opacity-100" : "opacity-0"),
                onClick: handleCloseSidebar
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("aside", {
                className: "absolute right-full top-0 flex h-full w-full flex-col overflow-hidden bg-white transition md:max-w-[var(--sidebar-width)] ".concat(menuSidebarOpen ? "translate-x-full" : "-translate-x-0"),
                children: menuSidebarOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative flex h-[60px] items-center justify-between border-b border-b-border px-[18px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "flex-[0_0_80px]",
                                    "aria-label": "Close menu sidebar",
                                    onClick: handleCloseSidebar,
                                    type: "button",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                                        className: "w-5 text-primary",
                                        src: "/svgs/close.svg#close",
                                        title: "Close",
                                        viewBox: "0 0 24 24"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                    className: "flex flex-[1_1_100%] justify-center",
                                    "aria-label": "Go to homepage",
                                    href: "/",
                                    onClick: handleCloseSidebar,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-[140px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                            priority: true,
                                            height: "30",
                                            width: "140",
                                            className: "h-auto w-full",
                                            alt: "Clearly Filtered",
                                            src: (logo === null || logo === void 0 ? void 0 : logo.src) || "https://cdn.shopify.com/s/files/1/1011/0318/files/Primary_Logo_Horizontal_c3aceaee-7ecc-4fb8-90a6-98df0ee6f7c8.png?v=1690837284",
                                            quality: "90"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-[0_0_80px] justify-end gap-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                            className: "w-[17px] text-primary",
                                            "aria-label": "Go to account page",
                                            onClick: handleCloseSidebar,
                                            href: customer ? "/account/orders" : "/account/login",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                                                className: "w-full",
                                                src: "/svgs/account.svg#account",
                                                title: "Account",
                                                viewBox: "0 0 17 17"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "relative flex items-center justify-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                "aria-label": "Open cart",
                                                className: "w-[21px]",
                                                onClick: openCart,
                                                type: "button",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                                                    className: "w-full text-text",
                                                    src: "/svgs/cart.svg#cart",
                                                    title: "Cart",
                                                    viewBox: "0 0 21 19"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative w-full flex-1 overflow-x-hidden",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "h-full w-full overflow-y-auto scrollbar-hide",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                        className: "mb-8 flex",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            className: "w-full flex-col",
                                            children: menuItems === null || menuItems === void 0 ? void 0 : menuItems.map(function(item, index) {
                                                var ref, ref1;
                                                var hasContent = ((ref = item.links) === null || ref === void 0 ? void 0 : ref.length) > 0 || ((ref1 = item.imageLinks) === null || ref1 === void 0 ? void 0 : ref1.length) > 0;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    className: "flex min-h-[3.5rem] w-full flex-col border-b border-b-border",
                                                    children: hasContent ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                "aria-label": item.menuItem.text,
                                                                className: "flex h-14 w-full items-center justify-between gap-5 p-4",
                                                                onClick: function() {
                                                                    toggleOpenSubNavMenu(index);
                                                                },
                                                                type: "button",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        className: "text-nav flex-1 text-left text-xl font-light text-primary",
                                                                        children: item.menuItem.text
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                                                                        className: "w-5 text-primary transition-transform duration-200 ease-in-out ".concat(openSubMenus.includes(index) ? "rotate-180" : ""),
                                                                        src: "/svgs/chevron-down.svg#chevron-down",
                                                                        title: "Expand Navigation",
                                                                        viewBox: "0 0 24 24"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                className: "mb-4 ".concat(openSubMenus.includes(index) ? "block" : "hidden"),
                                                                children: item.links.map(function(linkItem, linkIndex) {
                                                                    var ref, ref1, ref2, ref3, ref4, ref5;
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* Link */.r, {
                                                                            "aria-label": linkItem === null || linkItem === void 0 ? void 0 : (ref = linkItem.link) === null || ref === void 0 ? void 0 : ref.text,
                                                                            className: "flex w-full items-center px-4 py-2 text-base font-light text-primary",
                                                                            href: linkItem === null || linkItem === void 0 ? void 0 : (ref1 = linkItem.link) === null || ref1 === void 0 ? void 0 : ref1.url,
                                                                            onClick: function() {
                                                                                setOpenSubMenus([]);
                                                                                handleCloseSidebar();
                                                                            },
                                                                            children: [
                                                                                (linkItem === null || linkItem === void 0 ? void 0 : (ref2 = linkItem.image) === null || ref2 === void 0 ? void 0 : ref2.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "relative mr-4 aspect-square h-5 w-5",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                                                                        height: "264",
                                                                                        width: "330",
                                                                                        className: "absolute inset-0 m-auto box-border block h-0 max-h-full min-h-full w-0 min-w-full max-w-full border-none object-contain p-0 mix-blend-multiply",
                                                                                        alt: linkItem === null || linkItem === void 0 ? void 0 : (ref3 = linkItem.link) === null || ref3 === void 0 ? void 0 : ref3.text,
                                                                                        sizes: "50px",
                                                                                        src: linkItem === null || linkItem === void 0 ? void 0 : (ref4 = linkItem.image) === null || ref4 === void 0 ? void 0 : ref4.src,
                                                                                        quality: "90"
                                                                                    })
                                                                                }),
                                                                                linkItem === null || linkItem === void 0 ? void 0 : (ref5 = linkItem.link) === null || ref5 === void 0 ? void 0 : ref5.text
                                                                            ]
                                                                        })
                                                                    }, "".concat(linkIndex, "-subnavlink"));
                                                                })
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                                        "aria-label": item.menuItem.text,
                                                        className: "text-nav flex h-14 w-full items-center p-4 text-xl font-light text-primary",
                                                        href: item.menuItem.url,
                                                        onClick: handleCloseSidebar,
                                                        children: item.menuItem.text
                                                    })
                                                }, index);
                                            })
                                        })
                                    }),
                                    (additionalLinks === null || additionalLinks === void 0 ? void 0 : additionalLinks.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "flex flex-col gap-[0.25rem] px-5 pb-16",
                                        children: additionalLinks.map(function(param, index) {
                                            var link = param.link, icon = param.icon;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                className: "flex gap-[13px]",
                                                children: [
                                                    (icon === null || icon === void 0 ? void 0 : icon.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "relative aspect-square w-[14px]",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                                            fill: true,
                                                            alt: link === null || link === void 0 ? void 0 : link.text,
                                                            className: "!object-contain",
                                                            src: icon === null || icon === void 0 ? void 0 : icon.src
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                                        className: "font-[300] text-text",
                                                        "aria-label": link === null || link === void 0 ? void 0 : link.text,
                                                        href: link === null || link === void 0 ? void 0 : link.url,
                                                        onClick: handleCloseSidebar,
                                                        children: link === null || link === void 0 ? void 0 : link.text
                                                    })
                                                ]
                                            }, index);
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
}
MenuSidebar.displayName = "MenuSidebar";

// EXTERNAL MODULE: ../node_modules/swiper/swiper-react.mjs + 3 modules
var swiper_react = __webpack_require__(5509);
// EXTERNAL MODULE: ../node_modules/swiper/modules/index.mjs + 28 modules
var modules = __webpack_require__(3365);
;// CONCATENATED MODULE: ./src/snippets/Header/Promobar.jsx









function Promobar(param) {
    var promobarDisabled = param.promobarDisabled, promobarHidden = param.promobarHidden, setPromobarHidden = param.setPromobarHidden;
    var settings = (0,dist.useSettings)();
    var promobar = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : settings.header).promobar;
    var ref = (0,_object_spread/* default */.Z)({}, promobar), autohide = ref.autohide, delay = ref.delay, enabled = ref.enabled, messages = ref.messages, speed = ref.speed;
    var ref1 = (0,react.useState)(false), promoBarCloseClick = ref1[0], setPromoBarCloseClick = ref1[1];
    var swiperParams = {
        autoplay: {
            delay: delay || 5000,
            disableOnInteraction: false
        },
        effect: "fade",
        fadeEffect: {
            crossFade: true
        },
        loop: (messages === null || messages === void 0 ? void 0 : messages.length) > 1,
        modules: [
            modules/* A11y */.s5,
            modules/* Autoplay */.pt,
            modules/* EffectFade */.xW,
            modules/* Navigation */.W_
        ],
        speed: speed || 500,
        style: {
            "--swiper-navigation-color": "#FFFFFF",
            "--swiper-navigation-size": "12px"
        }
    };
    var closePromoBar = function() {
        setPromoBarCloseClick(true);
        setPromobarHidden(true);
    };
    (0,react.useEffect)(function() {
        var setPromobarVisibility = function() {
            if (document.body.style.position === "fixed") return;
            setPromobarHidden(window.scrollY > 48);
        };
        if (!autohide) {
            setPromobarHidden(false);
            window.removeEventListener("scroll", setPromobarVisibility);
            return undefined;
        }
        window.addEventListener("scroll", setPromobarVisibility);
        return function() {
            window.removeEventListener("scroll", setPromobarVisibility);
        };
    }, [
        autohide
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative overflow-hidden bg-[#CCE0F1] transition-[height] ease-out print:hidden ".concat(promoBarCloseClick || promobarHidden || promobarDisabled ? "h-0 duration-[50ms]" : "h-[var(--promobar-height)] duration-300"),
        children: enabled && (messages === null || messages === void 0 ? void 0 : messages.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, swiperParams), {
                    className: "swiper-wrapper-center relative flex h-full items-center",
                    children: messages.map(function(param, index) {
                        var message = param.message, link = param.link;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            className: "px-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "px-contained flex min-h-full items-center justify-center text-center text-xs tracking-[0.04em] text-black sm:text-sm",
                                children: (link === null || link === void 0 ? void 0 : link.url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                    className: "select-none",
                                    draggable: false,
                                    href: link.url,
                                    newTab: link.newTab,
                                    children: message
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: message
                                })
                            })
                        }, index);
                    })
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "button",
                    "aria-label": "Close promo bar",
                    className: "absolute right-2 top-1/2 z-10 -translate-y-1/2 cursor-pointer p-1 md:right-6 xl:right-10",
                    onClick: function() {
                        return closePromoBar();
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                        className: "w-3 text-text",
                        src: "/svgs/close.svg#close",
                        title: "Close",
                        viewBox: "0 0 24 24"
                    })
                })
            ]
        }) : null
    });
}
Promobar.displayName = "Promobar";

;// CONCATENATED MODULE: ./src/snippets/Header/useMenuDrawer.js



function useMenuDrawer() {
    var ref;
    var settings = (0,dist.useSettings)();
    var menuItems = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.header) === null || ref === void 0 ? void 0 : ref.menu).menuItems;
    var ref1 = (0,react.useState)(null), menuDrawerIndex = ref1[0], setMenuDrawerIndex = ref1[1];
    var clearUnHoverTimer = (0,react.useCallback)(function() {
        if (window.unHover) {
            clearTimeout(window.unHover);
            window.unHover = null;
        }
    }, []);
    var handleMenuDrawerClose = (0,react.useCallback)(function() {
        setMenuDrawerIndex(null);
    }, []);
    var handleMenuDrawerStayOpen = (0,react.useCallback)(function() {
        clearUnHoverTimer();
        setMenuDrawerIndex(menuDrawerIndex);
    }, [
        menuDrawerIndex
    ]);
    var handleMenuHoverIn = (0,react.useCallback)(function(index) {
        clearUnHoverTimer();
        setMenuDrawerIndex(typeof index === "number" ? index : null);
    }, []);
    var handleMenuHoverOut = (0,react.useCallback)(function() {
        clearUnHoverTimer();
        window.unHover = setTimeout(function() {
            setMenuDrawerIndex(null);
            clearUnHoverTimer();
        }, 100);
    }, []);
    return {
        state: {
            menuDrawerContent: typeof menuDrawerIndex === "number" ? (menuItems === null || menuItems === void 0 ? void 0 : menuItems[menuDrawerIndex]) || null : null,
            menuDrawerIndex: menuDrawerIndex
        },
        actions: {
            handleMenuDrawerClose: handleMenuDrawerClose,
            handleMenuDrawerStayOpen: handleMenuDrawerStayOpen,
            handleMenuHoverIn: handleMenuHoverIn,
            handleMenuHoverOut: handleMenuHoverOut
        }
    };
}

;// CONCATENATED MODULE: ./src/snippets/Header/useMenuSidebar.jsx


function useMenuSidebar() {
    var ref = (0,hooks/* useBodyScrollLock */.yn)(), lockBodyScroll = ref.lockBodyScroll, unlockBodyScroll = ref.unlockBodyScroll;
    var ref1 = (0,react.useState)(false), menuSidebarOpen = ref1[0], setMenuSidebarOpen = ref1[1];
    var handleOpenSidebar = (0,react.useCallback)(function() {
        setMenuSidebarOpen(true);
        // delaying lock until content is ready
        requestAnimationFrame(function() {
            lockBodyScroll();
        });
    }, []);
    var handleCloseSidebar = (0,react.useCallback)(function() {
        setMenuSidebarOpen(false);
        unlockBodyScroll();
    }, []);
    return {
        state: {
            menuSidebarOpen: menuSidebarOpen
        },
        actions: {
            handleOpenSidebar: handleOpenSidebar,
            handleCloseSidebar: handleCloseSidebar
        }
    };
}

;// CONCATENATED MODULE: ./src/snippets/Header/Header.jsx











function Header(param) {
    var promobarDisabled = param.promobarDisabled, transparentMode = param.transparentMode, transparentModeTextColor = param.transparentModeTextColor, promobarHidden = param.promobarHidden, setPromoBarHidden = param.setPromoBarHidden, scrolledPast = param.scrolledPast, page = param.page;
    var ref, ref1, ref2, ref3;
    var ref4 = useMenuDrawer(), menuDrawerContent = ref4.state.menuDrawerContent, _actions = ref4.actions, handleMenuDrawerClose = _actions.handleMenuDrawerClose, handleMenuDrawerStayOpen = _actions.handleMenuDrawerStayOpen, handleMenuHoverIn = _actions.handleMenuHoverIn, handleMenuHoverOut = _actions.handleMenuHoverOut;
    var ref5 = useMenuSidebar(), menuSidebarOpen = ref5.state.menuSidebarOpen, _actions1 = ref5.actions, handleCloseSidebar = _actions1.handleCloseSidebar, handleOpenSidebar = _actions1.handleOpenSidebar;
    var ref6 = (0,contexts/* useGlobalContext */.b)(), _state = ref6.state, accountOpen = _state.accountOpen, cartOpen = _state.cartOpen, searchOpen = _state.searchOpen;
    // Only enable transparent mode when content is present for the Drawer
    var transparentModeEnabled = searchOpen || accountOpen || cartOpen || (menuDrawerContent === null || menuDrawerContent === void 0 ? void 0 : (ref = menuDrawerContent.imageLinks) === null || ref === void 0 ? void 0 : ref.length) > 0 || (menuDrawerContent === null || menuDrawerContent === void 0 ? void 0 : (ref1 = menuDrawerContent.links) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 || (menuDrawerContent === null || menuDrawerContent === void 0 ? void 0 : (ref2 = menuDrawerContent.iconMenuLinks) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 ? false : transparentMode;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        className: "fixed left-0 right-0 top-0 z-30 flex flex-col border-b border-b-border transition-[height] transition-opacity duration-300 ease-out print:hidden ".concat(promobarHidden || promobarDisabled ? "h-[60px] md:h-[var(--header-height)]" : "h-[calc(60px+var(--promobar-height))] md:h-[calc(var(--header-height)+var(--promobar-height))]", "\n      ").concat(transparentModeEnabled ? "!border-b-0 bg-transparent" : "bg-white", "\n      ").concat(transparentModeEnabled && transparentModeTextColor === "light" ? "text-white" : "text-primary", "\n      ").concat(accountOpen ? "z-[9999]" : "z-30", "\n      ").concat((page === null || page === void 0 ? void 0 : (ref3 = page.template) === null || ref3 === void 0 ? void 0 : ref3.type) === "product" && scrolledPast ? "pointer-events-none opacity-0" : "pointer-events-auto opacity-100", "\n      "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Promobar, {
                promobarDisabled: promobarDisabled,
                promobarHidden: promobarHidden,
                setPromobarHidden: setPromoBarHidden
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu, {
                transparentMode: transparentModeEnabled,
                transparentModeTextColor: transparentModeTextColor,
                handleOpenSidebar: handleOpenSidebar,
                handleMenuDrawerClose: handleMenuDrawerClose,
                handleMenuHoverIn: handleMenuHoverIn,
                handleMenuHoverOut: handleMenuHoverOut,
                menuDrawerContent: menuDrawerContent
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuDrawer, {
                handleMenuDrawerClose: handleMenuDrawerClose,
                handleMenuDrawerStayOpen: handleMenuDrawerStayOpen,
                handleMenuHoverOut: handleMenuHoverOut,
                menuDrawerContent: menuDrawerContent
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuSidebar, {
                promobarHidden: promobarHidden,
                promobarDisabled: promobarDisabled,
                handleCloseSidebar: handleCloseSidebar,
                menuSidebarOpen: menuSidebarOpen
            })
        ]
    });
}
Header.displayName = "Header";

;// CONCATENATED MODULE: ./src/snippets/Header/index.js


;// CONCATENATED MODULE: ./src/snippets/Modal/Modal.jsx






function Modal() {
    var ref = (0,contexts/* useGlobalContext */.b)(), modal = ref.state.modal, closeModal = ref.actions.closeModal;
    var _ref = (0,_object_spread/* default */.Z)({}, modal.props), className = _ref.className, props = (0,_object_without_properties/* default */.Z)(_ref, [
        "className"
    ]);
    return modal.children ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "global-site-modal fixed top-1/2 left-1/2 z-50 max-h-[calc(var(--viewport-height)-2rem)]  max-w-[1200px] -translate-x-1/2 -translate-y-1/2 overflow-hidden rounded-[10px] bg-white bg-gradient-to-r from-[#F1DCC126] to-[#2179C24A] max-md:max-w-full ".concat(className)
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                "aria-label": "Close modal",
                className: "absolute right-6 top-6 z-10 flex h-7 w-7 items-center justify-center",
                onClick: closeModal,
                type: "button",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                    className: "w-5 text-text",
                    src: "/svgs/close.svg#close",
                    title: "Close",
                    viewBox: "0 0 24 24"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "px-contained py-contained max-h-[calc(var(--viewport-height)-2rem)] overflow-y-auto scrollbar-hide",
                children: modal.children
            })
        ]
    })) : null;
}
Modal.displayName = "Modal";

;// CONCATENATED MODULE: ./src/snippets/Modal/index.js


;// CONCATENATED MODULE: ./src/snippets/Overlay/Overlay.jsx




function Overlay() {
    var ref = (0,contexts/* useGlobalContext */.b)(), overlayOpen = ref.state.overlayOpen, closeOverlay = ref.actions.closeOverlay;
    var ref1 = (0,hooks/* useBodyScrollLock */.yn)(), lockBodyScroll = ref1.lockBodyScroll, unlockBodyScroll = ref1.unlockBodyScroll;
    (0,react.useEffect)(function() {
        if (overlayOpen) {
            lockBodyScroll();
        } else {
            unlockBodyScroll();
        }
    }, [
        overlayOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        role: "button",
        "aria-hidden": "true",
        "aria-label": "Close menu sidebar",
        tabIndex: "-1",
        className: "fixed top-0 left-0 z-40 h-full w-full cursor-pointer bg-[rgba(0,0,0,0.3)] transition duration-200 ".concat(overlayOpen ? "pointer-events-auto opacity-100" : "pointer-events-none opacity-0"),
        onClick: closeOverlay
    });
}
Overlay.displayName = "Overlay";

;// CONCATENATED MODULE: ./src/snippets/Overlay/index.js


;// CONCATENATED MODULE: ./src/snippets/Pandectes/GpcBanner.jsx



function GpcBanner(param) {
    var text = param.text, backgroundColor = param.backgroundColor, _gpcBannerGpcEnabled = param.gpcBannerGpcEnabled, gpcBannerGpcEnabled = _gpcBannerGpcEnabled === void 0 ? false : _gpcBannerGpcEnabled, _gpcBannerDntEnabled = param.gpcBannerDntEnabled, gpcBannerDntEnabled = _gpcBannerDntEnabled === void 0 ? false : _gpcBannerDntEnabled;
    var ref = (0,react.useState)(false), show = ref[0], setShow = ref[1];
    (0,react.useEffect)(function() {
        var dismissed =  true && sessionStorage.getItem("gpcBannerDismissed") === "1";
        var gpc = typeof navigator !== "undefined" && navigator.globalPrivacyControl;
        var dnt = typeof navigator !== "undefined" && navigator.doNotTrack === "1";
        if (!dismissed) {
            var shouldShow = gpcBannerGpcEnabled && gpc || gpcBannerDntEnabled && dnt;
            setShow(shouldShow);
        }
    }, [
        gpcBannerGpcEnabled,
        gpcBannerDntEnabled
    ]);
    if (!show) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        role: "alert",
        className: "fixed inset-x-0 bottom-0 z-50 flex items-center justify-between px-4 py-3 text-sm",
        style: {
            backgroundColor: backgroundColor || "#CCE0F1"
        },
        "aria-describedby": "gpc-banner-message",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                "aria-label": "Close banner",
                onClick: function() {
                    setShow(false);
                    if (true) {
                        sessionStorage.setItem("gpcBannerDismissed", "1");
                    }
                },
                className: "ml-auto flex items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                    src: "/svgs/close.svg#close",
                    viewBox: "0 0 24 24",
                    className: "h-3 w-3",
                    "aria-hidden": "true"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                id: "gpc-banner-message",
                className: "mr-4 flex w-full justify-center",
                children: text
            })
        ]
    });
}
GpcBanner.displayName = "GpcBanner";

;// CONCATENATED MODULE: ./src/snippets/Pandectes/Pandectes.jsx



function Pandectes() {
    var settings = (0,dist.useSettings)();
    var globalPandectesSettings = (settings === null || settings === void 0 ? void 0 : settings.pandectes) || {};
    var _gpcBannerEnabled = globalPandectesSettings.gpcBannerEnabled, gpcBannerEnabled = _gpcBannerEnabled === void 0 ? false : _gpcBannerEnabled, _gpcBannerGpcEnabled = globalPandectesSettings.gpcBannerGpcEnabled, gpcBannerGpcEnabled = _gpcBannerGpcEnabled === void 0 ? false : _gpcBannerGpcEnabled, _gpcBannerDntEnabled = globalPandectesSettings.gpcBannerDntEnabled, gpcBannerDntEnabled = _gpcBannerDntEnabled === void 0 ? false : _gpcBannerDntEnabled, _gpcBannerText = globalPandectesSettings.gpcBannerText, gpcBannerText = _gpcBannerText === void 0 ? "We respect your Global Privacy Control (GPC) signal and automatically opt you out of non-essential cookies and data sharing." : _gpcBannerText, _gpcBannerColor = globalPandectesSettings.gpcBannerColor, gpcBannerColor = _gpcBannerColor === void 0 ? "#CCE0F1" : _gpcBannerColor;
    if (!gpcBannerEnabled) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("pandectes", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GpcBanner, {
            text: gpcBannerText,
            backgroundColor: gpcBannerColor,
            gpcBannerDntEnabled: gpcBannerDntEnabled,
            gpcBannerGpcEnabled: gpcBannerGpcEnabled
        })
    });
}
Pandectes.displayName = "Pandectes";

;// CONCATENATED MODULE: ./src/snippets/Pandectes/index.js


;// CONCATENATED MODULE: ./src/snippets/PlayButton/PlayButton.jsx

function PlayButton(props) {
    var className = props.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative h-11 w-11 overflow-hidden rounded-full border border-[#C1EFFA] lg:h-20 lg:w-20 ".concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute left-1/2 top-1/2 h-11 w-11 -translate-x-1/2 -translate-y-1/2 transform bg-[#ffffffb3] blur lg:h-20 lg:w-20"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    className: "h-[13px] w-[13px] lg:h-[22px] lg:w-[18px]",
                    viewBox: "0 0 18 22",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M18 11L9.2855e-07 21.3923L1.83707e-06 0.607695L18 11Z",
                        fill: "#3383C5"
                    })
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/snippets/PlayButton/index.js


;// CONCATENATED MODULE: ./src/snippets/ReviewStars/ReviewStars.jsx





function ReviewStars(param) {
    var _color = param.color, color = _color === void 0 ? "var(--text)" : _color, _rating = param.rating, rating = _rating === void 0 ? 0 : _rating, _size = param.size, size = _size === void 0 ? "large" : _size;
    var ref;
    var stars = (0,react.useMemo)(function() {
        var fullStar = {
            key: "star-full",
            label: "Full Star"
        };
        var emptyStar = {
            key: "star-empty",
            label: "Empty Star"
        };
        return (0,_to_consumable_array/* default */.Z)(Array(5).keys()).map(function(index) {
            var diff = rating - index;
            if (diff < 1 && diff > 0) {
                return {
                    key: "half-star",
                    label: "Half Star",
                    percent: Math.round(diff * 100)
                };
            }
            return diff >= 1 ? fullStar : emptyStar;
        });
    }, [
        rating
    ]);
    var classBySize = {
        small: {
            gap: "gap-0.5",
            width: "w-3"
        },
        large: {
            gap: "gap-1",
            width: "w-4"
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: "flex items-center ".concat((ref = classBySize[size]) === null || ref === void 0 ? void 0 : ref.gap),
        children: stars.map(function(param, index) {
            var key = param.key, label = param.label, percent = param.percent;
            var ref, ref1, ref2;
            return percent ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                        className: "absolute left-0 top-0 z-10 ".concat((ref = classBySize[size]) === null || ref === void 0 ? void 0 : ref.width),
                        src: "/svgs/star-empty.svg#star-empty",
                        style: {
                            color: color
                        },
                        title: label,
                        viewBox: "0 0 24 24"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                        className: "relative z-20 ".concat((ref1 = classBySize[size]) === null || ref1 === void 0 ? void 0 : ref1.width),
                        src: "/svgs/star-full.svg#star-full",
                        style: {
                            color: color,
                            clipPath: percent ? "inset(0 ".concat(100 - percent, "% 0 0)") : "unset"
                        },
                        title: label,
                        viewBox: "0 0 24 24"
                    })
                ]
            }, index) : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                    className: "".concat((ref2 = classBySize[size]) === null || ref2 === void 0 ? void 0 : ref2.width),
                    src: "/svgs/".concat(key, ".svg#").concat(key),
                    style: {
                        color: color
                    },
                    title: label,
                    viewBox: "0 0 24 24"
                })
            }, index);
        })
    });
}
ReviewStars.displayName = "ReviewStars";
ReviewStars.propTypes = {
    color: (prop_types_default()).string,
    rating: (prop_types_default()).number,
    size: prop_types_default().oneOf([
        "small",
        "large"
    ])
};

;// CONCATENATED MODULE: ./src/snippets/ReviewStars/index.js


;// CONCATENATED MODULE: ./src/snippets/ProductStars/ProductStars.jsx






function ProductStars(param) {
    var legacyResourceId = param.legacyResourceId;
    var ref = (0,react.useState)(null), reviewAggregate = ref[0], setReviewAggregate = ref[1];
    var fetchReviewAggregate = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(productId) {
            var endpoint, options, response, data, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        if (!productId) return [
                            2
                        ];
                        endpoint = "/api/reviews";
                        options = {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                action: "getProductReviewAggregate",
                                productId: productId
                            })
                        };
                        return [
                            4,
                            fetch(endpoint, options)
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            4,
                            response.json()
                        ];
                    case 2:
                        data = _state.sent();
                        if (!data) {
                            throw new Error("No data returned from fetchReviewAggregate");
                        }
                        setReviewAggregate(data);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.error("fetchReviewAggregate error: ".concat(error.message));
                        throw error;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(productId) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    (0,react.useEffect)(function() {
        // // api is for reference purposes only
        // fetchReviewAggregate(legacyResourceId);
        // mock data in lieu of fetchReviewAggregate data
        setReviewAggregate({
            rating: 4.7,
            count: 105
        });
    }, [
        legacyResourceId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex min-h-[1rem] flex-wrap items-center gap-1",
        children: reviewAggregate && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewStars, {
                    color: "var(--secondary)",
                    rating: reviewAggregate.rating,
                    size: "small"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "ml-1 text-sm font-light text-primary",
                    children: [
                        reviewAggregate.count,
                        " Reviews"
                    ]
                })
            ]
        })
    });
}
ProductStars.displayName = "ProductStars";
ProductStars.propTypes = {
    legacyResourceId: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./src/snippets/ProductStars/index.js


// EXTERNAL MODULE: ../node_modules/next/head.js
var head = __webpack_require__(8038);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/snippets/SchemaMarkup/ArticleSchemaMarkup.jsx
/* provided dependency */ var process = __webpack_require__(4284);


function ArticleSchemaMarkup(param) {
    var _article = param.article, article = _article === void 0 ? {} : _article, pageUrl = param.pageUrl;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
            type: "application/ld+json",
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: {
                __html: JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "BlogPosting",
                    "@id": pageUrl,
                    mainEntityOfPage: pageUrl,
                    headline: ((ref = article.seo) === null || ref === void 0 ? void 0 : ref.title) || "",
                    name: ((ref1 = article.seo) === null || ref1 === void 0 ? void 0 : ref1.title) || "",
                    description: ((ref2 = article.seo) === null || ref2 === void 0 ? void 0 : ref2.description) || "",
                    datePublished: ((ref3 = article.article) === null || ref3 === void 0 ? void 0 : ref3.publishedAt) || "",
                    dateModified: ((ref4 = article.article) === null || ref4 === void 0 ? void 0 : ref4.createdAt) || "",
                    author: [
                        {
                            "@type": "Person",
                            name: ((ref5 = article.article) === null || ref5 === void 0 ? void 0 : ref5.author) || ""
                        }, 
                    ],
                    publisher: {
                        "@type": "Organization",
                        "@id": "https://clearlyfiltered.com",
                        name: "Clearly Filtered" || 0,
                        logo: {
                            "@type": "ImageObject",
                            "@id": process.env.NEXT_PUBLIC_SITE_LOGO || "",
                            url: process.env.NEXT_PUBLIC_SITE_LOGO || ""
                        }
                    },
                    image: {
                        "@type": "ImageObject",
                        "@id": ((ref6 = article.seo) === null || ref6 === void 0 ? void 0 : ref6.image) || "",
                        url: ((ref7 = article.seo) === null || ref7 === void 0 ? void 0 : ref7.image) || ""
                    },
                    url: pageUrl,
                    isPartOf: {
                        "@type": "Blog",
                        "@id": "".concat("https://clearlyfiltered.com", "/blogs/").concat((ref8 = article.blogs) === null || ref8 === void 0 ? void 0 : (ref9 = ref8[0]) === null || ref9 === void 0 ? void 0 : ref9.handle),
                        name: (ref10 = article.blogs) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[0]) === null || ref11 === void 0 ? void 0 : ref11.title,
                        publisher: {
                            "@type": "Organization",
                            "@id": "https://clearlyfiltered.com",
                            name: "Clearly Filtered" || 0
                        }
                    }
                })
            }
        })
    });
}
ArticleSchemaMarkup.displayName = "ArticleSchemaMarkup";

;// CONCATENATED MODULE: ./src/snippets/SchemaMarkup/BlogSchemaMarkup.jsx
/* provided dependency */ var BlogSchemaMarkup_process = __webpack_require__(4284);


function BlogSchemaMarkup(param) {
    var _blog = param.blog, blog = _blog === void 0 ? {} : _blog, pageUrl = param.pageUrl;
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
            type: "application/ld+json",
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: {
                __html: JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "Blog",
                    "@id": pageUrl,
                    mainEntityOfPage: pageUrl,
                    name: ((ref = blog.seo) === null || ref === void 0 ? void 0 : ref.title) || "",
                    description: ((ref1 = blog.seo) === null || ref1 === void 0 ? void 0 : ref1.description) || "",
                    publisher: {
                        "@type": "Organization",
                        "@id": "https://clearlyfiltered.com",
                        name: "Clearly Filtered" || 0,
                        logo: {
                            "@type": "ImageObject",
                            "@id": BlogSchemaMarkup_process.env.NEXT_PUBLIC_SITE_LOGO || "",
                            url: BlogSchemaMarkup_process.env.NEXT_PUBLIC_SITE_LOGO || ""
                        }
                    }
                })
            }
        })
    });
}
BlogSchemaMarkup.displayName = "BlogSchemaMarkup";

;// CONCATENATED MODULE: ./src/snippets/SchemaMarkup/CollectionSchemaMarkup.jsx


function CollectionSchemaMarkup(param) {
    var _collection = param.collection, collection = _collection === void 0 ? {} : _collection, pageUrl = param.pageUrl;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
            type: "application/ld+json",
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: {
                __html: JSON.stringify({
                    "@context": "https://schema.org/",
                    "@type": "BreadcrumbList",
                    itemListElement: [
                        {
                            "@type": "ListItem",
                            position: 1,
                            name: "Clearly Filtered" || 0,
                            item: "https://clearlyfiltered.com" || 0
                        },
                        {
                            "@type": "ListItem",
                            position: 2,
                            name: collection.title || "",
                            item: pageUrl
                        }, 
                    ]
                })
            }
        })
    });
}
CollectionSchemaMarkup.displayName = "CollectionSchemaMarkup";

;// CONCATENATED MODULE: ./src/snippets/SchemaMarkup/MainSchemaMarkup.jsx
/* provided dependency */ var MainSchemaMarkup_process = __webpack_require__(4284);


function MainSchemaMarkup(param) {
    var pageUrl = param.pageUrl;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
            type: "application/ld+json",
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: {
                __html: JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "Organization",
                    name: "Clearly Filtered" || 0,
                    url: pageUrl,
                    logo: MainSchemaMarkup_process.env.NEXT_PUBLIC_SITE_LOGO || ""
                })
            }
        })
    });
}
MainSchemaMarkup.displayName = "MainSchemaMarkup";

;// CONCATENATED MODULE: ./src/snippets/SchemaMarkup/ProductSchemaMarkup.jsx


function ProductSchemaMarkup(param) {
    var pageUrl = param.pageUrl, _product = param.product, product = _product === void 0 ? {} : _product;
    var ref, ref1, ref2, ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify({
                        "@context": "https://schema.org/",
                        "@type": "BreadcrumbList",
                        itemListElement: [
                            {
                                "@type": "ListItem",
                                position: 1,
                                name: "Clearly Filtered" || 0,
                                item: "https://clearlyfiltered.com" || 0
                            },
                            {
                                "@type": "ListItem",
                                position: 2,
                                name: product.title || "",
                                item: pageUrl
                            }, 
                        ]
                    })
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify({
                        "@context": "https://schema.org/",
                        "@type": "Product",
                        name: product.title || "",
                        image: (ref = product.images) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.src,
                        description: product.description,
                        brand: {
                            "@type": "Brand",
                            name: "Clearly Filtered" || 0
                        },
                        offers: {
                            "@type": "Offer",
                            url: pageUrl,
                            priceCurrency: "USD",
                            price: ((ref2 = product.priceRange) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.minVariantPrice) === null || ref3 === void 0 ? void 0 : ref3.amount) || "",
                            availability: "https://schema.org/InStock",
                            itemCondition: "https://schema.org/NewCondition"
                        }
                    })
                }
            })
        ]
    });
}
ProductSchemaMarkup.displayName = "ProductSchemaMarkup";

;// CONCATENATED MODULE: ./src/snippets/SchemaMarkup/SchemaMarkup.jsx






function SchemaMarkup(props) {
    var baseUrl = "https://clearlyfiltered.com";
    var article = props.article, blog = props.blog, collection = props.collection, page = props.page, product = props.product;
    var resourceType = page === null || page === void 0 ? void 0 : page.resourceType;
    var pageUrl = "";
    if ((page === null || page === void 0 ? void 0 : page.resourceType) === "home_page") {
        pageUrl = baseUrl;
    } else if ((page === null || page === void 0 ? void 0 : page.resourceType) === "page") {
        pageUrl = "".concat(baseUrl, "/pages/").concat(page.handle);
    } else if ((page === null || page === void 0 ? void 0 : page.resourceType) === "product_page") {
        pageUrl = "".concat(baseUrl, "/products/").concat(page.handle);
    } else if ((page === null || page === void 0 ? void 0 : page.resourceType) === "collection_page") {
        pageUrl = "".concat(baseUrl, "/collections/").concat(page.handle);
    } else if (article) {
        pageUrl = "".concat(baseUrl, "/articles/").concat(article.handle);
        resourceType = "article";
    } else if (blog) {
        pageUrl = "".concat(baseUrl, "/blogs/").concat(blog.handle);
        resourceType = "blog";
    } else {
        pageUrl = baseUrl;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainSchemaMarkup, {
                pageUrl: pageUrl
            }),
            resourceType === "article" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleSchemaMarkup, {
                article: article,
                pageUrl: pageUrl
            }),
            resourceType === "blog" && /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogSchemaMarkup, {
                blog: blog,
                pageUrl: pageUrl
            }),
            resourceType === "collection_page" && /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionSchemaMarkup, {
                collection: collection,
                pageUrl: pageUrl
            }),
            resourceType === "product_page" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSchemaMarkup, {
                product: product,
                pageUrl: pageUrl
            })
        ]
    });
}
SchemaMarkup.displayName = "SchemaMarkup";

;// CONCATENATED MODULE: ./src/snippets/SchemaMarkup/index.js


;// CONCATENATED MODULE: ./src/snippets/Scripts/Scripts.jsx


function Scripts() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "gtm-script",
                type: "text/javascript",
                dangerouslySetInnerHTML: {
                    __html: "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n          })(window,document,'script','dataLayer', '".concat("GTM-MMMZDKQ", "');")
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                src: "https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=JXsSet",
                strategy: "beforeInteractive"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                src: "https://autopilot.kodif.io/chat/v1/application/d2da211f-5fac-4f31-af1b-4893119bfccb/widget-script",
                strategy: "beforeInteractive"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/snippets/Scripts/index.js


;// CONCATENATED MODULE: ./src/snippets/Search/SearchHeader.jsx


function SearchHeader(param) {
    var closeSearch = param.closeSearch;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative flex flex-end flex-row-reverse h-14 items-center justify-between px-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                "aria-label": "Close Search",
                className: "",
                onClick: closeSearch,
                type: "button",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                    className: "w-5 text-text",
                    src: "/svgs/close.svg#close",
                    title: "Close",
                    viewBox: "0 0 24 24"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-base uppercase tracking-[.02em] text-primaryLight",
                children: "Search"
            })
        ]
    });
}
SearchHeader.displayName = "SearchHeader";

;// CONCATENATED MODULE: ./src/snippets/Search/SearchAutocomplete.jsx




function SearchAutocomplete(param) {
    var searchOpen = param.searchOpen, setRawTerm = param.setRawTerm, term = param.term;
    var ref;
    var settings = (0,dist.useSettings)();
    var autocompleteResults = (0,hooks/* useSearchAutocomplete */.ch)({
        term: term,
        mounted: searchOpen
    }).autocompleteResults;
    var ref1 = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.search) === null || ref === void 0 ? void 0 : ref.autocomplete), enabled = ref1.enabled, heading = ref1.heading, limit = ref1.limit;
    return enabled && autocompleteResults.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mt-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "text-xs italic text-primaryLight",
                children: heading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "flex flex-wrap gap-x-2",
                children: autocompleteResults.slice(0, limit || 5).map(function(param) {
                    var item = param.item, refIndex = param.refIndex;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            "aria-label": item.suggestion,
                            onClick: function() {
                                return setRawTerm(item.suggestion);
                            },
                            type: "button",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-underline text-xs",
                                children: item.suggestion
                            })
                        })
                    }, refIndex);
                })
            })
        ]
    }) : null;
}
SearchAutocomplete.displayName = "SearchAutocomplete";

;// CONCATENATED MODULE: ./src/snippets/Search/SearchInput.jsx





function SearchInput(param) {
    var closeSearch = param.closeSearch, rawTerm = param.rawTerm, searchOpen = param.searchOpen, setRawTerm = param.setRawTerm;
    var inputRef = (0,react.useRef)(null);
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        if (!searchOpen) return;
        inputRef.current.focus();
    }, [
        searchOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "px-8 py-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative flex justify-between gap-3 rounded-full border border-border pl-3 pr-4 bg-white",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                        className: "w-5 text-text",
                        src: "/svgs/search.svg#search",
                        title: "Search",
                        viewBox: "0 0 24 24"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        "aria-label": "Search here",
                        className: "min-w-0 flex-1 py-3 text-base outline-none",
                        onChange: function(e) {
                            return setRawTerm(e.target.value);
                        },
                        onKeyDown: function(e) {
                            if (e.key === "Enter" && !!e.target.value) {
                                closeSearch();
                                router.push({
                                    pathname: "/pages/search",
                                    query: {
                                        term: e.target.value
                                    }
                                });
                            }
                        },
                        placeholder: "Search here",
                        ref: inputRef,
                        value: rawTerm
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        "aria-label": "Clear search",
                        className: "".concat(rawTerm ? "" : "invisible"),
                        onClick: function() {
                            return setRawTerm("");
                        },
                        type: "button",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                            className: "w-4 text-text",
                            src: "/svgs/close.svg#close",
                            title: "Close",
                            viewBox: "0 0 24 24"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchAutocomplete, {
                searchOpen: searchOpen,
                setRawTerm: setRawTerm,
                term: rawTerm
            })
        ]
    });
}
SearchInput.displayName = "SearchInput";

;// CONCATENATED MODULE: ./src/snippets/Search/SearchItem.jsx







function SearchItem(param) {
    var closeSearch = param.closeSearch, index = param.index, item = param.item, searchTerm = param.searchTerm;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var productItem = (0,dist.useProductItemByHandle)({
        handle: item.handle
    }).productItem;
    var ref6 = (0,hooks/* useVariantPrices */.be)({
        variant: productItem === null || productItem === void 0 ? void 0 : (ref = productItem.variants) === null || ref === void 0 ? void 0 : ref[0]
    }), price = ref6.price, compareAtPrice = ref6.compareAtPrice;
    var localized = (0,dist.useLocalizedVariant)({
        variant: productItem === null || productItem === void 0 ? void 0 : (ref1 = productItem.variants) === null || ref1 === void 0 ? void 0 : ref1[0]
    }).localized;
    var sendClickProductItemEvent = (0,hooks/* useDataLayerActions */.KZ)().sendClickProductItemEvent;
    var url = "/products/".concat(item.handle);
    var color = productItem === null || productItem === void 0 ? void 0 : (ref2 = productItem.variants) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.selectedOptionsMap) === null || ref4 === void 0 ? void 0 : ref4.Color;
    var image = productItem === null || productItem === void 0 ? void 0 : (ref5 = productItem.images) === null || ref5 === void 0 ? void 0 : ref5[0];
    var handleClick = (0,react.useCallback)(function() {
        var ref;
        sendClickProductItemEvent({
            isSearchResult: true,
            listIndex: index,
            localized: localized,
            product: productItem,
            searchTerm: searchTerm,
            selectedVariant: productItem === null || productItem === void 0 ? void 0 : (ref = productItem.variants) === null || ref === void 0 ? void 0 : ref[0]
        });
        closeSearch();
    }, [
        index,
        localized,
        productItem === null || productItem === void 0 ? void 0 : productItem.id,
        searchTerm
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* Link */.r, {
        "aria-label": "View ".concat(productItem === null || productItem === void 0 ? void 0 : productItem.title),
        className: "relative grid grid-cols-[5.5rem_1fr] items-start gap-3",
        href: url,
        onClick: handleClick,
        children: [
            (image === null || image === void 0 ? void 0 : image.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                alt: productItem === null || productItem === void 0 ? void 0 : productItem.title,
                className: "bg-offWhite",
                height: Math.floor(88 / (image.width / image.height)),
                src: image.src,
                width: "88"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "justify-fle flex flex-col gap-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "okendo-widget-container text-primary [&_.oke-sr-count]:font-light [&_.oke-sr-count_span]:!text-[12px] [&_svg]:h-[13px] ",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OkendoStarRating/* OkendoStarRating */.m, {
                                    className: "!text-[0px] [&_.oke-sr]:inline [&_[data-oke-container]>div]:text-[20px] [&_span]:font-light",
                                    productId: productItem === null || productItem === void 0 ? void 0 : productItem.legacyResourceId
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                className: "text-base font-light text-primary",
                                children: productItem === null || productItem === void 0 ? void 0 : productItem.title
                            }),
                            color && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-sm text-shadowGray",
                                children: color
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-wrap gap-x-1.5",
                        children: [
                            compareAtPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-sm text-mediumGray line-through",
                                children: compareAtPrice
                            }),
                            price && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "text-sm text-primary",
                                children: [
                                    "From ",
                                    price
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
SearchItem.displayName = "SearchItem";

;// CONCATENATED MODULE: ./src/snippets/Search/SearchResults.jsx









function SearchResults(param) {
    var closeSearch = param.closeSearch, collectionResults = param.collectionResults, productResults = param.productResults, rawTerm = param.rawTerm, searchTerm = param.searchTerm;
    var ref;
    var settings = (0,dist.useSettings)();
    var router = (0,next_router.useRouter)();
    // products for data layer event
    var products = (0,dist.useProductsFromHandles)({
        handles: productResults === null || productResults === void 0 ? void 0 : productResults.slice(0, 10).map(function(param) {
            var item = param.item;
            return item.handle;
        })
    }).products;
    var sendViewSearchResultsEvent = (0,hooks/* useDataLayerActions */.KZ)().sendViewSearchResultsEvent;
    var ref1 = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.search) === null || ref === void 0 ? void 0 : ref.results), productsEnabled = ref1.productsEnabled, collectionsEnabled = ref1.collectionsEnabled;
    var handleViewAll = function(pathName, term) {
        closeSearch();
        router.push("".concat(pathName, "?term=").concat(term));
    };
    (0,react.useEffect)(function() {
        sendViewSearchResultsEvent({
            products: productResults === null || productResults === void 0 ? void 0 : productResults.slice(0, 4),
            isSearchPage: false,
            searchTerm: searchTerm
        });
    }, [
        productResults,
        sendViewSearchResultsEvent
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative flex flex-1 flex-col gap-4 overflow-y-auto pt-4 scrollbar-hide",
        children: [
            productsEnabled && (products === null || products === void 0 ? void 0 : products.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mx-8 flex items-center justify-between border-b border-b-border pb-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                className: "text-sm font-light text-primaryLight ",
                                children: [
                                    productResults === null || productResults === void 0 ? void 0 : productResults.length,
                                    ' Product Results for "',
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "italic text-primary",
                                        children: rawTerm
                                    }),
                                    '"'
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                "aria-label": "View All",
                                className: "block flex-[0_0_80px] cursor-pointer items-center text-sm font-normal no-underline",
                                onClick: function() {
                                    return handleViewAll("/pages/search", rawTerm);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "flex",
                                    children: [
                                        "View All",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                                            className: "ml-[12px] w-[14px] text-black",
                                            src: "/svgs/arrow-right-long.svg#arrow-right-long",
                                            title: "Arrow Right",
                                            viewBox: "0 0 14 14"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        children: productResults === null || productResults === void 0 ? void 0 : productResults.slice(0, 4).map(function(param, index) {
                            var item = param.item;
                            return item ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: "mx-8 border-b border-b-border py-4 last:border-none",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchItem, {
                                    closeSearch: closeSearch,
                                    index: index,
                                    item: item,
                                    searchTerm: searchTerm
                                })
                            }, index) : null;
                        })
                    })
                ]
            }),
            collectionsEnabled && (collectionResults === null || collectionResults === void 0 ? void 0 : collectionResults.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-8 px-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mb-4 flex items-center justify-between border-b border-b-border pb-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                className: "text-sm font-light text-primaryLight",
                                children: [
                                    collectionResults === null || collectionResults === void 0 ? void 0 : collectionResults.length,
                                    ' Collection Results for "',
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "italic text-primary",
                                        children: rawTerm
                                    }),
                                    '"'
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                "aria-label": "View All",
                                className: "block w-[80px] items-center text-sm font-normal no-underline",
                                href: {
                                    pathname: "/pages/search",
                                    query: {
                                        term: rawTerm
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "inline-block",
                                    children: "View All"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "flex flex-col items-start gap-3",
                        children: collectionResults.map(function(param) {
                            var item = param.item, refIndex = param.refIndex;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                    "aria-label": "View All",
                                    href: "/collections/".concat(item.handle),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "",
                                        children: item.title
                                    })
                                })
                            }, refIndex);
                        })
                    })
                ]
            })
        ]
    });
}
SearchResults.displayName = "SearchResults";

;// CONCATENATED MODULE: ./src/snippets/Search/SearchSuggestions.jsx



function SearchSuggestions(param) {
    var setRawTerm = param.setRawTerm, term = param.term;
    var ref, ref1;
    var settings = (0,dist.useSettings)();
    var noResultsText = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref = settings.search) === null || ref === void 0 ? void 0 : ref.results).noResultsText;
    var ref2 = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : (ref1 = settings.search) === null || ref1 === void 0 ? void 0 : ref1.suggestions), enabled = ref2.enabled, heading = ref2.heading, terms = ref2.terms;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "scrollbar-hide flex flex-1 flex-col gap-8 overflow-y-auto p-8",
        children: [
            term && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "text-base font-normal",
                children: noResultsText
            }),
            enabled && (terms === null || terms === void 0 ? void 0 : terms.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-xs mb-3 text-primaryLight italic",
                        children: heading
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "flex flex-col items-start gap-3",
                        children: terms.map(function(suggestion) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    "aria-label": suggestion,
                                    onClick: function() {
                                        return setRawTerm(suggestion);
                                    },
                                    type: "button",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "hover-text-underline",
                                        children: suggestion
                                    })
                                })
                            }, suggestion);
                        })
                    })
                ]
            })
        ]
    });
}
SearchSuggestions.displayName = "SearchSuggestions";

;// CONCATENATED MODULE: ./src/snippets/Search/Search.jsx









function Search() {
    var ref = (0,contexts/* useGlobalContext */.b)(), searchOpen = ref.state.searchOpen, closeSearch = ref.actions.closeSearch;
    var ref1 = (0,react.useState)(""), rawTerm = ref1[0], setRawTerm = ref1[1];
    var ref2 = (0,react.useState)(rawTerm), term = ref2[0], setTerm = ref2[1];
    var productResults = (0,hooks/* useSearchProductResults */.DV)({
        term: term,
        mounted: searchOpen
    }).productResults;
    var collectionResults = (0,hooks/* useSearchCollectionResults */.Mx)({
        term: term,
        mounted: searchOpen
    }).collectionResults;
    var pageResults = (0,hooks/* useSearchPageResults */.v9)({
        term: term,
        mounted: searchOpen
    }).pageResults;
    var articleResults = (0,hooks/* useSearchArticleResults */.rH)({
        term: term,
        mounted: searchOpen
    }).articleResults;
    var hasProductResults = (productResults === null || productResults === void 0 ? void 0 : productResults.length) > 0;
    var hasCollectionResults = (collectionResults === null || collectionResults === void 0 ? void 0 : collectionResults.length) > 0;
    var hasPageResults = (pageResults === null || pageResults === void 0 ? void 0 : pageResults.length) > 0;
    var hasArticleResults = (articleResults === null || articleResults === void 0 ? void 0 : articleResults.length) > 0;
    var hasResults = hasProductResults || hasCollectionResults || hasPageResults || hasArticleResults;
    (0,react.useEffect)(function() {
        // debounce raw term
        var handler = window.requestTimeout(function() {
            setTerm(rawTerm);
        }, 300);
        return function() {
            window.clearRequestTimeout(handler);
        };
    }, [
        rawTerm
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("aside", {
        className: "fixed left-full top-0 z-[70] flex h-full w-full flex-col justify-between overflow-hidden bg-background bg-clearBlue pt-8 transition md:max-w-[23.5rem] ".concat(searchOpen ? "pointer-events-auto -translate-x-full" : "pointer-events-none translate-x-0"),
        children: searchOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchHeader, {
                    closeSearch: closeSearch
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInput, {
                    closeSearch: closeSearch,
                    rawTerm: rawTerm,
                    searchOpen: searchOpen,
                    setRawTerm: setRawTerm
                }),
                hasResults ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResults, {
                    closeSearch: closeSearch,
                    collectionResults: collectionResults,
                    productResults: productResults,
                    pageResults: pageResults,
                    articleResults: articleResults,
                    rawTerm: rawTerm,
                    searchTerm: term
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchSuggestions, {
                    term: term,
                    setRawTerm: setRawTerm
                })
            ]
        })
    });
}
Search.displayName = "Search";

;// CONCATENATED MODULE: ./src/snippets/Search/index.js


;// CONCATENATED MODULE: ./src/snippets/StorefrontHead/StorefrontHead.jsx




var tripleWhaleHeadlessSnippet = '\n/* >> TriplePixel :: start*/\nwindow.TriplePixelData={TripleName:"clearly-filtered.myshopify.com",ver:"2.17",plat:"SHOPIFY",isHeadless:true},function(W,H,A,L,E,_,B,N){function O(U,T,P,H,R){void 0===R&&(R=!1),H=new XMLHttpRequest,P?(H.open("POST",U,!0),H.setRequestHeader("Content-Type","text/plain")):H.open("GET",U,!0),H.send(JSON.stringify(P||{})),H.onreadystatechange=function(){4===H.readyState&&200===H.status?(R=H.responseText,U.includes("/first")?eval(R):P||(N[B]=R)):(299<H.status||H.status<200)&&T&&!R&&(R=!0,O(U,T-1,P))}}if(N=window,!N[H+"sn"]){N[H+"sn"]=1,L=function(){return Date.now().toString(36)+"_"+Math.random().toString(36)};try{A.setItem(H,1+(0|A.getItem(H)||0)),(E=JSON.parse(A.getItem(H+"U")||"[]")).push({u:location.href,r:document.referrer,t:Date.now(),id:L()}),A.setItem(H+"U",JSON.stringify(E))}catch(e){}var i,m,p;A.getItem(\'"!nC`\')||(_=A,A=N,A[H]||(E=A[H]=function(t,e,a){return void 0===a&&(a=[]),"State"==t?E.s:(W=L(),(E._q=E._q||[]).push([W,t,e].concat(a)),W)},E.s="Installed",E._q=[],E.ch=W,B="configSecurityConfModel",N[B]=1,O("https://conf.config-security.com/model",5),i=L(),m=A[atob("c2NyZWVu")],_.setItem("di_pmt_wt",i),p={id:i,action:"profile",avatar:_.getItem("auth-security_rand_salt_"),time:m[atob("d2lkdGg=")]+":"+m[atob("aGVpZ2h0")],host:A.TriplePixelData.TripleName,plat:A.TriplePixelData.plat,url:window.location.href.slice(0,500),ref:document.referrer,ver:A.TriplePixelData.ver},O("https://api.config-security.com/event",5,p),O("https://api.config-security.com/first?host=clearly-filtered.myshopify.com&plat=SHOPIFY",5)))}}("","TriplePixel",localStorage);\n/* << TriplePixel :: end*/\n';
function StorefrontHead() {
    var settings = (0,dist.useSettings)();
    var favicon = (0,_object_spread/* default */.Z)({}, settings === null || settings === void 0 ? void 0 : settings.general).favicon;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "preconnect dns-prefetch",
                href: "https://api.config-security.com/",
                crossOrigin: "anonymous"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "preconnect dns-prefetch",
                href: "https://conf.config-security.com/",
                crossOrigin: "anonymous"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                async: true,
                src: "https://st.pandect.es/clearly-filtered/pandectes-rules.js"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                src: "https://s.pandect.es/custom/clearly-filtered.js"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                defer: true,
                src: "https://cdn.shopify.com/shopifycloud/consent-tracking-api/v0.1/consent-tracking-api.js"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                defer: true,
                src: "https://s.pandect.es/scripts/pandectes-core.js"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "preconnect",
                href: "https://fonts.googleapis.com"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "preconnect",
                href: "https://fonts.gstatic.com",
                crossOrigin: "true"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "shortcut icon",
                href: (favicon === null || favicon === void 0 ? void 0 : favicon.src) || "/icons/favicon.svg"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:site_name",
                content: "Clearly Filtered"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "theme-color",
                content: "#000000"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "manifest",
                href: "/manifest.json"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "192x192",
                href: "/icons/icon-384x384.png"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "application-name",
                content: "Clearly Filtered"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "apple-mobile-web-app-capable",
                content: "yes"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "apple-mobile-web-app-status-bar-style",
                content: "default"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "apple-mobile-web-app-title",
                content: "Clearly Filtered"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "format-detection",
                content: "telephone=no"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "mobile-web-app-capable",
                content: "yes"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "msapplication-TileColor",
                content: "#000000"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "msapplication-tap-highlight",
                content: "no"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "text/javascript",
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: tripleWhaleHeadlessSnippet
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "text/javascript",
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: '\n              !function(){var o=window.tdl=window.tdl||[];if(o.invoked)window.console&&console.error&&console.error("Tune snippet has been included more than once.");else{o.invoked=!0,o.methods=["init","identify","convert"],o.factory=function(n){return function(){var e=Array.prototype.slice.call(arguments);return e.unshift(n),o.push(e),o}};for(var e=0;e<o.methods.length;e++){var n=o.methods[e];o[n]=o.factory(n)}o.init=function(e){var n=document.createElement("script");n.type="text/javascript",n.async=!0,n.src="https://js.go2sdk.com/v2/tune.js";var t=document.getElementsByTagName("script")[0];t.parentNode.insertBefore(n,t),o.domain=e}}}();\n              tdl.init("https://aspireiq.go2cloud.org")\n              tdl.identify()\n            '
                }
            })
        ]
    });
}
StorefrontHead.displayName = "StorefrontHead";

;// CONCATENATED MODULE: ./src/snippets/StorefrontHead/index.js


;// CONCATENATED MODULE: ./src/snippets/Superfiliate/Superfiliate.jsx




/*
 * Superfiliate's tracking script, so affiliate visits landing on our own pages
 * (instead of their cobranded landing pages) are attributed a conversion even
 * when no discount code is used at checkout.
 * @see https://help.superfiliate.com/articles/2185449010-using-superfiliate-with-headless-storefront
 */ // the sdk is keyed to the .myshopify.com domain
var shop = "clearly-filtered.myshopify.com";
// the sdk loads async, so poll for it before registering the page view
var SDK_POLL_INTERVAL = 250;
var SDK_POLL_ATTEMPTS = 40; // give up after 10s
function Superfiliate() {
    var asPath = (0,next_router.useRouter)().asPath;
    // register a page view on first load and on every client side navigation
    (0,react.useEffect)(function() {
        if (!shop) return undefined;
        var attempts = 0;
        var intervalId = setInterval(function() {
            var ref;
            attempts += 1;
            var sdk = (ref = window.$superfiliateStorefront) === null || ref === void 0 ? void 0 : ref.sdk;
            if (sdk === null || sdk === void 0 ? void 0 : sdk.handlePageView) {
                clearInterval(intervalId);
                sdk.handlePageView();
            } else if (attempts >= SDK_POLL_ATTEMPTS) {
                clearInterval(intervalId);
            }
        }, SDK_POLL_INTERVAL);
        return function() {
            return clearInterval(intervalId);
        };
    }, [
        asPath
    ]);
    if (!shop) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
        id: "superfiliate-script",
        type: "text/javascript",
        src: "https://superfiliate-cdn.com/storefront.js?shop=".concat(shop),
        strategy: "afterInteractive"
    });
}

;// CONCATENATED MODULE: ./src/snippets/Superfiliate/index.js


;// CONCATENATED MODULE: ./src/snippets/TestVariant/TestVariant.jsx


function TestVariant() {
    var ref = (0,contexts/* useGlobalContext */.b)(), setTestVariant = ref.actions.setTestVariant;
    (0,react.useEffect)(function() {
        if (false) {}
        var ref;
        // Get test variant from local storage
        var localStorageRecord = (ref = localStorage.getItem("bear:testVariant")) !== null && ref !== void 0 ? ref : "{}";
        var testVariantObj = JSON.parse(localStorageRecord);
        setTestVariant(testVariantObj);
        // Expose function to set test variant
        window.setTestVariant = function(testName, variantName) {
            if (!testName || !variantName) {
                console.error("Test name and variant name are required");
                return;
            }
            if (typeof testName !== "string" || typeof variantName !== "string") {
                console.error("Test name and variant name must be strings");
                return;
            }
            testVariantObj[testName] = variantName;
            // Set in local storage
            localStorage.setItem("bear:testVariant", JSON.stringify(testVariantObj));
            setTestVariant(testVariantObj);
        };
    }, []);
}

;// CONCATENATED MODULE: ./src/snippets/TestVariant/index.js


;// CONCATENATED MODULE: ./src/snippets/ThreeTilesRow/ThreeTilesTile.jsx






function ThreeTilesTile(param) {
    var aspectRatio = param.aspectRatio, item = param.item, textColor = param.textColor;
    var ref, ref1, ref2, ref3, ref4, ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full",
        style: {
            color: textColor
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative mb-4 bg-offWhite ".concat(aspectRatio),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                    "aria-label": item.heading,
                    href: (ref = item.link) === null || ref === void 0 ? void 0 : ref.url,
                    newTab: (ref1 = item.link) === null || ref1 === void 0 ? void 0 : ref1.newTab,
                    tabIndex: "-1",
                    children: ((ref2 = item.image) === null || ref2 === void 0 ? void 0 : ref2.src) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                        alt: item.alt,
                        className: "".concat(item.position),
                        fill: true,
                        sizes: "(min-width: 1440px) 1200px, (min-width: 768px) 50vw, 100vw",
                        src: item.image.src
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "inset-0 flex h-full w-full flex-col items-start gap-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                        "aria-label": item.heading,
                        href: (ref3 = item.link) === null || ref3 === void 0 ? void 0 : ref3.url,
                        newTab: (ref4 = item.link) === null || ref4 === void 0 ? void 0 : ref4.newTab,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "group flex",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "text-xl lg:text-2xl",
                                    children: item.heading
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "ml-[0.75rem] block w-[1.25rem] transition-transform lg:group-hover:translate-x-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* Svg */.n, {
                                        src: "/svgs/arrow-right.svg#arrow-right",
                                        title: "Arrow",
                                        viewBox: "0 0 24 24"
                                    })
                                })
                            ]
                        })
                    }),
                    item.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: item.description
                    }),
                    ((ref5 = item.link) === null || ref5 === void 0 ? void 0 : ref5.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                            "aria-label": item.link.text,
                            className: "text-label text-main-underline",
                            href: item.link.url,
                            newTab: item.link.newTab,
                            tabIndex: "-1",
                            children: item.link.text
                        })
                    })
                ]
            })
        ]
    });
}
ThreeTilesTile.displayName = "ThreeTilesTile";
ThreeTilesTile.propTypes = {
    aspectRatio: (prop_types_default()).string,
    item: (prop_types_default()).object,
    textColor: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./src/snippets/ThreeTilesRow/ThreeTilesRow.jsx





function ThreeTilesRow(param) {
    var aspectRatio = param.aspectRatio, maxWidthClass = param.maxWidthClass, textColor = param.textColor, tiles = param.tiles;
    var ref = (0,react.useState)(null), swiper = ref[0], setSwiper = ref[1];
    return (tiles === null || tiles === void 0 ? void 0 : tiles.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mx-auto ".concat(maxWidthClass),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative lg:hidden ".concat(!swiper ? "min-h-[25rem]" : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                        grabCursor: true,
                        onSwiper: setSwiper,
                        slidesOffsetAfter: 16,
                        slidesOffsetBefore: 16,
                        slidesPerView: 1.4,
                        spaceBetween: 16,
                        breakpoints: {
                            768: {
                                slidesPerView: 2.4,
                                slidesOffsetBefore: 32,
                                slidesOffsetAfter: 32,
                                spaceBetween: 20
                            }
                        },
                        children: swiper && tiles.slice(0, 3).map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                className: "w-full",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThreeTilesTile, {
                                    aspectRatio: aspectRatio,
                                    item: item,
                                    textColor: textColor
                                })
                            }, index);
                        })
                    }),
                    !swiper && /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {
                        width: "32",
                        className: "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hidden grid-cols-3 gap-x-5 lg:grid",
                children: tiles.slice(0, 3).map(function(item, blockIndex) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThreeTilesTile, {
                            aspectRatio: aspectRatio,
                            item: item,
                            textColor: textColor
                        })
                    }, blockIndex);
                })
            })
        ]
    }) : null;
}
ThreeTilesRow.displayName = "ThreeTilesRow";

;// CONCATENATED MODULE: ./src/snippets/ThreeTilesRow/index.js


;// CONCATENATED MODULE: ./src/snippets/Upsellit/Upsellit.jsx


function Upsellit() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
        id: "upsellit-script",
        type: "text/javascript",
        dangerouslySetInnerHTML: {
            __html: "usi_installed = 0; USI_installCode = function() { if (usi_installed == 0) { usi_installed = 1; var USI_headID = document.getElementsByTagName(\"head\")[0]; var USI_installID = document.createElement('script'); USI_installID.type = 'text/javascript'; USI_installID.src = 'https://www.upsellit.com/active/clearlyfiltered.jsp'; USI_headID.appendChild(USI_installID); } }; if (typeof(document.readyState) != \"undefined\" && document.readyState === \"complete\") { USI_installCode(); } else if (window.addEventListener){ window.addEventListener('load', USI_installCode, true); } else if (window.attachEvent) { window.attachEvent('onload', USI_installCode); } else { USI_installCode(); } setTimeout(\"USI_installCode()\", 10000);"
        }
    });
}

;// CONCATENATED MODULE: ./src/snippets/Upsellit/index.js


;// CONCATENATED MODULE: ./src/snippets/VisuallyIo/VisuallyIo.jsx





function getPageType(resourceType) {
    var pageType = "other";
    if (resourceType === "home_page") {
        return "home";
    }
    if (resourceType === "product_page") {
        return "product";
    }
    if (resourceType === "collection_page") {
        return "collection";
    }
    return pageType;
}
function maybe(f) {
    var def = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : undefined;
    try {
        return f();
    } catch (e) {
        return def;
    }
}
function transformCart(cart) {
    return cart ? {
        item_count: maybe(function() {
            return cart.lines.reduce(function(p, c) {
                return p + c.quantity;
            }, 0);
        }),
        attributes: (cart === null || cart === void 0 ? void 0 : cart.attributes) || [],
        items: cart.lines.map(function(l) {
            return {
                handle: l.variant.product.handle,
                price: maybe(function() {
                    return parseInt(l.variant.priceV2.amount, 10);
                }),
                product_id: maybe(function() {
                    return parseInt(l.variant.product.id.replace("gid://shopify/Product/", ""), 10);
                }),
                quantity: l.quantity,
                variant_id: maybe(function() {
                    return parseInt(l.variant.id.replace("gid://shopify/ProductVariant/", ""), 10);
                })
            };
        }),
        currency: maybe(function() {
            return parseInt(cart.estimatedCost.totalAmount.currencyCode, 10);
        }, 0),
        total_price: maybe(function() {
            return parseInt(cart.estimatedCost.totalAmount.amount, 10) * 100;
        }, 0),
        token: maybe(function() {
            return cart.id.replace("gid://shopify/Cart/", "");
        }, "")
    } : undefined;
}
function useVisuallyIo(param) {
    var product = param.product, resourceType = param.resourceType;
    var currency = (0,dist.useCurrency)();
    var cart = (0,dist.useCart)();
    var cartClear = (0,dist.useCartClear)().cartClear;
    var cartAddItem = (0,dist.useCartAddItem)().cartAddItem;
    var cartAddAttributes = (0,dist.useCartAddAttributes)().cartAddAttributes;
    var pageType = getPageType(resourceType);
    var ref = (0,contexts/* useGlobalContext */.b)(), openCart = ref.actions.openCart;
    (0,react.useEffect)(function() {
        maybe(function() {
            return window.visually.onCartChanged(transformCart(cart));
        });
    }, [
        cart
    ]);
    (0,react.useEffect)(function() {
        maybe(function() {
            return window.visually.visuallyConnect({
                cartClear: cartClear,
                initialProductId: maybe(function() {
                    return product.id.replace("gid://shopify/Product/", "");
                }),
                initialVariantPrice: maybe(function() {
                    return parseInt(product.variants[0].priceV2.amount, 10);
                }),
                initialVariantId: maybe(function() {
                    return product.variants[0].replace("gid://shopify/ProductVariant/", "");
                }),
                addToCart: function(variantId, quantity) {
                    return cartAddItem({
                        merchandiseId: "gid://shopify/ProductVariant/".concat(variantId),
                        quantity: quantity
                    });
                },
                cartAddAttributes: cartAddAttributes,
                openCartDrawer: openCart,
                pageType: pageType,
                initialCurrency: currency,
                initialLocale: "en-US"
            });
        });
    }, [
        pageType,
        currency,
        product
    ]);
}
function VisuallyIo(param) {
    var page = param.page, product = param.product;
    useVisuallyIo({
        product: product,
        resourceType: page === null || page === void 0 ? void 0 : page.resourceType
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                strategy: "beforeInteractive",
                rel: "preconnect prefetch",
                src: "https://sdk.loomi-prod.xyz/widgets/vsly-preact.min.js?k=js.10110318&e=2&s=CLEARLY_FILTERED"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                strategy: "beforeInteractive",
                rel: "preconnect prefetch",
                src: "https://sdk.loomi-prod.xyz/v/visually-spa.js"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                strategy: "afterInteractive",
                src: "https://sdk.loomi-prod.xyz/v/visually-a-spa.js"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
        ]
    });
}

;// CONCATENATED MODULE: ./src/snippets/VisuallyIo/index.js


;// CONCATENATED MODULE: ./src/snippets/index.js










































/***/ }),

/***/ 5979:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var handleize = function(string) {
    string.toLowerCase().replace(/ /g, "-");
    return "toc-".concat(string.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/-$/, "").replace(/^-/, ""));
};
/* harmony default export */ __webpack_exports__["Z"] = (handleize);


/***/ }),

/***/ 714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H4": function() { return /* reexport */ fetchProductsFromHandles; },
  "FA": function() { return /* reexport */ getDiscountRedirectUrl; },
  "YU": function() { return /* reexport */ trackTripleWhaleAddToCart; },
  "p1": function() { return /* reexport */ trackTripleWhaleContact; }
});

// UNUSED EXPORTS: fetchProductFromHandle, getShopifyRedirect, getTripleWhaleShop

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(3842);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(5556);
;// CONCATENATED MODULE: ./src/utils/product.js


var fetchProductFromHandle = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(handle) {
        var endpoint, response, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    if (!handle) return [
                        2,
                        null
                    ];
                    endpoint = "/json/products/".concat(handle, ".json");
                    return [
                        4,
                        fetch(endpoint)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    error = _state.sent();
                    console.error(error.message);
                    return [
                        2,
                        null
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchProductFromHandle(handle) {
        return _ref.apply(this, arguments);
    };
}();
var fetchProductsFromHandles = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(handles) {
        var productPromises;
        return (0,tslib_es6.__generator)(this, function(_state) {
            try {
                if (!Array.isArray(handles) || !(handles === null || handles === void 0 ? void 0 : handles.length)) return [
                    2,
                    []
                ];
                productPromises = handles.map(fetchProductFromHandle);
                return [
                    2,
                    Promise.all(productPromises)
                ];
            } catch (error) {
                console.error(error.message);
                return [
                    2,
                    []
                ];
            }
            return [
                2
            ];
        });
    });
    return function fetchProductsFromHandles(handles) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/utils/queryStorefrontApi.js
var queryStorefrontApi = __webpack_require__(5244);
;// CONCATENATED MODULE: ./src/utils/shopifyRedirects.js



/*
 * Mirrors Shopify's url redirects onto the headless domain.
 *
 * Superfiliate registers every affiliate's vanity link as a Shopify redirect
 * (/CODE -> their landing page or /discount/CODE link), but Shopify only serves
 * those on the "Online Store" domain, so clearlyfiltered.com/CODE would 404
 * here. Looking the path up per request instead of at build time keeps up with
 * affiliates joining without needing a redeploy.
 * @see https://help.superfiliate.com/articles/2185449010-using-superfiliate-with-headless-storefront
 */ var URL_REDIRECTS_QUERY = "\n  query UrlRedirects($query: String!) {\n    urlRedirects(first: 10, query: $query) {\n      nodes {\n        path\n        target\n      }\n    }\n  }\n";
var getShopifyRedirect = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(path) {
        var ref, body, nodes, redirect;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!path) return [
                        2,
                        null
                    ];
                    return [
                        4,
                        (0,queryStorefrontApi/* queryStorefrontApi */.h)(URL_REDIRECTS_QUERY, {
                            query: "path:".concat(JSON.stringify(path))
                        })
                    ];
                case 1:
                    body = _state.sent().body;
                    nodes = body === null || body === void 0 ? void 0 : (ref = body.urlRedirects) === null || ref === void 0 ? void 0 : ref.nodes;
                    if (!(nodes === null || nodes === void 0 ? void 0 : nodes.length)) return [
                        2,
                        null
                    ];
                    redirect = nodes.find(function(node) {
                        return node.path === path;
                    }) || nodes.find(function(node) {
                        return node.path.toLowerCase() === path.toLowerCase();
                    });
                    return [
                        2,
                        (redirect === null || redirect === void 0 ? void 0 : redirect.target) || null
                    ];
            }
        });
    });
    return function getShopifyRedirect(path) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/utils/superfiliate.js
/*
 * Builds the url a /discount/CODE hit should land on.
 *
 * Superfiliate (like Shopify) builds affiliate links as
 * /discount/CODE?redirect=/products/handle&utm_content=xyz, so the code is
 * forwarded as `discount_code` — `useCartAddDiscountUrl` applies it to the cart
 * and therefore to checkout — the visitor is sent to the `redirect` destination
 * and every other param, utms included, is preserved.
 * @see https://help.superfiliate.com/articles/2185449010-using-superfiliate-with-headless-storefront
 */ var getDiscountRedirectUrl = function(param) {
    var code = param.code, _search = param.search, search = _search === void 0 ? "" : _search, origin = param.origin;
    var linkParams = new URLSearchParams(search);
    var redirect = linkParams.get("redirect");
    linkParams.delete("redirect");
    // only same origin destinations are honored, anything else falls back to home
    var destination;
    try {
        destination = new URL(redirect || "/", origin);
        if (destination.origin !== origin) destination = new URL("/", origin);
    } catch (error) {
        destination = new URL("/", origin);
    }
    // params on the affiliate link win over the destination's own params
    linkParams.forEach(function(value, key) {
        destination.searchParams.set(key, value);
    });
    if (code) destination.searchParams.set("discount_code", code);
    return "".concat(destination.pathname).concat(destination.search).concat(destination.hash);
};

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
;// CONCATENATED MODULE: ./src/utils/tripleWhale.js

var TRIPLE_WHALE_SHOP = "clearly-filtered.myshopify.com";
var decodeShopifyId = function(value) {
    console.log("decoding value", value);
    if (!value || typeof value !== "string") return "";
    if (value.includes("/")) {
        return value.substring(value.lastIndexOf("/") + 1);
    }
    if ( true && typeof window.atob === "function") {
        try {
            var decoded = window.atob(value);
            if (decoded.includes("/")) {
                return decoded.substring(decoded.lastIndexOf("/") + 1);
            }
        } catch (error) {
            return value;
        }
    }
    return value;
};
var getTriplePixel = function() {
    if (false) {}
    if (typeof window.TriplePixel !== "function") return null;
    return window.TriplePixel;
};
var trackTripleWhaleAddToCart = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, item = ref.item, quantity = ref.quantity, variant = ref.variant, token = ref.token;
    var triplePixel = getTriplePixel();
    if (!triplePixel) return;
    var parsedItem = decodeShopifyId(item);
    var parsedVariant = decodeShopifyId(variant);
    var parsedQuantity = Number(quantity || 0);
    if (!parsedItem || !parsedVariant || !parsedQuantity) return;
    var payload = {
        item: parsedItem,
        q: parsedQuantity,
        v: parsedVariant
    };
    if (token) {
        payload.token = decodeShopifyId(token);
    }
    triplePixel("AddToCart", payload);
};
var trackTripleWhaleContact = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, email = ref.email, phone = ref.phone;
    var triplePixel = getTriplePixel();
    if (!triplePixel) return;
    var safeEmail = email === null || email === void 0 ? void 0 : email.trim();
    var safePhone = phone === null || phone === void 0 ? void 0 : phone.trim();
    if (!safeEmail && !safePhone) return;
    triplePixel("Contact", (0,_object_spread/* default */.Z)({}, safeEmail ? {
        email: safeEmail
    } : null, safePhone ? {
        phone: safePhone
    } : null));
};
var getTripleWhaleShop = function() {
    return TRIPLE_WHALE_SHOP;
};

;// CONCATENATED MODULE: ./src/utils/index.js






/***/ }),

/***/ 5244:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ queryStorefrontApi; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3842);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5556);


var endpoint = "https://clearly-filtered.myshopify.com/api/".concat("2025-04", "/graphql.json");
function queryStorefrontApi(query) {
    return _queryStorefrontApi.apply(this, arguments);
}
function _queryStorefrontApi() {
    _queryStorefrontApi = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(query) {
        var variables, result, data, error;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    variables = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        fetch(endpoint, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                "X-Shopify-Storefront-Access-Token": "3bc6486eea19d75d4dd39479084d4c7a"
                            },
                            body: {
                                query: query
                            } && JSON.stringify({
                                query: query,
                                variables: variables
                            })
                        })
                    ];
                case 2:
                    result = _state.sent();
                    return [
                        4,
                        result.json()
                    ];
                case 3:
                    data = _state.sent();
                    if (!(data === null || data === void 0 ? void 0 : data.data)) {
                        throw new Error("No data returned from Shopify");
                    }
                    return [
                        2,
                        {
                            status: result.status,
                            body: data.data
                        }
                    ];
                case 4:
                    error = _state.sent();
                    console.error("Error:", error);
                    return [
                        2,
                        {
                            status: 500,
                            error: "Error receiving data"
                        }
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return _queryStorefrontApi.apply(this, arguments);
}


/***/ }),

/***/ 1528:
/***/ (function(module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath = (/* unused pure expression or super */ null && ( false || ""));
function getDomainLocale(path, locale, locales, domainLocales) {
    if (false) { var finalLocale, proto, domain, target, detectDomainLocale, normalizeLocalePath; } else {
        return false;
    }
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=get-domain-locale.js.map


/***/ }),

/***/ 1453:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(9854)/* ["default"] */ .Z);
var _typeOf = (__webpack_require__(2271)["default"]);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _interop_require_default = (__webpack_require__(2619)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(518)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7378));
var _router = __webpack_require__(194);
var _addLocale = __webpack_require__(4087);
var _routerContext = __webpack_require__(9756);
var _appRouterContext = __webpack_require__(7868);
var _useIntersection = __webpack_require__(1842);
var _getDomainLocale = __webpack_require__(1528);
var _addBasePath = __webpack_require__(1470);
"client";
var prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    Promise.resolve(router.prefetch(href, as, options)).catch(function(err) {
        if (false) {}
    });
    var curLocale = options && typeof options.locale !== "undefined" ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")] = true;
}
function isModifiedEvent(event) {
    var target = event.currentTarget.target;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
    var nodeName = e.currentTarget.nodeName;
    // anchors inside an svg have a lowercase nodeName
    var isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    var navigate = function() {
        // If the router is an NextRouter instance it will have `beforePopState`
        if ("beforePopState" in router) {
            router[replace ? "replace" : "push"](href, as, {
                shallow: shallow,
                locale: locale,
                scroll: scroll
            });
        } else {
            // If `beforePopState` doesn't exist on the router it's the AppRouter.
            var method = replace ? "replace" : "push";
            router[method](href, {
                forceOptimisticNavigation: !prefetchEnabled
            });
        }
    };
    if (isAppRouter) {
        // @ts-expect-error startTransition exists.
        _react.default.startTransition(navigate);
    } else {
        navigate();
    }
}
var Link = /*#__PURE__*/ _react.default.forwardRef(function LinkComponent(props, forwardedRef) {
    if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }
    var children;
    var hrefProp = props.href, asProp = props.as, childrenProp = props.children, prefetchProp = props.prefetch, passHref = props.passHref, replace = props.replace, shallow = props.shallow, scroll = props.scroll, locale = props.locale, onClick = props.onClick, onMouseEnter = props.onMouseEnter, onTouchStart = props.onTouchStart, _legacyBehavior = props.legacyBehavior, legacyBehavior = _legacyBehavior === void 0 ? Boolean(false) !== true : _legacyBehavior, restProps = _object_without_properties_loose(props, [
        "href",
        "as",
        "children",
        "prefetch",
        "passHref",
        "replace",
        "shallow",
        "scroll",
        "locale",
        "onClick",
        "onMouseEnter",
        "onTouchStart",
        "legacyBehavior"
    ]);
    children = childrenProp;
    if (legacyBehavior && (typeof children === "string" || typeof children === "number")) {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    var p = prefetchProp !== false;
    var router = _react.default.useContext(_routerContext.RouterContext);
    // TODO-APP: type error. Remove `as any`
    var appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);
    if (appRouter) {
        router = appRouter;
    }
    var ref = _react.default.useMemo(function() {
        var ref = _slicedToArray((0, _router).resolveHref(router, hrefProp, true), 2), resolvedHref = ref[0], resolvedAs = ref[1];
        return {
            href: resolvedHref,
            as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
        };
    }, [
        router,
        hrefProp,
        asProp
    ]), href = ref.href, as = ref.as;
    var previousHref = _react.default.useRef(href);
    var previousAs = _react.default.useRef(as);
    // This will return the first child, if multiple are provided it will throw an error
    var child;
    if (legacyBehavior) {
        if (false) {} else {
            child = _react.default.Children.only(children);
        }
    }
    var childRef = legacyBehavior ? child && typeof child === "object" && child.ref : forwardedRef;
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootMargin: "200px"
    }), 3), setIntersectionRef = ref1[0], isVisible = ref1[1], resetVisible = ref1[2];
    var setRef = _react.default.useCallback(function(el) {
        // Before the link getting observed, check if visible state need to be reset
        if (previousAs.current !== as || previousHref.current !== href) {
            resetVisible();
            previousAs.current = as;
            previousHref.current = href;
        }
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        as,
        childRef,
        href,
        resetVisible,
        setIntersectionRef
    ]);
    _react.default.useEffect(function() {
        var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        var isPrefetched = prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    var childProps = {
        ref: setRef,
        onClick: function(e) {
            if (false) {}
            if (!legacyBehavior && typeof onClick === "function") {
                onClick(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, shallow, scroll, locale, Boolean(appRouter), p);
            }
        },
        onMouseEnter: function(e) {
            if (!legacyBehavior && typeof onMouseEnter === "function") {
                onMouseEnter(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onMouseEnter === "function") {
                child.props.onMouseEnter(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        },
        onTouchStart: function(e) {
            if (!legacyBehavior && typeof onTouchStart === "function") {
                onTouchStart(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onTouchStart === "function") {
                child.props.onTouchStart(e);
            }
            // Check for not prefetch disabled in page using appRouter
            if (!(!p && appRouter)) {
                if ((0, _router).isLocalURL(href)) {
                    prefetch(router, href, as, {
                        priority: true
                    });
                }
            }
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (!legacyBehavior || passHref || child.type === "a" && !("href" in child.props)) {
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        var localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
        childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
    }
    return legacyBehavior ? /*#__PURE__*/ _react.default.cloneElement(child, childProps) : /*#__PURE__*/ _react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=link.js.map


/***/ }),

/***/ 1842:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(9854)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(7378);
var _requestIdleCallback = __webpack_require__(2878);
var hasIntersectionObserver = typeof IntersectionObserver === "function";
var observers = new Map();
var idList = [];
function createObserver(options) {
    var id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    var existing = idList.find(function(obj) {
        return obj.root === id.root && obj.margin === id.margin;
    });
    var instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    var elements = new Map();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var callback = elements.get(entry.target);
            var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id: id,
        observer: observer,
        elements: elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
function observe(element, callback, options) {
    var ref = createObserver(options), id = ref.id, observer = ref.observer, elements = ref.elements;
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            var index = idList.findIndex(function(obj) {
                return obj.root === id.root && obj.margin === id.margin;
            });
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
function useIntersection(param) {
    var rootRef = param.rootRef, rootMargin = param.rootMargin, disabled = param.disabled;
    var isDisabled = disabled || !hasIntersectionObserver;
    var ref = _slicedToArray((0, _react).useState(false), 2), visible = ref[0], setVisible = ref[1];
    var ref1 = _slicedToArray((0, _react).useState(null), 2), element = ref1[0], setElement = ref1[1];
    (0, _react).useEffect(function() {
        if (hasIntersectionObserver) {
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                var unobserve = observe(element, function(isVisible) {
                    return isVisible && setVisible(isVisible);
                }, {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin: rootMargin
                });
                return unobserve;
            }
        } else {
            if (!visible) {
                var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function() {
                    return setVisible(true);
                });
                return function() {
                    return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
                };
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    var resetVisible = (0, _react).useCallback(function() {
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 7868:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.TemplateContext = exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;
var _interop_require_default = (__webpack_require__(2619)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7378));
var AppRouterContext = _react.default.createContext(null);
exports.AppRouterContext = AppRouterContext;
var LayoutRouterContext = _react.default.createContext(null);
exports.LayoutRouterContext = LayoutRouterContext;
var GlobalLayoutRouterContext = _react.default.createContext(null);
exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;
var TemplateContext = _react.default.createContext(null);
exports.TemplateContext = TemplateContext;
if (false) {} //# sourceMappingURL=app-router-context.js.map


/***/ }),

/***/ 1218:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"skeletonBox":"PageErrorBoundary_skeletonBox__RAWh4","shimmer":"PageErrorBoundary_shimmer__7u3Mk"};

/***/ }),

/***/ 5309:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"PreviewModeToast_container__uXpwm","message":"PreviewModeToast_message___V_Uy"};

/***/ }),

/***/ 4386:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__lbC1D","spin":"Spinner_spin__rcHsC"};

/***/ }),

/***/ 2080:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 5560:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 1307:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 6118:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={229:function(e){var t=e.exports={};var r;var n;function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}(function(){try{if(typeof setTimeout==="function"){r=setTimeout}else{r=defaultSetTimout}}catch(e){r=defaultSetTimout}try{if(typeof clearTimeout==="function"){n=clearTimeout}else{n=defaultClearTimeout}}catch(e){n=defaultClearTimeout}})();function runTimeout(e){if(r===setTimeout){return setTimeout(e,0)}if((r===defaultSetTimout||!r)&&setTimeout){r=setTimeout;return setTimeout(e,0)}try{return r(e,0)}catch(t){try{return r.call(null,e,0)}catch(t){return r.call(this,e,0)}}}function runClearTimeout(e){if(n===clearTimeout){return clearTimeout(e)}if((n===defaultClearTimeout||!n)&&clearTimeout){n=clearTimeout;return clearTimeout(e)}try{return n(e)}catch(t){try{return n.call(null,e)}catch(t){return n.call(this,e)}}}var i=[];var o=false;var u;var a=-1;function cleanUpNextTick(){if(!o||!u){return}o=false;if(u.length){i=u.concat(i)}else{a=-1}if(i.length){drainQueue()}}function drainQueue(){if(o){return}var e=runTimeout(cleanUpNextTick);o=true;var t=i.length;while(t){u=i;i=[];while(++a<t){if(u){u[a].run()}}a=-1;t=i.length}u=null;o=false;runClearTimeout(e)}t.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1){for(var r=1;r<arguments.length;r++){t[r-1]=arguments[r]}}i.push(new Item(e,t));if(i.length===1&&!o){runTimeout(drainQueue)}};function Item(e,t){this.fun=e;this.array=t}Item.prototype.run=function(){this.fun.apply(null,this.array)};t.title="browser";t.browser=true;t.env={};t.argv=[];t.version="";t.versions={};function noop(){}t.on=noop;t.addListener=noop;t.once=noop;t.off=noop;t.removeListener=noop;t.removeAllListeners=noop;t.emit=noop;t.prependListener=noop;t.prependOnceListener=noop;t.listeners=function(e){return[]};t.binding=function(e){throw new Error("process.binding is not supported")};t.cwd=function(){return"/"};t.chdir=function(e){throw new Error("process.chdir is not supported")};t.umask=function(){return 0}}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var o=true;try{e[r](i,i.exports,__nccwpck_require__);o=false}finally{if(o)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(229);module.exports=r})();

/***/ }),

/***/ 8038:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(555)


/***/ }),

/***/ 9894:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(1453)


/***/ }),

/***/ 6677:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5817)


/***/ }),

/***/ 3218:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(7162)


/***/ }),

/***/ 7221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ErrorCode": function() { return /* reexport */ ErrorCode; },
  "connectToChild": function() { return /* reexport */ connectToChild; },
  "connectToParent": function() { return /* reexport */ connectToParent; }
});

;// CONCATENATED MODULE: ../node_modules/penpal/lib/enums.js
var MessageType;
(function (MessageType) {
    MessageType["Call"] = "call";
    MessageType["Reply"] = "reply";
    MessageType["Syn"] = "syn";
    MessageType["SynAck"] = "synAck";
    MessageType["Ack"] = "ack";
})(MessageType || (MessageType = {}));
var Resolution;
(function (Resolution) {
    Resolution["Fulfilled"] = "fulfilled";
    Resolution["Rejected"] = "rejected";
})(Resolution || (Resolution = {}));
var ErrorCode;
(function (ErrorCode) {
    ErrorCode["ConnectionDestroyed"] = "ConnectionDestroyed";
    ErrorCode["ConnectionTimeout"] = "ConnectionTimeout";
    ErrorCode["NoIframeSrc"] = "NoIframeSrc";
})(ErrorCode || (ErrorCode = {}));
var NativeErrorName;
(function (NativeErrorName) {
    NativeErrorName["DataCloneError"] = "DataCloneError";
})(NativeErrorName || (NativeErrorName = {}));
var NativeEventType;
(function (NativeEventType) {
    NativeEventType["Message"] = "message";
})(NativeEventType || (NativeEventType = {}));

;// CONCATENATED MODULE: ../node_modules/penpal/lib/createDestructor.js
/* harmony default export */ var createDestructor = ((localName, log) => {
    const callbacks = [];
    let destroyed = false;
    return {
        destroy(error) {
            if (!destroyed) {
                destroyed = true;
                log(`${localName}: Destroying connection`);
                callbacks.forEach((callback) => {
                    callback(error);
                });
            }
        },
        onDestroy(callback) {
            destroyed ? callback() : callbacks.push(callback);
        },
    };
});

;// CONCATENATED MODULE: ../node_modules/penpal/lib/createLogger.js
/* harmony default export */ var createLogger = ((debug) => {
    /**
     * Logs a message if debug is enabled.
     */
    return (...args) => {
        if (debug) {
            console.log('[Penpal]', ...args); // eslint-disable-line no-console
        }
    };
});

;// CONCATENATED MODULE: ../node_modules/penpal/lib/parent/getOriginFromSrc.js
const DEFAULT_PORT_BY_PROTOCOL = {
    'http:': '80',
    'https:': '443',
};
const URL_REGEX = /^(https?:)?\/\/([^/:]+)?(:(\d+))?/;
const opaqueOriginSchemes = ['file:', 'data:'];
/**
 * Converts a src value into an origin.
 */
/* harmony default export */ var getOriginFromSrc = ((src) => {
    if (src && opaqueOriginSchemes.find((scheme) => src.startsWith(scheme))) {
        // The origin of the child document is an opaque origin and its
        // serialization is "null"
        // https://html.spec.whatwg.org/multipage/origin.html#origin
        return 'null';
    }
    // Note that if src is undefined, then srcdoc is being used instead of src
    // and we can follow this same logic below to get the origin of the parent,
    // which is the origin that we will need to use.
    const location = document.location;
    const regexResult = URL_REGEX.exec(src);
    let protocol;
    let hostname;
    let port;
    if (regexResult) {
        // It's an absolute URL. Use the parsed info.
        // regexResult[1] will be undefined if the URL starts with //
        protocol = regexResult[1] ? regexResult[1] : location.protocol;
        hostname = regexResult[2];
        port = regexResult[4];
    }
    else {
        // It's a relative path. Use the current location's info.
        protocol = location.protocol;
        hostname = location.hostname;
        port = location.port;
    }
    // If the port is the default for the protocol, we don't want to add it to the origin string
    // or it won't match the message's event.origin.
    const portSuffix = port && port !== DEFAULT_PORT_BY_PROTOCOL[protocol] ? `:${port}` : '';
    return `${protocol}//${hostname}${portSuffix}`;
});

;// CONCATENATED MODULE: ../node_modules/penpal/lib/errorSerialization.js
/**
 * Converts an error object into a plain object.
 */
const serializeError = ({ name, message, stack, }) => ({
    name,
    message,
    stack,
});
/**
 * Converts a plain object into an error object.
 */
const deserializeError = (obj) => {
    const deserializedError = new Error();
    // @ts-ignore
    Object.keys(obj).forEach((key) => (deserializedError[key] = obj[key]));
    return deserializedError;
};

;// CONCATENATED MODULE: ../node_modules/penpal/lib/connectCallReceiver.js


/**
 * Listens for "call" messages coming from the remote, executes the corresponding method, and
 * responds with the return value.
 */
/* harmony default export */ var connectCallReceiver = ((info, serializedMethods, log) => {
    const { localName, local, remote, originForSending, originForReceiving, } = info;
    let destroyed = false;
    const handleMessageEvent = (event) => {
        if (event.source !== remote || event.data.penpal !== MessageType.Call) {
            return;
        }
        if (originForReceiving !== '*' && event.origin !== originForReceiving) {
            log(`${localName} received message from origin ${event.origin} which did not match expected origin ${originForReceiving}`);
            return;
        }
        const callMessage = event.data;
        const { methodName, args, id } = callMessage;
        log(`${localName}: Received ${methodName}() call`);
        const createPromiseHandler = (resolution) => {
            return (returnValue) => {
                log(`${localName}: Sending ${methodName}() reply`);
                if (destroyed) {
                    // It's possible to throw an error here, but it would need to be thrown asynchronously
                    // and would only be catchable using window.onerror. This is because the consumer
                    // is merely returning a value from their method and not calling any function
                    // that they could wrap in a try-catch. Even if the consumer were to catch the error,
                    // the value of doing so is questionable. Instead, we'll just log a message.
                    log(`${localName}: Unable to send ${methodName}() reply due to destroyed connection`);
                    return;
                }
                const message = {
                    penpal: MessageType.Reply,
                    id,
                    resolution,
                    returnValue,
                };
                if (resolution === Resolution.Rejected &&
                    returnValue instanceof Error) {
                    message.returnValue = serializeError(returnValue);
                    message.returnValueIsError = true;
                }
                try {
                    remote.postMessage(message, originForSending);
                }
                catch (err) {
                    // If a consumer attempts to send an object that's not cloneable (e.g., window),
                    // we want to ensure the receiver's promise gets rejected.
                    if (err.name === NativeErrorName.DataCloneError) {
                        const errorReplyMessage = {
                            penpal: MessageType.Reply,
                            id,
                            resolution: Resolution.Rejected,
                            returnValue: serializeError(err),
                            returnValueIsError: true,
                        };
                        remote.postMessage(errorReplyMessage, originForSending);
                    }
                    throw err;
                }
            };
        };
        new Promise((resolve) => resolve(serializedMethods[methodName].apply(serializedMethods, args))).then(createPromiseHandler(Resolution.Fulfilled), createPromiseHandler(Resolution.Rejected));
    };
    local.addEventListener(NativeEventType.Message, handleMessageEvent);
    return () => {
        destroyed = true;
        local.removeEventListener(NativeEventType.Message, handleMessageEvent);
    };
});

;// CONCATENATED MODULE: ../node_modules/penpal/lib/generateId.js
let id = 0;
/**
 * @return {number} A unique ID (not universally unique)
 */
/* harmony default export */ var generateId = (() => ++id);

;// CONCATENATED MODULE: ../node_modules/penpal/lib/methodSerialization.js
const KEY_PATH_DELIMITER = '.';
const keyPathToSegments = (keyPath) => keyPath ? keyPath.split(KEY_PATH_DELIMITER) : [];
const segmentsToKeyPath = (segments) => segments.join(KEY_PATH_DELIMITER);
const createKeyPath = (key, prefix) => {
    const segments = keyPathToSegments(prefix || '');
    segments.push(key);
    return segmentsToKeyPath(segments);
};
/**
 * Given a `keyPath`, set it to be `value` on `subject`, creating any intermediate
 * objects along the way.
 *
 * @param {Object} subject The object on which to set value.
 * @param {string} keyPath The key path at which to set value.
 * @param {Object} value The value to store at the given key path.
 * @returns {Object} Updated subject.
 */
const setAtKeyPath = (subject, keyPath, value) => {
    const segments = keyPathToSegments(keyPath);
    segments.reduce((prevSubject, key, idx) => {
        if (typeof prevSubject[key] === 'undefined') {
            prevSubject[key] = {};
        }
        if (idx === segments.length - 1) {
            prevSubject[key] = value;
        }
        return prevSubject[key];
    }, subject);
    return subject;
};
/**
 * Given a dictionary of (nested) keys to function, flatten them to a map
 * from key path to function.
 *
 * @param {Object} methods The (potentially nested) object to serialize.
 * @param {string} prefix A string with which to prefix entries. Typically not intended to be used by consumers.
 * @returns {Object} An map from key path in `methods` to functions.
 */
const serializeMethods = (methods, prefix) => {
    const flattenedMethods = {};
    Object.keys(methods).forEach((key) => {
        const value = methods[key];
        const keyPath = createKeyPath(key, prefix);
        if (typeof value === 'object') {
            // Recurse into any nested children.
            Object.assign(flattenedMethods, serializeMethods(value, keyPath));
        }
        if (typeof value === 'function') {
            // If we've found a method, expose it.
            flattenedMethods[keyPath] = value;
        }
    });
    return flattenedMethods;
};
/**
 * Given a map of key paths to functions, unpack the key paths to an object.
 *
 * @param {Object} flattenedMethods A map of key paths to functions to unpack.
 * @returns {Object} A (potentially nested) map of functions.
 */
const deserializeMethods = (flattenedMethods) => {
    const methods = {};
    for (const keyPath in flattenedMethods) {
        setAtKeyPath(methods, keyPath, flattenedMethods[keyPath]);
    }
    return methods;
};

;// CONCATENATED MODULE: ../node_modules/penpal/lib/connectCallSender.js




/**
 * Augments an object with methods that match those defined by the remote. When these methods are
 * called, a "call" message will be sent to the remote, the remote's corresponding method will be
 * executed, and the method's return value will be returned via a message.
 * @param {Object} callSender Sender object that should be augmented with methods.
 * @param {Object} info Information about the local and remote windows.
 * @param {Array} methodKeyPaths Key paths of methods available to be called on the remote.
 * @param {Promise} destructionPromise A promise resolved when destroy() is called on the penpal
 * connection.
 * @returns {Object} The call sender object with methods that may be called.
 */
/* harmony default export */ var connectCallSender = ((callSender, info, methodKeyPaths, destroyConnection, log) => {
    const { localName, local, remote, originForSending, originForReceiving, } = info;
    let destroyed = false;
    log(`${localName}: Connecting call sender`);
    const createMethodProxy = (methodName) => {
        return (...args) => {
            log(`${localName}: Sending ${methodName}() call`);
            // This handles the case where the iframe has been removed from the DOM
            // (and therefore its window closed), the consumer has not yet
            // called destroy(), and the user calls a method exposed by
            // the remote. We detect the iframe has been removed and force
            // a destroy() immediately so that the consumer sees the error saying
            // the connection has been destroyed. We wrap this check in a try catch
            // because Edge throws an "Object expected" error when accessing
            // contentWindow.closed on a contentWindow from an iframe that's been
            // removed from the DOM.
            let iframeRemoved;
            try {
                if (remote.closed) {
                    iframeRemoved = true;
                }
            }
            catch (e) {
                iframeRemoved = true;
            }
            if (iframeRemoved) {
                destroyConnection();
            }
            if (destroyed) {
                const error = new Error(`Unable to send ${methodName}() call due ` + `to destroyed connection`);
                error.code = ErrorCode.ConnectionDestroyed;
                throw error;
            }
            return new Promise((resolve, reject) => {
                const id = generateId();
                const handleMessageEvent = (event) => {
                    if (event.source !== remote ||
                        event.data.penpal !== MessageType.Reply ||
                        event.data.id !== id) {
                        return;
                    }
                    if (originForReceiving !== '*' &&
                        event.origin !== originForReceiving) {
                        log(`${localName} received message from origin ${event.origin} which did not match expected origin ${originForReceiving}`);
                        return;
                    }
                    const replyMessage = event.data;
                    log(`${localName}: Received ${methodName}() reply`);
                    local.removeEventListener(NativeEventType.Message, handleMessageEvent);
                    let returnValue = replyMessage.returnValue;
                    if (replyMessage.returnValueIsError) {
                        returnValue = deserializeError(returnValue);
                    }
                    (replyMessage.resolution === Resolution.Fulfilled ? resolve : reject)(returnValue);
                };
                local.addEventListener(NativeEventType.Message, handleMessageEvent);
                const callMessage = {
                    penpal: MessageType.Call,
                    id,
                    methodName,
                    args,
                };
                remote.postMessage(callMessage, originForSending);
            });
        };
    };
    // Wrap each method in a proxy which sends it to the corresponding receiver.
    const flattenedMethods = methodKeyPaths.reduce((api, name) => {
        api[name] = createMethodProxy(name);
        return api;
    }, {});
    // Unpack the structure of the provided methods object onto the CallSender, exposing
    // the methods in the same shape they were provided.
    Object.assign(callSender, deserializeMethods(flattenedMethods));
    return () => {
        destroyed = true;
    };
});

;// CONCATENATED MODULE: ../node_modules/penpal/lib/parent/handleAckMessageFactory.js


/**
 * Handles an ACK handshake message.
 */
/* harmony default export */ var handleAckMessageFactory = ((serializedMethods, childOrigin, originForSending, destructor, log) => {
    const { destroy, onDestroy } = destructor;
    let destroyCallReceiver;
    let receiverMethodNames;
    // We resolve the promise with the call sender. If the child reconnects
    // (for example, after refreshing or navigating to another page that
    // uses Penpal, we'll update the call sender with methods that match the
    // latest provided by the child.
    const callSender = {};
    return (event) => {
        if (childOrigin !== '*' && event.origin !== childOrigin) {
            log(`Parent: Handshake - Received ACK message from origin ${event.origin} which did not match expected origin ${childOrigin}`);
            return;
        }
        log('Parent: Handshake - Received ACK');
        const info = {
            localName: 'Parent',
            local: window,
            remote: event.source,
            originForSending: originForSending,
            originForReceiving: childOrigin,
        };
        // If the child reconnected, we need to destroy the prior call receiver
        // before setting up a new one.
        if (destroyCallReceiver) {
            destroyCallReceiver();
        }
        destroyCallReceiver = connectCallReceiver(info, serializedMethods, log);
        onDestroy(destroyCallReceiver);
        // If the child reconnected, we need to remove the methods from the
        // previous call receiver off the sender.
        if (receiverMethodNames) {
            receiverMethodNames.forEach((receiverMethodName) => {
                delete callSender[receiverMethodName];
            });
        }
        receiverMethodNames = event.data.methodNames;
        const destroyCallSender = connectCallSender(callSender, info, receiverMethodNames, destroy, log);
        onDestroy(destroyCallSender);
        return callSender;
    };
});

;// CONCATENATED MODULE: ../node_modules/penpal/lib/parent/handleSynMessageFactory.js

/**
 * Handles a SYN handshake message.
 */
/* harmony default export */ var handleSynMessageFactory = ((log, serializedMethods, childOrigin, originForSending) => {
    return (event) => {
        // Under specific timing circumstances, we can receive an event
        // whose source is null. This seems to happen when the child iframe is
        // removed from the DOM about the same time it has sent the SYN event.
        // https://github.com/Aaronius/penpal/issues/85
        if (!event.source) {
            return;
        }
        if (childOrigin !== '*' && event.origin !== childOrigin) {
            log(`Parent: Handshake - Received SYN message from origin ${event.origin} which did not match expected origin ${childOrigin}`);
            return;
        }
        log('Parent: Handshake - Received SYN, responding with SYN-ACK');
        const synAckMessage = {
            penpal: MessageType.SynAck,
            methodNames: Object.keys(serializedMethods),
        };
        event.source.postMessage(synAckMessage, originForSending);
    };
});

;// CONCATENATED MODULE: ../node_modules/penpal/lib/parent/monitorIframeRemoval.js
const CHECK_IFRAME_IN_DOC_INTERVAL = 60000;
/**
 * Monitors for iframe removal and destroys connection if iframe
 * is found to have been removed from DOM. This is to prevent memory
 * leaks when the iframe is removed from the document and the consumer
 * hasn't called destroy(). Without this, event listeners attached to
 * the window would stick around and since the event handlers have a
 * reference to the iframe in their closures, the iframe would stick
 * around too.
 */
/* harmony default export */ var monitorIframeRemoval = ((iframe, destructor) => {
    const { destroy, onDestroy } = destructor;
    const checkIframeInDocIntervalId = setInterval(() => {
        if (!iframe.isConnected) {
            clearInterval(checkIframeInDocIntervalId);
            destroy();
        }
    }, CHECK_IFRAME_IN_DOC_INTERVAL);
    onDestroy(() => {
        clearInterval(checkIframeInDocIntervalId);
    });
});

;// CONCATENATED MODULE: ../node_modules/penpal/lib/startConnectionTimeout.js

/**
 * Starts a timeout and calls the callback with an error
 * if the timeout completes before the stop function is called.
 */
/* harmony default export */ var startConnectionTimeout = ((timeout, callback) => {
    let timeoutId;
    if (timeout !== undefined) {
        timeoutId = window.setTimeout(() => {
            const error = new Error(`Connection timed out after ${timeout}ms`);
            error.code = ErrorCode.ConnectionTimeout;
            callback(error);
        }, timeout);
    }
    return () => {
        clearTimeout(timeoutId);
    };
});

;// CONCATENATED MODULE: ../node_modules/penpal/lib/parent/validateIframeHasSrcOrSrcDoc.js

/* harmony default export */ var validateIframeHasSrcOrSrcDoc = ((iframe) => {
    if (!iframe.src && !iframe.srcdoc) {
        const error = new Error('Iframe must have src or srcdoc property defined.');
        error.code = ErrorCode.NoIframeSrc;
        throw error;
    }
});

;// CONCATENATED MODULE: ../node_modules/penpal/lib/parent/connectToChild.js










/**
 * Attempts to establish communication with an iframe.
 */
/* harmony default export */ var connectToChild = ((options) => {
    let { iframe, methods = {}, childOrigin, timeout, debug = false } = options;
    const log = createLogger(debug);
    const destructor = createDestructor('Parent', log);
    const { onDestroy, destroy } = destructor;
    if (!childOrigin) {
        validateIframeHasSrcOrSrcDoc(iframe);
        childOrigin = getOriginFromSrc(iframe.src);
    }
    // If event.origin is "null", the remote protocol is file: or data: and we
    // must post messages with "*" as targetOrigin when sending messages.
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/postMessage#Using_window.postMessage_in_extensions
    const originForSending = childOrigin === 'null' ? '*' : childOrigin;
    const serializedMethods = serializeMethods(methods);
    const handleSynMessage = handleSynMessageFactory(log, serializedMethods, childOrigin, originForSending);
    const handleAckMessage = handleAckMessageFactory(serializedMethods, childOrigin, originForSending, destructor, log);
    const promise = new Promise((resolve, reject) => {
        const stopConnectionTimeout = startConnectionTimeout(timeout, destroy);
        const handleMessage = (event) => {
            if (event.source !== iframe.contentWindow || !event.data) {
                return;
            }
            if (event.data.penpal === MessageType.Syn) {
                handleSynMessage(event);
                return;
            }
            if (event.data.penpal === MessageType.Ack) {
                const callSender = handleAckMessage(event);
                if (callSender) {
                    stopConnectionTimeout();
                    resolve(callSender);
                }
                return;
            }
        };
        window.addEventListener(NativeEventType.Message, handleMessage);
        log('Parent: Awaiting handshake');
        monitorIframeRemoval(iframe, destructor);
        onDestroy((error) => {
            window.removeEventListener(NativeEventType.Message, handleMessage);
            if (error) {
                reject(error);
            }
        });
    });
    return {
        promise,
        destroy() {
            // Don't allow consumer to pass an error into destroy.
            destroy();
        },
    };
});

;// CONCATENATED MODULE: ../node_modules/penpal/lib/child/handleSynAckMessageFactory.js



/**
 * Handles a SYN-ACK handshake message.
 */
/* harmony default export */ var handleSynAckMessageFactory = ((parentOrigin, serializedMethods, destructor, log) => {
    const { destroy, onDestroy } = destructor;
    return (event) => {
        let originQualifies = parentOrigin instanceof RegExp
            ? parentOrigin.test(event.origin)
            : parentOrigin === '*' || parentOrigin === event.origin;
        if (!originQualifies) {
            log(`Child: Handshake - Received SYN-ACK from origin ${event.origin} which did not match expected origin ${parentOrigin}`);
            return;
        }
        log('Child: Handshake - Received SYN-ACK, responding with ACK');
        // If event.origin is "null", the remote protocol is file: or data: and we
        // must post messages with "*" as targetOrigin when sending messages.
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/postMessage#Using_window.postMessage_in_extensions
        const originForSending = event.origin === 'null' ? '*' : event.origin;
        const ackMessage = {
            penpal: MessageType.Ack,
            methodNames: Object.keys(serializedMethods),
        };
        window.parent.postMessage(ackMessage, originForSending);
        const info = {
            localName: 'Child',
            local: window,
            remote: window.parent,
            originForSending,
            originForReceiving: event.origin,
        };
        const destroyCallReceiver = connectCallReceiver(info, serializedMethods, log);
        onDestroy(destroyCallReceiver);
        const callSender = {};
        const destroyCallSender = connectCallSender(callSender, info, event.data.methodNames, destroy, log);
        onDestroy(destroyCallSender);
        return callSender;
    };
});

;// CONCATENATED MODULE: ../node_modules/penpal/lib/child/connectToParent.js






const areGlobalsAccessible = () => {
    try {
        clearTimeout();
    }
    catch (e) {
        return false;
    }
    return true;
};
/**
 * Attempts to establish communication with the parent window.
 */
/* harmony default export */ var connectToParent = ((options = {}) => {
    const { parentOrigin = '*', methods = {}, timeout, debug = false } = options;
    const log = createLogger(debug);
    const destructor = createDestructor('Child', log);
    const { destroy, onDestroy } = destructor;
    const serializedMethods = serializeMethods(methods);
    const handleSynAckMessage = handleSynAckMessageFactory(parentOrigin, serializedMethods, destructor, log);
    const sendSynMessage = () => {
        log('Child: Handshake - Sending SYN');
        const synMessage = { penpal: MessageType.Syn };
        const parentOriginForSyn = parentOrigin instanceof RegExp ? '*' : parentOrigin;
        window.parent.postMessage(synMessage, parentOriginForSyn);
    };
    const promise = new Promise((resolve, reject) => {
        const stopConnectionTimeout = startConnectionTimeout(timeout, destroy);
        const handleMessage = (event) => {
            // Under niche scenarios, we get into this function after
            // the iframe has been removed from the DOM. In Edge, this
            // results in "Object expected" errors being thrown when we
            // try to access properties on window (global properties).
            // For this reason, we try to access a global up front (clearTimeout)
            // and if it fails we can assume the iframe has been removed
            // and we ignore the message event.
            if (!areGlobalsAccessible()) {
                return;
            }
            if (event.source !== parent || !event.data) {
                return;
            }
            if (event.data.penpal === MessageType.SynAck) {
                const callSender = handleSynAckMessage(event);
                if (callSender) {
                    window.removeEventListener(NativeEventType.Message, handleMessage);
                    stopConnectionTimeout();
                    resolve(callSender);
                }
            }
        };
        window.addEventListener(NativeEventType.Message, handleMessage);
        sendSynMessage();
        onDestroy((error) => {
            window.removeEventListener(NativeEventType.Message, handleMessage);
            if (error) {
                reject(error);
            }
        });
    });
    return {
        promise,
        destroy() {
            // Don't allow consumer to pass an error into destroy.
            destroy();
        },
    };
});

;// CONCATENATED MODULE: ../node_modules/penpal/lib/index.js





/***/ }),

/***/ 8772:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(331);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 3615:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(8772)();
}


/***/ }),

/***/ 331:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 7651:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
/**
 * Copyright (c) 2010,2011,2012,2013,2014 Morgan Roderick http://roderick.dk
 * License: MIT - http://mrgnrdrck.mit-license.org
 *
 * https://github.com/mroderick/PubSubJS
 */

(function (root, factory){
    'use strict';

    var PubSub = {};

    if (root.PubSub) {
        PubSub = root.PubSub;
        console.warn("PubSub already loaded, using existing version");
    } else {
        root.PubSub = PubSub;
        factory(PubSub);
    }
    // CommonJS and Node.js module support
    if (true){
        if (module !== undefined && module.exports) {
            exports = module.exports = PubSub; // Node.js specific `module.exports`
        }
        exports.PubSub = PubSub; // CommonJS module 1.1.1 spec
        module.exports = exports = PubSub; // CommonJS
    }
    // AMD support
    /* eslint-disable no-undef */
    else {}

}(( typeof window === 'object' && window ) || this, function (PubSub){
    'use strict';

    var messages = {},
        lastUid = -1,
        ALL_SUBSCRIBING_MSG = '*';

    function hasKeys(obj){
        var key;

        for (key in obj){
            if ( Object.prototype.hasOwnProperty.call(obj, key) ){
                return true;
            }
        }
        return false;
    }

    /**
     * Returns a function that throws the passed exception, for use as argument for setTimeout
     * @alias throwException
     * @function
     * @param { Object } ex An Error object
     */
    function throwException( ex ){
        return function reThrowException(){
            throw ex;
        };
    }

    function callSubscriberWithDelayedExceptions( subscriber, message, data ){
        try {
            subscriber( message, data );
        } catch( ex ){
            setTimeout( throwException( ex ), 0);
        }
    }

    function callSubscriberWithImmediateExceptions( subscriber, message, data ){
        subscriber( message, data );
    }

    function deliverMessage( originalMessage, matchedMessage, data, immediateExceptions ){
        var subscribers = messages[matchedMessage],
            callSubscriber = immediateExceptions ? callSubscriberWithImmediateExceptions : callSubscriberWithDelayedExceptions,
            s;

        if ( !Object.prototype.hasOwnProperty.call( messages, matchedMessage ) ) {
            return;
        }

        for (s in subscribers){
            if ( Object.prototype.hasOwnProperty.call(subscribers, s)){
                callSubscriber( subscribers[s], originalMessage, data );
            }
        }
    }

    function createDeliveryFunction( message, data, immediateExceptions ){
        return function deliverNamespaced(){
            var topic = String( message ),
                position = topic.lastIndexOf( '.' );

            // deliver the message as it is now
            deliverMessage(message, message, data, immediateExceptions);

            // trim the hierarchy and deliver message to each level
            while( position !== -1 ){
                topic = topic.substr( 0, position );
                position = topic.lastIndexOf('.');
                deliverMessage( message, topic, data, immediateExceptions );
            }

            deliverMessage(message, ALL_SUBSCRIBING_MSG, data, immediateExceptions);
        };
    }

    function hasDirectSubscribersFor( message ) {
        var topic = String( message ),
            found = Boolean(Object.prototype.hasOwnProperty.call( messages, topic ) && hasKeys(messages[topic]));

        return found;
    }

    function messageHasSubscribers( message ){
        var topic = String( message ),
            found = hasDirectSubscribersFor(topic) || hasDirectSubscribersFor(ALL_SUBSCRIBING_MSG),
            position = topic.lastIndexOf( '.' );

        while ( !found && position !== -1 ){
            topic = topic.substr( 0, position );
            position = topic.lastIndexOf( '.' );
            found = hasDirectSubscribersFor(topic);
        }

        return found;
    }

    function publish( message, data, sync, immediateExceptions ){
        message = (typeof message === 'symbol') ? message.toString() : message;

        var deliver = createDeliveryFunction( message, data, immediateExceptions ),
            hasSubscribers = messageHasSubscribers( message );

        if ( !hasSubscribers ){
            return false;
        }

        if ( sync === true ){
            deliver();
        } else {
            setTimeout( deliver, 0 );
        }
        return true;
    }

    /**
     * Publishes the message, passing the data to it's subscribers
     * @function
     * @alias publish
     * @param { String } message The message to publish
     * @param {} data The data to pass to subscribers
     * @return { Boolean }
     */
    PubSub.publish = function( message, data ){
        return publish( message, data, false, PubSub.immediateExceptions );
    };

    /**
     * Publishes the message synchronously, passing the data to it's subscribers
     * @function
     * @alias publishSync
     * @param { String } message The message to publish
     * @param {} data The data to pass to subscribers
     * @return { Boolean }
     */
    PubSub.publishSync = function( message, data ){
        return publish( message, data, true, PubSub.immediateExceptions );
    };

    /**
     * Subscribes the passed function to the passed message. Every returned token is unique and should be stored if you need to unsubscribe
     * @function
     * @alias subscribe
     * @param { String } message The message to subscribe to
     * @param { Function } func The function to call when a new message is published
     * @return { String }
     */
    PubSub.subscribe = function( message, func ){
        if ( typeof func !== 'function'){
            return false;
        }

        message = (typeof message === 'symbol') ? message.toString() : message;

        // message is not registered yet
        if ( !Object.prototype.hasOwnProperty.call( messages, message ) ){
            messages[message] = {};
        }

        // forcing token as String, to allow for future expansions without breaking usage
        // and allow for easy use as key names for the 'messages' object
        var token = 'uid_' + String(++lastUid);
        messages[message][token] = func;

        // return token for unsubscribing
        return token;
    };

    PubSub.subscribeAll = function( func ){
        return PubSub.subscribe(ALL_SUBSCRIBING_MSG, func);
    };

    /**
     * Subscribes the passed function to the passed message once
     * @function
     * @alias subscribeOnce
     * @param { String } message The message to subscribe to
     * @param { Function } func The function to call when a new message is published
     * @return { PubSub }
     */
    PubSub.subscribeOnce = function( message, func ){
        var token = PubSub.subscribe( message, function(){
            // before func apply, unsubscribe message
            PubSub.unsubscribe( token );
            func.apply( this, arguments );
        });
        return PubSub;
    };

    /**
     * Clears all subscriptions
     * @function
     * @public
     * @alias clearAllSubscriptions
     */
    PubSub.clearAllSubscriptions = function clearAllSubscriptions(){
        messages = {};
    };

    /**
     * Clear subscriptions by the topic
     * @function
     * @public
     * @alias clearAllSubscriptions
     * @return { int }
     */
    PubSub.clearSubscriptions = function clearSubscriptions(topic){
        var m;
        for (m in messages){
            if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0){
                delete messages[m];
            }
        }
    };

    /**
       Count subscriptions by the topic
     * @function
     * @public
     * @alias countSubscriptions
     * @return { Array }
    */
    PubSub.countSubscriptions = function countSubscriptions(topic){
        var m;
        // eslint-disable-next-line no-unused-vars
        var token;
        var count = 0;
        for (m in messages) {
            if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0) {
                for (token in messages[m]) {
                    count++;
                }
                break;
            }
        }
        return count;
    };


    /**
       Gets subscriptions by the topic
     * @function
     * @public
     * @alias getSubscriptions
    */
    PubSub.getSubscriptions = function getSubscriptions(topic){
        var m;
        var list = [];
        for (m in messages){
            if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0){
                list.push(m);
            }
        }
        return list;
    };

    /**
     * Removes subscriptions
     *
     * - When passed a token, removes a specific subscription.
     *
	 * - When passed a function, removes all subscriptions for that function
     *
	 * - When passed a topic, removes all subscriptions for that topic (hierarchy)
     * @function
     * @public
     * @alias subscribeOnce
     * @param { String | Function } value A token, function or topic to unsubscribe from
     * @example // Unsubscribing with a token
     * var token = PubSub.subscribe('mytopic', myFunc);
     * PubSub.unsubscribe(token);
     * @example // Unsubscribing with a function
     * PubSub.unsubscribe(myFunc);
     * @example // Unsubscribing from a topic
     * PubSub.unsubscribe('mytopic');
     */
    PubSub.unsubscribe = function(value){
        var descendantTopicExists = function(topic) {
                var m;
                for ( m in messages ){
                    if ( Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0 ){
                        // a descendant of the topic exists:
                        return true;
                    }
                }

                return false;
            },
            isTopic    = typeof value === 'string' && ( Object.prototype.hasOwnProperty.call(messages, value) || descendantTopicExists(value) ),
            isToken    = !isTopic && typeof value === 'string',
            isFunction = typeof value === 'function',
            result = false,
            m, message, t;

        if (isTopic){
            PubSub.clearSubscriptions(value);
            return;
        }

        for ( m in messages ){
            if ( Object.prototype.hasOwnProperty.call( messages, m ) ){
                message = messages[m];

                if ( isToken && message[value] ){
                    delete message[value];
                    result = value;
                    // tokens are unique, so we can just stop here
                    break;
                }

                if (isFunction) {
                    for ( t in message ){
                        if (Object.prototype.hasOwnProperty.call(message, t) && message[t] === value){
                            delete message[t];
                            result = true;
                        }
                    }
                }
            }
        }

        return result;
    };
}));


/***/ }),

/***/ 962:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(4276)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(this, function (exports, _reactSwipe) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactSwipe2 = _interopRequireDefault(_reactSwipe);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _reactSwipe2.default;
});

/***/ }),

/***/ 4276:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(7378), __webpack_require__(3615)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(this, function (exports, _react, _propTypes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.setHasSupportToCaptureOption = setHasSupportToCaptureOption;

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var supportsCaptureOption = false;
  function setHasSupportToCaptureOption(hasSupport) {
    supportsCaptureOption = hasSupport;
  }

  try {
    addEventListener('test', null, Object.defineProperty({}, 'capture', { get: function get() {
        setHasSupportToCaptureOption(true);
      } }));
  } catch (e) {} // eslint-disable-line no-empty

  function getSafeEventHandlerOpts() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { capture: true };

    return supportsCaptureOption ? options : options.capture;
  }

  /**
   * [getPosition returns a position element that works for mouse or touch events]
   * @param  {[Event]} event [the received event]
   * @return {[Object]}      [x and y coords]
   */
  function getPosition(event) {
    if ('touches' in event) {
      var _event$touches$ = event.touches[0],
          pageX = _event$touches$.pageX,
          pageY = _event$touches$.pageY;

      return { x: pageX, y: pageY };
    }

    var screenX = event.screenX,
        screenY = event.screenY;

    return { x: screenX, y: screenY };
  }

  var ReactSwipe = function (_Component) {
    _inherits(ReactSwipe, _Component);

    function ReactSwipe() {
      var _ref;

      _classCallCheck(this, ReactSwipe);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var _this = _possibleConstructorReturn(this, (_ref = ReactSwipe.__proto__ || Object.getPrototypeOf(ReactSwipe)).call.apply(_ref, [this].concat(args)));

      _this._handleSwipeStart = _this._handleSwipeStart.bind(_this);
      _this._handleSwipeMove = _this._handleSwipeMove.bind(_this);
      _this._handleSwipeEnd = _this._handleSwipeEnd.bind(_this);

      _this._onMouseDown = _this._onMouseDown.bind(_this);
      _this._onMouseMove = _this._onMouseMove.bind(_this);
      _this._onMouseUp = _this._onMouseUp.bind(_this);

      _this._setSwiperRef = _this._setSwiperRef.bind(_this);
      return _this;
    }

    _createClass(ReactSwipe, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (this.swiper) {
          this.swiper.addEventListener('touchmove', this._handleSwipeMove, getSafeEventHandlerOpts({
            capture: true,
            passive: false
          }));
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.swiper) {
          this.swiper.removeEventListener('touchmove', this._handleSwipeMove, getSafeEventHandlerOpts({
            capture: true,
            passive: false
          }));
        }
      }
    }, {
      key: '_onMouseDown',
      value: function _onMouseDown(event) {
        if (!this.props.allowMouseEvents) {
          return;
        }

        this.mouseDown = true;

        document.addEventListener('mouseup', this._onMouseUp);
        document.addEventListener('mousemove', this._onMouseMove);

        this._handleSwipeStart(event);
      }
    }, {
      key: '_onMouseMove',
      value: function _onMouseMove(event) {
        if (!this.mouseDown) {
          return;
        }

        this._handleSwipeMove(event);
      }
    }, {
      key: '_onMouseUp',
      value: function _onMouseUp(event) {
        this.mouseDown = false;

        document.removeEventListener('mouseup', this._onMouseUp);
        document.removeEventListener('mousemove', this._onMouseMove);

        this._handleSwipeEnd(event);
      }
    }, {
      key: '_handleSwipeStart',
      value: function _handleSwipeStart(event) {
        var _getPosition = getPosition(event),
            x = _getPosition.x,
            y = _getPosition.y;

        this.moveStart = { x: x, y: y };
        this.props.onSwipeStart(event);
      }
    }, {
      key: '_handleSwipeMove',
      value: function _handleSwipeMove(event) {
        if (!this.moveStart) {
          return;
        }

        var _getPosition2 = getPosition(event),
            x = _getPosition2.x,
            y = _getPosition2.y;

        var deltaX = x - this.moveStart.x;
        var deltaY = y - this.moveStart.y;
        this.moving = true;

        // handling the responsability of cancelling the scroll to
        // the component handling the event
        var shouldPreventDefault = this.props.onSwipeMove({
          x: deltaX,
          y: deltaY
        }, event);

        if (shouldPreventDefault && event.cancelable) {
          event.preventDefault();
        }

        this.movePosition = { deltaX: deltaX, deltaY: deltaY };
      }
    }, {
      key: '_handleSwipeEnd',
      value: function _handleSwipeEnd(event) {
        this.props.onSwipeEnd(event);

        var tolerance = this.props.tolerance;


        if (this.moving && this.movePosition) {
          if (this.movePosition.deltaX < -tolerance) {
            this.props.onSwipeLeft(1, event);
          } else if (this.movePosition.deltaX > tolerance) {
            this.props.onSwipeRight(1, event);
          }
          if (this.movePosition.deltaY < -tolerance) {
            this.props.onSwipeUp(1, event);
          } else if (this.movePosition.deltaY > tolerance) {
            this.props.onSwipeDown(1, event);
          }
        }

        this.moveStart = null;
        this.moving = false;
        this.movePosition = null;
      }
    }, {
      key: '_setSwiperRef',
      value: function _setSwiperRef(node) {
        this.swiper = node;
        this.props.innerRef(node);
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            tagName = _props.tagName,
            className = _props.className,
            style = _props.style,
            children = _props.children,
            allowMouseEvents = _props.allowMouseEvents,
            onSwipeUp = _props.onSwipeUp,
            onSwipeDown = _props.onSwipeDown,
            onSwipeLeft = _props.onSwipeLeft,
            onSwipeRight = _props.onSwipeRight,
            onSwipeStart = _props.onSwipeStart,
            onSwipeMove = _props.onSwipeMove,
            onSwipeEnd = _props.onSwipeEnd,
            innerRef = _props.innerRef,
            tolerance = _props.tolerance,
            props = _objectWithoutProperties(_props, ['tagName', 'className', 'style', 'children', 'allowMouseEvents', 'onSwipeUp', 'onSwipeDown', 'onSwipeLeft', 'onSwipeRight', 'onSwipeStart', 'onSwipeMove', 'onSwipeEnd', 'innerRef', 'tolerance']);

        return _react2.default.createElement(
          this.props.tagName,
          _extends({
            ref: this._setSwiperRef,
            onMouseDown: this._onMouseDown,
            onTouchStart: this._handleSwipeStart,
            onTouchEnd: this._handleSwipeEnd,
            className: className,
            style: style
          }, props),
          children
        );
      }
    }]);

    return ReactSwipe;
  }(_react.Component);

  ReactSwipe.displayName = 'ReactSwipe';
  ReactSwipe.propTypes = {
    tagName: _propTypes2.default.string,
    className: _propTypes2.default.string,
    style: _propTypes2.default.object,
    children: _propTypes2.default.node,
    allowMouseEvents: _propTypes2.default.bool,
    onSwipeUp: _propTypes2.default.func,
    onSwipeDown: _propTypes2.default.func,
    onSwipeLeft: _propTypes2.default.func,
    onSwipeRight: _propTypes2.default.func,
    onSwipeStart: _propTypes2.default.func,
    onSwipeMove: _propTypes2.default.func,
    onSwipeEnd: _propTypes2.default.func,
    innerRef: _propTypes2.default.func,
    tolerance: _propTypes2.default.number.isRequired
  };
  ReactSwipe.defaultProps = {
    tagName: 'div',
    allowMouseEvents: false,
    onSwipeUp: function onSwipeUp() {},
    onSwipeDown: function onSwipeDown() {},
    onSwipeLeft: function onSwipeLeft() {},
    onSwipeRight: function onSwipeRight() {},
    onSwipeStart: function onSwipeStart() {},
    onSwipeMove: function onSwipeMove() {},
    onSwipeEnd: function onSwipeEnd() {},
    innerRef: function innerRef() {},

    tolerance: 0
  };
  exports.default = ReactSwipe;
});

/***/ }),

/***/ 1906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ErrorBoundary": function() { return /* binding */ ErrorBoundary; },
/* harmony export */   "ErrorBoundaryContext": function() { return /* binding */ ErrorBoundaryContext; },
/* harmony export */   "useErrorBoundary": function() { return /* binding */ useErrorBoundary; },
/* harmony export */   "withErrorBoundary": function() { return /* binding */ withErrorBoundary; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
'use client';


const ErrorBoundaryContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);

const initialState = {
  didCatch: false,
  error: null
};
class ErrorBoundary extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor(props) {
    super(props);
    this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
    this.state = initialState;
  }
  static getDerivedStateFromError(error) {
    return {
      didCatch: true,
      error
    };
  }
  resetErrorBoundary() {
    const {
      error
    } = this.state;
    if (error !== null) {
      var _this$props$onReset, _this$props;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 ? void 0 : _this$props$onReset.call(_this$props, {
        args,
        reason: "imperative-api"
      });
      this.setState(initialState);
    }
  }
  componentDidCatch(error, info) {
    var _this$props$onError, _this$props2;
    (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 ? void 0 : _this$props$onError.call(_this$props2, error, info);
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      didCatch
    } = this.state;
    const {
      resetKeys
    } = this.props;

    // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
    // we'd end up resetting the error boundary immediately.
    // This would likely trigger a second error to be thrown.
    // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.

    if (didCatch && prevState.error !== null && hasArrayChanged(prevProps.resetKeys, resetKeys)) {
      var _this$props$onReset2, _this$props3;
      (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 ? void 0 : _this$props$onReset2.call(_this$props3, {
        next: resetKeys,
        prev: prevProps.resetKeys,
        reason: "keys"
      });
      this.setState(initialState);
    }
  }
  render() {
    const {
      children,
      fallbackRender,
      FallbackComponent,
      fallback
    } = this.props;
    const {
      didCatch,
      error
    } = this.state;
    let childToRender = children;
    if (didCatch) {
      const props = {
        error,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (typeof fallbackRender === "function") {
        childToRender = fallbackRender(props);
      } else if (FallbackComponent) {
        childToRender = (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(FallbackComponent, props);
      } else if (fallback === null || (0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(fallback)) {
        childToRender = fallback;
      } else {
        throw error;
      }
    }
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(ErrorBoundaryContext.Provider, {
      value: {
        didCatch,
        error,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, childToRender);
  }
}
function hasArrayChanged() {
  let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return a.length !== b.length || a.some((item, index) => !Object.is(item, b[index]));
}

function assertErrorBoundaryContext(value) {
  if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") {
    throw new Error("ErrorBoundaryContext not found");
  }
}

function useErrorBoundary() {
  const context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ErrorBoundaryContext);
  assertErrorBoundaryContext(context);
  const [state, setState] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    error: null,
    hasError: false
  });
  const memoized = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => ({
    resetBoundary: () => {
      context.resetErrorBoundary();
      setState({
        error: null,
        hasError: false
      });
    },
    showBoundary: error => setState({
      error,
      hasError: true
    })
  }), [context.resetErrorBoundary]);
  if (state.hasError) {
    throw state.error;
  }
  return memoized;
}

function withErrorBoundary(component, errorBoundaryProps) {
  const Wrapped = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, ref) => (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(ErrorBoundary, errorBoundaryProps, (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(component, {
    ...props,
    ref
  })));

  // Format for display in DevTools
  const name = component.displayName || component.name || "Unknown";
  Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
  return Wrapped;
}




/***/ }),

/***/ 8702:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=Symbol.for("react.element"),c=Symbol.for("react.portal"),d=Symbol.for("react.fragment"),e=Symbol.for("react.strict_mode"),f=Symbol.for("react.profiler"),g=Symbol.for("react.provider"),h=Symbol.for("react.context"),k=Symbol.for("react.server_context"),l=Symbol.for("react.forward_ref"),m=Symbol.for("react.suspense"),n=Symbol.for("react.suspense_list"),p=Symbol.for("react.memo"),q=Symbol.for("react.lazy"),t=Symbol.for("react.offscreen"),u;u=Symbol.for("react.module.reference");
function v(a){if("object"===typeof a&&null!==a){var r=a.$$typeof;switch(r){case b:switch(a=a.type,a){case d:case f:case e:case m:case n:return a;default:switch(a=a&&a.$$typeof,a){case k:case h:case l:case q:case p:case g:return a;default:return r}}case c:return r}}}exports.ContextConsumer=h;exports.ContextProvider=g;exports.Element=b;exports.ForwardRef=l;exports.Fragment=d;exports.Lazy=q;exports.Memo=p;exports.Portal=c;exports.Profiler=f;exports.StrictMode=e;exports.Suspense=m;
exports.SuspenseList=n;exports.isAsyncMode=function(){return!1};exports.isConcurrentMode=function(){return!1};exports.isContextConsumer=function(a){return v(a)===h};exports.isContextProvider=function(a){return v(a)===g};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};exports.isForwardRef=function(a){return v(a)===l};exports.isFragment=function(a){return v(a)===d};exports.isLazy=function(a){return v(a)===q};exports.isMemo=function(a){return v(a)===p};
exports.isPortal=function(a){return v(a)===c};exports.isProfiler=function(a){return v(a)===f};exports.isStrictMode=function(a){return v(a)===e};exports.isSuspense=function(a){return v(a)===m};exports.isSuspenseList=function(a){return v(a)===n};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===e||a===m||a===n||a===t||"object"===typeof a&&null!==a&&(a.$$typeof===q||a.$$typeof===p||a.$$typeof===g||a.$$typeof===h||a.$$typeof===l||a.$$typeof===u||void 0!==a.getModuleId)?!0:!1};exports.typeOf=v;


/***/ }),

/***/ 9185:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(8702);
} else {}


/***/ }),

/***/ 3563:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _default = function _default(position, metric, axis) {
  var positionPercent = position === 0 ? position : position + metric;
  var positionCss = axis === 'horizontal' ? [positionPercent, 0, 0] : [0, positionPercent, 0];
  var transitionProp = 'translate3d';
  var translatedPosition = '(' + positionCss.join(',') + ')';
  return transitionProp + translatedPosition;
};

exports["default"] = _default;

/***/ }),

/***/ 5820:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.fadeAnimationHandler = exports.slideStopSwipingHandler = exports.slideSwipeAnimationHandler = exports.slideAnimationHandler = void 0;

var _react = __webpack_require__(7378);

var _CSSTranslate = _interopRequireDefault(__webpack_require__(3563));

var _utils = __webpack_require__(2341);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Main animation handler for the default 'sliding' style animation
 * @param props
 * @param state
 */
var slideAnimationHandler = function slideAnimationHandler(props, state) {
  var returnStyles = {};
  var selectedItem = state.selectedItem;
  var previousItem = selectedItem;
  var lastPosition = _react.Children.count(props.children) - 1;
  var needClonedSlide = props.infiniteLoop && (selectedItem < 0 || selectedItem > lastPosition); // Handle list position if it needs a clone

  if (needClonedSlide) {
    if (previousItem < 0) {
      if (props.centerMode && props.centerSlidePercentage && props.axis === 'horizontal') {
        returnStyles.itemListStyle = (0, _utils.setPosition)(-(lastPosition + 2) * props.centerSlidePercentage - (100 - props.centerSlidePercentage) / 2, props.axis);
      } else {
        returnStyles.itemListStyle = (0, _utils.setPosition)(-(lastPosition + 2) * 100, props.axis);
      }
    } else if (previousItem > lastPosition) {
      returnStyles.itemListStyle = (0, _utils.setPosition)(0, props.axis);
    }

    return returnStyles;
  }

  var currentPosition = (0, _utils.getPosition)(selectedItem, props); // if 3d is available, let's take advantage of the performance of transform

  var transformProp = (0, _CSSTranslate.default)(currentPosition, '%', props.axis);
  var transitionTime = props.transitionTime + 'ms';
  returnStyles.itemListStyle = {
    WebkitTransform: transformProp,
    msTransform: transformProp,
    OTransform: transformProp,
    transform: transformProp
  };

  if (!state.swiping) {
    returnStyles.itemListStyle = _objectSpread(_objectSpread({}, returnStyles.itemListStyle), {}, {
      WebkitTransitionDuration: transitionTime,
      MozTransitionDuration: transitionTime,
      OTransitionDuration: transitionTime,
      transitionDuration: transitionTime,
      msTransitionDuration: transitionTime
    });
  }

  return returnStyles;
};
/**
 * Swiping animation handler for the default 'sliding' style animation
 * @param delta
 * @param props
 * @param state
 * @param setState
 */


exports.slideAnimationHandler = slideAnimationHandler;

var slideSwipeAnimationHandler = function slideSwipeAnimationHandler(delta, props, state, setState) {
  var returnStyles = {};
  var isHorizontal = props.axis === 'horizontal';

  var childrenLength = _react.Children.count(props.children);

  var initialBoundry = 0;
  var currentPosition = (0, _utils.getPosition)(state.selectedItem, props);
  var finalBoundry = props.infiniteLoop ? (0, _utils.getPosition)(childrenLength - 1, props) - 100 : (0, _utils.getPosition)(childrenLength - 1, props);
  var axisDelta = isHorizontal ? delta.x : delta.y;
  var handledDelta = axisDelta; // prevent user from swiping left out of boundaries

  if (currentPosition === initialBoundry && axisDelta > 0) {
    handledDelta = 0;
  } // prevent user from swiping right out of boundaries


  if (currentPosition === finalBoundry && axisDelta < 0) {
    handledDelta = 0;
  }

  var position = currentPosition + 100 / (state.itemSize / handledDelta);
  var hasMoved = Math.abs(axisDelta) > props.swipeScrollTolerance;

  if (props.infiniteLoop && hasMoved) {
    // When allowing infinite loop, if we slide left from position 0 we reveal the cloned last slide that appears before it
    // if we slide even further we need to jump to other side so it can continue - and vice versa for the last slide
    if (state.selectedItem === 0 && position > -100) {
      position -= childrenLength * 100;
    } else if (state.selectedItem === childrenLength - 1 && position < -childrenLength * 100) {
      position += childrenLength * 100;
    }
  }

  if (!props.preventMovementUntilSwipeScrollTolerance || hasMoved || state.swipeMovementStarted) {
    if (!state.swipeMovementStarted) {
      setState({
        swipeMovementStarted: true
      });
    }

    returnStyles.itemListStyle = (0, _utils.setPosition)(position, props.axis);
  } //allows scroll if the swipe was within the tolerance


  if (hasMoved && !state.cancelClick) {
    setState({
      cancelClick: true
    });
  }

  return returnStyles;
};
/**
 * Default 'sliding' style animination handler for when a swipe action stops.
 * @param props
 * @param state
 */


exports.slideSwipeAnimationHandler = slideSwipeAnimationHandler;

var slideStopSwipingHandler = function slideStopSwipingHandler(props, state) {
  var currentPosition = (0, _utils.getPosition)(state.selectedItem, props);
  var itemListStyle = (0, _utils.setPosition)(currentPosition, props.axis);
  return {
    itemListStyle: itemListStyle
  };
};
/**
 * Main animation handler for the default 'fade' style animation
 * @param props
 * @param state
 */


exports.slideStopSwipingHandler = slideStopSwipingHandler;

var fadeAnimationHandler = function fadeAnimationHandler(props, state) {
  var transitionTime = props.transitionTime + 'ms';
  var transitionTimingFunction = 'ease-in-out';
  var slideStyle = {
    position: 'absolute',
    display: 'block',
    zIndex: -2,
    minHeight: '100%',
    opacity: 0,
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    transitionTimingFunction: transitionTimingFunction,
    msTransitionTimingFunction: transitionTimingFunction,
    MozTransitionTimingFunction: transitionTimingFunction,
    WebkitTransitionTimingFunction: transitionTimingFunction,
    OTransitionTimingFunction: transitionTimingFunction
  };

  if (!state.swiping) {
    slideStyle = _objectSpread(_objectSpread({}, slideStyle), {}, {
      WebkitTransitionDuration: transitionTime,
      MozTransitionDuration: transitionTime,
      OTransitionDuration: transitionTime,
      transitionDuration: transitionTime,
      msTransitionDuration: transitionTime
    });
  }

  return {
    slideStyle: slideStyle,
    selectedStyle: _objectSpread(_objectSpread({}, slideStyle), {}, {
      opacity: 1,
      position: 'relative'
    }),
    prevStyle: _objectSpread({}, slideStyle)
  };
};

exports.fadeAnimationHandler = fadeAnimationHandler;

/***/ }),

/***/ 68:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(7378));

var _reactEasySwipe = _interopRequireDefault(__webpack_require__(962));

var _cssClasses = _interopRequireDefault(__webpack_require__(9187));

var _Thumbs = _interopRequireDefault(__webpack_require__(4818));

var _document = _interopRequireDefault(__webpack_require__(5621));

var _window = _interopRequireDefault(__webpack_require__(6106));

var _utils = __webpack_require__(2341);

var _animations = __webpack_require__(5820);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Carousel = /*#__PURE__*/function (_React$Component) {
  _inherits(Carousel, _React$Component);

  var _super = _createSuper(Carousel);

  // @ts-ignore
  function Carousel(props) {
    var _this;

    _classCallCheck(this, Carousel);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "thumbsRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "carouselWrapperRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "listRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "itemsRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "timer", void 0);

    _defineProperty(_assertThisInitialized(_this), "animationHandler", void 0);

    _defineProperty(_assertThisInitialized(_this), "setThumbsRef", function (node) {
      _this.thumbsRef = node;
    });

    _defineProperty(_assertThisInitialized(_this), "setCarouselWrapperRef", function (node) {
      _this.carouselWrapperRef = node;
    });

    _defineProperty(_assertThisInitialized(_this), "setListRef", function (node) {
      _this.listRef = node;
    });

    _defineProperty(_assertThisInitialized(_this), "setItemsRef", function (node, index) {
      if (!_this.itemsRef) {
        _this.itemsRef = [];
      }

      _this.itemsRef[index] = node;
    });

    _defineProperty(_assertThisInitialized(_this), "autoPlay", function () {
      if (_react.Children.count(_this.props.children) <= 1) {
        return;
      }

      _this.clearAutoPlay();

      if (!_this.props.autoPlay) {
        return;
      }

      _this.timer = setTimeout(function () {
        _this.increment();
      }, _this.props.interval);
    });

    _defineProperty(_assertThisInitialized(_this), "clearAutoPlay", function () {
      if (_this.timer) clearTimeout(_this.timer);
    });

    _defineProperty(_assertThisInitialized(_this), "resetAutoPlay", function () {
      _this.clearAutoPlay();

      _this.autoPlay();
    });

    _defineProperty(_assertThisInitialized(_this), "stopOnHover", function () {
      _this.setState({
        isMouseEntered: true
      }, _this.clearAutoPlay);
    });

    _defineProperty(_assertThisInitialized(_this), "startOnLeave", function () {
      _this.setState({
        isMouseEntered: false
      }, _this.autoPlay);
    });

    _defineProperty(_assertThisInitialized(_this), "isFocusWithinTheCarousel", function () {
      if (!_this.carouselWrapperRef) {
        return false;
      }

      if ((0, _document.default)().activeElement === _this.carouselWrapperRef || _this.carouselWrapperRef.contains((0, _document.default)().activeElement)) {
        return true;
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "navigateWithKeyboard", function (e) {
      if (!_this.isFocusWithinTheCarousel()) {
        return;
      }

      var axis = _this.props.axis;
      var isHorizontal = axis === 'horizontal';
      var keyNames = {
        ArrowUp: 38,
        ArrowRight: 39,
        ArrowDown: 40,
        ArrowLeft: 37
      };
      var nextKey = isHorizontal ? keyNames.ArrowRight : keyNames.ArrowDown;
      var prevKey = isHorizontal ? keyNames.ArrowLeft : keyNames.ArrowUp;

      if (nextKey === e.keyCode) {
        _this.increment();
      } else if (prevKey === e.keyCode) {
        _this.decrement();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "updateSizes", function () {
      if (!_this.state.initialized || !_this.itemsRef || _this.itemsRef.length === 0) {
        return;
      }

      var isHorizontal = _this.props.axis === 'horizontal';
      var firstItem = _this.itemsRef[0];

      if (!firstItem) {
        return;
      }

      var itemSize = isHorizontal ? firstItem.clientWidth : firstItem.clientHeight;

      _this.setState({
        itemSize: itemSize
      });

      if (_this.thumbsRef) {
        _this.thumbsRef.updateSizes();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setMountState", function () {
      _this.setState({
        hasMount: true
      });

      _this.updateSizes();
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickItem", function (index, item) {
      if (_react.Children.count(_this.props.children) === 0) {
        return;
      }

      if (_this.state.cancelClick) {
        _this.setState({
          cancelClick: false
        });

        return;
      }

      _this.props.onClickItem(index, item);

      if (index !== _this.state.selectedItem) {
        _this.setState({
          selectedItem: index
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (index, item) {
      if (_react.Children.count(_this.props.children) <= 1) {
        return;
      }

      _this.props.onChange(index, item);
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickThumb", function (index, item) {
      _this.props.onClickThumb(index, item);

      _this.moveTo(index);
    });

    _defineProperty(_assertThisInitialized(_this), "onSwipeStart", function (event) {
      _this.setState({
        swiping: true
      });

      _this.props.onSwipeStart(event);
    });

    _defineProperty(_assertThisInitialized(_this), "onSwipeEnd", function (event) {
      _this.setState({
        swiping: false,
        cancelClick: false,
        swipeMovementStarted: false
      });

      _this.props.onSwipeEnd(event);

      _this.clearAutoPlay();

      if (_this.state.autoPlay) {
        _this.autoPlay();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSwipeMove", function (delta, event) {
      _this.props.onSwipeMove(event);

      var animationHandlerResponse = _this.props.swipeAnimationHandler(delta, _this.props, _this.state, _this.setState.bind(_assertThisInitialized(_this)));

      _this.setState(_objectSpread({}, animationHandlerResponse)); // If we have not moved, we should have an empty object returned
      // Return false to allow scrolling when not swiping


      return !!Object.keys(animationHandlerResponse).length;
    });

    _defineProperty(_assertThisInitialized(_this), "decrement", function () {
      var positions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      _this.moveTo(_this.state.selectedItem - (typeof positions === 'number' ? positions : 1));
    });

    _defineProperty(_assertThisInitialized(_this), "increment", function () {
      var positions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      _this.moveTo(_this.state.selectedItem + (typeof positions === 'number' ? positions : 1));
    });

    _defineProperty(_assertThisInitialized(_this), "moveTo", function (position) {
      if (typeof position !== 'number') {
        return;
      }

      var lastPosition = _react.Children.count(_this.props.children) - 1;

      if (position < 0) {
        position = _this.props.infiniteLoop ? lastPosition : 0;
      }

      if (position > lastPosition) {
        position = _this.props.infiniteLoop ? 0 : lastPosition;
      }

      _this.selectItem({
        // if it's not a slider, we don't need to set position here
        selectedItem: position
      }); // don't reset auto play when stop on hover is enabled, doing so will trigger a call to auto play more than once
      // and will result in the interval function not being cleared correctly.


      if (_this.state.autoPlay && _this.state.isMouseEntered === false) {
        _this.resetAutoPlay();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onClickNext", function () {
      _this.increment(1);
    });

    _defineProperty(_assertThisInitialized(_this), "onClickPrev", function () {
      _this.decrement(1);
    });

    _defineProperty(_assertThisInitialized(_this), "onSwipeForward", function () {
      _this.increment(1);

      if (_this.props.emulateTouch) {
        _this.setState({
          cancelClick: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSwipeBackwards", function () {
      _this.decrement(1);

      if (_this.props.emulateTouch) {
        _this.setState({
          cancelClick: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "changeItem", function (newIndex) {
      return function (e) {
        if (!(0, _utils.isKeyboardEvent)(e) || e.key === 'Enter') {
          _this.moveTo(newIndex);
        }
      };
    });

    _defineProperty(_assertThisInitialized(_this), "selectItem", function (state) {
      // Merge in the new state while updating updating previous item
      _this.setState(_objectSpread({
        previousItem: _this.state.selectedItem
      }, state), function () {
        // Run animation handler and update styles based on it
        _this.setState(_this.animationHandler(_this.props, _this.state));
      });

      _this.handleOnChange(state.selectedItem, _react.Children.toArray(_this.props.children)[state.selectedItem]);
    });

    _defineProperty(_assertThisInitialized(_this), "getInitialImage", function () {
      var selectedItem = _this.props.selectedItem;
      var item = _this.itemsRef && _this.itemsRef[selectedItem];
      var images = item && item.getElementsByTagName('img') || [];
      return images[0];
    });

    _defineProperty(_assertThisInitialized(_this), "getVariableItemHeight", function (position) {
      var item = _this.itemsRef && _this.itemsRef[position];

      if (_this.state.hasMount && item && item.children.length) {
        var slideImages = item.children[0].getElementsByTagName('img') || [];

        if (slideImages.length > 0) {
          var image = slideImages[0];

          if (!image.complete) {
            // if the image is still loading, the size won't be available so we trigger a new render after it's done
            var onImageLoad = function onImageLoad() {
              _this.forceUpdate();

              image.removeEventListener('load', onImageLoad);
            };

            image.addEventListener('load', onImageLoad);
          }
        } // try to get img first, if img not there find first display tag


        var displayItem = slideImages[0] || item.children[0];
        var height = displayItem.clientHeight;
        return height > 0 ? height : null;
      }

      return null;
    });

    var initState = {
      initialized: false,
      previousItem: props.selectedItem,
      selectedItem: props.selectedItem,
      hasMount: false,
      isMouseEntered: false,
      autoPlay: props.autoPlay,
      swiping: false,
      swipeMovementStarted: false,
      cancelClick: false,
      itemSize: 1,
      itemListStyle: {},
      slideStyle: {},
      selectedStyle: {},
      prevStyle: {}
    };
    _this.animationHandler = typeof props.animationHandler === 'function' && props.animationHandler || props.animationHandler === 'fade' && _animations.fadeAnimationHandler || _animations.slideAnimationHandler;
    _this.state = _objectSpread(_objectSpread({}, initState), _this.animationHandler(props, initState));
    return _this;
  }

  _createClass(Carousel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.children) {
        return;
      }

      this.setupCarousel();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (!prevProps.children && this.props.children && !this.state.initialized) {
        this.setupCarousel();
      }

      if (!prevProps.autoFocus && this.props.autoFocus) {
        this.forceFocus();
      }

      if (prevState.swiping && !this.state.swiping) {
        // We stopped swiping, ensure we are heading to the new/current slide and not stuck
        this.setState(_objectSpread({}, this.props.stopSwipingHandler(this.props, this.state)));
      }

      if (prevProps.selectedItem !== this.props.selectedItem || prevProps.centerMode !== this.props.centerMode) {
        this.updateSizes();
        this.moveTo(this.props.selectedItem);
      }

      if (prevProps.autoPlay !== this.props.autoPlay) {
        if (this.props.autoPlay) {
          this.setupAutoPlay();
        } else {
          this.destroyAutoPlay();
        }

        this.setState({
          autoPlay: this.props.autoPlay
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.destroyCarousel();
    }
  }, {
    key: "setupCarousel",
    value: function setupCarousel() {
      var _this2 = this;

      this.bindEvents();

      if (this.state.autoPlay && _react.Children.count(this.props.children) > 1) {
        this.setupAutoPlay();
      }

      if (this.props.autoFocus) {
        this.forceFocus();
      }

      this.setState({
        initialized: true
      }, function () {
        var initialImage = _this2.getInitialImage();

        if (initialImage && !initialImage.complete) {
          // if it's a carousel of images, we set the mount state after the first image is loaded
          initialImage.addEventListener('load', _this2.setMountState);
        } else {
          _this2.setMountState();
        }
      });
    }
  }, {
    key: "destroyCarousel",
    value: function destroyCarousel() {
      if (this.state.initialized) {
        this.unbindEvents();
        this.destroyAutoPlay();
      }
    }
  }, {
    key: "setupAutoPlay",
    value: function setupAutoPlay() {
      this.autoPlay();
      var carouselWrapper = this.carouselWrapperRef;

      if (this.props.stopOnHover && carouselWrapper) {
        carouselWrapper.addEventListener('mouseenter', this.stopOnHover);
        carouselWrapper.addEventListener('mouseleave', this.startOnLeave);
      }
    }
  }, {
    key: "destroyAutoPlay",
    value: function destroyAutoPlay() {
      this.clearAutoPlay();
      var carouselWrapper = this.carouselWrapperRef;

      if (this.props.stopOnHover && carouselWrapper) {
        carouselWrapper.removeEventListener('mouseenter', this.stopOnHover);
        carouselWrapper.removeEventListener('mouseleave', this.startOnLeave);
      }
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      // as the widths are calculated, we need to resize
      // the carousel when the window is resized
      (0, _window.default)().addEventListener('resize', this.updateSizes); // issue #2 - image loading smaller

      (0, _window.default)().addEventListener('DOMContentLoaded', this.updateSizes);

      if (this.props.useKeyboardArrows) {
        (0, _document.default)().addEventListener('keydown', this.navigateWithKeyboard);
      }
    }
  }, {
    key: "unbindEvents",
    value: function unbindEvents() {
      // removing listeners
      (0, _window.default)().removeEventListener('resize', this.updateSizes);
      (0, _window.default)().removeEventListener('DOMContentLoaded', this.updateSizes);
      var initialImage = this.getInitialImage();

      if (initialImage) {
        initialImage.removeEventListener('load', this.setMountState);
      }

      if (this.props.useKeyboardArrows) {
        (0, _document.default)().removeEventListener('keydown', this.navigateWithKeyboard);
      }
    }
  }, {
    key: "forceFocus",
    value: function forceFocus() {
      var _this$carouselWrapper;

      (_this$carouselWrapper = this.carouselWrapperRef) === null || _this$carouselWrapper === void 0 ? void 0 : _this$carouselWrapper.focus();
    }
  }, {
    key: "renderItems",
    value: function renderItems(isClone) {
      var _this3 = this;

      if (!this.props.children) {
        return [];
      }

      return _react.Children.map(this.props.children, function (item, index) {
        var isSelected = index === _this3.state.selectedItem;
        var isPrevious = index === _this3.state.previousItem;
        var style = isSelected && _this3.state.selectedStyle || isPrevious && _this3.state.prevStyle || _this3.state.slideStyle || {};

        if (_this3.props.centerMode && _this3.props.axis === 'horizontal') {
          style = _objectSpread(_objectSpread({}, style), {}, {
            minWidth: _this3.props.centerSlidePercentage + '%'
          });
        }

        if (_this3.state.swiping && _this3.state.swipeMovementStarted) {
          style = _objectSpread(_objectSpread({}, style), {}, {
            pointerEvents: 'none'
          });
        }

        var slideProps = {
          ref: function ref(e) {
            return _this3.setItemsRef(e, index);
          },
          key: 'itemKey' + index + (isClone ? 'clone' : ''),
          className: _cssClasses.default.ITEM(true, index === _this3.state.selectedItem, index === _this3.state.previousItem),
          onClick: _this3.handleClickItem.bind(_this3, index, item),
          style: style
        };
        return /*#__PURE__*/_react.default.createElement("li", slideProps, _this3.props.renderItem(item, {
          isSelected: index === _this3.state.selectedItem,
          isPrevious: index === _this3.state.previousItem
        }));
      });
    }
  }, {
    key: "renderControls",
    value: function renderControls() {
      var _this4 = this;

      var _this$props = this.props,
          showIndicators = _this$props.showIndicators,
          labels = _this$props.labels,
          renderIndicator = _this$props.renderIndicator,
          children = _this$props.children;

      if (!showIndicators) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement("ul", {
        className: "control-dots"
      }, _react.Children.map(children, function (_, index) {
        return renderIndicator && renderIndicator(_this4.changeItem(index), index === _this4.state.selectedItem, index, labels.item);
      }));
    }
  }, {
    key: "renderStatus",
    value: function renderStatus() {
      if (!this.props.showStatus) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement("p", {
        className: "carousel-status"
      }, this.props.statusFormatter(this.state.selectedItem + 1, _react.Children.count(this.props.children)));
    }
  }, {
    key: "renderThumbs",
    value: function renderThumbs() {
      if (!this.props.showThumbs || !this.props.children || _react.Children.count(this.props.children) === 0) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement(_Thumbs.default, {
        ref: this.setThumbsRef,
        onSelectItem: this.handleClickThumb,
        selectedItem: this.state.selectedItem,
        transitionTime: this.props.transitionTime,
        thumbWidth: this.props.thumbWidth,
        labels: this.props.labels,
        emulateTouch: this.props.emulateTouch
      }, this.props.renderThumbs(this.props.children));
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      if (!this.props.children || _react.Children.count(this.props.children) === 0) {
        return null;
      }

      var isSwipeable = this.props.swipeable && _react.Children.count(this.props.children) > 1;
      var isHorizontal = this.props.axis === 'horizontal';
      var canShowArrows = this.props.showArrows && _react.Children.count(this.props.children) > 1; // show left arrow?

      var hasPrev = canShowArrows && (this.state.selectedItem > 0 || this.props.infiniteLoop) || false; // show right arrow

      var hasNext = canShowArrows && (this.state.selectedItem < _react.Children.count(this.props.children) - 1 || this.props.infiniteLoop) || false;
      var itemsClone = this.renderItems(true);
      var firstClone = itemsClone.shift();
      var lastClone = itemsClone.pop();
      var swiperProps = {
        className: _cssClasses.default.SLIDER(true, this.state.swiping),
        onSwipeMove: this.onSwipeMove,
        onSwipeStart: this.onSwipeStart,
        onSwipeEnd: this.onSwipeEnd,
        style: this.state.itemListStyle,
        tolerance: this.props.swipeScrollTolerance
      };
      var containerStyles = {};

      if (isHorizontal) {
        swiperProps.onSwipeLeft = this.onSwipeForward;
        swiperProps.onSwipeRight = this.onSwipeBackwards;

        if (this.props.dynamicHeight) {
          var itemHeight = this.getVariableItemHeight(this.state.selectedItem); // swiperProps.style.height = itemHeight || 'auto';

          containerStyles.height = itemHeight || 'auto';
        }
      } else {
        swiperProps.onSwipeUp = this.props.verticalSwipe === 'natural' ? this.onSwipeBackwards : this.onSwipeForward;
        swiperProps.onSwipeDown = this.props.verticalSwipe === 'natural' ? this.onSwipeForward : this.onSwipeBackwards;
        swiperProps.style = _objectSpread(_objectSpread({}, swiperProps.style), {}, {
          height: this.state.itemSize
        });
        containerStyles.height = this.state.itemSize;
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        "aria-label": this.props.ariaLabel,
        className: _cssClasses.default.ROOT(this.props.className),
        ref: this.setCarouselWrapperRef,
        tabIndex: this.props.useKeyboardArrows ? 0 : undefined
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: _cssClasses.default.CAROUSEL(true),
        style: {
          width: this.props.width
        }
      }, this.renderControls(), this.props.renderArrowPrev(this.onClickPrev, hasPrev, this.props.labels.leftArrow), /*#__PURE__*/_react.default.createElement("div", {
        className: _cssClasses.default.WRAPPER(true, this.props.axis),
        style: containerStyles
      }, isSwipeable ? /*#__PURE__*/_react.default.createElement(_reactEasySwipe.default, _extends({
        tagName: "ul",
        innerRef: this.setListRef
      }, swiperProps, {
        allowMouseEvents: this.props.emulateTouch
      }), this.props.infiniteLoop && lastClone, this.renderItems(), this.props.infiniteLoop && firstClone) : /*#__PURE__*/_react.default.createElement("ul", {
        className: _cssClasses.default.SLIDER(true, this.state.swiping),
        ref: function ref(node) {
          return _this5.setListRef(node);
        },
        style: this.state.itemListStyle || {}
      }, this.props.infiniteLoop && lastClone, this.renderItems(), this.props.infiniteLoop && firstClone)), this.props.renderArrowNext(this.onClickNext, hasNext, this.props.labels.rightArrow), this.renderStatus()), this.renderThumbs());
    }
  }]);

  return Carousel;
}(_react.default.Component);

exports["default"] = Carousel;

_defineProperty(Carousel, "displayName", 'Carousel');

_defineProperty(Carousel, "defaultProps", {
  ariaLabel: undefined,
  axis: 'horizontal',
  centerSlidePercentage: 80,
  interval: 3000,
  labels: {
    leftArrow: 'previous slide / item',
    rightArrow: 'next slide / item',
    item: 'slide item'
  },
  onClickItem: _utils.noop,
  onClickThumb: _utils.noop,
  onChange: _utils.noop,
  onSwipeStart: function onSwipeStart() {},
  onSwipeEnd: function onSwipeEnd() {},
  onSwipeMove: function onSwipeMove() {
    return false;
  },
  preventMovementUntilSwipeScrollTolerance: false,
  renderArrowPrev: function renderArrowPrev(onClickHandler, hasPrev, label) {
    return /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      "aria-label": label,
      className: _cssClasses.default.ARROW_PREV(!hasPrev),
      onClick: onClickHandler
    });
  },
  renderArrowNext: function renderArrowNext(onClickHandler, hasNext, label) {
    return /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      "aria-label": label,
      className: _cssClasses.default.ARROW_NEXT(!hasNext),
      onClick: onClickHandler
    });
  },
  renderIndicator: function renderIndicator(onClickHandler, isSelected, index, label) {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: _cssClasses.default.DOT(isSelected),
      onClick: onClickHandler,
      onKeyDown: onClickHandler,
      value: index,
      key: index,
      role: "button",
      tabIndex: 0,
      "aria-label": "".concat(label, " ").concat(index + 1)
    });
  },
  renderItem: function renderItem(item) {
    return item;
  },
  renderThumbs: function renderThumbs(children) {
    var images = _react.Children.map(children, function (item) {
      var img = item; // if the item is not an image, try to find the first image in the item's children.

      if (item.type !== 'img') {
        img = _react.Children.toArray(item.props.children).find(function (children) {
          return children.type === 'img';
        });
      }

      if (!img) {
        return undefined;
      }

      return img;
    });

    if (images.filter(function (image) {
      return image;
    }).length === 0) {
      console.warn("No images found! Can't build the thumb list without images. If you don't need thumbs, set showThumbs={false} in the Carousel. Note that it's not possible to get images rendered inside custom components. More info at https://github.com/leandrowd/react-responsive-carousel/blob/master/TROUBLESHOOTING.md");
      return [];
    }

    return images;
  },
  statusFormatter: _utils.defaultStatusFormatter,
  selectedItem: 0,
  showArrows: true,
  showIndicators: true,
  showStatus: true,
  showThumbs: true,
  stopOnHover: true,
  swipeScrollTolerance: 5,
  swipeable: true,
  transitionTime: 350,
  verticalSwipe: 'standard',
  width: '100%',
  animationHandler: 'slide',
  swipeAnimationHandler: _animations.slideSwipeAnimationHandler,
  stopSwipingHandler: _animations.slideStopSwipingHandler
});

/***/ }),

/***/ 1945:
/***/ (function() {

"use strict";


/***/ }),

/***/ 2341:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.setPosition = exports.getPosition = exports.isKeyboardEvent = exports.defaultStatusFormatter = exports.noop = void 0;

var _react = __webpack_require__(7378);

var _CSSTranslate = _interopRequireDefault(__webpack_require__(3563));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noop = function noop() {};

exports.noop = noop;

var defaultStatusFormatter = function defaultStatusFormatter(current, total) {
  return "".concat(current, " of ").concat(total);
};

exports.defaultStatusFormatter = defaultStatusFormatter;

var isKeyboardEvent = function isKeyboardEvent(e) {
  return e ? e.hasOwnProperty('key') : false;
};
/**
 * Gets the list 'position' relative to a current index
 * @param index
 */


exports.isKeyboardEvent = isKeyboardEvent;

var getPosition = function getPosition(index, props) {
  if (props.infiniteLoop) {
    // index has to be added by 1 because of the first cloned slide
    ++index;
  }

  if (index === 0) {
    return 0;
  }

  var childrenLength = _react.Children.count(props.children);

  if (props.centerMode && props.axis === 'horizontal') {
    var currentPosition = -index * props.centerSlidePercentage;
    var lastPosition = childrenLength - 1;

    if (index && (index !== lastPosition || props.infiniteLoop)) {
      currentPosition += (100 - props.centerSlidePercentage) / 2;
    } else if (index === lastPosition) {
      currentPosition += 100 - props.centerSlidePercentage;
    }

    return currentPosition;
  }

  return -index * 100;
};
/**
 * Sets the 'position' transform for sliding animations
 * @param position
 * @param forceReflow
 */


exports.getPosition = getPosition;

var setPosition = function setPosition(position, axis) {
  var style = {};
  ['WebkitTransform', 'MozTransform', 'MsTransform', 'OTransform', 'transform', 'msTransform'].forEach(function (prop) {
    // @ts-ignore
    style[prop] = (0, _CSSTranslate.default)(position, '%', axis);
  });
  return style;
};

exports.setPosition = setPosition;

/***/ }),

/***/ 4818:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(7378));

var _cssClasses = _interopRequireDefault(__webpack_require__(9187));

var _dimensions = __webpack_require__(9571);

var _CSSTranslate = _interopRequireDefault(__webpack_require__(3563));

var _reactEasySwipe = _interopRequireDefault(__webpack_require__(962));

var _window = _interopRequireDefault(__webpack_require__(6106));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var isKeyboardEvent = function isKeyboardEvent(e) {
  return e.hasOwnProperty('key');
};

var Thumbs = /*#__PURE__*/function (_Component) {
  _inherits(Thumbs, _Component);

  var _super = _createSuper(Thumbs);

  function Thumbs(_props) {
    var _this;

    _classCallCheck(this, Thumbs);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "itemsWrapperRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "itemsListRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "thumbsRef", void 0);

    _defineProperty(_assertThisInitialized(_this), "setItemsWrapperRef", function (node) {
      _this.itemsWrapperRef = node;
    });

    _defineProperty(_assertThisInitialized(_this), "setItemsListRef", function (node) {
      _this.itemsListRef = node;
    });

    _defineProperty(_assertThisInitialized(_this), "setThumbsRef", function (node, index) {
      if (!_this.thumbsRef) {
        _this.thumbsRef = [];
      }

      _this.thumbsRef[index] = node;
    });

    _defineProperty(_assertThisInitialized(_this), "updateSizes", function () {
      if (!_this.props.children || !_this.itemsWrapperRef || !_this.thumbsRef) {
        return;
      }

      var total = _react.Children.count(_this.props.children);

      var wrapperSize = _this.itemsWrapperRef.clientWidth;
      var itemSize = _this.props.thumbWidth ? _this.props.thumbWidth : (0, _dimensions.outerWidth)(_this.thumbsRef[0]);
      var visibleItems = Math.floor(wrapperSize / itemSize);
      var showArrows = visibleItems < total;
      var lastPosition = showArrows ? total - visibleItems : 0;

      _this.setState(function (_state, props) {
        return {
          itemSize: itemSize,
          visibleItems: visibleItems,
          firstItem: showArrows ? _this.getFirstItem(props.selectedItem) : 0,
          lastPosition: lastPosition,
          showArrows: showArrows
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickItem", function (index, item, e) {
      if (!isKeyboardEvent(e) || e.key === 'Enter') {
        var handler = _this.props.onSelectItem;

        if (typeof handler === 'function') {
          handler(index, item);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSwipeStart", function () {
      _this.setState({
        swiping: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSwipeEnd", function () {
      _this.setState({
        swiping: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSwipeMove", function (delta) {
      var deltaX = delta.x;

      if (!_this.state.itemSize || !_this.itemsWrapperRef || !_this.state.visibleItems) {
        return false;
      }

      var leftBoundary = 0;

      var childrenLength = _react.Children.count(_this.props.children);

      var currentPosition = -(_this.state.firstItem * 100) / _this.state.visibleItems;
      var lastLeftItem = Math.max(childrenLength - _this.state.visibleItems, 0);
      var lastLeftBoundary = -lastLeftItem * 100 / _this.state.visibleItems; // prevent user from swiping left out of boundaries

      if (currentPosition === leftBoundary && deltaX > 0) {
        deltaX = 0;
      } // prevent user from swiping right out of boundaries


      if (currentPosition === lastLeftBoundary && deltaX < 0) {
        deltaX = 0;
      }

      var wrapperSize = _this.itemsWrapperRef.clientWidth;
      var position = currentPosition + 100 / (wrapperSize / deltaX); // if 3d isn't available we will use left to move

      if (_this.itemsListRef) {
        ['WebkitTransform', 'MozTransform', 'MsTransform', 'OTransform', 'transform', 'msTransform'].forEach(function (prop) {
          _this.itemsListRef.style[prop] = (0, _CSSTranslate.default)(position, '%', _this.props.axis);
        });
      }

      return true;
    });

    _defineProperty(_assertThisInitialized(_this), "slideRight", function (positions) {
      _this.moveTo(_this.state.firstItem - (typeof positions === 'number' ? positions : 1));
    });

    _defineProperty(_assertThisInitialized(_this), "slideLeft", function (positions) {
      _this.moveTo(_this.state.firstItem + (typeof positions === 'number' ? positions : 1));
    });

    _defineProperty(_assertThisInitialized(_this), "moveTo", function (position) {
      // position can't be lower than 0
      position = position < 0 ? 0 : position; // position can't be higher than last postion

      position = position >= _this.state.lastPosition ? _this.state.lastPosition : position;

      _this.setState({
        firstItem: position
      });
    });

    _this.state = {
      selectedItem: _props.selectedItem,
      swiping: false,
      showArrows: false,
      firstItem: 0,
      visibleItems: 0,
      lastPosition: 0
    };
    return _this;
  }

  _createClass(Thumbs, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setupThumbs();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.selectedItem !== this.state.selectedItem) {
        this.setState({
          selectedItem: this.props.selectedItem,
          firstItem: this.getFirstItem(this.props.selectedItem)
        });
      }

      if (this.props.children === prevProps.children) {
        return;
      } // This will capture any size changes for arrow adjustments etc.
      // usually in the same render cycle so we don't see any flickers


      this.updateSizes();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.destroyThumbs();
    }
  }, {
    key: "setupThumbs",
    value: function setupThumbs() {
      // as the widths are calculated, we need to resize
      // the carousel when the window is resized
      (0, _window.default)().addEventListener('resize', this.updateSizes); // issue #2 - image loading smaller

      (0, _window.default)().addEventListener('DOMContentLoaded', this.updateSizes); // when the component is rendered we need to calculate
      // the container size to adjust the responsive behaviour

      this.updateSizes();
    }
  }, {
    key: "destroyThumbs",
    value: function destroyThumbs() {
      // removing listeners
      (0, _window.default)().removeEventListener('resize', this.updateSizes);
      (0, _window.default)().removeEventListener('DOMContentLoaded', this.updateSizes);
    }
  }, {
    key: "getFirstItem",
    value: function getFirstItem(selectedItem) {
      var firstItem = selectedItem;

      if (selectedItem >= this.state.lastPosition) {
        firstItem = this.state.lastPosition;
      }

      if (selectedItem < this.state.firstItem + this.state.visibleItems) {
        firstItem = this.state.firstItem;
      }

      if (selectedItem < this.state.firstItem) {
        firstItem = selectedItem;
      }

      return firstItem;
    }
  }, {
    key: "renderItems",
    value: function renderItems() {
      var _this2 = this;

      return this.props.children.map(function (img, index) {
        var itemClass = _cssClasses.default.ITEM(false, index === _this2.state.selectedItem);

        var thumbProps = {
          key: index,
          ref: function ref(e) {
            return _this2.setThumbsRef(e, index);
          },
          className: itemClass,
          onClick: _this2.handleClickItem.bind(_this2, index, _this2.props.children[index]),
          onKeyDown: _this2.handleClickItem.bind(_this2, index, _this2.props.children[index]),
          'aria-label': "".concat(_this2.props.labels.item, " ").concat(index + 1),
          style: {
            width: _this2.props.thumbWidth
          }
        };
        return /*#__PURE__*/_react.default.createElement("li", _extends({}, thumbProps, {
          role: "button",
          tabIndex: 0
        }), img);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      if (!this.props.children) {
        return null;
      }

      var isSwipeable = _react.Children.count(this.props.children) > 1; // show left arrow?

      var hasPrev = this.state.showArrows && this.state.firstItem > 0; // show right arrow

      var hasNext = this.state.showArrows && this.state.firstItem < this.state.lastPosition; // obj to hold the transformations and styles

      var itemListStyles = {};
      var currentPosition = -this.state.firstItem * (this.state.itemSize || 0);
      var transformProp = (0, _CSSTranslate.default)(currentPosition, 'px', this.props.axis);
      var transitionTime = this.props.transitionTime + 'ms';
      itemListStyles = {
        WebkitTransform: transformProp,
        MozTransform: transformProp,
        MsTransform: transformProp,
        OTransform: transformProp,
        transform: transformProp,
        msTransform: transformProp,
        WebkitTransitionDuration: transitionTime,
        MozTransitionDuration: transitionTime,
        MsTransitionDuration: transitionTime,
        OTransitionDuration: transitionTime,
        transitionDuration: transitionTime,
        msTransitionDuration: transitionTime
      };
      return /*#__PURE__*/_react.default.createElement("div", {
        className: _cssClasses.default.CAROUSEL(false)
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: _cssClasses.default.WRAPPER(false),
        ref: this.setItemsWrapperRef
      }, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: _cssClasses.default.ARROW_PREV(!hasPrev),
        onClick: function onClick() {
          return _this3.slideRight();
        },
        "aria-label": this.props.labels.leftArrow
      }), isSwipeable ? /*#__PURE__*/_react.default.createElement(_reactEasySwipe.default, {
        tagName: "ul",
        className: _cssClasses.default.SLIDER(false, this.state.swiping),
        onSwipeLeft: this.slideLeft,
        onSwipeRight: this.slideRight,
        onSwipeMove: this.onSwipeMove,
        onSwipeStart: this.onSwipeStart,
        onSwipeEnd: this.onSwipeEnd,
        style: itemListStyles,
        innerRef: this.setItemsListRef,
        allowMouseEvents: this.props.emulateTouch
      }, this.renderItems()) : /*#__PURE__*/_react.default.createElement("ul", {
        className: _cssClasses.default.SLIDER(false, this.state.swiping),
        ref: function ref(node) {
          return _this3.setItemsListRef(node);
        },
        style: itemListStyles
      }, this.renderItems()), /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: _cssClasses.default.ARROW_NEXT(!hasNext),
        onClick: function onClick() {
          return _this3.slideLeft();
        },
        "aria-label": this.props.labels.rightArrow
      })));
    }
  }]);

  return Thumbs;
}(_react.Component);

exports["default"] = Thumbs;

_defineProperty(Thumbs, "displayName", 'Thumbs');

_defineProperty(Thumbs, "defaultProps", {
  axis: 'horizontal',
  labels: {
    leftArrow: 'previous slide / item',
    rightArrow: 'next slide / item',
    item: 'slide item'
  },
  selectedItem: 0,
  thumbWidth: 80,
  transitionTime: 350
});

/***/ }),

/***/ 9187:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _classnames = _interopRequireDefault(__webpack_require__(5));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = {
  ROOT: function ROOT(customClassName) {
    return (0, _classnames.default)(_defineProperty({
      'carousel-root': true
    }, customClassName || '', !!customClassName));
  },
  CAROUSEL: function CAROUSEL(isSlider) {
    return (0, _classnames.default)({
      carousel: true,
      'carousel-slider': isSlider
    });
  },
  WRAPPER: function WRAPPER(isSlider, axis) {
    return (0, _classnames.default)({
      'thumbs-wrapper': !isSlider,
      'slider-wrapper': isSlider,
      'axis-horizontal': axis === 'horizontal',
      'axis-vertical': axis !== 'horizontal'
    });
  },
  SLIDER: function SLIDER(isSlider, isSwiping) {
    return (0, _classnames.default)({
      thumbs: !isSlider,
      slider: isSlider,
      animated: !isSwiping
    });
  },
  ITEM: function ITEM(isSlider, selected, previous) {
    return (0, _classnames.default)({
      thumb: !isSlider,
      slide: isSlider,
      selected: selected,
      previous: previous
    });
  },
  ARROW_PREV: function ARROW_PREV(disabled) {
    return (0, _classnames.default)({
      'control-arrow control-prev': true,
      'control-disabled': disabled
    });
  },
  ARROW_NEXT: function ARROW_NEXT(disabled) {
    return (0, _classnames.default)({
      'control-arrow control-next': true,
      'control-disabled': disabled
    });
  },
  DOT: function DOT(selected) {
    return (0, _classnames.default)({
      dot: true,
      selected: selected
    });
  }
};
exports["default"] = _default;

/***/ }),

/***/ 9571:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.outerWidth = void 0;

var outerWidth = function outerWidth(el) {
  var width = el.offsetWidth;
  var style = getComputedStyle(el);
  width += parseInt(style.marginLeft) + parseInt(style.marginRight);
  return width;
};

exports.outerWidth = outerWidth;

/***/ }),

/***/ 4837:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
Object.defineProperty(exports, "lr", ({
  enumerable: true,
  get: function get() {
    return _Carousel.default;
  }
}));
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _types.CarouselProps;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _Thumbs.default;
  }
});

var _Carousel = _interopRequireDefault(__webpack_require__(68));

var _types = __webpack_require__(1945);

var _Thumbs = _interopRequireDefault(__webpack_require__(4818));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 5621:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _default = function _default() {
  return document;
};

exports["default"] = _default;

/***/ }),

/***/ 6106:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _default = function _default() {
  return window;
};

exports["default"] = _default;

/***/ }),

/***/ 434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "DEFAULT_LOADER": function() { return /* reexport */ DEFAULT_LOADER; },
  "ERRORS_STACK_SIZE": function() { return /* reexport */ ERRORS_STACK_SIZE; },
  "RecoilDevTools": function() { return /* reexport */ RecoilDevTools; },
  "RecoilReduxBridge": function() { return /* reexport */ RecoilReduxBridge; },
  "RecoilTunnel": function() { return /* reexport */ RecoilTunnel; },
  "TaskStatus": function() { return /* reexport */ TaskStatus; },
  "addCancelSignal": function() { return /* reexport */ addCancelSignal; },
  "and": function() { return /* reexport */ and; },
  "dec": function() { return /* reexport */ dec; },
  "decAbs": function() { return /* reexport */ decAbs; },
  "delay": function() { return /* reexport */ delay; },
  "doCancelSignal": function() { return /* reexport */ doCancelSignal; },
  "errorStack": function() { return /* reexport */ errors_errorStack; },
  "filter": function() { return /* reexport */ filter; },
  "getFetchSignal": function() { return /* reexport */ getFetchSignal; },
  "getRecoilStore": function() { return /* reexport */ getRecoilStore; },
  "hide": function() { return /* reexport */ hide; },
  "inc": function() { return /* reexport */ inc; },
  "isLoading": function() { return /* reexport */ isLoading; },
  "lastError": function() { return /* reexport */ lastError; },
  "lastErrorType": function() { return /* reexport */ lastErrorType; },
  "lastTaskByKey": function() { return /* reexport */ lastTaskByKey; },
  "loader": function() { return /* reexport */ loader; },
  "not": function() { return /* reexport */ not; },
  "or": function() { return /* reexport */ or; },
  "push": function() { return /* reexport */ push; },
  "pushError": function() { return /* reexport */ pushError; },
  "pushTask": function() { return /* reexport */ pushTask; },
  "pushTop": function() { return /* reexport */ pushTop; },
  "reduxSelector": function() { return /* reexport */ reduxSelector; },
  "reduxState": function() { return /* reexport */ reduxState; },
  "removeObj": function() { return /* reexport */ removeObj; },
  "reverse": function() { return /* reexport */ reverse; },
  "runningTasks": function() { return /* reexport */ runningTasks; },
  "set": function() { return /* reexport */ set; },
  "show": function() { return /* reexport */ show; },
  "taskById": function() { return /* reexport */ taskById; },
  "tasks": function() { return /* reexport */ tasks; },
  "toggle": function() { return /* reexport */ toggle; },
  "uniqueId": function() { return /* reexport */ uniqueId; },
  "unshift": function() { return /* reexport */ unshift; },
  "updateObj": function() { return /* reexport */ updateObj; },
  "updateTaskDone": function() { return /* reexport */ updateTaskDone; },
  "updateTaskError": function() { return /* reexport */ updateTaskError; },
  "useDispatch": function() { return /* reexport */ useDispatch; },
  "useIsLoading": function() { return /* reexport */ useIsLoading; },
  "useLastError": function() { return /* reexport */ useLastError; },
  "useMountedRef": function() { return /* reexport */ useMountedRef; },
  "useRecoilCurrentGetLoadable": function() { return /* reexport */ useRecoilCurrentGetLoadable; },
  "useRecoilCurrentGetPromise": function() { return /* reexport */ useRecoilCurrentGetPromise; },
  "useRecoilCurrentRefresh": function() { return /* reexport */ useRecoilCurrentRefresh; },
  "useRecoilCurrentReset": function() { return /* reexport */ useRecoilCurrentReset; },
  "useRecoilCurrentSet": function() { return /* reexport */ useRecoilCurrentSet; },
  "useRecoilCurrentSnapshot": function() { return /* reexport */ useRecoilCurrentSnapshot; },
  "useRecoilQuery": function() { return /* reexport */ useRecoilQuery; },
  "useRecoilRequest": function() { return /* reexport */ useRecoilRequest; },
  "useRecoilTask": function() { return /* reexport */ useRecoilTask; },
  "useResetErrors": function() { return /* reexport */ useResetErrors; },
  "useRunningTasks": function() { return /* reexport */ useRunningTasks; },
  "useSelector": function() { return /* reexport */ useSelector; }
});

;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/helpers/delay.js
const delay = (ms) => new Promise(resolve => {
    setTimeout(() => {
        resolve(true);
    }, ms);
});
//# sourceMappingURL=delay.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/helpers/uniqueId.js
let uniqueIdCounter = 0;
function uniqueId() {
    // eslint-disable-next-line no-plusplus
    return ++uniqueIdCounter;
}
//# sourceMappingURL=uniqueId.js.map
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/helpers/useMountedRef.js

function useMountedRef() {
    const mounted = (0,react.useRef)(true);
    (0,react.useEffect)(() => () => {
        mounted.current = false;
    }, []);
    return mounted;
}
//# sourceMappingURL=useMountedRef.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/helpers/index.js



//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../node_modules/recoil/es/index.js
var es = __webpack_require__(9853);
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/updaters/number.js
const inc = (s) => s + 1;
const dec = (s) => s - 1;
const decAbs = (s) => (s > 0 ? s - 1 : 0);
// alias
const show = inc;
const hide = decAbs;
//# sourceMappingURL=number.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/hooks/useRecoilRequest.js



const useRecoilRequest = (request) => {
    const setRequestId = (0,es.useSetRecoilState)(request);
    return (0,react.useCallback)(() => {
        setRequestId(inc);
    }, [setRequestId]);
};
//# sourceMappingURL=useRecoilRequest.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/hooks/recoilStore.js

const useRecoilCurrentGetPromise = () => (0,es.useRecoilCallback)(({ snapshot: { getPromise } }) => getPromise, []);
const useRecoilCurrentGetLoadable = () => (0,es.useRecoilCallback)(({ snapshot: { getLoadable } }) => getLoadable, []);
const useRecoilCurrentSnapshot = () => (0,es.useRecoilCallback)(({ snapshot }) => () => snapshot, []);
const useRecoilCurrentSet = () => (0,es.useRecoilCallback)(({ set }) => set, []);
const useRecoilCurrentReset = () => (0,es.useRecoilCallback)(({ reset }) => reset, []);
const useRecoilCurrentRefresh = () => (0,es.useRecoilCallback)(({ refresh }) => refresh, []);
//# sourceMappingURL=recoilStore.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/hooks/signals/store.js
let instanceId = 0;
function getInstanceId() {
    instanceId += 1;
    return instanceId;
}
const signalStore = {};
function addCancelSignal(key, signal) {
    if (!signalStore[key]) {
        signalStore[key] = {};
    }
    signalStore[key][getInstanceId()] = signal;
}
function doCancelSignal(key) {
    if (signalStore[key]) {
        Object.values(signalStore[key]).forEach(abortsignal => {
            try {
                abortsignal.cancel();
            }
            catch (_a) {
                // ignore
            }
        });
        signalStore[key] = {};
    }
}
//# sourceMappingURL=store.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/hooks/signals/fetch.js

function getFetchSignal(key) {
    const newAbortController = new AbortController();
    addCancelSignal(key, {
        signal: newAbortController.signal,
        cancel: () => {
            newAbortController.abort();
        },
    });
    return newAbortController.signal;
}
//# sourceMappingURL=fetch.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/hooks/signals/index.js


//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/hooks/useRecoilQuery.js



//todo freeze options object
const useRecoilQuery = (selector, options) => {
    const { state, contents } = (0,es.useRecoilValueLoadable)(selector);
    const loading = state === 'loading';
    const error = state === 'hasError' ? contents : undefined;
    const data = (state === 'hasValue' ? contents : undefined);
    const lastData = (0,react.useRef)();
    (0,react.useEffect)(() => {
        if (data !== undefined) {
            lastData.current = data;
        }
    }, [data]);
    const refresh = (0,es.useRecoilRefresher_UNSTABLE)(selector);
    (0,react.useEffect)(() => {
        if ((options === null || options === void 0 ? void 0 : options.refreshOnMount) === 'always' || ((options === null || options === void 0 ? void 0 : options.refreshOnMount) === 'error' && error)) {
            !loading && refresh();
        }
    }, []); //eslint-disable-line
    (0,react.useEffect)(() => () => {
        if ((options === null || options === void 0 ? void 0 : options.cancelOnUnmount) === true) {
            doCancelSignal(selector.key);
        }
        if (typeof (options === null || options === void 0 ? void 0 : options.cancelOnUnmount) === 'function') {
            options === null || options === void 0 ? void 0 : options.cancelOnUnmount();
        }
    }, []);
    return {
        loading,
        data: data !== undefined ? data : lastData.current,
        error,
        refresh,
    };
};
//# sourceMappingURL=useRecoilQuery.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/hooks/index.js




//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/tunnel/getStore.js
const recoilStores = {};
const DEFAULT_STORE = '$defaultStore$';
function set(recoilVal, valOrUpdater) {
    var _a, _b;
    if ((_a = recoilStores[DEFAULT_STORE]) === null || _a === void 0 ? void 0 : _a.set)
        return (_b = recoilStores[DEFAULT_STORE]) === null || _b === void 0 ? void 0 : _b.set(recoilVal, valOrUpdater);
    throw new Error('Recoil Toolkit Tunnel not ready');
}
const pendigGetStorePromises = [];
const flushGetStorePending = (name) => {
    pendigGetStorePromises.forEach(p => {
        if (p.pending && p.name === name) {
            // @ts-ignore
            if (recoilStores[name]) {
                // @ts-ignore
                p.resolve(recoilStores[name]);
            }
            else
                p.reject(new Error('no store found'));
            p.pending = false;
        }
    });
};
function getRecoilStore(name = DEFAULT_STORE) {
    return new Promise((resolve, reject) => {
        if (recoilStores[name]) {
            // @ts-ignore
            resolve(recoilStores[name]);
        }
        else {
            pendigGetStorePromises.push({
                resolve,
                reject,
                name,
                pending: true,
            });
        }
    });
}
//# sourceMappingURL=getStore.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/tunnel/RecoilTunnel.js




const RecoilTunnel = ({ name = DEFAULT_STORE, children, }) => {
    const storeName = (0,react.useRef)(name);
    const getPromise = useRecoilCurrentGetPromise();
    const getLoadable = useRecoilCurrentGetLoadable();
    const set = useRecoilCurrentSet();
    const reset = useRecoilCurrentReset();
    const refresh = useRecoilCurrentRefresh();
    const getSnapshot = useRecoilCurrentSnapshot();
    const gotoSnapshot = (0,es.useGotoRecoilSnapshot)();
    const [ready, setReady] = (0,react.useState)(false);
    (0,react.useEffect)(() => {
        recoilStores[storeName.current] = {
            getPromise,
            getLoadable,
            set,
            reset,
            refresh,
            getSnapshot,
            gotoSnapshot,
            //TODO add runTask
        };
        flushGetStorePending(storeName.current);
        setReady(true);
        return () => {
            recoilStores[storeName.current] = undefined;
            flushGetStorePending(storeName.current);
        };
    }, []);
    return ready ? react.createElement(react.Fragment, null, children) : null;
};
//# sourceMappingURL=RecoilTunnel.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/tunnel/index.js


//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/updaters/array.js
const reverse = (s) => s.slice().reverse();
const filter = (predicate) => (s) => s.filter(predicate);
const push = (item, maxSize) => (s) => maxSize === undefined || s.length < maxSize
    ? [...s, item]
    : [...[...s, item].slice(s.length + 1 - maxSize, s.length + 1)];
const unshift = (item, maxSize) => (s) => maxSize === undefined || s.length < maxSize
    ? [item, ...s]
    : [item, ...s.slice(0, maxSize - 1)];
const updateObj = (item, match) => (s) => s.map(el => (Object.keys(match).every(k => match[k] === el[k]) ? Object.assign(Object.assign({}, el), item) : el));
const removeObj = (match) => filter(el => !Object.keys(match).every(k => match[k] === el[k]));
//alias
const pushTop = unshift;
//# sourceMappingURL=array.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/updaters/boolean.js
const not = (s) => !s;
const and = (value) => (s) => s && !!value;
const or = (value) => (s) => s || !!value;
// alias
const toggle = not;
//# sourceMappingURL=boolean.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/updaters/index.js



//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/_core/index.js




//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/atoms/errors.js

const ERRORS_STACK_SIZE = 100;
const errors_errorStack = (0,es.atom)({
    key: '@recoil-toolkit.errorStack',
    default: [],
});
const lastError = (0,es.selector)({
    key: '@recoil-toolkit.lastError',
    get: ({ get }) => {
        const e = get(errors_errorStack);
        return e.length > 0 ? e[e.length - 1] : undefined;
    },
});
const lastErrorType = (0,es.selectorFamily)({
    key: '@recoil-toolkit.lastErrorType',
    get: (key) => ({ get }) => get(errors_errorStack)
        .filter(e => e.key === key)
        .pop(),
});
const useLastError = (key) => (0,es.useRecoilValue)(key ? lastErrorType(key) : lastError);
const useResetErrors = () => (0,es.useResetRecoilState)(errors_errorStack);
//# sourceMappingURL=errors.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/atoms/loader.js

const DEFAULT_LOADER = '@recoil-toolkit.loader.global';
const loader = (0,es.atomFamily)({
    key: '@recoil-toolkit.loader',
    default: 0,
});
const isLoading = (0,es.selectorFamily)({
    key: '@recoil-toolkit.loader.isLoading',
    get: (key) => ({ get }) => get(loader(key)) > 0,
});
const useIsLoading = (key) => (0,es.useRecoilValue)(isLoading(key || DEFAULT_LOADER));
//# sourceMappingURL=loader.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/types.js
// eslint-disable-next-line no-shadow
var TaskStatus;
(function (TaskStatus) {
    TaskStatus[TaskStatus["Running"] = 0] = "Running";
    TaskStatus[TaskStatus["Error"] = 1] = "Error";
    TaskStatus[TaskStatus["Done"] = 2] = "Done";
})(TaskStatus || (TaskStatus = {}));
//# sourceMappingURL=types.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/atoms/tasks.js


const tasks = (0,es.atom)({
    key: '@recoil-toolkit.tasks',
    default: [],
});
const runningTasks = (0,es.selector)({
    key: '@recoil-toolkit.runningTasks',
    get: ({ get }) => get(tasks).filter(t => t.status === TaskStatus.Running),
});
const taskById = (0,es.selectorFamily)({
    key: '@recoil-toolkit.taskById',
    get: (id) => ({ get }) => {
        return get(tasks).find(t => t.id === id);
    },
});
const lastTaskByKey = (0,es.selectorFamily)({
    key: '@recoil-toolkit.lastTaskType',
    get: (key) => ({ get }) => {
        return get(tasks)
            .filter(t => { var _a; return ((_a = t === null || t === void 0 ? void 0 : t.options) === null || _a === void 0 ? void 0 : _a.key) === key; })
            .pop();
    },
});
const useRunningTasks = () => (0,es.useRecoilValue)(runningTasks);
//# sourceMappingURL=tasks.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/atoms/index.js



//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/devtools/consts.js
const RecoilToolkitDevTools = {
    consolePrefix: 'recoil-toolkit: ',
    eventMessageFromPage: '@recoil-toolkit/msg-from-web-page',
    eventMessageToPage: '@recoil-toolkit/msg-to-web-page',
    enableConsole: '@recoil-toolkit/enable-content-script-console',
};
//# sourceMappingURL=consts.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/devtools/getSnapshotState.js
//todo traverse and json stringify Errors
function getSnapshotState(snapshot) {
    var _a;
    const nodes = [];
    for (const node of snapshot.getNodes_UNSTABLE({ isInitialized: true })) {
        const nodeInfo = snapshot.getInfo_UNSTABLE(node);
        const loadable = snapshot.getLoadable(node);
        const subNodes = [];
        for (const comp of nodeInfo.subscribers.nodes) {
            subNodes.push(comp.key);
        }
        nodes.sort((a, b) => a.key.localeCompare(b.key));
        nodes.push({
            key: node.key,
            type: nodeInfo.type,
            // isSet: nodeInfo.isSet,
            // isActive: nodeInfo.isActive,
            isModified: nodeInfo.isModified,
            subNodes,
            state: loadable.state,
            value: loadable.state === 'hasValue'
                ? loadable.contents
                : loadable.state === 'loading'
                    ? '... loading ...'
                    : JSON.stringify(((_a = loadable.contents) === null || _a === void 0 ? void 0 : _a.message) || loadable.contents),
        });
    }
    return {
        id: snapshot.getID().toString(),
        nodes,
    };
}
//# sourceMappingURL=getSnapshotState.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/devtools/RecoilDevTools.js




/*const stringifyCircularJSON = obj => {
   const seen = new WeakSet();
   return JSON.stringify(obj, (k, v) => {
      if (v !== null && typeof v === 'object') {
         if (seen.has(v)) return '[Circular]';
         seen.add(v);
      }
      return v;
   });
};*/
const RecoilDevTools = ({ enableConsole, forceSerialize, serializer }) => {
    const snapshot = (0,es.useRecoilSnapshot)();
    (0,react.useEffect)(() => {
        window.postMessage({ type: RecoilToolkitDevTools.enableConsole, enable: !!enableConsole }, '*');
    }, [enableConsole]);
    /** Send Snapshot to DevTools **/
    (0,react.useEffect)(() => {
        const snapState = getSnapshotState(snapshot);
        window.postMessage({
            type: RecoilToolkitDevTools.eventMessageFromPage,
            data: forceSerialize
                ? JSON.parse(serializer ? serializer(snapState) : JSON.stringify(snapState))
                : snapState,
        }, '*');
    }, [snapshot]); //eslint-disable-line
    /** Listen messages from DevTools **/
    (0,react.useEffect)(() => {
        const onMessage = function (event) {
            // We only accept messages from ourselves
            if (event.source !== window)
                return;
            if (event.data.type && event.data.type === RecoilToolkitDevTools.eventMessageToPage) {
                console.log('DebugObserver Message Received: ', event.data);
            }
        };
        window.addEventListener('message', onMessage, false);
        return () => {
            window.removeEventListener('message', onMessage, false);
        };
    }, []);
    return null;
};
//# sourceMappingURL=RecoilDevTools.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/devtools/index.js

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/updaters/tasks.js


const pushTask = ({ parentId, id, options, args, extra, }) => push({
    parentId,
    id,
    args,
    status: TaskStatus.Running,
    options,
    extra,
    startedAt: new Date(),
});
const updateTaskDone = ({ data, id }) => updateObj({ status: TaskStatus.Done, data, endAt: new Date() }, {
    id,
});
const updateTaskError = ({ error, id }) => updateObj({ status: TaskStatus.Error, error, endAt: new Date() }, {
    id,
});
//# sourceMappingURL=tasks.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/updaters/errors.js


const pushError = ({ key, error, taskId }) => push({ key, error, id: uniqueId(), taskId }, ERRORS_STACK_SIZE);
//# sourceMappingURL=errors.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/updaters/index.js


//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/hooks/waitFor.js
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

const cancelledTaskMap = new Map();
const createCancelled = (taskId) => () => cancelledTaskMap.get(taskId) || false;
const createWaitFor = (cancelled) => (promiseOrMs) => __awaiter(void 0, void 0, void 0, function* () {
    if (typeof promiseOrMs === 'number') {
        const d = promiseOrMs < 0 ? 0 : Math.trunc(promiseOrMs);
        const times = Math.trunc(d / 50);
        for (let i = 0; i < times; i++) {
            yield delay(50);
            if (cancelled())
                throw new Error('Cancelled!');
        }
        return;
    }
    else {
        const data = yield promiseOrMs;
        if (cancelled())
            throw new Error('Cancelled!');
        return data;
    }
});
const cancelTask = (taskId) => {
    cancelledTaskMap.set(taskId, true);
};
//# sourceMappingURL=waitFor.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/hooks/fork.js
var fork_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};




const createFork = (parentId, recoil) => (taskCreator, args, debugKey) => {
    /* child task id */
    const id = uniqueId();
    const cancelledChild = createCancelled(id);
    const cancelled = () => recoil.cancelled() || cancelledChild();
    const cancel = () => cancelTask(id);
    const waitFor = createWaitFor(cancelled);
    /* injected current snapshot */
    const snapshot = recoil.getSnapshot();
    const childRecoil = Object.assign(Object.assign({}, recoil), { snapshot,
        waitFor,
        cancelled });
    /* injected fork recursively */
    const fork = createFork(id, childRecoil);
    const execute = taskCreator(Object.assign(Object.assign({}, childRecoil), { fork }));
    const childTaskObj = {
        parentId,
        id,
        args,
        options: debugKey ? { key: debugKey } : undefined,
    };
    const taskRunner = () => fork_awaiter(void 0, void 0, void 0, function* () {
        try {
            recoil.set(tasks, pushTask(childTaskObj));
            const data = yield execute(...args);
            recoil.set(tasks, updateTaskDone({ data, id }));
            return data;
        }
        catch (error) {
            recoil.set(tasks, updateTaskError({ error, id }));
        }
    });
    /* run child task */
    const task = taskRunner();
    const getTaskState = () => recoil.getLoadable(taskById(id)).getValue();
    return { id, cancel, task, getTaskState };
};
//# sourceMappingURL=fork.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/hooks/useRecoilTask.js
var useRecoilTask_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};








function useRecoilTask(taskCreator, deps, options) {
    const optionsRef = (0,react.useRef)(options || {}); //options freeze
    const { cancelOnUnmount, key, errorStack, loaderStack, exclusive, dataSelector, autoStart } = optionsRef.current;
    if (exclusive && !key) {
        throw new Error('Exclusive tasks must have a key!');
    }
    const [taskId, setTaskId] = (0,react.useState)(0);
    const task = (0,es.useRecoilValue)(exclusive ? lastTaskByKey(key || '') : taskById(taskId));
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const taskData = dataSelector ? (0,es.useRecoilValue)(dataSelector) : task === null || task === void 0 ? void 0 : task.data;
    const getSnapshot = useRecoilCurrentSnapshot();
    const getLoadable = useRecoilCurrentGetLoadable();
    const execute = (0,es.useRecoilCallback)((_a) => {
        var { set, snapshot } = _a, rest = __rest(_a, ["set", "snapshot"]);
        return (...args) => useRecoilTask_awaiter(this, void 0, void 0, function* () {
            if (exclusive && key) {
                const t = snapshot.getLoadable(lastTaskByKey(key)).getValue();
                if (t && t.status === TaskStatus.Running)
                    return;
            }
            const id = uniqueId();
            setTaskId(id);
            const cancelled = createCancelled(id);
            const waitFor = createWaitFor(cancelled);
            const fork = createFork(id, Object.assign({ cancelled,
                waitFor,
                getSnapshot,
                getLoadable,
                set,
                snapshot }, rest));
            try {
                if (loaderStack)
                    set(loader(loaderStack === true ? DEFAULT_LOADER : loaderStack), show);
                set(tasks, pushTask({ id, options, args }));
                const data = yield taskCreator(Object.assign({ fork,
                    cancelled,
                    waitFor,
                    getSnapshot,
                    getLoadable,
                    set,
                    snapshot }, rest))(...args);
                set(tasks, updateTaskDone({ data, id }));
            }
            catch (error) {
                set(tasks, updateTaskError({ error, id }));
                if (errorStack) {
                    set(errors_errorStack, pushError({ key, error, taskId: id }));
                }
            }
            finally {
                if (loaderStack)
                    set(loader(loaderStack === true ? DEFAULT_LOADER : loaderStack), hide);
            }
        });
    }, deps);
    (0,react.useEffect)(() => {
        if (autoStart) {
            execute(...autoStart);
        }
    }, [execute]);
    (0,react.useEffect)(() => {
        if (cancelOnUnmount && taskId) {
            return () => {
                cancelTask(taskId);
            };
        }
    }, [taskId]);
    const resetTask = (0,react.useCallback)(() => {
        setTaskId(0);
    }, []);
    return {
        loading: (task === null || task === void 0 ? void 0 : task.status) === TaskStatus.Running,
        execute,
        error: task === null || task === void 0 ? void 0 : task.error,
        data: taskData,
        success: (task === null || task === void 0 ? void 0 : task.status) === TaskStatus.Done,
        taskId,
        resetTask,
    };
}
//# sourceMappingURL=useRecoilTask.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/hooks/index.js

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/redux/atoms.js


const reduxSelectorsMap = new Map();
const reduxSelectorsMapInv = new Map();
function getSelectorId(selectorFunc) {
    let cachedSelectorId = reduxSelectorsMapInv.get(selectorFunc);
    if (!cachedSelectorId) {
        const id = uniqueId();
        reduxSelectorsMapInv.set(selectorFunc, id);
        reduxSelectorsMap.set(id, selectorFunc);
        cachedSelectorId = id;
    }
    return cachedSelectorId;
}
const reduxState = (0,es.atom)({
    key: '@recoil-toolkit.reduxState',
    default: undefined,
});
const reduxSelectorFamily = (0,es.selectorFamily)({
    key: '@recoil-toolkit.reduxSelectors',
    get: (selectorId) => ({ get }) => {
        const currentReduxState = get(reduxState);
        const selectorFunc = reduxSelectorsMap.get(selectorId);
        return currentReduxState && selectorFunc ? selectorFunc(currentReduxState) : undefined;
    },
});
function reduxSelector(selector) {
    return reduxSelectorFamily(getSelectorId(selector));
}
//# sourceMappingURL=atoms.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/redux/context.js

const RecoilReduxContext = (0,react.createContext)({});
//# sourceMappingURL=context.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/redux/hooks.js




function useSelector(selector) {
    return (0,es.useRecoilValue)(reduxSelector(selector));
}
function useDispatch() {
    const { store } = (0,react.useContext)(RecoilReduxContext);
    if (!store)
        throw new Error('RecoilReduxBridge with store not found!');
    return store.dispatch;
}
//# sourceMappingURL=hooks.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/redux/RecoilReduxBridge.js




const RecoilReduxBridge = ({ store, children }) => {
    const set = useRecoilCurrentSet();
    const [sub, setSub] = (0,react.useState)(false);
    (0,react.useEffect)(() => {
        const unsub = store.subscribe(() => {
            set(reduxState, store.getState());
        });
        set(reduxState, store.getState());
        setSub(true);
        return unsub;
    }, []);
    return (0,react.createElement)(RecoilReduxContext.Provider, {
        children: sub ? children : undefined,
        value: { store },
    });
};
//# sourceMappingURL=RecoilReduxBridge.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/redux/index.js



//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/recoil-toolkit/build/es6/index.js







//# sourceMappingURL=index.js.map

/***/ }),

/***/ 9853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DefaultValue": function() { return /* binding */ Recoil_index_1; },
/* harmony export */   "RecoilEnv": function() { return /* binding */ Recoil_index_4; },
/* harmony export */   "RecoilLoadable": function() { return /* binding */ Recoil_index_3; },
/* harmony export */   "RecoilRoot": function() { return /* binding */ Recoil_index_5; },
/* harmony export */   "atom": function() { return /* binding */ Recoil_index_8; },
/* harmony export */   "atomFamily": function() { return /* binding */ Recoil_index_10; },
/* harmony export */   "constSelector": function() { return /* binding */ Recoil_index_12; },
/* harmony export */   "errorSelector": function() { return /* binding */ Recoil_index_13; },
/* harmony export */   "isRecoilValue": function() { return /* binding */ Recoil_index_2; },
/* harmony export */   "noWait": function() { return /* binding */ Recoil_index_15; },
/* harmony export */   "readOnlySelector": function() { return /* binding */ Recoil_index_14; },
/* harmony export */   "retentionZone": function() { return /* binding */ Recoil_index_38; },
/* harmony export */   "selector": function() { return /* binding */ Recoil_index_9; },
/* harmony export */   "selectorFamily": function() { return /* binding */ Recoil_index_11; },
/* harmony export */   "snapshot_UNSTABLE": function() { return /* binding */ Recoil_index_36; },
/* harmony export */   "useGetRecoilValueInfo_UNSTABLE": function() { return /* binding */ Recoil_index_26; },
/* harmony export */   "useGotoRecoilSnapshot": function() { return /* binding */ Recoil_index_33; },
/* harmony export */   "useRecoilBridgeAcrossReactRoots_UNSTABLE": function() { return /* binding */ Recoil_index_7; },
/* harmony export */   "useRecoilCallback": function() { return /* binding */ Recoil_index_31; },
/* harmony export */   "useRecoilRefresher_UNSTABLE": function() { return /* binding */ Recoil_index_27; },
/* harmony export */   "useRecoilSnapshot": function() { return /* binding */ Recoil_index_34; },
/* harmony export */   "useRecoilState": function() { return /* binding */ Recoil_index_22; },
/* harmony export */   "useRecoilStateLoadable": function() { return /* binding */ Recoil_index_23; },
/* harmony export */   "useRecoilState_TRANSITION_SUPPORT_UNSTABLE": function() { return /* binding */ Recoil_index_30; },
/* harmony export */   "useRecoilStoreID": function() { return /* binding */ Recoil_index_6; },
/* harmony export */   "useRecoilTransactionObserver_UNSTABLE": function() { return /* binding */ Recoil_index_35; },
/* harmony export */   "useRecoilTransaction_UNSTABLE": function() { return /* binding */ Recoil_index_32; },
/* harmony export */   "useRecoilValue": function() { return /* binding */ Recoil_index_20; },
/* harmony export */   "useRecoilValueLoadable": function() { return /* binding */ Recoil_index_21; },
/* harmony export */   "useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE": function() { return /* binding */ Recoil_index_28; },
/* harmony export */   "useRecoilValue_TRANSITION_SUPPORT_UNSTABLE": function() { return /* binding */ Recoil_index_29; },
/* harmony export */   "useResetRecoilState": function() { return /* binding */ Recoil_index_25; },
/* harmony export */   "useRetain": function() { return /* binding */ Recoil_index_37; },
/* harmony export */   "useSetRecoilState": function() { return /* binding */ Recoil_index_24; },
/* harmony export */   "waitForAll": function() { return /* binding */ Recoil_index_18; },
/* harmony export */   "waitForAllSettled": function() { return /* binding */ Recoil_index_19; },
/* harmony export */   "waitForAny": function() { return /* binding */ Recoil_index_17; },
/* harmony export */   "waitForNone": function() { return /* binding */ Recoil_index_16; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1542);
/* provided dependency */ var process = __webpack_require__(4284);



/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function err(message) {
  const error = new Error(message); // In V8, Error objects keep the closure scope chain alive until the
  // err.stack property is accessed.

  if (error.stack === undefined) {
    // IE sets the stack only if error is thrown
    try {
      throw error;
    } catch (_) {} // eslint-disable-line fb-www/no-unused-catch-bindings, no-empty

  }

  return error;
}

var err_1 = err;

// @oss-only


var Recoil_err = err_1;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

// Split declaration and implementation to allow this function to pretend to
// check for actual instance of Promise instead of something with a `then`
// method.
// eslint-disable-next-line no-redeclare
function isPromise(p) {
  return !!p && typeof p.then === 'function';
}

var Recoil_isPromise = isPromise;

function nullthrows(x, message) {
  if (x != null) {
    return x;
  }

  throw Recoil_err(message !== null && message !== void 0 ? message : 'Got unexpected null or undefined');
}

var Recoil_nullthrows = nullthrows;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

class BaseLoadable {
  getValue() {
    throw Recoil_err('BaseLoadable');
  }

  toPromise() {
    throw Recoil_err('BaseLoadable');
  }

  valueMaybe() {
    throw Recoil_err('BaseLoadable');
  }

  valueOrThrow() {
    // $FlowFixMe[prop-missing]
    throw Recoil_err(`Loadable expected value, but in "${this.state}" state`);
  }

  promiseMaybe() {
    throw Recoil_err('BaseLoadable');
  }

  promiseOrThrow() {
    // $FlowFixMe[prop-missing]
    throw Recoil_err(`Loadable expected promise, but in "${this.state}" state`);
  }

  errorMaybe() {
    throw Recoil_err('BaseLoadable');
  }

  errorOrThrow() {
    // $FlowFixMe[prop-missing]
    throw Recoil_err(`Loadable expected error, but in "${this.state}" state`);
  }

  is(other) {
    // $FlowFixMe[prop-missing]
    return other.state === this.state && other.contents === this.contents;
  }

  map(_map) {
    throw Recoil_err('BaseLoadable');
  }

}

class ValueLoadable extends BaseLoadable {
  constructor(value) {
    super();

    _defineProperty(this, "state", 'hasValue');

    _defineProperty(this, "contents", void 0);

    this.contents = value;
  }

  getValue() {
    return this.contents;
  }

  toPromise() {
    return Promise.resolve(this.contents);
  }

  valueMaybe() {
    return this.contents;
  }

  valueOrThrow() {
    return this.contents;
  }

  promiseMaybe() {
    return undefined;
  }

  errorMaybe() {
    return undefined;
  }

  map(map) {
    try {
      const next = map(this.contents);
      return Recoil_isPromise(next) ? loadableWithPromise(next) : isLoadable(next) ? next : loadableWithValue(next);
    } catch (e) {
      return Recoil_isPromise(e) ? // If we "suspended", then try again.
      // errors and subsequent retries will be handled in 'loading' case
      // $FlowFixMe[prop-missing]
      loadableWithPromise(e.next(() => this.map(map))) : loadableWithError(e);
    }
  }

}

class ErrorLoadable extends BaseLoadable {
  constructor(error) {
    super();

    _defineProperty(this, "state", 'hasError');

    _defineProperty(this, "contents", void 0);

    this.contents = error;
  }

  getValue() {
    throw this.contents;
  }

  toPromise() {
    return Promise.reject(this.contents);
  }

  valueMaybe() {
    return undefined;
  }

  promiseMaybe() {
    return undefined;
  }

  errorMaybe() {
    return this.contents;
  }

  errorOrThrow() {
    return this.contents;
  }

  map(_map) {
    // $FlowIssue[incompatible-return]
    return this;
  }

}

class LoadingLoadable extends BaseLoadable {
  constructor(promise) {
    super();

    _defineProperty(this, "state", 'loading');

    _defineProperty(this, "contents", void 0);

    this.contents = promise;
  }

  getValue() {
    throw this.contents;
  }

  toPromise() {
    return this.contents;
  }

  valueMaybe() {
    return undefined;
  }

  promiseMaybe() {
    return this.contents;
  }

  promiseOrThrow() {
    return this.contents;
  }

  errorMaybe() {
    return undefined;
  }

  map(map) {
    return loadableWithPromise(this.contents.then(value => {
      const next = map(value);

      if (isLoadable(next)) {
        const nextLoadable = next;

        switch (nextLoadable.state) {
          case 'hasValue':
            return nextLoadable.contents;

          case 'hasError':
            throw nextLoadable.contents;

          case 'loading':
            return nextLoadable.contents;
        }
      } // $FlowIssue[incompatible-return]


      return next;
    }) // $FlowFixMe[incompatible-call]
    .catch(e => {
      if (Recoil_isPromise(e)) {
        // we were "suspended," try again
        return e.then(() => this.map(map).contents);
      }

      throw e;
    }));
  }

}

function loadableWithValue(value) {
  return Object.freeze(new ValueLoadable(value));
}

function loadableWithError(error) {
  return Object.freeze(new ErrorLoadable(error));
}

function loadableWithPromise(promise) {
  return Object.freeze(new LoadingLoadable(promise));
}

function loadableLoading() {
  return Object.freeze(new LoadingLoadable(new Promise(() => {})));
}

function loadableAllArray(inputs) {
  return inputs.every(i => i.state === 'hasValue') ? loadableWithValue(inputs.map(i => i.contents)) : inputs.some(i => i.state === 'hasError') ? loadableWithError(Recoil_nullthrows(inputs.find(i => i.state === 'hasError'), 'Invalid loadable passed to loadableAll').contents) : loadableWithPromise(Promise.all(inputs.map(i => i.contents)));
}

function loadableAll(inputs) {
  const unwrapedInputs = Array.isArray(inputs) ? inputs : Object.getOwnPropertyNames(inputs).map(key => inputs[key]);
  const normalizedInputs = unwrapedInputs.map(x => isLoadable(x) ? x : Recoil_isPromise(x) ? loadableWithPromise(x) : loadableWithValue(x));
  const output = loadableAllArray(normalizedInputs);
  return Array.isArray(inputs) ? // $FlowIssue[incompatible-return]
  output : // Object.getOwnPropertyNames() has consistent key ordering with ES6
  // $FlowIssue[incompatible-call]
  output.map(outputs => Object.getOwnPropertyNames(inputs).reduce( // $FlowFixMe[invalid-computed-prop]
  (out, key, idx) => ({ ...out,
    [key]: outputs[idx]
  }), {}));
}

function isLoadable(x) {
  return x instanceof BaseLoadable;
}

const LoadableStaticInterface = {
  of: value => Recoil_isPromise(value) ? loadableWithPromise(value) : isLoadable(value) ? value : loadableWithValue(value),
  error: error => loadableWithError(error),
  // $FlowIssue[incompatible-return]
  loading: () => loadableLoading(),
  // $FlowIssue[unclear-type]
  all: loadableAll,
  isLoadable
};
var Recoil_Loadable = {
  loadableWithValue,
  loadableWithError,
  loadableWithPromise,
  loadableLoading,
  loadableAll,
  isLoadable,
  RecoilLoadable: LoadableStaticInterface
};

var Recoil_Loadable_1 = Recoil_Loadable.loadableWithValue;
var Recoil_Loadable_2 = Recoil_Loadable.loadableWithError;
var Recoil_Loadable_3 = Recoil_Loadable.loadableWithPromise;
var Recoil_Loadable_4 = Recoil_Loadable.loadableLoading;
var Recoil_Loadable_5 = Recoil_Loadable.loadableAll;
var Recoil_Loadable_6 = Recoil_Loadable.isLoadable;
var Recoil_Loadable_7 = Recoil_Loadable.RecoilLoadable;

var Recoil_Loadable$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  loadableWithValue: Recoil_Loadable_1,
  loadableWithError: Recoil_Loadable_2,
  loadableWithPromise: Recoil_Loadable_3,
  loadableLoading: Recoil_Loadable_4,
  loadableAll: Recoil_Loadable_5,
  isLoadable: Recoil_Loadable_6,
  RecoilLoadable: Recoil_Loadable_7
});

const env = {
  RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED: true,
  // Note: RECOIL_GKS_ENABLED settings will only be honored in OSS builds of Recoil
  RECOIL_GKS_ENABLED: new Set(['recoil_hamt_2020', 'recoil_sync_external_store', 'recoil_suppress_rerender_in_callback', 'recoil_memory_managament_2020'])
};

function readProcessEnvBooleanFlag(name, set) {
  var _process$env$name, _process$env$name$toL;

  const sanitizedValue = (_process$env$name = process.env[name]) === null || _process$env$name === void 0 ? void 0 : (_process$env$name$toL = _process$env$name.toLowerCase()) === null || _process$env$name$toL === void 0 ? void 0 : _process$env$name$toL.trim();

  if (sanitizedValue == null || sanitizedValue === '') {
    return;
  }

  const allowedValues = ['true', 'false'];

  if (!allowedValues.includes(sanitizedValue)) {
    throw Recoil_err(`process.env.${name} value must be 'true', 'false', or empty: ${sanitizedValue}`);
  }

  set(sanitizedValue === 'true');
}

function readProcessEnvStringArrayFlag(name, set) {
  var _process$env$name2;

  const sanitizedValue = (_process$env$name2 = process.env[name]) === null || _process$env$name2 === void 0 ? void 0 : _process$env$name2.trim();

  if (sanitizedValue == null || sanitizedValue === '') {
    return;
  }

  set(sanitizedValue.split(/\s*,\s*|\s+/));
}
/**
 * Allow NodeJS/NextJS/etc to set the initial state through process.env variable
 * Note:  we don't assume 'process' is available in all runtime environments
 *
 * @see https://github.com/facebookexperimental/Recoil/issues/733
 */


function applyProcessEnvFlagOverrides() {
  var _process;

  // note: this check is needed in addition to the check below, runtime error will occur without it!
  // eslint-disable-next-line fb-www/typeof-undefined
  if (typeof process === 'undefined') {
    return;
  }

  if (((_process = process) === null || process === void 0 ? void 0 : process.env) == null) {
    return;
  }

  readProcessEnvBooleanFlag('RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED', value => {
    env.RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED = value;
  });
  readProcessEnvStringArrayFlag('RECOIL_GKS_ENABLED', value => {
    value.forEach(gk => {
      env.RECOIL_GKS_ENABLED.add(gk);
    });
  });
}

applyProcessEnvFlagOverrides();
var Recoil_RecoilEnv = env;

function Recoil_gkx_OSS(gk) {
  return Recoil_RecoilEnv.RECOIL_GKS_ENABLED.has(gk);
}

Recoil_gkx_OSS.setPass = gk => {
  Recoil_RecoilEnv.RECOIL_GKS_ENABLED.add(gk);
};

Recoil_gkx_OSS.setFail = gk => {
  Recoil_RecoilEnv.RECOIL_GKS_ENABLED.delete(gk);
};

Recoil_gkx_OSS.clear = () => {
  Recoil_RecoilEnv.RECOIL_GKS_ENABLED.clear();
};

var Recoil_gkx = Recoil_gkx_OSS; // @oss-only

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function recoverableViolation(message, _projectName, {
  error
} = {}) {
  if (false) {}

  return null;
}

var recoverableViolation_1 = recoverableViolation;

// @oss-only


var Recoil_recoverableViolation = recoverableViolation_1;

var _createMutableSource, _useMutableSource, _useSyncExternalStore;







const createMutableSource = // flowlint-next-line unclear-type:off
(_createMutableSource = react__WEBPACK_IMPORTED_MODULE_0__.createMutableSource) !== null && _createMutableSource !== void 0 ? _createMutableSource : react__WEBPACK_IMPORTED_MODULE_0__.unstable_createMutableSource;
const useMutableSource = // flowlint-next-line unclear-type:off
(_useMutableSource = react__WEBPACK_IMPORTED_MODULE_0__.useMutableSource) !== null && _useMutableSource !== void 0 ? _useMutableSource : react__WEBPACK_IMPORTED_MODULE_0__.unstable_useMutableSource; // https://github.com/reactwg/react-18/discussions/86

const useSyncExternalStore = // flowlint-next-line unclear-type:off
(_useSyncExternalStore = react__WEBPACK_IMPORTED_MODULE_0__.useSyncExternalStore) !== null && _useSyncExternalStore !== void 0 ? _useSyncExternalStore : // flowlint-next-line unclear-type:off
react__WEBPACK_IMPORTED_MODULE_0__.unstable_useSyncExternalStore;
let ReactRendererVersionMismatchWarnOnce = false; // Check if the current renderer supports `useSyncExternalStore()`.
// Since React goes through a proxy dispatcher and the current renderer can
// change we can't simply check if `React.useSyncExternalStore()` is defined.

function currentRendererSupportsUseSyncExternalStore() {
  var _ReactCurrentDispatch;

  // $FlowFixMe[incompatible-use]
  const {
    ReactCurrentDispatcher,
    ReactCurrentOwner
  } =
  /* $FlowFixMe[prop-missing] This workaround was approved as a safer mechanism
   * to detect if the current renderer supports useSyncExternalStore()
   * https://fb.workplace.com/groups/reactjs/posts/9558682330846963/ */
  react__WEBPACK_IMPORTED_MODULE_0__.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  const dispatcher = (_ReactCurrentDispatch = ReactCurrentDispatcher === null || ReactCurrentDispatcher === void 0 ? void 0 : ReactCurrentDispatcher.current) !== null && _ReactCurrentDispatch !== void 0 ? _ReactCurrentDispatch : ReactCurrentOwner.currentDispatcher;
  const isUseSyncExternalStoreSupported = dispatcher.useSyncExternalStore != null;

  if (useSyncExternalStore && !isUseSyncExternalStoreSupported && !ReactRendererVersionMismatchWarnOnce) {
    ReactRendererVersionMismatchWarnOnce = true;
    Recoil_recoverableViolation('A React renderer without React 18+ API support is being used with React 18+.');
  }

  return isUseSyncExternalStoreSupported;
}

/**
 * mode: The React API and approach to use for syncing state with React
 * early: Re-renders from Recoil updates occur:
 *    1) earlier
 *    2) in sync with React updates in the same batch
 *    3) before transaction observers instead of after.
 * concurrent: Is the current mode compatible with Concurrent Mode and useTransition()
 */
function reactMode() {
  // NOTE: This mode is currently broken with some Suspense cases
  // see Recoil_selector-test.js
  if (Recoil_gkx('recoil_transition_support')) {
    return {
      mode: 'TRANSITION_SUPPORT',
      early: true,
      concurrent: true
    };
  }

  if (Recoil_gkx('recoil_sync_external_store') && useSyncExternalStore != null) {
    return {
      mode: 'SYNC_EXTERNAL_STORE',
      early: true,
      concurrent: false
    };
  }

  if (Recoil_gkx('recoil_mutable_source') && useMutableSource != null && typeof window !== 'undefined' && !window.$disableRecoilValueMutableSource_TEMP_HACK_DO_NOT_USE) {
    return Recoil_gkx('recoil_suppress_rerender_in_callback') ? {
      mode: 'MUTABLE_SOURCE',
      early: true,
      concurrent: true
    } : {
      mode: 'MUTABLE_SOURCE',
      early: false,
      concurrent: false
    };
  }

  return Recoil_gkx('recoil_suppress_rerender_in_callback') ? {
    mode: 'LEGACY',
    early: true,
    concurrent: false
  } : {
    mode: 'LEGACY',
    early: false,
    concurrent: false
  };
} // TODO Need to figure out if there is a standard/open-source equivalent to see if hot module replacement is happening:


function isFastRefreshEnabled() {
  // @fb-only: const {isAcceptingUpdate} = require('__debug');
  // @fb-only: return typeof isAcceptingUpdate === 'function' && isAcceptingUpdate();
  return false; // @oss-only
}

var Recoil_ReactMode = {
  createMutableSource,
  useMutableSource,
  useSyncExternalStore,
  currentRendererSupportsUseSyncExternalStore,
  reactMode,
  isFastRefreshEnabled
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

// eslint-disable-next-line no-unused-vars
class AbstractRecoilValue {
  constructor(newKey) {
    _defineProperty(this, "key", void 0);

    this.key = newKey;
  }

  toJSON() {
    return {
      key: this.key
    };
  }

}

class RecoilState extends AbstractRecoilValue {}

class RecoilValueReadOnly extends AbstractRecoilValue {}

function isRecoilValue(x) {
  return x instanceof RecoilState || x instanceof RecoilValueReadOnly;
}

var Recoil_RecoilValue = {
  AbstractRecoilValue,
  RecoilState,
  RecoilValueReadOnly,
  isRecoilValue
};

var Recoil_RecoilValue_1 = Recoil_RecoilValue.AbstractRecoilValue;
var Recoil_RecoilValue_2 = Recoil_RecoilValue.RecoilState;
var Recoil_RecoilValue_3 = Recoil_RecoilValue.RecoilValueReadOnly;
var Recoil_RecoilValue_4 = Recoil_RecoilValue.isRecoilValue;

var Recoil_RecoilValue$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  AbstractRecoilValue: Recoil_RecoilValue_1,
  RecoilState: Recoil_RecoilValue_2,
  RecoilValueReadOnly: Recoil_RecoilValue_3,
  isRecoilValue: Recoil_RecoilValue_4
});

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function sprintf(format, ...args) {
  let index = 0;
  return format.replace(/%s/g, () => String(args[index++]));
}

var sprintf_1 = (/* unused pure expression or super */ null && (sprintf));

function expectationViolation(format, ...args) {
  if (false) {}
}

var expectationViolation_1 = expectationViolation;

// @oss-only


var Recoil_expectationViolation = expectationViolation_1;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Creates a new iterable whose output is generated by passing the input
 * iterable's values through the mapper function.
 */

function mapIterable(iterable, callback) {
  // Use generator to create iterable/iterator
  return function* () {
    let index = 0;

    for (const value of iterable) {
      yield callback(value, index++);
    }
  }();
}

var Recoil_mapIterable = mapIterable;

const {
  isFastRefreshEnabled: isFastRefreshEnabled$1
} = Recoil_ReactMode;















class DefaultValue {}

const DEFAULT_VALUE = new DefaultValue();
// flowlint-next-line unclear-type:off
const nodes = new Map(); // flowlint-next-line unclear-type:off

const recoilValues = new Map();
/* eslint-disable no-redeclare */

function recoilValuesForKeys(keys) {
  return Recoil_mapIterable(keys, key => Recoil_nullthrows(recoilValues.get(key)));
}

function checkForDuplicateAtomKey(key) {
  if (nodes.has(key)) {
    const message = `Duplicate atom key "${key}". This is a FATAL ERROR in
      production. But it is safe to ignore this warning if it occurred because of
      hot module replacement.`;

    if (false) {} else {
      // @fb-only: recoverableViolation(message, 'recoil');
      console.warn(message); // @oss-only
    }
  }
}

function registerNode(node) {
  if (Recoil_RecoilEnv.RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED) {
    checkForDuplicateAtomKey(node.key);
  }

  nodes.set(node.key, node);
  const recoilValue = node.set == null ? new Recoil_RecoilValue$1.RecoilValueReadOnly(node.key) : new Recoil_RecoilValue$1.RecoilState(node.key);
  recoilValues.set(node.key, recoilValue);
  return recoilValue;
}
/* eslint-enable no-redeclare */


class NodeMissingError extends Error {} // flowlint-next-line unclear-type:off


function getNode(key) {
  const node = nodes.get(key);

  if (node == null) {
    throw new NodeMissingError(`Missing definition for RecoilValue: "${key}""`);
  }

  return node;
} // flowlint-next-line unclear-type:off


function getNodeMaybe(key) {
  return nodes.get(key);
}

const configDeletionHandlers = new Map();

function deleteNodeConfigIfPossible(key) {
  var _node$shouldDeleteCon;

  if (!Recoil_gkx('recoil_memory_managament_2020')) {
    return;
  }

  const node = nodes.get(key);

  if (node !== null && node !== void 0 && (_node$shouldDeleteCon = node.shouldDeleteConfigOnRelease) !== null && _node$shouldDeleteCon !== void 0 && _node$shouldDeleteCon.call(node)) {
    var _getConfigDeletionHan;

    nodes.delete(key);
    (_getConfigDeletionHan = getConfigDeletionHandler(key)) === null || _getConfigDeletionHan === void 0 ? void 0 : _getConfigDeletionHan();
    configDeletionHandlers.delete(key);
  }
}

function setConfigDeletionHandler(key, fn) {
  if (!Recoil_gkx('recoil_memory_managament_2020')) {
    return;
  }

  if (fn === undefined) {
    configDeletionHandlers.delete(key);
  } else {
    configDeletionHandlers.set(key, fn);
  }
}

function getConfigDeletionHandler(key) {
  return configDeletionHandlers.get(key);
}

var Recoil_Node = {
  nodes,
  recoilValues,
  registerNode,
  getNode,
  getNodeMaybe,
  deleteNodeConfigIfPossible,
  setConfigDeletionHandler,
  getConfigDeletionHandler,
  recoilValuesForKeys,
  NodeMissingError,
  DefaultValue,
  DEFAULT_VALUE
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function enqueueExecution(s, f) {
  f();
}

var Recoil_Queue = {
  enqueueExecution
};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var hamt_1 = createCommonjsModule(function (module) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
/**
    @fileOverview Hash Array Mapped Trie.

    Code based on: https://github.com/exclipy/pdata
*/


var hamt = {}; // export

/* Configuration
 ******************************************************************************/

var SIZE = 5;
var BUCKET_SIZE = Math.pow(2, SIZE);
var MASK = BUCKET_SIZE - 1;
var MAX_INDEX_NODE = BUCKET_SIZE / 2;
var MIN_ARRAY_NODE = BUCKET_SIZE / 4;
/*
 ******************************************************************************/

var nothing = {};

var constant = function constant(x) {
  return function () {
    return x;
  };
};
/**
    Get 32 bit hash of string.

    Based on:
    http://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript-jquery
*/


var hash = hamt.hash = function (str) {
  var type = typeof str === 'undefined' ? 'undefined' : _typeof(str);
  if (type === 'number') return str;
  if (type !== 'string') str += '';
  var hash = 0;

  for (var i = 0, len = str.length; i < len; ++i) {
    var c = str.charCodeAt(i);
    hash = (hash << 5) - hash + c | 0;
  }

  return hash;
};
/* Bit Ops
 ******************************************************************************/

/**
    Hamming weight.

    Taken from: http://jsperf.com/hamming-weight
*/


var popcount = function popcount(x) {
  x -= x >> 1 & 0x55555555;
  x = (x & 0x33333333) + (x >> 2 & 0x33333333);
  x = x + (x >> 4) & 0x0f0f0f0f;
  x += x >> 8;
  x += x >> 16;
  return x & 0x7f;
};

var hashFragment = function hashFragment(shift, h) {
  return h >>> shift & MASK;
};

var toBitmap = function toBitmap(x) {
  return 1 << x;
};

var fromBitmap = function fromBitmap(bitmap, bit) {
  return popcount(bitmap & bit - 1);
};
/* Array Ops
 ******************************************************************************/

/**
    Set a value in an array.

    @param mutate Should the input array be mutated?
    @param at Index to change.
    @param v New value
    @param arr Array.
*/


var arrayUpdate = function arrayUpdate(mutate, at, v, arr) {
  var out = arr;

  if (!mutate) {
    var len = arr.length;
    out = new Array(len);

    for (var i = 0; i < len; ++i) {
      out[i] = arr[i];
    }
  }

  out[at] = v;
  return out;
};
/**
    Remove a value from an array.

    @param mutate Should the input array be mutated?
    @param at Index to remove.
    @param arr Array.
*/


var arraySpliceOut = function arraySpliceOut(mutate, at, arr) {
  var newLen = arr.length - 1;
  var i = 0;
  var g = 0;
  var out = arr;

  if (mutate) {
    i = g = at;
  } else {
    out = new Array(newLen);

    while (i < at) {
      out[g++] = arr[i++];
    }
  }

  ++i;

  while (i <= newLen) {
    out[g++] = arr[i++];
  }

  if (mutate) {
    out.length = newLen;
  }

  return out;
};
/**
    Insert a value into an array.

    @param mutate Should the input array be mutated?
    @param at Index to insert at.
    @param v Value to insert,
    @param arr Array.
*/


var arraySpliceIn = function arraySpliceIn(mutate, at, v, arr) {
  var len = arr.length;

  if (mutate) {
    var _i = len;

    while (_i >= at) {
      arr[_i--] = arr[_i];
    }

    arr[at] = v;
    return arr;
  }

  var i = 0,
      g = 0;
  var out = new Array(len + 1);

  while (i < at) {
    out[g++] = arr[i++];
  }

  out[at] = v;

  while (i < len) {
    out[++g] = arr[i++];
  }

  return out;
};
/* Node Structures
 ******************************************************************************/


var LEAF = 1;
var COLLISION = 2;
var INDEX = 3;
var ARRAY = 4;
/**
    Empty node.
*/

var empty = {
  __hamt_isEmpty: true
};

var isEmptyNode = function isEmptyNode(x) {
  return x === empty || x && x.__hamt_isEmpty;
};
/**
    Leaf holding a value.

    @member edit Edit of the node.
    @member hash Hash of key.
    @member key Key.
    @member value Value stored.
*/


var Leaf = function Leaf(edit, hash, key, value) {
  return {
    type: LEAF,
    edit: edit,
    hash: hash,
    key: key,
    value: value,
    _modify: Leaf__modify
  };
};
/**
    Leaf holding multiple values with the same hash but different keys.

    @member edit Edit of the node.
    @member hash Hash of key.
    @member children Array of collision children node.
*/


var Collision = function Collision(edit, hash, children) {
  return {
    type: COLLISION,
    edit: edit,
    hash: hash,
    children: children,
    _modify: Collision__modify
  };
};
/**
    Internal node with a sparse set of children.

    Uses a bitmap and array to pack children.

  @member edit Edit of the node.
    @member mask Bitmap that encode the positions of children in the array.
    @member children Array of child nodes.
*/


var IndexedNode = function IndexedNode(edit, mask, children) {
  return {
    type: INDEX,
    edit: edit,
    mask: mask,
    children: children,
    _modify: IndexedNode__modify
  };
};
/**
    Internal node with many children.

    @member edit Edit of the node.
    @member size Number of children.
    @member children Array of child nodes.
*/


var ArrayNode = function ArrayNode(edit, size, children) {
  return {
    type: ARRAY,
    edit: edit,
    size: size,
    children: children,
    _modify: ArrayNode__modify
  };
};
/**
    Is `node` a leaf node?
*/


var isLeaf = function isLeaf(node) {
  return node === empty || node.type === LEAF || node.type === COLLISION;
};
/* Internal node operations.
 ******************************************************************************/

/**
    Expand an indexed node into an array node.

  @param edit Current edit.
    @param frag Index of added child.
    @param child Added child.
    @param mask Index node mask before child added.
    @param subNodes Index node children before child added.
*/


var expand = function expand(edit, frag, child, bitmap, subNodes) {
  var arr = [];
  var bit = bitmap;
  var count = 0;

  for (var i = 0; bit; ++i) {
    if (bit & 1) arr[i] = subNodes[count++];
    bit >>>= 1;
  }

  arr[frag] = child;
  return ArrayNode(edit, count + 1, arr);
};
/**
    Collapse an array node into a indexed node.

  @param edit Current edit.
    @param count Number of elements in new array.
    @param removed Index of removed element.
    @param elements Array node children before remove.
*/


var pack = function pack(edit, count, removed, elements) {
  var children = new Array(count - 1);
  var g = 0;
  var bitmap = 0;

  for (var i = 0, len = elements.length; i < len; ++i) {
    if (i !== removed) {
      var elem = elements[i];

      if (elem && !isEmptyNode(elem)) {
        children[g++] = elem;
        bitmap |= 1 << i;
      }
    }
  }

  return IndexedNode(edit, bitmap, children);
};
/**
    Merge two leaf nodes.

    @param shift Current shift.
    @param h1 Node 1 hash.
    @param n1 Node 1.
    @param h2 Node 2 hash.
    @param n2 Node 2.
*/


var mergeLeaves = function mergeLeaves(edit, shift, h1, n1, h2, n2) {
  if (h1 === h2) return Collision(edit, h1, [n2, n1]);
  var subH1 = hashFragment(shift, h1);
  var subH2 = hashFragment(shift, h2);
  return IndexedNode(edit, toBitmap(subH1) | toBitmap(subH2), subH1 === subH2 ? [mergeLeaves(edit, shift + SIZE, h1, n1, h2, n2)] : subH1 < subH2 ? [n1, n2] : [n2, n1]);
};
/**
    Update an entry in a collision list.

    @param mutate Should mutation be used?
    @param edit Current edit.
    @param keyEq Key compare function.
    @param hash Hash of collision.
    @param list Collision list.
    @param f Update function.
    @param k Key to update.
    @param size Size ref.
*/


var updateCollisionList = function updateCollisionList(mutate, edit, keyEq, h, list, f, k, size) {
  var len = list.length;

  for (var i = 0; i < len; ++i) {
    var child = list[i];

    if (keyEq(k, child.key)) {
      var value = child.value;

      var _newValue = f(value);

      if (_newValue === value) return list;

      if (_newValue === nothing) {
        --size.value;
        return arraySpliceOut(mutate, i, list);
      }

      return arrayUpdate(mutate, i, Leaf(edit, h, k, _newValue), list);
    }
  }

  var newValue = f();
  if (newValue === nothing) return list;
  ++size.value;
  return arrayUpdate(mutate, len, Leaf(edit, h, k, newValue), list);
};

var canEditNode = function canEditNode(edit, node) {
  return edit === node.edit;
};
/* Editing
 ******************************************************************************/


var Leaf__modify = function Leaf__modify(edit, keyEq, shift, f, h, k, size) {
  if (keyEq(k, this.key)) {
    var _v = f(this.value);

    if (_v === this.value) return this;else if (_v === nothing) {
      --size.value;
      return empty;
    }

    if (canEditNode(edit, this)) {
      this.value = _v;
      return this;
    }

    return Leaf(edit, h, k, _v);
  }

  var v = f();
  if (v === nothing) return this;
  ++size.value;
  return mergeLeaves(edit, shift, this.hash, this, h, Leaf(edit, h, k, v));
};

var Collision__modify = function Collision__modify(edit, keyEq, shift, f, h, k, size) {
  if (h === this.hash) {
    var canEdit = canEditNode(edit, this);
    var list = updateCollisionList(canEdit, edit, keyEq, this.hash, this.children, f, k, size);
    if (list === this.children) return this;
    return list.length > 1 ? Collision(edit, this.hash, list) : list[0]; // collapse single element collision list
  }

  var v = f();
  if (v === nothing) return this;
  ++size.value;
  return mergeLeaves(edit, shift, this.hash, this, h, Leaf(edit, h, k, v));
};

var IndexedNode__modify = function IndexedNode__modify(edit, keyEq, shift, f, h, k, size) {
  var mask = this.mask;
  var children = this.children;
  var frag = hashFragment(shift, h);
  var bit = toBitmap(frag);
  var indx = fromBitmap(mask, bit);
  var exists = mask & bit;
  var current = exists ? children[indx] : empty;

  var child = current._modify(edit, keyEq, shift + SIZE, f, h, k, size);

  if (current === child) return this;
  var canEdit = canEditNode(edit, this);
  var bitmap = mask;
  var newChildren = void 0;

  if (exists && isEmptyNode(child)) {
    // remove
    bitmap &= ~bit;
    if (!bitmap) return empty;
    if (children.length <= 2 && isLeaf(children[indx ^ 1])) return children[indx ^ 1]; // collapse

    newChildren = arraySpliceOut(canEdit, indx, children);
  } else if (!exists && !isEmptyNode(child)) {
    // add
    if (children.length >= MAX_INDEX_NODE) return expand(edit, frag, child, mask, children);
    bitmap |= bit;
    newChildren = arraySpliceIn(canEdit, indx, child, children);
  } else {
    // modify
    newChildren = arrayUpdate(canEdit, indx, child, children);
  }

  if (canEdit) {
    this.mask = bitmap;
    this.children = newChildren;
    return this;
  }

  return IndexedNode(edit, bitmap, newChildren);
};

var ArrayNode__modify = function ArrayNode__modify(edit, keyEq, shift, f, h, k, size) {
  var count = this.size;
  var children = this.children;
  var frag = hashFragment(shift, h);
  var child = children[frag];

  var newChild = (child || empty)._modify(edit, keyEq, shift + SIZE, f, h, k, size);

  if (child === newChild) return this;
  var canEdit = canEditNode(edit, this);
  var newChildren = void 0;

  if (isEmptyNode(child) && !isEmptyNode(newChild)) {
    // add
    ++count;
    newChildren = arrayUpdate(canEdit, frag, newChild, children);
  } else if (!isEmptyNode(child) && isEmptyNode(newChild)) {
    // remove
    --count;
    if (count <= MIN_ARRAY_NODE) return pack(edit, count, frag, children);
    newChildren = arrayUpdate(canEdit, frag, empty, children);
  } else {
    // modify
    newChildren = arrayUpdate(canEdit, frag, newChild, children);
  }

  if (canEdit) {
    this.size = count;
    this.children = newChildren;
    return this;
  }

  return ArrayNode(edit, count, newChildren);
};

empty._modify = function (edit, keyEq, shift, f, h, k, size) {
  var v = f();
  if (v === nothing) return empty;
  ++size.value;
  return Leaf(edit, h, k, v);
};
/*
 ******************************************************************************/


function Map(editable, edit, config, root, size) {
  this._editable = editable;
  this._edit = edit;
  this._config = config;
  this._root = root;
  this._size = size;
}

Map.prototype.setTree = function (newRoot, newSize) {
  if (this._editable) {
    this._root = newRoot;
    this._size = newSize;
    return this;
  }

  return newRoot === this._root ? this : new Map(this._editable, this._edit, this._config, newRoot, newSize);
};
/* Queries
 ******************************************************************************/

/**
    Lookup the value for `key` in `map` using a custom `hash`.

    Returns the value or `alt` if none.
*/


var tryGetHash = hamt.tryGetHash = function (alt, hash, key, map) {
  var node = map._root;
  var shift = 0;
  var keyEq = map._config.keyEq;

  while (true) {
    switch (node.type) {
      case LEAF:
        {
          return keyEq(key, node.key) ? node.value : alt;
        }

      case COLLISION:
        {
          if (hash === node.hash) {
            var children = node.children;

            for (var i = 0, len = children.length; i < len; ++i) {
              var child = children[i];
              if (keyEq(key, child.key)) return child.value;
            }
          }

          return alt;
        }

      case INDEX:
        {
          var frag = hashFragment(shift, hash);
          var bit = toBitmap(frag);

          if (node.mask & bit) {
            node = node.children[fromBitmap(node.mask, bit)];
            shift += SIZE;
            break;
          }

          return alt;
        }

      case ARRAY:
        {
          node = node.children[hashFragment(shift, hash)];

          if (node) {
            shift += SIZE;
            break;
          }

          return alt;
        }

      default:
        return alt;
    }
  }
};

Map.prototype.tryGetHash = function (alt, hash, key) {
  return tryGetHash(alt, hash, key, this);
};
/**
    Lookup the value for `key` in `map` using internal hash function.

    @see `tryGetHash`
*/


var tryGet = hamt.tryGet = function (alt, key, map) {
  return tryGetHash(alt, map._config.hash(key), key, map);
};

Map.prototype.tryGet = function (alt, key) {
  return tryGet(alt, key, this);
};
/**
    Lookup the value for `key` in `map` using a custom `hash`.

    Returns the value or `undefined` if none.
*/


var getHash = hamt.getHash = function (hash, key, map) {
  return tryGetHash(undefined, hash, key, map);
};

Map.prototype.getHash = function (hash, key) {
  return getHash(hash, key, this);
};
/**
    Lookup the value for `key` in `map` using internal hash function.

    @see `get`
*/


var get = hamt.get = function (key, map) {
  return tryGetHash(undefined, map._config.hash(key), key, map);
};

Map.prototype.get = function (key, alt) {
  return tryGet(alt, key, this);
};
/**
    Does an entry exist for `key` in `map`? Uses custom `hash`.
*/


var hasHash = hamt.has = function (hash, key, map) {
  return tryGetHash(nothing, hash, key, map) !== nothing;
};

Map.prototype.hasHash = function (hash, key) {
  return hasHash(hash, key, this);
};
/**
    Does an entry exist for `key` in `map`? Uses internal hash function.
*/


var has = hamt.has = function (key, map) {
  return hasHash(map._config.hash(key), key, map);
};

Map.prototype.has = function (key) {
  return has(key, this);
};

var defKeyCompare = function defKeyCompare(x, y) {
  return x === y;
};
/**
    Create an empty map.

    @param config Configuration.
*/


hamt.make = function (config) {
  return new Map(0, 0, {
    keyEq: config && config.keyEq || defKeyCompare,
    hash: config && config.hash || hash
  }, empty, 0);
};
/**
    Empty map.
*/


hamt.empty = hamt.make();
/**
    Does `map` contain any elements?
*/

var isEmpty = hamt.isEmpty = function (map) {
  return map && !!isEmptyNode(map._root);
};

Map.prototype.isEmpty = function () {
  return isEmpty(this);
};
/* Updates
 ******************************************************************************/

/**
    Alter the value stored for `key` in `map` using function `f` using
    custom hash.

    `f` is invoked with the current value for `k` if it exists,
    or no arguments if no such value exists. `modify` will always either
    update or insert a value into the map.

    Returns a map with the modified value. Does not alter `map`.
*/


var modifyHash = hamt.modifyHash = function (f, hash, key, map) {
  var size = {
    value: map._size
  };

  var newRoot = map._root._modify(map._editable ? map._edit : NaN, map._config.keyEq, 0, f, hash, key, size);

  return map.setTree(newRoot, size.value);
};

Map.prototype.modifyHash = function (hash, key, f) {
  return modifyHash(f, hash, key, this);
};
/**
    Alter the value stored for `key` in `map` using function `f` using
    internal hash function.

    @see `modifyHash`
*/


var modify = hamt.modify = function (f, key, map) {
  return modifyHash(f, map._config.hash(key), key, map);
};

Map.prototype.modify = function (key, f) {
  return modify(f, key, this);
};
/**
    Store `value` for `key` in `map` using custom `hash`.

    Returns a map with the modified value. Does not alter `map`.
*/


var setHash = hamt.setHash = function (hash, key, value, map) {
  return modifyHash(constant(value), hash, key, map);
};

Map.prototype.setHash = function (hash, key, value) {
  return setHash(hash, key, value, this);
};
/**
    Store `value` for `key` in `map` using internal hash function.

    @see `setHash`
*/


var set = hamt.set = function (key, value, map) {
  return setHash(map._config.hash(key), key, value, map);
};

Map.prototype.set = function (key, value) {
  return set(key, value, this);
};
/**
    Remove the entry for `key` in `map`.

    Returns a map with the value removed. Does not alter `map`.
*/


var del = constant(nothing);

var removeHash = hamt.removeHash = function (hash, key, map) {
  return modifyHash(del, hash, key, map);
};

Map.prototype.removeHash = Map.prototype.deleteHash = function (hash, key) {
  return removeHash(hash, key, this);
};
/**
    Remove the entry for `key` in `map` using internal hash function.

    @see `removeHash`
*/


var remove = hamt.remove = function (key, map) {
  return removeHash(map._config.hash(key), key, map);
};

Map.prototype.remove = Map.prototype.delete = function (key) {
  return remove(key, this);
};
/* Mutation
 ******************************************************************************/

/**
    Mark `map` as mutable.
 */


var beginMutation = hamt.beginMutation = function (map) {
  return new Map(map._editable + 1, map._edit + 1, map._config, map._root, map._size);
};

Map.prototype.beginMutation = function () {
  return beginMutation(this);
};
/**
    Mark `map` as immutable.
 */


var endMutation = hamt.endMutation = function (map) {
  map._editable = map._editable && map._editable - 1;
  return map;
};

Map.prototype.endMutation = function () {
  return endMutation(this);
};
/**
    Mutate `map` within the context of `f`.
    @param f
    @param map HAMT
*/


var mutate = hamt.mutate = function (f, map) {
  var transient = beginMutation(map);
  f(transient);
  return endMutation(transient);
};

Map.prototype.mutate = function (f) {
  return mutate(f, this);
};
/* Traversal
 ******************************************************************************/

/**
    Apply a continuation.
*/


var appk = function appk(k) {
  return k && lazyVisitChildren(k[0], k[1], k[2], k[3], k[4]);
};
/**
    Recursively visit all values stored in an array of nodes lazily.
*/


var lazyVisitChildren = function lazyVisitChildren(len, children, i, f, k) {
  while (i < len) {
    var child = children[i++];
    if (child && !isEmptyNode(child)) return lazyVisit(child, f, [len, children, i, f, k]);
  }

  return appk(k);
};
/**
    Recursively visit all values stored in `node` lazily.
*/


var lazyVisit = function lazyVisit(node, f, k) {
  switch (node.type) {
    case LEAF:
      return {
        value: f(node),
        rest: k
      };

    case COLLISION:
    case ARRAY:
    case INDEX:
      var children = node.children;
      return lazyVisitChildren(children.length, children, 0, f, k);

    default:
      return appk(k);
  }
};

var DONE = {
  done: true
};
/**
    Javascript iterator over a map.
*/

function MapIterator(v) {
  this.v = v;
}

MapIterator.prototype.next = function () {
  if (!this.v) return DONE;
  var v0 = this.v;
  this.v = appk(v0.rest);
  return v0;
};

MapIterator.prototype[Symbol.iterator] = function () {
  return this;
};
/**
    Lazily visit each value in map with function `f`.
*/


var visit = function visit(map, f) {
  return new MapIterator(lazyVisit(map._root, f));
};
/**
    Get a Javascsript iterator of `map`.

    Iterates over `[key, value]` arrays.
*/


var buildPairs = function buildPairs(x) {
  return [x.key, x.value];
};

var entries = hamt.entries = function (map) {
  return visit(map, buildPairs);
};

Map.prototype.entries = Map.prototype[Symbol.iterator] = function () {
  return entries(this);
};
/**
    Get array of all keys in `map`.

    Order is not guaranteed.
*/


var buildKeys = function buildKeys(x) {
  return x.key;
};

var keys = hamt.keys = function (map) {
  return visit(map, buildKeys);
};

Map.prototype.keys = function () {
  return keys(this);
};
/**
    Get array of all values in `map`.

    Order is not guaranteed, duplicates are preserved.
*/


var buildValues = function buildValues(x) {
  return x.value;
};

var values = hamt.values = Map.prototype.values = function (map) {
  return visit(map, buildValues);
};

Map.prototype.values = function () {
  return values(this);
};
/* Fold
 ******************************************************************************/

/**
    Visit every entry in the map, aggregating data.

    Order of nodes is not guaranteed.

    @param f Function mapping accumulated value, value, and key to new value.
    @param z Starting value.
    @param m HAMT
*/


var fold = hamt.fold = function (f, z, m) {
  var root = m._root;
  if (root.type === LEAF) return f(z, root.value, root.key);
  var toVisit = [root.children];
  var children = void 0;

  while (children = toVisit.pop()) {
    for (var i = 0, len = children.length; i < len;) {
      var child = children[i++];

      if (child && child.type) {
        if (child.type === LEAF) z = f(z, child.value, child.key);else toVisit.push(child.children);
      }
    }
  }

  return z;
};

Map.prototype.fold = function (f, z) {
  return fold(f, z, this);
};
/**
    Visit every entry in the map, aggregating data.

    Order of nodes is not guaranteed.

    @param f Function invoked with value and key
    @param map HAMT
*/


var forEach = hamt.forEach = function (f, map) {
  return fold(function (_, value, key) {
    return f(value, key, map);
  }, null, map);
};

Map.prototype.forEach = function (f) {
  return forEach(f, this);
};
/* Aggregate
 ******************************************************************************/

/**
    Get the number of entries in `map`.
*/


var count = hamt.count = function (map) {
  return map._size;
};

Map.prototype.count = function () {
  return count(this);
};

Object.defineProperty(Map.prototype, 'size', {
  get: Map.prototype.count
});
/* Export
 ******************************************************************************/

if ( module.exports) {
  module.exports = hamt;
} else {
  undefined.hamt = hamt;
}
});

class BuiltInMap {
  constructor(existing) {
    _defineProperty(this, "_map", void 0);

    this._map = new Map(existing === null || existing === void 0 ? void 0 : existing.entries());
  }

  keys() {
    return this._map.keys();
  }

  entries() {
    return this._map.entries();
  }

  get(k) {
    return this._map.get(k);
  }

  has(k) {
    return this._map.has(k);
  }

  set(k, v) {
    this._map.set(k, v);

    return this;
  }

  delete(k) {
    this._map.delete(k);

    return this;
  }

  clone() {
    return persistentMap(this);
  }

  toMap() {
    return new Map(this._map);
  }

}

class HashArrayMappedTrieMap {
  // Because hamt.empty is not a function there is no way to introduce type
  // parameters on it, so empty is typed as HAMTPlusMap<string, mixed>.
  // $FlowIssue
  constructor(existing) {
    _defineProperty(this, "_hamt", hamt_1.empty.beginMutation());

    if (existing instanceof HashArrayMappedTrieMap) {
      const h = existing._hamt.endMutation();

      existing._hamt = h.beginMutation();
      this._hamt = h.beginMutation();
    } else if (existing) {
      for (const [k, v] of existing.entries()) {
        this._hamt.set(k, v);
      }
    }
  }

  keys() {
    return this._hamt.keys();
  }

  entries() {
    return this._hamt.entries();
  }

  get(k) {
    return this._hamt.get(k);
  }

  has(k) {
    return this._hamt.has(k);
  }

  set(k, v) {
    this._hamt.set(k, v);

    return this;
  }

  delete(k) {
    this._hamt.delete(k);

    return this;
  }

  clone() {
    return persistentMap(this);
  }

  toMap() {
    return new Map(this._hamt);
  }

}

function persistentMap(existing) {
  if (Recoil_gkx('recoil_hamt_2020')) {
    return new HashArrayMappedTrieMap(existing);
  } else {
    return new BuiltInMap(existing);
  }
}

var Recoil_PersistentMap = {
  persistentMap
};

var Recoil_PersistentMap_1 = Recoil_PersistentMap.persistentMap;

var Recoil_PersistentMap$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  persistentMap: Recoil_PersistentMap_1
});

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Returns a set containing all of the values from the first set that are not
 * present in any of the subsequent sets.
 *
 * Note: this is written procedurally (i.e., without filterSet) for performant
 * use in tight loops.
 */

function differenceSets(set, ...setsWithValuesToRemove) {
  const ret = new Set();

  FIRST: for (const value of set) {
    for (const otherSet of setsWithValuesToRemove) {
      if (otherSet.has(value)) {
        continue FIRST;
      }
    }

    ret.add(value);
  }

  return ret;
}

var Recoil_differenceSets = differenceSets;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Returns a new Map object with the same keys as the original, but with the
 * values replaced with the output of the given callback function.
 */

function mapMap(map, callback) {
  const result = new Map();
  map.forEach((value, key) => {
    result.set(key, callback(value, key));
  });
  return result;
}

var Recoil_mapMap = mapMap;

function makeGraph() {
  return {
    nodeDeps: new Map(),
    nodeToNodeSubscriptions: new Map()
  };
}

function cloneGraph(graph) {
  return {
    nodeDeps: Recoil_mapMap(graph.nodeDeps, s => new Set(s)),
    nodeToNodeSubscriptions: Recoil_mapMap(graph.nodeToNodeSubscriptions, s => new Set(s))
  };
} // Note that this overwrites the deps of existing nodes, rather than unioning
// the new deps with the old deps.


function mergeDepsIntoGraph(key, newDeps, graph, // If olderGraph is given then we will not overwrite changes made to the given
// graph compared with olderGraph:
olderGraph) {
  const {
    nodeDeps,
    nodeToNodeSubscriptions
  } = graph;
  const oldDeps = nodeDeps.get(key);

  if (oldDeps && olderGraph && oldDeps !== olderGraph.nodeDeps.get(key)) {
    return;
  } // Update nodeDeps:


  nodeDeps.set(key, newDeps); // Add new deps to nodeToNodeSubscriptions:

  const addedDeps = oldDeps == null ? newDeps : Recoil_differenceSets(newDeps, oldDeps);

  for (const dep of addedDeps) {
    if (!nodeToNodeSubscriptions.has(dep)) {
      nodeToNodeSubscriptions.set(dep, new Set());
    }

    const existing = Recoil_nullthrows(nodeToNodeSubscriptions.get(dep));
    existing.add(key);
  } // Remove removed deps from nodeToNodeSubscriptions:


  if (oldDeps) {
    const removedDeps = Recoil_differenceSets(oldDeps, newDeps);

    for (const dep of removedDeps) {
      if (!nodeToNodeSubscriptions.has(dep)) {
        return;
      }

      const existing = Recoil_nullthrows(nodeToNodeSubscriptions.get(dep));
      existing.delete(key);

      if (existing.size === 0) {
        nodeToNodeSubscriptions.delete(dep);
      }
    }
  }
}

function saveDepsToStore(key, deps, store, version) {
  var _storeState$nextTree, _storeState$previousT, _storeState$previousT2, _storeState$previousT3;

  const storeState = store.getState();

  if (!(version === storeState.currentTree.version || version === ((_storeState$nextTree = storeState.nextTree) === null || _storeState$nextTree === void 0 ? void 0 : _storeState$nextTree.version) || version === ((_storeState$previousT = storeState.previousTree) === null || _storeState$previousT === void 0 ? void 0 : _storeState$previousT.version))) {
    Recoil_recoverableViolation('Tried to save dependencies to a discarded tree');
  } // Merge the dependencies discovered into the store's dependency map
  // for the version that was read:


  const graph = store.getGraph(version);
  mergeDepsIntoGraph(key, deps, graph); // If this version is not the latest version, also write these dependencies
  // into later versions if they don't already have their own:

  if (version === ((_storeState$previousT2 = storeState.previousTree) === null || _storeState$previousT2 === void 0 ? void 0 : _storeState$previousT2.version)) {
    const currentGraph = store.getGraph(storeState.currentTree.version);
    mergeDepsIntoGraph(key, deps, currentGraph, graph);
  }

  if (version === ((_storeState$previousT3 = storeState.previousTree) === null || _storeState$previousT3 === void 0 ? void 0 : _storeState$previousT3.version) || version === storeState.currentTree.version) {
    var _storeState$nextTree2;

    const nextVersion = (_storeState$nextTree2 = storeState.nextTree) === null || _storeState$nextTree2 === void 0 ? void 0 : _storeState$nextTree2.version;

    if (nextVersion !== undefined) {
      const nextGraph = store.getGraph(nextVersion);
      mergeDepsIntoGraph(key, deps, nextGraph, graph);
    }
  }
}

var Recoil_Graph = {
  cloneGraph,
  graph: makeGraph,
  saveDepsToStore
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

let nextTreeStateVersion = 0;

const getNextTreeStateVersion = () => nextTreeStateVersion++;

let nextStoreID = 0;

const getNextStoreID = () => nextStoreID++;

let nextComponentID = 0;

const getNextComponentID = () => nextComponentID++;

var Recoil_Keys = {
  getNextTreeStateVersion,
  getNextStoreID,
  getNextComponentID
};

const {
  persistentMap: persistentMap$1
} = Recoil_PersistentMap$1;

const {
  graph
} = Recoil_Graph;

const {
  getNextTreeStateVersion: getNextTreeStateVersion$1
} = Recoil_Keys;

function makeEmptyTreeState() {
  const version = getNextTreeStateVersion$1();
  return {
    version,
    stateID: version,
    transactionMetadata: {},
    dirtyAtoms: new Set(),
    atomValues: persistentMap$1(),
    nonvalidatedAtoms: persistentMap$1()
  };
}

function makeEmptyStoreState() {
  const currentTree = makeEmptyTreeState();
  return {
    currentTree,
    nextTree: null,
    previousTree: null,
    commitDepth: 0,
    knownAtoms: new Set(),
    knownSelectors: new Set(),
    transactionSubscriptions: new Map(),
    nodeTransactionSubscriptions: new Map(),
    nodeToComponentSubscriptions: new Map(),
    queuedComponentCallbacks_DEPRECATED: [],
    suspendedComponentResolvers: new Set(),
    graphsByVersion: new Map().set(currentTree.version, graph()),
    retention: {
      referenceCounts: new Map(),
      nodesRetainedByZone: new Map(),
      retainablesToCheckForRelease: new Set()
    },
    nodeCleanupFunctions: new Map()
  };
}

var Recoil_State = {
  makeEmptyTreeState,
  makeEmptyStoreState,
  getNextTreeStateVersion: getNextTreeStateVersion$1
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

class RetentionZone {}

function retentionZone() {
  return new RetentionZone();
}

var Recoil_RetentionZone = {
  RetentionZone,
  retentionZone
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Utilities for working with built-in Maps and Sets without mutating them.
 *
 * 
 * @format
 * @oncall recoil
 */

function setByAddingToSet(set, v) {
  const next = new Set(set);
  next.add(v);
  return next;
}

function setByDeletingFromSet(set, v) {
  const next = new Set(set);
  next.delete(v);
  return next;
}

function mapBySettingInMap(map, k, v) {
  const next = new Map(map);
  next.set(k, v);
  return next;
}

function mapByUpdatingInMap(map, k, updater) {
  const next = new Map(map);
  next.set(k, updater(next.get(k)));
  return next;
}

function mapByDeletingFromMap(map, k) {
  const next = new Map(map);
  next.delete(k);
  return next;
}

function mapByDeletingMultipleFromMap(map, ks) {
  const next = new Map(map);
  ks.forEach(k => next.delete(k));
  return next;
}

var Recoil_CopyOnWrite = {
  setByAddingToSet,
  setByDeletingFromSet,
  mapBySettingInMap,
  mapByUpdatingInMap,
  mapByDeletingFromMap,
  mapByDeletingMultipleFromMap
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Creates a new iterable whose output is generated by passing the input
 * iterable's values through the filter function.
 */

function* filterIterable(iterable, predicate) {
  // Use generator to create iterable/iterator
  let index = 0;

  for (const value of iterable) {
    if (predicate(value, index++)) {
      yield value;
    }
  }
}

var Recoil_filterIterable = filterIterable;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Return a proxy object based on the provided base and factories objects.
 * The proxy will include all properties of the base object as-is.
 * The factories object contains callbacks to obtain the values of the properies
 * for its keys.
 *
 * This is useful for providing users an object where some properties may be
 * lazily computed only on first access.
 */
// $FlowIssue[unclear-type]

function lazyProxy(base, factories) {
  const proxy = new Proxy(base, {
    // Compute and cache lazy property if not already done.
    get: (target, prop) => {
      if (!(prop in target) && prop in factories) {
        target[prop] = factories[prop]();
      }

      return target[prop];
    },
    // This method allows user to iterate keys as normal
    ownKeys: target => {

      return Object.keys(target);
    }
  }); // $FlowIssue[incompatible-return]

  return proxy;
}

var Recoil_lazyProxy = lazyProxy;

const {
  getNode: getNode$1,
  getNodeMaybe: getNodeMaybe$1,
  recoilValuesForKeys: recoilValuesForKeys$1
} = Recoil_Node;

const {
  RetentionZone: RetentionZone$1
} = Recoil_RetentionZone;

const {
  setByAddingToSet: setByAddingToSet$1
} = Recoil_CopyOnWrite;







 // flowlint-next-line unclear-type:off


const emptySet = Object.freeze(new Set());

class ReadOnlyRecoilValueError extends Error {}

function initializeRetentionForNode(store, nodeKey, retainedBy) {
  if (!Recoil_gkx('recoil_memory_managament_2020')) {
    return () => undefined;
  }

  const {
    nodesRetainedByZone
  } = store.getState().retention;

  function addToZone(zone) {
    let set = nodesRetainedByZone.get(zone);

    if (!set) {
      nodesRetainedByZone.set(zone, set = new Set());
    }

    set.add(nodeKey);
  }

  if (retainedBy instanceof RetentionZone$1) {
    addToZone(retainedBy);
  } else if (Array.isArray(retainedBy)) {
    for (const zone of retainedBy) {
      addToZone(zone);
    }
  }

  return () => {
    if (!Recoil_gkx('recoil_memory_managament_2020')) {
      return;
    }

    const {
      retention
    } = store.getState();

    function deleteFromZone(zone) {
      const set = retention.nodesRetainedByZone.get(zone);
      set === null || set === void 0 ? void 0 : set.delete(nodeKey);

      if (set && set.size === 0) {
        retention.nodesRetainedByZone.delete(zone);
      }
    }

    if (retainedBy instanceof RetentionZone$1) {
      deleteFromZone(retainedBy);
    } else if (Array.isArray(retainedBy)) {
      for (const zone of retainedBy) {
        deleteFromZone(zone);
      }
    }
  };
}

function initializeNodeIfNewToStore(store, treeState, key, trigger) {
  const storeState = store.getState();

  if (storeState.nodeCleanupFunctions.has(key)) {
    return;
  }

  const node = getNode$1(key);
  const retentionCleanup = initializeRetentionForNode(store, key, node.retainedBy);
  const nodeCleanup = node.init(store, treeState, trigger);
  storeState.nodeCleanupFunctions.set(key, () => {
    nodeCleanup();
    retentionCleanup();
  });
}

function initializeNode(store, key, trigger) {
  initializeNodeIfNewToStore(store, store.getState().currentTree, key, trigger);
}

function cleanUpNode(store, key) {
  var _state$nodeCleanupFun;

  const state = store.getState();
  (_state$nodeCleanupFun = state.nodeCleanupFunctions.get(key)) === null || _state$nodeCleanupFun === void 0 ? void 0 : _state$nodeCleanupFun();
  state.nodeCleanupFunctions.delete(key);
} // Get the current value loadable of a node and update the state.
// Update dependencies and subscriptions for selectors.
// Update saved value validation for atoms.


function getNodeLoadable(store, state, key) {
  initializeNodeIfNewToStore(store, state, key, 'get');
  return getNode$1(key).get(store, state);
} // Peek at the current value loadable for a node without any evaluation or state change


function peekNodeLoadable(store, state, key) {
  return getNode$1(key).peek(store, state);
} // Write value directly to state bypassing the Node interface as the node
// definitions may not have been loaded yet when processing the initial snapshot.


function setUnvalidatedAtomValue_DEPRECATED(state, key, newValue) {
  var _node$invalidate;

  const node = getNodeMaybe$1(key);
  node === null || node === void 0 ? void 0 : (_node$invalidate = node.invalidate) === null || _node$invalidate === void 0 ? void 0 : _node$invalidate.call(node, state);
  return { ...state,
    atomValues: state.atomValues.clone().delete(key),
    nonvalidatedAtoms: state.nonvalidatedAtoms.clone().set(key, newValue),
    dirtyAtoms: setByAddingToSet$1(state.dirtyAtoms, key)
  };
} // Return the discovered dependencies and values to be written by setting
// a node value. (Multiple values may be written due to selectors getting to
// set upstreams; deps may be discovered because of reads in updater functions.)


function setNodeValue(store, state, key, newValue) {
  const node = getNode$1(key);

  if (node.set == null) {
    throw new ReadOnlyRecoilValueError(`Attempt to set read-only RecoilValue: ${key}`);
  }

  const set = node.set; // so flow doesn't lose the above refinement.

  initializeNodeIfNewToStore(store, state, key, 'set');
  return set(store, state, newValue);
}

function peekNodeInfo(store, state, key) {
  const storeState = store.getState();
  const graph = store.getGraph(state.version);
  const type = getNode$1(key).nodeType;
  return Recoil_lazyProxy({
    type
  }, {
    // $FlowFixMe[underconstrained-implicit-instantiation]
    loadable: () => peekNodeLoadable(store, state, key),
    isActive: () => storeState.knownAtoms.has(key) || storeState.knownSelectors.has(key),
    isSet: () => type === 'selector' ? false : state.atomValues.has(key),
    isModified: () => state.dirtyAtoms.has(key),
    // Report current dependencies.  If the node hasn't been evaluated, then
    // dependencies may be missing based on the current state.
    deps: () => {
      var _graph$nodeDeps$get;

      return recoilValuesForKeys$1((_graph$nodeDeps$get = graph.nodeDeps.get(key)) !== null && _graph$nodeDeps$get !== void 0 ? _graph$nodeDeps$get : []);
    },
    // Reports all "current" subscribers.  Evaluating other nodes or
    // previous in-progress async evaluations may introduce new subscribers.
    subscribers: () => {
      var _storeState$nodeToCom, _storeState$nodeToCom2;

      return {
        nodes: recoilValuesForKeys$1(Recoil_filterIterable(getDownstreamNodes(store, state, new Set([key])), nodeKey => nodeKey !== key)),
        components: Recoil_mapIterable((_storeState$nodeToCom = (_storeState$nodeToCom2 = storeState.nodeToComponentSubscriptions.get(key)) === null || _storeState$nodeToCom2 === void 0 ? void 0 : _storeState$nodeToCom2.values()) !== null && _storeState$nodeToCom !== void 0 ? _storeState$nodeToCom : [], ([name]) => ({
          name
        }))
      };
    }
  });
} // Find all of the recursively dependent nodes


function getDownstreamNodes(store, state, keys) {
  const visitedNodes = new Set();
  const visitingNodes = Array.from(keys);
  const graph = store.getGraph(state.version);

  for (let key = visitingNodes.pop(); key; key = visitingNodes.pop()) {
    var _graph$nodeToNodeSubs;

    visitedNodes.add(key);
    const subscribedNodes = (_graph$nodeToNodeSubs = graph.nodeToNodeSubscriptions.get(key)) !== null && _graph$nodeToNodeSubs !== void 0 ? _graph$nodeToNodeSubs : emptySet;

    for (const downstreamNode of subscribedNodes) {
      if (!visitedNodes.has(downstreamNode)) {
        visitingNodes.push(downstreamNode);
      }
    }
  }

  return visitedNodes;
}

var Recoil_FunctionalCore = {
  getNodeLoadable,
  peekNodeLoadable,
  setNodeValue,
  initializeNode,
  cleanUpNode,
  setUnvalidatedAtomValue_DEPRECATED,
  peekNodeInfo,
  getDownstreamNodes
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

let _invalidateMemoizedSnapshot = null;

function setInvalidateMemoizedSnapshot(invalidate) {
  _invalidateMemoizedSnapshot = invalidate;
}

function invalidateMemoizedSnapshot() {
  var _invalidateMemoizedSn;

  (_invalidateMemoizedSn = _invalidateMemoizedSnapshot) === null || _invalidateMemoizedSn === void 0 ? void 0 : _invalidateMemoizedSn();
}

var Recoil_SnapshotCache = {
  setInvalidateMemoizedSnapshot,
  invalidateMemoizedSnapshot
};

const {
  getDownstreamNodes: getDownstreamNodes$1,
  getNodeLoadable: getNodeLoadable$1,
  setNodeValue: setNodeValue$1
} = Recoil_FunctionalCore;

const {
  getNextComponentID: getNextComponentID$1
} = Recoil_Keys;

const {
  getNode: getNode$2,
  getNodeMaybe: getNodeMaybe$2
} = Recoil_Node;

const {
  DefaultValue: DefaultValue$1
} = Recoil_Node;

const {
  reactMode: reactMode$1
} = Recoil_ReactMode;

const {
  AbstractRecoilValue: AbstractRecoilValue$1,
  RecoilState: RecoilState$1,
  RecoilValueReadOnly: RecoilValueReadOnly$1,
  isRecoilValue: isRecoilValue$1
} = Recoil_RecoilValue$1;

const {
  invalidateMemoizedSnapshot: invalidateMemoizedSnapshot$1
} = Recoil_SnapshotCache;







function getRecoilValueAsLoadable(store, {
  key
}, treeState = store.getState().currentTree) {
  var _storeState$nextTree, _storeState$previousT;

  // Reading from an older tree can cause bugs because the dependencies that we
  // discover during the read are lost.
  const storeState = store.getState();

  if (!(treeState.version === storeState.currentTree.version || treeState.version === ((_storeState$nextTree = storeState.nextTree) === null || _storeState$nextTree === void 0 ? void 0 : _storeState$nextTree.version) || treeState.version === ((_storeState$previousT = storeState.previousTree) === null || _storeState$previousT === void 0 ? void 0 : _storeState$previousT.version))) {
    Recoil_recoverableViolation('Tried to read from a discarded tree');
  }

  const loadable = getNodeLoadable$1(store, treeState, key);

  if (loadable.state === 'loading') {
    loadable.contents.catch(() => {
      /**
       * HACK: intercept thrown error here to prevent an uncaught promise exception. Ideally this would happen closer to selector
       * execution (perhaps introducing a new ERROR class to be resolved by async selectors that are in an error state)
       */
      return;
    });
  }

  return loadable;
}

function applyAtomValueWrites(atomValues, writes) {
  const result = atomValues.clone();
  writes.forEach((v, k) => {
    if (v.state === 'hasValue' && v.contents instanceof DefaultValue$1) {
      result.delete(k);
    } else {
      result.set(k, v);
    }
  });
  return result;
}

function valueFromValueOrUpdater(store, state, {
  key
}, valueOrUpdater) {
  if (typeof valueOrUpdater === 'function') {
    // Updater form: pass in the current value. Throw if the current value
    // is unavailable (namely when updating an async selector that's
    // pending or errored):
    const current = getNodeLoadable$1(store, state, key);

    if (current.state === 'loading') {
      const msg = `Tried to set atom or selector "${key}" using an updater function while the current state is pending, this is not currently supported.`;
      Recoil_recoverableViolation(msg);
      throw Recoil_err(msg);
    } else if (current.state === 'hasError') {
      throw current.contents;
    } // T itself may be a function, so our refinement is not sufficient:


    return valueOrUpdater(current.contents); // flowlint-line unclear-type:off
  } else {
    return valueOrUpdater;
  }
}

function applyAction(store, state, action) {
  if (action.type === 'set') {
    const {
      recoilValue,
      valueOrUpdater
    } = action;
    const newValue = valueFromValueOrUpdater(store, state, recoilValue, valueOrUpdater);
    const writes = setNodeValue$1(store, state, recoilValue.key, newValue);

    for (const [key, loadable] of writes.entries()) {
      writeLoadableToTreeState(state, key, loadable);
    }
  } else if (action.type === 'setLoadable') {
    const {
      recoilValue: {
        key
      },
      loadable
    } = action;
    writeLoadableToTreeState(state, key, loadable);
  } else if (action.type === 'markModified') {
    const {
      recoilValue: {
        key
      }
    } = action;
    state.dirtyAtoms.add(key);
  } else if (action.type === 'setUnvalidated') {
    var _node$invalidate;

    // Write value directly to state bypassing the Node interface as the node
    // definitions may not have been loaded yet when processing the initial snapshot.
    const {
      recoilValue: {
        key
      },
      unvalidatedValue
    } = action;
    const node = getNodeMaybe$2(key);
    node === null || node === void 0 ? void 0 : (_node$invalidate = node.invalidate) === null || _node$invalidate === void 0 ? void 0 : _node$invalidate.call(node, state);
    state.atomValues.delete(key);
    state.nonvalidatedAtoms.set(key, unvalidatedValue);
    state.dirtyAtoms.add(key);
  } else {
    Recoil_recoverableViolation(`Unknown action ${action.type}`);
  }
}

function writeLoadableToTreeState(state, key, loadable) {
  if (loadable.state === 'hasValue' && loadable.contents instanceof DefaultValue$1) {
    state.atomValues.delete(key);
  } else {
    state.atomValues.set(key, loadable);
  }

  state.dirtyAtoms.add(key);
  state.nonvalidatedAtoms.delete(key);
}

function applyActionsToStore(store, actions) {
  store.replaceState(state => {
    const newState = copyTreeState(state);

    for (const action of actions) {
      applyAction(store, newState, action);
    }

    invalidateDownstreams(store, newState);
    invalidateMemoizedSnapshot$1();
    return newState;
  });
}

function queueOrPerformStateUpdate(store, action) {
  if (batchStack.length) {
    const actionsByStore = batchStack[batchStack.length - 1];
    let actions = actionsByStore.get(store);

    if (!actions) {
      actionsByStore.set(store, actions = []);
    }

    actions.push(action);
  } else {
    applyActionsToStore(store, [action]);
  }
}

const batchStack = [];

function batchStart() {
  const actionsByStore = new Map();
  batchStack.push(actionsByStore);
  return () => {
    for (const [store, actions] of actionsByStore) {
      applyActionsToStore(store, actions);
    }

    const popped = batchStack.pop();

    if (popped !== actionsByStore) {
      Recoil_recoverableViolation('Incorrect order of batch popping');
    }
  };
}

function copyTreeState(state) {
  return { ...state,
    atomValues: state.atomValues.clone(),
    nonvalidatedAtoms: state.nonvalidatedAtoms.clone(),
    dirtyAtoms: new Set(state.dirtyAtoms)
  };
}

function invalidateDownstreams(store, state) {
  // Inform any nodes that were changed or downstream of changes so that they
  // can clear out any caches as needed due to the update:
  const downstreams = getDownstreamNodes$1(store, state, state.dirtyAtoms);

  for (const key of downstreams) {
    var _getNodeMaybe, _getNodeMaybe$invalid;

    (_getNodeMaybe = getNodeMaybe$2(key)) === null || _getNodeMaybe === void 0 ? void 0 : (_getNodeMaybe$invalid = _getNodeMaybe.invalidate) === null || _getNodeMaybe$invalid === void 0 ? void 0 : _getNodeMaybe$invalid.call(_getNodeMaybe, state);
  }
}

function setRecoilValue(store, recoilValue, valueOrUpdater) {
  queueOrPerformStateUpdate(store, {
    type: 'set',
    recoilValue,
    valueOrUpdater
  });
}

function setRecoilValueLoadable(store, recoilValue, loadable) {
  if (loadable instanceof DefaultValue$1) {
    return setRecoilValue(store, recoilValue, loadable);
  }

  queueOrPerformStateUpdate(store, {
    type: 'setLoadable',
    recoilValue,
    loadable: loadable
  });
}

function markRecoilValueModified(store, recoilValue) {
  queueOrPerformStateUpdate(store, {
    type: 'markModified',
    recoilValue
  });
}

function setUnvalidatedRecoilValue(store, recoilValue, unvalidatedValue) {
  queueOrPerformStateUpdate(store, {
    type: 'setUnvalidated',
    recoilValue,
    unvalidatedValue
  });
}

function subscribeToRecoilValue(store, {
  key
}, callback, componentDebugName = null) {
  const subID = getNextComponentID$1();
  const storeState = store.getState();

  if (!storeState.nodeToComponentSubscriptions.has(key)) {
    storeState.nodeToComponentSubscriptions.set(key, new Map());
  }

  Recoil_nullthrows(storeState.nodeToComponentSubscriptions.get(key)).set(subID, [componentDebugName !== null && componentDebugName !== void 0 ? componentDebugName : '<not captured>', callback]); // Handle the case that, during the same tick that we are subscribing, an atom
  // has been updated by some effect handler. Otherwise we will miss the update.

  const mode = reactMode$1();

  if (mode.early && (mode.mode === 'LEGACY' || mode.mode === 'MUTABLE_SOURCE')) {
    const nextTree = store.getState().nextTree;

    if (nextTree && nextTree.dirtyAtoms.has(key)) {
      callback(nextTree);
    }
  }

  return {
    release: () => {
      const releaseStoreState = store.getState();
      const subs = releaseStoreState.nodeToComponentSubscriptions.get(key);

      if (subs === undefined || !subs.has(subID)) {
        Recoil_recoverableViolation(`Subscription missing at release time for atom ${key}. This is a bug in Recoil.`);
        return;
      }

      subs.delete(subID);

      if (subs.size === 0) {
        releaseStoreState.nodeToComponentSubscriptions.delete(key);
      }
    }
  };
}

function refreshRecoilValue(store, recoilValue) {
  var _node$clearCache;

  const {
    currentTree
  } = store.getState();
  const node = getNode$2(recoilValue.key);
  (_node$clearCache = node.clearCache) === null || _node$clearCache === void 0 ? void 0 : _node$clearCache.call(node, store, currentTree);
}

var Recoil_RecoilValueInterface = {
  RecoilValueReadOnly: RecoilValueReadOnly$1,
  AbstractRecoilValue: AbstractRecoilValue$1,
  RecoilState: RecoilState$1,
  getRecoilValueAsLoadable,
  setRecoilValue,
  setRecoilValueLoadable,
  markRecoilValueModified,
  setUnvalidatedRecoilValue,
  subscribeToRecoilValue,
  isRecoilValue: isRecoilValue$1,
  applyAtomValueWrites,
  // TODO Remove export when deprecating initialStoreState_DEPRECATED in RecoilRoot
  batchStart,
  writeLoadableToTreeState,
  invalidateDownstreams,
  copyTreeState,
  refreshRecoilValue
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * The someSet() method tests whether some elements in the given Set pass the
 * test implemented by the provided function.
 */

function someSet(set, callback, context) {
  const iterator = set.entries();
  let current = iterator.next();

  while (!current.done) {
    const entry = current.value;

    if (callback.call(context, entry[1], entry[0], set)) {
      return true;
    }

    current = iterator.next();
  }

  return false;
}

var Recoil_someSet = someSet;

const {
  cleanUpNode: cleanUpNode$1
} = Recoil_FunctionalCore;

const {
  deleteNodeConfigIfPossible: deleteNodeConfigIfPossible$1,
  getNode: getNode$3
} = Recoil_Node;

const {
  RetentionZone: RetentionZone$2
} = Recoil_RetentionZone;







 // Components that aren't mounted after suspending for this long will be assumed
// to be discarded and their resources released.


const SUSPENSE_TIMEOUT_MS = 120000;
const emptySet$1 = new Set();

function releaseRetainablesNowOnCurrentTree(store, retainables) {
  const storeState = store.getState();
  const treeState = storeState.currentTree;

  if (storeState.nextTree) {
    Recoil_recoverableViolation('releaseNodesNowOnCurrentTree should only be called at the end of a batch');
    return; // leak memory rather than erase something that's about to be used.
  }

  const nodes = new Set();

  for (const r of retainables) {
    if (r instanceof RetentionZone$2) {
      for (const n of nodesRetainedByZone(storeState, r)) {
        nodes.add(n);
      }
    } else {
      nodes.add(r);
    }
  }

  const releasableNodes = findReleasableNodes(store, nodes);

  for (const node of releasableNodes) {
    releaseNode(store, treeState, node);
  }
}

function findReleasableNodes(store, searchFromNodes) {
  const storeState = store.getState();
  const treeState = storeState.currentTree;
  const graph = store.getGraph(treeState.version);
  const releasableNodes = new Set(); // mutated to collect answer

  const nonReleasableNodes = new Set();
  findReleasableNodesInner(searchFromNodes);
  return releasableNodes;

  function findReleasableNodesInner(searchFromNodes) {
    const releasableNodesFoundThisIteration = new Set();
    const downstreams = getDownstreamNodesInTopologicalOrder(store, treeState, searchFromNodes, releasableNodes, // don't descend into these
    nonReleasableNodes // don't descend into these
    ); // Find which of the downstream nodes are releasable and which are not:

    for (const node of downstreams) {
      var _storeState$retention;

      // Not releasable if configured to be retained forever:
      if (getNode$3(node).retainedBy === 'recoilRoot') {
        nonReleasableNodes.add(node);
        continue;
      } // Not releasable if retained directly by a component:


      if (((_storeState$retention = storeState.retention.referenceCounts.get(node)) !== null && _storeState$retention !== void 0 ? _storeState$retention : 0) > 0) {
        nonReleasableNodes.add(node);
        continue;
      } // Not releasable if retained by a zone:


      if (zonesThatCouldRetainNode(node).some(z => storeState.retention.referenceCounts.get(z))) {
        nonReleasableNodes.add(node);
        continue;
      } // Not releasable if it has a non-releasable child (which will already be in
      // nonReleasableNodes because we are going in topological order):


      const nodeChildren = graph.nodeToNodeSubscriptions.get(node);

      if (nodeChildren && Recoil_someSet(nodeChildren, child => nonReleasableNodes.has(child))) {
        nonReleasableNodes.add(node);
        continue;
      }

      releasableNodes.add(node);
      releasableNodesFoundThisIteration.add(node);
    } // If we found any releasable nodes, we need to walk UP from those nodes to
    // find whether their parents can now be released as well:


    const parents = new Set();

    for (const node of releasableNodesFoundThisIteration) {
      for (const parent of (_graph$nodeDeps$get = graph.nodeDeps.get(node)) !== null && _graph$nodeDeps$get !== void 0 ? _graph$nodeDeps$get : emptySet$1) {
        var _graph$nodeDeps$get;

        if (!releasableNodes.has(parent)) {
          parents.add(parent);
        }
      }
    }

    if (parents.size) {
      findReleasableNodesInner(parents);
    }
  }
} // Children before parents


function getDownstreamNodesInTopologicalOrder(store, treeState, nodes, // Mutable set is destroyed in place
doNotDescendInto1, doNotDescendInto2) {
  const graph = store.getGraph(treeState.version);
  const answer = [];
  const visited = new Set();

  while (nodes.size > 0) {
    visit(Recoil_nullthrows(nodes.values().next().value));
  }

  return answer;

  function visit(node) {
    if (doNotDescendInto1.has(node) || doNotDescendInto2.has(node)) {
      nodes.delete(node);
      return;
    }

    if (visited.has(node)) {
      return;
    }

    const children = graph.nodeToNodeSubscriptions.get(node);

    if (children) {
      for (const child of children) {
        visit(child);
      }
    }

    visited.add(node);
    nodes.delete(node);
    answer.push(node);
  }
}

function releaseNode(store, treeState, node) {
  if (!Recoil_gkx('recoil_memory_managament_2020')) {
    return;
  } // Atom effects, in-closure caches, etc.:


  cleanUpNode$1(store, node); // Delete from store state:

  const storeState = store.getState();
  storeState.knownAtoms.delete(node);
  storeState.knownSelectors.delete(node);
  storeState.nodeTransactionSubscriptions.delete(node);
  storeState.retention.referenceCounts.delete(node);
  const zones = zonesThatCouldRetainNode(node);

  for (const zone of zones) {
    var _storeState$retention2;

    (_storeState$retention2 = storeState.retention.nodesRetainedByZone.get(zone)) === null || _storeState$retention2 === void 0 ? void 0 : _storeState$retention2.delete(node);
  } // Note that we DO NOT delete from nodeToComponentSubscriptions because this
  // already happens when the last component that was retaining the node unmounts,
  // and this could happen either before or after that.
  // Delete from TreeState and dep graph:


  treeState.atomValues.delete(node);
  treeState.dirtyAtoms.delete(node);
  treeState.nonvalidatedAtoms.delete(node);
  const graph = storeState.graphsByVersion.get(treeState.version);

  if (graph) {
    const deps = graph.nodeDeps.get(node);

    if (deps !== undefined) {
      graph.nodeDeps.delete(node);

      for (const dep of deps) {
        var _graph$nodeToNodeSubs;

        (_graph$nodeToNodeSubs = graph.nodeToNodeSubscriptions.get(dep)) === null || _graph$nodeToNodeSubs === void 0 ? void 0 : _graph$nodeToNodeSubs.delete(node);
      }
    } // No need to delete sub's deps as there should be no subs at this point.
    // But an invariant would require deleting nodes in topological order.


    graph.nodeToNodeSubscriptions.delete(node);
  } // Node config (for family members only as their configs can be recreated, and
  // only if they are not retained within any other Stores):


  deleteNodeConfigIfPossible$1(node);
}

function nodesRetainedByZone(storeState, zone) {
  var _storeState$retention3;

  return (_storeState$retention3 = storeState.retention.nodesRetainedByZone.get(zone)) !== null && _storeState$retention3 !== void 0 ? _storeState$retention3 : emptySet$1;
}

function zonesThatCouldRetainNode(node) {
  const retainedBy = getNode$3(node).retainedBy;

  if (retainedBy === undefined || retainedBy === 'components' || retainedBy === 'recoilRoot') {
    return [];
  } else if (retainedBy instanceof RetentionZone$2) {
    return [retainedBy];
  } else {
    return retainedBy; // it's an array of zones
  }
}

function scheduleOrPerformPossibleReleaseOfRetainable(store, retainable) {
  const state = store.getState();

  if (state.nextTree) {
    state.retention.retainablesToCheckForRelease.add(retainable);
  } else {
    releaseRetainablesNowOnCurrentTree(store, new Set([retainable]));
  }
}

function updateRetainCount(store, retainable, delta) {
  var _map$get;

  if (!Recoil_gkx('recoil_memory_managament_2020')) {
    return;
  }

  const map = store.getState().retention.referenceCounts;
  const newCount = ((_map$get = map.get(retainable)) !== null && _map$get !== void 0 ? _map$get : 0) + delta;

  if (newCount === 0) {
    updateRetainCountToZero(store, retainable);
  } else {
    map.set(retainable, newCount);
  }
}

function updateRetainCountToZero(store, retainable) {
  if (!Recoil_gkx('recoil_memory_managament_2020')) {
    return;
  }

  const map = store.getState().retention.referenceCounts;
  map.delete(retainable);
  scheduleOrPerformPossibleReleaseOfRetainable(store, retainable);
}

function releaseScheduledRetainablesNow(store) {
  if (!Recoil_gkx('recoil_memory_managament_2020')) {
    return;
  }

  const state = store.getState();
  releaseRetainablesNowOnCurrentTree(store, state.retention.retainablesToCheckForRelease);
  state.retention.retainablesToCheckForRelease.clear();
}

function retainedByOptionWithDefault(r) {
  // The default will change from 'recoilRoot' to 'components' in the future.
  return r === undefined ? 'recoilRoot' : r;
}

var Recoil_Retention = {
  SUSPENSE_TIMEOUT_MS,
  updateRetainCount,
  updateRetainCountToZero,
  releaseScheduledRetainablesNow,
  retainedByOptionWithDefault
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * This is to export esstiential functions from react-dom
 * for our web build
 *
 * 
 * @format
 * @oncall recoil
 */
const {
  unstable_batchedUpdates
} = react_dom__WEBPACK_IMPORTED_MODULE_1__;

var ReactBatchedUpdates = {
  unstable_batchedUpdates
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * This is to export esstiential functions from react-dom
 * for our web build
 *
 * 
 * @format
 * @oncall recoil
 */
// @fb-only: const {unstable_batchedUpdates} = require('ReactDOMComet');
// prettier-ignore
const {
  unstable_batchedUpdates: unstable_batchedUpdates$1
} = ReactBatchedUpdates; // @oss-only


var Recoil_ReactBatchedUpdates = {
  unstable_batchedUpdates: unstable_batchedUpdates$1
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
const {
  batchStart: batchStart$1
} = Recoil_RecoilValueInterface;

const {
  unstable_batchedUpdates: unstable_batchedUpdates$2
} = Recoil_ReactBatchedUpdates; // flowlint-next-line unclear-type:off


/*
 * During SSR, unstable_batchedUpdates may be undefined so this
 * falls back to a basic function that executes the batch
 */
let batcher = unstable_batchedUpdates$2 || (batchFn => batchFn());
/**
 * Sets the provided batcher function as the batcher function used by Recoil.
 *
 * Set the batcher to a custom batcher for your renderer,
 * if you use a renderer other than React DOM or React Native.
 */


const setBatcher = newBatcher => {
  batcher = newBatcher;
};
/**
 * Returns the current batcher function.
 */


const getBatcher = () => batcher;
/**
 * Calls the current batcher function and passes the
 * provided callback function.
 */


const batchUpdates = callback => {
  batcher(() => {
    let batchEnd = () => undefined;

    try {
      batchEnd = batchStart$1();
      callback();
    } finally {
      batchEnd();
    }
  });
};

var Recoil_Batching = {
  getBatcher,
  setBatcher,
  batchUpdates
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Combines multiple Iterables into a single Iterable.
 * Traverses the input Iterables in the order provided and maintains the order
 * of their elements.
 *
 * Example:
 * ```
 * const r = Array.from(concatIterables(['a', 'b'], ['c'], ['d', 'e', 'f']));
 * r == ['a', 'b', 'c', 'd', 'e', 'f'];
 * ```
 */

function* concatIterables(iters) {
  for (const iter of iters) {
    for (const val of iter) {
      yield val;
    }
  }
}

var Recoil_concatIterables = concatIterables;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/* eslint-disable fb-www/typeof-undefined */

const isSSR = // $FlowFixMe(site=recoil) Window does not have a FlowType definition https://github.com/facebook/flow/issues/6709
typeof Window === 'undefined' || typeof window === 'undefined';
/* eslint-enable fb-www/typeof-undefined */

const isWindow = value => !isSSR && ( // $FlowFixMe(site=recoil) Window does not have a FlowType definition https://github.com/facebook/flow/issues/6709
value === window || value instanceof Window);

const isReactNative = typeof navigator !== 'undefined' && navigator.product === 'ReactNative'; // eslint-disable-line fb-www/typeof-undefined

var Recoil_Environment = {
  isSSR,
  isReactNative,
  isWindow
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Caches a function's results based on the key returned by the passed
 * hashFunction.
 */

function memoizeWithArgsHash(fn, hashFunction) {
  let cache;
  return (...args) => {
    if (!cache) {
      cache = {};
    }

    const key = hashFunction(...args);

    if (!Object.hasOwnProperty.call(cache, key)) {
      cache[key] = fn(...args);
    }

    return cache[key];
  };
}
/**
 * Caches a function's results based on a comparison of the arguments.
 * Only caches the last return of the function.
 * Defaults to reference equality
 */


function memoizeOneWithArgsHash(fn, hashFunction) {
  let lastKey;
  let lastResult; // breaking cache when arguments change

  return (...args) => {
    const key = hashFunction(...args);

    if (lastKey === key) {
      return lastResult;
    }

    lastKey = key;
    lastResult = fn(...args);
    return lastResult;
  };
}
/**
 * Caches a function's results based on a comparison of the arguments.
 * Only caches the last return of the function.
 * Defaults to reference equality
 */


function memoizeOneWithArgsHashAndInvalidation(fn, hashFunction) {
  let lastKey;
  let lastResult; // breaking cache when arguments change

  const memoizedFn = (...args) => {
    const key = hashFunction(...args);

    if (lastKey === key) {
      return lastResult;
    }

    lastKey = key;
    lastResult = fn(...args);
    return lastResult;
  };

  const invalidate = () => {
    lastKey = null;
  };

  return [memoizedFn, invalidate];
}

var Recoil_Memoize = {
  memoizeWithArgsHash,
  memoizeOneWithArgsHash,
  memoizeOneWithArgsHashAndInvalidation
};

const {
  batchUpdates: batchUpdates$1
} = Recoil_Batching;

const {
  initializeNode: initializeNode$1,
  peekNodeInfo: peekNodeInfo$1
} = Recoil_FunctionalCore;

const {
  graph: graph$1
} = Recoil_Graph;

const {
  getNextStoreID: getNextStoreID$1
} = Recoil_Keys;

const {
  DEFAULT_VALUE: DEFAULT_VALUE$1,
  recoilValues: recoilValues$1,
  recoilValuesForKeys: recoilValuesForKeys$2
} = Recoil_Node;

const {
  AbstractRecoilValue: AbstractRecoilValue$2,
  getRecoilValueAsLoadable: getRecoilValueAsLoadable$1,
  setRecoilValue: setRecoilValue$1,
  setUnvalidatedRecoilValue: setUnvalidatedRecoilValue$1
} = Recoil_RecoilValueInterface;

const {
  updateRetainCount: updateRetainCount$1
} = Recoil_Retention;

const {
  setInvalidateMemoizedSnapshot: setInvalidateMemoizedSnapshot$1
} = Recoil_SnapshotCache;

const {
  getNextTreeStateVersion: getNextTreeStateVersion$2,
  makeEmptyStoreState: makeEmptyStoreState$1
} = Recoil_State;



const {
  isSSR: isSSR$1
} = Recoil_Environment;









const {
  memoizeOneWithArgsHashAndInvalidation: memoizeOneWithArgsHashAndInvalidation$1
} = Recoil_Memoize;



 // Opaque at this surface because it's part of the public API from here.


const retainWarning = (/* unused pure expression or super */ null && (`
Recoil Snapshots only last for the duration of the callback they are provided to. To keep a Snapshot longer, do this:

  const release = snapshot.retain();
  try {
    await doSomethingWithSnapshot(snapshot);
  } finally {
    release();
  }

This is currently a DEV-only warning but will become a thrown exception in the next release of Recoil.
`)); // A "Snapshot" is "read-only" and captures a specific set of values of atoms.
// However, the data-flow-graph and selector values may evolve as selector
// evaluation functions are executed and async selectors resolve.

class Snapshot {
  // eslint-disable-next-line fb-www/no-uninitialized-properties
  constructor(storeState, parentStoreID) {
    _defineProperty(this, "_store", void 0);

    _defineProperty(this, "_refCount", 1);

    _defineProperty(this, "getLoadable", recoilValue => {
      this.checkRefCount_INTERNAL();
      return getRecoilValueAsLoadable$1(this._store, recoilValue);
    });

    _defineProperty(this, "getPromise", recoilValue => {
      this.checkRefCount_INTERNAL();
      return this.getLoadable(recoilValue).toPromise();
    });

    _defineProperty(this, "getNodes_UNSTABLE", opt => {
      this.checkRefCount_INTERNAL(); // TODO Deal with modified selectors

      if ((opt === null || opt === void 0 ? void 0 : opt.isModified) === true) {
        if ((opt === null || opt === void 0 ? void 0 : opt.isInitialized) === false) {
          return [];
        }

        const state = this._store.getState().currentTree;

        return recoilValuesForKeys$2(state.dirtyAtoms);
      }

      const knownAtoms = this._store.getState().knownAtoms;

      const knownSelectors = this._store.getState().knownSelectors;

      return (opt === null || opt === void 0 ? void 0 : opt.isInitialized) == null ? recoilValues$1.values() : opt.isInitialized === true ? recoilValuesForKeys$2(Recoil_concatIterables([knownAtoms, knownSelectors])) : Recoil_filterIterable(recoilValues$1.values(), ({
        key
      }) => !knownAtoms.has(key) && !knownSelectors.has(key));
    });

    _defineProperty(this, "getInfo_UNSTABLE", ({
      key
    }) => {
      this.checkRefCount_INTERNAL();
      return peekNodeInfo$1(this._store, this._store.getState().currentTree, key);
    });

    _defineProperty(this, "map", mapper => {
      this.checkRefCount_INTERNAL();
      const mutableSnapshot = new MutableSnapshot(this, batchUpdates$1);
      mapper(mutableSnapshot); // if removing batchUpdates from `set` add it here

      return mutableSnapshot;
    });

    _defineProperty(this, "asyncMap", async mapper => {
      this.checkRefCount_INTERNAL();
      const mutableSnapshot = new MutableSnapshot(this, batchUpdates$1);
      mutableSnapshot.retain(); // Retain new snapshot during async mapper

      await mapper(mutableSnapshot); // Continue to retain the new snapshot for the user, but auto-release it
      // after the next tick, the same as a new synchronous snapshot.

      mutableSnapshot.autoRelease_INTERNAL();
      return mutableSnapshot;
    });

    this._store = {
      storeID: getNextStoreID$1(),
      parentStoreID,
      getState: () => storeState,
      replaceState: replacer => {
        // no batching, so nextTree is never active
        storeState.currentTree = replacer(storeState.currentTree);
      },
      getGraph: version => {
        const graphs = storeState.graphsByVersion;

        if (graphs.has(version)) {
          return Recoil_nullthrows(graphs.get(version));
        }

        const newGraph = graph$1();
        graphs.set(version, newGraph);
        return newGraph;
      },
      subscribeToTransactions: () => ({
        release: () => {}
      }),
      addTransactionMetadata: () => {
        throw Recoil_err('Cannot subscribe to Snapshots');
      }
    }; // Initialize any nodes that are live in the parent store (primarily so that
    // this snapshot gets counted towards the node's live stores count).
    // TODO Optimize this when cloning snapshots for callbacks

    for (const nodeKey of this._store.getState().knownAtoms) {
      initializeNode$1(this._store, nodeKey, 'get');
      updateRetainCount$1(this._store, nodeKey, 1);
    }

    this.autoRelease_INTERNAL();
  }

  retain() {
    if (this._refCount <= 0) {
      if (false) {} else {
        Recoil_recoverableViolation('Attempt to retain() Snapshot that was already released.');
      }
    }

    this._refCount++;
    let released = false;
    return () => {
      if (!released) {
        released = true;

        this._release();
      }
    };
  }
  /**
   * Release the snapshot on the next tick.  This means the snapshot is retained
   * during the execution of the current function using it.
   */


  autoRelease_INTERNAL() {
    if (!isSSR$1) {
      // Use timeout of 10 to workaround Firefox issue: https://github.com/facebookexperimental/Recoil/issues/1936
      window.setTimeout(() => this._release(), 10);
    }
  }

  _release() {
    this._refCount--;

    if (this._refCount === 0) {
      this._store.getState().nodeCleanupFunctions.forEach(cleanup => cleanup());

      this._store.getState().nodeCleanupFunctions.clear();

      if (!Recoil_gkx('recoil_memory_managament_2020')) {
        return;
      } // Temporarily nerfing this to allow us to find broken call sites without
      // actually breaking anybody yet.
      // for (const k of this._store.getState().knownAtoms) {
      //   updateRetainCountToZero(this._store, k);
      // }

    } else if (this._refCount < 0) {
      if (false) {}
    }
  }

  isRetained() {
    return this._refCount > 0;
  }

  checkRefCount_INTERNAL() {
    if (Recoil_gkx('recoil_memory_managament_2020') && this._refCount <= 0) {
      if (false) {} // What we will ship later:
      // throw err(retainWarning);

    }
  }

  getStore_INTERNAL() {
    this.checkRefCount_INTERNAL();
    return this._store;
  }

  getID() {
    this.checkRefCount_INTERNAL();
    return this._store.getState().currentTree.stateID;
  }

  getStoreID() {
    this.checkRefCount_INTERNAL();
    return this._store.storeID;
  } // We want to allow the methods to be destructured and used as accessors

  /* eslint-disable fb-www/extra-arrow-initializer */

  /* eslint-enable fb-www/extra-arrow-initializer */


}

function cloneStoreState(store, treeState, bumpVersion = false) {
  const storeState = store.getState();
  const version = bumpVersion ? getNextTreeStateVersion$2() : treeState.version;
  return {
    // Always clone the TreeState to isolate stores from accidental mutations.
    // For example, reading a selector from a cloned snapshot shouldn't cache
    // in the original treestate which may cause the original to skip
    // initialization of upstream atoms.
    currentTree: {
      // TODO snapshots shouldn't really have versions because a new version number
      // is always assigned when the snapshot is gone to.
      version: bumpVersion ? version : treeState.version,
      stateID: bumpVersion ? version : treeState.stateID,
      transactionMetadata: { ...treeState.transactionMetadata
      },
      dirtyAtoms: new Set(treeState.dirtyAtoms),
      atomValues: treeState.atomValues.clone(),
      nonvalidatedAtoms: treeState.nonvalidatedAtoms.clone()
    },
    commitDepth: 0,
    nextTree: null,
    previousTree: null,
    knownAtoms: new Set(storeState.knownAtoms),
    // FIXME here's a copy
    knownSelectors: new Set(storeState.knownSelectors),
    // FIXME here's a copy
    transactionSubscriptions: new Map(),
    nodeTransactionSubscriptions: new Map(),
    nodeToComponentSubscriptions: new Map(),
    queuedComponentCallbacks_DEPRECATED: [],
    suspendedComponentResolvers: new Set(),
    graphsByVersion: new Map().set(version, store.getGraph(treeState.version)),
    retention: {
      referenceCounts: new Map(),
      nodesRetainedByZone: new Map(),
      retainablesToCheckForRelease: new Set()
    },
    // FIXME here's a copy
    // Create blank cleanup handlers for atoms so snapshots don't re-run
    // atom effects.
    nodeCleanupFunctions: new Map(Recoil_mapIterable(storeState.nodeCleanupFunctions.entries(), ([key]) => [key, () => {}]))
  };
} // Factory to build a fresh snapshot


function freshSnapshot(initializeState) {
  const snapshot = new Snapshot(makeEmptyStoreState$1());
  return initializeState != null ? snapshot.map(initializeState) : snapshot;
} // Factory to clone a snapshot state


const [memoizedCloneSnapshot, invalidateMemoizedSnapshot$2] = memoizeOneWithArgsHashAndInvalidation$1( // $FlowFixMe[missing-local-annot]
(store, version) => {
  var _storeState$nextTree;

  const storeState = store.getState();
  const treeState = version === 'latest' ? (_storeState$nextTree = storeState.nextTree) !== null && _storeState$nextTree !== void 0 ? _storeState$nextTree : storeState.currentTree : Recoil_nullthrows(storeState.previousTree);
  return new Snapshot(cloneStoreState(store, treeState), store.storeID);
}, (store, version) => {
  var _store$getState$nextT, _store$getState$previ;

  return String(version) + String(store.storeID) + String((_store$getState$nextT = store.getState().nextTree) === null || _store$getState$nextT === void 0 ? void 0 : _store$getState$nextT.version) + String(store.getState().currentTree.version) + String((_store$getState$previ = store.getState().previousTree) === null || _store$getState$previ === void 0 ? void 0 : _store$getState$previ.version);
}); // Avoid circular dependencies

setInvalidateMemoizedSnapshot$1(invalidateMemoizedSnapshot$2);

function cloneSnapshot(store, version = 'latest') {
  const snapshot = memoizedCloneSnapshot(store, version);

  if (!snapshot.isRetained()) {
    invalidateMemoizedSnapshot$2();
    return memoizedCloneSnapshot(store, version);
  }

  return snapshot;
}

class MutableSnapshot extends Snapshot {
  constructor(snapshot, batch) {
    super(cloneStoreState(snapshot.getStore_INTERNAL(), snapshot.getStore_INTERNAL().getState().currentTree, true), snapshot.getStoreID());

    _defineProperty(this, "_batch", void 0);

    _defineProperty(this, "set", (recoilState, newValueOrUpdater) => {
      this.checkRefCount_INTERNAL();
      const store = this.getStore_INTERNAL(); // This batchUpdates ensures this `set` is applied immediately and you can
      // read the written value after calling `set`. I would like to remove this
      // behavior and only batch in `Snapshot.map`, but this would be a breaking
      // change potentially.

      this._batch(() => {
        updateRetainCount$1(store, recoilState.key, 1);
        setRecoilValue$1(this.getStore_INTERNAL(), recoilState, newValueOrUpdater);
      });
    });

    _defineProperty(this, "reset", recoilState => {
      this.checkRefCount_INTERNAL();
      const store = this.getStore_INTERNAL(); // See note at `set` about batched updates.

      this._batch(() => {
        updateRetainCount$1(store, recoilState.key, 1);
        setRecoilValue$1(this.getStore_INTERNAL(), recoilState, DEFAULT_VALUE$1);
      });
    });

    _defineProperty(this, "setUnvalidatedAtomValues_DEPRECATED", values => {
      this.checkRefCount_INTERNAL();
      const store = this.getStore_INTERNAL(); // See note at `set` about batched updates.

      batchUpdates$1(() => {
        for (const [k, v] of values.entries()) {
          updateRetainCount$1(store, k, 1);
          setUnvalidatedRecoilValue$1(store, new AbstractRecoilValue$2(k), v);
        }
      });
    });

    this._batch = batch;
  }

}

var Recoil_Snapshot = {
  Snapshot,
  MutableSnapshot,
  freshSnapshot,
  cloneSnapshot
};

var Recoil_Snapshot_1 = Recoil_Snapshot.Snapshot;
var Recoil_Snapshot_2 = Recoil_Snapshot.MutableSnapshot;
var Recoil_Snapshot_3 = Recoil_Snapshot.freshSnapshot;
var Recoil_Snapshot_4 = Recoil_Snapshot.cloneSnapshot;

var Recoil_Snapshot$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Snapshot: Recoil_Snapshot_1,
  MutableSnapshot: Recoil_Snapshot_2,
  freshSnapshot: Recoil_Snapshot_3,
  cloneSnapshot: Recoil_Snapshot_4
});

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function unionSets(...sets) {
  const result = new Set();

  for (const set of sets) {
    for (const value of set) {
      result.add(value);
    }
  }

  return result;
}

var Recoil_unionSets = unionSets;

const {
  useRef
} = react__WEBPACK_IMPORTED_MODULE_0__;
/**
 * The same as `useRef()` except that if a function is specified then it will
 * call that function to get the value to initialize the reference with.
 * This is similar to how `useState()` behaves when given a function.  It allows
 * the user to avoid generating the initial value for subsequent renders.
 * The tradeoff is that to set the reference to a function itself you need to
 * nest it: useRefInitOnce(() => () => {...});
 */


function useRefInitOnce(initialValue) {
  // $FlowExpectedError[incompatible-call]
  const ref = useRef(initialValue);

  if (ref.current === initialValue && typeof initialValue === 'function') {
    // $FlowExpectedError[incompatible-use]
    ref.current = initialValue();
  }

  return ref;
}

var Recoil_useRefInitOnce = useRefInitOnce;

// @fb-only: const RecoilusagelogEvent = require('RecoilusagelogEvent');
// @fb-only: const RecoilUsageLogFalcoEvent = require('RecoilUsageLogFalcoEvent');
// @fb-only: const URI = require('URI');


const {
  getNextTreeStateVersion: getNextTreeStateVersion$3,
  makeEmptyStoreState: makeEmptyStoreState$2
} = Recoil_State;

const {
  cleanUpNode: cleanUpNode$2,
  getDownstreamNodes: getDownstreamNodes$2,
  initializeNode: initializeNode$2,
  setNodeValue: setNodeValue$2,
  setUnvalidatedAtomValue_DEPRECATED: setUnvalidatedAtomValue_DEPRECATED$1
} = Recoil_FunctionalCore;

const {
  graph: graph$2
} = Recoil_Graph;

const {
  cloneGraph: cloneGraph$1
} = Recoil_Graph;

const {
  getNextStoreID: getNextStoreID$2
} = Recoil_Keys;

const {
  createMutableSource: createMutableSource$1,
  reactMode: reactMode$2
} = Recoil_ReactMode;

const {
  applyAtomValueWrites: applyAtomValueWrites$1
} = Recoil_RecoilValueInterface;

const {
  releaseScheduledRetainablesNow: releaseScheduledRetainablesNow$1
} = Recoil_Retention;

const {
  freshSnapshot: freshSnapshot$1
} = Recoil_Snapshot$1;



const {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef: useRef$1,
  useState
} = react__WEBPACK_IMPORTED_MODULE_0__;















function notInAContext() {
  throw Recoil_err('This component must be used inside a <RecoilRoot> component.');
}

const defaultStore = Object.freeze({
  storeID: getNextStoreID$2(),
  getState: notInAContext,
  replaceState: notInAContext,
  getGraph: notInAContext,
  subscribeToTransactions: notInAContext,
  addTransactionMetadata: notInAContext
});
let stateReplacerIsBeingExecuted = false;

function startNextTreeIfNeeded(store) {
  if (stateReplacerIsBeingExecuted) {
    throw Recoil_err('An atom update was triggered within the execution of a state updater function. State updater functions provided to Recoil must be pure functions.');
  }

  const storeState = store.getState();

  if (storeState.nextTree === null) {
    if (Recoil_gkx('recoil_memory_managament_2020') && Recoil_gkx('recoil_release_on_cascading_update_killswitch_2021')) {
      // If this is a cascading update (that is, rendering due to one state change
      // invokes a second state change), we won't have cleaned up retainables yet
      // because this normally happens after notifying components. Do it before
      // proceeding with the cascading update so that it remains predictable:
      if (storeState.commitDepth > 0) {
        releaseScheduledRetainablesNow$1(store);
      }
    }

    const version = storeState.currentTree.version;
    const nextVersion = getNextTreeStateVersion$3();
    storeState.nextTree = { ...storeState.currentTree,
      version: nextVersion,
      stateID: nextVersion,
      dirtyAtoms: new Set(),
      transactionMetadata: {}
    };
    storeState.graphsByVersion.set(nextVersion, cloneGraph$1(Recoil_nullthrows(storeState.graphsByVersion.get(version))));
  }
}

const AppContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({
  current: defaultStore
});

const useStoreRef = () => useContext(AppContext); // $FlowExpectedError[incompatible-call]


const MutableSourceContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);

function useRecoilMutableSource() {
  const mutableSource = useContext(MutableSourceContext);

  if (mutableSource == null) {
    Recoil_expectationViolation('Attempted to use a Recoil hook outside of a <RecoilRoot>. ' + '<RecoilRoot> must be an ancestor of any component that uses ' + 'Recoil hooks.');
  }

  return mutableSource;
}

function notifyComponents(store, storeState, treeState) {
  const dependentNodes = getDownstreamNodes$2(store, treeState, treeState.dirtyAtoms);

  for (const key of dependentNodes) {
    const comps = storeState.nodeToComponentSubscriptions.get(key);

    if (comps) {
      for (const [_subID, [_debugName, callback]] of comps) {
        callback(treeState);
      }
    }
  }
}

function sendEndOfBatchNotifications(store) {
  const storeState = store.getState();
  const treeState = storeState.currentTree; // Inform transaction subscribers of the transaction:

  const dirtyAtoms = treeState.dirtyAtoms;

  if (dirtyAtoms.size) {
    // Execute Node-specific subscribers before global subscribers
    for (const [key, subscriptions] of storeState.nodeTransactionSubscriptions) {
      if (dirtyAtoms.has(key)) {
        for (const [_, subscription] of subscriptions) {
          subscription(store);
        }
      }
    }

    for (const [_, subscription] of storeState.transactionSubscriptions) {
      subscription(store);
    }

    if (!reactMode$2().early || storeState.suspendedComponentResolvers.size > 0) {
      // Notifying components is needed to wake from suspense, even when using
      // early rendering.
      notifyComponents(store, storeState, treeState); // Wake all suspended components so the right one(s) can try to re-render.
      // We need to wake up components not just when some asynchronous selector
      // resolved, but also when changing synchronous values because this may cause
      // a selector to change from asynchronous to synchronous, in which case there
      // would be no follow-up asynchronous resolution to wake us up.
      // TODO OPTIMIZATION Only wake up related downstream components

      storeState.suspendedComponentResolvers.forEach(cb => cb());
      storeState.suspendedComponentResolvers.clear();
    }
  } // Special behavior ONLY invoked by useInterface.
  // FIXME delete queuedComponentCallbacks_DEPRECATED when deleting useInterface.


  storeState.queuedComponentCallbacks_DEPRECATED.forEach(cb => cb(treeState));
  storeState.queuedComponentCallbacks_DEPRECATED.splice(0, storeState.queuedComponentCallbacks_DEPRECATED.length);
}

function endBatch(store) {
  const storeState = store.getState();
  storeState.commitDepth++;

  try {
    const {
      nextTree
    } = storeState; // Ignore commits that are not because of Recoil transactions -- namely,
    // because something above RecoilRoot re-rendered:

    if (nextTree == null) {
      return;
    } // nextTree is now committed -- note that copying and reset occurs when
    // a transaction begins, in startNextTreeIfNeeded:


    storeState.previousTree = storeState.currentTree;
    storeState.currentTree = nextTree;
    storeState.nextTree = null;
    sendEndOfBatchNotifications(store);

    if (storeState.previousTree != null) {
      storeState.graphsByVersion.delete(storeState.previousTree.version);
    } else {
      Recoil_recoverableViolation('Ended batch with no previous state, which is unexpected', 'recoil');
    }

    storeState.previousTree = null;

    if (Recoil_gkx('recoil_memory_managament_2020')) {
      // Only release retainables if there were no writes during the end of the
      // batch.  This avoids releasing something we might be about to use.
      if (nextTree == null) {
        releaseScheduledRetainablesNow$1(store);
      }
    }
  } finally {
    storeState.commitDepth--;
  }
}
/*
 * The purpose of the Batcher is to observe when React batches end so that
 * Recoil state changes can be batched. Whenever Recoil state changes, we call
 * setState on the batcher. Then we wait for that change to be committed, which
 * signifies the end of the batch. That's when we respond to the Recoil change.
 */


function Batcher({
  setNotifyBatcherOfChange
}) {
  const storeRef = useStoreRef();
  const [, setState] = useState([]); // $FlowFixMe[incompatible-call]

  setNotifyBatcherOfChange(() => setState({}));
  useEffect(() => {
    // $FlowFixMe[incompatible-call]
    setNotifyBatcherOfChange(() => setState({})); // If an asynchronous selector resolves after the Batcher is unmounted,
    // notifyBatcherOfChange will still be called. An error gets thrown whenever
    // setState is called after a component is already unmounted, so this sets
    // notifyBatcherOfChange to be a no-op.

    return () => {
      setNotifyBatcherOfChange(() => {});
    };
  }, [setNotifyBatcherOfChange]);
  useEffect(() => {
    // enqueueExecution runs this function immediately; it is only used to
    // manipulate the order of useEffects during tests, since React seems to
    // call useEffect in an unpredictable order sometimes.
    Recoil_Queue.enqueueExecution('Batcher', () => {
      endBatch(storeRef.current);
    });
  });
  return null;
}

if (false) {} // When removing this deprecated function, remove stateBySettingRecoilValue
// which will no longer be needed.


function initialStoreState_DEPRECATED(store, initializeState) {
  const initial = makeEmptyStoreState$2();
  initializeState({
    set: (atom, value) => {
      const state = initial.currentTree;
      const writes = setNodeValue$2(store, state, atom.key, value);
      const writtenNodes = new Set(writes.keys());
      const nonvalidatedAtoms = state.nonvalidatedAtoms.clone();

      for (const n of writtenNodes) {
        nonvalidatedAtoms.delete(n);
      }

      initial.currentTree = { ...state,
        dirtyAtoms: Recoil_unionSets(state.dirtyAtoms, writtenNodes),
        atomValues: applyAtomValueWrites$1(state.atomValues, writes),
        // NB: PLEASE un-export applyAtomValueWrites when deleting this code
        nonvalidatedAtoms
      };
    },
    setUnvalidatedAtomValues: atomValues => {
      // FIXME replace this with a mutative loop
      atomValues.forEach((v, k) => {
        initial.currentTree = setUnvalidatedAtomValue_DEPRECATED$1(initial.currentTree, k, v);
      });
    }
  });
  return initial;
} // Initialize state snapshot for <RecoilRoot> for the initializeState prop.
// Atom effect initialization takes precedence over this prop.
// Any atom effects will be run before initialization, but then cleaned up,
// they are then re-run when used as part of rendering.  These semantics are
// compatible with React StrictMode where effects may be re-run multiple times
// but state initialization only happens once the first time.


function initialStoreState(initializeState) {
  // Initialize a snapshot and get its store
  const snapshot = freshSnapshot$1(initializeState);
  const storeState = snapshot.getStore_INTERNAL().getState(); // Counteract the snapshot auto-release

  snapshot.retain(); // Cleanup any effects run during initialization and clear the handlers so
  // they will re-initialize if used during rendering.  This allows atom effect
  // initialization to take precedence over initializeState and be compatible
  // with StrictMode semantics.

  storeState.nodeCleanupFunctions.forEach(cleanup => cleanup());
  storeState.nodeCleanupFunctions.clear();
  return storeState;
}

let nextID = 0;

function RecoilRoot_INTERNAL({
  initializeState_DEPRECATED,
  initializeState,
  store_INTERNAL: storeProp,
  // For use with React "context bridging"
  children
}) {
  // prettier-ignore
  // @fb-only: useEffect(() => {
  // @fb-only: if (gkx('recoil_usage_logging')) {
  // @fb-only: try {
  // @fb-only: RecoilUsageLogFalcoEvent.log(() => ({
  // @fb-only: type: RecoilusagelogEvent.RECOIL_ROOT_MOUNTED,
  // @fb-only: path: URI.getRequestURI().getPath(),
  // @fb-only: }));
  // @fb-only: } catch {
  // @fb-only: recoverableViolation(
  // @fb-only: 'Error when logging Recoil Usage event',
  // @fb-only: 'recoil',
  // @fb-only: );
  // @fb-only: }
  // @fb-only: }
  // @fb-only: }, []);
  let storeStateRef; // eslint-disable-line prefer-const

  const getGraph = version => {
    const graphs = storeStateRef.current.graphsByVersion;

    if (graphs.has(version)) {
      return Recoil_nullthrows(graphs.get(version));
    }

    const newGraph = graph$2();
    graphs.set(version, newGraph);
    return newGraph;
  };

  const subscribeToTransactions = (callback, key) => {
    if (key == null) {
      // Global transaction subscriptions
      const {
        transactionSubscriptions
      } = storeRef.current.getState();
      const id = nextID++;
      transactionSubscriptions.set(id, callback);
      return {
        release: () => {
          transactionSubscriptions.delete(id);
        }
      };
    } else {
      // Node-specific transaction subscriptions:
      const {
        nodeTransactionSubscriptions
      } = storeRef.current.getState();

      if (!nodeTransactionSubscriptions.has(key)) {
        nodeTransactionSubscriptions.set(key, new Map());
      }

      const id = nextID++;
      Recoil_nullthrows(nodeTransactionSubscriptions.get(key)).set(id, callback);
      return {
        release: () => {
          const subs = nodeTransactionSubscriptions.get(key);

          if (subs) {
            subs.delete(id);

            if (subs.size === 0) {
              nodeTransactionSubscriptions.delete(key);
            }
          }
        }
      };
    }
  };

  const addTransactionMetadata = metadata => {
    startNextTreeIfNeeded(storeRef.current);

    for (const k of Object.keys(metadata)) {
      Recoil_nullthrows(storeRef.current.getState().nextTree).transactionMetadata[k] = metadata[k];
    }
  };

  const replaceState = replacer => {
    startNextTreeIfNeeded(storeRef.current); // Use replacer to get the next state:

    const nextTree = Recoil_nullthrows(storeStateRef.current.nextTree);
    let replaced;

    try {
      stateReplacerIsBeingExecuted = true;
      replaced = replacer(nextTree);
    } finally {
      stateReplacerIsBeingExecuted = false;
    }

    if (replaced === nextTree) {
      return;
    }

    if (false) {} // Save changes to nextTree and schedule a React update:


    storeStateRef.current.nextTree = replaced;

    if (reactMode$2().early) {
      notifyComponents(storeRef.current, storeStateRef.current, replaced);
    }

    Recoil_nullthrows(notifyBatcherOfChange.current)();
  };

  const notifyBatcherOfChange = useRef$1(null);
  const setNotifyBatcherOfChange = useCallback(x => {
    notifyBatcherOfChange.current = x;
  }, [notifyBatcherOfChange]);
  const storeRef = Recoil_useRefInitOnce(() => storeProp !== null && storeProp !== void 0 ? storeProp : {
    storeID: getNextStoreID$2(),
    getState: () => storeStateRef.current,
    replaceState,
    getGraph,
    subscribeToTransactions,
    addTransactionMetadata
  });

  if (storeProp != null) {
    storeRef.current = storeProp;
  }

  storeStateRef = Recoil_useRefInitOnce(() => initializeState_DEPRECATED != null ? initialStoreState_DEPRECATED(storeRef.current, initializeState_DEPRECATED) : initializeState != null ? initialStoreState(initializeState) : makeEmptyStoreState$2());
  const mutableSource = useMemo(() => createMutableSource$1 === null || createMutableSource$1 === void 0 ? void 0 : createMutableSource$1(storeStateRef, () => storeStateRef.current.currentTree.version), [storeStateRef]); // Cleanup when the <RecoilRoot> is unmounted

  useEffect(() => {
    // React is free to call effect cleanup handlers and effects at will, the
    // deps array is only an optimization.  For example, React strict mode
    // will execute each effect twice for testing.  Therefore, we need symmetry
    // to re-initialize all known atoms after they were cleaned up.
    const store = storeRef.current;

    for (const atomKey of new Set(store.getState().knownAtoms)) {
      initializeNode$2(store, atomKey, 'get');
    }

    return () => {
      for (const atomKey of store.getState().knownAtoms) {
        cleanUpNode$2(store, atomKey);
      }
    };
  }, [storeRef]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(AppContext.Provider, {
    value: storeRef
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(MutableSourceContext.Provider, {
    value: mutableSource
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Batcher, {
    setNotifyBatcherOfChange: setNotifyBatcherOfChange
  }), children));
}

function RecoilRoot(props) {
  const {
    override,
    ...propsExceptOverride
  } = props;
  const ancestorStoreRef = useStoreRef();

  if (override === false && ancestorStoreRef.current !== defaultStore) {
    // If ancestorStoreRef.current !== defaultStore, it means that this
    // RecoilRoot is not nested within another.
    return props.children;
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(RecoilRoot_INTERNAL, propsExceptOverride);
}

function useRecoilStoreID() {
  return useStoreRef().current.storeID;
}

var Recoil_RecoilRoot = {
  RecoilRoot,
  useStoreRef,
  useRecoilMutableSource,
  useRecoilStoreID,
  notifyComponents_FOR_TESTING: notifyComponents,
  sendEndOfBatchNotifications_FOR_TESTING: sendEndOfBatchNotifications
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function shallowArrayEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (a.length !== b.length) {
    return false;
  }

  for (let i = 0, l = a.length; i < l; i++) {
    if (a[i] !== b[i]) {
      return false;
    }
  }

  return true;
}

var Recoil_shallowArrayEqual = shallowArrayEqual;

const {
  useEffect: useEffect$1,
  useRef: useRef$2
} = react__WEBPACK_IMPORTED_MODULE_0__;

function usePrevious(value) {
  const ref = useRef$2();
  useEffect$1(() => {
    // $FlowFixMe[incompatible-type]
    ref.current = value;
  });
  return ref.current;
}

var Recoil_usePrevious = usePrevious;

const {
  useStoreRef: useStoreRef$1
} = Recoil_RecoilRoot;

const {
  SUSPENSE_TIMEOUT_MS: SUSPENSE_TIMEOUT_MS$1
} = Recoil_Retention;

const {
  updateRetainCount: updateRetainCount$2
} = Recoil_Retention;

const {
  RetentionZone: RetentionZone$3
} = Recoil_RetentionZone;

const {
  useEffect: useEffect$2,
  useRef: useRef$3
} = react__WEBPACK_IMPORTED_MODULE_0__;

const {
  isSSR: isSSR$2
} = Recoil_Environment;





 // I don't see a way to avoid the any type here because we want to accept readable
// and writable values with any type parameter, but normally with writable ones
// RecoilState<SomeT> is not a subtype of RecoilState<mixed>.


// flowlint-line unclear-type:off
function useRetain(toRetain) {
  if (!Recoil_gkx('recoil_memory_managament_2020')) {
    return;
  } // eslint-disable-next-line fb-www/react-hooks


  return useRetain_ACTUAL(toRetain);
}

function useRetain_ACTUAL(toRetain) {
  const array = Array.isArray(toRetain) ? toRetain : [toRetain];
  const retainables = array.map(a => a instanceof RetentionZone$3 ? a : a.key);
  const storeRef = useStoreRef$1();
  useEffect$2(() => {
    if (!Recoil_gkx('recoil_memory_managament_2020')) {
      return;
    }

    const store = storeRef.current;

    if (timeoutID.current && !isSSR$2) {
      // Already performed a temporary retain on render, simply cancel the release
      // of that temporary retain.
      window.clearTimeout(timeoutID.current);
      timeoutID.current = null;
    } else {
      for (const r of retainables) {
        updateRetainCount$2(store, r, 1);
      }
    }

    return () => {
      for (const r of retainables) {
        updateRetainCount$2(store, r, -1);
      }
    }; // eslint-disable-next-line fb-www/react-hooks-deps
  }, [storeRef, ...retainables]); // We want to retain if the component suspends. This is terrible but the Suspense
  // API affords us no better option. If we suspend and never commit after some
  // seconds, then release. The 'actual' retain/release in the effect above
  // cancels this.

  const timeoutID = useRef$3();
  const previousRetainables = Recoil_usePrevious(retainables);

  if (!isSSR$2 && (previousRetainables === undefined || !Recoil_shallowArrayEqual(previousRetainables, retainables))) {
    const store = storeRef.current;

    for (const r of retainables) {
      updateRetainCount$2(store, r, 1);
    }

    if (previousRetainables) {
      for (const r of previousRetainables) {
        updateRetainCount$2(store, r, -1);
      }
    }

    if (timeoutID.current) {
      window.clearTimeout(timeoutID.current);
    }

    timeoutID.current = window.setTimeout(() => {
      timeoutID.current = null;

      for (const r of retainables) {
        updateRetainCount$2(store, r, -1);
      }
    }, SUSPENSE_TIMEOUT_MS$1);
  }
}

var Recoil_useRetain = useRetain;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * THIS CODE HAS BEEN COMMENTED OUT INTENTIONALLY
 *
 * This technique of getting the component name is imperfect, since it both only
 * works in a non-minified code base, and more importantly introduces performance
 * problems since it relies in throwing errors which is an expensive operation.
 *
 * At some point we may want to reevaluate this technique hence why we have commented
 * this code out, rather than delete it all together.
 */
// const {useRef} = require('react');
// const gkx = require('recoil-shared/util/Recoil_gkx');
// const stackTraceParser = require('recoil-shared/util/Recoil_stackTraceParser');

function useComponentName() {
  // const nameRef = useRef();
  // if (__DEV__) {
  //   if (gkx('recoil_infer_component_names')) {
  //     if (nameRef.current === undefined) {
  //       // There is no blessed way to determine the calling React component from
  //       // within a hook. This hack uses the fact that hooks must start with 'use'
  //       // and that hooks are either called by React Components or other hooks. It
  //       // follows therefore, that to find the calling component, you simply need
  //       // to look down the stack and find the first function which doesn't start
  //       // with 'use'. We are only enabling this in dev for now, since once the
  //       // codebase is minified, the naming assumptions no longer hold true.
  //       // eslint-disable-next-line fb-www/no-new-error
  //       const frames = stackTraceParser(new Error().stack);
  //       for (const {methodName} of frames) {
  //         // I observed cases where the frame was of the form 'Object.useXXX'
  //         // hence why I'm searching for hooks following a word boundary
  //         if (!methodName.match(/\buse[^\b]+$/)) {
  //           return (nameRef.current = methodName);
  //         }
  //       }
  //       nameRef.current = null;
  //     }
  //     return nameRef.current ?? '<unable to determine component name>';
  //   }
  // }
  // @fb-only: return "<component name only available when both in dev mode and when passing GK 'recoil_infer_component_names'>";
  return '<component name not available>'; // @oss-only
}

var Recoil_useComponentName = useComponentName;

const {
  batchUpdates: batchUpdates$2
} = Recoil_Batching;

const {
  DEFAULT_VALUE: DEFAULT_VALUE$2
} = Recoil_Node;

const {
  currentRendererSupportsUseSyncExternalStore: currentRendererSupportsUseSyncExternalStore$1,
  reactMode: reactMode$3,
  useMutableSource: useMutableSource$1,
  useSyncExternalStore: useSyncExternalStore$1
} = Recoil_ReactMode;

const {
  useRecoilMutableSource: useRecoilMutableSource$1,
  useStoreRef: useStoreRef$2
} = Recoil_RecoilRoot;

const {
  isRecoilValue: isRecoilValue$2
} = Recoil_RecoilValue$1;

const {
  AbstractRecoilValue: AbstractRecoilValue$3,
  getRecoilValueAsLoadable: getRecoilValueAsLoadable$2,
  setRecoilValue: setRecoilValue$2,
  setUnvalidatedRecoilValue: setUnvalidatedRecoilValue$2,
  subscribeToRecoilValue: subscribeToRecoilValue$1
} = Recoil_RecoilValueInterface;



const {
  useCallback: useCallback$1,
  useEffect: useEffect$3,
  useMemo: useMemo$1,
  useRef: useRef$4,
  useState: useState$1
} = react__WEBPACK_IMPORTED_MODULE_0__;

const {
  setByAddingToSet: setByAddingToSet$2
} = Recoil_CopyOnWrite;



const {
  isSSR: isSSR$3
} = Recoil_Environment;













function handleLoadable(loadable, recoilValue, storeRef) {
  // We can't just throw the promise we are waiting on to Suspense.  If the
  // upstream dependencies change it may produce a state in which the component
  // can render, but it would still be suspended on a Promise that may never resolve.
  if (loadable.state === 'hasValue') {
    return loadable.contents;
  } else if (loadable.state === 'loading') {
    const promise = new Promise(resolve => {
      const suspendedComponentResolvers = storeRef.current.getState().suspendedComponentResolvers;
      suspendedComponentResolvers.add(resolve); // SSR should clear out the wake-up resolver if the Promise is resolved
      // to avoid infinite loops.  (See https://github.com/facebookexperimental/Recoil/pull/2073)

      if (isSSR$3 && Recoil_isPromise(loadable.contents)) {
        loadable.contents.finally(() => {
          suspendedComponentResolvers.delete(resolve);
        });
      }
    }); // $FlowExpectedError Flow(prop-missing) for integrating with tools that inspect thrown promises @fb-only
    // @fb-only: promise.displayName = `Recoil State: ${recoilValue.key}`;

    throw promise;
  } else if (loadable.state === 'hasError') {
    throw loadable.contents;
  } else {
    throw Recoil_err(`Invalid value of loadable atom "${recoilValue.key}"`);
  }
}

function validateRecoilValue(recoilValue, hookName // $FlowFixMe[missing-local-annot]
) {
  if (!isRecoilValue$2(recoilValue)) {
    throw Recoil_err(`Invalid argument to ${hookName}: expected an atom or selector but got ${String(recoilValue)}`);
  }
}

/**
 * Various things are broken with useRecoilInterface, particularly concurrent
 * mode, React strict mode, and memory management. They will not be fixed.
 * */
function useRecoilInterface_DEPRECATED() {
  const componentName = Recoil_useComponentName();
  const storeRef = useStoreRef$2(); // eslint-disable-next-line fb-www/react-no-unused-state-hook

  const [, forceUpdate] = useState$1([]);
  const recoilValuesUsed = useRef$4(new Set());
  recoilValuesUsed.current = new Set(); // Track the RecoilValues used just during this render

  const previousSubscriptions = useRef$4(new Set());
  const subscriptions = useRef$4(new Map());
  const unsubscribeFrom = useCallback$1(key => {
    const sub = subscriptions.current.get(key);

    if (sub) {
      sub.release();
      subscriptions.current.delete(key);
    }
  }, [subscriptions]);
  const updateState = useCallback$1((_state, key) => {
    if (subscriptions.current.has(key)) {
      forceUpdate([]);
    }
  }, []); // Effect to add/remove subscriptions as nodes are used

  useEffect$3(() => {
    const store = storeRef.current;
    Recoil_differenceSets(recoilValuesUsed.current, previousSubscriptions.current).forEach(key => {
      if (subscriptions.current.has(key)) {
        Recoil_expectationViolation(`Double subscription to RecoilValue "${key}"`);
        return;
      }

      const sub = subscribeToRecoilValue$1(store, new AbstractRecoilValue$3(key), state => updateState(state, key), componentName);
      subscriptions.current.set(key, sub);
      /**
       * Since we're subscribing in an effect we need to update to the latest
       * value of the atom since it may have changed since we rendered. We can
       * go ahead and do that now, unless we're in the middle of a batch --
       * in which case we should do it at the end of the batch, due to the
       * following edge case: Suppose an atom is updated in another useEffect
       * of this same component. Then the following sequence of events occur:
       * 1. Atom is updated and subs fired (but we may not be subscribed
       *    yet depending on order of effects, so we miss this) Updated value
       *    is now in nextTree, but not currentTree.
       * 2. This effect happens. We subscribe and update.
       * 3. From the update we re-render and read currentTree, with old value.
       * 4. Batcher's effect sets currentTree to nextTree.
       * In this sequence we miss the update. To avoid that, add the update
       * to queuedComponentCallback if a batch is in progress.
       */
      // FIXME delete queuedComponentCallbacks_DEPRECATED when deleting useInterface.

      const state = store.getState();

      if (state.nextTree) {
        store.getState().queuedComponentCallbacks_DEPRECATED.push(() => {
          updateState(store.getState(), key);
        });
      } else {
        updateState(store.getState(), key);
      }
    });
    Recoil_differenceSets(previousSubscriptions.current, recoilValuesUsed.current).forEach(key => {
      unsubscribeFrom(key);
    });
    previousSubscriptions.current = recoilValuesUsed.current;
  }); // Effect to unsubscribe from all when unmounting

  useEffect$3(() => {
    const currentSubscriptions = subscriptions.current; // Restore subscriptions that were cleared due to StrictMode running this effect twice

    Recoil_differenceSets(recoilValuesUsed.current, new Set(currentSubscriptions.keys())).forEach(key => {
      const sub = subscribeToRecoilValue$1(storeRef.current, new AbstractRecoilValue$3(key), state => updateState(state, key), componentName);
      currentSubscriptions.set(key, sub);
    });
    return () => currentSubscriptions.forEach((_, key) => unsubscribeFrom(key));
  }, [componentName, storeRef, unsubscribeFrom, updateState]);
  return useMemo$1(() => {
    // eslint-disable-next-line no-shadow
    function useSetRecoilState(recoilState) {
      if (false) {}

      return newValueOrUpdater => {
        setRecoilValue$2(storeRef.current, recoilState, newValueOrUpdater);
      };
    } // eslint-disable-next-line no-shadow


    function useResetRecoilState(recoilState) {
      if (false) {}

      return () => setRecoilValue$2(storeRef.current, recoilState, DEFAULT_VALUE$2);
    } // eslint-disable-next-line no-shadow


    function useRecoilValueLoadable(recoilValue) {
      var _storeState$nextTree;

      if (false) {}

      if (!recoilValuesUsed.current.has(recoilValue.key)) {
        recoilValuesUsed.current = setByAddingToSet$2(recoilValuesUsed.current, recoilValue.key);
      } // TODO Restore optimization to memoize lookup


      const storeState = storeRef.current.getState();
      return getRecoilValueAsLoadable$2(storeRef.current, recoilValue, reactMode$3().early ? (_storeState$nextTree = storeState.nextTree) !== null && _storeState$nextTree !== void 0 ? _storeState$nextTree : storeState.currentTree : storeState.currentTree);
    } // eslint-disable-next-line no-shadow


    function useRecoilValue(recoilValue) {
      if (false) {}

      const loadable = useRecoilValueLoadable(recoilValue);
      return handleLoadable(loadable, recoilValue, storeRef);
    } // eslint-disable-next-line no-shadow


    function useRecoilState(recoilState) {
      if (false) {}

      return [useRecoilValue(recoilState), useSetRecoilState(recoilState)];
    } // eslint-disable-next-line no-shadow


    function useRecoilStateLoadable(recoilState) {
      if (false) {}

      return [useRecoilValueLoadable(recoilState), useSetRecoilState(recoilState)];
    }

    return {
      getRecoilValue: useRecoilValue,
      getRecoilValueLoadable: useRecoilValueLoadable,
      getRecoilState: useRecoilState,
      getRecoilStateLoadable: useRecoilStateLoadable,
      getSetRecoilState: useSetRecoilState,
      getResetRecoilState: useResetRecoilState
    };
  }, [recoilValuesUsed, storeRef]);
}

const recoilComponentGetRecoilValueCount_FOR_TESTING = {
  current: 0
};

function useRecoilValueLoadable_SYNC_EXTERNAL_STORE(recoilValue) {
  const storeRef = useStoreRef$2();
  const componentName = Recoil_useComponentName();
  const getSnapshot = useCallback$1(() => {
    var _storeState$nextTree2;

    if (false) {}

    const store = storeRef.current;
    const storeState = store.getState();
    const treeState = reactMode$3().early ? (_storeState$nextTree2 = storeState.nextTree) !== null && _storeState$nextTree2 !== void 0 ? _storeState$nextTree2 : storeState.currentTree : storeState.currentTree;
    const loadable = getRecoilValueAsLoadable$2(store, recoilValue, treeState);
    return {
      loadable,
      key: recoilValue.key
    };
  }, [storeRef, recoilValue]); // Memoize the state to avoid unnecessary rerenders

  const memoizePreviousSnapshot = useCallback$1(getState => {
    let prevState;
    return () => {
      var _prevState, _prevState2;

      const nextState = getState();

      if ((_prevState = prevState) !== null && _prevState !== void 0 && _prevState.loadable.is(nextState.loadable) && ((_prevState2 = prevState) === null || _prevState2 === void 0 ? void 0 : _prevState2.key) === nextState.key) {
        return prevState;
      }

      prevState = nextState;
      return nextState;
    };
  }, []);
  const getMemoizedSnapshot = useMemo$1(() => memoizePreviousSnapshot(getSnapshot), [getSnapshot, memoizePreviousSnapshot]);
  const subscribe = useCallback$1(notify => {
    const store = storeRef.current;
    const subscription = subscribeToRecoilValue$1(store, recoilValue, notify, componentName);
    return subscription.release;
  }, [storeRef, recoilValue, componentName]);
  return useSyncExternalStore$1(subscribe, getMemoizedSnapshot, // getSnapshot()
  getMemoizedSnapshot // getServerSnapshot() for SSR support
  ).loadable;
}

function useRecoilValueLoadable_MUTABLE_SOURCE(recoilValue) {
  const storeRef = useStoreRef$2();
  const getLoadable = useCallback$1(() => {
    var _storeState$nextTree3;

    const store = storeRef.current;
    const storeState = store.getState();
    const treeState = reactMode$3().early ? (_storeState$nextTree3 = storeState.nextTree) !== null && _storeState$nextTree3 !== void 0 ? _storeState$nextTree3 : storeState.currentTree : storeState.currentTree;
    return getRecoilValueAsLoadable$2(store, recoilValue, treeState);
  }, [storeRef, recoilValue]);
  const getLoadableWithTesting = useCallback$1(() => {
    if (false) {}

    return getLoadable();
  }, [getLoadable]);
  const componentName = Recoil_useComponentName();
  const subscribe = useCallback$1((_storeState, notify) => {
    const store = storeRef.current;
    const subscription = subscribeToRecoilValue$1(store, recoilValue, () => {
      if (!Recoil_gkx('recoil_suppress_rerender_in_callback')) {
        return notify();
      } // Only re-render if the value has changed.
      // This will evaluate the atom/selector now as well as when the
      // component renders, but that may help with prefetching.


      const newLoadable = getLoadable();

      if (!prevLoadableRef.current.is(newLoadable)) {
        notify();
      } // If the component is suspended then the effect setting prevLoadableRef
      // will not run.  So, set the previous value here when its subscription
      // is fired to wake it up.  We can't just rely on this, though, because
      // this only executes when an atom/selector is dirty and the atom/selector
      // passed to the hook can dynamically change.


      prevLoadableRef.current = newLoadable;
    }, componentName);
    return subscription.release;
  }, [storeRef, recoilValue, componentName, getLoadable]);
  const source = useRecoilMutableSource$1();

  if (source == null) {
    throw Recoil_err('Recoil hooks must be used in components contained within a <RecoilRoot> component.');
  }

  const loadable = useMutableSource$1(source, getLoadableWithTesting, subscribe);
  const prevLoadableRef = useRef$4(loadable);
  useEffect$3(() => {
    prevLoadableRef.current = loadable;
  });
  return loadable;
}

function useRecoilValueLoadable_TRANSITION_SUPPORT(recoilValue) {
  const storeRef = useStoreRef$2();
  const componentName = Recoil_useComponentName(); // Accessors to get the current state

  const getLoadable = useCallback$1(() => {
    var _storeState$nextTree4;

    if (false) {}

    const store = storeRef.current;
    const storeState = store.getState();
    const treeState = reactMode$3().early ? (_storeState$nextTree4 = storeState.nextTree) !== null && _storeState$nextTree4 !== void 0 ? _storeState$nextTree4 : storeState.currentTree : storeState.currentTree;
    return getRecoilValueAsLoadable$2(store, recoilValue, treeState);
  }, [storeRef, recoilValue]);
  const getState = useCallback$1(() => ({
    loadable: getLoadable(),
    key: recoilValue.key
  }), [getLoadable, recoilValue.key]); // Memoize state snapshots

  const updateState = useCallback$1(prevState => {
    const nextState = getState();
    return prevState.loadable.is(nextState.loadable) && prevState.key === nextState.key ? prevState : nextState;
  }, [getState]); // Subscribe to Recoil state changes

  useEffect$3(() => {
    const subscription = subscribeToRecoilValue$1(storeRef.current, recoilValue, _state => {
      setState(updateState);
    }, componentName); // Update state in case we are using a different key

    setState(updateState);
    return subscription.release;
  }, [componentName, recoilValue, storeRef, updateState]); // Get the current state

  const [state, setState] = useState$1(getState); // If we changed keys, then return the state for the new key.
  // This is important in case the old key would cause the component to suspend.
  // We don't have to set the new state here since the subscribing effect above
  // will do that.

  return state.key !== recoilValue.key ? getState().loadable : state.loadable;
}

function useRecoilValueLoadable_LEGACY(recoilValue) {
  const storeRef = useStoreRef$2(); // eslint-disable-next-line fb-www/react-no-unused-state-hook

  const [, forceUpdate] = useState$1([]);
  const componentName = Recoil_useComponentName();
  const getLoadable = useCallback$1(() => {
    var _storeState$nextTree5;

    if (false) {}

    const store = storeRef.current;
    const storeState = store.getState();
    const treeState = reactMode$3().early ? (_storeState$nextTree5 = storeState.nextTree) !== null && _storeState$nextTree5 !== void 0 ? _storeState$nextTree5 : storeState.currentTree : storeState.currentTree;
    return getRecoilValueAsLoadable$2(store, recoilValue, treeState);
  }, [storeRef, recoilValue]);
  const loadable = getLoadable();
  const prevLoadableRef = useRef$4(loadable);
  useEffect$3(() => {
    prevLoadableRef.current = loadable;
  });
  useEffect$3(() => {
    const store = storeRef.current;
    const storeState = store.getState();
    const subscription = subscribeToRecoilValue$1(store, recoilValue, _state => {
      var _prevLoadableRef$curr;

      if (!Recoil_gkx('recoil_suppress_rerender_in_callback')) {
        return forceUpdate([]);
      }

      const newLoadable = getLoadable();

      if (!((_prevLoadableRef$curr = prevLoadableRef.current) !== null && _prevLoadableRef$curr !== void 0 && _prevLoadableRef$curr.is(newLoadable))) {
        // $FlowFixMe[incompatible-call]
        forceUpdate(newLoadable);
      }

      prevLoadableRef.current = newLoadable;
    }, componentName);
    /**
     * Since we're subscribing in an effect we need to update to the latest
     * value of the atom since it may have changed since we rendered. We can
     * go ahead and do that now, unless we're in the middle of a batch --
     * in which case we should do it at the end of the batch, due to the
     * following edge case: Suppose an atom is updated in another useEffect
     * of this same component. Then the following sequence of events occur:
     * 1. Atom is updated and subs fired (but we may not be subscribed
     *    yet depending on order of effects, so we miss this) Updated value
     *    is now in nextTree, but not currentTree.
     * 2. This effect happens. We subscribe and update.
     * 3. From the update we re-render and read currentTree, with old value.
     * 4. Batcher's effect sets currentTree to nextTree.
     * In this sequence we miss the update. To avoid that, add the update
     * to queuedComponentCallback if a batch is in progress.
     */

    if (storeState.nextTree) {
      store.getState().queuedComponentCallbacks_DEPRECATED.push(() => {
        // $FlowFixMe[incompatible-type]
        prevLoadableRef.current = null;
        forceUpdate([]);
      });
    } else {
      var _prevLoadableRef$curr2;

      if (!Recoil_gkx('recoil_suppress_rerender_in_callback')) {
        return forceUpdate([]);
      }

      const newLoadable = getLoadable();

      if (!((_prevLoadableRef$curr2 = prevLoadableRef.current) !== null && _prevLoadableRef$curr2 !== void 0 && _prevLoadableRef$curr2.is(newLoadable))) {
        // $FlowFixMe[incompatible-call]
        forceUpdate(newLoadable);
      }

      prevLoadableRef.current = newLoadable;
    }

    return subscription.release;
  }, [componentName, getLoadable, recoilValue, storeRef]);
  return loadable;
}
/**
  Like useRecoilValue(), but either returns the value if available or
  just undefined if not available for any reason, such as pending or error.
*/


function useRecoilValueLoadable(recoilValue) {
  if (false) {}

  if (Recoil_gkx('recoil_memory_managament_2020')) {
    // eslint-disable-next-line fb-www/react-hooks
    Recoil_useRetain(recoilValue);
  }

  return {
    TRANSITION_SUPPORT: useRecoilValueLoadable_TRANSITION_SUPPORT,
    // Recoil will attemp to detect if `useSyncExternalStore()` is supported with
    // `reactMode()` before calling it.  However, sometimes the host React
    // environment supports it but uses additional React renderers (such as with
    // `react-three-fiber`) which do not.  While this is technically a user issue
    // by using a renderer with React 18+ that doesn't fully support React 18 we
    // don't want to break users if it can be avoided. As the current renderer can
    // change at runtime, we need to dynamically check and fallback if necessary.
    SYNC_EXTERNAL_STORE: currentRendererSupportsUseSyncExternalStore$1() ? useRecoilValueLoadable_SYNC_EXTERNAL_STORE : useRecoilValueLoadable_TRANSITION_SUPPORT,
    MUTABLE_SOURCE: useRecoilValueLoadable_MUTABLE_SOURCE,
    LEGACY: useRecoilValueLoadable_LEGACY
  }[reactMode$3().mode](recoilValue);
}
/**
  Returns the value represented by the RecoilValue.
  If the value is pending, it will throw a Promise to suspend the component,
  if the value is an error it will throw it for the nearest React error boundary.
  This will also subscribe the component for any updates in the value.
  */


function useRecoilValue(recoilValue) {
  if (false) {}

  const storeRef = useStoreRef$2();
  const loadable = useRecoilValueLoadable(recoilValue);
  return handleLoadable(loadable, recoilValue, storeRef);
}
/**
  Returns a function that allows the value of a RecoilState to be updated, but does
  not subscribe the component to changes to that RecoilState.
*/


function useSetRecoilState(recoilState) {
  if (false) {}

  const storeRef = useStoreRef$2();
  return useCallback$1(newValueOrUpdater => {
    setRecoilValue$2(storeRef.current, recoilState, newValueOrUpdater);
  }, [storeRef, recoilState]);
}
/**
  Returns a function that will reset the value of a RecoilState to its default
*/


function useResetRecoilState(recoilState) {
  if (false) {}

  const storeRef = useStoreRef$2();
  return useCallback$1(() => {
    setRecoilValue$2(storeRef.current, recoilState, DEFAULT_VALUE$2);
  }, [storeRef, recoilState]);
}
/**
  Equivalent to useState(). Allows the value of the RecoilState to be read and written.
  Subsequent updates to the RecoilState will cause the component to re-render. If the
  RecoilState is pending, this will suspend the component and initiate the
  retrieval of the value. If evaluating the RecoilState resulted in an error, this will
  throw the error so that the nearest React error boundary can catch it.
*/


function useRecoilState(recoilState) {
  if (false) {}

  return [useRecoilValue(recoilState), useSetRecoilState(recoilState)];
}
/**
  Like useRecoilState(), but does not cause Suspense or React error handling. Returns
  an object that indicates whether the RecoilState is available, pending, or
  unavailable due to an error.
*/


function useRecoilStateLoadable(recoilState) {
  if (false) {}

  return [useRecoilValueLoadable(recoilState), useSetRecoilState(recoilState)];
}

function useSetUnvalidatedAtomValues() {
  const storeRef = useStoreRef$2();
  return (values, transactionMetadata = {}) => {
    batchUpdates$2(() => {
      storeRef.current.addTransactionMetadata(transactionMetadata);
      values.forEach((value, key) => setUnvalidatedRecoilValue$2(storeRef.current, new AbstractRecoilValue$3(key), value));
    });
  };
}
/**
 * Experimental variants of hooks with support for useTransition()
 */


function useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE(recoilValue) {
  if (false) {}

  if (Recoil_gkx('recoil_memory_managament_2020')) {
    // eslint-disable-next-line fb-www/react-hooks
    Recoil_useRetain(recoilValue);
  }

  return useRecoilValueLoadable_TRANSITION_SUPPORT(recoilValue);
}

function useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(recoilValue) {
  if (false) {}

  const storeRef = useStoreRef$2();
  const loadable = useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE(recoilValue);
  return handleLoadable(loadable, recoilValue, storeRef);
}

function useRecoilState_TRANSITION_SUPPORT_UNSTABLE(recoilState) {
  if (false) {}

  return [useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(recoilState), useSetRecoilState(recoilState)];
}

var Recoil_Hooks = {
  recoilComponentGetRecoilValueCount_FOR_TESTING,
  useRecoilInterface: useRecoilInterface_DEPRECATED,
  useRecoilState,
  useRecoilStateLoadable,
  useRecoilValue,
  useRecoilValueLoadable,
  useResetRecoilState,
  useSetRecoilState,
  useSetUnvalidatedAtomValues,
  useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE,
  useRecoilValue_TRANSITION_SUPPORT_UNSTABLE,
  useRecoilState_TRANSITION_SUPPORT_UNSTABLE
};

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Returns a map containing all of the keys + values from the original map where
 * the given callback returned true.
 */

function filterMap(map, callback) {
  const result = new Map();

  for (const [key, value] of map) {
    if (callback(value, key)) {
      result.set(key, value);
    }
  }

  return result;
}

var Recoil_filterMap = filterMap;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */
/**
 * Returns a set containing all of the values from the original set where
 * the given callback returned true.
 */

function filterSet(set, callback) {
  const result = new Set();

  for (const value of set) {
    if (callback(value)) {
      result.add(value);
    }
  }

  return result;
}

var Recoil_filterSet = filterSet;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function mergeMaps(...maps) {
  const result = new Map();

  for (let i = 0; i < maps.length; i++) {
    const iterator = maps[i].keys();
    let nextKey;

    while (!(nextKey = iterator.next()).done) {
      // $FlowIssue[incompatible-call] - map/iterator knows nothing about flow types
      result.set(nextKey.value, maps[i].get(nextKey.value));
    }
  }

  return result;
}

var Recoil_mergeMaps = mergeMaps;

const {
  batchUpdates: batchUpdates$3
} = Recoil_Batching;

const {
  DEFAULT_VALUE: DEFAULT_VALUE$3,
  getNode: getNode$4,
  nodes: nodes$1
} = Recoil_Node;

const {
  useStoreRef: useStoreRef$3
} = Recoil_RecoilRoot;

const {
  AbstractRecoilValue: AbstractRecoilValue$4,
  setRecoilValueLoadable: setRecoilValueLoadable$1
} = Recoil_RecoilValueInterface;

const {
  SUSPENSE_TIMEOUT_MS: SUSPENSE_TIMEOUT_MS$2
} = Recoil_Retention;

const {
  cloneSnapshot: cloneSnapshot$1
} = Recoil_Snapshot$1;

const {
  useCallback: useCallback$2,
  useEffect: useEffect$4,
  useRef: useRef$5,
  useState: useState$2
} = react__WEBPACK_IMPORTED_MODULE_0__;

const {
  isSSR: isSSR$4
} = Recoil_Environment;















function useTransactionSubscription(callback) {
  const storeRef = useStoreRef$3();
  useEffect$4(() => {
    const sub = storeRef.current.subscribeToTransactions(callback);
    return sub.release;
  }, [callback, storeRef]);
}

function externallyVisibleAtomValuesInState(state) {
  const atomValues = state.atomValues.toMap();
  const persistedAtomContentsValues = Recoil_mapMap(Recoil_filterMap(atomValues, (v, k) => {
    const node = getNode$4(k);
    const persistence = node.persistence_UNSTABLE;
    return persistence != null && persistence.type !== 'none' && v.state === 'hasValue';
  }), v => v.contents); // Merge in nonvalidated atoms; we may not have defs for them but they will
  // all have persistence on or they wouldn't be there in the first place.

  return Recoil_mergeMaps(state.nonvalidatedAtoms.toMap(), persistedAtomContentsValues);
}

/**
  Calls the given callback after any atoms have been modified and the consequent
  component re-renders have been committed. This is intended for persisting
  the values of the atoms to storage. The stored values can then be restored
  using the useSetUnvalidatedAtomValues hook.

  The callback receives the following info:

  atomValues: The current value of every atom that is both persistable (persistence
              type not set to 'none') and whose value is available (not in an
              error or loading state).

  previousAtomValues: The value of every persistable and available atom before
               the transaction began.

  atomInfo: A map containing the persistence settings for each atom. Every key
            that exists in atomValues will also exist in atomInfo.

  modifiedAtoms: The set of atoms that were written to during the transaction.

  transactionMetadata: Arbitrary information that was added via the
          useSetUnvalidatedAtomValues hook. Useful for ignoring the useSetUnvalidatedAtomValues
          transaction, to avoid loops.
*/
function useTransactionObservation_DEPRECATED(callback) {
  useTransactionSubscription(useCallback$2(store => {
    let previousTree = store.getState().previousTree;
    const currentTree = store.getState().currentTree;

    if (!previousTree) {
      Recoil_recoverableViolation('Transaction subscribers notified without a previous tree being present -- this is a bug in Recoil');
      previousTree = store.getState().currentTree; // attempt to trundle on
    }

    const atomValues = externallyVisibleAtomValuesInState(currentTree);
    const previousAtomValues = externallyVisibleAtomValuesInState(previousTree);
    const atomInfo = Recoil_mapMap(nodes$1, node => {
      var _node$persistence_UNS, _node$persistence_UNS2, _node$persistence_UNS3, _node$persistence_UNS4;

      return {
        persistence_UNSTABLE: {
          type: (_node$persistence_UNS = (_node$persistence_UNS2 = node.persistence_UNSTABLE) === null || _node$persistence_UNS2 === void 0 ? void 0 : _node$persistence_UNS2.type) !== null && _node$persistence_UNS !== void 0 ? _node$persistence_UNS : 'none',
          backButton: (_node$persistence_UNS3 = (_node$persistence_UNS4 = node.persistence_UNSTABLE) === null || _node$persistence_UNS4 === void 0 ? void 0 : _node$persistence_UNS4.backButton) !== null && _node$persistence_UNS3 !== void 0 ? _node$persistence_UNS3 : false
        }
      };
    }); // Filter on existance in atomValues so that externally-visible rules
    // are also applied to modified atoms (specifically exclude selectors):

    const modifiedAtoms = Recoil_filterSet(currentTree.dirtyAtoms, k => atomValues.has(k) || previousAtomValues.has(k));
    callback({
      atomValues,
      previousAtomValues,
      atomInfo,
      modifiedAtoms,
      transactionMetadata: { ...currentTree.transactionMetadata
      }
    });
  }, [callback]));
}

function useRecoilTransactionObserver(callback) {
  useTransactionSubscription(useCallback$2(store => {
    const snapshot = cloneSnapshot$1(store, 'latest');
    const previousSnapshot = cloneSnapshot$1(store, 'previous');
    callback({
      snapshot,
      previousSnapshot
    });
  }, [callback]));
} // Return a snapshot of the current state and subscribe to all state changes


function useRecoilSnapshot() {
  const storeRef = useStoreRef$3();
  const [snapshot, setSnapshot] = useState$2(() => cloneSnapshot$1(storeRef.current));
  const previousSnapshot = Recoil_usePrevious(snapshot);
  const timeoutID = useRef$5();
  const releaseRef = useRef$5();
  useTransactionSubscription(useCallback$2(store => setSnapshot(cloneSnapshot$1(store)), [])); // Retain snapshot for duration component is mounted

  useEffect$4(() => {
    const release = snapshot.retain(); // Release the retain from the rendering call

    if (timeoutID.current && !isSSR$4) {
      var _releaseRef$current;

      window.clearTimeout(timeoutID.current);
      timeoutID.current = null;
      (_releaseRef$current = releaseRef.current) === null || _releaseRef$current === void 0 ? void 0 : _releaseRef$current.call(releaseRef);
      releaseRef.current = null;
    }

    return () => {
      // Defer the release.  If "Fast Refresh"" is used then the component may
      // re-render with the same state.  The previous cleanup will then run and
      // then the new effect will run. We don't want the snapshot to be released
      // by that cleanup before the new effect has a chance to retain it again.
      // Use timeout of 10 to workaround Firefox issue: https://github.com/facebookexperimental/Recoil/issues/1936
      window.setTimeout(release, 10);
    };
  }, [snapshot]); // Retain snapshot until above effect is run.
  // Release after a threshold in case component is suspended.

  if (previousSnapshot !== snapshot && !isSSR$4) {
    // Release the previous snapshot
    if (timeoutID.current) {
      var _releaseRef$current2;

      window.clearTimeout(timeoutID.current);
      timeoutID.current = null;
      (_releaseRef$current2 = releaseRef.current) === null || _releaseRef$current2 === void 0 ? void 0 : _releaseRef$current2.call(releaseRef);
      releaseRef.current = null;
    }

    releaseRef.current = snapshot.retain();
    timeoutID.current = window.setTimeout(() => {
      var _releaseRef$current3;

      timeoutID.current = null;
      (_releaseRef$current3 = releaseRef.current) === null || _releaseRef$current3 === void 0 ? void 0 : _releaseRef$current3.call(releaseRef);
      releaseRef.current = null;
    }, SUSPENSE_TIMEOUT_MS$2);
  }

  return snapshot;
}

function gotoSnapshot(store, snapshot) {
  var _storeState$nextTree;

  const storeState = store.getState();
  const prev = (_storeState$nextTree = storeState.nextTree) !== null && _storeState$nextTree !== void 0 ? _storeState$nextTree : storeState.currentTree;
  const next = snapshot.getStore_INTERNAL().getState().currentTree;
  batchUpdates$3(() => {
    const keysToUpdate = new Set();

    for (const keys of [prev.atomValues.keys(), next.atomValues.keys()]) {
      for (const key of keys) {
        var _prev$atomValues$get, _next$atomValues$get;

        if (((_prev$atomValues$get = prev.atomValues.get(key)) === null || _prev$atomValues$get === void 0 ? void 0 : _prev$atomValues$get.contents) !== ((_next$atomValues$get = next.atomValues.get(key)) === null || _next$atomValues$get === void 0 ? void 0 : _next$atomValues$get.contents) && getNode$4(key).shouldRestoreFromSnapshots) {
          keysToUpdate.add(key);
        }
      }
    }

    keysToUpdate.forEach(key => {
      setRecoilValueLoadable$1(store, new AbstractRecoilValue$4(key), next.atomValues.has(key) ? Recoil_nullthrows(next.atomValues.get(key)) : DEFAULT_VALUE$3);
    });
    store.replaceState(state => ({ ...state,
      stateID: snapshot.getID()
    }));
  });
}

function useGotoRecoilSnapshot() {
  const storeRef = useStoreRef$3();
  return useCallback$2(snapshot => gotoSnapshot(storeRef.current, snapshot), [storeRef]);
}

var Recoil_SnapshotHooks = {
  useRecoilSnapshot,
  gotoSnapshot,
  useGotoRecoilSnapshot,
  useRecoilTransactionObserver,
  useTransactionObservation_DEPRECATED,
  useTransactionSubscription_DEPRECATED: useTransactionSubscription
};

const {
  peekNodeInfo: peekNodeInfo$2
} = Recoil_FunctionalCore;

const {
  useStoreRef: useStoreRef$4
} = Recoil_RecoilRoot;

function useGetRecoilValueInfo() {
  const storeRef = useStoreRef$4(); // $FlowFixMe[incompatible-return]

  return ({
    key
  }) => peekNodeInfo$2(storeRef.current, storeRef.current.getState().currentTree, key);
}

var Recoil_useGetRecoilValueInfo = useGetRecoilValueInfo;

const {
  reactMode: reactMode$4
} = Recoil_ReactMode;

const {
  RecoilRoot: RecoilRoot$1,
  useStoreRef: useStoreRef$5
} = Recoil_RecoilRoot;



const {
  useMemo: useMemo$2
} = react__WEBPACK_IMPORTED_MODULE_0__;

function useRecoilBridgeAcrossReactRoots() {
  // The test fails when using useMutableSource(), but only if act() is used
  // for the nested root.  So, this may only be a testing environment issue.
  if (reactMode$4().mode === 'MUTABLE_SOURCE') {
    // eslint-disable-next-line fb-www/no-console
    console.warn('Warning: There are known issues using useRecoilBridgeAcrossReactRoots() in recoil_mutable_source rendering mode.  Please consider upgrading to recoil_sync_external_store mode.');
  }

  const store = useStoreRef$5().current;
  return useMemo$2(() => {
    // eslint-disable-next-line no-shadow
    function RecoilBridge({
      children
    }) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(RecoilRoot$1, {
        store_INTERNAL: store
      }, children);
    }

    return RecoilBridge;
  }, [store]);
}

var Recoil_useRecoilBridgeAcrossReactRoots = useRecoilBridgeAcrossReactRoots;

const {
  loadableWithValue: loadableWithValue$1
} = Recoil_Loadable$1;

const {
  initializeNode: initializeNode$3
} = Recoil_FunctionalCore;

const {
  DEFAULT_VALUE: DEFAULT_VALUE$4,
  getNode: getNode$5
} = Recoil_Node;

const {
  copyTreeState: copyTreeState$1,
  getRecoilValueAsLoadable: getRecoilValueAsLoadable$3,
  invalidateDownstreams: invalidateDownstreams$1,
  writeLoadableToTreeState: writeLoadableToTreeState$1
} = Recoil_RecoilValueInterface;



function isAtom(recoilValue) {
  return getNode$5(recoilValue.key).nodeType === 'atom';
}

class TransactionInterfaceImpl {
  constructor(store, treeState) {
    _defineProperty(this, "_store", void 0);

    _defineProperty(this, "_treeState", void 0);

    _defineProperty(this, "_changes", void 0);

    _defineProperty(this, "get", recoilValue => {
      if (this._changes.has(recoilValue.key)) {
        // $FlowIssue[incompatible-return]
        return this._changes.get(recoilValue.key);
      }

      if (!isAtom(recoilValue)) {
        throw Recoil_err('Reading selectors within atomicUpdate is not supported');
      }

      const loadable = getRecoilValueAsLoadable$3(this._store, recoilValue, this._treeState);

      if (loadable.state === 'hasValue') {
        return loadable.contents;
      } else if (loadable.state === 'hasError') {
        throw loadable.contents;
      } else {
        throw Recoil_err(`Expected Recoil atom ${recoilValue.key} to have a value, but it is in a loading state.`);
      }
    });

    _defineProperty(this, "set", (recoilState, valueOrUpdater) => {
      if (!isAtom(recoilState)) {
        throw Recoil_err('Setting selectors within atomicUpdate is not supported');
      }

      if (typeof valueOrUpdater === 'function') {
        const current = this.get(recoilState);

        this._changes.set(recoilState.key, valueOrUpdater(current)); // flowlint-line unclear-type:off

      } else {
        // Initialize atom and run effects if not initialized yet
        initializeNode$3(this._store, recoilState.key, 'set');

        this._changes.set(recoilState.key, valueOrUpdater);
      }
    });

    _defineProperty(this, "reset", recoilState => {
      this.set(recoilState, DEFAULT_VALUE$4);
    });

    this._store = store;
    this._treeState = treeState;
    this._changes = new Map();
  } // Allow destructing
  // eslint-disable-next-line fb-www/extra-arrow-initializer


  newTreeState_INTERNAL() {
    if (this._changes.size === 0) {
      return this._treeState;
    }

    const newState = copyTreeState$1(this._treeState);

    for (const [k, v] of this._changes) {
      writeLoadableToTreeState$1(newState, k, loadableWithValue$1(v));
    }

    invalidateDownstreams$1(this._store, newState);
    return newState;
  }

}

function atomicUpdater(store) {
  return fn => {
    store.replaceState(treeState => {
      const changeset = new TransactionInterfaceImpl(store, treeState);
      fn(changeset);
      return changeset.newTreeState_INTERNAL();
    });
  };
}

var Recoil_AtomicUpdates = {
  atomicUpdater
};

var Recoil_AtomicUpdates_1 = Recoil_AtomicUpdates.atomicUpdater;

var Recoil_AtomicUpdates$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  atomicUpdater: Recoil_AtomicUpdates_1
});

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function invariant(condition, message) {
  if (!condition) {
    throw new Error(message);
  }
}

var invariant_1 = invariant;

// @oss-only


var Recoil_invariant = invariant_1;

const {
  atomicUpdater: atomicUpdater$1
} = Recoil_AtomicUpdates$1;

const {
  batchUpdates: batchUpdates$4
} = Recoil_Batching;

const {
  DEFAULT_VALUE: DEFAULT_VALUE$5
} = Recoil_Node;

const {
  useStoreRef: useStoreRef$6
} = Recoil_RecoilRoot;

const {
  refreshRecoilValue: refreshRecoilValue$1,
  setRecoilValue: setRecoilValue$3
} = Recoil_RecoilValueInterface;

const {
  cloneSnapshot: cloneSnapshot$2
} = Recoil_Snapshot$1;

const {
  gotoSnapshot: gotoSnapshot$1
} = Recoil_SnapshotHooks;

const {
  useCallback: useCallback$3
} = react__WEBPACK_IMPORTED_MODULE_0__;









class Sentinel {}

const SENTINEL = new Sentinel();

function recoilCallback(store, fn, args, extraInterface) {
  let ret = SENTINEL;
  let releaseSnapshot;
  batchUpdates$4(() => {
    const errMsg = 'useRecoilCallback() expects a function that returns a function: ' + 'it accepts a function of the type (RecoilInterface) => (Args) => ReturnType ' + 'and returns a callback function (Args) => ReturnType, where RecoilInterface is ' + 'an object {snapshot, set, ...} and Args and ReturnType are the argument and return ' + 'types of the callback you want to create.  Please see the docs ' + 'at recoiljs.org for details.';

    if (typeof fn !== 'function') {
      throw Recoil_err(errMsg);
    } // Clone the snapshot lazily to avoid overhead if the callback does not use it.
    // Note that this means the snapshot may represent later state from when
    // the callback was called if it first accesses the snapshot asynchronously.


    const callbackInterface = Recoil_lazyProxy({ ...(extraInterface !== null && extraInterface !== void 0 ? extraInterface : {}),
      // flowlint-line unclear-type:off
      // $FlowFixMe[missing-local-annot]
      set: (node, newValue) => setRecoilValue$3(store, node, newValue),
      // $FlowFixMe[missing-local-annot]
      reset: node => setRecoilValue$3(store, node, DEFAULT_VALUE$5),
      // $FlowFixMe[missing-local-annot]
      refresh: node => refreshRecoilValue$1(store, node),
      gotoSnapshot: snapshot => gotoSnapshot$1(store, snapshot),
      transact_UNSTABLE: transaction => atomicUpdater$1(store)(transaction)
    }, {
      snapshot: () => {
        const snapshot = cloneSnapshot$2(store);
        releaseSnapshot = snapshot.retain();
        return snapshot;
      }
    });
    const callback = fn(callbackInterface);

    if (typeof callback !== 'function') {
      throw Recoil_err(errMsg);
    }

    ret = callback(...args);
  });
  !!(ret instanceof Sentinel) ?  false ? 0 : Recoil_invariant(false) : void 0;

  if (Recoil_isPromise(ret)) {
    ret = ret.finally(() => {
      var _releaseSnapshot;

      (_releaseSnapshot = releaseSnapshot) === null || _releaseSnapshot === void 0 ? void 0 : _releaseSnapshot();
    });
  } else {
    var _releaseSnapshot2;

    (_releaseSnapshot2 = releaseSnapshot) === null || _releaseSnapshot2 === void 0 ? void 0 : _releaseSnapshot2();
  }

  return ret;
}

function useRecoilCallback(fn, deps) {
  const storeRef = useStoreRef$6();
  return useCallback$3( // $FlowIssue[incompatible-call]
  (...args) => {
    return recoilCallback(storeRef.current, fn, args);
  }, deps != null ? [...deps, storeRef] : undefined // eslint-disable-line fb-www/react-hooks-deps
  );
}

var Recoil_useRecoilCallback = {
  recoilCallback,
  useRecoilCallback
};

const {
  useStoreRef: useStoreRef$7
} = Recoil_RecoilRoot;

const {
  refreshRecoilValue: refreshRecoilValue$2
} = Recoil_RecoilValueInterface;

const {
  useCallback: useCallback$4
} = react__WEBPACK_IMPORTED_MODULE_0__;

function useRecoilRefresher(recoilValue) {
  const storeRef = useStoreRef$7();
  return useCallback$4(() => {
    const store = storeRef.current;
    refreshRecoilValue$2(store, recoilValue);
  }, [recoilValue, storeRef]);
}

var Recoil_useRecoilRefresher = useRecoilRefresher;

const {
  atomicUpdater: atomicUpdater$2
} = Recoil_AtomicUpdates$1;

const {
  useStoreRef: useStoreRef$8
} = Recoil_RecoilRoot;

const {
  useMemo: useMemo$3
} = react__WEBPACK_IMPORTED_MODULE_0__;

function useRecoilTransaction(fn, deps) {
  const storeRef = useStoreRef$8();
  return useMemo$3(() => (...args) => {
    const atomicUpdate = atomicUpdater$2(storeRef.current);
    atomicUpdate(transactionInterface => {
      fn(transactionInterface)(...args);
    });
  }, deps != null ? [...deps, storeRef] : undefined // eslint-disable-line fb-www/react-hooks-deps
  );
}

var Recoil_useRecoilTransaction = useRecoilTransaction;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

class WrappedValue {
  constructor(value) {
    _defineProperty(this, "value", void 0);

    this.value = value;
  }

}

var Recoil_Wrapper = {
  WrappedValue
};

var Recoil_Wrapper_1 = Recoil_Wrapper.WrappedValue;

var Recoil_Wrapper$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  WrappedValue: Recoil_Wrapper_1
});

const {
  isFastRefreshEnabled: isFastRefreshEnabled$2
} = Recoil_ReactMode;



class ChangedPathError extends Error {}

class TreeCache {
  // $FlowIssue[unclear-type]
  constructor(options) {
    var _options$onHit, _options$onSet, _options$mapNodeValue;

    _defineProperty(this, "_name", void 0);

    _defineProperty(this, "_numLeafs", void 0);

    _defineProperty(this, "_root", void 0);

    _defineProperty(this, "_onHit", void 0);

    _defineProperty(this, "_onSet", void 0);

    _defineProperty(this, "_mapNodeValue", void 0);

    this._name = options === null || options === void 0 ? void 0 : options.name;
    this._numLeafs = 0;
    this._root = null;
    this._onHit = (_options$onHit = options === null || options === void 0 ? void 0 : options.onHit) !== null && _options$onHit !== void 0 ? _options$onHit : () => {};
    this._onSet = (_options$onSet = options === null || options === void 0 ? void 0 : options.onSet) !== null && _options$onSet !== void 0 ? _options$onSet : () => {};
    this._mapNodeValue = (_options$mapNodeValue = options === null || options === void 0 ? void 0 : options.mapNodeValue) !== null && _options$mapNodeValue !== void 0 ? _options$mapNodeValue : val => val;
  }

  size() {
    return this._numLeafs;
  } // $FlowIssue[unclear-type]


  root() {
    return this._root;
  }

  get(getNodeValue, handlers) {
    var _this$getLeafNode;

    return (_this$getLeafNode = this.getLeafNode(getNodeValue, handlers)) === null || _this$getLeafNode === void 0 ? void 0 : _this$getLeafNode.value;
  }

  getLeafNode(getNodeValue, handlers) {
    if (this._root == null) {
      return undefined;
    } // Iterate down the tree based on the current node values until we hit a leaf
    // $FlowIssue[unclear-type]


    let node = this._root;

    while (node) {
      handlers === null || handlers === void 0 ? void 0 : handlers.onNodeVisit(node);

      if (node.type === 'leaf') {
        this._onHit(node);

        return node;
      }

      const nodeValue = this._mapNodeValue(getNodeValue(node.nodeKey));

      node = node.branches.get(nodeValue);
    }

    return undefined;
  }

  set(route, value, handlers) {
    const addLeaf = () => {
      var _node2, _node3, _this$_root2, _handlers$onNodeVisit2;

      // First, setup the branch nodes for the route:
      // Iterate down the tree to find or add branch nodes following the route
      let node;
      let branchKey;

      for (const [nodeKey, nodeValue] of route) {
        var _node, _handlers$onNodeVisit, _this$_root;

        // If the previous root was a leaf, while we not have a get(), it means
        // the selector has inconsistent values or implementation changed.
        const root = this._root;

        if ((root === null || root === void 0 ? void 0 : root.type) === 'leaf') {
          throw this.invalidCacheError();
        } // node now refers to the next node down in the tree


        const parent = node; // $FlowFixMe[prop-missing]
        // $FlowFixMe[incompatible-type]

        node = parent ? parent.branches.get(branchKey) : root; // $FlowFixMe[prop-missing]
        // $FlowFixMe[incompatible-type]

        node = (_node = node) !== null && _node !== void 0 ? _node : {
          type: 'branch',
          nodeKey,
          parent,
          branches: new Map(),
          branchKey
        }; // If we found an existing node, confirm it has a consistent value

        if (node.type !== 'branch' || node.nodeKey !== nodeKey) {
          throw this.invalidCacheError();
        } // Add the branch node to the tree


        parent === null || parent === void 0 ? void 0 : parent.branches.set(branchKey, node);
        handlers === null || handlers === void 0 ? void 0 : (_handlers$onNodeVisit = handlers.onNodeVisit) === null || _handlers$onNodeVisit === void 0 ? void 0 : _handlers$onNodeVisit.call(handlers, node); // Prepare for next iteration and install root if it is new.

        branchKey = this._mapNodeValue(nodeValue);
        this._root = (_this$_root = this._root) !== null && _this$_root !== void 0 ? _this$_root : node;
      } // Second, setup the leaf node:
      // If there is an existing leaf for this route confirm it is consistent


      const oldLeaf = node ? (_node2 = node) === null || _node2 === void 0 ? void 0 : _node2.branches.get(branchKey) : this._root;

      if (oldLeaf != null && (oldLeaf.type !== 'leaf' || oldLeaf.branchKey !== branchKey)) {
        throw this.invalidCacheError();
      } // Create a new or replacement leaf.


      const leafNode = {
        type: 'leaf',
        value,
        parent: node,
        branchKey
      }; // Install the leaf and call handlers

      (_node3 = node) === null || _node3 === void 0 ? void 0 : _node3.branches.set(branchKey, leafNode);
      this._root = (_this$_root2 = this._root) !== null && _this$_root2 !== void 0 ? _this$_root2 : leafNode;
      this._numLeafs++;

      this._onSet(leafNode);

      handlers === null || handlers === void 0 ? void 0 : (_handlers$onNodeVisit2 = handlers.onNodeVisit) === null || _handlers$onNodeVisit2 === void 0 ? void 0 : _handlers$onNodeVisit2.call(handlers, leafNode);
    };

    try {
      addLeaf();
    } catch (error) {
      // If the cache was stale or observed inconsistent values, such as with
      // Fast Refresh, then clear it and rebuild with the new values.
      if (error instanceof ChangedPathError) {
        this.clear();
        addLeaf();
      } else {
        throw error;
      }
    }
  } // Returns true if leaf was actually deleted from the tree


  delete(leaf) {
    const root = this.root();

    if (!root) {
      return false;
    }

    if (leaf === root) {
      this._root = null;
      this._numLeafs = 0;
      return true;
    } // Iterate up from the leaf deleteing it from it's parent's branches.


    let node = leaf.parent;
    let branchKey = leaf.branchKey;

    while (node) {
      var _node4;

      node.branches.delete(branchKey); // Stop iterating if we hit the root.

      if (node === root) {
        if (node.branches.size === 0) {
          this._root = null;
          this._numLeafs = 0;
        } else {
          this._numLeafs--;
        }

        return true;
      } // Stop iterating if there are other branches since we don't need to
      // remove any more nodes.


      if (node.branches.size > 0) {
        break;
      } // Iterate up to our parent


      branchKey = (_node4 = node) === null || _node4 === void 0 ? void 0 : _node4.branchKey;
      node = node.parent;
    } // Confirm that the leaf we are deleting is actually attached to our tree


    for (; node !== root; node = node.parent) {
      if (node == null) {
        return false;
      }
    }

    this._numLeafs--;
    return true;
  }

  clear() {
    this._numLeafs = 0;
    this._root = null;
  }

  invalidCacheError() {
    const CHANGED_PATH_ERROR_MESSAGE = isFastRefreshEnabled$2() ? 'Possible Fast Refresh module reload detected.  ' + 'This may also be caused by an selector returning inconsistent values. ' + 'Resetting cache.' : 'Invalid cache values.  This happens when selectors do not return ' + 'consistent values for the same input dependency values.  That may also ' + 'be caused when using Fast Refresh to change a selector implementation.  ' + 'Resetting cache.';
    Recoil_recoverableViolation(CHANGED_PATH_ERROR_MESSAGE + (this._name != null ? ` - ${this._name}` : ''));
    throw new ChangedPathError();
  }

}

var Recoil_TreeCache = {
  TreeCache
};

var Recoil_TreeCache_1 = Recoil_TreeCache.TreeCache;

var Recoil_TreeCache$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  TreeCache: Recoil_TreeCache_1
});

class LRUCache {
  constructor(options) {
    var _options$mapKey;

    _defineProperty(this, "_maxSize", void 0);

    _defineProperty(this, "_size", void 0);

    _defineProperty(this, "_head", void 0);

    _defineProperty(this, "_tail", void 0);

    _defineProperty(this, "_map", void 0);

    _defineProperty(this, "_keyMapper", void 0);

    this._maxSize = options.maxSize;
    this._size = 0;
    this._head = null;
    this._tail = null;
    this._map = new Map();
    this._keyMapper = (_options$mapKey = options.mapKey) !== null && _options$mapKey !== void 0 ? _options$mapKey : v => v;
  }

  head() {
    return this._head;
  }

  tail() {
    return this._tail;
  }

  size() {
    return this._size;
  }

  maxSize() {
    return this._maxSize;
  }

  has(key) {
    return this._map.has(this._keyMapper(key));
  }

  get(key) {
    const mappedKey = this._keyMapper(key);

    const node = this._map.get(mappedKey);

    if (!node) {
      return undefined;
    }

    this.set(key, node.value);
    return node.value;
  }

  set(key, val) {
    const mappedKey = this._keyMapper(key);

    const existingNode = this._map.get(mappedKey);

    if (existingNode) {
      this.delete(key);
    }

    const head = this.head();
    const node = {
      key,
      right: head,
      left: null,
      value: val
    };

    if (head) {
      head.left = node;
    } else {
      this._tail = node;
    }

    this._map.set(mappedKey, node);

    this._head = node;
    this._size++;

    this._maybeDeleteLRU();
  }

  _maybeDeleteLRU() {
    if (this.size() > this.maxSize()) {
      this.deleteLru();
    }
  }

  deleteLru() {
    const tail = this.tail();

    if (tail) {
      this.delete(tail.key);
    }
  }

  delete(key) {
    const mappedKey = this._keyMapper(key);

    if (!this._size || !this._map.has(mappedKey)) {
      return;
    }

    const node = Recoil_nullthrows(this._map.get(mappedKey));
    const right = node.right;
    const left = node.left;

    if (right) {
      right.left = node.left;
    }

    if (left) {
      left.right = node.right;
    }

    if (node === this.head()) {
      this._head = right;
    }

    if (node === this.tail()) {
      this._tail = left;
    }

    this._map.delete(mappedKey);

    this._size--;
  }

  clear() {
    this._size = 0;
    this._head = null;
    this._tail = null;
    this._map = new Map();
  }

}

var Recoil_LRUCache = {
  LRUCache
};

var Recoil_LRUCache_1 = Recoil_LRUCache.LRUCache;

var Recoil_LRUCache$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  LRUCache: Recoil_LRUCache_1
});

const {
  LRUCache: LRUCache$1
} = Recoil_LRUCache$1;

const {
  TreeCache: TreeCache$1
} = Recoil_TreeCache$1;

function treeCacheLRU({
  name,
  maxSize,
  mapNodeValue = v => v
}) {
  const lruCache = new LRUCache$1({
    maxSize
  });
  const cache = new TreeCache$1({
    name,
    mapNodeValue,
    onHit: node => {
      lruCache.set(node, true);
    },
    onSet: node => {
      const lruNode = lruCache.tail();
      lruCache.set(node, true);

      if (lruNode && cache.size() > maxSize) {
        // $FlowFixMe[incompatible-call]
        cache.delete(lruNode.key);
      }
    }
  });
  return cache;
}

var Recoil_treeCacheLRU = treeCacheLRU;

const TIME_WARNING_THRESHOLD_MS = 15;

function stringify(x, opt, key) {
  // A optimization to avoid the more expensive JSON.stringify() for simple strings
  // This may lose protection for u2028 and u2029, though.
  if (typeof x === 'string' && !x.includes('"') && !x.includes('\\')) {
    return `"${x}"`;
  } // Handle primitive types


  switch (typeof x) {
    case 'undefined':
      return '';
    // JSON.stringify(undefined) returns undefined, but we always want to return a string

    case 'boolean':
      return x ? 'true' : 'false';

    case 'number':
    case 'symbol':
      // case 'bigint': // BigInt is not supported in www
      return String(x);

    case 'string':
      // Add surrounding quotes and escape internal quotes
      return JSON.stringify(x);

    case 'function':
      if ((opt === null || opt === void 0 ? void 0 : opt.allowFunctions) !== true) {
        throw Recoil_err('Attempt to serialize function in a Recoil cache key');
      }

      return `__FUNCTION(${x.name})__`;
  }

  if (x === null) {
    return 'null';
  } // Fallback case for unknown types


  if (typeof x !== 'object') {
    var _JSON$stringify;

    return (_JSON$stringify = JSON.stringify(x)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : '';
  } // Deal with all promises as equivalent for now.


  if (Recoil_isPromise(x)) {
    return '__PROMISE__';
  } // Arrays handle recursive stringification


  if (Array.isArray(x)) {
    // $FlowFixMe[missing-local-annot]
    return `[${x.map((v, i) => stringify(v, opt, i.toString()))}]`;
  } // If an object defines a toJSON() method, then use that to override the
  // serialization.  This matches the behavior of JSON.stringify().
  // Pass the key for compatibility.
  // Immutable.js collections define this method to allow us to serialize them.


  if (typeof x.toJSON === 'function') {
    // flowlint-next-line unclear-type: off
    return stringify(x.toJSON(key), opt, key);
  } // For built-in Maps, sort the keys in a stable order instead of the
  // default insertion order.  Support non-string keys.


  if (x instanceof Map) {
    const obj = {};

    for (const [k, v] of x) {
      // Stringify will escape any nested quotes
      obj[typeof k === 'string' ? k : stringify(k, opt)] = v;
    }

    return stringify(obj, opt, key);
  } // For built-in Sets, sort the keys in a stable order instead of the
  // default insertion order.


  if (x instanceof Set) {
    return stringify( // $FlowFixMe[missing-local-annot]
    Array.from(x).sort((a, b) => stringify(a, opt).localeCompare(stringify(b, opt))), opt, key);
  } // Anything else that is iterable serialize as an Array.


  if (Symbol !== undefined && x[Symbol.iterator] != null && typeof x[Symbol.iterator] === 'function') {
    // flowlint-next-line unclear-type: off
    return stringify(Array.from(x), opt, key);
  } // For all other Objects, sort the keys in a stable order.


  return `{${Object.keys(x).filter(k => x[k] !== undefined).sort() // stringify the key to add quotes and escape any nested slashes or quotes.
  .map(k => `${stringify(k, opt)}:${stringify(x[k], opt, k)}`).join(',')}}`;
} // Utility similar to JSON.stringify() except:
// * Serialize built-in Sets as an Array
// * Serialize built-in Maps as an Object.  Supports non-string keys.
// * Serialize other iterables as arrays
// * Sort the keys of Objects and Maps to have a stable order based on string conversion.
//    This overrides their default insertion order.
// * Still uses toJSON() of any object to override serialization
// * Support Symbols (though don't guarantee uniqueness)
// * We could support BigInt, but Flow doesn't seem to like it.
// See Recoil_stableStringify-test.js for examples


function stableStringify(x, opt = {
  allowFunctions: false
}) {
  if (false) {}

  return stringify(x, opt);
}

var Recoil_stableStringify = stableStringify;

const {
  TreeCache: TreeCache$2
} = Recoil_TreeCache$1;









const defaultPolicy = {
  equality: 'reference',
  eviction: 'keep-all',
  maxSize: Infinity
};

function treeCacheFromPolicy({
  equality = defaultPolicy.equality,
  eviction = defaultPolicy.eviction,
  maxSize = defaultPolicy.maxSize
} = defaultPolicy, name) {
  const valueMapper = getValueMapper(equality);
  return getTreeCache(eviction, maxSize, valueMapper, name);
}

function getValueMapper(equality) {
  switch (equality) {
    case 'reference':
      return val => val;

    case 'value':
      return val => Recoil_stableStringify(val);
  }

  throw Recoil_err(`Unrecognized equality policy ${equality}`);
}

function getTreeCache(eviction, maxSize, mapNodeValue, name) {
  switch (eviction) {
    case 'keep-all':
      return new TreeCache$2({
        name,
        mapNodeValue
      });

    case 'lru':
      return Recoil_treeCacheLRU({
        name,
        maxSize: Recoil_nullthrows(maxSize),
        mapNodeValue
      });

    case 'most-recent':
      return Recoil_treeCacheLRU({
        name,
        maxSize: 1,
        mapNodeValue
      });
  }

  throw Recoil_err(`Unrecognized eviction policy ${eviction}`);
}

var Recoil_treeCacheFromPolicy = treeCacheFromPolicy;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

function isNode(object) {
  var _ownerDocument, _doc$defaultView;

  if (typeof window === 'undefined') {
    return false;
  }

  const doc = object != null ? (_ownerDocument = object.ownerDocument) !== null && _ownerDocument !== void 0 ? _ownerDocument : object : document;
  const defaultView = (_doc$defaultView = doc.defaultView) !== null && _doc$defaultView !== void 0 ? _doc$defaultView : window;
  return !!(object != null && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

var Recoil_isNode = (/* unused pure expression or super */ null && (isNode));

const {
  isReactNative: isReactNative$1,
  isWindow: isWindow$1
} = Recoil_Environment;





function shouldNotBeFrozen(value) {
  // Primitives and functions:
  if (value === null || typeof value !== 'object') {
    return true;
  } // React elements:


  switch (typeof value.$$typeof) {
    case 'symbol':
      return true;

    case 'number':
      return true;
  } // Immutable structures:


  if (value['@@__IMMUTABLE_ITERABLE__@@'] != null || value['@@__IMMUTABLE_KEYED__@@'] != null || value['@@__IMMUTABLE_INDEXED__@@'] != null || value['@@__IMMUTABLE_ORDERED__@@'] != null || value['@@__IMMUTABLE_RECORD__@@'] != null) {
    return true;
  } // DOM nodes:


  if (Recoil_isNode(value)) {
    return true;
  }

  if (Recoil_isPromise(value)) {
    return true;
  }

  if (value instanceof Error) {
    return true;
  }

  if (ArrayBuffer.isView(value)) {
    return true;
  } // Some environments, just as Jest, don't work with the instanceof check


  if (!isReactNative$1 && isWindow$1(value)) {
    return true;
  }

  return false;
} // Recursively freeze a value to enforce it is read-only.
// This may also have minimal performance improvements for enumerating
// objects (based on browser implementations, of course)


function deepFreezeValue(value) {
  if (typeof value !== 'object' || shouldNotBeFrozen(value)) {
    return;
  }

  Object.freeze(value); // Make all properties read-only

  for (const key in value) {
    // $FlowIssue[method-unbinding] added when improving typing for this parameters
    if (Object.prototype.hasOwnProperty.call(value, key)) {
      const prop = value[key]; // Prevent infinite recurssion for circular references.

      if (typeof prop === 'object' && prop != null && !Object.isFrozen(prop)) {
        deepFreezeValue(prop);
      }
    }
  }

  Object.seal(value); // This also makes existing properties non-configurable.
}

var Recoil_deepFreezeValue = (/* unused pure expression or super */ null && (deepFreezeValue));

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * This is a stub for some integration into FB internal stuff
 *
 * 
 * @format
 * @oncall recoil
 */
function startPerfBlock(_id) {
  return () => null;
}

var Recoil_PerformanceTimings = {
  startPerfBlock
};

const {
  isLoadable: isLoadable$1,
  loadableWithError: loadableWithError$1,
  loadableWithPromise: loadableWithPromise$1,
  loadableWithValue: loadableWithValue$2
} = Recoil_Loadable$1;

const {
  WrappedValue: WrappedValue$1
} = Recoil_Wrapper$1;



const {
  getNodeLoadable: getNodeLoadable$2,
  peekNodeLoadable: peekNodeLoadable$1,
  setNodeValue: setNodeValue$3
} = Recoil_FunctionalCore;

const {
  saveDepsToStore: saveDepsToStore$1
} = Recoil_Graph;

const {
  DEFAULT_VALUE: DEFAULT_VALUE$6,
  getConfigDeletionHandler: getConfigDeletionHandler$1,
  getNode: getNode$6,
  registerNode: registerNode$1
} = Recoil_Node;

const {
  isRecoilValue: isRecoilValue$3
} = Recoil_RecoilValue$1;

const {
  markRecoilValueModified: markRecoilValueModified$1
} = Recoil_RecoilValueInterface;

const {
  retainedByOptionWithDefault: retainedByOptionWithDefault$1
} = Recoil_Retention;

const {
  recoilCallback: recoilCallback$1
} = Recoil_useRecoilCallback;



















const {
  startPerfBlock: startPerfBlock$1
} = Recoil_PerformanceTimings;



class Canceled {}

const CANCELED = new Canceled();
/**
 * An ExecutionID is an arbitrary ID that lets us distinguish executions from
 * each other. This is necessary as we need a way of solving this problem:
 * "given 3 async executions, only update state for the 'latest' execution when
 * it finishes running regardless of when the other 2 finish". ExecutionIDs
 * provide a convenient way of identifying executions so that we can track and
 * manage them over time.
 */

const dependencyStack = []; // for detecting circular dependencies.

const waitingStores = new Map();

const getNewExecutionID = (() => {
  let executionID = 0;
  return () => executionID++;
})();
/* eslint-disable no-redeclare */


function selector(options) {
  let recoilValue = null;
  const {
    key,
    get,
    cachePolicy_UNSTABLE: cachePolicy
  } = options;
  const set = options.set != null ? options.set : undefined; // flow

  if (false) {} // This is every discovered dependency across all executions


  const discoveredDependencyNodeKeys = new Set();
  const cache = Recoil_treeCacheFromPolicy(cachePolicy !== null && cachePolicy !== void 0 ? cachePolicy : {
    equality: 'reference',
    eviction: 'keep-all'
  }, key);
  const retainedBy = retainedByOptionWithDefault$1(options.retainedBy_UNSTABLE);
  const executionInfoMap = new Map();
  let liveStoresCount = 0;

  function selectorIsLive() {
    return !Recoil_gkx('recoil_memory_managament_2020') || liveStoresCount > 0;
  }

  function selectorInit(store) {
    store.getState().knownSelectors.add(key);
    liveStoresCount++;
    return () => {
      liveStoresCount--;
    };
  }

  function selectorShouldDeleteConfigOnRelease() {
    return getConfigDeletionHandler$1(key) !== undefined && !selectorIsLive();
  }

  function resolveAsync(store, state, executionID, loadable, depValues) {
    setCache(state, loadable, depValues);
    notifyStoresOfResolvedAsync(store, executionID);
  }

  function notifyStoresOfResolvedAsync(store, executionID) {
    if (isLatestExecution(store, executionID)) {
      clearExecutionInfo(store);
    }

    notifyWaitingStores(executionID, true);
  }
  /**
   * Notify stores to pull the selector again if a new async dep was discovered.
   * 1) Async selector adds a new dep but doesn't resolve yet.
   *    Note that deps for an async selector are based on the state when the
   *    evaluation started, in order to provide a consistent picture of state.
   * 2) But, new value of dep based on the current state might cause the selector
   *    to resolve or resolve differently.
   * 3) Therefore, this notification will pull the selector based on the current
   *    state for the components
   */


  function notifyStoresOfNewAsyncDep(store, executionID) {
    if (isLatestExecution(store, executionID)) {
      const executionInfo = Recoil_nullthrows(getExecutionInfo(store));
      executionInfo.stateVersions.clear();
      notifyWaitingStores(executionID, false);
    }
  }

  function notifyWaitingStores(executionID, clearWaitlist) {
    const stores = waitingStores.get(executionID);

    if (stores != null) {
      for (const waitingStore of stores) {
        markRecoilValueModified$1(waitingStore, Recoil_nullthrows(recoilValue));
      }

      if (clearWaitlist) {
        waitingStores.delete(executionID);
      }
    }
  }

  function markStoreWaitingForResolvedAsync(store, executionID) {
    let stores = waitingStores.get(executionID);

    if (stores == null) {
      waitingStores.set(executionID, stores = new Set());
    }

    stores.add(store);
  }
  /**
   * This function attaches a then() and a catch() to a promise that was
   * returned from a selector's get() (either explicitly or implicitly by
   * running a function that uses the "async" keyword). If a selector's get()
   * returns a promise, we have two possibilities:
   *
   * 1. The promise will resolve, in which case it will have completely finished
   *    executing without any remaining pending dependencies. No more retries
   *    are needed and we can proceed with updating the cache and notifying
   *    subscribers (if it is the latest execution, otherwise only the cache
   *    will be updated and subscriptions will not be fired). This is the case
   *    handled by the attached then() handler.
   *
   * 2. The promise will throw because it either has an error or it came across
   *    an async dependency that has not yet resolved, in which case we will
   *    call wrapDepdencyPromise(), whose responsibility is to handle dependency
   *    promises. This case is handled by the attached catch() handler.
   *
   * Both branches will eventually resolve to the final result of the selector
   * (or an error if a real error occurred).
   *
   * The execution will run to completion even if it is stale, and its value
   * will be cached. But stale executions will not update global state or update
   * executionInfo as that is the responsibility of the 'latest' execution.
   *
   * Note this function should not be passed a promise that was thrown--AKA a
   * dependency promise. Dependency promises should be passed to
   * wrapPendingDependencyPromise()).
   */


  function wrapResultPromise(store, promise, state, depValues, executionID, loadingDepsState) {
    return promise.then(value => {
      if (!selectorIsLive()) {
        // The selector was released since the request began; ignore the response.
        clearExecutionInfo(store);
        throw CANCELED;
      }

      const loadable = loadableWithValue$2(value);
      resolveAsync(store, state, executionID, loadable, depValues);
      return value;
    }).catch(errorOrPromise => {
      if (!selectorIsLive()) {
        // The selector was released since the request began; ignore the response.
        clearExecutionInfo(store);
        throw CANCELED;
      }

      if (Recoil_isPromise(errorOrPromise)) {
        return wrapPendingDependencyPromise(store, errorOrPromise, state, depValues, executionID, loadingDepsState);
      }

      const loadable = loadableWithError$1(errorOrPromise);
      resolveAsync(store, state, executionID, loadable, depValues);
      throw errorOrPromise;
    });
  }
  /**
   * This function attaches a then() and a catch() to a promise that was
   * thrown from a selector's get(). If a selector's get() throws a promise,
   * we have two possibilities:
   *
   * 1. The promise will resolve, meaning one of our selector's dependencies is
   *    now available and we should "retry" our get() by running it again. This
   *    is the case handled by the attached then() handler.
   *
   * 2. The promise will throw because something went wrong with the dependency
   *    promise (in other words a real error occurred). This case is handled by
   *    the attached catch() handler. If the dependency promise throws, it is
   *    _always_ a real error and not another dependency promise (any dependency
   *    promises would have been handled upstream).
   *
   * The then() branch will eventually resolve to the final result of the
   * selector (or an error if a real error occurs), and the catch() will always
   * resolve to an error because the dependency promise is a promise that was
   * wrapped upstream, meaning it will only resolve to its real value or to a
   * real error.
   *
   * The execution will run to completion even if it is stale, and its value
   * will be cached. But stale executions will not update global state or update
   * executionInfo as that is the responsibility of the 'latest' execution.
   *
   * Note this function should not be passed a promise that was returned from
   * get(). The intention is that this function is only passed promises that
   * were thrown due to a pending dependency. Promises returned by get() should
   * be passed to wrapResultPromise() instead.
   */


  function wrapPendingDependencyPromise(store, promise, state, existingDeps, executionID, loadingDepsState) {
    return promise.then(resolvedDep => {
      if (!selectorIsLive()) {
        // The selector was released since the request began; ignore the response.
        clearExecutionInfo(store);
        throw CANCELED;
      } // Check if we are handling a pending Recoil dependency or if the user
      // threw their own Promise to "suspend" a selector evaluation.  We need
      // to check that the loadingDepPromise actually matches the promise that
      // we caught in case the selector happened to catch the promise we threw
      // for a pending Recoil dependency from `getRecoilValue()` and threw
      // their own promise instead.


      if (loadingDepsState.loadingDepKey != null && loadingDepsState.loadingDepPromise === promise) {
        /**
         * Note for async atoms, this means we are changing the atom's value
         * in the store for the given version. This should be alright because
         * the version of state is now stale and a new version will have
         * already been triggered by the atom being resolved (see this logic
         * in Recoil_atom.js)
         */
        state.atomValues.set(loadingDepsState.loadingDepKey, loadableWithValue$2(resolvedDep));
      } else {
        /**
         * If resolvedDepKey is not defined, the promise was a user-thrown
         * promise. User-thrown promises are an advanced feature and they
         * should be avoided in almost all cases. Using `loadable.map()` inside
         * of selectors for loading loadables and then throwing that mapped
         * loadable's promise is an example of a user-thrown promise.
         *
         * When we hit a user-thrown promise, we have to bail out of an optimization
         * where we bypass calculating selector cache keys for selectors that
         * have been previously seen for a given state (these selectors are saved in
         * state.atomValues) to avoid stale state as we have no way of knowing
         * what state changes happened (if any) in result to the promise resolving.
         *
         * Ideally we would only bail out selectors that are in the chain of
         * dependencies for this selector, but there's currently no way to get
         * a full list of a selector's downstream nodes because the state that
         * is executing may be a discarded tree (so store.getGraph(state.version)
         * will be empty), and the full dep tree may not be in the selector
         * caches in the case where the selector's cache was cleared. To solve
         * for this we would have to keep track of all running selector
         * executions and their downstream deps. Because this only covers edge
         * cases, that complexity might not be justifyable.
         */
        store.getState().knownSelectors.forEach(nodeKey => {
          state.atomValues.delete(nodeKey);
        });
      }
      /**
       * Optimization: Now that the dependency has resolved, let's try hitting
       * the cache in case the dep resolved to a value we have previously seen.
       *
       * TODO:
       * Note this optimization is not perfect because it only prevents re-executions
       * _after_ the point where an async dependency is found. Any code leading
       * up to the async dependency may have run unnecessarily. The ideal case
       * would be to wait for the async dependency to resolve first, check the
       * cache, and prevent _any_ execution of the selector if the resulting
       * value of the dependency leads to a path that is found in the cache.
       * The ideal case is more difficult to implement as it would require that
       * we capture and wait for the the async dependency right after checking
       * the cache. The current approach takes advantage of the fact that running
       * the selector already has a code path that lets us exit early when
       * an async dep resolves.
       */


      const cachedLoadable = getLoadableFromCacheAndUpdateDeps(store, state);

      if (cachedLoadable && cachedLoadable.state !== 'loading') {
        /**
         * This has to notify stores of a resolved async, even if there is no
         * current pending execution for the following case:
         * 1) A component renders with this pending loadable.
         * 2) The upstream dependency resolves.
         * 3) While processing some other selector it reads this one, such as
         *    while traversing its dependencies.  At this point it gets the
         *    new resolved value synchronously and clears the current
         *    execution ID.  The component wasn't getting the value itself,
         *    though, so it still has the pending loadable.
         * 4) When this code executes the current execution id was cleared
         *    and it wouldn't notify the component of the new value.
         *
         * I think this is only an issue with "early" rendering since the
         * components got their value using the in-progress execution.
         * We don't have a unit test for this case yet.  I'm not sure it is
         * necessary with recoil_transition_support mode.
         */
        if (isLatestExecution(store, executionID) || getExecutionInfo(store) == null) {
          notifyStoresOfResolvedAsync(store, executionID);
        }

        if (cachedLoadable.state === 'hasValue') {
          return cachedLoadable.contents;
        } else {
          throw cachedLoadable.contents;
        }
      }
      /**
       * If this execution is stale, let's check to see if there is some in
       * progress execution with a matching state. If we find a match, then
       * we can take the value from that in-progress execution. Note this may
       * sound like an edge case, but may be very common in cases where a
       * loading dependency resolves from loading to having a value (thus
       * possibly triggering a re-render), and React re-renders before the
       * chained .then() functions run, thus starting a new execution as the
       * dep has changed value. Without this check we will run the selector
       * twice (once in the new execution and once again in this .then(), so
       * this check is necessary to keep unnecessary re-executions to a
       * minimum).
       *
       * Also note this code does not check across all executions that may be
       * running. It only optimizes for the _latest_ execution per store as
       * we currently do not maintain a list of all currently running executions.
       * This means in some cases we may run selectors more than strictly
       * necessary when there are multiple executions running for the same
       * selector. This may be a valid tradeoff as checking for dep changes
       * across all in-progress executions may take longer than just
       * re-running the selector. This will be app-dependent, and maybe in the
       * future we can make the behavior configurable. An ideal fix may be
       * to extend the tree cache to support caching loading states.
       */


      if (!isLatestExecution(store, executionID)) {
        const executionInfo = getInProgressExecutionInfo(store, state);

        if (executionInfo != null) {
          /**
           * Returning promise here without wrapping as the wrapper logic was
           * already done upstream when this promise was generated.
           */
          return executionInfo.loadingLoadable.contents;
        }
      } // Retry the selector evaluation now that the dependency has resolved


      const [loadable, depValues] = evaluateSelectorGetter(store, state, executionID);

      if (loadable.state !== 'loading') {
        resolveAsync(store, state, executionID, loadable, depValues);
      }

      if (loadable.state === 'hasError') {
        throw loadable.contents;
      }

      return loadable.contents;
    }).catch(error => {
      // The selector was released since the request began; ignore the response.
      if (error instanceof Canceled) {
        throw CANCELED;
      }

      if (!selectorIsLive()) {
        clearExecutionInfo(store);
        throw CANCELED;
      }

      const loadable = loadableWithError$1(error);
      resolveAsync(store, state, executionID, loadable, existingDeps);
      throw error;
    });
  }

  function updateDeps(store, state, deps, executionID) {
    var _store$getState, _store$getState$curre, _store$getState2, _store$getState2$next;

    if (isLatestExecution(store, executionID) || state.version === ((_store$getState = store.getState()) === null || _store$getState === void 0 ? void 0 : (_store$getState$curre = _store$getState.currentTree) === null || _store$getState$curre === void 0 ? void 0 : _store$getState$curre.version) || state.version === ((_store$getState2 = store.getState()) === null || _store$getState2 === void 0 ? void 0 : (_store$getState2$next = _store$getState2.nextTree) === null || _store$getState2$next === void 0 ? void 0 : _store$getState2$next.version)) {
      var _store$getState$nextT, _store$getState3, _store$getState3$next;

      saveDepsToStore$1(key, deps, store, (_store$getState$nextT = (_store$getState3 = store.getState()) === null || _store$getState3 === void 0 ? void 0 : (_store$getState3$next = _store$getState3.nextTree) === null || _store$getState3$next === void 0 ? void 0 : _store$getState3$next.version) !== null && _store$getState$nextT !== void 0 ? _store$getState$nextT : store.getState().currentTree.version);
    }

    for (const nodeKey of deps) {
      discoveredDependencyNodeKeys.add(nodeKey);
    }
  }

  function evaluateSelectorGetter(store, state, executionID) {
    const endPerfBlock = startPerfBlock$1(key); // TODO T63965866: use execution ID here

    let duringSynchronousExecution = true;
    let duringAsynchronousExecution = true;

    const finishEvaluation = () => {
      endPerfBlock();
      duringAsynchronousExecution = false;
    };

    let result;
    let resultIsError = false;
    let loadable;
    const loadingDepsState = {
      loadingDepKey: null,
      loadingDepPromise: null
    };
    /**
     * Starting a fresh set of deps that we'll be using to update state. We're
     * starting a new set versus adding it in existing state deps because
     * the version of state that we update deps for may be a more recent version
     * than the version the selector was called with. This is because the latest
     * execution will update the deps of the current/latest version of state
     * (This is safe to do because the fact that the selector is the latest
     * execution means the deps we discover below are our best guess at the
     * deps for the current/latest state in the store)
     */

    const depValues = new Map();

    function getRecoilValue({
      key: depKey
    }) {
      const depLoadable = getNodeLoadable$2(store, state, depKey);
      depValues.set(depKey, depLoadable); // We need to update asynchronous dependencies as we go so the selector
      // knows if it has to restart evaluation if one of them is updated before
      // the asynchronous selector completely resolves.

      if (!duringSynchronousExecution) {
        updateDeps(store, state, new Set(depValues.keys()), executionID);
        notifyStoresOfNewAsyncDep(store, executionID);
      }

      switch (depLoadable.state) {
        case 'hasValue':
          return depLoadable.contents;

        case 'hasError':
          throw depLoadable.contents;

        case 'loading':
          loadingDepsState.loadingDepKey = depKey;
          loadingDepsState.loadingDepPromise = depLoadable.contents;
          throw depLoadable.contents;
      }

      throw Recoil_err('Invalid Loadable state');
    }

    const getCallback = fn => {
      return (...args) => {
        if (duringAsynchronousExecution) {
          throw Recoil_err('Callbacks from getCallback() should only be called asynchronously after the selector is evalutated.  It can be used for selectors to return objects with callbacks that can work with Recoil state without a subscription.');
        }

        !(recoilValue != null) ?  false ? 0 : Recoil_invariant(false) : void 0;
        return recoilCallback$1(store, fn, args, {
          node: recoilValue
        } // flowlint-line unclear-type:off
        );
      };
    };

    try {
      result = get({
        get: getRecoilValue,
        getCallback
      });
      result = isRecoilValue$3(result) ? getRecoilValue(result) : result;

      if (isLoadable$1(result)) {
        if (result.state === 'hasError') {
          resultIsError = true;
        }

        result = result.contents;
      }

      if (Recoil_isPromise(result)) {
        result = wrapResultPromise(store, result, state, depValues, executionID, loadingDepsState).finally(finishEvaluation);
      } else {
        finishEvaluation();
      }

      result = result instanceof WrappedValue$1 ? result.value : result;
    } catch (errorOrDepPromise) {
      result = errorOrDepPromise;

      if (Recoil_isPromise(result)) {
        result = wrapPendingDependencyPromise(store, result, state, depValues, executionID, loadingDepsState).finally(finishEvaluation);
      } else {
        resultIsError = true;
        finishEvaluation();
      }
    }

    if (resultIsError) {
      loadable = loadableWithError$1(result);
    } else if (Recoil_isPromise(result)) {
      loadable = loadableWithPromise$1(result);
    } else {
      loadable = loadableWithValue$2(result);
    }

    duringSynchronousExecution = false;
    updateExecutionInfoDepValues(store, executionID, depValues);
    updateDeps(store, state, new Set(depValues.keys()), executionID);
    return [loadable, depValues];
  }

  function getLoadableFromCacheAndUpdateDeps(store, state) {
    // First, look up in the state cache
    // If it's here, then the deps in the store should already be valid.
    let cachedLoadable = state.atomValues.get(key);

    if (cachedLoadable != null) {
      return cachedLoadable;
    } // Second, look up in the selector cache and update the deps in the store


    const depsAfterCacheLookup = new Set();

    try {
      cachedLoadable = cache.get(nodeKey => {
        !(typeof nodeKey === 'string') ?  false ? 0 : Recoil_invariant(false) : void 0;
        return getNodeLoadable$2(store, state, nodeKey).contents;
      }, {
        onNodeVisit: node => {
          if (node.type === 'branch' && node.nodeKey !== key) {
            depsAfterCacheLookup.add(node.nodeKey);
          }
        }
      });
    } catch (error) {
      throw Recoil_err(`Problem with cache lookup for selector "${key}": ${error.message}`);
    }

    if (cachedLoadable) {
      var _getExecutionInfo;

      // Cache the results in the state to allow for cheaper lookup than
      // iterating the tree cache of dependencies.
      state.atomValues.set(key, cachedLoadable);
      /**
       * Ensure store contains correct dependencies if we hit the cache so that
       * the store deps and cache are in sync for a given state. This is important
       * because store deps are normally updated when new executions are created,
       * but cache hits don't trigger new executions but they still _may_ signify
       * a change in deps in the store if the store deps for this state are empty
       * or stale.
       */

      updateDeps(store, state, depsAfterCacheLookup, (_getExecutionInfo = getExecutionInfo(store)) === null || _getExecutionInfo === void 0 ? void 0 : _getExecutionInfo.executionID);
    }

    return cachedLoadable;
  }
  /**
   * Given a tree state, this function returns a Loadable of the current state.
   *
   * The selector's get() function will only be re-evaluated if _both_ of the
   * following statements are true:
   *
   * 1. The current dep values from the given state produced a cache key that
   *    was not found in the cache.
   * 2. There is no currently running async execution OR there is an
   *    async execution that is running, but after comparing the dep values in
   *    the given state with the dep values that the execution has discovered so
   *    far we find that at least one dep value has changed, in which case we
   *    start a new execution (the previously running execution will continue to
   *    run to completion, but only the new execution will be deemed the
   *    'latest' execution, meaning it will be the only execution that will
   *    update global state when it is finished. Any non-latest executions will
   *    run to completion and update the selector cache but not global state).
   */


  function getSelectorLoadableAndUpdateDeps(store, state) {
    // First, see if our current state is cached
    const cachedVal = getLoadableFromCacheAndUpdateDeps(store, state);

    if (cachedVal != null) {
      clearExecutionInfo(store);
      return cachedVal;
    } // Second, check if there is already an ongoing execution based on the current state


    const inProgressExecutionInfo = getInProgressExecutionInfo(store, state);

    if (inProgressExecutionInfo != null) {
      var _inProgressExecutionI;

      if (((_inProgressExecutionI = inProgressExecutionInfo.loadingLoadable) === null || _inProgressExecutionI === void 0 ? void 0 : _inProgressExecutionI.state) === 'loading') {
        markStoreWaitingForResolvedAsync(store, inProgressExecutionInfo.executionID);
      } // FIXME: check after the fact to see if we made the right choice by waiting


      return inProgressExecutionInfo.loadingLoadable;
    } // Third, start a new evaluation of the selector


    const newExecutionID = getNewExecutionID();
    const [loadable, newDepValues] = evaluateSelectorGetter(store, state, newExecutionID);
    /**
     * Conditionally updates the cache with a given loadable.
     *
     * We only cache loadables that are not loading because our cache keys are
     * based on dep values, which are in an unfinished state for loadables that
     * have a 'loading' state (new deps may be discovered while the selector
     * runs its async code). We never want to cache partial dependencies b/c it
     * could lead to errors, such as prematurely returning the result based on a
     * partial list of deps-- we need the full list of deps to ensure that we
     * are returning the correct result from cache.
     */

    if (loadable.state === 'loading') {
      setExecutionInfo(store, newExecutionID, loadable, newDepValues, state);
      markStoreWaitingForResolvedAsync(store, newExecutionID);
    } else {
      clearExecutionInfo(store);
      setCache(state, loadable, newDepValues);
    }

    return loadable;
  }
  /**
   * Searches execution info across all stores to see if there is an in-progress
   * execution whose dependency values match the values of the requesting store.
   */


  function getInProgressExecutionInfo(store, state) {
    // Sort the pending executions so that our current store is checked first.
    const pendingExecutions = Recoil_concatIterables([executionInfoMap.has(store) ? [Recoil_nullthrows(executionInfoMap.get(store))] : [], Recoil_mapIterable(Recoil_filterIterable(executionInfoMap, ([s]) => s !== store), ([, execInfo]) => execInfo)]);

    function anyDepChanged(execDepValues) {
      for (const [depKey, execLoadable] of execDepValues) {
        if (!getNodeLoadable$2(store, state, depKey).is(execLoadable)) {
          return true;
        }
      }

      return false;
    }

    for (const execInfo of pendingExecutions) {
      if ( // If this execution was already checked to be valid with this version
      // of state, then let's use it!
      execInfo.stateVersions.get(state.version) || // If the deps for the execution match our current state, then it's valid
      !anyDepChanged(execInfo.depValuesDiscoveredSoFarDuringAsyncWork)) {
        execInfo.stateVersions.set(state.version, true);
        return execInfo;
      } else {
        execInfo.stateVersions.set(state.version, false);
      }
    }

    return undefined;
  }

  function getExecutionInfo(store) {
    return executionInfoMap.get(store);
  }
  /**
   * This function will update the selector's execution info when the selector
   * has either finished running an execution or has started a new execution. If
   * the given loadable is in a 'loading' state, the intention is that a new
   * execution has started. Otherwise, the intention is that an execution has
   * just finished.
   */


  function setExecutionInfo(store, newExecutionID, loadable, depValues, state) {
    executionInfoMap.set(store, {
      depValuesDiscoveredSoFarDuringAsyncWork: depValues,
      executionID: newExecutionID,
      loadingLoadable: loadable,
      stateVersions: new Map([[state.version, true]])
    });
  }

  function updateExecutionInfoDepValues(store, executionID, depValues) {
    // We only need to bother updating the deps for the latest execution because
    // that's all getInProgressExecutionInfo() will be looking for.
    if (isLatestExecution(store, executionID)) {
      const executionInfo = getExecutionInfo(store);

      if (executionInfo != null) {
        executionInfo.depValuesDiscoveredSoFarDuringAsyncWork = depValues;
      }
    }
  }

  function clearExecutionInfo(store) {
    executionInfoMap.delete(store);
  }

  function isLatestExecution(store, executionID) {
    var _getExecutionInfo2;

    return executionID === ((_getExecutionInfo2 = getExecutionInfo(store)) === null || _getExecutionInfo2 === void 0 ? void 0 : _getExecutionInfo2.executionID);
  }
  /**
   * FIXME: dep keys should take into account the state of the loadable to
   * prevent the edge case where a loadable with an error and a loadable with
   * an error as a value are treated as the same thing incorrectly. For example
   * these two should be treated differently:
   *
   * selector({key: '', get: () => new Error('hi')});
   * selector({key: '', get () => {throw new Error('hi')}});
   *
   * With current implementation they are treated the same
   */


  function depValuesToDepRoute(depValues) {
    return Array.from(depValues.entries()).map(([depKey, valLoadable]) => [depKey, valLoadable.contents]);
  }

  function setCache(state, loadable, depValues) {
    if (false) {}

    state.atomValues.set(key, loadable);

    try {
      cache.set(depValuesToDepRoute(depValues), loadable);
    } catch (error) {
      throw Recoil_err(`Problem with setting cache for selector "${key}": ${error.message}`);
    }
  }

  function detectCircularDependencies(fn) {
    if (dependencyStack.includes(key)) {
      const message = `Recoil selector has circular dependencies: ${dependencyStack.slice(dependencyStack.indexOf(key)).join(' \u2192 ')}`;
      return loadableWithError$1(Recoil_err(message));
    }

    dependencyStack.push(key);

    try {
      return fn();
    } finally {
      dependencyStack.pop();
    }
  }

  function selectorPeek(store, state) {
    const cachedLoadable = state.atomValues.get(key);

    if (cachedLoadable != null) {
      return cachedLoadable;
    }

    return cache.get(nodeKey => {
      var _peekNodeLoadable;

      !(typeof nodeKey === 'string') ?  false ? 0 : Recoil_invariant(false) : void 0;
      return (_peekNodeLoadable = peekNodeLoadable$1(store, state, nodeKey)) === null || _peekNodeLoadable === void 0 ? void 0 : _peekNodeLoadable.contents;
    });
  }

  function selectorGet(store, state) {
    return detectCircularDependencies(() => getSelectorLoadableAndUpdateDeps(store, state));
  }

  function invalidateSelector(state) {
    state.atomValues.delete(key);
  }

  function clearSelectorCache(store, treeState) {
    !(recoilValue != null) ?  false ? 0 : Recoil_invariant(false) : void 0;

    for (const nodeKey of discoveredDependencyNodeKeys) {
      var _node$clearCache;

      const node = getNode$6(nodeKey);
      (_node$clearCache = node.clearCache) === null || _node$clearCache === void 0 ? void 0 : _node$clearCache.call(node, store, treeState);
    }

    discoveredDependencyNodeKeys.clear();
    invalidateSelector(treeState);
    cache.clear();
    markRecoilValueModified$1(store, recoilValue);
  }

  if (set != null) {
    /**
     * ES5 strict mode prohibits defining non-top-level function declarations,
     * so don't use function declaration syntax here
     */
    const selectorSet = (store, state, newValue) => {
      let syncSelectorSetFinished = false;
      const writes = new Map();

      function getRecoilValue({
        key: depKey
      }) {
        if (syncSelectorSetFinished) {
          throw Recoil_err('Recoil: Async selector sets are not currently supported.');
        }

        const loadable = getNodeLoadable$2(store, state, depKey);

        if (loadable.state === 'hasValue') {
          return loadable.contents;
        } else if (loadable.state === 'loading') {
          const msg = `Getting value of asynchronous atom or selector "${depKey}" in a pending state while setting selector "${key}" is not yet supported.`;
          Recoil_recoverableViolation(msg);
          throw Recoil_err(msg);
        } else {
          throw loadable.contents;
        }
      }

      function setRecoilState(recoilState, valueOrUpdater // $FlowFixMe[missing-local-annot]
      ) {
        if (syncSelectorSetFinished) {
          const msg = 'Recoil: Async selector sets are not currently supported.';
          Recoil_recoverableViolation(msg);
          throw Recoil_err(msg);
        }

        const setValue = typeof valueOrUpdater === 'function' ? // cast to any because we can't restrict type S from being a function itself without losing support for opaque types
        // flowlint-next-line unclear-type:off
        valueOrUpdater(getRecoilValue(recoilState)) : valueOrUpdater;
        const upstreamWrites = setNodeValue$3(store, state, recoilState.key, setValue);
        upstreamWrites.forEach((v, k) => writes.set(k, v));
      }

      function resetRecoilState(recoilState) {
        setRecoilState(recoilState, DEFAULT_VALUE$6);
      }

      const ret = set({
        set: setRecoilState,
        get: getRecoilValue,
        reset: resetRecoilState
      }, newValue); // set should be a void method, but if the user makes it `async`, then it
      // will return a Promise, which we don't currently support.

      if (ret !== undefined) {
        throw Recoil_isPromise(ret) ? Recoil_err('Recoil: Async selector sets are not currently supported.') : Recoil_err('Recoil: selector set should be a void function.');
      }

      syncSelectorSetFinished = true;
      return writes;
    };

    return recoilValue = registerNode$1({
      key,
      nodeType: 'selector',
      peek: selectorPeek,
      get: selectorGet,
      set: selectorSet,
      init: selectorInit,
      invalidate: invalidateSelector,
      clearCache: clearSelectorCache,
      shouldDeleteConfigOnRelease: selectorShouldDeleteConfigOnRelease,
      dangerouslyAllowMutability: options.dangerouslyAllowMutability,
      shouldRestoreFromSnapshots: false,
      retainedBy
    });
  } else {
    return recoilValue = registerNode$1({
      key,
      nodeType: 'selector',
      peek: selectorPeek,
      get: selectorGet,
      init: selectorInit,
      invalidate: invalidateSelector,
      clearCache: clearSelectorCache,
      shouldDeleteConfigOnRelease: selectorShouldDeleteConfigOnRelease,
      dangerouslyAllowMutability: options.dangerouslyAllowMutability,
      shouldRestoreFromSnapshots: false,
      retainedBy
    });
  }
}
/* eslint-enable no-redeclare */
// $FlowIssue[incompatible-use]
// $FlowFixMe[missing-local-annot]


selector.value = value => new WrappedValue$1(value);

var Recoil_selector = selector;

// @fb-only: import type {ScopeRules} from 'Recoil_ScopedAtom';
// @fb-only: const {scopedAtom} = require('Recoil_ScopedAtom');
const {
  isLoadable: isLoadable$2,
  loadableWithError: loadableWithError$2,
  loadableWithPromise: loadableWithPromise$2,
  loadableWithValue: loadableWithValue$3
} = Recoil_Loadable$1;

const {
  WrappedValue: WrappedValue$2
} = Recoil_Wrapper$1;

const {
  peekNodeInfo: peekNodeInfo$3
} = Recoil_FunctionalCore;

const {
  DEFAULT_VALUE: DEFAULT_VALUE$7,
  DefaultValue: DefaultValue$2,
  getConfigDeletionHandler: getConfigDeletionHandler$2,
  registerNode: registerNode$2,
  setConfigDeletionHandler: setConfigDeletionHandler$1
} = Recoil_Node;

const {
  isRecoilValue: isRecoilValue$4
} = Recoil_RecoilValue$1;

const {
  getRecoilValueAsLoadable: getRecoilValueAsLoadable$4,
  markRecoilValueModified: markRecoilValueModified$2,
  setRecoilValue: setRecoilValue$4,
  setRecoilValueLoadable: setRecoilValueLoadable$2
} = Recoil_RecoilValueInterface;

const {
  retainedByOptionWithDefault: retainedByOptionWithDefault$2
} = Recoil_Retention;















const unwrap = x => x instanceof WrappedValue$2 ? x.value : x;

function baseAtom(options) {
  const {
    key,
    persistence_UNSTABLE: persistence
  } = options;
  const retainedBy = retainedByOptionWithDefault$2(options.retainedBy_UNSTABLE);
  let liveStoresCount = 0;

  function unwrapPromise(promise) {
    return loadableWithPromise$2(promise.then(value => {
      defaultLoadable = loadableWithValue$3(value);
      return value;
    }).catch(error => {
      defaultLoadable = loadableWithError$2(error);
      throw error;
    }));
  }

  let defaultLoadable = Recoil_isPromise(options.default) ? unwrapPromise(options.default) : isLoadable$2(options.default) ? options.default.state === 'loading' ? unwrapPromise(options.default.contents) : options.default : // $FlowFixMe[incompatible-call]
  loadableWithValue$3(unwrap(options.default));
  maybeFreezeValueOrPromise(defaultLoadable.contents);
  let cachedAnswerForUnvalidatedValue = undefined; // Cleanup handlers for this atom
  // Rely on stable reference equality of the store to use it as a key per <RecoilRoot>

  const cleanupEffectsByStore = new Map();

  function maybeFreezeValueOrPromise(valueOrPromise) {
    if (false) {}

    return valueOrPromise;
  }

  function wrapPendingPromise(store, promise) {
    const wrappedPromise = promise.then(value => {
      var _store$getState$nextT, _state$atomValues$get;

      const state = (_store$getState$nextT = store.getState().nextTree) !== null && _store$getState$nextT !== void 0 ? _store$getState$nextT : store.getState().currentTree;

      if (((_state$atomValues$get = state.atomValues.get(key)) === null || _state$atomValues$get === void 0 ? void 0 : _state$atomValues$get.contents) === wrappedPromise) {
        setRecoilValue$4(store, node, value);
      }

      return value;
    }).catch(error => {
      var _store$getState$nextT2, _state$atomValues$get2;

      const state = (_store$getState$nextT2 = store.getState().nextTree) !== null && _store$getState$nextT2 !== void 0 ? _store$getState$nextT2 : store.getState().currentTree;

      if (((_state$atomValues$get2 = state.atomValues.get(key)) === null || _state$atomValues$get2 === void 0 ? void 0 : _state$atomValues$get2.contents) === wrappedPromise) {
        setRecoilValueLoadable$2(store, node, loadableWithError$2(error));
      }

      throw error;
    });
    return wrappedPromise;
  }

  function initAtom(store, initState, trigger) {
    var _options$effects;

    liveStoresCount++;

    const cleanupAtom = () => {
      var _cleanupEffectsByStor;

      liveStoresCount--;
      (_cleanupEffectsByStor = cleanupEffectsByStore.get(store)) === null || _cleanupEffectsByStor === void 0 ? void 0 : _cleanupEffectsByStor.forEach(cleanup => cleanup());
      cleanupEffectsByStore.delete(store);
    };

    store.getState().knownAtoms.add(key); // Setup async defaults to notify subscribers when they resolve

    if (defaultLoadable.state === 'loading') {
      const notifyDefaultSubscribers = () => {
        var _store$getState$nextT3;

        const state = (_store$getState$nextT3 = store.getState().nextTree) !== null && _store$getState$nextT3 !== void 0 ? _store$getState$nextT3 : store.getState().currentTree;

        if (!state.atomValues.has(key)) {
          markRecoilValueModified$2(store, node);
        }
      };

      defaultLoadable.contents.finally(notifyDefaultSubscribers);
    } ///////////////////
    // Run Atom Effects
    ///////////////////


    const effects = (_options$effects = options.effects) !== null && _options$effects !== void 0 ? _options$effects : options.effects_UNSTABLE;

    if (effects != null) {
      // This state is scoped by Store, since this is in the initAtom() closure
      let initValue = DEFAULT_VALUE$7;
      let isDuringInit = true;
      let isInitError = false;
      let pendingSetSelf = null;

      function getLoadable(recoilValue) {
        // Normally we can just get the current value of another atom.
        // But for our own value we need to check if there is a pending
        // initialized value or get the fallback default value.
        if (isDuringInit && recoilValue.key === key) {
          // Cast T to S
          const retValue = initValue; // flowlint-line unclear-type:off

          return retValue instanceof DefaultValue$2 ? peekAtom(store, initState) // flowlint-line unclear-type:off
          : Recoil_isPromise(retValue) ? loadableWithPromise$2(retValue.then(v => v instanceof DefaultValue$2 ? // Cast T to S
          defaultLoadable.toPromise() // flowlint-line unclear-type:off
          : v)) : // $FlowFixMe[incompatible-call]
          loadableWithValue$3(retValue);
        }

        return getRecoilValueAsLoadable$4(store, recoilValue);
      }

      function getPromise(recoilValue) {
        return getLoadable(recoilValue).toPromise();
      }

      function getInfo_UNSTABLE(recoilValue) {
        var _store$getState$nextT4;

        const info = peekNodeInfo$3(store, (_store$getState$nextT4 = store.getState().nextTree) !== null && _store$getState$nextT4 !== void 0 ? _store$getState$nextT4 : store.getState().currentTree, recoilValue.key);
        return isDuringInit && recoilValue.key === key && !(initValue instanceof DefaultValue$2) ? { ...info,
          isSet: true,
          loadable: getLoadable(recoilValue)
        } : info;
      }

      const setSelf = effect => valueOrUpdater => {
        if (isDuringInit) {
          const currentLoadable = getLoadable(node);
          const currentValue = currentLoadable.state === 'hasValue' ? currentLoadable.contents : DEFAULT_VALUE$7;
          initValue = typeof valueOrUpdater === 'function' ? // cast to any because we can't restrict T from being a function without losing support for opaque types
          valueOrUpdater(currentValue) // flowlint-line unclear-type:off
          : valueOrUpdater;

          if (Recoil_isPromise(initValue)) {
            initValue = initValue.then(value => {
              // Avoid calling onSet() when setSelf() initializes with a Promise
              pendingSetSelf = {
                effect,
                value
              };
              return value;
            });
          }
        } else {
          if (Recoil_isPromise(valueOrUpdater)) {
            throw Recoil_err('Setting atoms to async values is not implemented.');
          }

          if (typeof valueOrUpdater !== 'function') {
            pendingSetSelf = {
              effect,
              value: unwrap(valueOrUpdater)
            };
          }

          setRecoilValue$4(store, node, typeof valueOrUpdater === 'function' ? currentValue => {
            const newValue = unwrap( // cast to any because we can't restrict T from being a function without losing support for opaque types
            valueOrUpdater(currentValue) // flowlint-line unclear-type:off
            ); // $FlowFixMe[incompatible-type]

            pendingSetSelf = {
              effect,
              value: newValue
            };
            return newValue;
          } : unwrap(valueOrUpdater));
        }
      };

      const resetSelf = effect => () => setSelf(effect)(DEFAULT_VALUE$7);

      const onSet = effect => handler => {
        var _cleanupEffectsByStor2;

        const {
          release
        } = store.subscribeToTransactions(currentStore => {
          var _currentTree$atomValu;

          // eslint-disable-next-line prefer-const
          let {
            currentTree,
            previousTree
          } = currentStore.getState();

          if (!previousTree) {
            Recoil_recoverableViolation('Transaction subscribers notified without a next tree being present -- this is a bug in Recoil');
            previousTree = currentTree; // attempt to trundle on
          }

          const newLoadable = (_currentTree$atomValu = currentTree.atomValues.get(key)) !== null && _currentTree$atomValu !== void 0 ? _currentTree$atomValu : defaultLoadable;

          if (newLoadable.state === 'hasValue') {
            var _previousTree$atomVal, _pendingSetSelf, _pendingSetSelf2, _pendingSetSelf3;

            const newValue = newLoadable.contents;
            const oldLoadable = (_previousTree$atomVal = previousTree.atomValues.get(key)) !== null && _previousTree$atomVal !== void 0 ? _previousTree$atomVal : defaultLoadable;
            const oldValue = oldLoadable.state === 'hasValue' ? oldLoadable.contents : DEFAULT_VALUE$7; // TODO This isn't actually valid, use as a placeholder for now.
            // Ignore atom value changes that were set via setSelf() in the same effect.
            // We will still properly call the handler if there was a subsequent
            // set from something other than an atom effect which was batched
            // with the `setSelf()` call.  However, we may incorrectly ignore
            // the handler if the subsequent batched call happens to set the
            // atom to the exact same value as the `setSelf()`.   But, in that
            // case, it was kind of a noop, so the semantics are debatable..

            if (((_pendingSetSelf = pendingSetSelf) === null || _pendingSetSelf === void 0 ? void 0 : _pendingSetSelf.effect) !== effect || ((_pendingSetSelf2 = pendingSetSelf) === null || _pendingSetSelf2 === void 0 ? void 0 : _pendingSetSelf2.value) !== newValue) {
              handler(newValue, oldValue, !currentTree.atomValues.has(key));
            } else if (((_pendingSetSelf3 = pendingSetSelf) === null || _pendingSetSelf3 === void 0 ? void 0 : _pendingSetSelf3.effect) === effect) {
              pendingSetSelf = null;
            }
          }
        }, key);
        cleanupEffectsByStore.set(store, [...((_cleanupEffectsByStor2 = cleanupEffectsByStore.get(store)) !== null && _cleanupEffectsByStor2 !== void 0 ? _cleanupEffectsByStor2 : []), release]);
      };

      for (const effect of effects) {
        try {
          const cleanup = effect({
            node,
            storeID: store.storeID,
            parentStoreID_UNSTABLE: store.parentStoreID,
            trigger,
            setSelf: setSelf(effect),
            resetSelf: resetSelf(effect),
            onSet: onSet(effect),
            getPromise,
            getLoadable,
            getInfo_UNSTABLE
          });

          if (cleanup != null) {
            var _cleanupEffectsByStor3;

            cleanupEffectsByStore.set(store, [...((_cleanupEffectsByStor3 = cleanupEffectsByStore.get(store)) !== null && _cleanupEffectsByStor3 !== void 0 ? _cleanupEffectsByStor3 : []), cleanup]);
          }
        } catch (error) {
          initValue = error;
          isInitError = true;
        }
      }

      isDuringInit = false; // Mutate initial state in place since we know there are no other subscribers
      // since we are the ones initializing on first use.

      if (!(initValue instanceof DefaultValue$2)) {
        var _store$getState$nextT5;

        const initLoadable = isInitError ? loadableWithError$2(initValue) : Recoil_isPromise(initValue) ? loadableWithPromise$2(wrapPendingPromise(store, initValue)) : loadableWithValue$3(unwrap(initValue));
        maybeFreezeValueOrPromise(initLoadable.contents);
        initState.atomValues.set(key, initLoadable); // If there is a pending transaction, then also mutate the next state tree.
        // This could happen if the atom was first initialized in an action that
        // also updated some other atom's state.

        (_store$getState$nextT5 = store.getState().nextTree) === null || _store$getState$nextT5 === void 0 ? void 0 : _store$getState$nextT5.atomValues.set(key, initLoadable);
      }
    }

    return cleanupAtom;
  }

  function peekAtom(_store, state) {
    var _ref, _state$atomValues$get3;

    return (_ref = (_state$atomValues$get3 = state.atomValues.get(key)) !== null && _state$atomValues$get3 !== void 0 ? _state$atomValues$get3 : cachedAnswerForUnvalidatedValue) !== null && _ref !== void 0 ? _ref : defaultLoadable;
  }

  function getAtom(_store, state) {
    if (state.atomValues.has(key)) {
      // Atom value is stored in state:
      return Recoil_nullthrows(state.atomValues.get(key));
    } else if (state.nonvalidatedAtoms.has(key)) {
      // Atom value is stored but needs validation before use.
      // We might have already validated it and have a cached validated value:
      if (cachedAnswerForUnvalidatedValue != null) {
        return cachedAnswerForUnvalidatedValue;
      }

      if (persistence == null) {
        Recoil_expectationViolation(`Tried to restore a persisted value for atom ${key} but it has no persistence settings.`);
        return defaultLoadable;
      }

      const nonvalidatedValue = state.nonvalidatedAtoms.get(key);
      const validatorResult = persistence.validator(nonvalidatedValue, DEFAULT_VALUE$7);
      const validatedValueLoadable = validatorResult instanceof DefaultValue$2 ? defaultLoadable : loadableWithValue$3(validatorResult);
      cachedAnswerForUnvalidatedValue = validatedValueLoadable;
      return cachedAnswerForUnvalidatedValue;
    } else {
      return defaultLoadable;
    }
  }

  function invalidateAtom() {
    cachedAnswerForUnvalidatedValue = undefined;
  }

  function setAtom(_store, state, newValue) {
    // Bail out if we're being set to the existing value, or if we're being
    // reset but have no stored value (validated or unvalidated) to reset from:
    if (state.atomValues.has(key)) {
      const existing = Recoil_nullthrows(state.atomValues.get(key));

      if (existing.state === 'hasValue' && newValue === existing.contents) {
        return new Map();
      }
    } else if (!state.nonvalidatedAtoms.has(key) && newValue instanceof DefaultValue$2) {
      return new Map();
    }

    maybeFreezeValueOrPromise(newValue);
    cachedAnswerForUnvalidatedValue = undefined; // can be released now if it was previously in use

    return new Map().set(key, loadableWithValue$3(newValue));
  }

  function shouldDeleteConfigOnReleaseAtom() {
    return getConfigDeletionHandler$2(key) !== undefined && liveStoresCount <= 0;
  }

  const node = registerNode$2({
    key,
    nodeType: 'atom',
    peek: peekAtom,
    get: getAtom,
    set: setAtom,
    init: initAtom,
    invalidate: invalidateAtom,
    shouldDeleteConfigOnRelease: shouldDeleteConfigOnReleaseAtom,
    dangerouslyAllowMutability: options.dangerouslyAllowMutability,
    persistence_UNSTABLE: options.persistence_UNSTABLE ? {
      type: options.persistence_UNSTABLE.type,
      backButton: options.persistence_UNSTABLE.backButton
    } : undefined,
    shouldRestoreFromSnapshots: true,
    retainedBy
  });
  return node;
} // prettier-ignore


function atom(options) {
  if (false) {}

  const { // @fb-only: scopeRules_APPEND_ONLY_READ_THE_DOCS,
    ...restOptions
  } = options;
  const optionsDefault = 'default' in options ? // $FlowIssue[incompatible-type] No way to refine in Flow that property is not defined
  options.default : new Promise(() => {});

  if (isRecoilValue$4(optionsDefault) // Continue to use atomWithFallback for promise defaults for scoped atoms
  // for now, since scoped atoms don't support async defaults
  // @fb-only: || (isPromise(optionsDefault) && scopeRules_APPEND_ONLY_READ_THE_DOCS)
  // @fb-only: || (isLoadable(optionsDefault) && scopeRules_APPEND_ONLY_READ_THE_DOCS)
  ) {
    return atomWithFallback({ ...restOptions,
      default: optionsDefault // @fb-only: scopeRules_APPEND_ONLY_READ_THE_DOCS,

    }); // @fb-only: } else if (scopeRules_APPEND_ONLY_READ_THE_DOCS
    // @fb-only: && !isPromise(optionsDefault)
    // @fb-only: && !isLoadable(optionsDefault)
    // @fb-only: ) {
    // @fb-only: return scopedAtom<T>({
    // @fb-only: ...restOptions,
    // @fb-only: default: unwrap<T>(optionsDefault),
    // @fb-only: scopeRules_APPEND_ONLY_READ_THE_DOCS,
    // @fb-only: });
  } else {
    return baseAtom({ ...restOptions,
      default: optionsDefault
    });
  }
}

function atomWithFallback(options) {
  const base = atom({ ...options,
    default: DEFAULT_VALUE$7,
    persistence_UNSTABLE: options.persistence_UNSTABLE === undefined ? undefined : { ...options.persistence_UNSTABLE,
      validator: storedValue => storedValue instanceof DefaultValue$2 ? storedValue : Recoil_nullthrows(options.persistence_UNSTABLE).validator(storedValue, DEFAULT_VALUE$7)
    },
    // TODO Hack for now.
    effects: options.effects,
    // flowlint-line unclear-type: off
    effects_UNSTABLE: options.effects_UNSTABLE // flowlint-line unclear-type: off

  }); // $FlowFixMe[incompatible-call]

  const sel = Recoil_selector({
    key: `${options.key}__withFallback`,
    get: ({
      get
    }) => {
      const baseValue = get(base);
      return baseValue instanceof DefaultValue$2 ? options.default : baseValue;
    },
    // $FlowFixMe[incompatible-call]
    set: ({
      set
    }, newValue) => set(base, newValue),
    // This selector does not need to cache as it is a wrapper selector
    // and the selector within the wrapper selector will have a cache
    // option by default
    cachePolicy_UNSTABLE: {
      eviction: 'most-recent'
    },
    dangerouslyAllowMutability: options.dangerouslyAllowMutability
  });
  setConfigDeletionHandler$1(sel.key, getConfigDeletionHandler$2(options.key));
  return sel;
} // $FlowFixMe[missing-local-annot]


atom.value = value => new WrappedValue$2(value);

var Recoil_atom = atom;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */

class MapCache {
  constructor(options) {
    var _options$mapKey;

    _defineProperty(this, "_map", void 0);

    _defineProperty(this, "_keyMapper", void 0);

    this._map = new Map();
    this._keyMapper = (_options$mapKey = options === null || options === void 0 ? void 0 : options.mapKey) !== null && _options$mapKey !== void 0 ? _options$mapKey : v => v;
  }

  size() {
    return this._map.size;
  }

  has(key) {
    return this._map.has(this._keyMapper(key));
  }

  get(key) {
    return this._map.get(this._keyMapper(key));
  }

  set(key, val) {
    this._map.set(this._keyMapper(key), val);
  }

  delete(key) {
    this._map.delete(this._keyMapper(key));
  }

  clear() {
    this._map.clear();
  }

}

var Recoil_MapCache = {
  MapCache
};

var Recoil_MapCache_1 = Recoil_MapCache.MapCache;

var Recoil_MapCache$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  MapCache: Recoil_MapCache_1
});

const {
  LRUCache: LRUCache$2
} = Recoil_LRUCache$1;

const {
  MapCache: MapCache$1
} = Recoil_MapCache$1;







const defaultPolicy$1 = {
  equality: 'reference',
  eviction: 'none',
  maxSize: Infinity
};

function cacheFromPolicy({
  equality = defaultPolicy$1.equality,
  eviction = defaultPolicy$1.eviction,
  maxSize = defaultPolicy$1.maxSize
} = defaultPolicy$1) {
  const valueMapper = getValueMapper$1(equality);
  const cache = getCache(eviction, maxSize, valueMapper);
  return cache;
}

function getValueMapper$1(equality) {
  switch (equality) {
    case 'reference':
      return val => val;

    case 'value':
      return val => Recoil_stableStringify(val);
  }

  throw Recoil_err(`Unrecognized equality policy ${equality}`);
}

function getCache(eviction, maxSize, mapKey) {
  switch (eviction) {
    case 'keep-all':
      return new MapCache$1({
        mapKey
      });

    case 'lru':
      return new LRUCache$2({
        mapKey,
        maxSize: Recoil_nullthrows(maxSize)
      });

    case 'most-recent':
      return new LRUCache$2({
        mapKey,
        maxSize: 1
      });
  }

  throw Recoil_err(`Unrecognized eviction policy ${eviction}`);
}

var Recoil_cacheFromPolicy = cacheFromPolicy;

// @fb-only: import type {ScopeRules} from 'Recoil_ScopedAtom';


const {
  setConfigDeletionHandler: setConfigDeletionHandler$2
} = Recoil_Node;





// Process scopeRules to handle any entries which are functions taking parameters
// prettier-ignore
// @fb-only: function mapScopeRules<P>(
// @fb-only: scopeRules?: ParameterizedScopeRules<P>,
// @fb-only: param: P,
// @fb-only: ): ScopeRules | void {
// @fb-only: return scopeRules?.map(rule =>
// @fb-only: Array.isArray(rule)
// @fb-only: ? rule.map(entry => (typeof entry === 'function' ? entry(param) : entry))
// @fb-only: : rule,
// @fb-only: );
// @fb-only: }

/*
A function which returns an atom based on the input parameter.

Each unique parameter returns a unique atom. E.g.,

  const f = atomFamily(...);
  f({a: 1}) => an atom
  f({a: 2}) => a different atom

This allows components to persist local, private state using atoms.  Each
instance of the component may have a different key, which it uses as the
parameter for a family of atoms; in this way, each component will have
its own atom not shared by other instances.  These state keys may be composed
into children's state keys as well.
*/
function atomFamily(options) {
  var _options$cachePolicyF, _options$cachePolicyF2;

  const atomCache = Recoil_cacheFromPolicy({
    equality: (_options$cachePolicyF = (_options$cachePolicyF2 = options.cachePolicyForParams_UNSTABLE) === null || _options$cachePolicyF2 === void 0 ? void 0 : _options$cachePolicyF2.equality) !== null && _options$cachePolicyF !== void 0 ? _options$cachePolicyF : 'value',
    eviction: 'keep-all'
  }); // Simple atomFamily implementation to cache individual atoms based
  // on the parameter value equality.

  return params => {
    var _stableStringify, _options$effects;

    const cachedAtom = atomCache.get(params);

    if (cachedAtom != null) {
      return cachedAtom;
    }

    const {
      cachePolicyForParams_UNSTABLE,
      ...atomOptions
    } = options;
    const optionsDefault = 'default' in options ? // $FlowIssue[incompatible-type] No way to refine in Flow that property is not defined
    options.default : new Promise(() => {});
    const newAtom = Recoil_atom({ ...atomOptions,
      key: `${options.key}__${(_stableStringify = Recoil_stableStringify(params)) !== null && _stableStringify !== void 0 ? _stableStringify : 'void'}`,
      default: typeof optionsDefault === 'function' ? // The default was parameterized
      // Flow doesn't know that T isn't a function, so we need to case to any
      // $FlowIssue[incompatible-use]
      optionsDefault(params) : // Default may be a static value, promise, or RecoilValue
      optionsDefault,
      retainedBy_UNSTABLE: typeof options.retainedBy_UNSTABLE === 'function' ? options.retainedBy_UNSTABLE(params) : options.retainedBy_UNSTABLE,
      effects: typeof options.effects === 'function' ? options.effects(params) : typeof options.effects_UNSTABLE === 'function' ? options.effects_UNSTABLE(params) : (_options$effects = options.effects) !== null && _options$effects !== void 0 ? _options$effects : options.effects_UNSTABLE // prettier-ignore
      // @fb-only: scopeRules_APPEND_ONLY_READ_THE_DOCS: mapScopeRules(
      // @fb-only: options.scopeRules_APPEND_ONLY_READ_THE_DOCS,
      // @fb-only: params,
      // @fb-only: ),

    });
    atomCache.set(params, newAtom);
    setConfigDeletionHandler$2(newAtom.key, () => {
      atomCache.delete(params);
    });
    return newAtom;
  };
}

var Recoil_atomFamily = atomFamily;

const {
  setConfigDeletionHandler: setConfigDeletionHandler$3
} = Recoil_Node;





 // Keep in mind the parameter needs to be serializable as a cahche key
// using Recoil_stableStringify


// Add a unique index to each selector in case the cache implementation allows
// duplicate keys based on equivalent stringified parameters
let nextIndex = 0;
/* eslint-disable no-redeclare */

// Return a function that returns members of a family of selectors of the same type
// E.g.,
//
// const s = selectorFamily(...);
// s({a: 1}) => a selector
// s({a: 2}) => a different selector
//
// By default, the selectors are distinguished by distinct values of the
// parameter based on value equality, not reference equality.  This allows using
// object literals or other equivalent objects at callsites to not create
// duplicate cache entries.  This behavior may be overridden with the
// cacheImplementationForParams option.
function selectorFamily(options) {
  var _options$cachePolicyF, _options$cachePolicyF2;

  const selectorCache = Recoil_cacheFromPolicy({
    equality: (_options$cachePolicyF = (_options$cachePolicyF2 = options.cachePolicyForParams_UNSTABLE) === null || _options$cachePolicyF2 === void 0 ? void 0 : _options$cachePolicyF2.equality) !== null && _options$cachePolicyF !== void 0 ? _options$cachePolicyF : 'value',
    eviction: 'keep-all'
  });
  return params => {
    var _stableStringify;

    // Throw an error with selector key so that it is clear which
    // selector is causing an error
    let cachedSelector;

    try {
      cachedSelector = selectorCache.get(params);
    } catch (error) {
      throw Recoil_err(`Problem with cache lookup for selector ${options.key}: ${error.message}`);
    }

    if (cachedSelector != null) {
      return cachedSelector;
    }

    const myKey = `${options.key}__selectorFamily/${(_stableStringify = Recoil_stableStringify(params, {
      // It is possible to use functions in parameters if the user uses
      // a cache with reference equality thanks to the incrementing index.
      allowFunctions: true
    })) !== null && _stableStringify !== void 0 ? _stableStringify : 'void'}/${nextIndex++}`; // Append index in case values serialize to the same key string

    const myGet = callbacks => options.get(params)(callbacks);

    const myCachePolicy = options.cachePolicy_UNSTABLE;
    const retainedBy = typeof options.retainedBy_UNSTABLE === 'function' ? options.retainedBy_UNSTABLE(params) : options.retainedBy_UNSTABLE;
    let newSelector;

    if (options.set != null) {
      const set = options.set;

      const mySet = (callbacks, newValue) => set(params)(callbacks, newValue);

      newSelector = Recoil_selector({
        key: myKey,
        get: myGet,
        set: mySet,
        cachePolicy_UNSTABLE: myCachePolicy,
        dangerouslyAllowMutability: options.dangerouslyAllowMutability,
        retainedBy_UNSTABLE: retainedBy
      });
    } else {
      newSelector = Recoil_selector({
        key: myKey,
        get: myGet,
        cachePolicy_UNSTABLE: myCachePolicy,
        dangerouslyAllowMutability: options.dangerouslyAllowMutability,
        retainedBy_UNSTABLE: retainedBy
      });
    }

    selectorCache.set(params, newSelector);
    setConfigDeletionHandler$3(newSelector.key, () => {
      selectorCache.delete(params);
    });
    return newSelector;
  };
}
/* eslint-enable no-redeclare */


var Recoil_selectorFamily = selectorFamily;

// flowlint-next-line unclear-type:off


const constantSelector = Recoil_selectorFamily({
  key: '__constant',
  get: constant => () => constant,
  cachePolicyForParams_UNSTABLE: {
    equality: 'reference'
  }
}); // Function that returns a selector which always produces the
// same constant value.  It may be called multiple times with the
// same value, based on reference equality, and will provide the
// same selector.

function constSelector(constant) {
  return constantSelector(constant);
}

var Recoil_constSelector = constSelector;

// flowlint-next-line unclear-type:off


const throwingSelector = Recoil_selectorFamily({
  key: '__error',
  get: message => () => {
    throw Recoil_err(message);
  },
  // TODO Why?
  cachePolicyForParams_UNSTABLE: {
    equality: 'reference'
  }
}); // Function that returns a selector which always throws an error
// with the provided message.

function errorSelector(message) {
  return throwingSelector(message);
}

var Recoil_errorSelector = errorSelector;

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Wraps another recoil value and prevents writing to it.
 *
 * 
 * @format
 * @oncall recoil
 */

function readOnlySelector(atom) {
  // flowlint-next-line unclear-type: off
  return atom;
}

var Recoil_readOnlySelector = readOnlySelector;

const {
  loadableWithError: loadableWithError$3,
  loadableWithPromise: loadableWithPromise$3,
  loadableWithValue: loadableWithValue$4
} = Recoil_Loadable$1;





 /////////////////
//  TRUTH TABLE
/////////////////
// Dependencies        waitForNone         waitForAny        waitForAll       waitForAllSettled
//  [loading, loading]  [Promise, Promise]  Promise           Promise         Promise
//  [value, loading]    [value, Promise]    [value, Promise]  Promise         Promise
//  [value, value]      [value, value]      [value, value]    [value, value]  [value, value]
//
//  [error, loading]    [Error, Promise]    [Error, Promise]  Error           Promise
//  [error, error]      [Error, Error]      [Error, Error]    Error           [error, error]
//  [value, error]      [value, Error]      [value, Error]    Error           [value, error]
// Issue parallel requests for all dependencies and return the current
// status if they have results, have some error, or are still pending.


function concurrentRequests(getRecoilValue, deps) {
  const results = Array(deps.length).fill(undefined);
  const exceptions = Array(deps.length).fill(undefined);

  for (const [i, dep] of deps.entries()) {
    try {
      results[i] = getRecoilValue(dep);
    } catch (e) {
      // exceptions can either be Promises of pending results or real errors
      exceptions[i] = e;
    }
  }

  return [results, exceptions];
}

function isError(exp) {
  return exp != null && !Recoil_isPromise(exp);
}

function unwrapDependencies(dependencies) {
  return Array.isArray(dependencies) ? dependencies : Object.getOwnPropertyNames(dependencies).map(key => dependencies[key]);
}

function wrapResults(dependencies,
/* $FlowFixMe[missing-local-annot] The type annotation(s) required by Flow's
 * LTI update could not be added via codemod */
results) {
  return Array.isArray(dependencies) ? results : // Object.getOwnPropertyNames() has consistent key ordering with ES6
  Object.getOwnPropertyNames(dependencies).reduce((out, key, idx) => ({ ...out,
    [key]: results[idx]
  }), {});
}

function wrapLoadables(dependencies, results, exceptions) {
  const output = exceptions.map((exception, idx) => exception == null ? loadableWithValue$4(results[idx]) : Recoil_isPromise(exception) ? loadableWithPromise$3(exception) : loadableWithError$3(exception));
  return wrapResults(dependencies, output);
}

function combineAsyncResultsWithSyncResults(syncResults, asyncResults) {
  return asyncResults.map((result, idx) =>
  /**
   * it's important we use === undefined as opposed to == null, because the
   * resolved value of the async promise could be `null`, in which case we
   * don't want to use syncResults[idx], which would be undefined. If async
   * promise resolves to `undefined`, that's ok because `syncResults[idx]`
   * will also be `undefined`. That's a little hacky, but it works.
   */
  result === undefined ? syncResults[idx] : result);
} // Selector that requests all dependencies in parallel and immediately returns
// current results without waiting.


const waitForNone = Recoil_selectorFamily({
  key: '__waitForNone',
  get: dependencies => ({
    get
  }) => {
    // Issue requests for all dependencies in parallel.
    const deps = unwrapDependencies(dependencies);
    const [results, exceptions] = concurrentRequests(get, deps); // Always return the current status of the results; never block.

    return wrapLoadables(dependencies, results, exceptions);
  },
  dangerouslyAllowMutability: true
}); // Selector that requests all dependencies in parallel and waits for at least
// one to be available before returning results.  It will only error if all
// dependencies have errors.

const waitForAny = Recoil_selectorFamily({
  key: '__waitForAny',
  get: dependencies => ({
    get
  }) => {
    // Issue requests for all dependencies in parallel.
    // Exceptions can either be Promises of pending results or real errors
    const deps = unwrapDependencies(dependencies);
    const [results, exceptions] = concurrentRequests(get, deps); // If any results are available, value or error, return the current status

    if (exceptions.some(exp => !Recoil_isPromise(exp))) {
      return wrapLoadables(dependencies, results, exceptions);
    } // Otherwise, return a promise that will resolve when the next result is
    // available, whichever one happens to be next.  But, if all pending
    // dependencies end up with errors, then reject the promise.


    return new Promise(resolve => {
      for (const [i, exp] of exceptions.entries()) {
        if (Recoil_isPromise(exp)) {
          exp.then(result => {
            results[i] = result;
            exceptions[i] = undefined;
            resolve(wrapLoadables(dependencies, results, exceptions));
          }).catch(error => {
            exceptions[i] = error;
            resolve(wrapLoadables(dependencies, results, exceptions));
          });
        }
      }
    });
  },
  dangerouslyAllowMutability: true
}); // Selector that requests all dependencies in parallel and waits for all to be
// available before returning a value.  It will error if any dependencies error.

const waitForAll = Recoil_selectorFamily({
  key: '__waitForAll',
  get: dependencies => ({
    get
  }) => {
    // Issue requests for all dependencies in parallel.
    // Exceptions can either be Promises of pending results or real errors
    const deps = unwrapDependencies(dependencies);
    const [results, exceptions] = concurrentRequests(get, deps); // If all results are available, return the results

    if (exceptions.every(exp => exp == null)) {
      return wrapResults(dependencies, results);
    } // If we have any errors, throw the first error


    const error = exceptions.find(isError);

    if (error != null) {
      throw error;
    } // Otherwise, return a promise that will resolve when all results are available


    return Promise.all(exceptions).then(exceptionResults => wrapResults(dependencies, combineAsyncResultsWithSyncResults(results, exceptionResults)));
  },
  dangerouslyAllowMutability: true
});
const waitForAllSettled = Recoil_selectorFamily({
  key: '__waitForAllSettled',
  get: dependencies => ({
    get
  }) => {
    // Issue requests for all dependencies in parallel.
    // Exceptions can either be Promises of pending results or real errors
    const deps = unwrapDependencies(dependencies);
    const [results, exceptions] = concurrentRequests(get, deps); // If all results are available, return the results

    if (exceptions.every(exp => !Recoil_isPromise(exp))) {
      return wrapLoadables(dependencies, results, exceptions);
    } // Wait for all results to settle


    return Promise.all(exceptions.map((exp, i) => Recoil_isPromise(exp) ? exp.then(result => {
      results[i] = result;
      exceptions[i] = undefined;
    }).catch(error => {
      results[i] = undefined;
      exceptions[i] = error;
    }) : null)) // Then wrap them as loadables
    .then(() => wrapLoadables(dependencies, results, exceptions));
  },
  dangerouslyAllowMutability: true
});
const noWait = Recoil_selectorFamily({
  key: '__noWait',
  get: dependency => ({
    get
  }) => {
    try {
      return Recoil_selector.value(loadableWithValue$4(get(dependency)));
    } catch (exception) {
      return Recoil_selector.value(Recoil_isPromise(exception) ? loadableWithPromise$3(exception) : loadableWithError$3(exception));
    }
  },
  dangerouslyAllowMutability: true
});
var Recoil_WaitFor = {
  waitForNone,
  waitForAny,
  waitForAll,
  waitForAllSettled,
  noWait
};

const {
  RecoilLoadable
} = Recoil_Loadable$1;

const {
  DefaultValue: DefaultValue$3
} = Recoil_Node;

const {
  RecoilRoot: RecoilRoot$2,
  useRecoilStoreID: useRecoilStoreID$1
} = Recoil_RecoilRoot;

const {
  isRecoilValue: isRecoilValue$5
} = Recoil_RecoilValue$1;

const {
  retentionZone: retentionZone$1
} = Recoil_RetentionZone;

const {
  freshSnapshot: freshSnapshot$2
} = Recoil_Snapshot$1;

const {
  useRecoilState: useRecoilState$1,
  useRecoilState_TRANSITION_SUPPORT_UNSTABLE: useRecoilState_TRANSITION_SUPPORT_UNSTABLE$1,
  useRecoilStateLoadable: useRecoilStateLoadable$1,
  useRecoilValue: useRecoilValue$1,
  useRecoilValue_TRANSITION_SUPPORT_UNSTABLE: useRecoilValue_TRANSITION_SUPPORT_UNSTABLE$1,
  useRecoilValueLoadable: useRecoilValueLoadable$1,
  useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE: useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE$1,
  useResetRecoilState: useResetRecoilState$1,
  useSetRecoilState: useSetRecoilState$1
} = Recoil_Hooks;

const {
  useGotoRecoilSnapshot: useGotoRecoilSnapshot$1,
  useRecoilSnapshot: useRecoilSnapshot$1,
  useRecoilTransactionObserver: useRecoilTransactionObserver$1
} = Recoil_SnapshotHooks;





const {
  useRecoilCallback: useRecoilCallback$1
} = Recoil_useRecoilCallback;





















const {
  noWait: noWait$1,
  waitForAll: waitForAll$1,
  waitForAllSettled: waitForAllSettled$1,
  waitForAny: waitForAny$1,
  waitForNone: waitForNone$1
} = Recoil_WaitFor;



var Recoil_index = {
  // Types
  DefaultValue: DefaultValue$3,
  isRecoilValue: isRecoilValue$5,
  RecoilLoadable,
  // Global Recoil environment settiongs
  RecoilEnv: Recoil_RecoilEnv,
  // Recoil Root
  RecoilRoot: RecoilRoot$2,
  useRecoilStoreID: useRecoilStoreID$1,
  useRecoilBridgeAcrossReactRoots_UNSTABLE: Recoil_useRecoilBridgeAcrossReactRoots,
  // Atoms/Selectors
  atom: Recoil_atom,
  selector: Recoil_selector,
  // Convenience Atoms/Selectors
  atomFamily: Recoil_atomFamily,
  selectorFamily: Recoil_selectorFamily,
  constSelector: Recoil_constSelector,
  errorSelector: Recoil_errorSelector,
  readOnlySelector: Recoil_readOnlySelector,
  // Concurrency Helpers for Atoms/Selectors
  noWait: noWait$1,
  waitForNone: waitForNone$1,
  waitForAny: waitForAny$1,
  waitForAll: waitForAll$1,
  waitForAllSettled: waitForAllSettled$1,
  // Hooks for Atoms/Selectors
  useRecoilValue: useRecoilValue$1,
  useRecoilValueLoadable: useRecoilValueLoadable$1,
  useRecoilState: useRecoilState$1,
  useRecoilStateLoadable: useRecoilStateLoadable$1,
  useSetRecoilState: useSetRecoilState$1,
  useResetRecoilState: useResetRecoilState$1,
  useGetRecoilValueInfo_UNSTABLE: Recoil_useGetRecoilValueInfo,
  useRecoilRefresher_UNSTABLE: Recoil_useRecoilRefresher,
  useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE: useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE$1,
  useRecoilValue_TRANSITION_SUPPORT_UNSTABLE: useRecoilValue_TRANSITION_SUPPORT_UNSTABLE$1,
  useRecoilState_TRANSITION_SUPPORT_UNSTABLE: useRecoilState_TRANSITION_SUPPORT_UNSTABLE$1,
  // Hooks for complex operations
  useRecoilCallback: useRecoilCallback$1,
  useRecoilTransaction_UNSTABLE: Recoil_useRecoilTransaction,
  // Snapshots
  useGotoRecoilSnapshot: useGotoRecoilSnapshot$1,
  useRecoilSnapshot: useRecoilSnapshot$1,
  useRecoilTransactionObserver_UNSTABLE: useRecoilTransactionObserver$1,
  snapshot_UNSTABLE: freshSnapshot$2,
  // Memory Management
  useRetain: Recoil_useRetain,
  retentionZone: retentionZone$1
};
var Recoil_index_1 = Recoil_index.DefaultValue;
var Recoil_index_2 = Recoil_index.isRecoilValue;
var Recoil_index_3 = Recoil_index.RecoilLoadable;
var Recoil_index_4 = Recoil_index.RecoilEnv;
var Recoil_index_5 = Recoil_index.RecoilRoot;
var Recoil_index_6 = Recoil_index.useRecoilStoreID;
var Recoil_index_7 = Recoil_index.useRecoilBridgeAcrossReactRoots_UNSTABLE;
var Recoil_index_8 = Recoil_index.atom;
var Recoil_index_9 = Recoil_index.selector;
var Recoil_index_10 = Recoil_index.atomFamily;
var Recoil_index_11 = Recoil_index.selectorFamily;
var Recoil_index_12 = Recoil_index.constSelector;
var Recoil_index_13 = Recoil_index.errorSelector;
var Recoil_index_14 = Recoil_index.readOnlySelector;
var Recoil_index_15 = Recoil_index.noWait;
var Recoil_index_16 = Recoil_index.waitForNone;
var Recoil_index_17 = Recoil_index.waitForAny;
var Recoil_index_18 = Recoil_index.waitForAll;
var Recoil_index_19 = Recoil_index.waitForAllSettled;
var Recoil_index_20 = Recoil_index.useRecoilValue;
var Recoil_index_21 = Recoil_index.useRecoilValueLoadable;
var Recoil_index_22 = Recoil_index.useRecoilState;
var Recoil_index_23 = Recoil_index.useRecoilStateLoadable;
var Recoil_index_24 = Recoil_index.useSetRecoilState;
var Recoil_index_25 = Recoil_index.useResetRecoilState;
var Recoil_index_26 = Recoil_index.useGetRecoilValueInfo_UNSTABLE;
var Recoil_index_27 = Recoil_index.useRecoilRefresher_UNSTABLE;
var Recoil_index_28 = Recoil_index.useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE;
var Recoil_index_29 = Recoil_index.useRecoilValue_TRANSITION_SUPPORT_UNSTABLE;
var Recoil_index_30 = Recoil_index.useRecoilState_TRANSITION_SUPPORT_UNSTABLE;
var Recoil_index_31 = Recoil_index.useRecoilCallback;
var Recoil_index_32 = Recoil_index.useRecoilTransaction_UNSTABLE;
var Recoil_index_33 = Recoil_index.useGotoRecoilSnapshot;
var Recoil_index_34 = Recoil_index.useRecoilSnapshot;
var Recoil_index_35 = Recoil_index.useRecoilTransactionObserver_UNSTABLE;
var Recoil_index_36 = Recoil_index.snapshot_UNSTABLE;
var Recoil_index_37 = Recoil_index.useRetain;
var Recoil_index_38 = Recoil_index.retentionZone;

/* harmony default export */ __webpack_exports__["default"] = (Recoil_index);



/***/ }),

/***/ 1914:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(7378);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {};

var uaParser = {exports: {}};

(function (module, exports) {
/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v1.0.33
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License *//*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment. 
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */
/////////////////////////////////////////////////////////////////////////////////

(function (window, undefined$1) {

    //////////////
    // Constants
    /////////////


    var LIBVERSION  = '1.0.33',
        EMPTY       = '',
        UNKNOWN     = '?',
        FUNC_TYPE   = 'function',
        UNDEF_TYPE  = 'undefined',
        OBJ_TYPE    = 'object',
        STR_TYPE    = 'string',
        MAJOR       = 'major',
        MODEL       = 'model',
        NAME        = 'name',
        TYPE        = 'type',
        VENDOR      = 'vendor',
        VERSION     = 'version',
        ARCHITECTURE= 'architecture',
        CONSOLE     = 'console',
        MOBILE      = 'mobile',
        TABLET      = 'tablet',
        SMARTTV     = 'smarttv',
        WEARABLE    = 'wearable',
        EMBEDDED    = 'embedded',
        UA_MAX_LENGTH = 350;

    var AMAZON  = 'Amazon',
        APPLE   = 'Apple',
        ASUS    = 'ASUS',
        BLACKBERRY = 'BlackBerry',
        BROWSER = 'Browser',
        CHROME  = 'Chrome',
        EDGE    = 'Edge',
        FIREFOX = 'Firefox',
        GOOGLE  = 'Google',
        HUAWEI  = 'Huawei',
        LG      = 'LG',
        MICROSOFT = 'Microsoft',
        MOTOROLA  = 'Motorola',
        OPERA   = 'Opera',
        SAMSUNG = 'Samsung',
        SHARP   = 'Sharp',
        SONY    = 'Sony',
        XIAOMI  = 'Xiaomi',
        ZEBRA   = 'Zebra',
        FACEBOOK   = 'Facebook';

    ///////////
    // Helper
    //////////

    var extend = function (regexes, extensions) {
            var mergedRegexes = {};
            for (var i in regexes) {
                if (extensions[i] && extensions[i].length % 2 === 0) {
                    mergedRegexes[i] = extensions[i].concat(regexes[i]);
                } else {
                    mergedRegexes[i] = regexes[i];
                }
            }
            return mergedRegexes;
        },
        enumerize = function (arr) {
            var enums = {};
            for (var i=0; i<arr.length; i++) {
                enums[arr[i].toUpperCase()] = arr[i];
            }
            return enums;
        },
        has = function (str1, str2) {
            return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
        },
        lowerize = function (str) {
            return str.toLowerCase();
        },
        majorize = function (version) {
            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split('.')[0] : undefined$1;
        },
        trim = function (str, len) {
            if (typeof(str) === STR_TYPE) {
                str = str.replace(/^\s\s*/, EMPTY);
                return typeof(len) === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
            }
    };

    ///////////////
    // Map helper
    //////////////

    var rgxMapper = function (ua, arrays) {

            var i = 0, j, k, p, q, matches, match;

            // loop through all regexes maps
            while (i < arrays.length && !matches) {

                var regex = arrays[i],       // even sequence (0,2,4,..)
                    props = arrays[i + 1];   // odd sequence (1,3,5,..)
                j = k = 0;

                // try matching uastring with regexes
                while (j < regex.length && !matches) {

                    matches = regex[j++].exec(ua);

                    if (!!matches) {
                        for (p = 0; p < props.length; p++) {
                            match = matches[++k];
                            q = props[p];
                            // check if given property is actually array
                            if (typeof q === OBJ_TYPE && q.length > 0) {
                                if (q.length === 2) {
                                    if (typeof q[1] == FUNC_TYPE) {
                                        // assign modified match
                                        this[q[0]] = q[1].call(this, match);
                                    } else {
                                        // assign given value, ignore regex match
                                        this[q[0]] = q[1];
                                    }
                                } else if (q.length === 3) {
                                    // check whether function or regex
                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                                        // call function (usually string mapper)
                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined$1;
                                    } else {
                                        // sanitize match using given regex
                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined$1;
                                    }
                                } else if (q.length === 4) {
                                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined$1;
                                }
                            } else {
                                this[q] = match ? match : undefined$1;
                            }
                        }
                    }
                }
                i += 2;
            }
        },

        strMapper = function (str, map) {

            for (var i in map) {
                // check if current value is array
                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
                    for (var j = 0; j < map[i].length; j++) {
                        if (has(map[i][j], str)) {
                            return (i === UNKNOWN) ? undefined$1 : i;
                        }
                    }
                } else if (has(map[i], str)) {
                    return (i === UNKNOWN) ? undefined$1 : i;
                }
            }
            return str;
    };

    ///////////////
    // String map
    //////////////

    // Safari < 3.0
    var oldSafariMap = {
            '1.0'   : '/8',
            '1.2'   : '/1',
            '1.3'   : '/3',
            '2.0'   : '/412',
            '2.0.2' : '/416',
            '2.0.3' : '/417',
            '2.0.4' : '/419',
            '?'     : '/'
        },
        windowsVersionMap = {
            'ME'        : '4.90',
            'NT 3.11'   : 'NT3.51',
            'NT 4.0'    : 'NT4.0',
            '2000'      : 'NT 5.0',
            'XP'        : ['NT 5.1', 'NT 5.2'],
            'Vista'     : 'NT 6.0',
            '7'         : 'NT 6.1',
            '8'         : 'NT 6.2',
            '8.1'       : 'NT 6.3',
            '10'        : ['NT 6.4', 'NT 10.0'],
            'RT'        : 'ARM'
    };

    //////////////
    // Regex map
    /////////////

    var regexes = {

        browser : [[

            /\b(?:crmo|crios)\/([\w\.]+)/i                                      // Chrome for Android/iOS
            ], [VERSION, [NAME, 'Chrome']], [
            /edg(?:e|ios|a)?\/([\w\.]+)/i                                       // Microsoft Edge
            ], [VERSION, [NAME, 'Edge']], [

            // Presto based
            /(opera mini)\/([-\w\.]+)/i,                                        // Opera Mini
            /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,                 // Opera Mobi/Tablet
            /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i                           // Opera
            ], [NAME, VERSION], [
            /opios[\/ ]+([\w\.]+)/i                                             // Opera mini on iphone >= 8.0
            ], [VERSION, [NAME, OPERA+' Mini']], [
            /\bopr\/([\w\.]+)/i                                                 // Opera Webkit
            ], [VERSION, [NAME, OPERA]], [

            // Mixed
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,      // Lunascape/Maxthon/Netfront/Jasmine/Blazer
            // Trident based
            /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,               // Avant/IEMobile/SlimBrowser
            /(ba?idubrowser)[\/ ]?([\w\.]+)/i,                                  // Baidu Browser
            /(?:ms|\()(ie) ([\w\.]+)/i,                                         // Internet Explorer

            // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
            /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
                                                                                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
            /(weibo)__([\d\.]+)/i                                               // Weibo
            ], [NAME, VERSION], [
            /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i                 // UCBrowser
            ], [VERSION, [NAME, 'UC'+BROWSER]], [
            /microm.+\bqbcore\/([\w\.]+)/i,                                     // WeChat Desktop for Windows Built-in Browser
            /\bqbcore\/([\w\.]+).+microm/i
            ], [VERSION, [NAME, 'WeChat(Win) Desktop']], [
            /micromessenger\/([\w\.]+)/i                                        // WeChat
            ], [VERSION, [NAME, 'WeChat']], [
            /konqueror\/([\w\.]+)/i                                             // Konqueror
            ], [VERSION, [NAME, 'Konqueror']], [
            /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i                       // IE11
            ], [VERSION, [NAME, 'IE']], [
            /yabrowser\/([\w\.]+)/i                                             // Yandex
            ], [VERSION, [NAME, 'Yandex']], [
            /(avast|avg)\/([\w\.]+)/i                                           // Avast/AVG Secure Browser
            ], [[NAME, /(.+)/, '$1 Secure '+BROWSER], VERSION], [
            /\bfocus\/([\w\.]+)/i                                               // Firefox Focus
            ], [VERSION, [NAME, FIREFOX+' Focus']], [
            /\bopt\/([\w\.]+)/i                                                 // Opera Touch
            ], [VERSION, [NAME, OPERA+' Touch']], [
            /coc_coc\w+\/([\w\.]+)/i                                            // Coc Coc Browser
            ], [VERSION, [NAME, 'Coc Coc']], [
            /dolfin\/([\w\.]+)/i                                                // Dolphin
            ], [VERSION, [NAME, 'Dolphin']], [
            /coast\/([\w\.]+)/i                                                 // Opera Coast
            ], [VERSION, [NAME, OPERA+' Coast']], [
            /miuibrowser\/([\w\.]+)/i                                           // MIUI Browser
            ], [VERSION, [NAME, 'MIUI '+BROWSER]], [
            /fxios\/([-\w\.]+)/i                                                // Firefox for iOS
            ], [VERSION, [NAME, FIREFOX]], [
            /\bqihu|(qi?ho?o?|360)browser/i                                     // 360
            ], [[NAME, '360 '+BROWSER]], [
            /(oculus|samsung|sailfish|huawei)browser\/([\w\.]+)/i
            ], [[NAME, /(.+)/, '$1 '+BROWSER], VERSION], [                      // Oculus/Samsung/Sailfish/Huawei Browser
            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
            ], [[NAME, /_/g, ' '], VERSION], [
            /(electron)\/([\w\.]+) safari/i,                                    // Electron-based App
            /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,                   // Tesla
            /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i            // QQBrowser/Baidu App/2345 Browser
            ], [NAME, VERSION], [
            /(metasr)[\/ ]?([\w\.]+)/i,                                         // SouGouBrowser
            /(lbbrowser)/i,                                                     // LieBao Browser
            /\[(linkedin)app\]/i                                                // LinkedIn App for iOS & Android
            ], [NAME], [

            // WebView
            /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i       // Facebook App for iOS & Android
            ], [[NAME, FACEBOOK], VERSION], [
            /safari (line)\/([\w\.]+)/i,                                        // Line App for iOS
            /\b(line)\/([\w\.]+)\/iab/i,                                        // Line App for Android
            /(chromium|instagram)[\/ ]([-\w\.]+)/i                              // Chromium/Instagram
            ], [NAME, VERSION], [
            /\bgsa\/([\w\.]+) .*safari\//i                                      // Google Search Appliance on iOS
            ], [VERSION, [NAME, 'GSA']], [

            /headlesschrome(?:\/([\w\.]+)| )/i                                  // Chrome Headless
            ], [VERSION, [NAME, CHROME+' Headless']], [

            / wv\).+(chrome)\/([\w\.]+)/i                                       // Chrome WebView
            ], [[NAME, CHROME+' WebView'], VERSION], [

            /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i           // Android Browser
            ], [VERSION, [NAME, 'Android '+BROWSER]], [

            /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i       // Chrome/OmniWeb/Arora/Tizen/Nokia
            ], [NAME, VERSION], [

            /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i                      // Mobile Safari
            ], [VERSION, [NAME, 'Mobile Safari']], [
            /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i                // Safari & Safari Mobile
            ], [VERSION, NAME], [
            /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i                      // Safari < 3.0
            ], [NAME, [VERSION, strMapper, oldSafariMap]], [

            /(webkit|khtml)\/([\w\.]+)/i
            ], [NAME, VERSION], [

            // Gecko based
            /(navigator|netscape\d?)\/([-\w\.]+)/i                              // Netscape
            ], [[NAME, 'Netscape'], VERSION], [
            /mobile vr; rv:([\w\.]+)\).+firefox/i                               // Firefox Reality
            ], [VERSION, [NAME, FIREFOX+' Reality']], [
            /ekiohf.+(flow)\/([\w\.]+)/i,                                       // Flow
            /(swiftfox)/i,                                                      // Swiftfox
            /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
            /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(firefox)\/([\w\.]+)/i,                                            // Other Firefox-based
            /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,                         // Mozilla

            // Other
            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
            /(links) \(([\w\.]+)/i                                              // Links
            ], [NAME, VERSION], [
            
            /(cobalt)\/([\w\.]+)/i                                              // Cobalt
            ], [NAME, [VERSION, /master.|lts./, ""]]
        ],

        cpu : [[

            /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i                     // AMD64 (x64)
            ], [[ARCHITECTURE, 'amd64']], [

            /(ia32(?=;))/i                                                      // IA32 (quicktime)
            ], [[ARCHITECTURE, lowerize]], [

            /((?:i[346]|x)86)[;\)]/i                                            // IA32 (x86)
            ], [[ARCHITECTURE, 'ia32']], [

            /\b(aarch64|arm(v?8e?l?|_?64))\b/i                                 // ARM64
            ], [[ARCHITECTURE, 'arm64']], [

            /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i                                   // ARMHF
            ], [[ARCHITECTURE, 'armhf']], [

            // PocketPC mistakenly identified as PowerPC
            /windows (ce|mobile); ppc;/i
            ], [[ARCHITECTURE, 'arm']], [

            /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i                            // PowerPC
            ], [[ARCHITECTURE, /ower/, EMPTY, lowerize]], [

            /(sun4\w)[;\)]/i                                                    // SPARC
            ], [[ARCHITECTURE, 'sparc']], [

            /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
            ], [[ARCHITECTURE, lowerize]]
        ],

        device : [[

            //////////////////////////
            // MOBILES & TABLETS
            // Ordered by popularity
            /////////////////////////

            // Samsung
            /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]], [
            /\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i,
            /samsung[- ]([-\w]+)/i,
            /sec-(sgh\w+)/i
            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]], [

            // Apple
            /\((ip(?:hone|od)[\w ]*);/i                                         // iPod/iPhone
            ], [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]], [
            /\((ipad);[-\w\),; ]+apple/i,                                       // iPad
            /applecoremedia\/[\w\.]+ \((ipad)/i,
            /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ], [MODEL, [VENDOR, APPLE], [TYPE, TABLET]], [
            /(macintosh);/i
            ], [MODEL, [VENDOR, APPLE]], [

            // Huawei
            /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ], [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]], [
            /(?:huawei|honor)([-\w ]+)[;\)]/i,
            /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ], [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]], [

            // Xiaomi
            /\b(poco[\w ]+)(?: bui|\))/i,                                       // Xiaomi POCO
            /\b; (\w+) build\/hm\1/i,                                           // Xiaomi Hongmi 'numeric' models
            /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,                             // Xiaomi Hongmi
            /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,                   // Xiaomi Redmi
            /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i // Xiaomi Mi
            ], [[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, MOBILE]], [
            /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i                        // Mi Pad tablets
            ],[[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, TABLET]], [

            // OPPO
            /; (\w+) bui.+ oppo/i,
            /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ], [MODEL, [VENDOR, 'OPPO'], [TYPE, MOBILE]], [

            // Vivo
            /vivo (\w+)(?: bui|\))/i,
            /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ], [MODEL, [VENDOR, 'Vivo'], [TYPE, MOBILE]], [

            // Realme
            /\b(rmx[12]\d{3})(?: bui|;|\))/i
            ], [MODEL, [VENDOR, 'Realme'], [TYPE, MOBILE]], [

            // Motorola
            /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
            /\bmot(?:orola)?[- ](\w*)/i,
            /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]], [
            /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]], [

            // LG
            /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ], [MODEL, [VENDOR, LG], [TYPE, TABLET]], [
            /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
            /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
            /\blg-?([\d\w]+) bui/i
            ], [MODEL, [VENDOR, LG], [TYPE, MOBILE]], [

            // Lenovo
            /(ideatab[-\w ]+)/i,
            /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [

            // Nokia
            /(?:maemo|nokia).*(n900|lumia \d+)/i,
            /nokia[-_ ]?([-\w\.]*)/i
            ], [[MODEL, /_/g, ' '], [VENDOR, 'Nokia'], [TYPE, MOBILE]], [

            // Google
            /(pixel c)\b/i                                                      // Google Pixel C
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]], [
            /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i                         // Google Pixel
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]], [

            // Sony
            /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ], [MODEL, [VENDOR, SONY], [TYPE, MOBILE]], [
            /sony tablet [ps]/i,
            /\b(?:sony)?sgp\w+(?: bui|\))/i
            ], [[MODEL, 'Xperia Tablet'], [VENDOR, SONY], [TYPE, TABLET]], [

            // OnePlus
            / (kb2005|in20[12]5|be20[12][59])\b/i,
            /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [

            // Amazon
            /(alexa)webm/i,
            /(kf[a-z]{2}wi)( bui|\))/i,                                         // Kindle Fire without Silk
            /(kf[a-z]+)( bui|\)).+silk\//i                                      // Kindle Fire HD
            ], [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]], [
            /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i                     // Fire Phone
            ], [[MODEL, /(.+)/g, 'Fire Phone $1'], [VENDOR, AMAZON], [TYPE, MOBILE]], [

            // BlackBerry
            /(playbook);[-\w\),; ]+(rim)/i                                      // BlackBerry PlayBook
            ], [MODEL, VENDOR, [TYPE, TABLET]], [
            /\b((?:bb[a-f]|st[hv])100-\d)/i,
            /\(bb10; (\w+)/i                                                    // BlackBerry 10
            ], [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]], [

            // Asus
            /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ], [MODEL, [VENDOR, ASUS], [TYPE, TABLET]], [
            / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ], [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]], [

            // HTC
            /(nexus 9)/i                                                        // HTC Nexus 9
            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [
            /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,                         // HTC

            // ZTE
            /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
            /(alcatel|geeksphone|nexian|panasonic|sony(?!-bra))[-_ ]?([-\w]*)/i         // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [

            // Acer
            /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

            // Meizu
            /droid.+; (m[1-5] note) bui/i,
            /\bmz-([-\w]{2,})/i
            ], [MODEL, [VENDOR, 'Meizu'], [TYPE, MOBILE]], [

            // Sharp
            /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ], [MODEL, [VENDOR, SHARP], [TYPE, MOBILE]], [

            // MIXED
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
                                                                                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
            /(hp) ([\w ]+\w)/i,                                                 // HP iPAQ
            /(asus)-?(\w+)/i,                                                   // Asus
            /(microsoft); (lumia[\w ]+)/i,                                      // Microsoft Lumia
            /(lenovo)[-_ ]?([-\w]+)/i,                                          // Lenovo
            /(jolla)/i,                                                         // Jolla
            /(oppo) ?([\w ]+) bui/i                                             // OPPO
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /(archos) (gamepad2?)/i,                                            // Archos
            /(hp).+(touchpad(?!.+tablet)|tablet)/i,                             // HP TouchPad
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(nook)[\w ]+build\/(\w+)/i,                                        // Nook
            /(dell) (strea[kpr\d ]*[\dko])/i,                                   // Dell Streak
            /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,                                  // Le Pan Tablets
            /(trinity)[- ]*(t\d{3}) bui/i,                                      // Trinity Tablets
            /(gigaset)[- ]+(q\w{1,9}) bui/i,                                    // Gigaset Tablets
            /(vodafone) ([\w ]+)(?:\)| bui)/i                                   // Vodafone
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(surface duo)/i                                                    // Surface Duo
            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]], [
            /droid [\d\.]+; (fp\du?)(?: b|\))/i                                 // Fairphone
            ], [MODEL, [VENDOR, 'Fairphone'], [TYPE, MOBILE]], [
            /(u304aa)/i                                                         // AT&T
            ], [MODEL, [VENDOR, 'AT&T'], [TYPE, MOBILE]], [
            /\bsie-(\w*)/i                                                      // Siemens
            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [
            /\b(rct\w+) b/i                                                     // RCA Tablets
            ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [
            /\b(venue[\d ]{2,7}) b/i                                            // Dell Venue Tablets
            ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [
            /\b(q(?:mv|ta)\w+) b/i                                              // Verizon Tablet
            ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [
            /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i                       // Barnes & Noble Tablet
            ], [MODEL, [VENDOR, 'Barnes & Noble'], [TYPE, TABLET]], [
            /\b(tm\d{3}\w+) b/i
            ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [
            /\b(k88) b/i                                                        // ZTE K Series Tablet
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [
            /\b(nx\d{3}j) b/i                                                   // ZTE Nubia
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [
            /\b(gen\d{3}) b.+49h/i                                              // Swiss GEN Mobile
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [
            /\b(zur\d{3}) b/i                                                   // Swiss ZUR Tablet
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [
            /\b((zeki)?tb.*\b) b/i                                              // Zeki Tablets
            ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [
            /\b([yr]\d{2}) b/i,
            /\b(dragon[- ]+touch |dt)(\w{5}) b/i                                // Dragon Touch Tablet
            ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [
            /\b(ns-?\w{0,9}) b/i                                                // Insignia Tablets
            ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [
            /\b((nxa|next)-?\w{0,9}) b/i                                        // NextBook Tablets
            ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [
            /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i                  // Voice Xtreme Phones
            ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [
            /\b(lvtel\-)?(v1[12]) b/i                                           // LvTel Phones
            ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [
            /\b(ph-1) /i                                                        // Essential PH-1
            ], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [
            /\b(v(100md|700na|7011|917g).*\b) b/i                               // Envizen Tablets
            ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [
            /\b(trio[-\w\. ]+) b/i                                              // MachSpeed Tablets
            ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [
            /\btu_(1491) b/i                                                    // Rotor Tablets
            ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [
            /(shield[\w ]+) b/i                                                 // Nvidia Shield Tablets
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, TABLET]], [
            /(sprint) (\w+)/i                                                   // Sprint Phones
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
            ], [[MODEL, /\./g, ' '], [VENDOR, MICROSOFT], [TYPE, MOBILE]], [
            /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i             // Zebra
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]], [
            /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]], [

            ///////////////////
            // CONSOLES
            ///////////////////

            /(ouya)/i,                                                          // Ouya
            /(nintendo) ([wids3utch]+)/i                                        // Nintendo
            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [
            /droid.+; (shield) bui/i                                            // Nvidia
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [
            /(playstation [345portablevi]+)/i                                   // Playstation
            ], [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]], [
            /\b(xbox(?: one)?(?!; xbox))[\); ]/i                                // Microsoft Xbox
            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]], [

            ///////////////////
            // SMARTTVS
            ///////////////////

            /smart-tv.+(samsung)/i                                              // Samsung
            ], [VENDOR, [TYPE, SMARTTV]], [
            /hbbtv.+maple;(\d+)/i
            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, SAMSUNG], [TYPE, SMARTTV]], [
            /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i        // LG SmartTV
            ], [[VENDOR, LG], [TYPE, SMARTTV]], [
            /(apple) ?tv/i                                                      // Apple TV
            ], [VENDOR, [MODEL, APPLE+' TV'], [TYPE, SMARTTV]], [
            /crkey/i                                                            // Google Chromecast
            ], [[MODEL, CHROME+'cast'], [VENDOR, GOOGLE], [TYPE, SMARTTV]], [
            /droid.+aft(\w)( bui|\))/i                                          // Fire TV
            ], [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]], [
            /\(dtv[\);].+(aquos)/i,
            /(aquos-tv[\w ]+)\)/i                                               // Sharp
            ], [MODEL, [VENDOR, SHARP], [TYPE, SMARTTV]],[
            /(bravia[\w ]+)( bui|\))/i                                              // Sony
            ], [MODEL, [VENDOR, SONY], [TYPE, SMARTTV]], [
            /(mitv-\w{5}) bui/i                                                 // Xiaomi
            ], [MODEL, [VENDOR, XIAOMI], [TYPE, SMARTTV]], [
            /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,                          // Roku
            /hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i               // HbbTV devices
            ], [[VENDOR, trim], [MODEL, trim], [TYPE, SMARTTV]], [
            /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i                   // SmartTV from Unidentified Vendors
            ], [[TYPE, SMARTTV]], [

            ///////////////////
            // WEARABLES
            ///////////////////

            /((pebble))app/i                                                    // Pebble
            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [
            /droid.+; (glass) \d/i                                              // Google Glass
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]], [
            /droid.+; (wt63?0{2,3})\)/i
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]], [
            /(quest( 2)?)/i                                                     // Oculus Quest
            ], [MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]], [

            ///////////////////
            // EMBEDDED
            ///////////////////

            /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i                              // Tesla
            ], [VENDOR, [TYPE, EMBEDDED]], [

            ////////////////////
            // MIXED (GENERIC)
            ///////////////////

            /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i           // Android Phones from Unidentified Vendors
            ], [MODEL, [TYPE, MOBILE]], [
            /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i       // Android Tablets from Unidentified Vendors
            ], [MODEL, [TYPE, TABLET]], [
            /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i                      // Unidentifiable Tablet
            ], [[TYPE, TABLET]], [
            /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i    // Unidentifiable Mobile
            ], [[TYPE, MOBILE]], [
            /(android[-\w\. ]{0,9});.+buil/i                                    // Generic Android Device
            ], [MODEL, [VENDOR, 'Generic']]
        ],

        engine : [[

            /windows.+ edge\/([\w\.]+)/i                                       // EdgeHTML
            ], [VERSION, [NAME, EDGE+'HTML']], [

            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i                         // Blink
            ], [VERSION, [NAME, 'Blink']], [

            /(presto)\/([\w\.]+)/i,                                             // Presto
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
            /ekioh(flow)\/([\w\.]+)/i,                                          // Flow
            /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,                           // KHTML/Tasman/Links
            /(icab)[\/ ]([23]\.[\d\.]+)/i                                       // iCab
            ], [NAME, VERSION], [

            /rv\:([\w\.]{1,9})\b.+(gecko)/i                                     // Gecko
            ], [VERSION, NAME]
        ],

        os : [[

            // Windows
            /microsoft (windows) (vista|xp)/i                                   // Windows (iTunes)
            ], [NAME, VERSION], [
            /(windows) nt 6\.2; (arm)/i,                                        // Windows RT
            /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,            // Windows Phone
            /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
            ], [NAME, [VERSION, strMapper, windowsVersionMap]], [
            /(win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ], [[NAME, 'Windows'], [VERSION, strMapper, windowsVersionMap]], [

            // iOS/macOS
            /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,              // iOS
            /cfnetwork\/.+darwin/i
            ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [
            /(mac os x) ?([\w\. ]*)/i,
            /(macintosh|mac_powerpc\b)(?!.+haiku)/i                             // Mac OS
            ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [

            // Mobile OSes
            /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i                    // Android-x86/HarmonyOS
            ], [VERSION, NAME], [                                               // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
            /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
            /(blackberry)\w*\/([\w\.]*)/i,                                      // Blackberry
            /(tizen|kaios)[\/ ]([\w\.]+)/i,                                     // Tizen/KaiOS
            /\((series40);/i                                                    // Series 40
            ], [NAME, VERSION], [
            /\(bb(10);/i                                                        // BlackBerry 10
            ], [VERSION, [NAME, BLACKBERRY]], [
            /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i         // Symbian
            ], [VERSION, [NAME, 'Symbian']], [
            /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
            ], [VERSION, [NAME, FIREFOX+' OS']], [
            /web0s;.+rt(tv)/i,
            /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i                              // WebOS
            ], [VERSION, [NAME, 'webOS']], [

            // Google Chromecast
            /crkey\/([\d\.]+)/i                                                 // Google Chromecast
            ], [VERSION, [NAME, CHROME+'cast']], [
            /(cros) [\w]+ ([\w\.]+\w)/i                                         // Chromium OS
            ], [[NAME, 'Chromium OS'], VERSION],[

            // Console
            /(nintendo|playstation) ([wids345portablevuch]+)/i,                 // Nintendo/Playstation
            /(xbox); +xbox ([^\);]+)/i,                                         // Microsoft Xbox (360, One, X, S, Series X, Series S)

            // Other
            /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,                            // Joli/Palm
            /(mint)[\/\(\) ]?(\w*)/i,                                           // Mint
            /(mageia|vectorlinux)[; ]/i,                                        // Mageia/VectorLinux
            /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                                                                                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
            /(hurd|linux) ?([\w\.]*)/i,                                         // Hurd/Linux
            /(gnu) ?([\w\.]*)/i,                                                // GNU
            /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
            /(haiku) (\w+)/i                                                    // Haiku
            ], [NAME, VERSION], [
            /(sunos) ?([\w\.\d]*)/i                                             // Solaris
            ], [[NAME, 'Solaris'], VERSION], [
            /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,                              // Solaris
            /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,                                  // AIX
            /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i,            // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX
            /(unix) ?([\w\.]*)/i                                                // UNIX
            ], [NAME, VERSION]
        ]
    };

    /////////////////
    // Constructor
    ////////////////

    var UAParser = function (ua, extensions) {

        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined$1;
        }

        if (!(this instanceof UAParser)) {
            return new UAParser(ua, extensions).getResult();
        }

        var _ua = ua || ((typeof window !== UNDEF_TYPE && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : EMPTY);
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;

        this.getBrowser = function () {
            var _browser = {};
            _browser[NAME] = undefined$1;
            _browser[VERSION] = undefined$1;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser.major = majorize(_browser.version);
            return _browser;
        };
        this.getCPU = function () {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined$1;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function () {
            var _device = {};
            _device[VENDOR] = undefined$1;
            _device[MODEL] = undefined$1;
            _device[TYPE] = undefined$1;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            return _device;
        };
        this.getEngine = function () {
            var _engine = {};
            _engine[NAME] = undefined$1;
            _engine[VERSION] = undefined$1;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function () {
            var _os = {};
            _os[NAME] = undefined$1;
            _os[VERSION] = undefined$1;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            return _os;
        };
        this.getResult = function () {
            return {
                ua      : this.getUA(),
                browser : this.getBrowser(),
                engine  : this.getEngine(),
                os      : this.getOS(),
                device  : this.getDevice(),
                cpu     : this.getCPU()
            };
        };
        this.getUA = function () {
            return _ua;
        };
        this.setUA = function (ua) {
            _ua = (typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH) ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };

    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER =  enumerize([NAME, VERSION, MAJOR]);
    UAParser.CPU = enumerize([ARCHITECTURE]);
    UAParser.DEVICE = enumerize([MODEL, VENDOR, TYPE, CONSOLE, MOBILE, SMARTTV, TABLET, WEARABLE, EMBEDDED]);
    UAParser.ENGINE = UAParser.OS = enumerize([NAME, VERSION]);

    ///////////
    // Export
    //////////

    // check js environment
    {
        // nodejs env
        if (module.exports) {
            exports = module.exports = UAParser;
        }
        exports.UAParser = UAParser;
    }

    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window !== UNDEF_TYPE && (window.jQuery || window.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function () {
            return parser.getUA();
        };
        $.ua.set = function (ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for (var prop in result) {
                $.ua[prop] = result[prop];
            }
        };
    }

})(typeof window === 'object' ? window : commonjsGlobal);
}(uaParser, uaParser.exports));

var UAParser = uaParser.exports;

var mp4box_all = {};

(function (exports) {
// file:src/log.js
/* 
 * Copyright (c) 2012-2013. Telecom ParisTech/TSI/MM/GPAC Cyril Concolato
 * License: BSD-3-Clause (see LICENSE file)
 */
var Log = (function (){
		var start = new Date();
		var LOG_LEVEL_ERROR 	= 4;
		var LOG_LEVEL_WARNING 	= 3;
		var LOG_LEVEL_INFO 		= 2;
		var LOG_LEVEL_DEBUG		= 1;
		var log_level = LOG_LEVEL_ERROR;
		var logObject = {
			setLogLevel : function(level) {
				if (level == this.debug) log_level = LOG_LEVEL_DEBUG;
				else if (level == this.info) log_level = LOG_LEVEL_INFO;
				else if (level == this.warn) log_level = LOG_LEVEL_WARNING;
				else if (level == this.error) log_level = LOG_LEVEL_ERROR;
				else log_level = LOG_LEVEL_ERROR;
			},
			debug : function(module, msg) {
				if (console.debug === undefined) {
					console.debug = console.log;
				}
				if (LOG_LEVEL_DEBUG >= log_level) {
					console.debug("["+Log.getDurationString(new Date()-start,1000)+"]","["+module+"]",msg);
				}
			},
			log : function(module, msg) {
				this.debug(module.msg);
			},
			info : function(module, msg) {
				if (LOG_LEVEL_INFO >= log_level) {
					console.info("["+Log.getDurationString(new Date()-start,1000)+"]","["+module+"]",msg);
				}
			},
			warn : function(module, msg) {
				if (LOG_LEVEL_WARNING >= log_level) {
					console.warn("["+Log.getDurationString(new Date()-start,1000)+"]","["+module+"]",msg);
				}
			},
			error : function(module, msg) {
				if (LOG_LEVEL_ERROR >= log_level) {
					console.error("["+Log.getDurationString(new Date()-start,1000)+"]","["+module+"]",msg);
				}
			}
		};
		return logObject;
	})();
	
/* Helper function to print a duration value in the form H:MM:SS.MS */
Log.getDurationString = function(duration, _timescale) {
	var neg;
	/* Helper function to print a number on a fixed number of digits */
	function pad(number, length) {
		var str = '' + number;
		var a = str.split('.');		
		while (a[0].length < length) {
			a[0] = '0' + a[0];
		}
		return a.join('.');
	}
	if (duration < 0) {
		neg = true;
		duration = -duration;
	} else {
		neg = false;	
	}
	var timescale = _timescale || 1;
	var duration_sec = duration/timescale;
	var hours = Math.floor(duration_sec/3600);
	duration_sec -= hours * 3600;
	var minutes = Math.floor(duration_sec/60);
	duration_sec -= minutes * 60;		
	var msec = duration_sec*1000;
	duration_sec = Math.floor(duration_sec);
	msec -= duration_sec*1000;
	msec = Math.floor(msec);
	return (neg ? "-": "")+hours+":"+pad(minutes,2)+":"+pad(duration_sec,2)+"."+pad(msec,3);
};
	
/* Helper function to stringify HTML5 TimeRanges objects */	
Log.printRanges = function(ranges) {
	var length = ranges.length;
	if (length > 0) {
		var str = "";
		for (var i = 0; i < length; i++) {
		  if (i > 0) str += ",";
		  str += "["+Log.getDurationString(ranges.start(i))+ ","+Log.getDurationString(ranges.end(i))+"]";
		}
		return str;
	} else {
		return "(empty)";
	}
};

{
	exports.Log = Log;
}
// file:src/stream.js
var MP4BoxStream = function(arrayBuffer) {
  if (arrayBuffer instanceof ArrayBuffer) {
    this.buffer = arrayBuffer;
    this.dataview = new DataView(arrayBuffer);
  } else {
    throw ("Needs an array buffer");
  }
  this.position = 0;
};

/*************************************************************************
  Common API between MultiBufferStream and SimpleStream
 *************************************************************************/
MP4BoxStream.prototype.getPosition = function() {
  return this.position;
};

MP4BoxStream.prototype.getEndPosition = function() {
  return this.buffer.byteLength;
};

MP4BoxStream.prototype.getLength = function() {
  return this.buffer.byteLength;
};

MP4BoxStream.prototype.seek = function (pos) {
  var npos = Math.max(0, Math.min(this.buffer.byteLength, pos));
  this.position = (isNaN(npos) || !isFinite(npos)) ? 0 : npos;
  return true;
};

MP4BoxStream.prototype.isEos = function () {
  return this.getPosition() >= this.getEndPosition();
};

/*************************************************************************
  Read methods, simimar to DataStream but simpler
 *************************************************************************/
MP4BoxStream.prototype.readAnyInt = function(size, signed) {
  var res = 0;
  if (this.position + size <= this.buffer.byteLength) {
    switch (size) {
      case 1:
        if (signed) {
          res = this.dataview.getInt8(this.position);
        } else {
          res = this.dataview.getUint8(this.position);
        }
        break;
      case 2:
        if (signed) {
          res = this.dataview.getInt16(this.position);
        } else {
          res = this.dataview.getUint16(this.position);
        }
        break;
      case 3:
        if (signed) {
          throw ("No method for reading signed 24 bits values");
        } else {
          res = this.dataview.getUint8(this.position) << 16;
          res |= this.dataview.getUint8(this.position+1) << 8;
          res |= this.dataview.getUint8(this.position+2);
        }
        break;
      case 4:
        if (signed) {
          res = this.dataview.getInt32(this.position);
        } else {
          res = this.dataview.getUint32(this.position);
        }
        break;
      case 8:
        if (signed) {
          throw ("No method for reading signed 64 bits values");
        } else {
          res = this.dataview.getUint32(this.position) << 32;
          res |= this.dataview.getUint32(this.position+4);
        }
        break;
      default:
        throw ("readInt method not implemented for size: "+size);
    }
    this.position+= size;
    return res;
  } else {
    throw ("Not enough bytes in buffer");
  }
};

MP4BoxStream.prototype.readUint8 = function() {
  return this.readAnyInt(1, false);
};

MP4BoxStream.prototype.readUint16 = function() {
  return this.readAnyInt(2, false);
};

MP4BoxStream.prototype.readUint24 = function() {
  return this.readAnyInt(3, false);
};

MP4BoxStream.prototype.readUint32 = function() {
  return this.readAnyInt(4, false);
};

MP4BoxStream.prototype.readUint64 = function() {
  return this.readAnyInt(8, false);
};

MP4BoxStream.prototype.readString = function(length) {
  if (this.position + length <= this.buffer.byteLength) {
    var s = "";
    for (var i = 0; i < length; i++) {
      s += String.fromCharCode(this.readUint8());
    }
    return s;
  } else {
    throw ("Not enough bytes in buffer");
  }
};

MP4BoxStream.prototype.readCString = function() {
  var arr = [];
  while(true) {
    var b = this.readUint8();
    if (b !== 0) {
      arr.push(b);
    } else {
      break;
    }
  }
  return String.fromCharCode.apply(null, arr); 
};

MP4BoxStream.prototype.readInt8 = function() {
  return this.readAnyInt(1, true);
};

MP4BoxStream.prototype.readInt16 = function() {
  return this.readAnyInt(2, true);
};

MP4BoxStream.prototype.readInt32 = function() {
  return this.readAnyInt(4, true);
};

MP4BoxStream.prototype.readInt64 = function() {
  return this.readAnyInt(8, false);
};

MP4BoxStream.prototype.readUint8Array = function(length) {
  var arr = new Uint8Array(length);
  for (var i = 0; i < length; i++) {
    arr[i] = this.readUint8();
  }
  return arr;
};

MP4BoxStream.prototype.readInt16Array = function(length) {
  var arr = new Int16Array(length);
  for (var i = 0; i < length; i++) {
    arr[i] = this.readInt16();
  }
  return arr;
};

MP4BoxStream.prototype.readUint16Array = function(length) {
  var arr = new Int16Array(length);
  for (var i = 0; i < length; i++) {
    arr[i] = this.readUint16();
  }
  return arr;
};

MP4BoxStream.prototype.readUint32Array = function(length) {
  var arr = new Uint32Array(length);
  for (var i = 0; i < length; i++) {
    arr[i] = this.readUint32();
  }
  return arr;
};

MP4BoxStream.prototype.readInt32Array = function(length) {
  var arr = new Int32Array(length);
  for (var i = 0; i < length; i++) {
    arr[i] = this.readInt32();
  }
  return arr;
};

{
  exports.MP4BoxStream = MP4BoxStream;
}// file:src/DataStream.js
/**
  DataStream reads scalars, arrays and structs of data from an ArrayBuffer.
  It's like a file-like DataView on steroids.

  @param {ArrayBuffer} arrayBuffer ArrayBuffer to read from.
  @param {?Number} byteOffset Offset from arrayBuffer beginning for the DataStream.
  @param {?Boolean} endianness DataStream.BIG_ENDIAN or DataStream.LITTLE_ENDIAN (the default).
  */
var DataStream = function(arrayBuffer, byteOffset, endianness) {
  this._byteOffset = byteOffset || 0;
  if (arrayBuffer instanceof ArrayBuffer) {
    this.buffer = arrayBuffer;
  } else if (typeof arrayBuffer == "object") {
    this.dataView = arrayBuffer;
    if (byteOffset) {
      this._byteOffset += byteOffset;
    }
  } else {
    this.buffer = new ArrayBuffer(arrayBuffer || 0);
  }
  this.position = 0;
  this.endianness = endianness == null ? DataStream.LITTLE_ENDIAN : endianness;
};
DataStream.prototype = {};

DataStream.prototype.getPosition = function() {
  return this.position;
};

/**
  Internal function to resize the DataStream buffer when required.
  @param {number} extra Number of bytes to add to the buffer allocation.
  @return {null}
  */
DataStream.prototype._realloc = function(extra) {
  if (!this._dynamicSize) {
    return;
  }
  var req = this._byteOffset + this.position + extra;
  var blen = this._buffer.byteLength;
  if (req <= blen) {
    if (req > this._byteLength) {
      this._byteLength = req;
    }
    return;
  }
  if (blen < 1) {
    blen = 1;
  }
  while (req > blen) {
    blen *= 2;
  }
  var buf = new ArrayBuffer(blen);
  var src = new Uint8Array(this._buffer);
  var dst = new Uint8Array(buf, 0, src.length);
  dst.set(src);
  this.buffer = buf;
  this._byteLength = req;
};

/**
  Internal function to trim the DataStream buffer when required.
  Used for stripping out the extra bytes from the backing buffer when
  the virtual byteLength is smaller than the buffer byteLength (happens after
  growing the buffer with writes and not filling the extra space completely).

  @return {null}
  */
DataStream.prototype._trimAlloc = function() {
  if (this._byteLength == this._buffer.byteLength) {
    return;
  }
  var buf = new ArrayBuffer(this._byteLength);
  var dst = new Uint8Array(buf);
  var src = new Uint8Array(this._buffer, 0, dst.length);
  dst.set(src);
  this.buffer = buf;
};


/**
  Big-endian const to use as default endianness.
  @type {boolean}
  */
DataStream.BIG_ENDIAN = false;

/**
  Little-endian const to use as default endianness.
  @type {boolean}
  */
DataStream.LITTLE_ENDIAN = true;

/**
  Virtual byte length of the DataStream backing buffer.
  Updated to be max of original buffer size and last written size.
  If dynamicSize is false is set to buffer size.
  @type {number}
  */
DataStream.prototype._byteLength = 0;

/**
  Returns the byte length of the DataStream object.
  @type {number}
  */
Object.defineProperty(DataStream.prototype, 'byteLength',
  { get: function() {
    return this._byteLength - this._byteOffset;
  }});

/**
  Set/get the backing ArrayBuffer of the DataStream object.
  The setter updates the DataView to point to the new buffer.
  @type {Object}
  */
Object.defineProperty(DataStream.prototype, 'buffer',
  { get: function() {
      this._trimAlloc();
      return this._buffer;
    },
    set: function(v) {
      this._buffer = v;
      this._dataView = new DataView(this._buffer, this._byteOffset);
      this._byteLength = this._buffer.byteLength;
    } });

/**
  Set/get the byteOffset of the DataStream object.
  The setter updates the DataView to point to the new byteOffset.
  @type {number}
  */
Object.defineProperty(DataStream.prototype, 'byteOffset',
  { get: function() {
      return this._byteOffset;
    },
    set: function(v) {
      this._byteOffset = v;
      this._dataView = new DataView(this._buffer, this._byteOffset);
      this._byteLength = this._buffer.byteLength;
    } });

/**
  Set/get the backing DataView of the DataStream object.
  The setter updates the buffer and byteOffset to point to the DataView values.
  @type {Object}
  */
Object.defineProperty(DataStream.prototype, 'dataView',
  { get: function() {
      return this._dataView;
    },
    set: function(v) {
      this._byteOffset = v.byteOffset;
      this._buffer = v.buffer;
      this._dataView = new DataView(this._buffer, this._byteOffset);
      this._byteLength = this._byteOffset + v.byteLength;
    } });

/**
  Sets the DataStream read/write position to given position.
  Clamps between 0 and DataStream length.

  @param {number} pos Position to seek to.
  @return {null}
  */
DataStream.prototype.seek = function(pos) {
  var npos = Math.max(0, Math.min(this.byteLength, pos));
  this.position = (isNaN(npos) || !isFinite(npos)) ? 0 : npos;
};

/**
  Returns true if the DataStream seek pointer is at the end of buffer and
  there's no more data to read.

  @return {boolean} True if the seek pointer is at the end of the buffer.
  */
DataStream.prototype.isEof = function() {
  return (this.position >= this._byteLength);
};


/**
  Maps a Uint8Array into the DataStream buffer.

  Nice for quickly reading in data.

  @param {number} length Number of elements to map.
  @param {?boolean} e Endianness of the data to read.
  @return {Object} Uint8Array to the DataStream backing buffer.
  */
DataStream.prototype.mapUint8Array = function(length) {
  this._realloc(length * 1);
  var arr = new Uint8Array(this._buffer, this.byteOffset+this.position, length);
  this.position += length * 1;
  return arr;
};


/**
  Reads an Int32Array of desired length and endianness from the DataStream.

  @param {number} length Number of elements to map.
  @param {?boolean} e Endianness of the data to read.
  @return {Object} The read Int32Array.
 */
DataStream.prototype.readInt32Array = function(length, e) {
  length = length == null ? (this.byteLength-this.position / 4) : length;
  var arr = new Int32Array(length);
  DataStream.memcpy(arr.buffer, 0,
                    this.buffer, this.byteOffset+this.position,
                    length*arr.BYTES_PER_ELEMENT);
  DataStream.arrayToNative(arr, e == null ? this.endianness : e);
  this.position += arr.byteLength;
  return arr;
};

/**
  Reads an Int16Array of desired length and endianness from the DataStream.

  @param {number} length Number of elements to map.
  @param {?boolean} e Endianness of the data to read.
  @return {Object} The read Int16Array.
 */
DataStream.prototype.readInt16Array = function(length, e) {
  length = length == null ? (this.byteLength-this.position / 2) : length;
  var arr = new Int16Array(length);
  DataStream.memcpy(arr.buffer, 0,
                    this.buffer, this.byteOffset+this.position,
                    length*arr.BYTES_PER_ELEMENT);
  DataStream.arrayToNative(arr, e == null ? this.endianness : e);
  this.position += arr.byteLength;
  return arr;
};

/**
  Reads an Int8Array of desired length from the DataStream.

  @param {number} length Number of elements to map.
  @param {?boolean} e Endianness of the data to read.
  @return {Object} The read Int8Array.
 */
DataStream.prototype.readInt8Array = function(length) {
  length = length == null ? (this.byteLength-this.position) : length;
  var arr = new Int8Array(length);
  DataStream.memcpy(arr.buffer, 0,
                    this.buffer, this.byteOffset+this.position,
                    length*arr.BYTES_PER_ELEMENT);
  this.position += arr.byteLength;
  return arr;
};

/**
  Reads a Uint32Array of desired length and endianness from the DataStream.

  @param {number} length Number of elements to map.
  @param {?boolean} e Endianness of the data to read.
  @return {Object} The read Uint32Array.
 */
DataStream.prototype.readUint32Array = function(length, e) {
  length = length == null ? (this.byteLength-this.position / 4) : length;
  var arr = new Uint32Array(length);
  DataStream.memcpy(arr.buffer, 0,
                    this.buffer, this.byteOffset+this.position,
                    length*arr.BYTES_PER_ELEMENT);
  DataStream.arrayToNative(arr, e == null ? this.endianness : e);
  this.position += arr.byteLength;
  return arr;
};

/**
  Reads a Uint16Array of desired length and endianness from the DataStream.

  @param {number} length Number of elements to map.
  @param {?boolean} e Endianness of the data to read.
  @return {Object} The read Uint16Array.
 */
DataStream.prototype.readUint16Array = function(length, e) {
  length = length == null ? (this.byteLength-this.position / 2) : length;
  var arr = new Uint16Array(length);
  DataStream.memcpy(arr.buffer, 0,
                    this.buffer, this.byteOffset+this.position,
                    length*arr.BYTES_PER_ELEMENT);
  DataStream.arrayToNative(arr, e == null ? this.endianness : e);
  this.position += arr.byteLength;
  return arr;
};

/**
  Reads a Uint8Array of desired length from the DataStream.

  @param {number} length Number of elements to map.
  @param {?boolean} e Endianness of the data to read.
  @return {Object} The read Uint8Array.
 */
DataStream.prototype.readUint8Array = function(length) {
  length = length == null ? (this.byteLength-this.position) : length;
  var arr = new Uint8Array(length);
  DataStream.memcpy(arr.buffer, 0,
                    this.buffer, this.byteOffset+this.position,
                    length*arr.BYTES_PER_ELEMENT);
  this.position += arr.byteLength;
  return arr;
};

/**
  Reads a Float64Array of desired length and endianness from the DataStream.

  @param {number} length Number of elements to map.
  @param {?boolean} e Endianness of the data to read.
  @return {Object} The read Float64Array.
 */
DataStream.prototype.readFloat64Array = function(length, e) {
  length = length == null ? (this.byteLength-this.position / 8) : length;
  var arr = new Float64Array(length);
  DataStream.memcpy(arr.buffer, 0,
                    this.buffer, this.byteOffset+this.position,
                    length*arr.BYTES_PER_ELEMENT);
  DataStream.arrayToNative(arr, e == null ? this.endianness : e);
  this.position += arr.byteLength;
  return arr;
};

/**
  Reads a Float32Array of desired length and endianness from the DataStream.

  @param {number} length Number of elements to map.
  @param {?boolean} e Endianness of the data to read.
  @return {Object} The read Float32Array.
 */
DataStream.prototype.readFloat32Array = function(length, e) {
  length = length == null ? (this.byteLength-this.position / 4) : length;
  var arr = new Float32Array(length);
  DataStream.memcpy(arr.buffer, 0,
                    this.buffer, this.byteOffset+this.position,
                    length*arr.BYTES_PER_ELEMENT);
  DataStream.arrayToNative(arr, e == null ? this.endianness : e);
  this.position += arr.byteLength;
  return arr;
};


/**
  Reads a 32-bit int from the DataStream with the desired endianness.

  @param {?boolean} e Endianness of the number.
  @return {number} The read number.
 */
DataStream.prototype.readInt32 = function(e) {
  var v = this._dataView.getInt32(this.position, e == null ? this.endianness : e);
  this.position += 4;
  return v;
};

/**
  Reads a 16-bit int from the DataStream with the desired endianness.

  @param {?boolean} e Endianness of the number.
  @return {number} The read number.
 */
DataStream.prototype.readInt16 = function(e) {
  var v = this._dataView.getInt16(this.position, e == null ? this.endianness : e);
  this.position += 2;
  return v;
};

/**
  Reads an 8-bit int from the DataStream.

  @return {number} The read number.
 */
DataStream.prototype.readInt8 = function() {
  var v = this._dataView.getInt8(this.position);
  this.position += 1;
  return v;
};

/**
  Reads a 32-bit unsigned int from the DataStream with the desired endianness.

  @param {?boolean} e Endianness of the number.
  @return {number} The read number.
 */
DataStream.prototype.readUint32 = function(e) {
  var v = this._dataView.getUint32(this.position, e == null ? this.endianness : e);
  this.position += 4;
  return v;
};

/**
  Reads a 16-bit unsigned int from the DataStream with the desired endianness.

  @param {?boolean} e Endianness of the number.
  @return {number} The read number.
 */
DataStream.prototype.readUint16 = function(e) {
  var v = this._dataView.getUint16(this.position, e == null ? this.endianness : e);
  this.position += 2;
  return v;
};

/**
  Reads an 8-bit unsigned int from the DataStream.

  @return {number} The read number.
 */
DataStream.prototype.readUint8 = function() {
  var v = this._dataView.getUint8(this.position);
  this.position += 1;
  return v;
};

/**
  Reads a 32-bit float from the DataStream with the desired endianness.

  @param {?boolean} e Endianness of the number.
  @return {number} The read number.
 */
DataStream.prototype.readFloat32 = function(e) {
  var v = this._dataView.getFloat32(this.position, e == null ? this.endianness : e);
  this.position += 4;
  return v;
};

/**
  Reads a 64-bit float from the DataStream with the desired endianness.

  @param {?boolean} e Endianness of the number.
  @return {number} The read number.
 */
DataStream.prototype.readFloat64 = function(e) {
  var v = this._dataView.getFloat64(this.position, e == null ? this.endianness : e);
  this.position += 8;
  return v;
};

/**
  Native endianness. Either DataStream.BIG_ENDIAN or DataStream.LITTLE_ENDIAN
  depending on the platform endianness.

  @type {boolean}
 */
DataStream.endianness = new Int8Array(new Int16Array([1]).buffer)[0] > 0;

/**
  Copies byteLength bytes from the src buffer at srcOffset to the
  dst buffer at dstOffset.

  @param {Object} dst Destination ArrayBuffer to write to.
  @param {number} dstOffset Offset to the destination ArrayBuffer.
  @param {Object} src Source ArrayBuffer to read from.
  @param {number} srcOffset Offset to the source ArrayBuffer.
  @param {number} byteLength Number of bytes to copy.
 */
DataStream.memcpy = function(dst, dstOffset, src, srcOffset, byteLength) {
  var dstU8 = new Uint8Array(dst, dstOffset, byteLength);
  var srcU8 = new Uint8Array(src, srcOffset, byteLength);
  dstU8.set(srcU8);
};

/**
  Converts array to native endianness in-place.

  @param {Object} array Typed array to convert.
  @param {boolean} arrayIsLittleEndian True if the data in the array is
                                       little-endian. Set false for big-endian.
  @return {Object} The converted typed array.
 */
DataStream.arrayToNative = function(array, arrayIsLittleEndian) {
  if (arrayIsLittleEndian == this.endianness) {
    return array;
  } else {
    return this.flipArrayEndianness(array);
  }
};

/**
  Converts native endianness array to desired endianness in-place.

  @param {Object} array Typed array to convert.
  @param {boolean} littleEndian True if the converted array should be
                                little-endian. Set false for big-endian.
  @return {Object} The converted typed array.
 */
DataStream.nativeToEndian = function(array, littleEndian) {
  if (this.endianness == littleEndian) {
    return array;
  } else {
    return this.flipArrayEndianness(array);
  }
};

/**
  Flips typed array endianness in-place.

  @param {Object} array Typed array to flip.
  @return {Object} The converted typed array.
 */
DataStream.flipArrayEndianness = function(array) {
  var u8 = new Uint8Array(array.buffer, array.byteOffset, array.byteLength);
  for (var i=0; i<array.byteLength; i+=array.BYTES_PER_ELEMENT) {
    for (var j=i+array.BYTES_PER_ELEMENT-1, k=i; j>k; j--, k++) {
      var tmp = u8[k];
      u8[k] = u8[j];
      u8[j] = tmp;
    }
  }
  return array;
};

/**
  Seek position where DataStream#readStruct ran into a problem.
  Useful for debugging struct parsing.

  @type {number}
 */
DataStream.prototype.failurePosition = 0;

String.fromCharCodeUint8 = function(uint8arr) {
    var arr = [];
    for (var i = 0; i < uint8arr.length; i++) {
      arr[i] = uint8arr[i];
    }
    return String.fromCharCode.apply(null, arr);
};
/**
  Read a string of desired length and encoding from the DataStream.

  @param {number} length The length of the string to read in bytes.
  @param {?string} encoding The encoding of the string data in the DataStream.
                            Defaults to ASCII.
  @return {string} The read string.
 */
DataStream.prototype.readString = function(length, encoding) {
  if (encoding == null || encoding == "ASCII") {
    return String.fromCharCodeUint8.apply(null, [this.mapUint8Array(length == null ? this.byteLength-this.position : length)]);
  } else {
    return (new TextDecoder(encoding)).decode(this.mapUint8Array(length));
  }
};

/**
  Read null-terminated string of desired length from the DataStream. Truncates
  the returned string so that the null byte is not a part of it.

  @param {?number} length The length of the string to read.
  @return {string} The read string.
 */
DataStream.prototype.readCString = function(length) {
  var blen = this.byteLength-this.position;
  var u8 = new Uint8Array(this._buffer, this._byteOffset + this.position);
  var len = blen;
  if (length != null) {
    len = Math.min(length, blen);
  }
  for (var i = 0; i < len && u8[i] !== 0; i++); // find first zero byte
  var s = String.fromCharCodeUint8.apply(null, [this.mapUint8Array(i)]);
  if (length != null) {
    this.position += len-i;
  } else if (i != blen) {
    this.position += 1; // trailing zero if not at end of buffer
  }
  return s;
};

/* 
   TODO: fix endianness for 24/64-bit fields
   TODO: check range/support for 64-bits numbers in JavaScript
*/
var MAX_SIZE = Math.pow(2, 32);

DataStream.prototype.readInt64 = function () {
  return (this.readInt32()*MAX_SIZE)+this.readUint32();
};
DataStream.prototype.readUint64 = function () {
	return (this.readUint32()*MAX_SIZE)+this.readUint32();
};

DataStream.prototype.readInt64 = function () {
  return (this.readUint32()*MAX_SIZE)+this.readUint32();
};

DataStream.prototype.readUint24 = function () {
	return (this.readUint8()<<16)+(this.readUint8()<<8)+this.readUint8();
};

{
  exports.DataStream = DataStream;  
}
// file:src/DataStream-write.js
/**
  Saves the DataStream contents to the given filename.
  Uses Chrome's anchor download property to initiate download.
 
  @param {string} filename Filename to save as.
  @return {null}
  */
DataStream.prototype.save = function(filename) {
  var blob = new Blob([this.buffer]);
  if (window.URL && URL.createObjectURL) {
      var url = window.URL.createObjectURL(blob);
      var a = document.createElement('a');
      // Required in Firefox:
      document.body.appendChild(a);
      a.setAttribute('href', url);
      a.setAttribute('download', filename);
      // Required in Firefox:
      a.setAttribute('target', '_self');
      a.click();
      window.URL.revokeObjectURL(url);
  } else {
      throw("DataStream.save: Can't create object URL.");
  }
};

/**
  Whether to extend DataStream buffer when trying to write beyond its size.
  If set, the buffer is reallocated to twice its current size until the
  requested write fits the buffer.
  @type {boolean}
  */
DataStream.prototype._dynamicSize = true;
Object.defineProperty(DataStream.prototype, 'dynamicSize',
  { get: function() {
      return this._dynamicSize;
    },
    set: function(v) {
      if (!v) {
        this._trimAlloc();
      }
      this._dynamicSize = v;
    } });

/**
  Internal function to trim the DataStream buffer when required.
  Used for stripping out the first bytes when not needed anymore.

  @return {null}
  */
DataStream.prototype.shift = function(offset) {
  var buf = new ArrayBuffer(this._byteLength-offset);
  var dst = new Uint8Array(buf);
  var src = new Uint8Array(this._buffer, offset, dst.length);
  dst.set(src);
  this.buffer = buf;
  this.position -= offset;
};

/**
  Writes an Int32Array of specified endianness to the DataStream.

  @param {Object} arr The array to write.
  @param {?boolean} e Endianness of the data to write.
 */
DataStream.prototype.writeInt32Array = function(arr, e) {
  this._realloc(arr.length * 4);
  if (arr instanceof Int32Array &&
      this.byteOffset+this.position % arr.BYTES_PER_ELEMENT === 0) {
    DataStream.memcpy(this._buffer, this.byteOffset+this.position,
                      arr.buffer, 0,
                      arr.byteLength);
    this.mapInt32Array(arr.length, e);
  } else {
    for (var i=0; i<arr.length; i++) {
      this.writeInt32(arr[i], e);
    }
  }
};

/**
  Writes an Int16Array of specified endianness to the DataStream.

  @param {Object} arr The array to write.
  @param {?boolean} e Endianness of the data to write.
 */
DataStream.prototype.writeInt16Array = function(arr, e) {
  this._realloc(arr.length * 2);
  if (arr instanceof Int16Array &&
      this.byteOffset+this.position % arr.BYTES_PER_ELEMENT === 0) {
    DataStream.memcpy(this._buffer, this.byteOffset+this.position,
                      arr.buffer, 0,
                      arr.byteLength);
    this.mapInt16Array(arr.length, e);
  } else {
    for (var i=0; i<arr.length; i++) {
      this.writeInt16(arr[i], e);
    }
  }
};

/**
  Writes an Int8Array to the DataStream.

  @param {Object} arr The array to write.
 */
DataStream.prototype.writeInt8Array = function(arr) {
  this._realloc(arr.length * 1);
  if (arr instanceof Int8Array &&
      this.byteOffset+this.position % arr.BYTES_PER_ELEMENT === 0) {
    DataStream.memcpy(this._buffer, this.byteOffset+this.position,
                      arr.buffer, 0,
                      arr.byteLength);
    this.mapInt8Array(arr.length);
  } else {
    for (var i=0; i<arr.length; i++) {
      this.writeInt8(arr[i]);
    }
  }
};

/**
  Writes a Uint32Array of specified endianness to the DataStream.

  @param {Object} arr The array to write.
  @param {?boolean} e Endianness of the data to write.
 */
DataStream.prototype.writeUint32Array = function(arr, e) {
  this._realloc(arr.length * 4);
  if (arr instanceof Uint32Array &&
      this.byteOffset+this.position % arr.BYTES_PER_ELEMENT === 0) {
    DataStream.memcpy(this._buffer, this.byteOffset+this.position,
                      arr.buffer, 0,
                      arr.byteLength);
    this.mapUint32Array(arr.length, e);
  } else {
    for (var i=0; i<arr.length; i++) {
      this.writeUint32(arr[i], e);
    }
  }
};

/**
  Writes a Uint16Array of specified endianness to the DataStream.

  @param {Object} arr The array to write.
  @param {?boolean} e Endianness of the data to write.
 */
DataStream.prototype.writeUint16Array = function(arr, e) {
  this._realloc(arr.length * 2);
  if (arr instanceof Uint16Array &&
      this.byteOffset+this.position % arr.BYTES_PER_ELEMENT === 0) {
    DataStream.memcpy(this._buffer, this.byteOffset+this.position,
                      arr.buffer, 0,
                      arr.byteLength);
    this.mapUint16Array(arr.length, e);
  } else {
    for (var i=0; i<arr.length; i++) {
      this.writeUint16(arr[i], e);
    }
  }
};

/**
  Writes a Uint8Array to the DataStream.

  @param {Object} arr The array to write.
 */
DataStream.prototype.writeUint8Array = function(arr) {
  this._realloc(arr.length * 1);
  if (arr instanceof Uint8Array &&
      this.byteOffset+this.position % arr.BYTES_PER_ELEMENT === 0) {
    DataStream.memcpy(this._buffer, this.byteOffset+this.position,
                      arr.buffer, 0,
                      arr.byteLength);
    this.mapUint8Array(arr.length);
  } else {
    for (var i=0; i<arr.length; i++) {
      this.writeUint8(arr[i]);
    }
  }
};

/**
  Writes a Float64Array of specified endianness to the DataStream.

  @param {Object} arr The array to write.
  @param {?boolean} e Endianness of the data to write.
 */
DataStream.prototype.writeFloat64Array = function(arr, e) {
  this._realloc(arr.length * 8);
  if (arr instanceof Float64Array &&
      this.byteOffset+this.position % arr.BYTES_PER_ELEMENT === 0) {
    DataStream.memcpy(this._buffer, this.byteOffset+this.position,
                      arr.buffer, 0,
                      arr.byteLength);
    this.mapFloat64Array(arr.length, e);
  } else {
    for (var i=0; i<arr.length; i++) {
      this.writeFloat64(arr[i], e);
    }
  }
};

/**
  Writes a Float32Array of specified endianness to the DataStream.

  @param {Object} arr The array to write.
  @param {?boolean} e Endianness of the data to write.
 */
DataStream.prototype.writeFloat32Array = function(arr, e) {
  this._realloc(arr.length * 4);
  if (arr instanceof Float32Array &&
      this.byteOffset+this.position % arr.BYTES_PER_ELEMENT === 0) {
    DataStream.memcpy(this._buffer, this.byteOffset+this.position,
                      arr.buffer, 0,
                      arr.byteLength);
    this.mapFloat32Array(arr.length, e);
  } else {
    for (var i=0; i<arr.length; i++) {
      this.writeFloat32(arr[i], e);
    }
  }
};


/**
  Writes a 32-bit int to the DataStream with the desired endianness.

  @param {number} v Number to write.
  @param {?boolean} e Endianness of the number.
 */
DataStream.prototype.writeInt32 = function(v, e) {
  this._realloc(4);
  this._dataView.setInt32(this.position, v, e == null ? this.endianness : e);
  this.position += 4;
};

/**
  Writes a 16-bit int to the DataStream with the desired endianness.

  @param {number} v Number to write.
  @param {?boolean} e Endianness of the number.
 */
DataStream.prototype.writeInt16 = function(v, e) {
  this._realloc(2);
  this._dataView.setInt16(this.position, v, e == null ? this.endianness : e);
  this.position += 2;
};

/**
  Writes an 8-bit int to the DataStream.

  @param {number} v Number to write.
 */
DataStream.prototype.writeInt8 = function(v) {
  this._realloc(1);
  this._dataView.setInt8(this.position, v);
  this.position += 1;
};

/**
  Writes a 32-bit unsigned int to the DataStream with the desired endianness.

  @param {number} v Number to write.
  @param {?boolean} e Endianness of the number.
 */
DataStream.prototype.writeUint32 = function(v, e) {
  this._realloc(4);
  this._dataView.setUint32(this.position, v, e == null ? this.endianness : e);
  this.position += 4;
};

/**
  Writes a 16-bit unsigned int to the DataStream with the desired endianness.

  @param {number} v Number to write.
  @param {?boolean} e Endianness of the number.
 */
DataStream.prototype.writeUint16 = function(v, e) {
  this._realloc(2);
  this._dataView.setUint16(this.position, v, e == null ? this.endianness : e);
  this.position += 2;
};

/**
  Writes an 8-bit unsigned  int to the DataStream.

  @param {number} v Number to write.
 */
DataStream.prototype.writeUint8 = function(v) {
  this._realloc(1);
  this._dataView.setUint8(this.position, v);
  this.position += 1;
};

/**
  Writes a 32-bit float to the DataStream with the desired endianness.

  @param {number} v Number to write.
  @param {?boolean} e Endianness of the number.
 */
DataStream.prototype.writeFloat32 = function(v, e) {
  this._realloc(4);
  this._dataView.setFloat32(this.position, v, e == null ? this.endianness : e);
  this.position += 4;
};

/**
  Writes a 64-bit float to the DataStream with the desired endianness.

  @param {number} v Number to write.
  @param {?boolean} e Endianness of the number.
 */
DataStream.prototype.writeFloat64 = function(v, e) {
  this._realloc(8);
  this._dataView.setFloat64(this.position, v, e == null ? this.endianness : e);
  this.position += 8;
};

/**
  Write a UCS-2 string of desired endianness to the DataStream. The
  lengthOverride argument lets you define the number of characters to write.
  If the string is shorter than lengthOverride, the extra space is padded with
  zeroes.

  @param {string} str The string to write.
  @param {?boolean} endianness The endianness to use for the written string data.
  @param {?number} lengthOverride The number of characters to write.
 */
DataStream.prototype.writeUCS2String = function(str, endianness, lengthOverride) {
  if (lengthOverride == null) {
    lengthOverride = str.length;
  }
  for (var i = 0; i < str.length && i < lengthOverride; i++) {
    this.writeUint16(str.charCodeAt(i), endianness);
  }
  for (; i<lengthOverride; i++) {
    this.writeUint16(0);
  }
};

/**
  Writes a string of desired length and encoding to the DataStream.

  @param {string} s The string to write.
  @param {?string} encoding The encoding for the written string data.
                            Defaults to ASCII.
  @param {?number} length The number of characters to write.
 */
DataStream.prototype.writeString = function(s, encoding, length) {
  var i = 0;
  if (encoding == null || encoding == "ASCII") {
    if (length != null) {
      var len = Math.min(s.length, length);
      for (i=0; i<len; i++) {
        this.writeUint8(s.charCodeAt(i));
      }
      for (; i<length; i++) {
        this.writeUint8(0);
      }
    } else {
      for (i=0; i<s.length; i++) {
        this.writeUint8(s.charCodeAt(i));
      }
    }
  } else {
    this.writeUint8Array((new TextEncoder(encoding)).encode(s.substring(0, length)));
  }
};

/**
  Writes a null-terminated string to DataStream and zero-pads it to length
  bytes. If length is not given, writes the string followed by a zero.
  If string is longer than length, the written part of the string does not have
  a trailing zero.

  @param {string} s The string to write.
  @param {?number} length The number of characters to write.
 */
DataStream.prototype.writeCString = function(s, length) {
  var i = 0;
  if (length != null) {
    var len = Math.min(s.length, length);
    for (i=0; i<len; i++) {
      this.writeUint8(s.charCodeAt(i));
    }
    for (; i<length; i++) {
      this.writeUint8(0);
    }
  } else {
    for (i=0; i<s.length; i++) {
      this.writeUint8(s.charCodeAt(i));
    }
    this.writeUint8(0);
  }
};

/**
  Writes a struct to the DataStream. Takes a structDefinition that gives the
  types and a struct object that gives the values. Refer to readStruct for the
  structure of structDefinition.

  @param {Object} structDefinition Type definition of the struct.
  @param {Object} struct The struct data object.
  */
DataStream.prototype.writeStruct = function(structDefinition, struct) {
  for (var i = 0; i < structDefinition.length; i+=2) {
    var t = structDefinition[i+1];
    this.writeType(t, struct[structDefinition[i]], struct);
  }
};

/**
  Writes object v of type t to the DataStream.

  @param {Object} t Type of data to write.
  @param {Object} v Value of data to write.
  @param {Object} struct Struct to pass to write callback functions.
  */
DataStream.prototype.writeType = function(t, v, struct) {
  var tp;
  if (typeof t == "function") {
    return t(this, v);
  } else if (typeof t == "object" && !(t instanceof Array)) {
    return t.set(this, v, struct);
  }
  var lengthOverride = null;
  var charset = "ASCII";
  var pos = this.position;
  if (typeof(t) == 'string' && /:/.test(t)) {
    tp = t.split(":");
    t = tp[0];
    lengthOverride = parseInt(tp[1]);
  }
  if (typeof t == 'string' && /,/.test(t)) {
    tp = t.split(",");
    t = tp[0];
    charset = parseInt(tp[1]);
  }

  switch(t) {
    case 'uint8':
      this.writeUint8(v);
      break;
    case 'int8':
      this.writeInt8(v);
      break;

    case 'uint16':
      this.writeUint16(v, this.endianness);
      break;
    case 'int16':
      this.writeInt16(v, this.endianness);
      break;
    case 'uint32':
      this.writeUint32(v, this.endianness);
      break;
    case 'int32':
      this.writeInt32(v, this.endianness);
      break;
    case 'float32':
      this.writeFloat32(v, this.endianness);
      break;
    case 'float64':
      this.writeFloat64(v, this.endianness);
      break;

    case 'uint16be':
      this.writeUint16(v, DataStream.BIG_ENDIAN);
      break;
    case 'int16be':
      this.writeInt16(v, DataStream.BIG_ENDIAN);
      break;
    case 'uint32be':
      this.writeUint32(v, DataStream.BIG_ENDIAN);
      break;
    case 'int32be':
      this.writeInt32(v, DataStream.BIG_ENDIAN);
      break;
    case 'float32be':
      this.writeFloat32(v, DataStream.BIG_ENDIAN);
      break;
    case 'float64be':
      this.writeFloat64(v, DataStream.BIG_ENDIAN);
      break;

    case 'uint16le':
      this.writeUint16(v, DataStream.LITTLE_ENDIAN);
      break;
    case 'int16le':
      this.writeInt16(v, DataStream.LITTLE_ENDIAN);
      break;
    case 'uint32le':
      this.writeUint32(v, DataStream.LITTLE_ENDIAN);
      break;
    case 'int32le':
      this.writeInt32(v, DataStream.LITTLE_ENDIAN);
      break;
    case 'float32le':
      this.writeFloat32(v, DataStream.LITTLE_ENDIAN);
      break;
    case 'float64le':
      this.writeFloat64(v, DataStream.LITTLE_ENDIAN);
      break;

    case 'cstring':
      this.writeCString(v, lengthOverride);
      break;

    case 'string':
      this.writeString(v, charset, lengthOverride);
      break;

    case 'u16string':
      this.writeUCS2String(v, this.endianness, lengthOverride);
      break;

    case 'u16stringle':
      this.writeUCS2String(v, DataStream.LITTLE_ENDIAN, lengthOverride);
      break;

    case 'u16stringbe':
      this.writeUCS2String(v, DataStream.BIG_ENDIAN, lengthOverride);
      break;

    default:
      if (t.length == 3) {
        var ta = t[1];
        for (var i=0; i<v.length; i++) {
          this.writeType(ta, v[i]);
        }
        break;
      } else {
        this.writeStruct(t, v);
        break;
      }
  }
  if (lengthOverride != null) {
    this.position = pos;
    this._realloc(lengthOverride);
    this.position = pos + lengthOverride;
  }
};


DataStream.prototype.writeUint64 = function (v) {
	var h = Math.floor(v / MAX_SIZE);
	this.writeUint32(h);
	this.writeUint32(v & 0xFFFFFFFF);
};

DataStream.prototype.writeUint24 = function (v) {
	this.writeUint8((v & 0x00FF0000)>>16);
	this.writeUint8((v & 0x0000FF00)>>8);
	this.writeUint8((v & 0x000000FF));
};

DataStream.prototype.adjustUint32 = function(position, value) {
	var pos = this.position;
	this.seek(position);
	this.writeUint32(value);
	this.seek(pos);
};
// file:src/DataStream-map.js
/**
  Maps an Int32Array into the DataStream buffer, swizzling it to native
  endianness in-place. The current offset from the start of the buffer needs to
  be a multiple of element size, just like with typed array views.

  Nice for quickly reading in data. Warning: potentially modifies the buffer
  contents.

  @param {number} length Number of elements to map.
  @param {?boolean} e Endianness of the data to read.
  @return {Object} Int32Array to the DataStream backing buffer.
  */
DataStream.prototype.mapInt32Array = function(length, e) {
  this._realloc(length * 4);
  var arr = new Int32Array(this._buffer, this.byteOffset+this.position, length);
  DataStream.arrayToNative(arr, e == null ? this.endianness : e);
  this.position += length * 4;
  return arr;
};

/**
  Maps an Int16Array into the DataStream buffer, swizzling it to native
  endianness in-place. The current offset from the start of the buffer needs to
  be a multiple of element size, just like with typed array views.

  Nice for quickly reading in data. Warning: potentially modifies the buffer
  contents.

  @param {number} length Number of elements to map.
  @param {?boolean} e Endianness of the data to read.
  @return {Object} Int16Array to the DataStream backing buffer.
  */
DataStream.prototype.mapInt16Array = function(length, e) {
  this._realloc(length * 2);
  var arr = new Int16Array(this._buffer, this.byteOffset+this.position, length);
  DataStream.arrayToNative(arr, e == null ? this.endianness : e);
  this.position += length * 2;
  return arr;
};

/**
  Maps an Int8Array into the DataStream buffer.

  Nice for quickly reading in data.

  @param {number} length Number of elements to map.
  @param {?boolean} e Endianness of the data to read.
  @return {Object} Int8Array to the DataStream backing buffer.
  */
DataStream.prototype.mapInt8Array = function(length) {
  this._realloc(length * 1);
  var arr = new Int8Array(this._buffer, this.byteOffset+this.position, length);
  this.position += length * 1;
  return arr;
};

/**
  Maps a Uint32Array into the DataStream buffer, swizzling it to native
  endianness in-place. The current offset from the start of the buffer needs to
  be a multiple of element size, just like with typed array views.

  Nice for quickly reading in data. Warning: potentially modifies the buffer
  contents.

  @param {number} length Number of elements to map.
  @param {?boolean} e Endianness of the data to read.
  @return {Object} Uint32Array to the DataStream backing buffer.
  */
DataStream.prototype.mapUint32Array = function(length, e) {
  this._realloc(length * 4);
  var arr = new Uint32Array(this._buffer, this.byteOffset+this.position, length);
  DataStream.arrayToNative(arr, e == null ? this.endianness : e);
  this.position += length * 4;
  return arr;
};

/**
  Maps a Uint16Array into the DataStream buffer, swizzling it to native
  endianness in-place. The current offset from the start of the buffer needs to
  be a multiple of element size, just like with typed array views.

  Nice for quickly reading in data. Warning: potentially modifies the buffer
  contents.

  @param {number} length Number of elements to map.
  @param {?boolean} e Endianness of the data to read.
  @return {Object} Uint16Array to the DataStream backing buffer.
  */
DataStream.prototype.mapUint16Array = function(length, e) {
  this._realloc(length * 2);
  var arr = new Uint16Array(this._buffer, this.byteOffset+this.position, length);
  DataStream.arrayToNative(arr, e == null ? this.endianness : e);
  this.position += length * 2;
  return arr;
};

/**
  Maps a Float64Array into the DataStream buffer, swizzling it to native
  endianness in-place. The current offset from the start of the buffer needs to
  be a multiple of element size, just like with typed array views.

  Nice for quickly reading in data. Warning: potentially modifies the buffer
  contents.

  @param {number} length Number of elements to map.
  @param {?boolean} e Endianness of the data to read.
  @return {Object} Float64Array to the DataStream backing buffer.
  */
DataStream.prototype.mapFloat64Array = function(length, e) {
  this._realloc(length * 8);
  var arr = new Float64Array(this._buffer, this.byteOffset+this.position, length);
  DataStream.arrayToNative(arr, e == null ? this.endianness : e);
  this.position += length * 8;
  return arr;
};

/**
  Maps a Float32Array into the DataStream buffer, swizzling it to native
  endianness in-place. The current offset from the start of the buffer needs to
  be a multiple of element size, just like with typed array views.

  Nice for quickly reading in data. Warning: potentially modifies the buffer
  contents.

  @param {number} length Number of elements to map.
  @param {?boolean} e Endianness of the data to read.
  @return {Object} Float32Array to the DataStream backing buffer.
  */
DataStream.prototype.mapFloat32Array = function(length, e) {
  this._realloc(length * 4);
  var arr = new Float32Array(this._buffer, this.byteOffset+this.position, length);
  DataStream.arrayToNative(arr, e == null ? this.endianness : e);
  this.position += length * 4;
  return arr;
};
// file:src/buffer.js
/**
 * MultiBufferStream is a class that acts as a SimpleStream for parsing 
 * It holds several, possibly non-contiguous ArrayBuffer objects, each with a fileStart property 
 * containing the offset for the buffer data in an original/virtual file 
 *
 * It inherits also from DataStream for all read/write/alloc operations
 */

/**
 * Constructor
 */
var MultiBufferStream = function(buffer) {
	/* List of ArrayBuffers, with a fileStart property, sorted in fileStart order and non overlapping */
	this.buffers = [];	
	this.bufferIndex = -1;
	if (buffer) {
		this.insertBuffer(buffer);
		this.bufferIndex = 0;
	}
};
MultiBufferStream.prototype = new DataStream(new ArrayBuffer(), 0, DataStream.BIG_ENDIAN);

/************************************************************************************
  Methods for the managnement of the buffers (insertion, removal, concatenation, ...)
 ***********************************************************************************/

MultiBufferStream.prototype.initialized = function() {
	var firstBuffer;
	if (this.bufferIndex > -1) {
		return true;
	} else if (this.buffers.length > 0) {
		firstBuffer = this.buffers[0];
		if (firstBuffer.fileStart === 0) {
			this.buffer = firstBuffer;
			this.bufferIndex = 0;
			Log.debug("MultiBufferStream", "Stream ready for parsing");
			return true;
		} else {
			Log.warn("MultiBufferStream", "The first buffer should have a fileStart of 0");
			this.logBufferLevel();
			return false;
		}
	} else {
		Log.warn("MultiBufferStream", "No buffer to start parsing from");
		this.logBufferLevel();
		return false;
	}			
};

/**
 * helper functions to concatenate two ArrayBuffer objects
 * @param  {ArrayBuffer} buffer1 
 * @param  {ArrayBuffer} buffer2 
 * @return {ArrayBuffer} the concatenation of buffer1 and buffer2 in that order
 */
ArrayBuffer.concat = function(buffer1, buffer2) {
  Log.debug("ArrayBuffer", "Trying to create a new buffer of size: "+(buffer1.byteLength + buffer2.byteLength));
  var tmp = new Uint8Array(buffer1.byteLength + buffer2.byteLength);
  tmp.set(new Uint8Array(buffer1), 0);
  tmp.set(new Uint8Array(buffer2), buffer1.byteLength);
  return tmp.buffer;
};

/**
 * Reduces the size of a given buffer, but taking the part between offset and offset+newlength
 * @param  {ArrayBuffer} buffer    
 * @param  {Number}      offset    the start of new buffer
 * @param  {Number}      newLength the length of the new buffer
 * @return {ArrayBuffer}           the new buffer
 */
MultiBufferStream.prototype.reduceBuffer = function(buffer, offset, newLength) {
	var smallB;
	smallB = new Uint8Array(newLength);
	smallB.set(new Uint8Array(buffer, offset, newLength));
	smallB.buffer.fileStart = buffer.fileStart+offset;
	smallB.buffer.usedBytes = 0;
	return smallB.buffer;	
};

/**
 * Inserts the new buffer in the sorted list of buffers,
 *  making sure, it is not overlapping with existing ones (possibly reducing its size).
 *  if the new buffer overrides/replaces the 0-th buffer (for instance because it is bigger), 
 *  updates the DataStream buffer for parsing 
*/
MultiBufferStream.prototype.insertBuffer = function(ab) {	
	var to_add = true;
	/* TODO: improve insertion if many buffers */
	for (var i = 0; i < this.buffers.length; i++) {
		var b = this.buffers[i];
		if (ab.fileStart <= b.fileStart) {
			/* the insertion position is found */
			if (ab.fileStart === b.fileStart) {
				/* The new buffer overlaps with an existing buffer */
				if (ab.byteLength >  b.byteLength) {
					/* the new buffer is bigger than the existing one
					   remove the existing buffer and try again to insert 
					   the new buffer to check overlap with the next ones */
					this.buffers.splice(i, 1);
					i--; 
					continue;
				} else {
					/* the new buffer is smaller than the existing one, just drop it */
					Log.warn("MultiBufferStream", "Buffer (fileStart: "+ab.fileStart+" - Length: "+ab.byteLength+") already appended, ignoring");
				}
			} else {
				/* The beginning of the new buffer is not overlapping with an existing buffer
				   let's check the end of it */
				if (ab.fileStart + ab.byteLength <= b.fileStart) ; else {
					/* There is some overlap, cut the new buffer short, and add it*/
					ab = this.reduceBuffer(ab, 0, b.fileStart - ab.fileStart);
				}
				Log.debug("MultiBufferStream", "Appending new buffer (fileStart: "+ab.fileStart+" - Length: "+ab.byteLength+")");
				this.buffers.splice(i, 0, ab);
				/* if this new buffer is inserted in the first place in the list of the buffer, 
				   and the DataStream is initialized, make it the buffer used for parsing */
				if (i === 0) {
					this.buffer = ab;
				}
			}
			to_add = false;
			break;
		} else if (ab.fileStart < b.fileStart + b.byteLength) {
			/* the new buffer overlaps its beginning with the end of the current buffer */
			var offset = b.fileStart + b.byteLength - ab.fileStart;
			var newLength = ab.byteLength - offset;
			if (newLength > 0) {
				/* the new buffer is bigger than the current overlap, drop the overlapping part and try again inserting the remaining buffer */
				ab = this.reduceBuffer(ab, offset, newLength);
			} else {
				/* the content of the new buffer is entirely contained in the existing buffer, drop it entirely */
				to_add = false;
				break;
			}
		}
	}
	/* if the buffer has not been added, we can add it at the end */
	if (to_add) {
		Log.debug("MultiBufferStream", "Appending new buffer (fileStart: "+ab.fileStart+" - Length: "+ab.byteLength+")");
		this.buffers.push(ab);
		/* if this new buffer is inserted in the first place in the list of the buffer, 
		   and the DataStream is initialized, make it the buffer used for parsing */
		if (i === 0) {
			this.buffer = ab;
		}
	}
};

/**
 * Displays the status of the buffers (number and used bytes)
 * @param  {Object} info callback method for display
 */
MultiBufferStream.prototype.logBufferLevel = function(info) {
	var i;
	var buffer;
	var used, total;
	var ranges = [];
	var range;
	var bufferedString = "";
	used = 0;
	total = 0;
	for (i = 0; i < this.buffers.length; i++) {
		buffer = this.buffers[i];
		if (i === 0) {
			range = {};
			ranges.push(range);
			range.start = buffer.fileStart;
			range.end = buffer.fileStart+buffer.byteLength;
			bufferedString += "["+range.start+"-";
		} else if (range.end === buffer.fileStart) {
			range.end = buffer.fileStart+buffer.byteLength;
		} else {
			range = {};
			range.start = buffer.fileStart;
			bufferedString += (ranges[ranges.length-1].end-1)+"], ["+range.start+"-";
			range.end = buffer.fileStart+buffer.byteLength;
			ranges.push(range);
		}
		used += buffer.usedBytes;
		total += buffer.byteLength;
	}
	if (ranges.length > 0) {
		bufferedString += (range.end-1)+"]";
	}
	var log = (info ? Log.info : Log.debug);
	if (this.buffers.length === 0) {
		log("MultiBufferStream", "No more buffer in memory");
	} else {
		log("MultiBufferStream", ""+this.buffers.length+" stored buffer(s) ("+used+"/"+total+" bytes), continuous ranges: "+bufferedString);
	}
};

MultiBufferStream.prototype.cleanBuffers = function () {
	var i;
	var buffer;
	for (i = 0; i < this.buffers.length; i++) {
		buffer = this.buffers[i];
		if (buffer.usedBytes === buffer.byteLength) {
			Log.debug("MultiBufferStream", "Removing buffer #"+i);
			this.buffers.splice(i, 1);
			i--;
		}
	}
};

MultiBufferStream.prototype.mergeNextBuffer = function() {
	var next_buffer;
	if (this.bufferIndex+1 < this.buffers.length) {
		next_buffer = this.buffers[this.bufferIndex+1];
		if (next_buffer.fileStart === this.buffer.fileStart + this.buffer.byteLength) {
			var oldLength = this.buffer.byteLength;
			var oldUsedBytes = this.buffer.usedBytes;
			var oldFileStart = this.buffer.fileStart;
			this.buffers[this.bufferIndex] = ArrayBuffer.concat(this.buffer, next_buffer);
			this.buffer = this.buffers[this.bufferIndex];
			this.buffers.splice(this.bufferIndex+1, 1);
			this.buffer.usedBytes = oldUsedBytes; /* TODO: should it be += ? */
			this.buffer.fileStart = oldFileStart;
			Log.debug("ISOFile", "Concatenating buffer for box parsing (length: "+oldLength+"->"+this.buffer.byteLength+")");
			return true;
		} else {
			return false;
		}
	} else {
		return false;
	}
};


/*************************************************************************
  Seek-related functions
 *************************************************************************/

/**
 * Finds the buffer that holds the given file position
 * @param  {Boolean} fromStart    indicates if the search should start from the current buffer (false) 
 *                                or from the first buffer (true)
 * @param  {Number}  filePosition position in the file to seek to
 * @param  {Boolean} markAsUsed   indicates if the bytes in between the current position and the seek position 
 *                                should be marked as used for garbage collection
 * @return {Number}               the index of the buffer holding the seeked file position, -1 if not found.
 */
MultiBufferStream.prototype.findPosition = function(fromStart, filePosition, markAsUsed) {
	var i;
	var abuffer = null;
	var index = -1;

	/* find the buffer with the largest position smaller than the given position */
	if (fromStart === true) {
	   /* the reposition can be in the past, we need to check from the beginning of the list of buffers */
		i = 0;
	} else {
		i = this.bufferIndex;
	}

	while (i < this.buffers.length) {
		abuffer = this.buffers[i];
		if (abuffer.fileStart <= filePosition) {
			index = i;
			if (markAsUsed) {
				if (abuffer.fileStart + abuffer.byteLength <= filePosition) {
					abuffer.usedBytes = abuffer.byteLength;	
				} else {
					abuffer.usedBytes = filePosition - abuffer.fileStart;
				}		
				this.logBufferLevel();	
			}
		} else {
			break;
		}
		i++;
	}

	if (index !== -1) {
		abuffer = this.buffers[index];
		if (abuffer.fileStart + abuffer.byteLength >= filePosition) {			
			Log.debug("MultiBufferStream", "Found position in existing buffer #"+index);
			return index;
		} else {
			return -1;
		}
	} else {
		return -1;
	}
};

/**
 * Finds the largest file position contained in a buffer or in the next buffers if they are contiguous (no gap)
 * starting from the given buffer index or from the current buffer if the index is not given
 *
 * @param  {Number} inputindex Index of the buffer to start from
 * @return {Number}            The largest file position found in the buffers
 */
MultiBufferStream.prototype.findEndContiguousBuf = function(inputindex) {
	var i;
	var currentBuf;
	var nextBuf;
	var index = (inputindex !== undefined ? inputindex : this.bufferIndex);
	currentBuf = this.buffers[index];
	/* find the end of the contiguous range of data */
	if (this.buffers.length > index+1) {
		for (i = index+1; i < this.buffers.length; i++) {
			nextBuf = this.buffers[i];
			if (nextBuf.fileStart === currentBuf.fileStart + currentBuf.byteLength) {
				currentBuf = nextBuf;
			} else {
				break;
			}
		}
	}
	/* return the position of last byte in the file that we have */
	return currentBuf.fileStart + currentBuf.byteLength;
};

/**
 * Returns the largest file position contained in the buffers, larger than the given position
 * @param  {Number} pos the file position to start from
 * @return {Number}     the largest position in the current buffer or in the buffer and the next contiguous 
 *                      buffer that holds the given position
 */
MultiBufferStream.prototype.getEndFilePositionAfter = function(pos) {
	var index = this.findPosition(true, pos, false);
	if (index !== -1) {
		return this.findEndContiguousBuf(index);
	} else {
		return pos;
	}
};

/*************************************************************************
  Garbage collection related functions
 *************************************************************************/

/**
 * Marks a given number of bytes as used in the current buffer for garbage collection
 * @param {Number} nbBytes 
 */
MultiBufferStream.prototype.addUsedBytes = function(nbBytes) {
	this.buffer.usedBytes += nbBytes;
	this.logBufferLevel();
};

/**
 * Marks the entire current buffer as used, ready for garbage collection
 */
MultiBufferStream.prototype.setAllUsedBytes = function() {
	this.buffer.usedBytes = this.buffer.byteLength;
	this.logBufferLevel();
};

/*************************************************************************
  Common API between MultiBufferStream and SimpleStream
 *************************************************************************/

/**
 * Tries to seek to a given file position
 * if possible, repositions the parsing from there and returns true 
 * if not possible, does not change anything and returns false 
 * @param  {Number}  filePosition position in the file to seek to
 * @param  {Boolean} fromStart    indicates if the search should start from the current buffer (false) 
 *                                or from the first buffer (true)
 * @param  {Boolean} markAsUsed   indicates if the bytes in between the current position and the seek position 
 *                                should be marked as used for garbage collection
 * @return {Boolean}              true if the seek succeeded, false otherwise
 */
MultiBufferStream.prototype.seek = function(filePosition, fromStart, markAsUsed) {
	var index;
	index = this.findPosition(fromStart, filePosition, markAsUsed);
	if (index !== -1) {
		this.buffer = this.buffers[index];
		this.bufferIndex = index;
		this.position = filePosition - this.buffer.fileStart;
		Log.debug("MultiBufferStream", "Repositioning parser at buffer position: "+this.position);
		return true;
	} else {
		Log.debug("MultiBufferStream", "Position "+filePosition+" not found in buffered data");
		return false;
	}
};

/**
 * Returns the current position in the file
 * @return {Number} the position in the file
 */
MultiBufferStream.prototype.getPosition = function() {
	if (this.bufferIndex === -1 || this.buffers[this.bufferIndex] === null) {
		throw "Error accessing position in the MultiBufferStream";
	}
	return this.buffers[this.bufferIndex].fileStart+this.position;
};

/**
 * Returns the length of the current buffer
 * @return {Number} the length of the current buffer
 */
MultiBufferStream.prototype.getLength = function() {
	return this.byteLength;
};

MultiBufferStream.prototype.getEndPosition = function() {
	if (this.bufferIndex === -1 || this.buffers[this.bufferIndex] === null) {
		throw "Error accessing position in the MultiBufferStream";
	}
	return this.buffers[this.bufferIndex].fileStart+this.byteLength;
};

{
	exports.MultiBufferStream = MultiBufferStream;
}// file:src/descriptor.js
/*
 * Copyright (c) 2012-2013. Telecom ParisTech/TSI/MM/GPAC Cyril Concolato
 * License: BSD-3-Clause (see LICENSE file)
 */
var MPEG4DescriptorParser = function () {
	var ES_DescrTag 			= 0x03;
	var DecoderConfigDescrTag 	= 0x04;
	var DecSpecificInfoTag 		= 0x05;
	var SLConfigDescrTag 		= 0x06;

	var descTagToName = [];
	descTagToName[ES_DescrTag] 				= "ES_Descriptor";
	descTagToName[DecoderConfigDescrTag] 	= "DecoderConfigDescriptor";
	descTagToName[DecSpecificInfoTag] 		= "DecoderSpecificInfo";
	descTagToName[SLConfigDescrTag] 		= "SLConfigDescriptor";

	this.getDescriptorName = function(tag) {
		return descTagToName[tag];
	};

	var that = this;
	var classes = {};

	this.parseOneDescriptor = function (stream) {
		var size = 0;
		var tag;
		var desc;
		var byteRead;
		tag = stream.readUint8();
		byteRead = stream.readUint8();
		while (byteRead & 0x80) {
			size = (byteRead & 0x7F)<<7;
			byteRead = stream.readUint8();
		}
		size += byteRead & 0x7F;
		Log.debug("MPEG4DescriptorParser", "Found "+(descTagToName[tag] || "Descriptor "+tag)+", size "+size+" at position "+stream.getPosition());
		if (descTagToName[tag]) {
			desc = new classes[descTagToName[tag]](size);
		} else {
			desc = new classes.Descriptor(size);
		}
		desc.parse(stream);
		return desc;
	};

	classes.Descriptor = function(_tag, _size) {
		this.tag = _tag;
		this.size = _size;
		this.descs = [];
	};

	classes.Descriptor.prototype.parse = function (stream) {
		this.data = stream.readUint8Array(this.size);
	};

	classes.Descriptor.prototype.findDescriptor = function (tag) {
		for (var i = 0; i < this.descs.length; i++) {
			if (this.descs[i].tag == tag) {
				return this.descs[i];
			}
		}
		return null;
	};

	classes.Descriptor.prototype.parseRemainingDescriptors = function (stream) {
		var start = stream.position;
		while (stream.position < start+this.size) {
			var desc = that.parseOneDescriptor(stream);
			this.descs.push(desc);
		}
	};

	classes.ES_Descriptor = function (size) {
		classes.Descriptor.call(this, ES_DescrTag, size);
	};

	classes.ES_Descriptor.prototype = new classes.Descriptor();

	classes.ES_Descriptor.prototype.parse = function(stream) {
		this.ES_ID = stream.readUint16();
		this.flags = stream.readUint8();
		this.size -= 3;
		if (this.flags & 0x80) {
			this.dependsOn_ES_ID = stream.readUint16();
			this.size -= 2;
		} else {
			this.dependsOn_ES_ID = 0;
		}
		if (this.flags & 0x40) {
			var l = stream.readUint8();
			this.URL = stream.readString(l);
			this.size -= l+1;
		} else {
			this.URL = "";
		}
		if (this.flags & 0x20) {
			this.OCR_ES_ID = stream.readUint16();
			this.size -= 2;
		} else {
			this.OCR_ES_ID = 0;
		}
		this.parseRemainingDescriptors(stream);
	};

	classes.ES_Descriptor.prototype.getOTI = function(stream) {
		var dcd = this.findDescriptor(DecoderConfigDescrTag);
		if (dcd) {
			return dcd.oti;
		} else {
			return 0;
		}
	};

	classes.ES_Descriptor.prototype.getAudioConfig = function(stream) {
		var dcd = this.findDescriptor(DecoderConfigDescrTag);
		if (!dcd) return null;
		var dsi = dcd.findDescriptor(DecSpecificInfoTag);
		if (dsi && dsi.data) {
			var audioObjectType = (dsi.data[0]& 0xF8) >> 3;
			if (audioObjectType === 31 && dsi.data.length >= 2) {
				audioObjectType = 32 + ((dsi.data[0] & 0x7) << 3) + ((dsi.data[1] & 0xE0) >> 5);
			}
			return audioObjectType;
		} else {
			return null;
		}
	};

	classes.DecoderConfigDescriptor = function (size) {
		classes.Descriptor.call(this, DecoderConfigDescrTag, size);
	};
	classes.DecoderConfigDescriptor.prototype = new classes.Descriptor();

	classes.DecoderConfigDescriptor.prototype.parse = function(stream) {
		this.oti = stream.readUint8();
		this.streamType = stream.readUint8();
		this.bufferSize = stream.readUint24();
		this.maxBitrate = stream.readUint32();
		this.avgBitrate = stream.readUint32();
		this.size -= 13;
		this.parseRemainingDescriptors(stream);
	};

	classes.DecoderSpecificInfo = function (size) {
		classes.Descriptor.call(this, DecSpecificInfoTag, size);
	};
	classes.DecoderSpecificInfo.prototype = new classes.Descriptor();

	classes.SLConfigDescriptor = function (size) {
		classes.Descriptor.call(this, SLConfigDescrTag, size);
	};
	classes.SLConfigDescriptor.prototype = new classes.Descriptor();

	return this;
};

{
	exports.MPEG4DescriptorParser = MPEG4DescriptorParser;
}// file:src/box.js
/*
 * Copyright (c) 2012-2013. Telecom ParisTech/TSI/MM/GPAC Cyril Concolato
 * License: BSD-3-Clause (see LICENSE file)
 */
var BoxParser = {
	ERR_INVALID_DATA : -1,
	ERR_NOT_ENOUGH_DATA : 0,
	OK : 1,

	// Boxes to be created with default parsing
	BASIC_BOXES: [ "mdat", "idat", "free", "skip", "meco", "strk" ],
	FULL_BOXES: [ "hmhd", "nmhd", "iods", "xml ", "bxml", "ipro", "mere" ],
	CONTAINER_BOXES: [
		[ "moov", [ "trak", "pssh" ] ],
		[ "trak" ],
		[ "edts" ],
		[ "mdia" ],
		[ "minf" ],
		[ "dinf" ],
		[ "stbl", [ "sgpd", "sbgp" ] ],
		[ "mvex", [ "trex" ] ],
		[ "moof", [ "traf" ] ],
		[ "traf", [ "trun", "sgpd", "sbgp" ] ],
		[ "vttc" ],
		[ "tref" ],
		[ "iref" ],
		[ "mfra", [ "tfra" ] ],
		[ "meco" ],
		[ "hnti" ],
		[ "hinf" ],
		[ "strk" ],
		[ "strd" ],
		[ "sinf" ],
		[ "rinf" ],
		[ "schi" ],
		[ "trgr" ],
		[ "udta", ["kind"] ],
		[ "iprp", ["ipma"] ],
		[ "ipco"]
	],
	// Boxes effectively created
	boxCodes : [],
	fullBoxCodes : [],
	containerBoxCodes : [],
	sampleEntryCodes : {},
	sampleGroupEntryCodes: [],
	trackGroupTypes: [],
	UUIDBoxes: {},
	UUIDs: [],
	initialize: function() {
		BoxParser.FullBox.prototype = new BoxParser.Box();
		BoxParser.ContainerBox.prototype = new BoxParser.Box();
		BoxParser.SampleEntry.prototype = new BoxParser.Box();
		BoxParser.TrackGroupTypeBox.prototype = new BoxParser.FullBox();

		/* creating constructors for simple boxes */
		BoxParser.BASIC_BOXES.forEach(function(type) {
			BoxParser.createBoxCtor(type);
		});
		BoxParser.FULL_BOXES.forEach(function(type) {
			BoxParser.createFullBoxCtor(type);
		});
		BoxParser.CONTAINER_BOXES.forEach(function(types) {
			BoxParser.createContainerBoxCtor(types[0], null, types[1]);
		});
	},
	Box: function(_type, _size, _uuid) {
		this.type = _type;
		this.size = _size;
		this.uuid = _uuid;
	},
	FullBox: function(type, size, uuid) {
		BoxParser.Box.call(this, type, size, uuid);
		this.flags = 0;
		this.version = 0;
	},
	ContainerBox: function(type, size, uuid) {
		BoxParser.Box.call(this, type, size, uuid);
		this.boxes = [];
	},
	SampleEntry: function(type, size, hdr_size, start) {
		BoxParser.ContainerBox.call(this, type, size);
		this.hdr_size = hdr_size;
		this.start = start;
	},
	SampleGroupEntry: function(type) {
		this.grouping_type = type;
	},
	TrackGroupTypeBox: function(type, size) {
		BoxParser.FullBox.call(this, type, size);
	},
	createBoxCtor: function(type, parseMethod){
		BoxParser.boxCodes.push(type);
		BoxParser[type+"Box"] = function(size) {
			BoxParser.Box.call(this, type, size);
		};
		BoxParser[type+"Box"].prototype = new BoxParser.Box();
		if (parseMethod) BoxParser[type+"Box"].prototype.parse = parseMethod;
	},
	createFullBoxCtor: function(type, parseMethod) {
		//BoxParser.fullBoxCodes.push(type);
		BoxParser[type+"Box"] = function(size) {
			BoxParser.FullBox.call(this, type, size);
		};
		BoxParser[type+"Box"].prototype = new BoxParser.FullBox();
		BoxParser[type+"Box"].prototype.parse = function(stream) {
			this.parseFullHeader(stream);
			if (parseMethod) {
				parseMethod.call(this, stream);
			}
		};
	},
	addSubBoxArrays: function(subBoxNames) {
		if (subBoxNames) {
			this.subBoxNames = subBoxNames;
			var nbSubBoxes = subBoxNames.length;
			for (var k = 0; k<nbSubBoxes; k++) {
				this[subBoxNames[k]+"s"] = [];
			}
		}
	},
	createContainerBoxCtor: function(type, parseMethod, subBoxNames) {
		//BoxParser.containerBoxCodes.push(type);
		BoxParser[type+"Box"] = function(size) {
			BoxParser.ContainerBox.call(this, type, size);
			BoxParser.addSubBoxArrays.call(this, subBoxNames);
		};
		BoxParser[type+"Box"].prototype = new BoxParser.ContainerBox();
		if (parseMethod) BoxParser[type+"Box"].prototype.parse = parseMethod;
	},
	createMediaSampleEntryCtor: function(mediaType, parseMethod, subBoxNames) {
		BoxParser.sampleEntryCodes[mediaType] = [];
		BoxParser[mediaType+"SampleEntry"] = function(type, size) {
			BoxParser.SampleEntry.call(this, type, size);
			BoxParser.addSubBoxArrays.call(this, subBoxNames);
		};
		BoxParser[mediaType+"SampleEntry"].prototype = new BoxParser.SampleEntry();
		if (parseMethod) BoxParser[mediaType+"SampleEntry"].prototype .parse = parseMethod;
	},
	createSampleEntryCtor: function(mediaType, type, parseMethod, subBoxNames) {
		BoxParser.sampleEntryCodes[mediaType].push(type);
		BoxParser[type+"SampleEntry"] = function(size) {
			BoxParser[mediaType+"SampleEntry"].call(this, type, size);
			BoxParser.addSubBoxArrays.call(this, subBoxNames);
		};
		BoxParser[type+"SampleEntry"].prototype = new BoxParser[mediaType+"SampleEntry"]();
		if (parseMethod) BoxParser[type+"SampleEntry"].prototype.parse = parseMethod;
	},
	createEncryptedSampleEntryCtor: function(mediaType, type, parseMethod) {
		BoxParser.createSampleEntryCtor.call(this, mediaType, type, parseMethod, ["sinf"]);
	},
	createSampleGroupCtor: function(type, parseMethod) {
		//BoxParser.sampleGroupEntryCodes.push(type);
		BoxParser[type+"SampleGroupEntry"] = function(size) {
			BoxParser.SampleGroupEntry.call(this, type, size);
		};
		BoxParser[type+"SampleGroupEntry"].prototype = new BoxParser.SampleGroupEntry();
		if (parseMethod) BoxParser[type+"SampleGroupEntry"].prototype.parse = parseMethod;
	},
	createTrackGroupCtor: function(type, parseMethod) {
		//BoxParser.trackGroupTypes.push(type);
		BoxParser[type+"TrackGroupTypeBox"] = function(size) {
			BoxParser.TrackGroupTypeBox.call(this, type, size);
		};
		BoxParser[type+"TrackGroupTypeBox"].prototype = new BoxParser.TrackGroupTypeBox();
		if (parseMethod) BoxParser[type+"TrackGroupTypeBox"].prototype.parse = parseMethod;
	},
	createUUIDBox: function(uuid, isFullBox, isContainerBox, parseMethod) {
		BoxParser.UUIDs.push(uuid);
		BoxParser.UUIDBoxes[uuid] = function(size) {
			if (isFullBox) {
				BoxParser.FullBox.call(this, "uuid", size, uuid);
			} else {
				if (isContainerBox) {
					BoxParser.ContainerBox.call(this, "uuid", size, uuid);
				} else {
					BoxParser.Box.call(this, "uuid", size, uuid);
				}
			}
		};
		BoxParser.UUIDBoxes[uuid].prototype = (isFullBox ? new BoxParser.FullBox() : (isContainerBox ? new BoxParser.ContainerBox() : new BoxParser.Box()));
		if (parseMethod) {
			if (isFullBox) {
				BoxParser.UUIDBoxes[uuid].prototype.parse = function(stream) {
					this.parseFullHeader(stream);
					if (parseMethod) {
						parseMethod.call(this, stream);
					}
				};
			} else {
				BoxParser.UUIDBoxes[uuid].prototype.parse = parseMethod;
			}
		}
	}
};

BoxParser.initialize();

BoxParser.TKHD_FLAG_ENABLED    = 0x000001;
BoxParser.TKHD_FLAG_IN_MOVIE   = 0x000002;
BoxParser.TKHD_FLAG_IN_PREVIEW = 0x000004;

BoxParser.TFHD_FLAG_BASE_DATA_OFFSET	= 0x01;
BoxParser.TFHD_FLAG_SAMPLE_DESC			= 0x02;
BoxParser.TFHD_FLAG_SAMPLE_DUR			= 0x08;
BoxParser.TFHD_FLAG_SAMPLE_SIZE			= 0x10;
BoxParser.TFHD_FLAG_SAMPLE_FLAGS		= 0x20;
BoxParser.TFHD_FLAG_DUR_EMPTY			= 0x10000;
BoxParser.TFHD_FLAG_DEFAULT_BASE_IS_MOOF= 0x20000;

BoxParser.TRUN_FLAGS_DATA_OFFSET= 0x01;
BoxParser.TRUN_FLAGS_FIRST_FLAG	= 0x04;
BoxParser.TRUN_FLAGS_DURATION	= 0x100;
BoxParser.TRUN_FLAGS_SIZE		= 0x200;
BoxParser.TRUN_FLAGS_FLAGS		= 0x400;
BoxParser.TRUN_FLAGS_CTS_OFFSET	= 0x800;

BoxParser.Box.prototype.add = function(name) {
	return this.addBox(new BoxParser[name+"Box"]());
};

BoxParser.Box.prototype.addBox = function(box) {
	this.boxes.push(box);
	if (this[box.type+"s"]) {
		this[box.type+"s"].push(box);
	} else {
		this[box.type] = box;
	}
	return box;
};

BoxParser.Box.prototype.set = function(prop, value) {
	this[prop] = value;
	return this;
};

BoxParser.Box.prototype.addEntry = function(value, _prop) {
	var prop = _prop || "entries";
	if (!this[prop]) {
		this[prop] = [];
	}
	this[prop].push(value);
	return this;
};

{
	exports.BoxParser = BoxParser;
}
// file:src/box-parse.js
/* 
 * Copyright (c) Telecom ParisTech/TSI/MM/GPAC Cyril Concolato
 * License: BSD-3-Clause (see LICENSE file)
 */
BoxParser.parseUUID = function(stream) {
	return BoxParser.parseHex16(stream);
};

BoxParser.parseHex16 = function(stream) {
	var hex16 = "";
	for (var i = 0; i <16; i++) {
		var hex = stream.readUint8().toString(16);
		hex16 += (hex.length === 1 ? "0"+hex : hex);
	}
	return hex16;
};

BoxParser.parseOneBox = function(stream, headerOnly, parentSize) {
	var box;
	var start = stream.getPosition();
	var hdr_size = 0;
	var diff;
	var uuid;
	if (stream.getEndPosition() - start < 8) {
		Log.debug("BoxParser", "Not enough data in stream to parse the type and size of the box");
		return { code: BoxParser.ERR_NOT_ENOUGH_DATA };
	}
	if (parentSize && parentSize < 8) {
		Log.debug("BoxParser", "Not enough bytes left in the parent box to parse a new box");
		return { code: BoxParser.ERR_NOT_ENOUGH_DATA };
	}
	var size = stream.readUint32();
	var type = stream.readString(4);
	var box_type = type;
	Log.debug("BoxParser", "Found box of type '"+type+"' and size "+size+" at position "+start);
	hdr_size = 8;
	if (type == "uuid") {
		if ((stream.getEndPosition() - stream.getPosition() < 16) || (parentSize -hdr_size < 16)) {
			stream.seek(start);
			Log.debug("BoxParser", "Not enough bytes left in the parent box to parse a UUID box");
			return { code: BoxParser.ERR_NOT_ENOUGH_DATA };
		}
		uuid = BoxParser.parseUUID(stream);
		hdr_size += 16;
		box_type = uuid;
	}
	if (size == 1) {
		if ((stream.getEndPosition() - stream.getPosition() < 8) || (parentSize && (parentSize - hdr_size) < 8)) {
			stream.seek(start);
			Log.warn("BoxParser", "Not enough data in stream to parse the extended size of the \""+type+"\" box");
			return { code: BoxParser.ERR_NOT_ENOUGH_DATA };
		}
		size = stream.readUint64();
		hdr_size += 8;
	} else if (size === 0) {
		/* box extends till the end of file or invalid file */
		if (parentSize) {
			size = parentSize;
		} else {
			/* box extends till the end of file */
			if (type !== "mdat") {
				Log.error("BoxParser", "Unlimited box size not supported for type: '"+type+"'");
				box = new BoxParser.Box(type, size);
				return { code: BoxParser.OK, box: box, size: box.size };
			}
		}
	}
	if (size < hdr_size) {
		Log.error("BoxParser", "Box of type "+type+" has an invalid size "+size+" (too small to be a box)");
		return { code: BoxParser.ERR_NOT_ENOUGH_DATA, type: type, size: size, hdr_size: hdr_size, start: start };
	}
	if (parentSize && size > parentSize) {
		Log.error("BoxParser", "Box of type '"+type+"' has a size "+size+" greater than its container size "+parentSize);
		return { code: BoxParser.ERR_NOT_ENOUGH_DATA, type: type, size: size, hdr_size: hdr_size, start: start };
	}
	if (start + size > stream.getEndPosition()) {
		stream.seek(start);
		Log.info("BoxParser", "Not enough data in stream to parse the entire '"+type+"' box");
		return { code: BoxParser.ERR_NOT_ENOUGH_DATA, type: type, size: size, hdr_size: hdr_size, start: start };
	}
	if (headerOnly) {
		return { code: BoxParser.OK, type: type, size: size, hdr_size: hdr_size, start: start };
	} else {
		if (BoxParser[type+"Box"]) {
			box = new BoxParser[type+"Box"](size);
		} else {
			if (type !== "uuid") {
				Log.warn("BoxParser", "Unknown box type: '"+type+"'");
				box = new BoxParser.Box(type, size);
				box.has_unparsed_data = true;
			} else {
				if (BoxParser.UUIDBoxes[uuid]) {
					box = new BoxParser.UUIDBoxes[uuid](size);
				} else {
					Log.warn("BoxParser", "Unknown uuid type: '"+uuid+"'");
					box = new BoxParser.Box(type, size);
					box.uuid = uuid;
					box.has_unparsed_data = true;
				}
			}
		}
	}
	box.hdr_size = hdr_size;
	/* recording the position of the box in the input stream */
	box.start = start;
	if (box.write === BoxParser.Box.prototype.write && box.type !== "mdat") {
		Log.info("BoxParser", "'"+box_type+"' box writing not yet implemented, keeping unparsed data in memory for later write");
		box.parseDataAndRewind(stream);
	}
	box.parse(stream);
	diff = stream.getPosition() - (box.start+box.size);
	if (diff < 0) {
		Log.warn("BoxParser", "Parsing of box '"+box_type+"' did not read the entire indicated box data size (missing "+(-diff)+" bytes), seeking forward");
		stream.seek(box.start+box.size);
	} else if (diff > 0) {
		Log.error("BoxParser", "Parsing of box '"+box_type+"' read "+diff+" more bytes than the indicated box data size, seeking backwards");
		stream.seek(box.start+box.size);
	}
	return { code: BoxParser.OK, box: box, size: box.size };
};

BoxParser.Box.prototype.parse = function(stream) {
	if (this.type != "mdat") {
		this.data = stream.readUint8Array(this.size-this.hdr_size);
	} else {
		if (this.size === 0) {
			stream.seek(stream.getEndPosition());
		} else {
			stream.seek(this.start+this.size);
		}
	}
};

/* Used to parse a box without consuming its data, to allow detailled parsing
   Useful for boxes for which a write method is not yet implemented */
BoxParser.Box.prototype.parseDataAndRewind = function(stream) {
	this.data = stream.readUint8Array(this.size-this.hdr_size);
	// rewinding
	stream.position -= this.size-this.hdr_size;
};

BoxParser.FullBox.prototype.parseDataAndRewind = function(stream) {
	this.parseFullHeader(stream);
	this.data = stream.readUint8Array(this.size-this.hdr_size);
	// restore the header size as if the full header had not been parsed
	this.hdr_size -= 4;
	// rewinding
	stream.position -= this.size-this.hdr_size;
};

BoxParser.FullBox.prototype.parseFullHeader = function (stream) {
	this.version = stream.readUint8();
	this.flags = stream.readUint24();
	this.hdr_size += 4;
};

BoxParser.FullBox.prototype.parse = function (stream) {
	this.parseFullHeader(stream);
	this.data = stream.readUint8Array(this.size-this.hdr_size);
};

BoxParser.ContainerBox.prototype.parse = function(stream) {
	var ret;
	var box;
	while (stream.getPosition() < this.start+this.size) {
		ret = BoxParser.parseOneBox(stream, false, this.size - (stream.getPosition() - this.start));
		if (ret.code === BoxParser.OK) {
			box = ret.box;
			/* store the box in the 'boxes' array to preserve box order (for offset) but also store box in a property for more direct access */
			this.boxes.push(box);
			if (this.subBoxNames && this.subBoxNames.indexOf(box.type) != -1) {
				this[this.subBoxNames[this.subBoxNames.indexOf(box.type)]+"s"].push(box);
			} else {
				var box_type = box.type !== "uuid" ? box.type : box.uuid;
				if (this[box_type]) {
					Log.warn("Box of type "+box_type+" already stored in field of this type");
				} else {
					this[box_type] = box;
				}
			}
		} else {
			return;
		}
	}
};

BoxParser.Box.prototype.parseLanguage = function(stream) {
	this.language = stream.readUint16();
	var chars = [];
	chars[0] = (this.language>>10)&0x1F;
	chars[1] = (this.language>>5)&0x1F;
	chars[2] = (this.language)&0x1F;
	this.languageString = String.fromCharCode(chars[0]+0x60, chars[1]+0x60, chars[2]+0x60);
};

// file:src/parsing/sampleentries/sampleentry.js
BoxParser.SAMPLE_ENTRY_TYPE_VISUAL 		= "Visual";
BoxParser.SAMPLE_ENTRY_TYPE_AUDIO 		= "Audio";
BoxParser.SAMPLE_ENTRY_TYPE_HINT 		= "Hint";
BoxParser.SAMPLE_ENTRY_TYPE_METADATA 	= "Metadata";
BoxParser.SAMPLE_ENTRY_TYPE_SUBTITLE 	= "Subtitle";
BoxParser.SAMPLE_ENTRY_TYPE_SYSTEM 		= "System";
BoxParser.SAMPLE_ENTRY_TYPE_TEXT 		= "Text";

BoxParser.SampleEntry.prototype.parseHeader = function(stream) {
	stream.readUint8Array(6);
	this.data_reference_index = stream.readUint16();
	this.hdr_size += 8;
};

BoxParser.SampleEntry.prototype.parse = function(stream) {
	this.parseHeader(stream);
	this.data = stream.readUint8Array(this.size - this.hdr_size);
};

BoxParser.SampleEntry.prototype.parseDataAndRewind = function(stream) {
	this.parseHeader(stream);
	this.data = stream.readUint8Array(this.size - this.hdr_size);
	// restore the header size as if the sample entry header had not been parsed
	this.hdr_size -= 8;
	// rewinding
	stream.position -= this.size-this.hdr_size;
};

BoxParser.SampleEntry.prototype.parseFooter = function(stream) {
	BoxParser.ContainerBox.prototype.parse.call(this, stream);
};

// Base SampleEntry types with default parsing
BoxParser.createMediaSampleEntryCtor(BoxParser.SAMPLE_ENTRY_TYPE_HINT);
BoxParser.createMediaSampleEntryCtor(BoxParser.SAMPLE_ENTRY_TYPE_METADATA);
BoxParser.createMediaSampleEntryCtor(BoxParser.SAMPLE_ENTRY_TYPE_SUBTITLE);
BoxParser.createMediaSampleEntryCtor(BoxParser.SAMPLE_ENTRY_TYPE_SYSTEM);
BoxParser.createMediaSampleEntryCtor(BoxParser.SAMPLE_ENTRY_TYPE_TEXT);

//Base SampleEntry types for Audio and Video with specific parsing
BoxParser.createMediaSampleEntryCtor(BoxParser.SAMPLE_ENTRY_TYPE_VISUAL, function(stream) {
	var compressorname_length;
	this.parseHeader(stream);
	stream.readUint16();
	stream.readUint16();
	stream.readUint32Array(3);
	this.width = stream.readUint16();
	this.height = stream.readUint16();
	this.horizresolution = stream.readUint32();
	this.vertresolution = stream.readUint32();
	stream.readUint32();
	this.frame_count = stream.readUint16();
	compressorname_length = Math.min(31, stream.readUint8());
	this.compressorname = stream.readString(compressorname_length);
	if (compressorname_length < 31) {
		stream.readString(31 - compressorname_length);
	}
	this.depth = stream.readUint16();
	stream.readUint16();
	this.parseFooter(stream);
});

BoxParser.createMediaSampleEntryCtor(BoxParser.SAMPLE_ENTRY_TYPE_AUDIO, function(stream) {
	this.parseHeader(stream);
	stream.readUint32Array(2);
	this.channel_count = stream.readUint16();
	this.samplesize = stream.readUint16();
	stream.readUint16();
	stream.readUint16();
	this.samplerate = (stream.readUint32()/(1<<16));
	this.parseFooter(stream);
});

// Sample entries inheriting from Audio and Video
BoxParser.createSampleEntryCtor(BoxParser.SAMPLE_ENTRY_TYPE_VISUAL, "avc1");
BoxParser.createSampleEntryCtor(BoxParser.SAMPLE_ENTRY_TYPE_VISUAL, "avc2");
BoxParser.createSampleEntryCtor(BoxParser.SAMPLE_ENTRY_TYPE_VISUAL, "avc3");
BoxParser.createSampleEntryCtor(BoxParser.SAMPLE_ENTRY_TYPE_VISUAL, "avc4");
BoxParser.createSampleEntryCtor(BoxParser.SAMPLE_ENTRY_TYPE_VISUAL, "av01");
BoxParser.createSampleEntryCtor(BoxParser.SAMPLE_ENTRY_TYPE_VISUAL, "hvc1");
BoxParser.createSampleEntryCtor(BoxParser.SAMPLE_ENTRY_TYPE_VISUAL, "hev1");
BoxParser.createSampleEntryCtor(BoxParser.SAMPLE_ENTRY_TYPE_AUDIO, 	"mp4a");
BoxParser.createSampleEntryCtor(BoxParser.SAMPLE_ENTRY_TYPE_AUDIO, 	"ac-3");
BoxParser.createSampleEntryCtor(BoxParser.SAMPLE_ENTRY_TYPE_AUDIO, 	"ec-3");

// Encrypted sample entries
BoxParser.createEncryptedSampleEntryCtor(BoxParser.SAMPLE_ENTRY_TYPE_VISUAL, 	"encv");
BoxParser.createEncryptedSampleEntryCtor(BoxParser.SAMPLE_ENTRY_TYPE_AUDIO, 	"enca");
BoxParser.createEncryptedSampleEntryCtor(BoxParser.SAMPLE_ENTRY_TYPE_SUBTITLE, 	"encu");
BoxParser.createEncryptedSampleEntryCtor(BoxParser.SAMPLE_ENTRY_TYPE_SYSTEM, 	"encs");
BoxParser.createEncryptedSampleEntryCtor(BoxParser.SAMPLE_ENTRY_TYPE_TEXT, 		"enct");
BoxParser.createEncryptedSampleEntryCtor(BoxParser.SAMPLE_ENTRY_TYPE_METADATA, 	"encm");


// file:src/parsing/a1lx.js
BoxParser.createBoxCtor("a1lx", function(stream) {
	var large_size = stream.readUint8() & 1;
	var FieldLength = ((large_size & 1) + 1) * 16;
	this.layer_size = [];
	for (var i = 0; i < 3; i++) {
		if (FieldLength == 16) {
			this.layer_size[i] = stream.readUint16();
		} else {
			this.layer_size[i] = stream.readUint32();
		}
	}
});// file:src/parsing/a1op.js
BoxParser.createBoxCtor("a1op", function(stream) {
	this.op_index = stream.readUint8();
});// file:src/parsing/auxC.js
BoxParser.createFullBoxCtor("auxC", function(stream) {
	this.aux_type = stream.readCString();
	var aux_subtype_length = this.size - this.hdr_size - (this.aux_type.length + 1);
	this.aux_subtype = stream.readUint8Array(aux_subtype_length);
});// file:src/parsing/av1C.js
BoxParser.createBoxCtor("av1C", function(stream) {
	var tmp = stream.readUint8();
	if ((tmp >> 7) & 0x1 !== 1) {
		Log.error("av1C marker problem");
		return;
	}
	this.version = tmp & 0x7F;
	if (this.version !== 1) {
		Log.error("av1C version "+this.version+" not supported");
		return;
	}
	tmp = stream.readUint8();
	this.seq_profile = (tmp >> 5) & 0x7;
	this.seq_level_idx_0 = tmp & 0x1F;
	tmp = stream.readUint8();
	this.seq_tier_0 = (tmp >> 7) & 0x1;
	this.high_bitdepth = (tmp >> 6) & 0x1;
	this.twelve_bit = (tmp >> 5) & 0x1;
	this.monochrome = (tmp >> 4) & 0x1;
	this.chroma_subsampling_x = (tmp >> 3) & 0x1;
	this.chroma_subsampling_y = (tmp >> 2) & 0x1;
	this.chroma_sample_position = (tmp & 0x3);
	tmp = stream.readUint8();
	this.reserved_1 = (tmp >> 5) & 0x7;
	if (this.reserved_1 !== 0) {
		Log.error("av1C reserved_1 parsing problem");
		return;
	}
	this.initial_presentation_delay_present = (tmp >> 4) & 0x1;
	if (this.initial_presentation_delay_present === 1) {
		this.initial_presentation_delay_minus_one = (tmp & 0xF);
	} else {
		this.reserved_2 = (tmp & 0xF);
		if (this.reserved_2 !== 0) {
			Log.error("av1C reserved_2 parsing problem");
			return;
		}
	}

	var configOBUs_length = this.size - this.hdr_size - 4;
	this.configOBUs = stream.readUint8Array(configOBUs_length);
});

// file:src/parsing/avcC.js
BoxParser.createBoxCtor("avcC", function(stream) {
	var i;
	var toparse;
	this.configurationVersion = stream.readUint8();
	this.AVCProfileIndication = stream.readUint8();
	this.profile_compatibility = stream.readUint8();
	this.AVCLevelIndication = stream.readUint8();
	this.lengthSizeMinusOne = (stream.readUint8() & 0x3);
	this.nb_SPS_nalus = (stream.readUint8() & 0x1F);
	toparse = this.size - this.hdr_size - 6;
	this.SPS = [];
	for (i = 0; i < this.nb_SPS_nalus; i++) {
		this.SPS[i] = {};
		this.SPS[i].length = stream.readUint16();
		this.SPS[i].nalu = stream.readUint8Array(this.SPS[i].length);
		toparse -= 2+this.SPS[i].length;
	}
	this.nb_PPS_nalus = stream.readUint8();
	toparse--;
	this.PPS = [];
	for (i = 0; i < this.nb_PPS_nalus; i++) {
		this.PPS[i] = {};
		this.PPS[i].length = stream.readUint16();
		this.PPS[i].nalu = stream.readUint8Array(this.PPS[i].length);
		toparse -= 2+this.PPS[i].length;
	}
	if (toparse>0) {
		this.ext = stream.readUint8Array(toparse);
	}
});

// file:src/parsing/btrt.js
BoxParser.createBoxCtor("btrt", function(stream) {
	this.bufferSizeDB = stream.readUint32();
	this.maxBitrate = stream.readUint32();
	this.avgBitrate = stream.readUint32();
});

// file:src/parsing/clap.js
BoxParser.createBoxCtor("clap", function(stream) {
	this.cleanApertureWidthN = stream.readUint32();
	this.cleanApertureWidthD = stream.readUint32();
	this.cleanApertureHeightN = stream.readUint32();
	this.cleanApertureHeightD = stream.readUint32();
	this.horizOffN = stream.readUint32();
	this.horizOffD = stream.readUint32();
	this.vertOffN = stream.readUint32();
	this.vertOffD = stream.readUint32();
});// file:src/parsing/clli.js
BoxParser.createBoxCtor("clli", function(stream) {
	this.max_content_light_level = stream.readUint16();
    this.max_pic_average_light_level = stream.readUint16();
});

// file:src/parsing/co64.js
BoxParser.createFullBoxCtor("co64", function(stream) {
	var entry_count;
	var i;
	entry_count = stream.readUint32();
	this.chunk_offsets = [];
	if (this.version === 0) {
		for(i=0; i<entry_count; i++) {
			this.chunk_offsets.push(stream.readUint64());
		}
	}
});

// file:src/parsing/CoLL.js
BoxParser.createFullBoxCtor("CoLL", function(stream) {
	this.maxCLL = stream.readUint16();
    this.maxFALL = stream.readUint16();
});

// file:src/parsing/colr.js
BoxParser.createBoxCtor("colr", function(stream) {
	this.colour_type = stream.readString(4);
	if (this.colour_type === 'nclx') {
		this.colour_primaries = stream.readUint16();
		this.transfer_characteristics = stream.readUint16();
		this.matrix_coefficients = stream.readUint16();
		var tmp = stream.readUint8();
		this.full_range_flag = tmp >> 7;
	} else if (this.colour_type === 'rICC') {
		this.ICC_profile = stream.readUint8Array(this.size - 4);
	} else if (this.colour_type === 'prof') {
		this.ICC_profile = stream.readUint8Array(this.size - 4);
	}
});// file:src/parsing/cprt.js
BoxParser.createFullBoxCtor("cprt", function (stream) {
	this.parseLanguage(stream);
	this.notice = stream.readCString();
});

// file:src/parsing/cslg.js
BoxParser.createFullBoxCtor("cslg", function(stream) {
	if (this.version === 0) {
		this.compositionToDTSShift = stream.readInt32(); /* signed */
		this.leastDecodeToDisplayDelta = stream.readInt32(); /* signed */
		this.greatestDecodeToDisplayDelta = stream.readInt32(); /* signed */
		this.compositionStartTime = stream.readInt32(); /* signed */
		this.compositionEndTime = stream.readInt32(); /* signed */
	}
});

// file:src/parsing/ctts.js
BoxParser.createFullBoxCtor("ctts", function(stream) {
	var entry_count;
	var i;
	entry_count = stream.readUint32();
	this.sample_counts = [];
	this.sample_offsets = [];
	if (this.version === 0) {
		for(i=0; i<entry_count; i++) {
			this.sample_counts.push(stream.readUint32());
			/* some files are buggy and declare version=0 while using signed offsets.
			   The likelyhood of using the most significant bit in a 32-bits time offset is very low,
			   so using signed value here as well */
			   var value = stream.readInt32();
			   if (value < 0) {
			   		Log.warn("BoxParser", "ctts box uses negative values without using version 1");
			   }
			this.sample_offsets.push(value);
		}
	} else if (this.version == 1) {
		for(i=0; i<entry_count; i++) {
			this.sample_counts.push(stream.readUint32());
			this.sample_offsets.push(stream.readInt32()); /* signed */
		}
	}
});

// file:src/parsing/dac3.js
BoxParser.createBoxCtor("dac3", function(stream) {
	var tmp_byte1 = stream.readUint8();
	var tmp_byte2 = stream.readUint8();
	var tmp_byte3 = stream.readUint8();
	this.fscod = tmp_byte1 >> 6;
	this.bsid  = ((tmp_byte1 >> 1) & 0x1F);
	this.bsmod = ((tmp_byte1 & 0x1) <<  2) | ((tmp_byte2 >> 6) & 0x3);
	this.acmod = ((tmp_byte2 >> 3) & 0x7);
	this.lfeon = ((tmp_byte2 >> 2) & 0x1);
	this.bit_rate_code = (tmp_byte2 & 0x3) | ((tmp_byte3 >> 5) & 0x7);
});

// file:src/parsing/dec3.js
BoxParser.createBoxCtor("dec3", function(stream) {
	var tmp_16 = stream.readUint16();
	this.data_rate = tmp_16 >> 3;
	this.num_ind_sub = tmp_16 & 0x7;
	this.ind_subs = [];
	for (var i = 0; i < this.num_ind_sub+1; i++) {
		var ind_sub = {};
		this.ind_subs.push(ind_sub);
		var tmp_byte1 = stream.readUint8();
		var tmp_byte2 = stream.readUint8();
		var tmp_byte3 = stream.readUint8();
		ind_sub.fscod = tmp_byte1 >> 6;
		ind_sub.bsid  = ((tmp_byte1 >> 1) & 0x1F);
		ind_sub.bsmod = ((tmp_byte1 & 0x1) << 4) | ((tmp_byte2 >> 4) & 0xF);
		ind_sub.acmod = ((tmp_byte2 >> 1) & 0x7);
		ind_sub.lfeon = (tmp_byte2 & 0x1);
		ind_sub.num_dep_sub = ((tmp_byte3 >> 1) & 0xF);
		if (ind_sub.num_dep_sub > 0) {
			ind_sub.chan_loc = ((tmp_byte3 & 0x1) << 8) | stream.readUint8();
		}
	}
});

// file:src/parsing/dfLa.js
BoxParser.createFullBoxCtor("dfLa", function(stream) {
    var BLOCKTYPE_MASK = 0x7F;
    var LASTMETADATABLOCKFLAG_MASK = 0x80;

    var boxesFound = [];
    var knownBlockTypes = [
        "STREAMINFO",
        "PADDING",
        "APPLICATION",
        "SEEKTABLE",
        "VORBIS_COMMENT",
        "CUESHEET",
        "PICTURE",
        "RESERVED"
    ];

    // dfLa is a FullBox
    this.parseFullHeader(stream);

    // for (i=0; ; i++) { // to end of box
    do {
        var flagAndType = stream.readUint8();

        var type = Math.min(
            (flagAndType & BLOCKTYPE_MASK),
            (knownBlockTypes.length - 1)
        );

        // if this is a STREAMINFO block, read the true samplerate since this
        // can be different to the AudioSampleEntry samplerate.
        if (!(type)) {
            // read past all the other stuff
            stream.readUint8Array(13);

            // extract samplerate
            this.samplerate = (stream.readUint32() >> 12);

            // read to end of STREAMINFO
            stream.readUint8Array(20);
        } else {
            // not interested in other block types so just discard length bytes
            stream.readUint8Array(stream.readUint24());
        }

        boxesFound.push(knownBlockTypes[type]);

        if (!!(flagAndType & LASTMETADATABLOCKFLAG_MASK)) {
            break;
        }
    } while (true);

    this.numMetadataBlocks =
        boxesFound.length + " (" + boxesFound.join(", ") + ")";
});
// file:src/parsing/dimm.js
BoxParser.createBoxCtor("dimm", function(stream) {
	this.bytessent = stream.readUint64();
});

// file:src/parsing/dmax.js
BoxParser.createBoxCtor("dmax", function(stream) {
	this.time = stream.readUint32();
});

// file:src/parsing/dmed.js
BoxParser.createBoxCtor("dmed", function(stream) {
	this.bytessent = stream.readUint64();
});

// file:src/parsing/dref.js
BoxParser.createFullBoxCtor("dref", function(stream) {
	var ret;
	var box;
	this.entries = [];
	var entry_count = stream.readUint32();
	for (var i = 0; i < entry_count; i++) {
		ret = BoxParser.parseOneBox(stream, false, this.size - (stream.getPosition() - this.start));
		if (ret.code === BoxParser.OK) {
			box = ret.box;
			this.entries.push(box);
		} else {
			return;
		}
	}
});

// file:src/parsing/drep.js
BoxParser.createBoxCtor("drep", function(stream) {
	this.bytessent = stream.readUint64();
});

// file:src/parsing/elng.js
BoxParser.createFullBoxCtor("elng", function(stream) {
	this.extended_language = stream.readString(this.size-this.hdr_size);
});

// file:src/parsing/elst.js
BoxParser.createFullBoxCtor("elst", function(stream) {
	this.entries = [];
	var entry_count = stream.readUint32();
	for (var i = 0; i < entry_count; i++) {
		var entry = {};
		this.entries.push(entry);
		if (this.version === 1) {
			entry.segment_duration = stream.readUint64();
			entry.media_time = stream.readInt64();
		} else {
			entry.segment_duration = stream.readUint32();
			entry.media_time = stream.readInt32();
		}
		entry.media_rate_integer = stream.readInt16();
		entry.media_rate_fraction = stream.readInt16();
	}
});

// file:src/parsing/emsg.js
BoxParser.createFullBoxCtor("emsg", function(stream) {
	if (this.version == 1) {
		this.timescale 					= stream.readUint32();
		this.presentation_time 			= stream.readUint64();
		this.event_duration			 	= stream.readUint32();
		this.id 						= stream.readUint32();
		this.scheme_id_uri 				= stream.readCString();
		this.value 						= stream.readCString();
	} else {
		this.scheme_id_uri 				= stream.readCString();
		this.value 						= stream.readCString();
		this.timescale 					= stream.readUint32();
		this.presentation_time_delta 	= stream.readUint32();
		this.event_duration			 	= stream.readUint32();
		this.id 						= stream.readUint32();
	}
	var message_size = this.size - this.hdr_size - (4*4 + (this.scheme_id_uri.length+1) + (this.value.length+1));
	if (this.version == 1) {
		message_size -= 4;
	}
	this.message_data = stream.readUint8Array(message_size);
});

// file:src/parsing/esds.js
BoxParser.createFullBoxCtor("esds", function(stream) {
	var esd_data = stream.readUint8Array(this.size-this.hdr_size);
	if (typeof MPEG4DescriptorParser !== "undefined") {
		var esd_parser = new MPEG4DescriptorParser();
		this.esd = esd_parser.parseOneDescriptor(new DataStream(esd_data.buffer, 0, DataStream.BIG_ENDIAN));
	}
});

// file:src/parsing/fiel.js
BoxParser.createBoxCtor("fiel", function(stream) {
	this.fieldCount = stream.readUint8();
	this.fieldOrdering = stream.readUint8();
});

// file:src/parsing/frma.js
BoxParser.createBoxCtor("frma", function(stream) {
	this.data_format = stream.readString(4);
});

// file:src/parsing/ftyp.js
BoxParser.createBoxCtor("ftyp", function(stream) {
	var toparse = this.size - this.hdr_size;
	this.major_brand = stream.readString(4);
	this.minor_version = stream.readUint32();
	toparse -= 8;
	this.compatible_brands = [];
	var i = 0;
	while (toparse>=4) {
		this.compatible_brands[i] = stream.readString(4);
		toparse -= 4;
		i++;
	}
});

// file:src/parsing/hdlr.js
BoxParser.createFullBoxCtor("hdlr", function(stream) {
	if (this.version === 0) {
		stream.readUint32();
		this.handler = stream.readString(4);
		stream.readUint32Array(3);
		this.name = stream.readString(this.size-this.hdr_size-20);
		if (this.name[this.name.length-1]==='\0') {
			this.name = this.name.slice(0,-1);
		}
	}
});

// file:src/parsing/hvcC.js
BoxParser.createBoxCtor("hvcC", function(stream) {
	var i, j;
	var length;
	var tmp_byte;
	this.configurationVersion = stream.readUint8();
	tmp_byte = stream.readUint8();
	this.general_profile_space = tmp_byte >> 6;
	this.general_tier_flag = (tmp_byte & 0x20) >> 5;
	this.general_profile_idc = (tmp_byte & 0x1F);
	this.general_profile_compatibility = stream.readUint32();
	this.general_constraint_indicator = stream.readUint8Array(6);
	this.general_level_idc = stream.readUint8();
	this.min_spatial_segmentation_idc = stream.readUint16() & 0xFFF;
	this.parallelismType = (stream.readUint8() & 0x3);
	this.chroma_format_idc = (stream.readUint8() & 0x3);
	this.bit_depth_luma_minus8 = (stream.readUint8() & 0x7);
	this.bit_depth_chroma_minus8 = (stream.readUint8() & 0x7);
	this.avgFrameRate = stream.readUint16();
	tmp_byte = stream.readUint8();
	this.constantFrameRate = (tmp_byte >> 6);
	this.numTemporalLayers = (tmp_byte & 0XD) >> 3;
	this.temporalIdNested = (tmp_byte & 0X4) >> 2;
	this.lengthSizeMinusOne = (tmp_byte & 0X3);

	this.nalu_arrays = [];
	var numOfArrays = stream.readUint8();
	for (i = 0; i < numOfArrays; i++) {
		var nalu_array = [];
		this.nalu_arrays.push(nalu_array);
		tmp_byte = stream.readUint8();
		nalu_array.completeness = (tmp_byte & 0x80) >> 7;
		nalu_array.nalu_type = tmp_byte & 0x3F;
		var numNalus = stream.readUint16();
		for (j = 0; j < numNalus; j++) {
			var nalu = {};
			nalu_array.push(nalu);
			length = stream.readUint16();
			nalu.data   = stream.readUint8Array(length);
		}
	}
});

// file:src/parsing/iinf.js
BoxParser.createFullBoxCtor("iinf", function(stream) {
	var ret;
	if (this.version === 0) {
		this.entry_count = stream.readUint16();
	} else {
		this.entry_count = stream.readUint32();
	}
	this.item_infos = [];
	for (var i = 0; i < this.entry_count; i++) {
		ret = BoxParser.parseOneBox(stream, false, this.size - (stream.getPosition() - this.start));
		if (ret.code === BoxParser.OK) {
			if (ret.box.type !== "infe") {
				Log.error("BoxParser", "Expected 'infe' box, got "+ret.box.type);
			}
			this.item_infos[i] = ret.box;
		} else {
			return;
		}
	}
});

// file:src/parsing/iloc.js
BoxParser.createFullBoxCtor("iloc", function(stream) {
	var byte;
	byte = stream.readUint8();
	this.offset_size = (byte >> 4) & 0xF;
	this.length_size = byte & 0xF;
	byte = stream.readUint8();
	this.base_offset_size = (byte >> 4) & 0xF;
	if (this.version === 1 || this.version === 2) {
		this.index_size = byte & 0xF;
	} else {
		this.index_size = 0;
		// reserved = byte & 0xF;
	}
	this.items = [];
	var item_count = 0;
	if (this.version < 2) {
		item_count = stream.readUint16();
	} else if (this.version === 2) {
		item_count = stream.readUint32();
	} else {
		throw "version of iloc box not supported";
	}
	for (var i = 0; i < item_count; i++) {
		var item = {};
		this.items.push(item);
		if (this.version < 2) {
			item.item_ID = stream.readUint16();
		} else if (this.version === 2) {
			item.item_ID = stream.readUint16();
		} else {
			throw "version of iloc box not supported";
		}
		if (this.version === 1 || this.version === 2) {
			item.construction_method = (stream.readUint16() & 0xF);
		} else {
			item.construction_method = 0;
		}
		item.data_reference_index = stream.readUint16();
		switch(this.base_offset_size) {
			case 0:
				item.base_offset = 0;
				break;
			case 4:
				item.base_offset = stream.readUint32();
				break;
			case 8:
				item.base_offset = stream.readUint64();
				break;
			default:
				throw "Error reading base offset size";
		}
		var extent_count = stream.readUint16();
		item.extents = [];
		for (var j=0; j < extent_count; j++) {
			var extent = {};
			item.extents.push(extent);
			if (this.version === 1 || this.version === 2) {
				switch(this.index_size) {
					case 0:
						extent.extent_index = 0;
						break;
					case 4:
						extent.extent_index = stream.readUint32();
						break;
					case 8:
						extent.extent_index = stream.readUint64();
						break;
					default:
						throw "Error reading extent index";
				}
			}
			switch(this.offset_size) {
				case 0:
					extent.extent_offset = 0;
					break;
				case 4:
					extent.extent_offset = stream.readUint32();
					break;
				case 8:
					extent.extent_offset = stream.readUint64();
					break;
				default:
					throw "Error reading extent index";
			}
			switch(this.length_size) {
				case 0:
					extent.extent_length = 0;
					break;
				case 4:
					extent.extent_length = stream.readUint32();
					break;
				case 8:
					extent.extent_length = stream.readUint64();
					break;
				default:
					throw "Error reading extent index";
			}
		}
	}
});

// file:src/parsing/imir.js
BoxParser.createBoxCtor("imir", function(stream) {
	var tmp = stream.readUint8();
	this.reserved = tmp >> 7;
	this.axis = tmp & 1;
});// file:src/parsing/infe.js
BoxParser.createFullBoxCtor("infe", function(stream) {
	if (this.version === 0 || this.version === 1) {
		this.item_ID = stream.readUint16();
		this.item_protection_index = stream.readUint16();
		this.item_name = stream.readCString();
		this.content_type = stream.readCString();
		this.content_encoding = stream.readCString();
	}
	if (this.version === 1) {
		this.extension_type = stream.readString(4);
		Log.warn("BoxParser", "Cannot parse extension type");
		stream.seek(this.start+this.size);
		return;
	}
	if (this.version >= 2) {
		if (this.version === 2) {
			this.item_ID = stream.readUint16();
		} else if (this.version === 3) {
			this.item_ID = stream.readUint32();
		}
		this.item_protection_index = stream.readUint16();
		this.item_type = stream.readString(4);
		this.item_name = stream.readCString();
		if (this.item_type === "mime") {
			this.content_type = stream.readCString();
			this.content_encoding = stream.readCString();
		} else if (this.item_type === "uri ") {
			this.item_uri_type = stream.readCString();
		}
	}
});
// file:src/parsing/ipma.js
BoxParser.createFullBoxCtor("ipma", function(stream) {
	var i, j;
	entry_count = stream.readUint32();
	this.associations = [];
	for(i=0; i<entry_count; i++) {
		var item_assoc = {};
		this.associations.push(item_assoc);
		if (this.version < 1) {
			item_assoc.id = stream.readUint16();
		} else {
			item_assoc.id = stream.readUint32();
		}
		var association_count = stream.readUint8();
		item_assoc.props = [];
		for (j = 0; j < association_count; j++) {
			var tmp = stream.readUint8();
			var p = {};
			item_assoc.props.push(p);
			p.essential = ((tmp & 0x80) >> 7) === 1;
			if (this.flags & 0x1) {
				p.property_index = (tmp & 0x7F) << 8 | stream.readUint8();
			} else {
				p.property_index = (tmp & 0x7F);
			}
		}
	}
});

// file:src/parsing/iref.js
BoxParser.createFullBoxCtor("iref", function(stream) {
	var ret;
	var box;
	this.references = [];

	while (stream.getPosition() < this.start+this.size) {
		ret = BoxParser.parseOneBox(stream, true, this.size - (stream.getPosition() - this.start));
		if (ret.code === BoxParser.OK) {
			if (this.version === 0) {
				box = new BoxParser.SingleItemTypeReferenceBox(ret.type, ret.size, ret.hdr_size, ret.start);
			} else {
				box = new BoxParser.SingleItemTypeReferenceBoxLarge(ret.type, ret.size, ret.hdr_size, ret.start);
			}
			if (box.write === BoxParser.Box.prototype.write && box.type !== "mdat") {
				Log.warn("BoxParser", box.type+" box writing not yet implemented, keeping unparsed data in memory for later write");
				box.parseDataAndRewind(stream);
			}
			box.parse(stream);
			this.references.push(box);
		} else {
			return;
		}
	}
});
// file:src/parsing/irot.js
BoxParser.createBoxCtor("irot", function(stream) {
	this.angle = stream.readUint8() & 0x3;
});

// file:src/parsing/ispe.js
BoxParser.createFullBoxCtor("ispe", function(stream) {
	this.image_width = stream.readUint32();
	this.image_height = stream.readUint32();
});// file:src/parsing/kind.js
BoxParser.createFullBoxCtor("kind", function(stream) {
	this.schemeURI = stream.readCString();
	this.value = stream.readCString();
});
// file:src/parsing/leva.js
BoxParser.createFullBoxCtor("leva", function(stream) {
	var count = stream.readUint8();
	this.levels = [];
	for (var i = 0; i < count; i++) {
		var level = {};
		this.levels[i] = level;
		level.track_ID = stream.readUint32();
		var tmp_byte = stream.readUint8();
		level.padding_flag = tmp_byte >> 7;
		level.assignment_type = tmp_byte & 0x7F;
		switch (level.assignment_type) {
			case 0:
				level.grouping_type = stream.readString(4);
				break;
			case 1:
				level.grouping_type = stream.readString(4);
				level.grouping_type_parameter = stream.readUint32();
				break;
			case 2:
				break;
			case 3:
				break;
			case 4:
				level.sub_track_id = stream.readUint32();
				break;
			default:
				Log.warn("BoxParser", "Unknown leva assignement type");
		}
	}
});

// file:src/parsing/lsel.js
BoxParser.createBoxCtor("lsel", function(stream) {
	this.layer_id = stream.readUint16();
});// file:src/parsing/maxr.js
BoxParser.createBoxCtor("maxr", function(stream) {
	this.period = stream.readUint32();
	this.bytes = stream.readUint32();
});

// file:src/parsing/mdcv.js
BoxParser.createBoxCtor("mdcv", function(stream) {
    this.display_primaries = [];
    this.display_primaries[0] = {};
    this.display_primaries[0].x = stream.readUint16();
    this.display_primaries[0].y = stream.readUint16();
    this.display_primaries[1] = {};
    this.display_primaries[1].x = stream.readUint16();
    this.display_primaries[1].y = stream.readUint16();
    this.display_primaries[2] = {};
    this.display_primaries[2].x = stream.readUint16();
    this.display_primaries[2].y = stream.readUint16();
    this.white_point = {};
    this.white_point.x = stream.readUint16();
    this.white_point.y = stream.readUint16();
    this.max_display_mastering_luminance = stream.readUint32();
    this.min_display_mastering_luminance = stream.readUint32();
});

// file:src/parsing/mdhd.js
BoxParser.createFullBoxCtor("mdhd", function(stream) {
	if (this.version == 1) {
		this.creation_time = stream.readUint64();
		this.modification_time = stream.readUint64();
		this.timescale = stream.readUint32();
		this.duration = stream.readUint64();
	} else {
		this.creation_time = stream.readUint32();
		this.modification_time = stream.readUint32();
		this.timescale = stream.readUint32();
		this.duration = stream.readUint32();
	}
	this.parseLanguage(stream);
	stream.readUint16();
});

// file:src/parsing/mehd.js
BoxParser.createFullBoxCtor("mehd", function(stream) {
	if (this.flags & 0x1) {
		Log.warn("BoxParser", "mehd box incorrectly uses flags set to 1, converting version to 1");
		this.version = 1;
	}
	if (this.version == 1) {
		this.fragment_duration = stream.readUint64();
	} else {
		this.fragment_duration = stream.readUint32();
	}
});

// file:src/parsing/meta.js
BoxParser.createFullBoxCtor("meta", function(stream) {
	this.boxes = [];
	BoxParser.ContainerBox.prototype.parse.call(this, stream);
});
// file:src/parsing/mfhd.js
BoxParser.createFullBoxCtor("mfhd", function(stream) {
	this.sequence_number = stream.readUint32();
});

// file:src/parsing/mfro.js
BoxParser.createFullBoxCtor("mfro", function(stream) {
	this._size = stream.readUint32();
});

// file:src/parsing/mvhd.js
BoxParser.createFullBoxCtor("mvhd", function(stream) {
	if (this.version == 1) {
		this.creation_time = stream.readUint64();
		this.modification_time = stream.readUint64();
		this.timescale = stream.readUint32();
		this.duration = stream.readUint64();
	} else {
		this.creation_time = stream.readUint32();
		this.modification_time = stream.readUint32();
		this.timescale = stream.readUint32();
		this.duration = stream.readUint32();
	}
	this.rate = stream.readUint32();
	this.volume = stream.readUint16()>>8;
	stream.readUint16();
	stream.readUint32Array(2);
	this.matrix = stream.readUint32Array(9);
	stream.readUint32Array(6);
	this.next_track_id = stream.readUint32();
});
// file:src/parsing/npck.js
BoxParser.createBoxCtor("npck", function(stream) {
	this.packetssent = stream.readUint32();
});

// file:src/parsing/nump.js
BoxParser.createBoxCtor("nump", function(stream) {
	this.packetssent = stream.readUint64();
});

// file:src/parsing/padb.js
BoxParser.createFullBoxCtor("padb", function(stream) {
	var sample_count = stream.readUint32();
	this.padbits = [];
	for (var i = 0; i < Math.floor((sample_count+1)/2); i++) {
		this.padbits = stream.readUint8();
	}
});

// file:src/parsing/pasp.js
BoxParser.createBoxCtor("pasp", function(stream) {
	this.hSpacing = stream.readUint32();
	this.vSpacing = stream.readUint32();
});// file:src/parsing/payl.js
BoxParser.createBoxCtor("payl", function(stream) {
	this.text = stream.readString(this.size - this.hdr_size);
});

// file:src/parsing/payt.js
BoxParser.createBoxCtor("payt", function(stream) {
	this.payloadID = stream.readUint32();
	var count = stream.readUint8();
	this.rtpmap_string = stream.readString(count);
});

// file:src/parsing/pdin.js
BoxParser.createFullBoxCtor("pdin", function(stream) {
	var count = (this.size - this.hdr_size)/8;
	this.rate = [];
	this.initial_delay = [];
	for (var i = 0; i < count; i++) {
		this.rate[i] = stream.readUint32();
		this.initial_delay[i] = stream.readUint32();
	}
});

// file:src/parsing/pitm.js
BoxParser.createFullBoxCtor("pitm", function(stream) {
	if (this.version === 0) {
		this.item_id = stream.readUint16();
	} else {
		this.item_id = stream.readUint32();
	}
});

// file:src/parsing/pixi.js
BoxParser.createFullBoxCtor("pixi", function(stream) {
	var i;
	this.num_channels = stream.readUint8();
	this.bits_per_channels = [];
	for (i = 0; i < this.num_channels; i++) {
		this.bits_per_channels[i] = stream.readUint8();
	}
});

// file:src/parsing/pmax.js
BoxParser.createBoxCtor("pmax", function(stream) {
	this.bytes = stream.readUint32();
});

// file:src/parsing/prft.js
BoxParser.createFullBoxCtor("prft", function(stream) {
	this.ref_track_id = stream.readUint32();
	this.ntp_timestamp = stream.readUint64();
	if (this.version === 0) {
		this.media_time = stream.readUint32();
	} else {
		this.media_time = stream.readUint64();
	}
});

// file:src/parsing/pssh.js
BoxParser.createFullBoxCtor("pssh", function(stream) {
	this.system_id = BoxParser.parseHex16(stream);
	if (this.version > 0) {
		var count = stream.readUint32();
		this.kid = [];
		for (var i = 0; i < count; i++) {
			this.kid[i] = BoxParser.parseHex16(stream);
		}
	}
	var datasize = stream.readUint32();
	if (datasize > 0) {
		this.data = stream.readUint8Array(datasize);
	}
});

// file:src/parsing/qt/clef.js
BoxParser.createFullBoxCtor("clef", function(stream) {
	this.width = stream.readUint32();
	this.height = stream.readUint32();
});// file:src/parsing/qt/enof.js
BoxParser.createFullBoxCtor("enof", function(stream) {
	this.width = stream.readUint32();
	this.height = stream.readUint32();
});// file:src/parsing/qt/prof.js
BoxParser.createFullBoxCtor("prof", function(stream) {
	this.width = stream.readUint32();
	this.height = stream.readUint32();
});// file:src/parsing/qt/tapt.js
BoxParser.createContainerBoxCtor("tapt", null, [ "clef", "prof", "enof"]);// file:src/parsing/rtp.js
BoxParser.createBoxCtor("rtp ", function(stream) {
	this.descriptionformat = stream.readString(4);
	this.sdptext = stream.readString(this.size - this.hdr_size - 4);
});

// file:src/parsing/saio.js
BoxParser.createFullBoxCtor("saio", function(stream) {
	if (this.flags & 0x1) {
		this.aux_info_type = stream.readUint32();
		this.aux_info_type_parameter = stream.readUint32();
	}
	var count = stream.readUint32();
	this.offset = [];
	for (var i = 0; i < count; i++) {
		if (this.version === 0) {
			this.offset[i] = stream.readUint32();
		} else {
			this.offset[i] = stream.readUint64();
		}
	}
});
// file:src/parsing/saiz.js
BoxParser.createFullBoxCtor("saiz", function(stream) {
	if (this.flags & 0x1) {
		this.aux_info_type = stream.readUint32();
		this.aux_info_type_parameter = stream.readUint32();
	}
	this.default_sample_info_size = stream.readUint8();
	var count = stream.readUint32();
	this.sample_info_size = [];
	if (this.default_sample_info_size === 0) {
		for (var i = 0; i < count; i++) {
			this.sample_info_size[i] = stream.readUint8();
		}
	}
});

// file:src/parsing/sampleentries/mett.js
BoxParser.createSampleEntryCtor(BoxParser.SAMPLE_ENTRY_TYPE_METADATA, "mett", function(stream) {
	this.parseHeader(stream);
	this.content_encoding = stream.readCString();
	this.mime_format = stream.readCString();
	this.parseFooter(stream);
});

// file:src/parsing/sampleentries/metx.js
BoxParser.createSampleEntryCtor(BoxParser.SAMPLE_ENTRY_TYPE_METADATA, "metx", function(stream) {
	this.parseHeader(stream);
	this.content_encoding = stream.readCString();
	this.namespace = stream.readCString();
	this.schema_location = stream.readCString();
	this.parseFooter(stream);
});

// file:src/parsing/sampleentries/sbtt.js
BoxParser.createSampleEntryCtor(BoxParser.SAMPLE_ENTRY_TYPE_SUBTITLE, "sbtt", function(stream) {
	this.parseHeader(stream);
	this.content_encoding = stream.readCString();
	this.mime_format = stream.readCString();
	this.parseFooter(stream);
});

// file:src/parsing/sampleentries/stpp.js
BoxParser.createSampleEntryCtor(BoxParser.SAMPLE_ENTRY_TYPE_SUBTITLE, "stpp", function(stream) {
	this.parseHeader(stream);
	this.namespace = stream.readCString();
	this.schema_location = stream.readCString();
	this.auxiliary_mime_types = stream.readCString();
	this.parseFooter(stream);
});

// file:src/parsing/sampleentries/stxt.js
BoxParser.createSampleEntryCtor(BoxParser.SAMPLE_ENTRY_TYPE_SUBTITLE, "stxt", function(stream) {
	this.parseHeader(stream);
	this.content_encoding = stream.readCString();
	this.mime_format = stream.readCString();
	this.parseFooter(stream);
});

// file:src/parsing/sampleentries/tx3g.js
BoxParser.createSampleEntryCtor(BoxParser.SAMPLE_ENTRY_TYPE_SUBTITLE, "tx3g", function(stream) {
	this.parseHeader(stream);
	this.displayFlags = stream.readUint32();
	this.horizontal_justification = stream.readInt8();
	this.vertical_justification = stream.readInt8();
	this.bg_color_rgba = stream.readUint8Array(4);
	this.box_record = stream.readInt16Array(4);
	this.style_record = stream.readUint8Array(12);
	this.parseFooter(stream);
});
// file:src/parsing/sampleentries/wvtt.js
BoxParser.createSampleEntryCtor(BoxParser.SAMPLE_ENTRY_TYPE_METADATA, "wvtt", function(stream) {
	this.parseHeader(stream);
	this.parseFooter(stream);
});

// file:src/parsing/samplegroups/alst.js
BoxParser.createSampleGroupCtor("alst", function(stream) {
	var i;
	var roll_count = stream.readUint16();
	this.first_output_sample = stream.readUint16();
	this.sample_offset = [];
	for (i = 0; i < roll_count; i++) {
		this.sample_offset[i] = stream.readUint32();
	}
	var remaining = this.description_length - 4 - 4*roll_count;
	this.num_output_samples = [];
	this.num_total_samples = [];
	for (i = 0; i < remaining/4; i++) {
		this.num_output_samples[i] = stream.readUint16();
		this.num_total_samples[i] = stream.readUint16();
	}
});

// file:src/parsing/samplegroups/avll.js
BoxParser.createSampleGroupCtor("avll", function(stream) {
	this.layerNumber = stream.readUint8();
	this.accurateStatisticsFlag = stream.readUint8();
	this.avgBitRate = stream.readUint16();
	this.avgFrameRate = stream.readUint16();
});

// file:src/parsing/samplegroups/avss.js
BoxParser.createSampleGroupCtor("avss", function(stream) {
	this.subSequenceIdentifier = stream.readUint16();
	this.layerNumber = stream.readUint8();
	var tmp_byte = stream.readUint8();
	this.durationFlag = tmp_byte >> 7;
	this.avgRateFlag = (tmp_byte >> 6) & 0x1;
	if (this.durationFlag) {
		this.duration = stream.readUint32();
	}
	if (this.avgRateFlag) {
		this.accurateStatisticsFlag = stream.readUint8();
		this.avgBitRate = stream.readUint16();
		this.avgFrameRate = stream.readUint16();
	}
	this.dependency = [];
	var numReferences = stream.readUint8();
	for (var i = 0; i < numReferences; i++) {
		var dependencyInfo = {};
		this.dependency.push(dependencyInfo);
		dependencyInfo.subSeqDirectionFlag = stream.readUint8();
		dependencyInfo.layerNumber = stream.readUint8();
		dependencyInfo.subSequenceIdentifier = stream.readUint16();
	}
});

// file:src/parsing/samplegroups/dtrt.js
BoxParser.createSampleGroupCtor("dtrt", function(stream) {
	Log.warn("BoxParser", "Sample Group type: "+this.grouping_type+" not fully parsed");
});

// file:src/parsing/samplegroups/mvif.js
BoxParser.createSampleGroupCtor("mvif", function(stream) {
	Log.warn("BoxParser", "Sample Group type: "+this.grouping_type+" not fully parsed");
});

// file:src/parsing/samplegroups/prol.js
BoxParser.createSampleGroupCtor("prol", function(stream) {
	this.roll_distance = stream.readInt16();
});

// file:src/parsing/samplegroups/rap.js
BoxParser.createSampleGroupCtor("rap ", function(stream) {
	var tmp_byte = stream.readUint8();
	this.num_leading_samples_known = tmp_byte >> 7;
	this.num_leading_samples = tmp_byte & 0x7F;
});

// file:src/parsing/samplegroups/rash.js
BoxParser.createSampleGroupCtor("rash", function(stream) {
	this.operation_point_count = stream.readUint16();
	if (this.description_length !== 2+(this.operation_point_count === 1?2:this.operation_point_count*6)+9) {
		Log.warn("BoxParser", "Mismatch in "+this.grouping_type+" sample group length");
		this.data =  stream.readUint8Array(this.description_length-2);
	} else {
		if (this.operation_point_count === 1) {
			this.target_rate_share = stream.readUint16();
		} else {
			this.target_rate_share = [];
			this.available_bitrate = [];
			for (var i = 0; i < this.operation_point_count; i++) {
				this.available_bitrate[i] = stream.readUint32();
				this.target_rate_share[i] = stream.readUint16();
			}
		}
		this.maximum_bitrate = stream.readUint32();
		this.minimum_bitrate = stream.readUint32();
		this.discard_priority = stream.readUint8();
	}
});

// file:src/parsing/samplegroups/roll.js
BoxParser.createSampleGroupCtor("roll", function(stream) {
	this.roll_distance = stream.readInt16();
});

// file:src/parsing/samplegroups/samplegroup.js
BoxParser.SampleGroupEntry.prototype.parse = function(stream) {
	Log.warn("BoxParser", "Unknown Sample Group type: "+this.grouping_type);
	this.data =  stream.readUint8Array(this.description_length);
};

// file:src/parsing/samplegroups/scif.js
BoxParser.createSampleGroupCtor("scif", function(stream) {
	Log.warn("BoxParser", "Sample Group type: "+this.grouping_type+" not fully parsed");
});

// file:src/parsing/samplegroups/scnm.js
BoxParser.createSampleGroupCtor("scnm", function(stream) {
	Log.warn("BoxParser", "Sample Group type: "+this.grouping_type+" not fully parsed");
});

// file:src/parsing/samplegroups/seig.js
BoxParser.createSampleGroupCtor("seig", function(stream) {
	this.reserved = stream.readUint8();
	var tmp = stream.readUint8();
	this.crypt_byte_block = tmp >> 4;
	this.skip_byte_block = tmp & 0xF;
	this.isProtected = stream.readUint8();
	this.Per_Sample_IV_Size = stream.readUint8();
	this.KID = BoxParser.parseHex16(stream);
	this.constant_IV_size = 0;
	this.constant_IV = 0;
	if (this.isProtected === 1 && this.Per_Sample_IV_Size === 0) {
		this.constant_IV_size = stream.readUint8();
		this.constant_IV = stream.readUint8Array(this.constant_IV_size);
	}
});

// file:src/parsing/samplegroups/stsa.js
BoxParser.createSampleGroupCtor("stsa", function(stream) {
	Log.warn("BoxParser", "Sample Group type: "+this.grouping_type+" not fully parsed");
});

// file:src/parsing/samplegroups/sync.js
BoxParser.createSampleGroupCtor("sync", function(stream) {
	var tmp_byte = stream.readUint8();
	this.NAL_unit_type = tmp_byte & 0x3F;
});

// file:src/parsing/samplegroups/tele.js
BoxParser.createSampleGroupCtor("tele", function(stream) {
	var tmp_byte = stream.readUint8();
	this.level_independently_decodable = tmp_byte >> 7;
});

// file:src/parsing/samplegroups/tsas.js
BoxParser.createSampleGroupCtor("tsas", function(stream) {
	Log.warn("BoxParser", "Sample Group type: "+this.grouping_type+" not fully parsed");
});

// file:src/parsing/samplegroups/tscl.js
BoxParser.createSampleGroupCtor("tscl", function(stream) {
	Log.warn("BoxParser", "Sample Group type: "+this.grouping_type+" not fully parsed");
});

// file:src/parsing/samplegroups/vipr.js
BoxParser.createSampleGroupCtor("vipr", function(stream) {
	Log.warn("BoxParser", "Sample Group type: "+this.grouping_type+" not fully parsed");
});

// file:src/parsing/sbgp.js
BoxParser.createFullBoxCtor("sbgp", function(stream) {
	this.grouping_type = stream.readString(4);
	if (this.version === 1) {
		this.grouping_type_parameter = stream.readUint32();
	} else {
		this.grouping_type_parameter = 0;
	}
	this.entries = [];
	var entry_count = stream.readUint32();
	for (var i = 0; i < entry_count; i++) {
		var entry = {};
		this.entries.push(entry);
		entry.sample_count = stream.readInt32();
		entry.group_description_index = stream.readInt32();
	}
});

// file:src/parsing/schm.js
BoxParser.createFullBoxCtor("schm", function(stream) {
	this.scheme_type = stream.readString(4);
	this.scheme_version = stream.readUint32();
	if (this.flags & 0x000001) {
		this.scheme_uri = stream.readString(this.size - this.hdr_size - 8);
	}
});

// file:src/parsing/sdp.js
BoxParser.createBoxCtor("sdp ", function(stream) {
	this.sdptext = stream.readString(this.size - this.hdr_size);
});

// file:src/parsing/sdtp.js
BoxParser.createFullBoxCtor("sdtp", function(stream) {
	var tmp_byte;
	var count = (this.size - this.hdr_size);
	this.is_leading = [];
	this.sample_depends_on = [];
	this.sample_is_depended_on = [];
	this.sample_has_redundancy = [];
	for (var i = 0; i < count; i++) {
		tmp_byte = stream.readUint8();
		this.is_leading[i] = tmp_byte >> 6;
		this.sample_depends_on[i] = (tmp_byte >> 4) & 0x3;
		this.sample_is_depended_on[i] = (tmp_byte >> 2) & 0x3;
		this.sample_has_redundancy[i] = tmp_byte & 0x3;
	}
});

// file:src/parsing/senc.js
// Cannot be fully parsed because Per_Sample_IV_Size needs to be known
BoxParser.createFullBoxCtor("senc" /*, function(stream) {
	this.parseFullHeader(stream);
	var sample_count = stream.readUint32();
	this.samples = [];
	for (var i = 0; i < sample_count; i++) {
		var sample = {};
		// tenc.default_Per_Sample_IV_Size or seig.Per_Sample_IV_Size
		sample.InitializationVector = this.readUint8Array(Per_Sample_IV_Size*8);
		if (this.flags & 0x2) {
			sample.subsamples = [];
			subsample_count = stream.readUint16();
			for (var j = 0; j < subsample_count; j++) {
				var subsample = {};
				subsample.BytesOfClearData = stream.readUint16();
				subsample.BytesOfProtectedData = stream.readUint32();
				sample.subsamples.push(subsample);
			}
		}
		// TODO
		this.samples.push(sample);
	}
}*/);
// file:src/parsing/sgpd.js
BoxParser.createFullBoxCtor("sgpd", function(stream) {
	this.grouping_type = stream.readString(4);
	Log.debug("BoxParser", "Found Sample Groups of type "+this.grouping_type);
	if (this.version === 1) {
		this.default_length = stream.readUint32();
	} else {
		this.default_length = 0;
	}
	if (this.version >= 2) {
		this.default_group_description_index = stream.readUint32();
	}
	this.entries = [];
	var entry_count = stream.readUint32();
	for (var i = 0; i < entry_count; i++) {
		var entry;
		if (BoxParser[this.grouping_type+"SampleGroupEntry"]) {
			entry = new BoxParser[this.grouping_type+"SampleGroupEntry"](this.grouping_type);
		}  else {
			entry = new BoxParser.SampleGroupEntry(this.grouping_type);
		}
		this.entries.push(entry);
		if (this.version === 1) {
			if (this.default_length === 0) {
				entry.description_length = stream.readUint32();
			} else {
				entry.description_length = this.default_length;
			}
		} else {
			entry.description_length = this.default_length;
		}
		if (entry.write === BoxParser.SampleGroupEntry.prototype.write) {
			Log.info("BoxParser", "SampleGroup for type "+this.grouping_type+" writing not yet implemented, keeping unparsed data in memory for later write");
			// storing data
			entry.data = stream.readUint8Array(entry.description_length);
			// rewinding
			stream.position -= entry.description_length;
		}
		entry.parse(stream);
	}
});

// file:src/parsing/sidx.js
BoxParser.createFullBoxCtor("sidx", function(stream) {
	this.reference_ID = stream.readUint32();
	this.timescale = stream.readUint32();
	if (this.version === 0) {
		this.earliest_presentation_time = stream.readUint32();
		this.first_offset = stream.readUint32();
	} else {
		this.earliest_presentation_time = stream.readUint64();
		this.first_offset = stream.readUint64();
	}
	stream.readUint16();
	this.references = [];
	var count = stream.readUint16();
	for (var i = 0; i < count; i++) {
		var ref = {};
		this.references.push(ref);
		var tmp_32 = stream.readUint32();
		ref.reference_type = (tmp_32 >> 31) & 0x1;
		ref.referenced_size = tmp_32 & 0x7FFFFFFF;
		ref.subsegment_duration = stream.readUint32();
		tmp_32 = stream.readUint32();
		ref.starts_with_SAP = (tmp_32 >> 31) & 0x1;
		ref.SAP_type = (tmp_32 >> 28) & 0x7;
		ref.SAP_delta_time = tmp_32 & 0xFFFFFFF;
	}
});

// file:src/parsing/singleitemtypereference.js
BoxParser.SingleItemTypeReferenceBox = function(type, size, hdr_size, start) {
	BoxParser.Box.call(this, type, size);
	this.hdr_size = hdr_size;
	this.start = start;
};
BoxParser.SingleItemTypeReferenceBox.prototype = new BoxParser.Box();
BoxParser.SingleItemTypeReferenceBox.prototype.parse = function(stream) {
	this.from_item_ID = stream.readUint16();
	var count =  stream.readUint16();
	this.references = [];
	for(var i = 0; i < count; i++) {
		this.references[i] = stream.readUint16();
	}
};

// file:src/parsing/singleitemtypereferencelarge.js
BoxParser.SingleItemTypeReferenceBoxLarge = function(type, size, hdr_size, start) {
	BoxParser.Box.call(this, type, size);
	this.hdr_size = hdr_size;
	this.start = start;
};
BoxParser.SingleItemTypeReferenceBoxLarge.prototype = new BoxParser.Box();
BoxParser.SingleItemTypeReferenceBoxLarge.prototype.parse = function(stream) {
	this.from_item_ID = stream.readUint32();
	var count =  stream.readUint16();
	this.references = [];
	for(var i = 0; i < count; i++) {
		this.references[i] = stream.readUint32();
	}
};

// file:src/parsing/SmDm.js
BoxParser.createFullBoxCtor("SmDm", function(stream) {
	this.primaryRChromaticity_x = stream.readUint16();
    this.primaryRChromaticity_y = stream.readUint16();
    this.primaryGChromaticity_x = stream.readUint16();
    this.primaryGChromaticity_y = stream.readUint16();
    this.primaryBChromaticity_x = stream.readUint16();
    this.primaryBChromaticity_y = stream.readUint16();
    this.whitePointChromaticity_x = stream.readUint16();
    this.whitePointChromaticity_y = stream.readUint16();
    this.luminanceMax = stream.readUint32();
    this.luminanceMin = stream.readUint32();
});

// file:src/parsing/smhd.js
BoxParser.createFullBoxCtor("smhd", function(stream) {
	this.balance = stream.readUint16();
	stream.readUint16();
});

// file:src/parsing/ssix.js
BoxParser.createFullBoxCtor("ssix", function(stream) {
	this.subsegments = [];
	var subsegment_count = stream.readUint32();
	for (var i = 0; i < subsegment_count; i++) {
		var subsegment = {};
		this.subsegments.push(subsegment);
		subsegment.ranges = [];
		var range_count = stream.readUint32();
		for (var j = 0; j < range_count; j++) {
			var range = {};
			subsegment.ranges.push(range);
			range.level = stream.readUint8();
			range.range_size = stream.readUint24();
		}
	}
});

// file:src/parsing/stco.js
BoxParser.createFullBoxCtor("stco", function(stream) {
	var entry_count;
	entry_count = stream.readUint32();
	this.chunk_offsets = [];
	if (this.version === 0) {
		for (var i = 0; i < entry_count; i++) {
			this.chunk_offsets.push(stream.readUint32());
		}
	}
});

// file:src/parsing/stdp.js
BoxParser.createFullBoxCtor("stdp", function(stream) {
	var count = (this.size - this.hdr_size)/2;
	this.priority = [];
	for (var i = 0; i < count; i++) {
		this.priority[i] = stream.readUint16();
	}
});

// file:src/parsing/sthd.js
BoxParser.createFullBoxCtor("sthd");

// file:src/parsing/stri.js
BoxParser.createFullBoxCtor("stri", function(stream) {
	this.switch_group = stream.readUint16();
	this.alternate_group = stream.readUint16();
	this.sub_track_id = stream.readUint32();
	var count = (this.size - this.hdr_size - 8)/4;
	this.attribute_list = [];
	for (var i = 0; i < count; i++) {
		this.attribute_list[i] = stream.readUint32();
	}
});

// file:src/parsing/stsc.js
BoxParser.createFullBoxCtor("stsc", function(stream) {
	var entry_count;
	var i;
	entry_count = stream.readUint32();
	this.first_chunk = [];
	this.samples_per_chunk = [];
	this.sample_description_index = [];
	if (this.version === 0) {
		for(i=0; i<entry_count; i++) {
			this.first_chunk.push(stream.readUint32());
			this.samples_per_chunk.push(stream.readUint32());
			this.sample_description_index.push(stream.readUint32());
		}
	}
});

// file:src/parsing/stsd.js
BoxParser.createFullBoxCtor("stsd", function(stream) {
	var i;
	var ret;
	var entryCount;
	var box;
	this.entries = [];
	entryCount = stream.readUint32();
	for (i = 1; i <= entryCount; i++) {
		ret = BoxParser.parseOneBox(stream, true, this.size - (stream.getPosition() - this.start));
		if (ret.code === BoxParser.OK) {
			if (BoxParser[ret.type+"SampleEntry"]) {
				box = new BoxParser[ret.type+"SampleEntry"](ret.size);
				box.hdr_size = ret.hdr_size;
				box.start = ret.start;
			} else {
				Log.warn("BoxParser", "Unknown sample entry type: "+ret.type);
				box = new BoxParser.SampleEntry(ret.type, ret.size, ret.hdr_size, ret.start);
			}
			if (box.write === BoxParser.SampleEntry.prototype.write) {
				Log.info("BoxParser", "SampleEntry "+box.type+" box writing not yet implemented, keeping unparsed data in memory for later write");
				box.parseDataAndRewind(stream);
			}
			box.parse(stream);
			this.entries.push(box);
		} else {
			return;
		}
	}
});

// file:src/parsing/stsg.js
BoxParser.createFullBoxCtor("stsg", function(stream) {
	this.grouping_type = stream.readUint32();
	var count = stream.readUint16();
	this.group_description_index = [];
	for (var i = 0; i < count; i++) {
		this.group_description_index[i] = stream.readUint32();
	}
});

// file:src/parsing/stsh.js
BoxParser.createFullBoxCtor("stsh", function(stream) {
	var entry_count;
	var i;
	entry_count = stream.readUint32();
	this.shadowed_sample_numbers = [];
	this.sync_sample_numbers = [];
	if (this.version === 0) {
		for(i=0; i<entry_count; i++) {
			this.shadowed_sample_numbers.push(stream.readUint32());
			this.sync_sample_numbers.push(stream.readUint32());
		}
	}
});

// file:src/parsing/stss.js
BoxParser.createFullBoxCtor("stss", function(stream) {
	var i;
	var entry_count;
	entry_count = stream.readUint32();
	if (this.version === 0) {
		this.sample_numbers = [];
		for(i=0; i<entry_count; i++) {
			this.sample_numbers.push(stream.readUint32());
		}
	}
});

// file:src/parsing/stsz.js
BoxParser.createFullBoxCtor("stsz", function(stream) {
	var i;
	this.sample_sizes = [];
	if (this.version === 0) {
		this.sample_size = stream.readUint32();
		this.sample_count = stream.readUint32();
		for (i = 0; i < this.sample_count; i++) {
			if (this.sample_size === 0) {
				this.sample_sizes.push(stream.readUint32());
			} else {
				this.sample_sizes[i] = this.sample_size;
			}
		}
	}
});

// file:src/parsing/stts.js
BoxParser.createFullBoxCtor("stts", function(stream) {
	var entry_count;
	var i;
	var delta;
	entry_count = stream.readUint32();
	this.sample_counts = [];
	this.sample_deltas = [];
	if (this.version === 0) {
		for(i=0; i<entry_count; i++) {
			this.sample_counts.push(stream.readUint32());
			delta = stream.readInt32();
			if (delta < 0) {
				Log.warn("BoxParser", "File uses negative stts sample delta, using value 1 instead, sync may be lost!");
				delta = 1;
			}
			this.sample_deltas.push(delta);
		}
	}
});

// file:src/parsing/stvi.js
BoxParser.createFullBoxCtor("stvi", function(stream) {
	var tmp32 = stream.readUint32();
	this.single_view_allowed = tmp32 & 0x3;
	this.stereo_scheme = stream.readUint32();
	var length = stream.readUint32();
	this.stereo_indication_type = stream.readString(length);
	var ret;
	var box;
	this.boxes = [];
	while (stream.getPosition() < this.start+this.size) {
		ret = BoxParser.parseOneBox(stream, false, this.size - (stream.getPosition() - this.start));
		if (ret.code === BoxParser.OK) {
			box = ret.box;
			this.boxes.push(box);
			this[box.type] = box;
		} else {
			return;
		}
	}
});

// file:src/parsing/styp.js
BoxParser.createBoxCtor("styp", function(stream) {
	BoxParser.ftypBox.prototype.parse.call(this, stream);
});

// file:src/parsing/stz2.js
BoxParser.createFullBoxCtor("stz2", function(stream) {
	var i;
	var sample_count;
	this.sample_sizes = [];
	if (this.version === 0) {
		this.reserved = stream.readUint24();
		this.field_size = stream.readUint8();
		sample_count = stream.readUint32();
		if (this.field_size === 4) {
			for (i = 0; i < sample_count; i+=2) {
				var tmp = stream.readUint8();
				this.sample_sizes[i] = (tmp >> 4) & 0xF;
				this.sample_sizes[i+1] = tmp & 0xF;
			}
		} else if (this.field_size === 8) {
			for (i = 0; i < sample_count; i++) {
				this.sample_sizes[i] = stream.readUint8();
			}
		} else if (this.field_size === 16) {
			for (i = 0; i < sample_count; i++) {
				this.sample_sizes[i] = stream.readUint16();
			}
		} else {
			Log.error("BoxParser", "Error in length field in stz2 box");
		}
	}
});

// file:src/parsing/subs.js
BoxParser.createFullBoxCtor("subs", function(stream) {
	var i,j;
	var entry_count;
	var subsample_count;
	entry_count = stream.readUint32();
	this.entries = [];
	for (i = 0; i < entry_count; i++) {
		var sampleInfo = {};
		this.entries[i] = sampleInfo;
		sampleInfo.sample_delta = stream.readUint32();
		sampleInfo.subsamples = [];
		subsample_count = stream.readUint16();
		if (subsample_count>0) {
			for (j = 0; j < subsample_count; j++) {
				var subsample = {};
				sampleInfo.subsamples.push(subsample);
				if (this.version == 1) {
					subsample.size = stream.readUint32();
				} else {
					subsample.size = stream.readUint16();
				}
				subsample.priority = stream.readUint8();
				subsample.discardable = stream.readUint8();
				subsample.codec_specific_parameters = stream.readUint32();
			}
		}
	}
});

// file:src/parsing/tenc.js
BoxParser.createFullBoxCtor("tenc", function(stream) {
	stream.readUint8(); // reserved
	if (this.version === 0) {
		stream.readUint8();
	} else {
		var tmp = stream.readUint8();
		this.default_crypt_byte_block = (tmp >> 4) & 0xF;
		this.default_skip_byte_block = tmp & 0xF;
	}
	this.default_isProtected = stream.readUint8();
	this.default_Per_Sample_IV_Size = stream.readUint8();
	this.default_KID = BoxParser.parseHex16(stream);
	if (this.default_isProtected === 1 && this.default_Per_Sample_IV_Size === 0) {
		this.default_constant_IV_size = stream.readUint8();
		this.default_constant_IV = stream.readUint8Array(this.default_constant_IV_size);
	}
});// file:src/parsing/tfdt.js
BoxParser.createFullBoxCtor("tfdt", function(stream) {
	if (this.version == 1) {
		this.baseMediaDecodeTime = stream.readUint64();
	} else {
		this.baseMediaDecodeTime = stream.readUint32();
	}
});

// file:src/parsing/tfhd.js
BoxParser.createFullBoxCtor("tfhd", function(stream) {
	var readBytes = 0;
	this.track_id = stream.readUint32();
	if (this.size - this.hdr_size > readBytes && (this.flags & BoxParser.TFHD_FLAG_BASE_DATA_OFFSET)) {
		this.base_data_offset = stream.readUint64();
		readBytes += 8;
	} else {
		this.base_data_offset = 0;
	}
	if (this.size - this.hdr_size > readBytes && (this.flags & BoxParser.TFHD_FLAG_SAMPLE_DESC)) {
		this.default_sample_description_index = stream.readUint32();
		readBytes += 4;
	} else {
		this.default_sample_description_index = 0;
	}
	if (this.size - this.hdr_size > readBytes && (this.flags & BoxParser.TFHD_FLAG_SAMPLE_DUR)) {
		this.default_sample_duration = stream.readUint32();
		readBytes += 4;
	} else {
		this.default_sample_duration = 0;
	}
	if (this.size - this.hdr_size > readBytes && (this.flags & BoxParser.TFHD_FLAG_SAMPLE_SIZE)) {
		this.default_sample_size = stream.readUint32();
		readBytes += 4;
	} else {
		this.default_sample_size = 0;
	}
	if (this.size - this.hdr_size > readBytes && (this.flags & BoxParser.TFHD_FLAG_SAMPLE_FLAGS)) {
		this.default_sample_flags = stream.readUint32();
		readBytes += 4;
	} else {
		this.default_sample_flags = 0;
	}
});

// file:src/parsing/tfra.js
BoxParser.createFullBoxCtor("tfra", function(stream) {
	this.track_ID = stream.readUint32();
	stream.readUint24();
	var tmp_byte = stream.readUint8();
	this.length_size_of_traf_num = (tmp_byte >> 4) & 0x3;
	this.length_size_of_trun_num = (tmp_byte >> 2) & 0x3;
	this.length_size_of_sample_num = (tmp_byte) & 0x3;
	this.entries = [];
	var number_of_entries = stream.readUint32();
	for (var i = 0; i < number_of_entries; i++) {
		if (this.version === 1) {
			this.time = stream.readUint64();
			this.moof_offset = stream.readUint64();
		} else {
			this.time = stream.readUint32();
			this.moof_offset = stream.readUint32();
		}
		this.traf_number = stream["readUint"+(8*(this.length_size_of_traf_num+1))]();
		this.trun_number = stream["readUint"+(8*(this.length_size_of_trun_num+1))]();
		this.sample_number = stream["readUint"+(8*(this.length_size_of_sample_num+1))]();
	}
});

// file:src/parsing/tkhd.js
BoxParser.createFullBoxCtor("tkhd", function(stream) {
	if (this.version == 1) {
		this.creation_time = stream.readUint64();
		this.modification_time = stream.readUint64();
		this.track_id = stream.readUint32();
		stream.readUint32();
		this.duration = stream.readUint64();
	} else {
		this.creation_time = stream.readUint32();
		this.modification_time = stream.readUint32();
		this.track_id = stream.readUint32();
		stream.readUint32();
		this.duration = stream.readUint32();
	}
	stream.readUint32Array(2);
	this.layer = stream.readInt16();
	this.alternate_group = stream.readInt16();
	this.volume = stream.readInt16()>>8;
	stream.readUint16();
	this.matrix = stream.readInt32Array(9);
	this.width = stream.readUint32();
	this.height = stream.readUint32();
});

// file:src/parsing/tmax.js
BoxParser.createBoxCtor("tmax", function(stream) {
	this.time = stream.readUint32();
});

// file:src/parsing/tmin.js
BoxParser.createBoxCtor("tmin", function(stream) {
	this.time = stream.readUint32();
});

// file:src/parsing/totl.js
BoxParser.createBoxCtor("totl",function(stream) {
	this.bytessent = stream.readUint32();
});

// file:src/parsing/tpay.js
BoxParser.createBoxCtor("tpay", function(stream) {
	this.bytessent = stream.readUint32();
});

// file:src/parsing/tpyl.js
BoxParser.createBoxCtor("tpyl", function(stream) {
	this.bytessent = stream.readUint64();
});

// file:src/parsing/TrackGroup.js
BoxParser.TrackGroupTypeBox.prototype.parse = function(stream) {
	this.parseFullHeader(stream);
	this.track_group_id = stream.readUint32();
};

// file:src/parsing/trackgroups/msrc.js
BoxParser.createTrackGroupCtor("msrc");// file:src/parsing/TrakReference.js
BoxParser.TrackReferenceTypeBox = function(type, size, hdr_size, start) {
	BoxParser.Box.call(this, type, size);
	this.hdr_size = hdr_size;
	this.start = start;
};
BoxParser.TrackReferenceTypeBox.prototype = new BoxParser.Box();
BoxParser.TrackReferenceTypeBox.prototype.parse = function(stream) {
	this.track_ids = stream.readUint32Array((this.size-this.hdr_size)/4);
};

// file:src/parsing/tref.js
BoxParser.trefBox.prototype.parse = function(stream) {
	var ret;
	var box;
	while (stream.getPosition() < this.start+this.size) {
		ret = BoxParser.parseOneBox(stream, true, this.size - (stream.getPosition() - this.start));
		if (ret.code === BoxParser.OK) {
			box = new BoxParser.TrackReferenceTypeBox(ret.type, ret.size, ret.hdr_size, ret.start);
			if (box.write === BoxParser.Box.prototype.write && box.type !== "mdat") {
				Log.info("BoxParser", "TrackReference "+box.type+" box writing not yet implemented, keeping unparsed data in memory for later write");
				box.parseDataAndRewind(stream);
			}
			box.parse(stream);
			this.boxes.push(box);
		} else {
			return;
		}
	}
};

// file:src/parsing/trep.js
BoxParser.createFullBoxCtor("trep", function(stream) {
	this.track_ID = stream.readUint32();
	this.boxes = [];
	while (stream.getPosition() < this.start+this.size) {
		ret = BoxParser.parseOneBox(stream, false, this.size - (stream.getPosition() - this.start));
		if (ret.code === BoxParser.OK) {
			box = ret.box;
			this.boxes.push(box);
		} else {
			return;
		}
	}
});

// file:src/parsing/trex.js
BoxParser.createFullBoxCtor("trex", function(stream) {
	this.track_id = stream.readUint32();
	this.default_sample_description_index = stream.readUint32();
	this.default_sample_duration = stream.readUint32();
	this.default_sample_size = stream.readUint32();
	this.default_sample_flags = stream.readUint32();
});

// file:src/parsing/trpy.js
BoxParser.createBoxCtor("trpy", function(stream) {
	this.bytessent = stream.readUint64();
});

// file:src/parsing/trun.js
BoxParser.createFullBoxCtor("trun", function(stream) {
	var readBytes = 0;
	this.sample_count = stream.readUint32();
	readBytes+= 4;
	if (this.size - this.hdr_size > readBytes && (this.flags & BoxParser.TRUN_FLAGS_DATA_OFFSET) ) {
		this.data_offset = stream.readInt32(); //signed
		readBytes += 4;
	} else {
		this.data_offset = 0;
	}
	if (this.size - this.hdr_size > readBytes && (this.flags & BoxParser.TRUN_FLAGS_FIRST_FLAG) ) {
		this.first_sample_flags = stream.readUint32();
		readBytes += 4;
	} else {
		this.first_sample_flags = 0;
	}
	this.sample_duration = [];
	this.sample_size = [];
	this.sample_flags = [];
	this.sample_composition_time_offset = [];
	if (this.size - this.hdr_size > readBytes) {
		for (var i = 0; i < this.sample_count; i++) {
			if (this.flags & BoxParser.TRUN_FLAGS_DURATION) {
				this.sample_duration[i] = stream.readUint32();
			}
			if (this.flags & BoxParser.TRUN_FLAGS_SIZE) {
				this.sample_size[i] = stream.readUint32();
			}
			if (this.flags & BoxParser.TRUN_FLAGS_FLAGS) {
				this.sample_flags[i] = stream.readUint32();
			}
			if (this.flags & BoxParser.TRUN_FLAGS_CTS_OFFSET) {
				if (this.version === 0) {
					this.sample_composition_time_offset[i] = stream.readUint32();
				} else {
					this.sample_composition_time_offset[i] = stream.readInt32(); //signed
				}
			}
		}
	}
});

// file:src/parsing/tsel.js
BoxParser.createFullBoxCtor("tsel", function(stream) {
	this.switch_group = stream.readUint32();
	var count = (this.size - this.hdr_size - 4)/4;
	this.attribute_list = [];
	for (var i = 0; i < count; i++) {
		this.attribute_list[i] = stream.readUint32();
	}
});

// file:src/parsing/txtC.js
BoxParser.createFullBoxCtor("txtC", function(stream) {
	this.config = stream.readCString();
});

// file:src/parsing/url.js
BoxParser.createFullBoxCtor("url ", function(stream) {
	if (this.flags !== 0x000001) {
		this.location = stream.readCString();
	}
});

// file:src/parsing/urn.js
BoxParser.createFullBoxCtor("urn ", function(stream) {
	this.name = stream.readCString();
	if (this.size - this.hdr_size - this.name.length - 1 > 0) {
		this.location = stream.readCString();
	}
});

// file:src/parsing/uuid/piff/piffLsm.js
BoxParser.createUUIDBox("a5d40b30e81411ddba2f0800200c9a66", true, false, function(stream) {
    this.LiveServerManifest = stream.readString(this.size - this.hdr_size)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
});// file:src/parsing/uuid/piff/piffPssh.js
BoxParser.createUUIDBox("d08a4f1810f34a82b6c832d8aba183d3", true, false, function(stream) {
	this.system_id = BoxParser.parseHex16(stream);
	var datasize = stream.readUint32();
	if (datasize > 0) {
		this.data = stream.readUint8Array(datasize);
	}
});

// file:src/parsing/uuid/piff/piffSenc.js
BoxParser.createUUIDBox("a2394f525a9b4f14a2446c427c648df4", true, false /*, function(stream) {
	if (this.flags & 0x1) {
		this.AlgorithmID = stream.readUint24();
		this.IV_size = stream.readUint8();
		this.KID = BoxParser.parseHex16(stream);
	}
	var sample_count = stream.readUint32();
	this.samples = [];
	for (var i = 0; i < sample_count; i++) {
		var sample = {};
		sample.InitializationVector = this.readUint8Array(this.IV_size*8);
		if (this.flags & 0x2) {
			sample.subsamples = [];
			sample.NumberOfEntries = stream.readUint16();
			for (var j = 0; j < sample.NumberOfEntries; j++) {
				var subsample = {};
				subsample.BytesOfClearData = stream.readUint16();
				subsample.BytesOfProtectedData = stream.readUint32();
				sample.subsamples.push(subsample);
			}
		}
		this.samples.push(sample);
	}
}*/);
// file:src/parsing/uuid/piff/piffTenc.js
BoxParser.createUUIDBox("8974dbce7be74c5184f97148f9882554", true, false, function(stream) {
	this.default_AlgorithmID = stream.readUint24();
	this.default_IV_size = stream.readUint8();
	this.default_KID = BoxParser.parseHex16(stream);
});// file:src/parsing/uuid/piff/piffTfrf.js
BoxParser.createUUIDBox("d4807ef2ca3946958e5426cb9e46a79f", true, false, function(stream) {
    this.fragment_count = stream.readUint8();
    this.entries = [];

    for (var i = 0; i < this.fragment_count; i++) {
        var entry = {};
        var absolute_time = 0;
        var absolute_duration = 0;

        if (this.version === 1) {
            absolute_time = stream.readUint64();
            absolute_duration = stream.readUint64();
        } else {
            absolute_time = stream.readUint32();
            absolute_duration = stream.readUint32();
        }

        entry.absolute_time = absolute_time;
        entry.absolute_duration = absolute_duration;

        this.entries.push(entry);
    }
});// file:src/parsing/uuid/piff/piffTfxd.js
BoxParser.createUUIDBox("6d1d9b0542d544e680e2141daff757b2", true, false, function(stream) {
    if (this.version === 1) {
       this.absolute_time = stream.readUint64();
       this.duration = stream.readUint64();
    } else {
       this.absolute_time = stream.readUint32();
       this.duration = stream.readUint32();
    }
});// file:src/parsing/vmhd.js
BoxParser.createFullBoxCtor("vmhd", function(stream) {
	this.graphicsmode = stream.readUint16();
	this.opcolor = stream.readUint16Array(3);
});

// file:src/parsing/vpcC.js
BoxParser.createFullBoxCtor("vpcC", function (stream) {
	var tmp;
	if (this.version === 1) {
		this.profile = stream.readUint8();
		this.level = stream.readUint8();
		tmp = stream.readUint8();
		this.bitDepth = tmp >> 4;
		this.chromaSubsampling = (tmp >> 1) & 0x7;
		this.videoFullRangeFlag = tmp & 0x1;
		this.colourPrimaries = stream.readUint8();
		this.transferCharacteristics = stream.readUint8();
		this.matrixCoefficients = stream.readUint8();
		this.codecIntializationDataSize = stream.readUint16();
		this.codecIntializationData = stream.readUint8Array(this.codecIntializationDataSize);
	} else {
		this.profile = stream.readUint8();
		this.level = stream.readUint8();
		tmp = stream.readUint8();
		this.bitDepth = (tmp >> 4) & 0xF;
		this.colorSpace = tmp & 0xF;
		tmp = stream.readUint8();
		this.chromaSubsampling = (tmp >> 4) & 0xF;
		this.transferFunction = (tmp >> 1) & 0x7;
		this.videoFullRangeFlag = tmp & 0x1;
		this.codecIntializationDataSize = stream.readUint16();
		this.codecIntializationData = stream.readUint8Array(this.codecIntializationDataSize);
	}
});// file:src/parsing/vttC.js
BoxParser.createBoxCtor("vttC", function(stream) {
	this.text = stream.readString(this.size - this.hdr_size);
});

// file:src/box-codecs.js
BoxParser.SampleEntry.prototype.isVideo = function() {
	return false;
};

BoxParser.SampleEntry.prototype.isAudio = function() {
	return false;
};

BoxParser.SampleEntry.prototype.isSubtitle = function() {
	return false;
};

BoxParser.SampleEntry.prototype.isMetadata = function() {
	return false;
};

BoxParser.SampleEntry.prototype.isHint = function() {
	return false;
};

BoxParser.SampleEntry.prototype.getCodec = function() {
	return this.type.replace('.','');
};

BoxParser.SampleEntry.prototype.getWidth = function() {
	return "";
};

BoxParser.SampleEntry.prototype.getHeight = function() {
	return "";
};

BoxParser.SampleEntry.prototype.getChannelCount = function() {
	return "";
};

BoxParser.SampleEntry.prototype.getSampleRate = function() {
	return "";
};

BoxParser.SampleEntry.prototype.getSampleSize = function() {
	return "";
};

BoxParser.VisualSampleEntry.prototype.isVideo = function() {
	return true;
};

BoxParser.VisualSampleEntry.prototype.getWidth = function() {
	return this.width;
};

BoxParser.VisualSampleEntry.prototype.getHeight = function() {
	return this.height;
};

BoxParser.AudioSampleEntry.prototype.isAudio = function() {
	return true;
};

BoxParser.AudioSampleEntry.prototype.getChannelCount = function() {
	return this.channel_count;
};

BoxParser.AudioSampleEntry.prototype.getSampleRate = function() {
	return this.samplerate;
};

BoxParser.AudioSampleEntry.prototype.getSampleSize = function() {
	return this.samplesize;
};

BoxParser.SubtitleSampleEntry.prototype.isSubtitle = function() {
	return true;
};

BoxParser.MetadataSampleEntry.prototype.isMetadata = function() {
	return true;
};


BoxParser.decimalToHex = function(d, padding) {
	var hex = Number(d).toString(16);
	padding = typeof (padding) === "undefined" || padding === null ? padding = 2 : padding;
	while (hex.length < padding) {
		hex = "0" + hex;
	}
	return hex;
};

BoxParser.avc1SampleEntry.prototype.getCodec =
BoxParser.avc2SampleEntry.prototype.getCodec =
BoxParser.avc3SampleEntry.prototype.getCodec =
BoxParser.avc4SampleEntry.prototype.getCodec = function() {
	var baseCodec = BoxParser.SampleEntry.prototype.getCodec.call(this);
	if (this.avcC) {
		return baseCodec+"."+BoxParser.decimalToHex(this.avcC.AVCProfileIndication)+
						  ""+BoxParser.decimalToHex(this.avcC.profile_compatibility)+
						  ""+BoxParser.decimalToHex(this.avcC.AVCLevelIndication);
	} else {
		return baseCodec;
	}
};

BoxParser.hev1SampleEntry.prototype.getCodec =
BoxParser.hvc1SampleEntry.prototype.getCodec = function() {
	var i;
	var baseCodec = BoxParser.SampleEntry.prototype.getCodec.call(this);
	if (this.hvcC) {
		baseCodec += '.';
		switch (this.hvcC.general_profile_space) {
			case 0:
				baseCodec += '';
				break;
			case 1:
				baseCodec += 'A';
				break;
			case 2:
				baseCodec += 'B';
				break;
			case 3:
				baseCodec += 'C';
				break;
		}
		baseCodec += this.hvcC.general_profile_idc;
		baseCodec += '.';
		var val = this.hvcC.general_profile_compatibility;
		var reversed = 0;
		for (i=0; i<32; i++) {
			reversed |= val & 1;
			if (i==31) break;
			reversed <<= 1;
			val >>=1;
		}
		baseCodec += BoxParser.decimalToHex(reversed, 0);
		baseCodec += '.';
		if (this.hvcC.general_tier_flag === 0) {
			baseCodec += 'L';
		} else {
			baseCodec += 'H';
		}
		baseCodec += this.hvcC.general_level_idc;
		var hasByte = false;
		var constraint_string = "";
		for (i = 5; i >= 0; i--) {
			if (this.hvcC.general_constraint_indicator[i] || hasByte) {
				constraint_string = "."+BoxParser.decimalToHex(this.hvcC.general_constraint_indicator[i], 0)+constraint_string;
				hasByte = true;
			}
		}
		baseCodec += constraint_string;
	}
	return baseCodec;
};

BoxParser.mp4aSampleEntry.prototype.getCodec = function() {
	var baseCodec = BoxParser.SampleEntry.prototype.getCodec.call(this);
	if (this.esds && this.esds.esd) {
		var oti = this.esds.esd.getOTI();
		var dsi = this.esds.esd.getAudioConfig();
		return baseCodec+"."+BoxParser.decimalToHex(oti)+(dsi ? "."+dsi: "");
	} else {
		return baseCodec;
	}
};

BoxParser.stxtSampleEntry.prototype.getCodec = function() {
	var baseCodec = BoxParser.SampleEntry.prototype.getCodec.call(this);
	if(this.mime_format) {
		return baseCodec + "." + this.mime_format;
	} else {
		return baseCodec
	}
};

BoxParser.av01SampleEntry.prototype.getCodec = function() {
	var baseCodec = BoxParser.SampleEntry.prototype.getCodec.call(this);
	var bitdepth;
	if (this.av1C.seq_profile === 2 && this.av1C.high_bitdepth === 1) {
		bitdepth = (this.av1C.twelve_bit === 1) ? "12" : "10";
	} else if ( this.av1C.seq_profile <= 2 ) {
		bitdepth = (this.av1C.high_bitdepth === 1) ? "10" : "08";
	}
	// TODO need to parse the SH to find color config
	return baseCodec+"."+this.av1C.seq_profile+"."+this.av1C.seq_level_idx_0+(this.av1C.seq_tier_0?"H":"M")+"."+bitdepth;//+"."+this.av1C.monochrome+"."+this.av1C.chroma_subsampling_x+""+this.av1C.chroma_subsampling_y+""+this.av1C.chroma_sample_position;
};


// file:src/box-write.js
/* 
 * Copyright (c) Telecom ParisTech/TSI/MM/GPAC Cyril Concolato
 * License: BSD-3-Clause (see LICENSE file)
 */
BoxParser.Box.prototype.writeHeader = function(stream, msg) {
	this.size += 8;
	if (this.size > MAX_SIZE) {
		this.size += 8;
	}
	if (this.type === "uuid") {
		this.size += 16;
	}
	Log.debug("BoxWriter", "Writing box "+this.type+" of size: "+this.size+" at position "+stream.getPosition()+(msg || ""));
	if (this.size > MAX_SIZE) {
		stream.writeUint32(1);
	} else {
		this.sizePosition = stream.getPosition();
		stream.writeUint32(this.size);
	}
	stream.writeString(this.type, null, 4);
	if (this.type === "uuid") {
		stream.writeUint8Array(this.uuid);
	}
	if (this.size > MAX_SIZE) {
		stream.writeUint64(this.size);
	} 
};

BoxParser.FullBox.prototype.writeHeader = function(stream) {
	this.size += 4;
	BoxParser.Box.prototype.writeHeader.call(this, stream, " v="+this.version+" f="+this.flags);
	stream.writeUint8(this.version);
	stream.writeUint24(this.flags);
};

BoxParser.Box.prototype.write = function(stream) {
	if (this.type === "mdat") {
		/* TODO: fix this */
		if (this.data) {
			this.size = this.data.length;
			this.writeHeader(stream);
			stream.writeUint8Array(this.data);
		}
	} else {
		this.size = (this.data ? this.data.length : 0);
		this.writeHeader(stream);
		if (this.data) {
			stream.writeUint8Array(this.data);
		}
	}
};

BoxParser.ContainerBox.prototype.write = function(stream) {
	this.size = 0;
	this.writeHeader(stream);
	for (var i=0; i<this.boxes.length; i++) {
		if (this.boxes[i]) {
			this.boxes[i].write(stream);
			this.size += this.boxes[i].size;
		}
	}
	/* adjusting the size, now that all sub-boxes are known */
	Log.debug("BoxWriter", "Adjusting box "+this.type+" with new size "+this.size);
	stream.adjustUint32(this.sizePosition, this.size);
};

BoxParser.TrackReferenceTypeBox.prototype.write = function(stream) {
	this.size = this.track_ids.length*4;
	this.writeHeader(stream);
	stream.writeUint32Array(this.track_ids);
};

// file:src/writing/avcC.js
BoxParser.avcCBox.prototype.write = function(stream) {
	var i;
	this.size = 7;
	for (i = 0; i < this.SPS.length; i++) {
		this.size += 2+this.SPS[i].length;
	}
	for (i = 0; i < this.PPS.length; i++) {
		this.size += 2+this.PPS[i].length;
	}
	if (this.ext) {
		this.size += this.ext.length;
	}
	this.writeHeader(stream);
	stream.writeUint8(this.configurationVersion);
	stream.writeUint8(this.AVCProfileIndication);
	stream.writeUint8(this.profile_compatibility);
	stream.writeUint8(this.AVCLevelIndication);
	stream.writeUint8(this.lengthSizeMinusOne + (63<<2));
	stream.writeUint8(this.SPS.length + (7<<5));
	for (i = 0; i < this.SPS.length; i++) {
		stream.writeUint16(this.SPS[i].length);
		stream.writeUint8Array(this.SPS[i].nalu);
	}
	stream.writeUint8(this.PPS.length);
	for (i = 0; i < this.PPS.length; i++) {
		stream.writeUint16(this.PPS[i].length);
		stream.writeUint8Array(this.PPS[i].nalu);
	}
	if (this.ext) {
		stream.writeUint8Array(this.ext);
	}
};

// file:src/writing/co64.js
BoxParser.co64Box.prototype.write = function(stream) {
	var i;
	this.version = 0;
	this.flags = 0;
	this.size = 4+8*this.chunk_offsets.length;
	this.writeHeader(stream);
	stream.writeUint32(this.chunk_offsets.length);
	for(i=0; i<this.chunk_offsets.length; i++) {
		stream.writeUint64(this.chunk_offsets[i]);
	}
};

// file:src/writing/cslg.js
BoxParser.cslgBox.prototype.write = function(stream) {
	this.version = 0;
	this.flags = 0;
	this.size = 4*5;
	this.writeHeader(stream);
	stream.writeInt32(this.compositionToDTSShift);
	stream.writeInt32(this.leastDecodeToDisplayDelta);
	stream.writeInt32(this.greatestDecodeToDisplayDelta);
	stream.writeInt32(this.compositionStartTime);
	stream.writeInt32(this.compositionEndTime);
};

// file:src/writing/ctts.js
BoxParser.cttsBox.prototype.write = function(stream) {
	var i;
	this.version = 0;
	this.flags = 0;
	this.size = 4+8*this.sample_counts.length;
	this.writeHeader(stream);
	stream.writeUint32(this.sample_counts.length);
	for(i=0; i<this.sample_counts.length; i++) {
		stream.writeUint32(this.sample_counts[i]);
		if (this.version === 1) {
			stream.writeInt32(this.sample_offsets[i]); /* signed */
		} else {			
			stream.writeUint32(this.sample_offsets[i]); /* unsigned */
		}
	}
};

// file:src/writing/dref.js
BoxParser.drefBox.prototype.write = function(stream) {
	this.version = 0;
	this.flags = 0;
	this.size = 4; //
	this.writeHeader(stream);
	stream.writeUint32(this.entries.length);
	for (var i = 0; i < this.entries.length; i++) {
		this.entries[i].write(stream);
		this.size += this.entries[i].size;
	}	
	/* adjusting the size, now that all sub-boxes are known */
	Log.debug("BoxWriter", "Adjusting box "+this.type+" with new size "+this.size);
	stream.adjustUint32(this.sizePosition, this.size);
};

// file:src/writing/elng.js
BoxParser.elngBox.prototype.write = function(stream) {
	this.version = 0;	
	this.flags = 0;
	this.size = this.extended_language.length;
	this.writeHeader(stream);
	stream.writeString(this.extended_language);
};

// file:src/writing/elst.js
BoxParser.elstBox.prototype.write = function(stream) {
	this.version = 0;	
	this.flags = 0;
	this.size = 4+12*this.entries.length;
	this.writeHeader(stream);
	stream.writeUint32(this.entries.length);
	for (var i = 0; i < this.entries.length; i++) {
		var entry = this.entries[i];
		stream.writeUint32(entry.segment_duration);
		stream.writeInt32(entry.media_time);
		stream.writeInt16(entry.media_rate_integer);
		stream.writeInt16(entry.media_rate_fraction);
	}
};

// file:src/writing/emsg.js
BoxParser.emsgBox.prototype.write = function(stream) {
	this.version = 0;	
	this.flags = 0;
	this.size = 4*4+this.message_data.length+(this.scheme_id_uri.length+1)+(this.value.length+1);
	this.writeHeader(stream);
	stream.writeCString(this.scheme_id_uri);
	stream.writeCString(this.value);
	stream.writeUint32(this.timescale);
	stream.writeUint32(this.presentation_time_delta);
	stream.writeUint32(this.event_duration);
	stream.writeUint32(this.id);
	stream.writeUint8Array(this.message_data);
};

// file:src/writing/ftyp.js
BoxParser.ftypBox.prototype.write = function(stream) {
	this.size = 8+4*this.compatible_brands.length;
	this.writeHeader(stream);
	stream.writeString(this.major_brand, null, 4);
	stream.writeUint32(this.minor_version);
	for (var i = 0; i < this.compatible_brands.length; i++) {
		stream.writeString(this.compatible_brands[i], null, 4);
	}
};

// file:src/writing/hdlr.js
BoxParser.hdlrBox.prototype.write = function(stream) {
	this.size = 5*4+this.name.length+1;
	this.version = 0;
	this.flags = 0;
	this.writeHeader(stream);
	stream.writeUint32(0);
	stream.writeString(this.handler, null, 4);
	stream.writeUint32(0);
	stream.writeUint32(0);
	stream.writeUint32(0);
	stream.writeCString(this.name);
};

// file:src/writing/kind.js
BoxParser.kindBox.prototype.write = function(stream) {
	this.version = 0;	
	this.flags = 0;
	this.size = (this.schemeURI.length+1)+(this.value.length+1);
	this.writeHeader(stream);
	stream.writeCString(this.schemeURI);
	stream.writeCString(this.value);
};

// file:src/writing/mdhd.js
BoxParser.mdhdBox.prototype.write = function(stream) {
	this.size = 4*4+2*2;
	this.flags = 0;
	this.version = 0;
	this.writeHeader(stream);
	stream.writeUint32(this.creation_time);
	stream.writeUint32(this.modification_time);
	stream.writeUint32(this.timescale);
	stream.writeUint32(this.duration);
	stream.writeUint16(this.language);
	stream.writeUint16(0);
};

// file:src/writing/mehd.js
BoxParser.mehdBox.prototype.write = function(stream) {
	this.version = 0;
	this.flags = 0;
	this.size = 4;
	this.writeHeader(stream);
	stream.writeUint32(this.fragment_duration);
};

// file:src/writing/mfhd.js
BoxParser.mfhdBox.prototype.write = function(stream) {
	this.version = 0;
	this.flags = 0;
	this.size = 4;
	this.writeHeader(stream);
	stream.writeUint32(this.sequence_number);
};

// file:src/writing/mvhd.js
BoxParser.mvhdBox.prototype.write = function(stream) {
	this.version = 0;
	this.flags = 0;
	this.size = 23*4+2*2;
	this.writeHeader(stream);
	stream.writeUint32(this.creation_time);
	stream.writeUint32(this.modification_time);
	stream.writeUint32(this.timescale);
	stream.writeUint32(this.duration);
	stream.writeUint32(this.rate);
	stream.writeUint16(this.volume<<8);
	stream.writeUint16(0);
	stream.writeUint32(0);
	stream.writeUint32(0);
	stream.writeUint32Array(this.matrix);
	stream.writeUint32(0);
	stream.writeUint32(0);
	stream.writeUint32(0);
	stream.writeUint32(0);
	stream.writeUint32(0);
	stream.writeUint32(0);
	stream.writeUint32(this.next_track_id);
};

// file:src/writing/sampleentry.js
BoxParser.SampleEntry.prototype.writeHeader = function(stream) {
	this.size = 8;
	BoxParser.Box.prototype.writeHeader.call(this, stream);
	stream.writeUint8(0);
	stream.writeUint8(0);
	stream.writeUint8(0);
	stream.writeUint8(0);
	stream.writeUint8(0);
	stream.writeUint8(0);
	stream.writeUint16(this.data_reference_index);
};

BoxParser.SampleEntry.prototype.writeFooter = function(stream) {
	for (var i=0; i<this.boxes.length; i++) {
		this.boxes[i].write(stream);
		this.size += this.boxes[i].size;
	}
	Log.debug("BoxWriter", "Adjusting box "+this.type+" with new size "+this.size);
	stream.adjustUint32(this.sizePosition, this.size);	
};

BoxParser.SampleEntry.prototype.write = function(stream) {
	this.writeHeader(stream);
	stream.writeUint8Array(this.data);
	this.size += this.data.length;
	Log.debug("BoxWriter", "Adjusting box "+this.type+" with new size "+this.size);
	stream.adjustUint32(this.sizePosition, this.size);	
};

BoxParser.VisualSampleEntry.prototype.write = function(stream) {
	this.writeHeader(stream);
	this.size += 2*7+6*4+32;
	stream.writeUint16(0); 
	stream.writeUint16(0);
	stream.writeUint32(0);
	stream.writeUint32(0);
	stream.writeUint32(0);
	stream.writeUint16(this.width);
	stream.writeUint16(this.height);
	stream.writeUint32(this.horizresolution);
	stream.writeUint32(this.vertresolution);
	stream.writeUint32(0);
	stream.writeUint16(this.frame_count);
	stream.writeUint8(Math.min(31, this.compressorname.length));
	stream.writeString(this.compressorname, null, 31);
	stream.writeUint16(this.depth);
	stream.writeInt16(-1);
	this.writeFooter(stream);
};

BoxParser.AudioSampleEntry.prototype.write = function(stream) {
	this.writeHeader(stream);
	this.size += 2*4+3*4;
	stream.writeUint32(0);
	stream.writeUint32(0);
	stream.writeUint16(this.channel_count);
	stream.writeUint16(this.samplesize);
	stream.writeUint16(0);
	stream.writeUint16(0);
	stream.writeUint32(this.samplerate<<16);
	this.writeFooter(stream);
};

BoxParser.stppSampleEntry.prototype.write = function(stream) {
	this.writeHeader(stream);
	this.size += this.namespace.length+1+
				 this.schema_location.length+1+
				 this.auxiliary_mime_types.length+1;
	stream.writeCString(this.namespace);
	stream.writeCString(this.schema_location);
	stream.writeCString(this.auxiliary_mime_types);
	this.writeFooter(stream);
};

// file:src/writing/samplegroups/samplegroup.js
BoxParser.SampleGroupEntry.prototype.write = function(stream) {
	stream.writeUint8Array(this.data);
};

// file:src/writing/sbgp.js
BoxParser.sbgpBox.prototype.write = function(stream) {
	this.version = 1;	
	this.flags = 0;
	this.size = 12+8*this.entries.length;
	this.writeHeader(stream);
	stream.writeString(this.grouping_type, null, 4);
	stream.writeUint32(this.grouping_type_parameter);
	stream.writeUint32(this.entries.length);
	for (var i = 0; i < this.entries.length; i++) {
		var entry = this.entries[i];
		stream.writeInt32(entry.sample_count);
		stream.writeInt32(entry.group_description_index);
	}
};

// file:src/writing/sgpd.js
BoxParser.sgpdBox.prototype.write = function(stream) {
	var i;
	var entry;
	// leave version as read
	// this.version;
	this.flags = 0;
	this.size = 12;
	for (i = 0; i < this.entries.length; i++) {
		entry = this.entries[i];
		if (this.version === 1) {
			if (this.default_length === 0) {
				this.size += 4;
			}
			this.size += entry.data.length;
		}
	}
	this.writeHeader(stream);
	stream.writeString(this.grouping_type, null, 4);
	if (this.version === 1) {
		stream.writeUint32(this.default_length);
	}
	if (this.version >= 2) {
		stream.writeUint32(this.default_sample_description_index);
	}
	stream.writeUint32(this.entries.length);
	for (i = 0; i < this.entries.length; i++) {
		entry = this.entries[i];
		if (this.version === 1) {
			if (this.default_length === 0) {
				stream.writeUint32(entry.description_length);
			}
		}
		entry.write(stream);
	}
};


// file:src/writing/sidx.js
BoxParser.sidxBox.prototype.write = function(stream) {
	this.version = 0;	
	this.flags = 0;
	this.size = 4*4+2+2+12*this.references.length;
	this.writeHeader(stream);
	stream.writeUint32(this.reference_ID);
	stream.writeUint32(this.timescale);
	stream.writeUint32(this.earliest_presentation_time);
	stream.writeUint32(this.first_offset);
	stream.writeUint16(0);
	stream.writeUint16(this.references.length);
	for (var i = 0; i < this.references.length; i++) {
		var ref = this.references[i];
		stream.writeUint32(ref.reference_type << 31 | ref.referenced_size);
		stream.writeUint32(ref.subsegment_duration);
		stream.writeUint32(ref.starts_with_SAP << 31 | ref.SAP_type << 28 | ref.SAP_delta_time);
	}
};

// file:src/writing/stco.js
BoxParser.stcoBox.prototype.write = function(stream) {
	this.version = 0;
	this.flags = 0;
	this.size = 4+4*this.chunk_offsets.length;
	this.writeHeader(stream);
	stream.writeUint32(this.chunk_offsets.length);
	stream.writeUint32Array(this.chunk_offsets);
};

// file:src/writing/stsc.js
BoxParser.stscBox.prototype.write = function(stream) {
	var i;
	this.version = 0;
	this.flags = 0;
	this.size = 4+12*this.first_chunk.length;
	this.writeHeader(stream);
	stream.writeUint32(this.first_chunk.length);
	for(i=0; i<this.first_chunk.length; i++) {
		stream.writeUint32(this.first_chunk[i]);
		stream.writeUint32(this.samples_per_chunk[i]);
		stream.writeUint32(this.sample_description_index[i]);
	}
};

// file:src/writing/stsd.js
BoxParser.stsdBox.prototype.write = function(stream) {
	var i;
	this.version = 0;
	this.flags = 0;
	this.size = 0;
	this.writeHeader(stream);
	stream.writeUint32(this.entries.length);
	this.size += 4;
	for (i = 0; i < this.entries.length; i++) {
		this.entries[i].write(stream);
		this.size += this.entries[i].size;
	}
	/* adjusting the size, now that all sub-boxes are known */
	Log.debug("BoxWriter", "Adjusting box "+this.type+" with new size "+this.size);
	stream.adjustUint32(this.sizePosition, this.size);
};

// file:src/writing/stsh.js
BoxParser.stshBox.prototype.write = function(stream) {
	var i;
	this.version = 0;
	this.flags = 0;
	this.size = 4+8*this.shadowed_sample_numbers.length;
	this.writeHeader(stream);
	stream.writeUint32(this.shadowed_sample_numbers.length);
	for(i=0; i<this.shadowed_sample_numbers.length; i++) {
		stream.writeUint32(this.shadowed_sample_numbers[i]);
		stream.writeUint32(this.sync_sample_numbers[i]);
	}
};

// file:src/writing/stss.js
BoxParser.stssBox.prototype.write = function(stream) {
	this.version = 0;
	this.flags = 0;
	this.size = 4+4*this.sample_numbers.length;
	this.writeHeader(stream);
	stream.writeUint32(this.sample_numbers.length);
	stream.writeUint32Array(this.sample_numbers);
};

// file:src/writing/stsz.js
BoxParser.stszBox.prototype.write = function(stream) {
	var i;
	var constant = true;
	this.version = 0;
	this.flags = 0;
	if (this.sample_sizes.length > 0) {
		i = 0;
		while (i+1 < this.sample_sizes.length) {
			if (this.sample_sizes[i+1] !==  this.sample_sizes[0]) {
				constant = false;
				break;
			} else {
				i++;
			}
		}
	} else {
		constant = false;
	}
	this.size = 8;
	if (!constant) {
		this.size += 4*this.sample_sizes.length;
	}
	this.writeHeader(stream);
	if (!constant) {
		stream.writeUint32(0);
	} else {
		stream.writeUint32(this.sample_sizes[0]);
	}
	stream.writeUint32(this.sample_sizes.length);
	if (!constant) {
		stream.writeUint32Array(this.sample_sizes);
	}	
};

// file:src/writing/stts.js
BoxParser.sttsBox.prototype.write = function(stream) {
	var i;
	this.version = 0;
	this.flags = 0;
	this.size = 4+8*this.sample_counts.length;
	this.writeHeader(stream);
	stream.writeUint32(this.sample_counts.length);
	for(i=0; i<this.sample_counts.length; i++) {
		stream.writeUint32(this.sample_counts[i]);
		stream.writeUint32(this.sample_deltas[i]);
	}
};

// file:src/writing/tfdt.js
BoxParser.tfdtBox.prototype.write = function(stream) {
	var UINT32_MAX = Math.pow(2, 32) - 1;
	// use version 1 if baseMediaDecodeTime does not fit 32 bits
	this.version = this.baseMediaDecodeTime > UINT32_MAX ? 1 : 0;
	this.flags = 0;
	this.size = 4;
	if (this.version === 1) {
		this.size += 4;
	}
	this.writeHeader(stream);
	if (this.version === 1) {
		stream.writeUint64(this.baseMediaDecodeTime);
	} else {
		stream.writeUint32(this.baseMediaDecodeTime);
	}
};

// file:src/writing/tfhd.js
BoxParser.tfhdBox.prototype.write = function(stream) {
	this.version = 0;
	this.size = 4;
	if (this.flags & BoxParser.TFHD_FLAG_BASE_DATA_OFFSET) {
		this.size += 8;
	}
	if (this.flags & BoxParser.TFHD_FLAG_SAMPLE_DESC) {
		this.size += 4;
	}
	if (this.flags & BoxParser.TFHD_FLAG_SAMPLE_DUR) {
		this.size += 4;
	}
	if (this.flags & BoxParser.TFHD_FLAG_SAMPLE_SIZE) {
		this.size += 4;
	}
	if (this.flags & BoxParser.TFHD_FLAG_SAMPLE_FLAGS) {
		this.size += 4;
	}
	this.writeHeader(stream);
	stream.writeUint32(this.track_id);
	if (this.flags & BoxParser.TFHD_FLAG_BASE_DATA_OFFSET) {
		stream.writeUint64(this.base_data_offset);
	}
	if (this.flags & BoxParser.TFHD_FLAG_SAMPLE_DESC) {
		stream.writeUint32(this.default_sample_description_index);
	}
	if (this.flags & BoxParser.TFHD_FLAG_SAMPLE_DUR) {
		stream.writeUint32(this.default_sample_duration);
	}
	if (this.flags & BoxParser.TFHD_FLAG_SAMPLE_SIZE) {
		stream.writeUint32(this.default_sample_size);
	}
	if (this.flags & BoxParser.TFHD_FLAG_SAMPLE_FLAGS) {
		stream.writeUint32(this.default_sample_flags);
	}
};

// file:src/writing/tkhd.js
BoxParser.tkhdBox.prototype.write = function(stream) {
	this.version = 0;
	//this.flags = 0;
	this.size = 4*18+2*4;
	this.writeHeader(stream);
	stream.writeUint32(this.creation_time);
	stream.writeUint32(this.modification_time);
	stream.writeUint32(this.track_id);
	stream.writeUint32(0);
	stream.writeUint32(this.duration);
	stream.writeUint32(0);
	stream.writeUint32(0);
	stream.writeInt16(this.layer);
	stream.writeInt16(this.alternate_group);
	stream.writeInt16(this.volume<<8);
	stream.writeUint16(0);
	stream.writeInt32Array(this.matrix);
	stream.writeUint32(this.width);
	stream.writeUint32(this.height);
};

// file:src/writing/trex.js
BoxParser.trexBox.prototype.write = function(stream) {
	this.version = 0;
	this.flags = 0;
	this.size = 4*5;
	this.writeHeader(stream);
	stream.writeUint32(this.track_id);
	stream.writeUint32(this.default_sample_description_index);
	stream.writeUint32(this.default_sample_duration);
	stream.writeUint32(this.default_sample_size);
	stream.writeUint32(this.default_sample_flags);
};

// file:src/writing/trun.js
BoxParser.trunBox.prototype.write = function(stream) {
	this.version = 0;
	this.size = 4;
	if (this.flags & BoxParser.TRUN_FLAGS_DATA_OFFSET) {
		this.size += 4;
	}
	if (this.flags & BoxParser.TRUN_FLAGS_FIRST_FLAG) {
		this.size += 4;
	}
	if (this.flags & BoxParser.TRUN_FLAGS_DURATION) {
		this.size += 4*this.sample_duration.length;
	}
	if (this.flags & BoxParser.TRUN_FLAGS_SIZE) {
		this.size += 4*this.sample_size.length;
	}
	if (this.flags & BoxParser.TRUN_FLAGS_FLAGS) {
		this.size += 4*this.sample_flags.length;
	}
	if (this.flags & BoxParser.TRUN_FLAGS_CTS_OFFSET) {
		this.size += 4*this.sample_composition_time_offset.length;
	}
	this.writeHeader(stream);
	stream.writeUint32(this.sample_count);
	if (this.flags & BoxParser.TRUN_FLAGS_DATA_OFFSET) {
		this.data_offset_position = stream.getPosition();
		stream.writeInt32(this.data_offset); //signed
	}
	if (this.flags & BoxParser.TRUN_FLAGS_FIRST_FLAG) {
		stream.writeUint32(this.first_sample_flags);
	}
	for (var i = 0; i < this.sample_count; i++) {
		if (this.flags & BoxParser.TRUN_FLAGS_DURATION) {
			stream.writeUint32(this.sample_duration[i]);
		}
		if (this.flags & BoxParser.TRUN_FLAGS_SIZE) {
			stream.writeUint32(this.sample_size[i]);
		}
		if (this.flags & BoxParser.TRUN_FLAGS_FLAGS) {
			stream.writeUint32(this.sample_flags[i]);
		}
		if (this.flags & BoxParser.TRUN_FLAGS_CTS_OFFSET) {
			if (this.version === 0) {
				stream.writeUint32(this.sample_composition_time_offset[i]);
			} else {
				stream.writeInt32(this.sample_composition_time_offset[i]); //signed
			}
		}
	}		
};

// file:src/writing/url.js
BoxParser["url Box"].prototype.write = function(stream) {
	this.version = 0;	
	if (this.location) {
		this.flags = 0;
		this.size = this.location.length+1;
	} else {
		this.flags = 0x000001;
		this.size = 0;
	}
	this.writeHeader(stream);
	if (this.location) {
		stream.writeCString(this.location);
	}
};

// file:src/writing/urn.js
BoxParser["urn Box"].prototype.write = function(stream) {
	this.version = 0;	
	this.flags = 0;
	this.size = this.name.length+1+(this.location ? this.location.length+1 : 0);
	this.writeHeader(stream);
	stream.writeCString(this.name);
	if (this.location) {
		stream.writeCString(this.location);
	}
};

// file:src/writing/vmhd.js
BoxParser.vmhdBox.prototype.write = function(stream) {
	this.version = 0;
	this.flags = 1;
	this.size = 8;
	this.writeHeader(stream);
	stream.writeUint16(this.graphicsmode);
	stream.writeUint16Array(this.opcolor);
};

// file:src/box-unpack.js
/* 
 * Copyright (c) Telecom ParisTech/TSI/MM/GPAC Cyril Concolato
 * License: BSD-3-Clause (see LICENSE file)
 */
BoxParser.cttsBox.prototype.unpack = function(samples) {
	var i, j, k;
	k = 0;
	for (i = 0; i < this.sample_counts.length; i++) {
		for (j = 0; j < this.sample_counts[i]; j++) {
			samples[k].pts = samples[k].dts + this.sample_offsets[i];
			k++;
		}
	}
};

BoxParser.sttsBox.prototype.unpack = function(samples) {
	var i, j, k;
	k = 0;
	for (i = 0; i < this.sample_counts.length; i++) {
		for (j = 0; j < this.sample_counts[i]; j++) {
			if (k === 0) {
				samples[k].dts = 0;
			} else {
				samples[k].dts = samples[k-1].dts + this.sample_deltas[i];
			}
			k++;
		}
	}
};

BoxParser.stcoBox.prototype.unpack = function(samples) {
	var i;
	for (i = 0; i < this.chunk_offsets.length; i++) {
		samples[i].offset = this.chunk_offsets[i];
	}
};

BoxParser.stscBox.prototype.unpack = function(samples) {
	var i, j, k, l, m;
	l = 0;
	m = 0;
	for (i = 0; i < this.first_chunk.length; i++) {
		for (j = 0; j < (i+1 < this.first_chunk.length ? this.first_chunk[i+1] : Infinity); j++) {
			m++;
			for (k = 0; k < this.samples_per_chunk[i]; k++) {
				if (samples[l]) {
					samples[l].description_index = this.sample_description_index[i];
					samples[l].chunk_index = m;
				} else {
					return;
				}
				l++;
			}			
		}
	}
};

BoxParser.stszBox.prototype.unpack = function(samples) {
	var i;
	for (i = 0; i < this.sample_sizes.length; i++) {
		samples[i].size = this.sample_sizes[i];
	}
};
// file:src/box-diff.js

BoxParser.DIFF_BOXES_PROP_NAMES = [ "boxes", "entries", "references", "subsamples",
					 	 "items", "item_infos", "extents", "associations",
					 	 "subsegments", "ranges", "seekLists", "seekPoints",
					 	 "esd", "levels"];

BoxParser.DIFF_PRIMITIVE_ARRAY_PROP_NAMES = [ "compatible_brands", "matrix", "opcolor", "sample_counts", "sample_counts", "sample_deltas",
"first_chunk", "samples_per_chunk", "sample_sizes", "chunk_offsets", "sample_offsets", "sample_description_index", "sample_duration" ];

BoxParser.boxEqualFields = function(box_a, box_b) {
	if (box_a && !box_b) return false;
	var prop;
	for (prop in box_a) {
		if (BoxParser.DIFF_BOXES_PROP_NAMES.indexOf(prop) > -1) {
			continue;
		// } else if (excluded_fields && excluded_fields.indexOf(prop) > -1) {
		// 	continue;
		} else if (box_a[prop] instanceof BoxParser.Box || box_b[prop] instanceof BoxParser.Box) {
			continue;
		} else if (typeof box_a[prop] === "undefined" || typeof box_b[prop] === "undefined") {
			continue;
		} else if (typeof box_a[prop] === "function" || typeof box_b[prop] === "function") {
			continue;
		} else if (
			(box_a.subBoxNames && box_a.subBoxNames.indexOf(prop.slice(0,4)) > -1) ||
			(box_b.subBoxNames && box_b.subBoxNames.indexOf(prop.slice(0,4)) > -1))  {
			continue;
		} else {
			if (prop === "data" || prop === "start" || prop === "size" || prop === "creation_time" || prop === "modification_time") {
				continue;
			} else if (BoxParser.DIFF_PRIMITIVE_ARRAY_PROP_NAMES.indexOf(prop) > -1) {
				continue;
			} else {
				if (box_a[prop] !== box_b[prop]) {
					return false;
				}
			}
		}
	}
	return true;
};

BoxParser.boxEqual = function(box_a, box_b) {
	if (!BoxParser.boxEqualFields(box_a, box_b)) {
		return false;
	}
	for (var j = 0; j < BoxParser.DIFF_BOXES_PROP_NAMES.length; j++) {
		var name = BoxParser.DIFF_BOXES_PROP_NAMES[j];
		if (box_a[name] && box_b[name]) {
			if (!BoxParser.boxEqual(box_a[name], box_b[name])) {
				return false;
			}
		}
	}
	return true;
};// file:src/text-mp4.js

var XMLSubtitlein4Parser = function() {	
};

XMLSubtitlein4Parser.prototype.parseSample = function(sample) {
	var res = {};	
	var i;
	res.resources = [];
	var stream = new MP4BoxStream(sample.data.buffer);
	if (!sample.subsamples || sample.subsamples.length === 0) {
		res.documentString = stream.readString(sample.data.length);
	} else {
		res.documentString = stream.readString(sample.subsamples[0].size);
		if (sample.subsamples.length > 1) {
			for (i = 1; i < sample.subsamples.length; i++) {
				res.resources[i] = stream.readUint8Array(sample.subsamples[i].size);
			}
		}
	}
	if (typeof (DOMParser) !== "undefined") {
		res.document = (new DOMParser()).parseFromString(res.documentString, "application/xml");
	}
	return res;
};

var Textin4Parser = function() {	
};

Textin4Parser.prototype.parseSample = function(sample) {
	var textString;
	var stream = new MP4BoxStream(sample.data.buffer);
	textString = stream.readString(sample.data.length);
	return textString;
};

Textin4Parser.prototype.parseConfig = function(data) {
	var textString;
	var stream = new MP4BoxStream(data.buffer);
	stream.readUint32(); // version & flags
	textString = stream.readCString();
	return textString;
};

{
	exports.XMLSubtitlein4Parser = XMLSubtitlein4Parser;
	exports.Textin4Parser = Textin4Parser;
}
// file:src/isofile.js
/*
 * Copyright (c) 2012-2013. Telecom ParisTech/TSI/MM/GPAC Cyril Concolato
 * License: BSD-3-Clause (see LICENSE file)
 */
var ISOFile = function (stream) {
	/* MutiBufferStream object used to parse boxes */
	this.stream = stream || new MultiBufferStream();
	/* Array of all boxes (in order) found in the file */
	this.boxes = [];
	/* Array of all mdats */
	this.mdats = [];
	/* Array of all moofs */
	this.moofs = [];
	/* Boolean indicating if the file is compatible with progressive parsing (moov first) */
	this.isProgressive = false;
	/* Boolean used to fire moov start event only once */
	this.moovStartFound = false;
	/* Callback called when the moov parsing starts */
	this.onMoovStart = null;
	/* Boolean keeping track of the call to onMoovStart, to avoid double calls */
	this.moovStartSent = false;
	/* Callback called when the moov is entirely parsed */
	this.onReady = null;
	/* Boolean keeping track of the call to onReady, to avoid double calls */
	this.readySent = false;
	/* Callback to call when segments are ready */
	this.onSegment = null;
	/* Callback to call when samples are ready */
	this.onSamples = null;
	/* Callback to call when there is an error in the parsing or processing of samples */
	this.onError = null;
	/* Boolean indicating if the moov box run-length encoded tables of sample information have been processed */
	this.sampleListBuilt = false;
	/* Array of Track objects for which fragmentation of samples is requested */
	this.fragmentedTracks = [];
	/* Array of Track objects for which extraction of samples is requested */
	this.extractedTracks = [];
	/* Boolean indicating that fragmention is ready */
	this.isFragmentationInitialized = false;
	/* Boolean indicating that fragmented has started */
	this.sampleProcessingStarted = false;
	/* Number of the next 'moof' to generate when fragmenting */
	this.nextMoofNumber = 0;
	/* Boolean indicating if the initial list of items has been produced */
	this.itemListBuilt = false;
	/* Callback called when the sidx box is entirely parsed */
	this.onSidx = null;
	/* Boolean keeping track of the call to onSidx, to avoid double calls */
	this.sidxSent = false;
};

ISOFile.prototype.setSegmentOptions = function(id, user, options) {
	var trak = this.getTrackById(id);
	if (trak) {
		var fragTrack = {};
		this.fragmentedTracks.push(fragTrack);
		fragTrack.id = id;
		fragTrack.user = user;
		fragTrack.trak = trak;
		trak.nextSample = 0;
		fragTrack.segmentStream = null;
		fragTrack.nb_samples = 1000;
		fragTrack.rapAlignement = true;
		if (options) {
			if (options.nbSamples) fragTrack.nb_samples = options.nbSamples;
			if (options.rapAlignement) fragTrack.rapAlignement = options.rapAlignement;
		}
	}
};

ISOFile.prototype.unsetSegmentOptions = function(id) {
	var index = -1;
	for (var i = 0; i < this.fragmentedTracks.length; i++) {
		var fragTrack = this.fragmentedTracks[i];
		if (fragTrack.id == id) {
			index = i;
		}
	}
	if (index > -1) {
		this.fragmentedTracks.splice(index, 1);
	}
};

ISOFile.prototype.setExtractionOptions = function(id, user, options) {
	var trak = this.getTrackById(id);
	if (trak) {
		var extractTrack = {};
		this.extractedTracks.push(extractTrack);
		extractTrack.id = id;
		extractTrack.user = user;
		extractTrack.trak = trak;
		trak.nextSample = 0;
		extractTrack.nb_samples = 1000;
		extractTrack.samples = [];
		if (options) {
			if (options.nbSamples) extractTrack.nb_samples = options.nbSamples;
		}
	}
};

ISOFile.prototype.unsetExtractionOptions = function(id) {
	var index = -1;
	for (var i = 0; i < this.extractedTracks.length; i++) {
		var extractTrack = this.extractedTracks[i];
		if (extractTrack.id == id) {
			index = i;
		}
	}
	if (index > -1) {
		this.extractedTracks.splice(index, 1);
	}
};

ISOFile.prototype.parse = function() {
	var ret;
	var box;
	var parseBoxHeadersOnly = false;

	if (this.restoreParsePosition)	{
		if (!this.restoreParsePosition()) {
			return;
		}
	}

	while (true) {

		if (this.hasIncompleteMdat && this.hasIncompleteMdat()) {
			if (this.processIncompleteMdat()) {
				continue;
			} else {
				return;
			}
		} else {
			if (this.saveParsePosition)	{
				this.saveParsePosition();
			}
			ret = BoxParser.parseOneBox(this.stream, parseBoxHeadersOnly);
			if (ret.code === BoxParser.ERR_NOT_ENOUGH_DATA) {
				if (this.processIncompleteBox) {
					if (this.processIncompleteBox(ret)) {
						continue;
					} else {
						return;
					}
				} else {
					return;
				}
			} else {
				var box_type;
				/* the box is entirely parsed */
				box = ret.box;
				box_type = (box.type !== "uuid" ? box.type : box.uuid);
				/* store the box in the 'boxes' array to preserve box order (for file rewrite if needed)  */
				this.boxes.push(box);
				/* but also store box in a property for more direct access */
				switch (box_type) {
					case "mdat":
						this.mdats.push(box);
						break;
					case "moof":
						this.moofs.push(box);
						break;
					case "moov":
						this.moovStartFound = true;
						if (this.mdats.length === 0) {
							this.isProgressive = true;
						}
						/* no break */
						/* falls through */
					default:
						if (this[box_type] !== undefined) {
							Log.warn("ISOFile", "Duplicate Box of type: "+box_type+", overriding previous occurrence");
						}
						this[box_type] = box;
						break;
				}
				if (this.updateUsedBytes) {
					this.updateUsedBytes(box, ret);
				}
			}
		}
	}
};

ISOFile.prototype.checkBuffer = function (ab) {
	if (ab === null || ab === undefined) {
		throw("Buffer must be defined and non empty");
	}
	if (ab.fileStart === undefined) {
		throw("Buffer must have a fileStart property");
	}
	if (ab.byteLength === 0) {
		Log.warn("ISOFile", "Ignoring empty buffer (fileStart: "+ab.fileStart+")");
		this.stream.logBufferLevel();
		return false;
	}
	Log.info("ISOFile", "Processing buffer (fileStart: "+ab.fileStart+")");

	/* mark the bytes in the buffer as not being used yet */
	ab.usedBytes = 0;
	this.stream.insertBuffer(ab);
	this.stream.logBufferLevel();

	if (!this.stream.initialized()) {
		Log.warn("ISOFile", "Not ready to start parsing");
		return false;
	}
	return true;
};

/* Processes a new ArrayBuffer (with a fileStart property)
   Returns the next expected file position, or undefined if not ready to parse */
ISOFile.prototype.appendBuffer = function(ab, last) {
	var nextFileStart;
	if (!this.checkBuffer(ab)) {
		return;
	}

	/* Parse whatever is in the existing buffers */
	this.parse();

	/* Check if the moovStart callback needs to be called */
	if (this.moovStartFound && !this.moovStartSent) {
		this.moovStartSent = true;
		if (this.onMoovStart) this.onMoovStart();
	}

	if (this.moov) {
		/* A moov box has been entirely parsed */

		/* if this is the first call after the moov is found we initialize the list of samples (may be empty in fragmented files) */
		if (!this.sampleListBuilt) {
			this.buildSampleLists();
			this.sampleListBuilt = true;
		}

		/* We update the sample information if there are any new moof boxes */
		this.updateSampleLists();

		/* If the application needs to be informed that the 'moov' has been found,
		   we create the information object and callback the application */
		if (this.onReady && !this.readySent) {
			this.readySent = true;
			this.onReady(this.getInfo());
		}

		/* See if any sample extraction or segment creation needs to be done with the available samples */
		this.processSamples(last);

		/* Inform about the best range to fetch next */
		if (this.nextSeekPosition) {
			nextFileStart = this.nextSeekPosition;
			this.nextSeekPosition = undefined;
		} else {
			nextFileStart = this.nextParsePosition;
		}
		if (this.stream.getEndFilePositionAfter) {
			nextFileStart = this.stream.getEndFilePositionAfter(nextFileStart);
		}
	} else {
		if (this.nextParsePosition) {
			/* moov has not been parsed but the first buffer was received,
			   the next fetch should probably be the next box start */
			nextFileStart = this.nextParsePosition;
		} else {
			/* No valid buffer has been parsed yet, we cannot know what to parse next */
			nextFileStart = 0;
		}
	}
	if (this.sidx) {
		if (this.onSidx && !this.sidxSent) {
			this.onSidx(this.sidx);
			this.sidxSent = true;
		}
	}
	if (this.meta) {
		if (this.flattenItemInfo && !this.itemListBuilt) {
			this.flattenItemInfo();
			this.itemListBuilt = true;
		}
		if (this.processItems) {
			this.processItems(this.onItem);
		}
	}

	if (this.stream.cleanBuffers) {
		Log.info("ISOFile", "Done processing buffer (fileStart: "+ab.fileStart+") - next buffer to fetch should have a fileStart position of "+nextFileStart);
		this.stream.logBufferLevel();
		this.stream.cleanBuffers();
		this.stream.logBufferLevel(true);
		Log.info("ISOFile", "Sample data size in memory: "+this.getAllocatedSampleDataSize());
	}
	return nextFileStart;
};

ISOFile.prototype.getInfo = function() {
	var i, j;
	var movie = {};
	var trak;
	var track;
	var sample_desc;
	var _1904 = (new Date('1904-01-01T00:00:00Z').getTime());

	if (this.moov) {
		movie.hasMoov = true;
		movie.duration = this.moov.mvhd.duration;
		movie.timescale = this.moov.mvhd.timescale;
		movie.isFragmented = (this.moov.mvex != null);
		if (movie.isFragmented && this.moov.mvex.mehd) {
			movie.fragment_duration = this.moov.mvex.mehd.fragment_duration;
		}
		movie.isProgressive = this.isProgressive;
		movie.hasIOD = (this.moov.iods != null);
		movie.brands = [];
		movie.brands.push(this.ftyp.major_brand);
		movie.brands = movie.brands.concat(this.ftyp.compatible_brands);
		movie.created = new Date(_1904+this.moov.mvhd.creation_time*1000);
		movie.modified = new Date(_1904+this.moov.mvhd.modification_time*1000);
		movie.tracks = [];
		movie.audioTracks = [];
		movie.videoTracks = [];
		movie.subtitleTracks = [];
		movie.metadataTracks = [];
		movie.hintTracks = [];
		movie.otherTracks = [];
		for (i = 0; i < this.moov.traks.length; i++) {
			trak = this.moov.traks[i];
			sample_desc = trak.mdia.minf.stbl.stsd.entries[0];
			track = {};
			movie.tracks.push(track);
			track.id = trak.tkhd.track_id;
			track.name = trak.mdia.hdlr.name;
			track.references = [];
			if (trak.tref) {
				for (j = 0; j < trak.tref.boxes.length; j++) {
					ref = {};
					track.references.push(ref);
					ref.type = trak.tref.boxes[j].type;
					ref.track_ids = trak.tref.boxes[j].track_ids;
				}
			}
			if (trak.edts) {
				track.edits = trak.edts.elst.entries;
			}
			track.created = new Date(_1904+trak.tkhd.creation_time*1000);
			track.modified = new Date(_1904+trak.tkhd.modification_time*1000);
			track.movie_duration = trak.tkhd.duration;
			track.movie_timescale = movie.timescale;
			track.layer = trak.tkhd.layer;
			track.alternate_group = trak.tkhd.alternate_group;
			track.volume = trak.tkhd.volume;
			track.matrix = trak.tkhd.matrix;
			track.track_width = trak.tkhd.width/(1<<16);
			track.track_height = trak.tkhd.height/(1<<16);
			track.timescale = trak.mdia.mdhd.timescale;
			track.cts_shift = trak.mdia.minf.stbl.cslg;
			track.duration = trak.mdia.mdhd.duration;
			track.samples_duration = trak.samples_duration;
			track.codec = sample_desc.getCodec();
			track.kind = (trak.udta && trak.udta.kinds.length ? trak.udta.kinds[0] : { schemeURI: "", value: ""});
			track.language = (trak.mdia.elng ? trak.mdia.elng.extended_language : trak.mdia.mdhd.languageString);
			track.nb_samples = trak.samples.length;
			track.size = trak.samples_size;
			track.bitrate = (track.size*8*track.timescale)/track.samples_duration;
			if (sample_desc.isAudio()) {
				track.type = "audio";
				movie.audioTracks.push(track);
				track.audio = {};
				track.audio.sample_rate = sample_desc.getSampleRate();
				track.audio.channel_count = sample_desc.getChannelCount();
				track.audio.sample_size = sample_desc.getSampleSize();
			} else if (sample_desc.isVideo()) {
				track.type = "video";
				movie.videoTracks.push(track);
				track.video = {};
				track.video.width = sample_desc.getWidth();
				track.video.height = sample_desc.getHeight();
			} else if (sample_desc.isSubtitle()) {
				track.type = "subtitles";
				movie.subtitleTracks.push(track);
			} else if (sample_desc.isHint()) {
				track.type = "metadata";
				movie.hintTracks.push(track);
			} else if (sample_desc.isMetadata()) {
				track.type = "metadata";
				movie.metadataTracks.push(track);
			} else {
				track.type = "metadata";
				movie.otherTracks.push(track);
			}
		}
	} else {
		movie.hasMoov = false;
	}
	movie.mime = "";
	if (movie.hasMoov && movie.tracks) {
		if (movie.videoTracks && movie.videoTracks.length > 0) {
			movie.mime += 'video/mp4; codecs=\"';
		} else if (movie.audioTracks && movie.audioTracks.length > 0) {
			movie.mime += 'audio/mp4; codecs=\"';
		} else {
			movie.mime += 'application/mp4; codecs=\"';
		}
		for (i = 0; i < movie.tracks.length; i++) {
			if (i !== 0) movie.mime += ',';
			movie.mime+= movie.tracks[i].codec;
		}
		movie.mime += '\"; profiles=\"';
		movie.mime += this.ftyp.compatible_brands.join();
		movie.mime += '\"';
	}
	return movie;
};

ISOFile.prototype.processSamples = function(last) {
	var i;
	var trak;
	if (!this.sampleProcessingStarted) return;

	/* For each track marked for fragmentation,
	   check if the next sample is there (i.e. if the sample information is known (i.e. moof has arrived) and if it has been downloaded)
	   and create a fragment with it */
	if (this.isFragmentationInitialized && this.onSegment !== null) {
		for (i = 0; i < this.fragmentedTracks.length; i++) {
			var fragTrak = this.fragmentedTracks[i];
			trak = fragTrak.trak;
			while (trak.nextSample < trak.samples.length && this.sampleProcessingStarted) {
				/* The sample information is there (either because the file is not fragmented and this is not the last sample,
				or because the file is fragmented and the moof for that sample has been received */
				Log.debug("ISOFile", "Creating media fragment on track #"+fragTrak.id +" for sample "+trak.nextSample);
				var result = this.createFragment(fragTrak.id, trak.nextSample, fragTrak.segmentStream);
				if (result) {
					fragTrak.segmentStream = result;
					trak.nextSample++;
				} else {
					/* The fragment could not be created because the media data is not there (not downloaded), wait for it */
					break;
				}
				/* A fragment is created by sample, but the segment is the accumulation in the buffer of these fragments.
				   It is flushed only as requested by the application (nb_samples) to avoid too many callbacks */
				if (trak.nextSample % fragTrak.nb_samples === 0 || (last || trak.nextSample >= trak.samples.length)) {
					Log.info("ISOFile", "Sending fragmented data on track #"+fragTrak.id+" for samples ["+Math.max(0,trak.nextSample-fragTrak.nb_samples)+","+(trak.nextSample-1)+"]");
					Log.info("ISOFile", "Sample data size in memory: "+this.getAllocatedSampleDataSize());
					if (this.onSegment) {
						this.onSegment(fragTrak.id, fragTrak.user, fragTrak.segmentStream.buffer, trak.nextSample, (last || trak.nextSample >= trak.samples.length));
					}
					/* force the creation of a new buffer */
					fragTrak.segmentStream = null;
					if (fragTrak !== this.fragmentedTracks[i]) {
						/* make sure we can stop fragmentation if needed */
						break;
					}
				}
			}
		}
	}

	if (this.onSamples !== null) {
		/* For each track marked for data export,
		   check if the next sample is there (i.e. has been downloaded) and send it */
		for (i = 0; i < this.extractedTracks.length; i++) {
			var extractTrak = this.extractedTracks[i];
			trak = extractTrak.trak;
			while (trak.nextSample < trak.samples.length && this.sampleProcessingStarted) {
				Log.debug("ISOFile", "Exporting on track #"+extractTrak.id +" sample #"+trak.nextSample);
				var sample = this.getSample(trak, trak.nextSample);
				if (sample) {
					trak.nextSample++;
					extractTrak.samples.push(sample);
				} else {
					break;
				}
				if (trak.nextSample % extractTrak.nb_samples === 0 || trak.nextSample >= trak.samples.length) {
					Log.debug("ISOFile", "Sending samples on track #"+extractTrak.id+" for sample "+trak.nextSample);
					if (this.onSamples) {
						this.onSamples(extractTrak.id, extractTrak.user, extractTrak.samples);
					}
					extractTrak.samples = [];
					if (extractTrak !== this.extractedTracks[i]) {
						/* check if the extraction needs to be stopped */
						break;
					}
				}
			}
		}
	}
};

/* Find and return specific boxes using recursion and early return */
ISOFile.prototype.getBox = function(type) {
  var result = this.getBoxes(type, true);
  return (result.length ? result[0] : null);
};

ISOFile.prototype.getBoxes = function(type, returnEarly) {
  var result = [];
  ISOFile._sweep.call(this, type, result, returnEarly);
  return result;
};

ISOFile._sweep = function(type, result, returnEarly) {
  if (this.type && this.type == type) result.push(this);
  for (var box in this.boxes) {
    if (result.length && returnEarly) return;
    ISOFile._sweep.call(this.boxes[box], type, result, returnEarly);
  }
};

ISOFile.prototype.getTrackSamplesInfo = function(track_id) {
	var track = this.getTrackById(track_id);
	if (track) {
		return track.samples;
	} else {
		return;
	}
};

ISOFile.prototype.getTrackSample = function(track_id, number) {
	var track = this.getTrackById(track_id);
	var sample = this.getSample(track, number);
	return sample;
};

/* Called by the application to release the resources associated to samples already forwarded to the application */
ISOFile.prototype.releaseUsedSamples = function (id, sampleNum) {
	var size = 0;
	var trak = this.getTrackById(id);
	if (!trak.lastValidSample) trak.lastValidSample = 0;
	for (var i = trak.lastValidSample; i < sampleNum; i++) {
		size+=this.releaseSample(trak, i);
	}
	Log.info("ISOFile", "Track #"+id+" released samples up to "+sampleNum+" (released size: "+size+", remaining: "+this.samplesDataSize+")");
	trak.lastValidSample = sampleNum;
};

ISOFile.prototype.start = function() {
	this.sampleProcessingStarted = true;
	this.processSamples(false);
};

ISOFile.prototype.stop = function() {
	this.sampleProcessingStarted = false;
};

/* Called by the application to flush the remaining samples (e.g. once the download is finished or when no more samples will be added) */
ISOFile.prototype.flush = function() {
	Log.info("ISOFile", "Flushing remaining samples");
	this.updateSampleLists();
	this.processSamples(true);
	this.stream.cleanBuffers();
	this.stream.logBufferLevel(true);
};

/* Finds the byte offset for a given time on a given track
   also returns the time of the previous rap */
ISOFile.prototype.seekTrack = function(time, useRap, trak) {
	var j;
	var sample;
	var seek_offset = Infinity;
	var rap_seek_sample_num = 0;
	var seek_sample_num = 0;
	var timescale;

	if (trak.samples.length === 0) {
		Log.info("ISOFile", "No sample in track, cannot seek! Using time "+Log.getDurationString(0, 1) +" and offset: "+0);
		return { offset: 0, time: 0 };
	}

	for (j = 0; j < trak.samples.length; j++) {
		sample = trak.samples[j];
		if (j === 0) {
			seek_sample_num = 0;
			timescale = sample.timescale;
		} else if (sample.cts > time * sample.timescale) {
			seek_sample_num = j-1;
			break;
		}
		if (useRap && sample.is_sync) {
			rap_seek_sample_num = j;
		}
	}
	if (useRap) {
		seek_sample_num = rap_seek_sample_num;
	}
	time = trak.samples[seek_sample_num].cts;
	trak.nextSample = seek_sample_num;
	while (trak.samples[seek_sample_num].alreadyRead === trak.samples[seek_sample_num].size) {
		// No remaining samples to look for, all are downloaded.
		if (!trak.samples[seek_sample_num + 1]) {
			break;
		}
		seek_sample_num++;
	}
	seek_offset = trak.samples[seek_sample_num].offset+trak.samples[seek_sample_num].alreadyRead;
	Log.info("ISOFile", "Seeking to "+(useRap ? "RAP": "")+" sample #"+trak.nextSample+" on track "+trak.tkhd.track_id+", time "+Log.getDurationString(time, timescale) +" and offset: "+seek_offset);
	return { offset: seek_offset, time: time/timescale };
};

/* Finds the byte offset in the file corresponding to the given time or to the time of the previous RAP */
ISOFile.prototype.seek = function(time, useRap) {
	var moov = this.moov;
	var trak;
	var trak_seek_info;
	var i;
	var seek_info = { offset: Infinity, time: Infinity };
	if (!this.moov) {
		throw "Cannot seek: moov not received!";
	} else {
		for (i = 0; i<moov.traks.length; i++) {
			trak = moov.traks[i];
			trak_seek_info = this.seekTrack(time, useRap, trak);
			if (trak_seek_info.offset < seek_info.offset) {
				seek_info.offset = trak_seek_info.offset;
			}
			if (trak_seek_info.time < seek_info.time) {
				seek_info.time = trak_seek_info.time;
			}
		}
		Log.info("ISOFile", "Seeking at time "+Log.getDurationString(seek_info.time, 1)+" needs a buffer with a fileStart position of "+seek_info.offset);
		if (seek_info.offset === Infinity) {
			/* No sample info, in all tracks, cannot seek */
			seek_info = { offset: this.nextParsePosition, time: 0 };
		} else {
			/* check if the seek position is already in some buffer and
			 in that case return the end of that buffer (or of the last contiguous buffer) */
			/* TODO: Should wait until append operations are done */
			seek_info.offset = this.stream.getEndFilePositionAfter(seek_info.offset);
		}
		Log.info("ISOFile", "Adjusted seek position (after checking data already in buffer): "+seek_info.offset);
		return seek_info;
	}
};

ISOFile.prototype.equal = function(b) {
	var box_index = 0;
	while (box_index < this.boxes.length && box_index < b.boxes.length) {
		var a_box = this.boxes[box_index];
		var b_box = b.boxes[box_index];
		if (!BoxParser.boxEqual(a_box, b_box)) {
			return false;
		}
		box_index++;
	}
	return true;
};

{
	exports.ISOFile = ISOFile;
}
// file:src/isofile-advanced-parsing.js
/* position in the current buffer of the beginning of the last box parsed */
ISOFile.prototype.lastBoxStartPosition = 0;
/* indicator if the parsing is stuck in the middle of an mdat box */
ISOFile.prototype.parsingMdat = null;
/* next file position that the parser needs:
    - 0 until the first buffer (i.e. fileStart ===0) has been received 
    - otherwise, the next box start until the moov box has been parsed
    - otherwise, the position of the next sample to fetch
 */
ISOFile.prototype.nextParsePosition = 0;
/* keep mdat data */
ISOFile.prototype.discardMdatData = false;

ISOFile.prototype.processIncompleteBox = function(ret) {
	var box;
	var merged;
	var found;
	
	/* we did not have enough bytes in the current buffer to parse the entire box */
	if (ret.type === "mdat") { 
		/* we had enough bytes to get its type and size and it's an 'mdat' */
		
		/* special handling for mdat boxes, since we don't actually need to parse it linearly 
		   we create the box */
		box = new BoxParser[ret.type+"Box"](ret.size);	
		this.parsingMdat = box;
		this.boxes.push(box);
		this.mdats.push(box);			
		box.start = ret.start;
		box.hdr_size = ret.hdr_size;
		this.stream.addUsedBytes(box.hdr_size);

		/* indicate that the parsing should start from the end of the box */
		this.lastBoxStartPosition = box.start + box.size;
 		/* let's see if we have the end of the box in the other buffers */
		found = this.stream.seek(box.start + box.size, false, this.discardMdatData);
		if (found) {
			/* found the end of the box */
			this.parsingMdat = null;
			/* let's see if we can parse more in this buffer */
			return true;
		} else {
			/* 'mdat' end not found in the existing buffers */
			/* determine the next position in the file to start parsing from */
			if (!this.moovStartFound) {
				/* moov not find yet, 
				   the file probably has 'mdat' at the beginning, and 'moov' at the end, 
				   indicate that the downloader should not try to download those bytes now */
				this.nextParsePosition = box.start + box.size;
			} else {
				/* we have the start of the moov box, 
				   the next bytes should try to complete the current 'mdat' */
				this.nextParsePosition = this.stream.findEndContiguousBuf();
			}
			/* not much we can do, wait for more buffers to arrive */
			return false;
		}
	} else {
		/* box is incomplete, we may not even know its type */
		if (ret.type === "moov") { 
			/* the incomplete box is a 'moov' box */
			this.moovStartFound = true;
			if (this.mdats.length === 0) {
				this.isProgressive = true;
			}
		}
		/* either it's not an mdat box (and we need to parse it, we cannot skip it)
		   (TODO: we could skip 'free' boxes ...)
			   or we did not have enough data to parse the type and size of the box, 
		   we try to concatenate the current buffer with the next buffer to restart parsing */
		merged = (this.stream.mergeNextBuffer ? this.stream.mergeNextBuffer() : false);
		if (merged) {
			/* The next buffer was contiguous, the merging succeeded,
			   we can now continue parsing, 
			   the next best position to parse is at the end of this new buffer */
			this.nextParsePosition = this.stream.getEndPosition();
			return true;
		} else {
			/* we cannot concatenate existing buffers because they are not contiguous or because there is no additional buffer */
			/* The next best position to parse is still at the end of this old buffer */
			if (!ret.type) {
				/* There were not enough bytes in the buffer to parse the box type and length,
				   the next fetch should retrieve those missing bytes, i.e. the next bytes after this buffer */
				this.nextParsePosition = this.stream.getEndPosition();
			} else {
				/* we had enough bytes to parse size and type of the incomplete box
				   if we haven't found yet the moov box, skip this one and try the next one 
				   if we have found the moov box, let's continue linear parsing */
				if (this.moovStartFound) {
					this.nextParsePosition = this.stream.getEndPosition();
				} else {
					this.nextParsePosition = this.stream.getPosition() + ret.size;
				}
			}
			return false;
		}
	}
};

ISOFile.prototype.hasIncompleteMdat = function () {
	return (this.parsingMdat !== null);
};

ISOFile.prototype.processIncompleteMdat = function () {
	var box;
	var found;
	
	/* we are in the parsing of an incomplete mdat box */
	box = this.parsingMdat;

	found = this.stream.seek(box.start + box.size, false, this.discardMdatData);
	if (found) {
		Log.debug("ISOFile", "Found 'mdat' end in buffered data");
		/* the end of the mdat has been found */ 
		this.parsingMdat = null;
		/* we can parse more in this buffer */
		return true;
	} else {
		/* we don't have the end of this mdat yet, 
		   indicate that the next byte to fetch is the end of the buffers we have so far, 
		   return and wait for more buffer to come */
		this.nextParsePosition = this.stream.findEndContiguousBuf();
		return false;
	}
};

ISOFile.prototype.restoreParsePosition = function() {
	/* Reposition at the start position of the previous box not entirely parsed */
	return this.stream.seek(this.lastBoxStartPosition, true, this.discardMdatData);
};

ISOFile.prototype.saveParsePosition = function() {
	/* remember the position of the box start in case we need to roll back (if the box is incomplete) */
	this.lastBoxStartPosition = this.stream.getPosition();	
};

ISOFile.prototype.updateUsedBytes = function(box, ret) {
	if (this.stream.addUsedBytes) {
		if (box.type === "mdat") {
			/* for an mdat box, only its header is considered used, other bytes will be used when sample data is requested */
			this.stream.addUsedBytes(box.hdr_size);
			if (this.discardMdatData) {
				this.stream.addUsedBytes(box.size-box.hdr_size);
			}
		} else {
			/* for all other boxes, the entire box data is considered used */
			this.stream.addUsedBytes(box.size);
		}	
	}
};
// file:src/isofile-advanced-creation.js
ISOFile.prototype.add = BoxParser.Box.prototype.add;
ISOFile.prototype.addBox = BoxParser.Box.prototype.addBox;

ISOFile.prototype.init = function (_options) {
	var options = _options || {}; 
	this.add("ftyp").set("major_brand", (options.brands && options.brands[0]) || "iso4")
							   .set("minor_version", 0)
							   .set("compatible_brands", options.brands || ["iso4"]);
	var moov = this.add("moov");
	moov.add("mvhd").set("timescale", options.timescale || 600)
					.set("rate", options.rate || 1<<16)
					.set("creation_time", 0)
					.set("modification_time", 0)
					.set("duration", options.duration || 0)
					.set("volume", (options.width) ? 0 : 0x0100)
					.set("matrix", [ 1<<16, 0, 0, 0, 1<<16, 0, 0, 0, 0x40000000])
					.set("next_track_id", 1);
	moov.add("mvex");
	return this;
};

ISOFile.prototype.addTrack = function (_options) {
	if (!this.moov) {
		this.init(_options);
	}

	var options = _options || {}; 
	options.width = options.width || 320;
	options.height = options.height || 320;
	options.id = options.id || this.moov.mvhd.next_track_id;
	options.type = options.type || "avc1";

	var trak = this.moov.add("trak");
	this.moov.mvhd.next_track_id = options.id+1;
	trak.add("tkhd").set("flags",BoxParser.TKHD_FLAG_ENABLED | 
								 BoxParser.TKHD_FLAG_IN_MOVIE | 
								 BoxParser.TKHD_FLAG_IN_PREVIEW)
					.set("creation_time",0)
					.set("modification_time", 0)
					.set("track_id", options.id)
					.set("duration", options.duration || 0)
					.set("layer", options.layer || 0)
					.set("alternate_group", 0)
					.set("volume", 1)
					.set("matrix", [ 0, 0, 0, 0, 0, 0, 0, 0, 0 ])
					.set("width", options.width)
					.set("height", options.height);

	var mdia = trak.add("mdia");
	mdia.add("mdhd").set("creation_time", 0)
					.set("modification_time", 0)
					.set("timescale", options.timescale || 1)
					.set("duration", options.media_duration || 0)
					.set("language", options.language || "und");

	mdia.add("hdlr").set("handler", options.hdlr || "vide")
					.set("name", options.name || "Track created with MP4Box.js");

	mdia.add("elng").set("extended_language", options.language || "fr-FR");

	var minf = mdia.add("minf");
	if (BoxParser[options.type+"SampleEntry"] === undefined) return;
	var sample_description_entry = new BoxParser[options.type+"SampleEntry"]();
	sample_description_entry.data_reference_index = 1;
	var media_type = "";
	for (var mediaType in BoxParser.sampleEntryCodes) {
		var codes = BoxParser.sampleEntryCodes[mediaType];
		for (var i = 0; i < codes.length; i++) {
			if (codes.indexOf(options.type) > -1) {
				media_type = mediaType;
				break;
			}
		}
	}
	switch(media_type) {
		case "Visual":
			minf.add("vmhd").set("graphicsmode",0).set("opcolor", [ 0, 0, 0 ]);
			sample_description_entry.set("width", options.width)
						.set("height", options.height)
						.set("horizresolution", 0x48<<16)
						.set("vertresolution", 0x48<<16)
						.set("frame_count", 1)
						.set("compressorname", options.type+" Compressor")
						.set("depth", 0x18);
			if (options.avcDecoderConfigRecord) {
				var avcC = new BoxParser.avcCBox();
				var stream = new MP4BoxStream(options.avcDecoderConfigRecord);
				avcC.parse(stream);
				sample_description_entry.addBox(avcC);
			}
			break;
		case "Audio":
			minf.add("smhd").set("balance", options.balance || 0);
			sample_description_entry.set("channel_count", options.channel_count || 2)
						.set("samplesize", options.samplesize || 16)
						.set("samplerate", options.samplerate || 1<<16);
			break;
		case "Hint":
			minf.add("hmhd"); // TODO: add properties
			break;
		case "Subtitle":
			minf.add("sthd");
			switch (options.type) {
				case "stpp":
					sample_description_entry.set("namespace", options.namespace || "nonamespace")
								.set("schema_location", options.schema_location || "")
								.set("auxiliary_mime_types", options.auxiliary_mime_types || "");
					break;
			}
			break;
		case "Metadata":
			minf.add("nmhd");
			break;
		case "System":
			minf.add("nmhd");
			break;
		default:
			minf.add("nmhd");
			break;
	}
	if (options.description) {
		sample_description_entry.addBox(options.description);
	}
	if (options.description_boxes) {
		options.description_boxes.forEach(function (b) {
			sample_description_entry.addBox(b);
		});
	}
	minf.add("dinf").add("dref").addEntry((new BoxParser["url Box"]()).set("flags", 0x1));
	var stbl = minf.add("stbl");
	stbl.add("stsd").addEntry(sample_description_entry);
	stbl.add("stts").set("sample_counts", [])
					.set("sample_deltas", []);
	stbl.add("stsc").set("first_chunk", [])
					.set("samples_per_chunk", [])
					.set("sample_description_index", []);
	stbl.add("stco").set("chunk_offsets", []);
	stbl.add("stsz").set("sample_sizes", []);

	this.moov.mvex.add("trex").set("track_id", options.id)
							  .set("default_sample_description_index", options.default_sample_description_index || 1)
							  .set("default_sample_duration", options.default_sample_duration || 0)
							  .set("default_sample_size", options.default_sample_size || 0)
							  .set("default_sample_flags", options.default_sample_flags || 0);
	this.buildTrakSampleLists(trak);
	return options.id;
};

BoxParser.Box.prototype.computeSize = function(stream_) {
	var stream = stream_ || new DataStream();
	stream.endianness = DataStream.BIG_ENDIAN;
	this.write(stream);
};

ISOFile.prototype.addSample = function (track_id, data, _options) {
	var options = _options || {};
	var sample = {};
	var trak = this.getTrackById(track_id);
	if (trak === null) return;
    sample.number = trak.samples.length;
	sample.track_id = trak.tkhd.track_id;
	sample.timescale = trak.mdia.mdhd.timescale;
	sample.description_index = (options.sample_description_index ? options.sample_description_index - 1: 0);
	sample.description = trak.mdia.minf.stbl.stsd.entries[sample.description_index];
	sample.data = data;
	sample.size = data.byteLength;
	sample.alreadyRead = sample.size;
	sample.duration = options.duration || 1;
	sample.cts = options.cts || 0;
	sample.dts = options.dts || 0;
	sample.is_sync = options.is_sync || false;
	sample.is_leading = options.is_leading || 0;
	sample.depends_on = options.depends_on || 0;
	sample.is_depended_on = options.is_depended_on || 0;
	sample.has_redundancy = options.has_redundancy || 0;
	sample.degradation_priority = options.degradation_priority || 0;
	sample.offset = 0;
	sample.subsamples = options.subsamples;
	trak.samples.push(sample);
	trak.samples_size += sample.size;
	trak.samples_duration += sample.duration;
	if (!trak.first_dts) {
		trak.first_dts = options.dts;
	}

	this.processSamples();
	
	var moof = this.createSingleSampleMoof(sample);
	this.addBox(moof);
	moof.computeSize();
	/* adjusting the data_offset now that the moof size is known*/
	moof.trafs[0].truns[0].data_offset = moof.size+8; //8 is mdat header
	this.add("mdat").data = new Uint8Array(data);
	return sample;
};

ISOFile.prototype.createSingleSampleMoof = function(sample) {
	var sample_flags = 0;
	if (sample.is_sync)
		sample_flags = (1 << 25);  // sample_depends_on_none (I picture)
	else
		sample_flags = (1 << 16);  // non-sync

	var moof = new BoxParser.moofBox();
	moof.add("mfhd").set("sequence_number", this.nextMoofNumber);
	this.nextMoofNumber++;
	var traf = moof.add("traf");
	var trak = this.getTrackById(sample.track_id);
	traf.add("tfhd").set("track_id", sample.track_id)
					.set("flags", BoxParser.TFHD_FLAG_DEFAULT_BASE_IS_MOOF);
	traf.add("tfdt").set("baseMediaDecodeTime", (sample.dts - trak.first_dts));
	traf.add("trun").set("flags", BoxParser.TRUN_FLAGS_DATA_OFFSET | BoxParser.TRUN_FLAGS_DURATION | 
				 				  BoxParser.TRUN_FLAGS_SIZE | BoxParser.TRUN_FLAGS_FLAGS | 
				 				  BoxParser.TRUN_FLAGS_CTS_OFFSET)
					.set("data_offset",0)
					.set("first_sample_flags",0)
					.set("sample_count",1)
					.set("sample_duration",[sample.duration])
					.set("sample_size",[sample.size])
					.set("sample_flags",[sample_flags])
					.set("sample_composition_time_offset", [sample.cts - sample.dts]);
	return moof;
};

// file:src/isofile-sample-processing.js
/* Index of the last moof box received */
ISOFile.prototype.lastMoofIndex = 0;

/* size of the buffers allocated for samples */
ISOFile.prototype.samplesDataSize = 0;

/* Resets all sample tables */
ISOFile.prototype.resetTables = function () {
	var i;
	var trak, stco, stsc, stsz, stts, ctts, stss;
	this.initial_duration = this.moov.mvhd.duration;
	this.moov.mvhd.duration = 0;
	for (i = 0; i < this.moov.traks.length; i++) {
		trak = this.moov.traks[i];
		trak.tkhd.duration = 0;
		trak.mdia.mdhd.duration = 0;
		stco = trak.mdia.minf.stbl.stco || trak.mdia.minf.stbl.co64;
		stco.chunk_offsets = [];
		stsc = trak.mdia.minf.stbl.stsc;
		stsc.first_chunk = [];
		stsc.samples_per_chunk = [];
		stsc.sample_description_index = [];
		stsz = trak.mdia.minf.stbl.stsz || trak.mdia.minf.stbl.stz2;
		stsz.sample_sizes = [];
		stts = trak.mdia.minf.stbl.stts;
		stts.sample_counts = [];
		stts.sample_deltas = [];
		ctts = trak.mdia.minf.stbl.ctts;
		if (ctts) {
			ctts.sample_counts = [];
			ctts.sample_offsets = [];
		}
		stss = trak.mdia.minf.stbl.stss;
		var k = trak.mdia.minf.stbl.boxes.indexOf(stss);
		if (k != -1) trak.mdia.minf.stbl.boxes[k] = null;
	}
};

ISOFile.initSampleGroups = function(trak, traf, sbgps, trak_sgpds, traf_sgpds) {
	var l;
	var k;
	var sample_group_info;
	var sample_group_key;
	function SampleGroupInfo(_type, _parameter, _sbgp) {
		this.grouping_type = _type;
		this.grouping_type_parameter = _parameter;
		this.sbgp = _sbgp;
		this.last_sample_in_run = -1;
		this.entry_index = -1;		
	}
	if (traf) {
		traf.sample_groups_info = [];
	} 
	if (!trak.sample_groups_info) {
		trak.sample_groups_info = [];
	}
	for (k = 0; k < sbgps.length; k++) {
		sample_group_key = sbgps[k].grouping_type +"/"+ sbgps[k].grouping_type_parameter;
		sample_group_info = new SampleGroupInfo(sbgps[k].grouping_type, sbgps[k].grouping_type_parameter, sbgps[k]);
		if (traf) {
			traf.sample_groups_info[sample_group_key] = sample_group_info;
		}
		if (!trak.sample_groups_info[sample_group_key]) {
			trak.sample_groups_info[sample_group_key] = sample_group_info;
		}
		for (l=0; l <trak_sgpds.length; l++) {
			if (trak_sgpds[l].grouping_type === sbgps[k].grouping_type) {
				sample_group_info.description = trak_sgpds[l];
				sample_group_info.description.used = true;
			}
		}
		if (traf_sgpds) {
			for (l=0; l <traf_sgpds.length; l++) {
				if (traf_sgpds[l].grouping_type === sbgps[k].grouping_type) {
					sample_group_info.fragment_description = traf_sgpds[l];
					sample_group_info.fragment_description.used = true;
					sample_group_info.is_fragment = true;
				}
			}			
		}
	}
	if (!traf) {
		for (k = 0; k < trak_sgpds.length; k++) {
			if (!trak_sgpds[k].used && trak_sgpds[k].version >= 2) {
				sample_group_key = trak_sgpds[k].grouping_type +"/0";
				sample_group_info = new SampleGroupInfo(trak_sgpds[k].grouping_type, 0);
				if (!trak.sample_groups_info[sample_group_key]) {
					trak.sample_groups_info[sample_group_key] = sample_group_info;
				}
			}
		}
	} else {
		if (traf_sgpds) {
			for (k = 0; k < traf_sgpds.length; k++) {
				if (!traf_sgpds[k].used && traf_sgpds[k].version >= 2) {
					sample_group_key = traf_sgpds[k].grouping_type +"/0";
					sample_group_info = new SampleGroupInfo(traf_sgpds[k].grouping_type, 0);
					sample_group_info.is_fragment = true;
					if (!traf.sample_groups_info[sample_group_key]) {
						traf.sample_groups_info[sample_group_key] = sample_group_info;
					}
				}
			}
		}
	}
};

ISOFile.setSampleGroupProperties = function(trak, sample, sample_number, sample_groups_info) {
	var k;
	var index;
	sample.sample_groups = [];
	for (k in sample_groups_info) {
		sample.sample_groups[k] = {};
		sample.sample_groups[k].grouping_type = sample_groups_info[k].grouping_type;
		sample.sample_groups[k].grouping_type_parameter = sample_groups_info[k].grouping_type_parameter;
		if (sample_number >= sample_groups_info[k].last_sample_in_run) {
			if (sample_groups_info[k].last_sample_in_run < 0) {
				sample_groups_info[k].last_sample_in_run = 0;
			}
			sample_groups_info[k].entry_index++;	
			if (sample_groups_info[k].entry_index <= sample_groups_info[k].sbgp.entries.length - 1) {
				sample_groups_info[k].last_sample_in_run += sample_groups_info[k].sbgp.entries[sample_groups_info[k].entry_index].sample_count;
			}
		}
		if (sample_groups_info[k].entry_index <= sample_groups_info[k].sbgp.entries.length - 1) {
			sample.sample_groups[k].group_description_index = sample_groups_info[k].sbgp.entries[sample_groups_info[k].entry_index].group_description_index;
		} else {
			sample.sample_groups[k].group_description_index = -1; // special value for not defined
		}
		if (sample.sample_groups[k].group_description_index !== 0) {
			var description;
			if (sample_groups_info[k].fragment_description) {
				description = sample_groups_info[k].fragment_description;
			} else {
				description = sample_groups_info[k].description;
			}
			if (sample.sample_groups[k].group_description_index > 0) {
				if (sample.sample_groups[k].group_description_index > 65535) {
					index = (sample.sample_groups[k].group_description_index >> 16)-1;
				} else {
					index = sample.sample_groups[k].group_description_index-1;
				}
				if (description && index >= 0) {
					sample.sample_groups[k].description = description.entries[index];
				}
			} else {
				if (description && description.version >= 2) {
					if (description.default_group_description_index > 0) {								
						sample.sample_groups[k].description = description.entries[description.default_group_description_index-1];
					}
				}
			}
		}
	}
};

ISOFile.process_sdtp = function (sdtp, sample, number) {
	if (!sample) {
		return;
	}
	if (sdtp) {
		sample.is_leading = sdtp.is_leading[number];
		sample.depends_on = sdtp.sample_depends_on[number];
		sample.is_depended_on = sdtp.sample_is_depended_on[number];
		sample.has_redundancy = sdtp.sample_has_redundancy[number];
	} else {
		sample.is_leading = 0;
		sample.depends_on = 0;
		sample.is_depended_on = 0;
		sample.has_redundancy = 0;
	}	
};

/* Build initial sample list from  sample tables */
ISOFile.prototype.buildSampleLists = function() {	
	var i;
	var trak;
	for (i = 0; i < this.moov.traks.length; i++) {
		trak = this.moov.traks[i];
		this.buildTrakSampleLists(trak);
	}
};

ISOFile.prototype.buildTrakSampleLists = function(trak) {	
	var j;
	var stco, stsc, stsz, stts, ctts, stss, stsd, subs, sbgps, sgpds, stdp;
	var chunk_run_index, chunk_index, last_chunk_in_run, offset_in_chunk, last_sample_in_chunk;
	var last_sample_in_stts_run, stts_run_index, last_sample_in_ctts_run, ctts_run_index, last_stss_index, subs_entry_index, last_subs_sample_index;

	trak.samples = [];
	trak.samples_duration = 0;
	trak.samples_size = 0;
	stco = trak.mdia.minf.stbl.stco || trak.mdia.minf.stbl.co64;
	stsc = trak.mdia.minf.stbl.stsc;
	stsz = trak.mdia.minf.stbl.stsz || trak.mdia.minf.stbl.stz2;
	stts = trak.mdia.minf.stbl.stts;
	ctts = trak.mdia.minf.stbl.ctts;
	stss = trak.mdia.minf.stbl.stss;
	stsd = trak.mdia.minf.stbl.stsd;
	subs = trak.mdia.minf.stbl.subs;
	stdp = trak.mdia.minf.stbl.stdp;
	sbgps = trak.mdia.minf.stbl.sbgps;
	sgpds = trak.mdia.minf.stbl.sgpds;
	
	last_sample_in_stts_run = -1;
	stts_run_index = -1;
	last_sample_in_ctts_run = -1;
	ctts_run_index = -1;
	last_stss_index = 0;
	subs_entry_index = 0;
	last_subs_sample_index = 0;		

	ISOFile.initSampleGroups(trak, null, sbgps, sgpds);

	if (typeof stsz === "undefined") {
		return;
	}

	/* we build the samples one by one and compute their properties */
	for (j = 0; j < stsz.sample_sizes.length; j++) {
		var sample = {};
		sample.number = j;
		sample.track_id = trak.tkhd.track_id;
		sample.timescale = trak.mdia.mdhd.timescale;
		sample.alreadyRead = 0;
		trak.samples[j] = sample;
		/* size can be known directly */
		sample.size = stsz.sample_sizes[j];
		trak.samples_size += sample.size;
		/* computing chunk-based properties (offset, sample description index)*/
		if (j === 0) {				
			chunk_index = 1; /* the first sample is in the first chunk (chunk indexes are 1-based) */
			chunk_run_index = 0; /* the first chunk is the first entry in the first_chunk table */
			sample.chunk_index = chunk_index;
			sample.chunk_run_index = chunk_run_index;
			last_sample_in_chunk = stsc.samples_per_chunk[chunk_run_index];
			offset_in_chunk = 0;

			/* Is there another entry in the first_chunk table ? */
			if (chunk_run_index + 1 < stsc.first_chunk.length) {
				/* The last chunk in the run is the chunk before the next first chunk */
				last_chunk_in_run = stsc.first_chunk[chunk_run_index+1]-1; 	
			} else {
				/* There is only one entry in the table, it is valid for all future chunks*/
				last_chunk_in_run = Infinity;
			}
		} else {
			if (j < last_sample_in_chunk) {
				/* the sample is still in the current chunk */
				sample.chunk_index = chunk_index;
				sample.chunk_run_index = chunk_run_index;
			} else {
				/* the sample is in the next chunk */
				chunk_index++;
				sample.chunk_index = chunk_index;
				/* reset the accumulated offset in the chunk */
				offset_in_chunk = 0;
				if (chunk_index <= last_chunk_in_run) ; else {
					chunk_run_index++;
					/* Is there another entry in the first_chunk table ? */
					if (chunk_run_index + 1 < stsc.first_chunk.length) {
						/* The last chunk in the run is the chunk before the next first chunk */
						last_chunk_in_run = stsc.first_chunk[chunk_run_index+1]-1; 	
					} else {
						/* There is only one entry in the table, it is valid for all future chunks*/
						last_chunk_in_run = Infinity;
					}
					
				}
				sample.chunk_run_index = chunk_run_index;
				last_sample_in_chunk += stsc.samples_per_chunk[chunk_run_index];
			}
		}

		sample.description_index = stsc.sample_description_index[sample.chunk_run_index]-1;
		sample.description = stsd.entries[sample.description_index];
		sample.offset = stco.chunk_offsets[sample.chunk_index-1] + offset_in_chunk; /* chunk indexes are 1-based */
		offset_in_chunk += sample.size;

		/* setting dts, cts, duration and rap flags */
		if (j > last_sample_in_stts_run) {
			stts_run_index++;
			if (last_sample_in_stts_run < 0) {
				last_sample_in_stts_run = 0;
			}
			last_sample_in_stts_run += stts.sample_counts[stts_run_index];				
		}
		if (j > 0) {
			trak.samples[j-1].duration = stts.sample_deltas[stts_run_index];
			trak.samples_duration += trak.samples[j-1].duration;
			sample.dts = trak.samples[j-1].dts + trak.samples[j-1].duration;
		} else {
			sample.dts = 0;
		}
		if (ctts) {
			if (j >= last_sample_in_ctts_run) {
				ctts_run_index++;
				if (last_sample_in_ctts_run < 0) {
					last_sample_in_ctts_run = 0;
				}
				last_sample_in_ctts_run += ctts.sample_counts[ctts_run_index];				
			}
			sample.cts = trak.samples[j].dts + ctts.sample_offsets[ctts_run_index];
		} else {
			sample.cts = sample.dts;
		}
		if (stss) {
			if (j == stss.sample_numbers[last_stss_index] - 1) { // sample numbers are 1-based
				sample.is_sync = true;
				last_stss_index++;
			} else {
				sample.is_sync = false;				
				sample.degradation_priority = 0;
			}
			if (subs) {
				if (subs.entries[subs_entry_index].sample_delta + last_subs_sample_index == j+1) {
					sample.subsamples = subs.entries[subs_entry_index].subsamples;
					last_subs_sample_index += subs.entries[subs_entry_index].sample_delta;
					subs_entry_index++;
				}
			}
		} else {
			sample.is_sync = true;
		}
		ISOFile.process_sdtp(trak.mdia.minf.stbl.sdtp, sample, sample.number);
		if (stdp) {
			sample.degradation_priority = stdp.priority[j];
		} else {
			sample.degradation_priority = 0;
		}
		if (subs) {
			if (subs.entries[subs_entry_index].sample_delta + last_subs_sample_index == j) {
				sample.subsamples = subs.entries[subs_entry_index].subsamples;
				last_subs_sample_index += subs.entries[subs_entry_index].sample_delta;
			}
		}
		if (sbgps.length > 0 || sgpds.length > 0) {
			ISOFile.setSampleGroupProperties(trak, sample, j, trak.sample_groups_info);
		}
	}
	if (j>0) {
		trak.samples[j-1].duration = Math.max(trak.mdia.mdhd.duration - trak.samples[j-1].dts, 0);
		trak.samples_duration += trak.samples[j-1].duration;
	}
};

/* Update sample list when new 'moof' boxes are received */
ISOFile.prototype.updateSampleLists = function() {	
	var i, j, k;
	var default_sample_description_index, default_sample_duration, default_sample_size, default_sample_flags;
	var last_run_position;
	var box, moof, traf, trak, trex;
	var sample;
	var sample_flags;
	
	if (this.moov === undefined) {
		return;
	}
	/* if the input file is fragmented and fetched in multiple downloads, we need to update the list of samples */
	while (this.lastMoofIndex < this.moofs.length) {
		box = this.moofs[this.lastMoofIndex];
		this.lastMoofIndex++;
		if (box.type == "moof") {
			moof = box;
			for (i = 0; i < moof.trafs.length; i++) {
				traf = moof.trafs[i];
				trak = this.getTrackById(traf.tfhd.track_id);
				trex = this.getTrexById(traf.tfhd.track_id);
				if (traf.tfhd.flags & BoxParser.TFHD_FLAG_SAMPLE_DESC) {
					default_sample_description_index = traf.tfhd.default_sample_description_index;
				} else {
					default_sample_description_index = (trex ? trex.default_sample_description_index: 1);
				}
				if (traf.tfhd.flags & BoxParser.TFHD_FLAG_SAMPLE_DUR) {
					default_sample_duration = traf.tfhd.default_sample_duration;
				} else {
					default_sample_duration = (trex ? trex.default_sample_duration : 0);
				}
				if (traf.tfhd.flags & BoxParser.TFHD_FLAG_SAMPLE_SIZE) {
					default_sample_size = traf.tfhd.default_sample_size;
				} else {
					default_sample_size = (trex ? trex.default_sample_size : 0);
				}
				if (traf.tfhd.flags & BoxParser.TFHD_FLAG_SAMPLE_FLAGS) {
					default_sample_flags = traf.tfhd.default_sample_flags;
				} else {
					default_sample_flags = (trex ? trex.default_sample_flags : 0);
				}
				traf.sample_number = 0;
				/* process sample groups */
				if (traf.sbgps.length > 0) {
					ISOFile.initSampleGroups(trak, traf, traf.sbgps, trak.mdia.minf.stbl.sgpds, traf.sgpds);
				}
				for (j = 0; j < traf.truns.length; j++) {
					var trun = traf.truns[j];
					for (k = 0; k < trun.sample_count; k++) {
						sample = {};
						sample.moof_number = this.lastMoofIndex;
						sample.number_in_traf = traf.sample_number;
						traf.sample_number++;
			            sample.number = trak.samples.length;
						traf.first_sample_index = trak.samples.length;
						trak.samples.push(sample);
						sample.track_id = trak.tkhd.track_id;
						sample.timescale = trak.mdia.mdhd.timescale;
						sample.description_index = default_sample_description_index-1;
						sample.description = trak.mdia.minf.stbl.stsd.entries[sample.description_index];
						sample.size = default_sample_size;
						if (trun.flags & BoxParser.TRUN_FLAGS_SIZE) {
							sample.size = trun.sample_size[k];
						}
						trak.samples_size += sample.size;
						sample.duration = default_sample_duration;
						if (trun.flags & BoxParser.TRUN_FLAGS_DURATION) {
							sample.duration = trun.sample_duration[k];
						}
						trak.samples_duration += sample.duration;
						if (trak.first_traf_merged || k > 0) {
							sample.dts = trak.samples[trak.samples.length-2].dts+trak.samples[trak.samples.length-2].duration;
						} else {
							if (traf.tfdt) {
								sample.dts = traf.tfdt.baseMediaDecodeTime;
							} else {
								sample.dts = 0;
							}
							trak.first_traf_merged = true;
						}
						sample.cts = sample.dts;
						if (trun.flags & BoxParser.TRUN_FLAGS_CTS_OFFSET) {
							sample.cts = sample.dts + trun.sample_composition_time_offset[k];
						}
						sample_flags = default_sample_flags;
						if (trun.flags & BoxParser.TRUN_FLAGS_FLAGS) {
							sample_flags = trun.sample_flags[k];
						} else if (k === 0 && (trun.flags & BoxParser.TRUN_FLAGS_FIRST_FLAG)) {
							sample_flags = trun.first_sample_flags;
						}
						sample.is_sync = ((sample_flags >> 16 & 0x1) ? false : true);
						sample.is_leading = (sample_flags >> 26 & 0x3);
						sample.depends_on = (sample_flags >> 24 & 0x3);
						sample.is_depended_on = (sample_flags >> 22 & 0x3);
						sample.has_redundancy = (sample_flags >> 20 & 0x3);
						sample.degradation_priority = (sample_flags & 0xFFFF);
						//ISOFile.process_sdtp(traf.sdtp, sample, sample.number_in_traf);
						var bdop = (traf.tfhd.flags & BoxParser.TFHD_FLAG_BASE_DATA_OFFSET) ? true : false;
						var dbim = (traf.tfhd.flags & BoxParser.TFHD_FLAG_DEFAULT_BASE_IS_MOOF) ? true : false;
						var dop = (trun.flags & BoxParser.TRUN_FLAGS_DATA_OFFSET) ? true : false;
						var bdo = 0;
						if (!bdop) {
							if (!dbim) {
								if (j === 0) { // the first track in the movie fragment
									bdo = moof.start; // the position of the first byte of the enclosing Movie Fragment Box
								} else {
									bdo = last_run_position; // end of the data defined by the preceding *track* (irrespective of the track id) fragment in the moof
								}
							} else {
								bdo = moof.start;
							}
						} else {
							bdo = traf.tfhd.base_data_offset;
						}
						if (j === 0 && k === 0) {
							if (dop) {
								sample.offset = bdo + trun.data_offset; // If the data-offset is present, it is relative to the base-data-offset established in the track fragment header
							} else {
								sample.offset = bdo; // the data for this run starts the base-data-offset defined by the track fragment header
							}
						} else {
							sample.offset = last_run_position; // this run starts immediately after the data of the previous run
						}
						last_run_position = sample.offset + sample.size;
						if (traf.sbgps.length > 0 || traf.sgpds.length > 0 ||
							trak.mdia.minf.stbl.sbgps.length > 0 || trak.mdia.minf.stbl.sgpds.length > 0) {
							ISOFile.setSampleGroupProperties(trak, sample, sample.number_in_traf, traf.sample_groups_info);
						}
					}
				}
				if (traf.subs) {
					trak.has_fragment_subsamples = true;
					var sample_index = traf.first_sample_index;
					for (j = 0; j < traf.subs.entries.length; j++) {
						sample_index += traf.subs.entries[j].sample_delta;
						sample = trak.samples[sample_index-1];
						sample.subsamples = traf.subs.entries[j].subsamples;
					}					
				}
			}
		}
	}	
};

/* Try to get sample data for a given sample:
   returns null if not found
   returns the same sample if already requested
 */
ISOFile.prototype.getSample = function(trak, sampleNum) {	
	var buffer;
	var sample = trak.samples[sampleNum];
	
	if (!this.moov) {
		return null;
	}

	if (!sample.data) {
		/* Not yet fetched */
		sample.data = new Uint8Array(sample.size);
		sample.alreadyRead = 0;
		this.samplesDataSize += sample.size;
		Log.debug("ISOFile", "Allocating sample #"+sampleNum+" on track #"+trak.tkhd.track_id+" of size "+sample.size+" (total: "+this.samplesDataSize+")");
	} else if (sample.alreadyRead == sample.size) {
		/* Already fetched entirely */
		return sample;
	}

	/* The sample has only been partially fetched, we need to check in all buffers */
	while(true) {
		var index =	this.stream.findPosition(true, sample.offset + sample.alreadyRead, false);
		if (index > -1) {
			buffer = this.stream.buffers[index];
			var lengthAfterStart = buffer.byteLength - (sample.offset + sample.alreadyRead - buffer.fileStart);
			if (sample.size - sample.alreadyRead <= lengthAfterStart) {
				/* the (rest of the) sample is entirely contained in this buffer */

				Log.debug("ISOFile","Getting sample #"+sampleNum+" data (alreadyRead: "+sample.alreadyRead+" offset: "+
					(sample.offset+sample.alreadyRead - buffer.fileStart)+" read size: "+(sample.size - sample.alreadyRead)+" full size: "+sample.size+")");

				DataStream.memcpy(sample.data.buffer, sample.alreadyRead,
				                  buffer, sample.offset+sample.alreadyRead - buffer.fileStart, sample.size - sample.alreadyRead);

				/* update the number of bytes used in this buffer and check if it needs to be removed */
				buffer.usedBytes += sample.size - sample.alreadyRead;
				this.stream.logBufferLevel();

				sample.alreadyRead = sample.size;

				return sample;
			} else {
				/* the sample does not end in this buffer */

				if (lengthAfterStart === 0) return null;

				Log.debug("ISOFile","Getting sample #"+sampleNum+" partial data (alreadyRead: "+sample.alreadyRead+" offset: "+
					(sample.offset+sample.alreadyRead - buffer.fileStart)+" read size: "+lengthAfterStart+" full size: "+sample.size+")");

				DataStream.memcpy(sample.data.buffer, sample.alreadyRead,
				                  buffer, sample.offset+sample.alreadyRead - buffer.fileStart, lengthAfterStart);
				sample.alreadyRead += lengthAfterStart;

				/* update the number of bytes used in this buffer and check if it needs to be removed */
				buffer.usedBytes += lengthAfterStart;
				this.stream.logBufferLevel();

				/* keep looking in the next buffer */
			}
		} else {
			return null;
		}
	}
};

/* Release the memory used to store the data of the sample */
ISOFile.prototype.releaseSample = function(trak, sampleNum) {	
	var sample = trak.samples[sampleNum];
	if (sample.data) {
		this.samplesDataSize -= sample.size;
		sample.data = null;
		sample.alreadyRead = 0;
		return sample.size;
	} else {
		return 0;
	}
};

ISOFile.prototype.getAllocatedSampleDataSize = function() {
	return this.samplesDataSize;
};

/* Builds the MIME Type 'codecs' sub-parameters for the whole file */
ISOFile.prototype.getCodecs = function() {	
	var i;
	var codecs = "";
	for (i = 0; i < this.moov.traks.length; i++) {
		var trak = this.moov.traks[i];
		if (i>0) {
			codecs+=","; 
		}
		codecs += trak.mdia.minf.stbl.stsd.entries[0].getCodec();		
	}
	return codecs;
};

/* Helper function */
ISOFile.prototype.getTrexById = function(id) {	
	var i;
	if (!this.moov || !this.moov.mvex) return null;
	for (i = 0; i < this.moov.mvex.trexs.length; i++) {
		var trex = this.moov.mvex.trexs[i];
		if (trex.track_id == id) return trex;
	}
	return null;
};

/* Helper function */
ISOFile.prototype.getTrackById = function(id) {
	if (this.moov === undefined) {
		return null;
	}
	for (var j = 0; j < this.moov.traks.length; j++) {
		var trak = this.moov.traks[j];
		if (trak.tkhd.track_id == id) return trak;
	}
	return null;
};
// file:src/isofile-item-processing.js
ISOFile.prototype.items = [];
/* size of the buffers allocated for samples */
ISOFile.prototype.itemsDataSize = 0;

ISOFile.prototype.flattenItemInfo = function() {	
	var items = this.items;
	var i, j;
	var item;
	var meta = this.meta;
	if (meta === null || meta === undefined) return;
	if (meta.hdlr === undefined) return;
	if (meta.iinf === undefined) return;
	for (i = 0; i < meta.iinf.item_infos.length; i++) {
		item = {};
		item.id = meta.iinf.item_infos[i].item_ID;
		items[item.id] = item;
		item.ref_to = [];
		item.name = meta.iinf.item_infos[i].item_name;
		if (meta.iinf.item_infos[i].protection_index > 0) {
			item.protection = meta.ipro.protections[meta.iinf.item_infos[i].protection_index-1];
		}
		if (meta.iinf.item_infos[i].item_type) {
			item.type = meta.iinf.item_infos[i].item_type;
		} else {
			item.type = "mime";
		}
		item.content_type = meta.iinf.item_infos[i].content_type;
		item.content_encoding = meta.iinf.item_infos[i].content_encoding;
	}
	if (meta.iloc) {
		for(i = 0; i < meta.iloc.items.length; i++) {
			var itemloc = meta.iloc.items[i];
			item = items[itemloc.item_ID];
			if (itemloc.data_reference_index !== 0) {
				Log.warn("Item storage with reference to other files: not supported");
				item.source = meta.dinf.boxes[itemloc.data_reference_index-1];
			}
			switch(itemloc.construction_method) {
				case 0: // offset into the file referenced by the data reference index
				break;
				case 1: // offset into the idat box of this meta box
				Log.warn("Item storage with construction_method : not supported");
				break;
				case 2: // offset into another item
				Log.warn("Item storage with construction_method : not supported");
				break;
			}
			item.extents = [];
			item.size = 0;
			for (j = 0; j < itemloc.extents.length; j++) {
				item.extents[j] = {};
				item.extents[j].offset = itemloc.extents[j].extent_offset + itemloc.base_offset;
				item.extents[j].length = itemloc.extents[j].extent_length;
				item.extents[j].alreadyRead = 0;
				item.size += item.extents[j].length;
			}
		}
	}
	if (meta.pitm) {
		items[meta.pitm.item_id].primary = true;
	}
	if (meta.iref) {
		for (i=0; i <meta.iref.references.length; i++) {
			var ref = meta.iref.references[i];
			for (j=0; j<ref.references.length; j++) {
				items[ref.from_item_ID].ref_to.push({type: ref.type, id: ref.references[j]});
			}
		}
	}
	if (meta.iprp) {
		for (var k = 0; k < meta.iprp.ipmas.length; k++) {
			var ipma = meta.iprp.ipmas[k];
			for (i = 0; i < ipma.associations.length; i++) {
				var association = ipma.associations[i];
				item = items[association.id];
				if (item.properties === undefined) {
					item.properties = {};
					item.properties.boxes = [];
				}
				for (j = 0; j < association.props.length; j++) {
					var propEntry = association.props[j];
					if (propEntry.property_index > 0 && propEntry.property_index-1 < meta.iprp.ipco.boxes.length) {
						var propbox = meta.iprp.ipco.boxes[propEntry.property_index-1];
						item.properties[propbox.type] = propbox;
						item.properties.boxes.push(propbox);
					}
				}
			}
		}
	}
};

ISOFile.prototype.getItem = function(item_id) {	
	var buffer;
	var item;
	
	if (!this.meta) {
		return null;
	}

 	item = this.items[item_id];
	if (!item.data && item.size) {
		/* Not yet fetched */
		item.data = new Uint8Array(item.size);
		item.alreadyRead = 0;
		this.itemsDataSize += item.size;
		Log.debug("ISOFile", "Allocating item #"+item_id+" of size "+item.size+" (total: "+this.itemsDataSize+")");
	} else if (item.alreadyRead === item.size) {
		/* Already fetched entirely */
		return item;
	}

	/* The item has only been partially fetched, we need to check in all buffers to find the remaining extents*/

	for (var i = 0; i < item.extents.length; i++) {
		var extent = item.extents[i];
		if (extent.alreadyRead === extent.length) {
			continue;
		} else {
			var index =	this.stream.findPosition(true, extent.offset + extent.alreadyRead, false);
			if (index > -1) {
				buffer = this.stream.buffers[index];
				var lengthAfterStart = buffer.byteLength - (extent.offset + extent.alreadyRead - buffer.fileStart);
				if (extent.length - extent.alreadyRead <= lengthAfterStart) {
					/* the (rest of the) extent is entirely contained in this buffer */

					Log.debug("ISOFile","Getting item #"+item_id+" extent #"+i+" data (alreadyRead: "+extent.alreadyRead+
						" offset: "+(extent.offset+extent.alreadyRead - buffer.fileStart)+" read size: "+(extent.length - extent.alreadyRead)+
						" full extent size: "+extent.length+" full item size: "+item.size+")");

					DataStream.memcpy(item.data.buffer, item.alreadyRead, 
					                  buffer, extent.offset+extent.alreadyRead - buffer.fileStart, extent.length - extent.alreadyRead);

					/* update the number of bytes used in this buffer and check if it needs to be removed */
					buffer.usedBytes += extent.length - extent.alreadyRead;
					this.stream.logBufferLevel();

					item.alreadyRead += (extent.length - extent.alreadyRead);
					extent.alreadyRead = extent.length;
				} else {
					/* the sample does not end in this buffer */

					Log.debug("ISOFile","Getting item #"+item_id+" extent #"+i+" partial data (alreadyRead: "+extent.alreadyRead+" offset: "+
						(extent.offset+extent.alreadyRead - buffer.fileStart)+" read size: "+lengthAfterStart+
						" full extent size: "+extent.length+" full item size: "+item.size+")");

					DataStream.memcpy(item.data.buffer, item.alreadyRead, 
					                  buffer, extent.offset+extent.alreadyRead - buffer.fileStart, lengthAfterStart);
					extent.alreadyRead += lengthAfterStart;
					item.alreadyRead += lengthAfterStart;

					/* update the number of bytes used in this buffer and check if it needs to be removed */
					buffer.usedBytes += lengthAfterStart;
					this.stream.logBufferLevel();
					return null;
				}
			} else {
				return null;
			}
		}
	}
	if (item.alreadyRead === item.size) {
		/* fetched entirely */
		return item;
	} else {
		return null;
	}
};

/* Release the memory used to store the data of the item */
ISOFile.prototype.releaseItem = function(item_id) {	
	var item = this.items[item_id];
	if (item.data) {
		this.itemsDataSize -= item.size;
		item.data = null;
		item.alreadyRead = 0;
		for (var i = 0; i < item.extents.length; i++) {
			var extent = item.extents[i];
			extent.alreadyRead = 0;
		}
		return item.size;
	} else {
		return 0;
	}
};


ISOFile.prototype.processItems = function(callback) {
	for(var i in this.items) {
		var item = this.items[i];
		this.getItem(item.id);
		if (callback && !item.sent) {
			callback(item);
			item.sent = true;
			item.data = null;
		}
	}
};

ISOFile.prototype.hasItem = function(name) {
	for(var i in this.items) {
		var item = this.items[i];
		if (item.name === name) {
			return item.id;
		}
	}
	return -1;
};

ISOFile.prototype.getMetaHandler = function() {
	if (!this.meta) {
		return null;
	} else {
		return this.meta.hdlr.handler;		
	}
};

ISOFile.prototype.getPrimaryItem = function() {
	if (!this.meta || !this.meta.pitm) {
		return null;
	} else {
		return this.getItem(this.meta.pitm.item_id);
	}
};

ISOFile.prototype.itemToFragmentedTrackFile = function(_options) {
	var options = _options || {};
	var item = null;
	if (options.itemId) {
		item = this.getItem(options.itemId);
	} else {
		item = this.getPrimaryItem();
	}
	if (item == null) return null;

	var file = new ISOFile();
	file.discardMdatData = false;
	// assuming the track type is the same as the item type
	var trackOptions = { type: item.type, description_boxes: item.properties.boxes};
	if (item.properties.ispe) {
		trackOptions.width = item.properties.ispe.image_width;
		trackOptions.height = item.properties.ispe.image_height;
	}
	var trackId = file.addTrack(trackOptions);
	if (trackId) {
		file.addSample(trackId, item.data);
		return file;
	} else {
		return null;
	}
};

// file:src/isofile-write.js
/* Rewrite the entire file */
ISOFile.prototype.write = function(outstream) {
	for (var i=0; i<this.boxes.length; i++) {
		this.boxes[i].write(outstream);
	}
};

ISOFile.prototype.createFragment = function(track_id, sampleNumber, stream_) {
	var trak = this.getTrackById(track_id);
	var sample = this.getSample(trak, sampleNumber);
	if (sample == null) {
		sample = trak.samples[sampleNumber];
		if (this.nextSeekPosition) {
			this.nextSeekPosition = Math.min(sample.offset+sample.alreadyRead,this.nextSeekPosition);
		} else {
			this.nextSeekPosition = trak.samples[sampleNumber].offset+sample.alreadyRead;
		}
		return null;
	}
	
	var stream = stream_ || new DataStream();
	stream.endianness = DataStream.BIG_ENDIAN;

	var moof = this.createSingleSampleMoof(sample);
	moof.write(stream);

	/* adjusting the data_offset now that the moof size is known*/
	moof.trafs[0].truns[0].data_offset = moof.size+8; //8 is mdat header
	Log.debug("MP4Box", "Adjusting data_offset with new value "+moof.trafs[0].truns[0].data_offset);
	stream.adjustUint32(moof.trafs[0].truns[0].data_offset_position, moof.trafs[0].truns[0].data_offset);
		
	var mdat = new BoxParser.mdatBox();
	mdat.data = sample.data;
	mdat.write(stream);
	return stream;
};

/* Modify the file and create the initialization segment */
ISOFile.writeInitializationSegment = function(ftyp, moov, total_duration, sample_duration) {
	var i;
	Log.debug("ISOFile", "Generating initialization segment");

	var stream = new DataStream();
	stream.endianness = DataStream.BIG_ENDIAN;
	ftyp.write(stream);
	
	/* we can now create the new mvex box */
	var mvex = moov.add("mvex");
	if (total_duration) {
		mvex.add("mehd").set("fragment_duration", total_duration);
	}
	for (i = 0; i < moov.traks.length; i++) {
		mvex.add("trex").set("track_id", moov.traks[i].tkhd.track_id)
						.set("default_sample_description_index", 1)
						.set("default_sample_duration", sample_duration)
						.set("default_sample_size", 0)
						.set("default_sample_flags", 1<<16);
	}
	moov.write(stream);

	return stream.buffer;

};

ISOFile.prototype.save = function(name) {
	var stream = new DataStream();
	stream.endianness = DataStream.BIG_ENDIAN;
	this.write(stream);
	stream.save(name);	
};

ISOFile.prototype.getBuffer = function() {
	var stream = new DataStream();
	stream.endianness = DataStream.BIG_ENDIAN;
	this.write(stream);
	return stream.buffer;
};

ISOFile.prototype.initializeSegmentation = function() {
	var i;
	var initSegs;
	var trak;
	var seg;
	if (this.onSegment === null) {
		Log.warn("MP4Box", "No segmentation callback set!");
	}
	if (!this.isFragmentationInitialized) {
		this.isFragmentationInitialized = true;		
		this.nextMoofNumber = 0;
		this.resetTables();
	}	
	initSegs = [];	
	for (i = 0; i < this.fragmentedTracks.length; i++) {
		var moov = new BoxParser.moovBox();
		moov.mvhd = this.moov.mvhd;
	    moov.boxes.push(moov.mvhd);
		trak = this.getTrackById(this.fragmentedTracks[i].id);
		moov.boxes.push(trak);
		moov.traks.push(trak);
		seg = {};
		seg.id = trak.tkhd.track_id;
		seg.user = this.fragmentedTracks[i].user;
		seg.buffer = ISOFile.writeInitializationSegment(this.ftyp, moov, (this.moov.mvex && this.moov.mvex.mehd ? this.moov.mvex.mehd.fragment_duration: undefined), (this.moov.traks[i].samples.length>0 ? this.moov.traks[i].samples[0].duration: 0));
		initSegs.push(seg);
	}
	return initSegs;
};

// file:src/box-print.js
/* 
 * Copyright (c) Telecom ParisTech/TSI/MM/GPAC Cyril Concolato
 * License: BSD-3-Clause (see LICENSE file)
 */
BoxParser.Box.prototype.printHeader = function(output) {
	this.size += 8;
	if (this.size > MAX_SIZE) {
		this.size += 8;
	}
	if (this.type === "uuid") {
		this.size += 16;
	}
	output.log(output.indent+"size:"+this.size);
	output.log(output.indent+"type:"+this.type);
};

BoxParser.FullBox.prototype.printHeader = function(output) {
	this.size += 4;
	BoxParser.Box.prototype.printHeader.call(this, output);
	output.log(output.indent+"version:"+this.version);
	output.log(output.indent+"flags:"+this.flags);
};

BoxParser.Box.prototype.print = function(output) {
	this.printHeader(output);
};

BoxParser.ContainerBox.prototype.print = function(output) {
	this.printHeader(output);
	for (var i=0; i<this.boxes.length; i++) {
		if (this.boxes[i]) {
			var prev_indent = output.indent;
			output.indent += " ";
			this.boxes[i].print(output);
			output.indent = prev_indent;
		}
	}
};

ISOFile.prototype.print = function(output) {
	output.indent = "";
	for (var i=0; i<this.boxes.length; i++) {
		if (this.boxes[i]) {
			this.boxes[i].print(output);
		}
	}	
};

BoxParser.mvhdBox.prototype.print = function(output) {
	BoxParser.FullBox.prototype.printHeader.call(this, output);
	output.log(output.indent+"creation_time: "+this.creation_time);
	output.log(output.indent+"modification_time: "+this.modification_time);
	output.log(output.indent+"timescale: "+this.timescale);
	output.log(output.indent+"duration: "+this.duration);
	output.log(output.indent+"rate: "+this.rate);
	output.log(output.indent+"volume: "+(this.volume>>8));
	output.log(output.indent+"matrix: "+this.matrix.join(", "));
	output.log(output.indent+"next_track_id: "+this.next_track_id);
};

BoxParser.tkhdBox.prototype.print = function(output) {
	BoxParser.FullBox.prototype.printHeader.call(this, output);
	output.log(output.indent+"creation_time: "+this.creation_time);
	output.log(output.indent+"modification_time: "+this.modification_time);
	output.log(output.indent+"track_id: "+this.track_id);
	output.log(output.indent+"duration: "+this.duration);
	output.log(output.indent+"volume: "+(this.volume>>8));
	output.log(output.indent+"matrix: "+this.matrix.join(", "));
	output.log(output.indent+"layer: "+this.layer);
	output.log(output.indent+"alternate_group: "+this.alternate_group);
	output.log(output.indent+"width: "+this.width);
	output.log(output.indent+"height: "+this.height);
};// file:src/mp4box.js
/*
 * Copyright (c) 2012-2013. Telecom ParisTech/TSI/MM/GPAC Cyril Concolato
 * License: BSD-3-Clause (see LICENSE file)
 */
var MP4Box = {};

MP4Box.createFile = function (_keepMdatData, _stream) {
	/* Boolean indicating if bytes containing media data should be kept in memory */
	var keepMdatData = (_keepMdatData !== undefined ? _keepMdatData : true);
	var file = new ISOFile(_stream);
	file.discardMdatData = (keepMdatData ? false : true);
	return file;
};

{
	exports.createFile = MP4Box.createFile;
}
}(mp4box_all));

/**
 * Taken from https://github.com/w3c/webcodecs/blob/main/samples/mp4-decode/mp4_demuxer.js
 */
var Writer = /*#__PURE__*/function () {
  function Writer(size) {
    _classCallCheck(this, Writer);
    this.data = new Uint8Array(size);
    this.idx = 0;
    this.size = size;
  }
  _createClass(Writer, [{
    key: "getData",
    value: function getData() {
      if (this.idx !== this.size) throw new Error('Mismatch between size reserved and sized used');
      return this.data.slice(0, this.idx);
    }
  }, {
    key: "writeUint8",
    value: function writeUint8(value) {
      this.data.set([value], this.idx);
      this.idx += 1;
    }
  }, {
    key: "writeUint16",
    value: function writeUint16(value) {
      var arr = new Uint16Array(1);
      arr[0] = value;
      var buffer = new Uint8Array(arr.buffer);
      this.data.set([buffer[1], buffer[0]], this.idx);
      this.idx += 2;
    }
  }, {
    key: "writeUint8Array",
    value: function writeUint8Array(value) {
      this.data.set(value, this.idx);
      this.idx += value.length;
    }
  }]);
  return Writer;
}();
/**
 * Taken from https://github.com/w3c/webcodecs/blob/main/samples/mp4-decode/mp4_demuxer.js
 *
 * @param avccBox
 * @returns {*}
 */
var getExtradata = function getExtradata(avccBox) {
  var i;
  var size = 7;
  for (i = 0; i < avccBox.SPS.length; i += 1) {
    // nalu length is encoded as a uint16.
    size += 2 + avccBox.SPS[i].length;
  }
  for (i = 0; i < avccBox.PPS.length; i += 1) {
    // nalu length is encoded as a uint16.
    size += 2 + avccBox.PPS[i].length;
  }
  var writer = new Writer(size);
  writer.writeUint8(avccBox.configurationVersion);
  writer.writeUint8(avccBox.AVCProfileIndication);
  writer.writeUint8(avccBox.profile_compatibility);
  writer.writeUint8(avccBox.AVCLevelIndication);
  // eslint-disable-next-line no-bitwise
  writer.writeUint8(avccBox.lengthSizeMinusOne + (63 << 2));

  // eslint-disable-next-line no-bitwise
  writer.writeUint8(avccBox.nb_SPS_nalus + (7 << 5));
  for (i = 0; i < avccBox.SPS.length; i += 1) {
    writer.writeUint16(avccBox.SPS[i].length);
    writer.writeUint8Array(avccBox.SPS[i].nalu);
  }
  writer.writeUint8(avccBox.nb_PPS_nalus);
  for (i = 0; i < avccBox.PPS.length; i += 1) {
    writer.writeUint16(avccBox.PPS[i].length);
    writer.writeUint8Array(avccBox.PPS[i].nalu);
  }
  return writer.getData();
};

/**
 * decodeVideo takes an url to a mp4 file and converts it into frames.
 *
 * The steps for this are:
 *  1. Determine the codec for this video file and demux it into chunks.
 *  2. Read the chunks with VideoDecoder as fast as possible.
 *  3. Return an array of frames that we can efficiently draw to a canvas.
 *
 * @param src
 * @param VideoDecoder
 * @param EncodedVideoChunk
 * @param emitFrame
 * @param debug
 * @returns {Promise<unknown>}
 */
var decodeVideo = function decodeVideo(src, emitFrame, _ref) {
  var VideoDecoder = _ref.VideoDecoder,
    EncodedVideoChunk = _ref.EncodedVideoChunk,
    debug = _ref.debug;
  return new Promise(function (resolve, reject) {
    if (debug) console.info('Decoding video from', src);
    try {
      // Uses mp4box for demuxing
      var mp4boxfile = mp4box_all.createFile();

      // Holds the codec value
      var codec;

      // Creates a VideoDecoder instance
      var decoder = new VideoDecoder({
        output: function output(frame) {
          createImageBitmap(frame, {
            resizeQuality: 'low'
          }).then(function (bitmap) {
            emitFrame(bitmap);
            frame.close();
            if (decoder.decodeQueueSize <= 0) {
              // Give it an extra half second to finish everything
              setTimeout(function () {
                if (decoder.state !== 'closed') {
                  decoder.close();
                  resolve();
                }
              }, 500);
            }
          });
        },
        error: function error(e) {
          // eslint-disable-next-line no-console
          console.error(e);
          reject(e);
        }
      });
      mp4boxfile.onReady = function (info) {
        if (info && info.videoTracks && info.videoTracks[0]) {
          var _info$videoTracks = _slicedToArray(info.videoTracks, 1);
          codec = _info$videoTracks[0].codec;
          if (debug) console.info('Video with codec:', codec);

          // Gets the avccbox used for reading extradata
          var avccBox = mp4boxfile.moov.traks[0].mdia.minf.stbl.stsd.entries[0].avcC;
          var extradata = getExtradata(avccBox);

          // configure decoder
          decoder.configure({
            codec: codec,
            description: extradata
          });

          // Setup mp4box file for breaking it into chunks
          mp4boxfile.setExtractionOptions(info.videoTracks[0].id);
          mp4boxfile.start();
        } else reject(new Error('URL provided is not a valid mp4 video file.'));
      };
      mp4boxfile.onSamples = function (track_id, ref, samples) {
        for (var i = 0; i < samples.length; i += 1) {
          var sample = samples[i];
          var type = sample.is_sync ? 'key' : 'delta';
          var chunk = new EncodedVideoChunk({
            type: type,
            timestamp: sample.cts,
            duration: sample.duration,
            data: sample.data
          });
          decoder.decode(chunk);
        }
      };

      // Fetches the file into arraybuffers
      fetch(src).then(function (res) {
        var reader = res.body.getReader();
        var offset = 0;
        function appendBuffers(_ref2) {
          var done = _ref2.done,
            value = _ref2.value;
          if (done) {
            mp4boxfile.flush();
            return null;
          }
          var buf = value.buffer;
          buf.fileStart = offset;
          offset += buf.byteLength;
          mp4boxfile.appendBuffer(buf);
          return reader.read().then(appendBuffers);
        }
        return reader.read().then(appendBuffers);
      });
    } catch (e) {
      reject(e);
    }
  });
};

/**
 * The main function for decoding video. Deals with the polyfill cases first,
 * then calls our decodeVideo.
 *
 * @param src
 * @param emitFrame
 * @param debug
 * @returns {Promise<never>|Promise<void>|*}
 */
var videoDecoder = (function (src, emitFrame, debug) {
  // If our browser supports WebCodecs natively
  if (typeof VideoDecoder === 'function' && typeof EncodedVideoChunk === 'function') {
    if (debug) console.info('WebCodecs is natively supported, using native version...');
    return decodeVideo(src, emitFrame, {
      VideoDecoder: VideoDecoder,
      EncodedVideoChunk: EncodedVideoChunk,
      debug: debug
    });
  }

  // Otherwise, resolve nothing
  if (debug) console.info('WebCodecs is not available in this browser.');
  return Promise.resolve();
});

function debounce(func) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var timeoutId;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var context = this;

    // Clear the previous timeout if it exists
    clearTimeout(timeoutId);

    // Set a new timeout to call the function later
    timeoutId = setTimeout(function () {
      func.apply(context, args);
    }, delay);
  };
}
var isScrollPositionAtTarget = function isScrollPositionAtTarget(targetScrollPosition) {
  var threshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  // eslint-disable-next-line no-undef
  var currentScrollPosition = window.pageYOffset;
  var difference = Math.abs(currentScrollPosition - targetScrollPosition);
  return difference < threshold;
};

/**
 *   ____                 _ _     __     ___     _
 *  / ___|  ___ _ __ ___ | | |_   \ \   / (_) __| | ___  ___
 *  \___ \ / __| '__/ _ \| | | | | \ \ / /| |/ _` |/ _ \/ _ \
 *   ___) | (__| | | (_) | | | |_| |\ V / | | (_| |  __/ (_) |
 *  |____/ \___|_|  \___/|_|_|\__, | \_/  |_|\__,_|\___|\___/
 *                            |___/
 *
 * Responsive scrollable videos without obscure video encoding requirements.
 * Compatible with React, Svelte, Vue, and plain HTML.
 */
var ScrollyVideo = /*#__PURE__*/function () {
  function ScrollyVideo(_ref) {
    var _this = this;
    var src = _ref.src,
      scrollyVideoContainer = _ref.scrollyVideoContainer,
      _ref$cover = _ref.cover,
      cover = _ref$cover === void 0 ? true : _ref$cover,
      _ref$sticky = _ref.sticky,
      sticky = _ref$sticky === void 0 ? true : _ref$sticky,
      _ref$full = _ref.full,
      full = _ref$full === void 0 ? true : _ref$full,
      _ref$trackScroll = _ref.trackScroll,
      trackScroll = _ref$trackScroll === void 0 ? true : _ref$trackScroll,
      _ref$lockScroll = _ref.lockScroll,
      lockScroll = _ref$lockScroll === void 0 ? true : _ref$lockScroll,
      _ref$transitionSpeed = _ref.transitionSpeed,
      transitionSpeed = _ref$transitionSpeed === void 0 ? 8 : _ref$transitionSpeed,
      _ref$frameThreshold = _ref.frameThreshold,
      frameThreshold = _ref$frameThreshold === void 0 ? 0.1 : _ref$frameThreshold,
      _ref$useWebCodecs = _ref.useWebCodecs,
      useWebCodecs = _ref$useWebCodecs === void 0 ? true : _ref$useWebCodecs,
      _ref$onReady = _ref.onReady,
      onReady = _ref$onReady === void 0 ? function () {} : _ref$onReady,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      _ref$debug = _ref.debug,
      debug = _ref$debug === void 0 ? false : _ref$debug;
    _classCallCheck(this, ScrollyVideo);
    // Make sure that we have a DOM
    if ((typeof document === "undefined" ? "undefined" : _typeof(document)) !== 'object') {
      console.error('ScrollyVideo must be initiated in a DOM context');
      return;
    }

    // Make sure the basic arguments are set for scrollyvideo
    if (!scrollyVideoContainer) {
      console.error('scrollyVideoContainer must be a valid DOM object');
      return;
    }
    if (!src) {
      console.error('Must provide valid video src to ScrollyVideo');
      return;
    }

    // Save the container. If the container is a string we get the element
    // eslint-disable-next-line no-undef
    if (scrollyVideoContainer instanceof Element) this.container = scrollyVideoContainer;
    // otherwise it should better be an element
    else if (typeof scrollyVideoContainer === 'string') {
      // eslint-disable-next-line no-undef
      this.container = document.getElementById(scrollyVideoContainer);
      if (!this.container) throw new Error('scrollyVideoContainer must be a valid DOM object');
    } else {
      throw new Error('scrollyVideoContainer must be a valid DOM object');
    }

    // Save the constructor options
    this.src = src;
    this.transitionSpeed = transitionSpeed;
    this.frameThreshold = frameThreshold;
    this.useWebCodecs = useWebCodecs;
    this.cover = cover;
    this.sticky = sticky;
    this.trackScroll = trackScroll;
    this.onReady = onReady;
    this.onChange = onChange;
    this.debug = debug;

    // Create the initial video object. Even if we are going to use webcodecs,
    // we start with a paused video object
    // eslint-disable-next-line no-undef
    this.video = document.createElement('video');
    this.video.src = src;
    this.video.preload = 'auto';
    this.video.tabIndex = 0;
    this.video.autobuffer = true;
    this.video.playsInline = true;
    this.video.muted = true;
    this.video.pause();
    this.video.load();

    // Start the video percentage at 0
    this.videoPercentage = 0;

    // Adds the video to the container
    this.container.appendChild(this.video);

    // Setting CSS properties for sticky
    if (sticky) {
      this.container.style.display = 'block';
      this.container.style.position = 'sticky';
      this.container.style.top = '0';
    }

    // Setting CSS properties for full
    if (full) {
      this.container.style.width = '100%';
      this.container.style.height = '100vh';
      this.container.style.overflow = 'hidden';
    }

    // Setting CSS properties for cover
    if (cover) this.setCoverStyle(this.video);

    // Detect webkit (safari), because webkit requires special attention
    var browserEngine = new UAParser().getEngine();
    // eslint-disable-next-line no-undef
    this.isSafari = browserEngine.name === 'WebKit';
    if (debug && this.isSafari) console.info('Safari browser detected');

    // Initialize state variables
    this.currentTime = 0; // Saves the currentTime of the video, synced with this.video.currentTime
    this.targetTime = 0; // The target time before a transition happens
    this.canvas = null; // The canvas for drawing the frames decoded by webCodecs
    this.context = null; // The canvas context
    this.frames = []; // The frames decoded by webCodecs
    this.frameRate = 0; // Calculation of frameRate so we know which frame to paint

    var debouncedScroll = debounce(function () {
      // eslint-disable-next-line no-undef
      window.requestAnimationFrame(function () {
        _this.setScrollPercent(_this.videoPercentage);
      });
    }, 100);

    // Add scroll listener for responding to scroll position
    this.updateScrollPercentage = function (jump) {
      // Used for internally setting the scroll percentage based on built-in listeners
      var containerBoundingClientRect = _this.container.parentNode.getBoundingClientRect();

      // Calculate the current scroll percent of the video
      var scrollPercent = -containerBoundingClientRect.top / (
      // eslint-disable-next-line no-undef
      containerBoundingClientRect.height - window.innerHeight);
      if (_this.debug) {
        console.info('ScrollyVideo scrolled to', scrollPercent);
      }
      if (_this.targetScrollPosition == null) {
        _this.setTargetTimePercent(scrollPercent, {
          jump: jump
        });
        _this.onChange(scrollPercent);
      } else if (isScrollPositionAtTarget(_this.targetScrollPosition)) {
        _this.targetScrollPosition = null;
      } else if (lockScroll && _this.targetScrollPosition != null) {
        debouncedScroll();
      }
    };

    // Add our event listeners for handling changes to the window or scroll
    if (this.trackScroll) {
      // eslint-disable-next-line no-undef
      window.addEventListener('scroll', this.updateScrollPercentage);

      // Set the initial scroll percentage
      this.video.addEventListener('loadedmetadata', function () {
        return _this.updateScrollPercentage(true);
      }, {
        once: true
      });
    } else {
      this.video.addEventListener('loadedmetadata', function () {
        return _this.setTargetTimePercent(0, {
          jump: true
        });
      }, {
        once: true
      });
    }

    // Add resize function
    this.resize = function () {
      if (_this.debug) console.info('ScrollyVideo resizing...');
      // On resize, we need to reset the cover style
      if (_this.cover) _this.setCoverStyle(_this.canvas || _this.video);
      // Then repaint the canvas, if we are in useWebcodecs
      _this.paintCanvasFrame(Math.floor(_this.currentTime * _this.frameRate));
    };

    // eslint-disable-next-line no-undef
    window.addEventListener('resize', this.resize);
    this.video.addEventListener('progress', this.resize);

    // Calls decode video to attempt webcodecs method
    this.decodeVideo();
  }

  /**
   * Sets the currentTime of the video as a specified percentage of its total duration.
   *
   * @param percentage - The percentage of the video duration to set as the current time.
   * @param options - Configuration options for adjusting the video playback.
   *    - jump: boolean - If true, the video currentTime will jump directly to the specified percentage. If false, the change will be animated over time.
   *    - transitionSpeed: number - Defines the speed of the transition when `jump` is false. Represents the duration of the transition in milliseconds. Default is 8.
   *    - easing: (progress: number) => number - A function that defines the easing curve for the transition. It takes the progress ratio (a number between 0 and 1) as an argument and returns the eased value, affecting the playback speed during the transition.
   */
  _createClass(ScrollyVideo, [{
    key: "setVideoPercentage",
    value: function setVideoPercentage(percentage) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // Early termination if the video percentage is already at the percentage that is intended.
      if (this.videoPercentage === percentage) return;
      if (this.transitioningRaf) {
        // eslint-disable-next-line no-undef
        window.cancelAnimationFrame(this.transitioningRaf);
      }
      this.videoPercentage = percentage;
      this.onChange(percentage);
      if (this.trackScroll) {
        this.setScrollPercent(percentage);
      }
      this.setTargetTimePercent(percentage, options);
    }

    /**
     * Sets the style of the video or canvas to "cover" it's container
     *
     * @param el
     */
  }, {
    key: "setCoverStyle",
    value: function setCoverStyle(el) {
      if (this.cover) {
        /* eslint-disable no-param-reassign */
        el.style.position = 'absolute';
        el.style.top = '50%';
        el.style.left = '50%';
        el.style.transform = 'translate(-50%, -50%)';
        el.style.minWidth = '101%';
        el.style.minHeight = '101%';

        // Gets the width and height of the container
        var _this$container$getBo = this.container.getBoundingClientRect(),
          containerWidth = _this$container$getBo.width,
          containerHeight = _this$container$getBo.height;

        // Gets the width and height of the video frames
        var width = el.videoWidth || el.width;
        var height = el.videoHeight || el.height;
        if (this.debug) console.info('Container dimensions:', [containerWidth, containerHeight]);
        if (this.debug) console.info('Element dimensions:', [width, height]);

        // Determines which axis needs to be 100% and which needs to be scaled
        if (containerWidth / containerHeight > width / height) {
          el.style.width = '100%';
          el.style.height = 'auto';
        } else {
          el.style.height = '100%';
          el.style.width = 'auto';
        }
        /* eslint-enable no-param-reassign */
      }
    }

    /**
     * Uses webCodecs to decode the video into frames
     */
  }, {
    key: "decodeVideo",
    value: function () {
      var _decodeVideo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this2 = this;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this.useWebCodecs) {
                _context.next = 3;
                break;
              }
              if (this.debug) console.warn('Cannot perform video decode: `useWebCodes` disabled');
              return _context.abrupt("return");
            case 3:
              if (this.src) {
                _context.next = 6;
                break;
              }
              if (this.debug) console.warn('Cannot perform video decode: no `src` found');
              return _context.abrupt("return");
            case 6:
              _context.prev = 6;
              _context.next = 9;
              return videoDecoder(this.src, function (frame) {
                _this2.frames.push(frame);
              }, this.debug);
            case 9:
              _context.next = 16;
              break;
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](6);
              if (this.debug) console.error('Error encountered while decoding video', _context.t0);

              // Remove all decoded frames if a failure happens during decoding
              this.frames = [];

              // Force a video reload when videoDecoder fails
              this.video.load();
            case 16:
              if (!(this.frames.length === 0)) {
                _context.next = 20;
                break;
              }
              if (this.debug) console.error('No frames were received from webCodecs');
              this.onReady();
              return _context.abrupt("return");
            case 20:
              // Calculate the frameRate based on number of frames and the duration
              this.frameRate = this.frames.length / this.video.duration;
              if (this.debug) console.info('Received', this.frames.length, 'frames');

              // Remove the video and add the canvas
              // eslint-disable-next-line no-undef
              this.canvas = document.createElement('canvas');
              this.context = this.canvas.getContext('2d');

              // Hide the video and add the canvas to the container
              this.video.style.display = 'none';
              this.container.appendChild(this.canvas);
              if (this.cover) this.setCoverStyle(this.canvas);

              // Paint our first frame
              this.paintCanvasFrame(Math.floor(this.currentTime * this.frameRate));
              this.onReady();
            case 29:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[6, 11]]);
      }));
      function decodeVideo() {
        return _decodeVideo.apply(this, arguments);
      }
      return decodeVideo;
    }()
    /**
     * Paints the frame of to the canvas
     *
     * @param frameNum
     */
  }, {
    key: "paintCanvasFrame",
    value: function paintCanvasFrame(frameNum) {
      // Get the frame and paint it to the canvas
      var currFrame = this.frames[frameNum];
      if (!this.canvas || !currFrame) {
        return;
      }
      if (this.debug) {
        console.info('Painting frame', frameNum);
      }

      // Make sure the canvas is scaled properly, similar to setCoverStyle
      this.canvas.width = currFrame.width;
      this.canvas.height = currFrame.height;
      var _this$container$getBo2 = this.container.getBoundingClientRect(),
        width = _this$container$getBo2.width,
        height = _this$container$getBo2.height;
      if (width / height > currFrame.width / currFrame.height) {
        this.canvas.style.width = '100%';
        this.canvas.style.height = 'auto';
      } else {
        this.canvas.style.height = '100%';
        this.canvas.style.width = 'auto';
      }

      // Draw the frame to the canvas context
      this.context.drawImage(currFrame, 0, 0, currFrame.width, currFrame.height);
    }

    /**
     * Transitions the video or the canvas to the proper frame.
     *
     * @param options - Configuration options for adjusting the video playback.
     *    - jump: boolean - If true, the video currentTime will jump directly to the specified percentage. If false, the change will be animated over time.
     *    - transitionSpeed: number - Defines the speed of the transition when `jump` is false. Represents the duration of the transition in milliseconds. Default is 8.
     *    - easing: (progress: number) => number - A function that defines the easing curve for the transition. It takes the progress ratio (a number between 0 and 1) as an argument and returns the eased value, affecting the playback speed during the transition.
     */
  }, {
    key: "transitionToTargetTime",
    value: function transitionToTargetTime(_ref2) {
      var _this3 = this;
      var jump = _ref2.jump,
        _ref2$transitionSpeed = _ref2.transitionSpeed,
        transitionSpeed = _ref2$transitionSpeed === void 0 ? this.transitionSpeed : _ref2$transitionSpeed,
        _ref2$easing = _ref2.easing,
        easing = _ref2$easing === void 0 ? null : _ref2$easing;
      if (this.debug) {
        console.info('Transitioning targetTime:', this.targetTime, 'currentTime:', this.currentTime);
      }
      var diff = this.targetTime - this.currentTime;
      var distance = Math.abs(diff);
      var duration = distance * 1000;
      var isForwardTransition = diff > 0;
      var tick = function tick(_ref3) {
        var startCurrentTime = _ref3.startCurrentTime,
          startTimestamp = _ref3.startTimestamp,
          timestamp = _ref3.timestamp;
        var progress = (timestamp - startTimestamp) / duration;

        // if frameThreshold is too low to catch condition Math.abs(this.targetTime - this.currentTime) < this.frameThreshold
        var hasPassedThreshold = isForwardTransition ? _this3.currentTime >= _this3.targetTime : _this3.currentTime <= _this3.targetTime;

        // If we are already close enough to our target, pause the video and return.
        // This is the base case of the recursive function
        if (
        // eslint-disable-next-line no-restricted-globals
        isNaN(_this3.targetTime) ||
        // If the currentTime is already close enough to the targetTime
        Math.abs(_this3.targetTime - _this3.currentTime) < _this3.frameThreshold || hasPassedThreshold) {
          _this3.video.pause();
          if (_this3.transitioningRaf) {
            // eslint-disable-next-line no-undef
            cancelAnimationFrame(_this3.transitioningRaf);
            _this3.transitioningRaf = null;
          }
          return;
        }

        // Make sure we don't go out of time bounds
        if (_this3.targetTime > _this3.video.duration) _this3.targetTime = _this3.video.duration;
        if (_this3.targetTime < 0) _this3.targetTime = 0;

        // How far forward we need to transition
        var transitionForward = _this3.targetTime - _this3.currentTime;
        var easedProgress = easing && Number.isFinite(progress) ? easing(progress) : null;
        var easedCurrentTime = isForwardTransition ? startCurrentTime + easedProgress * Math.abs(distance) * transitionSpeed : startCurrentTime - easedProgress * Math.abs(distance) * transitionSpeed;
        if (_this3.canvas) {
          if (jump) {
            // If jump, we go directly to the frame
            _this3.currentTime = _this3.targetTime;
          } else if (easedProgress) {
            _this3.currentTime = easedCurrentTime;
          } else {
            _this3.currentTime += transitionForward / (256 / transitionSpeed);
          }
          _this3.paintCanvasFrame(Math.floor(_this3.currentTime * _this3.frameRate));
        } else if (jump || _this3.isSafari || !isForwardTransition) {
          // We can't use a negative playbackRate, so if the video needs to go backwards,
          // We have to use the inefficient method of modifying currentTime rapidly to
          // get an effect.
          _this3.video.pause();
          if (easedProgress) {
            _this3.currentTime = easedCurrentTime;
          } else {
            _this3.currentTime += transitionForward / (64 / transitionSpeed);
          }

          // If jump, we go directly to the frame
          if (jump) {
            _this3.currentTime = _this3.targetTime;
          }
          _this3.video.currentTime = _this3.currentTime;
        } else {
          // Otherwise, we play the video and adjust the playbackRate to get a smoother
          // animation effect.
          var playbackRate = Math.max(Math.min(transitionForward * 4, transitionSpeed, 16), 1);
          if (_this3.debug) console.info('ScrollyVideo playbackRate:', playbackRate);
          // eslint-disable-next-line no-restricted-globals
          if (!isNaN(playbackRate)) {
            _this3.video.playbackRate = playbackRate;
            _this3.video.play();
          }
          // Set the currentTime to the video's currentTime
          _this3.currentTime = _this3.video.currentTime;
        }

        // Recursively calls ourselves until the animation is done.
        if (typeof requestAnimationFrame === 'function') {
          // eslint-disable-next-line no-undef
          _this3.transitioningRaf = requestAnimationFrame(function (currentTimestamp) {
            return tick({
              startCurrentTime: startCurrentTime,
              startTimestamp: startTimestamp,
              timestamp: currentTimestamp
            });
          });
        }
      };
      if (typeof requestAnimationFrame === 'function') {
        // eslint-disable-next-line no-undef
        this.transitioningRaf = requestAnimationFrame(function (startTimestamp) {
          tick({
            startCurrentTime: _this3.currentTime,
            startTimestamp: startTimestamp,
            timestamp: startTimestamp
          });
        });
      }
    }

    /**
     * Sets the currentTime of the video as a specified percentage of its total duration.
     *
     * @param percentage - The percentage of the video duration to set as the current time.
     * @param options - Configuration options for adjusting the video playback.
     *    - jump: boolean - If true, the video currentTime will jump directly to the specified percentage. If false, the change will be animated over time.
     *    - transitionSpeed: number - Defines the speed of the transition when `jump` is false. Represents the duration of the transition in milliseconds. Default is 8.
     *    - easing: (progress: number) => number - A function that defines the easing curve for the transition. It takes the progress ratio (a number between 0 and 1) as an argument and returns the eased value, affecting the playback speed during the transition.
     */
  }, {
    key: "setTargetTimePercent",
    value: function setTargetTimePercent(percentage) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var targetDuration = this.frames.length && this.frameRate ? this.frames.length / this.frameRate : this.video.duration;
      // The time we want to transition to
      this.targetTime = Math.max(Math.min(percentage, 1), 0) * targetDuration;

      // If we are close enough, return early
      if (!options.jump && Math.abs(this.currentTime - this.targetTime) < this.frameThreshold) return;

      // Play the video if we are in video mode
      if (!this.canvas && !this.video.paused) this.video.play();
      this.transitionToTargetTime(options);
    }

    /**
     * Simulate trackScroll programmatically (scrolls on page by percentage of video)
     *
     * @param percentage
     */
  }, {
    key: "setScrollPercent",
    value: function setScrollPercent(percentage) {
      if (!this.trackScroll) {
        console.warn('`setScrollPercent` requires enabled `trackScroll`');
        return;
      }
      var parent = this.container.parentNode;
      var _parent$getBoundingCl = parent.getBoundingClientRect(),
        top = _parent$getBoundingCl.top,
        height = _parent$getBoundingCl.height;

      // eslint-disable-next-line no-undef
      var startPoint = top + window.pageYOffset;
      // eslint-disable-next-line no-undef
      var containerHeightInViewport = height - window.innerHeight;
      var targetPosition = startPoint + containerHeightInViewport * percentage;
      if (isScrollPositionAtTarget(targetPosition)) {
        this.targetScrollPosition = null;
      } else {
        // eslint-disable-next-line no-undef
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
        this.targetScrollPosition = targetPosition;
      }
    }

    /**
     * Call to destroy this ScrollyVideo object
     */
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.debug) console.info('Destroying ScrollyVideo');
      if (this.trackScroll)
        // eslint-disable-next-line no-undef
        window.removeEventListener('scroll', this.updateScrollPercentage);

      // eslint-disable-next-line no-undef
      window.removeEventListener('resize', this.resize);

      // Clear component
      if (this.container) this.container.innerHTML = '';
    }
  }]);
  return ScrollyVideo;
}();

var ScrollyVideoComponent = /*#__PURE__*/React.forwardRef(function ScrollyVideoComponent(_ref, ref) {
  var src = _ref.src,
    transitionSpeed = _ref.transitionSpeed,
    frameThreshold = _ref.frameThreshold,
    cover = _ref.cover,
    sticky = _ref.sticky,
    full = _ref.full,
    trackScroll = _ref.trackScroll,
    lockScroll = _ref.lockScroll,
    useWebCodecs = _ref.useWebCodecs,
    videoPercentage = _ref.videoPercentage,
    debug = _ref.debug,
    onReady = _ref.onReady,
    onChange = _ref.onChange;
  var containerElement = React.useRef(null);
  var scrollyVideoRef = React.useRef(null);
  var _useState = React.useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    instance = _useState2[0],
    setInstance = _useState2[1];
  var videoPercentageRef = React.useRef(videoPercentage);
  videoPercentageRef.current = videoPercentage;
  var onReadyRef = React.useRef(onReady);
  onReadyRef.current = onReady;
  var onChangeRef = React.useRef(onChange);
  onChangeRef.current = onChange;

  // effect for destroy and recreate on props change (except video percentage)
  React.useEffect(function () {
    if (!containerElement.current) return;

    // if scrollyVideo already exists and any parameter is updated, destroy and recreate.
    if (scrollyVideoRef.current && scrollyVideoRef.current.destroy) {
      scrollyVideoRef.current.destroy();
    }
    var scrollyVideo = new ScrollyVideo({
      scrollyVideoContainer: containerElement.current,
      src: src,
      transitionSpeed: transitionSpeed,
      frameThreshold: frameThreshold,
      cover: cover,
      sticky: sticky,
      full: full,
      trackScroll: trackScroll,
      lockScroll: lockScroll,
      useWebCodecs: useWebCodecs,
      debug: debug,
      onReady: onReadyRef.current,
      onChange: onChangeRef.current,
      videoPercentage: videoPercentageRef.current
    });
    setInstance(scrollyVideo);
    scrollyVideoRef.current = scrollyVideo;
  }, [src, transitionSpeed, frameThreshold, cover, sticky, full, trackScroll, lockScroll, useWebCodecs, debug]);

  // effect for video percentage change
  React.useEffect(function () {
    // If we need to update the target time percent
    if (scrollyVideoRef.current && typeof videoPercentage === 'number' && videoPercentage >= 0 && videoPercentage <= 1) {
      scrollyVideoRef.current.setVideoPercentage(videoPercentage);
    }
  }, [videoPercentage]);

  // effect for unmount
  React.useEffect(function () {
    return function () {
      if (scrollyVideoRef.current && scrollyVideoRef.current.destroy) {
        scrollyVideoRef.current.destroy();
      }
    };
  }, []);
  React.useImperativeHandle(ref, function () {
    return {
      setVideoPercentage: scrollyVideoRef.current ? scrollyVideoRef.current.setVideoPercentage.bind(instance) : function () {}
    };
  }, [instance]);
  return /*#__PURE__*/React__default["default"].createElement("div", {
    ref: containerElement,
    "data-scrolly-container": true
  });
});

module.exports = ScrollyVideoComponent;


/***/ }),

/***/ 5862:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var parse = __webpack_require__(3812);

/**
 * Parses inline style to object.
 *
 * @example
 * // returns { 'line-height': '42' }
 * StyleToObject('line-height: 42;');
 *
 * @param  {String}      style      - The inline style.
 * @param  {Function}    [iterator] - The iterator function.
 * @return {null|Object}
 */
function StyleToObject(style, iterator) {
  var output = null;
  if (!style || typeof style !== 'string') {
    return output;
  }

  var declaration;
  var declarations = parse(style);
  var hasIterator = typeof iterator === 'function';
  var property;
  var value;

  for (var i = 0, len = declarations.length; i < len; i++) {
    declaration = declarations[i];
    property = declaration.property;
    value = declaration.value;

    if (hasIterator) {
      iterator(property, value, declaration);
    } else if (value) {
      output || (output = {});
      output[property] = value;
    }
  }

  return output;
}

module.exports = StyleToObject;
module.exports["default"] = StyleToObject; // ESM support


/***/ }),

/***/ 338:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "NIL", ({
  enumerable: true,
  get: function get() {
    return _nil.default;
  }
}));
Object.defineProperty(exports, "parse", ({
  enumerable: true,
  get: function get() {
    return _parse.default;
  }
}));
Object.defineProperty(exports, "stringify", ({
  enumerable: true,
  get: function get() {
    return _stringify.default;
  }
}));
Object.defineProperty(exports, "v1", ({
  enumerable: true,
  get: function get() {
    return _v.default;
  }
}));
Object.defineProperty(exports, "v3", ({
  enumerable: true,
  get: function get() {
    return _v2.default;
  }
}));
Object.defineProperty(exports, "v4", ({
  enumerable: true,
  get: function get() {
    return _v3.default;
  }
}));
Object.defineProperty(exports, "v5", ({
  enumerable: true,
  get: function get() {
    return _v4.default;
  }
}));
Object.defineProperty(exports, "validate", ({
  enumerable: true,
  get: function get() {
    return _validate.default;
  }
}));
Object.defineProperty(exports, "version", ({
  enumerable: true,
  get: function get() {
    return _version.default;
  }
}));

var _v = _interopRequireDefault(__webpack_require__(3925));

var _v2 = _interopRequireDefault(__webpack_require__(2220));

var _v3 = _interopRequireDefault(__webpack_require__(8015));

var _v4 = _interopRequireDefault(__webpack_require__(197));

var _nil = _interopRequireDefault(__webpack_require__(5529));

var _version = _interopRequireDefault(__webpack_require__(923));

var _validate = _interopRequireDefault(__webpack_require__(3447));

var _stringify = _interopRequireDefault(__webpack_require__(3584));

var _parse = _interopRequireDefault(__webpack_require__(5842));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 7809:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

/*
 * Browser-compatible JavaScript MD5
 *
 * Modification of JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */
function md5(bytes) {
  if (typeof bytes === 'string') {
    const msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = new Uint8Array(msg.length);

    for (let i = 0; i < msg.length; ++i) {
      bytes[i] = msg.charCodeAt(i);
    }
  }

  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
}
/*
 * Convert an array of little-endian words to an array of bytes
 */


function md5ToHexEncodedArray(input) {
  const output = [];
  const length32 = input.length * 32;
  const hexTab = '0123456789abcdef';

  for (let i = 0; i < length32; i += 8) {
    const x = input[i >> 5] >>> i % 32 & 0xff;
    const hex = parseInt(hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f), 16);
    output.push(hex);
  }

  return output;
}
/**
 * Calculate output length with padding and bit length
 */


function getOutputLength(inputLength8) {
  return (inputLength8 + 64 >>> 9 << 4) + 14 + 1;
}
/*
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 */


function wordsToMd5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << len % 32;
  x[getOutputLength(len) - 1] = len;
  let a = 1732584193;
  let b = -271733879;
  let c = -1732584194;
  let d = 271733878;

  for (let i = 0; i < x.length; i += 16) {
    const olda = a;
    const oldb = b;
    const oldc = c;
    const oldd = d;
    a = md5ff(a, b, c, d, x[i], 7, -680876936);
    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5gg(b, c, d, a, x[i], 20, -373897302);
    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5hh(d, a, b, c, x[i], 11, -358537222);
    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
    a = md5ii(a, b, c, d, x[i], 6, -198630844);
    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
    a = safeAdd(a, olda);
    b = safeAdd(b, oldb);
    c = safeAdd(c, oldc);
    d = safeAdd(d, oldd);
  }

  return [a, b, c, d];
}
/*
 * Convert an array bytes to an array of little-endian words
 * Characters >255 have their high-byte silently ignored.
 */


function bytesToWords(input) {
  if (input.length === 0) {
    return [];
  }

  const length8 = input.length * 8;
  const output = new Uint32Array(getOutputLength(length8));

  for (let i = 0; i < length8; i += 8) {
    output[i >> 5] |= (input[i / 8] & 0xff) << i % 32;
  }

  return output;
}
/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */


function safeAdd(x, y) {
  const lsw = (x & 0xffff) + (y & 0xffff);
  const msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 0xffff;
}
/*
 * Bitwise rotate a 32-bit number to the left.
 */


function bitRotateLeft(num, cnt) {
  return num << cnt | num >>> 32 - cnt;
}
/*
 * These functions implement the four basic operations the algorithm uses.
 */


function md5cmn(q, a, b, x, s, t) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}

function md5ff(a, b, c, d, x, s, t) {
  return md5cmn(b & c | ~b & d, a, b, x, s, t);
}

function md5gg(a, b, c, d, x, s, t) {
  return md5cmn(b & d | c & ~d, a, b, x, s, t);
}

function md5hh(a, b, c, d, x, s, t) {
  return md5cmn(b ^ c ^ d, a, b, x, s, t);
}

function md5ii(a, b, c, d, x, s, t) {
  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}

var _default = md5;
exports["default"] = _default;

/***/ }),

/***/ 9871:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var _default = {
  randomUUID
};
exports["default"] = _default;

/***/ }),

/***/ 5529:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _default = '00000000-0000-0000-0000-000000000000';
exports["default"] = _default;

/***/ }),

/***/ 5842:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _validate = _interopRequireDefault(__webpack_require__(3447));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function parse(uuid) {
  if (!(0, _validate.default)(uuid)) {
    throw TypeError('Invalid UUID');
  }

  let v;
  const arr = new Uint8Array(16); // Parse ########-....-....-....-............

  arr[0] = (v = parseInt(uuid.slice(0, 8), 16)) >>> 24;
  arr[1] = v >>> 16 & 0xff;
  arr[2] = v >>> 8 & 0xff;
  arr[3] = v & 0xff; // Parse ........-####-....-....-............

  arr[4] = (v = parseInt(uuid.slice(9, 13), 16)) >>> 8;
  arr[5] = v & 0xff; // Parse ........-....-####-....-............

  arr[6] = (v = parseInt(uuid.slice(14, 18), 16)) >>> 8;
  arr[7] = v & 0xff; // Parse ........-....-....-####-............

  arr[8] = (v = parseInt(uuid.slice(19, 23), 16)) >>> 8;
  arr[9] = v & 0xff; // Parse ........-....-....-....-############
  // (Use "/" to avoid 32-bit truncation when bit-shifting high-order bytes)

  arr[10] = (v = parseInt(uuid.slice(24, 36), 16)) / 0x10000000000 & 0xff;
  arr[11] = v / 0x100000000 & 0xff;
  arr[12] = v >>> 24 & 0xff;
  arr[13] = v >>> 16 & 0xff;
  arr[14] = v >>> 8 & 0xff;
  arr[15] = v & 0xff;
  return arr;
}

var _default = parse;
exports["default"] = _default;

/***/ }),

/***/ 4261:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
exports["default"] = _default;

/***/ }),

/***/ 9469:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = rng;
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);

function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}

/***/ }),

/***/ 7230:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

// Adapted from Chris Veness' SHA1 code at
// http://www.movable-type.co.uk/scripts/sha1.html
function f(s, x, y, z) {
  switch (s) {
    case 0:
      return x & y ^ ~x & z;

    case 1:
      return x ^ y ^ z;

    case 2:
      return x & y ^ x & z ^ y & z;

    case 3:
      return x ^ y ^ z;
  }
}

function ROTL(x, n) {
  return x << n | x >>> 32 - n;
}

function sha1(bytes) {
  const K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xca62c1d6];
  const H = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0];

  if (typeof bytes === 'string') {
    const msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = [];

    for (let i = 0; i < msg.length; ++i) {
      bytes.push(msg.charCodeAt(i));
    }
  } else if (!Array.isArray(bytes)) {
    // Convert Array-like to Array
    bytes = Array.prototype.slice.call(bytes);
  }

  bytes.push(0x80);
  const l = bytes.length / 4 + 2;
  const N = Math.ceil(l / 16);
  const M = new Array(N);

  for (let i = 0; i < N; ++i) {
    const arr = new Uint32Array(16);

    for (let j = 0; j < 16; ++j) {
      arr[j] = bytes[i * 64 + j * 4] << 24 | bytes[i * 64 + j * 4 + 1] << 16 | bytes[i * 64 + j * 4 + 2] << 8 | bytes[i * 64 + j * 4 + 3];
    }

    M[i] = arr;
  }

  M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
  M[N - 1][14] = Math.floor(M[N - 1][14]);
  M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;

  for (let i = 0; i < N; ++i) {
    const W = new Uint32Array(80);

    for (let t = 0; t < 16; ++t) {
      W[t] = M[i][t];
    }

    for (let t = 16; t < 80; ++t) {
      W[t] = ROTL(W[t - 3] ^ W[t - 8] ^ W[t - 14] ^ W[t - 16], 1);
    }

    let a = H[0];
    let b = H[1];
    let c = H[2];
    let d = H[3];
    let e = H[4];

    for (let t = 0; t < 80; ++t) {
      const s = Math.floor(t / 20);
      const T = ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[t] >>> 0;
      e = d;
      d = c;
      c = ROTL(b, 30) >>> 0;
      b = a;
      a = T;
    }

    H[0] = H[0] + a >>> 0;
    H[1] = H[1] + b >>> 0;
    H[2] = H[2] + c >>> 0;
    H[3] = H[3] + d >>> 0;
    H[4] = H[4] + e >>> 0;
  }

  return [H[0] >> 24 & 0xff, H[0] >> 16 & 0xff, H[0] >> 8 & 0xff, H[0] & 0xff, H[1] >> 24 & 0xff, H[1] >> 16 & 0xff, H[1] >> 8 & 0xff, H[1] & 0xff, H[2] >> 24 & 0xff, H[2] >> 16 & 0xff, H[2] >> 8 & 0xff, H[2] & 0xff, H[3] >> 24 & 0xff, H[3] >> 16 & 0xff, H[3] >> 8 & 0xff, H[3] & 0xff, H[4] >> 24 & 0xff, H[4] >> 16 & 0xff, H[4] >> 8 & 0xff, H[4] & 0xff];
}

var _default = sha1;
exports["default"] = _default;

/***/ }),

/***/ 3584:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
exports.unsafeStringify = unsafeStringify;

var _validate = _interopRequireDefault(__webpack_require__(3447));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
}

function stringify(arr, offset = 0) {
  const uuid = unsafeStringify(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!(0, _validate.default)(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

var _default = stringify;
exports["default"] = _default;

/***/ }),

/***/ 3925:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _rng = _interopRequireDefault(__webpack_require__(9469));

var _stringify = __webpack_require__(3584);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
let _nodeId;

let _clockseq; // Previous uuid creation time


let _lastMSecs = 0;
let _lastNSecs = 0; // See https://github.com/uuidjs/uuid for API details

function v1(options, buf, offset) {
  let i = buf && offset || 0;
  const b = buf || new Array(16);
  options = options || {};
  let node = options.node || _nodeId;
  let clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq; // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189

  if (node == null || clockseq == null) {
    const seedBytes = options.random || (options.rng || _rng.default)();

    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [seedBytes[0] | 0x01, seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
    }

    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  } // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.


  let msecs = options.msecs !== undefined ? options.msecs : Date.now(); // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock

  let nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1; // Time since last uuid creation (in msecs)

  const dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000; // Per 4.2.1.2, Bump clockseq on clock regression

  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  } // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval


  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  } // Per 4.2.1.2 Throw error if too many uuids are requested


  if (nsecs >= 10000) {
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq; // Per 4.1.4 - Convert from unix epoch to Gregorian epoch

  msecs += 12219292800000; // `time_low`

  const tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff; // `time_mid`

  const tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff; // `time_high_and_version`

  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version

  b[i++] = tmh >>> 16 & 0xff; // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)

  b[i++] = clockseq >>> 8 | 0x80; // `clock_seq_low`

  b[i++] = clockseq & 0xff; // `node`

  for (let n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf || (0, _stringify.unsafeStringify)(b);
}

var _default = v1;
exports["default"] = _default;

/***/ }),

/***/ 2220:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _v = _interopRequireDefault(__webpack_require__(2969));

var _md = _interopRequireDefault(__webpack_require__(7809));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const v3 = (0, _v.default)('v3', 0x30, _md.default);
var _default = v3;
exports["default"] = _default;

/***/ }),

/***/ 2969:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.URL = exports.DNS = void 0;
exports["default"] = v35;

var _stringify = __webpack_require__(3584);

var _parse = _interopRequireDefault(__webpack_require__(5842));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function stringToBytes(str) {
  str = unescape(encodeURIComponent(str)); // UTF8 escape

  const bytes = [];

  for (let i = 0; i < str.length; ++i) {
    bytes.push(str.charCodeAt(i));
  }

  return bytes;
}

const DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
exports.DNS = DNS;
const URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';
exports.URL = URL;

function v35(name, version, hashfunc) {
  function generateUUID(value, namespace, buf, offset) {
    var _namespace;

    if (typeof value === 'string') {
      value = stringToBytes(value);
    }

    if (typeof namespace === 'string') {
      namespace = (0, _parse.default)(namespace);
    }

    if (((_namespace = namespace) === null || _namespace === void 0 ? void 0 : _namespace.length) !== 16) {
      throw TypeError('Namespace must be array-like (16 iterable integer values, 0-255)');
    } // Compute hash of namespace and value, Per 4.3
    // Future: Use spread syntax when supported on all platforms, e.g. `bytes =
    // hashfunc([...namespace, ... value])`


    let bytes = new Uint8Array(16 + value.length);
    bytes.set(namespace);
    bytes.set(value, namespace.length);
    bytes = hashfunc(bytes);
    bytes[6] = bytes[6] & 0x0f | version;
    bytes[8] = bytes[8] & 0x3f | 0x80;

    if (buf) {
      offset = offset || 0;

      for (let i = 0; i < 16; ++i) {
        buf[offset + i] = bytes[i];
      }

      return buf;
    }

    return (0, _stringify.unsafeStringify)(bytes);
  } // Function#name is not settable on some platforms (#270)


  try {
    generateUUID.name = name; // eslint-disable-next-line no-empty
  } catch (err) {} // For CommonJS default export support


  generateUUID.DNS = DNS;
  generateUUID.URL = URL;
  return generateUUID;
}

/***/ }),

/***/ 8015:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _native = _interopRequireDefault(__webpack_require__(9871));

var _rng = _interopRequireDefault(__webpack_require__(9469));

var _stringify = __webpack_require__(3584);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function v4(options, buf, offset) {
  if (_native.default.randomUUID && !buf && !options) {
    return _native.default.randomUUID();
  }

  options = options || {};

  const rnds = options.random || (options.rng || _rng.default)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`


  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return (0, _stringify.unsafeStringify)(rnds);
}

var _default = v4;
exports["default"] = _default;

/***/ }),

/***/ 197:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _v = _interopRequireDefault(__webpack_require__(2969));

var _sha = _interopRequireDefault(__webpack_require__(7230));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const v5 = (0, _v.default)('v5', 0x50, _sha.default);
var _default = v5;
exports["default"] = _default;

/***/ }),

/***/ 3447:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _regex = _interopRequireDefault(__webpack_require__(4261));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validate(uuid) {
  return typeof uuid === 'string' && _regex.default.test(uuid);
}

var _default = validate;
exports["default"] = _default;

/***/ }),

/***/ 923:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _validate = _interopRequireDefault(__webpack_require__(3447));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function version(uuid) {
  if (!(0, _validate.default)(uuid)) {
    throw TypeError('Invalid UUID');
  }

  return parseInt(uuid.slice(14, 15), 16);
}

var _default = version;
exports["default"] = _default;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 2139:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.defaultJsonSerializer = void 0;
exports.defaultJsonSerializer = JSON;
//# sourceMappingURL=defaultJsonSerializer.js.map

/***/ }),

/***/ 7323:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.GraphQLWebSocketClient = void 0;
/* eslint-disable */
const resolveRequestDocument_js_1 = __webpack_require__(7671);
const types_js_1 = __webpack_require__(8876);
// import type WebSocket from 'ws'
const CONNECTION_INIT = `connection_init`;
const CONNECTION_ACK = `connection_ack`;
const PING = `ping`;
const PONG = `pong`;
const SUBSCRIBE = `subscribe`;
const NEXT = `next`;
const ERROR = `error`;
const COMPLETE = `complete`;
class GraphQLWebSocketMessage {
    get type() {
        return this._type;
    }
    get id() {
        return this._id;
    }
    get payload() {
        return this._payload;
    }
    constructor(type, payload, id) {
        this._type = type;
        this._payload = payload;
        this._id = id;
    }
    get text() {
        const result = { type: this.type };
        if (this.id != null && this.id != undefined)
            result.id = this.id;
        if (this.payload != null && this.payload != undefined)
            result.payload = this.payload;
        return JSON.stringify(result);
    }
    static parse(data, f) {
        const { type, payload, id } = JSON.parse(data);
        return new GraphQLWebSocketMessage(type, f(payload), id);
    }
}
class GraphQLWebSocketClient {
    constructor(socket, { onInit, onAcknowledged, onPing, onPong }) {
        this.socketState = { acknowledged: false, lastRequestId: 0, subscriptions: {} };
        this.socket = socket;
        socket.addEventListener(`open`, async (e) => {
            this.socketState.acknowledged = false;
            this.socketState.subscriptions = {};
            socket.send(ConnectionInit(onInit ? await onInit() : null).text);
        });
        socket.addEventListener(`close`, (e) => {
            this.socketState.acknowledged = false;
            this.socketState.subscriptions = {};
        });
        socket.addEventListener(`error`, (e) => {
            console.error(e);
        });
        socket.addEventListener(`message`, (e) => {
            try {
                const message = parseMessage(e.data);
                switch (message.type) {
                    case CONNECTION_ACK: {
                        if (this.socketState.acknowledged) {
                            console.warn(`Duplicate CONNECTION_ACK message ignored`);
                        }
                        else {
                            this.socketState.acknowledged = true;
                            if (onAcknowledged)
                                onAcknowledged(message.payload);
                        }
                        return;
                    }
                    case PING: {
                        if (onPing)
                            onPing(message.payload).then((r) => socket.send(Pong(r).text));
                        else
                            socket.send(Pong(null).text);
                        return;
                    }
                    case PONG: {
                        if (onPong)
                            onPong(message.payload);
                        return;
                    }
                }
                if (!this.socketState.acknowledged) {
                    // Web-socket connection not acknowledged
                    return;
                }
                if (message.id === undefined || message.id === null || !this.socketState.subscriptions[message.id]) {
                    // No subscription identifer or subscription indentifier is not found
                    return;
                }
                const { query, variables, subscriber } = this.socketState.subscriptions[message.id];
                switch (message.type) {
                    case NEXT: {
                        if (!message.payload.errors && message.payload.data) {
                            subscriber.next && subscriber.next(message.payload.data);
                        }
                        if (message.payload.errors) {
                            subscriber.error &&
                                subscriber.error(new types_js_1.ClientError({ ...message.payload, status: 200 }, { query, variables }));
                        }
                        else {
                        }
                        return;
                    }
                    case ERROR: {
                        subscriber.error &&
                            subscriber.error(new types_js_1.ClientError({ errors: message.payload, status: 200 }, { query, variables }));
                        return;
                    }
                    case COMPLETE: {
                        subscriber.complete && subscriber.complete();
                        delete this.socketState.subscriptions[message.id];
                        return;
                    }
                }
            }
            catch (e) {
                // Unexpected errors while handling graphql-ws message
                console.error(e);
                socket.close(1006);
            }
            socket.close(4400, `Unknown graphql-ws message.`);
        });
    }
    makeSubscribe(query, operationName, subscriber, variables) {
        const subscriptionId = (this.socketState.lastRequestId++).toString();
        this.socketState.subscriptions[subscriptionId] = { query, variables, subscriber };
        this.socket.send(Subscribe(subscriptionId, { query, operationName, variables }).text);
        return () => {
            this.socket.send(Complete(subscriptionId).text);
            delete this.socketState.subscriptions[subscriptionId];
        };
    }
    rawRequest(query, variables) {
        return new Promise((resolve, reject) => {
            let result;
            this.rawSubscribe(query, {
                next: (data, extensions) => (result = { data, extensions }),
                error: reject,
                complete: () => resolve(result),
            }, variables);
        });
    }
    request(document, variables) {
        return new Promise((resolve, reject) => {
            let result;
            this.subscribe(document, {
                next: (data) => (result = data),
                error: reject,
                complete: () => resolve(result),
            }, variables);
        });
    }
    subscribe(document, subscriber, variables) {
        const { query, operationName } = (0, resolveRequestDocument_js_1.resolveRequestDocument)(document);
        return this.makeSubscribe(query, operationName, subscriber, variables);
    }
    rawSubscribe(query, subscriber, variables) {
        return this.makeSubscribe(query, undefined, subscriber, variables);
    }
    ping(payload) {
        this.socket.send(Ping(payload).text);
    }
    close() {
        this.socket.close(1000);
    }
}
GraphQLWebSocketClient.PROTOCOL = `graphql-transport-ws`;
exports.GraphQLWebSocketClient = GraphQLWebSocketClient;
// Helper functions
function parseMessage(data, f = (a) => a) {
    const m = GraphQLWebSocketMessage.parse(data, f);
    return m;
}
function ConnectionInit(payload) {
    return new GraphQLWebSocketMessage(CONNECTION_INIT, payload);
}
function Ping(payload) {
    return new GraphQLWebSocketMessage(PING, payload, undefined);
}
function Pong(payload) {
    return new GraphQLWebSocketMessage(PONG, payload, undefined);
}
function Subscribe(id, payload) {
    return new GraphQLWebSocketMessage(SUBSCRIBE, payload, id);
}
function Complete(id) {
    return new GraphQLWebSocketMessage(COMPLETE, undefined, id);
}
//# sourceMappingURL=graphql-ws.js.map

/***/ }),

/***/ 7431:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.HeadersInstanceToPlainObject = exports.uppercase = void 0;
const uppercase = (str) => str.toUpperCase();
exports.uppercase = uppercase;
/**
 * Convert Headers instance into regular object
 */
const HeadersInstanceToPlainObject = (headers) => {
    const o = {};
    headers.forEach((v, k) => {
        o[k] = v;
    });
    return o;
};
exports.HeadersInstanceToPlainObject = HeadersInstanceToPlainObject;
//# sourceMappingURL=helpers.js.map

/***/ }),

/***/ 3671:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.request = exports.rawRequest = exports.GraphQLClient = exports.ClientError = exports.batchRequests = exports.resolveRequestDocument = exports.GraphQLWebSocketClient = exports.gql = void 0;
const defaultJsonSerializer_js_1 = __webpack_require__(2139);
const helpers_js_1 = __webpack_require__(7431);
const parseArgs_js_1 = __webpack_require__(5912);
const resolveRequestDocument_js_1 = __webpack_require__(7671);
const types_js_1 = __webpack_require__(8876);
Object.defineProperty(exports, "ClientError", ({ enumerable: true, get: function () { return types_js_1.ClientError; } }));
const cross_fetch_1 = __importStar(__webpack_require__(9372)), CrossFetch = cross_fetch_1;
/**
 * Convert the given headers configuration into a plain object.
 */
const resolveHeaders = (headers) => {
    let oHeaders = {};
    if (headers) {
        if ((typeof Headers !== `undefined` && headers instanceof Headers) ||
            (CrossFetch && CrossFetch.Headers && headers instanceof CrossFetch.Headers)) {
            oHeaders = (0, helpers_js_1.HeadersInstanceToPlainObject)(headers);
        }
        else if (Array.isArray(headers)) {
            headers.forEach(([name, value]) => {
                if (name && value !== undefined) {
                    oHeaders[name] = value;
                }
            });
        }
        else {
            oHeaders = headers;
        }
    }
    return oHeaders;
};
/**
 * Clean a GraphQL document to send it via a GET query
 */
const cleanQuery = (str) => str.replace(/([\s,]|#[^\n\r]+)+/g, ` `).trim();
/**
 * Create query string for GraphQL request
 */
const buildRequestConfig = (params) => {
    if (!Array.isArray(params.query)) {
        const params_ = params;
        const search = [`query=${encodeURIComponent(cleanQuery(params_.query))}`];
        if (params.variables) {
            search.push(`variables=${encodeURIComponent(params_.jsonSerializer.stringify(params_.variables))}`);
        }
        if (params_.operationName) {
            search.push(`operationName=${encodeURIComponent(params_.operationName)}`);
        }
        return search.join(`&`);
    }
    if (typeof params.variables !== `undefined` && !Array.isArray(params.variables)) {
        throw new Error(`Cannot create query with given variable type, array expected`);
    }
    // Batch support
    const params_ = params;
    const payload = params.query.reduce((acc, currentQuery, index) => {
        acc.push({
            query: cleanQuery(currentQuery),
            variables: params_.variables ? params_.jsonSerializer.stringify(params_.variables[index]) : undefined,
        });
        return acc;
    }, []);
    return `query=${encodeURIComponent(params_.jsonSerializer.stringify(payload))}`;
};
const createHttpMethodFetcher = (method) => async (params) => {
    const { url, query, variables, operationName, fetch, fetchOptions, middleware } = params;
    const headers = { ...params.headers };
    let queryParams = ``;
    let body = undefined;
    if (method === `POST`) {
        body = createRequestBody(query, variables, operationName, fetchOptions.jsonSerializer);
        if (typeof body === `string`) {
            // @ts-expect-error todo
            headers[`Content-Type`] = `application/json`;
        }
    }
    else {
        // @ts-expect-error todo needs ADT for TS to understand the different states
        queryParams = buildRequestConfig({
            query,
            variables,
            operationName,
            jsonSerializer: fetchOptions.jsonSerializer ?? defaultJsonSerializer_js_1.defaultJsonSerializer,
        });
    }
    const init = {
        method,
        headers,
        body,
        ...fetchOptions,
    };
    let urlResolved = url;
    let initResolved = init;
    if (middleware) {
        const result = await Promise.resolve(middleware({ ...init, url, operationName, variables }));
        const { url: urlNew, ...initNew } = result;
        urlResolved = urlNew;
        initResolved = initNew;
    }
    if (queryParams) {
        urlResolved = `${urlResolved}?${queryParams}`;
    }
    return await fetch(urlResolved, initResolved);
};
/**
 * GraphQL Client.
 */
class GraphQLClient {
    constructor(url, requestConfig = {}) {
        this.url = url;
        this.requestConfig = requestConfig;
        /**
         * Send a GraphQL query to the server.
         */
        this.rawRequest = async (...args) => {
            const [queryOrOptions, variables, requestHeaders] = args;
            const rawRequestOptions = (0, parseArgs_js_1.parseRawRequestArgs)(queryOrOptions, variables, requestHeaders);
            const { headers, fetch = cross_fetch_1.default, method = `POST`, requestMiddleware, responseMiddleware, ...fetchOptions } = this.requestConfig;
            const { url } = this;
            if (rawRequestOptions.signal !== undefined) {
                fetchOptions.signal = rawRequestOptions.signal;
            }
            const { operationName } = (0, resolveRequestDocument_js_1.resolveRequestDocument)(rawRequestOptions.query);
            return makeRequest({
                url,
                query: rawRequestOptions.query,
                variables: rawRequestOptions.variables,
                headers: {
                    ...resolveHeaders(callOrIdentity(headers)),
                    ...resolveHeaders(rawRequestOptions.requestHeaders),
                },
                operationName,
                fetch,
                method,
                fetchOptions,
                middleware: requestMiddleware,
            })
                .then((response) => {
                if (responseMiddleware) {
                    responseMiddleware(response);
                }
                return response;
            })
                .catch((error) => {
                if (responseMiddleware) {
                    responseMiddleware(error);
                }
                throw error;
            });
        };
    }
    async request(documentOrOptions, ...variablesAndRequestHeaders) {
        const [variables, requestHeaders] = variablesAndRequestHeaders;
        const requestOptions = (0, parseArgs_js_1.parseRequestArgs)(documentOrOptions, variables, requestHeaders);
        const { headers, fetch = cross_fetch_1.default, method = `POST`, requestMiddleware, responseMiddleware, ...fetchOptions } = this.requestConfig;
        const { url } = this;
        if (requestOptions.signal !== undefined) {
            fetchOptions.signal = requestOptions.signal;
        }
        const { query, operationName } = (0, resolveRequestDocument_js_1.resolveRequestDocument)(requestOptions.document);
        return makeRequest({
            url,
            query,
            variables: requestOptions.variables,
            headers: {
                ...resolveHeaders(callOrIdentity(headers)),
                ...resolveHeaders(requestOptions.requestHeaders),
            },
            operationName,
            fetch,
            method,
            fetchOptions,
            middleware: requestMiddleware,
        })
            .then((response) => {
            if (responseMiddleware) {
                responseMiddleware(response);
            }
            return response.data;
        })
            .catch((error) => {
            if (responseMiddleware) {
                responseMiddleware(error);
            }
            throw error;
        });
    }
    // prettier-ignore
    batchRequests(documentsOrOptions, requestHeaders) {
        const batchRequestOptions = (0, parseArgs_js_1.parseBatchRequestArgs)(documentsOrOptions, requestHeaders);
        const { headers, ...fetchOptions } = this.requestConfig;
        if (batchRequestOptions.signal !== undefined) {
            fetchOptions.signal = batchRequestOptions.signal;
        }
        const queries = batchRequestOptions.documents.map(({ document }) => (0, resolveRequestDocument_js_1.resolveRequestDocument)(document).query);
        const variables = batchRequestOptions.documents.map(({ variables }) => variables);
        return makeRequest({
            url: this.url,
            query: queries,
            // @ts-expect-error TODO reconcile batch variables into system.
            variables,
            headers: {
                ...resolveHeaders(callOrIdentity(headers)),
                ...resolveHeaders(batchRequestOptions.requestHeaders),
            },
            operationName: undefined,
            fetch: this.requestConfig.fetch ?? cross_fetch_1.default,
            method: this.requestConfig.method || `POST`,
            fetchOptions,
            middleware: this.requestConfig.requestMiddleware,
        })
            .then((response) => {
            if (this.requestConfig.responseMiddleware) {
                this.requestConfig.responseMiddleware(response);
            }
            return response.data;
        })
            .catch((error) => {
            if (this.requestConfig.responseMiddleware) {
                this.requestConfig.responseMiddleware(error);
            }
            throw error;
        });
    }
    setHeaders(headers) {
        this.requestConfig.headers = headers;
        return this;
    }
    /**
     * Attach a header to the client. All subsequent requests will have this header.
     */
    setHeader(key, value) {
        const { headers } = this.requestConfig;
        if (headers) {
            // todo what if headers is in nested array form... ?
            //@ts-expect-error todo
            headers[key] = value;
        }
        else {
            this.requestConfig.headers = { [key]: value };
        }
        return this;
    }
    /**
     * Change the client endpoint. All subsequent requests will send to this endpoint.
     */
    setEndpoint(value) {
        this.url = value;
        return this;
    }
}
exports.GraphQLClient = GraphQLClient;
const makeRequest = async (params) => {
    const { query, variables, fetchOptions } = params;
    const fetcher = createHttpMethodFetcher((0, helpers_js_1.uppercase)(params.method ?? `post`));
    const isBatchingQuery = Array.isArray(params.query);
    const response = await fetcher(params);
    const result = await getResult(response, fetchOptions.jsonSerializer ?? defaultJsonSerializer_js_1.defaultJsonSerializer);
    const successfullyReceivedData = Array.isArray(result)
        ? !result.some(({ data }) => !data)
        : Boolean(result.data);
    const successfullyPassedErrorPolicy = Array.isArray(result) ||
        !result.errors ||
        (Array.isArray(result.errors) && !result.errors.length) ||
        fetchOptions.errorPolicy === `all` ||
        fetchOptions.errorPolicy === `ignore`;
    if (response.ok && successfullyPassedErrorPolicy && successfullyReceivedData) {
        // @ts-expect-error TODO fixme
        const { errors: _, ...rest } = Array.isArray(result) ? result : result;
        const data = fetchOptions.errorPolicy === `ignore` ? rest : result;
        const dataEnvelope = isBatchingQuery ? { data } : data;
        // @ts-expect-error TODO
        return {
            ...dataEnvelope,
            headers: response.headers,
            status: response.status,
        };
    }
    else {
        const errorResult = typeof result === `string`
            ? {
                error: result,
            }
            : result;
        throw new types_js_1.ClientError(
        // @ts-expect-error TODO
        { ...errorResult, status: response.status, headers: response.headers }, { query, variables });
    }
};
/**
 * Send a GraphQL Query to the GraphQL server for execution.
 */
const rawRequest = async (...args) => {
    const [urlOrOptions, query, ...variablesAndRequestHeaders] = args;
    const requestOptions = (0, parseArgs_js_1.parseRawRequestExtendedArgs)(urlOrOptions, query, ...variablesAndRequestHeaders);
    const client = new GraphQLClient(requestOptions.url);
    return client.rawRequest({
        ...requestOptions,
    });
};
exports.rawRequest = rawRequest;
// prettier-ignore
// eslint-disable-next-line
async function request(urlOrOptions, document, ...variablesAndRequestHeaders) {
    const requestOptions = (0, parseArgs_js_1.parseRequestExtendedArgs)(urlOrOptions, document, ...variablesAndRequestHeaders);
    const client = new GraphQLClient(requestOptions.url);
    return client.request({
        ...requestOptions,
    });
}
exports.request = request;
/**
 * Send a batch of GraphQL Document to the GraphQL server for execution.
 *
 * @example
 *
 * ```ts
 * // You can pass a raw string
 *
 * await batchRequests('https://foo.bar/graphql', [
 * {
 *  query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * },
 * {
 *   query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * }])
 *
 * // You can also pass a GraphQL DocumentNode as query. Convenient if you
 * // are using graphql-tag package.
 *
 * import gql from 'graphql-tag'
 *
 * await batchRequests('https://foo.bar/graphql', [{ query: gql`...` }])
 * ```
 */
const batchRequests = async (...args) => {
    const params = parseBatchRequestsArgsExtended(args);
    const client = new GraphQLClient(params.url);
    return client.batchRequests(params);
};
exports.batchRequests = batchRequests;
const parseBatchRequestsArgsExtended = (args) => {
    if (args.length === 1) {
        return args[0];
    }
    else {
        return {
            url: args[0],
            documents: args[1],
            requestHeaders: args[2],
            signal: undefined,
        };
    }
};
const createRequestBody = (query, variables, operationName, jsonSerializer) => {
    const jsonSerializer_ = jsonSerializer ?? defaultJsonSerializer_js_1.defaultJsonSerializer;
    if (!Array.isArray(query)) {
        return jsonSerializer_.stringify({ query, variables, operationName });
    }
    if (typeof variables !== `undefined` && !Array.isArray(variables)) {
        throw new Error(`Cannot create request body with given variable type, array expected`);
    }
    // Batch support
    const payload = query.reduce((acc, currentQuery, index) => {
        acc.push({ query: currentQuery, variables: variables ? variables[index] : undefined });
        return acc;
    }, []);
    return jsonSerializer_.stringify(payload);
};
const getResult = async (response, jsonSerializer) => {
    let contentType;
    response.headers.forEach((value, key) => {
        if (key.toLowerCase() === `content-type`) {
            contentType = value;
        }
    });
    if (contentType &&
        (contentType.toLowerCase().startsWith(`application/json`) ||
            contentType.toLowerCase().startsWith(`application/graphql+json`) ||
            contentType.toLowerCase().startsWith(`application/graphql-response+json`))) {
        return jsonSerializer.parse(await response.text());
    }
    else {
        return response.text();
    }
};
const callOrIdentity = (value) => {
    return typeof value === `function` ? value() : value;
};
/**
 * Convenience passthrough template tag to get the benefits of tooling for the gql template tag. This does not actually parse the input into a GraphQL DocumentNode like graphql-tag package does. It just returns the string with any variables given interpolated. Can save you a bit of performance and having to install another package.
 *
 * @example
 * ```
 * import { gql } from 'graphql-request'
 *
 * await request('https://foo.bar/graphql', gql`...`)
 * ```
 *
 * @remarks
 *
 * Several tools in the Node GraphQL ecosystem are hardcoded to specially treat any template tag named "gql". For example see this prettier issue: https://github.com/prettier/prettier/issues/4360. Using this template tag has no runtime effect beyond variable interpolation.
 */
const gql = (chunks, ...variables) => {
    return chunks.reduce((acc, chunk, index) => `${acc}${chunk}${index in variables ? String(variables[index]) : ``}`, ``);
};
exports.gql = gql;
var graphql_ws_js_1 = __webpack_require__(7323);
Object.defineProperty(exports, "GraphQLWebSocketClient", ({ enumerable: true, get: function () { return graphql_ws_js_1.GraphQLWebSocketClient; } }));
var resolveRequestDocument_js_2 = __webpack_require__(7671);
Object.defineProperty(exports, "resolveRequestDocument", ({ enumerable: true, get: function () { return resolveRequestDocument_js_2.resolveRequestDocument; } }));
exports["default"] = request;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 5912:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.parseRawRequestExtendedArgs = exports.parseRequestExtendedArgs = exports.parseBatchRequestArgs = exports.parseRawRequestArgs = exports.parseRequestArgs = void 0;
const parseRequestArgs = (documentOrOptions, variables, requestHeaders) => {
    return documentOrOptions.document
        ? documentOrOptions
        : {
            document: documentOrOptions,
            variables: variables,
            requestHeaders: requestHeaders,
            signal: undefined,
        };
};
exports.parseRequestArgs = parseRequestArgs;
const parseRawRequestArgs = (queryOrOptions, variables, requestHeaders) => {
    return queryOrOptions.query
        ? queryOrOptions
        : {
            query: queryOrOptions,
            variables: variables,
            requestHeaders: requestHeaders,
            signal: undefined,
        };
};
exports.parseRawRequestArgs = parseRawRequestArgs;
const parseBatchRequestArgs = (documentsOrOptions, requestHeaders) => {
    return documentsOrOptions.documents
        ? documentsOrOptions
        : {
            documents: documentsOrOptions,
            requestHeaders: requestHeaders,
            signal: undefined,
        };
};
exports.parseBatchRequestArgs = parseBatchRequestArgs;
const parseRequestExtendedArgs = (urlOrOptions, document, ...variablesAndRequestHeaders) => {
    const [variables, requestHeaders] = variablesAndRequestHeaders;
    return urlOrOptions.document
        ? urlOrOptions
        : {
            url: urlOrOptions,
            document: document,
            variables,
            requestHeaders,
            signal: undefined,
        };
};
exports.parseRequestExtendedArgs = parseRequestExtendedArgs;
const parseRawRequestExtendedArgs = (urlOrOptions, query, ...variablesAndRequestHeaders) => {
    const [variables, requestHeaders] = variablesAndRequestHeaders;
    return urlOrOptions.query
        ? urlOrOptions
        : {
            url: urlOrOptions,
            query: query,
            variables,
            requestHeaders,
            signal: undefined,
        };
};
exports.parseRawRequestExtendedArgs = parseRawRequestExtendedArgs;
//# sourceMappingURL=parseArgs.js.map

/***/ }),

/***/ 7671:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.resolveRequestDocument = void 0;
const graphql_1 = __webpack_require__(4358);
/**
 * helpers
 */
const extractOperationName = (document) => {
    let operationName = undefined;
    const operationDefinitions = document.definitions.filter((definition) => definition.kind === `OperationDefinition`);
    if (operationDefinitions.length === 1) {
        operationName = operationDefinitions[0]?.name?.value;
    }
    return operationName;
};
const resolveRequestDocument = (document) => {
    if (typeof document === `string`) {
        let operationName = undefined;
        try {
            const parsedDocument = (0, graphql_1.parse)(document);
            operationName = extractOperationName(parsedDocument);
        }
        catch (err) {
            // Failed parsing the document, the operationName will be undefined
        }
        return { query: document, operationName };
    }
    const operationName = extractOperationName(document);
    return { query: (0, graphql_1.print)(document), operationName };
};
exports.resolveRequestDocument = resolveRequestDocument;
//# sourceMappingURL=resolveRequestDocument.js.map

/***/ }),

/***/ 8876:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ClientError = void 0;
class ClientError extends Error {
    constructor(response, request) {
        const message = `${ClientError.extractMessage(response)}: ${JSON.stringify({
            response,
            request,
        })}`;
        super(message);
        Object.setPrototypeOf(this, ClientError.prototype);
        this.response = response;
        this.request = request;
        // this is needed as Safari doesn't support .captureStackTrace
        if (typeof Error.captureStackTrace === `function`) {
            Error.captureStackTrace(this, ClientError);
        }
    }
    static extractMessage(response) {
        return response.errors?.[0]?.message ?? `GraphQL Error (Code: ${response.status})`;
    }
}
exports.ClientError = ClientError;
//# sourceMappingURL=types.js.map

/***/ }),

/***/ 719:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 9695:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayWithHoles; }
/* harmony export */ });
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}


/***/ }),

/***/ 3842:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 7599:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


/***/ }),

/***/ 2126:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 539:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _nonIterableRest; }
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


/***/ }),

/***/ 5034:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread; }
/* harmony export */ });
/* harmony import */ var _define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7599);


function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      (0,_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),

/***/ 169:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 1373:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 5341:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _slicedToArray; }
/* harmony export */ });
/* harmony import */ var _array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9695);
/* harmony import */ var _iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2126);
/* harmony import */ var _non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(539);
/* harmony import */ var _unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2164);





function _slicedToArray(arr, i) {
  return (0,_array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(arr) || (0,_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr, i) || (0,_unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(arr, i) || (0,_non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
}


/***/ }),

/***/ 9967:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _toArray; }
/* harmony export */ });
/* harmony import */ var _array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9695);
/* harmony import */ var _iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2126);
/* harmony import */ var _non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(539);
/* harmony import */ var _unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2164);





function _toArray(arr) {
  return (0,_array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(arr) || (0,_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr) || (0,_unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(arr, i) || (0,_non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
}


/***/ }),

/***/ 3444:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(719);
;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(2126);
;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(2164);
;// CONCATENATED MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 2164:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(719);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ }),

/***/ 4358:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "BREAK": function() { return /* reexport */ BREAK; },
  "BreakingChangeType": function() { return /* reexport */ BreakingChangeType; },
  "DEFAULT_DEPRECATION_REASON": function() { return /* reexport */ DEFAULT_DEPRECATION_REASON; },
  "DangerousChangeType": function() { return /* reexport */ DangerousChangeType; },
  "DirectiveLocation": function() { return /* reexport */ DirectiveLocation; },
  "ExecutableDefinitionsRule": function() { return /* reexport */ ExecutableDefinitionsRule; },
  "FieldsOnCorrectTypeRule": function() { return /* reexport */ FieldsOnCorrectTypeRule; },
  "FragmentsOnCompositeTypesRule": function() { return /* reexport */ FragmentsOnCompositeTypesRule; },
  "GRAPHQL_MAX_INT": function() { return /* reexport */ GRAPHQL_MAX_INT; },
  "GRAPHQL_MIN_INT": function() { return /* reexport */ GRAPHQL_MIN_INT; },
  "GraphQLBoolean": function() { return /* reexport */ GraphQLBoolean; },
  "GraphQLDeprecatedDirective": function() { return /* reexport */ GraphQLDeprecatedDirective; },
  "GraphQLDirective": function() { return /* reexport */ GraphQLDirective; },
  "GraphQLEnumType": function() { return /* reexport */ GraphQLEnumType; },
  "GraphQLError": function() { return /* reexport */ GraphQLError; },
  "GraphQLFloat": function() { return /* reexport */ GraphQLFloat; },
  "GraphQLID": function() { return /* reexport */ GraphQLID; },
  "GraphQLIncludeDirective": function() { return /* reexport */ GraphQLIncludeDirective; },
  "GraphQLInputObjectType": function() { return /* reexport */ GraphQLInputObjectType; },
  "GraphQLInt": function() { return /* reexport */ GraphQLInt; },
  "GraphQLInterfaceType": function() { return /* reexport */ GraphQLInterfaceType; },
  "GraphQLList": function() { return /* reexport */ GraphQLList; },
  "GraphQLNonNull": function() { return /* reexport */ GraphQLNonNull; },
  "GraphQLObjectType": function() { return /* reexport */ GraphQLObjectType; },
  "GraphQLScalarType": function() { return /* reexport */ GraphQLScalarType; },
  "GraphQLSchema": function() { return /* reexport */ GraphQLSchema; },
  "GraphQLSkipDirective": function() { return /* reexport */ GraphQLSkipDirective; },
  "GraphQLSpecifiedByDirective": function() { return /* reexport */ GraphQLSpecifiedByDirective; },
  "GraphQLString": function() { return /* reexport */ GraphQLString; },
  "GraphQLUnionType": function() { return /* reexport */ GraphQLUnionType; },
  "Kind": function() { return /* reexport */ Kind; },
  "KnownArgumentNamesRule": function() { return /* reexport */ KnownArgumentNamesRule; },
  "KnownDirectivesRule": function() { return /* reexport */ KnownDirectivesRule; },
  "KnownFragmentNamesRule": function() { return /* reexport */ KnownFragmentNamesRule; },
  "KnownTypeNamesRule": function() { return /* reexport */ KnownTypeNamesRule; },
  "Lexer": function() { return /* reexport */ Lexer; },
  "Location": function() { return /* reexport */ Location; },
  "LoneAnonymousOperationRule": function() { return /* reexport */ LoneAnonymousOperationRule; },
  "LoneSchemaDefinitionRule": function() { return /* reexport */ LoneSchemaDefinitionRule; },
  "NoDeprecatedCustomRule": function() { return /* reexport */ NoDeprecatedCustomRule; },
  "NoFragmentCyclesRule": function() { return /* reexport */ NoFragmentCyclesRule; },
  "NoSchemaIntrospectionCustomRule": function() { return /* reexport */ NoSchemaIntrospectionCustomRule; },
  "NoUndefinedVariablesRule": function() { return /* reexport */ NoUndefinedVariablesRule; },
  "NoUnusedFragmentsRule": function() { return /* reexport */ NoUnusedFragmentsRule; },
  "NoUnusedVariablesRule": function() { return /* reexport */ NoUnusedVariablesRule; },
  "OperationTypeNode": function() { return /* reexport */ OperationTypeNode; },
  "OverlappingFieldsCanBeMergedRule": function() { return /* reexport */ OverlappingFieldsCanBeMergedRule; },
  "PossibleFragmentSpreadsRule": function() { return /* reexport */ PossibleFragmentSpreadsRule; },
  "PossibleTypeExtensionsRule": function() { return /* reexport */ PossibleTypeExtensionsRule; },
  "ProvidedRequiredArgumentsRule": function() { return /* reexport */ ProvidedRequiredArgumentsRule; },
  "ScalarLeafsRule": function() { return /* reexport */ ScalarLeafsRule; },
  "SchemaMetaFieldDef": function() { return /* reexport */ SchemaMetaFieldDef; },
  "SingleFieldSubscriptionsRule": function() { return /* reexport */ SingleFieldSubscriptionsRule; },
  "Source": function() { return /* reexport */ Source; },
  "Token": function() { return /* reexport */ Token; },
  "TokenKind": function() { return /* reexport */ TokenKind; },
  "TypeInfo": function() { return /* reexport */ TypeInfo; },
  "TypeKind": function() { return /* reexport */ TypeKind; },
  "TypeMetaFieldDef": function() { return /* reexport */ TypeMetaFieldDef; },
  "TypeNameMetaFieldDef": function() { return /* reexport */ TypeNameMetaFieldDef; },
  "UniqueArgumentDefinitionNamesRule": function() { return /* reexport */ UniqueArgumentDefinitionNamesRule; },
  "UniqueArgumentNamesRule": function() { return /* reexport */ UniqueArgumentNamesRule; },
  "UniqueDirectiveNamesRule": function() { return /* reexport */ UniqueDirectiveNamesRule; },
  "UniqueDirectivesPerLocationRule": function() { return /* reexport */ UniqueDirectivesPerLocationRule; },
  "UniqueEnumValueNamesRule": function() { return /* reexport */ UniqueEnumValueNamesRule; },
  "UniqueFieldDefinitionNamesRule": function() { return /* reexport */ UniqueFieldDefinitionNamesRule; },
  "UniqueFragmentNamesRule": function() { return /* reexport */ UniqueFragmentNamesRule; },
  "UniqueInputFieldNamesRule": function() { return /* reexport */ UniqueInputFieldNamesRule; },
  "UniqueOperationNamesRule": function() { return /* reexport */ UniqueOperationNamesRule; },
  "UniqueOperationTypesRule": function() { return /* reexport */ UniqueOperationTypesRule; },
  "UniqueTypeNamesRule": function() { return /* reexport */ UniqueTypeNamesRule; },
  "UniqueVariableNamesRule": function() { return /* reexport */ UniqueVariableNamesRule; },
  "ValidationContext": function() { return /* reexport */ ValidationContext; },
  "ValuesOfCorrectTypeRule": function() { return /* reexport */ ValuesOfCorrectTypeRule; },
  "VariablesAreInputTypesRule": function() { return /* reexport */ VariablesAreInputTypesRule; },
  "VariablesInAllowedPositionRule": function() { return /* reexport */ VariablesInAllowedPositionRule; },
  "__Directive": function() { return /* reexport */ __Directive; },
  "__DirectiveLocation": function() { return /* reexport */ __DirectiveLocation; },
  "__EnumValue": function() { return /* reexport */ __EnumValue; },
  "__Field": function() { return /* reexport */ __Field; },
  "__InputValue": function() { return /* reexport */ __InputValue; },
  "__Schema": function() { return /* reexport */ __Schema; },
  "__Type": function() { return /* reexport */ __Type; },
  "__TypeKind": function() { return /* reexport */ __TypeKind; },
  "assertAbstractType": function() { return /* reexport */ assertAbstractType; },
  "assertCompositeType": function() { return /* reexport */ assertCompositeType; },
  "assertDirective": function() { return /* reexport */ assertDirective; },
  "assertEnumType": function() { return /* reexport */ assertEnumType; },
  "assertEnumValueName": function() { return /* reexport */ assertEnumValueName; },
  "assertInputObjectType": function() { return /* reexport */ assertInputObjectType; },
  "assertInputType": function() { return /* reexport */ assertInputType; },
  "assertInterfaceType": function() { return /* reexport */ assertInterfaceType; },
  "assertLeafType": function() { return /* reexport */ assertLeafType; },
  "assertListType": function() { return /* reexport */ assertListType; },
  "assertName": function() { return /* reexport */ assertName; },
  "assertNamedType": function() { return /* reexport */ assertNamedType; },
  "assertNonNullType": function() { return /* reexport */ assertNonNullType; },
  "assertNullableType": function() { return /* reexport */ assertNullableType; },
  "assertObjectType": function() { return /* reexport */ assertObjectType; },
  "assertOutputType": function() { return /* reexport */ assertOutputType; },
  "assertScalarType": function() { return /* reexport */ assertScalarType; },
  "assertSchema": function() { return /* reexport */ assertSchema; },
  "assertType": function() { return /* reexport */ assertType; },
  "assertUnionType": function() { return /* reexport */ assertUnionType; },
  "assertValidName": function() { return /* reexport */ assertValidName; },
  "assertValidSchema": function() { return /* reexport */ assertValidSchema; },
  "assertWrappingType": function() { return /* reexport */ assertWrappingType; },
  "astFromValue": function() { return /* reexport */ astFromValue; },
  "buildASTSchema": function() { return /* reexport */ buildASTSchema; },
  "buildClientSchema": function() { return /* reexport */ buildClientSchema; },
  "buildSchema": function() { return /* reexport */ buildSchema; },
  "coerceInputValue": function() { return /* reexport */ coerceInputValue; },
  "concatAST": function() { return /* reexport */ concatAST; },
  "createSourceEventStream": function() { return /* reexport */ createSourceEventStream; },
  "defaultFieldResolver": function() { return /* reexport */ defaultFieldResolver; },
  "defaultTypeResolver": function() { return /* reexport */ defaultTypeResolver; },
  "doTypesOverlap": function() { return /* reexport */ doTypesOverlap; },
  "execute": function() { return /* reexport */ execute; },
  "executeSync": function() { return /* reexport */ executeSync; },
  "extendSchema": function() { return /* reexport */ extendSchema; },
  "findBreakingChanges": function() { return /* reexport */ findBreakingChanges; },
  "findDangerousChanges": function() { return /* reexport */ findDangerousChanges; },
  "formatError": function() { return /* reexport */ formatError; },
  "getArgumentValues": function() { return /* reexport */ getArgumentValues; },
  "getDirectiveValues": function() { return /* reexport */ getDirectiveValues; },
  "getEnterLeaveForKind": function() { return /* reexport */ getEnterLeaveForKind; },
  "getIntrospectionQuery": function() { return /* reexport */ getIntrospectionQuery; },
  "getLocation": function() { return /* reexport */ getLocation; },
  "getNamedType": function() { return /* reexport */ getNamedType; },
  "getNullableType": function() { return /* reexport */ getNullableType; },
  "getOperationAST": function() { return /* reexport */ getOperationAST; },
  "getOperationRootType": function() { return /* reexport */ getOperationRootType; },
  "getVariableValues": function() { return /* reexport */ getVariableValues; },
  "getVisitFn": function() { return /* reexport */ getVisitFn; },
  "graphql": function() { return /* reexport */ graphql; },
  "graphqlSync": function() { return /* reexport */ graphqlSync; },
  "introspectionFromSchema": function() { return /* reexport */ introspectionFromSchema; },
  "introspectionTypes": function() { return /* reexport */ introspectionTypes; },
  "isAbstractType": function() { return /* reexport */ isAbstractType; },
  "isCompositeType": function() { return /* reexport */ isCompositeType; },
  "isConstValueNode": function() { return /* reexport */ isConstValueNode; },
  "isDefinitionNode": function() { return /* reexport */ isDefinitionNode; },
  "isDirective": function() { return /* reexport */ isDirective; },
  "isEnumType": function() { return /* reexport */ isEnumType; },
  "isEqualType": function() { return /* reexport */ isEqualType; },
  "isExecutableDefinitionNode": function() { return /* reexport */ isExecutableDefinitionNode; },
  "isInputObjectType": function() { return /* reexport */ isInputObjectType; },
  "isInputType": function() { return /* reexport */ isInputType; },
  "isInterfaceType": function() { return /* reexport */ isInterfaceType; },
  "isIntrospectionType": function() { return /* reexport */ isIntrospectionType; },
  "isLeafType": function() { return /* reexport */ isLeafType; },
  "isListType": function() { return /* reexport */ isListType; },
  "isNamedType": function() { return /* reexport */ isNamedType; },
  "isNonNullType": function() { return /* reexport */ isNonNullType; },
  "isNullableType": function() { return /* reexport */ isNullableType; },
  "isObjectType": function() { return /* reexport */ isObjectType; },
  "isOutputType": function() { return /* reexport */ isOutputType; },
  "isRequiredArgument": function() { return /* reexport */ isRequiredArgument; },
  "isRequiredInputField": function() { return /* reexport */ isRequiredInputField; },
  "isScalarType": function() { return /* reexport */ isScalarType; },
  "isSchema": function() { return /* reexport */ isSchema; },
  "isSelectionNode": function() { return /* reexport */ isSelectionNode; },
  "isSpecifiedDirective": function() { return /* reexport */ isSpecifiedDirective; },
  "isSpecifiedScalarType": function() { return /* reexport */ isSpecifiedScalarType; },
  "isType": function() { return /* reexport */ isType; },
  "isTypeDefinitionNode": function() { return /* reexport */ isTypeDefinitionNode; },
  "isTypeExtensionNode": function() { return /* reexport */ isTypeExtensionNode; },
  "isTypeNode": function() { return /* reexport */ isTypeNode; },
  "isTypeSubTypeOf": function() { return /* reexport */ isTypeSubTypeOf; },
  "isTypeSystemDefinitionNode": function() { return /* reexport */ isTypeSystemDefinitionNode; },
  "isTypeSystemExtensionNode": function() { return /* reexport */ isTypeSystemExtensionNode; },
  "isUnionType": function() { return /* reexport */ isUnionType; },
  "isValidNameError": function() { return /* reexport */ isValidNameError; },
  "isValueNode": function() { return /* reexport */ isValueNode; },
  "isWrappingType": function() { return /* reexport */ isWrappingType; },
  "lexicographicSortSchema": function() { return /* reexport */ lexicographicSortSchema; },
  "locatedError": function() { return /* reexport */ locatedError; },
  "parse": function() { return /* reexport */ parse; },
  "parseConstValue": function() { return /* reexport */ parseConstValue; },
  "parseType": function() { return /* reexport */ parseType; },
  "parseValue": function() { return /* reexport */ parseValue; },
  "print": function() { return /* reexport */ print; },
  "printError": function() { return /* reexport */ printError; },
  "printIntrospectionSchema": function() { return /* reexport */ printIntrospectionSchema; },
  "printLocation": function() { return /* reexport */ printLocation; },
  "printSchema": function() { return /* reexport */ printSchema; },
  "printSourceLocation": function() { return /* reexport */ printSourceLocation; },
  "printType": function() { return /* reexport */ printType; },
  "resolveObjMapThunk": function() { return /* reexport */ resolveObjMapThunk; },
  "resolveReadonlyArrayThunk": function() { return /* reexport */ resolveReadonlyArrayThunk; },
  "responsePathAsArray": function() { return /* reexport */ pathToArray; },
  "separateOperations": function() { return /* reexport */ separateOperations; },
  "specifiedDirectives": function() { return /* reexport */ specifiedDirectives; },
  "specifiedRules": function() { return /* reexport */ specifiedRules; },
  "specifiedScalarTypes": function() { return /* reexport */ specifiedScalarTypes; },
  "stripIgnoredCharacters": function() { return /* reexport */ stripIgnoredCharacters; },
  "subscribe": function() { return /* reexport */ subscribe; },
  "syntaxError": function() { return /* reexport */ syntaxError; },
  "typeFromAST": function() { return /* reexport */ typeFromAST; },
  "validate": function() { return /* reexport */ validate; },
  "validateSchema": function() { return /* reexport */ validateSchema; },
  "valueFromAST": function() { return /* reexport */ valueFromAST; },
  "valueFromASTUntyped": function() { return /* reexport */ valueFromASTUntyped; },
  "version": function() { return /* reexport */ version; },
  "versionInfo": function() { return /* reexport */ versionInfo; },
  "visit": function() { return /* reexport */ visit; },
  "visitInParallel": function() { return /* reexport */ visitInParallel; },
  "visitWithTypeInfo": function() { return /* reexport */ visitWithTypeInfo; }
});

;// CONCATENATED MODULE: ../node_modules/graphql/version.mjs
// Note: This file is autogenerated using "resources/gen-version.js" script and
// automatically updated by "npm version" command.

/**
 * A string containing the version of the GraphQL.js library
 */
const version = '16.8.1';
/**
 * An object containing the components of the GraphQL.js version string
 */

const versionInfo = Object.freeze({
  major: 16,
  minor: 8,
  patch: 1,
  preReleaseTag: null,
});

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/devAssert.mjs
function devAssert(condition, message) {
  const booleanCondition = Boolean(condition);

  if (!booleanCondition) {
    throw new Error(message);
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/isPromise.mjs
/**
 * Returns true if the value acts like a Promise, i.e. has a "then" function,
 * otherwise returns false.
 */
function isPromise(value) {
  return (
    typeof (value === null || value === void 0 ? void 0 : value.then) ===
    'function'
  );
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/isObjectLike.mjs
/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */
function isObjectLike(value) {
  return typeof value == 'object' && value !== null;
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/invariant.mjs
function invariant(condition, message) {
  const booleanCondition = Boolean(condition);

  if (!booleanCondition) {
    throw new Error(
      message != null ? message : 'Unexpected invariant triggered.',
    );
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/language/location.mjs

const LineRegExp = /\r\n|[\n\r]/g;
/**
 * Represents a location in a Source.
 */

/**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */
function getLocation(source, position) {
  let lastLineStart = 0;
  let line = 1;

  for (const match of source.body.matchAll(LineRegExp)) {
    typeof match.index === 'number' || invariant(false);

    if (match.index >= position) {
      break;
    }

    lastLineStart = match.index + match[0].length;
    line += 1;
  }

  return {
    line,
    column: position + 1 - lastLineStart,
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/language/printLocation.mjs


/**
 * Render a helpful description of the location in the GraphQL Source document.
 */
function printLocation(location) {
  return printSourceLocation(
    location.source,
    getLocation(location.source, location.start),
  );
}
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */

function printSourceLocation(source, sourceLocation) {
  const firstLineColumnOffset = source.locationOffset.column - 1;
  const body = ''.padStart(firstLineColumnOffset) + source.body;
  const lineIndex = sourceLocation.line - 1;
  const lineOffset = source.locationOffset.line - 1;
  const lineNum = sourceLocation.line + lineOffset;
  const columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
  const columnNum = sourceLocation.column + columnOffset;
  const locationStr = `${source.name}:${lineNum}:${columnNum}\n`;
  const lines = body.split(/\r\n|[\n\r]/g);
  const locationLine = lines[lineIndex]; // Special case for minified documents

  if (locationLine.length > 120) {
    const subLineIndex = Math.floor(columnNum / 80);
    const subLineColumnNum = columnNum % 80;
    const subLines = [];

    for (let i = 0; i < locationLine.length; i += 80) {
      subLines.push(locationLine.slice(i, i + 80));
    }

    return (
      locationStr +
      printPrefixedLines([
        [`${lineNum} |`, subLines[0]],
        ...subLines.slice(1, subLineIndex + 1).map((subLine) => ['|', subLine]),
        ['|', '^'.padStart(subLineColumnNum)],
        ['|', subLines[subLineIndex + 1]],
      ])
    );
  }

  return (
    locationStr +
    printPrefixedLines([
      // Lines specified like this: ["prefix", "string"],
      [`${lineNum - 1} |`, lines[lineIndex - 1]],
      [`${lineNum} |`, locationLine],
      ['|', '^'.padStart(columnNum)],
      [`${lineNum + 1} |`, lines[lineIndex + 1]],
    ])
  );
}

function printPrefixedLines(lines) {
  const existingLines = lines.filter(([_, line]) => line !== undefined);
  const padLen = Math.max(...existingLines.map(([prefix]) => prefix.length));
  return existingLines
    .map(([prefix, line]) => prefix.padStart(padLen) + (line ? ' ' + line : ''))
    .join('\n');
}

;// CONCATENATED MODULE: ../node_modules/graphql/error/GraphQLError.mjs




function toNormalizedOptions(args) {
  const firstArg = args[0];

  if (firstArg == null || 'kind' in firstArg || 'length' in firstArg) {
    return {
      nodes: firstArg,
      source: args[1],
      positions: args[2],
      path: args[3],
      originalError: args[4],
      extensions: args[5],
    };
  }

  return firstArg;
}
/**
 * A GraphQLError describes an Error found during the parse, validate, or
 * execute phases of performing a GraphQL operation. In addition to a message
 * and stack trace, it also includes information about the locations in a
 * GraphQL document and/or execution result that correspond to the Error.
 */

class GraphQLError extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */

  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */

  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */

  /**
   * The original error thrown from a field resolver during execution.
   */

  /**
   * Extension fields to add to the formatted error.
   */

  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(message, ...rawArgs) {
    var _this$nodes, _nodeLocations$, _ref;

    const { nodes, source, positions, path, originalError, extensions } =
      toNormalizedOptions(rawArgs);
    super(message);
    this.name = 'GraphQLError';
    this.path = path !== null && path !== void 0 ? path : undefined;
    this.originalError =
      originalError !== null && originalError !== void 0
        ? originalError
        : undefined; // Compute list of blame nodes.

    this.nodes = undefinedIfEmpty(
      Array.isArray(nodes) ? nodes : nodes ? [nodes] : undefined,
    );
    const nodeLocations = undefinedIfEmpty(
      (_this$nodes = this.nodes) === null || _this$nodes === void 0
        ? void 0
        : _this$nodes.map((node) => node.loc).filter((loc) => loc != null),
    ); // Compute locations in the source for the given nodes/positions.

    this.source =
      source !== null && source !== void 0
        ? source
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : (_nodeLocations$ = nodeLocations[0]) === null ||
          _nodeLocations$ === void 0
        ? void 0
        : _nodeLocations$.source;
    this.positions =
      positions !== null && positions !== void 0
        ? positions
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : nodeLocations.map((loc) => loc.start);
    this.locations =
      positions && source
        ? positions.map((pos) => getLocation(source, pos))
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : nodeLocations.map((loc) => getLocation(loc.source, loc.start));
    const originalExtensions = isObjectLike(
      originalError === null || originalError === void 0
        ? void 0
        : originalError.extensions,
    )
      ? originalError === null || originalError === void 0
        ? void 0
        : originalError.extensions
      : undefined;
    this.extensions =
      (_ref =
        extensions !== null && extensions !== void 0
          ? extensions
          : originalExtensions) !== null && _ref !== void 0
        ? _ref
        : Object.create(null); // Only properties prescribed by the spec should be enumerable.
    // Keep the rest as non-enumerable.

    Object.defineProperties(this, {
      message: {
        writable: true,
        enumerable: true,
      },
      name: {
        enumerable: false,
      },
      nodes: {
        enumerable: false,
      },
      source: {
        enumerable: false,
      },
      positions: {
        enumerable: false,
      },
      originalError: {
        enumerable: false,
      },
    }); // Include (non-enumerable) stack trace.

    /* c8 ignore start */
    // FIXME: https://github.com/graphql/graphql-js/issues/2317

    if (
      originalError !== null &&
      originalError !== void 0 &&
      originalError.stack
    ) {
      Object.defineProperty(this, 'stack', {
        value: originalError.stack,
        writable: true,
        configurable: true,
      });
    } else if (Error.captureStackTrace) {
      Error.captureStackTrace(this, GraphQLError);
    } else {
      Object.defineProperty(this, 'stack', {
        value: Error().stack,
        writable: true,
        configurable: true,
      });
    }
    /* c8 ignore stop */
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLError';
  }

  toString() {
    let output = this.message;

    if (this.nodes) {
      for (const node of this.nodes) {
        if (node.loc) {
          output += '\n\n' + printLocation(node.loc);
        }
      }
    } else if (this.source && this.locations) {
      for (const location of this.locations) {
        output += '\n\n' + printSourceLocation(this.source, location);
      }
    }

    return output;
  }

  toJSON() {
    const formattedError = {
      message: this.message,
    };

    if (this.locations != null) {
      formattedError.locations = this.locations;
    }

    if (this.path != null) {
      formattedError.path = this.path;
    }

    if (this.extensions != null && Object.keys(this.extensions).length > 0) {
      formattedError.extensions = this.extensions;
    }

    return formattedError;
  }
}

function undefinedIfEmpty(array) {
  return array === undefined || array.length === 0 ? undefined : array;
}
/**
 * See: https://spec.graphql.org/draft/#sec-Errors
 */

/**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 *
 * @deprecated Please use `error.toString` instead. Will be removed in v17
 */
function printError(error) {
  return error.toString();
}
/**
 * Given a GraphQLError, format it according to the rules described by the
 * Response Format, Errors section of the GraphQL Specification.
 *
 * @deprecated Please use `error.toJSON` instead. Will be removed in v17
 */

function formatError(error) {
  return error.toJSON();
}

;// CONCATENATED MODULE: ../node_modules/graphql/error/syntaxError.mjs

/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */

function syntaxError(source, position, description) {
  return new GraphQLError(`Syntax Error: ${description}`, {
    source,
    positions: [position],
  });
}

;// CONCATENATED MODULE: ../node_modules/graphql/language/ast.mjs
/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */
class Location {
  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The Token at which this Node begins.
   */

  /**
   * The Token at which this Node ends.
   */

  /**
   * The Source document the AST represents.
   */
  constructor(startToken, endToken, source) {
    this.start = startToken.start;
    this.end = endToken.end;
    this.startToken = startToken;
    this.endToken = endToken;
    this.source = source;
  }

  get [Symbol.toStringTag]() {
    return 'Location';
  }

  toJSON() {
    return {
      start: this.start,
      end: this.end,
    };
  }
}
/**
 * Represents a range of characters represented by a lexical token
 * within a Source.
 */

class Token {
  /**
   * The kind of Token.
   */

  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The 1-indexed line number on which this Token appears.
   */

  /**
   * The 1-indexed column number at which this Token begins.
   */

  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */

  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(kind, start, end, line, column, value) {
    this.kind = kind;
    this.start = start;
    this.end = end;
    this.line = line;
    this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

    this.value = value;
    this.prev = null;
    this.next = null;
  }

  get [Symbol.toStringTag]() {
    return 'Token';
  }

  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column,
    };
  }
}
/**
 * The list of all possible AST node types.
 */

/**
 * @internal
 */
const QueryDocumentKeys = {
  Name: [],
  Document: ['definitions'],
  OperationDefinition: [
    'name',
    'variableDefinitions',
    'directives',
    'selectionSet',
  ],
  VariableDefinition: ['variable', 'type', 'defaultValue', 'directives'],
  Variable: ['name'],
  SelectionSet: ['selections'],
  Field: ['alias', 'name', 'arguments', 'directives', 'selectionSet'],
  Argument: ['name', 'value'],
  FragmentSpread: ['name', 'directives'],
  InlineFragment: ['typeCondition', 'directives', 'selectionSet'],
  FragmentDefinition: [
    'name', // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    'variableDefinitions',
    'typeCondition',
    'directives',
    'selectionSet',
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ['values'],
  ObjectValue: ['fields'],
  ObjectField: ['name', 'value'],
  Directive: ['name', 'arguments'],
  NamedType: ['name'],
  ListType: ['type'],
  NonNullType: ['type'],
  SchemaDefinition: ['description', 'directives', 'operationTypes'],
  OperationTypeDefinition: ['type'],
  ScalarTypeDefinition: ['description', 'name', 'directives'],
  ObjectTypeDefinition: [
    'description',
    'name',
    'interfaces',
    'directives',
    'fields',
  ],
  FieldDefinition: ['description', 'name', 'arguments', 'type', 'directives'],
  InputValueDefinition: [
    'description',
    'name',
    'type',
    'defaultValue',
    'directives',
  ],
  InterfaceTypeDefinition: [
    'description',
    'name',
    'interfaces',
    'directives',
    'fields',
  ],
  UnionTypeDefinition: ['description', 'name', 'directives', 'types'],
  EnumTypeDefinition: ['description', 'name', 'directives', 'values'],
  EnumValueDefinition: ['description', 'name', 'directives'],
  InputObjectTypeDefinition: ['description', 'name', 'directives', 'fields'],
  DirectiveDefinition: ['description', 'name', 'arguments', 'locations'],
  SchemaExtension: ['directives', 'operationTypes'],
  ScalarTypeExtension: ['name', 'directives'],
  ObjectTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  InterfaceTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  UnionTypeExtension: ['name', 'directives', 'types'],
  EnumTypeExtension: ['name', 'directives', 'values'],
  InputObjectTypeExtension: ['name', 'directives', 'fields'],
};
const kindValues = new Set(Object.keys(QueryDocumentKeys));
/**
 * @internal
 */

function isNode(maybeNode) {
  const maybeKind =
    maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
  return typeof maybeKind === 'string' && kindValues.has(maybeKind);
}
/** Name */

var OperationTypeNode;

(function (OperationTypeNode) {
  OperationTypeNode['QUERY'] = 'query';
  OperationTypeNode['MUTATION'] = 'mutation';
  OperationTypeNode['SUBSCRIPTION'] = 'subscription';
})(OperationTypeNode || (OperationTypeNode = {}));



;// CONCATENATED MODULE: ../node_modules/graphql/language/directiveLocation.mjs
/**
 * The set of allowed directive location values.
 */
var DirectiveLocation;

(function (DirectiveLocation) {
  DirectiveLocation['QUERY'] = 'QUERY';
  DirectiveLocation['MUTATION'] = 'MUTATION';
  DirectiveLocation['SUBSCRIPTION'] = 'SUBSCRIPTION';
  DirectiveLocation['FIELD'] = 'FIELD';
  DirectiveLocation['FRAGMENT_DEFINITION'] = 'FRAGMENT_DEFINITION';
  DirectiveLocation['FRAGMENT_SPREAD'] = 'FRAGMENT_SPREAD';
  DirectiveLocation['INLINE_FRAGMENT'] = 'INLINE_FRAGMENT';
  DirectiveLocation['VARIABLE_DEFINITION'] = 'VARIABLE_DEFINITION';
  DirectiveLocation['SCHEMA'] = 'SCHEMA';
  DirectiveLocation['SCALAR'] = 'SCALAR';
  DirectiveLocation['OBJECT'] = 'OBJECT';
  DirectiveLocation['FIELD_DEFINITION'] = 'FIELD_DEFINITION';
  DirectiveLocation['ARGUMENT_DEFINITION'] = 'ARGUMENT_DEFINITION';
  DirectiveLocation['INTERFACE'] = 'INTERFACE';
  DirectiveLocation['UNION'] = 'UNION';
  DirectiveLocation['ENUM'] = 'ENUM';
  DirectiveLocation['ENUM_VALUE'] = 'ENUM_VALUE';
  DirectiveLocation['INPUT_OBJECT'] = 'INPUT_OBJECT';
  DirectiveLocation['INPUT_FIELD_DEFINITION'] = 'INPUT_FIELD_DEFINITION';
})(DirectiveLocation || (DirectiveLocation = {}));


/**
 * The enum type representing the directive location values.
 *
 * @deprecated Please use `DirectiveLocation`. Will be remove in v17.
 */

;// CONCATENATED MODULE: ../node_modules/graphql/language/kinds.mjs
/**
 * The set of allowed kind values for AST nodes.
 */
var Kind;

(function (Kind) {
  Kind['NAME'] = 'Name';
  Kind['DOCUMENT'] = 'Document';
  Kind['OPERATION_DEFINITION'] = 'OperationDefinition';
  Kind['VARIABLE_DEFINITION'] = 'VariableDefinition';
  Kind['SELECTION_SET'] = 'SelectionSet';
  Kind['FIELD'] = 'Field';
  Kind['ARGUMENT'] = 'Argument';
  Kind['FRAGMENT_SPREAD'] = 'FragmentSpread';
  Kind['INLINE_FRAGMENT'] = 'InlineFragment';
  Kind['FRAGMENT_DEFINITION'] = 'FragmentDefinition';
  Kind['VARIABLE'] = 'Variable';
  Kind['INT'] = 'IntValue';
  Kind['FLOAT'] = 'FloatValue';
  Kind['STRING'] = 'StringValue';
  Kind['BOOLEAN'] = 'BooleanValue';
  Kind['NULL'] = 'NullValue';
  Kind['ENUM'] = 'EnumValue';
  Kind['LIST'] = 'ListValue';
  Kind['OBJECT'] = 'ObjectValue';
  Kind['OBJECT_FIELD'] = 'ObjectField';
  Kind['DIRECTIVE'] = 'Directive';
  Kind['NAMED_TYPE'] = 'NamedType';
  Kind['LIST_TYPE'] = 'ListType';
  Kind['NON_NULL_TYPE'] = 'NonNullType';
  Kind['SCHEMA_DEFINITION'] = 'SchemaDefinition';
  Kind['OPERATION_TYPE_DEFINITION'] = 'OperationTypeDefinition';
  Kind['SCALAR_TYPE_DEFINITION'] = 'ScalarTypeDefinition';
  Kind['OBJECT_TYPE_DEFINITION'] = 'ObjectTypeDefinition';
  Kind['FIELD_DEFINITION'] = 'FieldDefinition';
  Kind['INPUT_VALUE_DEFINITION'] = 'InputValueDefinition';
  Kind['INTERFACE_TYPE_DEFINITION'] = 'InterfaceTypeDefinition';
  Kind['UNION_TYPE_DEFINITION'] = 'UnionTypeDefinition';
  Kind['ENUM_TYPE_DEFINITION'] = 'EnumTypeDefinition';
  Kind['ENUM_VALUE_DEFINITION'] = 'EnumValueDefinition';
  Kind['INPUT_OBJECT_TYPE_DEFINITION'] = 'InputObjectTypeDefinition';
  Kind['DIRECTIVE_DEFINITION'] = 'DirectiveDefinition';
  Kind['SCHEMA_EXTENSION'] = 'SchemaExtension';
  Kind['SCALAR_TYPE_EXTENSION'] = 'ScalarTypeExtension';
  Kind['OBJECT_TYPE_EXTENSION'] = 'ObjectTypeExtension';
  Kind['INTERFACE_TYPE_EXTENSION'] = 'InterfaceTypeExtension';
  Kind['UNION_TYPE_EXTENSION'] = 'UnionTypeExtension';
  Kind['ENUM_TYPE_EXTENSION'] = 'EnumTypeExtension';
  Kind['INPUT_OBJECT_TYPE_EXTENSION'] = 'InputObjectTypeExtension';
})(Kind || (Kind = {}));


/**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */

;// CONCATENATED MODULE: ../node_modules/graphql/language/characterClasses.mjs
/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */
function isWhiteSpace(code) {
  return code === 0x0009 || code === 0x0020;
}
/**
 * ```
 * Digit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 * ```
 * @internal
 */

function isDigit(code) {
  return code >= 0x0030 && code <= 0x0039;
}
/**
 * ```
 * Letter :: one of
 *   - `A` `B` `C` `D` `E` `F` `G` `H` `I` `J` `K` `L` `M`
 *   - `N` `O` `P` `Q` `R` `S` `T` `U` `V` `W` `X` `Y` `Z`
 *   - `a` `b` `c` `d` `e` `f` `g` `h` `i` `j` `k` `l` `m`
 *   - `n` `o` `p` `q` `r` `s` `t` `u` `v` `w` `x` `y` `z`
 * ```
 * @internal
 */

function isLetter(code) {
  return (
    (code >= 0x0061 && code <= 0x007a) || // A-Z
    (code >= 0x0041 && code <= 0x005a) // a-z
  );
}
/**
 * ```
 * NameStart ::
 *   - Letter
 *   - `_`
 * ```
 * @internal
 */

function isNameStart(code) {
  return isLetter(code) || code === 0x005f;
}
/**
 * ```
 * NameContinue ::
 *   - Letter
 *   - Digit
 *   - `_`
 * ```
 * @internal
 */

function isNameContinue(code) {
  return isLetter(code) || isDigit(code) || code === 0x005f;
}

;// CONCATENATED MODULE: ../node_modules/graphql/language/blockString.mjs

/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */

function dedentBlockStringLines(lines) {
  var _firstNonEmptyLine2;

  let commonIndent = Number.MAX_SAFE_INTEGER;
  let firstNonEmptyLine = null;
  let lastNonEmptyLine = -1;

  for (let i = 0; i < lines.length; ++i) {
    var _firstNonEmptyLine;

    const line = lines[i];
    const indent = leadingWhitespace(line);

    if (indent === line.length) {
      continue; // skip empty lines
    }

    firstNonEmptyLine =
      (_firstNonEmptyLine = firstNonEmptyLine) !== null &&
      _firstNonEmptyLine !== void 0
        ? _firstNonEmptyLine
        : i;
    lastNonEmptyLine = i;

    if (i !== 0 && indent < commonIndent) {
      commonIndent = indent;
    }
  }

  return lines // Remove common indentation from all lines but first.
    .map((line, i) => (i === 0 ? line : line.slice(commonIndent))) // Remove leading and trailing blank lines.
    .slice(
      (_firstNonEmptyLine2 = firstNonEmptyLine) !== null &&
        _firstNonEmptyLine2 !== void 0
        ? _firstNonEmptyLine2
        : 0,
      lastNonEmptyLine + 1,
    );
}

function leadingWhitespace(str) {
  let i = 0;

  while (i < str.length && isWhiteSpace(str.charCodeAt(i))) {
    ++i;
  }

  return i;
}
/**
 * @internal
 */

function isPrintableAsBlockString(value) {
  if (value === '') {
    return true; // empty string is printable
  }

  let isEmptyLine = true;
  let hasIndent = false;
  let hasCommonIndent = true;
  let seenNonEmptyLine = false;

  for (let i = 0; i < value.length; ++i) {
    switch (value.codePointAt(i)) {
      case 0x0000:
      case 0x0001:
      case 0x0002:
      case 0x0003:
      case 0x0004:
      case 0x0005:
      case 0x0006:
      case 0x0007:
      case 0x0008:
      case 0x000b:
      case 0x000c:
      case 0x000e:
      case 0x000f:
        return false;
      // Has non-printable characters

      case 0x000d:
        //  \r
        return false;
      // Has \r or \r\n which will be replaced as \n

      case 10:
        //  \n
        if (isEmptyLine && !seenNonEmptyLine) {
          return false; // Has leading new line
        }

        seenNonEmptyLine = true;
        isEmptyLine = true;
        hasIndent = false;
        break;

      case 9: //   \t

      case 32:
        //  <space>
        hasIndent || (hasIndent = isEmptyLine);
        break;

      default:
        hasCommonIndent && (hasCommonIndent = hasIndent);
        isEmptyLine = false;
    }
  }

  if (isEmptyLine) {
    return false; // Has trailing empty lines
  }

  if (hasCommonIndent && seenNonEmptyLine) {
    return false; // Has internal indent
  }

  return true;
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 *
 * @internal
 */

function printBlockString(value, options) {
  const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.

  const lines = escapedValue.split(/\r\n|[\n\r]/g);
  const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line

  const forceLeadingNewLine =
    lines.length > 1 &&
    lines
      .slice(1)
      .every((line) => line.length === 0 || isWhiteSpace(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line

  const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line

  const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
  const hasTrailingSlash = value.endsWith('\\');
  const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
  const printAsMultipleLines =
    !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine ||
      value.length > 70 ||
      forceTrailingNewline ||
      forceLeadingNewLine ||
      hasTrailingTripleQuotes);
  let result = ''; // Format a multi-line block quote to account for leading space.

  const skipLeadingNewLine = isSingleLine && isWhiteSpace(value.charCodeAt(0));

  if ((printAsMultipleLines && !skipLeadingNewLine) || forceLeadingNewLine) {
    result += '\n';
  }

  result += escapedValue;

  if (printAsMultipleLines || forceTrailingNewline) {
    result += '\n';
  }

  return '"""' + result + '"""';
}

;// CONCATENATED MODULE: ../node_modules/graphql/language/tokenKind.mjs
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */
var TokenKind;

(function (TokenKind) {
  TokenKind['SOF'] = '<SOF>';
  TokenKind['EOF'] = '<EOF>';
  TokenKind['BANG'] = '!';
  TokenKind['DOLLAR'] = '$';
  TokenKind['AMP'] = '&';
  TokenKind['PAREN_L'] = '(';
  TokenKind['PAREN_R'] = ')';
  TokenKind['SPREAD'] = '...';
  TokenKind['COLON'] = ':';
  TokenKind['EQUALS'] = '=';
  TokenKind['AT'] = '@';
  TokenKind['BRACKET_L'] = '[';
  TokenKind['BRACKET_R'] = ']';
  TokenKind['BRACE_L'] = '{';
  TokenKind['PIPE'] = '|';
  TokenKind['BRACE_R'] = '}';
  TokenKind['NAME'] = 'Name';
  TokenKind['INT'] = 'Int';
  TokenKind['FLOAT'] = 'Float';
  TokenKind['STRING'] = 'String';
  TokenKind['BLOCK_STRING'] = 'BlockString';
  TokenKind['COMMENT'] = 'Comment';
})(TokenKind || (TokenKind = {}));


/**
 * The enum type representing the token kinds values.
 *
 * @deprecated Please use `TokenKind`. Will be remove in v17.
 */

;// CONCATENATED MODULE: ../node_modules/graphql/language/lexer.mjs





/**
 * Given a Source object, creates a Lexer for that source.
 * A Lexer is a stateful stream generator in that every time
 * it is advanced, it returns the next token in the Source. Assuming the
 * source lexes, the final Token emitted by the lexer will be of kind
 * EOF, after which the lexer will repeatedly return the same EOF token
 * whenever called.
 */

class Lexer {
  /**
   * The previously focused non-ignored token.
   */

  /**
   * The currently focused non-ignored token.
   */

  /**
   * The (1-indexed) line containing the current token.
   */

  /**
   * The character offset at which the current line begins.
   */
  constructor(source) {
    const startOfFileToken = new Token(TokenKind.SOF, 0, 0, 0, 0);
    this.source = source;
    this.lastToken = startOfFileToken;
    this.token = startOfFileToken;
    this.line = 1;
    this.lineStart = 0;
  }

  get [Symbol.toStringTag]() {
    return 'Lexer';
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */

  advance() {
    this.lastToken = this.token;
    const token = (this.token = this.lookahead());
    return token;
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */

  lookahead() {
    let token = this.token;

    if (token.kind !== TokenKind.EOF) {
      do {
        if (token.next) {
          token = token.next;
        } else {
          // Read the next token and form a link in the token linked-list.
          const nextToken = readNextToken(this, token.end); // @ts-expect-error next is only mutable during parsing.

          token.next = nextToken; // @ts-expect-error prev is only mutable during parsing.

          nextToken.prev = token;
          token = nextToken;
        }
      } while (token.kind === TokenKind.COMMENT);
    }

    return token;
  }
}
/**
 * @internal
 */

function isPunctuatorTokenKind(kind) {
  return (
    kind === TokenKind.BANG ||
    kind === TokenKind.DOLLAR ||
    kind === TokenKind.AMP ||
    kind === TokenKind.PAREN_L ||
    kind === TokenKind.PAREN_R ||
    kind === TokenKind.SPREAD ||
    kind === TokenKind.COLON ||
    kind === TokenKind.EQUALS ||
    kind === TokenKind.AT ||
    kind === TokenKind.BRACKET_L ||
    kind === TokenKind.BRACKET_R ||
    kind === TokenKind.BRACE_L ||
    kind === TokenKind.PIPE ||
    kind === TokenKind.BRACE_R
  );
}
/**
 * A Unicode scalar value is any Unicode code point except surrogate code
 * points. In other words, the inclusive ranges of values 0x0000 to 0xD7FF and
 * 0xE000 to 0x10FFFF.
 *
 * SourceCharacter ::
 *   - "Any Unicode scalar value"
 */

function isUnicodeScalarValue(code) {
  return (
    (code >= 0x0000 && code <= 0xd7ff) || (code >= 0xe000 && code <= 0x10ffff)
  );
}
/**
 * The GraphQL specification defines source text as a sequence of unicode scalar
 * values (which Unicode defines to exclude surrogate code points). However
 * JavaScript defines strings as a sequence of UTF-16 code units which may
 * include surrogates. A surrogate pair is a valid source character as it
 * encodes a supplementary code point (above U+FFFF), but unpaired surrogate
 * code points are not valid source characters.
 */

function isSupplementaryCodePoint(body, location) {
  return (
    isLeadingSurrogate(body.charCodeAt(location)) &&
    isTrailingSurrogate(body.charCodeAt(location + 1))
  );
}

function isLeadingSurrogate(code) {
  return code >= 0xd800 && code <= 0xdbff;
}

function isTrailingSurrogate(code) {
  return code >= 0xdc00 && code <= 0xdfff;
}
/**
 * Prints the code point (or end of file reference) at a given location in a
 * source for use in error messages.
 *
 * Printable ASCII is printed quoted, while other points are printed in Unicode
 * code point form (ie. U+1234).
 */

function printCodePointAt(lexer, location) {
  const code = lexer.source.body.codePointAt(location);

  if (code === undefined) {
    return TokenKind.EOF;
  } else if (code >= 0x0020 && code <= 0x007e) {
    // Printable ASCII
    const char = String.fromCodePoint(code);
    return char === '"' ? "'\"'" : `"${char}"`;
  } // Unicode code point

  return 'U+' + code.toString(16).toUpperCase().padStart(4, '0');
}
/**
 * Create a token with line and column location information.
 */

function createToken(lexer, kind, start, end, value) {
  const line = lexer.line;
  const col = 1 + start - lexer.lineStart;
  return new Token(kind, start, end, line, col, value);
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */

function readNextToken(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start;

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // SourceCharacter

    switch (code) {
      // Ignored ::
      //   - UnicodeBOM
      //   - WhiteSpace
      //   - LineTerminator
      //   - Comment
      //   - Comma
      //
      // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
      //
      // WhiteSpace ::
      //   - "Horizontal Tab (U+0009)"
      //   - "Space (U+0020)"
      //
      // Comma :: ,
      case 0xfeff: // <BOM>

      case 0x0009: // \t

      case 0x0020: // <space>

      case 0x002c:
        // ,
        ++position;
        continue;
      // LineTerminator ::
      //   - "New Line (U+000A)"
      //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
      //   - "Carriage Return (U+000D)" "New Line (U+000A)"

      case 0x000a:
        // \n
        ++position;
        ++lexer.line;
        lexer.lineStart = position;
        continue;

      case 0x000d:
        // \r
        if (body.charCodeAt(position + 1) === 0x000a) {
          position += 2;
        } else {
          ++position;
        }

        ++lexer.line;
        lexer.lineStart = position;
        continue;
      // Comment

      case 0x0023:
        // #
        return readComment(lexer, position);
      // Token ::
      //   - Punctuator
      //   - Name
      //   - IntValue
      //   - FloatValue
      //   - StringValue
      //
      // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }

      case 0x0021:
        // !
        return createToken(lexer, TokenKind.BANG, position, position + 1);

      case 0x0024:
        // $
        return createToken(lexer, TokenKind.DOLLAR, position, position + 1);

      case 0x0026:
        // &
        return createToken(lexer, TokenKind.AMP, position, position + 1);

      case 0x0028:
        // (
        return createToken(lexer, TokenKind.PAREN_L, position, position + 1);

      case 0x0029:
        // )
        return createToken(lexer, TokenKind.PAREN_R, position, position + 1);

      case 0x002e:
        // .
        if (
          body.charCodeAt(position + 1) === 0x002e &&
          body.charCodeAt(position + 2) === 0x002e
        ) {
          return createToken(lexer, TokenKind.SPREAD, position, position + 3);
        }

        break;

      case 0x003a:
        // :
        return createToken(lexer, TokenKind.COLON, position, position + 1);

      case 0x003d:
        // =
        return createToken(lexer, TokenKind.EQUALS, position, position + 1);

      case 0x0040:
        // @
        return createToken(lexer, TokenKind.AT, position, position + 1);

      case 0x005b:
        // [
        return createToken(lexer, TokenKind.BRACKET_L, position, position + 1);

      case 0x005d:
        // ]
        return createToken(lexer, TokenKind.BRACKET_R, position, position + 1);

      case 0x007b:
        // {
        return createToken(lexer, TokenKind.BRACE_L, position, position + 1);

      case 0x007c:
        // |
        return createToken(lexer, TokenKind.PIPE, position, position + 1);

      case 0x007d:
        // }
        return createToken(lexer, TokenKind.BRACE_R, position, position + 1);
      // StringValue

      case 0x0022:
        // "
        if (
          body.charCodeAt(position + 1) === 0x0022 &&
          body.charCodeAt(position + 2) === 0x0022
        ) {
          return readBlockString(lexer, position);
        }

        return readString(lexer, position);
    } // IntValue | FloatValue (Digit | -)

    if (isDigit(code) || code === 0x002d) {
      return readNumber(lexer, position, code);
    } // Name

    if (isNameStart(code)) {
      return readName(lexer, position);
    }

    throw syntaxError(
      lexer.source,
      position,
      code === 0x0027
        ? 'Unexpected single quote character (\'), did you mean to use a double quote (")?'
        : isUnicodeScalarValue(code) || isSupplementaryCodePoint(body, position)
        ? `Unexpected character: ${printCodePointAt(lexer, position)}.`
        : `Invalid character: ${printCodePointAt(lexer, position)}.`,
    );
  }

  return createToken(lexer, TokenKind.EOF, bodyLength, bodyLength);
}
/**
 * Reads a comment token from the source file.
 *
 * ```
 * Comment :: # CommentChar* [lookahead != CommentChar]
 *
 * CommentChar :: SourceCharacter but not LineTerminator
 * ```
 */

function readComment(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // LineTerminator (\n | \r)

    if (code === 0x000a || code === 0x000d) {
      break;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      break;
    }
  }

  return createToken(
    lexer,
    TokenKind.COMMENT,
    start,
    position,
    body.slice(start + 1, position),
  );
}
/**
 * Reads a number token from the source file, either a FloatValue or an IntValue
 * depending on whether a FractionalPart or ExponentPart is encountered.
 *
 * ```
 * IntValue :: IntegerPart [lookahead != {Digit, `.`, NameStart}]
 *
 * IntegerPart ::
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit Digit*
 *
 * NegativeSign :: -
 *
 * NonZeroDigit :: Digit but not `0`
 *
 * FloatValue ::
 *   - IntegerPart FractionalPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart FractionalPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *
 * FractionalPart :: . Digit+
 *
 * ExponentPart :: ExponentIndicator Sign? Digit+
 *
 * ExponentIndicator :: one of `e` `E`
 *
 * Sign :: one of + -
 * ```
 */

function readNumber(lexer, start, firstCode) {
  const body = lexer.source.body;
  let position = start;
  let code = firstCode;
  let isFloat = false; // NegativeSign (-)

  if (code === 0x002d) {
    code = body.charCodeAt(++position);
  } // Zero (0)

  if (code === 0x0030) {
    code = body.charCodeAt(++position);

    if (isDigit(code)) {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid number, unexpected digit after 0: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  } else {
    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // Full stop (.)

  if (code === 0x002e) {
    isFloat = true;
    code = body.charCodeAt(++position);
    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // E e

  if (code === 0x0045 || code === 0x0065) {
    isFloat = true;
    code = body.charCodeAt(++position); // + -

    if (code === 0x002b || code === 0x002d) {
      code = body.charCodeAt(++position);
    }

    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // Numbers cannot be followed by . or NameStart

  if (code === 0x002e || isNameStart(code)) {
    throw syntaxError(
      lexer.source,
      position,
      `Invalid number, expected digit but got: ${printCodePointAt(
        lexer,
        position,
      )}.`,
    );
  }

  return createToken(
    lexer,
    isFloat ? TokenKind.FLOAT : TokenKind.INT,
    start,
    position,
    body.slice(start, position),
  );
}
/**
 * Returns the new position in the source after reading one or more digits.
 */

function readDigits(lexer, start, firstCode) {
  if (!isDigit(firstCode)) {
    throw syntaxError(
      lexer.source,
      start,
      `Invalid number, expected digit but got: ${printCodePointAt(
        lexer,
        start,
      )}.`,
    );
  }

  const body = lexer.source.body;
  let position = start + 1; // +1 to skip first firstCode

  while (isDigit(body.charCodeAt(position))) {
    ++position;
  }

  return position;
}
/**
 * Reads a single-quote string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `""` [lookahead != `"`]
 *   - `"` StringCharacter+ `"`
 *
 * StringCharacter ::
 *   - SourceCharacter but not `"` or `\` or LineTerminator
 *   - `\u` EscapedUnicode
 *   - `\` EscapedCharacter
 *
 * EscapedUnicode ::
 *   - `{` HexDigit+ `}`
 *   - HexDigit HexDigit HexDigit HexDigit
 *
 * EscapedCharacter :: one of `"` `\` `/` `b` `f` `n` `r` `t`
 * ```
 */

function readString(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;
  let chunkStart = position;
  let value = '';

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // Closing Quote (")

    if (code === 0x0022) {
      value += body.slice(chunkStart, position);
      return createToken(lexer, TokenKind.STRING, start, position + 1, value);
    } // Escape Sequence (\)

    if (code === 0x005c) {
      value += body.slice(chunkStart, position);
      const escape =
        body.charCodeAt(position + 1) === 0x0075 // u
          ? body.charCodeAt(position + 2) === 0x007b // {
            ? readEscapedUnicodeVariableWidth(lexer, position)
            : readEscapedUnicodeFixedWidth(lexer, position)
          : readEscapedCharacter(lexer, position);
      value += escape.value;
      position += escape.size;
      chunkStart = position;
      continue;
    } // LineTerminator (\n | \r)

    if (code === 0x000a || code === 0x000d) {
      break;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid character within String: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  }

  throw syntaxError(lexer.source, position, 'Unterminated string.');
} // The string value and lexed size of an escape sequence.

function readEscapedUnicodeVariableWidth(lexer, position) {
  const body = lexer.source.body;
  let point = 0;
  let size = 3; // Cannot be larger than 12 chars (\u{00000000}).

  while (size < 12) {
    const code = body.charCodeAt(position + size++); // Closing Brace (})

    if (code === 0x007d) {
      // Must be at least 5 chars (\u{0}) and encode a Unicode scalar value.
      if (size < 5 || !isUnicodeScalarValue(point)) {
        break;
      }

      return {
        value: String.fromCodePoint(point),
        size,
      };
    } // Append this hex digit to the code point.

    point = (point << 4) | readHexDigit(code);

    if (point < 0) {
      break;
    }
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid Unicode escape sequence: "${body.slice(
      position,
      position + size,
    )}".`,
  );
}

function readEscapedUnicodeFixedWidth(lexer, position) {
  const body = lexer.source.body;
  const code = read16BitHexCode(body, position + 2);

  if (isUnicodeScalarValue(code)) {
    return {
      value: String.fromCodePoint(code),
      size: 6,
    };
  } // GraphQL allows JSON-style surrogate pair escape sequences, but only when
  // a valid pair is formed.

  if (isLeadingSurrogate(code)) {
    // \u
    if (
      body.charCodeAt(position + 6) === 0x005c &&
      body.charCodeAt(position + 7) === 0x0075
    ) {
      const trailingCode = read16BitHexCode(body, position + 8);

      if (isTrailingSurrogate(trailingCode)) {
        // JavaScript defines strings as a sequence of UTF-16 code units and
        // encodes Unicode code points above U+FFFF using a surrogate pair of
        // code units. Since this is a surrogate pair escape sequence, just
        // include both codes into the JavaScript string value. Had JavaScript
        // not been internally based on UTF-16, then this surrogate pair would
        // be decoded to retrieve the supplementary code point.
        return {
          value: String.fromCodePoint(code, trailingCode),
          size: 12,
        };
      }
    }
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid Unicode escape sequence: "${body.slice(position, position + 6)}".`,
  );
}
/**
 * Reads four hexadecimal characters and returns the positive integer that 16bit
 * hexadecimal string represents. For example, "000f" will return 15, and "dead"
 * will return 57005.
 *
 * Returns a negative number if any char was not a valid hexadecimal digit.
 */

function read16BitHexCode(body, position) {
  // readHexDigit() returns -1 on error. ORing a negative value with any other
  // value always produces a negative value.
  return (
    (readHexDigit(body.charCodeAt(position)) << 12) |
    (readHexDigit(body.charCodeAt(position + 1)) << 8) |
    (readHexDigit(body.charCodeAt(position + 2)) << 4) |
    readHexDigit(body.charCodeAt(position + 3))
  );
}
/**
 * Reads a hexadecimal character and returns its positive integer value (0-15).
 *
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 if the provided character code was not a valid hexadecimal digit.
 *
 * HexDigit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 *   - `A` `B` `C` `D` `E` `F`
 *   - `a` `b` `c` `d` `e` `f`
 */

function readHexDigit(code) {
  return code >= 0x0030 && code <= 0x0039 // 0-9
    ? code - 0x0030
    : code >= 0x0041 && code <= 0x0046 // A-F
    ? code - 0x0037
    : code >= 0x0061 && code <= 0x0066 // a-f
    ? code - 0x0057
    : -1;
}
/**
 * | Escaped Character | Code Point | Character Name               |
 * | ----------------- | ---------- | ---------------------------- |
 * | `"`               | U+0022     | double quote                 |
 * | `\`               | U+005C     | reverse solidus (back slash) |
 * | `/`               | U+002F     | solidus (forward slash)      |
 * | `b`               | U+0008     | backspace                    |
 * | `f`               | U+000C     | form feed                    |
 * | `n`               | U+000A     | line feed (new line)         |
 * | `r`               | U+000D     | carriage return              |
 * | `t`               | U+0009     | horizontal tab               |
 */

function readEscapedCharacter(lexer, position) {
  const body = lexer.source.body;
  const code = body.charCodeAt(position + 1);

  switch (code) {
    case 0x0022:
      // "
      return {
        value: '\u0022',
        size: 2,
      };

    case 0x005c:
      // \
      return {
        value: '\u005c',
        size: 2,
      };

    case 0x002f:
      // /
      return {
        value: '\u002f',
        size: 2,
      };

    case 0x0062:
      // b
      return {
        value: '\u0008',
        size: 2,
      };

    case 0x0066:
      // f
      return {
        value: '\u000c',
        size: 2,
      };

    case 0x006e:
      // n
      return {
        value: '\u000a',
        size: 2,
      };

    case 0x0072:
      // r
      return {
        value: '\u000d',
        size: 2,
      };

    case 0x0074:
      // t
      return {
        value: '\u0009',
        size: 2,
      };
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid character escape sequence: "${body.slice(
      position,
      position + 2,
    )}".`,
  );
}
/**
 * Reads a block string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `"""` BlockStringCharacter* `"""`
 *
 * BlockStringCharacter ::
 *   - SourceCharacter but not `"""` or `\"""`
 *   - `\"""`
 * ```
 */

function readBlockString(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let lineStart = lexer.lineStart;
  let position = start + 3;
  let chunkStart = position;
  let currentLine = '';
  const blockLines = [];

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // Closing Triple-Quote (""")

    if (
      code === 0x0022 &&
      body.charCodeAt(position + 1) === 0x0022 &&
      body.charCodeAt(position + 2) === 0x0022
    ) {
      currentLine += body.slice(chunkStart, position);
      blockLines.push(currentLine);
      const token = createToken(
        lexer,
        TokenKind.BLOCK_STRING,
        start,
        position + 3, // Return a string of the lines joined with U+000A.
        dedentBlockStringLines(blockLines).join('\n'),
      );
      lexer.line += blockLines.length - 1;
      lexer.lineStart = lineStart;
      return token;
    } // Escaped Triple-Quote (\""")

    if (
      code === 0x005c &&
      body.charCodeAt(position + 1) === 0x0022 &&
      body.charCodeAt(position + 2) === 0x0022 &&
      body.charCodeAt(position + 3) === 0x0022
    ) {
      currentLine += body.slice(chunkStart, position);
      chunkStart = position + 1; // skip only slash

      position += 4;
      continue;
    } // LineTerminator

    if (code === 0x000a || code === 0x000d) {
      currentLine += body.slice(chunkStart, position);
      blockLines.push(currentLine);

      if (code === 0x000d && body.charCodeAt(position + 1) === 0x000a) {
        position += 2;
      } else {
        ++position;
      }

      currentLine = '';
      chunkStart = position;
      lineStart = position;
      continue;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid character within String: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  }

  throw syntaxError(lexer.source, position, 'Unterminated string.');
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * ```
 * Name ::
 *   - NameStart NameContinue* [lookahead != NameContinue]
 * ```
 */

function readName(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;

  while (position < bodyLength) {
    const code = body.charCodeAt(position);

    if (isNameContinue(code)) {
      ++position;
    } else {
      break;
    }
  }

  return createToken(
    lexer,
    TokenKind.NAME,
    start,
    position,
    body.slice(start, position),
  );
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/inspect.mjs
const MAX_ARRAY_LENGTH = 10;
const MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */

function inspect(value) {
  return formatValue(value, []);
}

function formatValue(value, seenValues) {
  switch (typeof value) {
    case 'string':
      return JSON.stringify(value);

    case 'function':
      return value.name ? `[function ${value.name}]` : '[function]';

    case 'object':
      return formatObjectValue(value, seenValues);

    default:
      return String(value);
  }
}

function formatObjectValue(value, previouslySeenValues) {
  if (value === null) {
    return 'null';
  }

  if (previouslySeenValues.includes(value)) {
    return '[Circular]';
  }

  const seenValues = [...previouslySeenValues, value];

  if (isJSONable(value)) {
    const jsonValue = value.toJSON(); // check for infinite recursion

    if (jsonValue !== value) {
      return typeof jsonValue === 'string'
        ? jsonValue
        : formatValue(jsonValue, seenValues);
    }
  } else if (Array.isArray(value)) {
    return formatArray(value, seenValues);
  }

  return formatObject(value, seenValues);
}

function isJSONable(value) {
  return typeof value.toJSON === 'function';
}

function formatObject(object, seenValues) {
  const entries = Object.entries(object);

  if (entries.length === 0) {
    return '{}';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[' + getObjectTag(object) + ']';
  }

  const properties = entries.map(
    ([key, value]) => key + ': ' + formatValue(value, seenValues),
  );
  return '{ ' + properties.join(', ') + ' }';
}

function formatArray(array, seenValues) {
  if (array.length === 0) {
    return '[]';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[Array]';
  }

  const len = Math.min(MAX_ARRAY_LENGTH, array.length);
  const remaining = array.length - len;
  const items = [];

  for (let i = 0; i < len; ++i) {
    items.push(formatValue(array[i], seenValues));
  }

  if (remaining === 1) {
    items.push('... 1 more item');
  } else if (remaining > 1) {
    items.push(`... ${remaining} more items`);
  }

  return '[' + items.join(', ') + ']';
}

function getObjectTag(object) {
  const tag = Object.prototype.toString
    .call(object)
    .replace(/^\[object /, '')
    .replace(/]$/, '');

  if (tag === 'Object' && typeof object.constructor === 'function') {
    const name = object.constructor.name;

    if (typeof name === 'string' && name !== '') {
      return name;
    }
  }

  return tag;
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/instanceOf.mjs

/**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 * See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
 * See: https://webpack.js.org/guides/production/
 */

const instanceOf =
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  globalThis.process && globalThis.process.env.NODE_ENV === 'production'
    ? function instanceOf(value, constructor) {
        return value instanceof constructor;
      }
    : function instanceOf(value, constructor) {
        if (value instanceof constructor) {
          return true;
        }

        if (typeof value === 'object' && value !== null) {
          var _value$constructor;

          // Prefer Symbol.toStringTag since it is immune to minification.
          const className = constructor.prototype[Symbol.toStringTag];
          const valueClassName = // We still need to support constructor's name to detect conflicts with older versions of this library.
            Symbol.toStringTag in value // @ts-expect-error TS bug see, https://github.com/microsoft/TypeScript/issues/38009
              ? value[Symbol.toStringTag]
              : (_value$constructor = value.constructor) === null ||
                _value$constructor === void 0
              ? void 0
              : _value$constructor.name;

          if (className === valueClassName) {
            const stringifiedValue = inspect(value);
            throw new Error(`Cannot use ${className} "${stringifiedValue}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
          }
        }

        return false;
      };

;// CONCATENATED MODULE: ../node_modules/graphql/language/source.mjs




/**
 * A representation of source input to GraphQL. The `name` and `locationOffset` parameters are
 * optional, but they are useful for clients who store GraphQL documents in source files.
 * For example, if the GraphQL input starts at line 40 in a file named `Foo.graphql`, it might
 * be useful for `name` to be `"Foo.graphql"` and location to be `{ line: 40, column: 1 }`.
 * The `line` and `column` properties in `locationOffset` are 1-indexed.
 */
class Source {
  constructor(
    body,
    name = 'GraphQL request',
    locationOffset = {
      line: 1,
      column: 1,
    },
  ) {
    typeof body === 'string' ||
      devAssert(false, `Body must be a string. Received: ${inspect(body)}.`);
    this.body = body;
    this.name = name;
    this.locationOffset = locationOffset;
    this.locationOffset.line > 0 ||
      devAssert(
        false,
        'line in locationOffset is 1-indexed and must be positive.',
      );
    this.locationOffset.column > 0 ||
      devAssert(
        false,
        'column in locationOffset is 1-indexed and must be positive.',
      );
  }

  get [Symbol.toStringTag]() {
    return 'Source';
  }
}
/**
 * Test if the given value is a Source object.
 *
 * @internal
 */

function isSource(source) {
  return instanceOf(source, Source);
}

;// CONCATENATED MODULE: ../node_modules/graphql/language/parser.mjs







/**
 * Configuration options to control parser behavior
 */

/**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */
function parse(source, options) {
  const parser = new Parser(source, options);
  return parser.parseDocument();
}
/**
 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
 * that value.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Values directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: valueFromAST().
 */

function parseValue(source, options) {
  const parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  const value = parser.parseValueLiteral(false);
  parser.expectToken(TokenKind.EOF);
  return value;
}
/**
 * Similar to parseValue(), but raises a parse error if it encounters a
 * variable. The return type will be a constant value.
 */

function parseConstValue(source, options) {
  const parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  const value = parser.parseConstValueLiteral();
  parser.expectToken(TokenKind.EOF);
  return value;
}
/**
 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
 * that type.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Types directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: typeFromAST().
 */

function parseType(source, options) {
  const parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  const type = parser.parseTypeReference();
  parser.expectToken(TokenKind.EOF);
  return type;
}
/**
 * This class is exported only to assist people in implementing their own parsers
 * without duplicating too much code and should be used only as last resort for cases
 * such as experimental syntax or if certain features could not be contributed upstream.
 *
 * It is still part of the internal API and is versioned, so any changes to it are never
 * considered breaking changes. If you still need to support multiple versions of the
 * library, please use the `versionInfo` variable for version detection.
 *
 * @internal
 */

class Parser {
  constructor(source, options = {}) {
    const sourceObj = isSource(source) ? source : new Source(source);
    this._lexer = new Lexer(sourceObj);
    this._options = options;
    this._tokenCounter = 0;
  }
  /**
   * Converts a name lex token into a name parse node.
   */

  parseName() {
    const token = this.expectToken(TokenKind.NAME);
    return this.node(token, {
      kind: Kind.NAME,
      value: token.value,
    });
  } // Implements the parsing rules in the Document section.

  /**
   * Document : Definition+
   */

  parseDocument() {
    return this.node(this._lexer.token, {
      kind: Kind.DOCUMENT,
      definitions: this.many(
        TokenKind.SOF,
        this.parseDefinition,
        TokenKind.EOF,
      ),
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */

  parseDefinition() {
    if (this.peek(TokenKind.BRACE_L)) {
      return this.parseOperationDefinition();
    } // Many definitions begin with a description and require a lookahead.

    const hasDescription = this.peekDescription();
    const keywordToken = hasDescription
      ? this._lexer.lookahead()
      : this._lexer.token;

    if (keywordToken.kind === TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaDefinition();

        case 'scalar':
          return this.parseScalarTypeDefinition();

        case 'type':
          return this.parseObjectTypeDefinition();

        case 'interface':
          return this.parseInterfaceTypeDefinition();

        case 'union':
          return this.parseUnionTypeDefinition();

        case 'enum':
          return this.parseEnumTypeDefinition();

        case 'input':
          return this.parseInputObjectTypeDefinition();

        case 'directive':
          return this.parseDirectiveDefinition();
      }

      if (hasDescription) {
        throw syntaxError(
          this._lexer.source,
          this._lexer.token.start,
          'Unexpected description, descriptions are supported only on type definitions.',
        );
      }

      switch (keywordToken.value) {
        case 'query':
        case 'mutation':
        case 'subscription':
          return this.parseOperationDefinition();

        case 'fragment':
          return this.parseFragmentDefinition();

        case 'extend':
          return this.parseTypeSystemExtension();
      }
    }

    throw this.unexpected(keywordToken);
  } // Implements the parsing rules in the Operations section.

  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */

  parseOperationDefinition() {
    const start = this._lexer.token;

    if (this.peek(TokenKind.BRACE_L)) {
      return this.node(start, {
        kind: Kind.OPERATION_DEFINITION,
        operation: OperationTypeNode.QUERY,
        name: undefined,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet(),
      });
    }

    const operation = this.parseOperationType();
    let name;

    if (this.peek(TokenKind.NAME)) {
      name = this.parseName();
    }

    return this.node(start, {
      kind: Kind.OPERATION_DEFINITION,
      operation,
      name,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * OperationType : one of query mutation subscription
   */

  parseOperationType() {
    const operationToken = this.expectToken(TokenKind.NAME);

    switch (operationToken.value) {
      case 'query':
        return OperationTypeNode.QUERY;

      case 'mutation':
        return OperationTypeNode.MUTATION;

      case 'subscription':
        return OperationTypeNode.SUBSCRIPTION;
    }

    throw this.unexpected(operationToken);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */

  parseVariableDefinitions() {
    return this.optionalMany(
      TokenKind.PAREN_L,
      this.parseVariableDefinition,
      TokenKind.PAREN_R,
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */

  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: Kind.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(TokenKind.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(TokenKind.EQUALS)
        ? this.parseConstValueLiteral()
        : undefined,
      directives: this.parseConstDirectives(),
    });
  }
  /**
   * Variable : $ Name
   */

  parseVariable() {
    const start = this._lexer.token;
    this.expectToken(TokenKind.DOLLAR);
    return this.node(start, {
      kind: Kind.VARIABLE,
      name: this.parseName(),
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */

  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: Kind.SELECTION_SET,
      selections: this.many(
        TokenKind.BRACE_L,
        this.parseSelection,
        TokenKind.BRACE_R,
      ),
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */

  parseSelection() {
    return this.peek(TokenKind.SPREAD)
      ? this.parseFragment()
      : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */

  parseField() {
    const start = this._lexer.token;
    const nameOrAlias = this.parseName();
    let alias;
    let name;

    if (this.expectOptionalToken(TokenKind.COLON)) {
      alias = nameOrAlias;
      name = this.parseName();
    } else {
      name = nameOrAlias;
    }

    return this.node(start, {
      kind: Kind.FIELD,
      alias,
      name,
      arguments: this.parseArguments(false),
      directives: this.parseDirectives(false),
      selectionSet: this.peek(TokenKind.BRACE_L)
        ? this.parseSelectionSet()
        : undefined,
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */

  parseArguments(isConst) {
    const item = isConst ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(TokenKind.PAREN_L, item, TokenKind.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */

  parseArgument(isConst = false) {
    const start = this._lexer.token;
    const name = this.parseName();
    this.expectToken(TokenKind.COLON);
    return this.node(start, {
      kind: Kind.ARGUMENT,
      name,
      value: this.parseValueLiteral(isConst),
    });
  }

  parseConstArgument() {
    return this.parseArgument(true);
  } // Implements the parsing rules in the Fragments section.

  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */

  parseFragment() {
    const start = this._lexer.token;
    this.expectToken(TokenKind.SPREAD);
    const hasTypeCondition = this.expectOptionalKeyword('on');

    if (!hasTypeCondition && this.peek(TokenKind.NAME)) {
      return this.node(start, {
        kind: Kind.FRAGMENT_SPREAD,
        name: this.parseFragmentName(),
        directives: this.parseDirectives(false),
      });
    }

    return this.node(start, {
      kind: Kind.INLINE_FRAGMENT,
      typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */

  parseFragmentDefinition() {
    const start = this._lexer.token;
    this.expectKeyword('fragment'); // Legacy support for defining variables within fragments changes
    // the grammar of FragmentDefinition:
    //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet

    if (this._options.allowLegacyFragmentVariables === true) {
      return this.node(start, {
        kind: Kind.FRAGMENT_DEFINITION,
        name: this.parseFragmentName(),
        variableDefinitions: this.parseVariableDefinitions(),
        typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
        directives: this.parseDirectives(false),
        selectionSet: this.parseSelectionSet(),
      });
    }

    return this.node(start, {
      kind: Kind.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * FragmentName : Name but not `on`
   */

  parseFragmentName() {
    if (this._lexer.token.value === 'on') {
      throw this.unexpected();
    }

    return this.parseName();
  } // Implements the parsing rules in the Values section.

  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */

  parseValueLiteral(isConst) {
    const token = this._lexer.token;

    switch (token.kind) {
      case TokenKind.BRACKET_L:
        return this.parseList(isConst);

      case TokenKind.BRACE_L:
        return this.parseObject(isConst);

      case TokenKind.INT:
        this.advanceLexer();
        return this.node(token, {
          kind: Kind.INT,
          value: token.value,
        });

      case TokenKind.FLOAT:
        this.advanceLexer();
        return this.node(token, {
          kind: Kind.FLOAT,
          value: token.value,
        });

      case TokenKind.STRING:
      case TokenKind.BLOCK_STRING:
        return this.parseStringLiteral();

      case TokenKind.NAME:
        this.advanceLexer();

        switch (token.value) {
          case 'true':
            return this.node(token, {
              kind: Kind.BOOLEAN,
              value: true,
            });

          case 'false':
            return this.node(token, {
              kind: Kind.BOOLEAN,
              value: false,
            });

          case 'null':
            return this.node(token, {
              kind: Kind.NULL,
            });

          default:
            return this.node(token, {
              kind: Kind.ENUM,
              value: token.value,
            });
        }

      case TokenKind.DOLLAR:
        if (isConst) {
          this.expectToken(TokenKind.DOLLAR);

          if (this._lexer.token.kind === TokenKind.NAME) {
            const varName = this._lexer.token.value;
            throw syntaxError(
              this._lexer.source,
              token.start,
              `Unexpected variable "$${varName}" in constant value.`,
            );
          } else {
            throw this.unexpected(token);
          }
        }

        return this.parseVariable();

      default:
        throw this.unexpected();
    }
  }

  parseConstValueLiteral() {
    return this.parseValueLiteral(true);
  }

  parseStringLiteral() {
    const token = this._lexer.token;
    this.advanceLexer();
    return this.node(token, {
      kind: Kind.STRING,
      value: token.value,
      block: token.kind === TokenKind.BLOCK_STRING,
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */

  parseList(isConst) {
    const item = () => this.parseValueLiteral(isConst);

    return this.node(this._lexer.token, {
      kind: Kind.LIST,
      values: this.any(TokenKind.BRACKET_L, item, TokenKind.BRACKET_R),
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */

  parseObject(isConst) {
    const item = () => this.parseObjectField(isConst);

    return this.node(this._lexer.token, {
      kind: Kind.OBJECT,
      fields: this.any(TokenKind.BRACE_L, item, TokenKind.BRACE_R),
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */

  parseObjectField(isConst) {
    const start = this._lexer.token;
    const name = this.parseName();
    this.expectToken(TokenKind.COLON);
    return this.node(start, {
      kind: Kind.OBJECT_FIELD,
      name,
      value: this.parseValueLiteral(isConst),
    });
  } // Implements the parsing rules in the Directives section.

  /**
   * Directives[Const] : Directive[?Const]+
   */

  parseDirectives(isConst) {
    const directives = [];

    while (this.peek(TokenKind.AT)) {
      directives.push(this.parseDirective(isConst));
    }

    return directives;
  }

  parseConstDirectives() {
    return this.parseDirectives(true);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */

  parseDirective(isConst) {
    const start = this._lexer.token;
    this.expectToken(TokenKind.AT);
    return this.node(start, {
      kind: Kind.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(isConst),
    });
  } // Implements the parsing rules in the Types section.

  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */

  parseTypeReference() {
    const start = this._lexer.token;
    let type;

    if (this.expectOptionalToken(TokenKind.BRACKET_L)) {
      const innerType = this.parseTypeReference();
      this.expectToken(TokenKind.BRACKET_R);
      type = this.node(start, {
        kind: Kind.LIST_TYPE,
        type: innerType,
      });
    } else {
      type = this.parseNamedType();
    }

    if (this.expectOptionalToken(TokenKind.BANG)) {
      return this.node(start, {
        kind: Kind.NON_NULL_TYPE,
        type,
      });
    }

    return type;
  }
  /**
   * NamedType : Name
   */

  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: Kind.NAMED_TYPE,
      name: this.parseName(),
    });
  } // Implements the parsing rules in the Type Definition section.

  peekDescription() {
    return this.peek(TokenKind.STRING) || this.peek(TokenKind.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */

  parseDescription() {
    if (this.peekDescription()) {
      return this.parseStringLiteral();
    }
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */

  parseSchemaDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('schema');
    const directives = this.parseConstDirectives();
    const operationTypes = this.many(
      TokenKind.BRACE_L,
      this.parseOperationTypeDefinition,
      TokenKind.BRACE_R,
    );
    return this.node(start, {
      kind: Kind.SCHEMA_DEFINITION,
      description,
      directives,
      operationTypes,
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */

  parseOperationTypeDefinition() {
    const start = this._lexer.token;
    const operation = this.parseOperationType();
    this.expectToken(TokenKind.COLON);
    const type = this.parseNamedType();
    return this.node(start, {
      kind: Kind.OPERATION_TYPE_DEFINITION,
      operation,
      type,
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */

  parseScalarTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('scalar');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: Kind.SCALAR_TYPE_DEFINITION,
      description,
      name,
      directives,
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */

  parseObjectTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('type');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();
    return this.node(start, {
      kind: Kind.OBJECT_TYPE_DEFINITION,
      description,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */

  parseImplementsInterfaces() {
    return this.expectOptionalKeyword('implements')
      ? this.delimitedMany(TokenKind.AMP, this.parseNamedType)
      : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */

  parseFieldsDefinition() {
    return this.optionalMany(
      TokenKind.BRACE_L,
      this.parseFieldDefinition,
      TokenKind.BRACE_R,
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */

  parseFieldDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseName();
    const args = this.parseArgumentDefs();
    this.expectToken(TokenKind.COLON);
    const type = this.parseTypeReference();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: Kind.FIELD_DEFINITION,
      description,
      name,
      arguments: args,
      type,
      directives,
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */

  parseArgumentDefs() {
    return this.optionalMany(
      TokenKind.PAREN_L,
      this.parseInputValueDef,
      TokenKind.PAREN_R,
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */

  parseInputValueDef() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseName();
    this.expectToken(TokenKind.COLON);
    const type = this.parseTypeReference();
    let defaultValue;

    if (this.expectOptionalToken(TokenKind.EQUALS)) {
      defaultValue = this.parseConstValueLiteral();
    }

    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: Kind.INPUT_VALUE_DEFINITION,
      description,
      name,
      type,
      defaultValue,
      directives,
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */

  parseInterfaceTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('interface');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();
    return this.node(start, {
      kind: Kind.INTERFACE_TYPE_DEFINITION,
      description,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */

  parseUnionTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('union');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const types = this.parseUnionMemberTypes();
    return this.node(start, {
      kind: Kind.UNION_TYPE_DEFINITION,
      description,
      name,
      directives,
      types,
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */

  parseUnionMemberTypes() {
    return this.expectOptionalToken(TokenKind.EQUALS)
      ? this.delimitedMany(TokenKind.PIPE, this.parseNamedType)
      : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */

  parseEnumTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('enum');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const values = this.parseEnumValuesDefinition();
    return this.node(start, {
      kind: Kind.ENUM_TYPE_DEFINITION,
      description,
      name,
      directives,
      values,
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */

  parseEnumValuesDefinition() {
    return this.optionalMany(
      TokenKind.BRACE_L,
      this.parseEnumValueDefinition,
      TokenKind.BRACE_R,
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */

  parseEnumValueDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseEnumValueName();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: Kind.ENUM_VALUE_DEFINITION,
      description,
      name,
      directives,
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   */

  parseEnumValueName() {
    if (
      this._lexer.token.value === 'true' ||
      this._lexer.token.value === 'false' ||
      this._lexer.token.value === 'null'
    ) {
      throw syntaxError(
        this._lexer.source,
        this._lexer.token.start,
        `${getTokenDesc(
          this._lexer.token,
        )} is reserved and cannot be used for an enum value.`,
      );
    }

    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */

  parseInputObjectTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('input');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const fields = this.parseInputFieldsDefinition();
    return this.node(start, {
      kind: Kind.INPUT_OBJECT_TYPE_DEFINITION,
      description,
      name,
      directives,
      fields,
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */

  parseInputFieldsDefinition() {
    return this.optionalMany(
      TokenKind.BRACE_L,
      this.parseInputValueDef,
      TokenKind.BRACE_R,
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */

  parseTypeSystemExtension() {
    const keywordToken = this._lexer.lookahead();

    if (keywordToken.kind === TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaExtension();

        case 'scalar':
          return this.parseScalarTypeExtension();

        case 'type':
          return this.parseObjectTypeExtension();

        case 'interface':
          return this.parseInterfaceTypeExtension();

        case 'union':
          return this.parseUnionTypeExtension();

        case 'enum':
          return this.parseEnumTypeExtension();

        case 'input':
          return this.parseInputObjectTypeExtension();
      }
    }

    throw this.unexpected(keywordToken);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */

  parseSchemaExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('schema');
    const directives = this.parseConstDirectives();
    const operationTypes = this.optionalMany(
      TokenKind.BRACE_L,
      this.parseOperationTypeDefinition,
      TokenKind.BRACE_R,
    );

    if (directives.length === 0 && operationTypes.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: Kind.SCHEMA_EXTENSION,
      directives,
      operationTypes,
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */

  parseScalarTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('scalar');
    const name = this.parseName();
    const directives = this.parseConstDirectives();

    if (directives.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: Kind.SCALAR_TYPE_EXTENSION,
      name,
      directives,
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */

  parseObjectTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('type');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();

    if (
      interfaces.length === 0 &&
      directives.length === 0 &&
      fields.length === 0
    ) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: Kind.OBJECT_TYPE_EXTENSION,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */

  parseInterfaceTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('interface');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();

    if (
      interfaces.length === 0 &&
      directives.length === 0 &&
      fields.length === 0
    ) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: Kind.INTERFACE_TYPE_EXTENSION,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */

  parseUnionTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('union');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const types = this.parseUnionMemberTypes();

    if (directives.length === 0 && types.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: Kind.UNION_TYPE_EXTENSION,
      name,
      directives,
      types,
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */

  parseEnumTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('enum');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const values = this.parseEnumValuesDefinition();

    if (directives.length === 0 && values.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: Kind.ENUM_TYPE_EXTENSION,
      name,
      directives,
      values,
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */

  parseInputObjectTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('input');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const fields = this.parseInputFieldsDefinition();

    if (directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: Kind.INPUT_OBJECT_TYPE_EXTENSION,
      name,
      directives,
      fields,
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */

  parseDirectiveDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('directive');
    this.expectToken(TokenKind.AT);
    const name = this.parseName();
    const args = this.parseArgumentDefs();
    const repeatable = this.expectOptionalKeyword('repeatable');
    this.expectKeyword('on');
    const locations = this.parseDirectiveLocations();
    return this.node(start, {
      kind: Kind.DIRECTIVE_DEFINITION,
      description,
      name,
      arguments: args,
      repeatable,
      locations,
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */

  parseDirectiveLocations() {
    return this.delimitedMany(TokenKind.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */

  parseDirectiveLocation() {
    const start = this._lexer.token;
    const name = this.parseName();

    if (Object.prototype.hasOwnProperty.call(DirectiveLocation, name.value)) {
      return name;
    }

    throw this.unexpected(start);
  } // Core parsing utility functions

  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */

  node(startToken, node) {
    if (this._options.noLocation !== true) {
      node.loc = new Location(
        startToken,
        this._lexer.lastToken,
        this._lexer.source,
      );
    }

    return node;
  }
  /**
   * Determines if the next token is of a given kind
   */

  peek(kind) {
    return this._lexer.token.kind === kind;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */

  expectToken(kind) {
    const token = this._lexer.token;

    if (token.kind === kind) {
      this.advanceLexer();
      return token;
    }

    throw syntaxError(
      this._lexer.source,
      token.start,
      `Expected ${getTokenKindDesc(kind)}, found ${getTokenDesc(token)}.`,
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */

  expectOptionalToken(kind) {
    const token = this._lexer.token;

    if (token.kind === kind) {
      this.advanceLexer();
      return true;
    }

    return false;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */

  expectKeyword(value) {
    const token = this._lexer.token;

    if (token.kind === TokenKind.NAME && token.value === value) {
      this.advanceLexer();
    } else {
      throw syntaxError(
        this._lexer.source,
        token.start,
        `Expected "${value}", found ${getTokenDesc(token)}.`,
      );
    }
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */

  expectOptionalKeyword(value) {
    const token = this._lexer.token;

    if (token.kind === TokenKind.NAME && token.value === value) {
      this.advanceLexer();
      return true;
    }

    return false;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */

  unexpected(atToken) {
    const token =
      atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
    return syntaxError(
      this._lexer.source,
      token.start,
      `Unexpected ${getTokenDesc(token)}.`,
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  any(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    const nodes = [];

    while (!this.expectOptionalToken(closeKind)) {
      nodes.push(parseFn.call(this));
    }

    return nodes;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  optionalMany(openKind, parseFn, closeKind) {
    if (this.expectOptionalToken(openKind)) {
      const nodes = [];

      do {
        nodes.push(parseFn.call(this));
      } while (!this.expectOptionalToken(closeKind));

      return nodes;
    }

    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  many(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    const nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (!this.expectOptionalToken(closeKind));

    return nodes;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */

  delimitedMany(delimiterKind, parseFn) {
    this.expectOptionalToken(delimiterKind);
    const nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (this.expectOptionalToken(delimiterKind));

    return nodes;
  }

  advanceLexer() {
    const { maxTokens } = this._options;

    const token = this._lexer.advance();

    if (maxTokens !== undefined && token.kind !== TokenKind.EOF) {
      ++this._tokenCounter;

      if (this._tokenCounter > maxTokens) {
        throw syntaxError(
          this._lexer.source,
          token.start,
          `Document contains more that ${maxTokens} tokens. Parsing aborted.`,
        );
      }
    }
  }
}
/**
 * A helper function to describe a token as a string for debugging.
 */

function getTokenDesc(token) {
  const value = token.value;
  return getTokenKindDesc(token.kind) + (value != null ? ` "${value}"` : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */

function getTokenKindDesc(kind) {
  return isPunctuatorTokenKind(kind) ? `"${kind}"` : kind;
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/didYouMean.mjs
const MAX_SUGGESTIONS = 5;
/**
 * Given [ A, B, C ] return ' Did you mean A, B, or C?'.
 */

function didYouMean(firstArg, secondArg) {
  const [subMessage, suggestionsArg] = secondArg
    ? [firstArg, secondArg]
    : [undefined, firstArg];
  let message = ' Did you mean ';

  if (subMessage) {
    message += subMessage + ' ';
  }

  const suggestions = suggestionsArg.map((x) => `"${x}"`);

  switch (suggestions.length) {
    case 0:
      return '';

    case 1:
      return message + suggestions[0] + '?';

    case 2:
      return message + suggestions[0] + ' or ' + suggestions[1] + '?';
  }

  const selected = suggestions.slice(0, MAX_SUGGESTIONS);
  const lastItem = selected.pop();
  return message + selected.join(', ') + ', or ' + lastItem + '?';
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/identityFunc.mjs
/**
 * Returns the first argument it receives.
 */
function identityFunc(x) {
  return x;
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/keyMap.mjs
/**
 * Creates a keyed JS object from an array, given a function to produce the keys
 * for each value in the array.
 *
 * This provides a convenient lookup for the array items if the key function
 * produces unique results.
 * ```ts
 * const phoneBook = [
 *   { name: 'Jon', num: '555-1234' },
 *   { name: 'Jenny', num: '867-5309' }
 * ]
 *
 * const entriesByName = keyMap(
 *   phoneBook,
 *   entry => entry.name
 * )
 *
 * // {
 * //   Jon: { name: 'Jon', num: '555-1234' },
 * //   Jenny: { name: 'Jenny', num: '867-5309' }
 * // }
 *
 * const jennyEntry = entriesByName['Jenny']
 *
 * // { name: 'Jenny', num: '857-6309' }
 * ```
 */
function keyMap(list, keyFn) {
  const result = Object.create(null);

  for (const item of list) {
    result[keyFn(item)] = item;
  }

  return result;
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/keyValMap.mjs
/**
 * Creates a keyed JS object from an array, given a function to produce the keys
 * and a function to produce the values from each item in the array.
 * ```ts
 * const phoneBook = [
 *   { name: 'Jon', num: '555-1234' },
 *   { name: 'Jenny', num: '867-5309' }
 * ]
 *
 * // { Jon: '555-1234', Jenny: '867-5309' }
 * const phonesByName = keyValMap(
 *   phoneBook,
 *   entry => entry.name,
 *   entry => entry.num
 * )
 * ```
 */
function keyValMap(list, keyFn, valFn) {
  const result = Object.create(null);

  for (const item of list) {
    result[keyFn(item)] = valFn(item);
  }

  return result;
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/mapValue.mjs
/**
 * Creates an object map with the same keys as `map` and values generated by
 * running each value of `map` thru `fn`.
 */
function mapValue(map, fn) {
  const result = Object.create(null);

  for (const key of Object.keys(map)) {
    result[key] = fn(map[key], key);
  }

  return result;
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/naturalCompare.mjs
/**
 * Returns a number indicating whether a reference string comes before, or after,
 * or is the same as the given string in natural sort order.
 *
 * See: https://en.wikipedia.org/wiki/Natural_sort_order
 *
 */
function naturalCompare(aStr, bStr) {
  let aIndex = 0;
  let bIndex = 0;

  while (aIndex < aStr.length && bIndex < bStr.length) {
    let aChar = aStr.charCodeAt(aIndex);
    let bChar = bStr.charCodeAt(bIndex);

    if (naturalCompare_isDigit(aChar) && naturalCompare_isDigit(bChar)) {
      let aNum = 0;

      do {
        ++aIndex;
        aNum = aNum * 10 + aChar - DIGIT_0;
        aChar = aStr.charCodeAt(aIndex);
      } while (naturalCompare_isDigit(aChar) && aNum > 0);

      let bNum = 0;

      do {
        ++bIndex;
        bNum = bNum * 10 + bChar - DIGIT_0;
        bChar = bStr.charCodeAt(bIndex);
      } while (naturalCompare_isDigit(bChar) && bNum > 0);

      if (aNum < bNum) {
        return -1;
      }

      if (aNum > bNum) {
        return 1;
      }
    } else {
      if (aChar < bChar) {
        return -1;
      }

      if (aChar > bChar) {
        return 1;
      }

      ++aIndex;
      ++bIndex;
    }
  }

  return aStr.length - bStr.length;
}
const DIGIT_0 = 48;
const DIGIT_9 = 57;

function naturalCompare_isDigit(code) {
  return !isNaN(code) && DIGIT_0 <= code && code <= DIGIT_9;
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/suggestionList.mjs

/**
 * Given an invalid input string and a list of valid options, returns a filtered
 * list of valid options sorted based on their similarity with the input.
 */

function suggestionList(input, options) {
  const optionsByDistance = Object.create(null);
  const lexicalDistance = new LexicalDistance(input);
  const threshold = Math.floor(input.length * 0.4) + 1;

  for (const option of options) {
    const distance = lexicalDistance.measure(option, threshold);

    if (distance !== undefined) {
      optionsByDistance[option] = distance;
    }
  }

  return Object.keys(optionsByDistance).sort((a, b) => {
    const distanceDiff = optionsByDistance[a] - optionsByDistance[b];
    return distanceDiff !== 0 ? distanceDiff : naturalCompare(a, b);
  });
}
/**
 * Computes the lexical distance between strings A and B.
 *
 * The "distance" between two strings is given by counting the minimum number
 * of edits needed to transform string A into string B. An edit can be an
 * insertion, deletion, or substitution of a single character, or a swap of two
 * adjacent characters.
 *
 * Includes a custom alteration from Damerau-Levenshtein to treat case changes
 * as a single edit which helps identify mis-cased values with an edit distance
 * of 1.
 *
 * This distance can be useful for detecting typos in input or sorting
 */

class LexicalDistance {
  constructor(input) {
    this._input = input;
    this._inputLowerCase = input.toLowerCase();
    this._inputArray = stringToArray(this._inputLowerCase);
    this._rows = [
      new Array(input.length + 1).fill(0),
      new Array(input.length + 1).fill(0),
      new Array(input.length + 1).fill(0),
    ];
  }

  measure(option, threshold) {
    if (this._input === option) {
      return 0;
    }

    const optionLowerCase = option.toLowerCase(); // Any case change counts as a single edit

    if (this._inputLowerCase === optionLowerCase) {
      return 1;
    }

    let a = stringToArray(optionLowerCase);
    let b = this._inputArray;

    if (a.length < b.length) {
      const tmp = a;
      a = b;
      b = tmp;
    }

    const aLength = a.length;
    const bLength = b.length;

    if (aLength - bLength > threshold) {
      return undefined;
    }

    const rows = this._rows;

    for (let j = 0; j <= bLength; j++) {
      rows[0][j] = j;
    }

    for (let i = 1; i <= aLength; i++) {
      const upRow = rows[(i - 1) % 3];
      const currentRow = rows[i % 3];
      let smallestCell = (currentRow[0] = i);

      for (let j = 1; j <= bLength; j++) {
        const cost = a[i - 1] === b[j - 1] ? 0 : 1;
        let currentCell = Math.min(
          upRow[j] + 1, // delete
          currentRow[j - 1] + 1, // insert
          upRow[j - 1] + cost, // substitute
        );

        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) {
          // transposition
          const doubleDiagonalCell = rows[(i - 2) % 3][j - 2];
          currentCell = Math.min(currentCell, doubleDiagonalCell + 1);
        }

        if (currentCell < smallestCell) {
          smallestCell = currentCell;
        }

        currentRow[j] = currentCell;
      } // Early exit, since distance can't go smaller than smallest element of the previous row.

      if (smallestCell > threshold) {
        return undefined;
      }
    }

    const distance = rows[aLength % 3][bLength];
    return distance <= threshold ? distance : undefined;
  }
}

function stringToArray(str) {
  const strLength = str.length;
  const array = new Array(strLength);

  for (let i = 0; i < strLength; ++i) {
    array[i] = str.charCodeAt(i);
  }

  return array;
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/toObjMap.mjs
function toObjMap(obj) {
  if (obj == null) {
    return Object.create(null);
  }

  if (Object.getPrototypeOf(obj) === null) {
    return obj;
  }

  const map = Object.create(null);

  for (const [key, value] of Object.entries(obj)) {
    map[key] = value;
  }

  return map;
}

;// CONCATENATED MODULE: ../node_modules/graphql/language/printString.mjs
/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */
function printString(str) {
  return `"${str.replace(escapedRegExp, escapedReplacer)}"`;
} // eslint-disable-next-line no-control-regex

const escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;

function escapedReplacer(str) {
  return escapeSequences[str.charCodeAt(0)];
} // prettier-ignore

const escapeSequences = [
  '\\u0000',
  '\\u0001',
  '\\u0002',
  '\\u0003',
  '\\u0004',
  '\\u0005',
  '\\u0006',
  '\\u0007',
  '\\b',
  '\\t',
  '\\n',
  '\\u000B',
  '\\f',
  '\\r',
  '\\u000E',
  '\\u000F',
  '\\u0010',
  '\\u0011',
  '\\u0012',
  '\\u0013',
  '\\u0014',
  '\\u0015',
  '\\u0016',
  '\\u0017',
  '\\u0018',
  '\\u0019',
  '\\u001A',
  '\\u001B',
  '\\u001C',
  '\\u001D',
  '\\u001E',
  '\\u001F',
  '',
  '',
  '\\"',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 2F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 3F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 4F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '\\\\',
  '',
  '',
  '', // 5F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 6F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '\\u007F',
  '\\u0080',
  '\\u0081',
  '\\u0082',
  '\\u0083',
  '\\u0084',
  '\\u0085',
  '\\u0086',
  '\\u0087',
  '\\u0088',
  '\\u0089',
  '\\u008A',
  '\\u008B',
  '\\u008C',
  '\\u008D',
  '\\u008E',
  '\\u008F',
  '\\u0090',
  '\\u0091',
  '\\u0092',
  '\\u0093',
  '\\u0094',
  '\\u0095',
  '\\u0096',
  '\\u0097',
  '\\u0098',
  '\\u0099',
  '\\u009A',
  '\\u009B',
  '\\u009C',
  '\\u009D',
  '\\u009E',
  '\\u009F',
];

;// CONCATENATED MODULE: ../node_modules/graphql/language/visitor.mjs




/**
 * A visitor is provided to visit, it contains the collection of
 * relevant functions to be called during the visitor's traversal.
 */

const BREAK = Object.freeze({});
/**
 * visit() will walk through an AST using a depth-first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 * ```ts
 * const editedAST = visit(ast, {
 *   enter(node, key, parent, path, ancestors) {
 *     // @return
 *     //   undefined: no action
 *     //   false: skip visiting this node
 *     //   visitor.BREAK: stop visiting altogether
 *     //   null: delete this node
 *     //   any value: replace this node with the returned value
 *   },
 *   leave(node, key, parent, path, ancestors) {
 *     // @return
 *     //   undefined: no action
 *     //   false: no action
 *     //   visitor.BREAK: stop visiting altogether
 *     //   null: delete this node
 *     //   any value: replace this node with the returned value
 *   }
 * });
 * ```
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to three permutations of the
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node of a specific kind.
 *
 * ```ts
 * visit(ast, {
 *   Kind(node) {
 *     // enter the "Kind" node
 *   }
 * })
 * ```
 *
 * 2) Named visitors that trigger upon entering and leaving a node of a specific kind.
 *
 * ```ts
 * visit(ast, {
 *   Kind: {
 *     enter(node) {
 *       // enter the "Kind" node
 *     }
 *     leave(node) {
 *       // leave the "Kind" node
 *     }
 *   }
 * })
 * ```
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 * ```ts
 * visit(ast, {
 *   enter(node) {
 *     // enter any node
 *   },
 *   leave(node) {
 *     // leave any node
 *   }
 * })
 * ```
 */

function visit(root, visitor, visitorKeys = QueryDocumentKeys) {
  const enterLeaveMap = new Map();

  for (const kind of Object.values(Kind)) {
    enterLeaveMap.set(kind, getEnterLeaveForKind(visitor, kind));
  }
  /* eslint-disable no-undef-init */

  let stack = undefined;
  let inArray = Array.isArray(root);
  let keys = [root];
  let index = -1;
  let edits = [];
  let node = root;
  let key = undefined;
  let parent = undefined;
  const path = [];
  const ancestors = [];
  /* eslint-enable no-undef-init */

  do {
    index++;
    const isLeaving = index === keys.length;
    const isEdited = isLeaving && edits.length !== 0;

    if (isLeaving) {
      key = ancestors.length === 0 ? undefined : path[path.length - 1];
      node = parent;
      parent = ancestors.pop();

      if (isEdited) {
        if (inArray) {
          node = node.slice();
          let editOffset = 0;

          for (const [editKey, editValue] of edits) {
            const arrayKey = editKey - editOffset;

            if (editValue === null) {
              node.splice(arrayKey, 1);
              editOffset++;
            } else {
              node[arrayKey] = editValue;
            }
          }
        } else {
          node = Object.defineProperties(
            {},
            Object.getOwnPropertyDescriptors(node),
          );

          for (const [editKey, editValue] of edits) {
            node[editKey] = editValue;
          }
        }
      }

      index = stack.index;
      keys = stack.keys;
      edits = stack.edits;
      inArray = stack.inArray;
      stack = stack.prev;
    } else if (parent) {
      key = inArray ? index : keys[index];
      node = parent[key];

      if (node === null || node === undefined) {
        continue;
      }

      path.push(key);
    }

    let result;

    if (!Array.isArray(node)) {
      var _enterLeaveMap$get, _enterLeaveMap$get2;

      isNode(node) || devAssert(false, `Invalid AST Node: ${inspect(node)}.`);
      const visitFn = isLeaving
        ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null ||
          _enterLeaveMap$get === void 0
          ? void 0
          : _enterLeaveMap$get.leave
        : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null ||
          _enterLeaveMap$get2 === void 0
        ? void 0
        : _enterLeaveMap$get2.enter;
      result =
        visitFn === null || visitFn === void 0
          ? void 0
          : visitFn.call(visitor, node, key, parent, path, ancestors);

      if (result === BREAK) {
        break;
      }

      if (result === false) {
        if (!isLeaving) {
          path.pop();
          continue;
        }
      } else if (result !== undefined) {
        edits.push([key, result]);

        if (!isLeaving) {
          if (isNode(result)) {
            node = result;
          } else {
            path.pop();
            continue;
          }
        }
      }
    }

    if (result === undefined && isEdited) {
      edits.push([key, node]);
    }

    if (isLeaving) {
      path.pop();
    } else {
      var _node$kind;

      stack = {
        inArray,
        index,
        keys,
        edits,
        prev: stack,
      };
      inArray = Array.isArray(node);
      keys = inArray
        ? node
        : (_node$kind = visitorKeys[node.kind]) !== null &&
          _node$kind !== void 0
        ? _node$kind
        : [];
      index = -1;
      edits = [];

      if (parent) {
        ancestors.push(parent);
      }

      parent = node;
    }
  } while (stack !== undefined);

  if (edits.length !== 0) {
    // New root
    return edits[edits.length - 1][1];
  }

  return root;
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */

function visitInParallel(visitors) {
  const skipping = new Array(visitors.length).fill(null);
  const mergedVisitor = Object.create(null);

  for (const kind of Object.values(Kind)) {
    let hasVisitor = false;
    const enterList = new Array(visitors.length).fill(undefined);
    const leaveList = new Array(visitors.length).fill(undefined);

    for (let i = 0; i < visitors.length; ++i) {
      const { enter, leave } = getEnterLeaveForKind(visitors[i], kind);
      hasVisitor || (hasVisitor = enter != null || leave != null);
      enterList[i] = enter;
      leaveList[i] = leave;
    }

    if (!hasVisitor) {
      continue;
    }

    const mergedEnterLeave = {
      enter(...args) {
        const node = args[0];

        for (let i = 0; i < visitors.length; i++) {
          if (skipping[i] === null) {
            var _enterList$i;

            const result =
              (_enterList$i = enterList[i]) === null || _enterList$i === void 0
                ? void 0
                : _enterList$i.apply(visitors[i], args);

            if (result === false) {
              skipping[i] = node;
            } else if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined) {
              return result;
            }
          }
        }
      },

      leave(...args) {
        const node = args[0];

        for (let i = 0; i < visitors.length; i++) {
          if (skipping[i] === null) {
            var _leaveList$i;

            const result =
              (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0
                ? void 0
                : _leaveList$i.apply(visitors[i], args);

            if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined && result !== false) {
              return result;
            }
          } else if (skipping[i] === node) {
            skipping[i] = null;
          }
        }
      },
    };
    mergedVisitor[kind] = mergedEnterLeave;
  }

  return mergedVisitor;
}
/**
 * Given a visitor instance and a node kind, return EnterLeaveVisitor for that kind.
 */

function getEnterLeaveForKind(visitor, kind) {
  const kindVisitor = visitor[kind];

  if (typeof kindVisitor === 'object') {
    // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
  } else if (typeof kindVisitor === 'function') {
    // { Kind() {} }
    return {
      enter: kindVisitor,
      leave: undefined,
    };
  } // { enter() {}, leave() {} }

  return {
    enter: visitor.enter,
    leave: visitor.leave,
  };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 *
 * @deprecated Please use `getEnterLeaveForKind` instead. Will be removed in v17
 */

/* c8 ignore next 8 */

function getVisitFn(visitor, kind, isLeaving) {
  const { enter, leave } = getEnterLeaveForKind(visitor, kind);
  return isLeaving ? leave : enter;
}

;// CONCATENATED MODULE: ../node_modules/graphql/language/printer.mjs



/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */

function print(ast) {
  return visit(ast, printDocASTReducer);
}
const MAX_LINE_LENGTH = 80;
const printDocASTReducer = {
  Name: {
    leave: (node) => node.value,
  },
  Variable: {
    leave: (node) => '$' + node.name,
  },
  // Document
  Document: {
    leave: (node) => join(node.definitions, '\n\n'),
  },
  OperationDefinition: {
    leave(node) {
      const varDefs = wrap('(', join(node.variableDefinitions, ', '), ')');
      const prefix = join(
        [
          node.operation,
          join([node.name, varDefs]),
          join(node.directives, ' '),
        ],
        ' ',
      ); // Anonymous queries with no directives or variable definitions can use
      // the query short form.

      return (prefix === 'query' ? '' : prefix + ' ') + node.selectionSet;
    },
  },
  VariableDefinition: {
    leave: ({ variable, type, defaultValue, directives }) =>
      variable +
      ': ' +
      type +
      wrap(' = ', defaultValue) +
      wrap(' ', join(directives, ' ')),
  },
  SelectionSet: {
    leave: ({ selections }) => block(selections),
  },
  Field: {
    leave({ alias, name, arguments: args, directives, selectionSet }) {
      const prefix = wrap('', alias, ': ') + name;
      let argsLine = prefix + wrap('(', join(args, ', '), ')');

      if (argsLine.length > MAX_LINE_LENGTH) {
        argsLine = prefix + wrap('(\n', indent(join(args, '\n')), '\n)');
      }

      return join([argsLine, join(directives, ' '), selectionSet], ' ');
    },
  },
  Argument: {
    leave: ({ name, value }) => name + ': ' + value,
  },
  // Fragments
  FragmentSpread: {
    leave: ({ name, directives }) =>
      '...' + name + wrap(' ', join(directives, ' ')),
  },
  InlineFragment: {
    leave: ({ typeCondition, directives, selectionSet }) =>
      join(
        [
          '...',
          wrap('on ', typeCondition),
          join(directives, ' '),
          selectionSet,
        ],
        ' ',
      ),
  },
  FragmentDefinition: {
    leave: (
      { name, typeCondition, variableDefinitions, directives, selectionSet }, // Note: fragment variable definitions are experimental and may be changed
    ) =>
      // or removed in the future.
      `fragment ${name}${wrap('(', join(variableDefinitions, ', '), ')')} ` +
      `on ${typeCondition} ${wrap('', join(directives, ' '), ' ')}` +
      selectionSet,
  },
  // Value
  IntValue: {
    leave: ({ value }) => value,
  },
  FloatValue: {
    leave: ({ value }) => value,
  },
  StringValue: {
    leave: ({ value, block: isBlockString }) =>
      isBlockString ? printBlockString(value) : printString(value),
  },
  BooleanValue: {
    leave: ({ value }) => (value ? 'true' : 'false'),
  },
  NullValue: {
    leave: () => 'null',
  },
  EnumValue: {
    leave: ({ value }) => value,
  },
  ListValue: {
    leave: ({ values }) => '[' + join(values, ', ') + ']',
  },
  ObjectValue: {
    leave: ({ fields }) => '{' + join(fields, ', ') + '}',
  },
  ObjectField: {
    leave: ({ name, value }) => name + ': ' + value,
  },
  // Directive
  Directive: {
    leave: ({ name, arguments: args }) =>
      '@' + name + wrap('(', join(args, ', '), ')'),
  },
  // Type
  NamedType: {
    leave: ({ name }) => name,
  },
  ListType: {
    leave: ({ type }) => '[' + type + ']',
  },
  NonNullType: {
    leave: ({ type }) => type + '!',
  },
  // Type System Definitions
  SchemaDefinition: {
    leave: ({ description, directives, operationTypes }) =>
      wrap('', description, '\n') +
      join(['schema', join(directives, ' '), block(operationTypes)], ' '),
  },
  OperationTypeDefinition: {
    leave: ({ operation, type }) => operation + ': ' + type,
  },
  ScalarTypeDefinition: {
    leave: ({ description, name, directives }) =>
      wrap('', description, '\n') +
      join(['scalar', name, join(directives, ' ')], ' '),
  },
  ObjectTypeDefinition: {
    leave: ({ description, name, interfaces, directives, fields }) =>
      wrap('', description, '\n') +
      join(
        [
          'type',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  FieldDefinition: {
    leave: ({ description, name, arguments: args, type, directives }) =>
      wrap('', description, '\n') +
      name +
      (hasMultilineItems(args)
        ? wrap('(\n', indent(join(args, '\n')), '\n)')
        : wrap('(', join(args, ', '), ')')) +
      ': ' +
      type +
      wrap(' ', join(directives, ' ')),
  },
  InputValueDefinition: {
    leave: ({ description, name, type, defaultValue, directives }) =>
      wrap('', description, '\n') +
      join(
        [name + ': ' + type, wrap('= ', defaultValue), join(directives, ' ')],
        ' ',
      ),
  },
  InterfaceTypeDefinition: {
    leave: ({ description, name, interfaces, directives, fields }) =>
      wrap('', description, '\n') +
      join(
        [
          'interface',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  UnionTypeDefinition: {
    leave: ({ description, name, directives, types }) =>
      wrap('', description, '\n') +
      join(
        ['union', name, join(directives, ' '), wrap('= ', join(types, ' | '))],
        ' ',
      ),
  },
  EnumTypeDefinition: {
    leave: ({ description, name, directives, values }) =>
      wrap('', description, '\n') +
      join(['enum', name, join(directives, ' '), block(values)], ' '),
  },
  EnumValueDefinition: {
    leave: ({ description, name, directives }) =>
      wrap('', description, '\n') + join([name, join(directives, ' ')], ' '),
  },
  InputObjectTypeDefinition: {
    leave: ({ description, name, directives, fields }) =>
      wrap('', description, '\n') +
      join(['input', name, join(directives, ' '), block(fields)], ' '),
  },
  DirectiveDefinition: {
    leave: ({ description, name, arguments: args, repeatable, locations }) =>
      wrap('', description, '\n') +
      'directive @' +
      name +
      (hasMultilineItems(args)
        ? wrap('(\n', indent(join(args, '\n')), '\n)')
        : wrap('(', join(args, ', '), ')')) +
      (repeatable ? ' repeatable' : '') +
      ' on ' +
      join(locations, ' | '),
  },
  SchemaExtension: {
    leave: ({ directives, operationTypes }) =>
      join(
        ['extend schema', join(directives, ' '), block(operationTypes)],
        ' ',
      ),
  },
  ScalarTypeExtension: {
    leave: ({ name, directives }) =>
      join(['extend scalar', name, join(directives, ' ')], ' '),
  },
  ObjectTypeExtension: {
    leave: ({ name, interfaces, directives, fields }) =>
      join(
        [
          'extend type',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  InterfaceTypeExtension: {
    leave: ({ name, interfaces, directives, fields }) =>
      join(
        [
          'extend interface',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  UnionTypeExtension: {
    leave: ({ name, directives, types }) =>
      join(
        [
          'extend union',
          name,
          join(directives, ' '),
          wrap('= ', join(types, ' | ')),
        ],
        ' ',
      ),
  },
  EnumTypeExtension: {
    leave: ({ name, directives, values }) =>
      join(['extend enum', name, join(directives, ' '), block(values)], ' '),
  },
  InputObjectTypeExtension: {
    leave: ({ name, directives, fields }) =>
      join(['extend input', name, join(directives, ' '), block(fields)], ' '),
  },
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */

function join(maybeArray, separator = '') {
  var _maybeArray$filter$jo;

  return (_maybeArray$filter$jo =
    maybeArray === null || maybeArray === void 0
      ? void 0
      : maybeArray.filter((x) => x).join(separator)) !== null &&
    _maybeArray$filter$jo !== void 0
    ? _maybeArray$filter$jo
    : '';
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */

function block(array) {
  return wrap('{\n', indent(join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */

function wrap(start, maybeString, end = '') {
  return maybeString != null && maybeString !== ''
    ? start + maybeString + end
    : '';
}

function indent(str) {
  return wrap('  ', str.replace(/\n/g, '\n  '));
}

function hasMultilineItems(maybeArray) {
  var _maybeArray$some;

  // FIXME: https://github.com/graphql/graphql-js/issues/2203

  /* c8 ignore next */
  return (_maybeArray$some =
    maybeArray === null || maybeArray === void 0
      ? void 0
      : maybeArray.some((str) => str.includes('\n'))) !== null &&
    _maybeArray$some !== void 0
    ? _maybeArray$some
    : false;
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/valueFromASTUntyped.mjs


/**
 * Produces a JavaScript value given a GraphQL Value AST.
 *
 * Unlike `valueFromAST()`, no type is provided. The resulting JavaScript value
 * will reflect the provided GraphQL value AST.
 *
 * | GraphQL Value        | JavaScript Value |
 * | -------------------- | ---------------- |
 * | Input Object         | Object           |
 * | List                 | Array            |
 * | Boolean              | Boolean          |
 * | String / Enum        | String           |
 * | Int / Float          | Number           |
 * | Null                 | null             |
 *
 */

function valueFromASTUntyped(valueNode, variables) {
  switch (valueNode.kind) {
    case Kind.NULL:
      return null;

    case Kind.INT:
      return parseInt(valueNode.value, 10);

    case Kind.FLOAT:
      return parseFloat(valueNode.value);

    case Kind.STRING:
    case Kind.ENUM:
    case Kind.BOOLEAN:
      return valueNode.value;

    case Kind.LIST:
      return valueNode.values.map((node) =>
        valueFromASTUntyped(node, variables),
      );

    case Kind.OBJECT:
      return keyValMap(
        valueNode.fields,
        (field) => field.name.value,
        (field) => valueFromASTUntyped(field.value, variables),
      );

    case Kind.VARIABLE:
      return variables === null || variables === void 0
        ? void 0
        : variables[valueNode.name.value];
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/type/assertName.mjs



/**
 * Upholds the spec rules about naming.
 */

function assertName(name) {
  name != null || devAssert(false, 'Must provide name.');
  typeof name === 'string' || devAssert(false, 'Expected name to be a string.');

  if (name.length === 0) {
    throw new GraphQLError('Expected name to be a non-empty string.');
  }

  for (let i = 1; i < name.length; ++i) {
    if (!isNameContinue(name.charCodeAt(i))) {
      throw new GraphQLError(
        `Names must only contain [_a-zA-Z0-9] but "${name}" does not.`,
      );
    }
  }

  if (!isNameStart(name.charCodeAt(0))) {
    throw new GraphQLError(
      `Names must start with [_a-zA-Z] but "${name}" does not.`,
    );
  }

  return name;
}
/**
 * Upholds the spec rules about naming enum values.
 *
 * @internal
 */

function assertEnumValueName(name) {
  if (name === 'true' || name === 'false' || name === 'null') {
    throw new GraphQLError(`Enum values cannot be named: ${name}`);
  }

  return assertName(name);
}

;// CONCATENATED MODULE: ../node_modules/graphql/type/definition.mjs
















function isType(type) {
  return (
    isScalarType(type) ||
    isObjectType(type) ||
    isInterfaceType(type) ||
    isUnionType(type) ||
    isEnumType(type) ||
    isInputObjectType(type) ||
    isListType(type) ||
    isNonNullType(type)
  );
}
function assertType(type) {
  if (!isType(type)) {
    throw new Error(`Expected ${inspect(type)} to be a GraphQL type.`);
  }

  return type;
}
/**
 * There are predicates for each kind of GraphQL type.
 */

function isScalarType(type) {
  return instanceOf(type, GraphQLScalarType);
}
function assertScalarType(type) {
  if (!isScalarType(type)) {
    throw new Error(`Expected ${inspect(type)} to be a GraphQL Scalar type.`);
  }

  return type;
}
function isObjectType(type) {
  return instanceOf(type, GraphQLObjectType);
}
function assertObjectType(type) {
  if (!isObjectType(type)) {
    throw new Error(`Expected ${inspect(type)} to be a GraphQL Object type.`);
  }

  return type;
}
function isInterfaceType(type) {
  return instanceOf(type, GraphQLInterfaceType);
}
function assertInterfaceType(type) {
  if (!isInterfaceType(type)) {
    throw new Error(
      `Expected ${inspect(type)} to be a GraphQL Interface type.`,
    );
  }

  return type;
}
function isUnionType(type) {
  return instanceOf(type, GraphQLUnionType);
}
function assertUnionType(type) {
  if (!isUnionType(type)) {
    throw new Error(`Expected ${inspect(type)} to be a GraphQL Union type.`);
  }

  return type;
}
function isEnumType(type) {
  return instanceOf(type, GraphQLEnumType);
}
function assertEnumType(type) {
  if (!isEnumType(type)) {
    throw new Error(`Expected ${inspect(type)} to be a GraphQL Enum type.`);
  }

  return type;
}
function isInputObjectType(type) {
  return instanceOf(type, GraphQLInputObjectType);
}
function assertInputObjectType(type) {
  if (!isInputObjectType(type)) {
    throw new Error(
      `Expected ${inspect(type)} to be a GraphQL Input Object type.`,
    );
  }

  return type;
}
function isListType(type) {
  return instanceOf(type, GraphQLList);
}
function assertListType(type) {
  if (!isListType(type)) {
    throw new Error(`Expected ${inspect(type)} to be a GraphQL List type.`);
  }

  return type;
}
function isNonNullType(type) {
  return instanceOf(type, GraphQLNonNull);
}
function assertNonNullType(type) {
  if (!isNonNullType(type)) {
    throw new Error(`Expected ${inspect(type)} to be a GraphQL Non-Null type.`);
  }

  return type;
}
/**
 * These types may be used as input types for arguments and directives.
 */

function isInputType(type) {
  return (
    isScalarType(type) ||
    isEnumType(type) ||
    isInputObjectType(type) ||
    (isWrappingType(type) && isInputType(type.ofType))
  );
}
function assertInputType(type) {
  if (!isInputType(type)) {
    throw new Error(`Expected ${inspect(type)} to be a GraphQL input type.`);
  }

  return type;
}
/**
 * These types may be used as output types as the result of fields.
 */

function isOutputType(type) {
  return (
    isScalarType(type) ||
    isObjectType(type) ||
    isInterfaceType(type) ||
    isUnionType(type) ||
    isEnumType(type) ||
    (isWrappingType(type) && isOutputType(type.ofType))
  );
}
function assertOutputType(type) {
  if (!isOutputType(type)) {
    throw new Error(`Expected ${inspect(type)} to be a GraphQL output type.`);
  }

  return type;
}
/**
 * These types may describe types which may be leaf values.
 */

function isLeafType(type) {
  return isScalarType(type) || isEnumType(type);
}
function assertLeafType(type) {
  if (!isLeafType(type)) {
    throw new Error(`Expected ${inspect(type)} to be a GraphQL leaf type.`);
  }

  return type;
}
/**
 * These types may describe the parent context of a selection set.
 */

function isCompositeType(type) {
  return isObjectType(type) || isInterfaceType(type) || isUnionType(type);
}
function assertCompositeType(type) {
  if (!isCompositeType(type)) {
    throw new Error(
      `Expected ${inspect(type)} to be a GraphQL composite type.`,
    );
  }

  return type;
}
/**
 * These types may describe the parent context of a selection set.
 */

function isAbstractType(type) {
  return isInterfaceType(type) || isUnionType(type);
}
function assertAbstractType(type) {
  if (!isAbstractType(type)) {
    throw new Error(`Expected ${inspect(type)} to be a GraphQL abstract type.`);
  }

  return type;
}
/**
 * List Type Wrapper
 *
 * A list is a wrapping type which points to another type.
 * Lists are often created within the context of defining the fields of
 * an object type.
 *
 * Example:
 *
 * ```ts
 * const PersonType = new GraphQLObjectType({
 *   name: 'Person',
 *   fields: () => ({
 *     parents: { type: new GraphQLList(PersonType) },
 *     children: { type: new GraphQLList(PersonType) },
 *   })
 * })
 * ```
 */

class GraphQLList {
  constructor(ofType) {
    isType(ofType) ||
      devAssert(false, `Expected ${inspect(ofType)} to be a GraphQL type.`);
    this.ofType = ofType;
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLList';
  }

  toString() {
    return '[' + String(this.ofType) + ']';
  }

  toJSON() {
    return this.toString();
  }
}
/**
 * Non-Null Type Wrapper
 *
 * A non-null is a wrapping type which points to another type.
 * Non-null types enforce that their values are never null and can ensure
 * an error is raised if this ever occurs during a request. It is useful for
 * fields which you can make a strong guarantee on non-nullability, for example
 * usually the id field of a database row will never be null.
 *
 * Example:
 *
 * ```ts
 * const RowType = new GraphQLObjectType({
 *   name: 'Row',
 *   fields: () => ({
 *     id: { type: new GraphQLNonNull(GraphQLString) },
 *   })
 * })
 * ```
 * Note: the enforcement of non-nullability occurs within the executor.
 */

class GraphQLNonNull {
  constructor(ofType) {
    isNullableType(ofType) ||
      devAssert(
        false,
        `Expected ${inspect(ofType)} to be a GraphQL nullable type.`,
      );
    this.ofType = ofType;
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLNonNull';
  }

  toString() {
    return String(this.ofType) + '!';
  }

  toJSON() {
    return this.toString();
  }
}
/**
 * These types wrap and modify other types
 */

function isWrappingType(type) {
  return isListType(type) || isNonNullType(type);
}
function assertWrappingType(type) {
  if (!isWrappingType(type)) {
    throw new Error(`Expected ${inspect(type)} to be a GraphQL wrapping type.`);
  }

  return type;
}
/**
 * These types can all accept null as a value.
 */

function isNullableType(type) {
  return isType(type) && !isNonNullType(type);
}
function assertNullableType(type) {
  if (!isNullableType(type)) {
    throw new Error(`Expected ${inspect(type)} to be a GraphQL nullable type.`);
  }

  return type;
}
function getNullableType(type) {
  if (type) {
    return isNonNullType(type) ? type.ofType : type;
  }
}
/**
 * These named types do not include modifiers like List or NonNull.
 */

function isNamedType(type) {
  return (
    isScalarType(type) ||
    isObjectType(type) ||
    isInterfaceType(type) ||
    isUnionType(type) ||
    isEnumType(type) ||
    isInputObjectType(type)
  );
}
function assertNamedType(type) {
  if (!isNamedType(type)) {
    throw new Error(`Expected ${inspect(type)} to be a GraphQL named type.`);
  }

  return type;
}
function getNamedType(type) {
  if (type) {
    let unwrappedType = type;

    while (isWrappingType(unwrappedType)) {
      unwrappedType = unwrappedType.ofType;
    }

    return unwrappedType;
  }
}
/**
 * Used while defining GraphQL types to allow for circular references in
 * otherwise immutable type definitions.
 */

function resolveReadonlyArrayThunk(thunk) {
  return typeof thunk === 'function' ? thunk() : thunk;
}
function resolveObjMapThunk(thunk) {
  return typeof thunk === 'function' ? thunk() : thunk;
}
/**
 * Custom extensions
 *
 * @remarks
 * Use a unique identifier name for your extension, for example the name of
 * your library or project. Do not use a shortened identifier as this increases
 * the risk of conflicts. We recommend you add at most one extension field,
 * an object which can contain all the values you need.
 */

/**
 * Scalar Type Definition
 *
 * The leaf values of any request and input values to arguments are
 * Scalars (or Enums) and are defined with a name and a series of functions
 * used to parse input from ast or variables and to ensure validity.
 *
 * If a type's serialize function returns `null` or does not return a value
 * (i.e. it returns `undefined`) then an error will be raised and a `null`
 * value will be returned in the response. It is always better to validate
 *
 * Example:
 *
 * ```ts
 * const OddType = new GraphQLScalarType({
 *   name: 'Odd',
 *   serialize(value) {
 *     if (!Number.isFinite(value)) {
 *       throw new Error(
 *         `Scalar "Odd" cannot represent "${value}" since it is not a finite number.`,
 *       );
 *     }
 *
 *     if (value % 2 === 0) {
 *       throw new Error(`Scalar "Odd" cannot represent "${value}" since it is even.`);
 *     }
 *     return value;
 *   }
 * });
 * ```
 */
class GraphQLScalarType {
  constructor(config) {
    var _config$parseValue,
      _config$serialize,
      _config$parseLiteral,
      _config$extensionASTN;

    const parseValue =
      (_config$parseValue = config.parseValue) !== null &&
      _config$parseValue !== void 0
        ? _config$parseValue
        : identityFunc;
    this.name = assertName(config.name);
    this.description = config.description;
    this.specifiedByURL = config.specifiedByURL;
    this.serialize =
      (_config$serialize = config.serialize) !== null &&
      _config$serialize !== void 0
        ? _config$serialize
        : identityFunc;
    this.parseValue = parseValue;
    this.parseLiteral =
      (_config$parseLiteral = config.parseLiteral) !== null &&
      _config$parseLiteral !== void 0
        ? _config$parseLiteral
        : (node, variables) => parseValue(valueFromASTUntyped(node, variables));
    this.extensions = toObjMap(config.extensions);
    this.astNode = config.astNode;
    this.extensionASTNodes =
      (_config$extensionASTN = config.extensionASTNodes) !== null &&
      _config$extensionASTN !== void 0
        ? _config$extensionASTN
        : [];
    config.specifiedByURL == null ||
      typeof config.specifiedByURL === 'string' ||
      devAssert(
        false,
        `${this.name} must provide "specifiedByURL" as a string, ` +
          `but got: ${inspect(config.specifiedByURL)}.`,
      );
    config.serialize == null ||
      typeof config.serialize === 'function' ||
      devAssert(
        false,
        `${this.name} must provide "serialize" function. If this custom Scalar is also used as an input type, ensure "parseValue" and "parseLiteral" functions are also provided.`,
      );

    if (config.parseLiteral) {
      (typeof config.parseValue === 'function' &&
        typeof config.parseLiteral === 'function') ||
        devAssert(
          false,
          `${this.name} must provide both "parseValue" and "parseLiteral" functions.`,
        );
    }
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLScalarType';
  }

  toConfig() {
    return {
      name: this.name,
      description: this.description,
      specifiedByURL: this.specifiedByURL,
      serialize: this.serialize,
      parseValue: this.parseValue,
      parseLiteral: this.parseLiteral,
      extensions: this.extensions,
      astNode: this.astNode,
      extensionASTNodes: this.extensionASTNodes,
    };
  }

  toString() {
    return this.name;
  }

  toJSON() {
    return this.toString();
  }
}

/**
 * Object Type Definition
 *
 * Almost all of the GraphQL types you define will be object types. Object types
 * have a name, but most importantly describe their fields.
 *
 * Example:
 *
 * ```ts
 * const AddressType = new GraphQLObjectType({
 *   name: 'Address',
 *   fields: {
 *     street: { type: GraphQLString },
 *     number: { type: GraphQLInt },
 *     formatted: {
 *       type: GraphQLString,
 *       resolve(obj) {
 *         return obj.number + ' ' + obj.street
 *       }
 *     }
 *   }
 * });
 * ```
 *
 * When two types need to refer to each other, or a type needs to refer to
 * itself in a field, you can use a function expression (aka a closure or a
 * thunk) to supply the fields lazily.
 *
 * Example:
 *
 * ```ts
 * const PersonType = new GraphQLObjectType({
 *   name: 'Person',
 *   fields: () => ({
 *     name: { type: GraphQLString },
 *     bestFriend: { type: PersonType },
 *   })
 * });
 * ```
 */
class GraphQLObjectType {
  constructor(config) {
    var _config$extensionASTN2;

    this.name = assertName(config.name);
    this.description = config.description;
    this.isTypeOf = config.isTypeOf;
    this.extensions = toObjMap(config.extensions);
    this.astNode = config.astNode;
    this.extensionASTNodes =
      (_config$extensionASTN2 = config.extensionASTNodes) !== null &&
      _config$extensionASTN2 !== void 0
        ? _config$extensionASTN2
        : [];

    this._fields = () => defineFieldMap(config);

    this._interfaces = () => defineInterfaces(config);

    config.isTypeOf == null ||
      typeof config.isTypeOf === 'function' ||
      devAssert(
        false,
        `${this.name} must provide "isTypeOf" as a function, ` +
          `but got: ${inspect(config.isTypeOf)}.`,
      );
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLObjectType';
  }

  getFields() {
    if (typeof this._fields === 'function') {
      this._fields = this._fields();
    }

    return this._fields;
  }

  getInterfaces() {
    if (typeof this._interfaces === 'function') {
      this._interfaces = this._interfaces();
    }

    return this._interfaces;
  }

  toConfig() {
    return {
      name: this.name,
      description: this.description,
      interfaces: this.getInterfaces(),
      fields: fieldsToFieldsConfig(this.getFields()),
      isTypeOf: this.isTypeOf,
      extensions: this.extensions,
      astNode: this.astNode,
      extensionASTNodes: this.extensionASTNodes,
    };
  }

  toString() {
    return this.name;
  }

  toJSON() {
    return this.toString();
  }
}

function defineInterfaces(config) {
  var _config$interfaces;

  const interfaces = resolveReadonlyArrayThunk(
    (_config$interfaces = config.interfaces) !== null &&
      _config$interfaces !== void 0
      ? _config$interfaces
      : [],
  );
  Array.isArray(interfaces) ||
    devAssert(
      false,
      `${config.name} interfaces must be an Array or a function which returns an Array.`,
    );
  return interfaces;
}

function defineFieldMap(config) {
  const fieldMap = resolveObjMapThunk(config.fields);
  isPlainObj(fieldMap) ||
    devAssert(
      false,
      `${config.name} fields must be an object with field names as keys or a function which returns such an object.`,
    );
  return mapValue(fieldMap, (fieldConfig, fieldName) => {
    var _fieldConfig$args;

    isPlainObj(fieldConfig) ||
      devAssert(
        false,
        `${config.name}.${fieldName} field config must be an object.`,
      );
    fieldConfig.resolve == null ||
      typeof fieldConfig.resolve === 'function' ||
      devAssert(
        false,
        `${config.name}.${fieldName} field resolver must be a function if ` +
          `provided, but got: ${inspect(fieldConfig.resolve)}.`,
      );
    const argsConfig =
      (_fieldConfig$args = fieldConfig.args) !== null &&
      _fieldConfig$args !== void 0
        ? _fieldConfig$args
        : {};
    isPlainObj(argsConfig) ||
      devAssert(
        false,
        `${config.name}.${fieldName} args must be an object with argument names as keys.`,
      );
    return {
      name: assertName(fieldName),
      description: fieldConfig.description,
      type: fieldConfig.type,
      args: defineArguments(argsConfig),
      resolve: fieldConfig.resolve,
      subscribe: fieldConfig.subscribe,
      deprecationReason: fieldConfig.deprecationReason,
      extensions: toObjMap(fieldConfig.extensions),
      astNode: fieldConfig.astNode,
    };
  });
}

function defineArguments(config) {
  return Object.entries(config).map(([argName, argConfig]) => ({
    name: assertName(argName),
    description: argConfig.description,
    type: argConfig.type,
    defaultValue: argConfig.defaultValue,
    deprecationReason: argConfig.deprecationReason,
    extensions: toObjMap(argConfig.extensions),
    astNode: argConfig.astNode,
  }));
}

function isPlainObj(obj) {
  return isObjectLike(obj) && !Array.isArray(obj);
}

function fieldsToFieldsConfig(fields) {
  return mapValue(fields, (field) => ({
    description: field.description,
    type: field.type,
    args: argsToArgsConfig(field.args),
    resolve: field.resolve,
    subscribe: field.subscribe,
    deprecationReason: field.deprecationReason,
    extensions: field.extensions,
    astNode: field.astNode,
  }));
}
/**
 * @internal
 */

function argsToArgsConfig(args) {
  return keyValMap(
    args,
    (arg) => arg.name,
    (arg) => ({
      description: arg.description,
      type: arg.type,
      defaultValue: arg.defaultValue,
      deprecationReason: arg.deprecationReason,
      extensions: arg.extensions,
      astNode: arg.astNode,
    }),
  );
}
function isRequiredArgument(arg) {
  return isNonNullType(arg.type) && arg.defaultValue === undefined;
}

/**
 * Interface Type Definition
 *
 * When a field can return one of a heterogeneous set of types, a Interface type
 * is used to describe what types are possible, what fields are in common across
 * all types, as well as a function to determine which type is actually used
 * when the field is resolved.
 *
 * Example:
 *
 * ```ts
 * const EntityType = new GraphQLInterfaceType({
 *   name: 'Entity',
 *   fields: {
 *     name: { type: GraphQLString }
 *   }
 * });
 * ```
 */
class GraphQLInterfaceType {
  constructor(config) {
    var _config$extensionASTN3;

    this.name = assertName(config.name);
    this.description = config.description;
    this.resolveType = config.resolveType;
    this.extensions = toObjMap(config.extensions);
    this.astNode = config.astNode;
    this.extensionASTNodes =
      (_config$extensionASTN3 = config.extensionASTNodes) !== null &&
      _config$extensionASTN3 !== void 0
        ? _config$extensionASTN3
        : [];
    this._fields = defineFieldMap.bind(undefined, config);
    this._interfaces = defineInterfaces.bind(undefined, config);
    config.resolveType == null ||
      typeof config.resolveType === 'function' ||
      devAssert(
        false,
        `${this.name} must provide "resolveType" as a function, ` +
          `but got: ${inspect(config.resolveType)}.`,
      );
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLInterfaceType';
  }

  getFields() {
    if (typeof this._fields === 'function') {
      this._fields = this._fields();
    }

    return this._fields;
  }

  getInterfaces() {
    if (typeof this._interfaces === 'function') {
      this._interfaces = this._interfaces();
    }

    return this._interfaces;
  }

  toConfig() {
    return {
      name: this.name,
      description: this.description,
      interfaces: this.getInterfaces(),
      fields: fieldsToFieldsConfig(this.getFields()),
      resolveType: this.resolveType,
      extensions: this.extensions,
      astNode: this.astNode,
      extensionASTNodes: this.extensionASTNodes,
    };
  }

  toString() {
    return this.name;
  }

  toJSON() {
    return this.toString();
  }
}

/**
 * Union Type Definition
 *
 * When a field can return one of a heterogeneous set of types, a Union type
 * is used to describe what types are possible as well as providing a function
 * to determine which type is actually used when the field is resolved.
 *
 * Example:
 *
 * ```ts
 * const PetType = new GraphQLUnionType({
 *   name: 'Pet',
 *   types: [ DogType, CatType ],
 *   resolveType(value) {
 *     if (value instanceof Dog) {
 *       return DogType;
 *     }
 *     if (value instanceof Cat) {
 *       return CatType;
 *     }
 *   }
 * });
 * ```
 */
class GraphQLUnionType {
  constructor(config) {
    var _config$extensionASTN4;

    this.name = assertName(config.name);
    this.description = config.description;
    this.resolveType = config.resolveType;
    this.extensions = toObjMap(config.extensions);
    this.astNode = config.astNode;
    this.extensionASTNodes =
      (_config$extensionASTN4 = config.extensionASTNodes) !== null &&
      _config$extensionASTN4 !== void 0
        ? _config$extensionASTN4
        : [];
    this._types = defineTypes.bind(undefined, config);
    config.resolveType == null ||
      typeof config.resolveType === 'function' ||
      devAssert(
        false,
        `${this.name} must provide "resolveType" as a function, ` +
          `but got: ${inspect(config.resolveType)}.`,
      );
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLUnionType';
  }

  getTypes() {
    if (typeof this._types === 'function') {
      this._types = this._types();
    }

    return this._types;
  }

  toConfig() {
    return {
      name: this.name,
      description: this.description,
      types: this.getTypes(),
      resolveType: this.resolveType,
      extensions: this.extensions,
      astNode: this.astNode,
      extensionASTNodes: this.extensionASTNodes,
    };
  }

  toString() {
    return this.name;
  }

  toJSON() {
    return this.toString();
  }
}

function defineTypes(config) {
  const types = resolveReadonlyArrayThunk(config.types);
  Array.isArray(types) ||
    devAssert(
      false,
      `Must provide Array of types or a function which returns such an array for Union ${config.name}.`,
    );
  return types;
}

/**
 * Enum Type Definition
 *
 * Some leaf values of requests and input values are Enums. GraphQL serializes
 * Enum values as strings, however internally Enums can be represented by any
 * kind of type, often integers.
 *
 * Example:
 *
 * ```ts
 * const RGBType = new GraphQLEnumType({
 *   name: 'RGB',
 *   values: {
 *     RED: { value: 0 },
 *     GREEN: { value: 1 },
 *     BLUE: { value: 2 }
 *   }
 * });
 * ```
 *
 * Note: If a value is not provided in a definition, the name of the enum value
 * will be used as its internal value.
 */
class GraphQLEnumType {
  /* <T> */
  constructor(config) {
    var _config$extensionASTN5;

    this.name = assertName(config.name);
    this.description = config.description;
    this.extensions = toObjMap(config.extensions);
    this.astNode = config.astNode;
    this.extensionASTNodes =
      (_config$extensionASTN5 = config.extensionASTNodes) !== null &&
      _config$extensionASTN5 !== void 0
        ? _config$extensionASTN5
        : [];
    this._values = defineEnumValues(this.name, config.values);
    this._valueLookup = new Map(
      this._values.map((enumValue) => [enumValue.value, enumValue]),
    );
    this._nameLookup = keyMap(this._values, (value) => value.name);
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLEnumType';
  }

  getValues() {
    return this._values;
  }

  getValue(name) {
    return this._nameLookup[name];
  }

  serialize(outputValue) {
    const enumValue = this._valueLookup.get(outputValue);

    if (enumValue === undefined) {
      throw new GraphQLError(
        `Enum "${this.name}" cannot represent value: ${inspect(outputValue)}`,
      );
    }

    return enumValue.name;
  }

  parseValue(inputValue) /* T */
  {
    if (typeof inputValue !== 'string') {
      const valueStr = inspect(inputValue);
      throw new GraphQLError(
        `Enum "${this.name}" cannot represent non-string value: ${valueStr}.` +
          didYouMeanEnumValue(this, valueStr),
      );
    }

    const enumValue = this.getValue(inputValue);

    if (enumValue == null) {
      throw new GraphQLError(
        `Value "${inputValue}" does not exist in "${this.name}" enum.` +
          didYouMeanEnumValue(this, inputValue),
      );
    }

    return enumValue.value;
  }

  parseLiteral(valueNode, _variables) /* T */
  {
    // Note: variables will be resolved to a value before calling this function.
    if (valueNode.kind !== Kind.ENUM) {
      const valueStr = print(valueNode);
      throw new GraphQLError(
        `Enum "${this.name}" cannot represent non-enum value: ${valueStr}.` +
          didYouMeanEnumValue(this, valueStr),
        {
          nodes: valueNode,
        },
      );
    }

    const enumValue = this.getValue(valueNode.value);

    if (enumValue == null) {
      const valueStr = print(valueNode);
      throw new GraphQLError(
        `Value "${valueStr}" does not exist in "${this.name}" enum.` +
          didYouMeanEnumValue(this, valueStr),
        {
          nodes: valueNode,
        },
      );
    }

    return enumValue.value;
  }

  toConfig() {
    const values = keyValMap(
      this.getValues(),
      (value) => value.name,
      (value) => ({
        description: value.description,
        value: value.value,
        deprecationReason: value.deprecationReason,
        extensions: value.extensions,
        astNode: value.astNode,
      }),
    );
    return {
      name: this.name,
      description: this.description,
      values,
      extensions: this.extensions,
      astNode: this.astNode,
      extensionASTNodes: this.extensionASTNodes,
    };
  }

  toString() {
    return this.name;
  }

  toJSON() {
    return this.toString();
  }
}

function didYouMeanEnumValue(enumType, unknownValueStr) {
  const allNames = enumType.getValues().map((value) => value.name);
  const suggestedValues = suggestionList(unknownValueStr, allNames);
  return didYouMean('the enum value', suggestedValues);
}

function defineEnumValues(typeName, valueMap) {
  isPlainObj(valueMap) ||
    devAssert(
      false,
      `${typeName} values must be an object with value names as keys.`,
    );
  return Object.entries(valueMap).map(([valueName, valueConfig]) => {
    isPlainObj(valueConfig) ||
      devAssert(
        false,
        `${typeName}.${valueName} must refer to an object with a "value" key ` +
          `representing an internal value but got: ${inspect(valueConfig)}.`,
      );
    return {
      name: assertEnumValueName(valueName),
      description: valueConfig.description,
      value: valueConfig.value !== undefined ? valueConfig.value : valueName,
      deprecationReason: valueConfig.deprecationReason,
      extensions: toObjMap(valueConfig.extensions),
      astNode: valueConfig.astNode,
    };
  });
}

/**
 * Input Object Type Definition
 *
 * An input object defines a structured collection of fields which may be
 * supplied to a field argument.
 *
 * Using `NonNull` will ensure that a value must be provided by the query
 *
 * Example:
 *
 * ```ts
 * const GeoPoint = new GraphQLInputObjectType({
 *   name: 'GeoPoint',
 *   fields: {
 *     lat: { type: new GraphQLNonNull(GraphQLFloat) },
 *     lon: { type: new GraphQLNonNull(GraphQLFloat) },
 *     alt: { type: GraphQLFloat, defaultValue: 0 },
 *   }
 * });
 * ```
 */
class GraphQLInputObjectType {
  constructor(config) {
    var _config$extensionASTN6;

    this.name = assertName(config.name);
    this.description = config.description;
    this.extensions = toObjMap(config.extensions);
    this.astNode = config.astNode;
    this.extensionASTNodes =
      (_config$extensionASTN6 = config.extensionASTNodes) !== null &&
      _config$extensionASTN6 !== void 0
        ? _config$extensionASTN6
        : [];
    this._fields = defineInputFieldMap.bind(undefined, config);
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLInputObjectType';
  }

  getFields() {
    if (typeof this._fields === 'function') {
      this._fields = this._fields();
    }

    return this._fields;
  }

  toConfig() {
    const fields = mapValue(this.getFields(), (field) => ({
      description: field.description,
      type: field.type,
      defaultValue: field.defaultValue,
      deprecationReason: field.deprecationReason,
      extensions: field.extensions,
      astNode: field.astNode,
    }));
    return {
      name: this.name,
      description: this.description,
      fields,
      extensions: this.extensions,
      astNode: this.astNode,
      extensionASTNodes: this.extensionASTNodes,
    };
  }

  toString() {
    return this.name;
  }

  toJSON() {
    return this.toString();
  }
}

function defineInputFieldMap(config) {
  const fieldMap = resolveObjMapThunk(config.fields);
  isPlainObj(fieldMap) ||
    devAssert(
      false,
      `${config.name} fields must be an object with field names as keys or a function which returns such an object.`,
    );
  return mapValue(fieldMap, (fieldConfig, fieldName) => {
    !('resolve' in fieldConfig) ||
      devAssert(
        false,
        `${config.name}.${fieldName} field has a resolve property, but Input Types cannot define resolvers.`,
      );
    return {
      name: assertName(fieldName),
      description: fieldConfig.description,
      type: fieldConfig.type,
      defaultValue: fieldConfig.defaultValue,
      deprecationReason: fieldConfig.deprecationReason,
      extensions: toObjMap(fieldConfig.extensions),
      astNode: fieldConfig.astNode,
    };
  });
}

function isRequiredInputField(field) {
  return isNonNullType(field.type) && field.defaultValue === undefined;
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/typeComparators.mjs


/**
 * Provided two types, return true if the types are equal (invariant).
 */
function isEqualType(typeA, typeB) {
  // Equivalent types are equal.
  if (typeA === typeB) {
    return true;
  } // If either type is non-null, the other must also be non-null.

  if (isNonNullType(typeA) && isNonNullType(typeB)) {
    return isEqualType(typeA.ofType, typeB.ofType);
  } // If either type is a list, the other must also be a list.

  if (isListType(typeA) && isListType(typeB)) {
    return isEqualType(typeA.ofType, typeB.ofType);
  } // Otherwise the types are not equal.

  return false;
}
/**
 * Provided a type and a super type, return true if the first type is either
 * equal or a subset of the second super type (covariant).
 */

function isTypeSubTypeOf(schema, maybeSubType, superType) {
  // Equivalent type is a valid subtype
  if (maybeSubType === superType) {
    return true;
  } // If superType is non-null, maybeSubType must also be non-null.

  if (isNonNullType(superType)) {
    if (isNonNullType(maybeSubType)) {
      return isTypeSubTypeOf(schema, maybeSubType.ofType, superType.ofType);
    }

    return false;
  }

  if (isNonNullType(maybeSubType)) {
    // If superType is nullable, maybeSubType may be non-null or nullable.
    return isTypeSubTypeOf(schema, maybeSubType.ofType, superType);
  } // If superType type is a list, maybeSubType type must also be a list.

  if (isListType(superType)) {
    if (isListType(maybeSubType)) {
      return isTypeSubTypeOf(schema, maybeSubType.ofType, superType.ofType);
    }

    return false;
  }

  if (isListType(maybeSubType)) {
    // If superType is not a list, maybeSubType must also be not a list.
    return false;
  } // If superType type is an abstract type, check if it is super type of maybeSubType.
  // Otherwise, the child type is not a valid subtype of the parent type.

  return (
    isAbstractType(superType) &&
    (isInterfaceType(maybeSubType) || isObjectType(maybeSubType)) &&
    schema.isSubType(superType, maybeSubType)
  );
}
/**
 * Provided two composite types, determine if they "overlap". Two composite
 * types overlap when the Sets of possible concrete types for each intersect.
 *
 * This is often used to determine if a fragment of a given type could possibly
 * be visited in a context of another type.
 *
 * This function is commutative.
 */

function doTypesOverlap(schema, typeA, typeB) {
  // Equivalent types overlap
  if (typeA === typeB) {
    return true;
  }

  if (isAbstractType(typeA)) {
    if (isAbstractType(typeB)) {
      // If both types are abstract, then determine if there is any intersection
      // between possible concrete types of each.
      return schema
        .getPossibleTypes(typeA)
        .some((type) => schema.isSubType(typeB, type));
    } // Determine if the latter type is a possible concrete type of the former.

    return schema.isSubType(typeA, typeB);
  }

  if (isAbstractType(typeB)) {
    // Determine if the former type is a possible concrete type of the latter.
    return schema.isSubType(typeB, typeA);
  } // Otherwise the types do not overlap.

  return false;
}

;// CONCATENATED MODULE: ../node_modules/graphql/type/scalars.mjs






/**
 * Maximum possible Int value as per GraphQL Spec (32-bit signed integer).
 * n.b. This differs from JavaScript's numbers that are IEEE 754 doubles safe up-to 2^53 - 1
 * */

const GRAPHQL_MAX_INT = 2147483647;
/**
 * Minimum possible Int value as per GraphQL Spec (32-bit signed integer).
 * n.b. This differs from JavaScript's numbers that are IEEE 754 doubles safe starting at -(2^53 - 1)
 * */

const GRAPHQL_MIN_INT = -2147483648;
const GraphQLInt = new GraphQLScalarType({
  name: 'Int',
  description:
    'The `Int` scalar type represents non-fractional signed whole numeric values. Int can represent values between -(2^31) and 2^31 - 1.',

  serialize(outputValue) {
    const coercedValue = serializeObject(outputValue);

    if (typeof coercedValue === 'boolean') {
      return coercedValue ? 1 : 0;
    }

    let num = coercedValue;

    if (typeof coercedValue === 'string' && coercedValue !== '') {
      num = Number(coercedValue);
    }

    if (typeof num !== 'number' || !Number.isInteger(num)) {
      throw new GraphQLError(
        `Int cannot represent non-integer value: ${inspect(coercedValue)}`,
      );
    }

    if (num > GRAPHQL_MAX_INT || num < GRAPHQL_MIN_INT) {
      throw new GraphQLError(
        'Int cannot represent non 32-bit signed integer value: ' +
          inspect(coercedValue),
      );
    }

    return num;
  },

  parseValue(inputValue) {
    if (typeof inputValue !== 'number' || !Number.isInteger(inputValue)) {
      throw new GraphQLError(
        `Int cannot represent non-integer value: ${inspect(inputValue)}`,
      );
    }

    if (inputValue > GRAPHQL_MAX_INT || inputValue < GRAPHQL_MIN_INT) {
      throw new GraphQLError(
        `Int cannot represent non 32-bit signed integer value: ${inputValue}`,
      );
    }

    return inputValue;
  },

  parseLiteral(valueNode) {
    if (valueNode.kind !== Kind.INT) {
      throw new GraphQLError(
        `Int cannot represent non-integer value: ${print(valueNode)}`,
        {
          nodes: valueNode,
        },
      );
    }

    const num = parseInt(valueNode.value, 10);

    if (num > GRAPHQL_MAX_INT || num < GRAPHQL_MIN_INT) {
      throw new GraphQLError(
        `Int cannot represent non 32-bit signed integer value: ${valueNode.value}`,
        {
          nodes: valueNode,
        },
      );
    }

    return num;
  },
});
const GraphQLFloat = new GraphQLScalarType({
  name: 'Float',
  description:
    'The `Float` scalar type represents signed double-precision fractional values as specified by [IEEE 754](https://en.wikipedia.org/wiki/IEEE_floating_point).',

  serialize(outputValue) {
    const coercedValue = serializeObject(outputValue);

    if (typeof coercedValue === 'boolean') {
      return coercedValue ? 1 : 0;
    }

    let num = coercedValue;

    if (typeof coercedValue === 'string' && coercedValue !== '') {
      num = Number(coercedValue);
    }

    if (typeof num !== 'number' || !Number.isFinite(num)) {
      throw new GraphQLError(
        `Float cannot represent non numeric value: ${inspect(coercedValue)}`,
      );
    }

    return num;
  },

  parseValue(inputValue) {
    if (typeof inputValue !== 'number' || !Number.isFinite(inputValue)) {
      throw new GraphQLError(
        `Float cannot represent non numeric value: ${inspect(inputValue)}`,
      );
    }

    return inputValue;
  },

  parseLiteral(valueNode) {
    if (valueNode.kind !== Kind.FLOAT && valueNode.kind !== Kind.INT) {
      throw new GraphQLError(
        `Float cannot represent non numeric value: ${print(valueNode)}`,
        valueNode,
      );
    }

    return parseFloat(valueNode.value);
  },
});
const GraphQLString = new GraphQLScalarType({
  name: 'String',
  description:
    'The `String` scalar type represents textual data, represented as UTF-8 character sequences. The String type is most often used by GraphQL to represent free-form human-readable text.',

  serialize(outputValue) {
    const coercedValue = serializeObject(outputValue); // Serialize string, boolean and number values to a string, but do not
    // attempt to coerce object, function, symbol, or other types as strings.

    if (typeof coercedValue === 'string') {
      return coercedValue;
    }

    if (typeof coercedValue === 'boolean') {
      return coercedValue ? 'true' : 'false';
    }

    if (typeof coercedValue === 'number' && Number.isFinite(coercedValue)) {
      return coercedValue.toString();
    }

    throw new GraphQLError(
      `String cannot represent value: ${inspect(outputValue)}`,
    );
  },

  parseValue(inputValue) {
    if (typeof inputValue !== 'string') {
      throw new GraphQLError(
        `String cannot represent a non string value: ${inspect(inputValue)}`,
      );
    }

    return inputValue;
  },

  parseLiteral(valueNode) {
    if (valueNode.kind !== Kind.STRING) {
      throw new GraphQLError(
        `String cannot represent a non string value: ${print(valueNode)}`,
        {
          nodes: valueNode,
        },
      );
    }

    return valueNode.value;
  },
});
const GraphQLBoolean = new GraphQLScalarType({
  name: 'Boolean',
  description: 'The `Boolean` scalar type represents `true` or `false`.',

  serialize(outputValue) {
    const coercedValue = serializeObject(outputValue);

    if (typeof coercedValue === 'boolean') {
      return coercedValue;
    }

    if (Number.isFinite(coercedValue)) {
      return coercedValue !== 0;
    }

    throw new GraphQLError(
      `Boolean cannot represent a non boolean value: ${inspect(coercedValue)}`,
    );
  },

  parseValue(inputValue) {
    if (typeof inputValue !== 'boolean') {
      throw new GraphQLError(
        `Boolean cannot represent a non boolean value: ${inspect(inputValue)}`,
      );
    }

    return inputValue;
  },

  parseLiteral(valueNode) {
    if (valueNode.kind !== Kind.BOOLEAN) {
      throw new GraphQLError(
        `Boolean cannot represent a non boolean value: ${print(valueNode)}`,
        {
          nodes: valueNode,
        },
      );
    }

    return valueNode.value;
  },
});
const GraphQLID = new GraphQLScalarType({
  name: 'ID',
  description:
    'The `ID` scalar type represents a unique identifier, often used to refetch an object or as key for a cache. The ID type appears in a JSON response as a String; however, it is not intended to be human-readable. When expected as an input type, any string (such as `"4"`) or integer (such as `4`) input value will be accepted as an ID.',

  serialize(outputValue) {
    const coercedValue = serializeObject(outputValue);

    if (typeof coercedValue === 'string') {
      return coercedValue;
    }

    if (Number.isInteger(coercedValue)) {
      return String(coercedValue);
    }

    throw new GraphQLError(
      `ID cannot represent value: ${inspect(outputValue)}`,
    );
  },

  parseValue(inputValue) {
    if (typeof inputValue === 'string') {
      return inputValue;
    }

    if (typeof inputValue === 'number' && Number.isInteger(inputValue)) {
      return inputValue.toString();
    }

    throw new GraphQLError(`ID cannot represent value: ${inspect(inputValue)}`);
  },

  parseLiteral(valueNode) {
    if (valueNode.kind !== Kind.STRING && valueNode.kind !== Kind.INT) {
      throw new GraphQLError(
        'ID cannot represent a non-string and non-integer value: ' +
          print(valueNode),
        {
          nodes: valueNode,
        },
      );
    }

    return valueNode.value;
  },
});
const specifiedScalarTypes = Object.freeze([
  GraphQLString,
  GraphQLInt,
  GraphQLFloat,
  GraphQLBoolean,
  GraphQLID,
]);
function isSpecifiedScalarType(type) {
  return specifiedScalarTypes.some(({ name }) => type.name === name);
} // Support serializing objects with custom valueOf() or toJSON() functions -
// a common way to represent a complex value which can be represented as
// a string (ex: MongoDB id objects).

function serializeObject(outputValue) {
  if (isObjectLike(outputValue)) {
    if (typeof outputValue.valueOf === 'function') {
      const valueOfResult = outputValue.valueOf();

      if (!isObjectLike(valueOfResult)) {
        return valueOfResult;
      }
    }

    if (typeof outputValue.toJSON === 'function') {
      return outputValue.toJSON();
    }
  }

  return outputValue;
}

;// CONCATENATED MODULE: ../node_modules/graphql/type/directives.mjs









/**
 * Test if the given value is a GraphQL directive.
 */

function isDirective(directive) {
  return instanceOf(directive, GraphQLDirective);
}
function assertDirective(directive) {
  if (!isDirective(directive)) {
    throw new Error(
      `Expected ${inspect(directive)} to be a GraphQL directive.`,
    );
  }

  return directive;
}
/**
 * Custom extensions
 *
 * @remarks
 * Use a unique identifier name for your extension, for example the name of
 * your library or project. Do not use a shortened identifier as this increases
 * the risk of conflicts. We recommend you add at most one extension field,
 * an object which can contain all the values you need.
 */

/**
 * Directives are used by the GraphQL runtime as a way of modifying execution
 * behavior. Type system creators will usually not create these directly.
 */
class GraphQLDirective {
  constructor(config) {
    var _config$isRepeatable, _config$args;

    this.name = assertName(config.name);
    this.description = config.description;
    this.locations = config.locations;
    this.isRepeatable =
      (_config$isRepeatable = config.isRepeatable) !== null &&
      _config$isRepeatable !== void 0
        ? _config$isRepeatable
        : false;
    this.extensions = toObjMap(config.extensions);
    this.astNode = config.astNode;
    Array.isArray(config.locations) ||
      devAssert(false, `@${config.name} locations must be an Array.`);
    const args =
      (_config$args = config.args) !== null && _config$args !== void 0
        ? _config$args
        : {};
    (isObjectLike(args) && !Array.isArray(args)) ||
      devAssert(
        false,
        `@${config.name} args must be an object with argument names as keys.`,
      );
    this.args = defineArguments(args);
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLDirective';
  }

  toConfig() {
    return {
      name: this.name,
      description: this.description,
      locations: this.locations,
      args: argsToArgsConfig(this.args),
      isRepeatable: this.isRepeatable,
      extensions: this.extensions,
      astNode: this.astNode,
    };
  }

  toString() {
    return '@' + this.name;
  }

  toJSON() {
    return this.toString();
  }
}

/**
 * Used to conditionally include fields or fragments.
 */
const GraphQLIncludeDirective = new GraphQLDirective({
  name: 'include',
  description:
    'Directs the executor to include this field or fragment only when the `if` argument is true.',
  locations: [
    DirectiveLocation.FIELD,
    DirectiveLocation.FRAGMENT_SPREAD,
    DirectiveLocation.INLINE_FRAGMENT,
  ],
  args: {
    if: {
      type: new GraphQLNonNull(GraphQLBoolean),
      description: 'Included when true.',
    },
  },
});
/**
 * Used to conditionally skip (exclude) fields or fragments.
 */

const GraphQLSkipDirective = new GraphQLDirective({
  name: 'skip',
  description:
    'Directs the executor to skip this field or fragment when the `if` argument is true.',
  locations: [
    DirectiveLocation.FIELD,
    DirectiveLocation.FRAGMENT_SPREAD,
    DirectiveLocation.INLINE_FRAGMENT,
  ],
  args: {
    if: {
      type: new GraphQLNonNull(GraphQLBoolean),
      description: 'Skipped when true.',
    },
  },
});
/**
 * Constant string used for default reason for a deprecation.
 */

const DEFAULT_DEPRECATION_REASON = 'No longer supported';
/**
 * Used to declare element of a GraphQL schema as deprecated.
 */

const GraphQLDeprecatedDirective = new GraphQLDirective({
  name: 'deprecated',
  description: 'Marks an element of a GraphQL schema as no longer supported.',
  locations: [
    DirectiveLocation.FIELD_DEFINITION,
    DirectiveLocation.ARGUMENT_DEFINITION,
    DirectiveLocation.INPUT_FIELD_DEFINITION,
    DirectiveLocation.ENUM_VALUE,
  ],
  args: {
    reason: {
      type: GraphQLString,
      description:
        'Explains why this element was deprecated, usually also including a suggestion for how to access supported similar data. Formatted using the Markdown syntax, as specified by [CommonMark](https://commonmark.org/).',
      defaultValue: DEFAULT_DEPRECATION_REASON,
    },
  },
});
/**
 * Used to provide a URL for specifying the behavior of custom scalar definitions.
 */

const GraphQLSpecifiedByDirective = new GraphQLDirective({
  name: 'specifiedBy',
  description: 'Exposes a URL that specifies the behavior of this scalar.',
  locations: [DirectiveLocation.SCALAR],
  args: {
    url: {
      type: new GraphQLNonNull(GraphQLString),
      description: 'The URL that specifies the behavior of this scalar.',
    },
  },
});
/**
 * The full list of specified directives.
 */

const specifiedDirectives = Object.freeze([
  GraphQLIncludeDirective,
  GraphQLSkipDirective,
  GraphQLDeprecatedDirective,
  GraphQLSpecifiedByDirective,
]);
function isSpecifiedDirective(directive) {
  return specifiedDirectives.some(({ name }) => name === directive.name);
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/isIterableObject.mjs
/**
 * Returns true if the provided object is an Object (i.e. not a string literal)
 * and implements the Iterator protocol.
 *
 * This may be used in place of [Array.isArray()][isArray] to determine if
 * an object should be iterated-over e.g. Array, Map, Set, Int8Array,
 * TypedArray, etc. but excludes string literals.
 *
 * @example
 * ```ts
 * isIterableObject([ 1, 2, 3 ]) // true
 * isIterableObject(new Map()) // true
 * isIterableObject('ABC') // false
 * isIterableObject({ key: 'value' }) // false
 * isIterableObject({ length: 1, 0: 'Alpha' }) // false
 * ```
 */
function isIterableObject(maybeIterable) {
  return (
    typeof maybeIterable === 'object' &&
    typeof (maybeIterable === null || maybeIterable === void 0
      ? void 0
      : maybeIterable[Symbol.iterator]) === 'function'
  );
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/astFromValue.mjs







/**
 * Produces a GraphQL Value AST given a JavaScript object.
 * Function will match JavaScript/JSON values to GraphQL AST schema format
 * by using suggested GraphQLInputType. For example:
 *
 *     astFromValue("value", GraphQLString)
 *
 * A GraphQL type must be provided, which will be used to interpret different
 * JavaScript values.
 *
 * | JSON Value    | GraphQL Value        |
 * | ------------- | -------------------- |
 * | Object        | Input Object         |
 * | Array         | List                 |
 * | Boolean       | Boolean              |
 * | String        | String / Enum Value  |
 * | Number        | Int / Float          |
 * | Unknown       | Enum Value           |
 * | null          | NullValue            |
 *
 */

function astFromValue(value, type) {
  if (isNonNullType(type)) {
    const astValue = astFromValue(value, type.ofType);

    if (
      (astValue === null || astValue === void 0 ? void 0 : astValue.kind) ===
      Kind.NULL
    ) {
      return null;
    }

    return astValue;
  } // only explicit null, not undefined, NaN

  if (value === null) {
    return {
      kind: Kind.NULL,
    };
  } // undefined

  if (value === undefined) {
    return null;
  } // Convert JavaScript array to GraphQL list. If the GraphQLType is a list, but
  // the value is not an array, convert the value using the list's item type.

  if (isListType(type)) {
    const itemType = type.ofType;

    if (isIterableObject(value)) {
      const valuesNodes = [];

      for (const item of value) {
        const itemNode = astFromValue(item, itemType);

        if (itemNode != null) {
          valuesNodes.push(itemNode);
        }
      }

      return {
        kind: Kind.LIST,
        values: valuesNodes,
      };
    }

    return astFromValue(value, itemType);
  } // Populate the fields of the input object by creating ASTs from each value
  // in the JavaScript object according to the fields in the input type.

  if (isInputObjectType(type)) {
    if (!isObjectLike(value)) {
      return null;
    }

    const fieldNodes = [];

    for (const field of Object.values(type.getFields())) {
      const fieldValue = astFromValue(value[field.name], field.type);

      if (fieldValue) {
        fieldNodes.push({
          kind: Kind.OBJECT_FIELD,
          name: {
            kind: Kind.NAME,
            value: field.name,
          },
          value: fieldValue,
        });
      }
    }

    return {
      kind: Kind.OBJECT,
      fields: fieldNodes,
    };
  }

  if (isLeafType(type)) {
    // Since value is an internally represented value, it must be serialized
    // to an externally represented value before converting into an AST.
    const serialized = type.serialize(value);

    if (serialized == null) {
      return null;
    } // Others serialize based on their corresponding JavaScript scalar types.

    if (typeof serialized === 'boolean') {
      return {
        kind: Kind.BOOLEAN,
        value: serialized,
      };
    } // JavaScript numbers can be Int or Float values.

    if (typeof serialized === 'number' && Number.isFinite(serialized)) {
      const stringNum = String(serialized);
      return integerStringRegExp.test(stringNum)
        ? {
            kind: Kind.INT,
            value: stringNum,
          }
        : {
            kind: Kind.FLOAT,
            value: stringNum,
          };
    }

    if (typeof serialized === 'string') {
      // Enum types use Enum literals.
      if (isEnumType(type)) {
        return {
          kind: Kind.ENUM,
          value: serialized,
        };
      } // ID types can use Int literals.

      if (type === GraphQLID && integerStringRegExp.test(serialized)) {
        return {
          kind: Kind.INT,
          value: serialized,
        };
      }

      return {
        kind: Kind.STRING,
        value: serialized,
      };
    }

    throw new TypeError(`Cannot convert value to AST: ${inspect(serialized)}.`);
  }
  /* c8 ignore next 3 */
  // Not reachable, all possible types have been considered.

   false || invariant(false, 'Unexpected input type: ' + inspect(type));
}
/**
 * IntValue:
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit ( Digit+ )?
 */

const integerStringRegExp = /^-?(?:0|[1-9][0-9]*)$/;

;// CONCATENATED MODULE: ../node_modules/graphql/type/introspection.mjs







const __Schema = new GraphQLObjectType({
  name: '__Schema',
  description:
    'A GraphQL Schema defines the capabilities of a GraphQL server. It exposes all available types and directives on the server, as well as the entry points for query, mutation, and subscription operations.',
  fields: () => ({
    description: {
      type: GraphQLString,
      resolve: (schema) => schema.description,
    },
    types: {
      description: 'A list of all types supported by this server.',
      type: new GraphQLNonNull(new GraphQLList(new GraphQLNonNull(__Type))),

      resolve(schema) {
        return Object.values(schema.getTypeMap());
      },
    },
    queryType: {
      description: 'The type that query operations will be rooted at.',
      type: new GraphQLNonNull(__Type),
      resolve: (schema) => schema.getQueryType(),
    },
    mutationType: {
      description:
        'If this server supports mutation, the type that mutation operations will be rooted at.',
      type: __Type,
      resolve: (schema) => schema.getMutationType(),
    },
    subscriptionType: {
      description:
        'If this server support subscription, the type that subscription operations will be rooted at.',
      type: __Type,
      resolve: (schema) => schema.getSubscriptionType(),
    },
    directives: {
      description: 'A list of all directives supported by this server.',
      type: new GraphQLNonNull(
        new GraphQLList(new GraphQLNonNull(__Directive)),
      ),
      resolve: (schema) => schema.getDirectives(),
    },
  }),
});
const __Directive = new GraphQLObjectType({
  name: '__Directive',
  description:
    "A Directive provides a way to describe alternate runtime execution and type validation behavior in a GraphQL document.\n\nIn some cases, you need to provide options to alter GraphQL's execution behavior in ways field arguments will not suffice, such as conditionally including or skipping a field. Directives provide this by describing additional information to the executor.",
  fields: () => ({
    name: {
      type: new GraphQLNonNull(GraphQLString),
      resolve: (directive) => directive.name,
    },
    description: {
      type: GraphQLString,
      resolve: (directive) => directive.description,
    },
    isRepeatable: {
      type: new GraphQLNonNull(GraphQLBoolean),
      resolve: (directive) => directive.isRepeatable,
    },
    locations: {
      type: new GraphQLNonNull(
        new GraphQLList(new GraphQLNonNull(__DirectiveLocation)),
      ),
      resolve: (directive) => directive.locations,
    },
    args: {
      type: new GraphQLNonNull(
        new GraphQLList(new GraphQLNonNull(__InputValue)),
      ),
      args: {
        includeDeprecated: {
          type: GraphQLBoolean,
          defaultValue: false,
        },
      },

      resolve(field, { includeDeprecated }) {
        return includeDeprecated
          ? field.args
          : field.args.filter((arg) => arg.deprecationReason == null);
      },
    },
  }),
});
const __DirectiveLocation = new GraphQLEnumType({
  name: '__DirectiveLocation',
  description:
    'A Directive can be adjacent to many parts of the GraphQL language, a __DirectiveLocation describes one such possible adjacencies.',
  values: {
    QUERY: {
      value: DirectiveLocation.QUERY,
      description: 'Location adjacent to a query operation.',
    },
    MUTATION: {
      value: DirectiveLocation.MUTATION,
      description: 'Location adjacent to a mutation operation.',
    },
    SUBSCRIPTION: {
      value: DirectiveLocation.SUBSCRIPTION,
      description: 'Location adjacent to a subscription operation.',
    },
    FIELD: {
      value: DirectiveLocation.FIELD,
      description: 'Location adjacent to a field.',
    },
    FRAGMENT_DEFINITION: {
      value: DirectiveLocation.FRAGMENT_DEFINITION,
      description: 'Location adjacent to a fragment definition.',
    },
    FRAGMENT_SPREAD: {
      value: DirectiveLocation.FRAGMENT_SPREAD,
      description: 'Location adjacent to a fragment spread.',
    },
    INLINE_FRAGMENT: {
      value: DirectiveLocation.INLINE_FRAGMENT,
      description: 'Location adjacent to an inline fragment.',
    },
    VARIABLE_DEFINITION: {
      value: DirectiveLocation.VARIABLE_DEFINITION,
      description: 'Location adjacent to a variable definition.',
    },
    SCHEMA: {
      value: DirectiveLocation.SCHEMA,
      description: 'Location adjacent to a schema definition.',
    },
    SCALAR: {
      value: DirectiveLocation.SCALAR,
      description: 'Location adjacent to a scalar definition.',
    },
    OBJECT: {
      value: DirectiveLocation.OBJECT,
      description: 'Location adjacent to an object type definition.',
    },
    FIELD_DEFINITION: {
      value: DirectiveLocation.FIELD_DEFINITION,
      description: 'Location adjacent to a field definition.',
    },
    ARGUMENT_DEFINITION: {
      value: DirectiveLocation.ARGUMENT_DEFINITION,
      description: 'Location adjacent to an argument definition.',
    },
    INTERFACE: {
      value: DirectiveLocation.INTERFACE,
      description: 'Location adjacent to an interface definition.',
    },
    UNION: {
      value: DirectiveLocation.UNION,
      description: 'Location adjacent to a union definition.',
    },
    ENUM: {
      value: DirectiveLocation.ENUM,
      description: 'Location adjacent to an enum definition.',
    },
    ENUM_VALUE: {
      value: DirectiveLocation.ENUM_VALUE,
      description: 'Location adjacent to an enum value definition.',
    },
    INPUT_OBJECT: {
      value: DirectiveLocation.INPUT_OBJECT,
      description: 'Location adjacent to an input object type definition.',
    },
    INPUT_FIELD_DEFINITION: {
      value: DirectiveLocation.INPUT_FIELD_DEFINITION,
      description: 'Location adjacent to an input object field definition.',
    },
  },
});
const __Type = new GraphQLObjectType({
  name: '__Type',
  description:
    'The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.\n\nDepending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.',
  fields: () => ({
    kind: {
      type: new GraphQLNonNull(__TypeKind),

      resolve(type) {
        if (isScalarType(type)) {
          return TypeKind.SCALAR;
        }

        if (isObjectType(type)) {
          return TypeKind.OBJECT;
        }

        if (isInterfaceType(type)) {
          return TypeKind.INTERFACE;
        }

        if (isUnionType(type)) {
          return TypeKind.UNION;
        }

        if (isEnumType(type)) {
          return TypeKind.ENUM;
        }

        if (isInputObjectType(type)) {
          return TypeKind.INPUT_OBJECT;
        }

        if (isListType(type)) {
          return TypeKind.LIST;
        }

        if (isNonNullType(type)) {
          return TypeKind.NON_NULL;
        }
        /* c8 ignore next 3 */
        // Not reachable, all possible types have been considered)

         false || invariant(false, `Unexpected type: "${inspect(type)}".`);
      },
    },
    name: {
      type: GraphQLString,
      resolve: (type) => ('name' in type ? type.name : undefined),
    },
    description: {
      type: GraphQLString,
      resolve: (
        type, // FIXME: add test case
      ) =>
        /* c8 ignore next */
        'description' in type ? type.description : undefined,
    },
    specifiedByURL: {
      type: GraphQLString,
      resolve: (obj) =>
        'specifiedByURL' in obj ? obj.specifiedByURL : undefined,
    },
    fields: {
      type: new GraphQLList(new GraphQLNonNull(__Field)),
      args: {
        includeDeprecated: {
          type: GraphQLBoolean,
          defaultValue: false,
        },
      },

      resolve(type, { includeDeprecated }) {
        if (isObjectType(type) || isInterfaceType(type)) {
          const fields = Object.values(type.getFields());
          return includeDeprecated
            ? fields
            : fields.filter((field) => field.deprecationReason == null);
        }
      },
    },
    interfaces: {
      type: new GraphQLList(new GraphQLNonNull(__Type)),

      resolve(type) {
        if (isObjectType(type) || isInterfaceType(type)) {
          return type.getInterfaces();
        }
      },
    },
    possibleTypes: {
      type: new GraphQLList(new GraphQLNonNull(__Type)),

      resolve(type, _args, _context, { schema }) {
        if (isAbstractType(type)) {
          return schema.getPossibleTypes(type);
        }
      },
    },
    enumValues: {
      type: new GraphQLList(new GraphQLNonNull(__EnumValue)),
      args: {
        includeDeprecated: {
          type: GraphQLBoolean,
          defaultValue: false,
        },
      },

      resolve(type, { includeDeprecated }) {
        if (isEnumType(type)) {
          const values = type.getValues();
          return includeDeprecated
            ? values
            : values.filter((field) => field.deprecationReason == null);
        }
      },
    },
    inputFields: {
      type: new GraphQLList(new GraphQLNonNull(__InputValue)),
      args: {
        includeDeprecated: {
          type: GraphQLBoolean,
          defaultValue: false,
        },
      },

      resolve(type, { includeDeprecated }) {
        if (isInputObjectType(type)) {
          const values = Object.values(type.getFields());
          return includeDeprecated
            ? values
            : values.filter((field) => field.deprecationReason == null);
        }
      },
    },
    ofType: {
      type: __Type,
      resolve: (type) => ('ofType' in type ? type.ofType : undefined),
    },
  }),
});
const __Field = new GraphQLObjectType({
  name: '__Field',
  description:
    'Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type.',
  fields: () => ({
    name: {
      type: new GraphQLNonNull(GraphQLString),
      resolve: (field) => field.name,
    },
    description: {
      type: GraphQLString,
      resolve: (field) => field.description,
    },
    args: {
      type: new GraphQLNonNull(
        new GraphQLList(new GraphQLNonNull(__InputValue)),
      ),
      args: {
        includeDeprecated: {
          type: GraphQLBoolean,
          defaultValue: false,
        },
      },

      resolve(field, { includeDeprecated }) {
        return includeDeprecated
          ? field.args
          : field.args.filter((arg) => arg.deprecationReason == null);
      },
    },
    type: {
      type: new GraphQLNonNull(__Type),
      resolve: (field) => field.type,
    },
    isDeprecated: {
      type: new GraphQLNonNull(GraphQLBoolean),
      resolve: (field) => field.deprecationReason != null,
    },
    deprecationReason: {
      type: GraphQLString,
      resolve: (field) => field.deprecationReason,
    },
  }),
});
const __InputValue = new GraphQLObjectType({
  name: '__InputValue',
  description:
    'Arguments provided to Fields or Directives and the input fields of an InputObject are represented as Input Values which describe their type and optionally a default value.',
  fields: () => ({
    name: {
      type: new GraphQLNonNull(GraphQLString),
      resolve: (inputValue) => inputValue.name,
    },
    description: {
      type: GraphQLString,
      resolve: (inputValue) => inputValue.description,
    },
    type: {
      type: new GraphQLNonNull(__Type),
      resolve: (inputValue) => inputValue.type,
    },
    defaultValue: {
      type: GraphQLString,
      description:
        'A GraphQL-formatted string representing the default value for this input value.',

      resolve(inputValue) {
        const { type, defaultValue } = inputValue;
        const valueAST = astFromValue(defaultValue, type);
        return valueAST ? print(valueAST) : null;
      },
    },
    isDeprecated: {
      type: new GraphQLNonNull(GraphQLBoolean),
      resolve: (field) => field.deprecationReason != null,
    },
    deprecationReason: {
      type: GraphQLString,
      resolve: (obj) => obj.deprecationReason,
    },
  }),
});
const __EnumValue = new GraphQLObjectType({
  name: '__EnumValue',
  description:
    'One possible value for a given Enum. Enum values are unique values, not a placeholder for a string or numeric value. However an Enum value is returned in a JSON response as a string.',
  fields: () => ({
    name: {
      type: new GraphQLNonNull(GraphQLString),
      resolve: (enumValue) => enumValue.name,
    },
    description: {
      type: GraphQLString,
      resolve: (enumValue) => enumValue.description,
    },
    isDeprecated: {
      type: new GraphQLNonNull(GraphQLBoolean),
      resolve: (enumValue) => enumValue.deprecationReason != null,
    },
    deprecationReason: {
      type: GraphQLString,
      resolve: (enumValue) => enumValue.deprecationReason,
    },
  }),
});
var TypeKind;

(function (TypeKind) {
  TypeKind['SCALAR'] = 'SCALAR';
  TypeKind['OBJECT'] = 'OBJECT';
  TypeKind['INTERFACE'] = 'INTERFACE';
  TypeKind['UNION'] = 'UNION';
  TypeKind['ENUM'] = 'ENUM';
  TypeKind['INPUT_OBJECT'] = 'INPUT_OBJECT';
  TypeKind['LIST'] = 'LIST';
  TypeKind['NON_NULL'] = 'NON_NULL';
})(TypeKind || (TypeKind = {}));


const __TypeKind = new GraphQLEnumType({
  name: '__TypeKind',
  description: 'An enum describing what kind of type a given `__Type` is.',
  values: {
    SCALAR: {
      value: TypeKind.SCALAR,
      description: 'Indicates this type is a scalar.',
    },
    OBJECT: {
      value: TypeKind.OBJECT,
      description:
        'Indicates this type is an object. `fields` and `interfaces` are valid fields.',
    },
    INTERFACE: {
      value: TypeKind.INTERFACE,
      description:
        'Indicates this type is an interface. `fields`, `interfaces`, and `possibleTypes` are valid fields.',
    },
    UNION: {
      value: TypeKind.UNION,
      description:
        'Indicates this type is a union. `possibleTypes` is a valid field.',
    },
    ENUM: {
      value: TypeKind.ENUM,
      description:
        'Indicates this type is an enum. `enumValues` is a valid field.',
    },
    INPUT_OBJECT: {
      value: TypeKind.INPUT_OBJECT,
      description:
        'Indicates this type is an input object. `inputFields` is a valid field.',
    },
    LIST: {
      value: TypeKind.LIST,
      description: 'Indicates this type is a list. `ofType` is a valid field.',
    },
    NON_NULL: {
      value: TypeKind.NON_NULL,
      description:
        'Indicates this type is a non-null. `ofType` is a valid field.',
    },
  },
});
/**
 * Note that these are GraphQLField and not GraphQLFieldConfig,
 * so the format for args is different.
 */

const SchemaMetaFieldDef = {
  name: '__schema',
  type: new GraphQLNonNull(__Schema),
  description: 'Access the current type schema of this server.',
  args: [],
  resolve: (_source, _args, _context, { schema }) => schema,
  deprecationReason: undefined,
  extensions: Object.create(null),
  astNode: undefined,
};
const TypeMetaFieldDef = {
  name: '__type',
  type: __Type,
  description: 'Request the type information of a single type.',
  args: [
    {
      name: 'name',
      description: undefined,
      type: new GraphQLNonNull(GraphQLString),
      defaultValue: undefined,
      deprecationReason: undefined,
      extensions: Object.create(null),
      astNode: undefined,
    },
  ],
  resolve: (_source, { name }, _context, { schema }) => schema.getType(name),
  deprecationReason: undefined,
  extensions: Object.create(null),
  astNode: undefined,
};
const TypeNameMetaFieldDef = {
  name: '__typename',
  type: new GraphQLNonNull(GraphQLString),
  description: 'The name of the current Object type at runtime.',
  args: [],
  resolve: (_source, _args, _context, { parentType }) => parentType.name,
  deprecationReason: undefined,
  extensions: Object.create(null),
  astNode: undefined,
};
const introspectionTypes = Object.freeze([
  __Schema,
  __Directive,
  __DirectiveLocation,
  __Type,
  __Field,
  __InputValue,
  __EnumValue,
  __TypeKind,
]);
function isIntrospectionType(type) {
  return introspectionTypes.some(({ name }) => type.name === name);
}

;// CONCATENATED MODULE: ../node_modules/graphql/type/schema.mjs









/**
 * Test if the given value is a GraphQL schema.
 */

function isSchema(schema) {
  return instanceOf(schema, GraphQLSchema);
}
function assertSchema(schema) {
  if (!isSchema(schema)) {
    throw new Error(`Expected ${inspect(schema)} to be a GraphQL schema.`);
  }

  return schema;
}
/**
 * Custom extensions
 *
 * @remarks
 * Use a unique identifier name for your extension, for example the name of
 * your library or project. Do not use a shortened identifier as this increases
 * the risk of conflicts. We recommend you add at most one extension field,
 * an object which can contain all the values you need.
 */

/**
 * Schema Definition
 *
 * A Schema is created by supplying the root types of each type of operation,
 * query and mutation (optional). A schema definition is then supplied to the
 * validator and executor.
 *
 * Example:
 *
 * ```ts
 * const MyAppSchema = new GraphQLSchema({
 *   query: MyAppQueryRootType,
 *   mutation: MyAppMutationRootType,
 * })
 * ```
 *
 * Note: When the schema is constructed, by default only the types that are
 * reachable by traversing the root types are included, other types must be
 * explicitly referenced.
 *
 * Example:
 *
 * ```ts
 * const characterInterface = new GraphQLInterfaceType({
 *   name: 'Character',
 *   ...
 * });
 *
 * const humanType = new GraphQLObjectType({
 *   name: 'Human',
 *   interfaces: [characterInterface],
 *   ...
 * });
 *
 * const droidType = new GraphQLObjectType({
 *   name: 'Droid',
 *   interfaces: [characterInterface],
 *   ...
 * });
 *
 * const schema = new GraphQLSchema({
 *   query: new GraphQLObjectType({
 *     name: 'Query',
 *     fields: {
 *       hero: { type: characterInterface, ... },
 *     }
 *   }),
 *   ...
 *   // Since this schema references only the `Character` interface it's
 *   // necessary to explicitly list the types that implement it if
 *   // you want them to be included in the final schema.
 *   types: [humanType, droidType],
 * })
 * ```
 *
 * Note: If an array of `directives` are provided to GraphQLSchema, that will be
 * the exact list of directives represented and allowed. If `directives` is not
 * provided then a default set of the specified directives (e.g. `@include` and
 * `@skip`) will be used. If you wish to provide *additional* directives to these
 * specified directives, you must explicitly declare them. Example:
 *
 * ```ts
 * const MyAppSchema = new GraphQLSchema({
 *   ...
 *   directives: specifiedDirectives.concat([ myCustomDirective ]),
 * })
 * ```
 */
class GraphQLSchema {
  // Used as a cache for validateSchema().
  constructor(config) {
    var _config$extensionASTN, _config$directives;

    // If this schema was built from a source known to be valid, then it may be
    // marked with assumeValid to avoid an additional type system validation.
    this.__validationErrors = config.assumeValid === true ? [] : undefined; // Check for common mistakes during construction to produce early errors.

    isObjectLike(config) ||
      devAssert(false, 'Must provide configuration object.');
    !config.types ||
      Array.isArray(config.types) ||
      devAssert(
        false,
        `"types" must be Array if provided but got: ${inspect(config.types)}.`,
      );
    !config.directives ||
      Array.isArray(config.directives) ||
      devAssert(
        false,
        '"directives" must be Array if provided but got: ' +
          `${inspect(config.directives)}.`,
      );
    this.description = config.description;
    this.extensions = toObjMap(config.extensions);
    this.astNode = config.astNode;
    this.extensionASTNodes =
      (_config$extensionASTN = config.extensionASTNodes) !== null &&
      _config$extensionASTN !== void 0
        ? _config$extensionASTN
        : [];
    this._queryType = config.query;
    this._mutationType = config.mutation;
    this._subscriptionType = config.subscription; // Provide specified directives (e.g. @include and @skip) by default.

    this._directives =
      (_config$directives = config.directives) !== null &&
      _config$directives !== void 0
        ? _config$directives
        : specifiedDirectives; // To preserve order of user-provided types, we add first to add them to
    // the set of "collected" types, so `collectReferencedTypes` ignore them.

    const allReferencedTypes = new Set(config.types);

    if (config.types != null) {
      for (const type of config.types) {
        // When we ready to process this type, we remove it from "collected" types
        // and then add it together with all dependent types in the correct position.
        allReferencedTypes.delete(type);
        collectReferencedTypes(type, allReferencedTypes);
      }
    }

    if (this._queryType != null) {
      collectReferencedTypes(this._queryType, allReferencedTypes);
    }

    if (this._mutationType != null) {
      collectReferencedTypes(this._mutationType, allReferencedTypes);
    }

    if (this._subscriptionType != null) {
      collectReferencedTypes(this._subscriptionType, allReferencedTypes);
    }

    for (const directive of this._directives) {
      // Directives are not validated until validateSchema() is called.
      if (isDirective(directive)) {
        for (const arg of directive.args) {
          collectReferencedTypes(arg.type, allReferencedTypes);
        }
      }
    }

    collectReferencedTypes(__Schema, allReferencedTypes); // Storing the resulting map for reference by the schema.

    this._typeMap = Object.create(null);
    this._subTypeMap = Object.create(null); // Keep track of all implementations by interface name.

    this._implementationsMap = Object.create(null);

    for (const namedType of allReferencedTypes) {
      if (namedType == null) {
        continue;
      }

      const typeName = namedType.name;
      typeName ||
        devAssert(
          false,
          'One of the provided types for building the Schema is missing a name.',
        );

      if (this._typeMap[typeName] !== undefined) {
        throw new Error(
          `Schema must contain uniquely named types but contains multiple types named "${typeName}".`,
        );
      }

      this._typeMap[typeName] = namedType;

      if (isInterfaceType(namedType)) {
        // Store implementations by interface.
        for (const iface of namedType.getInterfaces()) {
          if (isInterfaceType(iface)) {
            let implementations = this._implementationsMap[iface.name];

            if (implementations === undefined) {
              implementations = this._implementationsMap[iface.name] = {
                objects: [],
                interfaces: [],
              };
            }

            implementations.interfaces.push(namedType);
          }
        }
      } else if (isObjectType(namedType)) {
        // Store implementations by objects.
        for (const iface of namedType.getInterfaces()) {
          if (isInterfaceType(iface)) {
            let implementations = this._implementationsMap[iface.name];

            if (implementations === undefined) {
              implementations = this._implementationsMap[iface.name] = {
                objects: [],
                interfaces: [],
              };
            }

            implementations.objects.push(namedType);
          }
        }
      }
    }
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLSchema';
  }

  getQueryType() {
    return this._queryType;
  }

  getMutationType() {
    return this._mutationType;
  }

  getSubscriptionType() {
    return this._subscriptionType;
  }

  getRootType(operation) {
    switch (operation) {
      case OperationTypeNode.QUERY:
        return this.getQueryType();

      case OperationTypeNode.MUTATION:
        return this.getMutationType();

      case OperationTypeNode.SUBSCRIPTION:
        return this.getSubscriptionType();
    }
  }

  getTypeMap() {
    return this._typeMap;
  }

  getType(name) {
    return this.getTypeMap()[name];
  }

  getPossibleTypes(abstractType) {
    return isUnionType(abstractType)
      ? abstractType.getTypes()
      : this.getImplementations(abstractType).objects;
  }

  getImplementations(interfaceType) {
    const implementations = this._implementationsMap[interfaceType.name];
    return implementations !== null && implementations !== void 0
      ? implementations
      : {
          objects: [],
          interfaces: [],
        };
  }

  isSubType(abstractType, maybeSubType) {
    let map = this._subTypeMap[abstractType.name];

    if (map === undefined) {
      map = Object.create(null);

      if (isUnionType(abstractType)) {
        for (const type of abstractType.getTypes()) {
          map[type.name] = true;
        }
      } else {
        const implementations = this.getImplementations(abstractType);

        for (const type of implementations.objects) {
          map[type.name] = true;
        }

        for (const type of implementations.interfaces) {
          map[type.name] = true;
        }
      }

      this._subTypeMap[abstractType.name] = map;
    }

    return map[maybeSubType.name] !== undefined;
  }

  getDirectives() {
    return this._directives;
  }

  getDirective(name) {
    return this.getDirectives().find((directive) => directive.name === name);
  }

  toConfig() {
    return {
      description: this.description,
      query: this.getQueryType(),
      mutation: this.getMutationType(),
      subscription: this.getSubscriptionType(),
      types: Object.values(this.getTypeMap()),
      directives: this.getDirectives(),
      extensions: this.extensions,
      astNode: this.astNode,
      extensionASTNodes: this.extensionASTNodes,
      assumeValid: this.__validationErrors !== undefined,
    };
  }
}

function collectReferencedTypes(type, typeSet) {
  const namedType = getNamedType(type);

  if (!typeSet.has(namedType)) {
    typeSet.add(namedType);

    if (isUnionType(namedType)) {
      for (const memberType of namedType.getTypes()) {
        collectReferencedTypes(memberType, typeSet);
      }
    } else if (isObjectType(namedType) || isInterfaceType(namedType)) {
      for (const interfaceType of namedType.getInterfaces()) {
        collectReferencedTypes(interfaceType, typeSet);
      }

      for (const field of Object.values(namedType.getFields())) {
        collectReferencedTypes(field.type, typeSet);

        for (const arg of field.args) {
          collectReferencedTypes(arg.type, typeSet);
        }
      }
    } else if (isInputObjectType(namedType)) {
      for (const field of Object.values(namedType.getFields())) {
        collectReferencedTypes(field.type, typeSet);
      }
    }
  }

  return typeSet;
}

;// CONCATENATED MODULE: ../node_modules/graphql/type/validate.mjs








/**
 * Implements the "Type Validation" sub-sections of the specification's
 * "Type System" section.
 *
 * Validation runs synchronously, returning an array of encountered errors, or
 * an empty array if no errors were encountered and the Schema is valid.
 */

function validateSchema(schema) {
  // First check to ensure the provided value is in fact a GraphQLSchema.
  assertSchema(schema); // If this Schema has already been validated, return the previous results.

  if (schema.__validationErrors) {
    return schema.__validationErrors;
  } // Validate the schema, producing a list of errors.

  const context = new SchemaValidationContext(schema);
  validateRootTypes(context);
  validateDirectives(context);
  validateTypes(context); // Persist the results of validation before returning to ensure validation
  // does not run multiple times for this schema.

  const errors = context.getErrors();
  schema.__validationErrors = errors;
  return errors;
}
/**
 * Utility function which asserts a schema is valid by throwing an error if
 * it is invalid.
 */

function assertValidSchema(schema) {
  const errors = validateSchema(schema);

  if (errors.length !== 0) {
    throw new Error(errors.map((error) => error.message).join('\n\n'));
  }
}

class SchemaValidationContext {
  constructor(schema) {
    this._errors = [];
    this.schema = schema;
  }

  reportError(message, nodes) {
    const _nodes = Array.isArray(nodes) ? nodes.filter(Boolean) : nodes;

    this._errors.push(
      new GraphQLError(message, {
        nodes: _nodes,
      }),
    );
  }

  getErrors() {
    return this._errors;
  }
}

function validateRootTypes(context) {
  const schema = context.schema;
  const queryType = schema.getQueryType();

  if (!queryType) {
    context.reportError('Query root type must be provided.', schema.astNode);
  } else if (!isObjectType(queryType)) {
    var _getOperationTypeNode;

    context.reportError(
      `Query root type must be Object type, it cannot be ${inspect(
        queryType,
      )}.`,
      (_getOperationTypeNode = getOperationTypeNode(
        schema,
        OperationTypeNode.QUERY,
      )) !== null && _getOperationTypeNode !== void 0
        ? _getOperationTypeNode
        : queryType.astNode,
    );
  }

  const mutationType = schema.getMutationType();

  if (mutationType && !isObjectType(mutationType)) {
    var _getOperationTypeNode2;

    context.reportError(
      'Mutation root type must be Object type if provided, it cannot be ' +
        `${inspect(mutationType)}.`,
      (_getOperationTypeNode2 = getOperationTypeNode(
        schema,
        OperationTypeNode.MUTATION,
      )) !== null && _getOperationTypeNode2 !== void 0
        ? _getOperationTypeNode2
        : mutationType.astNode,
    );
  }

  const subscriptionType = schema.getSubscriptionType();

  if (subscriptionType && !isObjectType(subscriptionType)) {
    var _getOperationTypeNode3;

    context.reportError(
      'Subscription root type must be Object type if provided, it cannot be ' +
        `${inspect(subscriptionType)}.`,
      (_getOperationTypeNode3 = getOperationTypeNode(
        schema,
        OperationTypeNode.SUBSCRIPTION,
      )) !== null && _getOperationTypeNode3 !== void 0
        ? _getOperationTypeNode3
        : subscriptionType.astNode,
    );
  }
}

function getOperationTypeNode(schema, operation) {
  var _flatMap$find;

  return (_flatMap$find = [schema.astNode, ...schema.extensionASTNodes]
    .flatMap(
      // FIXME: https://github.com/graphql/graphql-js/issues/2203
      (schemaNode) => {
        var _schemaNode$operation;

        return (
          /* c8 ignore next */
          (_schemaNode$operation =
            schemaNode === null || schemaNode === void 0
              ? void 0
              : schemaNode.operationTypes) !== null &&
            _schemaNode$operation !== void 0
            ? _schemaNode$operation
            : []
        );
      },
    )
    .find((operationNode) => operationNode.operation === operation)) === null ||
    _flatMap$find === void 0
    ? void 0
    : _flatMap$find.type;
}

function validateDirectives(context) {
  for (const directive of context.schema.getDirectives()) {
    // Ensure all directives are in fact GraphQL directives.
    if (!isDirective(directive)) {
      context.reportError(
        `Expected directive but got: ${inspect(directive)}.`,
        directive === null || directive === void 0 ? void 0 : directive.astNode,
      );
      continue;
    } // Ensure they are named correctly.

    validateName(context, directive); // TODO: Ensure proper locations.
    // Ensure the arguments are valid.

    for (const arg of directive.args) {
      // Ensure they are named correctly.
      validateName(context, arg); // Ensure the type is an input type.

      if (!isInputType(arg.type)) {
        context.reportError(
          `The type of @${directive.name}(${arg.name}:) must be Input Type ` +
            `but got: ${inspect(arg.type)}.`,
          arg.astNode,
        );
      }

      if (isRequiredArgument(arg) && arg.deprecationReason != null) {
        var _arg$astNode;

        context.reportError(
          `Required argument @${directive.name}(${arg.name}:) cannot be deprecated.`,
          [
            getDeprecatedDirectiveNode(arg.astNode),
            (_arg$astNode = arg.astNode) === null || _arg$astNode === void 0
              ? void 0
              : _arg$astNode.type,
          ],
        );
      }
    }
  }
}

function validateName(context, node) {
  // Ensure names are valid, however introspection types opt out.
  if (node.name.startsWith('__')) {
    context.reportError(
      `Name "${node.name}" must not begin with "__", which is reserved by GraphQL introspection.`,
      node.astNode,
    );
  }
}

function validateTypes(context) {
  const validateInputObjectCircularRefs =
    createInputObjectCircularRefsValidator(context);
  const typeMap = context.schema.getTypeMap();

  for (const type of Object.values(typeMap)) {
    // Ensure all provided types are in fact GraphQL type.
    if (!isNamedType(type)) {
      context.reportError(
        `Expected GraphQL named type but got: ${inspect(type)}.`,
        type.astNode,
      );
      continue;
    } // Ensure it is named correctly (excluding introspection types).

    if (!isIntrospectionType(type)) {
      validateName(context, type);
    }

    if (isObjectType(type)) {
      // Ensure fields are valid
      validateFields(context, type); // Ensure objects implement the interfaces they claim to.

      validateInterfaces(context, type);
    } else if (isInterfaceType(type)) {
      // Ensure fields are valid.
      validateFields(context, type); // Ensure interfaces implement the interfaces they claim to.

      validateInterfaces(context, type);
    } else if (isUnionType(type)) {
      // Ensure Unions include valid member types.
      validateUnionMembers(context, type);
    } else if (isEnumType(type)) {
      // Ensure Enums have valid values.
      validateEnumValues(context, type);
    } else if (isInputObjectType(type)) {
      // Ensure Input Object fields are valid.
      validateInputFields(context, type); // Ensure Input Objects do not contain non-nullable circular references

      validateInputObjectCircularRefs(type);
    }
  }
}

function validateFields(context, type) {
  const fields = Object.values(type.getFields()); // Objects and Interfaces both must define one or more fields.

  if (fields.length === 0) {
    context.reportError(`Type ${type.name} must define one or more fields.`, [
      type.astNode,
      ...type.extensionASTNodes,
    ]);
  }

  for (const field of fields) {
    // Ensure they are named correctly.
    validateName(context, field); // Ensure the type is an output type

    if (!isOutputType(field.type)) {
      var _field$astNode;

      context.reportError(
        `The type of ${type.name}.${field.name} must be Output Type ` +
          `but got: ${inspect(field.type)}.`,
        (_field$astNode = field.astNode) === null || _field$astNode === void 0
          ? void 0
          : _field$astNode.type,
      );
    } // Ensure the arguments are valid

    for (const arg of field.args) {
      const argName = arg.name; // Ensure they are named correctly.

      validateName(context, arg); // Ensure the type is an input type

      if (!isInputType(arg.type)) {
        var _arg$astNode2;

        context.reportError(
          `The type of ${type.name}.${field.name}(${argName}:) must be Input ` +
            `Type but got: ${inspect(arg.type)}.`,
          (_arg$astNode2 = arg.astNode) === null || _arg$astNode2 === void 0
            ? void 0
            : _arg$astNode2.type,
        );
      }

      if (isRequiredArgument(arg) && arg.deprecationReason != null) {
        var _arg$astNode3;

        context.reportError(
          `Required argument ${type.name}.${field.name}(${argName}:) cannot be deprecated.`,
          [
            getDeprecatedDirectiveNode(arg.astNode),
            (_arg$astNode3 = arg.astNode) === null || _arg$astNode3 === void 0
              ? void 0
              : _arg$astNode3.type,
          ],
        );
      }
    }
  }
}

function validateInterfaces(context, type) {
  const ifaceTypeNames = Object.create(null);

  for (const iface of type.getInterfaces()) {
    if (!isInterfaceType(iface)) {
      context.reportError(
        `Type ${inspect(type)} must only implement Interface types, ` +
          `it cannot implement ${inspect(iface)}.`,
        getAllImplementsInterfaceNodes(type, iface),
      );
      continue;
    }

    if (type === iface) {
      context.reportError(
        `Type ${type.name} cannot implement itself because it would create a circular reference.`,
        getAllImplementsInterfaceNodes(type, iface),
      );
      continue;
    }

    if (ifaceTypeNames[iface.name]) {
      context.reportError(
        `Type ${type.name} can only implement ${iface.name} once.`,
        getAllImplementsInterfaceNodes(type, iface),
      );
      continue;
    }

    ifaceTypeNames[iface.name] = true;
    validateTypeImplementsAncestors(context, type, iface);
    validateTypeImplementsInterface(context, type, iface);
  }
}

function validateTypeImplementsInterface(context, type, iface) {
  const typeFieldMap = type.getFields(); // Assert each interface field is implemented.

  for (const ifaceField of Object.values(iface.getFields())) {
    const fieldName = ifaceField.name;
    const typeField = typeFieldMap[fieldName]; // Assert interface field exists on type.

    if (!typeField) {
      context.reportError(
        `Interface field ${iface.name}.${fieldName} expected but ${type.name} does not provide it.`,
        [ifaceField.astNode, type.astNode, ...type.extensionASTNodes],
      );
      continue;
    } // Assert interface field type is satisfied by type field type, by being
    // a valid subtype. (covariant)

    if (!isTypeSubTypeOf(context.schema, typeField.type, ifaceField.type)) {
      var _ifaceField$astNode, _typeField$astNode;

      context.reportError(
        `Interface field ${iface.name}.${fieldName} expects type ` +
          `${inspect(ifaceField.type)} but ${type.name}.${fieldName} ` +
          `is type ${inspect(typeField.type)}.`,
        [
          (_ifaceField$astNode = ifaceField.astNode) === null ||
          _ifaceField$astNode === void 0
            ? void 0
            : _ifaceField$astNode.type,
          (_typeField$astNode = typeField.astNode) === null ||
          _typeField$astNode === void 0
            ? void 0
            : _typeField$astNode.type,
        ],
      );
    } // Assert each interface field arg is implemented.

    for (const ifaceArg of ifaceField.args) {
      const argName = ifaceArg.name;
      const typeArg = typeField.args.find((arg) => arg.name === argName); // Assert interface field arg exists on object field.

      if (!typeArg) {
        context.reportError(
          `Interface field argument ${iface.name}.${fieldName}(${argName}:) expected but ${type.name}.${fieldName} does not provide it.`,
          [ifaceArg.astNode, typeField.astNode],
        );
        continue;
      } // Assert interface field arg type matches object field arg type.
      // (invariant)
      // TODO: change to contravariant?

      if (!isEqualType(ifaceArg.type, typeArg.type)) {
        var _ifaceArg$astNode, _typeArg$astNode;

        context.reportError(
          `Interface field argument ${iface.name}.${fieldName}(${argName}:) ` +
            `expects type ${inspect(ifaceArg.type)} but ` +
            `${type.name}.${fieldName}(${argName}:) is type ` +
            `${inspect(typeArg.type)}.`,
          [
            (_ifaceArg$astNode = ifaceArg.astNode) === null ||
            _ifaceArg$astNode === void 0
              ? void 0
              : _ifaceArg$astNode.type,
            (_typeArg$astNode = typeArg.astNode) === null ||
            _typeArg$astNode === void 0
              ? void 0
              : _typeArg$astNode.type,
          ],
        );
      } // TODO: validate default values?
    } // Assert additional arguments must not be required.

    for (const typeArg of typeField.args) {
      const argName = typeArg.name;
      const ifaceArg = ifaceField.args.find((arg) => arg.name === argName);

      if (!ifaceArg && isRequiredArgument(typeArg)) {
        context.reportError(
          `Object field ${type.name}.${fieldName} includes required argument ${argName} that is missing from the Interface field ${iface.name}.${fieldName}.`,
          [typeArg.astNode, ifaceField.astNode],
        );
      }
    }
  }
}

function validateTypeImplementsAncestors(context, type, iface) {
  const ifaceInterfaces = type.getInterfaces();

  for (const transitive of iface.getInterfaces()) {
    if (!ifaceInterfaces.includes(transitive)) {
      context.reportError(
        transitive === type
          ? `Type ${type.name} cannot implement ${iface.name} because it would create a circular reference.`
          : `Type ${type.name} must implement ${transitive.name} because it is implemented by ${iface.name}.`,
        [
          ...getAllImplementsInterfaceNodes(iface, transitive),
          ...getAllImplementsInterfaceNodes(type, iface),
        ],
      );
    }
  }
}

function validateUnionMembers(context, union) {
  const memberTypes = union.getTypes();

  if (memberTypes.length === 0) {
    context.reportError(
      `Union type ${union.name} must define one or more member types.`,
      [union.astNode, ...union.extensionASTNodes],
    );
  }

  const includedTypeNames = Object.create(null);

  for (const memberType of memberTypes) {
    if (includedTypeNames[memberType.name]) {
      context.reportError(
        `Union type ${union.name} can only include type ${memberType.name} once.`,
        getUnionMemberTypeNodes(union, memberType.name),
      );
      continue;
    }

    includedTypeNames[memberType.name] = true;

    if (!isObjectType(memberType)) {
      context.reportError(
        `Union type ${union.name} can only include Object types, ` +
          `it cannot include ${inspect(memberType)}.`,
        getUnionMemberTypeNodes(union, String(memberType)),
      );
    }
  }
}

function validateEnumValues(context, enumType) {
  const enumValues = enumType.getValues();

  if (enumValues.length === 0) {
    context.reportError(
      `Enum type ${enumType.name} must define one or more values.`,
      [enumType.astNode, ...enumType.extensionASTNodes],
    );
  }

  for (const enumValue of enumValues) {
    // Ensure valid name.
    validateName(context, enumValue);
  }
}

function validateInputFields(context, inputObj) {
  const fields = Object.values(inputObj.getFields());

  if (fields.length === 0) {
    context.reportError(
      `Input Object type ${inputObj.name} must define one or more fields.`,
      [inputObj.astNode, ...inputObj.extensionASTNodes],
    );
  } // Ensure the arguments are valid

  for (const field of fields) {
    // Ensure they are named correctly.
    validateName(context, field); // Ensure the type is an input type

    if (!isInputType(field.type)) {
      var _field$astNode2;

      context.reportError(
        `The type of ${inputObj.name}.${field.name} must be Input Type ` +
          `but got: ${inspect(field.type)}.`,
        (_field$astNode2 = field.astNode) === null || _field$astNode2 === void 0
          ? void 0
          : _field$astNode2.type,
      );
    }

    if (isRequiredInputField(field) && field.deprecationReason != null) {
      var _field$astNode3;

      context.reportError(
        `Required input field ${inputObj.name}.${field.name} cannot be deprecated.`,
        [
          getDeprecatedDirectiveNode(field.astNode),
          (_field$astNode3 = field.astNode) === null ||
          _field$astNode3 === void 0
            ? void 0
            : _field$astNode3.type,
        ],
      );
    }
  }
}

function createInputObjectCircularRefsValidator(context) {
  // Modified copy of algorithm from 'src/validation/rules/NoFragmentCycles.js'.
  // Tracks already visited types to maintain O(N) and to ensure that cycles
  // are not redundantly reported.
  const visitedTypes = Object.create(null); // Array of types nodes used to produce meaningful errors

  const fieldPath = []; // Position in the type path

  const fieldPathIndexByTypeName = Object.create(null);
  return detectCycleRecursive; // This does a straight-forward DFS to find cycles.
  // It does not terminate when a cycle was found but continues to explore
  // the graph to find all possible cycles.

  function detectCycleRecursive(inputObj) {
    if (visitedTypes[inputObj.name]) {
      return;
    }

    visitedTypes[inputObj.name] = true;
    fieldPathIndexByTypeName[inputObj.name] = fieldPath.length;
    const fields = Object.values(inputObj.getFields());

    for (const field of fields) {
      if (isNonNullType(field.type) && isInputObjectType(field.type.ofType)) {
        const fieldType = field.type.ofType;
        const cycleIndex = fieldPathIndexByTypeName[fieldType.name];
        fieldPath.push(field);

        if (cycleIndex === undefined) {
          detectCycleRecursive(fieldType);
        } else {
          const cyclePath = fieldPath.slice(cycleIndex);
          const pathStr = cyclePath.map((fieldObj) => fieldObj.name).join('.');
          context.reportError(
            `Cannot reference Input Object "${fieldType.name}" within itself through a series of non-null fields: "${pathStr}".`,
            cyclePath.map((fieldObj) => fieldObj.astNode),
          );
        }

        fieldPath.pop();
      }
    }

    fieldPathIndexByTypeName[inputObj.name] = undefined;
  }
}

function getAllImplementsInterfaceNodes(type, iface) {
  const { astNode, extensionASTNodes } = type;
  const nodes =
    astNode != null ? [astNode, ...extensionASTNodes] : extensionASTNodes; // FIXME: https://github.com/graphql/graphql-js/issues/2203

  return nodes
    .flatMap((typeNode) => {
      var _typeNode$interfaces;

      return (
        /* c8 ignore next */
        (_typeNode$interfaces = typeNode.interfaces) !== null &&
          _typeNode$interfaces !== void 0
          ? _typeNode$interfaces
          : []
      );
    })
    .filter((ifaceNode) => ifaceNode.name.value === iface.name);
}

function getUnionMemberTypeNodes(union, typeName) {
  const { astNode, extensionASTNodes } = union;
  const nodes =
    astNode != null ? [astNode, ...extensionASTNodes] : extensionASTNodes; // FIXME: https://github.com/graphql/graphql-js/issues/2203

  return nodes
    .flatMap((unionNode) => {
      var _unionNode$types;

      return (
        /* c8 ignore next */
        (_unionNode$types = unionNode.types) !== null &&
          _unionNode$types !== void 0
          ? _unionNode$types
          : []
      );
    })
    .filter((typeNode) => typeNode.name.value === typeName);
}

function getDeprecatedDirectiveNode(definitionNode) {
  var _definitionNode$direc;

  return definitionNode === null || definitionNode === void 0
    ? void 0
    : (_definitionNode$direc = definitionNode.directives) === null ||
      _definitionNode$direc === void 0
    ? void 0
    : _definitionNode$direc.find(
        (node) => node.name.value === GraphQLDeprecatedDirective.name,
      );
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/typeFromAST.mjs


function typeFromAST(schema, typeNode) {
  switch (typeNode.kind) {
    case Kind.LIST_TYPE: {
      const innerType = typeFromAST(schema, typeNode.type);
      return innerType && new GraphQLList(innerType);
    }

    case Kind.NON_NULL_TYPE: {
      const innerType = typeFromAST(schema, typeNode.type);
      return innerType && new GraphQLNonNull(innerType);
    }

    case Kind.NAMED_TYPE:
      return schema.getType(typeNode.name.value);
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/TypeInfo.mjs






/**
 * TypeInfo is a utility class which, given a GraphQL schema, can keep track
 * of the current field and type definitions at any point in a GraphQL document
 * AST during a recursive descent by calling `enter(node)` and `leave(node)`.
 */

class TypeInfo {
  constructor(
    schema,
    /**
     * Initial type may be provided in rare cases to facilitate traversals
     *  beginning somewhere other than documents.
     */
    initialType,
    /** @deprecated will be removed in 17.0.0 */
    getFieldDefFn,
  ) {
    this._schema = schema;
    this._typeStack = [];
    this._parentTypeStack = [];
    this._inputTypeStack = [];
    this._fieldDefStack = [];
    this._defaultValueStack = [];
    this._directive = null;
    this._argument = null;
    this._enumValue = null;
    this._getFieldDef =
      getFieldDefFn !== null && getFieldDefFn !== void 0
        ? getFieldDefFn
        : getFieldDef;

    if (initialType) {
      if (isInputType(initialType)) {
        this._inputTypeStack.push(initialType);
      }

      if (isCompositeType(initialType)) {
        this._parentTypeStack.push(initialType);
      }

      if (isOutputType(initialType)) {
        this._typeStack.push(initialType);
      }
    }
  }

  get [Symbol.toStringTag]() {
    return 'TypeInfo';
  }

  getType() {
    if (this._typeStack.length > 0) {
      return this._typeStack[this._typeStack.length - 1];
    }
  }

  getParentType() {
    if (this._parentTypeStack.length > 0) {
      return this._parentTypeStack[this._parentTypeStack.length - 1];
    }
  }

  getInputType() {
    if (this._inputTypeStack.length > 0) {
      return this._inputTypeStack[this._inputTypeStack.length - 1];
    }
  }

  getParentInputType() {
    if (this._inputTypeStack.length > 1) {
      return this._inputTypeStack[this._inputTypeStack.length - 2];
    }
  }

  getFieldDef() {
    if (this._fieldDefStack.length > 0) {
      return this._fieldDefStack[this._fieldDefStack.length - 1];
    }
  }

  getDefaultValue() {
    if (this._defaultValueStack.length > 0) {
      return this._defaultValueStack[this._defaultValueStack.length - 1];
    }
  }

  getDirective() {
    return this._directive;
  }

  getArgument() {
    return this._argument;
  }

  getEnumValue() {
    return this._enumValue;
  }

  enter(node) {
    const schema = this._schema; // Note: many of the types below are explicitly typed as "unknown" to drop
    // any assumptions of a valid schema to ensure runtime types are properly
    // checked before continuing since TypeInfo is used as part of validation
    // which occurs before guarantees of schema and document validity.

    switch (node.kind) {
      case Kind.SELECTION_SET: {
        const namedType = getNamedType(this.getType());

        this._parentTypeStack.push(
          isCompositeType(namedType) ? namedType : undefined,
        );

        break;
      }

      case Kind.FIELD: {
        const parentType = this.getParentType();
        let fieldDef;
        let fieldType;

        if (parentType) {
          fieldDef = this._getFieldDef(schema, parentType, node);

          if (fieldDef) {
            fieldType = fieldDef.type;
          }
        }

        this._fieldDefStack.push(fieldDef);

        this._typeStack.push(isOutputType(fieldType) ? fieldType : undefined);

        break;
      }

      case Kind.DIRECTIVE:
        this._directive = schema.getDirective(node.name.value);
        break;

      case Kind.OPERATION_DEFINITION: {
        const rootType = schema.getRootType(node.operation);

        this._typeStack.push(isObjectType(rootType) ? rootType : undefined);

        break;
      }

      case Kind.INLINE_FRAGMENT:
      case Kind.FRAGMENT_DEFINITION: {
        const typeConditionAST = node.typeCondition;
        const outputType = typeConditionAST
          ? typeFromAST(schema, typeConditionAST)
          : getNamedType(this.getType());

        this._typeStack.push(isOutputType(outputType) ? outputType : undefined);

        break;
      }

      case Kind.VARIABLE_DEFINITION: {
        const inputType = typeFromAST(schema, node.type);

        this._inputTypeStack.push(
          isInputType(inputType) ? inputType : undefined,
        );

        break;
      }

      case Kind.ARGUMENT: {
        var _this$getDirective;

        let argDef;
        let argType;
        const fieldOrDirective =
          (_this$getDirective = this.getDirective()) !== null &&
          _this$getDirective !== void 0
            ? _this$getDirective
            : this.getFieldDef();

        if (fieldOrDirective) {
          argDef = fieldOrDirective.args.find(
            (arg) => arg.name === node.name.value,
          );

          if (argDef) {
            argType = argDef.type;
          }
        }

        this._argument = argDef;

        this._defaultValueStack.push(argDef ? argDef.defaultValue : undefined);

        this._inputTypeStack.push(isInputType(argType) ? argType : undefined);

        break;
      }

      case Kind.LIST: {
        const listType = getNullableType(this.getInputType());
        const itemType = isListType(listType) ? listType.ofType : listType; // List positions never have a default value.

        this._defaultValueStack.push(undefined);

        this._inputTypeStack.push(isInputType(itemType) ? itemType : undefined);

        break;
      }

      case Kind.OBJECT_FIELD: {
        const objectType = getNamedType(this.getInputType());
        let inputFieldType;
        let inputField;

        if (isInputObjectType(objectType)) {
          inputField = objectType.getFields()[node.name.value];

          if (inputField) {
            inputFieldType = inputField.type;
          }
        }

        this._defaultValueStack.push(
          inputField ? inputField.defaultValue : undefined,
        );

        this._inputTypeStack.push(
          isInputType(inputFieldType) ? inputFieldType : undefined,
        );

        break;
      }

      case Kind.ENUM: {
        const enumType = getNamedType(this.getInputType());
        let enumValue;

        if (isEnumType(enumType)) {
          enumValue = enumType.getValue(node.value);
        }

        this._enumValue = enumValue;
        break;
      }

      default: // Ignore other nodes
    }
  }

  leave(node) {
    switch (node.kind) {
      case Kind.SELECTION_SET:
        this._parentTypeStack.pop();

        break;

      case Kind.FIELD:
        this._fieldDefStack.pop();

        this._typeStack.pop();

        break;

      case Kind.DIRECTIVE:
        this._directive = null;
        break;

      case Kind.OPERATION_DEFINITION:
      case Kind.INLINE_FRAGMENT:
      case Kind.FRAGMENT_DEFINITION:
        this._typeStack.pop();

        break;

      case Kind.VARIABLE_DEFINITION:
        this._inputTypeStack.pop();

        break;

      case Kind.ARGUMENT:
        this._argument = null;

        this._defaultValueStack.pop();

        this._inputTypeStack.pop();

        break;

      case Kind.LIST:
      case Kind.OBJECT_FIELD:
        this._defaultValueStack.pop();

        this._inputTypeStack.pop();

        break;

      case Kind.ENUM:
        this._enumValue = null;
        break;

      default: // Ignore other nodes
    }
  }
}

/**
 * Not exactly the same as the executor's definition of getFieldDef, in this
 * statically evaluated environment we do not always have an Object type,
 * and need to handle Interface and Union types.
 */
function getFieldDef(schema, parentType, fieldNode) {
  const name = fieldNode.name.value;

  if (
    name === SchemaMetaFieldDef.name &&
    schema.getQueryType() === parentType
  ) {
    return SchemaMetaFieldDef;
  }

  if (name === TypeMetaFieldDef.name && schema.getQueryType() === parentType) {
    return TypeMetaFieldDef;
  }

  if (name === TypeNameMetaFieldDef.name && isCompositeType(parentType)) {
    return TypeNameMetaFieldDef;
  }

  if (isObjectType(parentType) || isInterfaceType(parentType)) {
    return parentType.getFields()[name];
  }
}
/**
 * Creates a new visitor instance which maintains a provided TypeInfo instance
 * along with visiting visitor.
 */

function visitWithTypeInfo(typeInfo, visitor) {
  return {
    enter(...args) {
      const node = args[0];
      typeInfo.enter(node);
      const fn = getEnterLeaveForKind(visitor, node.kind).enter;

      if (fn) {
        const result = fn.apply(visitor, args);

        if (result !== undefined) {
          typeInfo.leave(node);

          if (isNode(result)) {
            typeInfo.enter(result);
          }
        }

        return result;
      }
    },

    leave(...args) {
      const node = args[0];
      const fn = getEnterLeaveForKind(visitor, node.kind).leave;
      let result;

      if (fn) {
        result = fn.apply(visitor, args);
      }

      typeInfo.leave(node);
      return result;
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/language/predicates.mjs

function isDefinitionNode(node) {
  return (
    isExecutableDefinitionNode(node) ||
    isTypeSystemDefinitionNode(node) ||
    isTypeSystemExtensionNode(node)
  );
}
function isExecutableDefinitionNode(node) {
  return (
    node.kind === Kind.OPERATION_DEFINITION ||
    node.kind === Kind.FRAGMENT_DEFINITION
  );
}
function isSelectionNode(node) {
  return (
    node.kind === Kind.FIELD ||
    node.kind === Kind.FRAGMENT_SPREAD ||
    node.kind === Kind.INLINE_FRAGMENT
  );
}
function isValueNode(node) {
  return (
    node.kind === Kind.VARIABLE ||
    node.kind === Kind.INT ||
    node.kind === Kind.FLOAT ||
    node.kind === Kind.STRING ||
    node.kind === Kind.BOOLEAN ||
    node.kind === Kind.NULL ||
    node.kind === Kind.ENUM ||
    node.kind === Kind.LIST ||
    node.kind === Kind.OBJECT
  );
}
function isConstValueNode(node) {
  return (
    isValueNode(node) &&
    (node.kind === Kind.LIST
      ? node.values.some(isConstValueNode)
      : node.kind === Kind.OBJECT
      ? node.fields.some((field) => isConstValueNode(field.value))
      : node.kind !== Kind.VARIABLE)
  );
}
function isTypeNode(node) {
  return (
    node.kind === Kind.NAMED_TYPE ||
    node.kind === Kind.LIST_TYPE ||
    node.kind === Kind.NON_NULL_TYPE
  );
}
function isTypeSystemDefinitionNode(node) {
  return (
    node.kind === Kind.SCHEMA_DEFINITION ||
    isTypeDefinitionNode(node) ||
    node.kind === Kind.DIRECTIVE_DEFINITION
  );
}
function isTypeDefinitionNode(node) {
  return (
    node.kind === Kind.SCALAR_TYPE_DEFINITION ||
    node.kind === Kind.OBJECT_TYPE_DEFINITION ||
    node.kind === Kind.INTERFACE_TYPE_DEFINITION ||
    node.kind === Kind.UNION_TYPE_DEFINITION ||
    node.kind === Kind.ENUM_TYPE_DEFINITION ||
    node.kind === Kind.INPUT_OBJECT_TYPE_DEFINITION
  );
}
function isTypeSystemExtensionNode(node) {
  return node.kind === Kind.SCHEMA_EXTENSION || isTypeExtensionNode(node);
}
function isTypeExtensionNode(node) {
  return (
    node.kind === Kind.SCALAR_TYPE_EXTENSION ||
    node.kind === Kind.OBJECT_TYPE_EXTENSION ||
    node.kind === Kind.INTERFACE_TYPE_EXTENSION ||
    node.kind === Kind.UNION_TYPE_EXTENSION ||
    node.kind === Kind.ENUM_TYPE_EXTENSION ||
    node.kind === Kind.INPUT_OBJECT_TYPE_EXTENSION
  );
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/ExecutableDefinitionsRule.mjs




/**
 * Executable definitions
 *
 * A GraphQL document is only valid for execution if all definitions are either
 * operation or fragment definitions.
 *
 * See https://spec.graphql.org/draft/#sec-Executable-Definitions
 */
function ExecutableDefinitionsRule(context) {
  return {
    Document(node) {
      for (const definition of node.definitions) {
        if (!isExecutableDefinitionNode(definition)) {
          const defName =
            definition.kind === Kind.SCHEMA_DEFINITION ||
            definition.kind === Kind.SCHEMA_EXTENSION
              ? 'schema'
              : '"' + definition.name.value + '"';
          context.reportError(
            new GraphQLError(`The ${defName} definition is not executable.`, {
              nodes: definition,
            }),
          );
        }
      }

      return false;
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/FieldsOnCorrectTypeRule.mjs






/**
 * Fields on correct type
 *
 * A GraphQL document is only valid if all fields selected are defined by the
 * parent type, or are an allowed meta field such as __typename.
 *
 * See https://spec.graphql.org/draft/#sec-Field-Selections
 */
function FieldsOnCorrectTypeRule(context) {
  return {
    Field(node) {
      const type = context.getParentType();

      if (type) {
        const fieldDef = context.getFieldDef();

        if (!fieldDef) {
          // This field doesn't exist, lets look for suggestions.
          const schema = context.getSchema();
          const fieldName = node.name.value; // First determine if there are any suggested types to condition on.

          let suggestion = didYouMean(
            'to use an inline fragment on',
            getSuggestedTypeNames(schema, type, fieldName),
          ); // If there are no suggested types, then perhaps this was a typo?

          if (suggestion === '') {
            suggestion = didYouMean(getSuggestedFieldNames(type, fieldName));
          } // Report an error, including helpful suggestions.

          context.reportError(
            new GraphQLError(
              `Cannot query field "${fieldName}" on type "${type.name}".` +
                suggestion,
              {
                nodes: node,
              },
            ),
          );
        }
      }
    },
  };
}
/**
 * Go through all of the implementations of type, as well as the interfaces that
 * they implement. If any of those types include the provided field, suggest them,
 * sorted by how often the type is referenced.
 */

function getSuggestedTypeNames(schema, type, fieldName) {
  if (!isAbstractType(type)) {
    // Must be an Object type, which does not have possible fields.
    return [];
  }

  const suggestedTypes = new Set();
  const usageCount = Object.create(null);

  for (const possibleType of schema.getPossibleTypes(type)) {
    if (!possibleType.getFields()[fieldName]) {
      continue;
    } // This object type defines this field.

    suggestedTypes.add(possibleType);
    usageCount[possibleType.name] = 1;

    for (const possibleInterface of possibleType.getInterfaces()) {
      var _usageCount$possibleI;

      if (!possibleInterface.getFields()[fieldName]) {
        continue;
      } // This interface type defines this field.

      suggestedTypes.add(possibleInterface);
      usageCount[possibleInterface.name] =
        ((_usageCount$possibleI = usageCount[possibleInterface.name]) !==
          null && _usageCount$possibleI !== void 0
          ? _usageCount$possibleI
          : 0) + 1;
    }
  }

  return [...suggestedTypes]
    .sort((typeA, typeB) => {
      // Suggest both interface and object types based on how common they are.
      const usageCountDiff = usageCount[typeB.name] - usageCount[typeA.name];

      if (usageCountDiff !== 0) {
        return usageCountDiff;
      } // Suggest super types first followed by subtypes

      if (isInterfaceType(typeA) && schema.isSubType(typeA, typeB)) {
        return -1;
      }

      if (isInterfaceType(typeB) && schema.isSubType(typeB, typeA)) {
        return 1;
      }

      return naturalCompare(typeA.name, typeB.name);
    })
    .map((x) => x.name);
}
/**
 * For the field name provided, determine if there are any similar field names
 * that may be the result of a typo.
 */

function getSuggestedFieldNames(type, fieldName) {
  if (isObjectType(type) || isInterfaceType(type)) {
    const possibleFieldNames = Object.keys(type.getFields());
    return suggestionList(fieldName, possibleFieldNames);
  } // Otherwise, must be a Union type, which does not define fields.

  return [];
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/FragmentsOnCompositeTypesRule.mjs





/**
 * Fragments on composite type
 *
 * Fragments use a type condition to determine if they apply, since fragments
 * can only be spread into a composite type (object, interface, or union), the
 * type condition must also be a composite type.
 *
 * See https://spec.graphql.org/draft/#sec-Fragments-On-Composite-Types
 */
function FragmentsOnCompositeTypesRule(context) {
  return {
    InlineFragment(node) {
      const typeCondition = node.typeCondition;

      if (typeCondition) {
        const type = typeFromAST(context.getSchema(), typeCondition);

        if (type && !isCompositeType(type)) {
          const typeStr = print(typeCondition);
          context.reportError(
            new GraphQLError(
              `Fragment cannot condition on non composite type "${typeStr}".`,
              {
                nodes: typeCondition,
              },
            ),
          );
        }
      }
    },

    FragmentDefinition(node) {
      const type = typeFromAST(context.getSchema(), node.typeCondition);

      if (type && !isCompositeType(type)) {
        const typeStr = print(node.typeCondition);
        context.reportError(
          new GraphQLError(
            `Fragment "${node.name.value}" cannot condition on non composite type "${typeStr}".`,
            {
              nodes: node.typeCondition,
            },
          ),
        );
      }
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/KnownArgumentNamesRule.mjs






/**
 * Known argument names
 *
 * A GraphQL field is only valid if all supplied arguments are defined by
 * that field.
 *
 * See https://spec.graphql.org/draft/#sec-Argument-Names
 * See https://spec.graphql.org/draft/#sec-Directives-Are-In-Valid-Locations
 */
function KnownArgumentNamesRule(context) {
  return {
    // eslint-disable-next-line new-cap
    ...KnownArgumentNamesOnDirectivesRule(context),

    Argument(argNode) {
      const argDef = context.getArgument();
      const fieldDef = context.getFieldDef();
      const parentType = context.getParentType();

      if (!argDef && fieldDef && parentType) {
        const argName = argNode.name.value;
        const knownArgsNames = fieldDef.args.map((arg) => arg.name);
        const suggestions = suggestionList(argName, knownArgsNames);
        context.reportError(
          new GraphQLError(
            `Unknown argument "${argName}" on field "${parentType.name}.${fieldDef.name}".` +
              didYouMean(suggestions),
            {
              nodes: argNode,
            },
          ),
        );
      }
    },
  };
}
/**
 * @internal
 */

function KnownArgumentNamesOnDirectivesRule(context) {
  const directiveArgs = Object.create(null);
  const schema = context.getSchema();
  const definedDirectives = schema
    ? schema.getDirectives()
    : specifiedDirectives;

  for (const directive of definedDirectives) {
    directiveArgs[directive.name] = directive.args.map((arg) => arg.name);
  }

  const astDefinitions = context.getDocument().definitions;

  for (const def of astDefinitions) {
    if (def.kind === Kind.DIRECTIVE_DEFINITION) {
      var _def$arguments;

      // FIXME: https://github.com/graphql/graphql-js/issues/2203

      /* c8 ignore next */
      const argsNodes =
        (_def$arguments = def.arguments) !== null && _def$arguments !== void 0
          ? _def$arguments
          : [];
      directiveArgs[def.name.value] = argsNodes.map((arg) => arg.name.value);
    }
  }

  return {
    Directive(directiveNode) {
      const directiveName = directiveNode.name.value;
      const knownArgs = directiveArgs[directiveName];

      if (directiveNode.arguments && knownArgs) {
        for (const argNode of directiveNode.arguments) {
          const argName = argNode.name.value;

          if (!knownArgs.includes(argName)) {
            const suggestions = suggestionList(argName, knownArgs);
            context.reportError(
              new GraphQLError(
                `Unknown argument "${argName}" on directive "@${directiveName}".` +
                  didYouMean(suggestions),
                {
                  nodes: argNode,
                },
              ),
            );
          }
        }
      }

      return false;
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/KnownDirectivesRule.mjs








/**
 * Known directives
 *
 * A GraphQL document is only valid if all `@directives` are known by the
 * schema and legally positioned.
 *
 * See https://spec.graphql.org/draft/#sec-Directives-Are-Defined
 */
function KnownDirectivesRule(context) {
  const locationsMap = Object.create(null);
  const schema = context.getSchema();
  const definedDirectives = schema
    ? schema.getDirectives()
    : specifiedDirectives;

  for (const directive of definedDirectives) {
    locationsMap[directive.name] = directive.locations;
  }

  const astDefinitions = context.getDocument().definitions;

  for (const def of astDefinitions) {
    if (def.kind === Kind.DIRECTIVE_DEFINITION) {
      locationsMap[def.name.value] = def.locations.map((name) => name.value);
    }
  }

  return {
    Directive(node, _key, _parent, _path, ancestors) {
      const name = node.name.value;
      const locations = locationsMap[name];

      if (!locations) {
        context.reportError(
          new GraphQLError(`Unknown directive "@${name}".`, {
            nodes: node,
          }),
        );
        return;
      }

      const candidateLocation = getDirectiveLocationForASTPath(ancestors);

      if (candidateLocation && !locations.includes(candidateLocation)) {
        context.reportError(
          new GraphQLError(
            `Directive "@${name}" may not be used on ${candidateLocation}.`,
            {
              nodes: node,
            },
          ),
        );
      }
    },
  };
}

function getDirectiveLocationForASTPath(ancestors) {
  const appliedTo = ancestors[ancestors.length - 1];
  'kind' in appliedTo || invariant(false);

  switch (appliedTo.kind) {
    case Kind.OPERATION_DEFINITION:
      return getDirectiveLocationForOperation(appliedTo.operation);

    case Kind.FIELD:
      return DirectiveLocation.FIELD;

    case Kind.FRAGMENT_SPREAD:
      return DirectiveLocation.FRAGMENT_SPREAD;

    case Kind.INLINE_FRAGMENT:
      return DirectiveLocation.INLINE_FRAGMENT;

    case Kind.FRAGMENT_DEFINITION:
      return DirectiveLocation.FRAGMENT_DEFINITION;

    case Kind.VARIABLE_DEFINITION:
      return DirectiveLocation.VARIABLE_DEFINITION;

    case Kind.SCHEMA_DEFINITION:
    case Kind.SCHEMA_EXTENSION:
      return DirectiveLocation.SCHEMA;

    case Kind.SCALAR_TYPE_DEFINITION:
    case Kind.SCALAR_TYPE_EXTENSION:
      return DirectiveLocation.SCALAR;

    case Kind.OBJECT_TYPE_DEFINITION:
    case Kind.OBJECT_TYPE_EXTENSION:
      return DirectiveLocation.OBJECT;

    case Kind.FIELD_DEFINITION:
      return DirectiveLocation.FIELD_DEFINITION;

    case Kind.INTERFACE_TYPE_DEFINITION:
    case Kind.INTERFACE_TYPE_EXTENSION:
      return DirectiveLocation.INTERFACE;

    case Kind.UNION_TYPE_DEFINITION:
    case Kind.UNION_TYPE_EXTENSION:
      return DirectiveLocation.UNION;

    case Kind.ENUM_TYPE_DEFINITION:
    case Kind.ENUM_TYPE_EXTENSION:
      return DirectiveLocation.ENUM;

    case Kind.ENUM_VALUE_DEFINITION:
      return DirectiveLocation.ENUM_VALUE;

    case Kind.INPUT_OBJECT_TYPE_DEFINITION:
    case Kind.INPUT_OBJECT_TYPE_EXTENSION:
      return DirectiveLocation.INPUT_OBJECT;

    case Kind.INPUT_VALUE_DEFINITION: {
      const parentNode = ancestors[ancestors.length - 3];
      'kind' in parentNode || invariant(false);
      return parentNode.kind === Kind.INPUT_OBJECT_TYPE_DEFINITION
        ? DirectiveLocation.INPUT_FIELD_DEFINITION
        : DirectiveLocation.ARGUMENT_DEFINITION;
    }
    // Not reachable, all possible types have been considered.

    /* c8 ignore next */

    default:
       false || invariant(false, 'Unexpected kind: ' + inspect(appliedTo.kind));
  }
}

function getDirectiveLocationForOperation(operation) {
  switch (operation) {
    case OperationTypeNode.QUERY:
      return DirectiveLocation.QUERY;

    case OperationTypeNode.MUTATION:
      return DirectiveLocation.MUTATION;

    case OperationTypeNode.SUBSCRIPTION:
      return DirectiveLocation.SUBSCRIPTION;
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/KnownFragmentNamesRule.mjs


/**
 * Known fragment names
 *
 * A GraphQL document is only valid if all `...Fragment` fragment spreads refer
 * to fragments defined in the same document.
 *
 * See https://spec.graphql.org/draft/#sec-Fragment-spread-target-defined
 */
function KnownFragmentNamesRule(context) {
  return {
    FragmentSpread(node) {
      const fragmentName = node.name.value;
      const fragment = context.getFragment(fragmentName);

      if (!fragment) {
        context.reportError(
          new GraphQLError(`Unknown fragment "${fragmentName}".`, {
            nodes: node.name,
          }),
        );
      }
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/KnownTypeNamesRule.mjs







/**
 * Known type names
 *
 * A GraphQL document is only valid if referenced types (specifically
 * variable definitions and fragment conditions) are defined by the type schema.
 *
 * See https://spec.graphql.org/draft/#sec-Fragment-Spread-Type-Existence
 */
function KnownTypeNamesRule(context) {
  const schema = context.getSchema();
  const existingTypesMap = schema ? schema.getTypeMap() : Object.create(null);
  const definedTypes = Object.create(null);

  for (const def of context.getDocument().definitions) {
    if (isTypeDefinitionNode(def)) {
      definedTypes[def.name.value] = true;
    }
  }

  const typeNames = [
    ...Object.keys(existingTypesMap),
    ...Object.keys(definedTypes),
  ];
  return {
    NamedType(node, _1, parent, _2, ancestors) {
      const typeName = node.name.value;

      if (!existingTypesMap[typeName] && !definedTypes[typeName]) {
        var _ancestors$;

        const definitionNode =
          (_ancestors$ = ancestors[2]) !== null && _ancestors$ !== void 0
            ? _ancestors$
            : parent;
        const isSDL = definitionNode != null && isSDLNode(definitionNode);

        if (isSDL && standardTypeNames.includes(typeName)) {
          return;
        }

        const suggestedTypes = suggestionList(
          typeName,
          isSDL ? standardTypeNames.concat(typeNames) : typeNames,
        );
        context.reportError(
          new GraphQLError(
            `Unknown type "${typeName}".` + didYouMean(suggestedTypes),
            {
              nodes: node,
            },
          ),
        );
      }
    },
  };
}
const standardTypeNames = [...specifiedScalarTypes, ...introspectionTypes].map(
  (type) => type.name,
);

function isSDLNode(value) {
  return (
    'kind' in value &&
    (isTypeSystemDefinitionNode(value) || isTypeSystemExtensionNode(value))
  );
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/LoneAnonymousOperationRule.mjs



/**
 * Lone anonymous operation
 *
 * A GraphQL document is only valid if when it contains an anonymous operation
 * (the query short-hand) that it contains only that one operation definition.
 *
 * See https://spec.graphql.org/draft/#sec-Lone-Anonymous-Operation
 */
function LoneAnonymousOperationRule(context) {
  let operationCount = 0;
  return {
    Document(node) {
      operationCount = node.definitions.filter(
        (definition) => definition.kind === Kind.OPERATION_DEFINITION,
      ).length;
    },

    OperationDefinition(node) {
      if (!node.name && operationCount > 1) {
        context.reportError(
          new GraphQLError(
            'This anonymous operation must be the only defined operation.',
            {
              nodes: node,
            },
          ),
        );
      }
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/LoneSchemaDefinitionRule.mjs


/**
 * Lone Schema definition
 *
 * A GraphQL document is only valid if it contains only one schema definition.
 */
function LoneSchemaDefinitionRule(context) {
  var _ref, _ref2, _oldSchema$astNode;

  const oldSchema = context.getSchema();
  const alreadyDefined =
    (_ref =
      (_ref2 =
        (_oldSchema$astNode =
          oldSchema === null || oldSchema === void 0
            ? void 0
            : oldSchema.astNode) !== null && _oldSchema$astNode !== void 0
          ? _oldSchema$astNode
          : oldSchema === null || oldSchema === void 0
          ? void 0
          : oldSchema.getQueryType()) !== null && _ref2 !== void 0
        ? _ref2
        : oldSchema === null || oldSchema === void 0
        ? void 0
        : oldSchema.getMutationType()) !== null && _ref !== void 0
      ? _ref
      : oldSchema === null || oldSchema === void 0
      ? void 0
      : oldSchema.getSubscriptionType();
  let schemaDefinitionsCount = 0;
  return {
    SchemaDefinition(node) {
      if (alreadyDefined) {
        context.reportError(
          new GraphQLError(
            'Cannot define a new schema within a schema extension.',
            {
              nodes: node,
            },
          ),
        );
        return;
      }

      if (schemaDefinitionsCount > 0) {
        context.reportError(
          new GraphQLError('Must provide only one schema definition.', {
            nodes: node,
          }),
        );
      }

      ++schemaDefinitionsCount;
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/NoFragmentCyclesRule.mjs


/**
 * No fragment cycles
 *
 * The graph of fragment spreads must not form any cycles including spreading itself.
 * Otherwise an operation could infinitely spread or infinitely execute on cycles in the underlying data.
 *
 * See https://spec.graphql.org/draft/#sec-Fragment-spreads-must-not-form-cycles
 */
function NoFragmentCyclesRule(context) {
  // Tracks already visited fragments to maintain O(N) and to ensure that cycles
  // are not redundantly reported.
  const visitedFrags = Object.create(null); // Array of AST nodes used to produce meaningful errors

  const spreadPath = []; // Position in the spread path

  const spreadPathIndexByName = Object.create(null);
  return {
    OperationDefinition: () => false,

    FragmentDefinition(node) {
      detectCycleRecursive(node);
      return false;
    },
  }; // This does a straight-forward DFS to find cycles.
  // It does not terminate when a cycle was found but continues to explore
  // the graph to find all possible cycles.

  function detectCycleRecursive(fragment) {
    if (visitedFrags[fragment.name.value]) {
      return;
    }

    const fragmentName = fragment.name.value;
    visitedFrags[fragmentName] = true;
    const spreadNodes = context.getFragmentSpreads(fragment.selectionSet);

    if (spreadNodes.length === 0) {
      return;
    }

    spreadPathIndexByName[fragmentName] = spreadPath.length;

    for (const spreadNode of spreadNodes) {
      const spreadName = spreadNode.name.value;
      const cycleIndex = spreadPathIndexByName[spreadName];
      spreadPath.push(spreadNode);

      if (cycleIndex === undefined) {
        const spreadFragment = context.getFragment(spreadName);

        if (spreadFragment) {
          detectCycleRecursive(spreadFragment);
        }
      } else {
        const cyclePath = spreadPath.slice(cycleIndex);
        const viaPath = cyclePath
          .slice(0, -1)
          .map((s) => '"' + s.name.value + '"')
          .join(', ');
        context.reportError(
          new GraphQLError(
            `Cannot spread fragment "${spreadName}" within itself` +
              (viaPath !== '' ? ` via ${viaPath}.` : '.'),
            {
              nodes: cyclePath,
            },
          ),
        );
      }

      spreadPath.pop();
    }

    spreadPathIndexByName[fragmentName] = undefined;
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/NoUndefinedVariablesRule.mjs


/**
 * No undefined variables
 *
 * A GraphQL operation is only valid if all variables encountered, both directly
 * and via fragment spreads, are defined by that operation.
 *
 * See https://spec.graphql.org/draft/#sec-All-Variable-Uses-Defined
 */
function NoUndefinedVariablesRule(context) {
  let variableNameDefined = Object.create(null);
  return {
    OperationDefinition: {
      enter() {
        variableNameDefined = Object.create(null);
      },

      leave(operation) {
        const usages = context.getRecursiveVariableUsages(operation);

        for (const { node } of usages) {
          const varName = node.name.value;

          if (variableNameDefined[varName] !== true) {
            context.reportError(
              new GraphQLError(
                operation.name
                  ? `Variable "$${varName}" is not defined by operation "${operation.name.value}".`
                  : `Variable "$${varName}" is not defined.`,
                {
                  nodes: [node, operation],
                },
              ),
            );
          }
        }
      },
    },

    VariableDefinition(node) {
      variableNameDefined[node.variable.name.value] = true;
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/NoUnusedFragmentsRule.mjs


/**
 * No unused fragments
 *
 * A GraphQL document is only valid if all fragment definitions are spread
 * within operations, or spread within other fragments spread within operations.
 *
 * See https://spec.graphql.org/draft/#sec-Fragments-Must-Be-Used
 */
function NoUnusedFragmentsRule(context) {
  const operationDefs = [];
  const fragmentDefs = [];
  return {
    OperationDefinition(node) {
      operationDefs.push(node);
      return false;
    },

    FragmentDefinition(node) {
      fragmentDefs.push(node);
      return false;
    },

    Document: {
      leave() {
        const fragmentNameUsed = Object.create(null);

        for (const operation of operationDefs) {
          for (const fragment of context.getRecursivelyReferencedFragments(
            operation,
          )) {
            fragmentNameUsed[fragment.name.value] = true;
          }
        }

        for (const fragmentDef of fragmentDefs) {
          const fragName = fragmentDef.name.value;

          if (fragmentNameUsed[fragName] !== true) {
            context.reportError(
              new GraphQLError(`Fragment "${fragName}" is never used.`, {
                nodes: fragmentDef,
              }),
            );
          }
        }
      },
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/NoUnusedVariablesRule.mjs


/**
 * No unused variables
 *
 * A GraphQL operation is only valid if all variables defined by an operation
 * are used, either directly or within a spread fragment.
 *
 * See https://spec.graphql.org/draft/#sec-All-Variables-Used
 */
function NoUnusedVariablesRule(context) {
  let variableDefs = [];
  return {
    OperationDefinition: {
      enter() {
        variableDefs = [];
      },

      leave(operation) {
        const variableNameUsed = Object.create(null);
        const usages = context.getRecursiveVariableUsages(operation);

        for (const { node } of usages) {
          variableNameUsed[node.name.value] = true;
        }

        for (const variableDef of variableDefs) {
          const variableName = variableDef.variable.name.value;

          if (variableNameUsed[variableName] !== true) {
            context.reportError(
              new GraphQLError(
                operation.name
                  ? `Variable "$${variableName}" is never used in operation "${operation.name.value}".`
                  : `Variable "$${variableName}" is never used.`,
                {
                  nodes: variableDef,
                },
              ),
            );
          }
        }
      },
    },

    VariableDefinition(def) {
      variableDefs.push(def);
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/sortValueNode.mjs


/**
 * Sort ValueNode.
 *
 * This function returns a sorted copy of the given ValueNode.
 *
 * @internal
 */

function sortValueNode(valueNode) {
  switch (valueNode.kind) {
    case Kind.OBJECT:
      return { ...valueNode, fields: sortFields(valueNode.fields) };

    case Kind.LIST:
      return { ...valueNode, values: valueNode.values.map(sortValueNode) };

    case Kind.INT:
    case Kind.FLOAT:
    case Kind.STRING:
    case Kind.BOOLEAN:
    case Kind.NULL:
    case Kind.ENUM:
    case Kind.VARIABLE:
      return valueNode;
  }
}

function sortFields(fields) {
  return fields
    .map((fieldNode) => ({
      ...fieldNode,
      value: sortValueNode(fieldNode.value),
    }))
    .sort((fieldA, fieldB) =>
      naturalCompare(fieldA.name.value, fieldB.name.value),
    );
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/OverlappingFieldsCanBeMergedRule.mjs








function reasonMessage(reason) {
  if (Array.isArray(reason)) {
    return reason
      .map(
        ([responseName, subReason]) =>
          `subfields "${responseName}" conflict because ` +
          reasonMessage(subReason),
      )
      .join(' and ');
  }

  return reason;
}
/**
 * Overlapping fields can be merged
 *
 * A selection set is only valid if all fields (including spreading any
 * fragments) either correspond to distinct response names or can be merged
 * without ambiguity.
 *
 * See https://spec.graphql.org/draft/#sec-Field-Selection-Merging
 */

function OverlappingFieldsCanBeMergedRule(context) {
  // A memoization for when two fragments are compared "between" each other for
  // conflicts. Two fragments may be compared many times, so memoizing this can
  // dramatically improve the performance of this validator.
  const comparedFragmentPairs = new PairSet(); // A cache for the "field map" and list of fragment names found in any given
  // selection set. Selection sets may be asked for this information multiple
  // times, so this improves the performance of this validator.

  const cachedFieldsAndFragmentNames = new Map();
  return {
    SelectionSet(selectionSet) {
      const conflicts = findConflictsWithinSelectionSet(
        context,
        cachedFieldsAndFragmentNames,
        comparedFragmentPairs,
        context.getParentType(),
        selectionSet,
      );

      for (const [[responseName, reason], fields1, fields2] of conflicts) {
        const reasonMsg = reasonMessage(reason);
        context.reportError(
          new GraphQLError(
            `Fields "${responseName}" conflict because ${reasonMsg}. Use different aliases on the fields to fetch both if this was intentional.`,
            {
              nodes: fields1.concat(fields2),
            },
          ),
        );
      }
    },
  };
}

/**
 * Algorithm:
 *
 * Conflicts occur when two fields exist in a query which will produce the same
 * response name, but represent differing values, thus creating a conflict.
 * The algorithm below finds all conflicts via making a series of comparisons
 * between fields. In order to compare as few fields as possible, this makes
 * a series of comparisons "within" sets of fields and "between" sets of fields.
 *
 * Given any selection set, a collection produces both a set of fields by
 * also including all inline fragments, as well as a list of fragments
 * referenced by fragment spreads.
 *
 * A) Each selection set represented in the document first compares "within" its
 * collected set of fields, finding any conflicts between every pair of
 * overlapping fields.
 * Note: This is the *only time* that a the fields "within" a set are compared
 * to each other. After this only fields "between" sets are compared.
 *
 * B) Also, if any fragment is referenced in a selection set, then a
 * comparison is made "between" the original set of fields and the
 * referenced fragment.
 *
 * C) Also, if multiple fragments are referenced, then comparisons
 * are made "between" each referenced fragment.
 *
 * D) When comparing "between" a set of fields and a referenced fragment, first
 * a comparison is made between each field in the original set of fields and
 * each field in the the referenced set of fields.
 *
 * E) Also, if any fragment is referenced in the referenced selection set,
 * then a comparison is made "between" the original set of fields and the
 * referenced fragment (recursively referring to step D).
 *
 * F) When comparing "between" two fragments, first a comparison is made between
 * each field in the first referenced set of fields and each field in the the
 * second referenced set of fields.
 *
 * G) Also, any fragments referenced by the first must be compared to the
 * second, and any fragments referenced by the second must be compared to the
 * first (recursively referring to step F).
 *
 * H) When comparing two fields, if both have selection sets, then a comparison
 * is made "between" both selection sets, first comparing the set of fields in
 * the first selection set with the set of fields in the second.
 *
 * I) Also, if any fragment is referenced in either selection set, then a
 * comparison is made "between" the other set of fields and the
 * referenced fragment.
 *
 * J) Also, if two fragments are referenced in both selection sets, then a
 * comparison is made "between" the two fragments.
 *
 */
// Find all conflicts found "within" a selection set, including those found
// via spreading in fragments. Called when visiting each SelectionSet in the
// GraphQL Document.
function findConflictsWithinSelectionSet(
  context,
  cachedFieldsAndFragmentNames,
  comparedFragmentPairs,
  parentType,
  selectionSet,
) {
  const conflicts = [];
  const [fieldMap, fragmentNames] = getFieldsAndFragmentNames(
    context,
    cachedFieldsAndFragmentNames,
    parentType,
    selectionSet,
  ); // (A) Find find all conflicts "within" the fields of this selection set.
  // Note: this is the *only place* `collectConflictsWithin` is called.

  collectConflictsWithin(
    context,
    conflicts,
    cachedFieldsAndFragmentNames,
    comparedFragmentPairs,
    fieldMap,
  );

  if (fragmentNames.length !== 0) {
    // (B) Then collect conflicts between these fields and those represented by
    // each spread fragment name found.
    for (let i = 0; i < fragmentNames.length; i++) {
      collectConflictsBetweenFieldsAndFragment(
        context,
        conflicts,
        cachedFieldsAndFragmentNames,
        comparedFragmentPairs,
        false,
        fieldMap,
        fragmentNames[i],
      ); // (C) Then compare this fragment with all other fragments found in this
      // selection set to collect conflicts between fragments spread together.
      // This compares each item in the list of fragment names to every other
      // item in that same list (except for itself).

      for (let j = i + 1; j < fragmentNames.length; j++) {
        collectConflictsBetweenFragments(
          context,
          conflicts,
          cachedFieldsAndFragmentNames,
          comparedFragmentPairs,
          false,
          fragmentNames[i],
          fragmentNames[j],
        );
      }
    }
  }

  return conflicts;
} // Collect all conflicts found between a set of fields and a fragment reference
// including via spreading in any nested fragments.

function collectConflictsBetweenFieldsAndFragment(
  context,
  conflicts,
  cachedFieldsAndFragmentNames,
  comparedFragmentPairs,
  areMutuallyExclusive,
  fieldMap,
  fragmentName,
) {
  const fragment = context.getFragment(fragmentName);

  if (!fragment) {
    return;
  }

  const [fieldMap2, referencedFragmentNames] =
    getReferencedFieldsAndFragmentNames(
      context,
      cachedFieldsAndFragmentNames,
      fragment,
    ); // Do not compare a fragment's fieldMap to itself.

  if (fieldMap === fieldMap2) {
    return;
  } // (D) First collect any conflicts between the provided collection of fields
  // and the collection of fields represented by the given fragment.

  collectConflictsBetween(
    context,
    conflicts,
    cachedFieldsAndFragmentNames,
    comparedFragmentPairs,
    areMutuallyExclusive,
    fieldMap,
    fieldMap2,
  ); // (E) Then collect any conflicts between the provided collection of fields
  // and any fragment names found in the given fragment.

  for (const referencedFragmentName of referencedFragmentNames) {
    // Memoize so two fragments are not compared for conflicts more than once.
    if (
      comparedFragmentPairs.has(
        referencedFragmentName,
        fragmentName,
        areMutuallyExclusive,
      )
    ) {
      continue;
    }

    comparedFragmentPairs.add(
      referencedFragmentName,
      fragmentName,
      areMutuallyExclusive,
    );
    collectConflictsBetweenFieldsAndFragment(
      context,
      conflicts,
      cachedFieldsAndFragmentNames,
      comparedFragmentPairs,
      areMutuallyExclusive,
      fieldMap,
      referencedFragmentName,
    );
  }
} // Collect all conflicts found between two fragments, including via spreading in
// any nested fragments.

function collectConflictsBetweenFragments(
  context,
  conflicts,
  cachedFieldsAndFragmentNames,
  comparedFragmentPairs,
  areMutuallyExclusive,
  fragmentName1,
  fragmentName2,
) {
  // No need to compare a fragment to itself.
  if (fragmentName1 === fragmentName2) {
    return;
  } // Memoize so two fragments are not compared for conflicts more than once.

  if (
    comparedFragmentPairs.has(
      fragmentName1,
      fragmentName2,
      areMutuallyExclusive,
    )
  ) {
    return;
  }

  comparedFragmentPairs.add(fragmentName1, fragmentName2, areMutuallyExclusive);
  const fragment1 = context.getFragment(fragmentName1);
  const fragment2 = context.getFragment(fragmentName2);

  if (!fragment1 || !fragment2) {
    return;
  }

  const [fieldMap1, referencedFragmentNames1] =
    getReferencedFieldsAndFragmentNames(
      context,
      cachedFieldsAndFragmentNames,
      fragment1,
    );
  const [fieldMap2, referencedFragmentNames2] =
    getReferencedFieldsAndFragmentNames(
      context,
      cachedFieldsAndFragmentNames,
      fragment2,
    ); // (F) First, collect all conflicts between these two collections of fields
  // (not including any nested fragments).

  collectConflictsBetween(
    context,
    conflicts,
    cachedFieldsAndFragmentNames,
    comparedFragmentPairs,
    areMutuallyExclusive,
    fieldMap1,
    fieldMap2,
  ); // (G) Then collect conflicts between the first fragment and any nested
  // fragments spread in the second fragment.

  for (const referencedFragmentName2 of referencedFragmentNames2) {
    collectConflictsBetweenFragments(
      context,
      conflicts,
      cachedFieldsAndFragmentNames,
      comparedFragmentPairs,
      areMutuallyExclusive,
      fragmentName1,
      referencedFragmentName2,
    );
  } // (G) Then collect conflicts between the second fragment and any nested
  // fragments spread in the first fragment.

  for (const referencedFragmentName1 of referencedFragmentNames1) {
    collectConflictsBetweenFragments(
      context,
      conflicts,
      cachedFieldsAndFragmentNames,
      comparedFragmentPairs,
      areMutuallyExclusive,
      referencedFragmentName1,
      fragmentName2,
    );
  }
} // Find all conflicts found between two selection sets, including those found
// via spreading in fragments. Called when determining if conflicts exist
// between the sub-fields of two overlapping fields.

function findConflictsBetweenSubSelectionSets(
  context,
  cachedFieldsAndFragmentNames,
  comparedFragmentPairs,
  areMutuallyExclusive,
  parentType1,
  selectionSet1,
  parentType2,
  selectionSet2,
) {
  const conflicts = [];
  const [fieldMap1, fragmentNames1] = getFieldsAndFragmentNames(
    context,
    cachedFieldsAndFragmentNames,
    parentType1,
    selectionSet1,
  );
  const [fieldMap2, fragmentNames2] = getFieldsAndFragmentNames(
    context,
    cachedFieldsAndFragmentNames,
    parentType2,
    selectionSet2,
  ); // (H) First, collect all conflicts between these two collections of field.

  collectConflictsBetween(
    context,
    conflicts,
    cachedFieldsAndFragmentNames,
    comparedFragmentPairs,
    areMutuallyExclusive,
    fieldMap1,
    fieldMap2,
  ); // (I) Then collect conflicts between the first collection of fields and
  // those referenced by each fragment name associated with the second.

  for (const fragmentName2 of fragmentNames2) {
    collectConflictsBetweenFieldsAndFragment(
      context,
      conflicts,
      cachedFieldsAndFragmentNames,
      comparedFragmentPairs,
      areMutuallyExclusive,
      fieldMap1,
      fragmentName2,
    );
  } // (I) Then collect conflicts between the second collection of fields and
  // those referenced by each fragment name associated with the first.

  for (const fragmentName1 of fragmentNames1) {
    collectConflictsBetweenFieldsAndFragment(
      context,
      conflicts,
      cachedFieldsAndFragmentNames,
      comparedFragmentPairs,
      areMutuallyExclusive,
      fieldMap2,
      fragmentName1,
    );
  } // (J) Also collect conflicts between any fragment names by the first and
  // fragment names by the second. This compares each item in the first set of
  // names to each item in the second set of names.

  for (const fragmentName1 of fragmentNames1) {
    for (const fragmentName2 of fragmentNames2) {
      collectConflictsBetweenFragments(
        context,
        conflicts,
        cachedFieldsAndFragmentNames,
        comparedFragmentPairs,
        areMutuallyExclusive,
        fragmentName1,
        fragmentName2,
      );
    }
  }

  return conflicts;
} // Collect all Conflicts "within" one collection of fields.

function collectConflictsWithin(
  context,
  conflicts,
  cachedFieldsAndFragmentNames,
  comparedFragmentPairs,
  fieldMap,
) {
  // A field map is a keyed collection, where each key represents a response
  // name and the value at that key is a list of all fields which provide that
  // response name. For every response name, if there are multiple fields, they
  // must be compared to find a potential conflict.
  for (const [responseName, fields] of Object.entries(fieldMap)) {
    // This compares every field in the list to every other field in this list
    // (except to itself). If the list only has one item, nothing needs to
    // be compared.
    if (fields.length > 1) {
      for (let i = 0; i < fields.length; i++) {
        for (let j = i + 1; j < fields.length; j++) {
          const conflict = findConflict(
            context,
            cachedFieldsAndFragmentNames,
            comparedFragmentPairs,
            false, // within one collection is never mutually exclusive
            responseName,
            fields[i],
            fields[j],
          );

          if (conflict) {
            conflicts.push(conflict);
          }
        }
      }
    }
  }
} // Collect all Conflicts between two collections of fields. This is similar to,
// but different from the `collectConflictsWithin` function above. This check
// assumes that `collectConflictsWithin` has already been called on each
// provided collection of fields. This is true because this validator traverses
// each individual selection set.

function collectConflictsBetween(
  context,
  conflicts,
  cachedFieldsAndFragmentNames,
  comparedFragmentPairs,
  parentFieldsAreMutuallyExclusive,
  fieldMap1,
  fieldMap2,
) {
  // A field map is a keyed collection, where each key represents a response
  // name and the value at that key is a list of all fields which provide that
  // response name. For any response name which appears in both provided field
  // maps, each field from the first field map must be compared to every field
  // in the second field map to find potential conflicts.
  for (const [responseName, fields1] of Object.entries(fieldMap1)) {
    const fields2 = fieldMap2[responseName];

    if (fields2) {
      for (const field1 of fields1) {
        for (const field2 of fields2) {
          const conflict = findConflict(
            context,
            cachedFieldsAndFragmentNames,
            comparedFragmentPairs,
            parentFieldsAreMutuallyExclusive,
            responseName,
            field1,
            field2,
          );

          if (conflict) {
            conflicts.push(conflict);
          }
        }
      }
    }
  }
} // Determines if there is a conflict between two particular fields, including
// comparing their sub-fields.

function findConflict(
  context,
  cachedFieldsAndFragmentNames,
  comparedFragmentPairs,
  parentFieldsAreMutuallyExclusive,
  responseName,
  field1,
  field2,
) {
  const [parentType1, node1, def1] = field1;
  const [parentType2, node2, def2] = field2; // If it is known that two fields could not possibly apply at the same
  // time, due to the parent types, then it is safe to permit them to diverge
  // in aliased field or arguments used as they will not present any ambiguity
  // by differing.
  // It is known that two parent types could never overlap if they are
  // different Object types. Interface or Union types might overlap - if not
  // in the current state of the schema, then perhaps in some future version,
  // thus may not safely diverge.

  const areMutuallyExclusive =
    parentFieldsAreMutuallyExclusive ||
    (parentType1 !== parentType2 &&
      isObjectType(parentType1) &&
      isObjectType(parentType2));

  if (!areMutuallyExclusive) {
    // Two aliases must refer to the same field.
    const name1 = node1.name.value;
    const name2 = node2.name.value;

    if (name1 !== name2) {
      return [
        [responseName, `"${name1}" and "${name2}" are different fields`],
        [node1],
        [node2],
      ];
    } // Two field calls must have the same arguments.

    if (!sameArguments(node1, node2)) {
      return [
        [responseName, 'they have differing arguments'],
        [node1],
        [node2],
      ];
    }
  } // The return type for each field.

  const type1 = def1 === null || def1 === void 0 ? void 0 : def1.type;
  const type2 = def2 === null || def2 === void 0 ? void 0 : def2.type;

  if (type1 && type2 && doTypesConflict(type1, type2)) {
    return [
      [
        responseName,
        `they return conflicting types "${inspect(type1)}" and "${inspect(
          type2,
        )}"`,
      ],
      [node1],
      [node2],
    ];
  } // Collect and compare sub-fields. Use the same "visited fragment names" list
  // for both collections so fields in a fragment reference are never
  // compared to themselves.

  const selectionSet1 = node1.selectionSet;
  const selectionSet2 = node2.selectionSet;

  if (selectionSet1 && selectionSet2) {
    const conflicts = findConflictsBetweenSubSelectionSets(
      context,
      cachedFieldsAndFragmentNames,
      comparedFragmentPairs,
      areMutuallyExclusive,
      getNamedType(type1),
      selectionSet1,
      getNamedType(type2),
      selectionSet2,
    );
    return subfieldConflicts(conflicts, responseName, node1, node2);
  }
}

function sameArguments(node1, node2) {
  const args1 = node1.arguments;
  const args2 = node2.arguments;

  if (args1 === undefined || args1.length === 0) {
    return args2 === undefined || args2.length === 0;
  }

  if (args2 === undefined || args2.length === 0) {
    return false;
  }
  /* c8 ignore next */

  if (args1.length !== args2.length) {
    /* c8 ignore next */
    return false;
    /* c8 ignore next */
  }

  const values2 = new Map(args2.map(({ name, value }) => [name.value, value]));
  return args1.every((arg1) => {
    const value1 = arg1.value;
    const value2 = values2.get(arg1.name.value);

    if (value2 === undefined) {
      return false;
    }

    return stringifyValue(value1) === stringifyValue(value2);
  });
}

function stringifyValue(value) {
  return print(sortValueNode(value));
} // Two types conflict if both types could not apply to a value simultaneously.
// Composite types are ignored as their individual field types will be compared
// later recursively. However List and Non-Null types must match.

function doTypesConflict(type1, type2) {
  if (isListType(type1)) {
    return isListType(type2)
      ? doTypesConflict(type1.ofType, type2.ofType)
      : true;
  }

  if (isListType(type2)) {
    return true;
  }

  if (isNonNullType(type1)) {
    return isNonNullType(type2)
      ? doTypesConflict(type1.ofType, type2.ofType)
      : true;
  }

  if (isNonNullType(type2)) {
    return true;
  }

  if (isLeafType(type1) || isLeafType(type2)) {
    return type1 !== type2;
  }

  return false;
} // Given a selection set, return the collection of fields (a mapping of response
// name to field nodes and definitions) as well as a list of fragment names
// referenced via fragment spreads.

function getFieldsAndFragmentNames(
  context,
  cachedFieldsAndFragmentNames,
  parentType,
  selectionSet,
) {
  const cached = cachedFieldsAndFragmentNames.get(selectionSet);

  if (cached) {
    return cached;
  }

  const nodeAndDefs = Object.create(null);
  const fragmentNames = Object.create(null);

  _collectFieldsAndFragmentNames(
    context,
    parentType,
    selectionSet,
    nodeAndDefs,
    fragmentNames,
  );

  const result = [nodeAndDefs, Object.keys(fragmentNames)];
  cachedFieldsAndFragmentNames.set(selectionSet, result);
  return result;
} // Given a reference to a fragment, return the represented collection of fields
// as well as a list of nested fragment names referenced via fragment spreads.

function getReferencedFieldsAndFragmentNames(
  context,
  cachedFieldsAndFragmentNames,
  fragment,
) {
  // Short-circuit building a type from the node if possible.
  const cached = cachedFieldsAndFragmentNames.get(fragment.selectionSet);

  if (cached) {
    return cached;
  }

  const fragmentType = typeFromAST(context.getSchema(), fragment.typeCondition);
  return getFieldsAndFragmentNames(
    context,
    cachedFieldsAndFragmentNames,
    fragmentType,
    fragment.selectionSet,
  );
}

function _collectFieldsAndFragmentNames(
  context,
  parentType,
  selectionSet,
  nodeAndDefs,
  fragmentNames,
) {
  for (const selection of selectionSet.selections) {
    switch (selection.kind) {
      case Kind.FIELD: {
        const fieldName = selection.name.value;
        let fieldDef;

        if (isObjectType(parentType) || isInterfaceType(parentType)) {
          fieldDef = parentType.getFields()[fieldName];
        }

        const responseName = selection.alias
          ? selection.alias.value
          : fieldName;

        if (!nodeAndDefs[responseName]) {
          nodeAndDefs[responseName] = [];
        }

        nodeAndDefs[responseName].push([parentType, selection, fieldDef]);
        break;
      }

      case Kind.FRAGMENT_SPREAD:
        fragmentNames[selection.name.value] = true;
        break;

      case Kind.INLINE_FRAGMENT: {
        const typeCondition = selection.typeCondition;
        const inlineFragmentType = typeCondition
          ? typeFromAST(context.getSchema(), typeCondition)
          : parentType;

        _collectFieldsAndFragmentNames(
          context,
          inlineFragmentType,
          selection.selectionSet,
          nodeAndDefs,
          fragmentNames,
        );

        break;
      }
    }
  }
} // Given a series of Conflicts which occurred between two sub-fields, generate
// a single Conflict.

function subfieldConflicts(conflicts, responseName, node1, node2) {
  if (conflicts.length > 0) {
    return [
      [responseName, conflicts.map(([reason]) => reason)],
      [node1, ...conflicts.map(([, fields1]) => fields1).flat()],
      [node2, ...conflicts.map(([, , fields2]) => fields2).flat()],
    ];
  }
}
/**
 * A way to keep track of pairs of things when the ordering of the pair does not matter.
 */

class PairSet {
  constructor() {
    this._data = new Map();
  }

  has(a, b, areMutuallyExclusive) {
    var _this$_data$get;

    const [key1, key2] = a < b ? [a, b] : [b, a];
    const result =
      (_this$_data$get = this._data.get(key1)) === null ||
      _this$_data$get === void 0
        ? void 0
        : _this$_data$get.get(key2);

    if (result === undefined) {
      return false;
    } // areMutuallyExclusive being false is a superset of being true, hence if
    // we want to know if this PairSet "has" these two with no exclusivity,
    // we have to ensure it was added as such.

    return areMutuallyExclusive ? true : areMutuallyExclusive === result;
  }

  add(a, b, areMutuallyExclusive) {
    const [key1, key2] = a < b ? [a, b] : [b, a];

    const map = this._data.get(key1);

    if (map === undefined) {
      this._data.set(key1, new Map([[key2, areMutuallyExclusive]]));
    } else {
      map.set(key2, areMutuallyExclusive);
    }
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/PossibleFragmentSpreadsRule.mjs






/**
 * Possible fragment spread
 *
 * A fragment spread is only valid if the type condition could ever possibly
 * be true: if there is a non-empty intersection of the possible parent types,
 * and possible types which pass the type condition.
 */
function PossibleFragmentSpreadsRule(context) {
  return {
    InlineFragment(node) {
      const fragType = context.getType();
      const parentType = context.getParentType();

      if (
        isCompositeType(fragType) &&
        isCompositeType(parentType) &&
        !doTypesOverlap(context.getSchema(), fragType, parentType)
      ) {
        const parentTypeStr = inspect(parentType);
        const fragTypeStr = inspect(fragType);
        context.reportError(
          new GraphQLError(
            `Fragment cannot be spread here as objects of type "${parentTypeStr}" can never be of type "${fragTypeStr}".`,
            {
              nodes: node,
            },
          ),
        );
      }
    },

    FragmentSpread(node) {
      const fragName = node.name.value;
      const fragType = getFragmentType(context, fragName);
      const parentType = context.getParentType();

      if (
        fragType &&
        parentType &&
        !doTypesOverlap(context.getSchema(), fragType, parentType)
      ) {
        const parentTypeStr = inspect(parentType);
        const fragTypeStr = inspect(fragType);
        context.reportError(
          new GraphQLError(
            `Fragment "${fragName}" cannot be spread here as objects of type "${parentTypeStr}" can never be of type "${fragTypeStr}".`,
            {
              nodes: node,
            },
          ),
        );
      }
    },
  };
}

function getFragmentType(context, name) {
  const frag = context.getFragment(name);

  if (frag) {
    const type = typeFromAST(context.getSchema(), frag.typeCondition);

    if (isCompositeType(type)) {
      return type;
    }
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/PossibleTypeExtensionsRule.mjs









/**
 * Possible type extension
 *
 * A type extension is only valid if the type is defined and has the same kind.
 */
function PossibleTypeExtensionsRule(context) {
  const schema = context.getSchema();
  const definedTypes = Object.create(null);

  for (const def of context.getDocument().definitions) {
    if (isTypeDefinitionNode(def)) {
      definedTypes[def.name.value] = def;
    }
  }

  return {
    ScalarTypeExtension: checkExtension,
    ObjectTypeExtension: checkExtension,
    InterfaceTypeExtension: checkExtension,
    UnionTypeExtension: checkExtension,
    EnumTypeExtension: checkExtension,
    InputObjectTypeExtension: checkExtension,
  };

  function checkExtension(node) {
    const typeName = node.name.value;
    const defNode = definedTypes[typeName];
    const existingType =
      schema === null || schema === void 0 ? void 0 : schema.getType(typeName);
    let expectedKind;

    if (defNode) {
      expectedKind = defKindToExtKind[defNode.kind];
    } else if (existingType) {
      expectedKind = typeToExtKind(existingType);
    }

    if (expectedKind) {
      if (expectedKind !== node.kind) {
        const kindStr = extensionKindToTypeName(node.kind);
        context.reportError(
          new GraphQLError(`Cannot extend non-${kindStr} type "${typeName}".`, {
            nodes: defNode ? [defNode, node] : node,
          }),
        );
      }
    } else {
      const allTypeNames = Object.keys({
        ...definedTypes,
        ...(schema === null || schema === void 0
          ? void 0
          : schema.getTypeMap()),
      });
      const suggestedTypes = suggestionList(typeName, allTypeNames);
      context.reportError(
        new GraphQLError(
          `Cannot extend type "${typeName}" because it is not defined.` +
            didYouMean(suggestedTypes),
          {
            nodes: node.name,
          },
        ),
      );
    }
  }
}
const defKindToExtKind = {
  [Kind.SCALAR_TYPE_DEFINITION]: Kind.SCALAR_TYPE_EXTENSION,
  [Kind.OBJECT_TYPE_DEFINITION]: Kind.OBJECT_TYPE_EXTENSION,
  [Kind.INTERFACE_TYPE_DEFINITION]: Kind.INTERFACE_TYPE_EXTENSION,
  [Kind.UNION_TYPE_DEFINITION]: Kind.UNION_TYPE_EXTENSION,
  [Kind.ENUM_TYPE_DEFINITION]: Kind.ENUM_TYPE_EXTENSION,
  [Kind.INPUT_OBJECT_TYPE_DEFINITION]: Kind.INPUT_OBJECT_TYPE_EXTENSION,
};

function typeToExtKind(type) {
  if (isScalarType(type)) {
    return Kind.SCALAR_TYPE_EXTENSION;
  }

  if (isObjectType(type)) {
    return Kind.OBJECT_TYPE_EXTENSION;
  }

  if (isInterfaceType(type)) {
    return Kind.INTERFACE_TYPE_EXTENSION;
  }

  if (isUnionType(type)) {
    return Kind.UNION_TYPE_EXTENSION;
  }

  if (isEnumType(type)) {
    return Kind.ENUM_TYPE_EXTENSION;
  }

  if (isInputObjectType(type)) {
    return Kind.INPUT_OBJECT_TYPE_EXTENSION;
  }
  /* c8 ignore next 3 */
  // Not reachable. All possible types have been considered

   false || invariant(false, 'Unexpected type: ' + inspect(type));
}

function extensionKindToTypeName(kind) {
  switch (kind) {
    case Kind.SCALAR_TYPE_EXTENSION:
      return 'scalar';

    case Kind.OBJECT_TYPE_EXTENSION:
      return 'object';

    case Kind.INTERFACE_TYPE_EXTENSION:
      return 'interface';

    case Kind.UNION_TYPE_EXTENSION:
      return 'union';

    case Kind.ENUM_TYPE_EXTENSION:
      return 'enum';

    case Kind.INPUT_OBJECT_TYPE_EXTENSION:
      return 'input object';
    // Not reachable. All possible types have been considered

    /* c8 ignore next */

    default:
       false || invariant(false, 'Unexpected kind: ' + inspect(kind));
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/ProvidedRequiredArgumentsRule.mjs








/**
 * Provided required arguments
 *
 * A field or directive is only valid if all required (non-null without a
 * default value) field arguments have been provided.
 */
function ProvidedRequiredArgumentsRule(context) {
  return {
    // eslint-disable-next-line new-cap
    ...ProvidedRequiredArgumentsOnDirectivesRule(context),
    Field: {
      // Validate on leave to allow for deeper errors to appear first.
      leave(fieldNode) {
        var _fieldNode$arguments;

        const fieldDef = context.getFieldDef();

        if (!fieldDef) {
          return false;
        }

        const providedArgs = new Set( // FIXME: https://github.com/graphql/graphql-js/issues/2203
          /* c8 ignore next */
          (_fieldNode$arguments = fieldNode.arguments) === null ||
          _fieldNode$arguments === void 0
            ? void 0
            : _fieldNode$arguments.map((arg) => arg.name.value),
        );

        for (const argDef of fieldDef.args) {
          if (!providedArgs.has(argDef.name) && isRequiredArgument(argDef)) {
            const argTypeStr = inspect(argDef.type);
            context.reportError(
              new GraphQLError(
                `Field "${fieldDef.name}" argument "${argDef.name}" of type "${argTypeStr}" is required, but it was not provided.`,
                {
                  nodes: fieldNode,
                },
              ),
            );
          }
        }
      },
    },
  };
}
/**
 * @internal
 */

function ProvidedRequiredArgumentsOnDirectivesRule(context) {
  var _schema$getDirectives;

  const requiredArgsMap = Object.create(null);
  const schema = context.getSchema();
  const definedDirectives =
    (_schema$getDirectives =
      schema === null || schema === void 0
        ? void 0
        : schema.getDirectives()) !== null && _schema$getDirectives !== void 0
      ? _schema$getDirectives
      : specifiedDirectives;

  for (const directive of definedDirectives) {
    requiredArgsMap[directive.name] = keyMap(
      directive.args.filter(isRequiredArgument),
      (arg) => arg.name,
    );
  }

  const astDefinitions = context.getDocument().definitions;

  for (const def of astDefinitions) {
    if (def.kind === Kind.DIRECTIVE_DEFINITION) {
      var _def$arguments;

      // FIXME: https://github.com/graphql/graphql-js/issues/2203

      /* c8 ignore next */
      const argNodes =
        (_def$arguments = def.arguments) !== null && _def$arguments !== void 0
          ? _def$arguments
          : [];
      requiredArgsMap[def.name.value] = keyMap(
        argNodes.filter(isRequiredArgumentNode),
        (arg) => arg.name.value,
      );
    }
  }

  return {
    Directive: {
      // Validate on leave to allow for deeper errors to appear first.
      leave(directiveNode) {
        const directiveName = directiveNode.name.value;
        const requiredArgs = requiredArgsMap[directiveName];

        if (requiredArgs) {
          var _directiveNode$argume;

          // FIXME: https://github.com/graphql/graphql-js/issues/2203

          /* c8 ignore next */
          const argNodes =
            (_directiveNode$argume = directiveNode.arguments) !== null &&
            _directiveNode$argume !== void 0
              ? _directiveNode$argume
              : [];
          const argNodeMap = new Set(argNodes.map((arg) => arg.name.value));

          for (const [argName, argDef] of Object.entries(requiredArgs)) {
            if (!argNodeMap.has(argName)) {
              const argType = isType(argDef.type)
                ? inspect(argDef.type)
                : print(argDef.type);
              context.reportError(
                new GraphQLError(
                  `Directive "@${directiveName}" argument "${argName}" of type "${argType}" is required, but it was not provided.`,
                  {
                    nodes: directiveNode,
                  },
                ),
              );
            }
          }
        }
      },
    },
  };
}

function isRequiredArgumentNode(arg) {
  return arg.type.kind === Kind.NON_NULL_TYPE && arg.defaultValue == null;
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/ScalarLeafsRule.mjs




/**
 * Scalar leafs
 *
 * A GraphQL document is valid only if all leaf fields (fields without
 * sub selections) are of scalar or enum types.
 */
function ScalarLeafsRule(context) {
  return {
    Field(node) {
      const type = context.getType();
      const selectionSet = node.selectionSet;

      if (type) {
        if (isLeafType(getNamedType(type))) {
          if (selectionSet) {
            const fieldName = node.name.value;
            const typeStr = inspect(type);
            context.reportError(
              new GraphQLError(
                `Field "${fieldName}" must not have a selection since type "${typeStr}" has no subfields.`,
                {
                  nodes: selectionSet,
                },
              ),
            );
          }
        } else if (!selectionSet) {
          const fieldName = node.name.value;
          const typeStr = inspect(type);
          context.reportError(
            new GraphQLError(
              `Field "${fieldName}" of type "${typeStr}" must have a selection of subfields. Did you mean "${fieldName} { ... }"?`,
              {
                nodes: node,
              },
            ),
          );
        }
      }
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/printPathArray.mjs
/**
 * Build a string describing the path.
 */
function printPathArray(path) {
  return path
    .map((key) =>
      typeof key === 'number' ? '[' + key.toString() + ']' : '.' + key,
    )
    .join('');
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/Path.mjs
/**
 * Given a Path and a key, return a new Path containing the new key.
 */
function addPath(prev, key, typename) {
  return {
    prev,
    key,
    typename,
  };
}
/**
 * Given a Path, return an Array of the path keys.
 */

function pathToArray(path) {
  const flattened = [];
  let curr = path;

  while (curr) {
    flattened.push(curr.key);
    curr = curr.prev;
  }

  return flattened.reverse();
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/coerceInputValue.mjs











/**
 * Coerces a JavaScript value given a GraphQL Input Type.
 */
function coerceInputValue(inputValue, type, onError = defaultOnError) {
  return coerceInputValueImpl(inputValue, type, onError, undefined);
}

function defaultOnError(path, invalidValue, error) {
  let errorPrefix = 'Invalid value ' + inspect(invalidValue);

  if (path.length > 0) {
    errorPrefix += ` at "value${printPathArray(path)}"`;
  }

  error.message = errorPrefix + ': ' + error.message;
  throw error;
}

function coerceInputValueImpl(inputValue, type, onError, path) {
  if (isNonNullType(type)) {
    if (inputValue != null) {
      return coerceInputValueImpl(inputValue, type.ofType, onError, path);
    }

    onError(
      pathToArray(path),
      inputValue,
      new GraphQLError(
        `Expected non-nullable type "${inspect(type)}" not to be null.`,
      ),
    );
    return;
  }

  if (inputValue == null) {
    // Explicitly return the value null.
    return null;
  }

  if (isListType(type)) {
    const itemType = type.ofType;

    if (isIterableObject(inputValue)) {
      return Array.from(inputValue, (itemValue, index) => {
        const itemPath = addPath(path, index, undefined);
        return coerceInputValueImpl(itemValue, itemType, onError, itemPath);
      });
    } // Lists accept a non-list value as a list of one.

    return [coerceInputValueImpl(inputValue, itemType, onError, path)];
  }

  if (isInputObjectType(type)) {
    if (!isObjectLike(inputValue)) {
      onError(
        pathToArray(path),
        inputValue,
        new GraphQLError(`Expected type "${type.name}" to be an object.`),
      );
      return;
    }

    const coercedValue = {};
    const fieldDefs = type.getFields();

    for (const field of Object.values(fieldDefs)) {
      const fieldValue = inputValue[field.name];

      if (fieldValue === undefined) {
        if (field.defaultValue !== undefined) {
          coercedValue[field.name] = field.defaultValue;
        } else if (isNonNullType(field.type)) {
          const typeStr = inspect(field.type);
          onError(
            pathToArray(path),
            inputValue,
            new GraphQLError(
              `Field "${field.name}" of required type "${typeStr}" was not provided.`,
            ),
          );
        }

        continue;
      }

      coercedValue[field.name] = coerceInputValueImpl(
        fieldValue,
        field.type,
        onError,
        addPath(path, field.name, type.name),
      );
    } // Ensure every provided field is defined.

    for (const fieldName of Object.keys(inputValue)) {
      if (!fieldDefs[fieldName]) {
        const suggestions = suggestionList(
          fieldName,
          Object.keys(type.getFields()),
        );
        onError(
          pathToArray(path),
          inputValue,
          new GraphQLError(
            `Field "${fieldName}" is not defined by type "${type.name}".` +
              didYouMean(suggestions),
          ),
        );
      }
    }

    return coercedValue;
  }

  if (isLeafType(type)) {
    let parseResult; // Scalars and Enums determine if a input value is valid via parseValue(),
    // which can throw to indicate failure. If it throws, maintain a reference
    // to the original error.

    try {
      parseResult = type.parseValue(inputValue);
    } catch (error) {
      if (error instanceof GraphQLError) {
        onError(pathToArray(path), inputValue, error);
      } else {
        onError(
          pathToArray(path),
          inputValue,
          new GraphQLError(`Expected type "${type.name}". ` + error.message, {
            originalError: error,
          }),
        );
      }

      return;
    }

    if (parseResult === undefined) {
      onError(
        pathToArray(path),
        inputValue,
        new GraphQLError(`Expected type "${type.name}".`),
      );
    }

    return parseResult;
  }
  /* c8 ignore next 3 */
  // Not reachable, all possible types have been considered.

   false || invariant(false, 'Unexpected input type: ' + inspect(type));
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/valueFromAST.mjs





/**
 * Produces a JavaScript value given a GraphQL Value AST.
 *
 * A GraphQL type must be provided, which will be used to interpret different
 * GraphQL Value literals.
 *
 * Returns `undefined` when the value could not be validly coerced according to
 * the provided type.
 *
 * | GraphQL Value        | JSON Value    |
 * | -------------------- | ------------- |
 * | Input Object         | Object        |
 * | List                 | Array         |
 * | Boolean              | Boolean       |
 * | String               | String        |
 * | Int / Float          | Number        |
 * | Enum Value           | Unknown       |
 * | NullValue            | null          |
 *
 */

function valueFromAST(valueNode, type, variables) {
  if (!valueNode) {
    // When there is no node, then there is also no value.
    // Importantly, this is different from returning the value null.
    return;
  }

  if (valueNode.kind === Kind.VARIABLE) {
    const variableName = valueNode.name.value;

    if (variables == null || variables[variableName] === undefined) {
      // No valid return value.
      return;
    }

    const variableValue = variables[variableName];

    if (variableValue === null && isNonNullType(type)) {
      return; // Invalid: intentionally return no value.
    } // Note: This does no further checking that this variable is correct.
    // This assumes that this query has been validated and the variable
    // usage here is of the correct type.

    return variableValue;
  }

  if (isNonNullType(type)) {
    if (valueNode.kind === Kind.NULL) {
      return; // Invalid: intentionally return no value.
    }

    return valueFromAST(valueNode, type.ofType, variables);
  }

  if (valueNode.kind === Kind.NULL) {
    // This is explicitly returning the value null.
    return null;
  }

  if (isListType(type)) {
    const itemType = type.ofType;

    if (valueNode.kind === Kind.LIST) {
      const coercedValues = [];

      for (const itemNode of valueNode.values) {
        if (isMissingVariable(itemNode, variables)) {
          // If an array contains a missing variable, it is either coerced to
          // null or if the item type is non-null, it considered invalid.
          if (isNonNullType(itemType)) {
            return; // Invalid: intentionally return no value.
          }

          coercedValues.push(null);
        } else {
          const itemValue = valueFromAST(itemNode, itemType, variables);

          if (itemValue === undefined) {
            return; // Invalid: intentionally return no value.
          }

          coercedValues.push(itemValue);
        }
      }

      return coercedValues;
    }

    const coercedValue = valueFromAST(valueNode, itemType, variables);

    if (coercedValue === undefined) {
      return; // Invalid: intentionally return no value.
    }

    return [coercedValue];
  }

  if (isInputObjectType(type)) {
    if (valueNode.kind !== Kind.OBJECT) {
      return; // Invalid: intentionally return no value.
    }

    const coercedObj = Object.create(null);
    const fieldNodes = keyMap(valueNode.fields, (field) => field.name.value);

    for (const field of Object.values(type.getFields())) {
      const fieldNode = fieldNodes[field.name];

      if (!fieldNode || isMissingVariable(fieldNode.value, variables)) {
        if (field.defaultValue !== undefined) {
          coercedObj[field.name] = field.defaultValue;
        } else if (isNonNullType(field.type)) {
          return; // Invalid: intentionally return no value.
        }

        continue;
      }

      const fieldValue = valueFromAST(fieldNode.value, field.type, variables);

      if (fieldValue === undefined) {
        return; // Invalid: intentionally return no value.
      }

      coercedObj[field.name] = fieldValue;
    }

    return coercedObj;
  }

  if (isLeafType(type)) {
    // Scalars and Enums fulfill parsing a literal value via parseLiteral().
    // Invalid values represent a failure to parse correctly, in which case
    // no value is returned.
    let result;

    try {
      result = type.parseLiteral(valueNode, variables);
    } catch (_error) {
      return; // Invalid: intentionally return no value.
    }

    if (result === undefined) {
      return; // Invalid: intentionally return no value.
    }

    return result;
  }
  /* c8 ignore next 3 */
  // Not reachable, all possible input types have been considered.

   false || invariant(false, 'Unexpected input type: ' + inspect(type));
} // Returns true if the provided valueNode is a variable which is not defined
// in the set of variables.

function isMissingVariable(valueNode, variables) {
  return (
    valueNode.kind === Kind.VARIABLE &&
    (variables == null || variables[valueNode.name.value] === undefined)
  );
}

;// CONCATENATED MODULE: ../node_modules/graphql/execution/values.mjs











/**
 * Prepares an object map of variableValues of the correct type based on the
 * provided variable definitions and arbitrary input. If the input cannot be
 * parsed to match the variable definitions, a GraphQLError will be thrown.
 *
 * Note: The returned value is a plain Object with a prototype, since it is
 * exposed to user code. Care should be taken to not pull values from the
 * Object prototype.
 */
function getVariableValues(schema, varDefNodes, inputs, options) {
  const errors = [];
  const maxErrors =
    options === null || options === void 0 ? void 0 : options.maxErrors;

  try {
    const coerced = coerceVariableValues(
      schema,
      varDefNodes,
      inputs,
      (error) => {
        if (maxErrors != null && errors.length >= maxErrors) {
          throw new GraphQLError(
            'Too many errors processing variables, error limit reached. Execution aborted.',
          );
        }

        errors.push(error);
      },
    );

    if (errors.length === 0) {
      return {
        coerced,
      };
    }
  } catch (error) {
    errors.push(error);
  }

  return {
    errors,
  };
}

function coerceVariableValues(schema, varDefNodes, inputs, onError) {
  const coercedValues = {};

  for (const varDefNode of varDefNodes) {
    const varName = varDefNode.variable.name.value;
    const varType = typeFromAST(schema, varDefNode.type);

    if (!isInputType(varType)) {
      // Must use input types for variables. This should be caught during
      // validation, however is checked again here for safety.
      const varTypeStr = print(varDefNode.type);
      onError(
        new GraphQLError(
          `Variable "$${varName}" expected value of type "${varTypeStr}" which cannot be used as an input type.`,
          {
            nodes: varDefNode.type,
          },
        ),
      );
      continue;
    }

    if (!values_hasOwnProperty(inputs, varName)) {
      if (varDefNode.defaultValue) {
        coercedValues[varName] = valueFromAST(varDefNode.defaultValue, varType);
      } else if (isNonNullType(varType)) {
        const varTypeStr = inspect(varType);
        onError(
          new GraphQLError(
            `Variable "$${varName}" of required type "${varTypeStr}" was not provided.`,
            {
              nodes: varDefNode,
            },
          ),
        );
      }

      continue;
    }

    const value = inputs[varName];

    if (value === null && isNonNullType(varType)) {
      const varTypeStr = inspect(varType);
      onError(
        new GraphQLError(
          `Variable "$${varName}" of non-null type "${varTypeStr}" must not be null.`,
          {
            nodes: varDefNode,
          },
        ),
      );
      continue;
    }

    coercedValues[varName] = coerceInputValue(
      value,
      varType,
      (path, invalidValue, error) => {
        let prefix =
          `Variable "$${varName}" got invalid value ` + inspect(invalidValue);

        if (path.length > 0) {
          prefix += ` at "${varName}${printPathArray(path)}"`;
        }

        onError(
          new GraphQLError(prefix + '; ' + error.message, {
            nodes: varDefNode,
            originalError: error,
          }),
        );
      },
    );
  }

  return coercedValues;
}
/**
 * Prepares an object map of argument values given a list of argument
 * definitions and list of argument AST nodes.
 *
 * Note: The returned value is a plain Object with a prototype, since it is
 * exposed to user code. Care should be taken to not pull values from the
 * Object prototype.
 */

function getArgumentValues(def, node, variableValues) {
  var _node$arguments;

  const coercedValues = {}; // FIXME: https://github.com/graphql/graphql-js/issues/2203

  /* c8 ignore next */

  const argumentNodes =
    (_node$arguments = node.arguments) !== null && _node$arguments !== void 0
      ? _node$arguments
      : [];
  const argNodeMap = keyMap(argumentNodes, (arg) => arg.name.value);

  for (const argDef of def.args) {
    const name = argDef.name;
    const argType = argDef.type;
    const argumentNode = argNodeMap[name];

    if (!argumentNode) {
      if (argDef.defaultValue !== undefined) {
        coercedValues[name] = argDef.defaultValue;
      } else if (isNonNullType(argType)) {
        throw new GraphQLError(
          `Argument "${name}" of required type "${inspect(argType)}" ` +
            'was not provided.',
          {
            nodes: node,
          },
        );
      }

      continue;
    }

    const valueNode = argumentNode.value;
    let isNull = valueNode.kind === Kind.NULL;

    if (valueNode.kind === Kind.VARIABLE) {
      const variableName = valueNode.name.value;

      if (
        variableValues == null ||
        !values_hasOwnProperty(variableValues, variableName)
      ) {
        if (argDef.defaultValue !== undefined) {
          coercedValues[name] = argDef.defaultValue;
        } else if (isNonNullType(argType)) {
          throw new GraphQLError(
            `Argument "${name}" of required type "${inspect(argType)}" ` +
              `was provided the variable "$${variableName}" which was not provided a runtime value.`,
            {
              nodes: valueNode,
            },
          );
        }

        continue;
      }

      isNull = variableValues[variableName] == null;
    }

    if (isNull && isNonNullType(argType)) {
      throw new GraphQLError(
        `Argument "${name}" of non-null type "${inspect(argType)}" ` +
          'must not be null.',
        {
          nodes: valueNode,
        },
      );
    }

    const coercedValue = valueFromAST(valueNode, argType, variableValues);

    if (coercedValue === undefined) {
      // Note: ValuesOfCorrectTypeRule validation should catch this before
      // execution. This is a runtime check to ensure execution does not
      // continue with an invalid argument value.
      throw new GraphQLError(
        `Argument "${name}" has invalid value ${print(valueNode)}.`,
        {
          nodes: valueNode,
        },
      );
    }

    coercedValues[name] = coercedValue;
  }

  return coercedValues;
}
/**
 * Prepares an object map of argument values given a directive definition
 * and a AST node which may contain directives. Optionally also accepts a map
 * of variable values.
 *
 * If the directive does not exist on the node, returns undefined.
 *
 * Note: The returned value is a plain Object with a prototype, since it is
 * exposed to user code. Care should be taken to not pull values from the
 * Object prototype.
 */

function getDirectiveValues(directiveDef, node, variableValues) {
  var _node$directives;

  const directiveNode =
    (_node$directives = node.directives) === null || _node$directives === void 0
      ? void 0
      : _node$directives.find(
          (directive) => directive.name.value === directiveDef.name,
        );

  if (directiveNode) {
    return getArgumentValues(directiveDef, directiveNode, variableValues);
  }
}

function values_hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

;// CONCATENATED MODULE: ../node_modules/graphql/execution/collectFields.mjs





/**
 * Given a selectionSet, collects all of the fields and returns them.
 *
 * CollectFields requires the "runtime type" of an object. For a field that
 * returns an Interface or Union type, the "runtime type" will be the actual
 * object type returned by that field.
 *
 * @internal
 */

function collectFields(
  schema,
  fragments,
  variableValues,
  runtimeType,
  selectionSet,
) {
  const fields = new Map();
  collectFieldsImpl(
    schema,
    fragments,
    variableValues,
    runtimeType,
    selectionSet,
    fields,
    new Set(),
  );
  return fields;
}
/**
 * Given an array of field nodes, collects all of the subfields of the passed
 * in fields, and returns them at the end.
 *
 * CollectSubFields requires the "return type" of an object. For a field that
 * returns an Interface or Union type, the "return type" will be the actual
 * object type returned by that field.
 *
 * @internal
 */

function collectSubfields(
  schema,
  fragments,
  variableValues,
  returnType,
  fieldNodes,
) {
  const subFieldNodes = new Map();
  const visitedFragmentNames = new Set();

  for (const node of fieldNodes) {
    if (node.selectionSet) {
      collectFieldsImpl(
        schema,
        fragments,
        variableValues,
        returnType,
        node.selectionSet,
        subFieldNodes,
        visitedFragmentNames,
      );
    }
  }

  return subFieldNodes;
}

function collectFieldsImpl(
  schema,
  fragments,
  variableValues,
  runtimeType,
  selectionSet,
  fields,
  visitedFragmentNames,
) {
  for (const selection of selectionSet.selections) {
    switch (selection.kind) {
      case Kind.FIELD: {
        if (!shouldIncludeNode(variableValues, selection)) {
          continue;
        }

        const name = getFieldEntryKey(selection);
        const fieldList = fields.get(name);

        if (fieldList !== undefined) {
          fieldList.push(selection);
        } else {
          fields.set(name, [selection]);
        }

        break;
      }

      case Kind.INLINE_FRAGMENT: {
        if (
          !shouldIncludeNode(variableValues, selection) ||
          !doesFragmentConditionMatch(schema, selection, runtimeType)
        ) {
          continue;
        }

        collectFieldsImpl(
          schema,
          fragments,
          variableValues,
          runtimeType,
          selection.selectionSet,
          fields,
          visitedFragmentNames,
        );
        break;
      }

      case Kind.FRAGMENT_SPREAD: {
        const fragName = selection.name.value;

        if (
          visitedFragmentNames.has(fragName) ||
          !shouldIncludeNode(variableValues, selection)
        ) {
          continue;
        }

        visitedFragmentNames.add(fragName);
        const fragment = fragments[fragName];

        if (
          !fragment ||
          !doesFragmentConditionMatch(schema, fragment, runtimeType)
        ) {
          continue;
        }

        collectFieldsImpl(
          schema,
          fragments,
          variableValues,
          runtimeType,
          fragment.selectionSet,
          fields,
          visitedFragmentNames,
        );
        break;
      }
    }
  }
}
/**
 * Determines if a field should be included based on the `@include` and `@skip`
 * directives, where `@skip` has higher precedence than `@include`.
 */

function shouldIncludeNode(variableValues, node) {
  const skip = getDirectiveValues(GraphQLSkipDirective, node, variableValues);

  if ((skip === null || skip === void 0 ? void 0 : skip.if) === true) {
    return false;
  }

  const include = getDirectiveValues(
    GraphQLIncludeDirective,
    node,
    variableValues,
  );

  if (
    (include === null || include === void 0 ? void 0 : include.if) === false
  ) {
    return false;
  }

  return true;
}
/**
 * Determines if a fragment is applicable to the given type.
 */

function doesFragmentConditionMatch(schema, fragment, type) {
  const typeConditionNode = fragment.typeCondition;

  if (!typeConditionNode) {
    return true;
  }

  const conditionalType = typeFromAST(schema, typeConditionNode);

  if (conditionalType === type) {
    return true;
  }

  if (isAbstractType(conditionalType)) {
    return schema.isSubType(conditionalType, type);
  }

  return false;
}
/**
 * Implements the logic to compute the key of a given field's entry
 */

function getFieldEntryKey(node) {
  return node.alias ? node.alias.value : node.name.value;
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/SingleFieldSubscriptionsRule.mjs




/**
 * Subscriptions must only include a non-introspection field.
 *
 * A GraphQL subscription is valid only if it contains a single root field and
 * that root field is not an introspection field.
 *
 * See https://spec.graphql.org/draft/#sec-Single-root-field
 */
function SingleFieldSubscriptionsRule(context) {
  return {
    OperationDefinition(node) {
      if (node.operation === 'subscription') {
        const schema = context.getSchema();
        const subscriptionType = schema.getSubscriptionType();

        if (subscriptionType) {
          const operationName = node.name ? node.name.value : null;
          const variableValues = Object.create(null);
          const document = context.getDocument();
          const fragments = Object.create(null);

          for (const definition of document.definitions) {
            if (definition.kind === Kind.FRAGMENT_DEFINITION) {
              fragments[definition.name.value] = definition;
            }
          }

          const fields = collectFields(
            schema,
            fragments,
            variableValues,
            subscriptionType,
            node.selectionSet,
          );

          if (fields.size > 1) {
            const fieldSelectionLists = [...fields.values()];
            const extraFieldSelectionLists = fieldSelectionLists.slice(1);
            const extraFieldSelections = extraFieldSelectionLists.flat();
            context.reportError(
              new GraphQLError(
                operationName != null
                  ? `Subscription "${operationName}" must select only one top level field.`
                  : 'Anonymous Subscription must select only one top level field.',
                {
                  nodes: extraFieldSelections,
                },
              ),
            );
          }

          for (const fieldNodes of fields.values()) {
            const field = fieldNodes[0];
            const fieldName = field.name.value;

            if (fieldName.startsWith('__')) {
              context.reportError(
                new GraphQLError(
                  operationName != null
                    ? `Subscription "${operationName}" must not select an introspection top level field.`
                    : 'Anonymous Subscription must not select an introspection top level field.',
                  {
                    nodes: fieldNodes,
                  },
                ),
              );
            }
          }
        }
      }
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/groupBy.mjs
/**
 * Groups array items into a Map, given a function to produce grouping key.
 */
function groupBy(list, keyFn) {
  const result = new Map();

  for (const item of list) {
    const key = keyFn(item);
    const group = result.get(key);

    if (group === undefined) {
      result.set(key, [item]);
    } else {
      group.push(item);
    }
  }

  return result;
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/UniqueArgumentDefinitionNamesRule.mjs



/**
 * Unique argument definition names
 *
 * A GraphQL Object or Interface type is only valid if all its fields have uniquely named arguments.
 * A GraphQL Directive is only valid if all its arguments are uniquely named.
 */
function UniqueArgumentDefinitionNamesRule(context) {
  return {
    DirectiveDefinition(directiveNode) {
      var _directiveNode$argume;

      // FIXME: https://github.com/graphql/graphql-js/issues/2203

      /* c8 ignore next */
      const argumentNodes =
        (_directiveNode$argume = directiveNode.arguments) !== null &&
        _directiveNode$argume !== void 0
          ? _directiveNode$argume
          : [];
      return checkArgUniqueness(`@${directiveNode.name.value}`, argumentNodes);
    },

    InterfaceTypeDefinition: checkArgUniquenessPerField,
    InterfaceTypeExtension: checkArgUniquenessPerField,
    ObjectTypeDefinition: checkArgUniquenessPerField,
    ObjectTypeExtension: checkArgUniquenessPerField,
  };

  function checkArgUniquenessPerField(typeNode) {
    var _typeNode$fields;

    const typeName = typeNode.name.value; // FIXME: https://github.com/graphql/graphql-js/issues/2203

    /* c8 ignore next */

    const fieldNodes =
      (_typeNode$fields = typeNode.fields) !== null &&
      _typeNode$fields !== void 0
        ? _typeNode$fields
        : [];

    for (const fieldDef of fieldNodes) {
      var _fieldDef$arguments;

      const fieldName = fieldDef.name.value; // FIXME: https://github.com/graphql/graphql-js/issues/2203

      /* c8 ignore next */

      const argumentNodes =
        (_fieldDef$arguments = fieldDef.arguments) !== null &&
        _fieldDef$arguments !== void 0
          ? _fieldDef$arguments
          : [];
      checkArgUniqueness(`${typeName}.${fieldName}`, argumentNodes);
    }

    return false;
  }

  function checkArgUniqueness(parentName, argumentNodes) {
    const seenArgs = groupBy(argumentNodes, (arg) => arg.name.value);

    for (const [argName, argNodes] of seenArgs) {
      if (argNodes.length > 1) {
        context.reportError(
          new GraphQLError(
            `Argument "${parentName}(${argName}:)" can only be defined once.`,
            {
              nodes: argNodes.map((node) => node.name),
            },
          ),
        );
      }
    }

    return false;
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/UniqueArgumentNamesRule.mjs



/**
 * Unique argument names
 *
 * A GraphQL field or directive is only valid if all supplied arguments are
 * uniquely named.
 *
 * See https://spec.graphql.org/draft/#sec-Argument-Names
 */
function UniqueArgumentNamesRule(context) {
  return {
    Field: checkArgUniqueness,
    Directive: checkArgUniqueness,
  };

  function checkArgUniqueness(parentNode) {
    var _parentNode$arguments;

    // FIXME: https://github.com/graphql/graphql-js/issues/2203

    /* c8 ignore next */
    const argumentNodes =
      (_parentNode$arguments = parentNode.arguments) !== null &&
      _parentNode$arguments !== void 0
        ? _parentNode$arguments
        : [];
    const seenArgs = groupBy(argumentNodes, (arg) => arg.name.value);

    for (const [argName, argNodes] of seenArgs) {
      if (argNodes.length > 1) {
        context.reportError(
          new GraphQLError(
            `There can be only one argument named "${argName}".`,
            {
              nodes: argNodes.map((node) => node.name),
            },
          ),
        );
      }
    }
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/UniqueDirectiveNamesRule.mjs


/**
 * Unique directive names
 *
 * A GraphQL document is only valid if all defined directives have unique names.
 */
function UniqueDirectiveNamesRule(context) {
  const knownDirectiveNames = Object.create(null);
  const schema = context.getSchema();
  return {
    DirectiveDefinition(node) {
      const directiveName = node.name.value;

      if (
        schema !== null &&
        schema !== void 0 &&
        schema.getDirective(directiveName)
      ) {
        context.reportError(
          new GraphQLError(
            `Directive "@${directiveName}" already exists in the schema. It cannot be redefined.`,
            {
              nodes: node.name,
            },
          ),
        );
        return;
      }

      if (knownDirectiveNames[directiveName]) {
        context.reportError(
          new GraphQLError(
            `There can be only one directive named "@${directiveName}".`,
            {
              nodes: [knownDirectiveNames[directiveName], node.name],
            },
          ),
        );
      } else {
        knownDirectiveNames[directiveName] = node.name;
      }

      return false;
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/UniqueDirectivesPerLocationRule.mjs





/**
 * Unique directive names per location
 *
 * A GraphQL document is only valid if all non-repeatable directives at
 * a given location are uniquely named.
 *
 * See https://spec.graphql.org/draft/#sec-Directives-Are-Unique-Per-Location
 */
function UniqueDirectivesPerLocationRule(context) {
  const uniqueDirectiveMap = Object.create(null);
  const schema = context.getSchema();
  const definedDirectives = schema
    ? schema.getDirectives()
    : specifiedDirectives;

  for (const directive of definedDirectives) {
    uniqueDirectiveMap[directive.name] = !directive.isRepeatable;
  }

  const astDefinitions = context.getDocument().definitions;

  for (const def of astDefinitions) {
    if (def.kind === Kind.DIRECTIVE_DEFINITION) {
      uniqueDirectiveMap[def.name.value] = !def.repeatable;
    }
  }

  const schemaDirectives = Object.create(null);
  const typeDirectivesMap = Object.create(null);
  return {
    // Many different AST nodes may contain directives. Rather than listing
    // them all, just listen for entering any node, and check to see if it
    // defines any directives.
    enter(node) {
      if (!('directives' in node) || !node.directives) {
        return;
      }

      let seenDirectives;

      if (
        node.kind === Kind.SCHEMA_DEFINITION ||
        node.kind === Kind.SCHEMA_EXTENSION
      ) {
        seenDirectives = schemaDirectives;
      } else if (isTypeDefinitionNode(node) || isTypeExtensionNode(node)) {
        const typeName = node.name.value;
        seenDirectives = typeDirectivesMap[typeName];

        if (seenDirectives === undefined) {
          typeDirectivesMap[typeName] = seenDirectives = Object.create(null);
        }
      } else {
        seenDirectives = Object.create(null);
      }

      for (const directive of node.directives) {
        const directiveName = directive.name.value;

        if (uniqueDirectiveMap[directiveName]) {
          if (seenDirectives[directiveName]) {
            context.reportError(
              new GraphQLError(
                `The directive "@${directiveName}" can only be used once at this location.`,
                {
                  nodes: [seenDirectives[directiveName], directive],
                },
              ),
            );
          } else {
            seenDirectives[directiveName] = directive;
          }
        }
      }
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/UniqueEnumValueNamesRule.mjs



/**
 * Unique enum value names
 *
 * A GraphQL enum type is only valid if all its values are uniquely named.
 */
function UniqueEnumValueNamesRule(context) {
  const schema = context.getSchema();
  const existingTypeMap = schema ? schema.getTypeMap() : Object.create(null);
  const knownValueNames = Object.create(null);
  return {
    EnumTypeDefinition: checkValueUniqueness,
    EnumTypeExtension: checkValueUniqueness,
  };

  function checkValueUniqueness(node) {
    var _node$values;

    const typeName = node.name.value;

    if (!knownValueNames[typeName]) {
      knownValueNames[typeName] = Object.create(null);
    } // FIXME: https://github.com/graphql/graphql-js/issues/2203

    /* c8 ignore next */

    const valueNodes =
      (_node$values = node.values) !== null && _node$values !== void 0
        ? _node$values
        : [];
    const valueNames = knownValueNames[typeName];

    for (const valueDef of valueNodes) {
      const valueName = valueDef.name.value;
      const existingType = existingTypeMap[typeName];

      if (isEnumType(existingType) && existingType.getValue(valueName)) {
        context.reportError(
          new GraphQLError(
            `Enum value "${typeName}.${valueName}" already exists in the schema. It cannot also be defined in this type extension.`,
            {
              nodes: valueDef.name,
            },
          ),
        );
      } else if (valueNames[valueName]) {
        context.reportError(
          new GraphQLError(
            `Enum value "${typeName}.${valueName}" can only be defined once.`,
            {
              nodes: [valueNames[valueName], valueDef.name],
            },
          ),
        );
      } else {
        valueNames[valueName] = valueDef.name;
      }
    }

    return false;
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/UniqueFieldDefinitionNamesRule.mjs



/**
 * Unique field definition names
 *
 * A GraphQL complex type is only valid if all its fields are uniquely named.
 */
function UniqueFieldDefinitionNamesRule(context) {
  const schema = context.getSchema();
  const existingTypeMap = schema ? schema.getTypeMap() : Object.create(null);
  const knownFieldNames = Object.create(null);
  return {
    InputObjectTypeDefinition: checkFieldUniqueness,
    InputObjectTypeExtension: checkFieldUniqueness,
    InterfaceTypeDefinition: checkFieldUniqueness,
    InterfaceTypeExtension: checkFieldUniqueness,
    ObjectTypeDefinition: checkFieldUniqueness,
    ObjectTypeExtension: checkFieldUniqueness,
  };

  function checkFieldUniqueness(node) {
    var _node$fields;

    const typeName = node.name.value;

    if (!knownFieldNames[typeName]) {
      knownFieldNames[typeName] = Object.create(null);
    } // FIXME: https://github.com/graphql/graphql-js/issues/2203

    /* c8 ignore next */

    const fieldNodes =
      (_node$fields = node.fields) !== null && _node$fields !== void 0
        ? _node$fields
        : [];
    const fieldNames = knownFieldNames[typeName];

    for (const fieldDef of fieldNodes) {
      const fieldName = fieldDef.name.value;

      if (hasField(existingTypeMap[typeName], fieldName)) {
        context.reportError(
          new GraphQLError(
            `Field "${typeName}.${fieldName}" already exists in the schema. It cannot also be defined in this type extension.`,
            {
              nodes: fieldDef.name,
            },
          ),
        );
      } else if (fieldNames[fieldName]) {
        context.reportError(
          new GraphQLError(
            `Field "${typeName}.${fieldName}" can only be defined once.`,
            {
              nodes: [fieldNames[fieldName], fieldDef.name],
            },
          ),
        );
      } else {
        fieldNames[fieldName] = fieldDef.name;
      }
    }

    return false;
  }
}

function hasField(type, fieldName) {
  if (isObjectType(type) || isInterfaceType(type) || isInputObjectType(type)) {
    return type.getFields()[fieldName] != null;
  }

  return false;
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/UniqueFragmentNamesRule.mjs


/**
 * Unique fragment names
 *
 * A GraphQL document is only valid if all defined fragments have unique names.
 *
 * See https://spec.graphql.org/draft/#sec-Fragment-Name-Uniqueness
 */
function UniqueFragmentNamesRule(context) {
  const knownFragmentNames = Object.create(null);
  return {
    OperationDefinition: () => false,

    FragmentDefinition(node) {
      const fragmentName = node.name.value;

      if (knownFragmentNames[fragmentName]) {
        context.reportError(
          new GraphQLError(
            `There can be only one fragment named "${fragmentName}".`,
            {
              nodes: [knownFragmentNames[fragmentName], node.name],
            },
          ),
        );
      } else {
        knownFragmentNames[fragmentName] = node.name;
      }

      return false;
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/UniqueInputFieldNamesRule.mjs



/**
 * Unique input field names
 *
 * A GraphQL input object value is only valid if all supplied fields are
 * uniquely named.
 *
 * See https://spec.graphql.org/draft/#sec-Input-Object-Field-Uniqueness
 */
function UniqueInputFieldNamesRule(context) {
  const knownNameStack = [];
  let knownNames = Object.create(null);
  return {
    ObjectValue: {
      enter() {
        knownNameStack.push(knownNames);
        knownNames = Object.create(null);
      },

      leave() {
        const prevKnownNames = knownNameStack.pop();
        prevKnownNames || invariant(false);
        knownNames = prevKnownNames;
      },
    },

    ObjectField(node) {
      const fieldName = node.name.value;

      if (knownNames[fieldName]) {
        context.reportError(
          new GraphQLError(
            `There can be only one input field named "${fieldName}".`,
            {
              nodes: [knownNames[fieldName], node.name],
            },
          ),
        );
      } else {
        knownNames[fieldName] = node.name;
      }
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/UniqueOperationNamesRule.mjs


/**
 * Unique operation names
 *
 * A GraphQL document is only valid if all defined operations have unique names.
 *
 * See https://spec.graphql.org/draft/#sec-Operation-Name-Uniqueness
 */
function UniqueOperationNamesRule(context) {
  const knownOperationNames = Object.create(null);
  return {
    OperationDefinition(node) {
      const operationName = node.name;

      if (operationName) {
        if (knownOperationNames[operationName.value]) {
          context.reportError(
            new GraphQLError(
              `There can be only one operation named "${operationName.value}".`,
              {
                nodes: [
                  knownOperationNames[operationName.value],
                  operationName,
                ],
              },
            ),
          );
        } else {
          knownOperationNames[operationName.value] = operationName;
        }
      }

      return false;
    },

    FragmentDefinition: () => false,
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/UniqueOperationTypesRule.mjs


/**
 * Unique operation types
 *
 * A GraphQL document is only valid if it has only one type per operation.
 */
function UniqueOperationTypesRule(context) {
  const schema = context.getSchema();
  const definedOperationTypes = Object.create(null);
  const existingOperationTypes = schema
    ? {
        query: schema.getQueryType(),
        mutation: schema.getMutationType(),
        subscription: schema.getSubscriptionType(),
      }
    : {};
  return {
    SchemaDefinition: checkOperationTypes,
    SchemaExtension: checkOperationTypes,
  };

  function checkOperationTypes(node) {
    var _node$operationTypes;

    // See: https://github.com/graphql/graphql-js/issues/2203

    /* c8 ignore next */
    const operationTypesNodes =
      (_node$operationTypes = node.operationTypes) !== null &&
      _node$operationTypes !== void 0
        ? _node$operationTypes
        : [];

    for (const operationType of operationTypesNodes) {
      const operation = operationType.operation;
      const alreadyDefinedOperationType = definedOperationTypes[operation];

      if (existingOperationTypes[operation]) {
        context.reportError(
          new GraphQLError(
            `Type for ${operation} already defined in the schema. It cannot be redefined.`,
            {
              nodes: operationType,
            },
          ),
        );
      } else if (alreadyDefinedOperationType) {
        context.reportError(
          new GraphQLError(
            `There can be only one ${operation} type in schema.`,
            {
              nodes: [alreadyDefinedOperationType, operationType],
            },
          ),
        );
      } else {
        definedOperationTypes[operation] = operationType;
      }
    }

    return false;
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/UniqueTypeNamesRule.mjs


/**
 * Unique type names
 *
 * A GraphQL document is only valid if all defined types have unique names.
 */
function UniqueTypeNamesRule(context) {
  const knownTypeNames = Object.create(null);
  const schema = context.getSchema();
  return {
    ScalarTypeDefinition: checkTypeName,
    ObjectTypeDefinition: checkTypeName,
    InterfaceTypeDefinition: checkTypeName,
    UnionTypeDefinition: checkTypeName,
    EnumTypeDefinition: checkTypeName,
    InputObjectTypeDefinition: checkTypeName,
  };

  function checkTypeName(node) {
    const typeName = node.name.value;

    if (schema !== null && schema !== void 0 && schema.getType(typeName)) {
      context.reportError(
        new GraphQLError(
          `Type "${typeName}" already exists in the schema. It cannot also be defined in this type definition.`,
          {
            nodes: node.name,
          },
        ),
      );
      return;
    }

    if (knownTypeNames[typeName]) {
      context.reportError(
        new GraphQLError(`There can be only one type named "${typeName}".`, {
          nodes: [knownTypeNames[typeName], node.name],
        }),
      );
    } else {
      knownTypeNames[typeName] = node.name;
    }

    return false;
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/UniqueVariableNamesRule.mjs



/**
 * Unique variable names
 *
 * A GraphQL operation is only valid if all its variables are uniquely named.
 */
function UniqueVariableNamesRule(context) {
  return {
    OperationDefinition(operationNode) {
      var _operationNode$variab;

      // See: https://github.com/graphql/graphql-js/issues/2203

      /* c8 ignore next */
      const variableDefinitions =
        (_operationNode$variab = operationNode.variableDefinitions) !== null &&
        _operationNode$variab !== void 0
          ? _operationNode$variab
          : [];
      const seenVariableDefinitions = groupBy(
        variableDefinitions,
        (node) => node.variable.name.value,
      );

      for (const [variableName, variableNodes] of seenVariableDefinitions) {
        if (variableNodes.length > 1) {
          context.reportError(
            new GraphQLError(
              `There can be only one variable named "$${variableName}".`,
              {
                nodes: variableNodes.map((node) => node.variable.name),
              },
            ),
          );
        }
      }
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/ValuesOfCorrectTypeRule.mjs








/**
 * Value literals of correct type
 *
 * A GraphQL document is only valid if all value literals are of the type
 * expected at their position.
 *
 * See https://spec.graphql.org/draft/#sec-Values-of-Correct-Type
 */
function ValuesOfCorrectTypeRule(context) {
  return {
    ListValue(node) {
      // Note: TypeInfo will traverse into a list's item type, so look to the
      // parent input type to check if it is a list.
      const type = getNullableType(context.getParentInputType());

      if (!isListType(type)) {
        isValidValueNode(context, node);
        return false; // Don't traverse further.
      }
    },

    ObjectValue(node) {
      const type = getNamedType(context.getInputType());

      if (!isInputObjectType(type)) {
        isValidValueNode(context, node);
        return false; // Don't traverse further.
      } // Ensure every required field exists.

      const fieldNodeMap = keyMap(node.fields, (field) => field.name.value);

      for (const fieldDef of Object.values(type.getFields())) {
        const fieldNode = fieldNodeMap[fieldDef.name];

        if (!fieldNode && isRequiredInputField(fieldDef)) {
          const typeStr = inspect(fieldDef.type);
          context.reportError(
            new GraphQLError(
              `Field "${type.name}.${fieldDef.name}" of required type "${typeStr}" was not provided.`,
              {
                nodes: node,
              },
            ),
          );
        }
      }
    },

    ObjectField(node) {
      const parentType = getNamedType(context.getParentInputType());
      const fieldType = context.getInputType();

      if (!fieldType && isInputObjectType(parentType)) {
        const suggestions = suggestionList(
          node.name.value,
          Object.keys(parentType.getFields()),
        );
        context.reportError(
          new GraphQLError(
            `Field "${node.name.value}" is not defined by type "${parentType.name}".` +
              didYouMean(suggestions),
            {
              nodes: node,
            },
          ),
        );
      }
    },

    NullValue(node) {
      const type = context.getInputType();

      if (isNonNullType(type)) {
        context.reportError(
          new GraphQLError(
            `Expected value of type "${inspect(type)}", found ${print(node)}.`,
            {
              nodes: node,
            },
          ),
        );
      }
    },

    EnumValue: (node) => isValidValueNode(context, node),
    IntValue: (node) => isValidValueNode(context, node),
    FloatValue: (node) => isValidValueNode(context, node),
    StringValue: (node) => isValidValueNode(context, node),
    BooleanValue: (node) => isValidValueNode(context, node),
  };
}
/**
 * Any value literal may be a valid representation of a Scalar, depending on
 * that scalar type.
 */

function isValidValueNode(context, node) {
  // Report any error at the full type expected by the location.
  const locationType = context.getInputType();

  if (!locationType) {
    return;
  }

  const type = getNamedType(locationType);

  if (!isLeafType(type)) {
    const typeStr = inspect(locationType);
    context.reportError(
      new GraphQLError(
        `Expected value of type "${typeStr}", found ${print(node)}.`,
        {
          nodes: node,
        },
      ),
    );
    return;
  } // Scalars and Enums determine if a literal value is valid via parseLiteral(),
  // which may throw or return an invalid value to indicate failure.

  try {
    const parseResult = type.parseLiteral(
      node,
      undefined,
      /* variables */
    );

    if (parseResult === undefined) {
      const typeStr = inspect(locationType);
      context.reportError(
        new GraphQLError(
          `Expected value of type "${typeStr}", found ${print(node)}.`,
          {
            nodes: node,
          },
        ),
      );
    }
  } catch (error) {
    const typeStr = inspect(locationType);

    if (error instanceof GraphQLError) {
      context.reportError(error);
    } else {
      context.reportError(
        new GraphQLError(
          `Expected value of type "${typeStr}", found ${print(node)}; ` +
            error.message,
          {
            nodes: node,
            originalError: error,
          },
        ),
      );
    }
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/VariablesAreInputTypesRule.mjs





/**
 * Variables are input types
 *
 * A GraphQL operation is only valid if all the variables it defines are of
 * input types (scalar, enum, or input object).
 *
 * See https://spec.graphql.org/draft/#sec-Variables-Are-Input-Types
 */
function VariablesAreInputTypesRule(context) {
  return {
    VariableDefinition(node) {
      const type = typeFromAST(context.getSchema(), node.type);

      if (type !== undefined && !isInputType(type)) {
        const variableName = node.variable.name.value;
        const typeName = print(node.type);
        context.reportError(
          new GraphQLError(
            `Variable "$${variableName}" cannot be non-input type "${typeName}".`,
            {
              nodes: node.type,
            },
          ),
        );
      }
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/VariablesInAllowedPositionRule.mjs







/**
 * Variables in allowed position
 *
 * Variable usages must be compatible with the arguments they are passed to.
 *
 * See https://spec.graphql.org/draft/#sec-All-Variable-Usages-are-Allowed
 */
function VariablesInAllowedPositionRule(context) {
  let varDefMap = Object.create(null);
  return {
    OperationDefinition: {
      enter() {
        varDefMap = Object.create(null);
      },

      leave(operation) {
        const usages = context.getRecursiveVariableUsages(operation);

        for (const { node, type, defaultValue } of usages) {
          const varName = node.name.value;
          const varDef = varDefMap[varName];

          if (varDef && type) {
            // A var type is allowed if it is the same or more strict (e.g. is
            // a subtype of) than the expected type. It can be more strict if
            // the variable type is non-null when the expected type is nullable.
            // If both are list types, the variable item type can be more strict
            // than the expected item type (contravariant).
            const schema = context.getSchema();
            const varType = typeFromAST(schema, varDef.type);

            if (
              varType &&
              !allowedVariableUsage(
                schema,
                varType,
                varDef.defaultValue,
                type,
                defaultValue,
              )
            ) {
              const varTypeStr = inspect(varType);
              const typeStr = inspect(type);
              context.reportError(
                new GraphQLError(
                  `Variable "$${varName}" of type "${varTypeStr}" used in position expecting type "${typeStr}".`,
                  {
                    nodes: [varDef, node],
                  },
                ),
              );
            }
          }
        }
      },
    },

    VariableDefinition(node) {
      varDefMap[node.variable.name.value] = node;
    },
  };
}
/**
 * Returns true if the variable is allowed in the location it was found,
 * which includes considering if default values exist for either the variable
 * or the location at which it is located.
 */

function allowedVariableUsage(
  schema,
  varType,
  varDefaultValue,
  locationType,
  locationDefaultValue,
) {
  if (isNonNullType(locationType) && !isNonNullType(varType)) {
    const hasNonNullVariableDefaultValue =
      varDefaultValue != null && varDefaultValue.kind !== Kind.NULL;
    const hasLocationDefaultValue = locationDefaultValue !== undefined;

    if (!hasNonNullVariableDefaultValue && !hasLocationDefaultValue) {
      return false;
    }

    const nullableLocationType = locationType.ofType;
    return isTypeSubTypeOf(schema, varType, nullableLocationType);
  }

  return isTypeSubTypeOf(schema, varType, locationType);
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/specifiedRules.mjs
// Spec Section: "Executable Definitions"
 // Spec Section: "Field Selections on Objects, Interfaces, and Unions Types"

 // Spec Section: "Fragments on Composite Types"

 // Spec Section: "Argument Names"

 // Spec Section: "Directives Are Defined"

 // Spec Section: "Fragment spread target defined"

 // Spec Section: "Fragment Spread Type Existence"

 // Spec Section: "Lone Anonymous Operation"

 // SDL-specific validation rules

 // Spec Section: "Fragments must not form cycles"

 // Spec Section: "All Variable Used Defined"

 // Spec Section: "Fragments must be used"

 // Spec Section: "All Variables Used"

 // Spec Section: "Field Selection Merging"

 // Spec Section: "Fragment spread is possible"


 // Spec Section: "Argument Optionality"

 // Spec Section: "Leaf Field Selections"

 // Spec Section: "Subscriptions with Single Root Field"


 // Spec Section: "Argument Uniqueness"


 // Spec Section: "Directives Are Unique Per Location"



 // Spec Section: "Fragment Name Uniqueness"

 // Spec Section: "Input Object Field Uniqueness"

 // Spec Section: "Operation Name Uniqueness"



 // Spec Section: "Variable Uniqueness"

 // Spec Section: "Value Type Correctness"

 // Spec Section: "Variables are Input Types"

 // Spec Section: "All Variable Usages Are Allowed"



/**
 * This set includes all validation rules defined by the GraphQL spec.
 *
 * The order of the rules in this list has been adjusted to lead to the
 * most clear output when encountering multiple validation errors.
 */
const specifiedRules = Object.freeze([
  ExecutableDefinitionsRule,
  UniqueOperationNamesRule,
  LoneAnonymousOperationRule,
  SingleFieldSubscriptionsRule,
  KnownTypeNamesRule,
  FragmentsOnCompositeTypesRule,
  VariablesAreInputTypesRule,
  ScalarLeafsRule,
  FieldsOnCorrectTypeRule,
  UniqueFragmentNamesRule,
  KnownFragmentNamesRule,
  NoUnusedFragmentsRule,
  PossibleFragmentSpreadsRule,
  NoFragmentCyclesRule,
  UniqueVariableNamesRule,
  NoUndefinedVariablesRule,
  NoUnusedVariablesRule,
  KnownDirectivesRule,
  UniqueDirectivesPerLocationRule,
  KnownArgumentNamesRule,
  UniqueArgumentNamesRule,
  ValuesOfCorrectTypeRule,
  ProvidedRequiredArgumentsRule,
  VariablesInAllowedPositionRule,
  OverlappingFieldsCanBeMergedRule,
  UniqueInputFieldNamesRule,
]);
/**
 * @internal
 */

const specifiedSDLRules = Object.freeze([
  LoneSchemaDefinitionRule,
  UniqueOperationTypesRule,
  UniqueTypeNamesRule,
  UniqueEnumValueNamesRule,
  UniqueFieldDefinitionNamesRule,
  UniqueArgumentDefinitionNamesRule,
  UniqueDirectiveNamesRule,
  KnownTypeNamesRule,
  KnownDirectivesRule,
  UniqueDirectivesPerLocationRule,
  PossibleTypeExtensionsRule,
  KnownArgumentNamesOnDirectivesRule,
  UniqueArgumentNamesRule,
  UniqueInputFieldNamesRule,
  ProvidedRequiredArgumentsOnDirectivesRule,
]);

;// CONCATENATED MODULE: ../node_modules/graphql/validation/ValidationContext.mjs




/**
 * An instance of this class is passed as the "this" context to all validators,
 * allowing access to commonly useful contextual information from within a
 * validation rule.
 */
class ASTValidationContext {
  constructor(ast, onError) {
    this._ast = ast;
    this._fragments = undefined;
    this._fragmentSpreads = new Map();
    this._recursivelyReferencedFragments = new Map();
    this._onError = onError;
  }

  get [Symbol.toStringTag]() {
    return 'ASTValidationContext';
  }

  reportError(error) {
    this._onError(error);
  }

  getDocument() {
    return this._ast;
  }

  getFragment(name) {
    let fragments;

    if (this._fragments) {
      fragments = this._fragments;
    } else {
      fragments = Object.create(null);

      for (const defNode of this.getDocument().definitions) {
        if (defNode.kind === Kind.FRAGMENT_DEFINITION) {
          fragments[defNode.name.value] = defNode;
        }
      }

      this._fragments = fragments;
    }

    return fragments[name];
  }

  getFragmentSpreads(node) {
    let spreads = this._fragmentSpreads.get(node);

    if (!spreads) {
      spreads = [];
      const setsToVisit = [node];
      let set;

      while ((set = setsToVisit.pop())) {
        for (const selection of set.selections) {
          if (selection.kind === Kind.FRAGMENT_SPREAD) {
            spreads.push(selection);
          } else if (selection.selectionSet) {
            setsToVisit.push(selection.selectionSet);
          }
        }
      }

      this._fragmentSpreads.set(node, spreads);
    }

    return spreads;
  }

  getRecursivelyReferencedFragments(operation) {
    let fragments = this._recursivelyReferencedFragments.get(operation);

    if (!fragments) {
      fragments = [];
      const collectedNames = Object.create(null);
      const nodesToVisit = [operation.selectionSet];
      let node;

      while ((node = nodesToVisit.pop())) {
        for (const spread of this.getFragmentSpreads(node)) {
          const fragName = spread.name.value;

          if (collectedNames[fragName] !== true) {
            collectedNames[fragName] = true;
            const fragment = this.getFragment(fragName);

            if (fragment) {
              fragments.push(fragment);
              nodesToVisit.push(fragment.selectionSet);
            }
          }
        }
      }

      this._recursivelyReferencedFragments.set(operation, fragments);
    }

    return fragments;
  }
}
class SDLValidationContext extends ASTValidationContext {
  constructor(ast, schema, onError) {
    super(ast, onError);
    this._schema = schema;
  }

  get [Symbol.toStringTag]() {
    return 'SDLValidationContext';
  }

  getSchema() {
    return this._schema;
  }
}
class ValidationContext extends ASTValidationContext {
  constructor(schema, ast, typeInfo, onError) {
    super(ast, onError);
    this._schema = schema;
    this._typeInfo = typeInfo;
    this._variableUsages = new Map();
    this._recursiveVariableUsages = new Map();
  }

  get [Symbol.toStringTag]() {
    return 'ValidationContext';
  }

  getSchema() {
    return this._schema;
  }

  getVariableUsages(node) {
    let usages = this._variableUsages.get(node);

    if (!usages) {
      const newUsages = [];
      const typeInfo = new TypeInfo(this._schema);
      visit(
        node,
        visitWithTypeInfo(typeInfo, {
          VariableDefinition: () => false,

          Variable(variable) {
            newUsages.push({
              node: variable,
              type: typeInfo.getInputType(),
              defaultValue: typeInfo.getDefaultValue(),
            });
          },
        }),
      );
      usages = newUsages;

      this._variableUsages.set(node, usages);
    }

    return usages;
  }

  getRecursiveVariableUsages(operation) {
    let usages = this._recursiveVariableUsages.get(operation);

    if (!usages) {
      usages = this.getVariableUsages(operation);

      for (const frag of this.getRecursivelyReferencedFragments(operation)) {
        usages = usages.concat(this.getVariableUsages(frag));
      }

      this._recursiveVariableUsages.set(operation, usages);
    }

    return usages;
  }

  getType() {
    return this._typeInfo.getType();
  }

  getParentType() {
    return this._typeInfo.getParentType();
  }

  getInputType() {
    return this._typeInfo.getInputType();
  }

  getParentInputType() {
    return this._typeInfo.getParentInputType();
  }

  getFieldDef() {
    return this._typeInfo.getFieldDef();
  }

  getDirective() {
    return this._typeInfo.getDirective();
  }

  getArgument() {
    return this._typeInfo.getArgument();
  }

  getEnumValue() {
    return this._typeInfo.getEnumValue();
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/validate.mjs







/**
 * Implements the "Validation" section of the spec.
 *
 * Validation runs synchronously, returning an array of encountered errors, or
 * an empty array if no errors were encountered and the document is valid.
 *
 * A list of specific validation rules may be provided. If not provided, the
 * default list of rules defined by the GraphQL specification will be used.
 *
 * Each validation rules is a function which returns a visitor
 * (see the language/visitor API). Visitor methods are expected to return
 * GraphQLErrors, or Arrays of GraphQLErrors when invalid.
 *
 * Validate will stop validation after a `maxErrors` limit has been reached.
 * Attackers can send pathologically invalid queries to induce a DoS attack,
 * so by default `maxErrors` set to 100 errors.
 *
 * Optionally a custom TypeInfo instance may be provided. If not provided, one
 * will be created from the provided schema.
 */

function validate(
  schema,
  documentAST,
  rules = specifiedRules,
  options,
  /** @deprecated will be removed in 17.0.0 */
  typeInfo = new TypeInfo(schema),
) {
  var _options$maxErrors;

  const maxErrors =
    (_options$maxErrors =
      options === null || options === void 0 ? void 0 : options.maxErrors) !==
      null && _options$maxErrors !== void 0
      ? _options$maxErrors
      : 100;
  documentAST || devAssert(false, 'Must provide document.'); // If the schema used for validation is invalid, throw an error.

  assertValidSchema(schema);
  const abortObj = Object.freeze({});
  const errors = [];
  const context = new ValidationContext(
    schema,
    documentAST,
    typeInfo,
    (error) => {
      if (errors.length >= maxErrors) {
        errors.push(
          new GraphQLError(
            'Too many validation errors, error limit reached. Validation aborted.',
          ),
        ); // eslint-disable-next-line @typescript-eslint/no-throw-literal

        throw abortObj;
      }

      errors.push(error);
    },
  ); // This uses a specialized visitor which runs multiple visitors in parallel,
  // while maintaining the visitor skip and break API.

  const visitor = visitInParallel(rules.map((rule) => rule(context))); // Visit the whole document with each instance of all provided rules.

  try {
    visit(documentAST, visitWithTypeInfo(typeInfo, visitor));
  } catch (e) {
    if (e !== abortObj) {
      throw e;
    }
  }

  return errors;
}
/**
 * @internal
 */

function validateSDL(
  documentAST,
  schemaToExtend,
  rules = specifiedSDLRules,
) {
  const errors = [];
  const context = new SDLValidationContext(
    documentAST,
    schemaToExtend,
    (error) => {
      errors.push(error);
    },
  );
  const visitors = rules.map((rule) => rule(context));
  visit(documentAST, visitInParallel(visitors));
  return errors;
}
/**
 * Utility function which asserts a SDL document is valid by throwing an error
 * if it is invalid.
 *
 * @internal
 */

function assertValidSDL(documentAST) {
  const errors = validateSDL(documentAST);

  if (errors.length !== 0) {
    throw new Error(errors.map((error) => error.message).join('\n\n'));
  }
}
/**
 * Utility function which asserts a SDL document is valid by throwing an error
 * if it is invalid.
 *
 * @internal
 */

function assertValidSDLExtension(documentAST, schema) {
  const errors = validateSDL(documentAST, schema);

  if (errors.length !== 0) {
    throw new Error(errors.map((error) => error.message).join('\n\n'));
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/memoize3.mjs
/**
 * Memoizes the provided three-argument function.
 */
function memoize3(fn) {
  let cache0;
  return function memoized(a1, a2, a3) {
    if (cache0 === undefined) {
      cache0 = new WeakMap();
    }

    let cache1 = cache0.get(a1);

    if (cache1 === undefined) {
      cache1 = new WeakMap();
      cache0.set(a1, cache1);
    }

    let cache2 = cache1.get(a2);

    if (cache2 === undefined) {
      cache2 = new WeakMap();
      cache1.set(a2, cache2);
    }

    let fnResult = cache2.get(a3);

    if (fnResult === undefined) {
      fnResult = fn(a1, a2, a3);
      cache2.set(a3, fnResult);
    }

    return fnResult;
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/promiseForObject.mjs
/**
 * This function transforms a JS object `ObjMap<Promise<T>>` into
 * a `Promise<ObjMap<T>>`
 *
 * This is akin to bluebird's `Promise.props`, but implemented only using
 * `Promise.all` so it will work with any implementation of ES6 promises.
 */
function promiseForObject(object) {
  return Promise.all(Object.values(object)).then((resolvedValues) => {
    const resolvedObject = Object.create(null);

    for (const [i, key] of Object.keys(object).entries()) {
      resolvedObject[key] = resolvedValues[i];
    }

    return resolvedObject;
  });
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/promiseReduce.mjs


/**
 * Similar to Array.prototype.reduce(), however the reducing callback may return
 * a Promise, in which case reduction will continue after each promise resolves.
 *
 * If the callback does not return a Promise, then this function will also not
 * return a Promise.
 */
function promiseReduce(values, callbackFn, initialValue) {
  let accumulator = initialValue;

  for (const value of values) {
    accumulator = isPromise(accumulator)
      ? accumulator.then((resolved) => callbackFn(resolved, value))
      : callbackFn(accumulator, value);
  }

  return accumulator;
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/toError.mjs

/**
 * Sometimes a non-error is thrown, wrap it as an Error instance to ensure a consistent Error interface.
 */

function toError(thrownValue) {
  return thrownValue instanceof Error
    ? thrownValue
    : new NonErrorThrown(thrownValue);
}

class NonErrorThrown extends Error {
  constructor(thrownValue) {
    super('Unexpected error value: ' + inspect(thrownValue));
    this.name = 'NonErrorThrown';
    this.thrownValue = thrownValue;
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/error/locatedError.mjs


/**
 * Given an arbitrary value, presumably thrown while attempting to execute a
 * GraphQL operation, produce a new GraphQLError aware of the location in the
 * document responsible for the original Error.
 */

function locatedError(rawOriginalError, nodes, path) {
  var _nodes;

  const originalError = toError(rawOriginalError); // Note: this uses a brand-check to support GraphQL errors originating from other contexts.

  if (isLocatedGraphQLError(originalError)) {
    return originalError;
  }

  return new GraphQLError(originalError.message, {
    nodes:
      (_nodes = originalError.nodes) !== null && _nodes !== void 0
        ? _nodes
        : nodes,
    source: originalError.source,
    positions: originalError.positions,
    path,
    originalError,
  });
}

function isLocatedGraphQLError(error) {
  return Array.isArray(error.path);
}

;// CONCATENATED MODULE: ../node_modules/graphql/execution/execute.mjs



















/**
 * A memoized collection of relevant subfields with regard to the return
 * type. Memoizing ensures the subfields are not repeatedly calculated, which
 * saves overhead when resolving lists of values.
 */

const execute_collectSubfields = memoize3((exeContext, returnType, fieldNodes) =>
  collectSubfields(
    exeContext.schema,
    exeContext.fragments,
    exeContext.variableValues,
    returnType,
    fieldNodes,
  ),
);
/**
 * Terminology
 *
 * "Definitions" are the generic name for top-level statements in the document.
 * Examples of this include:
 * 1) Operations (such as a query)
 * 2) Fragments
 *
 * "Operations" are a generic name for requests in the document.
 * Examples of this include:
 * 1) query,
 * 2) mutation
 *
 * "Selections" are the definitions that can appear legally and at
 * single level of the query. These include:
 * 1) field references e.g `a`
 * 2) fragment "spreads" e.g. `...c`
 * 3) inline fragment "spreads" e.g. `...on Type { a }`
 */

/**
 * Data that must be available at all points during query execution.
 *
 * Namely, schema of the type system that is currently executing,
 * and the fragments defined in the query document
 */

/**
 * Implements the "Executing requests" section of the GraphQL specification.
 *
 * Returns either a synchronous ExecutionResult (if all encountered resolvers
 * are synchronous), or a Promise of an ExecutionResult that will eventually be
 * resolved and never rejected.
 *
 * If the arguments to this function do not result in a legal execution context,
 * a GraphQLError will be thrown immediately explaining the invalid input.
 */
function execute(args) {
  // Temporary for v15 to v16 migration. Remove in v17
  arguments.length < 2 ||
    devAssert(
      false,
      'graphql@16 dropped long-deprecated support for positional arguments, please pass an object instead.',
    );
  const { schema, document, variableValues, rootValue } = args; // If arguments are missing or incorrect, throw an error.

  assertValidExecutionArguments(schema, document, variableValues); // If a valid execution context cannot be created due to incorrect arguments,
  // a "Response" with only errors is returned.

  const exeContext = buildExecutionContext(args); // Return early errors if execution context failed.

  if (!('schema' in exeContext)) {
    return {
      errors: exeContext,
    };
  } // Return a Promise that will eventually resolve to the data described by
  // The "Response" section of the GraphQL specification.
  //
  // If errors are encountered while executing a GraphQL field, only that
  // field and its descendants will be omitted, and sibling fields will still
  // be executed. An execution which encounters errors will still result in a
  // resolved Promise.
  //
  // Errors from sub-fields of a NonNull type may propagate to the top level,
  // at which point we still log the error and null the parent field, which
  // in this case is the entire response.

  try {
    const { operation } = exeContext;
    const result = executeOperation(exeContext, operation, rootValue);

    if (isPromise(result)) {
      return result.then(
        (data) => buildResponse(data, exeContext.errors),
        (error) => {
          exeContext.errors.push(error);
          return buildResponse(null, exeContext.errors);
        },
      );
    }

    return buildResponse(result, exeContext.errors);
  } catch (error) {
    exeContext.errors.push(error);
    return buildResponse(null, exeContext.errors);
  }
}
/**
 * Also implements the "Executing requests" section of the GraphQL specification.
 * However, it guarantees to complete synchronously (or throw an error) assuming
 * that all field resolvers are also synchronous.
 */

function executeSync(args) {
  const result = execute(args); // Assert that the execution was synchronous.

  if (isPromise(result)) {
    throw new Error('GraphQL execution failed to complete synchronously.');
  }

  return result;
}
/**
 * Given a completed execution context and data, build the `{ errors, data }`
 * response defined by the "Response" section of the GraphQL specification.
 */

function buildResponse(data, errors) {
  return errors.length === 0
    ? {
        data,
      }
    : {
        errors,
        data,
      };
}
/**
 * Essential assertions before executing to provide developer feedback for
 * improper use of the GraphQL library.
 *
 * @internal
 */

function assertValidExecutionArguments(
  schema,
  document,
  rawVariableValues,
) {
  document || devAssert(false, 'Must provide document.'); // If the schema used for execution is invalid, throw an error.

  assertValidSchema(schema); // Variables, if provided, must be an object.

  rawVariableValues == null ||
    isObjectLike(rawVariableValues) ||
    devAssert(
      false,
      'Variables must be provided as an Object where each property is a variable value. Perhaps look to see if an unparsed JSON string was provided.',
    );
}
/**
 * Constructs a ExecutionContext object from the arguments passed to
 * execute, which we will pass throughout the other execution methods.
 *
 * Throws a GraphQLError if a valid execution context cannot be created.
 *
 * @internal
 */

function buildExecutionContext(args) {
  var _definition$name, _operation$variableDe;

  const {
    schema,
    document,
    rootValue,
    contextValue,
    variableValues: rawVariableValues,
    operationName,
    fieldResolver,
    typeResolver,
    subscribeFieldResolver,
  } = args;
  let operation;
  const fragments = Object.create(null);

  for (const definition of document.definitions) {
    switch (definition.kind) {
      case Kind.OPERATION_DEFINITION:
        if (operationName == null) {
          if (operation !== undefined) {
            return [
              new GraphQLError(
                'Must provide operation name if query contains multiple operations.',
              ),
            ];
          }

          operation = definition;
        } else if (
          ((_definition$name = definition.name) === null ||
          _definition$name === void 0
            ? void 0
            : _definition$name.value) === operationName
        ) {
          operation = definition;
        }

        break;

      case Kind.FRAGMENT_DEFINITION:
        fragments[definition.name.value] = definition;
        break;

      default: // ignore non-executable definitions
    }
  }

  if (!operation) {
    if (operationName != null) {
      return [new GraphQLError(`Unknown operation named "${operationName}".`)];
    }

    return [new GraphQLError('Must provide an operation.')];
  } // FIXME: https://github.com/graphql/graphql-js/issues/2203

  /* c8 ignore next */

  const variableDefinitions =
    (_operation$variableDe = operation.variableDefinitions) !== null &&
    _operation$variableDe !== void 0
      ? _operation$variableDe
      : [];
  const coercedVariableValues = getVariableValues(
    schema,
    variableDefinitions,
    rawVariableValues !== null && rawVariableValues !== void 0
      ? rawVariableValues
      : {},
    {
      maxErrors: 50,
    },
  );

  if (coercedVariableValues.errors) {
    return coercedVariableValues.errors;
  }

  return {
    schema,
    fragments,
    rootValue,
    contextValue,
    operation,
    variableValues: coercedVariableValues.coerced,
    fieldResolver:
      fieldResolver !== null && fieldResolver !== void 0
        ? fieldResolver
        : defaultFieldResolver,
    typeResolver:
      typeResolver !== null && typeResolver !== void 0
        ? typeResolver
        : defaultTypeResolver,
    subscribeFieldResolver:
      subscribeFieldResolver !== null && subscribeFieldResolver !== void 0
        ? subscribeFieldResolver
        : defaultFieldResolver,
    errors: [],
  };
}
/**
 * Implements the "Executing operations" section of the spec.
 */

function executeOperation(exeContext, operation, rootValue) {
  const rootType = exeContext.schema.getRootType(operation.operation);

  if (rootType == null) {
    throw new GraphQLError(
      `Schema is not configured to execute ${operation.operation} operation.`,
      {
        nodes: operation,
      },
    );
  }

  const rootFields = collectFields(
    exeContext.schema,
    exeContext.fragments,
    exeContext.variableValues,
    rootType,
    operation.selectionSet,
  );
  const path = undefined;

  switch (operation.operation) {
    case OperationTypeNode.QUERY:
      return executeFields(exeContext, rootType, rootValue, path, rootFields);

    case OperationTypeNode.MUTATION:
      return executeFieldsSerially(
        exeContext,
        rootType,
        rootValue,
        path,
        rootFields,
      );

    case OperationTypeNode.SUBSCRIPTION:
      // TODO: deprecate `subscribe` and move all logic here
      // Temporary solution until we finish merging execute and subscribe together
      return executeFields(exeContext, rootType, rootValue, path, rootFields);
  }
}
/**
 * Implements the "Executing selection sets" section of the spec
 * for fields that must be executed serially.
 */

function executeFieldsSerially(
  exeContext,
  parentType,
  sourceValue,
  path,
  fields,
) {
  return promiseReduce(
    fields.entries(),
    (results, [responseName, fieldNodes]) => {
      const fieldPath = addPath(path, responseName, parentType.name);
      const result = executeField(
        exeContext,
        parentType,
        sourceValue,
        fieldNodes,
        fieldPath,
      );

      if (result === undefined) {
        return results;
      }

      if (isPromise(result)) {
        return result.then((resolvedResult) => {
          results[responseName] = resolvedResult;
          return results;
        });
      }

      results[responseName] = result;
      return results;
    },
    Object.create(null),
  );
}
/**
 * Implements the "Executing selection sets" section of the spec
 * for fields that may be executed in parallel.
 */

function executeFields(exeContext, parentType, sourceValue, path, fields) {
  const results = Object.create(null);
  let containsPromise = false;

  try {
    for (const [responseName, fieldNodes] of fields.entries()) {
      const fieldPath = addPath(path, responseName, parentType.name);
      const result = executeField(
        exeContext,
        parentType,
        sourceValue,
        fieldNodes,
        fieldPath,
      );

      if (result !== undefined) {
        results[responseName] = result;

        if (isPromise(result)) {
          containsPromise = true;
        }
      }
    }
  } catch (error) {
    if (containsPromise) {
      // Ensure that any promises returned by other fields are handled, as they may also reject.
      return promiseForObject(results).finally(() => {
        throw error;
      });
    }

    throw error;
  } // If there are no promises, we can just return the object

  if (!containsPromise) {
    return results;
  } // Otherwise, results is a map from field name to the result of resolving that
  // field, which is possibly a promise. Return a promise that will return this
  // same map, but with any promises replaced with the values they resolved to.

  return promiseForObject(results);
}
/**
 * Implements the "Executing fields" section of the spec
 * In particular, this function figures out the value that the field returns by
 * calling its resolve function, then calls completeValue to complete promises,
 * serialize scalars, or execute the sub-selection-set for objects.
 */

function executeField(exeContext, parentType, source, fieldNodes, path) {
  var _fieldDef$resolve;

  const fieldDef = execute_getFieldDef(exeContext.schema, parentType, fieldNodes[0]);

  if (!fieldDef) {
    return;
  }

  const returnType = fieldDef.type;
  const resolveFn =
    (_fieldDef$resolve = fieldDef.resolve) !== null &&
    _fieldDef$resolve !== void 0
      ? _fieldDef$resolve
      : exeContext.fieldResolver;
  const info = buildResolveInfo(
    exeContext,
    fieldDef,
    fieldNodes,
    parentType,
    path,
  ); // Get the resolve function, regardless of if its result is normal or abrupt (error).

  try {
    // Build a JS object of arguments from the field.arguments AST, using the
    // variables scope to fulfill any variable references.
    // TODO: find a way to memoize, in case this field is within a List type.
    const args = getArgumentValues(
      fieldDef,
      fieldNodes[0],
      exeContext.variableValues,
    ); // The resolve function's optional third argument is a context value that
    // is provided to every resolve function within an execution. It is commonly
    // used to represent an authenticated user, or request-specific caches.

    const contextValue = exeContext.contextValue;
    const result = resolveFn(source, args, contextValue, info);
    let completed;

    if (isPromise(result)) {
      completed = result.then((resolved) =>
        completeValue(exeContext, returnType, fieldNodes, info, path, resolved),
      );
    } else {
      completed = completeValue(
        exeContext,
        returnType,
        fieldNodes,
        info,
        path,
        result,
      );
    }

    if (isPromise(completed)) {
      // Note: we don't rely on a `catch` method, but we do expect "thenable"
      // to take a second callback for the error case.
      return completed.then(undefined, (rawError) => {
        const error = locatedError(rawError, fieldNodes, pathToArray(path));
        return handleFieldError(error, returnType, exeContext);
      });
    }

    return completed;
  } catch (rawError) {
    const error = locatedError(rawError, fieldNodes, pathToArray(path));
    return handleFieldError(error, returnType, exeContext);
  }
}
/**
 * @internal
 */

function buildResolveInfo(
  exeContext,
  fieldDef,
  fieldNodes,
  parentType,
  path,
) {
  // The resolve function's optional fourth argument is a collection of
  // information about the current execution state.
  return {
    fieldName: fieldDef.name,
    fieldNodes,
    returnType: fieldDef.type,
    parentType,
    path,
    schema: exeContext.schema,
    fragments: exeContext.fragments,
    rootValue: exeContext.rootValue,
    operation: exeContext.operation,
    variableValues: exeContext.variableValues,
  };
}

function handleFieldError(error, returnType, exeContext) {
  // If the field type is non-nullable, then it is resolved without any
  // protection from errors, however it still properly locates the error.
  if (isNonNullType(returnType)) {
    throw error;
  } // Otherwise, error protection is applied, logging the error and resolving
  // a null value for this field if one is encountered.

  exeContext.errors.push(error);
  return null;
}
/**
 * Implements the instructions for completeValue as defined in the
 * "Value Completion" section of the spec.
 *
 * If the field type is Non-Null, then this recursively completes the value
 * for the inner type. It throws a field error if that completion returns null,
 * as per the "Nullability" section of the spec.
 *
 * If the field type is a List, then this recursively completes the value
 * for the inner type on each item in the list.
 *
 * If the field type is a Scalar or Enum, ensures the completed value is a legal
 * value of the type by calling the `serialize` method of GraphQL type
 * definition.
 *
 * If the field is an abstract type, determine the runtime type of the value
 * and then complete based on that type
 *
 * Otherwise, the field type expects a sub-selection set, and will complete the
 * value by executing all sub-selections.
 */

function completeValue(exeContext, returnType, fieldNodes, info, path, result) {
  // If result is an Error, throw a located error.
  if (result instanceof Error) {
    throw result;
  } // If field type is NonNull, complete for inner type, and throw field error
  // if result is null.

  if (isNonNullType(returnType)) {
    const completed = completeValue(
      exeContext,
      returnType.ofType,
      fieldNodes,
      info,
      path,
      result,
    );

    if (completed === null) {
      throw new Error(
        `Cannot return null for non-nullable field ${info.parentType.name}.${info.fieldName}.`,
      );
    }

    return completed;
  } // If result value is null or undefined then return null.

  if (result == null) {
    return null;
  } // If field type is List, complete each item in the list with the inner type

  if (isListType(returnType)) {
    return completeListValue(
      exeContext,
      returnType,
      fieldNodes,
      info,
      path,
      result,
    );
  } // If field type is a leaf type, Scalar or Enum, serialize to a valid value,
  // returning null if serialization is not possible.

  if (isLeafType(returnType)) {
    return completeLeafValue(returnType, result);
  } // If field type is an abstract type, Interface or Union, determine the
  // runtime Object type and complete for that type.

  if (isAbstractType(returnType)) {
    return completeAbstractValue(
      exeContext,
      returnType,
      fieldNodes,
      info,
      path,
      result,
    );
  } // If field type is Object, execute and complete all sub-selections.

  if (isObjectType(returnType)) {
    return completeObjectValue(
      exeContext,
      returnType,
      fieldNodes,
      info,
      path,
      result,
    );
  }
  /* c8 ignore next 6 */
  // Not reachable, all possible output types have been considered.

   false ||
    invariant(
      false,
      'Cannot complete value of unexpected output type: ' + inspect(returnType),
    );
}
/**
 * Complete a list value by completing each item in the list with the
 * inner type
 */

function completeListValue(
  exeContext,
  returnType,
  fieldNodes,
  info,
  path,
  result,
) {
  if (!isIterableObject(result)) {
    throw new GraphQLError(
      `Expected Iterable, but did not find one for field "${info.parentType.name}.${info.fieldName}".`,
    );
  } // This is specified as a simple map, however we're optimizing the path
  // where the list contains no Promises by avoiding creating another Promise.

  const itemType = returnType.ofType;
  let containsPromise = false;
  const completedResults = Array.from(result, (item, index) => {
    // No need to modify the info object containing the path,
    // since from here on it is not ever accessed by resolver functions.
    const itemPath = addPath(path, index, undefined);

    try {
      let completedItem;

      if (isPromise(item)) {
        completedItem = item.then((resolved) =>
          completeValue(
            exeContext,
            itemType,
            fieldNodes,
            info,
            itemPath,
            resolved,
          ),
        );
      } else {
        completedItem = completeValue(
          exeContext,
          itemType,
          fieldNodes,
          info,
          itemPath,
          item,
        );
      }

      if (isPromise(completedItem)) {
        containsPromise = true; // Note: we don't rely on a `catch` method, but we do expect "thenable"
        // to take a second callback for the error case.

        return completedItem.then(undefined, (rawError) => {
          const error = locatedError(
            rawError,
            fieldNodes,
            pathToArray(itemPath),
          );
          return handleFieldError(error, itemType, exeContext);
        });
      }

      return completedItem;
    } catch (rawError) {
      const error = locatedError(rawError, fieldNodes, pathToArray(itemPath));
      return handleFieldError(error, itemType, exeContext);
    }
  });
  return containsPromise ? Promise.all(completedResults) : completedResults;
}
/**
 * Complete a Scalar or Enum by serializing to a valid value, returning
 * null if serialization is not possible.
 */

function completeLeafValue(returnType, result) {
  const serializedResult = returnType.serialize(result);

  if (serializedResult == null) {
    throw new Error(
      `Expected \`${inspect(returnType)}.serialize(${inspect(result)})\` to ` +
        `return non-nullable value, returned: ${inspect(serializedResult)}`,
    );
  }

  return serializedResult;
}
/**
 * Complete a value of an abstract type by determining the runtime object type
 * of that value, then complete the value for that type.
 */

function completeAbstractValue(
  exeContext,
  returnType,
  fieldNodes,
  info,
  path,
  result,
) {
  var _returnType$resolveTy;

  const resolveTypeFn =
    (_returnType$resolveTy = returnType.resolveType) !== null &&
    _returnType$resolveTy !== void 0
      ? _returnType$resolveTy
      : exeContext.typeResolver;
  const contextValue = exeContext.contextValue;
  const runtimeType = resolveTypeFn(result, contextValue, info, returnType);

  if (isPromise(runtimeType)) {
    return runtimeType.then((resolvedRuntimeType) =>
      completeObjectValue(
        exeContext,
        ensureValidRuntimeType(
          resolvedRuntimeType,
          exeContext,
          returnType,
          fieldNodes,
          info,
          result,
        ),
        fieldNodes,
        info,
        path,
        result,
      ),
    );
  }

  return completeObjectValue(
    exeContext,
    ensureValidRuntimeType(
      runtimeType,
      exeContext,
      returnType,
      fieldNodes,
      info,
      result,
    ),
    fieldNodes,
    info,
    path,
    result,
  );
}

function ensureValidRuntimeType(
  runtimeTypeName,
  exeContext,
  returnType,
  fieldNodes,
  info,
  result,
) {
  if (runtimeTypeName == null) {
    throw new GraphQLError(
      `Abstract type "${returnType.name}" must resolve to an Object type at runtime for field "${info.parentType.name}.${info.fieldName}". Either the "${returnType.name}" type should provide a "resolveType" function or each possible type should provide an "isTypeOf" function.`,
      fieldNodes,
    );
  } // releases before 16.0.0 supported returning `GraphQLObjectType` from `resolveType`
  // TODO: remove in 17.0.0 release

  if (isObjectType(runtimeTypeName)) {
    throw new GraphQLError(
      'Support for returning GraphQLObjectType from resolveType was removed in graphql-js@16.0.0 please return type name instead.',
    );
  }

  if (typeof runtimeTypeName !== 'string') {
    throw new GraphQLError(
      `Abstract type "${returnType.name}" must resolve to an Object type at runtime for field "${info.parentType.name}.${info.fieldName}" with ` +
        `value ${inspect(result)}, received "${inspect(runtimeTypeName)}".`,
    );
  }

  const runtimeType = exeContext.schema.getType(runtimeTypeName);

  if (runtimeType == null) {
    throw new GraphQLError(
      `Abstract type "${returnType.name}" was resolved to a type "${runtimeTypeName}" that does not exist inside the schema.`,
      {
        nodes: fieldNodes,
      },
    );
  }

  if (!isObjectType(runtimeType)) {
    throw new GraphQLError(
      `Abstract type "${returnType.name}" was resolved to a non-object type "${runtimeTypeName}".`,
      {
        nodes: fieldNodes,
      },
    );
  }

  if (!exeContext.schema.isSubType(returnType, runtimeType)) {
    throw new GraphQLError(
      `Runtime Object type "${runtimeType.name}" is not a possible type for "${returnType.name}".`,
      {
        nodes: fieldNodes,
      },
    );
  }

  return runtimeType;
}
/**
 * Complete an Object value by executing all sub-selections.
 */

function completeObjectValue(
  exeContext,
  returnType,
  fieldNodes,
  info,
  path,
  result,
) {
  // Collect sub-fields to execute to complete this value.
  const subFieldNodes = execute_collectSubfields(exeContext, returnType, fieldNodes); // If there is an isTypeOf predicate function, call it with the
  // current result. If isTypeOf returns false, then raise an error rather
  // than continuing execution.

  if (returnType.isTypeOf) {
    const isTypeOf = returnType.isTypeOf(result, exeContext.contextValue, info);

    if (isPromise(isTypeOf)) {
      return isTypeOf.then((resolvedIsTypeOf) => {
        if (!resolvedIsTypeOf) {
          throw invalidReturnTypeError(returnType, result, fieldNodes);
        }

        return executeFields(
          exeContext,
          returnType,
          result,
          path,
          subFieldNodes,
        );
      });
    }

    if (!isTypeOf) {
      throw invalidReturnTypeError(returnType, result, fieldNodes);
    }
  }

  return executeFields(exeContext, returnType, result, path, subFieldNodes);
}

function invalidReturnTypeError(returnType, result, fieldNodes) {
  return new GraphQLError(
    `Expected value of type "${returnType.name}" but got: ${inspect(result)}.`,
    {
      nodes: fieldNodes,
    },
  );
}
/**
 * If a resolveType function is not given, then a default resolve behavior is
 * used which attempts two strategies:
 *
 * First, See if the provided value has a `__typename` field defined, if so, use
 * that value as name of the resolved type.
 *
 * Otherwise, test each possible type for the abstract type by calling
 * isTypeOf for the object being coerced, returning the first type that matches.
 */

const defaultTypeResolver = function (
  value,
  contextValue,
  info,
  abstractType,
) {
  // First, look for `__typename`.
  if (isObjectLike(value) && typeof value.__typename === 'string') {
    return value.__typename;
  } // Otherwise, test each possible type.

  const possibleTypes = info.schema.getPossibleTypes(abstractType);
  const promisedIsTypeOfResults = [];

  for (let i = 0; i < possibleTypes.length; i++) {
    const type = possibleTypes[i];

    if (type.isTypeOf) {
      const isTypeOfResult = type.isTypeOf(value, contextValue, info);

      if (isPromise(isTypeOfResult)) {
        promisedIsTypeOfResults[i] = isTypeOfResult;
      } else if (isTypeOfResult) {
        return type.name;
      }
    }
  }

  if (promisedIsTypeOfResults.length) {
    return Promise.all(promisedIsTypeOfResults).then((isTypeOfResults) => {
      for (let i = 0; i < isTypeOfResults.length; i++) {
        if (isTypeOfResults[i]) {
          return possibleTypes[i].name;
        }
      }
    });
  }
};
/**
 * If a resolve function is not given, then a default resolve behavior is used
 * which takes the property of the source object of the same name as the field
 * and returns it as the result, or if it's a function, returns the result
 * of calling that function while passing along args and context value.
 */

const defaultFieldResolver = function (
  source,
  args,
  contextValue,
  info,
) {
  // ensure source is a value for which property access is acceptable.
  if (isObjectLike(source) || typeof source === 'function') {
    const property = source[info.fieldName];

    if (typeof property === 'function') {
      return source[info.fieldName](args, contextValue, info);
    }

    return property;
  }
};
/**
 * This method looks up the field on the given type definition.
 * It has special casing for the three introspection fields,
 * __schema, __type and __typename. __typename is special because
 * it can always be queried as a field, even in situations where no
 * other fields are allowed, like on a Union. __schema and __type
 * could get automatically added to the query type, but that would
 * require mutating type definitions, which would cause issues.
 *
 * @internal
 */

function execute_getFieldDef(schema, parentType, fieldNode) {
  const fieldName = fieldNode.name.value;

  if (
    fieldName === SchemaMetaFieldDef.name &&
    schema.getQueryType() === parentType
  ) {
    return SchemaMetaFieldDef;
  } else if (
    fieldName === TypeMetaFieldDef.name &&
    schema.getQueryType() === parentType
  ) {
    return TypeMetaFieldDef;
  } else if (fieldName === TypeNameMetaFieldDef.name) {
    return TypeNameMetaFieldDef;
  }

  return parentType.getFields()[fieldName];
}

;// CONCATENATED MODULE: ../node_modules/graphql/graphql.mjs






/**
 * This is the primary entry point function for fulfilling GraphQL operations
 * by parsing, validating, and executing a GraphQL document along side a
 * GraphQL schema.
 *
 * More sophisticated GraphQL servers, such as those which persist queries,
 * may wish to separate the validation and execution phases to a static time
 * tooling step, and a server runtime step.
 *
 * Accepts either an object with named arguments, or individual arguments:
 *
 * schema:
 *    The GraphQL type system to use when validating and executing a query.
 * source:
 *    A GraphQL language formatted string representing the requested operation.
 * rootValue:
 *    The value provided as the first argument to resolver functions on the top
 *    level type (e.g. the query object type).
 * contextValue:
 *    The context value is provided as an argument to resolver functions after
 *    field arguments. It is used to pass shared information useful at any point
 *    during executing this query, for example the currently logged in user and
 *    connections to databases or other services.
 * variableValues:
 *    A mapping of variable name to runtime value to use for all variables
 *    defined in the requestString.
 * operationName:
 *    The name of the operation to use if requestString contains multiple
 *    possible operations. Can be omitted if requestString contains only
 *    one operation.
 * fieldResolver:
 *    A resolver function to use when one is not provided by the schema.
 *    If not provided, the default field resolver is used (which looks for a
 *    value or method on the source value with the field's name).
 * typeResolver:
 *    A type resolver function to use when none is provided by the schema.
 *    If not provided, the default type resolver is used (which looks for a
 *    `__typename` field or alternatively calls the `isTypeOf` method).
 */

function graphql(args) {
  // Always return a Promise for a consistent API.
  return new Promise((resolve) => resolve(graphqlImpl(args)));
}
/**
 * The graphqlSync function also fulfills GraphQL operations by parsing,
 * validating, and executing a GraphQL document along side a GraphQL schema.
 * However, it guarantees to complete synchronously (or throw an error) assuming
 * that all field resolvers are also synchronous.
 */

function graphqlSync(args) {
  const result = graphqlImpl(args); // Assert that the execution was synchronous.

  if (isPromise(result)) {
    throw new Error('GraphQL execution failed to complete synchronously.');
  }

  return result;
}

function graphqlImpl(args) {
  // Temporary for v15 to v16 migration. Remove in v17
  arguments.length < 2 ||
    devAssert(
      false,
      'graphql@16 dropped long-deprecated support for positional arguments, please pass an object instead.',
    );
  const {
    schema,
    source,
    rootValue,
    contextValue,
    variableValues,
    operationName,
    fieldResolver,
    typeResolver,
  } = args; // Validate Schema

  const schemaValidationErrors = validateSchema(schema);

  if (schemaValidationErrors.length > 0) {
    return {
      errors: schemaValidationErrors,
    };
  } // Parse

  let document;

  try {
    document = parse(source);
  } catch (syntaxError) {
    return {
      errors: [syntaxError],
    };
  } // Validate

  const validationErrors = validate(schema, document);

  if (validationErrors.length > 0) {
    return {
      errors: validationErrors,
    };
  } // Execute

  return execute({
    schema,
    document,
    rootValue,
    contextValue,
    variableValues,
    operationName,
    fieldResolver,
    typeResolver,
  });
}

;// CONCATENATED MODULE: ../node_modules/graphql/jsutils/isAsyncIterable.mjs
/**
 * Returns true if the provided object implements the AsyncIterator protocol via
 * implementing a `Symbol.asyncIterator` method.
 */
function isAsyncIterable(maybeAsyncIterable) {
  return (
    typeof (maybeAsyncIterable === null || maybeAsyncIterable === void 0
      ? void 0
      : maybeAsyncIterable[Symbol.asyncIterator]) === 'function'
  );
}

;// CONCATENATED MODULE: ../node_modules/graphql/execution/mapAsyncIterator.mjs
/**
 * Given an AsyncIterable and a callback function, return an AsyncIterator
 * which produces values mapped via calling the callback function.
 */
function mapAsyncIterator(iterable, callback) {
  const iterator = iterable[Symbol.asyncIterator]();

  async function mapResult(result) {
    if (result.done) {
      return result;
    }

    try {
      return {
        value: await callback(result.value),
        done: false,
      };
    } catch (error) {
      /* c8 ignore start */
      // FIXME: add test case
      if (typeof iterator.return === 'function') {
        try {
          await iterator.return();
        } catch (_e) {
          /* ignore error */
        }
      }

      throw error;
      /* c8 ignore stop */
    }
  }

  return {
    async next() {
      return mapResult(await iterator.next());
    },

    async return() {
      // If iterator.return() does not exist, then type R must be undefined.
      return typeof iterator.return === 'function'
        ? mapResult(await iterator.return())
        : {
            value: undefined,
            done: true,
          };
    },

    async throw(error) {
      if (typeof iterator.throw === 'function') {
        return mapResult(await iterator.throw(error));
      }

      throw error;
    },

    [Symbol.asyncIterator]() {
      return this;
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/execution/subscribe.mjs










/**
 * Implements the "Subscribe" algorithm described in the GraphQL specification.
 *
 * Returns a Promise which resolves to either an AsyncIterator (if successful)
 * or an ExecutionResult (error). The promise will be rejected if the schema or
 * other arguments to this function are invalid, or if the resolved event stream
 * is not an async iterable.
 *
 * If the client-provided arguments to this function do not result in a
 * compliant subscription, a GraphQL Response (ExecutionResult) with
 * descriptive errors and no data will be returned.
 *
 * If the source stream could not be created due to faulty subscription
 * resolver logic or underlying systems, the promise will resolve to a single
 * ExecutionResult containing `errors` and no `data`.
 *
 * If the operation succeeded, the promise resolves to an AsyncIterator, which
 * yields a stream of ExecutionResults representing the response stream.
 *
 * Accepts either an object with named arguments, or individual arguments.
 */

async function subscribe(args) {
  // Temporary for v15 to v16 migration. Remove in v17
  arguments.length < 2 ||
    devAssert(
      false,
      'graphql@16 dropped long-deprecated support for positional arguments, please pass an object instead.',
    );
  const resultOrStream = await createSourceEventStream(args);

  if (!isAsyncIterable(resultOrStream)) {
    return resultOrStream;
  } // For each payload yielded from a subscription, map it over the normal
  // GraphQL `execute` function, with `payload` as the rootValue.
  // This implements the "MapSourceToResponseEvent" algorithm described in
  // the GraphQL specification. The `execute` function provides the
  // "ExecuteSubscriptionEvent" algorithm, as it is nearly identical to the
  // "ExecuteQuery" algorithm, for which `execute` is also used.

  const mapSourceToResponse = (payload) =>
    execute({ ...args, rootValue: payload }); // Map every source value to a ExecutionResult value as described above.

  return mapAsyncIterator(resultOrStream, mapSourceToResponse);
}

function toNormalizedArgs(args) {
  const firstArg = args[0];

  if (firstArg && 'document' in firstArg) {
    return firstArg;
  }

  return {
    schema: firstArg,
    // FIXME: when underlying TS bug fixed, see https://github.com/microsoft/TypeScript/issues/31613
    document: args[1],
    rootValue: args[2],
    contextValue: args[3],
    variableValues: args[4],
    operationName: args[5],
    subscribeFieldResolver: args[6],
  };
}
/**
 * Implements the "CreateSourceEventStream" algorithm described in the
 * GraphQL specification, resolving the subscription source event stream.
 *
 * Returns a Promise which resolves to either an AsyncIterable (if successful)
 * or an ExecutionResult (error). The promise will be rejected if the schema or
 * other arguments to this function are invalid, or if the resolved event stream
 * is not an async iterable.
 *
 * If the client-provided arguments to this function do not result in a
 * compliant subscription, a GraphQL Response (ExecutionResult) with
 * descriptive errors and no data will be returned.
 *
 * If the the source stream could not be created due to faulty subscription
 * resolver logic or underlying systems, the promise will resolve to a single
 * ExecutionResult containing `errors` and no `data`.
 *
 * If the operation succeeded, the promise resolves to the AsyncIterable for the
 * event stream returned by the resolver.
 *
 * A Source Event Stream represents a sequence of events, each of which triggers
 * a GraphQL execution for that event.
 *
 * This may be useful when hosting the stateful subscription service in a
 * different process or machine than the stateless GraphQL execution engine,
 * or otherwise separating these two steps. For more on this, see the
 * "Supporting Subscriptions at Scale" information in the GraphQL specification.
 */

async function createSourceEventStream(...rawArgs) {
  const args = toNormalizedArgs(rawArgs);
  const { schema, document, variableValues } = args; // If arguments are missing or incorrectly typed, this is an internal
  // developer mistake which should throw an early error.

  assertValidExecutionArguments(schema, document, variableValues); // If a valid execution context cannot be created due to incorrect arguments,
  // a "Response" with only errors is returned.

  const exeContext = buildExecutionContext(args); // Return early errors if execution context failed.

  if (!('schema' in exeContext)) {
    return {
      errors: exeContext,
    };
  }

  try {
    const eventStream = await executeSubscription(exeContext); // Assert field returned an event stream, otherwise yield an error.

    if (!isAsyncIterable(eventStream)) {
      throw new Error(
        'Subscription field must return Async Iterable. ' +
          `Received: ${inspect(eventStream)}.`,
      );
    }

    return eventStream;
  } catch (error) {
    // If it GraphQLError, report it as an ExecutionResult, containing only errors and no data.
    // Otherwise treat the error as a system-class error and re-throw it.
    if (error instanceof GraphQLError) {
      return {
        errors: [error],
      };
    }

    throw error;
  }
}

async function executeSubscription(exeContext) {
  const { schema, fragments, operation, variableValues, rootValue } =
    exeContext;
  const rootType = schema.getSubscriptionType();

  if (rootType == null) {
    throw new GraphQLError(
      'Schema is not configured to execute subscription operation.',
      {
        nodes: operation,
      },
    );
  }

  const rootFields = collectFields(
    schema,
    fragments,
    variableValues,
    rootType,
    operation.selectionSet,
  );
  const [responseName, fieldNodes] = [...rootFields.entries()][0];
  const fieldDef = execute_getFieldDef(schema, rootType, fieldNodes[0]);

  if (!fieldDef) {
    const fieldName = fieldNodes[0].name.value;
    throw new GraphQLError(
      `The subscription field "${fieldName}" is not defined.`,
      {
        nodes: fieldNodes,
      },
    );
  }

  const path = addPath(undefined, responseName, rootType.name);
  const info = buildResolveInfo(
    exeContext,
    fieldDef,
    fieldNodes,
    rootType,
    path,
  );

  try {
    var _fieldDef$subscribe;

    // Implements the "ResolveFieldEventStream" algorithm from GraphQL specification.
    // It differs from "ResolveFieldValue" due to providing a different `resolveFn`.
    // Build a JS object of arguments from the field.arguments AST, using the
    // variables scope to fulfill any variable references.
    const args = getArgumentValues(fieldDef, fieldNodes[0], variableValues); // The resolve function's optional third argument is a context value that
    // is provided to every resolve function within an execution. It is commonly
    // used to represent an authenticated user, or request-specific caches.

    const contextValue = exeContext.contextValue; // Call the `subscribe()` resolver or the default resolver to produce an
    // AsyncIterable yielding raw payloads.

    const resolveFn =
      (_fieldDef$subscribe = fieldDef.subscribe) !== null &&
      _fieldDef$subscribe !== void 0
        ? _fieldDef$subscribe
        : exeContext.subscribeFieldResolver;
    const eventStream = await resolveFn(rootValue, args, contextValue, info);

    if (eventStream instanceof Error) {
      throw eventStream;
    }

    return eventStream;
  } catch (error) {
    throw locatedError(error, fieldNodes, pathToArray(path));
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/custom/NoDeprecatedCustomRule.mjs




/**
 * No deprecated
 *
 * A GraphQL document is only valid if all selected fields and all used enum values have not been
 * deprecated.
 *
 * Note: This rule is optional and is not part of the Validation section of the GraphQL
 * Specification. The main purpose of this rule is detection of deprecated usages and not
 * necessarily to forbid their use when querying a service.
 */
function NoDeprecatedCustomRule(context) {
  return {
    Field(node) {
      const fieldDef = context.getFieldDef();
      const deprecationReason =
        fieldDef === null || fieldDef === void 0
          ? void 0
          : fieldDef.deprecationReason;

      if (fieldDef && deprecationReason != null) {
        const parentType = context.getParentType();
        parentType != null || invariant(false);
        context.reportError(
          new GraphQLError(
            `The field ${parentType.name}.${fieldDef.name} is deprecated. ${deprecationReason}`,
            {
              nodes: node,
            },
          ),
        );
      }
    },

    Argument(node) {
      const argDef = context.getArgument();
      const deprecationReason =
        argDef === null || argDef === void 0
          ? void 0
          : argDef.deprecationReason;

      if (argDef && deprecationReason != null) {
        const directiveDef = context.getDirective();

        if (directiveDef != null) {
          context.reportError(
            new GraphQLError(
              `Directive "@${directiveDef.name}" argument "${argDef.name}" is deprecated. ${deprecationReason}`,
              {
                nodes: node,
              },
            ),
          );
        } else {
          const parentType = context.getParentType();
          const fieldDef = context.getFieldDef();
          (parentType != null && fieldDef != null) || invariant(false);
          context.reportError(
            new GraphQLError(
              `Field "${parentType.name}.${fieldDef.name}" argument "${argDef.name}" is deprecated. ${deprecationReason}`,
              {
                nodes: node,
              },
            ),
          );
        }
      }
    },

    ObjectField(node) {
      const inputObjectDef = getNamedType(context.getParentInputType());

      if (isInputObjectType(inputObjectDef)) {
        const inputFieldDef = inputObjectDef.getFields()[node.name.value];
        const deprecationReason =
          inputFieldDef === null || inputFieldDef === void 0
            ? void 0
            : inputFieldDef.deprecationReason;

        if (deprecationReason != null) {
          context.reportError(
            new GraphQLError(
              `The input field ${inputObjectDef.name}.${inputFieldDef.name} is deprecated. ${deprecationReason}`,
              {
                nodes: node,
              },
            ),
          );
        }
      }
    },

    EnumValue(node) {
      const enumValueDef = context.getEnumValue();
      const deprecationReason =
        enumValueDef === null || enumValueDef === void 0
          ? void 0
          : enumValueDef.deprecationReason;

      if (enumValueDef && deprecationReason != null) {
        const enumTypeDef = getNamedType(context.getInputType());
        enumTypeDef != null || invariant(false);
        context.reportError(
          new GraphQLError(
            `The enum value "${enumTypeDef.name}.${enumValueDef.name}" is deprecated. ${deprecationReason}`,
            {
              nodes: node,
            },
          ),
        );
      }
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/validation/rules/custom/NoSchemaIntrospectionCustomRule.mjs




/**
 * Prohibit introspection queries
 *
 * A GraphQL document is only valid if all fields selected are not fields that
 * return an introspection type.
 *
 * Note: This rule is optional and is not part of the Validation section of the
 * GraphQL Specification. This rule effectively disables introspection, which
 * does not reflect best practices and should only be done if absolutely necessary.
 */
function NoSchemaIntrospectionCustomRule(context) {
  return {
    Field(node) {
      const type = getNamedType(context.getType());

      if (type && isIntrospectionType(type)) {
        context.reportError(
          new GraphQLError(
            `GraphQL introspection has been disabled, but the requested query contained the field "${node.name.value}".`,
            {
              nodes: node,
            },
          ),
        );
      }
    },
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/getIntrospectionQuery.mjs
/**
 * Produce the GraphQL query recommended for a full schema introspection.
 * Accepts optional IntrospectionOptions.
 */
function getIntrospectionQuery(options) {
  const optionsWithDefault = {
    descriptions: true,
    specifiedByUrl: false,
    directiveIsRepeatable: false,
    schemaDescription: false,
    inputValueDeprecation: false,
    ...options,
  };
  const descriptions = optionsWithDefault.descriptions ? 'description' : '';
  const specifiedByUrl = optionsWithDefault.specifiedByUrl
    ? 'specifiedByURL'
    : '';
  const directiveIsRepeatable = optionsWithDefault.directiveIsRepeatable
    ? 'isRepeatable'
    : '';
  const schemaDescription = optionsWithDefault.schemaDescription
    ? descriptions
    : '';

  function inputDeprecation(str) {
    return optionsWithDefault.inputValueDeprecation ? str : '';
  }

  return `
    query IntrospectionQuery {
      __schema {
        ${schemaDescription}
        queryType { name }
        mutationType { name }
        subscriptionType { name }
        types {
          ...FullType
        }
        directives {
          name
          ${descriptions}
          ${directiveIsRepeatable}
          locations
          args${inputDeprecation('(includeDeprecated: true)')} {
            ...InputValue
          }
        }
      }
    }

    fragment FullType on __Type {
      kind
      name
      ${descriptions}
      ${specifiedByUrl}
      fields(includeDeprecated: true) {
        name
        ${descriptions}
        args${inputDeprecation('(includeDeprecated: true)')} {
          ...InputValue
        }
        type {
          ...TypeRef
        }
        isDeprecated
        deprecationReason
      }
      inputFields${inputDeprecation('(includeDeprecated: true)')} {
        ...InputValue
      }
      interfaces {
        ...TypeRef
      }
      enumValues(includeDeprecated: true) {
        name
        ${descriptions}
        isDeprecated
        deprecationReason
      }
      possibleTypes {
        ...TypeRef
      }
    }

    fragment InputValue on __InputValue {
      name
      ${descriptions}
      type { ...TypeRef }
      defaultValue
      ${inputDeprecation('isDeprecated')}
      ${inputDeprecation('deprecationReason')}
    }

    fragment TypeRef on __Type {
      kind
      name
      ofType {
        kind
        name
        ofType {
          kind
          name
          ofType {
            kind
            name
            ofType {
              kind
              name
              ofType {
                kind
                name
                ofType {
                  kind
                  name
                  ofType {
                    kind
                    name
                    ofType {
                      kind
                      name
                      ofType {
                        kind
                        name
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `;
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/getOperationAST.mjs

/**
 * Returns an operation AST given a document AST and optionally an operation
 * name. If a name is not provided, an operation is only returned if only one is
 * provided in the document.
 */

function getOperationAST(documentAST, operationName) {
  let operation = null;

  for (const definition of documentAST.definitions) {
    if (definition.kind === Kind.OPERATION_DEFINITION) {
      var _definition$name;

      if (operationName == null) {
        // If no operation name was provided, only return an Operation if there
        // is one defined in the document. Upon encountering the second, return
        // null.
        if (operation) {
          return null;
        }

        operation = definition;
      } else if (
        ((_definition$name = definition.name) === null ||
        _definition$name === void 0
          ? void 0
          : _definition$name.value) === operationName
      ) {
        return definition;
      }
    }
  }

  return operation;
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/getOperationRootType.mjs


/**
 * Extracts the root type of the operation from the schema.
 *
 * @deprecated Please use `GraphQLSchema.getRootType` instead. Will be removed in v17
 */
function getOperationRootType(schema, operation) {
  if (operation.operation === 'query') {
    const queryType = schema.getQueryType();

    if (!queryType) {
      throw new GraphQLError(
        'Schema does not define the required query root type.',
        {
          nodes: operation,
        },
      );
    }

    return queryType;
  }

  if (operation.operation === 'mutation') {
    const mutationType = schema.getMutationType();

    if (!mutationType) {
      throw new GraphQLError('Schema is not configured for mutations.', {
        nodes: operation,
      });
    }

    return mutationType;
  }

  if (operation.operation === 'subscription') {
    const subscriptionType = schema.getSubscriptionType();

    if (!subscriptionType) {
      throw new GraphQLError('Schema is not configured for subscriptions.', {
        nodes: operation,
      });
    }

    return subscriptionType;
  }

  throw new GraphQLError(
    'Can only have query, mutation and subscription operations.',
    {
      nodes: operation,
    },
  );
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/introspectionFromSchema.mjs




/**
 * Build an IntrospectionQuery from a GraphQLSchema
 *
 * IntrospectionQuery is useful for utilities that care about type and field
 * relationships, but do not need to traverse through those relationships.
 *
 * This is the inverse of buildClientSchema. The primary use case is outside
 * of the server context, for instance when doing schema comparisons.
 */

function introspectionFromSchema(schema, options) {
  const optionsWithDefaults = {
    specifiedByUrl: true,
    directiveIsRepeatable: true,
    schemaDescription: true,
    inputValueDeprecation: true,
    ...options,
  };
  const document = parse(getIntrospectionQuery(optionsWithDefaults));
  const result = executeSync({
    schema,
    document,
  });
  (!result.errors && result.data) || invariant(false);
  return result.data;
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/buildClientSchema.mjs











/**
 * Build a GraphQLSchema for use by client tools.
 *
 * Given the result of a client running the introspection query, creates and
 * returns a GraphQLSchema instance which can be then used with all graphql-js
 * tools, but cannot be used to execute a query, as introspection does not
 * represent the "resolver", "parse" or "serialize" functions or any other
 * server-internal mechanisms.
 *
 * This function expects a complete introspection result. Don't forget to check
 * the "errors" field of a server response before calling this function.
 */

function buildClientSchema(introspection, options) {
  (isObjectLike(introspection) && isObjectLike(introspection.__schema)) ||
    devAssert(
      false,
      `Invalid or incomplete introspection result. Ensure that you are passing "data" property of introspection response and no "errors" was returned alongside: ${inspect(
        introspection,
      )}.`,
    ); // Get the schema from the introspection result.

  const schemaIntrospection = introspection.__schema; // Iterate through all types, getting the type definition for each.

  const typeMap = keyValMap(
    schemaIntrospection.types,
    (typeIntrospection) => typeIntrospection.name,
    (typeIntrospection) => buildType(typeIntrospection),
  ); // Include standard types only if they are used.

  for (const stdType of [...specifiedScalarTypes, ...introspectionTypes]) {
    if (typeMap[stdType.name]) {
      typeMap[stdType.name] = stdType;
    }
  } // Get the root Query, Mutation, and Subscription types.

  const queryType = schemaIntrospection.queryType
    ? getObjectType(schemaIntrospection.queryType)
    : null;
  const mutationType = schemaIntrospection.mutationType
    ? getObjectType(schemaIntrospection.mutationType)
    : null;
  const subscriptionType = schemaIntrospection.subscriptionType
    ? getObjectType(schemaIntrospection.subscriptionType)
    : null; // Get the directives supported by Introspection, assuming empty-set if
  // directives were not queried for.

  const directives = schemaIntrospection.directives
    ? schemaIntrospection.directives.map(buildDirective)
    : []; // Then produce and return a Schema with these types.

  return new GraphQLSchema({
    description: schemaIntrospection.description,
    query: queryType,
    mutation: mutationType,
    subscription: subscriptionType,
    types: Object.values(typeMap),
    directives,
    assumeValid:
      options === null || options === void 0 ? void 0 : options.assumeValid,
  }); // Given a type reference in introspection, return the GraphQLType instance.
  // preferring cached instances before building new instances.

  function getType(typeRef) {
    if (typeRef.kind === TypeKind.LIST) {
      const itemRef = typeRef.ofType;

      if (!itemRef) {
        throw new Error('Decorated type deeper than introspection query.');
      }

      return new GraphQLList(getType(itemRef));
    }

    if (typeRef.kind === TypeKind.NON_NULL) {
      const nullableRef = typeRef.ofType;

      if (!nullableRef) {
        throw new Error('Decorated type deeper than introspection query.');
      }

      const nullableType = getType(nullableRef);
      return new GraphQLNonNull(assertNullableType(nullableType));
    }

    return getNamedType(typeRef);
  }

  function getNamedType(typeRef) {
    const typeName = typeRef.name;

    if (!typeName) {
      throw new Error(`Unknown type reference: ${inspect(typeRef)}.`);
    }

    const type = typeMap[typeName];

    if (!type) {
      throw new Error(
        `Invalid or incomplete schema, unknown type: ${typeName}. Ensure that a full introspection query is used in order to build a client schema.`,
      );
    }

    return type;
  }

  function getObjectType(typeRef) {
    return assertObjectType(getNamedType(typeRef));
  }

  function getInterfaceType(typeRef) {
    return assertInterfaceType(getNamedType(typeRef));
  } // Given a type's introspection result, construct the correct
  // GraphQLType instance.

  function buildType(type) {
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    if (type != null && type.name != null && type.kind != null) {
      // FIXME: Properly type IntrospectionType, it's a breaking change so fix in v17
      // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
      switch (type.kind) {
        case TypeKind.SCALAR:
          return buildScalarDef(type);

        case TypeKind.OBJECT:
          return buildObjectDef(type);

        case TypeKind.INTERFACE:
          return buildInterfaceDef(type);

        case TypeKind.UNION:
          return buildUnionDef(type);

        case TypeKind.ENUM:
          return buildEnumDef(type);

        case TypeKind.INPUT_OBJECT:
          return buildInputObjectDef(type);
      }
    }

    const typeStr = inspect(type);
    throw new Error(
      `Invalid or incomplete introspection result. Ensure that a full introspection query is used in order to build a client schema: ${typeStr}.`,
    );
  }

  function buildScalarDef(scalarIntrospection) {
    return new GraphQLScalarType({
      name: scalarIntrospection.name,
      description: scalarIntrospection.description,
      specifiedByURL: scalarIntrospection.specifiedByURL,
    });
  }

  function buildImplementationsList(implementingIntrospection) {
    // TODO: Temporary workaround until GraphQL ecosystem will fully support
    // 'interfaces' on interface types.
    if (
      implementingIntrospection.interfaces === null &&
      implementingIntrospection.kind === TypeKind.INTERFACE
    ) {
      return [];
    }

    if (!implementingIntrospection.interfaces) {
      const implementingIntrospectionStr = inspect(implementingIntrospection);
      throw new Error(
        `Introspection result missing interfaces: ${implementingIntrospectionStr}.`,
      );
    }

    return implementingIntrospection.interfaces.map(getInterfaceType);
  }

  function buildObjectDef(objectIntrospection) {
    return new GraphQLObjectType({
      name: objectIntrospection.name,
      description: objectIntrospection.description,
      interfaces: () => buildImplementationsList(objectIntrospection),
      fields: () => buildFieldDefMap(objectIntrospection),
    });
  }

  function buildInterfaceDef(interfaceIntrospection) {
    return new GraphQLInterfaceType({
      name: interfaceIntrospection.name,
      description: interfaceIntrospection.description,
      interfaces: () => buildImplementationsList(interfaceIntrospection),
      fields: () => buildFieldDefMap(interfaceIntrospection),
    });
  }

  function buildUnionDef(unionIntrospection) {
    if (!unionIntrospection.possibleTypes) {
      const unionIntrospectionStr = inspect(unionIntrospection);
      throw new Error(
        `Introspection result missing possibleTypes: ${unionIntrospectionStr}.`,
      );
    }

    return new GraphQLUnionType({
      name: unionIntrospection.name,
      description: unionIntrospection.description,
      types: () => unionIntrospection.possibleTypes.map(getObjectType),
    });
  }

  function buildEnumDef(enumIntrospection) {
    if (!enumIntrospection.enumValues) {
      const enumIntrospectionStr = inspect(enumIntrospection);
      throw new Error(
        `Introspection result missing enumValues: ${enumIntrospectionStr}.`,
      );
    }

    return new GraphQLEnumType({
      name: enumIntrospection.name,
      description: enumIntrospection.description,
      values: keyValMap(
        enumIntrospection.enumValues,
        (valueIntrospection) => valueIntrospection.name,
        (valueIntrospection) => ({
          description: valueIntrospection.description,
          deprecationReason: valueIntrospection.deprecationReason,
        }),
      ),
    });
  }

  function buildInputObjectDef(inputObjectIntrospection) {
    if (!inputObjectIntrospection.inputFields) {
      const inputObjectIntrospectionStr = inspect(inputObjectIntrospection);
      throw new Error(
        `Introspection result missing inputFields: ${inputObjectIntrospectionStr}.`,
      );
    }

    return new GraphQLInputObjectType({
      name: inputObjectIntrospection.name,
      description: inputObjectIntrospection.description,
      fields: () => buildInputValueDefMap(inputObjectIntrospection.inputFields),
    });
  }

  function buildFieldDefMap(typeIntrospection) {
    if (!typeIntrospection.fields) {
      throw new Error(
        `Introspection result missing fields: ${inspect(typeIntrospection)}.`,
      );
    }

    return keyValMap(
      typeIntrospection.fields,
      (fieldIntrospection) => fieldIntrospection.name,
      buildField,
    );
  }

  function buildField(fieldIntrospection) {
    const type = getType(fieldIntrospection.type);

    if (!isOutputType(type)) {
      const typeStr = inspect(type);
      throw new Error(
        `Introspection must provide output type for fields, but received: ${typeStr}.`,
      );
    }

    if (!fieldIntrospection.args) {
      const fieldIntrospectionStr = inspect(fieldIntrospection);
      throw new Error(
        `Introspection result missing field args: ${fieldIntrospectionStr}.`,
      );
    }

    return {
      description: fieldIntrospection.description,
      deprecationReason: fieldIntrospection.deprecationReason,
      type,
      args: buildInputValueDefMap(fieldIntrospection.args),
    };
  }

  function buildInputValueDefMap(inputValueIntrospections) {
    return keyValMap(
      inputValueIntrospections,
      (inputValue) => inputValue.name,
      buildInputValue,
    );
  }

  function buildInputValue(inputValueIntrospection) {
    const type = getType(inputValueIntrospection.type);

    if (!isInputType(type)) {
      const typeStr = inspect(type);
      throw new Error(
        `Introspection must provide input type for arguments, but received: ${typeStr}.`,
      );
    }

    const defaultValue =
      inputValueIntrospection.defaultValue != null
        ? valueFromAST(parseValue(inputValueIntrospection.defaultValue), type)
        : undefined;
    return {
      description: inputValueIntrospection.description,
      type,
      defaultValue,
      deprecationReason: inputValueIntrospection.deprecationReason,
    };
  }

  function buildDirective(directiveIntrospection) {
    if (!directiveIntrospection.args) {
      const directiveIntrospectionStr = inspect(directiveIntrospection);
      throw new Error(
        `Introspection result missing directive args: ${directiveIntrospectionStr}.`,
      );
    }

    if (!directiveIntrospection.locations) {
      const directiveIntrospectionStr = inspect(directiveIntrospection);
      throw new Error(
        `Introspection result missing directive locations: ${directiveIntrospectionStr}.`,
      );
    }

    return new GraphQLDirective({
      name: directiveIntrospection.name,
      description: directiveIntrospection.description,
      isRepeatable: directiveIntrospection.isRepeatable,
      locations: directiveIntrospection.locations.slice(),
      args: buildInputValueDefMap(directiveIntrospection.args),
    });
  }
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/extendSchema.mjs
















/**
 * Produces a new schema given an existing schema and a document which may
 * contain GraphQL type extensions and definitions. The original schema will
 * remain unaltered.
 *
 * Because a schema represents a graph of references, a schema cannot be
 * extended without effectively making an entire copy. We do not know until it's
 * too late if subgraphs remain unchanged.
 *
 * This algorithm copies the provided schema, applying extensions while
 * producing the copy. The original schema remains unaltered.
 */
function extendSchema(schema, documentAST, options) {
  assertSchema(schema);
  (documentAST != null && documentAST.kind === Kind.DOCUMENT) ||
    devAssert(false, 'Must provide valid Document AST.');

  if (
    (options === null || options === void 0 ? void 0 : options.assumeValid) !==
      true &&
    (options === null || options === void 0
      ? void 0
      : options.assumeValidSDL) !== true
  ) {
    assertValidSDLExtension(documentAST, schema);
  }

  const schemaConfig = schema.toConfig();
  const extendedConfig = extendSchemaImpl(schemaConfig, documentAST, options);
  return schemaConfig === extendedConfig
    ? schema
    : new GraphQLSchema(extendedConfig);
}
/**
 * @internal
 */

function extendSchemaImpl(schemaConfig, documentAST, options) {
  var _schemaDef, _schemaDef$descriptio, _schemaDef2, _options$assumeValid;

  // Collect the type definitions and extensions found in the document.
  const typeDefs = [];
  const typeExtensionsMap = Object.create(null); // New directives and types are separate because a directives and types can
  // have the same name. For example, a type named "skip".

  const directiveDefs = [];
  let schemaDef; // Schema extensions are collected which may add additional operation types.

  const schemaExtensions = [];

  for (const def of documentAST.definitions) {
    if (def.kind === Kind.SCHEMA_DEFINITION) {
      schemaDef = def;
    } else if (def.kind === Kind.SCHEMA_EXTENSION) {
      schemaExtensions.push(def);
    } else if (isTypeDefinitionNode(def)) {
      typeDefs.push(def);
    } else if (isTypeExtensionNode(def)) {
      const extendedTypeName = def.name.value;
      const existingTypeExtensions = typeExtensionsMap[extendedTypeName];
      typeExtensionsMap[extendedTypeName] = existingTypeExtensions
        ? existingTypeExtensions.concat([def])
        : [def];
    } else if (def.kind === Kind.DIRECTIVE_DEFINITION) {
      directiveDefs.push(def);
    }
  } // If this document contains no new types, extensions, or directives then
  // return the same unmodified GraphQLSchema instance.

  if (
    Object.keys(typeExtensionsMap).length === 0 &&
    typeDefs.length === 0 &&
    directiveDefs.length === 0 &&
    schemaExtensions.length === 0 &&
    schemaDef == null
  ) {
    return schemaConfig;
  }

  const typeMap = Object.create(null);

  for (const existingType of schemaConfig.types) {
    typeMap[existingType.name] = extendNamedType(existingType);
  }

  for (const typeNode of typeDefs) {
    var _stdTypeMap$name;

    const name = typeNode.name.value;
    typeMap[name] =
      (_stdTypeMap$name = stdTypeMap[name]) !== null &&
      _stdTypeMap$name !== void 0
        ? _stdTypeMap$name
        : buildType(typeNode);
  }

  const operationTypes = {
    // Get the extended root operation types.
    query: schemaConfig.query && replaceNamedType(schemaConfig.query),
    mutation: schemaConfig.mutation && replaceNamedType(schemaConfig.mutation),
    subscription:
      schemaConfig.subscription && replaceNamedType(schemaConfig.subscription),
    // Then, incorporate schema definition and all schema extensions.
    ...(schemaDef && getOperationTypes([schemaDef])),
    ...getOperationTypes(schemaExtensions),
  }; // Then produce and return a Schema config with these types.

  return {
    description:
      (_schemaDef = schemaDef) === null || _schemaDef === void 0
        ? void 0
        : (_schemaDef$descriptio = _schemaDef.description) === null ||
          _schemaDef$descriptio === void 0
        ? void 0
        : _schemaDef$descriptio.value,
    ...operationTypes,
    types: Object.values(typeMap),
    directives: [
      ...schemaConfig.directives.map(replaceDirective),
      ...directiveDefs.map(buildDirective),
    ],
    extensions: Object.create(null),
    astNode:
      (_schemaDef2 = schemaDef) !== null && _schemaDef2 !== void 0
        ? _schemaDef2
        : schemaConfig.astNode,
    extensionASTNodes: schemaConfig.extensionASTNodes.concat(schemaExtensions),
    assumeValid:
      (_options$assumeValid =
        options === null || options === void 0
          ? void 0
          : options.assumeValid) !== null && _options$assumeValid !== void 0
        ? _options$assumeValid
        : false,
  }; // Below are functions used for producing this schema that have closed over
  // this scope and have access to the schema, cache, and newly defined types.

  function replaceType(type) {
    if (isListType(type)) {
      // @ts-expect-error
      return new GraphQLList(replaceType(type.ofType));
    }

    if (isNonNullType(type)) {
      // @ts-expect-error
      return new GraphQLNonNull(replaceType(type.ofType));
    } // @ts-expect-error FIXME

    return replaceNamedType(type);
  }

  function replaceNamedType(type) {
    // Note: While this could make early assertions to get the correctly
    // typed values, that would throw immediately while type system
    // validation with validateSchema() will produce more actionable results.
    return typeMap[type.name];
  }

  function replaceDirective(directive) {
    const config = directive.toConfig();
    return new GraphQLDirective({
      ...config,
      args: mapValue(config.args, extendArg),
    });
  }

  function extendNamedType(type) {
    if (isIntrospectionType(type) || isSpecifiedScalarType(type)) {
      // Builtin types are not extended.
      return type;
    }

    if (isScalarType(type)) {
      return extendScalarType(type);
    }

    if (isObjectType(type)) {
      return extendObjectType(type);
    }

    if (isInterfaceType(type)) {
      return extendInterfaceType(type);
    }

    if (isUnionType(type)) {
      return extendUnionType(type);
    }

    if (isEnumType(type)) {
      return extendEnumType(type);
    }

    if (isInputObjectType(type)) {
      return extendInputObjectType(type);
    }
    /* c8 ignore next 3 */
    // Not reachable, all possible type definition nodes have been considered.

     false || invariant(false, 'Unexpected type: ' + inspect(type));
  }

  function extendInputObjectType(type) {
    var _typeExtensionsMap$co;

    const config = type.toConfig();
    const extensions =
      (_typeExtensionsMap$co = typeExtensionsMap[config.name]) !== null &&
      _typeExtensionsMap$co !== void 0
        ? _typeExtensionsMap$co
        : [];
    return new GraphQLInputObjectType({
      ...config,
      fields: () => ({
        ...mapValue(config.fields, (field) => ({
          ...field,
          type: replaceType(field.type),
        })),
        ...buildInputFieldMap(extensions),
      }),
      extensionASTNodes: config.extensionASTNodes.concat(extensions),
    });
  }

  function extendEnumType(type) {
    var _typeExtensionsMap$ty;

    const config = type.toConfig();
    const extensions =
      (_typeExtensionsMap$ty = typeExtensionsMap[type.name]) !== null &&
      _typeExtensionsMap$ty !== void 0
        ? _typeExtensionsMap$ty
        : [];
    return new GraphQLEnumType({
      ...config,
      values: { ...config.values, ...buildEnumValueMap(extensions) },
      extensionASTNodes: config.extensionASTNodes.concat(extensions),
    });
  }

  function extendScalarType(type) {
    var _typeExtensionsMap$co2;

    const config = type.toConfig();
    const extensions =
      (_typeExtensionsMap$co2 = typeExtensionsMap[config.name]) !== null &&
      _typeExtensionsMap$co2 !== void 0
        ? _typeExtensionsMap$co2
        : [];
    let specifiedByURL = config.specifiedByURL;

    for (const extensionNode of extensions) {
      var _getSpecifiedByURL;

      specifiedByURL =
        (_getSpecifiedByURL = getSpecifiedByURL(extensionNode)) !== null &&
        _getSpecifiedByURL !== void 0
          ? _getSpecifiedByURL
          : specifiedByURL;
    }

    return new GraphQLScalarType({
      ...config,
      specifiedByURL,
      extensionASTNodes: config.extensionASTNodes.concat(extensions),
    });
  }

  function extendObjectType(type) {
    var _typeExtensionsMap$co3;

    const config = type.toConfig();
    const extensions =
      (_typeExtensionsMap$co3 = typeExtensionsMap[config.name]) !== null &&
      _typeExtensionsMap$co3 !== void 0
        ? _typeExtensionsMap$co3
        : [];
    return new GraphQLObjectType({
      ...config,
      interfaces: () => [
        ...type.getInterfaces().map(replaceNamedType),
        ...buildInterfaces(extensions),
      ],
      fields: () => ({
        ...mapValue(config.fields, extendField),
        ...buildFieldMap(extensions),
      }),
      extensionASTNodes: config.extensionASTNodes.concat(extensions),
    });
  }

  function extendInterfaceType(type) {
    var _typeExtensionsMap$co4;

    const config = type.toConfig();
    const extensions =
      (_typeExtensionsMap$co4 = typeExtensionsMap[config.name]) !== null &&
      _typeExtensionsMap$co4 !== void 0
        ? _typeExtensionsMap$co4
        : [];
    return new GraphQLInterfaceType({
      ...config,
      interfaces: () => [
        ...type.getInterfaces().map(replaceNamedType),
        ...buildInterfaces(extensions),
      ],
      fields: () => ({
        ...mapValue(config.fields, extendField),
        ...buildFieldMap(extensions),
      }),
      extensionASTNodes: config.extensionASTNodes.concat(extensions),
    });
  }

  function extendUnionType(type) {
    var _typeExtensionsMap$co5;

    const config = type.toConfig();
    const extensions =
      (_typeExtensionsMap$co5 = typeExtensionsMap[config.name]) !== null &&
      _typeExtensionsMap$co5 !== void 0
        ? _typeExtensionsMap$co5
        : [];
    return new GraphQLUnionType({
      ...config,
      types: () => [
        ...type.getTypes().map(replaceNamedType),
        ...buildUnionTypes(extensions),
      ],
      extensionASTNodes: config.extensionASTNodes.concat(extensions),
    });
  }

  function extendField(field) {
    return {
      ...field,
      type: replaceType(field.type),
      args: field.args && mapValue(field.args, extendArg),
    };
  }

  function extendArg(arg) {
    return { ...arg, type: replaceType(arg.type) };
  }

  function getOperationTypes(nodes) {
    const opTypes = {};

    for (const node of nodes) {
      var _node$operationTypes;

      // FIXME: https://github.com/graphql/graphql-js/issues/2203
      const operationTypesNodes =
        /* c8 ignore next */
        (_node$operationTypes = node.operationTypes) !== null &&
        _node$operationTypes !== void 0
          ? _node$operationTypes
          : [];

      for (const operationType of operationTypesNodes) {
        // Note: While this could make early assertions to get the correctly
        // typed values below, that would throw immediately while type system
        // validation with validateSchema() will produce more actionable results.
        // @ts-expect-error
        opTypes[operationType.operation] = getNamedType(operationType.type);
      }
    }

    return opTypes;
  }

  function getNamedType(node) {
    var _stdTypeMap$name2;

    const name = node.name.value;
    const type =
      (_stdTypeMap$name2 = stdTypeMap[name]) !== null &&
      _stdTypeMap$name2 !== void 0
        ? _stdTypeMap$name2
        : typeMap[name];

    if (type === undefined) {
      throw new Error(`Unknown type: "${name}".`);
    }

    return type;
  }

  function getWrappedType(node) {
    if (node.kind === Kind.LIST_TYPE) {
      return new GraphQLList(getWrappedType(node.type));
    }

    if (node.kind === Kind.NON_NULL_TYPE) {
      return new GraphQLNonNull(getWrappedType(node.type));
    }

    return getNamedType(node);
  }

  function buildDirective(node) {
    var _node$description;

    return new GraphQLDirective({
      name: node.name.value,
      description:
        (_node$description = node.description) === null ||
        _node$description === void 0
          ? void 0
          : _node$description.value,
      // @ts-expect-error
      locations: node.locations.map(({ value }) => value),
      isRepeatable: node.repeatable,
      args: buildArgumentMap(node.arguments),
      astNode: node,
    });
  }

  function buildFieldMap(nodes) {
    const fieldConfigMap = Object.create(null);

    for (const node of nodes) {
      var _node$fields;

      // FIXME: https://github.com/graphql/graphql-js/issues/2203
      const nodeFields =
        /* c8 ignore next */
        (_node$fields = node.fields) !== null && _node$fields !== void 0
          ? _node$fields
          : [];

      for (const field of nodeFields) {
        var _field$description;

        fieldConfigMap[field.name.value] = {
          // Note: While this could make assertions to get the correctly typed
          // value, that would throw immediately while type system validation
          // with validateSchema() will produce more actionable results.
          type: getWrappedType(field.type),
          description:
            (_field$description = field.description) === null ||
            _field$description === void 0
              ? void 0
              : _field$description.value,
          args: buildArgumentMap(field.arguments),
          deprecationReason: getDeprecationReason(field),
          astNode: field,
        };
      }
    }

    return fieldConfigMap;
  }

  function buildArgumentMap(args) {
    // FIXME: https://github.com/graphql/graphql-js/issues/2203
    const argsNodes =
      /* c8 ignore next */
      args !== null && args !== void 0 ? args : [];
    const argConfigMap = Object.create(null);

    for (const arg of argsNodes) {
      var _arg$description;

      // Note: While this could make assertions to get the correctly typed
      // value, that would throw immediately while type system validation
      // with validateSchema() will produce more actionable results.
      const type = getWrappedType(arg.type);
      argConfigMap[arg.name.value] = {
        type,
        description:
          (_arg$description = arg.description) === null ||
          _arg$description === void 0
            ? void 0
            : _arg$description.value,
        defaultValue: valueFromAST(arg.defaultValue, type),
        deprecationReason: getDeprecationReason(arg),
        astNode: arg,
      };
    }

    return argConfigMap;
  }

  function buildInputFieldMap(nodes) {
    const inputFieldMap = Object.create(null);

    for (const node of nodes) {
      var _node$fields2;

      // FIXME: https://github.com/graphql/graphql-js/issues/2203
      const fieldsNodes =
        /* c8 ignore next */
        (_node$fields2 = node.fields) !== null && _node$fields2 !== void 0
          ? _node$fields2
          : [];

      for (const field of fieldsNodes) {
        var _field$description2;

        // Note: While this could make assertions to get the correctly typed
        // value, that would throw immediately while type system validation
        // with validateSchema() will produce more actionable results.
        const type = getWrappedType(field.type);
        inputFieldMap[field.name.value] = {
          type,
          description:
            (_field$description2 = field.description) === null ||
            _field$description2 === void 0
              ? void 0
              : _field$description2.value,
          defaultValue: valueFromAST(field.defaultValue, type),
          deprecationReason: getDeprecationReason(field),
          astNode: field,
        };
      }
    }

    return inputFieldMap;
  }

  function buildEnumValueMap(nodes) {
    const enumValueMap = Object.create(null);

    for (const node of nodes) {
      var _node$values;

      // FIXME: https://github.com/graphql/graphql-js/issues/2203
      const valuesNodes =
        /* c8 ignore next */
        (_node$values = node.values) !== null && _node$values !== void 0
          ? _node$values
          : [];

      for (const value of valuesNodes) {
        var _value$description;

        enumValueMap[value.name.value] = {
          description:
            (_value$description = value.description) === null ||
            _value$description === void 0
              ? void 0
              : _value$description.value,
          deprecationReason: getDeprecationReason(value),
          astNode: value,
        };
      }
    }

    return enumValueMap;
  }

  function buildInterfaces(nodes) {
    // Note: While this could make assertions to get the correctly typed
    // values below, that would throw immediately while type system
    // validation with validateSchema() will produce more actionable results.
    // @ts-expect-error
    return nodes.flatMap(
      // FIXME: https://github.com/graphql/graphql-js/issues/2203
      (node) => {
        var _node$interfaces$map, _node$interfaces;

        return (
          /* c8 ignore next */
          (_node$interfaces$map =
            (_node$interfaces = node.interfaces) === null ||
            _node$interfaces === void 0
              ? void 0
              : _node$interfaces.map(getNamedType)) !== null &&
            _node$interfaces$map !== void 0
            ? _node$interfaces$map
            : []
        );
      },
    );
  }

  function buildUnionTypes(nodes) {
    // Note: While this could make assertions to get the correctly typed
    // values below, that would throw immediately while type system
    // validation with validateSchema() will produce more actionable results.
    // @ts-expect-error
    return nodes.flatMap(
      // FIXME: https://github.com/graphql/graphql-js/issues/2203
      (node) => {
        var _node$types$map, _node$types;

        return (
          /* c8 ignore next */
          (_node$types$map =
            (_node$types = node.types) === null || _node$types === void 0
              ? void 0
              : _node$types.map(getNamedType)) !== null &&
            _node$types$map !== void 0
            ? _node$types$map
            : []
        );
      },
    );
  }

  function buildType(astNode) {
    var _typeExtensionsMap$na;

    const name = astNode.name.value;
    const extensionASTNodes =
      (_typeExtensionsMap$na = typeExtensionsMap[name]) !== null &&
      _typeExtensionsMap$na !== void 0
        ? _typeExtensionsMap$na
        : [];

    switch (astNode.kind) {
      case Kind.OBJECT_TYPE_DEFINITION: {
        var _astNode$description;

        const allNodes = [astNode, ...extensionASTNodes];
        return new GraphQLObjectType({
          name,
          description:
            (_astNode$description = astNode.description) === null ||
            _astNode$description === void 0
              ? void 0
              : _astNode$description.value,
          interfaces: () => buildInterfaces(allNodes),
          fields: () => buildFieldMap(allNodes),
          astNode,
          extensionASTNodes,
        });
      }

      case Kind.INTERFACE_TYPE_DEFINITION: {
        var _astNode$description2;

        const allNodes = [astNode, ...extensionASTNodes];
        return new GraphQLInterfaceType({
          name,
          description:
            (_astNode$description2 = astNode.description) === null ||
            _astNode$description2 === void 0
              ? void 0
              : _astNode$description2.value,
          interfaces: () => buildInterfaces(allNodes),
          fields: () => buildFieldMap(allNodes),
          astNode,
          extensionASTNodes,
        });
      }

      case Kind.ENUM_TYPE_DEFINITION: {
        var _astNode$description3;

        const allNodes = [astNode, ...extensionASTNodes];
        return new GraphQLEnumType({
          name,
          description:
            (_astNode$description3 = astNode.description) === null ||
            _astNode$description3 === void 0
              ? void 0
              : _astNode$description3.value,
          values: buildEnumValueMap(allNodes),
          astNode,
          extensionASTNodes,
        });
      }

      case Kind.UNION_TYPE_DEFINITION: {
        var _astNode$description4;

        const allNodes = [astNode, ...extensionASTNodes];
        return new GraphQLUnionType({
          name,
          description:
            (_astNode$description4 = astNode.description) === null ||
            _astNode$description4 === void 0
              ? void 0
              : _astNode$description4.value,
          types: () => buildUnionTypes(allNodes),
          astNode,
          extensionASTNodes,
        });
      }

      case Kind.SCALAR_TYPE_DEFINITION: {
        var _astNode$description5;

        return new GraphQLScalarType({
          name,
          description:
            (_astNode$description5 = astNode.description) === null ||
            _astNode$description5 === void 0
              ? void 0
              : _astNode$description5.value,
          specifiedByURL: getSpecifiedByURL(astNode),
          astNode,
          extensionASTNodes,
        });
      }

      case Kind.INPUT_OBJECT_TYPE_DEFINITION: {
        var _astNode$description6;

        const allNodes = [astNode, ...extensionASTNodes];
        return new GraphQLInputObjectType({
          name,
          description:
            (_astNode$description6 = astNode.description) === null ||
            _astNode$description6 === void 0
              ? void 0
              : _astNode$description6.value,
          fields: () => buildInputFieldMap(allNodes),
          astNode,
          extensionASTNodes,
        });
      }
    }
  }
}
const stdTypeMap = keyMap(
  [...specifiedScalarTypes, ...introspectionTypes],
  (type) => type.name,
);
/**
 * Given a field or enum value node, returns the string value for the
 * deprecation reason.
 */

function getDeprecationReason(node) {
  const deprecated = getDirectiveValues(GraphQLDeprecatedDirective, node); // @ts-expect-error validated by `getDirectiveValues`

  return deprecated === null || deprecated === void 0
    ? void 0
    : deprecated.reason;
}
/**
 * Given a scalar node, returns the string value for the specifiedByURL.
 */

function getSpecifiedByURL(node) {
  const specifiedBy = getDirectiveValues(GraphQLSpecifiedByDirective, node); // @ts-expect-error validated by `getDirectiveValues`

  return specifiedBy === null || specifiedBy === void 0
    ? void 0
    : specifiedBy.url;
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/buildASTSchema.mjs








/**
 * This takes the ast of a schema document produced by the parse function in
 * src/language/parser.js.
 *
 * If no schema definition is provided, then it will look for types named Query,
 * Mutation and Subscription.
 *
 * Given that AST it constructs a GraphQLSchema. The resulting schema
 * has no resolve methods, so execution will use default resolvers.
 */
function buildASTSchema(documentAST, options) {
  (documentAST != null && documentAST.kind === Kind.DOCUMENT) ||
    devAssert(false, 'Must provide valid Document AST.');

  if (
    (options === null || options === void 0 ? void 0 : options.assumeValid) !==
      true &&
    (options === null || options === void 0
      ? void 0
      : options.assumeValidSDL) !== true
  ) {
    assertValidSDL(documentAST);
  }

  const emptySchemaConfig = {
    description: undefined,
    types: [],
    directives: [],
    extensions: Object.create(null),
    extensionASTNodes: [],
    assumeValid: false,
  };
  const config = extendSchemaImpl(emptySchemaConfig, documentAST, options);

  if (config.astNode == null) {
    for (const type of config.types) {
      switch (type.name) {
        // Note: While this could make early assertions to get the correctly
        // typed values below, that would throw immediately while type system
        // validation with validateSchema() will produce more actionable results.
        case 'Query':
          // @ts-expect-error validated in `validateSchema`
          config.query = type;
          break;

        case 'Mutation':
          // @ts-expect-error validated in `validateSchema`
          config.mutation = type;
          break;

        case 'Subscription':
          // @ts-expect-error validated in `validateSchema`
          config.subscription = type;
          break;
      }
    }
  }

  const directives = [
    ...config.directives, // If specified directives were not explicitly declared, add them.
    ...specifiedDirectives.filter((stdDirective) =>
      config.directives.every(
        (directive) => directive.name !== stdDirective.name,
      ),
    ),
  ];
  return new GraphQLSchema({ ...config, directives });
}
/**
 * A helper function to build a GraphQLSchema directly from a source
 * document.
 */

function buildSchema(source, options) {
  const document = parse(source, {
    noLocation:
      options === null || options === void 0 ? void 0 : options.noLocation,
    allowLegacyFragmentVariables:
      options === null || options === void 0
        ? void 0
        : options.allowLegacyFragmentVariables,
  });
  return buildASTSchema(document, {
    assumeValidSDL:
      options === null || options === void 0 ? void 0 : options.assumeValidSDL,
    assumeValid:
      options === null || options === void 0 ? void 0 : options.assumeValid,
  });
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/lexicographicSortSchema.mjs








/**
 * Sort GraphQLSchema.
 *
 * This function returns a sorted copy of the given GraphQLSchema.
 */

function lexicographicSortSchema(schema) {
  const schemaConfig = schema.toConfig();
  const typeMap = keyValMap(
    sortByName(schemaConfig.types),
    (type) => type.name,
    sortNamedType,
  );
  return new GraphQLSchema({
    ...schemaConfig,
    types: Object.values(typeMap),
    directives: sortByName(schemaConfig.directives).map(sortDirective),
    query: replaceMaybeType(schemaConfig.query),
    mutation: replaceMaybeType(schemaConfig.mutation),
    subscription: replaceMaybeType(schemaConfig.subscription),
  });

  function replaceType(type) {
    if (isListType(type)) {
      // @ts-expect-error
      return new GraphQLList(replaceType(type.ofType));
    } else if (isNonNullType(type)) {
      // @ts-expect-error
      return new GraphQLNonNull(replaceType(type.ofType));
    } // @ts-expect-error FIXME: TS Conversion

    return replaceNamedType(type);
  }

  function replaceNamedType(type) {
    return typeMap[type.name];
  }

  function replaceMaybeType(maybeType) {
    return maybeType && replaceNamedType(maybeType);
  }

  function sortDirective(directive) {
    const config = directive.toConfig();
    return new GraphQLDirective({
      ...config,
      locations: sortBy(config.locations, (x) => x),
      args: sortArgs(config.args),
    });
  }

  function sortArgs(args) {
    return sortObjMap(args, (arg) => ({ ...arg, type: replaceType(arg.type) }));
  }

  function sortFields(fieldsMap) {
    return sortObjMap(fieldsMap, (field) => ({
      ...field,
      type: replaceType(field.type),
      args: field.args && sortArgs(field.args),
    }));
  }

  function sortInputFields(fieldsMap) {
    return sortObjMap(fieldsMap, (field) => ({
      ...field,
      type: replaceType(field.type),
    }));
  }

  function sortTypes(array) {
    return sortByName(array).map(replaceNamedType);
  }

  function sortNamedType(type) {
    if (isScalarType(type) || isIntrospectionType(type)) {
      return type;
    }

    if (isObjectType(type)) {
      const config = type.toConfig();
      return new GraphQLObjectType({
        ...config,
        interfaces: () => sortTypes(config.interfaces),
        fields: () => sortFields(config.fields),
      });
    }

    if (isInterfaceType(type)) {
      const config = type.toConfig();
      return new GraphQLInterfaceType({
        ...config,
        interfaces: () => sortTypes(config.interfaces),
        fields: () => sortFields(config.fields),
      });
    }

    if (isUnionType(type)) {
      const config = type.toConfig();
      return new GraphQLUnionType({
        ...config,
        types: () => sortTypes(config.types),
      });
    }

    if (isEnumType(type)) {
      const config = type.toConfig();
      return new GraphQLEnumType({
        ...config,
        values: sortObjMap(config.values, (value) => value),
      });
    }

    if (isInputObjectType(type)) {
      const config = type.toConfig();
      return new GraphQLInputObjectType({
        ...config,
        fields: () => sortInputFields(config.fields),
      });
    }
    /* c8 ignore next 3 */
    // Not reachable, all possible types have been considered.

     false || invariant(false, 'Unexpected type: ' + inspect(type));
  }
}

function sortObjMap(map, sortValueFn) {
  const sortedMap = Object.create(null);

  for (const key of Object.keys(map).sort(naturalCompare)) {
    sortedMap[key] = sortValueFn(map[key]);
  }

  return sortedMap;
}

function sortByName(array) {
  return sortBy(array, (obj) => obj.name);
}

function sortBy(array, mapToKey) {
  return array.slice().sort((obj1, obj2) => {
    const key1 = mapToKey(obj1);
    const key2 = mapToKey(obj2);
    return naturalCompare(key1, key2);
  });
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/printSchema.mjs










function printSchema(schema) {
  return printFilteredSchema(
    schema,
    (n) => !isSpecifiedDirective(n),
    isDefinedType,
  );
}
function printIntrospectionSchema(schema) {
  return printFilteredSchema(schema, isSpecifiedDirective, isIntrospectionType);
}

function isDefinedType(type) {
  return !isSpecifiedScalarType(type) && !isIntrospectionType(type);
}

function printFilteredSchema(schema, directiveFilter, typeFilter) {
  const directives = schema.getDirectives().filter(directiveFilter);
  const types = Object.values(schema.getTypeMap()).filter(typeFilter);
  return [
    printSchemaDefinition(schema),
    ...directives.map((directive) => printDirective(directive)),
    ...types.map((type) => printType(type)),
  ]
    .filter(Boolean)
    .join('\n\n');
}

function printSchemaDefinition(schema) {
  if (schema.description == null && isSchemaOfCommonNames(schema)) {
    return;
  }

  const operationTypes = [];
  const queryType = schema.getQueryType();

  if (queryType) {
    operationTypes.push(`  query: ${queryType.name}`);
  }

  const mutationType = schema.getMutationType();

  if (mutationType) {
    operationTypes.push(`  mutation: ${mutationType.name}`);
  }

  const subscriptionType = schema.getSubscriptionType();

  if (subscriptionType) {
    operationTypes.push(`  subscription: ${subscriptionType.name}`);
  }

  return printDescription(schema) + `schema {\n${operationTypes.join('\n')}\n}`;
}
/**
 * GraphQL schema define root types for each type of operation. These types are
 * the same as any other type and can be named in any manner, however there is
 * a common naming convention:
 *
 * ```graphql
 *   schema {
 *     query: Query
 *     mutation: Mutation
 *     subscription: Subscription
 *   }
 * ```
 *
 * When using this naming convention, the schema description can be omitted.
 */

function isSchemaOfCommonNames(schema) {
  const queryType = schema.getQueryType();

  if (queryType && queryType.name !== 'Query') {
    return false;
  }

  const mutationType = schema.getMutationType();

  if (mutationType && mutationType.name !== 'Mutation') {
    return false;
  }

  const subscriptionType = schema.getSubscriptionType();

  if (subscriptionType && subscriptionType.name !== 'Subscription') {
    return false;
  }

  return true;
}

function printType(type) {
  if (isScalarType(type)) {
    return printScalar(type);
  }

  if (isObjectType(type)) {
    return printObject(type);
  }

  if (isInterfaceType(type)) {
    return printInterface(type);
  }

  if (isUnionType(type)) {
    return printUnion(type);
  }

  if (isEnumType(type)) {
    return printEnum(type);
  }

  if (isInputObjectType(type)) {
    return printInputObject(type);
  }
  /* c8 ignore next 3 */
  // Not reachable, all possible types have been considered.

   false || invariant(false, 'Unexpected type: ' + inspect(type));
}

function printScalar(type) {
  return (
    printDescription(type) + `scalar ${type.name}` + printSpecifiedByURL(type)
  );
}

function printImplementedInterfaces(type) {
  const interfaces = type.getInterfaces();
  return interfaces.length
    ? ' implements ' + interfaces.map((i) => i.name).join(' & ')
    : '';
}

function printObject(type) {
  return (
    printDescription(type) +
    `type ${type.name}` +
    printImplementedInterfaces(type) +
    printFields(type)
  );
}

function printInterface(type) {
  return (
    printDescription(type) +
    `interface ${type.name}` +
    printImplementedInterfaces(type) +
    printFields(type)
  );
}

function printUnion(type) {
  const types = type.getTypes();
  const possibleTypes = types.length ? ' = ' + types.join(' | ') : '';
  return printDescription(type) + 'union ' + type.name + possibleTypes;
}

function printEnum(type) {
  const values = type
    .getValues()
    .map(
      (value, i) =>
        printDescription(value, '  ', !i) +
        '  ' +
        value.name +
        printDeprecated(value.deprecationReason),
    );
  return printDescription(type) + `enum ${type.name}` + printBlock(values);
}

function printInputObject(type) {
  const fields = Object.values(type.getFields()).map(
    (f, i) => printDescription(f, '  ', !i) + '  ' + printInputValue(f),
  );
  return printDescription(type) + `input ${type.name}` + printBlock(fields);
}

function printFields(type) {
  const fields = Object.values(type.getFields()).map(
    (f, i) =>
      printDescription(f, '  ', !i) +
      '  ' +
      f.name +
      printArgs(f.args, '  ') +
      ': ' +
      String(f.type) +
      printDeprecated(f.deprecationReason),
  );
  return printBlock(fields);
}

function printBlock(items) {
  return items.length !== 0 ? ' {\n' + items.join('\n') + '\n}' : '';
}

function printArgs(args, indentation = '') {
  if (args.length === 0) {
    return '';
  } // If every arg does not have a description, print them on one line.

  if (args.every((arg) => !arg.description)) {
    return '(' + args.map(printInputValue).join(', ') + ')';
  }

  return (
    '(\n' +
    args
      .map(
        (arg, i) =>
          printDescription(arg, '  ' + indentation, !i) +
          '  ' +
          indentation +
          printInputValue(arg),
      )
      .join('\n') +
    '\n' +
    indentation +
    ')'
  );
}

function printInputValue(arg) {
  const defaultAST = astFromValue(arg.defaultValue, arg.type);
  let argDecl = arg.name + ': ' + String(arg.type);

  if (defaultAST) {
    argDecl += ` = ${print(defaultAST)}`;
  }

  return argDecl + printDeprecated(arg.deprecationReason);
}

function printDirective(directive) {
  return (
    printDescription(directive) +
    'directive @' +
    directive.name +
    printArgs(directive.args) +
    (directive.isRepeatable ? ' repeatable' : '') +
    ' on ' +
    directive.locations.join(' | ')
  );
}

function printDeprecated(reason) {
  if (reason == null) {
    return '';
  }

  if (reason !== DEFAULT_DEPRECATION_REASON) {
    const astValue = print({
      kind: Kind.STRING,
      value: reason,
    });
    return ` @deprecated(reason: ${astValue})`;
  }

  return ' @deprecated';
}

function printSpecifiedByURL(scalar) {
  if (scalar.specifiedByURL == null) {
    return '';
  }

  const astValue = print({
    kind: Kind.STRING,
    value: scalar.specifiedByURL,
  });
  return ` @specifiedBy(url: ${astValue})`;
}

function printDescription(def, indentation = '', firstInBlock = true) {
  const { description } = def;

  if (description == null) {
    return '';
  }

  const blockString = print({
    kind: Kind.STRING,
    value: description,
    block: isPrintableAsBlockString(description),
  });
  const prefix =
    indentation && !firstInBlock ? '\n' + indentation : indentation;
  return prefix + blockString.replace(/\n/g, '\n' + indentation) + '\n';
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/concatAST.mjs

/**
 * Provided a collection of ASTs, presumably each from different files,
 * concatenate the ASTs together into batched AST, useful for validating many
 * GraphQL source files which together represent one conceptual application.
 */

function concatAST(documents) {
  const definitions = [];

  for (const doc of documents) {
    definitions.push(...doc.definitions);
  }

  return {
    kind: Kind.DOCUMENT,
    definitions,
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/separateOperations.mjs


/**
 * separateOperations accepts a single AST document which may contain many
 * operations and fragments and returns a collection of AST documents each of
 * which contains a single operation as well the fragment definitions it
 * refers to.
 */

function separateOperations(documentAST) {
  const operations = [];
  const depGraph = Object.create(null); // Populate metadata and build a dependency graph.

  for (const definitionNode of documentAST.definitions) {
    switch (definitionNode.kind) {
      case Kind.OPERATION_DEFINITION:
        operations.push(definitionNode);
        break;

      case Kind.FRAGMENT_DEFINITION:
        depGraph[definitionNode.name.value] = collectDependencies(
          definitionNode.selectionSet,
        );
        break;

      default: // ignore non-executable definitions
    }
  } // For each operation, produce a new synthesized AST which includes only what
  // is necessary for completing that operation.

  const separatedDocumentASTs = Object.create(null);

  for (const operation of operations) {
    const dependencies = new Set();

    for (const fragmentName of collectDependencies(operation.selectionSet)) {
      collectTransitiveDependencies(dependencies, depGraph, fragmentName);
    } // Provides the empty string for anonymous operations.

    const operationName = operation.name ? operation.name.value : ''; // The list of definition nodes to be included for this operation, sorted
    // to retain the same order as the original document.

    separatedDocumentASTs[operationName] = {
      kind: Kind.DOCUMENT,
      definitions: documentAST.definitions.filter(
        (node) =>
          node === operation ||
          (node.kind === Kind.FRAGMENT_DEFINITION &&
            dependencies.has(node.name.value)),
      ),
    };
  }

  return separatedDocumentASTs;
}

// From a dependency graph, collects a list of transitive dependencies by
// recursing through a dependency graph.
function collectTransitiveDependencies(collected, depGraph, fromName) {
  if (!collected.has(fromName)) {
    collected.add(fromName);
    const immediateDeps = depGraph[fromName];

    if (immediateDeps !== undefined) {
      for (const toName of immediateDeps) {
        collectTransitiveDependencies(collected, depGraph, toName);
      }
    }
  }
}

function collectDependencies(selectionSet) {
  const dependencies = [];
  visit(selectionSet, {
    FragmentSpread(node) {
      dependencies.push(node.name.value);
    },
  });
  return dependencies;
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/stripIgnoredCharacters.mjs




/**
 * Strips characters that are not significant to the validity or execution
 * of a GraphQL document:
 *   - UnicodeBOM
 *   - WhiteSpace
 *   - LineTerminator
 *   - Comment
 *   - Comma
 *   - BlockString indentation
 *
 * Note: It is required to have a delimiter character between neighboring
 * non-punctuator tokens and this function always uses single space as delimiter.
 *
 * It is guaranteed that both input and output documents if parsed would result
 * in the exact same AST except for nodes location.
 *
 * Warning: It is guaranteed that this function will always produce stable results.
 * However, it's not guaranteed that it will stay the same between different
 * releases due to bugfixes or changes in the GraphQL specification.
 *
 * Query example:
 *
 * ```graphql
 * query SomeQuery($foo: String!, $bar: String) {
 *   someField(foo: $foo, bar: $bar) {
 *     a
 *     b {
 *       c
 *       d
 *     }
 *   }
 * }
 * ```
 *
 * Becomes:
 *
 * ```graphql
 * query SomeQuery($foo:String!$bar:String){someField(foo:$foo bar:$bar){a b{c d}}}
 * ```
 *
 * SDL example:
 *
 * ```graphql
 * """
 * Type description
 * """
 * type Foo {
 *   """
 *   Field description
 *   """
 *   bar: String
 * }
 * ```
 *
 * Becomes:
 *
 * ```graphql
 * """Type description""" type Foo{"""Field description""" bar:String}
 * ```
 */

function stripIgnoredCharacters(source) {
  const sourceObj = isSource(source) ? source : new Source(source);
  const body = sourceObj.body;
  const lexer = new Lexer(sourceObj);
  let strippedBody = '';
  let wasLastAddedTokenNonPunctuator = false;

  while (lexer.advance().kind !== TokenKind.EOF) {
    const currentToken = lexer.token;
    const tokenKind = currentToken.kind;
    /**
     * Every two non-punctuator tokens should have space between them.
     * Also prevent case of non-punctuator token following by spread resulting
     * in invalid token (e.g. `1...` is invalid Float token).
     */

    const isNonPunctuator = !isPunctuatorTokenKind(currentToken.kind);

    if (wasLastAddedTokenNonPunctuator) {
      if (isNonPunctuator || currentToken.kind === TokenKind.SPREAD) {
        strippedBody += ' ';
      }
    }

    const tokenBody = body.slice(currentToken.start, currentToken.end);

    if (tokenKind === TokenKind.BLOCK_STRING) {
      strippedBody += printBlockString(currentToken.value, {
        minimize: true,
      });
    } else {
      strippedBody += tokenBody;
    }

    wasLastAddedTokenNonPunctuator = isNonPunctuator;
  }

  return strippedBody;
}

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/assertValidName.mjs



/* c8 ignore start */

/**
 * Upholds the spec rules about naming.
 * @deprecated Please use `assertName` instead. Will be removed in v17
 */

function assertValidName(name) {
  const error = isValidNameError(name);

  if (error) {
    throw error;
  }

  return name;
}
/**
 * Returns an Error if a name is invalid.
 * @deprecated Please use `assertName` instead. Will be removed in v17
 */

function isValidNameError(name) {
  typeof name === 'string' || devAssert(false, 'Expected name to be a string.');

  if (name.startsWith('__')) {
    return new GraphQLError(
      `Name "${name}" must not begin with "__", which is reserved by GraphQL introspection.`,
    );
  }

  try {
    assertName(name);
  } catch (error) {
    return error;
  }
}
/* c8 ignore stop */

;// CONCATENATED MODULE: ../node_modules/graphql/utilities/findBreakingChanges.mjs








var BreakingChangeType;

(function (BreakingChangeType) {
  BreakingChangeType['TYPE_REMOVED'] = 'TYPE_REMOVED';
  BreakingChangeType['TYPE_CHANGED_KIND'] = 'TYPE_CHANGED_KIND';
  BreakingChangeType['TYPE_REMOVED_FROM_UNION'] = 'TYPE_REMOVED_FROM_UNION';
  BreakingChangeType['VALUE_REMOVED_FROM_ENUM'] = 'VALUE_REMOVED_FROM_ENUM';
  BreakingChangeType['REQUIRED_INPUT_FIELD_ADDED'] =
    'REQUIRED_INPUT_FIELD_ADDED';
  BreakingChangeType['IMPLEMENTED_INTERFACE_REMOVED'] =
    'IMPLEMENTED_INTERFACE_REMOVED';
  BreakingChangeType['FIELD_REMOVED'] = 'FIELD_REMOVED';
  BreakingChangeType['FIELD_CHANGED_KIND'] = 'FIELD_CHANGED_KIND';
  BreakingChangeType['REQUIRED_ARG_ADDED'] = 'REQUIRED_ARG_ADDED';
  BreakingChangeType['ARG_REMOVED'] = 'ARG_REMOVED';
  BreakingChangeType['ARG_CHANGED_KIND'] = 'ARG_CHANGED_KIND';
  BreakingChangeType['DIRECTIVE_REMOVED'] = 'DIRECTIVE_REMOVED';
  BreakingChangeType['DIRECTIVE_ARG_REMOVED'] = 'DIRECTIVE_ARG_REMOVED';
  BreakingChangeType['REQUIRED_DIRECTIVE_ARG_ADDED'] =
    'REQUIRED_DIRECTIVE_ARG_ADDED';
  BreakingChangeType['DIRECTIVE_REPEATABLE_REMOVED'] =
    'DIRECTIVE_REPEATABLE_REMOVED';
  BreakingChangeType['DIRECTIVE_LOCATION_REMOVED'] =
    'DIRECTIVE_LOCATION_REMOVED';
})(BreakingChangeType || (BreakingChangeType = {}));


var DangerousChangeType;

(function (DangerousChangeType) {
  DangerousChangeType['VALUE_ADDED_TO_ENUM'] = 'VALUE_ADDED_TO_ENUM';
  DangerousChangeType['TYPE_ADDED_TO_UNION'] = 'TYPE_ADDED_TO_UNION';
  DangerousChangeType['OPTIONAL_INPUT_FIELD_ADDED'] =
    'OPTIONAL_INPUT_FIELD_ADDED';
  DangerousChangeType['OPTIONAL_ARG_ADDED'] = 'OPTIONAL_ARG_ADDED';
  DangerousChangeType['IMPLEMENTED_INTERFACE_ADDED'] =
    'IMPLEMENTED_INTERFACE_ADDED';
  DangerousChangeType['ARG_DEFAULT_VALUE_CHANGE'] = 'ARG_DEFAULT_VALUE_CHANGE';
})(DangerousChangeType || (DangerousChangeType = {}));



/**
 * Given two schemas, returns an Array containing descriptions of all the types
 * of breaking changes covered by the other functions down below.
 */
function findBreakingChanges(oldSchema, newSchema) {
  // @ts-expect-error
  return findSchemaChanges(oldSchema, newSchema).filter(
    (change) => change.type in BreakingChangeType,
  );
}
/**
 * Given two schemas, returns an Array containing descriptions of all the types
 * of potentially dangerous changes covered by the other functions down below.
 */

function findDangerousChanges(oldSchema, newSchema) {
  // @ts-expect-error
  return findSchemaChanges(oldSchema, newSchema).filter(
    (change) => change.type in DangerousChangeType,
  );
}

function findSchemaChanges(oldSchema, newSchema) {
  return [
    ...findTypeChanges(oldSchema, newSchema),
    ...findDirectiveChanges(oldSchema, newSchema),
  ];
}

function findDirectiveChanges(oldSchema, newSchema) {
  const schemaChanges = [];
  const directivesDiff = diff(
    oldSchema.getDirectives(),
    newSchema.getDirectives(),
  );

  for (const oldDirective of directivesDiff.removed) {
    schemaChanges.push({
      type: BreakingChangeType.DIRECTIVE_REMOVED,
      description: `${oldDirective.name} was removed.`,
    });
  }

  for (const [oldDirective, newDirective] of directivesDiff.persisted) {
    const argsDiff = diff(oldDirective.args, newDirective.args);

    for (const newArg of argsDiff.added) {
      if (isRequiredArgument(newArg)) {
        schemaChanges.push({
          type: BreakingChangeType.REQUIRED_DIRECTIVE_ARG_ADDED,
          description: `A required arg ${newArg.name} on directive ${oldDirective.name} was added.`,
        });
      }
    }

    for (const oldArg of argsDiff.removed) {
      schemaChanges.push({
        type: BreakingChangeType.DIRECTIVE_ARG_REMOVED,
        description: `${oldArg.name} was removed from ${oldDirective.name}.`,
      });
    }

    if (oldDirective.isRepeatable && !newDirective.isRepeatable) {
      schemaChanges.push({
        type: BreakingChangeType.DIRECTIVE_REPEATABLE_REMOVED,
        description: `Repeatable flag was removed from ${oldDirective.name}.`,
      });
    }

    for (const location of oldDirective.locations) {
      if (!newDirective.locations.includes(location)) {
        schemaChanges.push({
          type: BreakingChangeType.DIRECTIVE_LOCATION_REMOVED,
          description: `${location} was removed from ${oldDirective.name}.`,
        });
      }
    }
  }

  return schemaChanges;
}

function findTypeChanges(oldSchema, newSchema) {
  const schemaChanges = [];
  const typesDiff = diff(
    Object.values(oldSchema.getTypeMap()),
    Object.values(newSchema.getTypeMap()),
  );

  for (const oldType of typesDiff.removed) {
    schemaChanges.push({
      type: BreakingChangeType.TYPE_REMOVED,
      description: isSpecifiedScalarType(oldType)
        ? `Standard scalar ${oldType.name} was removed because it is not referenced anymore.`
        : `${oldType.name} was removed.`,
    });
  }

  for (const [oldType, newType] of typesDiff.persisted) {
    if (isEnumType(oldType) && isEnumType(newType)) {
      schemaChanges.push(...findEnumTypeChanges(oldType, newType));
    } else if (isUnionType(oldType) && isUnionType(newType)) {
      schemaChanges.push(...findUnionTypeChanges(oldType, newType));
    } else if (isInputObjectType(oldType) && isInputObjectType(newType)) {
      schemaChanges.push(...findInputObjectTypeChanges(oldType, newType));
    } else if (isObjectType(oldType) && isObjectType(newType)) {
      schemaChanges.push(
        ...findFieldChanges(oldType, newType),
        ...findImplementedInterfacesChanges(oldType, newType),
      );
    } else if (isInterfaceType(oldType) && isInterfaceType(newType)) {
      schemaChanges.push(
        ...findFieldChanges(oldType, newType),
        ...findImplementedInterfacesChanges(oldType, newType),
      );
    } else if (oldType.constructor !== newType.constructor) {
      schemaChanges.push({
        type: BreakingChangeType.TYPE_CHANGED_KIND,
        description:
          `${oldType.name} changed from ` +
          `${typeKindName(oldType)} to ${typeKindName(newType)}.`,
      });
    }
  }

  return schemaChanges;
}

function findInputObjectTypeChanges(oldType, newType) {
  const schemaChanges = [];
  const fieldsDiff = diff(
    Object.values(oldType.getFields()),
    Object.values(newType.getFields()),
  );

  for (const newField of fieldsDiff.added) {
    if (isRequiredInputField(newField)) {
      schemaChanges.push({
        type: BreakingChangeType.REQUIRED_INPUT_FIELD_ADDED,
        description: `A required field ${newField.name} on input type ${oldType.name} was added.`,
      });
    } else {
      schemaChanges.push({
        type: DangerousChangeType.OPTIONAL_INPUT_FIELD_ADDED,
        description: `An optional field ${newField.name} on input type ${oldType.name} was added.`,
      });
    }
  }

  for (const oldField of fieldsDiff.removed) {
    schemaChanges.push({
      type: BreakingChangeType.FIELD_REMOVED,
      description: `${oldType.name}.${oldField.name} was removed.`,
    });
  }

  for (const [oldField, newField] of fieldsDiff.persisted) {
    const isSafe = isChangeSafeForInputObjectFieldOrFieldArg(
      oldField.type,
      newField.type,
    );

    if (!isSafe) {
      schemaChanges.push({
        type: BreakingChangeType.FIELD_CHANGED_KIND,
        description:
          `${oldType.name}.${oldField.name} changed type from ` +
          `${String(oldField.type)} to ${String(newField.type)}.`,
      });
    }
  }

  return schemaChanges;
}

function findUnionTypeChanges(oldType, newType) {
  const schemaChanges = [];
  const possibleTypesDiff = diff(oldType.getTypes(), newType.getTypes());

  for (const newPossibleType of possibleTypesDiff.added) {
    schemaChanges.push({
      type: DangerousChangeType.TYPE_ADDED_TO_UNION,
      description: `${newPossibleType.name} was added to union type ${oldType.name}.`,
    });
  }

  for (const oldPossibleType of possibleTypesDiff.removed) {
    schemaChanges.push({
      type: BreakingChangeType.TYPE_REMOVED_FROM_UNION,
      description: `${oldPossibleType.name} was removed from union type ${oldType.name}.`,
    });
  }

  return schemaChanges;
}

function findEnumTypeChanges(oldType, newType) {
  const schemaChanges = [];
  const valuesDiff = diff(oldType.getValues(), newType.getValues());

  for (const newValue of valuesDiff.added) {
    schemaChanges.push({
      type: DangerousChangeType.VALUE_ADDED_TO_ENUM,
      description: `${newValue.name} was added to enum type ${oldType.name}.`,
    });
  }

  for (const oldValue of valuesDiff.removed) {
    schemaChanges.push({
      type: BreakingChangeType.VALUE_REMOVED_FROM_ENUM,
      description: `${oldValue.name} was removed from enum type ${oldType.name}.`,
    });
  }

  return schemaChanges;
}

function findImplementedInterfacesChanges(oldType, newType) {
  const schemaChanges = [];
  const interfacesDiff = diff(oldType.getInterfaces(), newType.getInterfaces());

  for (const newInterface of interfacesDiff.added) {
    schemaChanges.push({
      type: DangerousChangeType.IMPLEMENTED_INTERFACE_ADDED,
      description: `${newInterface.name} added to interfaces implemented by ${oldType.name}.`,
    });
  }

  for (const oldInterface of interfacesDiff.removed) {
    schemaChanges.push({
      type: BreakingChangeType.IMPLEMENTED_INTERFACE_REMOVED,
      description: `${oldType.name} no longer implements interface ${oldInterface.name}.`,
    });
  }

  return schemaChanges;
}

function findFieldChanges(oldType, newType) {
  const schemaChanges = [];
  const fieldsDiff = diff(
    Object.values(oldType.getFields()),
    Object.values(newType.getFields()),
  );

  for (const oldField of fieldsDiff.removed) {
    schemaChanges.push({
      type: BreakingChangeType.FIELD_REMOVED,
      description: `${oldType.name}.${oldField.name} was removed.`,
    });
  }

  for (const [oldField, newField] of fieldsDiff.persisted) {
    schemaChanges.push(...findArgChanges(oldType, oldField, newField));
    const isSafe = isChangeSafeForObjectOrInterfaceField(
      oldField.type,
      newField.type,
    );

    if (!isSafe) {
      schemaChanges.push({
        type: BreakingChangeType.FIELD_CHANGED_KIND,
        description:
          `${oldType.name}.${oldField.name} changed type from ` +
          `${String(oldField.type)} to ${String(newField.type)}.`,
      });
    }
  }

  return schemaChanges;
}

function findArgChanges(oldType, oldField, newField) {
  const schemaChanges = [];
  const argsDiff = diff(oldField.args, newField.args);

  for (const oldArg of argsDiff.removed) {
    schemaChanges.push({
      type: BreakingChangeType.ARG_REMOVED,
      description: `${oldType.name}.${oldField.name} arg ${oldArg.name} was removed.`,
    });
  }

  for (const [oldArg, newArg] of argsDiff.persisted) {
    const isSafe = isChangeSafeForInputObjectFieldOrFieldArg(
      oldArg.type,
      newArg.type,
    );

    if (!isSafe) {
      schemaChanges.push({
        type: BreakingChangeType.ARG_CHANGED_KIND,
        description:
          `${oldType.name}.${oldField.name} arg ${oldArg.name} has changed type from ` +
          `${String(oldArg.type)} to ${String(newArg.type)}.`,
      });
    } else if (oldArg.defaultValue !== undefined) {
      if (newArg.defaultValue === undefined) {
        schemaChanges.push({
          type: DangerousChangeType.ARG_DEFAULT_VALUE_CHANGE,
          description: `${oldType.name}.${oldField.name} arg ${oldArg.name} defaultValue was removed.`,
        });
      } else {
        // Since we looking only for client's observable changes we should
        // compare default values in the same representation as they are
        // represented inside introspection.
        const oldValueStr = findBreakingChanges_stringifyValue(oldArg.defaultValue, oldArg.type);
        const newValueStr = findBreakingChanges_stringifyValue(newArg.defaultValue, newArg.type);

        if (oldValueStr !== newValueStr) {
          schemaChanges.push({
            type: DangerousChangeType.ARG_DEFAULT_VALUE_CHANGE,
            description: `${oldType.name}.${oldField.name} arg ${oldArg.name} has changed defaultValue from ${oldValueStr} to ${newValueStr}.`,
          });
        }
      }
    }
  }

  for (const newArg of argsDiff.added) {
    if (isRequiredArgument(newArg)) {
      schemaChanges.push({
        type: BreakingChangeType.REQUIRED_ARG_ADDED,
        description: `A required arg ${newArg.name} on ${oldType.name}.${oldField.name} was added.`,
      });
    } else {
      schemaChanges.push({
        type: DangerousChangeType.OPTIONAL_ARG_ADDED,
        description: `An optional arg ${newArg.name} on ${oldType.name}.${oldField.name} was added.`,
      });
    }
  }

  return schemaChanges;
}

function isChangeSafeForObjectOrInterfaceField(oldType, newType) {
  if (isListType(oldType)) {
    return (
      // if they're both lists, make sure the underlying types are compatible
      (isListType(newType) &&
        isChangeSafeForObjectOrInterfaceField(
          oldType.ofType,
          newType.ofType,
        )) || // moving from nullable to non-null of the same underlying type is safe
      (isNonNullType(newType) &&
        isChangeSafeForObjectOrInterfaceField(oldType, newType.ofType))
    );
  }

  if (isNonNullType(oldType)) {
    // if they're both non-null, make sure the underlying types are compatible
    return (
      isNonNullType(newType) &&
      isChangeSafeForObjectOrInterfaceField(oldType.ofType, newType.ofType)
    );
  }

  return (
    // if they're both named types, see if their names are equivalent
    (isNamedType(newType) && oldType.name === newType.name) || // moving from nullable to non-null of the same underlying type is safe
    (isNonNullType(newType) &&
      isChangeSafeForObjectOrInterfaceField(oldType, newType.ofType))
  );
}

function isChangeSafeForInputObjectFieldOrFieldArg(oldType, newType) {
  if (isListType(oldType)) {
    // if they're both lists, make sure the underlying types are compatible
    return (
      isListType(newType) &&
      isChangeSafeForInputObjectFieldOrFieldArg(oldType.ofType, newType.ofType)
    );
  }

  if (isNonNullType(oldType)) {
    return (
      // if they're both non-null, make sure the underlying types are
      // compatible
      (isNonNullType(newType) &&
        isChangeSafeForInputObjectFieldOrFieldArg(
          oldType.ofType,
          newType.ofType,
        )) || // moving from non-null to nullable of the same underlying type is safe
      (!isNonNullType(newType) &&
        isChangeSafeForInputObjectFieldOrFieldArg(oldType.ofType, newType))
    );
  } // if they're both named types, see if their names are equivalent

  return isNamedType(newType) && oldType.name === newType.name;
}

function typeKindName(type) {
  if (isScalarType(type)) {
    return 'a Scalar type';
  }

  if (isObjectType(type)) {
    return 'an Object type';
  }

  if (isInterfaceType(type)) {
    return 'an Interface type';
  }

  if (isUnionType(type)) {
    return 'a Union type';
  }

  if (isEnumType(type)) {
    return 'an Enum type';
  }

  if (isInputObjectType(type)) {
    return 'an Input type';
  }
  /* c8 ignore next 3 */
  // Not reachable, all possible types have been considered.

   false || invariant(false, 'Unexpected type: ' + inspect(type));
}

function findBreakingChanges_stringifyValue(value, type) {
  const ast = astFromValue(value, type);
  ast != null || invariant(false);
  return print(sortValueNode(ast));
}

function diff(oldArray, newArray) {
  const added = [];
  const removed = [];
  const persisted = [];
  const oldMap = keyMap(oldArray, ({ name }) => name);
  const newMap = keyMap(newArray, ({ name }) => name);

  for (const oldItem of oldArray) {
    const newItem = newMap[oldItem.name];

    if (newItem === undefined) {
      removed.push(oldItem);
    } else {
      persisted.push([oldItem, newItem]);
    }
  }

  for (const newItem of newArray) {
    if (oldMap[newItem.name] === undefined) {
      added.push(newItem);
    }
  }

  return {
    added,
    persisted,
    removed,
  };
}

;// CONCATENATED MODULE: ../node_modules/graphql/index.mjs
/**
 * GraphQL.js provides a reference implementation for the GraphQL specification
 * but is also a useful utility for operating on GraphQL files and building
 * sophisticated tools.
 *
 * This primary module exports a general purpose function for fulfilling all
 * steps of the GraphQL specification in a single operation, but also includes
 * utilities for every part of the GraphQL specification:
 *
 *   - Parsing the GraphQL language.
 *   - Building a GraphQL type schema.
 *   - Validating a GraphQL request against a type schema.
 *   - Executing a GraphQL request against a type schema.
 *
 * This also includes utility functions for operating on GraphQL types and
 * GraphQL documents to facilitate building tools.
 *
 * You may also import from each sub-directory directly. For example, the
 * following two import statements are equivalent:
 *
 * ```ts
 * import { parse } from 'graphql';
 * import { parse } from 'graphql/language';
 * ```
 *
 * @packageDocumentation
 */
// The GraphQL.js version info.
 // The primary entry point into fulfilling a GraphQL request.

 // Create and operate on GraphQL type definitions and schema.


// Parse and operate on GraphQL language source files.

// Execute GraphQL queries.

// Validate GraphQL documents.

// Create, format, and print GraphQL errors.

// Utilities for operating on GraphQL type schema and parsed sources.



/***/ }),

/***/ 8039:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cI": function() { return /* binding */ useForm; }
/* harmony export */ });
/* unused harmony exports Controller, Form, FormProvider, appendErrors, get, set, useController, useFieldArray, useFormContext, useFormState, useWatch */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);


var isCheckBoxInput = (element) => element.type === 'checkbox';

var isDateObject = (value) => value instanceof Date;

var isNullOrUndefined = (value) => value == null;

const isObjectType = (value) => typeof value === 'object';
var isObject = (value) => !isNullOrUndefined(value) &&
    !Array.isArray(value) &&
    isObjectType(value) &&
    !isDateObject(value);

var getEventValue = (event) => isObject(event) && event.target
    ? isCheckBoxInput(event.target)
        ? event.target.checked
        : event.target.value
    : event;

var getNodeParentName = (name) => name.substring(0, name.search(/\.\d+(\.|$)/)) || name;

var isNameInFieldArray = (names, name) => names.has(getNodeParentName(name));

var isPlainObject = (tempObject) => {
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return (isObject(prototypeCopy) && prototypeCopy.hasOwnProperty('isPrototypeOf'));
};

var isWeb = typeof window !== 'undefined' &&
    typeof window.HTMLElement !== 'undefined' &&
    typeof document !== 'undefined';

function cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) {
        copy = new Date(data);
    }
    else if (data instanceof Set) {
        copy = new Set(data);
    }
    else if (!(isWeb && (data instanceof Blob || data instanceof FileList)) &&
        (isArray || isObject(data))) {
        copy = isArray ? [] : {};
        if (!isArray && !isPlainObject(data)) {
            copy = data;
        }
        else {
            for (const key in data) {
                if (data.hasOwnProperty(key)) {
                    copy[key] = cloneObject(data[key]);
                }
            }
        }
    }
    else {
        return data;
    }
    return copy;
}

var compact = (value) => Array.isArray(value) ? value.filter(Boolean) : [];

var isUndefined = (val) => val === undefined;

var get = (object, path, defaultValue) => {
    if (!path || !isObject(object)) {
        return defaultValue;
    }
    const result = compact(path.split(/[,[\].]+?/)).reduce((result, key) => isNullOrUndefined(result) ? result : result[key], object);
    return isUndefined(result) || result === object
        ? isUndefined(object[path])
            ? defaultValue
            : object[path]
        : result;
};

var isBoolean = (value) => typeof value === 'boolean';

const EVENTS = {
    BLUR: 'blur',
    FOCUS_OUT: 'focusout',
    CHANGE: 'change',
};
const VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all',
};
const INPUT_VALIDATION_RULES = {
    max: 'max',
    min: 'min',
    maxLength: 'maxLength',
    minLength: 'minLength',
    pattern: 'pattern',
    required: 'required',
    validate: 'validate',
};

const HookFormContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */
const useFormContext = () => React.useContext(HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */
const FormProvider = (props) => {
    const { children, ...data } = props;
    return (React.createElement(HookFormContext.Provider, { value: data }, children));
};

var getProxyFormState = (formState, control, localProxyFormState, isRoot = true) => {
    const result = {
        defaultValues: control._defaultValues,
    };
    for (const key in formState) {
        Object.defineProperty(result, key, {
            get: () => {
                const _key = key;
                if (control._proxyFormState[_key] !== VALIDATION_MODE.all) {
                    control._proxyFormState[_key] = !isRoot || VALIDATION_MODE.all;
                }
                localProxyFormState && (localProxyFormState[_key] = true);
                return formState[_key];
            },
        });
    }
    return result;
};

var isEmptyObject = (value) => isObject(value) && !Object.keys(value).length;

var shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot) => {
    updateFormState(formStateData);
    const { name, ...formState } = formStateData;
    return (isEmptyObject(formState) ||
        Object.keys(formState).length >= Object.keys(_proxyFormState).length ||
        Object.keys(formState).find((key) => _proxyFormState[key] ===
            (!isRoot || VALIDATION_MODE.all)));
};

var convertToArrayPayload = (value) => (Array.isArray(value) ? value : [value]);

var shouldSubscribeByName = (name, signalName, exact) => !name ||
    !signalName ||
    name === signalName ||
    convertToArrayPayload(name).some((currentName) => currentName &&
        (exact
            ? currentName === signalName
            : currentName.startsWith(signalName) ||
                signalName.startsWith(currentName)));

function useSubscribe(props) {
    const _props = react__WEBPACK_IMPORTED_MODULE_0__.useRef(props);
    _props.current = props;
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        const subscription = !props.disabled &&
            _props.current.subject &&
            _props.current.subject.subscribe({
                next: _props.current.next,
            });
        return () => {
            subscription && subscription.unsubscribe();
        };
    }, [props.disabled]);
}

/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */
function useFormState(props) {
    const methods = useFormContext();
    const { control = methods.control, disabled, name, exact } = props || {};
    const [formState, updateFormState] = React.useState(control._formState);
    const _mounted = React.useRef(true);
    const _localProxyFormState = React.useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false,
    });
    const _name = React.useRef(name);
    _name.current = name;
    useSubscribe({
        disabled,
        next: (value) => _mounted.current &&
            shouldSubscribeByName(_name.current, value.name, exact) &&
            shouldRenderFormState(value, _localProxyFormState.current, control._updateFormState) &&
            updateFormState({
                ...control._formState,
                ...value,
            }),
        subject: control._subjects.state,
    });
    React.useEffect(() => {
        _mounted.current = true;
        _localProxyFormState.current.isValid && control._updateValid(true);
        return () => {
            _mounted.current = false;
        };
    }, [control]);
    return getProxyFormState(formState, control, _localProxyFormState.current, false);
}

var isString = (value) => typeof value === 'string';

var generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue) => {
    if (isString(names)) {
        isGlobal && _names.watch.add(names);
        return get(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) {
        return names.map((fieldName) => (isGlobal && _names.watch.add(fieldName), get(formValues, fieldName)));
    }
    isGlobal && (_names.watchAll = true);
    return formValues;
};

/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */
function useWatch(props) {
    const methods = useFormContext();
    const { control = methods.control, name, defaultValue, disabled, exact, } = props || {};
    const _name = React.useRef(name);
    _name.current = name;
    useSubscribe({
        disabled,
        subject: control._subjects.values,
        next: (formState) => {
            if (shouldSubscribeByName(_name.current, formState.name, exact)) {
                updateValue(cloneObject(generateWatchOutput(_name.current, control._names, formState.values || control._formValues, false, defaultValue)));
            }
        },
    });
    const [value, updateValue] = React.useState(control._getWatch(name, defaultValue));
    React.useEffect(() => control._removeUnmounted());
    return value;
}

var isKey = (value) => /^\w*$/.test(value);

var stringToPath = (input) => compact(input.replace(/["|']|\]/g, '').split(/\.|\[/));

var set = (object, path, value) => {
    let index = -1;
    const tempPath = isKey(path) ? [path] : stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while (++index < length) {
        const key = tempPath[index];
        let newValue = value;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue =
                isObject(objValue) || Array.isArray(objValue)
                    ? objValue
                    : !isNaN(+tempPath[index + 1])
                        ? []
                        : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
};

/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */
function useController(props) {
    const methods = useFormContext();
    const { name, disabled, control = methods.control, shouldUnregister } = props;
    const isArrayField = isNameInFieldArray(control._names.array, name);
    const value = useWatch({
        control,
        name,
        defaultValue: get(control._formValues, name, get(control._defaultValues, name, props.defaultValue)),
        exact: true,
    });
    const formState = useFormState({
        control,
        name,
    });
    const _registerProps = React.useRef(control.register(name, {
        ...props.rules,
        value,
        ...(isBoolean(props.disabled) ? { disabled: props.disabled } : {}),
    }));
    React.useEffect(() => {
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        const updateMounted = (name, value) => {
            const field = get(control._fields, name);
            if (field) {
                field._f.mount = value;
            }
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value = cloneObject(get(control._options.defaultValues, name));
            set(control._defaultValues, name, value);
            if (isUndefined(get(control._formValues, name))) {
                set(control._formValues, name, value);
            }
        }
        return () => {
            (isArrayField
                ? _shouldUnregisterField && !control._state.action
                : _shouldUnregisterField)
                ? control.unregister(name)
                : updateMounted(name, false);
        };
    }, [name, control, isArrayField, shouldUnregister]);
    React.useEffect(() => {
        if (get(control._fields, name)) {
            control._updateDisabledField({
                disabled,
                fields: control._fields,
                name,
                value: get(control._fields, name)._f.value,
            });
        }
    }, [disabled, name, control]);
    return {
        field: {
            name,
            value,
            ...(isBoolean(disabled) || formState.disabled
                ? { disabled: formState.disabled || disabled }
                : {}),
            onChange: React.useCallback((event) => _registerProps.current.onChange({
                target: {
                    value: getEventValue(event),
                    name: name,
                },
                type: EVENTS.CHANGE,
            }), [name]),
            onBlur: React.useCallback(() => _registerProps.current.onBlur({
                target: {
                    value: get(control._formValues, name),
                    name: name,
                },
                type: EVENTS.BLUR,
            }), [name, control]),
            ref: (elm) => {
                const field = get(control._fields, name);
                if (field && elm) {
                    field._f.ref = {
                        focus: () => elm.focus(),
                        select: () => elm.select(),
                        setCustomValidity: (message) => elm.setCustomValidity(message),
                        reportValidity: () => elm.reportValidity(),
                    };
                }
            },
        },
        formState,
        fieldState: Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: () => !!get(formState.errors, name),
            },
            isDirty: {
                enumerable: true,
                get: () => !!get(formState.dirtyFields, name),
            },
            isTouched: {
                enumerable: true,
                get: () => !!get(formState.touchedFields, name),
            },
            error: {
                enumerable: true,
                get: () => get(formState.errors, name),
            },
        }),
    };
}

/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */
const Controller = (props) => props.render(useController(props));

const POST_REQUEST = 'post';
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */
function Form(props) {
    const methods = useFormContext();
    const [mounted, setMounted] = React.useState(false);
    const { control = methods.control, onSubmit, children, action, method = POST_REQUEST, headers, encType, onError, render, onSuccess, validateStatus, ...rest } = props;
    const submit = async (event) => {
        let hasError = false;
        let type = '';
        await control.handleSubmit(async (data) => {
            const formData = new FormData();
            let formDataJson = '';
            try {
                formDataJson = JSON.stringify(data);
            }
            catch (_a) { }
            for (const name of control._names.mount) {
                formData.append(name, get(data, name));
            }
            if (onSubmit) {
                await onSubmit({
                    data,
                    event,
                    method,
                    formData,
                    formDataJson,
                });
            }
            if (action) {
                try {
                    const shouldStringifySubmissionData = [
                        headers && headers['Content-Type'],
                        encType,
                    ].some((value) => value && value.includes('json'));
                    const response = await fetch(action, {
                        method,
                        headers: {
                            ...headers,
                            ...(encType ? { 'Content-Type': encType } : {}),
                        },
                        body: shouldStringifySubmissionData ? formDataJson : formData,
                    });
                    if (response &&
                        (validateStatus
                            ? !validateStatus(response.status)
                            : response.status < 200 || response.status >= 300)) {
                        hasError = true;
                        onError && onError({ response });
                        type = String(response.status);
                    }
                    else {
                        onSuccess && onSuccess({ response });
                    }
                }
                catch (error) {
                    hasError = true;
                    onError && onError({ error });
                }
            }
        })(event);
        if (hasError && props.control) {
            props.control._subjects.state.next({
                isSubmitSuccessful: false,
            });
            props.control.setError('root.server', {
                type,
            });
        }
    };
    React.useEffect(() => {
        setMounted(true);
    }, []);
    return render ? (React.createElement(React.Fragment, null, render({
        submit,
    }))) : (React.createElement("form", { noValidate: mounted, action: action, method: method, encType: encType, onSubmit: submit, ...rest }, children));
}

var appendErrors = (name, validateAllFieldCriteria, errors, type, message) => validateAllFieldCriteria
    ? {
        ...errors[name],
        types: {
            ...(errors[name] && errors[name].types ? errors[name].types : {}),
            [type]: message || true,
        },
    }
    : {};

var generateId = () => {
    const d = typeof performance === 'undefined' ? Date.now() : performance.now() * 1000;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
};

var getFocusFieldName = (name, index, options = {}) => options.shouldFocus || isUndefined(options.shouldFocus)
    ? options.focusName ||
        `${name}.${isUndefined(options.focusIndex) ? index : options.focusIndex}.`
    : '';

var getValidationModes = (mode) => ({
    isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
    isOnBlur: mode === VALIDATION_MODE.onBlur,
    isOnChange: mode === VALIDATION_MODE.onChange,
    isOnAll: mode === VALIDATION_MODE.all,
    isOnTouch: mode === VALIDATION_MODE.onTouched,
});

var isWatched = (name, _names, isBlurEvent) => !isBlurEvent &&
    (_names.watchAll ||
        _names.watch.has(name) ||
        [..._names.watch].some((watchName) => name.startsWith(watchName) &&
            /^\.\w+/.test(name.slice(watchName.length))));

const iterateFieldsByAction = (fields, action, fieldsNames, abortEarly) => {
    for (const key of fieldsNames || Object.keys(fields)) {
        const field = get(fields, key);
        if (field) {
            const { _f, ...currentField } = field;
            if (_f) {
                if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) {
                    break;
                }
                else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) {
                    break;
                }
                else {
                    iterateFieldsByAction(currentField, action);
                }
            }
            else if (isObject(currentField)) {
                iterateFieldsByAction(currentField, action);
            }
        }
    }
};

var updateFieldArrayRootError = (errors, error, name) => {
    const fieldArrayErrors = compact(get(errors, name));
    set(fieldArrayErrors, 'root', error[name]);
    set(errors, name, fieldArrayErrors);
    return errors;
};

var isFileInput = (element) => element.type === 'file';

var isFunction = (value) => typeof value === 'function';

var isHTMLElement = (value) => {
    if (!isWeb) {
        return false;
    }
    const owner = value ? value.ownerDocument : 0;
    return (value instanceof
        (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement));
};

var isMessage = (value) => isString(value);

var isRadioInput = (element) => element.type === 'radio';

var isRegex = (value) => value instanceof RegExp;

const defaultResult = {
    value: false,
    isValid: false,
};
const validResult = { value: true, isValid: true };
var getCheckboxValue = (options) => {
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options
                .filter((option) => option && option.checked && !option.disabled)
                .map((option) => option.value);
            return { value: values, isValid: !!values.length };
        }
        return options[0].checked && !options[0].disabled
            ? // @ts-expect-error expected to work in the browser
                options[0].attributes && !isUndefined(options[0].attributes.value)
                    ? isUndefined(options[0].value) || options[0].value === ''
                        ? validResult
                        : { value: options[0].value, isValid: true }
                    : validResult
            : defaultResult;
    }
    return defaultResult;
};

const defaultReturn = {
    isValid: false,
    value: null,
};
var getRadioValue = (options) => Array.isArray(options)
    ? options.reduce((previous, option) => option && option.checked && !option.disabled
        ? {
            isValid: true,
            value: option.value,
        }
        : previous, defaultReturn)
    : defaultReturn;

function getValidateError(result, ref, type = 'validate') {
    if (isMessage(result) ||
        (Array.isArray(result) && result.every(isMessage)) ||
        (isBoolean(result) && !result)) {
        return {
            type,
            message: isMessage(result) ? result : '',
            ref,
        };
    }
}

var getValueAndMessage = (validationData) => isObject(validationData) && !isRegex(validationData)
    ? validationData
    : {
        value: validationData,
        message: '',
    };

var validateField = async (field, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray) => {
    const { ref, refs, required, maxLength, minLength, min, max, pattern, validate, name, valueAsNumber, mount, disabled, } = field._f;
    const inputValue = get(formValues, name);
    if (!mount || disabled) {
        return {};
    }
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message) => {
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity(isBoolean(message) ? '' : message || '');
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = isRadioInput(ref);
    const isCheckBox = isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = ((valueAsNumber || isFileInput(ref)) &&
        isUndefined(ref.value) &&
        isUndefined(inputValue)) ||
        (isHTMLElement(ref) && ref.value === '') ||
        inputValue === '' ||
        (Array.isArray(inputValue) && !inputValue.length);
    const appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = INPUT_VALIDATION_RULES.maxLength, minType = INPUT_VALIDATION_RULES.minLength) => {
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message,
            ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message),
        };
    };
    if (isFieldArray
        ? !Array.isArray(inputValue) || !inputValue.length
        : required &&
            ((!isRadioOrCheckbox && (isEmpty || isNullOrUndefined(inputValue))) ||
                (isBoolean(inputValue) && !inputValue) ||
                (isCheckBox && !getCheckboxValue(refs).isValid) ||
                (isRadio && !getRadioValue(refs).isValid))) {
        const { value, message } = isMessage(required)
            ? { value: !!required, message: required }
            : getValueAndMessage(required);
        if (value) {
            error[name] = {
                type: INPUT_VALIDATION_RULES.required,
                message,
                ref: inputRef,
                ...appendErrorsCurry(INPUT_VALIDATION_RULES.required, message),
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!isNullOrUndefined(min) || !isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = getValueAndMessage(max);
        const minOutput = getValueAndMessage(min);
        if (!isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber ||
                (inputValue ? +inputValue : inputValue);
            if (!isNullOrUndefined(maxOutput.value)) {
                exceedMax = valueNumber > maxOutput.value;
            }
            if (!isNullOrUndefined(minOutput.value)) {
                exceedMin = valueNumber < minOutput.value;
            }
        }
        else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time) => new Date(new Date().toDateString() + ' ' + time);
            const isTime = ref.type == 'time';
            const isWeek = ref.type == 'week';
            if (isString(maxOutput.value) && inputValue) {
                exceedMax = isTime
                    ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value)
                    : isWeek
                        ? inputValue > maxOutput.value
                        : valueDate > new Date(maxOutput.value);
            }
            if (isString(minOutput.value) && inputValue) {
                exceedMin = isTime
                    ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value)
                    : isWeek
                        ? inputValue < minOutput.value
                        : valueDate < new Date(minOutput.value);
            }
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) &&
        !isEmpty &&
        (isString(inputValue) || (isFieldArray && Array.isArray(inputValue)))) {
        const maxLengthOutput = getValueAndMessage(maxLength);
        const minLengthOutput = getValueAndMessage(minLength);
        const exceedMax = !isNullOrUndefined(maxLengthOutput.value) &&
            inputValue.length > +maxLengthOutput.value;
        const exceedMin = !isNullOrUndefined(minLengthOutput.value) &&
            inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && isString(inputValue)) {
        const { value: patternValue, message } = getValueAndMessage(pattern);
        if (isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: INPUT_VALIDATION_RULES.pattern,
                message,
                ref,
                ...appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, message),
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if (isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message),
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        }
        else if (isObject(validate)) {
            let validationResult = {};
            for (const key in validate) {
                if (!isEmptyObject(validationResult) && !validateAllFieldCriteria) {
                    break;
                }
                const validateError = getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message),
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) {
                        error[name] = validationResult;
                    }
                }
            }
            if (!isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult,
                };
                if (!validateAllFieldCriteria) {
                    return error;
                }
            }
        }
    }
    setCustomValidity(true);
    return error;
};

var appendAt = (data, value) => [
    ...data,
    ...convertToArrayPayload(value),
];

var fillEmptyArray = (value) => Array.isArray(value) ? value.map(() => undefined) : undefined;

function insert(data, index, value) {
    return [
        ...data.slice(0, index),
        ...convertToArrayPayload(value),
        ...data.slice(index),
    ];
}

var moveArrayAt = (data, from, to) => {
    if (!Array.isArray(data)) {
        return [];
    }
    if (isUndefined(data[to])) {
        data[to] = undefined;
    }
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};

var prependAt = (data, value) => [
    ...convertToArrayPayload(value),
    ...convertToArrayPayload(data),
];

function removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [...data];
    for (const index of indexes) {
        temp.splice(index - i, 1);
        i++;
    }
    return compact(temp).length ? temp : [];
}
var removeArrayAt = (data, index) => isUndefined(index)
    ? []
    : removeAtIndexes(data, convertToArrayPayload(index).sort((a, b) => a - b));

var swapArrayAt = (data, indexA, indexB) => {
    [data[indexA], data[indexB]] = [data[indexB], data[indexA]];
};

function baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while (index < length) {
        object = isUndefined(object) ? index++ : object[updatePath[index++]];
    }
    return object;
}
function isEmptyArray(obj) {
    for (const key in obj) {
        if (obj.hasOwnProperty(key) && !isUndefined(obj[key])) {
            return false;
        }
    }
    return true;
}
function unset(object, path) {
    const paths = Array.isArray(path)
        ? path
        : isKey(path)
            ? [path]
            : stringToPath(path);
    const childObject = paths.length === 1 ? object : baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) {
        delete childObject[key];
    }
    if (index !== 0 &&
        ((isObject(childObject) && isEmptyObject(childObject)) ||
            (Array.isArray(childObject) && isEmptyArray(childObject)))) {
        unset(object, paths.slice(0, -1));
    }
    return object;
}

var updateAt = (fieldValues, index, value) => {
    fieldValues[index] = value;
    return fieldValues;
};

/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */
function useFieldArray(props) {
    const methods = useFormContext();
    const { control = methods.control, name, keyName = 'id', shouldUnregister, } = props;
    const [fields, setFields] = React.useState(control._getFieldArray(name));
    const ids = React.useRef(control._getFieldArray(name).map(generateId));
    const _fieldIds = React.useRef(fields);
    const _name = React.useRef(name);
    const _actioned = React.useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    props.rules &&
        control.register(name, props.rules);
    useSubscribe({
        next: ({ values, name: fieldArrayName, }) => {
            if (fieldArrayName === _name.current || !fieldArrayName) {
                const fieldValues = get(values, _name.current);
                if (Array.isArray(fieldValues)) {
                    setFields(fieldValues);
                    ids.current = fieldValues.map(generateId);
                }
            }
        },
        subject: control._subjects.array,
    });
    const updateValues = React.useCallback((updatedFieldArrayValues) => {
        _actioned.current = true;
        control._updateFieldArray(name, updatedFieldArrayValues);
    }, [control, name]);
    const append = (value, options) => {
        const appendValue = convertToArrayPayload(cloneObject(value));
        const updatedFieldArrayValues = appendAt(control._getFieldArray(name), appendValue);
        control._names.focus = getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = appendAt(ids.current, appendValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, appendAt, {
            argA: fillEmptyArray(value),
        });
    };
    const prepend = (value, options) => {
        const prependValue = convertToArrayPayload(cloneObject(value));
        const updatedFieldArrayValues = prependAt(control._getFieldArray(name), prependValue);
        control._names.focus = getFocusFieldName(name, 0, options);
        ids.current = prependAt(ids.current, prependValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, prependAt, {
            argA: fillEmptyArray(value),
        });
    };
    const remove = (index) => {
        const updatedFieldArrayValues = removeArrayAt(control._getFieldArray(name), index);
        ids.current = removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, removeArrayAt, {
            argA: index,
        });
    };
    const insert$1 = (index, value, options) => {
        const insertValue = convertToArrayPayload(cloneObject(value));
        const updatedFieldArrayValues = insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = getFocusFieldName(name, index, options);
        ids.current = insert(ids.current, index, insertValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, insert, {
            argA: index,
            argB: fillEmptyArray(value),
        });
    };
    const swap = (indexA, indexB) => {
        const updatedFieldArrayValues = control._getFieldArray(name);
        swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, swapArrayAt, {
            argA: indexA,
            argB: indexB,
        }, false);
    };
    const move = (from, to) => {
        const updatedFieldArrayValues = control._getFieldArray(name);
        moveArrayAt(updatedFieldArrayValues, from, to);
        moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, moveArrayAt, {
            argA: from,
            argB: to,
        }, false);
    };
    const update = (index, value) => {
        const updateValue = cloneObject(value);
        const updatedFieldArrayValues = updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [...updatedFieldArrayValues].map((item, i) => !item || i === index ? generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([...updatedFieldArrayValues]);
        control._updateFieldArray(name, updatedFieldArrayValues, updateAt, {
            argA: index,
            argB: updateValue,
        }, true, false);
    };
    const replace = (value) => {
        const updatedFieldArrayValues = convertToArrayPayload(cloneObject(value));
        ids.current = updatedFieldArrayValues.map(generateId);
        updateValues([...updatedFieldArrayValues]);
        setFields([...updatedFieldArrayValues]);
        control._updateFieldArray(name, [...updatedFieldArrayValues], (data) => data, {}, true, false);
    };
    React.useEffect(() => {
        control._state.action = false;
        isWatched(name, control._names) &&
            control._subjects.state.next({
                ...control._formState,
            });
        if (_actioned.current &&
            (!getValidationModes(control._options.mode).isOnSubmit ||
                control._formState.isSubmitted)) {
            if (control._options.resolver) {
                control._executeSchema([name]).then((result) => {
                    const error = get(result.errors, name);
                    const existingError = get(control._formState.errors, name);
                    if (existingError
                        ? (!error && existingError.type) ||
                            (error &&
                                (existingError.type !== error.type ||
                                    existingError.message !== error.message))
                        : error && error.type) {
                        error
                            ? set(control._formState.errors, name, error)
                            : unset(control._formState.errors, name);
                        control._subjects.state.next({
                            errors: control._formState.errors,
                        });
                    }
                });
            }
            else {
                const field = get(control._fields, name);
                if (field &&
                    field._f &&
                    !(getValidationModes(control._options.reValidateMode).isOnSubmit &&
                        getValidationModes(control._options.mode).isOnSubmit)) {
                    validateField(field, control._formValues, control._options.criteriaMode === VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error) => !isEmptyObject(error) &&
                        control._subjects.state.next({
                            errors: updateFieldArrayRootError(control._formState.errors, error, name),
                        }));
                }
            }
        }
        control._subjects.values.next({
            name,
            values: { ...control._formValues },
        });
        control._names.focus &&
            iterateFieldsByAction(control._fields, (ref, key) => {
                if (control._names.focus &&
                    key.startsWith(control._names.focus) &&
                    ref.focus) {
                    ref.focus();
                    return 1;
                }
                return;
            });
        control._names.focus = '';
        control._updateValid();
        _actioned.current = false;
    }, [fields, name, control]);
    React.useEffect(() => {
        !get(control._formValues, name) && control._updateFieldArray(name);
        return () => {
            (control._options.shouldUnregister || shouldUnregister) &&
                control.unregister(name);
        };
    }, [name, control, keyName, shouldUnregister]);
    return {
        swap: React.useCallback(swap, [updateValues, name, control]),
        move: React.useCallback(move, [updateValues, name, control]),
        prepend: React.useCallback(prepend, [updateValues, name, control]),
        append: React.useCallback(append, [updateValues, name, control]),
        remove: React.useCallback(remove, [updateValues, name, control]),
        insert: React.useCallback(insert$1, [updateValues, name, control]),
        update: React.useCallback(update, [updateValues, name, control]),
        replace: React.useCallback(replace, [updateValues, name, control]),
        fields: React.useMemo(() => fields.map((field, index) => ({
            ...field,
            [keyName]: ids.current[index] || generateId(),
        })), [fields, keyName]),
    };
}

var createSubject = () => {
    let _observers = [];
    const next = (value) => {
        for (const observer of _observers) {
            observer.next && observer.next(value);
        }
    };
    const subscribe = (observer) => {
        _observers.push(observer);
        return {
            unsubscribe: () => {
                _observers = _observers.filter((o) => o !== observer);
            },
        };
    };
    const unsubscribe = () => {
        _observers = [];
    };
    return {
        get observers() {
            return _observers;
        },
        next,
        subscribe,
        unsubscribe,
    };
};

var isPrimitive = (value) => isNullOrUndefined(value) || !isObjectType(value);

function deepEqual(object1, object2) {
    if (isPrimitive(object1) || isPrimitive(object2)) {
        return object1 === object2;
    }
    if (isDateObject(object1) && isDateObject(object2)) {
        return object1.getTime() === object2.getTime();
    }
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) {
        return false;
    }
    for (const key of keys1) {
        const val1 = object1[key];
        if (!keys2.includes(key)) {
            return false;
        }
        if (key !== 'ref') {
            const val2 = object2[key];
            if ((isDateObject(val1) && isDateObject(val2)) ||
                (isObject(val1) && isObject(val2)) ||
                (Array.isArray(val1) && Array.isArray(val2))
                ? !deepEqual(val1, val2)
                : val1 !== val2) {
                return false;
            }
        }
    }
    return true;
}

var isMultipleSelect = (element) => element.type === `select-multiple`;

var isRadioOrCheckbox = (ref) => isRadioInput(ref) || isCheckBoxInput(ref);

var live = (ref) => isHTMLElement(ref) && ref.isConnected;

var objectHasFunction = (data) => {
    for (const key in data) {
        if (isFunction(data[key])) {
            return true;
        }
    }
    return false;
};

function markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if (isObject(data) || isParentNodeArray) {
        for (const key in data) {
            if (Array.isArray(data[key]) ||
                (isObject(data[key]) && !objectHasFunction(data[key]))) {
                fields[key] = Array.isArray(data[key]) ? [] : {};
                markFieldsDirty(data[key], fields[key]);
            }
            else if (!isNullOrUndefined(data[key])) {
                fields[key] = true;
            }
        }
    }
    return fields;
}
function getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if (isObject(data) || isParentNodeArray) {
        for (const key in data) {
            if (Array.isArray(data[key]) ||
                (isObject(data[key]) && !objectHasFunction(data[key]))) {
                if (isUndefined(formValues) ||
                    isPrimitive(dirtyFieldsFromValues[key])) {
                    dirtyFieldsFromValues[key] = Array.isArray(data[key])
                        ? markFieldsDirty(data[key], [])
                        : { ...markFieldsDirty(data[key]) };
                }
                else {
                    getDirtyFieldsFromDefaultValues(data[key], isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
                }
            }
            else {
                dirtyFieldsFromValues[key] = !deepEqual(data[key], formValues[key]);
            }
        }
    }
    return dirtyFieldsFromValues;
}
var getDirtyFields = (defaultValues, formValues) => getDirtyFieldsFromDefaultValues(defaultValues, formValues, markFieldsDirty(formValues));

var getFieldValueAs = (value, { valueAsNumber, valueAsDate, setValueAs }) => isUndefined(value)
    ? value
    : valueAsNumber
        ? value === ''
            ? NaN
            : value
                ? +value
                : value
        : valueAsDate && isString(value)
            ? new Date(value)
            : setValueAs
                ? setValueAs(value)
                : value;

function getFieldValue(_f) {
    const ref = _f.ref;
    if (_f.refs ? _f.refs.every((ref) => ref.disabled) : ref.disabled) {
        return;
    }
    if (isFileInput(ref)) {
        return ref.files;
    }
    if (isRadioInput(ref)) {
        return getRadioValue(_f.refs).value;
    }
    if (isMultipleSelect(ref)) {
        return [...ref.selectedOptions].map(({ value }) => value);
    }
    if (isCheckBoxInput(ref)) {
        return getCheckboxValue(_f.refs).value;
    }
    return getFieldValueAs(isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}

var getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation) => {
    const fields = {};
    for (const name of fieldsNames) {
        const field = get(_fields, name);
        field && set(fields, name, field._f);
    }
    return {
        criteriaMode,
        names: [...fieldsNames],
        fields,
        shouldUseNativeValidation,
    };
};

var getRuleValue = (rule) => isUndefined(rule)
    ? rule
    : isRegex(rule)
        ? rule.source
        : isObject(rule)
            ? isRegex(rule.value)
                ? rule.value.source
                : rule.value
            : rule;

var hasValidation = (options) => options.mount &&
    (options.required ||
        options.min ||
        options.max ||
        options.maxLength ||
        options.minLength ||
        options.pattern ||
        options.validate);

function schemaErrorLookup(errors, _fields, name) {
    const error = get(errors, name);
    if (error || isKey(name)) {
        return {
            error,
            name,
        };
    }
    const names = name.split('.');
    while (names.length) {
        const fieldName = names.join('.');
        const field = get(_fields, fieldName);
        const foundError = get(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) {
            return { name };
        }
        if (foundError && foundError.type) {
            return {
                name: fieldName,
                error: foundError,
            };
        }
        names.pop();
    }
    return {
        name,
    };
}

var skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode) => {
    if (mode.isOnAll) {
        return false;
    }
    else if (!isSubmitted && mode.isOnTouch) {
        return !(isTouched || isBlurEvent);
    }
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) {
        return !isBlurEvent;
    }
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) {
        return isBlurEvent;
    }
    return true;
};

var unsetEmptyArray = (ref, name) => !compact(get(ref, name)).length && unset(ref, name);

const defaultOptions = {
    mode: VALIDATION_MODE.onSubmit,
    reValidateMode: VALIDATION_MODE.onChange,
    shouldFocusError: true,
};
function createFormControl(props = {}, flushRootRender) {
    let _options = {
        ...defaultOptions,
        ...props,
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isLoading: isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        errors: _options.errors || {},
        disabled: _options.disabled || false,
    };
    let _fields = {};
    let _defaultValues = isObject(_options.values) || isObject(_options.defaultValues)
        ? cloneObject(_options.values || _options.defaultValues) || {}
        : {};
    let _formValues = _options.shouldUnregister
        ? {}
        : cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false,
    };
    let _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set(),
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false,
    };
    const _subjects = {
        values: createSubject(),
        array: createSubject(),
        state: createSubject(),
    };
    const validationModeBeforeSubmit = getValidationModes(_options.mode);
    const validationModeAfterSubmit = getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === VALIDATION_MODE.all;
    const debounce = (callback) => (wait) => {
        clearTimeout(timer);
        timer = setTimeout(callback, wait);
    };
    const _updateValid = async (shouldUpdateValid) => {
        if (_proxyFormState.isValid || shouldUpdateValid) {
            const isValid = _options.resolver
                ? isEmptyObject((await _executeSchema()).errors)
                : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) {
                _subjects.state.next({
                    isValid,
                });
            }
        }
    };
    const _updateIsValidating = (value) => _proxyFormState.isValidating &&
        _subjects.state.next({
            isValidating: value,
        });
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true) => {
        if (args && method) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray(get(_fields, name))) {
                const fieldValues = method(get(_fields, name), args.argA, args.argB);
                shouldSetValues && set(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState &&
                Array.isArray(get(_formState.errors, name))) {
                const errors = method(get(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && set(_formState.errors, name, errors);
                unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields &&
                shouldUpdateFieldsAndState &&
                Array.isArray(get(_formState.touchedFields, name))) {
                const touchedFields = method(get(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && set(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) {
                _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
            }
            _subjects.state.next({
                name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid,
            });
        }
        else {
            set(_formValues, name, values);
        }
    };
    const updateErrors = (name, error) => {
        set(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors,
        });
    };
    const _setErrors = (errors) => {
        _formState.errors = errors;
        _subjects.state.next({
            errors: _formState.errors,
            isValid: false,
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value, ref) => {
        const field = get(_fields, name);
        if (field) {
            const defaultValue = get(_formValues, name, isUndefined(value) ? get(_defaultValues, name) : value);
            isUndefined(defaultValue) ||
                (ref && ref.defaultChecked) ||
                shouldSkipSetValueAs
                ? set(_formValues, name, shouldSkipSetValueAs ? defaultValue : getFieldValue(field._f))
                : setFieldValue(name, defaultValue);
            _state.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender) => {
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name,
        };
        const disabledField = !!(get(_fields, name) && get(_fields, name)._f.disabled);
        if (!isBlurEvent || shouldDirty) {
            if (_proxyFormState.isDirty) {
                isPreviousDirty = _formState.isDirty;
                _formState.isDirty = output.isDirty = _getDirty();
                shouldUpdateField = isPreviousDirty !== output.isDirty;
            }
            const isCurrentFieldPristine = disabledField || deepEqual(get(_defaultValues, name), fieldValue);
            isPreviousDirty = !!(!disabledField && get(_formState.dirtyFields, name));
            isCurrentFieldPristine || disabledField
                ? unset(_formState.dirtyFields, name)
                : set(_formState.dirtyFields, name, true);
            output.dirtyFields = _formState.dirtyFields;
            shouldUpdateField =
                shouldUpdateField ||
                    (_proxyFormState.dirtyFields &&
                        isPreviousDirty !== !isCurrentFieldPristine);
        }
        if (isBlurEvent) {
            const isPreviousFieldTouched = get(_formState.touchedFields, name);
            if (!isPreviousFieldTouched) {
                set(_formState.touchedFields, name, isBlurEvent);
                output.touchedFields = _formState.touchedFields;
                shouldUpdateField =
                    shouldUpdateField ||
                        (_proxyFormState.touchedFields &&
                            isPreviousFieldTouched !== isBlurEvent);
            }
        }
        shouldUpdateField && shouldRender && _subjects.state.next(output);
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState) => {
        const previousFieldError = get(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid &&
            isBoolean(isValid) &&
            _formState.isValid !== isValid;
        if (props.delayError && error) {
            delayErrorCallback = debounce(() => updateErrors(name, error));
            delayErrorCallback(props.delayError);
        }
        else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error
                ? set(_formState.errors, name, error)
                : unset(_formState.errors, name);
        }
        if ((error ? !deepEqual(previousFieldError, error) : previousFieldError) ||
            !isEmptyObject(fieldState) ||
            shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...(shouldUpdateValid && isBoolean(isValid) ? { isValid } : {}),
                errors: _formState.errors,
                name,
            };
            _formState = {
                ..._formState,
                ...updatedFormState,
            };
            _subjects.state.next(updatedFormState);
        }
        _updateIsValidating(false);
    };
    const _executeSchema = async (name) => _options.resolver(_formValues, _options.context, getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
    const executeSchemaAndUpdateState = async (names) => {
        const { errors } = await _executeSchema(names);
        if (names) {
            for (const name of names) {
                const error = get(errors, name);
                error
                    ? set(_formState.errors, name, error)
                    : unset(_formState.errors, name);
            }
        }
        else {
            _formState.errors = errors;
        }
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true,
    }) => {
        for (const name in fields) {
            const field = fields[name];
            if (field) {
                const { _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const fieldError = await validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) {
                            break;
                        }
                    }
                    !shouldOnlyCheckValid &&
                        (get(fieldError, _f.name)
                            ? isFieldArrayRoot
                                ? updateFieldArrayRootError(_formState.errors, fieldError, _f.name)
                                : set(_formState.errors, _f.name, fieldError[_f.name])
                            : unset(_formState.errors, _f.name));
                }
                fieldValue &&
                    (await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context));
            }
        }
        return context.valid;
    };
    const _removeUnmounted = () => {
        for (const name of _names.unMount) {
            const field = get(_fields, name);
            field &&
                (field._f.refs
                    ? field._f.refs.every((ref) => !live(ref))
                    : !live(field._f.ref)) &&
                unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data) => (name && data && set(_formValues, name, data),
        !deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal) => generateWatchOutput(names, _names, {
        ...(_state.mount
            ? _formValues
            : isUndefined(defaultValue)
                ? _defaultValues
                : isString(names)
                    ? { [names]: defaultValue }
                    : defaultValue),
    }, isGlobal, defaultValue);
    const _getFieldArray = (name) => compact(get(_state.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? get(_defaultValues, name, []) : []));
    const setFieldValue = (name, value, options = {}) => {
        const field = get(_fields, name);
        let fieldValue = value;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled &&
                    set(_formValues, name, getFieldValueAs(value, fieldReference));
                fieldValue =
                    isHTMLElement(fieldReference.ref) && isNullOrUndefined(value)
                        ? ''
                        : value;
                if (isMultipleSelect(fieldReference.ref)) {
                    [...fieldReference.ref.options].forEach((optionRef) => (optionRef.selected = fieldValue.includes(optionRef.value)));
                }
                else if (fieldReference.refs) {
                    if (isCheckBoxInput(fieldReference.ref)) {
                        fieldReference.refs.length > 1
                            ? fieldReference.refs.forEach((checkboxRef) => (!checkboxRef.defaultChecked || !checkboxRef.disabled) &&
                                (checkboxRef.checked = Array.isArray(fieldValue)
                                    ? !!fieldValue.find((data) => data === checkboxRef.value)
                                    : fieldValue === checkboxRef.value))
                            : fieldReference.refs[0] &&
                                (fieldReference.refs[0].checked = !!fieldValue);
                    }
                    else {
                        fieldReference.refs.forEach((radioRef) => (radioRef.checked = radioRef.value === fieldValue));
                    }
                }
                else if (isFileInput(fieldReference.ref)) {
                    fieldReference.ref.value = '';
                }
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) {
                        _subjects.values.next({
                            name,
                            values: { ..._formValues },
                        });
                    }
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) &&
            updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value, options) => {
        for (const fieldKey in value) {
            const fieldValue = value[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = get(_fields, fieldName);
            (_names.array.has(name) ||
                !isPrimitive(fieldValue) ||
                (field && !field._f)) &&
                !isDateObject(fieldValue)
                ? setValues(fieldName, fieldValue, options)
                : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value, options = {}) => {
        const field = get(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = cloneObject(value);
        set(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name,
                values: { ..._formValues },
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) &&
                options.shouldDirty) {
                _subjects.state.next({
                    name,
                    dirtyFields: getDirtyFields(_defaultValues, _formValues),
                    isDirty: _getDirty(name, cloneValue),
                });
            }
        }
        else {
            field && !field._f && !isNullOrUndefined(cloneValue)
                ? setValues(name, cloneValue, options)
                : setFieldValue(name, cloneValue, options);
        }
        isWatched(name, _names) && _subjects.state.next({ ..._formState });
        _subjects.values.next({
            name,
            values: { ..._formValues },
        });
        !_state.mount && flushRootRender();
    };
    const onChange = async (event) => {
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = get(_fields, name);
        const getCurrentFieldValue = () => target.type ? getFieldValue(field._f) : getEventValue(event);
        const _updateIsFieldValueUpdated = (fieldValue) => {
            isFieldValueUpdated =
                Number.isNaN(fieldValue) ||
                    fieldValue === get(_formValues, name, fieldValue);
        };
        if (field) {
            let error;
            let isValid;
            const fieldValue = getCurrentFieldValue();
            const isBlurEvent = event.type === EVENTS.BLUR || event.type === EVENTS.FOCUS_OUT;
            const shouldSkipValidation = (!hasValidation(field._f) &&
                !_options.resolver &&
                !get(_formState.errors, name) &&
                !field._f.deps) ||
                skipValidation(isBlurEvent, get(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = isWatched(name, _names, isBlurEvent);
            set(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            }
            else if (field._f.onChange) {
                field._f.onChange(event);
            }
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !isEmptyObject(fieldState) || watched;
            !isBlurEvent &&
                _subjects.values.next({
                    name,
                    type: event.type,
                    values: { ..._formValues },
                });
            if (shouldSkipValidation) {
                _proxyFormState.isValid && _updateValid();
                return (shouldRender &&
                    _subjects.state.next({ name, ...(watched ? {} : fieldState) }));
            }
            !isBlurEvent && watched && _subjects.state.next({ ..._formState });
            _updateIsValidating(true);
            if (_options.resolver) {
                const { errors } = await _executeSchema([name]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    const previousErrorLookupResult = schemaErrorLookup(_formState.errors, _fields, name);
                    const errorLookupResult = schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                    error = errorLookupResult.error;
                    name = errorLookupResult.name;
                    isValid = isEmptyObject(errors);
                }
            }
            else {
                error = (await validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    if (error) {
                        isValid = false;
                    }
                    else if (_proxyFormState.isValid) {
                        isValid = await executeBuiltInValidation(_fields, true);
                    }
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps &&
                    trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const _focusInput = (ref, key) => {
        if (get(_formState.errors, key) && ref.focus) {
            ref.focus();
            return 1;
        }
        return;
    };
    const trigger = async (name, options = {}) => {
        let isValid;
        let validationResult;
        const fieldNames = convertToArrayPayload(name);
        _updateIsValidating(true);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState(isUndefined(name) ? name : fieldNames);
            isValid = isEmptyObject(errors);
            validationResult = name
                ? !fieldNames.some((name) => get(errors, name))
                : isValid;
        }
        else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName) => {
                const field = get(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? { [fieldName]: field } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        }
        else {
            validationResult = isValid = await executeBuiltInValidation(_fields);
        }
        _subjects.state.next({
            ...(!isString(name) ||
                (_proxyFormState.isValid && isValid !== _formState.isValid)
                ? {}
                : { name }),
            ...(_options.resolver || !name ? { isValid } : {}),
            errors: _formState.errors,
            isValidating: false,
        });
        options.shouldFocus &&
            !validationResult &&
            iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames) => {
        const values = {
            ..._defaultValues,
            ...(_state.mount ? _formValues : {}),
        };
        return isUndefined(fieldNames)
            ? values
            : isString(fieldNames)
                ? get(values, fieldNames)
                : fieldNames.map((name) => get(values, name));
    };
    const getFieldState = (name, formState) => ({
        invalid: !!get((formState || _formState).errors, name),
        isDirty: !!get((formState || _formState).dirtyFields, name),
        isTouched: !!get((formState || _formState).touchedFields, name),
        error: get((formState || _formState).errors, name),
    });
    const clearErrors = (name) => {
        name &&
            convertToArrayPayload(name).forEach((inputName) => unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {},
        });
    };
    const setError = (name, error, options) => {
        const ref = (get(_fields, name, { _f: {} })._f || {}).ref;
        set(_formState.errors, name, {
            ...error,
            ref,
        });
        _subjects.state.next({
            name,
            errors: _formState.errors,
            isValid: false,
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue) => isFunction(name)
        ? _subjects.values.subscribe({
            next: (payload) => name(_getWatch(undefined, defaultValue), payload),
        })
        : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {}) => {
        for (const fieldName of name ? convertToArrayPayload(name) : _names.mount) {
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                unset(_fields, fieldName);
                unset(_formValues, fieldName);
            }
            !options.keepError && unset(_formState.errors, fieldName);
            !options.keepDirty && unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && unset(_formState.touchedFields, fieldName);
            !_options.shouldUnregister &&
                !options.keepDefaultValue &&
                unset(_defaultValues, fieldName);
        }
        _subjects.values.next({
            values: { ..._formValues },
        });
        _subjects.state.next({
            ..._formState,
            ...(!options.keepDirty ? {} : { isDirty: _getDirty() }),
        });
        !options.keepIsValid && _updateValid();
    };
    const _updateDisabledField = ({ disabled, name, field, fields, value, }) => {
        if (isBoolean(disabled)) {
            const inputValue = disabled
                ? undefined
                : isUndefined(value)
                    ? getFieldValue(field ? field._f : get(fields, name)._f)
                    : value;
            set(_formValues, name, inputValue);
            updateTouchAndDirty(name, inputValue, false, false, true);
        }
    };
    const register = (name, options = {}) => {
        let field = get(_fields, name);
        const disabledIsDefined = isBoolean(options.disabled);
        set(_fields, name, {
            ...(field || {}),
            _f: {
                ...(field && field._f ? field._f : { ref: { name } }),
                name,
                mount: true,
                ...options,
            },
        });
        _names.mount.add(name);
        if (field) {
            _updateDisabledField({
                field,
                disabled: options.disabled,
                name,
                value: options.value,
            });
        }
        else {
            updateValidAndValue(name, true, options.value);
        }
        return {
            ...(disabledIsDefined ? { disabled: options.disabled } : {}),
            ...(_options.progressive
                ? {
                    required: !!options.required,
                    min: getRuleValue(options.min),
                    max: getRuleValue(options.max),
                    minLength: getRuleValue(options.minLength),
                    maxLength: getRuleValue(options.maxLength),
                    pattern: getRuleValue(options.pattern),
                }
                : {}),
            name,
            onChange,
            onBlur: onChange,
            ref: (ref) => {
                if (ref) {
                    register(name, options);
                    field = get(_fields, name);
                    const fieldRef = isUndefined(ref.value)
                        ? ref.querySelectorAll
                            ? ref.querySelectorAll('input,select,textarea')[0] || ref
                            : ref
                        : ref;
                    const radioOrCheckbox = isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox
                        ? refs.find((option) => option === fieldRef)
                        : fieldRef === field._f.ref) {
                        return;
                    }
                    set(_fields, name, {
                        _f: {
                            ...field._f,
                            ...(radioOrCheckbox
                                ? {
                                    refs: [
                                        ...refs.filter(live),
                                        fieldRef,
                                        ...(Array.isArray(get(_defaultValues, name)) ? [{}] : []),
                                    ],
                                    ref: { type: fieldRef.type, name },
                                }
                                : { ref: fieldRef }),
                        },
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                }
                else {
                    field = get(_fields, name, {});
                    if (field._f) {
                        field._f.mount = false;
                    }
                    (_options.shouldUnregister || options.shouldUnregister) &&
                        !(isNameInFieldArray(_names.array, name) && _state.action) &&
                        _names.unMount.add(name);
                }
            },
        };
    };
    const _focusError = () => _options.shouldFocusError &&
        iterateFieldsByAction(_fields, _focusInput, _names.mount);
    const _disableForm = (disabled) => {
        if (isBoolean(disabled)) {
            _subjects.state.next({ disabled });
            iterateFieldsByAction(_fields, (ref, name) => {
                let requiredDisabledState = disabled;
                const currentField = get(_fields, name);
                if (currentField && isBoolean(currentField._f.disabled)) {
                    requiredDisabledState || (requiredDisabledState = currentField._f.disabled);
                }
                ref.disabled = requiredDisabledState;
            }, 0, false);
        }
    };
    const handleSubmit = (onValid, onInvalid) => async (e) => {
        let onValidError = undefined;
        if (e) {
            e.preventDefault && e.preventDefault();
            e.persist && e.persist();
        }
        let fieldValues = cloneObject(_formValues);
        _subjects.state.next({
            isSubmitting: true,
        });
        if (_options.resolver) {
            const { errors, values } = await _executeSchema();
            _formState.errors = errors;
            fieldValues = values;
        }
        else {
            await executeBuiltInValidation(_fields);
        }
        unset(_formState.errors, 'root');
        if (isEmptyObject(_formState.errors)) {
            _subjects.state.next({
                errors: {},
            });
            try {
                await onValid(fieldValues, e);
            }
            catch (error) {
                onValidError = error;
            }
        }
        else {
            if (onInvalid) {
                await onInvalid({ ..._formState.errors }, e);
            }
            _focusError();
            setTimeout(_focusError);
        }
        _subjects.state.next({
            isSubmitted: true,
            isSubmitting: false,
            isSubmitSuccessful: isEmptyObject(_formState.errors) && !onValidError,
            submitCount: _formState.submitCount + 1,
            errors: _formState.errors,
        });
        if (onValidError) {
            throw onValidError;
        }
    };
    const resetField = (name, options = {}) => {
        if (get(_fields, name)) {
            if (isUndefined(options.defaultValue)) {
                setValue(name, cloneObject(get(_defaultValues, name)));
            }
            else {
                setValue(name, options.defaultValue);
                set(_defaultValues, name, cloneObject(options.defaultValue));
            }
            if (!options.keepTouched) {
                unset(_formState.touchedFields, name);
            }
            if (!options.keepDirty) {
                unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue
                    ? _getDirty(name, cloneObject(get(_defaultValues, name)))
                    : _getDirty();
            }
            if (!options.keepError) {
                unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next({ ..._formState });
        }
    };
    const _reset = (formValues, keepStateOptions = {}) => {
        const updatedValues = formValues ? cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = cloneObject(updatedValues);
        const values = formValues && !isEmptyObject(formValues)
            ? cloneUpdatedValues
            : _defaultValues;
        if (!keepStateOptions.keepDefaultValues) {
            _defaultValues = updatedValues;
        }
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) {
                for (const fieldName of _names.mount) {
                    get(_formState.dirtyFields, fieldName)
                        ? set(values, fieldName, get(_formValues, fieldName))
                        : setValue(fieldName, get(values, fieldName));
                }
            }
            else {
                if (isWeb && isUndefined(formValues)) {
                    for (const name of _names.mount) {
                        const field = get(_fields, name);
                        if (field && field._f) {
                            const fieldReference = Array.isArray(field._f.refs)
                                ? field._f.refs[0]
                                : field._f.ref;
                            if (isHTMLElement(fieldReference)) {
                                const form = fieldReference.closest('form');
                                if (form) {
                                    form.reset();
                                    break;
                                }
                            }
                        }
                    }
                }
                _fields = {};
            }
            _formValues = props.shouldUnregister
                ? keepStateOptions.keepDefaultValues
                    ? cloneObject(_defaultValues)
                    : {}
                : cloneObject(values);
            _subjects.array.next({
                values: { ...values },
            });
            _subjects.values.next({
                values: { ...values },
            });
        }
        _names = {
            mount: new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: '',
        };
        !_state.mount && flushRootRender();
        _state.mount =
            !_proxyFormState.isValid ||
                !!keepStateOptions.keepIsValid ||
                !!keepStateOptions.keepDirtyValues;
        _state.watch = !!props.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount
                ? _formState.submitCount
                : 0,
            isDirty: keepStateOptions.keepDirty
                ? _formState.isDirty
                : !!(keepStateOptions.keepDefaultValues &&
                    !deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted
                ? _formState.isSubmitted
                : false,
            dirtyFields: keepStateOptions.keepDirtyValues
                ? keepStateOptions.keepDefaultValues && _formValues
                    ? getDirtyFields(_defaultValues, _formValues)
                    : _formState.dirtyFields
                : keepStateOptions.keepDefaultValues && formValues
                    ? getDirtyFields(_defaultValues, formValues)
                    : {},
            touchedFields: keepStateOptions.keepTouched
                ? _formState.touchedFields
                : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful
                ? _formState.isSubmitSuccessful
                : false,
            isSubmitting: false,
        });
    };
    const reset = (formValues, keepStateOptions) => _reset(isFunction(formValues)
        ? formValues(_formValues)
        : formValues, keepStateOptions);
    const setFocus = (name, options = {}) => {
        const field = get(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs
                ? fieldReference.refs[0]
                : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && fieldRef.select();
            }
        }
    };
    const _updateFormState = (updatedFormState) => {
        _formState = {
            ..._formState,
            ...updatedFormState,
        };
    };
    const _resetDefaultValues = () => isFunction(_options.defaultValues) &&
        _options.defaultValues().then((values) => {
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false,
            });
        });
    return {
        control: {
            register,
            unregister,
            getFieldState,
            handleSubmit,
            setError,
            _executeSchema,
            _getWatch,
            _getDirty,
            _updateValid,
            _removeUnmounted,
            _updateFieldArray,
            _updateDisabledField,
            _getFieldArray,
            _reset,
            _resetDefaultValues,
            _updateFormState,
            _disableForm,
            _subjects,
            _proxyFormState,
            _setErrors,
            get _fields() {
                return _fields;
            },
            get _formValues() {
                return _formValues;
            },
            get _state() {
                return _state;
            },
            set _state(value) {
                _state = value;
            },
            get _defaultValues() {
                return _defaultValues;
            },
            get _names() {
                return _names;
            },
            set _names(value) {
                _names = value;
            },
            get _formState() {
                return _formState;
            },
            set _formState(value) {
                _formState = value;
            },
            get _options() {
                return _options;
            },
            set _options(value) {
                _options = {
                    ..._options,
                    ...value,
                };
            },
        },
        trigger,
        register,
        handleSubmit,
        watch,
        setValue,
        getValues,
        reset,
        resetField,
        clearErrors,
        unregister,
        setError,
        setFocus,
        getFieldState,
    };
}

/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */
function useForm(props = {}) {
    const _formControl = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
    const _values = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
    const [formState, updateFormState] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
        isDirty: false,
        isValidating: false,
        isLoading: isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        errors: props.errors || {},
        disabled: props.disabled || false,
        defaultValues: isFunction(props.defaultValues)
            ? undefined
            : props.defaultValues,
    });
    if (!_formControl.current) {
        _formControl.current = {
            ...createFormControl(props, () => updateFormState((formState) => ({ ...formState }))),
            formState,
        };
    }
    const control = _formControl.current.control;
    control._options = props;
    useSubscribe({
        subject: control._subjects.state,
        next: (value) => {
            if (shouldRenderFormState(value, control._proxyFormState, control._updateFormState, true)) {
                updateFormState({ ...control._formState });
            }
        },
    });
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => control._disableForm(props.disabled), [control, props.disabled]);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        if (control._proxyFormState.isDirty) {
            const isDirty = control._getDirty();
            if (isDirty !== formState.isDirty) {
                control._subjects.state.next({
                    isDirty,
                });
            }
        }
    }, [control, formState.isDirty]);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        if (props.values && !deepEqual(props.values, _values.current)) {
            control._reset(props.values, control._options.resetOptions);
            _values.current = props.values;
            updateFormState((state) => ({ ...state }));
        }
        else {
            control._resetDefaultValues();
        }
    }, [props.values, control]);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        if (props.errors) {
            control._setErrors(props.errors);
        }
    }, [props.errors, control]);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        if (!control._state.mount) {
            control._updateValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({ ...control._formState });
        }
        control._removeUnmounted();
    });
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        props.shouldUnregister &&
            control._subjects.values.next({
                values: control._getWatch(),
            });
    }, [props.shouldUnregister, control]);
    _formControl.current.formState = getProxyFormState(formState, control);
    return _formControl.current;
}


//# sourceMappingURL=index.esm.mjs.map


/***/ }),

/***/ 205:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YD": function() { return /* binding */ useInView; }
/* harmony export */ });
/* unused harmony exports InView, defaultFallbackInView, observe */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
"use client";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/InView.tsx


// src/observe.ts
var observerMap = /* @__PURE__ */ new Map();
var RootIds = /* @__PURE__ */ new WeakMap();
var rootId = 0;
var unsupportedValue = void 0;
function defaultFallbackInView(inView) {
  unsupportedValue = inView;
}
function getRootId(root) {
  if (!root)
    return "0";
  if (RootIds.has(root))
    return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
function optionsToId(options) {
  return Object.keys(options).sort().filter(
    (key) => options[key] !== void 0
  ).map((key) => {
    return `${key}_${key === "root" ? getRootId(options.root) : options[key]}`;
  }).toString();
}
function createObserver(options) {
  const id = optionsToId(options);
  let instance = observerMap.get(id);
  if (!instance) {
    const elements = /* @__PURE__ */ new Map();
    let thresholds;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        var _a;
        const inView = entry.isIntersecting && thresholds.some((threshold) => entry.intersectionRatio >= threshold);
        if (options.trackVisibility && typeof entry.isVisible === "undefined") {
          entry.isVisible = inView;
        }
        (_a = elements.get(entry.target)) == null ? void 0 : _a.forEach((callback) => {
          callback(inView, entry);
        });
      });
    }, options);
    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id,
      observer,
      elements
    };
    observerMap.set(id, instance);
  }
  return instance;
}
function observe(element, callback, options = {}, fallbackInView = unsupportedValue) {
  if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
    const bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return () => {
    };
  }
  const { id, observer, elements } = createObserver(options);
  const callbacks = elements.get(element) || [];
  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }
  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    callbacks.splice(callbacks.indexOf(callback), 1);
    if (callbacks.length === 0) {
      elements.delete(element);
      observer.unobserve(element);
    }
    if (elements.size === 0) {
      observer.disconnect();
      observerMap.delete(id);
    }
  };
}

// src/InView.tsx
function isPlainChildren(props) {
  return typeof props.children !== "function";
}
var InView = class extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor(props) {
    super(props);
    __publicField(this, "node", null);
    __publicField(this, "_unobserveCb", null);
    __publicField(this, "handleNode", (node) => {
      if (this.node) {
        this.unobserve();
        if (!node && !this.props.triggerOnce && !this.props.skip) {
          this.setState({ inView: !!this.props.initialInView, entry: void 0 });
        }
      }
      this.node = node ? node : null;
      this.observeNode();
    });
    __publicField(this, "handleChange", (inView, entry) => {
      if (inView && this.props.triggerOnce) {
        this.unobserve();
      }
      if (!isPlainChildren(this.props)) {
        this.setState({ inView, entry });
      }
      if (this.props.onChange) {
        this.props.onChange(inView, entry);
      }
    });
    this.state = {
      inView: !!props.initialInView,
      entry: void 0
    };
  }
  componentDidMount() {
    this.unobserve();
    this.observeNode();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  }
  componentWillUnmount() {
    this.unobserve();
  }
  observeNode() {
    if (!this.node || this.props.skip)
      return;
    const {
      threshold,
      root,
      rootMargin,
      trackVisibility,
      delay,
      fallbackInView
    } = this.props;
    this._unobserveCb = observe(
      this.node,
      this.handleChange,
      {
        threshold,
        root,
        rootMargin,
        // @ts-ignore
        trackVisibility,
        // @ts-ignore
        delay
      },
      fallbackInView
    );
  }
  unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();
      this._unobserveCb = null;
    }
  }
  render() {
    const { children } = this.props;
    if (typeof children === "function") {
      const { inView, entry } = this.state;
      return children({ inView, entry, ref: this.handleNode });
    }
    const {
      as,
      triggerOnce,
      threshold,
      root,
      rootMargin,
      onChange,
      skip,
      trackVisibility,
      delay,
      initialInView,
      fallbackInView,
      ...props
    } = this.props;
    return React.createElement(
      as || "div",
      { ref: this.handleNode, ...props },
      children
    );
  }
};

// src/useInView.tsx

function useInView({
  threshold,
  delay,
  trackVisibility,
  rootMargin,
  root,
  triggerOnce,
  skip,
  initialInView,
  fallbackInView,
  onChange
} = {}) {
  var _a;
  const [ref, setRef] = react__WEBPACK_IMPORTED_MODULE_0__.useState(null);
  const callback = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  const [state, setState] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
    inView: !!initialInView,
    entry: void 0
  });
  callback.current = onChange;
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(
    () => {
      if (skip || !ref)
        return;
      let unobserve;
      unobserve = observe(
        ref,
        (inView, entry) => {
          setState({
            inView,
            entry
          });
          if (callback.current)
            callback.current(inView, entry);
          if (entry.isIntersecting && triggerOnce && unobserve) {
            unobserve();
            unobserve = void 0;
          }
        },
        {
          root,
          rootMargin,
          threshold,
          // @ts-ignore
          trackVisibility,
          // @ts-ignore
          delay
        },
        fallbackInView
      );
      return () => {
        if (unobserve) {
          unobserve();
        }
      };
    },
    // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // If the threshold is an array, convert it to a string, so it won't change between renders.
      Array.isArray(threshold) ? threshold.toString() : threshold,
      ref,
      root,
      rootMargin,
      triggerOnce,
      skip,
      trackVisibility,
      fallbackInView,
      delay
    ]
  );
  const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
  const previousEntryTarget = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
    previousEntryTarget.current = entryTarget;
    setState({
      inView: !!initialInView,
      entry: void 0
    });
  }
  const result = [setRef, state.inView, state.entry];
  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}

//# sourceMappingURL=index.mjs.map

/***/ }),

/***/ 3365:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s5": function() { return /* reexport */ A11y; },
  "pt": function() { return /* reexport */ Autoplay; },
  "xW": function() { return /* reexport */ EffectFade; },
  "W_": function() { return /* reexport */ Navigation; },
  "tl": function() { return /* reexport */ Pagination; },
  "o3": function() { return /* reexport */ Thumb; }
});

// UNUSED EXPORTS: Controller, EffectCards, EffectCoverflow, EffectCreative, EffectCube, EffectFlip, FreeMode, Grid, HashNavigation, History, Keyboard, Manipulation, Mousewheel, Parallax, Scrollbar, Virtual, Zoom

// EXTERNAL MODULE: ../node_modules/swiper/shared/ssr-window.esm.mjs
var ssr_window_esm = __webpack_require__(2882);
// EXTERNAL MODULE: ../node_modules/swiper/shared/utils.mjs
var utils = __webpack_require__(1691);
;// CONCATENATED MODULE: ../node_modules/swiper/modules/virtual.mjs



function Virtual({
  swiper,
  extendParams,
  on,
  emit
}) {
  extendParams({
    virtual: {
      enabled: false,
      slides: [],
      cache: true,
      slidesPerViewAutoSlideSize: 320,
      renderSlide: null,
      renderExternal: null,
      renderExternalUpdate: true,
      addSlidesBefore: 0,
      addSlidesAfter: 0
    }
  });
  let cssModeTimeout;
  const document = getDocument();
  swiper.virtual = {
    cache: {},
    from: undefined,
    to: undefined,
    slides: [],
    offset: 0,
    slidesGrid: []
  };
  const tempDOM = document.createElement('div');
  function renderSlide(slide, index) {
    const params = swiper.params.virtual;
    if (params.cache && swiper.virtual.cache[index]) {
      return swiper.virtual.cache[index];
    }
    // eslint-disable-next-line
    let slideEl;
    if (params.renderSlide) {
      slideEl = params.renderSlide.call(swiper, slide, index);
      if (typeof slideEl === 'string') {
        setInnerHTML(tempDOM, slideEl);
        slideEl = tempDOM.children[0];
      }
    } else if (swiper.isElement) {
      slideEl = createElement('swiper-slide');
    } else {
      slideEl = createElement('div', swiper.params.slideClass);
    }
    slideEl.setAttribute('data-swiper-slide-index', index);
    if (!params.renderSlide) {
      setInnerHTML(slideEl, slide);
    }
    if (params.cache) {
      swiper.virtual.cache[index] = slideEl;
    }
    return slideEl;
  }
  function update(force, beforeInit, forceActiveIndex) {
    const {
      slidesPerGroup,
      centeredSlides,
      slidesPerView,
      loop: isLoop,
      initialSlide
    } = swiper.params;
    if (beforeInit && !isLoop && initialSlide > 0) {
      return;
    }
    const {
      addSlidesBefore,
      addSlidesAfter,
      slidesPerViewAutoSlideSize
    } = swiper.params.virtual;
    const {
      from: previousFrom,
      to: previousTo,
      slides,
      slidesGrid: previousSlidesGrid,
      offset: previousOffset
    } = swiper.virtual;
    if (!swiper.params.cssMode) {
      swiper.updateActiveIndex();
    }
    const activeIndex = typeof forceActiveIndex === 'undefined' ? swiper.activeIndex || 0 : forceActiveIndex;
    let offsetProp;
    if (swiper.rtlTranslate) offsetProp = 'right';else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
    let slidesPerViewNumeric;
    if (slidesPerView === 'auto') {
      if (slidesPerViewAutoSlideSize) {
        let swiperSize = swiper.size;
        if (!swiperSize) {
          swiperSize = swiper.isHorizontal() ? swiper.el.getBoundingClientRect().width : swiper.el.getBoundingClientRect().height;
        }
        slidesPerViewNumeric = Math.max(1, Math.ceil(swiperSize / slidesPerViewAutoSlideSize));
      } else {
        slidesPerViewNumeric = 1;
      }
    } else {
      slidesPerViewNumeric = slidesPerView;
    }
    let slidesAfter;
    let slidesBefore;
    if (centeredSlides) {
      slidesAfter = Math.floor(slidesPerViewNumeric / 2) + slidesPerGroup + addSlidesAfter;
      slidesBefore = Math.floor(slidesPerViewNumeric / 2) + slidesPerGroup + addSlidesBefore;
    } else {
      slidesAfter = slidesPerViewNumeric + (slidesPerGroup - 1) + addSlidesAfter;
      slidesBefore = (isLoop ? slidesPerViewNumeric : slidesPerGroup) + addSlidesBefore;
    }
    let from = activeIndex - slidesBefore;
    let to = activeIndex + slidesAfter;
    if (!isLoop) {
      from = Math.max(from, 0);
      to = Math.min(to, slides.length - 1);
    }
    let offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
    if (isLoop && activeIndex >= slidesBefore) {
      from -= slidesBefore;
      if (!centeredSlides) offset += swiper.slidesGrid[0];
    } else if (isLoop && activeIndex < slidesBefore) {
      from = -slidesBefore;
      if (centeredSlides) offset += swiper.slidesGrid[0];
    }
    Object.assign(swiper.virtual, {
      from,
      to,
      offset,
      slidesGrid: swiper.slidesGrid,
      slidesBefore,
      slidesAfter
    });
    function onRendered() {
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();
      emit('virtualUpdate');
    }
    if (previousFrom === from && previousTo === to && !force) {
      if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
        swiper.slides.forEach(slideEl => {
          slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
        });
      }
      swiper.updateProgress();
      emit('virtualUpdate');
      return;
    }
    if (swiper.params.virtual.renderExternal) {
      swiper.params.virtual.renderExternal.call(swiper, {
        offset,
        from,
        to,
        slides: function getSlides() {
          const slidesToRender = [];
          for (let i = from; i <= to; i += 1) {
            slidesToRender.push(slides[i]);
          }
          return slidesToRender;
        }()
      });
      if (swiper.params.virtual.renderExternalUpdate) {
        onRendered();
      } else {
        emit('virtualUpdate');
      }
      return;
    }
    const prependIndexes = [];
    const appendIndexes = [];
    const getSlideIndex = index => {
      let slideIndex = index;
      if (index < 0) {
        slideIndex = slides.length + index;
      } else if (slideIndex >= slides.length) {
        // eslint-disable-next-line
        slideIndex = slideIndex - slides.length;
      }
      return slideIndex;
    };
    if (force) {
      swiper.slides.filter(el => el.matches(`.${swiper.params.slideClass}, swiper-slide`)).forEach(slideEl => {
        slideEl.remove();
      });
    } else {
      for (let i = previousFrom; i <= previousTo; i += 1) {
        if (i < from || i > to) {
          const slideIndex = getSlideIndex(i);
          swiper.slides.filter(el => el.matches(`.${swiper.params.slideClass}[data-swiper-slide-index="${slideIndex}"], swiper-slide[data-swiper-slide-index="${slideIndex}"]`)).forEach(slideEl => {
            slideEl.remove();
          });
        }
      }
    }
    const loopFrom = isLoop ? -slides.length : 0;
    const loopTo = isLoop ? slides.length * 2 : slides.length;
    for (let i = loopFrom; i < loopTo; i += 1) {
      if (i >= from && i <= to) {
        const slideIndex = getSlideIndex(i);
        if (typeof previousTo === 'undefined' || force) {
          appendIndexes.push(slideIndex);
        } else {
          if (i > previousTo) appendIndexes.push(slideIndex);
          if (i < previousFrom) prependIndexes.push(slideIndex);
        }
      }
    }
    appendIndexes.forEach(index => {
      swiper.slidesEl.append(renderSlide(slides[index], index));
    });
    if (isLoop) {
      for (let i = prependIndexes.length - 1; i >= 0; i -= 1) {
        const index = prependIndexes[i];
        swiper.slidesEl.prepend(renderSlide(slides[index], index));
      }
    } else {
      prependIndexes.sort((a, b) => b - a);
      prependIndexes.forEach(index => {
        swiper.slidesEl.prepend(renderSlide(slides[index], index));
      });
    }
    elementChildren(swiper.slidesEl, '.swiper-slide, swiper-slide').forEach(slideEl => {
      slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
    });
    onRendered();
  }
  function appendSlide(slides) {
    if (typeof slides === 'object' && 'length' in slides) {
      for (let i = 0; i < slides.length; i += 1) {
        if (slides[i]) swiper.virtual.slides.push(slides[i]);
      }
    } else {
      swiper.virtual.slides.push(slides);
    }
    update(true);
  }
  function prependSlide(slides) {
    const activeIndex = swiper.activeIndex;
    let newActiveIndex = activeIndex + 1;
    let numberOfNewSlides = 1;
    if (Array.isArray(slides)) {
      for (let i = 0; i < slides.length; i += 1) {
        if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
      }
      newActiveIndex = activeIndex + slides.length;
      numberOfNewSlides = slides.length;
    } else {
      swiper.virtual.slides.unshift(slides);
    }
    if (swiper.params.virtual.cache) {
      const cache = swiper.virtual.cache;
      const newCache = {};
      Object.keys(cache).forEach(cachedIndex => {
        const cachedEl = cache[cachedIndex];
        const cachedElIndex = cachedEl.getAttribute('data-swiper-slide-index');
        if (cachedElIndex) {
          cachedEl.setAttribute('data-swiper-slide-index', parseInt(cachedElIndex, 10) + numberOfNewSlides);
        }
        newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cachedEl;
      });
      swiper.virtual.cache = newCache;
    }
    update(true);
    swiper.slideTo(newActiveIndex, 0);
  }
  function removeSlide(slidesIndexes) {
    if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
    let activeIndex = swiper.activeIndex;
    if (Array.isArray(slidesIndexes)) {
      for (let i = slidesIndexes.length - 1; i >= 0; i -= 1) {
        if (swiper.params.virtual.cache) {
          delete swiper.virtual.cache[slidesIndexes[i]];
          // shift cache indexes
          Object.keys(swiper.virtual.cache).forEach(key => {
            if (key > slidesIndexes) {
              swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
              swiper.virtual.cache[key - 1].setAttribute('data-swiper-slide-index', key - 1);
              delete swiper.virtual.cache[key];
            }
          });
        }
        swiper.virtual.slides.splice(slidesIndexes[i], 1);
        if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
        activeIndex = Math.max(activeIndex, 0);
      }
    } else {
      if (swiper.params.virtual.cache) {
        delete swiper.virtual.cache[slidesIndexes];
        // shift cache indexes
        Object.keys(swiper.virtual.cache).forEach(key => {
          if (key > slidesIndexes) {
            swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
            swiper.virtual.cache[key - 1].setAttribute('data-swiper-slide-index', key - 1);
            delete swiper.virtual.cache[key];
          }
        });
      }
      swiper.virtual.slides.splice(slidesIndexes, 1);
      if (slidesIndexes < activeIndex) activeIndex -= 1;
      activeIndex = Math.max(activeIndex, 0);
    }
    update(true);
    swiper.slideTo(activeIndex, 0);
  }
  function removeAllSlides() {
    swiper.virtual.slides = [];
    if (swiper.params.virtual.cache) {
      swiper.virtual.cache = {};
    }
    update(true);
    swiper.slideTo(0, 0);
  }
  on('beforeInit', () => {
    if (!swiper.params.virtual.enabled) return;
    let domSlidesAssigned;
    if (typeof swiper.passedParams.virtual.slides === 'undefined') {
      const slides = [...swiper.slidesEl.children].filter(el => el.matches(`.${swiper.params.slideClass}, swiper-slide`));
      if (slides && slides.length) {
        swiper.virtual.slides = [...slides];
        domSlidesAssigned = true;
        slides.forEach((slideEl, slideIndex) => {
          slideEl.setAttribute('data-swiper-slide-index', slideIndex);
          swiper.virtual.cache[slideIndex] = slideEl;
          slideEl.remove();
        });
      }
    }
    if (!domSlidesAssigned) {
      swiper.virtual.slides = swiper.params.virtual.slides;
    }
    swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
    swiper.params.watchSlidesProgress = true;
    swiper.originalParams.watchSlidesProgress = true;
    update(false, true);
  });
  on('setTranslate', () => {
    if (!swiper.params.virtual.enabled) return;
    if (swiper.params.cssMode && !swiper._immediateVirtual) {
      clearTimeout(cssModeTimeout);
      cssModeTimeout = setTimeout(() => {
        update();
      }, 100);
    } else {
      update();
    }
  });
  on('init update resize', () => {
    if (!swiper.params.virtual.enabled) return;
    if (swiper.params.cssMode) {
      setCSSProperty(swiper.wrapperEl, '--swiper-virtual-size', `${swiper.virtualSize}px`);
    }
  });
  Object.assign(swiper.virtual, {
    appendSlide,
    prependSlide,
    removeSlide,
    removeAllSlides,
    update
  });
}



;// CONCATENATED MODULE: ../node_modules/swiper/modules/keyboard.mjs



/* eslint-disable consistent-return */
function Keyboard({
  swiper,
  extendParams,
  on,
  emit
}) {
  const document = getDocument();
  const window = getWindow();
  swiper.keyboard = {
    enabled: false
  };
  extendParams({
    keyboard: {
      enabled: false,
      onlyInViewport: true,
      pageUpDown: true,
      speed: undefined
    }
  });
  function handle(event) {
    if (!swiper.enabled) return;
    const {
      rtlTranslate: rtl
    } = swiper;
    let e = event;
    if (e.originalEvent) e = e.originalEvent; // jquery fix
    const kc = e.keyCode || e.charCode;
    const pageUpDown = swiper.params.keyboard.pageUpDown;
    const isPageUp = pageUpDown && kc === 33;
    const isPageDown = pageUpDown && kc === 34;
    const isArrowLeft = kc === 37;
    const isArrowRight = kc === 39;
    const isArrowUp = kc === 38;
    const isArrowDown = kc === 40;
    // Directions locks
    if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) {
      return false;
    }
    if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) {
      return false;
    }
    if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
      return undefined;
    }
    if (document.activeElement && (document.activeElement.isContentEditable || document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea'))) {
      return undefined;
    }
    if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
      let inView = false;
      // Check that swiper should be inside of visible area of window
      if (elementParents(swiper.el, `.${swiper.params.slideClass}, swiper-slide`).length > 0 && elementParents(swiper.el, `.${swiper.params.slideActiveClass}`).length === 0) {
        return undefined;
      }
      const el = swiper.el;
      const swiperWidth = el.clientWidth;
      const swiperHeight = el.clientHeight;
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      const swiperOffset = elementOffset(el);
      if (rtl) swiperOffset.left -= el.scrollLeft;
      const swiperCoord = [[swiperOffset.left, swiperOffset.top], [swiperOffset.left + swiperWidth, swiperOffset.top], [swiperOffset.left, swiperOffset.top + swiperHeight], [swiperOffset.left + swiperWidth, swiperOffset.top + swiperHeight]];
      for (let i = 0; i < swiperCoord.length; i += 1) {
        const point = swiperCoord[i];
        if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
          if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
          inView = true;
        }
      }
      if (!inView) return undefined;
    }
    const speed = swiper.params.keyboard.speed;
    if (swiper.isHorizontal()) {
      if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
        if (e.preventDefault) e.preventDefault();else e.returnValue = false;
      }
      if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext(speed);
      if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev(speed);
    } else {
      if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
        if (e.preventDefault) e.preventDefault();else e.returnValue = false;
      }
      if (isPageDown || isArrowDown) swiper.slideNext(speed);
      if (isPageUp || isArrowUp) swiper.slidePrev(speed);
    }
    emit('keyPress', kc);
    return undefined;
  }
  function enable() {
    if (swiper.keyboard.enabled) return;
    document.addEventListener('keydown', handle);
    swiper.keyboard.enabled = true;
  }
  function disable() {
    if (!swiper.keyboard.enabled) return;
    document.removeEventListener('keydown', handle);
    swiper.keyboard.enabled = false;
  }
  on('init', () => {
    if (swiper.params.keyboard.enabled) {
      enable();
    }
  });
  on('destroy', () => {
    if (swiper.keyboard.enabled) {
      disable();
    }
  });
  Object.assign(swiper.keyboard, {
    enable,
    disable
  });
}



;// CONCATENATED MODULE: ../node_modules/swiper/modules/mousewheel.mjs



/* eslint-disable consistent-return */
function Mousewheel({
  swiper,
  extendParams,
  on,
  emit
}) {
  const window = getWindow();
  extendParams({
    mousewheel: {
      enabled: false,
      releaseOnEdges: false,
      invert: false,
      forceToAxis: false,
      sensitivity: 1,
      eventsTarget: 'container',
      thresholdDelta: null,
      thresholdTime: null,
      noMousewheelClass: 'swiper-no-mousewheel'
    }
  });
  swiper.mousewheel = {
    enabled: false
  };
  let timeout;
  let lastScrollTime = now();
  let lastEventBeforeSnap;
  const recentWheelEvents = [];
  function normalize(e) {
    // Reasonable defaults
    const PIXEL_STEP = 10;
    const LINE_HEIGHT = 40;
    const PAGE_HEIGHT = 800;
    let sX = 0;
    let sY = 0; // spinX, spinY
    let pX = 0;
    let pY = 0; // pixelX, pixelY

    // Legacy
    if ('detail' in e) {
      sY = e.detail;
    }
    if ('wheelDelta' in e) {
      sY = -e.wheelDelta / 120;
    }
    if ('wheelDeltaY' in e) {
      sY = -e.wheelDeltaY / 120;
    }
    if ('wheelDeltaX' in e) {
      sX = -e.wheelDeltaX / 120;
    }

    // side scrolling on FF with DOMMouseScroll
    if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
      sX = sY;
      sY = 0;
    }
    pX = sX * PIXEL_STEP;
    pY = sY * PIXEL_STEP;
    if ('deltaY' in e) {
      pY = e.deltaY;
    }
    if ('deltaX' in e) {
      pX = e.deltaX;
    }
    if (e.shiftKey && !pX) {
      // if user scrolls with shift he wants horizontal scroll
      pX = pY;
      pY = 0;
    }
    if ((pX || pY) && e.deltaMode) {
      if (e.deltaMode === 1) {
        // delta in LINE units
        pX *= LINE_HEIGHT;
        pY *= LINE_HEIGHT;
      } else {
        // delta in PAGE units
        pX *= PAGE_HEIGHT;
        pY *= PAGE_HEIGHT;
      }
    }

    // Fall-back if spin cannot be determined
    if (pX && !sX) {
      sX = pX < 1 ? -1 : 1;
    }
    if (pY && !sY) {
      sY = pY < 1 ? -1 : 1;
    }
    return {
      spinX: sX,
      spinY: sY,
      pixelX: pX,
      pixelY: pY
    };
  }
  function handleMouseEnter() {
    if (!swiper.enabled) return;
    swiper.mouseEntered = true;
  }
  function handleMouseLeave() {
    if (!swiper.enabled) return;
    swiper.mouseEntered = false;
  }
  function animateSlider(newEvent) {
    if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) {
      // Prevent if delta of wheel scroll delta is below configured threshold
      return false;
    }
    if (swiper.params.mousewheel.thresholdTime && now() - lastScrollTime < swiper.params.mousewheel.thresholdTime) {
      // Prevent if time between scrolls is below configured threshold
      return false;
    }

    // If the movement is NOT big enough and
    // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
    //   Don't go any further (avoid insignificant scroll movement).
    if (newEvent.delta >= 6 && now() - lastScrollTime < 60) {
      // Return false as a default
      return true;
    }
    // If user is scrolling towards the end:
    //   If the slider hasn't hit the latest slide or
    //   if the slider is a loop and
    //   if the slider isn't moving right now:
    //     Go to next slide and
    //     emit a scroll event.
    // Else (the user is scrolling towards the beginning) and
    // if the slider hasn't hit the first slide or
    // if the slider is a loop and
    // if the slider isn't moving right now:
    //   Go to prev slide and
    //   emit a scroll event.
    if (newEvent.direction < 0) {
      if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
        swiper.slideNext();
        emit('scroll', newEvent.raw);
      }
    } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
      swiper.slidePrev();
      emit('scroll', newEvent.raw);
    }
    // If you got here is because an animation has been triggered so store the current time
    lastScrollTime = new window.Date().getTime();
    // Return false as a default
    return false;
  }
  function releaseScroll(newEvent) {
    const params = swiper.params.mousewheel;
    if (newEvent.direction < 0) {
      if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) {
        // Return true to animate scroll on edges
        return true;
      }
    } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) {
      // Return true to animate scroll on edges
      return true;
    }
    return false;
  }
  function handle(event) {
    let e = event;
    let disableParentSwiper = true;
    if (!swiper.enabled) return;

    // Ignore event if the target or its parents have the swiper-no-mousewheel class
    if (event.target.closest(`.${swiper.params.mousewheel.noMousewheelClass}`)) return;
    const params = swiper.params.mousewheel;
    if (swiper.params.cssMode) {
      e.preventDefault();
    }
    let targetEl = swiper.el;
    if (swiper.params.mousewheel.eventsTarget !== 'container') {
      targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
    }
    const targetElContainsTarget = targetEl && targetEl.contains(e.target);
    if (!swiper.mouseEntered && !targetElContainsTarget && !params.releaseOnEdges) return true;
    if (e.originalEvent) e = e.originalEvent; // jquery fix
    let delta = 0;
    const rtlFactor = swiper.rtlTranslate ? -1 : 1;
    const data = normalize(e);
    if (params.forceToAxis) {
      if (swiper.isHorizontal()) {
        if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;else return true;
      } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;else return true;
    } else {
      delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
    }
    if (delta === 0) return true;
    if (params.invert) delta = -delta;

    // Get the scroll positions
    let positions = swiper.getTranslate() + delta * params.sensitivity;
    if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
    if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate();

    // When loop is true:
    //     the disableParentSwiper will be true.
    // When loop is false:
    //     if the scroll positions is not on edge,
    //     then the disableParentSwiper will be true.
    //     if the scroll on edge positions,
    //     then the disableParentSwiper will be false.
    disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
    if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
    if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
      // Register the new event in a variable which stores the relevant data
      const newEvent = {
        time: now(),
        delta: Math.abs(delta),
        direction: Math.sign(delta),
        raw: event
      };

      // Keep the most recent events
      if (recentWheelEvents.length >= 2) {
        recentWheelEvents.shift(); // only store the last N events
      }

      const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
      recentWheelEvents.push(newEvent);

      // If there is at least one previous recorded event:
      //   If direction has changed or
      //   if the scroll is quicker than the previous one:
      //     Animate the slider.
      // Else (this is the first time the wheel is moved):
      //     Animate the slider.
      if (prevEvent) {
        if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) {
          animateSlider(newEvent);
        }
      } else {
        animateSlider(newEvent);
      }

      // If it's time to release the scroll:
      //   Return now so you don't hit the preventDefault.
      if (releaseScroll(newEvent)) {
        return true;
      }
    } else {
      // Freemode or scrollContainer:

      // If we recently snapped after a momentum scroll, then ignore wheel events
      // to give time for the deceleration to finish. Stop ignoring after 500 msecs
      // or if it's a new scroll (larger delta or inverse sign as last event before
      // an end-of-momentum snap).
      const newEvent = {
        time: now(),
        delta: Math.abs(delta),
        direction: Math.sign(delta)
      };
      const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
      if (!ignoreWheelEvents) {
        lastEventBeforeSnap = undefined;
        let position = swiper.getTranslate() + delta * params.sensitivity;
        const wasBeginning = swiper.isBeginning;
        const wasEnd = swiper.isEnd;
        if (position >= swiper.minTranslate()) position = swiper.minTranslate();
        if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
        swiper.setTransition(0);
        swiper.setTranslate(position);
        swiper.updateProgress();
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
        if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) {
          swiper.updateSlidesClasses();
        }
        if (swiper.params.loop) {
          swiper.loopFix({
            direction: newEvent.direction < 0 ? 'next' : 'prev',
            byMousewheel: true
          });
        }
        if (swiper.params.freeMode.sticky) {
          // When wheel scrolling starts with sticky (aka snap) enabled, then detect
          // the end of a momentum scroll by storing recent (N=15?) wheel events.
          // 1. do all N events have decreasing or same (absolute value) delta?
          // 2. did all N events arrive in the last M (M=500?) msecs?
          // 3. does the earliest event have an (absolute value) delta that's
          //    at least P (P=1?) larger than the most recent event's delta?
          // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
          // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
          // Snap immediately and ignore remaining wheel events in this scroll.
          // See comment above for "remaining wheel events in this scroll" determination.
          // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
          clearTimeout(timeout);
          timeout = undefined;
          if (recentWheelEvents.length >= 15) {
            recentWheelEvents.shift(); // only store the last N events
          }

          const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
          const firstEvent = recentWheelEvents[0];
          recentWheelEvents.push(newEvent);
          if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) {
            // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
            recentWheelEvents.splice(0);
          } else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
            // We're at the end of the deceleration of a momentum scroll, so there's no need
            // to wait for more events. Snap ASAP on the next tick.
            // Also, because there's some remaining momentum we'll bias the snap in the
            // direction of the ongoing scroll because it's better UX for the scroll to snap
            // in the same direction as the scroll instead of reversing to snap.  Therefore,
            // if it's already scrolled more than 20% in the current direction, keep going.
            const snapToThreshold = delta > 0 ? 0.8 : 0.2;
            lastEventBeforeSnap = newEvent;
            recentWheelEvents.splice(0);
            timeout = nextTick(() => {
              if (swiper.destroyed || !swiper.params) return;
              swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
            }, 0); // no delay; move on next tick
          }

          if (!timeout) {
            // if we get here, then we haven't detected the end of a momentum scroll, so
            // we'll consider a scroll "complete" when there haven't been any wheel events
            // for 500ms.
            timeout = nextTick(() => {
              if (swiper.destroyed || !swiper.params) return;
              const snapToThreshold = 0.5;
              lastEventBeforeSnap = newEvent;
              recentWheelEvents.splice(0);
              swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
            }, 500);
          }
        }

        // Emit event
        if (!ignoreWheelEvents) emit('scroll', e);

        // Stop autoplay
        if (swiper.params.autoplay && swiper.params.autoplay.disableOnInteraction) swiper.autoplay.stop();
        // Return page scroll on edge positions
        if (params.releaseOnEdges && (position === swiper.minTranslate() || position === swiper.maxTranslate())) {
          return true;
        }
      }
    }
    if (e.preventDefault) e.preventDefault();else e.returnValue = false;
    return false;
  }
  function events(method) {
    let targetEl = swiper.el;
    if (swiper.params.mousewheel.eventsTarget !== 'container') {
      targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
    }
    targetEl[method]('mouseenter', handleMouseEnter);
    targetEl[method]('mouseleave', handleMouseLeave);
    targetEl[method]('wheel', handle);
  }
  function enable() {
    if (swiper.params.cssMode) {
      swiper.wrapperEl.removeEventListener('wheel', handle);
      return true;
    }
    if (swiper.mousewheel.enabled) return false;
    events('addEventListener');
    swiper.mousewheel.enabled = true;
    return true;
  }
  function disable() {
    if (swiper.params.cssMode) {
      swiper.wrapperEl.addEventListener(event, handle);
      return true;
    }
    if (!swiper.mousewheel.enabled) return false;
    events('removeEventListener');
    swiper.mousewheel.enabled = false;
    return true;
  }
  on('init', () => {
    if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) {
      disable();
    }
    if (swiper.params.mousewheel.enabled) enable();
  });
  on('destroy', () => {
    if (swiper.params.cssMode) {
      enable();
    }
    if (swiper.mousewheel.enabled) disable();
  });
  Object.assign(swiper.mousewheel, {
    enable,
    disable
  });
}



;// CONCATENATED MODULE: ../node_modules/swiper/shared/create-element-if-not-defined.mjs


function create_element_if_not_defined_createElementIfNotDefined(swiper, originalParams, params, checkProps) {
  if (swiper.params.createElements) {
    Object.keys(checkProps).forEach(key => {
      if (!params[key] && params.auto === true) {
        let element = (0,utils.e)(swiper.el, `.${checkProps[key]}`)[0];
        if (!element) {
          element = (0,utils.c)('div', checkProps[key]);
          element.className = checkProps[key];
          swiper.el.append(element);
        }
        params[key] = element;
        originalParams[key] = element;
      }
    });
  }
  return params;
}



;// CONCATENATED MODULE: ../node_modules/swiper/modules/navigation.mjs



const arrowSvg = `<svg class="swiper-navigation-icon" width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor"/></svg>`;
function Navigation({
  swiper,
  extendParams,
  on,
  emit
}) {
  extendParams({
    navigation: {
      nextEl: null,
      prevEl: null,
      addIcons: true,
      hideOnClick: false,
      disabledClass: 'swiper-button-disabled',
      hiddenClass: 'swiper-button-hidden',
      lockClass: 'swiper-button-lock',
      navigationDisabledClass: 'swiper-navigation-disabled'
    }
  });
  swiper.navigation = {
    nextEl: null,
    prevEl: null,
    arrowSvg
  };
  function getEl(el) {
    let res;
    if (el && typeof el === 'string' && swiper.isElement) {
      res = swiper.el.querySelector(el) || swiper.hostEl.querySelector(el);
      if (res) return res;
    }
    if (el) {
      if (typeof el === 'string') res = [...document.querySelectorAll(el)];
      if (swiper.params.uniqueNavElements && typeof el === 'string' && res && res.length > 1 && swiper.el.querySelectorAll(el).length === 1) {
        res = swiper.el.querySelector(el);
      } else if (res && res.length === 1) {
        res = res[0];
      }
    }
    if (el && !res) return el;
    // if (Array.isArray(res) && res.length === 1) res = res[0];
    return res;
  }
  function toggleEl(el, disabled) {
    const params = swiper.params.navigation;
    el = (0,utils.m)(el);
    el.forEach(subEl => {
      if (subEl) {
        subEl.classList[disabled ? 'add' : 'remove'](...params.disabledClass.split(' '));
        if (subEl.tagName === 'BUTTON') subEl.disabled = disabled;
        if (swiper.params.watchOverflow && swiper.enabled) {
          subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
        }
      }
    });
  }
  function update() {
    // Update Navigation Buttons
    const {
      nextEl,
      prevEl
    } = swiper.navigation;
    if (swiper.params.loop) {
      toggleEl(prevEl, false);
      toggleEl(nextEl, false);
      return;
    }
    toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
    toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
  }
  function onPrevClick(e) {
    e.preventDefault();
    if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
    swiper.slidePrev();
    emit('navigationPrev');
  }
  function onNextClick(e) {
    e.preventDefault();
    if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
    swiper.slideNext();
    emit('navigationNext');
  }
  function init() {
    const params = swiper.params.navigation;
    swiper.params.navigation = create_element_if_not_defined_createElementIfNotDefined(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
      nextEl: 'swiper-button-next',
      prevEl: 'swiper-button-prev'
    });
    if (!(params.nextEl || params.prevEl)) return;
    let nextEl = getEl(params.nextEl);
    let prevEl = getEl(params.prevEl);
    Object.assign(swiper.navigation, {
      nextEl,
      prevEl
    });
    nextEl = (0,utils.m)(nextEl);
    prevEl = (0,utils.m)(prevEl);
    const initButton = (el, dir) => {
      if (el) {
        if (params.addIcons && el.matches('.swiper-button-next,.swiper-button-prev') && !el.querySelector('svg')) {
          const tempEl = document.createElement('div');
          (0,utils.s)(tempEl, arrowSvg);
          el.appendChild(tempEl.querySelector('svg'));
          tempEl.remove();
        }
        el.addEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
      }
      if (!swiper.enabled && el) {
        el.classList.add(...params.lockClass.split(' '));
      }
    };
    nextEl.forEach(el => initButton(el, 'next'));
    prevEl.forEach(el => initButton(el, 'prev'));
  }
  function destroy() {
    let {
      nextEl,
      prevEl
    } = swiper.navigation;
    nextEl = (0,utils.m)(nextEl);
    prevEl = (0,utils.m)(prevEl);
    const destroyButton = (el, dir) => {
      el.removeEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
      el.classList.remove(...swiper.params.navigation.disabledClass.split(' '));
    };
    nextEl.forEach(el => destroyButton(el, 'next'));
    prevEl.forEach(el => destroyButton(el, 'prev'));
  }
  on('init', () => {
    if (swiper.params.navigation.enabled === false) {
      // eslint-disable-next-line
      disable();
    } else {
      init();
      update();
    }
  });
  on('toEdge fromEdge lock unlock', () => {
    update();
  });
  on('destroy', () => {
    destroy();
  });
  on('enable disable', () => {
    let {
      nextEl,
      prevEl
    } = swiper.navigation;
    nextEl = (0,utils.m)(nextEl);
    prevEl = (0,utils.m)(prevEl);
    if (swiper.enabled) {
      update();
      return;
    }
    [...nextEl, ...prevEl].filter(el => !!el).forEach(el => el.classList.add(swiper.params.navigation.lockClass));
  });
  on('click', (_s, e) => {
    let {
      nextEl,
      prevEl
    } = swiper.navigation;
    nextEl = (0,utils.m)(nextEl);
    prevEl = (0,utils.m)(prevEl);
    const targetEl = e.target;
    let targetIsButton = prevEl.includes(targetEl) || nextEl.includes(targetEl);
    if (swiper.isElement && !targetIsButton) {
      const path = e.path || e.composedPath && e.composedPath();
      if (path) {
        targetIsButton = path.find(pathEl => nextEl.includes(pathEl) || prevEl.includes(pathEl));
      }
    }
    if (swiper.params.navigation.hideOnClick && !targetIsButton) {
      if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
      let isHidden;
      if (nextEl.length) {
        isHidden = nextEl[0].classList.contains(swiper.params.navigation.hiddenClass);
      } else if (prevEl.length) {
        isHidden = prevEl[0].classList.contains(swiper.params.navigation.hiddenClass);
      }
      if (isHidden === true) {
        emit('navigationShow');
      } else {
        emit('navigationHide');
      }
      [...nextEl, ...prevEl].filter(el => !!el).forEach(el => el.classList.toggle(swiper.params.navigation.hiddenClass));
    }
  });
  const enable = () => {
    swiper.el.classList.remove(...swiper.params.navigation.navigationDisabledClass.split(' '));
    init();
    update();
  };
  const disable = () => {
    swiper.el.classList.add(...swiper.params.navigation.navigationDisabledClass.split(' '));
    destroy();
  };
  Object.assign(swiper.navigation, {
    enable,
    disable,
    update,
    init,
    destroy
  });
}



;// CONCATENATED MODULE: ../node_modules/swiper/shared/classes-to-selector.mjs
function classes_to_selector_classesToSelector(classes = '') {
  // Escape all CSS selector special characters
  return `.${classes.trim().replace(/([\.:!+\/()[\]#>~*^$|=,'"@{}\\])/g, '\\$1') // eslint-disable-line
  .replace(/ /g, '.')}`;
}



;// CONCATENATED MODULE: ../node_modules/swiper/modules/pagination.mjs




function Pagination({
  swiper,
  extendParams,
  on,
  emit
}) {
  const pfx = 'swiper-pagination';
  extendParams({
    pagination: {
      el: null,
      bulletElement: 'span',
      clickable: false,
      hideOnClick: false,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: false,
      type: 'bullets',
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: false,
      dynamicMainBullets: 1,
      formatFractionCurrent: number => number,
      formatFractionTotal: number => number,
      bulletClass: `${pfx}-bullet`,
      bulletActiveClass: `${pfx}-bullet-active`,
      modifierClass: `${pfx}-`,
      currentClass: `${pfx}-current`,
      totalClass: `${pfx}-total`,
      hiddenClass: `${pfx}-hidden`,
      progressbarFillClass: `${pfx}-progressbar-fill`,
      progressbarOppositeClass: `${pfx}-progressbar-opposite`,
      clickableClass: `${pfx}-clickable`,
      lockClass: `${pfx}-lock`,
      horizontalClass: `${pfx}-horizontal`,
      verticalClass: `${pfx}-vertical`,
      paginationDisabledClass: `${pfx}-disabled`
    }
  });
  swiper.pagination = {
    el: null,
    bullets: []
  };
  let bulletSize;
  let dynamicBulletIndex = 0;
  function isPaginationDisabled() {
    return !swiper.params.pagination.el || !swiper.pagination.el || Array.isArray(swiper.pagination.el) && swiper.pagination.el.length === 0;
  }
  function setSideBullets(bulletEl, position) {
    const {
      bulletActiveClass
    } = swiper.params.pagination;
    if (!bulletEl) return;
    bulletEl = bulletEl[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
    if (bulletEl) {
      bulletEl.classList.add(`${bulletActiveClass}-${position}`);
      bulletEl = bulletEl[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
      if (bulletEl) {
        bulletEl.classList.add(`${bulletActiveClass}-${position}-${position}`);
      }
    }
  }
  function getMoveDirection(prevIndex, nextIndex, length) {
    prevIndex = prevIndex % length;
    nextIndex = nextIndex % length;
    if (nextIndex === prevIndex + 1) {
      return 'next';
    } else if (nextIndex === prevIndex - 1) {
      return 'previous';
    }
    return;
  }
  function onBulletClick(e) {
    const bulletEl = e.target.closest(classes_to_selector_classesToSelector(swiper.params.pagination.bulletClass));
    if (!bulletEl) {
      return;
    }
    e.preventDefault();
    const index = (0,utils.j)(bulletEl) * swiper.params.slidesPerGroup;
    if (swiper.params.loop) {
      if (swiper.realIndex === index) return;
      const moveDirection = getMoveDirection(swiper.realIndex, index, swiper.slides.length);
      if (moveDirection === 'next') {
        swiper.slideNext();
      } else if (moveDirection === 'previous') {
        swiper.slidePrev();
      } else {
        swiper.slideToLoop(index);
      }
    } else {
      swiper.slideTo(index);
    }
  }
  function update() {
    // Render || Update Pagination bullets/items
    const rtl = swiper.rtl;
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    let el = swiper.pagination.el;
    el = (0,utils.m)(el);
    // Current/Total
    let current;
    let previousIndex;
    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    const total = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
    if (swiper.params.loop) {
      previousIndex = swiper.previousRealIndex || 0;
      current = swiper.params.slidesPerGroup > 1 ? Math.floor(swiper.realIndex / swiper.params.slidesPerGroup) : swiper.realIndex;
    } else if (typeof swiper.snapIndex !== 'undefined') {
      current = swiper.snapIndex;
      previousIndex = swiper.previousSnapIndex;
    } else {
      previousIndex = swiper.previousIndex || 0;
      current = swiper.activeIndex || 0;
    }
    // Types
    if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
      const bullets = swiper.pagination.bullets;
      let firstIndex;
      let lastIndex;
      let midIndex;
      if (params.dynamicBullets) {
        bulletSize = (0,utils.i)(bullets[0], swiper.isHorizontal() ? 'width' : 'height', true);
        el.forEach(subEl => {
          subEl.style[swiper.isHorizontal() ? 'width' : 'height'] = `${bulletSize * (params.dynamicMainBullets + 4)}px`;
        });
        if (params.dynamicMainBullets > 1 && previousIndex !== undefined) {
          dynamicBulletIndex += current - (previousIndex || 0);
          if (dynamicBulletIndex > params.dynamicMainBullets - 1) {
            dynamicBulletIndex = params.dynamicMainBullets - 1;
          } else if (dynamicBulletIndex < 0) {
            dynamicBulletIndex = 0;
          }
        }
        firstIndex = Math.max(current - dynamicBulletIndex, 0);
        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
        midIndex = (lastIndex + firstIndex) / 2;
      }
      bullets.forEach(bulletEl => {
        const classesToRemove = [...['', '-next', '-next-next', '-prev', '-prev-prev', '-main'].map(suffix => `${params.bulletActiveClass}${suffix}`)].map(s => typeof s === 'string' && s.includes(' ') ? s.split(' ') : s).flat();
        bulletEl.classList.remove(...classesToRemove);
      });
      if (el.length > 1) {
        bullets.forEach(bullet => {
          const bulletIndex = (0,utils.j)(bullet);
          if (bulletIndex === current) {
            bullet.classList.add(...params.bulletActiveClass.split(' '));
          } else if (swiper.isElement) {
            bullet.setAttribute('part', 'bullet');
          }
          if (params.dynamicBullets) {
            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
              bullet.classList.add(...`${params.bulletActiveClass}-main`.split(' '));
            }
            if (bulletIndex === firstIndex) {
              setSideBullets(bullet, 'prev');
            }
            if (bulletIndex === lastIndex) {
              setSideBullets(bullet, 'next');
            }
          }
        });
      } else {
        const bullet = bullets[current];
        if (bullet) {
          bullet.classList.add(...params.bulletActiveClass.split(' '));
        }
        if (swiper.isElement) {
          bullets.forEach((bulletEl, bulletIndex) => {
            bulletEl.setAttribute('part', bulletIndex === current ? 'bullet-active' : 'bullet');
          });
        }
        if (params.dynamicBullets) {
          const firstDisplayedBullet = bullets[firstIndex];
          const lastDisplayedBullet = bullets[lastIndex];
          for (let i = firstIndex; i <= lastIndex; i += 1) {
            if (bullets[i]) {
              bullets[i].classList.add(...`${params.bulletActiveClass}-main`.split(' '));
            }
          }
          setSideBullets(firstDisplayedBullet, 'prev');
          setSideBullets(lastDisplayedBullet, 'next');
        }
      }
      if (params.dynamicBullets) {
        const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
        const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
        const offsetProp = rtl ? 'right' : 'left';
        bullets.forEach(bullet => {
          bullet.style[swiper.isHorizontal() ? offsetProp : 'top'] = `${bulletsOffset}px`;
        });
      }
    }
    el.forEach((subEl, subElIndex) => {
      if (params.type === 'fraction') {
        subEl.querySelectorAll(classes_to_selector_classesToSelector(params.currentClass)).forEach(fractionEl => {
          fractionEl.textContent = params.formatFractionCurrent(current + 1);
        });
        subEl.querySelectorAll(classes_to_selector_classesToSelector(params.totalClass)).forEach(totalEl => {
          totalEl.textContent = params.formatFractionTotal(total);
        });
      }
      if (params.type === 'progressbar') {
        let progressbarDirection;
        if (params.progressbarOpposite) {
          progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
        } else {
          progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
        }
        const scale = (current + 1) / total;
        let scaleX = 1;
        let scaleY = 1;
        if (progressbarDirection === 'horizontal') {
          scaleX = scale;
        } else {
          scaleY = scale;
        }
        subEl.querySelectorAll(classes_to_selector_classesToSelector(params.progressbarFillClass)).forEach(progressEl => {
          progressEl.style.transform = `translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`;
          progressEl.style.transitionDuration = `${swiper.params.speed}ms`;
        });
      }
      if (params.type === 'custom' && params.renderCustom) {
        (0,utils.s)(subEl, params.renderCustom(swiper, current + 1, total));
        if (subElIndex === 0) emit('paginationRender', subEl);
      } else {
        if (subElIndex === 0) emit('paginationRender', subEl);
        emit('paginationUpdate', subEl);
      }
      if (swiper.params.watchOverflow && swiper.enabled) {
        subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
      }
    });
  }
  function render() {
    // Render Container
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.grid && swiper.params.grid.rows > 1 ? swiper.slides.length / Math.ceil(swiper.params.grid.rows) : swiper.slides.length;
    let el = swiper.pagination.el;
    el = (0,utils.m)(el);
    let paginationHTML = '';
    if (params.type === 'bullets') {
      let numberOfBullets = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
      if (swiper.params.freeMode && swiper.params.freeMode.enabled && numberOfBullets > slidesLength) {
        numberOfBullets = slidesLength;
      }
      for (let i = 0; i < numberOfBullets; i += 1) {
        if (params.renderBullet) {
          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
        } else {
          // prettier-ignore
          paginationHTML += `<${params.bulletElement} ${swiper.isElement ? 'part="bullet"' : ''} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
      }
    }
    if (params.type === 'fraction') {
      if (params.renderFraction) {
        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
      } else {
        paginationHTML = `<span class="${params.currentClass}"></span>` + ' / ' + `<span class="${params.totalClass}"></span>`;
      }
    }
    if (params.type === 'progressbar') {
      if (params.renderProgressbar) {
        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
      } else {
        paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
      }
    }
    swiper.pagination.bullets = [];
    el.forEach(subEl => {
      if (params.type !== 'custom') {
        (0,utils.s)(subEl, paginationHTML || '');
      }
      if (params.type === 'bullets') {
        swiper.pagination.bullets.push(...subEl.querySelectorAll(classes_to_selector_classesToSelector(params.bulletClass)));
      }
    });
    if (params.type !== 'custom') {
      emit('paginationRender', el[0]);
    }
  }
  function init() {
    swiper.params.pagination = create_element_if_not_defined_createElementIfNotDefined(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
      el: 'swiper-pagination'
    });
    const params = swiper.params.pagination;
    if (!params.el) return;
    let el;
    if (typeof params.el === 'string' && swiper.isElement) {
      el = swiper.el.querySelector(params.el);
    }
    if (!el && typeof params.el === 'string') {
      el = [...document.querySelectorAll(params.el)];
    }
    if (!el) {
      el = params.el;
    }
    if (!el || el.length === 0) return;
    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && Array.isArray(el) && el.length > 1) {
      el = [...swiper.el.querySelectorAll(params.el)];
      // check if it belongs to another nested Swiper
      if (el.length > 1) {
        el = el.find(subEl => {
          if ((0,utils.d)(subEl, '.swiper')[0] !== swiper.el) return false;
          return true;
        });
      }
    }
    if (Array.isArray(el) && el.length === 1) el = el[0];
    Object.assign(swiper.pagination, {
      el
    });
    el = (0,utils.m)(el);
    el.forEach(subEl => {
      if (params.type === 'bullets' && params.clickable) {
        subEl.classList.add(...(params.clickableClass || '').split(' '));
      }
      subEl.classList.add(params.modifierClass + params.type);
      subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
      if (params.type === 'bullets' && params.dynamicBullets) {
        subEl.classList.add(`${params.modifierClass}${params.type}-dynamic`);
        dynamicBulletIndex = 0;
        if (params.dynamicMainBullets < 1) {
          params.dynamicMainBullets = 1;
        }
      }
      if (params.type === 'progressbar' && params.progressbarOpposite) {
        subEl.classList.add(params.progressbarOppositeClass);
      }
      if (params.clickable) {
        subEl.addEventListener('click', onBulletClick);
      }
      if (!swiper.enabled) {
        subEl.classList.add(params.lockClass);
      }
    });
  }
  function destroy() {
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    let el = swiper.pagination.el;
    if (el) {
      el = (0,utils.m)(el);
      el.forEach(subEl => {
        subEl.classList.remove(params.hiddenClass);
        subEl.classList.remove(params.modifierClass + params.type);
        subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        if (params.clickable) {
          subEl.classList.remove(...(params.clickableClass || '').split(' '));
          subEl.removeEventListener('click', onBulletClick);
        }
      });
    }
    if (swiper.pagination.bullets) swiper.pagination.bullets.forEach(subEl => subEl.classList.remove(...params.bulletActiveClass.split(' ')));
  }
  on('changeDirection', () => {
    if (!swiper.pagination || !swiper.pagination.el) return;
    const params = swiper.params.pagination;
    let {
      el
    } = swiper.pagination;
    el = (0,utils.m)(el);
    el.forEach(subEl => {
      subEl.classList.remove(params.horizontalClass, params.verticalClass);
      subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    });
  });
  on('init', () => {
    if (swiper.params.pagination.enabled === false) {
      // eslint-disable-next-line
      disable();
    } else {
      init();
      render();
      update();
    }
  });
  on('activeIndexChange', () => {
    if (typeof swiper.snapIndex === 'undefined') {
      update();
    }
  });
  on('snapIndexChange', () => {
    update();
  });
  on('snapGridLengthChange', () => {
    render();
    update();
  });
  on('destroy', () => {
    destroy();
  });
  on('enable disable', () => {
    let {
      el
    } = swiper.pagination;
    if (el) {
      el = (0,utils.m)(el);
      el.forEach(subEl => subEl.classList[swiper.enabled ? 'remove' : 'add'](swiper.params.pagination.lockClass));
    }
  });
  on('lock unlock', () => {
    update();
  });
  on('click', (_s, e) => {
    const targetEl = e.target;
    const el = (0,utils.m)(swiper.pagination.el);
    if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && el && el.length > 0 && !targetEl.classList.contains(swiper.params.pagination.bulletClass)) {
      if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
      const isHidden = el[0].classList.contains(swiper.params.pagination.hiddenClass);
      if (isHidden === true) {
        emit('paginationShow');
      } else {
        emit('paginationHide');
      }
      el.forEach(subEl => subEl.classList.toggle(swiper.params.pagination.hiddenClass));
    }
  });
  const enable = () => {
    swiper.el.classList.remove(swiper.params.pagination.paginationDisabledClass);
    let {
      el
    } = swiper.pagination;
    if (el) {
      el = (0,utils.m)(el);
      el.forEach(subEl => subEl.classList.remove(swiper.params.pagination.paginationDisabledClass));
    }
    init();
    render();
    update();
  };
  const disable = () => {
    swiper.el.classList.add(swiper.params.pagination.paginationDisabledClass);
    let {
      el
    } = swiper.pagination;
    if (el) {
      el = (0,utils.m)(el);
      el.forEach(subEl => subEl.classList.add(swiper.params.pagination.paginationDisabledClass));
    }
    destroy();
  };
  Object.assign(swiper.pagination, {
    enable,
    disable,
    render,
    update,
    init,
    destroy
  });
}



;// CONCATENATED MODULE: ../node_modules/swiper/modules/scrollbar.mjs





function Scrollbar({
  swiper,
  extendParams,
  on,
  emit
}) {
  const document = getDocument();
  let isTouched = false;
  let timeout = null;
  let dragTimeout = null;
  let dragStartPos;
  let dragSize;
  let trackSize;
  let divider;
  extendParams({
    scrollbar: {
      el: null,
      dragSize: 'auto',
      hide: false,
      draggable: false,
      snapOnRelease: true,
      lockClass: 'swiper-scrollbar-lock',
      dragClass: 'swiper-scrollbar-drag',
      scrollbarDisabledClass: 'swiper-scrollbar-disabled',
      horizontalClass: `swiper-scrollbar-horizontal`,
      verticalClass: `swiper-scrollbar-vertical`
    }
  });
  swiper.scrollbar = {
    el: null,
    dragEl: null
  };
  function setTranslate() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    const {
      scrollbar,
      rtlTranslate: rtl
    } = swiper;
    const {
      dragEl,
      el
    } = scrollbar;
    const params = swiper.params.scrollbar;
    const progress = swiper.params.loop ? swiper.progressLoop : swiper.progress;
    let newSize = dragSize;
    let newPos = (trackSize - dragSize) * progress;
    if (rtl) {
      newPos = -newPos;
      if (newPos > 0) {
        newSize = dragSize - newPos;
        newPos = 0;
      } else if (-newPos + dragSize > trackSize) {
        newSize = trackSize + newPos;
      }
    } else if (newPos < 0) {
      newSize = dragSize + newPos;
      newPos = 0;
    } else if (newPos + dragSize > trackSize) {
      newSize = trackSize - newPos;
    }
    if (swiper.isHorizontal()) {
      dragEl.style.transform = `translate3d(${newPos}px, 0, 0)`;
      dragEl.style.width = `${newSize}px`;
    } else {
      dragEl.style.transform = `translate3d(0px, ${newPos}px, 0)`;
      dragEl.style.height = `${newSize}px`;
    }
    if (params.hide) {
      clearTimeout(timeout);
      el.style.opacity = 1;
      timeout = setTimeout(() => {
        el.style.opacity = 0;
        el.style.transitionDuration = '400ms';
      }, 1000);
    }
  }
  function setTransition(duration) {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    swiper.scrollbar.dragEl.style.transitionDuration = `${duration}ms`;
  }
  function updateSize() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    const {
      scrollbar
    } = swiper;
    const {
      dragEl,
      el
    } = scrollbar;
    dragEl.style.width = '';
    dragEl.style.height = '';
    trackSize = swiper.isHorizontal() ? el.offsetWidth : el.offsetHeight;
    divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
    if (swiper.params.scrollbar.dragSize === 'auto') {
      dragSize = trackSize * divider;
    } else {
      dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
    }
    if (swiper.isHorizontal()) {
      dragEl.style.width = `${dragSize}px`;
    } else {
      dragEl.style.height = `${dragSize}px`;
    }
    if (divider >= 1) {
      el.style.display = 'none';
    } else {
      el.style.display = '';
    }
    if (swiper.params.scrollbar.hide) {
      el.style.opacity = 0;
    }
    if (swiper.params.watchOverflow && swiper.enabled) {
      scrollbar.el.classList[swiper.isLocked ? 'add' : 'remove'](swiper.params.scrollbar.lockClass);
    }
  }
  function getPointerPosition(e) {
    return swiper.isHorizontal() ? e.clientX : e.clientY;
  }
  function setDragPosition(e) {
    const {
      scrollbar,
      rtlTranslate: rtl
    } = swiper;
    const {
      el
    } = scrollbar;
    let positionRatio;
    positionRatio = (getPointerPosition(e) - elementOffset(el)[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
    positionRatio = Math.max(Math.min(positionRatio, 1), 0);
    if (rtl) {
      positionRatio = 1 - positionRatio;
    }
    const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
    swiper.updateProgress(position);
    swiper.setTranslate(position);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }
  function onDragStart(e) {
    const params = swiper.params.scrollbar;
    const {
      scrollbar,
      wrapperEl
    } = swiper;
    const {
      el,
      dragEl
    } = scrollbar;
    isTouched = true;
    dragStartPos = e.target === dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
    e.preventDefault();
    e.stopPropagation();
    wrapperEl.style.transitionDuration = '100ms';
    dragEl.style.transitionDuration = '100ms';
    setDragPosition(e);
    clearTimeout(dragTimeout);
    el.style.transitionDuration = '0ms';
    if (params.hide) {
      el.style.opacity = 1;
    }
    if (swiper.params.cssMode) {
      swiper.wrapperEl.style['scroll-snap-type'] = 'none';
    }
    emit('scrollbarDragStart', e);
  }
  function onDragMove(e) {
    const {
      scrollbar,
      wrapperEl
    } = swiper;
    const {
      el,
      dragEl
    } = scrollbar;
    if (!isTouched) return;
    if (e.preventDefault && e.cancelable) e.preventDefault();else e.returnValue = false;
    setDragPosition(e);
    wrapperEl.style.transitionDuration = '0ms';
    el.style.transitionDuration = '0ms';
    dragEl.style.transitionDuration = '0ms';
    emit('scrollbarDragMove', e);
  }
  function onDragEnd(e) {
    const params = swiper.params.scrollbar;
    const {
      scrollbar,
      wrapperEl
    } = swiper;
    const {
      el
    } = scrollbar;
    if (!isTouched) return;
    isTouched = false;
    if (swiper.params.cssMode) {
      swiper.wrapperEl.style['scroll-snap-type'] = '';
      wrapperEl.style.transitionDuration = '';
    }
    if (params.hide) {
      clearTimeout(dragTimeout);
      dragTimeout = nextTick(() => {
        el.style.opacity = 0;
        el.style.transitionDuration = '400ms';
      }, 1000);
    }
    emit('scrollbarDragEnd', e);
    if (params.snapOnRelease) {
      swiper.slideToClosest();
    }
  }
  function events(method) {
    const {
      scrollbar,
      params
    } = swiper;
    const el = scrollbar.el;
    if (!el) return;
    const target = el;
    const activeListener = params.passiveListeners ? {
      passive: false,
      capture: false
    } : false;
    const passiveListener = params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    if (!target) return;
    const eventMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
    target[eventMethod]('pointerdown', onDragStart, activeListener);
    document[eventMethod]('pointermove', onDragMove, activeListener);
    document[eventMethod]('pointerup', onDragEnd, passiveListener);
  }
  function enableDraggable() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    events('on');
  }
  function disableDraggable() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    events('off');
  }
  function init() {
    const {
      scrollbar,
      el: swiperEl
    } = swiper;
    swiper.params.scrollbar = createElementIfNotDefined(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
      el: 'swiper-scrollbar'
    });
    const params = swiper.params.scrollbar;
    if (!params.el) return;
    let el;
    if (typeof params.el === 'string' && swiper.isElement) {
      el = swiper.el.querySelector(params.el);
    }
    if (!el && typeof params.el === 'string') {
      el = document.querySelectorAll(params.el);
      if (!el.length) return;
    } else if (!el) {
      el = params.el;
    }
    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && el.length > 1 && swiperEl.querySelectorAll(params.el).length === 1) {
      el = swiperEl.querySelector(params.el);
    }
    if (el.length > 0) el = el[0];
    el.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    let dragEl;
    if (el) {
      dragEl = el.querySelector(classesToSelector(swiper.params.scrollbar.dragClass));
      if (!dragEl) {
        dragEl = createElement('div', swiper.params.scrollbar.dragClass);
        el.append(dragEl);
      }
    }
    Object.assign(scrollbar, {
      el,
      dragEl
    });
    if (params.draggable) {
      enableDraggable();
    }
    if (el) {
      el.classList[swiper.enabled ? 'remove' : 'add'](...classesToTokens(swiper.params.scrollbar.lockClass));
    }
  }
  function destroy() {
    const params = swiper.params.scrollbar;
    const el = swiper.scrollbar.el;
    if (el) {
      el.classList.remove(...classesToTokens(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass));
    }
    disableDraggable();
  }
  on('changeDirection', () => {
    if (!swiper.scrollbar || !swiper.scrollbar.el) return;
    const params = swiper.params.scrollbar;
    let {
      el
    } = swiper.scrollbar;
    el = makeElementsArray(el);
    el.forEach(subEl => {
      subEl.classList.remove(params.horizontalClass, params.verticalClass);
      subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    });
  });
  on('init', () => {
    if (swiper.params.scrollbar.enabled === false) {
      // eslint-disable-next-line
      disable();
    } else {
      init();
      updateSize();
      setTranslate();
    }
  });
  on('update resize observerUpdate lock unlock changeDirection', () => {
    updateSize();
  });
  on('setTranslate', () => {
    setTranslate();
  });
  on('setTransition', (_s, duration) => {
    setTransition(duration);
  });
  on('enable disable', () => {
    const {
      el
    } = swiper.scrollbar;
    if (el) {
      el.classList[swiper.enabled ? 'remove' : 'add'](...classesToTokens(swiper.params.scrollbar.lockClass));
    }
  });
  on('destroy', () => {
    destroy();
  });
  const enable = () => {
    swiper.el.classList.remove(...classesToTokens(swiper.params.scrollbar.scrollbarDisabledClass));
    if (swiper.scrollbar.el) {
      swiper.scrollbar.el.classList.remove(...classesToTokens(swiper.params.scrollbar.scrollbarDisabledClass));
    }
    init();
    updateSize();
    setTranslate();
  };
  const disable = () => {
    swiper.el.classList.add(...classesToTokens(swiper.params.scrollbar.scrollbarDisabledClass));
    if (swiper.scrollbar.el) {
      swiper.scrollbar.el.classList.add(...classesToTokens(swiper.params.scrollbar.scrollbarDisabledClass));
    }
    destroy();
  };
  Object.assign(swiper.scrollbar, {
    enable,
    disable,
    updateSize,
    setTranslate,
    init,
    destroy
  });
}



;// CONCATENATED MODULE: ../node_modules/swiper/modules/parallax.mjs


function Parallax({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    parallax: {
      enabled: false
    }
  });
  const elementsSelector = '[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]';
  const setTransform = (el, progress) => {
    const {
      rtl
    } = swiper;
    const rtlFactor = rtl ? -1 : 1;
    const p = el.getAttribute('data-swiper-parallax') || '0';
    let x = el.getAttribute('data-swiper-parallax-x');
    let y = el.getAttribute('data-swiper-parallax-y');
    const scale = el.getAttribute('data-swiper-parallax-scale');
    const opacity = el.getAttribute('data-swiper-parallax-opacity');
    const rotate = el.getAttribute('data-swiper-parallax-rotate');
    if (x || y) {
      x = x || '0';
      y = y || '0';
    } else if (swiper.isHorizontal()) {
      x = p;
      y = '0';
    } else {
      y = p;
      x = '0';
    }
    if (x.indexOf('%') >= 0) {
      x = `${parseInt(x, 10) * progress * rtlFactor}%`;
    } else {
      x = `${x * progress * rtlFactor}px`;
    }
    if (y.indexOf('%') >= 0) {
      y = `${parseInt(y, 10) * progress}%`;
    } else {
      y = `${y * progress}px`;
    }
    if (typeof opacity !== 'undefined' && opacity !== null) {
      const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
      el.style.opacity = currentOpacity;
    }
    let transform = `translate3d(${x}, ${y}, 0px)`;
    if (typeof scale !== 'undefined' && scale !== null) {
      const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
      transform += ` scale(${currentScale})`;
    }
    if (rotate && typeof rotate !== 'undefined' && rotate !== null) {
      const currentRotate = rotate * progress * -1;
      transform += ` rotate(${currentRotate}deg)`;
    }
    el.style.transform = transform;
  };
  const setTranslate = () => {
    const {
      el,
      slides,
      progress,
      snapGrid,
      isElement
    } = swiper;
    const elements = elementChildren(el, elementsSelector);
    if (swiper.isElement) {
      elements.push(...elementChildren(swiper.hostEl, elementsSelector));
    }
    elements.forEach(subEl => {
      setTransform(subEl, progress);
    });
    slides.forEach((slideEl, slideIndex) => {
      let slideProgress = slideEl.progress;
      if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
        slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
      }
      slideProgress = Math.min(Math.max(slideProgress, -1), 1);
      slideEl.querySelectorAll(`${elementsSelector}, [data-swiper-parallax-rotate]`).forEach(subEl => {
        setTransform(subEl, slideProgress);
      });
    });
  };
  const setTransition = (duration = swiper.params.speed) => {
    const {
      el,
      hostEl
    } = swiper;
    const elements = [...el.querySelectorAll(elementsSelector)];
    if (swiper.isElement) {
      elements.push(...hostEl.querySelectorAll(elementsSelector));
    }
    elements.forEach(parallaxEl => {
      let parallaxDuration = parseInt(parallaxEl.getAttribute('data-swiper-parallax-duration'), 10) || duration;
      if (duration === 0) parallaxDuration = 0;
      parallaxEl.style.transitionDuration = `${parallaxDuration}ms`;
    });
  };
  on('beforeInit', () => {
    if (!swiper.params.parallax.enabled) return;
    swiper.params.watchSlidesProgress = true;
    swiper.originalParams.watchSlidesProgress = true;
  });
  on('init', () => {
    if (!swiper.params.parallax.enabled) return;
    setTranslate();
  });
  on('setTranslate', () => {
    if (!swiper.params.parallax.enabled) return;
    setTranslate();
  });
  on('setTransition', (_swiper, duration) => {
    if (!swiper.params.parallax.enabled) return;
    setTransition(duration);
  });
}



;// CONCATENATED MODULE: ../node_modules/swiper/modules/zoom.mjs



function Zoom({
  swiper,
  extendParams,
  on,
  emit
}) {
  const window = getWindow();
  extendParams({
    zoom: {
      enabled: false,
      limitToOriginalSize: false,
      maxRatio: 3,
      minRatio: 1,
      panOnMouseMove: false,
      toggle: true,
      containerClass: 'swiper-zoom-container',
      zoomedSlideClass: 'swiper-slide-zoomed'
    }
  });
  swiper.zoom = {
    enabled: false
  };
  let currentScale = 1;
  let isScaling = false;
  let isPanningWithMouse = false;
  let mousePanStart = {
    x: 0,
    y: 0
  };
  const mousePanSensitivity = -3; // Negative to invert pan direction
  let fakeGestureTouched;
  let fakeGestureMoved;
  const evCache = [];
  const gesture = {
    originX: 0,
    originY: 0,
    slideEl: undefined,
    slideWidth: undefined,
    slideHeight: undefined,
    imageEl: undefined,
    imageWrapEl: undefined,
    maxRatio: 3
  };
  const image = {
    isTouched: undefined,
    isMoved: undefined,
    currentX: undefined,
    currentY: undefined,
    minX: undefined,
    minY: undefined,
    maxX: undefined,
    maxY: undefined,
    width: undefined,
    height: undefined,
    startX: undefined,
    startY: undefined,
    touchesStart: {},
    touchesCurrent: {}
  };
  const velocity = {
    x: undefined,
    y: undefined,
    prevPositionX: undefined,
    prevPositionY: undefined,
    prevTime: undefined
  };
  let scale = 1;
  Object.defineProperty(swiper.zoom, 'scale', {
    get() {
      return scale;
    },
    set(value) {
      if (scale !== value) {
        const imageEl = gesture.imageEl;
        const slideEl = gesture.slideEl;
        emit('zoomChange', value, imageEl, slideEl);
      }
      scale = value;
    }
  });
  function getDistanceBetweenTouches() {
    if (evCache.length < 2) return 1;
    const x1 = evCache[0].pageX;
    const y1 = evCache[0].pageY;
    const x2 = evCache[1].pageX;
    const y2 = evCache[1].pageY;
    const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
    return distance;
  }
  function getMaxRatio() {
    const params = swiper.params.zoom;
    const maxRatio = gesture.imageWrapEl.getAttribute('data-swiper-zoom') || params.maxRatio;
    if (params.limitToOriginalSize && gesture.imageEl && gesture.imageEl.naturalWidth) {
      const imageMaxRatio = gesture.imageEl.naturalWidth / gesture.imageEl.offsetWidth;
      return Math.min(imageMaxRatio, maxRatio);
    }
    return maxRatio;
  }
  function getScaleOrigin() {
    if (evCache.length < 2) return {
      x: null,
      y: null
    };
    const box = gesture.imageEl.getBoundingClientRect();
    return [(evCache[0].pageX + (evCache[1].pageX - evCache[0].pageX) / 2 - box.x - window.scrollX) / currentScale, (evCache[0].pageY + (evCache[1].pageY - evCache[0].pageY) / 2 - box.y - window.scrollY) / currentScale];
  }
  function getSlideSelector() {
    return swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
  }
  function eventWithinSlide(e) {
    const slideSelector = getSlideSelector();
    if (e.target.matches(slideSelector)) return true;
    if (swiper.slides.filter(slideEl => slideEl.contains(e.target)).length > 0) return true;
    return false;
  }
  function eventWithinZoomContainer(e) {
    const selector = `.${swiper.params.zoom.containerClass}`;
    if (e.target.matches(selector)) return true;
    if ([...swiper.hostEl.querySelectorAll(selector)].filter(containerEl => containerEl.contains(e.target)).length > 0) return true;
    return false;
  }

  // Events
  function onGestureStart(e) {
    if (e.pointerType === 'mouse') {
      evCache.splice(0, evCache.length);
    }
    if (!eventWithinSlide(e)) return;
    const params = swiper.params.zoom;
    fakeGestureTouched = false;
    fakeGestureMoved = false;
    evCache.push(e);
    if (evCache.length < 2) {
      return;
    }
    fakeGestureTouched = true;
    gesture.scaleStart = getDistanceBetweenTouches();
    if (!gesture.slideEl) {
      gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
      if (!gesture.slideEl) gesture.slideEl = swiper.slides[swiper.activeIndex];
      let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
      if (imageEl) {
        imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
      }
      gesture.imageEl = imageEl;
      if (imageEl) {
        gesture.imageWrapEl = elementParents(gesture.imageEl, `.${params.containerClass}`)[0];
      } else {
        gesture.imageWrapEl = undefined;
      }
      if (!gesture.imageWrapEl) {
        gesture.imageEl = undefined;
        return;
      }
      gesture.maxRatio = getMaxRatio();
    }
    if (gesture.imageEl) {
      const [originX, originY] = getScaleOrigin();
      gesture.originX = originX;
      gesture.originY = originY;
      gesture.imageEl.style.transitionDuration = '0ms';
    }
    isScaling = true;
  }
  function onGestureChange(e) {
    if (!eventWithinSlide(e)) return;
    const params = swiper.params.zoom;
    const zoom = swiper.zoom;
    const pointerIndex = evCache.findIndex(cachedEv => cachedEv.pointerId === e.pointerId);
    if (pointerIndex >= 0) evCache[pointerIndex] = e;
    if (evCache.length < 2) {
      return;
    }
    fakeGestureMoved = true;
    gesture.scaleMove = getDistanceBetweenTouches();
    if (!gesture.imageEl) {
      return;
    }
    zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
    if (zoom.scale > gesture.maxRatio) {
      zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
    }
    if (zoom.scale < params.minRatio) {
      zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
    }
    gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
  }
  function onGestureEnd(e) {
    if (!eventWithinSlide(e)) return;
    if (e.pointerType === 'mouse' && e.type === 'pointerout') return;
    const params = swiper.params.zoom;
    const zoom = swiper.zoom;
    const pointerIndex = evCache.findIndex(cachedEv => cachedEv.pointerId === e.pointerId);
    if (pointerIndex >= 0) evCache.splice(pointerIndex, 1);
    if (!fakeGestureTouched || !fakeGestureMoved) {
      return;
    }
    fakeGestureTouched = false;
    fakeGestureMoved = false;
    if (!gesture.imageEl) return;
    zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
    gesture.imageEl.style.transitionDuration = `${swiper.params.speed}ms`;
    gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    currentScale = zoom.scale;
    isScaling = false;
    if (zoom.scale > 1 && gesture.slideEl) {
      gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
    } else if (zoom.scale <= 1 && gesture.slideEl) {
      gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
    }
    if (zoom.scale === 1) {
      gesture.originX = 0;
      gesture.originY = 0;
      gesture.slideEl = undefined;
    }
  }
  let allowTouchMoveTimeout;
  function allowTouchMove() {
    swiper.touchEventsData.preventTouchMoveFromPointerMove = false;
  }
  function preventTouchMove() {
    clearTimeout(allowTouchMoveTimeout);
    swiper.touchEventsData.preventTouchMoveFromPointerMove = true;
    allowTouchMoveTimeout = setTimeout(() => {
      if (swiper.destroyed) return;
      allowTouchMove();
    });
  }
  function onTouchStart(e) {
    const device = swiper.device;
    if (!gesture.imageEl) return;
    if (image.isTouched) return;
    if (device.android && e.cancelable) e.preventDefault();
    image.isTouched = true;
    const event = evCache.length > 0 ? evCache[0] : e;
    image.touchesStart.x = event.pageX;
    image.touchesStart.y = event.pageY;
  }
  function onTouchMove(e) {
    const isMouseEvent = e.pointerType === 'mouse';
    const isMousePan = isMouseEvent && swiper.params.zoom.panOnMouseMove;
    if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) {
      return;
    }
    const zoom = swiper.zoom;
    if (!gesture.imageEl) {
      return;
    }
    if (!image.isTouched || !gesture.slideEl) {
      if (isMousePan) onMouseMove(e);
      return;
    }
    if (isMousePan) {
      onMouseMove(e);
      return;
    }
    if (!image.isMoved) {
      image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
      image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
      image.startX = getTranslate(gesture.imageWrapEl, 'x') || 0;
      image.startY = getTranslate(gesture.imageWrapEl, 'y') || 0;
      gesture.slideWidth = gesture.slideEl.offsetWidth;
      gesture.slideHeight = gesture.slideEl.offsetHeight;
      gesture.imageWrapEl.style.transitionDuration = '0ms';
    }
    // Define if we need image drag
    const scaledWidth = image.width * zoom.scale;
    const scaledHeight = image.height * zoom.scale;
    image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
    image.maxX = -image.minX;
    image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
    image.maxY = -image.minY;
    image.touchesCurrent.x = evCache.length > 0 ? evCache[0].pageX : e.pageX;
    image.touchesCurrent.y = evCache.length > 0 ? evCache[0].pageY : e.pageY;
    const touchesDiff = Math.max(Math.abs(image.touchesCurrent.x - image.touchesStart.x), Math.abs(image.touchesCurrent.y - image.touchesStart.y));
    if (touchesDiff > 5) {
      swiper.allowClick = false;
    }
    if (!image.isMoved && !isScaling) {
      if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
        image.isTouched = false;
        allowTouchMove();
        return;
      }
      if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
        image.isTouched = false;
        allowTouchMove();
        return;
      }
    }
    if (e.cancelable) {
      e.preventDefault();
    }
    e.stopPropagation();
    preventTouchMove();
    image.isMoved = true;
    const scaleRatio = (zoom.scale - currentScale) / (gesture.maxRatio - swiper.params.zoom.minRatio);
    const {
      originX,
      originY
    } = gesture;
    image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX + scaleRatio * (image.width - originX * 2);
    image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY + scaleRatio * (image.height - originY * 2);
    if (image.currentX < image.minX) {
      image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
    }
    if (image.currentX > image.maxX) {
      image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
    }
    if (image.currentY < image.minY) {
      image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
    }
    if (image.currentY > image.maxY) {
      image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
    }

    // Velocity
    if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
    if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
    if (!velocity.prevTime) velocity.prevTime = Date.now();
    velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
    velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
    if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
    if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
    velocity.prevPositionX = image.touchesCurrent.x;
    velocity.prevPositionY = image.touchesCurrent.y;
    velocity.prevTime = Date.now();
    gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
  }
  function onTouchEnd() {
    const zoom = swiper.zoom;
    evCache.length = 0;
    if (!gesture.imageEl) return;
    if (!image.isTouched || !image.isMoved) {
      image.isTouched = false;
      image.isMoved = false;
      return;
    }
    image.isTouched = false;
    image.isMoved = false;
    let momentumDurationX = 300;
    let momentumDurationY = 300;
    const momentumDistanceX = velocity.x * momentumDurationX;
    const newPositionX = image.currentX + momentumDistanceX;
    const momentumDistanceY = velocity.y * momentumDurationY;
    const newPositionY = image.currentY + momentumDistanceY;

    // Fix duration
    if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
    if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
    const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
    image.currentX = newPositionX;
    image.currentY = newPositionY;
    // Define if we need image drag
    const scaledWidth = image.width * zoom.scale;
    const scaledHeight = image.height * zoom.scale;
    image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
    image.maxX = -image.minX;
    image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
    image.maxY = -image.minY;
    image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
    image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
    gesture.imageWrapEl.style.transitionDuration = `${momentumDuration}ms`;
    gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
  }
  function onTransitionEnd() {
    const zoom = swiper.zoom;
    if (gesture.slideEl && swiper.activeIndex !== swiper.slides.indexOf(gesture.slideEl)) {
      if (gesture.imageEl) {
        gesture.imageEl.style.transform = 'translate3d(0,0,0) scale(1)';
      }
      if (gesture.imageWrapEl) {
        gesture.imageWrapEl.style.transform = 'translate3d(0,0,0)';
      }
      gesture.slideEl.classList.remove(`${swiper.params.zoom.zoomedSlideClass}`);
      zoom.scale = 1;
      currentScale = 1;
      gesture.slideEl = undefined;
      gesture.imageEl = undefined;
      gesture.imageWrapEl = undefined;
      gesture.originX = 0;
      gesture.originY = 0;
    }
  }
  function onMouseMove(e) {
    // Only pan if zoomed in and mouse panning is enabled
    if (currentScale <= 1 || !gesture.imageWrapEl) return;
    if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
    const currentTransform = window.getComputedStyle(gesture.imageWrapEl).transform;
    const matrix = new window.DOMMatrix(currentTransform);
    if (!isPanningWithMouse) {
      isPanningWithMouse = true;
      mousePanStart.x = e.clientX;
      mousePanStart.y = e.clientY;
      image.startX = matrix.e;
      image.startY = matrix.f;
      image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
      image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
      gesture.slideWidth = gesture.slideEl.offsetWidth;
      gesture.slideHeight = gesture.slideEl.offsetHeight;
      return;
    }
    const deltaX = (e.clientX - mousePanStart.x) * mousePanSensitivity;
    const deltaY = (e.clientY - mousePanStart.y) * mousePanSensitivity;
    const scaledWidth = image.width * currentScale;
    const scaledHeight = image.height * currentScale;
    const slideWidth = gesture.slideWidth;
    const slideHeight = gesture.slideHeight;
    const minX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
    const maxX = -minX;
    const minY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
    const maxY = -minY;
    const newX = Math.max(Math.min(image.startX + deltaX, maxX), minX);
    const newY = Math.max(Math.min(image.startY + deltaY, maxY), minY);
    gesture.imageWrapEl.style.transitionDuration = '0ms';
    gesture.imageWrapEl.style.transform = `translate3d(${newX}px, ${newY}px, 0)`;
    mousePanStart.x = e.clientX;
    mousePanStart.y = e.clientY;
    image.startX = newX;
    image.startY = newY;
    image.currentX = newX;
    image.currentY = newY;
  }
  function zoomIn(e) {
    const zoom = swiper.zoom;
    const params = swiper.params.zoom;
    if (!gesture.slideEl) {
      if (e && e.target) {
        gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
      }
      if (!gesture.slideEl) {
        if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
          gesture.slideEl = elementChildren(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
        } else {
          gesture.slideEl = swiper.slides[swiper.activeIndex];
        }
      }
      let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
      if (imageEl) {
        imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
      }
      gesture.imageEl = imageEl;
      if (imageEl) {
        gesture.imageWrapEl = elementParents(gesture.imageEl, `.${params.containerClass}`)[0];
      } else {
        gesture.imageWrapEl = undefined;
      }
    }
    if (!gesture.imageEl || !gesture.imageWrapEl) return;
    gesture.maxRatio = getMaxRatio();
    if (swiper.params.cssMode) {
      swiper.wrapperEl.style.overflow = 'hidden';
      swiper.wrapperEl.style.touchAction = 'none';
    }
    gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
    let touchX;
    let touchY;
    let offsetX;
    let offsetY;
    let diffX;
    let diffY;
    let translateX;
    let translateY;
    let imageWidth;
    let imageHeight;
    let scaledWidth;
    let scaledHeight;
    let translateMinX;
    let translateMinY;
    let translateMaxX;
    let translateMaxY;
    let slideWidth;
    let slideHeight;
    if (typeof image.touchesStart.x === 'undefined' && e) {
      touchX = e.pageX;
      touchY = e.pageY;
    } else {
      touchX = image.touchesStart.x;
      touchY = image.touchesStart.y;
    }
    const prevScale = currentScale;
    const forceZoomRatio = typeof e === 'number' ? e : null;
    if (currentScale === 1 && forceZoomRatio) {
      touchX = undefined;
      touchY = undefined;
      image.touchesStart.x = undefined;
      image.touchesStart.y = undefined;
    }
    const maxRatio = getMaxRatio();
    zoom.scale = forceZoomRatio || maxRatio;
    currentScale = forceZoomRatio || maxRatio;
    if (e && !(currentScale === 1 && forceZoomRatio)) {
      slideWidth = gesture.slideEl.offsetWidth;
      slideHeight = gesture.slideEl.offsetHeight;
      offsetX = elementOffset(gesture.slideEl).left + window.scrollX;
      offsetY = elementOffset(gesture.slideEl).top + window.scrollY;
      diffX = offsetX + slideWidth / 2 - touchX;
      diffY = offsetY + slideHeight / 2 - touchY;
      imageWidth = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
      imageHeight = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
      scaledWidth = imageWidth * zoom.scale;
      scaledHeight = imageHeight * zoom.scale;
      translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
      translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
      translateMaxX = -translateMinX;
      translateMaxY = -translateMinY;
      if (prevScale > 0 && forceZoomRatio && typeof image.currentX === 'number' && typeof image.currentY === 'number') {
        translateX = image.currentX * zoom.scale / prevScale;
        translateY = image.currentY * zoom.scale / prevScale;
      } else {
        translateX = diffX * zoom.scale;
        translateY = diffY * zoom.scale;
      }
      if (translateX < translateMinX) {
        translateX = translateMinX;
      }
      if (translateX > translateMaxX) {
        translateX = translateMaxX;
      }
      if (translateY < translateMinY) {
        translateY = translateMinY;
      }
      if (translateY > translateMaxY) {
        translateY = translateMaxY;
      }
    } else {
      translateX = 0;
      translateY = 0;
    }
    if (forceZoomRatio && zoom.scale === 1) {
      gesture.originX = 0;
      gesture.originY = 0;
    }
    image.currentX = translateX;
    image.currentY = translateY;
    gesture.imageWrapEl.style.transitionDuration = '300ms';
    gesture.imageWrapEl.style.transform = `translate3d(${translateX}px, ${translateY}px,0)`;
    gesture.imageEl.style.transitionDuration = '300ms';
    gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
  }
  function zoomOut() {
    const zoom = swiper.zoom;
    const params = swiper.params.zoom;
    if (!gesture.slideEl) {
      if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) {
        gesture.slideEl = elementChildren(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
      } else {
        gesture.slideEl = swiper.slides[swiper.activeIndex];
      }
      let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
      if (imageEl) {
        imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
      }
      gesture.imageEl = imageEl;
      if (imageEl) {
        gesture.imageWrapEl = elementParents(gesture.imageEl, `.${params.containerClass}`)[0];
      } else {
        gesture.imageWrapEl = undefined;
      }
    }
    if (!gesture.imageEl || !gesture.imageWrapEl) return;
    gesture.maxRatio = getMaxRatio();
    if (swiper.params.cssMode) {
      swiper.wrapperEl.style.overflow = '';
      swiper.wrapperEl.style.touchAction = '';
    }
    zoom.scale = 1;
    currentScale = 1;
    image.currentX = undefined;
    image.currentY = undefined;
    image.touchesStart.x = undefined;
    image.touchesStart.y = undefined;
    gesture.imageWrapEl.style.transitionDuration = '300ms';
    gesture.imageWrapEl.style.transform = 'translate3d(0,0,0)';
    gesture.imageEl.style.transitionDuration = '300ms';
    gesture.imageEl.style.transform = 'translate3d(0,0,0) scale(1)';
    gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
    gesture.slideEl = undefined;
    gesture.originX = 0;
    gesture.originY = 0;
    if (swiper.params.zoom.panOnMouseMove) {
      mousePanStart = {
        x: 0,
        y: 0
      };
      if (isPanningWithMouse) {
        isPanningWithMouse = false;
        image.startX = 0;
        image.startY = 0;
      }
    }
  }

  // Toggle Zoom
  function zoomToggle(e) {
    const zoom = swiper.zoom;
    if (zoom.scale && zoom.scale !== 1) {
      // Zoom Out
      zoomOut();
    } else {
      // Zoom In
      zoomIn(e);
    }
  }
  function getListeners() {
    const passiveListener = swiper.params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    const activeListenerWithCapture = swiper.params.passiveListeners ? {
      passive: false,
      capture: true
    } : true;
    return {
      passiveListener,
      activeListenerWithCapture
    };
  }

  // Attach/Detach Events
  function enable() {
    const zoom = swiper.zoom;
    if (zoom.enabled) return;
    zoom.enabled = true;
    const {
      passiveListener,
      activeListenerWithCapture
    } = getListeners();

    // Scale image
    swiper.wrapperEl.addEventListener('pointerdown', onGestureStart, passiveListener);
    swiper.wrapperEl.addEventListener('pointermove', onGestureChange, activeListenerWithCapture);
    ['pointerup', 'pointercancel', 'pointerout'].forEach(eventName => {
      swiper.wrapperEl.addEventListener(eventName, onGestureEnd, passiveListener);
    });

    // Move image
    swiper.wrapperEl.addEventListener('pointermove', onTouchMove, activeListenerWithCapture);
  }
  function disable() {
    const zoom = swiper.zoom;
    if (!zoom.enabled) return;
    zoom.enabled = false;
    const {
      passiveListener,
      activeListenerWithCapture
    } = getListeners();

    // Scale image
    swiper.wrapperEl.removeEventListener('pointerdown', onGestureStart, passiveListener);
    swiper.wrapperEl.removeEventListener('pointermove', onGestureChange, activeListenerWithCapture);
    ['pointerup', 'pointercancel', 'pointerout'].forEach(eventName => {
      swiper.wrapperEl.removeEventListener(eventName, onGestureEnd, passiveListener);
    });

    // Move image
    swiper.wrapperEl.removeEventListener('pointermove', onTouchMove, activeListenerWithCapture);
  }
  on('init', () => {
    if (swiper.params.zoom.enabled) {
      enable();
    }
  });
  on('destroy', () => {
    disable();
  });
  on('touchStart', (_s, e) => {
    if (!swiper.zoom.enabled) return;
    onTouchStart(e);
  });
  on('touchEnd', (_s, e) => {
    if (!swiper.zoom.enabled) return;
    onTouchEnd();
  });
  on('doubleTap', (_s, e) => {
    if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
      zoomToggle(e);
    }
  });
  on('transitionEnd', () => {
    if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
      onTransitionEnd();
    }
  });
  on('slideChange', () => {
    if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) {
      onTransitionEnd();
    }
  });
  Object.assign(swiper.zoom, {
    enable,
    disable,
    in: zoomIn,
    out: zoomOut,
    toggle: zoomToggle
  });
}



;// CONCATENATED MODULE: ../node_modules/swiper/modules/controller.mjs


/* eslint no-bitwise: ["error", { "allow": [">>"] }] */
function Controller({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    controller: {
      control: undefined,
      inverse: false,
      by: 'slide' // or 'container'
    }
  });

  swiper.controller = {
    control: undefined
  };
  function LinearSpline(x, y) {
    const binarySearch = function search() {
      let maxIndex;
      let minIndex;
      let guess;
      return (array, val) => {
        minIndex = -1;
        maxIndex = array.length;
        while (maxIndex - minIndex > 1) {
          guess = maxIndex + minIndex >> 1;
          if (array[guess] <= val) {
            minIndex = guess;
          } else {
            maxIndex = guess;
          }
        }
        return maxIndex;
      };
    }();
    this.x = x;
    this.y = y;
    this.lastIndex = x.length - 1;
    // Given an x value (x2), return the expected y2 value:
    // (x1,y1) is the known point before given value,
    // (x3,y3) is the known point after given value.
    let i1;
    let i3;
    this.interpolate = function interpolate(x2) {
      if (!x2) return 0;

      // Get the indexes of x1 and x3 (the array indexes before and after given x2):
      i3 = binarySearch(this.x, x2);
      i1 = i3 - 1;

      // We have our indexes i1 & i3, so we can calculate already:
      // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
      return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
    };
    return this;
  }
  function getInterpolateFunction(c) {
    swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
  }
  function setTranslate(_t, byController) {
    const controlled = swiper.controller.control;
    let multiplier;
    let controlledTranslate;
    const Swiper = swiper.constructor;
    function setControlledTranslate(c) {
      if (c.destroyed) return;

      // this will create an Interpolate function based on the snapGrids
      // x is the Grid of the scrolled scroller and y will be the controlled scroller
      // it makes sense to create this only once and recall it for the interpolation
      // the function does a lot of value caching for performance
      const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
      if (swiper.params.controller.by === 'slide') {
        getInterpolateFunction(c);
        // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
        // but it did not work out
        controlledTranslate = -swiper.controller.spline.interpolate(-translate);
      }
      if (!controlledTranslate || swiper.params.controller.by === 'container') {
        multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
        if (Number.isNaN(multiplier) || !Number.isFinite(multiplier)) {
          multiplier = 1;
        }
        controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
      }
      if (swiper.params.controller.inverse) {
        controlledTranslate = c.maxTranslate() - controlledTranslate;
      }
      c.updateProgress(controlledTranslate);
      c.setTranslate(controlledTranslate, swiper);
      c.updateActiveIndex();
      c.updateSlidesClasses();
    }
    if (Array.isArray(controlled)) {
      for (let i = 0; i < controlled.length; i += 1) {
        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
          setControlledTranslate(controlled[i]);
        }
      }
    } else if (controlled instanceof Swiper && byController !== controlled) {
      setControlledTranslate(controlled);
    }
  }
  function setTransition(duration, byController) {
    const Swiper = swiper.constructor;
    const controlled = swiper.controller.control;
    let i;
    function setControlledTransition(c) {
      if (c.destroyed) return;
      c.setTransition(duration, swiper);
      if (duration !== 0) {
        c.transitionStart();
        if (c.params.autoHeight) {
          nextTick(() => {
            c.updateAutoHeight();
          });
        }
        elementTransitionEnd(c.wrapperEl, () => {
          if (!controlled) return;
          c.transitionEnd();
        });
      }
    }
    if (Array.isArray(controlled)) {
      for (i = 0; i < controlled.length; i += 1) {
        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
          setControlledTransition(controlled[i]);
        }
      }
    } else if (controlled instanceof Swiper && byController !== controlled) {
      setControlledTransition(controlled);
    }
  }
  function removeSpline() {
    if (!swiper.controller.control) return;
    if (swiper.controller.spline) {
      swiper.controller.spline = undefined;
      delete swiper.controller.spline;
    }
  }
  on('beforeInit', () => {
    if (typeof window !== 'undefined' && (
    // eslint-disable-line
    typeof swiper.params.controller.control === 'string' || swiper.params.controller.control instanceof HTMLElement)) {
      const controlElements = typeof swiper.params.controller.control === 'string' ? [...document.querySelectorAll(swiper.params.controller.control)] : [swiper.params.controller.control];
      controlElements.forEach(controlElement => {
        if (!swiper.controller.control) swiper.controller.control = [];
        if (controlElement && controlElement.swiper) {
          swiper.controller.control.push(controlElement.swiper);
        } else if (controlElement) {
          const eventName = `${swiper.params.eventsPrefix}init`;
          const onControllerSwiper = e => {
            swiper.controller.control.push(e.detail[0]);
            swiper.update();
            controlElement.removeEventListener(eventName, onControllerSwiper);
          };
          controlElement.addEventListener(eventName, onControllerSwiper);
        }
      });
      return;
    }
    swiper.controller.control = swiper.params.controller.control;
  });
  on('update', () => {
    removeSpline();
  });
  on('resize', () => {
    removeSpline();
  });
  on('observerUpdate', () => {
    removeSpline();
  });
  on('setTranslate', (_s, translate, byController) => {
    if (!swiper.controller.control || swiper.controller.control.destroyed) return;
    swiper.controller.setTranslate(translate, byController);
  });
  on('setTransition', (_s, duration, byController) => {
    if (!swiper.controller.control || swiper.controller.control.destroyed) return;
    swiper.controller.setTransition(duration, byController);
  });
  Object.assign(swiper.controller, {
    setTranslate,
    setTransition
  });
}



;// CONCATENATED MODULE: ../node_modules/swiper/modules/a11y.mjs




function A11y({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    a11y: {
      enabled: true,
      notificationClass: 'swiper-notification',
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
      firstSlideMessage: 'This is the first slide',
      lastSlideMessage: 'This is the last slide',
      paginationBulletMessage: 'Go to slide {{index}}',
      slideLabelMessage: '{{index}} / {{slidesLength}}',
      containerMessage: null,
      containerRoleDescriptionMessage: null,
      containerRole: null,
      itemRoleDescriptionMessage: null,
      slideRole: 'group',
      id: null,
      scrollOnFocus: true,
      wrapperLiveRegion: true
    }
  });
  swiper.a11y = {
    clicked: false
  };
  let liveRegion = null;
  let preventFocusHandler;
  let focusTargetSlideEl;
  let visibilityChangedTimestamp = new Date().getTime();
  function notify(message) {
    const notification = liveRegion;
    if (notification.length === 0) return;
    (0,utils.s)(notification, message);
  }
  function getRandomNumber(size = 16) {
    const randomChar = () => Math.round(16 * Math.random()).toString(16);
    return 'x'.repeat(size).replace(/x/g, randomChar);
  }
  function makeElFocusable(el) {
    el = (0,utils.m)(el);
    el.forEach(subEl => {
      subEl.setAttribute('tabIndex', '0');
    });
  }
  function makeElNotFocusable(el) {
    el = (0,utils.m)(el);
    el.forEach(subEl => {
      subEl.setAttribute('tabIndex', '-1');
    });
  }
  function addElRole(el, role) {
    el = (0,utils.m)(el);
    el.forEach(subEl => {
      subEl.setAttribute('role', role);
    });
  }
  function addElRoleDescription(el, description) {
    el = (0,utils.m)(el);
    el.forEach(subEl => {
      subEl.setAttribute('aria-roledescription', description);
    });
  }
  function addElControls(el, controls) {
    el = (0,utils.m)(el);
    el.forEach(subEl => {
      subEl.setAttribute('aria-controls', controls);
    });
  }
  function addElLabel(el, label) {
    el = (0,utils.m)(el);
    el.forEach(subEl => {
      subEl.setAttribute('aria-label', label);
    });
  }
  function addElId(el, id) {
    el = (0,utils.m)(el);
    el.forEach(subEl => {
      subEl.setAttribute('id', id);
    });
  }
  function addElLive(el, live) {
    el = (0,utils.m)(el);
    el.forEach(subEl => {
      subEl.setAttribute('aria-live', live);
    });
  }
  function disableEl(el) {
    el = (0,utils.m)(el);
    el.forEach(subEl => {
      subEl.setAttribute('aria-disabled', true);
    });
  }
  function enableEl(el) {
    el = (0,utils.m)(el);
    el.forEach(subEl => {
      subEl.setAttribute('aria-disabled', false);
    });
  }
  function onEnterOrSpaceKey(e) {
    if (e.keyCode !== 13 && e.keyCode !== 32) return;
    const params = swiper.params.a11y;
    const targetEl = e.target;
    if (swiper.pagination && swiper.pagination.el && (targetEl === swiper.pagination.el || swiper.pagination.el.contains(e.target))) {
      if (!e.target.matches(classes_to_selector_classesToSelector(swiper.params.pagination.bulletClass))) return;
    }
    if (swiper.navigation && swiper.navigation.prevEl && swiper.navigation.nextEl) {
      const prevEls = (0,utils.m)(swiper.navigation.prevEl);
      const nextEls = (0,utils.m)(swiper.navigation.nextEl);
      if (nextEls.includes(targetEl)) {
        if (!(swiper.isEnd && !swiper.params.loop)) {
          swiper.slideNext();
        }
        if (swiper.isEnd) {
          notify(params.lastSlideMessage);
        } else {
          notify(params.nextSlideMessage);
        }
      }
      if (prevEls.includes(targetEl)) {
        if (!(swiper.isBeginning && !swiper.params.loop)) {
          swiper.slidePrev();
        }
        if (swiper.isBeginning) {
          notify(params.firstSlideMessage);
        } else {
          notify(params.prevSlideMessage);
        }
      }
    }
    if (swiper.pagination && targetEl.matches(classes_to_selector_classesToSelector(swiper.params.pagination.bulletClass))) {
      targetEl.click();
    }
  }
  function updateNavigation() {
    if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
    const {
      nextEl,
      prevEl
    } = swiper.navigation;
    if (prevEl) {
      if (swiper.isBeginning) {
        disableEl(prevEl);
        makeElNotFocusable(prevEl);
      } else {
        enableEl(prevEl);
        makeElFocusable(prevEl);
      }
    }
    if (nextEl) {
      if (swiper.isEnd) {
        disableEl(nextEl);
        makeElNotFocusable(nextEl);
      } else {
        enableEl(nextEl);
        makeElFocusable(nextEl);
      }
    }
  }
  function hasPagination() {
    return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
  }
  function hasClickablePagination() {
    return hasPagination() && swiper.params.pagination.clickable;
  }
  function updatePagination() {
    const params = swiper.params.a11y;
    if (!hasPagination()) return;
    swiper.pagination.bullets.forEach(bulletEl => {
      if (swiper.params.pagination.clickable) {
        makeElFocusable(bulletEl);
        if (!swiper.params.pagination.renderBullet) {
          addElRole(bulletEl, 'button');
          addElLabel(bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, (0,utils.j)(bulletEl) + 1));
        }
      }
      if (bulletEl.matches(classes_to_selector_classesToSelector(swiper.params.pagination.bulletActiveClass))) {
        bulletEl.setAttribute('aria-current', 'true');
      } else {
        bulletEl.removeAttribute('aria-current');
      }
    });
  }
  const initNavEl = (el, wrapperId, message) => {
    makeElFocusable(el);
    if (el.tagName !== 'BUTTON') {
      addElRole(el, 'button');
      el.addEventListener('keydown', onEnterOrSpaceKey);
    }
    addElLabel(el, message);
    addElControls(el, wrapperId);
  };
  const handlePointerDown = e => {
    if (focusTargetSlideEl && focusTargetSlideEl !== e.target && !focusTargetSlideEl.contains(e.target)) {
      preventFocusHandler = true;
    }
    swiper.a11y.clicked = true;
  };
  const handlePointerUp = () => {
    preventFocusHandler = false;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (!swiper.destroyed) {
          swiper.a11y.clicked = false;
        }
      });
    });
  };
  const onVisibilityChange = e => {
    visibilityChangedTimestamp = new Date().getTime();
  };
  const handleFocus = e => {
    if (swiper.a11y.clicked || !swiper.params.a11y.scrollOnFocus) return;
    if (new Date().getTime() - visibilityChangedTimestamp < 100) return;
    const slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
    if (!slideEl || !swiper.slides.includes(slideEl)) return;
    focusTargetSlideEl = slideEl;
    const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
    const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
    if (isActive || isVisible) return;
    if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
    if (swiper.isHorizontal()) {
      swiper.el.scrollLeft = 0;
    } else {
      swiper.el.scrollTop = 0;
    }
    requestAnimationFrame(() => {
      if (preventFocusHandler) return;
      if (swiper.params.loop) {
        swiper.slideToLoop(swiper.getSlideIndexWhenGrid(parseInt(slideEl.getAttribute('data-swiper-slide-index'))), 0);
      } else {
        swiper.slideTo(swiper.getSlideIndexWhenGrid(swiper.slides.indexOf(slideEl)), 0);
      }
      preventFocusHandler = false;
    });
  };
  const initSlides = () => {
    const params = swiper.params.a11y;
    if (params.itemRoleDescriptionMessage) {
      addElRoleDescription(swiper.slides, params.itemRoleDescriptionMessage);
    }
    if (params.slideRole) {
      addElRole(swiper.slides, params.slideRole);
    }
    const slidesLength = swiper.slides.length;
    if (params.slideLabelMessage) {
      swiper.slides.forEach((slideEl, index) => {
        const slideIndex = swiper.params.loop ? parseInt(slideEl.getAttribute('data-swiper-slide-index'), 10) : index;
        const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
        addElLabel(slideEl, ariaLabelMessage);
      });
    }
  };
  const init = () => {
    const params = swiper.params.a11y;
    swiper.el.append(liveRegion);

    // Container
    const containerEl = swiper.el;
    if (params.containerRoleDescriptionMessage) {
      addElRoleDescription(containerEl, params.containerRoleDescriptionMessage);
    }
    if (params.containerMessage) {
      addElLabel(containerEl, params.containerMessage);
    }
    if (params.containerRole) {
      addElRole(containerEl, params.containerRole);
    }

    // Wrapper
    const wrapperEl = swiper.wrapperEl;
    const wrapperId = params.id || wrapperEl.getAttribute('id') || `swiper-wrapper-${getRandomNumber(16)}`;
    addElId(wrapperEl, wrapperId);
    if (params.wrapperLiveRegion) {
      const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? 'off' : 'polite';
      addElLive(wrapperEl, live);
    }

    // Slide
    initSlides();

    // Navigation
    let {
      nextEl,
      prevEl
    } = swiper.navigation ? swiper.navigation : {};
    nextEl = (0,utils.m)(nextEl);
    prevEl = (0,utils.m)(prevEl);
    if (nextEl) {
      nextEl.forEach(el => initNavEl(el, wrapperId, params.nextSlideMessage));
    }
    if (prevEl) {
      prevEl.forEach(el => initNavEl(el, wrapperId, params.prevSlideMessage));
    }

    // Pagination
    if (hasClickablePagination()) {
      const paginationEl = (0,utils.m)(swiper.pagination.el);
      paginationEl.forEach(el => {
        el.addEventListener('keydown', onEnterOrSpaceKey);
      });
    }

    // Tab focus
    const document = (0,ssr_window_esm.g)();
    document.addEventListener('visibilitychange', onVisibilityChange);
    swiper.el.addEventListener('focus', handleFocus, true);
    swiper.el.addEventListener('pointerdown', handlePointerDown, true);
    swiper.el.addEventListener('pointerup', handlePointerUp, true);
  };
  function destroy() {
    if (liveRegion) liveRegion.remove();
    let {
      nextEl,
      prevEl
    } = swiper.navigation ? swiper.navigation : {};
    nextEl = (0,utils.m)(nextEl);
    prevEl = (0,utils.m)(prevEl);
    if (nextEl) {
      nextEl.forEach(el => el.removeEventListener('keydown', onEnterOrSpaceKey));
    }
    if (prevEl) {
      prevEl.forEach(el => el.removeEventListener('keydown', onEnterOrSpaceKey));
    }

    // Pagination
    if (hasClickablePagination()) {
      const paginationEl = (0,utils.m)(swiper.pagination.el);
      paginationEl.forEach(el => {
        el.removeEventListener('keydown', onEnterOrSpaceKey);
      });
    }
    const document = (0,ssr_window_esm.g)();
    document.removeEventListener('visibilitychange', onVisibilityChange);
    // Tab focus
    if (swiper.el && typeof swiper.el !== 'string') {
      swiper.el.removeEventListener('focus', handleFocus, true);
      swiper.el.removeEventListener('pointerdown', handlePointerDown, true);
      swiper.el.removeEventListener('pointerup', handlePointerUp, true);
    }
  }
  on('beforeInit', () => {
    liveRegion = (0,utils.c)('span', swiper.params.a11y.notificationClass);
    liveRegion.setAttribute('aria-live', 'assertive');
    liveRegion.setAttribute('aria-atomic', 'true');
  });
  on('afterInit', () => {
    if (!swiper.params.a11y.enabled) return;
    init();
  });
  on('slidesLengthChange snapGridLengthChange slidesGridLengthChange', () => {
    if (!swiper.params.a11y.enabled) return;
    initSlides();
  });
  on('fromEdge toEdge afterInit lock unlock', () => {
    if (!swiper.params.a11y.enabled) return;
    updateNavigation();
  });
  on('paginationUpdate', () => {
    if (!swiper.params.a11y.enabled) return;
    updatePagination();
  });
  on('destroy', () => {
    if (!swiper.params.a11y.enabled) return;
    destroy();
  });
}



;// CONCATENATED MODULE: ../node_modules/swiper/modules/history.mjs


function History({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    history: {
      enabled: false,
      root: '',
      replaceState: false,
      key: 'slides',
      keepQuery: false
    }
  });
  let initialized = false;
  let paths = {};
  const slugify = text => {
    return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
  };
  const getPathValues = urlOverride => {
    const window = getWindow();
    let location;
    if (urlOverride) {
      location = new URL(urlOverride);
    } else {
      location = window.location;
    }
    const pathArray = location.pathname.slice(1).split('/').filter(part => part !== '');
    const total = pathArray.length;
    const key = pathArray[total - 2];
    const value = pathArray[total - 1];
    return {
      key,
      value
    };
  };
  const setHistory = (key, index) => {
    const window = getWindow();
    if (!initialized || !swiper.params.history.enabled) return;
    let location;
    if (swiper.params.url) {
      location = new URL(swiper.params.url);
    } else {
      location = window.location;
    }
    const slide = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${index}"]`) : swiper.slides[index];
    let value = slugify(slide.getAttribute('data-history'));
    if (swiper.params.history.root.length > 0) {
      let root = swiper.params.history.root;
      if (root[root.length - 1] === '/') root = root.slice(0, root.length - 1);
      value = `${root}/${key ? `${key}/` : ''}${value}`;
    } else if (!location.pathname.includes(key)) {
      value = `${key ? `${key}/` : ''}${value}`;
    }
    if (swiper.params.history.keepQuery) {
      value += location.search;
    }
    const currentState = window.history.state;
    if (currentState && currentState.value === value) {
      return;
    }
    if (swiper.params.history.replaceState) {
      window.history.replaceState({
        value
      }, null, value);
    } else {
      window.history.pushState({
        value
      }, null, value);
    }
  };
  const scrollToSlide = (speed, value, runCallbacks) => {
    if (value) {
      for (let i = 0, length = swiper.slides.length; i < length; i += 1) {
        const slide = swiper.slides[i];
        const slideHistory = slugify(slide.getAttribute('data-history'));
        if (slideHistory === value) {
          const index = swiper.getSlideIndex(slide);
          swiper.slideTo(index, speed, runCallbacks);
        }
      }
    } else {
      swiper.slideTo(0, speed, runCallbacks);
    }
  };
  const setHistoryPopState = () => {
    paths = getPathValues(swiper.params.url);
    scrollToSlide(swiper.params.speed, paths.value, false);
  };
  const init = () => {
    const window = getWindow();
    if (!swiper.params.history) return;
    if (!window.history || !window.history.pushState) {
      swiper.params.history.enabled = false;
      swiper.params.hashNavigation.enabled = true;
      return;
    }
    initialized = true;
    paths = getPathValues(swiper.params.url);
    if (!paths.key && !paths.value) {
      if (!swiper.params.history.replaceState) {
        window.addEventListener('popstate', setHistoryPopState);
      }
      return;
    }
    scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
    if (!swiper.params.history.replaceState) {
      window.addEventListener('popstate', setHistoryPopState);
    }
  };
  const destroy = () => {
    const window = getWindow();
    if (!swiper.params.history.replaceState) {
      window.removeEventListener('popstate', setHistoryPopState);
    }
  };
  on('init', () => {
    if (swiper.params.history.enabled) {
      init();
    }
  });
  on('destroy', () => {
    if (swiper.params.history.enabled) {
      destroy();
    }
  });
  on('transitionEnd _freeModeNoMomentumRelease', () => {
    if (initialized) {
      setHistory(swiper.params.history.key, swiper.activeIndex);
    }
  });
  on('slideChange', () => {
    if (initialized && swiper.params.cssMode) {
      setHistory(swiper.params.history.key, swiper.activeIndex);
    }
  });
}



;// CONCATENATED MODULE: ../node_modules/swiper/modules/hash-navigation.mjs



function HashNavigation({
  swiper,
  extendParams,
  emit,
  on
}) {
  let initialized = false;
  const document = getDocument();
  const window = getWindow();
  extendParams({
    hashNavigation: {
      enabled: false,
      replaceState: false,
      watchState: false,
      getSlideIndex(_s, hash) {
        if (swiper.virtual && swiper.params.virtual.enabled) {
          const slideWithHash = swiper.slides.find(slideEl => slideEl.getAttribute('data-hash') === hash);
          if (!slideWithHash) return 0;
          const index = parseInt(slideWithHash.getAttribute('data-swiper-slide-index'), 10);
          return index;
        }
        return swiper.getSlideIndex(elementChildren(swiper.slidesEl, `.${swiper.params.slideClass}[data-hash="${hash}"], swiper-slide[data-hash="${hash}"]`)[0]);
      }
    }
  });
  const onHashChange = () => {
    emit('hashChange');
    const newHash = document.location.hash.replace('#', '');
    const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
    const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute('data-hash') : '';
    if (newHash !== activeSlideHash) {
      const newIndex = swiper.params.hashNavigation.getSlideIndex(swiper, newHash);
      if (typeof newIndex === 'undefined' || Number.isNaN(newIndex)) return;
      swiper.slideTo(newIndex);
    }
  };
  const setHash = () => {
    if (!initialized || !swiper.params.hashNavigation.enabled) return;
    const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
    const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute('data-hash') || activeSlideEl.getAttribute('data-history') : '';
    if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
      window.history.replaceState(null, null, `#${activeSlideHash}` || '');
      emit('hashSet');
    } else {
      document.location.hash = activeSlideHash || '';
      emit('hashSet');
    }
  };
  const init = () => {
    if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
    initialized = true;
    const hash = document.location.hash.replace('#', '');
    if (hash) {
      const speed = 0;
      const index = swiper.params.hashNavigation.getSlideIndex(swiper, hash);
      swiper.slideTo(index || 0, speed, swiper.params.runCallbacksOnInit, true);
    }
    if (swiper.params.hashNavigation.watchState) {
      window.addEventListener('hashchange', onHashChange);
    }
  };
  const destroy = () => {
    if (swiper.params.hashNavigation.watchState) {
      window.removeEventListener('hashchange', onHashChange);
    }
  };
  on('init', () => {
    if (swiper.params.hashNavigation.enabled) {
      init();
    }
  });
  on('destroy', () => {
    if (swiper.params.hashNavigation.enabled) {
      destroy();
    }
  });
  on('transitionEnd _freeModeNoMomentumRelease', () => {
    if (initialized) {
      setHash();
    }
  });
  on('slideChange', () => {
    if (initialized && swiper.params.cssMode) {
      setHash();
    }
  });
}



;// CONCATENATED MODULE: ../node_modules/swiper/modules/autoplay.mjs


/* eslint no-underscore-dangle: "off" */
/* eslint no-use-before-define: "off" */
function Autoplay({
  swiper,
  extendParams,
  on,
  emit,
  params
}) {
  swiper.autoplay = {
    running: false,
    paused: false,
    timeLeft: 0
  };
  extendParams({
    autoplay: {
      enabled: false,
      delay: 3000,
      waitForTransition: true,
      disableOnInteraction: false,
      stopOnLastSlide: false,
      reverseDirection: false,
      pauseOnMouseEnter: false
    }
  });
  let timeout;
  let raf;
  let autoplayDelayTotal = params && params.autoplay ? params.autoplay.delay : 3000;
  let autoplayDelayCurrent = params && params.autoplay ? params.autoplay.delay : 3000;
  let autoplayTimeLeft;
  let autoplayStartTime = new Date().getTime();
  let wasPaused;
  let isTouched;
  let pausedByTouch;
  let touchStartTimeout;
  let pausedByInteraction;
  let pausedByPointerEnter;
  function onTransitionEnd(e) {
    if (!swiper || swiper.destroyed || !swiper.wrapperEl) return;
    if (e.target !== swiper.wrapperEl) return;
    swiper.wrapperEl.removeEventListener('transitionend', onTransitionEnd);
    if (pausedByPointerEnter || e.detail && e.detail.bySwiperTouchMove) {
      return;
    }
    resume();
  }
  const calcTimeLeft = () => {
    if (swiper.destroyed || !swiper.autoplay.running) return;
    if (swiper.autoplay.paused) {
      wasPaused = true;
    } else if (wasPaused) {
      autoplayDelayCurrent = autoplayTimeLeft;
      wasPaused = false;
    }
    const timeLeft = swiper.autoplay.paused ? autoplayTimeLeft : autoplayStartTime + autoplayDelayCurrent - new Date().getTime();
    swiper.autoplay.timeLeft = timeLeft;
    emit('autoplayTimeLeft', timeLeft, timeLeft / autoplayDelayTotal);
    raf = requestAnimationFrame(() => {
      calcTimeLeft();
    });
  };
  const getSlideDelay = () => {
    let activeSlideEl;
    if (swiper.virtual && swiper.params.virtual.enabled) {
      activeSlideEl = swiper.slides.find(slideEl => slideEl.classList.contains('swiper-slide-active'));
    } else {
      activeSlideEl = swiper.slides[swiper.activeIndex];
    }
    if (!activeSlideEl) return undefined;
    const currentSlideDelay = parseInt(activeSlideEl.getAttribute('data-swiper-autoplay'), 10);
    return currentSlideDelay;
  };
  const getTotalDelay = () => {
    let totalDelay = swiper.params.autoplay.delay;
    const currentSlideDelay = getSlideDelay();
    if (!Number.isNaN(currentSlideDelay) && currentSlideDelay > 0) {
      totalDelay = currentSlideDelay;
    }
    return totalDelay;
  };
  const run = delayForce => {
    if (swiper.destroyed || !swiper.autoplay.running) return;
    cancelAnimationFrame(raf);
    calcTimeLeft();
    let delay = delayForce;
    if (typeof delay === 'undefined') {
      delay = getTotalDelay();
      autoplayDelayTotal = delay;
      autoplayDelayCurrent = delay;
    }
    autoplayTimeLeft = delay;
    const speed = swiper.params.speed;
    const proceed = () => {
      if (!swiper || swiper.destroyed) return;
      if (swiper.params.autoplay.reverseDirection) {
        if (!swiper.isBeginning || swiper.params.loop || swiper.params.rewind) {
          swiper.slidePrev(speed, true, true);
          emit('autoplay');
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          swiper.slideTo(swiper.slides.length - 1, speed, true, true);
          emit('autoplay');
        }
      } else {
        if (!swiper.isEnd || swiper.params.loop || swiper.params.rewind) {
          swiper.slideNext(speed, true, true);
          emit('autoplay');
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          swiper.slideTo(0, speed, true, true);
          emit('autoplay');
        }
      }
      if (swiper.params.cssMode) {
        autoplayStartTime = new Date().getTime();
        requestAnimationFrame(() => {
          run();
        });
      }
    };
    if (delay > 0) {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        proceed();
      }, delay);
    } else {
      requestAnimationFrame(() => {
        proceed();
      });
    }

    // eslint-disable-next-line
    return delay;
  };
  const start = () => {
    autoplayStartTime = new Date().getTime();
    swiper.autoplay.running = true;
    run();
    emit('autoplayStart');
  };
  const stop = () => {
    swiper.autoplay.running = false;
    clearTimeout(timeout);
    cancelAnimationFrame(raf);
    emit('autoplayStop');
  };
  const pause = (internal, reset) => {
    if (swiper.destroyed || !swiper.autoplay.running) return;
    clearTimeout(timeout);
    if (!internal) {
      pausedByInteraction = true;
    }
    const proceed = () => {
      emit('autoplayPause');
      if (swiper.params.autoplay.waitForTransition) {
        swiper.wrapperEl.addEventListener('transitionend', onTransitionEnd);
      } else {
        resume();
      }
    };
    swiper.autoplay.paused = true;
    if (reset) {
      proceed();
      return;
    }
    const delay = autoplayTimeLeft || swiper.params.autoplay.delay;
    autoplayTimeLeft = delay - (new Date().getTime() - autoplayStartTime);
    if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop) return;
    if (autoplayTimeLeft < 0) autoplayTimeLeft = 0;
    proceed();
  };
  const resume = () => {
    if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop || swiper.destroyed || !swiper.autoplay.running) return;
    autoplayStartTime = new Date().getTime();
    if (pausedByInteraction) {
      pausedByInteraction = false;
      run(autoplayTimeLeft);
    } else {
      run();
    }
    swiper.autoplay.paused = false;
    emit('autoplayResume');
  };
  const onVisibilityChange = () => {
    if (swiper.destroyed || !swiper.autoplay.running) return;
    const document = (0,ssr_window_esm.g)();
    if (document.visibilityState === 'hidden') {
      pausedByInteraction = true;
      pause(true);
    }
    if (document.visibilityState === 'visible') {
      resume();
    }
  };
  const onPointerEnter = e => {
    if (e.pointerType !== 'mouse') return;
    pausedByInteraction = true;
    pausedByPointerEnter = true;
    if (swiper.animating || swiper.autoplay.paused) return;
    pause(true);
  };
  const onPointerLeave = e => {
    if (e.pointerType !== 'mouse') return;
    pausedByPointerEnter = false;
    if (swiper.autoplay.paused) {
      resume();
    }
  };
  const attachMouseEvents = () => {
    if (swiper.params.autoplay.pauseOnMouseEnter) {
      swiper.el.addEventListener('pointerenter', onPointerEnter);
      swiper.el.addEventListener('pointerleave', onPointerLeave);
    }
  };
  const detachMouseEvents = () => {
    if (swiper.el && typeof swiper.el !== 'string') {
      swiper.el.removeEventListener('pointerenter', onPointerEnter);
      swiper.el.removeEventListener('pointerleave', onPointerLeave);
    }
  };
  const attachDocumentEvents = () => {
    const document = (0,ssr_window_esm.g)();
    document.addEventListener('visibilitychange', onVisibilityChange);
  };
  const detachDocumentEvents = () => {
    const document = (0,ssr_window_esm.g)();
    document.removeEventListener('visibilitychange', onVisibilityChange);
  };
  on('init', () => {
    if (swiper.params.autoplay.enabled) {
      attachMouseEvents();
      attachDocumentEvents();
      start();
    }
  });
  on('destroy', () => {
    detachMouseEvents();
    detachDocumentEvents();
    if (swiper.autoplay.running) {
      stop();
    }
  });
  on('_freeModeStaticRelease', () => {
    if (pausedByTouch || pausedByInteraction) {
      resume();
    }
  });
  on('_freeModeNoMomentumRelease', () => {
    if (!swiper.params.autoplay.disableOnInteraction) {
      pause(true, true);
    } else {
      stop();
    }
  });
  on('beforeTransitionStart', (_s, speed, internal) => {
    if (swiper.destroyed || !swiper.autoplay.running) return;
    if (internal || !swiper.params.autoplay.disableOnInteraction) {
      pause(true, true);
    } else {
      stop();
    }
  });
  on('sliderFirstMove', () => {
    if (swiper.destroyed || !swiper.autoplay.running) return;
    if (swiper.params.autoplay.disableOnInteraction) {
      stop();
      return;
    }
    isTouched = true;
    pausedByTouch = false;
    pausedByInteraction = false;
    touchStartTimeout = setTimeout(() => {
      pausedByInteraction = true;
      pausedByTouch = true;
      pause(true);
    }, 200);
  });
  on('touchEnd', () => {
    if (swiper.destroyed || !swiper.autoplay.running || !isTouched) return;
    clearTimeout(touchStartTimeout);
    clearTimeout(timeout);
    if (swiper.params.autoplay.disableOnInteraction) {
      pausedByTouch = false;
      isTouched = false;
      return;
    }
    if (pausedByTouch && swiper.params.cssMode) resume();
    pausedByTouch = false;
    isTouched = false;
  });
  on('slideChange', () => {
    if (swiper.destroyed || !swiper.autoplay.running) return;
    if (swiper.autoplay.paused) {
      autoplayTimeLeft = getTotalDelay();
      autoplayDelayTotal = getTotalDelay();
    }
  });
  Object.assign(swiper.autoplay, {
    start,
    stop,
    pause,
    resume
  });
}



;// CONCATENATED MODULE: ../node_modules/swiper/modules/thumbs.mjs



function Thumb({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    thumbs: {
      swiper: null,
      multipleActiveThumbs: true,
      autoScrollOffset: 0,
      slideThumbActiveClass: 'swiper-slide-thumb-active',
      thumbsContainerClass: 'swiper-thumbs'
    }
  });
  let initialized = false;
  let swiperCreated = false;
  swiper.thumbs = {
    swiper: null
  };
  function isVirtualEnabled() {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed) return false;
    return thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled;
  }
  function onThumbClick() {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed) return;
    const clickedIndex = thumbsSwiper.clickedIndex;
    const clickedSlide = thumbsSwiper.clickedSlide;
    if (clickedSlide && clickedSlide.classList.contains(swiper.params.thumbs.slideThumbActiveClass)) return;
    if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
    let slideToIndex;
    if (thumbsSwiper.params.loop) {
      slideToIndex = parseInt(thumbsSwiper.clickedSlide.getAttribute('data-swiper-slide-index'), 10);
    } else {
      slideToIndex = clickedIndex;
    }
    if (swiper.params.loop) {
      swiper.slideToLoop(slideToIndex);
    } else {
      swiper.slideTo(slideToIndex);
    }
  }
  function init() {
    const {
      thumbs: thumbsParams
    } = swiper.params;
    if (initialized) return false;
    initialized = true;
    const SwiperClass = swiper.constructor;
    if (thumbsParams.swiper instanceof SwiperClass) {
      if (thumbsParams.swiper.destroyed) {
        initialized = false;
        return false;
      }
      swiper.thumbs.swiper = thumbsParams.swiper;
      Object.assign(swiper.thumbs.swiper.originalParams, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
      Object.assign(swiper.thumbs.swiper.params, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
      swiper.thumbs.swiper.update();
    } else if ((0,utils.p)(thumbsParams.swiper)) {
      const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
      Object.assign(thumbsSwiperParams, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
      swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
      swiperCreated = true;
    }
    swiper.thumbs.swiper.el.classList.add(swiper.params.thumbs.thumbsContainerClass);
    swiper.thumbs.swiper.on('tap', onThumbClick);
    if (isVirtualEnabled()) {
      swiper.thumbs.swiper.on('virtualUpdate', () => {
        update(false, {
          autoScroll: false
        });
      });
    }
    return true;
  }
  function update(initial, p) {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed) return;

    // Activate thumbs
    let thumbsToActivate = 1;
    const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
    if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
      thumbsToActivate = swiper.params.slidesPerView;
    }
    if (!swiper.params.thumbs.multipleActiveThumbs) {
      thumbsToActivate = 1;
    }
    thumbsToActivate = Math.floor(thumbsToActivate);
    thumbsSwiper.slides.forEach(slideEl => slideEl.classList.remove(thumbActiveClass));
    if (thumbsSwiper.params.loop || isVirtualEnabled()) {
      for (let i = 0; i < thumbsToActivate; i += 1) {
        (0,utils.e)(thumbsSwiper.slidesEl, `[data-swiper-slide-index="${swiper.realIndex + i}"]`).forEach(slideEl => {
          slideEl.classList.add(thumbActiveClass);
        });
      }
    } else {
      for (let i = 0; i < thumbsToActivate; i += 1) {
        if (thumbsSwiper.slides[swiper.realIndex + i]) {
          thumbsSwiper.slides[swiper.realIndex + i].classList.add(thumbActiveClass);
        }
      }
    }
    if (p?.autoScroll ?? true) {
      autoScroll(initial ? 0 : undefined);
    }
  }
  function autoScroll(slideSpeed) {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed) return;
    const slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
    const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
    const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
    if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
      const currentThumbsIndex = thumbsSwiper.activeIndex;
      let newThumbsIndex;
      let direction;
      if (thumbsSwiper.params.loop) {
        const newThumbsSlide = thumbsSwiper.slides.find(slideEl => slideEl.getAttribute('data-swiper-slide-index') === `${swiper.realIndex}`);
        newThumbsIndex = thumbsSwiper.slides.indexOf(newThumbsSlide);
        direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
      } else {
        newThumbsIndex = swiper.realIndex;
        direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
      }
      if (useOffset) {
        newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
      }
      if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
        if (thumbsSwiper.params.centeredSlides) {
          if (newThumbsIndex > currentThumbsIndex) {
            newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
          } else {
            newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
          }
        } else if (newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup === 1) ;
        thumbsSwiper.slideTo(newThumbsIndex, slideSpeed);
      }
    }
  }
  on('beforeInit', () => {
    const {
      thumbs
    } = swiper.params;
    if (!thumbs || !thumbs.swiper) return;
    if (typeof thumbs.swiper === 'string' || thumbs.swiper instanceof HTMLElement) {
      const document = (0,ssr_window_esm.g)();
      const getThumbsElementAndInit = () => {
        const thumbsElement = typeof thumbs.swiper === 'string' ? document.querySelector(thumbs.swiper) : thumbs.swiper;
        if (thumbsElement && thumbsElement.swiper) {
          thumbs.swiper = thumbsElement.swiper;
          init();
          update(true);
        } else if (thumbsElement) {
          const eventName = `${swiper.params.eventsPrefix}init`;
          const onThumbsSwiper = e => {
            thumbs.swiper = e.detail[0];
            thumbsElement.removeEventListener(eventName, onThumbsSwiper);
            init();
            update(true);
            thumbs.swiper.update();
            swiper.update();
          };
          thumbsElement.addEventListener(eventName, onThumbsSwiper);
        }
        return thumbsElement;
      };
      const watchForThumbsToAppear = () => {
        if (swiper.destroyed) return;
        const thumbsElement = getThumbsElementAndInit();
        if (!thumbsElement) {
          requestAnimationFrame(watchForThumbsToAppear);
        }
      };
      requestAnimationFrame(watchForThumbsToAppear);
    } else {
      init();
      update(true);
    }
  });
  on('slideChange update resize observerUpdate', () => {
    update();
  });
  on('setTransition', (_s, duration) => {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed) return;
    thumbsSwiper.setTransition(duration);
  });
  on('beforeDestroy', () => {
    const thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper || thumbsSwiper.destroyed) return;
    if (swiperCreated) {
      thumbsSwiper.destroy();
    }
  });
  Object.assign(swiper.thumbs, {
    init,
    update
  });
}



;// CONCATENATED MODULE: ../node_modules/swiper/modules/free-mode.mjs


function freeMode({
  swiper,
  extendParams,
  emit,
  once
}) {
  extendParams({
    freeMode: {
      enabled: false,
      momentum: true,
      momentumRatio: 1,
      momentumBounce: true,
      momentumBounceRatio: 1,
      momentumVelocityRatio: 1,
      sticky: false,
      minimumVelocity: 0.02
    }
  });
  function onTouchStart() {
    if (swiper.params.cssMode) return;
    const translate = swiper.getTranslate();
    swiper.setTranslate(translate);
    swiper.setTransition(0);
    swiper.touchEventsData.velocities.length = 0;
    swiper.freeMode.onTouchEnd({
      currentPos: swiper.rtl ? swiper.translate : -swiper.translate
    });
  }
  function onTouchMove() {
    if (swiper.params.cssMode) return;
    const {
      touchEventsData: data,
      touches
    } = swiper;
    // Velocity
    if (data.velocities.length === 0) {
      data.velocities.push({
        position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
        time: data.touchStartTime
      });
    }
    data.velocities.push({
      position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
      time: now()
    });
  }
  function onTouchEnd({
    currentPos
  }) {
    if (swiper.params.cssMode) return;
    const {
      params,
      wrapperEl,
      rtlTranslate: rtl,
      snapGrid,
      touchEventsData: data
    } = swiper;
    // Time diff
    const touchEndTime = now();
    const timeDiff = touchEndTime - data.touchStartTime;
    if (currentPos < -swiper.minTranslate()) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    if (currentPos > -swiper.maxTranslate()) {
      if (swiper.slides.length < snapGrid.length) {
        swiper.slideTo(snapGrid.length - 1);
      } else {
        swiper.slideTo(swiper.slides.length - 1);
      }
      return;
    }
    if (params.freeMode.momentum) {
      if (data.velocities.length > 1) {
        const lastMoveEvent = data.velocities.pop();
        const velocityEvent = data.velocities.pop();
        const distance = lastMoveEvent.position - velocityEvent.position;
        const time = lastMoveEvent.time - velocityEvent.time;
        swiper.velocity = distance / time;
        swiper.velocity /= 2;
        if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) {
          swiper.velocity = 0;
        }
        // this implies that the user stopped moving a finger then released.
        // There would be no events with distance zero, so the last event is stale.
        if (time > 150 || now() - lastMoveEvent.time > 300) {
          swiper.velocity = 0;
        }
      } else {
        swiper.velocity = 0;
      }
      swiper.velocity *= params.freeMode.momentumVelocityRatio;
      data.velocities.length = 0;
      let momentumDuration = 1000 * params.freeMode.momentumRatio;
      const momentumDistance = swiper.velocity * momentumDuration;
      let newPosition = swiper.translate + momentumDistance;
      if (rtl) newPosition = -newPosition;
      let doBounce = false;
      let afterBouncePosition;
      const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
      let needsLoopFix;
      if (newPosition < swiper.maxTranslate()) {
        if (params.freeMode.momentumBounce) {
          if (newPosition + swiper.maxTranslate() < -bounceAmount) {
            newPosition = swiper.maxTranslate() - bounceAmount;
          }
          afterBouncePosition = swiper.maxTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.maxTranslate();
        }
        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (newPosition > swiper.minTranslate()) {
        if (params.freeMode.momentumBounce) {
          if (newPosition - swiper.minTranslate() > bounceAmount) {
            newPosition = swiper.minTranslate() + bounceAmount;
          }
          afterBouncePosition = swiper.minTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.minTranslate();
        }
        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (params.freeMode.sticky) {
        let nextSlide;
        for (let j = 0; j < snapGrid.length; j += 1) {
          if (snapGrid[j] > -newPosition) {
            nextSlide = j;
            break;
          }
        }
        if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
          newPosition = snapGrid[nextSlide];
        } else {
          newPosition = snapGrid[nextSlide - 1];
        }
        newPosition = -newPosition;
      }
      if (needsLoopFix) {
        once('transitionEnd', () => {
          swiper.loopFix();
        });
      }
      // Fix duration
      if (swiper.velocity !== 0) {
        if (rtl) {
          momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
        } else {
          momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
        }
        if (params.freeMode.sticky) {
          // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
          // event, then durations can be 20+ seconds to slide one (or zero!) slides.
          // It's easy to see this when simulating touch with mouse events. To fix this,
          // limit single-slide swipes to the default slide duration. This also has the
          // nice side effect of matching slide speed if the user stopped moving before
          // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
          // For faster swipes, also apply limits (albeit higher ones).
          const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
          const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
          if (moveDistance < currentSlideSize) {
            momentumDuration = params.speed;
          } else if (moveDistance < 2 * currentSlideSize) {
            momentumDuration = params.speed * 1.5;
          } else {
            momentumDuration = params.speed * 2.5;
          }
        }
      } else if (params.freeMode.sticky) {
        swiper.slideToClosest();
        return;
      }
      if (params.freeMode.momentumBounce && doBounce) {
        swiper.updateProgress(afterBouncePosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);
        swiper.animating = true;
        elementTransitionEnd(wrapperEl, () => {
          if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
          emit('momentumBounce');
          swiper.setTransition(params.speed);
          setTimeout(() => {
            swiper.setTranslate(afterBouncePosition);
            elementTransitionEnd(wrapperEl, () => {
              if (!swiper || swiper.destroyed) return;
              swiper.transitionEnd();
            });
          }, 0);
        });
      } else if (swiper.velocity) {
        emit('_freeModeNoMomentumRelease');
        swiper.updateProgress(newPosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);
        if (!swiper.animating) {
          swiper.animating = true;
          elementTransitionEnd(wrapperEl, () => {
            if (!swiper || swiper.destroyed) return;
            swiper.transitionEnd();
          });
        }
      } else {
        swiper.updateProgress(newPosition);
      }
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    } else if (params.freeMode.sticky) {
      swiper.slideToClosest();
      return;
    } else if (params.freeMode) {
      emit('_freeModeNoMomentumRelease');
    }
    if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
      emit('_freeModeStaticRelease');
      swiper.updateProgress();
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
  }
  Object.assign(swiper, {
    freeMode: {
      onTouchStart,
      onTouchMove,
      onTouchEnd
    }
  });
}



;// CONCATENATED MODULE: ../node_modules/swiper/modules/manipulation.mjs


function appendSlide(slides) {
  const swiper = this;
  const {
    params,
    slidesEl
  } = swiper;
  if (params.loop) {
    swiper.loopDestroy();
  }
  const appendElement = slideEl => {
    if (typeof slideEl === 'string') {
      const tempDOM = document.createElement('div');
      setInnerHTML(tempDOM, slideEl);
      slidesEl.append(tempDOM.children[0]);
      setInnerHTML(tempDOM, '');
    } else {
      slidesEl.append(slideEl);
    }
  };
  if (typeof slides === 'object' && 'length' in slides) {
    for (let i = 0; i < slides.length; i += 1) {
      if (slides[i]) appendElement(slides[i]);
    }
  } else {
    appendElement(slides);
  }
  swiper.recalcSlides();
  if (params.loop) {
    swiper.loopCreate();
  }
  if (!params.observer || swiper.isElement) {
    swiper.update();
  }
}

function prependSlide(slides) {
  const swiper = this;
  const {
    params,
    activeIndex,
    slidesEl
  } = swiper;
  if (params.loop) {
    swiper.loopDestroy();
  }
  let newActiveIndex = activeIndex + 1;
  const prependElement = slideEl => {
    if (typeof slideEl === 'string') {
      const tempDOM = document.createElement('div');
      setInnerHTML(tempDOM, slideEl);
      slidesEl.prepend(tempDOM.children[0]);
      setInnerHTML(tempDOM, '');
    } else {
      slidesEl.prepend(slideEl);
    }
  };
  if (typeof slides === 'object' && 'length' in slides) {
    for (let i = 0; i < slides.length; i += 1) {
      if (slides[i]) prependElement(slides[i]);
    }
    newActiveIndex = activeIndex + slides.length;
  } else {
    prependElement(slides);
  }
  swiper.recalcSlides();
  if (params.loop) {
    swiper.loopCreate();
  }
  if (!params.observer || swiper.isElement) {
    swiper.update();
  }
  swiper.slideTo(newActiveIndex, 0, false);
}

function addSlide(index, slides) {
  const swiper = this;
  const {
    params,
    activeIndex,
    slidesEl
  } = swiper;
  let activeIndexBuffer = activeIndex;
  if (params.loop) {
    activeIndexBuffer -= swiper.loopedSlides;
    swiper.loopDestroy();
    swiper.recalcSlides();
  }
  const baseLength = swiper.slides.length;
  if (index <= 0) {
    swiper.prependSlide(slides);
    return;
  }
  if (index >= baseLength) {
    swiper.appendSlide(slides);
    return;
  }
  let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
  const slidesBuffer = [];
  for (let i = baseLength - 1; i >= index; i -= 1) {
    const currentSlide = swiper.slides[i];
    currentSlide.remove();
    slidesBuffer.unshift(currentSlide);
  }
  if (typeof slides === 'object' && 'length' in slides) {
    for (let i = 0; i < slides.length; i += 1) {
      if (slides[i]) slidesEl.append(slides[i]);
    }
    newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
  } else {
    slidesEl.append(slides);
  }
  for (let i = 0; i < slidesBuffer.length; i += 1) {
    slidesEl.append(slidesBuffer[i]);
  }
  swiper.recalcSlides();
  if (params.loop) {
    swiper.loopCreate();
  }
  if (!params.observer || swiper.isElement) {
    swiper.update();
  }
  if (params.loop) {
    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
  } else {
    swiper.slideTo(newActiveIndex, 0, false);
  }
}

function removeSlide(slidesIndexes) {
  const swiper = this;
  const {
    params,
    activeIndex
  } = swiper;
  let activeIndexBuffer = activeIndex;
  if (params.loop) {
    activeIndexBuffer -= swiper.loopedSlides;
    swiper.loopDestroy();
  }
  let newActiveIndex = activeIndexBuffer;
  let indexToRemove;
  if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
    for (let i = 0; i < slidesIndexes.length; i += 1) {
      indexToRemove = slidesIndexes[i];
      if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
      if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
    }
    newActiveIndex = Math.max(newActiveIndex, 0);
  } else {
    indexToRemove = slidesIndexes;
    if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
    if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
    newActiveIndex = Math.max(newActiveIndex, 0);
  }
  swiper.recalcSlides();
  if (params.loop) {
    swiper.loopCreate();
  }
  if (!params.observer || swiper.isElement) {
    swiper.update();
  }
  if (params.loop) {
    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
  } else {
    swiper.slideTo(newActiveIndex, 0, false);
  }
}

function removeAllSlides() {
  const swiper = this;
  const slidesIndexes = [];
  for (let i = 0; i < swiper.slides.length; i += 1) {
    slidesIndexes.push(i);
  }
  swiper.removeSlide(slidesIndexes);
}

function Manipulation({
  swiper
}) {
  Object.assign(swiper, {
    appendSlide: appendSlide.bind(swiper),
    prependSlide: prependSlide.bind(swiper),
    addSlide: addSlide.bind(swiper),
    removeSlide: removeSlide.bind(swiper),
    removeAllSlides: removeAllSlides.bind(swiper)
  });
}



;// CONCATENATED MODULE: ../node_modules/swiper/shared/effect-init.mjs
function effect_init_effectInit(params) {
  const {
    effect,
    swiper,
    on,
    setTranslate,
    setTransition,
    overwriteParams,
    perspective,
    recreateShadows,
    getEffectParams
  } = params;
  on('beforeInit', () => {
    if (swiper.params.effect !== effect) return;
    swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
    if (perspective && perspective()) {
      swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
    }
    const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
    Object.assign(swiper.params, overwriteParamsResult);
    Object.assign(swiper.originalParams, overwriteParamsResult);
  });
  on('setTranslate _virtualUpdated', () => {
    if (swiper.params.effect !== effect) return;
    setTranslate();
  });
  on('setTransition', (_s, duration) => {
    if (swiper.params.effect !== effect) return;
    setTransition(duration);
  });
  on('transitionEnd', () => {
    if (swiper.params.effect !== effect) return;
    if (recreateShadows) {
      if (!getEffectParams || !getEffectParams().slideShadows) return;
      // remove shadows
      swiper.slides.forEach(slideEl => {
        slideEl.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach(shadowEl => shadowEl.remove());
      });
      // create new one
      recreateShadows();
    }
  });
  let requireUpdateOnVirtual;
  on('virtualUpdate', () => {
    if (swiper.params.effect !== effect) return;
    if (!swiper.slides.length) {
      requireUpdateOnVirtual = true;
    }
    requestAnimationFrame(() => {
      if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
        setTranslate();
        requireUpdateOnVirtual = false;
      }
    });
  });
}



;// CONCATENATED MODULE: ../node_modules/swiper/shared/effect-target.mjs


function effect_target_effectTarget(effectParams, slideEl) {
  const transformEl = (0,utils.g)(slideEl);
  if (transformEl !== slideEl) {
    transformEl.style.backfaceVisibility = 'hidden';
    transformEl.style['-webkit-backface-visibility'] = 'hidden';
  }
  return transformEl;
}



;// CONCATENATED MODULE: ../node_modules/swiper/shared/effect-virtual-transition-end.mjs


function effect_virtual_transition_end_effectVirtualTransitionEnd({
  swiper,
  duration,
  transformElements,
  allSlides
}) {
  const {
    activeIndex
  } = swiper;
  const getSlide = el => {
    if (!el.parentElement) {
      // assume shadow root
      const slide = swiper.slides.find(slideEl => slideEl.shadowRoot && slideEl.shadowRoot === el.parentNode);
      return slide;
    }
    return el.parentElement;
  };
  if (swiper.params.virtualTranslate && duration !== 0) {
    let eventTriggered = false;
    let transitionEndTarget;
    if (allSlides) {
      transitionEndTarget = transformElements;
    } else {
      transitionEndTarget = transformElements.filter(transformEl => {
        const el = transformEl.classList.contains('swiper-slide-transform') ? getSlide(transformEl) : transformEl;
        return swiper.getSlideIndex(el) === activeIndex;
      });
    }
    transitionEndTarget.forEach(el => {
      (0,utils.o)(el, () => {
        if (eventTriggered) return;
        if (!swiper || swiper.destroyed) return;
        eventTriggered = true;
        swiper.animating = false;
        const evt = new window.CustomEvent('transitionend', {
          bubbles: true,
          cancelable: true
        });
        swiper.wrapperEl.dispatchEvent(evt);
      });
    });
  }
}



;// CONCATENATED MODULE: ../node_modules/swiper/modules/effect-fade.mjs





function EffectFade({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    fadeEffect: {
      crossFade: false
    }
  });
  const setTranslate = () => {
    const {
      slides
    } = swiper;
    const params = swiper.params.fadeEffect;
    for (let i = 0; i < slides.length; i += 1) {
      const slideEl = swiper.slides[i];
      const offset = slideEl.swiperSlideOffset;
      let tx = -offset;
      if (!swiper.params.virtualTranslate) tx -= swiper.translate;
      let ty = 0;
      if (!swiper.isHorizontal()) {
        ty = tx;
        tx = 0;
      }
      const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(slideEl.progress), 0) : 1 + Math.min(Math.max(slideEl.progress, -1), 0);
      const targetEl = effect_target_effectTarget(params, slideEl);
      targetEl.style.opacity = slideOpacity;
      targetEl.style.transform = `translate3d(${tx}px, ${ty}px, 0px)`;
    }
  };
  const setTransition = duration => {
    const transformElements = swiper.slides.map(slideEl => (0,utils.g)(slideEl));
    transformElements.forEach(el => {
      el.style.transitionDuration = `${duration}ms`;
    });
    effect_virtual_transition_end_effectVirtualTransitionEnd({
      swiper,
      duration,
      transformElements,
      allSlides: true
    });
  };
  effect_init_effectInit({
    effect: 'fade',
    swiper,
    on,
    setTranslate,
    setTransition,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: true,
      spaceBetween: 0,
      virtualTranslate: !swiper.params.cssMode
    })
  });
}



;// CONCATENATED MODULE: ../node_modules/swiper/modules/effect-cube.mjs



function EffectCube({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    cubeEffect: {
      slideShadows: true,
      shadow: true,
      shadowOffset: 20,
      shadowScale: 0.94
    }
  });
  const createSlideShadows = (slideEl, progress, isHorizontal) => {
    let shadowBefore = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
    let shadowAfter = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
    if (!shadowBefore) {
      shadowBefore = createElement('div', `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? 'left' : 'top'}`.split(' '));
      slideEl.append(shadowBefore);
    }
    if (!shadowAfter) {
      shadowAfter = createElement('div', `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? 'right' : 'bottom'}`.split(' '));
      slideEl.append(shadowAfter);
    }
    if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
    if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
  };
  const recreateShadows = () => {
    // create new ones
    const isHorizontal = swiper.isHorizontal();
    swiper.slides.forEach(slideEl => {
      const progress = Math.max(Math.min(slideEl.progress, 1), -1);
      createSlideShadows(slideEl, progress, isHorizontal);
    });
  };
  const setTranslate = () => {
    const {
      el,
      wrapperEl,
      slides,
      width: swiperWidth,
      height: swiperHeight,
      rtlTranslate: rtl,
      size: swiperSize,
      browser
    } = swiper;
    const r = getRotateFix(swiper);
    const params = swiper.params.cubeEffect;
    const isHorizontal = swiper.isHorizontal();
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let wrapperRotate = 0;
    let cubeShadowEl;
    if (params.shadow) {
      if (isHorizontal) {
        cubeShadowEl = swiper.wrapperEl.querySelector('.swiper-cube-shadow');
        if (!cubeShadowEl) {
          cubeShadowEl = createElement('div', 'swiper-cube-shadow');
          swiper.wrapperEl.append(cubeShadowEl);
        }
        cubeShadowEl.style.height = `${swiperWidth}px`;
      } else {
        cubeShadowEl = el.querySelector('.swiper-cube-shadow');
        if (!cubeShadowEl) {
          cubeShadowEl = createElement('div', 'swiper-cube-shadow');
          el.append(cubeShadowEl);
        }
      }
    }
    for (let i = 0; i < slides.length; i += 1) {
      const slideEl = slides[i];
      let slideIndex = i;
      if (isVirtual) {
        slideIndex = parseInt(slideEl.getAttribute('data-swiper-slide-index'), 10);
      }
      let slideAngle = slideIndex * 90;
      let round = Math.floor(slideAngle / 360);
      if (rtl) {
        slideAngle = -slideAngle;
        round = Math.floor(-slideAngle / 360);
      }
      const progress = Math.max(Math.min(slideEl.progress, 1), -1);
      let tx = 0;
      let ty = 0;
      let tz = 0;
      if (slideIndex % 4 === 0) {
        tx = -round * 4 * swiperSize;
        tz = 0;
      } else if ((slideIndex - 1) % 4 === 0) {
        tx = 0;
        tz = -round * 4 * swiperSize;
      } else if ((slideIndex - 2) % 4 === 0) {
        tx = swiperSize + round * 4 * swiperSize;
        tz = swiperSize;
      } else if ((slideIndex - 3) % 4 === 0) {
        tx = -swiperSize;
        tz = 3 * swiperSize + swiperSize * 4 * round;
      }
      if (rtl) {
        tx = -tx;
      }
      if (!isHorizontal) {
        ty = tx;
        tx = 0;
      }
      const transform = `rotateX(${r(isHorizontal ? 0 : -slideAngle)}deg) rotateY(${r(isHorizontal ? slideAngle : 0)}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
      if (progress <= 1 && progress > -1) {
        wrapperRotate = slideIndex * 90 + progress * 90;
        if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
      }
      slideEl.style.transform = transform;
      if (params.slideShadows) {
        createSlideShadows(slideEl, progress, isHorizontal);
      }
    }
    wrapperEl.style.transformOrigin = `50% 50% -${swiperSize / 2}px`;
    wrapperEl.style['-webkit-transform-origin'] = `50% 50% -${swiperSize / 2}px`;
    if (params.shadow) {
      if (isHorizontal) {
        cubeShadowEl.style.transform = `translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(89.99deg) rotateZ(0deg) scale(${params.shadowScale})`;
      } else {
        const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
        const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
        const scale1 = params.shadowScale;
        const scale2 = params.shadowScale / multiplier;
        const offset = params.shadowOffset;
        cubeShadowEl.style.transform = `scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-89.99deg)`;
      }
    }
    const zFactor = (browser.isSafari || browser.isWebView) && browser.needPerspectiveFix ? -swiperSize / 2 : 0;
    wrapperEl.style.transform = `translate3d(0px,0,${zFactor}px) rotateX(${r(swiper.isHorizontal() ? 0 : wrapperRotate)}deg) rotateY(${r(swiper.isHorizontal() ? -wrapperRotate : 0)}deg)`;
    wrapperEl.style.setProperty('--swiper-cube-translate-z', `${zFactor}px`);
  };
  const setTransition = duration => {
    const {
      el,
      slides
    } = swiper;
    slides.forEach(slideEl => {
      slideEl.style.transitionDuration = `${duration}ms`;
      slideEl.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach(subEl => {
        subEl.style.transitionDuration = `${duration}ms`;
      });
    });
    if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
      const shadowEl = el.querySelector('.swiper-cube-shadow');
      if (shadowEl) shadowEl.style.transitionDuration = `${duration}ms`;
    }
  };
  effectInit({
    effect: 'cube',
    swiper,
    on,
    setTranslate,
    setTransition,
    recreateShadows,
    getEffectParams: () => swiper.params.cubeEffect,
    perspective: () => true,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: true,
      resistanceRatio: 0,
      spaceBetween: 0,
      centeredSlides: false,
      virtualTranslate: true
    })
  });
}



;// CONCATENATED MODULE: ../node_modules/swiper/shared/create-shadow.mjs


function create_shadow_createShadow(suffix, slideEl, side) {
  const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ''}${suffix ? ` swiper-slide-shadow-${suffix}` : ''}`;
  const shadowContainer = getSlideTransformEl(slideEl);
  let shadowEl = shadowContainer.querySelector(`.${shadowClass.split(' ').join('.')}`);
  if (!shadowEl) {
    shadowEl = createElement('div', shadowClass.split(' '));
    shadowContainer.append(shadowEl);
  }
  return shadowEl;
}



;// CONCATENATED MODULE: ../node_modules/swiper/modules/effect-flip.mjs






function EffectFlip({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    flipEffect: {
      slideShadows: true,
      limitRotation: true
    }
  });
  const createSlideShadows = (slideEl, progress) => {
    let shadowBefore = swiper.isHorizontal() ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
    let shadowAfter = swiper.isHorizontal() ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
    if (!shadowBefore) {
      shadowBefore = createShadow('flip', slideEl, swiper.isHorizontal() ? 'left' : 'top');
    }
    if (!shadowAfter) {
      shadowAfter = createShadow('flip', slideEl, swiper.isHorizontal() ? 'right' : 'bottom');
    }
    if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
    if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
  };
  const recreateShadows = () => {
    // Set shadows
    swiper.params.flipEffect;
    swiper.slides.forEach(slideEl => {
      let progress = slideEl.progress;
      if (swiper.params.flipEffect.limitRotation) {
        progress = Math.max(Math.min(slideEl.progress, 1), -1);
      }
      createSlideShadows(slideEl, progress);
    });
  };
  const setTranslate = () => {
    const {
      slides,
      rtlTranslate: rtl
    } = swiper;
    const params = swiper.params.flipEffect;
    const rotateFix = getRotateFix(swiper);
    for (let i = 0; i < slides.length; i += 1) {
      const slideEl = slides[i];
      let progress = slideEl.progress;
      if (swiper.params.flipEffect.limitRotation) {
        progress = Math.max(Math.min(slideEl.progress, 1), -1);
      }
      const offset = slideEl.swiperSlideOffset;
      const rotate = -180 * progress;
      let rotateY = rotate;
      let rotateX = 0;
      let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
      let ty = 0;
      if (!swiper.isHorizontal()) {
        ty = tx;
        tx = 0;
        rotateX = -rotateY;
        rotateY = 0;
      } else if (rtl) {
        rotateY = -rotateY;
      }
      slideEl.style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
      if (params.slideShadows) {
        createSlideShadows(slideEl, progress);
      }
      const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateFix(rotateX)}deg) rotateY(${rotateFix(rotateY)}deg)`;
      const targetEl = effectTarget(params, slideEl);
      targetEl.style.transform = transform;
    }
  };
  const setTransition = duration => {
    const transformElements = swiper.slides.map(slideEl => getSlideTransformEl(slideEl));
    transformElements.forEach(el => {
      el.style.transitionDuration = `${duration}ms`;
      el.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach(shadowEl => {
        shadowEl.style.transitionDuration = `${duration}ms`;
      });
    });
    effectVirtualTransitionEnd({
      swiper,
      duration,
      transformElements
    });
  };
  effectInit({
    effect: 'flip',
    swiper,
    on,
    setTranslate,
    setTransition,
    recreateShadows,
    getEffectParams: () => swiper.params.flipEffect,
    perspective: () => true,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: true,
      spaceBetween: 0,
      virtualTranslate: !swiper.params.cssMode
    })
  });
}



;// CONCATENATED MODULE: ../node_modules/swiper/modules/effect-coverflow.mjs





function EffectCoverflow({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      scale: 1,
      modifier: 1,
      slideShadows: true
    }
  });
  const setTranslate = () => {
    const {
      width: swiperWidth,
      height: swiperHeight,
      slides,
      slidesSizesGrid
    } = swiper;
    const params = swiper.params.coverflowEffect;
    const isHorizontal = swiper.isHorizontal();
    const transform = swiper.translate;
    const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
    const rotate = isHorizontal ? params.rotate : -params.rotate;
    const translate = params.depth;
    const r = getRotateFix(swiper);
    // Each slide offset from center
    for (let i = 0, length = slides.length; i < length; i += 1) {
      const slideEl = slides[i];
      const slideSize = slidesSizesGrid[i];
      const slideOffset = slideEl.swiperSlideOffset;
      const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
      const offsetMultiplier = typeof params.modifier === 'function' ? params.modifier(centerOffset) : centerOffset * params.modifier;
      let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
      let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
      // var rotateZ = 0
      let translateZ = -translate * Math.abs(offsetMultiplier);
      let stretch = params.stretch;
      // Allow percentage to make a relative stretch for responsive sliders
      if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) {
        stretch = parseFloat(params.stretch) / 100 * slideSize;
      }
      let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
      let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
      let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);

      // Fix for ultra small values
      if (Math.abs(translateX) < 0.001) translateX = 0;
      if (Math.abs(translateY) < 0.001) translateY = 0;
      if (Math.abs(translateZ) < 0.001) translateZ = 0;
      if (Math.abs(rotateY) < 0.001) rotateY = 0;
      if (Math.abs(rotateX) < 0.001) rotateX = 0;
      if (Math.abs(scale) < 0.001) scale = 0;
      const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${r(rotateX)}deg) rotateY(${r(rotateY)}deg) scale(${scale})`;
      const targetEl = effectTarget(params, slideEl);
      targetEl.style.transform = slideTransform;
      slideEl.style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
      if (params.slideShadows) {
        // Set shadows
        let shadowBeforeEl = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
        let shadowAfterEl = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
        if (!shadowBeforeEl) {
          shadowBeforeEl = createShadow('coverflow', slideEl, isHorizontal ? 'left' : 'top');
        }
        if (!shadowAfterEl) {
          shadowAfterEl = createShadow('coverflow', slideEl, isHorizontal ? 'right' : 'bottom');
        }
        if (shadowBeforeEl) shadowBeforeEl.style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
        if (shadowAfterEl) shadowAfterEl.style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
      }
    }
  };
  const setTransition = duration => {
    const transformElements = swiper.slides.map(slideEl => getSlideTransformEl(slideEl));
    transformElements.forEach(el => {
      el.style.transitionDuration = `${duration}ms`;
      el.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach(shadowEl => {
        shadowEl.style.transitionDuration = `${duration}ms`;
      });
    });
  };
  effectInit({
    effect: 'coverflow',
    swiper,
    on,
    setTranslate,
    setTransition,
    perspective: () => true,
    overwriteParams: () => ({
      watchSlidesProgress: true
    })
  });
}



;// CONCATENATED MODULE: ../node_modules/swiper/modules/effect-creative.mjs






function EffectCreative({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    creativeEffect: {
      limitProgress: 1,
      shadowPerProgress: false,
      progressMultiplier: 1,
      perspective: true,
      prev: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      },
      next: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      }
    }
  });
  const getTranslateValue = value => {
    if (typeof value === 'string') return value;
    return `${value}px`;
  };
  const setTranslate = () => {
    const {
      slides,
      wrapperEl,
      slidesSizesGrid
    } = swiper;
    const params = swiper.params.creativeEffect;
    const {
      progressMultiplier: multiplier
    } = params;
    const isCenteredSlides = swiper.params.centeredSlides;
    const rotateFix = getRotateFix(swiper);
    if (isCenteredSlides) {
      const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
      wrapperEl.style.transform = `translateX(calc(50% - ${margin}px))`;
    }
    for (let i = 0; i < slides.length; i += 1) {
      const slideEl = slides[i];
      const slideProgress = slideEl.progress;
      const progress = Math.min(Math.max(slideEl.progress, -params.limitProgress), params.limitProgress);
      let originalProgress = progress;
      if (!isCenteredSlides) {
        originalProgress = Math.min(Math.max(slideEl.originalProgress, -params.limitProgress), params.limitProgress);
      }
      const offset = slideEl.swiperSlideOffset;
      const t = [swiper.params.cssMode ? -offset - swiper.translate : -offset, 0, 0];
      const r = [0, 0, 0];
      let custom = false;
      if (!swiper.isHorizontal()) {
        t[1] = t[0];
        t[0] = 0;
      }
      let data = {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        scale: 1,
        opacity: 1
      };
      if (progress < 0) {
        data = params.next;
        custom = true;
      } else if (progress > 0) {
        data = params.prev;
        custom = true;
      }
      // set translate
      t.forEach((value, index) => {
        t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
      });
      // set rotates
      r.forEach((value, index) => {
        let val = data.rotate[index] * Math.abs(progress * multiplier);
        r[index] = val;
      });
      slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
      const translateString = t.join(', ');
      const rotateString = `rotateX(${rotateFix(r[0])}deg) rotateY(${rotateFix(r[1])}deg) rotateZ(${rotateFix(r[2])}deg)`;
      const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
      const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
      const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`;

      // Set shadows
      if (custom && data.shadow || !custom) {
        let shadowEl = slideEl.querySelector('.swiper-slide-shadow');
        if (!shadowEl && data.shadow) {
          shadowEl = createShadow('creative', slideEl);
        }
        if (shadowEl) {
          const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
          shadowEl.style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
        }
      }
      const targetEl = effectTarget(params, slideEl);
      targetEl.style.transform = transform;
      targetEl.style.opacity = opacityString;
      if (data.origin) {
        targetEl.style.transformOrigin = data.origin;
      }
    }
  };
  const setTransition = duration => {
    const transformElements = swiper.slides.map(slideEl => getSlideTransformEl(slideEl));
    transformElements.forEach(el => {
      el.style.transitionDuration = `${duration}ms`;
      el.querySelectorAll('.swiper-slide-shadow').forEach(shadowEl => {
        shadowEl.style.transitionDuration = `${duration}ms`;
      });
    });
    effectVirtualTransitionEnd({
      swiper,
      duration,
      transformElements,
      allSlides: true
    });
  };
  effectInit({
    effect: 'creative',
    swiper,
    on,
    setTranslate,
    setTransition,
    perspective: () => swiper.params.creativeEffect.perspective,
    overwriteParams: () => ({
      watchSlidesProgress: true,
      virtualTranslate: !swiper.params.cssMode
    })
  });
}



;// CONCATENATED MODULE: ../node_modules/swiper/modules/effect-cards.mjs






function EffectCards({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    cardsEffect: {
      slideShadows: true,
      rotate: true,
      perSlideRotate: 2,
      perSlideOffset: 8
    }
  });
  const setTranslate = () => {
    const {
      slides,
      activeIndex,
      rtlTranslate: rtl
    } = swiper;
    const params = swiper.params.cardsEffect;
    const {
      startTranslate,
      isTouched
    } = swiper.touchEventsData;
    const currentTranslate = rtl ? -swiper.translate : swiper.translate;
    for (let i = 0; i < slides.length; i += 1) {
      const slideEl = slides[i];
      const slideProgress = slideEl.progress;
      const progress = Math.min(Math.max(slideProgress, -4), 4);
      let offset = slideEl.swiperSlideOffset;
      if (swiper.params.centeredSlides && !swiper.params.cssMode) {
        swiper.wrapperEl.style.transform = `translateX(${swiper.minTranslate()}px)`;
      }
      if (swiper.params.centeredSlides && swiper.params.cssMode) {
        offset -= slides[0].swiperSlideOffset;
      }
      let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
      let tY = 0;
      const tZ = -100 * Math.abs(progress);
      let scale = 1;
      let rotate = -params.perSlideRotate * progress;
      let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
      const slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
      const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
      const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
      if (isSwipeToNext || isSwipeToPrev) {
        const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
        rotate += -28 * progress * subProgress;
        scale += -0.5 * subProgress;
        tXAdd += 96 * subProgress;
        tY = `${(params.rotate || swiper.isHorizontal() ? -25 : 0) * subProgress * Math.abs(progress)}%`;
      }
      if (progress < 0) {
        // next
        tX = `calc(${tX}px ${rtl ? '-' : '+'} (${tXAdd * Math.abs(progress)}%))`;
      } else if (progress > 0) {
        // prev
        tX = `calc(${tX}px ${rtl ? '-' : '+'} (-${tXAdd * Math.abs(progress)}%))`;
      } else {
        tX = `${tX}px`;
      }
      if (!swiper.isHorizontal()) {
        const prevY = tY;
        tY = tX;
        tX = prevY;
      }
      const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;

      /* eslint-disable */
      const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rtl ? -rotate : rotate : 0}deg)
        scale(${scaleString})
      `;
      /* eslint-enable */

      if (params.slideShadows) {
        // Set shadows
        let shadowEl = slideEl.querySelector('.swiper-slide-shadow');
        if (!shadowEl) {
          shadowEl = createShadow('cards', slideEl);
        }
        if (shadowEl) shadowEl.style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
      }
      slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
      const targetEl = effectTarget(params, slideEl);
      targetEl.style.transform = transform;
    }
  };
  const setTransition = duration => {
    const transformElements = swiper.slides.map(slideEl => getSlideTransformEl(slideEl));
    transformElements.forEach(el => {
      el.style.transitionDuration = `${duration}ms`;
      el.querySelectorAll('.swiper-slide-shadow').forEach(shadowEl => {
        shadowEl.style.transitionDuration = `${duration}ms`;
      });
    });
    effectVirtualTransitionEnd({
      swiper,
      duration,
      transformElements
    });
  };
  effectInit({
    effect: 'cards',
    swiper,
    on,
    setTranslate,
    setTransition,
    perspective: () => true,
    overwriteParams: () => ({
      _loopSwapReset: false,
      watchSlidesProgress: true,
      loopAdditionalSlides: swiper.params.cardsEffect.rotate ? 3 : 2,
      centeredSlides: true,
      virtualTranslate: !swiper.params.cssMode
    })
  });
}



;// CONCATENATED MODULE: ../node_modules/swiper/modules/index.mjs
























/***/ }),

/***/ 2882:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ getWindow; },
/* harmony export */   "g": function() { return /* binding */ getDocument; }
/* harmony export */ });
/**
 * SSR Window 5.0.1
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2025, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: June 27, 2025
 */
/* eslint-disable no-param-reassign */
function isObject(obj) {
  return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
}
function extend(target = {}, src = {}) {
  const noExtend = ['__proto__', 'constructor', 'prototype'];
  Object.keys(src).filter(key => noExtend.indexOf(key) < 0).forEach(key => {
    if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
      extend(target[key], src[key]);
    }
  });
}
const ssrDocument = {
  body: {},
  addEventListener() {},
  removeEventListener() {},
  activeElement: {
    blur() {},
    nodeName: ''
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {}
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {},
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: '',
    host: '',
    hostname: '',
    href: '',
    origin: '',
    pathname: '',
    protocol: '',
    search: ''
  }
};
function getDocument() {
  const doc = typeof document !== 'undefined' ? document : {};
  extend(doc, ssrDocument);
  return doc;
}
const ssrWindow = {
  document: ssrDocument,
  navigator: {
    userAgent: ''
  },
  location: {
    hash: '',
    host: '',
    hostname: '',
    href: '',
    origin: '',
    pathname: '',
    protocol: '',
    search: ''
  },
  history: {
    replaceState() {},
    pushState() {},
    go() {},
    back() {}
  },
  CustomEvent: function CustomEvent() {
    return this;
  },
  addEventListener() {},
  removeEventListener() {},
  getComputedStyle() {
    return {
      getPropertyValue() {
        return '';
      }
    };
  },
  Image() {},
  Date() {},
  screen: {},
  setTimeout() {},
  clearTimeout() {},
  matchMedia() {
    return {};
  },
  requestAnimationFrame(callback) {
    if (typeof setTimeout === 'undefined') {
      callback();
      return null;
    }
    return setTimeout(callback, 0);
  },
  cancelAnimationFrame(id) {
    if (typeof setTimeout === 'undefined') {
      return;
    }
    clearTimeout(id);
  }
};
function getWindow() {
  const win = typeof window !== 'undefined' ? window : {};
  extend(win, ssrWindow);
  return win;
}




/***/ }),

/***/ 1691:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ setCSSProperty; },
/* harmony export */   "c": function() { return /* binding */ createElement; },
/* harmony export */   "d": function() { return /* binding */ elementParents; },
/* harmony export */   "e": function() { return /* binding */ elementChildren; },
/* harmony export */   "g": function() { return /* binding */ getSlideTransformEl; },
/* harmony export */   "h": function() { return /* binding */ now; },
/* harmony export */   "i": function() { return /* binding */ elementOuterSize; },
/* harmony export */   "j": function() { return /* binding */ elementIndex; },
/* harmony export */   "l": function() { return /* binding */ getTranslate; },
/* harmony export */   "m": function() { return /* binding */ makeElementsArray; },
/* harmony export */   "n": function() { return /* binding */ nextTick; },
/* harmony export */   "o": function() { return /* binding */ elementTransitionEnd; },
/* harmony export */   "p": function() { return /* binding */ isObject; },
/* harmony export */   "q": function() { return /* binding */ elementStyle; },
/* harmony export */   "r": function() { return /* binding */ elementNextAll; },
/* harmony export */   "s": function() { return /* binding */ setInnerHTML; },
/* harmony export */   "t": function() { return /* binding */ elementPrevAll; },
/* harmony export */   "u": function() { return /* binding */ animateCSSModeScroll; },
/* harmony export */   "v": function() { return /* binding */ showWarning; },
/* harmony export */   "w": function() { return /* binding */ elementIsChildOf; },
/* harmony export */   "x": function() { return /* binding */ extend; },
/* harmony export */   "y": function() { return /* binding */ deleteProps; }
/* harmony export */ });
/* unused harmony exports a, f, k */
/* harmony import */ var _ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2882);


function classesToTokens(classes = '') {
  return classes.trim().split(' ').filter(c => !!c.trim());
}

function deleteProps(obj) {
  const object = obj;
  Object.keys(object).forEach(key => {
    try {
      object[key] = null;
    } catch (e) {
      // no getter for object
    }
    try {
      delete object[key];
    } catch (e) {
      // something got wrong
    }
  });
}
function nextTick(callback, delay = 0) {
  return setTimeout(callback, delay);
}
function now() {
  return Date.now();
}
function getComputedStyle(el) {
  const window = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
  let style;
  if (window.getComputedStyle) {
    style = window.getComputedStyle(el, null);
  }
  if (!style && el.currentStyle) {
    style = el.currentStyle;
  }
  if (!style) {
    style = el.style;
  }
  return style;
}
function getTranslate(el, axis = 'x') {
  const window = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
  let matrix;
  let curTransform;
  let transformMatrix;
  const curStyle = getComputedStyle(el);
  if (window.WebKitCSSMatrix) {
    curTransform = curStyle.transform || curStyle.webkitTransform;
    if (curTransform.split(',').length > 6) {
      curTransform = curTransform.split(', ').map(a => a.replace(',', '.')).join(', ');
    }
    // Some old versions of Webkit choke when 'none' is passed; pass
    // empty string instead in this case
    transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
  } else {
    transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
    matrix = transformMatrix.toString().split(',');
  }
  if (axis === 'x') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m41;
    // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
    // Normal Browsers
    else curTransform = parseFloat(matrix[4]);
  }
  if (axis === 'y') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m42;
    // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
    // Normal Browsers
    else curTransform = parseFloat(matrix[5]);
  }
  return curTransform || 0;
}
function isObject(o) {
  return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}
function isNode(node) {
  // eslint-disable-next-line
  if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') {
    return node instanceof HTMLElement;
  }
  return node && (node.nodeType === 1 || node.nodeType === 11);
}
function extend(...args) {
  const to = Object(args[0]);
  const noExtend = ['__proto__', 'constructor', 'prototype'];
  for (let i = 1; i < args.length; i += 1) {
    const nextSource = args[i];
    if (nextSource !== undefined && nextSource !== null && !isNode(nextSource)) {
      const keysArray = Object.keys(Object(nextSource)).filter(key => noExtend.indexOf(key) < 0);
      for (let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
        const nextKey = keysArray[nextIndex];
        const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
        if (desc !== undefined && desc.enumerable) {
          if (isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend(to[nextKey], nextSource[nextKey]);
            }
          } else if (!isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
            to[nextKey] = {};
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend(to[nextKey], nextSource[nextKey]);
            }
          } else {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
  }
  return to;
}
function setCSSProperty(el, varName, varValue) {
  el.style.setProperty(varName, varValue);
}
function animateCSSModeScroll({
  swiper,
  targetPosition,
  side
}) {
  const window = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
  const startPosition = -swiper.translate;
  let startTime = null;
  let time;
  const duration = swiper.params.speed;
  swiper.wrapperEl.style.scrollSnapType = 'none';
  window.cancelAnimationFrame(swiper.cssModeFrameID);
  const dir = targetPosition > startPosition ? 'next' : 'prev';
  const isOutOfBound = (current, target) => {
    return dir === 'next' && current >= target || dir === 'prev' && current <= target;
  };
  const animate = () => {
    time = new Date().getTime();
    if (startTime === null) {
      startTime = time;
    }
    const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
    const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
    let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
    if (isOutOfBound(currentPosition, targetPosition)) {
      currentPosition = targetPosition;
    }
    swiper.wrapperEl.scrollTo({
      [side]: currentPosition
    });
    if (isOutOfBound(currentPosition, targetPosition)) {
      swiper.wrapperEl.style.overflow = 'hidden';
      swiper.wrapperEl.style.scrollSnapType = '';
      setTimeout(() => {
        swiper.wrapperEl.style.overflow = '';
        swiper.wrapperEl.scrollTo({
          [side]: currentPosition
        });
      });
      window.cancelAnimationFrame(swiper.cssModeFrameID);
      return;
    }
    swiper.cssModeFrameID = window.requestAnimationFrame(animate);
  };
  animate();
}
function getSlideTransformEl(slideEl) {
  return slideEl.querySelector('.swiper-slide-transform') || slideEl.shadowRoot && slideEl.shadowRoot.querySelector('.swiper-slide-transform') || slideEl;
}
function elementChildren(element, selector = '') {
  const window = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
  const children = [...element.children];
  if (window.HTMLSlotElement && element instanceof HTMLSlotElement) {
    children.push(...element.assignedElements());
  }
  if (!selector) {
    return children;
  }
  return children.filter(el => el.matches(selector));
}
function elementIsChildOfSlot(el, slot) {
  // Breadth-first search through all parent's children and assigned elements
  const elementsQueue = [slot];
  while (elementsQueue.length > 0) {
    const elementToCheck = elementsQueue.shift();
    if (el === elementToCheck) {
      return true;
    }
    elementsQueue.push(...elementToCheck.children, ...(elementToCheck.shadowRoot ? elementToCheck.shadowRoot.children : []), ...(elementToCheck.assignedElements ? elementToCheck.assignedElements() : []));
  }
}
function elementIsChildOf(el, parent) {
  const window = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
  let isChild = parent.contains(el);
  if (!isChild && window.HTMLSlotElement && parent instanceof HTMLSlotElement) {
    const children = [...parent.assignedElements()];
    isChild = children.includes(el);
    if (!isChild) {
      isChild = elementIsChildOfSlot(el, parent);
    }
  }
  return isChild;
}
function showWarning(text) {
  try {
    console.warn(text);
    return;
  } catch (err) {
    // err
  }
}
function createElement(tag, classes = []) {
  const el = document.createElement(tag);
  el.classList.add(...(Array.isArray(classes) ? classes : classesToTokens(classes)));
  return el;
}
function elementOffset(el) {
  const window = getWindow();
  const document = getDocument();
  const box = el.getBoundingClientRect();
  const body = document.body;
  const clientTop = el.clientTop || body.clientTop || 0;
  const clientLeft = el.clientLeft || body.clientLeft || 0;
  const scrollTop = el === window ? window.scrollY : el.scrollTop;
  const scrollLeft = el === window ? window.scrollX : el.scrollLeft;
  return {
    top: box.top + scrollTop - clientTop,
    left: box.left + scrollLeft - clientLeft
  };
}
function elementPrevAll(el, selector) {
  const prevEls = [];
  while (el.previousElementSibling) {
    const prev = el.previousElementSibling; // eslint-disable-line
    if (selector) {
      if (prev.matches(selector)) prevEls.push(prev);
    } else prevEls.push(prev);
    el = prev;
  }
  return prevEls;
}
function elementNextAll(el, selector) {
  const nextEls = [];
  while (el.nextElementSibling) {
    const next = el.nextElementSibling; // eslint-disable-line
    if (selector) {
      if (next.matches(selector)) nextEls.push(next);
    } else nextEls.push(next);
    el = next;
  }
  return nextEls;
}
function elementStyle(el, prop) {
  const window = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
  return window.getComputedStyle(el, null).getPropertyValue(prop);
}
function elementIndex(el) {
  let child = el;
  let i;
  if (child) {
    i = 0;
    // eslint-disable-next-line
    while ((child = child.previousSibling) !== null) {
      if (child.nodeType === 1) i += 1;
    }
    return i;
  }
  return undefined;
}
function elementParents(el, selector) {
  const parents = []; // eslint-disable-line
  let parent = el.parentElement; // eslint-disable-line
  while (parent) {
    if (selector) {
      if (parent.matches(selector)) parents.push(parent);
    } else {
      parents.push(parent);
    }
    parent = parent.parentElement;
  }
  return parents;
}
function elementTransitionEnd(el, callback) {
  function fireCallBack(e) {
    if (e.target !== el) return;
    callback.call(el, e);
    el.removeEventListener('transitionend', fireCallBack);
  }
  if (callback) {
    el.addEventListener('transitionend', fireCallBack);
  }
}
function elementOuterSize(el, size, includeMargins) {
  const window = (0,_ssr_window_esm_mjs__WEBPACK_IMPORTED_MODULE_0__.a)();
  if (includeMargins) {
    return el[size === 'width' ? 'offsetWidth' : 'offsetHeight'] + parseFloat(window.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-right' : 'margin-top')) + parseFloat(window.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-left' : 'margin-bottom'));
  }
  return el.offsetWidth;
}
function makeElementsArray(el) {
  return (Array.isArray(el) ? el : [el]).filter(e => !!e);
}
function getRotateFix(swiper) {
  return v => {
    if (Math.abs(v) > 0 && swiper.browser && swiper.browser.need3dFix && Math.abs(v) % 90 === 0) {
      return v + 0.001;
    }
    return v;
  };
}
function setInnerHTML(el, html = '') {
  if (typeof trustedTypes !== 'undefined') {
    el.innerHTML = trustedTypes.createPolicy('html', {
      createHTML: s => s
    }).createHTML(html);
  } else {
    el.innerHTML = html;
  }
}




/***/ }),

/***/ 5509:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "tq": function() { return /* binding */ swiper_react_Swiper; },
  "o5": function() { return /* binding */ SwiperSlide; }
});

// UNUSED EXPORTS: useSwiper, useSwiperSlide

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../node_modules/swiper/shared/ssr-window.esm.mjs
var ssr_window_esm = __webpack_require__(2882);
// EXTERNAL MODULE: ../node_modules/swiper/shared/utils.mjs
var utils = __webpack_require__(1691);
;// CONCATENATED MODULE: ../node_modules/swiper/shared/swiper-core.mjs



let support;
function calcSupport() {
  const window = (0,ssr_window_esm.a)();
  const document = (0,ssr_window_esm.g)();
  return {
    smoothScroll: document.documentElement && document.documentElement.style && 'scrollBehavior' in document.documentElement.style,
    touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch)
  };
}
function getSupport() {
  if (!support) {
    support = calcSupport();
  }
  return support;
}

let deviceCached;
function calcDevice({
  userAgent
} = {}) {
  const support = getSupport();
  const window = (0,ssr_window_esm.a)();
  const platform = window.navigator.platform;
  const ua = userAgent || window.navigator.userAgent;
  const device = {
    ios: false,
    android: false
  };
  const screenWidth = window.screen.width;
  const screenHeight = window.screen.height;
  const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
  let ipad = ua.match(/(iPad)(?!\1).*OS\s([\d_]+)/);
  const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
  const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
  const windows = platform === 'Win32';
  let macos = platform === 'MacIntel';

  // iPadOs 13 fix
  const iPadScreens = ['1024x1366', '1366x1024', '834x1194', '1194x834', '834x1112', '1112x834', '768x1024', '1024x768', '820x1180', '1180x820', '810x1080', '1080x810'];
  if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
    ipad = ua.match(/(Version)\/([\d.]+)/);
    if (!ipad) ipad = [0, 1, '13_0_0'];
    macos = false;
  }

  // Android
  if (android && !windows) {
    device.os = 'android';
    device.android = true;
  }
  if (ipad || iphone || ipod) {
    device.os = 'ios';
    device.ios = true;
  }

  // Export object
  return device;
}
function getDevice(overrides = {}) {
  if (!deviceCached) {
    deviceCached = calcDevice(overrides);
  }
  return deviceCached;
}

let browser;
function calcBrowser() {
  const window = (0,ssr_window_esm.a)();
  const device = getDevice();
  let needPerspectiveFix = false;
  function isSafari() {
    const ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
  }
  if (isSafari()) {
    const ua = String(window.navigator.userAgent);
    if (ua.includes('Version/')) {
      const [major, minor] = ua.split('Version/')[1].split(' ')[0].split('.').map(num => Number(num));
      needPerspectiveFix = major < 16 || major === 16 && minor < 2;
    }
  }
  const isWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent);
  const isSafariBrowser = isSafari();
  const need3dFix = isSafariBrowser || isWebView && device.ios;
  return {
    isSafari: needPerspectiveFix || isSafariBrowser,
    needPerspectiveFix,
    need3dFix,
    isWebView
  };
}
function getBrowser() {
  if (!browser) {
    browser = calcBrowser();
  }
  return browser;
}

function Resize({
  swiper,
  on,
  emit
}) {
  const window = (0,ssr_window_esm.a)();
  let observer = null;
  let animationFrame = null;
  const resizeHandler = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    emit('beforeResize');
    emit('resize');
  };
  const createObserver = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    observer = new ResizeObserver(entries => {
      animationFrame = window.requestAnimationFrame(() => {
        const {
          width,
          height
        } = swiper;
        let newWidth = width;
        let newHeight = height;
        entries.forEach(({
          contentBoxSize,
          contentRect,
          target
        }) => {
          if (target && target !== swiper.el) return;
          newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
          newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
        });
        if (newWidth !== width || newHeight !== height) {
          resizeHandler();
        }
      });
    });
    observer.observe(swiper.el);
  };
  const removeObserver = () => {
    if (animationFrame) {
      window.cancelAnimationFrame(animationFrame);
    }
    if (observer && observer.unobserve && swiper.el) {
      observer.unobserve(swiper.el);
      observer = null;
    }
  };
  const orientationChangeHandler = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    emit('orientationchange');
  };
  on('init', () => {
    if (swiper.params.resizeObserver && typeof window.ResizeObserver !== 'undefined') {
      createObserver();
      return;
    }
    window.addEventListener('resize', resizeHandler);
    window.addEventListener('orientationchange', orientationChangeHandler);
  });
  on('destroy', () => {
    removeObserver();
    window.removeEventListener('resize', resizeHandler);
    window.removeEventListener('orientationchange', orientationChangeHandler);
  });
}

function Observer({
  swiper,
  extendParams,
  on,
  emit
}) {
  const observers = [];
  const window = (0,ssr_window_esm.a)();
  const attach = (target, options = {}) => {
    const ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
    const observer = new ObserverFunc(mutations => {
      // The observerUpdate event should only be triggered
      // once despite the number of mutations.  Additional
      // triggers are redundant and are very costly
      if (swiper.__preventObserver__) return;
      if (mutations.length === 1) {
        emit('observerUpdate', mutations[0]);
        return;
      }
      const observerUpdate = function observerUpdate() {
        emit('observerUpdate', mutations[0]);
      };
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(observerUpdate);
      } else {
        window.setTimeout(observerUpdate, 0);
      }
    });
    observer.observe(target, {
      attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
      childList: swiper.isElement || (typeof options.childList === 'undefined' ? true : options).childList,
      characterData: typeof options.characterData === 'undefined' ? true : options.characterData
    });
    observers.push(observer);
  };
  const init = () => {
    if (!swiper.params.observer) return;
    if (swiper.params.observeParents) {
      const containerParents = (0,utils.d)(swiper.hostEl);
      for (let i = 0; i < containerParents.length; i += 1) {
        attach(containerParents[i]);
      }
    }
    // Observe container
    attach(swiper.hostEl, {
      childList: swiper.params.observeSlideChildren
    });

    // Observe wrapper
    attach(swiper.wrapperEl, {
      attributes: false
    });
  };
  const destroy = () => {
    observers.forEach(observer => {
      observer.disconnect();
    });
    observers.splice(0, observers.length);
  };
  extendParams({
    observer: false,
    observeParents: false,
    observeSlideChildren: false
  });
  on('init', init);
  on('destroy', destroy);
}

/* eslint-disable no-underscore-dangle */

var eventsEmitter = {
  on(events, handler, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;
    const method = priority ? 'unshift' : 'push';
    events.split(' ').forEach(event => {
      if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
      self.eventsListeners[event][method](handler);
    });
    return self;
  },
  once(events, handler, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;
    function onceHandler(...args) {
      self.off(events, onceHandler);
      if (onceHandler.__emitterProxy) {
        delete onceHandler.__emitterProxy;
      }
      handler.apply(self, args);
    }
    onceHandler.__emitterProxy = handler;
    return self.on(events, onceHandler, priority);
  },
  onAny(handler, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;
    const method = priority ? 'unshift' : 'push';
    if (self.eventsAnyListeners.indexOf(handler) < 0) {
      self.eventsAnyListeners[method](handler);
    }
    return self;
  },
  offAny(handler) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsAnyListeners) return self;
    const index = self.eventsAnyListeners.indexOf(handler);
    if (index >= 0) {
      self.eventsAnyListeners.splice(index, 1);
    }
    return self;
  },
  off(events, handler) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsListeners) return self;
    events.split(' ').forEach(event => {
      if (typeof handler === 'undefined') {
        self.eventsListeners[event] = [];
      } else if (self.eventsListeners[event]) {
        self.eventsListeners[event].forEach((eventHandler, index) => {
          if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
            self.eventsListeners[event].splice(index, 1);
          }
        });
      }
    });
    return self;
  },
  emit(...args) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsListeners) return self;
    let events;
    let data;
    let context;
    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
      events = args[0];
      data = args.slice(1, args.length);
      context = self;
    } else {
      events = args[0].events;
      data = args[0].data;
      context = args[0].context || self;
    }
    data.unshift(context);
    const eventsArray = Array.isArray(events) ? events : events.split(' ');
    eventsArray.forEach(event => {
      if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
        self.eventsAnyListeners.forEach(eventHandler => {
          eventHandler.apply(context, [event, ...data]);
        });
      }
      if (self.eventsListeners && self.eventsListeners[event]) {
        self.eventsListeners[event].forEach(eventHandler => {
          eventHandler.apply(context, data);
        });
      }
    });
    return self;
  }
};

function updateSize() {
  const swiper = this;
  let width;
  let height;
  const el = swiper.el;
  if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) {
    width = swiper.params.width;
  } else {
    width = el.clientWidth;
  }
  if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) {
    height = swiper.params.height;
  } else {
    height = el.clientHeight;
  }
  if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
    return;
  }

  // Subtract paddings
  width = width - parseInt((0,utils.q)(el, 'padding-left') || 0, 10) - parseInt((0,utils.q)(el, 'padding-right') || 0, 10);
  height = height - parseInt((0,utils.q)(el, 'padding-top') || 0, 10) - parseInt((0,utils.q)(el, 'padding-bottom') || 0, 10);
  if (Number.isNaN(width)) width = 0;
  if (Number.isNaN(height)) height = 0;
  Object.assign(swiper, {
    width,
    height,
    size: swiper.isHorizontal() ? width : height
  });
}

function updateSlides() {
  const swiper = this;
  function getDirectionPropertyValue(node, label) {
    return parseFloat(node.getPropertyValue(swiper.getDirectionLabel(label)) || 0);
  }
  const params = swiper.params;
  const {
    wrapperEl,
    slidesEl,
    rtlTranslate: rtl,
    wrongRTL
  } = swiper;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
  const slides = (0,utils.e)(slidesEl, `.${swiper.params.slideClass}, swiper-slide`);
  const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
  let snapGrid = [];
  const slidesGrid = [];
  const slidesSizesGrid = [];
  let offsetBefore = params.slidesOffsetBefore;
  if (typeof offsetBefore === 'function') {
    offsetBefore = params.slidesOffsetBefore.call(swiper);
  }
  let offsetAfter = params.slidesOffsetAfter;
  if (typeof offsetAfter === 'function') {
    offsetAfter = params.slidesOffsetAfter.call(swiper);
  }
  const previousSnapGridLength = swiper.snapGrid.length;
  const previousSlidesGridLength = swiper.slidesGrid.length;
  const swiperSize = swiper.size - offsetBefore - offsetAfter;
  let spaceBetween = params.spaceBetween;
  let slidePosition = -offsetBefore;
  let prevSlideSize = 0;
  let index = 0;
  if (typeof swiperSize === 'undefined') {
    return;
  }
  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
  } else if (typeof spaceBetween === 'string') {
    spaceBetween = parseFloat(spaceBetween);
  }
  swiper.virtualSize = -spaceBetween - offsetBefore - offsetAfter;

  // reset margins
  slides.forEach(slideEl => {
    if (rtl) {
      slideEl.style.marginLeft = '';
    } else {
      slideEl.style.marginRight = '';
    }
    slideEl.style.marginBottom = '';
    slideEl.style.marginTop = '';
  });

  // reset cssMode offsets
  if (params.centeredSlides && params.cssMode) {
    (0,utils.b)(wrapperEl, '--swiper-centered-offset-before', '');
    (0,utils.b)(wrapperEl, '--swiper-centered-offset-after', '');
  }

  // set cssMode offsets
  if (params.cssMode) {
    (0,utils.b)(wrapperEl, '--swiper-slides-offset-before', `${offsetBefore}px`);
    (0,utils.b)(wrapperEl, '--swiper-slides-offset-after', `${offsetAfter}px`);
  }
  const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
  if (gridEnabled) {
    swiper.grid.initSlides(slides);
  } else if (swiper.grid) {
    swiper.grid.unsetSlides();
  }

  // Calc slides
  let slideSize;
  const shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter(key => {
    return typeof params.breakpoints[key].slidesPerView !== 'undefined';
  }).length > 0;
  for (let i = 0; i < slidesLength; i += 1) {
    slideSize = 0;
    const slide = slides[i];
    if (slide) {
      if (gridEnabled) {
        swiper.grid.updateSlide(i, slide, slides);
      }
      if ((0,utils.q)(slide, 'display') === 'none') continue; // eslint-disable-line
    }

    if (isVirtual && params.slidesPerView === 'auto') {
      if (params.virtual.slidesPerViewAutoSlideSize) {
        slideSize = params.virtual.slidesPerViewAutoSlideSize;
      }
      if (slideSize && slide) {
        if (params.roundLengths) slideSize = Math.floor(slideSize);
        slide.style[swiper.getDirectionLabel('width')] = `${slideSize}px`;
      }
    } else if (params.slidesPerView === 'auto') {
      if (shouldResetSlideSize) {
        slide.style[swiper.getDirectionLabel('width')] = ``;
      }
      const slideStyles = getComputedStyle(slide);
      const currentTransform = slide.style.transform;
      const currentWebKitTransform = slide.style.webkitTransform;
      if (currentTransform) {
        slide.style.transform = 'none';
      }
      if (currentWebKitTransform) {
        slide.style.webkitTransform = 'none';
      }
      if (params.roundLengths) {
        slideSize = swiper.isHorizontal() ? (0,utils.i)(slide, 'width', true) : (0,utils.i)(slide, 'height', true);
      } else {
        // eslint-disable-next-line
        const width = getDirectionPropertyValue(slideStyles, 'width');
        const paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
        const paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
        const marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
        const marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
        const boxSizing = slideStyles.getPropertyValue('box-sizing');
        if (boxSizing && boxSizing === 'border-box') {
          slideSize = width + marginLeft + marginRight;
        } else {
          const {
            clientWidth,
            offsetWidth
          } = slide;
          slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
        }
      }
      if (currentTransform) {
        slide.style.transform = currentTransform;
      }
      if (currentWebKitTransform) {
        slide.style.webkitTransform = currentWebKitTransform;
      }
      if (params.roundLengths) slideSize = Math.floor(slideSize);
    } else {
      slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
      if (params.roundLengths) slideSize = Math.floor(slideSize);
      if (slide) {
        slide.style[swiper.getDirectionLabel('width')] = `${slideSize}px`;
      }
    }
    if (slide) {
      slide.swiperSlideSize = slideSize;
    }
    slidesSizesGrid.push(slideSize);
    if (params.centeredSlides) {
      slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
      if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
    } else {
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
      slidePosition = slidePosition + slideSize + spaceBetween;
    }
    swiper.virtualSize += slideSize + spaceBetween;
    prevSlideSize = slideSize;
    index += 1;
  }
  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
  if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
    wrapperEl.style.width = `${swiper.virtualSize + spaceBetween}px`;
  }
  if (params.setWrapperSize) {
    wrapperEl.style[swiper.getDirectionLabel('width')] = `${swiper.virtualSize + spaceBetween}px`;
  }
  if (gridEnabled) {
    swiper.grid.updateWrapperSize(slideSize, snapGrid);
  }

  // Remove last grid elements depending on width
  if (!params.centeredSlides) {
    // Check if snapToSlideEdge should be applied
    const isFractionalSlidesPerView = params.slidesPerView !== 'auto' && params.slidesPerView % 1 !== 0;
    const shouldSnapToSlideEdge = params.snapToSlideEdge && !params.loop && (params.slidesPerView === 'auto' || isFractionalSlidesPerView);

    // Calculate the last allowed snap index when snapToSlideEdge is enabled
    // This ensures minimum slides are visible at the end
    let lastAllowedSnapIndex = snapGrid.length;
    if (shouldSnapToSlideEdge) {
      let minVisibleSlides;
      if (params.slidesPerView === 'auto') {
        // For 'auto' mode, calculate how many slides fit based on actual sizes
        minVisibleSlides = 1;
        let accumulatedSize = 0;
        for (let i = slidesSizesGrid.length - 1; i >= 0; i -= 1) {
          accumulatedSize += slidesSizesGrid[i] + (i < slidesSizesGrid.length - 1 ? spaceBetween : 0);
          if (accumulatedSize <= swiperSize) {
            minVisibleSlides = slidesSizesGrid.length - i;
          } else {
            break;
          }
        }
      } else {
        minVisibleSlides = Math.floor(params.slidesPerView);
      }
      lastAllowedSnapIndex = Math.max(slidesLength - minVisibleSlides, 0);
    }
    const newSlidesGrid = [];
    for (let i = 0; i < snapGrid.length; i += 1) {
      let slidesGridItem = snapGrid[i];
      if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
      if (shouldSnapToSlideEdge) {
        // When snapToSlideEdge is enabled, only keep snaps up to lastAllowedSnapIndex
        if (i <= lastAllowedSnapIndex) {
          newSlidesGrid.push(slidesGridItem);
        }
      } else if (snapGrid[i] <= swiper.virtualSize - swiperSize) {
        // When snapToSlideEdge is disabled, keep snaps that fit within scrollable area
        newSlidesGrid.push(slidesGridItem);
      }
    }
    snapGrid = newSlidesGrid;
    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
      // Only add edge-aligned snap if snapToSlideEdge is not enabled
      if (!shouldSnapToSlideEdge) {
        snapGrid.push(swiper.virtualSize - swiperSize);
      }
    }
  }
  if (isVirtual && params.loop) {
    const size = slidesSizesGrid[0] + spaceBetween;
    if (params.slidesPerGroup > 1) {
      const groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
      const groupSize = size * params.slidesPerGroup;
      for (let i = 0; i < groups; i += 1) {
        snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
      }
    }
    for (let i = 0; i < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i += 1) {
      if (params.slidesPerGroup === 1) {
        snapGrid.push(snapGrid[snapGrid.length - 1] + size);
      }
      slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
      swiper.virtualSize += size;
    }
  }
  if (snapGrid.length === 0) snapGrid = [0];
  if (spaceBetween !== 0) {
    const key = swiper.isHorizontal() && rtl ? 'marginLeft' : swiper.getDirectionLabel('marginRight');
    slides.filter((_, slideIndex) => {
      if (!params.cssMode || params.loop) return true;
      if (slideIndex === slides.length - 1) {
        return false;
      }
      return true;
    }).forEach(slideEl => {
      slideEl.style[key] = `${spaceBetween}px`;
    });
  }
  if (params.centeredSlides && params.centeredSlidesBounds) {
    let allSlidesSize = 0;
    slidesSizesGrid.forEach(slideSizeValue => {
      allSlidesSize += slideSizeValue + (spaceBetween || 0);
    });
    allSlidesSize -= spaceBetween;
    const maxSnap = allSlidesSize > swiperSize ? allSlidesSize - swiperSize : 0;
    snapGrid = snapGrid.map(snap => {
      if (snap <= 0) return -offsetBefore;
      if (snap > maxSnap) return maxSnap + offsetAfter;
      return snap;
    });
  }
  if (params.centerInsufficientSlides) {
    let allSlidesSize = 0;
    slidesSizesGrid.forEach(slideSizeValue => {
      allSlidesSize += slideSizeValue + (spaceBetween || 0);
    });
    allSlidesSize -= spaceBetween;
    const offsetSize = (offsetBefore || 0) + (offsetAfter || 0);
    if (allSlidesSize + offsetSize < swiperSize) {
      const allSlidesOffset = (swiperSize - allSlidesSize - offsetSize) / 2;
      snapGrid.forEach((snap, snapIndex) => {
        snapGrid[snapIndex] = snap - allSlidesOffset;
      });
      slidesGrid.forEach((snap, snapIndex) => {
        slidesGrid[snapIndex] = snap + allSlidesOffset;
      });
    }
  }
  Object.assign(swiper, {
    slides,
    snapGrid,
    slidesGrid,
    slidesSizesGrid
  });
  if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
    (0,utils.b)(wrapperEl, '--swiper-centered-offset-before', `${-snapGrid[0]}px`);
    (0,utils.b)(wrapperEl, '--swiper-centered-offset-after', `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
    const addToSnapGrid = -swiper.snapGrid[0];
    const addToSlidesGrid = -swiper.slidesGrid[0];
    swiper.snapGrid = swiper.snapGrid.map(v => v + addToSnapGrid);
    swiper.slidesGrid = swiper.slidesGrid.map(v => v + addToSlidesGrid);
  }
  if (slidesLength !== previousSlidesLength) {
    swiper.emit('slidesLengthChange');
  }
  if (snapGrid.length !== previousSnapGridLength) {
    if (swiper.params.watchOverflow) swiper.checkOverflow();
    swiper.emit('snapGridLengthChange');
  }
  if (slidesGrid.length !== previousSlidesGridLength) {
    swiper.emit('slidesGridLengthChange');
  }
  if (params.watchSlidesProgress) {
    swiper.updateSlidesOffset();
  }
  swiper.emit('slidesUpdated');
  if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
    const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
    const hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
    if (slidesLength <= params.maxBackfaceHiddenSlides) {
      if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
    } else if (hasClassBackfaceClassAdded) {
      swiper.el.classList.remove(backFaceHiddenClass);
    }
  }
}

function updateAutoHeight(speed) {
  const swiper = this;
  const activeSlides = [];
  const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  let newHeight = 0;
  let i;
  if (typeof speed === 'number') {
    swiper.setTransition(speed);
  } else if (speed === true) {
    swiper.setTransition(swiper.params.speed);
  }
  const getSlideByIndex = index => {
    if (isVirtual) {
      return swiper.slides[swiper.getSlideIndexByData(index)];
    }
    return swiper.slides[index];
  };
  // Find slides currently in view
  if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
    if (swiper.params.centeredSlides) {
      (swiper.visibleSlides || []).forEach(slide => {
        activeSlides.push(slide);
      });
    } else {
      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
        const index = swiper.activeIndex + i;
        if (index > swiper.slides.length && !isVirtual) break;
        activeSlides.push(getSlideByIndex(index));
      }
    }
  } else {
    activeSlides.push(getSlideByIndex(swiper.activeIndex));
  }

  // Find new height from highest slide in view
  for (i = 0; i < activeSlides.length; i += 1) {
    if (typeof activeSlides[i] !== 'undefined') {
      const height = activeSlides[i].offsetHeight;
      newHeight = height > newHeight ? height : newHeight;
    }
  }

  // Update Height
  if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = `${newHeight}px`;
}

function updateSlidesOffset() {
  const swiper = this;
  const slides = swiper.slides;
  // eslint-disable-next-line
  const minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
  for (let i = 0; i < slides.length; i += 1) {
    slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
  }
}

const toggleSlideClasses$1 = (slideEl, condition, className) => {
  if (condition && !slideEl.classList.contains(className)) {
    slideEl.classList.add(className);
  } else if (!condition && slideEl.classList.contains(className)) {
    slideEl.classList.remove(className);
  }
};
function updateSlidesProgress(translate = this && this.translate || 0) {
  const swiper = this;
  const params = swiper.params;
  const {
    slides,
    rtlTranslate: rtl,
    snapGrid
  } = swiper;
  if (slides.length === 0) return;
  if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
  let offsetCenter = -translate;
  if (rtl) offsetCenter = translate;
  swiper.visibleSlidesIndexes = [];
  swiper.visibleSlides = [];
  let spaceBetween = params.spaceBetween;
  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
  } else if (typeof spaceBetween === 'string') {
    spaceBetween = parseFloat(spaceBetween);
  }
  for (let i = 0; i < slides.length; i += 1) {
    const slide = slides[i];
    let slideOffset = slide.swiperSlideOffset;
    if (params.cssMode && params.centeredSlides) {
      slideOffset -= slides[0].swiperSlideOffset;
    }
    const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
    const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
    const slideBefore = -(offsetCenter - slideOffset);
    const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
    const isFullyVisible = slideBefore >= 0 && slideBefore <= swiper.size - swiper.slidesSizesGrid[i];
    const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
    if (isVisible) {
      swiper.visibleSlides.push(slide);
      swiper.visibleSlidesIndexes.push(i);
    }
    toggleSlideClasses$1(slide, isVisible, params.slideVisibleClass);
    toggleSlideClasses$1(slide, isFullyVisible, params.slideFullyVisibleClass);
    slide.progress = rtl ? -slideProgress : slideProgress;
    slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
  }
}

function updateProgress(translate) {
  const swiper = this;
  if (typeof translate === 'undefined') {
    const multiplier = swiper.rtlTranslate ? -1 : 1;
    // eslint-disable-next-line
    translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
  }
  const params = swiper.params;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  let {
    progress,
    isBeginning,
    isEnd,
    progressLoop
  } = swiper;
  const wasBeginning = isBeginning;
  const wasEnd = isEnd;
  if (translatesDiff === 0) {
    progress = 0;
    isBeginning = true;
    isEnd = true;
  } else {
    progress = (translate - swiper.minTranslate()) / translatesDiff;
    const isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
    const isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
    isBeginning = isBeginningRounded || progress <= 0;
    isEnd = isEndRounded || progress >= 1;
    if (isBeginningRounded) progress = 0;
    if (isEndRounded) progress = 1;
  }
  if (params.loop) {
    const firstSlideIndex = swiper.getSlideIndexByData(0);
    const lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
    const firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
    const lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
    const translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
    const translateAbs = Math.abs(translate);
    if (translateAbs >= firstSlideTranslate) {
      progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
    } else {
      progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
    }
    if (progressLoop > 1) progressLoop -= 1;
  }
  Object.assign(swiper, {
    progress,
    progressLoop,
    isBeginning,
    isEnd
  });
  if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
  if (isBeginning && !wasBeginning) {
    swiper.emit('reachBeginning toEdge');
  }
  if (isEnd && !wasEnd) {
    swiper.emit('reachEnd toEdge');
  }
  if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
    swiper.emit('fromEdge');
  }
  swiper.emit('progress', progress);
}

const toggleSlideClasses = (slideEl, condition, className) => {
  if (condition && !slideEl.classList.contains(className)) {
    slideEl.classList.add(className);
  } else if (!condition && slideEl.classList.contains(className)) {
    slideEl.classList.remove(className);
  }
};
function updateSlidesClasses() {
  const swiper = this;
  const {
    slides,
    params,
    slidesEl,
    activeIndex
  } = swiper;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
  const getFilteredSlide = selector => {
    return (0,utils.e)(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
  };
  let activeSlide;
  let prevSlide;
  let nextSlide;
  if (isVirtual) {
    if (params.loop) {
      let slideIndex = activeIndex - swiper.virtual.slidesBefore;
      if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
      if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
      activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
    } else {
      activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
    }
  } else {
    if (gridEnabled) {
      activeSlide = slides.find(slideEl => slideEl.column === activeIndex);
      nextSlide = slides.find(slideEl => slideEl.column === activeIndex + 1);
      prevSlide = slides.find(slideEl => slideEl.column === activeIndex - 1);
    } else {
      activeSlide = slides[activeIndex];
    }
  }
  if (activeSlide) {
    if (!gridEnabled) {
      // Next Slide
      nextSlide = (0,utils.r)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
      if (params.loop && !nextSlide) {
        nextSlide = slides[0];
      }

      // Prev Slide
      prevSlide = (0,utils.t)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
      if (params.loop && !prevSlide === 0) {
        prevSlide = slides[slides.length - 1];
      }
    }
  }
  slides.forEach(slideEl => {
    toggleSlideClasses(slideEl, slideEl === activeSlide, params.slideActiveClass);
    toggleSlideClasses(slideEl, slideEl === nextSlide, params.slideNextClass);
    toggleSlideClasses(slideEl, slideEl === prevSlide, params.slidePrevClass);
  });
  swiper.emitSlidesClasses();
}

const processLazyPreloader = (swiper, imageEl) => {
  if (!swiper || swiper.destroyed || !swiper.params) return;
  const slideSelector = () => swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
  const slideEl = imageEl.closest(slideSelector());
  if (slideEl) {
    let lazyEl = slideEl.querySelector(`.${swiper.params.lazyPreloaderClass}`);
    if (!lazyEl && swiper.isElement) {
      if (slideEl.shadowRoot) {
        lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
      } else {
        // init later
        requestAnimationFrame(() => {
          if (slideEl.shadowRoot) {
            lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
            if (lazyEl && !lazyEl.lazyPreloaderManaged) lazyEl.remove();
          }
        });
      }
    }
    // Skip removal if managed by React/Vue component
    if (lazyEl && !lazyEl.lazyPreloaderManaged) lazyEl.remove();
  }
};
const unlazy = (swiper, index) => {
  if (!swiper.slides[index]) return;
  const imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
  if (imageEl) imageEl.removeAttribute('loading');
};
const preload = swiper => {
  if (!swiper || swiper.destroyed || !swiper.params) return;
  let amount = swiper.params.lazyPreloadPrevNext;
  const len = swiper.slides.length;
  if (!len || !amount || amount < 0) return;
  amount = Math.min(amount, len);
  const slidesPerView = swiper.params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
  const activeIndex = swiper.activeIndex;
  if (swiper.params.grid && swiper.params.grid.rows > 1) {
    const activeColumn = activeIndex;
    const preloadColumns = [activeColumn - amount];
    preloadColumns.push(...Array.from({
      length: amount
    }).map((_, i) => {
      return activeColumn + slidesPerView + i;
    }));
    swiper.slides.forEach((slideEl, i) => {
      if (preloadColumns.includes(slideEl.column)) unlazy(swiper, i);
    });
    return;
  }
  const slideIndexLastInView = activeIndex + slidesPerView - 1;
  if (swiper.params.rewind || swiper.params.loop) {
    for (let i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1) {
      const realIndex = (i % len + len) % len;
      if (realIndex < activeIndex || realIndex > slideIndexLastInView) unlazy(swiper, realIndex);
    }
  } else {
    for (let i = Math.max(activeIndex - amount, 0); i <= Math.min(slideIndexLastInView + amount, len - 1); i += 1) {
      if (i !== activeIndex && (i > slideIndexLastInView || i < activeIndex)) {
        unlazy(swiper, i);
      }
    }
  }
};

function getActiveIndexByTranslate(swiper) {
  const {
    slidesGrid,
    params
  } = swiper;
  const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  let activeIndex;
  for (let i = 0; i < slidesGrid.length; i += 1) {
    if (typeof slidesGrid[i + 1] !== 'undefined') {
      if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
        activeIndex = i;
      } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
        activeIndex = i + 1;
      }
    } else if (translate >= slidesGrid[i]) {
      activeIndex = i;
    }
  }
  // Normalize slideIndex
  if (params.normalizeSlideIndex) {
    if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
  }
  return activeIndex;
}
function updateActiveIndex(newActiveIndex) {
  const swiper = this;
  const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  const {
    snapGrid,
    params,
    activeIndex: previousIndex,
    realIndex: previousRealIndex,
    snapIndex: previousSnapIndex
  } = swiper;
  let activeIndex = newActiveIndex;
  let snapIndex;
  const getVirtualRealIndex = aIndex => {
    let realIndex = aIndex - swiper.virtual.slidesBefore;
    if (realIndex < 0) {
      realIndex = swiper.virtual.slides.length + realIndex;
    }
    if (realIndex >= swiper.virtual.slides.length) {
      realIndex -= swiper.virtual.slides.length;
    }
    return realIndex;
  };
  if (typeof activeIndex === 'undefined') {
    activeIndex = getActiveIndexByTranslate(swiper);
  }
  if (snapGrid.indexOf(translate) >= 0) {
    snapIndex = snapGrid.indexOf(translate);
  } else {
    const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
    snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
  }
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
  if (activeIndex === previousIndex && !swiper.params.loop) {
    if (snapIndex !== previousSnapIndex) {
      swiper.snapIndex = snapIndex;
      swiper.emit('snapIndexChange');
    }
    return;
  }
  if (activeIndex === previousIndex && swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
    swiper.realIndex = getVirtualRealIndex(activeIndex);
    return;
  }
  const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;

  // Get real index
  let realIndex;
  if (swiper.virtual && params.virtual.enabled) {
    if (params.loop) {
      realIndex = getVirtualRealIndex(activeIndex);
    } else {
      realIndex = activeIndex;
    }
  } else if (gridEnabled) {
    const firstSlideInColumn = swiper.slides.find(slideEl => slideEl.column === activeIndex);
    let activeSlideIndex = parseInt(firstSlideInColumn.getAttribute('data-swiper-slide-index'), 10);
    if (Number.isNaN(activeSlideIndex)) {
      activeSlideIndex = Math.max(swiper.slides.indexOf(firstSlideInColumn), 0);
    }
    realIndex = Math.floor(activeSlideIndex / params.grid.rows);
  } else if (swiper.slides[activeIndex]) {
    const slideIndex = swiper.slides[activeIndex].getAttribute('data-swiper-slide-index');
    if (slideIndex) {
      realIndex = parseInt(slideIndex, 10);
    } else {
      realIndex = activeIndex;
    }
  } else {
    realIndex = activeIndex;
  }
  Object.assign(swiper, {
    previousSnapIndex,
    snapIndex,
    previousRealIndex,
    realIndex,
    previousIndex,
    activeIndex
  });
  if (swiper.initialized) {
    preload(swiper);
  }
  swiper.emit('activeIndexChange');
  swiper.emit('snapIndexChange');
  if (swiper.initialized || swiper.params.runCallbacksOnInit) {
    if (previousRealIndex !== realIndex) {
      swiper.emit('realIndexChange');
    }
    swiper.emit('slideChange');
  }
}

function updateClickedSlide(el, path) {
  const swiper = this;
  const params = swiper.params;
  let slide = el.closest(`.${params.slideClass}, swiper-slide`);
  if (!slide && swiper.isElement && path && path.length > 1 && path.includes(el)) {
    [...path.slice(path.indexOf(el) + 1, path.length)].forEach(pathEl => {
      if (!slide && pathEl.matches && pathEl.matches(`.${params.slideClass}, swiper-slide`)) {
        slide = pathEl;
      }
    });
  }
  let slideFound = false;
  let slideIndex;
  if (slide) {
    for (let i = 0; i < swiper.slides.length; i += 1) {
      if (swiper.slides[i] === slide) {
        slideFound = true;
        slideIndex = i;
        break;
      }
    }
  }
  if (slide && slideFound) {
    swiper.clickedSlide = slide;
    if (swiper.virtual && swiper.params.virtual.enabled) {
      swiper.clickedIndex = parseInt(slide.getAttribute('data-swiper-slide-index'), 10);
    } else {
      swiper.clickedIndex = slideIndex;
    }
  } else {
    swiper.clickedSlide = undefined;
    swiper.clickedIndex = undefined;
    return;
  }
  if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
    swiper.slideToClickedSlide();
  }
}

var update = {
  updateSize,
  updateSlides,
  updateAutoHeight,
  updateSlidesOffset,
  updateSlidesProgress,
  updateProgress,
  updateSlidesClasses,
  updateActiveIndex,
  updateClickedSlide
};

function getSwiperTranslate(axis = this.isHorizontal() ? 'x' : 'y') {
  const swiper = this;
  const {
    params,
    rtlTranslate: rtl,
    translate,
    wrapperEl
  } = swiper;
  if (params.virtualTranslate) {
    return rtl ? -translate : translate;
  }
  if (params.cssMode) {
    return translate;
  }
  let currentTranslate = (0,utils.l)(wrapperEl, axis);
  currentTranslate += swiper.cssOverflowAdjustment();
  if (rtl) currentTranslate = -currentTranslate;
  return currentTranslate || 0;
}

function setTranslate(translate, byController) {
  const swiper = this;
  const {
    rtlTranslate: rtl,
    params,
    wrapperEl,
    progress
  } = swiper;
  let x = 0;
  let y = 0;
  const z = 0;
  if (swiper.isHorizontal()) {
    x = rtl ? -translate : translate;
  } else {
    y = translate;
  }
  if (params.roundLengths) {
    x = Math.floor(x);
    y = Math.floor(y);
  }
  swiper.previousTranslate = swiper.translate;
  swiper.translate = swiper.isHorizontal() ? x : y;
  if (params.cssMode) {
    wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
  } else if (!params.virtualTranslate) {
    if (swiper.isHorizontal()) {
      x -= swiper.cssOverflowAdjustment();
    } else {
      y -= swiper.cssOverflowAdjustment();
    }
    wrapperEl.style.transform = `translate3d(${x}px, ${y}px, ${z}px)`;
  }

  // Check if we need to update progress
  let newProgress;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (translate - swiper.minTranslate()) / translatesDiff;
  }
  if (newProgress !== progress) {
    swiper.updateProgress(translate);
  }
  swiper.emit('setTranslate', swiper.translate, byController);
}

function minTranslate() {
  return -this.snapGrid[0];
}

function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}

function translateTo(translate = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
  const swiper = this;
  const {
    params,
    wrapperEl
  } = swiper;
  if (swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }
  const minTranslate = swiper.minTranslate();
  const maxTranslate = swiper.maxTranslate();
  let newTranslate;
  if (translateBounds && translate > minTranslate) newTranslate = minTranslate;else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;else newTranslate = translate;

  // Update progress
  swiper.updateProgress(newTranslate);
  if (params.cssMode) {
    const isH = swiper.isHorizontal();
    if (speed === 0) {
      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
    } else {
      if (!swiper.support.smoothScroll) {
        (0,utils.u)({
          swiper,
          targetPosition: -newTranslate,
          side: isH ? 'left' : 'top'
        });
        return true;
      }
      wrapperEl.scrollTo({
        [isH ? 'left' : 'top']: -newTranslate,
        behavior: 'smooth'
      });
    }
    return true;
  }
  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(newTranslate);
    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionEnd');
    }
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(newTranslate);
    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionStart');
    }
    if (!swiper.animating) {
      swiper.animating = true;
      if (!swiper.onTranslateToWrapperTransitionEnd) {
        swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.wrapperEl.removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
          swiper.onTranslateToWrapperTransitionEnd = null;
          delete swiper.onTranslateToWrapperTransitionEnd;
          swiper.animating = false;
          if (runCallbacks) {
            swiper.emit('transitionEnd');
          }
        };
      }
      swiper.wrapperEl.addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
    }
  }
  return true;
}

var translate = {
  getTranslate: getSwiperTranslate,
  setTranslate,
  minTranslate,
  maxTranslate,
  translateTo
};

function setTransition(duration, byController) {
  const swiper = this;
  if (!swiper.params.cssMode) {
    swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
    swiper.wrapperEl.style.transitionDelay = duration === 0 ? `0ms` : '';
  }
  swiper.emit('setTransition', duration, byController);
}

function transitionEmit({
  swiper,
  runCallbacks,
  direction,
  step
}) {
  const {
    activeIndex,
    previousIndex
  } = swiper;
  let dir = direction;
  if (!dir) {
    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
  }
  swiper.emit(`transition${step}`);
  if (runCallbacks && dir === 'reset') {
    swiper.emit(`slideResetTransition${step}`);
  } else if (runCallbacks && activeIndex !== previousIndex) {
    swiper.emit(`slideChangeTransition${step}`);
    if (dir === 'next') {
      swiper.emit(`slideNextTransition${step}`);
    } else {
      swiper.emit(`slidePrevTransition${step}`);
    }
  }
}

function transitionStart(runCallbacks = true, direction) {
  const swiper = this;
  const {
    params
  } = swiper;
  if (params.cssMode) return;
  if (params.autoHeight) {
    swiper.updateAutoHeight();
  }
  transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step: 'Start'
  });
}

function transitionEnd(runCallbacks = true, direction) {
  const swiper = this;
  const {
    params
  } = swiper;
  swiper.animating = false;
  if (params.cssMode) return;
  swiper.setTransition(0);
  transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step: 'End'
  });
}

var transition = {
  setTransition,
  transitionStart,
  transitionEnd
};

function slideTo(index = 0, speed, runCallbacks = true, internal, initial) {
  if (typeof index === 'string') {
    index = parseInt(index, 10);
  }
  const swiper = this;
  let slideIndex = index;
  if (slideIndex < 0) slideIndex = 0;
  const {
    params,
    snapGrid,
    slidesGrid,
    previousIndex,
    activeIndex,
    rtlTranslate: rtl,
    wrapperEl,
    enabled
  } = swiper;
  if (!enabled && !internal && !initial || swiper.destroyed || swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }
  if (typeof speed === 'undefined') {
    speed = swiper.params.speed;
  }
  const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
  let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
  const translate = -snapGrid[snapIndex];
  // Normalize slideIndex
  if (params.normalizeSlideIndex) {
    for (let i = 0; i < slidesGrid.length; i += 1) {
      const normalizedTranslate = -Math.floor(translate * 100);
      const normalizedGrid = Math.floor(slidesGrid[i] * 100);
      const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) {
          slideIndex = i;
        } else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) {
          slideIndex = i + 1;
        }
      } else if (normalizedTranslate >= normalizedGrid) {
        slideIndex = i;
      }
    }
  }
  // Directions locks
  if (swiper.initialized && slideIndex !== activeIndex) {
    if (!swiper.allowSlideNext && (rtl ? translate > swiper.translate && translate > swiper.minTranslate() : translate < swiper.translate && translate < swiper.minTranslate())) {
      return false;
    }
    if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
      if ((activeIndex || 0) !== slideIndex) {
        return false;
      }
    }
  }
  if (slideIndex !== (previousIndex || 0) && runCallbacks) {
    swiper.emit('beforeSlideChangeStart');
  }

  // Update progress
  swiper.updateProgress(translate);
  let direction;
  if (slideIndex > activeIndex) direction = 'next';else if (slideIndex < activeIndex) direction = 'prev';else direction = 'reset';

  // initial virtual
  const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  const isInitialVirtual = isVirtual && initial;
  // Update Index
  if (!isInitialVirtual && (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate)) {
    swiper.updateActiveIndex(slideIndex);
    // Update Height
    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }
    swiper.updateSlidesClasses();
    if (params.effect !== 'slide') {
      swiper.setTranslate(translate);
    }
    if (direction !== 'reset') {
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    }
    return false;
  }
  if (params.cssMode) {
    const isH = swiper.isHorizontal();
    const t = rtl ? translate : -translate;
    if (speed === 0) {
      if (isVirtual) {
        swiper.wrapperEl.style.scrollSnapType = 'none';
        swiper._immediateVirtual = true;
      }
      if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
        swiper._cssModeVirtualInitialSet = true;
        requestAnimationFrame(() => {
          wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
        });
      } else {
        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
      }
      if (isVirtual) {
        requestAnimationFrame(() => {
          swiper.wrapperEl.style.scrollSnapType = '';
          swiper._immediateVirtual = false;
        });
      }
    } else {
      if (!swiper.support.smoothScroll) {
        (0,utils.u)({
          swiper,
          targetPosition: t,
          side: isH ? 'left' : 'top'
        });
        return true;
      }
      wrapperEl.scrollTo({
        [isH ? 'left' : 'top']: t,
        behavior: 'smooth'
      });
    }
    return true;
  }
  const browser = getBrowser();
  const isSafari = browser.isSafari;
  if (isVirtual && !initial && isSafari && swiper.isElement) {
    swiper.virtual.update(false, false, slideIndex);
  }
  swiper.setTransition(speed);
  swiper.setTranslate(translate);
  swiper.updateActiveIndex(slideIndex);
  swiper.updateSlidesClasses();
  swiper.emit('beforeTransitionStart', speed, internal);
  swiper.transitionStart(runCallbacks, direction);
  if (speed === 0) {
    swiper.transitionEnd(runCallbacks, direction);
  } else if (!swiper.animating) {
    swiper.animating = true;
    if (!swiper.onSlideToWrapperTransitionEnd) {
      swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
        if (!swiper || swiper.destroyed) return;
        if (e.target !== this) return;
        swiper.wrapperEl.removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
        swiper.onSlideToWrapperTransitionEnd = null;
        delete swiper.onSlideToWrapperTransitionEnd;
        swiper.transitionEnd(runCallbacks, direction);
      };
    }
    swiper.wrapperEl.addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
  }
  return true;
}

function slideToLoop(index = 0, speed, runCallbacks = true, internal) {
  if (typeof index === 'string') {
    const indexAsNumber = parseInt(index, 10);
    index = indexAsNumber;
  }
  const swiper = this;
  if (swiper.destroyed) return;
  if (typeof speed === 'undefined') {
    speed = swiper.params.speed;
  }
  const gridEnabled = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
  let newIndex = index;
  if (swiper.params.loop) {
    if (swiper.virtual && swiper.params.virtual.enabled) {
      // eslint-disable-next-line
      newIndex = newIndex + swiper.virtual.slidesBefore;
    } else {
      let targetSlideIndex;
      if (gridEnabled) {
        const slideIndex = newIndex * swiper.params.grid.rows;
        targetSlideIndex = swiper.slides.find(slideEl => slideEl.getAttribute('data-swiper-slide-index') * 1 === slideIndex).column;
      } else {
        targetSlideIndex = swiper.getSlideIndexByData(newIndex);
      }
      const cols = gridEnabled ? Math.ceil(swiper.slides.length / swiper.params.grid.rows) : swiper.slides.length;
      const {
        centeredSlides,
        slidesOffsetBefore,
        slidesOffsetAfter
      } = swiper.params;
      const bothDirections = centeredSlides || !!slidesOffsetBefore || !!slidesOffsetAfter;
      let slidesPerView = swiper.params.slidesPerView;
      if (slidesPerView === 'auto') {
        slidesPerView = swiper.slidesPerViewDynamic();
      } else {
        slidesPerView = Math.ceil(parseFloat(swiper.params.slidesPerView, 10));
        if (bothDirections && slidesPerView % 2 === 0) {
          slidesPerView = slidesPerView + 1;
        }
      }
      let needLoopFix = cols - targetSlideIndex < slidesPerView;
      if (bothDirections) {
        needLoopFix = needLoopFix || targetSlideIndex < Math.ceil(slidesPerView / 2);
      }
      if (internal && bothDirections && swiper.params.slidesPerView !== 'auto' && !gridEnabled) {
        needLoopFix = false;
      }
      if (needLoopFix) {
        const direction = bothDirections ? targetSlideIndex < swiper.activeIndex ? 'prev' : 'next' : targetSlideIndex - swiper.activeIndex - 1 < swiper.params.slidesPerView ? 'next' : 'prev';
        swiper.loopFix({
          direction,
          slideTo: true,
          activeSlideIndex: direction === 'next' ? targetSlideIndex + 1 : targetSlideIndex - cols + 1,
          slideRealIndex: direction === 'next' ? swiper.realIndex : undefined
        });
      }
      if (gridEnabled) {
        const slideIndex = newIndex * swiper.params.grid.rows;
        newIndex = swiper.slides.find(slideEl => slideEl.getAttribute('data-swiper-slide-index') * 1 === slideIndex).column;
      } else {
        newIndex = swiper.getSlideIndexByData(newIndex);
      }
    }
  }
  requestAnimationFrame(() => {
    swiper.slideTo(newIndex, speed, runCallbacks, internal);
  });
  return swiper;
}

/* eslint no-unused-vars: "off" */
function slideNext(speed, runCallbacks = true, internal) {
  const swiper = this;
  const {
    enabled,
    params,
    animating
  } = swiper;
  if (!enabled || swiper.destroyed) return swiper;
  if (typeof speed === 'undefined') {
    speed = swiper.params.speed;
  }
  let perGroup = params.slidesPerGroup;
  if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
    perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
  }
  const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  if (params.loop) {
    if (animating && !isVirtual && params.loopPreventsSliding) return false;
    swiper.loopFix({
      direction: 'next'
    });
    // eslint-disable-next-line
    swiper._clientLeft = swiper.wrapperEl.clientLeft;
    if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
      requestAnimationFrame(() => {
        swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
      });
      return true;
    }
  }
  if (params.rewind && swiper.isEnd) {
    return swiper.slideTo(0, speed, runCallbacks, internal);
  }
  return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slidePrev(speed, runCallbacks = true, internal) {
  const swiper = this;
  const {
    params,
    snapGrid,
    slidesGrid,
    rtlTranslate,
    enabled,
    animating
  } = swiper;
  if (!enabled || swiper.destroyed) return swiper;
  if (typeof speed === 'undefined') {
    speed = swiper.params.speed;
  }
  const isVirtual = swiper.virtual && params.virtual.enabled;
  if (params.loop) {
    if (animating && !isVirtual && params.loopPreventsSliding) return false;
    swiper.loopFix({
      direction: 'prev'
    });
    // eslint-disable-next-line
    swiper._clientLeft = swiper.wrapperEl.clientLeft;
  }
  const translate = rtlTranslate ? swiper.translate : -swiper.translate;
  function normalize(val) {
    if (val < 0) return -Math.floor(Math.abs(val));
    return Math.floor(val);
  }
  const normalizedTranslate = normalize(translate);
  const normalizedSnapGrid = snapGrid.map(val => normalize(val));
  const isFreeMode = params.freeMode && params.freeMode.enabled;
  let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
  if (typeof prevSnap === 'undefined' && (params.cssMode || isFreeMode)) {
    let prevSnapIndex;
    snapGrid.forEach((snap, snapIndex) => {
      if (normalizedTranslate >= snap) {
        // prevSnap = snap;
        prevSnapIndex = snapIndex;
      }
    });
    if (typeof prevSnapIndex !== 'undefined') {
      prevSnap = isFreeMode ? snapGrid[prevSnapIndex] : snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
  }
  let prevIndex = 0;
  if (typeof prevSnap !== 'undefined') {
    prevIndex = slidesGrid.indexOf(prevSnap);
    if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
      prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
      prevIndex = Math.max(prevIndex, 0);
    }
  }
  if (params.rewind && swiper.isBeginning) {
    const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
  } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
    requestAnimationFrame(() => {
      swiper.slideTo(prevIndex, speed, runCallbacks, internal);
    });
    return true;
  }
  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideReset(speed, runCallbacks = true, internal) {
  const swiper = this;
  if (swiper.destroyed) return;
  if (typeof speed === 'undefined') {
    speed = swiper.params.speed;
  }
  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideToClosest(speed, runCallbacks = true, internal, threshold = 0.5) {
  const swiper = this;
  if (swiper.destroyed) return;
  if (typeof speed === 'undefined') {
    speed = swiper.params.speed;
  }
  let index = swiper.activeIndex;
  const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
  const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
  const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  if (translate >= swiper.snapGrid[snapIndex]) {
    // The current translate is on or after the current snap index, so the choice
    // is between the current index and the one after it.
    const currentSnap = swiper.snapGrid[snapIndex];
    const nextSnap = swiper.snapGrid[snapIndex + 1];
    if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
      index += swiper.params.slidesPerGroup;
    }
  } else {
    // The current translate is before the current snap index, so the choice
    // is between the current index and the one before it.
    const prevSnap = swiper.snapGrid[snapIndex - 1];
    const currentSnap = swiper.snapGrid[snapIndex];
    if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) {
      index -= swiper.params.slidesPerGroup;
    }
  }
  index = Math.max(index, 0);
  index = Math.min(index, swiper.slidesGrid.length - 1);
  return swiper.slideTo(index, speed, runCallbacks, internal);
}

function slideToClickedSlide() {
  const swiper = this;
  if (swiper.destroyed) return;
  const {
    params,
    slidesEl
  } = swiper;
  const slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
  let slideToIndex = swiper.getSlideIndexWhenGrid(swiper.clickedIndex);
  let realIndex;
  const slideSelector = swiper.isElement ? `swiper-slide` : `.${params.slideClass}`;
  const isGrid = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
  if (params.loop) {
    if (swiper.animating) return;
    realIndex = parseInt(swiper.clickedSlide.getAttribute('data-swiper-slide-index'), 10);
    if (params.centeredSlides) {
      swiper.slideToLoop(realIndex);
    } else if (slideToIndex > (isGrid ? (swiper.slides.length - slidesPerView) / 2 - (swiper.params.grid.rows - 1) : swiper.slides.length - slidesPerView)) {
      swiper.loopFix();
      slideToIndex = swiper.getSlideIndex((0,utils.e)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
      (0,utils.n)(() => {
        swiper.slideTo(slideToIndex);
      });
    } else {
      swiper.slideTo(slideToIndex);
    }
  } else {
    swiper.slideTo(slideToIndex);
  }
}

var slide = {
  slideTo,
  slideToLoop,
  slideNext,
  slidePrev,
  slideReset,
  slideToClosest,
  slideToClickedSlide
};

function loopCreate(slideRealIndex, initial) {
  const swiper = this;
  const {
    params,
    slidesEl
  } = swiper;
  if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
  const initSlides = () => {
    const slides = (0,utils.e)(slidesEl, `.${params.slideClass}, swiper-slide`);
    slides.forEach((el, index) => {
      el.setAttribute('data-swiper-slide-index', index);
    });
  };
  const clearBlankSlides = () => {
    const slides = (0,utils.e)(slidesEl, `.${params.slideBlankClass}`);
    slides.forEach(el => {
      el.remove();
    });
    if (slides.length > 0) {
      swiper.recalcSlides();
      swiper.updateSlides();
    }
  };
  const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
  if (params.loopAddBlankSlides && (params.slidesPerGroup > 1 || gridEnabled)) {
    clearBlankSlides();
  }
  const slidesPerGroup = params.slidesPerGroup * (gridEnabled ? params.grid.rows : 1);
  const shouldFillGroup = swiper.slides.length % slidesPerGroup !== 0;
  const shouldFillGrid = gridEnabled && swiper.slides.length % params.grid.rows !== 0;
  const addBlankSlides = amountOfSlides => {
    for (let i = 0; i < amountOfSlides; i += 1) {
      const slideEl = swiper.isElement ? (0,utils.c)('swiper-slide', [params.slideBlankClass]) : (0,utils.c)('div', [params.slideClass, params.slideBlankClass]);
      swiper.slidesEl.append(slideEl);
    }
  };
  if (shouldFillGroup) {
    if (params.loopAddBlankSlides) {
      const slidesToAdd = slidesPerGroup - swiper.slides.length % slidesPerGroup;
      addBlankSlides(slidesToAdd);
      swiper.recalcSlides();
      swiper.updateSlides();
    } else {
      (0,utils.v)('Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
    }
    initSlides();
  } else if (shouldFillGrid) {
    if (params.loopAddBlankSlides) {
      const slidesToAdd = params.grid.rows - swiper.slides.length % params.grid.rows;
      addBlankSlides(slidesToAdd);
      swiper.recalcSlides();
      swiper.updateSlides();
    } else {
      (0,utils.v)('Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
    }
    initSlides();
  } else {
    initSlides();
  }
  const bothDirections = params.centeredSlides || !!params.slidesOffsetBefore || !!params.slidesOffsetAfter;
  swiper.loopFix({
    slideRealIndex,
    direction: bothDirections ? undefined : 'next',
    initial
  });
}

function loopFix({
  slideRealIndex,
  slideTo = true,
  direction,
  setTranslate,
  activeSlideIndex,
  initial,
  byController,
  byMousewheel
} = {}) {
  const swiper = this;
  if (!swiper.params.loop) return;
  swiper.emit('beforeLoopFix');
  const {
    slides,
    allowSlidePrev,
    allowSlideNext,
    slidesEl,
    params
  } = swiper;
  const {
    centeredSlides,
    slidesOffsetBefore,
    slidesOffsetAfter,
    initialSlide
  } = params;
  const bothDirections = centeredSlides || !!slidesOffsetBefore || !!slidesOffsetAfter;
  swiper.allowSlidePrev = true;
  swiper.allowSlideNext = true;
  if (swiper.virtual && params.virtual.enabled) {
    if (slideTo) {
      if (!bothDirections && swiper.snapIndex === 0) {
        swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
      } else if (bothDirections && swiper.snapIndex < params.slidesPerView) {
        swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
      } else if (swiper.snapIndex === swiper.snapGrid.length - 1) {
        swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
      }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    swiper.emit('loopFix');
    return;
  }
  let slidesPerView = params.slidesPerView;
  if (slidesPerView === 'auto') {
    slidesPerView = swiper.slidesPerViewDynamic();
  } else {
    slidesPerView = Math.ceil(parseFloat(params.slidesPerView, 10));
    if (bothDirections && slidesPerView % 2 === 0) {
      slidesPerView = slidesPerView + 1;
    }
  }
  const slidesPerGroup = params.slidesPerGroupAuto ? slidesPerView : params.slidesPerGroup;
  let loopedSlides = bothDirections ? Math.max(slidesPerGroup, Math.ceil(slidesPerView / 2)) : slidesPerGroup;
  if (loopedSlides % slidesPerGroup !== 0) {
    loopedSlides += slidesPerGroup - loopedSlides % slidesPerGroup;
  }
  loopedSlides += params.loopAdditionalSlides;
  swiper.loopedSlides = loopedSlides;
  const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
  if (slides.length < slidesPerView + loopedSlides || swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2) {
    (0,utils.v)('Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters');
  } else if (gridEnabled && params.grid.fill === 'row') {
    (0,utils.v)('Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`');
  }
  const prependSlidesIndexes = [];
  const appendSlidesIndexes = [];
  const cols = gridEnabled ? Math.ceil(slides.length / params.grid.rows) : slides.length;
  const isInitialOverflow = initial && cols - initialSlide < slidesPerView && !bothDirections;
  let activeIndex = isInitialOverflow ? initialSlide : swiper.activeIndex;
  if (typeof activeSlideIndex === 'undefined') {
    activeSlideIndex = swiper.getSlideIndex(slides.find(el => el.classList.contains(params.slideActiveClass)));
  } else {
    activeIndex = activeSlideIndex;
  }
  const isNext = direction === 'next' || !direction;
  const isPrev = direction === 'prev' || !direction;
  let slidesPrepended = 0;
  let slidesAppended = 0;
  const activeColIndex = gridEnabled ? slides[activeSlideIndex].column : activeSlideIndex;
  const activeColIndexWithShift = activeColIndex + (bothDirections && typeof setTranslate === 'undefined' ? -slidesPerView / 2 + 0.5 : 0);
  // prepend last slides before start
  if (activeColIndexWithShift < loopedSlides) {
    slidesPrepended = Math.max(loopedSlides - activeColIndexWithShift, slidesPerGroup);
    for (let i = 0; i < loopedSlides - activeColIndexWithShift; i += 1) {
      const index = i - Math.floor(i / cols) * cols;
      if (gridEnabled) {
        const colIndexToPrepend = cols - index - 1;
        for (let i = slides.length - 1; i >= 0; i -= 1) {
          if (slides[i].column === colIndexToPrepend) prependSlidesIndexes.push(i);
        }
        // slides.forEach((slide, slideIndex) => {
        //   if (slide.column === colIndexToPrepend) prependSlidesIndexes.push(slideIndex);
        // });
      } else {
        prependSlidesIndexes.push(cols - index - 1);
      }
    }
  } else if (activeColIndexWithShift + slidesPerView > cols - loopedSlides) {
    slidesAppended = Math.max(activeColIndexWithShift - (cols - loopedSlides * 2), slidesPerGroup);
    if (isInitialOverflow) {
      slidesAppended = Math.max(slidesAppended, slidesPerView - cols + initialSlide + 1);
    }
    for (let i = 0; i < slidesAppended; i += 1) {
      const index = i - Math.floor(i / cols) * cols;
      if (gridEnabled) {
        slides.forEach((slide, slideIndex) => {
          if (slide.column === index) appendSlidesIndexes.push(slideIndex);
        });
      } else {
        appendSlidesIndexes.push(index);
      }
    }
  }
  swiper.__preventObserver__ = true;
  requestAnimationFrame(() => {
    swiper.__preventObserver__ = false;
  });
  if (swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2) {
    if (appendSlidesIndexes.includes(activeSlideIndex)) {
      appendSlidesIndexes.splice(appendSlidesIndexes.indexOf(activeSlideIndex), 1);
    }
    if (prependSlidesIndexes.includes(activeSlideIndex)) {
      prependSlidesIndexes.splice(prependSlidesIndexes.indexOf(activeSlideIndex), 1);
    }
  }
  if (isPrev) {
    prependSlidesIndexes.forEach(index => {
      slides[index].swiperLoopMoveDOM = true;
      slidesEl.prepend(slides[index]);
      slides[index].swiperLoopMoveDOM = false;
    });
  }
  if (isNext) {
    appendSlidesIndexes.forEach(index => {
      slides[index].swiperLoopMoveDOM = true;
      slidesEl.append(slides[index]);
      slides[index].swiperLoopMoveDOM = false;
    });
  }
  swiper.recalcSlides();
  if (params.slidesPerView === 'auto') {
    swiper.updateSlides();
  } else if (gridEnabled && (prependSlidesIndexes.length > 0 && isPrev || appendSlidesIndexes.length > 0 && isNext)) {
    swiper.slides.forEach((slide, slideIndex) => {
      swiper.grid.updateSlide(slideIndex, slide, swiper.slides);
    });
  }
  if (params.watchSlidesProgress) {
    swiper.updateSlidesOffset();
  }
  if (slideTo) {
    if (prependSlidesIndexes.length > 0 && isPrev) {
      if (typeof slideRealIndex === 'undefined') {
        const currentSlideTranslate = swiper.slidesGrid[activeIndex];
        const newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
        const diff = newSlideTranslate - currentSlideTranslate;
        if (byMousewheel) {
          swiper.setTranslate(swiper.translate - diff);
        } else {
          swiper.slideTo(activeIndex + Math.ceil(slidesPrepended), 0, false, true);
          if (setTranslate) {
            swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
            swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
          }
        }
      } else {
        if (setTranslate) {
          const shift = gridEnabled ? prependSlidesIndexes.length / params.grid.rows : prependSlidesIndexes.length;
          swiper.slideTo(swiper.activeIndex + shift, 0, false, true);
          swiper.touchEventsData.currentTranslate = swiper.translate;
        }
      }
    } else if (appendSlidesIndexes.length > 0 && isNext) {
      if (typeof slideRealIndex === 'undefined') {
        const currentSlideTranslate = swiper.slidesGrid[activeIndex];
        const newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
        const diff = newSlideTranslate - currentSlideTranslate;
        if (byMousewheel) {
          swiper.setTranslate(swiper.translate - diff);
        } else {
          swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
          if (setTranslate) {
            swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
            swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
          }
        }
      } else {
        const shift = gridEnabled ? appendSlidesIndexes.length / params.grid.rows : appendSlidesIndexes.length;
        swiper.slideTo(swiper.activeIndex - shift, 0, false, true);
      }
    }
  }
  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  if (swiper.controller && swiper.controller.control && !byController) {
    const loopParams = {
      slideRealIndex,
      direction,
      setTranslate,
      activeSlideIndex,
      byController: true
    };
    if (Array.isArray(swiper.controller.control)) {
      swiper.controller.control.forEach(c => {
        if (!c.destroyed && c.params.loop) c.loopFix({
          ...loopParams,
          slideTo: c.params.slidesPerView === params.slidesPerView ? slideTo : false
        });
      });
    } else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) {
      swiper.controller.control.loopFix({
        ...loopParams,
        slideTo: swiper.controller.control.params.slidesPerView === params.slidesPerView ? slideTo : false
      });
    }
  }
  swiper.emit('loopFix');
}

function loopDestroy() {
  const swiper = this;
  const {
    params,
    slidesEl
  } = swiper;
  if (!params.loop || !slidesEl || swiper.virtual && swiper.params.virtual.enabled) return;
  swiper.recalcSlides();
  const newSlidesOrder = [];
  swiper.slides.forEach(slideEl => {
    const index = typeof slideEl.swiperSlideIndex === 'undefined' ? slideEl.getAttribute('data-swiper-slide-index') * 1 : slideEl.swiperSlideIndex;
    newSlidesOrder[index] = slideEl;
  });
  swiper.slides.forEach(slideEl => {
    slideEl.removeAttribute('data-swiper-slide-index');
  });
  newSlidesOrder.forEach(slideEl => {
    slidesEl.append(slideEl);
  });
  swiper.recalcSlides();
  swiper.slideTo(swiper.realIndex, 0);
}

var loop = {
  loopCreate,
  loopFix,
  loopDestroy
};

function setGrabCursor(moving) {
  const swiper = this;
  if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
  const el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
  if (swiper.isElement) {
    swiper.__preventObserver__ = true;
  }
  el.style.cursor = 'move';
  el.style.cursor = moving ? 'grabbing' : 'grab';
  if (swiper.isElement) {
    requestAnimationFrame(() => {
      swiper.__preventObserver__ = false;
    });
  }
}

function unsetGrabCursor() {
  const swiper = this;
  if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
    return;
  }
  if (swiper.isElement) {
    swiper.__preventObserver__ = true;
  }
  swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
  if (swiper.isElement) {
    requestAnimationFrame(() => {
      swiper.__preventObserver__ = false;
    });
  }
}

var grabCursor = {
  setGrabCursor,
  unsetGrabCursor
};

// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function closestElement(selector, base = this) {
  function __closestFrom(el) {
    if (!el || el === (0,ssr_window_esm.g)() || el === (0,ssr_window_esm.a)()) return null;
    if (el.assignedSlot) el = el.assignedSlot;
    const found = el.closest(selector);
    if (!found && !el.getRootNode) {
      return null;
    }
    return found || __closestFrom(el.getRootNode().host);
  }
  return __closestFrom(base);
}
function preventEdgeSwipe(swiper, event, startX) {
  const window = (0,ssr_window_esm.a)();
  const {
    params
  } = swiper;
  const edgeSwipeDetection = params.edgeSwipeDetection;
  const edgeSwipeThreshold = params.edgeSwipeThreshold;
  if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
    if (edgeSwipeDetection === 'prevent') {
      event.preventDefault();
      return true;
    }
    return false;
  }
  return true;
}
function onTouchStart(event) {
  const swiper = this;
  const document = (0,ssr_window_esm.g)();
  let e = event;
  if (e.originalEvent) e = e.originalEvent;
  const data = swiper.touchEventsData;
  if (e.type === 'pointerdown') {
    if (data.pointerId !== null && data.pointerId !== e.pointerId) {
      return;
    }
    data.pointerId = e.pointerId;
  } else if (e.type === 'touchstart' && e.targetTouches.length === 1) {
    data.touchId = e.targetTouches[0].identifier;
  }
  if (e.type === 'touchstart') {
    // don't proceed touch event
    preventEdgeSwipe(swiper, e, e.targetTouches[0].pageX);
    return;
  }
  const {
    params,
    touches,
    enabled
  } = swiper;
  if (!enabled) return;
  if (!params.simulateTouch && e.pointerType === 'mouse') return;
  if (swiper.animating && params.preventInteractionOnTransition) {
    return;
  }
  if (!swiper.animating && params.cssMode && params.loop) {
    swiper.loopFix();
  }
  let targetEl = e.target;
  if (params.touchEventsTarget === 'wrapper') {
    if (!(0,utils.w)(targetEl, swiper.wrapperEl)) return;
  }
  if ('which' in e && e.which === 3) return;
  if ('button' in e && e.button > 0) return;
  if (data.isTouched && data.isMoved) return;

  // change target el for shadow root component
  const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';
  // eslint-disable-next-line
  const eventPath = e.composedPath ? e.composedPath() : e.path;
  if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) {
    targetEl = eventPath[0];
  }
  const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
  const isTargetShadow = !!(e.target && e.target.shadowRoot);

  // use closestElement for shadow root element to get the actual closest for nested shadow root element
  if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
    swiper.allowClick = true;
    return;
  }
  if (params.swipeHandler) {
    if (!targetEl.closest(params.swipeHandler)) return;
  }
  touches.currentX = e.pageX;
  touches.currentY = e.pageY;
  const startX = touches.currentX;
  const startY = touches.currentY;

  // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore

  if (!preventEdgeSwipe(swiper, e, startX)) {
    return;
  }
  Object.assign(data, {
    isTouched: true,
    isMoved: false,
    allowTouchCallbacks: true,
    isScrolling: undefined,
    startMoving: undefined
  });
  touches.startX = startX;
  touches.startY = startY;
  data.touchStartTime = (0,utils.h)();
  swiper.allowClick = true;
  swiper.updateSize();
  swiper.swipeDirection = undefined;
  if (params.threshold > 0) data.allowThresholdMove = false;
  let preventDefault = true;
  if (targetEl.matches(data.focusableElements)) {
    preventDefault = false;
    if (targetEl.nodeName === 'SELECT') {
      data.isTouched = false;
    }
  }
  if (document.activeElement && document.activeElement.matches(data.focusableElements) && document.activeElement !== targetEl && (e.pointerType === 'mouse' || e.pointerType !== 'mouse' && !targetEl.matches(data.focusableElements))) {
    document.activeElement.blur();
  }
  const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
  if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) {
    e.preventDefault();
  }
  if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) {
    swiper.freeMode.onTouchStart();
  }
  swiper.emit('touchStart', e);
}

function onTouchMove(event) {
  const document = (0,ssr_window_esm.g)();
  const swiper = this;
  const data = swiper.touchEventsData;
  const {
    params,
    touches,
    rtlTranslate: rtl,
    enabled
  } = swiper;
  if (!enabled) return;
  if (!params.simulateTouch && event.pointerType === 'mouse') return;
  let e = event;
  if (e.originalEvent) e = e.originalEvent;
  if (e.type === 'pointermove') {
    if (data.touchId !== null) return; // return from pointer if we use touch
    const id = e.pointerId;
    if (id !== data.pointerId) return;
  }
  let targetTouch;
  if (e.type === 'touchmove') {
    targetTouch = [...e.changedTouches].find(t => t.identifier === data.touchId);
    if (!targetTouch || targetTouch.identifier !== data.touchId) return;
  } else {
    targetTouch = e;
  }
  if (!data.isTouched) {
    if (data.startMoving && data.isScrolling) {
      swiper.emit('touchMoveOpposite', e);
    }
    return;
  }
  const pageX = targetTouch.pageX;
  const pageY = targetTouch.pageY;
  if (e.preventedByNestedSwiper) {
    touches.startX = pageX;
    touches.startY = pageY;
    return;
  }
  if (!swiper.allowTouchMove) {
    if (!e.target.matches(data.focusableElements)) {
      swiper.allowClick = false;
    }
    if (data.isTouched) {
      Object.assign(touches, {
        startX: pageX,
        startY: pageY,
        currentX: pageX,
        currentY: pageY
      });
      data.touchStartTime = (0,utils.h)();
    }
    return;
  }
  if (params.touchReleaseOnEdges && !params.loop) {
    if (swiper.isVertical()) {
      // Vertical
      if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
        data.isTouched = false;
        data.isMoved = false;
        return;
      }
    } else if (rtl && (pageX > touches.startX && -swiper.translate <= swiper.maxTranslate() || pageX < touches.startX && -swiper.translate >= swiper.minTranslate())) {
      return;
    } else if (!rtl && (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate())) {
      return;
    }
  }
  if (document.activeElement && document.activeElement.matches(data.focusableElements) && document.activeElement !== e.target && e.pointerType !== 'mouse') {
    document.activeElement.blur();
  }
  if (document.activeElement) {
    if (e.target === document.activeElement && e.target.matches(data.focusableElements)) {
      data.isMoved = true;
      swiper.allowClick = false;
      return;
    }
  }
  if (data.allowTouchCallbacks) {
    swiper.emit('touchMove', e);
  }
  touches.previousX = touches.currentX;
  touches.previousY = touches.currentY;
  touches.currentX = pageX;
  touches.currentY = pageY;
  const diffX = touches.currentX - touches.startX;
  const diffY = touches.currentY - touches.startY;
  if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
  if (typeof data.isScrolling === 'undefined') {
    let touchAngle;
    if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
      data.isScrolling = false;
    } else {
      // eslint-disable-next-line
      if (diffX * diffX + diffY * diffY >= 25) {
        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
      }
    }
  }
  if (data.isScrolling) {
    swiper.emit('touchMoveOpposite', e);
  }
  if (typeof data.startMoving === 'undefined') {
    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
      data.startMoving = true;
    }
  }
  if (data.isScrolling || e.type === 'touchmove' && data.preventTouchMoveFromPointerMove) {
    data.isTouched = false;
    return;
  }
  if (!data.startMoving) {
    return;
  }
  swiper.allowClick = false;
  if (!params.cssMode && e.cancelable) {
    e.preventDefault();
  }
  if (params.touchMoveStopPropagation && !params.nested) {
    e.stopPropagation();
  }
  let diff = swiper.isHorizontal() ? diffX : diffY;
  let touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
  if (params.oneWayMovement) {
    diff = Math.abs(diff) * (rtl ? 1 : -1);
    touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
  }
  touches.diff = diff;
  diff *= params.touchRatio;
  if (rtl) {
    diff = -diff;
    touchesDiff = -touchesDiff;
  }
  const prevTouchesDirection = swiper.touchesDirection;
  swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
  swiper.touchesDirection = touchesDiff > 0 ? 'prev' : 'next';
  const isLoop = swiper.params.loop && !params.cssMode;
  const allowLoopFix = swiper.touchesDirection === 'next' && swiper.allowSlideNext || swiper.touchesDirection === 'prev' && swiper.allowSlidePrev;
  if (!data.isMoved) {
    if (isLoop && allowLoopFix) {
      swiper.loopFix({
        direction: swiper.swipeDirection
      });
    }
    data.startTranslate = swiper.getTranslate();
    swiper.setTransition(0);
    if (swiper.animating) {
      const evt = new window.CustomEvent('transitionend', {
        bubbles: true,
        cancelable: true,
        detail: {
          bySwiperTouchMove: true
        }
      });
      swiper.wrapperEl.dispatchEvent(evt);
    }
    data.allowMomentumBounce = false;
    // Grab Cursor
    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(true);
    }
    swiper.emit('sliderFirstMove', e);
  }
  let loopFixed;
  new Date().getTime();
  if (params._loopSwapReset !== false && data.isMoved && data.allowThresholdMove && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
    Object.assign(touches, {
      startX: pageX,
      startY: pageY,
      currentX: pageX,
      currentY: pageY,
      startTranslate: data.currentTranslate
    });
    data.loopSwapReset = true;
    data.startTranslate = data.currentTranslate;
    return;
  }
  swiper.emit('sliderMove', e);
  data.isMoved = true;
  data.currentTranslate = diff + data.startTranslate;
  let disableParentSwiper = true;
  let resistanceRatio = params.resistanceRatio;
  if (params.touchReleaseOnEdges) {
    resistanceRatio = 0;
  }
  if (diff > 0) {
    if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.slidesSizesGrid[swiper.activeIndex + 1] - (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.activeIndex + 1] + swiper.params.spaceBetween : 0) - swiper.params.spaceBetween : swiper.minTranslate())) {
      swiper.loopFix({
        direction: 'prev',
        setTranslate: true,
        activeSlideIndex: 0
      });
    }
    if (data.currentTranslate > swiper.minTranslate()) {
      disableParentSwiper = false;
      if (params.resistance) {
        data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
      }
    }
  } else if (diff < 0) {
    if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween + (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween : 0) : swiper.maxTranslate())) {
      swiper.loopFix({
        direction: 'next',
        setTranslate: true,
        activeSlideIndex: swiper.slides.length - (params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
      });
    }
    if (data.currentTranslate < swiper.maxTranslate()) {
      disableParentSwiper = false;
      if (params.resistance) {
        data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
      }
    }
  }
  if (disableParentSwiper) {
    e.preventedByNestedSwiper = true;
  }

  // Directions locks
  if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }
  if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }
  if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
    data.currentTranslate = data.startTranslate;
  }

  // Threshold
  if (params.threshold > 0) {
    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
      if (!data.allowThresholdMove) {
        data.allowThresholdMove = true;
        touches.startX = touches.currentX;
        touches.startY = touches.currentY;
        data.currentTranslate = data.startTranslate;
        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
        return;
      }
    } else {
      data.currentTranslate = data.startTranslate;
      return;
    }
  }
  if (!params.followFinger || params.cssMode) return;

  // Update active index in free mode
  if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }
  if (params.freeMode && params.freeMode.enabled && swiper.freeMode) {
    swiper.freeMode.onTouchMove();
  }
  // Update progress
  swiper.updateProgress(data.currentTranslate);
  // Update translate
  swiper.setTranslate(data.currentTranslate);
}

function onTouchEnd(event) {
  const swiper = this;
  const data = swiper.touchEventsData;
  let e = event;
  if (e.originalEvent) e = e.originalEvent;
  let targetTouch;
  const isTouchEvent = e.type === 'touchend' || e.type === 'touchcancel';
  if (!isTouchEvent) {
    if (data.touchId !== null) return; // return from pointer if we use touch
    if (e.pointerId !== data.pointerId) return;
    targetTouch = e;
  } else {
    targetTouch = [...e.changedTouches].find(t => t.identifier === data.touchId);
    if (!targetTouch || targetTouch.identifier !== data.touchId) return;
  }
  if (['pointercancel', 'pointerout', 'pointerleave', 'contextmenu'].includes(e.type)) {
    const proceed = ['pointercancel', 'contextmenu'].includes(e.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
    if (!proceed) {
      return;
    }
  }
  data.pointerId = null;
  data.touchId = null;
  const {
    params,
    touches,
    rtlTranslate: rtl,
    slidesGrid,
    enabled
  } = swiper;
  if (!enabled) return;
  if (!params.simulateTouch && e.pointerType === 'mouse') return;
  if (data.allowTouchCallbacks) {
    swiper.emit('touchEnd', e);
  }
  data.allowTouchCallbacks = false;
  if (!data.isTouched) {
    if (data.isMoved && params.grabCursor) {
      swiper.setGrabCursor(false);
    }
    data.isMoved = false;
    data.startMoving = false;
    return;
  }

  // Return Grab Cursor
  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
    swiper.setGrabCursor(false);
  }

  // Time diff
  const touchEndTime = (0,utils.h)();
  const timeDiff = touchEndTime - data.touchStartTime;

  // Tap, doubleTap, Click
  if (swiper.allowClick) {
    const pathTree = e.path || e.composedPath && e.composedPath();
    swiper.updateClickedSlide(pathTree && pathTree[0] || e.target, pathTree);
    swiper.emit('tap click', e);
    if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
      swiper.emit('doubleTap doubleClick', e);
    }
  }
  data.lastClickTime = (0,utils.h)();
  (0,utils.n)(() => {
    if (!swiper.destroyed) swiper.allowClick = true;
  });
  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 && !data.loopSwapReset || data.currentTranslate === data.startTranslate && !data.loopSwapReset) {
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    return;
  }
  data.isTouched = false;
  data.isMoved = false;
  data.startMoving = false;
  let currentPos;
  if (params.followFinger) {
    currentPos = rtl ? swiper.translate : -swiper.translate;
  } else {
    currentPos = -data.currentTranslate;
  }
  if (params.cssMode) {
    return;
  }
  if (params.freeMode && params.freeMode.enabled) {
    swiper.freeMode.onTouchEnd({
      currentPos
    });
    return;
  }

  // Find current slide
  const swipeToLast = currentPos >= -swiper.maxTranslate() && !swiper.params.loop;
  let stopIndex = 0;
  let groupSize = swiper.slidesSizesGrid[0];
  for (let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
    const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (typeof slidesGrid[i + increment] !== 'undefined') {
      if (swipeToLast || currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
        stopIndex = i;
        groupSize = slidesGrid[i + increment] - slidesGrid[i];
      }
    } else if (swipeToLast || currentPos >= slidesGrid[i]) {
      stopIndex = i;
      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
    }
  }
  let rewindFirstIndex = null;
  let rewindLastIndex = null;
  if (params.rewind) {
    if (swiper.isBeginning) {
      rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    } else if (swiper.isEnd) {
      rewindFirstIndex = 0;
    }
  }
  // Find current slide size
  const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
  const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
  if (timeDiff > params.longSwipesMs) {
    // Long touches
    if (!params.longSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    if (swiper.swipeDirection === 'next') {
      if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);else swiper.slideTo(stopIndex);
    }
    if (swiper.swipeDirection === 'prev') {
      if (ratio > 1 - params.longSwipesRatio) {
        swiper.slideTo(stopIndex + increment);
      } else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) {
        swiper.slideTo(rewindLastIndex);
      } else {
        swiper.slideTo(stopIndex);
      }
    }
  } else {
    // Short swipes
    if (!params.shortSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
    if (!isNavButtonTarget) {
      if (swiper.swipeDirection === 'next') {
        swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
      }
      if (swiper.swipeDirection === 'prev') {
        swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
      }
    } else if (e.target === swiper.navigation.nextEl) {
      swiper.slideTo(stopIndex + increment);
    } else {
      swiper.slideTo(stopIndex);
    }
  }
}

function onResize() {
  const swiper = this;
  const {
    params,
    el
  } = swiper;
  if (el && el.offsetWidth === 0) return;

  // Breakpoints
  if (params.breakpoints) {
    swiper.setBreakpoint();
  }

  // Save locks
  const {
    allowSlideNext,
    allowSlidePrev,
    snapGrid
  } = swiper;
  const isVirtual = swiper.virtual && swiper.params.virtual.enabled;

  // Disable locks on resize
  swiper.allowSlideNext = true;
  swiper.allowSlidePrev = true;
  swiper.updateSize();
  swiper.updateSlides();
  swiper.updateSlidesClasses();
  const isVirtualLoop = isVirtual && params.loop;
  if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) {
    swiper.slideTo(swiper.slides.length - 1, 0, false, true);
  } else {
    if (swiper.params.loop && !isVirtual) {
      swiper.slideToLoop(swiper.realIndex, 0, false, true);
    } else {
      swiper.slideTo(swiper.activeIndex, 0, false, true);
    }
  }
  if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
    clearTimeout(swiper.autoplay.resizeTimeout);
    swiper.autoplay.resizeTimeout = setTimeout(() => {
      if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        swiper.autoplay.resume();
      }
    }, 500);
  }
  // Return locks after resize
  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
    swiper.checkOverflow();
  }
}

function onClick(e) {
  const swiper = this;
  if (!swiper.enabled) return;
  if (!swiper.allowClick) {
    if (swiper.params.preventClicks) e.preventDefault();
    if (swiper.params.preventClicksPropagation && swiper.animating) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }
}

function onScroll() {
  const swiper = this;
  const {
    wrapperEl,
    rtlTranslate,
    enabled
  } = swiper;
  if (!enabled) return;
  swiper.previousTranslate = swiper.translate;
  if (swiper.isHorizontal()) {
    swiper.translate = -wrapperEl.scrollLeft;
  } else {
    swiper.translate = -wrapperEl.scrollTop;
  }
  // eslint-disable-next-line
  if (swiper.translate === 0) swiper.translate = 0;
  swiper.updateActiveIndex();
  swiper.updateSlidesClasses();
  let newProgress;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
  }
  if (newProgress !== swiper.progress) {
    swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
  }
  swiper.emit('setTranslate', swiper.translate, false);
}

function onLoad(e) {
  const swiper = this;
  processLazyPreloader(swiper, e.target);
  if (swiper.params.cssMode || swiper.params.slidesPerView !== 'auto' && !swiper.params.autoHeight) {
    return;
  }
  swiper.update();
}

function onDocumentTouchStart() {
  const swiper = this;
  if (swiper.documentTouchHandlerProceeded) return;
  swiper.documentTouchHandlerProceeded = true;
  if (swiper.params.touchReleaseOnEdges) {
    swiper.el.style.touchAction = 'auto';
  }
}

const events = (swiper, method) => {
  const document = (0,ssr_window_esm.g)();
  const {
    params,
    el,
    wrapperEl,
    device
  } = swiper;
  const capture = !!params.nested;
  const domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
  const swiperMethod = method;
  if (!el || typeof el === 'string') return;

  // Touch Events
  document[domMethod]('touchstart', swiper.onDocumentTouchStart, {
    passive: false,
    capture
  });
  el[domMethod]('touchstart', swiper.onTouchStart, {
    passive: false
  });
  el[domMethod]('pointerdown', swiper.onTouchStart, {
    passive: false
  });
  document[domMethod]('touchmove', swiper.onTouchMove, {
    passive: false,
    capture
  });
  document[domMethod]('pointermove', swiper.onTouchMove, {
    passive: false,
    capture
  });
  document[domMethod]('touchend', swiper.onTouchEnd, {
    passive: true
  });
  document[domMethod]('pointerup', swiper.onTouchEnd, {
    passive: true
  });
  document[domMethod]('pointercancel', swiper.onTouchEnd, {
    passive: true
  });
  document[domMethod]('touchcancel', swiper.onTouchEnd, {
    passive: true
  });
  document[domMethod]('pointerout', swiper.onTouchEnd, {
    passive: true
  });
  document[domMethod]('pointerleave', swiper.onTouchEnd, {
    passive: true
  });
  document[domMethod]('contextmenu', swiper.onTouchEnd, {
    passive: true
  });

  // Prevent Links Clicks
  if (params.preventClicks || params.preventClicksPropagation) {
    el[domMethod]('click', swiper.onClick, true);
  }
  if (params.cssMode) {
    wrapperEl[domMethod]('scroll', swiper.onScroll);
  }

  // Resize handler
  if (params.updateOnWindowResize) {
    swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize, true);
  } else {
    swiper[swiperMethod]('observerUpdate', onResize, true);
  }

  // Images loader
  el[domMethod]('load', swiper.onLoad, {
    capture: true
  });
};
function attachEvents() {
  const swiper = this;
  const {
    params
  } = swiper;
  swiper.onTouchStart = onTouchStart.bind(swiper);
  swiper.onTouchMove = onTouchMove.bind(swiper);
  swiper.onTouchEnd = onTouchEnd.bind(swiper);
  swiper.onDocumentTouchStart = onDocumentTouchStart.bind(swiper);
  if (params.cssMode) {
    swiper.onScroll = onScroll.bind(swiper);
  }
  swiper.onClick = onClick.bind(swiper);
  swiper.onLoad = onLoad.bind(swiper);
  events(swiper, 'on');
}
function detachEvents() {
  const swiper = this;
  events(swiper, 'off');
}
var events$1 = {
  attachEvents,
  detachEvents
};

const isGridEnabled = (swiper, params) => {
  return swiper.grid && params.grid && params.grid.rows > 1;
};
function setBreakpoint() {
  const swiper = this;
  const {
    realIndex,
    initialized,
    params,
    el
  } = swiper;
  const breakpoints = params.breakpoints;
  if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;
  const document = (0,ssr_window_esm.g)();

  // Get breakpoint for window/container width and update parameters
  const breakpointsBase = params.breakpointsBase === 'window' || !params.breakpointsBase ? params.breakpointsBase : 'container';
  const breakpointContainer = ['window', 'container'].includes(params.breakpointsBase) || !params.breakpointsBase ? swiper.el : document.querySelector(params.breakpointsBase);
  const breakpoint = swiper.getBreakpoint(breakpoints, breakpointsBase, breakpointContainer);
  if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
  const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
  const breakpointParams = breakpointOnlyParams || swiper.originalParams;
  const wasMultiRow = isGridEnabled(swiper, params);
  const isMultiRow = isGridEnabled(swiper, breakpointParams);
  const wasGrabCursor = swiper.params.grabCursor;
  const isGrabCursor = breakpointParams.grabCursor;
  const wasEnabled = params.enabled;
  if (wasMultiRow && !isMultiRow) {
    el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
    swiper.emitContainerClasses();
  } else if (!wasMultiRow && isMultiRow) {
    el.classList.add(`${params.containerModifierClass}grid`);
    if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') {
      el.classList.add(`${params.containerModifierClass}grid-column`);
    }
    swiper.emitContainerClasses();
  }
  if (wasGrabCursor && !isGrabCursor) {
    swiper.unsetGrabCursor();
  } else if (!wasGrabCursor && isGrabCursor) {
    swiper.setGrabCursor();
  }

  // Toggle navigation, pagination, scrollbar
  ['navigation', 'pagination', 'scrollbar'].forEach(prop => {
    if (typeof breakpointParams[prop] === 'undefined') return;
    const wasModuleEnabled = params[prop] && params[prop].enabled;
    const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
    if (wasModuleEnabled && !isModuleEnabled) {
      swiper[prop].disable();
    }
    if (!wasModuleEnabled && isModuleEnabled) {
      swiper[prop].enable();
    }
  });
  const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
  const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
  const wasLoop = params.loop;
  if (directionChanged && initialized) {
    swiper.changeDirection();
  }
  (0,utils.x)(swiper.params, breakpointParams);
  const isEnabled = swiper.params.enabled;
  const hasLoop = swiper.params.loop;
  Object.assign(swiper, {
    allowTouchMove: swiper.params.allowTouchMove,
    allowSlideNext: swiper.params.allowSlideNext,
    allowSlidePrev: swiper.params.allowSlidePrev
  });
  if (wasEnabled && !isEnabled) {
    swiper.disable();
  } else if (!wasEnabled && isEnabled) {
    swiper.enable();
  }
  swiper.currentBreakpoint = breakpoint;
  swiper.emit('_beforeBreakpoint', breakpointParams);
  if (initialized) {
    if (needsReLoop) {
      swiper.loopDestroy();
      swiper.loopCreate(realIndex);
      swiper.updateSlides();
    } else if (!wasLoop && hasLoop) {
      swiper.loopCreate(realIndex);
      swiper.updateSlides();
    } else if (wasLoop && !hasLoop) {
      swiper.loopDestroy();
    }
  }
  swiper.emit('breakpoint', breakpointParams);
}

function getBreakpoint(breakpoints, base = 'window', containerEl) {
  if (!breakpoints || base === 'container' && !containerEl) return undefined;
  let breakpoint = false;
  const window = (0,ssr_window_esm.a)();
  const currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
  const points = Object.keys(breakpoints).map(point => {
    if (typeof point === 'string' && point.indexOf('@') === 0) {
      const minRatio = parseFloat(point.substr(1));
      const value = currentHeight * minRatio;
      return {
        value,
        point
      };
    }
    return {
      value: point,
      point
    };
  });
  points.sort((a, b) => parseInt(a.value, 10) - parseInt(b.value, 10));
  for (let i = 0; i < points.length; i += 1) {
    const {
      point,
      value
    } = points[i];
    if (base === 'window') {
      if (window.matchMedia(`(min-width: ${value}px)`).matches) {
        breakpoint = point;
      }
    } else if (value <= containerEl.clientWidth) {
      breakpoint = point;
    }
  }
  return breakpoint || 'max';
}

var breakpoints = {
  setBreakpoint,
  getBreakpoint
};

function prepareClasses(entries, prefix) {
  const resultClasses = [];
  entries.forEach(item => {
    if (typeof item === 'object') {
      Object.keys(item).forEach(classNames => {
        if (item[classNames]) {
          resultClasses.push(prefix + classNames);
        }
      });
    } else if (typeof item === 'string') {
      resultClasses.push(prefix + item);
    }
  });
  return resultClasses;
}
function addClasses() {
  const swiper = this;
  const {
    classNames,
    params,
    rtl,
    el,
    device
  } = swiper;
  // prettier-ignore
  const suffixes = prepareClasses(['initialized', params.direction, {
    'free-mode': swiper.params.freeMode && params.freeMode.enabled
  }, {
    'autoheight': params.autoHeight
  }, {
    'rtl': rtl
  }, {
    'grid': params.grid && params.grid.rows > 1
  }, {
    'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
  }, {
    'android': device.android
  }, {
    'ios': device.ios
  }, {
    'css-mode': params.cssMode
  }, {
    'centered': params.cssMode && params.centeredSlides
  }, {
    'watch-progress': params.watchSlidesProgress
  }], params.containerModifierClass);
  classNames.push(...suffixes);
  el.classList.add(...classNames);
  swiper.emitContainerClasses();
}

function removeClasses() {
  const swiper = this;
  const {
    el,
    classNames
  } = swiper;
  if (!el || typeof el === 'string') return;
  el.classList.remove(...classNames);
  swiper.emitContainerClasses();
}

var classes = {
  addClasses,
  removeClasses
};

function checkOverflow() {
  const swiper = this;
  const {
    isLocked: wasLocked,
    params
  } = swiper;
  const {
    slidesOffsetBefore
  } = params;
  if (slidesOffsetBefore) {
    const lastSlideIndex = swiper.slides.length - 1;
    const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
    swiper.isLocked = swiper.size > lastSlideRightEdge;
  } else {
    swiper.isLocked = swiper.snapGrid.length === 1;
  }
  if (params.allowSlideNext === true) {
    swiper.allowSlideNext = !swiper.isLocked;
  }
  if (params.allowSlidePrev === true) {
    swiper.allowSlidePrev = !swiper.isLocked;
  }
  if (wasLocked && wasLocked !== swiper.isLocked) {
    swiper.isEnd = false;
  }
  if (wasLocked !== swiper.isLocked) {
    swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
  }
}
var checkOverflow$1 = {
  checkOverflow
};

var defaults = {
  init: true,
  direction: 'horizontal',
  oneWayMovement: false,
  swiperElementNodeName: 'SWIPER-CONTAINER',
  touchEventsTarget: 'wrapper',
  initialSlide: 0,
  speed: 300,
  cssMode: false,
  updateOnWindowResize: true,
  resizeObserver: true,
  nested: false,
  createElements: false,
  eventsPrefix: 'swiper',
  enabled: true,
  focusableElements: 'input, select, option, textarea, button, video, label',
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: false,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: false,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: false,
  // Set wrapper width
  setWrapperSize: false,
  // Virtual Translate
  virtualTranslate: false,
  // Effects
  effect: 'slide',
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'

  // Breakpoints
  breakpoints: undefined,
  breakpointsBase: 'window',
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: false,
  centeredSlides: false,
  centeredSlidesBounds: false,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: true,
  centerInsufficientSlides: false,
  snapToSlideEdge: false,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: true,
  // Round length
  roundLengths: false,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: true,
  shortSwipes: true,
  longSwipes: true,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: true,
  allowTouchMove: true,
  threshold: 5,
  touchMoveStopPropagation: false,
  touchStartPreventDefault: true,
  touchStartForcePreventDefault: false,
  touchReleaseOnEdges: false,
  // Unique Navigation Elements
  uniqueNavElements: true,
  // Resistance
  resistance: true,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: false,
  // Cursor
  grabCursor: false,
  // Clicks
  preventClicks: true,
  preventClicksPropagation: true,
  slideToClickedSlide: false,
  // loop
  loop: false,
  loopAddBlankSlides: true,
  loopAdditionalSlides: 0,
  loopPreventsSliding: true,
  // rewind
  rewind: false,
  // Swiping/no swiping
  allowSlidePrev: true,
  allowSlideNext: true,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: true,
  noSwipingClass: 'swiper-no-swiping',
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: true,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: 'swiper-',
  // NEW
  slideClass: 'swiper-slide',
  slideBlankClass: 'swiper-slide-blank',
  slideActiveClass: 'swiper-slide-active',
  slideVisibleClass: 'swiper-slide-visible',
  slideFullyVisibleClass: 'swiper-slide-fully-visible',
  slideNextClass: 'swiper-slide-next',
  slidePrevClass: 'swiper-slide-prev',
  wrapperClass: 'swiper-wrapper',
  lazyPreloaderClass: 'swiper-lazy-preloader',
  lazyPreloadPrevNext: 0,
  // Callbacks
  runCallbacksOnInit: true,
  // Internals
  _emitClasses: false
};

function moduleExtendParams(params, allModulesParams) {
  return function extendParams(obj = {}) {
    const moduleParamName = Object.keys(obj)[0];
    const moduleParams = obj[moduleParamName];
    if (typeof moduleParams !== 'object' || moduleParams === null) {
      (0,utils.x)(allModulesParams, obj);
      return;
    }
    if (params[moduleParamName] === true) {
      params[moduleParamName] = {
        enabled: true
      };
    }
    if (moduleParamName === 'navigation' && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) {
      params[moduleParamName].auto = true;
    }
    if (['pagination', 'scrollbar'].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) {
      params[moduleParamName].auto = true;
    }
    if (!(moduleParamName in params && 'enabled' in moduleParams)) {
      (0,utils.x)(allModulesParams, obj);
      return;
    }
    if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) {
      params[moduleParamName].enabled = true;
    }
    if (!params[moduleParamName]) params[moduleParamName] = {
      enabled: false
    };
    (0,utils.x)(allModulesParams, obj);
  };
}

/* eslint no-param-reassign: "off" */
const prototypes = {
  eventsEmitter,
  update,
  translate,
  transition,
  slide,
  loop,
  grabCursor,
  events: events$1,
  breakpoints,
  checkOverflow: checkOverflow$1,
  classes
};
const extendedDefaults = {};
class Swiper {
  constructor(...args) {
    let el;
    let params;
    if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') {
      params = args[0];
    } else {
      [el, params] = args;
    }
    if (!params) params = {};
    params = (0,utils.x)({}, params);
    if (el && !params.el) params.el = el;
    const document = (0,ssr_window_esm.g)();
    if (params.el && typeof params.el === 'string' && document.querySelectorAll(params.el).length > 1) {
      const swipers = [];
      document.querySelectorAll(params.el).forEach(containerEl => {
        const newParams = (0,utils.x)({}, params, {
          el: containerEl
        });
        swipers.push(new Swiper(newParams));
      });
      // eslint-disable-next-line no-constructor-return
      return swipers;
    }

    // Swiper Instance
    const swiper = this;
    swiper.__swiper__ = true;
    swiper.support = getSupport();
    swiper.device = getDevice({
      userAgent: params.userAgent
    });
    swiper.browser = getBrowser();
    swiper.eventsListeners = {};
    swiper.eventsAnyListeners = [];
    swiper.modules = [...swiper.__modules__];
    if (params.modules && Array.isArray(params.modules)) {
      swiper.modules.push(...params.modules);
    }
    const allModulesParams = {};
    swiper.modules.forEach(mod => {
      mod({
        params,
        swiper,
        extendParams: moduleExtendParams(params, allModulesParams),
        on: swiper.on.bind(swiper),
        once: swiper.once.bind(swiper),
        off: swiper.off.bind(swiper),
        emit: swiper.emit.bind(swiper)
      });
    });

    // Extend defaults with modules params
    const swiperParams = (0,utils.x)({}, defaults, allModulesParams);

    // Extend defaults with passed params
    swiper.params = (0,utils.x)({}, swiperParams, extendedDefaults, params);
    swiper.originalParams = (0,utils.x)({}, swiper.params);
    swiper.passedParams = (0,utils.x)({}, params);

    // add event listeners
    if (swiper.params && swiper.params.on) {
      Object.keys(swiper.params.on).forEach(eventName => {
        swiper.on(eventName, swiper.params.on[eventName]);
      });
    }
    if (swiper.params && swiper.params.onAny) {
      swiper.onAny(swiper.params.onAny);
    }

    // Extend Swiper
    Object.assign(swiper, {
      enabled: swiper.params.enabled,
      el,
      // Classes
      classNames: [],
      // Slides
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return swiper.params.direction === 'horizontal';
      },
      isVertical() {
        return swiper.params.direction === 'vertical';
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: true,
      isEnd: false,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: false,
      cssOverflowAdjustment() {
        // Returns 0 unless `translate` is > 2**23
        // Should be subtracted from css values to prevent overflow
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
      },
      // Locks
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev,
      // Touch Events
      touchEventsData: {
        isTouched: undefined,
        isMoved: undefined,
        allowTouchCallbacks: undefined,
        touchStartTime: undefined,
        isScrolling: undefined,
        currentTranslate: undefined,
        startTranslate: undefined,
        allowThresholdMove: undefined,
        // Form elements to match
        focusableElements: swiper.params.focusableElements,
        // Last click time
        lastClickTime: 0,
        clickTimeout: undefined,
        // Velocities
        velocities: [],
        allowMomentumBounce: undefined,
        startMoving: undefined,
        pointerId: null,
        touchId: null
      },
      // Clicks
      allowClick: true,
      // Touches
      allowTouchMove: swiper.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    });
    swiper.emit('_swiper');

    // Init
    if (swiper.params.init) {
      swiper.init();
    }

    // Return app instance
    // eslint-disable-next-line no-constructor-return
    return swiper;
  }
  getDirectionLabel(property) {
    if (this.isHorizontal()) {
      return property;
    }
    // prettier-ignore
    return {
      'width': 'height',
      'margin-top': 'margin-left',
      'margin-bottom ': 'margin-right',
      'margin-left': 'margin-top',
      'margin-right': 'margin-bottom',
      'padding-left': 'padding-top',
      'padding-right': 'padding-bottom',
      'marginRight': 'marginBottom'
    }[property];
  }
  getSlideIndex(slideEl) {
    const {
      slidesEl,
      params
    } = this;
    const slides = (0,utils.e)(slidesEl, `.${params.slideClass}, swiper-slide`);
    const firstSlideIndex = (0,utils.j)(slides[0]);
    return (0,utils.j)(slideEl) - firstSlideIndex;
  }
  getSlideIndexByData(index) {
    return this.getSlideIndex(this.slides.find(slideEl => slideEl.getAttribute('data-swiper-slide-index') * 1 === index));
  }
  getSlideIndexWhenGrid(index) {
    if (this.grid && this.params.grid && this.params.grid.rows > 1) {
      if (this.params.grid.fill === 'column') {
        index = Math.floor(index / this.params.grid.rows);
      } else if (this.params.grid.fill === 'row') {
        index = index % Math.ceil(this.slides.length / this.params.grid.rows);
      }
    }
    return index;
  }
  recalcSlides() {
    const swiper = this;
    const {
      slidesEl,
      params
    } = swiper;
    swiper.slides = (0,utils.e)(slidesEl, `.${params.slideClass}, swiper-slide`);
  }
  enable() {
    const swiper = this;
    if (swiper.enabled) return;
    swiper.enabled = true;
    if (swiper.params.grabCursor) {
      swiper.setGrabCursor();
    }
    swiper.emit('enable');
  }
  disable() {
    const swiper = this;
    if (!swiper.enabled) return;
    swiper.enabled = false;
    if (swiper.params.grabCursor) {
      swiper.unsetGrabCursor();
    }
    swiper.emit('disable');
  }
  setProgress(progress, speed) {
    const swiper = this;
    progress = Math.min(Math.max(progress, 0), 1);
    const min = swiper.minTranslate();
    const max = swiper.maxTranslate();
    const current = (max - min) * progress + min;
    swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }
  emitContainerClasses() {
    const swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    const cls = swiper.el.className.split(' ').filter(className => {
      return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
    });
    swiper.emit('_containerClasses', cls.join(' '));
  }
  getSlideClasses(slideEl) {
    const swiper = this;
    if (swiper.destroyed) return '';
    return slideEl.className.split(' ').filter(className => {
      return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
    }).join(' ');
  }
  emitSlidesClasses() {
    const swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    const updates = [];
    swiper.slides.forEach(slideEl => {
      const classNames = swiper.getSlideClasses(slideEl);
      updates.push({
        slideEl,
        classNames
      });
      swiper.emit('_slideClass', slideEl, classNames);
    });
    swiper.emit('_slideClasses', updates);
  }
  slidesPerViewDynamic(view = 'current', exact = false) {
    const swiper = this;
    const {
      params,
      slides,
      slidesGrid,
      slidesSizesGrid,
      size: swiperSize,
      activeIndex
    } = swiper;
    let spv = 1;
    if (typeof params.slidesPerView === 'number') return params.slidesPerView;
    if (params.centeredSlides) {
      let slideSize = slides[activeIndex] ? Math.ceil(slides[activeIndex].swiperSlideSize) : 0;
      let breakLoop;
      for (let i = activeIndex + 1; i < slides.length; i += 1) {
        if (slides[i] && !breakLoop) {
          slideSize += Math.ceil(slides[i].swiperSlideSize);
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }
      for (let i = activeIndex - 1; i >= 0; i -= 1) {
        if (slides[i] && !breakLoop) {
          slideSize += slides[i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }
    } else {
      // eslint-disable-next-line
      if (view === 'current') {
        for (let i = activeIndex + 1; i < slides.length; i += 1) {
          const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
          if (slideInView) {
            spv += 1;
          }
        }
      } else {
        // previous
        for (let i = activeIndex - 1; i >= 0; i -= 1) {
          const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
          if (slideInView) {
            spv += 1;
          }
        }
      }
    }
    return spv;
  }
  update() {
    const swiper = this;
    if (!swiper || swiper.destroyed) return;
    const {
      snapGrid,
      params
    } = swiper;
    // Breakpoints
    if (params.breakpoints) {
      swiper.setBreakpoint();
    }
    [...swiper.el.querySelectorAll('[loading="lazy"]')].forEach(imageEl => {
      if (imageEl.complete) {
        processLazyPreloader(swiper, imageEl);
      }
    });
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateProgress();
    swiper.updateSlidesClasses();
    function setTranslate() {
      const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
      const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
      swiper.setTranslate(newTranslate);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
    let translated;
    if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
      setTranslate();
      if (params.autoHeight) {
        swiper.updateAutoHeight();
      }
    } else {
      if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
        const slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
        translated = swiper.slideTo(slides.length - 1, 0, false, true);
      } else {
        translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
      }
      if (!translated) {
        setTranslate();
      }
    }
    if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }
    swiper.emit('update');
  }
  changeDirection(newDirection, needUpdate = true) {
    const swiper = this;
    const currentDirection = swiper.params.direction;
    if (!newDirection) {
      // eslint-disable-next-line
      newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
    }
    if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
      return swiper;
    }
    swiper.el.classList.remove(`${swiper.params.containerModifierClass}${currentDirection}`);
    swiper.el.classList.add(`${swiper.params.containerModifierClass}${newDirection}`);
    swiper.emitContainerClasses();
    swiper.params.direction = newDirection;
    swiper.slides.forEach(slideEl => {
      if (newDirection === 'vertical') {
        slideEl.style.width = '';
      } else {
        slideEl.style.height = '';
      }
    });
    swiper.emit('changeDirection');
    if (needUpdate) swiper.update();
    return swiper;
  }
  changeLanguageDirection(direction) {
    const swiper = this;
    if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
    swiper.rtl = direction === 'rtl';
    swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;
    if (swiper.rtl) {
      swiper.el.classList.add(`${swiper.params.containerModifierClass}rtl`);
      swiper.el.dir = 'rtl';
    } else {
      swiper.el.classList.remove(`${swiper.params.containerModifierClass}rtl`);
      swiper.el.dir = 'ltr';
    }
    swiper.update();
  }
  mount(element) {
    const swiper = this;
    if (swiper.mounted) return true;

    // Find el
    let el = element || swiper.params.el;
    if (typeof el === 'string') {
      el = document.querySelector(el);
    }
    if (!el) {
      return false;
    }
    el.swiper = swiper;
    if (el.parentNode && el.parentNode.host && el.parentNode.host.nodeName === swiper.params.swiperElementNodeName.toUpperCase()) {
      swiper.isElement = true;
    }
    const getWrapperSelector = () => {
      return `.${(swiper.params.wrapperClass || '').trim().split(' ').join('.')}`;
    };
    const getWrapper = () => {
      if (el && el.shadowRoot && el.shadowRoot.querySelector) {
        const res = el.shadowRoot.querySelector(getWrapperSelector());
        // Children needs to return slot items
        return res;
      }
      return (0,utils.e)(el, getWrapperSelector())[0];
    };
    // Find Wrapper
    let wrapperEl = getWrapper();
    if (!wrapperEl && swiper.params.createElements) {
      wrapperEl = (0,utils.c)('div', swiper.params.wrapperClass);
      el.append(wrapperEl);
      (0,utils.e)(el, `.${swiper.params.slideClass}`).forEach(slideEl => {
        wrapperEl.append(slideEl);
      });
    }
    Object.assign(swiper, {
      el,
      wrapperEl,
      slidesEl: swiper.isElement && !el.parentNode.host.slideSlots ? el.parentNode.host : wrapperEl,
      hostEl: swiper.isElement ? el.parentNode.host : el,
      mounted: true,
      // RTL
      rtl: el.dir.toLowerCase() === 'rtl' || (0,utils.q)(el, 'direction') === 'rtl',
      rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || (0,utils.q)(el, 'direction') === 'rtl'),
      wrongRTL: (0,utils.q)(wrapperEl, 'display') === '-webkit-box'
    });
    return true;
  }
  init(el) {
    const swiper = this;
    if (swiper.initialized) return swiper;
    const mounted = swiper.mount(el);
    if (mounted === false) return swiper;
    swiper.emit('beforeInit');

    // Set breakpoint
    if (swiper.params.breakpoints) {
      swiper.setBreakpoint();
    }

    // Add Classes
    swiper.addClasses();

    // Update size
    swiper.updateSize();

    // Update slides
    swiper.updateSlides();
    if (swiper.params.watchOverflow) {
      swiper.checkOverflow();
    }

    // Set Grab Cursor
    if (swiper.params.grabCursor && swiper.enabled) {
      swiper.setGrabCursor();
    }

    // Slide To Initial Slide
    if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
      swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
    } else {
      swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
    }

    // Create loop
    if (swiper.params.loop) {
      swiper.loopCreate(undefined, true);
    }

    // Attach events
    swiper.attachEvents();
    const lazyElements = [...swiper.el.querySelectorAll('[loading="lazy"]')];
    if (swiper.isElement) {
      lazyElements.push(...swiper.hostEl.querySelectorAll('[loading="lazy"]'));
    }
    lazyElements.forEach(imageEl => {
      if (imageEl.complete) {
        processLazyPreloader(swiper, imageEl);
      } else {
        imageEl.addEventListener('load', e => {
          processLazyPreloader(swiper, e.target);
        });
      }
    });
    preload(swiper);

    // Init Flag
    swiper.initialized = true;
    preload(swiper);

    // Emit
    swiper.emit('init');
    swiper.emit('afterInit');
    return swiper;
  }
  destroy(deleteInstance = true, cleanStyles = true) {
    const swiper = this;
    const {
      params,
      el,
      wrapperEl,
      slides
    } = swiper;
    if (typeof swiper.params === 'undefined' || swiper.destroyed) {
      return null;
    }
    swiper.emit('beforeDestroy');

    // Init Flag
    swiper.initialized = false;

    // Detach events
    swiper.detachEvents();

    // Destroy loop
    if (params.loop) {
      swiper.loopDestroy();
    }

    // Cleanup styles
    if (cleanStyles) {
      swiper.removeClasses();
      if (el && typeof el !== 'string') {
        el.removeAttribute('style');
      }
      if (wrapperEl) {
        wrapperEl.removeAttribute('style');
      }
      if (slides && slides.length) {
        slides.forEach(slideEl => {
          slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
          slideEl.removeAttribute('style');
          slideEl.removeAttribute('data-swiper-slide-index');
        });
      }
    }
    swiper.emit('destroy');

    // Detach emitter events
    Object.keys(swiper.eventsListeners).forEach(eventName => {
      swiper.off(eventName);
    });
    if (deleteInstance !== false) {
      if (swiper.el && typeof swiper.el !== 'string') {
        swiper.el.swiper = null;
      }
      (0,utils.y)(swiper);
    }
    swiper.destroyed = true;
    return null;
  }
  static extendDefaults(newDefaults) {
    (0,utils.x)(extendedDefaults, newDefaults);
  }
  static get extendedDefaults() {
    return extendedDefaults;
  }
  static get defaults() {
    return defaults;
  }
  static installModule(mod) {
    if (!Swiper.prototype.__modules__) Swiper.prototype.__modules__ = [];
    const modules = Swiper.prototype.__modules__;
    if (typeof mod === 'function' && modules.indexOf(mod) < 0) {
      modules.push(mod);
    }
  }
  static use(module) {
    if (Array.isArray(module)) {
      module.forEach(m => Swiper.installModule(m));
      return Swiper;
    }
    Swiper.installModule(module);
    return Swiper;
  }
}
Object.keys(prototypes).forEach(prototypeGroup => {
  Object.keys(prototypes[prototypeGroup]).forEach(protoMethod => {
    Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
  });
});
Swiper.use([Resize, Observer]);



;// CONCATENATED MODULE: ../node_modules/swiper/shared/update-swiper.mjs


/* underscore in name -> watch for changes */
const paramsList = ['eventsPrefix', 'injectStyles', 'injectStylesUrls', 'modules', 'init', '_direction', 'oneWayMovement', 'swiperElementNodeName', 'touchEventsTarget', 'initialSlide', '_speed', 'cssMode', 'updateOnWindowResize', 'resizeObserver', 'nested', 'focusableElements', '_enabled', '_width', '_height', 'preventInteractionOnTransition', 'userAgent', 'url', '_edgeSwipeDetection', '_edgeSwipeThreshold', '_freeMode', '_autoHeight', 'setWrapperSize', 'virtualTranslate', '_effect', 'breakpoints', 'breakpointsBase', '_spaceBetween', '_slidesPerView', 'maxBackfaceHiddenSlides', '_grid', '_slidesPerGroup', '_slidesPerGroupSkip', '_slidesPerGroupAuto', '_centeredSlides', '_centeredSlidesBounds', '_slidesOffsetBefore', '_slidesOffsetAfter', 'normalizeSlideIndex', '_centerInsufficientSlides', '_snapToSlideEdge', '_watchOverflow', 'roundLengths', 'touchRatio', 'touchAngle', 'simulateTouch', '_shortSwipes', '_longSwipes', 'longSwipesRatio', 'longSwipesMs', '_followFinger', 'allowTouchMove', '_threshold', 'touchMoveStopPropagation', 'touchStartPreventDefault', 'touchStartForcePreventDefault', 'touchReleaseOnEdges', 'uniqueNavElements', '_resistance', '_resistanceRatio', '_watchSlidesProgress', '_grabCursor', 'preventClicks', 'preventClicksPropagation', '_slideToClickedSlide', '_loop', 'loopAdditionalSlides', 'loopAddBlankSlides', 'loopPreventsSliding', '_rewind', '_allowSlidePrev', '_allowSlideNext', '_swipeHandler', '_noSwiping', 'noSwipingClass', 'noSwipingSelector', 'passiveListeners', 'containerModifierClass', 'slideClass', 'slideActiveClass', 'slideVisibleClass', 'slideFullyVisibleClass', 'slideNextClass', 'slidePrevClass', 'slideBlankClass', 'wrapperClass', 'lazyPreloaderClass', 'lazyPreloadPrevNext', 'runCallbacksOnInit', 'observer', 'observeParents', 'observeSlideChildren',
// modules
'a11y', '_autoplay', '_controller', 'coverflowEffect', 'cubeEffect', 'fadeEffect', 'flipEffect', 'creativeEffect', 'cardsEffect', 'hashNavigation', 'history', 'keyboard', 'mousewheel', '_navigation', '_pagination', 'parallax', '_scrollbar', '_thumbs', 'virtual', 'zoom', 'control'];

function isObject(o) {
  return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object' && !o.__swiper__;
}
function extend(target, src) {
  const noExtend = ['__proto__', 'constructor', 'prototype'];
  Object.keys(src).filter(key => noExtend.indexOf(key) < 0).forEach(key => {
    if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
      if (src[key].__swiper__) target[key] = src[key];else extend(target[key], src[key]);
    } else {
      target[key] = src[key];
    }
  });
}
function needsNavigation(params = {}) {
  return params.navigation && typeof params.navigation.nextEl === 'undefined' && typeof params.navigation.prevEl === 'undefined';
}
function needsPagination(params = {}) {
  return params.pagination && typeof params.pagination.el === 'undefined';
}
function needsScrollbar(params = {}) {
  return params.scrollbar && typeof params.scrollbar.el === 'undefined';
}
function uniqueClasses(classNames = '') {
  const classes = classNames.split(' ').map(c => c.trim()).filter(c => !!c);
  const unique = [];
  classes.forEach(c => {
    if (unique.indexOf(c) < 0) unique.push(c);
  });
  return unique.join(' ');
}
function attrToProp(attrName = '') {
  return attrName.replace(/-[a-z]/g, l => l.toUpperCase().replace('-', ''));
}
function wrapperClass(className = '') {
  if (!className) return 'swiper-wrapper';
  if (!className.includes('swiper-wrapper')) return `swiper-wrapper ${className}`;
  return className;
}

function updateSwiper({
  swiper,
  slides,
  passedParams,
  changedParams,
  nextEl,
  prevEl,
  scrollbarEl,
  paginationEl
}) {
  const updateParams = changedParams.filter(key => key !== 'children' && key !== 'direction' && key !== 'wrapperClass');
  const {
    params: currentParams,
    pagination,
    navigation,
    scrollbar,
    virtual,
    thumbs
  } = swiper;
  let needThumbsInit;
  let needControllerInit;
  let needPaginationInit;
  let needScrollbarInit;
  let needNavigationInit;
  let loopNeedDestroy;
  let loopNeedEnable;
  let loopNeedReloop;
  if (changedParams.includes('thumbs') && passedParams.thumbs && passedParams.thumbs.swiper && !passedParams.thumbs.swiper.destroyed && currentParams.thumbs && (!currentParams.thumbs.swiper || currentParams.thumbs.swiper.destroyed)) {
    needThumbsInit = true;
  }
  if (changedParams.includes('controller') && passedParams.controller && passedParams.controller.control && currentParams.controller && !currentParams.controller.control) {
    needControllerInit = true;
  }
  if (changedParams.includes('pagination') && passedParams.pagination && (passedParams.pagination.el || paginationEl) && (currentParams.pagination || currentParams.pagination === false) && pagination && !pagination.el) {
    needPaginationInit = true;
  }
  if (changedParams.includes('scrollbar') && passedParams.scrollbar && (passedParams.scrollbar.el || scrollbarEl) && (currentParams.scrollbar || currentParams.scrollbar === false) && scrollbar && !scrollbar.el) {
    needScrollbarInit = true;
  }
  if (changedParams.includes('navigation') && passedParams.navigation && (passedParams.navigation.prevEl || prevEl) && (passedParams.navigation.nextEl || nextEl) && (currentParams.navigation || currentParams.navigation === false) && navigation && !navigation.prevEl && !navigation.nextEl) {
    needNavigationInit = true;
  }
  const destroyModule = mod => {
    if (!swiper[mod]) return;
    swiper[mod].destroy();
    if (mod === 'navigation') {
      if (swiper.isElement) {
        swiper[mod].prevEl.remove();
        swiper[mod].nextEl.remove();
      }
      currentParams[mod].prevEl = undefined;
      currentParams[mod].nextEl = undefined;
      swiper[mod].prevEl = undefined;
      swiper[mod].nextEl = undefined;
    } else {
      if (swiper.isElement) {
        swiper[mod].el.remove();
      }
      currentParams[mod].el = undefined;
      swiper[mod].el = undefined;
    }
  };
  if (changedParams.includes('loop') && swiper.isElement) {
    if (currentParams.loop && !passedParams.loop) {
      loopNeedDestroy = true;
    } else if (!currentParams.loop && passedParams.loop) {
      loopNeedEnable = true;
    } else {
      loopNeedReloop = true;
    }
  }
  updateParams.forEach(key => {
    if (isObject(currentParams[key]) && isObject(passedParams[key])) {
      Object.assign(currentParams[key], passedParams[key]);
      if ((key === 'navigation' || key === 'pagination' || key === 'scrollbar') && 'enabled' in passedParams[key] && !passedParams[key].enabled) {
        destroyModule(key);
      }
    } else {
      const newValue = passedParams[key];
      if ((newValue === true || newValue === false) && (key === 'navigation' || key === 'pagination' || key === 'scrollbar')) {
        if (newValue === false) {
          destroyModule(key);
        }
      } else {
        currentParams[key] = passedParams[key];
      }
    }
  });
  if (updateParams.includes('controller') && !needControllerInit && swiper.controller && swiper.controller.control && currentParams.controller && currentParams.controller.control) {
    swiper.controller.control = currentParams.controller.control;
  }
  if (changedParams.includes('children') && slides && virtual && currentParams.virtual.enabled) {
    virtual.slides = slides;
    virtual.update(true);
  } else if (changedParams.includes('virtual') && virtual && currentParams.virtual.enabled) {
    if (slides) virtual.slides = slides;
    virtual.update(true);
  }
  if (changedParams.includes('children') && slides && currentParams.loop) {
    loopNeedReloop = true;
  }
  if (needThumbsInit) {
    const initialized = thumbs.init();
    if (initialized) thumbs.update(true);
  }
  if (needControllerInit) {
    swiper.controller.control = currentParams.controller.control;
  }
  if (needPaginationInit) {
    if (swiper.isElement && (!paginationEl || typeof paginationEl === 'string')) {
      paginationEl = document.createElement('div');
      paginationEl.classList.add('swiper-pagination');
      paginationEl.part.add('pagination');
      swiper.el.appendChild(paginationEl);
    }
    if (paginationEl) currentParams.pagination.el = paginationEl;
    pagination.init();
    pagination.render();
    pagination.update();
  }
  if (needScrollbarInit) {
    if (swiper.isElement && (!scrollbarEl || typeof scrollbarEl === 'string')) {
      scrollbarEl = document.createElement('div');
      scrollbarEl.classList.add('swiper-scrollbar');
      scrollbarEl.part.add('scrollbar');
      swiper.el.appendChild(scrollbarEl);
    }
    if (scrollbarEl) currentParams.scrollbar.el = scrollbarEl;
    scrollbar.init();
    scrollbar.updateSize();
    scrollbar.setTranslate();
  }
  if (needNavigationInit) {
    if (swiper.isElement) {
      if (!nextEl || typeof nextEl === 'string') {
        nextEl = document.createElement('div');
        nextEl.classList.add('swiper-button-next');
        (0,utils.s)(nextEl, swiper.navigation.arrowSvg);
        nextEl.part.add('button-next');
        swiper.el.appendChild(nextEl);
      }
      if (!prevEl || typeof prevEl === 'string') {
        prevEl = document.createElement('div');
        prevEl.classList.add('swiper-button-prev');
        (0,utils.s)(prevEl, swiper.navigation.arrowSvg);
        prevEl.part.add('button-prev');
        swiper.el.appendChild(prevEl);
      }
    }
    if (nextEl) currentParams.navigation.nextEl = nextEl;
    if (prevEl) currentParams.navigation.prevEl = prevEl;
    navigation.init();
    navigation.update();
  }
  if (changedParams.includes('allowSlideNext')) {
    swiper.allowSlideNext = passedParams.allowSlideNext;
  }
  if (changedParams.includes('allowSlidePrev')) {
    swiper.allowSlidePrev = passedParams.allowSlidePrev;
  }
  if (changedParams.includes('direction')) {
    swiper.changeDirection(passedParams.direction, false);
  }
  if (loopNeedDestroy || loopNeedReloop) {
    swiper.loopDestroy();
  }
  if (loopNeedEnable || loopNeedReloop) {
    swiper.loopCreate();
  }
  swiper.update();
}



;// CONCATENATED MODULE: ../node_modules/swiper/shared/update-on-virtual-data.mjs



function getParams(obj = {}, splitEvents = true) {
  const params = {
    on: {}
  };
  const events = {};
  const passedParams = {};
  extend(params, defaults);
  params._emitClasses = true;
  params.init = false;
  const rest = {};
  const allowedParams = paramsList.map(key => key.replace(/_/, ''));
  const plainObj = Object.assign({}, obj);
  Object.keys(plainObj).forEach(key => {
    if (typeof obj[key] === 'undefined') return;
    if (allowedParams.indexOf(key) >= 0) {
      if (isObject(obj[key])) {
        params[key] = {};
        passedParams[key] = {};
        extend(params[key], obj[key]);
        extend(passedParams[key], obj[key]);
      } else {
        params[key] = obj[key];
        passedParams[key] = obj[key];
      }
    } else if (key.search(/on[A-Z]/) === 0 && typeof obj[key] === 'function') {
      if (splitEvents) {
        events[`${key[2].toLowerCase()}${key.substr(3)}`] = obj[key];
      } else {
        params.on[`${key[2].toLowerCase()}${key.substr(3)}`] = obj[key];
      }
    } else {
      rest[key] = obj[key];
    }
  });
  ['navigation', 'pagination', 'scrollbar'].forEach(key => {
    if (params[key] === true) params[key] = {};
    if (params[key] === false) delete params[key];
  });
  return {
    params,
    passedParams,
    rest,
    events
  };
}

function mountSwiper({
  el,
  nextEl,
  prevEl,
  paginationEl,
  scrollbarEl,
  swiper
}, swiperParams) {
  if (needsNavigation(swiperParams) && nextEl && prevEl) {
    swiper.params.navigation.nextEl = nextEl;
    swiper.originalParams.navigation.nextEl = nextEl;
    swiper.params.navigation.prevEl = prevEl;
    swiper.originalParams.navigation.prevEl = prevEl;
  }
  if (needsPagination(swiperParams) && paginationEl) {
    swiper.params.pagination.el = paginationEl;
    swiper.originalParams.pagination.el = paginationEl;
  }
  if (needsScrollbar(swiperParams) && scrollbarEl) {
    swiper.params.scrollbar.el = scrollbarEl;
    swiper.originalParams.scrollbar.el = scrollbarEl;
  }
  swiper.init(el);
}

function getChangedParams(swiperParams, oldParams, children, oldChildren, getKey) {
  const keys = [];
  if (!oldParams) return keys;
  const addKey = key => {
    if (keys.indexOf(key) < 0) keys.push(key);
  };
  if (children && oldChildren) {
    const oldChildrenKeys = oldChildren.map(getKey);
    const childrenKeys = children.map(getKey);
    if (oldChildrenKeys.join('') !== childrenKeys.join('')) addKey('children');
    if (oldChildren.length !== children.length) addKey('children');
  }
  const watchParams = paramsList.filter(key => key[0] === '_').map(key => key.replace(/_/, ''));
  watchParams.forEach(key => {
    if (key in swiperParams && key in oldParams) {
      if (isObject(swiperParams[key]) && isObject(oldParams[key])) {
        const newKeys = Object.keys(swiperParams[key]);
        const oldKeys = Object.keys(oldParams[key]);
        if (newKeys.length !== oldKeys.length) {
          addKey(key);
        } else {
          newKeys.forEach(newKey => {
            if (swiperParams[key][newKey] !== oldParams[key][newKey]) {
              addKey(key);
            }
          });
          oldKeys.forEach(oldKey => {
            if (swiperParams[key][oldKey] !== oldParams[key][oldKey]) addKey(key);
          });
        }
      } else if (swiperParams[key] !== oldParams[key]) {
        addKey(key);
      }
    }
  });
  return keys;
}

const updateOnVirtualData = swiper => {
  if (!swiper || swiper.destroyed || !swiper.params.virtual || swiper.params.virtual && !swiper.params.virtual.enabled) return;
  swiper.updateSlides();
  swiper.updateProgress();
  swiper.updateSlidesClasses();
  swiper.emit('_virtualUpdated');
  if (swiper.parallax && swiper.params.parallax && swiper.params.parallax.enabled) {
    swiper.parallax.setTranslate();
  }
};



;// CONCATENATED MODULE: ../node_modules/swiper/swiper-react.mjs
/**
 * Swiper React 12.1.0
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2026 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: January 28, 2026
 */






function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

function isChildSwiperSlide(child) {
  return child.type && child.type.displayName && child.type.displayName.includes('SwiperSlide');
}
function processChildren(c) {
  const slides = [];
  react.Children.toArray(c).forEach(child => {
    if (isChildSwiperSlide(child)) {
      slides.push(child);
    } else if (child.props && child.props.children) {
      processChildren(child.props.children).forEach(slide => slides.push(slide));
    }
  });
  return slides;
}
function getChildren(c) {
  const slides = [];
  const slots = {
    'container-start': [],
    'container-end': [],
    'wrapper-start': [],
    'wrapper-end': []
  };
  react.Children.toArray(c).forEach(child => {
    if (isChildSwiperSlide(child)) {
      slides.push(child);
    } else if (child.props && child.props.slot && slots[child.props.slot]) {
      slots[child.props.slot].push(child);
    } else if (child.props && child.props.children) {
      const foundSlides = processChildren(child.props.children);
      if (foundSlides.length > 0) {
        foundSlides.forEach(slide => slides.push(slide));
      } else {
        slots['container-end'].push(child);
      }
    } else {
      slots['container-end'].push(child);
    }
  });
  return {
    slides,
    slots
  };
}

function renderVirtual(swiper, slides, virtualData) {
  if (!virtualData) return null;
  const getSlideIndex = index => {
    let slideIndex = index;
    if (index < 0) {
      slideIndex = slides.length + index;
    } else if (slideIndex >= slides.length) {
      // eslint-disable-next-line
      slideIndex = slideIndex - slides.length;
    }
    return slideIndex;
  };
  const style = swiper.isHorizontal() ? {
    [swiper.rtlTranslate ? 'right' : 'left']: `${virtualData.offset}px`
  } : {
    top: `${virtualData.offset}px`
  };
  const {
    from,
    to
  } = virtualData;
  const loopFrom = swiper.params.loop ? -slides.length : 0;
  const loopTo = swiper.params.loop ? slides.length * 2 : slides.length;
  const slidesToRender = [];
  for (let i = loopFrom; i < loopTo; i += 1) {
    if (i >= from && i <= to) {
      slidesToRender.push(slides[getSlideIndex(i)]);
    }
  }
  return slidesToRender.map((child, index) => {
    return /*#__PURE__*/react.cloneElement(child, {
      swiper,
      style,
      key: child.props.virtualIndex || child.key || `slide-${index}`
    });
  });
}

function useIsomorphicLayoutEffect(callback, deps) {
  // eslint-disable-next-line
  if (typeof window === 'undefined') return (0,react.useEffect)(callback, deps);
  return (0,react.useLayoutEffect)(callback, deps);
}

const SwiperSlideContext = /*#__PURE__*/(0,react.createContext)(null);
const useSwiperSlide = () => {
  return useContext(SwiperSlideContext);
};
const SwiperContext = /*#__PURE__*/(0,react.createContext)(null);
const useSwiper = () => {
  return useContext(SwiperContext);
};

const swiper_react_Swiper = /*#__PURE__*/(0,react.forwardRef)(({
  className,
  tag: Tag = 'div',
  wrapperTag: WrapperTag = 'div',
  children,
  onSwiper,
  ...rest
} = {}, externalElRef) => {
  let eventsAssigned = false;
  const [containerClasses, setContainerClasses] = (0,react.useState)('swiper');
  const [virtualData, setVirtualData] = (0,react.useState)(null);
  const [breakpointChanged, setBreakpointChanged] = (0,react.useState)(false);
  const initializedRef = (0,react.useRef)(false);
  const swiperElRef = (0,react.useRef)(null);
  const swiperRef = (0,react.useRef)(null);
  const oldPassedParamsRef = (0,react.useRef)(null);
  const oldSlides = (0,react.useRef)(null);
  const nextElRef = (0,react.useRef)(null);
  const prevElRef = (0,react.useRef)(null);
  const paginationElRef = (0,react.useRef)(null);
  const scrollbarElRef = (0,react.useRef)(null);
  const {
    params: swiperParams,
    passedParams,
    rest: restProps,
    events
  } = getParams(rest);
  const {
    slides,
    slots
  } = getChildren(children);
  const onBeforeBreakpoint = () => {
    setBreakpointChanged(!breakpointChanged);
  };
  Object.assign(swiperParams.on, {
    _containerClasses(swiper, classes) {
      setContainerClasses(classes);
    }
  });
  const initSwiper = () => {
    // init swiper
    Object.assign(swiperParams.on, events);
    eventsAssigned = true;
    const passParams = {
      ...swiperParams
    };
    delete passParams.wrapperClass;
    swiperRef.current = new Swiper(passParams);
    if (swiperRef.current.virtual && swiperRef.current.params.virtual.enabled) {
      swiperRef.current.virtual.slides = slides;
      const extendWith = {
        cache: false,
        slides,
        renderExternal: setVirtualData,
        renderExternalUpdate: false
      };
      extend(swiperRef.current.params.virtual, extendWith);
      extend(swiperRef.current.originalParams.virtual, extendWith);
    }
  };
  if (!swiperElRef.current) {
    initSwiper();
  }

  // Listen for breakpoints change
  if (swiperRef.current) {
    swiperRef.current.on('_beforeBreakpoint', onBeforeBreakpoint);
  }
  const attachEvents = () => {
    if (eventsAssigned || !events || !swiperRef.current) return;
    Object.keys(events).forEach(eventName => {
      swiperRef.current.on(eventName, events[eventName]);
    });
  };
  const detachEvents = () => {
    if (!events || !swiperRef.current) return;
    Object.keys(events).forEach(eventName => {
      swiperRef.current.off(eventName, events[eventName]);
    });
  };
  (0,react.useEffect)(() => {
    return () => {
      if (swiperRef.current) swiperRef.current.off('_beforeBreakpoint', onBeforeBreakpoint);
    };
  });

  // set initialized flag
  (0,react.useEffect)(() => {
    if (!initializedRef.current && swiperRef.current) {
      swiperRef.current.emitSlidesClasses();
      initializedRef.current = true;
    }
  });

  // mount swiper
  useIsomorphicLayoutEffect(() => {
    if (externalElRef) {
      externalElRef.current = swiperElRef.current;
    }
    if (!swiperElRef.current) return;
    if (swiperRef.current.destroyed) {
      initSwiper();
    }
    mountSwiper({
      el: swiperElRef.current,
      nextEl: nextElRef.current,
      prevEl: prevElRef.current,
      paginationEl: paginationElRef.current,
      scrollbarEl: scrollbarElRef.current,
      swiper: swiperRef.current
    }, swiperParams);
    if (onSwiper && !swiperRef.current.destroyed) onSwiper(swiperRef.current);
    // eslint-disable-next-line
    return () => {
      if (swiperRef.current && !swiperRef.current.destroyed) {
        swiperRef.current.destroy(true, false);
      }
    };
  }, []);

  // watch for params change
  useIsomorphicLayoutEffect(() => {
    attachEvents();
    const changedParams = getChangedParams(passedParams, oldPassedParamsRef.current, slides, oldSlides.current, c => c.key);
    oldPassedParamsRef.current = passedParams;
    oldSlides.current = slides;
    if (changedParams.length && swiperRef.current && !swiperRef.current.destroyed) {
      updateSwiper({
        swiper: swiperRef.current,
        slides,
        passedParams,
        changedParams,
        nextEl: nextElRef.current,
        prevEl: prevElRef.current,
        scrollbarEl: scrollbarElRef.current,
        paginationEl: paginationElRef.current
      });
    }
    return () => {
      detachEvents();
    };
  });

  // update on virtual update
  useIsomorphicLayoutEffect(() => {
    updateOnVirtualData(swiperRef.current);
  }, [virtualData]);

  // bypass swiper instance to slides
  function renderSlides() {
    if (swiperParams.virtual) {
      return renderVirtual(swiperRef.current, slides, virtualData);
    }
    return slides.map((child, index) => {
      return /*#__PURE__*/react.cloneElement(child, {
        swiper: swiperRef.current,
        swiperSlideIndex: index
      });
    });
  }
  return /*#__PURE__*/react.createElement(Tag, _extends({
    ref: swiperElRef,
    className: uniqueClasses(`${containerClasses}${className ? ` ${className}` : ''}`)
  }, restProps), /*#__PURE__*/react.createElement(SwiperContext.Provider, {
    value: swiperRef.current
  }, slots['container-start'], /*#__PURE__*/react.createElement(WrapperTag, {
    className: wrapperClass(swiperParams.wrapperClass)
  }, slots['wrapper-start'], renderSlides(), slots['wrapper-end']), needsNavigation(swiperParams) && /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
    ref: prevElRef,
    className: "swiper-button-prev"
  }), /*#__PURE__*/react.createElement("div", {
    ref: nextElRef,
    className: "swiper-button-next"
  })), needsScrollbar(swiperParams) && /*#__PURE__*/react.createElement("div", {
    ref: scrollbarElRef,
    className: "swiper-scrollbar"
  }), needsPagination(swiperParams) && /*#__PURE__*/react.createElement("div", {
    ref: paginationElRef,
    className: "swiper-pagination"
  }), slots['container-end']));
});
swiper_react_Swiper.displayName = 'Swiper';

const SwiperSlide = /*#__PURE__*/(0,react.forwardRef)(({
  tag: Tag = 'div',
  children,
  className = '',
  swiper,
  zoom,
  lazy,
  virtualIndex,
  swiperSlideIndex,
  ...rest
} = {}, externalRef) => {
  const slideElRef = (0,react.useRef)(null);
  const [slideClasses, setSlideClasses] = (0,react.useState)('swiper-slide');
  const [lazyLoaded, setLazyLoaded] = (0,react.useState)(false);
  function updateClasses(_s, el, classNames) {
    if (el === slideElRef.current) {
      setSlideClasses(classNames);
    }
  }
  useIsomorphicLayoutEffect(() => {
    if (typeof swiperSlideIndex !== 'undefined') {
      slideElRef.current.swiperSlideIndex = swiperSlideIndex;
    }
    if (externalRef) {
      externalRef.current = slideElRef.current;
    }
    if (!slideElRef.current || !swiper) {
      return;
    }
    if (swiper.destroyed) {
      if (slideClasses !== 'swiper-slide') {
        setSlideClasses('swiper-slide');
      }
      return;
    }
    swiper.on('_slideClass', updateClasses);
    // eslint-disable-next-line
    return () => {
      if (!swiper) return;
      swiper.off('_slideClass', updateClasses);
    };
  });
  useIsomorphicLayoutEffect(() => {
    if (swiper && slideElRef.current && !swiper.destroyed) {
      setSlideClasses(swiper.getSlideClasses(slideElRef.current));
    }
  }, [swiper]);
  const slideData = {
    isActive: slideClasses.indexOf('swiper-slide-active') >= 0,
    isVisible: slideClasses.indexOf('swiper-slide-visible') >= 0,
    isPrev: slideClasses.indexOf('swiper-slide-prev') >= 0,
    isNext: slideClasses.indexOf('swiper-slide-next') >= 0
  };
  const renderChildren = () => {
    return typeof children === 'function' ? children(slideData) : children;
  };
  const onLoad = () => {
    setLazyLoaded(true);
  };
  return /*#__PURE__*/react.createElement(Tag, _extends({
    ref: slideElRef,
    className: uniqueClasses(`${slideClasses}${className ? ` ${className}` : ''}`),
    "data-swiper-slide-index": virtualIndex,
    onLoad: onLoad
  }, rest), zoom && /*#__PURE__*/react.createElement(SwiperSlideContext.Provider, {
    value: slideData
  }, /*#__PURE__*/react.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof zoom === 'number' ? zoom : undefined
  }, renderChildren(), lazy && !lazyLoaded && /*#__PURE__*/react.createElement("div", {
    className: "swiper-lazy-preloader",
    ref: node => {
      if (node) node.lazyPreloaderManaged = true;
    }
  }))), !zoom && /*#__PURE__*/react.createElement(SwiperSlideContext.Provider, {
    value: slideData
  }, renderChildren(), lazy && !lazyLoaded && /*#__PURE__*/react.createElement("div", {
    className: "swiper-lazy-preloader",
    ref: node => {
      if (node) node.lazyPreloaderManaged = true;
    }
  })));
});
SwiperSlide.displayName = 'SwiperSlide';




/***/ }),

/***/ 4360:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m6": function() { return /* binding */ twMerge; }
/* harmony export */ });
/* unused harmony exports createTailwindMerge, extendTailwindMerge, fromTheme, getDefaultConfig, mergeConfigs, twJoin, validators */
const CLASS_PART_SEPARATOR = '-';
const createClassGroupUtils = config => {
  const classMap = createClassMap(config);
  const {
    conflictingClassGroups,
    conflictingClassGroupModifiers
  } = config;
  const getClassGroupId = className => {
    const classParts = className.split(CLASS_PART_SEPARATOR);
    // Classes like `-inset-1` produce an empty string as first classPart. We assume that classes for negative values are used correctly and remove it from classParts.
    if (classParts[0] === '' && classParts.length !== 1) {
      classParts.shift();
    }
    return getGroupRecursive(classParts, classMap) || getGroupIdForArbitraryProperty(className);
  };
  const getConflictingClassGroupIds = (classGroupId, hasPostfixModifier) => {
    const conflicts = conflictingClassGroups[classGroupId] || [];
    if (hasPostfixModifier && conflictingClassGroupModifiers[classGroupId]) {
      return [...conflicts, ...conflictingClassGroupModifiers[classGroupId]];
    }
    return conflicts;
  };
  return {
    getClassGroupId,
    getConflictingClassGroupIds
  };
};
const getGroupRecursive = (classParts, classPartObject) => {
  if (classParts.length === 0) {
    return classPartObject.classGroupId;
  }
  const currentClassPart = classParts[0];
  const nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
  const classGroupFromNextClassPart = nextClassPartObject ? getGroupRecursive(classParts.slice(1), nextClassPartObject) : undefined;
  if (classGroupFromNextClassPart) {
    return classGroupFromNextClassPart;
  }
  if (classPartObject.validators.length === 0) {
    return undefined;
  }
  const classRest = classParts.join(CLASS_PART_SEPARATOR);
  return classPartObject.validators.find(({
    validator
  }) => validator(classRest))?.classGroupId;
};
const arbitraryPropertyRegex = /^\[(.+)\]$/;
const getGroupIdForArbitraryProperty = className => {
  if (arbitraryPropertyRegex.test(className)) {
    const arbitraryPropertyClassName = arbitraryPropertyRegex.exec(className)[1];
    const property = arbitraryPropertyClassName?.substring(0, arbitraryPropertyClassName.indexOf(':'));
    if (property) {
      // I use two dots here because one dot is used as prefix for class groups in plugins
      return 'arbitrary..' + property;
    }
  }
};
/**
 * Exported for testing only
 */
const createClassMap = config => {
  const {
    theme,
    prefix
  } = config;
  const classMap = {
    nextPart: new Map(),
    validators: []
  };
  const prefixedClassGroupEntries = getPrefixedClassGroupEntries(Object.entries(config.classGroups), prefix);
  prefixedClassGroupEntries.forEach(([classGroupId, classGroup]) => {
    processClassesRecursively(classGroup, classMap, classGroupId, theme);
  });
  return classMap;
};
const processClassesRecursively = (classGroup, classPartObject, classGroupId, theme) => {
  classGroup.forEach(classDefinition => {
    if (typeof classDefinition === 'string') {
      const classPartObjectToEdit = classDefinition === '' ? classPartObject : getPart(classPartObject, classDefinition);
      classPartObjectToEdit.classGroupId = classGroupId;
      return;
    }
    if (typeof classDefinition === 'function') {
      if (isThemeGetter(classDefinition)) {
        processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
        return;
      }
      classPartObject.validators.push({
        validator: classDefinition,
        classGroupId
      });
      return;
    }
    Object.entries(classDefinition).forEach(([key, classGroup]) => {
      processClassesRecursively(classGroup, getPart(classPartObject, key), classGroupId, theme);
    });
  });
};
const getPart = (classPartObject, path) => {
  let currentClassPartObject = classPartObject;
  path.split(CLASS_PART_SEPARATOR).forEach(pathPart => {
    if (!currentClassPartObject.nextPart.has(pathPart)) {
      currentClassPartObject.nextPart.set(pathPart, {
        nextPart: new Map(),
        validators: []
      });
    }
    currentClassPartObject = currentClassPartObject.nextPart.get(pathPart);
  });
  return currentClassPartObject;
};
const isThemeGetter = func => func.isThemeGetter;
const getPrefixedClassGroupEntries = (classGroupEntries, prefix) => {
  if (!prefix) {
    return classGroupEntries;
  }
  return classGroupEntries.map(([classGroupId, classGroup]) => {
    const prefixedClassGroup = classGroup.map(classDefinition => {
      if (typeof classDefinition === 'string') {
        return prefix + classDefinition;
      }
      if (typeof classDefinition === 'object') {
        return Object.fromEntries(Object.entries(classDefinition).map(([key, value]) => [prefix + key, value]));
      }
      return classDefinition;
    });
    return [classGroupId, prefixedClassGroup];
  });
};

// LRU cache inspired from hashlru (https://github.com/dominictarr/hashlru/blob/v1.0.4/index.js) but object replaced with Map to improve performance
const createLruCache = maxCacheSize => {
  if (maxCacheSize < 1) {
    return {
      get: () => undefined,
      set: () => {}
    };
  }
  let cacheSize = 0;
  let cache = new Map();
  let previousCache = new Map();
  const update = (key, value) => {
    cache.set(key, value);
    cacheSize++;
    if (cacheSize > maxCacheSize) {
      cacheSize = 0;
      previousCache = cache;
      cache = new Map();
    }
  };
  return {
    get(key) {
      let value = cache.get(key);
      if (value !== undefined) {
        return value;
      }
      if ((value = previousCache.get(key)) !== undefined) {
        update(key, value);
        return value;
      }
    },
    set(key, value) {
      if (cache.has(key)) {
        cache.set(key, value);
      } else {
        update(key, value);
      }
    }
  };
};
const IMPORTANT_MODIFIER = '!';
const createParseClassName = config => {
  const {
    separator,
    experimentalParseClassName
  } = config;
  const isSeparatorSingleCharacter = separator.length === 1;
  const firstSeparatorCharacter = separator[0];
  const separatorLength = separator.length;
  // parseClassName inspired by https://github.com/tailwindlabs/tailwindcss/blob/v3.2.2/src/util/splitAtTopLevelOnly.js
  const parseClassName = className => {
    const modifiers = [];
    let bracketDepth = 0;
    let modifierStart = 0;
    let postfixModifierPosition;
    for (let index = 0; index < className.length; index++) {
      let currentCharacter = className[index];
      if (bracketDepth === 0) {
        if (currentCharacter === firstSeparatorCharacter && (isSeparatorSingleCharacter || className.slice(index, index + separatorLength) === separator)) {
          modifiers.push(className.slice(modifierStart, index));
          modifierStart = index + separatorLength;
          continue;
        }
        if (currentCharacter === '/') {
          postfixModifierPosition = index;
          continue;
        }
      }
      if (currentCharacter === '[') {
        bracketDepth++;
      } else if (currentCharacter === ']') {
        bracketDepth--;
      }
    }
    const baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.substring(modifierStart);
    const hasImportantModifier = baseClassNameWithImportantModifier.startsWith(IMPORTANT_MODIFIER);
    const baseClassName = hasImportantModifier ? baseClassNameWithImportantModifier.substring(1) : baseClassNameWithImportantModifier;
    const maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : undefined;
    return {
      modifiers,
      hasImportantModifier,
      baseClassName,
      maybePostfixModifierPosition
    };
  };
  if (experimentalParseClassName) {
    return className => experimentalParseClassName({
      className,
      parseClassName
    });
  }
  return parseClassName;
};
/**
 * Sorts modifiers according to following schema:
 * - Predefined modifiers are sorted alphabetically
 * - When an arbitrary variant appears, it must be preserved which modifiers are before and after it
 */
const sortModifiers = modifiers => {
  if (modifiers.length <= 1) {
    return modifiers;
  }
  const sortedModifiers = [];
  let unsortedModifiers = [];
  modifiers.forEach(modifier => {
    const isArbitraryVariant = modifier[0] === '[';
    if (isArbitraryVariant) {
      sortedModifiers.push(...unsortedModifiers.sort(), modifier);
      unsortedModifiers = [];
    } else {
      unsortedModifiers.push(modifier);
    }
  });
  sortedModifiers.push(...unsortedModifiers.sort());
  return sortedModifiers;
};
const createConfigUtils = config => ({
  cache: createLruCache(config.cacheSize),
  parseClassName: createParseClassName(config),
  ...createClassGroupUtils(config)
});
const SPLIT_CLASSES_REGEX = /\s+/;
const mergeClassList = (classList, configUtils) => {
  const {
    parseClassName,
    getClassGroupId,
    getConflictingClassGroupIds
  } = configUtils;
  /**
   * Set of classGroupIds in following format:
   * `{importantModifier}{variantModifiers}{classGroupId}`
   * @example 'float'
   * @example 'hover:focus:bg-color'
   * @example 'md:!pr'
   */
  const classGroupsInConflict = [];
  const classNames = classList.trim().split(SPLIT_CLASSES_REGEX);
  let result = '';
  for (let index = classNames.length - 1; index >= 0; index -= 1) {
    const originalClassName = classNames[index];
    const {
      modifiers,
      hasImportantModifier,
      baseClassName,
      maybePostfixModifierPosition
    } = parseClassName(originalClassName);
    let hasPostfixModifier = Boolean(maybePostfixModifierPosition);
    let classGroupId = getClassGroupId(hasPostfixModifier ? baseClassName.substring(0, maybePostfixModifierPosition) : baseClassName);
    if (!classGroupId) {
      if (!hasPostfixModifier) {
        // Not a Tailwind class
        result = originalClassName + (result.length > 0 ? ' ' + result : result);
        continue;
      }
      classGroupId = getClassGroupId(baseClassName);
      if (!classGroupId) {
        // Not a Tailwind class
        result = originalClassName + (result.length > 0 ? ' ' + result : result);
        continue;
      }
      hasPostfixModifier = false;
    }
    const variantModifier = sortModifiers(modifiers).join(':');
    const modifierId = hasImportantModifier ? variantModifier + IMPORTANT_MODIFIER : variantModifier;
    const classId = modifierId + classGroupId;
    if (classGroupsInConflict.includes(classId)) {
      // Tailwind class omitted due to conflict
      continue;
    }
    classGroupsInConflict.push(classId);
    const conflictGroups = getConflictingClassGroupIds(classGroupId, hasPostfixModifier);
    for (let i = 0; i < conflictGroups.length; ++i) {
      const group = conflictGroups[i];
      classGroupsInConflict.push(modifierId + group);
    }
    // Tailwind class not in conflict
    result = originalClassName + (result.length > 0 ? ' ' + result : result);
  }
  return result;
};

/**
 * The code in this file is copied from https://github.com/lukeed/clsx and modified to suit the needs of tailwind-merge better.
 *
 * Specifically:
 * - Runtime code from https://github.com/lukeed/clsx/blob/v1.2.1/src/index.js
 * - TypeScript types from https://github.com/lukeed/clsx/blob/v1.2.1/clsx.d.ts
 *
 * Original code has MIT license: Copyright (c) Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)
 */
function twJoin() {
  let index = 0;
  let argument;
  let resolvedValue;
  let string = '';
  while (index < arguments.length) {
    if (argument = arguments[index++]) {
      if (resolvedValue = toValue(argument)) {
        string && (string += ' ');
        string += resolvedValue;
      }
    }
  }
  return string;
}
const toValue = mix => {
  if (typeof mix === 'string') {
    return mix;
  }
  let resolvedValue;
  let string = '';
  for (let k = 0; k < mix.length; k++) {
    if (mix[k]) {
      if (resolvedValue = toValue(mix[k])) {
        string && (string += ' ');
        string += resolvedValue;
      }
    }
  }
  return string;
};
function createTailwindMerge(createConfigFirst, ...createConfigRest) {
  let configUtils;
  let cacheGet;
  let cacheSet;
  let functionToCall = initTailwindMerge;
  function initTailwindMerge(classList) {
    const config = createConfigRest.reduce((previousConfig, createConfigCurrent) => createConfigCurrent(previousConfig), createConfigFirst());
    configUtils = createConfigUtils(config);
    cacheGet = configUtils.cache.get;
    cacheSet = configUtils.cache.set;
    functionToCall = tailwindMerge;
    return tailwindMerge(classList);
  }
  function tailwindMerge(classList) {
    const cachedResult = cacheGet(classList);
    if (cachedResult) {
      return cachedResult;
    }
    const result = mergeClassList(classList, configUtils);
    cacheSet(classList, result);
    return result;
  }
  return function callTailwindMerge() {
    return functionToCall(twJoin.apply(null, arguments));
  };
}
const fromTheme = key => {
  const themeGetter = theme => theme[key] || [];
  themeGetter.isThemeGetter = true;
  return themeGetter;
};
const arbitraryValueRegex = /^\[(?:([a-z-]+):)?(.+)\]$/i;
const fractionRegex = /^\d+\/\d+$/;
const stringLengths = /*#__PURE__*/new Set(['px', 'full', 'screen']);
const tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
const lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
const colorFunctionRegex = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/;
// Shadow always begins with x and y offset separated by underscore optionally prepended by inset
const shadowRegex = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
const imageRegex = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
const isLength = value => isNumber(value) || stringLengths.has(value) || fractionRegex.test(value);
const isArbitraryLength = value => getIsArbitraryValue(value, 'length', isLengthOnly);
const isNumber = value => Boolean(value) && !Number.isNaN(Number(value));
const isArbitraryNumber = value => getIsArbitraryValue(value, 'number', isNumber);
const isInteger = value => Boolean(value) && Number.isInteger(Number(value));
const isPercent = value => value.endsWith('%') && isNumber(value.slice(0, -1));
const isArbitraryValue = value => arbitraryValueRegex.test(value);
const isTshirtSize = value => tshirtUnitRegex.test(value);
const sizeLabels = /*#__PURE__*/new Set(['length', 'size', 'percentage']);
const isArbitrarySize = value => getIsArbitraryValue(value, sizeLabels, isNever);
const isArbitraryPosition = value => getIsArbitraryValue(value, 'position', isNever);
const imageLabels = /*#__PURE__*/new Set(['image', 'url']);
const isArbitraryImage = value => getIsArbitraryValue(value, imageLabels, isImage);
const isArbitraryShadow = value => getIsArbitraryValue(value, '', isShadow);
const isAny = () => true;
const getIsArbitraryValue = (value, label, testValue) => {
  const result = arbitraryValueRegex.exec(value);
  if (result) {
    if (result[1]) {
      return typeof label === 'string' ? result[1] === label : label.has(result[1]);
    }
    return testValue(result[2]);
  }
  return false;
};
const isLengthOnly = value =>
// `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
// For example, `hsl(0 0% 0%)` would be classified as a length without this check.
// I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
lengthUnitRegex.test(value) && !colorFunctionRegex.test(value);
const isNever = () => false;
const isShadow = value => shadowRegex.test(value);
const isImage = value => imageRegex.test(value);
const validators = /*#__PURE__*/Object.defineProperty({
  __proto__: null,
  isAny,
  isArbitraryImage,
  isArbitraryLength,
  isArbitraryNumber,
  isArbitraryPosition,
  isArbitraryShadow,
  isArbitrarySize,
  isArbitraryValue,
  isInteger,
  isLength,
  isNumber,
  isPercent,
  isTshirtSize
}, Symbol.toStringTag, {
  value: 'Module'
});
const getDefaultConfig = () => {
  const colors = fromTheme('colors');
  const spacing = fromTheme('spacing');
  const blur = fromTheme('blur');
  const brightness = fromTheme('brightness');
  const borderColor = fromTheme('borderColor');
  const borderRadius = fromTheme('borderRadius');
  const borderSpacing = fromTheme('borderSpacing');
  const borderWidth = fromTheme('borderWidth');
  const contrast = fromTheme('contrast');
  const grayscale = fromTheme('grayscale');
  const hueRotate = fromTheme('hueRotate');
  const invert = fromTheme('invert');
  const gap = fromTheme('gap');
  const gradientColorStops = fromTheme('gradientColorStops');
  const gradientColorStopPositions = fromTheme('gradientColorStopPositions');
  const inset = fromTheme('inset');
  const margin = fromTheme('margin');
  const opacity = fromTheme('opacity');
  const padding = fromTheme('padding');
  const saturate = fromTheme('saturate');
  const scale = fromTheme('scale');
  const sepia = fromTheme('sepia');
  const skew = fromTheme('skew');
  const space = fromTheme('space');
  const translate = fromTheme('translate');
  const getOverscroll = () => ['auto', 'contain', 'none'];
  const getOverflow = () => ['auto', 'hidden', 'clip', 'visible', 'scroll'];
  const getSpacingWithAutoAndArbitrary = () => ['auto', isArbitraryValue, spacing];
  const getSpacingWithArbitrary = () => [isArbitraryValue, spacing];
  const getLengthWithEmptyAndArbitrary = () => ['', isLength, isArbitraryLength];
  const getNumberWithAutoAndArbitrary = () => ['auto', isNumber, isArbitraryValue];
  const getPositions = () => ['bottom', 'center', 'left', 'left-bottom', 'left-top', 'right', 'right-bottom', 'right-top', 'top'];
  const getLineStyles = () => ['solid', 'dashed', 'dotted', 'double', 'none'];
  const getBlendModes = () => ['normal', 'multiply', 'screen', 'overlay', 'darken', 'lighten', 'color-dodge', 'color-burn', 'hard-light', 'soft-light', 'difference', 'exclusion', 'hue', 'saturation', 'color', 'luminosity'];
  const getAlign = () => ['start', 'end', 'center', 'between', 'around', 'evenly', 'stretch'];
  const getZeroAndEmpty = () => ['', '0', isArbitraryValue];
  const getBreaks = () => ['auto', 'avoid', 'all', 'avoid-page', 'page', 'left', 'right', 'column'];
  const getNumberAndArbitrary = () => [isNumber, isArbitraryValue];
  return {
    cacheSize: 500,
    separator: ':',
    theme: {
      colors: [isAny],
      spacing: [isLength, isArbitraryLength],
      blur: ['none', '', isTshirtSize, isArbitraryValue],
      brightness: getNumberAndArbitrary(),
      borderColor: [colors],
      borderRadius: ['none', '', 'full', isTshirtSize, isArbitraryValue],
      borderSpacing: getSpacingWithArbitrary(),
      borderWidth: getLengthWithEmptyAndArbitrary(),
      contrast: getNumberAndArbitrary(),
      grayscale: getZeroAndEmpty(),
      hueRotate: getNumberAndArbitrary(),
      invert: getZeroAndEmpty(),
      gap: getSpacingWithArbitrary(),
      gradientColorStops: [colors],
      gradientColorStopPositions: [isPercent, isArbitraryLength],
      inset: getSpacingWithAutoAndArbitrary(),
      margin: getSpacingWithAutoAndArbitrary(),
      opacity: getNumberAndArbitrary(),
      padding: getSpacingWithArbitrary(),
      saturate: getNumberAndArbitrary(),
      scale: getNumberAndArbitrary(),
      sepia: getZeroAndEmpty(),
      skew: getNumberAndArbitrary(),
      space: getSpacingWithArbitrary(),
      translate: getSpacingWithArbitrary()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ['auto', 'square', 'video', isArbitraryValue]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ['container'],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [isTshirtSize]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      'break-after': [{
        'break-after': getBreaks()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      'break-before': [{
        'break-before': getBreaks()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      'break-inside': [{
        'break-inside': ['auto', 'avoid', 'avoid-page', 'avoid-column']
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      'box-decoration': [{
        'box-decoration': ['slice', 'clone']
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ['border', 'content']
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ['block', 'inline-block', 'inline', 'flex', 'inline-flex', 'table', 'inline-table', 'table-caption', 'table-cell', 'table-column', 'table-column-group', 'table-footer-group', 'table-header-group', 'table-row-group', 'table-row', 'flow-root', 'grid', 'inline-grid', 'contents', 'list-item', 'hidden'],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ['right', 'left', 'none', 'start', 'end']
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ['left', 'right', 'both', 'none', 'start', 'end']
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ['isolate', 'isolation-auto'],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      'object-fit': [{
        object: ['contain', 'cover', 'fill', 'none', 'scale-down']
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      'object-position': [{
        object: [...getPositions(), isArbitraryValue]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: getOverflow()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      'overflow-x': [{
        'overflow-x': getOverflow()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      'overflow-y': [{
        'overflow-y': getOverflow()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: getOverscroll()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      'overscroll-x': [{
        'overscroll-x': getOverscroll()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      'overscroll-y': [{
        'overscroll-y': getOverscroll()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ['static', 'fixed', 'absolute', 'relative', 'sticky'],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [inset]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      'inset-x': [{
        'inset-x': [inset]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      'inset-y': [{
        'inset-y': [inset]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [inset]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [inset]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [inset]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [inset]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [inset]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [inset]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ['visible', 'invisible', 'collapse'],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ['auto', isInteger, isArbitraryValue]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: getSpacingWithAutoAndArbitrary()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      'flex-direction': [{
        flex: ['row', 'row-reverse', 'col', 'col-reverse']
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      'flex-wrap': [{
        flex: ['wrap', 'wrap-reverse', 'nowrap']
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ['1', 'auto', 'initial', 'none', isArbitraryValue]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: getZeroAndEmpty()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: getZeroAndEmpty()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ['first', 'last', 'none', isInteger, isArbitraryValue]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      'grid-cols': [{
        'grid-cols': [isAny]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      'col-start-end': [{
        col: ['auto', {
          span: ['full', isInteger, isArbitraryValue]
        }, isArbitraryValue]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      'col-start': [{
        'col-start': getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      'col-end': [{
        'col-end': getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      'grid-rows': [{
        'grid-rows': [isAny]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      'row-start-end': [{
        row: ['auto', {
          span: [isInteger, isArbitraryValue]
        }, isArbitraryValue]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      'row-start': [{
        'row-start': getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      'row-end': [{
        'row-end': getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      'grid-flow': [{
        'grid-flow': ['row', 'col', 'dense', 'row-dense', 'col-dense']
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      'auto-cols': [{
        'auto-cols': ['auto', 'min', 'max', 'fr', isArbitraryValue]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      'auto-rows': [{
        'auto-rows': ['auto', 'min', 'max', 'fr', isArbitraryValue]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [gap]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      'gap-x': [{
        'gap-x': [gap]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      'gap-y': [{
        'gap-y': [gap]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      'justify-content': [{
        justify: ['normal', ...getAlign()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      'justify-items': [{
        'justify-items': ['start', 'end', 'center', 'stretch']
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      'justify-self': [{
        'justify-self': ['auto', 'start', 'end', 'center', 'stretch']
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      'align-content': [{
        content: ['normal', ...getAlign(), 'baseline']
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      'align-items': [{
        items: ['start', 'end', 'center', 'baseline', 'stretch']
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      'align-self': [{
        self: ['auto', 'start', 'end', 'center', 'stretch', 'baseline']
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      'place-content': [{
        'place-content': [...getAlign(), 'baseline']
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      'place-items': [{
        'place-items': ['start', 'end', 'center', 'baseline', 'stretch']
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      'place-self': [{
        'place-self': ['auto', 'start', 'end', 'center', 'stretch']
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [padding]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [padding]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [padding]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [padding]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [padding]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [padding]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [padding]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [padding]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [padding]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [margin]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [margin]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [margin]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [margin]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [margin]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [margin]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [margin]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [margin]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [margin]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      'space-x': [{
        'space-x': [space]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      'space-x-reverse': ['space-x-reverse'],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      'space-y': [{
        'space-y': [space]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      'space-y-reverse': ['space-y-reverse'],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ['auto', 'min', 'max', 'fit', 'svw', 'lvw', 'dvw', isArbitraryValue, spacing]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      'min-w': [{
        'min-w': [isArbitraryValue, spacing, 'min', 'max', 'fit']
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      'max-w': [{
        'max-w': [isArbitraryValue, spacing, 'none', 'full', 'min', 'max', 'fit', 'prose', {
          screen: [isTshirtSize]
        }, isTshirtSize]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [isArbitraryValue, spacing, 'auto', 'min', 'max', 'fit', 'svh', 'lvh', 'dvh']
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      'min-h': [{
        'min-h': [isArbitraryValue, spacing, 'min', 'max', 'fit', 'svh', 'lvh', 'dvh']
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      'max-h': [{
        'max-h': [isArbitraryValue, spacing, 'min', 'max', 'fit', 'svh', 'lvh', 'dvh']
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [isArbitraryValue, spacing, 'auto', 'min', 'max', 'fit']
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      'font-size': [{
        text: ['base', isTshirtSize, isArbitraryLength]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      'font-smoothing': ['antialiased', 'subpixel-antialiased'],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      'font-style': ['italic', 'not-italic'],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      'font-weight': [{
        font: ['thin', 'extralight', 'light', 'normal', 'medium', 'semibold', 'bold', 'extrabold', 'black', isArbitraryNumber]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      'font-family': [{
        font: [isAny]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      'fvn-normal': ['normal-nums'],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      'fvn-ordinal': ['ordinal'],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      'fvn-slashed-zero': ['slashed-zero'],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      'fvn-figure': ['lining-nums', 'oldstyle-nums'],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      'fvn-spacing': ['proportional-nums', 'tabular-nums'],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      'fvn-fraction': ['diagonal-fractions', 'stacked-fractions'],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ['tighter', 'tight', 'normal', 'wide', 'wider', 'widest', isArbitraryValue]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      'line-clamp': [{
        'line-clamp': ['none', isNumber, isArbitraryNumber]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ['none', 'tight', 'snug', 'normal', 'relaxed', 'loose', isLength, isArbitraryValue]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      'list-image': [{
        'list-image': ['none', isArbitraryValue]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      'list-style-type': [{
        list: ['none', 'disc', 'decimal', isArbitraryValue]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      'list-style-position': [{
        list: ['inside', 'outside']
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      'placeholder-color': [{
        placeholder: [colors]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      'placeholder-opacity': [{
        'placeholder-opacity': [opacity]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      'text-alignment': [{
        text: ['left', 'center', 'right', 'justify', 'start', 'end']
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      'text-color': [{
        text: [colors]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      'text-opacity': [{
        'text-opacity': [opacity]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      'text-decoration': ['underline', 'overline', 'line-through', 'no-underline'],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      'text-decoration-style': [{
        decoration: [...getLineStyles(), 'wavy']
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      'text-decoration-thickness': [{
        decoration: ['auto', 'from-font', isLength, isArbitraryLength]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      'underline-offset': [{
        'underline-offset': ['auto', isLength, isArbitraryValue]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      'text-decoration-color': [{
        decoration: [colors]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      'text-transform': ['uppercase', 'lowercase', 'capitalize', 'normal-case'],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      'text-overflow': ['truncate', 'text-ellipsis', 'text-clip'],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      'text-wrap': [{
        text: ['wrap', 'nowrap', 'balance', 'pretty']
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: getSpacingWithArbitrary()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      'vertical-align': [{
        align: ['baseline', 'top', 'middle', 'bottom', 'text-top', 'text-bottom', 'sub', 'super', isArbitraryValue]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ['normal', 'nowrap', 'pre', 'pre-line', 'pre-wrap', 'break-spaces']
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ['normal', 'words', 'all', 'keep']
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ['none', 'manual', 'auto']
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ['none', isArbitraryValue]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      'bg-attachment': [{
        bg: ['fixed', 'local', 'scroll']
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      'bg-clip': [{
        'bg-clip': ['border', 'padding', 'content', 'text']
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      'bg-opacity': [{
        'bg-opacity': [opacity]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      'bg-origin': [{
        'bg-origin': ['border', 'padding', 'content']
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      'bg-position': [{
        bg: [...getPositions(), isArbitraryPosition]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      'bg-repeat': [{
        bg: ['no-repeat', {
          repeat: ['', 'x', 'y', 'round', 'space']
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      'bg-size': [{
        bg: ['auto', 'cover', 'contain', isArbitrarySize]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      'bg-image': [{
        bg: ['none', {
          'gradient-to': ['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']
        }, isArbitraryImage]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      'bg-color': [{
        bg: [colors]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      'gradient-from-pos': [{
        from: [gradientColorStopPositions]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      'gradient-via-pos': [{
        via: [gradientColorStopPositions]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      'gradient-to-pos': [{
        to: [gradientColorStopPositions]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      'gradient-from': [{
        from: [gradientColorStops]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      'gradient-via': [{
        via: [gradientColorStops]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      'gradient-to': [{
        to: [gradientColorStops]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [borderRadius]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-s': [{
        'rounded-s': [borderRadius]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-e': [{
        'rounded-e': [borderRadius]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-t': [{
        'rounded-t': [borderRadius]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-r': [{
        'rounded-r': [borderRadius]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-b': [{
        'rounded-b': [borderRadius]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-l': [{
        'rounded-l': [borderRadius]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-ss': [{
        'rounded-ss': [borderRadius]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-se': [{
        'rounded-se': [borderRadius]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-ee': [{
        'rounded-ee': [borderRadius]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-es': [{
        'rounded-es': [borderRadius]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-tl': [{
        'rounded-tl': [borderRadius]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-tr': [{
        'rounded-tr': [borderRadius]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-br': [{
        'rounded-br': [borderRadius]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      'rounded-bl': [{
        'rounded-bl': [borderRadius]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      'border-w': [{
        border: [borderWidth]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      'border-w-x': [{
        'border-x': [borderWidth]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      'border-w-y': [{
        'border-y': [borderWidth]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      'border-w-s': [{
        'border-s': [borderWidth]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      'border-w-e': [{
        'border-e': [borderWidth]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      'border-w-t': [{
        'border-t': [borderWidth]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      'border-w-r': [{
        'border-r': [borderWidth]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      'border-w-b': [{
        'border-b': [borderWidth]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      'border-w-l': [{
        'border-l': [borderWidth]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      'border-opacity': [{
        'border-opacity': [opacity]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      'border-style': [{
        border: [...getLineStyles(), 'hidden']
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      'divide-x': [{
        'divide-x': [borderWidth]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      'divide-x-reverse': ['divide-x-reverse'],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      'divide-y': [{
        'divide-y': [borderWidth]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      'divide-y-reverse': ['divide-y-reverse'],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      'divide-opacity': [{
        'divide-opacity': [opacity]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      'divide-style': [{
        divide: getLineStyles()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      'border-color': [{
        border: [borderColor]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      'border-color-x': [{
        'border-x': [borderColor]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      'border-color-y': [{
        'border-y': [borderColor]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      'border-color-s': [{
        'border-s': [borderColor]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      'border-color-e': [{
        'border-e': [borderColor]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      'border-color-t': [{
        'border-t': [borderColor]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      'border-color-r': [{
        'border-r': [borderColor]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      'border-color-b': [{
        'border-b': [borderColor]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      'border-color-l': [{
        'border-l': [borderColor]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      'divide-color': [{
        divide: [borderColor]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      'outline-style': [{
        outline: ['', ...getLineStyles()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      'outline-offset': [{
        'outline-offset': [isLength, isArbitraryValue]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      'outline-w': [{
        outline: [isLength, isArbitraryLength]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      'outline-color': [{
        outline: [colors]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      'ring-w': [{
        ring: getLengthWithEmptyAndArbitrary()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      'ring-w-inset': ['ring-inset'],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      'ring-color': [{
        ring: [colors]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      'ring-opacity': [{
        'ring-opacity': [opacity]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      'ring-offset-w': [{
        'ring-offset': [isLength, isArbitraryLength]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      'ring-offset-color': [{
        'ring-offset': [colors]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ['', 'inner', 'none', isTshirtSize, isArbitraryShadow]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      'shadow-color': [{
        shadow: [isAny]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [opacity]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      'mix-blend': [{
        'mix-blend': [...getBlendModes(), 'plus-lighter', 'plus-darker']
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      'bg-blend': [{
        'bg-blend': getBlendModes()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ['', 'none']
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [blur]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [brightness]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [contrast]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      'drop-shadow': [{
        'drop-shadow': ['', 'none', isTshirtSize, isArbitraryValue]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [grayscale]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      'hue-rotate': [{
        'hue-rotate': [hueRotate]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [invert]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [saturate]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [sepia]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      'backdrop-filter': [{
        'backdrop-filter': ['', 'none']
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      'backdrop-blur': [{
        'backdrop-blur': [blur]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      'backdrop-brightness': [{
        'backdrop-brightness': [brightness]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      'backdrop-contrast': [{
        'backdrop-contrast': [contrast]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      'backdrop-grayscale': [{
        'backdrop-grayscale': [grayscale]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      'backdrop-hue-rotate': [{
        'backdrop-hue-rotate': [hueRotate]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      'backdrop-invert': [{
        'backdrop-invert': [invert]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      'backdrop-opacity': [{
        'backdrop-opacity': [opacity]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      'backdrop-saturate': [{
        'backdrop-saturate': [saturate]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      'backdrop-sepia': [{
        'backdrop-sepia': [sepia]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      'border-collapse': [{
        border: ['collapse', 'separate']
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      'border-spacing': [{
        'border-spacing': [borderSpacing]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      'border-spacing-x': [{
        'border-spacing-x': [borderSpacing]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      'border-spacing-y': [{
        'border-spacing-y': [borderSpacing]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      'table-layout': [{
        table: ['auto', 'fixed']
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ['top', 'bottom']
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ['none', 'all', '', 'colors', 'opacity', 'shadow', 'transform', isArbitraryValue]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: getNumberAndArbitrary()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ['linear', 'in', 'out', 'in-out', isArbitraryValue]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: getNumberAndArbitrary()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ['none', 'spin', 'ping', 'pulse', 'bounce', isArbitraryValue]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ['', 'gpu', 'none']
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [scale]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      'scale-x': [{
        'scale-x': [scale]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      'scale-y': [{
        'scale-y': [scale]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [isInteger, isArbitraryValue]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      'translate-x': [{
        'translate-x': [translate]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      'translate-y': [{
        'translate-y': [translate]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      'skew-x': [{
        'skew-x': [skew]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      'skew-y': [{
        'skew-y': [skew]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      'transform-origin': [{
        origin: ['center', 'top', 'top-right', 'right', 'bottom-right', 'bottom', 'bottom-left', 'left', 'top-left', isArbitraryValue]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ['auto', colors]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ['none', 'auto']
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ['auto', 'default', 'pointer', 'wait', 'text', 'move', 'help', 'not-allowed', 'none', 'context-menu', 'progress', 'cell', 'crosshair', 'vertical-text', 'alias', 'copy', 'no-drop', 'grab', 'grabbing', 'all-scroll', 'col-resize', 'row-resize', 'n-resize', 'e-resize', 's-resize', 'w-resize', 'ne-resize', 'nw-resize', 'se-resize', 'sw-resize', 'ew-resize', 'ns-resize', 'nesw-resize', 'nwse-resize', 'zoom-in', 'zoom-out', isArbitraryValue]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      'caret-color': [{
        caret: [colors]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      'pointer-events': [{
        'pointer-events': ['none', 'auto']
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ['none', 'y', 'x', '']
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      'scroll-behavior': [{
        scroll: ['auto', 'smooth']
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      'scroll-m': [{
        'scroll-m': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      'scroll-mx': [{
        'scroll-mx': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      'scroll-my': [{
        'scroll-my': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      'scroll-ms': [{
        'scroll-ms': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      'scroll-me': [{
        'scroll-me': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      'scroll-mt': [{
        'scroll-mt': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      'scroll-mr': [{
        'scroll-mr': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      'scroll-mb': [{
        'scroll-mb': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      'scroll-ml': [{
        'scroll-ml': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      'scroll-p': [{
        'scroll-p': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      'scroll-px': [{
        'scroll-px': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      'scroll-py': [{
        'scroll-py': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      'scroll-ps': [{
        'scroll-ps': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      'scroll-pe': [{
        'scroll-pe': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      'scroll-pt': [{
        'scroll-pt': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      'scroll-pr': [{
        'scroll-pr': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      'scroll-pb': [{
        'scroll-pb': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      'scroll-pl': [{
        'scroll-pl': getSpacingWithArbitrary()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      'snap-align': [{
        snap: ['start', 'end', 'center', 'align-none']
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      'snap-stop': [{
        snap: ['normal', 'always']
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      'snap-type': [{
        snap: ['none', 'x', 'y', 'both']
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      'snap-strictness': [{
        snap: ['mandatory', 'proximity']
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ['auto', 'none', 'manipulation']
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      'touch-x': [{
        'touch-pan': ['x', 'left', 'right']
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      'touch-y': [{
        'touch-pan': ['y', 'up', 'down']
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      'touch-pz': ['touch-pinch-zoom'],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ['none', 'text', 'all', 'auto']
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      'will-change': [{
        'will-change': ['auto', 'scroll', 'contents', 'transform', isArbitraryValue]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [colors, 'none']
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      'stroke-w': [{
        stroke: [isLength, isArbitraryLength, isArbitraryNumber]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [colors, 'none']
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ['sr-only', 'not-sr-only'],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      'forced-color-adjust': [{
        'forced-color-adjust': ['auto', 'none']
      }]
    },
    conflictingClassGroups: {
      overflow: ['overflow-x', 'overflow-y'],
      overscroll: ['overscroll-x', 'overscroll-y'],
      inset: ['inset-x', 'inset-y', 'start', 'end', 'top', 'right', 'bottom', 'left'],
      'inset-x': ['right', 'left'],
      'inset-y': ['top', 'bottom'],
      flex: ['basis', 'grow', 'shrink'],
      gap: ['gap-x', 'gap-y'],
      p: ['px', 'py', 'ps', 'pe', 'pt', 'pr', 'pb', 'pl'],
      px: ['pr', 'pl'],
      py: ['pt', 'pb'],
      m: ['mx', 'my', 'ms', 'me', 'mt', 'mr', 'mb', 'ml'],
      mx: ['mr', 'ml'],
      my: ['mt', 'mb'],
      size: ['w', 'h'],
      'font-size': ['leading'],
      'fvn-normal': ['fvn-ordinal', 'fvn-slashed-zero', 'fvn-figure', 'fvn-spacing', 'fvn-fraction'],
      'fvn-ordinal': ['fvn-normal'],
      'fvn-slashed-zero': ['fvn-normal'],
      'fvn-figure': ['fvn-normal'],
      'fvn-spacing': ['fvn-normal'],
      'fvn-fraction': ['fvn-normal'],
      'line-clamp': ['display', 'overflow'],
      rounded: ['rounded-s', 'rounded-e', 'rounded-t', 'rounded-r', 'rounded-b', 'rounded-l', 'rounded-ss', 'rounded-se', 'rounded-ee', 'rounded-es', 'rounded-tl', 'rounded-tr', 'rounded-br', 'rounded-bl'],
      'rounded-s': ['rounded-ss', 'rounded-es'],
      'rounded-e': ['rounded-se', 'rounded-ee'],
      'rounded-t': ['rounded-tl', 'rounded-tr'],
      'rounded-r': ['rounded-tr', 'rounded-br'],
      'rounded-b': ['rounded-br', 'rounded-bl'],
      'rounded-l': ['rounded-tl', 'rounded-bl'],
      'border-spacing': ['border-spacing-x', 'border-spacing-y'],
      'border-w': ['border-w-s', 'border-w-e', 'border-w-t', 'border-w-r', 'border-w-b', 'border-w-l'],
      'border-w-x': ['border-w-r', 'border-w-l'],
      'border-w-y': ['border-w-t', 'border-w-b'],
      'border-color': ['border-color-s', 'border-color-e', 'border-color-t', 'border-color-r', 'border-color-b', 'border-color-l'],
      'border-color-x': ['border-color-r', 'border-color-l'],
      'border-color-y': ['border-color-t', 'border-color-b'],
      'scroll-m': ['scroll-mx', 'scroll-my', 'scroll-ms', 'scroll-me', 'scroll-mt', 'scroll-mr', 'scroll-mb', 'scroll-ml'],
      'scroll-mx': ['scroll-mr', 'scroll-ml'],
      'scroll-my': ['scroll-mt', 'scroll-mb'],
      'scroll-p': ['scroll-px', 'scroll-py', 'scroll-ps', 'scroll-pe', 'scroll-pt', 'scroll-pr', 'scroll-pb', 'scroll-pl'],
      'scroll-px': ['scroll-pr', 'scroll-pl'],
      'scroll-py': ['scroll-pt', 'scroll-pb'],
      touch: ['touch-x', 'touch-y', 'touch-pz'],
      'touch-x': ['touch'],
      'touch-y': ['touch'],
      'touch-pz': ['touch']
    },
    conflictingClassGroupModifiers: {
      'font-size': ['leading']
    }
  };
};

/**
 * @param baseConfig Config where other config will be merged into. This object will be mutated.
 * @param configExtension Partial config to merge into the `baseConfig`.
 */
const mergeConfigs = (baseConfig, {
  cacheSize,
  prefix,
  separator,
  experimentalParseClassName,
  extend = {},
  override = {}
}) => {
  overrideProperty(baseConfig, 'cacheSize', cacheSize);
  overrideProperty(baseConfig, 'prefix', prefix);
  overrideProperty(baseConfig, 'separator', separator);
  overrideProperty(baseConfig, 'experimentalParseClassName', experimentalParseClassName);
  for (const configKey in override) {
    overrideConfigProperties(baseConfig[configKey], override[configKey]);
  }
  for (const key in extend) {
    mergeConfigProperties(baseConfig[key], extend[key]);
  }
  return baseConfig;
};
const overrideProperty = (baseObject, overrideKey, overrideValue) => {
  if (overrideValue !== undefined) {
    baseObject[overrideKey] = overrideValue;
  }
};
const overrideConfigProperties = (baseObject, overrideObject) => {
  if (overrideObject) {
    for (const key in overrideObject) {
      overrideProperty(baseObject, key, overrideObject[key]);
    }
  }
};
const mergeConfigProperties = (baseObject, mergeObject) => {
  if (mergeObject) {
    for (const key in mergeObject) {
      const mergeValue = mergeObject[key];
      if (mergeValue !== undefined) {
        baseObject[key] = (baseObject[key] || []).concat(mergeValue);
      }
    }
  }
};
const extendTailwindMerge = (configExtension, ...createConfig) => typeof configExtension === 'function' ? createTailwindMerge(getDefaultConfig, configExtension, ...createConfig) : createTailwindMerge(() => mergeConfigs(getDefaultConfig(), configExtension), ...createConfig);
const twMerge = /*#__PURE__*/createTailwindMerge(getDefaultConfig);

//# sourceMappingURL=bundle-mjs.mjs.map


/***/ }),

/***/ 1069:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ee": function() { return /* binding */ __commonJS; },
/* harmony export */   "_l": function() { return /* binding */ extractEventHiddenProperties; },
/* harmony export */   "v": function() { return /* binding */ __toESM; }
/* harmony export */ });
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// src/dom-event.ts
var eventProperties = [
  "bubbles",
  "cancelBubble",
  "cancelable",
  "composed",
  "currentTarget",
  "defaultPrevented",
  "eventPhase",
  "isTrusted",
  "returnValue",
  "srcElement",
  "target",
  "timeStamp",
  "type"
];
var customEventSpecificProperties = ["detail"];
function extractEventHiddenProperties(event) {
  const rebuildEvent = eventProperties.filter((value) => event[value] !== void 0).reduce((acc, value) => {
    return { ...acc, [value]: event[value] };
  }, {});
  if (event instanceof CustomEvent) {
    customEventSpecificProperties.filter((value) => event[value] !== void 0).forEach((value) => {
      rebuildEvent[value] = event[value];
    });
  }
  return rebuildEvent;
}




/***/ }),

/***/ 3347:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qc": function() { return /* binding */ parse; }
/* harmony export */ });
/* unused harmony exports isJSON, replacer, reviver, stringify */
/* harmony import */ var _chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1069);
/* harmony import */ var memoizerific__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8425);


// node_modules/has-symbols/shams.js
var require_shams = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__commonJS */ .Ee)({
  "node_modules/has-symbols/shams.js"(exports, module) {
    "use strict";
    module.exports = function hasSymbols() {
      if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") {
        return false;
      }
      if (typeof Symbol.iterator === "symbol") {
        return true;
      }
      var obj = {};
      var sym = Symbol("test");
      var symObj = Object(sym);
      if (typeof sym === "string") {
        return false;
      }
      if (Object.prototype.toString.call(sym) !== "[object Symbol]") {
        return false;
      }
      if (Object.prototype.toString.call(symObj) !== "[object Symbol]") {
        return false;
      }
      var symVal = 42;
      obj[sym] = symVal;
      for (sym in obj) {
        return false;
      }
      if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) {
        return false;
      }
      if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) {
        return false;
      }
      var syms = Object.getOwnPropertySymbols(obj);
      if (syms.length !== 1 || syms[0] !== sym) {
        return false;
      }
      if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
        return false;
      }
      if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) {
          return false;
        }
      }
      return true;
    };
  }
});

// node_modules/has-symbols/index.js
var require_has_symbols = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__commonJS */ .Ee)({
  "node_modules/has-symbols/index.js"(exports, module) {
    "use strict";
    var origSymbol = typeof Symbol !== "undefined" && Symbol;
    var hasSymbolSham = require_shams();
    module.exports = function hasNativeSymbols() {
      if (typeof origSymbol !== "function") {
        return false;
      }
      if (typeof Symbol !== "function") {
        return false;
      }
      if (typeof origSymbol("foo") !== "symbol") {
        return false;
      }
      if (typeof Symbol("bar") !== "symbol") {
        return false;
      }
      return hasSymbolSham();
    };
  }
});

// node_modules/function-bind/implementation.js
var require_implementation = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__commonJS */ .Ee)({
  "node_modules/function-bind/implementation.js"(exports, module) {
    "use strict";
    var ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
    var slice = Array.prototype.slice;
    var toStr = Object.prototype.toString;
    var funcType = "[object Function]";
    module.exports = function bind(that) {
      var target = this;
      if (typeof target !== "function" || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
      }
      var args2 = slice.call(arguments, 1);
      var bound;
      var binder = function() {
        if (this instanceof bound) {
          var result2 = target.apply(
            this,
            args2.concat(slice.call(arguments))
          );
          if (Object(result2) === result2) {
            return result2;
          }
          return this;
        } else {
          return target.apply(
            that,
            args2.concat(slice.call(arguments))
          );
        }
      };
      var boundLength = Math.max(0, target.length - args2.length);
      var boundArgs = [];
      for (var i = 0; i < boundLength; i++) {
        boundArgs.push("$" + i);
      }
      bound = Function("binder", "return function (" + boundArgs.join(",") + "){ return binder.apply(this,arguments); }")(binder);
      if (target.prototype) {
        var Empty = function Empty2() {
        };
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
      }
      return bound;
    };
  }
});

// node_modules/function-bind/index.js
var require_function_bind = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__commonJS */ .Ee)({
  "node_modules/function-bind/index.js"(exports, module) {
    "use strict";
    var implementation = require_implementation();
    module.exports = Function.prototype.bind || implementation;
  }
});

// node_modules/has/src/index.js
var require_src = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__commonJS */ .Ee)({
  "node_modules/has/src/index.js"(exports, module) {
    "use strict";
    var bind = require_function_bind();
    module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);
  }
});

// node_modules/get-intrinsic/index.js
var require_get_intrinsic = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__commonJS */ .Ee)({
  "node_modules/get-intrinsic/index.js"(exports, module) {
    "use strict";
    var undefined2;
    var $SyntaxError = SyntaxError;
    var $Function = Function;
    var $TypeError = TypeError;
    var getEvalledConstructor = function(expressionSyntax) {
      try {
        return $Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
      } catch (e) {
      }
    };
    var $gOPD = Object.getOwnPropertyDescriptor;
    if ($gOPD) {
      try {
        $gOPD({}, "");
      } catch (e) {
        $gOPD = null;
      }
    }
    var throwTypeError = function() {
      throw new $TypeError();
    };
    var ThrowTypeError = $gOPD ? function() {
      try {
        arguments.callee;
        return throwTypeError;
      } catch (calleeThrows) {
        try {
          return $gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
          return throwTypeError;
        }
      }
    }() : throwTypeError;
    var hasSymbols = require_has_symbols()();
    var getProto = Object.getPrototypeOf || function(x) {
      return x.__proto__;
    };
    var needsEval = {};
    var TypedArray = typeof Uint8Array === "undefined" ? undefined2 : getProto(Uint8Array);
    var INTRINSICS = {
      "%AggregateError%": typeof AggregateError === "undefined" ? undefined2 : AggregateError,
      "%Array%": Array,
      "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined2 : ArrayBuffer,
      "%ArrayIteratorPrototype%": hasSymbols ? getProto([][Symbol.iterator]()) : undefined2,
      "%AsyncFromSyncIteratorPrototype%": undefined2,
      "%AsyncFunction%": needsEval,
      "%AsyncGenerator%": needsEval,
      "%AsyncGeneratorFunction%": needsEval,
      "%AsyncIteratorPrototype%": needsEval,
      "%Atomics%": typeof Atomics === "undefined" ? undefined2 : Atomics,
      "%BigInt%": typeof BigInt === "undefined" ? undefined2 : BigInt,
      "%Boolean%": Boolean,
      "%DataView%": typeof DataView === "undefined" ? undefined2 : DataView,
      "%Date%": Date,
      "%decodeURI%": decodeURI,
      "%decodeURIComponent%": decodeURIComponent,
      "%encodeURI%": encodeURI,
      "%encodeURIComponent%": encodeURIComponent,
      "%Error%": Error,
      "%eval%": eval,
      "%EvalError%": EvalError,
      "%Float32Array%": typeof Float32Array === "undefined" ? undefined2 : Float32Array,
      "%Float64Array%": typeof Float64Array === "undefined" ? undefined2 : Float64Array,
      "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined2 : FinalizationRegistry,
      "%Function%": $Function,
      "%GeneratorFunction%": needsEval,
      "%Int8Array%": typeof Int8Array === "undefined" ? undefined2 : Int8Array,
      "%Int16Array%": typeof Int16Array === "undefined" ? undefined2 : Int16Array,
      "%Int32Array%": typeof Int32Array === "undefined" ? undefined2 : Int32Array,
      "%isFinite%": isFinite,
      "%isNaN%": isNaN,
      "%IteratorPrototype%": hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined2,
      "%JSON%": typeof JSON === "object" ? JSON : undefined2,
      "%Map%": typeof Map === "undefined" ? undefined2 : Map,
      "%MapIteratorPrototype%": typeof Map === "undefined" || !hasSymbols ? undefined2 : getProto((/* @__PURE__ */ new Map())[Symbol.iterator]()),
      "%Math%": Math,
      "%Number%": Number,
      "%Object%": Object,
      "%parseFloat%": parseFloat,
      "%parseInt%": parseInt,
      "%Promise%": typeof Promise === "undefined" ? undefined2 : Promise,
      "%Proxy%": typeof Proxy === "undefined" ? undefined2 : Proxy,
      "%RangeError%": RangeError,
      "%ReferenceError%": ReferenceError,
      "%Reflect%": typeof Reflect === "undefined" ? undefined2 : Reflect,
      "%RegExp%": RegExp,
      "%Set%": typeof Set === "undefined" ? undefined2 : Set,
      "%SetIteratorPrototype%": typeof Set === "undefined" || !hasSymbols ? undefined2 : getProto((/* @__PURE__ */ new Set())[Symbol.iterator]()),
      "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined2 : SharedArrayBuffer,
      "%String%": String,
      "%StringIteratorPrototype%": hasSymbols ? getProto(""[Symbol.iterator]()) : undefined2,
      "%Symbol%": hasSymbols ? Symbol : undefined2,
      "%SyntaxError%": $SyntaxError,
      "%ThrowTypeError%": ThrowTypeError,
      "%TypedArray%": TypedArray,
      "%TypeError%": $TypeError,
      "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined2 : Uint8Array,
      "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined2 : Uint8ClampedArray,
      "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined2 : Uint16Array,
      "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined2 : Uint32Array,
      "%URIError%": URIError,
      "%WeakMap%": typeof WeakMap === "undefined" ? undefined2 : WeakMap,
      "%WeakRef%": typeof WeakRef === "undefined" ? undefined2 : WeakRef,
      "%WeakSet%": typeof WeakSet === "undefined" ? undefined2 : WeakSet
    };
    var doEval = function doEval2(name2) {
      var value2;
      if (name2 === "%AsyncFunction%") {
        value2 = getEvalledConstructor("async function () {}");
      } else if (name2 === "%GeneratorFunction%") {
        value2 = getEvalledConstructor("function* () {}");
      } else if (name2 === "%AsyncGeneratorFunction%") {
        value2 = getEvalledConstructor("async function* () {}");
      } else if (name2 === "%AsyncGenerator%") {
        var fn = doEval2("%AsyncGeneratorFunction%");
        if (fn) {
          value2 = fn.prototype;
        }
      } else if (name2 === "%AsyncIteratorPrototype%") {
        var gen = doEval2("%AsyncGenerator%");
        if (gen) {
          value2 = getProto(gen.prototype);
        }
      }
      INTRINSICS[name2] = value2;
      return value2;
    };
    var LEGACY_ALIASES = {
      "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
      "%ArrayPrototype%": ["Array", "prototype"],
      "%ArrayProto_entries%": ["Array", "prototype", "entries"],
      "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
      "%ArrayProto_keys%": ["Array", "prototype", "keys"],
      "%ArrayProto_values%": ["Array", "prototype", "values"],
      "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
      "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
      "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
      "%BooleanPrototype%": ["Boolean", "prototype"],
      "%DataViewPrototype%": ["DataView", "prototype"],
      "%DatePrototype%": ["Date", "prototype"],
      "%ErrorPrototype%": ["Error", "prototype"],
      "%EvalErrorPrototype%": ["EvalError", "prototype"],
      "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
      "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
      "%FunctionPrototype%": ["Function", "prototype"],
      "%Generator%": ["GeneratorFunction", "prototype"],
      "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
      "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
      "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
      "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
      "%JSONParse%": ["JSON", "parse"],
      "%JSONStringify%": ["JSON", "stringify"],
      "%MapPrototype%": ["Map", "prototype"],
      "%NumberPrototype%": ["Number", "prototype"],
      "%ObjectPrototype%": ["Object", "prototype"],
      "%ObjProto_toString%": ["Object", "prototype", "toString"],
      "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
      "%PromisePrototype%": ["Promise", "prototype"],
      "%PromiseProto_then%": ["Promise", "prototype", "then"],
      "%Promise_all%": ["Promise", "all"],
      "%Promise_reject%": ["Promise", "reject"],
      "%Promise_resolve%": ["Promise", "resolve"],
      "%RangeErrorPrototype%": ["RangeError", "prototype"],
      "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
      "%RegExpPrototype%": ["RegExp", "prototype"],
      "%SetPrototype%": ["Set", "prototype"],
      "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
      "%StringPrototype%": ["String", "prototype"],
      "%SymbolPrototype%": ["Symbol", "prototype"],
      "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
      "%TypedArrayPrototype%": ["TypedArray", "prototype"],
      "%TypeErrorPrototype%": ["TypeError", "prototype"],
      "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
      "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
      "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
      "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
      "%URIErrorPrototype%": ["URIError", "prototype"],
      "%WeakMapPrototype%": ["WeakMap", "prototype"],
      "%WeakSetPrototype%": ["WeakSet", "prototype"]
    };
    var bind = require_function_bind();
    var hasOwn = require_src();
    var $concat = bind.call(Function.call, Array.prototype.concat);
    var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
    var $replace = bind.call(Function.call, String.prototype.replace);
    var $strSlice = bind.call(Function.call, String.prototype.slice);
    var $exec = bind.call(Function.call, RegExp.prototype.exec);
    var rePropName2 = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
    var reEscapeChar2 = /\\(\\)?/g;
    var stringToPath2 = function stringToPath3(string) {
      var first = $strSlice(string, 0, 1);
      var last = $strSlice(string, -1);
      if (first === "%" && last !== "%") {
        throw new $SyntaxError("invalid intrinsic syntax, expected closing `%`");
      } else if (last === "%" && first !== "%") {
        throw new $SyntaxError("invalid intrinsic syntax, expected opening `%`");
      }
      var result2 = [];
      $replace(string, rePropName2, function(match, number, quote, subString) {
        result2[result2.length] = quote ? $replace(subString, reEscapeChar2, "$1") : number || match;
      });
      return result2;
    };
    var getBaseIntrinsic = function getBaseIntrinsic2(name2, allowMissing) {
      var intrinsicName = name2;
      var alias;
      if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
        alias = LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
      }
      if (hasOwn(INTRINSICS, intrinsicName)) {
        var value2 = INTRINSICS[intrinsicName];
        if (value2 === needsEval) {
          value2 = doEval(intrinsicName);
        }
        if (typeof value2 === "undefined" && !allowMissing) {
          throw new $TypeError("intrinsic " + name2 + " exists, but is not available. Please file an issue!");
        }
        return {
          alias,
          name: intrinsicName,
          value: value2
        };
      }
      throw new $SyntaxError("intrinsic " + name2 + " does not exist!");
    };
    module.exports = function GetIntrinsic(name2, allowMissing) {
      if (typeof name2 !== "string" || name2.length === 0) {
        throw new $TypeError("intrinsic name must be a non-empty string");
      }
      if (arguments.length > 1 && typeof allowMissing !== "boolean") {
        throw new $TypeError('"allowMissing" argument must be a boolean');
      }
      if ($exec(/^%?[^%]*%?$/, name2) === null) {
        throw new $SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
      }
      var parts = stringToPath2(name2);
      var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
      var intrinsic = getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
      var intrinsicRealName = intrinsic.name;
      var value2 = intrinsic.value;
      var skipFurtherCaching = false;
      var alias = intrinsic.alias;
      if (alias) {
        intrinsicBaseName = alias[0];
        $spliceApply(parts, $concat([0, 1], alias));
      }
      for (var i = 1, isOwn = true; i < parts.length; i += 1) {
        var part = parts[i];
        var first = $strSlice(part, 0, 1);
        var last = $strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || (last === '"' || last === "'" || last === "`")) && first !== last) {
          throw new $SyntaxError("property names with quotes must have matching quotes");
        }
        if (part === "constructor" || !isOwn) {
          skipFurtherCaching = true;
        }
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if (hasOwn(INTRINSICS, intrinsicRealName)) {
          value2 = INTRINSICS[intrinsicRealName];
        } else if (value2 != null) {
          if (!(part in value2)) {
            if (!allowMissing) {
              throw new $TypeError("base intrinsic for " + name2 + " exists, but the property is not available.");
            }
            return void 0;
          }
          if ($gOPD && i + 1 >= parts.length) {
            var desc = $gOPD(value2, part);
            isOwn = !!desc;
            if (isOwn && "get" in desc && !("originalValue" in desc.get)) {
              value2 = desc.get;
            } else {
              value2 = value2[part];
            }
          } else {
            isOwn = hasOwn(value2, part);
            value2 = value2[part];
          }
          if (isOwn && !skipFurtherCaching) {
            INTRINSICS[intrinsicRealName] = value2;
          }
        }
      }
      return value2;
    };
  }
});

// node_modules/call-bind/index.js
var require_call_bind = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__commonJS */ .Ee)({
  "node_modules/call-bind/index.js"(exports, module) {
    "use strict";
    var bind = require_function_bind();
    var GetIntrinsic = require_get_intrinsic();
    var $apply = GetIntrinsic("%Function.prototype.apply%");
    var $call = GetIntrinsic("%Function.prototype.call%");
    var $reflectApply = GetIntrinsic("%Reflect.apply%", true) || bind.call($call, $apply);
    var $gOPD = GetIntrinsic("%Object.getOwnPropertyDescriptor%", true);
    var $defineProperty = GetIntrinsic("%Object.defineProperty%", true);
    var $max = GetIntrinsic("%Math.max%");
    if ($defineProperty) {
      try {
        $defineProperty({}, "a", { value: 1 });
      } catch (e) {
        $defineProperty = null;
      }
    }
    module.exports = function callBind(originalFunction) {
      var func = $reflectApply(bind, $call, arguments);
      if ($gOPD && $defineProperty) {
        var desc = $gOPD(func, "length");
        if (desc.configurable) {
          $defineProperty(
            func,
            "length",
            { value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
          );
        }
      }
      return func;
    };
    var applyBind = function applyBind2() {
      return $reflectApply(bind, $apply, arguments);
    };
    if ($defineProperty) {
      $defineProperty(module.exports, "apply", { value: applyBind });
    } else {
      module.exports.apply = applyBind;
    }
  }
});

// node_modules/call-bind/callBound.js
var require_callBound = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__commonJS */ .Ee)({
  "node_modules/call-bind/callBound.js"(exports, module) {
    "use strict";
    var GetIntrinsic = require_get_intrinsic();
    var callBind = require_call_bind();
    var $indexOf = callBind(GetIntrinsic("String.prototype.indexOf"));
    module.exports = function callBoundIntrinsic(name2, allowMissing) {
      var intrinsic = GetIntrinsic(name2, !!allowMissing);
      if (typeof intrinsic === "function" && $indexOf(name2, ".prototype.") > -1) {
        return callBind(intrinsic);
      }
      return intrinsic;
    };
  }
});

// node_modules/has-tostringtag/shams.js
var require_shams2 = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__commonJS */ .Ee)({
  "node_modules/has-tostringtag/shams.js"(exports, module) {
    "use strict";
    var hasSymbols = require_shams();
    module.exports = function hasToStringTagShams() {
      return hasSymbols() && !!Symbol.toStringTag;
    };
  }
});

// node_modules/is-regex/index.js
var require_is_regex = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__commonJS */ .Ee)({
  "node_modules/is-regex/index.js"(exports, module) {
    "use strict";
    var callBound = require_callBound();
    var hasToStringTag = require_shams2()();
    var has;
    var $exec;
    var isRegexMarker;
    var badStringifier;
    if (hasToStringTag) {
      has = callBound("Object.prototype.hasOwnProperty");
      $exec = callBound("RegExp.prototype.exec");
      isRegexMarker = {};
      throwRegexMarker = function() {
        throw isRegexMarker;
      };
      badStringifier = {
        toString: throwRegexMarker,
        valueOf: throwRegexMarker
      };
      if (typeof Symbol.toPrimitive === "symbol") {
        badStringifier[Symbol.toPrimitive] = throwRegexMarker;
      }
    }
    var throwRegexMarker;
    var $toString = callBound("Object.prototype.toString");
    var gOPD = Object.getOwnPropertyDescriptor;
    var regexClass = "[object RegExp]";
    module.exports = hasToStringTag ? function isRegex(value2) {
      if (!value2 || typeof value2 !== "object") {
        return false;
      }
      var descriptor = gOPD(value2, "lastIndex");
      var hasLastIndexDataProperty = descriptor && has(descriptor, "value");
      if (!hasLastIndexDataProperty) {
        return false;
      }
      try {
        $exec(value2, badStringifier);
      } catch (e) {
        return e === isRegexMarker;
      }
    } : function isRegex(value2) {
      if (!value2 || typeof value2 !== "object" && typeof value2 !== "function") {
        return false;
      }
      return $toString(value2) === regexClass;
    };
  }
});

// node_modules/is-function/index.js
var require_is_function = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__commonJS */ .Ee)({
  "node_modules/is-function/index.js"(exports, module) {
    module.exports = isFunction3;
    var toString2 = Object.prototype.toString;
    function isFunction3(fn) {
      if (!fn) {
        return false;
      }
      var string = toString2.call(fn);
      return string === "[object Function]" || typeof fn === "function" && string !== "[object RegExp]" || typeof window !== "undefined" && (fn === window.setTimeout || fn === window.alert || fn === window.confirm || fn === window.prompt);
    }
  }
});

// node_modules/is-symbol/index.js
var require_is_symbol = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__commonJS */ .Ee)({
  "node_modules/is-symbol/index.js"(exports, module) {
    "use strict";
    var toStr = Object.prototype.toString;
    var hasSymbols = require_has_symbols()();
    if (hasSymbols) {
      symToStr = Symbol.prototype.toString;
      symStringRegex = /^Symbol\(.*\)$/;
      isSymbolObject = function isRealSymbolObject(value2) {
        if (typeof value2.valueOf() !== "symbol") {
          return false;
        }
        return symStringRegex.test(symToStr.call(value2));
      };
      module.exports = function isSymbol3(value2) {
        if (typeof value2 === "symbol") {
          return true;
        }
        if (toStr.call(value2) !== "[object Symbol]") {
          return false;
        }
        try {
          return isSymbolObject(value2);
        } catch (e) {
          return false;
        }
      };
    } else {
      module.exports = function isSymbol3(value2) {
        return false;
      };
    }
    var symToStr;
    var symStringRegex;
    var isSymbolObject;
  }
});

// src/index.ts
var import_is_regex = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__toESM */ .v)(require_is_regex());
var import_is_function = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__toESM */ .v)(require_is_function());
var import_is_symbol = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .__toESM */ .v)(require_is_symbol());

// node_modules/isobject/index.js
function isObject(val) {
  return val != null && typeof val === "object" && Array.isArray(val) === false;
}

// node_modules/lodash-es/_freeGlobal.js
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
var freeGlobal_default = freeGlobal;

// node_modules/lodash-es/_root.js
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root2 = freeGlobal_default || freeSelf || Function("return this")();
var root_default = root2;

// node_modules/lodash-es/_Symbol.js
var Symbol2 = root_default.Symbol;
var Symbol_default = Symbol2;

// node_modules/lodash-es/_getRawTag.js
var objectProto = Object.prototype;
var hasOwnProperty = objectProto.hasOwnProperty;
var nativeObjectToString = objectProto.toString;
var symToStringTag = Symbol_default ? Symbol_default.toStringTag : void 0;
function getRawTag(value2) {
  var isOwn = hasOwnProperty.call(value2, symToStringTag), tag = value2[symToStringTag];
  try {
    value2[symToStringTag] = void 0;
    var unmasked = true;
  } catch (e) {
  }
  var result2 = nativeObjectToString.call(value2);
  if (unmasked) {
    if (isOwn) {
      value2[symToStringTag] = tag;
    } else {
      delete value2[symToStringTag];
    }
  }
  return result2;
}
var getRawTag_default = getRawTag;

// node_modules/lodash-es/_objectToString.js
var objectProto2 = Object.prototype;
var nativeObjectToString2 = objectProto2.toString;
function objectToString(value2) {
  return nativeObjectToString2.call(value2);
}
var objectToString_default = objectToString;

// node_modules/lodash-es/_baseGetTag.js
var nullTag = "[object Null]";
var undefinedTag = "[object Undefined]";
var symToStringTag2 = Symbol_default ? Symbol_default.toStringTag : void 0;
function baseGetTag(value2) {
  if (value2 == null) {
    return value2 === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag2 && symToStringTag2 in Object(value2) ? getRawTag_default(value2) : objectToString_default(value2);
}
var baseGetTag_default = baseGetTag;

// node_modules/lodash-es/isObjectLike.js
function isObjectLike(value2) {
  return value2 != null && typeof value2 == "object";
}
var isObjectLike_default = isObjectLike;

// node_modules/lodash-es/isSymbol.js
var symbolTag = "[object Symbol]";
function isSymbol(value2) {
  return typeof value2 == "symbol" || isObjectLike_default(value2) && baseGetTag_default(value2) == symbolTag;
}
var isSymbol_default = isSymbol;

// node_modules/lodash-es/_arrayMap.js
function arrayMap(array, iteratee) {
  var index = -1, length = array == null ? 0 : array.length, result2 = Array(length);
  while (++index < length) {
    result2[index] = iteratee(array[index], index, array);
  }
  return result2;
}
var arrayMap_default = arrayMap;

// node_modules/lodash-es/isArray.js
var isArray = Array.isArray;
var isArray_default = isArray;

// node_modules/lodash-es/_baseToString.js
var INFINITY = 1 / 0;
var symbolProto = Symbol_default ? Symbol_default.prototype : void 0;
var symbolToString = symbolProto ? symbolProto.toString : void 0;
function baseToString(value2) {
  if (typeof value2 == "string") {
    return value2;
  }
  if (isArray_default(value2)) {
    return arrayMap_default(value2, baseToString) + "";
  }
  if (isSymbol_default(value2)) {
    return symbolToString ? symbolToString.call(value2) : "";
  }
  var result2 = value2 + "";
  return result2 == "0" && 1 / value2 == -INFINITY ? "-0" : result2;
}
var baseToString_default = baseToString;

// node_modules/lodash-es/isObject.js
function isObject2(value2) {
  var type = typeof value2;
  return value2 != null && (type == "object" || type == "function");
}
var isObject_default = isObject2;

// node_modules/lodash-es/isFunction.js
var asyncTag = "[object AsyncFunction]";
var funcTag = "[object Function]";
var genTag = "[object GeneratorFunction]";
var proxyTag = "[object Proxy]";
function isFunction(value2) {
  if (!isObject_default(value2)) {
    return false;
  }
  var tag = baseGetTag_default(value2);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
var isFunction_default = isFunction;

// node_modules/lodash-es/_coreJsData.js
var coreJsData = root_default["__core-js_shared__"];
var coreJsData_default = coreJsData;

// node_modules/lodash-es/_isMasked.js
var maskSrcKey = function() {
  var uid = /[^.]+$/.exec(coreJsData_default && coreJsData_default.keys && coreJsData_default.keys.IE_PROTO || "");
  return uid ? "Symbol(src)_1." + uid : "";
}();
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var isMasked_default = isMasked;

// node_modules/lodash-es/_toSource.js
var funcProto = Function.prototype;
var funcToString = funcProto.toString;
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {
    }
    try {
      return func + "";
    } catch (e) {
    }
  }
  return "";
}
var toSource_default = toSource;

// node_modules/lodash-es/_baseIsNative.js
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var funcProto2 = Function.prototype;
var objectProto3 = Object.prototype;
var funcToString2 = funcProto2.toString;
var hasOwnProperty2 = objectProto3.hasOwnProperty;
var reIsNative = RegExp(
  "^" + funcToString2.call(hasOwnProperty2).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative(value2) {
  if (!isObject_default(value2) || isMasked_default(value2)) {
    return false;
  }
  var pattern = isFunction_default(value2) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource_default(value2));
}
var baseIsNative_default = baseIsNative;

// node_modules/lodash-es/_getValue.js
function getValue(object, key2) {
  return object == null ? void 0 : object[key2];
}
var getValue_default = getValue;

// node_modules/lodash-es/_getNative.js
function getNative(object, key2) {
  var value2 = getValue_default(object, key2);
  return baseIsNative_default(value2) ? value2 : void 0;
}
var getNative_default = getNative;

// node_modules/lodash-es/eq.js
function eq(value2, other) {
  return value2 === other || value2 !== value2 && other !== other;
}
var eq_default = eq;

// node_modules/lodash-es/_isKey.js
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/;
var reIsPlainProp = /^\w*$/;
function isKey(value2, object) {
  if (isArray_default(value2)) {
    return false;
  }
  var type = typeof value2;
  if (type == "number" || type == "symbol" || type == "boolean" || value2 == null || isSymbol_default(value2)) {
    return true;
  }
  return reIsPlainProp.test(value2) || !reIsDeepProp.test(value2) || object != null && value2 in Object(object);
}
var isKey_default = isKey;

// node_modules/lodash-es/_nativeCreate.js
var nativeCreate = getNative_default(Object, "create");
var nativeCreate_default = nativeCreate;

// node_modules/lodash-es/_hashClear.js
function hashClear() {
  this.__data__ = nativeCreate_default ? nativeCreate_default(null) : {};
  this.size = 0;
}
var hashClear_default = hashClear;

// node_modules/lodash-es/_hashDelete.js
function hashDelete(key2) {
  var result2 = this.has(key2) && delete this.__data__[key2];
  this.size -= result2 ? 1 : 0;
  return result2;
}
var hashDelete_default = hashDelete;

// node_modules/lodash-es/_hashGet.js
var HASH_UNDEFINED = "__lodash_hash_undefined__";
var objectProto4 = Object.prototype;
var hasOwnProperty3 = objectProto4.hasOwnProperty;
function hashGet(key2) {
  var data = this.__data__;
  if (nativeCreate_default) {
    var result2 = data[key2];
    return result2 === HASH_UNDEFINED ? void 0 : result2;
  }
  return hasOwnProperty3.call(data, key2) ? data[key2] : void 0;
}
var hashGet_default = hashGet;

// node_modules/lodash-es/_hashHas.js
var objectProto5 = Object.prototype;
var hasOwnProperty4 = objectProto5.hasOwnProperty;
function hashHas(key2) {
  var data = this.__data__;
  return nativeCreate_default ? data[key2] !== void 0 : hasOwnProperty4.call(data, key2);
}
var hashHas_default = hashHas;

// node_modules/lodash-es/_hashSet.js
var HASH_UNDEFINED2 = "__lodash_hash_undefined__";
function hashSet(key2, value2) {
  var data = this.__data__;
  this.size += this.has(key2) ? 0 : 1;
  data[key2] = nativeCreate_default && value2 === void 0 ? HASH_UNDEFINED2 : value2;
  return this;
}
var hashSet_default = hashSet;

// node_modules/lodash-es/_Hash.js
function Hash(entries) {
  var index = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
Hash.prototype.clear = hashClear_default;
Hash.prototype["delete"] = hashDelete_default;
Hash.prototype.get = hashGet_default;
Hash.prototype.has = hashHas_default;
Hash.prototype.set = hashSet_default;
var Hash_default = Hash;

// node_modules/lodash-es/_listCacheClear.js
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}
var listCacheClear_default = listCacheClear;

// node_modules/lodash-es/_assocIndexOf.js
function assocIndexOf(array, key2) {
  var length = array.length;
  while (length--) {
    if (eq_default(array[length][0], key2)) {
      return length;
    }
  }
  return -1;
}
var assocIndexOf_default = assocIndexOf;

// node_modules/lodash-es/_listCacheDelete.js
var arrayProto = Array.prototype;
var splice = arrayProto.splice;
function listCacheDelete(key2) {
  var data = this.__data__, index = assocIndexOf_default(data, key2);
  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}
var listCacheDelete_default = listCacheDelete;

// node_modules/lodash-es/_listCacheGet.js
function listCacheGet(key2) {
  var data = this.__data__, index = assocIndexOf_default(data, key2);
  return index < 0 ? void 0 : data[index][1];
}
var listCacheGet_default = listCacheGet;

// node_modules/lodash-es/_listCacheHas.js
function listCacheHas(key2) {
  return assocIndexOf_default(this.__data__, key2) > -1;
}
var listCacheHas_default = listCacheHas;

// node_modules/lodash-es/_listCacheSet.js
function listCacheSet(key2, value2) {
  var data = this.__data__, index = assocIndexOf_default(data, key2);
  if (index < 0) {
    ++this.size;
    data.push([key2, value2]);
  } else {
    data[index][1] = value2;
  }
  return this;
}
var listCacheSet_default = listCacheSet;

// node_modules/lodash-es/_ListCache.js
function ListCache(entries) {
  var index = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
ListCache.prototype.clear = listCacheClear_default;
ListCache.prototype["delete"] = listCacheDelete_default;
ListCache.prototype.get = listCacheGet_default;
ListCache.prototype.has = listCacheHas_default;
ListCache.prototype.set = listCacheSet_default;
var ListCache_default = ListCache;

// node_modules/lodash-es/_Map.js
var Map2 = getNative_default(root_default, "Map");
var Map_default = Map2;

// node_modules/lodash-es/_mapCacheClear.js
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    "hash": new Hash_default(),
    "map": new (Map_default || ListCache_default)(),
    "string": new Hash_default()
  };
}
var mapCacheClear_default = mapCacheClear;

// node_modules/lodash-es/_isKeyable.js
function isKeyable(value2) {
  var type = typeof value2;
  return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value2 !== "__proto__" : value2 === null;
}
var isKeyable_default = isKeyable;

// node_modules/lodash-es/_getMapData.js
function getMapData(map, key2) {
  var data = map.__data__;
  return isKeyable_default(key2) ? data[typeof key2 == "string" ? "string" : "hash"] : data.map;
}
var getMapData_default = getMapData;

// node_modules/lodash-es/_mapCacheDelete.js
function mapCacheDelete(key2) {
  var result2 = getMapData_default(this, key2)["delete"](key2);
  this.size -= result2 ? 1 : 0;
  return result2;
}
var mapCacheDelete_default = mapCacheDelete;

// node_modules/lodash-es/_mapCacheGet.js
function mapCacheGet(key2) {
  return getMapData_default(this, key2).get(key2);
}
var mapCacheGet_default = mapCacheGet;

// node_modules/lodash-es/_mapCacheHas.js
function mapCacheHas(key2) {
  return getMapData_default(this, key2).has(key2);
}
var mapCacheHas_default = mapCacheHas;

// node_modules/lodash-es/_mapCacheSet.js
function mapCacheSet(key2, value2) {
  var data = getMapData_default(this, key2), size = data.size;
  data.set(key2, value2);
  this.size += data.size == size ? 0 : 1;
  return this;
}
var mapCacheSet_default = mapCacheSet;

// node_modules/lodash-es/_MapCache.js
function MapCache(entries) {
  var index = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
MapCache.prototype.clear = mapCacheClear_default;
MapCache.prototype["delete"] = mapCacheDelete_default;
MapCache.prototype.get = mapCacheGet_default;
MapCache.prototype.has = mapCacheHas_default;
MapCache.prototype.set = mapCacheSet_default;
var MapCache_default = MapCache;

// node_modules/lodash-es/memoize.js
var FUNC_ERROR_TEXT = "Expected a function";
function memoize(func, resolver) {
  if (typeof func != "function" || resolver != null && typeof resolver != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args2 = arguments, key2 = resolver ? resolver.apply(this, args2) : args2[0], cache = memoized.cache;
    if (cache.has(key2)) {
      return cache.get(key2);
    }
    var result2 = func.apply(this, args2);
    memoized.cache = cache.set(key2, result2) || cache;
    return result2;
  };
  memoized.cache = new (memoize.Cache || MapCache_default)();
  return memoized;
}
memoize.Cache = MapCache_default;
var memoize_default = memoize;

// node_modules/lodash-es/_memoizeCapped.js
var MAX_MEMOIZE_SIZE = 500;
function memoizeCapped(func) {
  var result2 = memoize_default(func, function(key2) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key2;
  });
  var cache = result2.cache;
  return result2;
}
var memoizeCapped_default = memoizeCapped;

// node_modules/lodash-es/_stringToPath.js
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
var reEscapeChar = /\\(\\)?/g;
var stringToPath = memoizeCapped_default(function(string) {
  var result2 = [];
  if (string.charCodeAt(0) === 46) {
    result2.push("");
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result2.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
  });
  return result2;
});
var stringToPath_default = stringToPath;

// node_modules/lodash-es/toString.js
function toString(value2) {
  return value2 == null ? "" : baseToString_default(value2);
}
var toString_default = toString;

// node_modules/lodash-es/_castPath.js
function castPath(value2, object) {
  if (isArray_default(value2)) {
    return value2;
  }
  return isKey_default(value2, object) ? [value2] : stringToPath_default(toString_default(value2));
}
var castPath_default = castPath;

// node_modules/lodash-es/_toKey.js
var INFINITY2 = 1 / 0;
function toKey(value2) {
  if (typeof value2 == "string" || isSymbol_default(value2)) {
    return value2;
  }
  var result2 = value2 + "";
  return result2 == "0" && 1 / value2 == -INFINITY2 ? "-0" : result2;
}
var toKey_default = toKey;

// node_modules/lodash-es/_baseGet.js
function baseGet(object, path) {
  path = castPath_default(path, object);
  var index = 0, length = path.length;
  while (object != null && index < length) {
    object = object[toKey_default(path[index++])];
  }
  return index && index == length ? object : void 0;
}
var baseGet_default = baseGet;

// node_modules/lodash-es/get.js
function get(object, path, defaultValue) {
  var result2 = object == null ? void 0 : baseGet_default(object, path);
  return result2 === void 0 ? defaultValue : result2;
}
var get_default = get;

// src/index.ts

var isObject3 = isObject;
var removeCodeComments = (code) => {
  let inQuoteChar = null;
  let inBlockComment = false;
  let inLineComment = false;
  let inRegexLiteral = false;
  let newCode = "";
  if (code.indexOf("//") >= 0 || code.indexOf("/*") >= 0) {
    for (let i = 0; i < code.length; i += 1) {
      if (!inQuoteChar && !inBlockComment && !inLineComment && !inRegexLiteral) {
        if (code[i] === '"' || code[i] === "'" || code[i] === "`") {
          inQuoteChar = code[i];
        } else if (code[i] === "/" && code[i + 1] === "*") {
          inBlockComment = true;
        } else if (code[i] === "/" && code[i + 1] === "/") {
          inLineComment = true;
        } else if (code[i] === "/" && code[i + 1] !== "/") {
          inRegexLiteral = true;
        }
      } else {
        if (inQuoteChar && (code[i] === inQuoteChar && code[i - 1] !== "\\" || code[i] === "\n" && inQuoteChar !== "`")) {
          inQuoteChar = null;
        }
        if (inRegexLiteral && (code[i] === "/" && code[i - 1] !== "\\" || code[i] === "\n")) {
          inRegexLiteral = false;
        }
        if (inBlockComment && code[i - 1] === "/" && code[i - 2] === "*") {
          inBlockComment = false;
        }
        if (inLineComment && code[i] === "\n") {
          inLineComment = false;
        }
      }
      if (!inBlockComment && !inLineComment) {
        newCode += code[i];
      }
    }
  } else {
    newCode = code;
  }
  return newCode;
};
var cleanCode = memoizerific__WEBPACK_IMPORTED_MODULE_1__(1e4)(
  (code) => removeCodeComments(code).replace(/\n\s*/g, "").trim()
);
var convertShorthandMethods = function convertShorthandMethods2(key2, stringified) {
  const fnHead = stringified.slice(0, stringified.indexOf("{"));
  const fnBody = stringified.slice(stringified.indexOf("{"));
  if (fnHead.includes("=>")) {
    return stringified;
  }
  if (fnHead.includes("function")) {
    return stringified;
  }
  let modifiedHead = fnHead;
  modifiedHead = modifiedHead.replace(key2, "function");
  return modifiedHead + fnBody;
};
var dateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z$/;
var isJSON = (input) => input.match(/^[\[\{\"\}].*[\]\}\"]$/);
function convertUnconventionalData(data) {
  if (!isObject3(data)) {
    return data;
  }
  let result2 = data;
  let wasMutated = false;
  if (typeof Event !== "undefined" && data instanceof Event) {
    result2 = (0,_chunk_465TF3XA_mjs__WEBPACK_IMPORTED_MODULE_0__/* .extractEventHiddenProperties */ ._l)(result2);
    wasMutated = true;
  }
  result2 = Object.keys(result2).reduce((acc, key2) => {
    try {
      if (result2[key2]) {
        result2[key2].toJSON;
      }
      acc[key2] = result2[key2];
    } catch (err) {
      wasMutated = true;
    }
    return acc;
  }, {});
  return wasMutated ? result2 : data;
}
var replacer = function replacer2(options2) {
  let objects;
  let map;
  let stack;
  let keys;
  return function replace(key2, value2) {
    try {
      if (key2 === "") {
        keys = [];
        objects = /* @__PURE__ */ new Map([[value2, "[]"]]);
        map = /* @__PURE__ */ new Map();
        stack = [];
        return value2;
      }
      const origin = map.get(this) || this;
      while (stack.length && origin !== stack[0]) {
        stack.shift();
        keys.pop();
      }
      if (typeof value2 === "boolean") {
        return value2;
      }
      if (value2 === void 0) {
        if (!options2.allowUndefined) {
          return void 0;
        }
        return "_undefined_";
      }
      if (value2 === null) {
        return null;
      }
      if (typeof value2 === "number") {
        if (value2 === -Infinity) {
          return "_-Infinity_";
        }
        if (value2 === Infinity) {
          return "_Infinity_";
        }
        if (Number.isNaN(value2)) {
          return "_NaN_";
        }
        return value2;
      }
      if (typeof value2 === "bigint") {
        return `_bigint_${value2.toString()}`;
      }
      if (typeof value2 === "string") {
        if (dateFormat.test(value2)) {
          if (!options2.allowDate) {
            return void 0;
          }
          return `_date_${value2}`;
        }
        return value2;
      }
      if ((0, import_is_regex.default)(value2)) {
        if (!options2.allowRegExp) {
          return void 0;
        }
        return `_regexp_${value2.flags}|${value2.source}`;
      }
      if ((0, import_is_function.default)(value2)) {
        if (!options2.allowFunction) {
          return void 0;
        }
        const { name: name2 } = value2;
        const stringified = value2.toString();
        if (!stringified.match(
          /(\[native code\]|WEBPACK_IMPORTED_MODULE|__webpack_exports__|__webpack_require__)/
        )) {
          return `_function_${name2}|${cleanCode(convertShorthandMethods(key2, stringified))}`;
        }
        return `_function_${name2}|${(() => {
        }).toString()}`;
      }
      if ((0, import_is_symbol.default)(value2)) {
        if (!options2.allowSymbol) {
          return void 0;
        }
        const globalRegistryKey = Symbol.keyFor(value2);
        if (globalRegistryKey !== void 0) {
          return `_gsymbol_${globalRegistryKey}`;
        }
        return `_symbol_${value2.toString().slice(7, -1)}`;
      }
      if (stack.length >= options2.maxDepth) {
        if (Array.isArray(value2)) {
          return `[Array(${value2.length})]`;
        }
        return "[Object]";
      }
      if (value2 === this) {
        return `_duplicate_${JSON.stringify(keys)}`;
      }
      if (value2 instanceof Error && options2.allowError) {
        return {
          __isConvertedError__: true,
          errorProperties: {
            ...value2.cause ? { cause: value2.cause } : {},
            ...value2,
            name: value2.name,
            message: value2.message,
            stack: value2.stack,
            "_constructor-name_": value2.constructor.name
          }
        };
      }
      if (value2.constructor && value2.constructor.name && value2.constructor.name !== "Object" && !Array.isArray(value2) && !options2.allowClass) {
        return void 0;
      }
      const found = objects.get(value2);
      if (!found) {
        const converted = Array.isArray(value2) ? value2 : convertUnconventionalData(value2);
        if (value2.constructor && value2.constructor.name && value2.constructor.name !== "Object" && !Array.isArray(value2) && options2.allowClass) {
          try {
            Object.assign(converted, { "_constructor-name_": value2.constructor.name });
          } catch (e) {
          }
        }
        keys.push(key2);
        stack.unshift(converted);
        objects.set(value2, JSON.stringify(keys));
        if (value2 !== converted) {
          map.set(value2, converted);
        }
        return converted;
      }
      return `_duplicate_${found}`;
    } catch (e) {
      return void 0;
    }
  };
};
var reviver2 = function reviver(options) {
  const refs = [];
  let root;
  return function revive(key, value) {
    if (key === "") {
      root = value;
      refs.forEach(({ target, container, replacement }) => {
        const replacementArr = isJSON(replacement) ? JSON.parse(replacement) : replacement.split(".");
        if (replacementArr.length === 0) {
          container[target] = root;
        } else {
          container[target] = get_default(root, replacementArr);
        }
      });
    }
    if (key === "_constructor-name_") {
      return value;
    }
    if (isObject3(value) && value.__isConvertedError__) {
      const { message, ...properties } = value.errorProperties;
      const error = new Error(message);
      Object.assign(error, properties);
      return error;
    }
    if (isObject3(value) && value["_constructor-name_"] && options.allowFunction) {
      const name2 = value["_constructor-name_"];
      if (name2 !== "Object") {
        const Fn = new Function(`return function ${name2.replace(/[^a-zA-Z0-9$_]+/g, "")}(){}`)();
        Object.setPrototypeOf(value, new Fn());
      }
      delete value["_constructor-name_"];
      return value;
    }
    if (typeof value === "string" && value.startsWith("_function_") && options.allowFunction) {
      const [, name, source] = value.match(/_function_([^|]*)\|(.*)/) || [];
      const sourceSanitized = source.replace(/[(\(\))|\\| |\]|`]*$/, "");
      if (!options.lazyEval) {
        return eval(`(${sourceSanitized})`);
      }
      const result = (...args) => {
        const f = eval(`(${sourceSanitized})`);
        return f(...args);
      };
      Object.defineProperty(result, "toString", {
        value: () => sourceSanitized
      });
      Object.defineProperty(result, "name", {
        value: name
      });
      return result;
    }
    if (typeof value === "string" && value.startsWith("_regexp_") && options.allowRegExp) {
      const [, flags, source2] = value.match(/_regexp_([^|]*)\|(.*)/) || [];
      return new RegExp(source2, flags);
    }
    if (typeof value === "string" && value.startsWith("_date_") && options.allowDate) {
      return new Date(value.replace("_date_", ""));
    }
    if (typeof value === "string" && value.startsWith("_duplicate_")) {
      refs.push({ target: key, container: this, replacement: value.replace(/^_duplicate_/, "") });
      return null;
    }
    if (typeof value === "string" && value.startsWith("_symbol_") && options.allowSymbol) {
      return Symbol(value.replace("_symbol_", ""));
    }
    if (typeof value === "string" && value.startsWith("_gsymbol_") && options.allowSymbol) {
      return Symbol.for(value.replace("_gsymbol_", ""));
    }
    if (typeof value === "string" && value === "_-Infinity_") {
      return -Infinity;
    }
    if (typeof value === "string" && value === "_Infinity_") {
      return Infinity;
    }
    if (typeof value === "string" && value === "_NaN_") {
      return NaN;
    }
    if (typeof value === "string" && value.startsWith("_bigint_") && typeof BigInt === "function") {
      return BigInt(value.replace("_bigint_", ""));
    }
    return value;
  };
};
var defaultOptions = {
  maxDepth: 10,
  space: void 0,
  allowFunction: true,
  allowRegExp: true,
  allowDate: true,
  allowClass: true,
  allowError: true,
  allowUndefined: true,
  allowSymbol: true,
  lazyEval: true
};
var stringify = (data, options2 = {}) => {
  const mergedOptions = { ...defaultOptions, ...options2 };
  return JSON.stringify(convertUnconventionalData(data), replacer(mergedOptions), options2.space);
};
var mutator = () => {
  const mutated = /* @__PURE__ */ new Map();
  return function mutateUndefined(value2) {
    if (isObject3(value2)) {
      Object.entries(value2).forEach(([k, v]) => {
        if (v === "_undefined_") {
          value2[k] = void 0;
        } else if (!mutated.get(v)) {
          mutated.set(v, true);
          mutateUndefined(v);
        }
      });
    }
    if (Array.isArray(value2)) {
      value2.forEach((v, index) => {
        if (v === "_undefined_") {
          mutated.set(v, true);
          value2[index] = void 0;
        } else if (!mutated.get(v)) {
          mutated.set(v, true);
          mutateUndefined(v);
        }
      });
    }
  };
};
var parse = (data, options2 = {}) => {
  const mergedOptions = { ...defaultOptions, ...options2 };
  const result2 = JSON.parse(data, reviver2(mergedOptions));
  mutator()(result2);
  return result2;
};

/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
/**
 * @license
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="es" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,179], function() { return __webpack_exec__(6461), __webpack_exec__(5817); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);